
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0cca"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0cca"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("j8Tkc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $def9ae09e576fad6$var$parse;

var $iXioy = parcelRequire("iXioy");

var $z9qXh = parcelRequire("z9qXh");

var $gcQy4 = parcelRequire("gcQy4");

var $ki8SS = parcelRequire("ki8SS");
function $def9ae09e576fad6$var$parse(html, options) {
    const tokenAdapter = options && options.tokenAdapter || $ki8SS.defaultTokenAdapter;
    const { tokens: tokens } = (0, $z9qXh.tokenize)(html, tokenAdapter, options);
    const { ast: ast } = (0, $iXioy.constructTree)(tokens);
    return {
        ast: (0, $gcQy4.clearParent)(ast),
        tokens: tokens
    };
}

});
parcelRegister("iXioy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.constructTree = void 0;

var $8FQkj = parcelRequire("8FQkj");
Object.defineProperty(module.exports, "constructTree", {
    enumerable: true,
    get: function() {
        return $8FQkj.constructTree;
    }
});

});
parcelRegister("8FQkj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.constructTree = $650abe0e8347fc8d$var$constructTree;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");

var $4SoTV = parcelRequire("4SoTV");

var $fYahD = parcelRequire("fYahD");
const $650abe0e8347fc8d$var$contextHandlers = {
    [$eJ62A.ConstructTreeContextTypes.TagContent]: $fYahD.tagContent,
    [$eJ62A.ConstructTreeContextTypes.Tag]: $fYahD.tag,
    [$eJ62A.ConstructTreeContextTypes.TagName]: $fYahD.tagName,
    [$eJ62A.ConstructTreeContextTypes.Attribute]: $fYahD.attribute,
    [$eJ62A.ConstructTreeContextTypes.Attributes]: $fYahD.attributes,
    [$eJ62A.ConstructTreeContextTypes.AttributeValue]: $fYahD.attributeValue,
    [$eJ62A.ConstructTreeContextTypes.Comment]: $fYahD.comment,
    [$eJ62A.ConstructTreeContextTypes.Doctype]: $fYahD.doctype,
    [$eJ62A.ConstructTreeContextTypes.DoctypeAttributes]: $fYahD.doctypeAttributes,
    [$eJ62A.ConstructTreeContextTypes.DoctypeAttribute]: $fYahD.doctypeAttribute,
    [$eJ62A.ConstructTreeContextTypes.ScriptTag]: $fYahD.scriptTag,
    [$eJ62A.ConstructTreeContextTypes.StyleTag]: $fYahD.styleTag
};
const $650abe0e8347fc8d$var$EMPTY_RANGE = [
    0,
    0
];
const $650abe0e8347fc8d$var$EMPTY_LOC = {
    start: {
        line: 1,
        column: 0
    },
    end: {
        line: 1,
        column: 0
    }
};
function $650abe0e8347fc8d$var$constructTree(tokens) {
    const rootContext = {
        type: $eJ62A.ConstructTreeContextTypes.TagContent,
        parentRef: undefined,
        content: []
    };
    const lastToken = (0, $gcQy4.last)(tokens);
    const firstToken = (0, $gcQy4.first)(tokens);
    const range = lastToken ? [
        0,
        lastToken.range[1]
    ] : $650abe0e8347fc8d$var$EMPTY_RANGE;
    const loc = lastToken ? {
        start: (0, $4SoTV.cloneLocation)(firstToken.loc).start,
        end: (0, $4SoTV.cloneLocation)(lastToken.loc).end
    } : $650abe0e8347fc8d$var$EMPTY_LOC;
    loc.start.line = 1;
    const rootNode = {
        type: $eJ62A.NodeTypes.Document,
        range: range,
        children: [],
        loc: loc
    };
    const state = {
        caretPosition: 0,
        currentContext: rootContext,
        currentNode: rootNode,
        rootNode: rootNode
    };
    const positionOffset = state.caretPosition;
    $650abe0e8347fc8d$var$processTokens(tokens, state, positionOffset);
    return {
        state: state,
        ast: state.rootNode
    };
}
function $650abe0e8347fc8d$var$processTokens(tokens, state, positionOffset) {
    let tokenIndex = state.caretPosition - positionOffset;
    while(tokenIndex < tokens.length){
        const token = tokens[tokenIndex];
        const handler = $650abe0e8347fc8d$var$contextHandlers[state.currentContext.type].construct;
        // @ts-ignore
        state = handler(token, state);
        tokenIndex = state.caretPosition - positionOffset;
    }
    return state;
}

});
parcelRegister("eJ62A", function(module, exports) {
"use strict";
var $ab89f433dad02144$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ab89f433dad02144$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ab89f433dad02144$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ab89f433dad02144$var$__exportStar((parcelRequire("5ctDO")), module.exports);

$ab89f433dad02144$var$__exportStar((parcelRequire("e5hsK")), module.exports);

$ab89f433dad02144$var$__exportStar((parcelRequire("13PFj")), module.exports);

$ab89f433dad02144$var$__exportStar((parcelRequire("bqb37")), module.exports);

$ab89f433dad02144$var$__exportStar((parcelRequire("lefjN")), module.exports);

$ab89f433dad02144$var$__exportStar((parcelRequire("e1WeV")), module.exports);

});
parcelRegister("5ctDO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AstTypes = void 0;
var $3c9510df8832e3b1$var$AstTypes;
(function(AstTypes) {
    AstTypes["Document"] = "Document";
    AstTypes["Tag"] = "Tag";
    AstTypes["Text"] = "Text";
    AstTypes["Doctype"] = "Doctype";
    AstTypes["Comment"] = "Comment";
    AstTypes["Script"] = "Script";
    AstTypes["Style"] = "Style";
})($3c9510df8832e3b1$var$AstTypes || (module.exports.AstTypes = $3c9510df8832e3b1$var$AstTypes = {}));

});

parcelRegister("e5hsK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenizerContextTypes = void 0;
var $a40f14053b8109fa$var$TokenizerContextTypes;
(function(TokenizerContextTypes) {
    TokenizerContextTypes["Data"] = "Data";
    TokenizerContextTypes["OpenTagStart"] = "OpenTagStart";
    TokenizerContextTypes["CloseTag"] = "CloseTag";
    TokenizerContextTypes["Attributes"] = "Attributes";
    TokenizerContextTypes["OpenTagEnd"] = "OpenTagEnd";
    TokenizerContextTypes["AttributeKey"] = "AttributeKey";
    TokenizerContextTypes["AttributeValue"] = "AttributeValue";
    TokenizerContextTypes["AttributeValueBare"] = "AttributeValueBare";
    TokenizerContextTypes["AttributeValueWrapped"] = "AttributeValueWrapped";
    TokenizerContextTypes["ScriptContent"] = "ScriptContent";
    TokenizerContextTypes["StyleContent"] = "StyleContent";
    TokenizerContextTypes["DoctypeOpen"] = "DoctypeOpen";
    TokenizerContextTypes["DoctypeClose"] = "DoctypeClose";
    TokenizerContextTypes["DoctypeAttributes"] = "DoctypeAttributes";
    TokenizerContextTypes["DoctypeAttributeWrapped"] = "DoctypeAttributeWrapped";
    TokenizerContextTypes["DoctypeAttributeBare"] = "DoctypeAttributeBare";
    TokenizerContextTypes["CommentOpen"] = "CommentOpen";
    TokenizerContextTypes["CommentContent"] = "CommentContent";
    TokenizerContextTypes["CommentClose"] = "CommentClose";
    TokenizerContextTypes["CustomTagRawContent"] = "CustomTagRawContent";
})($a40f14053b8109fa$var$TokenizerContextTypes || (module.exports.TokenizerContextTypes = $a40f14053b8109fa$var$TokenizerContextTypes = {}));

});

parcelRegister("13PFj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CLOSE_TAG_NAME_PATTERN = module.exports.OPEN_TAG_NAME_PATTERN = module.exports.CLOSING_STYLE_TAG_PATTERN = module.exports.CLOSING_SCRIPT_TAG_PATTERN = module.exports.INCOMPLETE_CLOSING_TAG_PATTERN = void 0;
module.exports.INCOMPLETE_CLOSING_TAG_PATTERN = /<\/[^>]+$/;
module.exports.CLOSING_SCRIPT_TAG_PATTERN = /<\/script\s*>/i;
module.exports.CLOSING_STYLE_TAG_PATTERN = /<\/style\s*>/i;
module.exports.OPEN_TAG_NAME_PATTERN = /^<(\S+)/;
module.exports.CLOSE_TAG_NAME_PATTERN = /^<\/((?:.|\r?\n)*)>$/;

});

parcelRegister("bqb37", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenTypes = void 0;
var $850ab198e4b6f072$var$TokenTypes;
(function(TokenTypes) {
    TokenTypes["Text"] = "Text";
    TokenTypes["RawContent"] = "RawContent";
    TokenTypes["OpenTagStart"] = "OpenTagStart";
    TokenTypes["OpenTagEnd"] = "OpenTagEnd";
    TokenTypes["CloseTag"] = "CloseTag";
    TokenTypes["AttributeKey"] = "AttributeKey";
    TokenTypes["AttributeAssignment"] = "AttributeAssignment";
    TokenTypes["AttributeValueWrapperStart"] = "AttributeValueWrapperStart";
    TokenTypes["AttributeValue"] = "AttributeValue";
    TokenTypes["AttributeValueWrapperEnd"] = "AttributeValueWrapperEnd";
    TokenTypes["DoctypeOpen"] = "DoctypeOpen";
    TokenTypes["DoctypeAttributeValue"] = "DoctypeAttributeValue";
    TokenTypes["DoctypeAttributeWrapperStart"] = "DoctypeAttributeWrapperStart";
    TokenTypes["DoctypeAttributeWrapperEnd"] = "DoctypeAttributeWrapperEnd";
    TokenTypes["DoctypeClose"] = "DoctypeClose";
    TokenTypes["CommentOpen"] = "CommentOpen";
    TokenTypes["CommentContent"] = "CommentContent";
    TokenTypes["CommentClose"] = "CommentClose";
    TokenTypes["OpenScriptTagStart"] = "OpenScriptTagStart";
    TokenTypes["OpenScriptTagEnd"] = "OpenScriptTagEnd";
    TokenTypes["ScriptTagContent"] = "ScriptTagContent";
    TokenTypes["CloseScriptTag"] = "CloseScriptTag";
    TokenTypes["OpenStyleTagStart"] = "OpenStyleTagStart";
    TokenTypes["OpenStyleTagEnd"] = "OpenStyleTagEnd";
    TokenTypes["StyleTagContent"] = "StyleTagContent";
    TokenTypes["CloseStyleTag"] = "CloseStyleTag";
    TokenTypes["Part"] = "Part";
    TokenTypes["OpenTemplate"] = "OpenTemplate";
    TokenTypes["Template"] = "Template";
    TokenTypes["CloseTemplate"] = "CloseTemplate";
})($850ab198e4b6f072$var$TokenTypes || (module.exports.TokenTypes = $850ab198e4b6f072$var$TokenTypes = {}));

});

parcelRegister("lefjN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeTypes = void 0;
var $03fd0340a19529c7$var$NodeTypes;
(function(NodeTypes) {
    NodeTypes["Document"] = "Document";
    NodeTypes["Tag"] = "Tag";
    NodeTypes["Text"] = "Text";
    NodeTypes["Doctype"] = "Doctype";
    NodeTypes["RawContent"] = "RawContent";
    NodeTypes["Comment"] = "Comment";
    NodeTypes["CommentOpen"] = "CommentOpen";
    NodeTypes["CommentClose"] = "CommentClose";
    NodeTypes["CommentContent"] = "CommentContent";
    NodeTypes["Attribute"] = "Attribute";
    NodeTypes["AttributeKey"] = "AttributeKey";
    NodeTypes["AttributeValue"] = "AttributeValue";
    NodeTypes["AttributeValueWrapperStart"] = "AttributeValueWrapperStart";
    NodeTypes["AttributeValueWrapperEnd"] = "AttributeValueWrapperEnd";
    NodeTypes["CloseTag"] = "CloseTag";
    NodeTypes["OpenTagEnd"] = "OpenTagEnd";
    NodeTypes["OpenTagStart"] = "OpenTagStart";
    NodeTypes["DoctypeOpen"] = "DoctypeOpen";
    NodeTypes["DoctypeAttribute"] = "DoctypeAttribute";
    NodeTypes["DoctypeClose"] = "DoctypeClose";
    NodeTypes["ScriptTag"] = "ScriptTag";
    NodeTypes["OpenScriptTagStart"] = "OpenScriptTagStart";
    NodeTypes["OpenScriptTagEnd"] = "OpenScriptTagEnd";
    NodeTypes["ScriptTagContent"] = "ScriptTagContent";
    NodeTypes["StyleTag"] = "StyleTag";
    NodeTypes["OpenStyleTagStart"] = "OpenStyleTagStart";
    NodeTypes["OpenStyleTagEnd"] = "OpenStyleTagEnd";
    NodeTypes["StyleTagContent"] = "StyleTagContent";
    NodeTypes["CloseStyleTag"] = "CloseStyleTag";
    NodeTypes["CloseScriptTag"] = "CloseScriptTag";
    NodeTypes["DoctypeAttributeValue"] = "DoctypeAttributeValue";
    NodeTypes["DoctypeAttributeWrapperStart"] = "DoctypeAttributeWrapperStart";
    NodeTypes["DoctypeAttributeWrapperEnd"] = "DoctypeAttributeWrapperEnd";
    NodeTypes["OpenTemplate"] = "OpenTemplate";
    NodeTypes["Template"] = "Template";
    NodeTypes["CloseTemplate"] = "CloseTemplate";
    NodeTypes["Part"] = "Part";
})($03fd0340a19529c7$var$NodeTypes || (module.exports.NodeTypes = $03fd0340a19529c7$var$NodeTypes = {}));

});

parcelRegister("e1WeV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConstructTreeContextTypes = void 0;
var $a36e55e0d0403665$var$ConstructTreeContextTypes;
(function(ConstructTreeContextTypes) {
    ConstructTreeContextTypes["TagContent"] = "TagContent";
    ConstructTreeContextTypes["Tag"] = "Tag";
    ConstructTreeContextTypes["TagName"] = "TagName";
    ConstructTreeContextTypes["Attributes"] = "Attributes";
    ConstructTreeContextTypes["Attribute"] = "Attribute";
    ConstructTreeContextTypes["AttributeValue"] = "AttributeValue";
    ConstructTreeContextTypes["Comment"] = "Comment";
    ConstructTreeContextTypes["Doctype"] = "Doctype";
    ConstructTreeContextTypes["DoctypeAttributes"] = "DoctypeAttributes";
    ConstructTreeContextTypes["DoctypeAttribute"] = "DoctypeAttribute";
    ConstructTreeContextTypes["ScriptTag"] = "ScriptTag";
    ConstructTreeContextTypes["StyleTag"] = "StyleTag";
})($a36e55e0d0403665$var$ConstructTreeContextTypes || (module.exports.ConstructTreeContextTypes = $a36e55e0d0403665$var$ConstructTreeContextTypes = {}));

});


parcelRegister("gcQy4", function(module, exports) {
"use strict";
var $bcc6875e0d5dcc54$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bcc6875e0d5dcc54$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bcc6875e0d5dcc54$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("8iHbi")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("6liet")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("iAFRe")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("t1iP7")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("7QYW3")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("gbp5G")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("1DUGf")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("c3RRl")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("jppUl")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("kDHII")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("g36fn")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("juANk")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("dbD3M")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("4SoTV")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("jiDL2")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("6HgXt")), module.exports);

$bcc6875e0d5dcc54$var$__exportStar((parcelRequire("hsZXd")), module.exports);

});
parcelRegister("8iHbi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateTokenCharactersRange = $60b18008b3bb99af$var$calculateTokenCharactersRange;
function $60b18008b3bb99af$var$calculateTokenCharactersRange(state, { keepBuffer: keepBuffer }) {
    const startPosition = state.sourceCode.index() - (state.accumulatedContent.length() - 1) - state.decisionBuffer.length();
    let endPosition;
    if (!keepBuffer) endPosition = state.sourceCode.index() - state.decisionBuffer.length();
    else endPosition = state.sourceCode.index();
    return [
        startPosition,
        endPosition + 1
    ];
}

});

parcelRegister("6liet", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isWhitespace = $49e2d8cd9e7bba44$var$isWhitespace;
function $49e2d8cd9e7bba44$var$isWhitespace(char) {
    return char === " " || char === "\n" || char === "\t" || char === "\r";
}

});

parcelRegister("iAFRe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseOpenTagName = $d88c0ed1665a5f2c$var$parseOpenTagName;

var $eJ62A = parcelRequire("eJ62A");
function $d88c0ed1665a5f2c$var$parseOpenTagName(openTagStartTokenContent) {
    const match = openTagStartTokenContent.match($eJ62A.OPEN_TAG_NAME_PATTERN);
    if (match === null) throw new Error("Unable to parse open tag name.\n" + `${openTagStartTokenContent} does not match pattern of opening tag.`);
    return match[1].toLowerCase();
}

});

parcelRegister("t1iP7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCloseTagName = $0573b837f2c70c71$var$parseCloseTagName;

var $eJ62A = parcelRequire("eJ62A");
function $0573b837f2c70c71$var$parseCloseTagName(closeTagTokenContent) {
    const match = closeTagTokenContent.match($eJ62A.CLOSE_TAG_NAME_PATTERN);
    if (match === null) throw new Error("Unable to parse close tag name.\n" + `${closeTagTokenContent} does not match pattern of closing tag.`);
    return match[1].trim().toLowerCase();
}

});

parcelRegister("7QYW3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearParent = $5b7ca836004a581f$var$clearParent;
function $5b7ca836004a581f$var$clearParent(ast) {
    const cleanAst = ast;
    delete cleanAst.parentRef;
    if (Array.isArray(ast.children)) // @ts-ignore
    cleanAst.children = ast.children.map((node)=>{
        return $5b7ca836004a581f$var$clearParent(node);
    });
    return cleanAst;
}

});

parcelRegister("gbp5G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateTokenLocation = $bc8122ea6c884e91$var$calculateTokenLocation;

var $juANk = parcelRequire("juANk");
function $bc8122ea6c884e91$var$calculateTokenLocation(source, range) {
    return {
        start: (0, $juANk.getLineInfo)(source, range[0]),
        end: (0, $juANk.getLineInfo)(source, range[1])
    };
}

});
parcelRegister("juANk", function(module, exports) {
"use strict";
//https://github.com/acornjs/acorn/blob/master/acorn/src/whitespace.js
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLineInfo = $e30d5c53500f5bc3$var$getLineInfo;
function $e30d5c53500f5bc3$var$isNewLine(code) {
    return code === 10 || code === 13 || code === 0x2028 || code === 0x2029;
}
function $e30d5c53500f5bc3$var$nextLineBreak(code, from, end = code.length) {
    for(let i = from; i < end; i++){
        const next = code.charCodeAt(i);
        if ($e30d5c53500f5bc3$var$isNewLine(next)) return i < end - 1 && next === 13 && code.charCodeAt(i + 1) === 10 ? i + 2 : i + 1;
    }
    return -1;
}
function $e30d5c53500f5bc3$var$getLineInfo(input, offset) {
    for(let line = 1, cur = 0;;){
        const nextBreak = $e30d5c53500f5bc3$var$nextLineBreak(input, cur, offset);
        if (nextBreak < 0) return {
            line: line,
            column: offset - cur
        };
        ++line;
        cur = nextBreak;
    }
}

});


parcelRegister("1DUGf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateTokenPosition = $1325667e281e4862$var$calculateTokenPosition;

var $8iHbi = parcelRequire("8iHbi");

var $gbp5G = parcelRequire("gbp5G");
function $1325667e281e4862$var$calculateTokenPosition(state, options) {
    const range = (0, $8iHbi.calculateTokenCharactersRange)(state, options);
    const loc = (0, $gbp5G.calculateTokenLocation)(state.sourceCode.source, range);
    return {
        range: range,
        loc: loc
    };
}

});

parcelRegister("c3RRl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.last = $8c7f8b3a6f988266$var$last;
function $8c7f8b3a6f988266$var$last(items) {
    return items[items.length - 1];
}

});

parcelRegister("jppUl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cloneRange = $e21472dcb8d70fe5$var$cloneRange;
function $e21472dcb8d70fe5$var$cloneRange(range) {
    return [
        range[0],
        range[1]
    ];
}

});

parcelRegister("kDHII", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createNodeFrom = $f0695d16fd34f2c7$var$createNodeFrom;

var $4SoTV = parcelRequire("4SoTV");

var $jppUl = parcelRequire("jppUl");
function $f0695d16fd34f2c7$var$createNodeFrom(token) {
    const loc = (0, $4SoTV.cloneLocation)(token.loc);
    const range = (0, $jppUl.cloneRange)(token.range);
    const ret = {
        type: token.type,
        value: token.value,
        loc: loc,
        range: range
    };
    // @ts-ignore
    if (token.parts) // @ts-ignore
    ret.parts = token.parts;
    return ret;
}

});
parcelRegister("4SoTV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cloneLocation = $38cf8565af183d13$var$cloneLocation;
function $38cf8565af183d13$var$cloneLocation(loc) {
    return {
        start: {
            line: loc.start.line,
            column: loc.start.column
        },
        end: {
            line: loc.end.line,
            column: loc.end.column
        }
    };
}

});


parcelRegister("g36fn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.updateNodeEnd = $baf1c5ac80cd52e2$var$updateNodeEnd;
function $baf1c5ac80cd52e2$var$updateNodeEnd(node, token) {
    node.range[1] = token.range[1];
    node.loc.end = Object.assign({}, token.loc.end);
}

});

parcelRegister("dbD3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.first = $999a99f031b2d479$var$first;
function $999a99f031b2d479$var$first(items) {
    return items[0];
}

});

parcelRegister("jiDL2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initChildrenIfNone = $e0ce89d3cd48b47a$var$initChildrenIfNone;
module.exports.initAttributesIfNone = $e0ce89d3cd48b47a$var$initAttributesIfNone;
function $e0ce89d3cd48b47a$var$initChildrenIfNone(node) {
    /* istanbul ignore next */ if (!node.children) node.children = [];
}
function $e0ce89d3cd48b47a$var$initAttributesIfNone(node) {
    /* istanbul ignore next */ if (!node.attributes) node.attributes = [];
}

});

parcelRegister("6HgXt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRange = void 0;
module.exports.createParts = $4e03e9cd92b1ec0e$var$createParts;

var $eJ62A = parcelRequire("eJ62A");

var $2Uq4m = parcelRequire("2Uq4m");
const $4e03e9cd92b1ec0e$var$getRange = (info)=>{
    return Array.isArray(info) ? info : [
        info.open[0],
        info.close[1]
    ];
};
module.exports.getRange = $4e03e9cd92b1ec0e$var$getRange;
function $4e03e9cd92b1ec0e$var$createParts(state, type) {
    return state.mode === "template" && state.accumulatedContent.hasTemplate() ? state.accumulatedContent.getParts().map((chars)=>{
        var _a, _b;
        if (chars.type === $2Uq4m.CharsType.HTML) {
            const base = {
                type: $eJ62A.TokenTypes.Part,
                range: chars.range,
                loc: state.sourceCode.getLocationOf(chars.range),
                value: chars.value,
                partOf: type
            };
            return Object.assign(Object.assign({}, base), {
                range: state.tokenAdapter.finalizeRange(base),
                loc: state.tokenAdapter.finalizeLocation(base)
            });
        }
        const open = ((_a = chars.wrapper) === null || _a === void 0 ? void 0 : _a.open) ? {
            type: $eJ62A.TokenTypes.OpenTemplate,
            range: chars.wrapper.open,
            loc: state.sourceCode.getLocationOf(chars.wrapper.open),
            value: state.sourceCode.source.slice(chars.wrapper.open[0], chars.wrapper.open[1])
        } : undefined;
        const close = ((_b = chars.wrapper) === null || _b === void 0 ? void 0 : _b.close) ? {
            type: $eJ62A.TokenTypes.CloseTemplate,
            range: chars.wrapper.close,
            loc: state.sourceCode.getLocationOf(chars.wrapper.close),
            value: state.sourceCode.source.slice(chars.wrapper.close[0], chars.wrapper.close[1])
        } : undefined;
        const base = {
            type: $eJ62A.TokenTypes.Template,
            range: chars.range,
            loc: state.sourceCode.getLocationOf(chars.range),
            value: chars.value,
            partOf: type,
            open: open && Object.assign(Object.assign({}, open), {
                range: state.tokenAdapter.finalizeRange(open),
                loc: state.tokenAdapter.finalizeLocation(open)
            }),
            close: close && Object.assign(Object.assign({}, close), {
                range: state.tokenAdapter.finalizeRange(close),
                loc: state.tokenAdapter.finalizeLocation(close)
            })
        };
        return Object.assign(Object.assign({}, base), {
            range: state.tokenAdapter.finalizeRange(base),
            loc: state.tokenAdapter.finalizeLocation(base)
        });
    }) : [];
}

});
parcelRegister("2Uq4m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chars = module.exports.CharsType = void 0;
var $21e5088b393229a9$var$CharsType;
(function(CharsType) {
    CharsType["HTML"] = "HTML";
    CharsType["OpenTemplate"] = "OpenTemplate";
    CharsType["Template"] = "Template";
    CharsType["CloseTemplate"] = "CloseTemplate";
})($21e5088b393229a9$var$CharsType || (module.exports.CharsType = $21e5088b393229a9$var$CharsType = {}));
class $21e5088b393229a9$var$Chars {
    constructor(type, value, range, wrapper){
        this.type = type;
        this.value = value;
        this.range = range;
        this.wrapper = wrapper;
        this.isTemplate = type !== $21e5088b393229a9$var$CharsType.HTML;
    }
    concat(chars) {
        this.value += chars.value;
        this.range[1] = chars.range[1];
    }
    equals(chars) {
        return this.value === chars;
    }
    length() {
        return this.value.length;
    }
}
module.exports.Chars = $21e5088b393229a9$var$Chars;

});


parcelRegister("hsZXd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.raise = $cb751bf7f32681b0$var$raise;
function $cb751bf7f32681b0$var$raise(position, message) {
    const errorMessage = message + " (" + position.loc.start.line + ":" + position.loc.start.column + ")";
    const error = new SyntaxError(errorMessage);
    error.pos = position.range[0];
    error.loc = position.loc;
    error.raiseAt = position.range[0];
    throw error;
}

});


parcelRegister("fYahD", function(module, exports) {
"use strict";
var $ba046fac894ec738$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ba046fac894ec738$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ba046fac894ec738$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ba046fac894ec738$var$__createBinding(result, mod, k);
    }
    $ba046fac894ec738$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tag = module.exports.tagName = module.exports.tagContent = module.exports.styleTag = module.exports.scriptTag = module.exports.doctype = module.exports.doctypeAttributes = module.exports.doctypeAttribute = module.exports.comment = module.exports.attribute = module.exports.attributes = module.exports.attributeValue = void 0;

module.exports.attributeValue = $ba046fac894ec738$var$__importStar((parcelRequire("jcclM")));

module.exports.attributes = $ba046fac894ec738$var$__importStar((parcelRequire("kJUlH")));

module.exports.attribute = $ba046fac894ec738$var$__importStar((parcelRequire("SkigF")));

module.exports.comment = $ba046fac894ec738$var$__importStar((parcelRequire("fgXxU")));

module.exports.doctypeAttribute = $ba046fac894ec738$var$__importStar((parcelRequire("5X5Na")));

module.exports.doctypeAttributes = $ba046fac894ec738$var$__importStar((parcelRequire("2sLya")));

module.exports.doctype = $ba046fac894ec738$var$__importStar((parcelRequire("hNZvX")));

module.exports.scriptTag = $ba046fac894ec738$var$__importStar((parcelRequire("1vV44")));

module.exports.styleTag = $ba046fac894ec738$var$__importStar((parcelRequire("70Scf")));

module.exports.tagContent = $ba046fac894ec738$var$__importStar((parcelRequire("75jsl")));

module.exports.tagName = $ba046fac894ec738$var$__importStar((parcelRequire("8AlDl")));

module.exports.tag = $ba046fac894ec738$var$__importStar((parcelRequire("4VK2U")));

});
parcelRegister("jcclM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.construct = $df98b7cc6193307f$var$construct;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
const $df98b7cc6193307f$var$VALUE_END_TOKENS = [
    $eJ62A.TokenTypes.OpenTagEnd,
    $eJ62A.TokenTypes.AttributeKey,
    $eJ62A.TokenTypes.AttributeAssignment,
    $eJ62A.TokenTypes.OpenScriptTagEnd,
    $eJ62A.TokenTypes.OpenStyleTagEnd
];
function $df98b7cc6193307f$var$getLastAttribute(state) {
    const attributes = state.currentNode.attributes;
    return attributes[attributes.length - 1];
}
function $df98b7cc6193307f$var$handleValueEnd(state) {
    state.currentContext = state.currentContext.parentRef;
    return state;
}
function $df98b7cc6193307f$var$handleAttributeValue(state, token) {
    const attribute = $df98b7cc6193307f$var$getLastAttribute(state);
    attribute.value = (0, $gcQy4.createNodeFrom)(token);
    (0, $gcQy4.updateNodeEnd)(attribute, token);
    state.caretPosition++;
    return state;
}
function $df98b7cc6193307f$var$handleAttributeValueWrapperStart(state, token) {
    const attribute = $df98b7cc6193307f$var$getLastAttribute(state);
    attribute.startWrapper = (0, $gcQy4.createNodeFrom)(token);
    if (!attribute.key) {
        attribute.range = (0, $gcQy4.cloneRange)(token.range);
        attribute.loc = (0, $gcQy4.cloneLocation)(token.loc);
    }
    state.caretPosition++;
    return state;
}
function $df98b7cc6193307f$var$handleAttributeValueWrapperEnd(state, token) {
    const attribute = $df98b7cc6193307f$var$getLastAttribute(state);
    attribute.endWrapper = (0, $gcQy4.createNodeFrom)(token);
    (0, $gcQy4.updateNodeEnd)(attribute, token);
    state.caretPosition++;
    return state;
}
function $df98b7cc6193307f$var$construct(token, state) {
    if ($df98b7cc6193307f$var$VALUE_END_TOKENS.indexOf(token.type) !== -1) return $df98b7cc6193307f$var$handleValueEnd(state);
    if (token.type === $eJ62A.TokenTypes.AttributeValue) return $df98b7cc6193307f$var$handleAttributeValue(state, token);
    if (token.type === $eJ62A.TokenTypes.AttributeValueWrapperStart) return $df98b7cc6193307f$var$handleAttributeValueWrapperStart(state, token);
    if (token.type === $eJ62A.TokenTypes.AttributeValueWrapperEnd) return $df98b7cc6193307f$var$handleAttributeValueWrapperEnd(state, token);
    state.caretPosition++;
    return state;
}

});

parcelRegister("kJUlH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.construct = $f193b855faa23662$var$construct;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
const $f193b855faa23662$var$ATTRIBUTE_START_TOKENS = [
    $eJ62A.TokenTypes.AttributeKey,
    $eJ62A.TokenTypes.AttributeAssignment
];
const $f193b855faa23662$var$ATTRIBUTES_END_TOKENS = [
    $eJ62A.TokenTypes.OpenTagEnd,
    $eJ62A.TokenTypes.OpenStyleTagEnd,
    $eJ62A.TokenTypes.OpenScriptTagEnd
];
function $f193b855faa23662$var$handlerAttributeStart(state, token) {
    (0, $gcQy4.initAttributesIfNone)(state.currentNode);
    // new empty attribute
    state.currentNode.attributes.push({
        type: $eJ62A.NodeTypes.Attribute,
        range: (0, $gcQy4.cloneRange)(token.range),
        loc: (0, $gcQy4.cloneLocation)(token.loc)
    });
    state.currentContext = {
        parentRef: state.currentContext,
        type: $eJ62A.ConstructTreeContextTypes.Attribute
    };
    return state;
}
function $f193b855faa23662$var$handleOpenTagEnd(state) {
    state.currentContext = state.currentContext.parentRef;
    return state;
}
function $f193b855faa23662$var$construct(token, state) {
    if ($f193b855faa23662$var$ATTRIBUTE_START_TOKENS.indexOf(token.type) !== -1) return $f193b855faa23662$var$handlerAttributeStart(state, token);
    if ($f193b855faa23662$var$ATTRIBUTES_END_TOKENS.indexOf(token.type) !== -1) return $f193b855faa23662$var$handleOpenTagEnd(state);
    state.caretPosition++;
    return state;
}

});

parcelRegister("SkigF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.construct = $0a34c927985f45b2$var$construct;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
const $0a34c927985f45b2$var$OPEN_TAG_END_TOKENS = [
    $eJ62A.TokenTypes.OpenTagEnd,
    $eJ62A.TokenTypes.OpenScriptTagEnd,
    $eJ62A.TokenTypes.OpenStyleTagEnd
];
function $0a34c927985f45b2$var$getLastAttribute(state) {
    const attributes = state.currentNode.attributes;
    return attributes[attributes.length - 1];
}
function $0a34c927985f45b2$var$handleOpenTagEnd(state) {
    state.currentContext = state.currentContext.parentRef;
    return state;
}
function $0a34c927985f45b2$var$handleAttributeKey(state, token) {
    const attribute = $0a34c927985f45b2$var$getLastAttribute(state);
    if (attribute.key !== undefined || attribute.value !== undefined) {
        state.currentContext = state.currentContext.parentRef;
        return state;
    }
    attribute.key = (0, $gcQy4.createNodeFrom)(token);
    state.caretPosition++;
    return state;
}
function $0a34c927985f45b2$var$handleAttributeAssignment(state) {
    const attribute = $0a34c927985f45b2$var$getLastAttribute(state);
    if (attribute.value !== undefined) {
        state.currentContext = state.currentContext.parentRef;
        return state;
    }
    state.currentContext = {
        parentRef: state.currentContext,
        type: $eJ62A.ConstructTreeContextTypes.AttributeValue
    };
    state.caretPosition++;
    return state;
}
function $0a34c927985f45b2$var$construct(token, state) {
    if ($0a34c927985f45b2$var$OPEN_TAG_END_TOKENS.indexOf(token.type) !== -1) return $0a34c927985f45b2$var$handleOpenTagEnd(state);
    if (token.type === $eJ62A.TokenTypes.AttributeKey) return $0a34c927985f45b2$var$handleAttributeKey(state, token);
    if (token.type === $eJ62A.TokenTypes.AttributeAssignment) return $0a34c927985f45b2$var$handleAttributeAssignment(state);
    state.caretPosition++;
    return state;
}

});

parcelRegister("fgXxU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.construct = $b1e68a34d65fd54b$var$construct;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $b1e68a34d65fd54b$var$handleCommentOpen(state, token) {
    state.currentNode.open = (0, $gcQy4.createNodeFrom)(token);
    state.caretPosition++;
    return state;
}
function $b1e68a34d65fd54b$var$handleCommentContent(state, token) {
    state.currentNode.value = (0, $gcQy4.createNodeFrom)(token);
    state.caretPosition++;
    return state;
}
function $b1e68a34d65fd54b$var$handleCommentClose(state, token) {
    state.currentNode.close = (0, $gcQy4.createNodeFrom)(token);
    (0, $gcQy4.updateNodeEnd)(state.currentNode, token);
    state.currentNode = state.currentNode.parentRef;
    state.currentContext = state.currentContext.parentRef;
    state.caretPosition++;
    return state;
}
function $b1e68a34d65fd54b$var$construct(token, state) {
    if (token.type === $eJ62A.TokenTypes.CommentOpen) return $b1e68a34d65fd54b$var$handleCommentOpen(state, token);
    if (token.type === $eJ62A.TokenTypes.CommentContent) return $b1e68a34d65fd54b$var$handleCommentContent(state, token);
    if (token.type === $eJ62A.TokenTypes.CommentClose) return $b1e68a34d65fd54b$var$handleCommentClose(state, token);
    state.caretPosition++;
    return state;
}

});

parcelRegister("5X5Na", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.construct = $4556f49e007240a4$var$construct;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $4556f49e007240a4$var$getLastAttribute(state) {
    const attributes = state.currentNode.attributes;
    return attributes[attributes.length - 1];
}
function $4556f49e007240a4$var$handleDoctypeClose(state) {
    state.currentContext = state.currentContext.parentRef;
    return state;
}
function $4556f49e007240a4$var$handleAttributeValue(state, token) {
    const attribute = $4556f49e007240a4$var$getLastAttribute(state);
    if (attribute.value !== undefined) {
        state.currentContext = state.currentContext.parentRef;
        return state;
    }
    attribute.value = (0, $gcQy4.createNodeFrom)(token);
    if (!attribute.startWrapper) attribute.range = (0, $gcQy4.cloneRange)(token.range);
    state.caretPosition++;
    return state;
}
function $4556f49e007240a4$var$handleAttributeWrapperStart(state, token) {
    const attribute = $4556f49e007240a4$var$getLastAttribute(state);
    if (attribute.value !== undefined) {
        state.currentContext = state.currentContext.parentRef;
        return state;
    }
    attribute.startWrapper = (0, $gcQy4.createNodeFrom)(token);
    attribute.range = (0, $gcQy4.cloneRange)(token.range);
    state.caretPosition++;
    return state;
}
function $4556f49e007240a4$var$handleAttributeWrapperEnd(state, token) {
    const attribute = $4556f49e007240a4$var$getLastAttribute(state);
    attribute.endWrapper = (0, $gcQy4.createNodeFrom)(token);
    (0, $gcQy4.updateNodeEnd)(attribute, token);
    state.currentContext = state.currentContext.parentRef;
    state.caretPosition++;
    return state;
}
function $4556f49e007240a4$var$construct(token, state) {
    if (token.type === $eJ62A.TokenTypes.DoctypeClose) return $4556f49e007240a4$var$handleDoctypeClose(state);
    if (token.type === $eJ62A.TokenTypes.DoctypeAttributeWrapperStart) return $4556f49e007240a4$var$handleAttributeWrapperStart(state, token);
    if (token.type === $eJ62A.TokenTypes.DoctypeAttributeWrapperEnd) return $4556f49e007240a4$var$handleAttributeWrapperEnd(state, token);
    if (token.type === $eJ62A.TokenTypes.DoctypeAttributeValue) return $4556f49e007240a4$var$handleAttributeValue(state, token);
    state.caretPosition++;
    return state;
}

});

parcelRegister("2sLya", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.construct = $1cb314c6f042f35d$var$construct;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
const $1cb314c6f042f35d$var$ATTRIBUTE_START_TOKENS = [
    $eJ62A.TokenTypes.DoctypeAttributeWrapperStart,
    $eJ62A.TokenTypes.DoctypeAttributeValue
];
function $1cb314c6f042f35d$var$handleDoctypeClose(state) {
    state.currentContext = state.currentContext.parentRef;
    return state;
}
function $1cb314c6f042f35d$var$handleAttribute(state, token) {
    (0, $gcQy4.initAttributesIfNone)(state.currentNode);
    // new empty attribute
    state.currentNode.attributes.push({
        type: $eJ62A.NodeTypes.DoctypeAttribute,
        range: (0, $gcQy4.cloneRange)(token.range),
        loc: (0, $gcQy4.cloneLocation)(token.loc)
    });
    state.currentContext = {
        type: $eJ62A.ConstructTreeContextTypes.DoctypeAttribute,
        parentRef: state.currentContext
    };
    return state;
}
function $1cb314c6f042f35d$var$construct(token, state) {
    if (token.type === $eJ62A.TokenTypes.DoctypeClose) return $1cb314c6f042f35d$var$handleDoctypeClose(state);
    if ($1cb314c6f042f35d$var$ATTRIBUTE_START_TOKENS.indexOf(token.type) !== -1) return $1cb314c6f042f35d$var$handleAttribute(state, token);
    state.caretPosition++;
    return state;
}

});

parcelRegister("hNZvX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.construct = $cf66babba241a4b8$var$construct;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
const $cf66babba241a4b8$var$ATTRIBUTES_START_TOKENS = [
    $eJ62A.TokenTypes.DoctypeAttributeWrapperStart,
    $eJ62A.TokenTypes.DoctypeAttributeValue
];
function $cf66babba241a4b8$var$handleDoctypeOpen(state, token) {
    state.currentNode.open = (0, $gcQy4.createNodeFrom)(token);
    state.caretPosition++;
    return state;
}
function $cf66babba241a4b8$var$handleDoctypeClose(state, token) {
    state.currentNode.close = (0, $gcQy4.createNodeFrom)(token);
    (0, $gcQy4.updateNodeEnd)(state.currentNode, token);
    state.currentNode = state.currentNode.parentRef;
    state.currentContext = state.currentContext.parentRef;
    state.caretPosition++;
    return state;
}
function $cf66babba241a4b8$var$handleDoctypeAttributes(state) {
    state.currentContext = {
        parentRef: state.currentContext,
        type: $eJ62A.ConstructTreeContextTypes.DoctypeAttributes
    };
    return state;
}
function $cf66babba241a4b8$var$construct(token, state) {
    if (token.type === $eJ62A.TokenTypes.DoctypeOpen) return $cf66babba241a4b8$var$handleDoctypeOpen(state, token);
    if (token.type === $eJ62A.TokenTypes.DoctypeClose) return $cf66babba241a4b8$var$handleDoctypeClose(state, token);
    if ($cf66babba241a4b8$var$ATTRIBUTES_START_TOKENS.indexOf(token.type) !== -1) return $cf66babba241a4b8$var$handleDoctypeAttributes(state);
    state.caretPosition++;
    return state;
}

});

parcelRegister("1vV44", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.construct = $11a4f39130ec3cb0$var$construct;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
const $11a4f39130ec3cb0$var$ATTRIBUTE_START_TOKENS = [
    $eJ62A.TokenTypes.AttributeKey,
    $eJ62A.TokenTypes.AttributeAssignment
];
function $11a4f39130ec3cb0$var$handleOpenScriptTagStart(state, token) {
    state.currentNode.openStart = (0, $gcQy4.createNodeFrom)(token);
    (0, $gcQy4.updateNodeEnd)(state.currentNode, token);
    state.caretPosition++;
    return state;
}
function $11a4f39130ec3cb0$var$handleAttributeStartScript(state) {
    state.currentContext = {
        parentRef: state.currentContext,
        type: $eJ62A.ConstructTreeContextTypes.Attributes
    };
    return state;
}
function $11a4f39130ec3cb0$var$handleOpenScriptTagEnd(state, token) {
    state.currentNode.openEnd = (0, $gcQy4.createNodeFrom)(token);
    (0, $gcQy4.updateNodeEnd)(state.currentNode, token);
    state.caretPosition++;
    return state;
}
function $11a4f39130ec3cb0$var$handleScriptContent(state, token) {
    state.currentNode.value = (0, $gcQy4.createNodeFrom)(token);
    (0, $gcQy4.updateNodeEnd)(state.currentNode, token);
    state.caretPosition++;
    return state;
}
function $11a4f39130ec3cb0$var$handleCloseScriptTag(state, token) {
    state.currentNode.close = (0, $gcQy4.createNodeFrom)(token);
    (0, $gcQy4.updateNodeEnd)(state.currentNode, token);
    state.currentNode = state.currentNode.parentRef;
    state.currentContext = state.currentContext.parentRef;
    state.caretPosition++;
    return state;
}
function $11a4f39130ec3cb0$var$construct(token, state) {
    if (token.type === $eJ62A.TokenTypes.OpenScriptTagStart) return $11a4f39130ec3cb0$var$handleOpenScriptTagStart(state, token);
    if ($11a4f39130ec3cb0$var$ATTRIBUTE_START_TOKENS.indexOf(token.type) !== -1) return $11a4f39130ec3cb0$var$handleAttributeStartScript(state);
    if (token.type === $eJ62A.TokenTypes.OpenScriptTagEnd) return $11a4f39130ec3cb0$var$handleOpenScriptTagEnd(state, token);
    if (token.type === $eJ62A.TokenTypes.ScriptTagContent) return $11a4f39130ec3cb0$var$handleScriptContent(state, token);
    if (token.type === $eJ62A.TokenTypes.CloseScriptTag) return $11a4f39130ec3cb0$var$handleCloseScriptTag(state, token);
    state.caretPosition++;
    return state;
}

});

parcelRegister("70Scf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.construct = $51b292d239491f36$var$construct;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
const $51b292d239491f36$var$ATTRIBUTE_START_TOKENS = [
    $eJ62A.TokenTypes.AttributeKey,
    $eJ62A.TokenTypes.AttributeAssignment
];
function $51b292d239491f36$var$handleOpenStyleTagStart(state, token) {
    state.currentNode.openStart = (0, $gcQy4.createNodeFrom)(token);
    (0, $gcQy4.updateNodeEnd)(state.currentNode, token);
    state.caretPosition++;
    return state;
}
function $51b292d239491f36$var$handleAttributeStartStyle(state) {
    state.currentContext = {
        parentRef: state.currentContext,
        type: $eJ62A.ConstructTreeContextTypes.Attributes
    };
    return state;
}
function $51b292d239491f36$var$handleOpenStyleTagEnd(state, token) {
    state.currentNode.openEnd = (0, $gcQy4.createNodeFrom)(token);
    (0, $gcQy4.updateNodeEnd)(state.currentNode, token);
    state.caretPosition++;
    return state;
}
function $51b292d239491f36$var$handleStyleContent(state, token) {
    state.currentNode.value = (0, $gcQy4.createNodeFrom)(token);
    (0, $gcQy4.updateNodeEnd)(state.currentNode, token);
    state.caretPosition++;
    return state;
}
function $51b292d239491f36$var$handleCloseStyleTag(state, token) {
    state.currentNode.close = (0, $gcQy4.createNodeFrom)(token);
    (0, $gcQy4.updateNodeEnd)(state.currentNode, token);
    state.currentNode = state.currentNode.parentRef;
    state.currentContext = state.currentContext.parentRef;
    state.caretPosition++;
    return state;
}
function $51b292d239491f36$var$construct(token, state) {
    if (token.type === $eJ62A.TokenTypes.OpenStyleTagStart) return $51b292d239491f36$var$handleOpenStyleTagStart(state, token);
    if ($51b292d239491f36$var$ATTRIBUTE_START_TOKENS.indexOf(token.type) !== -1) return $51b292d239491f36$var$handleAttributeStartStyle(state);
    if (token.type === $eJ62A.TokenTypes.OpenStyleTagEnd) return $51b292d239491f36$var$handleOpenStyleTagEnd(state, token);
    if (token.type === $eJ62A.TokenTypes.StyleTagContent) return $51b292d239491f36$var$handleStyleContent(state, token);
    if (token.type === $eJ62A.TokenTypes.CloseStyleTag) return $51b292d239491f36$var$handleCloseStyleTag(state, token);
    state.caretPosition++;
    return state;
}

});

parcelRegister("75jsl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.construct = $528817997a28b89a$var$construct;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $528817997a28b89a$var$handleOpenTagStart(state, token) {
    (0, $gcQy4.initChildrenIfNone)(state.currentNode);
    const tagNode = {
        type: $eJ62A.NodeTypes.Tag,
        parentRef: state.currentNode,
        range: (0, $gcQy4.cloneRange)(token.range),
        loc: (0, $gcQy4.cloneLocation)(token.loc),
        attributes: [],
        children: []
    };
    state.currentNode.children.push(tagNode);
    state.currentNode = tagNode;
    state.currentContext = {
        parentRef: state.currentContext,
        type: $eJ62A.ConstructTreeContextTypes.Tag
    };
    return state;
}
function $528817997a28b89a$var$handleCloseTag(state, token) {
    const closeTagName = (0, $gcQy4.parseCloseTagName)(token.value);
    if (closeTagName !== state.currentNode.name) {
        state.caretPosition++;
        return state;
    }
    state.currentContext = state.currentContext.parentRef;
    return state;
}
function $528817997a28b89a$var$handleCommentOpen(state, token) {
    (0, $gcQy4.initChildrenIfNone)(state.currentNode);
    const commentNode = {
        type: $eJ62A.NodeTypes.Comment,
        parentRef: state.currentNode,
        range: (0, $gcQy4.cloneRange)(token.range),
        loc: (0, $gcQy4.cloneLocation)(token.loc)
    };
    state.currentNode.children.push(commentNode);
    // @ts-ignore
    state.currentNode = commentNode;
    state.currentContext = {
        parentRef: state.currentContext,
        type: $eJ62A.ConstructTreeContextTypes.Comment
    };
    return state;
}
function $528817997a28b89a$var$handleDoctypeOpen(state, token) {
    (0, $gcQy4.initChildrenIfNone)(state.currentNode);
    const doctypeNode = {
        type: $eJ62A.NodeTypes.Doctype,
        parentRef: state.currentNode,
        range: (0, $gcQy4.cloneRange)(token.range),
        loc: (0, $gcQy4.cloneLocation)(token.loc),
        attributes: []
    };
    state.currentNode.children.push(doctypeNode);
    // @ts-ignore
    state.currentNode = doctypeNode;
    state.currentContext = {
        parentRef: state.currentContext,
        type: $eJ62A.ConstructTreeContextTypes.Doctype
    };
    return state;
}
function $528817997a28b89a$var$handleText(state, token) {
    (0, $gcQy4.initChildrenIfNone)(state.currentNode);
    const textNode = (0, $gcQy4.createNodeFrom)(token);
    state.currentNode.children.push(textNode);
    state.caretPosition++;
    return state;
}
function $528817997a28b89a$var$handleRawContent(state, token) {
    (0, $gcQy4.initChildrenIfNone)(state.currentNode);
    const rawContentNode = (0, $gcQy4.createNodeFrom)(token);
    state.currentNode.children.push(rawContentNode);
    state.caretPosition++;
    return state;
}
function $528817997a28b89a$var$handleOpenScriptTagStart(state, token) {
    (0, $gcQy4.initChildrenIfNone)(state.currentNode);
    const scriptNode = {
        type: $eJ62A.NodeTypes.ScriptTag,
        parentRef: state.currentNode,
        range: (0, $gcQy4.cloneRange)(token.range),
        loc: (0, $gcQy4.cloneLocation)(token.loc),
        attributes: []
    };
    state.currentNode.children.push(scriptNode);
    // @ts-ignore
    state.currentNode = scriptNode;
    state.currentContext = {
        type: $eJ62A.ConstructTreeContextTypes.ScriptTag,
        parentRef: state.currentContext
    };
    return state;
}
function $528817997a28b89a$var$handleOpenStyleTagStart(state, token) {
    (0, $gcQy4.initChildrenIfNone)(state.currentNode);
    const styleNode = {
        type: $eJ62A.NodeTypes.StyleTag,
        parentRef: state.currentNode,
        range: (0, $gcQy4.cloneRange)(token.range),
        loc: (0, $gcQy4.cloneLocation)(token.loc),
        attributes: []
    };
    state.currentNode.children.push(styleNode);
    // @ts-ignore
    state.currentNode = styleNode;
    state.currentContext = {
        type: $eJ62A.ConstructTreeContextTypes.StyleTag,
        parentRef: state.currentContext
    };
    return state;
}
function $528817997a28b89a$var$construct(token, state) {
    if (token.type === $eJ62A.TokenTypes.OpenScriptTagStart) return $528817997a28b89a$var$handleOpenScriptTagStart(state, token);
    if (token.type === $eJ62A.TokenTypes.OpenStyleTagStart) return $528817997a28b89a$var$handleOpenStyleTagStart(state, token);
    if (token.type === $eJ62A.TokenTypes.OpenTagStart) return $528817997a28b89a$var$handleOpenTagStart(state, token);
    if (token.type === $eJ62A.TokenTypes.Text) return $528817997a28b89a$var$handleText(state, token);
    if (token.type === $eJ62A.TokenTypes.RawContent) return $528817997a28b89a$var$handleRawContent(state, token);
    if (token.type === $eJ62A.TokenTypes.CloseTag) return $528817997a28b89a$var$handleCloseTag(state, token);
    if (token.type === $eJ62A.TokenTypes.CommentOpen) return $528817997a28b89a$var$handleCommentOpen(state, token);
    if (token.type === $eJ62A.TokenTypes.DoctypeOpen) return $528817997a28b89a$var$handleDoctypeOpen(state, token);
    state.caretPosition++;
    return state;
}

});

parcelRegister("8AlDl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.construct = $64027784f7a68361$var$construct;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $64027784f7a68361$var$handleTagOpenStart(state, token) {
    state.currentNode.name = (0, $gcQy4.parseOpenTagName)(token.value);
    state.currentContext = state.currentContext.parentRef;
    return state;
}
function $64027784f7a68361$var$construct(token, state) {
    if (token.type === $eJ62A.TokenTypes.OpenTagStart) $64027784f7a68361$var$handleTagOpenStart(state, token);
    state.caretPosition++;
    return state;
}

});

parcelRegister("4VK2U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.construct = $3970341144406545$var$construct;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
const $3970341144406545$var$ATTRIBUTE_START_TOKENS = [
    $eJ62A.TokenTypes.AttributeKey,
    $eJ62A.TokenTypes.AttributeAssignment
];
const $3970341144406545$var$SELF_CLOSING_TAGS = [
    "area",
    "base",
    "br",
    "col",
    "embed",
    "hr",
    "img",
    "input",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
];
function $3970341144406545$var$handleOpenTagStart(state, token) {
    state.currentNode.openStart = (0, $gcQy4.createNodeFrom)(token);
    state.currentContext = {
        parentRef: state.currentContext,
        type: $eJ62A.ConstructTreeContextTypes.TagName
    };
    return state;
}
function $3970341144406545$var$handleAttributeStart(state) {
    state.currentContext = {
        parentRef: state.currentContext,
        type: $eJ62A.ConstructTreeContextTypes.Attributes
    };
    return state;
}
function $3970341144406545$var$handleOpenTagEnd(state, token) {
    const tagName = state.currentNode.name;
    state.currentNode.openEnd = (0, $gcQy4.createNodeFrom)(token);
    (0, $gcQy4.updateNodeEnd)(state.currentNode, token);
    if ($3970341144406545$var$SELF_CLOSING_TAGS.indexOf(tagName) !== -1 || state.currentNode.openEnd.value === "/>") {
        state.currentNode.selfClosing = true;
        state.currentNode = state.currentNode.parentRef;
        state.currentContext = state.currentContext.parentRef;
        state.caretPosition++;
        return state;
    }
    state.currentNode.selfClosing = false;
    state.currentContext = {
        parentRef: state.currentContext,
        type: $eJ62A.ConstructTreeContextTypes.TagContent
    };
    state.caretPosition++;
    return state;
}
function $3970341144406545$var$handleCloseTag(state, token) {
    state.currentNode.close = (0, $gcQy4.createNodeFrom)(token);
    (0, $gcQy4.updateNodeEnd)(state.currentNode, token);
    state.currentNode = state.currentNode.parentRef;
    state.currentContext = state.currentContext.parentRef;
    state.caretPosition++;
    return state;
}
function $3970341144406545$var$construct(token, state) {
    if (token.type === $eJ62A.TokenTypes.OpenTagStart) return $3970341144406545$var$handleOpenTagStart(state, token);
    if ($3970341144406545$var$ATTRIBUTE_START_TOKENS.indexOf(token.type) !== -1) return $3970341144406545$var$handleAttributeStart(state);
    if (token.type === $eJ62A.TokenTypes.OpenTagEnd) return $3970341144406545$var$handleOpenTagEnd(state, token);
    if (token.type === $eJ62A.TokenTypes.CloseTag) return $3970341144406545$var$handleCloseTag(state, token);
    state.caretPosition++;
    return state;
}

});




parcelRegister("z9qXh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tokenize = void 0;

var $86Nrj = parcelRequire("86Nrj");
Object.defineProperty(module.exports, "tokenize", {
    enumerable: true,
    get: function() {
        return $86Nrj.tokenize;
    }
});

});
parcelRegister("86Nrj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tokenize = $5e753be9d380053e$var$tokenize;

var $eJ62A = parcelRequire("eJ62A");

var $dUYFn = parcelRequire("dUYFn");

var $3Yi6a = parcelRequire("3Yi6a");

var $78lcF = parcelRequire("78lcF");
const $5e753be9d380053e$var$contextHandlers = {
    [$eJ62A.TokenizerContextTypes.Data]: $dUYFn.data,
    [$eJ62A.TokenizerContextTypes.OpenTagStart]: $dUYFn.openTagStart,
    [$eJ62A.TokenizerContextTypes.CloseTag]: $dUYFn.closeTag,
    [$eJ62A.TokenizerContextTypes.Attributes]: $dUYFn.attributes,
    [$eJ62A.TokenizerContextTypes.OpenTagEnd]: $dUYFn.openTagEnd,
    [$eJ62A.TokenizerContextTypes.AttributeKey]: $dUYFn.attributeKey,
    [$eJ62A.TokenizerContextTypes.AttributeValue]: $dUYFn.attributeValue,
    [$eJ62A.TokenizerContextTypes.AttributeValueBare]: $dUYFn.attributeValueBare,
    [$eJ62A.TokenizerContextTypes.AttributeValueWrapped]: $dUYFn.attributeValueWrapped,
    [$eJ62A.TokenizerContextTypes.ScriptContent]: $dUYFn.scriptTagContent,
    [$eJ62A.TokenizerContextTypes.StyleContent]: $dUYFn.styleTagContent,
    [$eJ62A.TokenizerContextTypes.DoctypeOpen]: $dUYFn.DoctypeOpen,
    [$eJ62A.TokenizerContextTypes.DoctypeClose]: $dUYFn.DoctypeClose,
    [$eJ62A.TokenizerContextTypes.DoctypeAttributes]: $dUYFn.doctypeAttributes,
    [$eJ62A.TokenizerContextTypes.DoctypeAttributeWrapped]: $dUYFn.doctypeAttributeWrapped,
    [$eJ62A.TokenizerContextTypes.DoctypeAttributeBare]: $dUYFn.doctypeAttributeBare,
    [$eJ62A.TokenizerContextTypes.CommentContent]: $dUYFn.commentContent,
    [$eJ62A.TokenizerContextTypes.CustomTagRawContent]: $dUYFn.customTagRawContent,
    [$eJ62A.TokenizerContextTypes.CommentOpen]: $dUYFn.noop,
    [$eJ62A.TokenizerContextTypes.CommentClose]: $dUYFn.noop
};
function $5e753be9d380053e$var$tokenizeChars(state) {
    while(!state.sourceCode.isEof()){
        const handler = $5e753be9d380053e$var$contextHandlers[state.currentContext];
        state.decisionBuffer.concat(state.sourceCode.current());
        handler.parse(state.decisionBuffer, state);
    }
    const handler = $5e753be9d380053e$var$contextHandlers[state.currentContext];
    state.sourceCode.prev();
    if (handler.handleContentEnd !== undefined) handler.handleContentEnd(state);
}
function $5e753be9d380053e$var$tokenize(source = "", tokenAdapter, options = {
    templateInfos: undefined,
    rawContentTags: undefined
}) {
    const tokens = [];
    const state = {
        currentContext: $eJ62A.TokenizerContextTypes.Data,
        contextParams: {},
        mode: options.templateInfos ? "template" : "default",
        templateInfos: options.templateInfos || [],
        decisionBuffer: new $78lcF.CharsBuffer(),
        accumulatedContent: new $78lcF.CharsBuffer(),
        tokenAdapter: tokenAdapter,
        rawContentTags: options.rawContentTags,
        sourceCode: new $3Yi6a.SourceCode(source, options.templateInfos || []),
        tokens: {
            push (token) {
                tokens.push(Object.assign(Object.assign({}, token), {
                    range: tokenAdapter.finalizeRange(token),
                    loc: tokenAdapter.finalizeLocation(token)
                }));
            }
        }
    };
    $5e753be9d380053e$var$tokenizeChars(state);
    return {
        state: state,
        tokens: tokens
    };
}

});
parcelRegister("dUYFn", function(module, exports) {
"use strict";
var $a21f906d6457fcf9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a21f906d6457fcf9$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a21f906d6457fcf9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a21f906d6457fcf9$var$__createBinding(result, mod, k);
    }
    $a21f906d6457fcf9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.noop = module.exports.customTagRawContent = module.exports.styleTagContent = module.exports.scriptTagContent = module.exports.openTagStart = module.exports.openTagEnd = module.exports.DoctypeOpen = module.exports.DoctypeClose = module.exports.doctypeAttributes = module.exports.doctypeAttributeWrapped = module.exports.doctypeAttributeBare = module.exports.data = module.exports.commentContent = module.exports.closeTag = module.exports.attributes = module.exports.attributeValue = module.exports.attributeValueWrapped = module.exports.attributeValueBare = module.exports.attributeKey = void 0;

module.exports.attributeKey = $a21f906d6457fcf9$var$__importStar((parcelRequire("eQGUc")));

module.exports.attributeValueBare = $a21f906d6457fcf9$var$__importStar((parcelRequire("ceRDV")));

module.exports.attributeValueWrapped = $a21f906d6457fcf9$var$__importStar((parcelRequire("64VC7")));

module.exports.attributeValue = $a21f906d6457fcf9$var$__importStar((parcelRequire("dCPfG")));

module.exports.attributes = $a21f906d6457fcf9$var$__importStar((parcelRequire("7VhdH")));

module.exports.closeTag = $a21f906d6457fcf9$var$__importStar((parcelRequire("aRwqK")));

module.exports.commentContent = $a21f906d6457fcf9$var$__importStar((parcelRequire("3kAZW")));

module.exports.data = $a21f906d6457fcf9$var$__importStar((parcelRequire("aGyfu")));

module.exports.doctypeAttributeBare = $a21f906d6457fcf9$var$__importStar((parcelRequire("ldlab")));

module.exports.doctypeAttributeWrapped = $a21f906d6457fcf9$var$__importStar((parcelRequire("fPsEm")));

module.exports.doctypeAttributes = $a21f906d6457fcf9$var$__importStar((parcelRequire("4p8Ax")));

module.exports.DoctypeClose = $a21f906d6457fcf9$var$__importStar((parcelRequire("b1kZv")));

module.exports.DoctypeOpen = $a21f906d6457fcf9$var$__importStar((parcelRequire("im6bL")));

module.exports.openTagEnd = $a21f906d6457fcf9$var$__importStar((parcelRequire("fLUnj")));

module.exports.openTagStart = $a21f906d6457fcf9$var$__importStar((parcelRequire("70sdW")));

module.exports.scriptTagContent = $a21f906d6457fcf9$var$__importStar((parcelRequire("g2VG4")));

module.exports.styleTagContent = $a21f906d6457fcf9$var$__importStar((parcelRequire("5lnTa")));

module.exports.customTagRawContent = $a21f906d6457fcf9$var$__importStar((parcelRequire("cC3nZ")));
module.exports.noop = {
    parse: ()=>void 0
};

});
parcelRegister("eQGUc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $acf73429bab095cf$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $bqb37 = parcelRequire("bqb37");

var $gcQy4 = parcelRequire("gcQy4");
function $acf73429bab095cf$var$parse(chars, state) {
    if ($acf73429bab095cf$var$isKeyBreak(chars)) return $acf73429bab095cf$var$parseKeyEnd(state);
    state.accumulatedContent.concatBuffer(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $acf73429bab095cf$var$isKeyBreak(chars) {
    const value = chars.value();
    return value === "=" || value === "/" || value === ">" || (0, $gcQy4.isWhitespace)(value);
}
function $acf73429bab095cf$var$parseKeyEnd(state) {
    const position = (0, $gcQy4.calculateTokenPosition)(state, {
        keepBuffer: false
    });
    state.tokens.push({
        type: $bqb37.TokenTypes.AttributeKey,
        value: state.accumulatedContent.value(),
        range: position.range,
        loc: position.loc,
        parts: (0, $gcQy4.createParts)(state, $bqb37.TokenTypes.AttributeKey)
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.Attributes;
}

});

parcelRegister("ceRDV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseValueEnd = $8e90673d608d713c$var$parseValueEnd;
module.exports.parse = $8e90673d608d713c$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $8e90673d608d713c$var$parseValueEnd(state) {
    const position = (0, $gcQy4.calculateTokenPosition)(state, {
        keepBuffer: false
    });
    state.tokens.push({
        type: $eJ62A.TokenTypes.AttributeValue,
        value: state.accumulatedContent.value(),
        range: position.range,
        loc: position.loc,
        parts: (0, $gcQy4.createParts)(state, $eJ62A.TokenTypes.AttributeValue)
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.Attributes;
}
function $8e90673d608d713c$var$parse(chars, state) {
    if ((0, $gcQy4.isWhitespace)(chars.value()) || chars.value() === ">" || chars.value() === "/") return $8e90673d608d713c$var$parseValueEnd(state);
    state.accumulatedContent.concatBuffer(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}

});

parcelRegister("64VC7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $46cfceb44cc9e9a4$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $46cfceb44cc9e9a4$var$parse(chars, state) {
    var _a;
    const wrapperChar = (_a = state.contextParams[$eJ62A.TokenizerContextTypes.AttributeValueWrapped]) === null || _a === void 0 ? void 0 : _a.wrapper;
    if (chars.value() === wrapperChar) return $46cfceb44cc9e9a4$var$parseWrapper(state);
    state.accumulatedContent.concatBuffer(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $46cfceb44cc9e9a4$var$parseWrapper(state) {
    const position = (0, $gcQy4.calculateTokenPosition)(state, {
        keepBuffer: false
    });
    const endWrapperPosition = position.range[1];
    state.tokens.push({
        type: $eJ62A.TokenTypes.AttributeValue,
        value: state.accumulatedContent.value(),
        range: position.range,
        loc: position.loc,
        parts: (0, $gcQy4.createParts)(state, $eJ62A.TokenTypes.AttributeValue)
    });
    const range = [
        endWrapperPosition,
        endWrapperPosition + 1
    ];
    state.tokens.push({
        type: $eJ62A.TokenTypes.AttributeValueWrapperEnd,
        value: state.decisionBuffer.value(),
        range: range,
        loc: state.sourceCode.getLocationOf(range)
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.Attributes;
    state.sourceCode.next();
    state.contextParams[$eJ62A.TokenizerContextTypes.AttributeValueWrapped] = undefined;
}

});

parcelRegister("dCPfG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $9eb6948575cfd3f4$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $9eb6948575cfd3f4$var$parse(chars, state) {
    const value = chars.value();
    if (value === '"' || value === "'") return $9eb6948575cfd3f4$var$parseWrapper(state);
    if (value === ">" || value === "/") return $9eb6948575cfd3f4$var$parseTagEnd(state);
    if (!(0, $gcQy4.isWhitespace)(value)) return $9eb6948575cfd3f4$var$parseBare(state);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $9eb6948575cfd3f4$var$parseWrapper(state) {
    const wrapper = state.decisionBuffer.value();
    const range = [
        state.sourceCode.index(),
        state.sourceCode.index() + 1
    ];
    state.tokens.push({
        type: $eJ62A.TokenTypes.AttributeValueWrapperStart,
        value: wrapper,
        range: range,
        loc: state.sourceCode.getLocationOf(range)
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.AttributeValueWrapped;
    state.contextParams[$eJ62A.TokenizerContextTypes.AttributeValueWrapped] = {
        wrapper: wrapper
    };
    state.sourceCode.next();
}
function $9eb6948575cfd3f4$var$parseBare(state) {
    state.accumulatedContent.replace(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.AttributeValueBare;
    state.sourceCode.next();
}
function $9eb6948575cfd3f4$var$parseTagEnd(state) {
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.Attributes;
}

});

parcelRegister("7VhdH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $5c4b36c749134a14$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $5c4b36c749134a14$var$parse(chars, state) {
    const value = chars.value();
    if (value === ">" || value === "/") return $5c4b36c749134a14$var$parseTagEnd(state);
    if (value === "=") return $5c4b36c749134a14$var$parseEqual(state);
    if (!(0, $gcQy4.isWhitespace)(value)) return $5c4b36c749134a14$var$parseNoneWhitespace(chars, state);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $5c4b36c749134a14$var$parseTagEnd(state) {
    var _a;
    const tagName = (_a = state.contextParams[$eJ62A.TokenizerContextTypes.Attributes]) === null || _a === void 0 ? void 0 : _a.tagName;
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.OpenTagEnd;
    state.contextParams[$eJ62A.TokenizerContextTypes.OpenTagEnd] = {
        tagName: tagName
    };
    state.contextParams[$eJ62A.TokenizerContextTypes.Attributes] = undefined;
}
function $5c4b36c749134a14$var$parseNoneWhitespace(chars, state) {
    if (chars.value() === "<") (0, $gcQy4.raise)((0, $gcQy4.calculateTokenPosition)(state, {
        keepBuffer: true
    }), "Unexpected end of tag. Expected '>' to close the opening tag.");
    state.accumulatedContent.replace(state.decisionBuffer);
    state.currentContext = $eJ62A.TokenizerContextTypes.AttributeKey;
    state.sourceCode.next();
    state.decisionBuffer.clear();
}
function $5c4b36c749134a14$var$parseEqual(state) {
    const position = (0, $gcQy4.calculateTokenPosition)(state, {
        keepBuffer: true
    });
    state.tokens.push({
        type: $eJ62A.TokenTypes.AttributeAssignment,
        value: state.decisionBuffer.value(),
        range: position.range,
        loc: position.loc
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.AttributeValue;
    state.sourceCode.next();
}

});

parcelRegister("aRwqK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $7e8802a68fabd30b$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $7e8802a68fabd30b$var$parse(chars, state) {
    const value = chars.value();
    if (value === ">") return $7e8802a68fabd30b$var$parseClosingCornerBrace(state);
    state.accumulatedContent.concatBuffer(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $7e8802a68fabd30b$var$parseClosingCornerBrace(state) {
    const position = (0, $gcQy4.calculateTokenPosition)(state, {
        keepBuffer: true
    });
    state.tokens.push({
        type: $eJ62A.TokenTypes.CloseTag,
        value: state.accumulatedContent.value() + state.decisionBuffer.value(),
        range: position.range,
        loc: position.loc
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.Data;
    state.sourceCode.next();
}

});

parcelRegister("3kAZW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $26cff06426ec3d72$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
const $26cff06426ec3d72$var$COMMENT_END = "-->";
function $26cff06426ec3d72$var$parse(chars, state) {
    const value = chars.value();
    if (value === "-" || value === "--") {
        state.sourceCode.next();
        return;
    }
    if (value === $26cff06426ec3d72$var$COMMENT_END) return $26cff06426ec3d72$var$parseCommentClose(state);
    state.accumulatedContent.concatBuffer(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $26cff06426ec3d72$var$parseCommentClose(state) {
    const position = (0, $gcQy4.calculateTokenPosition)(state, {
        keepBuffer: false
    });
    const endRange = [
        position.range[1],
        position.range[1] + $26cff06426ec3d72$var$COMMENT_END.length
    ];
    state.tokens.push({
        type: $eJ62A.TokenTypes.CommentContent,
        value: state.accumulatedContent.value(),
        range: position.range,
        loc: position.loc,
        parts: (0, $gcQy4.createParts)(state, $eJ62A.TokenTypes.CommentContent)
    });
    state.tokens.push({
        type: $eJ62A.TokenTypes.CommentClose,
        value: state.decisionBuffer.value(),
        range: endRange,
        loc: state.sourceCode.getLocationOf(endRange)
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.Data;
    state.sourceCode.next();
}

});

parcelRegister("aGyfu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $7c7864b6f20a4864$var$parse;
module.exports.handleContentEnd = $7c7864b6f20a4864$var$handleContentEnd;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
const $7c7864b6f20a4864$var$COMMENT_START = "<!--";
const $7c7864b6f20a4864$var$OPEN_TAG_START_PATTERN = /^<\w/;
function $7c7864b6f20a4864$var$parse(chars, state) {
    const value = chars.value();
    if ($7c7864b6f20a4864$var$OPEN_TAG_START_PATTERN.test(value)) return $7c7864b6f20a4864$var$parseOpeningCornerBraceWithText(state);
    if (value === "</") return $7c7864b6f20a4864$var$parseOpeningCornerBraceWithSlash(state);
    if (value === "<" || value === "<!" || value === "<!-") {
        state.sourceCode.next();
        return;
    }
    if (value === $7c7864b6f20a4864$var$COMMENT_START) return $7c7864b6f20a4864$var$parseCommentOpen(state);
    if ($7c7864b6f20a4864$var$isIncompleteDoctype(value)) {
        state.sourceCode.next();
        return;
    }
    if (value.toUpperCase() === "<!DOCTYPE") return $7c7864b6f20a4864$var$parseDoctypeOpen(state);
    state.accumulatedContent.concatBuffer(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $7c7864b6f20a4864$var$handleContentEnd(state) {
    const textContent = state.accumulatedContent.value() + state.decisionBuffer.value();
    if (textContent.length !== 0) {
        const position = (0, $gcQy4.calculateTokenPosition)(state, {
            keepBuffer: false
        });
        state.tokens.push({
            type: $eJ62A.TokenTypes.Text,
            value: textContent,
            range: position.range,
            loc: position.loc,
            parts: (0, $gcQy4.createParts)(state, $eJ62A.TokenTypes.Text)
        });
    }
}
function $7c7864b6f20a4864$var$generateTextToken(state) {
    const position = (0, $gcQy4.calculateTokenPosition)(state, {
        keepBuffer: false
    });
    return {
        type: $eJ62A.TokenTypes.Text,
        value: state.accumulatedContent.value(),
        range: position.range,
        loc: position.loc,
        parts: (0, $gcQy4.createParts)(state, $eJ62A.TokenTypes.Text)
    };
}
function $7c7864b6f20a4864$var$parseOpeningCornerBraceWithText(state) {
    if (state.accumulatedContent.length() !== 0) state.tokens.push($7c7864b6f20a4864$var$generateTextToken(state));
    state.accumulatedContent.replace(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.OpenTagStart;
    state.sourceCode.next();
}
function $7c7864b6f20a4864$var$parseOpeningCornerBraceWithSlash(state) {
    if (state.accumulatedContent.length() !== 0) state.tokens.push($7c7864b6f20a4864$var$generateTextToken(state));
    state.accumulatedContent.replace(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.CloseTag;
    state.sourceCode.next();
}
function $7c7864b6f20a4864$var$isIncompleteDoctype(chars) {
    const charsUpperCase = chars.toUpperCase();
    return charsUpperCase === "<!" || charsUpperCase === "<!D" || charsUpperCase === "<!DO" || charsUpperCase === "<!DOC" || charsUpperCase === "<!DOCT" || charsUpperCase === "<!DOCTY" || charsUpperCase === "<!DOCTYP";
}
function $7c7864b6f20a4864$var$parseCommentOpen(state) {
    if (state.accumulatedContent.length() !== 0) state.tokens.push($7c7864b6f20a4864$var$generateTextToken(state));
    const range = [
        state.sourceCode.index() - ($7c7864b6f20a4864$var$COMMENT_START.length - 1),
        state.sourceCode.index() + 1
    ];
    state.tokens.push({
        type: $eJ62A.TokenTypes.CommentOpen,
        value: state.decisionBuffer.value(),
        range: range,
        loc: state.sourceCode.getLocationOf(range)
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.CommentContent;
    state.sourceCode.next();
}
function $7c7864b6f20a4864$var$parseDoctypeOpen(state) {
    if (state.accumulatedContent.length() !== 0) state.tokens.push($7c7864b6f20a4864$var$generateTextToken(state));
    state.accumulatedContent.replace(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.DoctypeOpen;
    state.sourceCode.next();
}

});

parcelRegister("ldlab", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $f71b3a7801b8202f$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $f71b3a7801b8202f$var$parse(chars, state) {
    if ((0, $gcQy4.isWhitespace)(chars.value()) || chars.value() === ">") return $f71b3a7801b8202f$var$parseAttributeEnd(state);
    state.accumulatedContent.concatBuffer(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $f71b3a7801b8202f$var$parseAttributeEnd(state) {
    const position = (0, $gcQy4.calculateTokenPosition)(state, {
        keepBuffer: false
    });
    state.tokens.push({
        type: $eJ62A.TokenTypes.DoctypeAttributeValue,
        value: state.accumulatedContent.value(),
        range: position.range,
        loc: position.loc
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.DoctypeAttributes;
}

});

parcelRegister("fPsEm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $b861d7b5adfd0ab8$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $b861d7b5adfd0ab8$var$parse(chars, state) {
    var _a;
    const wrapperChar = (_a = state.contextParams[$eJ62A.TokenizerContextTypes.DoctypeAttributeWrapped]) === null || _a === void 0 ? void 0 : _a.wrapper;
    if (chars.value() === wrapperChar) return $b861d7b5adfd0ab8$var$parseWrapper(state);
    state.accumulatedContent.concatBuffer(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $b861d7b5adfd0ab8$var$parseWrapper(state) {
    const position = (0, $gcQy4.calculateTokenPosition)(state, {
        keepBuffer: false
    });
    const endWrapperPosition = position.range[1];
    state.tokens.push({
        type: $eJ62A.TokenTypes.DoctypeAttributeValue,
        value: state.accumulatedContent.value(),
        range: position.range,
        loc: position.loc
    });
    const range = [
        endWrapperPosition,
        endWrapperPosition + 1
    ];
    state.tokens.push({
        type: $eJ62A.TokenTypes.DoctypeAttributeWrapperEnd,
        value: state.decisionBuffer.value(),
        range: range,
        loc: state.sourceCode.getLocationOf(range)
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.DoctypeAttributes;
    state.sourceCode.next();
    state.contextParams[$eJ62A.TokenizerContextTypes.DoctypeAttributeWrapped] = undefined;
}

});

parcelRegister("4p8Ax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $335028abf2a221e6$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $335028abf2a221e6$var$parse(chars, state) {
    if (chars.value() === '"' || chars.value() === "'") return $335028abf2a221e6$var$parseWrapper(state);
    if (chars.value() === ">") return $335028abf2a221e6$var$parseClosingCornerBrace(state);
    if (!(0, $gcQy4.isWhitespace)(chars.value())) return $335028abf2a221e6$var$parseBare(state);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $335028abf2a221e6$var$parseWrapper(state) {
    const wrapper = state.decisionBuffer.value();
    const range = [
        state.sourceCode.index(),
        state.sourceCode.index() + wrapper.length
    ];
    state.tokens.push({
        type: $eJ62A.TokenTypes.DoctypeAttributeWrapperStart,
        value: wrapper,
        range: range,
        loc: state.sourceCode.getLocationOf(range)
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.DoctypeAttributeWrapped;
    state.contextParams[$eJ62A.TokenizerContextTypes.DoctypeAttributeWrapped] = {
        wrapper: wrapper
    };
    state.sourceCode.next();
}
function $335028abf2a221e6$var$parseBare(state) {
    state.accumulatedContent.replace(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.DoctypeAttributeBare;
    state.sourceCode.next();
}
function $335028abf2a221e6$var$parseClosingCornerBrace(state) {
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.DoctypeClose;
}

});

parcelRegister("b1kZv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $80601210f06f8e3f$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $80601210f06f8e3f$var$parse(chars, state) {
    const position = (0, $gcQy4.calculateTokenPosition)(state, {
        keepBuffer: true
    });
    state.tokens.push({
        type: $eJ62A.TokenTypes.DoctypeClose,
        value: state.decisionBuffer.value(),
        range: position.range,
        loc: position.loc
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.Data;
    state.sourceCode.next();
}

});

parcelRegister("im6bL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $d5cf150233c24386$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $d5cf150233c24386$var$parse(chars, state) {
    const value = chars.value();
    if ((0, $gcQy4.isWhitespace)(value)) return $d5cf150233c24386$var$parseWhitespace(state);
    if (value === ">") return $d5cf150233c24386$var$parseClosingCornerBrace(state);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $d5cf150233c24386$var$generateDoctypeOpenToken(state) {
    const position = (0, $gcQy4.calculateTokenPosition)(state, {
        keepBuffer: false
    });
    return {
        type: $eJ62A.TokenTypes.DoctypeOpen,
        value: state.accumulatedContent.value(),
        range: position.range,
        loc: position.loc
    };
}
function $d5cf150233c24386$var$parseWhitespace(state) {
    state.tokens.push($d5cf150233c24386$var$generateDoctypeOpenToken(state));
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.DoctypeAttributes;
}
function $d5cf150233c24386$var$parseClosingCornerBrace(state) {
    state.tokens.push($d5cf150233c24386$var$generateDoctypeOpenToken(state));
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.DoctypeClose;
}

});

parcelRegister("fLUnj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $b7b6f9b50bdf181f$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
const $b7b6f9b50bdf181f$var$tokensMap = {
    script: $eJ62A.TokenTypes.OpenScriptTagEnd,
    style: $eJ62A.TokenTypes.OpenStyleTagEnd,
    default: $eJ62A.TokenTypes.OpenTagEnd
};
const $b7b6f9b50bdf181f$var$contextsMap = {
    script: $eJ62A.TokenizerContextTypes.ScriptContent,
    style: $eJ62A.TokenizerContextTypes.StyleContent,
    default: $eJ62A.TokenizerContextTypes.Data
};
function $b7b6f9b50bdf181f$var$parse(chars, state) {
    if (chars.value() === ">") return $b7b6f9b50bdf181f$var$parseClosingCornerBrace(state);
    state.accumulatedContent.concatBuffer(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $b7b6f9b50bdf181f$var$parseClosingCornerBrace(state) {
    var _a, _b;
    const position = (0, $gcQy4.calculateTokenPosition)(state, {
        keepBuffer: true
    });
    const tagName = (_a = state.contextParams[$eJ62A.TokenizerContextTypes.OpenTagEnd]) === null || _a === void 0 ? void 0 : _a.tagName;
    state.tokens.push({
        type: $b7b6f9b50bdf181f$var$tokensMap[tagName] || $b7b6f9b50bdf181f$var$tokensMap.default,
        value: state.accumulatedContent.value() + state.decisionBuffer.value(),
        range: position.range,
        loc: position.loc
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    if ((_b = state.rawContentTags) === null || _b === void 0 ? void 0 : _b.includes(tagName)) {
        state.contextParams[$eJ62A.TokenizerContextTypes.CustomTagRawContent] = {
            tagName: tagName
        };
        state.currentContext = $eJ62A.TokenizerContextTypes.CustomTagRawContent;
    } else state.currentContext = $b7b6f9b50bdf181f$var$contextsMap[tagName || "default"] || $b7b6f9b50bdf181f$var$contextsMap["default"];
    state.sourceCode.next();
    state.contextParams[$eJ62A.TokenizerContextTypes.OpenTagEnd] = undefined;
}

});

parcelRegister("70sdW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $519e6d2ff5383741$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
const $519e6d2ff5383741$var$tokensMap = {
    script: $eJ62A.TokenTypes.OpenScriptTagStart,
    style: $eJ62A.TokenTypes.OpenStyleTagStart,
    default: $eJ62A.TokenTypes.OpenTagStart
};
function $519e6d2ff5383741$var$parse(chars, state) {
    if (chars.value() === ">" || chars.value() === "/") return $519e6d2ff5383741$var$parseTagEnd(state);
    if ((0, $gcQy4.isWhitespace)(chars.value())) return $519e6d2ff5383741$var$parseWhitespace(state);
    state.accumulatedContent.concatBuffer(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $519e6d2ff5383741$var$parseWhitespace(state) {
    const tagName = (0, $gcQy4.parseOpenTagName)(state.accumulatedContent.value());
    const position = (0, $gcQy4.calculateTokenPosition)(state, {
        keepBuffer: false
    });
    state.tokens.push({
        type: $519e6d2ff5383741$var$tokensMap[tagName] || $519e6d2ff5383741$var$tokensMap.default,
        value: state.accumulatedContent.value(),
        range: position.range,
        loc: position.loc
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.Attributes;
    state.contextParams[$eJ62A.TokenizerContextTypes.Attributes] = {
        tagName: tagName
    };
    state.sourceCode.next();
}
function $519e6d2ff5383741$var$parseTagEnd(state) {
    const tagName = (0, $gcQy4.parseOpenTagName)(state.accumulatedContent.value());
    const position = (0, $gcQy4.calculateTokenPosition)(state, {
        keepBuffer: false
    });
    state.tokens.push({
        type: $519e6d2ff5383741$var$tokensMap[tagName] || $519e6d2ff5383741$var$tokensMap.default,
        value: state.accumulatedContent.value(),
        range: position.range,
        loc: position.loc
    });
    state.decisionBuffer.clear();
    state.accumulatedContent.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.OpenTagEnd;
    state.contextParams[$eJ62A.TokenizerContextTypes.OpenTagEnd] = {
        tagName: tagName
    };
}

});

parcelRegister("g2VG4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $bae992cd8518ca4f$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $bae992cd8518ca4f$var$parse(chars, state) {
    if (chars.value() === "<" || chars.value() === "</" || $eJ62A.INCOMPLETE_CLOSING_TAG_PATTERN.test(chars.value())) {
        state.sourceCode.next();
        return;
    }
    if ($eJ62A.CLOSING_SCRIPT_TAG_PATTERN.test(chars.value())) return $bae992cd8518ca4f$var$parseClosingScriptTag(state);
    state.accumulatedContent.concatBuffer(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $bae992cd8518ca4f$var$parseClosingScriptTag(state) {
    if (state.accumulatedContent.value() !== "") {
        const position = (0, $gcQy4.calculateTokenPosition)(state, {
            keepBuffer: false
        });
        state.tokens.push({
            type: $eJ62A.TokenTypes.ScriptTagContent,
            value: state.accumulatedContent.value(),
            range: position.range,
            loc: position.loc,
            parts: (0, $gcQy4.createParts)(state, $eJ62A.TokenTypes.ScriptTagContent)
        });
    }
    const range = [
        state.sourceCode.index() - (state.decisionBuffer.length() - 1),
        state.sourceCode.index() + 1
    ];
    state.tokens.push({
        type: $eJ62A.TokenTypes.CloseScriptTag,
        value: state.decisionBuffer.value(),
        range: range,
        loc: state.sourceCode.getLocationOf(range)
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.Data;
    state.sourceCode.next();
}

});

parcelRegister("5lnTa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $3e4171c0d20d57c2$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
const $3e4171c0d20d57c2$var$CLOSING_STYLE_TAG_PATTERN = /<\/style\s*>/i;
function $3e4171c0d20d57c2$var$parse(chars, state) {
    if (chars.value() === "<" || chars.value() === "</" || $eJ62A.INCOMPLETE_CLOSING_TAG_PATTERN.test(chars.value())) {
        state.sourceCode.next();
        return;
    }
    if ($3e4171c0d20d57c2$var$CLOSING_STYLE_TAG_PATTERN.test(chars.value())) return $3e4171c0d20d57c2$var$parseClosingStyleTag(state);
    state.accumulatedContent.concatBuffer(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $3e4171c0d20d57c2$var$parseClosingStyleTag(state) {
    if (state.accumulatedContent.value() !== "") {
        const position = (0, $gcQy4.calculateTokenPosition)(state, {
            keepBuffer: false
        });
        state.tokens.push({
            type: $eJ62A.TokenTypes.StyleTagContent,
            value: state.accumulatedContent.value(),
            range: position.range,
            loc: position.loc,
            parts: (0, $gcQy4.createParts)(state, $eJ62A.TokenTypes.StyleTagContent)
        });
    }
    const range = [
        state.sourceCode.index() - (state.decisionBuffer.length() - 1),
        state.sourceCode.index() + 1
    ];
    state.tokens.push({
        type: $eJ62A.TokenTypes.CloseStyleTag,
        value: state.decisionBuffer.value(),
        range: range,
        loc: state.sourceCode.getLocationOf(range)
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.currentContext = $eJ62A.TokenizerContextTypes.Data;
    state.sourceCode.next();
}

});

parcelRegister("cC3nZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $92eba8fff3d02597$var$parse;

var $eJ62A = parcelRequire("eJ62A");

var $gcQy4 = parcelRequire("gcQy4");
function $92eba8fff3d02597$var$parse(chars, state) {
    var _a;
    if (chars.value() === "<" || chars.value() === "</" || $eJ62A.INCOMPLETE_CLOSING_TAG_PATTERN.test(chars.value())) {
        state.sourceCode.next();
        return;
    }
    const regex = new RegExp("</" + ((_a = state.contextParams[$eJ62A.TokenizerContextTypes.CustomTagRawContent]) === null || _a === void 0 ? void 0 : _a.tagName) + "\\s*>");
    if (regex.test(chars.value())) return $92eba8fff3d02597$var$parseClosingCustomTag(state);
    state.accumulatedContent.concatBuffer(state.decisionBuffer);
    state.decisionBuffer.clear();
    state.sourceCode.next();
}
function $92eba8fff3d02597$var$parseClosingCustomTag(state) {
    if (state.accumulatedContent.value() !== "") {
        const position = (0, $gcQy4.calculateTokenPosition)(state, {
            keepBuffer: false
        });
        state.tokens.push({
            type: $eJ62A.TokenTypes.RawContent,
            value: state.accumulatedContent.value(),
            range: position.range,
            loc: position.loc,
            parts: (0, $gcQy4.createParts)(state, $eJ62A.TokenTypes.RawContent)
        });
    }
    const range = [
        state.sourceCode.index() - (state.decisionBuffer.length() - 1),
        state.sourceCode.index() + 1
    ];
    state.tokens.push({
        type: $eJ62A.TokenTypes.CloseTag,
        value: state.decisionBuffer.value(),
        range: range,
        loc: state.sourceCode.getLocationOf(range)
    });
    state.accumulatedContent.clear();
    state.decisionBuffer.clear();
    state.contextParams[$eJ62A.TokenizerContextTypes.CustomTagRawContent] = undefined;
    state.currentContext = $eJ62A.TokenizerContextTypes.Data;
    state.sourceCode.next();
}

});


parcelRegister("3Yi6a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SourceCode = void 0;

var $gcQy4 = parcelRequire("gcQy4");

var $2Uq4m = parcelRequire("2Uq4m");
class $2e4503b13bede11d$var$SourceCode {
    constructor(source, templateInfos){
        this.source = source;
        this.charsIndex = 0;
        this.charsList = this.createCharsList(templateInfos);
    }
    getLocationOf(range) {
        return {
            start: (0, $gcQy4.getLineInfo)(this.source, range[0]),
            end: (0, $gcQy4.getLineInfo)(this.source, range[1])
        };
    }
    current() {
        return this.charsList[this.charsIndex];
    }
    next() {
        this.charsIndex++;
    }
    prev() {
        this.charsIndex--;
    }
    isEof() {
        return this.charsIndex >= this.charsList.length;
    }
    index() {
        const current = this.current();
        return current.range[1] - 1;
    }
    createCharsList(templateInfo) {
        const charsList = [];
        let sourceIndex = 0;
        let templateInfoIndex = 0;
        while(sourceIndex < this.source.length){
            const info = templateInfo[templateInfoIndex];
            if (info) {
                const range = (0, $gcQy4.getRange)(info);
                if (range[0] <= sourceIndex && sourceIndex < range[1]) {
                    charsList.push(new $2Uq4m.Chars($2Uq4m.CharsType.Template, this.source.slice(range[0], range[1]), [
                        range[0],
                        range[1]
                    ], Array.isArray(info) ? undefined : info));
                    templateInfoIndex++;
                    sourceIndex = range[1];
                    continue;
                }
            }
            charsList.push(new $2Uq4m.Chars($2Uq4m.CharsType.HTML, this.source[sourceIndex], [
                sourceIndex,
                sourceIndex + 1
            ]));
            sourceIndex++;
        }
        return charsList;
    }
}
module.exports.SourceCode = $2e4503b13bede11d$var$SourceCode;

});

parcelRegister("78lcF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CharsBuffer = void 0;
class $5319ba51aba5421a$var$CharsBuffer {
    constructor(){
        this.charsBuffer = [];
    }
    concat(chars) {
        const last = this.last();
        if (!last || last.isTemplate || chars.isTemplate) this.charsBuffer.push(chars);
        else last.concat(chars);
    }
    concatBuffer(buffer) {
        const last = this.last();
        const first = buffer.first();
        if ((last === null || last === void 0 ? void 0 : last.isTemplate) === false && (first === null || first === void 0 ? void 0 : first.isTemplate) === false) {
            last.concat(first);
            this.charsBuffer.push(...buffer.charsBuffer.slice(1));
            return;
        }
        this.charsBuffer.push(...buffer.charsBuffer);
    }
    hasTemplate() {
        return this.charsBuffer.some((char)=>char.isTemplate);
    }
    getParts() {
        return [
            ...this.charsBuffer
        ];
    }
    length() {
        return this.charsBuffer.map((chars)=>chars.length()).reduce((a, b)=>a + b, 0);
    }
    clear() {
        this.charsBuffer = [];
    }
    value() {
        const v = this.charsBuffer.map((chars)=>chars.value).join("");
        return v;
    }
    last() {
        return this.charsBuffer[this.charsBuffer.length - 1];
    }
    first() {
        return this.charsBuffer[0];
    }
    removeLast() {
        this.charsBuffer.splice(this.charsBuffer.length - 1, 1);
    }
    removeFirst() {
        this.charsBuffer.splice(0, 1);
    }
    replace(other) {
        this.charsBuffer = [
            ...other.charsBuffer
        ];
    }
}
module.exports.CharsBuffer = $5319ba51aba5421a$var$CharsBuffer;

});



parcelRegister("ki8SS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultTokenAdapter = void 0;

var $7gNk9 = parcelRequire("7gNk9");
Object.defineProperty(module.exports, "defaultTokenAdapter", {
    enumerable: true,
    get: function() {
        return $7gNk9.defaultTokenAdapter;
    }
});

});
parcelRegister("7gNk9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultTokenAdapter = void 0;
module.exports.defaultTokenAdapter = {
    finalizeRange (token) {
        return token.range;
    },
    finalizeLocation (token) {
        return token.loc;
    }
};

});



parcelRegister("6bVCb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("irZNt", function(module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/5/LICENSE
// This is CodeMirror (https://codemirror.net/5), a code editor
// implemented in JavaScript on top of the browser's DOM.
//
// You can find some technical background for some of the code below
// at http://marijnhaverbeke.nl/blog/#cm-internals .
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    // Kludges for bugs and behavior differences that can't be feature
    // detected are enabled based on userAgent etc sniffing.
    var userAgent = navigator.userAgent;
    var platform = navigator.platform;
    var gecko = /gecko\/\d/i.test(userAgent);
    var ie_upto10 = /MSIE \d/.test(userAgent);
    var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
    var edge = /Edge\/(\d+)/.exec(userAgent);
    var ie = ie_upto10 || ie_11up || edge;
    var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
    var webkit = !edge && /WebKit\//.test(userAgent);
    var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
    var chrome = !edge && /Chrome\/(\d+)/.exec(userAgent);
    var chrome_version = chrome && +chrome[1];
    var presto = /Opera\//.test(userAgent);
    var safari = /Apple Computer/.test(navigator.vendor);
    var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
    var phantom = /PhantomJS/.test(userAgent);
    var ios = safari && (/Mobile\/\w+/.test(userAgent) || navigator.maxTouchPoints > 2);
    var android = /Android/.test(userAgent);
    // This is woefully incomplete. Suggestions for alternative methods welcome.
    var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
    var mac = ios || /Mac/.test(platform);
    var chromeOS = /\bCrOS\b/.test(userAgent);
    var windows = /win/i.test(platform);
    var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
    if (presto_version) presto_version = Number(presto_version[1]);
    if (presto_version && presto_version >= 15) {
        presto = false;
        webkit = true;
    }
    // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
    var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
    var captureRightClick = gecko || ie && ie_version >= 9;
    function classTest(cls) {
        return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*");
    }
    var rmClass = function(node, cls) {
        var current = node.className;
        var match = classTest(cls).exec(current);
        if (match) {
            var after = current.slice(match.index + match[0].length);
            node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
        }
    };
    function removeChildren(e) {
        for(var count = e.childNodes.length; count > 0; --count)e.removeChild(e.firstChild);
        return e;
    }
    function removeChildrenAndAdd(parent, e) {
        return removeChildren(parent).appendChild(e);
    }
    function elt(tag, content, className, style) {
        var e = document.createElement(tag);
        if (className) e.className = className;
        if (style) e.style.cssText = style;
        if (typeof content == "string") e.appendChild(document.createTextNode(content));
        else if (content) for(var i = 0; i < content.length; ++i)e.appendChild(content[i]);
        return e;
    }
    // wrapper for elt, which removes the elt from the accessibility tree
    function eltP(tag, content, className, style) {
        var e = elt(tag, content, className, style);
        e.setAttribute("role", "presentation");
        return e;
    }
    var range;
    if (document.createRange) range = function(node, start, end, endNode) {
        var r = document.createRange();
        r.setEnd(endNode || node, end);
        r.setStart(node, start);
        return r;
    };
    else range = function(node, start, end) {
        var r = document.body.createTextRange();
        try {
            r.moveToElementText(node.parentNode);
        } catch (e) {
            return r;
        }
        r.collapse(true);
        r.moveEnd("character", end);
        r.moveStart("character", start);
        return r;
    };
    function contains(parent, child) {
        if (child.nodeType == 3) child = child.parentNode;
        if (parent.contains) return parent.contains(child);
        do {
            if (child.nodeType == 11) child = child.host;
            if (child == parent) return true;
        }while (child = child.parentNode);
    }
    function activeElt(rootNode) {
        // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
        // IE < 10 will throw when accessed while the page is loading or in an iframe.
        // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
        var doc = rootNode.ownerDocument || rootNode;
        var activeElement;
        try {
            activeElement = rootNode.activeElement;
        } catch (e) {
            activeElement = doc.body || null;
        }
        while(activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)activeElement = activeElement.shadowRoot.activeElement;
        return activeElement;
    }
    function addClass(node, cls) {
        var current = node.className;
        if (!classTest(cls).test(current)) node.className += (current ? " " : "") + cls;
    }
    function joinClasses(a, b) {
        var as = a.split(" ");
        for(var i = 0; i < as.length; i++)if (as[i] && !classTest(as[i]).test(b)) b += " " + as[i];
        return b;
    }
    var selectInput = function(node) {
        node.select();
    };
    if (ios) selectInput = function(node) {
        node.selectionStart = 0;
        node.selectionEnd = node.value.length;
    };
    else if (ie) selectInput = function(node) {
        try {
            node.select();
        } catch (_e) {}
    };
    function doc(cm) {
        return cm.display.wrapper.ownerDocument;
    }
    function root(cm) {
        return rootNode(cm.display.wrapper);
    }
    function rootNode(element) {
        // Detect modern browsers (2017+).
        return element.getRootNode ? element.getRootNode() : element.ownerDocument;
    }
    function win(cm) {
        return doc(cm).defaultView;
    }
    function bind(f) {
        var args = Array.prototype.slice.call(arguments, 1);
        return function() {
            return f.apply(null, args);
        };
    }
    function copyObj(obj, target, overwrite) {
        if (!target) target = {};
        for(var prop in obj)if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop))) target[prop] = obj[prop];
        return target;
    }
    // Counts the column offset in a string, taking tabs into account.
    // Used mostly to find indentation.
    function countColumn(string, end, tabSize, startIndex, startValue) {
        if (end == null) {
            end = string.search(/[^\s\u00a0]/);
            if (end == -1) end = string.length;
        }
        for(var i = startIndex || 0, n = startValue || 0;;){
            var nextTab = string.indexOf("\t", i);
            if (nextTab < 0 || nextTab >= end) return n + (end - i);
            n += nextTab - i;
            n += tabSize - n % tabSize;
            i = nextTab + 1;
        }
    }
    var Delayed = function() {
        this.id = null;
        this.f = null;
        this.time = 0;
        this.handler = bind(this.onTimeout, this);
    };
    Delayed.prototype.onTimeout = function(self) {
        self.id = 0;
        if (self.time <= +new Date) self.f();
        else setTimeout(self.handler, self.time - +new Date);
    };
    Delayed.prototype.set = function(ms, f) {
        this.f = f;
        var time = +new Date + ms;
        if (!this.id || time < this.time) {
            clearTimeout(this.id);
            this.id = setTimeout(this.handler, ms);
            this.time = time;
        }
    };
    function indexOf(array, elt) {
        for(var i = 0; i < array.length; ++i){
            if (array[i] == elt) return i;
        }
        return -1;
    }
    // Number of pixels added to scroller and sizer to hide scrollbar
    var scrollerGap = 50;
    // Returned or thrown by various protocols to signal 'I'm not
    // handling this'.
    var Pass = {
        toString: function() {
            return "CodeMirror.Pass";
        }
    };
    // Reused option objects for setSelection & friends
    var sel_dontScroll = {
        scroll: false
    }, sel_mouse = {
        origin: "*mouse"
    }, sel_move = {
        origin: "+move"
    };
    // The inverse of countColumn -- find the offset that corresponds to
    // a particular column.
    function findColumn(string, goal, tabSize) {
        for(var pos = 0, col = 0;;){
            var nextTab = string.indexOf("\t", pos);
            if (nextTab == -1) nextTab = string.length;
            var skipped = nextTab - pos;
            if (nextTab == string.length || col + skipped >= goal) return pos + Math.min(skipped, goal - col);
            col += nextTab - pos;
            col += tabSize - col % tabSize;
            pos = nextTab + 1;
            if (col >= goal) return pos;
        }
    }
    var spaceStrs = [
        ""
    ];
    function spaceStr(n) {
        while(spaceStrs.length <= n)spaceStrs.push(lst(spaceStrs) + " ");
        return spaceStrs[n];
    }
    function lst(arr) {
        return arr[arr.length - 1];
    }
    function map(array, f) {
        var out = [];
        for(var i = 0; i < array.length; i++)out[i] = f(array[i], i);
        return out;
    }
    function insertSorted(array, value, score) {
        var pos = 0, priority = score(value);
        while(pos < array.length && score(array[pos]) <= priority)pos++;
        array.splice(pos, 0, value);
    }
    function nothing() {}
    function createObj(base, props) {
        var inst;
        if (Object.create) inst = Object.create(base);
        else {
            nothing.prototype = base;
            inst = new nothing();
        }
        if (props) copyObj(props, inst);
        return inst;
    }
    var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
    function isWordCharBasic(ch) {
        return /\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch));
    }
    function isWordChar(ch, helper) {
        if (!helper) return isWordCharBasic(ch);
        if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) return true;
        return helper.test(ch);
    }
    function isEmpty(obj) {
        for(var n in obj){
            if (obj.hasOwnProperty(n) && obj[n]) return false;
        }
        return true;
    }
    // Extending unicode characters. A series of a non-extending char +
    // any number of extending chars is treated as a single unit as far
    // as editing and measuring is concerned. This is not fully correct,
    // since some scripts/fonts/browsers also treat other configurations
    // of code points as a group.
    var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
    function isExtendingChar(ch) {
        return ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
    }
    // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
    function skipExtendingChars(str, pos, dir) {
        while((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos)))pos += dir;
        return pos;
    }
    // Returns the value from the range [`from`; `to`] that satisfies
    // `pred` and is closest to `from`. Assumes that at least `to`
    // satisfies `pred`. Supports `from` being greater than `to`.
    function findFirst(pred, from, to) {
        // At any point we are certain `to` satisfies `pred`, don't know
        // whether `from` does.
        var dir = from > to ? -1 : 1;
        for(;;){
            if (from == to) return from;
            var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
            if (mid == from) return pred(mid) ? from : to;
            if (pred(mid)) to = mid;
            else from = mid + dir;
        }
    }
    // BIDI HELPERS
    function iterateBidiSections(order, from, to, f) {
        if (!order) return f(from, to, "ltr", 0);
        var found = false;
        for(var i = 0; i < order.length; ++i){
            var part = order[i];
            if (part.from < to && part.to > from || from == to && part.to == from) {
                f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
                found = true;
            }
        }
        if (!found) f(from, to, "ltr");
    }
    var bidiOther = null;
    function getBidiPartAt(order, ch, sticky) {
        var found;
        bidiOther = null;
        for(var i = 0; i < order.length; ++i){
            var cur = order[i];
            if (cur.from < ch && cur.to > ch) return i;
            if (cur.to == ch) {
                if (cur.from != cur.to && sticky == "before") found = i;
                else bidiOther = i;
            }
            if (cur.from == ch) {
                if (cur.from != cur.to && sticky != "before") found = i;
                else bidiOther = i;
            }
        }
        return found != null ? found : bidiOther;
    }
    // Bidirectional ordering algorithm
    // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
    // that this (partially) implements.
    // One-char codes used for character types:
    // L (L):   Left-to-Right
    // R (R):   Right-to-Left
    // r (AL):  Right-to-Left Arabic
    // 1 (EN):  European Number
    // + (ES):  European Number Separator
    // % (ET):  European Number Terminator
    // n (AN):  Arabic Number
    // , (CS):  Common Number Separator
    // m (NSM): Non-Spacing Mark
    // b (BN):  Boundary Neutral
    // s (B):   Paragraph Separator
    // t (S):   Segment Separator
    // w (WS):  Whitespace
    // N (ON):  Other Neutrals
    // Returns null if characters are ordered as they appear
    // (left-to-right), or an array of sections ({from, to, level}
    // objects) in the order in which they occur visually.
    var bidiOrdering = function() {
        // Character types for codepoints 0 to 0xff
        var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
        // Character types for codepoints 0x600 to 0x6f9
        var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
        function charType(code) {
            if (code <= 0xf7) return lowTypes.charAt(code);
            else if (0x590 <= code && code <= 0x5f4) return "R";
            else if (0x600 <= code && code <= 0x6f9) return arabicTypes.charAt(code - 0x600);
            else if (0x6ee <= code && code <= 0x8ac) return "r";
            else if (0x2000 <= code && code <= 0x200b) return "w";
            else if (code == 0x200c) return "b";
            else return "L";
        }
        var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
        var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;
        function BidiSpan(level, from, to) {
            this.level = level;
            this.from = from;
            this.to = to;
        }
        return function(str, direction) {
            var outerType = direction == "ltr" ? "L" : "R";
            if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) return false;
            var len = str.length, types = [];
            for(var i = 0; i < len; ++i)types.push(charType(str.charCodeAt(i)));
            // W1. Examine each non-spacing mark (NSM) in the level run, and
            // change the type of the NSM to the type of the previous
            // character. If the NSM is at the start of the level run, it will
            // get the type of sor.
            for(var i$1 = 0, prev = outerType; i$1 < len; ++i$1){
                var type = types[i$1];
                if (type == "m") types[i$1] = prev;
                else prev = type;
            }
            // W2. Search backwards from each instance of a European number
            // until the first strong type (R, L, AL, or sor) is found. If an
            // AL is found, change the type of the European number to Arabic
            // number.
            // W3. Change all ALs to R.
            for(var i$2 = 0, cur = outerType; i$2 < len; ++i$2){
                var type$1 = types[i$2];
                if (type$1 == "1" && cur == "r") types[i$2] = "n";
                else if (isStrong.test(type$1)) {
                    cur = type$1;
                    if (type$1 == "r") types[i$2] = "R";
                }
            }
            // W4. A single European separator between two European numbers
            // changes to a European number. A single common separator between
            // two numbers of the same type changes to that type.
            for(var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3){
                var type$2 = types[i$3];
                if (type$2 == "+" && prev$1 == "1" && types[i$3 + 1] == "1") types[i$3] = "1";
                else if (type$2 == "," && prev$1 == types[i$3 + 1] && (prev$1 == "1" || prev$1 == "n")) types[i$3] = prev$1;
                prev$1 = type$2;
            }
            // W5. A sequence of European terminators adjacent to European
            // numbers changes to all European numbers.
            // W6. Otherwise, separators and terminators change to Other
            // Neutral.
            for(var i$4 = 0; i$4 < len; ++i$4){
                var type$3 = types[i$4];
                if (type$3 == ",") types[i$4] = "N";
                else if (type$3 == "%") {
                    var end = void 0;
                    for(end = i$4 + 1; end < len && types[end] == "%"; ++end);
                    var replace = i$4 && types[i$4 - 1] == "!" || end < len && types[end] == "1" ? "1" : "N";
                    for(var j = i$4; j < end; ++j)types[j] = replace;
                    i$4 = end - 1;
                }
            }
            // W7. Search backwards from each instance of a European number
            // until the first strong type (R, L, or sor) is found. If an L is
            // found, then change the type of the European number to L.
            for(var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5){
                var type$4 = types[i$5];
                if (cur$1 == "L" && type$4 == "1") types[i$5] = "L";
                else if (isStrong.test(type$4)) cur$1 = type$4;
            }
            // N1. A sequence of neutrals takes the direction of the
            // surrounding strong text if the text on both sides has the same
            // direction. European and Arabic numbers act as if they were R in
            // terms of their influence on neutrals. Start-of-level-run (sor)
            // and end-of-level-run (eor) are used at level run boundaries.
            // N2. Any remaining neutrals take the embedding direction.
            for(var i$6 = 0; i$6 < len; ++i$6)if (isNeutral.test(types[i$6])) {
                var end$1 = void 0;
                for(end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1);
                var before = (i$6 ? types[i$6 - 1] : outerType) == "L";
                var after = (end$1 < len ? types[end$1] : outerType) == "L";
                var replace$1 = before == after ? before ? "L" : "R" : outerType;
                for(var j$1 = i$6; j$1 < end$1; ++j$1)types[j$1] = replace$1;
                i$6 = end$1 - 1;
            }
            // Here we depart from the documented algorithm, in order to avoid
            // building up an actual levels array. Since there are only three
            // levels (0, 1, 2) in an implementation that doesn't take
            // explicit embedding into account, we can build up the order on
            // the fly, without following the level-based algorithm.
            var order = [], m;
            for(var i$7 = 0; i$7 < len;)if (countsAsLeft.test(types[i$7])) {
                var start = i$7;
                for(++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7);
                order.push(new BidiSpan(0, start, i$7));
            } else {
                var pos = i$7, at = order.length, isRTL = direction == "rtl" ? 1 : 0;
                for(++i$7; i$7 < len && types[i$7] != "L"; ++i$7);
                for(var j$2 = pos; j$2 < i$7;)if (countsAsNum.test(types[j$2])) {
                    if (pos < j$2) {
                        order.splice(at, 0, new BidiSpan(1, pos, j$2));
                        at += isRTL;
                    }
                    var nstart = j$2;
                    for(++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2);
                    order.splice(at, 0, new BidiSpan(2, nstart, j$2));
                    at += isRTL;
                    pos = j$2;
                } else ++j$2;
                if (pos < i$7) order.splice(at, 0, new BidiSpan(1, pos, i$7));
            }
            if (direction == "ltr") {
                if (order[0].level == 1 && (m = str.match(/^\s+/))) {
                    order[0].from = m[0].length;
                    order.unshift(new BidiSpan(0, 0, m[0].length));
                }
                if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
                    lst(order).to -= m[0].length;
                    order.push(new BidiSpan(0, len - m[0].length, len));
                }
            }
            return direction == "rtl" ? order.reverse() : order;
        };
    }();
    // Get the bidi ordering for the given line (and cache it). Returns
    // false for lines that are fully left-to-right, and an array of
    // BidiSpan objects otherwise.
    function getOrder(line, direction) {
        var order = line.order;
        if (order == null) order = line.order = bidiOrdering(line.text, direction);
        return order;
    }
    // EVENT HANDLING
    // Lightweight event framework. on/off also work on DOM nodes,
    // registering native DOM handlers.
    var noHandlers = [];
    var on = function(emitter, type, f) {
        if (emitter.addEventListener) emitter.addEventListener(type, f, false);
        else if (emitter.attachEvent) emitter.attachEvent("on" + type, f);
        else {
            var map = emitter._handlers || (emitter._handlers = {});
            map[type] = (map[type] || noHandlers).concat(f);
        }
    };
    function getHandlers(emitter, type) {
        return emitter._handlers && emitter._handlers[type] || noHandlers;
    }
    function off(emitter, type, f) {
        if (emitter.removeEventListener) emitter.removeEventListener(type, f, false);
        else if (emitter.detachEvent) emitter.detachEvent("on" + type, f);
        else {
            var map = emitter._handlers, arr = map && map[type];
            if (arr) {
                var index = indexOf(arr, f);
                if (index > -1) map[type] = arr.slice(0, index).concat(arr.slice(index + 1));
            }
        }
    }
    function signal(emitter, type /*, values...*/ ) {
        var handlers = getHandlers(emitter, type);
        if (!handlers.length) return;
        var args = Array.prototype.slice.call(arguments, 2);
        for(var i = 0; i < handlers.length; ++i)handlers[i].apply(null, args);
    }
    // The DOM events that CodeMirror handles can be overridden by
    // registering a (non-DOM) handler on the editor for the event name,
    // and preventDefault-ing the event in that handler.
    function signalDOMEvent(cm, e, override) {
        if (typeof e == "string") e = {
            type: e,
            preventDefault: function() {
                this.defaultPrevented = true;
            }
        };
        signal(cm, override || e.type, cm, e);
        return e_defaultPrevented(e) || e.codemirrorIgnore;
    }
    function signalCursorActivity(cm) {
        var arr = cm._handlers && cm._handlers.cursorActivity;
        if (!arr) return;
        var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
        for(var i = 0; i < arr.length; ++i)if (indexOf(set, arr[i]) == -1) set.push(arr[i]);
    }
    function hasHandler(emitter, type) {
        return getHandlers(emitter, type).length > 0;
    }
    // Add on and off methods to a constructor's prototype, to make
    // registering events on such objects more convenient.
    function eventMixin(ctor) {
        ctor.prototype.on = function(type, f) {
            on(this, type, f);
        };
        ctor.prototype.off = function(type, f) {
            off(this, type, f);
        };
    }
    // Due to the fact that we still support jurassic IE versions, some
    // compatibility wrappers are needed.
    function e_preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
    }
    function e_stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else e.cancelBubble = true;
    }
    function e_defaultPrevented(e) {
        return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false;
    }
    function e_stop(e) {
        e_preventDefault(e);
        e_stopPropagation(e);
    }
    function e_target(e) {
        return e.target || e.srcElement;
    }
    function e_button(e) {
        var b = e.which;
        if (b == null) {
            if (e.button & 1) b = 1;
            else if (e.button & 2) b = 3;
            else if (e.button & 4) b = 2;
        }
        if (mac && e.ctrlKey && b == 1) b = 3;
        return b;
    }
    // Detect drag-and-drop
    var dragAndDrop = function() {
        // There is *some* kind of drag-and-drop support in IE6-8, but I
        // couldn't get it to work yet.
        if (ie && ie_version < 9) return false;
        var div = elt('div');
        return "draggable" in div || "dragDrop" in div;
    }();
    var zwspSupported;
    function zeroWidthElement(measure) {
        if (zwspSupported == null) {
            var test = elt("span", "\u200b");
            removeChildrenAndAdd(measure, elt("span", [
                test,
                document.createTextNode("x")
            ]));
            if (measure.firstChild.offsetHeight != 0) zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8);
        }
        var node = zwspSupported ? elt("span", "\u200b") : elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px");
        node.setAttribute("cm-text", "");
        return node;
    }
    // Feature-detect IE's crummy client rect reporting for bidi text
    var badBidiRects;
    function hasBadBidiRects(measure) {
        if (badBidiRects != null) return badBidiRects;
        var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"));
        var r0 = range(txt, 0, 1).getBoundingClientRect();
        var r1 = range(txt, 1, 2).getBoundingClientRect();
        removeChildren(measure);
        if (!r0 || r0.left == r0.right) return false;
         // Safari returns null in some cases (#2780)
        return badBidiRects = r1.right - r0.right < 3;
    }
    // See if "".split is the broken IE version, if so, provide an
    // alternative way to split lines.
    var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function(string) {
        var pos = 0, result = [], l = string.length;
        while(pos <= l){
            var nl = string.indexOf("\n", pos);
            if (nl == -1) nl = string.length;
            var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
            var rt = line.indexOf("\r");
            if (rt != -1) {
                result.push(line.slice(0, rt));
                pos += rt + 1;
            } else {
                result.push(line);
                pos = nl + 1;
            }
        }
        return result;
    } : function(string) {
        return string.split(/\r\n?|\n/);
    };
    var hasSelection = window.getSelection ? function(te) {
        try {
            return te.selectionStart != te.selectionEnd;
        } catch (e) {
            return false;
        }
    } : function(te) {
        var range;
        try {
            range = te.ownerDocument.selection.createRange();
        } catch (e) {}
        if (!range || range.parentElement() != te) return false;
        return range.compareEndPoints("StartToEnd", range) != 0;
    };
    var hasCopyEvent = function() {
        var e = elt("div");
        if ("oncopy" in e) return true;
        e.setAttribute("oncopy", "return;");
        return typeof e.oncopy == "function";
    }();
    var badZoomedRects = null;
    function hasBadZoomedRects(measure) {
        if (badZoomedRects != null) return badZoomedRects;
        var node = removeChildrenAndAdd(measure, elt("span", "x"));
        var normal = node.getBoundingClientRect();
        var fromRange = range(node, 0, 1).getBoundingClientRect();
        return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1;
    }
    // Known modes, by name and by MIME
    var modes = {}, mimeModes = {};
    // Extra arguments are stored as the mode's dependencies, which is
    // used by (legacy) mechanisms like loadmode.js to automatically
    // load a mode. (Preferred mechanism is the require/define calls.)
    function defineMode(name, mode) {
        if (arguments.length > 2) mode.dependencies = Array.prototype.slice.call(arguments, 2);
        modes[name] = mode;
    }
    function defineMIME(mime, spec) {
        mimeModes[mime] = spec;
    }
    // Given a MIME type, a {name, ...options} config object, or a name
    // string, return a mode config object.
    function resolveMode(spec) {
        if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) spec = mimeModes[spec];
        else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
            var found = mimeModes[spec.name];
            if (typeof found == "string") found = {
                name: found
            };
            spec = createObj(found, spec);
            spec.name = found.name;
        } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) return resolveMode("application/xml");
        else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) return resolveMode("application/json");
        if (typeof spec == "string") return {
            name: spec
        };
        else return spec || {
            name: "null"
        };
    }
    // Given a mode spec (anything that resolveMode accepts), find and
    // initialize an actual mode object.
    function getMode(options, spec) {
        spec = resolveMode(spec);
        var mfactory = modes[spec.name];
        if (!mfactory) return getMode(options, "text/plain");
        var modeObj = mfactory(options, spec);
        if (modeExtensions.hasOwnProperty(spec.name)) {
            var exts = modeExtensions[spec.name];
            for(var prop in exts){
                if (!exts.hasOwnProperty(prop)) continue;
                if (modeObj.hasOwnProperty(prop)) modeObj["_" + prop] = modeObj[prop];
                modeObj[prop] = exts[prop];
            }
        }
        modeObj.name = spec.name;
        if (spec.helperType) modeObj.helperType = spec.helperType;
        if (spec.modeProps) for(var prop$1 in spec.modeProps)modeObj[prop$1] = spec.modeProps[prop$1];
        return modeObj;
    }
    // This can be used to attach properties to mode objects from
    // outside the actual mode definition.
    var modeExtensions = {};
    function extendMode(mode, properties) {
        var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : modeExtensions[mode] = {};
        copyObj(properties, exts);
    }
    function copyState(mode, state) {
        if (state === true) return state;
        if (mode.copyState) return mode.copyState(state);
        var nstate = {};
        for(var n in state){
            var val = state[n];
            if (val instanceof Array) val = val.concat([]);
            nstate[n] = val;
        }
        return nstate;
    }
    // Given a mode and a state (for that mode), find the inner mode and
    // state at the position that the state refers to.
    function innerMode(mode, state) {
        var info;
        while(mode.innerMode){
            info = mode.innerMode(state);
            if (!info || info.mode == mode) break;
            state = info.state;
            mode = info.mode;
        }
        return info || {
            mode: mode,
            state: state
        };
    }
    function startState(mode, a1, a2) {
        return mode.startState ? mode.startState(a1, a2) : true;
    }
    // STRING STREAM
    // Fed to the mode parsers, provides helper functions to make
    // parsers more succinct.
    var StringStream = function(string, tabSize, lineOracle) {
        this.pos = this.start = 0;
        this.string = string;
        this.tabSize = tabSize || 8;
        this.lastColumnPos = this.lastColumnValue = 0;
        this.lineStart = 0;
        this.lineOracle = lineOracle;
    };
    StringStream.prototype.eol = function() {
        return this.pos >= this.string.length;
    };
    StringStream.prototype.sol = function() {
        return this.pos == this.lineStart;
    };
    StringStream.prototype.peek = function() {
        return this.string.charAt(this.pos) || undefined;
    };
    StringStream.prototype.next = function() {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    };
    StringStream.prototype.eat = function(match) {
        var ch = this.string.charAt(this.pos);
        var ok;
        if (typeof match == "string") ok = ch == match;
        else ok = ch && (match.test ? match.test(ch) : match(ch));
        if (ok) {
            ++this.pos;
            return ch;
        }
    };
    StringStream.prototype.eatWhile = function(match) {
        var start = this.pos;
        while(this.eat(match));
        return this.pos > start;
    };
    StringStream.prototype.eatSpace = function() {
        var start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos)))++this.pos;
        return this.pos > start;
    };
    StringStream.prototype.skipToEnd = function() {
        this.pos = this.string.length;
    };
    StringStream.prototype.skipTo = function(ch) {
        var found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    };
    StringStream.prototype.backUp = function(n) {
        this.pos -= n;
    };
    StringStream.prototype.column = function() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
    };
    StringStream.prototype.indentation = function() {
        return countColumn(this.string, null, this.tabSize) - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
    };
    StringStream.prototype.match = function(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            var cased = function(str) {
                return caseInsensitive ? str.toLowerCase() : str;
            };
            var substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) this.pos += pattern.length;
                return true;
            }
        } else {
            var match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) return null;
            if (match && consume !== false) this.pos += match[0].length;
            return match;
        }
    };
    StringStream.prototype.current = function() {
        return this.string.slice(this.start, this.pos);
    };
    StringStream.prototype.hideFirstChars = function(n, inner) {
        this.lineStart += n;
        try {
            return inner();
        } finally{
            this.lineStart -= n;
        }
    };
    StringStream.prototype.lookAhead = function(n) {
        var oracle = this.lineOracle;
        return oracle && oracle.lookAhead(n);
    };
    StringStream.prototype.baseToken = function() {
        var oracle = this.lineOracle;
        return oracle && oracle.baseToken(this.pos);
    };
    // Find the line object corresponding to the given line number.
    function getLine(doc, n) {
        n -= doc.first;
        if (n < 0 || n >= doc.size) throw new Error("There is no line " + (n + doc.first) + " in the document.");
        var chunk = doc;
        while(!chunk.lines)for(var i = 0;; ++i){
            var child = chunk.children[i], sz = child.chunkSize();
            if (n < sz) {
                chunk = child;
                break;
            }
            n -= sz;
        }
        return chunk.lines[n];
    }
    // Get the part of a document between two positions, as an array of
    // strings.
    function getBetween(doc, start, end) {
        var out = [], n = start.line;
        doc.iter(start.line, end.line + 1, function(line) {
            var text = line.text;
            if (n == end.line) text = text.slice(0, end.ch);
            if (n == start.line) text = text.slice(start.ch);
            out.push(text);
            ++n;
        });
        return out;
    }
    // Get the lines between from and to, as array of strings.
    function getLines(doc, from, to) {
        var out = [];
        doc.iter(from, to, function(line) {
            out.push(line.text);
        }); // iter aborts when callback returns truthy value
        return out;
    }
    // Update the height of a line, propagating the height change
    // upwards to parent nodes.
    function updateLineHeight(line, height) {
        var diff = height - line.height;
        if (diff) for(var n = line; n; n = n.parent)n.height += diff;
    }
    // Given a line object, find its line number by walking up through
    // its parent links.
    function lineNo(line) {
        if (line.parent == null) return null;
        var cur = line.parent, no = indexOf(cur.lines, line);
        for(var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent)for(var i = 0;; ++i){
            if (chunk.children[i] == cur) break;
            no += chunk.children[i].chunkSize();
        }
        return no + cur.first;
    }
    // Find the line at the given vertical position, using the height
    // information in the document tree.
    function lineAtHeight(chunk, h) {
        var n = chunk.first;
        outer: do {
            for(var i$1 = 0; i$1 < chunk.children.length; ++i$1){
                var child = chunk.children[i$1], ch = child.height;
                if (h < ch) {
                    chunk = child;
                    continue outer;
                }
                h -= ch;
                n += child.chunkSize();
            }
            return n;
        }while (!chunk.lines);
        var i = 0;
        for(; i < chunk.lines.length; ++i){
            var line = chunk.lines[i], lh = line.height;
            if (h < lh) break;
            h -= lh;
        }
        return n + i;
    }
    function isLine(doc, l) {
        return l >= doc.first && l < doc.first + doc.size;
    }
    function lineNumberFor(options, i) {
        return String(options.lineNumberFormatter(i + options.firstLineNumber));
    }
    // A Pos instance represents a position within the text.
    function Pos(line, ch, sticky) {
        if (sticky === void 0) sticky = null;
        if (!(this instanceof Pos)) return new Pos(line, ch, sticky);
        this.line = line;
        this.ch = ch;
        this.sticky = sticky;
    }
    // Compare two positions, return 0 if they are the same, a negative
    // number when a is less, and a positive number otherwise.
    function cmp(a, b) {
        return a.line - b.line || a.ch - b.ch;
    }
    function equalCursorPos(a, b) {
        return a.sticky == b.sticky && cmp(a, b) == 0;
    }
    function copyPos(x) {
        return Pos(x.line, x.ch);
    }
    function maxPos(a, b) {
        return cmp(a, b) < 0 ? b : a;
    }
    function minPos(a, b) {
        return cmp(a, b) < 0 ? a : b;
    }
    // Most of the external API clips given positions to make sure they
    // actually exist within the document.
    function clipLine(doc, n) {
        return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1));
    }
    function clipPos(doc, pos) {
        if (pos.line < doc.first) return Pos(doc.first, 0);
        var last = doc.first + doc.size - 1;
        if (pos.line > last) return Pos(last, getLine(doc, last).text.length);
        return clipToLen(pos, getLine(doc, pos.line).text.length);
    }
    function clipToLen(pos, linelen) {
        var ch = pos.ch;
        if (ch == null || ch > linelen) return Pos(pos.line, linelen);
        else if (ch < 0) return Pos(pos.line, 0);
        else return pos;
    }
    function clipPosArray(doc, array) {
        var out = [];
        for(var i = 0; i < array.length; i++)out[i] = clipPos(doc, array[i]);
        return out;
    }
    var SavedContext = function(state, lookAhead) {
        this.state = state;
        this.lookAhead = lookAhead;
    };
    var Context = function(doc, state, line, lookAhead) {
        this.state = state;
        this.doc = doc;
        this.line = line;
        this.maxLookAhead = lookAhead || 0;
        this.baseTokens = null;
        this.baseTokenPos = 1;
    };
    Context.prototype.lookAhead = function(n) {
        var line = this.doc.getLine(this.line + n);
        if (line != null && n > this.maxLookAhead) this.maxLookAhead = n;
        return line;
    };
    Context.prototype.baseToken = function(n) {
        if (!this.baseTokens) return null;
        while(this.baseTokens[this.baseTokenPos] <= n)this.baseTokenPos += 2;
        var type = this.baseTokens[this.baseTokenPos + 1];
        return {
            type: type && type.replace(/( |^)overlay .*/, ""),
            size: this.baseTokens[this.baseTokenPos] - n
        };
    };
    Context.prototype.nextLine = function() {
        this.line++;
        if (this.maxLookAhead > 0) this.maxLookAhead--;
    };
    Context.fromSaved = function(doc, saved, line) {
        if (saved instanceof SavedContext) return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead);
        else return new Context(doc, copyState(doc.mode, saved), line);
    };
    Context.prototype.save = function(copy) {
        var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
        return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state;
    };
    // Compute a style array (an array starting with a mode generation
    // -- for invalidation -- followed by pairs of end positions and
    // style strings), which is used to highlight the tokens on the
    // line.
    function highlightLine(cm, line, context, forceToEnd) {
        // A styles array always starts with a number identifying the
        // mode/overlays that it is based on (for easy invalidation).
        var st = [
            cm.state.modeGen
        ], lineClasses = {};
        // Compute the base array of styles
        runMode(cm, line.text, cm.doc.mode, context, function(end, style) {
            return st.push(end, style);
        }, lineClasses, forceToEnd);
        var state = context.state;
        // Run overlays, adjust style array.
        var loop = function(o) {
            context.baseTokens = st;
            var overlay = cm.state.overlays[o], i = 1, at = 0;
            context.state = true;
            runMode(cm, line.text, overlay.mode, context, function(end, style) {
                var start = i;
                // Ensure there's a token end at the current position, and that i points at it
                while(at < end){
                    var i_end = st[i];
                    if (i_end > end) st.splice(i, 1, end, st[i + 1], i_end);
                    i += 2;
                    at = Math.min(end, i_end);
                }
                if (!style) return;
                if (overlay.opaque) {
                    st.splice(start, i - start, end, "overlay " + style);
                    i = start + 2;
                } else for(; start < i; start += 2){
                    var cur = st[start + 1];
                    st[start + 1] = (cur ? cur + " " : "") + "overlay " + style;
                }
            }, lineClasses);
            context.state = state;
            context.baseTokens = null;
            context.baseTokenPos = 1;
        };
        for(var o = 0; o < cm.state.overlays.length; ++o)loop(o);
        return {
            styles: st,
            classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null
        };
    }
    function getLineStyles(cm, line, updateFrontier) {
        if (!line.styles || line.styles[0] != cm.state.modeGen) {
            var context = getContextBefore(cm, lineNo(line));
            var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
            var result = highlightLine(cm, line, context);
            if (resetState) context.state = resetState;
            line.stateAfter = context.save(!resetState);
            line.styles = result.styles;
            if (result.classes) line.styleClasses = result.classes;
            else if (line.styleClasses) line.styleClasses = null;
            if (updateFrontier === cm.doc.highlightFrontier) cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier);
        }
        return line.styles;
    }
    function getContextBefore(cm, n, precise) {
        var doc = cm.doc, display = cm.display;
        if (!doc.mode.startState) return new Context(doc, true, n);
        var start = findStartLine(cm, n, precise);
        var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
        var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);
        doc.iter(start, n, function(line) {
            processLine(cm, line.text, context);
            var pos = context.line;
            line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
            context.nextLine();
        });
        if (precise) doc.modeFrontier = context.line;
        return context;
    }
    // Lightweight form of highlight -- proceed over this line and
    // update state, but don't save a style array. Used for lines that
    // aren't currently visible.
    function processLine(cm, text, context, startAt) {
        var mode = cm.doc.mode;
        var stream = new StringStream(text, cm.options.tabSize, context);
        stream.start = stream.pos = startAt || 0;
        if (text == "") callBlankLine(mode, context.state);
        while(!stream.eol()){
            readToken(mode, stream, context.state);
            stream.start = stream.pos;
        }
    }
    function callBlankLine(mode, state) {
        if (mode.blankLine) return mode.blankLine(state);
        if (!mode.innerMode) return;
        var inner = innerMode(mode, state);
        if (inner.mode.blankLine) return inner.mode.blankLine(inner.state);
    }
    function readToken(mode, stream, state, inner) {
        for(var i = 0; i < 10; i++){
            if (inner) inner[0] = innerMode(mode, state).mode;
            var style = mode.token(stream, state);
            if (stream.pos > stream.start) return style;
        }
        throw new Error("Mode " + mode.name + " failed to advance stream.");
    }
    var Token = function(stream, type, state) {
        this.start = stream.start;
        this.end = stream.pos;
        this.string = stream.current();
        this.type = type || null;
        this.state = state;
    };
    // Utility for getTokenAt and getLineTokens
    function takeToken(cm, pos, precise, asArray) {
        var doc = cm.doc, mode = doc.mode, style;
        pos = clipPos(doc, pos);
        var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
        var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
        if (asArray) tokens = [];
        while((asArray || stream.pos < pos.ch) && !stream.eol()){
            stream.start = stream.pos;
            style = readToken(mode, stream, context.state);
            if (asArray) tokens.push(new Token(stream, style, copyState(doc.mode, context.state)));
        }
        return asArray ? tokens : new Token(stream, style, context.state);
    }
    function extractLineClasses(type, output) {
        if (type) for(;;){
            var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
            if (!lineClass) break;
            type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
            var prop = lineClass[1] ? "bgClass" : "textClass";
            if (output[prop] == null) output[prop] = lineClass[2];
            else if (!new RegExp("(?:^|\\s)" + lineClass[2] + "(?:$|\\s)").test(output[prop])) output[prop] += " " + lineClass[2];
        }
        return type;
    }
    // Run the given mode's parser over a line, calling f for each token.
    function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
        var flattenSpans = mode.flattenSpans;
        if (flattenSpans == null) flattenSpans = cm.options.flattenSpans;
        var curStart = 0, curStyle = null;
        var stream = new StringStream(text, cm.options.tabSize, context), style;
        var inner = cm.options.addModeClass && [
            null
        ];
        if (text == "") extractLineClasses(callBlankLine(mode, context.state), lineClasses);
        while(!stream.eol()){
            if (stream.pos > cm.options.maxHighlightLength) {
                flattenSpans = false;
                if (forceToEnd) processLine(cm, text, context, stream.pos);
                stream.pos = text.length;
                style = null;
            } else style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
            if (inner) {
                var mName = inner[0].name;
                if (mName) style = "m-" + (style ? mName + " " + style : mName);
            }
            if (!flattenSpans || curStyle != style) {
                while(curStart < stream.start){
                    curStart = Math.min(stream.start, curStart + 5000);
                    f(curStart, curStyle);
                }
                curStyle = style;
            }
            stream.start = stream.pos;
        }
        while(curStart < stream.pos){
            // Webkit seems to refuse to render text nodes longer than 57444
            // characters, and returns inaccurate measurements in nodes
            // starting around 5000 chars.
            var pos = Math.min(stream.pos, curStart + 5000);
            f(pos, curStyle);
            curStart = pos;
        }
    }
    // Finds the line to start with when starting a parse. Tries to
    // find a line with a stateAfter, so that it can start with a
    // valid state. If that fails, it returns the line with the
    // smallest indentation, which tends to need the least context to
    // parse correctly.
    function findStartLine(cm, n, precise) {
        var minindent, minline, doc = cm.doc;
        var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
        for(var search = n; search > lim; --search){
            if (search <= doc.first) return doc.first;
            var line = getLine(doc, search - 1), after = line.stateAfter;
            if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier)) return search;
            var indented = countColumn(line.text, null, cm.options.tabSize);
            if (minline == null || minindent > indented) {
                minline = search - 1;
                minindent = indented;
            }
        }
        return minline;
    }
    function retreatFrontier(doc, n) {
        doc.modeFrontier = Math.min(doc.modeFrontier, n);
        if (doc.highlightFrontier < n - 10) return;
        var start = doc.first;
        for(var line = n - 1; line > start; line--){
            var saved = getLine(doc, line).stateAfter;
            // change is on 3
            // state on line 1 looked ahead 2 -- so saw 3
            // test 1 + 2 < 3 should cover this
            if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
                start = line + 1;
                break;
            }
        }
        doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
    }
    // Optimize some code when these features are not used.
    var sawReadOnlySpans = false, sawCollapsedSpans = false;
    function seeReadOnlySpans() {
        sawReadOnlySpans = true;
    }
    function seeCollapsedSpans() {
        sawCollapsedSpans = true;
    }
    // TEXTMARKER SPANS
    function MarkedSpan(marker, from, to) {
        this.marker = marker;
        this.from = from;
        this.to = to;
    }
    // Search an array of spans for a span matching the given marker.
    function getMarkedSpanFor(spans, marker) {
        if (spans) for(var i = 0; i < spans.length; ++i){
            var span = spans[i];
            if (span.marker == marker) return span;
        }
    }
    // Remove a span from an array, returning undefined if no spans are
    // left (we don't store arrays for lines without spans).
    function removeMarkedSpan(spans, span) {
        var r;
        for(var i = 0; i < spans.length; ++i)if (spans[i] != span) (r || (r = [])).push(spans[i]);
        return r;
    }
    // Add a span to a line.
    function addMarkedSpan(line, span, op) {
        var inThisOp = op && window.WeakSet && (op.markedSpans || (op.markedSpans = new WeakSet));
        if (inThisOp && line.markedSpans && inThisOp.has(line.markedSpans)) line.markedSpans.push(span);
        else {
            line.markedSpans = line.markedSpans ? line.markedSpans.concat([
                span
            ]) : [
                span
            ];
            if (inThisOp) inThisOp.add(line.markedSpans);
        }
        span.marker.attachLine(line);
    }
    // Used for the algorithm that adjusts markers for a change in the
    // document. These functions cut an array of spans at a given
    // character position, returning an array of remaining chunks (or
    // undefined if nothing remains).
    function markedSpansBefore(old, startCh, isInsert) {
        var nw;
        if (old) for(var i = 0; i < old.length; ++i){
            var span = old[i], marker = span.marker;
            var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
            if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
                var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh);
                (nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
            }
        }
        return nw;
    }
    function markedSpansAfter(old, endCh, isInsert) {
        var nw;
        if (old) for(var i = 0; i < old.length; ++i){
            var span = old[i], marker = span.marker;
            var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
            if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
                var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh);
                (nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh, span.to == null ? null : span.to - endCh));
            }
        }
        return nw;
    }
    // Given a change object, compute the new set of marker spans that
    // cover the line in which the change took place. Removes spans
    // entirely within the change, reconnects spans belonging to the
    // same marker that appear on both sides of the change, and cuts off
    // spans partially within the change. Returns an array of span
    // arrays with one element for each line in (after) the change.
    function stretchSpansOverChange(doc, change) {
        if (change.full) return null;
        var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
        var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
        if (!oldFirst && !oldLast) return null;
        var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
        // Get the spans that 'stick out' on both sides
        var first = markedSpansBefore(oldFirst, startCh, isInsert);
        var last = markedSpansAfter(oldLast, endCh, isInsert);
        // Next, merge those two ends
        var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
        if (first) // Fix up .to properties of first
        for(var i = 0; i < first.length; ++i){
            var span = first[i];
            if (span.to == null) {
                var found = getMarkedSpanFor(last, span.marker);
                if (!found) span.to = startCh;
                else if (sameLine) span.to = found.to == null ? null : found.to + offset;
            }
        }
        if (last) // Fix up .from in last (or move them into first in case of sameLine)
        for(var i$1 = 0; i$1 < last.length; ++i$1){
            var span$1 = last[i$1];
            if (span$1.to != null) span$1.to += offset;
            if (span$1.from == null) {
                var found$1 = getMarkedSpanFor(first, span$1.marker);
                if (!found$1) {
                    span$1.from = offset;
                    if (sameLine) (first || (first = [])).push(span$1);
                }
            } else {
                span$1.from += offset;
                if (sameLine) (first || (first = [])).push(span$1);
            }
        }
        // Make sure we didn't create any zero-length spans
        if (first) first = clearEmptySpans(first);
        if (last && last != first) last = clearEmptySpans(last);
        var newMarkers = [
            first
        ];
        if (!sameLine) {
            // Fill gap with whole-line-spans
            var gap = change.text.length - 2, gapMarkers;
            if (gap > 0 && first) {
                for(var i$2 = 0; i$2 < first.length; ++i$2)if (first[i$2].to == null) (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null));
            }
            for(var i$3 = 0; i$3 < gap; ++i$3)newMarkers.push(gapMarkers);
            newMarkers.push(last);
        }
        return newMarkers;
    }
    // Remove spans that are empty and don't have a clearWhenEmpty
    // option of false.
    function clearEmptySpans(spans) {
        for(var i = 0; i < spans.length; ++i){
            var span = spans[i];
            if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false) spans.splice(i--, 1);
        }
        if (!spans.length) return null;
        return spans;
    }
    // Used to 'clip' out readOnly ranges when making a change.
    function removeReadOnlyRanges(doc, from, to) {
        var markers = null;
        doc.iter(from.line, to.line + 1, function(line) {
            if (line.markedSpans) for(var i = 0; i < line.markedSpans.length; ++i){
                var mark = line.markedSpans[i].marker;
                if (mark.readOnly && (!markers || indexOf(markers, mark) == -1)) (markers || (markers = [])).push(mark);
            }
        });
        if (!markers) return null;
        var parts = [
            {
                from: from,
                to: to
            }
        ];
        for(var i = 0; i < markers.length; ++i){
            var mk = markers[i], m = mk.find(0);
            for(var j = 0; j < parts.length; ++j){
                var p = parts[j];
                if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) continue;
                var newParts = [
                    j,
                    1
                ], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
                if (dfrom < 0 || !mk.inclusiveLeft && !dfrom) newParts.push({
                    from: p.from,
                    to: m.from
                });
                if (dto > 0 || !mk.inclusiveRight && !dto) newParts.push({
                    from: m.to,
                    to: p.to
                });
                parts.splice.apply(parts, newParts);
                j += newParts.length - 3;
            }
        }
        return parts;
    }
    // Connect or disconnect spans from a line.
    function detachMarkedSpans(line) {
        var spans = line.markedSpans;
        if (!spans) return;
        for(var i = 0; i < spans.length; ++i)spans[i].marker.detachLine(line);
        line.markedSpans = null;
    }
    function attachMarkedSpans(line, spans) {
        if (!spans) return;
        for(var i = 0; i < spans.length; ++i)spans[i].marker.attachLine(line);
        line.markedSpans = spans;
    }
    // Helpers used when computing which overlapping collapsed span
    // counts as the larger one.
    function extraLeft(marker) {
        return marker.inclusiveLeft ? -1 : 0;
    }
    function extraRight(marker) {
        return marker.inclusiveRight ? 1 : 0;
    }
    // Returns a number indicating which of two overlapping collapsed
    // spans is larger (and thus includes the other). Falls back to
    // comparing ids when the spans cover exactly the same range.
    function compareCollapsedMarkers(a, b) {
        var lenDiff = a.lines.length - b.lines.length;
        if (lenDiff != 0) return lenDiff;
        var aPos = a.find(), bPos = b.find();
        var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
        if (fromCmp) return -fromCmp;
        var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
        if (toCmp) return toCmp;
        return b.id - a.id;
    }
    // Find out whether a line ends or starts in a collapsed span. If
    // so, return the marker for that span.
    function collapsedSpanAtSide(line, start) {
        var sps = sawCollapsedSpans && line.markedSpans, found;
        if (sps) for(var sp = void 0, i = 0; i < sps.length; ++i){
            sp = sps[i];
            if (sp.marker.collapsed && (start ? sp.from : sp.to) == null && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) found = sp.marker;
        }
        return found;
    }
    function collapsedSpanAtStart(line) {
        return collapsedSpanAtSide(line, true);
    }
    function collapsedSpanAtEnd(line) {
        return collapsedSpanAtSide(line, false);
    }
    function collapsedSpanAround(line, ch) {
        var sps = sawCollapsedSpans && line.markedSpans, found;
        if (sps) for(var i = 0; i < sps.length; ++i){
            var sp = sps[i];
            if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) found = sp.marker;
        }
        return found;
    }
    // Test whether there exists a collapsed span that partially
    // overlaps (covers the start or end, but not both) of a new span.
    // Such overlap is not allowed.
    function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
        var line = getLine(doc, lineNo);
        var sps = sawCollapsedSpans && line.markedSpans;
        if (sps) for(var i = 0; i < sps.length; ++i){
            var sp = sps[i];
            if (!sp.marker.collapsed) continue;
            var found = sp.marker.find(0);
            var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
            var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
            if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) continue;
            if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) || fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0)) return true;
        }
    }
    // A visual line is a line as drawn on the screen. Folding, for
    // example, can cause multiple logical lines to appear on the same
    // visual line. This finds the start of the visual line that the
    // given line is part of (usually that is the line itself).
    function visualLine(line) {
        var merged;
        while(merged = collapsedSpanAtStart(line))line = merged.find(-1, true).line;
        return line;
    }
    function visualLineEnd(line) {
        var merged;
        while(merged = collapsedSpanAtEnd(line))line = merged.find(1, true).line;
        return line;
    }
    // Returns an array of logical lines that continue the visual line
    // started by the argument, or undefined if there are no such lines.
    function visualLineContinued(line) {
        var merged, lines;
        while(merged = collapsedSpanAtEnd(line)){
            line = merged.find(1, true).line;
            (lines || (lines = [])).push(line);
        }
        return lines;
    }
    // Get the line number of the start of the visual line that the
    // given line number is part of.
    function visualLineNo(doc, lineN) {
        var line = getLine(doc, lineN), vis = visualLine(line);
        if (line == vis) return lineN;
        return lineNo(vis);
    }
    // Get the line number of the start of the next visual line after
    // the given line.
    function visualLineEndNo(doc, lineN) {
        if (lineN > doc.lastLine()) return lineN;
        var line = getLine(doc, lineN), merged;
        if (!lineIsHidden(doc, line)) return lineN;
        while(merged = collapsedSpanAtEnd(line))line = merged.find(1, true).line;
        return lineNo(line) + 1;
    }
    // Compute whether a line is hidden. Lines count as hidden when they
    // are part of a visual line that starts with another line, or when
    // they are entirely covered by collapsed, non-widget span.
    function lineIsHidden(doc, line) {
        var sps = sawCollapsedSpans && line.markedSpans;
        if (sps) for(var sp = void 0, i = 0; i < sps.length; ++i){
            sp = sps[i];
            if (!sp.marker.collapsed) continue;
            if (sp.from == null) return true;
            if (sp.marker.widgetNode) continue;
            if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp)) return true;
        }
    }
    function lineIsHiddenInner(doc, line, span) {
        if (span.to == null) {
            var end = span.marker.find(1, true);
            return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker));
        }
        if (span.marker.inclusiveRight && span.to == line.text.length) return true;
        for(var sp = void 0, i = 0; i < line.markedSpans.length; ++i){
            sp = line.markedSpans[i];
            if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to && (sp.to == null || sp.to != span.from) && (sp.marker.inclusiveLeft || span.marker.inclusiveRight) && lineIsHiddenInner(doc, line, sp)) return true;
        }
    }
    // Find the height above the given line.
    function heightAtLine(lineObj) {
        lineObj = visualLine(lineObj);
        var h = 0, chunk = lineObj.parent;
        for(var i = 0; i < chunk.lines.length; ++i){
            var line = chunk.lines[i];
            if (line == lineObj) break;
            else h += line.height;
        }
        for(var p = chunk.parent; p; chunk = p, p = chunk.parent)for(var i$1 = 0; i$1 < p.children.length; ++i$1){
            var cur = p.children[i$1];
            if (cur == chunk) break;
            else h += cur.height;
        }
        return h;
    }
    // Compute the character length of a line, taking into account
    // collapsed ranges (see markText) that might hide parts, and join
    // other lines onto it.
    function lineLength(line) {
        if (line.height == 0) return 0;
        var len = line.text.length, merged, cur = line;
        while(merged = collapsedSpanAtStart(cur)){
            var found = merged.find(0, true);
            cur = found.from.line;
            len += found.from.ch - found.to.ch;
        }
        cur = line;
        while(merged = collapsedSpanAtEnd(cur)){
            var found$1 = merged.find(0, true);
            len -= cur.text.length - found$1.from.ch;
            cur = found$1.to.line;
            len += cur.text.length - found$1.to.ch;
        }
        return len;
    }
    // Find the longest line in the document.
    function findMaxLine(cm) {
        var d = cm.display, doc = cm.doc;
        d.maxLine = getLine(doc, doc.first);
        d.maxLineLength = lineLength(d.maxLine);
        d.maxLineChanged = true;
        doc.iter(function(line) {
            var len = lineLength(line);
            if (len > d.maxLineLength) {
                d.maxLineLength = len;
                d.maxLine = line;
            }
        });
    }
    // LINE DATA STRUCTURE
    // Line objects. These hold state related to a line, including
    // highlighting info (the styles array).
    var Line = function(text, markedSpans, estimateHeight) {
        this.text = text;
        attachMarkedSpans(this, markedSpans);
        this.height = estimateHeight ? estimateHeight(this) : 1;
    };
    Line.prototype.lineNo = function() {
        return lineNo(this);
    };
    eventMixin(Line);
    // Change the content (text, markers) of a line. Automatically
    // invalidates cached information and tries to re-estimate the
    // line's height.
    function updateLine(line, text, markedSpans, estimateHeight) {
        line.text = text;
        if (line.stateAfter) line.stateAfter = null;
        if (line.styles) line.styles = null;
        if (line.order != null) line.order = null;
        detachMarkedSpans(line);
        attachMarkedSpans(line, markedSpans);
        var estHeight = estimateHeight ? estimateHeight(line) : 1;
        if (estHeight != line.height) updateLineHeight(line, estHeight);
    }
    // Detach a line from the document tree and its markers.
    function cleanUpLine(line) {
        line.parent = null;
        detachMarkedSpans(line);
    }
    // Convert a style as returned by a mode (either null, or a string
    // containing one or more styles) to a CSS style. This is cached,
    // and also looks for line-wide styles.
    var styleToClassCache = {}, styleToClassCacheWithMode = {};
    function interpretTokenStyle(style, options) {
        if (!style || /^\s*$/.test(style)) return null;
        var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
        return cache[style] || (cache[style] = style.replace(/\S+/g, "cm-$&"));
    }
    // Render the DOM representation of the text of a line. Also builds
    // up a 'line map', which points at the DOM nodes that represent
    // specific stretches of text, and is used by the measuring code.
    // The returned object contains the DOM node, this map, and
    // information about line-wide styles that were set by the mode.
    function buildLineContent(cm, lineView) {
        // The padding-right forces the element to have a 'border', which
        // is needed on Webkit to be able to get line-level bounding
        // rectangles for it (in measureChar).
        var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
        var builder = {
            pre: eltP("pre", [
                content
            ], "CodeMirror-line"),
            content: content,
            col: 0,
            pos: 0,
            cm: cm,
            trailingSpace: false,
            splitSpaces: cm.getOption("lineWrapping")
        };
        lineView.measure = {};
        // Iterate over the logical lines that make up this visual line.
        for(var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++){
            var line = i ? lineView.rest[i - 1] : lineView.line, order = void 0;
            builder.pos = 0;
            builder.addToken = buildToken;
            // Optionally wire in some hacks into the token-rendering
            // algorithm, to deal with browser quirks.
            if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction))) builder.addToken = buildTokenBadBidi(builder.addToken, order);
            builder.map = [];
            var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
            insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
            if (line.styleClasses) {
                if (line.styleClasses.bgClass) builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || "");
                if (line.styleClasses.textClass) builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || "");
            }
            // Ensure at least a single node is present, for measuring.
            if (builder.map.length == 0) builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure)));
            // Store the map and a cache object for the current logical line
            if (i == 0) {
                lineView.measure.map = builder.map;
                lineView.measure.cache = {};
            } else {
                (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map);
                (lineView.measure.caches || (lineView.measure.caches = [])).push({});
            }
        }
        // See issue #2901
        if (webkit) {
            var last = builder.content.lastChild;
            if (/\bcm-tab\b/.test(last.className) || last.querySelector && last.querySelector(".cm-tab")) builder.content.className = "cm-tab-wrap-hack";
        }
        signal(cm, "renderLine", cm, lineView.line, builder.pre);
        if (builder.pre.className) builder.textClass = joinClasses(builder.pre.className, builder.textClass || "");
        return builder;
    }
    function defaultSpecialCharPlaceholder(ch) {
        var token = elt("span", "\u2022", "cm-invalidchar");
        token.title = "\\u" + ch.charCodeAt(0).toString(16);
        token.setAttribute("aria-label", token.title);
        return token;
    }
    // Build up the DOM representation for a single token, and add it to
    // the line map. Takes care to render special characters separately.
    function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
        if (!text) return;
        var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
        var special = builder.cm.state.specialChars, mustWrap = false;
        var content;
        if (!special.test(text)) {
            builder.col += text.length;
            content = document.createTextNode(displayText);
            builder.map.push(builder.pos, builder.pos + text.length, content);
            if (ie && ie_version < 9) mustWrap = true;
            builder.pos += text.length;
        } else {
            content = document.createDocumentFragment();
            var pos = 0;
            while(true){
                special.lastIndex = pos;
                var m = special.exec(text);
                var skipped = m ? m.index - pos : text.length - pos;
                if (skipped) {
                    var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
                    if (ie && ie_version < 9) content.appendChild(elt("span", [
                        txt
                    ]));
                    else content.appendChild(txt);
                    builder.map.push(builder.pos, builder.pos + skipped, txt);
                    builder.col += skipped;
                    builder.pos += skipped;
                }
                if (!m) break;
                pos += skipped + 1;
                var txt$1 = void 0;
                if (m[0] == "\t") {
                    var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
                    txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
                    txt$1.setAttribute("role", "presentation");
                    txt$1.setAttribute("cm-text", "\t");
                    builder.col += tabWidth;
                } else if (m[0] == "\r" || m[0] == "\n") {
                    txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"));
                    txt$1.setAttribute("cm-text", m[0]);
                    builder.col += 1;
                } else {
                    txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
                    txt$1.setAttribute("cm-text", m[0]);
                    if (ie && ie_version < 9) content.appendChild(elt("span", [
                        txt$1
                    ]));
                    else content.appendChild(txt$1);
                    builder.col += 1;
                }
                builder.map.push(builder.pos, builder.pos + 1, txt$1);
                builder.pos++;
            }
        }
        builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
        if (style || startStyle || endStyle || mustWrap || css || attributes) {
            var fullStyle = style || "";
            if (startStyle) fullStyle += startStyle;
            if (endStyle) fullStyle += endStyle;
            var token = elt("span", [
                content
            ], fullStyle, css);
            if (attributes) {
                for(var attr in attributes)if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class") token.setAttribute(attr, attributes[attr]);
            }
            return builder.content.appendChild(token);
        }
        builder.content.appendChild(content);
    }
    // Change some spaces to NBSP to prevent the browser from collapsing
    // trailing spaces at the end of a line when rendering text (issue #1362).
    function splitSpaces(text, trailingBefore) {
        if (text.length > 1 && !/  /.test(text)) return text;
        var spaceBefore = trailingBefore, result = "";
        for(var i = 0; i < text.length; i++){
            var ch = text.charAt(i);
            if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32)) ch = "\u00a0";
            result += ch;
            spaceBefore = ch == " ";
        }
        return result;
    }
    // Work around nonsense dimensions being reported for stretches of
    // right-to-left text.
    function buildTokenBadBidi(inner, order) {
        return function(builder, text, style, startStyle, endStyle, css, attributes) {
            style = style ? style + " cm-force-border" : "cm-force-border";
            var start = builder.pos, end = start + text.length;
            for(;;){
                // Find the part that overlaps with the start of this text
                var part = void 0;
                for(var i = 0; i < order.length; i++){
                    part = order[i];
                    if (part.to > start && part.from <= start) break;
                }
                if (part.to >= end) return inner(builder, text, style, startStyle, endStyle, css, attributes);
                inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
                startStyle = null;
                text = text.slice(part.to - start);
                start = part.to;
            }
        };
    }
    function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
        var widget = !ignoreWidget && marker.widgetNode;
        if (widget) builder.map.push(builder.pos, builder.pos + size, widget);
        if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
            if (!widget) widget = builder.content.appendChild(document.createElement("span"));
            widget.setAttribute("cm-marker", marker.id);
        }
        if (widget) {
            builder.cm.display.input.setUneditable(widget);
            builder.content.appendChild(widget);
        }
        builder.pos += size;
        builder.trailingSpace = false;
    }
    // Outputs a number of spans to make up a line, taking highlighting
    // and marked text into account.
    function insertLineContent(line, builder, styles) {
        var spans = line.markedSpans, allText = line.text, at = 0;
        if (!spans) {
            for(var i$1 = 1; i$1 < styles.length; i$1 += 2)builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1 + 1], builder.cm.options));
            return;
        }
        var len = allText.length, pos = 0, i = 1, text = "", style, css;
        var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, collapsed, attributes;
        for(;;){
            if (nextChange == pos) {
                spanStyle = spanEndStyle = spanStartStyle = css = "";
                attributes = null;
                collapsed = null;
                nextChange = Infinity;
                var foundBookmarks = [], endStyles = void 0;
                for(var j = 0; j < spans.length; ++j){
                    var sp = spans[j], m = sp.marker;
                    if (m.type == "bookmark" && sp.from == pos && m.widgetNode) foundBookmarks.push(m);
                    else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
                        if (sp.to != null && sp.to != pos && nextChange > sp.to) {
                            nextChange = sp.to;
                            spanEndStyle = "";
                        }
                        if (m.className) spanStyle += " " + m.className;
                        if (m.css) css = (css ? css + ";" : "") + m.css;
                        if (m.startStyle && sp.from == pos) spanStartStyle += " " + m.startStyle;
                        if (m.endStyle && sp.to == nextChange) (endStyles || (endStyles = [])).push(m.endStyle, sp.to);
                        // support for the old title property
                        // https://github.com/codemirror/CodeMirror/pull/5673
                        if (m.title) (attributes || (attributes = {})).title = m.title;
                        if (m.attributes) for(var attr in m.attributes)(attributes || (attributes = {}))[attr] = m.attributes[attr];
                        if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0)) collapsed = sp;
                    } else if (sp.from > pos && nextChange > sp.from) nextChange = sp.from;
                }
                if (endStyles) {
                    for(var j$1 = 0; j$1 < endStyles.length; j$1 += 2)if (endStyles[j$1 + 1] == nextChange) spanEndStyle += " " + endStyles[j$1];
                }
                if (!collapsed || collapsed.from == pos) for(var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)buildCollapsedSpan(builder, 0, foundBookmarks[j$2]);
                if (collapsed && (collapsed.from || 0) == pos) {
                    buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos, collapsed.marker, collapsed.from == null);
                    if (collapsed.to == null) return;
                    if (collapsed.to == pos) collapsed = false;
                }
            }
            if (pos >= len) break;
            var upto = Math.min(len, nextChange);
            while(true){
                if (text) {
                    var end = pos + text.length;
                    if (!collapsed) {
                        var tokenText = end > upto ? text.slice(0, upto - pos) : text;
                        builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle, spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
                    }
                    if (end >= upto) {
                        text = text.slice(upto - pos);
                        pos = upto;
                        break;
                    }
                    pos = end;
                    spanStartStyle = "";
                }
                text = allText.slice(at, at = styles[i++]);
                style = interpretTokenStyle(styles[i++], builder.cm.options);
            }
        }
    }
    // These objects are used to represent the visible (currently drawn)
    // part of the document. A LineView may correspond to multiple
    // logical lines, if those are connected by collapsed ranges.
    function LineView(doc, line, lineN) {
        // The starting line
        this.line = line;
        // Continuing lines, if any
        this.rest = visualLineContinued(line);
        // Number of logical lines in this visual line
        this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
        this.node = this.text = null;
        this.hidden = lineIsHidden(doc, line);
    }
    // Create a range of LineView objects for the given lines.
    function buildViewArray(cm, from, to) {
        var array = [], nextPos;
        for(var pos = from; pos < to; pos = nextPos){
            var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
            nextPos = pos + view.size;
            array.push(view);
        }
        return array;
    }
    var operationGroup = null;
    function pushOperation(op) {
        if (operationGroup) operationGroup.ops.push(op);
        else op.ownsGroup = operationGroup = {
            ops: [
                op
            ],
            delayedCallbacks: []
        };
    }
    function fireCallbacksForOps(group) {
        // Calls delayed callbacks and cursorActivity handlers until no
        // new ones appear
        var callbacks = group.delayedCallbacks, i = 0;
        do {
            for(; i < callbacks.length; i++)callbacks[i].call(null);
            for(var j = 0; j < group.ops.length; j++){
                var op = group.ops[j];
                if (op.cursorActivityHandlers) while(op.cursorActivityCalled < op.cursorActivityHandlers.length)op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm);
            }
        }while (i < callbacks.length);
    }
    function finishOperation(op, endCb) {
        var group = op.ownsGroup;
        if (!group) return;
        try {
            fireCallbacksForOps(group);
        } finally{
            operationGroup = null;
            endCb(group);
        }
    }
    var orphanDelayedCallbacks = null;
    // Often, we want to signal events at a point where we are in the
    // middle of some work, but don't want the handler to start calling
    // other methods on the editor, which might be in an inconsistent
    // state or simply not expect any other events to happen.
    // signalLater looks whether there are any handlers, and schedules
    // them to be executed when the last operation ends, or, if no
    // operation is active, when a timeout fires.
    function signalLater(emitter, type /*, values...*/ ) {
        var arr = getHandlers(emitter, type);
        if (!arr.length) return;
        var args = Array.prototype.slice.call(arguments, 2), list;
        if (operationGroup) list = operationGroup.delayedCallbacks;
        else if (orphanDelayedCallbacks) list = orphanDelayedCallbacks;
        else {
            list = orphanDelayedCallbacks = [];
            setTimeout(fireOrphanDelayed, 0);
        }
        var loop = function(i) {
            list.push(function() {
                return arr[i].apply(null, args);
            });
        };
        for(var i = 0; i < arr.length; ++i)loop(i);
    }
    function fireOrphanDelayed() {
        var delayed = orphanDelayedCallbacks;
        orphanDelayedCallbacks = null;
        for(var i = 0; i < delayed.length; ++i)delayed[i]();
    }
    // When an aspect of a line changes, a string is added to
    // lineView.changes. This updates the relevant part of the line's
    // DOM structure.
    function updateLineForChanges(cm, lineView, lineN, dims) {
        for(var j = 0; j < lineView.changes.length; j++){
            var type = lineView.changes[j];
            if (type == "text") updateLineText(cm, lineView);
            else if (type == "gutter") updateLineGutter(cm, lineView, lineN, dims);
            else if (type == "class") updateLineClasses(cm, lineView);
            else if (type == "widget") updateLineWidgets(cm, lineView, dims);
        }
        lineView.changes = null;
    }
    // Lines with gutter elements, widgets or a background class need to
    // be wrapped, and have the extra elements added to the wrapper div
    function ensureLineWrapped(lineView) {
        if (lineView.node == lineView.text) {
            lineView.node = elt("div", null, null, "position: relative");
            if (lineView.text.parentNode) lineView.text.parentNode.replaceChild(lineView.node, lineView.text);
            lineView.node.appendChild(lineView.text);
            if (ie && ie_version < 8) lineView.node.style.zIndex = 2;
        }
        return lineView.node;
    }
    function updateLineBackground(cm, lineView) {
        var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
        if (cls) cls += " CodeMirror-linebackground";
        if (lineView.background) {
            if (cls) lineView.background.className = cls;
            else {
                lineView.background.parentNode.removeChild(lineView.background);
                lineView.background = null;
            }
        } else if (cls) {
            var wrap = ensureLineWrapped(lineView);
            lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
            cm.display.input.setUneditable(lineView.background);
        }
    }
    // Wrapper around buildLineContent which will reuse the structure
    // in display.externalMeasured when possible.
    function getLineContent(cm, lineView) {
        var ext = cm.display.externalMeasured;
        if (ext && ext.line == lineView.line) {
            cm.display.externalMeasured = null;
            lineView.measure = ext.measure;
            return ext.built;
        }
        return buildLineContent(cm, lineView);
    }
    // Redraw the line's text. Interacts with the background and text
    // classes because the mode may output tokens that influence these
    // classes.
    function updateLineText(cm, lineView) {
        var cls = lineView.text.className;
        var built = getLineContent(cm, lineView);
        if (lineView.text == lineView.node) lineView.node = built.pre;
        lineView.text.parentNode.replaceChild(built.pre, lineView.text);
        lineView.text = built.pre;
        if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
            lineView.bgClass = built.bgClass;
            lineView.textClass = built.textClass;
            updateLineClasses(cm, lineView);
        } else if (cls) lineView.text.className = cls;
    }
    function updateLineClasses(cm, lineView) {
        updateLineBackground(cm, lineView);
        if (lineView.line.wrapClass) ensureLineWrapped(lineView).className = lineView.line.wrapClass;
        else if (lineView.node != lineView.text) lineView.node.className = "";
        var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
        lineView.text.className = textClass || "";
    }
    function updateLineGutter(cm, lineView, lineN, dims) {
        if (lineView.gutter) {
            lineView.node.removeChild(lineView.gutter);
            lineView.gutter = null;
        }
        if (lineView.gutterBackground) {
            lineView.node.removeChild(lineView.gutterBackground);
            lineView.gutterBackground = null;
        }
        if (lineView.line.gutterClass) {
            var wrap = ensureLineWrapped(lineView);
            lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass, "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + dims.gutterTotalWidth + "px");
            cm.display.input.setUneditable(lineView.gutterBackground);
            wrap.insertBefore(lineView.gutterBackground, lineView.text);
        }
        var markers = lineView.line.gutterMarkers;
        if (cm.options.lineNumbers || markers) {
            var wrap$1 = ensureLineWrapped(lineView);
            var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px");
            gutterWrap.setAttribute("aria-hidden", "true");
            cm.display.input.setUneditable(gutterWrap);
            wrap$1.insertBefore(gutterWrap, lineView.text);
            if (lineView.line.gutterClass) gutterWrap.className += " " + lineView.line.gutterClass;
            if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"])) lineView.lineNumber = gutterWrap.appendChild(elt("div", lineNumberFor(cm.options, lineN), "CodeMirror-linenumber CodeMirror-gutter-elt", "left: " + dims.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + cm.display.lineNumInnerWidth + "px"));
            if (markers) for(var k = 0; k < cm.display.gutterSpecs.length; ++k){
                var id = cm.display.gutterSpecs[k].className, found = markers.hasOwnProperty(id) && markers[id];
                if (found) gutterWrap.appendChild(elt("div", [
                    found
                ], "CodeMirror-gutter-elt", "left: " + dims.gutterLeft[id] + "px; width: " + dims.gutterWidth[id] + "px"));
            }
        }
    }
    function updateLineWidgets(cm, lineView, dims) {
        if (lineView.alignable) lineView.alignable = null;
        var isWidget = classTest("CodeMirror-linewidget");
        for(var node = lineView.node.firstChild, next = void 0; node; node = next){
            next = node.nextSibling;
            if (isWidget.test(node.className)) lineView.node.removeChild(node);
        }
        insertLineWidgets(cm, lineView, dims);
    }
    // Build a line's DOM representation from scratch
    function buildLineElement(cm, lineView, lineN, dims) {
        var built = getLineContent(cm, lineView);
        lineView.text = lineView.node = built.pre;
        if (built.bgClass) lineView.bgClass = built.bgClass;
        if (built.textClass) lineView.textClass = built.textClass;
        updateLineClasses(cm, lineView);
        updateLineGutter(cm, lineView, lineN, dims);
        insertLineWidgets(cm, lineView, dims);
        return lineView.node;
    }
    // A lineView may contain multiple logical lines (when merged by
    // collapsed spans). The widgets for all of them need to be drawn.
    function insertLineWidgets(cm, lineView, dims) {
        insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
        if (lineView.rest) for(var i = 0; i < lineView.rest.length; i++)insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false);
    }
    function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
        if (!line.widgets) return;
        var wrap = ensureLineWrapped(lineView);
        for(var i = 0, ws = line.widgets; i < ws.length; ++i){
            var widget = ws[i], node = elt("div", [
                widget.node
            ], "CodeMirror-linewidget" + (widget.className ? " " + widget.className : ""));
            if (!widget.handleMouseEvents) node.setAttribute("cm-ignore-events", "true");
            positionLineWidget(widget, node, lineView, dims);
            cm.display.input.setUneditable(node);
            if (allowAbove && widget.above) wrap.insertBefore(node, lineView.gutter || lineView.text);
            else wrap.appendChild(node);
            signalLater(widget, "redraw");
        }
    }
    function positionLineWidget(widget, node, lineView, dims) {
        if (widget.noHScroll) {
            (lineView.alignable || (lineView.alignable = [])).push(node);
            var width = dims.wrapperWidth;
            node.style.left = dims.fixedPos + "px";
            if (!widget.coverGutter) {
                width -= dims.gutterTotalWidth;
                node.style.paddingLeft = dims.gutterTotalWidth + "px";
            }
            node.style.width = width + "px";
        }
        if (widget.coverGutter) {
            node.style.zIndex = 5;
            node.style.position = "relative";
            if (!widget.noHScroll) node.style.marginLeft = -dims.gutterTotalWidth + "px";
        }
    }
    function widgetHeight(widget) {
        if (widget.height != null) return widget.height;
        var cm = widget.doc.cm;
        if (!cm) return 0;
        if (!contains(document.body, widget.node)) {
            var parentStyle = "position: relative;";
            if (widget.coverGutter) parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;";
            if (widget.noHScroll) parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;";
            removeChildrenAndAdd(cm.display.measure, elt("div", [
                widget.node
            ], null, parentStyle));
        }
        return widget.height = widget.node.parentNode.offsetHeight;
    }
    // Return true when the given mouse event happened in a widget
    function eventInWidget(display, e) {
        for(var n = e_target(e); n != display.wrapper; n = n.parentNode){
            if (!n || n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true" || n.parentNode == display.sizer && n != display.mover) return true;
        }
    }
    // POSITION MEASUREMENT
    function paddingTop(display) {
        return display.lineSpace.offsetTop;
    }
    function paddingVert(display) {
        return display.mover.offsetHeight - display.lineSpace.offsetHeight;
    }
    function paddingH(display) {
        if (display.cachedPaddingH) return display.cachedPaddingH;
        var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
        var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
        var data = {
            left: parseInt(style.paddingLeft),
            right: parseInt(style.paddingRight)
        };
        if (!isNaN(data.left) && !isNaN(data.right)) display.cachedPaddingH = data;
        return data;
    }
    function scrollGap(cm) {
        return scrollerGap - cm.display.nativeBarWidth;
    }
    function displayWidth(cm) {
        return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth;
    }
    function displayHeight(cm) {
        return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight;
    }
    // Ensure the lineView.wrapping.heights array is populated. This is
    // an array of bottom offsets for the lines that make up a drawn
    // line. When lineWrapping is on, there might be more than one
    // height.
    function ensureLineHeights(cm, lineView, rect) {
        var wrapping = cm.options.lineWrapping;
        var curWidth = wrapping && displayWidth(cm);
        if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
            var heights = lineView.measure.heights = [];
            if (wrapping) {
                lineView.measure.width = curWidth;
                var rects = lineView.text.firstChild.getClientRects();
                for(var i = 0; i < rects.length - 1; i++){
                    var cur = rects[i], next = rects[i + 1];
                    if (Math.abs(cur.bottom - next.bottom) > 2) heights.push((cur.bottom + next.top) / 2 - rect.top);
                }
            }
            heights.push(rect.bottom - rect.top);
        }
    }
    // Find a line map (mapping character offsets to text nodes) and a
    // measurement cache for the given line number. (A line view might
    // contain multiple lines when collapsed ranges are present.)
    function mapFromLineView(lineView, line, lineN) {
        if (lineView.line == line) return {
            map: lineView.measure.map,
            cache: lineView.measure.cache
        };
        if (lineView.rest) {
            for(var i = 0; i < lineView.rest.length; i++){
                if (lineView.rest[i] == line) return {
                    map: lineView.measure.maps[i],
                    cache: lineView.measure.caches[i]
                };
            }
            for(var i$1 = 0; i$1 < lineView.rest.length; i$1++){
                if (lineNo(lineView.rest[i$1]) > lineN) return {
                    map: lineView.measure.maps[i$1],
                    cache: lineView.measure.caches[i$1],
                    before: true
                };
            }
        }
    }
    // Render a line into the hidden node display.externalMeasured. Used
    // when measurement is needed for a line that's not in the viewport.
    function updateExternalMeasurement(cm, line) {
        line = visualLine(line);
        var lineN = lineNo(line);
        var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
        view.lineN = lineN;
        var built = view.built = buildLineContent(cm, view);
        view.text = built.pre;
        removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
        return view;
    }
    // Get a {top, bottom, left, right} box (in line-local coordinates)
    // for a given character.
    function measureChar(cm, line, ch, bias) {
        return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias);
    }
    // Find a line view that corresponds to the given line number.
    function findViewForLine(cm, lineN) {
        if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo) return cm.display.view[findViewIndex(cm, lineN)];
        var ext = cm.display.externalMeasured;
        if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size) return ext;
    }
    // Measurement can be split in two steps, the set-up work that
    // applies to the whole line, and the measurement of the actual
    // character. Functions like coordsChar, that need to do a lot of
    // measurements in a row, can thus ensure that the set-up work is
    // only done once.
    function prepareMeasureForLine(cm, line) {
        var lineN = lineNo(line);
        var view = findViewForLine(cm, lineN);
        if (view && !view.text) view = null;
        else if (view && view.changes) {
            updateLineForChanges(cm, view, lineN, getDimensions(cm));
            cm.curOp.forceUpdate = true;
        }
        if (!view) view = updateExternalMeasurement(cm, line);
        var info = mapFromLineView(view, line, lineN);
        return {
            line: line,
            view: view,
            rect: null,
            map: info.map,
            cache: info.cache,
            before: info.before,
            hasHeights: false
        };
    }
    // Given a prepared measurement object, measures the position of an
    // actual character (or fetches it from the cache).
    function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
        if (prepared.before) ch = -1;
        var key = ch + (bias || ""), found;
        if (prepared.cache.hasOwnProperty(key)) found = prepared.cache[key];
        else {
            if (!prepared.rect) prepared.rect = prepared.view.text.getBoundingClientRect();
            if (!prepared.hasHeights) {
                ensureLineHeights(cm, prepared.view, prepared.rect);
                prepared.hasHeights = true;
            }
            found = measureCharInner(cm, prepared, ch, bias);
            if (!found.bogus) prepared.cache[key] = found;
        }
        return {
            left: found.left,
            right: found.right,
            top: varHeight ? found.rtop : found.top,
            bottom: varHeight ? found.rbottom : found.bottom
        };
    }
    var nullRect = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    function nodeAndOffsetInLineMap(map, ch, bias) {
        var node, start, end, collapse, mStart, mEnd;
        // First, search the line map for the text node corresponding to,
        // or closest to, the target character.
        for(var i = 0; i < map.length; i += 3){
            mStart = map[i];
            mEnd = map[i + 1];
            if (ch < mStart) {
                start = 0;
                end = 1;
                collapse = "left";
            } else if (ch < mEnd) {
                start = ch - mStart;
                end = start + 1;
            } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
                end = mEnd - mStart;
                start = end - 1;
                if (ch >= mEnd) collapse = "right";
            }
            if (start != null) {
                node = map[i + 2];
                if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right")) collapse = bias;
                if (bias == "left" && start == 0) while(i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft){
                    node = map[(i -= 3) + 2];
                    collapse = "left";
                }
                if (bias == "right" && start == mEnd - mStart) while(i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft){
                    node = map[(i += 3) + 2];
                    collapse = "right";
                }
                break;
            }
        }
        return {
            node: node,
            start: start,
            end: end,
            collapse: collapse,
            coverStart: mStart,
            coverEnd: mEnd
        };
    }
    function getUsefulRect(rects, bias) {
        var rect = nullRect;
        if (bias == "left") for(var i = 0; i < rects.length; i++){
            if ((rect = rects[i]).left != rect.right) break;
        }
        else for(var i$1 = rects.length - 1; i$1 >= 0; i$1--){
            if ((rect = rects[i$1]).left != rect.right) break;
        }
        return rect;
    }
    function measureCharInner(cm, prepared, ch, bias) {
        var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
        var node = place.node, start = place.start, end = place.end, collapse = place.collapse;
        var rect;
        if (node.nodeType == 3) {
            for(var i$1 = 0; i$1 < 4; i$1++){
                while(start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start)))--start;
                while(place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end)))++end;
                if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart) rect = node.parentNode.getBoundingClientRect();
                else rect = getUsefulRect(range(node, start, end).getClientRects(), bias);
                if (rect.left || rect.right || start == 0) break;
                end = start;
                start = start - 1;
                collapse = "right";
            }
            if (ie && ie_version < 11) rect = maybeUpdateRectForZooming(cm.display.measure, rect);
        } else {
            if (start > 0) collapse = bias = "right";
            var rects;
            if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1) rect = rects[bias == "right" ? rects.length - 1 : 0];
            else rect = node.getBoundingClientRect();
        }
        if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
            var rSpan = node.parentNode.getClientRects()[0];
            if (rSpan) rect = {
                left: rSpan.left,
                right: rSpan.left + charWidth(cm.display),
                top: rSpan.top,
                bottom: rSpan.bottom
            };
            else rect = nullRect;
        }
        var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
        var mid = (rtop + rbot) / 2;
        var heights = prepared.view.measure.heights;
        var i = 0;
        for(; i < heights.length - 1; i++){
            if (mid < heights[i]) break;
        }
        var top = i ? heights[i - 1] : 0, bot = heights[i];
        var result = {
            left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
            right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
            top: top,
            bottom: bot
        };
        if (!rect.left && !rect.right) result.bogus = true;
        if (!cm.options.singleCursorHeightPerLine) {
            result.rtop = rtop;
            result.rbottom = rbot;
        }
        return result;
    }
    // Work around problem with bounding client rects on ranges being
    // returned incorrectly when zoomed on IE10 and below.
    function maybeUpdateRectForZooming(measure, rect) {
        if (!window.screen || screen.logicalXDPI == null || screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure)) return rect;
        var scaleX = screen.logicalXDPI / screen.deviceXDPI;
        var scaleY = screen.logicalYDPI / screen.deviceYDPI;
        return {
            left: rect.left * scaleX,
            right: rect.right * scaleX,
            top: rect.top * scaleY,
            bottom: rect.bottom * scaleY
        };
    }
    function clearLineMeasurementCacheFor(lineView) {
        if (lineView.measure) {
            lineView.measure.cache = {};
            lineView.measure.heights = null;
            if (lineView.rest) for(var i = 0; i < lineView.rest.length; i++)lineView.measure.caches[i] = {};
        }
    }
    function clearLineMeasurementCache(cm) {
        cm.display.externalMeasure = null;
        removeChildren(cm.display.lineMeasure);
        for(var i = 0; i < cm.display.view.length; i++)clearLineMeasurementCacheFor(cm.display.view[i]);
    }
    function clearCaches(cm) {
        clearLineMeasurementCache(cm);
        cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
        if (!cm.options.lineWrapping) cm.display.maxLineChanged = true;
        cm.display.lineNumChars = null;
    }
    function pageScrollX(doc) {
        // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
        // which causes page_Offset and bounding client rects to use
        // different reference viewports and invalidate our calculations.
        if (chrome && android) return -(doc.body.getBoundingClientRect().left - parseInt(getComputedStyle(doc.body).marginLeft));
        return doc.defaultView.pageXOffset || (doc.documentElement || doc.body).scrollLeft;
    }
    function pageScrollY(doc) {
        if (chrome && android) return -(doc.body.getBoundingClientRect().top - parseInt(getComputedStyle(doc.body).marginTop));
        return doc.defaultView.pageYOffset || (doc.documentElement || doc.body).scrollTop;
    }
    function widgetTopHeight(lineObj) {
        var ref = visualLine(lineObj);
        var widgets = ref.widgets;
        var height = 0;
        if (widgets) {
            for(var i = 0; i < widgets.length; ++i)if (widgets[i].above) height += widgetHeight(widgets[i]);
        }
        return height;
    }
    // Converts a {top, bottom, left, right} box from line-local
    // coordinates into another coordinate system. Context may be one of
    // "line", "div" (display.lineDiv), "local"./null (editor), "window",
    // or "page".
    function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
        if (!includeWidgets) {
            var height = widgetTopHeight(lineObj);
            rect.top += height;
            rect.bottom += height;
        }
        if (context == "line") return rect;
        if (!context) context = "local";
        var yOff = heightAtLine(lineObj);
        if (context == "local") yOff += paddingTop(cm.display);
        else yOff -= cm.display.viewOffset;
        if (context == "page" || context == "window") {
            var lOff = cm.display.lineSpace.getBoundingClientRect();
            yOff += lOff.top + (context == "window" ? 0 : pageScrollY(doc(cm)));
            var xOff = lOff.left + (context == "window" ? 0 : pageScrollX(doc(cm)));
            rect.left += xOff;
            rect.right += xOff;
        }
        rect.top += yOff;
        rect.bottom += yOff;
        return rect;
    }
    // Coverts a box from "div" coords to another coordinate system.
    // Context may be "window", "page", "div", or "local"./null.
    function fromCoordSystem(cm, coords, context) {
        if (context == "div") return coords;
        var left = coords.left, top = coords.top;
        // First move into "page" coordinate system
        if (context == "page") {
            left -= pageScrollX(doc(cm));
            top -= pageScrollY(doc(cm));
        } else if (context == "local" || !context) {
            var localBox = cm.display.sizer.getBoundingClientRect();
            left += localBox.left;
            top += localBox.top;
        }
        var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
        return {
            left: left - lineSpaceBox.left,
            top: top - lineSpaceBox.top
        };
    }
    function charCoords(cm, pos, context, lineObj, bias) {
        if (!lineObj) lineObj = getLine(cm.doc, pos.line);
        return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context);
    }
    // Returns a box for a given cursor position, which may have an
    // 'other' property containing the position of the secondary cursor
    // on a bidi boundary.
    // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
    // and after `char - 1` in writing order of `char - 1`
    // A cursor Pos(line, char, "after") is on the same visual line as `char`
    // and before `char` in writing order of `char`
    // Examples (upper-case letters are RTL, lower-case are LTR):
    //     Pos(0, 1, ...)
    //     before   after
    // ab     a|b     a|b
    // aB     a|B     aB|
    // Ab     |Ab     A|b
    // AB     B|A     B|A
    // Every position after the last character on a line is considered to stick
    // to the last character on the line.
    function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
        lineObj = lineObj || getLine(cm.doc, pos.line);
        if (!preparedMeasure) preparedMeasure = prepareMeasureForLine(cm, lineObj);
        function get(ch, right) {
            var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
            if (right) m.left = m.right;
            else m.right = m.left;
            return intoCoordSystem(cm, lineObj, m, context);
        }
        var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
        if (ch >= lineObj.text.length) {
            ch = lineObj.text.length;
            sticky = "before";
        } else if (ch <= 0) {
            ch = 0;
            sticky = "after";
        }
        if (!order) return get(sticky == "before" ? ch - 1 : ch, sticky == "before");
        function getBidi(ch, partPos, invert) {
            var part = order[partPos], right = part.level == 1;
            return get(invert ? ch - 1 : ch, right != invert);
        }
        var partPos = getBidiPartAt(order, ch, sticky);
        var other = bidiOther;
        var val = getBidi(ch, partPos, sticky == "before");
        if (other != null) val.other = getBidi(ch, other, sticky != "before");
        return val;
    }
    // Used to cheaply estimate the coordinates for a position. Used for
    // intermediate scroll updates.
    function estimateCoords(cm, pos) {
        var left = 0;
        pos = clipPos(cm.doc, pos);
        if (!cm.options.lineWrapping) left = charWidth(cm.display) * pos.ch;
        var lineObj = getLine(cm.doc, pos.line);
        var top = heightAtLine(lineObj) + paddingTop(cm.display);
        return {
            left: left,
            right: left,
            top: top,
            bottom: top + lineObj.height
        };
    }
    // Positions returned by coordsChar contain some extra information.
    // xRel is the relative x position of the input coordinates compared
    // to the found position (so xRel > 0 means the coordinates are to
    // the right of the character position, for example). When outside
    // is true, that means the coordinates lie outside the line's
    // vertical range.
    function PosWithInfo(line, ch, sticky, outside, xRel) {
        var pos = Pos(line, ch, sticky);
        pos.xRel = xRel;
        if (outside) pos.outside = outside;
        return pos;
    }
    // Compute the character position closest to the given coordinates.
    // Input must be lineSpace-local ("div" coordinate system).
    function coordsChar(cm, x, y) {
        var doc = cm.doc;
        y += cm.display.viewOffset;
        if (y < 0) return PosWithInfo(doc.first, 0, null, -1, -1);
        var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
        if (lineN > last) return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, 1, 1);
        if (x < 0) x = 0;
        var lineObj = getLine(doc, lineN);
        for(;;){
            var found = coordsCharInner(cm, lineObj, lineN, x, y);
            var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
            if (!collapsed) return found;
            var rangeEnd = collapsed.find(1);
            if (rangeEnd.line == lineN) return rangeEnd;
            lineObj = getLine(doc, lineN = rangeEnd.line);
        }
    }
    function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
        y -= widgetTopHeight(lineObj);
        var end = lineObj.text.length;
        var begin = findFirst(function(ch) {
            return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y;
        }, end, 0);
        end = findFirst(function(ch) {
            return measureCharPrepared(cm, preparedMeasure, ch).top > y;
        }, begin, end);
        return {
            begin: begin,
            end: end
        };
    }
    function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
        if (!preparedMeasure) preparedMeasure = prepareMeasureForLine(cm, lineObj);
        var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
        return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop);
    }
    // Returns true if the given side of a box is after the given
    // coordinates, in top-to-bottom, left-to-right order.
    function boxIsAfter(box, x, y, left) {
        return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x;
    }
    function coordsCharInner(cm, lineObj, lineNo, x, y) {
        // Move y into line-local coordinate space
        y -= heightAtLine(lineObj);
        var preparedMeasure = prepareMeasureForLine(cm, lineObj);
        // When directly calling `measureCharPrepared`, we have to adjust
        // for the widgets at this line.
        var widgetHeight = widgetTopHeight(lineObj);
        var begin = 0, end = lineObj.text.length, ltr = true;
        var order = getOrder(lineObj, cm.doc.direction);
        // If the line isn't plain left-to-right text, first figure out
        // which bidi section the coordinates fall into.
        if (order) {
            var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)(cm, lineObj, lineNo, preparedMeasure, order, x, y);
            ltr = part.level != 1;
            // The awkward -1 offsets are needed because findFirst (called
            // on these below) will treat its first bound as inclusive,
            // second as exclusive, but we want to actually address the
            // characters in the part's range
            begin = ltr ? part.from : part.to - 1;
            end = ltr ? part.to : part.from - 1;
        }
        // A binary search to find the first character whose bounding box
        // starts after the coordinates. If we run across any whose box wrap
        // the coordinates, store that.
        var chAround = null, boxAround = null;
        var ch = findFirst(function(ch) {
            var box = measureCharPrepared(cm, preparedMeasure, ch);
            box.top += widgetHeight;
            box.bottom += widgetHeight;
            if (!boxIsAfter(box, x, y, false)) return false;
            if (box.top <= y && box.left <= x) {
                chAround = ch;
                boxAround = box;
            }
            return true;
        }, begin, end);
        var baseX, sticky, outside = false;
        // If a box around the coordinates was found, use that
        if (boxAround) {
            // Distinguish coordinates nearer to the left or right side of the box
            var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
            ch = chAround + (atStart ? 0 : 1);
            sticky = atStart ? "after" : "before";
            baseX = atLeft ? boxAround.left : boxAround.right;
        } else {
            // (Adjust for extended bound, if necessary.)
            if (!ltr && (ch == end || ch == begin)) ch++;
            // To determine which side to associate with, get the box to the
            // left of the character and compare it's vertical position to the
            // coordinates
            sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" : measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight <= y == ltr ? "after" : "before";
            // Now get accurate coordinates for this place, in order to get a
            // base X position
            var coords = cursorCoords(cm, Pos(lineNo, ch, sticky), "line", lineObj, preparedMeasure);
            baseX = coords.left;
            outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
        }
        ch = skipExtendingChars(lineObj.text, ch, 1);
        return PosWithInfo(lineNo, ch, sticky, outside, x - baseX);
    }
    function coordsBidiPart(cm, lineObj, lineNo, preparedMeasure, order, x, y) {
        // Bidi parts are sorted left-to-right, and in a non-line-wrapping
        // situation, we can take this ordering to correspond to the visual
        // ordering. This finds the first part whose end is after the given
        // coordinates.
        var index = findFirst(function(i) {
            var part = order[i], ltr = part.level != 1;
            return boxIsAfter(cursorCoords(cm, Pos(lineNo, ltr ? part.to : part.from, ltr ? "before" : "after"), "line", lineObj, preparedMeasure), x, y, true);
        }, 0, order.length - 1);
        var part = order[index];
        // If this isn't the first part, the part's start is also after
        // the coordinates, and the coordinates aren't on the same line as
        // that start, move one part back.
        if (index > 0) {
            var ltr = part.level != 1;
            var start = cursorCoords(cm, Pos(lineNo, ltr ? part.from : part.to, ltr ? "after" : "before"), "line", lineObj, preparedMeasure);
            if (boxIsAfter(start, x, y, true) && start.top > y) part = order[index - 1];
        }
        return part;
    }
    function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
        // In a wrapped line, rtl text on wrapping boundaries can do things
        // that don't correspond to the ordering in our `order` array at
        // all, so a binary search doesn't work, and we want to return a
        // part that only spans one line so that the binary search in
        // coordsCharInner is safe. As such, we first find the extent of the
        // wrapped line, and then do a flat search in which we discard any
        // spans that aren't on the line.
        var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
        var begin = ref.begin;
        var end = ref.end;
        if (/\s/.test(lineObj.text.charAt(end - 1))) end--;
        var part = null, closestDist = null;
        for(var i = 0; i < order.length; i++){
            var p = order[i];
            if (p.from >= end || p.to <= begin) continue;
            var ltr = p.level != 1;
            var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
            // Weigh against spans ending before this, so that they are only
            // picked if nothing ends after
            var dist = endX < x ? x - endX + 1e9 : endX - x;
            if (!part || closestDist > dist) {
                part = p;
                closestDist = dist;
            }
        }
        if (!part) part = order[order.length - 1];
        // Clip the part to the wrapped line.
        if (part.from < begin) part = {
            from: begin,
            to: part.to,
            level: part.level
        };
        if (part.to > end) part = {
            from: part.from,
            to: end,
            level: part.level
        };
        return part;
    }
    var measureText;
    // Compute the default text height.
    function textHeight(display) {
        if (display.cachedTextHeight != null) return display.cachedTextHeight;
        if (measureText == null) {
            measureText = elt("pre", null, "CodeMirror-line-like");
            // Measure a bunch of lines, for browsers that compute
            // fractional heights.
            for(var i = 0; i < 49; ++i){
                measureText.appendChild(document.createTextNode("x"));
                measureText.appendChild(elt("br"));
            }
            measureText.appendChild(document.createTextNode("x"));
        }
        removeChildrenAndAdd(display.measure, measureText);
        var height = measureText.offsetHeight / 50;
        if (height > 3) display.cachedTextHeight = height;
        removeChildren(display.measure);
        return height || 1;
    }
    // Compute the default character width.
    function charWidth(display) {
        if (display.cachedCharWidth != null) return display.cachedCharWidth;
        var anchor = elt("span", "xxxxxxxxxx");
        var pre = elt("pre", [
            anchor
        ], "CodeMirror-line-like");
        removeChildrenAndAdd(display.measure, pre);
        var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
        if (width > 2) display.cachedCharWidth = width;
        return width || 10;
    }
    // Do a bulk-read of the DOM positions and sizes needed to draw the
    // view, so that we don't interleave reading and writing to the DOM.
    function getDimensions(cm) {
        var d = cm.display, left = {}, width = {};
        var gutterLeft = d.gutters.clientLeft;
        for(var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i){
            var id = cm.display.gutterSpecs[i].className;
            left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
            width[id] = n.clientWidth;
        }
        return {
            fixedPos: compensateForHScroll(d),
            gutterTotalWidth: d.gutters.offsetWidth,
            gutterLeft: left,
            gutterWidth: width,
            wrapperWidth: d.wrapper.clientWidth
        };
    }
    // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
    // but using getBoundingClientRect to get a sub-pixel-accurate
    // result.
    function compensateForHScroll(display) {
        return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left;
    }
    // Returns a function that estimates the height of a line, to use as
    // first approximation until the line becomes visible (and is thus
    // properly measurable).
    function estimateHeight(cm) {
        var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
        var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
        return function(line) {
            if (lineIsHidden(cm.doc, line)) return 0;
            var widgetsHeight = 0;
            if (line.widgets) {
                for(var i = 0; i < line.widgets.length; i++)if (line.widgets[i].height) widgetsHeight += line.widgets[i].height;
            }
            if (wrapping) return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th;
            else return widgetsHeight + th;
        };
    }
    function estimateLineHeights(cm) {
        var doc = cm.doc, est = estimateHeight(cm);
        doc.iter(function(line) {
            var estHeight = est(line);
            if (estHeight != line.height) updateLineHeight(line, estHeight);
        });
    }
    // Given a mouse event, find the corresponding position. If liberal
    // is false, it checks whether a gutter or scrollbar was clicked,
    // and returns null if it was. forRect is used by rectangular
    // selections, and tries to estimate a character position even for
    // coordinates beyond the right of the text.
    function posFromMouse(cm, e, liberal, forRect) {
        var display = cm.display;
        if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") return null;
        var x, y, space = display.lineSpace.getBoundingClientRect();
        // Fails unpredictably on IE[67] when mouse is dragged around quickly.
        try {
            x = e.clientX - space.left;
            y = e.clientY - space.top;
        } catch (e$1) {
            return null;
        }
        var coords = coordsChar(cm, x, y), line;
        if (forRect && coords.xRel > 0 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
            var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
            coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
        }
        return coords;
    }
    // Find the view element corresponding to a given line. Return null
    // when the line isn't visible.
    function findViewIndex(cm, n) {
        if (n >= cm.display.viewTo) return null;
        n -= cm.display.viewFrom;
        if (n < 0) return null;
        var view = cm.display.view;
        for(var i = 0; i < view.length; i++){
            n -= view[i].size;
            if (n < 0) return i;
        }
    }
    // Updates the display.view data structure for a given change to the
    // document. From and to are in pre-change coordinates. Lendiff is
    // the amount of lines added or subtracted by the change. This is
    // used for changes that span multiple lines, or change the way
    // lines are divided into visual lines. regLineChange (below)
    // registers single-line changes.
    function regChange(cm, from, to, lendiff) {
        if (from == null) from = cm.doc.first;
        if (to == null) to = cm.doc.first + cm.doc.size;
        if (!lendiff) lendiff = 0;
        var display = cm.display;
        if (lendiff && to < display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers > from)) display.updateLineNumbers = from;
        cm.curOp.viewChanged = true;
        if (from >= display.viewTo) {
            if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo) resetView(cm);
        } else if (to <= display.viewFrom) {
            if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) resetView(cm);
            else {
                display.viewFrom += lendiff;
                display.viewTo += lendiff;
            }
        } else if (from <= display.viewFrom && to >= display.viewTo) resetView(cm);
        else if (from <= display.viewFrom) {
            var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
            if (cut) {
                display.view = display.view.slice(cut.index);
                display.viewFrom = cut.lineN;
                display.viewTo += lendiff;
            } else resetView(cm);
        } else if (to >= display.viewTo) {
            var cut$1 = viewCuttingPoint(cm, from, from, -1);
            if (cut$1) {
                display.view = display.view.slice(0, cut$1.index);
                display.viewTo = cut$1.lineN;
            } else resetView(cm);
        } else {
            var cutTop = viewCuttingPoint(cm, from, from, -1);
            var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
            if (cutTop && cutBot) {
                display.view = display.view.slice(0, cutTop.index).concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN)).concat(display.view.slice(cutBot.index));
                display.viewTo += lendiff;
            } else resetView(cm);
        }
        var ext = display.externalMeasured;
        if (ext) {
            if (to < ext.lineN) ext.lineN += lendiff;
            else if (from < ext.lineN + ext.size) display.externalMeasured = null;
        }
    }
    // Register a change to a single line. Type must be one of "text",
    // "gutter", "class", "widget"
    function regLineChange(cm, line, type) {
        cm.curOp.viewChanged = true;
        var display = cm.display, ext = cm.display.externalMeasured;
        if (ext && line >= ext.lineN && line < ext.lineN + ext.size) display.externalMeasured = null;
        if (line < display.viewFrom || line >= display.viewTo) return;
        var lineView = display.view[findViewIndex(cm, line)];
        if (lineView.node == null) return;
        var arr = lineView.changes || (lineView.changes = []);
        if (indexOf(arr, type) == -1) arr.push(type);
    }
    // Clear the view.
    function resetView(cm) {
        cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
        cm.display.view = [];
        cm.display.viewOffset = 0;
    }
    function viewCuttingPoint(cm, oldN, newN, dir) {
        var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
        if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size) return {
            index: index,
            lineN: newN
        };
        var n = cm.display.viewFrom;
        for(var i = 0; i < index; i++)n += view[i].size;
        if (n != oldN) {
            if (dir > 0) {
                if (index == view.length - 1) return null;
                diff = n + view[index].size - oldN;
                index++;
            } else diff = n - oldN;
            oldN += diff;
            newN += diff;
        }
        while(visualLineNo(cm.doc, newN) != newN){
            if (index == (dir < 0 ? 0 : view.length - 1)) return null;
            newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
            index += dir;
        }
        return {
            index: index,
            lineN: newN
        };
    }
    // Force the view to cover a given range, adding empty view element
    // or clipping off existing ones as needed.
    function adjustView(cm, from, to) {
        var display = cm.display, view = display.view;
        if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
            display.view = buildViewArray(cm, from, to);
            display.viewFrom = from;
        } else {
            if (display.viewFrom > from) display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view);
            else if (display.viewFrom < from) display.view = display.view.slice(findViewIndex(cm, from));
            display.viewFrom = from;
            if (display.viewTo < to) display.view = display.view.concat(buildViewArray(cm, display.viewTo, to));
            else if (display.viewTo > to) display.view = display.view.slice(0, findViewIndex(cm, to));
        }
        display.viewTo = to;
    }
    // Count the number of lines in the view whose DOM representation is
    // out of date (or nonexistent).
    function countDirtyView(cm) {
        var view = cm.display.view, dirty = 0;
        for(var i = 0; i < view.length; i++){
            var lineView = view[i];
            if (!lineView.hidden && (!lineView.node || lineView.changes)) ++dirty;
        }
        return dirty;
    }
    function updateSelection(cm) {
        cm.display.input.showSelection(cm.display.input.prepareSelection());
    }
    function prepareSelection(cm, primary) {
        if (primary === void 0) primary = true;
        var doc = cm.doc, result = {};
        var curFragment = result.cursors = document.createDocumentFragment();
        var selFragment = result.selection = document.createDocumentFragment();
        var customCursor = cm.options.$customCursor;
        if (customCursor) primary = true;
        for(var i = 0; i < doc.sel.ranges.length; i++){
            if (!primary && i == doc.sel.primIndex) continue;
            var range = doc.sel.ranges[i];
            if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) continue;
            var collapsed = range.empty();
            if (customCursor) {
                var head = customCursor(cm, range);
                if (head) drawSelectionCursor(cm, head, curFragment);
            } else if (collapsed || cm.options.showCursorWhenSelecting) drawSelectionCursor(cm, range.head, curFragment);
            if (!collapsed) drawSelectionRange(cm, range, selFragment);
        }
        return result;
    }
    // Draws a cursor for the given range
    function drawSelectionCursor(cm, head, output) {
        var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);
        var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"));
        cursor.style.left = pos.left + "px";
        cursor.style.top = pos.top + "px";
        cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";
        if (/\bcm-fat-cursor\b/.test(cm.getWrapperElement().className)) {
            var charPos = charCoords(cm, head, "div", null, null);
            var width = charPos.right - charPos.left;
            cursor.style.width = (width > 0 ? width : cm.defaultCharWidth()) + "px";
        }
        if (pos.other) {
            // Secondary cursor, shown when on a 'jump' in bi-directional text
            var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"));
            otherCursor.style.display = "";
            otherCursor.style.left = pos.other.left + "px";
            otherCursor.style.top = pos.other.top + "px";
            otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
        }
    }
    function cmpCoords(a, b) {
        return a.top - b.top || a.left - b.left;
    }
    // Draws the given range as a highlighted selection
    function drawSelectionRange(cm, range, output) {
        var display = cm.display, doc = cm.doc;
        var fragment = document.createDocumentFragment();
        var padding = paddingH(cm.display), leftSide = padding.left;
        var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
        var docLTR = doc.direction == "ltr";
        function add(left, top, width, bottom) {
            if (top < 0) top = 0;
            top = Math.round(top);
            bottom = Math.round(bottom);
            fragment.appendChild(elt("div", null, "CodeMirror-selected", "position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px"));
        }
        function drawForLine(line, fromArg, toArg) {
            var lineObj = getLine(doc, line);
            var lineLen = lineObj.text.length;
            var start, end;
            function coords(ch, bias) {
                return charCoords(cm, Pos(line, ch), "div", lineObj, bias);
            }
            function wrapX(pos, dir, side) {
                var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
                var prop = dir == "ltr" == (side == "after") ? "left" : "right";
                var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
                return coords(ch, prop)[prop];
            }
            var order = getOrder(lineObj, doc.direction);
            iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function(from, to, dir, i) {
                var ltr = dir == "ltr";
                var fromPos = coords(from, ltr ? "left" : "right");
                var toPos = coords(to - 1, ltr ? "right" : "left");
                var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
                var first = i == 0, last = !order || i == order.length - 1;
                if (toPos.top - fromPos.top <= 3) {
                    var openLeft = (docLTR ? openStart : openEnd) && first;
                    var openRight = (docLTR ? openEnd : openStart) && last;
                    var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
                    var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
                    add(left, fromPos.top, right - left, fromPos.bottom);
                } else {
                    var topLeft, topRight, botLeft, botRight;
                    if (ltr) {
                        topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
                        topRight = docLTR ? rightSide : wrapX(from, dir, "before");
                        botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
                        botRight = docLTR && openEnd && last ? rightSide : toPos.right;
                    } else {
                        topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
                        topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
                        botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
                        botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
                    }
                    add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
                    if (fromPos.bottom < toPos.top) add(leftSide, fromPos.bottom, null, toPos.top);
                    add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
                }
                if (!start || cmpCoords(fromPos, start) < 0) start = fromPos;
                if (cmpCoords(toPos, start) < 0) start = toPos;
                if (!end || cmpCoords(fromPos, end) < 0) end = fromPos;
                if (cmpCoords(toPos, end) < 0) end = toPos;
            });
            return {
                start: start,
                end: end
            };
        }
        var sFrom = range.from(), sTo = range.to();
        if (sFrom.line == sTo.line) drawForLine(sFrom.line, sFrom.ch, sTo.ch);
        else {
            var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
            var singleVLine = visualLine(fromLine) == visualLine(toLine);
            var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
            var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
            if (singleVLine) {
                if (leftEnd.top < rightStart.top - 2) {
                    add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
                    add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
                } else add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
            }
            if (leftEnd.bottom < rightStart.top) add(leftSide, leftEnd.bottom, null, rightStart.top);
        }
        output.appendChild(fragment);
    }
    // Cursor-blinking
    function restartBlink(cm) {
        if (!cm.state.focused) return;
        var display = cm.display;
        clearInterval(display.blinker);
        var on = true;
        display.cursorDiv.style.visibility = "";
        if (cm.options.cursorBlinkRate > 0) display.blinker = setInterval(function() {
            if (!cm.hasFocus()) onBlur(cm);
            display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden";
        }, cm.options.cursorBlinkRate);
        else if (cm.options.cursorBlinkRate < 0) display.cursorDiv.style.visibility = "hidden";
    }
    function ensureFocus(cm) {
        if (!cm.hasFocus()) {
            cm.display.input.focus();
            if (!cm.state.focused) onFocus(cm);
        }
    }
    function delayBlurEvent(cm) {
        cm.state.delayingBlurEvent = true;
        setTimeout(function() {
            if (cm.state.delayingBlurEvent) {
                cm.state.delayingBlurEvent = false;
                if (cm.state.focused) onBlur(cm);
            }
        }, 100);
    }
    function onFocus(cm, e) {
        if (cm.state.delayingBlurEvent && !cm.state.draggingText) cm.state.delayingBlurEvent = false;
        if (cm.options.readOnly == "nocursor") return;
        if (!cm.state.focused) {
            signal(cm, "focus", cm, e);
            cm.state.focused = true;
            addClass(cm.display.wrapper, "CodeMirror-focused");
            // This test prevents this from firing when a context
            // menu is closed (since the input reset would kill the
            // select-all detection hack)
            if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
                cm.display.input.reset();
                if (webkit) setTimeout(function() {
                    return cm.display.input.reset(true);
                }, 20);
                 // Issue #1730
            }
            cm.display.input.receivedFocus();
        }
        restartBlink(cm);
    }
    function onBlur(cm, e) {
        if (cm.state.delayingBlurEvent) return;
        if (cm.state.focused) {
            signal(cm, "blur", cm, e);
            cm.state.focused = false;
            rmClass(cm.display.wrapper, "CodeMirror-focused");
        }
        clearInterval(cm.display.blinker);
        setTimeout(function() {
            if (!cm.state.focused) cm.display.shift = false;
        }, 150);
    }
    // Read the actual heights of the rendered lines, and update their
    // stored heights to match.
    function updateHeightsInViewport(cm) {
        var display = cm.display;
        var prevBottom = display.lineDiv.offsetTop;
        var viewTop = Math.max(0, display.scroller.getBoundingClientRect().top);
        var oldHeight = display.lineDiv.getBoundingClientRect().top;
        var mustScroll = 0;
        for(var i = 0; i < display.view.length; i++){
            var cur = display.view[i], wrapping = cm.options.lineWrapping;
            var height = void 0, width = 0;
            if (cur.hidden) continue;
            oldHeight += cur.line.height;
            if (ie && ie_version < 8) {
                var bot = cur.node.offsetTop + cur.node.offsetHeight;
                height = bot - prevBottom;
                prevBottom = bot;
            } else {
                var box = cur.node.getBoundingClientRect();
                height = box.bottom - box.top;
                // Check that lines don't extend past the right of the current
                // editor width
                if (!wrapping && cur.text.firstChild) width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1;
            }
            var diff = cur.line.height - height;
            if (diff > .005 || diff < -0.005) {
                if (oldHeight < viewTop) mustScroll -= diff;
                updateLineHeight(cur.line, height);
                updateWidgetHeight(cur.line);
                if (cur.rest) for(var j = 0; j < cur.rest.length; j++)updateWidgetHeight(cur.rest[j]);
            }
            if (width > cm.display.sizerWidth) {
                var chWidth = Math.ceil(width / charWidth(cm.display));
                if (chWidth > cm.display.maxLineLength) {
                    cm.display.maxLineLength = chWidth;
                    cm.display.maxLine = cur.line;
                    cm.display.maxLineChanged = true;
                }
            }
        }
        if (Math.abs(mustScroll) > 2) display.scroller.scrollTop += mustScroll;
    }
    // Read and store the height of line widgets associated with the
    // given line.
    function updateWidgetHeight(line) {
        if (line.widgets) for(var i = 0; i < line.widgets.length; ++i){
            var w = line.widgets[i], parent = w.node.parentNode;
            if (parent) w.height = parent.offsetHeight;
        }
    }
    // Compute the lines that are visible in a given viewport (defaults
    // the current scroll position). viewport may contain top,
    // height, and ensure (see op.scrollToPos) properties.
    function visibleLines(display, doc, viewport) {
        var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
        top = Math.floor(top - paddingTop(display));
        var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;
        var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
        // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
        // forces those lines into the viewport (if possible).
        if (viewport && viewport.ensure) {
            var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
            if (ensureFrom < from) {
                from = ensureFrom;
                to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
            } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
                from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
                to = ensureTo;
            }
        }
        return {
            from: from,
            to: Math.max(to, from + 1)
        };
    }
    // SCROLLING THINGS INTO VIEW
    // If an editor sits on the top or bottom of the window, partially
    // scrolled out of view, this ensures that the cursor is visible.
    function maybeScrollWindow(cm, rect) {
        if (signalDOMEvent(cm, "scrollCursorIntoView")) return;
        var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
        var doc = display.wrapper.ownerDocument;
        if (rect.top + box.top < 0) doScroll = true;
        else if (rect.bottom + box.top > (doc.defaultView.innerHeight || doc.documentElement.clientHeight)) doScroll = false;
        if (doScroll != null && !phantom) {
            var scrollNode = elt("div", "\u200b", null, "position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + rect.left + "px; width: " + Math.max(2, rect.right - rect.left) + "px;");
            cm.display.lineSpace.appendChild(scrollNode);
            scrollNode.scrollIntoView(doScroll);
            cm.display.lineSpace.removeChild(scrollNode);
        }
    }
    // Scroll a given position into view (immediately), verifying that
    // it actually became visible (as line heights are accurately
    // measured, the position of something may 'drift' during drawing).
    function scrollPosIntoView(cm, pos, end, margin) {
        if (margin == null) margin = 0;
        var rect;
        if (!cm.options.lineWrapping && pos == end) {
            // Set pos and end to the cursor positions around the character pos sticks to
            // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
            // If pos == Pos(_, 0, "before"), pos and end are unchanged
            end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
            pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
        }
        for(var limit = 0; limit < 5; limit++){
            var changed = false;
            var coords = cursorCoords(cm, pos);
            var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
            rect = {
                left: Math.min(coords.left, endCoords.left),
                top: Math.min(coords.top, endCoords.top) - margin,
                right: Math.max(coords.left, endCoords.left),
                bottom: Math.max(coords.bottom, endCoords.bottom) + margin
            };
            var scrollPos = calculateScrollPos(cm, rect);
            var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
            if (scrollPos.scrollTop != null) {
                updateScrollTop(cm, scrollPos.scrollTop);
                if (Math.abs(cm.doc.scrollTop - startTop) > 1) changed = true;
            }
            if (scrollPos.scrollLeft != null) {
                setScrollLeft(cm, scrollPos.scrollLeft);
                if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) changed = true;
            }
            if (!changed) break;
        }
        return rect;
    }
    // Scroll a given set of coordinates into view (immediately).
    function scrollIntoView(cm, rect) {
        var scrollPos = calculateScrollPos(cm, rect);
        if (scrollPos.scrollTop != null) updateScrollTop(cm, scrollPos.scrollTop);
        if (scrollPos.scrollLeft != null) setScrollLeft(cm, scrollPos.scrollLeft);
    }
    // Calculate a new scroll position needed to scroll the given
    // rectangle into view. Returns an object with scrollTop and
    // scrollLeft properties. When these are undefined, the
    // vertical/horizontal position does not need to be adjusted.
    function calculateScrollPos(cm, rect) {
        var display = cm.display, snapMargin = textHeight(cm.display);
        if (rect.top < 0) rect.top = 0;
        var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
        var screen1 = displayHeight(cm), result = {};
        if (rect.bottom - rect.top > screen1) rect.bottom = rect.top + screen1;
        var docBottom = cm.doc.height + paddingVert(display);
        var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
        if (rect.top < screentop) result.scrollTop = atTop ? 0 : rect.top;
        else if (rect.bottom > screentop + screen1) {
            var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen1);
            if (newTop != screentop) result.scrollTop = newTop;
        }
        var gutterSpace = cm.options.fixedGutter ? 0 : display.gutters.offsetWidth;
        var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft - gutterSpace;
        var screenw = displayWidth(cm) - display.gutters.offsetWidth;
        var tooWide = rect.right - rect.left > screenw;
        if (tooWide) rect.right = rect.left + screenw;
        if (rect.left < 10) result.scrollLeft = 0;
        else if (rect.left < screenleft) result.scrollLeft = Math.max(0, rect.left + gutterSpace - (tooWide ? 0 : 10));
        else if (rect.right > screenw + screenleft - 3) result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw;
        return result;
    }
    // Store a relative adjustment to the scroll position in the current
    // operation (to be applied when the operation finishes).
    function addToScrollTop(cm, top) {
        if (top == null) return;
        resolveScrollToPos(cm);
        cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
    }
    // Make sure that at the end of the operation the current cursor is
    // shown.
    function ensureCursorVisible(cm) {
        resolveScrollToPos(cm);
        var cur = cm.getCursor();
        cm.curOp.scrollToPos = {
            from: cur,
            to: cur,
            margin: cm.options.cursorScrollMargin
        };
    }
    function scrollToCoords(cm, x, y) {
        if (x != null || y != null) resolveScrollToPos(cm);
        if (x != null) cm.curOp.scrollLeft = x;
        if (y != null) cm.curOp.scrollTop = y;
    }
    function scrollToRange(cm, range) {
        resolveScrollToPos(cm);
        cm.curOp.scrollToPos = range;
    }
    // When an operation has its scrollToPos property set, and another
    // scroll action is applied before the end of the operation, this
    // 'simulates' scrolling that position into view in a cheap way, so
    // that the effect of intermediate scroll commands is not ignored.
    function resolveScrollToPos(cm) {
        var range = cm.curOp.scrollToPos;
        if (range) {
            cm.curOp.scrollToPos = null;
            var from = estimateCoords(cm, range.from), to = estimateCoords(cm, range.to);
            scrollToCoordsRange(cm, from, to, range.margin);
        }
    }
    function scrollToCoordsRange(cm, from, to, margin) {
        var sPos = calculateScrollPos(cm, {
            left: Math.min(from.left, to.left),
            top: Math.min(from.top, to.top) - margin,
            right: Math.max(from.right, to.right),
            bottom: Math.max(from.bottom, to.bottom) + margin
        });
        scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
    }
    // Sync the scrollable area and scrollbars, ensure the viewport
    // covers the visible area.
    function updateScrollTop(cm, val) {
        if (Math.abs(cm.doc.scrollTop - val) < 2) return;
        if (!gecko) updateDisplaySimple(cm, {
            top: val
        });
        setScrollTop(cm, val, true);
        if (gecko) updateDisplaySimple(cm);
        startWorker(cm, 100);
    }
    function setScrollTop(cm, val, forceScroll) {
        val = Math.max(0, Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val));
        if (cm.display.scroller.scrollTop == val && !forceScroll) return;
        cm.doc.scrollTop = val;
        cm.display.scrollbars.setScrollTop(val);
        if (cm.display.scroller.scrollTop != val) cm.display.scroller.scrollTop = val;
    }
    // Sync scroller and scrollbar, ensure the gutter elements are
    // aligned.
    function setScrollLeft(cm, val, isScroller, forceScroll) {
        val = Math.max(0, Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth));
        if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) return;
        cm.doc.scrollLeft = val;
        alignHorizontally(cm);
        if (cm.display.scroller.scrollLeft != val) cm.display.scroller.scrollLeft = val;
        cm.display.scrollbars.setScrollLeft(val);
    }
    // SCROLLBARS
    // Prepare DOM reads needed to update the scrollbars. Done in one
    // shot to minimize update/measure roundtrips.
    function measureForScrollbars(cm) {
        var d = cm.display, gutterW = d.gutters.offsetWidth;
        var docH = Math.round(cm.doc.height + paddingVert(cm.display));
        return {
            clientHeight: d.scroller.clientHeight,
            viewHeight: d.wrapper.clientHeight,
            scrollWidth: d.scroller.scrollWidth,
            clientWidth: d.scroller.clientWidth,
            viewWidth: d.wrapper.clientWidth,
            barLeft: cm.options.fixedGutter ? gutterW : 0,
            docHeight: docH,
            scrollHeight: docH + scrollGap(cm) + d.barHeight,
            nativeBarWidth: d.nativeBarWidth,
            gutterWidth: gutterW
        };
    }
    var NativeScrollbars = function(place, scroll, cm) {
        this.cm = cm;
        var vert = this.vert = elt("div", [
            elt("div", null, null, "min-width: 1px")
        ], "CodeMirror-vscrollbar");
        var horiz = this.horiz = elt("div", [
            elt("div", null, null, "height: 100%; min-height: 1px")
        ], "CodeMirror-hscrollbar");
        vert.tabIndex = horiz.tabIndex = -1;
        place(vert);
        place(horiz);
        on(vert, "scroll", function() {
            if (vert.clientHeight) scroll(vert.scrollTop, "vertical");
        });
        on(horiz, "scroll", function() {
            if (horiz.clientWidth) scroll(horiz.scrollLeft, "horizontal");
        });
        this.checkedZeroWidth = false;
        // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
        if (ie && ie_version < 8) this.horiz.style.minHeight = this.vert.style.minWidth = "18px";
    };
    NativeScrollbars.prototype.update = function(measure) {
        var needsH = measure.scrollWidth > measure.clientWidth + 1;
        var needsV = measure.scrollHeight > measure.clientHeight + 1;
        var sWidth = measure.nativeBarWidth;
        if (needsV) {
            this.vert.style.display = "block";
            this.vert.style.bottom = needsH ? sWidth + "px" : "0";
            var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
            // A bug in IE8 can cause this value to be negative, so guard it.
            this.vert.firstChild.style.height = Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
        } else {
            this.vert.scrollTop = 0;
            this.vert.style.display = "";
            this.vert.firstChild.style.height = "0";
        }
        if (needsH) {
            this.horiz.style.display = "block";
            this.horiz.style.right = needsV ? sWidth + "px" : "0";
            this.horiz.style.left = measure.barLeft + "px";
            var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
            this.horiz.firstChild.style.width = Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
        } else {
            this.horiz.style.display = "";
            this.horiz.firstChild.style.width = "0";
        }
        if (!this.checkedZeroWidth && measure.clientHeight > 0) {
            if (sWidth == 0) this.zeroWidthHack();
            this.checkedZeroWidth = true;
        }
        return {
            right: needsV ? sWidth : 0,
            bottom: needsH ? sWidth : 0
        };
    };
    NativeScrollbars.prototype.setScrollLeft = function(pos) {
        if (this.horiz.scrollLeft != pos) this.horiz.scrollLeft = pos;
        if (this.disableHoriz) this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
    };
    NativeScrollbars.prototype.setScrollTop = function(pos) {
        if (this.vert.scrollTop != pos) this.vert.scrollTop = pos;
        if (this.disableVert) this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
    };
    NativeScrollbars.prototype.zeroWidthHack = function() {
        var w = mac && !mac_geMountainLion ? "12px" : "18px";
        this.horiz.style.height = this.vert.style.width = w;
        this.horiz.style.visibility = this.vert.style.visibility = "hidden";
        this.disableHoriz = new Delayed;
        this.disableVert = new Delayed;
    };
    NativeScrollbars.prototype.enableZeroWidthBar = function(bar, delay, type) {
        bar.style.visibility = "";
        function maybeDisable() {
            // To find out whether the scrollbar is still visible, we
            // check whether the element under the pixel in the bottom
            // right corner of the scrollbar box is the scrollbar box
            // itself (when the bar is still visible) or its filler child
            // (when the bar is hidden). If it is still visible, we keep
            // it enabled, if it's hidden, we disable pointer events.
            var box = bar.getBoundingClientRect();
            var elt = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2) : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
            if (elt != bar) bar.style.visibility = "hidden";
            else delay.set(1000, maybeDisable);
        }
        delay.set(1000, maybeDisable);
    };
    NativeScrollbars.prototype.clear = function() {
        var parent = this.horiz.parentNode;
        parent.removeChild(this.horiz);
        parent.removeChild(this.vert);
    };
    var NullScrollbars = function() {};
    NullScrollbars.prototype.update = function() {
        return {
            bottom: 0,
            right: 0
        };
    };
    NullScrollbars.prototype.setScrollLeft = function() {};
    NullScrollbars.prototype.setScrollTop = function() {};
    NullScrollbars.prototype.clear = function() {};
    function updateScrollbars(cm, measure) {
        if (!measure) measure = measureForScrollbars(cm);
        var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
        updateScrollbarsInner(cm, measure);
        for(var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++){
            if (startWidth != cm.display.barWidth && cm.options.lineWrapping) updateHeightsInViewport(cm);
            updateScrollbarsInner(cm, measureForScrollbars(cm));
            startWidth = cm.display.barWidth;
            startHeight = cm.display.barHeight;
        }
    }
    // Re-synchronize the fake scrollbars with the actual size of the
    // content.
    function updateScrollbarsInner(cm, measure) {
        var d = cm.display;
        var sizes = d.scrollbars.update(measure);
        d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
        d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
        d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";
        if (sizes.right && sizes.bottom) {
            d.scrollbarFiller.style.display = "block";
            d.scrollbarFiller.style.height = sizes.bottom + "px";
            d.scrollbarFiller.style.width = sizes.right + "px";
        } else d.scrollbarFiller.style.display = "";
        if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
            d.gutterFiller.style.display = "block";
            d.gutterFiller.style.height = sizes.bottom + "px";
            d.gutterFiller.style.width = measure.gutterWidth + "px";
        } else d.gutterFiller.style.display = "";
    }
    var scrollbarModel = {
        "native": NativeScrollbars,
        "null": NullScrollbars
    };
    function initScrollbars(cm) {
        if (cm.display.scrollbars) {
            cm.display.scrollbars.clear();
            if (cm.display.scrollbars.addClass) rmClass(cm.display.wrapper, cm.display.scrollbars.addClass);
        }
        cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function(node) {
            cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
            // Prevent clicks in the scrollbars from killing focus
            on(node, "mousedown", function() {
                if (cm.state.focused) setTimeout(function() {
                    return cm.display.input.focus();
                }, 0);
            });
            node.setAttribute("cm-not-content", "true");
        }, function(pos, axis) {
            if (axis == "horizontal") setScrollLeft(cm, pos);
            else updateScrollTop(cm, pos);
        }, cm);
        if (cm.display.scrollbars.addClass) addClass(cm.display.wrapper, cm.display.scrollbars.addClass);
    }
    // Operations are used to wrap a series of changes to the editor
    // state in such a way that each change won't have to update the
    // cursor and display (which would be awkward, slow, and
    // error-prone). Instead, display updates are batched and then all
    // combined and executed at once.
    var nextOpId = 0;
    // Start a new operation.
    function startOperation(cm) {
        cm.curOp = {
            cm: cm,
            viewChanged: false,
            startHeight: cm.doc.height,
            forceUpdate: false,
            updateInput: 0,
            typing: false,
            changeObjs: null,
            cursorActivityHandlers: null,
            cursorActivityCalled: 0,
            selectionChanged: false,
            updateMaxLine: false,
            scrollLeft: null,
            scrollTop: null,
            scrollToPos: null,
            focus: false,
            id: ++nextOpId,
            markArrays: null // Used by addMarkedSpan
        };
        pushOperation(cm.curOp);
    }
    // Finish an operation, updating the display and signalling delayed events
    function endOperation(cm) {
        var op = cm.curOp;
        if (op) finishOperation(op, function(group) {
            for(var i = 0; i < group.ops.length; i++)group.ops[i].cm.curOp = null;
            endOperations(group);
        });
    }
    // The DOM updates done when an operation finishes are batched so
    // that the minimum number of relayouts are required.
    function endOperations(group) {
        var ops = group.ops;
        for(var i = 0; i < ops.length; i++)endOperation_R1(ops[i]);
        for(var i$1 = 0; i$1 < ops.length; i$1++)endOperation_W1(ops[i$1]);
        for(var i$2 = 0; i$2 < ops.length; i$2++)endOperation_R2(ops[i$2]);
        for(var i$3 = 0; i$3 < ops.length; i$3++)endOperation_W2(ops[i$3]);
        for(var i$4 = 0; i$4 < ops.length; i$4++)endOperation_finish(ops[i$4]);
    }
    function endOperation_R1(op) {
        var cm = op.cm, display = cm.display;
        maybeClipScrollbars(cm);
        if (op.updateMaxLine) findMaxLine(cm);
        op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null || op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom || op.scrollToPos.to.line >= display.viewTo) || display.maxLineChanged && cm.options.lineWrapping;
        op.update = op.mustUpdate && new DisplayUpdate(cm, op.mustUpdate && {
            top: op.scrollTop,
            ensure: op.scrollToPos
        }, op.forceUpdate);
    }
    function endOperation_W1(op) {
        op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
    }
    function endOperation_R2(op) {
        var cm = op.cm, display = cm.display;
        if (op.updatedDisplay) updateHeightsInViewport(cm);
        op.barMeasure = measureForScrollbars(cm);
        // If the max line changed since it was last measured, measure it,
        // and ensure the document's width matches it.
        // updateDisplay_W2 will use these properties to do the actual resizing
        if (display.maxLineChanged && !cm.options.lineWrapping) {
            op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
            cm.display.sizerWidth = op.adjustWidthTo;
            op.barMeasure.scrollWidth = Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
            op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
        }
        if (op.updatedDisplay || op.selectionChanged) op.preparedSelection = display.input.prepareSelection();
    }
    function endOperation_W2(op) {
        var cm = op.cm;
        if (op.adjustWidthTo != null) {
            cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
            if (op.maxScrollLeft < cm.doc.scrollLeft) setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true);
            cm.display.maxLineChanged = false;
        }
        var takeFocus = op.focus && op.focus == activeElt(root(cm));
        if (op.preparedSelection) cm.display.input.showSelection(op.preparedSelection, takeFocus);
        if (op.updatedDisplay || op.startHeight != cm.doc.height) updateScrollbars(cm, op.barMeasure);
        if (op.updatedDisplay) setDocumentHeight(cm, op.barMeasure);
        if (op.selectionChanged) restartBlink(cm);
        if (cm.state.focused && op.updateInput) cm.display.input.reset(op.typing);
        if (takeFocus) ensureFocus(op.cm);
    }
    function endOperation_finish(op) {
        var cm = op.cm, display = cm.display, doc = cm.doc;
        if (op.updatedDisplay) postUpdateDisplay(cm, op.update);
        // Abort mouse wheel delta measurement, when scrolling explicitly
        if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos)) display.wheelStartX = display.wheelStartY = null;
        // Propagate the scroll position to the actual DOM scroller
        if (op.scrollTop != null) setScrollTop(cm, op.scrollTop, op.forceScroll);
        if (op.scrollLeft != null) setScrollLeft(cm, op.scrollLeft, true, true);
        // If we need to scroll a specific position into view, do so.
        if (op.scrollToPos) {
            var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from), clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
            maybeScrollWindow(cm, rect);
        }
        // Fire events for markers that are hidden/unidden by editing or
        // undoing
        var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
        if (hidden) {
            for(var i = 0; i < hidden.length; ++i)if (!hidden[i].lines.length) signal(hidden[i], "hide");
        }
        if (unhidden) {
            for(var i$1 = 0; i$1 < unhidden.length; ++i$1)if (unhidden[i$1].lines.length) signal(unhidden[i$1], "unhide");
        }
        if (display.wrapper.offsetHeight) doc.scrollTop = cm.display.scroller.scrollTop;
        // Fire change events, and delayed event handlers
        if (op.changeObjs) signal(cm, "changes", cm, op.changeObjs);
        if (op.update) op.update.finish();
    }
    // Run the given function in an operation
    function runInOp(cm, f) {
        if (cm.curOp) return f();
        startOperation(cm);
        try {
            return f();
        } finally{
            endOperation(cm);
        }
    }
    // Wraps a function in an operation. Returns the wrapped function.
    function operation(cm, f) {
        return function() {
            if (cm.curOp) return f.apply(cm, arguments);
            startOperation(cm);
            try {
                return f.apply(cm, arguments);
            } finally{
                endOperation(cm);
            }
        };
    }
    // Used to add methods to editor and doc instances, wrapping them in
    // operations.
    function methodOp(f) {
        return function() {
            if (this.curOp) return f.apply(this, arguments);
            startOperation(this);
            try {
                return f.apply(this, arguments);
            } finally{
                endOperation(this);
            }
        };
    }
    function docMethodOp(f) {
        return function() {
            var cm = this.cm;
            if (!cm || cm.curOp) return f.apply(this, arguments);
            startOperation(cm);
            try {
                return f.apply(this, arguments);
            } finally{
                endOperation(cm);
            }
        };
    }
    // HIGHLIGHT WORKER
    function startWorker(cm, time) {
        if (cm.doc.highlightFrontier < cm.display.viewTo) cm.state.highlight.set(time, bind(highlightWorker, cm));
    }
    function highlightWorker(cm) {
        var doc = cm.doc;
        if (doc.highlightFrontier >= cm.display.viewTo) return;
        var end = +new Date + cm.options.workTime;
        var context = getContextBefore(cm, doc.highlightFrontier);
        var changedLines = [];
        doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function(line) {
            if (context.line >= cm.display.viewFrom) {
                var oldStyles = line.styles;
                var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
                var highlighted = highlightLine(cm, line, context, true);
                if (resetState) context.state = resetState;
                line.styles = highlighted.styles;
                var oldCls = line.styleClasses, newCls = highlighted.classes;
                if (newCls) line.styleClasses = newCls;
                else if (oldCls) line.styleClasses = null;
                var ischange = !oldStyles || oldStyles.length != line.styles.length || oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
                for(var i = 0; !ischange && i < oldStyles.length; ++i)ischange = oldStyles[i] != line.styles[i];
                if (ischange) changedLines.push(context.line);
                line.stateAfter = context.save();
                context.nextLine();
            } else {
                if (line.text.length <= cm.options.maxHighlightLength) processLine(cm, line.text, context);
                line.stateAfter = context.line % 5 == 0 ? context.save() : null;
                context.nextLine();
            }
            if (+new Date > end) {
                startWorker(cm, cm.options.workDelay);
                return true;
            }
        });
        doc.highlightFrontier = context.line;
        doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
        if (changedLines.length) runInOp(cm, function() {
            for(var i = 0; i < changedLines.length; i++)regLineChange(cm, changedLines[i], "text");
        });
    }
    // DISPLAY DRAWING
    var DisplayUpdate = function(cm, viewport, force) {
        var display = cm.display;
        this.viewport = viewport;
        // Store some values that we'll need later (but don't want to force a relayout for)
        this.visible = visibleLines(display, cm.doc, viewport);
        this.editorIsHidden = !display.wrapper.offsetWidth;
        this.wrapperHeight = display.wrapper.clientHeight;
        this.wrapperWidth = display.wrapper.clientWidth;
        this.oldDisplayWidth = displayWidth(cm);
        this.force = force;
        this.dims = getDimensions(cm);
        this.events = [];
    };
    DisplayUpdate.prototype.signal = function(emitter, type) {
        if (hasHandler(emitter, type)) this.events.push(arguments);
    };
    DisplayUpdate.prototype.finish = function() {
        for(var i = 0; i < this.events.length; i++)signal.apply(null, this.events[i]);
    };
    function maybeClipScrollbars(cm) {
        var display = cm.display;
        if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
            display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
            display.heightForcer.style.height = scrollGap(cm) + "px";
            display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
            display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
            display.scrollbarsClipped = true;
        }
    }
    function selectionSnapshot(cm) {
        if (cm.hasFocus()) return null;
        var active = activeElt(root(cm));
        if (!active || !contains(cm.display.lineDiv, active)) return null;
        var result = {
            activeElt: active
        };
        if (window.getSelection) {
            var sel = win(cm).getSelection();
            if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
                result.anchorNode = sel.anchorNode;
                result.anchorOffset = sel.anchorOffset;
                result.focusNode = sel.focusNode;
                result.focusOffset = sel.focusOffset;
            }
        }
        return result;
    }
    function restoreSelection(snapshot) {
        if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt(rootNode(snapshot.activeElt))) return;
        snapshot.activeElt.focus();
        if (!/^(INPUT|TEXTAREA)$/.test(snapshot.activeElt.nodeName) && snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
            var doc = snapshot.activeElt.ownerDocument;
            var sel = doc.defaultView.getSelection(), range = doc.createRange();
            range.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
            sel.extend(snapshot.focusNode, snapshot.focusOffset);
        }
    }
    // Does the actual updating of the line display. Bails out
    // (returning false) when there is nothing to be done and forced is
    // false.
    function updateDisplayIfNeeded(cm, update) {
        var display = cm.display, doc = cm.doc;
        if (update.editorIsHidden) {
            resetView(cm);
            return false;
        }
        // Bail out if the visible area is already rendered and nothing changed.
        if (!update.force && update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) && display.renderedView == display.view && countDirtyView(cm) == 0) return false;
        if (maybeUpdateLineNumberWidth(cm)) {
            resetView(cm);
            update.dims = getDimensions(cm);
        }
        // Compute a suitable new viewport (from & to)
        var end = doc.first + doc.size;
        var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
        var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
        if (display.viewFrom < from && from - display.viewFrom < 20) from = Math.max(doc.first, display.viewFrom);
        if (display.viewTo > to && display.viewTo - to < 20) to = Math.min(end, display.viewTo);
        if (sawCollapsedSpans) {
            from = visualLineNo(cm.doc, from);
            to = visualLineEndNo(cm.doc, to);
        }
        var different = from != display.viewFrom || to != display.viewTo || display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
        adjustView(cm, from, to);
        display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
        // Position the mover div to align with the current scroll position
        cm.display.mover.style.top = display.viewOffset + "px";
        var toUpdate = countDirtyView(cm);
        if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo)) return false;
        // For big changes, we hide the enclosing element during the
        // update, since that speeds up the operations on most browsers.
        var selSnapshot = selectionSnapshot(cm);
        if (toUpdate > 4) display.lineDiv.style.display = "none";
        patchDisplay(cm, display.updateLineNumbers, update.dims);
        if (toUpdate > 4) display.lineDiv.style.display = "";
        display.renderedView = display.view;
        // There might have been a widget with a focused element that got
        // hidden or updated, if so re-focus it.
        restoreSelection(selSnapshot);
        // Prevent selection and cursors from interfering with the scroll
        // width and height.
        removeChildren(display.cursorDiv);
        removeChildren(display.selectionDiv);
        display.gutters.style.height = display.sizer.style.minHeight = 0;
        if (different) {
            display.lastWrapHeight = update.wrapperHeight;
            display.lastWrapWidth = update.wrapperWidth;
            startWorker(cm, 400);
        }
        display.updateLineNumbers = null;
        return true;
    }
    function postUpdateDisplay(cm, update) {
        var viewport = update.viewport;
        for(var first = true;; first = false){
            if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
                // Clip forced viewport to actual scrollable area.
                if (viewport && viewport.top != null) viewport = {
                    top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)
                };
                // Updated line heights might result in the drawn area not
                // actually covering the viewport. Keep looping until it does.
                update.visible = visibleLines(cm.display, cm.doc, viewport);
                if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo) break;
            } else if (first) update.visible = visibleLines(cm.display, cm.doc, viewport);
            if (!updateDisplayIfNeeded(cm, update)) break;
            updateHeightsInViewport(cm);
            var barMeasure = measureForScrollbars(cm);
            updateSelection(cm);
            updateScrollbars(cm, barMeasure);
            setDocumentHeight(cm, barMeasure);
            update.force = false;
        }
        update.signal(cm, "update", cm);
        if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
            update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
            cm.display.reportedViewFrom = cm.display.viewFrom;
            cm.display.reportedViewTo = cm.display.viewTo;
        }
    }
    function updateDisplaySimple(cm, viewport) {
        var update = new DisplayUpdate(cm, viewport);
        if (updateDisplayIfNeeded(cm, update)) {
            updateHeightsInViewport(cm);
            postUpdateDisplay(cm, update);
            var barMeasure = measureForScrollbars(cm);
            updateSelection(cm);
            updateScrollbars(cm, barMeasure);
            setDocumentHeight(cm, barMeasure);
            update.finish();
        }
    }
    // Sync the actual display DOM structure with display.view, removing
    // nodes for lines that are no longer in view, and creating the ones
    // that are not there yet, and updating the ones that are out of
    // date.
    function patchDisplay(cm, updateNumbersFrom, dims) {
        var display = cm.display, lineNumbers = cm.options.lineNumbers;
        var container = display.lineDiv, cur = container.firstChild;
        function rm(node) {
            var next = node.nextSibling;
            // Works around a throw-scroll bug in OS X Webkit
            if (webkit && mac && cm.display.currentWheelTarget == node) node.style.display = "none";
            else node.parentNode.removeChild(node);
            return next;
        }
        var view = display.view, lineN = display.viewFrom;
        // Loop over the elements in the view, syncing cur (the DOM nodes
        // in display.lineDiv) with the view as we go.
        for(var i = 0; i < view.length; i++){
            var lineView = view[i];
            if (lineView.hidden) ;
            else if (!lineView.node || lineView.node.parentNode != container) {
                var node = buildLineElement(cm, lineView, lineN, dims);
                container.insertBefore(node, cur);
            } else {
                while(cur != lineView.node)cur = rm(cur);
                var updateNumber = lineNumbers && updateNumbersFrom != null && updateNumbersFrom <= lineN && lineView.lineNumber;
                if (lineView.changes) {
                    if (indexOf(lineView.changes, "gutter") > -1) updateNumber = false;
                    updateLineForChanges(cm, lineView, lineN, dims);
                }
                if (updateNumber) {
                    removeChildren(lineView.lineNumber);
                    lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
                }
                cur = lineView.node.nextSibling;
            }
            lineN += lineView.size;
        }
        while(cur)cur = rm(cur);
    }
    function updateGutterSpace(display) {
        var width = display.gutters.offsetWidth;
        display.sizer.style.marginLeft = width + "px";
        // Send an event to consumers responding to changes in gutter width.
        signalLater(display, "gutterChanged", display);
    }
    function setDocumentHeight(cm, measure) {
        cm.display.sizer.style.minHeight = measure.docHeight + "px";
        cm.display.heightForcer.style.top = measure.docHeight + "px";
        cm.display.gutters.style.height = measure.docHeight + cm.display.barHeight + scrollGap(cm) + "px";
    }
    // Re-align line numbers and gutter marks to compensate for
    // horizontal scrolling.
    function alignHorizontally(cm) {
        var display = cm.display, view = display.view;
        if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) return;
        var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
        var gutterW = display.gutters.offsetWidth, left = comp + "px";
        for(var i = 0; i < view.length; i++)if (!view[i].hidden) {
            if (cm.options.fixedGutter) {
                if (view[i].gutter) view[i].gutter.style.left = left;
                if (view[i].gutterBackground) view[i].gutterBackground.style.left = left;
            }
            var align = view[i].alignable;
            if (align) for(var j = 0; j < align.length; j++)align[j].style.left = left;
        }
        if (cm.options.fixedGutter) display.gutters.style.left = comp + gutterW + "px";
    }
    // Used to ensure that the line number gutter is still the right
    // size for the current document size. Returns true when an update
    // is needed.
    function maybeUpdateLineNumberWidth(cm) {
        if (!cm.options.lineNumbers) return false;
        var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
        if (last.length != display.lineNumChars) {
            var test = display.measure.appendChild(elt("div", [
                elt("div", last)
            ], "CodeMirror-linenumber CodeMirror-gutter-elt"));
            var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
            display.lineGutter.style.width = "";
            display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
            display.lineNumWidth = display.lineNumInnerWidth + padding;
            display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
            display.lineGutter.style.width = display.lineNumWidth + "px";
            updateGutterSpace(cm.display);
            return true;
        }
        return false;
    }
    function getGutters(gutters, lineNumbers) {
        var result = [], sawLineNumbers = false;
        for(var i = 0; i < gutters.length; i++){
            var name = gutters[i], style = null;
            if (typeof name != "string") {
                style = name.style;
                name = name.className;
            }
            if (name == "CodeMirror-linenumbers") {
                if (!lineNumbers) continue;
                else sawLineNumbers = true;
            }
            result.push({
                className: name,
                style: style
            });
        }
        if (lineNumbers && !sawLineNumbers) result.push({
            className: "CodeMirror-linenumbers",
            style: null
        });
        return result;
    }
    // Rebuild the gutter elements, ensure the margin to the left of the
    // code matches their width.
    function renderGutters(display) {
        var gutters = display.gutters, specs = display.gutterSpecs;
        removeChildren(gutters);
        display.lineGutter = null;
        for(var i = 0; i < specs.length; ++i){
            var ref = specs[i];
            var className = ref.className;
            var style = ref.style;
            var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
            if (style) gElt.style.cssText = style;
            if (className == "CodeMirror-linenumbers") {
                display.lineGutter = gElt;
                gElt.style.width = (display.lineNumWidth || 1) + "px";
            }
        }
        gutters.style.display = specs.length ? "" : "none";
        updateGutterSpace(display);
    }
    function updateGutters(cm) {
        renderGutters(cm.display);
        regChange(cm);
        alignHorizontally(cm);
    }
    // The display handles the DOM integration, both for input reading
    // and content drawing. It holds references to DOM nodes and
    // display-related state.
    function Display(place, doc, input, options) {
        var d = this;
        this.input = input;
        // Covers bottom-right square when both scrollbars are present.
        d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
        d.scrollbarFiller.setAttribute("cm-not-content", "true");
        // Covers bottom of gutter when coverGutterNextToScrollbar is on
        // and h scrollbar is present.
        d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
        d.gutterFiller.setAttribute("cm-not-content", "true");
        // Will contain the actual code, positioned to cover the viewport.
        d.lineDiv = eltP("div", null, "CodeMirror-code");
        // Elements are added to these to represent selection and cursors.
        d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
        d.cursorDiv = elt("div", null, "CodeMirror-cursors");
        // A visibility: hidden element used to find the size of things.
        d.measure = elt("div", null, "CodeMirror-measure");
        // When lines outside of the viewport are measured, they are drawn in this.
        d.lineMeasure = elt("div", null, "CodeMirror-measure");
        // Wraps everything that needs to exist inside the vertically-padded coordinate system
        d.lineSpace = eltP("div", [
            d.measure,
            d.lineMeasure,
            d.selectionDiv,
            d.cursorDiv,
            d.lineDiv
        ], null, "position: relative; outline: none");
        var lines = eltP("div", [
            d.lineSpace
        ], "CodeMirror-lines");
        // Moved around its parent to cover visible view.
        d.mover = elt("div", [
            lines
        ], null, "position: relative");
        // Set to the height of the document, allowing scrolling.
        d.sizer = elt("div", [
            d.mover
        ], "CodeMirror-sizer");
        d.sizerWidth = null;
        // Behavior of elts with overflow: auto and padding is
        // inconsistent across browsers. This is used to ensure the
        // scrollable area is big enough.
        d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
        // Will contain the gutters, if any.
        d.gutters = elt("div", null, "CodeMirror-gutters");
        d.lineGutter = null;
        // Actual scrollable element.
        d.scroller = elt("div", [
            d.sizer,
            d.heightForcer,
            d.gutters
        ], "CodeMirror-scroll");
        d.scroller.setAttribute("tabIndex", "-1");
        // The element in which the editor lives.
        d.wrapper = elt("div", [
            d.scrollbarFiller,
            d.gutterFiller,
            d.scroller
        ], "CodeMirror");
        // See #6982. FIXME remove when this has been fixed for a while in Chrome
        if (chrome && chrome_version >= 105) d.wrapper.style.clipPath = "inset(0px)";
        // This attribute is respected by automatic translation systems such as Google Translate,
        // and may also be respected by tools used by human translators.
        d.wrapper.setAttribute('translate', 'no');
        // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
        if (ie && ie_version < 8) {
            d.gutters.style.zIndex = -1;
            d.scroller.style.paddingRight = 0;
        }
        if (!webkit && !(gecko && mobile)) d.scroller.draggable = true;
        if (place) {
            if (place.appendChild) place.appendChild(d.wrapper);
            else place(d.wrapper);
        }
        // Current rendered range (may be bigger than the view window).
        d.viewFrom = d.viewTo = doc.first;
        d.reportedViewFrom = d.reportedViewTo = doc.first;
        // Information about the rendered lines.
        d.view = [];
        d.renderedView = null;
        // Holds info about a single rendered line when it was rendered
        // for measurement, while not in view.
        d.externalMeasured = null;
        // Empty space (in pixels) above the view
        d.viewOffset = 0;
        d.lastWrapHeight = d.lastWrapWidth = 0;
        d.updateLineNumbers = null;
        d.nativeBarWidth = d.barHeight = d.barWidth = 0;
        d.scrollbarsClipped = false;
        // Used to only resize the line number gutter when necessary (when
        // the amount of lines crosses a boundary that makes its width change)
        d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
        // Set to true when a non-horizontal-scrolling line widget is
        // added. As an optimization, line widget aligning is skipped when
        // this is false.
        d.alignWidgets = false;
        d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
        // Tracks the maximum line length so that the horizontal scrollbar
        // can be kept static when scrolling.
        d.maxLine = null;
        d.maxLineLength = 0;
        d.maxLineChanged = false;
        // Used for measuring wheel scrolling granularity
        d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;
        // True when shift is held down.
        d.shift = false;
        // Used to track whether anything happened since the context menu
        // was opened.
        d.selForContextMenu = null;
        d.activeTouch = null;
        d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
        renderGutters(d);
        input.init(d);
    }
    // Since the delta values reported on mouse wheel events are
    // unstandardized between browsers and even browser versions, and
    // generally horribly unpredictable, this code starts by measuring
    // the scroll effect that the first few mouse wheel events have,
    // and, from that, detects the way it can convert deltas to pixel
    // offsets afterwards.
    //
    // The reason we want to know the amount a wheel event will scroll
    // is that it gives us a chance to update the display before the
    // actual scrolling happens, reducing flickering.
    var wheelSamples = 0, wheelPixelsPerUnit = null;
    // Fill in a browser-detected starting value on browsers where we
    // know one. These don't have to be accurate -- the result of them
    // being wrong would just be a slight flicker on the first wheel
    // scroll (if it is large enough).
    if (ie) wheelPixelsPerUnit = -0.53;
    else if (gecko) wheelPixelsPerUnit = 15;
    else if (chrome) wheelPixelsPerUnit = -0.7;
    else if (safari) wheelPixelsPerUnit = -1 / 3;
    function wheelEventDelta(e) {
        var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
        if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) dx = e.detail;
        if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) dy = e.detail;
        else if (dy == null) dy = e.wheelDelta;
        return {
            x: dx,
            y: dy
        };
    }
    function wheelEventPixels(e) {
        var delta = wheelEventDelta(e);
        delta.x *= wheelPixelsPerUnit;
        delta.y *= wheelPixelsPerUnit;
        return delta;
    }
    function onScrollWheel(cm, e) {
        // On Chrome 102, viewport updates somehow stop wheel-based
        // scrolling. Turning off pointer events during the scroll seems
        // to avoid the issue.
        if (chrome && chrome_version == 102) {
            if (cm.display.chromeScrollHack == null) cm.display.sizer.style.pointerEvents = "none";
            else clearTimeout(cm.display.chromeScrollHack);
            cm.display.chromeScrollHack = setTimeout(function() {
                cm.display.chromeScrollHack = null;
                cm.display.sizer.style.pointerEvents = "";
            }, 100);
        }
        var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;
        var pixelsPerUnit = wheelPixelsPerUnit;
        if (e.deltaMode === 0) {
            dx = e.deltaX;
            dy = e.deltaY;
            pixelsPerUnit = 1;
        }
        var display = cm.display, scroll = display.scroller;
        // Quit if there's nothing to scroll here
        var canScrollX = scroll.scrollWidth > scroll.clientWidth;
        var canScrollY = scroll.scrollHeight > scroll.clientHeight;
        if (!(dx && canScrollX || dy && canScrollY)) return;
        // Webkit browsers on OS X abort momentum scrolls when the target
        // of the scroll event is removed from the scrollable element.
        // This hack (see related code in patchDisplay) makes sure the
        // element is kept around.
        if (dy && mac && webkit) outer: for(var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode){
            for(var i = 0; i < view.length; i++)if (view[i].node == cur) {
                cm.display.currentWheelTarget = cur;
                break outer;
            }
        }
        // On some browsers, horizontal scrolling will cause redraws to
        // happen before the gutter has been realigned, causing it to
        // wriggle around in a most unseemly way. When we have an
        // estimated pixels/delta value, we just handle horizontal
        // scrolling entirely here. It'll be slightly off from native, but
        // better than glitching out.
        if (dx && !gecko && !presto && pixelsPerUnit != null) {
            if (dy && canScrollY) updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * pixelsPerUnit));
            setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * pixelsPerUnit));
            // Only prevent default scrolling if vertical scrolling is
            // actually possible. Otherwise, it causes vertical scroll
            // jitter on OSX trackpads when deltaX is small and deltaY
            // is large (issue #3579)
            if (!dy || dy && canScrollY) e_preventDefault(e);
            display.wheelStartX = null; // Abort measurement, if in progress
            return;
        }
        // 'Project' the visible viewport to cover the area that is being
        // scrolled into view (if we know enough to estimate it).
        if (dy && pixelsPerUnit != null) {
            var pixels = dy * pixelsPerUnit;
            var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
            if (pixels < 0) top = Math.max(0, top + pixels - 50);
            else bot = Math.min(cm.doc.height, bot + pixels + 50);
            updateDisplaySimple(cm, {
                top: top,
                bottom: bot
            });
        }
        if (wheelSamples < 20 && e.deltaMode !== 0) {
            if (display.wheelStartX == null) {
                display.wheelStartX = scroll.scrollLeft;
                display.wheelStartY = scroll.scrollTop;
                display.wheelDX = dx;
                display.wheelDY = dy;
                setTimeout(function() {
                    if (display.wheelStartX == null) return;
                    var movedX = scroll.scrollLeft - display.wheelStartX;
                    var movedY = scroll.scrollTop - display.wheelStartY;
                    var sample = movedY && display.wheelDY && movedY / display.wheelDY || movedX && display.wheelDX && movedX / display.wheelDX;
                    display.wheelStartX = display.wheelStartY = null;
                    if (!sample) return;
                    wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
                    ++wheelSamples;
                }, 200);
            } else {
                display.wheelDX += dx;
                display.wheelDY += dy;
            }
        }
    }
    // Selection objects are immutable. A new one is created every time
    // the selection changes. A selection is one or more non-overlapping
    // (and non-touching) ranges, sorted, and an integer that indicates
    // which one is the primary selection (the one that's scrolled into
    // view, that getCursor returns, etc).
    var Selection = function(ranges, primIndex) {
        this.ranges = ranges;
        this.primIndex = primIndex;
    };
    Selection.prototype.primary = function() {
        return this.ranges[this.primIndex];
    };
    Selection.prototype.equals = function(other) {
        if (other == this) return true;
        if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) return false;
        for(var i = 0; i < this.ranges.length; i++){
            var here = this.ranges[i], there = other.ranges[i];
            if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) return false;
        }
        return true;
    };
    Selection.prototype.deepCopy = function() {
        var out = [];
        for(var i = 0; i < this.ranges.length; i++)out[i] = new Range(copyPos(this.ranges[i].anchor), copyPos(this.ranges[i].head));
        return new Selection(out, this.primIndex);
    };
    Selection.prototype.somethingSelected = function() {
        for(var i = 0; i < this.ranges.length; i++){
            if (!this.ranges[i].empty()) return true;
        }
        return false;
    };
    Selection.prototype.contains = function(pos, end) {
        if (!end) end = pos;
        for(var i = 0; i < this.ranges.length; i++){
            var range = this.ranges[i];
            if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0) return i;
        }
        return -1;
    };
    var Range = function(anchor, head) {
        this.anchor = anchor;
        this.head = head;
    };
    Range.prototype.from = function() {
        return minPos(this.anchor, this.head);
    };
    Range.prototype.to = function() {
        return maxPos(this.anchor, this.head);
    };
    Range.prototype.empty = function() {
        return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
    };
    // Take an unsorted, potentially overlapping set of ranges, and
    // build a selection out of it. 'Consumes' ranges array (modifying
    // it).
    function normalizeSelection(cm, ranges, primIndex) {
        var mayTouch = cm && cm.options.selectionsMayTouch;
        var prim = ranges[primIndex];
        ranges.sort(function(a, b) {
            return cmp(a.from(), b.from());
        });
        primIndex = indexOf(ranges, prim);
        for(var i = 1; i < ranges.length; i++){
            var cur = ranges[i], prev = ranges[i - 1];
            var diff = cmp(prev.to(), cur.from());
            if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
                var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
                var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
                if (i <= primIndex) --primIndex;
                ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
            }
        }
        return new Selection(ranges, primIndex);
    }
    function simpleSelection(anchor, head) {
        return new Selection([
            new Range(anchor, head || anchor)
        ], 0);
    }
    // Compute the position of the end of a change (its 'to' property
    // refers to the pre-change end).
    function changeEnd(change) {
        if (!change.text) return change.to;
        return Pos(change.from.line + change.text.length - 1, lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0));
    }
    // Adjust a position to refer to the post-change position of the
    // same text, or the end of the change if the change covers it.
    function adjustForChange(pos, change) {
        if (cmp(pos, change.from) < 0) return pos;
        if (cmp(pos, change.to) <= 0) return changeEnd(change);
        var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
        if (pos.line == change.to.line) ch += changeEnd(change).ch - change.to.ch;
        return Pos(line, ch);
    }
    function computeSelAfterChange(doc, change) {
        var out = [];
        for(var i = 0; i < doc.sel.ranges.length; i++){
            var range = doc.sel.ranges[i];
            out.push(new Range(adjustForChange(range.anchor, change), adjustForChange(range.head, change)));
        }
        return normalizeSelection(doc.cm, out, doc.sel.primIndex);
    }
    function offsetPos(pos, old, nw) {
        if (pos.line == old.line) return Pos(nw.line, pos.ch - old.ch + nw.ch);
        else return Pos(nw.line + (pos.line - old.line), pos.ch);
    }
    // Used by replaceSelections to allow moving the selection to the
    // start or around the replaced test. Hint may be "start" or "around".
    function computeReplacedSel(doc, changes, hint) {
        var out = [];
        var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
        for(var i = 0; i < changes.length; i++){
            var change = changes[i];
            var from = offsetPos(change.from, oldPrev, newPrev);
            var to = offsetPos(changeEnd(change), oldPrev, newPrev);
            oldPrev = change.to;
            newPrev = to;
            if (hint == "around") {
                var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
                out[i] = new Range(inv ? to : from, inv ? from : to);
            } else out[i] = new Range(from, from);
        }
        return new Selection(out, doc.sel.primIndex);
    }
    // Used to get the editor into a consistent state again when options change.
    function loadMode(cm) {
        cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
        resetModeState(cm);
    }
    function resetModeState(cm) {
        cm.doc.iter(function(line) {
            if (line.stateAfter) line.stateAfter = null;
            if (line.styles) line.styles = null;
        });
        cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
        startWorker(cm, 100);
        cm.state.modeGen++;
        if (cm.curOp) regChange(cm);
    }
    // DOCUMENT DATA STRUCTURE
    // By default, updates that start and end at the beginning of a line
    // are treated specially, in order to make the association of line
    // widgets and marker elements with the text behave more intuitive.
    function isWholeLineUpdate(doc, change) {
        return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" && (!doc.cm || doc.cm.options.wholeLineUpdateBefore);
    }
    // Perform a change on the document data structure.
    function updateDoc(doc, change, markedSpans, estimateHeight) {
        function spansFor(n) {
            return markedSpans ? markedSpans[n] : null;
        }
        function update(line, text, spans) {
            updateLine(line, text, spans, estimateHeight);
            signalLater(line, "change", line, change);
        }
        function linesFor(start, end) {
            var result = [];
            for(var i = start; i < end; ++i)result.push(new Line(text[i], spansFor(i), estimateHeight));
            return result;
        }
        var from = change.from, to = change.to, text = change.text;
        var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
        var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;
        // Adjust the line structure
        if (change.full) {
            doc.insert(0, linesFor(0, text.length));
            doc.remove(text.length, doc.size - text.length);
        } else if (isWholeLineUpdate(doc, change)) {
            // This is a whole-line replace. Treated specially to make
            // sure line objects move the way they are supposed to.
            var added = linesFor(0, text.length - 1);
            update(lastLine, lastLine.text, lastSpans);
            if (nlines) doc.remove(from.line, nlines);
            if (added.length) doc.insert(from.line, added);
        } else if (firstLine == lastLine) {
            if (text.length == 1) update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
            else {
                var added$1 = linesFor(1, text.length - 1);
                added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight));
                update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
                doc.insert(from.line + 1, added$1);
            }
        } else if (text.length == 1) {
            update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
            doc.remove(from.line + 1, nlines);
        } else {
            update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
            update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
            var added$2 = linesFor(1, text.length - 1);
            if (nlines > 1) doc.remove(from.line + 1, nlines - 1);
            doc.insert(from.line + 1, added$2);
        }
        signalLater(doc, "change", doc, change);
    }
    // Call f for all linked documents.
    function linkedDocs(doc, f, sharedHistOnly) {
        function propagate(doc, skip, sharedHist) {
            if (doc.linked) for(var i = 0; i < doc.linked.length; ++i){
                var rel = doc.linked[i];
                if (rel.doc == skip) continue;
                var shared = sharedHist && rel.sharedHist;
                if (sharedHistOnly && !shared) continue;
                f(rel.doc, shared);
                propagate(rel.doc, doc, shared);
            }
        }
        propagate(doc, null, true);
    }
    // Attach a document to an editor.
    function attachDoc(cm, doc) {
        if (doc.cm) throw new Error("This document is already in use.");
        cm.doc = doc;
        doc.cm = cm;
        estimateLineHeights(cm);
        loadMode(cm);
        setDirectionClass(cm);
        cm.options.direction = doc.direction;
        if (!cm.options.lineWrapping) findMaxLine(cm);
        cm.options.mode = doc.modeOption;
        regChange(cm);
    }
    function setDirectionClass(cm) {
        (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
    }
    function directionChanged(cm) {
        runInOp(cm, function() {
            setDirectionClass(cm);
            regChange(cm);
        });
    }
    function History(prev) {
        // Arrays of change events and selections. Doing something adds an
        // event to done and clears undo. Undoing moves events from done
        // to undone, redoing moves them in the other direction.
        this.done = [];
        this.undone = [];
        this.undoDepth = prev ? prev.undoDepth : Infinity;
        // Used to track when changes can be merged into a single undo
        // event
        this.lastModTime = this.lastSelTime = 0;
        this.lastOp = this.lastSelOp = null;
        this.lastOrigin = this.lastSelOrigin = null;
        // Used by the isClean() method
        this.generation = this.maxGeneration = prev ? prev.maxGeneration : 1;
    }
    // Create a history change event from an updateDoc-style change
    // object.
    function historyChangeFromChange(doc, change) {
        var histChange = {
            from: copyPos(change.from),
            to: changeEnd(change),
            text: getBetween(doc, change.from, change.to)
        };
        attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
        linkedDocs(doc, function(doc) {
            return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
        }, true);
        return histChange;
    }
    // Pop all selection events off the end of a history array. Stop at
    // a change event.
    function clearSelectionEvents(array) {
        while(array.length){
            var last = lst(array);
            if (last.ranges) array.pop();
            else break;
        }
    }
    // Find the top change event in the history. Pop off selection
    // events that are in the way.
    function lastChangeEvent(hist, force) {
        if (force) {
            clearSelectionEvents(hist.done);
            return lst(hist.done);
        } else if (hist.done.length && !lst(hist.done).ranges) return lst(hist.done);
        else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
            hist.done.pop();
            return lst(hist.done);
        }
    }
    // Register a change in the history. Merges changes that are within
    // a single operation, or are close together with an origin that
    // allows merging (starting with "+") into a single event.
    function addChangeToHistory(doc, change, selAfter, opId) {
        var hist = doc.history;
        hist.undone.length = 0;
        var time = +new Date, cur;
        var last;
        if ((hist.lastOp == opId || hist.lastOrigin == change.origin && change.origin && (change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500) || change.origin.charAt(0) == "*")) && (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
            // Merge this change into the last event
            last = lst(cur.changes);
            if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) // Optimized case for simple insertion -- don't want to add
            // new changesets for every character typed
            last.to = changeEnd(change);
            else // Add new sub-event
            cur.changes.push(historyChangeFromChange(doc, change));
        } else {
            // Can not be merged, start a new event.
            var before = lst(hist.done);
            if (!before || !before.ranges) pushSelectionToHistory(doc.sel, hist.done);
            cur = {
                changes: [
                    historyChangeFromChange(doc, change)
                ],
                generation: hist.generation
            };
            hist.done.push(cur);
            while(hist.done.length > hist.undoDepth){
                hist.done.shift();
                if (!hist.done[0].ranges) hist.done.shift();
            }
        }
        hist.done.push(selAfter);
        hist.generation = ++hist.maxGeneration;
        hist.lastModTime = hist.lastSelTime = time;
        hist.lastOp = hist.lastSelOp = opId;
        hist.lastOrigin = hist.lastSelOrigin = change.origin;
        if (!last) signal(doc, "historyAdded");
    }
    function selectionEventCanBeMerged(doc, origin, prev, sel) {
        var ch = origin.charAt(0);
        return ch == "*" || ch == "+" && prev.ranges.length == sel.ranges.length && prev.somethingSelected() == sel.somethingSelected() && new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500);
    }
    // Called whenever the selection changes, sets the new selection as
    // the pending selection in the history, and pushes the old pending
    // selection into the 'done' array when it was significantly
    // different (in number of selected ranges, emptiness, or time).
    function addSelectionToHistory(doc, sel, opId, options) {
        var hist = doc.history, origin = options && options.origin;
        // A new event is started when the previous origin does not match
        // the current, or the origins don't allow matching. Origins
        // starting with * are always merged, those starting with + are
        // merged when similar and close together in time.
        if (opId == hist.lastSelOp || origin && hist.lastSelOrigin == origin && (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin || selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))) hist.done[hist.done.length - 1] = sel;
        else pushSelectionToHistory(sel, hist.done);
        hist.lastSelTime = +new Date;
        hist.lastSelOrigin = origin;
        hist.lastSelOp = opId;
        if (options && options.clearRedo !== false) clearSelectionEvents(hist.undone);
    }
    function pushSelectionToHistory(sel, dest) {
        var top = lst(dest);
        if (!(top && top.ranges && top.equals(sel))) dest.push(sel);
    }
    // Used to store marked span information in the history.
    function attachLocalSpans(doc, change, from, to) {
        var existing = change["spans_" + doc.id], n = 0;
        doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function(line) {
            if (line.markedSpans) (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans;
            ++n;
        });
    }
    // When un/re-doing restores text containing marked spans, those
    // that have been explicitly cleared should not be restored.
    function removeClearedSpans(spans) {
        if (!spans) return null;
        var out;
        for(var i = 0; i < spans.length; ++i){
            if (spans[i].marker.explicitlyCleared) {
                if (!out) out = spans.slice(0, i);
            } else if (out) out.push(spans[i]);
        }
        return !out ? spans : out.length ? out : null;
    }
    // Retrieve and filter the old marked spans stored in a change event.
    function getOldSpans(doc, change) {
        var found = change["spans_" + doc.id];
        if (!found) return null;
        var nw = [];
        for(var i = 0; i < change.text.length; ++i)nw.push(removeClearedSpans(found[i]));
        return nw;
    }
    // Used for un/re-doing changes from the history. Combines the
    // result of computing the existing spans with the set of spans that
    // existed in the history (so that deleting around a span and then
    // undoing brings back the span).
    function mergeOldSpans(doc, change) {
        var old = getOldSpans(doc, change);
        var stretched = stretchSpansOverChange(doc, change);
        if (!old) return stretched;
        if (!stretched) return old;
        for(var i = 0; i < old.length; ++i){
            var oldCur = old[i], stretchCur = stretched[i];
            if (oldCur && stretchCur) spans: for(var j = 0; j < stretchCur.length; ++j){
                var span = stretchCur[j];
                for(var k = 0; k < oldCur.length; ++k){
                    if (oldCur[k].marker == span.marker) continue spans;
                }
                oldCur.push(span);
            }
            else if (stretchCur) old[i] = stretchCur;
        }
        return old;
    }
    // Used both to provide a JSON-safe object in .getHistory, and, when
    // detaching a document, to split the history in two
    function copyHistoryArray(events, newGroup, instantiateSel) {
        var copy = [];
        for(var i = 0; i < events.length; ++i){
            var event = events[i];
            if (event.ranges) {
                copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
                continue;
            }
            var changes = event.changes, newChanges = [];
            copy.push({
                changes: newChanges
            });
            for(var j = 0; j < changes.length; ++j){
                var change = changes[j], m = void 0;
                newChanges.push({
                    from: change.from,
                    to: change.to,
                    text: change.text
                });
                if (newGroup) for(var prop in change){
                    if (m = prop.match(/^spans_(\d+)$/)) {
                        if (indexOf(newGroup, Number(m[1])) > -1) {
                            lst(newChanges)[prop] = change[prop];
                            delete change[prop];
                        }
                    }
                }
            }
        }
        return copy;
    }
    // The 'scroll' parameter given to many of these indicated whether
    // the new cursor position should be scrolled into view after
    // modifying the selection.
    // If shift is held or the extend flag is set, extends a range to
    // include a given position (and optionally a second position).
    // Otherwise, simply returns the range between the given positions.
    // Used for cursor motion and such.
    function extendRange(range, head, other, extend) {
        if (extend) {
            var anchor = range.anchor;
            if (other) {
                var posBefore = cmp(head, anchor) < 0;
                if (posBefore != cmp(other, anchor) < 0) {
                    anchor = head;
                    head = other;
                } else if (posBefore != cmp(head, other) < 0) head = other;
            }
            return new Range(anchor, head);
        } else return new Range(other || head, head);
    }
    // Extend the primary selection range, discard the rest.
    function extendSelection(doc, head, other, options, extend) {
        if (extend == null) extend = doc.cm && (doc.cm.display.shift || doc.extend);
        setSelection(doc, new Selection([
            extendRange(doc.sel.primary(), head, other, extend)
        ], 0), options);
    }
    // Extend all selections (pos is an array of selections with length
    // equal the number of selections)
    function extendSelections(doc, heads, options) {
        var out = [];
        var extend = doc.cm && (doc.cm.display.shift || doc.extend);
        for(var i = 0; i < doc.sel.ranges.length; i++)out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend);
        var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
        setSelection(doc, newSel, options);
    }
    // Updates a single range in the selection.
    function replaceOneSelection(doc, i, range, options) {
        var ranges = doc.sel.ranges.slice(0);
        ranges[i] = range;
        setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
    }
    // Reset the selection to a single range.
    function setSimpleSelection(doc, anchor, head, options) {
        setSelection(doc, simpleSelection(anchor, head), options);
    }
    // Give beforeSelectionChange handlers a change to influence a
    // selection update.
    function filterSelectionChange(doc, sel, options) {
        var obj = {
            ranges: sel.ranges,
            update: function(ranges) {
                this.ranges = [];
                for(var i = 0; i < ranges.length; i++)this.ranges[i] = new Range(clipPos(doc, ranges[i].anchor), clipPos(doc, ranges[i].head));
            },
            origin: options && options.origin
        };
        signal(doc, "beforeSelectionChange", doc, obj);
        if (doc.cm) signal(doc.cm, "beforeSelectionChange", doc.cm, obj);
        if (obj.ranges != sel.ranges) return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1);
        else return sel;
    }
    function setSelectionReplaceHistory(doc, sel, options) {
        var done = doc.history.done, last = lst(done);
        if (last && last.ranges) {
            done[done.length - 1] = sel;
            setSelectionNoUndo(doc, sel, options);
        } else setSelection(doc, sel, options);
    }
    // Set a new selection.
    function setSelection(doc, sel, options) {
        setSelectionNoUndo(doc, sel, options);
        addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
    }
    function setSelectionNoUndo(doc, sel, options) {
        if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange")) sel = filterSelectionChange(doc, sel, options);
        var bias = options && options.bias || (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
        setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));
        if (!(options && options.scroll === false) && doc.cm && doc.cm.getOption("readOnly") != "nocursor") ensureCursorVisible(doc.cm);
    }
    function setSelectionInner(doc, sel) {
        if (sel.equals(doc.sel)) return;
        doc.sel = sel;
        if (doc.cm) {
            doc.cm.curOp.updateInput = 1;
            doc.cm.curOp.selectionChanged = true;
            signalCursorActivity(doc.cm);
        }
        signalLater(doc, "cursorActivity", doc);
    }
    // Verify that the selection does not partially select any atomic
    // marked ranges.
    function reCheckSelection(doc) {
        setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
    }
    // Return a selection that does not partially select any atomic
    // ranges.
    function skipAtomicInSelection(doc, sel, bias, mayClear) {
        var out;
        for(var i = 0; i < sel.ranges.length; i++){
            var range = sel.ranges[i];
            var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
            var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
            var newHead = range.head == range.anchor ? newAnchor : skipAtomic(doc, range.head, old && old.head, bias, mayClear);
            if (out || newAnchor != range.anchor || newHead != range.head) {
                if (!out) out = sel.ranges.slice(0, i);
                out[i] = new Range(newAnchor, newHead);
            }
        }
        return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel;
    }
    function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
        var line = getLine(doc, pos.line);
        if (line.markedSpans) for(var i = 0; i < line.markedSpans.length; ++i){
            var sp = line.markedSpans[i], m = sp.marker;
            // Determine if we should prevent the cursor being placed to the left/right of an atomic marker
            // Historically this was determined using the inclusiveLeft/Right option, but the new way to control it
            // is with selectLeft/Right
            var preventCursorLeft = "selectLeft" in m ? !m.selectLeft : m.inclusiveLeft;
            var preventCursorRight = "selectRight" in m ? !m.selectRight : m.inclusiveRight;
            if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) && (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
                if (mayClear) {
                    signal(m, "beforeCursorEnter");
                    if (m.explicitlyCleared) {
                        if (!line.markedSpans) break;
                        else {
                            --i;
                            continue;
                        }
                    }
                }
                if (!m.atomic) continue;
                if (oldPos) {
                    var near = m.find(dir < 0 ? 1 : -1), diff = void 0;
                    if (dir < 0 ? preventCursorRight : preventCursorLeft) near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null);
                    if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0)) return skipAtomicInner(doc, near, pos, dir, mayClear);
                }
                var far = m.find(dir < 0 ? -1 : 1);
                if (dir < 0 ? preventCursorLeft : preventCursorRight) far = movePos(doc, far, dir, far.line == pos.line ? line : null);
                return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null;
            }
        }
        return pos;
    }
    // Ensure a given position is not inside an atomic range.
    function skipAtomic(doc, pos, oldPos, bias, mayClear) {
        var dir = bias || 1;
        var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, dir, true) || skipAtomicInner(doc, pos, oldPos, -dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true);
        if (!found) {
            doc.cantEdit = true;
            return Pos(doc.first, 0);
        }
        return found;
    }
    function movePos(doc, pos, dir, line) {
        if (dir < 0 && pos.ch == 0) {
            if (pos.line > doc.first) return clipPos(doc, Pos(pos.line - 1));
            else return null;
        } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
            if (pos.line < doc.first + doc.size - 1) return Pos(pos.line + 1, 0);
            else return null;
        } else return new Pos(pos.line, pos.ch + dir);
    }
    function selectAll(cm) {
        cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
    }
    // UPDATING
    // Allow "beforeChange" event handlers to influence a change
    function filterChange(doc, change, update) {
        var obj = {
            canceled: false,
            from: change.from,
            to: change.to,
            text: change.text,
            origin: change.origin,
            cancel: function() {
                return obj.canceled = true;
            }
        };
        if (update) obj.update = function(from, to, text, origin) {
            if (from) obj.from = clipPos(doc, from);
            if (to) obj.to = clipPos(doc, to);
            if (text) obj.text = text;
            if (origin !== undefined) obj.origin = origin;
        };
        signal(doc, "beforeChange", doc, obj);
        if (doc.cm) signal(doc.cm, "beforeChange", doc.cm, obj);
        if (obj.canceled) {
            if (doc.cm) doc.cm.curOp.updateInput = 2;
            return null;
        }
        return {
            from: obj.from,
            to: obj.to,
            text: obj.text,
            origin: obj.origin
        };
    }
    // Apply a change to a document, and add it to the document's
    // history, and propagating it to all linked documents.
    function makeChange(doc, change, ignoreReadOnly) {
        if (doc.cm) {
            if (!doc.cm.curOp) return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly);
            if (doc.cm.state.suppressEdits) return;
        }
        if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
            change = filterChange(doc, change, true);
            if (!change) return;
        }
        // Possibly split or suppress the update based on the presence
        // of read-only spans in its range.
        var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
        if (split) for(var i = split.length - 1; i >= 0; --i)makeChangeInner(doc, {
            from: split[i].from,
            to: split[i].to,
            text: i ? [
                ""
            ] : change.text,
            origin: change.origin
        });
        else makeChangeInner(doc, change);
    }
    function makeChangeInner(doc, change) {
        if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) return;
        var selAfter = computeSelAfterChange(doc, change);
        addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);
        makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
        var rebased = [];
        linkedDocs(doc, function(doc, sharedHist) {
            if (!sharedHist && indexOf(rebased, doc.history) == -1) {
                rebaseHist(doc.history, change);
                rebased.push(doc.history);
            }
            makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
        });
    }
    // Revert a change stored in a document's history.
    function makeChangeFromHistory(doc, type, allowSelectionOnly) {
        var suppress = doc.cm && doc.cm.state.suppressEdits;
        if (suppress && !allowSelectionOnly) return;
        var hist = doc.history, event, selAfter = doc.sel;
        var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;
        // Verify that there is a useable event (so that ctrl-z won't
        // needlessly clear selection events)
        var i = 0;
        for(; i < source.length; i++){
            event = source[i];
            if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges) break;
        }
        if (i == source.length) return;
        hist.lastOrigin = hist.lastSelOrigin = null;
        for(;;){
            event = source.pop();
            if (event.ranges) {
                pushSelectionToHistory(event, dest);
                if (allowSelectionOnly && !event.equals(doc.sel)) {
                    setSelection(doc, event, {
                        clearRedo: false
                    });
                    return;
                }
                selAfter = event;
            } else if (suppress) {
                source.push(event);
                return;
            } else break;
        }
        // Build up a reverse change object to add to the opposite history
        // stack (redo when undoing, and vice versa).
        var antiChanges = [];
        pushSelectionToHistory(selAfter, dest);
        dest.push({
            changes: antiChanges,
            generation: hist.generation
        });
        hist.generation = event.generation || ++hist.maxGeneration;
        var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");
        var loop = function(i) {
            var change = event.changes[i];
            change.origin = type;
            if (filter && !filterChange(doc, change, false)) {
                source.length = 0;
                return {};
            }
            antiChanges.push(historyChangeFromChange(doc, change));
            var after = i ? computeSelAfterChange(doc, change) : lst(source);
            makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
            if (!i && doc.cm) doc.cm.scrollIntoView({
                from: change.from,
                to: changeEnd(change)
            });
            var rebased = [];
            // Propagate to the linked documents
            linkedDocs(doc, function(doc, sharedHist) {
                if (!sharedHist && indexOf(rebased, doc.history) == -1) {
                    rebaseHist(doc.history, change);
                    rebased.push(doc.history);
                }
                makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
            });
        };
        for(var i$1 = event.changes.length - 1; i$1 >= 0; --i$1){
            var returned = loop(i$1);
            if (returned) return returned.v;
        }
    }
    // Sub-views need their line numbers shifted when text is added
    // above or below them in the parent document.
    function shiftDoc(doc, distance) {
        if (distance == 0) return;
        doc.first += distance;
        doc.sel = new Selection(map(doc.sel.ranges, function(range) {
            return new Range(Pos(range.anchor.line + distance, range.anchor.ch), Pos(range.head.line + distance, range.head.ch));
        }), doc.sel.primIndex);
        if (doc.cm) {
            regChange(doc.cm, doc.first, doc.first - distance, distance);
            for(var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)regLineChange(doc.cm, l, "gutter");
        }
    }
    // More lower-level change function, handling only a single document
    // (not linked ones).
    function makeChangeSingleDoc(doc, change, selAfter, spans) {
        if (doc.cm && !doc.cm.curOp) return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans);
        if (change.to.line < doc.first) {
            shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
            return;
        }
        if (change.from.line > doc.lastLine()) return;
        // Clip the change to the size of this doc
        if (change.from.line < doc.first) {
            var shift = change.text.length - 1 - (doc.first - change.from.line);
            shiftDoc(doc, shift);
            change = {
                from: Pos(doc.first, 0),
                to: Pos(change.to.line + shift, change.to.ch),
                text: [
                    lst(change.text)
                ],
                origin: change.origin
            };
        }
        var last = doc.lastLine();
        if (change.to.line > last) change = {
            from: change.from,
            to: Pos(last, getLine(doc, last).text.length),
            text: [
                change.text[0]
            ],
            origin: change.origin
        };
        change.removed = getBetween(doc, change.from, change.to);
        if (!selAfter) selAfter = computeSelAfterChange(doc, change);
        if (doc.cm) makeChangeSingleDocInEditor(doc.cm, change, spans);
        else updateDoc(doc, change, spans);
        setSelectionNoUndo(doc, selAfter, sel_dontScroll);
        if (doc.cantEdit && skipAtomic(doc, Pos(doc.firstLine(), 0))) doc.cantEdit = false;
    }
    // Handle the interaction of a change to a document with the editor
    // that this document is part of.
    function makeChangeSingleDocInEditor(cm, change, spans) {
        var doc = cm.doc, display = cm.display, from = change.from, to = change.to;
        var recomputeMaxLength = false, checkWidthStart = from.line;
        if (!cm.options.lineWrapping) {
            checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
            doc.iter(checkWidthStart, to.line + 1, function(line) {
                if (line == display.maxLine) {
                    recomputeMaxLength = true;
                    return true;
                }
            });
        }
        if (doc.sel.contains(change.from, change.to) > -1) signalCursorActivity(cm);
        updateDoc(doc, change, spans, estimateHeight(cm));
        if (!cm.options.lineWrapping) {
            doc.iter(checkWidthStart, from.line + change.text.length, function(line) {
                var len = lineLength(line);
                if (len > display.maxLineLength) {
                    display.maxLine = line;
                    display.maxLineLength = len;
                    display.maxLineChanged = true;
                    recomputeMaxLength = false;
                }
            });
            if (recomputeMaxLength) cm.curOp.updateMaxLine = true;
        }
        retreatFrontier(doc, from.line);
        startWorker(cm, 400);
        var lendiff = change.text.length - (to.line - from.line) - 1;
        // Remember that these lines changed, for updating the display
        if (change.full) regChange(cm);
        else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change)) regLineChange(cm, from.line, "text");
        else regChange(cm, from.line, to.line + 1, lendiff);
        var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
        if (changeHandler || changesHandler) {
            var obj = {
                from: from,
                to: to,
                text: change.text,
                removed: change.removed,
                origin: change.origin
            };
            if (changeHandler) signalLater(cm, "change", cm, obj);
            if (changesHandler) (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj);
        }
        cm.display.selForContextMenu = null;
    }
    function replaceRange(doc, code, from, to, origin) {
        var assign;
        if (!to) to = from;
        if (cmp(to, from) < 0) assign = [
            to,
            from
        ], from = assign[0], to = assign[1];
        if (typeof code == "string") code = doc.splitLines(code);
        makeChange(doc, {
            from: from,
            to: to,
            text: code,
            origin: origin
        });
    }
    // Rebasing/resetting history to deal with externally-sourced changes
    function rebaseHistSelSingle(pos, from, to, diff) {
        if (to < pos.line) pos.line += diff;
        else if (from < pos.line) {
            pos.line = from;
            pos.ch = 0;
        }
    }
    // Tries to rebase an array of history events given a change in the
    // document. If the change touches the same lines as the event, the
    // event, and everything 'behind' it, is discarded. If the change is
    // before the event, the event's positions are updated. Uses a
    // copy-on-write scheme for the positions, to avoid having to
    // reallocate them all on every rebase, but also avoid problems with
    // shared position objects being unsafely updated.
    function rebaseHistArray(array, from, to, diff) {
        for(var i = 0; i < array.length; ++i){
            var sub = array[i], ok = true;
            if (sub.ranges) {
                if (!sub.copied) {
                    sub = array[i] = sub.deepCopy();
                    sub.copied = true;
                }
                for(var j = 0; j < sub.ranges.length; j++){
                    rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
                    rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
                }
                continue;
            }
            for(var j$1 = 0; j$1 < sub.changes.length; ++j$1){
                var cur = sub.changes[j$1];
                if (to < cur.from.line) {
                    cur.from = Pos(cur.from.line + diff, cur.from.ch);
                    cur.to = Pos(cur.to.line + diff, cur.to.ch);
                } else if (from <= cur.to.line) {
                    ok = false;
                    break;
                }
            }
            if (!ok) {
                array.splice(0, i + 1);
                i = 0;
            }
        }
    }
    function rebaseHist(hist, change) {
        var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
        rebaseHistArray(hist.done, from, to, diff);
        rebaseHistArray(hist.undone, from, to, diff);
    }
    // Utility for applying a change to a line by handle or number,
    // returning the number and optionally registering the line as
    // changed.
    function changeLine(doc, handle, changeType, op) {
        var no = handle, line = handle;
        if (typeof handle == "number") line = getLine(doc, clipLine(doc, handle));
        else no = lineNo(handle);
        if (no == null) return null;
        if (op(line, no) && doc.cm) regLineChange(doc.cm, no, changeType);
        return line;
    }
    // The document is represented as a BTree consisting of leaves, with
    // chunk of lines in them, and branches, with up to ten leaves or
    // other branch nodes below them. The top node is always a branch
    // node, and is the document object itself (meaning it has
    // additional methods and properties).
    //
    // All nodes have parent links. The tree is used both to go from
    // line numbers to line objects, and to go from objects to numbers.
    // It also indexes by height, and is used to convert between height
    // and line object, and to find the total height of the document.
    //
    // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
    function LeafChunk(lines) {
        this.lines = lines;
        this.parent = null;
        var height = 0;
        for(var i = 0; i < lines.length; ++i){
            lines[i].parent = this;
            height += lines[i].height;
        }
        this.height = height;
    }
    LeafChunk.prototype = {
        chunkSize: function() {
            return this.lines.length;
        },
        // Remove the n lines at offset 'at'.
        removeInner: function(at, n) {
            for(var i = at, e = at + n; i < e; ++i){
                var line = this.lines[i];
                this.height -= line.height;
                cleanUpLine(line);
                signalLater(line, "delete");
            }
            this.lines.splice(at, n);
        },
        // Helper used to collapse a small branch into a single leaf.
        collapse: function(lines) {
            lines.push.apply(lines, this.lines);
        },
        // Insert the given array of lines at offset 'at', count them as
        // having the given height.
        insertInner: function(at, lines, height) {
            this.height += height;
            this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
            for(var i = 0; i < lines.length; ++i)lines[i].parent = this;
        },
        // Used to iterate over a part of the tree.
        iterN: function(at, n, op) {
            for(var e = at + n; at < e; ++at){
                if (op(this.lines[at])) return true;
            }
        }
    };
    function BranchChunk(children) {
        this.children = children;
        var size = 0, height = 0;
        for(var i = 0; i < children.length; ++i){
            var ch = children[i];
            size += ch.chunkSize();
            height += ch.height;
            ch.parent = this;
        }
        this.size = size;
        this.height = height;
        this.parent = null;
    }
    BranchChunk.prototype = {
        chunkSize: function() {
            return this.size;
        },
        removeInner: function(at, n) {
            this.size -= n;
            for(var i = 0; i < this.children.length; ++i){
                var child = this.children[i], sz = child.chunkSize();
                if (at < sz) {
                    var rm = Math.min(n, sz - at), oldHeight = child.height;
                    child.removeInner(at, rm);
                    this.height -= oldHeight - child.height;
                    if (sz == rm) {
                        this.children.splice(i--, 1);
                        child.parent = null;
                    }
                    if ((n -= rm) == 0) break;
                    at = 0;
                } else at -= sz;
            }
            // If the result is smaller than 25 lines, ensure that it is a
            // single leaf node.
            if (this.size - n < 25 && (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
                var lines = [];
                this.collapse(lines);
                this.children = [
                    new LeafChunk(lines)
                ];
                this.children[0].parent = this;
            }
        },
        collapse: function(lines) {
            for(var i = 0; i < this.children.length; ++i)this.children[i].collapse(lines);
        },
        insertInner: function(at, lines, height) {
            this.size += lines.length;
            this.height += height;
            for(var i = 0; i < this.children.length; ++i){
                var child = this.children[i], sz = child.chunkSize();
                if (at <= sz) {
                    child.insertInner(at, lines, height);
                    if (child.lines && child.lines.length > 50) {
                        // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
                        // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
                        var remaining = child.lines.length % 25 + 25;
                        for(var pos = remaining; pos < child.lines.length;){
                            var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
                            child.height -= leaf.height;
                            this.children.splice(++i, 0, leaf);
                            leaf.parent = this;
                        }
                        child.lines = child.lines.slice(0, remaining);
                        this.maybeSpill();
                    }
                    break;
                }
                at -= sz;
            }
        },
        // When a node has grown, check whether it should be split.
        maybeSpill: function() {
            if (this.children.length <= 10) return;
            var me = this;
            do {
                var spilled = me.children.splice(me.children.length - 5, 5);
                var sibling = new BranchChunk(spilled);
                if (!me.parent) {
                    var copy = new BranchChunk(me.children);
                    copy.parent = me;
                    me.children = [
                        copy,
                        sibling
                    ];
                    me = copy;
                } else {
                    me.size -= sibling.size;
                    me.height -= sibling.height;
                    var myIndex = indexOf(me.parent.children, me);
                    me.parent.children.splice(myIndex + 1, 0, sibling);
                }
                sibling.parent = me.parent;
            }while (me.children.length > 10);
            me.parent.maybeSpill();
        },
        iterN: function(at, n, op) {
            for(var i = 0; i < this.children.length; ++i){
                var child = this.children[i], sz = child.chunkSize();
                if (at < sz) {
                    var used = Math.min(n, sz - at);
                    if (child.iterN(at, used, op)) return true;
                    if ((n -= used) == 0) break;
                    at = 0;
                } else at -= sz;
            }
        }
    };
    // Line widgets are block elements displayed above or below a line.
    var LineWidget = function(doc, node, options) {
        if (options) {
            for(var opt in options)if (options.hasOwnProperty(opt)) this[opt] = options[opt];
        }
        this.doc = doc;
        this.node = node;
    };
    LineWidget.prototype.clear = function() {
        var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
        if (no == null || !ws) return;
        for(var i = 0; i < ws.length; ++i)if (ws[i] == this) ws.splice(i--, 1);
        if (!ws.length) line.widgets = null;
        var height = widgetHeight(this);
        updateLineHeight(line, Math.max(0, line.height - height));
        if (cm) {
            runInOp(cm, function() {
                adjustScrollWhenAboveVisible(cm, line, -height);
                regLineChange(cm, no, "widget");
            });
            signalLater(cm, "lineWidgetCleared", cm, this, no);
        }
    };
    LineWidget.prototype.changed = function() {
        var this$1 = this;
        var oldH = this.height, cm = this.doc.cm, line = this.line;
        this.height = null;
        var diff = widgetHeight(this) - oldH;
        if (!diff) return;
        if (!lineIsHidden(this.doc, line)) updateLineHeight(line, line.height + diff);
        if (cm) runInOp(cm, function() {
            cm.curOp.forceUpdate = true;
            adjustScrollWhenAboveVisible(cm, line, diff);
            signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
        });
    };
    eventMixin(LineWidget);
    function adjustScrollWhenAboveVisible(cm, line, diff) {
        if (heightAtLine(line) < (cm.curOp && cm.curOp.scrollTop || cm.doc.scrollTop)) addToScrollTop(cm, diff);
    }
    function addLineWidget(doc, handle, node, options) {
        var widget = new LineWidget(doc, node, options);
        var cm = doc.cm;
        if (cm && widget.noHScroll) cm.display.alignWidgets = true;
        changeLine(doc, handle, "widget", function(line) {
            var widgets = line.widgets || (line.widgets = []);
            if (widget.insertAt == null) widgets.push(widget);
            else widgets.splice(Math.min(widgets.length, Math.max(0, widget.insertAt)), 0, widget);
            widget.line = line;
            if (cm && !lineIsHidden(doc, line)) {
                var aboveVisible = heightAtLine(line) < doc.scrollTop;
                updateLineHeight(line, line.height + widgetHeight(widget));
                if (aboveVisible) addToScrollTop(cm, widget.height);
                cm.curOp.forceUpdate = true;
            }
            return true;
        });
        if (cm) signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle));
        return widget;
    }
    // TEXTMARKERS
    // Created with markText and setBookmark methods. A TextMarker is a
    // handle that can be used to clear or find a marked position in the
    // document. Line objects hold arrays (markedSpans) containing
    // {from, to, marker} object pointing to such marker objects, and
    // indicating that such a marker is present on that line. Multiple
    // lines may point to the same marker when it spans across lines.
    // The spans will have null for their from/to properties when the
    // marker continues beyond the start/end of the line. Markers have
    // links back to the lines they currently touch.
    // Collapsed markers have unique ids, in order to be able to order
    // them, which is needed for uniquely determining an outer marker
    // when they overlap (they may nest, but not partially overlap).
    var nextMarkerId = 0;
    var TextMarker = function(doc, type) {
        this.lines = [];
        this.type = type;
        this.doc = doc;
        this.id = ++nextMarkerId;
    };
    // Clear the marker.
    TextMarker.prototype.clear = function() {
        if (this.explicitlyCleared) return;
        var cm = this.doc.cm, withOp = cm && !cm.curOp;
        if (withOp) startOperation(cm);
        if (hasHandler(this, "clear")) {
            var found = this.find();
            if (found) signalLater(this, "clear", found.from, found.to);
        }
        var min = null, max = null;
        for(var i = 0; i < this.lines.length; ++i){
            var line = this.lines[i];
            var span = getMarkedSpanFor(line.markedSpans, this);
            if (cm && !this.collapsed) regLineChange(cm, lineNo(line), "text");
            else if (cm) {
                if (span.to != null) max = lineNo(line);
                if (span.from != null) min = lineNo(line);
            }
            line.markedSpans = removeMarkedSpan(line.markedSpans, span);
            if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm) updateLineHeight(line, textHeight(cm.display));
        }
        if (cm && this.collapsed && !cm.options.lineWrapping) for(var i$1 = 0; i$1 < this.lines.length; ++i$1){
            var visual = visualLine(this.lines[i$1]), len = lineLength(visual);
            if (len > cm.display.maxLineLength) {
                cm.display.maxLine = visual;
                cm.display.maxLineLength = len;
                cm.display.maxLineChanged = true;
            }
        }
        if (min != null && cm && this.collapsed) regChange(cm, min, max + 1);
        this.lines.length = 0;
        this.explicitlyCleared = true;
        if (this.atomic && this.doc.cantEdit) {
            this.doc.cantEdit = false;
            if (cm) reCheckSelection(cm.doc);
        }
        if (cm) signalLater(cm, "markerCleared", cm, this, min, max);
        if (withOp) endOperation(cm);
        if (this.parent) this.parent.clear();
    };
    // Find the position of the marker in the document. Returns a {from,
    // to} object by default. Side can be passed to get a specific side
    // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
    // Pos objects returned contain a line object, rather than a line
    // number (used to prevent looking up the same line twice).
    TextMarker.prototype.find = function(side, lineObj) {
        if (side == null && this.type == "bookmark") side = 1;
        var from, to;
        for(var i = 0; i < this.lines.length; ++i){
            var line = this.lines[i];
            var span = getMarkedSpanFor(line.markedSpans, this);
            if (span.from != null) {
                from = Pos(lineObj ? line : lineNo(line), span.from);
                if (side == -1) return from;
            }
            if (span.to != null) {
                to = Pos(lineObj ? line : lineNo(line), span.to);
                if (side == 1) return to;
            }
        }
        return from && {
            from: from,
            to: to
        };
    };
    // Signals that the marker's widget changed, and surrounding layout
    // should be recomputed.
    TextMarker.prototype.changed = function() {
        var this$1 = this;
        var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
        if (!pos || !cm) return;
        runInOp(cm, function() {
            var line = pos.line, lineN = lineNo(pos.line);
            var view = findViewForLine(cm, lineN);
            if (view) {
                clearLineMeasurementCacheFor(view);
                cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
            }
            cm.curOp.updateMaxLine = true;
            if (!lineIsHidden(widget.doc, line) && widget.height != null) {
                var oldHeight = widget.height;
                widget.height = null;
                var dHeight = widgetHeight(widget) - oldHeight;
                if (dHeight) updateLineHeight(line, line.height + dHeight);
            }
            signalLater(cm, "markerChanged", cm, this$1);
        });
    };
    TextMarker.prototype.attachLine = function(line) {
        if (!this.lines.length && this.doc.cm) {
            var op = this.doc.cm.curOp;
            if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1) (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this);
        }
        this.lines.push(line);
    };
    TextMarker.prototype.detachLine = function(line) {
        this.lines.splice(indexOf(this.lines, line), 1);
        if (!this.lines.length && this.doc.cm) {
            var op = this.doc.cm.curOp;
            (op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
        }
    };
    eventMixin(TextMarker);
    // Create a marker, wire it up to the right lines, and
    function markText(doc, from, to, options, type) {
        // Shared markers (across linked documents) are handled separately
        // (markTextShared will call out to this again, once per
        // document).
        if (options && options.shared) return markTextShared(doc, from, to, options, type);
        // Ensure we are in an operation.
        if (doc.cm && !doc.cm.curOp) return operation(doc.cm, markText)(doc, from, to, options, type);
        var marker = new TextMarker(doc, type), diff = cmp(from, to);
        if (options) copyObj(options, marker, false);
        // Don't connect empty markers unless clearWhenEmpty is false
        if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false) return marker;
        if (marker.replacedWith) {
            // Showing up as a widget implies collapsed (widget replaces text)
            marker.collapsed = true;
            marker.widgetNode = eltP("span", [
                marker.replacedWith
            ], "CodeMirror-widget");
            if (!options.handleMouseEvents) marker.widgetNode.setAttribute("cm-ignore-events", "true");
            if (options.insertLeft) marker.widgetNode.insertLeft = true;
        }
        if (marker.collapsed) {
            if (conflictingCollapsedRange(doc, from.line, from, to, marker) || from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker)) throw new Error("Inserting collapsed marker partially overlapping an existing one");
            seeCollapsedSpans();
        }
        if (marker.addToHistory) addChangeToHistory(doc, {
            from: from,
            to: to,
            origin: "markText"
        }, doc.sel, NaN);
        var curLine = from.line, cm = doc.cm, updateMaxLine;
        doc.iter(curLine, to.line + 1, function(line) {
            if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine) updateMaxLine = true;
            if (marker.collapsed && curLine != from.line) updateLineHeight(line, 0);
            addMarkedSpan(line, new MarkedSpan(marker, curLine == from.line ? from.ch : null, curLine == to.line ? to.ch : null), doc.cm && doc.cm.curOp);
            ++curLine;
        });
        // lineIsHidden depends on the presence of the spans, so needs a second pass
        if (marker.collapsed) doc.iter(from.line, to.line + 1, function(line) {
            if (lineIsHidden(doc, line)) updateLineHeight(line, 0);
        });
        if (marker.clearOnEnter) on(marker, "beforeCursorEnter", function() {
            return marker.clear();
        });
        if (marker.readOnly) {
            seeReadOnlySpans();
            if (doc.history.done.length || doc.history.undone.length) doc.clearHistory();
        }
        if (marker.collapsed) {
            marker.id = ++nextMarkerId;
            marker.atomic = true;
        }
        if (cm) {
            // Sync editor state
            if (updateMaxLine) cm.curOp.updateMaxLine = true;
            if (marker.collapsed) regChange(cm, from.line, to.line + 1);
            else if (marker.className || marker.startStyle || marker.endStyle || marker.css || marker.attributes || marker.title) for(var i = from.line; i <= to.line; i++)regLineChange(cm, i, "text");
            if (marker.atomic) reCheckSelection(cm.doc);
            signalLater(cm, "markerAdded", cm, marker);
        }
        return marker;
    }
    // SHARED TEXTMARKERS
    // A shared marker spans multiple linked documents. It is
    // implemented as a meta-marker-object controlling multiple normal
    // markers.
    var SharedTextMarker = function(markers, primary) {
        this.markers = markers;
        this.primary = primary;
        for(var i = 0; i < markers.length; ++i)markers[i].parent = this;
    };
    SharedTextMarker.prototype.clear = function() {
        if (this.explicitlyCleared) return;
        this.explicitlyCleared = true;
        for(var i = 0; i < this.markers.length; ++i)this.markers[i].clear();
        signalLater(this, "clear");
    };
    SharedTextMarker.prototype.find = function(side, lineObj) {
        return this.primary.find(side, lineObj);
    };
    eventMixin(SharedTextMarker);
    function markTextShared(doc, from, to, options, type) {
        options = copyObj(options);
        options.shared = false;
        var markers = [
            markText(doc, from, to, options, type)
        ], primary = markers[0];
        var widget = options.widgetNode;
        linkedDocs(doc, function(doc) {
            if (widget) options.widgetNode = widget.cloneNode(true);
            markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
            for(var i = 0; i < doc.linked.length; ++i){
                if (doc.linked[i].isParent) return;
            }
            primary = lst(markers);
        });
        return new SharedTextMarker(markers, primary);
    }
    function findSharedMarkers(doc) {
        return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function(m) {
            return m.parent;
        });
    }
    function copySharedMarkers(doc, markers) {
        for(var i = 0; i < markers.length; i++){
            var marker = markers[i], pos = marker.find();
            var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
            if (cmp(mFrom, mTo)) {
                var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
                marker.markers.push(subMark);
                subMark.parent = marker;
            }
        }
    }
    function detachSharedMarkers(markers) {
        var loop = function(i) {
            var marker = markers[i], linked = [
                marker.primary.doc
            ];
            linkedDocs(marker.primary.doc, function(d) {
                return linked.push(d);
            });
            for(var j = 0; j < marker.markers.length; j++){
                var subMarker = marker.markers[j];
                if (indexOf(linked, subMarker.doc) == -1) {
                    subMarker.parent = null;
                    marker.markers.splice(j--, 1);
                }
            }
        };
        for(var i = 0; i < markers.length; i++)loop(i);
    }
    var nextDocId = 0;
    var Doc = function(text, mode, firstLine, lineSep, direction) {
        if (!(this instanceof Doc)) return new Doc(text, mode, firstLine, lineSep, direction);
        if (firstLine == null) firstLine = 0;
        BranchChunk.call(this, [
            new LeafChunk([
                new Line("", null)
            ])
        ]);
        this.first = firstLine;
        this.scrollTop = this.scrollLeft = 0;
        this.cantEdit = false;
        this.cleanGeneration = 1;
        this.modeFrontier = this.highlightFrontier = firstLine;
        var start = Pos(firstLine, 0);
        this.sel = simpleSelection(start);
        this.history = new History(null);
        this.id = ++nextDocId;
        this.modeOption = mode;
        this.lineSep = lineSep;
        this.direction = direction == "rtl" ? "rtl" : "ltr";
        this.extend = false;
        if (typeof text == "string") text = this.splitLines(text);
        updateDoc(this, {
            from: start,
            to: start,
            text: text
        });
        setSelection(this, simpleSelection(start), sel_dontScroll);
    };
    Doc.prototype = createObj(BranchChunk.prototype, {
        constructor: Doc,
        // Iterate over the document. Supports two forms -- with only one
        // argument, it calls that for each line in the document. With
        // three, it iterates over the range given by the first two (with
        // the second being non-inclusive).
        iter: function(from, to, op) {
            if (op) this.iterN(from - this.first, to - from, op);
            else this.iterN(this.first, this.first + this.size, from);
        },
        // Non-public interface for adding and removing lines.
        insert: function(at, lines) {
            var height = 0;
            for(var i = 0; i < lines.length; ++i)height += lines[i].height;
            this.insertInner(at - this.first, lines, height);
        },
        remove: function(at, n) {
            this.removeInner(at - this.first, n);
        },
        // From here, the methods are part of the public interface. Most
        // are also available from CodeMirror (editor) instances.
        getValue: function(lineSep) {
            var lines = getLines(this, this.first, this.first + this.size);
            if (lineSep === false) return lines;
            return lines.join(lineSep || this.lineSeparator());
        },
        setValue: docMethodOp(function(code) {
            var top = Pos(this.first, 0), last = this.first + this.size - 1;
            makeChange(this, {
                from: top,
                to: Pos(last, getLine(this, last).text.length),
                text: this.splitLines(code),
                origin: "setValue",
                full: true
            }, true);
            if (this.cm) scrollToCoords(this.cm, 0, 0);
            setSelection(this, simpleSelection(top), sel_dontScroll);
        }),
        replaceRange: function(code, from, to, origin) {
            from = clipPos(this, from);
            to = to ? clipPos(this, to) : from;
            replaceRange(this, code, from, to, origin);
        },
        getRange: function(from, to, lineSep) {
            var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
            if (lineSep === false) return lines;
            if (lineSep === '') return lines.join('');
            return lines.join(lineSep || this.lineSeparator());
        },
        getLine: function(line) {
            var l = this.getLineHandle(line);
            return l && l.text;
        },
        getLineHandle: function(line) {
            if (isLine(this, line)) return getLine(this, line);
        },
        getLineNumber: function(line) {
            return lineNo(line);
        },
        getLineHandleVisualStart: function(line) {
            if (typeof line == "number") line = getLine(this, line);
            return visualLine(line);
        },
        lineCount: function() {
            return this.size;
        },
        firstLine: function() {
            return this.first;
        },
        lastLine: function() {
            return this.first + this.size - 1;
        },
        clipPos: function(pos) {
            return clipPos(this, pos);
        },
        getCursor: function(start) {
            var range = this.sel.primary(), pos;
            if (start == null || start == "head") pos = range.head;
            else if (start == "anchor") pos = range.anchor;
            else if (start == "end" || start == "to" || start === false) pos = range.to();
            else pos = range.from();
            return pos;
        },
        listSelections: function() {
            return this.sel.ranges;
        },
        somethingSelected: function() {
            return this.sel.somethingSelected();
        },
        setCursor: docMethodOp(function(line, ch, options) {
            setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
        }),
        setSelection: docMethodOp(function(anchor, head, options) {
            setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
        }),
        extendSelection: docMethodOp(function(head, other, options) {
            extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
        }),
        extendSelections: docMethodOp(function(heads, options) {
            extendSelections(this, clipPosArray(this, heads), options);
        }),
        extendSelectionsBy: docMethodOp(function(f, options) {
            var heads = map(this.sel.ranges, f);
            extendSelections(this, clipPosArray(this, heads), options);
        }),
        setSelections: docMethodOp(function(ranges, primary, options) {
            if (!ranges.length) return;
            var out = [];
            for(var i = 0; i < ranges.length; i++)out[i] = new Range(clipPos(this, ranges[i].anchor), clipPos(this, ranges[i].head || ranges[i].anchor));
            if (primary == null) primary = Math.min(ranges.length - 1, this.sel.primIndex);
            setSelection(this, normalizeSelection(this.cm, out, primary), options);
        }),
        addSelection: docMethodOp(function(anchor, head, options) {
            var ranges = this.sel.ranges.slice(0);
            ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
            setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
        }),
        getSelection: function(lineSep) {
            var ranges = this.sel.ranges, lines;
            for(var i = 0; i < ranges.length; i++){
                var sel = getBetween(this, ranges[i].from(), ranges[i].to());
                lines = lines ? lines.concat(sel) : sel;
            }
            if (lineSep === false) return lines;
            else return lines.join(lineSep || this.lineSeparator());
        },
        getSelections: function(lineSep) {
            var parts = [], ranges = this.sel.ranges;
            for(var i = 0; i < ranges.length; i++){
                var sel = getBetween(this, ranges[i].from(), ranges[i].to());
                if (lineSep !== false) sel = sel.join(lineSep || this.lineSeparator());
                parts[i] = sel;
            }
            return parts;
        },
        replaceSelection: function(code, collapse, origin) {
            var dup = [];
            for(var i = 0; i < this.sel.ranges.length; i++)dup[i] = code;
            this.replaceSelections(dup, collapse, origin || "+input");
        },
        replaceSelections: docMethodOp(function(code, collapse, origin) {
            var changes = [], sel = this.sel;
            for(var i = 0; i < sel.ranges.length; i++){
                var range = sel.ranges[i];
                changes[i] = {
                    from: range.from(),
                    to: range.to(),
                    text: this.splitLines(code[i]),
                    origin: origin
                };
            }
            var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
            for(var i$1 = changes.length - 1; i$1 >= 0; i$1--)makeChange(this, changes[i$1]);
            if (newSel) setSelectionReplaceHistory(this, newSel);
            else if (this.cm) ensureCursorVisible(this.cm);
        }),
        undo: docMethodOp(function() {
            makeChangeFromHistory(this, "undo");
        }),
        redo: docMethodOp(function() {
            makeChangeFromHistory(this, "redo");
        }),
        undoSelection: docMethodOp(function() {
            makeChangeFromHistory(this, "undo", true);
        }),
        redoSelection: docMethodOp(function() {
            makeChangeFromHistory(this, "redo", true);
        }),
        setExtending: function(val) {
            this.extend = val;
        },
        getExtending: function() {
            return this.extend;
        },
        historySize: function() {
            var hist = this.history, done = 0, undone = 0;
            for(var i = 0; i < hist.done.length; i++)if (!hist.done[i].ranges) ++done;
            for(var i$1 = 0; i$1 < hist.undone.length; i$1++)if (!hist.undone[i$1].ranges) ++undone;
            return {
                undo: done,
                redo: undone
            };
        },
        clearHistory: function() {
            var this$1 = this;
            this.history = new History(this.history);
            linkedDocs(this, function(doc) {
                return doc.history = this$1.history;
            }, true);
        },
        markClean: function() {
            this.cleanGeneration = this.changeGeneration(true);
        },
        changeGeneration: function(forceSplit) {
            if (forceSplit) this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null;
            return this.history.generation;
        },
        isClean: function(gen) {
            return this.history.generation == (gen || this.cleanGeneration);
        },
        getHistory: function() {
            return {
                done: copyHistoryArray(this.history.done),
                undone: copyHistoryArray(this.history.undone)
            };
        },
        setHistory: function(histData) {
            var hist = this.history = new History(this.history);
            hist.done = copyHistoryArray(histData.done.slice(0), null, true);
            hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
        },
        setGutterMarker: docMethodOp(function(line, gutterID, value) {
            return changeLine(this, line, "gutter", function(line) {
                var markers = line.gutterMarkers || (line.gutterMarkers = {});
                markers[gutterID] = value;
                if (!value && isEmpty(markers)) line.gutterMarkers = null;
                return true;
            });
        }),
        clearGutter: docMethodOp(function(gutterID) {
            var this$1 = this;
            this.iter(function(line) {
                if (line.gutterMarkers && line.gutterMarkers[gutterID]) changeLine(this$1, line, "gutter", function() {
                    line.gutterMarkers[gutterID] = null;
                    if (isEmpty(line.gutterMarkers)) line.gutterMarkers = null;
                    return true;
                });
            });
        }),
        lineInfo: function(line) {
            var n;
            if (typeof line == "number") {
                if (!isLine(this, line)) return null;
                n = line;
                line = getLine(this, line);
                if (!line) return null;
            } else {
                n = lineNo(line);
                if (n == null) return null;
            }
            return {
                line: n,
                handle: line,
                text: line.text,
                gutterMarkers: line.gutterMarkers,
                textClass: line.textClass,
                bgClass: line.bgClass,
                wrapClass: line.wrapClass,
                widgets: line.widgets
            };
        },
        addLineClass: docMethodOp(function(handle, where, cls) {
            return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
                var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
                if (!line[prop]) line[prop] = cls;
                else if (classTest(cls).test(line[prop])) return false;
                else line[prop] += " " + cls;
                return true;
            });
        }),
        removeLineClass: docMethodOp(function(handle, where, cls) {
            return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
                var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
                var cur = line[prop];
                if (!cur) return false;
                else if (cls == null) line[prop] = null;
                else {
                    var found = cur.match(classTest(cls));
                    if (!found) return false;
                    var end = found.index + found[0].length;
                    line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
                }
                return true;
            });
        }),
        addLineWidget: docMethodOp(function(handle, node, options) {
            return addLineWidget(this, handle, node, options);
        }),
        removeLineWidget: function(widget) {
            widget.clear();
        },
        markText: function(from, to, options) {
            return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range");
        },
        setBookmark: function(pos, options) {
            var realOpts = {
                replacedWith: options && (options.nodeType == null ? options.widget : options),
                insertLeft: options && options.insertLeft,
                clearWhenEmpty: false,
                shared: options && options.shared,
                handleMouseEvents: options && options.handleMouseEvents
            };
            pos = clipPos(this, pos);
            return markText(this, pos, pos, realOpts, "bookmark");
        },
        findMarksAt: function(pos) {
            pos = clipPos(this, pos);
            var markers = [], spans = getLine(this, pos.line).markedSpans;
            if (spans) for(var i = 0; i < spans.length; ++i){
                var span = spans[i];
                if ((span.from == null || span.from <= pos.ch) && (span.to == null || span.to >= pos.ch)) markers.push(span.marker.parent || span.marker);
            }
            return markers;
        },
        findMarks: function(from, to, filter) {
            from = clipPos(this, from);
            to = clipPos(this, to);
            var found = [], lineNo = from.line;
            this.iter(from.line, to.line + 1, function(line) {
                var spans = line.markedSpans;
                if (spans) for(var i = 0; i < spans.length; i++){
                    var span = spans[i];
                    if (!(span.to != null && lineNo == from.line && from.ch >= span.to || span.from == null && lineNo != from.line || span.from != null && lineNo == to.line && span.from >= to.ch) && (!filter || filter(span.marker))) found.push(span.marker.parent || span.marker);
                }
                ++lineNo;
            });
            return found;
        },
        getAllMarks: function() {
            var markers = [];
            this.iter(function(line) {
                var sps = line.markedSpans;
                if (sps) {
                    for(var i = 0; i < sps.length; ++i)if (sps[i].from != null) markers.push(sps[i].marker);
                }
            });
            return markers;
        },
        posFromIndex: function(off) {
            var ch, lineNo = this.first, sepSize = this.lineSeparator().length;
            this.iter(function(line) {
                var sz = line.text.length + sepSize;
                if (sz > off) {
                    ch = off;
                    return true;
                }
                off -= sz;
                ++lineNo;
            });
            return clipPos(this, Pos(lineNo, ch));
        },
        indexFromPos: function(coords) {
            coords = clipPos(this, coords);
            var index = coords.ch;
            if (coords.line < this.first || coords.ch < 0) return 0;
            var sepSize = this.lineSeparator().length;
            this.iter(this.first, coords.line, function(line) {
                index += line.text.length + sepSize;
            });
            return index;
        },
        copy: function(copyHistory) {
            var doc = new Doc(getLines(this, this.first, this.first + this.size), this.modeOption, this.first, this.lineSep, this.direction);
            doc.scrollTop = this.scrollTop;
            doc.scrollLeft = this.scrollLeft;
            doc.sel = this.sel;
            doc.extend = false;
            if (copyHistory) {
                doc.history.undoDepth = this.history.undoDepth;
                doc.setHistory(this.getHistory());
            }
            return doc;
        },
        linkedDoc: function(options) {
            if (!options) options = {};
            var from = this.first, to = this.first + this.size;
            if (options.from != null && options.from > from) from = options.from;
            if (options.to != null && options.to < to) to = options.to;
            var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
            if (options.sharedHist) copy.history = this.history;
            (this.linked || (this.linked = [])).push({
                doc: copy,
                sharedHist: options.sharedHist
            });
            copy.linked = [
                {
                    doc: this,
                    isParent: true,
                    sharedHist: options.sharedHist
                }
            ];
            copySharedMarkers(copy, findSharedMarkers(this));
            return copy;
        },
        unlinkDoc: function(other) {
            if (other instanceof CodeMirror) other = other.doc;
            if (this.linked) for(var i = 0; i < this.linked.length; ++i){
                var link = this.linked[i];
                if (link.doc != other) continue;
                this.linked.splice(i, 1);
                other.unlinkDoc(this);
                detachSharedMarkers(findSharedMarkers(this));
                break;
            }
            // If the histories were shared, split them again
            if (other.history == this.history) {
                var splitIds = [
                    other.id
                ];
                linkedDocs(other, function(doc) {
                    return splitIds.push(doc.id);
                }, true);
                other.history = new History(null);
                other.history.done = copyHistoryArray(this.history.done, splitIds);
                other.history.undone = copyHistoryArray(this.history.undone, splitIds);
            }
        },
        iterLinkedDocs: function(f) {
            linkedDocs(this, f);
        },
        getMode: function() {
            return this.mode;
        },
        getEditor: function() {
            return this.cm;
        },
        splitLines: function(str) {
            if (this.lineSep) return str.split(this.lineSep);
            return splitLinesAuto(str);
        },
        lineSeparator: function() {
            return this.lineSep || "\n";
        },
        setDirection: docMethodOp(function(dir) {
            if (dir != "rtl") dir = "ltr";
            if (dir == this.direction) return;
            this.direction = dir;
            this.iter(function(line) {
                return line.order = null;
            });
            if (this.cm) directionChanged(this.cm);
        })
    });
    // Public alias.
    Doc.prototype.eachLine = Doc.prototype.iter;
    // Kludge to work around strange IE behavior where it'll sometimes
    // re-fire a series of drag-related events right after the drop (#1551)
    var lastDrop = 0;
    function onDrop(e) {
        var cm = this;
        clearDragCursor(cm);
        if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) return;
        e_preventDefault(e);
        if (ie) lastDrop = +new Date;
        var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
        if (!pos || cm.isReadOnly()) return;
        // Might be a file drop, in which case we simply extract the text
        // and insert it.
        if (files && files.length && window.FileReader && window.File) {
            var n = files.length, text = Array(n), read = 0;
            var markAsReadAndPasteIfAllFilesAreRead = function() {
                if (++read == n) operation(cm, function() {
                    pos = clipPos(cm.doc, pos);
                    var change = {
                        from: pos,
                        to: pos,
                        text: cm.doc.splitLines(text.filter(function(t) {
                            return t != null;
                        }).join(cm.doc.lineSeparator())),
                        origin: "paste"
                    };
                    makeChange(cm.doc, change);
                    setSelectionReplaceHistory(cm.doc, simpleSelection(clipPos(cm.doc, pos), clipPos(cm.doc, changeEnd(change))));
                })();
            };
            var readTextFromFile = function(file, i) {
                if (cm.options.allowDropFileTypes && indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
                    markAsReadAndPasteIfAllFilesAreRead();
                    return;
                }
                var reader = new FileReader;
                reader.onerror = function() {
                    return markAsReadAndPasteIfAllFilesAreRead();
                };
                reader.onload = function() {
                    var content = reader.result;
                    if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
                        markAsReadAndPasteIfAllFilesAreRead();
                        return;
                    }
                    text[i] = content;
                    markAsReadAndPasteIfAllFilesAreRead();
                };
                reader.readAsText(file);
            };
            for(var i = 0; i < files.length; i++)readTextFromFile(files[i], i);
        } else {
            // Don't do a replace if the drop happened inside of the selected text.
            if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
                cm.state.draggingText(e);
                // Ensure the editor is re-focused
                setTimeout(function() {
                    return cm.display.input.focus();
                }, 20);
                return;
            }
            try {
                var text$1 = e.dataTransfer.getData("Text");
                if (text$1) {
                    var selected;
                    if (cm.state.draggingText && !cm.state.draggingText.copy) selected = cm.listSelections();
                    setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
                    if (selected) for(var i$1 = 0; i$1 < selected.length; ++i$1)replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag");
                    cm.replaceSelection(text$1, "around", "paste");
                    cm.display.input.focus();
                }
            } catch (e$1) {}
        }
    }
    function onDragStart(cm, e) {
        if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) {
            e_stop(e);
            return;
        }
        if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) return;
        e.dataTransfer.setData("Text", cm.getSelection());
        e.dataTransfer.effectAllowed = "copyMove";
        // Use dummy image instead of default browsers image.
        // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
        if (e.dataTransfer.setDragImage && !safari) {
            var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
            img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
            if (presto) {
                img.width = img.height = 1;
                cm.display.wrapper.appendChild(img);
                // Force a relayout, or Opera won't use our image for some obscure reason
                img._top = img.offsetTop;
            }
            e.dataTransfer.setDragImage(img, 0, 0);
            if (presto) img.parentNode.removeChild(img);
        }
    }
    function onDragOver(cm, e) {
        var pos = posFromMouse(cm, e);
        if (!pos) return;
        var frag = document.createDocumentFragment();
        drawSelectionCursor(cm, pos, frag);
        if (!cm.display.dragCursor) {
            cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
            cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
        }
        removeChildrenAndAdd(cm.display.dragCursor, frag);
    }
    function clearDragCursor(cm) {
        if (cm.display.dragCursor) {
            cm.display.lineSpace.removeChild(cm.display.dragCursor);
            cm.display.dragCursor = null;
        }
    }
    // These must be handled carefully, because naively registering a
    // handler for each editor will cause the editors to never be
    // garbage collected.
    function forEachCodeMirror(f) {
        if (!document.getElementsByClassName) return;
        var byClass = document.getElementsByClassName("CodeMirror"), editors = [];
        for(var i = 0; i < byClass.length; i++){
            var cm = byClass[i].CodeMirror;
            if (cm) editors.push(cm);
        }
        if (editors.length) editors[0].operation(function() {
            for(var i = 0; i < editors.length; i++)f(editors[i]);
        });
    }
    var globalsRegistered = false;
    function ensureGlobalHandlers() {
        if (globalsRegistered) return;
        registerGlobalHandlers();
        globalsRegistered = true;
    }
    function registerGlobalHandlers() {
        // When the window resizes, we need to refresh active editors.
        var resizeTimer;
        on(window, "resize", function() {
            if (resizeTimer == null) resizeTimer = setTimeout(function() {
                resizeTimer = null;
                forEachCodeMirror(onResize);
            }, 100);
        });
        // When the window loses focus, we want to show the editor as blurred
        on(window, "blur", function() {
            return forEachCodeMirror(onBlur);
        });
    }
    // Called when the window resizes
    function onResize(cm) {
        var d = cm.display;
        // Might be a text scaling operation, clear size caches.
        d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
        d.scrollbarsClipped = false;
        cm.setSize();
    }
    var keyNames = {
        3: "Pause",
        8: "Backspace",
        9: "Tab",
        13: "Enter",
        16: "Shift",
        17: "Ctrl",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Esc",
        32: "Space",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "Left",
        38: "Up",
        39: "Right",
        40: "Down",
        44: "PrintScrn",
        45: "Insert",
        46: "Delete",
        59: ";",
        61: "=",
        91: "Mod",
        92: "Mod",
        93: "Mod",
        106: "*",
        107: "=",
        109: "-",
        110: ".",
        111: "/",
        145: "ScrollLock",
        173: "-",
        186: ";",
        187: "=",
        188: ",",
        189: "-",
        190: ".",
        191: "/",
        192: "`",
        219: "[",
        220: "\\",
        221: "]",
        222: "'",
        224: "Mod",
        63232: "Up",
        63233: "Down",
        63234: "Left",
        63235: "Right",
        63272: "Delete",
        63273: "Home",
        63275: "End",
        63276: "PageUp",
        63277: "PageDown",
        63302: "Insert"
    };
    // Number keys
    for(var i = 0; i < 10; i++)keyNames[i + 48] = keyNames[i + 96] = String(i);
    // Alphabetic keys
    for(var i$1 = 65; i$1 <= 90; i$1++)keyNames[i$1] = String.fromCharCode(i$1);
    // Function keys
    for(var i$2 = 1; i$2 <= 12; i$2++)keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2;
    var keyMap = {};
    keyMap.basic = {
        "Left": "goCharLeft",
        "Right": "goCharRight",
        "Up": "goLineUp",
        "Down": "goLineDown",
        "End": "goLineEnd",
        "Home": "goLineStartSmart",
        "PageUp": "goPageUp",
        "PageDown": "goPageDown",
        "Delete": "delCharAfter",
        "Backspace": "delCharBefore",
        "Shift-Backspace": "delCharBefore",
        "Tab": "defaultTab",
        "Shift-Tab": "indentAuto",
        "Enter": "newlineAndIndent",
        "Insert": "toggleOverwrite",
        "Esc": "singleSelection"
    };
    // Note that the save and find-related commands aren't defined by
    // default. User code or addons can define them. Unknown commands
    // are simply ignored.
    keyMap.pcDefault = {
        "Ctrl-A": "selectAll",
        "Ctrl-D": "deleteLine",
        "Ctrl-Z": "undo",
        "Shift-Ctrl-Z": "redo",
        "Ctrl-Y": "redo",
        "Ctrl-Home": "goDocStart",
        "Ctrl-End": "goDocEnd",
        "Ctrl-Up": "goLineUp",
        "Ctrl-Down": "goLineDown",
        "Ctrl-Left": "goGroupLeft",
        "Ctrl-Right": "goGroupRight",
        "Alt-Left": "goLineStart",
        "Alt-Right": "goLineEnd",
        "Ctrl-Backspace": "delGroupBefore",
        "Ctrl-Delete": "delGroupAfter",
        "Ctrl-S": "save",
        "Ctrl-F": "find",
        "Ctrl-G": "findNext",
        "Shift-Ctrl-G": "findPrev",
        "Shift-Ctrl-F": "replace",
        "Shift-Ctrl-R": "replaceAll",
        "Ctrl-[": "indentLess",
        "Ctrl-]": "indentMore",
        "Ctrl-U": "undoSelection",
        "Shift-Ctrl-U": "redoSelection",
        "Alt-U": "redoSelection",
        "fallthrough": "basic"
    };
    // Very basic readline/emacs-style bindings, which are standard on Mac.
    keyMap.emacsy = {
        "Ctrl-F": "goCharRight",
        "Ctrl-B": "goCharLeft",
        "Ctrl-P": "goLineUp",
        "Ctrl-N": "goLineDown",
        "Ctrl-A": "goLineStart",
        "Ctrl-E": "goLineEnd",
        "Ctrl-V": "goPageDown",
        "Shift-Ctrl-V": "goPageUp",
        "Ctrl-D": "delCharAfter",
        "Ctrl-H": "delCharBefore",
        "Alt-Backspace": "delWordBefore",
        "Ctrl-K": "killLine",
        "Ctrl-T": "transposeChars",
        "Ctrl-O": "openLine"
    };
    keyMap.macDefault = {
        "Cmd-A": "selectAll",
        "Cmd-D": "deleteLine",
        "Cmd-Z": "undo",
        "Shift-Cmd-Z": "redo",
        "Cmd-Y": "redo",
        "Cmd-Home": "goDocStart",
        "Cmd-Up": "goDocStart",
        "Cmd-End": "goDocEnd",
        "Cmd-Down": "goDocEnd",
        "Alt-Left": "goGroupLeft",
        "Alt-Right": "goGroupRight",
        "Cmd-Left": "goLineLeft",
        "Cmd-Right": "goLineRight",
        "Alt-Backspace": "delGroupBefore",
        "Ctrl-Alt-Backspace": "delGroupAfter",
        "Alt-Delete": "delGroupAfter",
        "Cmd-S": "save",
        "Cmd-F": "find",
        "Cmd-G": "findNext",
        "Shift-Cmd-G": "findPrev",
        "Cmd-Alt-F": "replace",
        "Shift-Cmd-Alt-F": "replaceAll",
        "Cmd-[": "indentLess",
        "Cmd-]": "indentMore",
        "Cmd-Backspace": "delWrappedLineLeft",
        "Cmd-Delete": "delWrappedLineRight",
        "Cmd-U": "undoSelection",
        "Shift-Cmd-U": "redoSelection",
        "Ctrl-Up": "goDocStart",
        "Ctrl-Down": "goDocEnd",
        "fallthrough": [
            "basic",
            "emacsy"
        ]
    };
    keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;
    // KEYMAP DISPATCH
    function normalizeKeyName(name) {
        var parts = name.split(/-(?!$)/);
        name = parts[parts.length - 1];
        var alt, ctrl, shift, cmd;
        for(var i = 0; i < parts.length - 1; i++){
            var mod = parts[i];
            if (/^(cmd|meta|m)$/i.test(mod)) cmd = true;
            else if (/^a(lt)?$/i.test(mod)) alt = true;
            else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
            else if (/^s(hift)?$/i.test(mod)) shift = true;
            else throw new Error("Unrecognized modifier name: " + mod);
        }
        if (alt) name = "Alt-" + name;
        if (ctrl) name = "Ctrl-" + name;
        if (cmd) name = "Cmd-" + name;
        if (shift) name = "Shift-" + name;
        return name;
    }
    // This is a kludge to keep keymaps mostly working as raw objects
    // (backwards compatibility) while at the same time support features
    // like normalization and multi-stroke key bindings. It compiles a
    // new normalized keymap, and then updates the old object to reflect
    // this.
    function normalizeKeyMap(keymap) {
        var copy = {};
        for(var keyname in keymap)if (keymap.hasOwnProperty(keyname)) {
            var value = keymap[keyname];
            if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) continue;
            if (value == "...") {
                delete keymap[keyname];
                continue;
            }
            var keys = map(keyname.split(" "), normalizeKeyName);
            for(var i = 0; i < keys.length; i++){
                var val = void 0, name = void 0;
                if (i == keys.length - 1) {
                    name = keys.join(" ");
                    val = value;
                } else {
                    name = keys.slice(0, i + 1).join(" ");
                    val = "...";
                }
                var prev = copy[name];
                if (!prev) copy[name] = val;
                else if (prev != val) throw new Error("Inconsistent bindings for " + name);
            }
            delete keymap[keyname];
        }
        for(var prop in copy)keymap[prop] = copy[prop];
        return keymap;
    }
    function lookupKey(key, map, handle, context) {
        map = getKeyMap(map);
        var found = map.call ? map.call(key, context) : map[key];
        if (found === false) return "nothing";
        if (found === "...") return "multi";
        if (found != null && handle(found)) return "handled";
        if (map.fallthrough) {
            if (Object.prototype.toString.call(map.fallthrough) != "[object Array]") return lookupKey(key, map.fallthrough, handle, context);
            for(var i = 0; i < map.fallthrough.length; i++){
                var result = lookupKey(key, map.fallthrough[i], handle, context);
                if (result) return result;
            }
        }
    }
    // Modifier key presses don't count as 'real' key presses for the
    // purpose of keymap fallthrough.
    function isModifierKey(value) {
        var name = typeof value == "string" ? value : keyNames[value.keyCode];
        return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod";
    }
    function addModifierNames(name, event, noShift) {
        var base = name;
        if (event.altKey && base != "Alt") name = "Alt-" + name;
        if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") name = "Ctrl-" + name;
        if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Mod") name = "Cmd-" + name;
        if (!noShift && event.shiftKey && base != "Shift") name = "Shift-" + name;
        return name;
    }
    // Look up the name of a key as indicated by an event object.
    function keyName(event, noShift) {
        if (presto && event.keyCode == 34 && event["char"]) return false;
        var name = keyNames[event.keyCode];
        if (name == null || event.altGraphKey) return false;
        // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
        // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
        if (event.keyCode == 3 && event.code) name = event.code;
        return addModifierNames(name, event, noShift);
    }
    function getKeyMap(val) {
        return typeof val == "string" ? keyMap[val] : val;
    }
    // Helper for deleting text near the selection(s), used to implement
    // backspace, delete, and similar functionality.
    function deleteNearSelection(cm, compute) {
        var ranges = cm.doc.sel.ranges, kill = [];
        // Build up a set of ranges to kill first, merging overlapping
        // ranges.
        for(var i = 0; i < ranges.length; i++){
            var toKill = compute(ranges[i]);
            while(kill.length && cmp(toKill.from, lst(kill).to) <= 0){
                var replaced = kill.pop();
                if (cmp(replaced.from, toKill.from) < 0) {
                    toKill.from = replaced.from;
                    break;
                }
            }
            kill.push(toKill);
        }
        // Next, remove those actual ranges.
        runInOp(cm, function() {
            for(var i = kill.length - 1; i >= 0; i--)replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete");
            ensureCursorVisible(cm);
        });
    }
    function moveCharLogically(line, ch, dir) {
        var target = skipExtendingChars(line.text, ch + dir, dir);
        return target < 0 || target > line.text.length ? null : target;
    }
    function moveLogically(line, start, dir) {
        var ch = moveCharLogically(line, start.ch, dir);
        return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before");
    }
    function endOfLine(visually, cm, lineObj, lineNo, dir) {
        if (visually) {
            if (cm.doc.direction == "rtl") dir = -dir;
            var order = getOrder(lineObj, cm.doc.direction);
            if (order) {
                var part = dir < 0 ? lst(order) : order[0];
                var moveInStorageOrder = dir < 0 == (part.level == 1);
                var sticky = moveInStorageOrder ? "after" : "before";
                var ch;
                // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
                // it could be that the last bidi part is not on the last visual line,
                // since visual lines contain content order-consecutive chunks.
                // Thus, in rtl, we are looking for the first (content-order) character
                // in the rtl chunk that is on the last line (that is, the same line
                // as the last (content-order) character).
                if (part.level > 0 || cm.doc.direction == "rtl") {
                    var prep = prepareMeasureForLine(cm, lineObj);
                    ch = dir < 0 ? lineObj.text.length - 1 : 0;
                    var targetTop = measureCharPrepared(cm, prep, ch).top;
                    ch = findFirst(function(ch) {
                        return measureCharPrepared(cm, prep, ch).top == targetTop;
                    }, dir < 0 == (part.level == 1) ? part.from : part.to - 1, ch);
                    if (sticky == "before") ch = moveCharLogically(lineObj, ch, 1);
                } else ch = dir < 0 ? part.to : part.from;
                return new Pos(lineNo, ch, sticky);
            }
        }
        return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after");
    }
    function moveVisually(cm, line, start, dir) {
        var bidi = getOrder(line, cm.doc.direction);
        if (!bidi) return moveLogically(line, start, dir);
        if (start.ch >= line.text.length) {
            start.ch = line.text.length;
            start.sticky = "before";
        } else if (start.ch <= 0) {
            start.ch = 0;
            start.sticky = "after";
        }
        var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
        if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
        // nothing interesting happens.
        return moveLogically(line, start, dir);
        var mv = function(pos, dir) {
            return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir);
        };
        var prep;
        var getWrappedLineExtent = function(ch) {
            if (!cm.options.lineWrapping) return {
                begin: 0,
                end: line.text.length
            };
            prep = prep || prepareMeasureForLine(cm, line);
            return wrappedLineExtentChar(cm, line, prep, ch);
        };
        var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);
        if (cm.doc.direction == "rtl" || part.level == 1) {
            var moveInStorageOrder = part.level == 1 == dir < 0;
            var ch = mv(start, moveInStorageOrder ? 1 : -1);
            if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
                // Case 2: We move within an rtl part or in an rtl editor on the same visual line
                var sticky = moveInStorageOrder ? "before" : "after";
                return new Pos(start.line, ch, sticky);
            }
        }
        // Case 3: Could not move within this bidi part in this visual line, so leave
        // the current bidi part
        var searchInVisualLine = function(partPos, dir, wrappedLineExtent) {
            var getRes = function(ch, moveInStorageOrder) {
                return moveInStorageOrder ? new Pos(start.line, mv(ch, 1), "before") : new Pos(start.line, ch, "after");
            };
            for(; partPos >= 0 && partPos < bidi.length; partPos += dir){
                var part = bidi[partPos];
                var moveInStorageOrder = dir > 0 == (part.level != 1);
                var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
                if (part.from <= ch && ch < part.to) return getRes(ch, moveInStorageOrder);
                ch = moveInStorageOrder ? part.from : mv(part.to, -1);
                if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) return getRes(ch, moveInStorageOrder);
            }
        };
        // Case 3a: Look for other bidi parts on the same visual line
        var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
        if (res) return res;
        // Case 3b: Look for other bidi parts on the next visual line
        var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
        if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
            res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
            if (res) return res;
        }
        // Case 4: Nowhere to move
        return null;
    }
    // Commands are parameter-less actions that can be performed on an
    // editor, mostly used for keybindings.
    var commands = {
        selectAll: selectAll,
        singleSelection: function(cm) {
            return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll);
        },
        killLine: function(cm) {
            return deleteNearSelection(cm, function(range) {
                if (range.empty()) {
                    var len = getLine(cm.doc, range.head.line).text.length;
                    if (range.head.ch == len && range.head.line < cm.lastLine()) return {
                        from: range.head,
                        to: Pos(range.head.line + 1, 0)
                    };
                    else return {
                        from: range.head,
                        to: Pos(range.head.line, len)
                    };
                } else return {
                    from: range.from(),
                    to: range.to()
                };
            });
        },
        deleteLine: function(cm) {
            return deleteNearSelection(cm, function(range) {
                return {
                    from: Pos(range.from().line, 0),
                    to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
                };
            });
        },
        delLineLeft: function(cm) {
            return deleteNearSelection(cm, function(range) {
                return {
                    from: Pos(range.from().line, 0),
                    to: range.from()
                };
            });
        },
        delWrappedLineLeft: function(cm) {
            return deleteNearSelection(cm, function(range) {
                var top = cm.charCoords(range.head, "div").top + 5;
                var leftPos = cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
                return {
                    from: leftPos,
                    to: range.from()
                };
            });
        },
        delWrappedLineRight: function(cm) {
            return deleteNearSelection(cm, function(range) {
                var top = cm.charCoords(range.head, "div").top + 5;
                var rightPos = cm.coordsChar({
                    left: cm.display.lineDiv.offsetWidth + 100,
                    top: top
                }, "div");
                return {
                    from: range.from(),
                    to: rightPos
                };
            });
        },
        undo: function(cm) {
            return cm.undo();
        },
        redo: function(cm) {
            return cm.redo();
        },
        undoSelection: function(cm) {
            return cm.undoSelection();
        },
        redoSelection: function(cm) {
            return cm.redoSelection();
        },
        goDocStart: function(cm) {
            return cm.extendSelection(Pos(cm.firstLine(), 0));
        },
        goDocEnd: function(cm) {
            return cm.extendSelection(Pos(cm.lastLine()));
        },
        goLineStart: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineStart(cm, range.head.line);
            }, {
                origin: "+move",
                bias: 1
            });
        },
        goLineStartSmart: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineStartSmart(cm, range.head);
            }, {
                origin: "+move",
                bias: 1
            });
        },
        goLineEnd: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineEnd(cm, range.head.line);
            }, {
                origin: "+move",
                bias: -1
            });
        },
        goLineRight: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                return cm.coordsChar({
                    left: cm.display.lineDiv.offsetWidth + 100,
                    top: top
                }, "div");
            }, sel_move);
        },
        goLineLeft: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                return cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
            }, sel_move);
        },
        goLineLeftSmart: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                var pos = cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
                if (pos.ch < cm.getLine(pos.line).search(/\S/)) return lineStartSmart(cm, range.head);
                return pos;
            }, sel_move);
        },
        goLineUp: function(cm) {
            return cm.moveV(-1, "line");
        },
        goLineDown: function(cm) {
            return cm.moveV(1, "line");
        },
        goPageUp: function(cm) {
            return cm.moveV(-1, "page");
        },
        goPageDown: function(cm) {
            return cm.moveV(1, "page");
        },
        goCharLeft: function(cm) {
            return cm.moveH(-1, "char");
        },
        goCharRight: function(cm) {
            return cm.moveH(1, "char");
        },
        goColumnLeft: function(cm) {
            return cm.moveH(-1, "column");
        },
        goColumnRight: function(cm) {
            return cm.moveH(1, "column");
        },
        goWordLeft: function(cm) {
            return cm.moveH(-1, "word");
        },
        goGroupRight: function(cm) {
            return cm.moveH(1, "group");
        },
        goGroupLeft: function(cm) {
            return cm.moveH(-1, "group");
        },
        goWordRight: function(cm) {
            return cm.moveH(1, "word");
        },
        delCharBefore: function(cm) {
            return cm.deleteH(-1, "codepoint");
        },
        delCharAfter: function(cm) {
            return cm.deleteH(1, "char");
        },
        delWordBefore: function(cm) {
            return cm.deleteH(-1, "word");
        },
        delWordAfter: function(cm) {
            return cm.deleteH(1, "word");
        },
        delGroupBefore: function(cm) {
            return cm.deleteH(-1, "group");
        },
        delGroupAfter: function(cm) {
            return cm.deleteH(1, "group");
        },
        indentAuto: function(cm) {
            return cm.indentSelection("smart");
        },
        indentMore: function(cm) {
            return cm.indentSelection("add");
        },
        indentLess: function(cm) {
            return cm.indentSelection("subtract");
        },
        insertTab: function(cm) {
            return cm.replaceSelection("\t");
        },
        insertSoftTab: function(cm) {
            var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
            for(var i = 0; i < ranges.length; i++){
                var pos = ranges[i].from();
                var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
                spaces.push(spaceStr(tabSize - col % tabSize));
            }
            cm.replaceSelections(spaces);
        },
        defaultTab: function(cm) {
            if (cm.somethingSelected()) cm.indentSelection("add");
            else cm.execCommand("insertTab");
        },
        // Swap the two chars left and right of each selection's head.
        // Move cursor behind the two swapped characters afterwards.
        //
        // Doesn't consider line feeds a character.
        // Doesn't scan more than one line above to find a character.
        // Doesn't do anything on an empty line.
        // Doesn't do anything with non-empty selections.
        transposeChars: function(cm) {
            return runInOp(cm, function() {
                var ranges = cm.listSelections(), newSel = [];
                for(var i = 0; i < ranges.length; i++){
                    if (!ranges[i].empty()) continue;
                    var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
                    if (line) {
                        if (cur.ch == line.length) cur = new Pos(cur.line, cur.ch - 1);
                        if (cur.ch > 0) {
                            cur = new Pos(cur.line, cur.ch + 1);
                            cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2), Pos(cur.line, cur.ch - 2), cur, "+transpose");
                        } else if (cur.line > cm.doc.first) {
                            var prev = getLine(cm.doc, cur.line - 1).text;
                            if (prev) {
                                cur = new Pos(cur.line, 1);
                                cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() + prev.charAt(prev.length - 1), Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
                            }
                        }
                    }
                    newSel.push(new Range(cur, cur));
                }
                cm.setSelections(newSel);
            });
        },
        newlineAndIndent: function(cm) {
            return runInOp(cm, function() {
                var sels = cm.listSelections();
                for(var i = sels.length - 1; i >= 0; i--)cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input");
                sels = cm.listSelections();
                for(var i$1 = 0; i$1 < sels.length; i$1++)cm.indentLine(sels[i$1].from().line, null, true);
                ensureCursorVisible(cm);
            });
        },
        openLine: function(cm) {
            return cm.replaceSelection("\n", "start");
        },
        toggleOverwrite: function(cm) {
            return cm.toggleOverwrite();
        }
    };
    function lineStart(cm, lineN) {
        var line = getLine(cm.doc, lineN);
        var visual = visualLine(line);
        if (visual != line) lineN = lineNo(visual);
        return endOfLine(true, cm, visual, lineN, 1);
    }
    function lineEnd(cm, lineN) {
        var line = getLine(cm.doc, lineN);
        var visual = visualLineEnd(line);
        if (visual != line) lineN = lineNo(visual);
        return endOfLine(true, cm, line, lineN, -1);
    }
    function lineStartSmart(cm, pos) {
        var start = lineStart(cm, pos.line);
        var line = getLine(cm.doc, start.line);
        var order = getOrder(line, cm.doc.direction);
        if (!order || order[0].level == 0) {
            var firstNonWS = Math.max(start.ch, line.text.search(/\S/));
            var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
            return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky);
        }
        return start;
    }
    // Run a handler that was bound to a key.
    function doHandleBinding(cm, bound, dropShift) {
        if (typeof bound == "string") {
            bound = commands[bound];
            if (!bound) return false;
        }
        // Ensure previous input has been read, so that the handler sees a
        // consistent view of the document
        cm.display.input.ensurePolled();
        var prevShift = cm.display.shift, done = false;
        try {
            if (cm.isReadOnly()) cm.state.suppressEdits = true;
            if (dropShift) cm.display.shift = false;
            done = bound(cm) != Pass;
        } finally{
            cm.display.shift = prevShift;
            cm.state.suppressEdits = false;
        }
        return done;
    }
    function lookupKeyForEditor(cm, name, handle) {
        for(var i = 0; i < cm.state.keyMaps.length; i++){
            var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
            if (result) return result;
        }
        return cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm) || lookupKey(name, cm.options.keyMap, handle, cm);
    }
    // Note that, despite the name, this function is also used to check
    // for bound mouse clicks.
    var stopSeq = new Delayed;
    function dispatchKey(cm, name, e, handle) {
        var seq = cm.state.keySeq;
        if (seq) {
            if (isModifierKey(name)) return "handled";
            if (/\'$/.test(name)) cm.state.keySeq = null;
            else stopSeq.set(50, function() {
                if (cm.state.keySeq == seq) {
                    cm.state.keySeq = null;
                    cm.display.input.reset();
                }
            });
            if (dispatchKeyInner(cm, seq + " " + name, e, handle)) return true;
        }
        return dispatchKeyInner(cm, name, e, handle);
    }
    function dispatchKeyInner(cm, name, e, handle) {
        var result = lookupKeyForEditor(cm, name, handle);
        if (result == "multi") cm.state.keySeq = name;
        if (result == "handled") signalLater(cm, "keyHandled", cm, name, e);
        if (result == "handled" || result == "multi") {
            e_preventDefault(e);
            restartBlink(cm);
        }
        return !!result;
    }
    // Handle a key from the keydown event.
    function handleKeyBinding(cm, e) {
        var name = keyName(e, true);
        if (!name) return false;
        if (e.shiftKey && !cm.state.keySeq) // First try to resolve full name (including 'Shift-'). Failing
        // that, see if there is a cursor-motion command (starting with
        // 'go') bound to the keyname without 'Shift-'.
        return dispatchKey(cm, "Shift-" + name, e, function(b) {
            return doHandleBinding(cm, b, true);
        }) || dispatchKey(cm, name, e, function(b) {
            if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion) return doHandleBinding(cm, b);
        });
        else return dispatchKey(cm, name, e, function(b) {
            return doHandleBinding(cm, b);
        });
    }
    // Handle a key from the keypress event
    function handleCharBinding(cm, e, ch) {
        return dispatchKey(cm, "'" + ch + "'", e, function(b) {
            return doHandleBinding(cm, b, true);
        });
    }
    var lastStoppedKey = null;
    function onKeyDown(e) {
        var cm = this;
        if (e.target && e.target != cm.display.input.getField()) return;
        cm.curOp.focus = activeElt(root(cm));
        if (signalDOMEvent(cm, e)) return;
        // IE does strange things with escape.
        if (ie && ie_version < 11 && e.keyCode == 27) e.returnValue = false;
        var code = e.keyCode;
        cm.display.shift = code == 16 || e.shiftKey;
        var handled = handleKeyBinding(cm, e);
        if (presto) {
            lastStoppedKey = handled ? code : null;
            // Opera has no cut event... we try to at least catch the key combo
            if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey)) cm.replaceSelection("", null, "cut");
        }
        if (gecko && !mac && !handled && code == 46 && e.shiftKey && !e.ctrlKey && document.execCommand) document.execCommand("cut");
        // Turn mouse into crosshair when Alt is held on Mac.
        if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className)) showCrossHair(cm);
    }
    function showCrossHair(cm) {
        var lineDiv = cm.display.lineDiv;
        addClass(lineDiv, "CodeMirror-crosshair");
        function up(e) {
            if (e.keyCode == 18 || !e.altKey) {
                rmClass(lineDiv, "CodeMirror-crosshair");
                off(document, "keyup", up);
                off(document, "mouseover", up);
            }
        }
        on(document, "keyup", up);
        on(document, "mouseover", up);
    }
    function onKeyUp(e) {
        if (e.keyCode == 16) this.doc.sel.shift = false;
        signalDOMEvent(this, e);
    }
    function onKeyPress(e) {
        var cm = this;
        if (e.target && e.target != cm.display.input.getField()) return;
        if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) return;
        var keyCode = e.keyCode, charCode = e.charCode;
        if (presto && keyCode == lastStoppedKey) {
            lastStoppedKey = null;
            e_preventDefault(e);
            return;
        }
        if (presto && (!e.which || e.which < 10) && handleKeyBinding(cm, e)) return;
        var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
        // Some browsers fire keypress events for backspace
        if (ch == "\x08") return;
        if (handleCharBinding(cm, e, ch)) return;
        cm.display.input.onKeyPress(e);
    }
    var DOUBLECLICK_DELAY = 400;
    var PastClick = function(time, pos, button) {
        this.time = time;
        this.pos = pos;
        this.button = button;
    };
    PastClick.prototype.compare = function(time, pos, button) {
        return this.time + DOUBLECLICK_DELAY > time && cmp(pos, this.pos) == 0 && button == this.button;
    };
    var lastClick, lastDoubleClick;
    function clickRepeat(pos, button) {
        var now = +new Date;
        if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
            lastClick = lastDoubleClick = null;
            return "triple";
        } else if (lastClick && lastClick.compare(now, pos, button)) {
            lastDoubleClick = new PastClick(now, pos, button);
            lastClick = null;
            return "double";
        } else {
            lastClick = new PastClick(now, pos, button);
            lastDoubleClick = null;
            return "single";
        }
    }
    // A mouse down can be a single click, double click, triple click,
    // start of selection drag, start of text drag, new cursor
    // (ctrl-click), rectangle drag (alt-drag), or xwin
    // middle-click-paste. Or it might be a click on something we should
    // not interfere with, such as a scrollbar or widget.
    function onMouseDown(e) {
        var cm = this, display = cm.display;
        if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) return;
        display.input.ensurePolled();
        display.shift = e.shiftKey;
        if (eventInWidget(display, e)) {
            if (!webkit) {
                // Briefly turn off draggability, to allow widgets to do
                // normal dragging things.
                display.scroller.draggable = false;
                setTimeout(function() {
                    return display.scroller.draggable = true;
                }, 100);
            }
            return;
        }
        if (clickInGutter(cm, e)) return;
        var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
        win(cm).focus();
        // #3261: make sure, that we're not starting a second selection
        if (button == 1 && cm.state.selectingText) cm.state.selectingText(e);
        if (pos && handleMappedButton(cm, button, pos, repeat, e)) return;
        if (button == 1) {
            if (pos) leftButtonDown(cm, pos, repeat, e);
            else if (e_target(e) == display.scroller) e_preventDefault(e);
        } else if (button == 2) {
            if (pos) extendSelection(cm.doc, pos);
            setTimeout(function() {
                return display.input.focus();
            }, 20);
        } else if (button == 3) {
            if (captureRightClick) cm.display.input.onContextMenu(e);
            else delayBlurEvent(cm);
        }
    }
    function handleMappedButton(cm, button, pos, repeat, event) {
        var name = "Click";
        if (repeat == "double") name = "Double" + name;
        else if (repeat == "triple") name = "Triple" + name;
        name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;
        return dispatchKey(cm, addModifierNames(name, event), event, function(bound) {
            if (typeof bound == "string") bound = commands[bound];
            if (!bound) return false;
            var done = false;
            try {
                if (cm.isReadOnly()) cm.state.suppressEdits = true;
                done = bound(cm, pos) != Pass;
            } finally{
                cm.state.suppressEdits = false;
            }
            return done;
        });
    }
    function configureMouse(cm, repeat, event) {
        var option = cm.getOption("configureMouse");
        var value = option ? option(cm, repeat, event) : {};
        if (value.unit == null) {
            var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
            value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
        }
        if (value.extend == null || cm.doc.extend) value.extend = cm.doc.extend || event.shiftKey;
        if (value.addNew == null) value.addNew = mac ? event.metaKey : event.ctrlKey;
        if (value.moveOnDrag == null) value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey);
        return value;
    }
    function leftButtonDown(cm, pos, repeat, event) {
        if (ie) setTimeout(bind(ensureFocus, cm), 0);
        else cm.curOp.focus = activeElt(root(cm));
        var behavior = configureMouse(cm, repeat, event);
        var sel = cm.doc.sel, contained;
        if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() && repeat == "single" && (contained = sel.contains(pos)) > -1 && (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) && (cmp(contained.to(), pos) > 0 || pos.xRel < 0)) leftButtonStartDrag(cm, event, pos, behavior);
        else leftButtonSelect(cm, event, pos, behavior);
    }
    // Start a text drag. When it ends, see if any dragging actually
    // happen, and treat as a click if it didn't.
    function leftButtonStartDrag(cm, event, pos, behavior) {
        var display = cm.display, moved = false;
        var dragEnd = operation(cm, function(e) {
            if (webkit) display.scroller.draggable = false;
            cm.state.draggingText = false;
            if (cm.state.delayingBlurEvent) {
                if (cm.hasFocus()) cm.state.delayingBlurEvent = false;
                else delayBlurEvent(cm);
            }
            off(display.wrapper.ownerDocument, "mouseup", dragEnd);
            off(display.wrapper.ownerDocument, "mousemove", mouseMove);
            off(display.scroller, "dragstart", dragStart);
            off(display.scroller, "drop", dragEnd);
            if (!moved) {
                e_preventDefault(e);
                if (!behavior.addNew) extendSelection(cm.doc, pos, null, null, behavior.extend);
                // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
                if (webkit && !safari || ie && ie_version == 9) setTimeout(function() {
                    display.wrapper.ownerDocument.body.focus({
                        preventScroll: true
                    });
                    display.input.focus();
                }, 20);
                else display.input.focus();
            }
        });
        var mouseMove = function(e2) {
            moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
        };
        var dragStart = function() {
            return moved = true;
        };
        // Let the drag handler handle this.
        if (webkit) display.scroller.draggable = true;
        cm.state.draggingText = dragEnd;
        dragEnd.copy = !behavior.moveOnDrag;
        on(display.wrapper.ownerDocument, "mouseup", dragEnd);
        on(display.wrapper.ownerDocument, "mousemove", mouseMove);
        on(display.scroller, "dragstart", dragStart);
        on(display.scroller, "drop", dragEnd);
        cm.state.delayingBlurEvent = true;
        setTimeout(function() {
            return display.input.focus();
        }, 20);
        // IE's approach to draggable
        if (display.scroller.dragDrop) display.scroller.dragDrop();
    }
    function rangeForUnit(cm, pos, unit) {
        if (unit == "char") return new Range(pos, pos);
        if (unit == "word") return cm.findWordAt(pos);
        if (unit == "line") return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0)));
        var result = unit(cm, pos);
        return new Range(result.from, result.to);
    }
    // Normal selection, as opposed to text dragging.
    function leftButtonSelect(cm, event, start, behavior) {
        if (ie) delayBlurEvent(cm);
        var display = cm.display, doc = cm.doc;
        e_preventDefault(event);
        var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
        if (behavior.addNew && !behavior.extend) {
            ourIndex = doc.sel.contains(start);
            if (ourIndex > -1) ourRange = ranges[ourIndex];
            else ourRange = new Range(start, start);
        } else {
            ourRange = doc.sel.primary();
            ourIndex = doc.sel.primIndex;
        }
        if (behavior.unit == "rectangle") {
            if (!behavior.addNew) ourRange = new Range(start, start);
            start = posFromMouse(cm, event, true, true);
            ourIndex = -1;
        } else {
            var range = rangeForUnit(cm, start, behavior.unit);
            if (behavior.extend) ourRange = extendRange(ourRange, range.anchor, range.head, behavior.extend);
            else ourRange = range;
        }
        if (!behavior.addNew) {
            ourIndex = 0;
            setSelection(doc, new Selection([
                ourRange
            ], 0), sel_mouse);
            startSel = doc.sel;
        } else if (ourIndex == -1) {
            ourIndex = ranges.length;
            setSelection(doc, normalizeSelection(cm, ranges.concat([
                ourRange
            ]), ourIndex), {
                scroll: false,
                origin: "*mouse"
            });
        } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
            setSelection(doc, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0), {
                scroll: false,
                origin: "*mouse"
            });
            startSel = doc.sel;
        } else replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
        var lastPos = start;
        function extendTo(pos) {
            if (cmp(lastPos, pos) == 0) return;
            lastPos = pos;
            if (behavior.unit == "rectangle") {
                var ranges = [], tabSize = cm.options.tabSize;
                var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
                var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
                var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
                for(var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line)); line <= end; line++){
                    var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
                    if (left == right) ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos)));
                    else if (text.length > leftPos) ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize))));
                }
                if (!ranges.length) ranges.push(new Range(start, start));
                setSelection(doc, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex), {
                    origin: "*mouse",
                    scroll: false
                });
                cm.scrollIntoView(pos);
            } else {
                var oldRange = ourRange;
                var range = rangeForUnit(cm, pos, behavior.unit);
                var anchor = oldRange.anchor, head;
                if (cmp(range.anchor, anchor) > 0) {
                    head = range.head;
                    anchor = minPos(oldRange.from(), range.anchor);
                } else {
                    head = range.anchor;
                    anchor = maxPos(oldRange.to(), range.head);
                }
                var ranges$1 = startSel.ranges.slice(0);
                ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc, anchor), head));
                setSelection(doc, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
            }
        }
        var editorSize = display.wrapper.getBoundingClientRect();
        // Used to ensure timeout re-tries don't fire when another extend
        // happened in the meantime (clearTimeout isn't reliable -- at
        // least on Chrome, the timeouts still happen even when cleared,
        // if the clear happens after their scheduled firing time).
        var counter = 0;
        function extend(e) {
            var curCount = ++counter;
            var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
            if (!cur) return;
            if (cmp(cur, lastPos) != 0) {
                cm.curOp.focus = activeElt(root(cm));
                extendTo(cur);
                var visible = visibleLines(display, doc);
                if (cur.line >= visible.to || cur.line < visible.from) setTimeout(operation(cm, function() {
                    if (counter == curCount) extend(e);
                }), 150);
            } else {
                var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
                if (outside) setTimeout(operation(cm, function() {
                    if (counter != curCount) return;
                    display.scroller.scrollTop += outside;
                    extend(e);
                }), 50);
            }
        }
        function done(e) {
            cm.state.selectingText = false;
            counter = Infinity;
            // If e is null or undefined we interpret this as someone trying
            // to explicitly cancel the selection rather than the user
            // letting go of the mouse button.
            if (e) {
                e_preventDefault(e);
                display.input.focus();
            }
            off(display.wrapper.ownerDocument, "mousemove", move);
            off(display.wrapper.ownerDocument, "mouseup", up);
            doc.history.lastSelOrigin = null;
        }
        var move = operation(cm, function(e) {
            if (e.buttons === 0 || !e_button(e)) done(e);
            else extend(e);
        });
        var up = operation(cm, done);
        cm.state.selectingText = up;
        on(display.wrapper.ownerDocument, "mousemove", move);
        on(display.wrapper.ownerDocument, "mouseup", up);
    }
    // Used when mouse-selecting to adjust the anchor to the proper side
    // of a bidi jump depending on the visual position of the head.
    function bidiSimplify(cm, range) {
        var anchor = range.anchor;
        var head = range.head;
        var anchorLine = getLine(cm.doc, anchor.line);
        if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) return range;
        var order = getOrder(anchorLine);
        if (!order) return range;
        var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
        if (part.from != anchor.ch && part.to != anchor.ch) return range;
        var boundary = index + (part.from == anchor.ch == (part.level != 1) ? 0 : 1);
        if (boundary == 0 || boundary == order.length) return range;
        // Compute the relative visual position of the head compared to the
        // anchor (<0 is to the left, >0 to the right)
        var leftSide;
        if (head.line != anchor.line) leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
        else {
            var headIndex = getBidiPartAt(order, head.ch, head.sticky);
            var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
            if (headIndex == boundary - 1 || headIndex == boundary) leftSide = dir < 0;
            else leftSide = dir > 0;
        }
        var usePart = order[boundary + (leftSide ? -1 : 0)];
        var from = leftSide == (usePart.level == 1);
        var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
        return anchor.ch == ch && anchor.sticky == sticky ? range : new Range(new Pos(anchor.line, ch, sticky), head);
    }
    // Determines whether an event happened in the gutter, and fires the
    // handlers for the corresponding event.
    function gutterEvent(cm, e, type, prevent) {
        var mX, mY;
        if (e.touches) {
            mX = e.touches[0].clientX;
            mY = e.touches[0].clientY;
        } else try {
            mX = e.clientX;
            mY = e.clientY;
        } catch (e$1) {
            return false;
        }
        if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) return false;
        if (prevent) e_preventDefault(e);
        var display = cm.display;
        var lineBox = display.lineDiv.getBoundingClientRect();
        if (mY > lineBox.bottom || !hasHandler(cm, type)) return e_defaultPrevented(e);
        mY -= lineBox.top - display.viewOffset;
        for(var i = 0; i < cm.display.gutterSpecs.length; ++i){
            var g = display.gutters.childNodes[i];
            if (g && g.getBoundingClientRect().right >= mX) {
                var line = lineAtHeight(cm.doc, mY);
                var gutter = cm.display.gutterSpecs[i];
                signal(cm, type, cm, line, gutter.className, e);
                return e_defaultPrevented(e);
            }
        }
    }
    function clickInGutter(cm, e) {
        return gutterEvent(cm, e, "gutterClick", true);
    }
    // CONTEXT MENU HANDLING
    // To make the context menu work, we need to briefly unhide the
    // textarea (making it as unobtrusive as possible) to let the
    // right-click take effect on it.
    function onContextMenu(cm, e) {
        if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) return;
        if (signalDOMEvent(cm, e, "contextmenu")) return;
        if (!captureRightClick) cm.display.input.onContextMenu(e);
    }
    function contextMenuInGutter(cm, e) {
        if (!hasHandler(cm, "gutterContextMenu")) return false;
        return gutterEvent(cm, e, "gutterContextMenu", false);
    }
    function themeChanged(cm) {
        cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
        clearCaches(cm);
    }
    var Init = {
        toString: function() {
            return "CodeMirror.Init";
        }
    };
    var defaults = {};
    var optionHandlers = {};
    function defineOptions(CodeMirror) {
        var optionHandlers = CodeMirror.optionHandlers;
        function option(name, deflt, handle, notOnInit) {
            CodeMirror.defaults[name] = deflt;
            if (handle) optionHandlers[name] = notOnInit ? function(cm, val, old) {
                if (old != Init) handle(cm, val, old);
            } : handle;
        }
        CodeMirror.defineOption = option;
        // Passed to option handlers when there is no old value.
        CodeMirror.Init = Init;
        // These two are, on init, called from the constructor because they
        // have to be initialized before the editor can start at all.
        option("value", "", function(cm, val) {
            return cm.setValue(val);
        }, true);
        option("mode", null, function(cm, val) {
            cm.doc.modeOption = val;
            loadMode(cm);
        }, true);
        option("indentUnit", 2, loadMode, true);
        option("indentWithTabs", false);
        option("smartIndent", true);
        option("tabSize", 4, function(cm) {
            resetModeState(cm);
            clearCaches(cm);
            regChange(cm);
        }, true);
        option("lineSeparator", null, function(cm, val) {
            cm.doc.lineSep = val;
            if (!val) return;
            var newBreaks = [], lineNo = cm.doc.first;
            cm.doc.iter(function(line) {
                for(var pos = 0;;){
                    var found = line.text.indexOf(val, pos);
                    if (found == -1) break;
                    pos = found + val.length;
                    newBreaks.push(Pos(lineNo, found));
                }
                lineNo++;
            });
            for(var i = newBreaks.length - 1; i >= 0; i--)replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length));
        });
        option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\u2066\u2067\u2069\ufeff\ufff9-\ufffc]/g, function(cm, val, old) {
            cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
            if (old != Init) cm.refresh();
        });
        option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function(cm) {
            return cm.refresh();
        }, true);
        option("electricChars", true);
        option("inputStyle", mobile ? "contenteditable" : "textarea", function() {
            throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
            ;
        }, true);
        option("spellcheck", false, function(cm, val) {
            return cm.getInputField().spellcheck = val;
        }, true);
        option("autocorrect", false, function(cm, val) {
            return cm.getInputField().autocorrect = val;
        }, true);
        option("autocapitalize", false, function(cm, val) {
            return cm.getInputField().autocapitalize = val;
        }, true);
        option("rtlMoveVisually", !windows);
        option("wholeLineUpdateBefore", true);
        option("theme", "default", function(cm) {
            themeChanged(cm);
            updateGutters(cm);
        }, true);
        option("keyMap", "default", function(cm, val, old) {
            var next = getKeyMap(val);
            var prev = old != Init && getKeyMap(old);
            if (prev && prev.detach) prev.detach(cm, next);
            if (next.attach) next.attach(cm, prev || null);
        });
        option("extraKeys", null);
        option("configureMouse", null);
        option("lineWrapping", false, wrappingChanged, true);
        option("gutters", [], function(cm, val) {
            cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
            updateGutters(cm);
        }, true);
        option("fixedGutter", true, function(cm, val) {
            cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
            cm.refresh();
        }, true);
        option("coverGutterNextToScrollbar", false, function(cm) {
            return updateScrollbars(cm);
        }, true);
        option("scrollbarStyle", "native", function(cm) {
            initScrollbars(cm);
            updateScrollbars(cm);
            cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
            cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
        }, true);
        option("lineNumbers", false, function(cm, val) {
            cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
            updateGutters(cm);
        }, true);
        option("firstLineNumber", 1, updateGutters, true);
        option("lineNumberFormatter", function(integer) {
            return integer;
        }, updateGutters, true);
        option("showCursorWhenSelecting", false, updateSelection, true);
        option("resetSelectionOnContextMenu", true);
        option("lineWiseCopyCut", true);
        option("pasteLinesPerSelection", true);
        option("selectionsMayTouch", false);
        option("readOnly", false, function(cm, val) {
            if (val == "nocursor") {
                onBlur(cm);
                cm.display.input.blur();
            }
            cm.display.input.readOnlyChanged(val);
        });
        option("screenReaderLabel", null, function(cm, val) {
            val = val === '' ? null : val;
            cm.display.input.screenReaderLabelChanged(val);
        });
        option("disableInput", false, function(cm, val) {
            if (!val) cm.display.input.reset();
        }, true);
        option("dragDrop", true, dragDropChanged);
        option("allowDropFileTypes", null);
        option("cursorBlinkRate", 530);
        option("cursorScrollMargin", 0);
        option("cursorHeight", 1, updateSelection, true);
        option("singleCursorHeightPerLine", true, updateSelection, true);
        option("workTime", 100);
        option("workDelay", 100);
        option("flattenSpans", true, resetModeState, true);
        option("addModeClass", false, resetModeState, true);
        option("pollInterval", 100);
        option("undoDepth", 200, function(cm, val) {
            return cm.doc.history.undoDepth = val;
        });
        option("historyEventDelay", 1250);
        option("viewportMargin", 10, function(cm) {
            return cm.refresh();
        }, true);
        option("maxHighlightLength", 10000, resetModeState, true);
        option("moveInputWithCursor", true, function(cm, val) {
            if (!val) cm.display.input.resetPosition();
        });
        option("tabindex", null, function(cm, val) {
            return cm.display.input.getField().tabIndex = val || "";
        });
        option("autofocus", null);
        option("direction", "ltr", function(cm, val) {
            return cm.doc.setDirection(val);
        }, true);
        option("phrases", null);
    }
    function dragDropChanged(cm, value, old) {
        var wasOn = old && old != Init;
        if (!value != !wasOn) {
            var funcs = cm.display.dragFunctions;
            var toggle = value ? on : off;
            toggle(cm.display.scroller, "dragstart", funcs.start);
            toggle(cm.display.scroller, "dragenter", funcs.enter);
            toggle(cm.display.scroller, "dragover", funcs.over);
            toggle(cm.display.scroller, "dragleave", funcs.leave);
            toggle(cm.display.scroller, "drop", funcs.drop);
        }
    }
    function wrappingChanged(cm) {
        if (cm.options.lineWrapping) {
            addClass(cm.display.wrapper, "CodeMirror-wrap");
            cm.display.sizer.style.minWidth = "";
            cm.display.sizerWidth = null;
        } else {
            rmClass(cm.display.wrapper, "CodeMirror-wrap");
            findMaxLine(cm);
        }
        estimateLineHeights(cm);
        regChange(cm);
        clearCaches(cm);
        setTimeout(function() {
            return updateScrollbars(cm);
        }, 100);
    }
    // A CodeMirror instance represents an editor. This is the object
    // that user code is usually dealing with.
    function CodeMirror(place, options) {
        var this$1 = this;
        if (!(this instanceof CodeMirror)) return new CodeMirror(place, options);
        this.options = options = options ? copyObj(options) : {};
        // Determine effective options based on given values and defaults.
        copyObj(defaults, options, false);
        var doc = options.value;
        if (typeof doc == "string") doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction);
        else if (options.mode) doc.modeOption = options.mode;
        this.doc = doc;
        var input = new CodeMirror.inputStyles[options.inputStyle](this);
        var display = this.display = new Display(place, doc, input, options);
        display.wrapper.CodeMirror = this;
        themeChanged(this);
        if (options.lineWrapping) this.display.wrapper.className += " CodeMirror-wrap";
        initScrollbars(this);
        this.state = {
            keyMaps: [],
            overlays: [],
            modeGen: 0,
            overwrite: false,
            delayingBlurEvent: false,
            focused: false,
            suppressEdits: false,
            pasteIncoming: -1,
            cutIncoming: -1,
            selectingText: false,
            draggingText: false,
            highlight: new Delayed(),
            keySeq: null,
            specialChars: null
        };
        if (options.autofocus && !mobile) display.input.focus();
        // Override magic textarea content restore that IE sometimes does
        // on our hidden textarea on reload
        if (ie && ie_version < 11) setTimeout(function() {
            return this$1.display.input.reset(true);
        }, 20);
        registerEventHandlers(this);
        ensureGlobalHandlers();
        startOperation(this);
        this.curOp.forceUpdate = true;
        attachDoc(this, doc);
        if (options.autofocus && !mobile || this.hasFocus()) setTimeout(function() {
            if (this$1.hasFocus() && !this$1.state.focused) onFocus(this$1);
        }, 20);
        else onBlur(this);
        for(var opt in optionHandlers)if (optionHandlers.hasOwnProperty(opt)) optionHandlers[opt](this, options[opt], Init);
        maybeUpdateLineNumberWidth(this);
        if (options.finishInit) options.finishInit(this);
        for(var i = 0; i < initHooks.length; ++i)initHooks[i](this);
        endOperation(this);
        // Suppress optimizelegibility in Webkit, since it breaks text
        // measuring on line wrapping boundaries.
        if (webkit && options.lineWrapping && getComputedStyle(display.lineDiv).textRendering == "optimizelegibility") display.lineDiv.style.textRendering = "auto";
    }
    // The default configuration options.
    CodeMirror.defaults = defaults;
    // Functions to run when options are changed.
    CodeMirror.optionHandlers = optionHandlers;
    // Attach the necessary event handlers when initializing the editor
    function registerEventHandlers(cm) {
        var d = cm.display;
        on(d.scroller, "mousedown", operation(cm, onMouseDown));
        // Older IE's will not fire a second mousedown for a double click
        if (ie && ie_version < 11) on(d.scroller, "dblclick", operation(cm, function(e) {
            if (signalDOMEvent(cm, e)) return;
            var pos = posFromMouse(cm, e);
            if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) return;
            e_preventDefault(e);
            var word = cm.findWordAt(pos);
            extendSelection(cm.doc, word.anchor, word.head);
        }));
        else on(d.scroller, "dblclick", function(e) {
            return signalDOMEvent(cm, e) || e_preventDefault(e);
        });
        // Some browsers fire contextmenu *after* opening the menu, at
        // which point we can't mess with it anymore. Context menu is
        // handled in onMouseDown for these browsers.
        on(d.scroller, "contextmenu", function(e) {
            return onContextMenu(cm, e);
        });
        on(d.input.getField(), "contextmenu", function(e) {
            if (!d.scroller.contains(e.target)) onContextMenu(cm, e);
        });
        // Used to suppress mouse event handling when a touch happens
        var touchFinished, prevTouch = {
            end: 0
        };
        function finishTouch() {
            if (d.activeTouch) {
                touchFinished = setTimeout(function() {
                    return d.activeTouch = null;
                }, 1000);
                prevTouch = d.activeTouch;
                prevTouch.end = +new Date;
            }
        }
        function isMouseLikeTouchEvent(e) {
            if (e.touches.length != 1) return false;
            var touch = e.touches[0];
            return touch.radiusX <= 1 && touch.radiusY <= 1;
        }
        function farAway(touch, other) {
            if (other.left == null) return true;
            var dx = other.left - touch.left, dy = other.top - touch.top;
            return dx * dx + dy * dy > 400;
        }
        on(d.scroller, "touchstart", function(e) {
            if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
                d.input.ensurePolled();
                clearTimeout(touchFinished);
                var now = +new Date;
                d.activeTouch = {
                    start: now,
                    moved: false,
                    prev: now - prevTouch.end <= 300 ? prevTouch : null
                };
                if (e.touches.length == 1) {
                    d.activeTouch.left = e.touches[0].pageX;
                    d.activeTouch.top = e.touches[0].pageY;
                }
            }
        });
        on(d.scroller, "touchmove", function() {
            if (d.activeTouch) d.activeTouch.moved = true;
        });
        on(d.scroller, "touchend", function(e) {
            var touch = d.activeTouch;
            if (touch && !eventInWidget(d, e) && touch.left != null && !touch.moved && new Date - touch.start < 300) {
                var pos = cm.coordsChar(d.activeTouch, "page"), range;
                if (!touch.prev || farAway(touch, touch.prev)) range = new Range(pos, pos);
                else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) range = cm.findWordAt(pos);
                else range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0)));
                cm.setSelection(range.anchor, range.head);
                cm.focus();
                e_preventDefault(e);
            }
            finishTouch();
        });
        on(d.scroller, "touchcancel", finishTouch);
        // Sync scrolling between fake scrollbars and real scrollable
        // area, ensure viewport is updated when scrolling.
        on(d.scroller, "scroll", function() {
            if (d.scroller.clientHeight) {
                updateScrollTop(cm, d.scroller.scrollTop);
                setScrollLeft(cm, d.scroller.scrollLeft, true);
                signal(cm, "scroll", cm);
            }
        });
        // Listen to wheel events in order to try and update the viewport on time.
        on(d.scroller, "mousewheel", function(e) {
            return onScrollWheel(cm, e);
        });
        on(d.scroller, "DOMMouseScroll", function(e) {
            return onScrollWheel(cm, e);
        });
        // Prevent wrapper from ever scrolling
        on(d.wrapper, "scroll", function() {
            return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0;
        });
        d.dragFunctions = {
            enter: function(e) {
                if (!signalDOMEvent(cm, e)) e_stop(e);
            },
            over: function(e) {
                if (!signalDOMEvent(cm, e)) {
                    onDragOver(cm, e);
                    e_stop(e);
                }
            },
            start: function(e) {
                return onDragStart(cm, e);
            },
            drop: operation(cm, onDrop),
            leave: function(e) {
                if (!signalDOMEvent(cm, e)) clearDragCursor(cm);
            }
        };
        var inp = d.input.getField();
        on(inp, "keyup", function(e) {
            return onKeyUp.call(cm, e);
        });
        on(inp, "keydown", operation(cm, onKeyDown));
        on(inp, "keypress", operation(cm, onKeyPress));
        on(inp, "focus", function(e) {
            return onFocus(cm, e);
        });
        on(inp, "blur", function(e) {
            return onBlur(cm, e);
        });
    }
    var initHooks = [];
    CodeMirror.defineInitHook = function(f) {
        return initHooks.push(f);
    };
    // Indent the given line. The how parameter can be "smart",
    // "add"/null, "subtract", or "prev". When aggressive is false
    // (typically set to true for forced single-line indents), empty
    // lines are not indented, and places where the mode returns Pass
    // are left alone.
    function indentLine(cm, n, how, aggressive) {
        var doc = cm.doc, state;
        if (how == null) how = "add";
        if (how == "smart") {
            // Fall back to "prev" when the mode doesn't have an indentation
            // method.
            if (!doc.mode.indent) how = "prev";
            else state = getContextBefore(cm, n).state;
        }
        var tabSize = cm.options.tabSize;
        var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
        if (line.stateAfter) line.stateAfter = null;
        var curSpaceString = line.text.match(/^\s*/)[0], indentation;
        if (!aggressive && !/\S/.test(line.text)) {
            indentation = 0;
            how = "not";
        } else if (how == "smart") {
            indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
            if (indentation == Pass || indentation > 150) {
                if (!aggressive) return;
                how = "prev";
            }
        }
        if (how == "prev") {
            if (n > doc.first) indentation = countColumn(getLine(doc, n - 1).text, null, tabSize);
            else indentation = 0;
        } else if (how == "add") indentation = curSpace + cm.options.indentUnit;
        else if (how == "subtract") indentation = curSpace - cm.options.indentUnit;
        else if (typeof how == "number") indentation = curSpace + how;
        indentation = Math.max(0, indentation);
        var indentString = "", pos = 0;
        if (cm.options.indentWithTabs) for(var i = Math.floor(indentation / tabSize); i; --i){
            pos += tabSize;
            indentString += "\t";
        }
        if (pos < indentation) indentString += spaceStr(indentation - pos);
        if (indentString != curSpaceString) {
            replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
            line.stateAfter = null;
            return true;
        } else // Ensure that, if the cursor was in the whitespace at the start
        // of the line, it is moved to the end of that space.
        for(var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++){
            var range = doc.sel.ranges[i$1];
            if (range.head.line == n && range.head.ch < curSpaceString.length) {
                var pos$1 = Pos(n, curSpaceString.length);
                replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
                break;
            }
        }
    }
    // This will be set to a {lineWise: bool, text: [string]} object, so
    // that, when pasting, we know what kind of selections the copied
    // text was made out of.
    var lastCopied = null;
    function setLastCopied(newLastCopied) {
        lastCopied = newLastCopied;
    }
    function applyTextInput(cm, inserted, deleted, sel, origin) {
        var doc = cm.doc;
        cm.display.shift = false;
        if (!sel) sel = doc.sel;
        var recent = +new Date - 200;
        var paste = origin == "paste" || cm.state.pasteIncoming > recent;
        var textLines = splitLinesAuto(inserted), multiPaste = null;
        // When pasting N lines into N selections, insert one line per selection
        if (paste && sel.ranges.length > 1) {
            if (lastCopied && lastCopied.text.join("\n") == inserted) {
                if (sel.ranges.length % lastCopied.text.length == 0) {
                    multiPaste = [];
                    for(var i = 0; i < lastCopied.text.length; i++)multiPaste.push(doc.splitLines(lastCopied.text[i]));
                }
            } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) multiPaste = map(textLines, function(l) {
                return [
                    l
                ];
            });
        }
        var updateInput = cm.curOp.updateInput;
        // Normal behavior is to insert the new text into every selection
        for(var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--){
            var range = sel.ranges[i$1];
            var from = range.from(), to = range.to();
            if (range.empty()) {
                if (deleted && deleted > 0) from = Pos(from.line, from.ch - deleted);
                else if (cm.state.overwrite && !paste) to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length));
                else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == textLines.join("\n")) from = to = Pos(from.line, 0);
            }
            var changeEvent = {
                from: from,
                to: to,
                text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
                origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input")
            };
            makeChange(cm.doc, changeEvent);
            signalLater(cm, "inputRead", cm, changeEvent);
        }
        if (inserted && !paste) triggerElectric(cm, inserted);
        ensureCursorVisible(cm);
        if (cm.curOp.updateInput < 2) cm.curOp.updateInput = updateInput;
        cm.curOp.typing = true;
        cm.state.pasteIncoming = cm.state.cutIncoming = -1;
    }
    function handlePaste(e, cm) {
        var pasted = e.clipboardData && e.clipboardData.getData("Text");
        if (pasted) {
            e.preventDefault();
            if (!cm.isReadOnly() && !cm.options.disableInput && cm.hasFocus()) runInOp(cm, function() {
                return applyTextInput(cm, pasted, 0, null, "paste");
            });
            return true;
        }
    }
    function triggerElectric(cm, inserted) {
        // When an 'electric' character is inserted, immediately trigger a reindent
        if (!cm.options.electricChars || !cm.options.smartIndent) return;
        var sel = cm.doc.sel;
        for(var i = sel.ranges.length - 1; i >= 0; i--){
            var range = sel.ranges[i];
            if (range.head.ch > 100 || i && sel.ranges[i - 1].head.line == range.head.line) continue;
            var mode = cm.getModeAt(range.head);
            var indented = false;
            if (mode.electricChars) {
                for(var j = 0; j < mode.electricChars.length; j++)if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
                    indented = indentLine(cm, range.head.line, "smart");
                    break;
                }
            } else if (mode.electricInput) {
                if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch))) indented = indentLine(cm, range.head.line, "smart");
            }
            if (indented) signalLater(cm, "electricInput", cm, range.head.line);
        }
    }
    function copyableRanges(cm) {
        var text = [], ranges = [];
        for(var i = 0; i < cm.doc.sel.ranges.length; i++){
            var line = cm.doc.sel.ranges[i].head.line;
            var lineRange = {
                anchor: Pos(line, 0),
                head: Pos(line + 1, 0)
            };
            ranges.push(lineRange);
            text.push(cm.getRange(lineRange.anchor, lineRange.head));
        }
        return {
            text: text,
            ranges: ranges
        };
    }
    function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
        field.setAttribute("autocorrect", autocorrect ? "on" : "off");
        field.setAttribute("autocapitalize", autocapitalize ? "on" : "off");
        field.setAttribute("spellcheck", !!spellcheck);
    }
    function hiddenTextarea() {
        var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none");
        var div = elt("div", [
            te
        ], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
        // The textarea is kept positioned near the cursor to prevent the
        // fact that it'll be scrolled into view on input from scrolling
        // our fake cursor out of view. On webkit, when wrap=off, paste is
        // very slow. So make the area wide instead.
        if (webkit) te.style.width = "1000px";
        else te.setAttribute("wrap", "off");
        // If border: 0; -- iOS fails to open keyboard (issue #1287)
        if (ios) te.style.border = "1px solid black";
        return div;
    }
    // The publicly visible API. Note that methodOp(f) means
    // 'wrap f in an operation, performed on its `this` parameter'.
    // This is not the complete set of editor methods. Most of the
    // methods defined on the Doc type are also injected into
    // CodeMirror.prototype, for backwards compatibility and
    // convenience.
    function addEditorMethods(CodeMirror) {
        var optionHandlers = CodeMirror.optionHandlers;
        var helpers = CodeMirror.helpers = {};
        CodeMirror.prototype = {
            constructor: CodeMirror,
            focus: function() {
                win(this).focus();
                this.display.input.focus();
            },
            setOption: function(option, value) {
                var options = this.options, old = options[option];
                if (options[option] == value && option != "mode") return;
                options[option] = value;
                if (optionHandlers.hasOwnProperty(option)) operation(this, optionHandlers[option])(this, value, old);
                signal(this, "optionChange", this, option);
            },
            getOption: function(option) {
                return this.options[option];
            },
            getDoc: function() {
                return this.doc;
            },
            addKeyMap: function(map, bottom) {
                this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map));
            },
            removeKeyMap: function(map) {
                var maps = this.state.keyMaps;
                for(var i = 0; i < maps.length; ++i)if (maps[i] == map || maps[i].name == map) {
                    maps.splice(i, 1);
                    return true;
                }
            },
            addOverlay: methodOp(function(spec, options) {
                var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
                if (mode.startState) throw new Error("Overlays may not be stateful.");
                insertSorted(this.state.overlays, {
                    mode: mode,
                    modeSpec: spec,
                    opaque: options && options.opaque,
                    priority: options && options.priority || 0
                }, function(overlay) {
                    return overlay.priority;
                });
                this.state.modeGen++;
                regChange(this);
            }),
            removeOverlay: methodOp(function(spec) {
                var overlays = this.state.overlays;
                for(var i = 0; i < overlays.length; ++i){
                    var cur = overlays[i].modeSpec;
                    if (cur == spec || typeof spec == "string" && cur.name == spec) {
                        overlays.splice(i, 1);
                        this.state.modeGen++;
                        regChange(this);
                        return;
                    }
                }
            }),
            indentLine: methodOp(function(n, dir, aggressive) {
                if (typeof dir != "string" && typeof dir != "number") {
                    if (dir == null) dir = this.options.smartIndent ? "smart" : "prev";
                    else dir = dir ? "add" : "subtract";
                }
                if (isLine(this.doc, n)) indentLine(this, n, dir, aggressive);
            }),
            indentSelection: methodOp(function(how) {
                var ranges = this.doc.sel.ranges, end = -1;
                for(var i = 0; i < ranges.length; i++){
                    var range = ranges[i];
                    if (!range.empty()) {
                        var from = range.from(), to = range.to();
                        var start = Math.max(end, from.line);
                        end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
                        for(var j = start; j < end; ++j)indentLine(this, j, how);
                        var newRanges = this.doc.sel.ranges;
                        if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0) replaceOneSelection(this.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll);
                    } else if (range.head.line > end) {
                        indentLine(this, range.head.line, how, true);
                        end = range.head.line;
                        if (i == this.doc.sel.primIndex) ensureCursorVisible(this);
                    }
                }
            }),
            // Fetch the parser token for a given character. Useful for hacks
            // that want to inspect the mode state (say, for completion).
            getTokenAt: function(pos, precise) {
                return takeToken(this, pos, precise);
            },
            getLineTokens: function(line, precise) {
                return takeToken(this, Pos(line), precise, true);
            },
            getTokenTypeAt: function(pos) {
                pos = clipPos(this.doc, pos);
                var styles = getLineStyles(this, getLine(this.doc, pos.line));
                var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
                var type;
                if (ch == 0) type = styles[2];
                else for(;;){
                    var mid = before + after >> 1;
                    if ((mid ? styles[mid * 2 - 1] : 0) >= ch) after = mid;
                    else if (styles[mid * 2 + 1] < ch) before = mid + 1;
                    else {
                        type = styles[mid * 2 + 2];
                        break;
                    }
                }
                var cut = type ? type.indexOf("overlay ") : -1;
                return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1);
            },
            getModeAt: function(pos) {
                var mode = this.doc.mode;
                if (!mode.innerMode) return mode;
                return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode;
            },
            getHelper: function(pos, type) {
                return this.getHelpers(pos, type)[0];
            },
            getHelpers: function(pos, type) {
                var found = [];
                if (!helpers.hasOwnProperty(type)) return found;
                var help = helpers[type], mode = this.getModeAt(pos);
                if (typeof mode[type] == "string") {
                    if (help[mode[type]]) found.push(help[mode[type]]);
                } else if (mode[type]) for(var i = 0; i < mode[type].length; i++){
                    var val = help[mode[type][i]];
                    if (val) found.push(val);
                }
                else if (mode.helperType && help[mode.helperType]) found.push(help[mode.helperType]);
                else if (help[mode.name]) found.push(help[mode.name]);
                for(var i$1 = 0; i$1 < help._global.length; i$1++){
                    var cur = help._global[i$1];
                    if (cur.pred(mode, this) && indexOf(found, cur.val) == -1) found.push(cur.val);
                }
                return found;
            },
            getStateAfter: function(line, precise) {
                var doc = this.doc;
                line = clipLine(doc, line == null ? doc.first + doc.size - 1 : line);
                return getContextBefore(this, line + 1, precise).state;
            },
            cursorCoords: function(start, mode) {
                var pos, range = this.doc.sel.primary();
                if (start == null) pos = range.head;
                else if (typeof start == "object") pos = clipPos(this.doc, start);
                else pos = start ? range.from() : range.to();
                return cursorCoords(this, pos, mode || "page");
            },
            charCoords: function(pos, mode) {
                return charCoords(this, clipPos(this.doc, pos), mode || "page");
            },
            coordsChar: function(coords, mode) {
                coords = fromCoordSystem(this, coords, mode || "page");
                return coordsChar(this, coords.left, coords.top);
            },
            lineAtHeight: function(height, mode) {
                height = fromCoordSystem(this, {
                    top: height,
                    left: 0
                }, mode || "page").top;
                return lineAtHeight(this.doc, height + this.display.viewOffset);
            },
            heightAtLine: function(line, mode, includeWidgets) {
                var end = false, lineObj;
                if (typeof line == "number") {
                    var last = this.doc.first + this.doc.size - 1;
                    if (line < this.doc.first) line = this.doc.first;
                    else if (line > last) {
                        line = last;
                        end = true;
                    }
                    lineObj = getLine(this.doc, line);
                } else lineObj = line;
                return intoCoordSystem(this, lineObj, {
                    top: 0,
                    left: 0
                }, mode || "page", includeWidgets || end).top + (end ? this.doc.height - heightAtLine(lineObj) : 0);
            },
            defaultTextHeight: function() {
                return textHeight(this.display);
            },
            defaultCharWidth: function() {
                return charWidth(this.display);
            },
            getViewport: function() {
                return {
                    from: this.display.viewFrom,
                    to: this.display.viewTo
                };
            },
            addWidget: function(pos, node, scroll, vert, horiz) {
                var display = this.display;
                pos = cursorCoords(this, clipPos(this.doc, pos));
                var top = pos.bottom, left = pos.left;
                node.style.position = "absolute";
                node.setAttribute("cm-ignore-events", "true");
                this.display.input.setUneditable(node);
                display.sizer.appendChild(node);
                if (vert == "over") top = pos.top;
                else if (vert == "above" || vert == "near") {
                    var vspace = Math.max(display.wrapper.clientHeight, this.doc.height), hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
                    // Default to positioning above (if specified and possible); otherwise default to positioning below
                    if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight) top = pos.top - node.offsetHeight;
                    else if (pos.bottom + node.offsetHeight <= vspace) top = pos.bottom;
                    if (left + node.offsetWidth > hspace) left = hspace - node.offsetWidth;
                }
                node.style.top = top + "px";
                node.style.left = node.style.right = "";
                if (horiz == "right") {
                    left = display.sizer.clientWidth - node.offsetWidth;
                    node.style.right = "0px";
                } else {
                    if (horiz == "left") left = 0;
                    else if (horiz == "middle") left = (display.sizer.clientWidth - node.offsetWidth) / 2;
                    node.style.left = left + "px";
                }
                if (scroll) scrollIntoView(this, {
                    left: left,
                    top: top,
                    right: left + node.offsetWidth,
                    bottom: top + node.offsetHeight
                });
            },
            triggerOnKeyDown: methodOp(onKeyDown),
            triggerOnKeyPress: methodOp(onKeyPress),
            triggerOnKeyUp: onKeyUp,
            triggerOnMouseDown: methodOp(onMouseDown),
            execCommand: function(cmd) {
                if (commands.hasOwnProperty(cmd)) return commands[cmd].call(null, this);
            },
            triggerElectric: methodOp(function(text) {
                triggerElectric(this, text);
            }),
            findPosH: function(from, amount, unit, visually) {
                var dir = 1;
                if (amount < 0) {
                    dir = -1;
                    amount = -amount;
                }
                var cur = clipPos(this.doc, from);
                for(var i = 0; i < amount; ++i){
                    cur = findPosH(this.doc, cur, dir, unit, visually);
                    if (cur.hitSide) break;
                }
                return cur;
            },
            moveH: methodOp(function(dir, unit) {
                var this$1 = this;
                this.extendSelectionsBy(function(range) {
                    if (this$1.display.shift || this$1.doc.extend || range.empty()) return findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually);
                    else return dir < 0 ? range.from() : range.to();
                }, sel_move);
            }),
            deleteH: methodOp(function(dir, unit) {
                var sel = this.doc.sel, doc = this.doc;
                if (sel.somethingSelected()) doc.replaceSelection("", null, "+delete");
                else deleteNearSelection(this, function(range) {
                    var other = findPosH(doc, range.head, dir, unit, false);
                    return dir < 0 ? {
                        from: other,
                        to: range.head
                    } : {
                        from: range.head,
                        to: other
                    };
                });
            }),
            findPosV: function(from, amount, unit, goalColumn) {
                var dir = 1, x = goalColumn;
                if (amount < 0) {
                    dir = -1;
                    amount = -amount;
                }
                var cur = clipPos(this.doc, from);
                for(var i = 0; i < amount; ++i){
                    var coords = cursorCoords(this, cur, "div");
                    if (x == null) x = coords.left;
                    else coords.left = x;
                    cur = findPosV(this, coords, dir, unit);
                    if (cur.hitSide) break;
                }
                return cur;
            },
            moveV: methodOp(function(dir, unit) {
                var this$1 = this;
                var doc = this.doc, goals = [];
                var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
                doc.extendSelectionsBy(function(range) {
                    if (collapse) return dir < 0 ? range.from() : range.to();
                    var headPos = cursorCoords(this$1, range.head, "div");
                    if (range.goalColumn != null) headPos.left = range.goalColumn;
                    goals.push(headPos.left);
                    var pos = findPosV(this$1, headPos, dir, unit);
                    if (unit == "page" && range == doc.sel.primary()) addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top);
                    return pos;
                }, sel_move);
                if (goals.length) for(var i = 0; i < doc.sel.ranges.length; i++)doc.sel.ranges[i].goalColumn = goals[i];
            }),
            // Find the word at the given position (as returned by coordsChar).
            findWordAt: function(pos) {
                var doc = this.doc, line = getLine(doc, pos.line).text;
                var start = pos.ch, end = pos.ch;
                if (line) {
                    var helper = this.getHelper(pos, "wordChars");
                    if ((pos.sticky == "before" || end == line.length) && start) --start;
                    else ++end;
                    var startChar = line.charAt(start);
                    var check = isWordChar(startChar, helper) ? function(ch) {
                        return isWordChar(ch, helper);
                    } : /\s/.test(startChar) ? function(ch) {
                        return /\s/.test(ch);
                    } : function(ch) {
                        return !/\s/.test(ch) && !isWordChar(ch);
                    };
                    while(start > 0 && check(line.charAt(start - 1)))--start;
                    while(end < line.length && check(line.charAt(end)))++end;
                }
                return new Range(Pos(pos.line, start), Pos(pos.line, end));
            },
            toggleOverwrite: function(value) {
                if (value != null && value == this.state.overwrite) return;
                if (this.state.overwrite = !this.state.overwrite) addClass(this.display.cursorDiv, "CodeMirror-overwrite");
                else rmClass(this.display.cursorDiv, "CodeMirror-overwrite");
                signal(this, "overwriteToggle", this, this.state.overwrite);
            },
            hasFocus: function() {
                return this.display.input.getField() == activeElt(root(this));
            },
            isReadOnly: function() {
                return !!(this.options.readOnly || this.doc.cantEdit);
            },
            scrollTo: methodOp(function(x, y) {
                scrollToCoords(this, x, y);
            }),
            getScrollInfo: function() {
                var scroller = this.display.scroller;
                return {
                    left: scroller.scrollLeft,
                    top: scroller.scrollTop,
                    height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
                    width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
                    clientHeight: displayHeight(this),
                    clientWidth: displayWidth(this)
                };
            },
            scrollIntoView: methodOp(function(range, margin) {
                if (range == null) {
                    range = {
                        from: this.doc.sel.primary().head,
                        to: null
                    };
                    if (margin == null) margin = this.options.cursorScrollMargin;
                } else if (typeof range == "number") range = {
                    from: Pos(range, 0),
                    to: null
                };
                else if (range.from == null) range = {
                    from: range,
                    to: null
                };
                if (!range.to) range.to = range.from;
                range.margin = margin || 0;
                if (range.from.line != null) scrollToRange(this, range);
                else scrollToCoordsRange(this, range.from, range.to, range.margin);
            }),
            setSize: methodOp(function(width, height) {
                var this$1 = this;
                var interpret = function(val) {
                    return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val;
                };
                if (width != null) this.display.wrapper.style.width = interpret(width);
                if (height != null) this.display.wrapper.style.height = interpret(height);
                if (this.options.lineWrapping) clearLineMeasurementCache(this);
                var lineNo = this.display.viewFrom;
                this.doc.iter(lineNo, this.display.viewTo, function(line) {
                    if (line.widgets) {
                        for(var i = 0; i < line.widgets.length; i++)if (line.widgets[i].noHScroll) {
                            regLineChange(this$1, lineNo, "widget");
                            break;
                        }
                    }
                    ++lineNo;
                });
                this.curOp.forceUpdate = true;
                signal(this, "refresh", this);
            }),
            operation: function(f) {
                return runInOp(this, f);
            },
            startOperation: function() {
                return startOperation(this);
            },
            endOperation: function() {
                return endOperation(this);
            },
            refresh: methodOp(function() {
                var oldHeight = this.display.cachedTextHeight;
                regChange(this);
                this.curOp.forceUpdate = true;
                clearCaches(this);
                scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
                updateGutterSpace(this.display);
                if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5 || this.options.lineWrapping) estimateLineHeights(this);
                signal(this, "refresh", this);
            }),
            swapDoc: methodOp(function(doc) {
                var old = this.doc;
                old.cm = null;
                // Cancel the current text selection if any (#5821)
                if (this.state.selectingText) this.state.selectingText();
                attachDoc(this, doc);
                clearCaches(this);
                this.display.input.reset();
                scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
                this.curOp.forceScroll = true;
                signalLater(this, "swapDoc", this, old);
                return old;
            }),
            phrase: function(phraseText) {
                var phrases = this.options.phrases;
                return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText;
            },
            getInputField: function() {
                return this.display.input.getField();
            },
            getWrapperElement: function() {
                return this.display.wrapper;
            },
            getScrollerElement: function() {
                return this.display.scroller;
            },
            getGutterElement: function() {
                return this.display.gutters;
            }
        };
        eventMixin(CodeMirror);
        CodeMirror.registerHelper = function(type, name, value) {
            if (!helpers.hasOwnProperty(type)) helpers[type] = CodeMirror[type] = {
                _global: []
            };
            helpers[type][name] = value;
        };
        CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
            CodeMirror.registerHelper(type, name, value);
            helpers[type]._global.push({
                pred: predicate,
                val: value
            });
        };
    }
    // Used for horizontal relative motion. Dir is -1 or 1 (left or
    // right), unit can be "codepoint", "char", "column" (like char, but
    // doesn't cross line boundaries), "word" (across next word), or
    // "group" (to the start of next group of word or
    // non-word-non-whitespace chars). The visually param controls
    // whether, in right-to-left text, direction 1 means to move towards
    // the next index in the string, or towards the character to the right
    // of the current position. The resulting position will have a
    // hitSide=true property if it reached the end of the document.
    function findPosH(doc, pos, dir, unit, visually) {
        var oldPos = pos;
        var origDir = dir;
        var lineObj = getLine(doc, pos.line);
        var lineDir = visually && doc.direction == "rtl" ? -dir : dir;
        function findNextLine() {
            var l = pos.line + lineDir;
            if (l < doc.first || l >= doc.first + doc.size) return false;
            pos = new Pos(l, pos.ch, pos.sticky);
            return lineObj = getLine(doc, l);
        }
        function moveOnce(boundToLine) {
            var next;
            if (unit == "codepoint") {
                var ch = lineObj.text.charCodeAt(pos.ch + (dir > 0 ? 0 : -1));
                if (isNaN(ch)) next = null;
                else {
                    var astral = dir > 0 ? ch >= 0xD800 && ch < 0xDC00 : ch >= 0xDC00 && ch < 0xDFFF;
                    next = new Pos(pos.line, Math.max(0, Math.min(lineObj.text.length, pos.ch + dir * (astral ? 2 : 1))), -dir);
                }
            } else if (visually) next = moveVisually(doc.cm, lineObj, pos, dir);
            else next = moveLogically(lineObj, pos, dir);
            if (next == null) {
                if (!boundToLine && findNextLine()) pos = endOfLine(visually, doc.cm, lineObj, pos.line, lineDir);
                else return false;
            } else pos = next;
            return true;
        }
        if (unit == "char" || unit == "codepoint") moveOnce();
        else if (unit == "column") moveOnce(true);
        else if (unit == "word" || unit == "group") {
            var sawType = null, group = unit == "group";
            var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
            for(var first = true;; first = false){
                if (dir < 0 && !moveOnce(!first)) break;
                var cur = lineObj.text.charAt(pos.ch) || "\n";
                var type = isWordChar(cur, helper) ? "w" : group && cur == "\n" ? "n" : !group || /\s/.test(cur) ? null : "p";
                if (group && !first && !type) type = "s";
                if (sawType && sawType != type) {
                    if (dir < 0) {
                        dir = 1;
                        moveOnce();
                        pos.sticky = "after";
                    }
                    break;
                }
                if (type) sawType = type;
                if (dir > 0 && !moveOnce(!first)) break;
            }
        }
        var result = skipAtomic(doc, pos, oldPos, origDir, true);
        if (equalCursorPos(oldPos, result)) result.hitSide = true;
        return result;
    }
    // For relative vertical movement. Dir may be -1 or 1. Unit can be
    // "page" or "line". The resulting position will have a hitSide=true
    // property if it reached the end of the document.
    function findPosV(cm, pos, dir, unit) {
        var doc = cm.doc, x = pos.left, y;
        if (unit == "page") {
            var pageSize = Math.min(cm.display.wrapper.clientHeight, win(cm).innerHeight || doc(cm).documentElement.clientHeight);
            var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
            y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;
        } else if (unit == "line") y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
        var target;
        for(;;){
            target = coordsChar(cm, x, y);
            if (!target.outside) break;
            if (dir < 0 ? y <= 0 : y >= doc.height) {
                target.hitSide = true;
                break;
            }
            y += dir * 5;
        }
        return target;
    }
    // CONTENTEDITABLE INPUT STYLE
    var ContentEditableInput = function(cm) {
        this.cm = cm;
        this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
        this.polling = new Delayed();
        this.composing = null;
        this.gracePeriod = false;
        this.readDOMTimeout = null;
    };
    ContentEditableInput.prototype.init = function(display) {
        var this$1 = this;
        var input = this, cm = input.cm;
        var div = input.div = display.lineDiv;
        div.contentEditable = true;
        disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);
        function belongsToInput(e) {
            for(var t = e.target; t; t = t.parentNode){
                if (t == div) return true;
                if (/\bCodeMirror-(?:line)?widget\b/.test(t.className)) break;
            }
            return false;
        }
        on(div, "paste", function(e) {
            if (!belongsToInput(e) || signalDOMEvent(cm, e) || handlePaste(e, cm)) return;
            // IE doesn't fire input events, so we schedule a read for the pasted content in this way
            if (ie_version <= 11) setTimeout(operation(cm, function() {
                return this$1.updateFromDOM();
            }), 20);
        });
        on(div, "compositionstart", function(e) {
            this$1.composing = {
                data: e.data,
                done: false
            };
        });
        on(div, "compositionupdate", function(e) {
            if (!this$1.composing) this$1.composing = {
                data: e.data,
                done: false
            };
        });
        on(div, "compositionend", function(e) {
            if (this$1.composing) {
                if (e.data != this$1.composing.data) this$1.readFromDOMSoon();
                this$1.composing.done = true;
            }
        });
        on(div, "touchstart", function() {
            return input.forceCompositionEnd();
        });
        on(div, "input", function() {
            if (!this$1.composing) this$1.readFromDOMSoon();
        });
        function onCopyCut(e) {
            if (!belongsToInput(e) || signalDOMEvent(cm, e)) return;
            if (cm.somethingSelected()) {
                setLastCopied({
                    lineWise: false,
                    text: cm.getSelections()
                });
                if (e.type == "cut") cm.replaceSelection("", null, "cut");
            } else if (!cm.options.lineWiseCopyCut) return;
            else {
                var ranges = copyableRanges(cm);
                setLastCopied({
                    lineWise: true,
                    text: ranges.text
                });
                if (e.type == "cut") cm.operation(function() {
                    cm.setSelections(ranges.ranges, 0, sel_dontScroll);
                    cm.replaceSelection("", null, "cut");
                });
            }
            if (e.clipboardData) {
                e.clipboardData.clearData();
                var content = lastCopied.text.join("\n");
                // iOS exposes the clipboard API, but seems to discard content inserted into it
                e.clipboardData.setData("Text", content);
                if (e.clipboardData.getData("Text") == content) {
                    e.preventDefault();
                    return;
                }
            }
            // Old-fashioned briefly-focus-a-textarea hack
            var kludge = hiddenTextarea(), te = kludge.firstChild;
            disableBrowserMagic(te);
            cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
            te.value = lastCopied.text.join("\n");
            var hadFocus = activeElt(rootNode(div));
            selectInput(te);
            setTimeout(function() {
                cm.display.lineSpace.removeChild(kludge);
                hadFocus.focus();
                if (hadFocus == div) input.showPrimarySelection();
            }, 50);
        }
        on(div, "copy", onCopyCut);
        on(div, "cut", onCopyCut);
    };
    ContentEditableInput.prototype.screenReaderLabelChanged = function(label) {
        // Label for screenreaders, accessibility
        if (label) this.div.setAttribute('aria-label', label);
        else this.div.removeAttribute('aria-label');
    };
    ContentEditableInput.prototype.prepareSelection = function() {
        var result = prepareSelection(this.cm, false);
        result.focus = activeElt(rootNode(this.div)) == this.div;
        return result;
    };
    ContentEditableInput.prototype.showSelection = function(info, takeFocus) {
        if (!info || !this.cm.display.view.length) return;
        if (info.focus || takeFocus) this.showPrimarySelection();
        this.showMultipleSelections(info);
    };
    ContentEditableInput.prototype.getSelection = function() {
        return this.cm.display.wrapper.ownerDocument.getSelection();
    };
    ContentEditableInput.prototype.showPrimarySelection = function() {
        var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
        var from = prim.from(), to = prim.to();
        if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
            sel.removeAllRanges();
            return;
        }
        var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
        var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
        if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad && cmp(minPos(curAnchor, curFocus), from) == 0 && cmp(maxPos(curAnchor, curFocus), to) == 0) return;
        var view = cm.display.view;
        var start = from.line >= cm.display.viewFrom && posToDOM(cm, from) || {
            node: view[0].measure.map[2],
            offset: 0
        };
        var end = to.line < cm.display.viewTo && posToDOM(cm, to);
        if (!end) {
            var measure = view[view.length - 1].measure;
            var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
            end = {
                node: map[map.length - 1],
                offset: map[map.length - 2] - map[map.length - 3]
            };
        }
        if (!start || !end) {
            sel.removeAllRanges();
            return;
        }
        var old = sel.rangeCount && sel.getRangeAt(0), rng;
        try {
            rng = range(start.node, start.offset, end.offset, end.node);
        } catch (e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
        if (rng) {
            if (!gecko && cm.state.focused) {
                sel.collapse(start.node, start.offset);
                if (!rng.collapsed) {
                    sel.removeAllRanges();
                    sel.addRange(rng);
                }
            } else {
                sel.removeAllRanges();
                sel.addRange(rng);
            }
            if (old && sel.anchorNode == null) sel.addRange(old);
            else if (gecko) this.startGracePeriod();
        }
        this.rememberSelection();
    };
    ContentEditableInput.prototype.startGracePeriod = function() {
        var this$1 = this;
        clearTimeout(this.gracePeriod);
        this.gracePeriod = setTimeout(function() {
            this$1.gracePeriod = false;
            if (this$1.selectionChanged()) this$1.cm.operation(function() {
                return this$1.cm.curOp.selectionChanged = true;
            });
        }, 20);
    };
    ContentEditableInput.prototype.showMultipleSelections = function(info) {
        removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
        removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
    };
    ContentEditableInput.prototype.rememberSelection = function() {
        var sel = this.getSelection();
        this.lastAnchorNode = sel.anchorNode;
        this.lastAnchorOffset = sel.anchorOffset;
        this.lastFocusNode = sel.focusNode;
        this.lastFocusOffset = sel.focusOffset;
    };
    ContentEditableInput.prototype.selectionInEditor = function() {
        var sel = this.getSelection();
        if (!sel.rangeCount) return false;
        var node = sel.getRangeAt(0).commonAncestorContainer;
        return contains(this.div, node);
    };
    ContentEditableInput.prototype.focus = function() {
        if (this.cm.options.readOnly != "nocursor") {
            if (!this.selectionInEditor() || activeElt(rootNode(this.div)) != this.div) this.showSelection(this.prepareSelection(), true);
            this.div.focus();
        }
    };
    ContentEditableInput.prototype.blur = function() {
        this.div.blur();
    };
    ContentEditableInput.prototype.getField = function() {
        return this.div;
    };
    ContentEditableInput.prototype.supportsTouch = function() {
        return true;
    };
    ContentEditableInput.prototype.receivedFocus = function() {
        var this$1 = this;
        var input = this;
        if (this.selectionInEditor()) setTimeout(function() {
            return this$1.pollSelection();
        }, 20);
        else runInOp(this.cm, function() {
            return input.cm.curOp.selectionChanged = true;
        });
        function poll() {
            if (input.cm.state.focused) {
                input.pollSelection();
                input.polling.set(input.cm.options.pollInterval, poll);
            }
        }
        this.polling.set(this.cm.options.pollInterval, poll);
    };
    ContentEditableInput.prototype.selectionChanged = function() {
        var sel = this.getSelection();
        return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset || sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset;
    };
    ContentEditableInput.prototype.pollSelection = function() {
        if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) return;
        var sel = this.getSelection(), cm = this.cm;
        // On Android Chrome (version 56, at least), backspacing into an
        // uneditable block element will put the cursor in that element,
        // and then, because it's not editable, hide the virtual keyboard.
        // Because Android doesn't allow us to actually detect backspace
        // presses in a sane way, this code checks for when that happens
        // and simulates a backspace press in this case.
        if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
            this.cm.triggerOnKeyDown({
                type: "keydown",
                keyCode: 8,
                preventDefault: Math.abs
            });
            this.blur();
            this.focus();
            return;
        }
        if (this.composing) return;
        this.rememberSelection();
        var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
        var head = domToPos(cm, sel.focusNode, sel.focusOffset);
        if (anchor && head) runInOp(cm, function() {
            setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
            if (anchor.bad || head.bad) cm.curOp.selectionChanged = true;
        });
    };
    ContentEditableInput.prototype.pollContent = function() {
        if (this.readDOMTimeout != null) {
            clearTimeout(this.readDOMTimeout);
            this.readDOMTimeout = null;
        }
        var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
        var from = sel.from(), to = sel.to();
        if (from.ch == 0 && from.line > cm.firstLine()) from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length);
        if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine()) to = Pos(to.line + 1, 0);
        if (from.line < display.viewFrom || to.line > display.viewTo - 1) return false;
        var fromIndex, fromLine, fromNode;
        if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
            fromLine = lineNo(display.view[0].line);
            fromNode = display.view[0].node;
        } else {
            fromLine = lineNo(display.view[fromIndex].line);
            fromNode = display.view[fromIndex - 1].node.nextSibling;
        }
        var toIndex = findViewIndex(cm, to.line);
        var toLine, toNode;
        if (toIndex == display.view.length - 1) {
            toLine = display.viewTo - 1;
            toNode = display.lineDiv.lastChild;
        } else {
            toLine = lineNo(display.view[toIndex + 1].line) - 1;
            toNode = display.view[toIndex + 1].node.previousSibling;
        }
        if (!fromNode) return false;
        var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
        var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
        while(newText.length > 1 && oldText.length > 1){
            if (lst(newText) == lst(oldText)) {
                newText.pop();
                oldText.pop();
                toLine--;
            } else if (newText[0] == oldText[0]) {
                newText.shift();
                oldText.shift();
                fromLine++;
            } else break;
        }
        var cutFront = 0, cutEnd = 0;
        var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
        while(cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))++cutFront;
        var newBot = lst(newText), oldBot = lst(oldText);
        var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0), oldBot.length - (oldText.length == 1 ? cutFront : 0));
        while(cutEnd < maxCutEnd && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))++cutEnd;
        // Try to move start of change to start of selection if ambiguous
        if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) while(cutFront && cutFront > from.ch && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)){
            cutFront--;
            cutEnd++;
        }
        newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
        newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");
        var chFrom = Pos(fromLine, cutFront);
        var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
        if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
            replaceRange(cm.doc, newText, chFrom, chTo, "+input");
            return true;
        }
    };
    ContentEditableInput.prototype.ensurePolled = function() {
        this.forceCompositionEnd();
    };
    ContentEditableInput.prototype.reset = function() {
        this.forceCompositionEnd();
    };
    ContentEditableInput.prototype.forceCompositionEnd = function() {
        if (!this.composing) return;
        clearTimeout(this.readDOMTimeout);
        this.composing = null;
        this.updateFromDOM();
        this.div.blur();
        this.div.focus();
    };
    ContentEditableInput.prototype.readFromDOMSoon = function() {
        var this$1 = this;
        if (this.readDOMTimeout != null) return;
        this.readDOMTimeout = setTimeout(function() {
            this$1.readDOMTimeout = null;
            if (this$1.composing) {
                if (this$1.composing.done) this$1.composing = null;
                else return;
            }
            this$1.updateFromDOM();
        }, 80);
    };
    ContentEditableInput.prototype.updateFromDOM = function() {
        var this$1 = this;
        if (this.cm.isReadOnly() || !this.pollContent()) runInOp(this.cm, function() {
            return regChange(this$1.cm);
        });
    };
    ContentEditableInput.prototype.setUneditable = function(node) {
        node.contentEditable = "false";
    };
    ContentEditableInput.prototype.onKeyPress = function(e) {
        if (e.charCode == 0 || this.composing) return;
        e.preventDefault();
        if (!this.cm.isReadOnly()) operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0);
    };
    ContentEditableInput.prototype.readOnlyChanged = function(val) {
        this.div.contentEditable = String(val != "nocursor");
    };
    ContentEditableInput.prototype.onContextMenu = function() {};
    ContentEditableInput.prototype.resetPosition = function() {};
    ContentEditableInput.prototype.needsContentAttribute = true;
    function posToDOM(cm, pos) {
        var view = findViewForLine(cm, pos.line);
        if (!view || view.hidden) return null;
        var line = getLine(cm.doc, pos.line);
        var info = mapFromLineView(view, line, pos.line);
        var order = getOrder(line, cm.doc.direction), side = "left";
        if (order) {
            var partPos = getBidiPartAt(order, pos.ch);
            side = partPos % 2 ? "right" : "left";
        }
        var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
        result.offset = result.collapse == "right" ? result.end : result.start;
        return result;
    }
    function isInGutter(node) {
        for(var scan = node; scan; scan = scan.parentNode){
            if (/CodeMirror-gutter-wrapper/.test(scan.className)) return true;
        }
        return false;
    }
    function badPos(pos, bad) {
        if (bad) pos.bad = true;
        return pos;
    }
    function domTextBetween(cm, from, to, fromLine, toLine) {
        var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
        function recognizeMarker(id) {
            return function(marker) {
                return marker.id == id;
            };
        }
        function close() {
            if (closing) {
                text += lineSep;
                if (extraLinebreak) text += lineSep;
                closing = extraLinebreak = false;
            }
        }
        function addText(str) {
            if (str) {
                close();
                text += str;
            }
        }
        function walk(node) {
            if (node.nodeType == 1) {
                var cmText = node.getAttribute("cm-text");
                if (cmText) {
                    addText(cmText);
                    return;
                }
                var markerID = node.getAttribute("cm-marker"), range;
                if (markerID) {
                    var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
                    if (found.length && (range = found[0].find(0))) addText(getBetween(cm.doc, range.from, range.to).join(lineSep));
                    return;
                }
                if (node.getAttribute("contenteditable") == "false") return;
                var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
                if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) return;
                if (isBlock) close();
                for(var i = 0; i < node.childNodes.length; i++)walk(node.childNodes[i]);
                if (/^(pre|p)$/i.test(node.nodeName)) extraLinebreak = true;
                if (isBlock) closing = true;
            } else if (node.nodeType == 3) addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
        }
        for(;;){
            walk(from);
            if (from == to) break;
            from = from.nextSibling;
            extraLinebreak = false;
        }
        return text;
    }
    function domToPos(cm, node, offset) {
        var lineNode;
        if (node == cm.display.lineDiv) {
            lineNode = cm.display.lineDiv.childNodes[offset];
            if (!lineNode) return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true);
            node = null;
            offset = 0;
        } else for(lineNode = node;; lineNode = lineNode.parentNode){
            if (!lineNode || lineNode == cm.display.lineDiv) return null;
            if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) break;
        }
        for(var i = 0; i < cm.display.view.length; i++){
            var lineView = cm.display.view[i];
            if (lineView.node == lineNode) return locateNodeInLineView(lineView, node, offset);
        }
    }
    function locateNodeInLineView(lineView, node, offset) {
        var wrapper = lineView.text.firstChild, bad = false;
        if (!node || !contains(wrapper, node)) return badPos(Pos(lineNo(lineView.line), 0), true);
        if (node == wrapper) {
            bad = true;
            node = wrapper.childNodes[offset];
            offset = 0;
            if (!node) {
                var line = lineView.rest ? lst(lineView.rest) : lineView.line;
                return badPos(Pos(lineNo(line), line.text.length), bad);
            }
        }
        var textNode = node.nodeType == 3 ? node : null, topNode = node;
        if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
            textNode = node.firstChild;
            if (offset) offset = textNode.nodeValue.length;
        }
        while(topNode.parentNode != wrapper)topNode = topNode.parentNode;
        var measure = lineView.measure, maps = measure.maps;
        function find(textNode, topNode, offset) {
            for(var i = -1; i < (maps ? maps.length : 0); i++){
                var map = i < 0 ? measure.map : maps[i];
                for(var j = 0; j < map.length; j += 3){
                    var curNode = map[j + 2];
                    if (curNode == textNode || curNode == topNode) {
                        var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
                        var ch = map[j] + offset;
                        if (offset < 0 || curNode != textNode) ch = map[j + (offset ? 1 : 0)];
                        return Pos(line, ch);
                    }
                }
            }
        }
        var found = find(textNode, topNode, offset);
        if (found) return badPos(found, bad);
        // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
        for(var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling){
            found = find(after, after.firstChild, 0);
            if (found) return badPos(Pos(found.line, found.ch - dist), bad);
            else dist += after.textContent.length;
        }
        for(var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling){
            found = find(before, before.firstChild, -1);
            if (found) return badPos(Pos(found.line, found.ch + dist$1), bad);
            else dist$1 += before.textContent.length;
        }
    }
    // TEXTAREA INPUT STYLE
    var TextareaInput = function(cm) {
        this.cm = cm;
        // See input.poll and input.reset
        this.prevInput = "";
        // Flag that indicates whether we expect input to appear real soon
        // now (after some event like 'keypress' or 'input') and are
        // polling intensively.
        this.pollingFast = false;
        // Self-resetting timeout for the poller
        this.polling = new Delayed();
        // Used to work around IE issue with selection being forgotten when focus moves away from textarea
        this.hasSelection = false;
        this.composing = null;
        this.resetting = false;
    };
    TextareaInput.prototype.init = function(display) {
        var this$1 = this;
        var input = this, cm = this.cm;
        this.createField(display);
        var te = this.textarea;
        display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);
        // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
        if (ios) te.style.width = "0px";
        on(te, "input", function() {
            if (ie && ie_version >= 9 && this$1.hasSelection) this$1.hasSelection = null;
            input.poll();
        });
        on(te, "paste", function(e) {
            if (signalDOMEvent(cm, e) || handlePaste(e, cm)) return;
            cm.state.pasteIncoming = +new Date;
            input.fastPoll();
        });
        function prepareCopyCut(e) {
            if (signalDOMEvent(cm, e)) return;
            if (cm.somethingSelected()) setLastCopied({
                lineWise: false,
                text: cm.getSelections()
            });
            else if (!cm.options.lineWiseCopyCut) return;
            else {
                var ranges = copyableRanges(cm);
                setLastCopied({
                    lineWise: true,
                    text: ranges.text
                });
                if (e.type == "cut") cm.setSelections(ranges.ranges, null, sel_dontScroll);
                else {
                    input.prevInput = "";
                    te.value = ranges.text.join("\n");
                    selectInput(te);
                }
            }
            if (e.type == "cut") cm.state.cutIncoming = +new Date;
        }
        on(te, "cut", prepareCopyCut);
        on(te, "copy", prepareCopyCut);
        on(display.scroller, "paste", function(e) {
            if (eventInWidget(display, e) || signalDOMEvent(cm, e)) return;
            if (!te.dispatchEvent) {
                cm.state.pasteIncoming = +new Date;
                input.focus();
                return;
            }
            // Pass the `paste` event to the textarea so it's handled by its event listener.
            var event = new Event("paste");
            event.clipboardData = e.clipboardData;
            te.dispatchEvent(event);
        });
        // Prevent normal selection in the editor (we handle our own)
        on(display.lineSpace, "selectstart", function(e) {
            if (!eventInWidget(display, e)) e_preventDefault(e);
        });
        on(te, "compositionstart", function() {
            var start = cm.getCursor("from");
            if (input.composing) input.composing.range.clear();
            input.composing = {
                start: start,
                range: cm.markText(start, cm.getCursor("to"), {
                    className: "CodeMirror-composing"
                })
            };
        });
        on(te, "compositionend", function() {
            if (input.composing) {
                input.poll();
                input.composing.range.clear();
                input.composing = null;
            }
        });
    };
    TextareaInput.prototype.createField = function(_display) {
        // Wraps and hides input textarea
        this.wrapper = hiddenTextarea();
        // The semihidden textarea that is focused when the editor is
        // focused, and receives input.
        this.textarea = this.wrapper.firstChild;
        var opts = this.cm.options;
        disableBrowserMagic(this.textarea, opts.spellcheck, opts.autocorrect, opts.autocapitalize);
    };
    TextareaInput.prototype.screenReaderLabelChanged = function(label) {
        // Label for screenreaders, accessibility
        if (label) this.textarea.setAttribute('aria-label', label);
        else this.textarea.removeAttribute('aria-label');
    };
    TextareaInput.prototype.prepareSelection = function() {
        // Redraw the selection and/or cursor
        var cm = this.cm, display = cm.display, doc = cm.doc;
        var result = prepareSelection(cm);
        // Move the hidden textarea near the cursor to prevent scrolling artifacts
        if (cm.options.moveInputWithCursor) {
            var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
            var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
            result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10, headPos.top + lineOff.top - wrapOff.top));
            result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10, headPos.left + lineOff.left - wrapOff.left));
        }
        return result;
    };
    TextareaInput.prototype.showSelection = function(drawn) {
        var cm = this.cm, display = cm.display;
        removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
        removeChildrenAndAdd(display.selectionDiv, drawn.selection);
        if (drawn.teTop != null) {
            this.wrapper.style.top = drawn.teTop + "px";
            this.wrapper.style.left = drawn.teLeft + "px";
        }
    };
    // Reset the input to correspond to the selection (or to be empty,
    // when not typing and nothing is selected)
    TextareaInput.prototype.reset = function(typing) {
        if (this.contextMenuPending || this.composing && typing) return;
        var cm = this.cm;
        this.resetting = true;
        if (cm.somethingSelected()) {
            this.prevInput = "";
            var content = cm.getSelection();
            this.textarea.value = content;
            if (cm.state.focused) selectInput(this.textarea);
            if (ie && ie_version >= 9) this.hasSelection = content;
        } else if (!typing) {
            this.prevInput = this.textarea.value = "";
            if (ie && ie_version >= 9) this.hasSelection = null;
        }
        this.resetting = false;
    };
    TextareaInput.prototype.getField = function() {
        return this.textarea;
    };
    TextareaInput.prototype.supportsTouch = function() {
        return false;
    };
    TextareaInput.prototype.focus = function() {
        if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt(rootNode(this.textarea)) != this.textarea)) try {
            this.textarea.focus();
        } catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
    };
    TextareaInput.prototype.blur = function() {
        this.textarea.blur();
    };
    TextareaInput.prototype.resetPosition = function() {
        this.wrapper.style.top = this.wrapper.style.left = 0;
    };
    TextareaInput.prototype.receivedFocus = function() {
        this.slowPoll();
    };
    // Poll for input changes, using the normal rate of polling. This
    // runs as long as the editor is focused.
    TextareaInput.prototype.slowPoll = function() {
        var this$1 = this;
        if (this.pollingFast) return;
        this.polling.set(this.cm.options.pollInterval, function() {
            this$1.poll();
            if (this$1.cm.state.focused) this$1.slowPoll();
        });
    };
    // When an event has just come in that is likely to add or change
    // something in the input textarea, we poll faster, to ensure that
    // the change appears on the screen quickly.
    TextareaInput.prototype.fastPoll = function() {
        var missed = false, input = this;
        input.pollingFast = true;
        function p() {
            var changed = input.poll();
            if (!changed && !missed) {
                missed = true;
                input.polling.set(60, p);
            } else {
                input.pollingFast = false;
                input.slowPoll();
            }
        }
        input.polling.set(20, p);
    };
    // Read input from the textarea, and update the document to match.
    // When something is selected, it is present in the textarea, and
    // selected (unless it is huge, in which case a placeholder is
    // used). When nothing is selected, the cursor sits after previously
    // seen text (can be empty), which is stored in prevInput (we must
    // not reset the textarea when typing, because that breaks IME).
    TextareaInput.prototype.poll = function() {
        var this$1 = this;
        var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
        // Since this is called a *lot*, try to bail out as cheaply as
        // possible when it is clear that nothing happened. hasSelection
        // will be the case when there is a lot of text in the textarea,
        // in which case reading its value would be expensive.
        if (this.contextMenuPending || this.resetting || !cm.state.focused || hasSelection(input) && !prevInput && !this.composing || cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq) return false;
        var text = input.value;
        // If nothing changed, bail.
        if (text == prevInput && !cm.somethingSelected()) return false;
        // Work around nonsensical selection resetting in IE9/10, and
        // inexplicable appearance of private area unicode characters on
        // some key combos in Mac (#2689).
        if (ie && ie_version >= 9 && this.hasSelection === text || mac && /[\uf700-\uf7ff]/.test(text)) {
            cm.display.input.reset();
            return false;
        }
        if (cm.doc.sel == cm.display.selForContextMenu) {
            var first = text.charCodeAt(0);
            if (first == 0x200b && !prevInput) prevInput = "\u200b";
            if (first == 0x21da) {
                this.reset();
                return this.cm.execCommand("undo");
            }
        }
        // Find the part of the input that is actually new
        var same = 0, l = Math.min(prevInput.length, text.length);
        while(same < l && prevInput.charCodeAt(same) == text.charCodeAt(same))++same;
        runInOp(cm, function() {
            applyTextInput(cm, text.slice(same), prevInput.length - same, null, this$1.composing ? "*compose" : null);
            // Don't leave long text in the textarea, since it makes further polling slow
            if (text.length > 1000 || text.indexOf("\n") > -1) input.value = this$1.prevInput = "";
            else this$1.prevInput = text;
            if (this$1.composing) {
                this$1.composing.range.clear();
                this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"), {
                    className: "CodeMirror-composing"
                });
            }
        });
        return true;
    };
    TextareaInput.prototype.ensurePolled = function() {
        if (this.pollingFast && this.poll()) this.pollingFast = false;
    };
    TextareaInput.prototype.onKeyPress = function() {
        if (ie && ie_version >= 9) this.hasSelection = null;
        this.fastPoll();
    };
    TextareaInput.prototype.onContextMenu = function(e) {
        var input = this, cm = input.cm, display = cm.display, te = input.textarea;
        if (input.contextMenuPending) input.contextMenuPending();
        var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
        if (!pos || presto) return;
         // Opera is difficult.
        // Reset the current text selection only if the click is done outside of the selection
        // and 'resetSelectionOnContextMenu' option is true.
        var reset = cm.options.resetSelectionOnContextMenu;
        if (reset && cm.doc.sel.contains(pos) == -1) operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll);
        var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
        var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
        input.wrapper.style.cssText = "position: static";
        te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
        var oldScrollY;
        if (webkit) oldScrollY = te.ownerDocument.defaultView.scrollY;
         // Work around Chrome issue (#2712)
        display.input.focus();
        if (webkit) te.ownerDocument.defaultView.scrollTo(null, oldScrollY);
        display.input.reset();
        // Adds "Select all" to context menu in FF
        if (!cm.somethingSelected()) te.value = input.prevInput = " ";
        input.contextMenuPending = rehide;
        display.selForContextMenu = cm.doc.sel;
        clearTimeout(display.detectingSelectAll);
        // Select-all will be greyed out if there's nothing to select, so
        // this adds a zero-width space so that we can later check whether
        // it got selected.
        function prepareSelectAllHack() {
            if (te.selectionStart != null) {
                var selected = cm.somethingSelected();
                var extval = "\u200b" + (selected ? te.value : "");
                te.value = "\u21da"; // Used to catch context-menu undo
                te.value = extval;
                input.prevInput = selected ? "" : "\u200b";
                te.selectionStart = 1;
                te.selectionEnd = extval.length;
                // Re-set this, in case some other handler touched the
                // selection in the meantime.
                display.selForContextMenu = cm.doc.sel;
            }
        }
        function rehide() {
            if (input.contextMenuPending != rehide) return;
            input.contextMenuPending = false;
            input.wrapper.style.cssText = oldWrapperCSS;
            te.style.cssText = oldCSS;
            if (ie && ie_version < 9) display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos);
            // Try to detect the user choosing select-all
            if (te.selectionStart != null) {
                if (!ie || ie && ie_version < 9) prepareSelectAllHack();
                var i = 0, poll = function() {
                    if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 && te.selectionEnd > 0 && input.prevInput == "\u200b") operation(cm, selectAll)(cm);
                    else if (i++ < 10) display.detectingSelectAll = setTimeout(poll, 500);
                    else {
                        display.selForContextMenu = null;
                        display.input.reset();
                    }
                };
                display.detectingSelectAll = setTimeout(poll, 200);
            }
        }
        if (ie && ie_version >= 9) prepareSelectAllHack();
        if (captureRightClick) {
            e_stop(e);
            var mouseup = function() {
                off(window, "mouseup", mouseup);
                setTimeout(rehide, 20);
            };
            on(window, "mouseup", mouseup);
        } else setTimeout(rehide, 50);
    };
    TextareaInput.prototype.readOnlyChanged = function(val) {
        if (!val) this.reset();
        this.textarea.disabled = val == "nocursor";
        this.textarea.readOnly = !!val;
    };
    TextareaInput.prototype.setUneditable = function() {};
    TextareaInput.prototype.needsContentAttribute = false;
    function fromTextArea(textarea, options) {
        options = options ? copyObj(options) : {};
        options.value = textarea.value;
        if (!options.tabindex && textarea.tabIndex) options.tabindex = textarea.tabIndex;
        if (!options.placeholder && textarea.placeholder) options.placeholder = textarea.placeholder;
        // Set autofocus to true if this textarea is focused, or if it has
        // autofocus and no other element is focused.
        if (options.autofocus == null) {
            var hasFocus = activeElt(rootNode(textarea));
            options.autofocus = hasFocus == textarea || textarea.getAttribute("autofocus") != null && hasFocus == document.body;
        }
        function save() {
            textarea.value = cm.getValue();
        }
        var realSubmit;
        if (textarea.form) {
            on(textarea.form, "submit", save);
            // Deplorable hack to make the submit method do the right thing.
            if (!options.leaveSubmitMethodAlone) {
                var form = textarea.form;
                realSubmit = form.submit;
                try {
                    var wrappedSubmit = form.submit = function() {
                        save();
                        form.submit = realSubmit;
                        form.submit();
                        form.submit = wrappedSubmit;
                    };
                } catch (e) {}
            }
        }
        options.finishInit = function(cm) {
            cm.save = save;
            cm.getTextArea = function() {
                return textarea;
            };
            cm.toTextArea = function() {
                cm.toTextArea = isNaN; // Prevent this from being ran twice
                save();
                textarea.parentNode.removeChild(cm.getWrapperElement());
                textarea.style.display = "";
                if (textarea.form) {
                    off(textarea.form, "submit", save);
                    if (!options.leaveSubmitMethodAlone && typeof textarea.form.submit == "function") textarea.form.submit = realSubmit;
                }
            };
        };
        textarea.style.display = "none";
        var cm = CodeMirror(function(node) {
            return textarea.parentNode.insertBefore(node, textarea.nextSibling);
        }, options);
        return cm;
    }
    function addLegacyProps(CodeMirror) {
        CodeMirror.off = off;
        CodeMirror.on = on;
        CodeMirror.wheelEventPixels = wheelEventPixels;
        CodeMirror.Doc = Doc;
        CodeMirror.splitLines = splitLinesAuto;
        CodeMirror.countColumn = countColumn;
        CodeMirror.findColumn = findColumn;
        CodeMirror.isWordChar = isWordCharBasic;
        CodeMirror.Pass = Pass;
        CodeMirror.signal = signal;
        CodeMirror.Line = Line;
        CodeMirror.changeEnd = changeEnd;
        CodeMirror.scrollbarModel = scrollbarModel;
        CodeMirror.Pos = Pos;
        CodeMirror.cmpPos = cmp;
        CodeMirror.modes = modes;
        CodeMirror.mimeModes = mimeModes;
        CodeMirror.resolveMode = resolveMode;
        CodeMirror.getMode = getMode;
        CodeMirror.modeExtensions = modeExtensions;
        CodeMirror.extendMode = extendMode;
        CodeMirror.copyState = copyState;
        CodeMirror.startState = startState;
        CodeMirror.innerMode = innerMode;
        CodeMirror.commands = commands;
        CodeMirror.keyMap = keyMap;
        CodeMirror.keyName = keyName;
        CodeMirror.isModifierKey = isModifierKey;
        CodeMirror.lookupKey = lookupKey;
        CodeMirror.normalizeKeyMap = normalizeKeyMap;
        CodeMirror.StringStream = StringStream;
        CodeMirror.SharedTextMarker = SharedTextMarker;
        CodeMirror.TextMarker = TextMarker;
        CodeMirror.LineWidget = LineWidget;
        CodeMirror.e_preventDefault = e_preventDefault;
        CodeMirror.e_stopPropagation = e_stopPropagation;
        CodeMirror.e_stop = e_stop;
        CodeMirror.addClass = addClass;
        CodeMirror.contains = contains;
        CodeMirror.rmClass = rmClass;
        CodeMirror.keyNames = keyNames;
    }
    // EDITOR CONSTRUCTOR
    defineOptions(CodeMirror);
    addEditorMethods(CodeMirror);
    // Set up methods on CodeMirror's prototype to redirect to the editor's document.
    var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
    for(var prop in Doc.prototype)if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0) CodeMirror.prototype[prop] = function(method) {
        return function() {
            return method.apply(this.doc, arguments);
        };
    }(Doc.prototype[prop]);
    eventMixin(Doc);
    CodeMirror.inputStyles = {
        "textarea": TextareaInput,
        "contenteditable": ContentEditableInput
    };
    // Extra arguments are stored as the mode's dependencies, which is
    // used by (legacy) mechanisms like loadmode.js to automatically
    // load a mode. (Preferred mechanism is the require/define calls.)
    CodeMirror.defineMode = function(name /*, mode, …*/ ) {
        if (!CodeMirror.defaults.mode && name != "null") CodeMirror.defaults.mode = name;
        defineMode.apply(this, arguments);
    };
    CodeMirror.defineMIME = defineMIME;
    // Minimal default mode.
    CodeMirror.defineMode("null", function() {
        return {
            token: function(stream) {
                return stream.skipToEnd();
            }
        };
    });
    CodeMirror.defineMIME("text/plain", "null");
    // EXTENSIONS
    CodeMirror.defineExtension = function(name, func) {
        CodeMirror.prototype[name] = func;
    };
    CodeMirror.defineDocExtension = function(name, func) {
        Doc.prototype[name] = func;
    };
    CodeMirror.fromTextArea = fromTextArea;
    addLegacyProps(CodeMirror);
    CodeMirror.version = "5.65.18";
    return CodeMirror;
});

});

parcelRegister("i8uuI", function(module, exports) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/5/LICENSE
(function(mod) {
    mod((parcelRequire("irZNt")));
})(function(CodeMirror) {
    "use strict";
    var htmlConfig = {
        autoSelfClosers: {
            'area': true,
            'base': true,
            'br': true,
            'col': true,
            'command': true,
            'embed': true,
            'frame': true,
            'hr': true,
            'img': true,
            'input': true,
            'keygen': true,
            'link': true,
            'meta': true,
            'param': true,
            'source': true,
            'track': true,
            'wbr': true,
            'menuitem': true
        },
        implicitlyClosed: {
            'dd': true,
            'li': true,
            'optgroup': true,
            'option': true,
            'p': true,
            'rp': true,
            'rt': true,
            'tbody': true,
            'td': true,
            'tfoot': true,
            'th': true,
            'tr': true
        },
        contextGrabbers: {
            'dd': {
                'dd': true,
                'dt': true
            },
            'dt': {
                'dd': true,
                'dt': true
            },
            'li': {
                'li': true
            },
            'option': {
                'option': true,
                'optgroup': true
            },
            'optgroup': {
                'optgroup': true
            },
            'p': {
                'address': true,
                'article': true,
                'aside': true,
                'blockquote': true,
                'dir': true,
                'div': true,
                'dl': true,
                'fieldset': true,
                'footer': true,
                'form': true,
                'h1': true,
                'h2': true,
                'h3': true,
                'h4': true,
                'h5': true,
                'h6': true,
                'header': true,
                'hgroup': true,
                'hr': true,
                'menu': true,
                'nav': true,
                'ol': true,
                'p': true,
                'pre': true,
                'section': true,
                'table': true,
                'ul': true
            },
            'rp': {
                'rp': true,
                'rt': true
            },
            'rt': {
                'rp': true,
                'rt': true
            },
            'tbody': {
                'tbody': true,
                'tfoot': true
            },
            'td': {
                'td': true,
                'th': true
            },
            'tfoot': {
                'tbody': true
            },
            'th': {
                'td': true,
                'th': true
            },
            'thead': {
                'tbody': true,
                'tfoot': true
            },
            'tr': {
                'tr': true
            }
        },
        doNotIndent: {
            "pre": true
        },
        allowUnquoted: true,
        allowMissing: true,
        caseFold: true
    };
    var xmlConfig = {
        autoSelfClosers: {},
        implicitlyClosed: {},
        contextGrabbers: {},
        doNotIndent: {},
        allowUnquoted: false,
        allowMissing: false,
        allowMissingTagName: false,
        caseFold: false
    };
    CodeMirror.defineMode("xml", function(editorConf, config_) {
        var indentUnit = editorConf.indentUnit;
        var config = {};
        var defaults = config_.htmlMode ? htmlConfig : xmlConfig;
        for(var prop in defaults)config[prop] = defaults[prop];
        for(var prop in config_)config[prop] = config_[prop];
        // Return variables for tokenizers
        var type, setStyle;
        function inText(stream, state) {
            function chain(parser) {
                state.tokenize = parser;
                return parser(stream, state);
            }
            var ch = stream.next();
            if (ch == "<") {
                if (stream.eat("!")) {
                    if (stream.eat("[")) {
                        if (stream.match("CDATA[")) return chain(inBlock("atom", "]]>"));
                        else return null;
                    } else if (stream.match("--")) return chain(inBlock("comment", "-->"));
                    else if (stream.match("DOCTYPE", true, true)) {
                        stream.eatWhile(/[\w\._\-]/);
                        return chain(doctype(1));
                    } else return null;
                } else if (stream.eat("?")) {
                    stream.eatWhile(/[\w\._\-]/);
                    state.tokenize = inBlock("meta", "?>");
                    return "meta";
                } else {
                    type = stream.eat("/") ? "closeTag" : "openTag";
                    state.tokenize = inTag;
                    return "tag bracket";
                }
            } else if (ch == "&") {
                var ok;
                if (stream.eat("#")) {
                    if (stream.eat("x")) ok = stream.eatWhile(/[a-fA-F\d]/) && stream.eat(";");
                    else ok = stream.eatWhile(/[\d]/) && stream.eat(";");
                } else ok = stream.eatWhile(/[\w\.\-:]/) && stream.eat(";");
                return ok ? "atom" : "error";
            } else {
                stream.eatWhile(/[^&<]/);
                return null;
            }
        }
        inText.isInText = true;
        function inTag(stream, state) {
            var ch = stream.next();
            if (ch == ">" || ch == "/" && stream.eat(">")) {
                state.tokenize = inText;
                type = ch == ">" ? "endTag" : "selfcloseTag";
                return "tag bracket";
            } else if (ch == "=") {
                type = "equals";
                return null;
            } else if (ch == "<") {
                state.tokenize = inText;
                state.state = baseState;
                state.tagName = state.tagStart = null;
                var next = state.tokenize(stream, state);
                return next ? next + " tag error" : "tag error";
            } else if (/[\'\"]/.test(ch)) {
                state.tokenize = inAttribute(ch);
                state.stringStartCol = stream.column();
                return state.tokenize(stream, state);
            } else {
                stream.match(/^[^\s\u00a0=<>\"\']*[^\s\u00a0=<>\"\'\/]/);
                return "word";
            }
        }
        function inAttribute(quote) {
            var closure = function(stream, state) {
                while(!stream.eol())if (stream.next() == quote) {
                    state.tokenize = inTag;
                    break;
                }
                return "string";
            };
            closure.isInAttribute = true;
            return closure;
        }
        function inBlock(style, terminator) {
            return function(stream, state) {
                while(!stream.eol()){
                    if (stream.match(terminator)) {
                        state.tokenize = inText;
                        break;
                    }
                    stream.next();
                }
                return style;
            };
        }
        function doctype(depth) {
            return function(stream, state) {
                var ch;
                while((ch = stream.next()) != null){
                    if (ch == "<") {
                        state.tokenize = doctype(depth + 1);
                        return state.tokenize(stream, state);
                    } else if (ch == ">") {
                        if (depth == 1) {
                            state.tokenize = inText;
                            break;
                        } else {
                            state.tokenize = doctype(depth - 1);
                            return state.tokenize(stream, state);
                        }
                    }
                }
                return "meta";
            };
        }
        function lower(tagName) {
            return tagName && tagName.toLowerCase();
        }
        function Context(state, tagName, startOfLine) {
            this.prev = state.context;
            this.tagName = tagName || "";
            this.indent = state.indented;
            this.startOfLine = startOfLine;
            if (config.doNotIndent.hasOwnProperty(tagName) || state.context && state.context.noIndent) this.noIndent = true;
        }
        function popContext(state) {
            if (state.context) state.context = state.context.prev;
        }
        function maybePopContext(state, nextTagName) {
            var parentTagName;
            while(true){
                if (!state.context) return;
                parentTagName = state.context.tagName;
                if (!config.contextGrabbers.hasOwnProperty(lower(parentTagName)) || !config.contextGrabbers[lower(parentTagName)].hasOwnProperty(lower(nextTagName))) return;
                popContext(state);
            }
        }
        function baseState(type, stream, state) {
            if (type == "openTag") {
                state.tagStart = stream.column();
                return tagNameState;
            } else if (type == "closeTag") return closeTagNameState;
            else return baseState;
        }
        function tagNameState(type, stream, state) {
            if (type == "word") {
                state.tagName = stream.current();
                setStyle = "tag";
                return attrState;
            } else if (config.allowMissingTagName && type == "endTag") {
                setStyle = "tag bracket";
                return attrState(type, stream, state);
            } else {
                setStyle = "error";
                return tagNameState;
            }
        }
        function closeTagNameState(type, stream, state) {
            if (type == "word") {
                var tagName = stream.current();
                if (state.context && state.context.tagName != tagName && config.implicitlyClosed.hasOwnProperty(lower(state.context.tagName))) popContext(state);
                if (state.context && state.context.tagName == tagName || config.matchClosing === false) {
                    setStyle = "tag";
                    return closeState;
                } else {
                    setStyle = "tag error";
                    return closeStateErr;
                }
            } else if (config.allowMissingTagName && type == "endTag") {
                setStyle = "tag bracket";
                return closeState(type, stream, state);
            } else {
                setStyle = "error";
                return closeStateErr;
            }
        }
        function closeState(type, _stream, state) {
            if (type != "endTag") {
                setStyle = "error";
                return closeState;
            }
            popContext(state);
            return baseState;
        }
        function closeStateErr(type, stream, state) {
            setStyle = "error";
            return closeState(type, stream, state);
        }
        function attrState(type, _stream, state) {
            if (type == "word") {
                setStyle = "attribute";
                return attrEqState;
            } else if (type == "endTag" || type == "selfcloseTag") {
                var tagName = state.tagName, tagStart = state.tagStart;
                state.tagName = state.tagStart = null;
                if (type == "selfcloseTag" || config.autoSelfClosers.hasOwnProperty(lower(tagName))) maybePopContext(state, tagName);
                else {
                    maybePopContext(state, tagName);
                    state.context = new Context(state, tagName, tagStart == state.indented);
                }
                return baseState;
            }
            setStyle = "error";
            return attrState;
        }
        function attrEqState(type, stream, state) {
            if (type == "equals") return attrValueState;
            if (!config.allowMissing) setStyle = "error";
            return attrState(type, stream, state);
        }
        function attrValueState(type, stream, state) {
            if (type == "string") return attrContinuedState;
            if (type == "word" && config.allowUnquoted) {
                setStyle = "string";
                return attrState;
            }
            setStyle = "error";
            return attrState(type, stream, state);
        }
        function attrContinuedState(type, stream, state) {
            if (type == "string") return attrContinuedState;
            return attrState(type, stream, state);
        }
        return {
            startState: function(baseIndent) {
                var state = {
                    tokenize: inText,
                    state: baseState,
                    indented: baseIndent || 0,
                    tagName: null,
                    tagStart: null,
                    context: null
                };
                if (baseIndent != null) state.baseIndent = baseIndent;
                return state;
            },
            token: function(stream, state) {
                if (!state.tagName && stream.sol()) state.indented = stream.indentation();
                if (stream.eatSpace()) return null;
                type = null;
                var style = state.tokenize(stream, state);
                if ((style || type) && style != "comment") {
                    setStyle = null;
                    state.state = state.state(type || style, stream, state);
                    if (setStyle) style = setStyle == "error" ? style + " error" : setStyle;
                }
                return style;
            },
            indent: function(state, textAfter, fullLine) {
                var context = state.context;
                // Indent multi-line strings (e.g. css).
                if (state.tokenize.isInAttribute) {
                    if (state.tagStart == state.indented) return state.stringStartCol + 1;
                    else return state.indented + indentUnit;
                }
                if (context && context.noIndent) return CodeMirror.Pass;
                if (state.tokenize != inTag && state.tokenize != inText) return fullLine ? fullLine.match(/^(\s*)/)[0].length : 0;
                // Indent the starts of attribute names.
                if (state.tagName) {
                    if (config.multilineTagIndentPastTag !== false) return state.tagStart + state.tagName.length + 2;
                    else return state.tagStart + indentUnit * (config.multilineTagIndentFactor || 1);
                }
                if (config.alignCDATA && /<!\[CDATA\[/.test(textAfter)) return 0;
                var tagAfter = textAfter && /^<(\/)?([\w_:\.-]*)/.exec(textAfter);
                if (tagAfter && tagAfter[1]) while(context){
                    if (context.tagName == tagAfter[2]) {
                        context = context.prev;
                        break;
                    } else if (config.implicitlyClosed.hasOwnProperty(lower(context.tagName))) context = context.prev;
                    else break;
                }
                else if (tagAfter) while(context){
                    var grabbers = config.contextGrabbers[lower(context.tagName)];
                    if (grabbers && grabbers.hasOwnProperty(lower(tagAfter[2]))) context = context.prev;
                    else break;
                }
                while(context && context.prev && !context.startOfLine)context = context.prev;
                if (context) return context.indent + indentUnit;
                else return state.baseIndent || 0;
            },
            electricInput: /<\/[\s\w:]+>$/,
            blockCommentStart: "<!--",
            blockCommentEnd: "-->",
            configuration: config.htmlMode ? "html" : "xml",
            helperType: config.htmlMode ? "html" : "xml",
            skipAttribute: function(state) {
                if (state.state == attrValueState) state.state = attrState;
            },
            xmlCurrentTag: function(state) {
                return state.tagName ? {
                    name: state.tagName,
                    close: state.type == "closeTag"
                } : null;
            },
            xmlCurrentContext: function(state) {
                var context = [];
                for(var cx = state.context; cx; cx = cx.prev)context.push(cx.tagName);
                return context.reverse();
            }
        };
    });
    CodeMirror.defineMIME("text/xml", "xml");
    CodeMirror.defineMIME("application/xml", "xml");
    if (!CodeMirror.mimeModes.hasOwnProperty("text/html")) CodeMirror.defineMIME("text/html", {
        name: "xml",
        htmlMode: true
    });
});

});

parcelRegister("76M02", function(module, exports) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/5/LICENSE
(function(mod) {
    mod((parcelRequire("irZNt")));
})(function(CodeMirror) {
    "use strict";
    CodeMirror.defineMode("javascript", function(config, parserConfig) {
        var indentUnit = config.indentUnit;
        var statementIndent = parserConfig.statementIndent;
        var jsonldMode = parserConfig.jsonld;
        var jsonMode = parserConfig.json || jsonldMode;
        var trackScope = parserConfig.trackScope !== false;
        var isTS = parserConfig.typescript;
        var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;
        // Tokenizer
        var keywords = function() {
            function kw(type) {
                return {
                    type: type,
                    style: "keyword"
                };
            }
            var A = kw("keyword a"), B = kw("keyword b"), C = kw("keyword c"), D = kw("keyword d");
            var operator = kw("operator"), atom = {
                type: "atom",
                style: "atom"
            };
            return {
                "if": kw("if"),
                "while": A,
                "with": A,
                "else": B,
                "do": B,
                "try": B,
                "finally": B,
                "return": D,
                "break": D,
                "continue": D,
                "new": kw("new"),
                "delete": C,
                "void": C,
                "throw": C,
                "debugger": kw("debugger"),
                "var": kw("var"),
                "const": kw("var"),
                "let": kw("var"),
                "function": kw("function"),
                "catch": kw("catch"),
                "for": kw("for"),
                "switch": kw("switch"),
                "case": kw("case"),
                "default": kw("default"),
                "in": operator,
                "typeof": operator,
                "instanceof": operator,
                "true": atom,
                "false": atom,
                "null": atom,
                "undefined": atom,
                "NaN": atom,
                "Infinity": atom,
                "this": kw("this"),
                "class": kw("class"),
                "super": kw("atom"),
                "yield": C,
                "export": kw("export"),
                "import": kw("import"),
                "extends": C,
                "await": C
            };
        }();
        var isOperatorChar = /[+\-*&%=<>!?|~^@]/;
        var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
        function readRegexp(stream) {
            var escaped = false, next, inSet = false;
            while((next = stream.next()) != null){
                if (!escaped) {
                    if (next == "/" && !inSet) return;
                    if (next == "[") inSet = true;
                    else if (inSet && next == "]") inSet = false;
                }
                escaped = !escaped && next == "\\";
            }
        }
        // Used as scratch variables to communicate multiple values without
        // consing up tons of objects.
        var type, content;
        function ret(tp, style, cont) {
            type = tp;
            content = cont;
            return style;
        }
        function tokenBase(stream, state) {
            var ch = stream.next();
            if (ch == '"' || ch == "'") {
                state.tokenize = tokenString(ch);
                return state.tokenize(stream, state);
            } else if (ch == "." && stream.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/)) return ret("number", "number");
            else if (ch == "." && stream.match("..")) return ret("spread", "meta");
            else if (/[\[\]{}\(\),;\:\.]/.test(ch)) return ret(ch);
            else if (ch == "=" && stream.eat(">")) return ret("=>", "operator");
            else if (ch == "0" && stream.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) return ret("number", "number");
            else if (/\d/.test(ch)) {
                stream.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/);
                return ret("number", "number");
            } else if (ch == "/") {
                if (stream.eat("*")) {
                    state.tokenize = tokenComment;
                    return tokenComment(stream, state);
                } else if (stream.eat("/")) {
                    stream.skipToEnd();
                    return ret("comment", "comment");
                } else if (expressionAllowed(stream, state, 1)) {
                    readRegexp(stream);
                    stream.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/);
                    return ret("regexp", "string-2");
                } else {
                    stream.eat("=");
                    return ret("operator", "operator", stream.current());
                }
            } else if (ch == "`") {
                state.tokenize = tokenQuasi;
                return tokenQuasi(stream, state);
            } else if (ch == "#" && stream.peek() == "!") {
                stream.skipToEnd();
                return ret("meta", "meta");
            } else if (ch == "#" && stream.eatWhile(wordRE)) return ret("variable", "property");
            else if (ch == "<" && stream.match("!--") || ch == "-" && stream.match("->") && !/\S/.test(stream.string.slice(0, stream.start))) {
                stream.skipToEnd();
                return ret("comment", "comment");
            } else if (isOperatorChar.test(ch)) {
                if (ch != ">" || !state.lexical || state.lexical.type != ">") {
                    if (stream.eat("=")) {
                        if (ch == "!" || ch == "=") stream.eat("=");
                    } else if (/[<>*+\-|&?]/.test(ch)) {
                        stream.eat(ch);
                        if (ch == ">") stream.eat(ch);
                    }
                }
                if (ch == "?" && stream.eat(".")) return ret(".");
                return ret("operator", "operator", stream.current());
            } else if (wordRE.test(ch)) {
                stream.eatWhile(wordRE);
                var word = stream.current();
                if (state.lastType != ".") {
                    if (keywords.propertyIsEnumerable(word)) {
                        var kw = keywords[word];
                        return ret(kw.type, kw.style, word);
                    }
                    if (word == "async" && stream.match(/^(\s|\/\*([^*]|\*(?!\/))*?\*\/)*[\[\(\w]/, false)) return ret("async", "keyword", word);
                }
                return ret("variable", "variable", word);
            }
        }
        function tokenString(quote) {
            return function(stream, state) {
                var escaped = false, next;
                if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)) {
                    state.tokenize = tokenBase;
                    return ret("jsonld-keyword", "meta");
                }
                while((next = stream.next()) != null){
                    if (next == quote && !escaped) break;
                    escaped = !escaped && next == "\\";
                }
                if (!escaped) state.tokenize = tokenBase;
                return ret("string", "string");
            };
        }
        function tokenComment(stream, state) {
            var maybeEnd = false, ch;
            while(ch = stream.next()){
                if (ch == "/" && maybeEnd) {
                    state.tokenize = tokenBase;
                    break;
                }
                maybeEnd = ch == "*";
            }
            return ret("comment", "comment");
        }
        function tokenQuasi(stream, state) {
            var escaped = false, next;
            while((next = stream.next()) != null){
                if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
                    state.tokenize = tokenBase;
                    break;
                }
                escaped = !escaped && next == "\\";
            }
            return ret("quasi", "string-2", stream.current());
        }
        var brackets = "([{}])";
        // This is a crude lookahead trick to try and notice that we're
        // parsing the argument patterns for a fat-arrow function before we
        // actually hit the arrow token. It only works if the arrow is on
        // the same line as the arguments and there's no strange noise
        // (comments) in between. Fallback is to only notice when we hit the
        // arrow, and not declare the arguments as locals for the arrow
        // body.
        function findFatArrow(stream, state) {
            if (state.fatArrowAt) state.fatArrowAt = null;
            var arrow = stream.string.indexOf("=>", stream.start);
            if (arrow < 0) return;
            if (isTS) {
                var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow));
                if (m) arrow = m.index;
            }
            var depth = 0, sawSomething = false;
            for(var pos = arrow - 1; pos >= 0; --pos){
                var ch = stream.string.charAt(pos);
                var bracket = brackets.indexOf(ch);
                if (bracket >= 0 && bracket < 3) {
                    if (!depth) {
                        ++pos;
                        break;
                    }
                    if (--depth == 0) {
                        if (ch == "(") sawSomething = true;
                        break;
                    }
                } else if (bracket >= 3 && bracket < 6) ++depth;
                else if (wordRE.test(ch)) sawSomething = true;
                else if (/["'\/`]/.test(ch)) for(;; --pos){
                    if (pos == 0) return;
                    var next = stream.string.charAt(pos - 1);
                    if (next == ch && stream.string.charAt(pos - 2) != "\\") {
                        pos--;
                        break;
                    }
                }
                else if (sawSomething && !depth) {
                    ++pos;
                    break;
                }
            }
            if (sawSomething && !depth) state.fatArrowAt = pos;
        }
        // Parser
        var atomicTypes = {
            "atom": true,
            "number": true,
            "variable": true,
            "string": true,
            "regexp": true,
            "this": true,
            "import": true,
            "jsonld-keyword": true
        };
        function JSLexical(indented, column, type, align, prev, info) {
            this.indented = indented;
            this.column = column;
            this.type = type;
            this.prev = prev;
            this.info = info;
            if (align != null) this.align = align;
        }
        function inScope(state, varname) {
            if (!trackScope) return false;
            for(var v = state.localVars; v; v = v.next)if (v.name == varname) return true;
            for(var cx = state.context; cx; cx = cx.prev){
                for(var v = cx.vars; v; v = v.next)if (v.name == varname) return true;
            }
        }
        function parseJS(state, style, type, content, stream) {
            var cc = state.cc;
            // Communicate our context to the combinators.
            // (Less wasteful than consing up a hundred closures on every call.)
            cx.state = state;
            cx.stream = stream;
            cx.marked = null, cx.cc = cc;
            cx.style = style;
            if (!state.lexical.hasOwnProperty("align")) state.lexical.align = true;
            while(true){
                var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
                if (combinator(type, content)) {
                    while(cc.length && cc[cc.length - 1].lex)cc.pop()();
                    if (cx.marked) return cx.marked;
                    if (type == "variable" && inScope(state, content)) return "variable-2";
                    return style;
                }
            }
        }
        // Combinator utils
        var cx = {
            state: null,
            column: null,
            marked: null,
            cc: null
        };
        function pass() {
            for(var i = arguments.length - 1; i >= 0; i--)cx.cc.push(arguments[i]);
        }
        function cont() {
            pass.apply(null, arguments);
            return true;
        }
        function inList(name, list) {
            for(var v = list; v; v = v.next)if (v.name == name) return true;
            return false;
        }
        function register(varname) {
            var state = cx.state;
            cx.marked = "def";
            if (!trackScope) return;
            if (state.context) {
                if (state.lexical.info == "var" && state.context && state.context.block) {
                    // FIXME function decls are also not block scoped
                    var newContext = registerVarScoped(varname, state.context);
                    if (newContext != null) {
                        state.context = newContext;
                        return;
                    }
                } else if (!inList(varname, state.localVars)) {
                    state.localVars = new Var(varname, state.localVars);
                    return;
                }
            }
            // Fall through means this is global
            if (parserConfig.globalVars && !inList(varname, state.globalVars)) state.globalVars = new Var(varname, state.globalVars);
        }
        function registerVarScoped(varname, context) {
            if (!context) return null;
            else if (context.block) {
                var inner = registerVarScoped(varname, context.prev);
                if (!inner) return null;
                if (inner == context.prev) return context;
                return new Context(inner, context.vars, true);
            } else if (inList(varname, context.vars)) return context;
            else return new Context(context.prev, new Var(varname, context.vars), false);
        }
        function isModifier(name) {
            return name == "public" || name == "private" || name == "protected" || name == "abstract" || name == "readonly";
        }
        // Combinators
        function Context(prev, vars, block) {
            this.prev = prev;
            this.vars = vars;
            this.block = block;
        }
        function Var(name, next) {
            this.name = name;
            this.next = next;
        }
        var defaultVars = new Var("this", new Var("arguments", null));
        function pushcontext() {
            cx.state.context = new Context(cx.state.context, cx.state.localVars, false);
            cx.state.localVars = defaultVars;
        }
        function pushblockcontext() {
            cx.state.context = new Context(cx.state.context, cx.state.localVars, true);
            cx.state.localVars = null;
        }
        pushcontext.lex = pushblockcontext.lex = true;
        function popcontext() {
            cx.state.localVars = cx.state.context.vars;
            cx.state.context = cx.state.context.prev;
        }
        popcontext.lex = true;
        function pushlex(type, info) {
            var result = function() {
                var state = cx.state, indent = state.indented;
                if (state.lexical.type == "stat") indent = state.lexical.indented;
                else for(var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev)indent = outer.indented;
                state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
            };
            result.lex = true;
            return result;
        }
        function poplex() {
            var state = cx.state;
            if (state.lexical.prev) {
                if (state.lexical.type == ")") state.indented = state.lexical.indented;
                state.lexical = state.lexical.prev;
            }
        }
        poplex.lex = true;
        function expect(wanted) {
            function exp(type) {
                if (type == wanted) return cont();
                else if (wanted == ";" || type == "}" || type == ")" || type == "]") return pass();
                else return cont(exp);
            }
            return exp;
        }
        function statement(type, value) {
            if (type == "var") return cont(pushlex("vardef", value), vardef, expect(";"), poplex);
            if (type == "keyword a") return cont(pushlex("form"), parenExpr, statement, poplex);
            if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
            if (type == "keyword d") return cx.stream.match(/^\s*$/, false) ? cont() : cont(pushlex("stat"), maybeexpression, expect(";"), poplex);
            if (type == "debugger") return cont(expect(";"));
            if (type == "{") return cont(pushlex("}"), pushblockcontext, block, poplex, popcontext);
            if (type == ";") return cont();
            if (type == "if") {
                if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex) cx.state.cc.pop()();
                return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
            }
            if (type == "function") return cont(functiondef);
            if (type == "for") return cont(pushlex("form"), pushblockcontext, forspec, statement, popcontext, poplex);
            if (type == "class" || isTS && value == "interface") {
                cx.marked = "keyword";
                return cont(pushlex("form", type == "class" ? type : value), className, poplex);
            }
            if (type == "variable") {
                if (isTS && value == "declare") {
                    cx.marked = "keyword";
                    return cont(statement);
                } else if (isTS && (value == "module" || value == "enum" || value == "type") && cx.stream.match(/^\s*\w/, false)) {
                    cx.marked = "keyword";
                    if (value == "enum") return cont(enumdef);
                    else if (value == "type") return cont(typename, expect("operator"), typeexpr, expect(";"));
                    else return cont(pushlex("form"), pattern, expect("{"), pushlex("}"), block, poplex, poplex);
                } else if (isTS && value == "namespace") {
                    cx.marked = "keyword";
                    return cont(pushlex("form"), expression, statement, poplex);
                } else if (isTS && value == "abstract") {
                    cx.marked = "keyword";
                    return cont(statement);
                } else return cont(pushlex("stat"), maybelabel);
            }
            if (type == "switch") return cont(pushlex("form"), parenExpr, expect("{"), pushlex("}", "switch"), pushblockcontext, block, poplex, poplex, popcontext);
            if (type == "case") return cont(expression, expect(":"));
            if (type == "default") return cont(expect(":"));
            if (type == "catch") return cont(pushlex("form"), pushcontext, maybeCatchBinding, statement, poplex, popcontext);
            if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
            if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
            if (type == "async") return cont(statement);
            if (value == "@") return cont(expression, statement);
            return pass(pushlex("stat"), expression, expect(";"), poplex);
        }
        function maybeCatchBinding(type) {
            if (type == "(") return cont(funarg, expect(")"));
        }
        function expression(type, value) {
            return expressionInner(type, value, false);
        }
        function expressionNoComma(type, value) {
            return expressionInner(type, value, true);
        }
        function parenExpr(type) {
            if (type != "(") return pass();
            return cont(pushlex(")"), maybeexpression, expect(")"), poplex);
        }
        function expressionInner(type, value, noComma) {
            if (cx.state.fatArrowAt == cx.stream.start) {
                var body = noComma ? arrowBodyNoComma : arrowBody;
                if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, expect("=>"), body, popcontext);
                else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
            }
            var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
            if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
            if (type == "function") return cont(functiondef, maybeop);
            if (type == "class" || isTS && value == "interface") {
                cx.marked = "keyword";
                return cont(pushlex("form"), classExpression, poplex);
            }
            if (type == "keyword c" || type == "async") return cont(noComma ? expressionNoComma : expression);
            if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
            if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
            if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
            if (type == "{") return contCommasep(objprop, "}", null, maybeop);
            if (type == "quasi") return pass(quasi, maybeop);
            if (type == "new") return cont(maybeTarget(noComma));
            return cont();
        }
        function maybeexpression(type) {
            if (type.match(/[;\}\)\],]/)) return pass();
            return pass(expression);
        }
        function maybeoperatorComma(type, value) {
            if (type == ",") return cont(maybeexpression);
            return maybeoperatorNoComma(type, value, false);
        }
        function maybeoperatorNoComma(type, value, noComma) {
            var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
            var expr = noComma == false ? expression : expressionNoComma;
            if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
            if (type == "operator") {
                if (/\+\+|--/.test(value) || isTS && value == "!") return cont(me);
                if (isTS && value == "<" && cx.stream.match(/^([^<>]|<[^<>]*>)*>\s*\(/, false)) return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, me);
                if (value == "?") return cont(expression, expect(":"), expr);
                return cont(expr);
            }
            if (type == "quasi") return pass(quasi, me);
            if (type == ";") return;
            if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
            if (type == ".") return cont(property, me);
            if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
            if (isTS && value == "as") {
                cx.marked = "keyword";
                return cont(typeexpr, me);
            }
            if (type == "regexp") {
                cx.state.lastType = cx.marked = "operator";
                cx.stream.backUp(cx.stream.pos - cx.stream.start - 1);
                return cont(expr);
            }
        }
        function quasi(type, value) {
            if (type != "quasi") return pass();
            if (value.slice(value.length - 2) != "${") return cont(quasi);
            return cont(maybeexpression, continueQuasi);
        }
        function continueQuasi(type) {
            if (type == "}") {
                cx.marked = "string-2";
                cx.state.tokenize = tokenQuasi;
                return cont(quasi);
            }
        }
        function arrowBody(type) {
            findFatArrow(cx.stream, cx.state);
            return pass(type == "{" ? statement : expression);
        }
        function arrowBodyNoComma(type) {
            findFatArrow(cx.stream, cx.state);
            return pass(type == "{" ? statement : expressionNoComma);
        }
        function maybeTarget(noComma) {
            return function(type) {
                if (type == ".") return cont(noComma ? targetNoComma : target);
                else if (type == "variable" && isTS) return cont(maybeTypeArgs, noComma ? maybeoperatorNoComma : maybeoperatorComma);
                else return pass(noComma ? expressionNoComma : expression);
            };
        }
        function target(_, value) {
            if (value == "target") {
                cx.marked = "keyword";
                return cont(maybeoperatorComma);
            }
        }
        function targetNoComma(_, value) {
            if (value == "target") {
                cx.marked = "keyword";
                return cont(maybeoperatorNoComma);
            }
        }
        function maybelabel(type) {
            if (type == ":") return cont(poplex, statement);
            return pass(maybeoperatorComma, expect(";"), poplex);
        }
        function property(type) {
            if (type == "variable") {
                cx.marked = "property";
                return cont();
            }
        }
        function objprop(type, value) {
            if (type == "async") {
                cx.marked = "property";
                return cont(objprop);
            } else if (type == "variable" || cx.style == "keyword") {
                cx.marked = "property";
                if (value == "get" || value == "set") return cont(getterSetter);
                var m // Work around fat-arrow-detection complication for detecting typescript typed arrow params
                ;
                if (isTS && cx.state.fatArrowAt == cx.stream.start && (m = cx.stream.match(/^\s*:\s*/, false))) cx.state.fatArrowAt = cx.stream.pos + m[0].length;
                return cont(afterprop);
            } else if (type == "number" || type == "string") {
                cx.marked = jsonldMode ? "property" : cx.style + " property";
                return cont(afterprop);
            } else if (type == "jsonld-keyword") return cont(afterprop);
            else if (isTS && isModifier(value)) {
                cx.marked = "keyword";
                return cont(objprop);
            } else if (type == "[") return cont(expression, maybetype, expect("]"), afterprop);
            else if (type == "spread") return cont(expressionNoComma, afterprop);
            else if (value == "*") {
                cx.marked = "keyword";
                return cont(objprop);
            } else if (type == ":") return pass(afterprop);
        }
        function getterSetter(type) {
            if (type != "variable") return pass(afterprop);
            cx.marked = "property";
            return cont(functiondef);
        }
        function afterprop(type) {
            if (type == ":") return cont(expressionNoComma);
            if (type == "(") return pass(functiondef);
        }
        function commasep(what, end, sep) {
            function proceed(type, value) {
                if (sep ? sep.indexOf(type) > -1 : type == ",") {
                    var lex = cx.state.lexical;
                    if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
                    return cont(function(type, value) {
                        if (type == end || value == end) return pass();
                        return pass(what);
                    }, proceed);
                }
                if (type == end || value == end) return cont();
                if (sep && sep.indexOf(";") > -1) return pass(what);
                return cont(expect(end));
            }
            return function(type, value) {
                if (type == end || value == end) return cont();
                return pass(what, proceed);
            };
        }
        function contCommasep(what, end, info) {
            for(var i = 3; i < arguments.length; i++)cx.cc.push(arguments[i]);
            return cont(pushlex(end, info), commasep(what, end), poplex);
        }
        function block(type) {
            if (type == "}") return cont();
            return pass(statement, block);
        }
        function maybetype(type, value) {
            if (isTS) {
                if (type == ":") return cont(typeexpr);
                if (value == "?") return cont(maybetype);
            }
        }
        function maybetypeOrIn(type, value) {
            if (isTS && (type == ":" || value == "in")) return cont(typeexpr);
        }
        function mayberettype(type) {
            if (isTS && type == ":") {
                if (cx.stream.match(/^\s*\w+\s+is\b/, false)) return cont(expression, isKW, typeexpr);
                else return cont(typeexpr);
            }
        }
        function isKW(_, value) {
            if (value == "is") {
                cx.marked = "keyword";
                return cont();
            }
        }
        function typeexpr(type, value) {
            if (value == "keyof" || value == "typeof" || value == "infer" || value == "readonly") {
                cx.marked = "keyword";
                return cont(value == "typeof" ? expressionNoComma : typeexpr);
            }
            if (type == "variable" || value == "void") {
                cx.marked = "type";
                return cont(afterType);
            }
            if (value == "|" || value == "&") return cont(typeexpr);
            if (type == "string" || type == "number" || type == "atom") return cont(afterType);
            if (type == "[") return cont(pushlex("]"), commasep(typeexpr, "]", ","), poplex, afterType);
            if (type == "{") return cont(pushlex("}"), typeprops, poplex, afterType);
            if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType, afterType);
            if (type == "<") return cont(commasep(typeexpr, ">"), typeexpr);
            if (type == "quasi") return pass(quasiType, afterType);
        }
        function maybeReturnType(type) {
            if (type == "=>") return cont(typeexpr);
        }
        function typeprops(type) {
            if (type.match(/[\}\)\]]/)) return cont();
            if (type == "," || type == ";") return cont(typeprops);
            return pass(typeprop, typeprops);
        }
        function typeprop(type, value) {
            if (type == "variable" || cx.style == "keyword") {
                cx.marked = "property";
                return cont(typeprop);
            } else if (value == "?" || type == "number" || type == "string") return cont(typeprop);
            else if (type == ":") return cont(typeexpr);
            else if (type == "[") return cont(expect("variable"), maybetypeOrIn, expect("]"), typeprop);
            else if (type == "(") return pass(functiondecl, typeprop);
            else if (!type.match(/[;\}\)\],]/)) return cont();
        }
        function quasiType(type, value) {
            if (type != "quasi") return pass();
            if (value.slice(value.length - 2) != "${") return cont(quasiType);
            return cont(typeexpr, continueQuasiType);
        }
        function continueQuasiType(type) {
            if (type == "}") {
                cx.marked = "string-2";
                cx.state.tokenize = tokenQuasi;
                return cont(quasiType);
            }
        }
        function typearg(type, value) {
            if (type == "variable" && cx.stream.match(/^\s*[?:]/, false) || value == "?") return cont(typearg);
            if (type == ":") return cont(typeexpr);
            if (type == "spread") return cont(typearg);
            return pass(typeexpr);
        }
        function afterType(type, value) {
            if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType);
            if (value == "|" || type == "." || value == "&") return cont(typeexpr);
            if (type == "[") return cont(typeexpr, expect("]"), afterType);
            if (value == "extends" || value == "implements") {
                cx.marked = "keyword";
                return cont(typeexpr);
            }
            if (value == "?") return cont(typeexpr, expect(":"), typeexpr);
        }
        function maybeTypeArgs(_, value) {
            if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType);
        }
        function typeparam() {
            return pass(typeexpr, maybeTypeDefault);
        }
        function maybeTypeDefault(_, value) {
            if (value == "=") return cont(typeexpr);
        }
        function vardef(_, value) {
            if (value == "enum") {
                cx.marked = "keyword";
                return cont(enumdef);
            }
            return pass(pattern, maybetype, maybeAssign, vardefCont);
        }
        function pattern(type, value) {
            if (isTS && isModifier(value)) {
                cx.marked = "keyword";
                return cont(pattern);
            }
            if (type == "variable") {
                register(value);
                return cont();
            }
            if (type == "spread") return cont(pattern);
            if (type == "[") return contCommasep(eltpattern, "]");
            if (type == "{") return contCommasep(proppattern, "}");
        }
        function proppattern(type, value) {
            if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
                register(value);
                return cont(maybeAssign);
            }
            if (type == "variable") cx.marked = "property";
            if (type == "spread") return cont(pattern);
            if (type == "}") return pass();
            if (type == "[") return cont(expression, expect(']'), expect(':'), proppattern);
            return cont(expect(":"), pattern, maybeAssign);
        }
        function eltpattern() {
            return pass(pattern, maybeAssign);
        }
        function maybeAssign(_type, value) {
            if (value == "=") return cont(expressionNoComma);
        }
        function vardefCont(type) {
            if (type == ",") return cont(vardef);
        }
        function maybeelse(type, value) {
            if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
        }
        function forspec(type, value) {
            if (value == "await") return cont(forspec);
            if (type == "(") return cont(pushlex(")"), forspec1, poplex);
        }
        function forspec1(type) {
            if (type == "var") return cont(vardef, forspec2);
            if (type == "variable") return cont(forspec2);
            return pass(forspec2);
        }
        function forspec2(type, value) {
            if (type == ")") return cont();
            if (type == ";") return cont(forspec2);
            if (value == "in" || value == "of") {
                cx.marked = "keyword";
                return cont(expression, forspec2);
            }
            return pass(expression, forspec2);
        }
        function functiondef(type, value) {
            if (value == "*") {
                cx.marked = "keyword";
                return cont(functiondef);
            }
            if (type == "variable") {
                register(value);
                return cont(functiondef);
            }
            if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, statement, popcontext);
            if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondef);
        }
        function functiondecl(type, value) {
            if (value == "*") {
                cx.marked = "keyword";
                return cont(functiondecl);
            }
            if (type == "variable") {
                register(value);
                return cont(functiondecl);
            }
            if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, popcontext);
            if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondecl);
        }
        function typename(type, value) {
            if (type == "keyword" || type == "variable") {
                cx.marked = "type";
                return cont(typename);
            } else if (value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex);
        }
        function funarg(type, value) {
            if (value == "@") cont(expression, funarg);
            if (type == "spread") return cont(funarg);
            if (isTS && isModifier(value)) {
                cx.marked = "keyword";
                return cont(funarg);
            }
            if (isTS && type == "this") return cont(maybetype, maybeAssign);
            return pass(pattern, maybetype, maybeAssign);
        }
        function classExpression(type, value) {
            // Class expressions may have an optional name.
            if (type == "variable") return className(type, value);
            return classNameAfter(type, value);
        }
        function className(type, value) {
            if (type == "variable") {
                register(value);
                return cont(classNameAfter);
            }
        }
        function classNameAfter(type, value) {
            if (value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, classNameAfter);
            if (value == "extends" || value == "implements" || isTS && type == ",") {
                if (value == "implements") cx.marked = "keyword";
                return cont(isTS ? typeexpr : expression, classNameAfter);
            }
            if (type == "{") return cont(pushlex("}"), classBody, poplex);
        }
        function classBody(type, value) {
            if (type == "async" || type == "variable" && (value == "static" || value == "get" || value == "set" || isTS && isModifier(value)) && cx.stream.match(/^\s+#?[\w$\xa1-\uffff]/, false)) {
                cx.marked = "keyword";
                return cont(classBody);
            }
            if (type == "variable" || cx.style == "keyword") {
                cx.marked = "property";
                return cont(classfield, classBody);
            }
            if (type == "number" || type == "string") return cont(classfield, classBody);
            if (type == "[") return cont(expression, maybetype, expect("]"), classfield, classBody);
            if (value == "*") {
                cx.marked = "keyword";
                return cont(classBody);
            }
            if (isTS && type == "(") return pass(functiondecl, classBody);
            if (type == ";" || type == ",") return cont(classBody);
            if (type == "}") return cont();
            if (value == "@") return cont(expression, classBody);
        }
        function classfield(type, value) {
            if (value == "!") return cont(classfield);
            if (value == "?") return cont(classfield);
            if (type == ":") return cont(typeexpr, maybeAssign);
            if (value == "=") return cont(expressionNoComma);
            var context = cx.state.lexical.prev, isInterface = context && context.info == "interface";
            return pass(isInterface ? functiondecl : functiondef);
        }
        function afterExport(type, value) {
            if (value == "*") {
                cx.marked = "keyword";
                return cont(maybeFrom, expect(";"));
            }
            if (value == "default") {
                cx.marked = "keyword";
                return cont(expression, expect(";"));
            }
            if (type == "{") return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
            return pass(statement);
        }
        function exportField(type, value) {
            if (value == "as") {
                cx.marked = "keyword";
                return cont(expect("variable"));
            }
            if (type == "variable") return pass(expressionNoComma, exportField);
        }
        function afterImport(type) {
            if (type == "string") return cont();
            if (type == "(") return pass(expression);
            if (type == ".") return pass(maybeoperatorComma);
            return pass(importSpec, maybeMoreImports, maybeFrom);
        }
        function importSpec(type, value) {
            if (type == "{") return contCommasep(importSpec, "}");
            if (type == "variable") register(value);
            if (value == "*") cx.marked = "keyword";
            return cont(maybeAs);
        }
        function maybeMoreImports(type) {
            if (type == ",") return cont(importSpec, maybeMoreImports);
        }
        function maybeAs(_type, value) {
            if (value == "as") {
                cx.marked = "keyword";
                return cont(importSpec);
            }
        }
        function maybeFrom(_type, value) {
            if (value == "from") {
                cx.marked = "keyword";
                return cont(expression);
            }
        }
        function arrayLiteral(type) {
            if (type == "]") return cont();
            return pass(commasep(expressionNoComma, "]"));
        }
        function enumdef() {
            return pass(pushlex("form"), pattern, expect("{"), pushlex("}"), commasep(enummember, "}"), poplex, poplex);
        }
        function enummember() {
            return pass(pattern, maybeAssign);
        }
        function isContinuedStatement(state, textAfter) {
            return state.lastType == "operator" || state.lastType == "," || isOperatorChar.test(textAfter.charAt(0)) || /[,.]/.test(textAfter.charAt(0));
        }
        function expressionAllowed(stream, state, backUp) {
            return state.tokenize == tokenBase && /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(state.lastType) || state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0)));
        }
        // Interface
        return {
            startState: function(basecolumn) {
                var state = {
                    tokenize: tokenBase,
                    lastType: "sof",
                    cc: [],
                    lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
                    localVars: parserConfig.localVars,
                    context: parserConfig.localVars && new Context(null, null, false),
                    indented: basecolumn || 0
                };
                if (parserConfig.globalVars && typeof parserConfig.globalVars == "object") state.globalVars = parserConfig.globalVars;
                return state;
            },
            token: function(stream, state) {
                if (stream.sol()) {
                    if (!state.lexical.hasOwnProperty("align")) state.lexical.align = false;
                    state.indented = stream.indentation();
                    findFatArrow(stream, state);
                }
                if (state.tokenize != tokenComment && stream.eatSpace()) return null;
                var style = state.tokenize(stream, state);
                if (type == "comment") return style;
                state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
                return parseJS(state, style, type, content, stream);
            },
            indent: function(state, textAfter) {
                if (state.tokenize == tokenComment || state.tokenize == tokenQuasi) return CodeMirror.Pass;
                if (state.tokenize != tokenBase) return 0;
                var firstChar = textAfter && textAfter.charAt(0), lexical = state.lexical, top;
                // Kludge to prevent 'maybelse' from blocking lexical scope pops
                if (!/^\s*else\b/.test(textAfter)) for(var i = state.cc.length - 1; i >= 0; --i){
                    var c = state.cc[i];
                    if (c == poplex) lexical = lexical.prev;
                    else if (c != maybeelse && c != popcontext) break;
                }
                while((lexical.type == "stat" || lexical.type == "form") && (firstChar == "}" || (top = state.cc[state.cc.length - 1]) && (top == maybeoperatorComma || top == maybeoperatorNoComma) && !/^[,\.=+\-*:?[\(]/.test(textAfter)))lexical = lexical.prev;
                if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat") lexical = lexical.prev;
                var type = lexical.type, closing = firstChar == type;
                if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info.length + 1 : 0);
                else if (type == "form" && firstChar == "{") return lexical.indented;
                else if (type == "form") return lexical.indented + indentUnit;
                else if (type == "stat") return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);
                else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false) return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);
                else if (lexical.align) return lexical.column + (closing ? 0 : 1);
                else return lexical.indented + (closing ? 0 : indentUnit);
            },
            electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
            blockCommentStart: jsonMode ? null : "/*",
            blockCommentEnd: jsonMode ? null : "*/",
            blockCommentContinue: jsonMode ? null : " * ",
            lineComment: jsonMode ? null : "//",
            fold: "brace",
            closeBrackets: "()[]{}''\"\"``",
            helperType: jsonMode ? "json" : "javascript",
            jsonldMode: jsonldMode,
            jsonMode: jsonMode,
            expressionAllowed: expressionAllowed,
            skipExpression: function(state) {
                parseJS(state, "atom", "atom", "true", new CodeMirror.StringStream("", 2, null));
            }
        };
    });
    CodeMirror.registerHelper("wordChars", "javascript", /[\w$]/);
    CodeMirror.defineMIME("text/javascript", "javascript");
    CodeMirror.defineMIME("text/ecmascript", "javascript");
    CodeMirror.defineMIME("application/javascript", "javascript");
    CodeMirror.defineMIME("application/x-javascript", "javascript");
    CodeMirror.defineMIME("application/ecmascript", "javascript");
    CodeMirror.defineMIME("application/json", {
        name: "javascript",
        json: true
    });
    CodeMirror.defineMIME("application/x-json", {
        name: "javascript",
        json: true
    });
    CodeMirror.defineMIME("application/manifest+json", {
        name: "javascript",
        json: true
    });
    CodeMirror.defineMIME("application/ld+json", {
        name: "javascript",
        jsonld: true
    });
    CodeMirror.defineMIME("text/typescript", {
        name: "javascript",
        typescript: true
    });
    CodeMirror.defineMIME("application/typescript", {
        name: "javascript",
        typescript: true
    });
});

});

parcelRegister("1IBC2", function(module, exports) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/5/LICENSE
(function(mod) {
    mod((parcelRequire("irZNt")));
})(function(CodeMirror) {
    "use strict";
    CodeMirror.defineMode("css", function(config, parserConfig) {
        var inline = parserConfig.inline;
        if (!parserConfig.propertyKeywords) parserConfig = CodeMirror.resolveMode("text/css");
        var indentUnit = config.indentUnit, tokenHooks = parserConfig.tokenHooks, documentTypes = parserConfig.documentTypes || {}, mediaTypes = parserConfig.mediaTypes || {}, mediaFeatures = parserConfig.mediaFeatures || {}, mediaValueKeywords = parserConfig.mediaValueKeywords || {}, propertyKeywords = parserConfig.propertyKeywords || {}, nonStandardPropertyKeywords = parserConfig.nonStandardPropertyKeywords || {}, fontProperties = parserConfig.fontProperties || {}, counterDescriptors = parserConfig.counterDescriptors || {}, colorKeywords = parserConfig.colorKeywords || {}, valueKeywords = parserConfig.valueKeywords || {}, allowNested = parserConfig.allowNested, lineComment = parserConfig.lineComment, supportsAtComponent = parserConfig.supportsAtComponent === true, highlightNonStandardPropertyKeywords = config.highlightNonStandardPropertyKeywords !== false;
        var type, override;
        function ret(style, tp) {
            type = tp;
            return style;
        }
        // Tokenizers
        function tokenBase(stream, state) {
            var ch = stream.next();
            if (tokenHooks[ch]) {
                var result = tokenHooks[ch](stream, state);
                if (result !== false) return result;
            }
            if (ch == "@") {
                stream.eatWhile(/[\w\\\-]/);
                return ret("def", stream.current());
            } else if (ch == "=" || (ch == "~" || ch == "|") && stream.eat("=")) return ret(null, "compare");
            else if (ch == "\"" || ch == "'") {
                state.tokenize = tokenString(ch);
                return state.tokenize(stream, state);
            } else if (ch == "#") {
                stream.eatWhile(/[\w\\\-]/);
                return ret("atom", "hash");
            } else if (ch == "!") {
                stream.match(/^\s*\w*/);
                return ret("keyword", "important");
            } else if (/\d/.test(ch) || ch == "." && stream.eat(/\d/)) {
                stream.eatWhile(/[\w.%]/);
                return ret("number", "unit");
            } else if (ch === "-") {
                if (/[\d.]/.test(stream.peek())) {
                    stream.eatWhile(/[\w.%]/);
                    return ret("number", "unit");
                } else if (stream.match(/^-[\w\\\-]*/)) {
                    stream.eatWhile(/[\w\\\-]/);
                    if (stream.match(/^\s*:/, false)) return ret("variable-2", "variable-definition");
                    return ret("variable-2", "variable");
                } else if (stream.match(/^\w+-/)) return ret("meta", "meta");
            } else if (/[,+>*\/]/.test(ch)) return ret(null, "select-op");
            else if (ch == "." && stream.match(/^-?[_a-z][_a-z0-9-]*/i)) return ret("qualifier", "qualifier");
            else if (/[:;{}\[\]\(\)]/.test(ch)) return ret(null, ch);
            else if (stream.match(/^[\w-.]+(?=\()/)) {
                if (/^(url(-prefix)?|domain|regexp)$/i.test(stream.current())) state.tokenize = tokenParenthesized;
                return ret("variable callee", "variable");
            } else if (/[\w\\\-]/.test(ch)) {
                stream.eatWhile(/[\w\\\-]/);
                return ret("property", "word");
            } else return ret(null, null);
        }
        function tokenString(quote) {
            return function(stream, state) {
                var escaped = false, ch;
                while((ch = stream.next()) != null){
                    if (ch == quote && !escaped) {
                        if (quote == ")") stream.backUp(1);
                        break;
                    }
                    escaped = !escaped && ch == "\\";
                }
                if (ch == quote || !escaped && quote != ")") state.tokenize = null;
                return ret("string", "string");
            };
        }
        function tokenParenthesized(stream, state) {
            stream.next(); // Must be '('
            if (!stream.match(/^\s*[\"\')]/, false)) state.tokenize = tokenString(")");
            else state.tokenize = null;
            return ret(null, "(");
        }
        // Context management
        function Context(type, indent, prev) {
            this.type = type;
            this.indent = indent;
            this.prev = prev;
        }
        function pushContext(state, stream, type, indent) {
            state.context = new Context(type, stream.indentation() + (indent === false ? 0 : indentUnit), state.context);
            return type;
        }
        function popContext(state) {
            if (state.context.prev) state.context = state.context.prev;
            return state.context.type;
        }
        function pass(type, stream, state) {
            return states[state.context.type](type, stream, state);
        }
        function popAndPass(type, stream, state, n) {
            for(var i = n || 1; i > 0; i--)state.context = state.context.prev;
            return pass(type, stream, state);
        }
        // Parser
        function wordAsValue(stream) {
            var word = stream.current().toLowerCase();
            if (valueKeywords.hasOwnProperty(word)) override = "atom";
            else if (colorKeywords.hasOwnProperty(word)) override = "keyword";
            else override = "variable";
        }
        var states = {};
        states.top = function(type, stream, state) {
            if (type == "{") return pushContext(state, stream, "block");
            else if (type == "}" && state.context.prev) return popContext(state);
            else if (supportsAtComponent && /@component/i.test(type)) return pushContext(state, stream, "atComponentBlock");
            else if (/^@(-moz-)?document$/i.test(type)) return pushContext(state, stream, "documentTypes");
            else if (/^@(media|supports|(-moz-)?document|import)$/i.test(type)) return pushContext(state, stream, "atBlock");
            else if (/^@(font-face|counter-style)/i.test(type)) {
                state.stateArg = type;
                return "restricted_atBlock_before";
            } else if (/^@(-(moz|ms|o|webkit)-)?keyframes$/i.test(type)) return "keyframes";
            else if (type && type.charAt(0) == "@") return pushContext(state, stream, "at");
            else if (type == "hash") override = "builtin";
            else if (type == "word") override = "tag";
            else if (type == "variable-definition") return "maybeprop";
            else if (type == "interpolation") return pushContext(state, stream, "interpolation");
            else if (type == ":") return "pseudo";
            else if (allowNested && type == "(") return pushContext(state, stream, "parens");
            return state.context.type;
        };
        states.block = function(type, stream, state) {
            if (type == "word") {
                var word = stream.current().toLowerCase();
                if (propertyKeywords.hasOwnProperty(word)) {
                    override = "property";
                    return "maybeprop";
                } else if (nonStandardPropertyKeywords.hasOwnProperty(word)) {
                    override = highlightNonStandardPropertyKeywords ? "string-2" : "property";
                    return "maybeprop";
                } else if (allowNested) {
                    override = stream.match(/^\s*:(?:\s|$)/, false) ? "property" : "tag";
                    return "block";
                } else {
                    override += " error";
                    return "maybeprop";
                }
            } else if (type == "meta") return "block";
            else if (!allowNested && (type == "hash" || type == "qualifier")) {
                override = "error";
                return "block";
            } else return states.top(type, stream, state);
        };
        states.maybeprop = function(type, stream, state) {
            if (type == ":") return pushContext(state, stream, "prop");
            return pass(type, stream, state);
        };
        states.prop = function(type, stream, state) {
            if (type == ";") return popContext(state);
            if (type == "{" && allowNested) return pushContext(state, stream, "propBlock");
            if (type == "}" || type == "{") return popAndPass(type, stream, state);
            if (type == "(") return pushContext(state, stream, "parens");
            if (type == "hash" && !/^#([0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(stream.current())) override += " error";
            else if (type == "word") wordAsValue(stream);
            else if (type == "interpolation") return pushContext(state, stream, "interpolation");
            return "prop";
        };
        states.propBlock = function(type, _stream, state) {
            if (type == "}") return popContext(state);
            if (type == "word") {
                override = "property";
                return "maybeprop";
            }
            return state.context.type;
        };
        states.parens = function(type, stream, state) {
            if (type == "{" || type == "}") return popAndPass(type, stream, state);
            if (type == ")") return popContext(state);
            if (type == "(") return pushContext(state, stream, "parens");
            if (type == "interpolation") return pushContext(state, stream, "interpolation");
            if (type == "word") wordAsValue(stream);
            return "parens";
        };
        states.pseudo = function(type, stream, state) {
            if (type == "meta") return "pseudo";
            if (type == "word") {
                override = "variable-3";
                return state.context.type;
            }
            return pass(type, stream, state);
        };
        states.documentTypes = function(type, stream, state) {
            if (type == "word" && documentTypes.hasOwnProperty(stream.current())) {
                override = "tag";
                return state.context.type;
            } else return states.atBlock(type, stream, state);
        };
        states.atBlock = function(type, stream, state) {
            if (type == "(") return pushContext(state, stream, "atBlock_parens");
            if (type == "}" || type == ";") return popAndPass(type, stream, state);
            if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top");
            if (type == "interpolation") return pushContext(state, stream, "interpolation");
            if (type == "word") {
                var word = stream.current().toLowerCase();
                if (word == "only" || word == "not" || word == "and" || word == "or") override = "keyword";
                else if (mediaTypes.hasOwnProperty(word)) override = "attribute";
                else if (mediaFeatures.hasOwnProperty(word)) override = "property";
                else if (mediaValueKeywords.hasOwnProperty(word)) override = "keyword";
                else if (propertyKeywords.hasOwnProperty(word)) override = "property";
                else if (nonStandardPropertyKeywords.hasOwnProperty(word)) override = highlightNonStandardPropertyKeywords ? "string-2" : "property";
                else if (valueKeywords.hasOwnProperty(word)) override = "atom";
                else if (colorKeywords.hasOwnProperty(word)) override = "keyword";
                else override = "error";
            }
            return state.context.type;
        };
        states.atComponentBlock = function(type, stream, state) {
            if (type == "}") return popAndPass(type, stream, state);
            if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top", false);
            if (type == "word") override = "error";
            return state.context.type;
        };
        states.atBlock_parens = function(type, stream, state) {
            if (type == ")") return popContext(state);
            if (type == "{" || type == "}") return popAndPass(type, stream, state, 2);
            return states.atBlock(type, stream, state);
        };
        states.restricted_atBlock_before = function(type, stream, state) {
            if (type == "{") return pushContext(state, stream, "restricted_atBlock");
            if (type == "word" && state.stateArg == "@counter-style") {
                override = "variable";
                return "restricted_atBlock_before";
            }
            return pass(type, stream, state);
        };
        states.restricted_atBlock = function(type, stream, state) {
            if (type == "}") {
                state.stateArg = null;
                return popContext(state);
            }
            if (type == "word") {
                if (state.stateArg == "@font-face" && !fontProperties.hasOwnProperty(stream.current().toLowerCase()) || state.stateArg == "@counter-style" && !counterDescriptors.hasOwnProperty(stream.current().toLowerCase())) override = "error";
                else override = "property";
                return "maybeprop";
            }
            return "restricted_atBlock";
        };
        states.keyframes = function(type, stream, state) {
            if (type == "word") {
                override = "variable";
                return "keyframes";
            }
            if (type == "{") return pushContext(state, stream, "top");
            return pass(type, stream, state);
        };
        states.at = function(type, stream, state) {
            if (type == ";") return popContext(state);
            if (type == "{" || type == "}") return popAndPass(type, stream, state);
            if (type == "word") override = "tag";
            else if (type == "hash") override = "builtin";
            return "at";
        };
        states.interpolation = function(type, stream, state) {
            if (type == "}") return popContext(state);
            if (type == "{" || type == ";") return popAndPass(type, stream, state);
            if (type == "word") override = "variable";
            else if (type != "variable" && type != "(" && type != ")") override = "error";
            return "interpolation";
        };
        return {
            startState: function(base) {
                return {
                    tokenize: null,
                    state: inline ? "block" : "top",
                    stateArg: null,
                    context: new Context(inline ? "block" : "top", base || 0, null)
                };
            },
            token: function(stream, state) {
                if (!state.tokenize && stream.eatSpace()) return null;
                var style = (state.tokenize || tokenBase)(stream, state);
                if (style && typeof style == "object") {
                    type = style[1];
                    style = style[0];
                }
                override = style;
                if (type != "comment") state.state = states[state.state](type, stream, state);
                return override;
            },
            indent: function(state, textAfter) {
                var cx = state.context, ch = textAfter && textAfter.charAt(0);
                var indent = cx.indent;
                if (cx.type == "prop" && (ch == "}" || ch == ")")) cx = cx.prev;
                if (cx.prev) {
                    if (ch == "}" && (cx.type == "block" || cx.type == "top" || cx.type == "interpolation" || cx.type == "restricted_atBlock")) {
                        // Resume indentation from parent context.
                        cx = cx.prev;
                        indent = cx.indent;
                    } else if (ch == ")" && (cx.type == "parens" || cx.type == "atBlock_parens") || ch == "{" && (cx.type == "at" || cx.type == "atBlock")) // Dedent relative to current context.
                    indent = Math.max(0, cx.indent - indentUnit);
                }
                return indent;
            },
            electricChars: "}",
            blockCommentStart: "/*",
            blockCommentEnd: "*/",
            blockCommentContinue: " * ",
            lineComment: lineComment,
            fold: "brace"
        };
    });
    function keySet(array) {
        var keys = {};
        for(var i = 0; i < array.length; ++i)keys[array[i].toLowerCase()] = true;
        return keys;
    }
    var documentTypes_ = [
        "domain",
        "regexp",
        "url",
        "url-prefix"
    ], documentTypes = keySet(documentTypes_);
    var mediaTypes_ = [
        "all",
        "aural",
        "braille",
        "handheld",
        "print",
        "projection",
        "screen",
        "tty",
        "tv",
        "embossed"
    ], mediaTypes = keySet(mediaTypes_);
    var mediaFeatures_ = [
        "width",
        "min-width",
        "max-width",
        "height",
        "min-height",
        "max-height",
        "device-width",
        "min-device-width",
        "max-device-width",
        "device-height",
        "min-device-height",
        "max-device-height",
        "aspect-ratio",
        "min-aspect-ratio",
        "max-aspect-ratio",
        "device-aspect-ratio",
        "min-device-aspect-ratio",
        "max-device-aspect-ratio",
        "color",
        "min-color",
        "max-color",
        "color-index",
        "min-color-index",
        "max-color-index",
        "monochrome",
        "min-monochrome",
        "max-monochrome",
        "resolution",
        "min-resolution",
        "max-resolution",
        "scan",
        "grid",
        "orientation",
        "device-pixel-ratio",
        "min-device-pixel-ratio",
        "max-device-pixel-ratio",
        "pointer",
        "any-pointer",
        "hover",
        "any-hover",
        "prefers-color-scheme",
        "dynamic-range",
        "video-dynamic-range"
    ], mediaFeatures = keySet(mediaFeatures_);
    var mediaValueKeywords_ = [
        "landscape",
        "portrait",
        "none",
        "coarse",
        "fine",
        "on-demand",
        "hover",
        "interlace",
        "progressive",
        "dark",
        "light",
        "standard",
        "high"
    ], mediaValueKeywords = keySet(mediaValueKeywords_);
    var propertyKeywords_ = [
        "align-content",
        "align-items",
        "align-self",
        "alignment-adjust",
        "alignment-baseline",
        "all",
        "anchor-point",
        "animation",
        "animation-delay",
        "animation-direction",
        "animation-duration",
        "animation-fill-mode",
        "animation-iteration-count",
        "animation-name",
        "animation-play-state",
        "animation-timing-function",
        "appearance",
        "azimuth",
        "backdrop-filter",
        "backface-visibility",
        "background",
        "background-attachment",
        "background-blend-mode",
        "background-clip",
        "background-color",
        "background-image",
        "background-origin",
        "background-position",
        "background-position-x",
        "background-position-y",
        "background-repeat",
        "background-size",
        "baseline-shift",
        "binding",
        "bleed",
        "block-size",
        "bookmark-label",
        "bookmark-level",
        "bookmark-state",
        "bookmark-target",
        "border",
        "border-bottom",
        "border-bottom-color",
        "border-bottom-left-radius",
        "border-bottom-right-radius",
        "border-bottom-style",
        "border-bottom-width",
        "border-collapse",
        "border-color",
        "border-image",
        "border-image-outset",
        "border-image-repeat",
        "border-image-slice",
        "border-image-source",
        "border-image-width",
        "border-left",
        "border-left-color",
        "border-left-style",
        "border-left-width",
        "border-radius",
        "border-right",
        "border-right-color",
        "border-right-style",
        "border-right-width",
        "border-spacing",
        "border-style",
        "border-top",
        "border-top-color",
        "border-top-left-radius",
        "border-top-right-radius",
        "border-top-style",
        "border-top-width",
        "border-width",
        "bottom",
        "box-decoration-break",
        "box-shadow",
        "box-sizing",
        "break-after",
        "break-before",
        "break-inside",
        "caption-side",
        "caret-color",
        "clear",
        "clip",
        "color",
        "color-profile",
        "column-count",
        "column-fill",
        "column-gap",
        "column-rule",
        "column-rule-color",
        "column-rule-style",
        "column-rule-width",
        "column-span",
        "column-width",
        "columns",
        "contain",
        "content",
        "counter-increment",
        "counter-reset",
        "crop",
        "cue",
        "cue-after",
        "cue-before",
        "cursor",
        "direction",
        "display",
        "dominant-baseline",
        "drop-initial-after-adjust",
        "drop-initial-after-align",
        "drop-initial-before-adjust",
        "drop-initial-before-align",
        "drop-initial-size",
        "drop-initial-value",
        "elevation",
        "empty-cells",
        "fit",
        "fit-content",
        "fit-position",
        "flex",
        "flex-basis",
        "flex-direction",
        "flex-flow",
        "flex-grow",
        "flex-shrink",
        "flex-wrap",
        "float",
        "float-offset",
        "flow-from",
        "flow-into",
        "font",
        "font-family",
        "font-feature-settings",
        "font-kerning",
        "font-language-override",
        "font-optical-sizing",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-synthesis",
        "font-variant",
        "font-variant-alternates",
        "font-variant-caps",
        "font-variant-east-asian",
        "font-variant-ligatures",
        "font-variant-numeric",
        "font-variant-position",
        "font-variation-settings",
        "font-weight",
        "gap",
        "grid",
        "grid-area",
        "grid-auto-columns",
        "grid-auto-flow",
        "grid-auto-rows",
        "grid-column",
        "grid-column-end",
        "grid-column-gap",
        "grid-column-start",
        "grid-gap",
        "grid-row",
        "grid-row-end",
        "grid-row-gap",
        "grid-row-start",
        "grid-template",
        "grid-template-areas",
        "grid-template-columns",
        "grid-template-rows",
        "hanging-punctuation",
        "height",
        "hyphens",
        "icon",
        "image-orientation",
        "image-rendering",
        "image-resolution",
        "inline-box-align",
        "inset",
        "inset-block",
        "inset-block-end",
        "inset-block-start",
        "inset-inline",
        "inset-inline-end",
        "inset-inline-start",
        "isolation",
        "justify-content",
        "justify-items",
        "justify-self",
        "left",
        "letter-spacing",
        "line-break",
        "line-height",
        "line-height-step",
        "line-stacking",
        "line-stacking-ruby",
        "line-stacking-shift",
        "line-stacking-strategy",
        "list-style",
        "list-style-image",
        "list-style-position",
        "list-style-type",
        "margin",
        "margin-bottom",
        "margin-left",
        "margin-right",
        "margin-top",
        "marks",
        "marquee-direction",
        "marquee-loop",
        "marquee-play-count",
        "marquee-speed",
        "marquee-style",
        "mask-clip",
        "mask-composite",
        "mask-image",
        "mask-mode",
        "mask-origin",
        "mask-position",
        "mask-repeat",
        "mask-size",
        "mask-type",
        "max-block-size",
        "max-height",
        "max-inline-size",
        "max-width",
        "min-block-size",
        "min-height",
        "min-inline-size",
        "min-width",
        "mix-blend-mode",
        "move-to",
        "nav-down",
        "nav-index",
        "nav-left",
        "nav-right",
        "nav-up",
        "object-fit",
        "object-position",
        "offset",
        "offset-anchor",
        "offset-distance",
        "offset-path",
        "offset-position",
        "offset-rotate",
        "opacity",
        "order",
        "orphans",
        "outline",
        "outline-color",
        "outline-offset",
        "outline-style",
        "outline-width",
        "overflow",
        "overflow-style",
        "overflow-wrap",
        "overflow-x",
        "overflow-y",
        "padding",
        "padding-bottom",
        "padding-left",
        "padding-right",
        "padding-top",
        "page",
        "page-break-after",
        "page-break-before",
        "page-break-inside",
        "page-policy",
        "pause",
        "pause-after",
        "pause-before",
        "perspective",
        "perspective-origin",
        "pitch",
        "pitch-range",
        "place-content",
        "place-items",
        "place-self",
        "play-during",
        "position",
        "presentation-level",
        "punctuation-trim",
        "quotes",
        "region-break-after",
        "region-break-before",
        "region-break-inside",
        "region-fragment",
        "rendering-intent",
        "resize",
        "rest",
        "rest-after",
        "rest-before",
        "richness",
        "right",
        "rotate",
        "rotation",
        "rotation-point",
        "row-gap",
        "ruby-align",
        "ruby-overhang",
        "ruby-position",
        "ruby-span",
        "scale",
        "scroll-behavior",
        "scroll-margin",
        "scroll-margin-block",
        "scroll-margin-block-end",
        "scroll-margin-block-start",
        "scroll-margin-bottom",
        "scroll-margin-inline",
        "scroll-margin-inline-end",
        "scroll-margin-inline-start",
        "scroll-margin-left",
        "scroll-margin-right",
        "scroll-margin-top",
        "scroll-padding",
        "scroll-padding-block",
        "scroll-padding-block-end",
        "scroll-padding-block-start",
        "scroll-padding-bottom",
        "scroll-padding-inline",
        "scroll-padding-inline-end",
        "scroll-padding-inline-start",
        "scroll-padding-left",
        "scroll-padding-right",
        "scroll-padding-top",
        "scroll-snap-align",
        "scroll-snap-type",
        "shape-image-threshold",
        "shape-inside",
        "shape-margin",
        "shape-outside",
        "size",
        "speak",
        "speak-as",
        "speak-header",
        "speak-numeral",
        "speak-punctuation",
        "speech-rate",
        "stress",
        "string-set",
        "tab-size",
        "table-layout",
        "target",
        "target-name",
        "target-new",
        "target-position",
        "text-align",
        "text-align-last",
        "text-combine-upright",
        "text-decoration",
        "text-decoration-color",
        "text-decoration-line",
        "text-decoration-skip",
        "text-decoration-skip-ink",
        "text-decoration-style",
        "text-emphasis",
        "text-emphasis-color",
        "text-emphasis-position",
        "text-emphasis-style",
        "text-height",
        "text-indent",
        "text-justify",
        "text-orientation",
        "text-outline",
        "text-overflow",
        "text-rendering",
        "text-shadow",
        "text-size-adjust",
        "text-space-collapse",
        "text-transform",
        "text-underline-position",
        "text-wrap",
        "top",
        "touch-action",
        "transform",
        "transform-origin",
        "transform-style",
        "transition",
        "transition-delay",
        "transition-duration",
        "transition-property",
        "transition-timing-function",
        "translate",
        "unicode-bidi",
        "user-select",
        "vertical-align",
        "visibility",
        "voice-balance",
        "voice-duration",
        "voice-family",
        "voice-pitch",
        "voice-range",
        "voice-rate",
        "voice-stress",
        "voice-volume",
        "volume",
        "white-space",
        "widows",
        "width",
        "will-change",
        "word-break",
        "word-spacing",
        "word-wrap",
        "writing-mode",
        "z-index",
        // SVG-specific
        "clip-path",
        "clip-rule",
        "mask",
        "enable-background",
        "filter",
        "flood-color",
        "flood-opacity",
        "lighting-color",
        "stop-color",
        "stop-opacity",
        "pointer-events",
        "color-interpolation",
        "color-interpolation-filters",
        "color-rendering",
        "fill",
        "fill-opacity",
        "fill-rule",
        "image-rendering",
        "marker",
        "marker-end",
        "marker-mid",
        "marker-start",
        "paint-order",
        "shape-rendering",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-rendering",
        "baseline-shift",
        "dominant-baseline",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "text-anchor",
        "writing-mode"
    ], propertyKeywords = keySet(propertyKeywords_);
    var nonStandardPropertyKeywords_ = [
        "accent-color",
        "aspect-ratio",
        "border-block",
        "border-block-color",
        "border-block-end",
        "border-block-end-color",
        "border-block-end-style",
        "border-block-end-width",
        "border-block-start",
        "border-block-start-color",
        "border-block-start-style",
        "border-block-start-width",
        "border-block-style",
        "border-block-width",
        "border-inline",
        "border-inline-color",
        "border-inline-end",
        "border-inline-end-color",
        "border-inline-end-style",
        "border-inline-end-width",
        "border-inline-start",
        "border-inline-start-color",
        "border-inline-start-style",
        "border-inline-start-width",
        "border-inline-style",
        "border-inline-width",
        "content-visibility",
        "margin-block",
        "margin-block-end",
        "margin-block-start",
        "margin-inline",
        "margin-inline-end",
        "margin-inline-start",
        "overflow-anchor",
        "overscroll-behavior",
        "padding-block",
        "padding-block-end",
        "padding-block-start",
        "padding-inline",
        "padding-inline-end",
        "padding-inline-start",
        "scroll-snap-stop",
        "scrollbar-3d-light-color",
        "scrollbar-arrow-color",
        "scrollbar-base-color",
        "scrollbar-dark-shadow-color",
        "scrollbar-face-color",
        "scrollbar-highlight-color",
        "scrollbar-shadow-color",
        "scrollbar-track-color",
        "searchfield-cancel-button",
        "searchfield-decoration",
        "searchfield-results-button",
        "searchfield-results-decoration",
        "shape-inside",
        "zoom"
    ], nonStandardPropertyKeywords = keySet(nonStandardPropertyKeywords_);
    var fontProperties_ = [
        "font-display",
        "font-family",
        "src",
        "unicode-range",
        "font-variant",
        "font-feature-settings",
        "font-stretch",
        "font-weight",
        "font-style"
    ], fontProperties = keySet(fontProperties_);
    var counterDescriptors_ = [
        "additive-symbols",
        "fallback",
        "negative",
        "pad",
        "prefix",
        "range",
        "speak-as",
        "suffix",
        "symbols",
        "system"
    ], counterDescriptors = keySet(counterDescriptors_);
    var colorKeywords_ = [
        "aliceblue",
        "antiquewhite",
        "aqua",
        "aquamarine",
        "azure",
        "beige",
        "bisque",
        "black",
        "blanchedalmond",
        "blue",
        "blueviolet",
        "brown",
        "burlywood",
        "cadetblue",
        "chartreuse",
        "chocolate",
        "coral",
        "cornflowerblue",
        "cornsilk",
        "crimson",
        "cyan",
        "darkblue",
        "darkcyan",
        "darkgoldenrod",
        "darkgray",
        "darkgreen",
        "darkgrey",
        "darkkhaki",
        "darkmagenta",
        "darkolivegreen",
        "darkorange",
        "darkorchid",
        "darkred",
        "darksalmon",
        "darkseagreen",
        "darkslateblue",
        "darkslategray",
        "darkslategrey",
        "darkturquoise",
        "darkviolet",
        "deeppink",
        "deepskyblue",
        "dimgray",
        "dimgrey",
        "dodgerblue",
        "firebrick",
        "floralwhite",
        "forestgreen",
        "fuchsia",
        "gainsboro",
        "ghostwhite",
        "gold",
        "goldenrod",
        "gray",
        "grey",
        "green",
        "greenyellow",
        "honeydew",
        "hotpink",
        "indianred",
        "indigo",
        "ivory",
        "khaki",
        "lavender",
        "lavenderblush",
        "lawngreen",
        "lemonchiffon",
        "lightblue",
        "lightcoral",
        "lightcyan",
        "lightgoldenrodyellow",
        "lightgray",
        "lightgreen",
        "lightgrey",
        "lightpink",
        "lightsalmon",
        "lightseagreen",
        "lightskyblue",
        "lightslategray",
        "lightslategrey",
        "lightsteelblue",
        "lightyellow",
        "lime",
        "limegreen",
        "linen",
        "magenta",
        "maroon",
        "mediumaquamarine",
        "mediumblue",
        "mediumorchid",
        "mediumpurple",
        "mediumseagreen",
        "mediumslateblue",
        "mediumspringgreen",
        "mediumturquoise",
        "mediumvioletred",
        "midnightblue",
        "mintcream",
        "mistyrose",
        "moccasin",
        "navajowhite",
        "navy",
        "oldlace",
        "olive",
        "olivedrab",
        "orange",
        "orangered",
        "orchid",
        "palegoldenrod",
        "palegreen",
        "paleturquoise",
        "palevioletred",
        "papayawhip",
        "peachpuff",
        "peru",
        "pink",
        "plum",
        "powderblue",
        "purple",
        "rebeccapurple",
        "red",
        "rosybrown",
        "royalblue",
        "saddlebrown",
        "salmon",
        "sandybrown",
        "seagreen",
        "seashell",
        "sienna",
        "silver",
        "skyblue",
        "slateblue",
        "slategray",
        "slategrey",
        "snow",
        "springgreen",
        "steelblue",
        "tan",
        "teal",
        "thistle",
        "tomato",
        "turquoise",
        "violet",
        "wheat",
        "white",
        "whitesmoke",
        "yellow",
        "yellowgreen"
    ], colorKeywords = keySet(colorKeywords_);
    var valueKeywords_ = [
        "above",
        "absolute",
        "activeborder",
        "additive",
        "activecaption",
        "afar",
        "after-white-space",
        "ahead",
        "alias",
        "all",
        "all-scroll",
        "alphabetic",
        "alternate",
        "always",
        "amharic",
        "amharic-abegede",
        "antialiased",
        "appworkspace",
        "arabic-indic",
        "armenian",
        "asterisks",
        "attr",
        "auto",
        "auto-flow",
        "avoid",
        "avoid-column",
        "avoid-page",
        "avoid-region",
        "axis-pan",
        "background",
        "backwards",
        "baseline",
        "below",
        "bidi-override",
        "binary",
        "bengali",
        "blink",
        "block",
        "block-axis",
        "blur",
        "bold",
        "bolder",
        "border",
        "border-box",
        "both",
        "bottom",
        "break",
        "break-all",
        "break-word",
        "brightness",
        "bullets",
        "button",
        "buttonface",
        "buttonhighlight",
        "buttonshadow",
        "buttontext",
        "calc",
        "cambodian",
        "capitalize",
        "caps-lock-indicator",
        "caption",
        "captiontext",
        "caret",
        "cell",
        "center",
        "checkbox",
        "circle",
        "cjk-decimal",
        "cjk-earthly-branch",
        "cjk-heavenly-stem",
        "cjk-ideographic",
        "clear",
        "clip",
        "close-quote",
        "col-resize",
        "collapse",
        "color",
        "color-burn",
        "color-dodge",
        "column",
        "column-reverse",
        "compact",
        "condensed",
        "conic-gradient",
        "contain",
        "content",
        "contents",
        "content-box",
        "context-menu",
        "continuous",
        "contrast",
        "copy",
        "counter",
        "counters",
        "cover",
        "crop",
        "cross",
        "crosshair",
        "cubic-bezier",
        "currentcolor",
        "cursive",
        "cyclic",
        "darken",
        "dashed",
        "decimal",
        "decimal-leading-zero",
        "default",
        "default-button",
        "dense",
        "destination-atop",
        "destination-in",
        "destination-out",
        "destination-over",
        "devanagari",
        "difference",
        "disc",
        "discard",
        "disclosure-closed",
        "disclosure-open",
        "document",
        "dot-dash",
        "dot-dot-dash",
        "dotted",
        "double",
        "down",
        "drop-shadow",
        "e-resize",
        "ease",
        "ease-in",
        "ease-in-out",
        "ease-out",
        "element",
        "ellipse",
        "ellipsis",
        "embed",
        "end",
        "ethiopic",
        "ethiopic-abegede",
        "ethiopic-abegede-am-et",
        "ethiopic-abegede-gez",
        "ethiopic-abegede-ti-er",
        "ethiopic-abegede-ti-et",
        "ethiopic-halehame-aa-er",
        "ethiopic-halehame-aa-et",
        "ethiopic-halehame-am-et",
        "ethiopic-halehame-gez",
        "ethiopic-halehame-om-et",
        "ethiopic-halehame-sid-et",
        "ethiopic-halehame-so-et",
        "ethiopic-halehame-ti-er",
        "ethiopic-halehame-ti-et",
        "ethiopic-halehame-tig",
        "ethiopic-numeric",
        "ew-resize",
        "exclusion",
        "expanded",
        "extends",
        "extra-condensed",
        "extra-expanded",
        "fantasy",
        "fast",
        "fill",
        "fill-box",
        "fixed",
        "flat",
        "flex",
        "flex-end",
        "flex-start",
        "footnotes",
        "forwards",
        "from",
        "geometricPrecision",
        "georgian",
        "grayscale",
        "graytext",
        "grid",
        "groove",
        "gujarati",
        "gurmukhi",
        "hand",
        "hangul",
        "hangul-consonant",
        "hard-light",
        "hebrew",
        "help",
        "hidden",
        "hide",
        "higher",
        "highlight",
        "highlighttext",
        "hiragana",
        "hiragana-iroha",
        "horizontal",
        "hsl",
        "hsla",
        "hue",
        "hue-rotate",
        "icon",
        "ignore",
        "inactiveborder",
        "inactivecaption",
        "inactivecaptiontext",
        "infinite",
        "infobackground",
        "infotext",
        "inherit",
        "initial",
        "inline",
        "inline-axis",
        "inline-block",
        "inline-flex",
        "inline-grid",
        "inline-table",
        "inset",
        "inside",
        "intrinsic",
        "invert",
        "italic",
        "japanese-formal",
        "japanese-informal",
        "justify",
        "kannada",
        "katakana",
        "katakana-iroha",
        "keep-all",
        "khmer",
        "korean-hangul-formal",
        "korean-hanja-formal",
        "korean-hanja-informal",
        "landscape",
        "lao",
        "large",
        "larger",
        "left",
        "level",
        "lighter",
        "lighten",
        "line-through",
        "linear",
        "linear-gradient",
        "lines",
        "list-item",
        "listbox",
        "listitem",
        "local",
        "logical",
        "loud",
        "lower",
        "lower-alpha",
        "lower-armenian",
        "lower-greek",
        "lower-hexadecimal",
        "lower-latin",
        "lower-norwegian",
        "lower-roman",
        "lowercase",
        "ltr",
        "luminosity",
        "malayalam",
        "manipulation",
        "match",
        "matrix",
        "matrix3d",
        "media-play-button",
        "media-slider",
        "media-sliderthumb",
        "media-volume-slider",
        "media-volume-sliderthumb",
        "medium",
        "menu",
        "menulist",
        "menulist-button",
        "menutext",
        "message-box",
        "middle",
        "min-intrinsic",
        "mix",
        "mongolian",
        "monospace",
        "move",
        "multiple",
        "multiple_mask_images",
        "multiply",
        "myanmar",
        "n-resize",
        "narrower",
        "ne-resize",
        "nesw-resize",
        "no-close-quote",
        "no-drop",
        "no-open-quote",
        "no-repeat",
        "none",
        "normal",
        "not-allowed",
        "nowrap",
        "ns-resize",
        "numbers",
        "numeric",
        "nw-resize",
        "nwse-resize",
        "oblique",
        "octal",
        "opacity",
        "open-quote",
        "optimizeLegibility",
        "optimizeSpeed",
        "oriya",
        "oromo",
        "outset",
        "outside",
        "outside-shape",
        "overlay",
        "overline",
        "padding",
        "padding-box",
        "painted",
        "page",
        "paused",
        "persian",
        "perspective",
        "pinch-zoom",
        "plus-darker",
        "plus-lighter",
        "pointer",
        "polygon",
        "portrait",
        "pre",
        "pre-line",
        "pre-wrap",
        "preserve-3d",
        "progress",
        "push-button",
        "radial-gradient",
        "radio",
        "read-only",
        "read-write",
        "read-write-plaintext-only",
        "rectangle",
        "region",
        "relative",
        "repeat",
        "repeating-linear-gradient",
        "repeating-radial-gradient",
        "repeating-conic-gradient",
        "repeat-x",
        "repeat-y",
        "reset",
        "reverse",
        "rgb",
        "rgba",
        "ridge",
        "right",
        "rotate",
        "rotate3d",
        "rotateX",
        "rotateY",
        "rotateZ",
        "round",
        "row",
        "row-resize",
        "row-reverse",
        "rtl",
        "run-in",
        "running",
        "s-resize",
        "sans-serif",
        "saturate",
        "saturation",
        "scale",
        "scale3d",
        "scaleX",
        "scaleY",
        "scaleZ",
        "screen",
        "scroll",
        "scrollbar",
        "scroll-position",
        "se-resize",
        "searchfield",
        "searchfield-cancel-button",
        "searchfield-decoration",
        "searchfield-results-button",
        "searchfield-results-decoration",
        "self-start",
        "self-end",
        "semi-condensed",
        "semi-expanded",
        "separate",
        "sepia",
        "serif",
        "show",
        "sidama",
        "simp-chinese-formal",
        "simp-chinese-informal",
        "single",
        "skew",
        "skewX",
        "skewY",
        "skip-white-space",
        "slide",
        "slider-horizontal",
        "slider-vertical",
        "sliderthumb-horizontal",
        "sliderthumb-vertical",
        "slow",
        "small",
        "small-caps",
        "small-caption",
        "smaller",
        "soft-light",
        "solid",
        "somali",
        "source-atop",
        "source-in",
        "source-out",
        "source-over",
        "space",
        "space-around",
        "space-between",
        "space-evenly",
        "spell-out",
        "square",
        "square-button",
        "start",
        "static",
        "status-bar",
        "stretch",
        "stroke",
        "stroke-box",
        "sub",
        "subpixel-antialiased",
        "svg_masks",
        "super",
        "sw-resize",
        "symbolic",
        "symbols",
        "system-ui",
        "table",
        "table-caption",
        "table-cell",
        "table-column",
        "table-column-group",
        "table-footer-group",
        "table-header-group",
        "table-row",
        "table-row-group",
        "tamil",
        "telugu",
        "text",
        "text-bottom",
        "text-top",
        "textarea",
        "textfield",
        "thai",
        "thick",
        "thin",
        "threeddarkshadow",
        "threedface",
        "threedhighlight",
        "threedlightshadow",
        "threedshadow",
        "tibetan",
        "tigre",
        "tigrinya-er",
        "tigrinya-er-abegede",
        "tigrinya-et",
        "tigrinya-et-abegede",
        "to",
        "top",
        "trad-chinese-formal",
        "trad-chinese-informal",
        "transform",
        "translate",
        "translate3d",
        "translateX",
        "translateY",
        "translateZ",
        "transparent",
        "ultra-condensed",
        "ultra-expanded",
        "underline",
        "unidirectional-pan",
        "unset",
        "up",
        "upper-alpha",
        "upper-armenian",
        "upper-greek",
        "upper-hexadecimal",
        "upper-latin",
        "upper-norwegian",
        "upper-roman",
        "uppercase",
        "urdu",
        "url",
        "var",
        "vertical",
        "vertical-text",
        "view-box",
        "visible",
        "visibleFill",
        "visiblePainted",
        "visibleStroke",
        "visual",
        "w-resize",
        "wait",
        "wave",
        "wider",
        "window",
        "windowframe",
        "windowtext",
        "words",
        "wrap",
        "wrap-reverse",
        "x-large",
        "x-small",
        "xor",
        "xx-large",
        "xx-small"
    ], valueKeywords = keySet(valueKeywords_);
    var allWords = documentTypes_.concat(mediaTypes_).concat(mediaFeatures_).concat(mediaValueKeywords_).concat(propertyKeywords_).concat(nonStandardPropertyKeywords_).concat(colorKeywords_).concat(valueKeywords_);
    CodeMirror.registerHelper("hintWords", "css", allWords);
    function tokenCComment(stream, state) {
        var maybeEnd = false, ch;
        while((ch = stream.next()) != null){
            if (maybeEnd && ch == "/") {
                state.tokenize = null;
                break;
            }
            maybeEnd = ch == "*";
        }
        return [
            "comment",
            "comment"
        ];
    }
    CodeMirror.defineMIME("text/css", {
        documentTypes: documentTypes,
        mediaTypes: mediaTypes,
        mediaFeatures: mediaFeatures,
        mediaValueKeywords: mediaValueKeywords,
        propertyKeywords: propertyKeywords,
        nonStandardPropertyKeywords: nonStandardPropertyKeywords,
        fontProperties: fontProperties,
        counterDescriptors: counterDescriptors,
        colorKeywords: colorKeywords,
        valueKeywords: valueKeywords,
        tokenHooks: {
            "/": function(stream, state) {
                if (!stream.eat("*")) return false;
                state.tokenize = tokenCComment;
                return tokenCComment(stream, state);
            }
        },
        name: "css"
    });
    CodeMirror.defineMIME("text/x-scss", {
        mediaTypes: mediaTypes,
        mediaFeatures: mediaFeatures,
        mediaValueKeywords: mediaValueKeywords,
        propertyKeywords: propertyKeywords,
        nonStandardPropertyKeywords: nonStandardPropertyKeywords,
        colorKeywords: colorKeywords,
        valueKeywords: valueKeywords,
        fontProperties: fontProperties,
        allowNested: true,
        lineComment: "//",
        tokenHooks: {
            "/": function(stream, state) {
                if (stream.eat("/")) {
                    stream.skipToEnd();
                    return [
                        "comment",
                        "comment"
                    ];
                } else if (stream.eat("*")) {
                    state.tokenize = tokenCComment;
                    return tokenCComment(stream, state);
                } else return [
                    "operator",
                    "operator"
                ];
            },
            ":": function(stream) {
                if (stream.match(/^\s*\{/, false)) return [
                    null,
                    null
                ];
                return false;
            },
            "$": function(stream) {
                stream.match(/^[\w-]+/);
                if (stream.match(/^\s*:/, false)) return [
                    "variable-2",
                    "variable-definition"
                ];
                return [
                    "variable-2",
                    "variable"
                ];
            },
            "#": function(stream) {
                if (!stream.eat("{")) return false;
                return [
                    null,
                    "interpolation"
                ];
            }
        },
        name: "css",
        helperType: "scss"
    });
    CodeMirror.defineMIME("text/x-less", {
        mediaTypes: mediaTypes,
        mediaFeatures: mediaFeatures,
        mediaValueKeywords: mediaValueKeywords,
        propertyKeywords: propertyKeywords,
        nonStandardPropertyKeywords: nonStandardPropertyKeywords,
        colorKeywords: colorKeywords,
        valueKeywords: valueKeywords,
        fontProperties: fontProperties,
        allowNested: true,
        lineComment: "//",
        tokenHooks: {
            "/": function(stream, state) {
                if (stream.eat("/")) {
                    stream.skipToEnd();
                    return [
                        "comment",
                        "comment"
                    ];
                } else if (stream.eat("*")) {
                    state.tokenize = tokenCComment;
                    return tokenCComment(stream, state);
                } else return [
                    "operator",
                    "operator"
                ];
            },
            "@": function(stream) {
                if (stream.eat("{")) return [
                    null,
                    "interpolation"
                ];
                if (stream.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/i, false)) return false;
                stream.eatWhile(/[\w\\\-]/);
                if (stream.match(/^\s*:/, false)) return [
                    "variable-2",
                    "variable-definition"
                ];
                return [
                    "variable-2",
                    "variable"
                ];
            },
            "&": function() {
                return [
                    "atom",
                    "atom"
                ];
            }
        },
        name: "css",
        helperType: "less"
    });
    CodeMirror.defineMIME("text/x-gss", {
        documentTypes: documentTypes,
        mediaTypes: mediaTypes,
        mediaFeatures: mediaFeatures,
        propertyKeywords: propertyKeywords,
        nonStandardPropertyKeywords: nonStandardPropertyKeywords,
        fontProperties: fontProperties,
        counterDescriptors: counterDescriptors,
        colorKeywords: colorKeywords,
        valueKeywords: valueKeywords,
        supportsAtComponent: true,
        tokenHooks: {
            "/": function(stream, state) {
                if (!stream.eat("*")) return false;
                state.tokenize = tokenCComment;
                return tokenCComment(stream, state);
            }
        },
        name: "css",
        helperType: "gss"
    });
});

});

/**
 * @import {Editor} from "codemirror";
 */ /**
 * @import eslint from "eslint";
 * @import {Language} from "./languages/types";
 * @import {RulesRecord, ParserOptions} from "./linter";
 * @typedef {"lint" | "changeLanguage" | "autofixed"} EventType
 */ /**
 * @import {Language} from './types';
 */ /**
 * @import {Language} from './types';
 */ var $f8ccc60522e42651$exports = {};
"use strict";
Object.defineProperty($f8ccc60522e42651$exports, "__esModule", {
    value: true
});
$f8ccc60522e42651$exports.html = void 0;
var $9c57598a5c9d3f27$exports = {};
"use strict";
Object.defineProperty($9c57598a5c9d3f27$exports, "__esModule", {
    value: true
});
$9c57598a5c9d3f27$exports.html = $9c57598a5c9d3f27$var$html;
var $8c7c38ff89e40793$exports = {};
"use strict";
Object.defineProperty($8c7c38ff89e40793$exports, "__esModule", {
    value: true
});
$8c7c38ff89e40793$exports.stringify = $8c7c38ff89e40793$var$stringify;
function $8c7c38ff89e40793$var$stringify(expression) {
    switch(typeof expression){
        case "string":
            return expression;
        case "boolean":
        case "undefined":
            return "";
        case "number":
        case "bigint":
            return expression.toString();
        case "object":
            if (expression === null) return "";
            if (Array.isArray(expression)) return expression.map($8c7c38ff89e40793$var$stringify).join("");
            if ("toString" in expression && typeof expression["toString"] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return expression.toString();
    }
    throw new Error("Unexpected expression type: " + typeof expression);
}


function $9c57598a5c9d3f27$var$html(templateStrings) {
    var expressions = [];
    for(var _i = 1; _i < arguments.length; _i++)expressions[_i - 1] = arguments[_i];
    var htmls = [];
    for(var i = 0; i < templateStrings.length; i++){
        htmls.push(templateStrings[i]);
        if (expressions[i]) htmls.push((0, $8c7c38ff89e40793$exports.stringify)(expressions[i]));
    }
    return htmls.join("");
}


Object.defineProperty($f8ccc60522e42651$exports, "html", {
    enumerable: true,
    get: function() {
        return $9c57598a5c9d3f27$exports.html;
    }
});


const $0014b56698c19c34$export$8f8d2c6695a994bc = {
    key: "html",
    mime: 'text/html',
    initialCode: (0, $f8ccc60522e42651$exports.html)`<!doctype html>
    <html lang="en-US">
      <head>
      </head>
      <body>
        <div>
          <li> foo </li>
        </div>
      </body>
    </html>
    `,
    initialConfig: {
        rules: {
            "@html-eslint/indent": "error"
        }
    },
    isEqual (lang) {
        return lang === "html";
    }
};


/**
 * @import {Language} from './types';
 */ /**
 * @type {Language}
 */ const $86db5bb4f67b4f2a$export$34367314addb4f7e = {
    key: "javascript",
    mime: 'text/javascript',
    initialCode: `html\`
    <div>
        <span>
    </span>
    </div>
\`

const html = /*html*/\`
<div>
    <span>
       </span>
</div>
\`;`,
    initialConfig: {
        rules: {
            "@html-eslint/indent": "error"
        }
    },
    isEqual (lang) {
        return "javascript" === lang;
    }
};


/**
 * @import {Language} from './types';
 */ /**
 * @type {Language}
 */ const $c4554859e2ce4715$export$169c667ff0f0f9be = {
    key: "jsx",
    mime: 'text/jsx',
    initialCode: `const Component = () => {
    return <a rel="no referrer">link</a>;
}`,
    initialConfig: {
        rules: {
            "@html-eslint/react/use-baseline": "error",
            "@html-eslint/react/no-invalid-attr-value": "error"
        }
    },
    isEqual (lang) {
        return lang === "jsx";
    }
};


function $2b0c23c0b32e13dd$export$b6e4117edbe490a2(lang) {
    switch(lang){
        case 'html':
            return 0, $0014b56698c19c34$export$8f8d2c6695a994bc;
        case 'javascript':
            return 0, $86db5bb4f67b4f2a$export$34367314addb4f7e;
        case 'jsx':
            return 0, $c4554859e2ce4715$export$169c667ff0f0f9be;
    }
}


var $f03705736c6cdfcd$exports = {};
/**
 * @import {Linter} from "eslint"
 * @import {
 *   HTMLProgram,
 *   ParserOptions
 * } from "./types"
 */ /**
 * @param {string} code
 * @param {ParserOptions | undefined} parserOptions
 * @returns {Linter.ESLintParseResult}
 */ var $a3ab9a0e987a7d68$export$98bf86c57679d65e;
var $f3f48439a2287510$exports = {};
"use strict";
var $f3f48439a2287510$var$__createBinding = $f3f48439a2287510$exports && $f3f48439a2287510$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f3f48439a2287510$var$__exportStar = $f3f48439a2287510$exports && $f3f48439a2287510$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f3f48439a2287510$var$__createBinding(exports1, m, p);
};
Object.defineProperty($f3f48439a2287510$exports, "__esModule", {
    value: true
});
$f3f48439a2287510$exports.TokenTypes = $f3f48439a2287510$exports.NodeTypes = $f3f48439a2287510$exports.parse = void 0;
var $561a5d30e3d45f75$exports = {};
"use strict";
var $561a5d30e3d45f75$var$__createBinding = $561a5d30e3d45f75$exports && $561a5d30e3d45f75$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $561a5d30e3d45f75$var$__exportStar = $561a5d30e3d45f75$exports && $561a5d30e3d45f75$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $561a5d30e3d45f75$var$__createBinding(exports1, m, p);
};
Object.defineProperty($561a5d30e3d45f75$exports, "__esModule", {
    value: true
});

$561a5d30e3d45f75$var$__exportStar((parcelRequire("j8Tkc")), $561a5d30e3d45f75$exports);


Object.defineProperty($f3f48439a2287510$exports, "parse", {
    enumerable: true,
    get: function() {
        return $561a5d30e3d45f75$exports.parse;
    }
});

var $eJ62A = parcelRequire("eJ62A");
Object.defineProperty($f3f48439a2287510$exports, "NodeTypes", {
    enumerable: true,
    get: function() {
        return $eJ62A.NodeTypes;
    }
});
Object.defineProperty($f3f48439a2287510$exports, "TokenTypes", {
    enumerable: true,
    get: function() {
        return $eJ62A.TokenTypes;
    }
});

$f3f48439a2287510$var$__exportStar((parcelRequire("6bVCb")), $f3f48439a2287510$exports);


var $a3ab9a0e987a7d68$require$parse = $f3f48439a2287510$exports.parse;
var $a3ab9a0e987a7d68$require$TokenTypes = $f3f48439a2287510$exports.TokenTypes;
var $48bb5b7f2107b205$exports = {};
var $ff2e297f9661f224$exports = {};

var $ff2e297f9661f224$require$NodeTypes = $f3f48439a2287510$exports.NodeTypes;
const $ff2e297f9661f224$var$NODE_TYPES = $ff2e297f9661f224$require$NodeTypes;
$ff2e297f9661f224$exports = {
    NODE_TYPES: $ff2e297f9661f224$var$NODE_TYPES
};


var $48bb5b7f2107b205$require$NODE_TYPES = $ff2e297f9661f224$exports.NODE_TYPES;
var $f92d3d7d3b5eb7a4$exports = {};
const $f92d3d7d3b5eb7a4$var$cssVisitorKeys = {
    CssAnPlusB: [],
    CssAtrule: [
        "prelude",
        "block"
    ],
    CssAtrulePrelude: [
        "children"
    ],
    CssAttributeSelector: [
        "name",
        "value"
    ],
    CssBlock: [
        "children"
    ],
    CssBrackets: [
        "children"
    ],
    CssCDC: [],
    CssCDO: [],
    CssClassSelector: [],
    CssCombinator: [],
    CssCondition: [
        "children"
    ],
    CssDeclaration: [
        "value"
    ],
    CssDeclarationList: [
        "children"
    ],
    CssDimension: [],
    CssFeature: [
        "value"
    ],
    CssFeatureFunction: [
        "value"
    ],
    CssFeatureRange: [
        "left",
        "middle",
        "right"
    ],
    CssFunction: [
        "children"
    ],
    CssGeneralEnclosed: [
        "children"
    ],
    CssHash: [],
    CssIdSelector: [],
    CssIdentifier: [],
    CssLayer: [],
    CssLayerList: [
        "children"
    ],
    CssMediaQuery: [
        "condition"
    ],
    CssMediaQueryList: [
        "children"
    ],
    CssNestingSelector: [],
    CssNth: [
        "nth",
        "selector"
    ],
    CssNumber: [],
    CssOperator: [],
    CssParentheses: [
        "children"
    ],
    CssPercentage: [],
    CssPseudoClassSelector: [
        "children"
    ],
    CssPseudoElementSelector: [
        "children"
    ],
    CssRatio: [
        "left",
        "right"
    ],
    CssRaw: [],
    CssRule: [
        "prelude",
        "block"
    ],
    CssScope: [
        "root",
        "limit"
    ],
    CssSelector: [
        "children"
    ],
    CssSelectorList: [
        "children"
    ],
    CssString: [],
    CssStyleSheet: [
        "children"
    ],
    CssSupportsDeclaration: [
        "declaration"
    ],
    CssTypeSelector: [],
    CssUnicodeRange: [],
    CssUrl: [],
    CssValue: [
        "children"
    ],
    CssWhiteSpace: []
};
$f92d3d7d3b5eb7a4$exports = {
    cssVisitorKeys: $f92d3d7d3b5eb7a4$var$cssVisitorKeys
};


var $48bb5b7f2107b205$require$cssVisitorKeys = $f92d3d7d3b5eb7a4$exports.cssVisitorKeys;
const $48bb5b7f2107b205$var$visitorKeys = {
    Program: [
        "body"
    ],
    [$48bb5b7f2107b205$require$NODE_TYPES.Document]: [
        "children"
    ],
    [$48bb5b7f2107b205$require$NODE_TYPES.Attribute]: [
        "key",
        "startWrapper",
        "endWrapper",
        "value"
    ],
    [$48bb5b7f2107b205$require$NODE_TYPES.AttributeKey]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.AttributeValue]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.AttributeValueWrapperEnd]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.AttributeValueWrapperStart]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.CloseScriptTag]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.CloseStyleTag]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.CloseTag]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.Comment]: [
        "open",
        "close",
        "value"
    ],
    [$48bb5b7f2107b205$require$NODE_TYPES.CommentContent]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.CommentOpen]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.CommentClose]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.Doctype]: [
        "open",
        "close",
        "attributes"
    ],
    [$48bb5b7f2107b205$require$NODE_TYPES.DoctypeAttribute]: [
        "startWrapper",
        "value",
        "endWrapper"
    ],
    [$48bb5b7f2107b205$require$NODE_TYPES.DoctypeAttributeValue]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.DoctypeAttributeWrapperEnd]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.DoctypeAttributeWrapperStart]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.DoctypeOpen]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.DoctypeClose]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.OpenScriptTagEnd]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.OpenScriptTagStart]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.OpenStyleTagEnd]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.OpenStyleTagStart]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.OpenTagEnd]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.OpenTagStart]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.ScriptTag]: [
        "attributes",
        "openStart",
        "openEnd",
        "close",
        "value"
    ],
    [$48bb5b7f2107b205$require$NODE_TYPES.ScriptTagContent]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.StyleTag]: [
        "attributes",
        "openStart",
        "openEnd",
        "close",
        "value"
    ],
    [$48bb5b7f2107b205$require$NODE_TYPES.StyleTagContent]: [
        "stylesheet"
    ],
    [$48bb5b7f2107b205$require$NODE_TYPES.Tag]: [
        "openStart",
        "openEnd",
        "close",
        "children",
        "attributes"
    ],
    [$48bb5b7f2107b205$require$NODE_TYPES.Text]: [],
    [$48bb5b7f2107b205$require$NODE_TYPES.RawContent]: [],
    ...$48bb5b7f2107b205$require$cssVisitorKeys
};
$48bb5b7f2107b205$exports = {
    visitorKeys: $48bb5b7f2107b205$var$visitorKeys
};


var $a3ab9a0e987a7d68$require$visitorKeys = $48bb5b7f2107b205$exports.visitorKeys;
var $9977fe06abf185f7$exports = {};
/**
 * @import {CssNodePlain} from "css-tree"
 * @import {AnyNode} from "es-html-parser"
 * @import {HTMLProgram} from "./types"
 */ 
var $9977fe06abf185f7$require$visitorKeys = $48bb5b7f2107b205$exports.visitorKeys;

var $9977fe06abf185f7$require$cssVisitorKeys = $f92d3d7d3b5eb7a4$exports.cssVisitorKeys;
/**
 * @param {AnyNode | HTMLProgram} node
 * @param {(arg: AnyNode | HTMLProgram) => void} visitor
 * @returns {void}
 */ function $9977fe06abf185f7$var$traverse(node, visitor) {
    if (!node || !("type" in node)) return;
    visitor(node);
    const { type: type } = node;
    // @ts-ignore
    const keys = $9977fe06abf185f7$require$visitorKeys[type];
    if (!keys || keys.length <= 0) return;
    // @ts-ignore
    keys.forEach((key)=>{
        // @ts-ignore
        const value = node[key];
        if (value) {
            if (Array.isArray(value)) value.forEach((n)=>$9977fe06abf185f7$var$traverse(n, visitor));
            else $9977fe06abf185f7$var$traverse(value, visitor);
        }
    });
}
/**
 * @param {CssNodePlain} node
 * @param {(node: any) => void} visitor
 */ function $9977fe06abf185f7$var$traverseCss(node, visitor) {
    if (!node) return;
    /** @type {keyof typeof cssVisitorKeys} */ // @ts-ignore
    const type = `Css${node.type}`;
    const keys = $9977fe06abf185f7$require$cssVisitorKeys[type];
    visitor(node);
    if (!keys || keys.length <= 0) return;
    keys.forEach((key)=>{
        // @ts-ignore
        const value = node[key];
        if (value) {
            if (Array.isArray(value)) value.forEach((n)=>$9977fe06abf185f7$var$traverseCss(n, visitor));
            else $9977fe06abf185f7$var$traverseCss(value, visitor);
        }
    });
}
$9977fe06abf185f7$exports = {
    traverse: $9977fe06abf185f7$var$traverse,
    traverseCss: $9977fe06abf185f7$var$traverseCss
};


var $a3ab9a0e987a7d68$require$traverse = $9977fe06abf185f7$exports.traverse;
var $a3ab9a0e987a7d68$require$traverseCss = $9977fe06abf185f7$exports.traverseCss;

var $a3ab9a0e987a7d68$require$NODE_TYPES = $ff2e297f9661f224$exports.NODE_TYPES;
var $cedeb024222075c6$exports = {};
/**
 * @import {TemplateSyntax} from "@html-eslint/template-syntax-parser"
 * @import ESHtmlParser from "es-html-parser"
 * @import {ParserOptions} from "./types"
 */ var $ea9e1996dfad9cb6$exports = {};
var $df638510dfaedead$exports = {};
/**
 * @import {
 *   SyntaxConfig,
 *   SyntaxConfigItem,
 *   TemplateSyntaxParserConfig
 * } from "./types"
 */ var $a2cc591a05faa769$exports = {};
/**
 * @import {Range} from "@html-eslint/types"
 * @import {
 *   CloseSyntax,
 *   OpenSyntax,
 *   SyntaxConfigItem,
 *   TemplateSyntax,
 *   TemplateSyntaxParserResult
 * } from "./types"
 */ $a2cc591a05faa769$exports = class Parser {
    /**
   * @param {string} code
   * @param {SyntaxConfigItem[]} syntaxPairs
   * @param {Range[]} skipRanges
   */ constructor(code, syntaxPairs, skipRanges){
        /** @type {string} */ this.code = code;
        /** @type {SyntaxConfigItem[]} */ this.syntaxPairs = syntaxPairs || [];
        /** @type {Range[]} */ this.skipRanges = skipRanges;
        /** @type {OpenSyntax[]} */ this.syntaxStack = [];
        /** @type {TemplateSyntax[]} */ this.result = [];
    }
    /**
   * @private
   * @param {number} index
   * @returns {Range | undefined}
   */ findSkipRange(index) {
        return this.skipRanges.find((range)=>range[0] <= index && index < range[1]);
    }
    /**
   * @param {string} syntax
   * @param {number} position
   * @returns {number}
   */ indexOf(syntax, position) {
        const index = this.code.indexOf(syntax, position);
        if (index < 0) return index;
        const skipRange = this.findSkipRange(index);
        if (skipRange) return this.indexOf(syntax, skipRange[1]);
        return index;
    }
    /**
   * @param {number} position
   * @returns {OpenSyntax | null}
   */ findOpenSyntax(position) {
        /** @type {string | null} */ let value = null;
        let rangeStart = Infinity;
        /** @type {boolean | undefined} */ let isComment = undefined;
        for(let i = 0; i < this.syntaxPairs.length; i++){
            const syntax = this.syntaxPairs[i];
            const open = syntax.open;
            const openIndex = this.indexOf(open, position);
            if (openIndex >= 0 && openIndex < rangeStart) {
                value = open;
                rangeStart = openIndex;
                isComment = syntax.isComment;
            }
        }
        if (!value) return null;
        return {
            type: "open",
            value: value,
            isComment: isComment,
            range: [
                rangeStart,
                rangeStart + value.length
            ]
        };
    }
    /**
   * @param {number} position
   * @returns {CloseSyntax | null}
   */ findCloseSyntax(position) {
        /** @type {string | null} */ let value = null;
        let rangeStart = Infinity;
        /** @type {boolean | undefined} */ let isComment = undefined;
        for(let i = 0; i < this.syntaxPairs.length; i++){
            const syntax = this.syntaxPairs[i];
            const close = syntax.close;
            const closeIndex = this.indexOf(close, position);
            if (closeIndex >= 0 && closeIndex < rangeStart) {
                value = close;
                rangeStart = closeIndex;
                isComment = syntax.isComment;
            }
        }
        if (!value) return null;
        return {
            type: "close",
            value: value,
            isComment: isComment,
            range: [
                rangeStart,
                rangeStart + value.length
            ]
        };
    }
    /** @returns {OpenSyntax[]} */ findAllOpenSyntax() {
        /** @type {OpenSyntax[]} */ const result = [];
        let position = 0;
        while(position < this.code.length){
            const openSyntax = this.findOpenSyntax(position);
            if (!openSyntax) break;
            result.push(openSyntax);
            position = openSyntax.range[1];
        }
        return result;
    }
    /** @returns {CloseSyntax[]} */ findAllCloseSyntax() {
        /** @type {CloseSyntax[]} */ const result = [];
        let position = 0;
        while(position < this.code.length){
            const closeSyntax = this.findCloseSyntax(position);
            if (!closeSyntax) break;
            result.push(closeSyntax);
            position = closeSyntax.range[1];
        }
        return result;
    }
    /** @returns {(CloseSyntax | OpenSyntax)[]} */ findAllSyntax() {
        /** @type {(CloseSyntax | OpenSyntax)[]} */ const result = this.findAllOpenSyntax();
        return result.concat(this.findAllCloseSyntax()).sort((a, b)=>a.range[0] - b.range[0]);
    }
    /**
   * @param {OpenSyntax} open
   * @returns {string}
   */ getPossibleCloseValueOf(open) {
        const found = this.syntaxPairs.find((syntax)=>syntax.open === open.value);
        if (!found) /* istanbul ignore next */ throw new Error("Unexpected open value: " + open);
        return found.close;
    }
    /** @param {CloseSyntax | OpenSyntax} syntax */ eatSyntax(syntax) {
        if (syntax.type === "open") {
            const top = this.syntaxStack[this.syntaxStack.length - 1];
            if (!top) {
                this.syntaxStack.push(syntax);
                return;
            }
            if (top.isComment) return;
            throw new Error(`Expecting "${this.getPossibleCloseValueOf(top)}", but found "${syntax.value}" at (${syntax.range[0]}, ${syntax.range[1]}).`);
        } else if (syntax.type === "close") {
            const top = this.syntaxStack[this.syntaxStack.length - 1];
            if (!top) return;
            if (top.isComment && !syntax.isComment) return;
            this.syntaxStack.pop();
            if (this.getPossibleCloseValueOf(top) === syntax.value) this.result.push({
                open: [
                    top.range[0],
                    top.range[0] + top.value.length
                ],
                close: [
                    syntax.range[1] - syntax.value.length,
                    syntax.range[1]
                ]
            });
        }
    }
    /** @returns {TemplateSyntaxParserResult} */ parse() {
        for (const syntax of this.findAllSyntax())this.eatSyntax(syntax);
        return {
            syntax: this.result
        };
    }
};


/**
 * @param {SyntaxConfig} syntax
 * @returns {SyntaxConfigItem[]}
 */ function $df638510dfaedead$var$normalizeSyntaxOptions(syntax) {
    if (Array.isArray(syntax)) return syntax;
    return Object.entries(syntax).map(([open, close])=>({
            open: open,
            close: close
        }));
}
/**
 * @param {TemplateSyntaxParserConfig} config
 * @returns {SyntaxConfigItem[]}
 */ function $df638510dfaedead$var$getSyntaxPairs(config) {
    const syntaxPairs = $df638510dfaedead$var$normalizeSyntaxOptions(config.syntax);
    syntaxPairs.sort((syntaxA, syntaxB)=>syntaxB.open.length - syntaxA.open.length);
    return syntaxPairs;
}
/**
 * @param {string} code
 * @param {TemplateSyntaxParserConfig} config
 */ function $df638510dfaedead$var$parse(code, config) {
    const syntaxPairs = $df638510dfaedead$var$getSyntaxPairs(config);
    const parser = new $a2cc591a05faa769$exports(code, syntaxPairs, config.skipRanges || []);
    return parser.parse();
}
$df638510dfaedead$exports = {
    parse: $df638510dfaedead$var$parse
};


var $ea9e1996dfad9cb6$require$parse = $df638510dfaedead$exports.parse;
$ea9e1996dfad9cb6$exports = {
    parse: $ea9e1996dfad9cb6$require$parse
};


var $69aec87ace2f649a$exports = {};
/**
 * @typedef {Object} FrontmatterResult
 * @property {number} FrontmatterResult.index
 * @property {number} FrontmatterResult.line
 * @property {string} FrontmatterResult.html
 */ /**
 * @param {string} text
 * @returns {boolean}
 */ function $69aec87ace2f649a$var$startsWithFrontmatter(text) {
    return /^[\n|\r\n]*---[\n|\r\n]/.test(text);
}
/**
 * @param {string} text
 * @returns {number | null}
 */ function $69aec87ace2f649a$var$indexOfEndFrontmatter(text) {
    const rest = text.slice(3);
    const endExpExec = /([\n|\r\n]---\s*[\n|\r\n]?)/.exec(rest);
    if (!endExpExec) return null;
    if (/([\n|\r\n]---[\S]+)/.exec(rest)) return null;
    const end = endExpExec.index + endExpExec[0].length;
    return end + 3;
}
/**
 * @param {string} text
 * @returns {number}
 */ function $69aec87ace2f649a$var$countLines(text) {
    return text.split("\n").length;
}
/**
 * @param {string} text
 * @returns {FrontmatterResult | null}
 */ function $69aec87ace2f649a$var$parseFrontmatterContent(text) {
    if (!$69aec87ace2f649a$var$startsWithFrontmatter(text)) return null;
    const end = $69aec87ace2f649a$var$indexOfEndFrontmatter(text);
    if (!end) return null;
    const line = $69aec87ace2f649a$var$countLines(text.slice(0, end));
    return {
        index: end,
        line: line,
        html: text.slice(end)
    };
}
$69aec87ace2f649a$exports = {
    parseFrontmatterContent: $69aec87ace2f649a$var$parseFrontmatterContent
};


var $cedeb024222075c6$require$parseFrontmatterContent = $69aec87ace2f649a$exports.parseFrontmatterContent;
/**
 * @param {string} code
 * @param {ParserOptions | undefined} parserOptions
 * @returns {{ options: Parameters<ESHtmlParser["parse"]>[1]; html: string }}
 */ function $cedeb024222075c6$var$getOptions(code, parserOptions) {
    let html = code;
    if (!parserOptions) return {
        options: undefined,
        html: html
    };
    /** @type {any} */ let tokenAdapter = undefined;
    if (parserOptions.frontmatter) {
        const result = $cedeb024222075c6$require$parseFrontmatterContent(code);
        if (result) {
            html = result.html;
            const lineOffset = result.line - 1;
            tokenAdapter = {
                /** @param {any} token */ finalizeLocation (token) {
                    const startLine = token.loc.start.line + lineOffset;
                    const endLine = token.loc.end.line + lineOffset;
                    return {
                        start: {
                            line: startLine,
                            column: token.loc.start.column
                        },
                        end: {
                            line: endLine,
                            column: token.loc.end.column
                        }
                    };
                },
                /** @param {any} token */ finalizeRange (token) {
                    return [
                        token.range[0] + result.index,
                        token.range[1] + result.index
                    ];
                }
            };
        }
    }
    /** @type {TemplateSyntax[] | undefined} */ let templateInfos = undefined;
    if (parserOptions.templateEngineSyntax) templateInfos = $ea9e1996dfad9cb6$exports.parse(html, {
        syntax: parserOptions.templateEngineSyntax
    }).syntax;
    /** @type {string[] | undefined} */ let rawContentTags;
    if (parserOptions.rawContentTags) rawContentTags = parserOptions.rawContentTags;
    if (templateInfos || tokenAdapter || rawContentTags) return {
        options: {
            templateInfos: templateInfos,
            tokenAdapter: tokenAdapter,
            rawContentTags: rawContentTags
        },
        html: html
    };
    return {
        options: undefined,
        html: html
    };
}
$cedeb024222075c6$exports = {
    getOptions: $cedeb024222075c6$var$getOptions
};


var $a3ab9a0e987a7d68$require$getOptions = $cedeb024222075c6$exports.getOptions;
// CSS Syntax Module Level 3
// https://www.w3.org/TR/css-syntax-3/
const $cb01acaf2e18d562$export$c1a09112320b1603 = 0; // <EOF-token>
const $cb01acaf2e18d562$export$331e9b6bdecaac5f = 1; // <ident-token>
const $cb01acaf2e18d562$export$f3890eeaf6851387 = 2; // <function-token>
const $cb01acaf2e18d562$export$21bfcb60d1b5ccac = 3; // <at-keyword-token>
const $cb01acaf2e18d562$export$ab85ecd77ce6a5cd = 4; // <hash-token>
const $cb01acaf2e18d562$export$89b8e0fa65f6a914 = 5; // <string-token>
const $cb01acaf2e18d562$export$d273d1be20da6de2 = 6; // <bad-string-token>
const $cb01acaf2e18d562$export$59d795186a5d3f58 = 7; // <url-token>
const $cb01acaf2e18d562$export$f8b4878501aa4a62 = 8; // <bad-url-token>
const $cb01acaf2e18d562$export$a918ca49ff4337a3 = 9; // <delim-token>
const $cb01acaf2e18d562$export$fffa67e515d04022 = 10; // <number-token>
const $cb01acaf2e18d562$export$d11913f8a6922aea = 11; // <percentage-token>
const $cb01acaf2e18d562$export$c940ece961bc43c6 = 12; // <dimension-token>
const $cb01acaf2e18d562$export$fb98946286ab4c97 = 13; // <whitespace-token>
const $cb01acaf2e18d562$export$521ef26a3002003b = 14; // <CDO-token>
const $cb01acaf2e18d562$export$b0b2bd2d1777c179 = 15; // <CDC-token>
const $cb01acaf2e18d562$export$e20ebb298016f6 = 16; // <colon-token>     :
const $cb01acaf2e18d562$export$bedd8b9b04d9dbd = 17; // <semicolon-token> ;
const $cb01acaf2e18d562$export$c06e3ee3b4d233fa = 18; // <comma-token>     ,
const $cb01acaf2e18d562$export$cd363bb53c2bb = 19; // <[-token>
const $cb01acaf2e18d562$export$72f933344f701f30 = 20; // <]-token>
const $cb01acaf2e18d562$export$b5a25f132cb53de6 = 21; // <(-token>
const $cb01acaf2e18d562$export$773d33972c6279ed = 22; // <)-token>
const $cb01acaf2e18d562$export$ccdce7304ac66390 = 23; // <{-token>
const $cb01acaf2e18d562$export$186d8b1f99e2bfec = 24; // <}-token>
const $cb01acaf2e18d562$export$4d299b491347818a = 25;


const $fb47edd266a7fc33$var$EOF = 0;
function $fb47edd266a7fc33$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $fb47edd266a7fc33$export$2a81dc4d1a2f9334(code) {
    return $fb47edd266a7fc33$export$727d9dbc4fbb948f(code) || // 0 .. 9
    code >= 0x0041 && code <= 0x0046 || // A .. F
    code >= 0x0061 && code <= 0x0066 // a .. f
    ;
}
function $fb47edd266a7fc33$export$35784e2518402c99(code) {
    return code >= 0x0041 && code <= 0x005A;
}
function $fb47edd266a7fc33$export$25a7e820fbcd58b9(code) {
    return code >= 0x0061 && code <= 0x007A;
}
function $fb47edd266a7fc33$export$79c5d5217943d6a7(code) {
    return $fb47edd266a7fc33$export$35784e2518402c99(code) || $fb47edd266a7fc33$export$25a7e820fbcd58b9(code);
}
function $fb47edd266a7fc33$export$386c40f28a3efd99(code) {
    return code >= 0x0080;
}
function $fb47edd266a7fc33$export$45a677ea7cb6d5c8(code) {
    return $fb47edd266a7fc33$export$79c5d5217943d6a7(code) || $fb47edd266a7fc33$export$386c40f28a3efd99(code) || code === 0x005F;
}
function $fb47edd266a7fc33$export$998d7ff9801e90bb(code) {
    return $fb47edd266a7fc33$export$45a677ea7cb6d5c8(code) || $fb47edd266a7fc33$export$727d9dbc4fbb948f(code) || code === 0x002D;
}
function $fb47edd266a7fc33$export$b7ed17c2edb4d953(code) {
    return code >= 0x0000 && code <= 0x0008 || code === 0x000B || code >= 0x000E && code <= 0x001F || code === 0x007F;
}
function $fb47edd266a7fc33$export$c6b40e80adfef3ae(code) {
    return code === 0x000A || code === 0x000D || code === 0x000C;
}
function $fb47edd266a7fc33$export$3c52dd84024ae72c(code) {
    return $fb47edd266a7fc33$export$c6b40e80adfef3ae(code) || code === 0x0020 || code === 0x0009;
}
function $fb47edd266a7fc33$export$352e2c1d24776bfb(first, second) {
    // If the first code point is not U+005C REVERSE SOLIDUS (\), return false.
    if (first !== 0x005C) return false;
    // Otherwise, if the second code point is a newline or EOF, return false.
    if ($fb47edd266a7fc33$export$c6b40e80adfef3ae(second) || second === $fb47edd266a7fc33$var$EOF) return false;
    // Otherwise, return true.
    return true;
}
function $fb47edd266a7fc33$export$56b48cc5d7560ffb(first, second, third) {
    // Look at the first code point:
    // U+002D HYPHEN-MINUS
    if (first === 0x002D) // If the second code point is a name-start code point or a U+002D HYPHEN-MINUS,
    // or the second and third code points are a valid escape, return true. Otherwise, return false.
    return $fb47edd266a7fc33$export$45a677ea7cb6d5c8(second) || second === 0x002D || $fb47edd266a7fc33$export$352e2c1d24776bfb(second, third);
    // name-start code point
    if ($fb47edd266a7fc33$export$45a677ea7cb6d5c8(first)) // Return true.
    return true;
    // U+005C REVERSE SOLIDUS (\)
    if (first === 0x005C) // If the first and second code points are a valid escape, return true. Otherwise, return false.
    return $fb47edd266a7fc33$export$352e2c1d24776bfb(first, second);
    // anything else
    // Return false.
    return false;
}
function $fb47edd266a7fc33$export$598e9af52cb9b904(first, second, third) {
    // Look at the first code point:
    // U+002B PLUS SIGN (+)
    // U+002D HYPHEN-MINUS (-)
    if (first === 0x002B || first === 0x002D) {
        // If the second code point is a digit, return true.
        if ($fb47edd266a7fc33$export$727d9dbc4fbb948f(second)) return 2;
        // Otherwise, if the second code point is a U+002E FULL STOP (.)
        // and the third code point is a digit, return true.
        // Otherwise, return false.
        return second === 0x002E && $fb47edd266a7fc33$export$727d9dbc4fbb948f(third) ? 3 : 0;
    }
    // U+002E FULL STOP (.)
    if (first === 0x002E) // If the second code point is a digit, return true. Otherwise, return false.
    return $fb47edd266a7fc33$export$727d9dbc4fbb948f(second) ? 2 : 0;
    // digit
    if ($fb47edd266a7fc33$export$727d9dbc4fbb948f(first)) // Return true.
    return 1;
    // anything else
    // Return false.
    return 0;
}
function $fb47edd266a7fc33$export$da737789103788ca(code) {
    // UTF-16BE
    if (code === 0xFEFF) return 1;
    // UTF-16LE
    if (code === 0xFFFE) return 1;
    return 0;
}
// Fast code category
// Only ASCII code points has a special meaning, that's why we define a maps for 0..127 codes only
const $fb47edd266a7fc33$var$CATEGORY = new Array(0x80);
const $fb47edd266a7fc33$export$2f591833f7f1b967 = 0x80;
const $fb47edd266a7fc33$export$90f8a5e44c6cc5e3 = 0x82;
const $fb47edd266a7fc33$export$bbf58a4a05c6b6e2 = 0x83;
const $fb47edd266a7fc33$export$48d90b0d2444a844 = 0x84;
const $fb47edd266a7fc33$export$deba3a5f607eb19 = 0x85;
for(let i = 0; i < $fb47edd266a7fc33$var$CATEGORY.length; i++)$fb47edd266a7fc33$var$CATEGORY[i] = $fb47edd266a7fc33$export$3c52dd84024ae72c(i) && $fb47edd266a7fc33$export$90f8a5e44c6cc5e3 || $fb47edd266a7fc33$export$727d9dbc4fbb948f(i) && $fb47edd266a7fc33$export$bbf58a4a05c6b6e2 || $fb47edd266a7fc33$export$45a677ea7cb6d5c8(i) && $fb47edd266a7fc33$export$48d90b0d2444a844 || $fb47edd266a7fc33$export$b7ed17c2edb4d953(i) && $fb47edd266a7fc33$export$deba3a5f607eb19 || i || $fb47edd266a7fc33$export$2f591833f7f1b967;
function $fb47edd266a7fc33$export$4b3b0ba223857b61(code) {
    return code < 0x80 ? $fb47edd266a7fc33$var$CATEGORY[code] : $fb47edd266a7fc33$export$48d90b0d2444a844;
}



function $0a1ac1d130312a6d$var$getCharCode(source, offset) {
    return offset < source.length ? source.charCodeAt(offset) : 0;
}
function $0a1ac1d130312a6d$export$2e282c3c0c638f20(source, offset, code) {
    if (code === 13 /* \r */  && $0a1ac1d130312a6d$var$getCharCode(source, offset + 1) === 10 /* \n */ ) return 2;
    return 1;
}
function $0a1ac1d130312a6d$export$6902610076fb2dc1(testStr, offset, referenceCode) {
    let code = testStr.charCodeAt(offset);
    // code.toLowerCase() for A..Z
    if ((0, $fb47edd266a7fc33$export$35784e2518402c99)(code)) code = code | 32;
    return code === referenceCode;
}
function $0a1ac1d130312a6d$export$5bf4b3d0861be8d9(testStr, start, end, referenceStr) {
    if (end - start !== referenceStr.length) return false;
    if (start < 0 || end > testStr.length) return false;
    for(let i = start; i < end; i++){
        const referenceCode = referenceStr.charCodeAt(i - start);
        let testCode = testStr.charCodeAt(i);
        // testCode.toLowerCase() for A..Z
        if ((0, $fb47edd266a7fc33$export$35784e2518402c99)(testCode)) testCode = testCode | 32;
        if (testCode !== referenceCode) return false;
    }
    return true;
}
function $0a1ac1d130312a6d$export$c4eb8307a0331d71(source, offset) {
    for(; offset >= 0; offset--){
        if (!(0, $fb47edd266a7fc33$export$3c52dd84024ae72c)(source.charCodeAt(offset))) break;
    }
    return offset + 1;
}
function $0a1ac1d130312a6d$export$5bd0595948d7ed9(source, offset) {
    for(; offset < source.length; offset++){
        if (!(0, $fb47edd266a7fc33$export$3c52dd84024ae72c)(source.charCodeAt(offset))) break;
    }
    return offset;
}
function $0a1ac1d130312a6d$export$e9aed36b506f417c(source, offset) {
    for(; offset < source.length; offset++){
        if (!(0, $fb47edd266a7fc33$export$727d9dbc4fbb948f)(source.charCodeAt(offset))) break;
    }
    return offset;
}
function $0a1ac1d130312a6d$export$1cf8ac3f090cf48a(source, offset) {
    // It assumes that the U+005C REVERSE SOLIDUS (\) has already been consumed and
    // that the next input code point has already been verified to be part of a valid escape.
    offset += 2;
    // hex digit
    if ((0, $fb47edd266a7fc33$export$2a81dc4d1a2f9334)($0a1ac1d130312a6d$var$getCharCode(source, offset - 1))) {
        // Consume as many hex digits as possible, but no more than 5.
        // Note that this means 1-6 hex digits have been consumed in total.
        for(const maxOffset = Math.min(source.length, offset + 5); offset < maxOffset; offset++){
            if (!(0, $fb47edd266a7fc33$export$2a81dc4d1a2f9334)($0a1ac1d130312a6d$var$getCharCode(source, offset))) break;
        }
        // If the next input code point is whitespace, consume it as well.
        const code = $0a1ac1d130312a6d$var$getCharCode(source, offset);
        if ((0, $fb47edd266a7fc33$export$3c52dd84024ae72c)(code)) offset += $0a1ac1d130312a6d$export$2e282c3c0c638f20(source, offset, code);
    }
    return offset;
}
function $0a1ac1d130312a6d$export$e314ae15c0f41984(source, offset) {
    // Let result initially be an empty string.
    // Repeatedly consume the next input code point from the stream:
    for(; offset < source.length; offset++){
        const code = source.charCodeAt(offset);
        // name code point
        if ((0, $fb47edd266a7fc33$export$998d7ff9801e90bb)(code)) continue;
        // the stream starts with a valid escape
        if ((0, $fb47edd266a7fc33$export$352e2c1d24776bfb)(code, $0a1ac1d130312a6d$var$getCharCode(source, offset + 1))) {
            // Consume an escaped code point. Append the returned code point to result.
            offset = $0a1ac1d130312a6d$export$1cf8ac3f090cf48a(source, offset) - 1;
            continue;
        }
        break;
    }
    return offset;
}
function $0a1ac1d130312a6d$export$b817115b8219186a(source, offset) {
    let code = source.charCodeAt(offset);
    // 2. If the next input code point is U+002B PLUS SIGN (+) or U+002D HYPHEN-MINUS (-),
    // consume it and append it to repr.
    if (code === 0x002B || code === 0x002D) code = source.charCodeAt(offset += 1);
    // 3. While the next input code point is a digit, consume it and append it to repr.
    if ((0, $fb47edd266a7fc33$export$727d9dbc4fbb948f)(code)) {
        offset = $0a1ac1d130312a6d$export$e9aed36b506f417c(source, offset + 1);
        code = source.charCodeAt(offset);
    }
    // 4. If the next 2 input code points are U+002E FULL STOP (.) followed by a digit, then:
    if (code === 0x002E && (0, $fb47edd266a7fc33$export$727d9dbc4fbb948f)(source.charCodeAt(offset + 1))) {
        // 4.1 Consume them.
        // 4.2 Append them to repr.
        offset += 2;
        // 4.3 Set type to "number".
        // TODO
        // 4.4 While the next input code point is a digit, consume it and append it to repr.
        offset = $0a1ac1d130312a6d$export$e9aed36b506f417c(source, offset);
    }
    // 5. If the next 2 or 3 input code points are U+0045 LATIN CAPITAL LETTER E (E)
    // or U+0065 LATIN SMALL LETTER E (e), ... , followed by a digit, then:
    if ($0a1ac1d130312a6d$export$6902610076fb2dc1(source, offset, 101 /* e */ )) {
        let sign = 0;
        code = source.charCodeAt(offset + 1);
        // ... optionally followed by U+002D HYPHEN-MINUS (-) or U+002B PLUS SIGN (+) ...
        if (code === 0x002D || code === 0x002B) {
            sign = 1;
            code = source.charCodeAt(offset + 2);
        }
        // ... followed by a digit
        if ((0, $fb47edd266a7fc33$export$727d9dbc4fbb948f)(code)) // 5.1 Consume them.
        // 5.2 Append them to repr.
        // 5.3 Set type to "number".
        // TODO
        // 5.4 While the next input code point is a digit, consume it and append it to repr.
        offset = $0a1ac1d130312a6d$export$e9aed36b506f417c(source, offset + 1 + sign + 1);
    }
    return offset;
}
function $0a1ac1d130312a6d$export$349fae4425f20458(source, offset) {
    // Repeatedly consume the next input code point from the stream:
    for(; offset < source.length; offset++){
        const code = source.charCodeAt(offset);
        // U+0029 RIGHT PARENTHESIS ())
        // EOF
        if (code === 0x0029) {
            // Return.
            offset++;
            break;
        }
        if ((0, $fb47edd266a7fc33$export$352e2c1d24776bfb)(code, $0a1ac1d130312a6d$var$getCharCode(source, offset + 1))) // Consume an escaped code point.
        // Note: This allows an escaped right parenthesis ("\)") to be encountered
        // without ending the <bad-url-token>. This is otherwise identical to
        // the "anything else" clause.
        offset = $0a1ac1d130312a6d$export$1cf8ac3f090cf48a(source, offset);
    }
    return offset;
}
function $0a1ac1d130312a6d$export$5ed93187f4ce070a(escaped) {
    // Single char escaped that's not a hex digit
    if (escaped.length === 1 && !(0, $fb47edd266a7fc33$export$2a81dc4d1a2f9334)(escaped.charCodeAt(0))) return escaped[0];
    // Interpret the hex digits as a hexadecimal number.
    let code = parseInt(escaped, 16);
    if (code === 0 || // If this number is zero,
    code >= 0xD800 && code <= 0xDFFF || // or is for a surrogate,
    code > 0x10FFFF // or is greater than the maximum allowed code point
    ) // ... return U+FFFD REPLACEMENT CHARACTER
    code = 0xFFFD;
    // Otherwise, return the code point with that value.
    return String.fromCodePoint(code);
}


var $a837ededd9a4d8ce$export$2e2bcd8739ae039 = [
    'EOF-token',
    'ident-token',
    'function-token',
    'at-keyword-token',
    'hash-token',
    'string-token',
    'bad-string-token',
    'url-token',
    'bad-url-token',
    'delim-token',
    'number-token',
    'percentage-token',
    'dimension-token',
    'whitespace-token',
    'CDO-token',
    'CDC-token',
    'colon-token',
    'semicolon-token',
    'comma-token',
    '[-token',
    ']-token',
    '(-token',
    ')-token',
    '{-token',
    '}-token',
    'comment-token'
];


const $294bdda319e98ea4$var$MIN_SIZE = 16384;
function $294bdda319e98ea4$export$cb41ea972ba24ee8(buffer = null, size) {
    if (buffer === null || buffer.length < size) return new Uint32Array(Math.max(size + 1024, $294bdda319e98ea4$var$MIN_SIZE));
    return buffer;
}



const $bc8729f50c1abd04$var$N = 10;
const $bc8729f50c1abd04$var$F = 12;
const $bc8729f50c1abd04$var$R = 13;
function $bc8729f50c1abd04$var$computeLinesAndColumns(host) {
    const source = host.source;
    const sourceLength = source.length;
    const startOffset = source.length > 0 ? (0, $fb47edd266a7fc33$export$da737789103788ca)(source.charCodeAt(0)) : 0;
    const lines = (0, $294bdda319e98ea4$export$cb41ea972ba24ee8)(host.lines, sourceLength);
    const columns = (0, $294bdda319e98ea4$export$cb41ea972ba24ee8)(host.columns, sourceLength);
    let line = host.startLine;
    let column = host.startColumn;
    for(let i = startOffset; i < sourceLength; i++){
        const code = source.charCodeAt(i);
        lines[i] = line;
        columns[i] = column++;
        if (code === $bc8729f50c1abd04$var$N || code === $bc8729f50c1abd04$var$R || code === $bc8729f50c1abd04$var$F) {
            if (code === $bc8729f50c1abd04$var$R && i + 1 < sourceLength && source.charCodeAt(i + 1) === $bc8729f50c1abd04$var$N) {
                i++;
                lines[i] = line;
                columns[i] = column;
            }
            line++;
            column = 1;
        }
    }
    lines[sourceLength] = line;
    columns[sourceLength] = column;
    host.lines = lines;
    host.columns = columns;
    host.computed = true;
}
class $bc8729f50c1abd04$export$a1e9ec249d80652c {
    constructor(source, startOffset, startLine, startColumn){
        this.setSource(source, startOffset, startLine, startColumn);
        this.lines = null;
        this.columns = null;
    }
    setSource(source = '', startOffset = 0, startLine = 1, startColumn = 1) {
        this.source = source;
        this.startOffset = startOffset;
        this.startLine = startLine;
        this.startColumn = startColumn;
        this.computed = false;
    }
    getLocation(offset, filename) {
        if (!this.computed) $bc8729f50c1abd04$var$computeLinesAndColumns(this);
        return {
            source: filename,
            offset: this.startOffset + offset,
            line: this.lines[offset],
            column: this.columns[offset]
        };
    }
    getLocationRange(start, end, filename) {
        if (!this.computed) $bc8729f50c1abd04$var$computeLinesAndColumns(this);
        return {
            source: filename,
            start: {
                offset: this.startOffset + start,
                line: this.lines[start],
                column: this.columns[start]
            },
            end: {
                offset: this.startOffset + end,
                line: this.lines[end],
                column: this.columns[end]
            }
        };
    }
}






const $66a702590f79175c$var$OFFSET_MASK = 0x00FFFFFF;
const $66a702590f79175c$var$TYPE_SHIFT = 24;
const $66a702590f79175c$var$balancePair = new Uint8Array(32); // 32b of memory ought to be enough for anyone (any number of tokens)
$66a702590f79175c$var$balancePair[0, $cb01acaf2e18d562$export$f3890eeaf6851387] = (0, $cb01acaf2e18d562$export$773d33972c6279ed);
$66a702590f79175c$var$balancePair[0, $cb01acaf2e18d562$export$b5a25f132cb53de6] = (0, $cb01acaf2e18d562$export$773d33972c6279ed);
$66a702590f79175c$var$balancePair[0, $cb01acaf2e18d562$export$cd363bb53c2bb] = (0, $cb01acaf2e18d562$export$72f933344f701f30);
$66a702590f79175c$var$balancePair[0, $cb01acaf2e18d562$export$ccdce7304ac66390] = (0, $cb01acaf2e18d562$export$186d8b1f99e2bfec);
function $66a702590f79175c$var$isBlockOpenerToken(tokenType) {
    return $66a702590f79175c$var$balancePair[tokenType] !== 0;
}
class $66a702590f79175c$export$b55edb69cfa7ac57 {
    constructor(source, tokenize){
        this.setSource(source, tokenize);
    }
    reset() {
        this.eof = false;
        this.tokenIndex = -1;
        this.tokenType = 0;
        this.tokenStart = this.firstCharOffset;
        this.tokenEnd = this.firstCharOffset;
    }
    setSource(source = '', tokenize = ()=>{}) {
        source = String(source || '');
        const sourceLength = source.length;
        const offsetAndType = (0, $294bdda319e98ea4$export$cb41ea972ba24ee8)(this.offsetAndType, source.length + 1); // +1 because of eof-token
        const balance = (0, $294bdda319e98ea4$export$cb41ea972ba24ee8)(this.balance, source.length + 1);
        let tokenCount = 0;
        let firstCharOffset = -1;
        let balanceCloseType = 0;
        let balanceStart = source.length;
        // capture buffers
        this.offsetAndType = null;
        this.balance = null;
        balance.fill(0);
        tokenize(source, (type, start, end)=>{
            const index = tokenCount++;
            // type & offset
            offsetAndType[index] = type << $66a702590f79175c$var$TYPE_SHIFT | end;
            if (firstCharOffset === -1) firstCharOffset = start;
            // balance
            balance[index] = balanceStart;
            if (type === balanceCloseType) {
                const prevBalanceStart = balance[balanceStart];
                // set reference to balance end for a block opener
                balance[balanceStart] = index;
                // pop state
                balanceStart = prevBalanceStart;
                balanceCloseType = $66a702590f79175c$var$balancePair[offsetAndType[prevBalanceStart] >> $66a702590f79175c$var$TYPE_SHIFT];
            } else if ($66a702590f79175c$var$isBlockOpenerToken(type)) {
                // push state
                balanceStart = index;
                balanceCloseType = $66a702590f79175c$var$balancePair[type];
            }
        });
        // finalize buffers
        offsetAndType[tokenCount] = (0, $cb01acaf2e18d562$export$c1a09112320b1603) << $66a702590f79175c$var$TYPE_SHIFT | sourceLength; // <EOF-token>
        balance[tokenCount] = tokenCount; // prevents false positive balance match with any token
        // reverse references from balance start to end
        // tokens
        //   token:   a ( [ b c ] d e ) {
        //   index:   0 1 2 3 4 5 6 7 8 9
        // before
        //   balance: 0 8 5 2 2 2 1 1 1 0
        //            - > > < < < < < < -
        // after
        //   balance: 9 8 5 5 5 2 8 8 1 9
        //            > > > > > < > > < >
        for(let i = 0; i < tokenCount; i++){
            const balanceStart = balance[i];
            if (balanceStart <= i) {
                const balanceEnd = balance[balanceStart];
                if (balanceEnd !== i) balance[i] = balanceEnd;
            } else if (balanceStart > tokenCount) balance[i] = tokenCount;
        }
        // balance[0] = tokenCount;
        this.source = source;
        this.firstCharOffset = firstCharOffset === -1 ? 0 : firstCharOffset;
        this.tokenCount = tokenCount;
        this.offsetAndType = offsetAndType;
        this.balance = balance;
        this.reset();
        this.next();
    }
    lookupType(offset) {
        offset += this.tokenIndex;
        if (offset < this.tokenCount) return this.offsetAndType[offset] >> $66a702590f79175c$var$TYPE_SHIFT;
        return 0, $cb01acaf2e18d562$export$c1a09112320b1603;
    }
    lookupTypeNonSC(idx) {
        for(let offset = this.tokenIndex; offset < this.tokenCount; offset++){
            const tokenType = this.offsetAndType[offset] >> $66a702590f79175c$var$TYPE_SHIFT;
            if (tokenType !== (0, $cb01acaf2e18d562$export$fb98946286ab4c97) && tokenType !== (0, $cb01acaf2e18d562$export$4d299b491347818a)) {
                if (idx-- === 0) return tokenType;
            }
        }
        return 0, $cb01acaf2e18d562$export$c1a09112320b1603;
    }
    lookupOffset(offset) {
        offset += this.tokenIndex;
        if (offset < this.tokenCount) return this.offsetAndType[offset - 1] & $66a702590f79175c$var$OFFSET_MASK;
        return this.source.length;
    }
    lookupOffsetNonSC(idx) {
        for(let offset = this.tokenIndex; offset < this.tokenCount; offset++){
            const tokenType = this.offsetAndType[offset] >> $66a702590f79175c$var$TYPE_SHIFT;
            if (tokenType !== (0, $cb01acaf2e18d562$export$fb98946286ab4c97) && tokenType !== (0, $cb01acaf2e18d562$export$4d299b491347818a)) {
                if (idx-- === 0) return offset - this.tokenIndex;
            }
        }
        return 0, $cb01acaf2e18d562$export$c1a09112320b1603;
    }
    lookupValue(offset, referenceStr) {
        offset += this.tokenIndex;
        if (offset < this.tokenCount) return (0, $0a1ac1d130312a6d$export$5bf4b3d0861be8d9)(this.source, this.offsetAndType[offset - 1] & $66a702590f79175c$var$OFFSET_MASK, this.offsetAndType[offset] & $66a702590f79175c$var$OFFSET_MASK, referenceStr);
        return false;
    }
    getTokenStart(tokenIndex) {
        if (tokenIndex === this.tokenIndex) return this.tokenStart;
        if (tokenIndex > 0) return tokenIndex < this.tokenCount ? this.offsetAndType[tokenIndex - 1] & $66a702590f79175c$var$OFFSET_MASK : this.offsetAndType[this.tokenCount] & $66a702590f79175c$var$OFFSET_MASK;
        return this.firstCharOffset;
    }
    substrToCursor(start) {
        return this.source.substring(start, this.tokenStart);
    }
    isBalanceEdge(pos) {
        return this.balance[this.tokenIndex] < pos;
    // return this.balance[this.balance[pos]] !== this.tokenIndex;
    }
    isDelim(code, offset) {
        if (offset) return this.lookupType(offset) === (0, $cb01acaf2e18d562$export$a918ca49ff4337a3) && this.source.charCodeAt(this.lookupOffset(offset)) === code;
        return this.tokenType === (0, $cb01acaf2e18d562$export$a918ca49ff4337a3) && this.source.charCodeAt(this.tokenStart) === code;
    }
    skip(tokenCount) {
        let next = this.tokenIndex + tokenCount;
        if (next < this.tokenCount) {
            this.tokenIndex = next;
            this.tokenStart = this.offsetAndType[next - 1] & $66a702590f79175c$var$OFFSET_MASK;
            next = this.offsetAndType[next];
            this.tokenType = next >> $66a702590f79175c$var$TYPE_SHIFT;
            this.tokenEnd = next & $66a702590f79175c$var$OFFSET_MASK;
        } else {
            this.tokenIndex = this.tokenCount;
            this.next();
        }
    }
    next() {
        let next = this.tokenIndex + 1;
        if (next < this.tokenCount) {
            this.tokenIndex = next;
            this.tokenStart = this.tokenEnd;
            next = this.offsetAndType[next];
            this.tokenType = next >> $66a702590f79175c$var$TYPE_SHIFT;
            this.tokenEnd = next & $66a702590f79175c$var$OFFSET_MASK;
        } else {
            this.eof = true;
            this.tokenIndex = this.tokenCount;
            this.tokenType = (0, $cb01acaf2e18d562$export$c1a09112320b1603);
            this.tokenStart = this.tokenEnd = this.source.length;
        }
    }
    skipSC() {
        while(this.tokenType === (0, $cb01acaf2e18d562$export$fb98946286ab4c97) || this.tokenType === (0, $cb01acaf2e18d562$export$4d299b491347818a))this.next();
    }
    skipUntilBalanced(startToken, stopConsume) {
        let cursor = startToken;
        let balanceEnd = 0;
        let offset = 0;
        loop: for(; cursor < this.tokenCount; cursor++){
            balanceEnd = this.balance[cursor];
            // stop scanning on balance edge that points to offset before start token
            if (balanceEnd < startToken) break loop;
            offset = cursor > 0 ? this.offsetAndType[cursor - 1] & $66a702590f79175c$var$OFFSET_MASK : this.firstCharOffset;
            // check stop condition
            switch(stopConsume(this.source.charCodeAt(offset))){
                case 1:
                    break loop;
                case 2:
                    cursor++;
                    break loop;
                default:
                    // fast forward to the end of balanced block for an open block tokens
                    if ($66a702590f79175c$var$isBlockOpenerToken(this.offsetAndType[cursor] >> $66a702590f79175c$var$TYPE_SHIFT)) cursor = balanceEnd;
            }
        }
        this.skip(cursor - this.tokenIndex);
    }
    forEachToken(fn) {
        for(let i = 0, offset = this.firstCharOffset; i < this.tokenCount; i++){
            const start = offset;
            const item = this.offsetAndType[i];
            const end = item & $66a702590f79175c$var$OFFSET_MASK;
            const type = item >> $66a702590f79175c$var$TYPE_SHIFT;
            offset = end;
            fn(type, start, end, i);
        }
    }
    dump() {
        const tokens = new Array(this.tokenCount);
        this.forEachToken((type, start, end, index)=>{
            tokens[index] = {
                idx: index,
                type: (0, $a837ededd9a4d8ce$export$2e2bcd8739ae039)[type],
                chunk: this.source.substring(start, end),
                balance: this.balance[index]
            };
        });
        return tokens;
    }
}


function $852eae0c0686a388$export$660b2ee2d4fb4eff(source, onToken) {
    function getCharCode(offset) {
        return offset < sourceLength ? source.charCodeAt(offset) : 0;
    }
    // § 4.3.3. Consume a numeric token
    function consumeNumericToken() {
        // Consume a number and let number be the result.
        offset = (0, $0a1ac1d130312a6d$export$b817115b8219186a)(source, offset);
        // If the next 3 input code points would start an identifier, then:
        if ((0, $fb47edd266a7fc33$export$56b48cc5d7560ffb)(getCharCode(offset), getCharCode(offset + 1), getCharCode(offset + 2))) {
            // Create a <dimension-token> with the same value and type flag as number, and a unit set initially to the empty string.
            // Consume a name. Set the <dimension-token>’s unit to the returned value.
            // Return the <dimension-token>.
            type = $cb01acaf2e18d562$export$c940ece961bc43c6;
            offset = (0, $0a1ac1d130312a6d$export$e314ae15c0f41984)(source, offset);
            return;
        }
        // Otherwise, if the next input code point is U+0025 PERCENTAGE SIGN (%), consume it.
        if (getCharCode(offset) === 0x0025) {
            // Create a <percentage-token> with the same value as number, and return it.
            type = $cb01acaf2e18d562$export$d11913f8a6922aea;
            offset++;
            return;
        }
        // Otherwise, create a <number-token> with the same value and type flag as number, and return it.
        type = $cb01acaf2e18d562$export$fffa67e515d04022;
    }
    // § 4.3.4. Consume an ident-like token
    function consumeIdentLikeToken() {
        const nameStartOffset = offset;
        // Consume a name, and let string be the result.
        offset = (0, $0a1ac1d130312a6d$export$e314ae15c0f41984)(source, offset);
        // If string’s value is an ASCII case-insensitive match for "url",
        // and the next input code point is U+0028 LEFT PARENTHESIS ((), consume it.
        if ((0, $0a1ac1d130312a6d$export$5bf4b3d0861be8d9)(source, nameStartOffset, offset, 'url') && getCharCode(offset) === 0x0028) {
            // While the next two input code points are whitespace, consume the next input code point.
            offset = (0, $0a1ac1d130312a6d$export$5bd0595948d7ed9)(source, offset + 1);
            // If the next one or two input code points are U+0022 QUOTATION MARK ("), U+0027 APOSTROPHE ('),
            // or whitespace followed by U+0022 QUOTATION MARK (") or U+0027 APOSTROPHE ('),
            // then create a <function-token> with its value set to string and return it.
            if (getCharCode(offset) === 0x0022 || getCharCode(offset) === 0x0027) {
                type = $cb01acaf2e18d562$export$f3890eeaf6851387;
                offset = nameStartOffset + 4;
                return;
            }
            // Otherwise, consume a url token, and return it.
            consumeUrlToken();
            return;
        }
        // Otherwise, if the next input code point is U+0028 LEFT PARENTHESIS ((), consume it.
        // Create a <function-token> with its value set to string and return it.
        if (getCharCode(offset) === 0x0028) {
            type = $cb01acaf2e18d562$export$f3890eeaf6851387;
            offset++;
            return;
        }
        // Otherwise, create an <ident-token> with its value set to string and return it.
        type = $cb01acaf2e18d562$export$331e9b6bdecaac5f;
    }
    // § 4.3.5. Consume a string token
    function consumeStringToken(endingCodePoint) {
        // This algorithm may be called with an ending code point, which denotes the code point
        // that ends the string. If an ending code point is not specified,
        // the current input code point is used.
        if (!endingCodePoint) endingCodePoint = getCharCode(offset++);
        // Initially create a <string-token> with its value set to the empty string.
        type = $cb01acaf2e18d562$export$89b8e0fa65f6a914;
        // Repeatedly consume the next input code point from the stream:
        for(; offset < source.length; offset++){
            const code = source.charCodeAt(offset);
            switch((0, $fb47edd266a7fc33$export$4b3b0ba223857b61)(code)){
                // ending code point
                case endingCodePoint:
                    // Return the <string-token>.
                    offset++;
                    return;
                // EOF
                // case EofCategory:
                // This is a parse error. Return the <string-token>.
                // return;
                // newline
                case 0, $fb47edd266a7fc33$export$90f8a5e44c6cc5e3:
                    if ((0, $fb47edd266a7fc33$export$c6b40e80adfef3ae)(code)) {
                        // This is a parse error. Reconsume the current input code point,
                        // create a <bad-string-token>, and return it.
                        offset += (0, $0a1ac1d130312a6d$export$2e282c3c0c638f20)(source, offset, code);
                        type = $cb01acaf2e18d562$export$d273d1be20da6de2;
                        return;
                    }
                    break;
                // U+005C REVERSE SOLIDUS (\)
                case 0x005C:
                    // If the next input code point is EOF, do nothing.
                    if (offset === source.length - 1) break;
                    const nextCode = getCharCode(offset + 1);
                    // Otherwise, if the next input code point is a newline, consume it.
                    if ((0, $fb47edd266a7fc33$export$c6b40e80adfef3ae)(nextCode)) offset += (0, $0a1ac1d130312a6d$export$2e282c3c0c638f20)(source, offset + 1, nextCode);
                    else if ((0, $fb47edd266a7fc33$export$352e2c1d24776bfb)(code, nextCode)) // Otherwise, (the stream starts with a valid escape) consume
                    // an escaped code point and append the returned code point to
                    // the <string-token>’s value.
                    offset = (0, $0a1ac1d130312a6d$export$1cf8ac3f090cf48a)(source, offset) - 1;
                    break;
            }
        }
    }
    // § 4.3.6. Consume a url token
    // Note: This algorithm assumes that the initial "url(" has already been consumed.
    // This algorithm also assumes that it’s being called to consume an "unquoted" value, like url(foo).
    // A quoted value, like url("foo"), is parsed as a <function-token>. Consume an ident-like token
    // automatically handles this distinction; this algorithm shouldn’t be called directly otherwise.
    function consumeUrlToken() {
        // Initially create a <url-token> with its value set to the empty string.
        type = $cb01acaf2e18d562$export$59d795186a5d3f58;
        // Consume as much whitespace as possible.
        offset = (0, $0a1ac1d130312a6d$export$5bd0595948d7ed9)(source, offset);
        // Repeatedly consume the next input code point from the stream:
        for(; offset < source.length; offset++){
            const code = source.charCodeAt(offset);
            switch((0, $fb47edd266a7fc33$export$4b3b0ba223857b61)(code)){
                // U+0029 RIGHT PARENTHESIS ())
                case 0x0029:
                    // Return the <url-token>.
                    offset++;
                    return;
                // EOF
                // case EofCategory:
                // This is a parse error. Return the <url-token>.
                // return;
                // whitespace
                case 0, $fb47edd266a7fc33$export$90f8a5e44c6cc5e3:
                    // Consume as much whitespace as possible.
                    offset = (0, $0a1ac1d130312a6d$export$5bd0595948d7ed9)(source, offset);
                    // If the next input code point is U+0029 RIGHT PARENTHESIS ()) or EOF,
                    // consume it and return the <url-token>
                    // (if EOF was encountered, this is a parse error);
                    if (getCharCode(offset) === 0x0029 || offset >= source.length) {
                        if (offset < source.length) offset++;
                        return;
                    }
                    // otherwise, consume the remnants of a bad url, create a <bad-url-token>,
                    // and return it.
                    offset = (0, $0a1ac1d130312a6d$export$349fae4425f20458)(source, offset);
                    type = $cb01acaf2e18d562$export$f8b4878501aa4a62;
                    return;
                // U+0022 QUOTATION MARK (")
                // U+0027 APOSTROPHE (')
                // U+0028 LEFT PARENTHESIS (()
                // non-printable code point
                case 0x0022:
                case 0x0027:
                case 0x0028:
                case 0, $fb47edd266a7fc33$export$deba3a5f607eb19:
                    // This is a parse error. Consume the remnants of a bad url,
                    // create a <bad-url-token>, and return it.
                    offset = (0, $0a1ac1d130312a6d$export$349fae4425f20458)(source, offset);
                    type = $cb01acaf2e18d562$export$f8b4878501aa4a62;
                    return;
                // U+005C REVERSE SOLIDUS (\)
                case 0x005C:
                    // If the stream starts with a valid escape, consume an escaped code point and
                    // append the returned code point to the <url-token>’s value.
                    if ((0, $fb47edd266a7fc33$export$352e2c1d24776bfb)(code, getCharCode(offset + 1))) {
                        offset = (0, $0a1ac1d130312a6d$export$1cf8ac3f090cf48a)(source, offset) - 1;
                        break;
                    }
                    // Otherwise, this is a parse error. Consume the remnants of a bad url,
                    // create a <bad-url-token>, and return it.
                    offset = (0, $0a1ac1d130312a6d$export$349fae4425f20458)(source, offset);
                    type = $cb01acaf2e18d562$export$f8b4878501aa4a62;
                    return;
            }
        }
    }
    // ensure source is a string
    source = String(source || '');
    const sourceLength = source.length;
    let start = (0, $fb47edd266a7fc33$export$da737789103788ca)(getCharCode(0));
    let offset = start;
    let type;
    // https://drafts.csswg.org/css-syntax-3/#consume-token
    // § 4.3.1. Consume a token
    while(offset < sourceLength){
        const code = source.charCodeAt(offset);
        switch((0, $fb47edd266a7fc33$export$4b3b0ba223857b61)(code)){
            // whitespace
            case 0, $fb47edd266a7fc33$export$90f8a5e44c6cc5e3:
                // Consume as much whitespace as possible. Return a <whitespace-token>.
                type = $cb01acaf2e18d562$export$fb98946286ab4c97;
                offset = (0, $0a1ac1d130312a6d$export$5bd0595948d7ed9)(source, offset + 1);
                break;
            // U+0022 QUOTATION MARK (")
            case 0x0022:
                // Consume a string token and return it.
                consumeStringToken();
                break;
            // U+0023 NUMBER SIGN (#)
            case 0x0023:
                // If the next input code point is a name code point or the next two input code points are a valid escape, then:
                if ((0, $fb47edd266a7fc33$export$998d7ff9801e90bb)(getCharCode(offset + 1)) || (0, $fb47edd266a7fc33$export$352e2c1d24776bfb)(getCharCode(offset + 1), getCharCode(offset + 2))) {
                    // Create a <hash-token>.
                    type = $cb01acaf2e18d562$export$ab85ecd77ce6a5cd;
                    // If the next 3 input code points would start an identifier, set the <hash-token>’s type flag to "id".
                    // if (isIdentifierStart(getCharCode(offset + 1), getCharCode(offset + 2), getCharCode(offset + 3))) {
                    //     // TODO: set id flag
                    // }
                    // Consume a name, and set the <hash-token>’s value to the returned string.
                    offset = (0, $0a1ac1d130312a6d$export$e314ae15c0f41984)(source, offset + 1);
                // Return the <hash-token>.
                } else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = $cb01acaf2e18d562$export$a918ca49ff4337a3;
                    offset++;
                }
                break;
            // U+0027 APOSTROPHE (')
            case 0x0027:
                // Consume a string token and return it.
                consumeStringToken();
                break;
            // U+0028 LEFT PARENTHESIS (()
            case 0x0028:
                // Return a <(-token>.
                type = $cb01acaf2e18d562$export$b5a25f132cb53de6;
                offset++;
                break;
            // U+0029 RIGHT PARENTHESIS ())
            case 0x0029:
                // Return a <)-token>.
                type = $cb01acaf2e18d562$export$773d33972c6279ed;
                offset++;
                break;
            // U+002B PLUS SIGN (+)
            case 0x002B:
                // If the input stream starts with a number, ...
                if ((0, $fb47edd266a7fc33$export$598e9af52cb9b904)(code, getCharCode(offset + 1), getCharCode(offset + 2))) // ... reconsume the current input code point, consume a numeric token, and return it.
                consumeNumericToken();
                else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = $cb01acaf2e18d562$export$a918ca49ff4337a3;
                    offset++;
                }
                break;
            // U+002C COMMA (,)
            case 0x002C:
                // Return a <comma-token>.
                type = $cb01acaf2e18d562$export$c06e3ee3b4d233fa;
                offset++;
                break;
            // U+002D HYPHEN-MINUS (-)
            case 0x002D:
                // If the input stream starts with a number, reconsume the current input code point, consume a numeric token, and return it.
                if ((0, $fb47edd266a7fc33$export$598e9af52cb9b904)(code, getCharCode(offset + 1), getCharCode(offset + 2))) consumeNumericToken();
                else {
                    // Otherwise, if the next 2 input code points are U+002D HYPHEN-MINUS U+003E GREATER-THAN SIGN (->), consume them and return a <CDC-token>.
                    if (getCharCode(offset + 1) === 0x002D && getCharCode(offset + 2) === 0x003E) {
                        type = $cb01acaf2e18d562$export$b0b2bd2d1777c179;
                        offset = offset + 3;
                    } else // Otherwise, if the input stream starts with an identifier, ...
                    if ((0, $fb47edd266a7fc33$export$56b48cc5d7560ffb)(code, getCharCode(offset + 1), getCharCode(offset + 2))) // ... reconsume the current input code point, consume an ident-like token, and return it.
                    consumeIdentLikeToken();
                    else {
                        // Otherwise, return a <delim-token> with its value set to the current input code point.
                        type = $cb01acaf2e18d562$export$a918ca49ff4337a3;
                        offset++;
                    }
                }
                break;
            // U+002E FULL STOP (.)
            case 0x002E:
                // If the input stream starts with a number, ...
                if ((0, $fb47edd266a7fc33$export$598e9af52cb9b904)(code, getCharCode(offset + 1), getCharCode(offset + 2))) // ... reconsume the current input code point, consume a numeric token, and return it.
                consumeNumericToken();
                else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = $cb01acaf2e18d562$export$a918ca49ff4337a3;
                    offset++;
                }
                break;
            // U+002F SOLIDUS (/)
            case 0x002F:
                // If the next two input code point are U+002F SOLIDUS (/) followed by a U+002A ASTERISK (*),
                if (getCharCode(offset + 1) === 0x002A) {
                    // ... consume them and all following code points up to and including the first U+002A ASTERISK (*)
                    // followed by a U+002F SOLIDUS (/), or up to an EOF code point.
                    type = $cb01acaf2e18d562$export$4d299b491347818a;
                    offset = source.indexOf('*/', offset + 2);
                    offset = offset === -1 ? source.length : offset + 2;
                } else {
                    type = $cb01acaf2e18d562$export$a918ca49ff4337a3;
                    offset++;
                }
                break;
            // U+003A COLON (:)
            case 0x003A:
                // Return a <colon-token>.
                type = $cb01acaf2e18d562$export$e20ebb298016f6;
                offset++;
                break;
            // U+003B SEMICOLON (;)
            case 0x003B:
                // Return a <semicolon-token>.
                type = $cb01acaf2e18d562$export$bedd8b9b04d9dbd;
                offset++;
                break;
            // U+003C LESS-THAN SIGN (<)
            case 0x003C:
                // If the next 3 input code points are U+0021 EXCLAMATION MARK U+002D HYPHEN-MINUS U+002D HYPHEN-MINUS (!--), ...
                if (getCharCode(offset + 1) === 0x0021 && getCharCode(offset + 2) === 0x002D && getCharCode(offset + 3) === 0x002D) {
                    // ... consume them and return a <CDO-token>.
                    type = $cb01acaf2e18d562$export$521ef26a3002003b;
                    offset = offset + 4;
                } else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = $cb01acaf2e18d562$export$a918ca49ff4337a3;
                    offset++;
                }
                break;
            // U+0040 COMMERCIAL AT (@)
            case 0x0040:
                // If the next 3 input code points would start an identifier, ...
                if ((0, $fb47edd266a7fc33$export$56b48cc5d7560ffb)(getCharCode(offset + 1), getCharCode(offset + 2), getCharCode(offset + 3))) {
                    // ... consume a name, create an <at-keyword-token> with its value set to the returned value, and return it.
                    type = $cb01acaf2e18d562$export$21bfcb60d1b5ccac;
                    offset = (0, $0a1ac1d130312a6d$export$e314ae15c0f41984)(source, offset + 1);
                } else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = $cb01acaf2e18d562$export$a918ca49ff4337a3;
                    offset++;
                }
                break;
            // U+005B LEFT SQUARE BRACKET ([)
            case 0x005B:
                // Return a <[-token>.
                type = $cb01acaf2e18d562$export$cd363bb53c2bb;
                offset++;
                break;
            // U+005C REVERSE SOLIDUS (\)
            case 0x005C:
                // If the input stream starts with a valid escape, ...
                if ((0, $fb47edd266a7fc33$export$352e2c1d24776bfb)(code, getCharCode(offset + 1))) // ... reconsume the current input code point, consume an ident-like token, and return it.
                consumeIdentLikeToken();
                else {
                    // Otherwise, this is a parse error. Return a <delim-token> with its value set to the current input code point.
                    type = $cb01acaf2e18d562$export$a918ca49ff4337a3;
                    offset++;
                }
                break;
            // U+005D RIGHT SQUARE BRACKET (])
            case 0x005D:
                // Return a <]-token>.
                type = $cb01acaf2e18d562$export$72f933344f701f30;
                offset++;
                break;
            // U+007B LEFT CURLY BRACKET ({)
            case 0x007B:
                // Return a <{-token>.
                type = $cb01acaf2e18d562$export$ccdce7304ac66390;
                offset++;
                break;
            // U+007D RIGHT CURLY BRACKET (})
            case 0x007D:
                // Return a <}-token>.
                type = $cb01acaf2e18d562$export$186d8b1f99e2bfec;
                offset++;
                break;
            // digit
            case 0, $fb47edd266a7fc33$export$bbf58a4a05c6b6e2:
                // Reconsume the current input code point, consume a numeric token, and return it.
                consumeNumericToken();
                break;
            // name-start code point
            case 0, $fb47edd266a7fc33$export$48d90b0d2444a844:
                // Reconsume the current input code point, consume an ident-like token, and return it.
                consumeIdentLikeToken();
                break;
            // EOF
            // case EofCategory:
            // Return an <EOF-token>.
            // break;
            // anything else
            default:
                // Return a <delim-token> with its value set to the current input code point.
                type = $cb01acaf2e18d562$export$a918ca49ff4337a3;
                offset++;
        }
        // put token to stream
        onToken(type, start, start = offset);
    }
}


//
//                              list
//                            ┌──────┐
//             ┌──────────────┼─head │
//             │              │ tail─┼──────────────┐
//             │              └──────┘              │
//             ▼                                    ▼
//            item        item        item        item
//          ┌──────┐    ┌──────┐    ┌──────┐    ┌──────┐
//  null ◀──┼─prev │◀───┼─prev │◀───┼─prev │◀───┼─prev │
//          │ next─┼───▶│ next─┼───▶│ next─┼───▶│ next─┼──▶ null
//          ├──────┤    ├──────┤    ├──────┤    ├──────┤
//          │ data │    │ data │    │ data │    │ data │
//          └──────┘    └──────┘    └──────┘    └──────┘
//
let $2836a6e7287d8f5c$var$releasedCursors = null;
class $2836a6e7287d8f5c$export$54c2e3dc7acea9f5 {
    static createItem(data) {
        return {
            prev: null,
            next: null,
            data: data
        };
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.cursor = null;
    }
    createItem(data) {
        return $2836a6e7287d8f5c$export$54c2e3dc7acea9f5.createItem(data);
    }
    // cursor helpers
    allocateCursor(prev, next) {
        let cursor;
        if ($2836a6e7287d8f5c$var$releasedCursors !== null) {
            cursor = $2836a6e7287d8f5c$var$releasedCursors;
            $2836a6e7287d8f5c$var$releasedCursors = $2836a6e7287d8f5c$var$releasedCursors.cursor;
            cursor.prev = prev;
            cursor.next = next;
            cursor.cursor = this.cursor;
        } else cursor = {
            prev: prev,
            next: next,
            cursor: this.cursor
        };
        this.cursor = cursor;
        return cursor;
    }
    releaseCursor() {
        const { cursor: cursor } = this;
        this.cursor = cursor.cursor;
        cursor.prev = null;
        cursor.next = null;
        cursor.cursor = $2836a6e7287d8f5c$var$releasedCursors;
        $2836a6e7287d8f5c$var$releasedCursors = cursor;
    }
    updateCursors(prevOld, prevNew, nextOld, nextNew) {
        let { cursor: cursor } = this;
        while(cursor !== null){
            if (cursor.prev === prevOld) cursor.prev = prevNew;
            if (cursor.next === nextOld) cursor.next = nextNew;
            cursor = cursor.cursor;
        }
    }
    *[Symbol.iterator]() {
        for(let cursor = this.head; cursor !== null; cursor = cursor.next)yield cursor.data;
    }
    // getters
    get size() {
        let size = 0;
        for(let cursor = this.head; cursor !== null; cursor = cursor.next)size++;
        return size;
    }
    get isEmpty() {
        return this.head === null;
    }
    get first() {
        return this.head && this.head.data;
    }
    get last() {
        return this.tail && this.tail.data;
    }
    // convertors
    fromArray(array) {
        let cursor = null;
        this.head = null;
        for (let data of array){
            const item = $2836a6e7287d8f5c$export$54c2e3dc7acea9f5.createItem(data);
            if (cursor !== null) cursor.next = item;
            else this.head = item;
            item.prev = cursor;
            cursor = item;
        }
        this.tail = cursor;
        return this;
    }
    toArray() {
        return [
            ...this
        ];
    }
    toJSON() {
        return [
            ...this
        ];
    }
    // array-like methods
    forEach(fn, thisArg = this) {
        // push cursor
        const cursor = this.allocateCursor(null, this.head);
        while(cursor.next !== null){
            const item = cursor.next;
            cursor.next = item.next;
            fn.call(thisArg, item.data, item, this);
        }
        // pop cursor
        this.releaseCursor();
    }
    forEachRight(fn, thisArg = this) {
        // push cursor
        const cursor = this.allocateCursor(this.tail, null);
        while(cursor.prev !== null){
            const item = cursor.prev;
            cursor.prev = item.prev;
            fn.call(thisArg, item.data, item, this);
        }
        // pop cursor
        this.releaseCursor();
    }
    reduce(fn, initialValue, thisArg = this) {
        // push cursor
        let cursor = this.allocateCursor(null, this.head);
        let acc = initialValue;
        let item;
        while(cursor.next !== null){
            item = cursor.next;
            cursor.next = item.next;
            acc = fn.call(thisArg, acc, item.data, item, this);
        }
        // pop cursor
        this.releaseCursor();
        return acc;
    }
    reduceRight(fn, initialValue, thisArg = this) {
        // push cursor
        let cursor = this.allocateCursor(this.tail, null);
        let acc = initialValue;
        let item;
        while(cursor.prev !== null){
            item = cursor.prev;
            cursor.prev = item.prev;
            acc = fn.call(thisArg, acc, item.data, item, this);
        }
        // pop cursor
        this.releaseCursor();
        return acc;
    }
    some(fn, thisArg = this) {
        for(let cursor = this.head; cursor !== null; cursor = cursor.next){
            if (fn.call(thisArg, cursor.data, cursor, this)) return true;
        }
        return false;
    }
    map(fn, thisArg = this) {
        const result = new $2836a6e7287d8f5c$export$54c2e3dc7acea9f5();
        for(let cursor = this.head; cursor !== null; cursor = cursor.next)result.appendData(fn.call(thisArg, cursor.data, cursor, this));
        return result;
    }
    filter(fn, thisArg = this) {
        const result = new $2836a6e7287d8f5c$export$54c2e3dc7acea9f5();
        for(let cursor = this.head; cursor !== null; cursor = cursor.next)if (fn.call(thisArg, cursor.data, cursor, this)) result.appendData(cursor.data);
        return result;
    }
    nextUntil(start, fn, thisArg = this) {
        if (start === null) return;
        // push cursor
        const cursor = this.allocateCursor(null, start);
        while(cursor.next !== null){
            const item = cursor.next;
            cursor.next = item.next;
            if (fn.call(thisArg, item.data, item, this)) break;
        }
        // pop cursor
        this.releaseCursor();
    }
    prevUntil(start, fn, thisArg = this) {
        if (start === null) return;
        // push cursor
        const cursor = this.allocateCursor(start, null);
        while(cursor.prev !== null){
            const item = cursor.prev;
            cursor.prev = item.prev;
            if (fn.call(thisArg, item.data, item, this)) break;
        }
        // pop cursor
        this.releaseCursor();
    }
    // mutation
    clear() {
        this.head = null;
        this.tail = null;
    }
    copy() {
        const result = new $2836a6e7287d8f5c$export$54c2e3dc7acea9f5();
        for (let data of this)result.appendData(data);
        return result;
    }
    prepend(item) {
        //      head
        //    ^
        // item
        this.updateCursors(null, item, this.head, item);
        // insert to the beginning of the list
        if (this.head !== null) {
            // new item <- first item
            this.head.prev = item;
            // new item -> first item
            item.next = this.head;
        } else // if list has no head, then it also has no tail
        // in this case tail points to the new item
        this.tail = item;
        // head always points to new item
        this.head = item;
        return this;
    }
    prependData(data) {
        return this.prepend($2836a6e7287d8f5c$export$54c2e3dc7acea9f5.createItem(data));
    }
    append(item) {
        return this.insert(item);
    }
    appendData(data) {
        return this.insert($2836a6e7287d8f5c$export$54c2e3dc7acea9f5.createItem(data));
    }
    insert(item, before = null) {
        if (before !== null) {
            // prev   before
            //      ^
            //     item
            this.updateCursors(before.prev, item, before, item);
            if (before.prev === null) {
                // insert to the beginning of list
                if (this.head !== before) throw new Error('before doesn\'t belong to list');
                // since head points to before therefore list doesn't empty
                // no need to check tail
                this.head = item;
                before.prev = item;
                item.next = before;
                this.updateCursors(null, item);
            } else {
                // insert between two items
                before.prev.next = item;
                item.prev = before.prev;
                before.prev = item;
                item.next = before;
            }
        } else {
            // tail
            //      ^
            //      item
            this.updateCursors(this.tail, item, null, item);
            // insert to the ending of the list
            if (this.tail !== null) {
                // last item -> new item
                this.tail.next = item;
                // last item <- new item
                item.prev = this.tail;
            } else // if list has no tail, then it also has no head
            // in this case head points to new item
            this.head = item;
            // tail always points to new item
            this.tail = item;
        }
        return this;
    }
    insertData(data, before) {
        return this.insert($2836a6e7287d8f5c$export$54c2e3dc7acea9f5.createItem(data), before);
    }
    remove(item) {
        //      item
        //       ^
        // prev     next
        this.updateCursors(item, item.prev, item, item.next);
        if (item.prev !== null) item.prev.next = item.next;
        else {
            if (this.head !== item) throw new Error('item doesn\'t belong to list');
            this.head = item.next;
        }
        if (item.next !== null) item.next.prev = item.prev;
        else {
            if (this.tail !== item) throw new Error('item doesn\'t belong to list');
            this.tail = item.prev;
        }
        item.prev = null;
        item.next = null;
        return item;
    }
    push(data) {
        this.insert($2836a6e7287d8f5c$export$54c2e3dc7acea9f5.createItem(data));
    }
    pop() {
        return this.tail !== null ? this.remove(this.tail) : null;
    }
    unshift(data) {
        this.prepend($2836a6e7287d8f5c$export$54c2e3dc7acea9f5.createItem(data));
    }
    shift() {
        return this.head !== null ? this.remove(this.head) : null;
    }
    prependList(list) {
        return this.insertList(list, this.head);
    }
    appendList(list) {
        return this.insertList(list);
    }
    insertList(list, before) {
        // ignore empty lists
        if (list.head === null) return this;
        if (before !== undefined && before !== null) {
            this.updateCursors(before.prev, list.tail, before, list.head);
            // insert in the middle of dist list
            if (before.prev !== null) {
                // before.prev <-> list.head
                before.prev.next = list.head;
                list.head.prev = before.prev;
            } else this.head = list.head;
            before.prev = list.tail;
            list.tail.next = before;
        } else {
            this.updateCursors(this.tail, list.tail, null, list.head);
            // insert to end of the list
            if (this.tail !== null) {
                // if destination list has a tail, then it also has a head,
                // but head doesn't change
                // dest tail -> source head
                this.tail.next = list.head;
                // dest tail <- source head
                list.head.prev = this.tail;
            } else // if list has no a tail, then it also has no a head
            // in this case points head to new item
            this.head = list.head;
            // tail always start point to new item
            this.tail = list.tail;
        }
        list.head = null;
        list.tail = null;
        return this;
    }
    replace(oldItem, newItemOrList) {
        if ('head' in newItemOrList) this.insertList(newItemOrList, oldItem);
        else this.insert(newItemOrList, oldItem);
        this.remove(oldItem);
    }
}


function $213a7d565abe4f4a$export$435492119a21bab3(name, message) {
    // use Object.create(), because some VMs prevent setting line/column otherwise
    // (iOS Safari 10 even throws an exception)
    const error = Object.create(SyntaxError.prototype);
    const errorStack = new Error();
    return Object.assign(error, {
        name: name,
        message: message,
        get stack () {
            return (errorStack.stack || '').replace(/^(.+\n){1,3}/, `${name}: ${message}\n`);
        }
    });
}


const $d25a1e4247862d73$var$MAX_LINE_LENGTH = 100;
const $d25a1e4247862d73$var$OFFSET_CORRECTION = 60;
const $d25a1e4247862d73$var$TAB_REPLACEMENT = '    ';
function $d25a1e4247862d73$var$sourceFragment({ source: source, line: line, column: column, baseLine: baseLine, baseColumn: baseColumn }, extraLines) {
    function processLines(start, end) {
        return lines.slice(start, end).map((line, idx)=>String(start + idx + 1).padStart(maxNumLength) + ' |' + line).join('\n');
    }
    const prelines = '\n'.repeat(Math.max(baseLine - 1, 0));
    const precolumns = ' '.repeat(Math.max(baseColumn - 1, 0));
    const lines = (prelines + precolumns + source).split(/\r\n?|\n|\f/);
    const startLine = Math.max(1, line - extraLines) - 1;
    const endLine = Math.min(line + extraLines, lines.length + 1);
    const maxNumLength = Math.max(4, String(endLine).length) + 1;
    let cutLeft = 0;
    // column correction according to replaced tab before column
    column += ($d25a1e4247862d73$var$TAB_REPLACEMENT.length - 1) * (lines[line - 1].substr(0, column - 1).match(/\t/g) || []).length;
    if (column > $d25a1e4247862d73$var$MAX_LINE_LENGTH) {
        cutLeft = column - $d25a1e4247862d73$var$OFFSET_CORRECTION + 3;
        column = $d25a1e4247862d73$var$OFFSET_CORRECTION - 2;
    }
    for(let i = startLine; i <= endLine; i++)if (i >= 0 && i < lines.length) {
        lines[i] = lines[i].replace(/\t/g, $d25a1e4247862d73$var$TAB_REPLACEMENT);
        lines[i] = (cutLeft > 0 && lines[i].length > cutLeft ? '\u2026' : '') + lines[i].substr(cutLeft, $d25a1e4247862d73$var$MAX_LINE_LENGTH - 2) + (lines[i].length > cutLeft + $d25a1e4247862d73$var$MAX_LINE_LENGTH - 1 ? '\u2026' : '');
    }
    return [
        processLines(startLine, line),
        new Array(column + maxNumLength + 2).join('-') + '^',
        processLines(line, endLine)
    ].filter(Boolean).join('\n').replace(/^(\s+\d+\s+\|\n)+/, '').replace(/\n(\s+\d+\s+\|)+$/, '');
}
function $d25a1e4247862d73$export$f21cea08b0dd60e8(message, source, offset, line, column, baseLine = 1, baseColumn = 1) {
    const error = Object.assign((0, $213a7d565abe4f4a$export$435492119a21bab3)('SyntaxError', message), {
        source: source,
        offset: offset,
        line: line,
        column: column,
        sourceFragment (extraLines) {
            return $d25a1e4247862d73$var$sourceFragment({
                source: source,
                line: line,
                column: column,
                baseLine: baseLine,
                baseColumn: baseColumn
            }, isNaN(extraLines) ? 0 : extraLines);
        },
        get formattedMessage () {
            return `Parse error: ${message}\n` + $d25a1e4247862d73$var$sourceFragment({
                source: source,
                line: line,
                column: column,
                baseLine: baseLine,
                baseColumn: baseColumn
            }, 2);
        }
    });
    return error;
}




function $86642271d35ae140$export$edc1450f8a1049b2(recognizer) {
    const children = this.createList();
    let space = false;
    const context = {
        recognizer: recognizer
    };
    while(!this.eof){
        switch(this.tokenType){
            case 0, $cb01acaf2e18d562$export$4d299b491347818a:
                this.next();
                continue;
            case 0, $cb01acaf2e18d562$export$fb98946286ab4c97:
                space = true;
                this.next();
                continue;
        }
        let child = recognizer.getNode.call(this, context);
        if (child === undefined) break;
        if (space) {
            if (recognizer.onWhiteSpace) recognizer.onWhiteSpace.call(this, child, children, context);
            space = false;
        }
        children.push(child);
    }
    if (space && recognizer.onWhiteSpace) recognizer.onWhiteSpace.call(this, null, children, context);
    return children;
}


const $b489d312071c19a3$var$NOOP = ()=>{};
const $b489d312071c19a3$var$EXCLAMATIONMARK = 0x0021; // U+0021 EXCLAMATION MARK (!)
const $b489d312071c19a3$var$NUMBERSIGN = 0x0023; // U+0023 NUMBER SIGN (#)
const $b489d312071c19a3$var$SEMICOLON = 0x003B; // U+003B SEMICOLON (;)
const $b489d312071c19a3$var$LEFTCURLYBRACKET = 0x007B; // U+007B LEFT CURLY BRACKET ({)
const $b489d312071c19a3$var$NULL = 0;
function $b489d312071c19a3$var$createParseContext(name) {
    return function() {
        return this[name]();
    };
}
function $b489d312071c19a3$var$fetchParseValues(dict) {
    const result = Object.create(null);
    for (const name of Object.keys(dict)){
        const item = dict[name];
        const fn = item.parse || item;
        if (fn) result[name] = fn;
    }
    return result;
}
function $b489d312071c19a3$var$processConfig(config) {
    const parseConfig = {
        context: Object.create(null),
        features: Object.assign(Object.create(null), config.features),
        scope: Object.assign(Object.create(null), config.scope),
        atrule: $b489d312071c19a3$var$fetchParseValues(config.atrule),
        pseudo: $b489d312071c19a3$var$fetchParseValues(config.pseudo),
        node: $b489d312071c19a3$var$fetchParseValues(config.node)
    };
    for (const [name, context] of Object.entries(config.parseContext))switch(typeof context){
        case 'function':
            parseConfig.context[name] = context;
            break;
        case 'string':
            parseConfig.context[name] = $b489d312071c19a3$var$createParseContext(context);
            break;
    }
    return {
        config: parseConfig,
        ...parseConfig,
        ...parseConfig.node
    };
}
function $b489d312071c19a3$export$88a1156fad04455f(config) {
    let source = '';
    let filename = '<unknown>';
    let needPositions = false;
    let onParseError = $b489d312071c19a3$var$NOOP;
    let onParseErrorThrow = false;
    const locationMap = new (0, $bc8729f50c1abd04$export$a1e9ec249d80652c)();
    const parser = Object.assign(new (0, $66a702590f79175c$export$b55edb69cfa7ac57)(), $b489d312071c19a3$var$processConfig(config || {}), {
        parseAtrulePrelude: true,
        parseRulePrelude: true,
        parseValue: true,
        parseCustomProperty: false,
        readSequence: $86642271d35ae140$export$edc1450f8a1049b2,
        consumeUntilBalanceEnd: ()=>0,
        consumeUntilLeftCurlyBracket (code) {
            return code === $b489d312071c19a3$var$LEFTCURLYBRACKET ? 1 : 0;
        },
        consumeUntilLeftCurlyBracketOrSemicolon (code) {
            return code === $b489d312071c19a3$var$LEFTCURLYBRACKET || code === $b489d312071c19a3$var$SEMICOLON ? 1 : 0;
        },
        consumeUntilExclamationMarkOrSemicolon (code) {
            return code === $b489d312071c19a3$var$EXCLAMATIONMARK || code === $b489d312071c19a3$var$SEMICOLON ? 1 : 0;
        },
        consumeUntilSemicolonIncluded (code) {
            return code === $b489d312071c19a3$var$SEMICOLON ? 2 : 0;
        },
        createList () {
            return new (0, $2836a6e7287d8f5c$export$54c2e3dc7acea9f5)();
        },
        createSingleNodeList (node) {
            return new (0, $2836a6e7287d8f5c$export$54c2e3dc7acea9f5)().appendData(node);
        },
        getFirstListNode (list) {
            return list && list.first;
        },
        getLastListNode (list) {
            return list && list.last;
        },
        parseWithFallback (consumer, fallback) {
            const startIndex = this.tokenIndex;
            try {
                return consumer.call(this);
            } catch (e) {
                if (onParseErrorThrow) throw e;
                this.skip(startIndex - this.tokenIndex);
                const fallbackNode = fallback.call(this);
                onParseErrorThrow = true;
                onParseError(e, fallbackNode);
                onParseErrorThrow = false;
                return fallbackNode;
            }
        },
        lookupNonWSType (offset) {
            let type;
            do {
                type = this.lookupType(offset++);
                if (type !== (0, $cb01acaf2e18d562$export$fb98946286ab4c97) && type !== (0, $cb01acaf2e18d562$export$4d299b491347818a)) return type;
            }while (type !== $b489d312071c19a3$var$NULL);
            return $b489d312071c19a3$var$NULL;
        },
        charCodeAt (offset) {
            return offset >= 0 && offset < source.length ? source.charCodeAt(offset) : 0;
        },
        substring (offsetStart, offsetEnd) {
            return source.substring(offsetStart, offsetEnd);
        },
        substrToCursor (start) {
            return this.source.substring(start, this.tokenStart);
        },
        cmpChar (offset, charCode) {
            return (0, $0a1ac1d130312a6d$export$6902610076fb2dc1)(source, offset, charCode);
        },
        cmpStr (offsetStart, offsetEnd, str) {
            return (0, $0a1ac1d130312a6d$export$5bf4b3d0861be8d9)(source, offsetStart, offsetEnd, str);
        },
        consume (tokenType) {
            const start = this.tokenStart;
            this.eat(tokenType);
            return this.substrToCursor(start);
        },
        consumeFunctionName () {
            const name = source.substring(this.tokenStart, this.tokenEnd - 1);
            this.eat((0, $cb01acaf2e18d562$export$f3890eeaf6851387));
            return name;
        },
        consumeNumber (type) {
            const number = source.substring(this.tokenStart, (0, $0a1ac1d130312a6d$export$b817115b8219186a)(source, this.tokenStart));
            this.eat(type);
            return number;
        },
        eat (tokenType) {
            if (this.tokenType !== tokenType) {
                const tokenName = (0, $a837ededd9a4d8ce$export$2e2bcd8739ae039)[tokenType].slice(0, -6).replace(/-/g, ' ').replace(/^./, (m)=>m.toUpperCase());
                let message = `${/[[\](){}]/.test(tokenName) ? `"${tokenName}"` : tokenName} is expected`;
                let offset = this.tokenStart;
                // tweak message and offset
                switch(tokenType){
                    case 0, $cb01acaf2e18d562$export$331e9b6bdecaac5f:
                        // when identifier is expected but there is a function or url
                        if (this.tokenType === (0, $cb01acaf2e18d562$export$f3890eeaf6851387) || this.tokenType === (0, $cb01acaf2e18d562$export$59d795186a5d3f58)) {
                            offset = this.tokenEnd - 1;
                            message = 'Identifier is expected but function found';
                        } else message = 'Identifier is expected';
                        break;
                    case 0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd:
                        if (this.isDelim($b489d312071c19a3$var$NUMBERSIGN)) {
                            this.next();
                            offset++;
                            message = 'Name is expected';
                        }
                        break;
                    case 0, $cb01acaf2e18d562$export$d11913f8a6922aea:
                        if (this.tokenType === (0, $cb01acaf2e18d562$export$fffa67e515d04022)) {
                            offset = this.tokenEnd;
                            message = 'Percent sign is expected';
                        }
                        break;
                }
                this.error(message, offset);
            }
            this.next();
        },
        eatIdent (name) {
            if (this.tokenType !== (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f) || this.lookupValue(0, name) === false) this.error(`Identifier "${name}" is expected`);
            this.next();
        },
        eatDelim (code) {
            if (!this.isDelim(code)) this.error(`Delim "${String.fromCharCode(code)}" is expected`);
            this.next();
        },
        getLocation (start, end) {
            if (needPositions) return locationMap.getLocationRange(start, end, filename);
            return null;
        },
        getLocationFromList (list) {
            if (needPositions) {
                const head = this.getFirstListNode(list);
                const tail = this.getLastListNode(list);
                return locationMap.getLocationRange(head !== null ? head.loc.start.offset - locationMap.startOffset : this.tokenStart, tail !== null ? tail.loc.end.offset - locationMap.startOffset : this.tokenStart, filename);
            }
            return null;
        },
        error (message, offset) {
            const location = typeof offset !== 'undefined' && offset < source.length ? locationMap.getLocation(offset) : this.eof ? locationMap.getLocation((0, $0a1ac1d130312a6d$export$c4eb8307a0331d71)(source, source.length - 1)) : locationMap.getLocation(this.tokenStart);
            throw new (0, $d25a1e4247862d73$export$f21cea08b0dd60e8)(message || 'Unexpected input', source, location.offset, location.line, location.column, locationMap.startLine, locationMap.startColumn);
        }
    });
    const parse = function(source_, options) {
        source = source_;
        options = options || {};
        parser.setSource(source, (0, $852eae0c0686a388$export$660b2ee2d4fb4eff));
        locationMap.setSource(source, options.offset, options.line, options.column);
        filename = options.filename || '<unknown>';
        needPositions = Boolean(options.positions);
        onParseError = typeof options.onParseError === 'function' ? options.onParseError : $b489d312071c19a3$var$NOOP;
        onParseErrorThrow = false;
        parser.parseAtrulePrelude = 'parseAtrulePrelude' in options ? Boolean(options.parseAtrulePrelude) : true;
        parser.parseRulePrelude = 'parseRulePrelude' in options ? Boolean(options.parseRulePrelude) : true;
        parser.parseValue = 'parseValue' in options ? Boolean(options.parseValue) : true;
        parser.parseCustomProperty = 'parseCustomProperty' in options ? Boolean(options.parseCustomProperty) : false;
        const { context: context = 'default', onComment: onComment } = options;
        if (context in parser.context === false) throw new Error('Unknown context `' + context + '`');
        if (typeof onComment === 'function') parser.forEachToken((type, start, end)=>{
            if (type === (0, $cb01acaf2e18d562$export$4d299b491347818a)) {
                const loc = parser.getLocation(start, end);
                const value = (0, $0a1ac1d130312a6d$export$5bf4b3d0861be8d9)(source, end - 2, end, '*/') ? source.slice(start + 2, end - 2) : source.slice(start + 2, end);
                onComment(value, loc);
            }
        });
        const ast = parser.context[context].call(parser, options);
        if (!parser.eof) parser.error();
        return ast;
    };
    return Object.assign(parse, {
        SyntaxError: $d25a1e4247862d73$export$f21cea08b0dd60e8,
        config: parser.config
    });
}



/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $5adb01c3a786518b$export$4d99f7c30e854ff;
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /**
 * Returns the base 64 VLQ encoded value.
 */ var $c815945a1565deac$export$c564cdbbe6da493;
/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */ var $c815945a1565deac$export$2f872c0f2117be69;
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */ var $2f58b90eec1a4f1c$export$c564cdbbe6da493;
/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */ var $2f58b90eec1a4f1c$export$2f872c0f2117be69;
var $2f58b90eec1a4f1c$var$intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
$2f58b90eec1a4f1c$export$c564cdbbe6da493 = function(number) {
    if (0 <= number && number < $2f58b90eec1a4f1c$var$intToCharMap.length) return $2f58b90eec1a4f1c$var$intToCharMap[number];
    throw new TypeError("Must be between 0 and 63: " + number);
};
$2f58b90eec1a4f1c$export$2f872c0f2117be69 = function(charCode) {
    var bigA = 65; // 'A'
    var bigZ = 90; // 'Z'
    var littleA = 97; // 'a'
    var littleZ = 122; // 'z'
    var zero = 48; // '0'
    var nine = 57; // '9'
    var plus = 43; // '+'
    var slash = 47; // '/'
    var littleOffset = 26;
    var numberOffset = 52;
    // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
    if (bigA <= charCode && charCode <= bigZ) return charCode - bigA;
    // 26 - 51: abcdefghijklmnopqrstuvwxyz
    if (littleA <= charCode && charCode <= littleZ) return charCode - littleA + littleOffset;
    // 52 - 61: 0123456789
    if (zero <= charCode && charCode <= nine) return charCode - zero + numberOffset;
    // 62: +
    if (charCode == plus) return 62;
    // 63: /
    if (charCode == slash) return 63;
    // Invalid base64 digit.
    return -1;
};


// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011
var $c815945a1565deac$var$VLQ_BASE_SHIFT = 5;
// binary: 100000
var $c815945a1565deac$var$VLQ_BASE = 1 << $c815945a1565deac$var$VLQ_BASE_SHIFT;
// binary: 011111
var $c815945a1565deac$var$VLQ_BASE_MASK = $c815945a1565deac$var$VLQ_BASE - 1;
// binary: 100000
var $c815945a1565deac$var$VLQ_CONTINUATION_BIT = $c815945a1565deac$var$VLQ_BASE;
/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */ function $c815945a1565deac$var$toVLQSigned(aValue) {
    return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
}
/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */ function $c815945a1565deac$var$fromVLQSigned(aValue) {
    var isNegative = (aValue & 1) === 1;
    var shifted = aValue >> 1;
    return isNegative ? -shifted : shifted;
}
$c815945a1565deac$export$c564cdbbe6da493 = function base64VLQ_encode(aValue) {
    var encoded = "";
    var digit;
    var vlq = $c815945a1565deac$var$toVLQSigned(aValue);
    do {
        digit = vlq & $c815945a1565deac$var$VLQ_BASE_MASK;
        vlq >>>= $c815945a1565deac$var$VLQ_BASE_SHIFT;
        if (vlq > 0) // There are still more digits in this value, so we must make sure the
        // continuation bit is marked.
        digit |= $c815945a1565deac$var$VLQ_CONTINUATION_BIT;
        encoded += $2f58b90eec1a4f1c$export$c564cdbbe6da493(digit);
    }while (vlq > 0);
    return encoded;
};
$c815945a1565deac$export$2f872c0f2117be69 = function base64VLQ_decode(aStr, aIndex, aOutParam) {
    var strLen = aStr.length;
    var result = 0;
    var shift = 0;
    var continuation, digit;
    do {
        if (aIndex >= strLen) throw new Error("Expected more digits in base 64 VLQ value.");
        digit = $2f58b90eec1a4f1c$export$2f872c0f2117be69(aStr.charCodeAt(aIndex++));
        if (digit === -1) throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
        continuation = !!(digit & $c815945a1565deac$var$VLQ_CONTINUATION_BIT);
        digit &= $c815945a1565deac$var$VLQ_BASE_MASK;
        result = result + (digit << shift);
        shift += $c815945a1565deac$var$VLQ_BASE_SHIFT;
    }while (continuation);
    aOutParam.value = $c815945a1565deac$var$fromVLQSigned(result);
    aOutParam.rest = aIndex;
};


/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */ var $42fee36e23e6bb3a$export$6e45e70adce70bb2;
var $42fee36e23e6bb3a$export$d6e833647f7f5f17;
var $42fee36e23e6bb3a$export$2ec9abc2d2cac192;
var $42fee36e23e6bb3a$export$a3295358bff77e;
var $42fee36e23e6bb3a$export$f7e2c8231c57a8bd;
var $42fee36e23e6bb3a$export$e434c7255acda994;
var $42fee36e23e6bb3a$export$f0e7d1106eeabbe6;
var $42fee36e23e6bb3a$export$be0fa1163fa7a4c;
var $42fee36e23e6bb3a$export$1fc47c3d4c3302a1;
var $42fee36e23e6bb3a$export$273077902de92ff2;
var $42fee36e23e6bb3a$export$6af840b44a9241f3;
var $42fee36e23e6bb3a$export$b7acf533941302f6;
var $42fee36e23e6bb3a$export$4d81ca1117b6e802;
var $42fee36e23e6bb3a$export$f9c43907549d61f1;
var $42fee36e23e6bb3a$export$b49e2de2ad542732;
var $42fee36e23e6bb3a$export$659a1aa8f1cdc036;
function $42fee36e23e6bb3a$var$getArg(aArgs, aName, aDefaultValue) {
    if (aName in aArgs) return aArgs[aName];
    else if (arguments.length === 3) return aDefaultValue;
    else throw new Error('"' + aName + '" is a required argument.');
}
$42fee36e23e6bb3a$export$6e45e70adce70bb2 = $42fee36e23e6bb3a$var$getArg;
var $42fee36e23e6bb3a$var$urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;
var $42fee36e23e6bb3a$var$dataUrlRegexp = /^data:.+\,.+$/;
function $42fee36e23e6bb3a$var$urlParse(aUrl) {
    var match = aUrl.match($42fee36e23e6bb3a$var$urlRegexp);
    if (!match) return null;
    return {
        scheme: match[1],
        auth: match[2],
        host: match[3],
        port: match[4],
        path: match[5]
    };
}
$42fee36e23e6bb3a$export$d6e833647f7f5f17 = $42fee36e23e6bb3a$var$urlParse;
function $42fee36e23e6bb3a$var$urlGenerate(aParsedUrl) {
    var url = '';
    if (aParsedUrl.scheme) url += aParsedUrl.scheme + ':';
    url += '//';
    if (aParsedUrl.auth) url += aParsedUrl.auth + '@';
    if (aParsedUrl.host) url += aParsedUrl.host;
    if (aParsedUrl.port) url += ":" + aParsedUrl.port;
    if (aParsedUrl.path) url += aParsedUrl.path;
    return url;
}
$42fee36e23e6bb3a$export$2ec9abc2d2cac192 = $42fee36e23e6bb3a$var$urlGenerate;
var $42fee36e23e6bb3a$var$MAX_CACHED_INPUTS = 32;
/**
 * Takes some function `f(input) -> result` and returns a memoized version of
 * `f`.
 *
 * We keep at most `MAX_CACHED_INPUTS` memoized results of `f` alive. The
 * memoization is a dumb-simple, linear least-recently-used cache.
 */ function $42fee36e23e6bb3a$var$lruMemoize(f) {
    var cache = [];
    return function(input) {
        for(var i = 0; i < cache.length; i++)if (cache[i].input === input) {
            var temp = cache[0];
            cache[0] = cache[i];
            cache[i] = temp;
            return cache[0].result;
        }
        var result = f(input);
        cache.unshift({
            input: input,
            result: result
        });
        if (cache.length > $42fee36e23e6bb3a$var$MAX_CACHED_INPUTS) cache.pop();
        return result;
    };
}
/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */ var $42fee36e23e6bb3a$var$normalize = $42fee36e23e6bb3a$var$lruMemoize(function normalize(aPath) {
    var path = aPath;
    var url = $42fee36e23e6bb3a$var$urlParse(aPath);
    if (url) {
        if (!url.path) return aPath;
        path = url.path;
    }
    var isAbsolute = $42fee36e23e6bb3a$export$e434c7255acda994(path);
    // Split the path into parts between `/` characters. This is much faster than
    // using `.split(/\/+/g)`.
    var parts = [];
    var start = 0;
    var i = 0;
    while(true){
        start = i;
        i = path.indexOf("/", start);
        if (i === -1) {
            parts.push(path.slice(start));
            break;
        } else {
            parts.push(path.slice(start, i));
            while(i < path.length && path[i] === "/")i++;
        }
    }
    for(var part, up = 0, i = parts.length - 1; i >= 0; i--){
        part = parts[i];
        if (part === '.') parts.splice(i, 1);
        else if (part === '..') up++;
        else if (up > 0) {
            if (part === '') {
                // The first part is blank if the path is absolute. Trying to go
                // above the root is a no-op. Therefore we can remove all '..' parts
                // directly after the root.
                parts.splice(i + 1, up);
                up = 0;
            } else {
                parts.splice(i, 2);
                up--;
            }
        }
    }
    path = parts.join('/');
    if (path === '') path = isAbsolute ? '/' : '.';
    if (url) {
        url.path = path;
        return $42fee36e23e6bb3a$var$urlGenerate(url);
    }
    return path;
});
$42fee36e23e6bb3a$export$a3295358bff77e = $42fee36e23e6bb3a$var$normalize;
/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */ function $42fee36e23e6bb3a$var$join(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    if (aPath === "") aPath = ".";
    var aPathUrl = $42fee36e23e6bb3a$var$urlParse(aPath);
    var aRootUrl = $42fee36e23e6bb3a$var$urlParse(aRoot);
    if (aRootUrl) aRoot = aRootUrl.path || '/';
    // `join(foo, '//www.example.org')`
    if (aPathUrl && !aPathUrl.scheme) {
        if (aRootUrl) aPathUrl.scheme = aRootUrl.scheme;
        return $42fee36e23e6bb3a$var$urlGenerate(aPathUrl);
    }
    if (aPathUrl || aPath.match($42fee36e23e6bb3a$var$dataUrlRegexp)) return aPath;
    // `join('http://', 'www.example.com')`
    if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
        aRootUrl.host = aPath;
        return $42fee36e23e6bb3a$var$urlGenerate(aRootUrl);
    }
    var joined = aPath.charAt(0) === '/' ? aPath : $42fee36e23e6bb3a$var$normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);
    if (aRootUrl) {
        aRootUrl.path = joined;
        return $42fee36e23e6bb3a$var$urlGenerate(aRootUrl);
    }
    return joined;
}
$42fee36e23e6bb3a$export$f7e2c8231c57a8bd = $42fee36e23e6bb3a$var$join;
$42fee36e23e6bb3a$export$e434c7255acda994 = function(aPath) {
    return aPath.charAt(0) === '/' || $42fee36e23e6bb3a$var$urlRegexp.test(aPath);
};
/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */ function $42fee36e23e6bb3a$var$relative(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    aRoot = aRoot.replace(/\/$/, '');
    // It is possible for the path to be above the root. In this case, simply
    // checking whether the root is a prefix of the path won't work. Instead, we
    // need to remove components from the root one by one, until either we find
    // a prefix that fits, or we run out of components to remove.
    var level = 0;
    while(aPath.indexOf(aRoot + '/') !== 0){
        var index = aRoot.lastIndexOf("/");
        if (index < 0) return aPath;
        // If the only part of the root that is left is the scheme (i.e. http://,
        // file:///, etc.), one or more slashes (/), or simply nothing at all, we
        // have exhausted all components, so the path is not relative to the root.
        aRoot = aRoot.slice(0, index);
        if (aRoot.match(/^([^\/]+:\/)?\/*$/)) return aPath;
        ++level;
    }
    // Make sure we add a "../" for each component we removed from the root.
    return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
$42fee36e23e6bb3a$export$f0e7d1106eeabbe6 = $42fee36e23e6bb3a$var$relative;
var $42fee36e23e6bb3a$var$supportsNullProto = function() {
    var obj = Object.create(null);
    return !('__proto__' in obj);
}();
function $42fee36e23e6bb3a$var$identity(s) {
    return s;
}
/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */ function $42fee36e23e6bb3a$var$toSetString(aStr) {
    if ($42fee36e23e6bb3a$var$isProtoString(aStr)) return '$' + aStr;
    return aStr;
}
$42fee36e23e6bb3a$export$be0fa1163fa7a4c = $42fee36e23e6bb3a$var$supportsNullProto ? $42fee36e23e6bb3a$var$identity : $42fee36e23e6bb3a$var$toSetString;
function $42fee36e23e6bb3a$var$fromSetString(aStr) {
    if ($42fee36e23e6bb3a$var$isProtoString(aStr)) return aStr.slice(1);
    return aStr;
}
$42fee36e23e6bb3a$export$1fc47c3d4c3302a1 = $42fee36e23e6bb3a$var$supportsNullProto ? $42fee36e23e6bb3a$var$identity : $42fee36e23e6bb3a$var$fromSetString;
function $42fee36e23e6bb3a$var$isProtoString(s) {
    if (!s) return false;
    var length = s.length;
    if (length < 9 /* "__proto__".length */ ) return false;
    if (s.charCodeAt(length - 1) !== 95 /* '_' */  || s.charCodeAt(length - 2) !== 95 /* '_' */  || s.charCodeAt(length - 3) !== 111 /* 'o' */  || s.charCodeAt(length - 4) !== 116 /* 't' */  || s.charCodeAt(length - 5) !== 111 /* 'o' */  || s.charCodeAt(length - 6) !== 114 /* 'r' */  || s.charCodeAt(length - 7) !== 112 /* 'p' */  || s.charCodeAt(length - 8) !== 95 /* '_' */  || s.charCodeAt(length - 9) !== 95 /* '_' */ ) return false;
    for(var i = length - 10; i >= 0; i--){
        if (s.charCodeAt(i) !== 36 /* '$' */ ) return false;
    }
    return true;
}
/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */ function $42fee36e23e6bb3a$var$compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
    var cmp = $42fee36e23e6bb3a$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    return $42fee36e23e6bb3a$var$strcmp(mappingA.name, mappingB.name);
}
$42fee36e23e6bb3a$export$273077902de92ff2 = $42fee36e23e6bb3a$var$compareByOriginalPositions;
function $42fee36e23e6bb3a$var$compareByOriginalPositionsNoSource(mappingA, mappingB, onlyCompareOriginal) {
    var cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    return $42fee36e23e6bb3a$var$strcmp(mappingA.name, mappingB.name);
}
$42fee36e23e6bb3a$export$6af840b44a9241f3 = $42fee36e23e6bb3a$var$compareByOriginalPositionsNoSource;
/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */ function $42fee36e23e6bb3a$var$compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) return cmp;
    cmp = $42fee36e23e6bb3a$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $42fee36e23e6bb3a$var$strcmp(mappingA.name, mappingB.name);
}
$42fee36e23e6bb3a$export$b7acf533941302f6 = $42fee36e23e6bb3a$var$compareByGeneratedPositionsDeflated;
function $42fee36e23e6bb3a$var$compareByGeneratedPositionsDeflatedNoLine(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) return cmp;
    cmp = $42fee36e23e6bb3a$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $42fee36e23e6bb3a$var$strcmp(mappingA.name, mappingB.name);
}
$42fee36e23e6bb3a$export$4d81ca1117b6e802 = $42fee36e23e6bb3a$var$compareByGeneratedPositionsDeflatedNoLine;
function $42fee36e23e6bb3a$var$strcmp(aStr1, aStr2) {
    if (aStr1 === aStr2) return 0;
    if (aStr1 === null) return 1; // aStr2 !== null
    if (aStr2 === null) return -1; // aStr1 !== null
    if (aStr1 > aStr2) return 1;
    return -1;
}
/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */ function $42fee36e23e6bb3a$var$compareByGeneratedPositionsInflated(mappingA, mappingB) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = $42fee36e23e6bb3a$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $42fee36e23e6bb3a$var$strcmp(mappingA.name, mappingB.name);
}
$42fee36e23e6bb3a$export$f9c43907549d61f1 = $42fee36e23e6bb3a$var$compareByGeneratedPositionsInflated;
/**
 * Strip any JSON XSSI avoidance prefix from the string (as documented
 * in the source maps specification), and then parse the string as
 * JSON.
 */ function $42fee36e23e6bb3a$var$parseSourceMapInput(str) {
    return JSON.parse(str.replace(/^\)]}'[^\n]*\n/, ''));
}
$42fee36e23e6bb3a$export$b49e2de2ad542732 = $42fee36e23e6bb3a$var$parseSourceMapInput;
/**
 * Compute the URL of a source given the the source root, the source's
 * URL, and the source map's URL.
 */ function $42fee36e23e6bb3a$var$computeSourceURL(sourceRoot, sourceURL, sourceMapURL) {
    sourceURL = sourceURL || '';
    if (sourceRoot) {
        // This follows what Chrome does.
        if (sourceRoot[sourceRoot.length - 1] !== '/' && sourceURL[0] !== '/') sourceRoot += '/';
        // The spec says:
        //   Line 4: An optional source root, useful for relocating source
        //   files on a server or removing repeated values in the
        //   “sources” entry.  This value is prepended to the individual
        //   entries in the “source” field.
        sourceURL = sourceRoot + sourceURL;
    }
    // Historically, SourceMapConsumer did not take the sourceMapURL as
    // a parameter.  This mode is still somewhat supported, which is why
    // this code block is conditional.  However, it's preferable to pass
    // the source map URL to SourceMapConsumer, so that this function
    // can implement the source URL resolution algorithm as outlined in
    // the spec.  This block is basically the equivalent of:
    //    new URL(sourceURL, sourceMapURL).toString()
    // ... except it avoids using URL, which wasn't available in the
    // older releases of node still supported by this library.
    //
    // The spec says:
    //   If the sources are not absolute URLs after prepending of the
    //   “sourceRoot”, the sources are resolved relative to the
    //   SourceMap (like resolving script src in a html document).
    if (sourceMapURL) {
        var parsed = $42fee36e23e6bb3a$var$urlParse(sourceMapURL);
        if (!parsed) throw new Error("sourceMapURL could not be parsed");
        if (parsed.path) {
            // Strip the last path component, but keep the "/".
            var index = parsed.path.lastIndexOf('/');
            if (index >= 0) parsed.path = parsed.path.substring(0, index + 1);
        }
        sourceURL = $42fee36e23e6bb3a$var$join($42fee36e23e6bb3a$var$urlGenerate(parsed), sourceURL);
    }
    return $42fee36e23e6bb3a$var$normalize(sourceURL);
}
$42fee36e23e6bb3a$export$659a1aa8f1cdc036 = $42fee36e23e6bb3a$var$computeSourceURL;


/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $4e5b017d50cab3e9$export$605bbf5ea7b60ba3;

var $4e5b017d50cab3e9$var$has = Object.prototype.hasOwnProperty;
var $4e5b017d50cab3e9$var$hasNativeMap = typeof Map !== "undefined";
/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */ function $4e5b017d50cab3e9$var$ArraySet() {
    this._array = [];
    this._set = $4e5b017d50cab3e9$var$hasNativeMap ? new Map() : Object.create(null);
}
/**
 * Static method for creating ArraySet instances from an existing array.
 */ $4e5b017d50cab3e9$var$ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
    var set = new $4e5b017d50cab3e9$var$ArraySet();
    for(var i = 0, len = aArray.length; i < len; i++)set.add(aArray[i], aAllowDuplicates);
    return set;
};
/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */ $4e5b017d50cab3e9$var$ArraySet.prototype.size = function ArraySet_size() {
    return $4e5b017d50cab3e9$var$hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};
/**
 * Add the given string to this set.
 *
 * @param String aStr
 */ $4e5b017d50cab3e9$var$ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
    var sStr = $4e5b017d50cab3e9$var$hasNativeMap ? aStr : $42fee36e23e6bb3a$export$be0fa1163fa7a4c(aStr);
    var isDuplicate = $4e5b017d50cab3e9$var$hasNativeMap ? this.has(aStr) : $4e5b017d50cab3e9$var$has.call(this._set, sStr);
    var idx = this._array.length;
    if (!isDuplicate || aAllowDuplicates) this._array.push(aStr);
    if (!isDuplicate) {
        if ($4e5b017d50cab3e9$var$hasNativeMap) this._set.set(aStr, idx);
        else this._set[sStr] = idx;
    }
};
/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */ $4e5b017d50cab3e9$var$ArraySet.prototype.has = function ArraySet_has(aStr) {
    if ($4e5b017d50cab3e9$var$hasNativeMap) return this._set.has(aStr);
    else {
        var sStr = $42fee36e23e6bb3a$export$be0fa1163fa7a4c(aStr);
        return $4e5b017d50cab3e9$var$has.call(this._set, sStr);
    }
};
/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */ $4e5b017d50cab3e9$var$ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
    if ($4e5b017d50cab3e9$var$hasNativeMap) {
        var idx = this._set.get(aStr);
        if (idx >= 0) return idx;
    } else {
        var sStr = $42fee36e23e6bb3a$export$be0fa1163fa7a4c(aStr);
        if ($4e5b017d50cab3e9$var$has.call(this._set, sStr)) return this._set[sStr];
    }
    throw new Error('"' + aStr + '" is not in the set.');
};
/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */ $4e5b017d50cab3e9$var$ArraySet.prototype.at = function ArraySet_at(aIdx) {
    if (aIdx >= 0 && aIdx < this._array.length) return this._array[aIdx];
    throw new Error('No element indexed by ' + aIdx);
};
/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */ $4e5b017d50cab3e9$var$ArraySet.prototype.toArray = function ArraySet_toArray() {
    return this._array.slice();
};
$4e5b017d50cab3e9$export$605bbf5ea7b60ba3 = $4e5b017d50cab3e9$var$ArraySet;


var $5adb01c3a786518b$require$ArraySet = $4e5b017d50cab3e9$export$605bbf5ea7b60ba3;
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2014 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $eac725fe3592f502$export$e82e0908843dd951;

/**
 * Determine whether mappingB is after mappingA with respect to generated
 * position.
 */ function $eac725fe3592f502$var$generatedPositionAfter(mappingA, mappingB) {
    // Optimized for most common case
    var lineA = mappingA.generatedLine;
    var lineB = mappingB.generatedLine;
    var columnA = mappingA.generatedColumn;
    var columnB = mappingB.generatedColumn;
    return lineB > lineA || lineB == lineA && columnB >= columnA || $42fee36e23e6bb3a$export$f9c43907549d61f1(mappingA, mappingB) <= 0;
}
/**
 * A data structure to provide a sorted view of accumulated mappings in a
 * performance conscious manner. It trades a neglibable overhead in general
 * case for a large speedup in case of mappings being added in order.
 */ function $eac725fe3592f502$var$MappingList() {
    this._array = [];
    this._sorted = true;
    // Serves as infimum
    this._last = {
        generatedLine: -1,
        generatedColumn: 0
    };
}
/**
 * Iterate through internal items. This method takes the same arguments that
 * `Array.prototype.forEach` takes.
 *
 * NOTE: The order of the mappings is NOT guaranteed.
 */ $eac725fe3592f502$var$MappingList.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
    this._array.forEach(aCallback, aThisArg);
};
/**
 * Add the given source mapping.
 *
 * @param Object aMapping
 */ $eac725fe3592f502$var$MappingList.prototype.add = function MappingList_add(aMapping) {
    if ($eac725fe3592f502$var$generatedPositionAfter(this._last, aMapping)) {
        this._last = aMapping;
        this._array.push(aMapping);
    } else {
        this._sorted = false;
        this._array.push(aMapping);
    }
};
/**
 * Returns the flat, sorted array of mappings. The mappings are sorted by
 * generated position.
 *
 * WARNING: This method returns internal data without copying, for
 * performance. The return value must NOT be mutated, and should be treated as
 * an immutable borrow. If you want to take ownership, you must make your own
 * copy.
 */ $eac725fe3592f502$var$MappingList.prototype.toArray = function MappingList_toArray() {
    if (!this._sorted) {
        this._array.sort($42fee36e23e6bb3a$export$f9c43907549d61f1);
        this._sorted = true;
    }
    return this._array;
};
$eac725fe3592f502$export$e82e0908843dd951 = $eac725fe3592f502$var$MappingList;


var $5adb01c3a786518b$require$MappingList = $eac725fe3592f502$export$e82e0908843dd951;
/**
 * An instance of the SourceMapGenerator represents a source map which is
 * being built incrementally. You may pass an object with the following
 * properties:
 *
 *   - file: The filename of the generated source.
 *   - sourceRoot: A root for all relative URLs in this source map.
 */ function $5adb01c3a786518b$var$SourceMapGenerator(aArgs) {
    if (!aArgs) aArgs = {};
    this._file = $42fee36e23e6bb3a$export$6e45e70adce70bb2(aArgs, 'file', null);
    this._sourceRoot = $42fee36e23e6bb3a$export$6e45e70adce70bb2(aArgs, 'sourceRoot', null);
    this._skipValidation = $42fee36e23e6bb3a$export$6e45e70adce70bb2(aArgs, 'skipValidation', false);
    this._ignoreInvalidMapping = $42fee36e23e6bb3a$export$6e45e70adce70bb2(aArgs, 'ignoreInvalidMapping', false);
    this._sources = new $5adb01c3a786518b$require$ArraySet();
    this._names = new $5adb01c3a786518b$require$ArraySet();
    this._mappings = new $5adb01c3a786518b$require$MappingList();
    this._sourcesContents = null;
}
$5adb01c3a786518b$var$SourceMapGenerator.prototype._version = 3;
/**
 * Creates a new SourceMapGenerator based on a SourceMapConsumer
 *
 * @param aSourceMapConsumer The SourceMap.
 */ $5adb01c3a786518b$var$SourceMapGenerator.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer, generatorOps) {
    var sourceRoot = aSourceMapConsumer.sourceRoot;
    var generator = new $5adb01c3a786518b$var$SourceMapGenerator(Object.assign(generatorOps || {}, {
        file: aSourceMapConsumer.file,
        sourceRoot: sourceRoot
    }));
    aSourceMapConsumer.eachMapping(function(mapping) {
        var newMapping = {
            generated: {
                line: mapping.generatedLine,
                column: mapping.generatedColumn
            }
        };
        if (mapping.source != null) {
            newMapping.source = mapping.source;
            if (sourceRoot != null) newMapping.source = $42fee36e23e6bb3a$export$f0e7d1106eeabbe6(sourceRoot, newMapping.source);
            newMapping.original = {
                line: mapping.originalLine,
                column: mapping.originalColumn
            };
            if (mapping.name != null) newMapping.name = mapping.name;
        }
        generator.addMapping(newMapping);
    });
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var sourceRelative = sourceFile;
        if (sourceRoot !== null) sourceRelative = $42fee36e23e6bb3a$export$f0e7d1106eeabbe6(sourceRoot, sourceFile);
        if (!generator._sources.has(sourceRelative)) generator._sources.add(sourceRelative);
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) generator.setSourceContent(sourceFile, content);
    });
    return generator;
};
/**
 * Add a single mapping from original source line and column to the generated
 * source's line and column for this source map being created. The mapping
 * object should have the following properties:
 *
 *   - generated: An object with the generated line and column positions.
 *   - original: An object with the original line and column positions.
 *   - source: The original source file (relative to the sourceRoot).
 *   - name: An optional original token name for this mapping.
 */ $5adb01c3a786518b$var$SourceMapGenerator.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
    var generated = $42fee36e23e6bb3a$export$6e45e70adce70bb2(aArgs, 'generated');
    var original = $42fee36e23e6bb3a$export$6e45e70adce70bb2(aArgs, 'original', null);
    var source = $42fee36e23e6bb3a$export$6e45e70adce70bb2(aArgs, 'source', null);
    var name = $42fee36e23e6bb3a$export$6e45e70adce70bb2(aArgs, 'name', null);
    if (!this._skipValidation) {
        if (this._validateMapping(generated, original, source, name) === false) return;
    }
    if (source != null) {
        source = String(source);
        if (!this._sources.has(source)) this._sources.add(source);
    }
    if (name != null) {
        name = String(name);
        if (!this._names.has(name)) this._names.add(name);
    }
    this._mappings.add({
        generatedLine: generated.line,
        generatedColumn: generated.column,
        originalLine: original != null && original.line,
        originalColumn: original != null && original.column,
        source: source,
        name: name
    });
};
/**
 * Set the source content for a source file.
 */ $5adb01c3a786518b$var$SourceMapGenerator.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
    var source = aSourceFile;
    if (this._sourceRoot != null) source = $42fee36e23e6bb3a$export$f0e7d1106eeabbe6(this._sourceRoot, source);
    if (aSourceContent != null) {
        // Add the source content to the _sourcesContents map.
        // Create a new _sourcesContents map if the property is null.
        if (!this._sourcesContents) this._sourcesContents = Object.create(null);
        this._sourcesContents[$42fee36e23e6bb3a$export$be0fa1163fa7a4c(source)] = aSourceContent;
    } else if (this._sourcesContents) {
        // Remove the source file from the _sourcesContents map.
        // If the _sourcesContents map is empty, set the property to null.
        delete this._sourcesContents[$42fee36e23e6bb3a$export$be0fa1163fa7a4c(source)];
        if (Object.keys(this._sourcesContents).length === 0) this._sourcesContents = null;
    }
};
/**
 * Applies the mappings of a sub-source-map for a specific source file to the
 * source map being generated. Each mapping to the supplied source file is
 * rewritten using the supplied source map. Note: The resolution for the
 * resulting mappings is the minimium of this map and the supplied map.
 *
 * @param aSourceMapConsumer The source map to be applied.
 * @param aSourceFile Optional. The filename of the source file.
 *        If omitted, SourceMapConsumer's file property will be used.
 * @param aSourceMapPath Optional. The dirname of the path to the source map
 *        to be applied. If relative, it is relative to the SourceMapConsumer.
 *        This parameter is needed when the two source maps aren't in the same
 *        directory, and the source map to be applied contains relative source
 *        paths. If so, those relative source paths need to be rewritten
 *        relative to the SourceMapGenerator.
 */ $5adb01c3a786518b$var$SourceMapGenerator.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
    var sourceFile = aSourceFile;
    // If aSourceFile is omitted, we will use the file property of the SourceMap
    if (aSourceFile == null) {
        if (aSourceMapConsumer.file == null) throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map\'s "file" property. Both were omitted.');
        sourceFile = aSourceMapConsumer.file;
    }
    var sourceRoot = this._sourceRoot;
    // Make "sourceFile" relative if an absolute Url is passed.
    if (sourceRoot != null) sourceFile = $42fee36e23e6bb3a$export$f0e7d1106eeabbe6(sourceRoot, sourceFile);
    // Applying the SourceMap can add and remove items from the sources and
    // the names array.
    var newSources = new $5adb01c3a786518b$require$ArraySet();
    var newNames = new $5adb01c3a786518b$require$ArraySet();
    // Find mappings for the "sourceFile"
    this._mappings.unsortedForEach(function(mapping) {
        if (mapping.source === sourceFile && mapping.originalLine != null) {
            // Check if it can be mapped by the source map, then update the mapping.
            var original = aSourceMapConsumer.originalPositionFor({
                line: mapping.originalLine,
                column: mapping.originalColumn
            });
            if (original.source != null) {
                // Copy mapping
                mapping.source = original.source;
                if (aSourceMapPath != null) mapping.source = $42fee36e23e6bb3a$export$f7e2c8231c57a8bd(aSourceMapPath, mapping.source);
                if (sourceRoot != null) mapping.source = $42fee36e23e6bb3a$export$f0e7d1106eeabbe6(sourceRoot, mapping.source);
                mapping.originalLine = original.line;
                mapping.originalColumn = original.column;
                if (original.name != null) mapping.name = original.name;
            }
        }
        var source = mapping.source;
        if (source != null && !newSources.has(source)) newSources.add(source);
        var name = mapping.name;
        if (name != null && !newNames.has(name)) newNames.add(name);
    }, this);
    this._sources = newSources;
    this._names = newNames;
    // Copy sourcesContents of applied map.
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) {
            if (aSourceMapPath != null) sourceFile = $42fee36e23e6bb3a$export$f7e2c8231c57a8bd(aSourceMapPath, sourceFile);
            if (sourceRoot != null) sourceFile = $42fee36e23e6bb3a$export$f0e7d1106eeabbe6(sourceRoot, sourceFile);
            this.setSourceContent(sourceFile, content);
        }
    }, this);
};
/**
 * A mapping can have one of the three levels of data:
 *
 *   1. Just the generated position.
 *   2. The Generated position, original position, and original source.
 *   3. Generated and original position, original source, as well as a name
 *      token.
 *
 * To maintain consistency, we validate that any new mapping being added falls
 * in to one of these categories.
 */ $5adb01c3a786518b$var$SourceMapGenerator.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
    // When aOriginal is truthy but has empty values for .line and .column,
    // it is most likely a programmer error. In this case we throw a very
    // specific error message to try to guide them the right way.
    // For example: https://github.com/Polymer/polymer-bundler/pull/519
    if (aOriginal && typeof aOriginal.line !== 'number' && typeof aOriginal.column !== 'number') {
        var message = "original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values.";
        if (this._ignoreInvalidMapping) {
            if (typeof console !== 'undefined' && console.warn) console.warn(message);
            return false;
        } else throw new Error(message);
    }
    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) // Case 1.
    return;
    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated && aOriginal && 'line' in aOriginal && 'column' in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) // Cases 2 and 3.
    return;
    else {
        var message = 'Invalid mapping: ' + JSON.stringify({
            generated: aGenerated,
            source: aSource,
            original: aOriginal,
            name: aName
        });
        if (this._ignoreInvalidMapping) {
            if (typeof console !== 'undefined' && console.warn) console.warn(message);
            return false;
        } else throw new Error(message);
    }
};
/**
 * Serialize the accumulated mappings in to the stream of base 64 VLQs
 * specified by the source map format.
 */ $5adb01c3a786518b$var$SourceMapGenerator.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
    var previousGeneratedColumn = 0;
    var previousGeneratedLine = 1;
    var previousOriginalColumn = 0;
    var previousOriginalLine = 0;
    var previousName = 0;
    var previousSource = 0;
    var result = '';
    var next;
    var mapping;
    var nameIdx;
    var sourceIdx;
    var mappings = this._mappings.toArray();
    for(var i = 0, len = mappings.length; i < len; i++){
        mapping = mappings[i];
        next = '';
        if (mapping.generatedLine !== previousGeneratedLine) {
            previousGeneratedColumn = 0;
            while(mapping.generatedLine !== previousGeneratedLine){
                next += ';';
                previousGeneratedLine++;
            }
        } else if (i > 0) {
            if (!$42fee36e23e6bb3a$export$f9c43907549d61f1(mapping, mappings[i - 1])) continue;
            next += ',';
        }
        next += $c815945a1565deac$export$c564cdbbe6da493(mapping.generatedColumn - previousGeneratedColumn);
        previousGeneratedColumn = mapping.generatedColumn;
        if (mapping.source != null) {
            sourceIdx = this._sources.indexOf(mapping.source);
            next += $c815945a1565deac$export$c564cdbbe6da493(sourceIdx - previousSource);
            previousSource = sourceIdx;
            // lines are stored 0-based in SourceMap spec version 3
            next += $c815945a1565deac$export$c564cdbbe6da493(mapping.originalLine - 1 - previousOriginalLine);
            previousOriginalLine = mapping.originalLine - 1;
            next += $c815945a1565deac$export$c564cdbbe6da493(mapping.originalColumn - previousOriginalColumn);
            previousOriginalColumn = mapping.originalColumn;
            if (mapping.name != null) {
                nameIdx = this._names.indexOf(mapping.name);
                next += $c815945a1565deac$export$c564cdbbe6da493(nameIdx - previousName);
                previousName = nameIdx;
            }
        }
        result += next;
    }
    return result;
};
$5adb01c3a786518b$var$SourceMapGenerator.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
    return aSources.map(function(source) {
        if (!this._sourcesContents) return null;
        if (aSourceRoot != null) source = $42fee36e23e6bb3a$export$f0e7d1106eeabbe6(aSourceRoot, source);
        var key = $42fee36e23e6bb3a$export$be0fa1163fa7a4c(source);
        return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
    }, this);
};
/**
 * Externalize the source map.
 */ $5adb01c3a786518b$var$SourceMapGenerator.prototype.toJSON = function SourceMapGenerator_toJSON() {
    var map = {
        version: this._version,
        sources: this._sources.toArray(),
        names: this._names.toArray(),
        mappings: this._serializeMappings()
    };
    if (this._file != null) map.file = this._file;
    if (this._sourceRoot != null) map.sourceRoot = this._sourceRoot;
    if (this._sourcesContents) map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
    return map;
};
/**
 * Render the source map being generated to a string.
 */ $5adb01c3a786518b$var$SourceMapGenerator.prototype.toString = function SourceMapGenerator_toString() {
    return JSON.stringify(this.toJSON());
};
$5adb01c3a786518b$export$4d99f7c30e854ff = $5adb01c3a786518b$var$SourceMapGenerator;


const $bb662c9e85778011$var$trackNodes = new Set([
    'Atrule',
    'Selector',
    'Declaration'
]);
function $bb662c9e85778011$export$36066a35e0efbb1e(handlers) {
    const map = new (0, $5adb01c3a786518b$export$4d99f7c30e854ff)();
    const generated = {
        line: 1,
        column: 0
    };
    const original = {
        line: 0,
        column: 0
    };
    const activatedGenerated = {
        line: 1,
        column: 0
    };
    const activatedMapping = {
        generated: activatedGenerated
    };
    let line = 1;
    let column = 0;
    let sourceMappingActive = false;
    const origHandlersNode = handlers.node;
    handlers.node = function(node) {
        if (node.loc && node.loc.start && $bb662c9e85778011$var$trackNodes.has(node.type)) {
            const nodeLine = node.loc.start.line;
            const nodeColumn = node.loc.start.column - 1;
            if (original.line !== nodeLine || original.column !== nodeColumn) {
                original.line = nodeLine;
                original.column = nodeColumn;
                generated.line = line;
                generated.column = column;
                if (sourceMappingActive) {
                    sourceMappingActive = false;
                    if (generated.line !== activatedGenerated.line || generated.column !== activatedGenerated.column) map.addMapping(activatedMapping);
                }
                sourceMappingActive = true;
                map.addMapping({
                    source: node.loc.source,
                    original: original,
                    generated: generated
                });
            }
        }
        origHandlersNode.call(this, node);
        if (sourceMappingActive && $bb662c9e85778011$var$trackNodes.has(node.type)) {
            activatedGenerated.line = line;
            activatedGenerated.column = column;
        }
    };
    const origHandlersEmit = handlers.emit;
    handlers.emit = function(value, type, auto) {
        for(let i = 0; i < value.length; i++)if (value.charCodeAt(i) === 10) {
            line++;
            column = 0;
        } else column++;
        origHandlersEmit(value, type, auto);
    };
    const origHandlersResult = handlers.result;
    handlers.result = function() {
        if (sourceMappingActive) map.addMapping(activatedMapping);
        return {
            css: origHandlersResult(),
            map: map
        };
    };
    return handlers;
}


var $a0ef19e6c3733557$exports = {};

$parcel$export($a0ef19e6c3733557$exports, "spec", function () { return $a0ef19e6c3733557$export$a40e83dd9f9a97c8; });
$parcel$export($a0ef19e6c3733557$exports, "safe", function () { return $a0ef19e6c3733557$export$170b8c323eee7bec; });

const $a0ef19e6c3733557$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $a0ef19e6c3733557$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $a0ef19e6c3733557$var$code = (type, value)=>{
    if (type === (0, $cb01acaf2e18d562$export$a918ca49ff4337a3)) type = value;
    if (typeof type === 'string') {
        const charCode = type.charCodeAt(0);
        return charCode > 0x7F ? 0x8000 : charCode << 8;
    }
    return type;
};
// https://www.w3.org/TR/css-syntax-3/#serialization
// The only requirement for serialization is that it must "round-trip" with parsing,
// that is, parsing the stylesheet must produce the same data structures as parsing,
// serializing, and parsing again, except for consecutive <whitespace-token>s,
// which may be collapsed into a single token.
const $a0ef19e6c3733557$var$specPairs = [
    [
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f),
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)
    ],
    [
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f),
        (0, $cb01acaf2e18d562$export$f3890eeaf6851387)
    ],
    [
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f),
        (0, $cb01acaf2e18d562$export$59d795186a5d3f58)
    ],
    [
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f),
        (0, $cb01acaf2e18d562$export$f8b4878501aa4a62)
    ],
    [
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f),
        '-'
    ],
    [
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f),
        (0, $cb01acaf2e18d562$export$fffa67e515d04022)
    ],
    [
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f),
        (0, $cb01acaf2e18d562$export$d11913f8a6922aea)
    ],
    [
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f),
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6)
    ],
    [
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f),
        (0, $cb01acaf2e18d562$export$b0b2bd2d1777c179)
    ],
    [
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f),
        (0, $cb01acaf2e18d562$export$b5a25f132cb53de6)
    ],
    [
        (0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac),
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)
    ],
    [
        (0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac),
        (0, $cb01acaf2e18d562$export$f3890eeaf6851387)
    ],
    [
        (0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac),
        (0, $cb01acaf2e18d562$export$59d795186a5d3f58)
    ],
    [
        (0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac),
        (0, $cb01acaf2e18d562$export$f8b4878501aa4a62)
    ],
    [
        (0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac),
        '-'
    ],
    [
        (0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac),
        (0, $cb01acaf2e18d562$export$fffa67e515d04022)
    ],
    [
        (0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac),
        (0, $cb01acaf2e18d562$export$d11913f8a6922aea)
    ],
    [
        (0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac),
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6)
    ],
    [
        (0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac),
        (0, $cb01acaf2e18d562$export$b0b2bd2d1777c179)
    ],
    [
        (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd),
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)
    ],
    [
        (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd),
        (0, $cb01acaf2e18d562$export$f3890eeaf6851387)
    ],
    [
        (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd),
        (0, $cb01acaf2e18d562$export$59d795186a5d3f58)
    ],
    [
        (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd),
        (0, $cb01acaf2e18d562$export$f8b4878501aa4a62)
    ],
    [
        (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd),
        '-'
    ],
    [
        (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd),
        (0, $cb01acaf2e18d562$export$fffa67e515d04022)
    ],
    [
        (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd),
        (0, $cb01acaf2e18d562$export$d11913f8a6922aea)
    ],
    [
        (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd),
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6)
    ],
    [
        (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd),
        (0, $cb01acaf2e18d562$export$b0b2bd2d1777c179)
    ],
    [
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6),
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)
    ],
    [
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6),
        (0, $cb01acaf2e18d562$export$f3890eeaf6851387)
    ],
    [
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6),
        (0, $cb01acaf2e18d562$export$59d795186a5d3f58)
    ],
    [
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6),
        (0, $cb01acaf2e18d562$export$f8b4878501aa4a62)
    ],
    [
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6),
        '-'
    ],
    [
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6),
        (0, $cb01acaf2e18d562$export$fffa67e515d04022)
    ],
    [
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6),
        (0, $cb01acaf2e18d562$export$d11913f8a6922aea)
    ],
    [
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6),
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6)
    ],
    [
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6),
        (0, $cb01acaf2e18d562$export$b0b2bd2d1777c179)
    ],
    [
        '#',
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)
    ],
    [
        '#',
        (0, $cb01acaf2e18d562$export$f3890eeaf6851387)
    ],
    [
        '#',
        (0, $cb01acaf2e18d562$export$59d795186a5d3f58)
    ],
    [
        '#',
        (0, $cb01acaf2e18d562$export$f8b4878501aa4a62)
    ],
    [
        '#',
        '-'
    ],
    [
        '#',
        (0, $cb01acaf2e18d562$export$fffa67e515d04022)
    ],
    [
        '#',
        (0, $cb01acaf2e18d562$export$d11913f8a6922aea)
    ],
    [
        '#',
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6)
    ],
    [
        '#',
        (0, $cb01acaf2e18d562$export$b0b2bd2d1777c179)
    ],
    [
        '-',
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)
    ],
    [
        '-',
        (0, $cb01acaf2e18d562$export$f3890eeaf6851387)
    ],
    [
        '-',
        (0, $cb01acaf2e18d562$export$59d795186a5d3f58)
    ],
    [
        '-',
        (0, $cb01acaf2e18d562$export$f8b4878501aa4a62)
    ],
    [
        '-',
        '-'
    ],
    [
        '-',
        (0, $cb01acaf2e18d562$export$fffa67e515d04022)
    ],
    [
        '-',
        (0, $cb01acaf2e18d562$export$d11913f8a6922aea)
    ],
    [
        '-',
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6)
    ],
    [
        '-',
        (0, $cb01acaf2e18d562$export$b0b2bd2d1777c179)
    ],
    [
        (0, $cb01acaf2e18d562$export$fffa67e515d04022),
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)
    ],
    [
        (0, $cb01acaf2e18d562$export$fffa67e515d04022),
        (0, $cb01acaf2e18d562$export$f3890eeaf6851387)
    ],
    [
        (0, $cb01acaf2e18d562$export$fffa67e515d04022),
        (0, $cb01acaf2e18d562$export$59d795186a5d3f58)
    ],
    [
        (0, $cb01acaf2e18d562$export$fffa67e515d04022),
        (0, $cb01acaf2e18d562$export$f8b4878501aa4a62)
    ],
    [
        (0, $cb01acaf2e18d562$export$fffa67e515d04022),
        (0, $cb01acaf2e18d562$export$fffa67e515d04022)
    ],
    [
        (0, $cb01acaf2e18d562$export$fffa67e515d04022),
        (0, $cb01acaf2e18d562$export$d11913f8a6922aea)
    ],
    [
        (0, $cb01acaf2e18d562$export$fffa67e515d04022),
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6)
    ],
    [
        (0, $cb01acaf2e18d562$export$fffa67e515d04022),
        '%'
    ],
    [
        (0, $cb01acaf2e18d562$export$fffa67e515d04022),
        (0, $cb01acaf2e18d562$export$b0b2bd2d1777c179)
    ],
    [
        '@',
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)
    ],
    [
        '@',
        (0, $cb01acaf2e18d562$export$f3890eeaf6851387)
    ],
    [
        '@',
        (0, $cb01acaf2e18d562$export$59d795186a5d3f58)
    ],
    [
        '@',
        (0, $cb01acaf2e18d562$export$f8b4878501aa4a62)
    ],
    [
        '@',
        '-'
    ],
    [
        '@',
        (0, $cb01acaf2e18d562$export$b0b2bd2d1777c179)
    ],
    [
        '.',
        (0, $cb01acaf2e18d562$export$fffa67e515d04022)
    ],
    [
        '.',
        (0, $cb01acaf2e18d562$export$d11913f8a6922aea)
    ],
    [
        '.',
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6)
    ],
    [
        '+',
        (0, $cb01acaf2e18d562$export$fffa67e515d04022)
    ],
    [
        '+',
        (0, $cb01acaf2e18d562$export$d11913f8a6922aea)
    ],
    [
        '+',
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6)
    ],
    [
        '/',
        '*'
    ]
];
// validate with scripts/generate-safe
const $a0ef19e6c3733557$var$safePairs = $a0ef19e6c3733557$var$specPairs.concat([
    [
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f),
        (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd)
    ],
    [
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6),
        (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd)
    ],
    [
        (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd),
        (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd)
    ],
    [
        (0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac),
        (0, $cb01acaf2e18d562$export$b5a25f132cb53de6)
    ],
    [
        (0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac),
        (0, $cb01acaf2e18d562$export$89b8e0fa65f6a914)
    ],
    [
        (0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac),
        (0, $cb01acaf2e18d562$export$e20ebb298016f6)
    ],
    [
        (0, $cb01acaf2e18d562$export$d11913f8a6922aea),
        (0, $cb01acaf2e18d562$export$d11913f8a6922aea)
    ],
    [
        (0, $cb01acaf2e18d562$export$d11913f8a6922aea),
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6)
    ],
    [
        (0, $cb01acaf2e18d562$export$d11913f8a6922aea),
        (0, $cb01acaf2e18d562$export$f3890eeaf6851387)
    ],
    [
        (0, $cb01acaf2e18d562$export$d11913f8a6922aea),
        '-'
    ],
    [
        (0, $cb01acaf2e18d562$export$773d33972c6279ed),
        (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)
    ],
    [
        (0, $cb01acaf2e18d562$export$773d33972c6279ed),
        (0, $cb01acaf2e18d562$export$f3890eeaf6851387)
    ],
    [
        (0, $cb01acaf2e18d562$export$773d33972c6279ed),
        (0, $cb01acaf2e18d562$export$d11913f8a6922aea)
    ],
    [
        (0, $cb01acaf2e18d562$export$773d33972c6279ed),
        (0, $cb01acaf2e18d562$export$c940ece961bc43c6)
    ],
    [
        (0, $cb01acaf2e18d562$export$773d33972c6279ed),
        (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd)
    ],
    [
        (0, $cb01acaf2e18d562$export$773d33972c6279ed),
        '-'
    ]
]);
function $a0ef19e6c3733557$var$createMap(pairs) {
    const isWhiteSpaceRequired = new Set(pairs.map(([prev, next])=>$a0ef19e6c3733557$var$code(prev) << 16 | $a0ef19e6c3733557$var$code(next)));
    return function(prevCode, type, value) {
        const nextCode = $a0ef19e6c3733557$var$code(type, value);
        const nextCharCode = value.charCodeAt(0);
        const emitWs = nextCharCode === $a0ef19e6c3733557$var$HYPHENMINUS && type !== (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f) && type !== (0, $cb01acaf2e18d562$export$f3890eeaf6851387) && type !== (0, $cb01acaf2e18d562$export$b0b2bd2d1777c179) || nextCharCode === $a0ef19e6c3733557$var$PLUSSIGN ? isWhiteSpaceRequired.has(prevCode << 16 | nextCharCode << 8) : isWhiteSpaceRequired.has(prevCode << 16 | nextCode);
        if (emitWs) this.emit(' ', (0, $cb01acaf2e18d562$export$fb98946286ab4c97), true);
        return nextCode;
    };
}
const $a0ef19e6c3733557$export$a40e83dd9f9a97c8 = $a0ef19e6c3733557$var$createMap($a0ef19e6c3733557$var$specPairs);
const $a0ef19e6c3733557$export$170b8c323eee7bec = $a0ef19e6c3733557$var$createMap($a0ef19e6c3733557$var$safePairs);


const $f52d95f0d194c2b7$var$REVERSESOLIDUS = 0x005c; // U+005C REVERSE SOLIDUS (\)
function $f52d95f0d194c2b7$var$processChildren(node, delimeter) {
    if (typeof delimeter === 'function') {
        let prev = null;
        node.children.forEach((node)=>{
            if (prev !== null) delimeter.call(this, prev);
            this.node(node);
            prev = node;
        });
        return;
    }
    node.children.forEach(this.node, this);
}
function $f52d95f0d194c2b7$var$processChunk(chunk) {
    (0, $852eae0c0686a388$export$660b2ee2d4fb4eff)(chunk, (type, start, end)=>{
        this.token(type, chunk.slice(start, end));
    });
}
function $f52d95f0d194c2b7$export$881f0ad61271ba2(config) {
    const types = new Map();
    for (let [name, item] of Object.entries(config.node)){
        const fn = item.generate || item;
        if (typeof fn === 'function') types.set(name, item.generate || item);
    }
    return function(node, options) {
        let buffer = '';
        let prevCode = 0;
        let handlers = {
            node (node) {
                if (types.has(node.type)) types.get(node.type).call(publicApi, node);
                else throw new Error('Unknown node type: ' + node.type);
            },
            tokenBefore: $a0ef19e6c3733557$exports.safe,
            token (type, value) {
                prevCode = this.tokenBefore(prevCode, type, value);
                this.emit(value, type, false);
                if (type === (0, $cb01acaf2e18d562$export$a918ca49ff4337a3) && value.charCodeAt(0) === $f52d95f0d194c2b7$var$REVERSESOLIDUS) this.emit('\n', (0, $cb01acaf2e18d562$export$fb98946286ab4c97), true);
            },
            emit (value) {
                buffer += value;
            },
            result () {
                return buffer;
            }
        };
        if (options) {
            if (typeof options.decorator === 'function') handlers = options.decorator(handlers);
            if (options.sourceMap) handlers = (0, $bb662c9e85778011$export$36066a35e0efbb1e)(handlers);
            if (options.mode in $a0ef19e6c3733557$exports) handlers.tokenBefore = $a0ef19e6c3733557$exports[options.mode];
        }
        const publicApi = {
            node: (node)=>handlers.node(node),
            children: $f52d95f0d194c2b7$var$processChildren,
            token: (type, value)=>handlers.token(type, value),
            tokenize: $f52d95f0d194c2b7$var$processChunk
        };
        handlers.node(node);
        return handlers.result();
    };
}



function $5cec6377554605f1$export$270c35c9c0b7b1f9(walk) {
    return {
        fromPlainObject (ast) {
            walk(ast, {
                enter (node) {
                    if (node.children && node.children instanceof (0, $2836a6e7287d8f5c$export$54c2e3dc7acea9f5) === false) node.children = new (0, $2836a6e7287d8f5c$export$54c2e3dc7acea9f5)().fromArray(node.children);
                }
            });
            return ast;
        },
        toPlainObject (ast) {
            walk(ast, {
                leave (node) {
                    if (node.children && node.children instanceof (0, $2836a6e7287d8f5c$export$54c2e3dc7acea9f5)) node.children = node.children.toArray();
                }
            });
            return ast;
        }
    };
}


const { hasOwnProperty: $021e21228e152a58$var$hasOwnProperty } = Object.prototype;
const $021e21228e152a58$var$noop = function() {};
function $021e21228e152a58$var$ensureFunction(value) {
    return typeof value === 'function' ? value : $021e21228e152a58$var$noop;
}
function $021e21228e152a58$var$invokeForType(fn, type) {
    return function(node, item, list) {
        if (node.type === type) fn.call(this, node, item, list);
    };
}
function $021e21228e152a58$var$getWalkersFromStructure(name, nodeType) {
    const structure = nodeType.structure;
    const walkers = [];
    for(const key in structure){
        if ($021e21228e152a58$var$hasOwnProperty.call(structure, key) === false) continue;
        let fieldTypes = structure[key];
        const walker = {
            name: key,
            type: false,
            nullable: false
        };
        if (!Array.isArray(fieldTypes)) fieldTypes = [
            fieldTypes
        ];
        for (const fieldType of fieldTypes){
            if (fieldType === null) walker.nullable = true;
            else if (typeof fieldType === 'string') walker.type = 'node';
            else if (Array.isArray(fieldType)) walker.type = 'list';
        }
        if (walker.type) walkers.push(walker);
    }
    if (walkers.length) return {
        context: nodeType.walkContext,
        fields: walkers
    };
    return null;
}
function $021e21228e152a58$var$getTypesFromConfig(config) {
    const types = {};
    for(const name in config.node)if ($021e21228e152a58$var$hasOwnProperty.call(config.node, name)) {
        const nodeType = config.node[name];
        if (!nodeType.structure) throw new Error('Missed `structure` field in `' + name + '` node type definition');
        types[name] = $021e21228e152a58$var$getWalkersFromStructure(name, nodeType);
    }
    return types;
}
function $021e21228e152a58$var$createTypeIterator(config, reverse) {
    const fields = config.fields.slice();
    const contextName = config.context;
    const useContext = typeof contextName === 'string';
    if (reverse) fields.reverse();
    return function(node, context, walk, walkReducer) {
        let prevContextValue;
        if (useContext) {
            prevContextValue = context[contextName];
            context[contextName] = node;
        }
        for (const field of fields){
            const ref = node[field.name];
            if (!field.nullable || ref) {
                if (field.type === 'list') {
                    const breakWalk = reverse ? ref.reduceRight(walkReducer, false) : ref.reduce(walkReducer, false);
                    if (breakWalk) return true;
                } else if (walk(ref)) return true;
            }
        }
        if (useContext) context[contextName] = prevContextValue;
    };
}
function $021e21228e152a58$var$createFastTraveralMap({ StyleSheet: StyleSheet, Atrule: Atrule, Rule: Rule, Block: Block, DeclarationList: DeclarationList }) {
    return {
        Atrule: {
            StyleSheet: StyleSheet,
            Atrule: Atrule,
            Rule: Rule,
            Block: Block
        },
        Rule: {
            StyleSheet: StyleSheet,
            Atrule: Atrule,
            Rule: Rule,
            Block: Block
        },
        Declaration: {
            StyleSheet: StyleSheet,
            Atrule: Atrule,
            Rule: Rule,
            Block: Block,
            DeclarationList: DeclarationList
        }
    };
}
function $021e21228e152a58$export$774c92c6aec941e8(config) {
    const types = $021e21228e152a58$var$getTypesFromConfig(config);
    const iteratorsNatural = {};
    const iteratorsReverse = {};
    const breakWalk = Symbol('break-walk');
    const skipNode = Symbol('skip-node');
    for(const name in types)if ($021e21228e152a58$var$hasOwnProperty.call(types, name) && types[name] !== null) {
        iteratorsNatural[name] = $021e21228e152a58$var$createTypeIterator(types[name], false);
        iteratorsReverse[name] = $021e21228e152a58$var$createTypeIterator(types[name], true);
    }
    const fastTraversalIteratorsNatural = $021e21228e152a58$var$createFastTraveralMap(iteratorsNatural);
    const fastTraversalIteratorsReverse = $021e21228e152a58$var$createFastTraveralMap(iteratorsReverse);
    const walk = function(root, options) {
        function walkNode(node, item, list) {
            const enterRet = enter.call(context, node, item, list);
            if (enterRet === breakWalk) return true;
            if (enterRet === skipNode) return false;
            if (iterators.hasOwnProperty(node.type)) {
                if (iterators[node.type](node, context, walkNode, walkReducer)) return true;
            }
            if (leave.call(context, node, item, list) === breakWalk) return true;
            return false;
        }
        let enter = $021e21228e152a58$var$noop;
        let leave = $021e21228e152a58$var$noop;
        let iterators = iteratorsNatural;
        let walkReducer = (ret, data, item, list)=>ret || walkNode(data, item, list);
        const context = {
            break: breakWalk,
            skip: skipNode,
            root: root,
            stylesheet: null,
            atrule: null,
            atrulePrelude: null,
            rule: null,
            selector: null,
            block: null,
            declaration: null,
            function: null
        };
        if (typeof options === 'function') enter = options;
        else if (options) {
            enter = $021e21228e152a58$var$ensureFunction(options.enter);
            leave = $021e21228e152a58$var$ensureFunction(options.leave);
            if (options.reverse) iterators = iteratorsReverse;
            if (options.visit) {
                if (fastTraversalIteratorsNatural.hasOwnProperty(options.visit)) iterators = options.reverse ? fastTraversalIteratorsReverse[options.visit] : fastTraversalIteratorsNatural[options.visit];
                else if (!types.hasOwnProperty(options.visit)) throw new Error('Bad value `' + options.visit + '` for `visit` option (should be: ' + Object.keys(types).sort().join(', ') + ')');
                enter = $021e21228e152a58$var$invokeForType(enter, options.visit);
                leave = $021e21228e152a58$var$invokeForType(leave, options.visit);
            }
        }
        if (enter === $021e21228e152a58$var$noop && leave === $021e21228e152a58$var$noop) throw new Error('Neither `enter` nor `leave` walker handler is set or both aren\'t a function');
        walkNode(root);
    };
    walk.break = breakWalk;
    walk.skip = skipNode;
    walk.find = function(ast, fn) {
        let found = null;
        walk(ast, function(node, item, list) {
            if (fn.call(this, node, item, list)) {
                found = node;
                return breakWalk;
            }
        });
        return found;
    };
    walk.findLast = function(ast, fn) {
        let found = null;
        walk(ast, {
            reverse: true,
            enter (node, item, list) {
                if (fn.call(this, node, item, list)) {
                    found = node;
                    return breakWalk;
                }
            }
        });
        return found;
    };
    walk.findAll = function(ast, fn) {
        const found = [];
        walk(ast, function(node, item, list) {
            if (fn.call(this, node, item, list)) found.push(node);
        });
        return found;
    };
    return walk;
}



function $87a319d4b88869d2$var$noop(value) {
    return value;
}
function $87a319d4b88869d2$var$generateMultiplier(multiplier) {
    const { min: min, max: max, comma: comma } = multiplier;
    if (min === 0 && max === 0) return comma ? '#?' : '*';
    if (min === 0 && max === 1) return '?';
    if (min === 1 && max === 0) return comma ? '#' : '+';
    if (min === 1 && max === 1) return '';
    return (comma ? '#' : '') + (min === max ? '{' + min + '}' : '{' + min + ',' + (max !== 0 ? max : '') + '}');
}
function $87a319d4b88869d2$var$generateTypeOpts(node) {
    switch(node.type){
        case 'Range':
            return ' [' + (node.min === null ? "-\u221E" : node.min) + ',' + (node.max === null ? "\u221E" : node.max) + ']';
        default:
            throw new Error('Unknown node type `' + node.type + '`');
    }
}
function $87a319d4b88869d2$var$generateSequence(node, decorate, forceBraces, compact) {
    const combinator = node.combinator === ' ' || compact ? node.combinator : ' ' + node.combinator + ' ';
    const result = node.terms.map((term)=>$87a319d4b88869d2$var$internalGenerate(term, decorate, forceBraces, compact)).join(combinator);
    if (node.explicit || forceBraces) return (compact || result[0] === ',' ? '[' : '[ ') + result + (compact ? ']' : ' ]');
    return result;
}
function $87a319d4b88869d2$var$internalGenerate(node, decorate, forceBraces, compact) {
    let result;
    switch(node.type){
        case 'Group':
            result = $87a319d4b88869d2$var$generateSequence(node, decorate, forceBraces, compact) + (node.disallowEmpty ? '!' : '');
            break;
        case 'Multiplier':
            // return since node is a composition
            return $87a319d4b88869d2$var$internalGenerate(node.term, decorate, forceBraces, compact) + decorate($87a319d4b88869d2$var$generateMultiplier(node), node);
        case 'Boolean':
            result = '<boolean-expr[' + $87a319d4b88869d2$var$internalGenerate(node.term, decorate, forceBraces, compact) + ']>';
            break;
        case 'Type':
            result = '<' + node.name + (node.opts ? decorate($87a319d4b88869d2$var$generateTypeOpts(node.opts), node.opts) : '') + '>';
            break;
        case 'Property':
            result = '<\'' + node.name + '\'>';
            break;
        case 'Keyword':
            result = node.name;
            break;
        case 'AtKeyword':
            result = '@' + node.name;
            break;
        case 'Function':
            result = node.name + '(';
            break;
        case 'String':
        case 'Token':
            result = node.value;
            break;
        case 'Comma':
            result = ',';
            break;
        default:
            throw new Error('Unknown node type `' + node.type + '`');
    }
    return decorate(result, node);
}
function $87a319d4b88869d2$export$80d376111cc09ad7(node, options) {
    let decorate = $87a319d4b88869d2$var$noop;
    let forceBraces = false;
    let compact = false;
    if (typeof options === 'function') decorate = options;
    else if (options) {
        forceBraces = Boolean(options.forceBraces);
        compact = Boolean(options.compact);
        if (typeof options.decorate === 'function') decorate = options.decorate;
    }
    return $87a319d4b88869d2$var$internalGenerate(node, decorate, forceBraces, compact);
}


const $833883a2fa46ad31$var$defaultLoc = {
    offset: 0,
    line: 1,
    column: 1
};
function $833883a2fa46ad31$var$locateMismatch(matchResult, node) {
    const tokens = matchResult.tokens;
    const longestMatch = matchResult.longestMatch;
    const mismatchNode = longestMatch < tokens.length ? tokens[longestMatch].node || null : null;
    const badNode = mismatchNode !== node ? mismatchNode : null;
    let mismatchOffset = 0;
    let mismatchLength = 0;
    let entries = 0;
    let css = '';
    let start;
    let end;
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i].value;
        if (i === longestMatch) {
            mismatchLength = token.length;
            mismatchOffset = css.length;
        }
        if (badNode !== null && tokens[i].node === badNode) {
            if (i <= longestMatch) entries++;
            else entries = 0;
        }
        css += token;
    }
    if (longestMatch === tokens.length || entries > 1) {
        start = $833883a2fa46ad31$var$fromLoc(badNode || node, 'end') || $833883a2fa46ad31$var$buildLoc($833883a2fa46ad31$var$defaultLoc, css);
        end = $833883a2fa46ad31$var$buildLoc(start);
    } else {
        start = $833883a2fa46ad31$var$fromLoc(badNode, 'start') || $833883a2fa46ad31$var$buildLoc($833883a2fa46ad31$var$fromLoc(node, 'start') || $833883a2fa46ad31$var$defaultLoc, css.slice(0, mismatchOffset));
        end = $833883a2fa46ad31$var$fromLoc(badNode, 'end') || $833883a2fa46ad31$var$buildLoc(start, css.substr(mismatchOffset, mismatchLength));
    }
    return {
        css: css,
        mismatchOffset: mismatchOffset,
        mismatchLength: mismatchLength,
        start: start,
        end: end
    };
}
function $833883a2fa46ad31$var$fromLoc(node, point) {
    const value = node && node.loc && node.loc[point];
    if (value) return 'line' in value ? $833883a2fa46ad31$var$buildLoc(value) : value;
    return null;
}
function $833883a2fa46ad31$var$buildLoc({ offset: offset, line: line, column: column }, extra) {
    const loc = {
        offset: offset,
        line: line,
        column: column
    };
    if (extra) {
        const lines = extra.split(/\n|\r\n?|\f/);
        loc.offset += extra.length;
        loc.line += lines.length - 1;
        loc.column = lines.length === 1 ? loc.column + extra.length : lines.pop().length + 1;
    }
    return loc;
}
const $833883a2fa46ad31$export$65d073607b1def2 = function(type, referenceName) {
    const error = (0, $213a7d565abe4f4a$export$435492119a21bab3)('SyntaxReferenceError', type + (referenceName ? ' `' + referenceName + '`' : ''));
    error.reference = referenceName;
    return error;
};
const $833883a2fa46ad31$export$c937494ee8e9606d = function(message, syntax, node, matchResult) {
    const error = (0, $213a7d565abe4f4a$export$435492119a21bab3)('SyntaxMatchError', message);
    const { css: css, mismatchOffset: mismatchOffset, mismatchLength: mismatchLength, start: start, end: end } = $833883a2fa46ad31$var$locateMismatch(matchResult, node);
    error.rawMessage = message;
    error.syntax = syntax ? (0, $87a319d4b88869d2$export$80d376111cc09ad7)(syntax) : '<generic>';
    error.css = css;
    error.mismatchOffset = mismatchOffset;
    error.mismatchLength = mismatchLength;
    error.message = message + '\n' + '  syntax: ' + error.syntax + '\n' + '   value: ' + (css || '<empty string>') + '\n' + '  --------' + new Array(error.mismatchOffset + 1).join('-') + '^';
    Object.assign(error, start);
    error.loc = {
        source: node && node.loc && node.loc.source || '<unknown>',
        start: start,
        end: end
    };
    return error;
};


const $27cf59322dfdd6cf$var$keywords = new Map();
const $27cf59322dfdd6cf$var$properties = new Map();
const $27cf59322dfdd6cf$var$HYPHENMINUS = 45; // '-'.charCodeAt()
const $27cf59322dfdd6cf$export$2e81050496d0e63e = $27cf59322dfdd6cf$var$getKeywordDescriptor;
const $27cf59322dfdd6cf$export$d541bacb2bda4494 = $27cf59322dfdd6cf$var$getPropertyDescriptor;
const $27cf59322dfdd6cf$export$5150dd39c4b2a5da = $27cf59322dfdd6cf$var$getVendorPrefix;
function $27cf59322dfdd6cf$export$15cf667f7f91c461(str, offset) {
    offset = offset || 0;
    return str.length - offset >= 2 && str.charCodeAt(offset) === $27cf59322dfdd6cf$var$HYPHENMINUS && str.charCodeAt(offset + 1) === $27cf59322dfdd6cf$var$HYPHENMINUS;
}
function $27cf59322dfdd6cf$var$getVendorPrefix(str, offset) {
    offset = offset || 0;
    // verdor prefix should be at least 3 chars length
    if (str.length - offset >= 3) // vendor prefix starts with hyper minus following non-hyper minus
    {
        if (str.charCodeAt(offset) === $27cf59322dfdd6cf$var$HYPHENMINUS && str.charCodeAt(offset + 1) !== $27cf59322dfdd6cf$var$HYPHENMINUS) {
            // vendor prefix should contain a hyper minus at the ending
            const secondDashIndex = str.indexOf('-', offset + 2);
            if (secondDashIndex !== -1) return str.substring(offset, secondDashIndex + 1);
        }
    }
    return '';
}
function $27cf59322dfdd6cf$var$getKeywordDescriptor(keyword) {
    if ($27cf59322dfdd6cf$var$keywords.has(keyword)) return $27cf59322dfdd6cf$var$keywords.get(keyword);
    const name = keyword.toLowerCase();
    let descriptor = $27cf59322dfdd6cf$var$keywords.get(name);
    if (descriptor === undefined) {
        const custom = $27cf59322dfdd6cf$export$15cf667f7f91c461(name, 0);
        const vendor = !custom ? $27cf59322dfdd6cf$var$getVendorPrefix(name, 0) : '';
        descriptor = Object.freeze({
            basename: name.substr(vendor.length),
            name: name,
            prefix: vendor,
            vendor: vendor,
            custom: custom
        });
    }
    $27cf59322dfdd6cf$var$keywords.set(keyword, descriptor);
    return descriptor;
}
function $27cf59322dfdd6cf$var$getPropertyDescriptor(property) {
    if ($27cf59322dfdd6cf$var$properties.has(property)) return $27cf59322dfdd6cf$var$properties.get(property);
    let name = property;
    let hack = property[0];
    if (hack === '/') hack = property[1] === '/' ? '//' : '/';
    else if (hack !== '_' && hack !== '*' && hack !== '$' && hack !== '#' && hack !== '+' && hack !== '&') hack = '';
    const custom = $27cf59322dfdd6cf$export$15cf667f7f91c461(name, hack.length);
    // re-use result when possible (the same as for lower case)
    if (!custom) {
        name = name.toLowerCase();
        if ($27cf59322dfdd6cf$var$properties.has(name)) {
            const descriptor = $27cf59322dfdd6cf$var$properties.get(name);
            $27cf59322dfdd6cf$var$properties.set(property, descriptor);
            return descriptor;
        }
    }
    const vendor = !custom ? $27cf59322dfdd6cf$var$getVendorPrefix(name, hack.length) : '';
    const prefix = name.substr(0, hack.length + vendor.length);
    const descriptor = Object.freeze({
        basename: name.substr(prefix.length),
        name: name.substr(hack.length),
        hack: hack,
        vendor: vendor,
        prefix: prefix,
        custom: custom
    });
    $27cf59322dfdd6cf$var$properties.set(property, descriptor);
    return descriptor;
}


// https://drafts.csswg.org/css-cascade-5/
const $42c1285c91ce4121$export$b3191e0d9e666e2c = [
    'initial',
    'inherit',
    'unset',
    'revert',
    'revert-layer'
];




const $c88d21a8e0d13b6d$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $c88d21a8e0d13b6d$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $c88d21a8e0d13b6d$var$N = 0x006E; // U+006E LATIN SMALL LETTER N (n)
const $c88d21a8e0d13b6d$var$DISALLOW_SIGN = true;
const $c88d21a8e0d13b6d$var$ALLOW_SIGN = false;
function $c88d21a8e0d13b6d$var$isDelim(token, code) {
    return token !== null && token.type === (0, $cb01acaf2e18d562$export$a918ca49ff4337a3) && token.value.charCodeAt(0) === code;
}
function $c88d21a8e0d13b6d$var$skipSC(token, offset, getNextToken) {
    while(token !== null && (token.type === (0, $cb01acaf2e18d562$export$fb98946286ab4c97) || token.type === (0, $cb01acaf2e18d562$export$4d299b491347818a)))token = getNextToken(++offset);
    return offset;
}
function $c88d21a8e0d13b6d$var$checkInteger(token, valueOffset, disallowSign, offset) {
    if (!token) return 0;
    const code = token.value.charCodeAt(valueOffset);
    if (code === $c88d21a8e0d13b6d$var$PLUSSIGN || code === $c88d21a8e0d13b6d$var$HYPHENMINUS) {
        if (disallowSign) // Number sign is not allowed
        return 0;
        valueOffset++;
    }
    for(; valueOffset < token.value.length; valueOffset++){
        if (!(0, $fb47edd266a7fc33$export$727d9dbc4fbb948f)(token.value.charCodeAt(valueOffset))) // Integer is expected
        return 0;
    }
    return offset + 1;
}
// ... <signed-integer>
// ... ['+' | '-'] <signless-integer>
function $c88d21a8e0d13b6d$var$consumeB(token, offset_, getNextToken) {
    let sign = false;
    let offset = $c88d21a8e0d13b6d$var$skipSC(token, offset_, getNextToken);
    token = getNextToken(offset);
    if (token === null) return offset_;
    if (token.type !== (0, $cb01acaf2e18d562$export$fffa67e515d04022)) {
        if ($c88d21a8e0d13b6d$var$isDelim(token, $c88d21a8e0d13b6d$var$PLUSSIGN) || $c88d21a8e0d13b6d$var$isDelim(token, $c88d21a8e0d13b6d$var$HYPHENMINUS)) {
            sign = true;
            offset = $c88d21a8e0d13b6d$var$skipSC(getNextToken(++offset), offset, getNextToken);
            token = getNextToken(offset);
            if (token === null || token.type !== (0, $cb01acaf2e18d562$export$fffa67e515d04022)) return 0;
        } else return offset_;
    }
    if (!sign) {
        const code = token.value.charCodeAt(0);
        if (code !== $c88d21a8e0d13b6d$var$PLUSSIGN && code !== $c88d21a8e0d13b6d$var$HYPHENMINUS) // Number sign is expected
        return 0;
    }
    return $c88d21a8e0d13b6d$var$checkInteger(token, sign ? 0 : 1, sign, offset);
}
function $c88d21a8e0d13b6d$export$2e2bcd8739ae039(token, getNextToken) {
    /* eslint-disable brace-style*/ let offset = 0;
    if (!token) return 0;
    // <integer>
    if (token.type === (0, $cb01acaf2e18d562$export$fffa67e515d04022)) return $c88d21a8e0d13b6d$var$checkInteger(token, 0, $c88d21a8e0d13b6d$var$ALLOW_SIGN, offset); // b
    else if (token.type === (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f) && token.value.charCodeAt(0) === $c88d21a8e0d13b6d$var$HYPHENMINUS) {
        // expect 1st char is N
        if (!(0, $0a1ac1d130312a6d$export$6902610076fb2dc1)(token.value, 1, $c88d21a8e0d13b6d$var$N)) return 0;
        switch(token.value.length){
            // -n
            // -n <signed-integer>
            // -n ['+' | '-'] <signless-integer>
            case 2:
                return $c88d21a8e0d13b6d$var$consumeB(getNextToken(++offset), offset, getNextToken);
            // -n- <signless-integer>
            case 3:
                if (token.value.charCodeAt(2) !== $c88d21a8e0d13b6d$var$HYPHENMINUS) return 0;
                offset = $c88d21a8e0d13b6d$var$skipSC(getNextToken(++offset), offset, getNextToken);
                token = getNextToken(offset);
                return $c88d21a8e0d13b6d$var$checkInteger(token, 0, $c88d21a8e0d13b6d$var$DISALLOW_SIGN, offset);
            // <dashndashdigit-ident>
            default:
                if (token.value.charCodeAt(2) !== $c88d21a8e0d13b6d$var$HYPHENMINUS) return 0;
                return $c88d21a8e0d13b6d$var$checkInteger(token, 3, $c88d21a8e0d13b6d$var$DISALLOW_SIGN, offset);
        }
    } else if (token.type === (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f) || $c88d21a8e0d13b6d$var$isDelim(token, $c88d21a8e0d13b6d$var$PLUSSIGN) && getNextToken(offset + 1).type === (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)) {
        // just ignore a plus
        if (token.type !== (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)) token = getNextToken(++offset);
        if (token === null || !(0, $0a1ac1d130312a6d$export$6902610076fb2dc1)(token.value, 0, $c88d21a8e0d13b6d$var$N)) return 0;
        switch(token.value.length){
            // '+'? n
            // '+'? n <signed-integer>
            // '+'? n ['+' | '-'] <signless-integer>
            case 1:
                return $c88d21a8e0d13b6d$var$consumeB(getNextToken(++offset), offset, getNextToken);
            // '+'? n- <signless-integer>
            case 2:
                if (token.value.charCodeAt(1) !== $c88d21a8e0d13b6d$var$HYPHENMINUS) return 0;
                offset = $c88d21a8e0d13b6d$var$skipSC(getNextToken(++offset), offset, getNextToken);
                token = getNextToken(offset);
                return $c88d21a8e0d13b6d$var$checkInteger(token, 0, $c88d21a8e0d13b6d$var$DISALLOW_SIGN, offset);
            // '+'? <ndashdigit-ident>
            default:
                if (token.value.charCodeAt(1) !== $c88d21a8e0d13b6d$var$HYPHENMINUS) return 0;
                return $c88d21a8e0d13b6d$var$checkInteger(token, 2, $c88d21a8e0d13b6d$var$DISALLOW_SIGN, offset);
        }
    } else if (token.type === (0, $cb01acaf2e18d562$export$c940ece961bc43c6)) {
        let code = token.value.charCodeAt(0);
        let sign = code === $c88d21a8e0d13b6d$var$PLUSSIGN || code === $c88d21a8e0d13b6d$var$HYPHENMINUS ? 1 : 0;
        let i = sign;
        for(; i < token.value.length; i++){
            if (!(0, $fb47edd266a7fc33$export$727d9dbc4fbb948f)(token.value.charCodeAt(i))) break;
        }
        if (i === sign) // Integer is expected
        return 0;
        if (!(0, $0a1ac1d130312a6d$export$6902610076fb2dc1)(token.value, i, $c88d21a8e0d13b6d$var$N)) return 0;
        // <n-dimension>
        // <n-dimension> <signed-integer>
        // <n-dimension> ['+' | '-'] <signless-integer>
        if (i + 1 === token.value.length) return $c88d21a8e0d13b6d$var$consumeB(getNextToken(++offset), offset, getNextToken);
        else {
            if (token.value.charCodeAt(i + 1) !== $c88d21a8e0d13b6d$var$HYPHENMINUS) return 0;
            // <ndash-dimension> <signless-integer>
            if (i + 2 === token.value.length) {
                offset = $c88d21a8e0d13b6d$var$skipSC(getNextToken(++offset), offset, getNextToken);
                token = getNextToken(offset);
                return $c88d21a8e0d13b6d$var$checkInteger(token, 0, $c88d21a8e0d13b6d$var$DISALLOW_SIGN, offset);
            } else return $c88d21a8e0d13b6d$var$checkInteger(token, i + 2, $c88d21a8e0d13b6d$var$DISALLOW_SIGN, offset);
        }
    }
    return 0;
}



const $32b174ca9dbfea22$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $32b174ca9dbfea22$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $32b174ca9dbfea22$var$QUESTIONMARK = 0x003F; // U+003F QUESTION MARK (?)
const $32b174ca9dbfea22$var$U = 0x0075; // U+0075 LATIN SMALL LETTER U (u)
function $32b174ca9dbfea22$var$isDelim(token, code) {
    return token !== null && token.type === (0, $cb01acaf2e18d562$export$a918ca49ff4337a3) && token.value.charCodeAt(0) === code;
}
function $32b174ca9dbfea22$var$startsWith(token, code) {
    return token.value.charCodeAt(0) === code;
}
function $32b174ca9dbfea22$var$hexSequence(token, offset, allowDash) {
    let hexlen = 0;
    for(let pos = offset; pos < token.value.length; pos++){
        const code = token.value.charCodeAt(pos);
        if (code === $32b174ca9dbfea22$var$HYPHENMINUS && allowDash && hexlen !== 0) {
            $32b174ca9dbfea22$var$hexSequence(token, offset + hexlen + 1, false);
            return 6; // dissallow following question marks
        }
        if (!(0, $fb47edd266a7fc33$export$2a81dc4d1a2f9334)(code)) return 0; // not a hex digit
        if (++hexlen > 6) return 0; // too many hex digits
    }
    return hexlen;
}
function $32b174ca9dbfea22$var$withQuestionMarkSequence(consumed, length, getNextToken) {
    if (!consumed) return 0; // nothing consumed
    while($32b174ca9dbfea22$var$isDelim(getNextToken(length), $32b174ca9dbfea22$var$QUESTIONMARK)){
        if (++consumed > 6) return 0; // too many question marks
        length++;
    }
    return length;
}
function $32b174ca9dbfea22$export$2e2bcd8739ae039(token, getNextToken) {
    let length = 0;
    // should start with `u` or `U`
    if (token === null || token.type !== (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f) || !(0, $0a1ac1d130312a6d$export$6902610076fb2dc1)(token.value, 0, $32b174ca9dbfea22$var$U)) return 0;
    token = getNextToken(++length);
    if (token === null) return 0;
    // u '+' <ident-token> '?'*
    // u '+' '?'+
    if ($32b174ca9dbfea22$var$isDelim(token, $32b174ca9dbfea22$var$PLUSSIGN)) {
        token = getNextToken(++length);
        if (token === null) return 0;
        if (token.type === (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)) // u '+' <ident-token> '?'*
        return $32b174ca9dbfea22$var$withQuestionMarkSequence($32b174ca9dbfea22$var$hexSequence(token, 0, true), ++length, getNextToken);
        if ($32b174ca9dbfea22$var$isDelim(token, $32b174ca9dbfea22$var$QUESTIONMARK)) // u '+' '?'+
        return $32b174ca9dbfea22$var$withQuestionMarkSequence(1, ++length, getNextToken);
        // Hex digit or question mark is expected
        return 0;
    }
    // u <number-token> '?'*
    // u <number-token> <dimension-token>
    // u <number-token> <number-token>
    if (token.type === (0, $cb01acaf2e18d562$export$fffa67e515d04022)) {
        const consumedHexLength = $32b174ca9dbfea22$var$hexSequence(token, 1, true);
        if (consumedHexLength === 0) return 0;
        token = getNextToken(++length);
        if (token === null) // u <number-token> <eof>
        return length;
        if (token.type === (0, $cb01acaf2e18d562$export$c940ece961bc43c6) || token.type === (0, $cb01acaf2e18d562$export$fffa67e515d04022)) {
            // u <number-token> <dimension-token>
            // u <number-token> <number-token>
            if (!$32b174ca9dbfea22$var$startsWith(token, $32b174ca9dbfea22$var$HYPHENMINUS) || !$32b174ca9dbfea22$var$hexSequence(token, 1, false)) return 0;
            return length + 1;
        }
        // u <number-token> '?'*
        return $32b174ca9dbfea22$var$withQuestionMarkSequence(consumedHexLength, length, getNextToken);
    }
    // u <dimension-token> '?'*
    if (token.type === (0, $cb01acaf2e18d562$export$c940ece961bc43c6)) return $32b174ca9dbfea22$var$withQuestionMarkSequence($32b174ca9dbfea22$var$hexSequence(token, 1, true), ++length, getNextToken);
    return 0;
}



const $497b63c7a32ea770$var$calcFunctionNames = [
    'calc(',
    '-moz-calc(',
    '-webkit-calc('
];
const $497b63c7a32ea770$var$balancePair = new Map([
    [
        (0, $cb01acaf2e18d562$export$f3890eeaf6851387),
        (0, $cb01acaf2e18d562$export$773d33972c6279ed)
    ],
    [
        (0, $cb01acaf2e18d562$export$b5a25f132cb53de6),
        (0, $cb01acaf2e18d562$export$773d33972c6279ed)
    ],
    [
        (0, $cb01acaf2e18d562$export$cd363bb53c2bb),
        (0, $cb01acaf2e18d562$export$72f933344f701f30)
    ],
    [
        (0, $cb01acaf2e18d562$export$ccdce7304ac66390),
        (0, $cb01acaf2e18d562$export$186d8b1f99e2bfec)
    ]
]);
// safe char code getter
function $497b63c7a32ea770$var$charCodeAt(str, index) {
    return index < str.length ? str.charCodeAt(index) : 0;
}
function $497b63c7a32ea770$var$eqStr(actual, expected) {
    return (0, $0a1ac1d130312a6d$export$5bf4b3d0861be8d9)(actual, 0, actual.length, expected);
}
function $497b63c7a32ea770$var$eqStrAny(actual, expected) {
    for(let i = 0; i < expected.length; i++){
        if ($497b63c7a32ea770$var$eqStr(actual, expected[i])) return true;
    }
    return false;
}
// IE postfix hack, i.e. 123\0 or 123px\9
function $497b63c7a32ea770$var$isPostfixIeHack(str, offset) {
    if (offset !== str.length - 2) return false;
    return $497b63c7a32ea770$var$charCodeAt(str, offset) === 0x005C && // U+005C REVERSE SOLIDUS (\)
    (0, $fb47edd266a7fc33$export$727d9dbc4fbb948f)($497b63c7a32ea770$var$charCodeAt(str, offset + 1));
}
function $497b63c7a32ea770$var$outOfRange(opts, value, numEnd) {
    if (opts && opts.type === 'Range') {
        const num = Number(numEnd !== undefined && numEnd !== value.length ? value.substr(0, numEnd) : value);
        if (isNaN(num)) return true;
        // FIXME: when opts.min is a string it's a dimension, skip a range validation
        // for now since it requires a type covertation which is not implmented yet
        if (opts.min !== null && num < opts.min && typeof opts.min !== 'string') return true;
        // FIXME: when opts.max is a string it's a dimension, skip a range validation
        // for now since it requires a type covertation which is not implmented yet
        if (opts.max !== null && num > opts.max && typeof opts.max !== 'string') return true;
    }
    return false;
}
function $497b63c7a32ea770$var$consumeFunction(token, getNextToken) {
    let balanceCloseType = 0;
    let balanceStash = [];
    let length = 0;
    // balanced token consuming
    scan: do {
        switch(token.type){
            case 0, $cb01acaf2e18d562$export$186d8b1f99e2bfec:
            case 0, $cb01acaf2e18d562$export$773d33972c6279ed:
            case 0, $cb01acaf2e18d562$export$72f933344f701f30:
                if (token.type !== balanceCloseType) break scan;
                balanceCloseType = balanceStash.pop();
                if (balanceStash.length === 0) {
                    length++;
                    break scan;
                }
                break;
            case 0, $cb01acaf2e18d562$export$f3890eeaf6851387:
            case 0, $cb01acaf2e18d562$export$b5a25f132cb53de6:
            case 0, $cb01acaf2e18d562$export$cd363bb53c2bb:
            case 0, $cb01acaf2e18d562$export$ccdce7304ac66390:
                balanceStash.push(balanceCloseType);
                balanceCloseType = $497b63c7a32ea770$var$balancePair.get(token.type);
                break;
        }
        length++;
    }while (token = getNextToken(length));
    return length;
}
// TODO: implement
// can be used wherever <length>, <frequency>, <angle>, <time>, <percentage>, <number>, or <integer> values are allowed
// https://drafts.csswg.org/css-values/#calc-notation
function $497b63c7a32ea770$var$calc(next) {
    return function(token, getNextToken, opts) {
        if (token === null) return 0;
        if (token.type === (0, $cb01acaf2e18d562$export$f3890eeaf6851387) && $497b63c7a32ea770$var$eqStrAny(token.value, $497b63c7a32ea770$var$calcFunctionNames)) return $497b63c7a32ea770$var$consumeFunction(token, getNextToken);
        return next(token, getNextToken, opts);
    };
}
function $497b63c7a32ea770$var$tokenType(expectedTokenType) {
    return function(token) {
        if (token === null || token.type !== expectedTokenType) return 0;
        return 1;
    };
}
// =========================
// Complex types
//
// https://drafts.csswg.org/css-values-4/#custom-idents
// 4.2. Author-defined Identifiers: the <custom-ident> type
// Some properties accept arbitrary author-defined identifiers as a component value.
// This generic data type is denoted by <custom-ident>, and represents any valid CSS identifier
// that would not be misinterpreted as a pre-defined keyword in that property’s value definition.
//
// See also: https://developer.mozilla.org/en-US/docs/Web/CSS/custom-ident
function $497b63c7a32ea770$var$customIdent(token) {
    if (token === null || token.type !== (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)) return 0;
    const name = token.value.toLowerCase();
    // The CSS-wide keywords are not valid <custom-ident>s
    if ($497b63c7a32ea770$var$eqStrAny(name, (0, $42c1285c91ce4121$export$b3191e0d9e666e2c))) return 0;
    // The default keyword is reserved and is also not a valid <custom-ident>
    if ($497b63c7a32ea770$var$eqStr(name, 'default')) return 0;
    // TODO: ignore property specific keywords (as described https://developer.mozilla.org/en-US/docs/Web/CSS/custom-ident)
    // Specifications using <custom-ident> must specify clearly what other keywords
    // are excluded from <custom-ident>, if any—for example by saying that any pre-defined keywords
    // in that property’s value definition are excluded. Excluded keywords are excluded
    // in all ASCII case permutations.
    return 1;
}
// https://drafts.csswg.org/css-values-4/#dashed-idents
// The <dashed-ident> production is a <custom-ident>, with all the case-sensitivity that implies,
// with the additional restriction that it must start with two dashes (U+002D HYPHEN-MINUS).
function $497b63c7a32ea770$var$dashedIdent(token) {
    if (token === null || token.type !== (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)) return 0;
    // ... must start with two dashes (U+002D HYPHEN-MINUS)
    if ($497b63c7a32ea770$var$charCodeAt(token.value, 0) !== 0x002D || $497b63c7a32ea770$var$charCodeAt(token.value, 1) !== 0x002D) return 0;
    return 1;
}
// https://drafts.csswg.org/css-variables/#typedef-custom-property-name
// A custom property is any property whose name starts with two dashes (U+002D HYPHEN-MINUS), like --foo.
// The <custom-property-name> production corresponds to this: it’s defined as any <dashed-ident>
// (a valid identifier that starts with two dashes), except -- itself, which is reserved for future use by CSS.
function $497b63c7a32ea770$var$customPropertyName(token) {
    // ... it’s defined as any <dashed-ident>
    if (!$497b63c7a32ea770$var$dashedIdent(token)) return 0;
    // ... except -- itself, which is reserved for future use by CSS
    if (token.value === '--') return 0;
    return 1;
}
// https://drafts.csswg.org/css-color-4/#hex-notation
// The syntax of a <hex-color> is a <hash-token> token whose value consists of 3, 4, 6, or 8 hexadecimal digits.
// In other words, a hex color is written as a hash character, "#", followed by some number of digits 0-9 or
// letters a-f (the case of the letters doesn’t matter - #00ff00 is identical to #00FF00).
function $497b63c7a32ea770$var$hexColor(token) {
    if (token === null || token.type !== (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd)) return 0;
    const length = token.value.length;
    // valid values (length): #rgb (4), #rgba (5), #rrggbb (7), #rrggbbaa (9)
    if (length !== 4 && length !== 5 && length !== 7 && length !== 9) return 0;
    for(let i = 1; i < length; i++){
        if (!(0, $fb47edd266a7fc33$export$2a81dc4d1a2f9334)($497b63c7a32ea770$var$charCodeAt(token.value, i))) return 0;
    }
    return 1;
}
function $497b63c7a32ea770$var$idSelector(token) {
    if (token === null || token.type !== (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd)) return 0;
    if (!(0, $fb47edd266a7fc33$export$56b48cc5d7560ffb)($497b63c7a32ea770$var$charCodeAt(token.value, 1), $497b63c7a32ea770$var$charCodeAt(token.value, 2), $497b63c7a32ea770$var$charCodeAt(token.value, 3))) return 0;
    return 1;
}
// https://drafts.csswg.org/css-syntax/#any-value
// It represents the entirety of what a valid declaration can have as its value.
function $497b63c7a32ea770$var$declarationValue(token, getNextToken) {
    if (!token) return 0;
    let balanceCloseType = 0;
    let balanceStash = [];
    let length = 0;
    // The <declaration-value> production matches any sequence of one or more tokens,
    // so long as the sequence does not contain ...
    scan: do {
        switch(token.type){
            // ... <bad-string-token>, <bad-url-token>,
            case 0, $cb01acaf2e18d562$export$d273d1be20da6de2:
            case 0, $cb01acaf2e18d562$export$f8b4878501aa4a62:
                break scan;
            // ... unmatched <)-token>, <]-token>, or <}-token>,
            case 0, $cb01acaf2e18d562$export$186d8b1f99e2bfec:
            case 0, $cb01acaf2e18d562$export$773d33972c6279ed:
            case 0, $cb01acaf2e18d562$export$72f933344f701f30:
                if (token.type !== balanceCloseType) break scan;
                balanceCloseType = balanceStash.pop();
                break;
            // ... or top-level <semicolon-token> tokens
            case 0, $cb01acaf2e18d562$export$bedd8b9b04d9dbd:
                if (balanceCloseType === 0) break scan;
                break;
            // ... or <delim-token> tokens with a value of "!"
            case 0, $cb01acaf2e18d562$export$a918ca49ff4337a3:
                if (balanceCloseType === 0 && token.value === '!') break scan;
                break;
            case 0, $cb01acaf2e18d562$export$f3890eeaf6851387:
            case 0, $cb01acaf2e18d562$export$b5a25f132cb53de6:
            case 0, $cb01acaf2e18d562$export$cd363bb53c2bb:
            case 0, $cb01acaf2e18d562$export$ccdce7304ac66390:
                balanceStash.push(balanceCloseType);
                balanceCloseType = $497b63c7a32ea770$var$balancePair.get(token.type);
                break;
        }
        length++;
    }while (token = getNextToken(length));
    return length;
}
// https://drafts.csswg.org/css-syntax/#any-value
// The <any-value> production is identical to <declaration-value>, but also
// allows top-level <semicolon-token> tokens and <delim-token> tokens
// with a value of "!". It represents the entirety of what valid CSS can be in any context.
function $497b63c7a32ea770$var$anyValue(token, getNextToken) {
    if (!token) return 0;
    let balanceCloseType = 0;
    let balanceStash = [];
    let length = 0;
    // The <any-value> production matches any sequence of one or more tokens,
    // so long as the sequence ...
    scan: do {
        switch(token.type){
            // ... does not contain <bad-string-token>, <bad-url-token>,
            case 0, $cb01acaf2e18d562$export$d273d1be20da6de2:
            case 0, $cb01acaf2e18d562$export$f8b4878501aa4a62:
                break scan;
            // ... unmatched <)-token>, <]-token>, or <}-token>,
            case 0, $cb01acaf2e18d562$export$186d8b1f99e2bfec:
            case 0, $cb01acaf2e18d562$export$773d33972c6279ed:
            case 0, $cb01acaf2e18d562$export$72f933344f701f30:
                if (token.type !== balanceCloseType) break scan;
                balanceCloseType = balanceStash.pop();
                break;
            case 0, $cb01acaf2e18d562$export$f3890eeaf6851387:
            case 0, $cb01acaf2e18d562$export$b5a25f132cb53de6:
            case 0, $cb01acaf2e18d562$export$cd363bb53c2bb:
            case 0, $cb01acaf2e18d562$export$ccdce7304ac66390:
                balanceStash.push(balanceCloseType);
                balanceCloseType = $497b63c7a32ea770$var$balancePair.get(token.type);
                break;
        }
        length++;
    }while (token = getNextToken(length));
    return length;
}
// =========================
// Dimensions
//
function $497b63c7a32ea770$var$dimension(type) {
    if (type) type = new Set(type);
    return function(token, getNextToken, opts) {
        if (token === null || token.type !== (0, $cb01acaf2e18d562$export$c940ece961bc43c6)) return 0;
        const numberEnd = (0, $0a1ac1d130312a6d$export$b817115b8219186a)(token.value, 0);
        // check unit
        if (type !== null) {
            // check for IE postfix hack, i.e. 123px\0 or 123px\9
            const reverseSolidusOffset = token.value.indexOf('\\', numberEnd);
            const unit = reverseSolidusOffset === -1 || !$497b63c7a32ea770$var$isPostfixIeHack(token.value, reverseSolidusOffset) ? token.value.substr(numberEnd) : token.value.substring(numberEnd, reverseSolidusOffset);
            if (type.has(unit.toLowerCase()) === false) return 0;
        }
        // check range if specified
        if ($497b63c7a32ea770$var$outOfRange(opts, token.value, numberEnd)) return 0;
        return 1;
    };
}
// =========================
// Percentage
//
// §5.5. Percentages: the <percentage> type
// https://drafts.csswg.org/css-values-4/#percentages
function $497b63c7a32ea770$var$percentage(token, getNextToken, opts) {
    // ... corresponds to the <percentage-token> production
    if (token === null || token.type !== (0, $cb01acaf2e18d562$export$d11913f8a6922aea)) return 0;
    // check range if specified
    if ($497b63c7a32ea770$var$outOfRange(opts, token.value, token.value.length - 1)) return 0;
    return 1;
}
// =========================
// Numeric
//
// https://drafts.csswg.org/css-values-4/#numbers
// The value <zero> represents a literal number with the value 0. Expressions that merely
// evaluate to a <number> with the value 0 (for example, calc(0)) do not match <zero>;
// only literal <number-token>s do.
function $497b63c7a32ea770$var$zero(next) {
    if (typeof next !== 'function') next = function() {
        return 0;
    };
    return function(token, getNextToken, opts) {
        if (token !== null && token.type === (0, $cb01acaf2e18d562$export$fffa67e515d04022)) {
            if (Number(token.value) === 0) return 1;
        }
        return next(token, getNextToken, opts);
    };
}
// § 5.3. Real Numbers: the <number> type
// https://drafts.csswg.org/css-values-4/#numbers
// Number values are denoted by <number>, and represent real numbers, possibly with a fractional component.
// ... It corresponds to the <number-token> production
function $497b63c7a32ea770$var$number(token, getNextToken, opts) {
    if (token === null) return 0;
    const numberEnd = (0, $0a1ac1d130312a6d$export$b817115b8219186a)(token.value, 0);
    const isNumber = numberEnd === token.value.length;
    if (!isNumber && !$497b63c7a32ea770$var$isPostfixIeHack(token.value, numberEnd)) return 0;
    // check range if specified
    if ($497b63c7a32ea770$var$outOfRange(opts, token.value, numberEnd)) return 0;
    return 1;
}
// §5.2. Integers: the <integer> type
// https://drafts.csswg.org/css-values-4/#integers
function $497b63c7a32ea770$var$integer(token, getNextToken, opts) {
    // ... corresponds to a subset of the <number-token> production
    if (token === null || token.type !== (0, $cb01acaf2e18d562$export$fffa67e515d04022)) return 0;
    // The first digit of an integer may be immediately preceded by `-` or `+` to indicate the integer’s sign.
    let i = $497b63c7a32ea770$var$charCodeAt(token.value, 0) === 0x002B || // U+002B PLUS SIGN (+)
    $497b63c7a32ea770$var$charCodeAt(token.value, 0) === 0x002D ? 1 : 0; // U+002D HYPHEN-MINUS (-)
    // When written literally, an integer is one or more decimal digits 0 through 9 ...
    for(; i < token.value.length; i++){
        if (!(0, $fb47edd266a7fc33$export$727d9dbc4fbb948f)($497b63c7a32ea770$var$charCodeAt(token.value, i))) return 0;
    }
    // check range if specified
    if ($497b63c7a32ea770$var$outOfRange(opts, token.value, i)) return 0;
    return 1;
}
const $497b63c7a32ea770$export$a60b91545d7e19fc = {
    'ident-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)),
    'function-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$f3890eeaf6851387)),
    'at-keyword-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac)),
    'hash-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd)),
    'string-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$89b8e0fa65f6a914)),
    'bad-string-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$d273d1be20da6de2)),
    'url-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$59d795186a5d3f58)),
    'bad-url-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$f8b4878501aa4a62)),
    'delim-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$a918ca49ff4337a3)),
    'number-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$fffa67e515d04022)),
    'percentage-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$d11913f8a6922aea)),
    'dimension-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$c940ece961bc43c6)),
    'whitespace-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$fb98946286ab4c97)),
    'CDO-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$521ef26a3002003b)),
    'CDC-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$b0b2bd2d1777c179)),
    'colon-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$e20ebb298016f6)),
    'semicolon-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$bedd8b9b04d9dbd)),
    'comma-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$c06e3ee3b4d233fa)),
    '[-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$cd363bb53c2bb)),
    ']-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$72f933344f701f30)),
    '(-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$b5a25f132cb53de6)),
    ')-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$773d33972c6279ed)),
    '{-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$ccdce7304ac66390)),
    '}-token': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$186d8b1f99e2bfec))
};
const $497b63c7a32ea770$export$54e0a8e52353d69f = {
    // token type aliases
    'string': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$89b8e0fa65f6a914)),
    'ident': $497b63c7a32ea770$var$tokenType((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)),
    // percentage
    'percentage': $497b63c7a32ea770$var$calc($497b63c7a32ea770$var$percentage),
    // numeric
    'zero': $497b63c7a32ea770$var$zero(),
    'number': $497b63c7a32ea770$var$calc($497b63c7a32ea770$var$number),
    'integer': $497b63c7a32ea770$var$calc($497b63c7a32ea770$var$integer),
    // complex types
    'custom-ident': $497b63c7a32ea770$var$customIdent,
    'dashed-ident': $497b63c7a32ea770$var$dashedIdent,
    'custom-property-name': $497b63c7a32ea770$var$customPropertyName,
    'hex-color': $497b63c7a32ea770$var$hexColor,
    'id-selector': $497b63c7a32ea770$var$idSelector,
    'an-plus-b': (0, $c88d21a8e0d13b6d$export$2e2bcd8739ae039),
    'urange': (0, $32b174ca9dbfea22$export$2e2bcd8739ae039),
    'declaration-value': $497b63c7a32ea770$var$declarationValue,
    'any-value': $497b63c7a32ea770$var$anyValue
};
const $497b63c7a32ea770$export$9708f157d9d54001 = [
    'length',
    'angle',
    'time',
    'frequency',
    'resolution',
    'flex',
    'decibel',
    'semitones'
];
function $497b63c7a32ea770$export$3a397ce06158d118(units) {
    const { angle: angle, decibel: decibel, frequency: frequency, flex: flex, length: length, resolution: resolution, semitones: semitones, time: time } = units || {};
    return {
        'dimension': $497b63c7a32ea770$var$calc($497b63c7a32ea770$var$dimension(null)),
        'angle': $497b63c7a32ea770$var$calc($497b63c7a32ea770$var$dimension(angle)),
        'decibel': $497b63c7a32ea770$var$calc($497b63c7a32ea770$var$dimension(decibel)),
        'frequency': $497b63c7a32ea770$var$calc($497b63c7a32ea770$var$dimension(frequency)),
        'flex': $497b63c7a32ea770$var$calc($497b63c7a32ea770$var$dimension(flex)),
        'length': $497b63c7a32ea770$var$calc($497b63c7a32ea770$var$zero($497b63c7a32ea770$var$dimension(length))),
        'resolution': $497b63c7a32ea770$var$calc($497b63c7a32ea770$var$dimension(resolution)),
        'semitones': $497b63c7a32ea770$var$calc($497b63c7a32ea770$var$dimension(semitones)),
        'time': $497b63c7a32ea770$var$calc($497b63c7a32ea770$var$dimension(time))
    };
}
function $497b63c7a32ea770$export$604ad466d301d4c1(units) {
    return {
        ...$497b63c7a32ea770$export$a60b91545d7e19fc,
        ...$497b63c7a32ea770$export$54e0a8e52353d69f,
        ...$497b63c7a32ea770$export$3a397ce06158d118(units)
    };
}


var $3b79d1ef8f2d2506$exports = {};

$parcel$export($3b79d1ef8f2d2506$exports, "length", function () { return $3b79d1ef8f2d2506$export$f24224f1c91d8156; });
$parcel$export($3b79d1ef8f2d2506$exports, "angle", function () { return $3b79d1ef8f2d2506$export$944b09d2ad10b378; });
$parcel$export($3b79d1ef8f2d2506$exports, "time", function () { return $3b79d1ef8f2d2506$export$2da9be4cfdb689b1; });
$parcel$export($3b79d1ef8f2d2506$exports, "frequency", function () { return $3b79d1ef8f2d2506$export$7ca27958f28e2974; });
$parcel$export($3b79d1ef8f2d2506$exports, "resolution", function () { return $3b79d1ef8f2d2506$export$52a39240d8d11a18; });
$parcel$export($3b79d1ef8f2d2506$exports, "flex", function () { return $3b79d1ef8f2d2506$export$97691fbb80847c19; });
$parcel$export($3b79d1ef8f2d2506$exports, "decibel", function () { return $3b79d1ef8f2d2506$export$b8ba4f24940bcb75; });
$parcel$export($3b79d1ef8f2d2506$exports, "semitones", function () { return $3b79d1ef8f2d2506$export$e36da636a01ffefa; });
const $3b79d1ef8f2d2506$export$f24224f1c91d8156 = [
    // absolute length units https://www.w3.org/TR/css-values-3/#lengths
    'cm',
    'mm',
    'q',
    'in',
    'pt',
    'pc',
    'px',
    // font-relative length units https://drafts.csswg.org/css-values-4/#font-relative-lengths
    'em',
    'rem',
    'ex',
    'rex',
    'cap',
    'rcap',
    'ch',
    'rch',
    'ic',
    'ric',
    'lh',
    'rlh',
    // viewport-percentage lengths https://drafts.csswg.org/css-values-4/#viewport-relative-lengths
    'vw',
    'svw',
    'lvw',
    'dvw',
    'vh',
    'svh',
    'lvh',
    'dvh',
    'vi',
    'svi',
    'lvi',
    'dvi',
    'vb',
    'svb',
    'lvb',
    'dvb',
    'vmin',
    'svmin',
    'lvmin',
    'dvmin',
    'vmax',
    'svmax',
    'lvmax',
    'dvmax',
    // container relative lengths https://drafts.csswg.org/css-contain-3/#container-lengths
    'cqw',
    'cqh',
    'cqi',
    'cqb',
    'cqmin',
    'cqmax'
];
const $3b79d1ef8f2d2506$export$944b09d2ad10b378 = [
    'deg',
    'grad',
    'rad',
    'turn'
]; // https://www.w3.org/TR/css-values-3/#angles
const $3b79d1ef8f2d2506$export$2da9be4cfdb689b1 = [
    's',
    'ms'
]; // https://www.w3.org/TR/css-values-3/#time
const $3b79d1ef8f2d2506$export$7ca27958f28e2974 = [
    'hz',
    'khz'
]; // https://www.w3.org/TR/css-values-3/#frequency
const $3b79d1ef8f2d2506$export$52a39240d8d11a18 = [
    'dpi',
    'dpcm',
    'dppx',
    'x'
]; // https://www.w3.org/TR/css-values-3/#resolution
const $3b79d1ef8f2d2506$export$97691fbb80847c19 = [
    'fr'
]; // https://drafts.csswg.org/css-grid/#fr-unit
const $3b79d1ef8f2d2506$export$b8ba4f24940bcb75 = [
    'db'
]; // https://www.w3.org/TR/css3-speech/#mixing-props-voice-volume
const $3b79d1ef8f2d2506$export$e36da636a01ffefa = [
    'st'
]; // https://www.w3.org/TR/css3-speech/#voice-props-voice-pitch



function $6c5bb9a79146c47f$export$f21cea08b0dd60e8(message, input, offset) {
    return Object.assign((0, $213a7d565abe4f4a$export$435492119a21bab3)('SyntaxError', message), {
        input: input,
        offset: offset,
        rawMessage: message,
        message: message + '\n' + '  ' + input + '\n' + '--' + new Array((offset || input.length) + 1).join('-') + '^'
    });
}




const $f9e5840ab0042aa3$var$TAB = 9;
const $f9e5840ab0042aa3$var$N = 10;
const $f9e5840ab0042aa3$var$F = 12;
const $f9e5840ab0042aa3$var$R = 13;
const $f9e5840ab0042aa3$var$SPACE = 32;
const $f9e5840ab0042aa3$var$NAME_CHAR = new Uint8Array(128).map((_, idx)=>/[a-zA-Z0-9\-]/.test(String.fromCharCode(idx)) ? 1 : 0);
class $f9e5840ab0042aa3$export$2da42535f3a161df {
    constructor(str){
        this.str = str;
        this.pos = 0;
    }
    charCodeAt(pos) {
        return pos < this.str.length ? this.str.charCodeAt(pos) : 0;
    }
    charCode() {
        return this.charCodeAt(this.pos);
    }
    isNameCharCode(code = this.charCode()) {
        return code < 128 && $f9e5840ab0042aa3$var$NAME_CHAR[code] === 1;
    }
    nextCharCode() {
        return this.charCodeAt(this.pos + 1);
    }
    nextNonWsCode(pos) {
        return this.charCodeAt(this.findWsEnd(pos));
    }
    skipWs() {
        this.pos = this.findWsEnd(this.pos);
    }
    findWsEnd(pos) {
        for(; pos < this.str.length; pos++){
            const code = this.str.charCodeAt(pos);
            if (code !== $f9e5840ab0042aa3$var$R && code !== $f9e5840ab0042aa3$var$N && code !== $f9e5840ab0042aa3$var$F && code !== $f9e5840ab0042aa3$var$SPACE && code !== $f9e5840ab0042aa3$var$TAB) break;
        }
        return pos;
    }
    substringToPos(end) {
        return this.str.substring(this.pos, this.pos = end);
    }
    eat(code) {
        if (this.charCode() !== code) this.error('Expect `' + String.fromCharCode(code) + '`');
        this.pos++;
    }
    peek() {
        return this.pos < this.str.length ? this.str.charAt(this.pos++) : '';
    }
    error(message) {
        throw new (0, $6c5bb9a79146c47f$export$f21cea08b0dd60e8)(message, this.str, this.pos);
    }
    scanSpaces() {
        return this.substringToPos(this.findWsEnd(this.pos));
    }
    scanWord() {
        let end = this.pos;
        for(; end < this.str.length; end++){
            const code = this.str.charCodeAt(end);
            if (code >= 128 || $f9e5840ab0042aa3$var$NAME_CHAR[code] === 0) break;
        }
        if (this.pos === end) this.error('Expect a keyword');
        return this.substringToPos(end);
    }
    scanNumber() {
        let end = this.pos;
        for(; end < this.str.length; end++){
            const code = this.str.charCodeAt(end);
            if (code < 48 || code > 57) break;
        }
        if (this.pos === end) this.error('Expect a number');
        return this.substringToPos(end);
    }
    scanString() {
        const end = this.str.indexOf('\'', this.pos + 1);
        if (end === -1) {
            this.pos = this.str.length;
            this.error('Expect an apostrophe');
        }
        return this.substringToPos(end + 1);
    }
}


const $2569dc2ad06cb2df$var$TAB = 9;
const $2569dc2ad06cb2df$var$N = 10;
const $2569dc2ad06cb2df$var$F = 12;
const $2569dc2ad06cb2df$var$R = 13;
const $2569dc2ad06cb2df$var$SPACE = 32;
const $2569dc2ad06cb2df$var$EXCLAMATIONMARK = 33; // !
const $2569dc2ad06cb2df$var$NUMBERSIGN = 35; // #
const $2569dc2ad06cb2df$var$AMPERSAND = 38; // &
const $2569dc2ad06cb2df$var$APOSTROPHE = 39; // '
const $2569dc2ad06cb2df$var$LEFTPARENTHESIS = 40; // (
const $2569dc2ad06cb2df$var$RIGHTPARENTHESIS = 41; // )
const $2569dc2ad06cb2df$var$ASTERISK = 42; // *
const $2569dc2ad06cb2df$var$PLUSSIGN = 43; // +
const $2569dc2ad06cb2df$var$COMMA = 44; // ,
const $2569dc2ad06cb2df$var$HYPERMINUS = 45; // -
const $2569dc2ad06cb2df$var$LESSTHANSIGN = 60; // <
const $2569dc2ad06cb2df$var$GREATERTHANSIGN = 62; // >
const $2569dc2ad06cb2df$var$QUESTIONMARK = 63; // ?
const $2569dc2ad06cb2df$var$COMMERCIALAT = 64; // @
const $2569dc2ad06cb2df$var$LEFTSQUAREBRACKET = 91; // [
const $2569dc2ad06cb2df$var$RIGHTSQUAREBRACKET = 93; // ]
const $2569dc2ad06cb2df$var$LEFTCURLYBRACKET = 123; // {
const $2569dc2ad06cb2df$var$VERTICALLINE = 124; // |
const $2569dc2ad06cb2df$var$RIGHTCURLYBRACKET = 125; // }
const $2569dc2ad06cb2df$var$INFINITY = 8734; // ∞
const $2569dc2ad06cb2df$var$COMBINATOR_PRECEDENCE = {
    ' ': 1,
    '&&': 2,
    '||': 3,
    '|': 4
};
function $2569dc2ad06cb2df$var$readMultiplierRange(scanner) {
    let min = null;
    let max = null;
    scanner.eat($2569dc2ad06cb2df$var$LEFTCURLYBRACKET);
    scanner.skipWs();
    min = scanner.scanNumber(scanner);
    scanner.skipWs();
    if (scanner.charCode() === $2569dc2ad06cb2df$var$COMMA) {
        scanner.pos++;
        scanner.skipWs();
        if (scanner.charCode() !== $2569dc2ad06cb2df$var$RIGHTCURLYBRACKET) {
            max = scanner.scanNumber(scanner);
            scanner.skipWs();
        }
    } else max = min;
    scanner.eat($2569dc2ad06cb2df$var$RIGHTCURLYBRACKET);
    return {
        min: Number(min),
        max: max ? Number(max) : 0
    };
}
function $2569dc2ad06cb2df$var$readMultiplier(scanner) {
    let range = null;
    let comma = false;
    switch(scanner.charCode()){
        case $2569dc2ad06cb2df$var$ASTERISK:
            scanner.pos++;
            range = {
                min: 0,
                max: 0
            };
            break;
        case $2569dc2ad06cb2df$var$PLUSSIGN:
            scanner.pos++;
            range = {
                min: 1,
                max: 0
            };
            break;
        case $2569dc2ad06cb2df$var$QUESTIONMARK:
            scanner.pos++;
            range = {
                min: 0,
                max: 1
            };
            break;
        case $2569dc2ad06cb2df$var$NUMBERSIGN:
            scanner.pos++;
            comma = true;
            if (scanner.charCode() === $2569dc2ad06cb2df$var$LEFTCURLYBRACKET) range = $2569dc2ad06cb2df$var$readMultiplierRange(scanner);
            else if (scanner.charCode() === $2569dc2ad06cb2df$var$QUESTIONMARK) {
                // https://www.w3.org/TR/css-values-4/#component-multipliers
                // > the # and ? multipliers may be stacked as #?
                // In this case just treat "#?" as a single multiplier
                // { min: 0, max: 0, comma: true }
                scanner.pos++;
                range = {
                    min: 0,
                    max: 0
                };
            } else range = {
                min: 1,
                max: 0
            };
            break;
        case $2569dc2ad06cb2df$var$LEFTCURLYBRACKET:
            range = $2569dc2ad06cb2df$var$readMultiplierRange(scanner);
            break;
        default:
            return null;
    }
    return {
        type: 'Multiplier',
        comma: comma,
        min: range.min,
        max: range.max,
        term: null
    };
}
function $2569dc2ad06cb2df$var$maybeMultiplied(scanner, node) {
    const multiplier = $2569dc2ad06cb2df$var$readMultiplier(scanner);
    if (multiplier !== null) {
        multiplier.term = node;
        // https://www.w3.org/TR/css-values-4/#component-multipliers
        // > The + and # multipliers may be stacked as +#;
        // Represent "+#" as nested multipliers:
        // { ...<multiplier #>,
        //   term: {
        //     ...<multipler +>,
        //     term: node
        //   }
        // }
        if (scanner.charCode() === $2569dc2ad06cb2df$var$NUMBERSIGN && scanner.charCodeAt(scanner.pos - 1) === $2569dc2ad06cb2df$var$PLUSSIGN) return $2569dc2ad06cb2df$var$maybeMultiplied(scanner, multiplier);
        return multiplier;
    }
    return node;
}
function $2569dc2ad06cb2df$var$maybeToken(scanner) {
    const ch = scanner.peek();
    if (ch === '') return null;
    return $2569dc2ad06cb2df$var$maybeMultiplied(scanner, {
        type: 'Token',
        value: ch
    });
}
function $2569dc2ad06cb2df$var$readProperty(scanner) {
    let name;
    scanner.eat($2569dc2ad06cb2df$var$LESSTHANSIGN);
    scanner.eat($2569dc2ad06cb2df$var$APOSTROPHE);
    name = scanner.scanWord();
    scanner.eat($2569dc2ad06cb2df$var$APOSTROPHE);
    scanner.eat($2569dc2ad06cb2df$var$GREATERTHANSIGN);
    return $2569dc2ad06cb2df$var$maybeMultiplied(scanner, {
        type: 'Property',
        name: name
    });
}
// https://drafts.csswg.org/css-values-3/#numeric-ranges
// 4.1. Range Restrictions and Range Definition Notation
//
// Range restrictions can be annotated in the numeric type notation using CSS bracketed
// range notation—[min,max]—within the angle brackets, after the identifying keyword,
// indicating a closed range between (and including) min and max.
// For example, <integer [0, 10]> indicates an integer between 0 and 10, inclusive.
function $2569dc2ad06cb2df$var$readTypeRange(scanner) {
    // use null for Infinity to make AST format JSON serializable/deserializable
    let min = null; // -Infinity
    let max = null; // Infinity
    let sign = 1;
    scanner.eat($2569dc2ad06cb2df$var$LEFTSQUAREBRACKET);
    if (scanner.charCode() === $2569dc2ad06cb2df$var$HYPERMINUS) {
        scanner.peek();
        sign = -1;
    }
    if (sign == -1 && scanner.charCode() === $2569dc2ad06cb2df$var$INFINITY) scanner.peek();
    else {
        min = sign * Number(scanner.scanNumber(scanner));
        if (scanner.isNameCharCode()) min += scanner.scanWord();
    }
    scanner.skipWs();
    scanner.eat($2569dc2ad06cb2df$var$COMMA);
    scanner.skipWs();
    if (scanner.charCode() === $2569dc2ad06cb2df$var$INFINITY) scanner.peek();
    else {
        sign = 1;
        if (scanner.charCode() === $2569dc2ad06cb2df$var$HYPERMINUS) {
            scanner.peek();
            sign = -1;
        }
        max = sign * Number(scanner.scanNumber(scanner));
        if (scanner.isNameCharCode()) max += scanner.scanWord();
    }
    scanner.eat($2569dc2ad06cb2df$var$RIGHTSQUAREBRACKET);
    return {
        type: 'Range',
        min: min,
        max: max
    };
}
function $2569dc2ad06cb2df$var$readType(scanner) {
    let name;
    let opts = null;
    scanner.eat($2569dc2ad06cb2df$var$LESSTHANSIGN);
    name = scanner.scanWord();
    // https://drafts.csswg.org/css-values-5/#boolean
    if (name === 'boolean-expr') {
        scanner.eat($2569dc2ad06cb2df$var$LEFTSQUAREBRACKET);
        const implicitGroup = $2569dc2ad06cb2df$var$readImplicitGroup(scanner, $2569dc2ad06cb2df$var$RIGHTSQUAREBRACKET);
        scanner.eat($2569dc2ad06cb2df$var$RIGHTSQUAREBRACKET);
        scanner.eat($2569dc2ad06cb2df$var$GREATERTHANSIGN);
        return $2569dc2ad06cb2df$var$maybeMultiplied(scanner, {
            type: 'Boolean',
            term: implicitGroup.terms.length === 1 ? implicitGroup.terms[0] : implicitGroup
        });
    }
    if (scanner.charCode() === $2569dc2ad06cb2df$var$LEFTPARENTHESIS && scanner.nextCharCode() === $2569dc2ad06cb2df$var$RIGHTPARENTHESIS) {
        scanner.pos += 2;
        name += '()';
    }
    if (scanner.charCodeAt(scanner.findWsEnd(scanner.pos)) === $2569dc2ad06cb2df$var$LEFTSQUAREBRACKET) {
        scanner.skipWs();
        opts = $2569dc2ad06cb2df$var$readTypeRange(scanner);
    }
    scanner.eat($2569dc2ad06cb2df$var$GREATERTHANSIGN);
    return $2569dc2ad06cb2df$var$maybeMultiplied(scanner, {
        type: 'Type',
        name: name,
        opts: opts
    });
}
function $2569dc2ad06cb2df$var$readKeywordOrFunction(scanner) {
    const name = scanner.scanWord();
    if (scanner.charCode() === $2569dc2ad06cb2df$var$LEFTPARENTHESIS) {
        scanner.pos++;
        return {
            type: 'Function',
            name: name
        };
    }
    return $2569dc2ad06cb2df$var$maybeMultiplied(scanner, {
        type: 'Keyword',
        name: name
    });
}
function $2569dc2ad06cb2df$var$regroupTerms(terms, combinators) {
    function createGroup(terms, combinator) {
        return {
            type: 'Group',
            terms: terms,
            combinator: combinator,
            disallowEmpty: false,
            explicit: false
        };
    }
    let combinator;
    combinators = Object.keys(combinators).sort((a, b)=>$2569dc2ad06cb2df$var$COMBINATOR_PRECEDENCE[a] - $2569dc2ad06cb2df$var$COMBINATOR_PRECEDENCE[b]);
    while(combinators.length > 0){
        combinator = combinators.shift();
        let i = 0;
        let subgroupStart = 0;
        for(; i < terms.length; i++){
            const term = terms[i];
            if (term.type === 'Combinator') {
                if (term.value === combinator) {
                    if (subgroupStart === -1) subgroupStart = i - 1;
                    terms.splice(i, 1);
                    i--;
                } else {
                    if (subgroupStart !== -1 && i - subgroupStart > 1) {
                        terms.splice(subgroupStart, i - subgroupStart, createGroup(terms.slice(subgroupStart, i), combinator));
                        i = subgroupStart + 1;
                    }
                    subgroupStart = -1;
                }
            }
        }
        if (subgroupStart !== -1 && combinators.length) terms.splice(subgroupStart, i - subgroupStart, createGroup(terms.slice(subgroupStart, i), combinator));
    }
    return combinator;
}
function $2569dc2ad06cb2df$var$readImplicitGroup(scanner, stopCharCode) {
    const combinators = Object.create(null);
    const terms = [];
    let token;
    let prevToken = null;
    let prevTokenPos = scanner.pos;
    while(scanner.charCode() !== stopCharCode && (token = $2569dc2ad06cb2df$var$peek(scanner, stopCharCode)))if (token.type !== 'Spaces') {
        if (token.type === 'Combinator') {
            // check for combinator in group beginning and double combinator sequence
            if (prevToken === null || prevToken.type === 'Combinator') {
                scanner.pos = prevTokenPos;
                scanner.error('Unexpected combinator');
            }
            combinators[token.value] = true;
        } else if (prevToken !== null && prevToken.type !== 'Combinator') {
            combinators[' '] = true; // a b
            terms.push({
                type: 'Combinator',
                value: ' '
            });
        }
        terms.push(token);
        prevToken = token;
        prevTokenPos = scanner.pos;
    }
    // check for combinator in group ending
    if (prevToken !== null && prevToken.type === 'Combinator') {
        scanner.pos -= prevTokenPos;
        scanner.error('Unexpected combinator');
    }
    return {
        type: 'Group',
        terms: terms,
        combinator: $2569dc2ad06cb2df$var$regroupTerms(terms, combinators) || ' ',
        disallowEmpty: false,
        explicit: false
    };
}
function $2569dc2ad06cb2df$var$readGroup(scanner, stopCharCode) {
    let result;
    scanner.eat($2569dc2ad06cb2df$var$LEFTSQUAREBRACKET);
    result = $2569dc2ad06cb2df$var$readImplicitGroup(scanner, stopCharCode);
    scanner.eat($2569dc2ad06cb2df$var$RIGHTSQUAREBRACKET);
    result.explicit = true;
    if (scanner.charCode() === $2569dc2ad06cb2df$var$EXCLAMATIONMARK) {
        scanner.pos++;
        result.disallowEmpty = true;
    }
    return result;
}
function $2569dc2ad06cb2df$var$peek(scanner, stopCharCode) {
    let code = scanner.charCode();
    switch(code){
        case $2569dc2ad06cb2df$var$RIGHTSQUAREBRACKET:
            break;
        case $2569dc2ad06cb2df$var$LEFTSQUAREBRACKET:
            return $2569dc2ad06cb2df$var$maybeMultiplied(scanner, $2569dc2ad06cb2df$var$readGroup(scanner, stopCharCode));
        case $2569dc2ad06cb2df$var$LESSTHANSIGN:
            return scanner.nextCharCode() === $2569dc2ad06cb2df$var$APOSTROPHE ? $2569dc2ad06cb2df$var$readProperty(scanner) : $2569dc2ad06cb2df$var$readType(scanner);
        case $2569dc2ad06cb2df$var$VERTICALLINE:
            return {
                type: 'Combinator',
                value: scanner.substringToPos(scanner.pos + (scanner.nextCharCode() === $2569dc2ad06cb2df$var$VERTICALLINE ? 2 : 1))
            };
        case $2569dc2ad06cb2df$var$AMPERSAND:
            scanner.pos++;
            scanner.eat($2569dc2ad06cb2df$var$AMPERSAND);
            return {
                type: 'Combinator',
                value: '&&'
            };
        case $2569dc2ad06cb2df$var$COMMA:
            scanner.pos++;
            return {
                type: 'Comma'
            };
        case $2569dc2ad06cb2df$var$APOSTROPHE:
            return $2569dc2ad06cb2df$var$maybeMultiplied(scanner, {
                type: 'String',
                value: scanner.scanString()
            });
        case $2569dc2ad06cb2df$var$SPACE:
        case $2569dc2ad06cb2df$var$TAB:
        case $2569dc2ad06cb2df$var$N:
        case $2569dc2ad06cb2df$var$R:
        case $2569dc2ad06cb2df$var$F:
            return {
                type: 'Spaces',
                value: scanner.scanSpaces()
            };
        case $2569dc2ad06cb2df$var$COMMERCIALAT:
            code = scanner.nextCharCode();
            if (scanner.isNameCharCode(code)) {
                scanner.pos++;
                return {
                    type: 'AtKeyword',
                    name: scanner.scanWord()
                };
            }
            return $2569dc2ad06cb2df$var$maybeToken(scanner);
        case $2569dc2ad06cb2df$var$ASTERISK:
        case $2569dc2ad06cb2df$var$PLUSSIGN:
        case $2569dc2ad06cb2df$var$QUESTIONMARK:
        case $2569dc2ad06cb2df$var$NUMBERSIGN:
        case $2569dc2ad06cb2df$var$EXCLAMATIONMARK:
            break;
        case $2569dc2ad06cb2df$var$LEFTCURLYBRACKET:
            // LEFTCURLYBRACKET is allowed since mdn/data uses it w/o quoting
            // check next char isn't a number, because it's likely a disjoined multiplier
            code = scanner.nextCharCode();
            if (code < 48 || code > 57) return $2569dc2ad06cb2df$var$maybeToken(scanner);
            break;
        default:
            if (scanner.isNameCharCode(code)) return $2569dc2ad06cb2df$var$readKeywordOrFunction(scanner);
            return $2569dc2ad06cb2df$var$maybeToken(scanner);
    }
}
function $2569dc2ad06cb2df$export$98e6a39c04603d36(source) {
    const scanner = new (0, $f9e5840ab0042aa3$export$2da42535f3a161df)(source);
    const result = $2569dc2ad06cb2df$var$readImplicitGroup(scanner);
    if (scanner.pos !== source.length) scanner.error('Unexpected input');
    // reduce redundant groups with single group term
    if (result.terms.length === 1 && result.terms[0].type === 'Group') return result.terms[0];
    return result;
}


const $70a5e6af7d4aa4b1$var$noop = function() {};
function $70a5e6af7d4aa4b1$var$ensureFunction(value) {
    return typeof value === 'function' ? value : $70a5e6af7d4aa4b1$var$noop;
}
function $70a5e6af7d4aa4b1$export$588732934346abbf(node, options, context) {
    function walk(node) {
        enter.call(context, node);
        switch(node.type){
            case 'Group':
                node.terms.forEach(walk);
                break;
            case 'Multiplier':
            case 'Boolean':
                walk(node.term);
                break;
            case 'Type':
            case 'Property':
            case 'Keyword':
            case 'AtKeyword':
            case 'Function':
            case 'String':
            case 'Token':
            case 'Comma':
                break;
            default:
                throw new Error('Unknown type: ' + node.type);
        }
        leave.call(context, node);
    }
    let enter = $70a5e6af7d4aa4b1$var$noop;
    let leave = $70a5e6af7d4aa4b1$var$noop;
    if (typeof options === 'function') enter = options;
    else if (options) {
        enter = $70a5e6af7d4aa4b1$var$ensureFunction(options.enter);
        leave = $70a5e6af7d4aa4b1$var$ensureFunction(options.leave);
    }
    if (enter === $70a5e6af7d4aa4b1$var$noop && leave === $70a5e6af7d4aa4b1$var$noop) throw new Error('Neither `enter` nor `leave` walker handler is set or both aren\'t a function');
    walk(node, context);
}





const $673f8d43542c2ea7$var$astToTokens = {
    decorator (handlers) {
        const tokens = [];
        let curNode = null;
        return {
            ...handlers,
            node (node) {
                const tmp = curNode;
                curNode = node;
                handlers.node.call(this, node);
                curNode = tmp;
            },
            emit (value, type, auto) {
                tokens.push({
                    type: type,
                    value: value,
                    node: auto ? null : curNode
                });
            },
            result () {
                return tokens;
            }
        };
    }
};
function $673f8d43542c2ea7$var$stringToTokens(str) {
    const tokens = [];
    (0, $852eae0c0686a388$export$660b2ee2d4fb4eff)(str, (type, start, end)=>tokens.push({
            type: type,
            value: str.slice(start, end),
            node: null
        }));
    return tokens;
}
function $673f8d43542c2ea7$export$2e2bcd8739ae039(value, syntax) {
    if (typeof value === 'string') return $673f8d43542c2ea7$var$stringToTokens(value);
    return syntax.generate(value, $673f8d43542c2ea7$var$astToTokens);
}



const $3d61a161f79f46c9$export$5a1a83be8f503735 = {
    type: 'Match'
};
const $3d61a161f79f46c9$export$dfbc42837bfccec4 = {
    type: 'Mismatch'
};
const $3d61a161f79f46c9$export$d962e73e7bcd24c = {
    type: 'DisallowEmpty'
};
const $3d61a161f79f46c9$var$LEFTPARENTHESIS = 40; // (
const $3d61a161f79f46c9$var$RIGHTPARENTHESIS = 41; // )
function $3d61a161f79f46c9$var$createCondition(match, thenBranch, elseBranch) {
    // reduce node count
    if (thenBranch === $3d61a161f79f46c9$export$5a1a83be8f503735 && elseBranch === $3d61a161f79f46c9$export$dfbc42837bfccec4) return match;
    if (match === $3d61a161f79f46c9$export$5a1a83be8f503735 && thenBranch === $3d61a161f79f46c9$export$5a1a83be8f503735 && elseBranch === $3d61a161f79f46c9$export$5a1a83be8f503735) return match;
    if (match.type === 'If' && match.else === $3d61a161f79f46c9$export$dfbc42837bfccec4 && thenBranch === $3d61a161f79f46c9$export$5a1a83be8f503735) {
        thenBranch = match.then;
        match = match.match;
    }
    return {
        type: 'If',
        match: match,
        then: thenBranch,
        else: elseBranch
    };
}
function $3d61a161f79f46c9$var$isFunctionType(name) {
    return name.length > 2 && name.charCodeAt(name.length - 2) === $3d61a161f79f46c9$var$LEFTPARENTHESIS && name.charCodeAt(name.length - 1) === $3d61a161f79f46c9$var$RIGHTPARENTHESIS;
}
function $3d61a161f79f46c9$var$isEnumCapatible(term) {
    return term.type === 'Keyword' || term.type === 'AtKeyword' || term.type === 'Function' || term.type === 'Type' && $3d61a161f79f46c9$var$isFunctionType(term.name);
}
function $3d61a161f79f46c9$var$groupNode(terms, combinator = ' ', explicit = false) {
    return {
        type: 'Group',
        terms: terms,
        combinator: combinator,
        disallowEmpty: false,
        explicit: explicit
    };
}
function $3d61a161f79f46c9$var$replaceTypeInGraph(node, replacements, visited = new Set()) {
    if (!visited.has(node)) {
        visited.add(node);
        switch(node.type){
            case 'If':
                node.match = $3d61a161f79f46c9$var$replaceTypeInGraph(node.match, replacements, visited);
                node.then = $3d61a161f79f46c9$var$replaceTypeInGraph(node.then, replacements, visited);
                node.else = $3d61a161f79f46c9$var$replaceTypeInGraph(node.else, replacements, visited);
                break;
            case 'Type':
                return replacements[node.name] || node;
        }
    }
    return node;
}
function $3d61a161f79f46c9$var$buildGroupMatchGraph(combinator, terms, atLeastOneTermMatched) {
    switch(combinator){
        case ' ':
            {
                // Juxtaposing components means that all of them must occur, in the given order.
                //
                // a b c
                // =
                // match a
                //   then match b
                //     then match c
                //       then MATCH
                //       else MISMATCH
                //     else MISMATCH
                //   else MISMATCH
                let result = $3d61a161f79f46c9$export$5a1a83be8f503735;
                for(let i = terms.length - 1; i >= 0; i--){
                    const term = terms[i];
                    result = $3d61a161f79f46c9$var$createCondition(term, result, $3d61a161f79f46c9$export$dfbc42837bfccec4);
                }
                return result;
            }
        case '|':
            {
                // A bar (|) separates two or more alternatives: exactly one of them must occur.
                //
                // a | b | c
                // =
                // match a
                //   then MATCH
                //   else match b
                //     then MATCH
                //     else match c
                //       then MATCH
                //       else MISMATCH
                let result = $3d61a161f79f46c9$export$dfbc42837bfccec4;
                let map = null;
                for(let i = terms.length - 1; i >= 0; i--){
                    let term = terms[i];
                    // reduce sequence of keywords into a Enum
                    if ($3d61a161f79f46c9$var$isEnumCapatible(term)) {
                        if (map === null && i > 0 && $3d61a161f79f46c9$var$isEnumCapatible(terms[i - 1])) {
                            map = Object.create(null);
                            result = $3d61a161f79f46c9$var$createCondition({
                                type: 'Enum',
                                map: map
                            }, $3d61a161f79f46c9$export$5a1a83be8f503735, result);
                        }
                        if (map !== null) {
                            const key = ($3d61a161f79f46c9$var$isFunctionType(term.name) ? term.name.slice(0, -1) : term.name).toLowerCase();
                            if (key in map === false) {
                                map[key] = term;
                                continue;
                            }
                        }
                    }
                    map = null;
                    // create a new conditonal node
                    result = $3d61a161f79f46c9$var$createCondition(term, $3d61a161f79f46c9$export$5a1a83be8f503735, result);
                }
                return result;
            }
        case '&&':
            {
                // A double ampersand (&&) separates two or more components,
                // all of which must occur, in any order.
                // Use MatchOnce for groups with a large number of terms,
                // since &&-groups produces at least N!-node trees
                if (terms.length > 5) return {
                    type: 'MatchOnce',
                    terms: terms,
                    all: true
                };
                // Use a combination tree for groups with small number of terms
                //
                // a && b && c
                // =
                // match a
                //   then [b && c]
                //   else match b
                //     then [a && c]
                //     else match c
                //       then [a && b]
                //       else MISMATCH
                //
                // a && b
                // =
                // match a
                //   then match b
                //     then MATCH
                //     else MISMATCH
                //   else match b
                //     then match a
                //       then MATCH
                //       else MISMATCH
                //     else MISMATCH
                let result = $3d61a161f79f46c9$export$dfbc42837bfccec4;
                for(let i = terms.length - 1; i >= 0; i--){
                    const term = terms[i];
                    let thenClause;
                    if (terms.length > 1) thenClause = $3d61a161f79f46c9$var$buildGroupMatchGraph(combinator, terms.filter(function(newGroupTerm) {
                        return newGroupTerm !== term;
                    }), false);
                    else thenClause = $3d61a161f79f46c9$export$5a1a83be8f503735;
                    result = $3d61a161f79f46c9$var$createCondition(term, thenClause, result);
                }
                return result;
            }
        case '||':
            {
                // A double bar (||) separates two or more options:
                // one or more of them must occur, in any order.
                // Use MatchOnce for groups with a large number of terms,
                // since ||-groups produces at least N!-node trees
                if (terms.length > 5) return {
                    type: 'MatchOnce',
                    terms: terms,
                    all: false
                };
                // Use a combination tree for groups with small number of terms
                //
                // a || b || c
                // =
                // match a
                //   then [b || c]
                //   else match b
                //     then [a || c]
                //     else match c
                //       then [a || b]
                //       else MISMATCH
                //
                // a || b
                // =
                // match a
                //   then match b
                //     then MATCH
                //     else MATCH
                //   else match b
                //     then match a
                //       then MATCH
                //       else MATCH
                //     else MISMATCH
                let result = atLeastOneTermMatched ? $3d61a161f79f46c9$export$5a1a83be8f503735 : $3d61a161f79f46c9$export$dfbc42837bfccec4;
                for(let i = terms.length - 1; i >= 0; i--){
                    const term = terms[i];
                    let thenClause;
                    if (terms.length > 1) thenClause = $3d61a161f79f46c9$var$buildGroupMatchGraph(combinator, terms.filter(function(newGroupTerm) {
                        return newGroupTerm !== term;
                    }), true);
                    else thenClause = $3d61a161f79f46c9$export$5a1a83be8f503735;
                    result = $3d61a161f79f46c9$var$createCondition(term, thenClause, result);
                }
                return result;
            }
    }
}
function $3d61a161f79f46c9$var$buildMultiplierMatchGraph(node) {
    let result = $3d61a161f79f46c9$export$5a1a83be8f503735;
    let matchTerm = $3d61a161f79f46c9$var$buildMatchGraphInternal(node.term);
    if (node.max === 0) {
        // disable repeating of empty match to prevent infinite loop
        matchTerm = $3d61a161f79f46c9$var$createCondition(matchTerm, $3d61a161f79f46c9$export$d962e73e7bcd24c, $3d61a161f79f46c9$export$dfbc42837bfccec4);
        // an occurrence count is not limited, make a cycle;
        // to collect more terms on each following matching mismatch
        result = $3d61a161f79f46c9$var$createCondition(matchTerm, null, $3d61a161f79f46c9$export$dfbc42837bfccec4);
        result.then = $3d61a161f79f46c9$var$createCondition($3d61a161f79f46c9$export$5a1a83be8f503735, $3d61a161f79f46c9$export$5a1a83be8f503735, result // make a loop
        );
        if (node.comma) result.then.else = $3d61a161f79f46c9$var$createCondition({
            type: 'Comma',
            syntax: node
        }, result, $3d61a161f79f46c9$export$dfbc42837bfccec4);
    } else // create a match node chain for [min .. max] interval with optional matches
    for(let i = node.min || 1; i <= node.max; i++){
        if (node.comma && result !== $3d61a161f79f46c9$export$5a1a83be8f503735) result = $3d61a161f79f46c9$var$createCondition({
            type: 'Comma',
            syntax: node
        }, result, $3d61a161f79f46c9$export$dfbc42837bfccec4);
        result = $3d61a161f79f46c9$var$createCondition(matchTerm, $3d61a161f79f46c9$var$createCondition($3d61a161f79f46c9$export$5a1a83be8f503735, $3d61a161f79f46c9$export$5a1a83be8f503735, result), $3d61a161f79f46c9$export$dfbc42837bfccec4);
    }
    if (node.min === 0) // allow zero match
    result = $3d61a161f79f46c9$var$createCondition($3d61a161f79f46c9$export$5a1a83be8f503735, $3d61a161f79f46c9$export$5a1a83be8f503735, result);
    else // create a match node chain to collect [0 ... min - 1] required matches
    for(let i = 0; i < node.min - 1; i++){
        if (node.comma && result !== $3d61a161f79f46c9$export$5a1a83be8f503735) result = $3d61a161f79f46c9$var$createCondition({
            type: 'Comma',
            syntax: node
        }, result, $3d61a161f79f46c9$export$dfbc42837bfccec4);
        result = $3d61a161f79f46c9$var$createCondition(matchTerm, result, $3d61a161f79f46c9$export$dfbc42837bfccec4);
    }
    return result;
}
function $3d61a161f79f46c9$var$buildMatchGraphInternal(node) {
    if (typeof node === 'function') return {
        type: 'Generic',
        fn: node
    };
    switch(node.type){
        case 'Group':
            {
                let result = $3d61a161f79f46c9$var$buildGroupMatchGraph(node.combinator, node.terms.map($3d61a161f79f46c9$var$buildMatchGraphInternal), false);
                if (node.disallowEmpty) result = $3d61a161f79f46c9$var$createCondition(result, $3d61a161f79f46c9$export$d962e73e7bcd24c, $3d61a161f79f46c9$export$dfbc42837bfccec4);
                return result;
            }
        case 'Multiplier':
            return $3d61a161f79f46c9$var$buildMultiplierMatchGraph(node);
        // https://drafts.csswg.org/css-values-5/#boolean
        case 'Boolean':
            {
                const term = $3d61a161f79f46c9$var$buildMatchGraphInternal(node.term);
                // <boolean-expr[ <test> ]> = not <boolean-expr-group> | <boolean-expr-group> [ [ and <boolean-expr-group> ]* | [ or <boolean-expr-group> ]* ]
                const matchNode = $3d61a161f79f46c9$var$buildMatchGraphInternal($3d61a161f79f46c9$var$groupNode([
                    $3d61a161f79f46c9$var$groupNode([
                        {
                            type: 'Keyword',
                            name: 'not'
                        },
                        {
                            type: 'Type',
                            name: '!boolean-group'
                        }
                    ]),
                    $3d61a161f79f46c9$var$groupNode([
                        {
                            type: 'Type',
                            name: '!boolean-group'
                        },
                        $3d61a161f79f46c9$var$groupNode([
                            {
                                type: 'Multiplier',
                                comma: false,
                                min: 0,
                                max: 0,
                                term: $3d61a161f79f46c9$var$groupNode([
                                    {
                                        type: 'Keyword',
                                        name: 'and'
                                    },
                                    {
                                        type: 'Type',
                                        name: '!boolean-group'
                                    }
                                ])
                            },
                            {
                                type: 'Multiplier',
                                comma: false,
                                min: 0,
                                max: 0,
                                term: $3d61a161f79f46c9$var$groupNode([
                                    {
                                        type: 'Keyword',
                                        name: 'or'
                                    },
                                    {
                                        type: 'Type',
                                        name: '!boolean-group'
                                    }
                                ])
                            }
                        ], '|')
                    ])
                ], '|'));
                // <boolean-expr-group> = <test> | ( <boolean-expr[ <test> ]> ) | <general-enclosed>
                const booleanGroup = $3d61a161f79f46c9$var$buildMatchGraphInternal($3d61a161f79f46c9$var$groupNode([
                    {
                        type: 'Type',
                        name: '!term'
                    },
                    $3d61a161f79f46c9$var$groupNode([
                        {
                            type: 'Token',
                            value: '('
                        },
                        {
                            type: 'Type',
                            name: '!self'
                        },
                        {
                            type: 'Token',
                            value: ')'
                        }
                    ]),
                    {
                        type: 'Type',
                        name: 'general-enclosed'
                    }
                ], '|'));
                $3d61a161f79f46c9$var$replaceTypeInGraph(booleanGroup, {
                    '!term': term,
                    '!self': matchNode
                });
                $3d61a161f79f46c9$var$replaceTypeInGraph(matchNode, {
                    '!boolean-group': booleanGroup
                });
                return matchNode;
            }
        case 'Type':
        case 'Property':
            return {
                type: node.type,
                name: node.name,
                syntax: node
            };
        case 'Keyword':
            return {
                type: node.type,
                name: node.name.toLowerCase(),
                syntax: node
            };
        case 'AtKeyword':
            return {
                type: node.type,
                name: '@' + node.name.toLowerCase(),
                syntax: node
            };
        case 'Function':
            return {
                type: node.type,
                name: node.name.toLowerCase() + '(',
                syntax: node
            };
        case 'String':
            // convert a one char length String to a Token
            if (node.value.length === 3) return {
                type: 'Token',
                value: node.value.charAt(1),
                syntax: node
            };
            // otherwise use it as is
            return {
                type: node.type,
                value: node.value.substr(1, node.value.length - 2).replace(/\\'/g, '\''),
                syntax: node
            };
        case 'Token':
            return {
                type: node.type,
                value: node.value,
                syntax: node
            };
        case 'Comma':
            return {
                type: node.type,
                syntax: node
            };
        default:
            throw new Error('Unknown node type:', node.type);
    }
}
function $3d61a161f79f46c9$export$41c88d779c06859d(syntaxTree, ref) {
    if (typeof syntaxTree === 'string') syntaxTree = (0, $2569dc2ad06cb2df$export$98e6a39c04603d36)(syntaxTree);
    return {
        type: 'MatchGraph',
        match: $3d61a161f79f46c9$var$buildMatchGraphInternal(syntaxTree),
        syntax: ref || null,
        source: syntaxTree
    };
}




const { hasOwnProperty: $0baf860c9560db33$var$hasOwnProperty } = Object.prototype;
const $0baf860c9560db33$var$STUB = 0;
const $0baf860c9560db33$var$TOKEN = 1;
const $0baf860c9560db33$var$OPEN_SYNTAX = 2;
const $0baf860c9560db33$var$CLOSE_SYNTAX = 3;
const $0baf860c9560db33$var$EXIT_REASON_MATCH = 'Match';
const $0baf860c9560db33$var$EXIT_REASON_MISMATCH = 'Mismatch';
const $0baf860c9560db33$var$EXIT_REASON_ITERATION_LIMIT = 'Maximum iteration number exceeded (please fill an issue on https://github.com/csstree/csstree/issues)';
const $0baf860c9560db33$var$ITERATION_LIMIT = 15000;
let $0baf860c9560db33$export$ec1b942061afe363 = 0;
function $0baf860c9560db33$var$reverseList(list) {
    let prev = null;
    let next = null;
    let item = list;
    while(item !== null){
        next = item.prev;
        item.prev = prev;
        prev = item;
        item = next;
    }
    return prev;
}
function $0baf860c9560db33$var$areStringsEqualCaseInsensitive(testStr, referenceStr) {
    if (testStr.length !== referenceStr.length) return false;
    for(let i = 0; i < testStr.length; i++){
        const referenceCode = referenceStr.charCodeAt(i);
        let testCode = testStr.charCodeAt(i);
        // testCode.toLowerCase() for U+0041 LATIN CAPITAL LETTER A (A) .. U+005A LATIN CAPITAL LETTER Z (Z).
        if (testCode >= 0x0041 && testCode <= 0x005A) testCode = testCode | 32;
        if (testCode !== referenceCode) return false;
    }
    return true;
}
function $0baf860c9560db33$var$isContextEdgeDelim(token) {
    if (token.type !== $cb01acaf2e18d562$export$a918ca49ff4337a3) return false;
    // Fix matching for unicode-range: U+30??, U+FF00-FF9F
    // Probably we need to check out previous match instead
    return token.value !== '?';
}
function $0baf860c9560db33$var$isCommaContextStart(token) {
    if (token === null) return true;
    return token.type === $cb01acaf2e18d562$export$c06e3ee3b4d233fa || token.type === $cb01acaf2e18d562$export$f3890eeaf6851387 || token.type === $cb01acaf2e18d562$export$b5a25f132cb53de6 || token.type === $cb01acaf2e18d562$export$cd363bb53c2bb || token.type === $cb01acaf2e18d562$export$ccdce7304ac66390 || $0baf860c9560db33$var$isContextEdgeDelim(token);
}
function $0baf860c9560db33$var$isCommaContextEnd(token) {
    if (token === null) return true;
    return token.type === $cb01acaf2e18d562$export$773d33972c6279ed || token.type === $cb01acaf2e18d562$export$72f933344f701f30 || token.type === $cb01acaf2e18d562$export$186d8b1f99e2bfec || token.type === $cb01acaf2e18d562$export$a918ca49ff4337a3 && token.value === '/';
}
function $0baf860c9560db33$var$internalMatch(tokens, state, syntaxes) {
    function moveToNextToken() {
        do {
            tokenIndex++;
            token = tokenIndex < tokens.length ? tokens[tokenIndex] : null;
        }while (token !== null && (token.type === $cb01acaf2e18d562$export$fb98946286ab4c97 || token.type === $cb01acaf2e18d562$export$4d299b491347818a));
    }
    function getNextToken(offset) {
        const nextIndex = tokenIndex + offset;
        return nextIndex < tokens.length ? tokens[nextIndex] : null;
    }
    function stateSnapshotFromSyntax(nextState, prev) {
        return {
            nextState: nextState,
            matchStack: matchStack,
            syntaxStack: syntaxStack,
            thenStack: thenStack,
            tokenIndex: tokenIndex,
            prev: prev
        };
    }
    function pushThenStack(nextState) {
        thenStack = {
            nextState: nextState,
            matchStack: matchStack,
            syntaxStack: syntaxStack,
            prev: thenStack
        };
    }
    function pushElseStack(nextState) {
        elseStack = stateSnapshotFromSyntax(nextState, elseStack);
    }
    function addTokenToMatch() {
        matchStack = {
            type: $0baf860c9560db33$var$TOKEN,
            syntax: state.syntax,
            token: token,
            prev: matchStack
        };
        moveToNextToken();
        syntaxStash = null;
        if (tokenIndex > longestMatch) longestMatch = tokenIndex;
    }
    function openSyntax() {
        syntaxStack = {
            syntax: state.syntax,
            opts: state.syntax.opts || syntaxStack !== null && syntaxStack.opts || null,
            prev: syntaxStack
        };
        matchStack = {
            type: $0baf860c9560db33$var$OPEN_SYNTAX,
            syntax: state.syntax,
            token: matchStack.token,
            prev: matchStack
        };
    }
    function closeSyntax() {
        if (matchStack.type === $0baf860c9560db33$var$OPEN_SYNTAX) matchStack = matchStack.prev;
        else matchStack = {
            type: $0baf860c9560db33$var$CLOSE_SYNTAX,
            syntax: syntaxStack.syntax,
            token: matchStack.token,
            prev: matchStack
        };
        syntaxStack = syntaxStack.prev;
    }
    let syntaxStack = null;
    let thenStack = null;
    let elseStack = null;
    // null – stashing allowed, nothing stashed
    // false – stashing disabled, nothing stashed
    // anithing else – fail stashable syntaxes, some syntax stashed
    let syntaxStash = null;
    let iterationCount = 0; // count iterations and prevent infinite loop
    let exitReason = null;
    let token = null;
    let tokenIndex = -1;
    let longestMatch = 0;
    let matchStack = {
        type: $0baf860c9560db33$var$STUB,
        syntax: null,
        token: null,
        prev: null
    };
    moveToNextToken();
    while(exitReason === null && ++iterationCount < $0baf860c9560db33$var$ITERATION_LIMIT)// function mapList(list, fn) {
    //     const result = [];
    //     while (list) {
    //         result.unshift(fn(list));
    //         list = list.prev;
    //     }
    //     return result;
    // }
    // console.log('--\n',
    //     '#' + iterationCount,
    //     require('util').inspect({
    //         match: mapList(matchStack, x => x.type === TOKEN ? x.token && x.token.value : x.syntax ? ({ [OPEN_SYNTAX]: '<', [CLOSE_SYNTAX]: '</' }[x.type] || x.type) + '!' + x.syntax.name : null),
    //         token: token && token.value,
    //         tokenIndex,
    //         syntax: syntax.type + (syntax.id ? ' #' + syntax.id : '')
    //     }, { depth: null })
    // );
    switch(state.type){
        case 'Match':
            if (thenStack === null) {
                // turn to MISMATCH when some tokens left unmatched
                if (token !== null) // doesn't mismatch if just one token left and it's an IE hack
                {
                    if (tokenIndex !== tokens.length - 1 || token.value !== '\\0' && token.value !== '\\9') {
                        state = (0, $3d61a161f79f46c9$export$dfbc42837bfccec4);
                        break;
                    }
                }
                // break the main loop, return a result - MATCH
                exitReason = $0baf860c9560db33$var$EXIT_REASON_MATCH;
                break;
            }
            // go to next syntax (`then` branch)
            state = thenStack.nextState;
            // check match is not empty
            if (state === (0, $3d61a161f79f46c9$export$d962e73e7bcd24c)) {
                if (thenStack.matchStack === matchStack) {
                    state = (0, $3d61a161f79f46c9$export$dfbc42837bfccec4);
                    break;
                } else state = (0, $3d61a161f79f46c9$export$5a1a83be8f503735);
            }
            // close syntax if needed
            while(thenStack.syntaxStack !== syntaxStack)closeSyntax();
            // pop stack
            thenStack = thenStack.prev;
            break;
        case 'Mismatch':
            // when some syntax is stashed
            if (syntaxStash !== null && syntaxStash !== false) // there is no else branches or a branch reduce match stack
            {
                if (elseStack === null || tokenIndex > elseStack.tokenIndex) {
                    // restore state from the stash
                    elseStack = syntaxStash;
                    syntaxStash = false; // disable stashing
                }
            } else if (elseStack === null) {
                // no else branches -> break the main loop
                // return a result - MISMATCH
                exitReason = $0baf860c9560db33$var$EXIT_REASON_MISMATCH;
                break;
            }
            // go to next syntax (`else` branch)
            state = elseStack.nextState;
            // restore all the rest stack states
            thenStack = elseStack.thenStack;
            syntaxStack = elseStack.syntaxStack;
            matchStack = elseStack.matchStack;
            tokenIndex = elseStack.tokenIndex;
            token = tokenIndex < tokens.length ? tokens[tokenIndex] : null;
            // pop stack
            elseStack = elseStack.prev;
            break;
        case 'MatchGraph':
            state = state.match;
            break;
        case 'If':
            // IMPORTANT: else stack push must go first,
            // since it stores the state of thenStack before changes
            if (state.else !== (0, $3d61a161f79f46c9$export$dfbc42837bfccec4)) pushElseStack(state.else);
            if (state.then !== (0, $3d61a161f79f46c9$export$5a1a83be8f503735)) pushThenStack(state.then);
            state = state.match;
            break;
        case 'MatchOnce':
            state = {
                type: 'MatchOnceBuffer',
                syntax: state,
                index: 0,
                mask: 0
            };
            break;
        case 'MatchOnceBuffer':
            {
                const terms = state.syntax.terms;
                if (state.index === terms.length) {
                    // no matches at all or it's required all terms to be matched
                    if (state.mask === 0 || state.syntax.all) {
                        state = (0, $3d61a161f79f46c9$export$dfbc42837bfccec4);
                        break;
                    }
                    // a partial match is ok
                    state = (0, $3d61a161f79f46c9$export$5a1a83be8f503735);
                    break;
                }
                // all terms are matched
                if (state.mask === (1 << terms.length) - 1) {
                    state = (0, $3d61a161f79f46c9$export$5a1a83be8f503735);
                    break;
                }
                for(; state.index < terms.length; state.index++){
                    const matchFlag = 1 << state.index;
                    if ((state.mask & matchFlag) === 0) {
                        // IMPORTANT: else stack push must go first,
                        // since it stores the state of thenStack before changes
                        pushElseStack(state);
                        pushThenStack({
                            type: 'AddMatchOnce',
                            syntax: state.syntax,
                            mask: state.mask | matchFlag
                        });
                        // match
                        state = terms[state.index++];
                        break;
                    }
                }
                break;
            }
        case 'AddMatchOnce':
            state = {
                type: 'MatchOnceBuffer',
                syntax: state.syntax,
                index: 0,
                mask: state.mask
            };
            break;
        case 'Enum':
            if (token !== null) {
                let name = token.value.toLowerCase();
                // drop \0 and \9 hack from keyword name
                if (name.indexOf('\\') !== -1) name = name.replace(/\\[09].*$/, '');
                if ($0baf860c9560db33$var$hasOwnProperty.call(state.map, name)) {
                    state = state.map[name];
                    break;
                }
            }
            state = (0, $3d61a161f79f46c9$export$dfbc42837bfccec4);
            break;
        case 'Generic':
            {
                const opts = syntaxStack !== null ? syntaxStack.opts : null;
                const lastTokenIndex = tokenIndex + Math.floor(state.fn(token, getNextToken, opts));
                if (!isNaN(lastTokenIndex) && lastTokenIndex > tokenIndex) {
                    while(tokenIndex < lastTokenIndex)addTokenToMatch();
                    state = (0, $3d61a161f79f46c9$export$5a1a83be8f503735);
                } else state = (0, $3d61a161f79f46c9$export$dfbc42837bfccec4);
                break;
            }
        case 'Type':
        case 'Property':
            {
                const syntaxDict = state.type === 'Type' ? 'types' : 'properties';
                const dictSyntax = $0baf860c9560db33$var$hasOwnProperty.call(syntaxes, syntaxDict) ? syntaxes[syntaxDict][state.name] : null;
                if (!dictSyntax || !dictSyntax.match) throw new Error('Bad syntax reference: ' + (state.type === 'Type' ? '<' + state.name + '>' : '<\'' + state.name + '\'>'));
                // stash a syntax for types with low priority
                if (syntaxStash !== false && token !== null && state.type === 'Type') {
                    const lowPriorityMatching = // https://drafts.csswg.org/css-values-4/#custom-idents
                    // When parsing positionally-ambiguous keywords in a property value, a <custom-ident> production
                    // can only claim the keyword if no other unfulfilled production can claim it.
                    state.name === 'custom-ident' && token.type === $cb01acaf2e18d562$export$331e9b6bdecaac5f || // https://drafts.csswg.org/css-values-4/#lengths
                    // ... if a `0` could be parsed as either a <number> or a <length> in a property (such as line-height),
                    // it must parse as a <number>
                    state.name === 'length' && token.value === '0';
                    if (lowPriorityMatching) {
                        if (syntaxStash === null) syntaxStash = stateSnapshotFromSyntax(state, elseStack);
                        state = (0, $3d61a161f79f46c9$export$dfbc42837bfccec4);
                        break;
                    }
                }
                openSyntax();
                state = dictSyntax.matchRef || dictSyntax.match;
                break;
            }
        case 'Keyword':
            {
                const name = state.name;
                if (token !== null) {
                    let keywordName = token.value;
                    // drop \0 and \9 hack from keyword name
                    if (keywordName.indexOf('\\') !== -1) keywordName = keywordName.replace(/\\[09].*$/, '');
                    if ($0baf860c9560db33$var$areStringsEqualCaseInsensitive(keywordName, name)) {
                        addTokenToMatch();
                        state = (0, $3d61a161f79f46c9$export$5a1a83be8f503735);
                        break;
                    }
                }
                state = (0, $3d61a161f79f46c9$export$dfbc42837bfccec4);
                break;
            }
        case 'AtKeyword':
        case 'Function':
            if (token !== null && $0baf860c9560db33$var$areStringsEqualCaseInsensitive(token.value, state.name)) {
                addTokenToMatch();
                state = (0, $3d61a161f79f46c9$export$5a1a83be8f503735);
                break;
            }
            state = (0, $3d61a161f79f46c9$export$dfbc42837bfccec4);
            break;
        case 'Token':
            if (token !== null && token.value === state.value) {
                addTokenToMatch();
                state = (0, $3d61a161f79f46c9$export$5a1a83be8f503735);
                break;
            }
            state = (0, $3d61a161f79f46c9$export$dfbc42837bfccec4);
            break;
        case 'Comma':
            if (token !== null && token.type === $cb01acaf2e18d562$export$c06e3ee3b4d233fa) {
                if ($0baf860c9560db33$var$isCommaContextStart(matchStack.token)) state = (0, $3d61a161f79f46c9$export$dfbc42837bfccec4);
                else {
                    addTokenToMatch();
                    state = $0baf860c9560db33$var$isCommaContextEnd(token) ? (0, $3d61a161f79f46c9$export$dfbc42837bfccec4) : (0, $3d61a161f79f46c9$export$5a1a83be8f503735);
                }
            } else state = $0baf860c9560db33$var$isCommaContextStart(matchStack.token) || $0baf860c9560db33$var$isCommaContextEnd(token) ? (0, $3d61a161f79f46c9$export$5a1a83be8f503735) : (0, $3d61a161f79f46c9$export$dfbc42837bfccec4);
            break;
        case 'String':
            let string = '';
            let lastTokenIndex = tokenIndex;
            for(; lastTokenIndex < tokens.length && string.length < state.value.length; lastTokenIndex++)string += tokens[lastTokenIndex].value;
            if ($0baf860c9560db33$var$areStringsEqualCaseInsensitive(string, state.value)) {
                while(tokenIndex < lastTokenIndex)addTokenToMatch();
                state = (0, $3d61a161f79f46c9$export$5a1a83be8f503735);
            } else state = (0, $3d61a161f79f46c9$export$dfbc42837bfccec4);
            break;
        default:
            throw new Error('Unknown node type: ' + state.type);
    }
    $0baf860c9560db33$export$ec1b942061afe363 += iterationCount;
    switch(exitReason){
        case null:
            console.warn('[csstree-match] BREAK after ' + $0baf860c9560db33$var$ITERATION_LIMIT + ' iterations');
            exitReason = $0baf860c9560db33$var$EXIT_REASON_ITERATION_LIMIT;
            matchStack = null;
            break;
        case $0baf860c9560db33$var$EXIT_REASON_MATCH:
            while(syntaxStack !== null)closeSyntax();
            break;
        default:
            matchStack = null;
    }
    return {
        tokens: tokens,
        reason: exitReason,
        iterations: iterationCount,
        match: matchStack,
        longestMatch: longestMatch
    };
}
function $0baf860c9560db33$export$b15baef7e00e9fac(tokens, matchGraph, syntaxes) {
    const matchResult = $0baf860c9560db33$var$internalMatch(tokens, matchGraph, syntaxes || {});
    if (matchResult.match !== null) {
        let item = $0baf860c9560db33$var$reverseList(matchResult.match).prev;
        matchResult.match = [];
        while(item !== null){
            switch(item.type){
                case $0baf860c9560db33$var$OPEN_SYNTAX:
                case $0baf860c9560db33$var$CLOSE_SYNTAX:
                    matchResult.match.push({
                        type: item.type,
                        syntax: item.syntax
                    });
                    break;
                default:
                    matchResult.match.push({
                        token: item.token.value,
                        node: item.token.node
                    });
                    break;
            }
            item = item.prev;
        }
    }
    return matchResult;
}
function $0baf860c9560db33$export$575ec9525823c563(tokens, matchGraph, syntaxes) {
    const matchResult = $0baf860c9560db33$var$internalMatch(tokens, matchGraph, syntaxes || {});
    if (matchResult.match === null) return matchResult;
    let item = matchResult.match;
    let host = matchResult.match = {
        syntax: matchGraph.syntax || null,
        match: []
    };
    const hostStack = [
        host
    ];
    // revert a list and start with 2nd item since 1st is a stub item
    item = $0baf860c9560db33$var$reverseList(item).prev;
    // build a tree
    while(item !== null){
        switch(item.type){
            case $0baf860c9560db33$var$OPEN_SYNTAX:
                host.match.push(host = {
                    syntax: item.syntax,
                    match: []
                });
                hostStack.push(host);
                break;
            case $0baf860c9560db33$var$CLOSE_SYNTAX:
                hostStack.pop();
                host = hostStack[hostStack.length - 1];
                break;
            default:
                host.match.push({
                    syntax: item.syntax || null,
                    token: item.token.value,
                    node: item.token.node
                });
        }
        item = item.prev;
    }
    return matchResult;
}


var $1bfca26dd4e9327e$exports = {};

$parcel$export($1bfca26dd4e9327e$exports, "getTrace", function () { return $1bfca26dd4e9327e$export$4f813bbe73196350; });
$parcel$export($1bfca26dd4e9327e$exports, "isType", function () { return $1bfca26dd4e9327e$export$26b9f946b448f23e; });
$parcel$export($1bfca26dd4e9327e$exports, "isProperty", function () { return $1bfca26dd4e9327e$export$dc0811f98246bcff; });
$parcel$export($1bfca26dd4e9327e$exports, "isKeyword", function () { return $1bfca26dd4e9327e$export$384ccb3991bcb643; });
function $1bfca26dd4e9327e$export$4f813bbe73196350(node) {
    function shouldPutToTrace(syntax) {
        if (syntax === null) return false;
        return syntax.type === 'Type' || syntax.type === 'Property' || syntax.type === 'Keyword';
    }
    function hasMatch(matchNode) {
        if (Array.isArray(matchNode.match)) {
            // use for-loop for better perfomance
            for(let i = 0; i < matchNode.match.length; i++)if (hasMatch(matchNode.match[i])) {
                if (shouldPutToTrace(matchNode.syntax)) result.unshift(matchNode.syntax);
                return true;
            }
        } else if (matchNode.node === node) {
            result = shouldPutToTrace(matchNode.syntax) ? [
                matchNode.syntax
            ] : [];
            return true;
        }
        return false;
    }
    let result = null;
    if (this.matched !== null) hasMatch(this.matched);
    return result;
}
function $1bfca26dd4e9327e$export$26b9f946b448f23e(node, type) {
    return $1bfca26dd4e9327e$var$testNode(this, node, (match)=>match.type === 'Type' && match.name === type);
}
function $1bfca26dd4e9327e$export$dc0811f98246bcff(node, property) {
    return $1bfca26dd4e9327e$var$testNode(this, node, (match)=>match.type === 'Property' && match.name === property);
}
function $1bfca26dd4e9327e$export$384ccb3991bcb643(node) {
    return $1bfca26dd4e9327e$var$testNode(this, node, (match)=>match.type === 'Keyword');
}
function $1bfca26dd4e9327e$var$testNode(match, node, fn) {
    const trace = $1bfca26dd4e9327e$export$4f813bbe73196350.call(match, node);
    if (trace === null) return false;
    return trace.some(fn);
}



function $d2a84b2ed38324da$var$getFirstMatchNode(matchNode) {
    if ('node' in matchNode) return matchNode.node;
    return $d2a84b2ed38324da$var$getFirstMatchNode(matchNode.match[0]);
}
function $d2a84b2ed38324da$var$getLastMatchNode(matchNode) {
    if ('node' in matchNode) return matchNode.node;
    return $d2a84b2ed38324da$var$getLastMatchNode(matchNode.match[matchNode.match.length - 1]);
}
function $d2a84b2ed38324da$export$2c0817d7096f698(lexer, ast, match, type, name) {
    function findFragments(matchNode) {
        if (matchNode.syntax !== null && matchNode.syntax.type === type && matchNode.syntax.name === name) {
            const start = $d2a84b2ed38324da$var$getFirstMatchNode(matchNode);
            const end = $d2a84b2ed38324da$var$getLastMatchNode(matchNode);
            lexer.syntax.walk(ast, function(node, item, list) {
                if (node === start) {
                    const nodes = new (0, $2836a6e7287d8f5c$export$54c2e3dc7acea9f5)();
                    do {
                        nodes.appendData(item.data);
                        if (item.data === end) break;
                        item = item.next;
                    }while (item !== null);
                    fragments.push({
                        parent: list,
                        nodes: nodes
                    });
                }
            });
        }
        if (Array.isArray(matchNode.match)) matchNode.match.forEach(findFragments);
    }
    const fragments = [];
    if (match.matched !== null) findFragments(match.matched);
    return fragments;
}



const { hasOwnProperty: $0ae9401ab40a6596$var$hasOwnProperty } = Object.prototype;
function $0ae9401ab40a6596$var$isValidNumber(value) {
    // Number.isInteger(value) && value >= 0
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value && value >= 0;
}
function $0ae9401ab40a6596$var$isValidLocation(loc) {
    return Boolean(loc) && $0ae9401ab40a6596$var$isValidNumber(loc.offset) && $0ae9401ab40a6596$var$isValidNumber(loc.line) && $0ae9401ab40a6596$var$isValidNumber(loc.column);
}
function $0ae9401ab40a6596$var$createNodeStructureChecker(type, fields) {
    return function checkNode(node, warn) {
        if (!node || node.constructor !== Object) return warn(node, 'Type of node should be an Object');
        for(let key in node){
            let valid = true;
            if ($0ae9401ab40a6596$var$hasOwnProperty.call(node, key) === false) continue;
            if (key === 'type') {
                if (node.type !== type) warn(node, 'Wrong node type `' + node.type + '`, expected `' + type + '`');
            } else if (key === 'loc') {
                if (node.loc === null) continue;
                else if (node.loc && node.loc.constructor === Object) {
                    if (typeof node.loc.source !== 'string') key += '.source';
                    else if (!$0ae9401ab40a6596$var$isValidLocation(node.loc.start)) key += '.start';
                    else if (!$0ae9401ab40a6596$var$isValidLocation(node.loc.end)) key += '.end';
                    else continue;
                }
                valid = false;
            } else if (fields.hasOwnProperty(key)) {
                valid = false;
                for(let i = 0; !valid && i < fields[key].length; i++){
                    const fieldType = fields[key][i];
                    switch(fieldType){
                        case String:
                            valid = typeof node[key] === 'string';
                            break;
                        case Boolean:
                            valid = typeof node[key] === 'boolean';
                            break;
                        case null:
                            valid = node[key] === null;
                            break;
                        default:
                            if (typeof fieldType === 'string') valid = node[key] && node[key].type === fieldType;
                            else if (Array.isArray(fieldType)) valid = node[key] instanceof (0, $2836a6e7287d8f5c$export$54c2e3dc7acea9f5);
                    }
                }
            } else warn(node, 'Unknown field `' + key + '` for ' + type + ' node type');
            if (!valid) warn(node, 'Bad value for `' + type + '.' + key + '`');
        }
        for(const key in fields)if ($0ae9401ab40a6596$var$hasOwnProperty.call(fields, key) && $0ae9401ab40a6596$var$hasOwnProperty.call(node, key) === false) warn(node, 'Field `' + type + '.' + key + '` is missed');
    };
}
function $0ae9401ab40a6596$var$genTypesList(fieldTypes, path) {
    const docsTypes = [];
    for(let i = 0; i < fieldTypes.length; i++){
        const fieldType = fieldTypes[i];
        if (fieldType === String || fieldType === Boolean) docsTypes.push(fieldType.name.toLowerCase());
        else if (fieldType === null) docsTypes.push('null');
        else if (typeof fieldType === 'string') docsTypes.push(fieldType);
        else if (Array.isArray(fieldType)) docsTypes.push('List<' + ($0ae9401ab40a6596$var$genTypesList(fieldType, path) || 'any') + '>'); // TODO: use type enum
        else throw new Error('Wrong value `' + fieldType + '` in `' + path + '` structure definition');
    }
    return docsTypes.join(' | ');
}
function $0ae9401ab40a6596$var$processStructure(name, nodeType) {
    const structure = nodeType.structure;
    const fields = {
        type: String,
        loc: true
    };
    const docs = {
        type: '"' + name + '"'
    };
    for(const key in structure){
        if ($0ae9401ab40a6596$var$hasOwnProperty.call(structure, key) === false) continue;
        const fieldTypes = fields[key] = Array.isArray(structure[key]) ? structure[key].slice() : [
            structure[key]
        ];
        docs[key] = $0ae9401ab40a6596$var$genTypesList(fieldTypes, name + '.' + key);
    }
    return {
        docs: docs,
        check: $0ae9401ab40a6596$var$createNodeStructureChecker(name, fields)
    };
}
function $0ae9401ab40a6596$export$2e9edb38e02d3c76(config) {
    const structure = {};
    if (config.node) {
        for(const name in config.node)if ($0ae9401ab40a6596$var$hasOwnProperty.call(config.node, name)) {
            const nodeType = config.node[name];
            if (nodeType.structure) structure[name] = $0ae9401ab40a6596$var$processStructure(name, nodeType);
            else throw new Error('Missed `structure` field in `' + name + '` node type definition');
        }
    }
    return structure;
}


function $c3ffbe583ac72763$var$dumpMapSyntax(map, compact, syntaxAsAst) {
    const result = {};
    for(const name in map)if (map[name].syntax) result[name] = syntaxAsAst ? map[name].syntax : (0, $87a319d4b88869d2$export$80d376111cc09ad7)(map[name].syntax, {
        compact: compact
    });
    return result;
}
function $c3ffbe583ac72763$var$dumpAtruleMapSyntax(map, compact, syntaxAsAst) {
    const result = {};
    for (const [name, atrule] of Object.entries(map))result[name] = {
        prelude: atrule.prelude && (syntaxAsAst ? atrule.prelude.syntax : (0, $87a319d4b88869d2$export$80d376111cc09ad7)(atrule.prelude.syntax, {
            compact: compact
        })),
        descriptors: atrule.descriptors && $c3ffbe583ac72763$var$dumpMapSyntax(atrule.descriptors, compact, syntaxAsAst)
    };
    return result;
}
function $c3ffbe583ac72763$var$valueHasVar(tokens) {
    for(let i = 0; i < tokens.length; i++){
        if (tokens[i].value.toLowerCase() === 'var(') return true;
    }
    return false;
}
function $c3ffbe583ac72763$var$syntaxHasTopLevelCommaMultiplier(syntax) {
    const singleTerm = syntax.terms[0];
    return syntax.explicit === false && syntax.terms.length === 1 && singleTerm.type === 'Multiplier' && singleTerm.comma === true;
}
function $c3ffbe583ac72763$var$buildMatchResult(matched, error, iterations) {
    return {
        matched: matched,
        iterations: iterations,
        error: error,
        ...$1bfca26dd4e9327e$exports
    };
}
function $c3ffbe583ac72763$var$matchSyntax(lexer, syntax, value, useCssWideKeywords) {
    const tokens = (0, $673f8d43542c2ea7$export$2e2bcd8739ae039)(value, lexer.syntax);
    let result;
    if ($c3ffbe583ac72763$var$valueHasVar(tokens)) return $c3ffbe583ac72763$var$buildMatchResult(null, new Error('Matching for a tree with var() is not supported'));
    if (useCssWideKeywords) result = (0, $0baf860c9560db33$export$575ec9525823c563)(tokens, lexer.cssWideKeywordsSyntax, lexer);
    if (!useCssWideKeywords || !result.match) {
        result = (0, $0baf860c9560db33$export$575ec9525823c563)(tokens, syntax.match, lexer);
        if (!result.match) return $c3ffbe583ac72763$var$buildMatchResult(null, new (0, $833883a2fa46ad31$export$c937494ee8e9606d)(result.reason, syntax.syntax, value, result), result.iterations);
    }
    return $c3ffbe583ac72763$var$buildMatchResult(result.match, null, result.iterations);
}
class $c3ffbe583ac72763$export$6168dc8908a6c652 {
    constructor(config, syntax, structure){
        this.cssWideKeywords = (0, $42c1285c91ce4121$export$b3191e0d9e666e2c);
        this.syntax = syntax;
        this.generic = false;
        this.units = {
            ...$3b79d1ef8f2d2506$exports
        };
        this.atrules = Object.create(null);
        this.properties = Object.create(null);
        this.types = Object.create(null);
        this.structure = structure || (0, $0ae9401ab40a6596$export$2e9edb38e02d3c76)(config);
        if (config) {
            if (config.cssWideKeywords) this.cssWideKeywords = config.cssWideKeywords;
            if (config.units) {
                for (const group of Object.keys($3b79d1ef8f2d2506$exports))if (Array.isArray(config.units[group])) this.units[group] = config.units[group];
            }
            if (config.types) for (const [name, type] of Object.entries(config.types))this.addType_(name, type);
            if (config.generic) {
                this.generic = true;
                for (const [name, value] of Object.entries((0, $497b63c7a32ea770$export$604ad466d301d4c1)(this.units)))this.addType_(name, value);
            }
            if (config.atrules) for (const [name, atrule] of Object.entries(config.atrules))this.addAtrule_(name, atrule);
            if (config.properties) for (const [name, property] of Object.entries(config.properties))this.addProperty_(name, property);
        }
        this.cssWideKeywordsSyntax = (0, $3d61a161f79f46c9$export$41c88d779c06859d)(this.cssWideKeywords.join(' |  '));
    }
    checkStructure(ast) {
        function collectWarning(node, message) {
            warns.push({
                node: node,
                message: message
            });
        }
        const structure = this.structure;
        const warns = [];
        this.syntax.walk(ast, function(node) {
            if (structure.hasOwnProperty(node.type)) structure[node.type].check(node, collectWarning);
            else collectWarning(node, 'Unknown node type `' + node.type + '`');
        });
        return warns.length ? warns : false;
    }
    createDescriptor(syntax, type, name, parent = null) {
        const ref = {
            type: type,
            name: name
        };
        const descriptor = {
            type: type,
            name: name,
            parent: parent,
            serializable: typeof syntax === 'string' || syntax && typeof syntax.type === 'string',
            syntax: null,
            match: null,
            matchRef: null // used for properties when a syntax referenced as <'property'> in other syntax definitions
        };
        if (typeof syntax === 'function') descriptor.match = (0, $3d61a161f79f46c9$export$41c88d779c06859d)(syntax, ref);
        else {
            if (typeof syntax === 'string') // lazy parsing on first access
            Object.defineProperty(descriptor, 'syntax', {
                get () {
                    Object.defineProperty(descriptor, 'syntax', {
                        value: (0, $2569dc2ad06cb2df$export$98e6a39c04603d36)(syntax)
                    });
                    return descriptor.syntax;
                }
            });
            else descriptor.syntax = syntax;
            // lazy graph build on first access
            Object.defineProperty(descriptor, 'match', {
                get () {
                    Object.defineProperty(descriptor, 'match', {
                        value: (0, $3d61a161f79f46c9$export$41c88d779c06859d)(descriptor.syntax, ref)
                    });
                    return descriptor.match;
                }
            });
            if (type === 'Property') Object.defineProperty(descriptor, 'matchRef', {
                get () {
                    const syntax = descriptor.syntax;
                    const value = $c3ffbe583ac72763$var$syntaxHasTopLevelCommaMultiplier(syntax) ? (0, $3d61a161f79f46c9$export$41c88d779c06859d)({
                        ...syntax,
                        terms: [
                            syntax.terms[0].term
                        ]
                    }, ref) : null;
                    Object.defineProperty(descriptor, 'matchRef', {
                        value: value
                    });
                    return value;
                }
            });
        }
        return descriptor;
    }
    addAtrule_(name, syntax) {
        if (!syntax) return;
        this.atrules[name] = {
            type: 'Atrule',
            name: name,
            prelude: syntax.prelude ? this.createDescriptor(syntax.prelude, 'AtrulePrelude', name) : null,
            descriptors: syntax.descriptors ? Object.keys(syntax.descriptors).reduce((map, descName)=>{
                map[descName] = this.createDescriptor(syntax.descriptors[descName], 'AtruleDescriptor', descName, name);
                return map;
            }, Object.create(null)) : null
        };
    }
    addProperty_(name, syntax) {
        if (!syntax) return;
        this.properties[name] = this.createDescriptor(syntax, 'Property', name);
    }
    addType_(name, syntax) {
        if (!syntax) return;
        this.types[name] = this.createDescriptor(syntax, 'Type', name);
    }
    checkAtruleName(atruleName) {
        if (!this.getAtrule(atruleName)) return new (0, $833883a2fa46ad31$export$65d073607b1def2)('Unknown at-rule', '@' + atruleName);
    }
    checkAtrulePrelude(atruleName, prelude) {
        const error = this.checkAtruleName(atruleName);
        if (error) return error;
        const atrule = this.getAtrule(atruleName);
        if (!atrule.prelude && prelude) return new SyntaxError('At-rule `@' + atruleName + '` should not contain a prelude');
        if (atrule.prelude && !prelude) {
            if (!$c3ffbe583ac72763$var$matchSyntax(this, atrule.prelude, '', false).matched) return new SyntaxError('At-rule `@' + atruleName + '` should contain a prelude');
        }
    }
    checkAtruleDescriptorName(atruleName, descriptorName) {
        const error = this.checkAtruleName(atruleName);
        if (error) return error;
        const atrule = this.getAtrule(atruleName);
        const descriptor = $27cf59322dfdd6cf$export$2e81050496d0e63e(descriptorName);
        if (!atrule.descriptors) return new SyntaxError('At-rule `@' + atruleName + '` has no known descriptors');
        if (!atrule.descriptors[descriptor.name] && !atrule.descriptors[descriptor.basename]) return new (0, $833883a2fa46ad31$export$65d073607b1def2)('Unknown at-rule descriptor', descriptorName);
    }
    checkPropertyName(propertyName) {
        if (!this.getProperty(propertyName)) return new (0, $833883a2fa46ad31$export$65d073607b1def2)('Unknown property', propertyName);
    }
    matchAtrulePrelude(atruleName, prelude) {
        const error = this.checkAtrulePrelude(atruleName, prelude);
        if (error) return $c3ffbe583ac72763$var$buildMatchResult(null, error);
        const atrule = this.getAtrule(atruleName);
        if (!atrule.prelude) return $c3ffbe583ac72763$var$buildMatchResult(null, null);
        return $c3ffbe583ac72763$var$matchSyntax(this, atrule.prelude, prelude || '', false);
    }
    matchAtruleDescriptor(atruleName, descriptorName, value) {
        const error = this.checkAtruleDescriptorName(atruleName, descriptorName);
        if (error) return $c3ffbe583ac72763$var$buildMatchResult(null, error);
        const atrule = this.getAtrule(atruleName);
        const descriptor = $27cf59322dfdd6cf$export$2e81050496d0e63e(descriptorName);
        return $c3ffbe583ac72763$var$matchSyntax(this, atrule.descriptors[descriptor.name] || atrule.descriptors[descriptor.basename], value, false);
    }
    matchDeclaration(node) {
        if (node.type !== 'Declaration') return $c3ffbe583ac72763$var$buildMatchResult(null, new Error('Not a Declaration node'));
        return this.matchProperty(node.property, node.value);
    }
    matchProperty(propertyName, value) {
        // don't match syntax for a custom property at the moment
        if ($27cf59322dfdd6cf$export$d541bacb2bda4494(propertyName).custom) return $c3ffbe583ac72763$var$buildMatchResult(null, new Error('Lexer matching doesn\'t applicable for custom properties'));
        const error = this.checkPropertyName(propertyName);
        if (error) return $c3ffbe583ac72763$var$buildMatchResult(null, error);
        return $c3ffbe583ac72763$var$matchSyntax(this, this.getProperty(propertyName), value, true);
    }
    matchType(typeName, value) {
        const typeSyntax = this.getType(typeName);
        if (!typeSyntax) return $c3ffbe583ac72763$var$buildMatchResult(null, new (0, $833883a2fa46ad31$export$65d073607b1def2)('Unknown type', typeName));
        return $c3ffbe583ac72763$var$matchSyntax(this, typeSyntax, value, false);
    }
    match(syntax, value) {
        if (typeof syntax !== 'string' && (!syntax || !syntax.type)) return $c3ffbe583ac72763$var$buildMatchResult(null, new (0, $833883a2fa46ad31$export$65d073607b1def2)('Bad syntax'));
        if (typeof syntax === 'string' || !syntax.match) syntax = this.createDescriptor(syntax, 'Type', 'anonymous');
        return $c3ffbe583ac72763$var$matchSyntax(this, syntax, value, false);
    }
    findValueFragments(propertyName, value, type, name) {
        return (0, $d2a84b2ed38324da$export$2c0817d7096f698)(this, value, this.matchProperty(propertyName, value), type, name);
    }
    findDeclarationValueFragments(declaration, type, name) {
        return (0, $d2a84b2ed38324da$export$2c0817d7096f698)(this, declaration.value, this.matchDeclaration(declaration), type, name);
    }
    findAllFragments(ast, type, name) {
        const result = [];
        this.syntax.walk(ast, {
            visit: 'Declaration',
            enter: (declaration)=>{
                result.push.apply(result, this.findDeclarationValueFragments(declaration, type, name));
            }
        });
        return result;
    }
    getAtrule(atruleName, fallbackBasename = true) {
        const atrule = $27cf59322dfdd6cf$export$2e81050496d0e63e(atruleName);
        const atruleEntry = atrule.vendor && fallbackBasename ? this.atrules[atrule.name] || this.atrules[atrule.basename] : this.atrules[atrule.name];
        return atruleEntry || null;
    }
    getAtrulePrelude(atruleName, fallbackBasename = true) {
        const atrule = this.getAtrule(atruleName, fallbackBasename);
        return atrule && atrule.prelude || null;
    }
    getAtruleDescriptor(atruleName, name) {
        return this.atrules.hasOwnProperty(atruleName) && this.atrules.declarators ? this.atrules[atruleName].declarators[name] || null : null;
    }
    getProperty(propertyName, fallbackBasename = true) {
        const property = $27cf59322dfdd6cf$export$d541bacb2bda4494(propertyName);
        const propertyEntry = property.vendor && fallbackBasename ? this.properties[property.name] || this.properties[property.basename] : this.properties[property.name];
        return propertyEntry || null;
    }
    getType(name) {
        return hasOwnProperty.call(this.types, name) ? this.types[name] : null;
    }
    validate() {
        function syntaxRef(name, isType) {
            return isType ? `<${name}>` : `<'${name}'>`;
        }
        function validate(syntax, name, broken, descriptor) {
            if (broken.has(name)) return broken.get(name);
            broken.set(name, false);
            if (descriptor.syntax !== null) (0, $70a5e6af7d4aa4b1$export$588732934346abbf)(descriptor.syntax, function(node) {
                if (node.type !== 'Type' && node.type !== 'Property') return;
                const map = node.type === 'Type' ? syntax.types : syntax.properties;
                const brokenMap = node.type === 'Type' ? brokenTypes : brokenProperties;
                if (!hasOwnProperty.call(map, node.name)) {
                    errors.push(`${syntaxRef(name, broken === brokenTypes)} used missed syntax definition ${syntaxRef(node.name, node.type === 'Type')}`);
                    broken.set(name, true);
                } else if (validate(syntax, node.name, brokenMap, map[node.name])) {
                    errors.push(`${syntaxRef(name, broken === brokenTypes)} used broken syntax definition ${syntaxRef(node.name, node.type === 'Type')}`);
                    broken.set(name, true);
                }
            }, this);
        }
        const errors = [];
        let brokenTypes = new Map();
        let brokenProperties = new Map();
        for(const key in this.types)validate(this, key, brokenTypes, this.types[key]);
        for(const key in this.properties)validate(this, key, brokenProperties, this.properties[key]);
        const brokenTypesArray = [
            ...brokenTypes.keys()
        ].filter((name)=>brokenTypes.get(name));
        const brokenPropertiesArray = [
            ...brokenProperties.keys()
        ].filter((name)=>brokenProperties.get(name));
        if (brokenTypesArray.length || brokenPropertiesArray.length) return {
            errors: errors,
            types: brokenTypesArray,
            properties: brokenPropertiesArray
        };
        return null;
    }
    dump(syntaxAsAst, pretty) {
        return {
            generic: this.generic,
            cssWideKeywords: this.cssWideKeywords,
            units: this.units,
            types: $c3ffbe583ac72763$var$dumpMapSyntax(this.types, !pretty, syntaxAsAst),
            properties: $c3ffbe583ac72763$var$dumpMapSyntax(this.properties, !pretty, syntaxAsAst),
            atrules: $c3ffbe583ac72763$var$dumpAtruleMapSyntax(this.atrules, !pretty, syntaxAsAst)
        };
    }
    toString() {
        return JSON.stringify(this.dump());
    }
}


function $03d9983475f5d5d4$var$appendOrSet(a, b) {
    if (typeof b === 'string' && /^\s*\|/.test(b)) return typeof a === 'string' ? a + b : b.replace(/^\s*\|\s*/, '');
    return b || null;
}
function $03d9983475f5d5d4$var$sliceProps(obj, props) {
    const result = Object.create(null);
    for (const [key, value] of Object.entries(obj))if (value) {
        result[key] = {};
        for (const prop of Object.keys(value))if (props.includes(prop)) result[key][prop] = value[prop];
    }
    return result;
}
function $03d9983475f5d5d4$export$2e2bcd8739ae039(dest, src) {
    const result = {
        ...dest
    };
    for (const [prop, value] of Object.entries(src))switch(prop){
        case 'generic':
            result[prop] = Boolean(value);
            break;
        case 'cssWideKeywords':
            result[prop] = dest[prop] ? [
                ...dest[prop],
                ...value
            ] : value || [];
            break;
        case 'units':
            result[prop] = {
                ...dest[prop]
            };
            for (const [name, patch] of Object.entries(value))result[prop][name] = Array.isArray(patch) ? patch : [];
            break;
        case 'atrules':
            result[prop] = {
                ...dest[prop]
            };
            for (const [name, atrule] of Object.entries(value)){
                const exists = result[prop][name] || {};
                const current = result[prop][name] = {
                    prelude: exists.prelude || null,
                    descriptors: {
                        ...exists.descriptors
                    }
                };
                if (!atrule) continue;
                current.prelude = atrule.prelude ? $03d9983475f5d5d4$var$appendOrSet(current.prelude, atrule.prelude) : current.prelude || null;
                for (const [descriptorName, descriptorValue] of Object.entries(atrule.descriptors || {}))current.descriptors[descriptorName] = descriptorValue ? $03d9983475f5d5d4$var$appendOrSet(current.descriptors[descriptorName], descriptorValue) : null;
                if (!Object.keys(current.descriptors).length) current.descriptors = null;
            }
            break;
        case 'types':
        case 'properties':
            result[prop] = {
                ...dest[prop]
            };
            for (const [name, syntax] of Object.entries(value))result[prop][name] = $03d9983475f5d5d4$var$appendOrSet(result[prop][name], syntax);
            break;
        case 'scope':
        case 'features':
            result[prop] = {
                ...dest[prop]
            };
            for (const [name, props] of Object.entries(value))result[prop][name] = {
                ...result[prop][name],
                ...props
            };
            break;
        case 'parseContext':
            result[prop] = {
                ...dest[prop],
                ...value
            };
            break;
        case 'atrule':
        case 'pseudo':
            result[prop] = {
                ...dest[prop],
                ...$03d9983475f5d5d4$var$sliceProps(value, [
                    'parse'
                ])
            };
            break;
        case 'node':
            result[prop] = {
                ...dest[prop],
                ...$03d9983475f5d5d4$var$sliceProps(value, [
                    'name',
                    'structure',
                    'parse',
                    'generate',
                    'walkContext'
                ])
            };
            break;
    }
    return result;
}


function $e18ab7fe63bfa5f9$var$createSyntax(config) {
    const parse = (0, $b489d312071c19a3$export$88a1156fad04455f)(config);
    const walk = (0, $021e21228e152a58$export$774c92c6aec941e8)(config);
    const generate = (0, $f52d95f0d194c2b7$export$881f0ad61271ba2)(config);
    const { fromPlainObject: fromPlainObject, toPlainObject: toPlainObject } = (0, $5cec6377554605f1$export$270c35c9c0b7b1f9)(walk);
    const syntax = {
        lexer: null,
        createLexer: (config)=>new (0, $c3ffbe583ac72763$export$6168dc8908a6c652)(config, syntax, syntax.lexer.structure),
        tokenize: $852eae0c0686a388$export$660b2ee2d4fb4eff,
        parse: parse,
        generate: generate,
        walk: walk,
        find: walk.find,
        findLast: walk.findLast,
        findAll: walk.findAll,
        fromPlainObject: fromPlainObject,
        toPlainObject: toPlainObject,
        fork (extension) {
            const base = (0, $03d9983475f5d5d4$export$2e2bcd8739ae039)({}, config); // copy of config
            return $e18ab7fe63bfa5f9$var$createSyntax(typeof extension === 'function' ? extension(base) // TODO: remove Object.assign as second parameter
             : (0, $03d9983475f5d5d4$export$2e2bcd8739ae039)(base, extension));
        }
    };
    syntax.lexer = new (0, $c3ffbe583ac72763$export$6168dc8908a6c652)({
        generic: config.generic,
        cssWideKeywords: config.cssWideKeywords,
        units: config.units,
        types: config.types,
        atrules: config.atrules,
        properties: config.properties,
        node: config.node
    }, syntax);
    return syntax;
}
var $e18ab7fe63bfa5f9$export$2e2bcd8739ae039 = (config)=>$e18ab7fe63bfa5f9$var$createSyntax((0, $03d9983475f5d5d4$export$2e2bcd8739ae039)({}, config));



var $3a03e93b9ed04fd8$export$2e2bcd8739ae039 = {
    "generic": true,
    "cssWideKeywords": [
        "initial",
        "inherit",
        "unset",
        "revert",
        "revert-layer"
    ],
    "units": {
        "angle": [
            "deg",
            "grad",
            "rad",
            "turn"
        ],
        "decibel": [
            "db"
        ],
        "flex": [
            "fr"
        ],
        "frequency": [
            "hz",
            "khz"
        ],
        "length": [
            "cm",
            "mm",
            "q",
            "in",
            "pt",
            "pc",
            "px",
            "em",
            "rem",
            "ex",
            "rex",
            "cap",
            "rcap",
            "ch",
            "rch",
            "ic",
            "ric",
            "lh",
            "rlh",
            "vw",
            "svw",
            "lvw",
            "dvw",
            "vh",
            "svh",
            "lvh",
            "dvh",
            "vi",
            "svi",
            "lvi",
            "dvi",
            "vb",
            "svb",
            "lvb",
            "dvb",
            "vmin",
            "svmin",
            "lvmin",
            "dvmin",
            "vmax",
            "svmax",
            "lvmax",
            "dvmax",
            "cqw",
            "cqh",
            "cqi",
            "cqb",
            "cqmin",
            "cqmax"
        ],
        "resolution": [
            "dpi",
            "dpcm",
            "dppx",
            "x"
        ],
        "semitones": [
            "st"
        ],
        "time": [
            "s",
            "ms"
        ]
    },
    "types": {
        "abs()": "abs( <calc-sum> )",
        "absolute-size": "xx-small|x-small|small|medium|large|x-large|xx-large|xxx-large",
        "acos()": "acos( <calc-sum> )",
        "alpha-value": "<number>|<percentage>",
        "angle-percentage": "<angle>|<percentage>",
        "angular-color-hint": "<angle-percentage>",
        "angular-color-stop": "<color>&&<color-stop-angle>?",
        "angular-color-stop-list": "[<angular-color-stop> [, <angular-color-hint>]?]# , <angular-color-stop>",
        "animateable-feature": "scroll-position|contents|<custom-ident>",
        "asin()": "asin( <calc-sum> )",
        "atan()": "atan( <calc-sum> )",
        "atan2()": "atan2( <calc-sum> , <calc-sum> )",
        "attachment": "scroll|fixed|local",
        "attr()": "attr( <attr-name> <type-or-unit>? [, <attr-fallback>]? )",
        "attr-matcher": "['~'|'|'|'^'|'$'|'*']? '='",
        "attr-modifier": "i|s",
        "attribute-selector": "'[' <wq-name> ']'|'[' <wq-name> <attr-matcher> [<string-token>|<ident-token>] <attr-modifier>? ']'",
        "auto-repeat": "repeat( [auto-fill|auto-fit] , [<line-names>? <fixed-size>]+ <line-names>? )",
        "auto-track-list": "[<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>? <auto-repeat> [<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>?",
        "axis": "block|inline|x|y",
        "baseline-position": "[first|last]? baseline",
        "basic-shape": "<inset()>|<xywh()>|<rect()>|<circle()>|<ellipse()>|<polygon()>|<path()>",
        "bg-image": "none|<image>",
        "bg-layer": "<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<box>||<box>",
        "bg-position": "[[left|center|right|top|bottom|<length-percentage>]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]|[center|[left|right] <length-percentage>?]&&[center|[top|bottom] <length-percentage>?]]",
        "bg-size": "[<length-percentage>|auto]{1,2}|cover|contain",
        "blur()": "blur( <length> )",
        "blend-mode": "normal|multiply|screen|overlay|darken|lighten|color-dodge|color-burn|hard-light|soft-light|difference|exclusion|hue|saturation|color|luminosity",
        "box": "border-box|padding-box|content-box",
        "brightness()": "brightness( <number-percentage> )",
        "calc()": "calc( <calc-sum> )",
        "calc-sum": "<calc-product> [['+'|'-'] <calc-product>]*",
        "calc-product": "<calc-value> ['*' <calc-value>|'/' <number>]*",
        "calc-value": "<number>|<dimension>|<percentage>|<calc-constant>|( <calc-sum> )",
        "calc-constant": "e|pi|infinity|-infinity|NaN",
        "cf-final-image": "<image>|<color>",
        "cf-mixing-image": "<percentage>?&&<image>",
        "circle()": "circle( [<shape-radius>]? [at <position>]? )",
        "clamp()": "clamp( <calc-sum>#{3} )",
        "class-selector": "'.' <ident-token>",
        "clip-source": "<url>",
        "color": "<color-base>|currentColor|<system-color>|<device-cmyk()>|<light-dark()>|<-non-standard-color>",
        "color-stop": "<color-stop-length>|<color-stop-angle>",
        "color-stop-angle": "<angle-percentage>{1,2}",
        "color-stop-length": "<length-percentage>{1,2}",
        "color-stop-list": "[<linear-color-stop> [, <linear-color-hint>]?]# , <linear-color-stop>",
        "color-interpolation-method": "in [<rectangular-color-space>|<polar-color-space> <hue-interpolation-method>?|<custom-color-space>]",
        "combinator": "'>'|'+'|'~'|['|' '|']",
        "common-lig-values": "[common-ligatures|no-common-ligatures]",
        "compat-auto": "searchfield|textarea|push-button|slider-horizontal|checkbox|radio|square-button|menulist|listbox|meter|progress-bar|button",
        "composite-style": "clear|copy|source-over|source-in|source-out|source-atop|destination-over|destination-in|destination-out|destination-atop|xor",
        "compositing-operator": "add|subtract|intersect|exclude",
        "compound-selector": "[<type-selector>? <subclass-selector>*]!",
        "compound-selector-list": "<compound-selector>#",
        "complex-selector": "<complex-selector-unit> [<combinator>? <complex-selector-unit>]*",
        "complex-selector-list": "<complex-selector>#",
        "conic-gradient()": "conic-gradient( [from <angle>]? [at <position>]? , <angular-color-stop-list> )",
        "contextual-alt-values": "[contextual|no-contextual]",
        "content-distribution": "space-between|space-around|space-evenly|stretch",
        "content-list": "[<string>|contents|<image>|<counter>|<quote>|<target>|<leader()>|<attr()>]+",
        "content-position": "center|start|end|flex-start|flex-end",
        "content-replacement": "<image>",
        "contrast()": "contrast( [<number-percentage>] )",
        "cos()": "cos( <calc-sum> )",
        "counter": "<counter()>|<counters()>",
        "counter()": "counter( <counter-name> , <counter-style>? )",
        "counter-name": "<custom-ident>",
        "counter-style": "<counter-style-name>|symbols( )",
        "counter-style-name": "<custom-ident>",
        "counters()": "counters( <counter-name> , <string> , <counter-style>? )",
        "cross-fade()": "cross-fade( <cf-mixing-image> , <cf-final-image>? )",
        "cubic-bezier-timing-function": "ease|ease-in|ease-out|ease-in-out|cubic-bezier( <number [0,1]> , <number> , <number [0,1]> , <number> )",
        "deprecated-system-color": "ActiveBorder|ActiveCaption|AppWorkspace|Background|ButtonFace|ButtonHighlight|ButtonShadow|ButtonText|CaptionText|GrayText|Highlight|HighlightText|InactiveBorder|InactiveCaption|InactiveCaptionText|InfoBackground|InfoText|Menu|MenuText|Scrollbar|ThreeDDarkShadow|ThreeDFace|ThreeDHighlight|ThreeDLightShadow|ThreeDShadow|Window|WindowFrame|WindowText",
        "discretionary-lig-values": "[discretionary-ligatures|no-discretionary-ligatures]",
        "display-box": "contents|none",
        "display-inside": "flow|flow-root|table|flex|grid|ruby",
        "display-internal": "table-row-group|table-header-group|table-footer-group|table-row|table-cell|table-column-group|table-column|table-caption|ruby-base|ruby-text|ruby-base-container|ruby-text-container",
        "display-legacy": "inline-block|inline-list-item|inline-table|inline-flex|inline-grid",
        "display-listitem": "<display-outside>?&&[flow|flow-root]?&&list-item",
        "display-outside": "block|inline|run-in",
        "drop-shadow()": "drop-shadow( <length>{2,3} <color>? )",
        "east-asian-variant-values": "[jis78|jis83|jis90|jis04|simplified|traditional]",
        "east-asian-width-values": "[full-width|proportional-width]",
        "element()": "element( <custom-ident> , [first|start|last|first-except]? )|element( <id-selector> )",
        "ellipse()": "ellipse( [<shape-radius>{2}]? [at <position>]? )",
        "ending-shape": "circle|ellipse",
        "env()": "env( <custom-ident> , <declaration-value>? )",
        "exp()": "exp( <calc-sum> )",
        "explicit-track-list": "[<line-names>? <track-size>]+ <line-names>?",
        "family-name": "<string>|<custom-ident>+",
        "feature-tag-value": "<string> [<integer>|on|off]?",
        "feature-type": "@stylistic|@historical-forms|@styleset|@character-variant|@swash|@ornaments|@annotation",
        "feature-value-block": "<feature-type> '{' <feature-value-declaration-list> '}'",
        "feature-value-block-list": "<feature-value-block>+",
        "feature-value-declaration": "<custom-ident> : <integer>+ ;",
        "feature-value-declaration-list": "<feature-value-declaration>",
        "feature-value-name": "<custom-ident>",
        "fill-rule": "nonzero|evenodd",
        "filter-function": "<blur()>|<brightness()>|<contrast()>|<drop-shadow()>|<grayscale()>|<hue-rotate()>|<invert()>|<opacity()>|<saturate()>|<sepia()>",
        "filter-function-list": "[<filter-function>|<url>]+",
        "final-bg-layer": "<'background-color'>||<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<box>||<box>",
        "fixed-breadth": "<length-percentage>",
        "fixed-repeat": "repeat( [<integer [1,\u221E]>] , [<line-names>? <fixed-size>]+ <line-names>? )",
        "fixed-size": "<fixed-breadth>|minmax( <fixed-breadth> , <track-breadth> )|minmax( <inflexible-breadth> , <fixed-breadth> )",
        "font-stretch-absolute": "normal|ultra-condensed|extra-condensed|condensed|semi-condensed|semi-expanded|expanded|extra-expanded|ultra-expanded|<percentage>",
        "font-variant-css21": "[normal|small-caps]",
        "font-weight-absolute": "normal|bold|<number [1,1000]>",
        "frequency-percentage": "<frequency>|<percentage>",
        "general-enclosed": "[<function-token> <any-value>? )]|[( <any-value>? )]",
        "generic-family": "<generic-script-specific>|<generic-complete>|<generic-incomplete>|<-non-standard-generic-family>",
        "generic-name": "serif|sans-serif|cursive|fantasy|monospace",
        "geometry-box": "<shape-box>|fill-box|stroke-box|view-box",
        "gradient": "<linear-gradient()>|<repeating-linear-gradient()>|<radial-gradient()>|<repeating-radial-gradient()>|<conic-gradient()>|<repeating-conic-gradient()>|<-legacy-gradient>",
        "grayscale()": "grayscale( <number-percentage> )",
        "grid-line": "auto|<custom-ident>|[<integer>&&<custom-ident>?]|[span&&[<integer>||<custom-ident>]]",
        "historical-lig-values": "[historical-ligatures|no-historical-ligatures]",
        "hsl()": "hsl( <hue> <percentage> <percentage> [/ <alpha-value>]? )|hsl( <hue> , <percentage> , <percentage> , <alpha-value>? )",
        "hsla()": "hsla( <hue> <percentage> <percentage> [/ <alpha-value>]? )|hsla( <hue> , <percentage> , <percentage> , <alpha-value>? )",
        "hue": "<number>|<angle>",
        "hue-rotate()": "hue-rotate( <angle> )",
        "hue-interpolation-method": "[shorter|longer|increasing|decreasing] hue",
        "hwb()": "hwb( [<hue>|none] [<percentage>|none] [<percentage>|none] [/ [<alpha-value>|none]]? )",
        "hypot()": "hypot( <calc-sum># )",
        "image": "<url>|<image()>|<image-set()>|<element()>|<paint()>|<cross-fade()>|<gradient>",
        "image()": "image( <image-tags>? [<image-src>? , <color>?]! )",
        "image-set()": "image-set( <image-set-option># )",
        "image-set-option": "[<image>|<string>] [<resolution>||type( <string> )]",
        "image-src": "<url>|<string>",
        "image-tags": "ltr|rtl",
        "inflexible-breadth": "<length-percentage>|min-content|max-content|auto",
        "inset()": "inset( <length-percentage>{1,4} [round <'border-radius'>]? )",
        "invert()": "invert( <number-percentage> )",
        "keyframes-name": "<custom-ident>|<string>",
        "keyframe-block": "<keyframe-selector># { <declaration-list> }",
        "keyframe-block-list": "<keyframe-block>+",
        "keyframe-selector": "from|to|<percentage>|<timeline-range-name> <percentage>",
        "lab()": "lab( [<percentage>|<number>|none] [<percentage>|<number>|none] [<percentage>|<number>|none] [/ [<alpha-value>|none]]? )",
        "layer()": "layer( <layer-name> )",
        "layer-name": "<ident> ['.' <ident>]*",
        "lch()": "lch( [<percentage>|<number>|none] [<percentage>|<number>|none] [<hue>|none] [/ [<alpha-value>|none]]? )",
        "leader()": "leader( <leader-type> )",
        "leader-type": "dotted|solid|space|<string>",
        "length-percentage": "<length>|<percentage>",
        "light-dark()": "light-dark( <color> , <color> )",
        "line-names": "'[' <custom-ident>* ']'",
        "line-name-list": "[<line-names>|<name-repeat>]+",
        "line-style": "none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset",
        "line-width": "<length>|thin|medium|thick",
        "linear-color-hint": "<length-percentage>",
        "linear-color-stop": "<color> <color-stop-length>?",
        "linear-gradient()": "linear-gradient( [[<angle>|to <side-or-corner>]||<color-interpolation-method>]? , <color-stop-list> )",
        "log()": "log( <calc-sum> , <calc-sum>? )",
        "mask-layer": "<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||<geometry-box>||[<geometry-box>|no-clip]||<compositing-operator>||<masking-mode>",
        "mask-position": "[<length-percentage>|left|center|right] [<length-percentage>|top|center|bottom]?",
        "mask-reference": "none|<image>|<mask-source>",
        "mask-source": "<url>",
        "masking-mode": "alpha|luminance|match-source",
        "matrix()": "matrix( <number>#{6} )",
        "matrix3d()": "matrix3d( <number>#{16} )",
        "max()": "max( <calc-sum># )",
        "media-and": "<media-in-parens> [and <media-in-parens>]+",
        "media-condition": "<media-not>|<media-and>|<media-or>|<media-in-parens>",
        "media-condition-without-or": "<media-not>|<media-and>|<media-in-parens>",
        "media-feature": "( [<mf-plain>|<mf-boolean>|<mf-range>] )",
        "media-in-parens": "( <media-condition> )|<media-feature>|<general-enclosed>",
        "media-not": "not <media-in-parens>",
        "media-or": "<media-in-parens> [or <media-in-parens>]+",
        "media-query": "<media-condition>|[not|only]? <media-type> [and <media-condition-without-or>]?",
        "media-query-list": "<media-query>#",
        "media-type": "<ident>",
        "mf-boolean": "<mf-name>",
        "mf-name": "<ident>",
        "mf-plain": "<mf-name> : <mf-value>",
        "mf-range": "<mf-name> ['<'|'>']? '='? <mf-value>|<mf-value> ['<'|'>']? '='? <mf-name>|<mf-value> '<' '='? <mf-name> '<' '='? <mf-value>|<mf-value> '>' '='? <mf-name> '>' '='? <mf-value>",
        "mf-value": "<number>|<dimension>|<ident>|<ratio>",
        "min()": "min( <calc-sum># )",
        "minmax()": "minmax( [<length-percentage>|min-content|max-content|auto] , [<length-percentage>|<flex>|min-content|max-content|auto] )",
        "mod()": "mod( <calc-sum> , <calc-sum> )",
        "name-repeat": "repeat( [<integer [1,\u221E]>|auto-fill] , <line-names>+ )",
        "named-color": "transparent|aliceblue|antiquewhite|aqua|aquamarine|azure|beige|bisque|black|blanchedalmond|blue|blueviolet|brown|burlywood|cadetblue|chartreuse|chocolate|coral|cornflowerblue|cornsilk|crimson|cyan|darkblue|darkcyan|darkgoldenrod|darkgray|darkgreen|darkgrey|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|floralwhite|forestgreen|fuchsia|gainsboro|ghostwhite|gold|goldenrod|gray|green|greenyellow|grey|honeydew|hotpink|indianred|indigo|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgreen|lightgrey|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|lime|limegreen|linen|magenta|maroon|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|navy|oldlace|olive|olivedrab|orange|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|pink|plum|powderblue|purple|rebeccapurple|red|rosybrown|royalblue|saddlebrown|salmon|sandybrown|seagreen|seashell|sienna|silver|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|teal|thistle|tomato|turquoise|violet|wheat|white|whitesmoke|yellow|yellowgreen",
        "namespace-prefix": "<ident>",
        "ns-prefix": "[<ident-token>|'*']? '|'",
        "number-percentage": "<number>|<percentage>",
        "numeric-figure-values": "[lining-nums|oldstyle-nums]",
        "numeric-fraction-values": "[diagonal-fractions|stacked-fractions]",
        "numeric-spacing-values": "[proportional-nums|tabular-nums]",
        "nth": "<an-plus-b>|even|odd",
        "opacity()": "opacity( [<number-percentage>] )",
        "overflow-position": "unsafe|safe",
        "outline-radius": "<length>|<percentage>",
        "page-body": "<declaration>? [; <page-body>]?|<page-margin-box> <page-body>",
        "page-margin-box": "<page-margin-box-type> '{' <declaration-list> '}'",
        "page-margin-box-type": "@top-left-corner|@top-left|@top-center|@top-right|@top-right-corner|@bottom-left-corner|@bottom-left|@bottom-center|@bottom-right|@bottom-right-corner|@left-top|@left-middle|@left-bottom|@right-top|@right-middle|@right-bottom",
        "page-selector-list": "[<page-selector>#]?",
        "page-selector": "<pseudo-page>+|<ident> <pseudo-page>*",
        "page-size": "A5|A4|A3|B5|B4|JIS-B5|JIS-B4|letter|legal|ledger",
        "path()": "path( [<fill-rule> ,]? <string> )",
        "paint()": "paint( <ident> , <declaration-value>? )",
        "perspective()": "perspective( [<length [0,\u221E]>|none] )",
        "polygon()": "polygon( <fill-rule>? , [<length-percentage> <length-percentage>]# )",
        "polar-color-space": "hsl|hwb|lch|oklch",
        "position": "[[left|center|right]||[top|center|bottom]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]?|[[left|right] <length-percentage>]&&[[top|bottom] <length-percentage>]]",
        "pow()": "pow( <calc-sum> , <calc-sum> )",
        "pseudo-class-selector": "':' <ident-token>|':' <function-token> <any-value> ')'",
        "pseudo-element-selector": "':' <pseudo-class-selector>|<legacy-pseudo-element-selector>",
        "pseudo-page": ": [left|right|first|blank]",
        "quote": "open-quote|close-quote|no-open-quote|no-close-quote",
        "radial-gradient()": "radial-gradient( [<ending-shape>||<size>]? [at <position>]? , <color-stop-list> )",
        "ratio": "<number [0,\u221E]> [/ <number [0,\u221E]>]?",
        "ray()": "ray( <angle>&&<ray-size>?&&contain?&&[at <position>]? )",
        "ray-size": "closest-side|closest-corner|farthest-side|farthest-corner|sides",
        "rectangular-color-space": "srgb|srgb-linear|display-p3|a98-rgb|prophoto-rgb|rec2020|lab|oklab|xyz|xyz-d50|xyz-d65",
        "relative-selector": "<combinator>? <complex-selector>",
        "relative-selector-list": "<relative-selector>#",
        "relative-size": "larger|smaller",
        "rem()": "rem( <calc-sum> , <calc-sum> )",
        "repeat-style": "repeat-x|repeat-y|[repeat|space|round|no-repeat]{1,2}",
        "repeating-conic-gradient()": "repeating-conic-gradient( [from <angle>]? [at <position>]? , <angular-color-stop-list> )",
        "repeating-linear-gradient()": "repeating-linear-gradient( [<angle>|to <side-or-corner>]? , <color-stop-list> )",
        "repeating-radial-gradient()": "repeating-radial-gradient( [<ending-shape>||<size>]? [at <position>]? , <color-stop-list> )",
        "reversed-counter-name": "reversed( <counter-name> )",
        "rgb()": "rgb( <percentage>{3} [/ <alpha-value>]? )|rgb( <number>{3} [/ <alpha-value>]? )|rgb( <percentage>#{3} , <alpha-value>? )|rgb( <number>#{3} , <alpha-value>? )",
        "rgba()": "rgba( <percentage>{3} [/ <alpha-value>]? )|rgba( <number>{3} [/ <alpha-value>]? )|rgba( <percentage>#{3} , <alpha-value>? )|rgba( <number>#{3} , <alpha-value>? )",
        "rotate()": "rotate( [<angle>|<zero>] )",
        "rotate3d()": "rotate3d( <number> , <number> , <number> , [<angle>|<zero>] )",
        "rotateX()": "rotateX( [<angle>|<zero>] )",
        "rotateY()": "rotateY( [<angle>|<zero>] )",
        "rotateZ()": "rotateZ( [<angle>|<zero>] )",
        "round()": "round( <rounding-strategy>? , <calc-sum> , <calc-sum> )",
        "rounding-strategy": "nearest|up|down|to-zero",
        "saturate()": "saturate( <number-percentage> )",
        "scale()": "scale( [<number>|<percentage>]#{1,2} )",
        "scale3d()": "scale3d( [<number>|<percentage>]#{3} )",
        "scaleX()": "scaleX( [<number>|<percentage>] )",
        "scaleY()": "scaleY( [<number>|<percentage>] )",
        "scaleZ()": "scaleZ( [<number>|<percentage>] )",
        "scroll()": "scroll( [<axis>||<scroller>]? )",
        "scroller": "root|nearest|self",
        "self-position": "center|start|end|self-start|self-end|flex-start|flex-end",
        "shape-radius": "<length-percentage>|closest-side|farthest-side",
        "sign()": "sign( <calc-sum> )",
        "skew()": "skew( [<angle>|<zero>] , [<angle>|<zero>]? )",
        "skewX()": "skewX( [<angle>|<zero>] )",
        "skewY()": "skewY( [<angle>|<zero>] )",
        "sepia()": "sepia( <number-percentage> )",
        "shadow": "inset?&&<length>{2,4}&&<color>?",
        "shadow-t": "[<length>{2,3}&&<color>?]",
        "shape": "rect( <top> , <right> , <bottom> , <left> )|rect( <top> <right> <bottom> <left> )",
        "shape-box": "<box>|margin-box",
        "side-or-corner": "[left|right]||[top|bottom]",
        "sin()": "sin( <calc-sum> )",
        "single-animation": "<'animation-duration'>||<easing-function>||<'animation-delay'>||<single-animation-iteration-count>||<single-animation-direction>||<single-animation-fill-mode>||<single-animation-play-state>||[none|<keyframes-name>]||<single-animation-timeline>",
        "single-animation-direction": "normal|reverse|alternate|alternate-reverse",
        "single-animation-fill-mode": "none|forwards|backwards|both",
        "single-animation-iteration-count": "infinite|<number>",
        "single-animation-play-state": "running|paused",
        "single-animation-timeline": "auto|none|<dashed-ident>|<scroll()>|<view()>",
        "single-transition": "[none|<single-transition-property>]||<time>||<easing-function>||<time>||<transition-behavior-value>",
        "single-transition-property": "all|<custom-ident>",
        "size": "closest-side|farthest-side|closest-corner|farthest-corner|<length>|<length-percentage>{2}",
        "sqrt()": "sqrt( <calc-sum> )",
        "step-position": "jump-start|jump-end|jump-none|jump-both|start|end",
        "step-timing-function": "step-start|step-end|steps( <integer> [, <step-position>]? )",
        "subclass-selector": "<id-selector>|<class-selector>|<attribute-selector>|<pseudo-class-selector>",
        "supports-condition": "not <supports-in-parens>|<supports-in-parens> [and <supports-in-parens>]*|<supports-in-parens> [or <supports-in-parens>]*",
        "supports-in-parens": "( <supports-condition> )|<supports-feature>|<general-enclosed>",
        "supports-feature": "<supports-decl>|<supports-selector-fn>",
        "supports-decl": "( <declaration> )",
        "supports-selector-fn": "selector( <complex-selector> )",
        "symbol": "<string>|<image>|<custom-ident>",
        "system-color": "AccentColor|AccentColorText|ActiveText|ButtonBorder|ButtonFace|ButtonText|Canvas|CanvasText|Field|FieldText|GrayText|Highlight|HighlightText|LinkText|Mark|MarkText|SelectedItem|SelectedItemText|VisitedText",
        "tan()": "tan( <calc-sum> )",
        "target": "<target-counter()>|<target-counters()>|<target-text()>",
        "target-counter()": "target-counter( [<string>|<url>] , <custom-ident> , <counter-style>? )",
        "target-counters()": "target-counters( [<string>|<url>] , <custom-ident> , <string> , <counter-style>? )",
        "target-text()": "target-text( [<string>|<url>] , [content|before|after|first-letter]? )",
        "time-percentage": "<time>|<percentage>",
        "timeline-range-name": "cover|contain|entry|exit|entry-crossing|exit-crossing",
        "easing-function": "linear|<cubic-bezier-timing-function>|<step-timing-function>",
        "track-breadth": "<length-percentage>|<flex>|min-content|max-content|auto",
        "track-list": "[<line-names>? [<track-size>|<track-repeat>]]+ <line-names>?",
        "track-repeat": "repeat( [<integer [1,\u221E]>] , [<line-names>? <track-size>]+ <line-names>? )",
        "track-size": "<track-breadth>|minmax( <inflexible-breadth> , <track-breadth> )|fit-content( <length-percentage> )",
        "transform-function": "<matrix()>|<translate()>|<translateX()>|<translateY()>|<scale()>|<scaleX()>|<scaleY()>|<rotate()>|<skew()>|<skewX()>|<skewY()>|<matrix3d()>|<translate3d()>|<translateZ()>|<scale3d()>|<scaleZ()>|<rotate3d()>|<rotateX()>|<rotateY()>|<rotateZ()>|<perspective()>",
        "transform-list": "<transform-function>+",
        "transition-behavior-value": "normal|allow-discrete",
        "translate()": "translate( <length-percentage> , <length-percentage>? )",
        "translate3d()": "translate3d( <length-percentage> , <length-percentage> , <length> )",
        "translateX()": "translateX( <length-percentage> )",
        "translateY()": "translateY( <length-percentage> )",
        "translateZ()": "translateZ( <length> )",
        "type-or-unit": "string|color|url|integer|number|length|angle|time|frequency|cap|ch|em|ex|ic|lh|rlh|rem|vb|vi|vw|vh|vmin|vmax|mm|Q|cm|in|pt|pc|px|deg|grad|rad|turn|ms|s|Hz|kHz|%",
        "type-selector": "<wq-name>|<ns-prefix>? '*'",
        "var()": "var( <custom-property-name> , <declaration-value>? )",
        "view()": "view( [<axis>||<'view-timeline-inset'>]? )",
        "viewport-length": "auto|<length-percentage>",
        "visual-box": "content-box|padding-box|border-box",
        "wq-name": "<ns-prefix>? <ident-token>",
        "-legacy-gradient": "<-webkit-gradient()>|<-legacy-linear-gradient>|<-legacy-repeating-linear-gradient>|<-legacy-radial-gradient>|<-legacy-repeating-radial-gradient>",
        "-legacy-linear-gradient": "-moz-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-linear-gradient( <-legacy-linear-gradient-arguments> )",
        "-legacy-repeating-linear-gradient": "-moz-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )",
        "-legacy-linear-gradient-arguments": "[<angle>|<side-or-corner>]? , <color-stop-list>",
        "-legacy-radial-gradient": "-moz-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-radial-gradient( <-legacy-radial-gradient-arguments> )",
        "-legacy-repeating-radial-gradient": "-moz-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )",
        "-legacy-radial-gradient-arguments": "[<position> ,]? [[[<-legacy-radial-gradient-shape>||<-legacy-radial-gradient-size>]|[<length>|<percentage>]{2}] ,]? <color-stop-list>",
        "-legacy-radial-gradient-size": "closest-side|closest-corner|farthest-side|farthest-corner|contain|cover",
        "-legacy-radial-gradient-shape": "circle|ellipse",
        "-non-standard-font": "-apple-system-body|-apple-system-headline|-apple-system-subheadline|-apple-system-caption1|-apple-system-caption2|-apple-system-footnote|-apple-system-short-body|-apple-system-short-headline|-apple-system-short-subheadline|-apple-system-short-caption1|-apple-system-short-footnote|-apple-system-tall-body",
        "-non-standard-color": "-moz-ButtonDefault|-moz-ButtonHoverFace|-moz-ButtonHoverText|-moz-CellHighlight|-moz-CellHighlightText|-moz-Combobox|-moz-ComboboxText|-moz-Dialog|-moz-DialogText|-moz-dragtargetzone|-moz-EvenTreeRow|-moz-Field|-moz-FieldText|-moz-html-CellHighlight|-moz-html-CellHighlightText|-moz-mac-accentdarkestshadow|-moz-mac-accentdarkshadow|-moz-mac-accentface|-moz-mac-accentlightesthighlight|-moz-mac-accentlightshadow|-moz-mac-accentregularhighlight|-moz-mac-accentregularshadow|-moz-mac-chrome-active|-moz-mac-chrome-inactive|-moz-mac-focusring|-moz-mac-menuselect|-moz-mac-menushadow|-moz-mac-menutextselect|-moz-MenuHover|-moz-MenuHoverText|-moz-MenuBarText|-moz-MenuBarHoverText|-moz-nativehyperlinktext|-moz-OddTreeRow|-moz-win-communicationstext|-moz-win-mediatext|-moz-activehyperlinktext|-moz-default-background-color|-moz-default-color|-moz-hyperlinktext|-moz-visitedhyperlinktext|-webkit-activelink|-webkit-focus-ring-color|-webkit-link|-webkit-text",
        "-non-standard-image-rendering": "optimize-contrast|-moz-crisp-edges|-o-crisp-edges|-webkit-optimize-contrast",
        "-non-standard-overflow": "overlay|-moz-scrollbars-none|-moz-scrollbars-horizontal|-moz-scrollbars-vertical|-moz-hidden-unscrollable",
        "-non-standard-size": "intrinsic|min-intrinsic|-webkit-fill-available|-webkit-fit-content|-webkit-min-content|-webkit-max-content|-moz-available|-moz-fit-content|-moz-min-content|-moz-max-content",
        "-webkit-gradient()": "-webkit-gradient( <-webkit-gradient-type> , <-webkit-gradient-point> [, <-webkit-gradient-point>|, <-webkit-gradient-radius> , <-webkit-gradient-point>] [, <-webkit-gradient-radius>]? [, <-webkit-gradient-color-stop>]* )",
        "-webkit-gradient-color-stop": "from( <color> )|color-stop( [<number-zero-one>|<percentage>] , <color> )|to( <color> )",
        "-webkit-gradient-point": "[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]",
        "-webkit-gradient-radius": "<length>|<percentage>",
        "-webkit-gradient-type": "linear|radial",
        "-webkit-mask-box-repeat": "repeat|stretch|round",
        "-ms-filter-function-list": "<-ms-filter-function>+",
        "-ms-filter-function": "<-ms-filter-function-progid>|<-ms-filter-function-legacy>",
        "-ms-filter-function-progid": "'progid:' [<ident-token> '.']* [<ident-token>|<function-token> <any-value>? )]",
        "-ms-filter-function-legacy": "<ident-token>|<function-token> <any-value>? )",
        "absolute-color-base": "<hex-color>|<absolute-color-function>|<named-color>|transparent",
        "absolute-color-function": "<rgb()>|<rgba()>|<hsl()>|<hsla()>|<hwb()>|<lab()>|<lch()>|<oklab()>|<oklch()>|<color()>",
        "age": "child|young|old",
        "anchor-name": "<dashed-ident>",
        "attr-name": "<wq-name>",
        "attr-fallback": "<any-value>",
        "bg-clip": "<box>|border|text",
        "bottom": "<length>|auto",
        "container-name": "<custom-ident>",
        "container-condition": "not <query-in-parens>|<query-in-parens> [[and <query-in-parens>]*|[or <query-in-parens>]*]",
        "coord-box": "content-box|padding-box|border-box|fill-box|stroke-box|view-box",
        "generic-voice": "[<age>? <gender> <integer>?]",
        "gender": "male|female|neutral",
        "generic-script-specific": "generic( kai )|generic( fangsong )|generic( nastaliq )",
        "generic-complete": "serif|sans-serif|system-ui|cursive|fantasy|math|monospace",
        "generic-incomplete": "ui-serif|ui-sans-serif|ui-monospace|ui-rounded",
        "-non-standard-generic-family": "-apple-system|BlinkMacSystemFont",
        "left": "<length>|auto",
        "color-base": "<hex-color>|<color-function>|<named-color>|<color-mix()>|transparent",
        "color-function": "<rgb()>|<rgba()>|<hsl()>|<hsla()>|<hwb()>|<lab()>|<lch()>|<oklab()>|<oklch()>|<color()>",
        "device-cmyk()": "<legacy-device-cmyk-syntax>|<modern-device-cmyk-syntax>",
        "legacy-device-cmyk-syntax": "device-cmyk( <number>#{4} )",
        "modern-device-cmyk-syntax": "device-cmyk( <cmyk-component>{4} [/ [<alpha-value>|none]]? )",
        "cmyk-component": "<number>|<percentage>|none",
        "color-mix()": "color-mix( <color-interpolation-method> , [<color>&&<percentage [0,100]>?]#{2} )",
        "color-space": "<rectangular-color-space>|<polar-color-space>|<custom-color-space>",
        "custom-color-space": "<dashed-ident>",
        "paint": "none|<color>|<url> [none|<color>]?|context-fill|context-stroke",
        "palette-identifier": "<dashed-ident>",
        "right": "<length>|auto",
        "scope-start": "<forgiving-selector-list>",
        "scope-end": "<forgiving-selector-list>",
        "forgiving-selector-list": "<complex-real-selector-list>",
        "forgiving-relative-selector-list": "<relative-real-selector-list>",
        "selector-list": "<complex-selector-list>",
        "complex-real-selector-list": "<complex-real-selector>#",
        "simple-selector-list": "<simple-selector>#",
        "relative-real-selector-list": "<relative-real-selector>#",
        "complex-selector-unit": "[<compound-selector>? <pseudo-compound-selector>*]!",
        "complex-real-selector": "<compound-selector> [<combinator>? <compound-selector>]*",
        "relative-real-selector": "<combinator>? <complex-real-selector>",
        "pseudo-compound-selector": "<pseudo-element-selector> <pseudo-class-selector>*",
        "simple-selector": "<type-selector>|<subclass-selector>",
        "legacy-pseudo-element-selector": "':' [before|after|first-line|first-letter]",
        "single-animation-composition": "replace|add|accumulate",
        "svg-length": "<percentage>|<length>|<number>",
        "svg-writing-mode": "lr-tb|rl-tb|tb-rl|lr|rl|tb",
        "top": "<length>|auto",
        "x": "<number>",
        "y": "<number>",
        "declaration": "<ident-token> : <declaration-value>? ['!' important]?",
        "declaration-list": "[<declaration>? ';']* <declaration>?",
        "url": "url( <string> <url-modifier>* )|<url-token>",
        "url-modifier": "<ident>|<function-token> <any-value> )",
        "number-zero-one": "<number [0,1]>",
        "number-one-or-greater": "<number [1,\u221E]>",
        "color()": "color( <colorspace-params> [/ [<alpha-value>|none]]? )",
        "colorspace-params": "[<predefined-rgb-params>|<xyz-params>]",
        "predefined-rgb-params": "<predefined-rgb> [<number>|<percentage>|none]{3}",
        "predefined-rgb": "srgb|srgb-linear|display-p3|a98-rgb|prophoto-rgb|rec2020",
        "xyz-params": "<xyz-space> [<number>|<percentage>|none]{3}",
        "xyz-space": "xyz|xyz-d50|xyz-d65",
        "oklab()": "oklab( [<percentage>|<number>|none] [<percentage>|<number>|none] [<percentage>|<number>|none] [/ [<alpha-value>|none]]? )",
        "oklch()": "oklch( [<percentage>|<number>|none] [<percentage>|<number>|none] [<hue>|none] [/ [<alpha-value>|none]]? )",
        "offset-path": "<ray()>|<url>|<basic-shape>",
        "rect()": "rect( [<length-percentage>|auto]{4} [round <'border-radius'>]? )",
        "xywh()": "xywh( <length-percentage>{2} <length-percentage [0,\u221E]>{2} [round <'border-radius'>]? )",
        "query-in-parens": "( <container-condition> )|( <size-feature> )|style( <style-query> )|<general-enclosed>",
        "size-feature": "<mf-plain>|<mf-boolean>|<mf-range>",
        "style-feature": "<declaration>",
        "style-query": "<style-condition>|<style-feature>",
        "style-condition": "not <style-in-parens>|<style-in-parens> [[and <style-in-parens>]*|[or <style-in-parens>]*]",
        "style-in-parens": "( <style-condition> )|( <style-feature> )|<general-enclosed>",
        "-non-standard-display": "-ms-inline-flexbox|-ms-grid|-ms-inline-grid|-webkit-flex|-webkit-inline-flex|-webkit-box|-webkit-inline-box|-moz-inline-stack|-moz-box|-moz-inline-box",
        "inset-area": "[[left|center|right|span-left|span-right|x-start|x-end|span-x-start|span-x-end|x-self-start|x-self-end|span-x-self-start|span-x-self-end|span-all]||[top|center|bottom|span-top|span-bottom|y-start|y-end|span-y-start|span-y-end|y-self-start|y-self-end|span-y-self-start|span-y-self-end|span-all]|[block-start|center|block-end|span-block-start|span-block-end|span-all]||[inline-start|center|inline-end|span-inline-start|span-inline-end|span-all]|[self-block-start|self-block-end|span-self-block-start|span-self-block-end|span-all]||[self-inline-start|self-inline-end|span-self-inline-start|span-self-inline-end|span-all]|[start|center|end|span-start|span-end|span-all]{1,2}|[self-start|center|self-end|span-self-start|span-self-end|span-all]{1,2}]",
        "position-area": "[[left|center|right|span-left|span-right|x-start|x-end|span-x-start|span-x-end|x-self-start|x-self-end|span-x-self-start|span-x-self-end|span-all]||[top|center|bottom|span-top|span-bottom|y-start|y-end|span-y-start|span-y-end|y-self-start|y-self-end|span-y-self-start|span-y-self-end|span-all]|[block-start|center|block-end|span-block-start|span-block-end|span-all]||[inline-start|center|inline-end|span-inline-start|span-inline-end|span-all]|[self-block-start|center|self-block-end|span-self-block-start|span-self-block-end|span-all]||[self-inline-start|center|self-inline-end|span-self-inline-start|span-self-inline-end|span-all]|[start|center|end|span-start|span-end|span-all]{1,2}|[self-start|center|self-end|span-self-start|span-self-end|span-all]{1,2}]",
        "anchor()": "anchor( <anchor-element>?&&<anchor-side> , <length-percentage>? )",
        "anchor-side": "inside|outside|top|left|right|bottom|start|end|self-start|self-end|<percentage>|center",
        "anchor-size()": "anchor-size( [<anchor-element>||<anchor-size>]? , <length-percentage>? )",
        "anchor-size": "width|height|block|inline|self-block|self-inline",
        "anchor-element": "<dashed-ident>",
        "try-size": "most-width|most-height|most-block-size|most-inline-size",
        "try-tactic": "flip-block||flip-inline||flip-start",
        "font-variant-css2": "normal|small-caps",
        "font-width-css3": "normal|ultra-condensed|extra-condensed|condensed|semi-condensed|semi-expanded|expanded|extra-expanded|ultra-expanded",
        "system-family-name": "caption|icon|menu|message-box|small-caption|status-bar"
    },
    "properties": {
        "--*": "<declaration-value>",
        "-ms-accelerator": "false|true",
        "-ms-block-progression": "tb|rl|bt|lr",
        "-ms-content-zoom-chaining": "none|chained",
        "-ms-content-zooming": "none|zoom",
        "-ms-content-zoom-limit": "<'-ms-content-zoom-limit-min'> <'-ms-content-zoom-limit-max'>",
        "-ms-content-zoom-limit-max": "<percentage>",
        "-ms-content-zoom-limit-min": "<percentage>",
        "-ms-content-zoom-snap": "<'-ms-content-zoom-snap-type'>||<'-ms-content-zoom-snap-points'>",
        "-ms-content-zoom-snap-points": "snapInterval( <percentage> , <percentage> )|snapList( <percentage># )",
        "-ms-content-zoom-snap-type": "none|proximity|mandatory",
        "-ms-filter": "<string>",
        "-ms-flow-from": "[none|<custom-ident>]#",
        "-ms-flow-into": "[none|<custom-ident>]#",
        "-ms-grid-columns": "none|<track-list>|<auto-track-list>",
        "-ms-grid-rows": "none|<track-list>|<auto-track-list>",
        "-ms-high-contrast-adjust": "auto|none",
        "-ms-hyphenate-limit-chars": "auto|<integer>{1,3}",
        "-ms-hyphenate-limit-lines": "no-limit|<integer>",
        "-ms-hyphenate-limit-zone": "<percentage>|<length>",
        "-ms-ime-align": "auto|after",
        "-ms-overflow-style": "auto|none|scrollbar|-ms-autohiding-scrollbar",
        "-ms-scrollbar-3dlight-color": "<color>",
        "-ms-scrollbar-arrow-color": "<color>",
        "-ms-scrollbar-base-color": "<color>",
        "-ms-scrollbar-darkshadow-color": "<color>",
        "-ms-scrollbar-face-color": "<color>",
        "-ms-scrollbar-highlight-color": "<color>",
        "-ms-scrollbar-shadow-color": "<color>",
        "-ms-scrollbar-track-color": "<color>",
        "-ms-scroll-chaining": "chained|none",
        "-ms-scroll-limit": "<'-ms-scroll-limit-x-min'> <'-ms-scroll-limit-y-min'> <'-ms-scroll-limit-x-max'> <'-ms-scroll-limit-y-max'>",
        "-ms-scroll-limit-x-max": "auto|<length>",
        "-ms-scroll-limit-x-min": "<length>",
        "-ms-scroll-limit-y-max": "auto|<length>",
        "-ms-scroll-limit-y-min": "<length>",
        "-ms-scroll-rails": "none|railed",
        "-ms-scroll-snap-points-x": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
        "-ms-scroll-snap-points-y": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
        "-ms-scroll-snap-type": "none|proximity|mandatory",
        "-ms-scroll-snap-x": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-x'>",
        "-ms-scroll-snap-y": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-y'>",
        "-ms-scroll-translation": "none|vertical-to-horizontal",
        "-ms-text-autospace": "none|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space",
        "-ms-touch-select": "grippers|none",
        "-ms-user-select": "none|element|text",
        "-ms-wrap-flow": "auto|both|start|end|maximum|clear",
        "-ms-wrap-margin": "<length>",
        "-ms-wrap-through": "wrap|none",
        "-moz-appearance": "none|button|button-arrow-down|button-arrow-next|button-arrow-previous|button-arrow-up|button-bevel|button-focus|caret|checkbox|checkbox-container|checkbox-label|checkmenuitem|dualbutton|groupbox|listbox|listitem|menuarrow|menubar|menucheckbox|menuimage|menuitem|menuitemtext|menulist|menulist-button|menulist-text|menulist-textfield|menupopup|menuradio|menuseparator|meterbar|meterchunk|progressbar|progressbar-vertical|progresschunk|progresschunk-vertical|radio|radio-container|radio-label|radiomenuitem|range|range-thumb|resizer|resizerpanel|scale-horizontal|scalethumbend|scalethumb-horizontal|scalethumbstart|scalethumbtick|scalethumb-vertical|scale-vertical|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|separator|sheet|spinner|spinner-downbutton|spinner-textfield|spinner-upbutton|splitter|statusbar|statusbarpanel|tab|tabpanel|tabpanels|tab-scroll-arrow-back|tab-scroll-arrow-forward|textfield|textfield-multiline|toolbar|toolbarbutton|toolbarbutton-dropdown|toolbargripper|toolbox|tooltip|treeheader|treeheadercell|treeheadersortarrow|treeitem|treeline|treetwisty|treetwistyopen|treeview|-moz-mac-unified-toolbar|-moz-win-borderless-glass|-moz-win-browsertabbar-toolbox|-moz-win-communicationstext|-moz-win-communications-toolbox|-moz-win-exclude-glass|-moz-win-glass|-moz-win-mediatext|-moz-win-media-toolbox|-moz-window-button-box|-moz-window-button-box-maximized|-moz-window-button-close|-moz-window-button-maximize|-moz-window-button-minimize|-moz-window-button-restore|-moz-window-frame-bottom|-moz-window-frame-left|-moz-window-frame-right|-moz-window-titlebar|-moz-window-titlebar-maximized",
        "-moz-binding": "<url>|none",
        "-moz-border-bottom-colors": "<color>+|none",
        "-moz-border-left-colors": "<color>+|none",
        "-moz-border-right-colors": "<color>+|none",
        "-moz-border-top-colors": "<color>+|none",
        "-moz-context-properties": "none|[fill|fill-opacity|stroke|stroke-opacity]#",
        "-moz-float-edge": "border-box|content-box|margin-box|padding-box",
        "-moz-force-broken-image-icon": "0|1",
        "-moz-image-region": "<shape>|auto",
        "-moz-orient": "inline|block|horizontal|vertical",
        "-moz-outline-radius": "<outline-radius>{1,4} [/ <outline-radius>{1,4}]?",
        "-moz-outline-radius-bottomleft": "<outline-radius>",
        "-moz-outline-radius-bottomright": "<outline-radius>",
        "-moz-outline-radius-topleft": "<outline-radius>",
        "-moz-outline-radius-topright": "<outline-radius>",
        "-moz-stack-sizing": "ignore|stretch-to-fit",
        "-moz-text-blink": "none|blink",
        "-moz-user-focus": "ignore|normal|select-after|select-before|select-menu|select-same|select-all|none",
        "-moz-user-input": "auto|none|enabled|disabled",
        "-moz-user-modify": "read-only|read-write|write-only",
        "-moz-window-dragging": "drag|no-drag",
        "-moz-window-shadow": "default|menu|tooltip|sheet|none",
        "-webkit-appearance": "none|button|button-bevel|caps-lock-indicator|caret|checkbox|default-button|inner-spin-button|listbox|listitem|media-controls-background|media-controls-fullscreen-background|media-current-time-display|media-enter-fullscreen-button|media-exit-fullscreen-button|media-fullscreen-button|media-mute-button|media-overlay-play-button|media-play-button|media-seek-back-button|media-seek-forward-button|media-slider|media-sliderthumb|media-time-remaining-display|media-toggle-closed-captions-button|media-volume-slider|media-volume-slider-container|media-volume-sliderthumb|menulist|menulist-button|menulist-text|menulist-textfield|meter|progress-bar|progress-bar-value|push-button|radio|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbargripper-horizontal|scrollbargripper-vertical|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|searchfield-cancel-button|searchfield-decoration|searchfield-results-button|searchfield-results-decoration|slider-horizontal|slider-vertical|sliderthumb-horizontal|sliderthumb-vertical|square-button|textarea|textfield|-apple-pay-button",
        "-webkit-border-before": "<'border-width'>||<'border-style'>||<color>",
        "-webkit-border-before-color": "<color>",
        "-webkit-border-before-style": "<'border-style'>",
        "-webkit-border-before-width": "<'border-width'>",
        "-webkit-box-reflect": "[above|below|right|left]? <length>? <image>?",
        "-webkit-line-clamp": "none|<integer>",
        "-webkit-mask": "[<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||[<box>|border|padding|content|text]||[<box>|border|padding|content]]#",
        "-webkit-mask-attachment": "<attachment>#",
        "-webkit-mask-clip": "[<box>|border|padding|content|text]#",
        "-webkit-mask-composite": "<composite-style>#",
        "-webkit-mask-image": "<mask-reference>#",
        "-webkit-mask-origin": "[<box>|border|padding|content]#",
        "-webkit-mask-position": "<position>#",
        "-webkit-mask-position-x": "[<length-percentage>|left|center|right]#",
        "-webkit-mask-position-y": "[<length-percentage>|top|center|bottom]#",
        "-webkit-mask-repeat": "<repeat-style>#",
        "-webkit-mask-repeat-x": "repeat|no-repeat|space|round",
        "-webkit-mask-repeat-y": "repeat|no-repeat|space|round",
        "-webkit-mask-size": "<bg-size>#",
        "-webkit-overflow-scrolling": "auto|touch",
        "-webkit-tap-highlight-color": "<color>",
        "-webkit-text-fill-color": "<color>",
        "-webkit-text-stroke": "<length>||<color>",
        "-webkit-text-stroke-color": "<color>",
        "-webkit-text-stroke-width": "<length>",
        "-webkit-touch-callout": "default|none",
        "-webkit-user-modify": "read-only|read-write|read-write-plaintext-only",
        "accent-color": "auto|<color>",
        "align-content": "normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>",
        "align-items": "normal|stretch|<baseline-position>|[<overflow-position>? <self-position>]",
        "align-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? <self-position>",
        "align-tracks": "[normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>]#",
        "all": "initial|inherit|unset|revert|revert-layer",
        "anchor-name": "none|<dashed-ident>#",
        "anchor-scope": "none|all|<dashed-ident>#",
        "animation": "<single-animation>#",
        "animation-composition": "<single-animation-composition>#",
        "animation-delay": "<time>#",
        "animation-direction": "<single-animation-direction>#",
        "animation-duration": "<time>#",
        "animation-fill-mode": "<single-animation-fill-mode>#",
        "animation-iteration-count": "<single-animation-iteration-count>#",
        "animation-name": "[none|<keyframes-name>]#",
        "animation-play-state": "<single-animation-play-state>#",
        "animation-range": "[<'animation-range-start'> <'animation-range-end'>?]#",
        "animation-range-end": "[normal|<length-percentage>|<timeline-range-name> <length-percentage>?]#",
        "animation-range-start": "[normal|<length-percentage>|<timeline-range-name> <length-percentage>?]#",
        "animation-timing-function": "<easing-function>#",
        "animation-timeline": "<single-animation-timeline>#",
        "appearance": "none|auto|textfield|menulist-button|<compat-auto>",
        "aspect-ratio": "auto||<ratio>",
        "azimuth": "<angle>|[[left-side|far-left|left|center-left|center|center-right|right|far-right|right-side]||behind]|leftwards|rightwards",
        "backdrop-filter": "none|<filter-function-list>",
        "backface-visibility": "visible|hidden",
        "background": "[<bg-layer> ,]* <final-bg-layer>",
        "background-attachment": "<attachment>#",
        "background-blend-mode": "<blend-mode>#",
        "background-clip": "<bg-clip>#",
        "background-color": "<color>",
        "background-image": "<bg-image>#",
        "background-origin": "<box>#",
        "background-position": "<bg-position>#",
        "background-position-x": "[center|[[left|right|x-start|x-end]? <length-percentage>?]!]#",
        "background-position-y": "[center|[[top|bottom|y-start|y-end]? <length-percentage>?]!]#",
        "background-repeat": "<repeat-style>#",
        "background-size": "<bg-size>#",
        "block-size": "<'width'>",
        "border": "<line-width>||<line-style>||<color>",
        "border-block": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-block-color": "<'border-top-color'>{1,2}",
        "border-block-style": "<'border-top-style'>",
        "border-block-width": "<'border-top-width'>",
        "border-block-end": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-block-end-color": "<'border-top-color'>",
        "border-block-end-style": "<'border-top-style'>",
        "border-block-end-width": "<'border-top-width'>",
        "border-block-start": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-block-start-color": "<'border-top-color'>",
        "border-block-start-style": "<'border-top-style'>",
        "border-block-start-width": "<'border-top-width'>",
        "border-bottom": "<line-width>||<line-style>||<color>",
        "border-bottom-color": "<'border-top-color'>",
        "border-bottom-left-radius": "<length-percentage>{1,2}",
        "border-bottom-right-radius": "<length-percentage>{1,2}",
        "border-bottom-style": "<line-style>",
        "border-bottom-width": "<line-width>",
        "border-collapse": "collapse|separate",
        "border-color": "<color>{1,4}",
        "border-end-end-radius": "<length-percentage>{1,2}",
        "border-end-start-radius": "<length-percentage>{1,2}",
        "border-image": "<'border-image-source'>||<'border-image-slice'> [/ <'border-image-width'>|/ <'border-image-width'>? / <'border-image-outset'>]?||<'border-image-repeat'>",
        "border-image-outset": "[<length>|<number>]{1,4}",
        "border-image-repeat": "[stretch|repeat|round|space]{1,2}",
        "border-image-slice": "<number-percentage>{1,4}&&fill?",
        "border-image-source": "none|<image>",
        "border-image-width": "[<length-percentage>|<number>|auto]{1,4}",
        "border-inline": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-inline-end": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-inline-color": "<'border-top-color'>{1,2}",
        "border-inline-style": "<'border-top-style'>",
        "border-inline-width": "<'border-top-width'>",
        "border-inline-end-color": "<'border-top-color'>",
        "border-inline-end-style": "<'border-top-style'>",
        "border-inline-end-width": "<'border-top-width'>",
        "border-inline-start": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-inline-start-color": "<'border-top-color'>",
        "border-inline-start-style": "<'border-top-style'>",
        "border-inline-start-width": "<'border-top-width'>",
        "border-left": "<line-width>||<line-style>||<color>",
        "border-left-color": "<color>",
        "border-left-style": "<line-style>",
        "border-left-width": "<line-width>",
        "border-radius": "<length-percentage>{1,4} [/ <length-percentage>{1,4}]?",
        "border-right": "<line-width>||<line-style>||<color>",
        "border-right-color": "<color>",
        "border-right-style": "<line-style>",
        "border-right-width": "<line-width>",
        "border-spacing": "<length> <length>?",
        "border-start-end-radius": "<length-percentage>{1,2}",
        "border-start-start-radius": "<length-percentage>{1,2}",
        "border-style": "<line-style>{1,4}",
        "border-top": "<line-width>||<line-style>||<color>",
        "border-top-color": "<color>",
        "border-top-left-radius": "<length-percentage>{1,2}",
        "border-top-right-radius": "<length-percentage>{1,2}",
        "border-top-style": "<line-style>",
        "border-top-width": "<line-width>",
        "border-width": "<line-width>{1,4}",
        "bottom": "<length>|<percentage>|auto",
        "box-align": "start|center|end|baseline|stretch",
        "box-decoration-break": "slice|clone",
        "box-direction": "normal|reverse|inherit",
        "box-flex": "<number>",
        "box-flex-group": "<integer>",
        "box-lines": "single|multiple",
        "box-ordinal-group": "<integer>",
        "box-orient": "horizontal|vertical|inline-axis|block-axis|inherit",
        "box-pack": "start|center|end|justify",
        "box-shadow": "none|<shadow>#",
        "box-sizing": "content-box|border-box",
        "break-after": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
        "break-before": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
        "break-inside": "auto|avoid|avoid-page|avoid-column|avoid-region",
        "caption-side": "top|bottom|block-start|block-end|inline-start|inline-end",
        "caret": "<'caret-color'>||<'caret-shape'>",
        "caret-color": "auto|<color>",
        "caret-shape": "auto|bar|block|underscore",
        "clear": "none|left|right|both|inline-start|inline-end",
        "clip": "<shape>|auto",
        "clip-path": "<clip-source>|[<basic-shape>||<geometry-box>]|none",
        "clip-rule": "nonzero|evenodd",
        "color": "<color>",
        "color-interpolation-filters": "auto|sRGB|linearRGB",
        "color-scheme": "normal|[light|dark|<custom-ident>]+&&only?",
        "column-count": "<integer>|auto",
        "column-fill": "auto|balance",
        "column-gap": "normal|<length-percentage>",
        "column-rule": "<'column-rule-width'>||<'column-rule-style'>||<'column-rule-color'>",
        "column-rule-color": "<color>",
        "column-rule-style": "<'border-style'>",
        "column-rule-width": "<'border-width'>",
        "column-span": "none|all",
        "column-width": "<length>|auto",
        "columns": "<'column-width'>||<'column-count'>",
        "contain": "none|strict|content|[[size||inline-size]||layout||style||paint]",
        "contain-intrinsic-size": "[auto? [none|<length>]]{1,2}",
        "contain-intrinsic-block-size": "auto? [none|<length>]",
        "contain-intrinsic-height": "auto? [none|<length>]",
        "contain-intrinsic-inline-size": "auto? [none|<length>]",
        "contain-intrinsic-width": "auto? [none|<length>]",
        "container": "<'container-name'> [/ <'container-type'>]?",
        "container-name": "none|<custom-ident>+",
        "container-type": "normal||[size|inline-size]",
        "content": "normal|none|[<content-replacement>|<content-list>] [/ [<string>|<counter>]+]?",
        "content-visibility": "visible|auto|hidden",
        "counter-increment": "[<counter-name> <integer>?]+|none",
        "counter-reset": "[<counter-name> <integer>?|<reversed-counter-name> <integer>?]+|none",
        "counter-set": "[<counter-name> <integer>?]+|none",
        "cursor": "[[<url> [<x> <y>]? ,]* [auto|default|none|context-menu|help|pointer|progress|wait|cell|crosshair|text|vertical-text|alias|copy|move|no-drop|not-allowed|e-resize|n-resize|ne-resize|nw-resize|s-resize|se-resize|sw-resize|w-resize|ew-resize|ns-resize|nesw-resize|nwse-resize|col-resize|row-resize|all-scroll|zoom-in|zoom-out|grab|grabbing|hand|-webkit-grab|-webkit-grabbing|-webkit-zoom-in|-webkit-zoom-out|-moz-grab|-moz-grabbing|-moz-zoom-in|-moz-zoom-out]]",
        "d": "none|path( <string> )",
        "cx": "<length>|<percentage>",
        "cy": "<length>|<percentage>",
        "direction": "ltr|rtl",
        "display": "[<display-outside>||<display-inside>]|<display-listitem>|<display-internal>|<display-box>|<display-legacy>|<-non-standard-display>",
        "dominant-baseline": "auto|use-script|no-change|reset-size|ideographic|alphabetic|hanging|mathematical|central|middle|text-after-edge|text-before-edge",
        "empty-cells": "show|hide",
        "field-sizing": "content|fixed",
        "fill": "<paint>",
        "fill-opacity": "<number-zero-one>",
        "fill-rule": "nonzero|evenodd",
        "filter": "none|<filter-function-list>|<-ms-filter-function-list>",
        "flex": "none|[<'flex-grow'> <'flex-shrink'>?||<'flex-basis'>]",
        "flex-basis": "content|<'width'>",
        "flex-direction": "row|row-reverse|column|column-reverse",
        "flex-flow": "<'flex-direction'>||<'flex-wrap'>",
        "flex-grow": "<number>",
        "flex-shrink": "<number>",
        "flex-wrap": "nowrap|wrap|wrap-reverse",
        "float": "left|right|none|inline-start|inline-end",
        "font": "[[<'font-style'>||<font-variant-css2>||<'font-weight'>||<font-width-css3>]? <'font-size'> [/ <'line-height'>]? <'font-family'>#]|<system-family-name>|<-non-standard-font>",
        "font-family": "[<family-name>|<generic-family>]#",
        "font-feature-settings": "normal|<feature-tag-value>#",
        "font-kerning": "auto|normal|none",
        "font-language-override": "normal|<string>",
        "font-optical-sizing": "auto|none",
        "font-palette": "normal|light|dark|<palette-identifier>",
        "font-variation-settings": "normal|[<string> <number>]#",
        "font-size": "<absolute-size>|<relative-size>|<length-percentage>",
        "font-size-adjust": "none|[ex-height|cap-height|ch-width|ic-width|ic-height]? [from-font|<number>]",
        "font-smooth": "auto|never|always|<absolute-size>|<length>",
        "font-stretch": "<font-stretch-absolute>",
        "font-style": "normal|italic|oblique <angle>?",
        "font-synthesis": "none|[weight||style||small-caps||position]",
        "font-synthesis-position": "auto|none",
        "font-synthesis-small-caps": "auto|none",
        "font-synthesis-style": "auto|none",
        "font-synthesis-weight": "auto|none",
        "font-variant": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>||stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )||[small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps]||<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero||<east-asian-variant-values>||<east-asian-width-values>||ruby]",
        "font-variant-alternates": "normal|[stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )]",
        "font-variant-caps": "normal|small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps",
        "font-variant-east-asian": "normal|[<east-asian-variant-values>||<east-asian-width-values>||ruby]",
        "font-variant-emoji": "normal|text|emoji|unicode",
        "font-variant-ligatures": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>]",
        "font-variant-numeric": "normal|[<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero]",
        "font-variant-position": "normal|sub|super",
        "font-weight": "<font-weight-absolute>|bolder|lighter",
        "forced-color-adjust": "auto|none|preserve-parent-color",
        "gap": "<'row-gap'> <'column-gap'>?",
        "grid": "<'grid-template'>|<'grid-template-rows'> / [auto-flow&&dense?] <'grid-auto-columns'>?|[auto-flow&&dense?] <'grid-auto-rows'>? / <'grid-template-columns'>",
        "grid-area": "<grid-line> [/ <grid-line>]{0,3}",
        "grid-auto-columns": "<track-size>+",
        "grid-auto-flow": "[row|column]||dense",
        "grid-auto-rows": "<track-size>+",
        "grid-column": "<grid-line> [/ <grid-line>]?",
        "grid-column-end": "<grid-line>",
        "grid-column-gap": "<length-percentage>",
        "grid-column-start": "<grid-line>",
        "grid-gap": "<'grid-row-gap'> <'grid-column-gap'>?",
        "grid-row": "<grid-line> [/ <grid-line>]?",
        "grid-row-end": "<grid-line>",
        "grid-row-gap": "<length-percentage>",
        "grid-row-start": "<grid-line>",
        "grid-template": "none|[<'grid-template-rows'> / <'grid-template-columns'>]|[<line-names>? <string> <track-size>? <line-names>?]+ [/ <explicit-track-list>]?",
        "grid-template-areas": "none|<string>+",
        "grid-template-columns": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
        "grid-template-rows": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
        "hanging-punctuation": "none|[first||[force-end|allow-end]||last]",
        "height": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|stretch|<-non-standard-size>",
        "hyphenate-character": "auto|<string>",
        "hyphenate-limit-chars": "[auto|<integer>]{1,3}",
        "hyphens": "none|manual|auto",
        "image-orientation": "from-image|<angle>|[<angle>? flip]",
        "image-rendering": "auto|crisp-edges|pixelated|optimizeSpeed|optimizeQuality|<-non-standard-image-rendering>",
        "image-resolution": "[from-image||<resolution>]&&snap?",
        "ime-mode": "auto|normal|active|inactive|disabled",
        "initial-letter": "normal|[<number> <integer>?]",
        "initial-letter-align": "[auto|alphabetic|hanging|ideographic]",
        "inline-size": "<'width'>",
        "input-security": "auto|none",
        "inset": "<'top'>{1,4}",
        "inset-block": "<'top'>{1,2}",
        "inset-block-end": "<'top'>",
        "inset-block-start": "<'top'>",
        "inset-inline": "<'top'>{1,2}",
        "inset-inline-end": "<'top'>",
        "inset-inline-start": "<'top'>",
        "interpolate-size": "numeric-only|allow-keywords",
        "isolation": "auto|isolate",
        "justify-content": "normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]",
        "justify-items": "normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]|legacy|legacy&&[left|right|center]",
        "justify-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]",
        "justify-tracks": "[normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]]#",
        "left": "<length>|<percentage>|auto",
        "letter-spacing": "normal|<length-percentage>",
        "line-break": "auto|loose|normal|strict|anywhere",
        "line-clamp": "none|<integer>",
        "line-height": "normal|<number>|<length>|<percentage>",
        "line-height-step": "<length>",
        "list-style": "<'list-style-type'>||<'list-style-position'>||<'list-style-image'>",
        "list-style-image": "<image>|none",
        "list-style-position": "inside|outside",
        "list-style-type": "<counter-style>|<string>|none",
        "margin": "[<length>|<percentage>|auto]{1,4}",
        "margin-block": "<'margin-left'>{1,2}",
        "margin-block-end": "<'margin-left'>",
        "margin-block-start": "<'margin-left'>",
        "margin-bottom": "<length>|<percentage>|auto",
        "margin-inline": "<'margin-left'>{1,2}",
        "margin-inline-end": "<'margin-left'>",
        "margin-inline-start": "<'margin-left'>",
        "margin-left": "<length>|<percentage>|auto",
        "margin-right": "<length>|<percentage>|auto",
        "margin-top": "<length>|<percentage>|auto",
        "margin-trim": "none|in-flow|all",
        "marker": "none|<url>",
        "marker-end": "none|<url>",
        "marker-mid": "none|<url>",
        "marker-start": "none|<url>",
        "mask": "<mask-layer>#",
        "mask-border": "<'mask-border-source'>||<'mask-border-slice'> [/ <'mask-border-width'>? [/ <'mask-border-outset'>]?]?||<'mask-border-repeat'>||<'mask-border-mode'>",
        "mask-border-mode": "luminance|alpha",
        "mask-border-outset": "[<length>|<number>]{1,4}",
        "mask-border-repeat": "[stretch|repeat|round|space]{1,2}",
        "mask-border-slice": "<number-percentage>{1,4} fill?",
        "mask-border-source": "none|<image>",
        "mask-border-width": "[<length-percentage>|<number>|auto]{1,4}",
        "mask-clip": "[<geometry-box>|no-clip]#",
        "mask-composite": "<compositing-operator>#",
        "mask-image": "<mask-reference>#",
        "mask-mode": "<masking-mode>#",
        "mask-origin": "<geometry-box>#",
        "mask-position": "<position>#",
        "mask-repeat": "<repeat-style>#",
        "mask-size": "<bg-size>#",
        "mask-type": "luminance|alpha",
        "masonry-auto-flow": "[pack|next]||[definite-first|ordered]",
        "math-depth": "auto-add|add( <integer> )|<integer>",
        "math-shift": "normal|compact",
        "math-style": "normal|compact",
        "max-block-size": "<'max-width'>",
        "max-height": "none|<length-percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|stretch|<-non-standard-size>",
        "max-inline-size": "<'max-width'>",
        "max-lines": "none|<integer>",
        "max-width": "none|<length-percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|stretch|<-non-standard-size>",
        "min-block-size": "<'min-width'>",
        "min-height": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|stretch|<-non-standard-size>",
        "min-inline-size": "<'min-width'>",
        "min-width": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|stretch|<-non-standard-size>",
        "mix-blend-mode": "<blend-mode>|plus-lighter",
        "object-fit": "fill|contain|cover|none|scale-down",
        "object-position": "<position>",
        "offset": "[<'offset-position'>? [<'offset-path'> [<'offset-distance'>||<'offset-rotate'>]?]?]! [/ <'offset-anchor'>]?",
        "offset-anchor": "auto|<position>",
        "offset-distance": "<length-percentage>",
        "offset-path": "none|<offset-path>||<coord-box>",
        "offset-position": "normal|auto|<position>",
        "offset-rotate": "[auto|reverse]||<angle>",
        "opacity": "<alpha-value>",
        "order": "<integer>",
        "orphans": "<integer>",
        "outline": "[<'outline-width'>||<'outline-style'>||<'outline-color'>]",
        "outline-color": "auto|<color>",
        "outline-offset": "<length>",
        "outline-style": "auto|<'border-style'>",
        "outline-width": "<line-width>",
        "overflow": "[visible|hidden|clip|scroll|auto]{1,2}|<-non-standard-overflow>",
        "overflow-anchor": "auto|none",
        "overflow-block": "visible|hidden|clip|scroll|auto",
        "overflow-clip-box": "padding-box|content-box",
        "overflow-clip-margin": "<visual-box>||<length [0,\u221E]>",
        "overflow-inline": "visible|hidden|clip|scroll|auto",
        "overflow-wrap": "normal|break-word|anywhere",
        "overflow-x": "visible|hidden|clip|scroll|auto",
        "overflow-y": "visible|hidden|clip|scroll|auto",
        "overlay": "none|auto",
        "overscroll-behavior": "[contain|none|auto]{1,2}",
        "overscroll-behavior-block": "contain|none|auto",
        "overscroll-behavior-inline": "contain|none|auto",
        "overscroll-behavior-x": "contain|none|auto",
        "overscroll-behavior-y": "contain|none|auto",
        "padding": "[<length>|<percentage>]{1,4}",
        "padding-block": "<'padding-left'>{1,2}",
        "padding-block-end": "<'padding-left'>",
        "padding-block-start": "<'padding-left'>",
        "padding-bottom": "<length>|<percentage>",
        "padding-inline": "<'padding-left'>{1,2}",
        "padding-inline-end": "<'padding-left'>",
        "padding-inline-start": "<'padding-left'>",
        "padding-left": "<length>|<percentage>",
        "padding-right": "<length>|<percentage>",
        "padding-top": "<length>|<percentage>",
        "page": "auto|<custom-ident>",
        "page-break-after": "auto|always|avoid|left|right|recto|verso",
        "page-break-before": "auto|always|avoid|left|right|recto|verso",
        "page-break-inside": "auto|avoid",
        "paint-order": "normal|[fill||stroke||markers]",
        "perspective": "none|<length>",
        "perspective-origin": "<position>",
        "place-content": "<'align-content'> <'justify-content'>?",
        "place-items": "<'align-items'> <'justify-items'>?",
        "place-self": "<'align-self'> <'justify-self'>?",
        "pointer-events": "auto|none|visiblePainted|visibleFill|visibleStroke|visible|painted|fill|stroke|all|inherit",
        "position": "static|relative|absolute|sticky|fixed|-webkit-sticky",
        "position-anchor": "auto|<anchor-name>",
        "position-area": "none|<position-area>",
        "position-try": "<'position-try-order'>? <'position-try-fallbacks'>",
        "position-try-fallbacks": "none|[[<dashed-ident>||<try-tactic>]|<'position-area'>]#",
        "position-try-order": "normal|<try-size>",
        "position-visibility": "always|[anchors-valid||anchors-visible||no-overflow]",
        "print-color-adjust": "economy|exact",
        "quotes": "none|auto|[<string> <string>]+",
        "r": "<length>|<percentage>",
        "resize": "none|both|horizontal|vertical|block|inline",
        "right": "<length>|<percentage>|auto",
        "rotate": "none|<angle>|[x|y|z|<number>{3}]&&<angle>",
        "row-gap": "normal|<length-percentage>",
        "ruby-align": "start|center|space-between|space-around",
        "ruby-merge": "separate|collapse|auto",
        "ruby-position": "[alternate||[over|under]]|inter-character",
        "rx": "<length>|<percentage>",
        "ry": "<length>|<percentage>",
        "scale": "none|[<number>|<percentage>]{1,3}",
        "scrollbar-color": "auto|<color>{2}",
        "scrollbar-gutter": "auto|stable&&both-edges?",
        "scrollbar-width": "auto|thin|none",
        "scroll-behavior": "auto|smooth",
        "scroll-margin": "<length>{1,4}",
        "scroll-margin-block": "<length>{1,2}",
        "scroll-margin-block-start": "<length>",
        "scroll-margin-block-end": "<length>",
        "scroll-margin-bottom": "<length>",
        "scroll-margin-inline": "<length>{1,2}",
        "scroll-margin-inline-start": "<length>",
        "scroll-margin-inline-end": "<length>",
        "scroll-margin-left": "<length>",
        "scroll-margin-right": "<length>",
        "scroll-margin-top": "<length>",
        "scroll-padding": "[auto|<length-percentage>]{1,4}",
        "scroll-padding-block": "[auto|<length-percentage>]{1,2}",
        "scroll-padding-block-start": "auto|<length-percentage>",
        "scroll-padding-block-end": "auto|<length-percentage>",
        "scroll-padding-bottom": "auto|<length-percentage>",
        "scroll-padding-inline": "[auto|<length-percentage>]{1,2}",
        "scroll-padding-inline-start": "auto|<length-percentage>",
        "scroll-padding-inline-end": "auto|<length-percentage>",
        "scroll-padding-left": "auto|<length-percentage>",
        "scroll-padding-right": "auto|<length-percentage>",
        "scroll-padding-top": "auto|<length-percentage>",
        "scroll-snap-align": "[none|start|end|center]{1,2}",
        "scroll-snap-coordinate": "none|<position>#",
        "scroll-snap-destination": "<position>",
        "scroll-snap-points-x": "none|repeat( <length-percentage> )",
        "scroll-snap-points-y": "none|repeat( <length-percentage> )",
        "scroll-snap-stop": "normal|always",
        "scroll-snap-type": "none|[x|y|block|inline|both] [mandatory|proximity]?",
        "scroll-snap-type-x": "none|mandatory|proximity",
        "scroll-snap-type-y": "none|mandatory|proximity",
        "scroll-timeline": "[<'scroll-timeline-name'>||<'scroll-timeline-axis'>]#",
        "scroll-timeline-axis": "[block|inline|x|y]#",
        "scroll-timeline-name": "[none|<dashed-ident>]#",
        "shape-image-threshold": "<alpha-value>",
        "shape-margin": "<length-percentage>",
        "shape-outside": "none|[<shape-box>||<basic-shape>]|<image>",
        "shape-rendering": "auto|optimizeSpeed|crispEdges|geometricPrecision",
        "stroke": "<paint>",
        "stroke-dasharray": "none|[<svg-length>+]#",
        "stroke-dashoffset": "<svg-length>",
        "stroke-linecap": "butt|round|square",
        "stroke-linejoin": "miter|round|bevel",
        "stroke-miterlimit": "<number-one-or-greater>",
        "stroke-opacity": "<'opacity'>",
        "stroke-width": "<svg-length>",
        "tab-size": "<integer>|<length>",
        "table-layout": "auto|fixed",
        "text-align": "start|end|left|right|center|justify|match-parent",
        "text-align-last": "auto|start|end|left|right|center|justify",
        "text-anchor": "start|middle|end",
        "text-combine-upright": "none|all|[digits <integer>?]",
        "text-decoration": "<'text-decoration-line'>||<'text-decoration-style'>||<'text-decoration-color'>||<'text-decoration-thickness'>",
        "text-decoration-color": "<color>",
        "text-decoration-line": "none|[underline||overline||line-through||blink]|spelling-error|grammar-error",
        "text-decoration-skip": "none|[objects||[spaces|[leading-spaces||trailing-spaces]]||edges||box-decoration]",
        "text-decoration-skip-ink": "auto|all|none",
        "text-decoration-style": "solid|double|dotted|dashed|wavy",
        "text-decoration-thickness": "auto|from-font|<length>|<percentage>",
        "text-emphasis": "<'text-emphasis-style'>||<'text-emphasis-color'>",
        "text-emphasis-color": "<color>",
        "text-emphasis-position": "auto|[over|under]&&[right|left]?",
        "text-emphasis-style": "none|[[filled|open]||[dot|circle|double-circle|triangle|sesame]]|<string>",
        "text-indent": "<length-percentage>&&hanging?&&each-line?",
        "text-justify": "auto|inter-character|inter-word|none",
        "text-orientation": "mixed|upright|sideways",
        "text-overflow": "[clip|ellipsis|<string>]{1,2}",
        "text-rendering": "auto|optimizeSpeed|optimizeLegibility|geometricPrecision",
        "text-shadow": "none|<shadow-t>#",
        "text-size-adjust": "none|auto|<percentage>",
        "text-spacing-trim": "space-all|normal|space-first|trim-start|trim-both|trim-all|auto",
        "text-transform": "none|capitalize|uppercase|lowercase|full-width|full-size-kana",
        "text-underline-offset": "auto|<length>|<percentage>",
        "text-underline-position": "auto|from-font|[under||[left|right]]",
        "text-wrap": "<'text-wrap-mode'>||<'text-wrap-style'>",
        "text-wrap-mode": "auto|wrap|nowrap",
        "text-wrap-style": "auto|balance|stable|pretty",
        "timeline-scope": "none|<dashed-ident>#",
        "top": "<length>|<percentage>|auto",
        "touch-action": "auto|none|[[pan-x|pan-left|pan-right]||[pan-y|pan-up|pan-down]||pinch-zoom]|manipulation",
        "transform": "none|<transform-list>",
        "transform-box": "content-box|border-box|fill-box|stroke-box|view-box",
        "transform-origin": "[<length-percentage>|left|center|right|top|bottom]|[[<length-percentage>|left|center|right]&&[<length-percentage>|top|center|bottom]] <length>?",
        "transform-style": "flat|preserve-3d",
        "transition": "<single-transition>#",
        "transition-behavior": "<transition-behavior-value>#",
        "transition-delay": "<time>#",
        "transition-duration": "<time>#",
        "transition-property": "none|<single-transition-property>#",
        "transition-timing-function": "<easing-function>#",
        "translate": "none|<length-percentage> [<length-percentage> <length>?]?",
        "unicode-bidi": "normal|embed|isolate|bidi-override|isolate-override|plaintext|-moz-isolate|-moz-isolate-override|-moz-plaintext|-webkit-isolate|-webkit-isolate-override|-webkit-plaintext",
        "user-select": "auto|text|none|contain|all",
        "vector-effect": "none|non-scaling-stroke|non-scaling-size|non-rotation|fixed-position",
        "vertical-align": "baseline|sub|super|text-top|text-bottom|middle|top|bottom|<percentage>|<length>",
        "view-timeline": "[<'view-timeline-name'> <'view-timeline-axis'>?]#",
        "view-timeline-axis": "[block|inline|x|y]#",
        "view-timeline-inset": "[[auto|<length-percentage>]{1,2}]#",
        "view-timeline-name": "none|<dashed-ident>#",
        "view-transition-name": "none|<custom-ident>",
        "visibility": "visible|hidden|collapse",
        "white-space": "normal|pre|nowrap|pre-wrap|pre-line|break-spaces|[<'white-space-collapse'>||<'text-wrap'>||<'white-space-trim'>]",
        "white-space-collapse": "collapse|discard|preserve|preserve-breaks|preserve-spaces|break-spaces",
        "widows": "<integer>",
        "width": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|stretch|<-non-standard-size>",
        "will-change": "auto|<animateable-feature>#",
        "word-break": "normal|break-all|keep-all|break-word|auto-phrase",
        "word-spacing": "normal|<length>",
        "word-wrap": "normal|break-word",
        "writing-mode": "horizontal-tb|vertical-rl|vertical-lr|sideways-rl|sideways-lr|<svg-writing-mode>",
        "x": "<length>|<percentage>",
        "y": "<length>|<percentage>",
        "z-index": "auto|<integer>",
        "zoom": "normal|reset|<number>|<percentage>",
        "-moz-background-clip": "padding|border",
        "-moz-border-radius-bottomleft": "<'border-bottom-left-radius'>",
        "-moz-border-radius-bottomright": "<'border-bottom-right-radius'>",
        "-moz-border-radius-topleft": "<'border-top-left-radius'>",
        "-moz-border-radius-topright": "<'border-bottom-right-radius'>",
        "-moz-control-character-visibility": "visible|hidden",
        "-moz-osx-font-smoothing": "auto|grayscale",
        "-moz-user-select": "none|text|all|-moz-none",
        "-ms-flex-align": "start|end|center|baseline|stretch",
        "-ms-flex-item-align": "auto|start|end|center|baseline|stretch",
        "-ms-flex-line-pack": "start|end|center|justify|distribute|stretch",
        "-ms-flex-negative": "<'flex-shrink'>",
        "-ms-flex-pack": "start|end|center|justify|distribute",
        "-ms-flex-order": "<integer>",
        "-ms-flex-positive": "<'flex-grow'>",
        "-ms-flex-preferred-size": "<'flex-basis'>",
        "-ms-interpolation-mode": "nearest-neighbor|bicubic",
        "-ms-grid-column-align": "start|end|center|stretch",
        "-ms-grid-row-align": "start|end|center|stretch",
        "-ms-hyphenate-limit-last": "none|always|column|page|spread",
        "-webkit-background-clip": "[<box>|border|padding|content|text]#",
        "-webkit-column-break-after": "always|auto|avoid",
        "-webkit-column-break-before": "always|auto|avoid",
        "-webkit-column-break-inside": "always|auto|avoid",
        "-webkit-font-smoothing": "auto|none|antialiased|subpixel-antialiased",
        "-webkit-mask-box-image": "[<url>|<gradient>|none] [<length-percentage>{4} <-webkit-mask-box-repeat>{2}]?",
        "-webkit-print-color-adjust": "economy|exact",
        "-webkit-text-security": "none|circle|disc|square",
        "-webkit-user-drag": "none|element|auto",
        "-webkit-user-select": "auto|none|text|all",
        "alignment-baseline": "auto|baseline|before-edge|text-before-edge|middle|central|after-edge|text-after-edge|ideographic|alphabetic|hanging|mathematical",
        "baseline-shift": "baseline|sub|super|<svg-length>",
        "behavior": "<url>+",
        "cue": "<'cue-before'> <'cue-after'>?",
        "cue-after": "<url> <decibel>?|none",
        "cue-before": "<url> <decibel>?|none",
        "glyph-orientation-horizontal": "<angle>",
        "glyph-orientation-vertical": "<angle>",
        "kerning": "auto|<svg-length>",
        "pause": "<'pause-before'> <'pause-after'>?",
        "pause-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
        "pause-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
        "rest": "<'rest-before'> <'rest-after'>?",
        "rest-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
        "rest-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
        "src": "[<url> [format( <string># )]?|local( <family-name> )]#",
        "speak": "auto|never|always",
        "speak-as": "normal|spell-out||digits||[literal-punctuation|no-punctuation]",
        "unicode-range": "<urange>#",
        "voice-balance": "<number>|left|center|right|leftwards|rightwards",
        "voice-duration": "auto|<time>",
        "voice-family": "[[<family-name>|<generic-voice>] ,]* [<family-name>|<generic-voice>]|preserve",
        "voice-pitch": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
        "voice-range": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
        "voice-rate": "[normal|x-slow|slow|medium|fast|x-fast]||<percentage>",
        "voice-stress": "normal|strong|moderate|none|reduced",
        "voice-volume": "silent|[[x-soft|soft|medium|loud|x-loud]||<decibel>]",
        "white-space-trim": "none|discard-before||discard-after||discard-inner"
    },
    "atrules": {
        "charset": {
            "prelude": "<string>",
            "descriptors": null
        },
        "counter-style": {
            "prelude": "<counter-style-name>",
            "descriptors": {
                "additive-symbols": "[<integer>&&<symbol>]#",
                "fallback": "<counter-style-name>",
                "negative": "<symbol> <symbol>?",
                "pad": "<integer>&&<symbol>",
                "prefix": "<symbol>",
                "range": "[[<integer>|infinite]{2}]#|auto",
                "speak-as": "auto|bullets|numbers|words|spell-out|<counter-style-name>",
                "suffix": "<symbol>",
                "symbols": "<symbol>+",
                "system": "cyclic|numeric|alphabetic|symbolic|additive|[fixed <integer>?]|[extends <counter-style-name>]"
            }
        },
        "document": {
            "prelude": "[<url>|url-prefix( <string> )|domain( <string> )|media-document( <string> )|regexp( <string> )]#",
            "descriptors": null
        },
        "font-palette-values": {
            "prelude": "<dashed-ident>",
            "descriptors": {
                "base-palette": "light|dark|<integer [0,\u221E]>",
                "font-family": "<family-name>#",
                "override-colors": "[<integer [0,\u221E]> <absolute-color-base>]#"
            }
        },
        "font-face": {
            "prelude": null,
            "descriptors": {
                "ascent-override": "normal|<percentage>",
                "descent-override": "normal|<percentage>",
                "font-display": "[auto|block|swap|fallback|optional]",
                "font-family": "<family-name>",
                "font-feature-settings": "normal|<feature-tag-value>#",
                "font-variation-settings": "normal|[<string> <number>]#",
                "font-stretch": "<font-stretch-absolute>{1,2}",
                "font-style": "normal|italic|oblique <angle>{0,2}",
                "font-weight": "<font-weight-absolute>{1,2}",
                "line-gap-override": "normal|<percentage>",
                "size-adjust": "<percentage>",
                "src": "[<url> [format( <string># )]?|local( <family-name> )]#",
                "unicode-range": "<urange>#"
            }
        },
        "font-feature-values": {
            "prelude": "<family-name>#",
            "descriptors": null
        },
        "import": {
            "prelude": "[<string>|<url>] [layer|layer( <layer-name> )]? [supports( [<supports-condition>|<declaration>] )]? <media-query-list>?",
            "descriptors": null
        },
        "keyframes": {
            "prelude": "<keyframes-name>",
            "descriptors": null
        },
        "layer": {
            "prelude": "[<layer-name>#|<layer-name>?]",
            "descriptors": null
        },
        "media": {
            "prelude": "<media-query-list>",
            "descriptors": null
        },
        "namespace": {
            "prelude": "<namespace-prefix>? [<string>|<url>]",
            "descriptors": null
        },
        "page": {
            "prelude": "<page-selector-list>",
            "descriptors": {
                "bleed": "auto|<length>",
                "marks": "none|[crop||cross]",
                "page-orientation": "upright|rotate-left|rotate-right",
                "size": "<length>{1,2}|auto|[<page-size>||[portrait|landscape]]"
            }
        },
        "position-try": {
            "prelude": "<dashed-ident>",
            "descriptors": {
                "top": "<'top'>",
                "left": "<'left'>",
                "bottom": "<'bottom'>",
                "right": "<'right'>",
                "inset-block-start": "<'inset-block-start'>",
                "inset-block-end": "<'inset-block-end'>",
                "inset-inline-start": "<'inset-inline-start'>",
                "inset-inline-end": "<'inset-inline-end'>",
                "inset-block": "<'inset-block'>",
                "inset-inline": "<'inset-inline'>",
                "inset": "<'inset'>",
                "margin-top": "<'margin-top'>",
                "margin-left": "<'margin-left'>",
                "margin-bottom": "<'margin-bottom'>",
                "margin-right": "<'margin-right'>",
                "margin-block-start": "<'margin-block-start'>",
                "margin-block-end": "<'margin-block-end'>",
                "margin-inline-start": "<'margin-inline-start'>",
                "margin-inline-end": "<'margin-inline-end'>",
                "margin": "<'margin'>",
                "margin-block": "<'margin-block'>",
                "margin-inline": "<'margin-inline'>",
                "width": "<'width'>",
                "height": "<'height'>",
                "min-width": "<'min-width'>",
                "min-height": "<'min-height'>",
                "max-width": "<'max-width'>",
                "max-height": "<'max-height'>",
                "block-size": "<'block-size'>",
                "inline-size": "<'inline-size'>",
                "min-block-size": "<'min-block-size'>",
                "min-inline-size": "<'min-inline-size'>",
                "max-block-size": "<'max-block-size'>",
                "max-inline-size": "<'max-inline-size'>",
                "align-self": "<'align-self'>|anchor-center",
                "justify-self": "<'justify-self'>|anchor-center"
            }
        },
        "property": {
            "prelude": "<custom-property-name>",
            "descriptors": {
                "syntax": "<string>",
                "inherits": "true|false",
                "initial-value": "<declaration-value>?"
            }
        },
        "scope": {
            "prelude": "[( <scope-start> )]? [to ( <scope-end> )]?",
            "descriptors": null
        },
        "starting-style": {
            "prelude": null,
            "descriptors": null
        },
        "supports": {
            "prelude": "<supports-condition>",
            "descriptors": null
        },
        "container": {
            "prelude": "[<container-name>]? <container-condition>",
            "descriptors": null
        },
        "nest": {
            "prelude": "<complex-selector-list>",
            "descriptors": null
        }
    }
};


var $fb10b100396c91c1$exports = {};

$parcel$export($fb10b100396c91c1$exports, "AnPlusB", function () { return $a4232d2c86667a8b$exports; });
$parcel$export($fb10b100396c91c1$exports, "Atrule", function () { return $edab30309e484102$exports; });
$parcel$export($fb10b100396c91c1$exports, "AtrulePrelude", function () { return $e0ba95883c90e8a1$exports; });
$parcel$export($fb10b100396c91c1$exports, "AttributeSelector", function () { return $8e0620cbf0fd5e8c$exports; });
$parcel$export($fb10b100396c91c1$exports, "Block", function () { return $ec16e9e8a8f0b297$exports; });
$parcel$export($fb10b100396c91c1$exports, "Brackets", function () { return $bc48d9f27c93572e$exports; });
$parcel$export($fb10b100396c91c1$exports, "CDC", function () { return $1c915a8248d24753$exports; });
$parcel$export($fb10b100396c91c1$exports, "CDO", function () { return $6148bde22ddba24d$exports; });
$parcel$export($fb10b100396c91c1$exports, "ClassSelector", function () { return $62046956e340f898$exports; });
$parcel$export($fb10b100396c91c1$exports, "Combinator", function () { return $678072efdd10fcdb$exports; });
$parcel$export($fb10b100396c91c1$exports, "Comment", function () { return $ed5fe54a4ebb649b$exports; });
$parcel$export($fb10b100396c91c1$exports, "Condition", function () { return $bdefa610a79ae05e$exports; });
$parcel$export($fb10b100396c91c1$exports, "Declaration", function () { return $b7a4464e404c9f7f$exports; });
$parcel$export($fb10b100396c91c1$exports, "DeclarationList", function () { return $42622accbf1b1b6b$exports; });
$parcel$export($fb10b100396c91c1$exports, "Dimension", function () { return $7f06ae44bdd41130$exports; });
$parcel$export($fb10b100396c91c1$exports, "Feature", function () { return $fc4d70523a88da9c$exports; });
$parcel$export($fb10b100396c91c1$exports, "FeatureFunction", function () { return $c5e215dd02b47b54$exports; });
$parcel$export($fb10b100396c91c1$exports, "FeatureRange", function () { return $afb64130c5df0f05$exports; });
$parcel$export($fb10b100396c91c1$exports, "Function", function () { return $9bf79ec41884755c$exports; });
$parcel$export($fb10b100396c91c1$exports, "GeneralEnclosed", function () { return $a68195bce17edba7$exports; });
$parcel$export($fb10b100396c91c1$exports, "Hash", function () { return $b35684aa816106b7$exports; });
$parcel$export($fb10b100396c91c1$exports, "Identifier", function () { return $11a87938930caa52$exports; });
$parcel$export($fb10b100396c91c1$exports, "IdSelector", function () { return $2f8d9fb2da484051$exports; });
$parcel$export($fb10b100396c91c1$exports, "Layer", function () { return $c85db2efff85fc02$exports; });
$parcel$export($fb10b100396c91c1$exports, "LayerList", function () { return $25655749f16bffa8$exports; });
$parcel$export($fb10b100396c91c1$exports, "MediaQuery", function () { return $94b05fd6c096774a$exports; });
$parcel$export($fb10b100396c91c1$exports, "MediaQueryList", function () { return $d970f304e8bc71ba$exports; });
$parcel$export($fb10b100396c91c1$exports, "NestingSelector", function () { return $fbed52d6f2df3274$exports; });
$parcel$export($fb10b100396c91c1$exports, "Nth", function () { return $352c778ae94e759f$exports; });
$parcel$export($fb10b100396c91c1$exports, "Number", function () { return $407e1ad9ced420db$exports; });
$parcel$export($fb10b100396c91c1$exports, "Operator", function () { return $04369877262756a7$exports; });
$parcel$export($fb10b100396c91c1$exports, "Parentheses", function () { return $c886fa5abc8d9d5f$exports; });
$parcel$export($fb10b100396c91c1$exports, "Percentage", function () { return $c99e2ae0e225fd3f$exports; });
$parcel$export($fb10b100396c91c1$exports, "PseudoClassSelector", function () { return $81ba3db47496bc3c$exports; });
$parcel$export($fb10b100396c91c1$exports, "PseudoElementSelector", function () { return $56f21670f2a6843f$exports; });
$parcel$export($fb10b100396c91c1$exports, "Ratio", function () { return $60a58b987a514501$exports; });
$parcel$export($fb10b100396c91c1$exports, "Raw", function () { return $54eb253192531e90$exports; });
$parcel$export($fb10b100396c91c1$exports, "Rule", function () { return $f80a1e59c59983e7$exports; });
$parcel$export($fb10b100396c91c1$exports, "Scope", function () { return $5de80a7b15a6bf26$exports; });
$parcel$export($fb10b100396c91c1$exports, "Selector", function () { return $9ccfeb24f689dd94$exports; });
$parcel$export($fb10b100396c91c1$exports, "SelectorList", function () { return $e09b6562adad0054$exports; });
$parcel$export($fb10b100396c91c1$exports, "String", function () { return $17d46c820b4ef3bc$exports; });
$parcel$export($fb10b100396c91c1$exports, "StyleSheet", function () { return $090f301751be1b14$exports; });
$parcel$export($fb10b100396c91c1$exports, "SupportsDeclaration", function () { return $8cafbe4e6566c6b0$exports; });
$parcel$export($fb10b100396c91c1$exports, "TypeSelector", function () { return $06e99d3dcf0b0856$exports; });
$parcel$export($fb10b100396c91c1$exports, "UnicodeRange", function () { return $04ee15830f72d29f$exports; });
$parcel$export($fb10b100396c91c1$exports, "Url", function () { return $c3203ce20adbeef5$exports; });
$parcel$export($fb10b100396c91c1$exports, "Value", function () { return $883cb73761c43b47$exports; });
$parcel$export($fb10b100396c91c1$exports, "WhiteSpace", function () { return $5da1a48d15cdd86d$exports; });
var $a4232d2c86667a8b$exports = {};

$parcel$export($a4232d2c86667a8b$exports, "name", function () { return $a4232d2c86667a8b$export$a8ff84c12d48cfa6; });
$parcel$export($a4232d2c86667a8b$exports, "structure", function () { return $a4232d2c86667a8b$export$46a2a563c28afca0; });
$parcel$export($a4232d2c86667a8b$exports, "parse", function () { return $a4232d2c86667a8b$export$98e6a39c04603d36; });
$parcel$export($a4232d2c86667a8b$exports, "generate", function () { return $a4232d2c86667a8b$export$80d376111cc09ad7; });

const $a4232d2c86667a8b$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $a4232d2c86667a8b$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $a4232d2c86667a8b$var$N = 0x006E; // U+006E LATIN SMALL LETTER N (n)
const $a4232d2c86667a8b$var$DISALLOW_SIGN = true;
const $a4232d2c86667a8b$var$ALLOW_SIGN = false;
function $a4232d2c86667a8b$var$checkInteger(offset, disallowSign) {
    let pos = this.tokenStart + offset;
    const code = this.charCodeAt(pos);
    if (code === $a4232d2c86667a8b$var$PLUSSIGN || code === $a4232d2c86667a8b$var$HYPHENMINUS) {
        if (disallowSign) this.error('Number sign is not allowed');
        pos++;
    }
    for(; pos < this.tokenEnd; pos++)if (!(0, $fb47edd266a7fc33$export$727d9dbc4fbb948f)(this.charCodeAt(pos))) this.error('Integer is expected', pos);
}
function $a4232d2c86667a8b$var$checkTokenIsInteger(disallowSign) {
    return $a4232d2c86667a8b$var$checkInteger.call(this, 0, disallowSign);
}
function $a4232d2c86667a8b$var$expectCharCode(offset, code) {
    if (!this.cmpChar(this.tokenStart + offset, code)) {
        let msg = '';
        switch(code){
            case $a4232d2c86667a8b$var$N:
                msg = 'N is expected';
                break;
            case $a4232d2c86667a8b$var$HYPHENMINUS:
                msg = 'HyphenMinus is expected';
                break;
        }
        this.error(msg, this.tokenStart + offset);
    }
}
// ... <signed-integer>
// ... ['+' | '-'] <signless-integer>
function $a4232d2c86667a8b$var$consumeB() {
    let offset = 0;
    let sign = 0;
    let type = this.tokenType;
    while(type === (0, $cb01acaf2e18d562$export$fb98946286ab4c97) || type === (0, $cb01acaf2e18d562$export$4d299b491347818a))type = this.lookupType(++offset);
    if (type !== (0, $cb01acaf2e18d562$export$fffa67e515d04022)) {
        if (this.isDelim($a4232d2c86667a8b$var$PLUSSIGN, offset) || this.isDelim($a4232d2c86667a8b$var$HYPHENMINUS, offset)) {
            sign = this.isDelim($a4232d2c86667a8b$var$PLUSSIGN, offset) ? $a4232d2c86667a8b$var$PLUSSIGN : $a4232d2c86667a8b$var$HYPHENMINUS;
            do type = this.lookupType(++offset);
            while (type === (0, $cb01acaf2e18d562$export$fb98946286ab4c97) || type === (0, $cb01acaf2e18d562$export$4d299b491347818a));
            if (type !== (0, $cb01acaf2e18d562$export$fffa67e515d04022)) {
                this.skip(offset);
                $a4232d2c86667a8b$var$checkTokenIsInteger.call(this, $a4232d2c86667a8b$var$DISALLOW_SIGN);
            }
        } else return null;
    }
    if (offset > 0) this.skip(offset);
    if (sign === 0) {
        type = this.charCodeAt(this.tokenStart);
        if (type !== $a4232d2c86667a8b$var$PLUSSIGN && type !== $a4232d2c86667a8b$var$HYPHENMINUS) this.error('Number sign is expected');
    }
    $a4232d2c86667a8b$var$checkTokenIsInteger.call(this, sign !== 0);
    return sign === $a4232d2c86667a8b$var$HYPHENMINUS ? '-' + this.consume((0, $cb01acaf2e18d562$export$fffa67e515d04022)) : this.consume((0, $cb01acaf2e18d562$export$fffa67e515d04022));
}
const $a4232d2c86667a8b$export$a8ff84c12d48cfa6 = 'AnPlusB';
const $a4232d2c86667a8b$export$46a2a563c28afca0 = {
    a: [
        String,
        null
    ],
    b: [
        String,
        null
    ]
};
function $a4232d2c86667a8b$export$98e6a39c04603d36() {
    /* eslint-disable brace-style*/ const start = this.tokenStart;
    let a = null;
    let b = null;
    // <integer>
    if (this.tokenType === (0, $cb01acaf2e18d562$export$fffa67e515d04022)) {
        $a4232d2c86667a8b$var$checkTokenIsInteger.call(this, $a4232d2c86667a8b$var$ALLOW_SIGN);
        b = this.consume((0, $cb01acaf2e18d562$export$fffa67e515d04022));
    } else if (this.tokenType === (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f) && this.cmpChar(this.tokenStart, $a4232d2c86667a8b$var$HYPHENMINUS)) {
        a = '-1';
        $a4232d2c86667a8b$var$expectCharCode.call(this, 1, $a4232d2c86667a8b$var$N);
        switch(this.tokenEnd - this.tokenStart){
            // -n
            // -n <signed-integer>
            // -n ['+' | '-'] <signless-integer>
            case 2:
                this.next();
                b = $a4232d2c86667a8b$var$consumeB.call(this);
                break;
            // -n- <signless-integer>
            case 3:
                $a4232d2c86667a8b$var$expectCharCode.call(this, 2, $a4232d2c86667a8b$var$HYPHENMINUS);
                this.next();
                this.skipSC();
                $a4232d2c86667a8b$var$checkTokenIsInteger.call(this, $a4232d2c86667a8b$var$DISALLOW_SIGN);
                b = '-' + this.consume((0, $cb01acaf2e18d562$export$fffa67e515d04022));
                break;
            // <dashndashdigit-ident>
            default:
                $a4232d2c86667a8b$var$expectCharCode.call(this, 2, $a4232d2c86667a8b$var$HYPHENMINUS);
                $a4232d2c86667a8b$var$checkInteger.call(this, 3, $a4232d2c86667a8b$var$DISALLOW_SIGN);
                this.next();
                b = this.substrToCursor(start + 2);
        }
    } else if (this.tokenType === (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f) || this.isDelim($a4232d2c86667a8b$var$PLUSSIGN) && this.lookupType(1) === (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)) {
        let sign = 0;
        a = '1';
        // just ignore a plus
        if (this.isDelim($a4232d2c86667a8b$var$PLUSSIGN)) {
            sign = 1;
            this.next();
        }
        $a4232d2c86667a8b$var$expectCharCode.call(this, 0, $a4232d2c86667a8b$var$N);
        switch(this.tokenEnd - this.tokenStart){
            // '+'? n
            // '+'? n <signed-integer>
            // '+'? n ['+' | '-'] <signless-integer>
            case 1:
                this.next();
                b = $a4232d2c86667a8b$var$consumeB.call(this);
                break;
            // '+'? n- <signless-integer>
            case 2:
                $a4232d2c86667a8b$var$expectCharCode.call(this, 1, $a4232d2c86667a8b$var$HYPHENMINUS);
                this.next();
                this.skipSC();
                $a4232d2c86667a8b$var$checkTokenIsInteger.call(this, $a4232d2c86667a8b$var$DISALLOW_SIGN);
                b = '-' + this.consume((0, $cb01acaf2e18d562$export$fffa67e515d04022));
                break;
            // '+'? <ndashdigit-ident>
            default:
                $a4232d2c86667a8b$var$expectCharCode.call(this, 1, $a4232d2c86667a8b$var$HYPHENMINUS);
                $a4232d2c86667a8b$var$checkInteger.call(this, 2, $a4232d2c86667a8b$var$DISALLOW_SIGN);
                this.next();
                b = this.substrToCursor(start + sign + 1);
        }
    } else if (this.tokenType === (0, $cb01acaf2e18d562$export$c940ece961bc43c6)) {
        const code = this.charCodeAt(this.tokenStart);
        const sign = code === $a4232d2c86667a8b$var$PLUSSIGN || code === $a4232d2c86667a8b$var$HYPHENMINUS;
        let i = this.tokenStart + sign;
        for(; i < this.tokenEnd; i++){
            if (!(0, $fb47edd266a7fc33$export$727d9dbc4fbb948f)(this.charCodeAt(i))) break;
        }
        if (i === this.tokenStart + sign) this.error('Integer is expected', this.tokenStart + sign);
        $a4232d2c86667a8b$var$expectCharCode.call(this, i - this.tokenStart, $a4232d2c86667a8b$var$N);
        a = this.substring(start, i);
        // <n-dimension>
        // <n-dimension> <signed-integer>
        // <n-dimension> ['+' | '-'] <signless-integer>
        if (i + 1 === this.tokenEnd) {
            this.next();
            b = $a4232d2c86667a8b$var$consumeB.call(this);
        } else {
            $a4232d2c86667a8b$var$expectCharCode.call(this, i - this.tokenStart + 1, $a4232d2c86667a8b$var$HYPHENMINUS);
            // <ndash-dimension> <signless-integer>
            if (i + 2 === this.tokenEnd) {
                this.next();
                this.skipSC();
                $a4232d2c86667a8b$var$checkTokenIsInteger.call(this, $a4232d2c86667a8b$var$DISALLOW_SIGN);
                b = '-' + this.consume((0, $cb01acaf2e18d562$export$fffa67e515d04022));
            } else {
                $a4232d2c86667a8b$var$checkInteger.call(this, i - this.tokenStart + 2, $a4232d2c86667a8b$var$DISALLOW_SIGN);
                this.next();
                b = this.substrToCursor(i + 1);
            }
        }
    } else this.error();
    if (a !== null && a.charCodeAt(0) === $a4232d2c86667a8b$var$PLUSSIGN) a = a.substr(1);
    if (b !== null && b.charCodeAt(0) === $a4232d2c86667a8b$var$PLUSSIGN) b = b.substr(1);
    return {
        type: 'AnPlusB',
        loc: this.getLocation(start, this.tokenStart),
        a: a,
        b: b
    };
}
function $a4232d2c86667a8b$export$80d376111cc09ad7(node) {
    if (node.a) {
        const a = node.a === '+1' && 'n' || node.a === '1' && 'n' || node.a === '-1' && '-n' || node.a + 'n';
        if (node.b) {
            const b = node.b[0] === '-' || node.b[0] === '+' ? node.b : '+' + node.b;
            this.tokenize(a + b);
        } else this.tokenize(a);
    } else this.tokenize(node.b);
}


var $edab30309e484102$exports = {};

$parcel$export($edab30309e484102$exports, "name", function () { return $edab30309e484102$export$a8ff84c12d48cfa6; });
$parcel$export($edab30309e484102$exports, "walkContext", function () { return $edab30309e484102$export$f7e0bb689fefb8c2; });
$parcel$export($edab30309e484102$exports, "structure", function () { return $edab30309e484102$export$46a2a563c28afca0; });
$parcel$export($edab30309e484102$exports, "parse", function () { return $edab30309e484102$export$98e6a39c04603d36; });
$parcel$export($edab30309e484102$exports, "generate", function () { return $edab30309e484102$export$80d376111cc09ad7; });

function $edab30309e484102$var$consumeRaw() {
    return this.Raw(this.consumeUntilLeftCurlyBracketOrSemicolon, true);
}
function $edab30309e484102$var$isDeclarationBlockAtrule() {
    for(let offset = 1, type; type = this.lookupType(offset); offset++){
        if (type === (0, $cb01acaf2e18d562$export$186d8b1f99e2bfec)) return true;
        if (type === (0, $cb01acaf2e18d562$export$ccdce7304ac66390) || type === (0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac)) return false;
    }
    return false;
}
const $edab30309e484102$export$a8ff84c12d48cfa6 = 'Atrule';
const $edab30309e484102$export$f7e0bb689fefb8c2 = 'atrule';
const $edab30309e484102$export$46a2a563c28afca0 = {
    name: String,
    prelude: [
        'AtrulePrelude',
        'Raw',
        null
    ],
    block: [
        'Block',
        null
    ]
};
function $edab30309e484102$export$98e6a39c04603d36(isDeclaration = false) {
    const start = this.tokenStart;
    let name;
    let nameLowerCase;
    let prelude = null;
    let block = null;
    this.eat((0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac));
    name = this.substrToCursor(start + 1);
    nameLowerCase = name.toLowerCase();
    this.skipSC();
    // parse prelude
    if (this.eof === false && this.tokenType !== (0, $cb01acaf2e18d562$export$ccdce7304ac66390) && this.tokenType !== (0, $cb01acaf2e18d562$export$bedd8b9b04d9dbd)) {
        if (this.parseAtrulePrelude) prelude = this.parseWithFallback(this.AtrulePrelude.bind(this, name, isDeclaration), $edab30309e484102$var$consumeRaw);
        else prelude = $edab30309e484102$var$consumeRaw.call(this, this.tokenIndex);
        this.skipSC();
    }
    switch(this.tokenType){
        case 0, $cb01acaf2e18d562$export$bedd8b9b04d9dbd:
            this.next();
            break;
        case 0, $cb01acaf2e18d562$export$ccdce7304ac66390:
            if (hasOwnProperty.call(this.atrule, nameLowerCase) && typeof this.atrule[nameLowerCase].block === 'function') block = this.atrule[nameLowerCase].block.call(this, isDeclaration);
            else // TODO: should consume block content as Raw?
            block = this.Block($edab30309e484102$var$isDeclarationBlockAtrule.call(this));
            break;
    }
    return {
        type: 'Atrule',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        prelude: prelude,
        block: block
    };
}
function $edab30309e484102$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac), '@' + node.name);
    if (node.prelude !== null) this.node(node.prelude);
    if (node.block) this.node(node.block);
    else this.token((0, $cb01acaf2e18d562$export$bedd8b9b04d9dbd), ';');
}


var $e0ba95883c90e8a1$exports = {};

$parcel$export($e0ba95883c90e8a1$exports, "name", function () { return $e0ba95883c90e8a1$export$a8ff84c12d48cfa6; });
$parcel$export($e0ba95883c90e8a1$exports, "walkContext", function () { return $e0ba95883c90e8a1$export$f7e0bb689fefb8c2; });
$parcel$export($e0ba95883c90e8a1$exports, "structure", function () { return $e0ba95883c90e8a1$export$46a2a563c28afca0; });
$parcel$export($e0ba95883c90e8a1$exports, "parse", function () { return $e0ba95883c90e8a1$export$98e6a39c04603d36; });
$parcel$export($e0ba95883c90e8a1$exports, "generate", function () { return $e0ba95883c90e8a1$export$80d376111cc09ad7; });

const $e0ba95883c90e8a1$export$a8ff84c12d48cfa6 = 'AtrulePrelude';
const $e0ba95883c90e8a1$export$f7e0bb689fefb8c2 = 'atrulePrelude';
const $e0ba95883c90e8a1$export$46a2a563c28afca0 = {
    children: [
        []
    ]
};
function $e0ba95883c90e8a1$export$98e6a39c04603d36(name) {
    let children = null;
    if (name !== null) name = name.toLowerCase();
    this.skipSC();
    if (hasOwnProperty.call(this.atrule, name) && typeof this.atrule[name].prelude === 'function') // custom consumer
    children = this.atrule[name].prelude.call(this);
    else // default consumer
    children = this.readSequence(this.scope.AtrulePrelude);
    this.skipSC();
    if (this.eof !== true && this.tokenType !== (0, $cb01acaf2e18d562$export$ccdce7304ac66390) && this.tokenType !== (0, $cb01acaf2e18d562$export$bedd8b9b04d9dbd)) this.error('Semicolon or block is expected');
    return {
        type: 'AtrulePrelude',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $e0ba95883c90e8a1$export$80d376111cc09ad7(node) {
    this.children(node);
}


var $8e0620cbf0fd5e8c$exports = {};

$parcel$export($8e0620cbf0fd5e8c$exports, "name", function () { return $8e0620cbf0fd5e8c$export$a8ff84c12d48cfa6; });
$parcel$export($8e0620cbf0fd5e8c$exports, "structure", function () { return $8e0620cbf0fd5e8c$export$46a2a563c28afca0; });
$parcel$export($8e0620cbf0fd5e8c$exports, "parse", function () { return $8e0620cbf0fd5e8c$export$98e6a39c04603d36; });
$parcel$export($8e0620cbf0fd5e8c$exports, "generate", function () { return $8e0620cbf0fd5e8c$export$80d376111cc09ad7; });

const $8e0620cbf0fd5e8c$var$DOLLARSIGN = 0x0024; // U+0024 DOLLAR SIGN ($)
const $8e0620cbf0fd5e8c$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $8e0620cbf0fd5e8c$var$EQUALSSIGN = 0x003D; // U+003D EQUALS SIGN (=)
const $8e0620cbf0fd5e8c$var$CIRCUMFLEXACCENT = 0x005E; // U+005E (^)
const $8e0620cbf0fd5e8c$var$VERTICALLINE = 0x007C; // U+007C VERTICAL LINE (|)
const $8e0620cbf0fd5e8c$var$TILDE = 0x007E; // U+007E TILDE (~)
function $8e0620cbf0fd5e8c$var$getAttributeName() {
    if (this.eof) this.error('Unexpected end of input');
    const start = this.tokenStart;
    let expectIdent = false;
    if (this.isDelim($8e0620cbf0fd5e8c$var$ASTERISK)) {
        expectIdent = true;
        this.next();
    } else if (!this.isDelim($8e0620cbf0fd5e8c$var$VERTICALLINE)) this.eat((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f));
    if (this.isDelim($8e0620cbf0fd5e8c$var$VERTICALLINE)) {
        if (this.charCodeAt(this.tokenStart + 1) !== $8e0620cbf0fd5e8c$var$EQUALSSIGN) {
            this.next();
            this.eat((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f));
        } else if (expectIdent) this.error('Identifier is expected', this.tokenEnd);
    } else if (expectIdent) this.error('Vertical line is expected');
    return {
        type: 'Identifier',
        loc: this.getLocation(start, this.tokenStart),
        name: this.substrToCursor(start)
    };
}
function $8e0620cbf0fd5e8c$var$getOperator() {
    const start = this.tokenStart;
    const code = this.charCodeAt(start);
    if (code !== $8e0620cbf0fd5e8c$var$EQUALSSIGN && // =
    code !== $8e0620cbf0fd5e8c$var$TILDE && // ~=
    code !== $8e0620cbf0fd5e8c$var$CIRCUMFLEXACCENT && // ^=
    code !== $8e0620cbf0fd5e8c$var$DOLLARSIGN && // $=
    code !== $8e0620cbf0fd5e8c$var$ASTERISK && // *=
    code !== $8e0620cbf0fd5e8c$var$VERTICALLINE // |=
    ) this.error('Attribute selector (=, ~=, ^=, $=, *=, |=) is expected');
    this.next();
    if (code !== $8e0620cbf0fd5e8c$var$EQUALSSIGN) {
        if (!this.isDelim($8e0620cbf0fd5e8c$var$EQUALSSIGN)) this.error('Equal sign is expected');
        this.next();
    }
    return this.substrToCursor(start);
}
const $8e0620cbf0fd5e8c$export$a8ff84c12d48cfa6 = 'AttributeSelector';
const $8e0620cbf0fd5e8c$export$46a2a563c28afca0 = {
    name: 'Identifier',
    matcher: [
        String,
        null
    ],
    value: [
        'String',
        'Identifier',
        null
    ],
    flags: [
        String,
        null
    ]
};
function $8e0620cbf0fd5e8c$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    let name;
    let matcher = null;
    let value = null;
    let flags = null;
    this.eat((0, $cb01acaf2e18d562$export$cd363bb53c2bb));
    this.skipSC();
    name = $8e0620cbf0fd5e8c$var$getAttributeName.call(this);
    this.skipSC();
    if (this.tokenType !== (0, $cb01acaf2e18d562$export$72f933344f701f30)) {
        // avoid case `[name i]`
        if (this.tokenType !== (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)) {
            matcher = $8e0620cbf0fd5e8c$var$getOperator.call(this);
            this.skipSC();
            value = this.tokenType === (0, $cb01acaf2e18d562$export$89b8e0fa65f6a914) ? this.String() : this.Identifier();
            this.skipSC();
        }
        // attribute flags
        if (this.tokenType === (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)) {
            flags = this.consume((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f));
            this.skipSC();
        }
    }
    this.eat((0, $cb01acaf2e18d562$export$72f933344f701f30));
    return {
        type: 'AttributeSelector',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        matcher: matcher,
        value: value,
        flags: flags
    };
}
function $8e0620cbf0fd5e8c$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$a918ca49ff4337a3), '[');
    this.node(node.name);
    if (node.matcher !== null) {
        this.tokenize(node.matcher);
        this.node(node.value);
    }
    if (node.flags !== null) this.token((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f), node.flags);
    this.token((0, $cb01acaf2e18d562$export$a918ca49ff4337a3), ']');
}


var $ec16e9e8a8f0b297$exports = {};

$parcel$export($ec16e9e8a8f0b297$exports, "name", function () { return $ec16e9e8a8f0b297$export$a8ff84c12d48cfa6; });
$parcel$export($ec16e9e8a8f0b297$exports, "walkContext", function () { return $ec16e9e8a8f0b297$export$f7e0bb689fefb8c2; });
$parcel$export($ec16e9e8a8f0b297$exports, "structure", function () { return $ec16e9e8a8f0b297$export$46a2a563c28afca0; });
$parcel$export($ec16e9e8a8f0b297$exports, "parse", function () { return $ec16e9e8a8f0b297$export$98e6a39c04603d36; });
$parcel$export($ec16e9e8a8f0b297$exports, "generate", function () { return $ec16e9e8a8f0b297$export$80d376111cc09ad7; });

const $ec16e9e8a8f0b297$var$AMPERSAND = 0x0026; // U+0026 AMPERSAND (&)
function $ec16e9e8a8f0b297$var$consumeRaw() {
    return this.Raw(null, true);
}
function $ec16e9e8a8f0b297$var$consumeRule() {
    return this.parseWithFallback(this.Rule, $ec16e9e8a8f0b297$var$consumeRaw);
}
function $ec16e9e8a8f0b297$var$consumeRawDeclaration() {
    return this.Raw(this.consumeUntilSemicolonIncluded, true);
}
function $ec16e9e8a8f0b297$var$consumeDeclaration() {
    if (this.tokenType === (0, $cb01acaf2e18d562$export$bedd8b9b04d9dbd)) return $ec16e9e8a8f0b297$var$consumeRawDeclaration.call(this, this.tokenIndex);
    const node = this.parseWithFallback(this.Declaration, $ec16e9e8a8f0b297$var$consumeRawDeclaration);
    if (this.tokenType === (0, $cb01acaf2e18d562$export$bedd8b9b04d9dbd)) this.next();
    return node;
}
const $ec16e9e8a8f0b297$export$a8ff84c12d48cfa6 = 'Block';
const $ec16e9e8a8f0b297$export$f7e0bb689fefb8c2 = 'block';
const $ec16e9e8a8f0b297$export$46a2a563c28afca0 = {
    children: [
        [
            'Atrule',
            'Rule',
            'Declaration'
        ]
    ]
};
function $ec16e9e8a8f0b297$export$98e6a39c04603d36(isStyleBlock) {
    const consumer = isStyleBlock ? $ec16e9e8a8f0b297$var$consumeDeclaration : $ec16e9e8a8f0b297$var$consumeRule;
    const start = this.tokenStart;
    let children = this.createList();
    this.eat((0, $cb01acaf2e18d562$export$ccdce7304ac66390));
    scan: while(!this.eof)switch(this.tokenType){
        case 0, $cb01acaf2e18d562$export$186d8b1f99e2bfec:
            break scan;
        case 0, $cb01acaf2e18d562$export$fb98946286ab4c97:
        case 0, $cb01acaf2e18d562$export$4d299b491347818a:
            this.next();
            break;
        case 0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac:
            children.push(this.parseWithFallback(this.Atrule.bind(this, isStyleBlock), $ec16e9e8a8f0b297$var$consumeRaw));
            break;
        default:
            if (isStyleBlock && this.isDelim($ec16e9e8a8f0b297$var$AMPERSAND)) children.push($ec16e9e8a8f0b297$var$consumeRule.call(this));
            else children.push(consumer.call(this));
    }
    if (!this.eof) this.eat((0, $cb01acaf2e18d562$export$186d8b1f99e2bfec));
    return {
        type: 'Block',
        loc: this.getLocation(start, this.tokenStart),
        children: children
    };
}
function $ec16e9e8a8f0b297$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$ccdce7304ac66390), '{');
    this.children(node, (prev)=>{
        if (prev.type === 'Declaration') this.token((0, $cb01acaf2e18d562$export$bedd8b9b04d9dbd), ';');
    });
    this.token((0, $cb01acaf2e18d562$export$186d8b1f99e2bfec), '}');
}


var $bc48d9f27c93572e$exports = {};

$parcel$export($bc48d9f27c93572e$exports, "name", function () { return $bc48d9f27c93572e$export$a8ff84c12d48cfa6; });
$parcel$export($bc48d9f27c93572e$exports, "structure", function () { return $bc48d9f27c93572e$export$46a2a563c28afca0; });
$parcel$export($bc48d9f27c93572e$exports, "parse", function () { return $bc48d9f27c93572e$export$98e6a39c04603d36; });
$parcel$export($bc48d9f27c93572e$exports, "generate", function () { return $bc48d9f27c93572e$export$80d376111cc09ad7; });

const $bc48d9f27c93572e$export$a8ff84c12d48cfa6 = 'Brackets';
const $bc48d9f27c93572e$export$46a2a563c28afca0 = {
    children: [
        []
    ]
};
function $bc48d9f27c93572e$export$98e6a39c04603d36(readSequence, recognizer) {
    const start = this.tokenStart;
    let children = null;
    this.eat((0, $cb01acaf2e18d562$export$cd363bb53c2bb));
    children = readSequence.call(this, recognizer);
    if (!this.eof) this.eat((0, $cb01acaf2e18d562$export$72f933344f701f30));
    return {
        type: 'Brackets',
        loc: this.getLocation(start, this.tokenStart),
        children: children
    };
}
function $bc48d9f27c93572e$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$a918ca49ff4337a3), '[');
    this.children(node);
    this.token((0, $cb01acaf2e18d562$export$a918ca49ff4337a3), ']');
}


var $1c915a8248d24753$exports = {};

$parcel$export($1c915a8248d24753$exports, "name", function () { return $1c915a8248d24753$export$a8ff84c12d48cfa6; });
$parcel$export($1c915a8248d24753$exports, "structure", function () { return $1c915a8248d24753$export$46a2a563c28afca0; });
$parcel$export($1c915a8248d24753$exports, "parse", function () { return $1c915a8248d24753$export$98e6a39c04603d36; });
$parcel$export($1c915a8248d24753$exports, "generate", function () { return $1c915a8248d24753$export$80d376111cc09ad7; });

const $1c915a8248d24753$export$a8ff84c12d48cfa6 = 'CDC';
const $1c915a8248d24753$export$46a2a563c28afca0 = [];
function $1c915a8248d24753$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    this.eat((0, $cb01acaf2e18d562$export$b0b2bd2d1777c179)); // -->
    return {
        type: 'CDC',
        loc: this.getLocation(start, this.tokenStart)
    };
}
function $1c915a8248d24753$export$80d376111cc09ad7() {
    this.token((0, $cb01acaf2e18d562$export$b0b2bd2d1777c179), '-->');
}


var $6148bde22ddba24d$exports = {};

$parcel$export($6148bde22ddba24d$exports, "name", function () { return $6148bde22ddba24d$export$a8ff84c12d48cfa6; });
$parcel$export($6148bde22ddba24d$exports, "structure", function () { return $6148bde22ddba24d$export$46a2a563c28afca0; });
$parcel$export($6148bde22ddba24d$exports, "parse", function () { return $6148bde22ddba24d$export$98e6a39c04603d36; });
$parcel$export($6148bde22ddba24d$exports, "generate", function () { return $6148bde22ddba24d$export$80d376111cc09ad7; });

const $6148bde22ddba24d$export$a8ff84c12d48cfa6 = 'CDO';
const $6148bde22ddba24d$export$46a2a563c28afca0 = [];
function $6148bde22ddba24d$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    this.eat((0, $cb01acaf2e18d562$export$521ef26a3002003b)); // <!--
    return {
        type: 'CDO',
        loc: this.getLocation(start, this.tokenStart)
    };
}
function $6148bde22ddba24d$export$80d376111cc09ad7() {
    this.token((0, $cb01acaf2e18d562$export$521ef26a3002003b), '<!--');
}


var $62046956e340f898$exports = {};

$parcel$export($62046956e340f898$exports, "name", function () { return $62046956e340f898$export$a8ff84c12d48cfa6; });
$parcel$export($62046956e340f898$exports, "structure", function () { return $62046956e340f898$export$46a2a563c28afca0; });
$parcel$export($62046956e340f898$exports, "parse", function () { return $62046956e340f898$export$98e6a39c04603d36; });
$parcel$export($62046956e340f898$exports, "generate", function () { return $62046956e340f898$export$80d376111cc09ad7; });

const $62046956e340f898$var$FULLSTOP = 0x002E; // U+002E FULL STOP (.)
const $62046956e340f898$export$a8ff84c12d48cfa6 = 'ClassSelector';
const $62046956e340f898$export$46a2a563c28afca0 = {
    name: String
};
function $62046956e340f898$export$98e6a39c04603d36() {
    this.eatDelim($62046956e340f898$var$FULLSTOP);
    return {
        type: 'ClassSelector',
        loc: this.getLocation(this.tokenStart - 1, this.tokenEnd),
        name: this.consume((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f))
    };
}
function $62046956e340f898$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$a918ca49ff4337a3), '.');
    this.token((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f), node.name);
}


var $678072efdd10fcdb$exports = {};

$parcel$export($678072efdd10fcdb$exports, "name", function () { return $678072efdd10fcdb$export$a8ff84c12d48cfa6; });
$parcel$export($678072efdd10fcdb$exports, "structure", function () { return $678072efdd10fcdb$export$46a2a563c28afca0; });
$parcel$export($678072efdd10fcdb$exports, "parse", function () { return $678072efdd10fcdb$export$98e6a39c04603d36; });
$parcel$export($678072efdd10fcdb$exports, "generate", function () { return $678072efdd10fcdb$export$80d376111cc09ad7; });

const $678072efdd10fcdb$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $678072efdd10fcdb$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $678072efdd10fcdb$var$GREATERTHANSIGN = 0x003E; // U+003E GREATER-THAN SIGN (>)
const $678072efdd10fcdb$var$TILDE = 0x007E; // U+007E TILDE (~)
const $678072efdd10fcdb$export$a8ff84c12d48cfa6 = 'Combinator';
const $678072efdd10fcdb$export$46a2a563c28afca0 = {
    name: String
};
function $678072efdd10fcdb$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    let name;
    switch(this.tokenType){
        case 0, $cb01acaf2e18d562$export$fb98946286ab4c97:
            name = ' ';
            break;
        case 0, $cb01acaf2e18d562$export$a918ca49ff4337a3:
            switch(this.charCodeAt(this.tokenStart)){
                case $678072efdd10fcdb$var$GREATERTHANSIGN:
                case $678072efdd10fcdb$var$PLUSSIGN:
                case $678072efdd10fcdb$var$TILDE:
                    this.next();
                    break;
                case $678072efdd10fcdb$var$SOLIDUS:
                    this.next();
                    this.eatIdent('deep');
                    this.eatDelim($678072efdd10fcdb$var$SOLIDUS);
                    break;
                default:
                    this.error('Combinator is expected');
            }
            name = this.substrToCursor(start);
            break;
    }
    return {
        type: 'Combinator',
        loc: this.getLocation(start, this.tokenStart),
        name: name
    };
}
function $678072efdd10fcdb$export$80d376111cc09ad7(node) {
    this.tokenize(node.name);
}


var $ed5fe54a4ebb649b$exports = {};

$parcel$export($ed5fe54a4ebb649b$exports, "name", function () { return $ed5fe54a4ebb649b$export$a8ff84c12d48cfa6; });
$parcel$export($ed5fe54a4ebb649b$exports, "structure", function () { return $ed5fe54a4ebb649b$export$46a2a563c28afca0; });
$parcel$export($ed5fe54a4ebb649b$exports, "parse", function () { return $ed5fe54a4ebb649b$export$98e6a39c04603d36; });
$parcel$export($ed5fe54a4ebb649b$exports, "generate", function () { return $ed5fe54a4ebb649b$export$80d376111cc09ad7; });

const $ed5fe54a4ebb649b$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $ed5fe54a4ebb649b$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $ed5fe54a4ebb649b$export$a8ff84c12d48cfa6 = 'Comment';
const $ed5fe54a4ebb649b$export$46a2a563c28afca0 = {
    value: String
};
function $ed5fe54a4ebb649b$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    let end = this.tokenEnd;
    this.eat((0, $cb01acaf2e18d562$export$4d299b491347818a));
    if (end - start + 2 >= 2 && this.charCodeAt(end - 2) === $ed5fe54a4ebb649b$var$ASTERISK && this.charCodeAt(end - 1) === $ed5fe54a4ebb649b$var$SOLIDUS) end -= 2;
    return {
        type: 'Comment',
        loc: this.getLocation(start, this.tokenStart),
        value: this.substring(start + 2, end)
    };
}
function $ed5fe54a4ebb649b$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$4d299b491347818a), '/*' + node.value + '*/');
}


var $bdefa610a79ae05e$exports = {};

$parcel$export($bdefa610a79ae05e$exports, "name", function () { return $bdefa610a79ae05e$export$a8ff84c12d48cfa6; });
$parcel$export($bdefa610a79ae05e$exports, "structure", function () { return $bdefa610a79ae05e$export$46a2a563c28afca0; });
$parcel$export($bdefa610a79ae05e$exports, "parse", function () { return $bdefa610a79ae05e$export$98e6a39c04603d36; });
$parcel$export($bdefa610a79ae05e$exports, "generate", function () { return $bdefa610a79ae05e$export$80d376111cc09ad7; });

const $bdefa610a79ae05e$var$likelyFeatureToken = new Set([
    (0, $cb01acaf2e18d562$export$e20ebb298016f6),
    (0, $cb01acaf2e18d562$export$773d33972c6279ed),
    (0, $cb01acaf2e18d562$export$c1a09112320b1603)
]);
const $bdefa610a79ae05e$export$a8ff84c12d48cfa6 = 'Condition';
const $bdefa610a79ae05e$export$46a2a563c28afca0 = {
    kind: String,
    children: [
        [
            'Identifier',
            'Feature',
            'FeatureFunction',
            'FeatureRange',
            'SupportsDeclaration'
        ]
    ]
};
function $bdefa610a79ae05e$var$featureOrRange(kind) {
    if (this.lookupTypeNonSC(1) === (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f) && $bdefa610a79ae05e$var$likelyFeatureToken.has(this.lookupTypeNonSC(2))) return this.Feature(kind);
    return this.FeatureRange(kind);
}
const $bdefa610a79ae05e$var$parentheses = {
    media: $bdefa610a79ae05e$var$featureOrRange,
    container: $bdefa610a79ae05e$var$featureOrRange,
    supports () {
        return this.SupportsDeclaration();
    }
};
function $bdefa610a79ae05e$export$98e6a39c04603d36(kind = 'media') {
    const children = this.createList();
    scan: while(!this.eof)switch(this.tokenType){
        case 0, $cb01acaf2e18d562$export$4d299b491347818a:
        case 0, $cb01acaf2e18d562$export$fb98946286ab4c97:
            this.next();
            continue;
        case 0, $cb01acaf2e18d562$export$331e9b6bdecaac5f:
            children.push(this.Identifier());
            break;
        case 0, $cb01acaf2e18d562$export$b5a25f132cb53de6:
            {
                let term = this.parseWithFallback(()=>$bdefa610a79ae05e$var$parentheses[kind].call(this, kind), ()=>null);
                if (!term) term = this.parseWithFallback(()=>{
                    this.eat((0, $cb01acaf2e18d562$export$b5a25f132cb53de6));
                    const res = this.Condition(kind);
                    this.eat((0, $cb01acaf2e18d562$export$773d33972c6279ed));
                    return res;
                }, ()=>{
                    return this.GeneralEnclosed(kind);
                });
                children.push(term);
                break;
            }
        case 0, $cb01acaf2e18d562$export$f3890eeaf6851387:
            {
                let term = this.parseWithFallback(()=>this.FeatureFunction(kind), ()=>null);
                if (!term) term = this.GeneralEnclosed(kind);
                children.push(term);
                break;
            }
        default:
            break scan;
    }
    if (children.isEmpty) this.error('Condition is expected');
    return {
        type: 'Condition',
        loc: this.getLocationFromList(children),
        kind: kind,
        children: children
    };
}
function $bdefa610a79ae05e$export$80d376111cc09ad7(node) {
    node.children.forEach((child)=>{
        if (child.type === 'Condition') {
            this.token((0, $cb01acaf2e18d562$export$b5a25f132cb53de6), '(');
            this.node(child);
            this.token((0, $cb01acaf2e18d562$export$773d33972c6279ed), ')');
        } else this.node(child);
    });
}


var $b7a4464e404c9f7f$exports = {};

$parcel$export($b7a4464e404c9f7f$exports, "name", function () { return $b7a4464e404c9f7f$export$a8ff84c12d48cfa6; });
$parcel$export($b7a4464e404c9f7f$exports, "walkContext", function () { return $b7a4464e404c9f7f$export$f7e0bb689fefb8c2; });
$parcel$export($b7a4464e404c9f7f$exports, "structure", function () { return $b7a4464e404c9f7f$export$46a2a563c28afca0; });
$parcel$export($b7a4464e404c9f7f$exports, "parse", function () { return $b7a4464e404c9f7f$export$98e6a39c04603d36; });
$parcel$export($b7a4464e404c9f7f$exports, "generate", function () { return $b7a4464e404c9f7f$export$80d376111cc09ad7; });


const $b7a4464e404c9f7f$var$EXCLAMATIONMARK = 0x0021; // U+0021 EXCLAMATION MARK (!)
const $b7a4464e404c9f7f$var$NUMBERSIGN = 0x0023; // U+0023 NUMBER SIGN (#)
const $b7a4464e404c9f7f$var$DOLLARSIGN = 0x0024; // U+0024 DOLLAR SIGN ($)
const $b7a4464e404c9f7f$var$AMPERSAND = 0x0026; // U+0026 AMPERSAND (&)
const $b7a4464e404c9f7f$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $b7a4464e404c9f7f$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $b7a4464e404c9f7f$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
function $b7a4464e404c9f7f$var$consumeValueRaw() {
    return this.Raw(this.consumeUntilExclamationMarkOrSemicolon, true);
}
function $b7a4464e404c9f7f$var$consumeCustomPropertyRaw() {
    return this.Raw(this.consumeUntilExclamationMarkOrSemicolon, false);
}
function $b7a4464e404c9f7f$var$consumeValue() {
    const startValueToken = this.tokenIndex;
    const value = this.Value();
    if (value.type !== 'Raw' && this.eof === false && this.tokenType !== (0, $cb01acaf2e18d562$export$bedd8b9b04d9dbd) && this.isDelim($b7a4464e404c9f7f$var$EXCLAMATIONMARK) === false && this.isBalanceEdge(startValueToken) === false) this.error();
    return value;
}
const $b7a4464e404c9f7f$export$a8ff84c12d48cfa6 = 'Declaration';
const $b7a4464e404c9f7f$export$f7e0bb689fefb8c2 = 'declaration';
const $b7a4464e404c9f7f$export$46a2a563c28afca0 = {
    important: [
        Boolean,
        String
    ],
    property: String,
    value: [
        'Value',
        'Raw'
    ]
};
function $b7a4464e404c9f7f$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    const startToken = this.tokenIndex;
    const property = $b7a4464e404c9f7f$var$readProperty.call(this);
    const customProperty = (0, $27cf59322dfdd6cf$export$15cf667f7f91c461)(property);
    const parseValue = customProperty ? this.parseCustomProperty : this.parseValue;
    const consumeRaw = customProperty ? $b7a4464e404c9f7f$var$consumeCustomPropertyRaw : $b7a4464e404c9f7f$var$consumeValueRaw;
    let important = false;
    let value;
    this.skipSC();
    this.eat((0, $cb01acaf2e18d562$export$e20ebb298016f6));
    const valueStart = this.tokenIndex;
    if (!customProperty) this.skipSC();
    if (parseValue) value = this.parseWithFallback($b7a4464e404c9f7f$var$consumeValue, consumeRaw);
    else value = consumeRaw.call(this, this.tokenIndex);
    if (customProperty && value.type === 'Value' && value.children.isEmpty) {
        for(let offset = valueStart - this.tokenIndex; offset <= 0; offset++)if (this.lookupType(offset) === (0, $cb01acaf2e18d562$export$fb98946286ab4c97)) {
            value.children.appendData({
                type: 'WhiteSpace',
                loc: null,
                value: ' '
            });
            break;
        }
    }
    if (this.isDelim($b7a4464e404c9f7f$var$EXCLAMATIONMARK)) {
        important = $b7a4464e404c9f7f$var$getImportant.call(this);
        this.skipSC();
    }
    // Do not include semicolon to range per spec
    // https://drafts.csswg.org/css-syntax/#declaration-diagram
    if (this.eof === false && this.tokenType !== (0, $cb01acaf2e18d562$export$bedd8b9b04d9dbd) && this.isBalanceEdge(startToken) === false) this.error();
    return {
        type: 'Declaration',
        loc: this.getLocation(start, this.tokenStart),
        important: important,
        property: property,
        value: value
    };
}
function $b7a4464e404c9f7f$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f), node.property);
    this.token((0, $cb01acaf2e18d562$export$e20ebb298016f6), ':');
    this.node(node.value);
    if (node.important) {
        this.token((0, $cb01acaf2e18d562$export$a918ca49ff4337a3), '!');
        this.token((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f), node.important === true ? 'important' : node.important);
    }
}
function $b7a4464e404c9f7f$var$readProperty() {
    const start = this.tokenStart;
    // hacks
    if (this.tokenType === (0, $cb01acaf2e18d562$export$a918ca49ff4337a3)) switch(this.charCodeAt(this.tokenStart)){
        case $b7a4464e404c9f7f$var$ASTERISK:
        case $b7a4464e404c9f7f$var$DOLLARSIGN:
        case $b7a4464e404c9f7f$var$PLUSSIGN:
        case $b7a4464e404c9f7f$var$NUMBERSIGN:
        case $b7a4464e404c9f7f$var$AMPERSAND:
            this.next();
            break;
        // TODO: not sure we should support this hack
        case $b7a4464e404c9f7f$var$SOLIDUS:
            this.next();
            if (this.isDelim($b7a4464e404c9f7f$var$SOLIDUS)) this.next();
            break;
    }
    if (this.tokenType === (0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd)) this.eat((0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd));
    else this.eat((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f));
    return this.substrToCursor(start);
}
// ! ws* important
function $b7a4464e404c9f7f$var$getImportant() {
    this.eat((0, $cb01acaf2e18d562$export$a918ca49ff4337a3));
    this.skipSC();
    const important = this.consume((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f));
    // store original value in case it differ from `important`
    // for better original source restoring and hacks like `!ie` support
    return important === 'important' ? true : important;
}


var $42622accbf1b1b6b$exports = {};

$parcel$export($42622accbf1b1b6b$exports, "name", function () { return $42622accbf1b1b6b$export$a8ff84c12d48cfa6; });
$parcel$export($42622accbf1b1b6b$exports, "structure", function () { return $42622accbf1b1b6b$export$46a2a563c28afca0; });
$parcel$export($42622accbf1b1b6b$exports, "parse", function () { return $42622accbf1b1b6b$export$98e6a39c04603d36; });
$parcel$export($42622accbf1b1b6b$exports, "generate", function () { return $42622accbf1b1b6b$export$80d376111cc09ad7; });

const $42622accbf1b1b6b$var$AMPERSAND = 0x0026; // U+0026 AMPERSAND (&)
function $42622accbf1b1b6b$var$consumeRaw() {
    return this.Raw(this.consumeUntilSemicolonIncluded, true);
}
const $42622accbf1b1b6b$export$a8ff84c12d48cfa6 = 'DeclarationList';
const $42622accbf1b1b6b$export$46a2a563c28afca0 = {
    children: [
        [
            'Declaration',
            'Atrule',
            'Rule'
        ]
    ]
};
function $42622accbf1b1b6b$export$98e6a39c04603d36() {
    const children = this.createList();
    scan: while(!this.eof)switch(this.tokenType){
        case 0, $cb01acaf2e18d562$export$fb98946286ab4c97:
        case 0, $cb01acaf2e18d562$export$4d299b491347818a:
        case 0, $cb01acaf2e18d562$export$bedd8b9b04d9dbd:
            this.next();
            break;
        case 0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac:
            children.push(this.parseWithFallback(this.Atrule.bind(this, true), $42622accbf1b1b6b$var$consumeRaw));
            break;
        default:
            if (this.isDelim($42622accbf1b1b6b$var$AMPERSAND)) children.push(this.parseWithFallback(this.Rule, $42622accbf1b1b6b$var$consumeRaw));
            else children.push(this.parseWithFallback(this.Declaration, $42622accbf1b1b6b$var$consumeRaw));
    }
    return {
        type: 'DeclarationList',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $42622accbf1b1b6b$export$80d376111cc09ad7(node) {
    this.children(node, (prev)=>{
        if (prev.type === 'Declaration') this.token((0, $cb01acaf2e18d562$export$bedd8b9b04d9dbd), ';');
    });
}


var $7f06ae44bdd41130$exports = {};

$parcel$export($7f06ae44bdd41130$exports, "name", function () { return $7f06ae44bdd41130$export$a8ff84c12d48cfa6; });
$parcel$export($7f06ae44bdd41130$exports, "structure", function () { return $7f06ae44bdd41130$export$46a2a563c28afca0; });
$parcel$export($7f06ae44bdd41130$exports, "parse", function () { return $7f06ae44bdd41130$export$98e6a39c04603d36; });
$parcel$export($7f06ae44bdd41130$exports, "generate", function () { return $7f06ae44bdd41130$export$80d376111cc09ad7; });

const $7f06ae44bdd41130$export$a8ff84c12d48cfa6 = 'Dimension';
const $7f06ae44bdd41130$export$46a2a563c28afca0 = {
    value: String,
    unit: String
};
function $7f06ae44bdd41130$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    const value = this.consumeNumber((0, $cb01acaf2e18d562$export$c940ece961bc43c6));
    return {
        type: 'Dimension',
        loc: this.getLocation(start, this.tokenStart),
        value: value,
        unit: this.substring(start + value.length, this.tokenStart)
    };
}
function $7f06ae44bdd41130$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$c940ece961bc43c6), node.value + node.unit);
}


var $fc4d70523a88da9c$exports = {};

$parcel$export($fc4d70523a88da9c$exports, "name", function () { return $fc4d70523a88da9c$export$a8ff84c12d48cfa6; });
$parcel$export($fc4d70523a88da9c$exports, "structure", function () { return $fc4d70523a88da9c$export$46a2a563c28afca0; });
$parcel$export($fc4d70523a88da9c$exports, "parse", function () { return $fc4d70523a88da9c$export$98e6a39c04603d36; });
$parcel$export($fc4d70523a88da9c$exports, "generate", function () { return $fc4d70523a88da9c$export$80d376111cc09ad7; });

const $fc4d70523a88da9c$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $fc4d70523a88da9c$export$a8ff84c12d48cfa6 = 'Feature';
const $fc4d70523a88da9c$export$46a2a563c28afca0 = {
    kind: String,
    name: String,
    value: [
        'Identifier',
        'Number',
        'Dimension',
        'Ratio',
        'Function',
        null
    ]
};
function $fc4d70523a88da9c$export$98e6a39c04603d36(kind) {
    const start = this.tokenStart;
    let name;
    let value = null;
    this.eat((0, $cb01acaf2e18d562$export$b5a25f132cb53de6));
    this.skipSC();
    name = this.consume((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f));
    this.skipSC();
    if (this.tokenType !== (0, $cb01acaf2e18d562$export$773d33972c6279ed)) {
        this.eat((0, $cb01acaf2e18d562$export$e20ebb298016f6));
        this.skipSC();
        switch(this.tokenType){
            case 0, $cb01acaf2e18d562$export$fffa67e515d04022:
                if (this.lookupNonWSType(1) === (0, $cb01acaf2e18d562$export$a918ca49ff4337a3)) value = this.Ratio();
                else value = this.Number();
                break;
            case 0, $cb01acaf2e18d562$export$c940ece961bc43c6:
                value = this.Dimension();
                break;
            case 0, $cb01acaf2e18d562$export$331e9b6bdecaac5f:
                value = this.Identifier();
                break;
            case 0, $cb01acaf2e18d562$export$f3890eeaf6851387:
                value = this.parseWithFallback(()=>{
                    const res = this.Function(this.readSequence, this.scope.Value);
                    this.skipSC();
                    if (this.isDelim($fc4d70523a88da9c$var$SOLIDUS)) this.error();
                    return res;
                }, ()=>{
                    return this.Ratio();
                });
                break;
            default:
                this.error('Number, dimension, ratio or identifier is expected');
        }
        this.skipSC();
    }
    if (!this.eof) this.eat((0, $cb01acaf2e18d562$export$773d33972c6279ed));
    return {
        type: 'Feature',
        loc: this.getLocation(start, this.tokenStart),
        kind: kind,
        name: name,
        value: value
    };
}
function $fc4d70523a88da9c$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$b5a25f132cb53de6), '(');
    this.token((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f), node.name);
    if (node.value !== null) {
        this.token((0, $cb01acaf2e18d562$export$e20ebb298016f6), ':');
        this.node(node.value);
    }
    this.token((0, $cb01acaf2e18d562$export$773d33972c6279ed), ')');
}


var $c5e215dd02b47b54$exports = {};

$parcel$export($c5e215dd02b47b54$exports, "name", function () { return $c5e215dd02b47b54$export$a8ff84c12d48cfa6; });
$parcel$export($c5e215dd02b47b54$exports, "structure", function () { return $c5e215dd02b47b54$export$46a2a563c28afca0; });
$parcel$export($c5e215dd02b47b54$exports, "parse", function () { return $c5e215dd02b47b54$export$98e6a39c04603d36; });
$parcel$export($c5e215dd02b47b54$exports, "generate", function () { return $c5e215dd02b47b54$export$80d376111cc09ad7; });

const $c5e215dd02b47b54$export$a8ff84c12d48cfa6 = 'FeatureFunction';
const $c5e215dd02b47b54$export$46a2a563c28afca0 = {
    kind: String,
    feature: String,
    value: [
        'Declaration',
        'Selector'
    ]
};
function $c5e215dd02b47b54$var$getFeatureParser(kind, name) {
    const featuresOfKind = this.features[kind] || {};
    const parser = featuresOfKind[name];
    if (typeof parser !== 'function') this.error(`Unknown feature ${name}()`);
    return parser;
}
function $c5e215dd02b47b54$export$98e6a39c04603d36(kind = 'unknown') {
    const start = this.tokenStart;
    const functionName = this.consumeFunctionName();
    const valueParser = $c5e215dd02b47b54$var$getFeatureParser.call(this, kind, functionName.toLowerCase());
    this.skipSC();
    const value = this.parseWithFallback(()=>{
        const startValueToken = this.tokenIndex;
        const value = valueParser.call(this);
        if (this.eof === false && this.isBalanceEdge(startValueToken) === false) this.error();
        return value;
    }, ()=>this.Raw(null, false));
    if (!this.eof) this.eat((0, $cb01acaf2e18d562$export$773d33972c6279ed));
    return {
        type: 'FeatureFunction',
        loc: this.getLocation(start, this.tokenStart),
        kind: kind,
        feature: functionName,
        value: value
    };
}
function $c5e215dd02b47b54$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$f3890eeaf6851387), node.feature + '(');
    this.node(node.value);
    this.token((0, $cb01acaf2e18d562$export$773d33972c6279ed), ')');
}


var $afb64130c5df0f05$exports = {};

$parcel$export($afb64130c5df0f05$exports, "name", function () { return $afb64130c5df0f05$export$a8ff84c12d48cfa6; });
$parcel$export($afb64130c5df0f05$exports, "structure", function () { return $afb64130c5df0f05$export$46a2a563c28afca0; });
$parcel$export($afb64130c5df0f05$exports, "parse", function () { return $afb64130c5df0f05$export$98e6a39c04603d36; });
$parcel$export($afb64130c5df0f05$exports, "generate", function () { return $afb64130c5df0f05$export$80d376111cc09ad7; });

const $afb64130c5df0f05$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $afb64130c5df0f05$var$LESSTHANSIGN = 0x003C; // U+003C LESS-THAN SIGN (<)
const $afb64130c5df0f05$var$EQUALSSIGN = 0x003D; // U+003D EQUALS SIGN (=)
const $afb64130c5df0f05$var$GREATERTHANSIGN = 0x003E; // U+003E GREATER-THAN SIGN (>)
const $afb64130c5df0f05$export$a8ff84c12d48cfa6 = 'FeatureRange';
const $afb64130c5df0f05$export$46a2a563c28afca0 = {
    kind: String,
    left: [
        'Identifier',
        'Number',
        'Dimension',
        'Ratio',
        'Function'
    ],
    leftComparison: String,
    middle: [
        'Identifier',
        'Number',
        'Dimension',
        'Ratio',
        'Function'
    ],
    rightComparison: [
        String,
        null
    ],
    right: [
        'Identifier',
        'Number',
        'Dimension',
        'Ratio',
        'Function',
        null
    ]
};
function $afb64130c5df0f05$var$readTerm() {
    this.skipSC();
    switch(this.tokenType){
        case 0, $cb01acaf2e18d562$export$fffa67e515d04022:
            if (this.isDelim($afb64130c5df0f05$var$SOLIDUS, this.lookupOffsetNonSC(1))) return this.Ratio();
            else return this.Number();
        case 0, $cb01acaf2e18d562$export$c940ece961bc43c6:
            return this.Dimension();
        case 0, $cb01acaf2e18d562$export$331e9b6bdecaac5f:
            return this.Identifier();
        case 0, $cb01acaf2e18d562$export$f3890eeaf6851387:
            return this.parseWithFallback(()=>{
                const res = this.Function(this.readSequence, this.scope.Value);
                this.skipSC();
                if (this.isDelim($afb64130c5df0f05$var$SOLIDUS)) this.error();
                return res;
            }, ()=>{
                return this.Ratio();
            });
        default:
            this.error('Number, dimension, ratio or identifier is expected');
    }
}
function $afb64130c5df0f05$var$readComparison(expectColon) {
    this.skipSC();
    if (this.isDelim($afb64130c5df0f05$var$LESSTHANSIGN) || this.isDelim($afb64130c5df0f05$var$GREATERTHANSIGN)) {
        const value = this.source[this.tokenStart];
        this.next();
        if (this.isDelim($afb64130c5df0f05$var$EQUALSSIGN)) {
            this.next();
            return value + '=';
        }
        return value;
    }
    if (this.isDelim($afb64130c5df0f05$var$EQUALSSIGN)) return '=';
    this.error(`Expected ${expectColon ? '":", ' : ''}"<", ">", "=" or ")"`);
}
function $afb64130c5df0f05$export$98e6a39c04603d36(kind = 'unknown') {
    const start = this.tokenStart;
    this.skipSC();
    this.eat((0, $cb01acaf2e18d562$export$b5a25f132cb53de6));
    const left = $afb64130c5df0f05$var$readTerm.call(this);
    const leftComparison = $afb64130c5df0f05$var$readComparison.call(this, left.type === 'Identifier');
    const middle = $afb64130c5df0f05$var$readTerm.call(this);
    let rightComparison = null;
    let right = null;
    if (this.lookupNonWSType(0) !== (0, $cb01acaf2e18d562$export$773d33972c6279ed)) {
        rightComparison = $afb64130c5df0f05$var$readComparison.call(this);
        right = $afb64130c5df0f05$var$readTerm.call(this);
    }
    this.skipSC();
    this.eat((0, $cb01acaf2e18d562$export$773d33972c6279ed));
    return {
        type: 'FeatureRange',
        loc: this.getLocation(start, this.tokenStart),
        kind: kind,
        left: left,
        leftComparison: leftComparison,
        middle: middle,
        rightComparison: rightComparison,
        right: right
    };
}
function $afb64130c5df0f05$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$b5a25f132cb53de6), '(');
    this.node(node.left);
    this.tokenize(node.leftComparison);
    this.node(node.middle);
    if (node.right) {
        this.tokenize(node.rightComparison);
        this.node(node.right);
    }
    this.token((0, $cb01acaf2e18d562$export$773d33972c6279ed), ')');
}


var $9bf79ec41884755c$exports = {};

$parcel$export($9bf79ec41884755c$exports, "name", function () { return $9bf79ec41884755c$export$a8ff84c12d48cfa6; });
$parcel$export($9bf79ec41884755c$exports, "walkContext", function () { return $9bf79ec41884755c$export$f7e0bb689fefb8c2; });
$parcel$export($9bf79ec41884755c$exports, "structure", function () { return $9bf79ec41884755c$export$46a2a563c28afca0; });
$parcel$export($9bf79ec41884755c$exports, "parse", function () { return $9bf79ec41884755c$export$98e6a39c04603d36; });
$parcel$export($9bf79ec41884755c$exports, "generate", function () { return $9bf79ec41884755c$export$80d376111cc09ad7; });

const $9bf79ec41884755c$export$a8ff84c12d48cfa6 = 'Function';
const $9bf79ec41884755c$export$f7e0bb689fefb8c2 = 'function';
const $9bf79ec41884755c$export$46a2a563c28afca0 = {
    name: String,
    children: [
        []
    ]
};
function $9bf79ec41884755c$export$98e6a39c04603d36(readSequence, recognizer) {
    const start = this.tokenStart;
    const name = this.consumeFunctionName();
    const nameLowerCase = name.toLowerCase();
    let children;
    children = recognizer.hasOwnProperty(nameLowerCase) ? recognizer[nameLowerCase].call(this, recognizer) : readSequence.call(this, recognizer);
    if (!this.eof) this.eat((0, $cb01acaf2e18d562$export$773d33972c6279ed));
    return {
        type: 'Function',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        children: children
    };
}
function $9bf79ec41884755c$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$f3890eeaf6851387), node.name + '(');
    this.children(node);
    this.token((0, $cb01acaf2e18d562$export$773d33972c6279ed), ')');
}


var $a68195bce17edba7$exports = {};

$parcel$export($a68195bce17edba7$exports, "name", function () { return $a68195bce17edba7$export$a8ff84c12d48cfa6; });
$parcel$export($a68195bce17edba7$exports, "structure", function () { return $a68195bce17edba7$export$46a2a563c28afca0; });
$parcel$export($a68195bce17edba7$exports, "parse", function () { return $a68195bce17edba7$export$98e6a39c04603d36; });
$parcel$export($a68195bce17edba7$exports, "generate", function () { return $a68195bce17edba7$export$80d376111cc09ad7; });

const $a68195bce17edba7$export$a8ff84c12d48cfa6 = 'GeneralEnclosed';
const $a68195bce17edba7$export$46a2a563c28afca0 = {
    kind: String,
    function: [
        String,
        null
    ],
    children: [
        []
    ]
};
function $a68195bce17edba7$export$98e6a39c04603d36(kind) {
    const start = this.tokenStart;
    let functionName = null;
    if (this.tokenType === (0, $cb01acaf2e18d562$export$f3890eeaf6851387)) functionName = this.consumeFunctionName();
    else this.eat((0, $cb01acaf2e18d562$export$b5a25f132cb53de6));
    const children = this.parseWithFallback(()=>{
        const startValueToken = this.tokenIndex;
        const children = this.readSequence(this.scope.Value);
        if (this.eof === false && this.isBalanceEdge(startValueToken) === false) this.error();
        return children;
    }, ()=>this.createSingleNodeList(this.Raw(null, false)));
    if (!this.eof) this.eat((0, $cb01acaf2e18d562$export$773d33972c6279ed));
    return {
        type: 'GeneralEnclosed',
        loc: this.getLocation(start, this.tokenStart),
        kind: kind,
        function: functionName,
        children: children
    };
}
function $a68195bce17edba7$export$80d376111cc09ad7(node) {
    if (node.function) this.token((0, $cb01acaf2e18d562$export$f3890eeaf6851387), node.function + '(');
    else this.token((0, $cb01acaf2e18d562$export$b5a25f132cb53de6), '(');
    this.children(node);
    this.token((0, $cb01acaf2e18d562$export$773d33972c6279ed), ')');
}


var $b35684aa816106b7$exports = {};

$parcel$export($b35684aa816106b7$exports, "xxx", function () { return $b35684aa816106b7$export$78cbacf5ba6edce7; });
$parcel$export($b35684aa816106b7$exports, "name", function () { return $b35684aa816106b7$export$a8ff84c12d48cfa6; });
$parcel$export($b35684aa816106b7$exports, "structure", function () { return $b35684aa816106b7$export$46a2a563c28afca0; });
$parcel$export($b35684aa816106b7$exports, "parse", function () { return $b35684aa816106b7$export$98e6a39c04603d36; });
$parcel$export($b35684aa816106b7$exports, "generate", function () { return $b35684aa816106b7$export$80d376111cc09ad7; });

const $b35684aa816106b7$export$78cbacf5ba6edce7 = 'XXX';
const $b35684aa816106b7$export$a8ff84c12d48cfa6 = 'Hash';
const $b35684aa816106b7$export$46a2a563c28afca0 = {
    value: String
};
function $b35684aa816106b7$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    this.eat((0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd));
    return {
        type: 'Hash',
        loc: this.getLocation(start, this.tokenStart),
        value: this.substrToCursor(start + 1)
    };
}
function $b35684aa816106b7$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd), '#' + node.value);
}


var $11a87938930caa52$exports = {};

$parcel$export($11a87938930caa52$exports, "name", function () { return $11a87938930caa52$export$a8ff84c12d48cfa6; });
$parcel$export($11a87938930caa52$exports, "structure", function () { return $11a87938930caa52$export$46a2a563c28afca0; });
$parcel$export($11a87938930caa52$exports, "parse", function () { return $11a87938930caa52$export$98e6a39c04603d36; });
$parcel$export($11a87938930caa52$exports, "generate", function () { return $11a87938930caa52$export$80d376111cc09ad7; });

const $11a87938930caa52$export$a8ff84c12d48cfa6 = 'Identifier';
const $11a87938930caa52$export$46a2a563c28afca0 = {
    name: String
};
function $11a87938930caa52$export$98e6a39c04603d36() {
    return {
        type: 'Identifier',
        loc: this.getLocation(this.tokenStart, this.tokenEnd),
        name: this.consume((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f))
    };
}
function $11a87938930caa52$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f), node.name);
}


var $2f8d9fb2da484051$exports = {};

$parcel$export($2f8d9fb2da484051$exports, "name", function () { return $2f8d9fb2da484051$export$a8ff84c12d48cfa6; });
$parcel$export($2f8d9fb2da484051$exports, "structure", function () { return $2f8d9fb2da484051$export$46a2a563c28afca0; });
$parcel$export($2f8d9fb2da484051$exports, "parse", function () { return $2f8d9fb2da484051$export$98e6a39c04603d36; });
$parcel$export($2f8d9fb2da484051$exports, "generate", function () { return $2f8d9fb2da484051$export$80d376111cc09ad7; });

const $2f8d9fb2da484051$export$a8ff84c12d48cfa6 = 'IdSelector';
const $2f8d9fb2da484051$export$46a2a563c28afca0 = {
    name: String
};
function $2f8d9fb2da484051$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    // TODO: check value is an ident
    this.eat((0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd));
    return {
        type: 'IdSelector',
        loc: this.getLocation(start, this.tokenStart),
        name: this.substrToCursor(start + 1)
    };
}
function $2f8d9fb2da484051$export$80d376111cc09ad7(node) {
    // Using Delim instead of Hash is a hack to avoid for a whitespace between ident and id-selector
    // in safe mode (e.g. "a#id"), because IE11 doesn't allow a sequence <ident-token> <hash-token>
    // without a whitespace in values (e.g. "1px solid#000")
    this.token((0, $cb01acaf2e18d562$export$a918ca49ff4337a3), '#' + node.name);
}


var $c85db2efff85fc02$exports = {};

$parcel$export($c85db2efff85fc02$exports, "name", function () { return $c85db2efff85fc02$export$a8ff84c12d48cfa6; });
$parcel$export($c85db2efff85fc02$exports, "structure", function () { return $c85db2efff85fc02$export$46a2a563c28afca0; });
$parcel$export($c85db2efff85fc02$exports, "parse", function () { return $c85db2efff85fc02$export$98e6a39c04603d36; });
$parcel$export($c85db2efff85fc02$exports, "generate", function () { return $c85db2efff85fc02$export$80d376111cc09ad7; });

const $c85db2efff85fc02$var$FULLSTOP = 0x002E; // U+002E FULL STOP (.)
const $c85db2efff85fc02$export$a8ff84c12d48cfa6 = 'Layer';
const $c85db2efff85fc02$export$46a2a563c28afca0 = {
    name: String
};
function $c85db2efff85fc02$export$98e6a39c04603d36() {
    let tokenStart = this.tokenStart;
    let name = this.consume((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f));
    while(this.isDelim($c85db2efff85fc02$var$FULLSTOP)){
        this.eat((0, $cb01acaf2e18d562$export$a918ca49ff4337a3));
        name += '.' + this.consume((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f));
    }
    return {
        type: 'Layer',
        loc: this.getLocation(tokenStart, this.tokenStart),
        name: name
    };
}
function $c85db2efff85fc02$export$80d376111cc09ad7(node) {
    this.tokenize(node.name);
}


var $25655749f16bffa8$exports = {};

$parcel$export($25655749f16bffa8$exports, "name", function () { return $25655749f16bffa8$export$a8ff84c12d48cfa6; });
$parcel$export($25655749f16bffa8$exports, "structure", function () { return $25655749f16bffa8$export$46a2a563c28afca0; });
$parcel$export($25655749f16bffa8$exports, "parse", function () { return $25655749f16bffa8$export$98e6a39c04603d36; });
$parcel$export($25655749f16bffa8$exports, "generate", function () { return $25655749f16bffa8$export$80d376111cc09ad7; });

const $25655749f16bffa8$export$a8ff84c12d48cfa6 = 'LayerList';
const $25655749f16bffa8$export$46a2a563c28afca0 = {
    children: [
        [
            'Layer'
        ]
    ]
};
function $25655749f16bffa8$export$98e6a39c04603d36() {
    const children = this.createList();
    this.skipSC();
    while(!this.eof){
        children.push(this.Layer());
        if (this.lookupTypeNonSC(0) !== (0, $cb01acaf2e18d562$export$c06e3ee3b4d233fa)) break;
        this.skipSC();
        this.next();
        this.skipSC();
    }
    return {
        type: 'LayerList',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $25655749f16bffa8$export$80d376111cc09ad7(node) {
    this.children(node, ()=>this.token((0, $cb01acaf2e18d562$export$c06e3ee3b4d233fa), ','));
}


var $94b05fd6c096774a$exports = {};

$parcel$export($94b05fd6c096774a$exports, "name", function () { return $94b05fd6c096774a$export$a8ff84c12d48cfa6; });
$parcel$export($94b05fd6c096774a$exports, "structure", function () { return $94b05fd6c096774a$export$46a2a563c28afca0; });
$parcel$export($94b05fd6c096774a$exports, "parse", function () { return $94b05fd6c096774a$export$98e6a39c04603d36; });
$parcel$export($94b05fd6c096774a$exports, "generate", function () { return $94b05fd6c096774a$export$80d376111cc09ad7; });

const $94b05fd6c096774a$export$a8ff84c12d48cfa6 = 'MediaQuery';
const $94b05fd6c096774a$export$46a2a563c28afca0 = {
    modifier: [
        String,
        null
    ],
    mediaType: [
        String,
        null
    ],
    condition: [
        'Condition',
        null
    ]
};
function $94b05fd6c096774a$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    let modifier = null;
    let mediaType = null;
    let condition = null;
    this.skipSC();
    if (this.tokenType === (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f) && this.lookupTypeNonSC(1) !== (0, $cb01acaf2e18d562$export$b5a25f132cb53de6)) {
        // [ not | only ]? <media-type>
        const ident = this.consume((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f));
        const identLowerCase = ident.toLowerCase();
        if (identLowerCase === 'not' || identLowerCase === 'only') {
            this.skipSC();
            modifier = identLowerCase;
            mediaType = this.consume((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f));
        } else mediaType = ident;
        switch(this.lookupTypeNonSC(0)){
            case 0, $cb01acaf2e18d562$export$331e9b6bdecaac5f:
                // and <media-condition-without-or>
                this.skipSC();
                this.eatIdent('and');
                condition = this.Condition('media');
                break;
            case 0, $cb01acaf2e18d562$export$ccdce7304ac66390:
            case 0, $cb01acaf2e18d562$export$bedd8b9b04d9dbd:
            case 0, $cb01acaf2e18d562$export$c06e3ee3b4d233fa:
            case 0, $cb01acaf2e18d562$export$c1a09112320b1603:
                break;
            default:
                this.error('Identifier or parenthesis is expected');
        }
    } else switch(this.tokenType){
        case 0, $cb01acaf2e18d562$export$331e9b6bdecaac5f:
        case 0, $cb01acaf2e18d562$export$b5a25f132cb53de6:
        case 0, $cb01acaf2e18d562$export$f3890eeaf6851387:
            // <media-condition>
            condition = this.Condition('media');
            break;
        case 0, $cb01acaf2e18d562$export$ccdce7304ac66390:
        case 0, $cb01acaf2e18d562$export$bedd8b9b04d9dbd:
        case 0, $cb01acaf2e18d562$export$c1a09112320b1603:
            break;
        default:
            this.error('Identifier or parenthesis is expected');
    }
    return {
        type: 'MediaQuery',
        loc: this.getLocation(start, this.tokenStart),
        modifier: modifier,
        mediaType: mediaType,
        condition: condition
    };
}
function $94b05fd6c096774a$export$80d376111cc09ad7(node) {
    if (node.mediaType) {
        if (node.modifier) this.token((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f), node.modifier);
        this.token((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f), node.mediaType);
        if (node.condition) {
            this.token((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f), 'and');
            this.node(node.condition);
        }
    } else if (node.condition) this.node(node.condition);
}


var $d970f304e8bc71ba$exports = {};

$parcel$export($d970f304e8bc71ba$exports, "name", function () { return $d970f304e8bc71ba$export$a8ff84c12d48cfa6; });
$parcel$export($d970f304e8bc71ba$exports, "structure", function () { return $d970f304e8bc71ba$export$46a2a563c28afca0; });
$parcel$export($d970f304e8bc71ba$exports, "parse", function () { return $d970f304e8bc71ba$export$98e6a39c04603d36; });
$parcel$export($d970f304e8bc71ba$exports, "generate", function () { return $d970f304e8bc71ba$export$80d376111cc09ad7; });

const $d970f304e8bc71ba$export$a8ff84c12d48cfa6 = 'MediaQueryList';
const $d970f304e8bc71ba$export$46a2a563c28afca0 = {
    children: [
        [
            'MediaQuery'
        ]
    ]
};
function $d970f304e8bc71ba$export$98e6a39c04603d36() {
    const children = this.createList();
    this.skipSC();
    while(!this.eof){
        children.push(this.MediaQuery());
        if (this.tokenType !== (0, $cb01acaf2e18d562$export$c06e3ee3b4d233fa)) break;
        this.next();
    }
    return {
        type: 'MediaQueryList',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $d970f304e8bc71ba$export$80d376111cc09ad7(node) {
    this.children(node, ()=>this.token((0, $cb01acaf2e18d562$export$c06e3ee3b4d233fa), ','));
}


var $fbed52d6f2df3274$exports = {};

$parcel$export($fbed52d6f2df3274$exports, "name", function () { return $fbed52d6f2df3274$export$a8ff84c12d48cfa6; });
$parcel$export($fbed52d6f2df3274$exports, "structure", function () { return $fbed52d6f2df3274$export$46a2a563c28afca0; });
$parcel$export($fbed52d6f2df3274$exports, "parse", function () { return $fbed52d6f2df3274$export$98e6a39c04603d36; });
$parcel$export($fbed52d6f2df3274$exports, "generate", function () { return $fbed52d6f2df3274$export$80d376111cc09ad7; });

const $fbed52d6f2df3274$var$AMPERSAND = 0x0026; // U+0026 AMPERSAND (&)
const $fbed52d6f2df3274$export$a8ff84c12d48cfa6 = 'NestingSelector';
const $fbed52d6f2df3274$export$46a2a563c28afca0 = {};
function $fbed52d6f2df3274$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    this.eatDelim($fbed52d6f2df3274$var$AMPERSAND);
    return {
        type: 'NestingSelector',
        loc: this.getLocation(start, this.tokenStart)
    };
}
function $fbed52d6f2df3274$export$80d376111cc09ad7() {
    this.token((0, $cb01acaf2e18d562$export$a918ca49ff4337a3), '&');
}


var $352c778ae94e759f$exports = {};

$parcel$export($352c778ae94e759f$exports, "name", function () { return $352c778ae94e759f$export$a8ff84c12d48cfa6; });
$parcel$export($352c778ae94e759f$exports, "structure", function () { return $352c778ae94e759f$export$46a2a563c28afca0; });
$parcel$export($352c778ae94e759f$exports, "parse", function () { return $352c778ae94e759f$export$98e6a39c04603d36; });
$parcel$export($352c778ae94e759f$exports, "generate", function () { return $352c778ae94e759f$export$80d376111cc09ad7; });

const $352c778ae94e759f$export$a8ff84c12d48cfa6 = 'Nth';
const $352c778ae94e759f$export$46a2a563c28afca0 = {
    nth: [
        'AnPlusB',
        'Identifier'
    ],
    selector: [
        'SelectorList',
        null
    ]
};
function $352c778ae94e759f$export$98e6a39c04603d36() {
    this.skipSC();
    const start = this.tokenStart;
    let end = start;
    let selector = null;
    let nth;
    if (this.lookupValue(0, 'odd') || this.lookupValue(0, 'even')) nth = this.Identifier();
    else nth = this.AnPlusB();
    end = this.tokenStart;
    this.skipSC();
    if (this.lookupValue(0, 'of')) {
        this.next();
        selector = this.SelectorList();
        end = this.tokenStart;
    }
    return {
        type: 'Nth',
        loc: this.getLocation(start, end),
        nth: nth,
        selector: selector
    };
}
function $352c778ae94e759f$export$80d376111cc09ad7(node) {
    this.node(node.nth);
    if (node.selector !== null) {
        this.token((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f), 'of');
        this.node(node.selector);
    }
}


var $407e1ad9ced420db$exports = {};

$parcel$export($407e1ad9ced420db$exports, "name", function () { return $407e1ad9ced420db$export$a8ff84c12d48cfa6; });
$parcel$export($407e1ad9ced420db$exports, "structure", function () { return $407e1ad9ced420db$export$46a2a563c28afca0; });
$parcel$export($407e1ad9ced420db$exports, "parse", function () { return $407e1ad9ced420db$export$98e6a39c04603d36; });
$parcel$export($407e1ad9ced420db$exports, "generate", function () { return $407e1ad9ced420db$export$80d376111cc09ad7; });

const $407e1ad9ced420db$export$a8ff84c12d48cfa6 = 'Number';
const $407e1ad9ced420db$export$46a2a563c28afca0 = {
    value: String
};
function $407e1ad9ced420db$export$98e6a39c04603d36() {
    return {
        type: 'Number',
        loc: this.getLocation(this.tokenStart, this.tokenEnd),
        value: this.consume((0, $cb01acaf2e18d562$export$fffa67e515d04022))
    };
}
function $407e1ad9ced420db$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$fffa67e515d04022), node.value);
}


var $04369877262756a7$exports = {};

$parcel$export($04369877262756a7$exports, "name", function () { return $04369877262756a7$export$a8ff84c12d48cfa6; });
$parcel$export($04369877262756a7$exports, "structure", function () { return $04369877262756a7$export$46a2a563c28afca0; });
$parcel$export($04369877262756a7$exports, "parse", function () { return $04369877262756a7$export$98e6a39c04603d36; });
$parcel$export($04369877262756a7$exports, "generate", function () { return $04369877262756a7$export$80d376111cc09ad7; });
// '/' | '*' | ',' | ':' | '+' | '-'
const $04369877262756a7$export$a8ff84c12d48cfa6 = 'Operator';
const $04369877262756a7$export$46a2a563c28afca0 = {
    value: String
};
function $04369877262756a7$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    this.next();
    return {
        type: 'Operator',
        loc: this.getLocation(start, this.tokenStart),
        value: this.substrToCursor(start)
    };
}
function $04369877262756a7$export$80d376111cc09ad7(node) {
    this.tokenize(node.value);
}


var $c886fa5abc8d9d5f$exports = {};

$parcel$export($c886fa5abc8d9d5f$exports, "name", function () { return $c886fa5abc8d9d5f$export$a8ff84c12d48cfa6; });
$parcel$export($c886fa5abc8d9d5f$exports, "structure", function () { return $c886fa5abc8d9d5f$export$46a2a563c28afca0; });
$parcel$export($c886fa5abc8d9d5f$exports, "parse", function () { return $c886fa5abc8d9d5f$export$98e6a39c04603d36; });
$parcel$export($c886fa5abc8d9d5f$exports, "generate", function () { return $c886fa5abc8d9d5f$export$80d376111cc09ad7; });

const $c886fa5abc8d9d5f$export$a8ff84c12d48cfa6 = 'Parentheses';
const $c886fa5abc8d9d5f$export$46a2a563c28afca0 = {
    children: [
        []
    ]
};
function $c886fa5abc8d9d5f$export$98e6a39c04603d36(readSequence, recognizer) {
    const start = this.tokenStart;
    let children = null;
    this.eat((0, $cb01acaf2e18d562$export$b5a25f132cb53de6));
    children = readSequence.call(this, recognizer);
    if (!this.eof) this.eat((0, $cb01acaf2e18d562$export$773d33972c6279ed));
    return {
        type: 'Parentheses',
        loc: this.getLocation(start, this.tokenStart),
        children: children
    };
}
function $c886fa5abc8d9d5f$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$b5a25f132cb53de6), '(');
    this.children(node);
    this.token((0, $cb01acaf2e18d562$export$773d33972c6279ed), ')');
}


var $c99e2ae0e225fd3f$exports = {};

$parcel$export($c99e2ae0e225fd3f$exports, "name", function () { return $c99e2ae0e225fd3f$export$a8ff84c12d48cfa6; });
$parcel$export($c99e2ae0e225fd3f$exports, "structure", function () { return $c99e2ae0e225fd3f$export$46a2a563c28afca0; });
$parcel$export($c99e2ae0e225fd3f$exports, "parse", function () { return $c99e2ae0e225fd3f$export$98e6a39c04603d36; });
$parcel$export($c99e2ae0e225fd3f$exports, "generate", function () { return $c99e2ae0e225fd3f$export$80d376111cc09ad7; });

const $c99e2ae0e225fd3f$export$a8ff84c12d48cfa6 = 'Percentage';
const $c99e2ae0e225fd3f$export$46a2a563c28afca0 = {
    value: String
};
function $c99e2ae0e225fd3f$export$98e6a39c04603d36() {
    return {
        type: 'Percentage',
        loc: this.getLocation(this.tokenStart, this.tokenEnd),
        value: this.consumeNumber((0, $cb01acaf2e18d562$export$d11913f8a6922aea))
    };
}
function $c99e2ae0e225fd3f$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$d11913f8a6922aea), node.value + '%');
}


var $81ba3db47496bc3c$exports = {};

$parcel$export($81ba3db47496bc3c$exports, "name", function () { return $81ba3db47496bc3c$export$a8ff84c12d48cfa6; });
$parcel$export($81ba3db47496bc3c$exports, "walkContext", function () { return $81ba3db47496bc3c$export$f7e0bb689fefb8c2; });
$parcel$export($81ba3db47496bc3c$exports, "structure", function () { return $81ba3db47496bc3c$export$46a2a563c28afca0; });
$parcel$export($81ba3db47496bc3c$exports, "parse", function () { return $81ba3db47496bc3c$export$98e6a39c04603d36; });
$parcel$export($81ba3db47496bc3c$exports, "generate", function () { return $81ba3db47496bc3c$export$80d376111cc09ad7; });

const $81ba3db47496bc3c$export$a8ff84c12d48cfa6 = 'PseudoClassSelector';
const $81ba3db47496bc3c$export$f7e0bb689fefb8c2 = 'function';
const $81ba3db47496bc3c$export$46a2a563c28afca0 = {
    name: String,
    children: [
        [
            'Raw'
        ],
        null
    ]
};
function $81ba3db47496bc3c$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    let children = null;
    let name;
    let nameLowerCase;
    this.eat((0, $cb01acaf2e18d562$export$e20ebb298016f6));
    if (this.tokenType === (0, $cb01acaf2e18d562$export$f3890eeaf6851387)) {
        name = this.consumeFunctionName();
        nameLowerCase = name.toLowerCase();
        if (this.lookupNonWSType(0) == (0, $cb01acaf2e18d562$export$773d33972c6279ed)) children = this.createList();
        else if (hasOwnProperty.call(this.pseudo, nameLowerCase)) {
            this.skipSC();
            children = this.pseudo[nameLowerCase].call(this);
            this.skipSC();
        } else {
            children = this.createList();
            children.push(this.Raw(null, false));
        }
        this.eat((0, $cb01acaf2e18d562$export$773d33972c6279ed));
    } else name = this.consume((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f));
    return {
        type: 'PseudoClassSelector',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        children: children
    };
}
function $81ba3db47496bc3c$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$e20ebb298016f6), ':');
    if (node.children === null) this.token((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f), node.name);
    else {
        this.token((0, $cb01acaf2e18d562$export$f3890eeaf6851387), node.name + '(');
        this.children(node);
        this.token((0, $cb01acaf2e18d562$export$773d33972c6279ed), ')');
    }
}


var $56f21670f2a6843f$exports = {};

$parcel$export($56f21670f2a6843f$exports, "name", function () { return $56f21670f2a6843f$export$a8ff84c12d48cfa6; });
$parcel$export($56f21670f2a6843f$exports, "walkContext", function () { return $56f21670f2a6843f$export$f7e0bb689fefb8c2; });
$parcel$export($56f21670f2a6843f$exports, "structure", function () { return $56f21670f2a6843f$export$46a2a563c28afca0; });
$parcel$export($56f21670f2a6843f$exports, "parse", function () { return $56f21670f2a6843f$export$98e6a39c04603d36; });
$parcel$export($56f21670f2a6843f$exports, "generate", function () { return $56f21670f2a6843f$export$80d376111cc09ad7; });

const $56f21670f2a6843f$export$a8ff84c12d48cfa6 = 'PseudoElementSelector';
const $56f21670f2a6843f$export$f7e0bb689fefb8c2 = 'function';
const $56f21670f2a6843f$export$46a2a563c28afca0 = {
    name: String,
    children: [
        [
            'Raw'
        ],
        null
    ]
};
function $56f21670f2a6843f$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    let children = null;
    let name;
    let nameLowerCase;
    this.eat((0, $cb01acaf2e18d562$export$e20ebb298016f6));
    this.eat((0, $cb01acaf2e18d562$export$e20ebb298016f6));
    if (this.tokenType === (0, $cb01acaf2e18d562$export$f3890eeaf6851387)) {
        name = this.consumeFunctionName();
        nameLowerCase = name.toLowerCase();
        if (this.lookupNonWSType(0) == (0, $cb01acaf2e18d562$export$773d33972c6279ed)) children = this.createList();
        else if (hasOwnProperty.call(this.pseudo, nameLowerCase)) {
            this.skipSC();
            children = this.pseudo[nameLowerCase].call(this);
            this.skipSC();
        } else {
            children = this.createList();
            children.push(this.Raw(null, false));
        }
        this.eat((0, $cb01acaf2e18d562$export$773d33972c6279ed));
    } else name = this.consume((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f));
    return {
        type: 'PseudoElementSelector',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        children: children
    };
}
function $56f21670f2a6843f$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$e20ebb298016f6), ':');
    this.token((0, $cb01acaf2e18d562$export$e20ebb298016f6), ':');
    if (node.children === null) this.token((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f), node.name);
    else {
        this.token((0, $cb01acaf2e18d562$export$f3890eeaf6851387), node.name + '(');
        this.children(node);
        this.token((0, $cb01acaf2e18d562$export$773d33972c6279ed), ')');
    }
}


var $60a58b987a514501$exports = {};

$parcel$export($60a58b987a514501$exports, "name", function () { return $60a58b987a514501$export$a8ff84c12d48cfa6; });
$parcel$export($60a58b987a514501$exports, "structure", function () { return $60a58b987a514501$export$46a2a563c28afca0; });
$parcel$export($60a58b987a514501$exports, "parse", function () { return $60a58b987a514501$export$98e6a39c04603d36; });
$parcel$export($60a58b987a514501$exports, "generate", function () { return $60a58b987a514501$export$80d376111cc09ad7; });

const $60a58b987a514501$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
// Media Queries Level 3 defines terms of <ratio> as a positive (not zero or negative)
// integers (see https://drafts.csswg.org/mediaqueries-3/#values)
// However, Media Queries Level 4 removes any definition of values
// (see https://drafts.csswg.org/mediaqueries-4/#values) and refers to
// CSS Values and Units for detail. In CSS Values and Units Level 4 a <ratio>
// definition was added (see https://drafts.csswg.org/css-values-4/#ratios) which
// defines ratio as "<number [0,∞]> [ / <number [0,∞]> ]?" and based on it
// any constrains on terms were removed. Parser also doesn't test numbers
// in any way to make possible for linting and fixing them by the tools using CSSTree.
// An additional syntax examination may be applied by a lexer.
function $60a58b987a514501$var$consumeTerm() {
    this.skipSC();
    switch(this.tokenType){
        case 0, $cb01acaf2e18d562$export$fffa67e515d04022:
            return this.Number();
        case 0, $cb01acaf2e18d562$export$f3890eeaf6851387:
            return this.Function(this.readSequence, this.scope.Value);
        default:
            this.error('Number of function is expected');
    }
}
const $60a58b987a514501$export$a8ff84c12d48cfa6 = 'Ratio';
const $60a58b987a514501$export$46a2a563c28afca0 = {
    left: [
        'Number',
        'Function'
    ],
    right: [
        'Number',
        'Function',
        null
    ]
};
function $60a58b987a514501$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    const left = $60a58b987a514501$var$consumeTerm.call(this);
    let right = null;
    this.skipSC();
    if (this.isDelim($60a58b987a514501$var$SOLIDUS)) {
        this.eatDelim($60a58b987a514501$var$SOLIDUS);
        right = $60a58b987a514501$var$consumeTerm.call(this);
    }
    return {
        type: 'Ratio',
        loc: this.getLocation(start, this.tokenStart),
        left: left,
        right: right
    };
}
function $60a58b987a514501$export$80d376111cc09ad7(node) {
    this.node(node.left);
    this.token((0, $cb01acaf2e18d562$export$a918ca49ff4337a3), '/');
    if (node.right) this.node(node.right);
    else this.node((0, $cb01acaf2e18d562$export$fffa67e515d04022), 1);
}


var $54eb253192531e90$exports = {};

$parcel$export($54eb253192531e90$exports, "name", function () { return $54eb253192531e90$export$a8ff84c12d48cfa6; });
$parcel$export($54eb253192531e90$exports, "structure", function () { return $54eb253192531e90$export$46a2a563c28afca0; });
$parcel$export($54eb253192531e90$exports, "parse", function () { return $54eb253192531e90$export$98e6a39c04603d36; });
$parcel$export($54eb253192531e90$exports, "generate", function () { return $54eb253192531e90$export$80d376111cc09ad7; });

function $54eb253192531e90$var$getOffsetExcludeWS() {
    if (this.tokenIndex > 0) {
        if (this.lookupType(-1) === (0, $cb01acaf2e18d562$export$fb98946286ab4c97)) return this.tokenIndex > 1 ? this.getTokenStart(this.tokenIndex - 1) : this.firstCharOffset;
    }
    return this.tokenStart;
}
const $54eb253192531e90$export$a8ff84c12d48cfa6 = 'Raw';
const $54eb253192531e90$export$46a2a563c28afca0 = {
    value: String
};
function $54eb253192531e90$export$98e6a39c04603d36(consumeUntil, excludeWhiteSpace) {
    const startOffset = this.getTokenStart(this.tokenIndex);
    let endOffset;
    this.skipUntilBalanced(this.tokenIndex, consumeUntil || this.consumeUntilBalanceEnd);
    if (excludeWhiteSpace && this.tokenStart > startOffset) endOffset = $54eb253192531e90$var$getOffsetExcludeWS.call(this);
    else endOffset = this.tokenStart;
    return {
        type: 'Raw',
        loc: this.getLocation(startOffset, endOffset),
        value: this.substring(startOffset, endOffset)
    };
}
function $54eb253192531e90$export$80d376111cc09ad7(node) {
    this.tokenize(node.value);
}


var $f80a1e59c59983e7$exports = {};

$parcel$export($f80a1e59c59983e7$exports, "name", function () { return $f80a1e59c59983e7$export$a8ff84c12d48cfa6; });
$parcel$export($f80a1e59c59983e7$exports, "walkContext", function () { return $f80a1e59c59983e7$export$f7e0bb689fefb8c2; });
$parcel$export($f80a1e59c59983e7$exports, "structure", function () { return $f80a1e59c59983e7$export$46a2a563c28afca0; });
$parcel$export($f80a1e59c59983e7$exports, "parse", function () { return $f80a1e59c59983e7$export$98e6a39c04603d36; });
$parcel$export($f80a1e59c59983e7$exports, "generate", function () { return $f80a1e59c59983e7$export$80d376111cc09ad7; });

function $f80a1e59c59983e7$var$consumeRaw() {
    return this.Raw(this.consumeUntilLeftCurlyBracket, true);
}
function $f80a1e59c59983e7$var$consumePrelude() {
    const prelude = this.SelectorList();
    if (prelude.type !== 'Raw' && this.eof === false && this.tokenType !== (0, $cb01acaf2e18d562$export$ccdce7304ac66390)) this.error();
    return prelude;
}
const $f80a1e59c59983e7$export$a8ff84c12d48cfa6 = 'Rule';
const $f80a1e59c59983e7$export$f7e0bb689fefb8c2 = 'rule';
const $f80a1e59c59983e7$export$46a2a563c28afca0 = {
    prelude: [
        'SelectorList',
        'Raw'
    ],
    block: [
        'Block'
    ]
};
function $f80a1e59c59983e7$export$98e6a39c04603d36() {
    const startToken = this.tokenIndex;
    const startOffset = this.tokenStart;
    let prelude;
    let block;
    if (this.parseRulePrelude) prelude = this.parseWithFallback($f80a1e59c59983e7$var$consumePrelude, $f80a1e59c59983e7$var$consumeRaw);
    else prelude = $f80a1e59c59983e7$var$consumeRaw.call(this, startToken);
    block = this.Block(true);
    return {
        type: 'Rule',
        loc: this.getLocation(startOffset, this.tokenStart),
        prelude: prelude,
        block: block
    };
}
function $f80a1e59c59983e7$export$80d376111cc09ad7(node) {
    this.node(node.prelude);
    this.node(node.block);
}


var $5de80a7b15a6bf26$exports = {};

$parcel$export($5de80a7b15a6bf26$exports, "name", function () { return $5de80a7b15a6bf26$export$a8ff84c12d48cfa6; });
$parcel$export($5de80a7b15a6bf26$exports, "structure", function () { return $5de80a7b15a6bf26$export$46a2a563c28afca0; });
$parcel$export($5de80a7b15a6bf26$exports, "parse", function () { return $5de80a7b15a6bf26$export$98e6a39c04603d36; });
$parcel$export($5de80a7b15a6bf26$exports, "generate", function () { return $5de80a7b15a6bf26$export$80d376111cc09ad7; });

const $5de80a7b15a6bf26$export$a8ff84c12d48cfa6 = 'Scope';
const $5de80a7b15a6bf26$export$46a2a563c28afca0 = {
    root: [
        'SelectorList',
        'Raw',
        null
    ],
    limit: [
        'SelectorList',
        'Raw',
        null
    ]
};
function $5de80a7b15a6bf26$export$98e6a39c04603d36() {
    let root = null;
    let limit = null;
    this.skipSC();
    const startOffset = this.tokenStart;
    if (this.tokenType === (0, $cb01acaf2e18d562$export$b5a25f132cb53de6)) {
        this.next();
        this.skipSC();
        root = this.parseWithFallback(this.SelectorList, ()=>this.Raw(false, true));
        this.skipSC();
        this.eat((0, $cb01acaf2e18d562$export$773d33972c6279ed));
    }
    if (this.lookupNonWSType(0) === (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)) {
        this.skipSC();
        this.eatIdent('to');
        this.skipSC();
        this.eat((0, $cb01acaf2e18d562$export$b5a25f132cb53de6));
        this.skipSC();
        limit = this.parseWithFallback(this.SelectorList, ()=>this.Raw(false, true));
        this.skipSC();
        this.eat((0, $cb01acaf2e18d562$export$773d33972c6279ed));
    }
    return {
        type: 'Scope',
        loc: this.getLocation(startOffset, this.tokenStart),
        root: root,
        limit: limit
    };
}
function $5de80a7b15a6bf26$export$80d376111cc09ad7(node) {
    if (node.root) {
        this.token((0, $cb01acaf2e18d562$export$b5a25f132cb53de6), '(');
        this.node(node.root);
        this.token((0, $cb01acaf2e18d562$export$773d33972c6279ed), ')');
    }
    if (node.limit) {
        this.token((0, $cb01acaf2e18d562$export$331e9b6bdecaac5f), 'to');
        this.token((0, $cb01acaf2e18d562$export$b5a25f132cb53de6), '(');
        this.node(node.limit);
        this.token((0, $cb01acaf2e18d562$export$773d33972c6279ed), ')');
    }
}


var $9ccfeb24f689dd94$exports = {};

$parcel$export($9ccfeb24f689dd94$exports, "name", function () { return $9ccfeb24f689dd94$export$a8ff84c12d48cfa6; });
$parcel$export($9ccfeb24f689dd94$exports, "structure", function () { return $9ccfeb24f689dd94$export$46a2a563c28afca0; });
$parcel$export($9ccfeb24f689dd94$exports, "parse", function () { return $9ccfeb24f689dd94$export$98e6a39c04603d36; });
$parcel$export($9ccfeb24f689dd94$exports, "generate", function () { return $9ccfeb24f689dd94$export$80d376111cc09ad7; });
const $9ccfeb24f689dd94$export$a8ff84c12d48cfa6 = 'Selector';
const $9ccfeb24f689dd94$export$46a2a563c28afca0 = {
    children: [
        [
            'TypeSelector',
            'IdSelector',
            'ClassSelector',
            'AttributeSelector',
            'PseudoClassSelector',
            'PseudoElementSelector',
            'Combinator'
        ]
    ]
};
function $9ccfeb24f689dd94$export$98e6a39c04603d36() {
    const children = this.readSequence(this.scope.Selector);
    // nothing were consumed
    if (this.getFirstListNode(children) === null) this.error('Selector is expected');
    return {
        type: 'Selector',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $9ccfeb24f689dd94$export$80d376111cc09ad7(node) {
    this.children(node);
}


var $e09b6562adad0054$exports = {};

$parcel$export($e09b6562adad0054$exports, "name", function () { return $e09b6562adad0054$export$a8ff84c12d48cfa6; });
$parcel$export($e09b6562adad0054$exports, "walkContext", function () { return $e09b6562adad0054$export$f7e0bb689fefb8c2; });
$parcel$export($e09b6562adad0054$exports, "structure", function () { return $e09b6562adad0054$export$46a2a563c28afca0; });
$parcel$export($e09b6562adad0054$exports, "parse", function () { return $e09b6562adad0054$export$98e6a39c04603d36; });
$parcel$export($e09b6562adad0054$exports, "generate", function () { return $e09b6562adad0054$export$80d376111cc09ad7; });

const $e09b6562adad0054$export$a8ff84c12d48cfa6 = 'SelectorList';
const $e09b6562adad0054$export$f7e0bb689fefb8c2 = 'selector';
const $e09b6562adad0054$export$46a2a563c28afca0 = {
    children: [
        [
            'Selector',
            'Raw'
        ]
    ]
};
function $e09b6562adad0054$export$98e6a39c04603d36() {
    const children = this.createList();
    while(!this.eof){
        children.push(this.Selector());
        if (this.tokenType === (0, $cb01acaf2e18d562$export$c06e3ee3b4d233fa)) {
            this.next();
            continue;
        }
        break;
    }
    return {
        type: 'SelectorList',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $e09b6562adad0054$export$80d376111cc09ad7(node) {
    this.children(node, ()=>this.token((0, $cb01acaf2e18d562$export$c06e3ee3b4d233fa), ','));
}


var $17d46c820b4ef3bc$exports = {};

$parcel$export($17d46c820b4ef3bc$exports, "name", function () { return $17d46c820b4ef3bc$export$a8ff84c12d48cfa6; });
$parcel$export($17d46c820b4ef3bc$exports, "structure", function () { return $17d46c820b4ef3bc$export$46a2a563c28afca0; });
$parcel$export($17d46c820b4ef3bc$exports, "parse", function () { return $17d46c820b4ef3bc$export$98e6a39c04603d36; });
$parcel$export($17d46c820b4ef3bc$exports, "generate", function () { return $17d46c820b4ef3bc$export$80d376111cc09ad7; });


const $8d973eb24389889b$var$REVERSE_SOLIDUS = 0x005c; // U+005C REVERSE SOLIDUS (\)
const $8d973eb24389889b$var$QUOTATION_MARK = 0x0022; // "
const $8d973eb24389889b$var$APOSTROPHE = 0x0027; // '
function $8d973eb24389889b$export$2f872c0f2117be69(str) {
    const len = str.length;
    const firstChar = str.charCodeAt(0);
    const start = firstChar === $8d973eb24389889b$var$QUOTATION_MARK || firstChar === $8d973eb24389889b$var$APOSTROPHE ? 1 : 0;
    const end = start === 1 && len > 1 && str.charCodeAt(len - 1) === firstChar ? len - 2 : len - 1;
    let decoded = '';
    for(let i = start; i <= end; i++){
        let code = str.charCodeAt(i);
        if (code === $8d973eb24389889b$var$REVERSE_SOLIDUS) {
            // special case at the ending
            if (i === end) {
                // if the next input code point is EOF, do nothing
                // otherwise include last quote as escaped
                if (i !== len - 1) decoded = str.substr(i + 1);
                break;
            }
            code = str.charCodeAt(++i);
            // consume escaped
            if ((0, $fb47edd266a7fc33$export$352e2c1d24776bfb)($8d973eb24389889b$var$REVERSE_SOLIDUS, code)) {
                const escapeStart = i - 1;
                const escapeEnd = (0, $0a1ac1d130312a6d$export$1cf8ac3f090cf48a)(str, escapeStart);
                i = escapeEnd - 1;
                decoded += (0, $0a1ac1d130312a6d$export$5ed93187f4ce070a)(str.substring(escapeStart + 1, escapeEnd));
            } else // \r\n
            if (code === 0x000d && str.charCodeAt(i + 1) === 0x000a) i++;
        } else decoded += str[i];
    }
    return decoded;
}
function $8d973eb24389889b$export$c564cdbbe6da493(str, apostrophe) {
    const quote = apostrophe ? '\'' : '"';
    const quoteCode = apostrophe ? $8d973eb24389889b$var$APOSTROPHE : $8d973eb24389889b$var$QUOTATION_MARK;
    let encoded = '';
    let wsBeforeHexIsNeeded = false;
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        // If the character is NULL (U+0000), then the REPLACEMENT CHARACTER (U+FFFD).
        if (code === 0x0000) {
            encoded += '\uFFFD';
            continue;
        }
        // If the character is in the range [\1-\1f] (U+0001 to U+001F) or is U+007F,
        // the character escaped as code point.
        // Note: Do not compare with 0x0001 since 0x0000 is precessed before
        if (code <= 0x001f || code === 0x007F) {
            encoded += '\\' + code.toString(16);
            wsBeforeHexIsNeeded = true;
            continue;
        }
        // If the character is '"' (U+0022) or "\" (U+005C), the escaped character.
        if (code === quoteCode || code === $8d973eb24389889b$var$REVERSE_SOLIDUS) {
            encoded += '\\' + str.charAt(i);
            wsBeforeHexIsNeeded = false;
        } else {
            if (wsBeforeHexIsNeeded && ((0, $fb47edd266a7fc33$export$2a81dc4d1a2f9334)(code) || (0, $fb47edd266a7fc33$export$3c52dd84024ae72c)(code))) encoded += ' ';
            // Otherwise, the character itself.
            encoded += str.charAt(i);
            wsBeforeHexIsNeeded = false;
        }
    }
    return quote + encoded + quote;
}


const $17d46c820b4ef3bc$export$a8ff84c12d48cfa6 = 'String';
const $17d46c820b4ef3bc$export$46a2a563c28afca0 = {
    value: String
};
function $17d46c820b4ef3bc$export$98e6a39c04603d36() {
    return {
        type: 'String',
        loc: this.getLocation(this.tokenStart, this.tokenEnd),
        value: (0, $8d973eb24389889b$export$2f872c0f2117be69)(this.consume((0, $cb01acaf2e18d562$export$89b8e0fa65f6a914)))
    };
}
function $17d46c820b4ef3bc$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$89b8e0fa65f6a914), (0, $8d973eb24389889b$export$c564cdbbe6da493)(node.value));
}


var $090f301751be1b14$exports = {};

$parcel$export($090f301751be1b14$exports, "name", function () { return $090f301751be1b14$export$a8ff84c12d48cfa6; });
$parcel$export($090f301751be1b14$exports, "walkContext", function () { return $090f301751be1b14$export$f7e0bb689fefb8c2; });
$parcel$export($090f301751be1b14$exports, "structure", function () { return $090f301751be1b14$export$46a2a563c28afca0; });
$parcel$export($090f301751be1b14$exports, "parse", function () { return $090f301751be1b14$export$98e6a39c04603d36; });
$parcel$export($090f301751be1b14$exports, "generate", function () { return $090f301751be1b14$export$80d376111cc09ad7; });

const $090f301751be1b14$var$EXCLAMATIONMARK = 0x0021; // U+0021 EXCLAMATION MARK (!)
function $090f301751be1b14$var$consumeRaw() {
    return this.Raw(null, false);
}
const $090f301751be1b14$export$a8ff84c12d48cfa6 = 'StyleSheet';
const $090f301751be1b14$export$f7e0bb689fefb8c2 = 'stylesheet';
const $090f301751be1b14$export$46a2a563c28afca0 = {
    children: [
        [
            'Comment',
            'CDO',
            'CDC',
            'Atrule',
            'Rule',
            'Raw'
        ]
    ]
};
function $090f301751be1b14$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    const children = this.createList();
    let child;
    scan: while(!this.eof){
        switch(this.tokenType){
            case 0, $cb01acaf2e18d562$export$fb98946286ab4c97:
                this.next();
                continue;
            case 0, $cb01acaf2e18d562$export$4d299b491347818a:
                // ignore comments except exclamation comments (i.e. /*! .. */) on top level
                if (this.charCodeAt(this.tokenStart + 2) !== $090f301751be1b14$var$EXCLAMATIONMARK) {
                    this.next();
                    continue;
                }
                child = this.Comment();
                break;
            case 0, $cb01acaf2e18d562$export$521ef26a3002003b:
                child = this.CDO();
                break;
            case 0, $cb01acaf2e18d562$export$b0b2bd2d1777c179:
                child = this.CDC();
                break;
            // CSS Syntax Module Level 3
            // §2.2 Error handling
            // At the "top level" of a stylesheet, an <at-keyword-token> starts an at-rule.
            case 0, $cb01acaf2e18d562$export$21bfcb60d1b5ccac:
                child = this.parseWithFallback(this.Atrule, $090f301751be1b14$var$consumeRaw);
                break;
            // Anything else starts a qualified rule ...
            default:
                child = this.parseWithFallback(this.Rule, $090f301751be1b14$var$consumeRaw);
        }
        children.push(child);
    }
    return {
        type: 'StyleSheet',
        loc: this.getLocation(start, this.tokenStart),
        children: children
    };
}
function $090f301751be1b14$export$80d376111cc09ad7(node) {
    this.children(node);
}


var $8cafbe4e6566c6b0$exports = {};

$parcel$export($8cafbe4e6566c6b0$exports, "name", function () { return $8cafbe4e6566c6b0$export$a8ff84c12d48cfa6; });
$parcel$export($8cafbe4e6566c6b0$exports, "structure", function () { return $8cafbe4e6566c6b0$export$46a2a563c28afca0; });
$parcel$export($8cafbe4e6566c6b0$exports, "parse", function () { return $8cafbe4e6566c6b0$export$98e6a39c04603d36; });
$parcel$export($8cafbe4e6566c6b0$exports, "generate", function () { return $8cafbe4e6566c6b0$export$80d376111cc09ad7; });

const $8cafbe4e6566c6b0$export$a8ff84c12d48cfa6 = 'SupportsDeclaration';
const $8cafbe4e6566c6b0$export$46a2a563c28afca0 = {
    declaration: 'Declaration'
};
function $8cafbe4e6566c6b0$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    this.eat((0, $cb01acaf2e18d562$export$b5a25f132cb53de6));
    this.skipSC();
    const declaration = this.Declaration();
    if (!this.eof) this.eat((0, $cb01acaf2e18d562$export$773d33972c6279ed));
    return {
        type: 'SupportsDeclaration',
        loc: this.getLocation(start, this.tokenStart),
        declaration: declaration
    };
}
function $8cafbe4e6566c6b0$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$b5a25f132cb53de6), '(');
    this.node(node.declaration);
    this.token((0, $cb01acaf2e18d562$export$773d33972c6279ed), ')');
}


var $06e99d3dcf0b0856$exports = {};

$parcel$export($06e99d3dcf0b0856$exports, "name", function () { return $06e99d3dcf0b0856$export$a8ff84c12d48cfa6; });
$parcel$export($06e99d3dcf0b0856$exports, "structure", function () { return $06e99d3dcf0b0856$export$46a2a563c28afca0; });
$parcel$export($06e99d3dcf0b0856$exports, "parse", function () { return $06e99d3dcf0b0856$export$98e6a39c04603d36; });
$parcel$export($06e99d3dcf0b0856$exports, "generate", function () { return $06e99d3dcf0b0856$export$80d376111cc09ad7; });

const $06e99d3dcf0b0856$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $06e99d3dcf0b0856$var$VERTICALLINE = 0x007C; // U+007C VERTICAL LINE (|)
function $06e99d3dcf0b0856$var$eatIdentifierOrAsterisk() {
    if (this.tokenType !== (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f) && this.isDelim($06e99d3dcf0b0856$var$ASTERISK) === false) this.error('Identifier or asterisk is expected');
    this.next();
}
const $06e99d3dcf0b0856$export$a8ff84c12d48cfa6 = 'TypeSelector';
const $06e99d3dcf0b0856$export$46a2a563c28afca0 = {
    name: String
};
function $06e99d3dcf0b0856$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    if (this.isDelim($06e99d3dcf0b0856$var$VERTICALLINE)) {
        this.next();
        $06e99d3dcf0b0856$var$eatIdentifierOrAsterisk.call(this);
    } else {
        $06e99d3dcf0b0856$var$eatIdentifierOrAsterisk.call(this);
        if (this.isDelim($06e99d3dcf0b0856$var$VERTICALLINE)) {
            this.next();
            $06e99d3dcf0b0856$var$eatIdentifierOrAsterisk.call(this);
        }
    }
    return {
        type: 'TypeSelector',
        loc: this.getLocation(start, this.tokenStart),
        name: this.substrToCursor(start)
    };
}
function $06e99d3dcf0b0856$export$80d376111cc09ad7(node) {
    this.tokenize(node.name);
}


var $04ee15830f72d29f$exports = {};

$parcel$export($04ee15830f72d29f$exports, "name", function () { return $04ee15830f72d29f$export$a8ff84c12d48cfa6; });
$parcel$export($04ee15830f72d29f$exports, "structure", function () { return $04ee15830f72d29f$export$46a2a563c28afca0; });
$parcel$export($04ee15830f72d29f$exports, "parse", function () { return $04ee15830f72d29f$export$98e6a39c04603d36; });
$parcel$export($04ee15830f72d29f$exports, "generate", function () { return $04ee15830f72d29f$export$80d376111cc09ad7; });

const $04ee15830f72d29f$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $04ee15830f72d29f$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $04ee15830f72d29f$var$QUESTIONMARK = 0x003F; // U+003F QUESTION MARK (?)
function $04ee15830f72d29f$var$eatHexSequence(offset, allowDash) {
    let len = 0;
    for(let pos = this.tokenStart + offset; pos < this.tokenEnd; pos++){
        const code = this.charCodeAt(pos);
        if (code === $04ee15830f72d29f$var$HYPHENMINUS && allowDash && len !== 0) {
            $04ee15830f72d29f$var$eatHexSequence.call(this, offset + len + 1, false);
            return -1;
        }
        if (!(0, $fb47edd266a7fc33$export$2a81dc4d1a2f9334)(code)) this.error(allowDash && len !== 0 ? 'Hyphen minus' + (len < 6 ? ' or hex digit' : '') + ' is expected' : len < 6 ? 'Hex digit is expected' : 'Unexpected input', pos);
        if (++len > 6) this.error('Too many hex digits', pos);
    }
    this.next();
    return len;
}
function $04ee15830f72d29f$var$eatQuestionMarkSequence(max) {
    let count = 0;
    while(this.isDelim($04ee15830f72d29f$var$QUESTIONMARK)){
        if (++count > max) this.error('Too many question marks');
        this.next();
    }
}
function $04ee15830f72d29f$var$startsWith(code) {
    if (this.charCodeAt(this.tokenStart) !== code) this.error((code === $04ee15830f72d29f$var$PLUSSIGN ? 'Plus sign' : 'Hyphen minus') + ' is expected');
}
// https://drafts.csswg.org/css-syntax/#urange
// Informally, the <urange> production has three forms:
// U+0001
//      Defines a range consisting of a single code point, in this case the code point "1".
// U+0001-00ff
//      Defines a range of codepoints between the first and the second value, in this case
//      the range between "1" and "ff" (255 in decimal) inclusive.
// U+00??
//      Defines a range of codepoints where the "?" characters range over all hex digits,
//      in this case defining the same as the value U+0000-00ff.
// In each form, a maximum of 6 digits is allowed for each hexadecimal number (if you treat "?" as a hexadecimal digit).
//
// <urange> =
//   u '+' <ident-token> '?'* |
//   u <dimension-token> '?'* |
//   u <number-token> '?'* |
//   u <number-token> <dimension-token> |
//   u <number-token> <number-token> |
//   u '+' '?'+
function $04ee15830f72d29f$var$scanUnicodeRange() {
    let hexLength = 0;
    switch(this.tokenType){
        case 0, $cb01acaf2e18d562$export$fffa67e515d04022:
            // u <number-token> '?'*
            // u <number-token> <dimension-token>
            // u <number-token> <number-token>
            hexLength = $04ee15830f72d29f$var$eatHexSequence.call(this, 1, true);
            if (this.isDelim($04ee15830f72d29f$var$QUESTIONMARK)) {
                $04ee15830f72d29f$var$eatQuestionMarkSequence.call(this, 6 - hexLength);
                break;
            }
            if (this.tokenType === (0, $cb01acaf2e18d562$export$c940ece961bc43c6) || this.tokenType === (0, $cb01acaf2e18d562$export$fffa67e515d04022)) {
                $04ee15830f72d29f$var$startsWith.call(this, $04ee15830f72d29f$var$HYPHENMINUS);
                $04ee15830f72d29f$var$eatHexSequence.call(this, 1, false);
                break;
            }
            break;
        case 0, $cb01acaf2e18d562$export$c940ece961bc43c6:
            // u <dimension-token> '?'*
            hexLength = $04ee15830f72d29f$var$eatHexSequence.call(this, 1, true);
            if (hexLength > 0) $04ee15830f72d29f$var$eatQuestionMarkSequence.call(this, 6 - hexLength);
            break;
        default:
            // u '+' <ident-token> '?'*
            // u '+' '?'+
            this.eatDelim($04ee15830f72d29f$var$PLUSSIGN);
            if (this.tokenType === (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)) {
                hexLength = $04ee15830f72d29f$var$eatHexSequence.call(this, 0, true);
                if (hexLength > 0) $04ee15830f72d29f$var$eatQuestionMarkSequence.call(this, 6 - hexLength);
                break;
            }
            if (this.isDelim($04ee15830f72d29f$var$QUESTIONMARK)) {
                this.next();
                $04ee15830f72d29f$var$eatQuestionMarkSequence.call(this, 5);
                break;
            }
            this.error('Hex digit or question mark is expected');
    }
}
const $04ee15830f72d29f$export$a8ff84c12d48cfa6 = 'UnicodeRange';
const $04ee15830f72d29f$export$46a2a563c28afca0 = {
    value: String
};
function $04ee15830f72d29f$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    // U or u
    this.eatIdent('u');
    $04ee15830f72d29f$var$scanUnicodeRange.call(this);
    return {
        type: 'UnicodeRange',
        loc: this.getLocation(start, this.tokenStart),
        value: this.substrToCursor(start)
    };
}
function $04ee15830f72d29f$export$80d376111cc09ad7(node) {
    this.tokenize(node.value);
}


var $c3203ce20adbeef5$exports = {};

$parcel$export($c3203ce20adbeef5$exports, "name", function () { return $c3203ce20adbeef5$export$a8ff84c12d48cfa6; });
$parcel$export($c3203ce20adbeef5$exports, "structure", function () { return $c3203ce20adbeef5$export$46a2a563c28afca0; });
$parcel$export($c3203ce20adbeef5$exports, "parse", function () { return $c3203ce20adbeef5$export$98e6a39c04603d36; });
$parcel$export($c3203ce20adbeef5$exports, "generate", function () { return $c3203ce20adbeef5$export$80d376111cc09ad7; });

const $02d14c513bb6fe46$var$SPACE = 0x0020; // U+0020 SPACE
const $02d14c513bb6fe46$var$REVERSE_SOLIDUS = 0x005c; // U+005C REVERSE SOLIDUS (\)
const $02d14c513bb6fe46$var$QUOTATION_MARK = 0x0022; // "
const $02d14c513bb6fe46$var$APOSTROPHE = 0x0027; // '
const $02d14c513bb6fe46$var$LEFTPARENTHESIS = 0x0028; // U+0028 LEFT PARENTHESIS (()
const $02d14c513bb6fe46$var$RIGHTPARENTHESIS = 0x0029; // U+0029 RIGHT PARENTHESIS ())
function $02d14c513bb6fe46$export$2f872c0f2117be69(str) {
    const len = str.length;
    let start = 4; // length of "url("
    let end = str.charCodeAt(len - 1) === $02d14c513bb6fe46$var$RIGHTPARENTHESIS ? len - 2 : len - 1;
    let decoded = '';
    while(start < end && (0, $fb47edd266a7fc33$export$3c52dd84024ae72c)(str.charCodeAt(start)))start++;
    while(start < end && (0, $fb47edd266a7fc33$export$3c52dd84024ae72c)(str.charCodeAt(end)))end--;
    for(let i = start; i <= end; i++){
        let code = str.charCodeAt(i);
        if (code === $02d14c513bb6fe46$var$REVERSE_SOLIDUS) {
            // special case at the ending
            if (i === end) {
                // if the next input code point is EOF, do nothing
                // otherwise include last left parenthesis as escaped
                if (i !== len - 1) decoded = str.substr(i + 1);
                break;
            }
            code = str.charCodeAt(++i);
            // consume escaped
            if ((0, $fb47edd266a7fc33$export$352e2c1d24776bfb)($02d14c513bb6fe46$var$REVERSE_SOLIDUS, code)) {
                const escapeStart = i - 1;
                const escapeEnd = (0, $0a1ac1d130312a6d$export$1cf8ac3f090cf48a)(str, escapeStart);
                i = escapeEnd - 1;
                decoded += (0, $0a1ac1d130312a6d$export$5ed93187f4ce070a)(str.substring(escapeStart + 1, escapeEnd));
            } else // \r\n
            if (code === 0x000d && str.charCodeAt(i + 1) === 0x000a) i++;
        } else decoded += str[i];
    }
    return decoded;
}
function $02d14c513bb6fe46$export$c564cdbbe6da493(str) {
    let encoded = '';
    let wsBeforeHexIsNeeded = false;
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        // If the character is NULL (U+0000), then the REPLACEMENT CHARACTER (U+FFFD).
        if (code === 0x0000) {
            encoded += '\uFFFD';
            continue;
        }
        // If the character is in the range [\1-\1f] (U+0001 to U+001F) or is U+007F,
        // the character escaped as code point.
        // Note: Do not compare with 0x0001 since 0x0000 is precessed before
        if (code <= 0x001f || code === 0x007F) {
            encoded += '\\' + code.toString(16);
            wsBeforeHexIsNeeded = true;
            continue;
        }
        if (code === $02d14c513bb6fe46$var$SPACE || code === $02d14c513bb6fe46$var$REVERSE_SOLIDUS || code === $02d14c513bb6fe46$var$QUOTATION_MARK || code === $02d14c513bb6fe46$var$APOSTROPHE || code === $02d14c513bb6fe46$var$LEFTPARENTHESIS || code === $02d14c513bb6fe46$var$RIGHTPARENTHESIS) {
            encoded += '\\' + str.charAt(i);
            wsBeforeHexIsNeeded = false;
        } else {
            if (wsBeforeHexIsNeeded && (0, $fb47edd266a7fc33$export$2a81dc4d1a2f9334)(code)) encoded += ' ';
            encoded += str.charAt(i);
            wsBeforeHexIsNeeded = false;
        }
    }
    return 'url(' + encoded + ')';
}




const $c3203ce20adbeef5$export$a8ff84c12d48cfa6 = 'Url';
const $c3203ce20adbeef5$export$46a2a563c28afca0 = {
    value: String
};
function $c3203ce20adbeef5$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    let value;
    switch(this.tokenType){
        case 0, $cb01acaf2e18d562$export$59d795186a5d3f58:
            value = $02d14c513bb6fe46$export$2f872c0f2117be69(this.consume((0, $cb01acaf2e18d562$export$59d795186a5d3f58)));
            break;
        case 0, $cb01acaf2e18d562$export$f3890eeaf6851387:
            if (!this.cmpStr(this.tokenStart, this.tokenEnd, 'url(')) this.error('Function name must be `url`');
            this.eat((0, $cb01acaf2e18d562$export$f3890eeaf6851387));
            this.skipSC();
            value = $8d973eb24389889b$export$2f872c0f2117be69(this.consume((0, $cb01acaf2e18d562$export$89b8e0fa65f6a914)));
            this.skipSC();
            if (!this.eof) this.eat((0, $cb01acaf2e18d562$export$773d33972c6279ed));
            break;
        default:
            this.error('Url or Function is expected');
    }
    return {
        type: 'Url',
        loc: this.getLocation(start, this.tokenStart),
        value: value
    };
}
function $c3203ce20adbeef5$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$59d795186a5d3f58), $02d14c513bb6fe46$export$c564cdbbe6da493(node.value));
}


var $883cb73761c43b47$exports = {};

$parcel$export($883cb73761c43b47$exports, "name", function () { return $883cb73761c43b47$export$a8ff84c12d48cfa6; });
$parcel$export($883cb73761c43b47$exports, "structure", function () { return $883cb73761c43b47$export$46a2a563c28afca0; });
$parcel$export($883cb73761c43b47$exports, "parse", function () { return $883cb73761c43b47$export$98e6a39c04603d36; });
$parcel$export($883cb73761c43b47$exports, "generate", function () { return $883cb73761c43b47$export$80d376111cc09ad7; });
const $883cb73761c43b47$export$a8ff84c12d48cfa6 = 'Value';
const $883cb73761c43b47$export$46a2a563c28afca0 = {
    children: [
        []
    ]
};
function $883cb73761c43b47$export$98e6a39c04603d36() {
    const start = this.tokenStart;
    const children = this.readSequence(this.scope.Value);
    return {
        type: 'Value',
        loc: this.getLocation(start, this.tokenStart),
        children: children
    };
}
function $883cb73761c43b47$export$80d376111cc09ad7(node) {
    this.children(node);
}


var $5da1a48d15cdd86d$exports = {};

$parcel$export($5da1a48d15cdd86d$exports, "name", function () { return $5da1a48d15cdd86d$export$a8ff84c12d48cfa6; });
$parcel$export($5da1a48d15cdd86d$exports, "structure", function () { return $5da1a48d15cdd86d$export$46a2a563c28afca0; });
$parcel$export($5da1a48d15cdd86d$exports, "parse", function () { return $5da1a48d15cdd86d$export$98e6a39c04603d36; });
$parcel$export($5da1a48d15cdd86d$exports, "generate", function () { return $5da1a48d15cdd86d$export$80d376111cc09ad7; });

const $5da1a48d15cdd86d$var$SPACE = Object.freeze({
    type: 'WhiteSpace',
    loc: null,
    value: ' '
});
const $5da1a48d15cdd86d$export$a8ff84c12d48cfa6 = 'WhiteSpace';
const $5da1a48d15cdd86d$export$46a2a563c28afca0 = {
    value: String
};
function $5da1a48d15cdd86d$export$98e6a39c04603d36() {
    this.eat((0, $cb01acaf2e18d562$export$fb98946286ab4c97));
    return $5da1a48d15cdd86d$var$SPACE;
// return {
//     type: 'WhiteSpace',
//     loc: this.getLocation(this.tokenStart, this.tokenEnd),
//     value: this.consume(WHITESPACE)
// };
}
function $5da1a48d15cdd86d$export$80d376111cc09ad7(node) {
    this.token((0, $cb01acaf2e18d562$export$fb98946286ab4c97), node.value);
}




var $0eefb1e5df616809$export$2e2bcd8739ae039 = {
    generic: true,
    cssWideKeywords: $42c1285c91ce4121$export$b3191e0d9e666e2c,
    ...(0, $3a03e93b9ed04fd8$export$2e2bcd8739ae039),
    node: $fb10b100396c91c1$exports
};


var $8df18fe246ea8d62$exports = {};

$parcel$export($8df18fe246ea8d62$exports, "AtrulePrelude", function () { return $fb63838ab27974e0$export$2e2bcd8739ae039; });
$parcel$export($8df18fe246ea8d62$exports, "Selector", function () { return $1b7a7619fab0fa56$export$2e2bcd8739ae039; });
$parcel$export($8df18fe246ea8d62$exports, "Value", function () { return $f4fabaac159c2db0$export$2e2bcd8739ae039; });

const $39ed68d7940e7d89$var$NUMBERSIGN = 0x0023; // U+0023 NUMBER SIGN (#)
const $39ed68d7940e7d89$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $39ed68d7940e7d89$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $39ed68d7940e7d89$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $39ed68d7940e7d89$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $39ed68d7940e7d89$var$U = 0x0075; // U+0075 LATIN SMALL LETTER U (u)
function $39ed68d7940e7d89$export$2e2bcd8739ae039(context) {
    switch(this.tokenType){
        case 0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd:
            return this.Hash();
        case 0, $cb01acaf2e18d562$export$c06e3ee3b4d233fa:
            return this.Operator();
        case 0, $cb01acaf2e18d562$export$b5a25f132cb53de6:
            return this.Parentheses(this.readSequence, context.recognizer);
        case 0, $cb01acaf2e18d562$export$cd363bb53c2bb:
            return this.Brackets(this.readSequence, context.recognizer);
        case 0, $cb01acaf2e18d562$export$89b8e0fa65f6a914:
            return this.String();
        case 0, $cb01acaf2e18d562$export$c940ece961bc43c6:
            return this.Dimension();
        case 0, $cb01acaf2e18d562$export$d11913f8a6922aea:
            return this.Percentage();
        case 0, $cb01acaf2e18d562$export$fffa67e515d04022:
            return this.Number();
        case 0, $cb01acaf2e18d562$export$f3890eeaf6851387:
            return this.cmpStr(this.tokenStart, this.tokenEnd, 'url(') ? this.Url() : this.Function(this.readSequence, context.recognizer);
        case 0, $cb01acaf2e18d562$export$59d795186a5d3f58:
            return this.Url();
        case 0, $cb01acaf2e18d562$export$331e9b6bdecaac5f:
            // check for unicode range, it should start with u+ or U+
            if (this.cmpChar(this.tokenStart, $39ed68d7940e7d89$var$U) && this.cmpChar(this.tokenStart + 1, $39ed68d7940e7d89$var$PLUSSIGN)) return this.UnicodeRange();
            else return this.Identifier();
        case 0, $cb01acaf2e18d562$export$a918ca49ff4337a3:
            {
                const code = this.charCodeAt(this.tokenStart);
                if (code === $39ed68d7940e7d89$var$SOLIDUS || code === $39ed68d7940e7d89$var$ASTERISK || code === $39ed68d7940e7d89$var$PLUSSIGN || code === $39ed68d7940e7d89$var$HYPHENMINUS) return this.Operator(); // TODO: replace with Delim
                // TODO: produce a node with Delim node type
                if (code === $39ed68d7940e7d89$var$NUMBERSIGN) this.error('Hex or identifier is expected', this.tokenStart + 1);
                break;
            }
    }
}


var $fb63838ab27974e0$export$2e2bcd8739ae039 = {
    getNode: $39ed68d7940e7d89$export$2e2bcd8739ae039
};



const $1b7a7619fab0fa56$var$NUMBERSIGN = 0x0023; // U+0023 NUMBER SIGN (#)
const $1b7a7619fab0fa56$var$AMPERSAND = 0x0026; // U+0026 AMPERSAND (&)
const $1b7a7619fab0fa56$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $1b7a7619fab0fa56$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $1b7a7619fab0fa56$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $1b7a7619fab0fa56$var$FULLSTOP = 0x002E; // U+002E FULL STOP (.)
const $1b7a7619fab0fa56$var$GREATERTHANSIGN = 0x003E; // U+003E GREATER-THAN SIGN (>)
const $1b7a7619fab0fa56$var$VERTICALLINE = 0x007C; // U+007C VERTICAL LINE (|)
const $1b7a7619fab0fa56$var$TILDE = 0x007E; // U+007E TILDE (~)
function $1b7a7619fab0fa56$var$onWhiteSpace(next, children) {
    if (children.last !== null && children.last.type !== 'Combinator' && next !== null && next.type !== 'Combinator') children.push({
        type: 'Combinator',
        loc: null,
        name: ' '
    });
}
function $1b7a7619fab0fa56$var$getNode() {
    switch(this.tokenType){
        case 0, $cb01acaf2e18d562$export$cd363bb53c2bb:
            return this.AttributeSelector();
        case 0, $cb01acaf2e18d562$export$ab85ecd77ce6a5cd:
            return this.IdSelector();
        case 0, $cb01acaf2e18d562$export$e20ebb298016f6:
            if (this.lookupType(1) === (0, $cb01acaf2e18d562$export$e20ebb298016f6)) return this.PseudoElementSelector();
            else return this.PseudoClassSelector();
        case 0, $cb01acaf2e18d562$export$331e9b6bdecaac5f:
            return this.TypeSelector();
        case 0, $cb01acaf2e18d562$export$fffa67e515d04022:
        case 0, $cb01acaf2e18d562$export$d11913f8a6922aea:
            return this.Percentage();
        case 0, $cb01acaf2e18d562$export$c940ece961bc43c6:
            // throws when .123ident
            if (this.charCodeAt(this.tokenStart) === $1b7a7619fab0fa56$var$FULLSTOP) this.error('Identifier is expected', this.tokenStart + 1);
            break;
        case 0, $cb01acaf2e18d562$export$a918ca49ff4337a3:
            {
                const code = this.charCodeAt(this.tokenStart);
                switch(code){
                    case $1b7a7619fab0fa56$var$PLUSSIGN:
                    case $1b7a7619fab0fa56$var$GREATERTHANSIGN:
                    case $1b7a7619fab0fa56$var$TILDE:
                    case $1b7a7619fab0fa56$var$SOLIDUS:
                        return this.Combinator();
                    case $1b7a7619fab0fa56$var$FULLSTOP:
                        return this.ClassSelector();
                    case $1b7a7619fab0fa56$var$ASTERISK:
                    case $1b7a7619fab0fa56$var$VERTICALLINE:
                        return this.TypeSelector();
                    case $1b7a7619fab0fa56$var$NUMBERSIGN:
                        return this.IdSelector();
                    case $1b7a7619fab0fa56$var$AMPERSAND:
                        return this.NestingSelector();
                }
                break;
            }
    }
}
var $1b7a7619fab0fa56$export$2e2bcd8739ae039 = {
    onWhiteSpace: $1b7a7619fab0fa56$var$onWhiteSpace,
    getNode: $1b7a7619fab0fa56$var$getNode
};



// legacy IE function
// expression( <any-value> )
function $e8bebc061dfcb0e9$export$2e2bcd8739ae039() {
    return this.createSingleNodeList(this.Raw(null, false));
}



function $8dadf8e991c94fa4$export$2e2bcd8739ae039() {
    const children = this.createList();
    this.skipSC();
    // NOTE: Don't check more than a first argument is an ident, rest checks are for lexer
    children.push(this.Identifier());
    this.skipSC();
    if (this.tokenType === (0, $cb01acaf2e18d562$export$c06e3ee3b4d233fa)) {
        children.push(this.Operator());
        const startIndex = this.tokenIndex;
        const value = this.parseCustomProperty ? this.Value(null) : this.Raw(this.consumeUntilExclamationMarkOrSemicolon, false);
        if (value.type === 'Value' && value.children.isEmpty) {
            for(let offset = startIndex - this.tokenIndex; offset <= 0; offset++)if (this.lookupType(offset) === (0, $cb01acaf2e18d562$export$fb98946286ab4c97)) {
                value.children.appendData({
                    type: 'WhiteSpace',
                    loc: null,
                    value: ' '
                });
                break;
            }
        }
        children.push(value);
    }
    return children;
}


function $f4fabaac159c2db0$var$isPlusMinusOperator(node) {
    return node !== null && node.type === 'Operator' && (node.value[node.value.length - 1] === '-' || node.value[node.value.length - 1] === '+');
}
var $f4fabaac159c2db0$export$2e2bcd8739ae039 = {
    getNode: $39ed68d7940e7d89$export$2e2bcd8739ae039,
    onWhiteSpace (next, children) {
        if ($f4fabaac159c2db0$var$isPlusMinusOperator(next)) next.value = ' ' + next.value;
        if ($f4fabaac159c2db0$var$isPlusMinusOperator(children.last)) children.last.value += ' ';
    },
    'expression': (0, $e8bebc061dfcb0e9$export$2e2bcd8739ae039),
    'var': (0, $8dadf8e991c94fa4$export$2e2bcd8739ae039)
};





// https://drafts.csswg.org/css-contain-3/#container-rule
// The keywords `none`, `and`, `not`, and `or` are excluded from the <custom-ident> above.
const $0e975e280bc2ab3b$var$nonContainerNameKeywords = new Set([
    'none',
    'and',
    'not',
    'or'
]);
var $0e975e280bc2ab3b$export$2e2bcd8739ae039 = {
    parse: {
        prelude () {
            const children = this.createList();
            if (this.tokenType === (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f)) {
                const name = this.substring(this.tokenStart, this.tokenEnd);
                if (!$0e975e280bc2ab3b$var$nonContainerNameKeywords.has(name.toLowerCase())) children.push(this.Identifier());
            }
            children.push(this.Condition('container'));
            return children;
        },
        block (nested = false) {
            return this.Block(nested);
        }
    }
};


var $55b298ae47821c48$export$2e2bcd8739ae039 = {
    parse: {
        prelude: null,
        block () {
            return this.Block(true);
        }
    }
};



function $cfd5c43535950498$var$parseWithFallback(parse, fallback) {
    return this.parseWithFallback(()=>{
        try {
            return parse.call(this);
        } finally{
            this.skipSC();
            if (this.lookupNonWSType(0) !== (0, $cb01acaf2e18d562$export$773d33972c6279ed)) this.error();
        }
    }, fallback || (()=>this.Raw(null, true)));
}
const $cfd5c43535950498$var$parseFunctions = {
    layer () {
        this.skipSC();
        const children = this.createList();
        const node = $cfd5c43535950498$var$parseWithFallback.call(this, this.Layer);
        if (node.type !== 'Raw' || node.value !== '') children.push(node);
        return children;
    },
    supports () {
        this.skipSC();
        const children = this.createList();
        const node = $cfd5c43535950498$var$parseWithFallback.call(this, this.Declaration, ()=>$cfd5c43535950498$var$parseWithFallback.call(this, ()=>this.Condition('supports')));
        if (node.type !== 'Raw' || node.value !== '') children.push(node);
        return children;
    }
};
var $cfd5c43535950498$export$2e2bcd8739ae039 = {
    parse: {
        prelude () {
            const children = this.createList();
            switch(this.tokenType){
                case 0, $cb01acaf2e18d562$export$89b8e0fa65f6a914:
                    children.push(this.String());
                    break;
                case 0, $cb01acaf2e18d562$export$59d795186a5d3f58:
                case 0, $cb01acaf2e18d562$export$f3890eeaf6851387:
                    children.push(this.Url());
                    break;
                default:
                    this.error('String or url() is expected');
            }
            this.skipSC();
            if (this.tokenType === (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f) && this.cmpStr(this.tokenStart, this.tokenEnd, 'layer')) children.push(this.Identifier());
            else if (this.tokenType === (0, $cb01acaf2e18d562$export$f3890eeaf6851387) && this.cmpStr(this.tokenStart, this.tokenEnd, 'layer(')) children.push(this.Function(null, $cfd5c43535950498$var$parseFunctions));
            this.skipSC();
            if (this.tokenType === (0, $cb01acaf2e18d562$export$f3890eeaf6851387) && this.cmpStr(this.tokenStart, this.tokenEnd, 'supports(')) children.push(this.Function(null, $cfd5c43535950498$var$parseFunctions));
            if (this.lookupNonWSType(0) === (0, $cb01acaf2e18d562$export$331e9b6bdecaac5f) || this.lookupNonWSType(0) === (0, $cb01acaf2e18d562$export$b5a25f132cb53de6)) children.push(this.MediaQueryList());
            return children;
        },
        block: null
    }
};


var $dabc54e7cc194a6f$export$2e2bcd8739ae039 = {
    parse: {
        prelude () {
            return this.createSingleNodeList(this.LayerList());
        },
        block () {
            return this.Block(false);
        }
    }
};


var $57ba7b49b6f375c6$export$2e2bcd8739ae039 = {
    parse: {
        prelude () {
            return this.createSingleNodeList(this.MediaQueryList());
        },
        block (nested = false) {
            return this.Block(nested);
        }
    }
};


var $3ce4baf557583411$export$2e2bcd8739ae039 = {
    parse: {
        prelude () {
            return this.createSingleNodeList(this.SelectorList());
        },
        block () {
            return this.Block(true);
        }
    }
};


var $8a3c7a4c7c69aab6$export$2e2bcd8739ae039 = {
    parse: {
        prelude () {
            return this.createSingleNodeList(this.SelectorList());
        },
        block () {
            return this.Block(true);
        }
    }
};


var $508b431f8908ab79$export$2e2bcd8739ae039 = {
    parse: {
        prelude () {
            return this.createSingleNodeList(this.Scope());
        },
        block (nested = false) {
            return this.Block(nested);
        }
    }
};


var $3bf1191f40d5db74$export$2e2bcd8739ae039 = {
    parse: {
        prelude: null,
        block (nested = false) {
            return this.Block(nested);
        }
    }
};


var $6bd36a5473ff28e7$export$2e2bcd8739ae039 = {
    parse: {
        prelude () {
            return this.createSingleNodeList(this.Condition('supports'));
        },
        block (nested = false) {
            return this.Block(nested);
        }
    }
};


var $3d9ba3e654596837$export$2e2bcd8739ae039 = {
    container: $0e975e280bc2ab3b$export$2e2bcd8739ae039,
    'font-face': (0, $55b298ae47821c48$export$2e2bcd8739ae039),
    import: (0, $cfd5c43535950498$export$2e2bcd8739ae039),
    layer: $dabc54e7cc194a6f$export$2e2bcd8739ae039,
    media: $57ba7b49b6f375c6$export$2e2bcd8739ae039,
    nest: $3ce4baf557583411$export$2e2bcd8739ae039,
    page: $8a3c7a4c7c69aab6$export$2e2bcd8739ae039,
    scope: $508b431f8908ab79$export$2e2bcd8739ae039,
    'starting-style': (0, $3bf1191f40d5db74$export$2e2bcd8739ae039),
    supports: $6bd36a5473ff28e7$export$2e2bcd8739ae039
};



function $f0de7324d824f4a4$export$b5311f7f48f77127() {
    const children = this.createList();
    this.skipSC();
    loop: while(!this.eof){
        switch(this.tokenType){
            case 0, $cb01acaf2e18d562$export$331e9b6bdecaac5f:
                children.push(this.Identifier());
                break;
            case 0, $cb01acaf2e18d562$export$89b8e0fa65f6a914:
                children.push(this.String());
                break;
            case 0, $cb01acaf2e18d562$export$c06e3ee3b4d233fa:
                children.push(this.Operator());
                break;
            case 0, $cb01acaf2e18d562$export$773d33972c6279ed:
                break loop;
            default:
                this.error('Identifier, string or comma is expected');
        }
        this.skipSC();
    }
    return children;
}


const $ce994a0bdbe0cd0e$var$selectorList = {
    parse () {
        return this.createSingleNodeList(this.SelectorList());
    }
};
const $ce994a0bdbe0cd0e$var$selector = {
    parse () {
        return this.createSingleNodeList(this.Selector());
    }
};
const $ce994a0bdbe0cd0e$var$identList = {
    parse () {
        return this.createSingleNodeList(this.Identifier());
    }
};
const $ce994a0bdbe0cd0e$var$langList = {
    parse: (0, $f0de7324d824f4a4$export$b5311f7f48f77127)
};
const $ce994a0bdbe0cd0e$var$nth = {
    parse () {
        return this.createSingleNodeList(this.Nth());
    }
};
var $ce994a0bdbe0cd0e$export$2e2bcd8739ae039 = {
    'dir': $ce994a0bdbe0cd0e$var$identList,
    'has': $ce994a0bdbe0cd0e$var$selectorList,
    'lang': $ce994a0bdbe0cd0e$var$langList,
    'matches': $ce994a0bdbe0cd0e$var$selectorList,
    'is': $ce994a0bdbe0cd0e$var$selectorList,
    '-moz-any': $ce994a0bdbe0cd0e$var$selectorList,
    '-webkit-any': $ce994a0bdbe0cd0e$var$selectorList,
    'where': $ce994a0bdbe0cd0e$var$selectorList,
    'not': $ce994a0bdbe0cd0e$var$selectorList,
    'nth-child': $ce994a0bdbe0cd0e$var$nth,
    'nth-last-child': $ce994a0bdbe0cd0e$var$nth,
    'nth-last-of-type': $ce994a0bdbe0cd0e$var$nth,
    'nth-of-type': $ce994a0bdbe0cd0e$var$nth,
    'slotted': $ce994a0bdbe0cd0e$var$selector,
    'host': $ce994a0bdbe0cd0e$var$selector,
    'host-context': $ce994a0bdbe0cd0e$var$selector
};


var $b47edf545ac3d326$exports = {};

$parcel$export($b47edf545ac3d326$exports, "AnPlusB", function () { return $a4232d2c86667a8b$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Atrule", function () { return $edab30309e484102$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "AtrulePrelude", function () { return $e0ba95883c90e8a1$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "AttributeSelector", function () { return $8e0620cbf0fd5e8c$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Block", function () { return $ec16e9e8a8f0b297$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Brackets", function () { return $bc48d9f27c93572e$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "CDC", function () { return $1c915a8248d24753$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "CDO", function () { return $6148bde22ddba24d$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "ClassSelector", function () { return $62046956e340f898$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Combinator", function () { return $678072efdd10fcdb$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Comment", function () { return $ed5fe54a4ebb649b$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Condition", function () { return $bdefa610a79ae05e$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Declaration", function () { return $b7a4464e404c9f7f$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "DeclarationList", function () { return $42622accbf1b1b6b$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Dimension", function () { return $7f06ae44bdd41130$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Feature", function () { return $fc4d70523a88da9c$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "FeatureFunction", function () { return $c5e215dd02b47b54$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "FeatureRange", function () { return $afb64130c5df0f05$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Function", function () { return $9bf79ec41884755c$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "GeneralEnclosed", function () { return $a68195bce17edba7$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Hash", function () { return $b35684aa816106b7$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Identifier", function () { return $11a87938930caa52$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "IdSelector", function () { return $2f8d9fb2da484051$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Layer", function () { return $c85db2efff85fc02$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "LayerList", function () { return $25655749f16bffa8$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "MediaQuery", function () { return $94b05fd6c096774a$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "MediaQueryList", function () { return $d970f304e8bc71ba$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "NestingSelector", function () { return $fbed52d6f2df3274$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Nth", function () { return $352c778ae94e759f$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Number", function () { return $407e1ad9ced420db$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Operator", function () { return $04369877262756a7$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Parentheses", function () { return $c886fa5abc8d9d5f$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Percentage", function () { return $c99e2ae0e225fd3f$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "PseudoClassSelector", function () { return $81ba3db47496bc3c$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "PseudoElementSelector", function () { return $56f21670f2a6843f$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Ratio", function () { return $60a58b987a514501$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Raw", function () { return $54eb253192531e90$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Rule", function () { return $f80a1e59c59983e7$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Scope", function () { return $5de80a7b15a6bf26$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Selector", function () { return $9ccfeb24f689dd94$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "SelectorList", function () { return $e09b6562adad0054$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "String", function () { return $17d46c820b4ef3bc$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "StyleSheet", function () { return $090f301751be1b14$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "SupportsDeclaration", function () { return $8cafbe4e6566c6b0$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "TypeSelector", function () { return $06e99d3dcf0b0856$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "UnicodeRange", function () { return $04ee15830f72d29f$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Url", function () { return $c3203ce20adbeef5$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "Value", function () { return $883cb73761c43b47$export$98e6a39c04603d36; });
$parcel$export($b47edf545ac3d326$exports, "WhiteSpace", function () { return $5da1a48d15cdd86d$export$98e6a39c04603d36; });



















































var $f5bb528c5c9a8083$export$2e2bcd8739ae039 = {
    parseContext: {
        default: 'StyleSheet',
        stylesheet: 'StyleSheet',
        atrule: 'Atrule',
        atrulePrelude (options) {
            return this.AtrulePrelude(options.atrule ? String(options.atrule) : null);
        },
        mediaQueryList: 'MediaQueryList',
        mediaQuery: 'MediaQuery',
        condition (options) {
            return this.Condition(options.kind);
        },
        rule: 'Rule',
        selectorList: 'SelectorList',
        selector: 'Selector',
        block () {
            return this.Block(true);
        },
        declarationList: 'DeclarationList',
        declaration: 'Declaration',
        value: 'Value'
    },
    features: {
        supports: {
            selector () {
                return this.Selector();
            }
        },
        container: {
            style () {
                return this.Declaration();
            }
        }
    },
    scope: $8df18fe246ea8d62$exports,
    atrule: $3d9ba3e654596837$export$2e2bcd8739ae039,
    pseudo: $ce994a0bdbe0cd0e$export$2e2bcd8739ae039,
    node: $b47edf545ac3d326$exports
};



var $bce27c27448d9ab8$export$2e2bcd8739ae039 = {
    node: $fb10b100396c91c1$exports
};


var $d8c26a2d71556afb$export$2e2bcd8739ae039 = (0, $e18ab7fe63bfa5f9$export$2e2bcd8739ae039)({
    ...(0, $0eefb1e5df616809$export$2e2bcd8739ae039),
    ...(0, $f5bb528c5c9a8083$export$2e2bcd8739ae039),
    ...(0, $bce27c27448d9ab8$export$2e2bcd8739ae039)
});


const $63cda6c94dd780cb$export$83d89fbfd8236492 = "3.1.0";








function $c162ddcef90f7866$export$9cd59f9826255e47(node) {
    const result = {};
    for (const key of Object.keys(node)){
        let value = node[key];
        if (value) {
            if (Array.isArray(value) || value instanceof (0, $2836a6e7287d8f5c$export$54c2e3dc7acea9f5)) value = value.map($c162ddcef90f7866$export$9cd59f9826255e47);
            else if (value.constructor === Object) value = $c162ddcef90f7866$export$9cd59f9826255e47(value);
        }
        result[key] = value;
    }
    return result;
}




const $c0b6a03f076f2091$var$REVERSE_SOLIDUS = 0x005c; // U+005C REVERSE SOLIDUS (\)
function $c0b6a03f076f2091$export$2f872c0f2117be69(str) {
    const end = str.length - 1;
    let decoded = '';
    for(let i = 0; i < str.length; i++){
        let code = str.charCodeAt(i);
        if (code === $c0b6a03f076f2091$var$REVERSE_SOLIDUS) {
            // special case at the ending
            if (i === end) break;
            code = str.charCodeAt(++i);
            // consume escaped
            if ((0, $fb47edd266a7fc33$export$352e2c1d24776bfb)($c0b6a03f076f2091$var$REVERSE_SOLIDUS, code)) {
                const escapeStart = i - 1;
                const escapeEnd = (0, $0a1ac1d130312a6d$export$1cf8ac3f090cf48a)(str, escapeStart);
                i = escapeEnd - 1;
                decoded += (0, $0a1ac1d130312a6d$export$5ed93187f4ce070a)(str.substring(escapeStart + 1, escapeEnd));
            } else // \r\n
            if (code === 0x000d && str.charCodeAt(i + 1) === 0x000a) i++;
        } else decoded += str[i];
    }
    return decoded;
}
function $c0b6a03f076f2091$export$c564cdbbe6da493(str) {
    let encoded = '';
    // If the character is the first character and is a "-" (U+002D),
    // and there is no second character, then the escaped character.
    // Note: That's means a single dash string "-" return as escaped dash,
    // so move the condition out of the main loop
    if (str.length === 1 && str.charCodeAt(0) === 0x002D) return '\\-';
    // To serialize an identifier means to create a string represented
    // by the concatenation of, for each character of the identifier:
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        // If the character is NULL (U+0000), then the REPLACEMENT CHARACTER (U+FFFD).
        if (code === 0x0000) {
            encoded += '\uFFFD';
            continue;
        }
        if (// If the character is in the range [\1-\1f] (U+0001 to U+001F) or is U+007F ...
        // Note: Do not compare with 0x0001 since 0x0000 is precessed before
        code <= 0x001F || code === 0x007F || // [or] ... is in the range [0-9] (U+0030 to U+0039),
        code >= 0x0030 && code <= 0x0039 && // If the character is the first character ...
        (i === 0 || // If the character is the second character ... and the first character is a "-" (U+002D)
        i === 1 && str.charCodeAt(0) === 0x002D)) {
            // ... then the character escaped as code point.
            encoded += '\\' + code.toString(16) + ' ';
            continue;
        }
        // If the character is not handled by one of the above rules and is greater
        // than or equal to U+0080, is "-" (U+002D) or "_" (U+005F), or is in one
        // of the ranges [0-9] (U+0030 to U+0039), [A-Z] (U+0041 to U+005A),
        // or \[a-z] (U+0061 to U+007A), then the character itself.
        if ((0, $fb47edd266a7fc33$export$998d7ff9801e90bb)(code)) encoded += str.charAt(i);
        else // Otherwise, the escaped character.
        encoded += '\\' + str.charAt(i);
    }
    return encoded;
}




const { tokenize: $3379b124c5cccf09$export$660b2ee2d4fb4eff, parse: $3379b124c5cccf09$export$98e6a39c04603d36, generate: $3379b124c5cccf09$export$80d376111cc09ad7, lexer: $3379b124c5cccf09$export$43feed32102720d2, createLexer: $3379b124c5cccf09$export$542413421c3f8a82, walk: $3379b124c5cccf09$export$588732934346abbf, find: $3379b124c5cccf09$export$71aa6c912b956294, findLast: $3379b124c5cccf09$export$296de88ccac4bedb, findAll: $3379b124c5cccf09$export$18200ea6c8035394, toPlainObject: $3379b124c5cccf09$export$8530f7b85295aab2, fromPlainObject: $3379b124c5cccf09$export$208fdd74c481bdd3, fork: $3379b124c5cccf09$export$7a5058c6b79333e0 } = (0, $d8c26a2d71556afb$export$2e2bcd8739ae039);


var $a3ab9a0e987a7d68$require$parseCSS = $3379b124c5cccf09$export$98e6a39c04603d36;
var $a3ab9a0e987a7d68$require$toPlainObject = $3379b124c5cccf09$export$8530f7b85295aab2;
$a3ab9a0e987a7d68$export$98bf86c57679d65e = function parseForESLint(code, parserOptions) {
    const { options: options, html: html } = $a3ab9a0e987a7d68$require$getOptions(code, parserOptions);
    const { ast: ast, tokens: tokens } = $a3ab9a0e987a7d68$require$parse(html, options);
    /** @type {HTMLProgram} */ const programNode = {
        type: "Program",
        // @ts-ignore
        body: [
            ast
        ],
        loc: ast.loc,
        range: ast.range,
        // @ts-ignore
        tokens: tokens.filter((token)=>token.type !== $a3ab9a0e987a7d68$require$TokenTypes.CommentContent && token.type !== $a3ab9a0e987a7d68$require$TokenTypes.CommentOpen && token.type !== $a3ab9a0e987a7d68$require$TokenTypes.CommentClose),
        comments: []
    };
    $a3ab9a0e987a7d68$require$traverse(programNode, (node)=>{
        if (node.type === $a3ab9a0e987a7d68$require$NODE_TYPES.CommentContent) programNode.comments.push({
            type: node.type,
            range: node.range,
            loc: node.loc,
            value: node.value
        });
        if (node.type === $a3ab9a0e987a7d68$require$NODE_TYPES.StyleTagContent) {
            const cssNode = $a3ab9a0e987a7d68$require$toPlainObject($a3ab9a0e987a7d68$require$parseCSS(node.value, {
                context: "stylesheet",
                offset: node.range[0],
                positions: true,
                line: node.loc.start.line,
                // css-tree uses 1-base column.
                column: node.loc.start.column + 1
            }));
            $a3ab9a0e987a7d68$require$traverseCss(cssNode, (node)=>{
                node.type = `Css${node.type}`;
                if (node.loc) {
                    node.range = [
                        node.loc.start.offset,
                        node.loc.end.offset
                    ];
                    node.loc.start.column -= 1;
                    node.loc.end.column -= 1;
                }
            });
            // @ts-ignore
            node.stylesheet = cssNode;
        }
    });
    return {
        // @ts-ignore
        ast: programNode,
        visitorKeys: $a3ab9a0e987a7d68$require$visitorKeys,
        scopeManager: undefined
    };
};


var $f03705736c6cdfcd$require$parseForESLint = $a3ab9a0e987a7d68$export$98bf86c57679d65e;
var $85153afe31670e5f$exports = {};
var $78f7ede9e6c6cd83$exports = {};
$78f7ede9e6c6cd83$exports = JSON.parse("{\"name\":\"@html-eslint/parser\",\"version\":\"0.59.0\",\"description\":\"Parser for @html-eslint/eslint-plugin\",\"author\":{\"name\":\"yeonjuan\",\"url\":\"https://github.com/yeonjuan\"},\"homepage\":\"https://github.com/yeonjuan/html-eslint#readme\",\"license\":\"MIT\",\"main\":\"lib/index.js\",\"type\":\"commonjs\",\"types\":\"types/exports.d.ts\",\"files\":[\"lib\",\"types\"],\"publishConfig\":{\"access\":\"public\"},\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/yeonjuan/html-eslint.git\"},\"scripts\":{\"test\":\"jest --coverage --updateSnapshot\",\"ts\":\"tsc --noEmit\",\"build\":\"rimraf types && tsc --project tsconfig.build.json\"},\"bugs\":{\"url\":\"https://github.com/yeonjuan/html-eslint/issues\"},\"keywords\":[\"html\",\"eslint\",\"parser\",\"ast\",\"lint\"],\"dependencies\":{\"@html-eslint/template-syntax-parser\":\"^0.59.0\",\"@html-eslint/types\":\"^0.59.0\",\"css-tree\":\"^3.1.0\",\"es-html-parser\":\"0.3.1\"},\"devDependencies\":{\"@types/css-tree\":\"^2.3.11\"}}");


var $85153afe31670e5f$require$name = $78f7ede9e6c6cd83$exports.name;
var $85153afe31670e5f$require$version = $78f7ede9e6c6cd83$exports.version;
$85153afe31670e5f$exports = {
    name: $85153afe31670e5f$require$name,
    version: $85153afe31670e5f$require$version
};



var $f03705736c6cdfcd$require$NODE_TYPES = $ff2e297f9661f224$exports.NODE_TYPES;
var $60c7cd734e519e64$exports = {};
/** @import {SyntaxConfig} from "@html-eslint/template-syntax-parser" */ /** @type {SyntaxConfig} */ const $60c7cd734e519e64$var$HANDLEBAR = {
    "{{": "}}"
};
/** @type {SyntaxConfig} */ const $60c7cd734e519e64$var$TWIG = [
    {
        open: "{{",
        close: "}}"
    },
    {
        open: "{%",
        close: "%}"
    },
    {
        open: "{#",
        close: "#}",
        isComment: true
    }
];
/** @type {SyntaxConfig} */ const $60c7cd734e519e64$var$ERB = {
    "<%": "%>"
};
$60c7cd734e519e64$exports = {
    HANDLEBAR: $60c7cd734e519e64$var$HANDLEBAR,
    TWIG: $60c7cd734e519e64$var$TWIG,
    ERB: $60c7cd734e519e64$var$ERB
};



var $f03705736c6cdfcd$require$visitorKeys = $48bb5b7f2107b205$exports.visitorKeys;
$f03705736c6cdfcd$exports = {
    TEMPLATE_ENGINE_SYNTAX: $60c7cd734e519e64$exports,
    parseForESLint: $f03705736c6cdfcd$require$parseForESLint,
    NODE_TYPES: $f03705736c6cdfcd$require$NODE_TYPES,
    meta: $85153afe31670e5f$exports,
    visitorKeys: $f03705736c6cdfcd$require$visitorKeys
};


var $aae83cc78a26c8db$exports = {};
var $cd1ae531f71e6bfe$exports = {};
/** @import {RuleModule} from "../types" */ var $25c931d91929d6ab$exports = {};
var $513c445ac07823b9$exports = {};
$513c445ac07823b9$exports = {
    BEST_PRACTICE: "Best Practice",
    SEO: "SEO",
    ACCESSIBILITY: "Accessibility",
    STYLE: "Style"
};


var $653a3b31735f73a9$exports = {};
// https://html.spec.whatwg.org/#non-conforming-features
/** @type {string[]} */ $653a3b31735f73a9$exports = [
    "applet",
    "acronym",
    "bgsound",
    "dir",
    "frame",
    "frameset",
    "noframes",
    "isindex",
    "keygen",
    "listing",
    "menuitem",
    "nextid",
    "noembed",
    "plaintext",
    "rb",
    "rtc",
    "strike",
    "xmp",
    "basefont",
    "big",
    "blink",
    "center",
    "font",
    "marquee",
    "multicol",
    "nobr",
    "spacer",
    "tt"
];


var $89dfbcec8e596446$exports = {};
/** @type {string[]} */ $89dfbcec8e596446$exports = [
    "area",
    "base",
    "br",
    "col",
    "embed",
    "hr",
    "img",
    "input",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
];


$25c931d91929d6ab$exports = {
    RULE_CATEGORY: $513c445ac07823b9$exports,
    OBSOLETE_TAGS: $653a3b31735f73a9$exports,
    VOID_ELEMENTS: $89dfbcec8e596446$exports
};


var $cd1ae531f71e6bfe$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;
var $7dabedd289de3a0a$exports = {};
/**
 * @import {
 *   AnyNode,
 *   AnyToken,
 *   Attribute,
 *   AttributeKey,
 *   AttributeValue,
 *   CloseTemplate,
 *   Comment,
 *   CommentContent,
 *   OpenTemplate,
 *   ScriptTag,
 *   StyleTag,
 *   Tag,
 *   Text
 * } from "@html-eslint/types"
 * @import {AST} from "eslint"
 * @import {
 *   BaseNode,
 *   Line
 * } from "../../types"
 */ 
var $7dabedd289de3a0a$require$NODE_TYPES = $f03705736c6cdfcd$exports.NODE_TYPES;
/**
 * @param {Tag | ScriptTag | StyleTag} node
 * @param {string} key
 * @returns {Attribute | undefined}
 */ function $7dabedd289de3a0a$var$findAttr(node, key) {
    return node.attributes.find((attr)=>attr.key && attr.key.value.toLowerCase() === key.toLowerCase());
}
/**
 * @param {Tag | ScriptTag} node
 * @param {string} attrName
 * @returns {boolean}
 */ function $7dabedd289de3a0a$var$hasAttr(node, attrName) {
    return node.attributes.some((a)=>a.type === "Attribute" && a.key.value === attrName);
}
/**
 * Checks whether a node's attributes is empty or not.
 *
 * @param {Tag | ScriptTag | StyleTag} node
 * @returns {boolean}
 */ function $7dabedd289de3a0a$var$isAttributesEmpty(node) {
    return !node.attributes || node.attributes.length <= 0;
}
/**
 * Checks whether a node's all tokens are on the same line or not.
 *
 * @param {AnyNode} node A node to check
 * @returns {boolean} `true` if a node's tokens are on the same line, otherwise
 *   `false`.
 */ function $7dabedd289de3a0a$var$isNodeTokensOnSameLine(node) {
    return node.loc.start.line === node.loc.end.line;
}
/**
 * @param {AST.Range} rangeA
 * @param {AST.Range} rangeB
 * @returns {boolean}
 */ function $7dabedd289de3a0a$var$isRangesOverlap(rangeA, rangeB) {
    return rangeA[0] < rangeB[1] && rangeB[0] < rangeA[1];
}
/**
 * @param {(Text | CommentContent)["parts"]} parts
 * @param {AST.Range} range
 * @returns {boolean}
 */ function $7dabedd289de3a0a$var$isOverlapWithTemplates(parts, range) {
    return parts.filter((part)=>part.type !== $7dabedd289de3a0a$require$NODE_TYPES.Part).some((part)=>$7dabedd289de3a0a$var$isRangesOverlap(part.range, range));
}
/**
 * @param {AttributeKey | AttributeValue | Text | CommentContent} node
 * @returns {boolean}
 */ function $7dabedd289de3a0a$var$hasTemplate(node) {
    return node.parts.some((part)=>part.type !== $7dabedd289de3a0a$require$NODE_TYPES.Part);
}
/**
 * @param {Text | CommentContent} node
 * @returns {Line[]}
 */ function $7dabedd289de3a0a$var$splitToLineNodes(node) {
    let start = node.range[0];
    let { line: line } = node.loc.start;
    const startCol = node.loc.start.column;
    /** @type {Line[]} */ const lineNodes = [];
    const parts = node.parts || [];
    /**
   * @param {AST.Range} range
   * @returns {{
   *   isOverlapTemplate: boolean;
   *   hasOpenTemplate: boolean;
   *   hasCloseTemplate: boolean;
   * }}
   */ function getTemplateInfo(range) {
        let isOverlapTemplate = false;
        let hasOpenTemplate = false;
        let hasCloseTemplate = false;
        for (const part of parts)if (part.type === $7dabedd289de3a0a$require$NODE_TYPES.Template) {
            if ($7dabedd289de3a0a$var$isRangesOverlap(part.range, range)) isOverlapTemplate = true;
            if (part.open && $7dabedd289de3a0a$var$isRangesOverlap(part.open.range, range)) hasOpenTemplate = true;
            if (part.close && $7dabedd289de3a0a$var$isRangesOverlap(part.close.range, range)) hasCloseTemplate = true;
        }
        return {
            isOverlapTemplate: isOverlapTemplate,
            hasCloseTemplate: hasCloseTemplate,
            hasOpenTemplate: hasOpenTemplate
        };
    }
    node.value.split("\n").forEach((value, index)=>{
        const columnStart = index === 0 ? startCol : 0;
        /** @type {AST.Range} */ const range = [
            start,
            start + value.length
        ];
        const loc = {
            start: {
                line: line,
                column: columnStart
            },
            end: {
                line: line,
                column: columnStart + value.length
            }
        };
        /** @type {Line} */ const lineNode = {
            type: "Line",
            value: value,
            range: range,
            loc: loc,
            ...getTemplateInfo(range)
        };
        start += value.length + 1;
        line += 1;
        lineNodes.push(lineNode);
    });
    return lineNodes;
}
/**
 * Get location between two nodes.
 *
 * @param {{ loc: AST.SourceLocation }} before A node placed in before
 * @param {{ loc: AST.SourceLocation }} after A node placed in after
 * @returns {AST.SourceLocation} Location between two nodes.
 */ function $7dabedd289de3a0a$var$getLocBetween(before, after) {
    return {
        start: before.loc.end,
        end: after.loc.start
    };
}
/**
 * @param {BaseNode} node
 * @returns {node is Tag}
 */ function $7dabedd289de3a0a$var$isTag(node) {
    return node.type === $7dabedd289de3a0a$require$NODE_TYPES.Tag;
}
/**
 * @param {BaseNode} node
 * @returns {node is ScriptTag}
 */ function $7dabedd289de3a0a$var$isScript(node) {
    return node.type === $7dabedd289de3a0a$require$NODE_TYPES.ScriptTag;
}
/**
 * @param {BaseNode} node
 * @returns {node is StyleTag}
 */ function $7dabedd289de3a0a$var$isStyle(node) {
    return node.type === $7dabedd289de3a0a$require$NODE_TYPES.StyleTag;
}
/**
 * @param {BaseNode} node
 * @returns {node is Comment}
 */ function $7dabedd289de3a0a$var$isComment(node) {
    return node.type === $7dabedd289de3a0a$require$NODE_TYPES.Comment;
}
/**
 * @param {BaseNode} node
 * @returns {node is Text}
 */ function $7dabedd289de3a0a$var$isText(node) {
    return node.type === $7dabedd289de3a0a$require$NODE_TYPES.Text;
}
/**
 * @param {BaseNode} node
 * @returns {node is Line}
 */ function $7dabedd289de3a0a$var$isLine(node) {
    return node.type === "Line";
}
const $7dabedd289de3a0a$var$lineBreakPattern = /\r\n|[\r\n\u2028\u2029]/u;
const $7dabedd289de3a0a$var$lineEndingPattern = new RegExp($7dabedd289de3a0a$var$lineBreakPattern.source, "gu");
/**
 * @param {string} source
 * @returns {string[]}
 */ function $7dabedd289de3a0a$var$codeToLines(source) {
    return source.split($7dabedd289de3a0a$var$lineEndingPattern);
}
/**
 * @param {AnyNode} node
 * @param {(node: AnyNode) => boolean} predicate
 * @returns {null | AnyNode}
 */ function $7dabedd289de3a0a$var$findParent(node, predicate) {
    if (!node.parent) return null;
    if (node.type === "TaggedTemplateExpression" || node.type === "TemplateLiteral" || node.type === "TemplateElement") return null;
    if (predicate(node.parent)) return node.parent;
    return $7dabedd289de3a0a$var$findParent(node.parent, predicate);
}
/**
 * @param {AnyToken[]} tokens
 * @returns {(CommentContent | Text)["parts"][number][]}
 */ function $7dabedd289de3a0a$var$getTemplateTokens(tokens) {
    return [].concat(...tokens// @ts-ignore
    .map((token)=>token["parts"] || []))// @ts-ignore
    .filter((token)=>token.type !== $7dabedd289de3a0a$require$NODE_TYPES.Part);
}
/**
 * @param {Tag | ScriptTag | StyleTag} node
 * @returns {string}
 */ function $7dabedd289de3a0a$var$getNameOf(node) {
    if ($7dabedd289de3a0a$var$isScript(node)) return "script";
    if ($7dabedd289de3a0a$var$isStyle(node)) return "style";
    return node.name.toLowerCase();
}
$7dabedd289de3a0a$exports = {
    findAttr: $7dabedd289de3a0a$var$findAttr,
    isAttributesEmpty: $7dabedd289de3a0a$var$isAttributesEmpty,
    isNodeTokensOnSameLine: $7dabedd289de3a0a$var$isNodeTokensOnSameLine,
    splitToLineNodes: $7dabedd289de3a0a$var$splitToLineNodes,
    getLocBetween: $7dabedd289de3a0a$var$getLocBetween,
    findParent: $7dabedd289de3a0a$var$findParent,
    isTag: $7dabedd289de3a0a$var$isTag,
    isComment: $7dabedd289de3a0a$var$isComment,
    isText: $7dabedd289de3a0a$var$isText,
    isLine: $7dabedd289de3a0a$var$isLine,
    isScript: $7dabedd289de3a0a$var$isScript,
    isStyle: $7dabedd289de3a0a$var$isStyle,
    isOverlapWithTemplates: $7dabedd289de3a0a$var$isOverlapWithTemplates,
    codeToLines: $7dabedd289de3a0a$var$codeToLines,
    isRangesOverlap: $7dabedd289de3a0a$var$isRangesOverlap,
    getTemplateTokens: $7dabedd289de3a0a$var$getTemplateTokens,
    hasTemplate: $7dabedd289de3a0a$var$hasTemplate,
    hasAttr: $7dabedd289de3a0a$var$hasAttr,
    getNameOf: $7dabedd289de3a0a$var$getNameOf
};


var $cd1ae531f71e6bfe$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $6e393e774f061794$exports = {};
/**
 * @import {
 *   Context,
 *   RuleListener
 * } from "../../types"
 */ var $82257e454733f104$exports = {};
/**
 * @import {
 *   TaggedTemplateExpression,
 *   TemplateLiteral
 * } from "@html-eslint/types"
 * @import {
 *   Context,
 *   HTMLSettings,
 *   MaybeHTMLSettings
 * } from "../../types"
 */ var $2abd6ce2c4a2d841$exports = {};
/** @import {Context} from "../../types" */ /** @param {Context<any[]>} context */ function $2abd6ce2c4a2d841$var$getSourceCode(context) {
    return context.sourceCode || /**
     * @type {Context<any[]> & {
     *   getSourceCode(): Context<any>["sourceCode"];
     * }}
     */ context.getSourceCode();
}
$2abd6ce2c4a2d841$exports = {
    getSourceCode: $2abd6ce2c4a2d841$var$getSourceCode
};


var $82257e454733f104$require$getSourceCode = $2abd6ce2c4a2d841$exports.getSourceCode;
const $82257e454733f104$var$DEFAULT_SETTINGS = {
    templateLiterals: {
        tags: [
            "^html$"
        ],
        comments: [
            "^\\s*html\\s*$"
        ]
    }
};
/**
 * @param {{ html?: MaybeHTMLSettings }} settings
 * @returns {HTMLSettings}
 */ function $82257e454733f104$var$getSettings(settings) {
    const tags = settings && settings.html && settings.html.templateLiterals && settings.html.templateLiterals.tags || $82257e454733f104$var$DEFAULT_SETTINGS.templateLiterals.tags;
    const comments = settings && settings.html && settings.html.templateLiterals && settings.html.templateLiterals.comments || $82257e454733f104$var$DEFAULT_SETTINGS.templateLiterals.comments;
    return {
        templateLiterals: {
            tags: tags.map((tag)=>new RegExp(tag, "u")),
            comments: comments.map((comment)=>new RegExp(comment, "u"))
        }
    };
}
/**
 * @param {TaggedTemplateExpression} node
 * @param {Context<any[]>} context
 * @returns {boolean}
 */ function $82257e454733f104$var$shouldCheckTaggedTemplateExpression(node, context) {
    const { templateLiterals: { tags: tags } } = $82257e454733f104$var$getSettings(context.settings);
    const tagNode = node.tag;
    return !!(tagNode.type === "Identifier" && tags.some((tag)=>tag.test(tagNode.name)));
}
/**
 * @param {TemplateLiteral} node
 * @param {Context<any[]>} context
 * @returns {boolean}
 */ function $82257e454733f104$var$shouldCheckTemplateLiteral(node, context) {
    const sourceCode = $82257e454733f104$require$getSourceCode(context);
    const { templateLiterals: templateLiterals } = $82257e454733f104$var$getSettings(context.settings);
    const comments = sourceCode.getCommentsBefore(node);
    const last = comments[comments.length - 1];
    return !!(last && templateLiterals.comments.some((comment)=>comment.test(last.value)));
}
$82257e454733f104$exports = {
    shouldCheckTemplateLiteral: $82257e454733f104$var$shouldCheckTemplateLiteral,
    shouldCheckTaggedTemplateExpression: $82257e454733f104$var$shouldCheckTaggedTemplateExpression
};


var $6e393e774f061794$require$shouldCheckTaggedTemplateExpression = $82257e454733f104$exports.shouldCheckTaggedTemplateExpression;
var $6e393e774f061794$require$shouldCheckTemplateLiteral = $82257e454733f104$exports.shouldCheckTemplateLiteral;
var $7038c80d40859759$exports = {};
/**
 * @import {TemplateHTMLVisitor} from "@html-eslint/template-parser"
 * @import {TemplateLiteral} from "@html-eslint/types"
 * @import {
 *   AnyToken,
 *   DocumentNode
 * } from "es-html-parser"
 * @import {SourceCode} from "eslint"
 */ var $e01937171d791ca6$exports = {};
var $982348b78a38e25c$exports = {};
/**
 * @import {
 *   Range,
 *   TemplateLiteral
 * } from "@html-eslint/types"
 * @import {SourceCode} from "eslint"
 * @import {TemplateHTMLVisitor} from "./types"
 */ 
var $71149d22aab81002$exports = {};
/**
 * @import {AnyNode} from "es-html-parser"
 * @import {
 *   TemplateHTMLVisitor,
 *   TemplateHTMLVisitorKeys
 * } from "./types"
 */ 
var $71149d22aab81002$require$NodeTypes = $f3f48439a2287510$exports.NodeTypes;
/** @type {TemplateHTMLVisitorKeys} */ const $71149d22aab81002$var$visitorKeys = {
    [$71149d22aab81002$require$NodeTypes.Document]: [
        "children"
    ],
    [$71149d22aab81002$require$NodeTypes.Attribute]: [
        "key",
        "startWrapper",
        "endWrapper",
        "value"
    ],
    [$71149d22aab81002$require$NodeTypes.AttributeKey]: [],
    [$71149d22aab81002$require$NodeTypes.AttributeValue]: [],
    [$71149d22aab81002$require$NodeTypes.AttributeValueWrapperEnd]: [],
    [$71149d22aab81002$require$NodeTypes.AttributeValueWrapperStart]: [],
    [$71149d22aab81002$require$NodeTypes.CloseScriptTag]: [],
    [$71149d22aab81002$require$NodeTypes.CloseStyleTag]: [],
    [$71149d22aab81002$require$NodeTypes.CloseTag]: [],
    [$71149d22aab81002$require$NodeTypes.Comment]: [
        "open",
        "close",
        "value"
    ],
    [$71149d22aab81002$require$NodeTypes.CommentContent]: [],
    [$71149d22aab81002$require$NodeTypes.CommentOpen]: [],
    [$71149d22aab81002$require$NodeTypes.CommentClose]: [],
    [$71149d22aab81002$require$NodeTypes.Doctype]: [
        "open",
        "close",
        "attributes"
    ],
    [$71149d22aab81002$require$NodeTypes.DoctypeAttribute]: [
        "startWrapper",
        "value",
        "endWrapper"
    ],
    [$71149d22aab81002$require$NodeTypes.DoctypeAttributeValue]: [],
    [$71149d22aab81002$require$NodeTypes.DoctypeAttributeWrapperEnd]: [],
    [$71149d22aab81002$require$NodeTypes.DoctypeAttributeWrapperStart]: [],
    [$71149d22aab81002$require$NodeTypes.DoctypeOpen]: [],
    [$71149d22aab81002$require$NodeTypes.DoctypeClose]: [],
    [$71149d22aab81002$require$NodeTypes.OpenScriptTagEnd]: [],
    [$71149d22aab81002$require$NodeTypes.OpenScriptTagStart]: [],
    [$71149d22aab81002$require$NodeTypes.OpenStyleTagEnd]: [],
    [$71149d22aab81002$require$NodeTypes.OpenStyleTagStart]: [],
    [$71149d22aab81002$require$NodeTypes.OpenTagEnd]: [],
    [$71149d22aab81002$require$NodeTypes.OpenTagStart]: [],
    [$71149d22aab81002$require$NodeTypes.ScriptTag]: [
        "attributes",
        "openStart",
        "openEnd",
        "close",
        "value"
    ],
    [$71149d22aab81002$require$NodeTypes.ScriptTagContent]: [],
    [$71149d22aab81002$require$NodeTypes.StyleTag]: [
        "attributes",
        "openStart",
        "openEnd",
        "close",
        "value"
    ],
    [$71149d22aab81002$require$NodeTypes.StyleTagContent]: [],
    [$71149d22aab81002$require$NodeTypes.Tag]: [
        "openStart",
        "openEnd",
        "close",
        "children",
        "attributes"
    ],
    [$71149d22aab81002$require$NodeTypes.Text]: [],
    [$71149d22aab81002$require$NodeTypes.Template]: [],
    [$71149d22aab81002$require$NodeTypes.OpenTemplate]: [],
    [$71149d22aab81002$require$NodeTypes.CloseTemplate]: [],
    [$71149d22aab81002$require$NodeTypes.Part]: [],
    [$71149d22aab81002$require$NodeTypes.RawContent]: []
};
/**
 * @param {AnyNode} node
 * @param {TemplateHTMLVisitor} visitors
 * @param {AnyNode | null} [parent]
 */ function $71149d22aab81002$var$traverse(node, visitors, parent) {
    parent = parent || null;
    // @ts-ignore
    const enterVisitor = visitors[node.type];
    // @ts-ignore
    node.parent = parent;
    enterVisitor && enterVisitor(node);
    const nextKeys = $71149d22aab81002$var$visitorKeys[node.type];
    nextKeys.forEach((key)=>{
        // @ts-ignore
        const next = node[key];
        if (Array.isArray(next)) next.forEach((n)=>$71149d22aab81002$var$traverse(n, visitors, node));
        else if (next) $71149d22aab81002$var$traverse(next, visitors, node);
    });
    // @ts-ignore
    const exitVisitor = visitors[`${node.type}:exit`];
    exitVisitor && exitVisitor(node);
}
$71149d22aab81002$exports = {
    traverse: $71149d22aab81002$var$traverse
};


var $982348b78a38e25c$require$traverse = $71149d22aab81002$exports.traverse;
/**
 * @param {TemplateLiteral} node
 * @param {SourceCode} sourceCode
 * @param {TemplateHTMLVisitor} [visitor]
 */ function $982348b78a38e25c$var$parse(node, sourceCode, visitor) {
    /** @type {string[]} */ const htmlParts = [];
    const quasis = node.quasis;
    const rangeOffset = node.range[0] + 1;
    const lineOffset = node.loc.start.line - 1;
    const expressions = node.expressions;
    /** @type {{ open: Range; close: Range }[]} */ const templateInfos = [];
    quasis.forEach((element, index)=>{
        htmlParts.push(element.value.raw);
        if (expressions[index]) {
            const nextQuasisElement = quasis[index + 1];
            const str = sourceCode.text.slice(element.range[1] - 2, nextQuasisElement.range[0] + 1);
            htmlParts.push(str);
            const start = element.range[1] - 2 - rangeOffset;
            const end = start + str.length;
            templateInfos.push({
                open: [
                    start,
                    start + 2
                ],
                close: [
                    end - 1,
                    end
                ]
            });
        }
    });
    const html = htmlParts.join("");
    const { ast: ast, tokens: tokens } = $f3f48439a2287510$exports.parse(html, {
        templateInfos: templateInfos,
        tokenAdapter: {
            finalizeLocation (token) {
                const startLine = token.loc.start.line + lineOffset;
                const columnOffset = startLine === node.loc.start.line ? node.loc.start.column + 1 : 0;
                return {
                    start: {
                        line: startLine,
                        column: token.loc.start.column + columnOffset
                    },
                    end: {
                        line: token.loc.end.line + lineOffset,
                        column: token.loc.end.column + columnOffset
                    }
                };
            },
            finalizeRange (token) {
                return [
                    token.range[0] + rangeOffset,
                    token.range[1] + rangeOffset
                ];
            }
        }
    });
    if (visitor) $982348b78a38e25c$require$traverse(ast, visitor, null);
    return {
        ast: ast,
        html: html,
        tokens: tokens
    };
}
$982348b78a38e25c$exports = {
    parse: $982348b78a38e25c$var$parse
};


var $e01937171d791ca6$require$parse = $982348b78a38e25c$exports.parse;

var $e01937171d791ca6$require$traverse = $71149d22aab81002$exports.traverse;
$e01937171d791ca6$exports = {
    parse: $e01937171d791ca6$require$parse,
    traverse: $e01937171d791ca6$require$traverse
};


var $7038c80d40859759$require$parse = $e01937171d791ca6$exports.parse;
var $7038c80d40859759$require$traverse = $e01937171d791ca6$exports.traverse;
/**
 * Cache for parsed template literals to avoid re-parsing the same template
 * multiple times. Uses WeakMap for automatic garbage collection when nodes are
 * no longer referenced.
 *
 * @type {WeakMap<
 *   TemplateLiteral,
 *   { ast: any; html: string; tokens: any[] }
 * >}
 */ const $7038c80d40859759$var$templateCache = new WeakMap();
/**
 * Get or create cached parse result for a template literal.
 *
 * @param {TemplateLiteral} node
 * @param {SourceCode} sourceCode
 * @param {TemplateHTMLVisitor} [visitor]
 * @returns {{ ast: DocumentNode; html: string; tokens: AnyToken[] }}
 */ function $7038c80d40859759$var$parseTemplateLiteral(node, sourceCode, visitor) {
    // Check if we already have a cached result for this node
    const cachedResult = $7038c80d40859759$var$templateCache.get(node);
    if (cachedResult) {
        if (visitor) $7038c80d40859759$require$traverse(cachedResult.ast, visitor);
        return cachedResult;
    }
    // Parse and cache the result
    const result = $7038c80d40859759$require$parse(node, sourceCode);
    $7038c80d40859759$var$templateCache.set(node, result);
    if (visitor) $7038c80d40859759$require$traverse(result.ast, visitor);
    return result;
}
$7038c80d40859759$exports = {
    parseTemplateLiteral: $7038c80d40859759$var$parseTemplateLiteral
};


var $6e393e774f061794$require$parseTemplateLiteral = $7038c80d40859759$exports.parseTemplateLiteral;

var $6e393e774f061794$require$getSourceCode = $2abd6ce2c4a2d841$exports.getSourceCode;
/**
 * @param {Context<any[]>} context
 * @param {any} visitors
 * @returns {RuleListener}
 */ function $6e393e774f061794$var$createTemplateVisitors(context, visitors) {
    return {
        TaggedTemplateExpression (node) {
            if ($6e393e774f061794$require$shouldCheckTaggedTemplateExpression(node, context)) $6e393e774f061794$require$parseTemplateLiteral(node.quasi, $6e393e774f061794$require$getSourceCode(context), visitors);
        },
        TemplateLiteral (node) {
            if ($6e393e774f061794$require$shouldCheckTemplateLiteral(node, context)) $6e393e774f061794$require$parseTemplateLiteral(node, $6e393e774f061794$require$getSourceCode(context), visitors);
        }
    };
}
/**
 * @param {Context<any[]>} context
 * @param {RuleListener} visitors
 * @param {any} [templateVisitors]
 * @returns {RuleListener}
 */ function $6e393e774f061794$var$createVisitors(context, visitors, templateVisitors) {
    const tmplVisitors = $6e393e774f061794$var$createTemplateVisitors(context, templateVisitors || visitors);
    return {
        ...visitors,
        ...tmplVisitors
    };
}
$6e393e774f061794$exports = {
    createVisitors: $6e393e774f061794$var$createVisitors
};


var $cd1ae531f71e6bfe$require$createVisitors = $6e393e774f061794$exports.createVisitors;
var $6a86dcf564257278$exports = {};
/** @param {string} ruleName */ function $6a86dcf564257278$var$getRuleUrl(ruleName) {
    return "https://html-eslint.org/docs/rules/" + ruleName;
}
$6a86dcf564257278$exports = {
    getRuleUrl: $6a86dcf564257278$var$getRuleUrl
};


var $cd1ae531f71e6bfe$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $cd1ae531f71e6bfe$var$MESSAGE_IDS = {
    MISSING: "missing",
    EMPTY: "empty"
};
/** @type {RuleModule<[]>} */ $cd1ae531f71e6bfe$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Require `lang` attribute on `<html>` tag",
            category: $cd1ae531f71e6bfe$require$RULE_CATEGORY.SEO,
            recommended: true,
            url: $cd1ae531f71e6bfe$require$getRuleUrl("require-lang")
        },
        fixable: null,
        schema: [],
        messages: {
            [$cd1ae531f71e6bfe$var$MESSAGE_IDS.MISSING]: "Missing `lang` attribute in `<html>` tag.",
            [$cd1ae531f71e6bfe$var$MESSAGE_IDS.EMPTY]: "Unexpected empty `lang` in in `<html>` tag."
        }
    },
    create (context) {
        return $cd1ae531f71e6bfe$require$createVisitors(context, {
            Tag (node) {
                if (node.name !== "html") return;
                const langAttr = $cd1ae531f71e6bfe$require$findAttr(node, "lang");
                if (!langAttr) context.report({
                    loc: {
                        start: node.openStart.loc.start,
                        end: node.openEnd.loc.end
                    },
                    messageId: $cd1ae531f71e6bfe$var$MESSAGE_IDS.MISSING
                });
                else if (langAttr.value?.value.trim().length === 0) context.report({
                    node: node.openStart,
                    messageId: $cd1ae531f71e6bfe$var$MESSAGE_IDS.EMPTY
                });
            }
        });
    }
};


var $3899496f4387d368$exports = {};
/**
 * @import {Tag} from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 * @typedef {Object} Option
 * @property {string[]} [substitute]
 */ 
var $3899496f4387d368$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $3899496f4387d368$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $3899496f4387d368$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $3899496f4387d368$var$MESSAGE_IDS = {
    MISSING_ALT: "missingAlt",
    INSERT_ALT: "insertAlt"
};
/** @type {RuleModule<[Option]>} */ $3899496f4387d368$exports = {
    meta: {
        type: "suggestion",
        docs: {
            description: "Require `alt` attribute on `<img>` tag",
            category: $3899496f4387d368$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: true,
            url: $3899496f4387d368$require$getRuleUrl("require-img-alt")
        },
        fixable: null,
        hasSuggestions: true,
        schema: [
            {
                type: "object",
                properties: {
                    substitute: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$3899496f4387d368$var$MESSAGE_IDS.MISSING_ALT]: "Missing `alt` attribute at `<img>` tag",
            [$3899496f4387d368$var$MESSAGE_IDS.INSERT_ALT]: 'Insert `alt=""` at `<img>` tag'
        }
    },
    create (context) {
        const substitute = context.options?.[0]?.substitute || [];
        return $3899496f4387d368$require$createVisitors(context, {
            Tag (node) {
                if (node.name !== "img") return;
                const hasAlt = $3899496f4387d368$var$hasValidAltOrSubstitute(node, substitute);
                const hasSubstituteOption = substitute.length > 0;
                if (!hasAlt) context.report({
                    loc: {
                        start: node.openStart.loc.start,
                        end: node.openEnd.loc.end
                    },
                    messageId: $3899496f4387d368$var$MESSAGE_IDS.MISSING_ALT,
                    suggest: hasSubstituteOption ? null : [
                        {
                            messageId: $3899496f4387d368$var$MESSAGE_IDS.INSERT_ALT,
                            fix (fixer) {
                                return fixer.insertTextBefore(node.openEnd, ' alt=""');
                            }
                        }
                    ]
                });
            }
        });
    }
};
/**
 * @param {Tag} node
 * @param {string[]} substitute
 * @returns {boolean}
 */ function $3899496f4387d368$var$hasValidAltOrSubstitute(node, substitute) {
    let hasAnyAlt = false;
    for (const attr of node.attributes)if (attr.key?.value) {
        const isAltAttr = attr.key.value === "alt";
        const isSubstituteAttr = substitute.includes(attr.key.value);
        if (isAltAttr || isSubstituteAttr) {
            hasAnyAlt = true;
            break;
        }
    }
    return hasAnyAlt;
}


var $40622b6fb641b995$exports = {};
/** @import {RuleModule} from "../types" */ 
var $40622b6fb641b995$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $40622b6fb641b995$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $40622b6fb641b995$var$MESSAGE_IDS = {
    MISSING: "missing"
};
/** @type {RuleModule<[]>} */ $40622b6fb641b995$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Require `<!DOCTYPE HTML>` in HTML",
            category: $40622b6fb641b995$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: true,
            url: $40622b6fb641b995$require$getRuleUrl("require-doctype")
        },
        fixable: true,
        schema: [],
        messages: {
            [$40622b6fb641b995$var$MESSAGE_IDS.MISSING]: "Missing `<!DOCTYPE HTML>`"
        }
    },
    create (context) {
        let hasDocType = false;
        return {
            Doctype () {
                hasDocType = true;
            },
            Tag (node) {
                if (node.name !== "html") return;
                if (!hasDocType) context.report({
                    node: node,
                    messageId: $40622b6fb641b995$var$MESSAGE_IDS.MISSING,
                    fix (fixer) {
                        return fixer.insertTextBeforeRange([
                            0,
                            0
                        ], "<!DOCTYPE html>\n");
                    }
                });
            }
        };
    }
};


var $8df233e0bd9b4858$exports = {};
/**
 * @import {
 *   AnyNode,
 *   Tag,
 *   Text
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $8df233e0bd9b4858$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;
var $c7fec554e020284f$exports = {};
/**
 * @template T
 * @template {T} S
 * @param {T[]} items
 * @param {(node: T) => node is S} predicate
 * @returns {S | undefined}
 */ function $c7fec554e020284f$var$find(items, predicate) {
    return items.find(predicate);
}
/**
 * @template T
 * @template {T} S
 * @param {T[]} items
 * @param {(node: T) => node is S} predicate
 * @returns {S[]}
 */ function $c7fec554e020284f$var$filter(items, predicate) {
    return items.filter(predicate);
}
$c7fec554e020284f$exports = {
    find: $c7fec554e020284f$var$find,
    filter: $c7fec554e020284f$var$filter
};


var $8df233e0bd9b4858$require$find = $c7fec554e020284f$exports.find;

var $8df233e0bd9b4858$require$isText = $7dabedd289de3a0a$exports.isText;
var $8df233e0bd9b4858$require$isTag = $7dabedd289de3a0a$exports.isTag;

var $8df233e0bd9b4858$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $8df233e0bd9b4858$var$MESSAGE_IDS = {
    MISSING_TITLE: "missing",
    EMPTY_TITLE: "empty"
};
/**
 * @param {AnyNode} node
 * @returns {node is Tag}
 */ function $8df233e0bd9b4858$var$isTitle(node) {
    return $8df233e0bd9b4858$require$isTag(node) && node.name === "title";
}
/**
 * @param {AnyNode} node
 * @returns {node is Text}
 */ function $8df233e0bd9b4858$var$isNonEmptyText(node) {
    return $8df233e0bd9b4858$require$isText(node) && node.value.trim().length > 0;
}
/** @type {RuleModule<[]>} */ $8df233e0bd9b4858$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Require `<title>` in the `<head>`",
            category: $8df233e0bd9b4858$require$RULE_CATEGORY.SEO,
            recommended: true,
            url: $8df233e0bd9b4858$require$getRuleUrl("require-title")
        },
        fixable: null,
        schema: [],
        messages: {
            [$8df233e0bd9b4858$var$MESSAGE_IDS.MISSING_TITLE]: "Missing `<title><title/>` in the `<head><head/>`",
            [$8df233e0bd9b4858$var$MESSAGE_IDS.EMPTY_TITLE]: "Unexpected empty text in `<title><title/>`"
        }
    },
    create (context) {
        return {
            Tag (node) {
                if (node.name !== "head") return;
                const title = $8df233e0bd9b4858$require$find(node.children, $8df233e0bd9b4858$var$isTitle);
                if (!title) {
                    context.report({
                        node: node,
                        messageId: $8df233e0bd9b4858$var$MESSAGE_IDS.MISSING_TITLE
                    });
                    return;
                }
                const content = $8df233e0bd9b4858$require$find(title.children, $8df233e0bd9b4858$var$isNonEmptyText);
                if (!content) context.report({
                    node: title,
                    messageId: $8df233e0bd9b4858$var$MESSAGE_IDS.EMPTY_TITLE
                });
            }
        };
    }
};


var $c8a0553aa885b660$exports = {};
/**
 * @import {
 *   AttributeValue,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $c8a0553aa885b660$require$parseTemplateLiteral = $7038c80d40859759$exports.parseTemplateLiteral;

var $c8a0553aa885b660$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $c8a0553aa885b660$require$findAttr = $7dabedd289de3a0a$exports.findAttr;

var $c8a0553aa885b660$require$shouldCheckTaggedTemplateExpression = $82257e454733f104$exports.shouldCheckTaggedTemplateExpression;
var $c8a0553aa885b660$require$shouldCheckTemplateLiteral = $82257e454733f104$exports.shouldCheckTemplateLiteral;

var $c8a0553aa885b660$require$getSourceCode = $2abd6ce2c4a2d841$exports.getSourceCode;

var $c8a0553aa885b660$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $c8a0553aa885b660$var$MESSAGE_IDS = {
    DUPLICATE_ID: "duplicateId"
};
/** @type {RuleModule<[]>} */ $c8a0553aa885b660$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow duplicate id attributes",
            category: $c8a0553aa885b660$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: true,
            url: $c8a0553aa885b660$require$getRuleUrl("no-duplicate-id")
        },
        fixable: null,
        schema: [],
        messages: {
            [$c8a0553aa885b660$var$MESSAGE_IDS.DUPLICATE_ID]: "The id '{{id}}' is duplicated."
        }
    },
    create (context) {
        const htmlIdAttrsMap = new Map();
        /** @param {Map<string, AttributeValue[]>} map */ function createTagVisitor(map) {
            /** @param {Tag} node */ return function(node) {
                if (!node.attributes || node.attributes.length <= 0) return;
                const idAttr = $c8a0553aa885b660$require$findAttr(node, "id");
                if (idAttr?.value) {
                    if (!map.has(idAttr.value.value)) map.set(idAttr.value.value, []);
                    const nodes = map.get(idAttr.value.value);
                    if (nodes) nodes.push(idAttr.value);
                }
            };
        }
        /** @param {Map<string, AttributeValue[]>} map */ function report(map) {
            map.forEach((attrs)=>{
                if (Array.isArray(attrs) && attrs.length > 1) attrs.forEach((attr)=>{
                    context.report({
                        node: attr,
                        data: {
                            id: attr.value
                        },
                        messageId: $c8a0553aa885b660$var$MESSAGE_IDS.DUPLICATE_ID
                    });
                });
            });
        }
        return {
            Tag: createTagVisitor(htmlIdAttrsMap),
            "Document:exit" () {
                report(htmlIdAttrsMap);
            },
            TaggedTemplateExpression (node) {
                const idAttrsMap = new Map();
                if ($c8a0553aa885b660$require$shouldCheckTaggedTemplateExpression(node, context)) $c8a0553aa885b660$require$parseTemplateLiteral(node.quasi, $c8a0553aa885b660$require$getSourceCode(context), {
                    Tag: createTagVisitor(idAttrsMap)
                });
                report(idAttrsMap);
            },
            TemplateLiteral (node) {
                const idAttrsMap = new Map();
                if ($c8a0553aa885b660$require$shouldCheckTemplateLiteral(node, context)) $c8a0553aa885b660$require$parseTemplateLiteral(node, $c8a0553aa885b660$require$getSourceCode(context), {
                    Tag: createTagVisitor(idAttrsMap)
                });
                report(idAttrsMap);
            }
        };
    }
};


var $005acf3d79da7a92$exports = {};
/** @import {RuleModule} from "../types" */ 
var $005acf3d79da7a92$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $005acf3d79da7a92$require$findAttr = $7dabedd289de3a0a$exports.findAttr;

var $005acf3d79da7a92$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $005acf3d79da7a92$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $005acf3d79da7a92$var$MESSAGE_IDS = {
    INLINE_STYLE: "unexpectedInlineStyle"
};
/** @type {RuleModule<[]>} */ $005acf3d79da7a92$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow using inline style",
            category: $005acf3d79da7a92$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $005acf3d79da7a92$require$getRuleUrl("no-inline-styles")
        },
        fixable: null,
        schema: [],
        messages: {
            [$005acf3d79da7a92$var$MESSAGE_IDS.INLINE_STYLE]: "Unexpected usage of inline style"
        }
    },
    create (context) {
        return $005acf3d79da7a92$require$createVisitors(context, {
            Tag (node) {
                const styleAttr = $005acf3d79da7a92$require$findAttr(node, "style");
                if (styleAttr) context.report({
                    node: styleAttr,
                    messageId: $005acf3d79da7a92$var$MESSAGE_IDS.INLINE_STYLE
                });
            }
        });
    }
};


var $58eb9fa824f3db09$exports = {};
/**
 * @import {Tag} from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $58eb9fa824f3db09$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $58eb9fa824f3db09$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $58eb9fa824f3db09$var$MESSAGE_IDS = {
    MULTIPLE_H1: "unexpectedMultiH1"
};
/** @type {RuleModule<[]>} */ $58eb9fa824f3db09$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow multiple `<h1></h1>`.",
            category: $58eb9fa824f3db09$require$RULE_CATEGORY.SEO,
            recommended: true,
            url: $58eb9fa824f3db09$require$getRuleUrl("no-multiple-h1")
        },
        fixable: null,
        schema: [],
        messages: {
            [$58eb9fa824f3db09$var$MESSAGE_IDS.MULTIPLE_H1]: "Unexpected multiple `<h1></h1>`."
        }
    },
    create (context) {
        /** @type {Tag[]} */ const h1s = [];
        return {
            Tag (node) {
                if (node.name === "h1") h1s.push(node);
            },
            "Document:exit" () {
                if (h1s.length > 1) h1s.forEach((h1)=>{
                    context.report({
                        node: h1,
                        messageId: $58eb9fa824f3db09$var$MESSAGE_IDS.MULTIPLE_H1
                    });
                });
            }
        };
    }
};


var $4d64e4ad9efe6d5f$exports = {};
/**
 * @import {
 *   AnyNode,
 *   Attribute,
 *   OpenScriptTagStart,
 *   OpenStyleTagStart,
 *   OpenTagStart,
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 * @typedef {Object} Option
 * @property {boolean} [Option.disallowInAssignment]
 * @property {boolean} [Option.disallowMissing]
 * @property {boolean} [Option.disallowTabs]
 * @property {boolean} [Option.enforceBeforeSelfClose]
 */ 
var $4d64e4ad9efe6d5f$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $4d64e4ad9efe6d5f$require$getLocBetween = $7dabedd289de3a0a$exports.getLocBetween;

var $4d64e4ad9efe6d5f$require$getSourceCode = $2abd6ce2c4a2d841$exports.getSourceCode;

var $4d64e4ad9efe6d5f$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $4d64e4ad9efe6d5f$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $4d64e4ad9efe6d5f$var$MESSAGE_IDS = {
    EXTRA_BETWEEN: "unexpectedBetween",
    EXTRA_AFTER: "unexpectedAfter",
    EXTRA_BEFORE: "unexpectedBefore",
    EXTRA_BEFORE_CLOSE: "unexpectedBeforeClose",
    EXTRA_IN_ASSIGNMENT: "unexpectedInAssignment",
    MISSING_BEFORE: "missingBefore",
    MISSING_BEFORE_SELF_CLOSE: "missingBeforeSelfClose",
    EXTRA_BEFORE_SELF_CLOSE: "unexpectedBeforeSelfClose",
    EXTRA_TAB_BEFORE: "unexpectedTabBefore",
    EXTRA_TAB_BEFORE_SELF_CLOSE: "unexpectedTabBeforeSelfClose",
    EXTRA_TAB_BETWEEN: "unexpectedTabBetween"
};
/** @type {RuleModule<[Option]>} */ $4d64e4ad9efe6d5f$exports = {
    meta: {
        type: "code",
        deprecated: true,
        replacedBy: [
            "no-extra-spacing-tags"
        ],
        docs: {
            description: "Disallow extra spacing around attributes",
            category: $4d64e4ad9efe6d5f$require$RULE_CATEGORY.STYLE,
            recommended: true,
            url: $4d64e4ad9efe6d5f$require$getRuleUrl("no-extra-spacing-attrs")
        },
        fixable: true,
        schema: [
            {
                type: "object",
                properties: {
                    disallowInAssignment: {
                        type: "boolean"
                    },
                    disallowMissing: {
                        type: "boolean"
                    },
                    disallowTabs: {
                        type: "boolean"
                    },
                    enforceBeforeSelfClose: {
                        type: "boolean"
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_BETWEEN]: "Unexpected space between attributes",
            [$4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_AFTER]: "Unexpected space after attribute",
            [$4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_BEFORE]: "Unexpected space before attribute",
            [$4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_BEFORE_CLOSE]: "Unexpected space before closing",
            [$4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_IN_ASSIGNMENT]: "Unexpected space in attribute assignment",
            [$4d64e4ad9efe6d5f$var$MESSAGE_IDS.MISSING_BEFORE_SELF_CLOSE]: "Missing space before self closing",
            [$4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_BEFORE_SELF_CLOSE]: "Unexpected extra spaces before self closing",
            [$4d64e4ad9efe6d5f$var$MESSAGE_IDS.MISSING_BEFORE]: "Missing space before attribute",
            [$4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_TAB_BEFORE]: "Unexpected tab before attribute; use space instead",
            [$4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_TAB_BEFORE_SELF_CLOSE]: "Unexpected tab before self closing; use space instead",
            [$4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_TAB_BETWEEN]: "Unexpected tab between attributes; use space instead"
        }
    },
    create (context) {
        const enforceBeforeSelfClose = !!(context.options[0] || {}).enforceBeforeSelfClose;
        const disallowMissing = !!(context.options[0] || {}).disallowMissing;
        const disallowTabs = !!(context.options[0] || {}).disallowTabs;
        const disallowInAssignment = !!(context.options[0] || []).disallowInAssignment;
        const sourceCode = $4d64e4ad9efe6d5f$require$getSourceCode(context).text;
        /** @param {Attribute[]} attrs */ function checkExtraSpacesBetweenAttrs(attrs) {
            attrs.forEach((current, index, attrs)=>{
                if (index >= attrs.length - 1) return;
                const after = attrs[index + 1];
                if (current.loc.end.line !== after.loc.start.line) // skip the attributes on the other line
                return;
                const spacesBetween = after.loc.start.column - current.loc.end.column;
                if (spacesBetween > 1) context.report({
                    loc: $4d64e4ad9efe6d5f$require$getLocBetween(current, after),
                    messageId: $4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_BETWEEN,
                    fix (fixer) {
                        return fixer.replaceTextRange([
                            current.range[1],
                            after.range[0]
                        ], ` `);
                    }
                });
                else if (disallowMissing && spacesBetween < 1) context.report({
                    loc: after.loc,
                    messageId: $4d64e4ad9efe6d5f$var$MESSAGE_IDS.MISSING_BEFORE,
                    fix (fixer) {
                        return fixer.insertTextAfter(current, " ");
                    }
                });
                else if (disallowTabs) {
                    if (sourceCode[current.range[1]] === `\t`) context.report({
                        loc: $4d64e4ad9efe6d5f$require$getLocBetween(current, after),
                        messageId: $4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_TAB_BETWEEN,
                        fix (fixer) {
                            return fixer.replaceTextRange([
                                current.range[1],
                                after.range[0]
                            ], ` `);
                        }
                    });
                }
            });
        }
        /**
     * @param {OpenScriptTagStart | OpenTagStart | OpenStyleTagStart} node
     * @param {Attribute} firstAttr
     * @returns
     */ function checkExtraSpaceBefore(node, firstAttr) {
            if (node.loc.start.line !== firstAttr.loc.start.line) // skip the attribute on the different line with the start tag
            return;
            const spacesBetween = firstAttr.loc.start.column - node.loc.end.column;
            if (spacesBetween >= 2) context.report({
                loc: $4d64e4ad9efe6d5f$require$getLocBetween(node, firstAttr),
                messageId: $4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_BEFORE,
                fix (fixer) {
                    return fixer.removeRange([
                        firstAttr.range[0] - spacesBetween + 1,
                        firstAttr.range[0]
                    ]);
                }
            });
            else if (disallowTabs) {
                if (sourceCode[firstAttr.range[0] - 1] === `\t`) context.report({
                    loc: firstAttr.loc,
                    messageId: $4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_TAB_BEFORE,
                    fix (fixer) {
                        return fixer.replaceTextRange([
                            firstAttr.range[0] - 1,
                            firstAttr.range[0]
                        ], ` `);
                    }
                });
            }
        }
        /**
     * @param {Tag | StyleTag | ScriptTag} node
     * @returns
     */ function check(node) {
            if (!node.attributes) return;
            if (node.attributes.length) {
                checkExtraSpaceBefore(node.openStart, node.attributes[0]);
                for (const attr of node.attributes){
                    if (attr.startWrapper && attr.value) {
                        if (disallowInAssignment && attr.startWrapper.loc.start.column - attr.key.loc.end.column > 1) {
                            const start = attr.key.range[1];
                            const end = attr.startWrapper.range[0];
                            context.report({
                                node: attr,
                                messageId: $4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_IN_ASSIGNMENT,
                                fix (fixer) {
                                    return fixer.replaceTextRange([
                                        start,
                                        end
                                    ], `=`);
                                }
                            });
                        }
                    }
                }
            }
            if (node.openEnd) {
                checkExtraSpacesBetweenAttrs(node.attributes);
                const lastAttr = node.attributes[node.attributes.length - 1];
                const nodeBeforeEnd = node.attributes.length === 0 ? node.openStart : lastAttr;
                if (nodeBeforeEnd.loc.end.line !== node.openEnd.loc.start.line) return;
                const isSelfClosing = node.openEnd.value === "/>";
                const spacesBetween = node.openEnd.loc.start.column - nodeBeforeEnd.loc.end.column;
                const locBetween = $4d64e4ad9efe6d5f$require$getLocBetween(nodeBeforeEnd, node.openEnd);
                if (isSelfClosing && enforceBeforeSelfClose) {
                    if (spacesBetween < 1) context.report({
                        loc: locBetween,
                        messageId: $4d64e4ad9efe6d5f$var$MESSAGE_IDS.MISSING_BEFORE_SELF_CLOSE,
                        fix (fixer) {
                            return fixer.insertTextAfter(nodeBeforeEnd, " ");
                        }
                    });
                    else if (spacesBetween === 1) {
                        if (disallowTabs && sourceCode[node.openEnd.range[0] - 1] === `\t`) context.report({
                            loc: node.openEnd.loc,
                            messageId: $4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_TAB_BEFORE_SELF_CLOSE,
                            fix (fixer) {
                                return fixer.replaceTextRange([
                                    node.openEnd.range[0] - 1,
                                    node.openEnd.range[0]
                                ], ` `);
                            }
                        });
                    } else context.report({
                        loc: locBetween,
                        messageId: $4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_BEFORE_SELF_CLOSE,
                        fix (fixer) {
                            return fixer.removeRange([
                                nodeBeforeEnd.range[1] + 1,
                                node.openEnd.range[0]
                            ]);
                        }
                    });
                    return;
                }
                if (spacesBetween > 0) {
                    if (node.attributes.length > 0) context.report({
                        loc: locBetween,
                        messageId: $4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_AFTER,
                        fix (fixer) {
                            return fixer.removeRange([
                                lastAttr.range[1],
                                node.openEnd.range[0]
                            ]);
                        }
                    });
                    else context.report({
                        loc: locBetween,
                        messageId: $4d64e4ad9efe6d5f$var$MESSAGE_IDS.EXTRA_BEFORE_CLOSE,
                        fix (fixer) {
                            return fixer.removeRange([
                                node.openStart.range[1],
                                node.openEnd.range[0]
                            ]);
                        }
                    });
                }
            }
        }
        return $4d64e4ad9efe6d5f$require$createVisitors(context, {
            Tag: check,
            StyleTag: check,
            ScriptTag: check
        });
    }
};


var $dd0615a95c427b06$exports = {};
/**
 * @import {
 *   AnyNode,
 *   Attribute,
 *   OpenScriptTagStart,
 *   OpenStyleTagStart,
 *   OpenTagStart,
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 * @typedef {Object} Option
 * @property {boolean} [Option.disallowInAssignment]
 * @property {boolean} [Option.disallowMissing]
 * @property {boolean} [Option.disallowTabs]
 * @property {boolean} [Option.enforceBeforeSelfClose]
 */ 
var $dd0615a95c427b06$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $dd0615a95c427b06$require$getLocBetween = $7dabedd289de3a0a$exports.getLocBetween;

var $dd0615a95c427b06$require$getSourceCode = $2abd6ce2c4a2d841$exports.getSourceCode;

var $dd0615a95c427b06$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $dd0615a95c427b06$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $dd0615a95c427b06$var$MESSAGE_IDS = {
    EXTRA_BETWEEN: "unexpectedBetween",
    EXTRA_AFTER: "unexpectedAfter",
    EXTRA_BEFORE: "unexpectedBefore",
    EXTRA_BEFORE_CLOSE: "unexpectedBeforeClose",
    EXTRA_IN_ASSIGNMENT: "unexpectedInAssignment",
    MISSING_BEFORE: "missingBefore",
    MISSING_BEFORE_SELF_CLOSE: "missingBeforeSelfClose",
    EXTRA_BEFORE_SELF_CLOSE: "unexpectedBeforeSelfClose",
    EXTRA_TAB_BEFORE: "unexpectedTabBefore",
    EXTRA_TAB_BEFORE_SELF_CLOSE: "unexpectedTabBeforeSelfClose",
    EXTRA_TAB_BETWEEN: "unexpectedTabBetween"
};
/** @type {RuleModule<[Option]>} */ $dd0615a95c427b06$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow extra spacing inside tags",
            category: $dd0615a95c427b06$require$RULE_CATEGORY.STYLE,
            recommended: true,
            url: $dd0615a95c427b06$require$getRuleUrl("no-extra-spacing-tags")
        },
        fixable: true,
        schema: [
            {
                type: "object",
                properties: {
                    disallowInAssignment: {
                        type: "boolean"
                    },
                    disallowMissing: {
                        type: "boolean"
                    },
                    disallowTabs: {
                        type: "boolean"
                    },
                    enforceBeforeSelfClose: {
                        type: "boolean"
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_BETWEEN]: "Unexpected space between attributes",
            [$dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_AFTER]: "Unexpected space after attribute",
            [$dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_BEFORE]: "Unexpected space before attribute",
            [$dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_BEFORE_CLOSE]: "Unexpected space before closing",
            [$dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_IN_ASSIGNMENT]: "Unexpected space in attribute assignment",
            [$dd0615a95c427b06$var$MESSAGE_IDS.MISSING_BEFORE_SELF_CLOSE]: "Missing space before self closing",
            [$dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_BEFORE_SELF_CLOSE]: "Unexpected extra spaces before self closing",
            [$dd0615a95c427b06$var$MESSAGE_IDS.MISSING_BEFORE]: "Missing space before attribute",
            [$dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_TAB_BEFORE]: "Unexpected tab before attribute; use space instead",
            [$dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_TAB_BEFORE_SELF_CLOSE]: "Unexpected tab before self closing; use space instead",
            [$dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_TAB_BETWEEN]: "Unexpected tab between attributes; use space instead"
        }
    },
    create (context) {
        const enforceBeforeSelfClose = !!(context.options[0] || {}).enforceBeforeSelfClose;
        const disallowMissing = !!(context.options[0] || {}).disallowMissing;
        const disallowTabs = !!(context.options[0] || {}).disallowTabs;
        const disallowInAssignment = !!(context.options[0] || []).disallowInAssignment;
        const sourceCode = $dd0615a95c427b06$require$getSourceCode(context).text;
        /** @param {Attribute[]} attrs */ function checkExtraSpacesBetweenAttrs(attrs) {
            attrs.forEach((current, index, attrs)=>{
                if (index >= attrs.length - 1) return;
                const after = attrs[index + 1];
                if (current.loc.end.line !== after.loc.start.line) // skip the attributes on the other line
                return;
                const spacesBetween = after.loc.start.column - current.loc.end.column;
                if (spacesBetween > 1) context.report({
                    loc: $dd0615a95c427b06$require$getLocBetween(current, after),
                    messageId: $dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_BETWEEN,
                    fix (fixer) {
                        return fixer.replaceTextRange([
                            current.range[1],
                            after.range[0]
                        ], ` `);
                    }
                });
                else if (disallowMissing && spacesBetween < 1) context.report({
                    loc: after.loc,
                    messageId: $dd0615a95c427b06$var$MESSAGE_IDS.MISSING_BEFORE,
                    fix (fixer) {
                        return fixer.insertTextAfter(current, " ");
                    }
                });
                else if (disallowTabs) {
                    if (sourceCode[current.range[1]] === `\t`) context.report({
                        loc: $dd0615a95c427b06$require$getLocBetween(current, after),
                        messageId: $dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_TAB_BETWEEN,
                        fix (fixer) {
                            return fixer.replaceTextRange([
                                current.range[1],
                                after.range[0]
                            ], ` `);
                        }
                    });
                }
            });
        }
        /**
     * @param {OpenScriptTagStart | OpenTagStart | OpenStyleTagStart} node
     * @param {Attribute} firstAttr
     * @returns
     */ function checkExtraSpaceBefore(node, firstAttr) {
            if (node.loc.start.line !== firstAttr.loc.start.line) // skip the attribute on the different line with the start tag
            return;
            const spacesBetween = firstAttr.loc.start.column - node.loc.end.column;
            if (spacesBetween >= 2) context.report({
                loc: $dd0615a95c427b06$require$getLocBetween(node, firstAttr),
                messageId: $dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_BEFORE,
                fix (fixer) {
                    return fixer.removeRange([
                        firstAttr.range[0] - spacesBetween + 1,
                        firstAttr.range[0]
                    ]);
                }
            });
            else if (disallowTabs) {
                if (sourceCode[firstAttr.range[0] - 1] === `\t`) context.report({
                    loc: firstAttr.loc,
                    messageId: $dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_TAB_BEFORE,
                    fix (fixer) {
                        return fixer.replaceTextRange([
                            firstAttr.range[0] - 1,
                            firstAttr.range[0]
                        ], ` `);
                    }
                });
            }
        }
        /**
     * @param {Tag | StyleTag | ScriptTag} node
     * @returns
     */ function check(node) {
            if (!node.attributes) return;
            if (node.attributes.length) {
                checkExtraSpaceBefore(node.openStart, node.attributes[0]);
                for (const attr of node.attributes){
                    if (attr.startWrapper && attr.value) {
                        if (disallowInAssignment && attr.startWrapper.loc.start.column - attr.key.loc.end.column > 1) {
                            const start = attr.key.range[1];
                            const end = attr.startWrapper.range[0];
                            context.report({
                                node: attr,
                                messageId: $dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_IN_ASSIGNMENT,
                                fix (fixer) {
                                    return fixer.replaceTextRange([
                                        start,
                                        end
                                    ], `=`);
                                }
                            });
                        }
                    }
                }
            }
            if (node.openEnd) {
                checkExtraSpacesBetweenAttrs(node.attributes);
                const lastAttr = node.attributes[node.attributes.length - 1];
                const nodeBeforeEnd = node.attributes.length === 0 ? node.openStart : lastAttr;
                if (nodeBeforeEnd.loc.end.line !== node.openEnd.loc.start.line) return;
                const isSelfClosing = node.openEnd.value === "/>";
                const spacesBetween = node.openEnd.loc.start.column - nodeBeforeEnd.loc.end.column;
                const locBetween = $dd0615a95c427b06$require$getLocBetween(nodeBeforeEnd, node.openEnd);
                if (isSelfClosing && enforceBeforeSelfClose) {
                    if (spacesBetween < 1) context.report({
                        loc: locBetween,
                        messageId: $dd0615a95c427b06$var$MESSAGE_IDS.MISSING_BEFORE_SELF_CLOSE,
                        fix (fixer) {
                            return fixer.insertTextAfter(nodeBeforeEnd, " ");
                        }
                    });
                    else if (spacesBetween === 1) {
                        if (disallowTabs && sourceCode[node.openEnd.range[0] - 1] === `\t`) context.report({
                            loc: node.openEnd.loc,
                            messageId: $dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_TAB_BEFORE_SELF_CLOSE,
                            fix (fixer) {
                                return fixer.replaceTextRange([
                                    node.openEnd.range[0] - 1,
                                    node.openEnd.range[0]
                                ], ` `);
                            }
                        });
                    } else context.report({
                        loc: locBetween,
                        messageId: $dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_BEFORE_SELF_CLOSE,
                        fix (fixer) {
                            return fixer.removeRange([
                                nodeBeforeEnd.range[1] + 1,
                                node.openEnd.range[0]
                            ]);
                        }
                    });
                    return;
                }
                if (spacesBetween > 0) {
                    if (node.attributes.length > 0) context.report({
                        loc: locBetween,
                        messageId: $dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_AFTER,
                        fix (fixer) {
                            return fixer.removeRange([
                                lastAttr.range[1],
                                node.openEnd.range[0]
                            ]);
                        }
                    });
                    else context.report({
                        loc: locBetween,
                        messageId: $dd0615a95c427b06$var$MESSAGE_IDS.EXTRA_BEFORE_CLOSE,
                        fix (fixer) {
                            return fixer.removeRange([
                                node.openStart.range[1],
                                node.openEnd.range[0]
                            ]);
                        }
                    });
                }
            }
        }
        return $dd0615a95c427b06$require$createVisitors(context, {
            Tag: check,
            StyleTag: check,
            ScriptTag: check
        });
    }
};


var $ea2a92963957e180$exports = {};
/**
 * @import {
 *   Comment,
 *   CommentContent,
 *   Tag,
 *   Text
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 * @typedef {Object} Option
 * @property {string[]} [Option.skip]
 */ 
var $ea2a92963957e180$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $ea2a92963957e180$require$isTag = $7dabedd289de3a0a$exports.isTag;
var $ea2a92963957e180$require$isOverlapWithTemplates = $7dabedd289de3a0a$exports.isOverlapWithTemplates;

var $ea2a92963957e180$require$getSourceCode = $2abd6ce2c4a2d841$exports.getSourceCode;

var $ea2a92963957e180$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $ea2a92963957e180$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $ea2a92963957e180$var$MESSAGE_IDS = {
    UNEXPECTED: "unexpected"
};
/** @type {RuleModule<[Option]>} */ $ea2a92963957e180$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow unnecessary consecutive spaces",
            category: $ea2a92963957e180$require$RULE_CATEGORY.STYLE,
            recommended: false,
            url: $ea2a92963957e180$require$getRuleUrl("no-extra-spacing-text")
        },
        fixable: true,
        schema: [
            {
                type: "object",
                properties: {
                    skip: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$ea2a92963957e180$var$MESSAGE_IDS.UNEXPECTED]: "Tabs and/or multiple consecutive spaces not allowed here"
        }
    },
    create (context) {
        const options = context.options[0] || {};
        /** @type {string[]} */ const skipTags = options.skip || [];
        const sourceCode = $ea2a92963957e180$require$getSourceCode(context);
        /** @type {Tag[]} */ const tagStack = [];
        /**
     * @param {Comment | Text} node
     * @returns {boolean}
     */ function hasSkipTagOnParent(node) {
            // @ts-ignore
            const { parent: parent } = node;
            if (parent && // @ts-ignore
            $ea2a92963957e180$require$isTag(parent) && skipTags.some((skipTag)=>skipTag === parent.name)) return true;
            return false;
        }
        /** @param {CommentContent | Text} node */ function stripConsecutiveSpaces(node) {
            const text = node.value;
            const matcher = /(^|[^\n \t])([ \t]+\n|\t[\t ]*|[ \t]{2,})/g;
            while(true){
                const offender = matcher.exec(text);
                if (offender === null) break;
                const space = offender[2];
                const indexStart = node.range[0] + matcher.lastIndex - space.length;
                const indexEnd = indexStart + space.length;
                const hasOverlap = $ea2a92963957e180$require$isOverlapWithTemplates(node.parts, [
                    indexStart,
                    indexEnd
                ]);
                if (hasOverlap) return;
                context.report({
                    node: node,
                    loc: {
                        start: sourceCode.getLocFromIndex(indexStart),
                        end: sourceCode.getLocFromIndex(indexEnd)
                    },
                    messageId: $ea2a92963957e180$var$MESSAGE_IDS.UNEXPECTED,
                    fix (fixer) {
                        return fixer.replaceTextRange([
                            indexStart,
                            indexEnd
                        ], space.endsWith(`\n`) ? `\n` : ` `);
                    }
                });
            }
        }
        return $ea2a92963957e180$require$createVisitors(context, {
            Comment (node) {
                if (hasSkipTagOnParent(node)) return;
                stripConsecutiveSpaces(node.value);
            },
            Text (node) {
                if (hasSkipTagOnParent(node)) return;
                stripConsecutiveSpaces(node);
            },
            Tag (node) {
                tagStack.push(node);
                if (skipTags.some((skipTag)=>tagStack.some((tag)=>tag.name === skipTag))) return;
            },
            "Tag:exit" () {
                tagStack.pop();
            }
        });
    }
};


var $6ed6c53bbac913f8$exports = {};
/**
 * @import {
 *   RuleFixer,
 *   RuleModule
 * } from "../types"
 * @typedef {Object} MessageId
 * @property {"closeStyleWrong"} CLOSE_STYLE_WRONG
 * @property {"newlineMissing"} NEWLINE_MISSING
 *
 * @typedef {Object} Option
 * @property {"sameline" | "newline"} [option.closeStyle]
 * @property {number} [options.ifAttrsMoreThan]
 * @property {string[]} [options.skip]
 * @property {string[]} [options.inline]
 */ 
var $6ed6c53bbac913f8$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $6ed6c53bbac913f8$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $6ed6c53bbac913f8$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
/** @type {MessageId} */ const $6ed6c53bbac913f8$var$MESSAGE_ID = {
    CLOSE_STYLE_WRONG: "closeStyleWrong",
    NEWLINE_MISSING: "newlineMissing"
};
/** @type {Object<string, string[]>} */ const $6ed6c53bbac913f8$var$PRESETS = {
    // From https://developer.mozilla.org/en-US/docs/Web/HTML/Element#inline_text_semantics
    $inline: `
a
abbr
b
bdi
bdo
br
cite
code
data
dfn
em
i
kbd
mark
q
rp
rt
ruby
s
samp
small
span
strong
sub
sup
time
u
var
wbr
  `.trim().split(`\n`)
};
/**
 * Expand preset tokens (e.g. "$inline") into the corresponding tag list.
 *
 * @param {string[]} options
 * @returns {string[]}
 */ function $6ed6c53bbac913f8$var$optionsOrPresets(options) {
    const result = [];
    for (const option of options)if (option in $6ed6c53bbac913f8$var$PRESETS) result.push(...$6ed6c53bbac913f8$var$PRESETS[option]);
    else result.push(option);
    return result;
}
/** @type {RuleModule<[Option]>} */ $6ed6c53bbac913f8$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Enforce newline between attributes",
            category: $6ed6c53bbac913f8$require$RULE_CATEGORY.STYLE,
            recommended: true,
            url: $6ed6c53bbac913f8$require$getRuleUrl("attrs-newline")
        },
        fixable: true,
        schema: [
            {
                type: "object",
                properties: {
                    closeStyle: {
                        enum: [
                            "newline",
                            "sameline"
                        ]
                    },
                    ifAttrsMoreThan: {
                        type: "integer"
                    },
                    skip: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    },
                    inline: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$6ed6c53bbac913f8$var$MESSAGE_ID.CLOSE_STYLE_WRONG]: "Closing bracket was on {{actual}}; expected {{expected}}",
            [$6ed6c53bbac913f8$var$MESSAGE_ID.NEWLINE_MISSING]: "Newline expected before {{attrName}}"
        }
    },
    create (context) {
        const options = context.options[0] || {};
        const attrMin = typeof options.ifAttrsMoreThan !== "number" ? 2 : options.ifAttrsMoreThan;
        const closeStyle = options.closeStyle || "newline";
        const skipTags = $6ed6c53bbac913f8$var$optionsOrPresets(options.skip || []);
        const inlineTags = $6ed6c53bbac913f8$var$optionsOrPresets(options.inline || []);
        /**
     * Tracks nesting depth inside `skip` elements. When > 0, the current node
     * is a descendant of a skipped element.
     *
     * @type {number}
     */ let skipDepth = 0;
        return $6ed6c53bbac913f8$require$createVisitors(context, {
            "Tag:exit" () {
                if (skipDepth > 0) skipDepth--;
            },
            Tag (node) {
                const tagName = node.name.toLowerCase();
                // Inside a skip ancestor — skip this descendant too.
                if (skipDepth > 0) {
                    skipDepth++;
                    return;
                }
                // This tag is in skip — suppress the rule AND its descendants.
                if (skipTags.includes(tagName)) {
                    skipDepth++;
                    return;
                }
                // This tag is in inline — suppress only this tag; descendants are still checked.
                if (inlineTags.includes(tagName)) return;
                const shouldBeMultiline = node.attributes.length > attrMin;
                if (!shouldBeMultiline) return;
                /**
         * This doesn't do any indentation, so the result will look silly.
         * Indentation should be covered by the `indent` rule
         *
         * @param {RuleFixer} fixer
         */ function fix(fixer) {
                    let expected = node.openStart.value;
                    for (const attr of node.attributes){
                        expected += `\n${attr.key.value}`;
                        if (attr.value) {
                            const startWrapper = attr.startWrapper ? attr.startWrapper.value : "";
                            const endWrapper = attr.endWrapper ? attr.endWrapper.value : "";
                            expected += `=${startWrapper}${attr.value.value}${endWrapper}`;
                        }
                    }
                    if (closeStyle === "newline") expected += "\n";
                    else if (node.selfClosing) expected += " ";
                    expected += node.openEnd.value;
                    return fixer.replaceTextRange([
                        node.openStart.range[0],
                        node.openEnd.range[1]
                    ], expected);
                }
                let index = 0;
                for (const attr of node.attributes){
                    const attrPrevious = node.attributes[index - 1];
                    const relativeToNode = attrPrevious || node.openStart;
                    if (attr.loc.start.line === relativeToNode.loc.end.line) return context.report({
                        node: node,
                        data: {
                            attrName: attr.key.value
                        },
                        fix: fix,
                        messageId: $6ed6c53bbac913f8$var$MESSAGE_ID.NEWLINE_MISSING
                    });
                    index += 1;
                }
                const attrLast = node.attributes[node.attributes.length - 1];
                const closeStyleActual = node.openEnd.loc.start.line === attrLast.loc.end.line ? "sameline" : "newline";
                if (closeStyle !== closeStyleActual) return context.report({
                    node: node,
                    data: {
                        actual: closeStyleActual,
                        expected: closeStyle
                    },
                    fix: fix,
                    messageId: $6ed6c53bbac913f8$var$MESSAGE_ID.CLOSE_STYLE_WRONG
                });
            }
        });
    }
};


var $2225097c51b29b91$exports = {};
/**
 * @import {
 *   AnyNode,
 *   CloseTag,
 *   OpenTagEnd,
 *   Text
 * } from "@html-eslint/types"
 * @import {
 *   Line,
 *   RuleModule
 * } from "../types"
 * @typedef {AnyNode | Line} AnyNodeOrLine
 *
 * @typedef {Object} Option
 * @property {string[]} [Option.skip]
 * @property {string[]} [Option.inline]
 */ 
var $2225097c51b29b91$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $2225097c51b29b91$require$isTag = $7dabedd289de3a0a$exports.isTag;
var $2225097c51b29b91$require$isComment = $7dabedd289de3a0a$exports.isComment;
var $2225097c51b29b91$require$isText = $7dabedd289de3a0a$exports.isText;
var $2225097c51b29b91$require$splitToLineNodes = $7dabedd289de3a0a$exports.splitToLineNodes;
var $2225097c51b29b91$require$isLine = $7dabedd289de3a0a$exports.isLine;
var $2225097c51b29b91$require$isScript = $7dabedd289de3a0a$exports.isScript;
var $2225097c51b29b91$require$isStyle = $7dabedd289de3a0a$exports.isStyle;
var $2225097c51b29b91$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;

var $2225097c51b29b91$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $2225097c51b29b91$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $2225097c51b29b91$var$MESSAGE_IDS = {
    EXPECT_NEW_LINE_AFTER: "expectAfter"
};
/** @type {Object<string, string[]>} */ const $2225097c51b29b91$var$PRESETS = {
    // From https://developer.mozilla.org/en-US/docs/Web/HTML/Element#inline_text_semantics
    $inline: `
a
abbr
b
bdi
bdo
br
cite
code
data
dfn
em
i
kbd
mark
q
rp
rt
ruby
s
samp
small
span
strong
sub
sup
time
u
var
wbr
  `.trim().split(`\n`)
};
/** @type {RuleModule<[Option]>} */ $2225097c51b29b91$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Enforce newline between elements.",
            category: $2225097c51b29b91$require$RULE_CATEGORY.STYLE,
            recommended: true,
            url: $2225097c51b29b91$require$getRuleUrl("element-newline")
        },
        fixable: true,
        schema: [
            {
                type: "object",
                properties: {
                    inline: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    },
                    skip: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$2225097c51b29b91$var$MESSAGE_IDS.EXPECT_NEW_LINE_AFTER]: "There should be a linebreak after {{name}}."
        }
    },
    create (context) {
        const option = context.options[0] || {};
        /** @type {string[]} */ const skipTags = option.skip || [
            "pre",
            "code"
        ];
        const inlineTags = optionsOrPresets(option.inline || []);
        /**
     * @param {AnyNodeOrLine[]} children
     * @returns {Exclude<AnyNodeOrLine, Text>[]}
     */ function getChildrenToCheck(children) {
            /** @type {Exclude<AnyNodeOrLine, Text>[]} */ const childrenToCheck = [];
            for (const child of children){
                if ($2225097c51b29b91$require$isText(child)) {
                    const lines = $2225097c51b29b91$require$splitToLineNodes(child);
                    childrenToCheck.push(...lines);
                    continue;
                }
                childrenToCheck.push(child);
            }
            return childrenToCheck.filter((child)=>!isEmptyText(child));
        }
        /**
     * @param {AnyNodeOrLine} before
     * @param {AnyNodeOrLine} after
     * @returns {boolean}
     */ function isOnTheSameLine(before, after) {
            return before.loc.end.line === after.loc.start.line;
        }
        /**
     * @param {AnyNode} node
     * @returns {boolean}
     */ function shouldSkipChildren(node) {
            if ($2225097c51b29b91$require$isTag(node)) {
                if (skipTags.includes($2225097c51b29b91$require$getNameOf(node))) return true;
                if (node.children.some((child)=>child.type === "RawContent")) return true;
            }
            return false;
        }
        /**
     * @param {AnyNodeOrLine} node
     * @returns {boolean}
     */ function isInline(node) {
            return $2225097c51b29b91$require$isLine(node) || $2225097c51b29b91$require$isTag(node) && inlineTags.includes($2225097c51b29b91$require$getNameOf(node));
        }
        /**
     * @param {AnyNode[]} children
     * @param {AnyNode} parent
     * @param {[OpenTagEnd, CloseTag]} [wrapper]
     */ function checkChildren(children, parent, wrapper) {
            if (shouldSkipChildren(parent)) return;
            const childrenToCheck = getChildrenToCheck(children);
            const firstChild = childrenToCheck[0];
            if (wrapper && firstChild && childrenToCheck.some((child)=>!isInline(child))) {
                const open = wrapper[0];
                if (isOnTheSameLine(open, firstChild)) context.report({
                    node: open,
                    messageId: $2225097c51b29b91$var$MESSAGE_IDS.EXPECT_NEW_LINE_AFTER,
                    data: {
                        name: getName(parent)
                    },
                    fix (fixer) {
                        return fixer.insertTextAfter(open, `\n`);
                    }
                });
            }
            childrenToCheck.forEach((current, index)=>{
                const next = childrenToCheck[index + 1];
                if (!next || !isOnTheSameLine(current, next) || isInline(current) && isInline(next)) return;
                context.report({
                    node: current,
                    messageId: $2225097c51b29b91$var$MESSAGE_IDS.EXPECT_NEW_LINE_AFTER,
                    data: {
                        name: getName(current, {
                            isClose: true
                        })
                    },
                    fix (fixer) {
                        return fixer.insertTextAfter(current, `\n`);
                    }
                });
            });
            childrenToCheck.forEach((child)=>{
                if ($2225097c51b29b91$require$isTag(child)) {
                    /** @type {[OpenTagEnd, CloseTag] | undefined} */ const wrapper = child.close ? [
                        child.openEnd,
                        child.close
                    ] : undefined;
                    checkChildren(child.children, child, wrapper);
                }
            });
            const lastChild = childrenToCheck[childrenToCheck.length - 1];
            if (wrapper && lastChild && childrenToCheck.some((child)=>!isInline(child))) {
                const close = wrapper[1];
                if (isOnTheSameLine(close, lastChild)) context.report({
                    node: lastChild,
                    messageId: $2225097c51b29b91$var$MESSAGE_IDS.EXPECT_NEW_LINE_AFTER,
                    data: {
                        name: getName(lastChild, {
                            isClose: true
                        })
                    },
                    fix (fixer) {
                        return fixer.insertTextAfter(lastChild, `\n`);
                    }
                });
            }
        }
        /**
     * @param {AnyNodeOrLine} node
     * @returns {boolean}
     */ function isEmptyText(node) {
            return $2225097c51b29b91$require$isText(node) && node.value.trim().length === 0 || $2225097c51b29b91$require$isLine(node) && node.value.trim().length === 0;
        }
        /**
     * @param {AnyNodeOrLine} node
     * @param {{ isClose?: boolean }} options
     */ function getName(node, options = {}) {
            const isClose = options.isClose || false;
            if ($2225097c51b29b91$require$isTag(node)) {
                if (isClose) return `</${node.name}>`;
                return `<${node.name}>`;
            }
            if ($2225097c51b29b91$require$isLine(node)) return "text";
            if ($2225097c51b29b91$require$isComment(node)) return "comment";
            if ($2225097c51b29b91$require$isScript(node)) {
                if (isClose) return `</script>`;
                return "<script>";
            }
            if ($2225097c51b29b91$require$isStyle(node)) {
                if (isClose) return `</style>`;
                return "<style>";
            }
            return `<${node.type}>`;
        }
        /** @param {string[]} options */ function optionsOrPresets(options) {
            const result = [];
            for (const option of options)if (option in $2225097c51b29b91$var$PRESETS) {
                const preset = $2225097c51b29b91$var$PRESETS[option];
                result.push(...preset);
            } else result.push(option);
            return result;
        }
        return $2225097c51b29b91$require$createVisitors(context, {
            Document (node) {
                checkChildren(node.children, node);
            }
        });
    }
};


var $4432e2472621352e$exports = {};
/**
 * @import {Tag} from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $4432e2472621352e$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $4432e2472621352e$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $4432e2472621352e$var$MESSAGE_IDS = {
    UNEXPECTED: "unexpected"
};
/** @type {RuleModule<[]>} */ $4432e2472621352e$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow skipping heading levels",
            category: $4432e2472621352e$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $4432e2472621352e$require$getRuleUrl("no-skip-heading-levels")
        },
        fixable: null,
        schema: [],
        messages: {
            [$4432e2472621352e$var$MESSAGE_IDS.UNEXPECTED]: "Unexpected skipping heading level. <h{{expected}}> is expected"
        }
    },
    create (context) {
        /** @type {{ node: Tag; level: number }[]} */ const headings = [];
        return {
            Tag (node) {
                if (![
                    "h1",
                    "h2",
                    "h3",
                    "h4",
                    "h5",
                    "h6"
                ].includes(node.name)) return;
                headings.push({
                    node: node,
                    level: parseInt(node.name.replace("h", ""), 10)
                });
            },
            "Document:exit" () {
                if (headings.length <= 1) return;
                headings.sort((a, b)=>a.node.range[0] - b.node.range[0]);
                headings.forEach((current, index)=>{
                    const next = headings[index + 1];
                    if (next) {
                        if (next.level - current.level > 1) context.report({
                            node: next.node,
                            data: {
                                expected: String(current.level + 1)
                            },
                            messageId: $4432e2472621352e$var$MESSAGE_IDS.UNEXPECTED
                        });
                    }
                });
            }
        };
    }
};


var $50316cf58633e636$exports = {};
var $d7b6c5a4b4d25cc2$exports = {};
/**
 * @import {
 *   AnyNode,
 *   CloseTemplate,
 *   OpenTemplate,
 *   ScriptTag,
 *   StyleTag,
 *   Tag,
 *   TemplateLiteral,
 *   TemplateText,
 *   Text
 * } from "@html-eslint/types"
 * @import {AST} from "eslint"
 * @import {
 *   Context,
 *   Line,
 *   RuleListener,
 *   RuleModule
 * } from "../../types"
 * @typedef {AnyNode | Line} AnyNodeOrLine
 *
 * @typedef {Object} IndentType
 * @property {"tab"} TAB
 * @property {"space"} SPACE
 *
 * @typedef {Object} MessageId
 * @property {"wrongIndent"} WRONG_INDENT
 *
 * @typedef {Object} IndentOptionInfo
 * @property {IndentType["TAB"] | IndentType["SPACE"]} indentType
 * @property {number} indentSize
 * @property {string} indentChar
 *
 * @typedef {"tab" | number} Option1
 *
 * @typedef {Object} Option2
 * @property {number} [Option2.Attribute]
 * @property {Record<string, number>} [Option2.tagChildrenIndent]
 * @property {boolean} [Option2.ignoreComment]
 * @property {"first" | "templateTag"} [Option2.templateIndentBase]
 */ 
var $d7b6c5a4b4d25cc2$require$parseTemplateLiteral = $7038c80d40859759$exports.parseTemplateLiteral;

var $d7b6c5a4b4d25cc2$require$NODE_TYPES = $f03705736c6cdfcd$exports.NODE_TYPES;

var $d7b6c5a4b4d25cc2$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $d7b6c5a4b4d25cc2$require$splitToLineNodes = $7dabedd289de3a0a$exports.splitToLineNodes;
var $d7b6c5a4b4d25cc2$require$isLine = $7dabedd289de3a0a$exports.isLine;
var $d7b6c5a4b4d25cc2$require$isTag = $7dabedd289de3a0a$exports.isTag;
var $d7b6c5a4b4d25cc2$require$isScript = $7dabedd289de3a0a$exports.isScript;
var $d7b6c5a4b4d25cc2$require$isStyle = $7dabedd289de3a0a$exports.isStyle;
var $d7b6c5a4b4d25cc2$require$isText = $7dabedd289de3a0a$exports.isText;
var $d7b6c5a4b4d25cc2$require$isRangesOverlap = $7dabedd289de3a0a$exports.isRangesOverlap;

var $d7b6c5a4b4d25cc2$require$shouldCheckTaggedTemplateExpression = $82257e454733f104$exports.shouldCheckTaggedTemplateExpression;
var $d7b6c5a4b4d25cc2$require$shouldCheckTemplateLiteral = $82257e454733f104$exports.shouldCheckTemplateLiteral;

var $d7b6c5a4b4d25cc2$require$getSourceCode = $2abd6ce2c4a2d841$exports.getSourceCode;
var $8361ca4d5fca74b2$exports = {};
/**
 * @import {AnyNode} from "@html-eslint/types"
 * @typedef {{ [key in AnyNode["type"]]?: number }} IncLevelOptions
 *
 * @typedef {(node: AnyNode) => number} GetIncreasingLevel
 */ class $8361ca4d5fca74b2$var$IndentLevel {
    /**
   * @param {Object} config
   * @param {GetIncreasingLevel} config.getIncreasingLevel
   */ constructor(config){
        /**
     * @private
     * @member
     * @type {number}
     */ this.level = -1;
        /**
     * @private
     * @member
     * @type {number}
     */ this.baseLevel = 0;
        /**
     * @private
     * @member
     */ this.getInc = config.getIncreasingLevel;
    }
    /** @returns {number} */ value() {
        return this.level + this.baseLevel;
    }
    /** @param {AnyNode} node */ indent(node) {
        this.level += this.getInc(node);
    }
    /** @param {AnyNode} node */ dedent(node) {
        this.level -= this.getInc(node);
    }
    /** @param {number} base */ setBase(base) {
        this.baseLevel = base;
    }
}
$8361ca4d5fca74b2$exports = $8361ca4d5fca74b2$var$IndentLevel;


/** @type {MessageId} */ const $d7b6c5a4b4d25cc2$var$MESSAGE_ID = {
    WRONG_INDENT: "wrongIndent"
};
/** @type {IndentType} */ const $d7b6c5a4b4d25cc2$var$INDENT_TYPES = {
    TAB: "tab",
    SPACE: "space"
};
const $d7b6c5a4b4d25cc2$var$IGNORING_NODES = [
    "pre",
    "xmp"
];
/** @type {RuleModule<[Option1, Option2]>} */ $d7b6c5a4b4d25cc2$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Enforce consistent indentation",
            category: $d7b6c5a4b4d25cc2$require$RULE_CATEGORY.STYLE,
            recommended: true
        },
        fixable: true,
        schema: [
            {
                oneOf: [
                    {
                        enum: [
                            "tab"
                        ]
                    },
                    {
                        type: "integer",
                        minimum: 0
                    }
                ]
            },
            {
                type: "object",
                properties: {
                    Attribute: {
                        type: "integer",
                        minimum: 1,
                        default: 1
                    },
                    tagChildrenIndent: {
                        default: {},
                        type: "object",
                        patternProperties: {
                            "^[a-z]+$": {
                                type: "integer",
                                minimum: 0
                            }
                        },
                        additionalProperties: false
                    },
                    ignoreComment: {
                        type: "boolean",
                        default: false
                    },
                    templateIndentBase: {
                        type: "string",
                        enum: [
                            "first",
                            "templateTag"
                        ],
                        default: "templateTag"
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$d7b6c5a4b4d25cc2$var$MESSAGE_ID.WRONG_INDENT]: "Expected indentation of {{expected}} but found {{actual}}."
        }
    },
    create (context) {
        const sourceCode = $d7b6c5a4b4d25cc2$require$getSourceCode(context);
        const indentLevelOptions = context.options && context.options[1] || {};
        const lines = sourceCode.getLines();
        const ignoreComment = indentLevelOptions.ignoreComment === true;
        const autoBaseIndent = indentLevelOptions.templateIndentBase === "first";
        const { indentType: indentType, indentSize: indentSize, indentChar: indentChar } = $d7b6c5a4b4d25cc2$var$getIndentOptionInfo(context);
        /** @type {number[]} */ const visitedTextLines = [];
        /**
     * @param {Tag | ScriptTag | StyleTag | Text} node
     * @returns {number}
     */ function getTagIncreasingLevel(node) {
            if (node.parent && $d7b6c5a4b4d25cc2$require$isTag(node.parent) && indentLevelOptions && typeof indentLevelOptions.tagChildrenIndent === "object" && indentLevelOptions.tagChildrenIndent) {
                const option = indentLevelOptions.tagChildrenIndent[node.parent.name.toLowerCase()];
                if (typeof option === "number") return option;
            }
            return 1;
        }
        /**
     * @param {AnyNode} node
     * @returns {number}
     */ function getIncreasingLevel(node) {
            if ($d7b6c5a4b4d25cc2$require$isLine(node)) return 1;
            if ($d7b6c5a4b4d25cc2$require$isTag(node) || $d7b6c5a4b4d25cc2$require$isScript(node) || $d7b6c5a4b4d25cc2$require$isStyle(node) || $d7b6c5a4b4d25cc2$require$isText(node)) return getTagIncreasingLevel(node);
            if (node.type === $d7b6c5a4b4d25cc2$require$NODE_TYPES.Attribute) {
                const optionIndent = indentLevelOptions[node.type];
                if (typeof optionIndent === "number") return optionIndent;
            }
            return 1;
        }
        /**
     * @param {TemplateLiteral} node
     * @returns {number}
     */ function getAutoBaseSpaces(node) {
            if (!autoBaseIndent) return 0;
            const startLineIndex = node.loc.start.line;
            const endLineIndex = node.loc.end.line - 1;
            const templateLines = lines.slice(startLineIndex, endLineIndex);
            for(let i = 0; i < templateLines.length; i++){
                const line = templateLines[i];
                if (line.trim()) return $d7b6c5a4b4d25cc2$var$countLeftPadding(line);
            }
            return 0;
        }
        /**
     * @param {TemplateLiteral} node
     * @returns {number}
     */ function getTemplateLiteralBaseIndentLevel(node) {
            if (autoBaseIndent) return 0;
            // @ts-ignore
            const lineIndex = node.loc.start.line - 1;
            const line = lines[lineIndex];
            const spaceCount = $d7b6c5a4b4d25cc2$var$countLeftPadding(line);
            if (indentType === "space") return Math.floor(spaceCount / indentSize) + 1;
            else return spaceCount + 1;
        }
        /**
     * Returns true when a line with hasCloseTemplate should skip indent check.
     * Skip when there is non-whitespace content before the close delimiter on
     * the line, meaning the line is a template expression continuation rather
     * than an HTML-structural closing line.
     *
     * In template literal context, additional ESLint token checks are applied
     * to avoid false positives (e.g. `})}` or single-token expressions like
     * `${\ncontent}`).
     *
     * @param {Line} lineNode
     * @param {Text["parts"]} parts
     * @param {boolean} inTemplateLiteral
     * @returns {boolean}
     */ function shouldSkipCloseTemplateLine(lineNode, parts, inTemplateLiteral) {
            const sourceLines = sourceCode.getLines();
            for (const part of parts || []){
                if (part.type !== $d7b6c5a4b4d25cc2$require$NODE_TYPES.Template || !part.close || !$d7b6c5a4b4d25cc2$require$isRangesOverlap(part.close.range, lineNode.range)) continue;
                // Skip this part if only whitespace precedes the close delimiter on the line
                const closeLineContent = sourceLines[part.close.loc.start.line - 1];
                const contentBeforeClose = closeLineContent.slice(0, part.close.loc.start.column);
                if (!contentBeforeClose.trim()) continue;
                if (inTemplateLiteral) {
                    // In template literal context, use ESLint tokens for precise detection
                    // to avoid false positives (e.g. `})}` or `${\ncontent}`)
                    const closeToken = sourceCode.getTokenByRangeStart(part.close.range[0]);
                    if (!closeToken) continue;
                    // Walk backward to find the leftmost token on the current line
                    let prevToken = sourceCode.getTokenBefore(closeToken);
                    let firstTokenOnLine = null;
                    while(prevToken && prevToken.loc.start.line === lineNode.loc.start.line){
                        firstTokenOnLine = prevToken;
                        prevToken = sourceCode.getTokenBefore(prevToken);
                    }
                    // No token before close delimiter → it is first → don't skip
                    if (!firstTokenOnLine) continue;
                    // Line starts with the same value as the close delimiter (e.g. `})}`) → don't skip
                    if (firstTokenOnLine.value === part.close.value) continue;
                    // If prevToken starts before the expression opened, it is the
                    // enclosing template literal — firstTokenOnLine is the only
                    // expression token, so don't skip (e.g. `${\ncontent}`).
                    // Nested templates inside the expression have range[0] after
                    // part.open.range[1] and are not caught by this check.
                    if (!prevToken || !part.open || prevToken.range[0] < part.open.range[1]) continue;
                }
                return true;
            }
            return false;
        }
        /**
     * @param {number} baseLevel
     * @param {number} baseSpaces
     * @param {boolean} [inTemplateLiteral]
     */ function createIndentVisitor(baseLevel, baseSpaces, inTemplateLiteral = false) {
            const indentLevel = new $8361ca4d5fca74b2$exports({
                getIncreasingLevel: getIncreasingLevel
            });
            indentLevel.setBase(baseLevel);
            let parentIgnoringChildCount = 0;
            /**
       * @param {AnyNode | Line | TemplateText | OpenTemplate} node
       * @returns {string}
       */ function getActualIndent(node) {
                const lines = sourceCode.getLines();
                const line = lines[node.loc.start.line - 1];
                let { column: column } = node.loc.start;
                if ($d7b6c5a4b4d25cc2$require$isLine(node)) column += $d7b6c5a4b4d25cc2$var$countLeftPadding(node.value);
                return line.slice(0, column);
            }
            /** @returns {string} */ function getExpectedIndent() {
                let base = "";
                if (indentType === "space") base = " ".repeat(baseSpaces);
                else base = indentChar.repeat(baseSpaces);
                return base + indentChar.repeat(indentLevel.value());
            }
            /**
       * @param {string} actualIndent
       * @param {number} expectedIndentSize
       */ function getMessageData(actualIndent, expectedIndentSize) {
                const actualTabs = (actualIndent.match(/\t/g) || []).length;
                const actualSpaces = (actualIndent.match(/[^\S\t\n\r]/g) || []).length;
                let actual = "";
                if (!actualTabs && !actualSpaces) actual = "no indent";
                else {
                    if (actualTabs) actual += `${actualTabs} tab`;
                    if (actualSpaces) {
                        if (actual) actual += ", ";
                        actual += `${actualSpaces} space`;
                    }
                }
                if (indentType === "space") expectedIndentSize *= indentSize;
                return {
                    actual: actual,
                    expected: `${expectedIndentSize} ${indentType}`
                };
            }
            /** @param {AnyNode | Line | TemplateText | OpenTemplate} node */ function checkIndent(node) {
                if (parentIgnoringChildCount > 0) return;
                const actualIndent = getActualIndent(node);
                const expectedIndent = getExpectedIndent();
                if (actualIndent.trim().length) return;
                if (actualIndent !== expectedIndent) {
                    const targetNode = $d7b6c5a4b4d25cc2$var$getIndentNodeToReport(node, actualIndent);
                    context.report({
                        loc: targetNode.loc,
                        messageId: $d7b6c5a4b4d25cc2$var$MESSAGE_ID.WRONG_INDENT,
                        data: getMessageData(actualIndent, indentLevel.value()),
                        fix (fixer) {
                            return fixer.replaceTextRange(targetNode.range, expectedIndent);
                        }
                    });
                }
            }
            /** @type {RuleListener} */ const commentVisitor = {
                Comment (node) {
                    indentLevel.indent(node);
                },
                CommentOpen: checkIndent,
                CommentContent (node) {
                    indentLevel.indent(node);
                    const lineNodes = $d7b6c5a4b4d25cc2$require$splitToLineNodes(node);
                    lineNodes.forEach((lineNode)=>{
                        if (lineNode.isOverlapTemplate && !lineNode.hasCloseTemplate && !lineNode.hasOpenTemplate) return;
                        if (lineNode.value.trim().length) checkIndent(lineNode);
                    });
                },
                CommentClose: checkIndent,
                "Comment:exit" (node) {
                    indentLevel.dedent(node);
                },
                "CommentContent:exit" (node) {
                    indentLevel.dedent(node);
                }
            };
            /** @type {RuleListener} */ const visitor = {
                Tag (node) {
                    if ($d7b6c5a4b4d25cc2$var$IGNORING_NODES.includes(node.name)) parentIgnoringChildCount++;
                    indentLevel.indent(node);
                },
                ScriptTag (node) {
                    indentLevel.indent(node);
                },
                "ScriptTag:exit" (node) {
                    indentLevel.dedent(node);
                },
                OpenScriptTagStart: checkIndent,
                OpenScriptTagEnd: checkIndent,
                CloseScriptTag: checkIndent,
                StyleTag (node) {
                    indentLevel.indent(node);
                },
                "StyleTag:exit" (node) {
                    indentLevel.dedent(node);
                },
                OpenStyleTagStart: checkIndent,
                OpenStyleTagEnd: checkIndent,
                CloseStyleTag: checkIndent,
                OpenTagStart: checkIndent,
                OpenTagEnd (node) {
                    checkIndent(node);
                },
                CloseTag: checkIndent,
                "Tag:exit" (node) {
                    if ($d7b6c5a4b4d25cc2$var$IGNORING_NODES.includes(node.name)) parentIgnoringChildCount--;
                    indentLevel.dedent(node);
                },
                Attribute (node) {
                    indentLevel.indent(node);
                },
                AttributeKey: checkIndent,
                AttributeValue: checkIndent,
                "Attribute:exit" (node) {
                    indentLevel.dedent(node);
                },
                Text (node) {
                    indentLevel.indent(node);
                    const lineNodes = $d7b6c5a4b4d25cc2$require$splitToLineNodes(node);
                    lineNodes.forEach((lineNode)=>{
                        if (visitedTextLines.includes(lineNode.loc.start.line)) return;
                        if (lineNode.isOverlapTemplate && !lineNode.hasCloseTemplate && !lineNode.hasOpenTemplate) return;
                        if (lineNode.hasCloseTemplate && !lineNode.hasOpenTemplate && shouldSkipCloseTemplateLine(lineNode, node.parts, inTemplateLiteral)) return;
                        if (lineNode.value.trim().length) {
                            visitedTextLines.push(lineNode.loc.start.line);
                            checkIndent(lineNode);
                        }
                    });
                },
                "Text:exit" (node) {
                    indentLevel.dedent(node);
                },
                ...ignoreComment ? {} : commentVisitor
            };
            return visitor;
        }
        return {
            ...createIndentVisitor(0, 0),
            "TaggedTemplateExpression:exit" (node) {
                if ($d7b6c5a4b4d25cc2$require$shouldCheckTaggedTemplateExpression(node, context)) {
                    const base = getTemplateLiteralBaseIndentLevel(node.quasi);
                    const baseSpaces = getAutoBaseSpaces(node.quasi);
                    $d7b6c5a4b4d25cc2$require$parseTemplateLiteral(node.quasi, $d7b6c5a4b4d25cc2$require$getSourceCode(context), createIndentVisitor(base, baseSpaces, true));
                }
            },
            "TemplateLiteral:exit" (node) {
                if ($d7b6c5a4b4d25cc2$require$shouldCheckTemplateLiteral(node, context)) {
                    const base = getTemplateLiteralBaseIndentLevel(node);
                    const baseSpaces = getAutoBaseSpaces(node);
                    $d7b6c5a4b4d25cc2$require$parseTemplateLiteral(node, $d7b6c5a4b4d25cc2$require$getSourceCode(context), createIndentVisitor(base, baseSpaces, true));
                }
            }
        };
    }
};
/**
 * @param {AnyNodeOrLine | TemplateText | OpenTemplate | CloseTemplate} node
 * @param {string} actualIndent
 * @returns {{ range: AST.Range; loc: AST.SourceLocation }}
 */ function $d7b6c5a4b4d25cc2$var$getIndentNodeToReport(node, actualIndent) {
    let rangeStart = node.range[0];
    if (!$d7b6c5a4b4d25cc2$require$isLine(node)) rangeStart -= actualIndent.length;
    return {
        range: [
            rangeStart,
            rangeStart + actualIndent.length
        ],
        loc: {
            start: {
                column: 0,
                line: node.loc.start.line
            },
            end: {
                column: actualIndent.length,
                line: node.loc.start.line
            }
        }
    };
}
/**
 * @param {string} str
 * @returns {number}
 */ function $d7b6c5a4b4d25cc2$var$countLeftPadding(str) {
    return str.length - str.replace(/^[\s\t]+/, "").length;
}
/**
 * @param {Context<any[]>} context
 * @returns {IndentOptionInfo}
 */ function $d7b6c5a4b4d25cc2$var$getIndentOptionInfo({ options: options }) {
    /** @type {IndentType["SPACE"] | IndentType["TAB"]} */ let indentType = $d7b6c5a4b4d25cc2$var$INDENT_TYPES.SPACE;
    let indentSize = 4;
    if (options.length) {
        if (options[0] === $d7b6c5a4b4d25cc2$var$INDENT_TYPES.TAB) indentType = $d7b6c5a4b4d25cc2$var$INDENT_TYPES.TAB;
        else indentSize = options[0];
    }
    const indentChar = indentType === $d7b6c5a4b4d25cc2$var$INDENT_TYPES.SPACE ? " ".repeat(indentSize) : "\t";
    return {
        indentType: indentType,
        indentSize: indentSize,
        indentChar: indentChar
    };
}


$50316cf58633e636$exports = $d7b6c5a4b4d25cc2$exports;


var $1986d63494746be2$exports = {};
/** @import {RuleModule} from "../types" */ 
var $1986d63494746be2$require$NODE_TYPES = $f03705736c6cdfcd$exports.NODE_TYPES;

var $1986d63494746be2$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $1986d63494746be2$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $1986d63494746be2$var$MESSAGE_IDS = {
    INVALID: "invalid"
};
const $1986d63494746be2$var$VALID_CONTAINERS = [
    "ul",
    "ol",
    "menu"
];
/** @type {RuleModule<[]>} */ $1986d63494746be2$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Enforce `<li>` to be in `<ul>`, `<ol>` or `<menu>`.",
            category: $1986d63494746be2$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: true,
            url: $1986d63494746be2$require$getRuleUrl("require-li-container")
        },
        fixable: null,
        schema: [],
        messages: {
            [$1986d63494746be2$var$MESSAGE_IDS.INVALID]: "Invalid container of `<li>`. <li>` should be in `<ul>`, `<ol>` or `<menu>`."
        }
    },
    create (context) {
        return {
            Tag (node) {
                if (node.name !== "li") return;
                if (!node.parent || node.parent.type === $1986d63494746be2$require$NODE_TYPES.Document) context.report({
                    node: node,
                    messageId: $1986d63494746be2$var$MESSAGE_IDS.INVALID
                });
                else if (node.parent.type === $1986d63494746be2$require$NODE_TYPES.Tag && !$1986d63494746be2$var$VALID_CONTAINERS.includes(node.parent.name || "")) context.report({
                    node: node,
                    messageId: $1986d63494746be2$var$MESSAGE_IDS.INVALID
                });
            }
        };
    }
};


var $038e8564917e2c5e$exports = {};
/**
 * @import {
 *   Attribute,
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {AST} from "eslint"
 * @import {RuleModule} from "../types"
 * @typedef {"single" | "double"} SingleOrQuoteOption
 *
 * @typedef {{ enforceTemplatedAttrValue: boolean }} ObjectOption
 */ 
var $038e8564917e2c5e$require$NODE_TYPES = $f03705736c6cdfcd$exports.NODE_TYPES;

var $038e8564917e2c5e$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $038e8564917e2c5e$require$getSourceCode = $2abd6ce2c4a2d841$exports.getSourceCode;

var $038e8564917e2c5e$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $038e8564917e2c5e$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $038e8564917e2c5e$var$MESSAGE_IDS = {
    UNEXPECTED: "unexpected",
    MISSING: "missing"
};
const $038e8564917e2c5e$var$QUOTES_STYLES = {
    SINGLE: "single",
    DOUBLE: "double"
};
const $038e8564917e2c5e$var$QUOTES_CODES = [
    `"`,
    `'`
];
/** @type {RuleModule<[SingleOrQuoteOption, ObjectOption]>} */ $038e8564917e2c5e$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Enforce consistent quoting attributes with double(\") or single(')",
            category: $038e8564917e2c5e$require$RULE_CATEGORY.STYLE,
            recommended: true,
            url: $038e8564917e2c5e$require$getRuleUrl("quotes")
        },
        fixable: true,
        schema: [
            {
                enum: [
                    $038e8564917e2c5e$var$QUOTES_STYLES.SINGLE,
                    $038e8564917e2c5e$var$QUOTES_STYLES.DOUBLE
                ]
            },
            {
                type: "object",
                properties: {
                    enforceTemplatedAttrValue: {
                        type: "boolean",
                        default: false
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$038e8564917e2c5e$var$MESSAGE_IDS.UNEXPECTED]: "Expected {{expected}} quotes but found {{actual}}.",
            [$038e8564917e2c5e$var$MESSAGE_IDS.MISSING]: "Expected {{expected}} quotes but no quotes found."
        }
    },
    create (context) {
        const SELECTED_STYLE = context.options?.[0] ?? $038e8564917e2c5e$var$QUOTES_STYLES.DOUBLE;
        const expectedQuote = SELECTED_STYLE === $038e8564917e2c5e$var$QUOTES_STYLES.DOUBLE ? `"` : `'`;
        const enforceTemplatedAttrValue = context.options?.[1]?.enforceTemplatedAttrValue;
        const sourceCode = $038e8564917e2c5e$require$getSourceCode(context);
        /**
     * @param {AST.Range} range
     * @returns {string}
     */ function getCodeIn(range) {
            return sourceCode.text.slice(range[0], range[1]);
        }
        /**
     * @param {Attribute} attr
     * @returns {[string, string]}
     */ function getQuotes(attr) {
            // @ts-ignore
            return [
                attr.startWrapper.value,
                attr.endWrapper.value
            ];
        }
        /**
     * @param {Attribute} attr
     * @returns {void}
     */ function checkQuotes(attr) {
            if (!attr.value || attr.value.value.includes(expectedQuote)) return;
            /** Allow template expression. ex: html`<div foo=${foo}></div>` */ if (!enforceTemplatedAttrValue && attr.value.parts.some((part)=>part.type === $038e8564917e2c5e$require$NODE_TYPES.Template)) return;
            if (attr.startWrapper && attr.endWrapper) {
                const [opening, closing] = getQuotes(attr);
                if ($038e8564917e2c5e$var$QUOTES_CODES.includes(opening)) {
                    if (opening === closing && opening !== expectedQuote) context.report({
                        node: attr,
                        messageId: $038e8564917e2c5e$var$MESSAGE_IDS.UNEXPECTED,
                        data: {
                            expected: `${SELECTED_STYLE}(${expectedQuote})`,
                            actual: SELECTED_STYLE === $038e8564917e2c5e$var$QUOTES_STYLES.SINGLE ? `${$038e8564917e2c5e$var$QUOTES_STYLES.DOUBLE}(")` : `${$038e8564917e2c5e$var$QUOTES_STYLES.SINGLE}(')`
                        },
                        fix (fixer) {
                            if (!attr.startWrapper || !attr.endWrapper || attr.value === undefined) return null;
                            return fixer.replaceTextRange([
                                attr.startWrapper.range[0],
                                attr.endWrapper.range[1]
                            ], `${expectedQuote}${attr.value.value}${expectedQuote}`);
                        }
                    });
                }
            } else context.report({
                node: attr,
                messageId: $038e8564917e2c5e$var$MESSAGE_IDS.MISSING,
                data: {
                    expected: `${SELECTED_STYLE}(${expectedQuote})`
                },
                fix (fixer) {
                    if (attr.value === undefined) return null;
                    const originCode = getCodeIn(attr.value.range);
                    return fixer.replaceTextRange(attr.value.range, `${expectedQuote}${originCode}${expectedQuote}`);
                }
            });
        }
        /** @param {Tag | ScriptTag | StyleTag} node */ function check(node) {
            node.attributes.forEach((attr)=>checkQuotes(attr));
        }
        return $038e8564917e2c5e$require$createVisitors(context, {
            Tag: check,
            ScriptTag: check,
            StyleTag: check
        });
    }
};


var $53dd157a204315c1$exports = {};
/**
 * @import {
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 * @typedef {"camelCase"
 *   | "snake_case"
 *   | "PascalCase"
 *   | "kebab-case"
 *   | "regex"} Option1
 *
 *
 * @typedef {Object} Option2
 * @property {string} pattern
 * @property {string} [flags]
 */ 
var $53dd157a204315c1$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;
var $d5f7ced5879e7b9c$exports = {};
// https://stylelint.io/user-guide/rules/regex
const $d5f7ced5879e7b9c$var$KEBAB_CASE_REGEX = /^([a-z][a-z0-9]*)(-[a-z0-9]+)*$/;
const $d5f7ced5879e7b9c$var$SNAKE_CASE_REGEX = /^([a-z][a-z0-9]*)(_[a-z0-9]+)*$/;
const $d5f7ced5879e7b9c$var$PASCAL_CASE_REGEX = /^[A-Z][a-zA-Z0-9]+$/;
const $d5f7ced5879e7b9c$var$CAMEL_CASE_REGEX = /^[a-z][a-zA-Z0-9]+$/;
$d5f7ced5879e7b9c$exports = {
    /**
   * Checks a given name follows `kebab-case` or not.
   *
   * @param {string} name Name to check
   * @returns {boolean} `true` if a name follows `kebab-case`, otherwise
   *   `false`.
   */ isKebabCase (name) {
        return $d5f7ced5879e7b9c$var$KEBAB_CASE_REGEX.test(name);
    },
    /**
   * Checks a given name follows `snake_case` or not.
   *
   * @param {string} name Name to check
   * @returns {boolean} `true` if a name follows `snake_case`, otherwise
   *   `false`.
   */ isSnakeCase (name) {
        return $d5f7ced5879e7b9c$var$SNAKE_CASE_REGEX.test(name);
    },
    /**
   * Checks a given name follows `PascalCase` or not.
   *
   * @param {string} name Name to check
   * @returns {boolean} `true` if a name follows `PascalCase`, otherwise
   *   `false`.
   */ isPascalCase (name) {
        return $d5f7ced5879e7b9c$var$PASCAL_CASE_REGEX.test(name);
    },
    /**
   * Checks a given name follows `camelCase` or not.
   *
   * @param {string} name Name to check
   * @returns {boolean} `true` if a name follows `camelCase`, otherwise `false`.
   */ isCamelCase (name) {
        return $d5f7ced5879e7b9c$var$CAMEL_CASE_REGEX.test(name);
    }
};


var $53dd157a204315c1$require$isCamelCase = $d5f7ced5879e7b9c$exports.isCamelCase;
var $53dd157a204315c1$require$isSnakeCase = $d5f7ced5879e7b9c$exports.isSnakeCase;
var $53dd157a204315c1$require$isPascalCase = $d5f7ced5879e7b9c$exports.isPascalCase;
var $53dd157a204315c1$require$isKebabCase = $d5f7ced5879e7b9c$exports.isKebabCase;

var $53dd157a204315c1$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $53dd157a204315c1$require$isAttributesEmpty = $7dabedd289de3a0a$exports.isAttributesEmpty;
var $53dd157a204315c1$require$hasTemplate = $7dabedd289de3a0a$exports.hasTemplate;

var $53dd157a204315c1$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $53dd157a204315c1$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $53dd157a204315c1$var$MESSAGE_IDS = {
    WRONG: "wrong"
};
const $53dd157a204315c1$var$CONVENTIONS = {
    CAMEL_CASE: "camelCase",
    SNAKE_CASE: "snake_case",
    PASCAL_CASE: "PascalCase",
    KEBAB_CASE: "kebab-case",
    REGEX: "regex"
};
const $53dd157a204315c1$var$CONVENTION_CHECKERS = {
    [$53dd157a204315c1$var$CONVENTIONS.CAMEL_CASE]: $53dd157a204315c1$require$isCamelCase,
    [$53dd157a204315c1$var$CONVENTIONS.SNAKE_CASE]: $53dd157a204315c1$require$isSnakeCase,
    [$53dd157a204315c1$var$CONVENTIONS.PASCAL_CASE]: $53dd157a204315c1$require$isPascalCase,
    [$53dd157a204315c1$var$CONVENTIONS.KEBAB_CASE]: $53dd157a204315c1$require$isKebabCase
};
/** @type {RuleModule<[Option1, Option2]>} */ $53dd157a204315c1$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Enforce consistent naming of id attributes",
            category: $53dd157a204315c1$require$RULE_CATEGORY.STYLE,
            recommended: false,
            url: $53dd157a204315c1$require$getRuleUrl("id-naming-convention")
        },
        fixable: null,
        schema: [
            {
                enum: Object.values($53dd157a204315c1$var$CONVENTIONS)
            },
            {
                type: "object",
                properties: {
                    pattern: {
                        type: "string"
                    },
                    flags: {
                        type: "string"
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$53dd157a204315c1$var$MESSAGE_IDS.WRONG]: "The id '{{actual}}' is not matched with the {{convention}}."
        }
    },
    create (context) {
        const convention = context.options?.[0] ?? $53dd157a204315c1$var$CONVENTIONS.SNAKE_CASE;
        const checkNaming = convention === $53dd157a204315c1$var$CONVENTIONS.REGEX ? (/** @type string */ name)=>new RegExp(context.options[1].pattern, context.options[1].flags || "").test(name) : $53dd157a204315c1$var$CONVENTION_CHECKERS[convention];
        /** @param {Tag | ScriptTag | StyleTag} node */ function check(node) {
            if ($53dd157a204315c1$require$isAttributesEmpty(node)) return;
            const idAttr = $53dd157a204315c1$require$findAttr(node, "id");
            if (idAttr?.value && !$53dd157a204315c1$require$hasTemplate(idAttr.value) && !checkNaming(idAttr.value.value)) context.report({
                node: idAttr,
                data: {
                    actual: idAttr.value.value,
                    convention: convention
                },
                messageId: $53dd157a204315c1$var$MESSAGE_IDS.WRONG
            });
        }
        /** @param {Tag | ScriptTag | StyleTag} node */ function checkInTemplate(node) {
            if ($53dd157a204315c1$require$isAttributesEmpty(node)) return;
            const idAttr = $53dd157a204315c1$require$findAttr(node, "id");
            if (idAttr?.value && !$53dd157a204315c1$require$hasTemplate(idAttr.value) && !checkNaming(idAttr.value.value)) context.report({
                node: idAttr,
                data: {
                    actual: idAttr.value.value,
                    convention: convention
                },
                messageId: $53dd157a204315c1$var$MESSAGE_IDS.WRONG
            });
        }
        return $53dd157a204315c1$require$createVisitors(context, {
            Tag: check,
            ScriptTag: check,
            StyleTag: check
        }, {
            Tag: checkInTemplate,
            ScriptTag: checkInTemplate,
            StyleTag: checkInTemplate
        });
    }
};


var $a3cc22c4efdf071f$exports = {};
/**
 * @import {
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $a3cc22c4efdf071f$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $a3cc22c4efdf071f$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $a3cc22c4efdf071f$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
// lib/rules/no-invalid-attr-value.js
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 'use strict';
var $2a533f0146ced75e$export$f435f793048e7a0f;
(function(TokenType) {
    TokenType[TokenType["Ident"] = 0] = "Ident";
    TokenType[TokenType["AtKeyword"] = 1] = "AtKeyword";
    TokenType[TokenType["String"] = 2] = "String";
    TokenType[TokenType["BadString"] = 3] = "BadString";
    TokenType[TokenType["UnquotedString"] = 4] = "UnquotedString";
    TokenType[TokenType["Hash"] = 5] = "Hash";
    TokenType[TokenType["Num"] = 6] = "Num";
    TokenType[TokenType["Percentage"] = 7] = "Percentage";
    TokenType[TokenType["Dimension"] = 8] = "Dimension";
    TokenType[TokenType["UnicodeRange"] = 9] = "UnicodeRange";
    TokenType[TokenType["CDO"] = 10] = "CDO";
    TokenType[TokenType["CDC"] = 11] = "CDC";
    TokenType[TokenType["Colon"] = 12] = "Colon";
    TokenType[TokenType["SemiColon"] = 13] = "SemiColon";
    TokenType[TokenType["CurlyL"] = 14] = "CurlyL";
    TokenType[TokenType["CurlyR"] = 15] = "CurlyR";
    TokenType[TokenType["ParenthesisL"] = 16] = "ParenthesisL";
    TokenType[TokenType["ParenthesisR"] = 17] = "ParenthesisR";
    TokenType[TokenType["BracketL"] = 18] = "BracketL";
    TokenType[TokenType["BracketR"] = 19] = "BracketR";
    TokenType[TokenType["Whitespace"] = 20] = "Whitespace";
    TokenType[TokenType["Includes"] = 21] = "Includes";
    TokenType[TokenType["Dashmatch"] = 22] = "Dashmatch";
    TokenType[TokenType["SubstringOperator"] = 23] = "SubstringOperator";
    TokenType[TokenType["PrefixOperator"] = 24] = "PrefixOperator";
    TokenType[TokenType["SuffixOperator"] = 25] = "SuffixOperator";
    TokenType[TokenType["Delim"] = 26] = "Delim";
    TokenType[TokenType["EMS"] = 27] = "EMS";
    TokenType[TokenType["EXS"] = 28] = "EXS";
    TokenType[TokenType["Length"] = 29] = "Length";
    TokenType[TokenType["Angle"] = 30] = "Angle";
    TokenType[TokenType["Time"] = 31] = "Time";
    TokenType[TokenType["Freq"] = 32] = "Freq";
    TokenType[TokenType["Exclamation"] = 33] = "Exclamation";
    TokenType[TokenType["Resolution"] = 34] = "Resolution";
    TokenType[TokenType["Comma"] = 35] = "Comma";
    TokenType[TokenType["Charset"] = 36] = "Charset";
    TokenType[TokenType["EscapedJavaScript"] = 37] = "EscapedJavaScript";
    TokenType[TokenType["BadEscapedJavaScript"] = 38] = "BadEscapedJavaScript";
    TokenType[TokenType["Comment"] = 39] = "Comment";
    TokenType[TokenType["SingleLineComment"] = 40] = "SingleLineComment";
    TokenType[TokenType["EOF"] = 41] = "EOF";
    TokenType[TokenType["ContainerQueryLength"] = 42] = "ContainerQueryLength";
    TokenType[TokenType["CustomToken"] = 43] = "CustomToken"; // must be last token type
})($2a533f0146ced75e$export$f435f793048e7a0f || ($2a533f0146ced75e$export$f435f793048e7a0f = {}));
class $2a533f0146ced75e$export$9a4429c5cbd3733 {
    constructor(source){
        this.source = source;
        this.len = source.length;
        this.position = 0;
    }
    substring(from, to = this.position) {
        return this.source.substring(from, to);
    }
    eos() {
        return this.len <= this.position;
    }
    pos() {
        return this.position;
    }
    goBackTo(pos) {
        this.position = pos;
    }
    goBack(n) {
        this.position -= n;
    }
    advance(n) {
        this.position += n;
    }
    nextChar() {
        return this.source.charCodeAt(this.position++) || 0;
    }
    peekChar(n = 0) {
        return this.source.charCodeAt(this.position + n) || 0;
    }
    lookbackChar(n = 0) {
        return this.source.charCodeAt(this.position - n) || 0;
    }
    advanceIfChar(ch) {
        if (ch === this.source.charCodeAt(this.position)) {
            this.position++;
            return true;
        }
        return false;
    }
    advanceIfChars(ch) {
        if (this.position + ch.length > this.source.length) return false;
        let i = 0;
        for(; i < ch.length; i++){
            if (this.source.charCodeAt(this.position + i) !== ch[i]) return false;
        }
        this.advance(i);
        return true;
    }
    advanceWhileChar(condition) {
        const posNow = this.position;
        while(this.position < this.len && condition(this.source.charCodeAt(this.position)))this.position++;
        return this.position - posNow;
    }
}
const $2a533f0146ced75e$var$_a = 'a'.charCodeAt(0);
const $2a533f0146ced75e$var$_f = 'f'.charCodeAt(0);
const $2a533f0146ced75e$var$_z = 'z'.charCodeAt(0);
const $2a533f0146ced75e$var$_u = 'u'.charCodeAt(0);
const $2a533f0146ced75e$var$_A = 'A'.charCodeAt(0);
const $2a533f0146ced75e$var$_F = 'F'.charCodeAt(0);
const $2a533f0146ced75e$var$_Z = 'Z'.charCodeAt(0);
const $2a533f0146ced75e$var$_0 = '0'.charCodeAt(0);
const $2a533f0146ced75e$var$_9 = '9'.charCodeAt(0);
const $2a533f0146ced75e$var$_TLD = '~'.charCodeAt(0);
const $2a533f0146ced75e$var$_HAT = '^'.charCodeAt(0);
const $2a533f0146ced75e$var$_EQS = '='.charCodeAt(0);
const $2a533f0146ced75e$var$_PIP = '|'.charCodeAt(0);
const $2a533f0146ced75e$var$_MIN = '-'.charCodeAt(0);
const $2a533f0146ced75e$var$_USC = '_'.charCodeAt(0);
const $2a533f0146ced75e$var$_PRC = '%'.charCodeAt(0);
const $2a533f0146ced75e$var$_MUL = '*'.charCodeAt(0);
const $2a533f0146ced75e$var$_LPA = '('.charCodeAt(0);
const $2a533f0146ced75e$var$_RPA = ')'.charCodeAt(0);
const $2a533f0146ced75e$var$_LAN = '<'.charCodeAt(0);
const $2a533f0146ced75e$var$_RAN = '>'.charCodeAt(0);
const $2a533f0146ced75e$var$_ATS = '@'.charCodeAt(0);
const $2a533f0146ced75e$var$_HSH = '#'.charCodeAt(0);
const $2a533f0146ced75e$var$_DLR = '$'.charCodeAt(0);
const $2a533f0146ced75e$var$_BSL = '\\'.charCodeAt(0);
const $2a533f0146ced75e$var$_FSL = '/'.charCodeAt(0);
const $2a533f0146ced75e$var$_NWL = '\n'.charCodeAt(0);
const $2a533f0146ced75e$var$_CAR = '\r'.charCodeAt(0);
const $2a533f0146ced75e$var$_LFD = '\f'.charCodeAt(0);
const $2a533f0146ced75e$var$_DQO = '"'.charCodeAt(0);
const $2a533f0146ced75e$var$_SQO = '\''.charCodeAt(0);
const $2a533f0146ced75e$var$_WSP = ' '.charCodeAt(0);
const $2a533f0146ced75e$var$_TAB = '\t'.charCodeAt(0);
const $2a533f0146ced75e$var$_SEM = ';'.charCodeAt(0);
const $2a533f0146ced75e$var$_COL = ':'.charCodeAt(0);
const $2a533f0146ced75e$var$_CUL = '{'.charCodeAt(0);
const $2a533f0146ced75e$var$_CUR = '}'.charCodeAt(0);
const $2a533f0146ced75e$var$_BRL = '['.charCodeAt(0);
const $2a533f0146ced75e$var$_BRR = ']'.charCodeAt(0);
const $2a533f0146ced75e$var$_CMA = ','.charCodeAt(0);
const $2a533f0146ced75e$var$_DOT = '.'.charCodeAt(0);
const $2a533f0146ced75e$var$_BNG = '!'.charCodeAt(0);
const $2a533f0146ced75e$var$_QSM = '?'.charCodeAt(0);
const $2a533f0146ced75e$var$_PLS = '+'.charCodeAt(0);
const $2a533f0146ced75e$var$staticTokenTable = {};
$2a533f0146ced75e$var$staticTokenTable[$2a533f0146ced75e$var$_SEM] = $2a533f0146ced75e$export$f435f793048e7a0f.SemiColon;
$2a533f0146ced75e$var$staticTokenTable[$2a533f0146ced75e$var$_COL] = $2a533f0146ced75e$export$f435f793048e7a0f.Colon;
$2a533f0146ced75e$var$staticTokenTable[$2a533f0146ced75e$var$_CUL] = $2a533f0146ced75e$export$f435f793048e7a0f.CurlyL;
$2a533f0146ced75e$var$staticTokenTable[$2a533f0146ced75e$var$_CUR] = $2a533f0146ced75e$export$f435f793048e7a0f.CurlyR;
$2a533f0146ced75e$var$staticTokenTable[$2a533f0146ced75e$var$_BRR] = $2a533f0146ced75e$export$f435f793048e7a0f.BracketR;
$2a533f0146ced75e$var$staticTokenTable[$2a533f0146ced75e$var$_BRL] = $2a533f0146ced75e$export$f435f793048e7a0f.BracketL;
$2a533f0146ced75e$var$staticTokenTable[$2a533f0146ced75e$var$_LPA] = $2a533f0146ced75e$export$f435f793048e7a0f.ParenthesisL;
$2a533f0146ced75e$var$staticTokenTable[$2a533f0146ced75e$var$_RPA] = $2a533f0146ced75e$export$f435f793048e7a0f.ParenthesisR;
$2a533f0146ced75e$var$staticTokenTable[$2a533f0146ced75e$var$_CMA] = $2a533f0146ced75e$export$f435f793048e7a0f.Comma;
const $2a533f0146ced75e$var$staticUnitTable = {};
$2a533f0146ced75e$var$staticUnitTable['em'] = $2a533f0146ced75e$export$f435f793048e7a0f.EMS;
$2a533f0146ced75e$var$staticUnitTable['ex'] = $2a533f0146ced75e$export$f435f793048e7a0f.EXS;
$2a533f0146ced75e$var$staticUnitTable['px'] = $2a533f0146ced75e$export$f435f793048e7a0f.Length;
$2a533f0146ced75e$var$staticUnitTable['cm'] = $2a533f0146ced75e$export$f435f793048e7a0f.Length;
$2a533f0146ced75e$var$staticUnitTable['mm'] = $2a533f0146ced75e$export$f435f793048e7a0f.Length;
$2a533f0146ced75e$var$staticUnitTable['in'] = $2a533f0146ced75e$export$f435f793048e7a0f.Length;
$2a533f0146ced75e$var$staticUnitTable['pt'] = $2a533f0146ced75e$export$f435f793048e7a0f.Length;
$2a533f0146ced75e$var$staticUnitTable['pc'] = $2a533f0146ced75e$export$f435f793048e7a0f.Length;
$2a533f0146ced75e$var$staticUnitTable['deg'] = $2a533f0146ced75e$export$f435f793048e7a0f.Angle;
$2a533f0146ced75e$var$staticUnitTable['rad'] = $2a533f0146ced75e$export$f435f793048e7a0f.Angle;
$2a533f0146ced75e$var$staticUnitTable['grad'] = $2a533f0146ced75e$export$f435f793048e7a0f.Angle;
$2a533f0146ced75e$var$staticUnitTable['ms'] = $2a533f0146ced75e$export$f435f793048e7a0f.Time;
$2a533f0146ced75e$var$staticUnitTable['s'] = $2a533f0146ced75e$export$f435f793048e7a0f.Time;
$2a533f0146ced75e$var$staticUnitTable['hz'] = $2a533f0146ced75e$export$f435f793048e7a0f.Freq;
$2a533f0146ced75e$var$staticUnitTable['khz'] = $2a533f0146ced75e$export$f435f793048e7a0f.Freq;
$2a533f0146ced75e$var$staticUnitTable['%'] = $2a533f0146ced75e$export$f435f793048e7a0f.Percentage;
$2a533f0146ced75e$var$staticUnitTable['fr'] = $2a533f0146ced75e$export$f435f793048e7a0f.Percentage;
$2a533f0146ced75e$var$staticUnitTable['dpi'] = $2a533f0146ced75e$export$f435f793048e7a0f.Resolution;
$2a533f0146ced75e$var$staticUnitTable['dpcm'] = $2a533f0146ced75e$export$f435f793048e7a0f.Resolution;
$2a533f0146ced75e$var$staticUnitTable['cqw'] = $2a533f0146ced75e$export$f435f793048e7a0f.ContainerQueryLength;
$2a533f0146ced75e$var$staticUnitTable['cqh'] = $2a533f0146ced75e$export$f435f793048e7a0f.ContainerQueryLength;
$2a533f0146ced75e$var$staticUnitTable['cqi'] = $2a533f0146ced75e$export$f435f793048e7a0f.ContainerQueryLength;
$2a533f0146ced75e$var$staticUnitTable['cqb'] = $2a533f0146ced75e$export$f435f793048e7a0f.ContainerQueryLength;
$2a533f0146ced75e$var$staticUnitTable['cqmin'] = $2a533f0146ced75e$export$f435f793048e7a0f.ContainerQueryLength;
$2a533f0146ced75e$var$staticUnitTable['cqmax'] = $2a533f0146ced75e$export$f435f793048e7a0f.ContainerQueryLength;
class $2a533f0146ced75e$export$2da42535f3a161df {
    constructor(){
        this.stream = new $2a533f0146ced75e$export$9a4429c5cbd3733('');
        this.ignoreComment = true;
        this.ignoreWhitespace = true;
        this.inURL = false;
    }
    setSource(input) {
        this.stream = new $2a533f0146ced75e$export$9a4429c5cbd3733(input);
    }
    finishToken(offset, type, text) {
        return {
            offset: offset,
            len: this.stream.pos() - offset,
            type: type,
            text: text || this.stream.substring(offset)
        };
    }
    substring(offset, len) {
        return this.stream.substring(offset, offset + len);
    }
    pos() {
        return this.stream.pos();
    }
    goBackTo(pos) {
        this.stream.goBackTo(pos);
    }
    scanUnquotedString() {
        const offset = this.stream.pos();
        const content = [];
        if (this._unquotedString(content)) return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.UnquotedString, content.join(''));
        return null;
    }
    scan() {
        // processes all whitespaces and comments
        const triviaToken = this.trivia();
        if (triviaToken !== null) return triviaToken;
        const offset = this.stream.pos();
        // End of file/input
        if (this.stream.eos()) return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.EOF);
        return this.scanNext(offset);
    }
    /**
     * Read the range as described in https://www.w3.org/TR/CSS21/syndata.html#tokenization
     * Assume the `u` has aleady been consumed
     * @returns if reading the unicode was successful
     */ tryScanUnicode() {
        const offset = this.stream.pos();
        if (!this.stream.eos() && this._unicodeRange()) return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.UnicodeRange);
        this.stream.goBackTo(offset);
        return undefined;
    }
    scanNext(offset) {
        // CDO <!--
        if (this.stream.advanceIfChars([
            $2a533f0146ced75e$var$_LAN,
            $2a533f0146ced75e$var$_BNG,
            $2a533f0146ced75e$var$_MIN,
            $2a533f0146ced75e$var$_MIN
        ])) return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.CDO);
        // CDC -->
        if (this.stream.advanceIfChars([
            $2a533f0146ced75e$var$_MIN,
            $2a533f0146ced75e$var$_MIN,
            $2a533f0146ced75e$var$_RAN
        ])) return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.CDC);
        let content = [];
        if (this.ident(content)) return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.Ident, content.join(''));
        // at-keyword
        if (this.stream.advanceIfChar($2a533f0146ced75e$var$_ATS)) {
            content = [
                '@'
            ];
            if (this._name(content)) {
                const keywordText = content.join('');
                if (keywordText === '@charset') return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.Charset, keywordText);
                return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.AtKeyword, keywordText);
            } else return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.Delim);
        }
        // hash
        if (this.stream.advanceIfChar($2a533f0146ced75e$var$_HSH)) {
            content = [
                '#'
            ];
            if (this._name(content)) return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.Hash, content.join(''));
            else return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.Delim);
        }
        // Important
        if (this.stream.advanceIfChar($2a533f0146ced75e$var$_BNG)) return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.Exclamation);
        // Numbers
        if (this._number()) {
            const pos = this.stream.pos();
            content = [
                this.stream.substring(offset, pos)
            ];
            if (this.stream.advanceIfChar($2a533f0146ced75e$var$_PRC)) // Percentage 43%
            return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.Percentage);
            else if (this.ident(content)) {
                const dim = this.stream.substring(pos).toLowerCase();
                const tokenType = $2a533f0146ced75e$var$staticUnitTable[dim];
                if (typeof tokenType !== 'undefined') // Known dimension 43px
                return this.finishToken(offset, tokenType, content.join(''));
                else // Unknown dimension 43ft
                return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.Dimension, content.join(''));
            }
            return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.Num);
        }
        // String, BadString
        content = [];
        let tokenType = this._string(content);
        if (tokenType !== null) return this.finishToken(offset, tokenType, content.join(''));
        // single character tokens
        tokenType = $2a533f0146ced75e$var$staticTokenTable[this.stream.peekChar()];
        if (typeof tokenType !== 'undefined') {
            this.stream.advance(1);
            return this.finishToken(offset, tokenType);
        }
        // includes ~=
        if (this.stream.peekChar(0) === $2a533f0146ced75e$var$_TLD && this.stream.peekChar(1) === $2a533f0146ced75e$var$_EQS) {
            this.stream.advance(2);
            return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.Includes);
        }
        // DashMatch |=
        if (this.stream.peekChar(0) === $2a533f0146ced75e$var$_PIP && this.stream.peekChar(1) === $2a533f0146ced75e$var$_EQS) {
            this.stream.advance(2);
            return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.Dashmatch);
        }
        // Substring operator *=
        if (this.stream.peekChar(0) === $2a533f0146ced75e$var$_MUL && this.stream.peekChar(1) === $2a533f0146ced75e$var$_EQS) {
            this.stream.advance(2);
            return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.SubstringOperator);
        }
        // Substring operator ^=
        if (this.stream.peekChar(0) === $2a533f0146ced75e$var$_HAT && this.stream.peekChar(1) === $2a533f0146ced75e$var$_EQS) {
            this.stream.advance(2);
            return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.PrefixOperator);
        }
        // Substring operator $=
        if (this.stream.peekChar(0) === $2a533f0146ced75e$var$_DLR && this.stream.peekChar(1) === $2a533f0146ced75e$var$_EQS) {
            this.stream.advance(2);
            return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.SuffixOperator);
        }
        // Delim
        this.stream.nextChar();
        return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.Delim);
    }
    trivia() {
        while(true){
            const offset = this.stream.pos();
            if (this._whitespace()) {
                if (!this.ignoreWhitespace) return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.Whitespace);
            } else if (this.comment()) {
                if (!this.ignoreComment) return this.finishToken(offset, $2a533f0146ced75e$export$f435f793048e7a0f.Comment);
            } else return null;
        }
    }
    comment() {
        if (this.stream.advanceIfChars([
            $2a533f0146ced75e$var$_FSL,
            $2a533f0146ced75e$var$_MUL
        ])) {
            let success = false, hot = false;
            this.stream.advanceWhileChar((ch)=>{
                if (hot && ch === $2a533f0146ced75e$var$_FSL) {
                    success = true;
                    return false;
                }
                hot = ch === $2a533f0146ced75e$var$_MUL;
                return true;
            });
            if (success) this.stream.advance(1);
            return true;
        }
        return false;
    }
    _number() {
        let npeek = 0;
        let hasDot = false;
        const peekFirst = this.stream.peekChar();
        if (peekFirst === $2a533f0146ced75e$var$_PLS || peekFirst === $2a533f0146ced75e$var$_MIN) npeek++;
        if (this.stream.peekChar(npeek) === $2a533f0146ced75e$var$_DOT) {
            npeek++;
            hasDot = true;
        }
        const ch = this.stream.peekChar(npeek);
        if (ch >= $2a533f0146ced75e$var$_0 && ch <= $2a533f0146ced75e$var$_9) {
            this.stream.advance(npeek + 1);
            this.stream.advanceWhileChar((ch)=>{
                return ch >= $2a533f0146ced75e$var$_0 && ch <= $2a533f0146ced75e$var$_9 || !hasDot && ch === $2a533f0146ced75e$var$_DOT;
            });
            return true;
        }
        return false;
    }
    _newline(result) {
        const ch = this.stream.peekChar();
        switch(ch){
            case $2a533f0146ced75e$var$_CAR:
            case $2a533f0146ced75e$var$_LFD:
            case $2a533f0146ced75e$var$_NWL:
                this.stream.advance(1);
                result.push(String.fromCharCode(ch));
                if (ch === $2a533f0146ced75e$var$_CAR && this.stream.advanceIfChar($2a533f0146ced75e$var$_NWL)) result.push('\n');
                return true;
        }
        return false;
    }
    _escape(result, includeNewLines) {
        let ch = this.stream.peekChar();
        if (ch === $2a533f0146ced75e$var$_BSL) {
            this.stream.advance(1);
            ch = this.stream.peekChar();
            let hexNumCount = 0;
            while(hexNumCount < 6 && (ch >= $2a533f0146ced75e$var$_0 && ch <= $2a533f0146ced75e$var$_9 || ch >= $2a533f0146ced75e$var$_a && ch <= $2a533f0146ced75e$var$_f || ch >= $2a533f0146ced75e$var$_A && ch <= $2a533f0146ced75e$var$_F)){
                this.stream.advance(1);
                ch = this.stream.peekChar();
                hexNumCount++;
            }
            if (hexNumCount > 0) {
                try {
                    const hexVal = parseInt(this.stream.substring(this.stream.pos() - hexNumCount), 16);
                    if (hexVal) result.push(String.fromCharCode(hexVal));
                } catch (e) {
                // ignore
                }
                // optional whitespace or new line, not part of result text
                if (ch === $2a533f0146ced75e$var$_WSP || ch === $2a533f0146ced75e$var$_TAB) this.stream.advance(1);
                else this._newline([]);
                return true;
            }
            if (ch !== $2a533f0146ced75e$var$_CAR && ch !== $2a533f0146ced75e$var$_LFD && ch !== $2a533f0146ced75e$var$_NWL) {
                this.stream.advance(1);
                result.push(String.fromCharCode(ch));
                return true;
            } else if (includeNewLines) return this._newline(result);
        }
        return false;
    }
    _stringChar(closeQuote, result) {
        // not closeQuote, not backslash, not newline
        const ch = this.stream.peekChar();
        if (ch !== 0 && ch !== closeQuote && ch !== $2a533f0146ced75e$var$_BSL && ch !== $2a533f0146ced75e$var$_CAR && ch !== $2a533f0146ced75e$var$_LFD && ch !== $2a533f0146ced75e$var$_NWL) {
            this.stream.advance(1);
            result.push(String.fromCharCode(ch));
            return true;
        }
        return false;
    }
    _string(result) {
        if (this.stream.peekChar() === $2a533f0146ced75e$var$_SQO || this.stream.peekChar() === $2a533f0146ced75e$var$_DQO) {
            const closeQuote = this.stream.nextChar();
            result.push(String.fromCharCode(closeQuote));
            while(this._stringChar(closeQuote, result) || this._escape(result, true));
            if (this.stream.peekChar() === closeQuote) {
                this.stream.nextChar();
                result.push(String.fromCharCode(closeQuote));
                return $2a533f0146ced75e$export$f435f793048e7a0f.String;
            } else return $2a533f0146ced75e$export$f435f793048e7a0f.BadString;
        }
        return null;
    }
    _unquotedChar(result) {
        // not closeQuote, not backslash, not newline
        const ch = this.stream.peekChar();
        if (ch !== 0 && ch !== $2a533f0146ced75e$var$_BSL && ch !== $2a533f0146ced75e$var$_SQO && ch !== $2a533f0146ced75e$var$_DQO && ch !== $2a533f0146ced75e$var$_LPA && ch !== $2a533f0146ced75e$var$_RPA && ch !== $2a533f0146ced75e$var$_WSP && ch !== $2a533f0146ced75e$var$_TAB && ch !== $2a533f0146ced75e$var$_NWL && ch !== $2a533f0146ced75e$var$_LFD && ch !== $2a533f0146ced75e$var$_CAR) {
            this.stream.advance(1);
            result.push(String.fromCharCode(ch));
            return true;
        }
        return false;
    }
    _unquotedString(result) {
        let hasContent = false;
        while(this._unquotedChar(result) || this._escape(result))hasContent = true;
        return hasContent;
    }
    _whitespace() {
        const n = this.stream.advanceWhileChar((ch)=>{
            return ch === $2a533f0146ced75e$var$_WSP || ch === $2a533f0146ced75e$var$_TAB || ch === $2a533f0146ced75e$var$_NWL || ch === $2a533f0146ced75e$var$_LFD || ch === $2a533f0146ced75e$var$_CAR;
        });
        return n > 0;
    }
    _name(result) {
        let matched = false;
        while(this._identChar(result) || this._escape(result))matched = true;
        return matched;
    }
    ident(result) {
        const pos = this.stream.pos();
        const hasMinus = this._minus(result);
        if (hasMinus) {
            if (this._minus(result) || this._identFirstChar(result) || this._escape(result)) {
                while(this._identChar(result) || this._escape(result));
                return true;
            }
        } else if (this._identFirstChar(result) || this._escape(result)) {
            while(this._identChar(result) || this._escape(result));
            return true;
        }
        this.stream.goBackTo(pos);
        return false;
    }
    _identFirstChar(result) {
        const ch = this.stream.peekChar();
        if (ch === $2a533f0146ced75e$var$_USC || // _
        ch >= $2a533f0146ced75e$var$_a && ch <= $2a533f0146ced75e$var$_z || // a-z
        ch >= $2a533f0146ced75e$var$_A && ch <= $2a533f0146ced75e$var$_Z || // A-Z
        ch >= 0x80 && ch <= 0xFFFF) {
            this.stream.advance(1);
            result.push(String.fromCharCode(ch));
            return true;
        }
        return false;
    }
    _minus(result) {
        const ch = this.stream.peekChar();
        if (ch === $2a533f0146ced75e$var$_MIN) {
            this.stream.advance(1);
            result.push(String.fromCharCode(ch));
            return true;
        }
        return false;
    }
    _identChar(result) {
        const ch = this.stream.peekChar();
        if (ch === $2a533f0146ced75e$var$_USC || // _
        ch === $2a533f0146ced75e$var$_MIN || // -
        ch >= $2a533f0146ced75e$var$_a && ch <= $2a533f0146ced75e$var$_z || // a-z
        ch >= $2a533f0146ced75e$var$_A && ch <= $2a533f0146ced75e$var$_Z || // A-Z
        ch >= $2a533f0146ced75e$var$_0 && ch <= $2a533f0146ced75e$var$_9 || // 0/9
        ch >= 0x80 && ch <= 0xFFFF) {
            this.stream.advance(1);
            result.push(String.fromCharCode(ch));
            return true;
        }
        return false;
    }
    _unicodeRange() {
        // follow https://www.w3.org/TR/CSS21/syndata.html#tokenization and https://www.w3.org/TR/css-syntax-3/#urange-syntax
        // assume u has already been parsed
        if (this.stream.advanceIfChar($2a533f0146ced75e$var$_PLS)) {
            const isHexDigit = (ch)=>ch >= $2a533f0146ced75e$var$_0 && ch <= $2a533f0146ced75e$var$_9 || ch >= $2a533f0146ced75e$var$_a && ch <= $2a533f0146ced75e$var$_f || ch >= $2a533f0146ced75e$var$_A && ch <= $2a533f0146ced75e$var$_F;
            const codePoints = this.stream.advanceWhileChar(isHexDigit) + this.stream.advanceWhileChar((ch)=>ch === $2a533f0146ced75e$var$_QSM);
            if (codePoints >= 1 && codePoints <= 6) {
                if (this.stream.advanceIfChar($2a533f0146ced75e$var$_MIN)) {
                    const digits = this.stream.advanceWhileChar(isHexDigit);
                    if (digits >= 1 && digits <= 6) return true;
                } else return true;
            }
        }
        return false;
    }
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 'use strict';
function $3383aa02dc8dfba4$export$68326237475e9a7d(haystack, needle) {
    if (haystack.length < needle.length) return false;
    for(let i = 0; i < needle.length; i++){
        if (haystack[i] !== needle[i]) return false;
    }
    return true;
}
function $3383aa02dc8dfba4$export$10fdab3683b55b22(haystack, needle) {
    let diff = haystack.length - needle.length;
    if (diff > 0) return haystack.lastIndexOf(needle) === diff;
    else if (diff === 0) return haystack === needle;
    else return false;
}
function $3383aa02dc8dfba4$export$acaf96a27438246b(first, second, maxLenDelta = 4) {
    let lengthDifference = Math.abs(first.length - second.length);
    // We only compute score if length of the currentWord and length of entry.name are similar.
    if (lengthDifference > maxLenDelta) return 0;
    // Initialize LCS (largest common subsequence) matrix.
    let LCS = [];
    let zeroArray = [];
    let i, j;
    for(i = 0; i < second.length + 1; ++i)zeroArray.push(0);
    for(i = 0; i < first.length + 1; ++i)LCS.push(zeroArray);
    for(i = 1; i < first.length + 1; ++i){
        for(j = 1; j < second.length + 1; ++j)if (first[i - 1] === second[j - 1]) LCS[i][j] = LCS[i - 1][j - 1] + 1;
        else LCS[i][j] = Math.max(LCS[i - 1][j], LCS[i][j - 1]);
    }
    return LCS[first.length][second.length] - Math.sqrt(lengthDifference);
}
function $3383aa02dc8dfba4$export$f0f1baa56cbb57cb(str, ellipsis = true) {
    if (!str) return '';
    if (str.length < 140) return str;
    return str.slice(0, 140) + (ellipsis ? '\u2026' : '');
}
function $3383aa02dc8dfba4$export$87c2784dc9fc4ab(str, regexp) {
    const m = regexp.exec(str);
    if (m && m[0].length) return str.substr(0, str.length - m[0].length);
    return str;
}
function $3383aa02dc8dfba4$export$76d90c956114f2c2(value, count) {
    let s = '';
    while(count > 0){
        if ((count & 1) === 1) s += value;
        value += value;
        count = count >>> 1;
    }
    return s;
}
function $3383aa02dc8dfba4$export$4d4f3e97266c6260(pattern) {
    return pattern.replace(/[\-\\\{\}\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, '\\$&').replace(/[\*]/g, '.*');
}


'use strict';
var $bd0cebf2eccc0e7e$export$f06e977173f1857c;
(function(NodeType) {
    NodeType[NodeType["Undefined"] = 0] = "Undefined";
    NodeType[NodeType["Identifier"] = 1] = "Identifier";
    NodeType[NodeType["Stylesheet"] = 2] = "Stylesheet";
    NodeType[NodeType["Ruleset"] = 3] = "Ruleset";
    NodeType[NodeType["Selector"] = 4] = "Selector";
    NodeType[NodeType["SimpleSelector"] = 5] = "SimpleSelector";
    NodeType[NodeType["SelectorInterpolation"] = 6] = "SelectorInterpolation";
    NodeType[NodeType["SelectorCombinator"] = 7] = "SelectorCombinator";
    NodeType[NodeType["SelectorCombinatorParent"] = 8] = "SelectorCombinatorParent";
    NodeType[NodeType["SelectorCombinatorSibling"] = 9] = "SelectorCombinatorSibling";
    NodeType[NodeType["SelectorCombinatorAllSiblings"] = 10] = "SelectorCombinatorAllSiblings";
    NodeType[NodeType["SelectorCombinatorShadowPiercingDescendant"] = 11] = "SelectorCombinatorShadowPiercingDescendant";
    NodeType[NodeType["Page"] = 12] = "Page";
    NodeType[NodeType["PageBoxMarginBox"] = 13] = "PageBoxMarginBox";
    NodeType[NodeType["ClassSelector"] = 14] = "ClassSelector";
    NodeType[NodeType["IdentifierSelector"] = 15] = "IdentifierSelector";
    NodeType[NodeType["ElementNameSelector"] = 16] = "ElementNameSelector";
    NodeType[NodeType["PseudoSelector"] = 17] = "PseudoSelector";
    NodeType[NodeType["AttributeSelector"] = 18] = "AttributeSelector";
    NodeType[NodeType["Declaration"] = 19] = "Declaration";
    NodeType[NodeType["Declarations"] = 20] = "Declarations";
    NodeType[NodeType["Property"] = 21] = "Property";
    NodeType[NodeType["Expression"] = 22] = "Expression";
    NodeType[NodeType["BinaryExpression"] = 23] = "BinaryExpression";
    NodeType[NodeType["Term"] = 24] = "Term";
    NodeType[NodeType["Operator"] = 25] = "Operator";
    NodeType[NodeType["Value"] = 26] = "Value";
    NodeType[NodeType["StringLiteral"] = 27] = "StringLiteral";
    NodeType[NodeType["URILiteral"] = 28] = "URILiteral";
    NodeType[NodeType["EscapedValue"] = 29] = "EscapedValue";
    NodeType[NodeType["Function"] = 30] = "Function";
    NodeType[NodeType["NumericValue"] = 31] = "NumericValue";
    NodeType[NodeType["HexColorValue"] = 32] = "HexColorValue";
    NodeType[NodeType["RatioValue"] = 33] = "RatioValue";
    NodeType[NodeType["MixinDeclaration"] = 34] = "MixinDeclaration";
    NodeType[NodeType["MixinReference"] = 35] = "MixinReference";
    NodeType[NodeType["VariableName"] = 36] = "VariableName";
    NodeType[NodeType["VariableDeclaration"] = 37] = "VariableDeclaration";
    NodeType[NodeType["Prio"] = 38] = "Prio";
    NodeType[NodeType["Interpolation"] = 39] = "Interpolation";
    NodeType[NodeType["NestedProperties"] = 40] = "NestedProperties";
    NodeType[NodeType["ExtendsReference"] = 41] = "ExtendsReference";
    NodeType[NodeType["SelectorPlaceholder"] = 42] = "SelectorPlaceholder";
    NodeType[NodeType["Debug"] = 43] = "Debug";
    NodeType[NodeType["If"] = 44] = "If";
    NodeType[NodeType["Else"] = 45] = "Else";
    NodeType[NodeType["For"] = 46] = "For";
    NodeType[NodeType["Each"] = 47] = "Each";
    NodeType[NodeType["While"] = 48] = "While";
    NodeType[NodeType["MixinContentReference"] = 49] = "MixinContentReference";
    NodeType[NodeType["MixinContentDeclaration"] = 50] = "MixinContentDeclaration";
    NodeType[NodeType["Media"] = 51] = "Media";
    NodeType[NodeType["Scope"] = 52] = "Scope";
    NodeType[NodeType["Keyframe"] = 53] = "Keyframe";
    NodeType[NodeType["FontFace"] = 54] = "FontFace";
    NodeType[NodeType["Import"] = 55] = "Import";
    NodeType[NodeType["Namespace"] = 56] = "Namespace";
    NodeType[NodeType["Invocation"] = 57] = "Invocation";
    NodeType[NodeType["FunctionDeclaration"] = 58] = "FunctionDeclaration";
    NodeType[NodeType["ReturnStatement"] = 59] = "ReturnStatement";
    NodeType[NodeType["MediaQuery"] = 60] = "MediaQuery";
    NodeType[NodeType["MediaCondition"] = 61] = "MediaCondition";
    NodeType[NodeType["MediaFeature"] = 62] = "MediaFeature";
    NodeType[NodeType["FunctionParameter"] = 63] = "FunctionParameter";
    NodeType[NodeType["FunctionArgument"] = 64] = "FunctionArgument";
    NodeType[NodeType["KeyframeSelector"] = 65] = "KeyframeSelector";
    NodeType[NodeType["ViewPort"] = 66] = "ViewPort";
    NodeType[NodeType["Document"] = 67] = "Document";
    NodeType[NodeType["AtApplyRule"] = 68] = "AtApplyRule";
    NodeType[NodeType["CustomPropertyDeclaration"] = 69] = "CustomPropertyDeclaration";
    NodeType[NodeType["CustomPropertySet"] = 70] = "CustomPropertySet";
    NodeType[NodeType["ListEntry"] = 71] = "ListEntry";
    NodeType[NodeType["Supports"] = 72] = "Supports";
    NodeType[NodeType["SupportsCondition"] = 73] = "SupportsCondition";
    NodeType[NodeType["NamespacePrefix"] = 74] = "NamespacePrefix";
    NodeType[NodeType["GridLine"] = 75] = "GridLine";
    NodeType[NodeType["Plugin"] = 76] = "Plugin";
    NodeType[NodeType["UnknownAtRule"] = 77] = "UnknownAtRule";
    NodeType[NodeType["Use"] = 78] = "Use";
    NodeType[NodeType["ModuleConfiguration"] = 79] = "ModuleConfiguration";
    NodeType[NodeType["Forward"] = 80] = "Forward";
    NodeType[NodeType["ForwardVisibility"] = 81] = "ForwardVisibility";
    NodeType[NodeType["Module"] = 82] = "Module";
    NodeType[NodeType["UnicodeRange"] = 83] = "UnicodeRange";
    NodeType[NodeType["Layer"] = 84] = "Layer";
    NodeType[NodeType["LayerNameList"] = 85] = "LayerNameList";
    NodeType[NodeType["LayerName"] = 86] = "LayerName";
    NodeType[NodeType["PropertyAtRule"] = 87] = "PropertyAtRule";
    NodeType[NodeType["Container"] = 88] = "Container";
    NodeType[NodeType["ModuleConfig"] = 89] = "ModuleConfig";
    NodeType[NodeType["SelectorList"] = 90] = "SelectorList";
    NodeType[NodeType["StartingStyleAtRule"] = 91] = "StartingStyleAtRule";
})($bd0cebf2eccc0e7e$export$f06e977173f1857c || ($bd0cebf2eccc0e7e$export$f06e977173f1857c = {}));
var $bd0cebf2eccc0e7e$export$8868dff548d048cf;
(function(ReferenceType) {
    ReferenceType[ReferenceType["Mixin"] = 0] = "Mixin";
    ReferenceType[ReferenceType["Rule"] = 1] = "Rule";
    ReferenceType[ReferenceType["Variable"] = 2] = "Variable";
    ReferenceType[ReferenceType["Function"] = 3] = "Function";
    ReferenceType[ReferenceType["Keyframe"] = 4] = "Keyframe";
    ReferenceType[ReferenceType["Unknown"] = 5] = "Unknown";
    ReferenceType[ReferenceType["Module"] = 6] = "Module";
    ReferenceType[ReferenceType["Forward"] = 7] = "Forward";
    ReferenceType[ReferenceType["ForwardVisibility"] = 8] = "ForwardVisibility";
    ReferenceType[ReferenceType["Property"] = 9] = "Property";
})($bd0cebf2eccc0e7e$export$8868dff548d048cf || ($bd0cebf2eccc0e7e$export$8868dff548d048cf = {}));
function $bd0cebf2eccc0e7e$export$8501d4bdbd8952bc(node, offset) {
    let candidate = null;
    if (!node || offset < node.offset || offset > node.end) return null;
    // Find the shortest node at the position
    node.accept((node)=>{
        if (node.offset === -1 && node.length === -1) return true;
        if (node.offset <= offset && node.end >= offset) {
            if (!candidate) candidate = node;
            else if (node.length <= candidate.length) candidate = node;
            return true;
        }
        return false;
    });
    return candidate;
}
function $bd0cebf2eccc0e7e$export$7371e5dfbc4269ff(node, offset) {
    let candidate = $bd0cebf2eccc0e7e$export$8501d4bdbd8952bc(node, offset);
    const path = [];
    while(candidate){
        path.unshift(candidate);
        candidate = candidate.parent;
    }
    return path;
}
function $bd0cebf2eccc0e7e$export$327419d17f0a0346(node) {
    const decl = node.findParent($bd0cebf2eccc0e7e$export$f06e977173f1857c.Declaration);
    const value = decl && decl.getValue();
    if (value && value.encloses(node)) return decl;
    return null;
}
class $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    get end() {
        return this.offset + this.length;
    }
    constructor(offset = -1, len = -1, nodeType){
        this.parent = null;
        this.offset = offset;
        this.length = len;
        if (nodeType) this.nodeType = nodeType;
    }
    set type(type) {
        this.nodeType = type;
    }
    get type() {
        return this.nodeType || $bd0cebf2eccc0e7e$export$f06e977173f1857c.Undefined;
    }
    getTextProvider() {
        let node = this;
        while(node && !node.textProvider)node = node.parent;
        if (node) return node.textProvider;
        return ()=>{
            return 'unknown';
        };
    }
    getText() {
        return this.getTextProvider()(this.offset, this.length);
    }
    matches(str) {
        return this.length === str.length && this.getTextProvider()(this.offset, this.length) === str;
    }
    startsWith(str) {
        return this.length >= str.length && this.getTextProvider()(this.offset, str.length) === str;
    }
    endsWith(str) {
        return this.length >= str.length && this.getTextProvider()(this.end - str.length, str.length) === str;
    }
    accept(visitor) {
        if (visitor(this) && this.children) for (const child of this.children)child.accept(visitor);
    }
    acceptVisitor(visitor) {
        this.accept(visitor.visitNode.bind(visitor));
    }
    adoptChild(node, index = -1) {
        if (node.parent && node.parent.children) {
            const idx = node.parent.children.indexOf(node);
            if (idx >= 0) node.parent.children.splice(idx, 1);
        }
        node.parent = this;
        let children = this.children;
        if (!children) children = this.children = [];
        if (index !== -1) children.splice(index, 0, node);
        else children.push(node);
        return node;
    }
    attachTo(parent, index = -1) {
        if (parent) parent.adoptChild(this, index);
        return this;
    }
    collectIssues(results) {
        if (this.issues) results.push.apply(results, this.issues);
    }
    addIssue(issue) {
        if (!this.issues) this.issues = [];
        this.issues.push(issue);
    }
    hasIssue(rule) {
        return Array.isArray(this.issues) && this.issues.some((i)=>i.getRule() === rule);
    }
    isErroneous(recursive = false) {
        if (this.issues && this.issues.length > 0) return true;
        return recursive && Array.isArray(this.children) && this.children.some((c)=>c.isErroneous(true));
    }
    setNode(field, node, index = -1) {
        if (node) {
            node.attachTo(this, index);
            this[field] = node;
            return true;
        }
        return false;
    }
    addChild(node) {
        if (node) {
            if (!this.children) this.children = [];
            node.attachTo(this);
            this.updateOffsetAndLength(node);
            return true;
        }
        return false;
    }
    updateOffsetAndLength(node) {
        if (node.offset < this.offset || this.offset === -1) this.offset = node.offset;
        const nodeEnd = node.end;
        if (nodeEnd > this.end || this.length === -1) this.length = nodeEnd - this.offset;
    }
    hasChildren() {
        return !!this.children && this.children.length > 0;
    }
    getChildren() {
        return this.children ? this.children.slice(0) : [];
    }
    getChild(index) {
        if (this.children && index < this.children.length) return this.children[index];
        return null;
    }
    addChildren(nodes) {
        for (const node of nodes)this.addChild(node);
    }
    findFirstChildBeforeOffset(offset) {
        if (this.children) {
            let current = null;
            for(let i = this.children.length - 1; i >= 0; i--){
                // iterate until we find a child that has a start offset smaller than the input offset
                current = this.children[i];
                if (current.offset <= offset) return current;
            }
        }
        return null;
    }
    findChildAtOffset(offset, goDeep) {
        const current = this.findFirstChildBeforeOffset(offset);
        if (current && current.end >= offset) {
            if (goDeep) return current.findChildAtOffset(offset, true) || current;
            return current;
        }
        return null;
    }
    encloses(candidate) {
        return this.offset <= candidate.offset && this.offset + this.length >= candidate.offset + candidate.length;
    }
    getParent() {
        let result = this.parent;
        while(result instanceof $bd0cebf2eccc0e7e$export$607901bfe20d7337)result = result.parent;
        return result;
    }
    findParent(type) {
        let result = this;
        while(result && result.type !== type)result = result.parent;
        return result;
    }
    findAParent(...types) {
        let result = this;
        while(result && !types.some((t)=>result.type === t))result = result.parent;
        return result;
    }
    setData(key, value) {
        if (!this.options) this.options = {};
        this.options[key] = value;
    }
    getData(key) {
        if (!this.options || !this.options.hasOwnProperty(key)) return null;
        return this.options[key];
    }
}
class $bd0cebf2eccc0e7e$export$607901bfe20d7337 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(parent, index = -1){
        super(-1, -1);
        this.attachTo(parent, index);
        this.offset = -1;
        this.length = -1;
    }
}
class $bd0cebf2eccc0e7e$export$3f8e011aa996e1b4 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.UnicodeRange;
    }
    setRangeStart(rangeStart) {
        return this.setNode('rangeStart', rangeStart);
    }
    getRangeStart() {
        return this.rangeStart;
    }
    setRangeEnd(rangeEnd) {
        return this.setNode('rangeEnd', rangeEnd);
    }
    getRangeEnd() {
        return this.rangeEnd;
    }
}
class $bd0cebf2eccc0e7e$export$989167234458594d extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
        this.isCustomProperty = false;
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Identifier;
    }
    containsInterpolation() {
        return this.hasChildren();
    }
}
class $bd0cebf2eccc0e7e$export$cd02bf5de16fbd7c extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Stylesheet;
    }
}
class $bd0cebf2eccc0e7e$export$86a08221bdddb90c extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Declarations;
    }
}
class $bd0cebf2eccc0e7e$export$750c6750564ae5ac extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    getDeclarations() {
        return this.declarations;
    }
    setDeclarations(decls) {
        return this.setNode('declarations', decls);
    }
}
class $bd0cebf2eccc0e7e$export$ade1230f1a17327c extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Ruleset;
    }
    getSelectors() {
        if (!this.selectors) this.selectors = new $bd0cebf2eccc0e7e$export$607901bfe20d7337(this);
        return this.selectors;
    }
    isNested() {
        return !!this.parent && this.parent.findParent($bd0cebf2eccc0e7e$export$f06e977173f1857c.Declarations) !== null;
    }
}
class $bd0cebf2eccc0e7e$export$d15f4cd5286f9b1e extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Selector;
    }
}
class $bd0cebf2eccc0e7e$export$bfa70abafbc5e495 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.SimpleSelector;
    }
}
class $bd0cebf2eccc0e7e$export$49a9ee615c9322a8 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.AtApplyRule;
    }
    setIdentifier(node) {
        return this.setNode('identifier', node, 0);
    }
    getIdentifier() {
        return this.identifier;
    }
    getName() {
        return this.identifier ? this.identifier.getText() : '';
    }
}
class $bd0cebf2eccc0e7e$export$d0574b2f663baa17 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
}
class $bd0cebf2eccc0e7e$export$bb5dbf44b0a48bac extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.CustomPropertySet;
    }
}
class $bd0cebf2eccc0e7e$export$48f3d9e786303b67 extends $bd0cebf2eccc0e7e$export$d0574b2f663baa17 {
    constructor(offset, length){
        super(offset, length);
        this.property = null;
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Declaration;
    }
    setProperty(node) {
        return this.setNode('property', node);
    }
    getProperty() {
        return this.property;
    }
    getFullPropertyName() {
        const propertyName = this.property ? this.property.getName() : 'unknown';
        if (this.parent instanceof $bd0cebf2eccc0e7e$export$86a08221bdddb90c && this.parent.getParent() instanceof $bd0cebf2eccc0e7e$export$791a0a3a4cdc7a08) {
            const parentDecl = this.parent.getParent().getParent();
            if (parentDecl instanceof $bd0cebf2eccc0e7e$export$48f3d9e786303b67) return parentDecl.getFullPropertyName() + propertyName;
        }
        return propertyName;
    }
    getNonPrefixedPropertyName() {
        const propertyName = this.getFullPropertyName();
        if (propertyName && propertyName.charAt(0) === '-') {
            const vendorPrefixEnd = propertyName.indexOf('-', 1);
            if (vendorPrefixEnd !== -1) return propertyName.substring(vendorPrefixEnd + 1);
        }
        return propertyName;
    }
    setValue(value) {
        return this.setNode('value', value);
    }
    getValue() {
        return this.value;
    }
    setNestedProperties(value) {
        return this.setNode('nestedProperties', value);
    }
    getNestedProperties() {
        return this.nestedProperties;
    }
}
class $bd0cebf2eccc0e7e$export$9eb29e7be34fda47 extends $bd0cebf2eccc0e7e$export$48f3d9e786303b67 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.CustomPropertyDeclaration;
    }
    setPropertySet(value) {
        return this.setNode('propertySet', value);
    }
    getPropertySet() {
        return this.propertySet;
    }
}
class $bd0cebf2eccc0e7e$export$41b04b3a73e7216d extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Property;
    }
    setIdentifier(value) {
        return this.setNode('identifier', value);
    }
    getIdentifier() {
        return this.identifier;
    }
    getName() {
        return (0, $3383aa02dc8dfba4$export$87c2784dc9fc4ab)(this.getText(), /[_\+]+$/); /* +_: less merge */ 
    }
    isCustomProperty() {
        return !!this.identifier && this.identifier.isCustomProperty;
    }
}
class $bd0cebf2eccc0e7e$export$9b1895ef7ed2ca15 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Invocation;
    }
    getArguments() {
        if (!this.arguments) this.arguments = new $bd0cebf2eccc0e7e$export$607901bfe20d7337(this);
        return this.arguments;
    }
}
class $bd0cebf2eccc0e7e$export$f3890eeaf6851387 extends $bd0cebf2eccc0e7e$export$9b1895ef7ed2ca15 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Function;
    }
    setIdentifier(node) {
        return this.setNode('identifier', node, 0);
    }
    getIdentifier() {
        return this.identifier;
    }
    getName() {
        return this.identifier ? this.identifier.getText() : '';
    }
}
class $bd0cebf2eccc0e7e$export$e8b5f24364ee45a9 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.FunctionParameter;
    }
    setIdentifier(node) {
        return this.setNode('identifier', node, 0);
    }
    getIdentifier() {
        return this.identifier;
    }
    getName() {
        return this.identifier ? this.identifier.getText() : '';
    }
    setDefaultValue(node) {
        return this.setNode('defaultValue', node, 0);
    }
    getDefaultValue() {
        return this.defaultValue;
    }
}
class $bd0cebf2eccc0e7e$export$5868bced5e602b28 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.FunctionArgument;
    }
    setIdentifier(node) {
        return this.setNode('identifier', node, 0);
    }
    getIdentifier() {
        return this.identifier;
    }
    getName() {
        return this.identifier ? this.identifier.getText() : '';
    }
    setValue(node) {
        return this.setNode('value', node, 0);
    }
    getValue() {
        return this.value;
    }
}
class $bd0cebf2eccc0e7e$export$9017d3771bcf5fda extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.If;
    }
    setExpression(node) {
        return this.setNode('expression', node, 0);
    }
    setElseClause(elseClause) {
        return this.setNode('elseClause', elseClause);
    }
}
class $bd0cebf2eccc0e7e$export$7fbe105ea6b2947 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.For;
    }
    setVariable(node) {
        return this.setNode('variable', node, 0);
    }
}
class $bd0cebf2eccc0e7e$export$54f14bc486f54670 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Each;
    }
    getVariables() {
        if (!this.variables) this.variables = new $bd0cebf2eccc0e7e$export$607901bfe20d7337(this);
        return this.variables;
    }
}
class $bd0cebf2eccc0e7e$export$479b943950dcc4d3 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.While;
    }
}
class $bd0cebf2eccc0e7e$export$bf9e95c0b5a6e7f7 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Else;
    }
}
class $bd0cebf2eccc0e7e$export$db0c6820087997c2 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.FunctionDeclaration;
    }
    setIdentifier(node) {
        return this.setNode('identifier', node, 0);
    }
    getIdentifier() {
        return this.identifier;
    }
    getName() {
        return this.identifier ? this.identifier.getText() : '';
    }
    getParameters() {
        if (!this.parameters) this.parameters = new $bd0cebf2eccc0e7e$export$607901bfe20d7337(this);
        return this.parameters;
    }
}
class $bd0cebf2eccc0e7e$export$15d36fc1a69ab4a0 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.ViewPort;
    }
}
class $bd0cebf2eccc0e7e$export$2e039772bf0d47a5 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.FontFace;
    }
}
class $bd0cebf2eccc0e7e$export$791a0a3a4cdc7a08 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.NestedProperties;
    }
}
class $bd0cebf2eccc0e7e$export$7b3cfeb4fa34c97f extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Keyframe;
    }
    setKeyword(keyword) {
        return this.setNode('keyword', keyword, 0);
    }
    getKeyword() {
        return this.keyword;
    }
    setIdentifier(node) {
        return this.setNode('identifier', node, 0);
    }
    getIdentifier() {
        return this.identifier;
    }
    getName() {
        return this.identifier ? this.identifier.getText() : '';
    }
}
class $bd0cebf2eccc0e7e$export$8e0f67d7f8836b42 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.KeyframeSelector;
    }
}
class $bd0cebf2eccc0e7e$export$d0dbb306591aec74 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Import;
    }
    setMedialist(node) {
        if (node) {
            node.attachTo(this);
            return true;
        }
        return false;
    }
}
class $bd0cebf2eccc0e7e$export$2973c9696e76e472 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Use;
    }
    setParameters(value) {
        return this.setNode('parameters', value);
    }
    getParameters() {
        return this.parameters;
    }
    setIdentifier(node) {
        return this.setNode('identifier', node, 0);
    }
    getIdentifier() {
        return this.identifier;
    }
}
class $bd0cebf2eccc0e7e$export$a9d66896dff4ea40 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.ModuleConfiguration;
    }
    setIdentifier(node) {
        return this.setNode('identifier', node, 0);
    }
    getIdentifier() {
        return this.identifier;
    }
    getName() {
        return this.identifier ? this.identifier.getText() : '';
    }
    setValue(node) {
        return this.setNode('value', node, 0);
    }
    getValue() {
        return this.value;
    }
}
class $bd0cebf2eccc0e7e$export$7724b1686f1f8cff extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Forward;
    }
    setIdentifier(node) {
        return this.setNode('identifier', node, 0);
    }
    getIdentifier() {
        return this.identifier;
    }
    setParameters(value) {
        return this.setNode('parameters', value);
    }
    getParameters() {
        return this.parameters;
    }
}
class $bd0cebf2eccc0e7e$export$7a6ba1620e111f36 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.ForwardVisibility;
    }
    setIdentifier(node) {
        return this.setNode('identifier', node, 0);
    }
    getIdentifier() {
        return this.identifier;
    }
}
class $bd0cebf2eccc0e7e$export$f89ac22183df46e9 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Namespace;
    }
}
class $bd0cebf2eccc0e7e$export$7fc53215244aec38 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Media;
    }
}
class $bd0cebf2eccc0e7e$export$775b6bb06e53a214 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Scope;
    }
}
class $bd0cebf2eccc0e7e$export$78326a4db4056ab8 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Scope;
    }
    getScopeStart() {
        return this.scopeStart;
    }
    setScopeStart(right) {
        return this.setNode('scopeStart', right);
    }
    getScopeEnd() {
        return this.scopeEnd;
    }
    setScopeEnd(right) {
        return this.setNode('scopeEnd', right);
    }
    getName() {
        let name = '';
        if (this.scopeStart) name += this.scopeStart.getText();
        if (this.scopeEnd) name += `${this.scopeStart ? ' ' : ''}\u{2192} ${this.scopeEnd.getText()}`;
        return name;
    }
}
class $bd0cebf2eccc0e7e$export$25be9502477c137d extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Supports;
    }
}
class $bd0cebf2eccc0e7e$export$936d0764594b6eb3 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Layer;
    }
    setNames(names) {
        return this.setNode('names', names);
    }
    getNames() {
        return this.names;
    }
}
class $bd0cebf2eccc0e7e$export$c856fef2b997f0ca extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.PropertyAtRule;
    }
    setName(node) {
        if (node) {
            node.attachTo(this);
            this.name = node;
            return true;
        }
        return false;
    }
    getName() {
        return this.name;
    }
}
class $bd0cebf2eccc0e7e$export$1b503fb31829e5d9 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.StartingStyleAtRule;
    }
}
class $bd0cebf2eccc0e7e$export$b34a105447964f9f extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Document;
    }
}
class $bd0cebf2eccc0e7e$export$42a852a2b6b56249 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Container;
    }
}
class $bd0cebf2eccc0e7e$export$7143f4602d24ccbd extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
}
class $bd0cebf2eccc0e7e$export$b745838c41029eb3 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.MediaQuery;
    }
}
class $bd0cebf2eccc0e7e$export$9b8dfe638de9b72f extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.MediaCondition;
    }
}
class $bd0cebf2eccc0e7e$export$a38b0f36e6ad18cf extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.MediaFeature;
    }
}
class $bd0cebf2eccc0e7e$export$a895090a19988f16 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.SupportsCondition;
    }
}
class $bd0cebf2eccc0e7e$export$6955bcca4cd3539f extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Page;
    }
}
class $bd0cebf2eccc0e7e$export$358767b9aa8b07d7 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.PageBoxMarginBox;
    }
}
class $bd0cebf2eccc0e7e$export$bfe37c1342e5eb83 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Expression;
    }
}
class $bd0cebf2eccc0e7e$export$5351bc98fa48e09c extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.BinaryExpression;
    }
    setLeft(left) {
        return this.setNode('left', left);
    }
    getLeft() {
        return this.left;
    }
    setRight(right) {
        return this.setNode('right', right);
    }
    getRight() {
        return this.right;
    }
    setOperator(value) {
        return this.setNode('operator', value);
    }
    getOperator() {
        return this.operator;
    }
}
class $bd0cebf2eccc0e7e$export$656c1e606ad06131 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Term;
    }
    setOperator(value) {
        return this.setNode('operator', value);
    }
    getOperator() {
        return this.operator;
    }
    setExpression(value) {
        return this.setNode('expression', value);
    }
    getExpression() {
        return this.expression;
    }
}
class $bd0cebf2eccc0e7e$export$8170b1e1b2558dd5 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.AttributeSelector;
    }
    setNamespacePrefix(value) {
        return this.setNode('namespacePrefix', value);
    }
    getNamespacePrefix() {
        return this.namespacePrefix;
    }
    setIdentifier(value) {
        return this.setNode('identifier', value);
    }
    getIdentifier() {
        return this.identifier;
    }
    setOperator(operator) {
        return this.setNode('operator', operator);
    }
    getOperator() {
        return this.operator;
    }
    setValue(value) {
        return this.setNode('value', value);
    }
    getValue() {
        return this.value;
    }
}
class $bd0cebf2eccc0e7e$export$fa5f90bfb4dbdbcd extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Operator;
    }
}
class $bd0cebf2eccc0e7e$export$7d5dd309eeea3db1 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.HexColorValue;
    }
}
class $bd0cebf2eccc0e7e$export$c67c8344288de6f6 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.RatioValue;
    }
}
const $bd0cebf2eccc0e7e$var$_dot = '.'.charCodeAt(0), $bd0cebf2eccc0e7e$var$_0 = '0'.charCodeAt(0), $bd0cebf2eccc0e7e$var$_9 = '9'.charCodeAt(0);
class $bd0cebf2eccc0e7e$export$8c91fb1ff010a18e extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.NumericValue;
    }
    getValue() {
        const raw = this.getText();
        let unitIdx = 0;
        let code;
        for(let i = 0, len = raw.length; i < len; i++){
            code = raw.charCodeAt(i);
            if (!($bd0cebf2eccc0e7e$var$_0 <= code && code <= $bd0cebf2eccc0e7e$var$_9 || code === $bd0cebf2eccc0e7e$var$_dot)) break;
            unitIdx += 1;
        }
        return {
            value: raw.substring(0, unitIdx),
            unit: unitIdx < raw.length ? raw.substring(unitIdx) : undefined
        };
    }
}
class $bd0cebf2eccc0e7e$export$839cf4f882eabac8 extends $bd0cebf2eccc0e7e$export$d0574b2f663baa17 {
    constructor(offset, length){
        super(offset, length);
        this.needsSemicolon = true;
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.VariableDeclaration;
    }
    setVariable(node) {
        if (node) {
            node.attachTo(this);
            this.variable = node;
            return true;
        }
        return false;
    }
    getVariable() {
        return this.variable;
    }
    getName() {
        return this.variable ? this.variable.getName() : '';
    }
    setValue(node) {
        if (node) {
            node.attachTo(this);
            this.value = node;
            return true;
        }
        return false;
    }
    getValue() {
        return this.value;
    }
}
class $bd0cebf2eccc0e7e$export$b0cc4f9860136880 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    // private _interpolations: void; // workaround for https://github.com/Microsoft/TypeScript/issues/18276
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Interpolation;
    }
}
class $bd0cebf2eccc0e7e$export$c867a5c9595a1350 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.VariableName;
    }
    getName() {
        return this.getText();
    }
}
class $bd0cebf2eccc0e7e$export$aebff1c4d1af2d3a extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.ExtendsReference;
    }
    getSelectors() {
        if (!this.selectors) this.selectors = new $bd0cebf2eccc0e7e$export$607901bfe20d7337(this);
        return this.selectors;
    }
}
class $bd0cebf2eccc0e7e$export$dfb915b95ac305eb extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.MixinContentReference;
    }
    getArguments() {
        if (!this.arguments) this.arguments = new $bd0cebf2eccc0e7e$export$607901bfe20d7337(this);
        return this.arguments;
    }
}
class $bd0cebf2eccc0e7e$export$33a2610af6b3f2ee extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.MixinContentDeclaration;
    }
    getParameters() {
        if (!this.parameters) this.parameters = new $bd0cebf2eccc0e7e$export$607901bfe20d7337(this);
        return this.parameters;
    }
}
class $bd0cebf2eccc0e7e$export$8ca7a1a636597cad extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.MixinReference;
    }
    getNamespaces() {
        if (!this.namespaces) this.namespaces = new $bd0cebf2eccc0e7e$export$607901bfe20d7337(this);
        return this.namespaces;
    }
    setIdentifier(node) {
        return this.setNode('identifier', node, 0);
    }
    getIdentifier() {
        return this.identifier;
    }
    getName() {
        return this.identifier ? this.identifier.getText() : '';
    }
    getArguments() {
        if (!this.arguments) this.arguments = new $bd0cebf2eccc0e7e$export$607901bfe20d7337(this);
        return this.arguments;
    }
    setContent(node) {
        return this.setNode('content', node);
    }
    getContent() {
        return this.content;
    }
}
class $bd0cebf2eccc0e7e$export$f518258a40310702 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.MixinDeclaration;
    }
    setIdentifier(node) {
        return this.setNode('identifier', node, 0);
    }
    getIdentifier() {
        return this.identifier;
    }
    getName() {
        return this.identifier ? this.identifier.getText() : '';
    }
    getParameters() {
        if (!this.parameters) this.parameters = new $bd0cebf2eccc0e7e$export$607901bfe20d7337(this);
        return this.parameters;
    }
    setGuard(node) {
        if (node) {
            node.attachTo(this);
            this.guard = node;
        }
        return false;
    }
}
class $bd0cebf2eccc0e7e$export$b8b985b0b9cf23a2 extends $bd0cebf2eccc0e7e$export$750c6750564ae5ac {
    constructor(offset, length){
        super(offset, length);
    }
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.UnknownAtRule;
    }
    setAtRuleName(atRuleName) {
        this.atRuleName = atRuleName;
    }
    getAtRuleName() {
        return this.atRuleName;
    }
}
class $bd0cebf2eccc0e7e$export$fe34ec5df90a97ec extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.ListEntry;
    }
    setKey(node) {
        return this.setNode('key', node, 0);
    }
    setValue(node) {
        return this.setNode('value', node, 1);
    }
}
class $bd0cebf2eccc0e7e$export$8b7e5e70221c0946 extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    getConditions() {
        if (!this.conditions) this.conditions = new $bd0cebf2eccc0e7e$export$607901bfe20d7337(this);
        return this.conditions;
    }
}
class $bd0cebf2eccc0e7e$export$8bca042b7fec9ee extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    setVariable(node) {
        return this.setNode('variable', node);
    }
}
class $bd0cebf2eccc0e7e$export$c3a9d7ff17e4f3ed extends $bd0cebf2eccc0e7e$export$85c928794f8d04d4 {
    get type() {
        return $bd0cebf2eccc0e7e$export$f06e977173f1857c.Module;
    }
    setIdentifier(node) {
        return this.setNode('identifier', node, 0);
    }
    getIdentifier() {
        return this.identifier;
    }
}
var $bd0cebf2eccc0e7e$export$ca664994d1d54bff;
(function(Level) {
    Level[Level["Ignore"] = 1] = "Ignore";
    Level[Level["Warning"] = 2] = "Warning";
    Level[Level["Error"] = 4] = "Error";
})($bd0cebf2eccc0e7e$export$ca664994d1d54bff || ($bd0cebf2eccc0e7e$export$ca664994d1d54bff = {}));
class $bd0cebf2eccc0e7e$export$e98856a975cab58e {
    constructor(node, rule, level, message, offset = node.offset, length = node.length){
        this.node = node;
        this.rule = rule;
        this.level = level;
        this.message = message || rule.message;
        this.offset = offset;
        this.length = length;
    }
    getRule() {
        return this.rule;
    }
    getLevel() {
        return this.level;
    }
    getOffset() {
        return this.offset;
    }
    getLength() {
        return this.length;
    }
    getNode() {
        return this.node;
    }
    getMessage() {
        return this.message;
    }
}
class $bd0cebf2eccc0e7e$export$376f37e19157ceda {
    static entries(node) {
        const visitor = new $bd0cebf2eccc0e7e$export$376f37e19157ceda();
        node.acceptVisitor(visitor);
        return visitor.entries;
    }
    constructor(){
        this.entries = [];
    }
    visitNode(node) {
        if (node.isErroneous()) node.collectIssues(this.entries);
        return true;
    }
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ // src/browser/reader.ts
async function $3240faa9c744ac82$var$readFileFromUri(uri) {
    if (uri.protocol === "http:" || uri.protocol === "https:") {
        const res = await fetch(uri);
        return await res.text();
    }
    throw new Error("Unsupported protocol");
}
function $3240faa9c744ac82$var$readFileFromFsPath(_) {
    throw new Error("Unsupported in browser");
}
// src/main.ts
var $3240faa9c744ac82$var$bundle;
function $3240faa9c744ac82$export$e506a1d27d1eaa20(config2) {
    if ("contents" in config2) {
        if (typeof config2.contents === "string") $3240faa9c744ac82$var$bundle = JSON.parse(config2.contents);
        else $3240faa9c744ac82$var$bundle = config2.contents;
        return;
    }
    if ("fsPath" in config2) {
        const fileContent = $3240faa9c744ac82$var$readFileFromFsPath(config2.fsPath);
        const content = JSON.parse(fileContent);
        $3240faa9c744ac82$var$bundle = $3240faa9c744ac82$var$isBuiltinExtension(content) ? content.contents.bundle : content;
        return;
    }
    if (config2.uri) {
        let uri = config2.uri;
        if (typeof config2.uri === "string") uri = new URL(config2.uri);
        return new Promise((resolve, reject)=>{
            $3240faa9c744ac82$var$readFileFromUri(uri).then((uriContent)=>{
                try {
                    const content = JSON.parse(uriContent);
                    $3240faa9c744ac82$var$bundle = $3240faa9c744ac82$var$isBuiltinExtension(content) ? content.contents.bundle : content;
                    resolve();
                } catch (err) {
                    reject(err);
                }
            }).catch((err)=>{
                reject(err);
            });
        });
    }
}
function $3240faa9c744ac82$export$625550452a3fa3ec(...args) {
    const firstArg = args[0];
    let key;
    let message;
    let formatArgs;
    if (typeof firstArg === "string") {
        key = firstArg;
        message = firstArg;
        args.splice(0, 1);
        formatArgs = !args || typeof args[0] !== "object" ? args : args[0];
    } else if (firstArg instanceof Array) {
        const replacements = args.slice(1);
        if (firstArg.length !== replacements.length + 1) throw new Error("expected a string as the first argument to l10n.t");
        let str = firstArg[0];
        for(let i = 1; i < firstArg.length; i++)str += `{${i - 1}}` + firstArg[i];
        return $3240faa9c744ac82$export$625550452a3fa3ec(str, ...replacements);
    } else {
        message = firstArg.message;
        key = message;
        if (firstArg.comment && firstArg.comment.length > 0) key += `/${Array.isArray(firstArg.comment) ? firstArg.comment.join("") : firstArg.comment}`;
        formatArgs = firstArg.args ?? {};
    }
    const messageFromBundle = $3240faa9c744ac82$var$bundle?.[key];
    if (!messageFromBundle) return $3240faa9c744ac82$var$format(message, formatArgs);
    if (typeof messageFromBundle === "string") return $3240faa9c744ac82$var$format(messageFromBundle, formatArgs);
    if (messageFromBundle.comment) return $3240faa9c744ac82$var$format(messageFromBundle.message, formatArgs);
    return $3240faa9c744ac82$var$format(message, formatArgs);
}
var $3240faa9c744ac82$var$_format2Regexp = /{([^}]+)}/g;
function $3240faa9c744ac82$var$format(template, values) {
    if (Object.keys(values).length === 0) return template;
    return template.replace($3240faa9c744ac82$var$_format2Regexp, (match, group)=>values[group] ?? match);
}
function $3240faa9c744ac82$var$isBuiltinExtension(json) {
    return !!(typeof json?.contents?.bundle === "object" && typeof json?.version === "string");
}


'use strict';
class $053a694fcaa2117c$export$2112b9e42555aa08 {
    constructor(id, message){
        this.id = id;
        this.message = message;
    }
}
const $053a694fcaa2117c$export$f9c837a54db411d = {
    NumberExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-numberexpected', $3240faa9c744ac82$export$625550452a3fa3ec("number expected")),
    ConditionExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-conditionexpected', $3240faa9c744ac82$export$625550452a3fa3ec("condition expected")),
    RuleOrSelectorExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-ruleorselectorexpected', $3240faa9c744ac82$export$625550452a3fa3ec("at-rule or selector expected")),
    DotExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-dotexpected', $3240faa9c744ac82$export$625550452a3fa3ec("dot expected")),
    ColonExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-colonexpected', $3240faa9c744ac82$export$625550452a3fa3ec("colon expected")),
    SemiColonExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-semicolonexpected', $3240faa9c744ac82$export$625550452a3fa3ec("semi-colon expected")),
    TermExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-termexpected', $3240faa9c744ac82$export$625550452a3fa3ec("term expected")),
    ExpressionExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-expressionexpected', $3240faa9c744ac82$export$625550452a3fa3ec("expression expected")),
    OperatorExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-operatorexpected', $3240faa9c744ac82$export$625550452a3fa3ec("operator expected")),
    IdentifierExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-identifierexpected', $3240faa9c744ac82$export$625550452a3fa3ec("identifier expected")),
    PercentageExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-percentageexpected', $3240faa9c744ac82$export$625550452a3fa3ec("percentage expected")),
    URIOrStringExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-uriorstringexpected', $3240faa9c744ac82$export$625550452a3fa3ec("uri or string expected")),
    URIExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-uriexpected', $3240faa9c744ac82$export$625550452a3fa3ec("URI expected")),
    VariableNameExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-varnameexpected', $3240faa9c744ac82$export$625550452a3fa3ec("variable name expected")),
    VariableValueExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-varvalueexpected', $3240faa9c744ac82$export$625550452a3fa3ec("variable value expected")),
    PropertyValueExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-propertyvalueexpected', $3240faa9c744ac82$export$625550452a3fa3ec("property value expected")),
    LeftCurlyExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-lcurlyexpected', $3240faa9c744ac82$export$625550452a3fa3ec("{ expected")),
    RightCurlyExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-rcurlyexpected', $3240faa9c744ac82$export$625550452a3fa3ec("} expected")),
    LeftSquareBracketExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-rbracketexpected', $3240faa9c744ac82$export$625550452a3fa3ec("[ expected")),
    RightSquareBracketExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-lbracketexpected', $3240faa9c744ac82$export$625550452a3fa3ec("] expected")),
    LeftParenthesisExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-lparentexpected', $3240faa9c744ac82$export$625550452a3fa3ec("( expected")),
    RightParenthesisExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-rparentexpected', $3240faa9c744ac82$export$625550452a3fa3ec(") expected")),
    CommaExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-commaexpected', $3240faa9c744ac82$export$625550452a3fa3ec("comma expected")),
    PageDirectiveOrDeclarationExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-pagedirordeclexpected', $3240faa9c744ac82$export$625550452a3fa3ec("page directive or declaraton expected")),
    UnknownAtRule: new $053a694fcaa2117c$export$2112b9e42555aa08('css-unknownatrule', $3240faa9c744ac82$export$625550452a3fa3ec("at-rule unknown")),
    UnknownKeyword: new $053a694fcaa2117c$export$2112b9e42555aa08('css-unknownkeyword', $3240faa9c744ac82$export$625550452a3fa3ec("unknown keyword")),
    SelectorExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-selectorexpected', $3240faa9c744ac82$export$625550452a3fa3ec("selector expected")),
    StringLiteralExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-stringliteralexpected', $3240faa9c744ac82$export$625550452a3fa3ec("string literal expected")),
    WhitespaceExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-whitespaceexpected', $3240faa9c744ac82$export$625550452a3fa3ec("whitespace expected")),
    MediaQueryExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-mediaqueryexpected', $3240faa9c744ac82$export$625550452a3fa3ec("media query expected")),
    IdentifierOrWildcardExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-idorwildcardexpected', $3240faa9c744ac82$export$625550452a3fa3ec("identifier or wildcard expected")),
    WildcardExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-wildcardexpected', $3240faa9c744ac82$export$625550452a3fa3ec("wildcard expected")),
    IdentifierOrVariableExpected: new $053a694fcaa2117c$export$2112b9e42555aa08('css-idorvarexpected', $3240faa9c744ac82$export$625550452a3fa3ec("identifier or variable expected"))
};


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var $1345bdc33671c7a9$exports = {};
(function(factory) {
    if (typeof $1345bdc33671c7a9$exports === "object") {
        var v = factory(undefined, $1345bdc33671c7a9$exports);
        if (v !== undefined) $1345bdc33671c7a9$exports = v;
    } else if (typeof define === "function" && define.amd) define([
        "require",
        "exports"
    ], factory);
})(function(require1, exports1) {
    /* --------------------------------------------------------------------------------------------
     * Copyright (c) Microsoft Corporation. All rights reserved.
     * Licensed under the MIT License. See License.txt in the project root for license information.
     * ------------------------------------------------------------------------------------------ */ 'use strict';
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.TextDocument = exports1.EOL = exports1.WorkspaceFolder = exports1.InlineCompletionContext = exports1.SelectedCompletionInfo = exports1.InlineCompletionTriggerKind = exports1.InlineCompletionList = exports1.InlineCompletionItem = exports1.StringValue = exports1.InlayHint = exports1.InlayHintLabelPart = exports1.InlayHintKind = exports1.InlineValueContext = exports1.InlineValueEvaluatableExpression = exports1.InlineValueVariableLookup = exports1.InlineValueText = exports1.SemanticTokens = exports1.SemanticTokenModifiers = exports1.SemanticTokenTypes = exports1.SelectionRange = exports1.DocumentLink = exports1.FormattingOptions = exports1.CodeLens = exports1.CodeAction = exports1.CodeActionContext = exports1.CodeActionTriggerKind = exports1.CodeActionKind = exports1.DocumentSymbol = exports1.WorkspaceSymbol = exports1.SymbolInformation = exports1.SymbolTag = exports1.SymbolKind = exports1.DocumentHighlight = exports1.DocumentHighlightKind = exports1.SignatureInformation = exports1.ParameterInformation = exports1.Hover = exports1.MarkedString = exports1.CompletionList = exports1.CompletionItem = exports1.CompletionItemLabelDetails = exports1.InsertTextMode = exports1.InsertReplaceEdit = exports1.CompletionItemTag = exports1.InsertTextFormat = exports1.CompletionItemKind = exports1.MarkupContent = exports1.MarkupKind = exports1.TextDocumentItem = exports1.OptionalVersionedTextDocumentIdentifier = exports1.VersionedTextDocumentIdentifier = exports1.TextDocumentIdentifier = exports1.WorkspaceChange = exports1.WorkspaceEdit = exports1.DeleteFile = exports1.RenameFile = exports1.CreateFile = exports1.TextDocumentEdit = exports1.AnnotatedTextEdit = exports1.ChangeAnnotationIdentifier = exports1.ChangeAnnotation = exports1.TextEdit = exports1.Command = exports1.Diagnostic = exports1.CodeDescription = exports1.DiagnosticTag = exports1.DiagnosticSeverity = exports1.DiagnosticRelatedInformation = exports1.FoldingRange = exports1.FoldingRangeKind = exports1.ColorPresentation = exports1.ColorInformation = exports1.Color = exports1.LocationLink = exports1.Location = exports1.Range = exports1.Position = exports1.uinteger = exports1.integer = exports1.URI = exports1.DocumentUri = void 0;
    var DocumentUri;
    (function(DocumentUri) {
        function is(value) {
            return typeof value === 'string';
        }
        DocumentUri.is = is;
    })(DocumentUri || (exports1.DocumentUri = DocumentUri = {}));
    var URI;
    (function(URI) {
        function is(value) {
            return typeof value === 'string';
        }
        URI.is = is;
    })(URI || (exports1.URI = URI = {}));
    var integer;
    (function(integer) {
        integer.MIN_VALUE = -2147483648;
        integer.MAX_VALUE = 2147483647;
        function is(value) {
            return typeof value === 'number' && integer.MIN_VALUE <= value && value <= integer.MAX_VALUE;
        }
        integer.is = is;
    })(integer || (exports1.integer = integer = {}));
    var uinteger;
    (function(uinteger) {
        uinteger.MIN_VALUE = 0;
        uinteger.MAX_VALUE = 2147483647;
        function is(value) {
            return typeof value === 'number' && uinteger.MIN_VALUE <= value && value <= uinteger.MAX_VALUE;
        }
        uinteger.is = is;
    })(uinteger || (exports1.uinteger = uinteger = {}));
    /**
     * The Position namespace provides helper functions to work with
     * {@link Position} literals.
     */ var Position;
    (function(Position) {
        /**
         * Creates a new Position literal from the given line and character.
         * @param line The position's line.
         * @param character The position's character.
         */ function create(line, character) {
            if (line === Number.MAX_VALUE) line = uinteger.MAX_VALUE;
            if (character === Number.MAX_VALUE) character = uinteger.MAX_VALUE;
            return {
                line: line,
                character: character
            };
        }
        Position.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Position} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.uinteger(candidate.line) && Is.uinteger(candidate.character);
        }
        Position.is = is;
    })(Position || (exports1.Position = Position = {}));
    /**
     * The Range namespace provides helper functions to work with
     * {@link Range} literals.
     */ var Range;
    (function(Range) {
        function create(one, two, three, four) {
            if (Is.uinteger(one) && Is.uinteger(two) && Is.uinteger(three) && Is.uinteger(four)) return {
                start: Position.create(one, two),
                end: Position.create(three, four)
            };
            else if (Position.is(one) && Position.is(two)) return {
                start: one,
                end: two
            };
            else throw new Error("Range#create called with invalid arguments[".concat(one, ", ").concat(two, ", ").concat(three, ", ").concat(four, "]"));
        }
        Range.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Range} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Position.is(candidate.start) && Position.is(candidate.end);
        }
        Range.is = is;
    })(Range || (exports1.Range = Range = {}));
    /**
     * The Location namespace provides helper functions to work with
     * {@link Location} literals.
     */ var Location;
    (function(Location) {
        /**
         * Creates a Location literal.
         * @param uri The location's uri.
         * @param range The location's range.
         */ function create(uri, range) {
            return {
                uri: uri,
                range: range
            };
        }
        Location.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Location} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Range.is(candidate.range) && (Is.string(candidate.uri) || Is.undefined(candidate.uri));
        }
        Location.is = is;
    })(Location || (exports1.Location = Location = {}));
    /**
     * The LocationLink namespace provides helper functions to work with
     * {@link LocationLink} literals.
     */ var LocationLink;
    (function(LocationLink) {
        /**
         * Creates a LocationLink literal.
         * @param targetUri The definition's uri.
         * @param targetRange The full range of the definition.
         * @param targetSelectionRange The span of the symbol definition at the target.
         * @param originSelectionRange The span of the symbol being defined in the originating source file.
         */ function create(targetUri, targetRange, targetSelectionRange, originSelectionRange) {
            return {
                targetUri: targetUri,
                targetRange: targetRange,
                targetSelectionRange: targetSelectionRange,
                originSelectionRange: originSelectionRange
            };
        }
        LocationLink.create = create;
        /**
         * Checks whether the given literal conforms to the {@link LocationLink} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Range.is(candidate.targetRange) && Is.string(candidate.targetUri) && Range.is(candidate.targetSelectionRange) && (Range.is(candidate.originSelectionRange) || Is.undefined(candidate.originSelectionRange));
        }
        LocationLink.is = is;
    })(LocationLink || (exports1.LocationLink = LocationLink = {}));
    /**
     * The Color namespace provides helper functions to work with
     * {@link Color} literals.
     */ var Color;
    (function(Color) {
        /**
         * Creates a new Color literal.
         */ function create(red, green, blue, alpha) {
            return {
                red: red,
                green: green,
                blue: blue,
                alpha: alpha
            };
        }
        Color.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Color} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.numberRange(candidate.red, 0, 1) && Is.numberRange(candidate.green, 0, 1) && Is.numberRange(candidate.blue, 0, 1) && Is.numberRange(candidate.alpha, 0, 1);
        }
        Color.is = is;
    })(Color || (exports1.Color = Color = {}));
    /**
     * The ColorInformation namespace provides helper functions to work with
     * {@link ColorInformation} literals.
     */ var ColorInformation;
    (function(ColorInformation) {
        /**
         * Creates a new ColorInformation literal.
         */ function create(range, color) {
            return {
                range: range,
                color: color
            };
        }
        ColorInformation.create = create;
        /**
         * Checks whether the given literal conforms to the {@link ColorInformation} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Range.is(candidate.range) && Color.is(candidate.color);
        }
        ColorInformation.is = is;
    })(ColorInformation || (exports1.ColorInformation = ColorInformation = {}));
    /**
     * The Color namespace provides helper functions to work with
     * {@link ColorPresentation} literals.
     */ var ColorPresentation;
    (function(ColorPresentation) {
        /**
         * Creates a new ColorInformation literal.
         */ function create(label, textEdit, additionalTextEdits) {
            return {
                label: label,
                textEdit: textEdit,
                additionalTextEdits: additionalTextEdits
            };
        }
        ColorPresentation.create = create;
        /**
         * Checks whether the given literal conforms to the {@link ColorInformation} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.string(candidate.label) && (Is.undefined(candidate.textEdit) || TextEdit.is(candidate)) && (Is.undefined(candidate.additionalTextEdits) || Is.typedArray(candidate.additionalTextEdits, TextEdit.is));
        }
        ColorPresentation.is = is;
    })(ColorPresentation || (exports1.ColorPresentation = ColorPresentation = {}));
    /**
     * A set of predefined range kinds.
     */ var FoldingRangeKind;
    (function(FoldingRangeKind) {
        /**
         * Folding range for a comment
         */ FoldingRangeKind.Comment = 'comment';
        /**
         * Folding range for an import or include
         */ FoldingRangeKind.Imports = 'imports';
        /**
         * Folding range for a region (e.g. `#region`)
         */ FoldingRangeKind.Region = 'region';
    })(FoldingRangeKind || (exports1.FoldingRangeKind = FoldingRangeKind = {}));
    /**
     * The folding range namespace provides helper functions to work with
     * {@link FoldingRange} literals.
     */ var FoldingRange;
    (function(FoldingRange) {
        /**
         * Creates a new FoldingRange literal.
         */ function create(startLine, endLine, startCharacter, endCharacter, kind, collapsedText) {
            var result = {
                startLine: startLine,
                endLine: endLine
            };
            if (Is.defined(startCharacter)) result.startCharacter = startCharacter;
            if (Is.defined(endCharacter)) result.endCharacter = endCharacter;
            if (Is.defined(kind)) result.kind = kind;
            if (Is.defined(collapsedText)) result.collapsedText = collapsedText;
            return result;
        }
        FoldingRange.create = create;
        /**
         * Checks whether the given literal conforms to the {@link FoldingRange} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.uinteger(candidate.startLine) && Is.uinteger(candidate.startLine) && (Is.undefined(candidate.startCharacter) || Is.uinteger(candidate.startCharacter)) && (Is.undefined(candidate.endCharacter) || Is.uinteger(candidate.endCharacter)) && (Is.undefined(candidate.kind) || Is.string(candidate.kind));
        }
        FoldingRange.is = is;
    })(FoldingRange || (exports1.FoldingRange = FoldingRange = {}));
    /**
     * The DiagnosticRelatedInformation namespace provides helper functions to work with
     * {@link DiagnosticRelatedInformation} literals.
     */ var DiagnosticRelatedInformation;
    (function(DiagnosticRelatedInformation) {
        /**
         * Creates a new DiagnosticRelatedInformation literal.
         */ function create(location, message) {
            return {
                location: location,
                message: message
            };
        }
        DiagnosticRelatedInformation.create = create;
        /**
         * Checks whether the given literal conforms to the {@link DiagnosticRelatedInformation} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Location.is(candidate.location) && Is.string(candidate.message);
        }
        DiagnosticRelatedInformation.is = is;
    })(DiagnosticRelatedInformation || (exports1.DiagnosticRelatedInformation = DiagnosticRelatedInformation = {}));
    /**
     * The diagnostic's severity.
     */ var DiagnosticSeverity;
    (function(DiagnosticSeverity) {
        /**
         * Reports an error.
         */ DiagnosticSeverity.Error = 1;
        /**
         * Reports a warning.
         */ DiagnosticSeverity.Warning = 2;
        /**
         * Reports an information.
         */ DiagnosticSeverity.Information = 3;
        /**
         * Reports a hint.
         */ DiagnosticSeverity.Hint = 4;
    })(DiagnosticSeverity || (exports1.DiagnosticSeverity = DiagnosticSeverity = {}));
    /**
     * The diagnostic tags.
     *
     * @since 3.15.0
     */ var DiagnosticTag;
    (function(DiagnosticTag) {
        /**
         * Unused or unnecessary code.
         *
         * Clients are allowed to render diagnostics with this tag faded out instead of having
         * an error squiggle.
         */ DiagnosticTag.Unnecessary = 1;
        /**
         * Deprecated or obsolete code.
         *
         * Clients are allowed to rendered diagnostics with this tag strike through.
         */ DiagnosticTag.Deprecated = 2;
    })(DiagnosticTag || (exports1.DiagnosticTag = DiagnosticTag = {}));
    /**
     * The CodeDescription namespace provides functions to deal with descriptions for diagnostic codes.
     *
     * @since 3.16.0
     */ var CodeDescription;
    (function(CodeDescription) {
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.string(candidate.href);
        }
        CodeDescription.is = is;
    })(CodeDescription || (exports1.CodeDescription = CodeDescription = {}));
    /**
     * The Diagnostic namespace provides helper functions to work with
     * {@link Diagnostic} literals.
     */ var Diagnostic;
    (function(Diagnostic) {
        /**
         * Creates a new Diagnostic literal.
         */ function create(range, message, severity, code, source, relatedInformation) {
            var result = {
                range: range,
                message: message
            };
            if (Is.defined(severity)) result.severity = severity;
            if (Is.defined(code)) result.code = code;
            if (Is.defined(source)) result.source = source;
            if (Is.defined(relatedInformation)) result.relatedInformation = relatedInformation;
            return result;
        }
        Diagnostic.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Diagnostic} interface.
         */ function is(value) {
            var _a;
            var candidate = value;
            return Is.defined(candidate) && Range.is(candidate.range) && Is.string(candidate.message) && (Is.number(candidate.severity) || Is.undefined(candidate.severity)) && (Is.integer(candidate.code) || Is.string(candidate.code) || Is.undefined(candidate.code)) && (Is.undefined(candidate.codeDescription) || Is.string((_a = candidate.codeDescription) === null || _a === void 0 ? void 0 : _a.href)) && (Is.string(candidate.source) || Is.undefined(candidate.source)) && (Is.undefined(candidate.relatedInformation) || Is.typedArray(candidate.relatedInformation, DiagnosticRelatedInformation.is));
        }
        Diagnostic.is = is;
    })(Diagnostic || (exports1.Diagnostic = Diagnostic = {}));
    /**
     * The Command namespace provides helper functions to work with
     * {@link Command} literals.
     */ var Command;
    (function(Command) {
        /**
         * Creates a new Command literal.
         */ function create(title, command) {
            var args = [];
            for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
            var result = {
                title: title,
                command: command
            };
            if (Is.defined(args) && args.length > 0) result.arguments = args;
            return result;
        }
        Command.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Command} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.title) && Is.string(candidate.command);
        }
        Command.is = is;
    })(Command || (exports1.Command = Command = {}));
    /**
     * The TextEdit namespace provides helper function to create replace,
     * insert and delete edits more easily.
     */ var TextEdit;
    (function(TextEdit) {
        /**
         * Creates a replace text edit.
         * @param range The range of text to be replaced.
         * @param newText The new text.
         */ function replace(range, newText) {
            return {
                range: range,
                newText: newText
            };
        }
        TextEdit.replace = replace;
        /**
         * Creates an insert text edit.
         * @param position The position to insert the text at.
         * @param newText The text to be inserted.
         */ function insert(position, newText) {
            return {
                range: {
                    start: position,
                    end: position
                },
                newText: newText
            };
        }
        TextEdit.insert = insert;
        /**
         * Creates a delete text edit.
         * @param range The range of text to be deleted.
         */ function del(range) {
            return {
                range: range,
                newText: ''
            };
        }
        TextEdit.del = del;
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.string(candidate.newText) && Range.is(candidate.range);
        }
        TextEdit.is = is;
    })(TextEdit || (exports1.TextEdit = TextEdit = {}));
    var ChangeAnnotation;
    (function(ChangeAnnotation) {
        function create(label, needsConfirmation, description) {
            var result = {
                label: label
            };
            if (needsConfirmation !== undefined) result.needsConfirmation = needsConfirmation;
            if (description !== undefined) result.description = description;
            return result;
        }
        ChangeAnnotation.create = create;
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.string(candidate.label) && (Is.boolean(candidate.needsConfirmation) || candidate.needsConfirmation === undefined) && (Is.string(candidate.description) || candidate.description === undefined);
        }
        ChangeAnnotation.is = is;
    })(ChangeAnnotation || (exports1.ChangeAnnotation = ChangeAnnotation = {}));
    var ChangeAnnotationIdentifier;
    (function(ChangeAnnotationIdentifier) {
        function is(value) {
            var candidate = value;
            return Is.string(candidate);
        }
        ChangeAnnotationIdentifier.is = is;
    })(ChangeAnnotationIdentifier || (exports1.ChangeAnnotationIdentifier = ChangeAnnotationIdentifier = {}));
    var AnnotatedTextEdit;
    (function(AnnotatedTextEdit) {
        /**
         * Creates an annotated replace text edit.
         *
         * @param range The range of text to be replaced.
         * @param newText The new text.
         * @param annotation The annotation.
         */ function replace(range, newText, annotation) {
            return {
                range: range,
                newText: newText,
                annotationId: annotation
            };
        }
        AnnotatedTextEdit.replace = replace;
        /**
         * Creates an annotated insert text edit.
         *
         * @param position The position to insert the text at.
         * @param newText The text to be inserted.
         * @param annotation The annotation.
         */ function insert(position, newText, annotation) {
            return {
                range: {
                    start: position,
                    end: position
                },
                newText: newText,
                annotationId: annotation
            };
        }
        AnnotatedTextEdit.insert = insert;
        /**
         * Creates an annotated delete text edit.
         *
         * @param range The range of text to be deleted.
         * @param annotation The annotation.
         */ function del(range, annotation) {
            return {
                range: range,
                newText: '',
                annotationId: annotation
            };
        }
        AnnotatedTextEdit.del = del;
        function is(value) {
            var candidate = value;
            return TextEdit.is(candidate) && (ChangeAnnotation.is(candidate.annotationId) || ChangeAnnotationIdentifier.is(candidate.annotationId));
        }
        AnnotatedTextEdit.is = is;
    })(AnnotatedTextEdit || (exports1.AnnotatedTextEdit = AnnotatedTextEdit = {}));
    /**
     * The TextDocumentEdit namespace provides helper function to create
     * an edit that manipulates a text document.
     */ var TextDocumentEdit;
    (function(TextDocumentEdit) {
        /**
         * Creates a new `TextDocumentEdit`
         */ function create(textDocument, edits) {
            return {
                textDocument: textDocument,
                edits: edits
            };
        }
        TextDocumentEdit.create = create;
        function is(value) {
            var candidate = value;
            return Is.defined(candidate) && OptionalVersionedTextDocumentIdentifier.is(candidate.textDocument) && Array.isArray(candidate.edits);
        }
        TextDocumentEdit.is = is;
    })(TextDocumentEdit || (exports1.TextDocumentEdit = TextDocumentEdit = {}));
    var CreateFile;
    (function(CreateFile) {
        function create(uri, options, annotation) {
            var result = {
                kind: 'create',
                uri: uri
            };
            if (options !== undefined && (options.overwrite !== undefined || options.ignoreIfExists !== undefined)) result.options = options;
            if (annotation !== undefined) result.annotationId = annotation;
            return result;
        }
        CreateFile.create = create;
        function is(value) {
            var candidate = value;
            return candidate && candidate.kind === 'create' && Is.string(candidate.uri) && (candidate.options === undefined || (candidate.options.overwrite === undefined || Is.boolean(candidate.options.overwrite)) && (candidate.options.ignoreIfExists === undefined || Is.boolean(candidate.options.ignoreIfExists))) && (candidate.annotationId === undefined || ChangeAnnotationIdentifier.is(candidate.annotationId));
        }
        CreateFile.is = is;
    })(CreateFile || (exports1.CreateFile = CreateFile = {}));
    var RenameFile;
    (function(RenameFile) {
        function create(oldUri, newUri, options, annotation) {
            var result = {
                kind: 'rename',
                oldUri: oldUri,
                newUri: newUri
            };
            if (options !== undefined && (options.overwrite !== undefined || options.ignoreIfExists !== undefined)) result.options = options;
            if (annotation !== undefined) result.annotationId = annotation;
            return result;
        }
        RenameFile.create = create;
        function is(value) {
            var candidate = value;
            return candidate && candidate.kind === 'rename' && Is.string(candidate.oldUri) && Is.string(candidate.newUri) && (candidate.options === undefined || (candidate.options.overwrite === undefined || Is.boolean(candidate.options.overwrite)) && (candidate.options.ignoreIfExists === undefined || Is.boolean(candidate.options.ignoreIfExists))) && (candidate.annotationId === undefined || ChangeAnnotationIdentifier.is(candidate.annotationId));
        }
        RenameFile.is = is;
    })(RenameFile || (exports1.RenameFile = RenameFile = {}));
    var DeleteFile;
    (function(DeleteFile) {
        function create(uri, options, annotation) {
            var result = {
                kind: 'delete',
                uri: uri
            };
            if (options !== undefined && (options.recursive !== undefined || options.ignoreIfNotExists !== undefined)) result.options = options;
            if (annotation !== undefined) result.annotationId = annotation;
            return result;
        }
        DeleteFile.create = create;
        function is(value) {
            var candidate = value;
            return candidate && candidate.kind === 'delete' && Is.string(candidate.uri) && (candidate.options === undefined || (candidate.options.recursive === undefined || Is.boolean(candidate.options.recursive)) && (candidate.options.ignoreIfNotExists === undefined || Is.boolean(candidate.options.ignoreIfNotExists))) && (candidate.annotationId === undefined || ChangeAnnotationIdentifier.is(candidate.annotationId));
        }
        DeleteFile.is = is;
    })(DeleteFile || (exports1.DeleteFile = DeleteFile = {}));
    var WorkspaceEdit;
    (function(WorkspaceEdit) {
        function is(value) {
            var candidate = value;
            return candidate && (candidate.changes !== undefined || candidate.documentChanges !== undefined) && (candidate.documentChanges === undefined || candidate.documentChanges.every(function(change) {
                if (Is.string(change.kind)) return CreateFile.is(change) || RenameFile.is(change) || DeleteFile.is(change);
                else return TextDocumentEdit.is(change);
            }));
        }
        WorkspaceEdit.is = is;
    })(WorkspaceEdit || (exports1.WorkspaceEdit = WorkspaceEdit = {}));
    var TextEditChangeImpl = /** @class */ function() {
        function TextEditChangeImpl(edits, changeAnnotations) {
            this.edits = edits;
            this.changeAnnotations = changeAnnotations;
        }
        TextEditChangeImpl.prototype.insert = function(position, newText, annotation) {
            var edit;
            var id;
            if (annotation === undefined) edit = TextEdit.insert(position, newText);
            else if (ChangeAnnotationIdentifier.is(annotation)) {
                id = annotation;
                edit = AnnotatedTextEdit.insert(position, newText, annotation);
            } else {
                this.assertChangeAnnotations(this.changeAnnotations);
                id = this.changeAnnotations.manage(annotation);
                edit = AnnotatedTextEdit.insert(position, newText, id);
            }
            this.edits.push(edit);
            if (id !== undefined) return id;
        };
        TextEditChangeImpl.prototype.replace = function(range, newText, annotation) {
            var edit;
            var id;
            if (annotation === undefined) edit = TextEdit.replace(range, newText);
            else if (ChangeAnnotationIdentifier.is(annotation)) {
                id = annotation;
                edit = AnnotatedTextEdit.replace(range, newText, annotation);
            } else {
                this.assertChangeAnnotations(this.changeAnnotations);
                id = this.changeAnnotations.manage(annotation);
                edit = AnnotatedTextEdit.replace(range, newText, id);
            }
            this.edits.push(edit);
            if (id !== undefined) return id;
        };
        TextEditChangeImpl.prototype.delete = function(range, annotation) {
            var edit;
            var id;
            if (annotation === undefined) edit = TextEdit.del(range);
            else if (ChangeAnnotationIdentifier.is(annotation)) {
                id = annotation;
                edit = AnnotatedTextEdit.del(range, annotation);
            } else {
                this.assertChangeAnnotations(this.changeAnnotations);
                id = this.changeAnnotations.manage(annotation);
                edit = AnnotatedTextEdit.del(range, id);
            }
            this.edits.push(edit);
            if (id !== undefined) return id;
        };
        TextEditChangeImpl.prototype.add = function(edit) {
            this.edits.push(edit);
        };
        TextEditChangeImpl.prototype.all = function() {
            return this.edits;
        };
        TextEditChangeImpl.prototype.clear = function() {
            this.edits.splice(0, this.edits.length);
        };
        TextEditChangeImpl.prototype.assertChangeAnnotations = function(value) {
            if (value === undefined) throw new Error("Text edit change is not configured to manage change annotations.");
        };
        return TextEditChangeImpl;
    }();
    /**
     * A helper class
     */ var ChangeAnnotations = /** @class */ function() {
        function ChangeAnnotations(annotations) {
            this._annotations = annotations === undefined ? Object.create(null) : annotations;
            this._counter = 0;
            this._size = 0;
        }
        ChangeAnnotations.prototype.all = function() {
            return this._annotations;
        };
        Object.defineProperty(ChangeAnnotations.prototype, "size", {
            get: function() {
                return this._size;
            },
            enumerable: false,
            configurable: true
        });
        ChangeAnnotations.prototype.manage = function(idOrAnnotation, annotation) {
            var id;
            if (ChangeAnnotationIdentifier.is(idOrAnnotation)) id = idOrAnnotation;
            else {
                id = this.nextId();
                annotation = idOrAnnotation;
            }
            if (this._annotations[id] !== undefined) throw new Error("Id ".concat(id, " is already in use."));
            if (annotation === undefined) throw new Error("No annotation provided for id ".concat(id));
            this._annotations[id] = annotation;
            this._size++;
            return id;
        };
        ChangeAnnotations.prototype.nextId = function() {
            this._counter++;
            return this._counter.toString();
        };
        return ChangeAnnotations;
    }();
    /**
     * A workspace change helps constructing changes to a workspace.
     */ var WorkspaceChange = /** @class */ function() {
        function WorkspaceChange(workspaceEdit) {
            var _this = this;
            this._textEditChanges = Object.create(null);
            if (workspaceEdit !== undefined) {
                this._workspaceEdit = workspaceEdit;
                if (workspaceEdit.documentChanges) {
                    this._changeAnnotations = new ChangeAnnotations(workspaceEdit.changeAnnotations);
                    workspaceEdit.changeAnnotations = this._changeAnnotations.all();
                    workspaceEdit.documentChanges.forEach(function(change) {
                        if (TextDocumentEdit.is(change)) {
                            var textEditChange = new TextEditChangeImpl(change.edits, _this._changeAnnotations);
                            _this._textEditChanges[change.textDocument.uri] = textEditChange;
                        }
                    });
                } else if (workspaceEdit.changes) Object.keys(workspaceEdit.changes).forEach(function(key) {
                    var textEditChange = new TextEditChangeImpl(workspaceEdit.changes[key]);
                    _this._textEditChanges[key] = textEditChange;
                });
            } else this._workspaceEdit = {};
        }
        Object.defineProperty(WorkspaceChange.prototype, "edit", {
            /**
             * Returns the underlying {@link WorkspaceEdit} literal
             * use to be returned from a workspace edit operation like rename.
             */ get: function() {
                this.initDocumentChanges();
                if (this._changeAnnotations !== undefined) {
                    if (this._changeAnnotations.size === 0) this._workspaceEdit.changeAnnotations = undefined;
                    else this._workspaceEdit.changeAnnotations = this._changeAnnotations.all();
                }
                return this._workspaceEdit;
            },
            enumerable: false,
            configurable: true
        });
        WorkspaceChange.prototype.getTextEditChange = function(key) {
            if (OptionalVersionedTextDocumentIdentifier.is(key)) {
                this.initDocumentChanges();
                if (this._workspaceEdit.documentChanges === undefined) throw new Error('Workspace edit is not configured for document changes.');
                var textDocument = {
                    uri: key.uri,
                    version: key.version
                };
                var result = this._textEditChanges[textDocument.uri];
                if (!result) {
                    var edits = [];
                    var textDocumentEdit = {
                        textDocument: textDocument,
                        edits: edits
                    };
                    this._workspaceEdit.documentChanges.push(textDocumentEdit);
                    result = new TextEditChangeImpl(edits, this._changeAnnotations);
                    this._textEditChanges[textDocument.uri] = result;
                }
                return result;
            } else {
                this.initChanges();
                if (this._workspaceEdit.changes === undefined) throw new Error('Workspace edit is not configured for normal text edit changes.');
                var result = this._textEditChanges[key];
                if (!result) {
                    var edits = [];
                    this._workspaceEdit.changes[key] = edits;
                    result = new TextEditChangeImpl(edits);
                    this._textEditChanges[key] = result;
                }
                return result;
            }
        };
        WorkspaceChange.prototype.initDocumentChanges = function() {
            if (this._workspaceEdit.documentChanges === undefined && this._workspaceEdit.changes === undefined) {
                this._changeAnnotations = new ChangeAnnotations();
                this._workspaceEdit.documentChanges = [];
                this._workspaceEdit.changeAnnotations = this._changeAnnotations.all();
            }
        };
        WorkspaceChange.prototype.initChanges = function() {
            if (this._workspaceEdit.documentChanges === undefined && this._workspaceEdit.changes === undefined) this._workspaceEdit.changes = Object.create(null);
        };
        WorkspaceChange.prototype.createFile = function(uri, optionsOrAnnotation, options) {
            this.initDocumentChanges();
            if (this._workspaceEdit.documentChanges === undefined) throw new Error('Workspace edit is not configured for document changes.');
            var annotation;
            if (ChangeAnnotation.is(optionsOrAnnotation) || ChangeAnnotationIdentifier.is(optionsOrAnnotation)) annotation = optionsOrAnnotation;
            else options = optionsOrAnnotation;
            var operation;
            var id;
            if (annotation === undefined) operation = CreateFile.create(uri, options);
            else {
                id = ChangeAnnotationIdentifier.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
                operation = CreateFile.create(uri, options, id);
            }
            this._workspaceEdit.documentChanges.push(operation);
            if (id !== undefined) return id;
        };
        WorkspaceChange.prototype.renameFile = function(oldUri, newUri, optionsOrAnnotation, options) {
            this.initDocumentChanges();
            if (this._workspaceEdit.documentChanges === undefined) throw new Error('Workspace edit is not configured for document changes.');
            var annotation;
            if (ChangeAnnotation.is(optionsOrAnnotation) || ChangeAnnotationIdentifier.is(optionsOrAnnotation)) annotation = optionsOrAnnotation;
            else options = optionsOrAnnotation;
            var operation;
            var id;
            if (annotation === undefined) operation = RenameFile.create(oldUri, newUri, options);
            else {
                id = ChangeAnnotationIdentifier.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
                operation = RenameFile.create(oldUri, newUri, options, id);
            }
            this._workspaceEdit.documentChanges.push(operation);
            if (id !== undefined) return id;
        };
        WorkspaceChange.prototype.deleteFile = function(uri, optionsOrAnnotation, options) {
            this.initDocumentChanges();
            if (this._workspaceEdit.documentChanges === undefined) throw new Error('Workspace edit is not configured for document changes.');
            var annotation;
            if (ChangeAnnotation.is(optionsOrAnnotation) || ChangeAnnotationIdentifier.is(optionsOrAnnotation)) annotation = optionsOrAnnotation;
            else options = optionsOrAnnotation;
            var operation;
            var id;
            if (annotation === undefined) operation = DeleteFile.create(uri, options);
            else {
                id = ChangeAnnotationIdentifier.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
                operation = DeleteFile.create(uri, options, id);
            }
            this._workspaceEdit.documentChanges.push(operation);
            if (id !== undefined) return id;
        };
        return WorkspaceChange;
    }();
    exports1.WorkspaceChange = WorkspaceChange;
    /**
     * The TextDocumentIdentifier namespace provides helper functions to work with
     * {@link TextDocumentIdentifier} literals.
     */ var TextDocumentIdentifier;
    (function(TextDocumentIdentifier) {
        /**
         * Creates a new TextDocumentIdentifier literal.
         * @param uri The document's uri.
         */ function create(uri) {
            return {
                uri: uri
            };
        }
        TextDocumentIdentifier.create = create;
        /**
         * Checks whether the given literal conforms to the {@link TextDocumentIdentifier} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.uri);
        }
        TextDocumentIdentifier.is = is;
    })(TextDocumentIdentifier || (exports1.TextDocumentIdentifier = TextDocumentIdentifier = {}));
    /**
     * The VersionedTextDocumentIdentifier namespace provides helper functions to work with
     * {@link VersionedTextDocumentIdentifier} literals.
     */ var VersionedTextDocumentIdentifier;
    (function(VersionedTextDocumentIdentifier) {
        /**
         * Creates a new VersionedTextDocumentIdentifier literal.
         * @param uri The document's uri.
         * @param version The document's version.
         */ function create(uri, version) {
            return {
                uri: uri,
                version: version
            };
        }
        VersionedTextDocumentIdentifier.create = create;
        /**
         * Checks whether the given literal conforms to the {@link VersionedTextDocumentIdentifier} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.uri) && Is.integer(candidate.version);
        }
        VersionedTextDocumentIdentifier.is = is;
    })(VersionedTextDocumentIdentifier || (exports1.VersionedTextDocumentIdentifier = VersionedTextDocumentIdentifier = {}));
    /**
     * The OptionalVersionedTextDocumentIdentifier namespace provides helper functions to work with
     * {@link OptionalVersionedTextDocumentIdentifier} literals.
     */ var OptionalVersionedTextDocumentIdentifier;
    (function(OptionalVersionedTextDocumentIdentifier) {
        /**
         * Creates a new OptionalVersionedTextDocumentIdentifier literal.
         * @param uri The document's uri.
         * @param version The document's version.
         */ function create(uri, version) {
            return {
                uri: uri,
                version: version
            };
        }
        OptionalVersionedTextDocumentIdentifier.create = create;
        /**
         * Checks whether the given literal conforms to the {@link OptionalVersionedTextDocumentIdentifier} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.uri) && (candidate.version === null || Is.integer(candidate.version));
        }
        OptionalVersionedTextDocumentIdentifier.is = is;
    })(OptionalVersionedTextDocumentIdentifier || (exports1.OptionalVersionedTextDocumentIdentifier = OptionalVersionedTextDocumentIdentifier = {}));
    /**
     * The TextDocumentItem namespace provides helper functions to work with
     * {@link TextDocumentItem} literals.
     */ var TextDocumentItem;
    (function(TextDocumentItem) {
        /**
         * Creates a new TextDocumentItem literal.
         * @param uri The document's uri.
         * @param languageId The document's language identifier.
         * @param version The document's version number.
         * @param text The document's text.
         */ function create(uri, languageId, version, text) {
            return {
                uri: uri,
                languageId: languageId,
                version: version,
                text: text
            };
        }
        TextDocumentItem.create = create;
        /**
         * Checks whether the given literal conforms to the {@link TextDocumentItem} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.uri) && Is.string(candidate.languageId) && Is.integer(candidate.version) && Is.string(candidate.text);
        }
        TextDocumentItem.is = is;
    })(TextDocumentItem || (exports1.TextDocumentItem = TextDocumentItem = {}));
    /**
     * Describes the content type that a client supports in various
     * result literals like `Hover`, `ParameterInfo` or `CompletionItem`.
     *
     * Please note that `MarkupKinds` must not start with a `$`. This kinds
     * are reserved for internal usage.
     */ var MarkupKind;
    (function(MarkupKind) {
        /**
         * Plain text is supported as a content format
         */ MarkupKind.PlainText = 'plaintext';
        /**
         * Markdown is supported as a content format
         */ MarkupKind.Markdown = 'markdown';
        /**
         * Checks whether the given value is a value of the {@link MarkupKind} type.
         */ function is(value) {
            var candidate = value;
            return candidate === MarkupKind.PlainText || candidate === MarkupKind.Markdown;
        }
        MarkupKind.is = is;
    })(MarkupKind || (exports1.MarkupKind = MarkupKind = {}));
    var MarkupContent;
    (function(MarkupContent) {
        /**
         * Checks whether the given value conforms to the {@link MarkupContent} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(value) && MarkupKind.is(candidate.kind) && Is.string(candidate.value);
        }
        MarkupContent.is = is;
    })(MarkupContent || (exports1.MarkupContent = MarkupContent = {}));
    /**
     * The kind of a completion entry.
     */ var CompletionItemKind;
    (function(CompletionItemKind) {
        CompletionItemKind.Text = 1;
        CompletionItemKind.Method = 2;
        CompletionItemKind.Function = 3;
        CompletionItemKind.Constructor = 4;
        CompletionItemKind.Field = 5;
        CompletionItemKind.Variable = 6;
        CompletionItemKind.Class = 7;
        CompletionItemKind.Interface = 8;
        CompletionItemKind.Module = 9;
        CompletionItemKind.Property = 10;
        CompletionItemKind.Unit = 11;
        CompletionItemKind.Value = 12;
        CompletionItemKind.Enum = 13;
        CompletionItemKind.Keyword = 14;
        CompletionItemKind.Snippet = 15;
        CompletionItemKind.Color = 16;
        CompletionItemKind.File = 17;
        CompletionItemKind.Reference = 18;
        CompletionItemKind.Folder = 19;
        CompletionItemKind.EnumMember = 20;
        CompletionItemKind.Constant = 21;
        CompletionItemKind.Struct = 22;
        CompletionItemKind.Event = 23;
        CompletionItemKind.Operator = 24;
        CompletionItemKind.TypeParameter = 25;
    })(CompletionItemKind || (exports1.CompletionItemKind = CompletionItemKind = {}));
    /**
     * Defines whether the insert text in a completion item should be interpreted as
     * plain text or a snippet.
     */ var InsertTextFormat;
    (function(InsertTextFormat) {
        /**
         * The primary text to be inserted is treated as a plain string.
         */ InsertTextFormat.PlainText = 1;
        /**
         * The primary text to be inserted is treated as a snippet.
         *
         * A snippet can define tab stops and placeholders with `$1`, `$2`
         * and `${3:foo}`. `$0` defines the final tab stop, it defaults to
         * the end of the snippet. Placeholders with equal identifiers are linked,
         * that is typing in one will update others too.
         *
         * See also: https://microsoft.github.io/language-server-protocol/specifications/specification-current/#snippet_syntax
         */ InsertTextFormat.Snippet = 2;
    })(InsertTextFormat || (exports1.InsertTextFormat = InsertTextFormat = {}));
    /**
     * Completion item tags are extra annotations that tweak the rendering of a completion
     * item.
     *
     * @since 3.15.0
     */ var CompletionItemTag;
    (function(CompletionItemTag) {
        /**
         * Render a completion as obsolete, usually using a strike-out.
         */ CompletionItemTag.Deprecated = 1;
    })(CompletionItemTag || (exports1.CompletionItemTag = CompletionItemTag = {}));
    /**
     * The InsertReplaceEdit namespace provides functions to deal with insert / replace edits.
     *
     * @since 3.16.0
     */ var InsertReplaceEdit;
    (function(InsertReplaceEdit) {
        /**
         * Creates a new insert / replace edit
         */ function create(newText, insert, replace) {
            return {
                newText: newText,
                insert: insert,
                replace: replace
            };
        }
        InsertReplaceEdit.create = create;
        /**
         * Checks whether the given literal conforms to the {@link InsertReplaceEdit} interface.
         */ function is(value) {
            var candidate = value;
            return candidate && Is.string(candidate.newText) && Range.is(candidate.insert) && Range.is(candidate.replace);
        }
        InsertReplaceEdit.is = is;
    })(InsertReplaceEdit || (exports1.InsertReplaceEdit = InsertReplaceEdit = {}));
    /**
     * How whitespace and indentation is handled during completion
     * item insertion.
     *
     * @since 3.16.0
     */ var InsertTextMode;
    (function(InsertTextMode) {
        /**
         * The insertion or replace strings is taken as it is. If the
         * value is multi line the lines below the cursor will be
         * inserted using the indentation defined in the string value.
         * The client will not apply any kind of adjustments to the
         * string.
         */ InsertTextMode.asIs = 1;
        /**
         * The editor adjusts leading whitespace of new lines so that
         * they match the indentation up to the cursor of the line for
         * which the item is accepted.
         *
         * Consider a line like this: <2tabs><cursor><3tabs>foo. Accepting a
         * multi line completion item is indented using 2 tabs and all
         * following lines inserted will be indented using 2 tabs as well.
         */ InsertTextMode.adjustIndentation = 2;
    })(InsertTextMode || (exports1.InsertTextMode = InsertTextMode = {}));
    var CompletionItemLabelDetails;
    (function(CompletionItemLabelDetails) {
        function is(value) {
            var candidate = value;
            return candidate && (Is.string(candidate.detail) || candidate.detail === undefined) && (Is.string(candidate.description) || candidate.description === undefined);
        }
        CompletionItemLabelDetails.is = is;
    })(CompletionItemLabelDetails || (exports1.CompletionItemLabelDetails = CompletionItemLabelDetails = {}));
    /**
     * The CompletionItem namespace provides functions to deal with
     * completion items.
     */ var CompletionItem;
    (function(CompletionItem) {
        /**
         * Create a completion item and seed it with a label.
         * @param label The completion item's label
         */ function create(label) {
            return {
                label: label
            };
        }
        CompletionItem.create = create;
    })(CompletionItem || (exports1.CompletionItem = CompletionItem = {}));
    /**
     * The CompletionList namespace provides functions to deal with
     * completion lists.
     */ var CompletionList;
    (function(CompletionList) {
        /**
         * Creates a new completion list.
         *
         * @param items The completion items.
         * @param isIncomplete The list is not complete.
         */ function create(items, isIncomplete) {
            return {
                items: items ? items : [],
                isIncomplete: !!isIncomplete
            };
        }
        CompletionList.create = create;
    })(CompletionList || (exports1.CompletionList = CompletionList = {}));
    var MarkedString;
    (function(MarkedString) {
        /**
         * Creates a marked string from plain text.
         *
         * @param plainText The plain text.
         */ function fromPlainText(plainText) {
            return plainText.replace(/[\\`*_{}[\]()#+\-.!]/g, '\\$&'); // escape markdown syntax tokens: http://daringfireball.net/projects/markdown/syntax#backslash
        }
        MarkedString.fromPlainText = fromPlainText;
        /**
         * Checks whether the given value conforms to the {@link MarkedString} type.
         */ function is(value) {
            var candidate = value;
            return Is.string(candidate) || Is.objectLiteral(candidate) && Is.string(candidate.language) && Is.string(candidate.value);
        }
        MarkedString.is = is;
    })(MarkedString || (exports1.MarkedString = MarkedString = {}));
    var Hover;
    (function(Hover) {
        /**
         * Checks whether the given value conforms to the {@link Hover} interface.
         */ function is(value) {
            var candidate = value;
            return !!candidate && Is.objectLiteral(candidate) && (MarkupContent.is(candidate.contents) || MarkedString.is(candidate.contents) || Is.typedArray(candidate.contents, MarkedString.is)) && (value.range === undefined || Range.is(value.range));
        }
        Hover.is = is;
    })(Hover || (exports1.Hover = Hover = {}));
    /**
     * The ParameterInformation namespace provides helper functions to work with
     * {@link ParameterInformation} literals.
     */ var ParameterInformation;
    (function(ParameterInformation) {
        /**
         * Creates a new parameter information literal.
         *
         * @param label A label string.
         * @param documentation A doc string.
         */ function create(label, documentation) {
            return documentation ? {
                label: label,
                documentation: documentation
            } : {
                label: label
            };
        }
        ParameterInformation.create = create;
    })(ParameterInformation || (exports1.ParameterInformation = ParameterInformation = {}));
    /**
     * The SignatureInformation namespace provides helper functions to work with
     * {@link SignatureInformation} literals.
     */ var SignatureInformation;
    (function(SignatureInformation) {
        function create(label, documentation) {
            var parameters = [];
            for(var _i = 2; _i < arguments.length; _i++)parameters[_i - 2] = arguments[_i];
            var result = {
                label: label
            };
            if (Is.defined(documentation)) result.documentation = documentation;
            if (Is.defined(parameters)) result.parameters = parameters;
            else result.parameters = [];
            return result;
        }
        SignatureInformation.create = create;
    })(SignatureInformation || (exports1.SignatureInformation = SignatureInformation = {}));
    /**
     * A document highlight kind.
     */ var DocumentHighlightKind;
    (function(DocumentHighlightKind) {
        /**
         * A textual occurrence.
         */ DocumentHighlightKind.Text = 1;
        /**
         * Read-access of a symbol, like reading a variable.
         */ DocumentHighlightKind.Read = 2;
        /**
         * Write-access of a symbol, like writing to a variable.
         */ DocumentHighlightKind.Write = 3;
    })(DocumentHighlightKind || (exports1.DocumentHighlightKind = DocumentHighlightKind = {}));
    /**
     * DocumentHighlight namespace to provide helper functions to work with
     * {@link DocumentHighlight} literals.
     */ var DocumentHighlight;
    (function(DocumentHighlight) {
        /**
         * Create a DocumentHighlight object.
         * @param range The range the highlight applies to.
         * @param kind The highlight kind
         */ function create(range, kind) {
            var result = {
                range: range
            };
            if (Is.number(kind)) result.kind = kind;
            return result;
        }
        DocumentHighlight.create = create;
    })(DocumentHighlight || (exports1.DocumentHighlight = DocumentHighlight = {}));
    /**
     * A symbol kind.
     */ var SymbolKind;
    (function(SymbolKind) {
        SymbolKind.File = 1;
        SymbolKind.Module = 2;
        SymbolKind.Namespace = 3;
        SymbolKind.Package = 4;
        SymbolKind.Class = 5;
        SymbolKind.Method = 6;
        SymbolKind.Property = 7;
        SymbolKind.Field = 8;
        SymbolKind.Constructor = 9;
        SymbolKind.Enum = 10;
        SymbolKind.Interface = 11;
        SymbolKind.Function = 12;
        SymbolKind.Variable = 13;
        SymbolKind.Constant = 14;
        SymbolKind.String = 15;
        SymbolKind.Number = 16;
        SymbolKind.Boolean = 17;
        SymbolKind.Array = 18;
        SymbolKind.Object = 19;
        SymbolKind.Key = 20;
        SymbolKind.Null = 21;
        SymbolKind.EnumMember = 22;
        SymbolKind.Struct = 23;
        SymbolKind.Event = 24;
        SymbolKind.Operator = 25;
        SymbolKind.TypeParameter = 26;
    })(SymbolKind || (exports1.SymbolKind = SymbolKind = {}));
    /**
     * Symbol tags are extra annotations that tweak the rendering of a symbol.
     *
     * @since 3.16
     */ var SymbolTag;
    (function(SymbolTag) {
        /**
         * Render a symbol as obsolete, usually using a strike-out.
         */ SymbolTag.Deprecated = 1;
    })(SymbolTag || (exports1.SymbolTag = SymbolTag = {}));
    var SymbolInformation;
    (function(SymbolInformation) {
        /**
         * Creates a new symbol information literal.
         *
         * @param name The name of the symbol.
         * @param kind The kind of the symbol.
         * @param range The range of the location of the symbol.
         * @param uri The resource of the location of symbol.
         * @param containerName The name of the symbol containing the symbol.
         */ function create(name, kind, range, uri, containerName) {
            var result = {
                name: name,
                kind: kind,
                location: {
                    uri: uri,
                    range: range
                }
            };
            if (containerName) result.containerName = containerName;
            return result;
        }
        SymbolInformation.create = create;
    })(SymbolInformation || (exports1.SymbolInformation = SymbolInformation = {}));
    var WorkspaceSymbol;
    (function(WorkspaceSymbol) {
        /**
         * Create a new workspace symbol.
         *
         * @param name The name of the symbol.
         * @param kind The kind of the symbol.
         * @param uri The resource of the location of the symbol.
         * @param range An options range of the location.
         * @returns A WorkspaceSymbol.
         */ function create(name, kind, uri, range) {
            return range !== undefined ? {
                name: name,
                kind: kind,
                location: {
                    uri: uri,
                    range: range
                }
            } : {
                name: name,
                kind: kind,
                location: {
                    uri: uri
                }
            };
        }
        WorkspaceSymbol.create = create;
    })(WorkspaceSymbol || (exports1.WorkspaceSymbol = WorkspaceSymbol = {}));
    var DocumentSymbol;
    (function(DocumentSymbol) {
        /**
         * Creates a new symbol information literal.
         *
         * @param name The name of the symbol.
         * @param detail The detail of the symbol.
         * @param kind The kind of the symbol.
         * @param range The range of the symbol.
         * @param selectionRange The selectionRange of the symbol.
         * @param children Children of the symbol.
         */ function create(name, detail, kind, range, selectionRange, children) {
            var result = {
                name: name,
                detail: detail,
                kind: kind,
                range: range,
                selectionRange: selectionRange
            };
            if (children !== undefined) result.children = children;
            return result;
        }
        DocumentSymbol.create = create;
        /**
         * Checks whether the given literal conforms to the {@link DocumentSymbol} interface.
         */ function is(value) {
            var candidate = value;
            return candidate && Is.string(candidate.name) && Is.number(candidate.kind) && Range.is(candidate.range) && Range.is(candidate.selectionRange) && (candidate.detail === undefined || Is.string(candidate.detail)) && (candidate.deprecated === undefined || Is.boolean(candidate.deprecated)) && (candidate.children === undefined || Array.isArray(candidate.children)) && (candidate.tags === undefined || Array.isArray(candidate.tags));
        }
        DocumentSymbol.is = is;
    })(DocumentSymbol || (exports1.DocumentSymbol = DocumentSymbol = {}));
    /**
     * A set of predefined code action kinds
     */ var CodeActionKind;
    (function(CodeActionKind) {
        /**
         * Empty kind.
         */ CodeActionKind.Empty = '';
        /**
         * Base kind for quickfix actions: 'quickfix'
         */ CodeActionKind.QuickFix = 'quickfix';
        /**
         * Base kind for refactoring actions: 'refactor'
         */ CodeActionKind.Refactor = 'refactor';
        /**
         * Base kind for refactoring extraction actions: 'refactor.extract'
         *
         * Example extract actions:
         *
         * - Extract method
         * - Extract function
         * - Extract variable
         * - Extract interface from class
         * - ...
         */ CodeActionKind.RefactorExtract = 'refactor.extract';
        /**
         * Base kind for refactoring inline actions: 'refactor.inline'
         *
         * Example inline actions:
         *
         * - Inline function
         * - Inline variable
         * - Inline constant
         * - ...
         */ CodeActionKind.RefactorInline = 'refactor.inline';
        /**
         * Base kind for refactoring rewrite actions: 'refactor.rewrite'
         *
         * Example rewrite actions:
         *
         * - Convert JavaScript function to class
         * - Add or remove parameter
         * - Encapsulate field
         * - Make method static
         * - Move method to base class
         * - ...
         */ CodeActionKind.RefactorRewrite = 'refactor.rewrite';
        /**
         * Base kind for source actions: `source`
         *
         * Source code actions apply to the entire file.
         */ CodeActionKind.Source = 'source';
        /**
         * Base kind for an organize imports source action: `source.organizeImports`
         */ CodeActionKind.SourceOrganizeImports = 'source.organizeImports';
        /**
         * Base kind for auto-fix source actions: `source.fixAll`.
         *
         * Fix all actions automatically fix errors that have a clear fix that do not require user input.
         * They should not suppress errors or perform unsafe fixes such as generating new types or classes.
         *
         * @since 3.15.0
         */ CodeActionKind.SourceFixAll = 'source.fixAll';
    })(CodeActionKind || (exports1.CodeActionKind = CodeActionKind = {}));
    /**
     * The reason why code actions were requested.
     *
     * @since 3.17.0
     */ var CodeActionTriggerKind;
    (function(CodeActionTriggerKind) {
        /**
         * Code actions were explicitly requested by the user or by an extension.
         */ CodeActionTriggerKind.Invoked = 1;
        /**
         * Code actions were requested automatically.
         *
         * This typically happens when current selection in a file changes, but can
         * also be triggered when file content changes.
         */ CodeActionTriggerKind.Automatic = 2;
    })(CodeActionTriggerKind || (exports1.CodeActionTriggerKind = CodeActionTriggerKind = {}));
    /**
     * The CodeActionContext namespace provides helper functions to work with
     * {@link CodeActionContext} literals.
     */ var CodeActionContext;
    (function(CodeActionContext) {
        /**
         * Creates a new CodeActionContext literal.
         */ function create(diagnostics, only, triggerKind) {
            var result = {
                diagnostics: diagnostics
            };
            if (only !== undefined && only !== null) result.only = only;
            if (triggerKind !== undefined && triggerKind !== null) result.triggerKind = triggerKind;
            return result;
        }
        CodeActionContext.create = create;
        /**
         * Checks whether the given literal conforms to the {@link CodeActionContext} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.typedArray(candidate.diagnostics, Diagnostic.is) && (candidate.only === undefined || Is.typedArray(candidate.only, Is.string)) && (candidate.triggerKind === undefined || candidate.triggerKind === CodeActionTriggerKind.Invoked || candidate.triggerKind === CodeActionTriggerKind.Automatic);
        }
        CodeActionContext.is = is;
    })(CodeActionContext || (exports1.CodeActionContext = CodeActionContext = {}));
    var CodeAction;
    (function(CodeAction) {
        function create(title, kindOrCommandOrEdit, kind) {
            var result = {
                title: title
            };
            var checkKind = true;
            if (typeof kindOrCommandOrEdit === 'string') {
                checkKind = false;
                result.kind = kindOrCommandOrEdit;
            } else if (Command.is(kindOrCommandOrEdit)) result.command = kindOrCommandOrEdit;
            else result.edit = kindOrCommandOrEdit;
            if (checkKind && kind !== undefined) result.kind = kind;
            return result;
        }
        CodeAction.create = create;
        function is(value) {
            var candidate = value;
            return candidate && Is.string(candidate.title) && (candidate.diagnostics === undefined || Is.typedArray(candidate.diagnostics, Diagnostic.is)) && (candidate.kind === undefined || Is.string(candidate.kind)) && (candidate.edit !== undefined || candidate.command !== undefined) && (candidate.command === undefined || Command.is(candidate.command)) && (candidate.isPreferred === undefined || Is.boolean(candidate.isPreferred)) && (candidate.edit === undefined || WorkspaceEdit.is(candidate.edit));
        }
        CodeAction.is = is;
    })(CodeAction || (exports1.CodeAction = CodeAction = {}));
    /**
     * The CodeLens namespace provides helper functions to work with
     * {@link CodeLens} literals.
     */ var CodeLens;
    (function(CodeLens) {
        /**
         * Creates a new CodeLens literal.
         */ function create(range, data) {
            var result = {
                range: range
            };
            if (Is.defined(data)) result.data = data;
            return result;
        }
        CodeLens.create = create;
        /**
         * Checks whether the given literal conforms to the {@link CodeLens} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Range.is(candidate.range) && (Is.undefined(candidate.command) || Command.is(candidate.command));
        }
        CodeLens.is = is;
    })(CodeLens || (exports1.CodeLens = CodeLens = {}));
    /**
     * The FormattingOptions namespace provides helper functions to work with
     * {@link FormattingOptions} literals.
     */ var FormattingOptions;
    (function(FormattingOptions) {
        /**
         * Creates a new FormattingOptions literal.
         */ function create(tabSize, insertSpaces) {
            return {
                tabSize: tabSize,
                insertSpaces: insertSpaces
            };
        }
        FormattingOptions.create = create;
        /**
         * Checks whether the given literal conforms to the {@link FormattingOptions} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.uinteger(candidate.tabSize) && Is.boolean(candidate.insertSpaces);
        }
        FormattingOptions.is = is;
    })(FormattingOptions || (exports1.FormattingOptions = FormattingOptions = {}));
    /**
     * The DocumentLink namespace provides helper functions to work with
     * {@link DocumentLink} literals.
     */ var DocumentLink;
    (function(DocumentLink) {
        /**
         * Creates a new DocumentLink literal.
         */ function create(range, target, data) {
            return {
                range: range,
                target: target,
                data: data
            };
        }
        DocumentLink.create = create;
        /**
         * Checks whether the given literal conforms to the {@link DocumentLink} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Range.is(candidate.range) && (Is.undefined(candidate.target) || Is.string(candidate.target));
        }
        DocumentLink.is = is;
    })(DocumentLink || (exports1.DocumentLink = DocumentLink = {}));
    /**
     * The SelectionRange namespace provides helper function to work with
     * SelectionRange literals.
     */ var SelectionRange;
    (function(SelectionRange) {
        /**
         * Creates a new SelectionRange
         * @param range the range.
         * @param parent an optional parent.
         */ function create(range, parent) {
            return {
                range: range,
                parent: parent
            };
        }
        SelectionRange.create = create;
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Range.is(candidate.range) && (candidate.parent === undefined || SelectionRange.is(candidate.parent));
        }
        SelectionRange.is = is;
    })(SelectionRange || (exports1.SelectionRange = SelectionRange = {}));
    /**
     * A set of predefined token types. This set is not fixed
     * an clients can specify additional token types via the
     * corresponding client capabilities.
     *
     * @since 3.16.0
     */ var SemanticTokenTypes;
    (function(SemanticTokenTypes) {
        SemanticTokenTypes["namespace"] = "namespace";
        /**
         * Represents a generic type. Acts as a fallback for types which can't be mapped to
         * a specific type like class or enum.
         */ SemanticTokenTypes["type"] = "type";
        SemanticTokenTypes["class"] = "class";
        SemanticTokenTypes["enum"] = "enum";
        SemanticTokenTypes["interface"] = "interface";
        SemanticTokenTypes["struct"] = "struct";
        SemanticTokenTypes["typeParameter"] = "typeParameter";
        SemanticTokenTypes["parameter"] = "parameter";
        SemanticTokenTypes["variable"] = "variable";
        SemanticTokenTypes["property"] = "property";
        SemanticTokenTypes["enumMember"] = "enumMember";
        SemanticTokenTypes["event"] = "event";
        SemanticTokenTypes["function"] = "function";
        SemanticTokenTypes["method"] = "method";
        SemanticTokenTypes["macro"] = "macro";
        SemanticTokenTypes["keyword"] = "keyword";
        SemanticTokenTypes["modifier"] = "modifier";
        SemanticTokenTypes["comment"] = "comment";
        SemanticTokenTypes["string"] = "string";
        SemanticTokenTypes["number"] = "number";
        SemanticTokenTypes["regexp"] = "regexp";
        SemanticTokenTypes["operator"] = "operator";
        /**
         * @since 3.17.0
         */ SemanticTokenTypes["decorator"] = "decorator";
    })(SemanticTokenTypes || (exports1.SemanticTokenTypes = SemanticTokenTypes = {}));
    /**
     * A set of predefined token modifiers. This set is not fixed
     * an clients can specify additional token types via the
     * corresponding client capabilities.
     *
     * @since 3.16.0
     */ var SemanticTokenModifiers;
    (function(SemanticTokenModifiers) {
        SemanticTokenModifiers["declaration"] = "declaration";
        SemanticTokenModifiers["definition"] = "definition";
        SemanticTokenModifiers["readonly"] = "readonly";
        SemanticTokenModifiers["static"] = "static";
        SemanticTokenModifiers["deprecated"] = "deprecated";
        SemanticTokenModifiers["abstract"] = "abstract";
        SemanticTokenModifiers["async"] = "async";
        SemanticTokenModifiers["modification"] = "modification";
        SemanticTokenModifiers["documentation"] = "documentation";
        SemanticTokenModifiers["defaultLibrary"] = "defaultLibrary";
    })(SemanticTokenModifiers || (exports1.SemanticTokenModifiers = SemanticTokenModifiers = {}));
    /**
     * @since 3.16.0
     */ var SemanticTokens;
    (function(SemanticTokens) {
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && (candidate.resultId === undefined || typeof candidate.resultId === 'string') && Array.isArray(candidate.data) && (candidate.data.length === 0 || typeof candidate.data[0] === 'number');
        }
        SemanticTokens.is = is;
    })(SemanticTokens || (exports1.SemanticTokens = SemanticTokens = {}));
    /**
     * The InlineValueText namespace provides functions to deal with InlineValueTexts.
     *
     * @since 3.17.0
     */ var InlineValueText;
    (function(InlineValueText) {
        /**
         * Creates a new InlineValueText literal.
         */ function create(range, text) {
            return {
                range: range,
                text: text
            };
        }
        InlineValueText.create = create;
        function is(value) {
            var candidate = value;
            return candidate !== undefined && candidate !== null && Range.is(candidate.range) && Is.string(candidate.text);
        }
        InlineValueText.is = is;
    })(InlineValueText || (exports1.InlineValueText = InlineValueText = {}));
    /**
     * The InlineValueVariableLookup namespace provides functions to deal with InlineValueVariableLookups.
     *
     * @since 3.17.0
     */ var InlineValueVariableLookup;
    (function(InlineValueVariableLookup) {
        /**
         * Creates a new InlineValueText literal.
         */ function create(range, variableName, caseSensitiveLookup) {
            return {
                range: range,
                variableName: variableName,
                caseSensitiveLookup: caseSensitiveLookup
            };
        }
        InlineValueVariableLookup.create = create;
        function is(value) {
            var candidate = value;
            return candidate !== undefined && candidate !== null && Range.is(candidate.range) && Is.boolean(candidate.caseSensitiveLookup) && (Is.string(candidate.variableName) || candidate.variableName === undefined);
        }
        InlineValueVariableLookup.is = is;
    })(InlineValueVariableLookup || (exports1.InlineValueVariableLookup = InlineValueVariableLookup = {}));
    /**
     * The InlineValueEvaluatableExpression namespace provides functions to deal with InlineValueEvaluatableExpression.
     *
     * @since 3.17.0
     */ var InlineValueEvaluatableExpression;
    (function(InlineValueEvaluatableExpression) {
        /**
         * Creates a new InlineValueEvaluatableExpression literal.
         */ function create(range, expression) {
            return {
                range: range,
                expression: expression
            };
        }
        InlineValueEvaluatableExpression.create = create;
        function is(value) {
            var candidate = value;
            return candidate !== undefined && candidate !== null && Range.is(candidate.range) && (Is.string(candidate.expression) || candidate.expression === undefined);
        }
        InlineValueEvaluatableExpression.is = is;
    })(InlineValueEvaluatableExpression || (exports1.InlineValueEvaluatableExpression = InlineValueEvaluatableExpression = {}));
    /**
     * The InlineValueContext namespace provides helper functions to work with
     * {@link InlineValueContext} literals.
     *
     * @since 3.17.0
     */ var InlineValueContext;
    (function(InlineValueContext) {
        /**
         * Creates a new InlineValueContext literal.
         */ function create(frameId, stoppedLocation) {
            return {
                frameId: frameId,
                stoppedLocation: stoppedLocation
            };
        }
        InlineValueContext.create = create;
        /**
         * Checks whether the given literal conforms to the {@link InlineValueContext} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Range.is(value.stoppedLocation);
        }
        InlineValueContext.is = is;
    })(InlineValueContext || (exports1.InlineValueContext = InlineValueContext = {}));
    /**
     * Inlay hint kinds.
     *
     * @since 3.17.0
     */ var InlayHintKind;
    (function(InlayHintKind) {
        /**
         * An inlay hint that for a type annotation.
         */ InlayHintKind.Type = 1;
        /**
         * An inlay hint that is for a parameter.
         */ InlayHintKind.Parameter = 2;
        function is(value) {
            return value === 1 || value === 2;
        }
        InlayHintKind.is = is;
    })(InlayHintKind || (exports1.InlayHintKind = InlayHintKind = {}));
    var InlayHintLabelPart;
    (function(InlayHintLabelPart) {
        function create(value) {
            return {
                value: value
            };
        }
        InlayHintLabelPart.create = create;
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && (candidate.tooltip === undefined || Is.string(candidate.tooltip) || MarkupContent.is(candidate.tooltip)) && (candidate.location === undefined || Location.is(candidate.location)) && (candidate.command === undefined || Command.is(candidate.command));
        }
        InlayHintLabelPart.is = is;
    })(InlayHintLabelPart || (exports1.InlayHintLabelPart = InlayHintLabelPart = {}));
    var InlayHint;
    (function(InlayHint) {
        function create(position, label, kind) {
            var result = {
                position: position,
                label: label
            };
            if (kind !== undefined) result.kind = kind;
            return result;
        }
        InlayHint.create = create;
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Position.is(candidate.position) && (Is.string(candidate.label) || Is.typedArray(candidate.label, InlayHintLabelPart.is)) && (candidate.kind === undefined || InlayHintKind.is(candidate.kind)) && candidate.textEdits === undefined || Is.typedArray(candidate.textEdits, TextEdit.is) && (candidate.tooltip === undefined || Is.string(candidate.tooltip) || MarkupContent.is(candidate.tooltip)) && (candidate.paddingLeft === undefined || Is.boolean(candidate.paddingLeft)) && (candidate.paddingRight === undefined || Is.boolean(candidate.paddingRight));
        }
        InlayHint.is = is;
    })(InlayHint || (exports1.InlayHint = InlayHint = {}));
    var StringValue;
    (function(StringValue) {
        function createSnippet(value) {
            return {
                kind: 'snippet',
                value: value
            };
        }
        StringValue.createSnippet = createSnippet;
    })(StringValue || (exports1.StringValue = StringValue = {}));
    var InlineCompletionItem;
    (function(InlineCompletionItem) {
        function create(insertText, filterText, range, command) {
            return {
                insertText: insertText,
                filterText: filterText,
                range: range,
                command: command
            };
        }
        InlineCompletionItem.create = create;
    })(InlineCompletionItem || (exports1.InlineCompletionItem = InlineCompletionItem = {}));
    var InlineCompletionList;
    (function(InlineCompletionList) {
        function create(items) {
            return {
                items: items
            };
        }
        InlineCompletionList.create = create;
    })(InlineCompletionList || (exports1.InlineCompletionList = InlineCompletionList = {}));
    /**
     * Describes how an {@link InlineCompletionItemProvider inline completion provider} was triggered.
     *
     * @since 3.18.0
     * @proposed
     */ var InlineCompletionTriggerKind;
    (function(InlineCompletionTriggerKind) {
        /**
         * Completion was triggered explicitly by a user gesture.
         */ InlineCompletionTriggerKind.Invoked = 0;
        /**
         * Completion was triggered automatically while editing.
         */ InlineCompletionTriggerKind.Automatic = 1;
    })(InlineCompletionTriggerKind || (exports1.InlineCompletionTriggerKind = InlineCompletionTriggerKind = {}));
    var SelectedCompletionInfo;
    (function(SelectedCompletionInfo) {
        function create(range, text) {
            return {
                range: range,
                text: text
            };
        }
        SelectedCompletionInfo.create = create;
    })(SelectedCompletionInfo || (exports1.SelectedCompletionInfo = SelectedCompletionInfo = {}));
    var InlineCompletionContext;
    (function(InlineCompletionContext) {
        function create(triggerKind, selectedCompletionInfo) {
            return {
                triggerKind: triggerKind,
                selectedCompletionInfo: selectedCompletionInfo
            };
        }
        InlineCompletionContext.create = create;
    })(InlineCompletionContext || (exports1.InlineCompletionContext = InlineCompletionContext = {}));
    var WorkspaceFolder;
    (function(WorkspaceFolder) {
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && URI.is(candidate.uri) && Is.string(candidate.name);
        }
        WorkspaceFolder.is = is;
    })(WorkspaceFolder || (exports1.WorkspaceFolder = WorkspaceFolder = {}));
    exports1.EOL = [
        '\n',
        '\r\n',
        '\r'
    ];
    /**
     * @deprecated Use the text document from the new vscode-languageserver-textdocument package.
     */ var TextDocument;
    (function(TextDocument) {
        /**
         * Creates a new ITextDocument literal from the given uri and content.
         * @param uri The document's uri.
         * @param languageId The document's language Id.
         * @param version The document's version.
         * @param content The document's content.
         */ function create(uri, languageId, version, content) {
            return new FullTextDocument(uri, languageId, version, content);
        }
        TextDocument.create = create;
        /**
         * Checks whether the given literal conforms to the {@link ITextDocument} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.uri) && (Is.undefined(candidate.languageId) || Is.string(candidate.languageId)) && Is.uinteger(candidate.lineCount) && Is.func(candidate.getText) && Is.func(candidate.positionAt) && Is.func(candidate.offsetAt) ? true : false;
        }
        TextDocument.is = is;
        function applyEdits(document, edits) {
            var text = document.getText();
            var sortedEdits = mergeSort(edits, function(a, b) {
                var diff = a.range.start.line - b.range.start.line;
                if (diff === 0) return a.range.start.character - b.range.start.character;
                return diff;
            });
            var lastModifiedOffset = text.length;
            for(var i = sortedEdits.length - 1; i >= 0; i--){
                var e = sortedEdits[i];
                var startOffset = document.offsetAt(e.range.start);
                var endOffset = document.offsetAt(e.range.end);
                if (endOffset <= lastModifiedOffset) text = text.substring(0, startOffset) + e.newText + text.substring(endOffset, text.length);
                else throw new Error('Overlapping edit');
                lastModifiedOffset = startOffset;
            }
            return text;
        }
        TextDocument.applyEdits = applyEdits;
        function mergeSort(data, compare) {
            if (data.length <= 1) // sorted
            return data;
            var p = data.length / 2 | 0;
            var left = data.slice(0, p);
            var right = data.slice(p);
            mergeSort(left, compare);
            mergeSort(right, compare);
            var leftIdx = 0;
            var rightIdx = 0;
            var i = 0;
            while(leftIdx < left.length && rightIdx < right.length){
                var ret = compare(left[leftIdx], right[rightIdx]);
                if (ret <= 0) // smaller_equal -> take left to preserve order
                data[i++] = left[leftIdx++];
                else // greater -> take right
                data[i++] = right[rightIdx++];
            }
            while(leftIdx < left.length)data[i++] = left[leftIdx++];
            while(rightIdx < right.length)data[i++] = right[rightIdx++];
            return data;
        }
    })(TextDocument || (exports1.TextDocument = TextDocument = {}));
    /**
     * @deprecated Use the text document from the new vscode-languageserver-textdocument package.
     */ var FullTextDocument = /** @class */ function() {
        function FullTextDocument(uri, languageId, version, content) {
            this._uri = uri;
            this._languageId = languageId;
            this._version = version;
            this._content = content;
            this._lineOffsets = undefined;
        }
        Object.defineProperty(FullTextDocument.prototype, "uri", {
            get: function() {
                return this._uri;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(FullTextDocument.prototype, "languageId", {
            get: function() {
                return this._languageId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(FullTextDocument.prototype, "version", {
            get: function() {
                return this._version;
            },
            enumerable: false,
            configurable: true
        });
        FullTextDocument.prototype.getText = function(range) {
            if (range) {
                var start = this.offsetAt(range.start);
                var end = this.offsetAt(range.end);
                return this._content.substring(start, end);
            }
            return this._content;
        };
        FullTextDocument.prototype.update = function(event, version) {
            this._content = event.text;
            this._version = version;
            this._lineOffsets = undefined;
        };
        FullTextDocument.prototype.getLineOffsets = function() {
            if (this._lineOffsets === undefined) {
                var lineOffsets = [];
                var text = this._content;
                var isLineStart = true;
                for(var i = 0; i < text.length; i++){
                    if (isLineStart) {
                        lineOffsets.push(i);
                        isLineStart = false;
                    }
                    var ch = text.charAt(i);
                    isLineStart = ch === '\r' || ch === '\n';
                    if (ch === '\r' && i + 1 < text.length && text.charAt(i + 1) === '\n') i++;
                }
                if (isLineStart && text.length > 0) lineOffsets.push(text.length);
                this._lineOffsets = lineOffsets;
            }
            return this._lineOffsets;
        };
        FullTextDocument.prototype.positionAt = function(offset) {
            offset = Math.max(Math.min(offset, this._content.length), 0);
            var lineOffsets = this.getLineOffsets();
            var low = 0, high = lineOffsets.length;
            if (high === 0) return Position.create(0, offset);
            while(low < high){
                var mid = Math.floor((low + high) / 2);
                if (lineOffsets[mid] > offset) high = mid;
                else low = mid + 1;
            }
            // low is the least x for which the line offset is larger than the current offset
            // or array.length if no line offset is larger than the current offset
            var line = low - 1;
            return Position.create(line, offset - lineOffsets[line]);
        };
        FullTextDocument.prototype.offsetAt = function(position) {
            var lineOffsets = this.getLineOffsets();
            if (position.line >= lineOffsets.length) return this._content.length;
            else if (position.line < 0) return 0;
            var lineOffset = lineOffsets[position.line];
            var nextLineOffset = position.line + 1 < lineOffsets.length ? lineOffsets[position.line + 1] : this._content.length;
            return Math.max(Math.min(lineOffset + position.character, nextLineOffset), lineOffset);
        };
        Object.defineProperty(FullTextDocument.prototype, "lineCount", {
            get: function() {
                return this.getLineOffsets().length;
            },
            enumerable: false,
            configurable: true
        });
        return FullTextDocument;
    }();
    var Is;
    (function(Is) {
        var toString = Object.prototype.toString;
        function defined(value) {
            return typeof value !== 'undefined';
        }
        Is.defined = defined;
        function undefined1(value) {
            return typeof value === 'undefined';
        }
        Is.undefined = undefined1;
        function boolean(value) {
            return value === true || value === false;
        }
        Is.boolean = boolean;
        function string(value) {
            return toString.call(value) === '[object String]';
        }
        Is.string = string;
        function number(value) {
            return toString.call(value) === '[object Number]';
        }
        Is.number = number;
        function numberRange(value, min, max) {
            return toString.call(value) === '[object Number]' && min <= value && value <= max;
        }
        Is.numberRange = numberRange;
        function integer(value) {
            return toString.call(value) === '[object Number]' && -2147483648 <= value && value <= 2147483647;
        }
        Is.integer = integer;
        function uinteger(value) {
            return toString.call(value) === '[object Number]' && 0 <= value && value <= 2147483647;
        }
        Is.uinteger = uinteger;
        function func(value) {
            return toString.call(value) === '[object Function]';
        }
        Is.func = func;
        function objectLiteral(value) {
            // Strictly speaking class instances pass this check as well. Since the LSP
            // doesn't use classes we ignore this for now. If we do we need to add something
            // like this: `Object.getPrototypeOf(Object.getPrototypeOf(x)) === null`
            return value !== null && typeof value === 'object';
        }
        Is.objectLiteral = objectLiteral;
        function typedArray(value, check) {
            return Array.isArray(value) && value.every(check);
        }
        Is.typedArray = typedArray;
    })(Is || (Is = {}));
});


var $01050fa442f244fa$exports = {};
var $01050fa442f244fa$var$__spreadArray = $01050fa442f244fa$exports && $01050fa442f244fa$exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
(function(factory) {
    if (typeof $01050fa442f244fa$exports === "object") {
        var v = factory(undefined, $01050fa442f244fa$exports);
        if (v !== undefined) $01050fa442f244fa$exports = v;
    } else if (typeof define === "function" && define.amd) define([
        "require",
        "exports"
    ], factory);
})(function(require1, exports1) {
    /* --------------------------------------------------------------------------------------------
     * Copyright (c) Microsoft Corporation. All rights reserved.
     * Licensed under the MIT License. See License.txt in the project root for license information.
     * ------------------------------------------------------------------------------------------ */ 'use strict';
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.TextDocument = void 0;
    var FullTextDocument = /** @class */ function() {
        function FullTextDocument(uri, languageId, version, content) {
            this._uri = uri;
            this._languageId = languageId;
            this._version = version;
            this._content = content;
            this._lineOffsets = undefined;
        }
        Object.defineProperty(FullTextDocument.prototype, "uri", {
            get: function() {
                return this._uri;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(FullTextDocument.prototype, "languageId", {
            get: function() {
                return this._languageId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(FullTextDocument.prototype, "version", {
            get: function() {
                return this._version;
            },
            enumerable: false,
            configurable: true
        });
        FullTextDocument.prototype.getText = function(range) {
            if (range) {
                var start = this.offsetAt(range.start);
                var end = this.offsetAt(range.end);
                return this._content.substring(start, end);
            }
            return this._content;
        };
        FullTextDocument.prototype.update = function(changes, version) {
            for(var _i = 0, changes_1 = changes; _i < changes_1.length; _i++){
                var change = changes_1[_i];
                if (FullTextDocument.isIncremental(change)) {
                    // makes sure start is before end
                    var range = getWellformedRange(change.range);
                    // update content
                    var startOffset = this.offsetAt(range.start);
                    var endOffset = this.offsetAt(range.end);
                    this._content = this._content.substring(0, startOffset) + change.text + this._content.substring(endOffset, this._content.length);
                    // update the offsets
                    var startLine = Math.max(range.start.line, 0);
                    var endLine = Math.max(range.end.line, 0);
                    var lineOffsets = this._lineOffsets;
                    var addedLineOffsets = computeLineOffsets(change.text, false, startOffset);
                    if (endLine - startLine === addedLineOffsets.length) for(var i = 0, len = addedLineOffsets.length; i < len; i++)lineOffsets[i + startLine + 1] = addedLineOffsets[i];
                    else if (addedLineOffsets.length < 10000) lineOffsets.splice.apply(lineOffsets, $01050fa442f244fa$var$__spreadArray([
                        startLine + 1,
                        endLine - startLine
                    ], addedLineOffsets, false));
                    else this._lineOffsets = lineOffsets = lineOffsets.slice(0, startLine + 1).concat(addedLineOffsets, lineOffsets.slice(endLine + 1));
                    var diff = change.text.length - (endOffset - startOffset);
                    if (diff !== 0) for(var i = startLine + 1 + addedLineOffsets.length, len = lineOffsets.length; i < len; i++)lineOffsets[i] = lineOffsets[i] + diff;
                } else if (FullTextDocument.isFull(change)) {
                    this._content = change.text;
                    this._lineOffsets = undefined;
                } else throw new Error('Unknown change event received');
            }
            this._version = version;
        };
        FullTextDocument.prototype.getLineOffsets = function() {
            if (this._lineOffsets === undefined) this._lineOffsets = computeLineOffsets(this._content, true);
            return this._lineOffsets;
        };
        FullTextDocument.prototype.positionAt = function(offset) {
            offset = Math.max(Math.min(offset, this._content.length), 0);
            var lineOffsets = this.getLineOffsets();
            var low = 0, high = lineOffsets.length;
            if (high === 0) return {
                line: 0,
                character: offset
            };
            while(low < high){
                var mid = Math.floor((low + high) / 2);
                if (lineOffsets[mid] > offset) high = mid;
                else low = mid + 1;
            }
            // low is the least x for which the line offset is larger than the current offset
            // or array.length if no line offset is larger than the current offset
            var line = low - 1;
            offset = this.ensureBeforeEOL(offset, lineOffsets[line]);
            return {
                line: line,
                character: offset - lineOffsets[line]
            };
        };
        FullTextDocument.prototype.offsetAt = function(position) {
            var lineOffsets = this.getLineOffsets();
            if (position.line >= lineOffsets.length) return this._content.length;
            else if (position.line < 0) return 0;
            var lineOffset = lineOffsets[position.line];
            if (position.character <= 0) return lineOffset;
            var nextLineOffset = position.line + 1 < lineOffsets.length ? lineOffsets[position.line + 1] : this._content.length;
            var offset = Math.min(lineOffset + position.character, nextLineOffset);
            return this.ensureBeforeEOL(offset, lineOffset);
        };
        FullTextDocument.prototype.ensureBeforeEOL = function(offset, lineOffset) {
            while(offset > lineOffset && isEOL(this._content.charCodeAt(offset - 1)))offset--;
            return offset;
        };
        Object.defineProperty(FullTextDocument.prototype, "lineCount", {
            get: function() {
                return this.getLineOffsets().length;
            },
            enumerable: false,
            configurable: true
        });
        FullTextDocument.isIncremental = function(event) {
            var candidate = event;
            return candidate !== undefined && candidate !== null && typeof candidate.text === 'string' && candidate.range !== undefined && (candidate.rangeLength === undefined || typeof candidate.rangeLength === 'number');
        };
        FullTextDocument.isFull = function(event) {
            var candidate = event;
            return candidate !== undefined && candidate !== null && typeof candidate.text === 'string' && candidate.range === undefined && candidate.rangeLength === undefined;
        };
        return FullTextDocument;
    }();
    var TextDocument;
    (function(TextDocument) {
        /**
         * Creates a new text document.
         *
         * @param uri The document's uri.
         * @param languageId  The document's language Id.
         * @param version The document's initial version number.
         * @param content The document's content.
         */ function create(uri, languageId, version, content) {
            return new FullTextDocument(uri, languageId, version, content);
        }
        TextDocument.create = create;
        /**
         * Updates a TextDocument by modifying its content.
         *
         * @param document the document to update. Only documents created by TextDocument.create are valid inputs.
         * @param changes the changes to apply to the document.
         * @param version the changes version for the document.
         * @returns The updated TextDocument. Note: That's the same document instance passed in as first parameter.
         *
         */ function update(document, changes, version) {
            if (document instanceof FullTextDocument) {
                document.update(changes, version);
                return document;
            } else throw new Error('TextDocument.update: document must be created by TextDocument.create');
        }
        TextDocument.update = update;
        function applyEdits(document, edits) {
            var text = document.getText();
            var sortedEdits = mergeSort(edits.map(getWellformedEdit), function(a, b) {
                var diff = a.range.start.line - b.range.start.line;
                if (diff === 0) return a.range.start.character - b.range.start.character;
                return diff;
            });
            var lastModifiedOffset = 0;
            var spans = [];
            for(var _i = 0, sortedEdits_1 = sortedEdits; _i < sortedEdits_1.length; _i++){
                var e = sortedEdits_1[_i];
                var startOffset = document.offsetAt(e.range.start);
                if (startOffset < lastModifiedOffset) throw new Error('Overlapping edit');
                else if (startOffset > lastModifiedOffset) spans.push(text.substring(lastModifiedOffset, startOffset));
                if (e.newText.length) spans.push(e.newText);
                lastModifiedOffset = document.offsetAt(e.range.end);
            }
            spans.push(text.substr(lastModifiedOffset));
            return spans.join('');
        }
        TextDocument.applyEdits = applyEdits;
    })(TextDocument || (exports1.TextDocument = TextDocument = {}));
    function mergeSort(data, compare) {
        if (data.length <= 1) // sorted
        return data;
        var p = data.length / 2 | 0;
        var left = data.slice(0, p);
        var right = data.slice(p);
        mergeSort(left, compare);
        mergeSort(right, compare);
        var leftIdx = 0;
        var rightIdx = 0;
        var i = 0;
        while(leftIdx < left.length && rightIdx < right.length){
            var ret = compare(left[leftIdx], right[rightIdx]);
            if (ret <= 0) // smaller_equal -> take left to preserve order
            data[i++] = left[leftIdx++];
            else // greater -> take right
            data[i++] = right[rightIdx++];
        }
        while(leftIdx < left.length)data[i++] = left[leftIdx++];
        while(rightIdx < right.length)data[i++] = right[rightIdx++];
        return data;
    }
    function computeLineOffsets(text, isAtLineStart, textOffset) {
        if (textOffset === void 0) textOffset = 0;
        var result = isAtLineStart ? [
            textOffset
        ] : [];
        for(var i = 0; i < text.length; i++){
            var ch = text.charCodeAt(i);
            if (isEOL(ch)) {
                if (ch === 13 /* CharCode.CarriageReturn */  && i + 1 < text.length && text.charCodeAt(i + 1) === 10 /* CharCode.LineFeed */ ) i++;
                result.push(textOffset + i + 1);
            }
        }
        return result;
    }
    function isEOL(char) {
        return char === 13 /* CharCode.CarriageReturn */  || char === 10 /* CharCode.LineFeed */ ;
    }
    function getWellformedRange(range) {
        var start = range.start;
        var end = range.end;
        if (start.line > end.line || start.line === end.line && start.character > end.character) return {
            start: end,
            end: start
        };
        return range;
    }
    function getWellformedEdit(textEdit) {
        var range = getWellformedRange(textEdit.range);
        if (range !== textEdit.range) return {
            newText: textEdit.newText,
            range: range
        };
        return textEdit;
    }
});


'use strict';
var $579034ff01526470$export$6c8296c43fb6786b;
(function(ClientCapabilities) {
    ClientCapabilities.LATEST = {
        textDocument: {
            completion: {
                completionItem: {
                    documentationFormat: [
                        (0, $1345bdc33671c7a9$exports.MarkupKind).Markdown,
                        (0, $1345bdc33671c7a9$exports.MarkupKind).PlainText
                    ]
                }
            },
            hover: {
                contentFormat: [
                    (0, $1345bdc33671c7a9$exports.MarkupKind).Markdown,
                    (0, $1345bdc33671c7a9$exports.MarkupKind).PlainText
                ]
            }
        }
    };
})($579034ff01526470$export$6c8296c43fb6786b || ($579034ff01526470$export$6c8296c43fb6786b = {}));
var $579034ff01526470$export$c5ae10d7c88c4d3e;
(function(FileType) {
    /**
     * The file type is unknown.
     */ FileType[FileType["Unknown"] = 0] = "Unknown";
    /**
     * A regular file.
     */ FileType[FileType["File"] = 1] = "File";
    /**
     * A directory.
     */ FileType[FileType["Directory"] = 2] = "Directory";
    /**
     * A symbolic link to a file.
     */ FileType[FileType["SymbolicLink"] = 64] = "SymbolicLink";
})($579034ff01526470$export$c5ae10d7c88c4d3e || ($579034ff01526470$export$c5ae10d7c88c4d3e = {}));


'use strict';
const $d5592ab2ff7f18b0$export$b732f4f6e9555f21 = {
    'C': {
        name: 'Chrome',
        platform: 'desktop'
    },
    'CA': {
        name: 'Chrome',
        platform: 'Android'
    },
    'E': {
        name: 'Edge',
        platform: 'desktop'
    },
    'FF': {
        name: 'Firefox',
        platform: 'desktop'
    },
    'FFA': {
        name: 'Firefox',
        platform: 'Android'
    },
    'S': {
        name: 'Safari',
        platform: 'macOS'
    },
    'SM': {
        name: 'Safari',
        platform: 'iOS'
    }
};
const $d5592ab2ff7f18b0$var$shortCompatPattern = /(E|FFA|FF|SM|S|CA|C|IE|O)([\d|\.]+)?/;
const $d5592ab2ff7f18b0$export$d3f5d25fc068a2c1 = {
    BASELINE_LIMITED: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCA1NDAgMzAwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxzdHlsZT4KICAgIC5ncmF5LXNoYXBlIHsKICAgICAgZmlsbDogI0M2QzZDNjsgLyogTGlnaHQgbW9kZSAqLwogICAgfQoKICAgIEBtZWRpYSAocHJlZmVycy1jb2xvci1zY2hlbWU6IGRhcmspIHsKICAgICAgLmdyYXktc2hhcGUgewogICAgICAgIGZpbGw6ICM1NjU2NTY7IC8qIERhcmsgbW9kZSAqLwogICAgICB9CiAgICB9CiAgPC9zdHlsZT4KICA8cGF0aCBkPSJNMTUwIDBMMjQwIDkwTDIxMCAxMjBMMTIwIDMwTDE1MCAwWiIgZmlsbD0iI0YwOTQwOSIvPgogIDxwYXRoIGQ9Ik00MjAgMzBMNTQwIDE1MEw0MjAgMjcwTDM5MCAyNDBMNDgwIDE1MEwzOTAgNjBMNDIwIDMwWiIgY2xhc3M9ImdyYXktc2hhcGUiLz4KICA8cGF0aCBkPSJNMzMwIDE4MEwzMDAgMjEwTDM5MCAzMDBMNDIwIDI3MEwzMzAgMTgwWiIgZmlsbD0iI0YwOTQwOSIvPgogIDxwYXRoIGQ9Ik0xMjAgMzBMMTUwIDYwTDYwIDE1MEwxNTAgMjQwTDEyMCAyNzBMMCAxNTBMMTIwIDMwWiIgY2xhc3M9ImdyYXktc2hhcGUiLz4KICA8cGF0aCBkPSJNMzkwIDBMNDIwIDMwTDE1MCAzMDBMMTIwIDI3MEwzOTAgMFoiIGZpbGw9IiNGMDk0MDkiLz4KPC9zdmc+',
    BASELINE_LOW: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCA1NDAgMzAwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxzdHlsZT4KICAgIC5ibHVlLXNoYXBlIHsKICAgICAgZmlsbDogI0E4QzdGQTsgLyogTGlnaHQgbW9kZSAqLwogICAgfQoKICAgIEBtZWRpYSAocHJlZmVycy1jb2xvci1zY2hlbWU6IGRhcmspIHsKICAgICAgLmJsdWUtc2hhcGUgewogICAgICAgIGZpbGw6ICMyRDUwOUU7IC8qIERhcmsgbW9kZSAqLwogICAgICB9CiAgICB9CgogICAgLmRhcmtlci1ibHVlLXNoYXBlIHsKICAgICAgICBmaWxsOiAjMUI2RUYzOwogICAgfQoKICAgIEBtZWRpYSAocHJlZmVycy1jb2xvci1zY2hlbWU6IGRhcmspIHsKICAgICAgICAuZGFya2VyLWJsdWUtc2hhcGUgewogICAgICAgICAgICBmaWxsOiAjNDE4NUZGOwogICAgICAgIH0KICAgIH0KCiAgPC9zdHlsZT4KICA8cGF0aCBkPSJNMTUwIDBMMTgwIDMwTDE1MCA2MEwxMjAgMzBMMTUwIDBaIiBjbGFzcz0iYmx1ZS1zaGFwZSIvPgogIDxwYXRoIGQ9Ik0yMTAgNjBMMjQwIDkwTDIxMCAxMjBMMTgwIDkwTDIxMCA2MFoiIGNsYXNzPSJibHVlLXNoYXBlIi8+CiAgPHBhdGggZD0iTTQ1MCA2MEw0ODAgOTBMNDUwIDEyMEw0MjAgOTBMNDUwIDYwWiIgY2xhc3M9ImJsdWUtc2hhcGUiLz4KICA8cGF0aCBkPSJNNTEwIDEyMEw1NDAgMTUwTDUxMCAxODBMNDgwIDE1MEw1MTAgMTIwWiIgY2xhc3M9ImJsdWUtc2hhcGUiLz4KICA8cGF0aCBkPSJNNDUwIDE4MEw0ODAgMjEwTDQ1MCAyNDBMNDIwIDIxMEw0NTAgMTgwWiIgY2xhc3M9ImJsdWUtc2hhcGUiLz4KICA8cGF0aCBkPSJNMzkwIDI0MEw0MjAgMjcwTDM5MCAzMDBMMzYwIDI3MEwzOTAgMjQwWiIgY2xhc3M9ImJsdWUtc2hhcGUiLz4KICA8cGF0aCBkPSJNMzMwIDE4MEwzNjAgMjEwTDMzMCAyNDBMMzAwIDIxMEwzMzAgMTgwWiIgY2xhc3M9ImJsdWUtc2hhcGUiLz4KICA8cGF0aCBkPSJNOTAgNjBMMTIwIDkwTDkwIDEyMEw2MCA5MEw5MCA2MFoiIGNsYXNzPSJibHVlLXNoYXBlIi8+CiAgPHBhdGggZD0iTTM5MCAwTDQyMCAzMEwxNTAgMzAwTDAgMTUwTDMwIDEyMEwxNTAgMjQwTDM5MCAwWiIgY2xhc3M9ImRhcmtlci1ibHVlLXNoYXBlIi8+Cjwvc3ZnPg==',
    BASELINE_HIGH: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCA1NDAgMzAwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxzdHlsZT4KICAgIC5ncmVlbi1zaGFwZSB7CiAgICAgIGZpbGw6ICNDNEVFRDA7IC8qIExpZ2h0IG1vZGUgKi8KICAgIH0KCiAgICBAbWVkaWEgKHByZWZlcnMtY29sb3Itc2NoZW1lOiBkYXJrKSB7CiAgICAgIC5ncmVlbi1zaGFwZSB7CiAgICAgICAgZmlsbDogIzEyNTIyNTsgLyogRGFyayBtb2RlICovCiAgICAgIH0KICAgIH0KICA8L3N0eWxlPgogIDxwYXRoIGQ9Ik00MjAgMzBMMzkwIDYwTDQ4MCAxNTBMMzkwIDI0MEwzMzAgMTgwTDMwMCAyMTBMMzkwIDMwMEw1NDAgMTUwTDQyMCAzMFoiIGNsYXNzPSJncmVlbi1zaGFwZSIvPgogIDxwYXRoIGQ9Ik0xNTAgMEwzMCAxMjBMNjAgMTUwTDE1MCA2MEwyMTAgMTIwTDI0MCA5MEwxNTAgMFoiIGNsYXNzPSJncmVlbi1zaGFwZSIvPgogIDxwYXRoIGQ9Ik0zOTAgMEw0MjAgMzBMMTUwIDMwMEwwIDE1MEwzMCAxMjBMMTUwIDI0MEwzOTAgMFoiIGZpbGw9IiMxRUE0NDYiLz4KPC9zdmc+'
};
function $d5592ab2ff7f18b0$var$getEntryStatus(status) {
    switch(status){
        case 'nonstandard':
            return "\uD83D\uDEA8\uFE0F Property is nonstandard. Avoid using it.\n\n";
        case 'obsolete':
            return "\uD83D\uDEA8\uFE0F\uFE0F\uFE0F Property is obsolete. Avoid using it.\n\n";
        default:
            return '';
    }
}
function $d5592ab2ff7f18b0$var$getEntryBaselineStatus(baseline, browsers) {
    if (baseline.status === "false") {
        const missingBrowsers = $d5592ab2ff7f18b0$export$25d19fa82514c038(browsers);
        let status = `Limited availability across major browsers`;
        if (missingBrowsers) status += ` (Not fully implemented in ${missingBrowsers})`;
        return status;
    }
    const baselineYear = baseline.baseline_low_date?.split('-')[0];
    return `${baseline.status === 'low' ? 'Newly' : 'Widely'} available across major browsers (Baseline since ${baselineYear})`;
}
function $d5592ab2ff7f18b0$var$getEntryBaselineImage(baseline) {
    if (!baseline) return '';
    let baselineImg;
    switch(baseline?.status){
        case 'low':
            baselineImg = $d5592ab2ff7f18b0$export$d3f5d25fc068a2c1.BASELINE_LOW;
            break;
        case 'high':
            baselineImg = $d5592ab2ff7f18b0$export$d3f5d25fc068a2c1.BASELINE_HIGH;
            break;
        default:
            baselineImg = $d5592ab2ff7f18b0$export$d3f5d25fc068a2c1.BASELINE_LIMITED;
    }
    return `![Baseline icon](${baselineImg})`;
}
function $d5592ab2ff7f18b0$export$7eaaf6bd9b4ee15(entry, doesSupportMarkdown, settings) {
    let result;
    if (doesSupportMarkdown) result = {
        kind: 'markdown',
        value: $d5592ab2ff7f18b0$var$getEntryMarkdownDescription(entry, settings)
    };
    else result = {
        kind: 'plaintext',
        value: $d5592ab2ff7f18b0$var$getEntryStringDescription(entry, settings)
    };
    if (result.value === '') return undefined;
    return result;
}
function $d5592ab2ff7f18b0$export$6bb084aa0df64fa4(text) {
    text = text.replace(/[\\`*_{}[\]()#+\-.!]/g, '\\$&'); // escape markdown syntax tokens: http://daringfireball.net/projects/markdown/syntax#backslash
    return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $d5592ab2ff7f18b0$var$getEntryStringDescription(entry, settings) {
    if (!entry.description || entry.description === '') return '';
    if (typeof entry.description !== 'string') return entry.description.value;
    let result = '';
    if (settings?.documentation !== false) {
        let status = '';
        if (entry.status) {
            status = $d5592ab2ff7f18b0$var$getEntryStatus(entry.status);
            result += status;
        }
        result += entry.description;
        if (entry.baseline && !status) result += `\n\n${$d5592ab2ff7f18b0$var$getEntryBaselineStatus(entry.baseline, entry.browsers)}`;
        if ('syntax' in entry) result += `\n\nSyntax: ${entry.syntax}`;
    }
    if (entry.references && entry.references.length > 0 && settings?.references !== false) {
        if (result.length > 0) result += '\n\n';
        result += entry.references.map((r)=>{
            return `${r.name}: ${r.url}`;
        }).join(' | ');
    }
    return result;
}
function $d5592ab2ff7f18b0$var$getEntryMarkdownDescription(entry, settings) {
    if (!entry.description || entry.description === '') return '';
    let result = '';
    if (settings?.documentation !== false) {
        let status = '';
        if (entry.status) {
            status = $d5592ab2ff7f18b0$var$getEntryStatus(entry.status);
            result += status;
        }
        if (typeof entry.description === 'string') result += $d5592ab2ff7f18b0$export$6bb084aa0df64fa4(entry.description);
        else result += entry.description.kind === (0, $1345bdc33671c7a9$exports.MarkupKind).Markdown ? entry.description.value : $d5592ab2ff7f18b0$export$6bb084aa0df64fa4(entry.description.value);
        if (entry.baseline && !status) result += `\n\n${$d5592ab2ff7f18b0$var$getEntryBaselineImage(entry.baseline)} _${$d5592ab2ff7f18b0$var$getEntryBaselineStatus(entry.baseline, entry.browsers)}_`;
        if ('syntax' in entry && entry.syntax) result += `\n\nSyntax: ${$d5592ab2ff7f18b0$export$6bb084aa0df64fa4(entry.syntax)}`;
    }
    if (entry.references && entry.references.length > 0 && settings?.references !== false) {
        if (result.length > 0) result += '\n\n';
        result += entry.references.map((r)=>{
            return `[${r.name}](${r.url})`;
        }).join(' | ');
    }
    return result;
}
// TODO: Remove "as any" when tsconfig supports es2021+
const $d5592ab2ff7f18b0$var$missingBaselineBrowserFormatter = new Intl.ListFormat("en", {
    style: "long",
    type: "disjunction"
});
function $d5592ab2ff7f18b0$export$25d19fa82514c038(browsers) {
    if (!browsers) return '';
    const missingBrowsers = new Map(Object.entries($d5592ab2ff7f18b0$export$b732f4f6e9555f21));
    for (const shortCompatString of browsers){
        const match = $d5592ab2ff7f18b0$var$shortCompatPattern.exec(shortCompatString);
        if (!match) continue;
        const browser = match[1];
        missingBrowsers.delete(browser);
    }
    return $d5592ab2ff7f18b0$var$missingBaselineBrowserFormatter.format(Object.values(Array.from(missingBrowsers.entries()).reduce((browsers, [browserId, browser])=>{
        if (browser.name in browsers || browserId === 'E') {
            browsers[browser.name] = browser.name;
            return browsers;
        }
        // distinguish between platforms when applicable 
        browsers[browser.name] = `${browser.name} on ${browser.platform}`;
        return browsers;
    }, {})));
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 

const $6be89f889e93fd15$var$hexColorRegExp = /(^#([0-9A-F]{3}){1,2}$)|(^#([0-9A-F]{4}){1,2}$)/i;
const $6be89f889e93fd15$export$41287bde05ee58e7 = [
    {
        label: 'rgb',
        func: 'rgb($red, $green, $blue)',
        insertText: 'rgb(${1:red}, ${2:green}, ${3:blue})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from red, green, and blue values.')
    },
    {
        label: 'rgba',
        func: 'rgba($red, $green, $blue, $alpha)',
        insertText: 'rgba(${1:red}, ${2:green}, ${3:blue}, ${4:alpha})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from red, green, blue, and alpha values.')
    },
    {
        label: 'rgb relative',
        func: 'rgb(from $color $red $green $blue)',
        insertText: 'rgb(from ${1:color} ${2:r} ${3:g} ${4:b})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from the red, green, and blue values of another Color.')
    },
    {
        label: 'hsl',
        func: 'hsl($hue, $saturation, $lightness)',
        insertText: 'hsl(${1:hue}, ${2:saturation}, ${3:lightness})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from hue, saturation, and lightness values.')
    },
    {
        label: 'hsla',
        func: 'hsla($hue, $saturation, $lightness, $alpha)',
        insertText: 'hsla(${1:hue}, ${2:saturation}, ${3:lightness}, ${4:alpha})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from hue, saturation, lightness, and alpha values.')
    },
    {
        label: 'hsl relative',
        func: 'hsl(from $color $hue $saturation $lightness)',
        insertText: 'hsl(from ${1:color} ${2:h} ${3:s} ${4:l})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from the hue, saturation, and lightness values of another Color.')
    },
    {
        label: 'hwb',
        func: 'hwb($hue $white $black)',
        insertText: 'hwb(${1:hue} ${2:white} ${3:black})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from hue, white, and black values.')
    },
    {
        label: 'hwb relative',
        func: 'hwb(from $color $hue $white $black)',
        insertText: 'hwb(from ${1:color} ${2:h} ${3:w} ${4:b})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from the hue, white, and black values of another Color.')
    },
    {
        label: 'lab',
        func: 'lab($lightness $a $b)',
        insertText: 'lab(${1:lightness} ${2:a} ${3:b})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from lightness, a, and b values.')
    },
    {
        label: 'lab relative',
        func: 'lab(from $color $lightness $a $b)',
        insertText: 'lab(from ${1:color} ${2:l} ${3:a} ${4:b})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from the lightness, a, and b values of another Color.')
    },
    {
        label: 'oklab',
        func: 'oklab($lightness $a $b)',
        insertText: 'oklab(${1:lightness} ${2:a} ${3:b})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from lightness, a, and b values.')
    },
    {
        label: 'oklab relative',
        func: 'oklab(from $color $lightness $a $b)',
        insertText: 'oklab(from ${1:color} ${2:l} ${3:a} ${4:b})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from the lightness, a, and b values of another Color.')
    },
    {
        label: 'lch',
        func: 'lch($lightness $chroma $hue)',
        insertText: 'lch(${1:lightness} ${2:chroma} ${3:hue})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from lightness, chroma, and hue values.')
    },
    {
        label: 'lch relative',
        func: 'lch(from $color $lightness $chroma $hue)',
        insertText: 'lch(from ${1:color} ${2:l} ${3:c} ${4:h})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from the lightness, chroma, and hue values of another Color.')
    },
    {
        label: 'oklch',
        func: 'oklch($lightness $chroma $hue)',
        insertText: 'oklch(${1:lightness} ${2:chroma} ${3:hue})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from lightness, chroma, and hue values.')
    },
    {
        label: 'oklch relative',
        func: 'oklch(from $color $lightness $chroma $hue)',
        insertText: 'oklch(from ${1:color} ${2:l} ${3:c} ${4:h})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color from the lightness, chroma, and hue values of another Color.')
    },
    {
        label: 'color',
        func: 'color($color-space $red $green $blue)',
        insertText: 'color(${1|srgb,srgb-linear,display-p3,a98-rgb,prophoto-rgb,rec2020,xyx,xyz-d50,xyz-d65|} ${2:red} ${3:green} ${4:blue})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color in a specific color space from red, green, and blue values.')
    },
    {
        label: 'color relative',
        func: 'color(from $color $color-space $red $green $blue)',
        insertText: 'color(from ${1:color} ${2|srgb,srgb-linear,display-p3,a98-rgb,prophoto-rgb,rec2020,xyx,xyz-d50,xyz-d65|} ${3:r} ${4:g} ${5:b})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Creates a Color in a specific color space from the red, green, and blue values of another Color.')
    },
    {
        label: 'color-mix',
        func: 'color-mix(in $color-space, $color $percentage, $color $percentage)',
        insertText: 'color-mix(in ${1|srgb,srgb-linear,lab,oklab,xyz,xyz-d50,xyz-d65|}, ${3:color} ${4:percentage}, ${5:color} ${6:percentage})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Mix two colors together in a rectangular color space.')
    },
    {
        label: 'color-mix hue',
        func: 'color-mix(in $color-space $interpolation-method hue, $color $percentage, $color $percentage)',
        insertText: 'color-mix(in ${1|hsl,hwb,lch,oklch|} ${2|shorter hue,longer hue,increasing hue,decreasing hue|}, ${3:color} ${4:percentage}, ${5:color} ${6:percentage})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Mix two colors together in a polar color space.')
    },
    {
        label: 'lab',
        func: 'lab($lightness $channel_a $channel_b $alpha)',
        insertText: 'lab(${1:lightness} ${2:a} ${3:b} ${4:alpha})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('css.builtin.lab', 'Creates a Color from Lightness, Channel a, Channel b and alpha values.')
    },
    {
        label: 'lab relative',
        func: 'lab(from $color $lightness $channel_a $channel_b $alpha)',
        insertText: 'lab(from ${1:color} ${2:lightness} ${3:channel_a} ${4:channel_b} ${5:alpha})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('css.builtin.lab', 'Creates a Color from Lightness, Channel a, Channel b and alpha values of another Color.')
    },
    {
        label: 'lch',
        func: 'lch($lightness $chrome $hue $alpha)',
        insertText: 'lch(${1:lightness} ${2:chrome} ${3:hue} ${4:alpha})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('css.builtin.lab', 'Creates a Color from Lightness, Chroma, Hue and alpha values.')
    },
    {
        label: 'lch relative',
        func: 'lch(from $color $lightness $chrome $hue $alpha)',
        insertText: 'lch(from ${1:color} ${2:lightness} ${3:chrome} ${4:hue} ${5:alpha})',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('css.builtin.lab', 'Creates a Color from Lightness, Chroma, Hue and alpha values of another Color.')
    }
];
const $6be89f889e93fd15$var$colorFunctionNameRegExp = /^(?:rgba?|hsla?|hwb|lab|lch|oklab|oklch)$/iu;
const $6be89f889e93fd15$export$8f45430ccf837300 = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgrey: '#a9a9a9',
    darkgreen: '#006400',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    grey: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgrey: '#d3d3d3',
    lightgreen: '#90ee90',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370d8',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#d87093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    red: '#ff0000',
    rebeccapurple: '#663399',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
};
const $6be89f889e93fd15$var$colorsRegExp = new RegExp(`^(${Object.keys($6be89f889e93fd15$export$8f45430ccf837300).join('|')})$`, "i");
const $6be89f889e93fd15$export$3b0ad6ab62bdaba6 = {
    'currentColor': 'The value of the \'color\' property. The computed value of the \'currentColor\' keyword is the computed value of the \'color\' property. If the \'currentColor\' keyword is set on the \'color\' property itself, it is treated as \'color:inherit\' at parse time.',
    'transparent': 'Fully transparent. This keyword can be considered a shorthand for rgba(0,0,0,0) which is its computed value.'
};
const $6be89f889e93fd15$var$colorKeywordsRegExp = new RegExp(`^(${Object.keys($6be89f889e93fd15$export$3b0ad6ab62bdaba6).join('|')})$`, "i");
function $6be89f889e93fd15$var$getNumericValue(node, factor, lowerLimit = 0, upperLimit = 1) {
    const val = node.getText();
    const m = val.match(/^([-+]?[0-9]*\.?[0-9]+)(%?)$/);
    if (m) {
        if (m[2]) factor = 100.0;
        const result = parseFloat(m[1]) / factor;
        if (result >= lowerLimit && result <= upperLimit) return result;
    }
    throw new Error();
}
const $6be89f889e93fd15$var$DEGREES_PER_CIRCLE = 360; // Number of degrees in a full circle
const $6be89f889e93fd15$var$GRAD_TO_DEGREE_FACTOR = 0.9; // Conversion factor: grads to degrees
const $6be89f889e93fd15$var$RADIANS_TO_DEGREES_FACTOR = $6be89f889e93fd15$var$DEGREES_PER_CIRCLE / 2 / Math.PI; // Conversion factor: radians to degrees
function $6be89f889e93fd15$var$getAngle(node) {
    const textValue = node.getText();
    // Hue angle keyword `none` is the equivilient of `0deg`
    if (textValue === 'none') return 0;
    const m = /^(?<numberString>[-+]?[0-9]*\.?[0-9]+)(?<unit>deg|rad|grad|turn)?$/iu.exec(textValue);
    if (m?.groups?.['numberString']) {
        const value = Number.parseFloat(m.groups['numberString']);
        if (!Number.isNaN(value)) switch(m.groups['unit']){
            case 'deg':
                return value % $6be89f889e93fd15$var$DEGREES_PER_CIRCLE;
            case 'grad':
                return value * $6be89f889e93fd15$var$GRAD_TO_DEGREE_FACTOR % $6be89f889e93fd15$var$DEGREES_PER_CIRCLE;
            case 'rad':
                return value * $6be89f889e93fd15$var$RADIANS_TO_DEGREES_FACTOR % $6be89f889e93fd15$var$DEGREES_PER_CIRCLE;
            case 'turn':
                return value * $6be89f889e93fd15$var$DEGREES_PER_CIRCLE % $6be89f889e93fd15$var$DEGREES_PER_CIRCLE;
            default:
                // Unitless angles are treated as degrees
                return value % $6be89f889e93fd15$var$DEGREES_PER_CIRCLE;
        }
    }
    throw new Error(`Failed to parse '${textValue}' as angle`);
}
function $6be89f889e93fd15$export$74126c8531eff483(node) {
    const name = node.getName();
    if (!name) return false;
    return $6be89f889e93fd15$var$colorFunctionNameRegExp.test(name);
}
function $6be89f889e93fd15$export$2c8400d58aca05e(s) {
    return $6be89f889e93fd15$var$hexColorRegExp.test(s) || $6be89f889e93fd15$var$colorsRegExp.test(s) || $6be89f889e93fd15$var$colorKeywordsRegExp.test(s);
}
function $6be89f889e93fd15$export$83b472abbe13aa0(node) {
    if (node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.HexColorValue) return true;
    else if (node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Function) return $6be89f889e93fd15$export$74126c8531eff483(node);
    else if (node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Identifier) {
        if (node.parent && node.parent.type !== $bd0cebf2eccc0e7e$export$f06e977173f1857c.Term) return false;
        const candidateColor = node.getText().toLowerCase();
        if (candidateColor === 'none') return false;
        if ($6be89f889e93fd15$export$8f45430ccf837300[candidateColor]) return true;
    }
    return false;
}
const $6be89f889e93fd15$var$Digit0 = 48;
const $6be89f889e93fd15$var$Digit9 = 57;
const $6be89f889e93fd15$var$A = 65;
const $6be89f889e93fd15$var$F = 70;
const $6be89f889e93fd15$var$a = 97;
const $6be89f889e93fd15$var$f = 102;
function $6be89f889e93fd15$export$6cf91e62dabd9493(charCode) {
    if (charCode < $6be89f889e93fd15$var$Digit0) return 0;
    if (charCode <= $6be89f889e93fd15$var$Digit9) return charCode - $6be89f889e93fd15$var$Digit0;
    if (charCode < $6be89f889e93fd15$var$a) charCode += $6be89f889e93fd15$var$a - $6be89f889e93fd15$var$A;
    if (charCode >= $6be89f889e93fd15$var$a && charCode <= $6be89f889e93fd15$var$f) return charCode - $6be89f889e93fd15$var$a + 10;
    return 0;
}
function $6be89f889e93fd15$export$a630133ba548050a(text) {
    if (text[0] !== '#') return null;
    switch(text.length){
        case 4:
            return {
                red: $6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(1)) * 0x11 / 255.0,
                green: $6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(2)) * 0x11 / 255.0,
                blue: $6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(3)) * 0x11 / 255.0,
                alpha: 1
            };
        case 5:
            return {
                red: $6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(1)) * 0x11 / 255.0,
                green: $6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(2)) * 0x11 / 255.0,
                blue: $6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(3)) * 0x11 / 255.0,
                alpha: $6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(4)) * 0x11 / 255.0
            };
        case 7:
            return {
                red: ($6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(1)) * 0x10 + $6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(2))) / 255.0,
                green: ($6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(3)) * 0x10 + $6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(4))) / 255.0,
                blue: ($6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(5)) * 0x10 + $6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(6))) / 255.0,
                alpha: 1
            };
        case 9:
            return {
                red: ($6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(1)) * 0x10 + $6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(2))) / 255.0,
                green: ($6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(3)) * 0x10 + $6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(4))) / 255.0,
                blue: ($6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(5)) * 0x10 + $6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(6))) / 255.0,
                alpha: ($6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(7)) * 0x10 + $6be89f889e93fd15$export$6cf91e62dabd9493(text.charCodeAt(8))) / 255.0
            };
    }
    return null;
}
function $6be89f889e93fd15$export$93f23228815ee392(red, green, blue, alpha = 1.0) {
    return {
        red: red / 255.0,
        green: green / 255.0,
        blue: blue / 255.0,
        alpha: alpha
    };
}
function $6be89f889e93fd15$export$8d8b8422512303b1(hue, sat, light, alpha = 1.0) {
    hue = hue / 60.0;
    if (sat === 0) return {
        red: light,
        green: light,
        blue: light,
        alpha: alpha
    };
    else {
        const hueToRgb = (t1, t2, hue)=>{
            while(hue < 0)hue += 6;
            while(hue >= 6)hue -= 6;
            if (hue < 1) return (t2 - t1) * hue + t1;
            if (hue < 3) return t2;
            if (hue < 4) return (t2 - t1) * (4 - hue) + t1;
            return t1;
        };
        const t2 = light <= 0.5 ? light * (sat + 1) : light + sat - light * sat;
        const t1 = light * 2 - t2;
        return {
            red: hueToRgb(t1, t2, hue + 2),
            green: hueToRgb(t1, t2, hue),
            blue: hueToRgb(t1, t2, hue - 2),
            alpha: alpha
        };
    }
}
function $6be89f889e93fd15$export$f03b420020baf37a(rgba) {
    const r = rgba.red;
    const g = rgba.green;
    const b = rgba.blue;
    const a = rgba.alpha;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h = 0;
    let s = 0;
    const l = (min + max) / 2;
    const chroma = max - min;
    if (chroma > 0) {
        s = Math.min(l <= 0.5 ? chroma / (2 * l) : chroma / (2 - 2 * l), 1);
        switch(max){
            case r:
                h = (g - b) / chroma + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / chroma + 2;
                break;
            case b:
                h = (r - g) / chroma + 4;
                break;
        }
        h *= 60;
        h = Math.round(h);
    }
    return {
        h: h,
        s: s,
        l: l,
        a: a
    };
}
function $6be89f889e93fd15$export$fbfed8d72c2a6df7(hue, white, black, alpha = 1.0) {
    if (white + black >= 1) {
        const gray = white / (white + black);
        return {
            red: gray,
            green: gray,
            blue: gray,
            alpha: alpha
        };
    }
    const rgb = $6be89f889e93fd15$export$8d8b8422512303b1(hue, 1, 0.5, alpha);
    let red = rgb.red;
    red *= 1 - white - black;
    red += white;
    let green = rgb.green;
    green *= 1 - white - black;
    green += white;
    let blue = rgb.blue;
    blue *= 1 - white - black;
    blue += white;
    return {
        red: red,
        green: green,
        blue: blue,
        alpha: alpha
    };
}
function $6be89f889e93fd15$export$c4218b01ca351769(rgba) {
    const hsl = $6be89f889e93fd15$export$f03b420020baf37a(rgba);
    const white = Math.min(rgba.red, rgba.green, rgba.blue);
    const black = 1 - Math.max(rgba.red, rgba.green, rgba.blue);
    return {
        h: hsl.h,
        w: white,
        b: black,
        a: hsl.a
    };
}
function $6be89f889e93fd15$export$eb79e9b0816bc3(lab) {
    const xyz = {
        x: 0,
        y: 0,
        z: 0,
        alpha: lab.alpha ?? 1
    };
    xyz.y = (lab.l + 16.0) / 116.0;
    xyz.x = lab.a / 500.0 + xyz.y;
    xyz.z = xyz.y - lab.b / 200.0;
    let key;
    for(key in xyz){
        let pow = xyz[key] * xyz[key] * xyz[key];
        if (pow > 0.008856) xyz[key] = pow;
        else xyz[key] = (xyz[key] - 16.0 / 116.0) / 7.787;
    }
    xyz.x = xyz.x * 95.047;
    xyz.y = xyz.y * 100.0;
    xyz.z = xyz.z * 108.883;
    return xyz;
}
function $6be89f889e93fd15$export$5e1b5b37128c9557(lab) {
    // Convert from OKLab to XYZ
    // References: https://bottosson.github.io/posts/oklab/
    // lab.l is in 0-1 range
    // lab.a and lab.b are in -0.4 to 0.4 range
    const l = lab.l + 0.3963377774 * lab.a + 0.2158037573 * lab.b;
    const m = lab.l - 0.1055613458 * lab.a - 0.0638541728 * lab.b;
    const s = lab.l - 0.0894841775 * lab.a - 1.291485548 * lab.b;
    // Apply non-linearity using exponentiation
    const l3 = l ** 3;
    const m3 = m ** 3;
    const s3 = s ** 3;
    // Convert to XYZ
    const x = 1.2270138511 * l3 - 0.5577999807 * m3 + 0.281256149 * s3;
    const y = -0.0405801784 * l3 + 1.1122568696 * m3 - 0.0716766787 * s3;
    const z = -0.0763812845 * l3 - 0.4214819784 * m3 + 1.5861632204 * s3;
    return {
        x: x * 100,
        y: y * 100,
        z: z * 100,
        alpha: lab.alpha ?? 1
    };
}
function $6be89f889e93fd15$export$c13d93169b80b59c(xyz) {
    const x = xyz.x / 100;
    const y = xyz.y / 100;
    const z = xyz.z / 100;
    const r = 3.2406254773200533 * x - 1.5372079722103187 * y - 0.4986285986982479 * z;
    const g = -0.9689307147293197 * x + 1.8757560608852415 * y + 0.041517523842953964 * z;
    const b = 0.055710120445510616 * x + -0.2040210505984867 * y + 1.0569959422543882 * z;
    const compand = (c)=>{
        return c <= 0.0031308 ? 12.92 * c : Math.min(1.055 * Math.pow(c, 1 / 2.4) - 0.055, 1);
    };
    return {
        red: Math.round(compand(r) * 255.0),
        blue: Math.round(compand(b) * 255.0),
        green: Math.round(compand(g) * 255.0),
        alpha: xyz.alpha
    };
}
function $6be89f889e93fd15$export$4bdd18cccfc0bd9a(rgba) {
    let r = rgba.red, g = rgba.green, b = rgba.blue;
    if (r > 0.04045) r = Math.pow((r + 0.055) / 1.055, 2.4);
    else r = r / 12.92;
    if (g > 0.04045) g = Math.pow((g + 0.055) / 1.055, 2.4);
    else g = g / 12.92;
    if (b > 0.04045) b = Math.pow((b + 0.055) / 1.055, 2.4);
    else b = b / 12.92;
    r = r * 100;
    g = g * 100;
    b = b * 100;
    //Observer = 2°, Illuminant = D65
    const x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    const z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return {
        x: x,
        y: y,
        z: z,
        alpha: rgba.alpha
    };
}
function $6be89f889e93fd15$export$ce8ad80f5ca9751c(xyz, round = true) {
    const ref_X = 95.047, ref_Y = 100.000, ref_Z = 108.883;
    let x = xyz.x / ref_X, y = xyz.y / ref_Y, z = xyz.z / ref_Z;
    if (x > 0.008856) x = Math.pow(x, 1 / 3);
    else x = 7.787 * x + 16 / 116;
    if (y > 0.008856) y = Math.pow(y, 1 / 3);
    else y = 7.787 * y + 16 / 116;
    if (z > 0.008856) z = Math.pow(z, 1 / 3);
    else z = 7.787 * z + 16 / 116;
    const l = 116 * y - 16, a = 500 * (x - y), b = 200 * (y - z);
    if (round) return {
        l: Math.round((l + Number.EPSILON) * 100) / 100,
        a: Math.round((a + Number.EPSILON) * 100) / 100,
        b: Math.round((b + Number.EPSILON) * 100) / 100,
        alpha: xyz.alpha
    };
    else return {
        l: l,
        a: a,
        b: b,
        alpha: xyz.alpha
    };
}
function $6be89f889e93fd15$export$15f8c27f13f5ba9e(xyz, round = true) {
    // Convert XYZ to OKLab
    // References: https://bottosson.github.io/posts/oklab/
    // Normalize XYZ values
    const x = xyz.x / 100;
    const y = xyz.y / 100;
    const z = xyz.z / 100;
    // Convert to LMS
    const l = 0.8189330101 * x + 0.3618667424 * y - 0.1288597137 * z;
    const m = 0.0329845436 * x + 0.9293118715 * y + 0.0361456387 * z;
    const s = 0.0482003018 * x + 0.2643662691 * y + 0.633851707 * z;
    // Apply non-linearity
    const l_ = Math.cbrt(l);
    const m_ = Math.cbrt(m);
    const s_ = Math.cbrt(s);
    // Convert to OKLab
    const L = 0.2104542553 * l_ + 0.793617785 * m_ - 0.0040720468 * s_;
    const a = 1.9779984951 * l_ - 2.428592205 * m_ + 0.4505937099 * s_;
    const b = 0.0259040371 * l_ + 0.7827717662 * m_ - 0.808675766 * s_;
    return round ? {
        l: Number(L.toFixed(5)),
        a: Number(a.toFixed(5)),
        b: Number(b.toFixed(5)),
        alpha: xyz.alpha
    } : {
        l: L,
        a: a,
        b: b,
        alpha: xyz.alpha
    };
}
function $6be89f889e93fd15$export$1f07a9bd2630df0(rgba, round = true) {
    const xyz = $6be89f889e93fd15$export$4bdd18cccfc0bd9a(rgba);
    const lab = $6be89f889e93fd15$export$ce8ad80f5ca9751c(xyz, round);
    return lab;
}
function $6be89f889e93fd15$export$c7257a7157807e10(rgba, round = true) {
    const xyz = $6be89f889e93fd15$export$4bdd18cccfc0bd9a(rgba);
    const lab = $6be89f889e93fd15$export$15f8c27f13f5ba9e(xyz, round);
    // Convert lightness to a percentage of oklab
    return {
        ...lab,
        l: lab.l * 100
    };
}
/**
 * Calculate chroma and hue from Lab values
 * Returns LCH values without formatting/rounding
 */ function $6be89f889e93fd15$var$labToLCH(lab) {
    const c = Math.sqrt(Math.pow(lab.a, 2) + Math.pow(lab.b, 2));
    let h = Math.atan2(lab.b, lab.a) * $6be89f889e93fd15$var$RADIANS_TO_DEGREES_FACTOR;
    while(h < 0)h = h + 360;
    return {
        l: lab.l,
        c: c,
        h: h,
        alpha: lab.alpha
    };
}
function $6be89f889e93fd15$export$75b78f317c952420(rgba) {
    const lab = $6be89f889e93fd15$export$1f07a9bd2630df0(rgba, false);
    const lch = $6be89f889e93fd15$var$labToLCH(lab);
    return {
        l: Math.round((lch.l + Number.EPSILON) * 100) / 100,
        c: Math.round((lch.c + Number.EPSILON) * 100) / 100,
        h: Math.round((lch.h + Number.EPSILON) * 100) / 100,
        alpha: lch.alpha
    };
}
function $6be89f889e93fd15$export$831fc7e7ace3b6e0(rgba) {
    const lab = $6be89f889e93fd15$export$c7257a7157807e10(rgba, false);
    const lch = $6be89f889e93fd15$var$labToLCH(lab);
    return {
        l: Number(lch.l.toFixed(3)),
        c: Number(lch.c.toFixed(5)),
        h: Number(lch.h.toFixed(3)),
        alpha: lch.alpha
    };
}
/**
 * Generic function to convert LAB/OKLAB to Color
 */ function $6be89f889e93fd15$var$labToColor(lab, xyzConverter) {
    const xyz = xyzConverter(lab);
    const rgb = $6be89f889e93fd15$export$c13d93169b80b59c(xyz);
    return {
        red: (rgb.red >= 0 ? Math.min(rgb.red, 255) : 0) / 255,
        green: (rgb.green >= 0 ? Math.min(rgb.green, 255) : 0) / 255,
        blue: (rgb.blue >= 0 ? Math.min(rgb.blue, 255) : 0) / 255,
        alpha: lab.alpha ?? 1
    };
}
function $6be89f889e93fd15$export$dcf6ad0784b41b9b(l, a, b, alpha = 1) {
    return $6be89f889e93fd15$var$labToColor({
        l: l,
        a: a,
        b: b,
        alpha: alpha
    }, $6be89f889e93fd15$export$eb79e9b0816bc3);
}
function $6be89f889e93fd15$export$984ef7f3426b8528(l, a, b, alpha = 1) {
    return $6be89f889e93fd15$var$labToColor({
        l: l,
        a: a,
        b: b,
        alpha: alpha
    }, $6be89f889e93fd15$export$5e1b5b37128c9557);
}
const $6be89f889e93fd15$var$DEGREES_TO_RADIANS_FACTOR = Math.PI / 180;
function $6be89f889e93fd15$export$4ccb3dafd518edf6(l, c, h, alpha = 1) {
    return {
        l: l,
        a: c * Math.cos(h * $6be89f889e93fd15$var$DEGREES_TO_RADIANS_FACTOR),
        b: c * Math.sin(h * $6be89f889e93fd15$var$DEGREES_TO_RADIANS_FACTOR),
        alpha: alpha
    };
}
function $6be89f889e93fd15$export$590771d220a79dca(l, c, h, alpha = 1) {
    const lab = $6be89f889e93fd15$export$4ccb3dafd518edf6(l, c, h, alpha);
    return $6be89f889e93fd15$export$dcf6ad0784b41b9b(lab.l, lab.a, lab.b, alpha);
}
function $6be89f889e93fd15$export$3b61839f872d5275(l, c, h, alpha = 1) {
    const lab = $6be89f889e93fd15$export$4ccb3dafd518edf6(l, c, h, alpha); // Conversion is the same as LCH->LAB for OKLCH-OKLAB
    return $6be89f889e93fd15$export$984ef7f3426b8528(lab.l, lab.a, lab.b, alpha);
}
function $6be89f889e93fd15$export$50c120d4d5566287(node) {
    if (node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.HexColorValue) {
        const text = node.getText();
        return $6be89f889e93fd15$export$a630133ba548050a(text);
    } else if (node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Function) {
        const functionNode = node;
        const name = functionNode.getName();
        let colorValues = functionNode.getArguments().getChildren();
        if (colorValues.length === 1) {
            const functionArg = colorValues[0].getChildren();
            if (functionArg.length === 1 && functionArg[0].type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Expression) {
                colorValues = functionArg[0].getChildren();
                if (colorValues.length === 3) {
                    const lastValue = colorValues[2];
                    if (lastValue instanceof $bd0cebf2eccc0e7e$export$5351bc98fa48e09c) {
                        const left = lastValue.getLeft(), right = lastValue.getRight(), operator = lastValue.getOperator();
                        if (left && right && operator && operator.matches('/')) colorValues = [
                            colorValues[0],
                            colorValues[1],
                            left,
                            right
                        ];
                    }
                }
            }
        }
        if (!name || colorValues.length < 3 || colorValues.length > 4) return null;
        try {
            const alpha = colorValues.length === 4 ? $6be89f889e93fd15$var$getNumericValue(colorValues[3], 1) : 1;
            switch(name){
                case 'rgb':
                case 'rgba':
                    return {
                        red: $6be89f889e93fd15$var$getNumericValue(colorValues[0], 255),
                        green: $6be89f889e93fd15$var$getNumericValue(colorValues[1], 255),
                        blue: $6be89f889e93fd15$var$getNumericValue(colorValues[2], 255),
                        alpha: alpha
                    };
                case 'hsl':
                case 'hsla':
                    {
                        const h = $6be89f889e93fd15$var$getAngle(colorValues[0]);
                        const s = $6be89f889e93fd15$var$getNumericValue(colorValues[1], 100);
                        const l = $6be89f889e93fd15$var$getNumericValue(colorValues[2], 100);
                        return $6be89f889e93fd15$export$8d8b8422512303b1(h, s, l, alpha);
                    }
                case 'hwb':
                    {
                        const h = $6be89f889e93fd15$var$getAngle(colorValues[0]);
                        const w = $6be89f889e93fd15$var$getNumericValue(colorValues[1], 100);
                        const b = $6be89f889e93fd15$var$getNumericValue(colorValues[2], 100);
                        return $6be89f889e93fd15$export$fbfed8d72c2a6df7(h, w, b, alpha);
                    }
                case 'lab':
                    {
                        // Reference: https://mina86.com/2021/srgb-lab-lchab-conversions/
                        const l = $6be89f889e93fd15$var$getNumericValue(colorValues[0], 100);
                        // Since these two values can be negative, a lower limit of -1 has been added
                        const a = $6be89f889e93fd15$var$getNumericValue(colorValues[1], 125, -1);
                        const b = $6be89f889e93fd15$var$getNumericValue(colorValues[2], 125, -1);
                        return $6be89f889e93fd15$export$dcf6ad0784b41b9b(l * 100, a * 125, b * 125, alpha);
                    }
                case 'lch':
                    {
                        const l = $6be89f889e93fd15$var$getNumericValue(colorValues[0], 100);
                        const c = $6be89f889e93fd15$var$getNumericValue(colorValues[1], 230);
                        const h = $6be89f889e93fd15$var$getAngle(colorValues[2]);
                        return $6be89f889e93fd15$export$590771d220a79dca(l * 100, c * 230, h, alpha);
                    }
                case 'oklab':
                    {
                        const l = $6be89f889e93fd15$var$getNumericValue(colorValues[0], 1);
                        // Since these two values can be negative, a lower limit of -1 has been added
                        const a = $6be89f889e93fd15$var$getNumericValue(colorValues[1], 0.4, -1);
                        const b = $6be89f889e93fd15$var$getNumericValue(colorValues[2], 0.4, -1);
                        return $6be89f889e93fd15$export$984ef7f3426b8528(l, a * 0.4, b * 0.4, alpha);
                    }
                case 'oklch':
                    {
                        const l = $6be89f889e93fd15$var$getNumericValue(colorValues[0], 1);
                        const c = $6be89f889e93fd15$var$getNumericValue(colorValues[1], 0.4);
                        const h = $6be89f889e93fd15$var$getAngle(colorValues[2]);
                        return $6be89f889e93fd15$export$3b61839f872d5275(l, c * 0.4, h, alpha);
                    }
            }
        } catch  {
            // parse error on numeric value
            return null;
        }
    } else if (node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Identifier) {
        if (node.parent && node.parent.type !== $bd0cebf2eccc0e7e$export$f06e977173f1857c.Term) return null;
        const term = node.parent;
        if (term && term.parent && term.parent.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.BinaryExpression) {
            const expression = term.parent;
            if (expression.parent && expression.parent.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.ListEntry && expression.parent.key === expression) return null;
        }
        const candidateColor = node.getText().toLowerCase();
        if (candidateColor === 'none') return null;
        const colorHex = $6be89f889e93fd15$export$8f45430ccf837300[candidateColor];
        if (colorHex) return $6be89f889e93fd15$export$a630133ba548050a(colorHex);
    }
    return null;
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 'use strict';
const $4b3cdcd55d375778$export$6767d05f2d3f94f0 = {
    'bottom': "Computes to \u2018100%\u2019 for the vertical position if one or two values are given, otherwise specifies the bottom edge as the origin for the next offset.",
    'center': "Computes to \u201850%\u2019 (\u2018left 50%\u2019) for the horizontal position if the horizontal position is not otherwise specified, or \u201850%\u2019 (\u2018top 50%\u2019) for the vertical position if it is.",
    'left': "Computes to \u20180%\u2019 for the horizontal position if one or two values are given, otherwise specifies the left edge as the origin for the next offset.",
    'right': "Computes to \u2018100%\u2019 for the horizontal position if one or two values are given, otherwise specifies the right edge as the origin for the next offset.",
    'top': "Computes to \u20180%\u2019 for the vertical position if one or two values are given, otherwise specifies the top edge as the origin for the next offset."
};
const $4b3cdcd55d375778$export$3f9cacf8bddbd0c8 = {
    'no-repeat': 'Placed once and not repeated in this direction.',
    'repeat': 'Repeated in this direction as often as needed to cover the background painting area.',
    'repeat-x': "Computes to \u2018repeat no-repeat\u2019.",
    'repeat-y': "Computes to \u2018no-repeat repeat\u2019.",
    'round': "Repeated as often as will fit within the background positioning area. If it doesn\u2019t fit a whole number of times, it is rescaled so that it does.",
    'space': 'Repeated as often as will fit within the background positioning area without being clipped and then the images are spaced out to fill the area.'
};
const $4b3cdcd55d375778$export$c0ee9796c60d7764 = {
    'dashed': 'A series of square-ended dashes.',
    'dotted': 'A series of round dots.',
    'double': 'Two parallel solid lines with some space between them.',
    'groove': 'Looks as if it were carved in the canvas.',
    'hidden': "Same as \u2018none\u2019, but has different behavior in the border conflict resolution rules for border-collapsed tables.",
    'inset': 'Looks as if the content on the inside of the border is sunken into the canvas.',
    'none': 'No border. Color and width are ignored.',
    'outset': 'Looks as if the content on the inside of the border is coming out of the canvas.',
    'ridge': 'Looks as if it were coming out of the canvas.',
    'solid': 'A single line segment.'
};
const $4b3cdcd55d375778$export$3373907888be2284 = [
    'medium',
    'thick',
    'thin'
];
const $4b3cdcd55d375778$export$90b90bffda3be805 = {
    'border-box': 'The background is painted within (clipped to) the border box.',
    'content-box': 'The background is painted within (clipped to) the content box.',
    'padding-box': 'The background is painted within (clipped to) the padding box.'
};
const $4b3cdcd55d375778$export$c6dc41dffca85e83 = {
    'margin-box': 'Uses the margin box as reference box.',
    'fill-box': 'Uses the object bounding box as reference box.',
    'stroke-box': 'Uses the stroke bounding box as reference box.',
    'view-box': 'Uses the nearest SVG viewport as reference box.'
};
const $4b3cdcd55d375778$export$b3191e0d9e666e2c = {
    'initial': "Represents the value specified as the property\u2019s initial value.",
    'inherit': "Represents the computed value of the property on the element\u2019s parent.",
    'unset': 'Acts as either `inherit` or `initial`, depending on whether the property is inherited or not.'
};
const $4b3cdcd55d375778$export$859e4e371f252e6b = {
    'var()': 'Evaluates the value of a custom variable.',
    'calc()': 'Evaluates an mathematical expression. The following operators can be used: + - * /.'
};
const $4b3cdcd55d375778$export$c69b22a9efcf76c8 = {
    'url()': 'Reference an image file by URL',
    'image()': 'Provide image fallbacks and annotations.',
    '-webkit-image-set()': 'Provide multiple resolutions. Remember to use unprefixed image-set() in addition.',
    'image-set()': 'Provide multiple resolutions of an image and const the UA decide which is most appropriate in a given situation.',
    '-moz-element()': 'Use an element in the document as an image. Remember to use unprefixed element() in addition.',
    'element()': 'Use an element in the document as an image.',
    'cross-fade()': 'Indicates the two images to be combined and how far along in the transition the combination is.',
    '-webkit-gradient()': 'Deprecated. Use modern linear-gradient() or radial-gradient() instead.',
    '-webkit-linear-gradient()': 'Linear gradient. Remember to use unprefixed version in addition.',
    '-moz-linear-gradient()': 'Linear gradient. Remember to use unprefixed version in addition.',
    '-o-linear-gradient()': 'Linear gradient. Remember to use unprefixed version in addition.',
    'linear-gradient()': 'A linear gradient is created by specifying a straight gradient line, and then several colors placed along that line.',
    '-webkit-repeating-linear-gradient()': 'Repeating Linear gradient. Remember to use unprefixed version in addition.',
    '-moz-repeating-linear-gradient()': 'Repeating Linear gradient. Remember to use unprefixed version in addition.',
    '-o-repeating-linear-gradient()': 'Repeating Linear gradient. Remember to use unprefixed version in addition.',
    'repeating-linear-gradient()': "Same as linear-gradient, except the color-stops are repeated infinitely in both directions, with their positions shifted by multiples of the difference between the last specified color-stop\u2019s position and the first specified color-stop\u2019s position.",
    '-webkit-radial-gradient()': 'Radial gradient. Remember to use unprefixed version in addition.',
    '-moz-radial-gradient()': 'Radial gradient. Remember to use unprefixed version in addition.',
    'radial-gradient()': 'Colors emerge from a single point and smoothly spread outward in a circular or elliptical shape.',
    '-webkit-repeating-radial-gradient()': 'Repeating radial gradient. Remember to use unprefixed version in addition.',
    '-moz-repeating-radial-gradient()': 'Repeating radial gradient. Remember to use unprefixed version in addition.',
    'repeating-radial-gradient()': "Same as radial-gradient, except the color-stops are repeated infinitely in both directions, with their positions shifted by multiples of the difference between the last specified color-stop\u2019s position and the first specified color-stop\u2019s position."
};
const $4b3cdcd55d375778$export$10889f3d8c705a70 = {
    'ease': 'Equivalent to cubic-bezier(0.25, 0.1, 0.25, 1.0).',
    'ease-in': 'Equivalent to cubic-bezier(0.42, 0, 1.0, 1.0).',
    'ease-in-out': 'Equivalent to cubic-bezier(0.42, 0, 0.58, 1.0).',
    'ease-out': 'Equivalent to cubic-bezier(0, 0, 0.58, 1.0).',
    'linear': 'Equivalent to cubic-bezier(0.0, 0.0, 1.0, 1.0).',
    'step-end': 'Equivalent to steps(1, end).',
    'step-start': 'Equivalent to steps(1, start).',
    'steps()': "The first parameter specifies the number of intervals in the function. The second parameter, which is optional, is either the value \u201Cstart\u201D or \u201Cend\u201D.",
    'cubic-bezier()': 'Specifies a cubic-bezier curve. The four values specify points P1 and P2  of the curve as (x1, y1, x2, y2).',
    'cubic-bezier(0.6, -0.28, 0.735, 0.045)': 'Ease-in Back. Overshoots.',
    'cubic-bezier(0.68, -0.55, 0.265, 1.55)': 'Ease-in-out Back. Overshoots.',
    'cubic-bezier(0.175, 0.885, 0.32, 1.275)': 'Ease-out Back. Overshoots.',
    'cubic-bezier(0.6, 0.04, 0.98, 0.335)': 'Ease-in Circular. Based on half circle.',
    'cubic-bezier(0.785, 0.135, 0.15, 0.86)': 'Ease-in-out Circular. Based on half circle.',
    'cubic-bezier(0.075, 0.82, 0.165, 1)': 'Ease-out Circular. Based on half circle.',
    'cubic-bezier(0.55, 0.055, 0.675, 0.19)': 'Ease-in Cubic. Based on power of three.',
    'cubic-bezier(0.645, 0.045, 0.355, 1)': 'Ease-in-out Cubic. Based on power of three.',
    'cubic-bezier(0.215, 0.610, 0.355, 1)': 'Ease-out Cubic. Based on power of three.',
    'cubic-bezier(0.95, 0.05, 0.795, 0.035)': 'Ease-in Exponential. Based on two to the power ten.',
    'cubic-bezier(1, 0, 0, 1)': 'Ease-in-out Exponential. Based on two to the power ten.',
    'cubic-bezier(0.19, 1, 0.22, 1)': 'Ease-out Exponential. Based on two to the power ten.',
    'cubic-bezier(0.47, 0, 0.745, 0.715)': 'Ease-in Sine.',
    'cubic-bezier(0.445, 0.05, 0.55, 0.95)': 'Ease-in-out Sine.',
    'cubic-bezier(0.39, 0.575, 0.565, 1)': 'Ease-out Sine.',
    'cubic-bezier(0.55, 0.085, 0.68, 0.53)': 'Ease-in Quadratic. Based on power of two.',
    'cubic-bezier(0.455, 0.03, 0.515, 0.955)': 'Ease-in-out Quadratic. Based on power of two.',
    'cubic-bezier(0.25, 0.46, 0.45, 0.94)': 'Ease-out Quadratic. Based on power of two.',
    'cubic-bezier(0.895, 0.03, 0.685, 0.22)': 'Ease-in Quartic. Based on power of four.',
    'cubic-bezier(0.77, 0, 0.175, 1)': 'Ease-in-out Quartic. Based on power of four.',
    'cubic-bezier(0.165, 0.84, 0.44, 1)': 'Ease-out Quartic. Based on power of four.',
    'cubic-bezier(0.755, 0.05, 0.855, 0.06)': 'Ease-in Quintic. Based on power of five.',
    'cubic-bezier(0.86, 0, 0.07, 1)': 'Ease-in-out Quintic. Based on power of five.',
    'cubic-bezier(0.23, 1, 0.320, 1)': 'Ease-out Quintic. Based on power of five.'
};
const $4b3cdcd55d375778$export$1282eb203ed8dd05 = {
    'circle()': 'Defines a circle.',
    'ellipse()': 'Defines an ellipse.',
    'inset()': 'Defines an inset rectangle.',
    'polygon()': 'Defines a polygon.'
};
const $4b3cdcd55d375778$export$fe0319385f0cf5a7 = {
    'length': [
        'cap',
        'ch',
        'cm',
        'cqb',
        'cqh',
        'cqi',
        'cqmax',
        'cqmin',
        'cqw',
        'dvb',
        'dvh',
        'dvi',
        'dvw',
        'em',
        'ex',
        'ic',
        'in',
        'lh',
        'lvb',
        'lvh',
        'lvi',
        'lvw',
        'mm',
        'pc',
        'pt',
        'px',
        'q',
        'rcap',
        'rch',
        'rem',
        'rex',
        'ric',
        'rlh',
        'svb',
        'svh',
        'svi',
        'svw',
        'vb',
        'vh',
        'vi',
        'vmax',
        'vmin',
        'vw'
    ],
    'angle': [
        'deg',
        'rad',
        'grad',
        'turn'
    ],
    'time': [
        'ms',
        's'
    ],
    'frequency': [
        'Hz',
        'kHz'
    ],
    'resolution': [
        'dpi',
        'dpcm',
        'dppx'
    ],
    'percentage': [
        '%',
        'fr'
    ]
};
const $4b3cdcd55d375778$export$a5b0ceca3b8901d2 = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rb',
    'rp',
    'rt',
    'rtc',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'const',
    'video',
    'wbr'
];
const $4b3cdcd55d375778$export$cf20112a1bc148da = [
    'circle',
    'clipPath',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'foreignObject',
    'g',
    'hatch',
    'hatchpath',
    'image',
    'line',
    'linearGradient',
    'marker',
    'mask',
    'mesh',
    'meshpatch',
    'meshrow',
    'metadata',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'set',
    'solidcolor',
    'stop',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'tspan',
    'use',
    'view'
];
const $4b3cdcd55d375778$export$3919b86686ec6946 = [
    '@bottom-center',
    '@bottom-left',
    '@bottom-left-corner',
    '@bottom-right',
    '@bottom-right-corner',
    '@left-bottom',
    '@left-middle',
    '@left-top',
    '@right-bottom',
    '@right-middle',
    '@right-top',
    '@top-center',
    '@top-left',
    '@top-left-corner',
    '@top-right',
    '@top-right-corner'
];


'use strict';


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 'use strict';
function $e213756046234466$export$68c286be0e7e55b7(obj) {
    return Object.keys(obj).map((key)=>obj[key]);
}
function $e213756046234466$export$4e62c701997796c1(obj) {
    return typeof obj !== 'undefined';
}


'use strict';
class $48c6713331b54e18$export$7acfa6ed01010e37 {
    constructor(scnr = new (0, $2a533f0146ced75e$export$2da42535f3a161df)()){
        this.keyframeRegex = /^@(\-(webkit|ms|moz|o)\-)?keyframes$/i;
        this.scanner = scnr;
        this.token = {
            type: (0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF,
            offset: -1,
            len: 0,
            text: ''
        };
        this.prevToken = undefined;
    }
    peekIdent(text) {
        return (0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident === this.token.type && text.length === this.token.text.length && text === this.token.text.toLowerCase();
    }
    peekKeyword(text) {
        return (0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword === this.token.type && text.length === this.token.text.length && text === this.token.text.toLowerCase();
    }
    peekDelim(text) {
        return (0, $2a533f0146ced75e$export$f435f793048e7a0f).Delim === this.token.type && text === this.token.text;
    }
    peek(type) {
        return type === this.token.type;
    }
    peekOne(...types) {
        return types.indexOf(this.token.type) !== -1;
    }
    peekRegExp(type, regEx) {
        if (type !== this.token.type) return false;
        return regEx.test(this.token.text);
    }
    hasWhitespace() {
        return !!this.prevToken && this.prevToken.offset + this.prevToken.len !== this.token.offset;
    }
    consumeToken() {
        this.prevToken = this.token;
        this.token = this.scanner.scan();
    }
    acceptUnicodeRange() {
        const token = this.scanner.tryScanUnicode();
        if (token) {
            this.prevToken = token;
            this.token = this.scanner.scan();
            return true;
        }
        return false;
    }
    mark() {
        return {
            prev: this.prevToken,
            curr: this.token,
            pos: this.scanner.pos()
        };
    }
    restoreAtMark(mark) {
        this.prevToken = mark.prev;
        this.token = mark.curr;
        this.scanner.goBackTo(mark.pos);
    }
    try(func) {
        const pos = this.mark();
        const node = func();
        if (!node) {
            this.restoreAtMark(pos);
            return null;
        }
        return node;
    }
    acceptOneKeyword(keywords) {
        if ((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword === this.token.type) {
            for (const keyword of keywords)if (keyword.length === this.token.text.length && keyword === this.token.text.toLowerCase()) {
                this.consumeToken();
                return true;
            }
        }
        return false;
    }
    accept(type) {
        if (type === this.token.type) {
            this.consumeToken();
            return true;
        }
        return false;
    }
    acceptIdent(text) {
        if (this.peekIdent(text)) {
            this.consumeToken();
            return true;
        }
        return false;
    }
    acceptKeyword(text) {
        if (this.peekKeyword(text)) {
            this.consumeToken();
            return true;
        }
        return false;
    }
    acceptDelim(text) {
        if (this.peekDelim(text)) {
            this.consumeToken();
            return true;
        }
        return false;
    }
    acceptRegexp(regEx) {
        if (regEx.test(this.token.text)) {
            this.consumeToken();
            return true;
        }
        return false;
    }
    _parseRegexp(regEx) {
        let node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.Identifier);
        do ;
        while (this.acceptRegexp(regEx));
        return this.finish(node);
    }
    acceptUnquotedString() {
        const pos = this.scanner.pos();
        this.scanner.goBackTo(this.token.offset);
        const unquoted = this.scanner.scanUnquotedString();
        if (unquoted) {
            this.token = unquoted;
            this.consumeToken();
            return true;
        }
        this.scanner.goBackTo(pos);
        return false;
    }
    resync(resyncTokens, resyncStopTokens) {
        while(true){
            if (resyncTokens && resyncTokens.indexOf(this.token.type) !== -1) {
                this.consumeToken();
                return true;
            } else if (resyncStopTokens && resyncStopTokens.indexOf(this.token.type) !== -1) return true;
            else {
                if (this.token.type === (0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF) return false;
                this.token = this.scanner.scan();
            }
        }
    }
    createNode(nodeType) {
        return new $bd0cebf2eccc0e7e$export$85c928794f8d04d4(this.token.offset, this.token.len, nodeType);
    }
    create(ctor) {
        return new ctor(this.token.offset, this.token.len);
    }
    finish(node, error, resyncTokens, resyncStopTokens) {
        // parseNumeric misuses error for boolean flagging (however the real error mustn't be a false)
        // + nodelist offsets mustn't be modified, because there is a offset hack in rulesets for smartselection
        if (!(node instanceof $bd0cebf2eccc0e7e$export$607901bfe20d7337)) {
            if (error) this.markError(node, error, resyncTokens, resyncStopTokens);
            // set the node end position
            if (this.prevToken) {
                // length with more elements belonging together
                const prevEnd = this.prevToken.offset + this.prevToken.len;
                node.length = prevEnd > node.offset ? prevEnd - node.offset : 0; // offset is taken from current token, end from previous: Use 0 for empty nodes
            }
        }
        return node;
    }
    markError(node, error, resyncTokens, resyncStopTokens) {
        if (this.token !== this.lastErrorToken) {
            node.addIssue(new $bd0cebf2eccc0e7e$export$e98856a975cab58e(node, error, $bd0cebf2eccc0e7e$export$ca664994d1d54bff.Error, undefined, this.token.offset, this.token.len));
            this.lastErrorToken = this.token;
        }
        if (resyncTokens || resyncStopTokens) this.resync(resyncTokens, resyncStopTokens);
    }
    parseStylesheet(textDocument) {
        const versionId = textDocument.version;
        const text = textDocument.getText();
        const textProvider = (offset, length)=>{
            if (textDocument.version !== versionId) throw new Error('Underlying model has changed, AST is no longer valid');
            return text.substr(offset, length);
        };
        return this.internalParse(text, this._parseStylesheet, textProvider);
    }
    internalParse(input, parseFunc, textProvider) {
        this.scanner.setSource(input);
        this.token = this.scanner.scan();
        const node = parseFunc.bind(this)();
        if (node) {
            if (textProvider) node.textProvider = textProvider;
            else node.textProvider = (offset, length)=>{
                return input.substr(offset, length);
            };
        }
        return node;
    }
    _parseStylesheet() {
        const node = this.create($bd0cebf2eccc0e7e$export$cd02bf5de16fbd7c);
        while(node.addChild(this._parseStylesheetStart()));
        let inRecovery = false;
        do {
            let hasMatch = false;
            do {
                hasMatch = false;
                const statement = this._parseStylesheetStatement();
                if (statement) {
                    node.addChild(statement);
                    hasMatch = true;
                    inRecovery = false;
                    if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF) && this._needsSemicolonAfter(statement) && !this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)) this.markError(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).SemiColonExpected);
                }
                while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon) || this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).CDO) || this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).CDC)){
                    // accept empty statements
                    hasMatch = true;
                    inRecovery = false;
                }
            }while (hasMatch);
            if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF)) break;
            if (!inRecovery) {
                if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword)) this.markError(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).UnknownAtRule);
                else this.markError(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RuleOrSelectorExpected);
                inRecovery = true;
            }
            this.consumeToken();
        }while (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF));
        return this.finish(node);
    }
    _parseStylesheetStart() {
        return this._parseCharset();
    }
    _parseStylesheetStatement(isNested = false) {
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword)) return this._parseStylesheetAtStatement(isNested);
        return this._parseRuleset(isNested);
    }
    _parseStylesheetAtStatement(isNested = false) {
        return this._parseImport() || this._parseMedia(isNested) || this._parseScope() || this._parsePage() || this._parseFontFace() || this._parseKeyframe() || this._parseSupports(isNested) || this._parseLayer(isNested) || this._parsePropertyAtRule() || this._parseViewPort() || this._parseNamespace() || this._parseDocument() || this._parseContainer(isNested) || this._parseStartingStyleAtRule(isNested) || this._parseUnknownAtRule();
    }
    _tryParseRuleset(isNested) {
        const mark = this.mark();
        if (this._parseSelector(isNested)) {
            while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma) && this._parseSelector(isNested));
            if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL)) {
                this.restoreAtMark(mark);
                return this._parseRuleset(isNested);
            }
        }
        this.restoreAtMark(mark);
        return null;
    }
    _parseRuleset(isNested = false) {
        const node = this.create($bd0cebf2eccc0e7e$export$ade1230f1a17327c);
        const selectors = node.getSelectors();
        if (!selectors.addChild(this._parseSelector(isNested))) return null;
        while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
            if (!selectors.addChild(this._parseSelector(isNested))) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).SelectorExpected);
        }
        return this._parseBody(node, this._parseRuleSetDeclaration.bind(this));
    }
    _parseRuleSetDeclarationAtStatement() {
        return this._parseMedia(true) || this._parseScope() || this._parseSupports(true) || this._parseLayer(true) || this._parseContainer(true) || this._parseStartingStyleAtRule(true) || this._parseUnknownAtRule();
    }
    _parseRuleSetDeclaration() {
        // https://www.w3.org/TR/css-syntax-3/#consume-a-list-of-declarations
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword)) return this._parseRuleSetDeclarationAtStatement();
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident)) return this._parseRuleset(true);
        return this._tryParseRuleset(true) || this._parseDeclaration();
    }
    _needsSemicolonAfter(node) {
        switch(node.type){
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Keyframe:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.ViewPort:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Media:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Ruleset:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Namespace:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.If:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.For:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Each:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.While:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.MixinDeclaration:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.FunctionDeclaration:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.MixinContentDeclaration:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Scope:
                return false;
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.ExtendsReference:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.MixinContentReference:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.ReturnStatement:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.MediaQuery:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Debug:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Import:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.AtApplyRule:
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.CustomPropertyDeclaration:
                return true;
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.VariableDeclaration:
                return node.needsSemicolon;
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.MixinReference:
                return !node.getContent();
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Declaration:
                return !node.getNestedProperties();
        }
        return false;
    }
    _parseDeclarations(parseDeclaration) {
        const node = this.create($bd0cebf2eccc0e7e$export$86a08221bdddb90c);
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL)) return null;
        let decl = parseDeclaration();
        while(node.addChild(decl)){
            if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR)) break;
            if (this._needsSemicolonAfter(decl) && !this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).SemiColonExpected, [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon,
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
            ]);
            // We accepted semicolon token. Link it to declaration.
            if (decl && this.prevToken && this.prevToken.type === (0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon) decl.semicolonPosition = this.prevToken.offset;
            while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon));
            decl = parseDeclaration();
        }
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightCurlyExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR,
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon
        ]);
        return this.finish(node);
    }
    _parseBody(node, parseDeclaration) {
        if (!node.setDeclarations(this._parseDeclarations(parseDeclaration))) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftCurlyExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR,
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon
        ]);
        return this.finish(node);
    }
    _parseSelector(isNested) {
        const node = this.create($bd0cebf2eccc0e7e$export$d15f4cd5286f9b1e);
        let hasContent = false;
        if (isNested) // nested selectors can start with a combinator
        hasContent = node.addChild(this._parseCombinator());
        while(node.addChild(this._parseSimpleSelector())){
            hasContent = true;
            node.addChild(this._parseCombinator()); // optional
        }
        return hasContent ? this.finish(node) : null;
    }
    _parseDeclaration(stopTokens) {
        const customProperty = this._tryParseCustomPropertyDeclaration(stopTokens);
        if (customProperty) return customProperty;
        const node = this.create($bd0cebf2eccc0e7e$export$48f3d9e786303b67);
        if (!node.setProperty(this._parseProperty())) return null;
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ColonExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon
        ], stopTokens || [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon
        ]);
        if (this.prevToken) node.colonPosition = this.prevToken.offset;
        if (!node.setValue(this._parseExpr())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).PropertyValueExpected);
        node.addChild(this._parsePrio());
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)) node.semicolonPosition = this.token.offset; // not part of the declaration, but useful information for code assist
        return this.finish(node);
    }
    _tryParseCustomPropertyDeclaration(stopTokens) {
        if (!this.peekRegExp((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident, /^--/)) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$9eb29e7be34fda47);
        if (!node.setProperty(this._parseProperty())) return null;
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ColonExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon
        ]);
        if (this.prevToken) node.colonPosition = this.prevToken.offset;
        const mark = this.mark();
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL)) {
            // try to parse it as nested declaration
            const propertySet = this.create($bd0cebf2eccc0e7e$export$bb5dbf44b0a48bac);
            const declarations = this._parseDeclarations(this._parseRuleSetDeclaration.bind(this));
            if (propertySet.setDeclarations(declarations) && !declarations.isErroneous(true)) {
                propertySet.addChild(this._parsePrio());
                if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)) {
                    this.finish(propertySet);
                    node.setPropertySet(propertySet);
                    node.semicolonPosition = this.token.offset; // not part of the declaration, but useful information for code assist
                    return this.finish(node);
                }
            }
            this.restoreAtMark(mark);
        }
        // try to parse as expression
        const expression = this._parseExpr();
        if (expression && !expression.isErroneous(true)) {
            this._parsePrio();
            if (this.peekOne(...stopTokens || [], (0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon, (0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF)) {
                node.setValue(expression);
                if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)) node.semicolonPosition = this.token.offset; // not part of the declaration, but useful information for code assist
                return this.finish(node);
            }
        }
        this.restoreAtMark(mark);
        node.addChild(this._parseCustomPropertyValue(stopTokens));
        node.addChild(this._parsePrio());
        if ((0, $e213756046234466$export$4e62c701997796c1)(node.colonPosition) && this.token.offset === node.colonPosition + 1) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).PropertyValueExpected);
        return this.finish(node);
    }
    /**
     * Parse custom property values.
     *
     * Based on https://www.w3.org/TR/css-variables/#syntax
     *
     * This code is somewhat unusual, as the allowed syntax is incredibly broad,
     * parsing almost any sequence of tokens, save for a small set of exceptions.
     * Unbalanced delimitors, invalid tokens, and declaration
     * terminators like semicolons and !important directives (when not inside
     * of delimitors).
     */ _parseCustomPropertyValue(stopTokens = [
        (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
    ]) {
        const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
        const isTopLevel = ()=>curlyDepth === 0 && parensDepth === 0 && bracketsDepth === 0;
        const onStopToken = ()=>stopTokens.indexOf(this.token.type) !== -1;
        let curlyDepth = 0;
        let parensDepth = 0;
        let bracketsDepth = 0;
        done: while(true){
            switch(this.token.type){
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon:
                    // A semicolon only ends things if we're not inside a delimitor.
                    if (isTopLevel()) break done;
                    break;
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).Exclamation:
                    // An exclamation ends the value if we're not inside delims.
                    if (isTopLevel()) break done;
                    break;
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL:
                    curlyDepth++;
                    break;
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR:
                    curlyDepth--;
                    if (curlyDepth < 0) {
                        // The property value has been terminated without a semicolon, and
                        // this is the last declaration in the ruleset.
                        if (onStopToken() && parensDepth === 0 && bracketsDepth === 0) break done;
                        return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftCurlyExpected);
                    }
                    break;
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL:
                    parensDepth++;
                    break;
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR:
                    parensDepth--;
                    if (parensDepth < 0) {
                        if (onStopToken() && bracketsDepth === 0 && curlyDepth === 0) break done;
                        return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftParenthesisExpected);
                    }
                    break;
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).BracketL:
                    bracketsDepth++;
                    break;
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).BracketR:
                    bracketsDepth--;
                    if (bracketsDepth < 0) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftSquareBracketExpected);
                    break;
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).BadString:
                    break done;
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF:
                    // We shouldn't have reached the end of input, something is
                    // unterminated.
                    let error = (0, $053a694fcaa2117c$export$f9c837a54db411d).RightCurlyExpected;
                    if (bracketsDepth > 0) error = (0, $053a694fcaa2117c$export$f9c837a54db411d).RightSquareBracketExpected;
                    else if (parensDepth > 0) error = (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected;
                    return this.finish(node, error);
            }
            this.consumeToken();
        }
        return this.finish(node);
    }
    _tryToParseDeclaration(stopTokens) {
        const mark = this.mark();
        if (this._parseProperty() && this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) {
            // looks like a declaration, go ahead
            this.restoreAtMark(mark);
            return this._parseDeclaration(stopTokens);
        }
        this.restoreAtMark(mark);
        return null;
    }
    _parseProperty() {
        const node = this.create($bd0cebf2eccc0e7e$export$41b04b3a73e7216d);
        const mark = this.mark();
        if (this.acceptDelim('*') || this.acceptDelim('_')) // support for  IE 5.x, 6 and 7 star hack: see http://en.wikipedia.org/wiki/CSS_filter#Star_hack
        {
            if (this.hasWhitespace()) {
                this.restoreAtMark(mark);
                return null;
            }
        }
        if (node.setIdentifier(this._parsePropertyIdentifier())) return this.finish(node);
        return null;
    }
    _parsePropertyIdentifier() {
        return this._parseIdent();
    }
    _parseCharset() {
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Charset)) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
        this.consumeToken(); // charset
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).String)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected);
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).SemiColonExpected);
        return this.finish(node);
    }
    _parseImport() {
        // @import [ <url> | <string> ]
        //     [ layer | layer(<layer-name>) ]?
        //     <import-condition> ;
        // <import-conditions> = [ supports( [ <supports-condition> | <declaration> ] ) ]?
        //                      <media-query-list>?
        if (!this.peekKeyword('@import')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$d0dbb306591aec74);
        this.consumeToken(); // @import
        if (!node.addChild(this._parseURILiteral()) && !node.addChild(this._parseStringLiteral())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).URIOrStringExpected);
        return this._completeParseImport(node);
    }
    _completeParseImport(node) {
        if (this.acceptIdent('layer')) {
            if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
                if (!node.addChild(this._parseLayerName())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected, [
                    (0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon
                ]);
                if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected, [
                    (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR
                ], []);
            }
        }
        if (this.acceptIdent('supports')) {
            if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
                node.addChild(this._tryToParseDeclaration() || this._parseSupportsCondition());
                if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected, [
                    (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR
                ], []);
            }
        }
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon) && !this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF)) node.setMedialist(this._parseMediaQueryList());
        return this.finish(node);
    }
    _parseNamespace() {
        // http://www.w3.org/TR/css3-namespace/
        // namespace  : NAMESPACE_SYM S* [IDENT S*]? [STRING|URI] S* ';' S*
        if (!this.peekKeyword('@namespace')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$f89ac22183df46e9);
        this.consumeToken(); // @namespace
        if (!node.addChild(this._parseURILiteral())) {
            node.addChild(this._parseIdent()); // optional prefix
            if (!node.addChild(this._parseURILiteral()) && !node.addChild(this._parseStringLiteral())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).URIExpected, [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon
            ]);
        }
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).SemiColonExpected);
        return this.finish(node);
    }
    _parseFontFace() {
        if (!this.peekKeyword('@font-face')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$2e039772bf0d47a5);
        this.consumeToken(); // @font-face
        return this._parseBody(node, this._parseRuleSetDeclaration.bind(this));
    }
    _parseViewPort() {
        if (!this.peekKeyword('@-ms-viewport') && !this.peekKeyword('@-o-viewport') && !this.peekKeyword('@viewport')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$15d36fc1a69ab4a0);
        this.consumeToken(); // @-ms-viewport
        return this._parseBody(node, this._parseRuleSetDeclaration.bind(this));
    }
    _parseKeyframe() {
        if (!this.peekRegExp((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword, this.keyframeRegex)) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$7b3cfeb4fa34c97f);
        const atNode = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
        this.consumeToken(); // atkeyword
        node.setKeyword(this.finish(atNode));
        if (atNode.matches('@-ms-keyframes')) this.markError(atNode, (0, $053a694fcaa2117c$export$f9c837a54db411d).UnknownKeyword);
        if (!node.setIdentifier(this._parseKeyframeIdent())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
        ]);
        return this._parseBody(node, this._parseKeyframeSelector.bind(this));
    }
    _parseKeyframeIdent() {
        return this._parseIdent([
            $bd0cebf2eccc0e7e$export$8868dff548d048cf.Keyframe
        ]);
    }
    _parseKeyframeSelector() {
        const node = this.create($bd0cebf2eccc0e7e$export$8e0f67d7f8836b42);
        let hasContent = false;
        if (node.addChild(this._parseIdent())) hasContent = true;
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Percentage)) hasContent = true;
        if (!hasContent) return null;
        while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
            hasContent = false;
            if (node.addChild(this._parseIdent())) hasContent = true;
            if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Percentage)) hasContent = true;
            if (!hasContent) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).PercentageExpected);
        }
        return this._parseBody(node, this._parseRuleSetDeclaration.bind(this));
    }
    _tryParseKeyframeSelector() {
        const node = this.create($bd0cebf2eccc0e7e$export$8e0f67d7f8836b42);
        const pos = this.mark();
        let hasContent = false;
        if (node.addChild(this._parseIdent())) hasContent = true;
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Percentage)) hasContent = true;
        if (!hasContent) return null;
        while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
            hasContent = false;
            if (node.addChild(this._parseIdent())) hasContent = true;
            if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Percentage)) hasContent = true;
            if (!hasContent) {
                this.restoreAtMark(pos);
                return null;
            }
        }
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL)) {
            this.restoreAtMark(pos);
            return null;
        }
        return this._parseBody(node, this._parseRuleSetDeclaration.bind(this));
    }
    _parsePropertyAtRule() {
        // @property <custom-property-name> {
        // 	<declaration-list>
        //  }
        if (!this.peekKeyword('@property')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$c856fef2b997f0ca);
        this.consumeToken(); // @layer
        if (!this.peekRegExp((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident, /^--/) || !node.setName(this._parseIdent([
            $bd0cebf2eccc0e7e$export$8868dff548d048cf.Property
        ]))) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected);
        return this._parseBody(node, this._parseDeclaration.bind(this));
    }
    _parseStartingStyleAtRule(isNested = false) {
        if (!this.peekKeyword("@starting-style")) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$1b503fb31829e5d9);
        this.consumeToken(); // @starting-style
        return this._parseBody(node, this._parseStartingStyleDeclaration.bind(this, isNested));
    }
    // this method is the same as ._parseContainerDeclaration()
    // which is the same as ._parseMediaDeclaration(),
    // _parseSupportsDeclaration, and ._parseLayerDeclaration()
    _parseStartingStyleDeclaration(isNested = false) {
        if (isNested) // if nested, the body can contain rulesets, but also declarations
        return this._tryParseRuleset(true) || this._tryToParseDeclaration() || this._parseStylesheetStatement(true);
        return this._parseStylesheetStatement(false);
    }
    _parseLayer(isNested = false) {
        // @layer layer-name {rules}
        // @layer layer-name;
        // @layer layer-name, layer-name, layer-name;
        // @layer {rules}
        if (!this.peekKeyword('@layer')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$936d0764594b6eb3);
        this.consumeToken(); // @layer
        const names = this._parseLayerNameList();
        if (names) node.setNames(names);
        if ((!names || names.getChildren().length === 1) && this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL)) return this._parseBody(node, this._parseLayerDeclaration.bind(this, isNested));
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).SemiColonExpected);
        return this.finish(node);
    }
    _parseLayerDeclaration(isNested = false) {
        if (isNested) // if nested, the body can contain rulesets, but also declarations
        return this._tryParseRuleset(true) || this._tryToParseDeclaration() || this._parseStylesheetStatement(true);
        return this._parseStylesheetStatement(false);
    }
    _parseLayerNameList() {
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.LayerNameList);
        if (!node.addChild(this._parseLayerName())) return null;
        while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
            if (!node.addChild(this._parseLayerName())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected);
        }
        return this.finish(node);
    }
    _parseLayerName() {
        // <layer-name> = <ident> [ '.' <ident> ]*
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.LayerName);
        if (!node.addChild(this._parseIdent())) return null;
        while(!this.hasWhitespace() && this.acceptDelim('.')){
            if (this.hasWhitespace() || !node.addChild(this._parseIdent())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected);
        }
        return this.finish(node);
    }
    _parseSupports(isNested = false) {
        // SUPPORTS_SYM S* supports_condition '{' S* ruleset* '}' S*
        if (!this.peekKeyword('@supports')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$25be9502477c137d);
        this.consumeToken(); // @supports
        node.addChild(this._parseSupportsCondition());
        return this._parseBody(node, this._parseSupportsDeclaration.bind(this, isNested));
    }
    _parseSupportsDeclaration(isNested = false) {
        if (isNested) // if nested, the body can contain rulesets, but also declarations
        return this._tryParseRuleset(true) || this._tryToParseDeclaration() || this._parseStylesheetStatement(true);
        return this._parseStylesheetStatement(false);
    }
    _parseSupportsCondition() {
        // supports_condition : supports_negation | supports_conjunction | supports_disjunction | supports_condition_in_parens ;
        // supports_condition_in_parens: ( '(' S* supports_condition S* ')' ) | supports_declaration_condition | general_enclosed ;
        // supports_negation: NOT S+ supports_condition_in_parens ;
        // supports_conjunction: supports_condition_in_parens ( S+ AND S+ supports_condition_in_parens )+;
        // supports_disjunction: supports_condition_in_parens ( S+ OR S+ supports_condition_in_parens )+;
        // supports_declaration_condition: '(' S* declaration ')';
        // general_enclosed: ( FUNCTION | '(' ) ( any | unused )* ')' ;
        const node = this.create($bd0cebf2eccc0e7e$export$a895090a19988f16);
        if (this.acceptIdent('not')) node.addChild(this._parseSupportsConditionInParens());
        else {
            node.addChild(this._parseSupportsConditionInParens());
            if (this.peekRegExp((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident, /^(and|or)$/i)) {
                const text = this.token.text.toLowerCase();
                while(this.acceptIdent(text))node.addChild(this._parseSupportsConditionInParens());
            }
        }
        return this.finish(node);
    }
    _parseSupportsConditionInParens() {
        const node = this.create($bd0cebf2eccc0e7e$export$a895090a19988f16);
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            if (this.prevToken) node.lParent = this.prevToken.offset;
            if (!node.addChild(this._tryToParseDeclaration([
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR
            ]))) {
                if (!this._parseSupportsCondition()) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ConditionExpected);
            }
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected, [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR
            ], []);
            if (this.prevToken) node.rParent = this.prevToken.offset;
            return this.finish(node);
        } else if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident)) {
            const pos = this.mark();
            this.consumeToken();
            if (!this.hasWhitespace() && this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
                let openParentCount = 1;
                while(this.token.type !== (0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF && openParentCount !== 0){
                    if (this.token.type === (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL) openParentCount++;
                    else if (this.token.type === (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR) openParentCount--;
                    this.consumeToken();
                }
                return this.finish(node);
            } else this.restoreAtMark(pos);
        }
        return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftParenthesisExpected, [], [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL
        ]);
    }
    _parseMediaDeclaration(isNested = false) {
        if (isNested) // if nested, the body can contain rulesets, but also declarations
        return this._tryParseRuleset(true) || this._tryToParseDeclaration() || this._parseStylesheetStatement(true);
        return this._parseStylesheetStatement(false);
    }
    _parseMedia(isNested = false) {
        // MEDIA_SYM S* media_query_list '{' S* ruleset* '}' S*
        // media_query_list : S* [media_query [ ',' S* media_query ]* ]?
        if (!this.peekKeyword('@media')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$7fc53215244aec38);
        this.consumeToken(); // @media
        if (!node.addChild(this._parseMediaQueryList())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).MediaQueryExpected);
        return this._parseBody(node, this._parseMediaDeclaration.bind(this, isNested));
    }
    _parseMediaQueryList() {
        const node = this.create($bd0cebf2eccc0e7e$export$7143f4602d24ccbd);
        if (!node.addChild(this._parseMediaQuery())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).MediaQueryExpected);
        while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
            if (!node.addChild(this._parseMediaQuery())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).MediaQueryExpected);
        }
        return this.finish(node);
    }
    _parseMediaQuery() {
        // <media-query> = <media-condition> | [ not | only ]? <media-type> [ and <media-condition-without-or> ]?
        const node = this.create($bd0cebf2eccc0e7e$export$b745838c41029eb3);
        const pos = this.mark();
        this.acceptIdent('not');
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            this.acceptIdent('only');
            if (!node.addChild(this._parseIdent())) return null;
            if (this.acceptIdent('and')) node.addChild(this._parseMediaCondition());
        } else {
            this.restoreAtMark(pos); // 'not' is part of the MediaCondition
            node.addChild(this._parseMediaCondition());
        }
        return this.finish(node);
    }
    _parseRatio() {
        const pos = this.mark();
        const node = this.create($bd0cebf2eccc0e7e$export$c67c8344288de6f6);
        if (!this._parseNumeric()) return null;
        if (!this.acceptDelim('/')) {
            this.restoreAtMark(pos);
            return null;
        }
        if (!this._parseNumeric()) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).NumberExpected);
        return this.finish(node);
    }
    _parseMediaCondition() {
        // <media-condition> = <media-not> | <media-and> | <media-or> | <media-in-parens>
        // <media-not> = not <media-in-parens>
        // <media-and> = <media-in-parens> [ and <media-in-parens> ]+
        // <media-or> = <media-in-parens> [ or <media-in-parens> ]+
        // <media-in-parens> = ( <media-condition> ) | <media-feature> | <general-enclosed>
        const node = this.create($bd0cebf2eccc0e7e$export$9b8dfe638de9b72f);
        this.acceptIdent('not');
        let parseExpression = true;
        while(parseExpression){
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftParenthesisExpected, [], [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL
            ]);
            if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL) || this.peekIdent('not')) // <media-condition>
            node.addChild(this._parseMediaCondition());
            else node.addChild(this._parseMediaFeature());
            // not yet implemented: general enclosed
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected, [], [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL
            ]);
            parseExpression = this.acceptIdent('and') || this.acceptIdent('or');
        }
        return this.finish(node);
    }
    _parseMediaFeature() {
        const resyncStopToken = [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR
        ];
        const node = this.create($bd0cebf2eccc0e7e$export$a38b0f36e6ad18cf);
        // <media-feature> = ( [ <mf-plain> | <mf-boolean> | <mf-range> ] )
        // <mf-plain> = <mf-name> : <mf-value>
        // <mf-boolean> = <mf-name>
        // <mf-range> = <mf-name> [ '<' | '>' ]? '='? <mf-value> | <mf-value> [ '<' | '>' ]? '='? <mf-name> | <mf-value> '<' '='? <mf-name> '<' '='? <mf-value> | <mf-value> '>' '='? <mf-name> '>' '='? <mf-value>
        if (node.addChild(this._parseMediaFeatureName())) {
            if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) {
                if (!node.addChild(this._parseMediaFeatureValue())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).TermExpected, [], resyncStopToken);
            } else if (this._parseMediaFeatureRangeOperator()) {
                if (!node.addChild(this._parseMediaFeatureValue())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).TermExpected, [], resyncStopToken);
                if (this._parseMediaFeatureRangeOperator()) {
                    if (!node.addChild(this._parseMediaFeatureValue())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).TermExpected, [], resyncStopToken);
                }
            }
        } else if (node.addChild(this._parseMediaFeatureValue())) {
            if (!this._parseMediaFeatureRangeOperator()) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).OperatorExpected, [], resyncStopToken);
            if (!node.addChild(this._parseMediaFeatureName())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected, [], resyncStopToken);
            if (this._parseMediaFeatureRangeOperator()) {
                if (!node.addChild(this._parseMediaFeatureValue())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).TermExpected, [], resyncStopToken);
            }
        } else return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected, [], resyncStopToken);
        return this.finish(node);
    }
    _parseMediaFeatureRangeOperator() {
        if (this.acceptDelim('<') || this.acceptDelim('>')) {
            if (!this.hasWhitespace()) this.acceptDelim('=');
            return true;
        } else if (this.acceptDelim('=')) return true;
        return false;
    }
    _parseMediaFeatureName() {
        return this._parseIdent();
    }
    _parseMediaFeatureValue() {
        return this._parseRatio() || this._parseTermExpression();
    }
    _parseScope() {
        // @scope [<scope-limits>]? { <block-contents> }
        if (!this.peekKeyword('@scope')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$775b6bb06e53a214);
        // @scope
        this.consumeToken();
        node.addChild(this._parseScopeLimits());
        return this._parseBody(node, this._parseScopeDeclaration.bind(this));
    }
    _parseScopeDeclaration() {
        // Treat as nested as regular declarations are implicity wrapped with :where(:scope)
        // https://github.com/w3c/csswg-drafts/issues/10389
        // pseudo-selectors implicitly target :scope
        // https://drafts.csswg.org/css-cascade-6/#scoped-rules
        const isNested = true;
        return this._tryParseRuleset(isNested) || this._tryToParseDeclaration() || this._parseStylesheetStatement(isNested);
    }
    _parseScopeLimits() {
        // [(<scope-start>)]? [to (<scope-end>)]?
        const node = this.create($bd0cebf2eccc0e7e$export$78326a4db4056ab8);
        // [(<scope-start>)]?
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            // scope-start selector can start with a combinator as it defaults to :scope
            // Treat as nested
            if (!node.setScopeStart(this._parseSelector(true))) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).SelectorExpected, [], [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR
            ]);
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected, [], [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL
            ]);
        }
        // [to (<scope-end>)]?
        if (this.acceptIdent('to')) {
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftParenthesisExpected, [], [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL
            ]);
            // 'to' selector can start with a combinator as it defaults to :scope
            // Treat as nested
            if (!node.setScopeEnd(this._parseSelector(true))) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).SelectorExpected, [], [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR
            ]);
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected, [], [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL
            ]);
        }
        return this.finish(node);
    }
    _parseMedium() {
        const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
        if (node.addChild(this._parseIdent())) return this.finish(node);
        else return null;
    }
    _parsePageDeclaration() {
        return this._parsePageMarginBox() || this._parseRuleSetDeclaration();
    }
    _parsePage() {
        // http://www.w3.org/TR/css3-page/
        // page_rule : PAGE_SYM S* page_selector_list '{' S* page_body '}' S*
        // page_body :  /* Can be empty */ declaration? [ ';' S* page_body ]? | page_margin_box page_body
        if (!this.peekKeyword('@page')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$6955bcca4cd3539f);
        this.consumeToken();
        if (node.addChild(this._parsePageSelector())) while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
            if (!node.addChild(this._parsePageSelector())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected);
        }
        return this._parseBody(node, this._parsePageDeclaration.bind(this));
    }
    _parsePageMarginBox() {
        // page_margin_box :  margin_sym S* '{' S* declaration? [ ';' S* declaration? ]* '}' S*
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword)) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$358767b9aa8b07d7);
        if (!this.acceptOneKeyword($4b3cdcd55d375778$export$3919b86686ec6946)) this.markError(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).UnknownAtRule, [], [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL
        ]);
        return this._parseBody(node, this._parseRuleSetDeclaration.bind(this));
    }
    _parsePageSelector() {
        // page_selector : pseudo_page+ | IDENT pseudo_page*
        // pseudo_page :  ':' [ "left" | "right" | "first" | "blank" ];
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident) && !this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
        node.addChild(this._parseIdent()); // optional ident
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) {
            if (!node.addChild(this._parseIdent())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected);
        }
        return this.finish(node);
    }
    _parseDocument() {
        // -moz-document is experimental but has been pushed to css4
        if (!this.peekKeyword('@-moz-document')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$b34a105447964f9f);
        this.consumeToken(); // @-moz-document
        this.resync([], [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL
        ]); // ignore all the rules
        return this._parseBody(node, this._parseStylesheetStatement.bind(this));
    }
    _parseContainerDeclaration(isNested = false) {
        if (isNested) // if nested, the body can contain rulesets, but also declarations
        return this._tryParseRuleset(true) || this._tryToParseDeclaration() || this._parseStylesheetStatement(true);
        return this._parseStylesheetStatement(false);
    }
    _parseContainer(isNested = false) {
        if (!this.peekKeyword('@container')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$42a852a2b6b56249);
        this.consumeToken(); // @container
        node.addChild(this._parseIdent()); // optional container name
        node.addChild(this._parseContainerQuery());
        return this._parseBody(node, this._parseContainerDeclaration.bind(this, isNested));
    }
    _parseContainerQuery() {
        // <container-query>     = not <query-in-parens>
        //                         | <query-in-parens> [ [ and <query-in-parens> ]* | [ or <query-in-parens> ]* ]
        const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
        if (this.acceptIdent('not')) node.addChild(this._parseContainerQueryInParens());
        else {
            node.addChild(this._parseContainerQueryInParens());
            if (this.peekIdent('and')) while(this.acceptIdent('and'))node.addChild(this._parseContainerQueryInParens());
            else if (this.peekIdent('or')) while(this.acceptIdent('or'))node.addChild(this._parseContainerQueryInParens());
        }
        return this.finish(node);
    }
    _parseContainerQueryInParens() {
        // <query-in-parens>     = ( <container-query> )
        // 					  | ( <size-feature> )
        // 					  | style( <style-query> )
        // 					  | <general-enclosed>
        const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            if (this.peekIdent('not') || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) node.addChild(this._parseContainerQuery());
            else node.addChild(this._parseMediaFeature());
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected, [], [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL
            ]);
        } else if (this.acceptIdent('style')) {
            if (this.hasWhitespace() || !this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftParenthesisExpected, [], [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL
            ]);
            node.addChild(this._parseStyleQuery());
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected, [], [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL
            ]);
        } else return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftParenthesisExpected, [], [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL
        ]);
        return this.finish(node);
    }
    _parseStyleQuery() {
        // <style-query>         = not <style-in-parens>
        // 					  | <style-in-parens> [ [ and <style-in-parens> ]* | [ or <style-in-parens> ]* ]
        // 					  | <style-feature>
        // <style-in-parens>     = ( <style-query> )
        // 					  | ( <style-feature> )
        // 					  | <general-enclosed>
        const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
        if (this.acceptIdent('not')) node.addChild(this._parseStyleInParens());
        else if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            node.addChild(this._parseStyleInParens());
            if (this.peekIdent('and')) while(this.acceptIdent('and'))node.addChild(this._parseStyleInParens());
            else if (this.peekIdent('or')) while(this.acceptIdent('or'))node.addChild(this._parseStyleInParens());
        } else node.addChild(this._parseDeclaration([
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR
        ]));
        return this.finish(node);
    }
    _parseStyleInParens() {
        const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            node.addChild(this._parseStyleQuery());
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected, [], [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL
            ]);
        } else return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftParenthesisExpected, [], [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL
        ]);
        return this.finish(node);
    }
    // https://www.w3.org/TR/css-syntax-3/#consume-an-at-rule
    _parseUnknownAtRule() {
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword)) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$b8b985b0b9cf23a2);
        node.addChild(this._parseUnknownAtRuleName());
        const isTopLevel = ()=>curlyDepth === 0 && parensDepth === 0 && bracketsDepth === 0;
        let curlyLCount = 0;
        let curlyDepth = 0;
        let parensDepth = 0;
        let bracketsDepth = 0;
        done: while(true){
            switch(this.token.type){
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon:
                    if (isTopLevel()) break done;
                    break;
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF:
                    if (curlyDepth > 0) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightCurlyExpected);
                    else if (bracketsDepth > 0) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightSquareBracketExpected);
                    else if (parensDepth > 0) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected);
                    else return this.finish(node);
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL:
                    curlyLCount++;
                    curlyDepth++;
                    break;
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR:
                    curlyDepth--;
                    // End of at-rule, consume CurlyR and return node
                    if (curlyLCount > 0 && curlyDepth === 0) {
                        this.consumeToken();
                        if (bracketsDepth > 0) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightSquareBracketExpected);
                        else if (parensDepth > 0) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected);
                        break done;
                    }
                    if (curlyDepth < 0) {
                        // The property value has been terminated without a semicolon, and
                        // this is the last declaration in the ruleset.
                        if (parensDepth === 0 && bracketsDepth === 0) break done;
                        return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftCurlyExpected);
                    }
                    break;
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL:
                    parensDepth++;
                    break;
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR:
                    parensDepth--;
                    if (parensDepth < 0) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftParenthesisExpected);
                    break;
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).BracketL:
                    bracketsDepth++;
                    break;
                case (0, $2a533f0146ced75e$export$f435f793048e7a0f).BracketR:
                    bracketsDepth--;
                    if (bracketsDepth < 0) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftSquareBracketExpected);
                    break;
            }
            this.consumeToken();
        }
        return node;
    }
    _parseUnknownAtRuleName() {
        const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword)) return this.finish(node);
        return node;
    }
    _parseOperator() {
        // these are operators for binary expressions
        if (this.peekDelim('/') || this.peekDelim('*') || this.peekDelim('+') || this.peekDelim('-') || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Dashmatch) || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Includes) || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).SubstringOperator) || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).PrefixOperator) || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).SuffixOperator) || this.peekDelim('=')) {
            const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.Operator);
            this.consumeToken();
            return this.finish(node);
        } else return null;
    }
    _parseUnaryOperator() {
        if (!this.peekDelim('+') && !this.peekDelim('-')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
        this.consumeToken();
        return this.finish(node);
    }
    _parseCombinator() {
        if (this.peekDelim('>')) {
            const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
            this.consumeToken();
            const mark = this.mark();
            if (!this.hasWhitespace() && this.acceptDelim('>')) {
                if (!this.hasWhitespace() && this.acceptDelim('>')) {
                    node.type = $bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorCombinatorShadowPiercingDescendant;
                    return this.finish(node);
                }
                this.restoreAtMark(mark);
            }
            node.type = $bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorCombinatorParent;
            return this.finish(node);
        } else if (this.peekDelim('+')) {
            const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
            this.consumeToken();
            node.type = $bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorCombinatorSibling;
            return this.finish(node);
        } else if (this.peekDelim('~')) {
            const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
            this.consumeToken();
            node.type = $bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorCombinatorAllSiblings;
            return this.finish(node);
        } else if (this.peekDelim('/')) {
            const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
            this.consumeToken();
            const mark = this.mark();
            if (!this.hasWhitespace() && this.acceptIdent('deep') && !this.hasWhitespace() && this.acceptDelim('/')) {
                node.type = $bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorCombinatorShadowPiercingDescendant;
                return this.finish(node);
            }
            this.restoreAtMark(mark);
        }
        return null;
    }
    _parseSimpleSelector() {
        // simple_selector
        //  : element_name [ HASH | class | attrib | pseudo ]* | [ HASH | class | attrib | pseudo ]+ ;
        const node = this.create($bd0cebf2eccc0e7e$export$bfa70abafbc5e495);
        let c = 0;
        if (node.addChild(this._parseElementName() || this._parseNestingSelector())) c++;
        while((c === 0 || !this.hasWhitespace()) && node.addChild(this._parseSimpleSelectorBody()))c++;
        return c > 0 ? this.finish(node) : null;
    }
    _parseNestingSelector() {
        if (this.peekDelim('&')) {
            const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorCombinator);
            this.consumeToken();
            return this.finish(node);
        }
        return null;
    }
    _parseSimpleSelectorBody() {
        return this._parsePseudo() || this._parseHash() || this._parseClass() || this._parseAttrib();
    }
    _parseSelectorIdent() {
        return this._parseIdent();
    }
    _parseHash() {
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Hash) && !this.peekDelim('#')) return null;
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.IdentifierSelector);
        if (this.acceptDelim('#')) {
            if (this.hasWhitespace() || !node.addChild(this._parseSelectorIdent())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected);
        } else this.consumeToken(); // TokenType.Hash
        return this.finish(node);
    }
    _parseClass() {
        // class: '.' IDENT ;
        if (!this.peekDelim('.')) return null;
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.ClassSelector);
        this.consumeToken(); // '.'
        if (this.hasWhitespace() || !node.addChild(this._parseSelectorIdent())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected);
        return this.finish(node);
    }
    _parseElementName() {
        // element_name: (ns? '|')? IDENT | '*';
        const pos = this.mark();
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.ElementNameSelector);
        node.addChild(this._parseNamespacePrefix());
        if (!node.addChild(this._parseSelectorIdent()) && !this.acceptDelim('*')) {
            this.restoreAtMark(pos);
            return null;
        }
        return this.finish(node);
    }
    _parseNamespacePrefix() {
        const pos = this.mark();
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.NamespacePrefix);
        !node.addChild(this._parseIdent()) && this.acceptDelim('*');
        if (!this.acceptDelim('|')) {
            this.restoreAtMark(pos);
            return null;
        }
        return this.finish(node);
    }
    _parseAttrib() {
        // attrib : '[' S* IDENT S* [ [ '=' | INCLUDES | DASHMATCH ] S*   [ IDENT | STRING ] S* ]? ']'
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).BracketL)) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$8170b1e1b2558dd5);
        this.consumeToken(); // BracketL
        // Optional attrib namespace
        node.setNamespacePrefix(this._parseNamespacePrefix());
        if (!node.setIdentifier(this._parseIdent())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected);
        if (node.setOperator(this._parseOperator())) {
            node.setValue(this._parseBinaryExpr());
            this.acceptIdent('i'); // case insensitive matching
            this.acceptIdent('s'); // case sensitive matching
        }
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).BracketR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightSquareBracketExpected);
        return this.finish(node);
    }
    _parsePseudo() {
        // pseudo: ':' [ IDENT | FUNCTION S* [IDENT S*]? ')' ]
        const node = this._tryParsePseudoIdentifier();
        if (node) {
            if (!this.hasWhitespace() && this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
                const tryAsSelector = ()=>{
                    const selectors = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorList);
                    if (!selectors.addChild(this._parseSelector(true))) return null;
                    while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma) && selectors.addChild(this._parseSelector(true)));
                    if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(selectors);
                    return null;
                };
                let hasSelector = node.addChild(this.try(tryAsSelector));
                if (!hasSelector) {
                    // accept the <an+b> syntax (not a proper expression) https://drafts.csswg.org/css-syntax/#anb
                    while(!this.peekIdent('of') && (node.addChild(this._parseTerm()) || node.addChild(this._parseOperator())));
                    if (this.acceptIdent('of') && !node.addChild(this.try(tryAsSelector))) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).SelectorExpected);
                }
                if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected);
            }
            return this.finish(node);
        }
        return null;
    }
    _tryParsePseudoIdentifier() {
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) return null;
        const pos = this.mark();
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.PseudoSelector);
        this.consumeToken(); // Colon
        if (this.hasWhitespace()) {
            this.restoreAtMark(pos);
            return null;
        }
        // optional, support ::
        this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon);
        if (this.hasWhitespace() || !node.addChild(this._parseIdent())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected);
        return this.finish(node);
    }
    _tryParsePrio() {
        const mark = this.mark();
        const prio = this._parsePrio();
        if (prio) return prio;
        this.restoreAtMark(mark);
        return null;
    }
    _parsePrio() {
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Exclamation)) return null;
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.Prio);
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Exclamation) && this.acceptIdent('important')) return this.finish(node);
        return null;
    }
    _parseExpr(stopOnComma = false) {
        const node = this.create($bd0cebf2eccc0e7e$export$bfe37c1342e5eb83);
        if (!node.addChild(this._parseBinaryExpr())) return null;
        while(true){
            if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)) {
                if (stopOnComma) return this.finish(node);
                this.consumeToken();
            }
            if (!node.addChild(this._parseBinaryExpr())) break;
        }
        return this.finish(node);
    }
    _parseUnicodeRange() {
        if (!this.peekIdent('u')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$3f8e011aa996e1b4);
        if (!this.acceptUnicodeRange()) return null;
        return this.finish(node);
    }
    _parseNamedLine() {
        // https://www.w3.org/TR/css-grid-1/#named-lines
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).BracketL)) return null;
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.GridLine);
        this.consumeToken();
        while(node.addChild(this._parseIdent()));
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).BracketR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightSquareBracketExpected);
        return this.finish(node);
    }
    _parseBinaryExpr(preparsedLeft, preparsedOper) {
        let node = this.create($bd0cebf2eccc0e7e$export$5351bc98fa48e09c);
        if (!node.setLeft(preparsedLeft || this._parseTerm())) return null;
        if (!node.setOperator(preparsedOper || this._parseOperator())) return this.finish(node);
        if (!node.setRight(this._parseTerm())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).TermExpected);
        // things needed for multiple binary expressions
        node = this.finish(node);
        const operator = this._parseOperator();
        if (operator) node = this._parseBinaryExpr(node, operator);
        return this.finish(node);
    }
    _parseTerm() {
        let node = this.create($bd0cebf2eccc0e7e$export$656c1e606ad06131);
        node.setOperator(this._parseUnaryOperator()); // optional
        if (node.setExpression(this._parseTermExpression())) return this.finish(node);
        return null;
    }
    _parseTermExpression() {
        return this._parseURILiteral() || // url before function
        this._parseUnicodeRange() || this._parseFunction() || // function before ident
        this._parseIdent() || this._parseStringLiteral() || this._parseNumeric() || this._parseHexColor() || this._parseOperation() || this._parseNamedLine();
    }
    _parseOperation() {
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
        this.consumeToken(); // ParenthesisL
        node.addChild(this._parseExpr());
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected);
        return this.finish(node);
    }
    _parseNumeric() {
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Num) || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Percentage) || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Resolution) || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Length) || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).EMS) || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).EXS) || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Angle) || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Time) || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Dimension) || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ContainerQueryLength) || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Freq)) {
            const node = this.create($bd0cebf2eccc0e7e$export$8c91fb1ff010a18e);
            this.consumeToken();
            return this.finish(node);
        }
        return null;
    }
    _parseStringLiteral() {
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).String) && !this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).BadString)) return null;
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.StringLiteral);
        this.consumeToken();
        return this.finish(node);
    }
    _parseURILiteral() {
        if (!this.peekRegExp((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident, /^url(-prefix)?$/i)) return null;
        const pos = this.mark();
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.URILiteral);
        this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident);
        if (this.hasWhitespace() || !this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            this.restoreAtMark(pos);
            return null;
        }
        this.scanner.inURL = true;
        this.consumeToken(); // consume ()
        node.addChild(this._parseURLArgument()); // argument is optional
        this.scanner.inURL = false;
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected);
        return this.finish(node);
    }
    _parseURLArgument() {
        const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).String) && !this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).BadString) && !this.acceptUnquotedString()) return null;
        return this.finish(node);
    }
    _parseIdent(referenceTypes) {
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident)) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$989167234458594d);
        if (referenceTypes) node.referenceTypes = referenceTypes;
        node.isCustomProperty = this.peekRegExp((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident, /^--/);
        this.consumeToken();
        return this.finish(node);
    }
    _parseFunction() {
        const pos = this.mark();
        const node = this.create($bd0cebf2eccc0e7e$export$f3890eeaf6851387);
        if (!node.setIdentifier(this._parseFunctionIdentifier())) return null;
        if (this.hasWhitespace() || !this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            this.restoreAtMark(pos);
            return null;
        }
        if (node.getArguments().addChild(this._parseFunctionArgument())) while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
            if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) break;
            if (!node.getArguments().addChild(this._parseFunctionArgument())) this.markError(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ExpressionExpected);
        }
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected);
        return this.finish(node);
    }
    _parseFunctionIdentifier() {
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident)) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$989167234458594d);
        node.referenceTypes = [
            $bd0cebf2eccc0e7e$export$8868dff548d048cf.Function
        ];
        if (this.acceptIdent('progid')) {
            // support for IE7 specific filters: 'progid:DXImageTransform.Microsoft.MotionBlur(strength=13, direction=310)'
            if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) {
                while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident) && this.acceptDelim('.'));
            }
            return this.finish(node);
        }
        this.consumeToken();
        return this.finish(node);
    }
    _parseFunctionArgument() {
        const node = this.create($bd0cebf2eccc0e7e$export$5868bced5e602b28);
        if (node.setValue(this._parseExpr(true))) return this.finish(node);
        return null;
    }
    _parseHexColor() {
        if (this.peekRegExp((0, $2a533f0146ced75e$export$f435f793048e7a0f).Hash, /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{4}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/g)) {
            const node = this.create($bd0cebf2eccc0e7e$export$7d5dd309eeea3db1);
            this.consumeToken();
            return this.finish(node);
        } else return null;
    }
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 'use strict';
function $0fa1735587167c7c$export$9a2f228bed5035c2(array, p) {
    let low = 0, high = array.length;
    if (high === 0) return 0; // no children
    while(low < high){
        let mid = Math.floor((low + high) / 2);
        if (p(array[mid])) high = mid;
        else low = mid + 1;
    }
    return low;
}
function $0fa1735587167c7c$export$ee2e0f811dca1807(array, item) {
    return array.indexOf(item) !== -1;
}
function $0fa1735587167c7c$export$971dd5b0dfd021b6(...arrays) {
    const result = [];
    for (const array of arrays){
        for (const item of array)if (!$0fa1735587167c7c$export$ee2e0f811dca1807(result, item)) result.push(item);
    }
    return result;
}


'use strict';
class $0e1028d5f31bf222$export$775b6bb06e53a214 {
    constructor(offset, length){
        this.offset = offset;
        this.length = length;
        this.symbols = [];
        this.parent = null;
        this.children = [];
    }
    addChild(scope) {
        this.children.push(scope);
        scope.setParent(this);
    }
    setParent(scope) {
        this.parent = scope;
    }
    findScope(offset, length = 0) {
        if (this.offset <= offset && this.offset + this.length > offset + length || this.offset === offset && this.length === length) return this.findInScope(offset, length);
        return null;
    }
    findInScope(offset, length = 0) {
        // find the first scope child that has an offset larger than offset + length
        const end = offset + length;
        const idx = (0, $0fa1735587167c7c$export$9a2f228bed5035c2)(this.children, (s)=>s.offset > end);
        if (idx === 0) // all scopes have offsets larger than our end
        return this;
        const res = this.children[idx - 1];
        if (res.offset <= offset && res.offset + res.length >= offset + length) return res.findInScope(offset, length);
        return this;
    }
    addSymbol(symbol) {
        this.symbols.push(symbol);
    }
    getSymbol(name, type) {
        for(let index = 0; index < this.symbols.length; index++){
            const symbol = this.symbols[index];
            if (symbol.name === name && symbol.type === type) return symbol;
        }
        return null;
    }
    getSymbols() {
        return this.symbols;
    }
}
class $0e1028d5f31bf222$export$5fdf684e73bb2de5 extends $0e1028d5f31bf222$export$775b6bb06e53a214 {
    constructor(){
        super(0, Number.MAX_VALUE);
    }
}
class $0e1028d5f31bf222$export$3e25e887b7a5b37b {
    constructor(name, value, node, type){
        this.name = name;
        this.value = value;
        this.node = node;
        this.type = type;
    }
}
class $0e1028d5f31bf222$export$3f54e18c91c2673a {
    constructor(scope){
        this.scope = scope;
    }
    addSymbol(node, name, value, type) {
        if (node.offset !== -1) {
            const current = this.scope.findScope(node.offset, node.length);
            if (current) current.addSymbol(new $0e1028d5f31bf222$export$3e25e887b7a5b37b(name, value, node, type));
        }
    }
    addScope(node) {
        if (node.offset !== -1) {
            const current = this.scope.findScope(node.offset, node.length);
            if (current && (current.offset !== node.offset || current.length !== node.length)) {
                const newScope = new $0e1028d5f31bf222$export$775b6bb06e53a214(node.offset, node.length);
                current.addChild(newScope);
                return newScope;
            }
            return current;
        }
        return null;
    }
    addSymbolToChildScope(scopeNode, node, name, value, type) {
        if (scopeNode && scopeNode.offset !== -1) {
            const current = this.addScope(scopeNode); // create the scope or gets the existing one
            if (current) current.addSymbol(new $0e1028d5f31bf222$export$3e25e887b7a5b37b(name, value, node, type));
        }
    }
    visitNode(node) {
        switch(node.type){
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Keyframe:
                this.addSymbol(node, node.getName(), void 0, $bd0cebf2eccc0e7e$export$8868dff548d048cf.Keyframe);
                return true;
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.CustomPropertyDeclaration:
                return this.visitCustomPropertyDeclarationNode(node);
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.VariableDeclaration:
                return this.visitVariableDeclarationNode(node);
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Ruleset:
                return this.visitRuleSet(node);
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.MixinDeclaration:
                this.addSymbol(node, node.getName(), void 0, $bd0cebf2eccc0e7e$export$8868dff548d048cf.Mixin);
                return true;
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.FunctionDeclaration:
                this.addSymbol(node, node.getName(), void 0, $bd0cebf2eccc0e7e$export$8868dff548d048cf.Function);
                return true;
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.FunctionParameter:
                return this.visitFunctionParameterNode(node);
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Declarations:
                this.addScope(node);
                return true;
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.For:
                const forNode = node;
                const scopeNode = forNode.getDeclarations();
                if (scopeNode && forNode.variable) this.addSymbolToChildScope(scopeNode, forNode.variable, forNode.variable.getName(), void 0, $bd0cebf2eccc0e7e$export$8868dff548d048cf.Variable);
                return true;
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Each:
                {
                    const eachNode = node;
                    const scopeNode = eachNode.getDeclarations();
                    if (scopeNode) {
                        const variables = eachNode.getVariables().getChildren();
                        for (const variable of variables)this.addSymbolToChildScope(scopeNode, variable, variable.getName(), void 0, $bd0cebf2eccc0e7e$export$8868dff548d048cf.Variable);
                    }
                    return true;
                }
        }
        return true;
    }
    visitRuleSet(node) {
        const current = this.scope.findScope(node.offset, node.length);
        if (current) for (const child of node.getSelectors().getChildren()){
            if (child instanceof $bd0cebf2eccc0e7e$export$d15f4cd5286f9b1e) {
                if (child.getChildren().length === 1) current.addSymbol(new $0e1028d5f31bf222$export$3e25e887b7a5b37b(child.getChild(0).getText(), void 0, child, $bd0cebf2eccc0e7e$export$8868dff548d048cf.Rule));
            }
        }
        return true;
    }
    visitVariableDeclarationNode(node) {
        const value = node.getValue() ? node.getValue().getText() : void 0;
        this.addSymbol(node, node.getName(), value, $bd0cebf2eccc0e7e$export$8868dff548d048cf.Variable);
        return true;
    }
    visitFunctionParameterNode(node) {
        // parameters are part of the body scope
        const scopeNode = node.getParent().getDeclarations();
        if (scopeNode) {
            const valueNode = node.getDefaultValue();
            const value = valueNode ? valueNode.getText() : void 0;
            this.addSymbolToChildScope(scopeNode, node, node.getName(), value, $bd0cebf2eccc0e7e$export$8868dff548d048cf.Variable);
        }
        return true;
    }
    visitCustomPropertyDeclarationNode(node) {
        const value = node.getValue() ? node.getValue().getText() : '';
        this.addCSSVariable(node.getProperty(), node.getProperty().getName(), value, $bd0cebf2eccc0e7e$export$8868dff548d048cf.Variable);
        return true;
    }
    addCSSVariable(node, name, value, type) {
        if (node.offset !== -1) this.scope.addSymbol(new $0e1028d5f31bf222$export$3e25e887b7a5b37b(name, value, node, type));
    }
}
class $0e1028d5f31bf222$export$fa456266707bf4e4 {
    constructor(node){
        this.global = new $0e1028d5f31bf222$export$5fdf684e73bb2de5();
        node.acceptVisitor(new $0e1028d5f31bf222$export$3f54e18c91c2673a(this.global));
    }
    findSymbolsAtOffset(offset, referenceType) {
        let scope = this.global.findScope(offset, 0);
        const result = [];
        const names = {};
        while(scope){
            const symbols = scope.getSymbols();
            for(let i = 0; i < symbols.length; i++){
                const symbol = symbols[i];
                if (symbol.type === referenceType && !names[symbol.name]) {
                    result.push(symbol);
                    names[symbol.name] = true;
                }
            }
            scope = scope.parent;
        }
        return result;
    }
    internalFindSymbol(node, referenceTypes) {
        let scopeNode = node;
        if (node.parent instanceof $bd0cebf2eccc0e7e$export$e8b5f24364ee45a9 && node.parent.getParent() instanceof $bd0cebf2eccc0e7e$export$750c6750564ae5ac) scopeNode = node.parent.getParent().getDeclarations();
        if (node.parent instanceof $bd0cebf2eccc0e7e$export$5868bced5e602b28 && node.parent.getParent() instanceof $bd0cebf2eccc0e7e$export$f3890eeaf6851387) {
            const funcId = node.parent.getParent().getIdentifier();
            if (funcId) {
                const functionSymbol = this.internalFindSymbol(funcId, [
                    $bd0cebf2eccc0e7e$export$8868dff548d048cf.Function
                ]);
                if (functionSymbol) scopeNode = functionSymbol.node.getDeclarations();
            }
        }
        if (!scopeNode) return null;
        const name = node.getText();
        let scope = this.global.findScope(scopeNode.offset, scopeNode.length);
        while(scope){
            for(let index = 0; index < referenceTypes.length; index++){
                const type = referenceTypes[index];
                const symbol = scope.getSymbol(name, type);
                if (symbol) return symbol;
            }
            scope = scope.parent;
        }
        return null;
    }
    evaluateReferenceTypes(node) {
        if (node instanceof $bd0cebf2eccc0e7e$export$989167234458594d) {
            const referenceTypes = node.referenceTypes;
            if (referenceTypes) return referenceTypes;
            else {
                if (node.isCustomProperty) return [
                    $bd0cebf2eccc0e7e$export$8868dff548d048cf.Variable
                ];
                // are a reference to a keyframe?
                const decl = $bd0cebf2eccc0e7e$export$327419d17f0a0346(node);
                if (decl) {
                    const propertyName = decl.getNonPrefixedPropertyName();
                    if ((propertyName === 'animation' || propertyName === 'animation-name') && decl.getValue() && decl.getValue().offset === node.offset) return [
                        $bd0cebf2eccc0e7e$export$8868dff548d048cf.Keyframe
                    ];
                }
            }
        } else if (node instanceof $bd0cebf2eccc0e7e$export$c867a5c9595a1350) return [
            $bd0cebf2eccc0e7e$export$8868dff548d048cf.Variable
        ];
        const selector = node.findAParent($bd0cebf2eccc0e7e$export$f06e977173f1857c.Selector, $bd0cebf2eccc0e7e$export$f06e977173f1857c.ExtendsReference);
        if (selector) return [
            $bd0cebf2eccc0e7e$export$8868dff548d048cf.Rule
        ];
        return null;
    }
    findSymbolFromNode(node) {
        if (!node) return null;
        while(node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Interpolation)node = node.getParent();
        const referenceTypes = this.evaluateReferenceTypes(node);
        if (referenceTypes) return this.internalFindSymbol(node, referenceTypes);
        return null;
    }
    matchesSymbol(node, symbol) {
        if (!node) return false;
        while(node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Interpolation)node = node.getParent();
        if (!node.matches(symbol.name)) return false;
        const referenceTypes = this.evaluateReferenceTypes(node);
        if (!referenceTypes || referenceTypes.indexOf(symbol.type) === -1) return false;
        const nodeSymbol = this.internalFindSymbol(node, referenceTypes);
        return nodeSymbol === symbol;
    }
    findSymbol(name, type, offset) {
        let scope = this.global.findScope(offset);
        while(scope){
            const symbol = scope.getSymbol(name, type);
            if (symbol) return symbol;
            scope = scope.parent;
        }
        return null;
    }
}







/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var $4b379b9378e55f86$exports = {};
var $391299e0893a3dfa$exports = {};
// shim for using process in browser
var $391299e0893a3dfa$var$process = $391299e0893a3dfa$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = 'browser';
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ''; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$391299e0893a3dfa$var$process.cwd = function() {
    return '/';
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};


!function(t, e) {
    var r, n;
    $4b379b9378e55f86$exports = e();
}($4b379b9378e55f86$exports, ()=>(()=>{
        "use strict";
        var t = {
            975: (t)=>{
                function e(t) {
                    if ("string" != typeof t) throw new TypeError("Path must be a string. Received " + JSON.stringify(t));
                }
                function r(t, e) {
                    for(var r, n = "", i = 0, o = -1, s = 0, a = 0; a <= t.length; ++a){
                        if (a < t.length) r = t.charCodeAt(a);
                        else {
                            if (47 === r) break;
                            r = 47;
                        }
                        if (47 === r) {
                            if (o === a - 1 || 1 === s) ;
                            else if (o !== a - 1 && 2 === s) {
                                if (n.length < 2 || 2 !== i || 46 !== n.charCodeAt(n.length - 1) || 46 !== n.charCodeAt(n.length - 2)) {
                                    if (n.length > 2) {
                                        var h = n.lastIndexOf("/");
                                        if (h !== n.length - 1) {
                                            -1 === h ? (n = "", i = 0) : i = (n = n.slice(0, h)).length - 1 - n.lastIndexOf("/"), o = a, s = 0;
                                            continue;
                                        }
                                    } else if (2 === n.length || 1 === n.length) {
                                        n = "", i = 0, o = a, s = 0;
                                        continue;
                                    }
                                }
                                e && (n.length > 0 ? n += "/.." : n = "..", i = 2);
                            } else n.length > 0 ? n += "/" + t.slice(o + 1, a) : n = t.slice(o + 1, a), i = a - o - 1;
                            o = a, s = 0;
                        } else 46 === r && -1 !== s ? ++s : s = -1;
                    }
                    return n;
                }
                var n = {
                    resolve: function() {
                        for(var t, n = "", i = !1, o = arguments.length - 1; o >= -1 && !i; o--){
                            var s;
                            o >= 0 ? s = arguments[o] : (void 0 === t && (t = $391299e0893a3dfa$exports.cwd()), s = t), e(s), 0 !== s.length && (n = s + "/" + n, i = 47 === s.charCodeAt(0));
                        }
                        return n = r(n, !i), i ? n.length > 0 ? "/" + n : "/" : n.length > 0 ? n : ".";
                    },
                    normalize: function(t) {
                        if (e(t), 0 === t.length) return ".";
                        var n = 47 === t.charCodeAt(0), i = 47 === t.charCodeAt(t.length - 1);
                        return 0 !== (t = r(t, !n)).length || n || (t = "."), t.length > 0 && i && (t += "/"), n ? "/" + t : t;
                    },
                    isAbsolute: function(t) {
                        return e(t), t.length > 0 && 47 === t.charCodeAt(0);
                    },
                    join: function() {
                        if (0 === arguments.length) return ".";
                        for(var t, r = 0; r < arguments.length; ++r){
                            var i = arguments[r];
                            e(i), i.length > 0 && (void 0 === t ? t = i : t += "/" + i);
                        }
                        return void 0 === t ? "." : n.normalize(t);
                    },
                    relative: function(t, r) {
                        if (e(t), e(r), t === r) return "";
                        if ((t = n.resolve(t)) === (r = n.resolve(r))) return "";
                        for(var i = 1; i < t.length && 47 === t.charCodeAt(i); ++i);
                        for(var o = t.length, s = o - i, a = 1; a < r.length && 47 === r.charCodeAt(a); ++a);
                        for(var h = r.length - a, c = s < h ? s : h, f = -1, u = 0; u <= c; ++u){
                            if (u === c) {
                                if (h > c) {
                                    if (47 === r.charCodeAt(a + u)) return r.slice(a + u + 1);
                                    if (0 === u) return r.slice(a + u);
                                } else s > c && (47 === t.charCodeAt(i + u) ? f = u : 0 === u && (f = 0));
                                break;
                            }
                            var l = t.charCodeAt(i + u);
                            if (l !== r.charCodeAt(a + u)) break;
                            47 === l && (f = u);
                        }
                        var d = "";
                        for(u = i + f + 1; u <= o; ++u)u !== o && 47 !== t.charCodeAt(u) || (0 === d.length ? d += ".." : d += "/..");
                        return d.length > 0 ? d + r.slice(a + f) : (a += f, 47 === r.charCodeAt(a) && ++a, r.slice(a));
                    },
                    _makeLong: function(t) {
                        return t;
                    },
                    dirname: function(t) {
                        if (e(t), 0 === t.length) return ".";
                        for(var r = t.charCodeAt(0), n = 47 === r, i = -1, o = !0, s = t.length - 1; s >= 1; --s)if (47 === (r = t.charCodeAt(s))) {
                            if (!o) {
                                i = s;
                                break;
                            }
                        } else o = !1;
                        return -1 === i ? n ? "/" : "." : n && 1 === i ? "//" : t.slice(0, i);
                    },
                    basename: function(t, r) {
                        if (void 0 !== r && "string" != typeof r) throw new TypeError('"ext" argument must be a string');
                        e(t);
                        var n, i = 0, o = -1, s = !0;
                        if (void 0 !== r && r.length > 0 && r.length <= t.length) {
                            if (r.length === t.length && r === t) return "";
                            var a = r.length - 1, h = -1;
                            for(n = t.length - 1; n >= 0; --n){
                                var c = t.charCodeAt(n);
                                if (47 === c) {
                                    if (!s) {
                                        i = n + 1;
                                        break;
                                    }
                                } else -1 === h && (s = !1, h = n + 1), a >= 0 && (c === r.charCodeAt(a) ? -1 == --a && (o = n) : (a = -1, o = h));
                            }
                            return i === o ? o = h : -1 === o && (o = t.length), t.slice(i, o);
                        }
                        for(n = t.length - 1; n >= 0; --n)if (47 === t.charCodeAt(n)) {
                            if (!s) {
                                i = n + 1;
                                break;
                            }
                        } else -1 === o && (s = !1, o = n + 1);
                        return -1 === o ? "" : t.slice(i, o);
                    },
                    extname: function(t) {
                        e(t);
                        for(var r = -1, n = 0, i = -1, o = !0, s = 0, a = t.length - 1; a >= 0; --a){
                            var h = t.charCodeAt(a);
                            if (47 !== h) -1 === i && (o = !1, i = a + 1), 46 === h ? -1 === r ? r = a : 1 !== s && (s = 1) : -1 !== r && (s = -1);
                            else if (!o) {
                                n = a + 1;
                                break;
                            }
                        }
                        return -1 === r || -1 === i || 0 === s || 1 === s && r === i - 1 && r === n + 1 ? "" : t.slice(r, i);
                    },
                    format: function(t) {
                        if (null === t || "object" != typeof t) throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof t);
                        return function(t, e) {
                            var r = e.dir || e.root, n = e.base || (e.name || "") + (e.ext || "");
                            return r ? r === e.root ? r + n : r + "/" + n : n;
                        }(0, t);
                    },
                    parse: function(t) {
                        e(t);
                        var r = {
                            root: "",
                            dir: "",
                            base: "",
                            ext: "",
                            name: ""
                        };
                        if (0 === t.length) return r;
                        var n, i = t.charCodeAt(0), o = 47 === i;
                        o ? (r.root = "/", n = 1) : n = 0;
                        for(var s = -1, a = 0, h = -1, c = !0, f = t.length - 1, u = 0; f >= n; --f)if (47 !== (i = t.charCodeAt(f))) -1 === h && (c = !1, h = f + 1), 46 === i ? -1 === s ? s = f : 1 !== u && (u = 1) : -1 !== s && (u = -1);
                        else if (!c) {
                            a = f + 1;
                            break;
                        }
                        return -1 === s || -1 === h || 0 === u || 1 === u && s === h - 1 && s === a + 1 ? -1 !== h && (r.base = r.name = 0 === a && o ? t.slice(1, h) : t.slice(a, h)) : (0 === a && o ? (r.name = t.slice(1, s), r.base = t.slice(1, h)) : (r.name = t.slice(a, s), r.base = t.slice(a, h)), r.ext = t.slice(s, h)), a > 0 ? r.dir = t.slice(0, a - 1) : o && (r.dir = "/"), r;
                    },
                    sep: "/",
                    delimiter: ":",
                    win32: null,
                    posix: null
                };
                n.posix = n, t.exports = n;
            },
            70: (t, e)=>{
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.isWindows = void 0;
                if ("object" == typeof navigator) {
                    let t = navigator.userAgent;
                    e.isWindows = t.indexOf("Windows") >= 0;
                }
            },
            231: (t, e, r)=>{
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.uriToFsPath = e.URI = void 0;
                const n = r(70), i = /^\w[\w\d+.-]*$/, o = /^\//, s = /^\/\//;
                function a(t, e) {
                    if (!t.scheme && e) throw new Error(`[UriError]: Scheme is missing: {scheme: "", authority: "${t.authority}", path: "${t.path}", query: "${t.query}", fragment: "${t.fragment}"}`);
                    if (t.scheme && !i.test(t.scheme)) throw new Error("[UriError]: Scheme contains illegal characters.");
                    if (t.path) {
                        if (t.authority) {
                            if (!o.test(t.path)) throw new Error('[UriError]: If a URI contains an authority component, then the path component must either be empty or begin with a slash ("/") character');
                        } else if (s.test(t.path)) throw new Error('[UriError]: If a URI does not contain an authority component, then the path cannot begin with two slash characters ("//")');
                    }
                }
                const h = "", c = "/", f = /^(([^:/?#]+?):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;
                class u {
                    static isUri(t) {
                        return t instanceof u || !!t && "string" == typeof t.authority && "string" == typeof t.fragment && "string" == typeof t.path && "string" == typeof t.query && "string" == typeof t.scheme && "string" == typeof t.fsPath && "function" == typeof t.with && "function" == typeof t.toString;
                    }
                    scheme;
                    authority;
                    path;
                    query;
                    fragment;
                    constructor(t, e, r, n, i, o = !1){
                        "object" == typeof t ? (this.scheme = t.scheme || h, this.authority = t.authority || h, this.path = t.path || h, this.query = t.query || h, this.fragment = t.fragment || h) : (this.scheme = function(t, e) {
                            return t || e ? t : "file";
                        }(t, o), this.authority = e || h, this.path = function(t, e) {
                            switch(t){
                                case "https":
                                case "http":
                                case "file":
                                    e ? e[0] !== c && (e = c + e) : e = c;
                            }
                            return e;
                        }(this.scheme, r || h), this.query = n || h, this.fragment = i || h, a(this, o));
                    }
                    get fsPath() {
                        return v(this, !1);
                    }
                    with(t) {
                        if (!t) return this;
                        let { scheme: e, authority: r, path: n, query: i, fragment: o } = t;
                        return void 0 === e ? e = this.scheme : null === e && (e = h), void 0 === r ? r = this.authority : null === r && (r = h), void 0 === n ? n = this.path : null === n && (n = h), void 0 === i ? i = this.query : null === i && (i = h), void 0 === o ? o = this.fragment : null === o && (o = h), e === this.scheme && r === this.authority && n === this.path && i === this.query && o === this.fragment ? this : new d(e, r, n, i, o);
                    }
                    static parse(t, e = !1) {
                        const r = f.exec(t);
                        return r ? new d(r[2] || h, w(r[4] || h), w(r[5] || h), w(r[7] || h), w(r[9] || h), e) : new d(h, h, h, h, h);
                    }
                    static file(t) {
                        let e = h;
                        if (n.isWindows && (t = t.replace(/\\/g, c)), t[0] === c && t[1] === c) {
                            const r = t.indexOf(c, 2);
                            -1 === r ? (e = t.substring(2), t = c) : (e = t.substring(2, r), t = t.substring(r) || c);
                        }
                        return new d("file", e, t, h, h);
                    }
                    static from(t) {
                        const e = new d(t.scheme, t.authority, t.path, t.query, t.fragment);
                        return a(e, !0), e;
                    }
                    toString(t = !1) {
                        return y(this, t);
                    }
                    toJSON() {
                        return this;
                    }
                    static revive(t) {
                        if (t) {
                            if (t instanceof u) return t;
                            {
                                const e = new d(t);
                                return e._formatted = t.external, e._fsPath = t._sep === l ? t.fsPath : null, e;
                            }
                        }
                        return t;
                    }
                }
                e.URI = u;
                const l = n.isWindows ? 1 : void 0;
                class d extends u {
                    _formatted = null;
                    _fsPath = null;
                    get fsPath() {
                        return this._fsPath || (this._fsPath = v(this, !1)), this._fsPath;
                    }
                    toString(t = !1) {
                        return t ? y(this, !0) : (this._formatted || (this._formatted = y(this, !1)), this._formatted);
                    }
                    toJSON() {
                        const t = {
                            $mid: 1
                        };
                        return this._fsPath && (t.fsPath = this._fsPath, t._sep = l), this._formatted && (t.external = this._formatted), this.path && (t.path = this.path), this.scheme && (t.scheme = this.scheme), this.authority && (t.authority = this.authority), this.query && (t.query = this.query), this.fragment && (t.fragment = this.fragment), t;
                    }
                }
                const p = {
                    58: "%3A",
                    47: "%2F",
                    63: "%3F",
                    35: "%23",
                    91: "%5B",
                    93: "%5D",
                    64: "%40",
                    33: "%21",
                    36: "%24",
                    38: "%26",
                    39: "%27",
                    40: "%28",
                    41: "%29",
                    42: "%2A",
                    43: "%2B",
                    44: "%2C",
                    59: "%3B",
                    61: "%3D",
                    32: "%20"
                };
                function g(t, e, r) {
                    let n, i = -1;
                    for(let o = 0; o < t.length; o++){
                        const s = t.charCodeAt(o);
                        if (s >= 97 && s <= 122 || s >= 65 && s <= 90 || s >= 48 && s <= 57 || 45 === s || 46 === s || 95 === s || 126 === s || e && 47 === s || r && 91 === s || r && 93 === s || r && 58 === s) -1 !== i && (n += encodeURIComponent(t.substring(i, o)), i = -1), void 0 !== n && (n += t.charAt(o));
                        else {
                            void 0 === n && (n = t.substr(0, o));
                            const e = p[s];
                            void 0 !== e ? (-1 !== i && (n += encodeURIComponent(t.substring(i, o)), i = -1), n += e) : -1 === i && (i = o);
                        }
                    }
                    return -1 !== i && (n += encodeURIComponent(t.substring(i))), void 0 !== n ? n : t;
                }
                function m(t) {
                    let e;
                    for(let r = 0; r < t.length; r++){
                        const n = t.charCodeAt(r);
                        35 === n || 63 === n ? (void 0 === e && (e = t.substr(0, r)), e += p[n]) : void 0 !== e && (e += t[r]);
                    }
                    return void 0 !== e ? e : t;
                }
                function v(t, e) {
                    let r;
                    return r = t.authority && t.path.length > 1 && "file" === t.scheme ? `//${t.authority}${t.path}` : 47 === t.path.charCodeAt(0) && (t.path.charCodeAt(1) >= 65 && t.path.charCodeAt(1) <= 90 || t.path.charCodeAt(1) >= 97 && t.path.charCodeAt(1) <= 122) && 58 === t.path.charCodeAt(2) ? e ? t.path.substr(1) : t.path[1].toLowerCase() + t.path.substr(2) : t.path, n.isWindows && (r = r.replace(/\//g, "\\")), r;
                }
                function y(t, e) {
                    const r = e ? m : g;
                    let n = "", { scheme: i, authority: o, path: s, query: a, fragment: h } = t;
                    if (i && (n += i, n += ":"), (o || "file" === i) && (n += c, n += c), o) {
                        let t = o.indexOf("@");
                        if (-1 !== t) {
                            const e = o.substr(0, t);
                            o = o.substr(t + 1), t = e.lastIndexOf(":"), -1 === t ? n += r(e, !1, !1) : (n += r(e.substr(0, t), !1, !1), n += ":", n += r(e.substr(t + 1), !1, !0)), n += "@";
                        }
                        o = o.toLowerCase(), t = o.lastIndexOf(":"), -1 === t ? n += r(o, !1, !0) : (n += r(o.substr(0, t), !1, !0), n += o.substr(t));
                    }
                    if (s) {
                        if (s.length >= 3 && 47 === s.charCodeAt(0) && 58 === s.charCodeAt(2)) {
                            const t = s.charCodeAt(1);
                            t >= 65 && t <= 90 && (s = `/${String.fromCharCode(t + 32)}:${s.substr(3)}`);
                        } else if (s.length >= 2 && 58 === s.charCodeAt(1)) {
                            const t = s.charCodeAt(0);
                            t >= 65 && t <= 90 && (s = `${String.fromCharCode(t + 32)}:${s.substr(2)}`);
                        }
                        n += r(s, !0, !1);
                    }
                    return a && (n += "?", n += r(a, !1, !1)), h && (n += "#", n += e ? h : g(h, !1, !1)), n;
                }
                function b(t) {
                    try {
                        return decodeURIComponent(t);
                    } catch  {
                        return t.length > 3 ? t.substr(0, 3) + b(t.substr(3)) : t;
                    }
                }
                e.uriToFsPath = v;
                const C = /(%[0-9A-Za-z][0-9A-Za-z])+/g;
                function w(t) {
                    return t.match(C) ? t.replace(C, (t)=>b(t)) : t;
                }
            },
            552: function(t, e, r) {
                var n = this && this.__createBinding || (Object.create ? function(t, e, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(e, r);
                    i && !("get" in i ? !e.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return e[r];
                        }
                    }), Object.defineProperty(t, n, i);
                } : function(t, e, r, n) {
                    void 0 === n && (n = r), t[n] = e[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(t, e) {
                    Object.defineProperty(t, "default", {
                        enumerable: !0,
                        value: e
                    });
                } : function(t, e) {
                    t.default = e;
                }), o = this && this.__importStar || function(t) {
                    if (t && t.__esModule) return t;
                    var e = {};
                    if (null != t) for(var r in t)"default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
                    return i(e, t), e;
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Utils = void 0;
                const s = o(r(975)), a = s.posix || s, h = "/";
                var c;
                !function(t) {
                    t.joinPath = function(t, ...e) {
                        return t.with({
                            path: a.join(t.path, ...e)
                        });
                    }, t.resolvePath = function(t, ...e) {
                        let r = t.path, n = !1;
                        r[0] !== h && (r = h + r, n = !0);
                        let i = a.resolve(r, ...e);
                        return n && i[0] === h && !t.authority && (i = i.substring(1)), t.with({
                            path: i
                        });
                    }, t.dirname = function(t) {
                        if (0 === t.path.length || t.path === h) return t;
                        let e = a.dirname(t.path);
                        return 1 === e.length && 46 === e.charCodeAt(0) && (e = ""), t.with({
                            path: e
                        });
                    }, t.basename = function(t) {
                        return a.basename(t.path);
                    }, t.extname = function(t) {
                        return a.extname(t.path);
                    };
                }(c || (e.Utils = c = {}));
            }
        }, e = {};
        function r(n) {
            var i = e[n];
            if (void 0 !== i) return i.exports;
            var o = e[n] = {
                exports: {}
            };
            return t[n].call(o.exports, o, o.exports, r), o.exports;
        }
        var n = {};
        return (()=>{
            var t = n;
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Utils = t.URI = void 0;
            const e = r(231);
            Object.defineProperty(t, "URI", {
                enumerable: !0,
                get: function() {
                    return e.URI;
                }
            });
            const i = r(552);
            Object.defineProperty(t, "Utils", {
                enumerable: !0,
                get: function() {
                    return i.Utils;
                }
            });
        })(), n;
    })());


function $a2a0b9096fdc2c46$export$7f7b8152cc673abe(uriString) {
    return (0, $4b379b9378e55f86$exports.Utils).dirname((0, $4b379b9378e55f86$exports.URI).parse(uriString)).toString(true);
}
function $a2a0b9096fdc2c46$export$b891921babc70093(uriString, ...paths) {
    return (0, $4b379b9378e55f86$exports.Utils).joinPath((0, $4b379b9378e55f86$exports.URI).parse(uriString), ...paths).toString(true);
}


class $3a8d746702642fb5$export$a1ba7ea3fde4aca5 {
    constructor(readDirectory){
        this.readDirectory = readDirectory;
        this.literalCompletions = [];
        this.importCompletions = [];
    }
    onCssURILiteralValue(context) {
        this.literalCompletions.push(context);
    }
    onCssImportPath(context) {
        this.importCompletions.push(context);
    }
    async computeCompletions(document, documentContext) {
        const result = {
            items: [],
            isIncomplete: false
        };
        for (const literalCompletion of this.literalCompletions){
            const uriValue = literalCompletion.uriValue;
            const fullValue = $3a8d746702642fb5$var$stripQuotes(uriValue);
            if (fullValue === '.' || fullValue === '..') result.isIncomplete = true;
            else {
                const items = await this.providePathSuggestions(uriValue, literalCompletion.position, literalCompletion.range, document, documentContext);
                for (let item of items)result.items.push(item);
            }
        }
        for (const importCompletion of this.importCompletions){
            const pathValue = importCompletion.pathValue;
            const fullValue = $3a8d746702642fb5$var$stripQuotes(pathValue);
            if (fullValue === '.' || fullValue === '..') result.isIncomplete = true;
            else {
                let suggestions = await this.providePathSuggestions(pathValue, importCompletion.position, importCompletion.range, document, documentContext);
                if (document.languageId === 'scss') suggestions.forEach((s)=>{
                    if ((0, $3383aa02dc8dfba4$export$68326237475e9a7d)(s.label, '_') && (0, $3383aa02dc8dfba4$export$10fdab3683b55b22)(s.label, '.scss')) {
                        if (s.textEdit) s.textEdit.newText = s.label.slice(1, -5);
                        else s.label = s.label.slice(1, -5);
                    }
                });
                for (let item of suggestions)result.items.push(item);
            }
        }
        return result;
    }
    async providePathSuggestions(pathValue, position, range, document, documentContext) {
        const fullValue = $3a8d746702642fb5$var$stripQuotes(pathValue);
        const isValueQuoted = (0, $3383aa02dc8dfba4$export$68326237475e9a7d)(pathValue, `'`) || (0, $3383aa02dc8dfba4$export$68326237475e9a7d)(pathValue, `"`);
        const valueBeforeCursor = isValueQuoted ? fullValue.slice(0, position.character - (range.start.character + 1)) : fullValue.slice(0, position.character - range.start.character);
        const currentDocUri = document.uri;
        const fullValueRange = isValueQuoted ? $3a8d746702642fb5$var$shiftRange(range, 1, -1) : range;
        const replaceRange = $3a8d746702642fb5$var$pathToReplaceRange(valueBeforeCursor, fullValue, fullValueRange);
        const valueBeforeLastSlash = valueBeforeCursor.substring(0, valueBeforeCursor.lastIndexOf('/') + 1); // keep the last slash
        let parentDir = documentContext.resolveReference(valueBeforeLastSlash || '.', currentDocUri);
        if (parentDir) try {
            const result = [];
            const infos = await this.readDirectory(parentDir);
            for (const [name, type] of infos)// Exclude paths that start with `.`
            if (name.charCodeAt(0) !== $3a8d746702642fb5$var$CharCode_dot && (type === (0, $579034ff01526470$export$c5ae10d7c88c4d3e).Directory || (0, $a2a0b9096fdc2c46$export$b891921babc70093)(parentDir, name) !== currentDocUri)) result.push($3a8d746702642fb5$var$createCompletionItem(name, type === (0, $579034ff01526470$export$c5ae10d7c88c4d3e).Directory, replaceRange));
            return result;
        } catch (e) {
        // ignore
        }
        return [];
    }
}
const $3a8d746702642fb5$var$CharCode_dot = '.'.charCodeAt(0);
function $3a8d746702642fb5$var$stripQuotes(fullValue) {
    if ((0, $3383aa02dc8dfba4$export$68326237475e9a7d)(fullValue, `'`) || (0, $3383aa02dc8dfba4$export$68326237475e9a7d)(fullValue, `"`)) return fullValue.slice(1, -1);
    else return fullValue;
}
function $3a8d746702642fb5$var$pathToReplaceRange(valueBeforeCursor, fullValue, fullValueRange) {
    let replaceRange;
    const lastIndexOfSlash = valueBeforeCursor.lastIndexOf('/');
    if (lastIndexOfSlash === -1) replaceRange = fullValueRange;
    else {
        // For cases where cursor is in the middle of attribute value, like <script src="./s|rc/test.js">
        // Find the last slash before cursor, and calculate the start of replace range from there
        const valueAfterLastSlash = fullValue.slice(lastIndexOfSlash + 1);
        const startPos = $3a8d746702642fb5$var$shiftPosition(fullValueRange.end, -valueAfterLastSlash.length);
        // If whitespace exists, replace until it
        const whitespaceIndex = valueAfterLastSlash.indexOf(' ');
        let endPos;
        if (whitespaceIndex !== -1) endPos = $3a8d746702642fb5$var$shiftPosition(startPos, whitespaceIndex);
        else endPos = fullValueRange.end;
        replaceRange = (0, $1345bdc33671c7a9$exports.Range).create(startPos, endPos);
    }
    return replaceRange;
}
function $3a8d746702642fb5$var$createCompletionItem(name, isDir, replaceRange) {
    if (isDir) {
        name = name + '/';
        return {
            label: $3a8d746702642fb5$var$escapePath(name),
            kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Folder,
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(replaceRange, $3a8d746702642fb5$var$escapePath(name)),
            command: {
                title: 'Suggest',
                command: 'editor.action.triggerSuggest'
            }
        };
    } else return {
        label: $3a8d746702642fb5$var$escapePath(name),
        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).File,
        textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(replaceRange, $3a8d746702642fb5$var$escapePath(name))
    };
}
// Escape https://www.w3.org/TR/CSS1/#url
function $3a8d746702642fb5$var$escapePath(p) {
    return p.replace(/(\s|\(|\)|,|"|')/g, '\\$1');
}
function $3a8d746702642fb5$var$shiftPosition(pos, offset) {
    return (0, $1345bdc33671c7a9$exports.Position).create(pos.line, pos.character + offset);
}
function $3a8d746702642fb5$var$shiftRange(range, startOffset, endOffset) {
    const start = $3a8d746702642fb5$var$shiftPosition(range.start, startOffset);
    const end = $3a8d746702642fb5$var$shiftPosition(range.end, endOffset);
    return (0, $1345bdc33671c7a9$exports.Range).create(start, end);
}


'use strict';
const $0e5c8ce9d229cf3c$var$SnippetFormat = (0, $1345bdc33671c7a9$exports.InsertTextFormat).Snippet;
const $0e5c8ce9d229cf3c$var$retriggerCommand = {
    title: 'Suggest',
    command: 'editor.action.triggerSuggest'
};
var $0e5c8ce9d229cf3c$var$SortTexts;
(function(SortTexts) {
    // char code 32, comes before everything
    SortTexts["Enums"] = " ";
    SortTexts["Normal"] = "d";
    SortTexts["VendorPrefixed"] = "x";
    SortTexts["Term"] = "y";
    SortTexts["Variable"] = "z";
})($0e5c8ce9d229cf3c$var$SortTexts || ($0e5c8ce9d229cf3c$var$SortTexts = {}));
class $0e5c8ce9d229cf3c$export$59dbe4ad1c157302 {
    constructor(variablePrefix = null, lsOptions, cssDataManager){
        this.variablePrefix = variablePrefix;
        this.lsOptions = lsOptions;
        this.cssDataManager = cssDataManager;
        this.completionParticipants = [];
    }
    configure(settings) {
        this.defaultSettings = settings;
    }
    getSymbolContext() {
        if (!this.symbolContext) this.symbolContext = new (0, $0e1028d5f31bf222$export$fa456266707bf4e4)(this.styleSheet);
        return this.symbolContext;
    }
    setCompletionParticipants(registeredCompletionParticipants) {
        this.completionParticipants = registeredCompletionParticipants || [];
    }
    async doComplete2(document, position, styleSheet, documentContext, completionSettings = this.defaultSettings) {
        if (!this.lsOptions.fileSystemProvider || !this.lsOptions.fileSystemProvider.readDirectory) return this.doComplete(document, position, styleSheet, completionSettings);
        const participant = new (0, $3a8d746702642fb5$export$a1ba7ea3fde4aca5)(this.lsOptions.fileSystemProvider.readDirectory);
        const contributedParticipants = this.completionParticipants;
        this.completionParticipants = [
            participant
        ].concat(contributedParticipants);
        const result = this.doComplete(document, position, styleSheet, completionSettings);
        try {
            const pathCompletionResult = await participant.computeCompletions(document, documentContext);
            return {
                isIncomplete: result.isIncomplete || pathCompletionResult.isIncomplete,
                itemDefaults: result.itemDefaults,
                items: pathCompletionResult.items.concat(result.items)
            };
        } finally{
            this.completionParticipants = contributedParticipants;
        }
    }
    doComplete(document, position, styleSheet, documentSettings) {
        this.offset = document.offsetAt(position);
        this.position = position;
        this.currentWord = $0e5c8ce9d229cf3c$var$getCurrentWord(document, this.offset);
        this.defaultReplaceRange = (0, $1345bdc33671c7a9$exports.Range).create((0, $1345bdc33671c7a9$exports.Position).create(this.position.line, this.position.character - this.currentWord.length), this.position);
        this.textDocument = document;
        this.styleSheet = styleSheet;
        this.documentSettings = documentSettings;
        try {
            const result = {
                isIncomplete: false,
                itemDefaults: {
                    editRange: {
                        start: {
                            line: position.line,
                            character: position.character - this.currentWord.length
                        },
                        end: position
                    }
                },
                items: []
            };
            this.nodePath = $bd0cebf2eccc0e7e$export$7371e5dfbc4269ff(this.styleSheet, this.offset);
            for(let i = this.nodePath.length - 1; i >= 0; i--){
                const node = this.nodePath[i];
                if (node instanceof $bd0cebf2eccc0e7e$export$41b04b3a73e7216d) this.getCompletionsForDeclarationProperty(node.getParent(), result);
                else if (node instanceof $bd0cebf2eccc0e7e$export$bfe37c1342e5eb83) {
                    if (node.parent instanceof $bd0cebf2eccc0e7e$export$b0cc4f9860136880) this.getVariableProposals(null, result);
                    else this.getCompletionsForExpression(node, result);
                } else if (node instanceof $bd0cebf2eccc0e7e$export$bfa70abafbc5e495) {
                    const parentRef = node.findAParent($bd0cebf2eccc0e7e$export$f06e977173f1857c.ExtendsReference, $bd0cebf2eccc0e7e$export$f06e977173f1857c.Ruleset);
                    if (parentRef) {
                        if (parentRef.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.ExtendsReference) this.getCompletionsForExtendsReference(parentRef, node, result);
                        else {
                            const parentRuleSet = parentRef;
                            this.getCompletionsForSelector(parentRuleSet, parentRuleSet && parentRuleSet.isNested(), result);
                        }
                    }
                } else if (node instanceof $bd0cebf2eccc0e7e$export$5868bced5e602b28) this.getCompletionsForFunctionArgument(node, node.getParent(), result);
                else if (node instanceof $bd0cebf2eccc0e7e$export$86a08221bdddb90c) this.getCompletionsForDeclarations(node, result);
                else if (node instanceof $bd0cebf2eccc0e7e$export$839cf4f882eabac8) this.getCompletionsForVariableDeclaration(node, result);
                else if (node instanceof $bd0cebf2eccc0e7e$export$ade1230f1a17327c) this.getCompletionsForRuleSet(node, result);
                else if (node instanceof $bd0cebf2eccc0e7e$export$b0cc4f9860136880) this.getCompletionsForInterpolation(node, result);
                else if (node instanceof $bd0cebf2eccc0e7e$export$db0c6820087997c2) this.getCompletionsForFunctionDeclaration(node, result);
                else if (node instanceof $bd0cebf2eccc0e7e$export$8ca7a1a636597cad) this.getCompletionsForMixinReference(node, result);
                else if (node instanceof $bd0cebf2eccc0e7e$export$f3890eeaf6851387) this.getCompletionsForFunctionArgument(null, node, result);
                else if (node instanceof $bd0cebf2eccc0e7e$export$25be9502477c137d) this.getCompletionsForSupports(node, result);
                else if (node instanceof $bd0cebf2eccc0e7e$export$a895090a19988f16) this.getCompletionsForSupportsCondition(node, result);
                else if (node instanceof $bd0cebf2eccc0e7e$export$9b8dfe638de9b72f) this.getCompletionsForMediaCondition(node, result);
                else if (node instanceof $bd0cebf2eccc0e7e$export$aebff1c4d1af2d3a) this.getCompletionsForExtendsReference(node, null, result);
                else if (node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.URILiteral) this.getCompletionForUriLiteralValue(node, result);
                else if (node.parent === null) this.getCompletionForTopLevel(result);
                else if (node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.StringLiteral && this.isImportPathParent(node.parent.type)) this.getCompletionForImportPath(node, result);
                else continue;
                if (result.items.length > 0 || this.offset > node.offset) return this.finalize(result);
            }
            this.getCompletionsForStylesheet(result);
            if (result.items.length === 0) {
                if (this.variablePrefix && this.currentWord.indexOf(this.variablePrefix) === 0) this.getVariableProposals(null, result);
            }
            return this.finalize(result);
        } finally{
            // don't hold on any state, clear symbolContext
            this.position = null;
            this.currentWord = null;
            this.textDocument = null;
            this.styleSheet = null;
            this.symbolContext = null;
            this.defaultReplaceRange = null;
            this.nodePath = null;
        }
    }
    isImportPathParent(type) {
        return type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Import;
    }
    finalize(result) {
        return result;
    }
    findInNodePath(...types) {
        for(let i = this.nodePath.length - 1; i >= 0; i--){
            const node = this.nodePath[i];
            if (types.indexOf(node.type) !== -1) return node;
        }
        return null;
    }
    getCompletionsForDeclarationProperty(declaration, result) {
        return this.getPropertyProposals(declaration, result);
    }
    getPropertyProposals(declaration, result) {
        const triggerPropertyValueCompletion = this.isTriggerPropertyValueCompletionEnabled;
        const completePropertyWithSemicolon = this.isCompletePropertyWithSemicolonEnabled;
        const properties = this.cssDataManager.getProperties();
        properties.forEach((entry)=>{
            let range;
            let insertText;
            let retrigger = false;
            if (declaration) {
                range = this.getCompletionRange(declaration.getProperty());
                insertText = entry.name;
                if (!(0, $e213756046234466$export$4e62c701997796c1)(declaration.colonPosition)) {
                    insertText += ': ';
                    retrigger = true;
                }
            } else {
                range = this.getCompletionRange(null);
                insertText = entry.name + ': ';
                retrigger = true;
            }
            // Empty .selector { | } case
            if (!declaration && completePropertyWithSemicolon) insertText += '$0;';
            // Cases such as .selector { p; } or .selector { p:; }
            if (declaration && !declaration.semicolonPosition) {
                if (completePropertyWithSemicolon && this.offset >= this.textDocument.offsetAt(range.end)) insertText += '$0;';
            }
            const item = {
                label: entry.name,
                documentation: $d5592ab2ff7f18b0$export$7eaaf6bd9b4ee15(entry, this.doesSupportMarkdown()),
                tags: $0e5c8ce9d229cf3c$var$isDeprecated(entry) ? [
                    (0, $1345bdc33671c7a9$exports.CompletionItemTag).Deprecated
                ] : [],
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(range, insertText),
                insertTextFormat: (0, $1345bdc33671c7a9$exports.InsertTextFormat).Snippet,
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Property
            };
            if (triggerPropertyValueCompletion && retrigger) item.command = $0e5c8ce9d229cf3c$var$retriggerCommand;
            const relevance = typeof entry.relevance === 'number' ? Math.min(Math.max(entry.relevance, 0), 99) : 50;
            const sortTextSuffix = (255 - relevance).toString(16);
            const sortTextPrefix = $3383aa02dc8dfba4$export$68326237475e9a7d(entry.name, '-') ? $0e5c8ce9d229cf3c$var$SortTexts.VendorPrefixed : $0e5c8ce9d229cf3c$var$SortTexts.Normal;
            item.sortText = sortTextPrefix + '_' + sortTextSuffix;
            result.items.push(item);
        });
        this.completionParticipants.forEach((participant)=>{
            if (participant.onCssProperty) participant.onCssProperty({
                propertyName: this.currentWord,
                range: this.defaultReplaceRange
            });
        });
        return result;
    }
    get isTriggerPropertyValueCompletionEnabled() {
        return this.documentSettings?.triggerPropertyValueCompletion ?? true;
    }
    get isCompletePropertyWithSemicolonEnabled() {
        return this.documentSettings?.completePropertyWithSemicolon ?? true;
    }
    getCompletionsForDeclarationValue(node, result) {
        const propertyName = node.getFullPropertyName();
        const entry = this.cssDataManager.getProperty(propertyName);
        let existingNode = node.getValue() || null;
        while(existingNode && existingNode.hasChildren())existingNode = existingNode.findChildAtOffset(this.offset, false);
        this.completionParticipants.forEach((participant)=>{
            if (participant.onCssPropertyValue) participant.onCssPropertyValue({
                propertyName: propertyName,
                propertyValue: this.currentWord,
                range: this.getCompletionRange(existingNode)
            });
        });
        if (entry) {
            if (entry.restrictions) for (const restriction of entry.restrictions)switch(restriction){
                case 'color':
                    this.getColorProposals(entry, existingNode, result);
                    break;
                case 'position':
                    this.getPositionProposals(entry, existingNode, result);
                    break;
                case 'repeat':
                    this.getRepeatStyleProposals(entry, existingNode, result);
                    break;
                case 'line-style':
                    this.getLineStyleProposals(entry, existingNode, result);
                    break;
                case 'line-width':
                    this.getLineWidthProposals(entry, existingNode, result);
                    break;
                case 'geometry-box':
                    this.getGeometryBoxProposals(entry, existingNode, result);
                    break;
                case 'box':
                    this.getBoxProposals(entry, existingNode, result);
                    break;
                case 'image':
                    this.getImageProposals(entry, existingNode, result);
                    break;
                case 'timing-function':
                    this.getTimingFunctionProposals(entry, existingNode, result);
                    break;
                case 'shape':
                    this.getBasicShapeProposals(entry, existingNode, result);
                    break;
            }
            this.getValueEnumProposals(entry, existingNode, result);
            this.getCSSWideKeywordProposals(entry, existingNode, result);
            this.getUnitProposals(entry, existingNode, result);
        } else {
            const existingValues = $0e5c8ce9d229cf3c$var$collectValues(this.styleSheet, node);
            for (const existingValue of existingValues.getEntries())result.items.push({
                label: existingValue,
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), existingValue),
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Value
            });
        }
        this.getVariableProposals(existingNode, result);
        this.getTermProposals(entry, existingNode, result);
        return result;
    }
    getValueEnumProposals(entry, existingNode, result) {
        if (entry.values) for (const value of entry.values){
            let insertString = value.name;
            let insertTextFormat;
            if ($3383aa02dc8dfba4$export$10fdab3683b55b22(insertString, ')')) {
                const from = insertString.lastIndexOf('(');
                if (from !== -1) {
                    insertString = insertString.substring(0, from + 1) + '$1' + insertString.substring(from + 1);
                    insertTextFormat = $0e5c8ce9d229cf3c$var$SnippetFormat;
                }
            }
            let sortText = $0e5c8ce9d229cf3c$var$SortTexts.Enums;
            if ($3383aa02dc8dfba4$export$68326237475e9a7d(value.name, '-')) sortText += $0e5c8ce9d229cf3c$var$SortTexts.VendorPrefixed;
            const item = {
                label: value.name,
                documentation: $d5592ab2ff7f18b0$export$7eaaf6bd9b4ee15(value, this.doesSupportMarkdown()),
                tags: $0e5c8ce9d229cf3c$var$isDeprecated(entry) ? [
                    (0, $1345bdc33671c7a9$exports.CompletionItemTag).Deprecated
                ] : [],
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), insertString),
                sortText: sortText,
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Value,
                insertTextFormat: insertTextFormat
            };
            result.items.push(item);
        }
        return result;
    }
    getCSSWideKeywordProposals(entry, existingNode, result) {
        for(const keywords in $4b3cdcd55d375778$export$b3191e0d9e666e2c)result.items.push({
            label: keywords,
            documentation: $4b3cdcd55d375778$export$b3191e0d9e666e2c[keywords],
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), keywords),
            kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Value
        });
        for(const func in $4b3cdcd55d375778$export$859e4e371f252e6b){
            const insertText = $0e5c8ce9d229cf3c$var$moveCursorInsideParenthesis(func);
            result.items.push({
                label: func,
                documentation: $4b3cdcd55d375778$export$859e4e371f252e6b[func],
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), insertText),
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Function,
                insertTextFormat: $0e5c8ce9d229cf3c$var$SnippetFormat,
                command: $3383aa02dc8dfba4$export$68326237475e9a7d(func, 'var') ? $0e5c8ce9d229cf3c$var$retriggerCommand : undefined
            });
        }
        return result;
    }
    getCompletionsForInterpolation(node, result) {
        if (this.offset >= node.offset + 2) this.getVariableProposals(null, result);
        return result;
    }
    getVariableProposals(existingNode, result) {
        const symbols = this.getSymbolContext().findSymbolsAtOffset(this.offset, $bd0cebf2eccc0e7e$export$8868dff548d048cf.Variable);
        for (const symbol of symbols){
            const insertText = $3383aa02dc8dfba4$export$68326237475e9a7d(symbol.name, '--') ? `var(${symbol.name})` : symbol.name;
            const completionItem = {
                label: symbol.name,
                documentation: symbol.value ? $3383aa02dc8dfba4$export$f0f1baa56cbb57cb(symbol.value) : symbol.value,
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), insertText),
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Variable,
                sortText: $0e5c8ce9d229cf3c$var$SortTexts.Variable
            };
            if (typeof completionItem.documentation === 'string' && $6be89f889e93fd15$export$2c8400d58aca05e(completionItem.documentation)) completionItem.kind = (0, $1345bdc33671c7a9$exports.CompletionItemKind).Color;
            if (symbol.node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.FunctionParameter) {
                const mixinNode = symbol.node.getParent();
                if (mixinNode.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.MixinDeclaration) completionItem.detail = $3240faa9c744ac82$export$625550452a3fa3ec('argument from \'{0}\'', mixinNode.getName());
            }
            result.items.push(completionItem);
        }
        return result;
    }
    getVariableProposalsForCSSVarFunction(result) {
        const allReferencedVariables = new $0e5c8ce9d229cf3c$var$Set();
        this.styleSheet.acceptVisitor(new $0e5c8ce9d229cf3c$var$VariableCollector(allReferencedVariables, this.offset));
        let symbols = this.getSymbolContext().findSymbolsAtOffset(this.offset, $bd0cebf2eccc0e7e$export$8868dff548d048cf.Variable);
        for (const symbol of symbols){
            if ($3383aa02dc8dfba4$export$68326237475e9a7d(symbol.name, '--')) {
                const completionItem = {
                    label: symbol.name,
                    documentation: symbol.value ? $3383aa02dc8dfba4$export$f0f1baa56cbb57cb(symbol.value) : symbol.value,
                    textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(null), symbol.name),
                    kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Variable
                };
                if (typeof completionItem.documentation === 'string' && $6be89f889e93fd15$export$2c8400d58aca05e(completionItem.documentation)) completionItem.kind = (0, $1345bdc33671c7a9$exports.CompletionItemKind).Color;
                result.items.push(completionItem);
            }
            allReferencedVariables.remove(symbol.name);
        }
        for (const name of allReferencedVariables.getEntries())if ($3383aa02dc8dfba4$export$68326237475e9a7d(name, '--')) {
            const completionItem = {
                label: name,
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(null), name),
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Variable
            };
            result.items.push(completionItem);
        }
        return result;
    }
    getUnitProposals(entry, existingNode, result) {
        let currentWord = '0';
        if (this.currentWord.length > 0) {
            const numMatch = this.currentWord.match(/^-?\d[\.\d+]*/);
            if (numMatch) {
                currentWord = numMatch[0];
                result.isIncomplete = currentWord.length === this.currentWord.length;
            }
        } else if (this.currentWord.length === 0) result.isIncomplete = true;
        if (existingNode && existingNode.parent && existingNode.parent.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Term) existingNode = existingNode.getParent(); // include the unary operator
        if (entry.restrictions) for (const restriction of entry.restrictions){
            const units = $4b3cdcd55d375778$export$fe0319385f0cf5a7[restriction];
            if (units) for (const unit of units){
                const insertText = currentWord + unit;
                result.items.push({
                    label: insertText,
                    textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), insertText),
                    kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Unit
                });
            }
        }
        return result;
    }
    getCompletionRange(existingNode) {
        if (existingNode && existingNode.offset <= this.offset && this.offset <= existingNode.end) {
            const end = existingNode.end !== -1 ? this.textDocument.positionAt(existingNode.end) : this.position;
            const start = this.textDocument.positionAt(existingNode.offset);
            if (start.line === end.line) return (0, $1345bdc33671c7a9$exports.Range).create(start, end); // multi line edits are not allowed
        }
        return this.defaultReplaceRange;
    }
    getColorProposals(entry, existingNode, result) {
        for(const color in $6be89f889e93fd15$export$8f45430ccf837300)result.items.push({
            label: color,
            documentation: $6be89f889e93fd15$export$8f45430ccf837300[color],
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), color),
            kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Color
        });
        for(const color in $6be89f889e93fd15$export$3b0ad6ab62bdaba6)result.items.push({
            label: color,
            documentation: $6be89f889e93fd15$export$3b0ad6ab62bdaba6[color],
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), color),
            kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Value
        });
        const colorValues = new $0e5c8ce9d229cf3c$var$Set();
        this.styleSheet.acceptVisitor(new $0e5c8ce9d229cf3c$var$ColorValueCollector(colorValues, this.offset));
        for (const color of colorValues.getEntries())result.items.push({
            label: color,
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), color),
            kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Color
        });
        for (const p of $6be89f889e93fd15$export$41287bde05ee58e7)result.items.push({
            label: p.label,
            detail: p.func,
            documentation: p.desc,
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), p.insertText),
            insertTextFormat: $0e5c8ce9d229cf3c$var$SnippetFormat,
            kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Function
        });
        return result;
    }
    getPositionProposals(entry, existingNode, result) {
        for(const position in $4b3cdcd55d375778$export$6767d05f2d3f94f0)result.items.push({
            label: position,
            documentation: $4b3cdcd55d375778$export$6767d05f2d3f94f0[position],
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), position),
            kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Value
        });
        return result;
    }
    getRepeatStyleProposals(entry, existingNode, result) {
        for(const repeat in $4b3cdcd55d375778$export$3f9cacf8bddbd0c8)result.items.push({
            label: repeat,
            documentation: $4b3cdcd55d375778$export$3f9cacf8bddbd0c8[repeat],
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), repeat),
            kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Value
        });
        return result;
    }
    getLineStyleProposals(entry, existingNode, result) {
        for(const lineStyle in $4b3cdcd55d375778$export$c0ee9796c60d7764)result.items.push({
            label: lineStyle,
            documentation: $4b3cdcd55d375778$export$c0ee9796c60d7764[lineStyle],
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), lineStyle),
            kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Value
        });
        return result;
    }
    getLineWidthProposals(entry, existingNode, result) {
        for (const lineWidth of $4b3cdcd55d375778$export$3373907888be2284)result.items.push({
            label: lineWidth,
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), lineWidth),
            kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Value
        });
        return result;
    }
    getGeometryBoxProposals(entry, existingNode, result) {
        for(const box in $4b3cdcd55d375778$export$c6dc41dffca85e83)result.items.push({
            label: box,
            documentation: $4b3cdcd55d375778$export$c6dc41dffca85e83[box],
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), box),
            kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Value
        });
        return result;
    }
    getBoxProposals(entry, existingNode, result) {
        for(const box in $4b3cdcd55d375778$export$90b90bffda3be805)result.items.push({
            label: box,
            documentation: $4b3cdcd55d375778$export$90b90bffda3be805[box],
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), box),
            kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Value
        });
        return result;
    }
    getImageProposals(entry, existingNode, result) {
        for(const image in $4b3cdcd55d375778$export$c69b22a9efcf76c8){
            const insertText = $0e5c8ce9d229cf3c$var$moveCursorInsideParenthesis(image);
            result.items.push({
                label: image,
                documentation: $4b3cdcd55d375778$export$c69b22a9efcf76c8[image],
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), insertText),
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Function,
                insertTextFormat: image !== insertText ? $0e5c8ce9d229cf3c$var$SnippetFormat : void 0
            });
        }
        return result;
    }
    getTimingFunctionProposals(entry, existingNode, result) {
        for(const timing in $4b3cdcd55d375778$export$10889f3d8c705a70){
            const insertText = $0e5c8ce9d229cf3c$var$moveCursorInsideParenthesis(timing);
            result.items.push({
                label: timing,
                documentation: $4b3cdcd55d375778$export$10889f3d8c705a70[timing],
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), insertText),
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Function,
                insertTextFormat: timing !== insertText ? $0e5c8ce9d229cf3c$var$SnippetFormat : void 0
            });
        }
        return result;
    }
    getBasicShapeProposals(entry, existingNode, result) {
        for(const shape in $4b3cdcd55d375778$export$1282eb203ed8dd05){
            const insertText = $0e5c8ce9d229cf3c$var$moveCursorInsideParenthesis(shape);
            result.items.push({
                label: shape,
                documentation: $4b3cdcd55d375778$export$1282eb203ed8dd05[shape],
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), insertText),
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Function,
                insertTextFormat: shape !== insertText ? $0e5c8ce9d229cf3c$var$SnippetFormat : void 0
            });
        }
        return result;
    }
    getCompletionsForStylesheet(result) {
        const node = this.styleSheet.findFirstChildBeforeOffset(this.offset);
        if (!node) return this.getCompletionForTopLevel(result);
        if (node instanceof $bd0cebf2eccc0e7e$export$ade1230f1a17327c) return this.getCompletionsForRuleSet(node, result);
        if (node instanceof $bd0cebf2eccc0e7e$export$25be9502477c137d) return this.getCompletionsForSupports(node, result);
        return result;
    }
    getCompletionForTopLevel(result) {
        this.cssDataManager.getAtDirectives().forEach((entry)=>{
            result.items.push({
                label: entry.name,
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(null), entry.name),
                documentation: $d5592ab2ff7f18b0$export$7eaaf6bd9b4ee15(entry, this.doesSupportMarkdown()),
                tags: $0e5c8ce9d229cf3c$var$isDeprecated(entry) ? [
                    (0, $1345bdc33671c7a9$exports.CompletionItemTag).Deprecated
                ] : [],
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
            });
        });
        this.getCompletionsForSelector(null, false, result);
        return result;
    }
    getCompletionsForRuleSet(ruleSet, result) {
        const declarations = ruleSet.getDeclarations();
        const isAfter = declarations && declarations.endsWith('}') && this.offset >= declarations.end;
        if (isAfter) return this.getCompletionForTopLevel(result);
        const isInSelectors = !declarations || this.offset <= declarations.offset;
        if (isInSelectors) return this.getCompletionsForSelector(ruleSet, ruleSet.isNested(), result);
        return this.getCompletionsForDeclarations(ruleSet.getDeclarations(), result);
    }
    getCompletionsForSelector(ruleSet, isNested, result) {
        const existingNode = this.findInNodePath($bd0cebf2eccc0e7e$export$f06e977173f1857c.PseudoSelector, $bd0cebf2eccc0e7e$export$f06e977173f1857c.IdentifierSelector, $bd0cebf2eccc0e7e$export$f06e977173f1857c.ClassSelector, $bd0cebf2eccc0e7e$export$f06e977173f1857c.ElementNameSelector);
        if (!existingNode && this.hasCharacterAtPosition(this.offset - this.currentWord.length - 1, ':')) {
            // after the ':' of a pseudo selector, no node generated for just ':'
            this.currentWord = ':' + this.currentWord;
            if (this.hasCharacterAtPosition(this.offset - this.currentWord.length - 1, ':')) this.currentWord = ':' + this.currentWord; // for '::'
            this.defaultReplaceRange = (0, $1345bdc33671c7a9$exports.Range).create((0, $1345bdc33671c7a9$exports.Position).create(this.position.line, this.position.character - this.currentWord.length), this.position);
        }
        const pseudoClasses = this.cssDataManager.getPseudoClasses();
        pseudoClasses.forEach((entry)=>{
            const insertText = $0e5c8ce9d229cf3c$var$moveCursorInsideParenthesis(entry.name);
            const item = {
                label: entry.name,
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), insertText),
                documentation: $d5592ab2ff7f18b0$export$7eaaf6bd9b4ee15(entry, this.doesSupportMarkdown()),
                tags: $0e5c8ce9d229cf3c$var$isDeprecated(entry) ? [
                    (0, $1345bdc33671c7a9$exports.CompletionItemTag).Deprecated
                ] : [],
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Function,
                insertTextFormat: entry.name !== insertText ? $0e5c8ce9d229cf3c$var$SnippetFormat : void 0
            };
            if ($3383aa02dc8dfba4$export$68326237475e9a7d(entry.name, ':-')) item.sortText = $0e5c8ce9d229cf3c$var$SortTexts.VendorPrefixed;
            result.items.push(item);
        });
        const pseudoElements = this.cssDataManager.getPseudoElements();
        pseudoElements.forEach((entry)=>{
            const insertText = $0e5c8ce9d229cf3c$var$moveCursorInsideParenthesis(entry.name);
            const item = {
                label: entry.name,
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), insertText),
                documentation: $d5592ab2ff7f18b0$export$7eaaf6bd9b4ee15(entry, this.doesSupportMarkdown()),
                tags: $0e5c8ce9d229cf3c$var$isDeprecated(entry) ? [
                    (0, $1345bdc33671c7a9$exports.CompletionItemTag).Deprecated
                ] : [],
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Function,
                insertTextFormat: entry.name !== insertText ? $0e5c8ce9d229cf3c$var$SnippetFormat : void 0
            };
            if ($3383aa02dc8dfba4$export$68326237475e9a7d(entry.name, '::-')) item.sortText = $0e5c8ce9d229cf3c$var$SortTexts.VendorPrefixed;
            result.items.push(item);
        });
        if (!isNested) {
            for (const entry of $4b3cdcd55d375778$export$a5b0ceca3b8901d2)result.items.push({
                label: entry,
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), entry),
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
            });
            for (const entry of $4b3cdcd55d375778$export$cf20112a1bc148da)result.items.push({
                label: entry,
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), entry),
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
            });
        }
        const visited = {};
        visited[this.currentWord] = true;
        const docText = this.textDocument.getText();
        this.styleSheet.accept((n)=>{
            if (n.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.SimpleSelector && n.length > 0) {
                const selector = docText.substr(n.offset, n.length);
                if (selector.charAt(0) === '.' && !visited[selector]) {
                    visited[selector] = true;
                    result.items.push({
                        label: selector,
                        textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), selector),
                        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
                    });
                }
                return false;
            }
            return true;
        });
        if (ruleSet && ruleSet.isNested()) {
            const selector = ruleSet.getSelectors().findFirstChildBeforeOffset(this.offset);
            if (selector && ruleSet.getSelectors().getChildren().indexOf(selector) === 0) this.getPropertyProposals(null, result);
        }
        return result;
    }
    getCompletionsForDeclarations(declarations, result) {
        if (!declarations || this.offset === declarations.offset) return result;
        const node = declarations.findFirstChildBeforeOffset(this.offset);
        if (!node) return this.getCompletionsForDeclarationProperty(null, result);
        if (node instanceof $bd0cebf2eccc0e7e$export$d0574b2f663baa17) {
            const declaration = node;
            if (!(0, $e213756046234466$export$4e62c701997796c1)(declaration.colonPosition) || this.offset <= declaration.colonPosition) // complete property
            return this.getCompletionsForDeclarationProperty(declaration, result);
            else if ((0, $e213756046234466$export$4e62c701997796c1)(declaration.semicolonPosition) && declaration.semicolonPosition < this.offset) {
                if (this.offset === declaration.semicolonPosition + 1) return result; // don't show new properties right after semicolon (see Bug 15421:[intellisense] [css] Be less aggressive when manually typing CSS)
                // complete next property
                return this.getCompletionsForDeclarationProperty(null, result);
            }
            if (declaration instanceof $bd0cebf2eccc0e7e$export$48f3d9e786303b67) // complete value
            return this.getCompletionsForDeclarationValue(declaration, result);
        } else if (node instanceof $bd0cebf2eccc0e7e$export$aebff1c4d1af2d3a) this.getCompletionsForExtendsReference(node, null, result);
        else if (this.currentWord && this.currentWord[0] === '@') this.getCompletionsForDeclarationProperty(null, result);
        else if (node instanceof $bd0cebf2eccc0e7e$export$ade1230f1a17327c) this.getCompletionsForDeclarationProperty(null, result);
        return result;
    }
    getCompletionsForVariableDeclaration(declaration, result) {
        if (this.offset && (0, $e213756046234466$export$4e62c701997796c1)(declaration.colonPosition) && this.offset > declaration.colonPosition) this.getVariableProposals(declaration.getValue() || null, result);
        return result;
    }
    getCompletionsForExpression(expression, result) {
        const parent = expression.getParent();
        if (parent instanceof $bd0cebf2eccc0e7e$export$5868bced5e602b28) {
            this.getCompletionsForFunctionArgument(parent, parent.getParent(), result);
            return result;
        }
        const declaration = expression.findParent($bd0cebf2eccc0e7e$export$f06e977173f1857c.Declaration);
        if (!declaration) {
            this.getTermProposals(undefined, null, result);
            return result;
        }
        const node = expression.findChildAtOffset(this.offset, true);
        if (!node) return this.getCompletionsForDeclarationValue(declaration, result);
        if (node instanceof $bd0cebf2eccc0e7e$export$8c91fb1ff010a18e || node instanceof $bd0cebf2eccc0e7e$export$989167234458594d) return this.getCompletionsForDeclarationValue(declaration, result);
        return result;
    }
    getCompletionsForFunctionArgument(arg, func, result) {
        const identifier = func.getIdentifier();
        if (identifier && identifier.matches('var')) {
            if (!func.getArguments().hasChildren() || func.getArguments().getChild(0) === arg) this.getVariableProposalsForCSSVarFunction(result);
        }
        return result;
    }
    getCompletionsForFunctionDeclaration(decl, result) {
        const declarations = decl.getDeclarations();
        if (declarations && this.offset > declarations.offset && this.offset < declarations.end) this.getTermProposals(undefined, null, result);
        return result;
    }
    getCompletionsForMixinReference(ref, result) {
        const allMixins = this.getSymbolContext().findSymbolsAtOffset(this.offset, $bd0cebf2eccc0e7e$export$8868dff548d048cf.Mixin);
        for (const mixinSymbol of allMixins)if (mixinSymbol.node instanceof $bd0cebf2eccc0e7e$export$f518258a40310702) result.items.push(this.makeTermProposal(mixinSymbol, mixinSymbol.node.getParameters(), null));
        const identifierNode = ref.getIdentifier() || null;
        this.completionParticipants.forEach((participant)=>{
            if (participant.onCssMixinReference) participant.onCssMixinReference({
                mixinName: this.currentWord,
                range: this.getCompletionRange(identifierNode)
            });
        });
        return result;
    }
    getTermProposals(entry, existingNode, result) {
        const allFunctions = this.getSymbolContext().findSymbolsAtOffset(this.offset, $bd0cebf2eccc0e7e$export$8868dff548d048cf.Function);
        for (const functionSymbol of allFunctions)if (functionSymbol.node instanceof $bd0cebf2eccc0e7e$export$db0c6820087997c2) result.items.push(this.makeTermProposal(functionSymbol, functionSymbol.node.getParameters(), existingNode));
        return result;
    }
    makeTermProposal(symbol, parameters, existingNode) {
        const decl = symbol.node;
        const params = parameters.getChildren().map((c)=>{
            return c instanceof $bd0cebf2eccc0e7e$export$e8b5f24364ee45a9 ? c.getName() : c.getText();
        });
        const insertText = symbol.name + '(' + params.map((p, index)=>'${' + (index + 1) + ':' + p + '}').join(', ') + ')';
        return {
            label: symbol.name,
            detail: symbol.name + '(' + params.join(', ') + ')',
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), insertText),
            insertTextFormat: $0e5c8ce9d229cf3c$var$SnippetFormat,
            kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Function,
            sortText: $0e5c8ce9d229cf3c$var$SortTexts.Term
        };
    }
    getCompletionsForSupportsCondition(supportsCondition, result) {
        const child = supportsCondition.findFirstChildBeforeOffset(this.offset);
        if (child) {
            if (child instanceof $bd0cebf2eccc0e7e$export$48f3d9e786303b67) {
                if (!(0, $e213756046234466$export$4e62c701997796c1)(child.colonPosition) || this.offset <= child.colonPosition) return this.getCompletionsForDeclarationProperty(child, result);
                else return this.getCompletionsForDeclarationValue(child, result);
            } else if (child instanceof $bd0cebf2eccc0e7e$export$a895090a19988f16) return this.getCompletionsForSupportsCondition(child, result);
        }
        if ((0, $e213756046234466$export$4e62c701997796c1)(supportsCondition.lParent) && this.offset > supportsCondition.lParent && (!(0, $e213756046234466$export$4e62c701997796c1)(supportsCondition.rParent) || this.offset <= supportsCondition.rParent)) return this.getCompletionsForDeclarationProperty(null, result);
        return result;
    }
    getCompletionsForSupports(supports, result) {
        const declarations = supports.getDeclarations();
        const inInCondition = !declarations || this.offset <= declarations.offset;
        if (inInCondition) {
            const child = supports.findFirstChildBeforeOffset(this.offset);
            if (child instanceof $bd0cebf2eccc0e7e$export$a895090a19988f16) return this.getCompletionsForSupportsCondition(child, result);
            return result;
        }
        return this.getCompletionForTopLevel(result);
    }
    getCompletionsForMediaCondition(mediaCondition, result) {
        const child = mediaCondition.findFirstChildBeforeOffset(this.offset);
        if (child) {
            if (child instanceof $bd0cebf2eccc0e7e$export$a38b0f36e6ad18cf) {
                const featureName = child.getChild(0);
                if (featureName && this.offset > featureName.end) {
                    const name = featureName.getText();
                    const media = this.cssDataManager.getAtDirective('@media')?.descriptors?.find((descriptor)=>descriptor.name === name);
                    if (media) return this.getValueEnumProposals(media, null, result);
                }
            } else if (child instanceof $bd0cebf2eccc0e7e$export$9b8dfe638de9b72f) return this.getCompletionsForMediaCondition(child, result);
        }
        // Return all media descriptors
        const media = this.cssDataManager.getAtDirective('@media');
        for (const descriptor of media?.descriptors || []){
            let command = undefined;
            let text = descriptor.name;
            if (descriptor.type === 'discrete') {
                // Change this check when we support auto completes for other types
                if (descriptor.values) command = $0e5c8ce9d229cf3c$var$retriggerCommand;
                text = `${descriptor.name}: `;
            }
            result.items.push({
                label: descriptor.name,
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(null), text),
                documentation: $d5592ab2ff7f18b0$export$7eaaf6bd9b4ee15(descriptor, this.doesSupportMarkdown()),
                tags: $0e5c8ce9d229cf3c$var$isDeprecated(descriptor) ? [
                    (0, $1345bdc33671c7a9$exports.CompletionItemTag).Deprecated
                ] : [],
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword,
                command: command
            });
        }
        return result;
    }
    getCompletionsForExtendsReference(extendsRef, existingNode, result) {
        return result;
    }
    getCompletionForUriLiteralValue(uriLiteralNode, result) {
        let uriValue;
        let position;
        let range;
        // No children, empty value
        if (!uriLiteralNode.hasChildren()) {
            uriValue = '';
            position = this.position;
            const emptyURIValuePosition = this.textDocument.positionAt(uriLiteralNode.offset + 4);
            range = (0, $1345bdc33671c7a9$exports.Range).create(emptyURIValuePosition, emptyURIValuePosition);
        } else {
            const uriValueNode = uriLiteralNode.getChild(0);
            uriValue = uriValueNode.getText();
            position = this.position;
            range = this.getCompletionRange(uriValueNode);
        }
        this.completionParticipants.forEach((participant)=>{
            if (participant.onCssURILiteralValue) participant.onCssURILiteralValue({
                uriValue: uriValue,
                position: position,
                range: range
            });
        });
        return result;
    }
    getCompletionForImportPath(importPathNode, result) {
        this.completionParticipants.forEach((participant)=>{
            if (participant.onCssImportPath) participant.onCssImportPath({
                pathValue: importPathNode.getText(),
                position: this.position,
                range: this.getCompletionRange(importPathNode)
            });
        });
        return result;
    }
    hasCharacterAtPosition(offset, char) {
        const text = this.textDocument.getText();
        return offset >= 0 && offset < text.length && text.charAt(offset) === char;
    }
    doesSupportMarkdown() {
        if (!(0, $e213756046234466$export$4e62c701997796c1)(this.supportsMarkdown)) {
            if (!(0, $e213756046234466$export$4e62c701997796c1)(this.lsOptions.clientCapabilities)) {
                this.supportsMarkdown = true;
                return this.supportsMarkdown;
            }
            const documentationFormat = this.lsOptions.clientCapabilities.textDocument?.completion?.completionItem?.documentationFormat;
            this.supportsMarkdown = Array.isArray(documentationFormat) && documentationFormat.indexOf((0, $1345bdc33671c7a9$exports.MarkupKind).Markdown) !== -1;
        }
        return this.supportsMarkdown;
    }
}
function $0e5c8ce9d229cf3c$var$isDeprecated(entry) {
    if (entry.status && (entry.status === 'nonstandard' || entry.status === 'obsolete')) return true;
    return false;
}
class $0e5c8ce9d229cf3c$var$Set {
    constructor(){
        this.entries = {};
    }
    add(entry) {
        this.entries[entry] = true;
    }
    remove(entry) {
        delete this.entries[entry];
    }
    getEntries() {
        return Object.keys(this.entries);
    }
}
function $0e5c8ce9d229cf3c$var$moveCursorInsideParenthesis(text) {
    return text.replace(/\(\)$/, "($1)");
}
function $0e5c8ce9d229cf3c$var$collectValues(styleSheet, declaration) {
    const fullPropertyName = declaration.getFullPropertyName();
    const entries = new $0e5c8ce9d229cf3c$var$Set();
    function visitValue(node) {
        if (node instanceof $bd0cebf2eccc0e7e$export$989167234458594d || node instanceof $bd0cebf2eccc0e7e$export$8c91fb1ff010a18e || node instanceof $bd0cebf2eccc0e7e$export$7d5dd309eeea3db1) entries.add(node.getText());
        return true;
    }
    function matchesProperty(decl) {
        const propertyName = decl.getFullPropertyName();
        return fullPropertyName === propertyName;
    }
    function vistNode(node) {
        if (node instanceof $bd0cebf2eccc0e7e$export$48f3d9e786303b67 && node !== declaration) {
            if (matchesProperty(node)) {
                const value = node.getValue();
                if (value) value.accept(visitValue);
            }
        }
        return true;
    }
    styleSheet.accept(vistNode);
    return entries;
}
class $0e5c8ce9d229cf3c$var$ColorValueCollector {
    constructor(entries, currentOffset){
        this.entries = entries;
        this.currentOffset = currentOffset;
    // nothing to do
    }
    visitNode(node) {
        if (node instanceof $bd0cebf2eccc0e7e$export$7d5dd309eeea3db1 || node instanceof $bd0cebf2eccc0e7e$export$f3890eeaf6851387 && $6be89f889e93fd15$export$74126c8531eff483(node)) {
            if (this.currentOffset < node.offset || node.end < this.currentOffset) this.entries.add(node.getText());
        }
        return true;
    }
}
class $0e5c8ce9d229cf3c$var$VariableCollector {
    constructor(entries, currentOffset){
        this.entries = entries;
        this.currentOffset = currentOffset;
    // nothing to do
    }
    visitNode(node) {
        if (node instanceof $bd0cebf2eccc0e7e$export$989167234458594d && node.isCustomProperty) {
            if (this.currentOffset < node.offset || node.end < this.currentOffset) this.entries.add(node.getText());
        }
        return true;
    }
}
function $0e5c8ce9d229cf3c$var$getCurrentWord(document, offset) {
    let i = offset - 1;
    const text = document.getText();
    while(i >= 0 && ' \t\n\r":{[()]},*>+'.indexOf(text.charAt(i)) === -1)i--;
    return text.substring(i + 1, offset);
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 



'use strict';
class $3944e26ba312d5ab$export$db77ccec0bb4ccac {
    constructor(){
        this.parent = null;
        this.children = null;
        this.attributes = null;
    }
    findAttribute(name) {
        if (this.attributes) for (const attribute of this.attributes){
            if (attribute.name === name) return attribute.value;
        }
        return null;
    }
    addChild(child) {
        if (child instanceof $3944e26ba312d5ab$export$db77ccec0bb4ccac) child.parent = this;
        if (!this.children) this.children = [];
        this.children.push(child);
    }
    append(text) {
        if (this.attributes) {
            const last = this.attributes[this.attributes.length - 1];
            last.value = last.value + text;
        }
    }
    prepend(text) {
        if (this.attributes) {
            const first = this.attributes[0];
            first.value = text + first.value;
        }
    }
    findRoot() {
        let curr = this;
        while(curr.parent && !(curr.parent instanceof $3944e26ba312d5ab$export$c06e9b40b0d02ca))curr = curr.parent;
        return curr;
    }
    removeChild(child) {
        if (this.children) {
            const index = this.children.indexOf(child);
            if (index !== -1) {
                this.children.splice(index, 1);
                return true;
            }
        }
        return false;
    }
    addAttr(name, value) {
        if (!this.attributes) this.attributes = [];
        for (const attribute of this.attributes)if (attribute.name === name) {
            attribute.value += ' ' + value;
            return;
        }
        this.attributes.push({
            name: name,
            value: value
        });
    }
    clone(cloneChildren = true) {
        const elem = new $3944e26ba312d5ab$export$db77ccec0bb4ccac();
        if (this.attributes) {
            elem.attributes = [];
            for (const attribute of this.attributes)elem.addAttr(attribute.name, attribute.value);
        }
        if (cloneChildren && this.children) {
            elem.children = [];
            for(let index = 0; index < this.children.length; index++)elem.addChild(this.children[index].clone());
        }
        return elem;
    }
    cloneWithParent() {
        const clone = this.clone(false);
        if (this.parent && !(this.parent instanceof $3944e26ba312d5ab$export$c06e9b40b0d02ca)) {
            const parentClone = this.parent.cloneWithParent();
            parentClone.addChild(clone);
        }
        return clone;
    }
}
class $3944e26ba312d5ab$export$c06e9b40b0d02ca extends $3944e26ba312d5ab$export$db77ccec0bb4ccac {
}
class $3944e26ba312d5ab$export$8f0f6d143a513bf6 extends $3944e26ba312d5ab$export$db77ccec0bb4ccac {
    constructor(label){
        super();
        this.addAttr('name', label);
    }
}
class $3944e26ba312d5ab$var$MarkedStringPrinter {
    constructor(quote){
        this.quote = quote;
        this.result = [];
    // empty
    }
    print(element, selectorContexts) {
        this.result = [];
        if (element instanceof $3944e26ba312d5ab$export$c06e9b40b0d02ca) {
            if (element.children) this.doPrint(element.children, 0);
        } else this.doPrint([
            element
        ], 0);
        let value;
        if (selectorContexts) value = [
            ...selectorContexts,
            ...this.result
        ].join('\n');
        else value = this.result.join('\n');
        return [
            {
                language: 'html',
                value: value
            }
        ];
    }
    doPrint(elements, indent) {
        for (const element of elements){
            this.doPrintElement(element, indent);
            if (element.children) this.doPrint(element.children, indent + 1);
        }
    }
    writeLine(level, content) {
        const indent = new Array(level + 1).join('  ');
        this.result.push(indent + content);
    }
    doPrintElement(element, indent) {
        const name = element.findAttribute('name');
        // special case: a simple label
        if (element instanceof $3944e26ba312d5ab$export$8f0f6d143a513bf6 || name === '\u2026') {
            this.writeLine(indent, name);
            return;
        }
        // the real deal
        const content = [
            '<'
        ];
        // element name
        if (name) content.push(name);
        else content.push('element');
        // attributes
        if (element.attributes) {
            for (const attr of element.attributes)if (attr.name !== 'name') {
                content.push(' ');
                content.push(attr.name);
                const value = attr.value;
                if (value) {
                    content.push('=');
                    content.push($3944e26ba312d5ab$var$quotes.ensure(value, this.quote));
                }
            }
        }
        content.push('>');
        this.writeLine(indent, content.join(''));
    }
}
var $3944e26ba312d5ab$var$quotes;
(function(quotes) {
    function ensure(value, which) {
        return which + remove(value) + which;
    }
    quotes.ensure = ensure;
    function remove(value) {
        const match = value.match(/^['"](.*)["']$/);
        if (match) return match[1];
        return value;
    }
    quotes.remove = remove;
})($3944e26ba312d5ab$var$quotes || ($3944e26ba312d5ab$var$quotes = {}));
class $3944e26ba312d5ab$var$Specificity {
    constructor(){
        /** Count of identifiers (e.g., `#app`) */ this.id = 0;
        /** Count of attributes (`[type="number"]`), classes (`.container-fluid`), and pseudo-classes (`:hover`) */ this.attr = 0;
        /** Count of tag names (`div`), and pseudo-elements (`::before`) */ this.tag = 0;
    }
}
function $3944e26ba312d5ab$export$8d51e3db1a844094(node, parentElement) {
    let result = new $3944e26ba312d5ab$export$db77ccec0bb4ccac();
    for (const child of node.getChildren())switch(child.type){
        case $bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorCombinator:
            if (parentElement) {
                const segments = child.getText().split('&');
                if (segments.length === 1) {
                    // should not happen
                    result.addAttr('name', segments[0]);
                    break;
                }
                result = parentElement.cloneWithParent();
                if (segments[0]) {
                    const root = result.findRoot();
                    root.prepend(segments[0]);
                }
                for(let i = 1; i < segments.length; i++){
                    if (i > 1) {
                        const clone = parentElement.cloneWithParent();
                        result.addChild(clone.findRoot());
                        result = clone;
                    }
                    result.append(segments[i]);
                }
            }
            break;
        case $bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorPlaceholder:
            if (child.matches('@at-root')) return result;
        // fall through
        case $bd0cebf2eccc0e7e$export$f06e977173f1857c.ElementNameSelector:
            const text = child.getText();
            result.addAttr('name', text === '*' ? 'element' : $3944e26ba312d5ab$var$unescape(text));
            break;
        case $bd0cebf2eccc0e7e$export$f06e977173f1857c.ClassSelector:
            result.addAttr('class', $3944e26ba312d5ab$var$unescape(child.getText().substring(1)));
            break;
        case $bd0cebf2eccc0e7e$export$f06e977173f1857c.IdentifierSelector:
            result.addAttr('id', $3944e26ba312d5ab$var$unescape(child.getText().substring(1)));
            break;
        case $bd0cebf2eccc0e7e$export$f06e977173f1857c.MixinDeclaration:
            result.addAttr('class', child.getName());
            break;
        case $bd0cebf2eccc0e7e$export$f06e977173f1857c.PseudoSelector:
            result.addAttr($3944e26ba312d5ab$var$unescape(child.getText()), '');
            break;
        case $bd0cebf2eccc0e7e$export$f06e977173f1857c.AttributeSelector:
            const selector = child;
            const identifier = selector.getIdentifier();
            if (identifier) {
                const expression = selector.getValue();
                const operator = selector.getOperator();
                let value;
                if (expression && operator) switch($3944e26ba312d5ab$var$unescape(operator.getText())){
                    case '|=':
                        // excatly or followed by -words
                        value = `${$3944e26ba312d5ab$var$quotes.remove($3944e26ba312d5ab$var$unescape(expression.getText()))}-\u2026`;
                        break;
                    case '^=':
                        // prefix
                        value = `${$3944e26ba312d5ab$var$quotes.remove($3944e26ba312d5ab$var$unescape(expression.getText()))}\u2026`;
                        break;
                    case '$=':
                        // suffix
                        value = `\u2026${$3944e26ba312d5ab$var$quotes.remove($3944e26ba312d5ab$var$unescape(expression.getText()))}`;
                        break;
                    case '~=':
                        // one of a list of words
                        value = ` \u2026 ${$3944e26ba312d5ab$var$quotes.remove($3944e26ba312d5ab$var$unescape(expression.getText()))} \u2026 `;
                        break;
                    case '*=':
                        // substring
                        value = `\u2026${$3944e26ba312d5ab$var$quotes.remove($3944e26ba312d5ab$var$unescape(expression.getText()))}\u2026`;
                        break;
                    default:
                        value = $3944e26ba312d5ab$var$quotes.remove($3944e26ba312d5ab$var$unescape(expression.getText()));
                        break;
                }
                result.addAttr($3944e26ba312d5ab$var$unescape(identifier.getText()), value);
            }
            break;
    }
    return result;
}
function $3944e26ba312d5ab$var$unescape(content) {
    const scanner = new (0, $2a533f0146ced75e$export$2da42535f3a161df)();
    scanner.setSource(content);
    const token = scanner.scanUnquotedString();
    if (token) return token.text;
    return content;
}
class $3944e26ba312d5ab$export$57dc82f081ca6d62 {
    constructor(cssDataManager){
        this.cssDataManager = cssDataManager;
    }
    selectorToMarkedString(node, selectorContexts) {
        const root = $3944e26ba312d5ab$export$41107a8aec02d1d9(node);
        if (root) {
            const markedStrings = new $3944e26ba312d5ab$var$MarkedStringPrinter('"').print(root, selectorContexts);
            markedStrings.push(this.selectorToSpecificityMarkedString(node));
            return markedStrings;
        } else return [];
    }
    simpleSelectorToMarkedString(node) {
        const element = $3944e26ba312d5ab$export$8d51e3db1a844094(node);
        const markedStrings = new $3944e26ba312d5ab$var$MarkedStringPrinter('"').print(element);
        markedStrings.push(this.selectorToSpecificityMarkedString(node));
        return markedStrings;
    }
    isPseudoElementIdentifier(text) {
        const match = text.match(/^::?([\w-]+)/);
        if (!match) return false;
        return !!this.cssDataManager.getPseudoElement('::' + match[1]);
    }
    selectorToSpecificityMarkedString(node) {
        const calculateMostSpecificListItem = (childElements)=>{
            const specificity = new $3944e26ba312d5ab$var$Specificity();
            let mostSpecificListItem = new $3944e26ba312d5ab$var$Specificity();
            for (const containerElement of childElements)for (const childElement of containerElement.getChildren()){
                const itemSpecificity = calculateScore(childElement);
                if (itemSpecificity.id > mostSpecificListItem.id) {
                    mostSpecificListItem = itemSpecificity;
                    continue;
                } else if (itemSpecificity.id < mostSpecificListItem.id) continue;
                if (itemSpecificity.attr > mostSpecificListItem.attr) {
                    mostSpecificListItem = itemSpecificity;
                    continue;
                } else if (itemSpecificity.attr < mostSpecificListItem.attr) continue;
                if (itemSpecificity.tag > mostSpecificListItem.tag) {
                    mostSpecificListItem = itemSpecificity;
                    continue;
                }
            }
            specificity.id += mostSpecificListItem.id;
            specificity.attr += mostSpecificListItem.attr;
            specificity.tag += mostSpecificListItem.tag;
            return specificity;
        };
        //https://www.w3.org/TR/selectors-3/#specificity
        const calculateScore = (node)=>{
            const specificity = new $3944e26ba312d5ab$var$Specificity();
            elementLoop: for (const element of node.getChildren()){
                switch(element.type){
                    case $bd0cebf2eccc0e7e$export$f06e977173f1857c.IdentifierSelector:
                        specificity.id++;
                        break;
                    case $bd0cebf2eccc0e7e$export$f06e977173f1857c.ClassSelector:
                    case $bd0cebf2eccc0e7e$export$f06e977173f1857c.AttributeSelector:
                        specificity.attr++;
                        break;
                    case $bd0cebf2eccc0e7e$export$f06e977173f1857c.ElementNameSelector:
                        //ignore universal selector
                        if (element.matches('*')) break;
                        specificity.tag++;
                        break;
                    case $bd0cebf2eccc0e7e$export$f06e977173f1857c.PseudoSelector:
                        const text = element.getText();
                        const childElements = element.getChildren();
                        if (this.isPseudoElementIdentifier(text)) {
                            if (text.match(/^::slotted/i) && childElements.length > 0) {
                                // The specificity of ::slotted() is that of a pseudo-element, plus the specificity of its argument.
                                // ::slotted() does not allow a selector list as its argument, but this isn't the right place to give feedback on validity.
                                // Reporting the most specific child will be correct for correct CSS and will be forgiving in case of mistakes.
                                specificity.tag++;
                                let mostSpecificListItem = calculateMostSpecificListItem(childElements);
                                specificity.id += mostSpecificListItem.id;
                                specificity.attr += mostSpecificListItem.attr;
                                specificity.tag += mostSpecificListItem.tag;
                                continue elementLoop;
                            }
                            specificity.tag++; // pseudo element
                            continue elementLoop;
                        }
                        // where and child selectors have zero specificity
                        if (text.match(/^:where/i)) continue elementLoop;
                        // the most specific child selector
                        if (text.match(/^:(?:not|has|is)/i) && childElements.length > 0) {
                            let mostSpecificListItem = calculateMostSpecificListItem(childElements);
                            specificity.id += mostSpecificListItem.id;
                            specificity.attr += mostSpecificListItem.attr;
                            specificity.tag += mostSpecificListItem.tag;
                            continue elementLoop;
                        }
                        if (text.match(/^:(?:host|host-context)/i) && childElements.length > 0) {
                            // The specificity of :host() is that of a pseudo-class, plus the specificity of its argument.
                            // The specificity of :host-context() is that of a pseudo-class, plus the specificity of its argument.
                            specificity.attr++;
                            let mostSpecificListItem = calculateMostSpecificListItem(childElements);
                            specificity.id += mostSpecificListItem.id;
                            specificity.attr += mostSpecificListItem.attr;
                            specificity.tag += mostSpecificListItem.tag;
                            continue elementLoop;
                        }
                        if (text.match(/^:(?:nth-child|nth-last-child)/i) && childElements.length > 0) {
                            /* The specificity of the :nth-child(An+B [of S]?) pseudo-class is the specificity of a single pseudo-class plus, if S is specified, the specificity of the most specific complex selector in S */ // https://www.w3.org/TR/selectors-4/#the-nth-child-pseudo
                            specificity.attr++;
                            const lastChild = childElements[childElements.length - 1];
                            if (childElements.length > 2 && lastChild.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorList) {
                                // e.g :nth-child(-n+3 of li.important)
                                let mostSpecificListItem = calculateMostSpecificListItem(lastChild.getChildren());
                                specificity.id += mostSpecificListItem.id;
                                specificity.attr += mostSpecificListItem.attr;
                                specificity.tag += mostSpecificListItem.tag;
                                continue elementLoop;
                            }
                            // Edge case: 'n' without integer prefix A, with B integer non-existent, is not regarded as a binary expression token.
                            const parser = new (0, $48c6713331b54e18$export$7acfa6ed01010e37)();
                            const pseudoSelectorText = childElements[1].getText();
                            parser.scanner.setSource(pseudoSelectorText);
                            const firstToken = parser.scanner.scan();
                            const secondToken = parser.scanner.scan();
                            if (firstToken.text === 'n' || firstToken.text === '-n' && secondToken.text === 'of') {
                                const complexSelectorListNodes = [];
                                const complexSelectorText = pseudoSelectorText.slice(secondToken.offset + 2);
                                const complexSelectorArray = complexSelectorText.split(',');
                                for (const selector of complexSelectorArray){
                                    const node = parser.internalParse(selector, parser._parseSelector);
                                    if (node) complexSelectorListNodes.push(node);
                                }
                                let mostSpecificListItem = calculateMostSpecificListItem(complexSelectorListNodes);
                                specificity.id += mostSpecificListItem.id;
                                specificity.attr += mostSpecificListItem.attr;
                                specificity.tag += mostSpecificListItem.tag;
                                continue elementLoop;
                            }
                            continue elementLoop;
                        }
                        specificity.attr++; //pseudo class
                        continue elementLoop;
                }
                if (element.getChildren().length > 0) {
                    const itemSpecificity = calculateScore(element);
                    specificity.id += itemSpecificity.id;
                    specificity.attr += itemSpecificity.attr;
                    specificity.tag += itemSpecificity.tag;
                }
            }
            return specificity;
        };
        const specificity = calculateScore(node);
        return `[${$3240faa9c744ac82$export$625550452a3fa3ec('Selector Specificity')}](https://developer.mozilla.org/docs/Web/CSS/Specificity): (${specificity.id}, ${specificity.attr}, ${specificity.tag})`;
    }
}
class $3944e26ba312d5ab$var$SelectorElementBuilder {
    constructor(element){
        this.prev = null;
        this.element = element;
    }
    processSelector(selector) {
        let parentElement = null;
        if (!(this.element instanceof $3944e26ba312d5ab$export$c06e9b40b0d02ca)) {
            if (selector.getChildren().some((c)=>c.hasChildren() && c.getChild(0).type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorCombinator)) {
                const curr = this.element.findRoot();
                if (curr.parent instanceof $3944e26ba312d5ab$export$c06e9b40b0d02ca) {
                    parentElement = this.element;
                    this.element = curr.parent;
                    this.element.removeChild(curr);
                    this.prev = null;
                }
            }
        }
        for (const selectorChild of selector.getChildren()){
            if (selectorChild instanceof $bd0cebf2eccc0e7e$export$bfa70abafbc5e495) {
                if (this.prev instanceof $bd0cebf2eccc0e7e$export$bfa70abafbc5e495) {
                    const labelElement = new $3944e26ba312d5ab$export$8f0f6d143a513bf6('\u2026');
                    this.element.addChild(labelElement);
                    this.element = labelElement;
                } else if (this.prev && (this.prev.matches('+') || this.prev.matches('~')) && this.element.parent) this.element = this.element.parent;
                if (this.prev && this.prev.matches('~')) this.element.addChild(new $3944e26ba312d5ab$export$8f0f6d143a513bf6('\u22EE'));
                const thisElement = $3944e26ba312d5ab$export$8d51e3db1a844094(selectorChild, parentElement);
                const root = thisElement.findRoot();
                this.element.addChild(root);
                this.element = thisElement;
            }
            if (selectorChild instanceof $bd0cebf2eccc0e7e$export$bfa70abafbc5e495 || selectorChild.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorCombinatorParent || selectorChild.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorCombinatorShadowPiercingDescendant || selectorChild.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorCombinatorSibling || selectorChild.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorCombinatorAllSiblings) this.prev = selectorChild;
        }
    }
}
function $3944e26ba312d5ab$var$isNewSelectorContext(node) {
    switch(node.type){
        case $bd0cebf2eccc0e7e$export$f06e977173f1857c.MixinDeclaration:
        case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Stylesheet:
            return true;
    }
    return false;
}
function $3944e26ba312d5ab$export$41107a8aec02d1d9(node) {
    if (node.matches('@at-root')) return null;
    const root = new $3944e26ba312d5ab$export$c06e9b40b0d02ca();
    const parentRuleSets = [];
    const ruleSet = node.getParent();
    if (ruleSet instanceof $bd0cebf2eccc0e7e$export$ade1230f1a17327c) {
        let parent = ruleSet.getParent(); // parent of the selector's ruleset
        while(parent && !$3944e26ba312d5ab$var$isNewSelectorContext(parent)){
            if (parent instanceof $bd0cebf2eccc0e7e$export$ade1230f1a17327c) {
                if (parent.getSelectors().matches('@at-root')) break;
                parentRuleSets.push(parent);
            }
            parent = parent.getParent();
        }
    }
    const builder = new $3944e26ba312d5ab$var$SelectorElementBuilder(root);
    for(let i = parentRuleSets.length - 1; i >= 0; i--){
        const selector = parentRuleSets[i].getSelectors().getChild(0);
        if (selector) builder.processSelector(selector);
    }
    builder.processSelector(node);
    return root;
}





'use strict';
class $647885fd6d687e9c$export$104da7ab2cb9bcf5 {
    constructor(clientCapabilities, cssDataManager){
        this.clientCapabilities = clientCapabilities;
        this.cssDataManager = cssDataManager;
        this.selectorPrinting = new (0, $3944e26ba312d5ab$export$57dc82f081ca6d62)(cssDataManager);
    }
    configure(settings) {
        this.defaultSettings = settings;
    }
    doHover(document, position, stylesheet, settings = this.defaultSettings) {
        function getRange(node) {
            return (0, $1345bdc33671c7a9$exports.Range).create(document.positionAt(node.offset), document.positionAt(node.end));
        }
        const offset = document.offsetAt(position);
        const nodepath = $bd0cebf2eccc0e7e$export$7371e5dfbc4269ff(stylesheet, offset);
        /**
         * nodepath is top-down
         * Build up the hover by appending inner node's information
         */ let hover = null;
        let selectorContexts = [];
        for(let i = 0; i < nodepath.length; i++){
            const node = nodepath[i];
            if (node instanceof $bd0cebf2eccc0e7e$export$775b6bb06e53a214) {
                const scopeLimits = node.getChild(0);
                if (scopeLimits instanceof $bd0cebf2eccc0e7e$export$78326a4db4056ab8) {
                    const scopeName = `${scopeLimits.getName()}`;
                    selectorContexts.push(`@scope${scopeName ? ` ${scopeName}` : ''}`);
                }
            }
            if (node instanceof $bd0cebf2eccc0e7e$export$7fc53215244aec38) {
                const mediaList = node.getChild(0);
                if (mediaList instanceof $bd0cebf2eccc0e7e$export$7143f4602d24ccbd) {
                    const name = '@media ' + mediaList.getText();
                    selectorContexts.push(name);
                }
            }
            if (node instanceof $bd0cebf2eccc0e7e$export$d15f4cd5286f9b1e) {
                hover = {
                    contents: this.selectorPrinting.selectorToMarkedString(node, selectorContexts),
                    range: getRange(node)
                };
                break;
            }
            if (node instanceof $bd0cebf2eccc0e7e$export$bfa70abafbc5e495) {
                /**
                 * Some sass specific at rules such as `@at-root` are parsed as `SimpleSelector`
                 */ if (!(0, $3383aa02dc8dfba4$export$68326237475e9a7d)(node.getText(), '@')) hover = {
                    contents: this.selectorPrinting.simpleSelectorToMarkedString(node),
                    range: getRange(node)
                };
                break;
            }
            if (node instanceof $bd0cebf2eccc0e7e$export$48f3d9e786303b67) {
                const propertyName = node.getFullPropertyName();
                const entry = this.cssDataManager.getProperty(propertyName);
                if (entry) {
                    const contents = $d5592ab2ff7f18b0$export$7eaaf6bd9b4ee15(entry, this.doesSupportMarkdown(), settings);
                    if (contents) hover = {
                        contents: contents,
                        range: getRange(node)
                    };
                    else hover = null;
                }
                continue;
            }
            if (node instanceof $bd0cebf2eccc0e7e$export$b8b985b0b9cf23a2) {
                const atRuleName = node.getText();
                const entry = this.cssDataManager.getAtDirective(atRuleName);
                if (entry) {
                    const contents = $d5592ab2ff7f18b0$export$7eaaf6bd9b4ee15(entry, this.doesSupportMarkdown(), settings);
                    if (contents) hover = {
                        contents: contents,
                        range: getRange(node)
                    };
                    else hover = null;
                }
                continue;
            }
            if (node instanceof $bd0cebf2eccc0e7e$export$85c928794f8d04d4 && node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.PseudoSelector) {
                const selectorName = node.getText();
                const entry = selectorName.slice(0, 2) === '::' ? this.cssDataManager.getPseudoElement(selectorName) : this.cssDataManager.getPseudoClass(selectorName);
                if (entry) {
                    const contents = $d5592ab2ff7f18b0$export$7eaaf6bd9b4ee15(entry, this.doesSupportMarkdown(), settings);
                    if (contents) hover = {
                        contents: contents,
                        range: getRange(node)
                    };
                    else hover = null;
                }
                continue;
            }
        }
        if (hover) hover.contents = this.convertContents(hover.contents);
        return hover;
    }
    convertContents(contents) {
        if (!this.doesSupportMarkdown()) {
            if (typeof contents === 'string') return contents;
            else if ('kind' in contents) return {
                kind: 'plaintext',
                value: contents.value
            };
            else if (Array.isArray(contents)) return contents.map((c)=>{
                return typeof c === 'string' ? c : c.value;
            });
            else return contents.value;
        }
        return contents;
    }
    doesSupportMarkdown() {
        if (!(0, $e213756046234466$export$4e62c701997796c1)(this.supportsMarkdown)) {
            if (!(0, $e213756046234466$export$4e62c701997796c1)(this.clientCapabilities)) {
                this.supportsMarkdown = true;
                return this.supportsMarkdown;
            }
            const hover = this.clientCapabilities.textDocument && this.clientCapabilities.textDocument.hover;
            this.supportsMarkdown = hover && hover.contentFormat && Array.isArray(hover.contentFormat) && hover.contentFormat.indexOf((0, $1345bdc33671c7a9$exports.MarkupKind).Markdown) !== -1;
        }
        return this.supportsMarkdown;
    }
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 






'use strict';
const $dcc89f559ec3166a$var$startsWithSchemeRegex = /^\w+:\/\//;
const $dcc89f559ec3166a$var$startsWithData = /^data:/;
class $dcc89f559ec3166a$export$939adce22595f374 {
    constructor(fileSystemProvider, resolveModuleReferences){
        this.fileSystemProvider = fileSystemProvider;
        this.resolveModuleReferences = resolveModuleReferences;
    }
    configure(settings) {
        this.defaultSettings = settings;
    }
    findDefinition(document, position, stylesheet) {
        const symbols = new (0, $0e1028d5f31bf222$export$fa456266707bf4e4)(stylesheet);
        const offset = document.offsetAt(position);
        const node = $bd0cebf2eccc0e7e$export$8501d4bdbd8952bc(stylesheet, offset);
        if (!node) return null;
        const symbol = symbols.findSymbolFromNode(node);
        if (!symbol) return null;
        return {
            uri: document.uri,
            range: $dcc89f559ec3166a$var$getRange(symbol.node, document)
        };
    }
    findReferences(document, position, stylesheet) {
        const highlights = this.findDocumentHighlights(document, position, stylesheet);
        return highlights.map((h)=>{
            return {
                uri: document.uri,
                range: h.range
            };
        });
    }
    getHighlightNode(document, position, stylesheet) {
        const offset = document.offsetAt(position);
        let node = $bd0cebf2eccc0e7e$export$8501d4bdbd8952bc(stylesheet, offset);
        if (!node || node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Stylesheet || node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Declarations || node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.ModuleConfig) return;
        if (node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Identifier && node.parent && node.parent.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.ClassSelector) node = node.parent;
        return node;
    }
    findDocumentHighlights(document, position, stylesheet) {
        const result = [];
        const node = this.getHighlightNode(document, position, stylesheet);
        if (!node) return result;
        const symbols = new (0, $0e1028d5f31bf222$export$fa456266707bf4e4)(stylesheet);
        const symbol = symbols.findSymbolFromNode(node);
        const name = node.getText();
        stylesheet.accept((candidate)=>{
            if (symbol) {
                if (symbols.matchesSymbol(candidate, symbol)) {
                    result.push({
                        kind: $dcc89f559ec3166a$var$getHighlightKind(candidate),
                        range: $dcc89f559ec3166a$var$getRange(candidate, document)
                    });
                    return false;
                }
            } else if (node && node.type === candidate.type && candidate.matches(name)) // Same node type and data
            result.push({
                kind: $dcc89f559ec3166a$var$getHighlightKind(candidate),
                range: $dcc89f559ec3166a$var$getRange(candidate, document)
            });
            return true;
        });
        return result;
    }
    isRawStringDocumentLinkNode(node) {
        return node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Import;
    }
    findDocumentLinks(document, stylesheet, documentContext) {
        const linkData = this.findUnresolvedLinks(document, stylesheet);
        const resolvedLinks = [];
        for (let data of linkData){
            const link = data.link;
            const target = link.target;
            if (!target || $dcc89f559ec3166a$var$startsWithData.test(target)) ;
            else if ($dcc89f559ec3166a$var$startsWithSchemeRegex.test(target)) resolvedLinks.push(link);
            else {
                const resolved = documentContext.resolveReference(target, document.uri);
                if (resolved) link.target = resolved;
                resolvedLinks.push(link);
            }
        }
        return resolvedLinks;
    }
    async findDocumentLinks2(document, stylesheet, documentContext) {
        const linkData = this.findUnresolvedLinks(document, stylesheet);
        const resolvedLinks = [];
        for (let data of linkData){
            const link = data.link;
            const target = link.target;
            if (!target || $dcc89f559ec3166a$var$startsWithData.test(target)) ;
            else if ($dcc89f559ec3166a$var$startsWithSchemeRegex.test(target)) resolvedLinks.push(link);
            else {
                const resolvedTarget = await this.resolveReference(target, document.uri, documentContext, data.isRawLink);
                if (resolvedTarget !== undefined) {
                    link.target = resolvedTarget;
                    resolvedLinks.push(link);
                }
            }
        }
        return resolvedLinks;
    }
    findUnresolvedLinks(document, stylesheet) {
        const result = [];
        const collect = (uriStringNode)=>{
            let rawUri = uriStringNode.getText();
            const range = $dcc89f559ec3166a$var$getRange(uriStringNode, document);
            // Make sure the range is not empty
            if (range.start.line === range.end.line && range.start.character === range.end.character) return;
            if ((0, $3383aa02dc8dfba4$export$68326237475e9a7d)(rawUri, `'`) || (0, $3383aa02dc8dfba4$export$68326237475e9a7d)(rawUri, `"`)) rawUri = rawUri.slice(1, -1);
            const isRawLink = uriStringNode.parent ? this.isRawStringDocumentLinkNode(uriStringNode.parent) : false;
            result.push({
                link: {
                    target: rawUri,
                    range: range
                },
                isRawLink: isRawLink
            });
        };
        stylesheet.accept((candidate)=>{
            if (candidate.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.URILiteral) {
                const first = candidate.getChild(0);
                if (first) collect(first);
                return false;
            }
            /**
             * In @import, it is possible to include links that do not use `url()`
             * For example, `@import 'foo.css';`
             */ if (candidate.parent && this.isRawStringDocumentLinkNode(candidate.parent)) {
                const rawText = candidate.getText();
                if ((0, $3383aa02dc8dfba4$export$68326237475e9a7d)(rawText, `'`) || (0, $3383aa02dc8dfba4$export$68326237475e9a7d)(rawText, `"`)) collect(candidate);
                return false;
            }
            return true;
        });
        return result;
    }
    findSymbolInformations(document, stylesheet) {
        const result = [];
        const addSymbolInformation = (name, kind, symbolNodeOrRange)=>{
            const range = symbolNodeOrRange instanceof $bd0cebf2eccc0e7e$export$85c928794f8d04d4 ? $dcc89f559ec3166a$var$getRange(symbolNodeOrRange, document) : symbolNodeOrRange;
            const entry = {
                name: name || $3240faa9c744ac82$export$625550452a3fa3ec('<undefined>'),
                kind: kind,
                location: (0, $1345bdc33671c7a9$exports.Location).create(document.uri, range)
            };
            result.push(entry);
        };
        this.collectDocumentSymbols(document, stylesheet, addSymbolInformation);
        return result;
    }
    findDocumentSymbols(document, stylesheet) {
        const result = [];
        const parents = [];
        const addDocumentSymbol = (name, kind, symbolNodeOrRange, nameNodeOrRange, bodyNode)=>{
            const range = symbolNodeOrRange instanceof $bd0cebf2eccc0e7e$export$85c928794f8d04d4 ? $dcc89f559ec3166a$var$getRange(symbolNodeOrRange, document) : symbolNodeOrRange;
            let selectionRange = nameNodeOrRange instanceof $bd0cebf2eccc0e7e$export$85c928794f8d04d4 ? $dcc89f559ec3166a$var$getRange(nameNodeOrRange, document) : nameNodeOrRange;
            if (!selectionRange || !$dcc89f559ec3166a$var$containsRange(range, selectionRange)) selectionRange = (0, $1345bdc33671c7a9$exports.Range).create(range.start, range.start);
            const entry = {
                name: name || $3240faa9c744ac82$export$625550452a3fa3ec('<undefined>'),
                kind: kind,
                range: range,
                selectionRange: selectionRange
            };
            let top = parents.pop();
            while(top && !$dcc89f559ec3166a$var$containsRange(top[1], range))top = parents.pop();
            if (top) {
                const topSymbol = top[0];
                if (!topSymbol.children) topSymbol.children = [];
                topSymbol.children.push(entry);
                parents.push(top); // put back top
            } else result.push(entry);
            if (bodyNode) parents.push([
                entry,
                $dcc89f559ec3166a$var$getRange(bodyNode, document)
            ]);
        };
        this.collectDocumentSymbols(document, stylesheet, addDocumentSymbol);
        return result;
    }
    collectDocumentSymbols(document, stylesheet, collect) {
        stylesheet.accept((node)=>{
            if (node instanceof $bd0cebf2eccc0e7e$export$ade1230f1a17327c) {
                for (const selector of node.getSelectors().getChildren())if (selector instanceof $bd0cebf2eccc0e7e$export$d15f4cd5286f9b1e) {
                    const range = (0, $1345bdc33671c7a9$exports.Range).create(document.positionAt(selector.offset), document.positionAt(node.end));
                    collect(selector.getText(), (0, $1345bdc33671c7a9$exports.SymbolKind).Class, range, selector, node.getDeclarations());
                }
            } else if (node instanceof $bd0cebf2eccc0e7e$export$839cf4f882eabac8) collect(node.getName(), (0, $1345bdc33671c7a9$exports.SymbolKind).Variable, node, node.getVariable(), undefined);
            else if (node instanceof $bd0cebf2eccc0e7e$export$f518258a40310702) collect(node.getName(), (0, $1345bdc33671c7a9$exports.SymbolKind).Method, node, node.getIdentifier(), node.getDeclarations());
            else if (node instanceof $bd0cebf2eccc0e7e$export$db0c6820087997c2) collect(node.getName(), (0, $1345bdc33671c7a9$exports.SymbolKind).Function, node, node.getIdentifier(), node.getDeclarations());
            else if (node instanceof $bd0cebf2eccc0e7e$export$7b3cfeb4fa34c97f) {
                const name = $3240faa9c744ac82$export$625550452a3fa3ec("@keyframes {0}", node.getName());
                collect(name, (0, $1345bdc33671c7a9$exports.SymbolKind).Class, node, node.getIdentifier(), node.getDeclarations());
            } else if (node instanceof $bd0cebf2eccc0e7e$export$2e039772bf0d47a5) {
                const name = $3240faa9c744ac82$export$625550452a3fa3ec("@font-face");
                collect(name, (0, $1345bdc33671c7a9$exports.SymbolKind).Class, node, undefined, node.getDeclarations());
            } else if (node instanceof $bd0cebf2eccc0e7e$export$7fc53215244aec38) {
                const mediaList = node.getChild(0);
                if (mediaList instanceof $bd0cebf2eccc0e7e$export$7143f4602d24ccbd) {
                    const name = '@media ' + mediaList.getText();
                    collect(name, (0, $1345bdc33671c7a9$exports.SymbolKind).Module, node, mediaList, node.getDeclarations());
                }
            } else if (node instanceof $bd0cebf2eccc0e7e$export$775b6bb06e53a214) {
                let scopeName = '';
                const scopeLimits = node.getChild(0);
                if (scopeLimits instanceof $bd0cebf2eccc0e7e$export$78326a4db4056ab8) scopeName = `${scopeLimits.getName()}`;
                collect(`@scope${scopeName ? ` ${scopeName}` : ''}`, (0, $1345bdc33671c7a9$exports.SymbolKind).Module, node, scopeLimits ?? undefined, node.getDeclarations());
            }
            return true;
        });
    }
    findDocumentColors(document, stylesheet) {
        const result = [];
        stylesheet.accept((node)=>{
            const colorInfo = $dcc89f559ec3166a$var$getColorInformation(node, document);
            if (colorInfo) result.push(colorInfo);
            return true;
        });
        return result;
    }
    getColorPresentations(document, stylesheet, color, range) {
        const result = [];
        const red256 = Math.round(color.red * 255), green256 = Math.round(color.green * 255), blue256 = Math.round(color.blue * 255);
        let label;
        if (color.alpha === 1) label = `rgb(${red256}, ${green256}, ${blue256})`;
        else label = `rgba(${red256}, ${green256}, ${blue256}, ${color.alpha})`;
        result.push({
            label: label,
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(range, label)
        });
        if (color.alpha === 1) label = `#${$dcc89f559ec3166a$var$toTwoDigitHex(red256)}${$dcc89f559ec3166a$var$toTwoDigitHex(green256)}${$dcc89f559ec3166a$var$toTwoDigitHex(blue256)}`;
        else label = `#${$dcc89f559ec3166a$var$toTwoDigitHex(red256)}${$dcc89f559ec3166a$var$toTwoDigitHex(green256)}${$dcc89f559ec3166a$var$toTwoDigitHex(blue256)}${$dcc89f559ec3166a$var$toTwoDigitHex(Math.round(color.alpha * 255))}`;
        result.push({
            label: label,
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(range, label)
        });
        const hsl = (0, $6be89f889e93fd15$export$f03b420020baf37a)(color);
        if (hsl.a === 1) label = `hsl(${hsl.h}, ${Math.round(hsl.s * 100)}%, ${Math.round(hsl.l * 100)}%)`;
        else label = `hsla(${hsl.h}, ${Math.round(hsl.s * 100)}%, ${Math.round(hsl.l * 100)}%, ${hsl.a})`;
        result.push({
            label: label,
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(range, label)
        });
        const hwb = (0, $6be89f889e93fd15$export$c4218b01ca351769)(color);
        if (hwb.a === 1) label = `hwb(${hwb.h} ${Math.round(hwb.w * 100)}% ${Math.round(hwb.b * 100)}%)`;
        else label = `hwb(${hwb.h} ${Math.round(hwb.w * 100)}% ${Math.round(hwb.b * 100)}% / ${hwb.a})`;
        result.push({
            label: label,
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(range, label)
        });
        const lab = (0, $6be89f889e93fd15$export$1f07a9bd2630df0)(color);
        if (lab.alpha === 1) label = `lab(${lab.l}% ${lab.a} ${lab.b})`;
        else label = `lab(${lab.l}% ${lab.a} ${lab.b} / ${lab.alpha})`;
        result.push({
            label: label,
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(range, label)
        });
        const lch = (0, $6be89f889e93fd15$export$75b78f317c952420)(color);
        if (lch.alpha === 1) label = `lch(${lch.l}% ${lch.c} ${lch.h})`;
        else label = `lch(${lch.l}% ${lch.c} ${lch.h} / ${lch.alpha})`;
        result.push({
            label: label,
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(range, label)
        });
        const oklab = (0, $6be89f889e93fd15$export$c7257a7157807e10)(color);
        label = oklab.alpha === 1 ? `oklab(${oklab.l}% ${oklab.a} ${oklab.b})` : `oklab(${oklab.l}% ${oklab.a} ${oklab.b} / ${oklab.alpha})`;
        result.push({
            label: label,
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(range, label)
        });
        const oklch = (0, $6be89f889e93fd15$export$831fc7e7ace3b6e0)(color);
        label = oklch.alpha === 1 ? `oklch(${oklch.l}% ${oklch.c} ${oklch.h})` : `oklch(${oklch.l}% ${oklch.c} ${oklch.h} / ${oklch.alpha})`;
        result.push({
            label: label,
            textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(range, label)
        });
        return result;
    }
    prepareRename(document, position, stylesheet) {
        const node = this.getHighlightNode(document, position, stylesheet);
        if (node) return (0, $1345bdc33671c7a9$exports.Range).create(document.positionAt(node.offset), document.positionAt(node.end));
    }
    doRename(document, position, newName, stylesheet) {
        const highlights = this.findDocumentHighlights(document, position, stylesheet);
        const edits = highlights.map((h)=>(0, $1345bdc33671c7a9$exports.TextEdit).replace(h.range, newName));
        return {
            changes: {
                [document.uri]: edits
            }
        };
    }
    async resolveModuleReference(ref, documentUri, documentContext) {
        if ((0, $3383aa02dc8dfba4$export$68326237475e9a7d)(documentUri, 'file://')) {
            const moduleName = $dcc89f559ec3166a$export$d1517c6a48a13687(ref);
            if (moduleName && moduleName !== '.' && moduleName !== '..') {
                const rootFolderUri = documentContext.resolveReference('/', documentUri);
                const documentFolderUri = (0, $a2a0b9096fdc2c46$export$7f7b8152cc673abe)(documentUri);
                const modulePath = await this.resolvePathToModule(moduleName, documentFolderUri, rootFolderUri);
                if (modulePath) {
                    const pathWithinModule = ref.substring(moduleName.length + 1);
                    return (0, $a2a0b9096fdc2c46$export$b891921babc70093)(modulePath, pathWithinModule);
                }
            }
        }
        return undefined;
    }
    async mapReference(target, isRawLink) {
        return target;
    }
    async resolveReference(target, documentUri, documentContext, isRawLink = false, settings = this.defaultSettings) {
        // Following [css-loader](https://github.com/webpack-contrib/css-loader#url)
        // and [sass-loader's](https://github.com/webpack-contrib/sass-loader#imports)
        // convention, if an import path starts with ~ then use node module resolution
        // *unless* it starts with "~/" as this refers to the user's home directory.
        if (target[0] === '~' && target[1] !== '/' && this.fileSystemProvider) {
            target = target.substring(1);
            return this.mapReference(await this.resolveModuleReference(target, documentUri, documentContext), isRawLink);
        }
        const ref = await this.mapReference(documentContext.resolveReference(target, documentUri), isRawLink);
        // Following [less-loader](https://github.com/webpack-contrib/less-loader#imports)
        // and [sass-loader's](https://github.com/webpack-contrib/sass-loader#resolving-import-at-rules)
        // new resolving import at-rules (~ is deprecated). The loader will first try to resolve @import as a relative path. If it cannot be resolved,
        // then the loader will try to resolve @import inside node_modules.
        if (this.resolveModuleReferences) {
            if (ref && await this.fileExists(ref)) return ref;
            const moduleReference = await this.mapReference(await this.resolveModuleReference(target, documentUri, documentContext), isRawLink);
            if (moduleReference) return moduleReference;
        }
        // Try resolving the reference from the language configuration alias settings
        if (ref && !await this.fileExists(ref)) {
            const rootFolderUri = documentContext.resolveReference('/', documentUri);
            if (settings && rootFolderUri) {
                // Specific file reference
                if (target in settings) return this.mapReference((0, $a2a0b9096fdc2c46$export$b891921babc70093)(rootFolderUri, settings[target]), isRawLink);
                // Reference folder
                const firstSlash = target.indexOf('/');
                const prefix = `${target.substring(0, firstSlash)}/`;
                if (prefix in settings) {
                    const aliasPath = settings[prefix].slice(0, -1);
                    let newPath = (0, $a2a0b9096fdc2c46$export$b891921babc70093)(rootFolderUri, aliasPath);
                    return this.mapReference(newPath = (0, $a2a0b9096fdc2c46$export$b891921babc70093)(newPath, target.substring(prefix.length - 1)), isRawLink);
                }
            }
        }
        // fall back. it might not exists
        return ref;
    }
    async resolvePathToModule(_moduleName, documentFolderUri, rootFolderUri) {
        // resolve the module relative to the document. We can't use `require` here as the code is webpacked.
        const packPath = (0, $a2a0b9096fdc2c46$export$b891921babc70093)(documentFolderUri, 'node_modules', _moduleName, 'package.json');
        if (await this.fileExists(packPath)) return (0, $a2a0b9096fdc2c46$export$7f7b8152cc673abe)(packPath);
        else if (rootFolderUri && documentFolderUri.startsWith(rootFolderUri) && documentFolderUri.length !== rootFolderUri.length) return this.resolvePathToModule(_moduleName, (0, $a2a0b9096fdc2c46$export$7f7b8152cc673abe)(documentFolderUri), rootFolderUri);
        return undefined;
    }
    async fileExists(uri) {
        if (!this.fileSystemProvider) return false;
        try {
            const stat = await this.fileSystemProvider.stat(uri);
            if (stat.type === (0, $579034ff01526470$export$c5ae10d7c88c4d3e).Unknown && stat.size === -1) return false;
            return true;
        } catch (err) {
            return false;
        }
    }
    async getContent(uri) {
        if (!this.fileSystemProvider || !this.fileSystemProvider.getContent) return null;
        try {
            return await this.fileSystemProvider.getContent(uri);
        } catch (err) {
            return null;
        }
    }
}
function $dcc89f559ec3166a$var$getColorInformation(node, document) {
    const color = (0, $6be89f889e93fd15$export$50c120d4d5566287)(node);
    if (color) {
        const range = $dcc89f559ec3166a$var$getRange(node, document);
        return {
            color: color,
            range: range
        };
    }
    return null;
}
function $dcc89f559ec3166a$var$getRange(node, document) {
    return (0, $1345bdc33671c7a9$exports.Range).create(document.positionAt(node.offset), document.positionAt(node.end));
}
/**
 * Test if `otherRange` is in `range`. If the ranges are equal, will return true.
 */ function $dcc89f559ec3166a$var$containsRange(range, otherRange) {
    const otherStartLine = otherRange.start.line, otherEndLine = otherRange.end.line;
    const rangeStartLine = range.start.line, rangeEndLine = range.end.line;
    if (otherStartLine < rangeStartLine || otherEndLine < rangeStartLine) return false;
    if (otherStartLine > rangeEndLine || otherEndLine > rangeEndLine) return false;
    if (otherStartLine === rangeStartLine && otherRange.start.character < range.start.character) return false;
    if (otherEndLine === rangeEndLine && otherRange.end.character > range.end.character) return false;
    return true;
}
function $dcc89f559ec3166a$var$getHighlightKind(node) {
    if (node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Selector) return (0, $1345bdc33671c7a9$exports.DocumentHighlightKind).Write;
    if (node instanceof $bd0cebf2eccc0e7e$export$989167234458594d) {
        if (node.parent && node.parent instanceof $bd0cebf2eccc0e7e$export$41b04b3a73e7216d) {
            if (node.isCustomProperty) return (0, $1345bdc33671c7a9$exports.DocumentHighlightKind).Write;
        }
    }
    if (node.parent) switch(node.parent.type){
        case $bd0cebf2eccc0e7e$export$f06e977173f1857c.FunctionDeclaration:
        case $bd0cebf2eccc0e7e$export$f06e977173f1857c.MixinDeclaration:
        case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Keyframe:
        case $bd0cebf2eccc0e7e$export$f06e977173f1857c.VariableDeclaration:
        case $bd0cebf2eccc0e7e$export$f06e977173f1857c.FunctionParameter:
            return (0, $1345bdc33671c7a9$exports.DocumentHighlightKind).Write;
    }
    return (0, $1345bdc33671c7a9$exports.DocumentHighlightKind).Read;
}
function $dcc89f559ec3166a$var$toTwoDigitHex(n) {
    const r = n.toString(16);
    return r.length !== 2 ? '0' + r : r;
}
function $dcc89f559ec3166a$export$d1517c6a48a13687(path) {
    const firstSlash = path.indexOf('/');
    if (firstSlash === -1) return '';
    // If a scoped module (starts with @) then get up until second instance of '/', or to the end of the string for root-level imports.
    if (path[0] === '@') {
        const secondSlash = path.indexOf('/', firstSlash + 1);
        if (secondSlash === -1) return path;
        return path.substring(0, secondSlash);
    }
    // Otherwise get until first instance of '/'
    return path.substring(0, firstSlash);
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 

'use strict';
const $821c90df06192cad$var$Warning = $bd0cebf2eccc0e7e$export$ca664994d1d54bff.Warning;
const $821c90df06192cad$var$Error = $bd0cebf2eccc0e7e$export$ca664994d1d54bff.Error;
const $821c90df06192cad$var$Ignore = $bd0cebf2eccc0e7e$export$ca664994d1d54bff.Ignore;
class $821c90df06192cad$export$f1ff2a90c38ff669 {
    constructor(id, message, defaultValue){
        this.id = id;
        this.message = message;
        this.defaultValue = defaultValue;
    // nothing to do
    }
}
class $821c90df06192cad$export$805dc0bee9369f09 {
    constructor(id, message, defaultValue){
        this.id = id;
        this.message = message;
        this.defaultValue = defaultValue;
    // nothing to do
    }
}
const $821c90df06192cad$export$374633da432e5a39 = {
    AllVendorPrefixes: new $821c90df06192cad$export$f1ff2a90c38ff669('compatibleVendorPrefixes', $3240faa9c744ac82$export$625550452a3fa3ec("When using a vendor-specific prefix make sure to also include all other vendor-specific properties"), $821c90df06192cad$var$Ignore),
    IncludeStandardPropertyWhenUsingVendorPrefix: new $821c90df06192cad$export$f1ff2a90c38ff669('vendorPrefix', $3240faa9c744ac82$export$625550452a3fa3ec("When using a vendor-specific prefix also include the standard property"), $821c90df06192cad$var$Warning),
    DuplicateDeclarations: new $821c90df06192cad$export$f1ff2a90c38ff669('duplicateProperties', $3240faa9c744ac82$export$625550452a3fa3ec("Do not use duplicate style definitions"), $821c90df06192cad$var$Ignore),
    EmptyRuleSet: new $821c90df06192cad$export$f1ff2a90c38ff669('emptyRules', $3240faa9c744ac82$export$625550452a3fa3ec("Do not use empty rulesets"), $821c90df06192cad$var$Warning),
    ImportStatemement: new $821c90df06192cad$export$f1ff2a90c38ff669('importStatement', $3240faa9c744ac82$export$625550452a3fa3ec("Import statements do not load in parallel"), $821c90df06192cad$var$Ignore),
    BewareOfBoxModelSize: new $821c90df06192cad$export$f1ff2a90c38ff669('boxModel', $3240faa9c744ac82$export$625550452a3fa3ec("Do not use width or height when using padding or border"), $821c90df06192cad$var$Ignore),
    UniversalSelector: new $821c90df06192cad$export$f1ff2a90c38ff669('universalSelector', $3240faa9c744ac82$export$625550452a3fa3ec("The universal selector (*) is known to be slow"), $821c90df06192cad$var$Ignore),
    ZeroWithUnit: new $821c90df06192cad$export$f1ff2a90c38ff669('zeroUnits', $3240faa9c744ac82$export$625550452a3fa3ec("No unit for zero needed"), $821c90df06192cad$var$Ignore),
    RequiredPropertiesForFontFace: new $821c90df06192cad$export$f1ff2a90c38ff669('fontFaceProperties', $3240faa9c744ac82$export$625550452a3fa3ec("@font-face rule must define 'src' and 'font-family' properties"), $821c90df06192cad$var$Warning),
    HexColorLength: new $821c90df06192cad$export$f1ff2a90c38ff669('hexColorLength', $3240faa9c744ac82$export$625550452a3fa3ec("Hex colors must consist of three, four, six or eight hex numbers"), $821c90df06192cad$var$Error),
    ArgsInColorFunction: new $821c90df06192cad$export$f1ff2a90c38ff669('argumentsInColorFunction', $3240faa9c744ac82$export$625550452a3fa3ec("Invalid number of parameters"), $821c90df06192cad$var$Error),
    UnknownProperty: new $821c90df06192cad$export$f1ff2a90c38ff669('unknownProperties', $3240faa9c744ac82$export$625550452a3fa3ec("Unknown property."), $821c90df06192cad$var$Warning),
    UnknownAtRules: new $821c90df06192cad$export$f1ff2a90c38ff669('unknownAtRules', $3240faa9c744ac82$export$625550452a3fa3ec("Unknown at-rule."), $821c90df06192cad$var$Warning),
    IEStarHack: new $821c90df06192cad$export$f1ff2a90c38ff669('ieHack', $3240faa9c744ac82$export$625550452a3fa3ec("IE hacks are only necessary when supporting IE7 and older"), $821c90df06192cad$var$Ignore),
    UnknownVendorSpecificProperty: new $821c90df06192cad$export$f1ff2a90c38ff669('unknownVendorSpecificProperties', $3240faa9c744ac82$export$625550452a3fa3ec("Unknown vendor specific property."), $821c90df06192cad$var$Ignore),
    PropertyIgnoredDueToDisplay: new $821c90df06192cad$export$f1ff2a90c38ff669('propertyIgnoredDueToDisplay', $3240faa9c744ac82$export$625550452a3fa3ec("Property is ignored due to the display."), $821c90df06192cad$var$Warning),
    AvoidImportant: new $821c90df06192cad$export$f1ff2a90c38ff669('important', $3240faa9c744ac82$export$625550452a3fa3ec("Avoid using !important. It is an indication that the specificity of the entire CSS has gotten out of control and needs to be refactored."), $821c90df06192cad$var$Ignore),
    AvoidFloat: new $821c90df06192cad$export$f1ff2a90c38ff669('float', $3240faa9c744ac82$export$625550452a3fa3ec("Avoid using 'float'. Floats lead to fragile CSS that is easy to break if one aspect of the layout changes."), $821c90df06192cad$var$Ignore),
    AvoidIdSelector: new $821c90df06192cad$export$f1ff2a90c38ff669('idSelector', $3240faa9c744ac82$export$625550452a3fa3ec("Selectors should not contain IDs because these rules are too tightly coupled with the HTML."), $821c90df06192cad$var$Ignore)
};
const $821c90df06192cad$export$c72f6eaae7b9adff = {
    ValidProperties: new $821c90df06192cad$export$805dc0bee9369f09('validProperties', $3240faa9c744ac82$export$625550452a3fa3ec("A list of properties that are not validated against the `unknownProperties` rule."), [])
};
class $821c90df06192cad$export$786692e090cbce75 {
    constructor(conf = {}){
        this.conf = conf;
    }
    getRule(rule) {
        if (this.conf.hasOwnProperty(rule.id)) {
            const level = $821c90df06192cad$var$toLevel(this.conf[rule.id]);
            if (level) return level;
        }
        return rule.defaultValue;
    }
    getSetting(setting) {
        return this.conf[setting.id];
    }
}
function $821c90df06192cad$var$toLevel(level) {
    switch(level){
        case 'ignore':
            return $bd0cebf2eccc0e7e$export$ca664994d1d54bff.Ignore;
        case 'warning':
            return $bd0cebf2eccc0e7e$export$ca664994d1d54bff.Warning;
        case 'error':
            return $bd0cebf2eccc0e7e$export$ca664994d1d54bff.Error;
    }
    return null;
}




'use strict';
class $4fcb1dcc3ec12ae1$export$66703fcd648c0ccf {
    constructor(cssDataManager){
        this.cssDataManager = cssDataManager;
    }
    doCodeActions(document, range, context, stylesheet) {
        return this.doCodeActions2(document, range, context, stylesheet).map((ca)=>{
            const textDocumentEdit = ca.edit && ca.edit.documentChanges && ca.edit.documentChanges[0];
            return (0, $1345bdc33671c7a9$exports.Command).create(ca.title, '_css.applyCodeAction', document.uri, document.version, textDocumentEdit && textDocumentEdit.edits);
        });
    }
    doCodeActions2(document, range, context, stylesheet) {
        const result = [];
        if (context.diagnostics) for (const diagnostic of context.diagnostics)this.appendFixesForMarker(document, stylesheet, diagnostic, result);
        return result;
    }
    getFixesForUnknownProperty(document, property, marker, result) {
        const propertyName = property.getName();
        const candidates = [];
        this.cssDataManager.getProperties().forEach((p)=>{
            const score = (0, $3383aa02dc8dfba4$export$acaf96a27438246b)(propertyName, p.name);
            if (score >= propertyName.length / 2 /*score_lim*/ ) candidates.push({
                property: p.name,
                score: score
            });
        });
        // Sort in descending order.
        candidates.sort((a, b)=>{
            return b.score - a.score || a.property.localeCompare(b.property);
        });
        let maxActions = 3;
        for (const candidate of candidates){
            const propertyName = candidate.property;
            const title = $3240faa9c744ac82$export$625550452a3fa3ec("Rename to '{0}'", propertyName);
            const edit = (0, $1345bdc33671c7a9$exports.TextEdit).replace(marker.range, propertyName);
            const documentIdentifier = (0, $1345bdc33671c7a9$exports.VersionedTextDocumentIdentifier).create(document.uri, document.version);
            const workspaceEdit = {
                documentChanges: [
                    (0, $1345bdc33671c7a9$exports.TextDocumentEdit).create(documentIdentifier, [
                        edit
                    ])
                ]
            };
            const codeAction = (0, $1345bdc33671c7a9$exports.CodeAction).create(title, workspaceEdit, (0, $1345bdc33671c7a9$exports.CodeActionKind).QuickFix);
            codeAction.diagnostics = [
                marker
            ];
            result.push(codeAction);
            if (--maxActions <= 0) return;
        }
    }
    appendFixesForMarker(document, stylesheet, marker, result) {
        if (marker.code !== (0, $821c90df06192cad$export$374633da432e5a39).UnknownProperty.id) return;
        const offset = document.offsetAt(marker.range.start);
        const end = document.offsetAt(marker.range.end);
        const nodepath = $bd0cebf2eccc0e7e$export$7371e5dfbc4269ff(stylesheet, offset);
        for(let i = nodepath.length - 1; i >= 0; i--){
            const node = nodepath[i];
            if (node instanceof $bd0cebf2eccc0e7e$export$48f3d9e786303b67) {
                const property = node.getProperty();
                if (property && property.offset === offset && property.end === end) {
                    this.getFixesForUnknownProperty(document, property, marker, result);
                    return;
                }
            }
        }
    }
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 




/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 
'use strict';
class $c5987b6ef754a63c$export$db77ccec0bb4ccac {
    constructor(decl){
        this.fullPropertyName = decl.getFullPropertyName().toLowerCase();
        this.node = decl;
    }
}
function $c5987b6ef754a63c$var$setSide(model, side, value, property) {
    const state = model[side];
    state.value = value;
    if (value) {
        if (!(0, $0fa1735587167c7c$export$ee2e0f811dca1807)(state.properties, property)) state.properties.push(property);
    }
}
function $c5987b6ef754a63c$var$setAllSides(model, value, property) {
    $c5987b6ef754a63c$var$setSide(model, 'top', value, property);
    $c5987b6ef754a63c$var$setSide(model, 'right', value, property);
    $c5987b6ef754a63c$var$setSide(model, 'bottom', value, property);
    $c5987b6ef754a63c$var$setSide(model, 'left', value, property);
}
function $c5987b6ef754a63c$var$updateModelWithValue(model, side, value, property) {
    if (side === 'top' || side === 'right' || side === 'bottom' || side === 'left') $c5987b6ef754a63c$var$setSide(model, side, value, property);
    else $c5987b6ef754a63c$var$setAllSides(model, value, property);
}
function $c5987b6ef754a63c$var$updateModelWithList(model, values, property) {
    switch(values.length){
        case 1:
            $c5987b6ef754a63c$var$updateModelWithValue(model, undefined, values[0], property);
            break;
        case 2:
            $c5987b6ef754a63c$var$updateModelWithValue(model, 'top', values[0], property);
            $c5987b6ef754a63c$var$updateModelWithValue(model, 'bottom', values[0], property);
            $c5987b6ef754a63c$var$updateModelWithValue(model, 'right', values[1], property);
            $c5987b6ef754a63c$var$updateModelWithValue(model, 'left', values[1], property);
            break;
        case 3:
            $c5987b6ef754a63c$var$updateModelWithValue(model, 'top', values[0], property);
            $c5987b6ef754a63c$var$updateModelWithValue(model, 'right', values[1], property);
            $c5987b6ef754a63c$var$updateModelWithValue(model, 'left', values[1], property);
            $c5987b6ef754a63c$var$updateModelWithValue(model, 'bottom', values[2], property);
            break;
        case 4:
            $c5987b6ef754a63c$var$updateModelWithValue(model, 'top', values[0], property);
            $c5987b6ef754a63c$var$updateModelWithValue(model, 'right', values[1], property);
            $c5987b6ef754a63c$var$updateModelWithValue(model, 'bottom', values[2], property);
            $c5987b6ef754a63c$var$updateModelWithValue(model, 'left', values[3], property);
            break;
    }
}
function $c5987b6ef754a63c$var$matches(value, candidates) {
    for (let candidate of candidates){
        if (value.matches(candidate)) return true;
    }
    return false;
}
/**
 * @param allowsKeywords whether the initial value of property is zero, so keywords `initial` and `unset` count as zero
 * @return `true` if this node represents a non-zero border; otherwise, `false`
 */ function $c5987b6ef754a63c$var$checkLineWidth(value, allowsKeywords = true) {
    if (allowsKeywords && $c5987b6ef754a63c$var$matches(value, [
        'initial',
        'unset'
    ])) return false;
    // a <length> is a value and a unit
    // so use `parseFloat` to strip the unit
    return parseFloat(value.getText()) !== 0;
}
function $c5987b6ef754a63c$var$checkLineWidthList(nodes, allowsKeywords = true) {
    return nodes.map((node)=>$c5987b6ef754a63c$var$checkLineWidth(node, allowsKeywords));
}
/**
 * @param allowsKeywords whether keywords `initial` and `unset` count as zero
 * @return `true` if this node represents a non-zero border; otherwise, `false`
 */ function $c5987b6ef754a63c$var$checkLineStyle(valueNode, allowsKeywords = true) {
    if ($c5987b6ef754a63c$var$matches(valueNode, [
        'none',
        'hidden'
    ])) return false;
    if (allowsKeywords && $c5987b6ef754a63c$var$matches(valueNode, [
        'initial',
        'unset'
    ])) return false;
    return true;
}
function $c5987b6ef754a63c$var$checkLineStyleList(nodes, allowsKeywords = true) {
    return nodes.map((node)=>$c5987b6ef754a63c$var$checkLineStyle(node, allowsKeywords));
}
function $c5987b6ef754a63c$var$checkBorderShorthand(node) {
    const children = node.getChildren();
    // the only child can be a keyword, a <line-width>, or a <line-style>
    // if either check returns false, the result is no border
    if (children.length === 1) {
        const value = children[0];
        return $c5987b6ef754a63c$var$checkLineWidth(value) && $c5987b6ef754a63c$var$checkLineStyle(value);
    }
    // multiple children can't contain keywords
    // if any child means no border, the result is no border
    for (const child of children){
        const value = child;
        if (!$c5987b6ef754a63c$var$checkLineWidth(value, /* allowsKeywords: */ false) || !$c5987b6ef754a63c$var$checkLineStyle(value, /* allowsKeywords: */ false)) return false;
    }
    return true;
}
function $c5987b6ef754a63c$export$2e2bcd8739ae039(propertyTable) {
    const model = {
        top: {
            value: false,
            properties: []
        },
        right: {
            value: false,
            properties: []
        },
        bottom: {
            value: false,
            properties: []
        },
        left: {
            value: false,
            properties: []
        }
    };
    for (const property of propertyTable){
        const value = property.node.value;
        if (typeof value === 'undefined') continue;
        switch(property.fullPropertyName){
            case 'box-sizing':
                // has `box-sizing`, bail out
                return {
                    top: {
                        value: false,
                        properties: []
                    },
                    right: {
                        value: false,
                        properties: []
                    },
                    bottom: {
                        value: false,
                        properties: []
                    },
                    left: {
                        value: false,
                        properties: []
                    }
                };
            case 'width':
                model.width = property;
                break;
            case 'height':
                model.height = property;
                break;
            default:
                const segments = property.fullPropertyName.split('-');
                switch(segments[0]){
                    case 'border':
                        switch(segments[1]){
                            case undefined:
                            case 'top':
                            case 'right':
                            case 'bottom':
                            case 'left':
                                switch(segments[2]){
                                    case undefined:
                                        $c5987b6ef754a63c$var$updateModelWithValue(model, segments[1], $c5987b6ef754a63c$var$checkBorderShorthand(value), property);
                                        break;
                                    case 'width':
                                        // the initial value of `border-width` is `medium`, not zero
                                        $c5987b6ef754a63c$var$updateModelWithValue(model, segments[1], $c5987b6ef754a63c$var$checkLineWidth(value, false), property);
                                        break;
                                    case 'style':
                                        // the initial value of `border-style` is `none`
                                        $c5987b6ef754a63c$var$updateModelWithValue(model, segments[1], $c5987b6ef754a63c$var$checkLineStyle(value, true), property);
                                        break;
                                }
                                break;
                            case 'width':
                                // the initial value of `border-width` is `medium`, not zero
                                $c5987b6ef754a63c$var$updateModelWithList(model, $c5987b6ef754a63c$var$checkLineWidthList(value.getChildren(), false), property);
                                break;
                            case 'style':
                                // the initial value of `border-style` is `none`
                                $c5987b6ef754a63c$var$updateModelWithList(model, $c5987b6ef754a63c$var$checkLineStyleList(value.getChildren(), true), property);
                                break;
                        }
                        break;
                    case 'padding':
                        if (segments.length === 1) // the initial value of `padding` is zero
                        $c5987b6ef754a63c$var$updateModelWithList(model, $c5987b6ef754a63c$var$checkLineWidthList(value.getChildren(), true), property);
                        else // the initial value of `padding` is zero
                        $c5987b6ef754a63c$var$updateModelWithValue(model, segments[1], $c5987b6ef754a63c$var$checkLineWidth(value, true), property);
                        break;
                }
                break;
        }
    }
    return model;
}


'use strict';
class $198b58ff3325194f$var$NodesByRootMap {
    constructor(){
        this.data = {};
    }
    add(root, name, node) {
        let entry = this.data[root];
        if (!entry) {
            entry = {
                nodes: [],
                names: []
            };
            this.data[root] = entry;
        }
        entry.names.push(name);
        if (node) entry.nodes.push(node);
    }
}
class $198b58ff3325194f$export$d9caeaf2e086aed9 {
    static entries(node, document, settings, cssDataManager, entryFilter) {
        const visitor = new $198b58ff3325194f$export$d9caeaf2e086aed9(document, settings, cssDataManager);
        node.acceptVisitor(visitor);
        visitor.completeValidations();
        return visitor.getEntries(entryFilter);
    }
    constructor(document, settings, cssDataManager){
        this.cssDataManager = cssDataManager;
        this.warnings = [];
        this.settings = settings;
        this.documentText = document.getText();
        this.keyframes = new $198b58ff3325194f$var$NodesByRootMap();
        this.validProperties = {};
        const properties = settings.getSetting((0, $821c90df06192cad$export$c72f6eaae7b9adff).ValidProperties);
        if (Array.isArray(properties)) properties.forEach((p)=>{
            if (typeof p === 'string') {
                const name = p.trim().toLowerCase();
                if (name.length) this.validProperties[name] = true;
            }
        });
    }
    isValidPropertyDeclaration(element) {
        const propertyName = element.fullPropertyName;
        return this.validProperties[propertyName];
    }
    fetch(input, s) {
        const elements = [];
        for (const curr of input)if (curr.fullPropertyName === s) elements.push(curr);
        return elements;
    }
    fetchWithValue(input, s, v) {
        const elements = [];
        for (const inputElement of input)if (inputElement.fullPropertyName === s) {
            const expression = inputElement.node.getValue();
            if (expression && this.findValueInExpression(expression, v)) elements.push(inputElement);
        }
        return elements;
    }
    findValueInExpression(expression, v) {
        let found = false;
        expression.accept((node)=>{
            if (node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Identifier && node.matches(v)) found = true;
            return !found;
        });
        return found;
    }
    getEntries(filter = $bd0cebf2eccc0e7e$export$ca664994d1d54bff.Warning | $bd0cebf2eccc0e7e$export$ca664994d1d54bff.Error) {
        return this.warnings.filter((entry)=>{
            return (entry.getLevel() & filter) !== 0;
        });
    }
    addEntry(node, rule, details) {
        const entry = new $bd0cebf2eccc0e7e$export$e98856a975cab58e(node, rule, this.settings.getRule(rule), details);
        this.warnings.push(entry);
    }
    getMissingNames(expected, actual) {
        const expectedClone = expected.slice(0); // clone
        for(let i = 0; i < actual.length; i++){
            const k = expectedClone.indexOf(actual[i]);
            if (k !== -1) expectedClone[k] = null;
        }
        let result = null;
        for(let i = 0; i < expectedClone.length; i++){
            const curr = expectedClone[i];
            if (curr) {
                if (result === null) result = $3240faa9c744ac82$export$625550452a3fa3ec("'{0}'", curr);
                else result = $3240faa9c744ac82$export$625550452a3fa3ec("{0}, '{1}'", result, curr);
            }
        }
        return result;
    }
    visitNode(node) {
        switch(node.type){
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.UnknownAtRule:
                return this.visitUnknownAtRule(node);
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Keyframe:
                return this.visitKeyframe(node);
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.FontFace:
                return this.visitFontFace(node);
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Ruleset:
                return this.visitRuleSet(node);
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.SimpleSelector:
                return this.visitSimpleSelector(node);
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Function:
                return this.visitFunction(node);
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.NumericValue:
                return this.visitNumericValue(node);
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Import:
                return this.visitImport(node);
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.HexColorValue:
                return this.visitHexColorValue(node);
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.Prio:
                return this.visitPrio(node);
            case $bd0cebf2eccc0e7e$export$f06e977173f1857c.IdentifierSelector:
                return this.visitIdentifierSelector(node);
        }
        return true;
    }
    completeValidations() {
        this.validateKeyframes();
    }
    visitUnknownAtRule(node) {
        const atRuleName = node.getChild(0);
        if (!atRuleName) return false;
        const atDirective = this.cssDataManager.getAtDirective(atRuleName.getText());
        if (atDirective) return false;
        this.addEntry(atRuleName, (0, $821c90df06192cad$export$374633da432e5a39).UnknownAtRules, `Unknown at rule ${atRuleName.getText()}`);
        return true;
    }
    visitKeyframe(node) {
        const keyword = node.getKeyword();
        if (!keyword) return false;
        const text = keyword.getText();
        this.keyframes.add(node.getName(), text, text !== '@keyframes' ? keyword : null);
        return true;
    }
    validateKeyframes() {
        // @keyframe and it's vendor specific alternatives
        // @keyframe should be included
        const expected = [
            '@-webkit-keyframes',
            '@-moz-keyframes',
            '@-o-keyframes'
        ];
        for(const name in this.keyframes.data){
            const actual = this.keyframes.data[name].names;
            const needsStandard = actual.indexOf('@keyframes') === -1;
            if (!needsStandard && actual.length === 1) continue; // only the non-vendor specific keyword is used, that's fine, no warning
            const missingVendorSpecific = this.getMissingNames(expected, actual);
            if (missingVendorSpecific || needsStandard) for (const node of this.keyframes.data[name].nodes){
                if (needsStandard) {
                    const message = $3240faa9c744ac82$export$625550452a3fa3ec("Always define standard rule '@keyframes' when defining keyframes.");
                    this.addEntry(node, (0, $821c90df06192cad$export$374633da432e5a39).IncludeStandardPropertyWhenUsingVendorPrefix, message);
                }
                if (missingVendorSpecific) {
                    const message = $3240faa9c744ac82$export$625550452a3fa3ec("Always include all vendor specific rules: Missing: {0}", missingVendorSpecific);
                    this.addEntry(node, (0, $821c90df06192cad$export$374633da432e5a39).AllVendorPrefixes, message);
                }
            }
        }
        return true;
    }
    visitSimpleSelector(node) {
        /////////////////////////////////////////////////////////////
        //	Lint - The universal selector (*) is known to be slow.
        /////////////////////////////////////////////////////////////
        const firstChar = this.documentText.charAt(node.offset);
        if (node.length === 1 && firstChar === '*') this.addEntry(node, (0, $821c90df06192cad$export$374633da432e5a39).UniversalSelector);
        return true;
    }
    visitIdentifierSelector(node) {
        /////////////////////////////////////////////////////////////
        //	Lint - Avoid id selectors
        /////////////////////////////////////////////////////////////
        this.addEntry(node, (0, $821c90df06192cad$export$374633da432e5a39).AvoidIdSelector);
        return true;
    }
    visitImport(node) {
        /////////////////////////////////////////////////////////////
        //	Lint - Import statements shouldn't be used, because they aren't offering parallel downloads.
        /////////////////////////////////////////////////////////////
        this.addEntry(node, (0, $821c90df06192cad$export$374633da432e5a39).ImportStatemement);
        return true;
    }
    visitRuleSet(node) {
        /////////////////////////////////////////////////////////////
        //	Lint - Don't use empty rulesets.
        /////////////////////////////////////////////////////////////
        const declarations = node.getDeclarations();
        if (!declarations) // syntax error
        return false;
        if (!declarations.hasChildren()) this.addEntry(node.getSelectors(), (0, $821c90df06192cad$export$374633da432e5a39).EmptyRuleSet);
        const propertyTable = [];
        for (const element of declarations.getChildren())if (element instanceof $bd0cebf2eccc0e7e$export$48f3d9e786303b67) propertyTable.push(new (0, $c5987b6ef754a63c$export$db77ccec0bb4ccac)(element));
        /////////////////////////////////////////////////////////////
        // the rule warns when it finds:
        // width being used with border, border-left, border-right, padding, padding-left, or padding-right
        // height being used with border, border-top, border-bottom, padding, padding-top, or padding-bottom
        // No error when box-sizing property is specified, as it assumes the user knows what he's doing.
        // see https://github.com/CSSLint/csslint/wiki/Beware-of-box-model-size
        /////////////////////////////////////////////////////////////
        const boxModel = (0, $c5987b6ef754a63c$export$2e2bcd8739ae039)(propertyTable);
        if (boxModel.width) {
            let properties = [];
            if (boxModel.right.value) properties = (0, $0fa1735587167c7c$export$971dd5b0dfd021b6)(properties, boxModel.right.properties);
            if (boxModel.left.value) properties = (0, $0fa1735587167c7c$export$971dd5b0dfd021b6)(properties, boxModel.left.properties);
            if (properties.length !== 0) {
                for (const item of properties)this.addEntry(item.node, (0, $821c90df06192cad$export$374633da432e5a39).BewareOfBoxModelSize);
                this.addEntry(boxModel.width.node, (0, $821c90df06192cad$export$374633da432e5a39).BewareOfBoxModelSize);
            }
        }
        if (boxModel.height) {
            let properties = [];
            if (boxModel.top.value) properties = (0, $0fa1735587167c7c$export$971dd5b0dfd021b6)(properties, boxModel.top.properties);
            if (boxModel.bottom.value) properties = (0, $0fa1735587167c7c$export$971dd5b0dfd021b6)(properties, boxModel.bottom.properties);
            if (properties.length !== 0) {
                for (const item of properties)this.addEntry(item.node, (0, $821c90df06192cad$export$374633da432e5a39).BewareOfBoxModelSize);
                this.addEntry(boxModel.height.node, (0, $821c90df06192cad$export$374633da432e5a39).BewareOfBoxModelSize);
            }
        }
        /////////////////////////////////////////////////////////////
        //	Properties ignored due to display
        /////////////////////////////////////////////////////////////
        // With 'display: inline-block', 'float' has no effect
        let displayElems = this.fetchWithValue(propertyTable, 'display', 'inline-block');
        if (displayElems.length > 0) {
            const elem = this.fetch(propertyTable, 'float');
            for(let index = 0; index < elem.length; index++){
                const node = elem[index].node;
                const value = node.getValue();
                if (value && !value.matches('none')) this.addEntry(node, (0, $821c90df06192cad$export$374633da432e5a39).PropertyIgnoredDueToDisplay, $3240faa9c744ac82$export$625550452a3fa3ec("inline-block is ignored due to the float. If 'float' has a value other than 'none', the box is floated and 'display' is treated as 'block'"));
            }
        }
        // With 'display: block', 'vertical-align' has no effect
        displayElems = this.fetchWithValue(propertyTable, 'display', 'block');
        if (displayElems.length > 0) {
            const elem = this.fetch(propertyTable, 'vertical-align');
            for(let index = 0; index < elem.length; index++)this.addEntry(elem[index].node, (0, $821c90df06192cad$export$374633da432e5a39).PropertyIgnoredDueToDisplay, $3240faa9c744ac82$export$625550452a3fa3ec("Property is ignored due to the display. With 'display: block', vertical-align should not be used."));
        }
        /////////////////////////////////////////////////////////////
        //	Avoid 'float'
        /////////////////////////////////////////////////////////////
        const elements = this.fetch(propertyTable, 'float');
        for(let index = 0; index < elements.length; index++){
            const element = elements[index];
            if (!this.isValidPropertyDeclaration(element)) this.addEntry(element.node, (0, $821c90df06192cad$export$374633da432e5a39).AvoidFloat);
        }
        /////////////////////////////////////////////////////////////
        //	Don't use duplicate declarations.
        /////////////////////////////////////////////////////////////
        for(let i = 0; i < propertyTable.length; i++){
            const element = propertyTable[i];
            if (element.fullPropertyName !== 'background' && !this.validProperties[element.fullPropertyName]) {
                const value = element.node.getValue();
                if (value && this.documentText.charAt(value.offset) !== '-') {
                    const elements = this.fetch(propertyTable, element.fullPropertyName);
                    if (elements.length > 1) for(let k = 0; k < elements.length; k++){
                        const value = elements[k].node.getValue();
                        if (value && this.documentText.charAt(value.offset) !== '-' && elements[k] !== element) this.addEntry(element.node, (0, $821c90df06192cad$export$374633da432e5a39).DuplicateDeclarations);
                    }
                }
            }
        }
        /////////////////////////////////////////////////////////////
        //	Unknown propery & When using a vendor-prefixed gradient, make sure to use them all.
        /////////////////////////////////////////////////////////////
        const isExportBlock = node.getSelectors().matches(":export");
        if (!isExportBlock) {
            const propertiesBySuffix = new $198b58ff3325194f$var$NodesByRootMap();
            let containsUnknowns = false;
            for (const element of propertyTable){
                const decl = element.node;
                if (this.isCSSDeclaration(decl)) {
                    let name = element.fullPropertyName;
                    const firstChar = name.charAt(0);
                    if (firstChar === '-') {
                        if (name.charAt(1) !== '-') {
                            if (!this.cssDataManager.isKnownProperty(name) && !this.validProperties[name]) this.addEntry(decl.getProperty(), (0, $821c90df06192cad$export$374633da432e5a39).UnknownVendorSpecificProperty);
                            const nonPrefixedName = decl.getNonPrefixedPropertyName();
                            propertiesBySuffix.add(nonPrefixedName, name, decl.getProperty());
                        }
                    } else {
                        const fullName = name;
                        if (firstChar === '*' || firstChar === '_') {
                            this.addEntry(decl.getProperty(), (0, $821c90df06192cad$export$374633da432e5a39).IEStarHack);
                            name = name.substr(1);
                        }
                        // _property and *property might be contributed via custom data
                        if (!this.cssDataManager.isKnownProperty(fullName) && !this.cssDataManager.isKnownProperty(name)) {
                            if (!this.validProperties[name]) this.addEntry(decl.getProperty(), (0, $821c90df06192cad$export$374633da432e5a39).UnknownProperty, $3240faa9c744ac82$export$625550452a3fa3ec("Unknown property: '{0}'", decl.getFullPropertyName()));
                        }
                        propertiesBySuffix.add(name, name, null); // don't pass the node as we don't show errors on the standard
                    }
                } else containsUnknowns = true;
            }
            if (!containsUnknowns) for(const suffix in propertiesBySuffix.data){
                const entry = propertiesBySuffix.data[suffix];
                const actual = entry.names;
                const needsStandard = this.cssDataManager.isStandardProperty(suffix) && actual.indexOf(suffix) === -1;
                if (!needsStandard && actual.length === 1) continue; // only the non-vendor specific rule is used, that's fine, no warning
                /**
                     * We should ignore missing standard properties, if there's an explicit contextual reference to a
                     * vendor specific pseudo-element selector with the same vendor (prefix)
                     *
                     * (See https://github.com/microsoft/vscode/issues/164350)
                     */ const entriesThatNeedStandard = new Set(needsStandard ? entry.nodes : []);
                if (needsStandard) {
                    const pseudoElements = this.getContextualVendorSpecificPseudoElements(node);
                    for (const node of entry.nodes){
                        const propertyName = node.getName();
                        const prefix = propertyName.substring(0, propertyName.length - suffix.length);
                        if (pseudoElements.some((x)=>x.startsWith(prefix))) entriesThatNeedStandard.delete(node);
                    }
                }
                const expected = [];
                for(let i = 0, len = $198b58ff3325194f$export$d9caeaf2e086aed9.prefixes.length; i < len; i++){
                    const prefix = $198b58ff3325194f$export$d9caeaf2e086aed9.prefixes[i];
                    if (this.cssDataManager.isStandardProperty(prefix + suffix)) expected.push(prefix + suffix);
                }
                const missingVendorSpecific = this.getMissingNames(expected, actual);
                if (missingVendorSpecific || needsStandard) for (const node of entry.nodes){
                    if (needsStandard && entriesThatNeedStandard.has(node)) {
                        const message = $3240faa9c744ac82$export$625550452a3fa3ec("Also define the standard property '{0}' for compatibility", suffix);
                        this.addEntry(node, (0, $821c90df06192cad$export$374633da432e5a39).IncludeStandardPropertyWhenUsingVendorPrefix, message);
                    }
                    if (missingVendorSpecific) {
                        const message = $3240faa9c744ac82$export$625550452a3fa3ec("Always include all vendor specific properties: Missing: {0}", missingVendorSpecific);
                        this.addEntry(node, (0, $821c90df06192cad$export$374633da432e5a39).AllVendorPrefixes, message);
                    }
                }
            }
        }
        return true;
    }
    /**
     * Walks up the syntax tree (starting from given `node`) and captures vendor
     * specific pseudo-element selectors.
     * @returns An array of vendor specific pseudo-elements; or empty if none
     * was found.
     */ getContextualVendorSpecificPseudoElements(node) {
        function walkDown(s, n) {
            for (const child of n.getChildren()){
                if (child.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.PseudoSelector) {
                    const pseudoElement = child.getChildren()[0]?.getText();
                    if (pseudoElement) s.add(pseudoElement);
                }
                walkDown(s, child);
            }
        }
        function walkUp(s, n) {
            if (n.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Ruleset) for (const selector of n.getSelectors().getChildren())walkDown(s, selector);
            return n.parent ? walkUp(s, n.parent) : undefined;
        }
        const result = new Set();
        walkUp(result, node);
        return Array.from(result);
    }
    visitPrio(node) {
        /////////////////////////////////////////////////////////////
        //	Don't use !important
        /////////////////////////////////////////////////////////////
        this.addEntry(node, (0, $821c90df06192cad$export$374633da432e5a39).AvoidImportant);
        return true;
    }
    visitNumericValue(node) {
        /////////////////////////////////////////////////////////////
        //	0 has no following unit
        /////////////////////////////////////////////////////////////
        const funcDecl = node.findParent($bd0cebf2eccc0e7e$export$f06e977173f1857c.Function);
        if (funcDecl && funcDecl.getName() === 'calc') return true;
        const decl = node.findParent($bd0cebf2eccc0e7e$export$f06e977173f1857c.Declaration);
        if (decl) {
            const declValue = decl.getValue();
            if (declValue) {
                const value = node.getValue();
                if (!value.unit || $4b3cdcd55d375778$export$fe0319385f0cf5a7.length.indexOf(value.unit.toLowerCase()) === -1) return true;
                if (parseFloat(value.value) === 0.0 && !!value.unit && !this.validProperties[decl.getFullPropertyName()]) this.addEntry(node, (0, $821c90df06192cad$export$374633da432e5a39).ZeroWithUnit);
            }
        }
        return true;
    }
    visitFontFace(node) {
        const declarations = node.getDeclarations();
        if (!declarations) // syntax error
        return false;
        let definesSrc = false, definesFontFamily = false;
        let containsUnknowns = false;
        for (const node of declarations.getChildren())if (this.isCSSDeclaration(node)) {
            const name = node.getProperty().getName().toLowerCase();
            if (name === 'src') definesSrc = true;
            if (name === 'font-family') definesFontFamily = true;
        } else containsUnknowns = true;
        if (!containsUnknowns && (!definesSrc || !definesFontFamily)) this.addEntry(node, (0, $821c90df06192cad$export$374633da432e5a39).RequiredPropertiesForFontFace);
        return true;
    }
    isCSSDeclaration(node) {
        if (node instanceof $bd0cebf2eccc0e7e$export$48f3d9e786303b67) {
            if (!node.getValue()) return false;
            const property = node.getProperty();
            if (!property) return false;
            const identifier = property.getIdentifier();
            if (!identifier || identifier.containsInterpolation()) return false;
            return true;
        }
        return false;
    }
    visitHexColorValue(node) {
        // Rule: #eeff0011 or #eeff00 or #ef01 or #ef0
        const length = node.length;
        if (length !== 9 && length !== 7 && length !== 5 && length !== 4) this.addEntry(node, (0, $821c90df06192cad$export$374633da432e5a39).HexColorLength);
        return false;
    }
    visitFunction(node) {
        const fnName = node.getName().toLowerCase();
        let expectedAttrCount = -1;
        let actualAttrCount = 0;
        switch(fnName){
            case 'rgb(':
            case 'hsl(':
                expectedAttrCount = 3;
                break;
            case 'rgba(':
            case 'hsla(':
                expectedAttrCount = 4;
                break;
        }
        if (expectedAttrCount !== -1) {
            node.getArguments().accept((n)=>{
                if (n instanceof $bd0cebf2eccc0e7e$export$5351bc98fa48e09c) {
                    actualAttrCount += 1;
                    return false;
                }
                return true;
            });
            if (actualAttrCount !== expectedAttrCount) this.addEntry(node, (0, $821c90df06192cad$export$374633da432e5a39).ArgsInColorFunction);
        }
        return true;
    }
}
$198b58ff3325194f$export$d9caeaf2e086aed9.prefixes = [
    '-ms-',
    '-moz-',
    '-o-',
    '-webkit-'
];



'use strict';
class $9791bfc028751c44$export$1500a191fd69c663 {
    constructor(cssDataManager){
        this.cssDataManager = cssDataManager;
    }
    configure(settings) {
        this.settings = settings;
    }
    doValidation(document, stylesheet, settings = this.settings) {
        if (settings && settings.validate === false) return [];
        const entries = [];
        entries.push.apply(entries, $bd0cebf2eccc0e7e$export$376f37e19157ceda.entries(stylesheet));
        entries.push.apply(entries, (0, $198b58ff3325194f$export$d9caeaf2e086aed9).entries(stylesheet, document, new (0, $821c90df06192cad$export$786692e090cbce75)(settings && settings.lint), this.cssDataManager));
        const ruleIds = [];
        for(const r in 0, $821c90df06192cad$export$374633da432e5a39)ruleIds.push((0, $821c90df06192cad$export$374633da432e5a39)[r].id);
        function toDiagnostic(marker) {
            const range = (0, $1345bdc33671c7a9$exports.Range).create(document.positionAt(marker.getOffset()), document.positionAt(marker.getOffset() + marker.getLength()));
            const source = document.languageId;
            return {
                code: marker.getRule().id,
                source: source,
                message: marker.getMessage(),
                severity: marker.getLevel() === $bd0cebf2eccc0e7e$export$ca664994d1d54bff.Warning ? (0, $1345bdc33671c7a9$exports.DiagnosticSeverity).Warning : (0, $1345bdc33671c7a9$exports.DiagnosticSeverity).Error,
                range: range
            };
        }
        return entries.filter((entry)=>entry.getLevel() !== $bd0cebf2eccc0e7e$export$ca664994d1d54bff.Ignore).map(toDiagnostic);
    }
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 
'use strict';
const $63ef42c3a3e4cf2c$var$_FSL = '/'.charCodeAt(0);
const $63ef42c3a3e4cf2c$var$_NWL = '\n'.charCodeAt(0);
const $63ef42c3a3e4cf2c$var$_CAR = '\r'.charCodeAt(0);
const $63ef42c3a3e4cf2c$var$_LFD = '\f'.charCodeAt(0);
const $63ef42c3a3e4cf2c$var$_DLR = '$'.charCodeAt(0);
const $63ef42c3a3e4cf2c$var$_HSH = '#'.charCodeAt(0);
const $63ef42c3a3e4cf2c$var$_CUL = '{'.charCodeAt(0);
const $63ef42c3a3e4cf2c$var$_EQS = '='.charCodeAt(0);
const $63ef42c3a3e4cf2c$var$_BNG = '!'.charCodeAt(0);
const $63ef42c3a3e4cf2c$var$_LAN = '<'.charCodeAt(0);
const $63ef42c3a3e4cf2c$var$_RAN = '>'.charCodeAt(0);
const $63ef42c3a3e4cf2c$var$_DOT = '.'.charCodeAt(0);
const $63ef42c3a3e4cf2c$var$_ATS = '@'.charCodeAt(0);
let $63ef42c3a3e4cf2c$var$customTokenValue = (0, $2a533f0146ced75e$export$f435f793048e7a0f).CustomToken;
const $63ef42c3a3e4cf2c$export$192c796a748aeea5 = $63ef42c3a3e4cf2c$var$customTokenValue++;
const $63ef42c3a3e4cf2c$export$4feb516370e0ca6e = $63ef42c3a3e4cf2c$var$customTokenValue++;
const $63ef42c3a3e4cf2c$export$39bcc3f08a9b5fa4 = $63ef42c3a3e4cf2c$var$customTokenValue++;
const $63ef42c3a3e4cf2c$export$158474a010a4a93c = $63ef42c3a3e4cf2c$var$customTokenValue++;
const $63ef42c3a3e4cf2c$export$280f289ed1bb240e = $63ef42c3a3e4cf2c$var$customTokenValue++;
const $63ef42c3a3e4cf2c$export$62ec28f9ad39452d = $63ef42c3a3e4cf2c$var$customTokenValue++;
const $63ef42c3a3e4cf2c$export$1019a61343978da1 = $63ef42c3a3e4cf2c$var$customTokenValue++;
const $63ef42c3a3e4cf2c$export$1297970233533a7d = $63ef42c3a3e4cf2c$var$customTokenValue++;
const $63ef42c3a3e4cf2c$export$c3a9d7ff17e4f3ed = $63ef42c3a3e4cf2c$var$customTokenValue++;
class $63ef42c3a3e4cf2c$export$8c54bcb21e842650 extends (0, $2a533f0146ced75e$export$2da42535f3a161df) {
    scanNext(offset) {
        // scss variable
        if (this.stream.advanceIfChar($63ef42c3a3e4cf2c$var$_DLR)) {
            const content = [
                '$'
            ];
            if (this.ident(content)) return this.finishToken(offset, $63ef42c3a3e4cf2c$export$192c796a748aeea5, content.join(''));
            else this.stream.goBackTo(offset);
        }
        // scss: interpolation function #{..})
        if (this.stream.advanceIfChars([
            $63ef42c3a3e4cf2c$var$_HSH,
            $63ef42c3a3e4cf2c$var$_CUL
        ])) return this.finishToken(offset, $63ef42c3a3e4cf2c$export$4feb516370e0ca6e);
        // operator ==
        if (this.stream.advanceIfChars([
            $63ef42c3a3e4cf2c$var$_EQS,
            $63ef42c3a3e4cf2c$var$_EQS
        ])) return this.finishToken(offset, $63ef42c3a3e4cf2c$export$158474a010a4a93c);
        // operator !=
        if (this.stream.advanceIfChars([
            $63ef42c3a3e4cf2c$var$_BNG,
            $63ef42c3a3e4cf2c$var$_EQS
        ])) return this.finishToken(offset, $63ef42c3a3e4cf2c$export$280f289ed1bb240e);
        // operators <, <=
        if (this.stream.advanceIfChar($63ef42c3a3e4cf2c$var$_LAN)) {
            if (this.stream.advanceIfChar($63ef42c3a3e4cf2c$var$_EQS)) return this.finishToken(offset, $63ef42c3a3e4cf2c$export$1019a61343978da1);
            return this.finishToken(offset, (0, $2a533f0146ced75e$export$f435f793048e7a0f).Delim);
        }
        // ooperators >, >=
        if (this.stream.advanceIfChar($63ef42c3a3e4cf2c$var$_RAN)) {
            if (this.stream.advanceIfChar($63ef42c3a3e4cf2c$var$_EQS)) return this.finishToken(offset, $63ef42c3a3e4cf2c$export$62ec28f9ad39452d);
            return this.finishToken(offset, (0, $2a533f0146ced75e$export$f435f793048e7a0f).Delim);
        }
        // ellipis
        if (this.stream.advanceIfChars([
            $63ef42c3a3e4cf2c$var$_DOT,
            $63ef42c3a3e4cf2c$var$_DOT,
            $63ef42c3a3e4cf2c$var$_DOT
        ])) return this.finishToken(offset, $63ef42c3a3e4cf2c$export$1297970233533a7d);
        return super.scanNext(offset);
    }
    comment() {
        if (super.comment()) return true;
        if (!this.inURL && this.stream.advanceIfChars([
            $63ef42c3a3e4cf2c$var$_FSL,
            $63ef42c3a3e4cf2c$var$_FSL
        ])) {
            this.stream.advanceWhileChar((ch)=>{
                switch(ch){
                    case $63ef42c3a3e4cf2c$var$_NWL:
                    case $63ef42c3a3e4cf2c$var$_CAR:
                    case $63ef42c3a3e4cf2c$var$_LFD:
                        return false;
                    default:
                        return true;
                }
            });
            return true;
        } else return false;
    }
}





/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 
'use strict';
class $b0146299b360156d$export$27d6460931436017 {
    constructor(id, message){
        this.id = id;
        this.message = message;
    }
}
const $b0146299b360156d$export$94e6c22232140b44 = {
    FromExpected: new $b0146299b360156d$export$27d6460931436017('scss-fromexpected', $3240faa9c744ac82$export$625550452a3fa3ec("'from' expected")),
    ThroughOrToExpected: new $b0146299b360156d$export$27d6460931436017('scss-throughexpected', $3240faa9c744ac82$export$625550452a3fa3ec("'through' or 'to' expected")),
    InExpected: new $b0146299b360156d$export$27d6460931436017('scss-fromexpected', $3240faa9c744ac82$export$625550452a3fa3ec("'in' expected"))
};



'use strict';
class $459ca5e86e85a7eb$export$9c43cb3656f18101 extends $48c6713331b54e18$export$7acfa6ed01010e37 {
    constructor(){
        super(new $63ef42c3a3e4cf2c$export$8c54bcb21e842650());
    }
    _parseStylesheetStatement(isNested = false) {
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword)) return this._parseWarnAndDebug() // @warn, @debug and @error statements
         || this._parseControlStatement() // @if, @while, @for, @each
         || this._parseMixinDeclaration() // @mixin
         || this._parseMixinContent() // @content
         || this._parseMixinReference() // @include
         || this._parseFunctionDeclaration() // @function
         || this._parseForward() // @forward
         || this._parseUse() // @use
         || this._parseRuleset(isNested) // @at-rule
         || super._parseStylesheetAtStatement(isNested);
        return this._parseRuleset(true) || this._parseVariableDeclaration();
    }
    _parseImport() {
        if (!this.peekKeyword('@import')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$d0dbb306591aec74);
        this.consumeToken();
        if (!node.addChild(this._parseURILiteral()) && !node.addChild(this._parseStringLiteral())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).URIOrStringExpected);
        while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
            if (!node.addChild(this._parseURILiteral()) && !node.addChild(this._parseStringLiteral())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).URIOrStringExpected);
        }
        return this._completeParseImport(node);
    }
    // scss variables: $font-size: 12px;
    _parseVariableDeclaration(panic = []) {
        if (!this.peek($63ef42c3a3e4cf2c$export$192c796a748aeea5)) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$839cf4f882eabac8);
        if (!node.setVariable(this._parseVariable())) return null;
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ColonExpected);
        if (this.prevToken) node.colonPosition = this.prevToken.offset;
        if (!node.setValue(this._parseExpr())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).VariableValueExpected, [], panic);
        while(this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Exclamation)){
            if (node.addChild(this._tryParsePrio())) ;
            else {
                this.consumeToken();
                if (!this.peekRegExp((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident, /^(default|global)$/)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).UnknownKeyword);
                this.consumeToken();
            }
        }
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)) node.semicolonPosition = this.token.offset; // not part of the declaration, but useful information for code assist
        return this.finish(node);
    }
    _parseMediaCondition() {
        return this._parseInterpolation() || super._parseMediaCondition();
    }
    _parseMediaFeatureRangeOperator() {
        return this.accept($63ef42c3a3e4cf2c$export$1019a61343978da1) || this.accept($63ef42c3a3e4cf2c$export$62ec28f9ad39452d) || super._parseMediaFeatureRangeOperator();
    }
    _parseMediaFeatureName() {
        return this._parseModuleMember() || this._parseFunction() // function before ident
         || this._parseIdent() || this._parseVariable();
    }
    _parseKeyframeSelector() {
        return this._tryParseKeyframeSelector() || this._parseControlStatement(this._parseKeyframeSelector.bind(this)) || this._parseWarnAndDebug() // @warn, @debug and @error statements
         || this._parseMixinReference() // @include
         || this._parseFunctionDeclaration() // @function
         || this._parseVariableDeclaration() || this._parseMixinContent();
    }
    _parseVariable() {
        if (!this.peek($63ef42c3a3e4cf2c$export$192c796a748aeea5)) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$c867a5c9595a1350);
        this.consumeToken();
        return node;
    }
    _parseModuleMember() {
        const pos = this.mark();
        const node = this.create($bd0cebf2eccc0e7e$export$c3a9d7ff17e4f3ed);
        if (!node.setIdentifier(this._parseIdent([
            $bd0cebf2eccc0e7e$export$8868dff548d048cf.Module
        ]))) return null;
        if (this.hasWhitespace() || !this.acceptDelim('.') || this.hasWhitespace()) {
            this.restoreAtMark(pos);
            return null;
        }
        if (!node.addChild(this._parseVariable() || this._parseFunction())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierOrVariableExpected);
        return node;
    }
    _parseIdent(referenceTypes) {
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident) && !this.peek($63ef42c3a3e4cf2c$export$4feb516370e0ca6e) && !this.peekDelim('-')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$989167234458594d);
        node.referenceTypes = referenceTypes;
        node.isCustomProperty = this.peekRegExp((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident, /^--/);
        let hasContent = false;
        const indentInterpolation = ()=>{
            const pos = this.mark();
            if (this.acceptDelim('-')) {
                if (!this.hasWhitespace()) this.acceptDelim('-');
                if (this.hasWhitespace()) {
                    this.restoreAtMark(pos);
                    return null;
                }
            }
            return this._parseInterpolation();
        };
        while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident) || node.addChild(indentInterpolation()) || hasContent && this.acceptRegexp(/^[\w-]/)){
            hasContent = true;
            if (this.hasWhitespace()) break;
        }
        return hasContent ? this.finish(node) : null;
    }
    _parseTermExpression() {
        return this._parseModuleMember() || this._parseVariable() || this._parseNestingSelector() || //this._tryParsePrio() ||
        super._parseTermExpression();
    }
    _parseInterpolation() {
        if (this.peek($63ef42c3a3e4cf2c$export$4feb516370e0ca6e)) {
            const node = this.create($bd0cebf2eccc0e7e$export$b0cc4f9860136880);
            this.consumeToken();
            if (!node.addChild(this._parseExpr()) && !this._parseNestingSelector()) {
                if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR)) return this.finish(node);
                return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ExpressionExpected);
            }
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightCurlyExpected);
            return this.finish(node);
        }
        return null;
    }
    _parseOperator() {
        if (this.peek($63ef42c3a3e4cf2c$export$158474a010a4a93c) || this.peek($63ef42c3a3e4cf2c$export$280f289ed1bb240e) || this.peek($63ef42c3a3e4cf2c$export$62ec28f9ad39452d) || this.peek($63ef42c3a3e4cf2c$export$1019a61343978da1) || this.peekDelim('>') || this.peekDelim('<') || this.peekIdent('and') || this.peekIdent('or') || this.peekDelim('%')) {
            const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.Operator);
            this.consumeToken();
            return this.finish(node);
        }
        return super._parseOperator();
    }
    _parseUnaryOperator() {
        if (this.peekIdent('not')) {
            const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
            this.consumeToken();
            return this.finish(node);
        }
        return super._parseUnaryOperator();
    }
    _parseRuleSetDeclaration() {
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword)) return this._parseKeyframe() // nested @keyframe
         || this._parseImport() // nested @import
         || this._parseMedia(true) // nested @media
         || this._parseFontFace() // nested @font-face
         || this._parseWarnAndDebug() // @warn, @debug and @error statements
         || this._parseControlStatement() // @if, @while, @for, @each
         || this._parseFunctionDeclaration() // @function
         || this._parseExtends() // @extends
         || this._parseMixinReference() // @include
         || this._parseMixinContent() // @content
         || this._parseMixinDeclaration() // nested @mixin
         || this._parseRuleset(true) // @at-rule
         || this._parseSupports(true) // @supports
         || this._parseLayer() // @layer
         || this._parsePropertyAtRule() // @property
         || this._parseContainer(true) // nested @container
         || this._parseRuleSetDeclarationAtStatement();
        return this._parseVariableDeclaration() // variable declaration
         || this._tryParseRuleset(true) // nested ruleset
         || this._parseDeclaration(); // try css ruleset declaration as last so in the error case, the ast will contain a declaration
    }
    _parseDeclaration(stopTokens) {
        const custonProperty = this._tryParseCustomPropertyDeclaration(stopTokens);
        if (custonProperty) return custonProperty;
        const node = this.create($bd0cebf2eccc0e7e$export$48f3d9e786303b67);
        if (!node.setProperty(this._parseProperty())) return null;
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ColonExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon
        ], stopTokens || [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon
        ]);
        if (this.prevToken) node.colonPosition = this.prevToken.offset;
        let hasContent = false;
        if (node.setValue(this._parseExpr())) {
            hasContent = true;
            node.addChild(this._parsePrio());
        }
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL)) node.setNestedProperties(this._parseNestedProperties());
        else {
            if (!hasContent) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).PropertyValueExpected);
        }
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)) node.semicolonPosition = this.token.offset; // not part of the declaration, but useful information for code assist
        return this.finish(node);
    }
    _parseNestedProperties() {
        const node = this.create($bd0cebf2eccc0e7e$export$791a0a3a4cdc7a08);
        return this._parseBody(node, this._parseDeclaration.bind(this));
    }
    _parseExtends() {
        if (this.peekKeyword('@extend')) {
            const node = this.create($bd0cebf2eccc0e7e$export$aebff1c4d1af2d3a);
            this.consumeToken();
            if (!node.getSelectors().addChild(this._parseSimpleSelector())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).SelectorExpected);
            while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma))node.getSelectors().addChild(this._parseSimpleSelector());
            if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Exclamation)) {
                if (!this.acceptIdent('optional')) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).UnknownKeyword);
            }
            return this.finish(node);
        }
        return null;
    }
    _parseSimpleSelectorBody() {
        return this._parseSelectorPlaceholder() || super._parseSimpleSelectorBody();
    }
    _parseNestingSelector() {
        if (this.peekDelim('&')) {
            const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorCombinator);
            this.consumeToken();
            while(!this.hasWhitespace() && (this.acceptDelim('-') || this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Num) || this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Dimension) || node.addChild(this._parseIdent()) || this.acceptDelim('&')));
            return this.finish(node);
        }
        return null;
    }
    _parseSelectorPlaceholder() {
        if (this.peekDelim('%')) {
            const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorPlaceholder);
            this.consumeToken();
            this._parseIdent();
            return this.finish(node);
        } else if (this.peekKeyword('@at-root')) {
            const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorPlaceholder);
            this.consumeToken();
            if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
                if (!this.acceptIdent('with') && !this.acceptIdent('without')) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected);
                if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ColonExpected);
                if (!node.addChild(this._parseIdent())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected);
                if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected, [
                    (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
                ]);
            }
            return this.finish(node);
        }
        return null;
    }
    _parseElementName() {
        const pos = this.mark();
        const node = super._parseElementName();
        if (node && !this.hasWhitespace() && this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            this.restoreAtMark(pos);
            return null;
        }
        return node;
    }
    _tryParsePseudoIdentifier() {
        return this._parseInterpolation() || super._tryParsePseudoIdentifier(); // for #49589
    }
    _parseWarnAndDebug() {
        if (!this.peekKeyword('@debug') && !this.peekKeyword('@warn') && !this.peekKeyword('@error')) return null;
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.Debug);
        this.consumeToken(); // @debug, @warn or @error
        node.addChild(this._parseExpr()); // optional
        return this.finish(node);
    }
    _parseControlStatement(parseStatement = this._parseRuleSetDeclaration.bind(this)) {
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword)) return null;
        return this._parseIfStatement(parseStatement) || this._parseForStatement(parseStatement) || this._parseEachStatement(parseStatement) || this._parseWhileStatement(parseStatement);
    }
    _parseIfStatement(parseStatement) {
        if (!this.peekKeyword('@if')) return null;
        return this._internalParseIfStatement(parseStatement);
    }
    _internalParseIfStatement(parseStatement) {
        const node = this.create($bd0cebf2eccc0e7e$export$9017d3771bcf5fda);
        this.consumeToken(); // @if or if
        if (!node.setExpression(this._parseExpr(true))) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ExpressionExpected);
        this._parseBody(node, parseStatement);
        if (this.acceptKeyword('@else')) {
            if (this.peekIdent('if')) node.setElseClause(this._internalParseIfStatement(parseStatement));
            else if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL)) {
                const elseNode = this.create($bd0cebf2eccc0e7e$export$bf9e95c0b5a6e7f7);
                this._parseBody(elseNode, parseStatement);
                node.setElseClause(elseNode);
            }
        }
        return this.finish(node);
    }
    _parseForStatement(parseStatement) {
        if (!this.peekKeyword('@for')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$7fbe105ea6b2947);
        this.consumeToken(); // @for
        if (!node.setVariable(this._parseVariable())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).VariableNameExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
        ]);
        if (!this.acceptIdent('from')) return this.finish(node, (0, $b0146299b360156d$export$94e6c22232140b44).FromExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
        ]);
        if (!node.addChild(this._parseBinaryExpr())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ExpressionExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
        ]);
        if (!this.acceptIdent('to') && !this.acceptIdent('through')) return this.finish(node, (0, $b0146299b360156d$export$94e6c22232140b44).ThroughOrToExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
        ]);
        if (!node.addChild(this._parseBinaryExpr())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ExpressionExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
        ]);
        return this._parseBody(node, parseStatement);
    }
    _parseEachStatement(parseStatement) {
        if (!this.peekKeyword('@each')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$54f14bc486f54670);
        this.consumeToken(); // @each
        const variables = node.getVariables();
        if (!variables.addChild(this._parseVariable())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).VariableNameExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
        ]);
        while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
            if (!variables.addChild(this._parseVariable())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).VariableNameExpected, [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
            ]);
        }
        this.finish(variables);
        if (!this.acceptIdent('in')) return this.finish(node, (0, $b0146299b360156d$export$94e6c22232140b44).InExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
        ]);
        if (!node.addChild(this._parseExpr())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ExpressionExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
        ]);
        return this._parseBody(node, parseStatement);
    }
    _parseWhileStatement(parseStatement) {
        if (!this.peekKeyword('@while')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$479b943950dcc4d3);
        this.consumeToken(); // @while
        if (!node.addChild(this._parseBinaryExpr())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ExpressionExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
        ]);
        return this._parseBody(node, parseStatement);
    }
    _parseFunctionBodyDeclaration() {
        return this._parseVariableDeclaration() || this._parseReturnStatement() || this._parseWarnAndDebug() || this._parseControlStatement(this._parseFunctionBodyDeclaration.bind(this));
    }
    _parseFunctionDeclaration() {
        if (!this.peekKeyword('@function')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$db0c6820087997c2);
        this.consumeToken(); // @function
        if (!node.setIdentifier(this._parseIdent([
            $bd0cebf2eccc0e7e$export$8868dff548d048cf.Function
        ]))) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
        ]);
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftParenthesisExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
        ]);
        if (node.getParameters().addChild(this._parseParameterDeclaration())) while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
            if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) break;
            if (!node.getParameters().addChild(this._parseParameterDeclaration())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).VariableNameExpected);
        }
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
        ]);
        return this._parseBody(node, this._parseFunctionBodyDeclaration.bind(this));
    }
    _parseReturnStatement() {
        if (!this.peekKeyword('@return')) return null;
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.ReturnStatement);
        this.consumeToken(); // @function
        if (!node.addChild(this._parseExpr())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ExpressionExpected);
        return this.finish(node);
    }
    _parseMixinDeclaration() {
        if (!this.peekKeyword('@mixin')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$f518258a40310702);
        this.consumeToken();
        if (!node.setIdentifier(this._parseIdent([
            $bd0cebf2eccc0e7e$export$8868dff548d048cf.Mixin
        ]))) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
        ]);
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            if (node.getParameters().addChild(this._parseParameterDeclaration())) while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
                if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) break;
                if (!node.getParameters().addChild(this._parseParameterDeclaration())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).VariableNameExpected);
            }
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected, [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
            ]);
        }
        return this._parseBody(node, this._parseRuleSetDeclaration.bind(this));
    }
    _parseParameterDeclaration() {
        const node = this.create($bd0cebf2eccc0e7e$export$e8b5f24364ee45a9);
        if (!node.setIdentifier(this._parseVariable())) return null;
        this.accept($63ef42c3a3e4cf2c$export$1297970233533a7d);
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) {
            if (!node.setDefaultValue(this._parseExpr(true))) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).VariableValueExpected, [], [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma,
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR
            ]);
        }
        return this.finish(node);
    }
    _parseMixinContent() {
        if (!this.peekKeyword('@content')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$dfb915b95ac305eb);
        this.consumeToken();
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            if (node.getArguments().addChild(this._parseFunctionArgument())) while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
                if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) break;
                if (!node.getArguments().addChild(this._parseFunctionArgument())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ExpressionExpected);
            }
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected);
        }
        return this.finish(node);
    }
    _parseMixinReference() {
        if (!this.peekKeyword('@include')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$8ca7a1a636597cad);
        this.consumeToken();
        // Could be module or mixin identifier, set as mixin as default.
        const firstIdent = this._parseIdent([
            $bd0cebf2eccc0e7e$export$8868dff548d048cf.Mixin
        ]);
        if (!node.setIdentifier(firstIdent)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
        ]);
        // Is a module accessor.
        if (!this.hasWhitespace() && this.acceptDelim('.') && !this.hasWhitespace()) {
            const secondIdent = this._parseIdent([
                $bd0cebf2eccc0e7e$export$8868dff548d048cf.Mixin
            ]);
            if (!secondIdent) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected, [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR
            ]);
            const moduleToken = this.create($bd0cebf2eccc0e7e$export$c3a9d7ff17e4f3ed);
            // Re-purpose first matched ident as identifier for module token.
            firstIdent.referenceTypes = [
                $bd0cebf2eccc0e7e$export$8868dff548d048cf.Module
            ];
            moduleToken.setIdentifier(firstIdent);
            // Override identifier with second ident.
            node.setIdentifier(secondIdent);
            node.addChild(moduleToken);
        }
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            if (node.getArguments().addChild(this._parseFunctionArgument())) while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
                if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) break;
                if (!node.getArguments().addChild(this._parseFunctionArgument())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ExpressionExpected);
            }
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected);
        }
        if (this.peekIdent('using') || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL)) node.setContent(this._parseMixinContentDeclaration());
        return this.finish(node);
    }
    _parseMixinContentDeclaration() {
        const node = this.create($bd0cebf2eccc0e7e$export$33a2610af6b3f2ee);
        if (this.acceptIdent('using')) {
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftParenthesisExpected, [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL
            ]);
            if (node.getParameters().addChild(this._parseParameterDeclaration())) while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
                if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) break;
                if (!node.getParameters().addChild(this._parseParameterDeclaration())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).VariableNameExpected);
            }
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected, [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL
            ]);
        }
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL)) this._parseBody(node, this._parseMixinReferenceBodyStatement.bind(this));
        return this.finish(node);
    }
    _parseMixinReferenceBodyStatement() {
        return this._tryParseKeyframeSelector() || this._parseRuleSetDeclaration();
    }
    _parseFunctionArgument() {
        // [variableName ':'] expression | variableName '...'
        const node = this.create($bd0cebf2eccc0e7e$export$5868bced5e602b28);
        const pos = this.mark();
        const argument = this._parseVariable();
        if (argument) {
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) {
                if (this.accept($63ef42c3a3e4cf2c$export$1297970233533a7d)) {
                    node.setValue(argument);
                    return this.finish(node);
                } else this.restoreAtMark(pos);
            } else node.setIdentifier(argument);
        }
        if (node.setValue(this._parseExpr(true))) {
            this.accept($63ef42c3a3e4cf2c$export$1297970233533a7d); // #43746
            node.addChild(this._parsePrio()); // #9859
            return this.finish(node);
        } else if (node.setValue(this._tryParsePrio())) return this.finish(node);
        return null;
    }
    _parseURLArgument() {
        const pos = this.mark();
        const node = super._parseURLArgument();
        if (!node || !this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) {
            this.restoreAtMark(pos);
            const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
            node.addChild(this._parseBinaryExpr());
            return this.finish(node);
        }
        return node;
    }
    _parseOperation() {
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
        this.consumeToken();
        while(node.addChild(this._parseListElement()))this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma); // optional
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected);
        return this.finish(node);
    }
    _parseListElement() {
        const node = this.create($bd0cebf2eccc0e7e$export$fe34ec5df90a97ec);
        const child = this._parseBinaryExpr();
        if (!child) return null;
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) {
            node.setKey(child);
            if (!node.setValue(this._parseBinaryExpr())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ExpressionExpected);
        } else node.setValue(child);
        return this.finish(node);
    }
    _parseUse() {
        if (!this.peekKeyword('@use')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$2973c9696e76e472);
        this.consumeToken(); // @use
        if (!node.addChild(this._parseStringLiteral())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).StringLiteralExpected);
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon) && !this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF)) {
            if (!this.peekRegExp((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident, /as|with/)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).UnknownKeyword);
            if (this.acceptIdent('as') && !node.setIdentifier(this._parseIdent([
                $bd0cebf2eccc0e7e$export$8868dff548d048cf.Module
            ])) && !this.acceptDelim('*')) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierOrWildcardExpected);
            if (this.acceptIdent('with')) {
                if (!node.setParameters(this._parseModuleConfig())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftParenthesisExpected, [
                    (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR
                ]);
            }
        }
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon) && !this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).SemiColonExpected);
        return this.finish(node);
    }
    _parseModuleConfig() {
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.ModuleConfig);
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) return null;
        // First variable statement, no comma.
        if (!node.addChild(this._parseModuleConfigDeclaration())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).VariableNameExpected);
        while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
            if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) break;
            if (!node.addChild(this._parseModuleConfigDeclaration())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).VariableNameExpected);
        }
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected);
        return this.finish(node);
    }
    _parseModuleConfigDeclaration() {
        const node = this.create($bd0cebf2eccc0e7e$export$a9d66896dff4ea40);
        if (!node.setIdentifier(this._parseVariable())) return null;
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon) || !node.setValue(this._parseExpr(true))) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).VariableValueExpected, [], [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma,
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR
        ]);
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Exclamation)) {
            if (this.hasWhitespace() || !this.acceptIdent('default')) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).UnknownKeyword);
        }
        return this.finish(node);
    }
    _parseForward() {
        if (!this.peekKeyword('@forward')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$7724b1686f1f8cff);
        this.consumeToken();
        if (!node.addChild(this._parseStringLiteral())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).StringLiteralExpected);
        if (this.acceptIdent('as')) {
            const identifier = this._parseIdent([
                $bd0cebf2eccc0e7e$export$8868dff548d048cf.Forward
            ]);
            if (!node.setIdentifier(identifier)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected);
            // Wildcard must be the next character after the identifier string.
            if (this.hasWhitespace() || !this.acceptDelim('*')) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).WildcardExpected);
        }
        if (this.acceptIdent('with')) {
            if (!node.setParameters(this._parseModuleConfig())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftParenthesisExpected, [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR
            ]);
        } else if (this.peekIdent('hide') || this.peekIdent('show')) {
            if (!node.addChild(this._parseForwardVisibility())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierOrVariableExpected);
        }
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon) && !this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).SemiColonExpected);
        return this.finish(node);
    }
    _parseForwardVisibility() {
        const node = this.create($bd0cebf2eccc0e7e$export$7a6ba1620e111f36);
        // Assume to be "hide" or "show".
        node.setIdentifier(this._parseIdent());
        while(node.addChild(this._parseVariable() || this._parseIdent()))// Consume all variables and idents ahead.
        this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma);
        // More than just identifier
        return node.getChildren().length > 1 ? node : null;
    }
    _parseSupportsCondition() {
        return this._parseInterpolation() || super._parseSupportsCondition();
    }
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 



'use strict';
const $ea77810d78e96a69$var$sassDocumentationName = $3240faa9c744ac82$export$625550452a3fa3ec('Sass documentation');
class $ea77810d78e96a69$export$40585303d8501a99 extends (0, $0e5c8ce9d229cf3c$export$59dbe4ad1c157302) {
    constructor(lsServiceOptions, cssDataManager){
        super('$', lsServiceOptions, cssDataManager);
        $ea77810d78e96a69$var$addReferencesToDocumentation($ea77810d78e96a69$export$40585303d8501a99.scssModuleLoaders);
        $ea77810d78e96a69$var$addReferencesToDocumentation($ea77810d78e96a69$export$40585303d8501a99.scssModuleBuiltIns);
    }
    isImportPathParent(type) {
        return type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Forward || type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Use || super.isImportPathParent(type);
    }
    getCompletionForImportPath(importPathNode, result) {
        const parentType = importPathNode.getParent().type;
        if (parentType === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Forward || parentType === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Use) for (let p of $ea77810d78e96a69$export$40585303d8501a99.scssModuleBuiltIns){
            const item = {
                label: p.label,
                documentation: p.documentation,
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(importPathNode), `'${p.label}'`),
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Module
            };
            result.items.push(item);
        }
        return super.getCompletionForImportPath(importPathNode, result);
    }
    createReplaceFunction() {
        let tabStopCounter = 1;
        return (_match, p1)=>{
            return '\\' + p1 + ': ${' + tabStopCounter++ + ':' + ($ea77810d78e96a69$export$40585303d8501a99.variableDefaults[p1] || '') + '}';
        };
    }
    createFunctionProposals(proposals, existingNode, sortToEnd, result) {
        for (const p of proposals){
            const insertText = p.func.replace(/\[?(\$\w+)\]?/g, this.createReplaceFunction());
            const label = p.func.substr(0, p.func.indexOf('('));
            const item = {
                label: label,
                detail: p.func,
                documentation: p.desc,
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), insertText),
                insertTextFormat: (0, $1345bdc33671c7a9$exports.InsertTextFormat).Snippet,
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Function
            };
            if (sortToEnd) item.sortText = 'z';
            result.items.push(item);
        }
        return result;
    }
    getCompletionsForSelector(ruleSet, isNested, result) {
        this.createFunctionProposals($ea77810d78e96a69$export$40585303d8501a99.selectorFuncs, null, true, result);
        return super.getCompletionsForSelector(ruleSet, isNested, result);
    }
    getTermProposals(entry, existingNode, result) {
        let functions = $ea77810d78e96a69$export$40585303d8501a99.builtInFuncs;
        if (entry) functions = functions.filter((f)=>!f.type || !entry.restrictions || entry.restrictions.indexOf(f.type) !== -1);
        this.createFunctionProposals(functions, existingNode, true, result);
        return super.getTermProposals(entry, existingNode, result);
    }
    getColorProposals(entry, existingNode, result) {
        this.createFunctionProposals($ea77810d78e96a69$export$40585303d8501a99.colorProposals, existingNode, false, result);
        return super.getColorProposals(entry, existingNode, result);
    }
    getCompletionsForDeclarationProperty(declaration, result) {
        this.getCompletionForAtDirectives(result);
        this.getCompletionsForSelector(null, true, result);
        return super.getCompletionsForDeclarationProperty(declaration, result);
    }
    getCompletionsForExtendsReference(_extendsRef, existingNode, result) {
        const symbols = this.getSymbolContext().findSymbolsAtOffset(this.offset, $bd0cebf2eccc0e7e$export$8868dff548d048cf.Rule);
        for (const symbol of symbols){
            const suggest = {
                label: symbol.name,
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), symbol.name),
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Function
            };
            result.items.push(suggest);
        }
        return result;
    }
    getCompletionForAtDirectives(result) {
        result.items.push(...$ea77810d78e96a69$export$40585303d8501a99.scssAtDirectives);
        return result;
    }
    getCompletionForTopLevel(result) {
        this.getCompletionForAtDirectives(result);
        this.getCompletionForModuleLoaders(result);
        super.getCompletionForTopLevel(result);
        return result;
    }
    getCompletionForModuleLoaders(result) {
        result.items.push(...$ea77810d78e96a69$export$40585303d8501a99.scssModuleLoaders);
        return result;
    }
}
$ea77810d78e96a69$export$40585303d8501a99.variableDefaults = {
    '$red': '1',
    '$green': '2',
    '$blue': '3',
    '$alpha': '1.0',
    '$color': '#000000',
    '$weight': '0.5',
    '$hue': '0',
    '$saturation': '0%',
    '$lightness': '0%',
    '$degrees': '0',
    '$amount': '0',
    '$string': '""',
    '$substring': '"s"',
    '$number': '0',
    '$limit': '1'
};
$ea77810d78e96a69$export$40585303d8501a99.colorProposals = [
    {
        func: 'red($color)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Gets the red component of a color.')
    },
    {
        func: 'green($color)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Gets the green component of a color.')
    },
    {
        func: 'blue($color)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Gets the blue component of a color.')
    },
    {
        func: 'mix($color, $color, [$weight])',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Mixes two colors together.')
    },
    {
        func: 'hue($color)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Gets the hue component of a color.')
    },
    {
        func: 'saturation($color)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Gets the saturation component of a color.')
    },
    {
        func: 'lightness($color)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Gets the lightness component of a color.')
    },
    {
        func: 'adjust-hue($color, $degrees)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Changes the hue of a color.')
    },
    {
        func: 'lighten($color, $amount)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Makes a color lighter.')
    },
    {
        func: 'darken($color, $amount)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Makes a color darker.')
    },
    {
        func: 'saturate($color, $amount)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Makes a color more saturated.')
    },
    {
        func: 'desaturate($color, $amount)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Makes a color less saturated.')
    },
    {
        func: 'grayscale($color)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Converts a color to grayscale.')
    },
    {
        func: 'complement($color)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns the complement of a color.')
    },
    {
        func: 'invert($color)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns the inverse of a color.')
    },
    {
        func: 'alpha($color)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Gets the opacity component of a color.')
    },
    {
        func: 'opacity($color)',
        desc: 'Gets the alpha component (opacity) of a color.'
    },
    {
        func: 'rgba($color, $alpha)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Changes the alpha component for a color.')
    },
    {
        func: 'opacify($color, $amount)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Makes a color more opaque.')
    },
    {
        func: 'fade-in($color, $amount)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Makes a color more opaque.')
    },
    {
        func: 'transparentize($color, $amount)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Makes a color more transparent.')
    },
    {
        func: 'fade-out($color, $amount)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Makes a color more transparent.')
    },
    {
        func: 'adjust-color($color, [$red], [$green], [$blue], [$hue], [$saturation], [$lightness], [$alpha])',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Increases or decreases one or more components of a color.')
    },
    {
        func: 'scale-color($color, [$red], [$green], [$blue], [$saturation], [$lightness], [$alpha])',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Fluidly scales one or more properties of a color.')
    },
    {
        func: 'change-color($color, [$red], [$green], [$blue], [$hue], [$saturation], [$lightness], [$alpha])',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Changes one or more properties of a color.')
    },
    {
        func: 'ie-hex-str($color)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Converts a color into the format understood by IE filters.')
    }
];
$ea77810d78e96a69$export$40585303d8501a99.selectorFuncs = [
    {
        func: "selector-nest($selectors\u2026)",
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Nests selector beneath one another like they would be nested in the stylesheet.')
    },
    {
        func: "selector-append($selectors\u2026)",
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Appends selectors to one another without spaces in between.')
    },
    {
        func: 'selector-extend($selector, $extendee, $extender)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Extends $extendee with $extender within $selector.')
    },
    {
        func: 'selector-replace($selector, $original, $replacement)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Replaces $original with $replacement within $selector.')
    },
    {
        func: 'selector-unify($selector1, $selector2)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Unifies two selectors to produce a selector that matches elements matched by both.')
    },
    {
        func: 'is-superselector($super, $sub)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns whether $super matches all the elements $sub does, and possibly more.')
    },
    {
        func: 'simple-selectors($selector)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns the simple selectors that comprise a compound selector.')
    },
    {
        func: 'selector-parse($selector)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Parses a selector into the format returned by &.')
    }
];
$ea77810d78e96a69$export$40585303d8501a99.builtInFuncs = [
    {
        func: 'unquote($string)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Removes quotes from a string.')
    },
    {
        func: 'quote($string)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Adds quotes to a string.')
    },
    {
        func: 'str-length($string)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns the number of characters in a string.')
    },
    {
        func: 'str-insert($string, $insert, $index)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Inserts $insert into $string at $index.')
    },
    {
        func: 'str-index($string, $substring)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns the index of the first occurance of $substring in $string.')
    },
    {
        func: 'str-slice($string, $start-at, [$end-at])',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Extracts a substring from $string.')
    },
    {
        func: 'to-upper-case($string)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Converts a string to upper case.')
    },
    {
        func: 'to-lower-case($string)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Converts a string to lower case.')
    },
    {
        func: 'percentage($number)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Converts a unitless number to a percentage.'),
        type: 'percentage'
    },
    {
        func: 'round($number)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Rounds a number to the nearest whole number.')
    },
    {
        func: 'ceil($number)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Rounds a number up to the next whole number.')
    },
    {
        func: 'floor($number)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Rounds a number down to the previous whole number.')
    },
    {
        func: 'abs($number)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns the absolute value of a number.')
    },
    {
        func: 'min($numbers)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Finds the minimum of several numbers.')
    },
    {
        func: 'max($numbers)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Finds the maximum of several numbers.')
    },
    {
        func: 'random([$limit])',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns a random number.')
    },
    {
        func: 'length($list)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns the length of a list.')
    },
    {
        func: 'nth($list, $n)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns a specific item in a list.')
    },
    {
        func: 'set-nth($list, $n, $value)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Replaces the nth item in a list.')
    },
    {
        func: 'join($list1, $list2, [$separator])',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Joins together two lists into one.')
    },
    {
        func: 'append($list1, $val, [$separator])',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Appends a single value onto the end of a list.')
    },
    {
        func: 'zip($lists)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Combines several lists into a single multidimensional list.')
    },
    {
        func: 'index($list, $value)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns the position of a value within a list.')
    },
    {
        func: 'list-separator(#list)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns the separator of a list.')
    },
    {
        func: 'map-get($map, $key)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns the value in a map associated with a given key.')
    },
    {
        func: 'map-merge($map1, $map2)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Merges two maps together into a new map.')
    },
    {
        func: 'map-remove($map, $keys)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns a new map with keys removed.')
    },
    {
        func: 'map-keys($map)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns a list of all keys in a map.')
    },
    {
        func: 'map-values($map)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns a list of all values in a map.')
    },
    {
        func: 'map-has-key($map, $key)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns whether a map has a value associated with a given key.')
    },
    {
        func: 'keywords($args)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns the keywords passed to a function that takes variable arguments.')
    },
    {
        func: 'feature-exists($feature)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns whether a feature exists in the current Sass runtime.')
    },
    {
        func: 'variable-exists($name)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns whether a variable with the given name exists in the current scope.')
    },
    {
        func: 'global-variable-exists($name)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns whether a variable with the given name exists in the global scope.')
    },
    {
        func: 'function-exists($name)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns whether a function with the given name exists.')
    },
    {
        func: 'mixin-exists($name)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns whether a mixin with the given name exists.')
    },
    {
        func: 'inspect($value)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns the string representation of a value as it would be represented in Sass.')
    },
    {
        func: 'type-of($value)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns the type of a value.')
    },
    {
        func: 'unit($number)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns the unit(s) associated with a number.')
    },
    {
        func: 'unitless($number)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns whether a number has units.')
    },
    {
        func: 'comparable($number1, $number2)',
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Returns whether two numbers can be added, subtracted, or compared.')
    },
    {
        func: "call($name, $args\u2026)",
        desc: $3240faa9c744ac82$export$625550452a3fa3ec('Dynamically calls a Sass function.')
    }
];
$ea77810d78e96a69$export$40585303d8501a99.scssAtDirectives = [
    {
        label: "@extend",
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("Inherits the styles of another selector."),
        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
    },
    {
        label: "@at-root",
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("Causes one or more rules to be emitted at the root of the document."),
        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
    },
    {
        label: "@debug",
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("Prints the value of an expression to the standard error output stream. Useful for debugging complicated Sass files."),
        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
    },
    {
        label: "@warn",
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("Prints the value of an expression to the standard error output stream. Useful for libraries that need to warn users of deprecations or recovering from minor mixin usage mistakes. Warnings can be turned off with the `--quiet` command-line option or the `:quiet` Sass option."),
        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
    },
    {
        label: "@error",
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("Throws the value of an expression as a fatal error with stack trace. Useful for validating arguments to mixins and functions."),
        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
    },
    {
        label: "@if",
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("Includes the body if the expression does not evaluate to `false` or `null`."),
        insertText: "@if ${1:expr} {\n\t$0\n}",
        insertTextFormat: (0, $1345bdc33671c7a9$exports.InsertTextFormat).Snippet,
        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
    },
    {
        label: "@for",
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("For loop that repeatedly outputs a set of styles for each `$var` in the `from/through` or `from/to` clause."),
        insertText: "@for \\$${1:var} from ${2:start} ${3|to,through|} ${4:end} {\n\t$0\n}",
        insertTextFormat: (0, $1345bdc33671c7a9$exports.InsertTextFormat).Snippet,
        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
    },
    {
        label: "@each",
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("Each loop that sets `$var` to each item in the list or map, then outputs the styles it contains using that value of `$var`."),
        insertText: "@each \\$${1:var} in ${2:list} {\n\t$0\n}",
        insertTextFormat: (0, $1345bdc33671c7a9$exports.InsertTextFormat).Snippet,
        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
    },
    {
        label: "@while",
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("While loop that takes an expression and repeatedly outputs the nested styles until the statement evaluates to `false`."),
        insertText: "@while ${1:condition} {\n\t$0\n}",
        insertTextFormat: (0, $1345bdc33671c7a9$exports.InsertTextFormat).Snippet,
        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
    },
    {
        label: "@mixin",
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("Defines styles that can be re-used throughout the stylesheet with `@include`."),
        insertText: "@mixin ${1:name} {\n\t$0\n}",
        insertTextFormat: (0, $1345bdc33671c7a9$exports.InsertTextFormat).Snippet,
        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
    },
    {
        label: "@include",
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("Includes the styles defined by another mixin into the current rule."),
        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
    },
    {
        label: "@function",
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("Defines complex operations that can be re-used throughout stylesheets."),
        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
    }
];
$ea77810d78e96a69$export$40585303d8501a99.scssModuleLoaders = [
    {
        label: "@use",
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("Loads mixins, functions, and variables from other Sass stylesheets as 'modules', and combines CSS from multiple stylesheets together."),
        references: [
            {
                name: $ea77810d78e96a69$var$sassDocumentationName,
                url: 'https://sass-lang.com/documentation/at-rules/use'
            }
        ],
        insertText: "@use $0;",
        insertTextFormat: (0, $1345bdc33671c7a9$exports.InsertTextFormat).Snippet,
        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
    },
    {
        label: "@forward",
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("Loads a Sass stylesheet and makes its mixins, functions, and variables available when this stylesheet is loaded with the @use rule."),
        references: [
            {
                name: $ea77810d78e96a69$var$sassDocumentationName,
                url: 'https://sass-lang.com/documentation/at-rules/forward'
            }
        ],
        insertText: "@forward $0;",
        insertTextFormat: (0, $1345bdc33671c7a9$exports.InsertTextFormat).Snippet,
        kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Keyword
    }
];
$ea77810d78e96a69$export$40585303d8501a99.scssModuleBuiltIns = [
    {
        label: 'sass:math',
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec('Provides functions that operate on numbers.'),
        references: [
            {
                name: $ea77810d78e96a69$var$sassDocumentationName,
                url: 'https://sass-lang.com/documentation/modules/math'
            }
        ]
    },
    {
        label: 'sass:string',
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec('Makes it easy to combine, search, or split apart strings.'),
        references: [
            {
                name: $ea77810d78e96a69$var$sassDocumentationName,
                url: 'https://sass-lang.com/documentation/modules/string'
            }
        ]
    },
    {
        label: 'sass:color',
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec('Generates new colors based on existing ones, making it easy to build color themes.'),
        references: [
            {
                name: $ea77810d78e96a69$var$sassDocumentationName,
                url: 'https://sass-lang.com/documentation/modules/color'
            }
        ]
    },
    {
        label: 'sass:list',
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec('Lets you access and modify values in lists.'),
        references: [
            {
                name: $ea77810d78e96a69$var$sassDocumentationName,
                url: 'https://sass-lang.com/documentation/modules/list'
            }
        ]
    },
    {
        label: 'sass:map',
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec('Makes it possible to look up the value associated with a key in a map, and much more.'),
        references: [
            {
                name: $ea77810d78e96a69$var$sassDocumentationName,
                url: 'https://sass-lang.com/documentation/modules/map'
            }
        ]
    },
    {
        label: 'sass:selector',
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("Provides access to Sass\u2019s powerful selector engine."),
        references: [
            {
                name: $ea77810d78e96a69$var$sassDocumentationName,
                url: 'https://sass-lang.com/documentation/modules/selector'
            }
        ]
    },
    {
        label: 'sass:meta',
        documentation: $3240faa9c744ac82$export$625550452a3fa3ec("Exposes the details of Sass\u2019s inner workings."),
        references: [
            {
                name: $ea77810d78e96a69$var$sassDocumentationName,
                url: 'https://sass-lang.com/documentation/modules/meta'
            }
        ]
    }
];
/**
 * Todo @Pine: Remove this and do it through custom data
 */ function $ea77810d78e96a69$var$addReferencesToDocumentation(items) {
    items.forEach((i)=>{
        if (i.documentation && i.references && i.references.length > 0) {
            const markdownDoc = typeof i.documentation === 'string' ? {
                kind: 'markdown',
                value: i.documentation
            } : {
                kind: 'markdown',
                value: i.documentation.value
            };
            markdownDoc.value += '\n\n';
            markdownDoc.value += i.references.map((r)=>{
                return `[${r.name}](${r.url})`;
            }).join(' | ');
            i.documentation = markdownDoc;
        }
    });
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 
'use strict';
const $ff9934c3c23be860$var$_FSL = '/'.charCodeAt(0);
const $ff9934c3c23be860$var$_NWL = '\n'.charCodeAt(0);
const $ff9934c3c23be860$var$_CAR = '\r'.charCodeAt(0);
const $ff9934c3c23be860$var$_LFD = '\f'.charCodeAt(0);
const $ff9934c3c23be860$var$_TIC = '`'.charCodeAt(0);
const $ff9934c3c23be860$var$_DOT = '.'.charCodeAt(0);
let $ff9934c3c23be860$var$customTokenValue = $2a533f0146ced75e$export$f435f793048e7a0f.CustomToken;
const $ff9934c3c23be860$export$1297970233533a7d = $ff9934c3c23be860$var$customTokenValue++;
class $ff9934c3c23be860$export$be7e2744a0f78a5 extends $2a533f0146ced75e$export$2da42535f3a161df {
    scanNext(offset) {
        // LESS: escaped JavaScript code `const a = "dddd"`
        const tokenType = this.escapedJavaScript();
        if (tokenType !== null) return this.finishToken(offset, tokenType);
        if (this.stream.advanceIfChars([
            $ff9934c3c23be860$var$_DOT,
            $ff9934c3c23be860$var$_DOT,
            $ff9934c3c23be860$var$_DOT
        ])) return this.finishToken(offset, $ff9934c3c23be860$export$1297970233533a7d);
        return super.scanNext(offset);
    }
    comment() {
        if (super.comment()) return true;
        if (!this.inURL && this.stream.advanceIfChars([
            $ff9934c3c23be860$var$_FSL,
            $ff9934c3c23be860$var$_FSL
        ])) {
            this.stream.advanceWhileChar((ch)=>{
                switch(ch){
                    case $ff9934c3c23be860$var$_NWL:
                    case $ff9934c3c23be860$var$_CAR:
                    case $ff9934c3c23be860$var$_LFD:
                        return false;
                    default:
                        return true;
                }
            });
            return true;
        } else return false;
    }
    escapedJavaScript() {
        const ch = this.stream.peekChar();
        if (ch === $ff9934c3c23be860$var$_TIC) {
            this.stream.advance(1);
            this.stream.advanceWhileChar((ch)=>{
                return ch !== $ff9934c3c23be860$var$_TIC;
            });
            return this.stream.advanceIfChar($ff9934c3c23be860$var$_TIC) ? $2a533f0146ced75e$export$f435f793048e7a0f.EscapedJavaScript : $2a533f0146ced75e$export$f435f793048e7a0f.BadEscapedJavaScript;
        }
        return null;
    }
}






'use strict';
class $cfc7658025b46be5$export$76e4c1f90ea15bb9 extends $48c6713331b54e18$export$7acfa6ed01010e37 {
    constructor(){
        super(new $ff9934c3c23be860$export$be7e2744a0f78a5());
    }
    _parseStylesheetStatement(isNested = false) {
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword)) return this._parseVariableDeclaration() || this._parsePlugin() || super._parseStylesheetAtStatement(isNested);
        return this._tryParseMixinDeclaration() || this._tryParseMixinReference() || this._parseFunction() || this._parseRuleset(true);
    }
    _parseImport() {
        if (!this.peekKeyword('@import') && !this.peekKeyword('@import-once')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$d0dbb306591aec74);
        this.consumeToken();
        // less 1.4.1: @import (css) "lib"
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected, [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon
            ]);
            do {
                if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)) break;
            }while (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident));
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected, [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon
            ]);
        }
        if (!node.addChild(this._parseURILiteral()) && !node.addChild(this._parseStringLiteral())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).URIOrStringExpected, [
            (0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon
        ]);
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon) && !this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF)) node.setMedialist(this._parseMediaQueryList());
        return this._completeParseImport(node);
    }
    _parsePlugin() {
        if (!this.peekKeyword('@plugin')) return null;
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.Plugin);
        this.consumeToken(); // @import
        if (!node.addChild(this._parseStringLiteral())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).StringLiteralExpected);
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).SemiColonExpected);
        return this.finish(node);
    }
    _parseMediaQuery() {
        const node = super._parseMediaQuery();
        if (!node) {
            const node = this.create($bd0cebf2eccc0e7e$export$b745838c41029eb3);
            if (node.addChild(this._parseVariable())) return this.finish(node);
            return null;
        }
        return node;
    }
    _parseMediaDeclaration(isNested = false) {
        return this._tryParseRuleset(isNested) || this._tryToParseDeclaration() || this._tryParseMixinDeclaration() || this._tryParseMixinReference() || this._parseDetachedRuleSetMixin() || this._parseStylesheetStatement(isNested);
    }
    _parseMediaFeatureName() {
        return this._parseIdent() || this._parseVariable();
    }
    _parseVariableDeclaration(panic = []) {
        const node = this.create($bd0cebf2eccc0e7e$export$839cf4f882eabac8);
        const mark = this.mark();
        if (!node.setVariable(this._parseVariable(true))) return null;
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) {
            if (this.prevToken) node.colonPosition = this.prevToken.offset;
            if (node.setValue(this._parseDetachedRuleSet())) node.needsSemicolon = false;
            else if (!node.setValue(this._parseExpr())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).VariableValueExpected, [], panic);
            node.addChild(this._parsePrio());
        } else {
            this.restoreAtMark(mark);
            return null; // at keyword, but no ':', not a variable declaration but some at keyword
        }
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)) node.semicolonPosition = this.token.offset; // not part of the declaration, but useful information for code assist
        return this.finish(node);
    }
    _parseDetachedRuleSet() {
        let mark = this.mark();
        // "Anonymous mixin" used in each() and possibly a generic type in the future
        if (this.peekDelim('#') || this.peekDelim('.')) {
            this.consumeToken();
            if (!this.hasWhitespace() && this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
                let node = this.create($bd0cebf2eccc0e7e$export$f518258a40310702);
                if (node.getParameters().addChild(this._parseMixinParameter())) while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma) || this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)){
                    if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) break;
                    if (!node.getParameters().addChild(this._parseMixinParameter())) this.markError(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected, [], [
                        (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR
                    ]);
                }
                if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) {
                    this.restoreAtMark(mark);
                    return null;
                }
            } else {
                this.restoreAtMark(mark);
                return null;
            }
        }
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL)) return null;
        const content = this.create($bd0cebf2eccc0e7e$export$750c6750564ae5ac);
        this._parseBody(content, this._parseDetachedRuleSetBody.bind(this));
        return this.finish(content);
    }
    _parseDetachedRuleSetBody() {
        return this._tryParseKeyframeSelector() || this._parseRuleSetDeclaration();
    }
    _addLookupChildren(node) {
        if (!node.addChild(this._parseLookupValue())) return false;
        let expectsValue = false;
        while(true){
            if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).BracketL)) expectsValue = true;
            if (!node.addChild(this._parseLookupValue())) break;
            expectsValue = false;
        }
        return !expectsValue;
    }
    _parseLookupValue() {
        const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
        const mark = this.mark();
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).BracketL)) {
            this.restoreAtMark(mark);
            return null;
        }
        if ((node.addChild(this._parseVariable(false, true)) || node.addChild(this._parsePropertyIdentifier())) && this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).BracketR) || this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).BracketR)) return node;
        this.restoreAtMark(mark);
        return null;
    }
    _parseVariable(declaration = false, insideLookup = false) {
        const isPropertyReference = !declaration && this.peekDelim('$');
        if (!this.peekDelim('@') && !isPropertyReference && !this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword)) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$c867a5c9595a1350);
        const mark = this.mark();
        while(this.acceptDelim('@') || !declaration && this.acceptDelim('$'))if (this.hasWhitespace()) {
            this.restoreAtMark(mark);
            return null;
        }
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword) && !this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident)) {
            this.restoreAtMark(mark);
            return null;
        }
        if (!insideLookup && this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).BracketL)) {
            if (!this._addLookupChildren(node)) {
                this.restoreAtMark(mark);
                return null;
            }
        }
        return node;
    }
    _parseTermExpression() {
        return this._parseVariable() || this._parseEscaped() || super._parseTermExpression() || // preference for colors before mixin references
        this._tryParseMixinReference(false);
    }
    _parseEscaped() {
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).EscapedJavaScript) || this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).BadEscapedJavaScript)) {
            const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.EscapedValue);
            this.consumeToken();
            return this.finish(node);
        }
        if (this.peekDelim('~')) {
            const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.EscapedValue);
            this.consumeToken();
            if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).String) || this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).EscapedJavaScript)) return this.finish(node);
            else return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).TermExpected);
        }
        return null;
    }
    _parseOperator() {
        const node = this._parseGuardOperator();
        if (node) return node;
        else return super._parseOperator();
    }
    _parseGuardOperator() {
        if (this.peekDelim('>')) {
            const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.Operator);
            this.consumeToken();
            this.acceptDelim('=');
            return node;
        } else if (this.peekDelim('=')) {
            const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.Operator);
            this.consumeToken();
            this.acceptDelim('<');
            return node;
        } else if (this.peekDelim('<')) {
            const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.Operator);
            this.consumeToken();
            this.acceptDelim('=');
            return node;
        }
        return null;
    }
    _parseRuleSetDeclaration() {
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword)) return this._parseKeyframe() || this._parseMedia(true) || this._parseImport() || this._parseSupports(true) // @supports
         || this._parseLayer() // @layer
         || this._parsePropertyAtRule() // @property
         || this._parseContainer(true) // @container
         || this._parseDetachedRuleSetMixin() // less detached ruleset mixin
         || this._parseVariableDeclaration() // Variable declarations
         || this._parseRuleSetDeclarationAtStatement();
        return this._tryParseMixinDeclaration() || this._tryParseRuleset(true) // nested ruleset
         || this._tryParseMixinReference() // less mixin reference
         || this._parseFunction() || this._parseExtend() // less extend declaration
         || this._parseDeclaration(); // try css ruleset declaration as the last option
    }
    _parseKeyframeIdent() {
        return this._parseIdent([
            $bd0cebf2eccc0e7e$export$8868dff548d048cf.Keyframe
        ]) || this._parseVariable();
    }
    _parseKeyframeSelector() {
        return this._parseDetachedRuleSetMixin() // less detached ruleset mixin
         || super._parseKeyframeSelector();
    }
    // public _parseSimpleSelectorBody(): nodes.Node | null {
    // 	return this._parseNestingSelector() || super._parseSimpleSelectorBody();
    // }
    _parseSelector(isNested) {
        // CSS Guards
        const node = this.create($bd0cebf2eccc0e7e$export$d15f4cd5286f9b1e);
        let hasContent = false;
        if (isNested) // nested selectors can start with a combinator
        hasContent = node.addChild(this._parseCombinator());
        while(node.addChild(this._parseSimpleSelector())){
            hasContent = true;
            const mark = this.mark();
            if (node.addChild(this._parseGuard()) && this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL)) break;
            this.restoreAtMark(mark);
            node.addChild(this._parseCombinator()); // optional
        }
        return hasContent ? this.finish(node) : null;
    }
    _parseNestingSelector() {
        if (this.peekDelim('&')) {
            const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorCombinator);
            this.consumeToken();
            while(!this.hasWhitespace() && (this.acceptDelim('-') || this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Num) || this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Dimension) || node.addChild(this._parseIdent()) || this.acceptDelim('&')));
            return this.finish(node);
        }
        return null;
    }
    _parseSelectorIdent() {
        if (!this.peekInterpolatedIdent()) return null;
        const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.SelectorInterpolation);
        const hasContent = this._acceptInterpolatedIdent(node);
        return hasContent ? this.finish(node) : null;
    }
    _parsePropertyIdentifier(inLookup = false) {
        const propertyRegex = /^[\w-]+/;
        if (!this.peekInterpolatedIdent() && !this.peekRegExp(this.token.type, propertyRegex)) return null;
        const mark = this.mark();
        const node = this.create($bd0cebf2eccc0e7e$export$989167234458594d);
        node.isCustomProperty = this.acceptDelim('-') && this.acceptDelim('-');
        let childAdded = false;
        if (!inLookup) {
            if (node.isCustomProperty) childAdded = this._acceptInterpolatedIdent(node);
            else childAdded = this._acceptInterpolatedIdent(node, propertyRegex);
        } else if (node.isCustomProperty) childAdded = node.addChild(this._parseIdent());
        else childAdded = node.addChild(this._parseRegexp(propertyRegex));
        if (!childAdded) {
            this.restoreAtMark(mark);
            return null;
        }
        if (!inLookup && !this.hasWhitespace()) {
            this.acceptDelim('+');
            if (!this.hasWhitespace()) this.acceptIdent('_');
        }
        return this.finish(node);
    }
    peekInterpolatedIdent() {
        return this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident) || this.peekDelim('@') || this.peekDelim('$') || this.peekDelim('-');
    }
    _acceptInterpolatedIdent(node, identRegex) {
        let hasContent = false;
        const indentInterpolation = ()=>{
            const pos = this.mark();
            if (this.acceptDelim('-')) {
                if (!this.hasWhitespace()) this.acceptDelim('-');
                if (this.hasWhitespace()) {
                    this.restoreAtMark(pos);
                    return null;
                }
            }
            return this._parseInterpolation();
        };
        const accept = identRegex ? ()=>this.acceptRegexp(identRegex) : ()=>this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Ident);
        while(accept() || node.addChild(this._parseInterpolation() || this.try(indentInterpolation))){
            hasContent = true;
            if (this.hasWhitespace()) break;
        }
        return hasContent;
    }
    _parseInterpolation() {
        // @{name} Variable or
        // ${name} Property
        const mark = this.mark();
        if (this.peekDelim('@') || this.peekDelim('$')) {
            const node = this.createNode($bd0cebf2eccc0e7e$export$f06e977173f1857c.Interpolation);
            this.consumeToken();
            if (this.hasWhitespace() || !this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL)) {
                this.restoreAtMark(mark);
                return null;
            }
            if (!node.addChild(this._parseIdent())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected);
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightCurlyExpected);
            return this.finish(node);
        }
        return null;
    }
    _tryParseMixinDeclaration() {
        const mark = this.mark();
        const node = this.create($bd0cebf2eccc0e7e$export$f518258a40310702);
        if (!node.setIdentifier(this._parseMixinDeclarationIdentifier()) || !this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            this.restoreAtMark(mark);
            return null;
        }
        if (node.getParameters().addChild(this._parseMixinParameter())) while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma) || this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)){
            if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) break;
            if (!node.getParameters().addChild(this._parseMixinParameter())) this.markError(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).IdentifierExpected, [], [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR
            ]);
        }
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) {
            this.restoreAtMark(mark);
            return null;
        }
        node.setGuard(this._parseGuard());
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL)) {
            this.restoreAtMark(mark);
            return null;
        }
        return this._parseBody(node, this._parseMixInBodyDeclaration.bind(this));
    }
    _parseMixInBodyDeclaration() {
        return this._parseFontFace() || this._parseRuleSetDeclaration();
    }
    _parseMixinDeclarationIdentifier() {
        let identifier;
        if (this.peekDelim('#') || this.peekDelim('.')) {
            identifier = this.create($bd0cebf2eccc0e7e$export$989167234458594d);
            this.consumeToken(); // # or .
            if (this.hasWhitespace() || !identifier.addChild(this._parseIdent())) return null;
        } else if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Hash)) {
            identifier = this.create($bd0cebf2eccc0e7e$export$989167234458594d);
            this.consumeToken(); // TokenType.Hash
        } else return null;
        identifier.referenceTypes = [
            $bd0cebf2eccc0e7e$export$8868dff548d048cf.Mixin
        ];
        return this.finish(identifier);
    }
    _parsePseudo() {
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) return null;
        const mark = this.mark();
        const node = this.create($bd0cebf2eccc0e7e$export$aebff1c4d1af2d3a);
        this.consumeToken(); // :
        if (this.acceptIdent('extend')) return this._completeExtends(node);
        this.restoreAtMark(mark);
        return super._parsePseudo();
    }
    _parseExtend() {
        if (!this.peekDelim('&')) return null;
        const mark = this.mark();
        const node = this.create($bd0cebf2eccc0e7e$export$aebff1c4d1af2d3a);
        this.consumeToken(); // &
        if (this.hasWhitespace() || !this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon) || !this.acceptIdent('extend')) {
            this.restoreAtMark(mark);
            return null;
        }
        return this._completeExtends(node);
    }
    _completeExtends(node) {
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftParenthesisExpected);
        const selectors = node.getSelectors();
        if (!selectors.addChild(this._parseSelector(true))) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).SelectorExpected);
        while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
            if (!selectors.addChild(this._parseSelector(true))) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).SelectorExpected);
        }
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected);
        return this.finish(node);
    }
    _parseDetachedRuleSetMixin() {
        if (!this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).AtKeyword)) return null;
        const mark = this.mark();
        const node = this.create($bd0cebf2eccc0e7e$export$8ca7a1a636597cad);
        if (node.addChild(this._parseVariable(true)) && (this.hasWhitespace() || !this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL))) {
            this.restoreAtMark(mark);
            return null;
        }
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected);
        return this.finish(node);
    }
    _tryParseMixinReference(atRoot = true) {
        const mark = this.mark();
        const node = this.create($bd0cebf2eccc0e7e$export$8ca7a1a636597cad);
        let identifier = this._parseMixinDeclarationIdentifier();
        while(identifier){
            this.acceptDelim('>');
            const nextId = this._parseMixinDeclarationIdentifier();
            if (nextId) {
                node.getNamespaces().addChild(identifier);
                identifier = nextId;
            } else break;
        }
        if (!node.setIdentifier(identifier)) {
            this.restoreAtMark(mark);
            return null;
        }
        let hasArguments = false;
        if (this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            hasArguments = true;
            if (node.getArguments().addChild(this._parseMixinArgument())) while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma) || this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)){
                if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) break;
                if (!node.getArguments().addChild(this._parseMixinArgument())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ExpressionExpected);
            }
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected);
            identifier.referenceTypes = [
                $bd0cebf2eccc0e7e$export$8868dff548d048cf.Mixin
            ];
        } else identifier.referenceTypes = [
            $bd0cebf2eccc0e7e$export$8868dff548d048cf.Mixin,
            $bd0cebf2eccc0e7e$export$8868dff548d048cf.Rule
        ];
        if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).BracketL)) {
            if (!atRoot) this._addLookupChildren(node);
        } else node.addChild(this._parsePrio());
        if (!hasArguments && !this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon) && !this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR) && !this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF)) {
            this.restoreAtMark(mark);
            return null;
        }
        return this.finish(node);
    }
    _parseMixinArgument() {
        // [variableName ':'] expression | variableName '...'
        const node = this.create($bd0cebf2eccc0e7e$export$5868bced5e602b28);
        const pos = this.mark();
        const argument = this._parseVariable();
        if (argument) {
            if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon)) this.restoreAtMark(pos);
            else node.setIdentifier(argument);
        }
        if (node.setValue(this._parseDetachedRuleSet() || this._parseExpr(true))) return this.finish(node);
        this.restoreAtMark(pos);
        return null;
    }
    _parseMixinParameter() {
        const node = this.create($bd0cebf2eccc0e7e$export$e8b5f24364ee45a9);
        // special rest variable: @rest...
        if (this.peekKeyword('@rest')) {
            const restNode = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
            this.consumeToken();
            if (!this.accept($ff9934c3c23be860$export$1297970233533a7d)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).DotExpected, [], [
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma,
                (0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR
            ]);
            node.setIdentifier(this.finish(restNode));
            return this.finish(node);
        }
        // special const args: ...
        if (this.peek($ff9934c3c23be860$export$1297970233533a7d)) {
            const varargsNode = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
            this.consumeToken();
            node.setIdentifier(this.finish(varargsNode));
            return this.finish(node);
        }
        let hasContent = false;
        // default variable declaration: @param: 12 or @name
        if (node.setIdentifier(this._parseVariable())) {
            this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Colon);
            hasContent = true;
        }
        if (!node.setDefaultValue(this._parseDetachedRuleSet() || this._parseExpr(true)) && !hasContent) return null;
        return this.finish(node);
    }
    _parseGuard() {
        if (!this.peekIdent('when')) return null;
        const node = this.create($bd0cebf2eccc0e7e$export$8b7e5e70221c0946);
        this.consumeToken(); // when
        if (!node.getConditions().addChild(this._parseGuardCondition())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ConditionExpected);
        while(this.acceptIdent('and') || this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma)){
            if (!node.getConditions().addChild(this._parseGuardCondition())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ConditionExpected);
        }
        return this.finish(node);
    }
    _parseGuardCondition() {
        const node = this.create($bd0cebf2eccc0e7e$export$8bca042b7fec9ee);
        node.isNegated = this.acceptIdent('not');
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            if (node.isNegated) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).LeftParenthesisExpected);
            return null;
        }
        node.addChild(this._parseExpr());
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected);
        return this.finish(node);
    }
    _parseFunction() {
        const pos = this.mark();
        const node = this.create($bd0cebf2eccc0e7e$export$f3890eeaf6851387);
        if (!node.setIdentifier(this._parseFunctionIdentifier())) return null;
        if (this.hasWhitespace() || !this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisL)) {
            this.restoreAtMark(pos);
            return null;
        }
        if (node.getArguments().addChild(this._parseMixinArgument())) while(this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).Comma) || this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).SemiColon)){
            if (this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) break;
            if (!node.getArguments().addChild(this._parseMixinArgument())) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).ExpressionExpected);
        }
        if (!this.accept((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) return this.finish(node, (0, $053a694fcaa2117c$export$f9c837a54db411d).RightParenthesisExpected);
        return this.finish(node);
    }
    _parseFunctionIdentifier() {
        if (this.peekDelim('%')) {
            const node = this.create($bd0cebf2eccc0e7e$export$989167234458594d);
            node.referenceTypes = [
                $bd0cebf2eccc0e7e$export$8868dff548d048cf.Function
            ];
            this.consumeToken();
            return this.finish(node);
        }
        return super._parseFunctionIdentifier();
    }
    _parseURLArgument() {
        const pos = this.mark();
        const node = super._parseURLArgument();
        if (!node || !this.peek((0, $2a533f0146ced75e$export$f435f793048e7a0f).ParenthesisR)) {
            this.restoreAtMark(pos);
            const node = this.create($bd0cebf2eccc0e7e$export$85c928794f8d04d4);
            node.addChild(this._parseBinaryExpr());
            return this.finish(node);
        }
        return node;
    }
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 


'use strict';
class $3f97c9b26c40b19d$export$16c78b003ba04a14 extends (0, $0e5c8ce9d229cf3c$export$59dbe4ad1c157302) {
    constructor(lsOptions, cssDataManager){
        super('@', lsOptions, cssDataManager);
    }
    createFunctionProposals(proposals, existingNode, sortToEnd, result) {
        for (const p of proposals){
            const item = {
                label: p.name,
                detail: p.example,
                documentation: p.description,
                textEdit: (0, $1345bdc33671c7a9$exports.TextEdit).replace(this.getCompletionRange(existingNode), p.name + '($0)'),
                insertTextFormat: (0, $1345bdc33671c7a9$exports.InsertTextFormat).Snippet,
                kind: (0, $1345bdc33671c7a9$exports.CompletionItemKind).Function
            };
            if (sortToEnd) item.sortText = 'z';
            result.items.push(item);
        }
        return result;
    }
    getTermProposals(entry, existingNode, result) {
        let functions = $3f97c9b26c40b19d$export$16c78b003ba04a14.builtInProposals;
        if (entry) functions = functions.filter((f)=>!f.type || !entry.restrictions || entry.restrictions.indexOf(f.type) !== -1);
        this.createFunctionProposals(functions, existingNode, true, result);
        return super.getTermProposals(entry, existingNode, result);
    }
    getColorProposals(entry, existingNode, result) {
        this.createFunctionProposals($3f97c9b26c40b19d$export$16c78b003ba04a14.colorProposals, existingNode, false, result);
        return super.getColorProposals(entry, existingNode, result);
    }
    getCompletionsForDeclarationProperty(declaration, result) {
        this.getCompletionsForSelector(null, true, result);
        return super.getCompletionsForDeclarationProperty(declaration, result);
    }
}
$3f97c9b26c40b19d$export$16c78b003ba04a14.builtInProposals = [
    // Boolean functions
    {
        'name': 'if',
        'example': 'if(condition, trueValue [, falseValue]);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns one of two values depending on a condition.')
    },
    {
        'name': 'boolean',
        'example': 'boolean(condition);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('"store" a boolean test for later evaluation in a guard or if().')
    },
    // List functions
    {
        'name': 'length',
        'example': 'length(@list);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns the number of elements in a value list')
    },
    {
        'name': 'extract',
        'example': 'extract(@list, index);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns a value at the specified position in the list')
    },
    {
        'name': 'range',
        'example': 'range([start, ] end [, step]);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('generate a list spanning a range of values')
    },
    {
        'name': 'each',
        'example': 'each(@list, ruleset);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('bind the evaluation of a ruleset to each member of a list.')
    },
    // Other built-ins
    {
        'name': 'escape',
        'example': 'escape(@string);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('URL encodes a string')
    },
    {
        'name': 'e',
        'example': 'e(@string);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('escape string content')
    },
    {
        'name': 'replace',
        'example': 'replace(@string, @pattern, @replacement[, @flags]);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('string replace')
    },
    {
        'name': 'unit',
        'example': 'unit(@dimension, [@unit: \'\']);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('remove or change the unit of a dimension')
    },
    {
        'name': 'color',
        'example': 'color(@string);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('parses a string to a color'),
        'type': 'color'
    },
    {
        'name': 'convert',
        'example': 'convert(@value, unit);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('converts numbers from one type into another')
    },
    {
        'name': 'data-uri',
        'example': 'data-uri([mimetype,] url);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('inlines a resource and falls back to `url()`'),
        'type': 'url'
    },
    {
        'name': 'abs',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('absolute value of a number'),
        'example': 'abs(number);'
    },
    {
        'name': 'acos',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('arccosine - inverse of cosine function'),
        'example': 'acos(number);'
    },
    {
        'name': 'asin',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('arcsine - inverse of sine function'),
        'example': 'asin(number);'
    },
    {
        'name': 'ceil',
        'example': 'ceil(@number);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('rounds up to an integer')
    },
    {
        'name': 'cos',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('cosine function'),
        'example': 'cos(number);'
    },
    {
        'name': 'floor',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('rounds down to an integer'),
        'example': 'floor(@number);'
    },
    {
        'name': 'percentage',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('converts to a %, e.g. 0.5 > 50%'),
        'example': 'percentage(@number);',
        'type': 'percentage'
    },
    {
        'name': 'round',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('rounds a number to a number of places'),
        'example': 'round(number, [places: 0]);'
    },
    {
        'name': 'sqrt',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('calculates square root of a number'),
        'example': 'sqrt(number);'
    },
    {
        'name': 'sin',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('sine function'),
        'example': 'sin(number);'
    },
    {
        'name': 'tan',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('tangent function'),
        'example': 'tan(number);'
    },
    {
        'name': 'atan',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('arctangent - inverse of tangent function'),
        'example': 'atan(number);'
    },
    {
        'name': 'pi',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns pi'),
        'example': 'pi();'
    },
    {
        'name': 'pow',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('first argument raised to the power of the second argument'),
        'example': 'pow(@base, @exponent);'
    },
    {
        'name': 'mod',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('first argument modulus second argument'),
        'example': 'mod(number, number);'
    },
    {
        'name': 'min',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns the lowest of one or more values'),
        'example': 'min(@x, @y);'
    },
    {
        'name': 'max',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns the lowest of one or more values'),
        'example': 'max(@x, @y);'
    }
];
$3f97c9b26c40b19d$export$16c78b003ba04a14.colorProposals = [
    {
        'name': 'argb',
        'example': 'argb(@color);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('creates a #AARRGGBB')
    },
    {
        'name': 'hsl',
        'example': 'hsl(@hue, @saturation, @lightness);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('creates a color')
    },
    {
        'name': 'hsla',
        'example': 'hsla(@hue, @saturation, @lightness, @alpha);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('creates a color')
    },
    {
        'name': 'hsv',
        'example': 'hsv(@hue, @saturation, @value);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('creates a color')
    },
    {
        'name': 'hsva',
        'example': 'hsva(@hue, @saturation, @value, @alpha);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('creates a color')
    },
    {
        'name': 'hue',
        'example': 'hue(@color);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns the `hue` channel of `@color` in the HSL space')
    },
    {
        'name': 'saturation',
        'example': 'saturation(@color);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns the `saturation` channel of `@color` in the HSL space')
    },
    {
        'name': 'lightness',
        'example': 'lightness(@color);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns the `lightness` channel of `@color` in the HSL space')
    },
    {
        'name': 'hsvhue',
        'example': 'hsvhue(@color);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns the `hue` channel of `@color` in the HSV space')
    },
    {
        'name': 'hsvsaturation',
        'example': 'hsvsaturation(@color);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns the `saturation` channel of `@color` in the HSV space')
    },
    {
        'name': 'hsvvalue',
        'example': 'hsvvalue(@color);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns the `value` channel of `@color` in the HSV space')
    },
    {
        'name': 'red',
        'example': 'red(@color);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns the `red` channel of `@color`')
    },
    {
        'name': 'green',
        'example': 'green(@color);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns the `green` channel of `@color`')
    },
    {
        'name': 'blue',
        'example': 'blue(@color);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns the `blue` channel of `@color`')
    },
    {
        'name': 'alpha',
        'example': 'alpha(@color);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns the `alpha` channel of `@color`')
    },
    {
        'name': 'luma',
        'example': 'luma(@color);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns the `luma` value (perceptual brightness) of `@color`')
    },
    {
        'name': 'saturate',
        'example': 'saturate(@color, 10%);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('return `@color` 10% points more saturated')
    },
    {
        'name': 'desaturate',
        'example': 'desaturate(@color, 10%);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('return `@color` 10% points less saturated')
    },
    {
        'name': 'lighten',
        'example': 'lighten(@color, 10%);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('return `@color` 10% points lighter')
    },
    {
        'name': 'darken',
        'example': 'darken(@color, 10%);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('return `@color` 10% points darker')
    },
    {
        'name': 'fadein',
        'example': 'fadein(@color, 10%);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('return `@color` 10% points less transparent')
    },
    {
        'name': 'fadeout',
        'example': 'fadeout(@color, 10%);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('return `@color` 10% points more transparent')
    },
    {
        'name': 'fade',
        'example': 'fade(@color, 50%);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('return `@color` with 50% transparency')
    },
    {
        'name': 'spin',
        'example': 'spin(@color, 10);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('return `@color` with a 10 degree larger in hue')
    },
    {
        'name': 'mix',
        'example': 'mix(@color1, @color2, [@weight: 50%]);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('return a mix of `@color1` and `@color2`')
    },
    {
        'name': 'greyscale',
        'example': 'greyscale(@color);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('returns a grey, 100% desaturated color')
    },
    {
        'name': 'contrast',
        'example': 'contrast(@color1, [@darkcolor: black], [@lightcolor: white], [@threshold: 43%]);',
        'description': $3240faa9c744ac82$export$625550452a3fa3ec('return `@darkcolor` if `@color1 is> 43% luma` otherwise return `@lightcolor`, see notes')
    },
    {
        'name': 'multiply',
        'example': 'multiply(@color1, @color2);'
    },
    {
        'name': 'screen',
        'example': 'screen(@color1, @color2);'
    },
    {
        'name': 'overlay',
        'example': 'overlay(@color1, @color2);'
    },
    {
        'name': 'softlight',
        'example': 'softlight(@color1, @color2);'
    },
    {
        'name': 'hardlight',
        'example': 'hardlight(@color1, @color2);'
    },
    {
        'name': 'difference',
        'example': 'difference(@color1, @color2);'
    },
    {
        'name': 'exclusion',
        'example': 'exclusion(@color1, @color2);'
    },
    {
        'name': 'average',
        'example': 'average(@color1, @color2);'
    },
    {
        'name': 'negation',
        'example': 'negation(@color1, @color2);'
    }
];


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 


'use strict';
function $72b66e11fef70fdd$export$8f757cf446e2053f(document, context) {
    const ranges = $72b66e11fef70fdd$var$computeFoldingRanges(document);
    return $72b66e11fef70fdd$var$limitFoldingRanges(ranges, context);
}
function $72b66e11fef70fdd$var$computeFoldingRanges(document) {
    function getStartLine(t) {
        return document.positionAt(t.offset).line;
    }
    function getEndLine(t) {
        return document.positionAt(t.offset + t.len).line;
    }
    function getScanner() {
        switch(document.languageId){
            case 'scss':
                return new (0, $63ef42c3a3e4cf2c$export$8c54bcb21e842650)();
            case 'less':
                return new (0, $ff9934c3c23be860$export$be7e2744a0f78a5)();
            default:
                return new (0, $2a533f0146ced75e$export$2da42535f3a161df)();
        }
    }
    function tokenToRange(t, kind) {
        const startLine = getStartLine(t);
        const endLine = getEndLine(t);
        if (startLine !== endLine) return {
            startLine: startLine,
            endLine: endLine,
            kind: kind
        };
        else return null;
    }
    const ranges = [];
    const delimiterStack = [];
    const scanner = getScanner();
    scanner.ignoreComment = false;
    scanner.setSource(document.getText());
    let token = scanner.scan();
    let prevToken = null;
    while(token.type !== (0, $2a533f0146ced75e$export$f435f793048e7a0f).EOF){
        switch(token.type){
            case (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyL:
            case 0, $63ef42c3a3e4cf2c$export$4feb516370e0ca6e:
                delimiterStack.push({
                    line: getStartLine(token),
                    type: 'brace',
                    isStart: true
                });
                break;
            case (0, $2a533f0146ced75e$export$f435f793048e7a0f).CurlyR:
                if (delimiterStack.length !== 0) {
                    const prevDelimiter = $72b66e11fef70fdd$var$popPrevStartDelimiterOfType(delimiterStack, 'brace');
                    if (!prevDelimiter) break;
                    let endLine = getEndLine(token);
                    if (prevDelimiter.type === 'brace') {
                        /**
                         * Other than the case when curly brace is not on a new line by itself, for example
                         * .foo {
                         *   color: red; }
                         * Use endLine minus one to show ending curly brace
                         */ if (prevToken && getEndLine(prevToken) !== endLine) endLine--;
                        if (prevDelimiter.line !== endLine) ranges.push({
                            startLine: prevDelimiter.line,
                            endLine: endLine,
                            kind: undefined
                        });
                    }
                }
                break;
            /**
             * In CSS, there is no single line comment prefixed with //
             * All comments are marked as `Comment`
             */ case (0, $2a533f0146ced75e$export$f435f793048e7a0f).Comment:
                {
                    const commentRegionMarkerToDelimiter = (marker)=>{
                        if (marker === '#region') return {
                            line: getStartLine(token),
                            type: 'comment',
                            isStart: true
                        };
                        else return {
                            line: getEndLine(token),
                            type: 'comment',
                            isStart: false
                        };
                    };
                    const getCurrDelimiter = (token)=>{
                        const matches = token.text.match(/^\s*\/\*\s*(#region|#endregion)\b\s*(.*?)\s*\*\//);
                        if (matches) return commentRegionMarkerToDelimiter(matches[1]);
                        else if (document.languageId === 'scss' || document.languageId === 'less') {
                            const matches = token.text.match(/^\s*\/\/\s*(#region|#endregion)\b\s*(.*?)\s*/);
                            if (matches) return commentRegionMarkerToDelimiter(matches[1]);
                        }
                        return null;
                    };
                    const currDelimiter = getCurrDelimiter(token);
                    // /* */ comment region folding
                    // All #region and #endregion cases
                    if (currDelimiter) {
                        if (currDelimiter.isStart) delimiterStack.push(currDelimiter);
                        else {
                            const prevDelimiter = $72b66e11fef70fdd$var$popPrevStartDelimiterOfType(delimiterStack, 'comment');
                            if (!prevDelimiter) break;
                            if (prevDelimiter.type === 'comment') {
                                if (prevDelimiter.line !== currDelimiter.line) ranges.push({
                                    startLine: prevDelimiter.line,
                                    endLine: currDelimiter.line,
                                    kind: 'region'
                                });
                            }
                        }
                    } else {
                        const range = tokenToRange(token, 'comment');
                        if (range) ranges.push(range);
                    }
                    break;
                }
        }
        prevToken = token;
        token = scanner.scan();
    }
    return ranges;
}
function $72b66e11fef70fdd$var$popPrevStartDelimiterOfType(stack, type) {
    if (stack.length === 0) return null;
    for(let i = stack.length - 1; i >= 0; i--){
        if (stack[i].type === type && stack[i].isStart) return stack.splice(i, 1)[0];
    }
    return null;
}
/**
 * - Sort regions
 * - Remove invalid regions (intersections)
 * - If limit exceeds, only return `rangeLimit` amount of ranges
 */ function $72b66e11fef70fdd$var$limitFoldingRanges(ranges, context) {
    const maxRanges = context && context.rangeLimit || Number.MAX_VALUE;
    const sortedRanges = ranges.sort((r1, r2)=>{
        let diff = r1.startLine - r2.startLine;
        if (diff === 0) diff = r1.endLine - r2.endLine;
        return diff;
    });
    const validRanges = [];
    let prevEndLine = -1;
    sortedRanges.forEach((r)=>{
        if (!(r.startLine < prevEndLine && prevEndLine < r.endLine)) {
            validRanges.push(r);
            prevEndLine = r.endLine;
        }
    });
    if (validRanges.length < maxRanges) return validRanges;
    else return validRanges.slice(0, maxRanges);
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 
// copied from js-beautify/js/lib/beautify-css.js
// version: 1.15.4
/* AUTO-GENERATED. DO NOT MODIFY. */ /*

  The MIT License (MIT)

  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.


 CSS Beautifier
---------------

    Written by Harutyun Amirjanyan, (amirjanyan@gmail.com)

    Based on code initially developed by: Einar Lielmanis, <einar@beautifier.io>
        https://beautifier.io/

    Usage:
        css_beautify(source_text);
        css_beautify(source_text, options);

    The options are (default in brackets):
        indent_size (4)                         — indentation size,
        indent_char (space)                     — character to indent with,
        selector_separator_newline (true)       - separate selectors with newline or
                                                  not (e.g. "a,\nbr" or "a, br")
        end_with_newline (false)                - end with a newline
        newline_between_rules (true)            - add a new line after every css rule
        space_around_selector_separator (false) - ensure space around selector separators:
                                                  '>', '+', '~' (e.g. "a>b" -> "a > b")
    e.g

    css_beautify(css_source_text, {
      'indent_size': 1,
      'indent_char': '\t',
      'selector_separator': ' ',
      'end_with_newline': false,
      'newline_between_rules': true,
      'space_around_selector_separator': true
    });
*/ // http://www.w3.org/TR/CSS21/syndata.html#tokenization
// http://www.w3.org/TR/css3-syntax/
var $c3432c97d5d1ea0d$var$legacy_beautify_css;
/******/ (function() {
    /******/ "use strict";
    /******/ var __webpack_modules__ = [
        ,
        ,
        /* 2 */ /***/ function(module) {
            /*jshint node:true */ /*
  The MIT License (MIT)

  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/ function OutputLine(parent) {
                this.__parent = parent;
                this.__character_count = 0;
                // use indent_count as a marker for this.__lines that have preserved indentation
                this.__indent_count = -1;
                this.__alignment_count = 0;
                this.__wrap_point_index = 0;
                this.__wrap_point_character_count = 0;
                this.__wrap_point_indent_count = -1;
                this.__wrap_point_alignment_count = 0;
                this.__items = [];
            }
            OutputLine.prototype.clone_empty = function() {
                var line = new OutputLine(this.__parent);
                line.set_indent(this.__indent_count, this.__alignment_count);
                return line;
            };
            OutputLine.prototype.item = function(index) {
                if (index < 0) return this.__items[this.__items.length + index];
                else return this.__items[index];
            };
            OutputLine.prototype.has_match = function(pattern) {
                for(var lastCheckedOutput = this.__items.length - 1; lastCheckedOutput >= 0; lastCheckedOutput--){
                    if (this.__items[lastCheckedOutput].match(pattern)) return true;
                }
                return false;
            };
            OutputLine.prototype.set_indent = function(indent, alignment) {
                if (this.is_empty()) {
                    this.__indent_count = indent || 0;
                    this.__alignment_count = alignment || 0;
                    this.__character_count = this.__parent.get_indent_size(this.__indent_count, this.__alignment_count);
                }
            };
            OutputLine.prototype._set_wrap_point = function() {
                if (this.__parent.wrap_line_length) {
                    this.__wrap_point_index = this.__items.length;
                    this.__wrap_point_character_count = this.__character_count;
                    this.__wrap_point_indent_count = this.__parent.next_line.__indent_count;
                    this.__wrap_point_alignment_count = this.__parent.next_line.__alignment_count;
                }
            };
            OutputLine.prototype._should_wrap = function() {
                return this.__wrap_point_index && this.__character_count > this.__parent.wrap_line_length && this.__wrap_point_character_count > this.__parent.next_line.__character_count;
            };
            OutputLine.prototype._allow_wrap = function() {
                if (this._should_wrap()) {
                    this.__parent.add_new_line();
                    var next = this.__parent.current_line;
                    next.set_indent(this.__wrap_point_indent_count, this.__wrap_point_alignment_count);
                    next.__items = this.__items.slice(this.__wrap_point_index);
                    this.__items = this.__items.slice(0, this.__wrap_point_index);
                    next.__character_count += this.__character_count - this.__wrap_point_character_count;
                    this.__character_count = this.__wrap_point_character_count;
                    if (next.__items[0] === " ") {
                        next.__items.splice(0, 1);
                        next.__character_count -= 1;
                    }
                    return true;
                }
                return false;
            };
            OutputLine.prototype.is_empty = function() {
                return this.__items.length === 0;
            };
            OutputLine.prototype.last = function() {
                if (!this.is_empty()) return this.__items[this.__items.length - 1];
                else return null;
            };
            OutputLine.prototype.push = function(item) {
                this.__items.push(item);
                var last_newline_index = item.lastIndexOf('\n');
                if (last_newline_index !== -1) this.__character_count = item.length - last_newline_index;
                else this.__character_count += item.length;
            };
            OutputLine.prototype.pop = function() {
                var item = null;
                if (!this.is_empty()) {
                    item = this.__items.pop();
                    this.__character_count -= item.length;
                }
                return item;
            };
            OutputLine.prototype._remove_indent = function() {
                if (this.__indent_count > 0) {
                    this.__indent_count -= 1;
                    this.__character_count -= this.__parent.indent_size;
                }
            };
            OutputLine.prototype._remove_wrap_indent = function() {
                if (this.__wrap_point_indent_count > 0) this.__wrap_point_indent_count -= 1;
            };
            OutputLine.prototype.trim = function() {
                while(this.last() === ' '){
                    this.__items.pop();
                    this.__character_count -= 1;
                }
            };
            OutputLine.prototype.toString = function() {
                var result = '';
                if (this.is_empty()) {
                    if (this.__parent.indent_empty_lines) result = this.__parent.get_indent_string(this.__indent_count);
                } else {
                    result = this.__parent.get_indent_string(this.__indent_count, this.__alignment_count);
                    result += this.__items.join('');
                }
                return result;
            };
            function IndentStringCache(options, baseIndentString) {
                this.__cache = [
                    ''
                ];
                this.__indent_size = options.indent_size;
                this.__indent_string = options.indent_char;
                if (!options.indent_with_tabs) this.__indent_string = new Array(options.indent_size + 1).join(options.indent_char);
                // Set to null to continue support for auto detection of base indent
                baseIndentString = baseIndentString || '';
                if (options.indent_level > 0) baseIndentString = new Array(options.indent_level + 1).join(this.__indent_string);
                this.__base_string = baseIndentString;
                this.__base_string_length = baseIndentString.length;
            }
            IndentStringCache.prototype.get_indent_size = function(indent, column) {
                var result = this.__base_string_length;
                column = column || 0;
                if (indent < 0) result = 0;
                result += indent * this.__indent_size;
                result += column;
                return result;
            };
            IndentStringCache.prototype.get_indent_string = function(indent_level, column) {
                var result = this.__base_string;
                column = column || 0;
                if (indent_level < 0) {
                    indent_level = 0;
                    result = '';
                }
                column += indent_level * this.__indent_size;
                this.__ensure_cache(column);
                result += this.__cache[column];
                return result;
            };
            IndentStringCache.prototype.__ensure_cache = function(column) {
                while(column >= this.__cache.length)this.__add_column();
            };
            IndentStringCache.prototype.__add_column = function() {
                var column = this.__cache.length;
                var indent = 0;
                var result = '';
                if (this.__indent_size && column >= this.__indent_size) {
                    indent = Math.floor(column / this.__indent_size);
                    column -= indent * this.__indent_size;
                    result = new Array(indent + 1).join(this.__indent_string);
                }
                if (column) result += new Array(column + 1).join(' ');
                this.__cache.push(result);
            };
            function Output(options, baseIndentString) {
                this.__indent_cache = new IndentStringCache(options, baseIndentString);
                this.raw = false;
                this._end_with_newline = options.end_with_newline;
                this.indent_size = options.indent_size;
                this.wrap_line_length = options.wrap_line_length;
                this.indent_empty_lines = options.indent_empty_lines;
                this.__lines = [];
                this.previous_line = null;
                this.current_line = null;
                this.next_line = new OutputLine(this);
                this.space_before_token = false;
                this.non_breaking_space = false;
                this.previous_token_wrapped = false;
                // initialize
                this.__add_outputline();
            }
            Output.prototype.__add_outputline = function() {
                this.previous_line = this.current_line;
                this.current_line = this.next_line.clone_empty();
                this.__lines.push(this.current_line);
            };
            Output.prototype.get_line_number = function() {
                return this.__lines.length;
            };
            Output.prototype.get_indent_string = function(indent, column) {
                return this.__indent_cache.get_indent_string(indent, column);
            };
            Output.prototype.get_indent_size = function(indent, column) {
                return this.__indent_cache.get_indent_size(indent, column);
            };
            Output.prototype.is_empty = function() {
                return !this.previous_line && this.current_line.is_empty();
            };
            Output.prototype.add_new_line = function(force_newline) {
                // never newline at the start of file
                // otherwise, newline only if we didn't just add one or we're forced
                if (this.is_empty() || !force_newline && this.just_added_newline()) return false;
                // if raw output is enabled, don't print additional newlines,
                // but still return True as though you had
                if (!this.raw) this.__add_outputline();
                return true;
            };
            Output.prototype.get_code = function(eol) {
                this.trim(true);
                // handle some edge cases where the last tokens
                // has text that ends with newline(s)
                var last_item = this.current_line.pop();
                if (last_item) {
                    if (last_item[last_item.length - 1] === '\n') last_item = last_item.replace(/\n+$/g, '');
                    this.current_line.push(last_item);
                }
                if (this._end_with_newline) this.__add_outputline();
                var sweet_code = this.__lines.join('\n');
                if (eol !== '\n') sweet_code = sweet_code.replace(/[\n]/g, eol);
                return sweet_code;
            };
            Output.prototype.set_wrap_point = function() {
                this.current_line._set_wrap_point();
            };
            Output.prototype.set_indent = function(indent, alignment) {
                indent = indent || 0;
                alignment = alignment || 0;
                // Next line stores alignment values
                this.next_line.set_indent(indent, alignment);
                // Never indent your first output indent at the start of the file
                if (this.__lines.length > 1) {
                    this.current_line.set_indent(indent, alignment);
                    return true;
                }
                this.current_line.set_indent();
                return false;
            };
            Output.prototype.add_raw_token = function(token) {
                for(var x = 0; x < token.newlines; x++)this.__add_outputline();
                this.current_line.set_indent(-1);
                this.current_line.push(token.whitespace_before);
                this.current_line.push(token.text);
                this.space_before_token = false;
                this.non_breaking_space = false;
                this.previous_token_wrapped = false;
            };
            Output.prototype.add_token = function(printable_token) {
                this.__add_space_before_token();
                this.current_line.push(printable_token);
                this.space_before_token = false;
                this.non_breaking_space = false;
                this.previous_token_wrapped = this.current_line._allow_wrap();
            };
            Output.prototype.__add_space_before_token = function() {
                if (this.space_before_token && !this.just_added_newline()) {
                    if (!this.non_breaking_space) this.set_wrap_point();
                    this.current_line.push(' ');
                }
            };
            Output.prototype.remove_indent = function(index) {
                var output_length = this.__lines.length;
                while(index < output_length){
                    this.__lines[index]._remove_indent();
                    index++;
                }
                this.current_line._remove_wrap_indent();
            };
            Output.prototype.trim = function(eat_newlines) {
                eat_newlines = eat_newlines === undefined ? false : eat_newlines;
                this.current_line.trim();
                while(eat_newlines && this.__lines.length > 1 && this.current_line.is_empty()){
                    this.__lines.pop();
                    this.current_line = this.__lines[this.__lines.length - 1];
                    this.current_line.trim();
                }
                this.previous_line = this.__lines.length > 1 ? this.__lines[this.__lines.length - 2] : null;
            };
            Output.prototype.just_added_newline = function() {
                return this.current_line.is_empty();
            };
            Output.prototype.just_added_blankline = function() {
                return this.is_empty() || this.current_line.is_empty() && this.previous_line.is_empty();
            };
            Output.prototype.ensure_empty_line_above = function(starts_with, ends_with) {
                var index = this.__lines.length - 2;
                while(index >= 0){
                    var potentialEmptyLine = this.__lines[index];
                    if (potentialEmptyLine.is_empty()) break;
                    else if (potentialEmptyLine.item(0).indexOf(starts_with) !== 0 && potentialEmptyLine.item(-1) !== ends_with) {
                        this.__lines.splice(index + 1, 0, new OutputLine(this));
                        this.previous_line = this.__lines[this.__lines.length - 2];
                        break;
                    }
                    index--;
                }
            };
            module.exports.Output = Output;
        /***/ },
        ,
        ,
        ,
        /* 6 */ /***/ function(module) {
            /*jshint node:true */ /*

  The MIT License (MIT)

  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/ function Options(options, merge_child_field) {
                this.raw_options = _mergeOpts(options, merge_child_field);
                // Support passing the source text back with no change
                this.disabled = this._get_boolean('disabled');
                this.eol = this._get_characters('eol', 'auto');
                this.end_with_newline = this._get_boolean('end_with_newline');
                this.indent_size = this._get_number('indent_size', 4);
                this.indent_char = this._get_characters('indent_char', ' ');
                this.indent_level = this._get_number('indent_level');
                this.preserve_newlines = this._get_boolean('preserve_newlines', true);
                this.max_preserve_newlines = this._get_number('max_preserve_newlines', 32786);
                if (!this.preserve_newlines) this.max_preserve_newlines = 0;
                this.indent_with_tabs = this._get_boolean('indent_with_tabs', this.indent_char === '\t');
                if (this.indent_with_tabs) {
                    this.indent_char = '\t';
                    // indent_size behavior changed after 1.8.6
                    // It used to be that indent_size would be
                    // set to 1 for indent_with_tabs. That is no longer needed and
                    // actually doesn't make sense - why not use spaces? Further,
                    // that might produce unexpected behavior - tabs being used
                    // for single-column alignment. So, when indent_with_tabs is true
                    // and indent_size is 1, reset indent_size to 4.
                    if (this.indent_size === 1) this.indent_size = 4;
                }
                // Backwards compat with 1.3.x
                this.wrap_line_length = this._get_number('wrap_line_length', this._get_number('max_char'));
                this.indent_empty_lines = this._get_boolean('indent_empty_lines');
                // valid templating languages ['django', 'erb', 'handlebars', 'php', 'smarty', 'angular']
                // For now, 'auto' = all off for javascript, all except angular on for html (and inline javascript/css).
                // other values ignored
                this.templating = this._get_selection_list('templating', [
                    'auto',
                    'none',
                    'angular',
                    'django',
                    'erb',
                    'handlebars',
                    'php',
                    'smarty'
                ], [
                    'auto'
                ]);
            }
            Options.prototype._get_array = function(name, default_value) {
                var option_value = this.raw_options[name];
                var result = default_value || [];
                if (typeof option_value === 'object') {
                    if (option_value !== null && typeof option_value.concat === 'function') result = option_value.concat();
                } else if (typeof option_value === 'string') result = option_value.split(/[^a-zA-Z0-9_\/\-]+/);
                return result;
            };
            Options.prototype._get_boolean = function(name, default_value) {
                var option_value = this.raw_options[name];
                var result = option_value === undefined ? !!default_value : !!option_value;
                return result;
            };
            Options.prototype._get_characters = function(name, default_value) {
                var option_value = this.raw_options[name];
                var result = default_value || '';
                if (typeof option_value === 'string') result = option_value.replace(/\\r/, '\r').replace(/\\n/, '\n').replace(/\\t/, '\t');
                return result;
            };
            Options.prototype._get_number = function(name, default_value) {
                var option_value = this.raw_options[name];
                default_value = parseInt(default_value, 10);
                if (isNaN(default_value)) default_value = 0;
                var result = parseInt(option_value, 10);
                if (isNaN(result)) result = default_value;
                return result;
            };
            Options.prototype._get_selection = function(name, selection_list, default_value) {
                var result = this._get_selection_list(name, selection_list, default_value);
                if (result.length !== 1) throw new Error("Invalid Option Value: The option '" + name + "' can only be one of the following values:\n" + selection_list + "\nYou passed in: '" + this.raw_options[name] + "'");
                return result[0];
            };
            Options.prototype._get_selection_list = function(name, selection_list, default_value) {
                if (!selection_list || selection_list.length === 0) throw new Error("Selection list cannot be empty.");
                default_value = default_value || [
                    selection_list[0]
                ];
                if (!this._is_valid_selection(default_value, selection_list)) throw new Error("Invalid Default Value!");
                var result = this._get_array(name, default_value);
                if (!this._is_valid_selection(result, selection_list)) throw new Error("Invalid Option Value: The option '" + name + "' can contain only the following values:\n" + selection_list + "\nYou passed in: '" + this.raw_options[name] + "'");
                return result;
            };
            Options.prototype._is_valid_selection = function(result, selection_list) {
                return result.length && selection_list.length && !result.some(function(item) {
                    return selection_list.indexOf(item) === -1;
                });
            };
            // merges child options up with the parent options object
            // Example: obj = {a: 1, b: {a: 2}}
            //          mergeOpts(obj, 'b')
            //
            //          Returns: {a: 2}
            function _mergeOpts(allOptions, childFieldName) {
                var finalOpts = {};
                allOptions = _normalizeOpts(allOptions);
                var name;
                for(name in allOptions)if (name !== childFieldName) finalOpts[name] = allOptions[name];
                //merge in the per type settings for the childFieldName
                if (childFieldName && allOptions[childFieldName]) for(name in allOptions[childFieldName])finalOpts[name] = allOptions[childFieldName][name];
                return finalOpts;
            }
            function _normalizeOpts(options) {
                var convertedOpts = {};
                var key;
                for(key in options){
                    var newKey = key.replace(/-/g, "_");
                    convertedOpts[newKey] = options[key];
                }
                return convertedOpts;
            }
            module.exports.Options = Options;
            module.exports.normalizeOpts = _normalizeOpts;
            module.exports.mergeOpts = _mergeOpts;
        /***/ },
        ,
        /* 8 */ /***/ function(module) {
            /*jshint node:true */ /*

  The MIT License (MIT)

  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/ var regexp_has_sticky = RegExp.prototype.hasOwnProperty('sticky');
            function InputScanner(input_string) {
                this.__input = input_string || '';
                this.__input_length = this.__input.length;
                this.__position = 0;
            }
            InputScanner.prototype.restart = function() {
                this.__position = 0;
            };
            InputScanner.prototype.back = function() {
                if (this.__position > 0) this.__position -= 1;
            };
            InputScanner.prototype.hasNext = function() {
                return this.__position < this.__input_length;
            };
            InputScanner.prototype.next = function() {
                var val = null;
                if (this.hasNext()) {
                    val = this.__input.charAt(this.__position);
                    this.__position += 1;
                }
                return val;
            };
            InputScanner.prototype.peek = function(index) {
                var val = null;
                index = index || 0;
                index += this.__position;
                if (index >= 0 && index < this.__input_length) val = this.__input.charAt(index);
                return val;
            };
            // This is a JavaScript only helper function (not in python)
            // Javascript doesn't have a match method
            // and not all implementation support "sticky" flag.
            // If they do not support sticky then both this.match() and this.test() method
            // must get the match and check the index of the match.
            // If sticky is supported and set, this method will use it.
            // Otherwise it will check that global is set, and fall back to the slower method.
            InputScanner.prototype.__match = function(pattern, index) {
                pattern.lastIndex = index;
                var pattern_match = pattern.exec(this.__input);
                if (pattern_match && !(regexp_has_sticky && pattern.sticky)) {
                    if (pattern_match.index !== index) pattern_match = null;
                }
                return pattern_match;
            };
            InputScanner.prototype.test = function(pattern, index) {
                index = index || 0;
                index += this.__position;
                if (index >= 0 && index < this.__input_length) return !!this.__match(pattern, index);
                else return false;
            };
            InputScanner.prototype.testChar = function(pattern, index) {
                // test one character regex match
                var val = this.peek(index);
                pattern.lastIndex = 0;
                return val !== null && pattern.test(val);
            };
            InputScanner.prototype.match = function(pattern) {
                var pattern_match = this.__match(pattern, this.__position);
                if (pattern_match) this.__position += pattern_match[0].length;
                else pattern_match = null;
                return pattern_match;
            };
            InputScanner.prototype.read = function(starting_pattern, until_pattern, until_after) {
                var val = '';
                var match;
                if (starting_pattern) {
                    match = this.match(starting_pattern);
                    if (match) val += match[0];
                }
                if (until_pattern && (match || !starting_pattern)) val += this.readUntil(until_pattern, until_after);
                return val;
            };
            InputScanner.prototype.readUntil = function(pattern, until_after) {
                var val = '';
                var match_index = this.__position;
                pattern.lastIndex = this.__position;
                var pattern_match = pattern.exec(this.__input);
                if (pattern_match) {
                    match_index = pattern_match.index;
                    if (until_after) match_index += pattern_match[0].length;
                } else match_index = this.__input_length;
                val = this.__input.substring(this.__position, match_index);
                this.__position = match_index;
                return val;
            };
            InputScanner.prototype.readUntilAfter = function(pattern) {
                return this.readUntil(pattern, true);
            };
            InputScanner.prototype.get_regexp = function(pattern, match_from) {
                var result = null;
                var flags = 'g';
                if (match_from && regexp_has_sticky) flags = 'y';
                // strings are converted to regexp
                if (typeof pattern === "string" && pattern !== '') // result = new RegExp(pattern.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), flags);
                result = new RegExp(pattern, flags);
                else if (pattern) result = new RegExp(pattern.source, flags);
                return result;
            };
            InputScanner.prototype.get_literal_regexp = function(literal_string) {
                return RegExp(literal_string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
            };
            /* css beautifier legacy helpers */ InputScanner.prototype.peekUntilAfter = function(pattern) {
                var start = this.__position;
                var val = this.readUntilAfter(pattern);
                this.__position = start;
                return val;
            };
            InputScanner.prototype.lookBack = function(testVal) {
                var start = this.__position - 1;
                return start >= testVal.length && this.__input.substring(start - testVal.length, start).toLowerCase() === testVal;
            };
            module.exports.InputScanner = InputScanner;
        /***/ },
        ,
        ,
        ,
        ,
        /* 13 */ /***/ function(module) {
            /*jshint node:true */ /*

  The MIT License (MIT)

  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/ function Directives(start_block_pattern, end_block_pattern) {
                start_block_pattern = typeof start_block_pattern === 'string' ? start_block_pattern : start_block_pattern.source;
                end_block_pattern = typeof end_block_pattern === 'string' ? end_block_pattern : end_block_pattern.source;
                this.__directives_block_pattern = new RegExp(start_block_pattern + / beautify( \w+[:]\w+)+ /.source + end_block_pattern, 'g');
                this.__directive_pattern = / (\w+)[:](\w+)/g;
                this.__directives_end_ignore_pattern = new RegExp(start_block_pattern + /\sbeautify\signore:end\s/.source + end_block_pattern, 'g');
            }
            Directives.prototype.get_directives = function(text) {
                if (!text.match(this.__directives_block_pattern)) return null;
                var directives = {};
                this.__directive_pattern.lastIndex = 0;
                var directive_match = this.__directive_pattern.exec(text);
                while(directive_match){
                    directives[directive_match[1]] = directive_match[2];
                    directive_match = this.__directive_pattern.exec(text);
                }
                return directives;
            };
            Directives.prototype.readIgnored = function(input) {
                return input.readUntilAfter(this.__directives_end_ignore_pattern);
            };
            module.exports.Directives = Directives;
        /***/ },
        ,
        /* 15 */ /***/ function(module, __unused_webpack_exports, __webpack_require__) {
            /*jshint node:true */ /*

  The MIT License (MIT)

  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/ var Beautifier = __webpack_require__(16).Beautifier, Options = __webpack_require__(17).Options;
            function css_beautify(source_text, options) {
                var beautifier = new Beautifier(source_text, options);
                return beautifier.beautify();
            }
            module.exports = css_beautify;
            module.exports.defaultOptions = function() {
                return new Options();
            };
        /***/ },
        /* 16 */ /***/ function(module, __unused_webpack_exports, __webpack_require__) {
            /*jshint node:true */ /*

  The MIT License (MIT)

  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/ var Options = __webpack_require__(17).Options;
            var Output = __webpack_require__(2).Output;
            var InputScanner = __webpack_require__(8).InputScanner;
            var Directives = __webpack_require__(13).Directives;
            var directives_core = new Directives(/\/\*/, /\*\//);
            var lineBreak = /\r\n|[\r\n]/;
            var allLineBreaks = /\r\n|[\r\n]/g;
            // tokenizer
            var whitespaceChar = /\s/;
            var whitespacePattern = /(?:\s|\n)+/g;
            var block_comment_pattern = /\/\*(?:[\s\S]*?)((?:\*\/)|$)/g;
            var comment_pattern = /\/\/(?:[^\n\r\u2028\u2029]*)/g;
            function Beautifier(source_text, options) {
                this._source_text = source_text || '';
                // Allow the setting of language/file-type specific options
                // with inheritance of overall settings
                this._options = new Options(options);
                this._ch = null;
                this._input = null;
                // https://developer.mozilla.org/en-US/docs/Web/CSS/At-rule
                this.NESTED_AT_RULE = {
                    "page": true,
                    "font-face": true,
                    "keyframes": true,
                    // also in CONDITIONAL_GROUP_RULE below
                    "media": true,
                    "supports": true,
                    "document": true
                };
                this.CONDITIONAL_GROUP_RULE = {
                    "media": true,
                    "supports": true,
                    "document": true
                };
                this.NON_SEMICOLON_NEWLINE_PROPERTY = [
                    "grid-template-areas",
                    "grid-template"
                ];
            }
            Beautifier.prototype.eatString = function(endChars) {
                var result = '';
                this._ch = this._input.next();
                while(this._ch){
                    result += this._ch;
                    if (this._ch === "\\") result += this._input.next();
                    else if (endChars.indexOf(this._ch) !== -1 || this._ch === "\n") break;
                    this._ch = this._input.next();
                }
                return result;
            };
            // Skips any white space in the source text from the current position.
            // When allowAtLeastOneNewLine is true, will output new lines for each
            // newline character found; if the user has preserve_newlines off, only
            // the first newline will be output
            Beautifier.prototype.eatWhitespace = function(allowAtLeastOneNewLine) {
                var result = whitespaceChar.test(this._input.peek());
                var newline_count = 0;
                while(whitespaceChar.test(this._input.peek())){
                    this._ch = this._input.next();
                    if (allowAtLeastOneNewLine && this._ch === '\n') {
                        if (newline_count === 0 || newline_count < this._options.max_preserve_newlines) {
                            newline_count++;
                            this._output.add_new_line(true);
                        }
                    }
                }
                return result;
            };
            // Nested pseudo-class if we are insideRule
            // and the next special character found opens
            // a new block
            Beautifier.prototype.foundNestedPseudoClass = function() {
                var openParen = 0;
                var i = 1;
                var ch = this._input.peek(i);
                while(ch){
                    if (ch === "{") return true;
                    else if (ch === '(') // pseudoclasses can contain ()
                    openParen += 1;
                    else if (ch === ')') {
                        if (openParen === 0) return false;
                        openParen -= 1;
                    } else if (ch === ";" || ch === "}") return false;
                    i++;
                    ch = this._input.peek(i);
                }
                return false;
            };
            Beautifier.prototype.print_string = function(output_string) {
                this._output.set_indent(this._indentLevel);
                this._output.non_breaking_space = true;
                this._output.add_token(output_string);
            };
            Beautifier.prototype.preserveSingleSpace = function(isAfterSpace) {
                if (isAfterSpace) this._output.space_before_token = true;
            };
            Beautifier.prototype.indent = function() {
                this._indentLevel++;
            };
            Beautifier.prototype.outdent = function() {
                if (this._indentLevel > 0) this._indentLevel--;
            };
            /*_____________________--------------------_____________________*/ Beautifier.prototype.beautify = function() {
                if (this._options.disabled) return this._source_text;
                var source_text = this._source_text;
                var eol = this._options.eol;
                if (eol === 'auto') {
                    eol = '\n';
                    if (source_text && lineBreak.test(source_text || '')) eol = source_text.match(lineBreak)[0];
                }
                // HACK: newline parsing inconsistent. This brute force normalizes the this._input.
                source_text = source_text.replace(allLineBreaks, '\n');
                // reset
                var baseIndentString = source_text.match(/^[\t ]*/)[0];
                this._output = new Output(this._options, baseIndentString);
                this._input = new InputScanner(source_text);
                this._indentLevel = 0;
                this._nestedLevel = 0;
                this._ch = null;
                var parenLevel = 0;
                var insideRule = false;
                // This is the value side of a property value pair (blue in the following ex)
                // label { content: blue }
                var insidePropertyValue = false;
                var enteringConditionalGroup = false;
                var insideNonNestedAtRule = false;
                var insideScssMap = false;
                var topCharacter = this._ch;
                var insideNonSemiColonValues = false;
                var whitespace;
                var isAfterSpace;
                var previous_ch;
                while(true){
                    whitespace = this._input.read(whitespacePattern);
                    isAfterSpace = whitespace !== '';
                    previous_ch = topCharacter;
                    this._ch = this._input.next();
                    if (this._ch === '\\' && this._input.hasNext()) this._ch += this._input.next();
                    topCharacter = this._ch;
                    if (!this._ch) break;
                    else if (this._ch === '/' && this._input.peek() === '*') {
                        // /* css comment */
                        // Always start block comments on a new line.
                        // This handles scenarios where a block comment immediately
                        // follows a property definition on the same line or where
                        // minified code is being beautified.
                        this._output.add_new_line();
                        this._input.back();
                        var comment = this._input.read(block_comment_pattern);
                        // Handle ignore directive
                        var directives = directives_core.get_directives(comment);
                        if (directives && directives.ignore === 'start') comment += directives_core.readIgnored(this._input);
                        this.print_string(comment);
                        // Ensures any new lines following the comment are preserved
                        this.eatWhitespace(true);
                        // Block comments are followed by a new line so they don't
                        // share a line with other properties
                        this._output.add_new_line();
                    } else if (this._ch === '/' && this._input.peek() === '/') {
                        // // single line comment
                        // Preserves the space before a comment
                        // on the same line as a rule
                        this._output.space_before_token = true;
                        this._input.back();
                        this.print_string(this._input.read(comment_pattern));
                        // Ensures any new lines following the comment are preserved
                        this.eatWhitespace(true);
                    } else if (this._ch === '$') {
                        this.preserveSingleSpace(isAfterSpace);
                        this.print_string(this._ch);
                        // strip trailing space, if present, for hash property checks
                        var variable = this._input.peekUntilAfter(/[: ,;{}()[\]\/='"]/g);
                        if (variable.match(/[ :]$/)) {
                            // we have a variable or pseudo-class, add it and insert one space before continuing
                            variable = this.eatString(": ").replace(/\s+$/, '');
                            this.print_string(variable);
                            this._output.space_before_token = true;
                        }
                        // might be sass variable
                        if (parenLevel === 0 && variable.indexOf(':') !== -1) {
                            insidePropertyValue = true;
                            this.indent();
                        }
                    } else if (this._ch === '@') {
                        this.preserveSingleSpace(isAfterSpace);
                        // deal with less property mixins @{...}
                        if (this._input.peek() === '{') this.print_string(this._ch + this.eatString('}'));
                        else {
                            this.print_string(this._ch);
                            // strip trailing space, if present, for hash property checks
                            var variableOrRule = this._input.peekUntilAfter(/[: ,;{}()[\]\/='"]/g);
                            if (variableOrRule.match(/[ :]$/)) {
                                // we have a variable or pseudo-class, add it and insert one space before continuing
                                variableOrRule = this.eatString(": ").replace(/\s+$/, '');
                                this.print_string(variableOrRule);
                                this._output.space_before_token = true;
                            }
                            // might be less variable
                            if (parenLevel === 0 && variableOrRule.indexOf(':') !== -1) {
                                insidePropertyValue = true;
                                this.indent();
                            // might be a nesting at-rule
                            } else if (variableOrRule in this.NESTED_AT_RULE) {
                                this._nestedLevel += 1;
                                if (variableOrRule in this.CONDITIONAL_GROUP_RULE) enteringConditionalGroup = true;
                            // might be a non-nested at-rule
                            } else if (parenLevel === 0 && !insidePropertyValue) insideNonNestedAtRule = true;
                        }
                    } else if (this._ch === '#' && this._input.peek() === '{') {
                        this.preserveSingleSpace(isAfterSpace);
                        this.print_string(this._ch + this.eatString('}'));
                    } else if (this._ch === '{') {
                        if (insidePropertyValue) {
                            insidePropertyValue = false;
                            this.outdent();
                        }
                        // non nested at rule becomes nested
                        insideNonNestedAtRule = false;
                        // when entering conditional groups, only rulesets are allowed
                        if (enteringConditionalGroup) {
                            enteringConditionalGroup = false;
                            insideRule = this._indentLevel >= this._nestedLevel;
                        } else // otherwise, declarations are also allowed
                        insideRule = this._indentLevel >= this._nestedLevel - 1;
                        if (this._options.newline_between_rules && insideRule) {
                            if (this._output.previous_line && this._output.previous_line.item(-1) !== '{') this._output.ensure_empty_line_above('/', ',');
                        }
                        this._output.space_before_token = true;
                        // The difference in print_string and indent order is necessary to indent the '{' correctly
                        if (this._options.brace_style === 'expand') {
                            this._output.add_new_line();
                            this.print_string(this._ch);
                            this.indent();
                            this._output.set_indent(this._indentLevel);
                        } else {
                            // inside mixin and first param is object
                            if (previous_ch === '(') this._output.space_before_token = false;
                            else if (previous_ch !== ',') this.indent();
                            this.print_string(this._ch);
                        }
                        this.eatWhitespace(true);
                        this._output.add_new_line();
                    } else if (this._ch === '}') {
                        this.outdent();
                        this._output.add_new_line();
                        if (previous_ch === '{') this._output.trim(true);
                        if (insidePropertyValue) {
                            this.outdent();
                            insidePropertyValue = false;
                        }
                        this.print_string(this._ch);
                        insideRule = false;
                        if (this._nestedLevel) this._nestedLevel--;
                        this.eatWhitespace(true);
                        this._output.add_new_line();
                        if (this._options.newline_between_rules && !this._output.just_added_blankline()) {
                            if (this._input.peek() !== '}') this._output.add_new_line(true);
                        }
                        if (this._input.peek() === ')') {
                            this._output.trim(true);
                            if (this._options.brace_style === "expand") this._output.add_new_line(true);
                        }
                    } else if (this._ch === ":") {
                        for(var i = 0; i < this.NON_SEMICOLON_NEWLINE_PROPERTY.length; i++)if (this._input.lookBack(this.NON_SEMICOLON_NEWLINE_PROPERTY[i])) {
                            insideNonSemiColonValues = true;
                            break;
                        }
                        if ((insideRule || enteringConditionalGroup) && !(this._input.lookBack("&") || this.foundNestedPseudoClass()) && !this._input.lookBack("(") && !insideNonNestedAtRule && parenLevel === 0) {
                            // 'property: value' delimiter
                            // which could be in a conditional group query
                            this.print_string(':');
                            if (!insidePropertyValue) {
                                insidePropertyValue = true;
                                this._output.space_before_token = true;
                                this.eatWhitespace(true);
                                this.indent();
                            }
                        } else {
                            // sass/less parent reference don't use a space
                            // sass nested pseudo-class don't use a space
                            // preserve space before pseudoclasses/pseudoelements, as it means "in any child"
                            if (this._input.lookBack(" ")) this._output.space_before_token = true;
                            if (this._input.peek() === ":") {
                                // pseudo-element
                                this._ch = this._input.next();
                                this.print_string("::");
                            } else // pseudo-class
                            this.print_string(':');
                        }
                    } else if (this._ch === '"' || this._ch === '\'') {
                        var preserveQuoteSpace = previous_ch === '"' || previous_ch === '\'';
                        this.preserveSingleSpace(preserveQuoteSpace || isAfterSpace);
                        this.print_string(this._ch + this.eatString(this._ch));
                        this.eatWhitespace(true);
                    } else if (this._ch === ';') {
                        insideNonSemiColonValues = false;
                        if (parenLevel === 0) {
                            if (insidePropertyValue) {
                                this.outdent();
                                insidePropertyValue = false;
                            }
                            insideNonNestedAtRule = false;
                            this.print_string(this._ch);
                            this.eatWhitespace(true);
                            // This maintains single line comments on the same
                            // line. Block comments are also affected, but
                            // a new line is always output before one inside
                            // that section
                            if (this._input.peek() !== '/') this._output.add_new_line();
                        } else {
                            this.print_string(this._ch);
                            this.eatWhitespace(true);
                            this._output.space_before_token = true;
                        }
                    } else if (this._ch === '(') {
                        if (this._input.lookBack("url")) {
                            this.print_string(this._ch);
                            this.eatWhitespace();
                            parenLevel++;
                            this.indent();
                            this._ch = this._input.next();
                            if (this._ch === ')' || this._ch === '"' || this._ch === '\'') this._input.back();
                            else if (this._ch) {
                                this.print_string(this._ch + this.eatString(')'));
                                if (parenLevel) {
                                    parenLevel--;
                                    this.outdent();
                                }
                            }
                        } else {
                            var space_needed = false;
                            if (this._input.lookBack("with")) // look back is not an accurate solution, we need tokens to confirm without whitespaces
                            space_needed = true;
                            this.preserveSingleSpace(isAfterSpace || space_needed);
                            this.print_string(this._ch);
                            // handle scss/sass map
                            if (insidePropertyValue && previous_ch === "$" && this._options.selector_separator_newline) {
                                this._output.add_new_line();
                                insideScssMap = true;
                            } else {
                                this.eatWhitespace();
                                parenLevel++;
                                this.indent();
                            }
                        }
                    } else if (this._ch === ')') {
                        if (parenLevel) {
                            parenLevel--;
                            this.outdent();
                        }
                        if (insideScssMap && this._input.peek() === ";" && this._options.selector_separator_newline) {
                            insideScssMap = false;
                            this.outdent();
                            this._output.add_new_line();
                        }
                        this.print_string(this._ch);
                    } else if (this._ch === ',') {
                        this.print_string(this._ch);
                        this.eatWhitespace(true);
                        if (this._options.selector_separator_newline && (!insidePropertyValue || insideScssMap) && parenLevel === 0 && !insideNonNestedAtRule) this._output.add_new_line();
                        else this._output.space_before_token = true;
                    } else if ((this._ch === '>' || this._ch === '+' || this._ch === '~') && !insidePropertyValue && parenLevel === 0) {
                        //handle combinator spacing
                        if (this._options.space_around_combinator) {
                            this._output.space_before_token = true;
                            this.print_string(this._ch);
                            this._output.space_before_token = true;
                        } else {
                            this.print_string(this._ch);
                            this.eatWhitespace();
                            // squash extra whitespace
                            if (this._ch && whitespaceChar.test(this._ch)) this._ch = '';
                        }
                    } else if (this._ch === ']') this.print_string(this._ch);
                    else if (this._ch === '[') {
                        this.preserveSingleSpace(isAfterSpace);
                        this.print_string(this._ch);
                    } else if (this._ch === '=') {
                        this.eatWhitespace();
                        this.print_string('=');
                        if (whitespaceChar.test(this._ch)) this._ch = '';
                    } else if (this._ch === '!' && !this._input.lookBack("\\")) {
                        this._output.space_before_token = true;
                        this.print_string(this._ch);
                    } else {
                        var preserveAfterSpace = previous_ch === '"' || previous_ch === '\'';
                        this.preserveSingleSpace(preserveAfterSpace || isAfterSpace);
                        this.print_string(this._ch);
                        if (!this._output.just_added_newline() && this._input.peek() === '\n' && insideNonSemiColonValues) this._output.add_new_line();
                    }
                }
                var sweetCode = this._output.get_code(eol);
                return sweetCode;
            };
            module.exports.Beautifier = Beautifier;
        /***/ },
        /* 17 */ /***/ function(module, __unused_webpack_exports, __webpack_require__) {
            /*jshint node:true */ /*

  The MIT License (MIT)

  Copyright (c) 2007-2018 Einar Lielmanis, Liam Newman, and contributors.

  Permission is hereby granted, free of charge, to any person
  obtaining a copy of this software and associated documentation files
  (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge,
  publish, distribute, sublicense, and/or sell copies of the Software,
  and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
  BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/ var BaseOptions = __webpack_require__(6).Options;
            function Options(options) {
                BaseOptions.call(this, options, 'css');
                this.selector_separator_newline = this._get_boolean('selector_separator_newline', true);
                this.newline_between_rules = this._get_boolean('newline_between_rules', true);
                var space_around_selector_separator = this._get_boolean('space_around_selector_separator');
                this.space_around_combinator = this._get_boolean('space_around_combinator') || space_around_selector_separator;
                var brace_style_split = this._get_selection_list('brace_style', [
                    'collapse',
                    'expand',
                    'end-expand',
                    'none',
                    'preserve-inline'
                ]);
                this.brace_style = 'collapse';
                for(var bs = 0; bs < brace_style_split.length; bs++)if (brace_style_split[bs] !== 'expand') // default to collapse, as only collapse|expand is implemented for now
                this.brace_style = 'collapse';
                else this.brace_style = brace_style_split[bs];
            }
            Options.prototype = new BaseOptions();
            module.exports.Options = Options;
        /***/ }
    ];
    /************************************************************************/ /******/ // The module cache
    /******/ var __webpack_module_cache__ = {};
    /******/ /******/ // The require function
    /******/ function __webpack_require__(moduleId) {
        /******/ // Check if module is in cache
        /******/ var cachedModule = __webpack_module_cache__[moduleId];
        /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
        /******/ // Create a new module (and put it into the cache)
        /******/ var module = __webpack_module_cache__[moduleId] = {
            /******/ // no module.id needed
            /******/ // no module.loaded needed
            /******/ exports: {}
        };
        /******/ /******/ // Execute the module function
        /******/ __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
        /******/ /******/ // Return the exports of the module
        /******/ return module.exports;
    /******/ }
    /******/ /************************************************************************/ /******/ /******/ // startup
    /******/ // Load entry module and return exports
    /******/ // This entry module is referenced by other modules so it can't be inlined
    /******/ var __webpack_exports__ = __webpack_require__(15);
    /******/ $c3432c97d5d1ea0d$var$legacy_beautify_css = __webpack_exports__;
/******/ /******/ })();
var $c3432c97d5d1ea0d$export$310386561c44e390 = $c3432c97d5d1ea0d$var$legacy_beautify_css;



function $9549d350c78fd43f$export$d9468344d3651243(document, range, options) {
    let value = document.getText();
    let includesEnd = true;
    let initialIndentLevel = 0;
    let inRule = false;
    const tabSize = options.tabSize || 4;
    if (range) {
        let startOffset = document.offsetAt(range.start);
        // include all leading whitespace iff at the beginning of the line
        let extendedStart = startOffset;
        while(extendedStart > 0 && $9549d350c78fd43f$var$isWhitespace(value, extendedStart - 1))extendedStart--;
        if (extendedStart === 0 || $9549d350c78fd43f$var$isEOL(value, extendedStart - 1)) startOffset = extendedStart;
        else // else keep at least one whitespace
        if (extendedStart < startOffset) startOffset = extendedStart + 1;
        // include all following whitespace until the end of the line
        let endOffset = document.offsetAt(range.end);
        let extendedEnd = endOffset;
        while(extendedEnd < value.length && $9549d350c78fd43f$var$isWhitespace(value, extendedEnd))extendedEnd++;
        if (extendedEnd === value.length || $9549d350c78fd43f$var$isEOL(value, extendedEnd)) endOffset = extendedEnd;
        range = (0, $1345bdc33671c7a9$exports.Range).create(document.positionAt(startOffset), document.positionAt(endOffset));
        // Test if inside a rule
        inRule = $9549d350c78fd43f$var$isInRule(value, startOffset);
        includesEnd = endOffset === value.length;
        value = value.substring(startOffset, endOffset);
        if (startOffset !== 0) {
            const startOfLineOffset = document.offsetAt((0, $1345bdc33671c7a9$exports.Position).create(range.start.line, 0));
            initialIndentLevel = $9549d350c78fd43f$var$computeIndentLevel(document.getText(), startOfLineOffset, options);
        }
        if (inRule) value = `{\n${$9549d350c78fd43f$var$trimLeft(value)}`;
    } else range = (0, $1345bdc33671c7a9$exports.Range).create((0, $1345bdc33671c7a9$exports.Position).create(0, 0), document.positionAt(value.length));
    const cssOptions = {
        indent_size: tabSize,
        indent_char: options.insertSpaces ? ' ' : '\t',
        end_with_newline: includesEnd && $9549d350c78fd43f$var$getFormatOption(options, 'insertFinalNewline', false),
        selector_separator_newline: $9549d350c78fd43f$var$getFormatOption(options, 'newlineBetweenSelectors', true),
        newline_between_rules: $9549d350c78fd43f$var$getFormatOption(options, 'newlineBetweenRules', true),
        space_around_selector_separator: $9549d350c78fd43f$var$getFormatOption(options, 'spaceAroundSelectorSeparator', false),
        brace_style: $9549d350c78fd43f$var$getFormatOption(options, 'braceStyle', 'collapse'),
        indent_empty_lines: $9549d350c78fd43f$var$getFormatOption(options, 'indentEmptyLines', false),
        max_preserve_newlines: $9549d350c78fd43f$var$getFormatOption(options, 'maxPreserveNewLines', undefined),
        preserve_newlines: $9549d350c78fd43f$var$getFormatOption(options, 'preserveNewLines', true),
        wrap_line_length: $9549d350c78fd43f$var$getFormatOption(options, 'wrapLineLength', undefined),
        eol: '\n'
    };
    let result = (0, $c3432c97d5d1ea0d$export$310386561c44e390)(value, cssOptions);
    if (inRule) result = $9549d350c78fd43f$var$trimLeft(result.substring(2));
    if (initialIndentLevel > 0) {
        const indent = options.insertSpaces ? (0, $3383aa02dc8dfba4$export$76d90c956114f2c2)(' ', tabSize * initialIndentLevel) : (0, $3383aa02dc8dfba4$export$76d90c956114f2c2)('\t', initialIndentLevel);
        result = result.split('\n').join('\n' + indent);
        if (range.start.character === 0) result = indent + result; // keep the indent
    }
    return [
        {
            range: range,
            newText: result
        }
    ];
}
function $9549d350c78fd43f$var$trimLeft(str) {
    return str.replace(/^\s+/, '');
}
const $9549d350c78fd43f$var$_CUL = '{'.charCodeAt(0);
const $9549d350c78fd43f$var$_CUR = '}'.charCodeAt(0);
function $9549d350c78fd43f$var$isInRule(str, offset) {
    while(offset >= 0){
        const ch = str.charCodeAt(offset);
        if (ch === $9549d350c78fd43f$var$_CUL) return true;
        else if (ch === $9549d350c78fd43f$var$_CUR) return false;
        offset--;
    }
    return false;
}
function $9549d350c78fd43f$var$getFormatOption(options, key, dflt) {
    if (options && options.hasOwnProperty(key)) {
        const value = options[key];
        if (value !== null) return value;
    }
    return dflt;
}
function $9549d350c78fd43f$var$computeIndentLevel(content, offset, options) {
    let i = offset;
    let nChars = 0;
    const tabSize = options.tabSize || 4;
    while(i < content.length){
        const ch = content.charAt(i);
        if (ch === ' ') nChars++;
        else if (ch === '\t') nChars += tabSize;
        else break;
        i++;
    }
    return Math.floor(nChars / tabSize);
}
function $9549d350c78fd43f$var$isEOL(text, offset) {
    return '\r\n'.indexOf(text.charAt(offset)) !== -1;
}
function $9549d350c78fd43f$var$isWhitespace(text, offset) {
    return ' \t'.indexOf(text.charAt(offset)) !== -1;
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ // file generated from @vscode/web-custom-data NPM package
const $62f4aa6a9f7f37a5$export$a300ecb306a53ef5 = {
    "version": 1.1,
    "properties": [
        {
            "name": "additive-symbols",
            "browsers": [
                "FF33"
            ],
            "atRule": "@counter-style",
            "syntax": "[ <integer [0,\u221E]> && <symbol> ]#",
            "relevance": 50,
            "description": "@counter-style descriptor. Specifies the symbols used by the marker-construction algorithm specified by the system descriptor. Needs to be specified if the counter system is 'additive'.",
            "restrictions": [
                "integer",
                "string",
                "image",
                "identifier"
            ]
        },
        {
            "name": "align-content",
            "browsers": [
                "E12",
                "FF28",
                "FFA28",
                "S9",
                "SM9",
                "C29",
                "CA29",
                "IE11",
                "O16"
            ],
            "values": [
                {
                    "name": "center",
                    "description": "Lines are packed toward the center of the flex container."
                },
                {
                    "name": "flex-end",
                    "description": "Lines are packed toward the end of the flex container."
                },
                {
                    "name": "flex-start",
                    "description": "Lines are packed toward the start of the flex container."
                },
                {
                    "name": "space-around",
                    "description": "Lines are evenly distributed in the flex container, with half-size spaces on either end."
                },
                {
                    "name": "space-between",
                    "description": "Lines are evenly distributed in the flex container."
                },
                {
                    "name": "stretch",
                    "description": "Lines stretch to take up the remaining space."
                },
                {
                    "name": "start"
                },
                {
                    "name": "end"
                },
                {
                    "name": "normal"
                },
                {
                    "name": "baseline"
                },
                {
                    "name": "first baseline"
                },
                {
                    "name": "last baseline"
                },
                {
                    "name": "space-around"
                },
                {
                    "name": "space-between"
                },
                {
                    "name": "space-evenly"
                },
                {
                    "name": "stretch"
                },
                {
                    "name": "safe"
                },
                {
                    "name": "unsafe"
                }
            ],
            "syntax": "normal | <baseline-position> | <content-distribution> | <overflow-position>? <content-position>",
            "relevance": 68,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/align-content"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Aligns a flex container's lines within the flex container when there is extra space in the cross-axis, similar to how 'justify-content' aligns individual items within the main-axis.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "align-items",
            "browsers": [
                "E12",
                "FF20",
                "FFA20",
                "S9",
                "SM9",
                "C29",
                "CA29",
                "IE11",
                "O16"
            ],
            "values": [
                {
                    "name": "baseline",
                    "description": "If the flex item's inline axis is the same as the cross axis, this value is identical to 'flex-start'. Otherwise, it participates in baseline alignment."
                },
                {
                    "name": "center",
                    "description": "The flex item's margin box is centered in the cross axis within the line."
                },
                {
                    "name": "flex-end",
                    "description": "The cross-end margin edge of the flex item is placed flush with the cross-end edge of the line."
                },
                {
                    "name": "flex-start",
                    "description": "The cross-start margin edge of the flex item is placed flush with the cross-start edge of the line."
                },
                {
                    "name": "stretch",
                    "description": "If the cross size property of the flex item computes to auto, and neither of the cross-axis margins are auto, the flex item is stretched."
                },
                {
                    "name": "normal"
                },
                {
                    "name": "start"
                },
                {
                    "name": "end"
                },
                {
                    "name": "self-start"
                },
                {
                    "name": "self-end"
                },
                {
                    "name": "first baseline"
                },
                {
                    "name": "last baseline"
                },
                {
                    "name": "stretch"
                },
                {
                    "name": "safe"
                },
                {
                    "name": "unsafe"
                }
            ],
            "syntax": "normal | stretch | <baseline-position> | [ <overflow-position>? <self-position> ]",
            "relevance": 89,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/align-items"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Aligns flex items along the cross axis of the current line of the flex container.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "justify-items",
            "browsers": [
                "E12",
                "FF20",
                "FFA20",
                "S9",
                "SM9",
                "C52",
                "CA52",
                "IE11",
                "O12.1"
            ],
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "normal"
                },
                {
                    "name": "end"
                },
                {
                    "name": "start"
                },
                {
                    "name": "flex-end",
                    "description": "\"Flex items are packed toward the end of the line.\""
                },
                {
                    "name": "flex-start",
                    "description": "\"Flex items are packed toward the start of the line.\""
                },
                {
                    "name": "self-end",
                    "description": "The item is packed flush to the edge of the alignment container of the end side of the item, in the appropriate axis."
                },
                {
                    "name": "self-start",
                    "description": "The item is packed flush to the edge of the alignment container of the start side of the item, in the appropriate axis.."
                },
                {
                    "name": "center",
                    "description": "The items are packed flush to each other toward the center of the of the alignment container."
                },
                {
                    "name": "left"
                },
                {
                    "name": "right"
                },
                {
                    "name": "baseline"
                },
                {
                    "name": "first baseline"
                },
                {
                    "name": "last baseline"
                },
                {
                    "name": "stretch",
                    "description": "If the cross size property of the flex item computes to auto, and neither of the cross-axis margins are auto, the flex item is stretched."
                },
                {
                    "name": "safe"
                },
                {
                    "name": "unsafe"
                },
                {
                    "name": "legacy"
                }
            ],
            "syntax": "normal | stretch | <baseline-position> | <overflow-position>? [ <self-position> | left | right ] | legacy | legacy && [ left | right | center ]",
            "relevance": 57,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/justify-items"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2016-07-27",
                "baseline_high_date": "2019-01-27"
            },
            "description": "Defines the default justify-self for all items of the box, giving them the default way of justifying each box along the appropriate axis",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "justify-self",
            "browsers": [
                "E16",
                "FF45",
                "FFA45",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "IE10",
                "O44"
            ],
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "normal"
                },
                {
                    "name": "end"
                },
                {
                    "name": "start"
                },
                {
                    "name": "flex-end",
                    "description": "\"Flex items are packed toward the end of the line.\""
                },
                {
                    "name": "flex-start",
                    "description": "\"Flex items are packed toward the start of the line.\""
                },
                {
                    "name": "self-end",
                    "description": "The item is packed flush to the edge of the alignment container of the end side of the item, in the appropriate axis."
                },
                {
                    "name": "self-start",
                    "description": "The item is packed flush to the edge of the alignment container of the start side of the item, in the appropriate axis.."
                },
                {
                    "name": "center",
                    "description": "The items are packed flush to each other toward the center of the of the alignment container."
                },
                {
                    "name": "left"
                },
                {
                    "name": "right"
                },
                {
                    "name": "baseline"
                },
                {
                    "name": "first baseline"
                },
                {
                    "name": "last baseline"
                },
                {
                    "name": "stretch",
                    "description": "If the cross size property of the flex item computes to auto, and neither of the cross-axis margins are auto, the flex item is stretched."
                },
                {
                    "name": "save"
                },
                {
                    "name": "unsave"
                }
            ],
            "syntax": "auto | normal | stretch | <baseline-position> | <overflow-position>? [ <self-position> | left | right ]",
            "relevance": 56,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/justify-self"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "Defines the way of justifying a box inside its container along the appropriate axis.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "align-self",
            "browsers": [
                "E12",
                "FF20",
                "FFA20",
                "S9",
                "SM9",
                "C29",
                "CA29",
                "IE10",
                "O12.1"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Computes to the value of 'align-items' on the element's parent, or 'stretch' if the element has no parent. On absolutely positioned elements, it computes to itself."
                },
                {
                    "name": "normal"
                },
                {
                    "name": "self-end"
                },
                {
                    "name": "self-start"
                },
                {
                    "name": "baseline",
                    "description": "If the flex item's inline axis is the same as the cross axis, this value is identical to 'flex-start'. Otherwise, it participates in baseline alignment."
                },
                {
                    "name": "center",
                    "description": "The flex item's margin box is centered in the cross axis within the line."
                },
                {
                    "name": "flex-end",
                    "description": "The cross-end margin edge of the flex item is placed flush with the cross-end edge of the line."
                },
                {
                    "name": "flex-start",
                    "description": "The cross-start margin edge of the flex item is placed flush with the cross-start edge of the line."
                },
                {
                    "name": "stretch",
                    "description": "If the cross size property of the flex item computes to auto, and neither of the cross-axis margins are auto, the flex item is stretched."
                },
                {
                    "name": "baseline"
                },
                {
                    "name": "first baseline"
                },
                {
                    "name": "last baseline"
                },
                {
                    "name": "safe"
                },
                {
                    "name": "unsafe"
                }
            ],
            "syntax": "auto | normal | stretch | <baseline-position> | <overflow-position>? <self-position>",
            "relevance": 74,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/align-self"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Allows the default alignment along the cross axis to be overridden for individual flex items.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "all",
            "browsers": [
                "E79",
                "FF27",
                "FFA27",
                "S9.1",
                "SM9.3",
                "C37",
                "CA37",
                "O24"
            ],
            "values": [],
            "syntax": "initial | inherit | unset | revert | revert-layer",
            "relevance": 55,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/all"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Shorthand that resets all properties except 'direction' and 'unicode-bidi'.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "alt",
            "values": [],
            "relevance": 50,
            "baseline": {
                "status": "false"
            },
            "description": "Provides alternative text for assistive technology to replace the generated content of a ::before or ::after element.",
            "restrictions": [
                "string",
                "enum"
            ]
        },
        {
            "name": "animation",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C43",
                "CA43",
                "IE10",
                "O30"
            ],
            "values": [
                {
                    "name": "alternate",
                    "description": "The animation cycle iterations that are odd counts are played in the normal direction, and the animation cycle iterations that are even counts are played in a reverse direction."
                },
                {
                    "name": "alternate-reverse",
                    "description": "The animation cycle iterations that are odd counts are played in the reverse direction, and the animation cycle iterations that are even counts are played in a normal direction."
                },
                {
                    "name": "backwards",
                    "description": "The beginning property value (as defined in the first @keyframes at-rule) is applied before the animation is displayed, during the period defined by 'animation-delay'."
                },
                {
                    "name": "both",
                    "description": "Both forwards and backwards fill modes are applied."
                },
                {
                    "name": "forwards",
                    "description": "The final property value (as defined in the last @keyframes at-rule) is maintained after the animation completes."
                },
                {
                    "name": "infinite",
                    "description": "Causes the animation to repeat forever."
                },
                {
                    "name": "none",
                    "description": "No animation is performed"
                },
                {
                    "name": "normal",
                    "description": "Normal playback."
                },
                {
                    "name": "reverse",
                    "description": "All iterations of the animation are played in the reverse direction from the way they were specified."
                }
            ],
            "syntax": "<single-animation>#",
            "relevance": 83,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/animation"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Shorthand property combines six of the animation properties into a single property.",
            "restrictions": [
                "time",
                "timing-function",
                "enum",
                "identifier",
                "number"
            ]
        },
        {
            "name": "animation-delay",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C43",
                "CA43",
                "IE10",
                "O30"
            ],
            "syntax": "<time>#",
            "relevance": 66,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/animation-delay"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Defines when the animation will start.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "animation-direction",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C43",
                "CA43",
                "IE10",
                "O30"
            ],
            "values": [
                {
                    "name": "alternate",
                    "description": "The animation cycle iterations that are odd counts are played in the normal direction, and the animation cycle iterations that are even counts are played in a reverse direction."
                },
                {
                    "name": "alternate-reverse",
                    "description": "The animation cycle iterations that are odd counts are played in the reverse direction, and the animation cycle iterations that are even counts are played in a normal direction."
                },
                {
                    "name": "normal",
                    "description": "Normal playback."
                },
                {
                    "name": "reverse",
                    "description": "All iterations of the animation are played in the reverse direction from the way they were specified."
                }
            ],
            "syntax": "<single-animation-direction>#",
            "relevance": 56,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/animation-direction"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Defines whether or not the animation should play in reverse on alternate cycles.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "animation-duration",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C43",
                "CA43",
                "IE10",
                "O30"
            ],
            "syntax": "<time>#",
            "relevance": 71,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/animation-duration"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Defines the length of time that an animation takes to complete one cycle.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "animation-fill-mode",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C43",
                "CA43",
                "IE10",
                "O30"
            ],
            "values": [
                {
                    "name": "backwards",
                    "description": "The beginning property value (as defined in the first @keyframes at-rule) is applied before the animation is displayed, during the period defined by 'animation-delay'."
                },
                {
                    "name": "both",
                    "description": "Both forwards and backwards fill modes are applied."
                },
                {
                    "name": "forwards",
                    "description": "The final property value (as defined in the last @keyframes at-rule) is maintained after the animation completes."
                },
                {
                    "name": "none",
                    "description": "There is no change to the property value between the time the animation is applied and the time the animation begins playing or after the animation completes."
                }
            ],
            "syntax": "<single-animation-fill-mode>#",
            "relevance": 64,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/animation-fill-mode"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Defines what values are applied by the animation outside the time it is executing.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "animation-iteration-count",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C43",
                "CA43",
                "IE10",
                "O30"
            ],
            "values": [
                {
                    "name": "infinite",
                    "description": "Causes the animation to repeat forever."
                }
            ],
            "syntax": "<single-animation-iteration-count>#",
            "relevance": 65,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/animation-iteration-count"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Defines the number of times an animation cycle is played. The default value is one, meaning the animation will play from beginning to end once.",
            "restrictions": [
                "number",
                "enum"
            ]
        },
        {
            "name": "animation-name",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C43",
                "CA43",
                "IE10",
                "O30"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No animation is performed"
                }
            ],
            "syntax": "[ none | <keyframes-name> ]#",
            "relevance": 71,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/animation-name"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Defines a list of animations that apply. Each name is used to select the keyframe at-rule that provides the property values for the animation.",
            "restrictions": [
                "identifier",
                "enum"
            ]
        },
        {
            "name": "animation-play-state",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C43",
                "CA43",
                "IE10",
                "O30"
            ],
            "values": [
                {
                    "name": "paused",
                    "description": "A running animation will be paused."
                },
                {
                    "name": "running",
                    "description": "Resume playback of a paused animation."
                }
            ],
            "syntax": "<single-animation-play-state>#",
            "relevance": 55,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/animation-play-state"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Defines whether the animation is running or paused.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "animation-timing-function",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C43",
                "CA43",
                "IE10",
                "O30"
            ],
            "syntax": "<easing-function>#",
            "relevance": 72,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/animation-timing-function"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Describes how the animation will progress over one cycle of its duration.",
            "restrictions": [
                "timing-function"
            ]
        },
        {
            "name": "backface-visibility",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S15.4",
                "SM15.4",
                "C36",
                "CA36",
                "IE10",
                "O23"
            ],
            "values": [
                {
                    "name": "hidden",
                    "description": "Back side is hidden."
                },
                {
                    "name": "visible",
                    "description": "Back side is visible."
                }
            ],
            "syntax": "visible | hidden",
            "relevance": 60,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/backface-visibility"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-03-14",
                "baseline_high_date": "2024-09-14"
            },
            "description": "Determines whether or not the 'back' side of a transformed element is visible when facing the viewer. With an identity transform, the front side of an element faces the viewer.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "background",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "values": [
                {
                    "name": "fixed",
                    "description": "The background is fixed with regard to the viewport. In paged media where there is no viewport, a 'fixed' background is fixed with respect to the page box and therefore replicated on every page."
                },
                {
                    "name": "local",
                    "description": "The background is fixed with regard to the element's contents: if the element has a scrolling mechanism, the background scrolls with the element's contents."
                },
                {
                    "name": "none",
                    "description": "A value of 'none' counts as an image layer but draws nothing."
                },
                {
                    "name": "scroll",
                    "description": "The background is fixed with regard to the element itself and does not scroll with its contents. (It is effectively attached to the element's border.)"
                }
            ],
            "syntax": "[ <bg-layer> , ]* <final-bg-layer>",
            "relevance": 93,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/background"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property for setting most background properties at the same place in the style sheet.",
            "restrictions": [
                "enum",
                "image",
                "color",
                "position",
                "length",
                "repeat",
                "percentage",
                "box"
            ]
        },
        {
            "name": "background-attachment",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM3.2",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "values": [
                {
                    "name": "fixed",
                    "description": "The background is fixed with regard to the viewport. In paged media where there is no viewport, a 'fixed' background is fixed with respect to the page box and therefore replicated on every page."
                },
                {
                    "name": "local",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM3.2",
                        "C1",
                        "CA18",
                        "IE4",
                        "O3.5"
                    ],
                    "description": "The background is fixed with regard to the element's contents: if the element has a scrolling mechanism, the background scrolls with the element's contents."
                },
                {
                    "name": "scroll",
                    "description": "The background is fixed with regard to the element itself and does not scroll with its contents. (It is effectively attached to the element's border.)"
                }
            ],
            "syntax": "<attachment>#",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/background-attachment"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies whether the background images are fixed with regard to the viewport ('fixed') or scroll along with the element ('scroll') or its contents ('local').",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "background-blend-mode",
            "browsers": [
                "E79",
                "FF30",
                "FFA30",
                "S8",
                "SM8",
                "C35",
                "CA35",
                "O22"
            ],
            "values": [
                {
                    "name": "normal",
                    "description": "Default attribute which specifies no blending"
                },
                {
                    "name": "multiply",
                    "description": "The source color is multiplied by the destination color and replaces the destination."
                },
                {
                    "name": "screen",
                    "description": "Multiplies the complements of the backdrop and source color values, then complements the result."
                },
                {
                    "name": "overlay",
                    "description": "Multiplies or screens the colors, depending on the backdrop color value."
                },
                {
                    "name": "darken",
                    "description": "Selects the darker of the backdrop and source colors."
                },
                {
                    "name": "lighten",
                    "description": "Selects the lighter of the backdrop and source colors."
                },
                {
                    "name": "color-dodge",
                    "description": "Brightens the backdrop color to reflect the source color."
                },
                {
                    "name": "color-burn",
                    "description": "Darkens the backdrop color to reflect the source color."
                },
                {
                    "name": "hard-light",
                    "description": "Multiplies or screens the colors, depending on the source color value."
                },
                {
                    "name": "soft-light",
                    "description": "Darkens or lightens the colors, depending on the source color value."
                },
                {
                    "name": "difference",
                    "description": "Subtracts the darker of the two constituent colors from the lighter color.."
                },
                {
                    "name": "exclusion",
                    "description": "Produces an effect similar to that of the Difference mode but lower in contrast."
                },
                {
                    "name": "hue",
                    "browsers": [
                        "E79",
                        "FF30",
                        "FFA30",
                        "S8",
                        "SM8",
                        "C35",
                        "CA35",
                        "O22"
                    ],
                    "description": "Creates a color with the hue of the source color and the saturation and luminosity of the backdrop color."
                },
                {
                    "name": "saturation",
                    "browsers": [
                        "E79",
                        "FF30",
                        "FFA30",
                        "S8",
                        "SM8",
                        "C35",
                        "CA35",
                        "O22"
                    ],
                    "description": "Creates a color with the saturation of the source color and the hue and luminosity of the backdrop color."
                },
                {
                    "name": "color",
                    "browsers": [
                        "E79",
                        "FF30",
                        "FFA30",
                        "S8",
                        "SM8",
                        "C35",
                        "CA35",
                        "O22"
                    ],
                    "description": "Creates a color with the hue and saturation of the source color and the luminosity of the backdrop color."
                },
                {
                    "name": "luminosity",
                    "browsers": [
                        "E79",
                        "FF30",
                        "FFA30",
                        "S8",
                        "SM8",
                        "C35",
                        "CA35",
                        "O22"
                    ],
                    "description": "Creates a color with the luminosity of the source color and the hue and saturation of the backdrop color."
                }
            ],
            "syntax": "<blend-mode>#",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/background-blend-mode"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Defines the blending mode of each background layer.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "background-clip",
            "browsers": [
                "E12",
                "FF4",
                "FFA4",
                "S5",
                "SM5",
                "C1",
                "CA18",
                "IE9",
                "O10.5"
            ],
            "syntax": "<bg-clip>#",
            "relevance": 69,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/background-clip"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Determines the background painting area.",
            "restrictions": [
                "box"
            ]
        },
        {
            "name": "background-color",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<color>",
            "relevance": 94,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/background-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the background color of an element.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "background-image",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "Counts as an image layer but draws nothing."
                }
            ],
            "syntax": "<bg-image>#",
            "relevance": 88,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/background-image"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the background image(s) of an element.",
            "restrictions": [
                "image",
                "enum"
            ]
        },
        {
            "name": "background-origin",
            "browsers": [
                "E12",
                "FF4",
                "FFA4",
                "S3",
                "SM1",
                "C1",
                "CA18",
                "IE9",
                "O10.5"
            ],
            "syntax": "<visual-box>#",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/background-origin"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "For elements rendered as a single box, specifies the background positioning area. For elements rendered as multiple boxes (e.g., inline boxes on several lines, boxes on several pages) specifies which boxes 'box-decoration-break' operates on to determine the background positioning area(s).",
            "restrictions": [
                "box"
            ]
        },
        {
            "name": "background-position",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<bg-position>#",
            "relevance": 87,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/background-position"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies the initial position of the background image(s) (after any resizing) within their corresponding background positioning area.",
            "restrictions": [
                "position",
                "length",
                "percentage"
            ]
        },
        {
            "name": "background-position-x",
            "browsers": [
                "E12",
                "FF49",
                "FFA49",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE6",
                "O15"
            ],
            "values": [
                {
                    "name": "center",
                    "description": "Equivalent to '50%' ('left 50%') for the horizontal position if the horizontal position is not otherwise specified, or '50%' ('top 50%') for the vertical position if it is."
                },
                {
                    "name": "left",
                    "description": "Equivalent to '0%' for the horizontal position if one or two values are given, otherwise specifies the left edge as the origin for the next offset."
                },
                {
                    "name": "right",
                    "description": "Equivalent to '100%' for the horizontal position if one or two values are given, otherwise specifies the right edge as the origin for the next offset."
                }
            ],
            "syntax": "[ center | [ [ left | right | x-start | x-end ]? <length-percentage>? ]! ]#",
            "relevance": 56,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/background-position-x"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2016-09-20",
                "baseline_high_date": "2019-03-20"
            },
            "description": "If background images have been specified, this property specifies their initial position (after any resizing) within their corresponding background positioning area.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "background-position-y",
            "browsers": [
                "E12",
                "FF49",
                "FFA49",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE6",
                "O15"
            ],
            "values": [
                {
                    "name": "bottom",
                    "description": "Equivalent to '100%' for the vertical position if one or two values are given, otherwise specifies the bottom edge as the origin for the next offset."
                },
                {
                    "name": "center",
                    "description": "Equivalent to '50%' ('left 50%') for the horizontal position if the horizontal position is not otherwise specified, or '50%' ('top 50%') for the vertical position if it is."
                },
                {
                    "name": "top",
                    "description": "Equivalent to '0%' for the vertical position if one or two values are given, otherwise specifies the top edge as the origin for the next offset."
                }
            ],
            "syntax": "[ center | [ [ top | bottom | y-start | y-end ]? <length-percentage>? ]! ]#",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/background-position-y"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2016-09-20",
                "baseline_high_date": "2019-03-20"
            },
            "description": "If background images have been specified, this property specifies their initial position (after any resizing) within their corresponding background positioning area.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "background-repeat",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "values": [],
            "syntax": "<repeat-style>#",
            "relevance": 86,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/background-repeat"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies how background images are tiled after they have been sized and positioned.",
            "restrictions": [
                "repeat"
            ]
        },
        {
            "name": "background-size",
            "browsers": [
                "E12",
                "FF4",
                "FFA4",
                "S5",
                "SM4.2",
                "C3",
                "CA18",
                "IE9",
                "O10"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Resolved by using the image's intrinsic ratio and the size of the other dimension, or failing that, using the image's intrinsic size, or failing that, treating it as 100%."
                },
                {
                    "name": "contain",
                    "description": "Scale the image, while preserving its intrinsic aspect ratio (if any), to the largest size such that both its width and its height can fit inside the background positioning area."
                },
                {
                    "name": "cover",
                    "description": "Scale the image, while preserving its intrinsic aspect ratio (if any), to the smallest size such that both its width and its height can completely cover the background positioning area."
                }
            ],
            "syntax": "<bg-size>#",
            "relevance": 86,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/background-size"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies the size of the background images.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "behavior",
            "browsers": [
                "IE6"
            ],
            "relevance": 50,
            "description": "IE only. Used to extend behaviors of the browser.",
            "restrictions": [
                "url"
            ]
        },
        {
            "name": "block-size",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Depends on the values of other properties."
                }
            ],
            "syntax": "<'width'>",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/block-size"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Size of an element in the direction opposite that of the direction specified by 'writing-mode'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "border",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<line-width> || <line-style> || <color>",
            "relevance": 95,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property for setting border width, style, and color.",
            "restrictions": [
                "length",
                "line-width",
                "line-style",
                "color"
            ]
        },
        {
            "name": "border-block-end",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-width'> || <'border-top-style'> || <color>",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-block-end"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-bottom'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "line-width",
                "line-style",
                "color"
            ]
        },
        {
            "name": "border-block-start",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-width'> || <'border-top-style'> || <color>",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-block-start"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-top'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "line-width",
                "line-style",
                "color"
            ]
        },
        {
            "name": "border-block-end-color",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-color'>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-block-end-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-bottom-color'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "border-block-start-color",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-color'>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-block-start-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-top-color'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "border-block-end-style",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-style'>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-block-end-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-bottom-style'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "line-style"
            ]
        },
        {
            "name": "border-block-start-style",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-style'>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-block-start-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-top-style'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "line-style"
            ]
        },
        {
            "name": "border-block-end-width",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-width'>",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-block-end-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-bottom-width'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "line-width"
            ]
        },
        {
            "name": "border-block-start-width",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-width'>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-block-start-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-top-width'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "line-width"
            ]
        },
        {
            "name": "border-bottom",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<line-width> || <line-style> || <color>",
            "relevance": 87,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-bottom"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property for setting border width, style and color.",
            "restrictions": [
                "length",
                "line-width",
                "line-style",
                "color"
            ]
        },
        {
            "name": "border-bottom-color",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<'border-top-color'>",
            "relevance": 69,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-bottom-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the color of the bottom border.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "border-bottom-left-radius",
            "browsers": [
                "E12",
                "FF4",
                "FFA4",
                "S5",
                "SM4.2",
                "C4",
                "CA18",
                "IE9",
                "O10.5"
            ],
            "syntax": "<length-percentage>{1,2}",
            "relevance": 75,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-bottom-left-radius"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Defines the radii of the bottom left outer border edge.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "border-bottom-right-radius",
            "browsers": [
                "E12",
                "FF4",
                "FFA4",
                "S5",
                "SM4.2",
                "C4",
                "CA18",
                "IE9",
                "O10.5"
            ],
            "syntax": "<length-percentage>{1,2}",
            "relevance": 75,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-bottom-right-radius"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Defines the radii of the bottom right outer border edge.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "border-bottom-style",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE5.5",
                "O9.2"
            ],
            "syntax": "<line-style>",
            "relevance": 58,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-bottom-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the style of the bottom border.",
            "restrictions": [
                "line-style"
            ]
        },
        {
            "name": "border-bottom-width",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<line-width>",
            "relevance": 62,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-bottom-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the thickness of the bottom border.",
            "restrictions": [
                "length",
                "line-width"
            ]
        },
        {
            "name": "border-collapse",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1.1",
                "SM1",
                "C1",
                "CA18",
                "IE5",
                "O4"
            ],
            "values": [
                {
                    "name": "collapse",
                    "description": "Selects the collapsing borders model."
                },
                {
                    "name": "separate",
                    "description": "Selects the separated borders border model."
                }
            ],
            "syntax": "collapse | separate",
            "relevance": 72,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-collapse"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Selects a table's border model.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "border-color",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "values": [],
            "syntax": "<color>{1,4}",
            "relevance": 87,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "The color of the border around all four edges of an element.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "border-image",
            "browsers": [
                "E12",
                "FF15",
                "FFA15",
                "S6",
                "SM6",
                "C16",
                "CA18",
                "IE11",
                "O11"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "If 'auto' is specified then the border image width is the intrinsic width or height (whichever is applicable) of the corresponding image slice. If the image does not have the required intrinsic dimension then the corresponding border-width is used instead."
                },
                {
                    "name": "fill",
                    "description": "Causes the middle part of the border-image to be preserved."
                },
                {
                    "name": "none",
                    "description": "Use the border styles."
                },
                {
                    "name": "repeat",
                    "description": "The image is tiled (repeated) to fill the area."
                },
                {
                    "name": "round",
                    "description": "The image is tiled (repeated) to fill the area. If it does not fill the area with a whole number of tiles, the image is rescaled so that it does."
                },
                {
                    "name": "space",
                    "description": "The image is tiled (repeated) to fill the area. If it does not fill the area with a whole number of tiles, the extra space is distributed around the tiles."
                },
                {
                    "name": "stretch",
                    "description": "The image is stretched to fill the area."
                },
                {
                    "name": "url()"
                }
            ],
            "syntax": "<'border-image-source'> || <'border-image-slice'> [ / <'border-image-width'> | / <'border-image-width'>? / <'border-image-outset'> ]? || <'border-image-repeat'>",
            "relevance": 52,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-image"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property for setting 'border-image-source', 'border-image-slice', 'border-image-width', 'border-image-outset' and 'border-image-repeat'. Omitted values are set to their initial values.",
            "restrictions": [
                "length",
                "percentage",
                "number",
                "url",
                "enum"
            ]
        },
        {
            "name": "border-image-outset",
            "browsers": [
                "E12",
                "FF15",
                "FFA15",
                "S6",
                "SM6",
                "C15",
                "CA18",
                "IE11",
                "O15"
            ],
            "syntax": "[ <length> | <number> ]{1,4}",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-image-outset"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "The values specify the amount by which the border image area extends beyond the border box on the top, right, bottom, and left sides respectively. If the fourth value is absent, it is the same as the second. If the third one is also absent, it is the same as the first. If the second one is also absent, it is the same as the first. Numbers represent multiples of the corresponding border-width.",
            "restrictions": [
                "length",
                "number"
            ]
        },
        {
            "name": "border-image-repeat",
            "browsers": [
                "E12",
                "FF15",
                "FFA15",
                "S6",
                "SM9.3",
                "C15",
                "CA18",
                "IE11",
                "O15"
            ],
            "values": [
                {
                    "name": "repeat",
                    "description": "The image is tiled (repeated) to fill the area."
                },
                {
                    "name": "round",
                    "description": "The image is tiled (repeated) to fill the area. If it does not fill the area with a whole number of tiles, the image is rescaled so that it does."
                },
                {
                    "name": "space",
                    "description": "The image is tiled (repeated) to fill the area. If it does not fill the area with a whole number of tiles, the extra space is distributed around the tiles."
                },
                {
                    "name": "stretch",
                    "description": "The image is stretched to fill the area."
                }
            ],
            "syntax": "[ stretch | repeat | round | space ]{1,2}",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-image-repeat"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2016-03-21",
                "baseline_high_date": "2018-09-21"
            },
            "description": "Specifies how the images for the sides and the middle part of the border image are scaled and tiled. If the second keyword is absent, it is assumed to be the same as the first.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "border-image-slice",
            "browsers": [
                "E12",
                "FF15",
                "FFA15",
                "S6",
                "SM6",
                "C15",
                "CA18",
                "IE11",
                "O15"
            ],
            "values": [
                {
                    "name": "fill",
                    "description": "Causes the middle part of the border-image to be preserved."
                }
            ],
            "syntax": "<number-percentage>{1,4} && fill?",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-image-slice"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies inward offsets from the top, right, bottom, and left edges of the image, dividing it into nine regions: four corners, four edges and a middle.",
            "restrictions": [
                "number",
                "percentage"
            ]
        },
        {
            "name": "border-image-source",
            "browsers": [
                "E12",
                "FF15",
                "FFA15",
                "S6",
                "SM6",
                "C15",
                "CA18",
                "IE11",
                "O15"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "Use the border styles."
                }
            ],
            "syntax": "none | <image>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-image-source"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies an image to use instead of the border styles given by the 'border-style' properties and as an additional background layer for the element. If the value is 'none' or if the image cannot be displayed, the border styles will be used.",
            "restrictions": [
                "image"
            ]
        },
        {
            "name": "border-image-width",
            "browsers": [
                "E12",
                "FF13",
                "FFA14",
                "S6",
                "SM6",
                "C16",
                "CA18",
                "IE11",
                "O15"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The border image width is the intrinsic width or height (whichever is applicable) of the corresponding image slice. If the image does not have the required intrinsic dimension then the corresponding border-width is used instead."
                }
            ],
            "syntax": "[ <length-percentage> | <number> | auto ]{1,4}",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-image-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "The four values of 'border-image-width' specify offsets that are used to divide the border image area into nine parts. They represent inward distances from the top, right, bottom, and left sides of the area, respectively.",
            "restrictions": [
                "length",
                "percentage",
                "number"
            ]
        },
        {
            "name": "border-inline-end",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-width'> || <'border-top-style'> || <color>",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-inline-end"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-right'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "line-width",
                "line-style",
                "color"
            ]
        },
        {
            "name": "border-inline-start",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-width'> || <'border-top-style'> || <color>",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-inline-start"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-left'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "line-width",
                "line-style",
                "color"
            ]
        },
        {
            "name": "border-inline-end-color",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-color'>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-inline-end-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-right-color'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "border-inline-start-color",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-color'>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-inline-start-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-left-color'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "border-inline-end-style",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-style'>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-inline-end-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-right-style'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "line-style"
            ]
        },
        {
            "name": "border-inline-start-style",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-style'>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-inline-start-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-left-style'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "line-style"
            ]
        },
        {
            "name": "border-inline-end-width",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-width'>",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-inline-end-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-right-width'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "line-width"
            ]
        },
        {
            "name": "border-inline-start-width",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'border-top-width'>",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-inline-start-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'border-left-width'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "line-width"
            ]
        },
        {
            "name": "border-left",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<line-width> || <line-style> || <color>",
            "relevance": 81,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-left"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property for setting border width, style and color",
            "restrictions": [
                "length",
                "line-width",
                "line-style",
                "color"
            ]
        },
        {
            "name": "border-left-color",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<color>",
            "relevance": 66,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-left-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the color of the left border.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "border-left-style",
            "browsers": [
                "E12",
                "FF1",
                "FFA14",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE5.5",
                "O9.2"
            ],
            "syntax": "<line-style>",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-left-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the style of the left border.",
            "restrictions": [
                "line-style"
            ]
        },
        {
            "name": "border-left-width",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<line-width>",
            "relevance": 64,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-left-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the thickness of the left border.",
            "restrictions": [
                "length",
                "line-width"
            ]
        },
        {
            "name": "border-radius",
            "browsers": [
                "E12",
                "FF4",
                "FFA4",
                "S5",
                "SM4.2",
                "C4",
                "CA18",
                "IE9",
                "O10.5"
            ],
            "syntax": "<length-percentage>{1,4} [ / <length-percentage>{1,4} ]?",
            "relevance": 92,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-radius"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Defines the radii of the outer border edge.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "border-right",
            "browsers": [
                "E12",
                "FF1",
                "FFA14",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE5.5",
                "O9.2"
            ],
            "syntax": "<line-width> || <line-style> || <color>",
            "relevance": 80,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-right"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property for setting border width, style and color",
            "restrictions": [
                "length",
                "line-width",
                "line-style",
                "color"
            ]
        },
        {
            "name": "border-right-color",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<color>",
            "relevance": 65,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-right-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the color of the right border.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "border-right-style",
            "browsers": [
                "E12",
                "FF1",
                "FFA14",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE5.5",
                "O9.2"
            ],
            "syntax": "<line-style>",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-right-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the style of the right border.",
            "restrictions": [
                "line-style"
            ]
        },
        {
            "name": "border-right-width",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<line-width>",
            "relevance": 63,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-right-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the thickness of the right border.",
            "restrictions": [
                "length",
                "line-width"
            ]
        },
        {
            "name": "border-spacing",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE8",
                "O4"
            ],
            "syntax": "<length> <length>?",
            "relevance": 65,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-spacing"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "The lengths specify the distance that separates adjoining cell borders. If one length is specified, it gives both the horizontal and vertical spacing. If two are specified, the first gives the horizontal spacing and the second the vertical spacing. Lengths may not be negative.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "border-style",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "values": [],
            "syntax": "<line-style>{1,4}",
            "relevance": 79,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "The style of the border around edges of an element.",
            "restrictions": [
                "line-style"
            ]
        },
        {
            "name": "border-top",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<line-width> || <line-style> || <color>",
            "relevance": 85,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-top"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property for setting border width, style and color",
            "restrictions": [
                "length",
                "line-width",
                "line-style",
                "color"
            ]
        },
        {
            "name": "border-top-color",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<color>",
            "relevance": 70,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-top-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the color of the top border.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "border-top-left-radius",
            "browsers": [
                "E12",
                "FF4",
                "FFA4",
                "S5",
                "SM4.2",
                "C4",
                "CA18",
                "IE9",
                "O10.5"
            ],
            "syntax": "<length-percentage>{1,2}",
            "relevance": 75,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-top-left-radius"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Defines the radii of the top left outer border edge.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "border-top-right-radius",
            "browsers": [
                "E12",
                "FF4",
                "FFA4",
                "S5",
                "SM4.2",
                "C4",
                "CA18",
                "IE9",
                "O10.5"
            ],
            "syntax": "<length-percentage>{1,2}",
            "relevance": 75,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-top-right-radius"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Defines the radii of the top right outer border edge.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "border-top-style",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE5.5",
                "O9.2"
            ],
            "syntax": "<line-style>",
            "relevance": 55,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-top-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the style of the top border.",
            "restrictions": [
                "line-style"
            ]
        },
        {
            "name": "border-top-width",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<line-width>",
            "relevance": 61,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-top-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the thickness of the top border.",
            "restrictions": [
                "length",
                "line-width"
            ]
        },
        {
            "name": "border-width",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM3",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "values": [],
            "syntax": "<line-width>{1,4}",
            "relevance": 82,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand that sets the four 'border-*-width' properties. If it has four values, they set top, right, bottom and left in that order. If left is missing, it is the same as right; if bottom is missing, it is the same as top; if right is missing, it is the same as top.",
            "restrictions": [
                "length",
                "line-width"
            ]
        },
        {
            "name": "bottom",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE5",
                "O6"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "For non-replaced elements, the effect of this value depends on which of related properties have the value 'auto' as well"
                }
            ],
            "syntax": "<length> | <percentage> | auto",
            "relevance": 90,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/bottom"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies how far an absolutely positioned box's bottom margin edge is offset above the bottom edge of the box's 'containing block'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "box-decoration-break",
            "browsers": [
                "E130",
                "FF32",
                "FFA32",
                "C130",
                "CA130",
                "O115"
            ],
            "values": [
                {
                    "name": "clone",
                    "description": "Each box is independently wrapped with the border and padding."
                },
                {
                    "name": "slice",
                    "description": "The effect is as though the element were rendered with no breaks present, and then sliced by the breaks afterward."
                }
            ],
            "syntax": "slice | clone",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/box-decoration-break"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Specifies whether individual boxes are treated as broken pieces of one continuous box, or whether each box is individually wrapped with the border and padding.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "box-shadow",
            "browsers": [
                "E12",
                "FF4",
                "FFA4",
                "S5.1",
                "SM5",
                "C10",
                "CA18",
                "IE9",
                "O10.5"
            ],
            "values": [
                {
                    "name": "inset",
                    "description": "Changes the drop shadow from an outer shadow (one that shadows the box onto the canvas, as if it were lifted above the canvas) to an inner shadow (one that shadows the canvas onto the box, as if the box were cut out of the canvas and shifted behind it)."
                },
                {
                    "name": "none",
                    "description": "No shadow."
                }
            ],
            "syntax": "none | <shadow>#",
            "relevance": 90,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/box-shadow"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Attaches one or more drop-shadows to the box. The property is a comma-separated list of shadows, each specified by 2-4 length values, an optional color, and an optional 'inset' keyword. Omitted lengths are 0; omitted colors are a user agent chosen color.",
            "restrictions": [
                "length",
                "color",
                "enum"
            ]
        },
        {
            "name": "box-sizing",
            "browsers": [
                "E12",
                "FF29",
                "FFA29",
                "S5.1",
                "SM6",
                "C10",
                "CA18",
                "IE8",
                "O7"
            ],
            "values": [
                {
                    "name": "border-box",
                    "description": "The specified width and height (and respective min/max properties) on this element determine the border box of the element."
                },
                {
                    "name": "content-box",
                    "description": "Behavior of width and height as specified by CSS2.1. The specified width and height (and respective min/max properties) apply to the width and height respectively of the content box of the element."
                }
            ],
            "syntax": "content-box | border-box",
            "relevance": 92,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/box-sizing"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies the behavior of the 'width' and 'height' properties.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "break-after",
            "browsers": [
                "E12",
                "FF65",
                "FFA65",
                "S10",
                "SM10",
                "C50",
                "CA50",
                "IE10",
                "O37"
            ],
            "values": [
                {
                    "name": "always",
                    "description": "Always force a page break before/after the generated box."
                },
                {
                    "name": "auto",
                    "description": "Neither force nor forbid a page/column break before/after the principal box."
                },
                {
                    "name": "avoid",
                    "description": "Avoid a break before/after the principal box."
                },
                {
                    "name": "avoid-column",
                    "description": "Avoid a column break before/after the principal box."
                },
                {
                    "name": "avoid-page",
                    "description": "Avoid a page break before/after the principal box."
                },
                {
                    "name": "column",
                    "description": "Always force a column break before/after the principal box."
                },
                {
                    "name": "left",
                    "description": "Force one or two page breaks before/after the generated box so that the next page is formatted as a left page."
                },
                {
                    "name": "page",
                    "description": "Always force a page break before/after the principal box."
                },
                {
                    "name": "right",
                    "description": "Force one or two page breaks before/after the generated box so that the next page is formatted as a right page."
                }
            ],
            "syntax": "auto | avoid | always | all | avoid-page | page | left | right | recto | verso | avoid-column | column | avoid-region | region",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/break-after"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2019-01-29",
                "baseline_high_date": "2021-07-29"
            },
            "description": "Describes the page/column/region break behavior after the generated box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "break-before",
            "browsers": [
                "E12",
                "FF65",
                "FFA65",
                "S10",
                "SM10",
                "C50",
                "CA50",
                "IE10",
                "O37"
            ],
            "values": [
                {
                    "name": "always",
                    "description": "Always force a page break before/after the generated box."
                },
                {
                    "name": "auto",
                    "description": "Neither force nor forbid a page/column break before/after the principal box."
                },
                {
                    "name": "avoid",
                    "description": "Avoid a break before/after the principal box."
                },
                {
                    "name": "avoid-column",
                    "description": "Avoid a column break before/after the principal box."
                },
                {
                    "name": "avoid-page",
                    "description": "Avoid a page break before/after the principal box."
                },
                {
                    "name": "column",
                    "description": "Always force a column break before/after the principal box."
                },
                {
                    "name": "left",
                    "description": "Force one or two page breaks before/after the generated box so that the next page is formatted as a left page."
                },
                {
                    "name": "page",
                    "description": "Always force a page break before/after the principal box."
                },
                {
                    "name": "right",
                    "description": "Force one or two page breaks before/after the generated box so that the next page is formatted as a right page."
                }
            ],
            "syntax": "auto | avoid | always | all | avoid-page | page | left | right | recto | verso | avoid-column | column | avoid-region | region",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/break-before"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2019-01-29",
                "baseline_high_date": "2021-07-29"
            },
            "description": "Describes the page/column/region break behavior before the generated box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "break-inside",
            "browsers": [
                "E12",
                "FF65",
                "FFA65",
                "S10",
                "SM10",
                "C50",
                "CA50",
                "IE10",
                "O37"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Impose no additional breaking constraints within the box."
                },
                {
                    "name": "avoid",
                    "description": "Avoid breaks within the box."
                },
                {
                    "name": "avoid-column",
                    "description": "Avoid a column break within the box."
                },
                {
                    "name": "avoid-page",
                    "description": "Avoid a page break within the box."
                }
            ],
            "syntax": "auto | avoid | avoid-page | avoid-column | avoid-region",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/break-inside"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2019-01-29",
                "baseline_high_date": "2021-07-29"
            },
            "description": "Describes the page/column/region break behavior inside the principal box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "caption-side",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE8",
                "O4"
            ],
            "values": [
                {
                    "name": "bottom",
                    "description": "Positions the caption box below the table box."
                },
                {
                    "name": "top",
                    "description": "Positions the caption box above the table box."
                }
            ],
            "syntax": "top | bottom",
            "relevance": 52,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/caption-side"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies the position of the caption box with respect to the table box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "caret-color",
            "browsers": [
                "E79",
                "FF53",
                "FFA53",
                "S11.1",
                "SM11.3",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The user agent selects an appropriate color for the caret. This is generally currentcolor, but the user agent may choose a different color to ensure good visibility and contrast with the surrounding content, taking into account the value of currentcolor, the background, shadows, and other factors."
                }
            ],
            "syntax": "auto | <color>",
            "relevance": 55,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/caret-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Controls the color of the text insertion indicator.",
            "restrictions": [
                "color",
                "enum"
            ]
        },
        {
            "name": "clear",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "values": [
                {
                    "name": "both",
                    "description": "The clearance of the generated box is set to the amount necessary to place the top border edge below the bottom outer edge of any right-floating and left-floating boxes that resulted from elements earlier in the source document."
                },
                {
                    "name": "left",
                    "description": "The clearance of the generated box is set to the amount necessary to place the top border edge below the bottom outer edge of any left-floating boxes that resulted from elements earlier in the source document."
                },
                {
                    "name": "none",
                    "description": "No constraint on the box's position with respect to floats."
                },
                {
                    "name": "right",
                    "description": "The clearance of the generated box is set to the amount necessary to place the top border edge below the bottom outer edge of any right-floating boxes that resulted from elements earlier in the source document."
                }
            ],
            "syntax": "none | left | right | both | inline-start | inline-end",
            "relevance": 81,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/clear"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Indicates which sides of an element's box(es) may not be adjacent to an earlier floating box. The 'clear' property does not consider floats inside the element itself or in other block formatting contexts.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "clip",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O7"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The element does not clip."
                },
                {
                    "name": "rect()",
                    "description": "Specifies offsets from the edges of the border box."
                }
            ],
            "status": "obsolete",
            "syntax": "<shape> | auto",
            "relevance": 24,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/clip"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Deprecated. Use the 'clip-path' property when support allows. Defines the visible portion of an element's box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "clip-path",
            "browsers": [
                "E79",
                "FF3.5",
                "FFA4",
                "S9.1",
                "SM9.3",
                "C55",
                "CA55",
                "IE10",
                "O42"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No clipping path gets created."
                },
                {
                    "name": "url()",
                    "description": "References a <clipPath> element to create a clipping path."
                }
            ],
            "syntax": "<clip-source> | [ <basic-shape> || <geometry-box> ] | none",
            "relevance": 67,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/clip-path"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Specifies a clipping path where everything inside the path is visible and everything outside is clipped out.",
            "restrictions": [
                "url",
                "shape",
                "geometry-box",
                "enum"
            ]
        },
        {
            "name": "clip-rule",
            "browsers": [
                "E79",
                "FF3.5",
                "FFA4",
                "S5",
                "SM4.2",
                "C15",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "evenodd",
                    "description": "Determines the 'insideness' of a point on the canvas by drawing a ray from that point to infinity in any direction and counting the number of path segments from the given shape that the ray crosses."
                },
                {
                    "name": "nonzero",
                    "description": "Determines the 'insideness' of a point on the canvas by drawing a ray from that point to infinity in any direction and then examining the places where a segment of the shape crosses the ray."
                }
            ],
            "syntax": "nonzero | evenodd",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/clip-rule"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Indicates the algorithm which is to be used to determine what parts of the canvas are included inside the shape.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "color",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE3",
                "O3.5"
            ],
            "syntax": "<color>",
            "relevance": 94,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the color of an element's text",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "color-interpolation-filters",
            "browsers": [
                "E79",
                "FF3",
                "FFA4",
                "S3",
                "SM2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Color operations are not required to occur in a particular color space."
                },
                {
                    "name": "linearRGB",
                    "description": "Color operations should occur in the linearized RGB color space."
                },
                {
                    "name": "sRGB",
                    "description": "Color operations should occur in the sRGB color space."
                }
            ],
            "syntax": "auto | sRGB | linearRGB",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/color-interpolation-filters"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Specifies the color space for imaging operations performed via filter effects.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "column-count",
            "browsers": [
                "E12",
                "FF52",
                "FFA52",
                "S9",
                "SM9",
                "C50",
                "CA50",
                "IE10",
                "O37"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Determines the number of columns by the 'column-width' property and the element width."
                }
            ],
            "syntax": "<integer> | auto",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/column-count"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-03-07",
                "baseline_high_date": "2019-09-07"
            },
            "description": "Describes the optimal number of columns into which the content of the element will be flowed.",
            "restrictions": [
                "integer",
                "enum"
            ]
        },
        {
            "name": "column-fill",
            "browsers": [
                "E12",
                "FF52",
                "FFA52",
                "S9",
                "SM9",
                "C50",
                "CA50",
                "IE10",
                "O37"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Fills columns sequentially."
                },
                {
                    "name": "balance",
                    "description": "Balance content equally between columns, if possible."
                }
            ],
            "syntax": "auto | balance",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/column-fill"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-03-07",
                "baseline_high_date": "2019-09-07"
            },
            "description": "In continuous media, this property will only be consulted if the length of columns has been constrained. Otherwise, columns will automatically be balanced.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "column-gap",
            "browsers": [
                "E12",
                "FF1.5",
                "FFA4",
                "S3",
                "SM2",
                "C1",
                "CA18",
                "IE10",
                "O11.1"
            ],
            "values": [
                {
                    "name": "normal",
                    "description": "User agent specific and typically equivalent to 1em."
                }
            ],
            "syntax": "normal | <length-percentage>",
            "relevance": 65,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/column-gap"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the gap between columns. If there is a column rule between columns, it will appear in the middle of the gap.",
            "restrictions": [
                "length",
                "enum"
            ]
        },
        {
            "name": "column-rule",
            "browsers": [
                "E12",
                "FF52",
                "FFA52",
                "S9",
                "SM9",
                "C50",
                "CA50",
                "IE10",
                "O11.1"
            ],
            "syntax": "<'column-rule-width'> || <'column-rule-style'> || <'column-rule-color'>",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/column-rule"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-03-07",
                "baseline_high_date": "2019-09-07"
            },
            "description": "Shorthand for setting 'column-rule-width', 'column-rule-style', and 'column-rule-color' at the same place in the style sheet. Omitted values are set to their initial values.",
            "restrictions": [
                "length",
                "line-width",
                "line-style",
                "color"
            ]
        },
        {
            "name": "column-rule-color",
            "browsers": [
                "E12",
                "FF52",
                "FFA52",
                "S9",
                "SM9",
                "C50",
                "CA50",
                "IE10",
                "O11.1"
            ],
            "syntax": "<color>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/column-rule-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-03-07",
                "baseline_high_date": "2019-09-07"
            },
            "description": "Sets the color of the column rule",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "column-rule-style",
            "browsers": [
                "E12",
                "FF52",
                "FFA52",
                "S9",
                "SM9",
                "C50",
                "CA50",
                "IE10",
                "O11.1"
            ],
            "syntax": "<'border-style'>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/column-rule-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-03-07",
                "baseline_high_date": "2019-09-07"
            },
            "description": "Sets the style of the rule between columns of an element.",
            "restrictions": [
                "line-style"
            ]
        },
        {
            "name": "column-rule-width",
            "browsers": [
                "E12",
                "FF52",
                "FFA52",
                "S9",
                "SM9",
                "C50",
                "CA50",
                "IE10",
                "O11.1"
            ],
            "syntax": "<'border-width'>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/column-rule-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-03-07",
                "baseline_high_date": "2019-09-07"
            },
            "description": "Sets the width of the rule between columns. Negative values are not allowed.",
            "restrictions": [
                "length",
                "line-width"
            ]
        },
        {
            "name": "columns",
            "browsers": [
                "E12",
                "FF52",
                "FFA52",
                "S9",
                "SM9",
                "C50",
                "CA50",
                "IE10",
                "O11.1"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The width depends on the values of other properties."
                }
            ],
            "syntax": "<'column-width'> || <'column-count'>",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/columns"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-03-07",
                "baseline_high_date": "2019-09-07"
            },
            "description": "A shorthand property which sets both 'column-width' and 'column-count'.",
            "restrictions": [
                "length",
                "integer",
                "enum"
            ]
        },
        {
            "name": "column-span",
            "browsers": [
                "E12",
                "FF71",
                "FFA79",
                "S9",
                "SM9",
                "C50",
                "CA50",
                "IE10",
                "O37"
            ],
            "values": [
                {
                    "name": "all",
                    "description": "The element spans across all columns. Content in the normal flow that appears before the element is automatically balanced across all columns before the element appear."
                },
                {
                    "name": "none",
                    "description": "The element does not span multiple columns."
                }
            ],
            "syntax": "none | all",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/column-span"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-07-28",
                "baseline_high_date": "2023-01-28"
            },
            "description": "Describes the page/column break behavior after the generated box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "column-width",
            "browsers": [
                "E12",
                "FF50",
                "FFA50",
                "S9",
                "SM9",
                "C50",
                "CA50",
                "IE10",
                "O11.1"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The width depends on the values of other properties."
                }
            ],
            "syntax": "<length> | auto",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/column-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2016-11-15",
                "baseline_high_date": "2019-05-15"
            },
            "description": "Describes the width of columns in multicol elements.",
            "restrictions": [
                "length",
                "enum"
            ]
        },
        {
            "name": "contain",
            "browsers": [
                "E79",
                "FF69",
                "FFA79",
                "S15.4",
                "SM15.4",
                "C52",
                "CA52",
                "O39"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "Indicates that the property has no effect."
                },
                {
                    "name": "strict",
                    "description": "Turns on all forms of containment for the element."
                },
                {
                    "name": "content",
                    "description": "All containment rules except size are applied to the element."
                },
                {
                    "name": "size",
                    "description": "For properties that can have effects on more than just an element and its descendants, those effects don't escape the containing element."
                },
                {
                    "name": "layout",
                    "description": "Turns on layout containment for the element."
                },
                {
                    "name": "style",
                    "description": "Turns on style containment for the element."
                },
                {
                    "name": "paint",
                    "description": "Turns on paint containment for the element."
                }
            ],
            "syntax": "none | strict | content | [ [ size || inline-size ] || layout || style || paint ]",
            "relevance": 59,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/contain"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-03-14",
                "baseline_high_date": "2024-09-14"
            },
            "description": "Indicates that an element and its contents are, as much as possible, independent of the rest of the document tree.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "content",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE8",
                "O4"
            ],
            "values": [
                {
                    "name": "attr()",
                    "description": "The attr(n) function returns as a string the value of attribute n for the subject of the selector."
                },
                {
                    "name": "counter(name)",
                    "description": "Counters are denoted by identifiers (see the 'counter-increment' and 'counter-reset' properties)."
                },
                {
                    "name": "icon",
                    "description": "The (pseudo-)element is replaced in its entirety by the resource referenced by its 'icon' property, and treated as a replaced element."
                },
                {
                    "name": "none",
                    "description": "On elements, this inhibits the children of the element from being rendered as children of this element, as if the element was empty. On pseudo-elements it causes the pseudo-element to have no content."
                },
                {
                    "name": "normal",
                    "description": "See http://www.w3.org/TR/css3-content/#content for computation rules."
                },
                {
                    "name": "url()"
                }
            ],
            "syntax": "normal | none | [ <content-replacement> | <content-list> ] [/ [ <string> | <counter> ]+ ]?",
            "relevance": 90,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/content"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Determines which page-based occurrence of a given element is applied to a counter or string value.",
            "restrictions": [
                "string",
                "url"
            ]
        },
        {
            "name": "counter-increment",
            "browsers": [
                "E12",
                "FF1",
                "FFA25",
                "S3",
                "SM1",
                "C2",
                "CA18",
                "IE8",
                "O9.2"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "This element does not alter the value of any counters."
                }
            ],
            "syntax": "[ <counter-name> <integer>? ]+ | none",
            "relevance": 55,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/counter-increment"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Manipulate the value of existing counters.",
            "restrictions": [
                "identifier",
                "integer"
            ]
        },
        {
            "name": "counter-reset",
            "browsers": [
                "E12",
                "FF1",
                "FFA25",
                "S3",
                "SM1",
                "C2",
                "CA18",
                "IE8",
                "O9.2"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "The counter is not modified."
                }
            ],
            "syntax": "[ <counter-name> <integer>? | <reversed-counter-name> <integer>? ]+ | none",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/counter-reset"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Property accepts one or more names of counters (identifiers), each one optionally followed by an integer. The integer gives the value that the counter is set to on each occurrence of the element.",
            "restrictions": [
                "identifier",
                "integer"
            ]
        },
        {
            "name": "cursor",
            "browsers": [
                "E12",
                "FF1",
                "FFA95",
                "S1.2",
                "SM13.4",
                "C1",
                "CA18",
                "IE4",
                "O7"
            ],
            "values": [
                {
                    "name": "alias",
                    "description": "Indicates an alias of/shortcut to something is to be created. Often rendered as an arrow with a small curved arrow next to it."
                },
                {
                    "name": "all-scroll",
                    "description": "Indicates that the something can be scrolled in any direction. Often rendered as arrows pointing up, down, left, and right with a dot in the middle."
                },
                {
                    "name": "auto",
                    "description": "The UA determines the cursor to display based on the current context."
                },
                {
                    "name": "cell",
                    "description": "Indicates that a cell or set of cells may be selected. Often rendered as a thick plus-sign with a dot in the middle."
                },
                {
                    "name": "col-resize",
                    "description": "Indicates that the item/column can be resized horizontally. Often rendered as arrows pointing left and right with a vertical bar separating them."
                },
                {
                    "name": "context-menu",
                    "description": "A context menu is available for the object under the cursor. Often rendered as an arrow with a small menu-like graphic next to it."
                },
                {
                    "name": "copy",
                    "description": "Indicates something is to be copied. Often rendered as an arrow with a small plus sign next to it."
                },
                {
                    "name": "crosshair",
                    "description": "A simple crosshair (e.g., short line segments resembling a '+' sign). Often used to indicate a two dimensional bitmap selection mode."
                },
                {
                    "name": "default",
                    "description": "The platform-dependent default cursor. Often rendered as an arrow."
                },
                {
                    "name": "e-resize",
                    "description": "Indicates that east edge is to be moved."
                },
                {
                    "name": "ew-resize",
                    "description": "Indicates a bidirectional east-west resize cursor."
                },
                {
                    "name": "grab",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA95",
                        "S1.2",
                        "SM13.4",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Indicates that something can be grabbed."
                },
                {
                    "name": "grabbing",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA95",
                        "S1.2",
                        "SM13.4",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Indicates that something is being grabbed."
                },
                {
                    "name": "help",
                    "description": "Help is available for the object under the cursor. Often rendered as a question mark or a balloon."
                },
                {
                    "name": "move",
                    "description": "Indicates something is to be moved."
                },
                {
                    "name": "-moz-grab",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA95",
                        "S1.2",
                        "SM13.4",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Indicates that something can be grabbed."
                },
                {
                    "name": "-moz-grabbing",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA95",
                        "S1.2",
                        "SM13.4",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Indicates that something is being grabbed."
                },
                {
                    "name": "-moz-zoom-in",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA95",
                        "S1.2",
                        "SM13.4",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Indicates that something can be zoomed (magnified) in."
                },
                {
                    "name": "-moz-zoom-out",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA95",
                        "S1.2",
                        "SM13.4",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Indicates that something can be zoomed (magnified) out."
                },
                {
                    "name": "ne-resize",
                    "description": "Indicates that movement starts from north-east corner."
                },
                {
                    "name": "nesw-resize",
                    "description": "Indicates a bidirectional north-east/south-west cursor."
                },
                {
                    "name": "no-drop",
                    "description": "Indicates that the dragged item cannot be dropped at the current cursor location. Often rendered as a hand or pointer with a small circle with a line through it."
                },
                {
                    "name": "none",
                    "description": "No cursor is rendered for the element."
                },
                {
                    "name": "not-allowed",
                    "description": "Indicates that the requested action will not be carried out. Often rendered as a circle with a line through it."
                },
                {
                    "name": "n-resize",
                    "description": "Indicates that north edge is to be moved."
                },
                {
                    "name": "ns-resize",
                    "description": "Indicates a bidirectional north-south cursor."
                },
                {
                    "name": "nw-resize",
                    "description": "Indicates that movement starts from north-west corner."
                },
                {
                    "name": "nwse-resize",
                    "description": "Indicates a bidirectional north-west/south-east cursor."
                },
                {
                    "name": "pointer",
                    "description": "The cursor is a pointer that indicates a link."
                },
                {
                    "name": "progress",
                    "description": "A progress indicator. The program is performing some processing, but is different from 'wait' in that the user may still interact with the program. Often rendered as a spinning beach ball, or an arrow with a watch or hourglass."
                },
                {
                    "name": "row-resize",
                    "description": "Indicates that the item/row can be resized vertically. Often rendered as arrows pointing up and down with a horizontal bar separating them."
                },
                {
                    "name": "se-resize",
                    "description": "Indicates that movement starts from south-east corner."
                },
                {
                    "name": "s-resize",
                    "description": "Indicates that south edge is to be moved."
                },
                {
                    "name": "sw-resize",
                    "description": "Indicates that movement starts from south-west corner."
                },
                {
                    "name": "text",
                    "description": "Indicates text that may be selected. Often rendered as a vertical I-beam."
                },
                {
                    "name": "vertical-text",
                    "description": "Indicates vertical-text that may be selected. Often rendered as a horizontal I-beam."
                },
                {
                    "name": "wait",
                    "description": "Indicates that the program is busy and the user should wait. Often rendered as a watch or hourglass."
                },
                {
                    "name": "-webkit-grab",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA95",
                        "S1.2",
                        "SM13.4",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Indicates that something can be grabbed."
                },
                {
                    "name": "-webkit-grabbing",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA95",
                        "S1.2",
                        "SM13.4",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Indicates that something is being grabbed."
                },
                {
                    "name": "-webkit-zoom-in",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA95",
                        "S1.2",
                        "SM13.4",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Indicates that something can be zoomed (magnified) in."
                },
                {
                    "name": "-webkit-zoom-out",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA95",
                        "S1.2",
                        "SM13.4",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Indicates that something can be zoomed (magnified) out."
                },
                {
                    "name": "w-resize",
                    "description": "Indicates that west edge is to be moved."
                },
                {
                    "name": "zoom-in",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA95",
                        "S1.2",
                        "SM13.4",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Indicates that something can be zoomed (magnified) in."
                },
                {
                    "name": "zoom-out",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA95",
                        "S1.2",
                        "SM13.4",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Indicates that something can be zoomed (magnified) out."
                }
            ],
            "syntax": "[ [ <url> [ <x> <y> ]? , ]* [ auto | default | none | context-menu | help | pointer | progress | wait | cell | crosshair | text | vertical-text | alias | copy | move | no-drop | not-allowed | e-resize | n-resize | ne-resize | nw-resize | s-resize | se-resize | sw-resize | w-resize | ew-resize | ns-resize | nesw-resize | nwse-resize | col-resize | row-resize | all-scroll | zoom-in | zoom-out | grab | grabbing ] ]",
            "relevance": 91,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/cursor"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-12-07",
                "baseline_high_date": "2024-06-07"
            },
            "description": "Allows control over cursor appearance in an element",
            "restrictions": [
                "url",
                "number",
                "enum"
            ]
        },
        {
            "name": "direction",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C2",
                "CA18",
                "IE5.5",
                "O9.2"
            ],
            "values": [
                {
                    "name": "ltr",
                    "description": "Left-to-right direction."
                },
                {
                    "name": "rtl",
                    "description": "Right-to-left direction."
                }
            ],
            "syntax": "ltr | rtl",
            "relevance": 72,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/direction"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies the inline base direction or directionality of any bidi paragraph, embedding, isolate, or override established by the box. Note: for HTML content use the 'dir' attribute and 'bdo' element rather than this property.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "display",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O7"
            ],
            "values": [
                {
                    "name": "block",
                    "description": "The element generates a block-level box"
                },
                {
                    "name": "contents",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "The element itself does not generate any boxes, but its children and pseudo-elements still generate boxes as normal."
                },
                {
                    "name": "flex",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "The element generates a principal flex container box and establishes a flex formatting context."
                },
                {
                    "name": "flexbox",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "The element lays out its contents using flow layout (block-and-inline layout). Standardized as 'flex'."
                },
                {
                    "name": "flow-root",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "The element generates a block container box, and lays out its contents using flow layout."
                },
                {
                    "name": "grid",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "The element generates a principal grid container box, and establishes a grid formatting context."
                },
                {
                    "name": "inline",
                    "description": "The element generates an inline-level box."
                },
                {
                    "name": "inline-block",
                    "description": "A block box, which itself is flowed as a single inline box, similar to a replaced element. The inside of an inline-block is formatted as a block box, and the box itself is formatted as an inline box."
                },
                {
                    "name": "inline-flex",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Inline-level flex container."
                },
                {
                    "name": "inline-flexbox",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Inline-level flex container. Standardized as 'inline-flex'"
                },
                {
                    "name": "inline-table",
                    "description": "Inline-level table wrapper box containing table box."
                },
                {
                    "name": "list-item",
                    "description": "One or more block boxes and one marker box."
                },
                {
                    "name": "-moz-box",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "The element lays out its contents using flow layout (block-and-inline layout). Standardized as 'flex'."
                },
                {
                    "name": "-moz-deck",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ]
                },
                {
                    "name": "-moz-grid",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ]
                },
                {
                    "name": "-moz-grid-group",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ]
                },
                {
                    "name": "-moz-grid-line",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ]
                },
                {
                    "name": "-moz-groupbox",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ]
                },
                {
                    "name": "-moz-inline-box",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Inline-level flex container. Standardized as 'inline-flex'"
                },
                {
                    "name": "-moz-inline-grid",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ]
                },
                {
                    "name": "-moz-inline-stack",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ]
                },
                {
                    "name": "-moz-marker",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ]
                },
                {
                    "name": "-moz-popup",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ]
                },
                {
                    "name": "-moz-stack",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ]
                },
                {
                    "name": "-ms-flexbox",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "The element lays out its contents using flow layout (block-and-inline layout). Standardized as 'flex'."
                },
                {
                    "name": "-ms-grid",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "The element generates a principal grid container box, and establishes a grid formatting context."
                },
                {
                    "name": "-ms-inline-flexbox",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Inline-level flex container. Standardized as 'inline-flex'"
                },
                {
                    "name": "-ms-inline-grid",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Inline-level grid container."
                },
                {
                    "name": "none",
                    "description": "The element and its descendants generates no boxes."
                },
                {
                    "name": "ruby",
                    "description": "The element generates a principal ruby container box, and establishes a ruby formatting context."
                },
                {
                    "name": "ruby-base"
                },
                {
                    "name": "ruby-base-container"
                },
                {
                    "name": "ruby-text"
                },
                {
                    "name": "ruby-text-container"
                },
                {
                    "name": "run-in",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "The element generates a run-in box. Run-in elements act like inlines or blocks, depending on the surrounding elements."
                },
                {
                    "name": "table",
                    "description": "The element generates a principal table wrapper box containing an additionally-generated table box, and establishes a table formatting context."
                },
                {
                    "name": "table-caption"
                },
                {
                    "name": "table-cell"
                },
                {
                    "name": "table-column"
                },
                {
                    "name": "table-column-group"
                },
                {
                    "name": "table-footer-group"
                },
                {
                    "name": "table-header-group"
                },
                {
                    "name": "table-row"
                },
                {
                    "name": "table-row-group"
                },
                {
                    "name": "-webkit-box",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "The element lays out its contents using flow layout (block-and-inline layout). Standardized as 'flex'."
                },
                {
                    "name": "-webkit-flex",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "The element lays out its contents using flow layout (block-and-inline layout)."
                },
                {
                    "name": "-webkit-inline-box",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Inline-level flex container. Standardized as 'inline-flex'"
                },
                {
                    "name": "-webkit-inline-flex",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Inline-level flex container."
                }
            ],
            "syntax": "[ <display-outside> || <display-inside> ] | <display-listitem> | <display-internal> | <display-box> | <display-legacy>",
            "relevance": 95,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/display"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "In combination with 'float' and 'position', determines the type of box or boxes that are generated for an element.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "empty-cells",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1.2",
                "SM1",
                "C1",
                "CA18",
                "IE8",
                "O4"
            ],
            "values": [
                {
                    "name": "hide",
                    "description": "No borders or backgrounds are drawn around/behind empty cells."
                },
                {
                    "name": "-moz-show-background",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1.2",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE8",
                        "O4"
                    ]
                },
                {
                    "name": "show",
                    "description": "Borders and backgrounds are drawn around/behind empty cells (like normal cells)."
                }
            ],
            "syntax": "show | hide",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/empty-cells"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "In the separated borders model, this property controls the rendering of borders and backgrounds around cells that have no visible content.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "enable-background",
            "values": [
                {
                    "name": "accumulate",
                    "description": "If the ancestor container element has a property of new, then all graphics elements within the current container are rendered both on the parent's background image and onto the target."
                },
                {
                    "name": "new",
                    "description": "Create a new background image canvas. All children of the current container element can access the background, and they will be rendered onto both the parent's background image canvas in addition to the target device."
                }
            ],
            "relevance": 50,
            "description": "Deprecated. Use 'isolation' property instead when support allows. Specifies how the accumulation of the background image is managed.",
            "restrictions": [
                "integer",
                "length",
                "percentage",
                "enum"
            ]
        },
        {
            "name": "fallback",
            "browsers": [
                "FF33"
            ],
            "atRule": "@counter-style",
            "syntax": "<counter-style-name>",
            "relevance": 50,
            "description": "@counter-style descriptor. Specifies a fallback counter style to be used when the current counter style can't create a representation for a given counter value.",
            "restrictions": [
                "identifier"
            ]
        },
        {
            "name": "fill",
            "browsers": [
                "E15",
                "FF3",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "url()",
                    "description": "A URL reference to a paint server element, which is an element that defines a paint server: 'hatch', 'linearGradient', 'mesh', 'pattern', 'radialGradient' and 'solidcolor'."
                },
                {
                    "name": "none",
                    "description": "No paint is applied in this layer."
                }
            ],
            "syntax": "<paint>",
            "relevance": 80,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/fill"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Paints the interior of the given graphical element.",
            "restrictions": [
                "color",
                "enum",
                "url"
            ]
        },
        {
            "name": "fill-opacity",
            "browsers": [
                "E15",
                "FF1",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "syntax": "<'opacity'>",
            "relevance": 55,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/fill-opacity"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Specifies the opacity of the painting operation used to paint the interior the current object.",
            "restrictions": [
                "number(0-1)"
            ]
        },
        {
            "name": "fill-rule",
            "browsers": [
                "E15",
                "FF3",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "evenodd",
                    "description": "Determines the 'insideness' of a point on the canvas by drawing a ray from that point to infinity in any direction and counting the number of path segments from the given shape that the ray crosses."
                },
                {
                    "name": "nonzero",
                    "description": "Determines the 'insideness' of a point on the canvas by drawing a ray from that point to infinity in any direction and then examining the places where a segment of the shape crosses the ray."
                }
            ],
            "syntax": "nonzero | evenodd",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/fill-rule"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Indicates the algorithm (or winding rule) which is to be used to determine what parts of the canvas are included inside the shape.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "filter",
            "browsers": [
                "E12",
                "FF35",
                "FFA35",
                "S9.1",
                "SM9.3",
                "C53",
                "CA53",
                "O40"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No filter effects are applied."
                },
                {
                    "name": "blur()",
                    "description": "Applies a Gaussian blur to the input image."
                },
                {
                    "name": "brightness()",
                    "description": "Applies a linear multiplier to input image, making it appear more or less bright."
                },
                {
                    "name": "contrast()",
                    "description": "Adjusts the contrast of the input."
                },
                {
                    "name": "drop-shadow()",
                    "description": "Applies a drop shadow effect to the input image."
                },
                {
                    "name": "grayscale()",
                    "description": "Converts the input image to grayscale."
                },
                {
                    "name": "hue-rotate()",
                    "description": "Applies a hue rotation on the input image. "
                },
                {
                    "name": "invert()",
                    "description": "Inverts the samples in the input image."
                },
                {
                    "name": "opacity()",
                    "description": "Applies transparency to the samples in the input image."
                },
                {
                    "name": "saturate()",
                    "description": "Saturates the input image."
                },
                {
                    "name": "sepia()",
                    "description": "Converts the input image to sepia."
                },
                {
                    "name": "url()",
                    "browsers": [
                        "E12",
                        "FF35",
                        "FFA35",
                        "S9.1",
                        "SM9.3",
                        "C53",
                        "CA53",
                        "O40"
                    ],
                    "description": "A filter reference to a <filter> element."
                }
            ],
            "syntax": "none | <filter-value-list>",
            "relevance": 73,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/filter"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2016-09-07",
                "baseline_high_date": "2019-03-07"
            },
            "description": "Processes an element's rendering before it is displayed in the document, by applying one or more filter effects.",
            "restrictions": [
                "enum",
                "url"
            ]
        },
        {
            "name": "flex",
            "browsers": [
                "E12",
                "FF20",
                "FFA20",
                "S9",
                "SM9",
                "C29",
                "CA29",
                "IE11",
                "O12.1"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Retrieves the value of the main size property as the used 'flex-basis'."
                },
                {
                    "name": "content",
                    "browsers": [
                        "E12",
                        "FF20",
                        "FFA20",
                        "S9",
                        "SM9",
                        "C29",
                        "CA29",
                        "IE11",
                        "O12.1"
                    ],
                    "description": "Indicates automatic sizing, based on the flex item's content."
                },
                {
                    "name": "none",
                    "description": "Expands to '0 0 auto'."
                }
            ],
            "syntax": "none | [ <'flex-grow'> <'flex-shrink'>? || <'flex-basis'> ]",
            "relevance": 82,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/flex"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Specifies the components of a flexible length: the flex grow factor and flex shrink factor, and the flex basis.",
            "restrictions": [
                "length",
                "number",
                "percentage"
            ]
        },
        {
            "name": "flex-basis",
            "browsers": [
                "E12",
                "FF22",
                "FFA22",
                "S9",
                "SM9",
                "C29",
                "CA29",
                "IE11",
                "O12.1"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Retrieves the value of the main size property as the used 'flex-basis'."
                },
                {
                    "name": "content",
                    "browsers": [
                        "E12",
                        "FF22",
                        "FFA22",
                        "S9",
                        "SM9",
                        "C29",
                        "CA29",
                        "IE11",
                        "O12.1"
                    ],
                    "description": "Indicates automatic sizing, based on the flex item's content."
                }
            ],
            "syntax": "content | <'width'>",
            "relevance": 70,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/flex-basis"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Sets the flex basis.",
            "restrictions": [
                "length",
                "number",
                "percentage"
            ]
        },
        {
            "name": "flex-direction",
            "browsers": [
                "E12",
                "FF20",
                "FFA20",
                "S9",
                "SM9",
                "C29",
                "CA29",
                "IE11",
                "O12.1"
            ],
            "values": [
                {
                    "name": "column",
                    "description": "The flex container's main axis has the same orientation as the block axis of the current writing mode."
                },
                {
                    "name": "column-reverse",
                    "description": "Same as 'column', except the main-start and main-end directions are swapped."
                },
                {
                    "name": "row",
                    "description": "The flex container's main axis has the same orientation as the inline axis of the current writing mode."
                },
                {
                    "name": "row-reverse",
                    "description": "Same as 'row', except the main-start and main-end directions are swapped."
                }
            ],
            "syntax": "row | row-reverse | column | column-reverse",
            "relevance": 86,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/flex-direction"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Specifies how flex items are placed in the flex container, by setting the direction of the flex container's main axis.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "flex-flow",
            "browsers": [
                "E12",
                "FF28",
                "FFA28",
                "S9",
                "SM9",
                "C29",
                "CA29",
                "IE11",
                "O12.1"
            ],
            "values": [
                {
                    "name": "column",
                    "description": "The flex container's main axis has the same orientation as the block axis of the current writing mode."
                },
                {
                    "name": "column-reverse",
                    "description": "Same as 'column', except the main-start and main-end directions are swapped."
                },
                {
                    "name": "nowrap",
                    "description": "The flex container is single-line."
                },
                {
                    "name": "row",
                    "description": "The flex container's main axis has the same orientation as the inline axis of the current writing mode."
                },
                {
                    "name": "row-reverse",
                    "description": "Same as 'row', except the main-start and main-end directions are swapped."
                },
                {
                    "name": "wrap",
                    "description": "The flexbox is multi-line."
                },
                {
                    "name": "wrap-reverse",
                    "description": "Same as 'wrap', except the cross-start and cross-end directions are swapped."
                }
            ],
            "syntax": "<'flex-direction'> || <'flex-wrap'>",
            "relevance": 64,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/flex-flow"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Specifies how flexbox items are placed in the flexbox.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "flex-grow",
            "browsers": [
                "E12",
                "FF20",
                "FFA20",
                "S9",
                "SM9",
                "C29",
                "CA29",
                "IE11",
                "O12.1"
            ],
            "syntax": "<number>",
            "relevance": 78,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/flex-grow"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Sets the flex grow factor. Negative numbers are invalid.",
            "restrictions": [
                "number"
            ]
        },
        {
            "name": "flex-shrink",
            "browsers": [
                "E12",
                "FF20",
                "FFA20",
                "S9",
                "SM9",
                "C29",
                "CA29",
                "IE10",
                "O12.1"
            ],
            "syntax": "<number>",
            "relevance": 78,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/flex-shrink"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Sets the flex shrink factor. Negative numbers are invalid.",
            "restrictions": [
                "number"
            ]
        },
        {
            "name": "flex-wrap",
            "browsers": [
                "E12",
                "FF28",
                "FFA28",
                "S9",
                "SM9",
                "C29",
                "CA29",
                "IE11",
                "O16"
            ],
            "values": [
                {
                    "name": "nowrap",
                    "description": "The flex container is single-line."
                },
                {
                    "name": "wrap",
                    "description": "The flexbox is multi-line."
                },
                {
                    "name": "wrap-reverse",
                    "description": "Same as 'wrap', except the cross-start and cross-end directions are swapped."
                }
            ],
            "syntax": "nowrap | wrap | wrap-reverse",
            "relevance": 83,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/flex-wrap"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Controls whether the flex container is single-line or multi-line, and the direction of the cross-axis, which determines the direction new lines are stacked in.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "float",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O7"
            ],
            "values": [
                {
                    "name": "inline-end",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "A keyword indicating that the element must float on the end side of its containing block. That is the right side with ltr scripts, and the left side with rtl scripts."
                },
                {
                    "name": "inline-start",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "A keyword indicating that the element must float on the start side of its containing block. That is the left side with ltr scripts, and the right side with rtl scripts."
                },
                {
                    "name": "left",
                    "description": "The element generates a block box that is floated to the left. Content flows on the right side of the box, starting at the top (subject to the 'clear' property)."
                },
                {
                    "name": "none",
                    "description": "The box is not floated."
                },
                {
                    "name": "right",
                    "description": "Similar to 'left', except the box is floated to the right, and content flows on the left side of the box, starting at the top."
                }
            ],
            "syntax": "left | right | none | inline-start | inline-end",
            "relevance": 87,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/float"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies how a box should be floated. It may be set for any element, but only applies to elements that generate boxes that are not absolutely positioned.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "flood-color",
            "browsers": [
                "E12",
                "FF3",
                "FFA4",
                "S6",
                "SM6",
                "C5",
                "CA18",
                "IE11",
                "O15"
            ],
            "syntax": "<color>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/flood-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Indicates what color to use to flood the current filter primitive subregion.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "flood-opacity",
            "browsers": [
                "E12",
                "FF3",
                "FFA4",
                "S6",
                "SM6",
                "C5",
                "CA18",
                "IE11",
                "O15"
            ],
            "syntax": "<'opacity'>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/flood-opacity"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Indicates what opacity to use to flood the current filter primitive subregion.",
            "restrictions": [
                "number(0-1)",
                "percentage"
            ]
        },
        {
            "name": "font",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE3",
                "O3.5"
            ],
            "values": [
                {
                    "name": "100",
                    "description": "Thin"
                },
                {
                    "name": "200",
                    "description": "Extra Light (Ultra Light)"
                },
                {
                    "name": "300",
                    "description": "Light"
                },
                {
                    "name": "400",
                    "description": "Normal"
                },
                {
                    "name": "500",
                    "description": "Medium"
                },
                {
                    "name": "600",
                    "description": "Semi Bold (Demi Bold)"
                },
                {
                    "name": "700",
                    "description": "Bold"
                },
                {
                    "name": "800",
                    "description": "Extra Bold (Ultra Bold)"
                },
                {
                    "name": "900",
                    "description": "Black (Heavy)"
                },
                {
                    "name": "bold",
                    "description": "Same as 700"
                },
                {
                    "name": "bolder",
                    "description": "Specifies the weight of the face bolder than the inherited value."
                },
                {
                    "name": "caption",
                    "description": "The font used for captioned controls (e.g., buttons, drop-downs, etc.)."
                },
                {
                    "name": "icon",
                    "description": "The font used to label icons."
                },
                {
                    "name": "italic",
                    "description": "Selects a font that is labeled 'italic', or, if that is not available, one labeled 'oblique'."
                },
                {
                    "name": "large"
                },
                {
                    "name": "larger"
                },
                {
                    "name": "lighter",
                    "description": "Specifies the weight of the face lighter than the inherited value."
                },
                {
                    "name": "medium"
                },
                {
                    "name": "menu",
                    "description": "The font used in menus (e.g., dropdown menus and menu lists)."
                },
                {
                    "name": "message-box",
                    "description": "The font used in dialog boxes."
                },
                {
                    "name": "normal",
                    "description": "Specifies a face that is not labeled as a small-caps font."
                },
                {
                    "name": "oblique",
                    "description": "Selects a font that is labeled 'oblique'."
                },
                {
                    "name": "small"
                },
                {
                    "name": "small-caps",
                    "description": "Specifies a font that is labeled as a small-caps font. If a genuine small-caps font is not available, user agents should simulate a small-caps font."
                },
                {
                    "name": "small-caption",
                    "description": "The font used for labeling small controls."
                },
                {
                    "name": "smaller"
                },
                {
                    "name": "status-bar",
                    "description": "The font used in window status bars."
                },
                {
                    "name": "x-large"
                },
                {
                    "name": "x-small"
                },
                {
                    "name": "xx-large"
                },
                {
                    "name": "xx-small"
                }
            ],
            "syntax": "[ [ <'font-style'> || <font-variant-css21> || <'font-weight'> || <'font-stretch'> ]? <'font-size'> [ / <'line-height'> ]? <'font-family'> ] | caption | icon | menu | message-box | small-caption | status-bar",
            "relevance": 82,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property for setting 'font-style', 'font-variant', 'font-weight', 'font-size', 'line-height', and 'font-family', at the same place in the style sheet. The syntax of this property is based on a traditional typographical shorthand notation to set multiple properties related to fonts.",
            "restrictions": [
                "font"
            ]
        },
        {
            "name": "font-family",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE3",
                "O3.5"
            ],
            "values": [
                {
                    "name": "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"
                },
                {
                    "name": "Arial, Helvetica, sans-serif"
                },
                {
                    "name": "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
                },
                {
                    "name": "'Courier New', Courier, monospace"
                },
                {
                    "name": "cursive"
                },
                {
                    "name": "fantasy"
                },
                {
                    "name": "'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif"
                },
                {
                    "name": "Georgia, 'Times New Roman', Times, serif"
                },
                {
                    "name": "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif"
                },
                {
                    "name": "Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif"
                },
                {
                    "name": "'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif"
                },
                {
                    "name": "monospace"
                },
                {
                    "name": "sans-serif"
                },
                {
                    "name": "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
                },
                {
                    "name": "serif"
                },
                {
                    "name": "'Times New Roman', Times, serif"
                },
                {
                    "name": "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
                },
                {
                    "name": "Verdana, Geneva, Tahoma, sans-serif"
                }
            ],
            "atRule": "@font-palette-values",
            "syntax": "<family-name>#",
            "relevance": 93,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-family"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies a prioritized list of font family names or generic family names. A user agent iterates through the list of family names until it matches an available font that contains a glyph for the character to be rendered.",
            "restrictions": [
                "font"
            ]
        },
        {
            "name": "font-feature-settings",
            "browsers": [
                "E15",
                "FF34",
                "FFA34",
                "S9.1",
                "SM9.3",
                "C48",
                "CA48",
                "IE10",
                "O35"
            ],
            "values": [
                {
                    "name": "\"aalt\"",
                    "description": "Access All Alternates."
                },
                {
                    "name": "\"abvf\"",
                    "description": "Above-base Forms. Required in Khmer script."
                },
                {
                    "name": "\"abvm\"",
                    "description": "Above-base Mark Positioning. Required in Indic scripts."
                },
                {
                    "name": "\"abvs\"",
                    "description": "Above-base Substitutions. Required in Indic scripts."
                },
                {
                    "name": "\"afrc\"",
                    "description": "Alternative Fractions."
                },
                {
                    "name": "\"akhn\"",
                    "description": "Akhand. Required in most Indic scripts."
                },
                {
                    "name": "\"blwf\"",
                    "description": "Below-base Form. Required in a number of Indic scripts."
                },
                {
                    "name": "\"blwm\"",
                    "description": "Below-base Mark Positioning. Required in Indic scripts."
                },
                {
                    "name": "\"blws\"",
                    "description": "Below-base Substitutions. Required in Indic scripts."
                },
                {
                    "name": "\"calt\"",
                    "description": "Contextual Alternates."
                },
                {
                    "name": "\"case\"",
                    "description": "Case-Sensitive Forms. Applies only to European scripts; particularly prominent in Spanish-language setting."
                },
                {
                    "name": "\"ccmp\"",
                    "description": "Glyph Composition/Decomposition."
                },
                {
                    "name": "\"cfar\"",
                    "description": "Conjunct Form After Ro. Required in Khmer scripts."
                },
                {
                    "name": "\"cjct\"",
                    "description": "Conjunct Forms. Required in Indic scripts that show similarity to Devanagari."
                },
                {
                    "name": "\"clig\"",
                    "description": "Contextual Ligatures."
                },
                {
                    "name": "\"cpct\"",
                    "description": "Centered CJK Punctuation. Used primarily in Chinese fonts."
                },
                {
                    "name": "\"cpsp\"",
                    "description": "Capital Spacing. Should not be used in connecting scripts (e.g. most Arabic)."
                },
                {
                    "name": "\"cswh\"",
                    "description": "Contextual Swash."
                },
                {
                    "name": "\"curs\"",
                    "description": "Cursive Positioning. Can be used in any cursive script."
                },
                {
                    "name": "\"c2pc\"",
                    "description": "Petite Capitals From Capitals. Applies only to bicameral scripts."
                },
                {
                    "name": "\"c2sc\"",
                    "description": "Small Capitals From Capitals. Applies only to bicameral scripts."
                },
                {
                    "name": "\"dist\"",
                    "description": "Distances. Required in Indic scripts."
                },
                {
                    "name": "\"dlig\"",
                    "description": "Discretionary ligatures."
                },
                {
                    "name": "\"dnom\"",
                    "description": "Denominators."
                },
                {
                    "name": "\"dtls\"",
                    "description": "Dotless Forms. Applied to math formula layout."
                },
                {
                    "name": "\"expt\"",
                    "description": "Expert Forms. Applies only to Japanese."
                },
                {
                    "name": "\"falt\"",
                    "description": "Final Glyph on Line Alternates. Can be used in any cursive script."
                },
                {
                    "name": "\"fin2\"",
                    "description": "Terminal Form #2. Used only with the Syriac script."
                },
                {
                    "name": "\"fin3\"",
                    "description": "Terminal Form #3. Used only with the Syriac script."
                },
                {
                    "name": "\"fina\"",
                    "description": "Terminal Forms. Can be used in any alphabetic script."
                },
                {
                    "name": "\"flac\"",
                    "description": "Flattened ascent forms. Applied to math formula layout."
                },
                {
                    "name": "\"frac\"",
                    "description": "Fractions."
                },
                {
                    "name": "\"fwid\"",
                    "description": "Full Widths. Applies to any script which can use monospaced forms."
                },
                {
                    "name": "\"half\"",
                    "description": "Half Forms. Required in Indic scripts that show similarity to Devanagari."
                },
                {
                    "name": "\"haln\"",
                    "description": "Halant Forms. Required in Indic scripts."
                },
                {
                    "name": "\"halt\"",
                    "description": "Alternate Half Widths. Used only in CJKV fonts."
                },
                {
                    "name": "\"hist\"",
                    "description": "Historical Forms."
                },
                {
                    "name": "\"hkna\"",
                    "description": "Horizontal Kana Alternates. Applies only to fonts that support kana (hiragana and katakana)."
                },
                {
                    "name": "\"hlig\"",
                    "description": "Historical Ligatures."
                },
                {
                    "name": "\"hngl\"",
                    "description": "Hangul. Korean only."
                },
                {
                    "name": "\"hojo\"",
                    "description": "Hojo Kanji Forms (JIS X 0212-1990 Kanji Forms). Used only with Kanji script."
                },
                {
                    "name": "\"hwid\"",
                    "description": "Half Widths. Generally used only in CJKV fonts."
                },
                {
                    "name": "\"init\"",
                    "description": "Initial Forms. Can be used in any alphabetic script."
                },
                {
                    "name": "\"isol\"",
                    "description": "Isolated Forms. Can be used in any cursive script."
                },
                {
                    "name": "\"ital\"",
                    "description": "Italics. Applies mostly to Latin; note that many non-Latin fonts contain Latin as well."
                },
                {
                    "name": "\"jalt\"",
                    "description": "Justification Alternates. Can be used in any cursive script."
                },
                {
                    "name": "\"jp78\"",
                    "description": "JIS78 Forms. Applies only to Japanese."
                },
                {
                    "name": "\"jp83\"",
                    "description": "JIS83 Forms. Applies only to Japanese."
                },
                {
                    "name": "\"jp90\"",
                    "description": "JIS90 Forms. Applies only to Japanese."
                },
                {
                    "name": "\"jp04\"",
                    "description": "JIS2004 Forms. Applies only to Japanese."
                },
                {
                    "name": "\"kern\"",
                    "description": "Kerning."
                },
                {
                    "name": "\"lfbd\"",
                    "description": "Left Bounds."
                },
                {
                    "name": "\"liga\"",
                    "description": "Standard Ligatures."
                },
                {
                    "name": "\"ljmo\"",
                    "description": "Leading Jamo Forms. Required for Hangul script when Ancient Hangul writing system is supported."
                },
                {
                    "name": "\"lnum\"",
                    "description": "Lining Figures."
                },
                {
                    "name": "\"locl\"",
                    "description": "Localized Forms."
                },
                {
                    "name": "\"ltra\"",
                    "description": "Left-to-right glyph alternates."
                },
                {
                    "name": "\"ltrm\"",
                    "description": "Left-to-right mirrored forms."
                },
                {
                    "name": "\"mark\"",
                    "description": "Mark Positioning."
                },
                {
                    "name": "\"med2\"",
                    "description": "Medial Form #2. Used only with the Syriac script."
                },
                {
                    "name": "\"medi\"",
                    "description": "Medial Forms."
                },
                {
                    "name": "\"mgrk\"",
                    "description": "Mathematical Greek."
                },
                {
                    "name": "\"mkmk\"",
                    "description": "Mark to Mark Positioning."
                },
                {
                    "name": "\"nalt\"",
                    "description": "Alternate Annotation Forms."
                },
                {
                    "name": "\"nlck\"",
                    "description": "NLC Kanji Forms. Used only with Kanji script."
                },
                {
                    "name": "\"nukt\"",
                    "description": "Nukta Forms. Required in Indic scripts.."
                },
                {
                    "name": "\"numr\"",
                    "description": "Numerators."
                },
                {
                    "name": "\"onum\"",
                    "description": "Oldstyle Figures."
                },
                {
                    "name": "\"opbd\"",
                    "description": "Optical Bounds."
                },
                {
                    "name": "\"ordn\"",
                    "description": "Ordinals. Applies mostly to Latin script."
                },
                {
                    "name": "\"ornm\"",
                    "description": "Ornaments."
                },
                {
                    "name": "\"palt\"",
                    "description": "Proportional Alternate Widths. Used mostly in CJKV fonts."
                },
                {
                    "name": "\"pcap\"",
                    "description": "Petite Capitals."
                },
                {
                    "name": "\"pkna\"",
                    "description": "Proportional Kana. Generally used only in Japanese fonts."
                },
                {
                    "name": "\"pnum\"",
                    "description": "Proportional Figures."
                },
                {
                    "name": "\"pref\"",
                    "description": "Pre-base Forms. Required in Khmer and Myanmar (Burmese) scripts and southern Indic scripts that may display a pre-base form of Ra."
                },
                {
                    "name": "\"pres\"",
                    "description": "Pre-base Substitutions. Required in Indic scripts."
                },
                {
                    "name": "\"pstf\"",
                    "description": "Post-base Forms. Required in scripts of south and southeast Asia that have post-base forms for consonants eg: Gurmukhi, Malayalam, Khmer."
                },
                {
                    "name": "\"psts\"",
                    "description": "Post-base Substitutions."
                },
                {
                    "name": "\"pwid\"",
                    "description": "Proportional Widths."
                },
                {
                    "name": "\"qwid\"",
                    "description": "Quarter Widths. Generally used only in CJKV fonts."
                },
                {
                    "name": "\"rand\"",
                    "description": "Randomize."
                },
                {
                    "name": "\"rclt\"",
                    "description": "Required Contextual Alternates. May apply to any script, but is especially important for many styles of Arabic."
                },
                {
                    "name": "\"rlig\"",
                    "description": "Required Ligatures. Applies to Arabic and Syriac. May apply to some other scripts."
                },
                {
                    "name": "\"rkrf\"",
                    "description": "Rakar Forms. Required in Devanagari and Gujarati scripts."
                },
                {
                    "name": "\"rphf\"",
                    "description": "Reph Form. Required in Indic scripts. E.g. Devanagari, Kannada."
                },
                {
                    "name": "\"rtbd\"",
                    "description": "Right Bounds."
                },
                {
                    "name": "\"rtla\"",
                    "description": "Right-to-left alternates."
                },
                {
                    "name": "\"rtlm\"",
                    "description": "Right-to-left mirrored forms."
                },
                {
                    "name": "\"ruby\"",
                    "description": "Ruby Notation Forms. Applies only to Japanese."
                },
                {
                    "name": "\"salt\"",
                    "description": "Stylistic Alternates."
                },
                {
                    "name": "\"sinf\"",
                    "description": "Scientific Inferiors."
                },
                {
                    "name": "\"size\"",
                    "description": "Optical size."
                },
                {
                    "name": "\"smcp\"",
                    "description": "Small Capitals. Applies only to bicameral scripts."
                },
                {
                    "name": "\"smpl\"",
                    "description": "Simplified Forms. Applies only to Chinese and Japanese."
                },
                {
                    "name": "\"ssty\"",
                    "description": "Math script style alternates."
                },
                {
                    "name": "\"stch\"",
                    "description": "Stretching Glyph Decomposition."
                },
                {
                    "name": "\"subs\"",
                    "description": "Subscript."
                },
                {
                    "name": "\"sups\"",
                    "description": "Superscript."
                },
                {
                    "name": "\"swsh\"",
                    "description": "Swash. Does not apply to ideographic scripts."
                },
                {
                    "name": "\"titl\"",
                    "description": "Titling."
                },
                {
                    "name": "\"tjmo\"",
                    "description": "Trailing Jamo Forms. Required for Hangul script when Ancient Hangul writing system is supported."
                },
                {
                    "name": "\"tnam\"",
                    "description": "Traditional Name Forms. Applies only to Japanese."
                },
                {
                    "name": "\"tnum\"",
                    "description": "Tabular Figures."
                },
                {
                    "name": "\"trad\"",
                    "description": "Traditional Forms. Applies only to Chinese and Japanese."
                },
                {
                    "name": "\"twid\"",
                    "description": "Third Widths. Generally used only in CJKV fonts."
                },
                {
                    "name": "\"unic\"",
                    "description": "Unicase."
                },
                {
                    "name": "\"valt\"",
                    "description": "Alternate Vertical Metrics. Applies only to scripts with vertical writing modes."
                },
                {
                    "name": "\"vatu\"",
                    "description": "Vattu Variants. Used for Indic scripts. E.g. Devanagari."
                },
                {
                    "name": "\"vert\"",
                    "description": "Vertical Alternates. Applies only to scripts with vertical writing modes."
                },
                {
                    "name": "\"vhal\"",
                    "description": "Alternate Vertical Half Metrics. Used only in CJKV fonts."
                },
                {
                    "name": "\"vjmo\"",
                    "description": "Vowel Jamo Forms. Required for Hangul script when Ancient Hangul writing system is supported."
                },
                {
                    "name": "\"vkna\"",
                    "description": "Vertical Kana Alternates. Applies only to fonts that support kana (hiragana and katakana)."
                },
                {
                    "name": "\"vkrn\"",
                    "description": "Vertical Kerning."
                },
                {
                    "name": "\"vpal\"",
                    "description": "Proportional Alternate Vertical Metrics. Used mostly in CJKV fonts."
                },
                {
                    "name": "\"vrt2\"",
                    "description": "Vertical Alternates and Rotation. Applies only to scripts with vertical writing modes."
                },
                {
                    "name": "\"zero\"",
                    "description": "Slashed Zero."
                },
                {
                    "name": "normal",
                    "description": "No change in glyph substitution or positioning occurs."
                },
                {
                    "name": "off",
                    "description": "Disable feature."
                },
                {
                    "name": "on",
                    "description": "Enable feature."
                }
            ],
            "atRule": "@font-face",
            "syntax": "normal | <feature-tag-value>#",
            "relevance": 59,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-feature-settings"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Provides low-level control over OpenType font features. It is intended as a way of providing access to font features that are not widely used but are needed for a particular use case.",
            "restrictions": [
                "string",
                "integer"
            ]
        },
        {
            "name": "font-kerning",
            "browsers": [
                "E79",
                "FF32",
                "FFA32",
                "S9",
                "SM9",
                "C33",
                "CA33",
                "O20"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Specifies that kerning is applied at the discretion of the user agent."
                },
                {
                    "name": "none",
                    "description": "Specifies that kerning is not applied."
                },
                {
                    "name": "normal",
                    "description": "Specifies that kerning is applied."
                }
            ],
            "syntax": "auto | normal | none",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-kerning"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Kerning is the contextual adjustment of inter-glyph spacing. This property controls metric kerning, kerning that utilizes adjustment data contained in the font.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "font-language-override",
            "browsers": [
                "FF34",
                "FFA34"
            ],
            "values": [
                {
                    "name": "normal",
                    "description": "Implies that when rendering with OpenType fonts the language of the document is used to infer the OpenType language system, used to select language specific features when rendering."
                }
            ],
            "syntax": "normal | <string>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-language-override"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The value of 'normal' implies that when rendering with OpenType fonts the language of the document is used to infer the OpenType language system, used to select language specific features when rendering.",
            "restrictions": [
                "string"
            ]
        },
        {
            "name": "font-size",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE5.5",
                "O7"
            ],
            "values": [
                {
                    "name": "large"
                },
                {
                    "name": "larger"
                },
                {
                    "name": "medium"
                },
                {
                    "name": "small"
                },
                {
                    "name": "smaller"
                },
                {
                    "name": "x-large"
                },
                {
                    "name": "x-small"
                },
                {
                    "name": "xx-large"
                },
                {
                    "name": "xx-small"
                }
            ],
            "syntax": "<absolute-size> | <relative-size> | <length-percentage [0,\u221E]> | math",
            "relevance": 94,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-size"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Indicates the desired height of glyphs from the font. For scalable fonts, the font-size is a scale factor applied to the EM unit of the font. (Note that certain glyphs may bleed outside their EM box.) For non-scalable fonts, the font-size is converted into absolute units and matched against the declared font-size of the font, using the same absolute coordinate space for both of the matched values.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "font-size-adjust",
            "browsers": [
                "E127",
                "FF3",
                "FFA4",
                "S16.4",
                "SM16.4",
                "C127",
                "CA127",
                "O113"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "Do not preserve the font's x-height."
                }
            ],
            "syntax": "none | [ ex-height | cap-height | ch-width | ic-width | ic-height ]? [ from-font | <number> ]",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-size-adjust"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-07-25"
            },
            "description": "Preserves the readability of text when font fallback occurs by adjusting the font-size so that the x-height is the same regardless of the font used.",
            "restrictions": [
                "number"
            ]
        },
        {
            "name": "font-stretch",
            "browsers": [
                "E12",
                "FF9",
                "FFA9",
                "S11",
                "SM11",
                "C60",
                "CA60",
                "IE9",
                "O47"
            ],
            "values": [
                {
                    "name": "condensed"
                },
                {
                    "name": "expanded"
                },
                {
                    "name": "extra-condensed"
                },
                {
                    "name": "extra-expanded"
                },
                {
                    "name": "narrower",
                    "browsers": [
                        "E12",
                        "FF9",
                        "FFA9",
                        "S11",
                        "SM11",
                        "C60",
                        "CA60",
                        "IE9",
                        "O47"
                    ],
                    "description": "Indicates a narrower value relative to the width of the parent element."
                },
                {
                    "name": "normal"
                },
                {
                    "name": "semi-condensed"
                },
                {
                    "name": "semi-expanded"
                },
                {
                    "name": "ultra-condensed"
                },
                {
                    "name": "ultra-expanded"
                },
                {
                    "name": "wider",
                    "browsers": [
                        "E12",
                        "FF9",
                        "FFA9",
                        "S11",
                        "SM11",
                        "C60",
                        "CA60",
                        "IE9",
                        "O47"
                    ],
                    "description": "Indicates a wider value relative to the width of the parent element."
                }
            ],
            "atRule": "@font-face",
            "status": "obsolete",
            "syntax": "<font-stretch-absolute>{1,2}",
            "relevance": 10,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-stretch"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Selects a normal, condensed, or expanded face from a font family.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "font-style",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O7"
            ],
            "values": [
                {
                    "name": "italic",
                    "description": "Selects a font that is labeled as an 'italic' face, or an 'oblique' face if one is not"
                },
                {
                    "name": "normal",
                    "description": "Selects a face that is classified as 'normal'."
                },
                {
                    "name": "oblique",
                    "description": "Selects a font that is labeled as an 'oblique' face, or an 'italic' face if one is not."
                }
            ],
            "atRule": "@font-face",
            "syntax": "normal | italic | oblique <angle>{0,2}",
            "relevance": 89,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Allows italic or oblique faces to be selected. Italic forms are generally cursive in nature while oblique faces are typically sloped versions of the regular face.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "font-synthesis",
            "browsers": [
                "E97",
                "FF34",
                "FFA34",
                "S9",
                "SM9",
                "C97",
                "CA97",
                "O83"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "Disallow all synthetic faces."
                },
                {
                    "name": "style",
                    "description": "Allow synthetic italic faces."
                },
                {
                    "name": "weight",
                    "description": "Allow synthetic bold faces."
                }
            ],
            "syntax": "none | [ weight || style || small-caps || position]",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-synthesis"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-01-06",
                "baseline_high_date": "2024-07-06"
            },
            "description": "Controls whether user agents are allowed to synthesize bold or oblique font faces when a font family lacks bold or italic faces.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "font-variant",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "values": [
                {
                    "name": "normal",
                    "description": "Specifies a face that is not labeled as a small-caps font."
                },
                {
                    "name": "small-caps",
                    "description": "Specifies a font that is labeled as a small-caps font. If a genuine small-caps font is not available, user agents should simulate a small-caps font."
                }
            ],
            "syntax": "normal | none | [ <common-lig-values> || <discretionary-lig-values> || <historical-lig-values> || <contextual-alt-values> || stylistic( <feature-value-name> ) || historical-forms || styleset( <feature-value-name># ) || character-variant( <feature-value-name># ) || swash( <feature-value-name> ) || ornaments( <feature-value-name> ) || annotation( <feature-value-name> ) || [ small-caps | all-small-caps | petite-caps | all-petite-caps | unicase | titling-caps ] || <numeric-figure-values> || <numeric-spacing-values> || <numeric-fraction-values> || ordinal || slashed-zero || <east-asian-variant-values> || <east-asian-width-values> || ruby ]",
            "relevance": 64,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-variant"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies variant representations of the font",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "font-variant-alternates",
            "browsers": [
                "E111",
                "FF34",
                "FFA34",
                "S9.1",
                "SM9.3",
                "C111",
                "CA111",
                "O97"
            ],
            "values": [
                {
                    "name": "annotation()",
                    "description": "Enables display of alternate annotation forms."
                },
                {
                    "name": "character-variant()",
                    "description": "Enables display of specific character variants."
                },
                {
                    "name": "historical-forms",
                    "description": "Enables display of historical forms."
                },
                {
                    "name": "normal",
                    "description": "None of the features are enabled."
                },
                {
                    "name": "ornaments()",
                    "description": "Enables replacement of default glyphs with ornaments, if provided in the font."
                },
                {
                    "name": "styleset()",
                    "description": "Enables display with stylistic sets."
                },
                {
                    "name": "stylistic()",
                    "description": "Enables display of stylistic alternates."
                },
                {
                    "name": "swash()",
                    "description": "Enables display of swash glyphs."
                }
            ],
            "syntax": "normal | [ stylistic( <feature-value-name> ) || historical-forms || styleset( <feature-value-name># ) || character-variant( <feature-value-name># ) || swash( <feature-value-name> ) || ornaments( <feature-value-name> ) || annotation( <feature-value-name> ) ]",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-variant-alternates"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-03-13"
            },
            "description": "For any given character, fonts can provide a variety of alternate glyphs in addition to the default glyph for that character. This property provides control over the selection of these alternate glyphs.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "font-variant-caps",
            "browsers": [
                "E79",
                "FF34",
                "FFA34",
                "S9.1",
                "SM9.3",
                "C52",
                "CA52",
                "O39"
            ],
            "values": [
                {
                    "name": "all-petite-caps",
                    "description": "Enables display of petite capitals for both upper and lowercase letters."
                },
                {
                    "name": "all-small-caps",
                    "description": "Enables display of small capitals for both upper and lowercase letters."
                },
                {
                    "name": "normal",
                    "description": "None of the features are enabled."
                },
                {
                    "name": "petite-caps",
                    "description": "Enables display of petite capitals."
                },
                {
                    "name": "small-caps",
                    "description": "Enables display of small capitals. Small-caps glyphs typically use the form of uppercase letters but are reduced to the size of lowercase letters."
                },
                {
                    "name": "titling-caps",
                    "description": "Enables display of titling capitals."
                },
                {
                    "name": "unicase",
                    "description": "Enables display of mixture of small capitals for uppercase letters with normal lowercase letters."
                }
            ],
            "syntax": "normal | small-caps | all-small-caps | petite-caps | all-petite-caps | unicase | titling-caps",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-variant-caps"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Specifies control over capitalized forms.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "font-variant-east-asian",
            "browsers": [
                "E79",
                "FF34",
                "FFA34",
                "S9.1",
                "SM9.3",
                "C63",
                "CA63",
                "O50"
            ],
            "values": [
                {
                    "name": "full-width",
                    "description": "Enables rendering of full-width variants."
                },
                {
                    "name": "jis04",
                    "description": "Enables rendering of JIS04 forms."
                },
                {
                    "name": "jis78",
                    "description": "Enables rendering of JIS78 forms."
                },
                {
                    "name": "jis83",
                    "description": "Enables rendering of JIS83 forms."
                },
                {
                    "name": "jis90",
                    "description": "Enables rendering of JIS90 forms."
                },
                {
                    "name": "normal",
                    "description": "None of the features are enabled."
                },
                {
                    "name": "proportional-width",
                    "description": "Enables rendering of proportionally-spaced variants."
                },
                {
                    "name": "ruby",
                    "description": "Enables display of ruby variant glyphs."
                },
                {
                    "name": "simplified",
                    "description": "Enables rendering of simplified forms."
                },
                {
                    "name": "traditional",
                    "description": "Enables rendering of traditional forms."
                }
            ],
            "syntax": "normal | [ <east-asian-variant-values> || <east-asian-width-values> || ruby ]",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-variant-east-asian"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Allows control of glyph substitute and positioning in East Asian text.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "font-variant-ligatures",
            "browsers": [
                "E79",
                "FF34",
                "FFA34",
                "S9.1",
                "SM9.3",
                "C34",
                "CA34",
                "O21"
            ],
            "values": [
                {
                    "name": "additional-ligatures",
                    "description": "Enables display of additional ligatures."
                },
                {
                    "name": "common-ligatures",
                    "description": "Enables display of common ligatures."
                },
                {
                    "name": "contextual",
                    "browsers": [
                        "E79",
                        "FF34",
                        "FFA34",
                        "S9.1",
                        "SM9.3",
                        "C34",
                        "CA34",
                        "O21"
                    ],
                    "description": "Enables display of contextual alternates."
                },
                {
                    "name": "discretionary-ligatures",
                    "description": "Enables display of discretionary ligatures."
                },
                {
                    "name": "historical-ligatures",
                    "description": "Enables display of historical ligatures."
                },
                {
                    "name": "no-additional-ligatures",
                    "description": "Disables display of additional ligatures."
                },
                {
                    "name": "no-common-ligatures",
                    "description": "Disables display of common ligatures."
                },
                {
                    "name": "no-contextual",
                    "browsers": [
                        "E79",
                        "FF34",
                        "FFA34",
                        "S9.1",
                        "SM9.3",
                        "C34",
                        "CA34",
                        "O21"
                    ],
                    "description": "Disables display of contextual alternates."
                },
                {
                    "name": "no-discretionary-ligatures",
                    "description": "Disables display of discretionary ligatures."
                },
                {
                    "name": "no-historical-ligatures",
                    "description": "Disables display of historical ligatures."
                },
                {
                    "name": "none",
                    "browsers": [
                        "E79",
                        "FF34",
                        "FFA34",
                        "S9.1",
                        "SM9.3",
                        "C34",
                        "CA34",
                        "O21"
                    ],
                    "description": "Disables all ligatures."
                },
                {
                    "name": "normal",
                    "description": "Implies that the defaults set by the font are used."
                }
            ],
            "syntax": "normal | none | [ <common-lig-values> || <discretionary-lig-values> || <historical-lig-values> || <contextual-alt-values> ]",
            "relevance": 52,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-variant-ligatures"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Specifies control over which ligatures are enabled or disabled. A value of 'normal' implies that the defaults set by the font are used.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "font-variant-numeric",
            "browsers": [
                "E79",
                "FF34",
                "FFA34",
                "S9.1",
                "SM9.3",
                "C52",
                "CA52",
                "O39"
            ],
            "values": [
                {
                    "name": "diagonal-fractions",
                    "description": "Enables display of lining diagonal fractions."
                },
                {
                    "name": "lining-nums",
                    "description": "Enables display of lining numerals."
                },
                {
                    "name": "normal",
                    "description": "None of the features are enabled."
                },
                {
                    "name": "oldstyle-nums",
                    "description": "Enables display of old-style numerals."
                },
                {
                    "name": "ordinal",
                    "description": "Enables display of letter forms used with ordinal numbers."
                },
                {
                    "name": "proportional-nums",
                    "description": "Enables display of proportional numerals."
                },
                {
                    "name": "slashed-zero",
                    "description": "Enables display of slashed zeros."
                },
                {
                    "name": "stacked-fractions",
                    "description": "Enables display of lining stacked fractions."
                },
                {
                    "name": "tabular-nums",
                    "description": "Enables display of tabular numerals."
                }
            ],
            "syntax": "normal | [ <numeric-figure-values> || <numeric-spacing-values> || <numeric-fraction-values> || ordinal || slashed-zero ]",
            "relevance": 52,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-variant-numeric"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Specifies control over numerical forms.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "font-variant-position",
            "browsers": [
                "FF34",
                "FFA34",
                "S9.1",
                "SM9.3"
            ],
            "values": [
                {
                    "name": "normal",
                    "description": "None of the features are enabled."
                },
                {
                    "name": "sub",
                    "description": "Enables display of subscript variants (OpenType feature: subs)."
                },
                {
                    "name": "super",
                    "description": "Enables display of superscript variants (OpenType feature: sups)."
                }
            ],
            "syntax": "normal | sub | super",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-variant-position"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Specifies the vertical position",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "font-weight",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C2",
                "CA18",
                "IE3",
                "O3.5"
            ],
            "values": [
                {
                    "name": "100",
                    "description": "Thin"
                },
                {
                    "name": "200",
                    "description": "Extra Light (Ultra Light)"
                },
                {
                    "name": "300",
                    "description": "Light"
                },
                {
                    "name": "400",
                    "description": "Normal"
                },
                {
                    "name": "500",
                    "description": "Medium"
                },
                {
                    "name": "600",
                    "description": "Semi Bold (Demi Bold)"
                },
                {
                    "name": "700",
                    "description": "Bold"
                },
                {
                    "name": "800",
                    "description": "Extra Bold (Ultra Bold)"
                },
                {
                    "name": "900",
                    "description": "Black (Heavy)"
                },
                {
                    "name": "bold",
                    "description": "Same as 700"
                },
                {
                    "name": "bolder",
                    "description": "Specifies the weight of the face bolder than the inherited value."
                },
                {
                    "name": "lighter",
                    "description": "Specifies the weight of the face lighter than the inherited value."
                },
                {
                    "name": "normal",
                    "description": "Same as 400"
                }
            ],
            "atRule": "@font-face",
            "syntax": "<font-weight-absolute>{1,2}",
            "relevance": 93,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-weight"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies weight of glyphs in the font, their degree of blackness or stroke thickness.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "glyph-orientation-horizontal",
            "relevance": 50,
            "description": "Controls glyph orientation when the inline-progression-direction is horizontal.",
            "restrictions": [
                "angle",
                "number"
            ]
        },
        {
            "name": "glyph-orientation-vertical",
            "browsers": [
                "S4",
                "SM3.2"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Sets the orientation based on the fullwidth or non-fullwidth characters and the most common orientation."
                }
            ],
            "relevance": 50,
            "baseline": {
                "status": "false"
            },
            "description": "Controls glyph orientation when the inline-progression-direction is vertical.",
            "restrictions": [
                "angle",
                "number",
                "enum"
            ]
        },
        {
            "name": "grid-area",
            "browsers": [
                "E16",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The property contributes nothing to the grid item's placement, indicating auto-placement, an automatic span, or a default span of one."
                },
                {
                    "name": "span",
                    "description": "Contributes a grid span to the grid item's placement such that the corresponding edge of the grid item's grid area is N lines from its opposite edge."
                }
            ],
            "syntax": "<grid-line> [ / <grid-line> ]{0,3}",
            "relevance": 59,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/grid-area"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "Determine a grid item's size and location within the grid by contributing a line, a span, or nothing (automatic) to its grid placement. Shorthand for 'grid-row-start', 'grid-column-start', 'grid-row-end', and 'grid-column-end'.",
            "restrictions": [
                "identifier",
                "integer"
            ]
        },
        {
            "name": "grid",
            "browsers": [
                "E16",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "O44"
            ],
            "syntax": "<'grid-template'> | <'grid-template-rows'> / [ auto-flow && dense? ] <'grid-auto-columns'>? | [ auto-flow && dense? ] <'grid-auto-rows'>? / <'grid-template-columns'>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/grid"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "The grid CSS property is a shorthand property that sets all of the explicit grid properties ('grid-template-rows', 'grid-template-columns', and 'grid-template-areas'), and all the implicit grid properties ('grid-auto-rows', 'grid-auto-columns', and 'grid-auto-flow'), in a single declaration.",
            "restrictions": [
                "identifier",
                "length",
                "percentage",
                "string",
                "enum"
            ]
        },
        {
            "name": "grid-auto-columns",
            "browsers": [
                "E16",
                "FF70",
                "FFA79",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "IE10",
                "O44"
            ],
            "values": [
                {
                    "name": "min-content",
                    "description": "Represents the largest min-content contribution of the grid items occupying the grid track."
                },
                {
                    "name": "max-content",
                    "description": "Represents the largest max-content contribution of the grid items occupying the grid track."
                },
                {
                    "name": "auto",
                    "description": "As a maximum, identical to 'max-content'. As a minimum, represents the largest minimum size (as specified by min-width/min-height) of the grid items occupying the grid track."
                },
                {
                    "name": "minmax()",
                    "description": "Defines a size range greater than or equal to min and less than or equal to max."
                }
            ],
            "syntax": "<track-size>+",
            "relevance": 52,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/grid-auto-columns"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-07-28",
                "baseline_high_date": "2023-01-28"
            },
            "description": "Specifies the size of implicitly created columns.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "grid-auto-flow",
            "browsers": [
                "E16",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "row",
                    "description": "The auto-placement algorithm places items by filling each row in turn, adding new rows as necessary."
                },
                {
                    "name": "column",
                    "description": "The auto-placement algorithm places items by filling each column in turn, adding new columns as necessary."
                },
                {
                    "name": "dense",
                    "description": "If specified, the auto-placement algorithm uses a \"dense\" packing algorithm, which attempts to fill in holes earlier in the grid if smaller items come up later."
                }
            ],
            "syntax": "[ row | column ] || dense",
            "relevance": 55,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/grid-auto-flow"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "Controls how the auto-placement algorithm works, specifying exactly how auto-placed items get flowed into the grid.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "grid-auto-rows",
            "browsers": [
                "E16",
                "FF70",
                "FFA79",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "IE10",
                "O44"
            ],
            "values": [
                {
                    "name": "min-content",
                    "description": "Represents the largest min-content contribution of the grid items occupying the grid track."
                },
                {
                    "name": "max-content",
                    "description": "Represents the largest max-content contribution of the grid items occupying the grid track."
                },
                {
                    "name": "auto",
                    "description": "As a maximum, identical to 'max-content'. As a minimum, represents the largest minimum size (as specified by min-width/min-height) of the grid items occupying the grid track."
                },
                {
                    "name": "minmax()",
                    "description": "Defines a size range greater than or equal to min and less than or equal to max."
                }
            ],
            "syntax": "<track-size>+",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/grid-auto-rows"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-07-28",
                "baseline_high_date": "2023-01-28"
            },
            "description": "Specifies the size of implicitly created rows.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "grid-column",
            "browsers": [
                "E16",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The property contributes nothing to the grid item's placement, indicating auto-placement, an automatic span, or a default span of one."
                },
                {
                    "name": "span",
                    "description": "Contributes a grid span to the grid item's placement such that the corresponding edge of the grid item's grid area is N lines from its opposite edge."
                }
            ],
            "syntax": "<grid-line> [ / <grid-line> ]?",
            "relevance": 61,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/grid-column"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "Shorthand for 'grid-column-start' and 'grid-column-end'.",
            "restrictions": [
                "identifier",
                "integer",
                "enum"
            ]
        },
        {
            "name": "grid-column-end",
            "browsers": [
                "E16",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The property contributes nothing to the grid item's placement, indicating auto-placement, an automatic span, or a default span of one."
                },
                {
                    "name": "span",
                    "description": "Contributes a grid span to the grid item's placement such that the corresponding edge of the grid item's grid area is N lines from its opposite edge."
                }
            ],
            "syntax": "<grid-line>",
            "relevance": 52,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/grid-column-end"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "Determine a grid item's size and location within the grid by contributing a line, a span, or nothing (automatic) to its grid placement.",
            "restrictions": [
                "identifier",
                "integer",
                "enum"
            ]
        },
        {
            "name": "grid-column-gap",
            "browsers": [
                "FF52",
                "C57",
                "S10.1",
                "O44"
            ],
            "status": "obsolete",
            "syntax": "<length-percentage>",
            "relevance": 4,
            "description": "Specifies the gutters between grid columns. Replaced by 'column-gap' property.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "grid-column-start",
            "browsers": [
                "E16",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The property contributes nothing to the grid item's placement, indicating auto-placement, an automatic span, or a default span of one."
                },
                {
                    "name": "span",
                    "description": "Contributes a grid span to the grid item's placement such that the corresponding edge of the grid item's grid area is N lines from its opposite edge."
                }
            ],
            "syntax": "<grid-line>",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/grid-column-start"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "Determine a grid item's size and location within the grid by contributing a line, a span, or nothing (automatic) to its grid placement.",
            "restrictions": [
                "identifier",
                "integer",
                "enum"
            ]
        },
        {
            "name": "grid-gap",
            "browsers": [
                "FF52",
                "C57",
                "S10.1",
                "O44"
            ],
            "status": "obsolete",
            "syntax": "<'grid-row-gap'> <'grid-column-gap'>?",
            "relevance": 9,
            "description": "Shorthand that specifies the gutters between grid columns and grid rows in one declaration. Replaced by 'gap' property.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "grid-row",
            "browsers": [
                "E16",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The property contributes nothing to the grid item's placement, indicating auto-placement, an automatic span, or a default span of one."
                },
                {
                    "name": "span",
                    "description": "Contributes a grid span to the grid item's placement such that the corresponding edge of the grid item's grid area is N lines from its opposite edge."
                }
            ],
            "syntax": "<grid-line> [ / <grid-line> ]?",
            "relevance": 58,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/grid-row"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "Shorthand for 'grid-row-start' and 'grid-row-end'.",
            "restrictions": [
                "identifier",
                "integer",
                "enum"
            ]
        },
        {
            "name": "grid-row-end",
            "browsers": [
                "E16",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The property contributes nothing to the grid item's placement, indicating auto-placement, an automatic span, or a default span of one."
                },
                {
                    "name": "span",
                    "description": "Contributes a grid span to the grid item's placement such that the corresponding edge of the grid item's grid area is N lines from its opposite edge."
                }
            ],
            "syntax": "<grid-line>",
            "relevance": 52,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/grid-row-end"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "Determine a grid item's size and location within the grid by contributing a line, a span, or nothing (automatic) to its grid placement.",
            "restrictions": [
                "identifier",
                "integer",
                "enum"
            ]
        },
        {
            "name": "grid-row-gap",
            "browsers": [
                "FF52",
                "C57",
                "S10.1",
                "O44"
            ],
            "status": "obsolete",
            "syntax": "<length-percentage>",
            "relevance": 2,
            "description": "Specifies the gutters between grid rows. Replaced by 'row-gap' property.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "grid-row-start",
            "browsers": [
                "E16",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The property contributes nothing to the grid item's placement, indicating auto-placement, an automatic span, or a default span of one."
                },
                {
                    "name": "span",
                    "description": "Contributes a grid span to the grid item's placement such that the corresponding edge of the grid item's grid area is N lines from its opposite edge."
                }
            ],
            "syntax": "<grid-line>",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/grid-row-start"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "Determine a grid item's size and location within the grid by contributing a line, a span, or nothing (automatic) to its grid placement.",
            "restrictions": [
                "identifier",
                "integer",
                "enum"
            ]
        },
        {
            "name": "grid-template",
            "browsers": [
                "E16",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "Sets all three properties to their initial values."
                },
                {
                    "name": "min-content",
                    "description": "Represents the largest min-content contribution of the grid items occupying the grid track."
                },
                {
                    "name": "max-content",
                    "description": "Represents the largest max-content contribution of the grid items occupying the grid track."
                },
                {
                    "name": "auto",
                    "description": "As a maximum, identical to 'max-content'. As a minimum, represents the largest minimum size (as specified by min-width/min-height) of the grid items occupying the grid track."
                },
                {
                    "name": "subgrid",
                    "description": "Sets 'grid-template-rows' and 'grid-template-columns' to 'subgrid', and 'grid-template-areas' to its initial value."
                },
                {
                    "name": "minmax()",
                    "description": "Defines a size range greater than or equal to min and less than or equal to max."
                },
                {
                    "name": "repeat()",
                    "description": "Represents a repeated fragment of the track list, allowing a large number of columns or rows that exhibit a recurring pattern to be written in a more compact form."
                }
            ],
            "syntax": "none | [ <'grid-template-rows'> / <'grid-template-columns'> ] | [ <line-names>? <string> <track-size>? <line-names>? ]+ [ / <explicit-track-list> ]?",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/grid-template"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "Shorthand for setting grid-template-columns, grid-template-rows, and grid-template-areas in a single declaration.",
            "restrictions": [
                "identifier",
                "length",
                "percentage",
                "string",
                "enum"
            ]
        },
        {
            "name": "grid-template-areas",
            "browsers": [
                "E16",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "The grid container doesn't define any named grid areas."
                }
            ],
            "syntax": "none | <string>+",
            "relevance": 55,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/grid-template-areas"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "Specifies named grid areas, which are not associated with any particular grid item, but can be referenced from the grid-placement properties.",
            "restrictions": [
                "string"
            ]
        },
        {
            "name": "grid-template-columns",
            "browsers": [
                "E16",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "IE10",
                "O44"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "There is no explicit grid; any rows/columns will be implicitly generated."
                },
                {
                    "name": "min-content",
                    "description": "Represents the largest min-content contribution of the grid items occupying the grid track."
                },
                {
                    "name": "max-content",
                    "description": "Represents the largest max-content contribution of the grid items occupying the grid track."
                },
                {
                    "name": "auto",
                    "description": "As a maximum, identical to 'max-content'. As a minimum, represents the largest minimum size (as specified by min-width/min-height) of the grid items occupying the grid track."
                },
                {
                    "name": "subgrid",
                    "description": "Indicates that the grid will align to its parent grid in that axis."
                },
                {
                    "name": "minmax()",
                    "description": "Defines a size range greater than or equal to min and less than or equal to max."
                },
                {
                    "name": "repeat()",
                    "description": "Represents a repeated fragment of the track list, allowing a large number of columns or rows that exhibit a recurring pattern to be written in a more compact form."
                }
            ],
            "syntax": "none | <track-list> | <auto-track-list> | subgrid <line-name-list>?",
            "relevance": 70,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/grid-template-columns"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "specifies, as a space-separated track list, the line names and track sizing functions of the grid.",
            "restrictions": [
                "identifier",
                "length",
                "percentage",
                "enum"
            ]
        },
        {
            "name": "grid-template-rows",
            "browsers": [
                "E16",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "IE10",
                "O44"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "There is no explicit grid; any rows/columns will be implicitly generated."
                },
                {
                    "name": "min-content",
                    "description": "Represents the largest min-content contribution of the grid items occupying the grid track."
                },
                {
                    "name": "max-content",
                    "description": "Represents the largest max-content contribution of the grid items occupying the grid track."
                },
                {
                    "name": "auto",
                    "description": "As a maximum, identical to 'max-content'. As a minimum, represents the largest minimum size (as specified by min-width/min-height) of the grid items occupying the grid track."
                },
                {
                    "name": "subgrid",
                    "description": "Indicates that the grid will align to its parent grid in that axis."
                },
                {
                    "name": "minmax()",
                    "description": "Defines a size range greater than or equal to min and less than or equal to max."
                },
                {
                    "name": "repeat()",
                    "description": "Represents a repeated fragment of the track list, allowing a large number of columns or rows that exhibit a recurring pattern to be written in a more compact form."
                }
            ],
            "syntax": "none | <track-list> | <auto-track-list> | subgrid <line-name-list>?",
            "relevance": 61,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/grid-template-rows"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "specifies, as a space-separated track list, the line names and track sizing functions of the grid.",
            "restrictions": [
                "identifier",
                "length",
                "percentage",
                "string",
                "enum"
            ]
        },
        {
            "name": "height",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O7"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The height depends on the values of other properties."
                },
                {
                    "name": "fit-content",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Use the fit-content inline size or fit-content block size, as appropriate to the writing mode."
                },
                {
                    "name": "max-content",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Use the max-content inline size or max-content block size, as appropriate to the writing mode."
                },
                {
                    "name": "min-content",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Use the min-content inline size or min-content block size, as appropriate to the writing mode."
                }
            ],
            "syntax": "auto | <length-percentage [0,\u221E]> | min-content | max-content | fit-content | fit-content(<length-percentage [0,\u221E]>) | <calc-size()> | <anchor-size()>",
            "relevance": 95,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/height"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies the height of the content area, padding area or border area (depending on 'box-sizing') of certain boxes.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "hyphens",
            "browsers": [
                "E79",
                "FF43",
                "FFA43",
                "S17",
                "SM17",
                "C55",
                "CA55",
                "IE10",
                "O42"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Conditional hyphenation characters inside a word, if present, take priority over automatic resources when determining hyphenation points within the word."
                },
                {
                    "name": "manual",
                    "description": "Words are only broken at line breaks where there are characters inside the word that suggest line break opportunities"
                },
                {
                    "name": "none",
                    "description": "Words are not broken at line breaks, even if characters inside the word suggest line break points."
                }
            ],
            "syntax": "none | manual | auto",
            "relevance": 55,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/hyphens"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-09-18"
            },
            "description": "Controls whether hyphenation is allowed to create more break opportunities within a line of text.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "image-orientation",
            "browsers": [
                "E81",
                "FF26",
                "FFA26",
                "S13.1",
                "SM13.4",
                "C81",
                "CA81",
                "O67"
            ],
            "values": [
                {
                    "name": "flip",
                    "description": "After rotating by the precededing angle, the image is flipped horizontally. Defaults to 0deg if the angle is ommitted."
                },
                {
                    "name": "from-image",
                    "description": "If the image has an orientation specified in its metadata, such as EXIF, this value computes to the angle that the metadata specifies is necessary to correctly orient the image."
                }
            ],
            "syntax": "from-image | <angle> | [ <angle>? flip ]",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/image-orientation"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-04-13",
                "baseline_high_date": "2022-10-13"
            },
            "description": "Specifies an orthogonal rotation to be applied to an image before it is laid out.",
            "restrictions": [
                "angle"
            ]
        },
        {
            "name": "image-rendering",
            "browsers": [
                "E79",
                "FF3.6",
                "FFA4",
                "S6",
                "SM6",
                "C13",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The image should be scaled with an algorithm that maximizes the appearance of the image."
                },
                {
                    "name": "crisp-edges",
                    "description": "The image must be scaled with an algorithm that preserves contrast and edges in the image, and which does not smooth colors or introduce blur to the image in the process."
                },
                {
                    "name": "-moz-crisp-edges",
                    "browsers": [
                        "E79",
                        "FF3.6",
                        "FFA4",
                        "S6",
                        "SM6",
                        "C13",
                        "CA18",
                        "O15"
                    ]
                },
                {
                    "name": "optimizeQuality",
                    "description": "Deprecated."
                },
                {
                    "name": "optimizeSpeed",
                    "description": "Deprecated."
                },
                {
                    "name": "pixelated",
                    "description": "When scaling the image up, the 'nearest neighbor' or similar algorithm must be used, so that the image appears to be simply composed of very large pixels."
                }
            ],
            "syntax": "auto | crisp-edges | pixelated | smooth",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/image-rendering"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Provides a hint to the user-agent about what aspects of an image are most important to preserve when the image is scaled, to aid the user-agent in the choice of an appropriate scaling algorithm.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "ime-mode",
            "browsers": [
                "FF3",
                "FFA4",
                "IE5"
            ],
            "values": [
                {
                    "name": "active",
                    "description": "The input method editor is initially active; text entry is performed using it unless the user specifically dismisses it."
                },
                {
                    "name": "auto",
                    "description": "No change is made to the current input method editor state. This is the default."
                },
                {
                    "name": "disabled",
                    "description": "The input method editor is disabled and may not be activated by the user."
                },
                {
                    "name": "inactive",
                    "description": "The input method editor is initially inactive, but the user may activate it if they wish."
                },
                {
                    "name": "normal",
                    "description": "The IME state should be normal; this value can be used in a user style sheet to override the page setting."
                }
            ],
            "status": "obsolete",
            "syntax": "auto | normal | active | inactive | disabled",
            "relevance": 0,
            "baseline": {
                "status": "false"
            },
            "description": "Controls the state of the input method editor for text fields.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "inline-size",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Depends on the values of other properties."
                }
            ],
            "syntax": "<'width'>",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/inline-size"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Size of an element in the direction specified by 'writing-mode'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "isolation",
            "browsers": [
                "E79",
                "FF36",
                "FFA36",
                "S8",
                "SM8",
                "C41",
                "CA41",
                "O30"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Elements are not isolated unless an operation is applied that causes the creation of a stacking context."
                },
                {
                    "name": "isolate",
                    "description": "In CSS will turn the element into a stacking context."
                }
            ],
            "syntax": "auto | isolate",
            "relevance": 55,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/isolation"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "In CSS setting to 'isolate' will turn the element into a stacking context. In SVG, it defines whether an element is isolated or not.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "justify-content",
            "browsers": [
                "E12",
                "FF20",
                "FFA20",
                "S9",
                "SM9",
                "C29",
                "CA29",
                "IE11",
                "O12.1"
            ],
            "values": [
                {
                    "name": "center",
                    "description": "Flex items are packed toward the center of the line."
                },
                {
                    "name": "start",
                    "description": "The items are packed flush to each other toward the start edge of the alignment container in the main axis."
                },
                {
                    "name": "end",
                    "description": "The items are packed flush to each other toward the end edge of the alignment container in the main axis."
                },
                {
                    "name": "left",
                    "description": "The items are packed flush to each other toward the left edge of the alignment container in the main axis."
                },
                {
                    "name": "right",
                    "description": "The items are packed flush to each other toward the right edge of the alignment container in the main axis."
                },
                {
                    "name": "safe",
                    "description": "If the size of the item overflows the alignment container, the item is instead aligned as if the alignment mode were start."
                },
                {
                    "name": "unsafe",
                    "description": "Regardless of the relative sizes of the item and alignment container, the given alignment value is honored."
                },
                {
                    "name": "stretch",
                    "description": "If the combined size of the alignment subjects is less than the size of the alignment container, any auto-sized alignment subjects have their size increased equally (not proportionally), while still respecting the constraints imposed by max-height/max-width (or equivalent functionality), so that the combined size exactly fills the alignment container."
                },
                {
                    "name": "space-evenly",
                    "description": "The items are evenly distributed within the alignment container along the main axis."
                },
                {
                    "name": "flex-end",
                    "description": "Flex items are packed toward the end of the line."
                },
                {
                    "name": "flex-start",
                    "description": "Flex items are packed toward the start of the line."
                },
                {
                    "name": "space-around",
                    "description": "Flex items are evenly distributed in the line, with half-size spaces on either end."
                },
                {
                    "name": "space-between",
                    "description": "Flex items are evenly distributed in the line."
                },
                {
                    "name": "baseline",
                    "description": "Specifies participation in first-baseline alignment."
                },
                {
                    "name": "first baseline",
                    "description": "Specifies participation in first-baseline alignment."
                },
                {
                    "name": "last baseline",
                    "description": "Specifies participation in last-baseline alignment."
                }
            ],
            "syntax": "normal | <content-distribution> | <overflow-position>? [ <content-position> | left | right ]",
            "relevance": 89,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/justify-content"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Aligns flex items along the main axis of the current line of the flex container.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "kerning",
            "values": [
                {
                    "name": "auto",
                    "description": "Indicates that the user agent should adjust inter-glyph spacing based on kerning tables that are included in the font that will be used."
                }
            ],
            "relevance": 50,
            "description": "Indicates whether the user agent should adjust inter-glyph spacing based on kerning tables that are included in the relevant font or instead disable auto-kerning and set inter-character spacing to a specific length.",
            "restrictions": [
                "length",
                "enum"
            ]
        },
        {
            "name": "left",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE5.5",
                "O5"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "For non-replaced elements, the effect of this value depends on which of related properties have the value 'auto' as well"
                }
            ],
            "syntax": "<length> | <percentage> | auto",
            "relevance": 94,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/left"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies how far an absolutely positioned box's left margin edge is offset to the right of the left edge of the box's 'containing block'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "letter-spacing",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "values": [
                {
                    "name": "normal",
                    "description": "The spacing is the normal spacing for the current font. It is typically zero-length."
                }
            ],
            "syntax": "normal | <length>",
            "relevance": 82,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/letter-spacing"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies the minimum, maximum, and optimal spacing between grapheme clusters.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "lighting-color",
            "browsers": [
                "E12",
                "FF3",
                "FFA4",
                "S6",
                "SM6",
                "C5",
                "CA18",
                "IE11",
                "O15"
            ],
            "syntax": "<color>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/lighting-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Defines the color of the light source for filter primitives 'feDiffuseLighting' and 'feSpecularLighting'.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "line-break",
            "browsers": [
                "E14",
                "FF69",
                "FFA79",
                "S11",
                "SM11",
                "C58",
                "CA58",
                "IE5.5",
                "O45"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The UA determines the set of line-breaking restrictions to use for CJK scripts, and it may vary the restrictions based on the length of the line; e.g., use a less restrictive set of line-break rules for short lines."
                },
                {
                    "name": "loose",
                    "description": "Breaks text using the least restrictive set of line-breaking rules. Typically used for short lines, such as in newspapers."
                },
                {
                    "name": "normal",
                    "description": "Breaks text using the most common set of line-breaking rules."
                },
                {
                    "name": "strict",
                    "description": "Breaks CJK scripts using a more restrictive set of line-breaking rules than 'normal'."
                },
                {
                    "name": "anywhere",
                    "description": "There is a soft wrap opportunity around every typographic character unit, including around any punctuation character or preserved white spaces, or in the middle of words, disregarding any prohibition against line breaks, even those introduced by characters with the GL, WJ, or ZWJ line breaking classes or mandated by the word-break property."
                }
            ],
            "syntax": "auto | loose | normal | strict | anywhere",
            "relevance": 52,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/line-break"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-07-28",
                "baseline_high_date": "2023-01-28"
            },
            "description": "Specifies what set of line breaking restrictions are in effect within the element.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "line-height",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O7"
            ],
            "values": [
                {
                    "name": "normal",
                    "description": "Tells user agents to set the computed value to a 'reasonable' value based on the font size of the element."
                }
            ],
            "syntax": "normal | <number> | <length> | <percentage>",
            "relevance": 92,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/line-height"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Determines the block-progression dimension of the text content area of an inline box.",
            "restrictions": [
                "number",
                "length",
                "percentage"
            ]
        },
        {
            "name": "list-style",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O7"
            ],
            "values": [
                {
                    "name": "armenian"
                },
                {
                    "name": "circle",
                    "description": "A hollow circle."
                },
                {
                    "name": "decimal"
                },
                {
                    "name": "decimal-leading-zero"
                },
                {
                    "name": "disc",
                    "description": "A filled circle."
                },
                {
                    "name": "georgian"
                },
                {
                    "name": "inside",
                    "description": "The marker box is outside the principal block box, as described in the section on the ::marker pseudo-element below."
                },
                {
                    "name": "lower-alpha"
                },
                {
                    "name": "lower-greek"
                },
                {
                    "name": "lower-latin"
                },
                {
                    "name": "lower-roman"
                },
                {
                    "name": "none"
                },
                {
                    "name": "outside",
                    "description": "The ::marker pseudo-element is an inline element placed immediately before all ::before pseudo-elements in the principal block box, after which the element's content flows."
                },
                {
                    "name": "square",
                    "description": "A filled square."
                },
                {
                    "name": "symbols()",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Allows a counter style to be defined inline."
                },
                {
                    "name": "upper-alpha"
                },
                {
                    "name": "upper-latin"
                },
                {
                    "name": "upper-roman"
                },
                {
                    "name": "url()"
                }
            ],
            "syntax": "<'list-style-type'> || <'list-style-position'> || <'list-style-image'>",
            "relevance": 83,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/list-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand for setting 'list-style-type', 'list-style-position' and 'list-style-image'",
            "restrictions": [
                "image",
                "enum",
                "url"
            ]
        },
        {
            "name": "list-style-image",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O7"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "The default contents of the of the list item's marker are given by 'list-style-type' instead."
                }
            ],
            "syntax": "<image> | none",
            "relevance": 52,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/list-style-image"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Sets the image that will be used as the list item marker. When the image is available, it will replace the marker set with the 'list-style-type' marker.",
            "restrictions": [
                "image"
            ]
        },
        {
            "name": "list-style-position",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "values": [
                {
                    "name": "inside",
                    "description": "The marker box is outside the principal block box, as described in the section on the ::marker pseudo-element below."
                },
                {
                    "name": "outside",
                    "description": "The ::marker pseudo-element is an inline element placed immediately before all ::before pseudo-elements in the principal block box, after which the element's content flows."
                }
            ],
            "syntax": "inside | outside",
            "relevance": 55,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/list-style-position"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies the position of the '::marker' pseudo-element's box in the list item.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "list-style-type",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "values": [
                {
                    "name": "armenian",
                    "description": "Traditional uppercase Armenian numbering."
                },
                {
                    "name": "circle",
                    "description": "A hollow circle."
                },
                {
                    "name": "decimal",
                    "description": "Western decimal numbers."
                },
                {
                    "name": "decimal-leading-zero",
                    "description": "Decimal numbers padded by initial zeros."
                },
                {
                    "name": "disc",
                    "description": "A filled circle."
                },
                {
                    "name": "georgian",
                    "description": "Traditional Georgian numbering."
                },
                {
                    "name": "lower-alpha",
                    "description": "Lowercase ASCII letters."
                },
                {
                    "name": "lower-greek",
                    "description": "Lowercase classical Greek."
                },
                {
                    "name": "lower-latin",
                    "description": "Lowercase ASCII letters."
                },
                {
                    "name": "lower-roman",
                    "description": "Lowercase ASCII Roman numerals."
                },
                {
                    "name": "none",
                    "description": "No marker"
                },
                {
                    "name": "square",
                    "description": "A filled square."
                },
                {
                    "name": "symbols()",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O3.5"
                    ],
                    "description": "Allows a counter style to be defined inline."
                },
                {
                    "name": "upper-alpha",
                    "description": "Uppercase ASCII letters."
                },
                {
                    "name": "upper-latin",
                    "description": "Uppercase ASCII letters."
                },
                {
                    "name": "upper-roman",
                    "description": "Uppercase ASCII Roman numerals."
                }
            ],
            "syntax": "<counter-style> | <string> | none",
            "relevance": 72,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/list-style-type"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Used to construct the default contents of a list item's marker",
            "restrictions": [
                "enum",
                "string"
            ]
        },
        {
            "name": "margin",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE3",
                "O3.5"
            ],
            "values": [
                {
                    "name": "auto"
                }
            ],
            "syntax": "<'margin-top'>{1,4}",
            "relevance": 95,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/margin"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property to set values for the thickness of the margin area. If left is omitted, it is the same as right. If bottom is omitted it is the same as top, if right is omitted it is the same as top. Negative values for margin properties are allowed, but there may be implementation-specific limits.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "margin-block-end",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "values": [
                {
                    "name": "auto"
                }
            ],
            "syntax": "<'margin-top'>",
            "relevance": 55,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/margin-block-end"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'margin-bottom'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "margin-block-start",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "values": [
                {
                    "name": "auto"
                }
            ],
            "syntax": "<'margin-top'>",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/margin-block-start"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'margin-top'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "margin-bottom",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE3",
                "O3.5"
            ],
            "values": [
                {
                    "name": "auto"
                }
            ],
            "syntax": "<length-percentage> | auto",
            "relevance": 91,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/margin-bottom"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property to set values for the thickness of the margin area. If left is omitted, it is the same as right. If bottom is omitted it is the same as top, if right is omitted it is the same as top. Negative values for margin properties are allowed, but there may be implementation-specific limits..",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "margin-inline-end",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "values": [
                {
                    "name": "auto"
                }
            ],
            "syntax": "<'margin-top'>",
            "relevance": 58,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/margin-inline-end"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'margin-right'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "margin-inline-start",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "values": [
                {
                    "name": "auto"
                }
            ],
            "syntax": "<'margin-top'>",
            "relevance": 59,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/margin-inline-start"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'margin-left'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "margin-left",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE3",
                "O3.5"
            ],
            "values": [
                {
                    "name": "auto"
                }
            ],
            "syntax": "<length-percentage> | auto",
            "relevance": 91,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/margin-left"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property to set values for the thickness of the margin area. If left is omitted, it is the same as right. If bottom is omitted it is the same as top, if right is omitted it is the same as top. Negative values for margin properties are allowed, but there may be implementation-specific limits..",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "margin-right",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE3",
                "O3.5"
            ],
            "values": [
                {
                    "name": "auto"
                }
            ],
            "syntax": "<length-percentage> | auto",
            "relevance": 91,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/margin-right"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property to set values for the thickness of the margin area. If left is omitted, it is the same as right. If bottom is omitted it is the same as top, if right is omitted it is the same as top. Negative values for margin properties are allowed, but there may be implementation-specific limits..",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "margin-top",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE3",
                "O3.5"
            ],
            "values": [
                {
                    "name": "auto"
                }
            ],
            "syntax": "<length-percentage> | auto",
            "relevance": 93,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/margin-top"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property to set values for the thickness of the margin area. If left is omitted, it is the same as right. If bottom is omitted it is the same as top, if right is omitted it is the same as top. Negative values for margin properties are allowed, but there may be implementation-specific limits..",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "marker",
            "browsers": [
                "E15",
                "FF3",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "Indicates that no marker symbol will be drawn at the given vertex or vertices."
                },
                {
                    "name": "url()",
                    "description": "Indicates that the <marker> element referenced will be used."
                }
            ],
            "syntax": "none | <url>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/marker"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Specifies the marker symbol that shall be used for all points on the sets the value for all vertices on the given 'path' element or basic shape.",
            "restrictions": [
                "url"
            ]
        },
        {
            "name": "marker-end",
            "browsers": [
                "E15",
                "FF3",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "Indicates that no marker symbol will be drawn at the given vertex or vertices."
                },
                {
                    "name": "url()",
                    "description": "Indicates that the <marker> element referenced will be used."
                }
            ],
            "syntax": "none | <url>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/marker-end"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Specifies the marker that will be drawn at the last vertices of the given markable element.",
            "restrictions": [
                "url"
            ]
        },
        {
            "name": "marker-mid",
            "browsers": [
                "E15",
                "FF3",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "Indicates that no marker symbol will be drawn at the given vertex or vertices."
                },
                {
                    "name": "url()",
                    "description": "Indicates that the <marker> element referenced will be used."
                }
            ],
            "syntax": "none | <url>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/marker-mid"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Specifies the marker that will be drawn at all vertices except the first and last.",
            "restrictions": [
                "url"
            ]
        },
        {
            "name": "marker-start",
            "browsers": [
                "E15",
                "FF3",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "Indicates that no marker symbol will be drawn at the given vertex or vertices."
                },
                {
                    "name": "url()",
                    "description": "Indicates that the <marker> element referenced will be used."
                }
            ],
            "syntax": "none | <url>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/marker-start"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Specifies the marker that will be drawn at the first vertices of the given markable element.",
            "restrictions": [
                "url"
            ]
        },
        {
            "name": "mask-image",
            "browsers": [
                "E120",
                "FF53",
                "FFA53",
                "S15.4",
                "SM15.4",
                "C120",
                "CA120",
                "O15"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "Counts as a transparent black image layer."
                },
                {
                    "name": "url()",
                    "description": "Reference to a <mask element or to a CSS image."
                }
            ],
            "syntax": "<mask-reference>#",
            "relevance": 59,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask-image"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-12-07"
            },
            "description": "Sets the mask layer image of an element.",
            "restrictions": [
                "url",
                "image",
                "enum"
            ]
        },
        {
            "name": "mask-mode",
            "browsers": [
                "E120",
                "FF53",
                "FFA53",
                "S15.4",
                "SM15.4",
                "C120",
                "CA120",
                "O106"
            ],
            "values": [
                {
                    "name": "alpha",
                    "description": "Alpha values of the mask layer image should be used as the mask values."
                },
                {
                    "name": "auto",
                    "description": "Use alpha values if 'mask-image' is an image, luminance if a <mask> element or a CSS image."
                },
                {
                    "name": "luminance",
                    "description": "Luminance values of the mask layer image should be used as the mask values."
                }
            ],
            "syntax": "<masking-mode>#",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask-mode"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-12-07"
            },
            "description": "Indicates whether the mask layer image is treated as luminance mask or alpha mask.",
            "restrictions": [
                "url",
                "image",
                "enum"
            ]
        },
        {
            "name": "mask-origin",
            "browsers": [
                "E120",
                "FF53",
                "FFA53",
                "S15.4",
                "SM15.4",
                "C120",
                "CA120",
                "O106"
            ],
            "syntax": "<coord-box>#",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask-origin"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-12-07"
            },
            "description": "Specifies the mask positioning area.",
            "restrictions": [
                "geometry-box",
                "enum"
            ]
        },
        {
            "name": "mask-position",
            "browsers": [
                "E120",
                "FF53",
                "FFA53",
                "S15.4",
                "SM15.4",
                "C120",
                "CA120",
                "O106"
            ],
            "syntax": "<position>#",
            "relevance": 55,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask-position"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-12-07"
            },
            "description": "Specifies how mask layer images are positioned.",
            "restrictions": [
                "position",
                "length",
                "percentage"
            ]
        },
        {
            "name": "mask-repeat",
            "browsers": [
                "E120",
                "FF53",
                "FFA53",
                "S15.4",
                "SM15.4",
                "C120",
                "CA120",
                "O106"
            ],
            "syntax": "<repeat-style>#",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask-repeat"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-12-07"
            },
            "description": "Specifies how mask layer images are tiled after they have been sized and positioned.",
            "restrictions": [
                "repeat"
            ]
        },
        {
            "name": "mask-size",
            "browsers": [
                "E120",
                "FF53",
                "FFA53",
                "S15.4",
                "SM15.4",
                "C120",
                "CA120",
                "O106"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Resolved by using the image's intrinsic ratio and the size of the other dimension, or failing that, using the image's intrinsic size, or failing that, treating it as 100%."
                },
                {
                    "name": "contain",
                    "description": "Scale the image, while preserving its intrinsic aspect ratio (if any), to the largest size such that both its width and its height can fit inside the background positioning area."
                },
                {
                    "name": "cover",
                    "description": "Scale the image, while preserving its intrinsic aspect ratio (if any), to the smallest size such that both its width and its height can completely cover the background positioning area."
                }
            ],
            "syntax": "<bg-size>#",
            "relevance": 55,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask-size"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-12-07"
            },
            "description": "Specifies the size of the mask layer images.",
            "restrictions": [
                "length",
                "percentage",
                "enum"
            ]
        },
        {
            "name": "mask-type",
            "browsers": [
                "E79",
                "FF35",
                "FFA35",
                "S7",
                "SM7",
                "C24",
                "CA25",
                "O15"
            ],
            "values": [
                {
                    "name": "alpha",
                    "description": "Indicates that the alpha values of the mask should be used."
                },
                {
                    "name": "luminance",
                    "description": "Indicates that the luminance values of the mask should be used."
                }
            ],
            "syntax": "luminance | alpha",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask-type"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Defines whether the content of the <mask> element is treated as as luminance mask or alpha mask.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "max-block-size",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No limit on the width of the box."
                }
            ],
            "syntax": "<'max-width'>",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/max-block-size"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Maximum size of an element in the direction opposite that of the direction specified by 'writing-mode'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "max-height",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1.3",
                "SM1",
                "C1",
                "CA18",
                "IE7",
                "O7"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No limit on the height of the box."
                },
                {
                    "name": "fit-content",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1.3",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE7",
                        "O7"
                    ],
                    "description": "Use the fit-content inline size or fit-content block size, as appropriate to the writing mode."
                },
                {
                    "name": "max-content",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1.3",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE7",
                        "O7"
                    ],
                    "description": "Use the max-content inline size or max-content block size, as appropriate to the writing mode."
                },
                {
                    "name": "min-content",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1.3",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE7",
                        "O7"
                    ],
                    "description": "Use the min-content inline size or min-content block size, as appropriate to the writing mode."
                }
            ],
            "syntax": "none | <length-percentage [0,\u221E]> | min-content | max-content | fit-content | fit-content(<length-percentage [0,\u221E]>) | <calc-size()> | <anchor-size()>",
            "relevance": 86,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/max-height"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Allows authors to constrain content height to a certain range.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "max-inline-size",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No limit on the height of the box."
                }
            ],
            "syntax": "<'max-width'>",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/max-inline-size"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Maximum size of an element in the direction specified by 'writing-mode'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "max-width",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE7",
                "O4"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No limit on the width of the box."
                },
                {
                    "name": "fit-content",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE7",
                        "O4"
                    ],
                    "description": "Use the fit-content inline size or fit-content block size, as appropriate to the writing mode."
                },
                {
                    "name": "max-content",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE7",
                        "O4"
                    ],
                    "description": "Use the max-content inline size or max-content block size, as appropriate to the writing mode."
                },
                {
                    "name": "min-content",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE7",
                        "O4"
                    ],
                    "description": "Use the min-content inline size or min-content block size, as appropriate to the writing mode."
                }
            ],
            "syntax": "none | <length-percentage [0,\u221E]> | min-content | max-content | fit-content | fit-content(<length-percentage [0,\u221E]>) | <calc-size()> | <anchor-size()>",
            "relevance": 91,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/max-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Allows authors to constrain content width to a certain range.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "min-block-size",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C57",
                "CA57",
                "O44"
            ],
            "syntax": "<'min-width'>",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/min-block-size"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Minimal size of an element in the direction opposite that of the direction specified by 'writing-mode'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "min-height",
            "browsers": [
                "E12",
                "FF3",
                "FFA4",
                "S1.3",
                "SM1",
                "C1",
                "CA18",
                "IE7",
                "O4"
            ],
            "values": [
                {
                    "name": "auto",
                    "browsers": [
                        "E12",
                        "FF3",
                        "FFA4",
                        "S1.3",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE7",
                        "O4"
                    ]
                },
                {
                    "name": "fit-content",
                    "browsers": [
                        "E12",
                        "FF3",
                        "FFA4",
                        "S1.3",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE7",
                        "O4"
                    ],
                    "description": "Use the fit-content inline size or fit-content block size, as appropriate to the writing mode."
                },
                {
                    "name": "max-content",
                    "browsers": [
                        "E12",
                        "FF3",
                        "FFA4",
                        "S1.3",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE7",
                        "O4"
                    ],
                    "description": "Use the max-content inline size or max-content block size, as appropriate to the writing mode."
                },
                {
                    "name": "min-content",
                    "browsers": [
                        "E12",
                        "FF3",
                        "FFA4",
                        "S1.3",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE7",
                        "O4"
                    ],
                    "description": "Use the min-content inline size or min-content block size, as appropriate to the writing mode."
                }
            ],
            "syntax": "auto | <length-percentage [0,\u221E]> | min-content | max-content | fit-content | fit-content(<length-percentage [0,\u221E]>) | <calc-size()> | <anchor-size()>",
            "relevance": 89,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/min-height"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Allows authors to constrain content height to a certain range.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "min-inline-size",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C57",
                "CA57",
                "O44"
            ],
            "syntax": "<'min-width'>",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/min-inline-size"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Minimal size of an element in the direction specified by 'writing-mode'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "min-width",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE7",
                "O4"
            ],
            "values": [
                {
                    "name": "auto",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE7",
                        "O4"
                    ]
                },
                {
                    "name": "fit-content",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE7",
                        "O4"
                    ],
                    "description": "Use the fit-content inline size or fit-content block size, as appropriate to the writing mode."
                },
                {
                    "name": "max-content",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE7",
                        "O4"
                    ],
                    "description": "Use the max-content inline size or max-content block size, as appropriate to the writing mode."
                },
                {
                    "name": "min-content",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE7",
                        "O4"
                    ],
                    "description": "Use the min-content inline size or min-content block size, as appropriate to the writing mode."
                }
            ],
            "syntax": "auto | <length-percentage [0,\u221E]> | min-content | max-content | fit-content | fit-content(<length-percentage [0,\u221E]>) | <calc-size()> | <anchor-size()>",
            "relevance": 88,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/min-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Allows authors to constrain content width to a certain range.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "mix-blend-mode",
            "browsers": [
                "E79",
                "FF32",
                "FFA32",
                "S8",
                "SM8",
                "C41",
                "CA41",
                "O28"
            ],
            "values": [
                {
                    "name": "normal",
                    "description": "Default attribute which specifies no blending"
                },
                {
                    "name": "multiply",
                    "description": "The source color is multiplied by the destination color and replaces the destination."
                },
                {
                    "name": "screen",
                    "description": "Multiplies the complements of the backdrop and source color values, then complements the result."
                },
                {
                    "name": "overlay",
                    "description": "Multiplies or screens the colors, depending on the backdrop color value."
                },
                {
                    "name": "darken",
                    "description": "Selects the darker of the backdrop and source colors."
                },
                {
                    "name": "lighten",
                    "description": "Selects the lighter of the backdrop and source colors."
                },
                {
                    "name": "color-dodge",
                    "description": "Brightens the backdrop color to reflect the source color."
                },
                {
                    "name": "color-burn",
                    "description": "Darkens the backdrop color to reflect the source color."
                },
                {
                    "name": "hard-light",
                    "description": "Multiplies or screens the colors, depending on the source color value."
                },
                {
                    "name": "soft-light",
                    "description": "Darkens or lightens the colors, depending on the source color value."
                },
                {
                    "name": "difference",
                    "description": "Subtracts the darker of the two constituent colors from the lighter color.."
                },
                {
                    "name": "exclusion",
                    "description": "Produces an effect similar to that of the Difference mode but lower in contrast."
                },
                {
                    "name": "hue",
                    "browsers": [
                        "E79",
                        "FF32",
                        "FFA32",
                        "S8",
                        "SM8",
                        "C41",
                        "CA41",
                        "O28"
                    ],
                    "description": "Creates a color with the hue of the source color and the saturation and luminosity of the backdrop color."
                },
                {
                    "name": "saturation",
                    "browsers": [
                        "E79",
                        "FF32",
                        "FFA32",
                        "S8",
                        "SM8",
                        "C41",
                        "CA41",
                        "O28"
                    ],
                    "description": "Creates a color with the saturation of the source color and the hue and luminosity of the backdrop color."
                },
                {
                    "name": "color",
                    "browsers": [
                        "E79",
                        "FF32",
                        "FFA32",
                        "S8",
                        "SM8",
                        "C41",
                        "CA41",
                        "O28"
                    ],
                    "description": "Creates a color with the hue and saturation of the source color and the luminosity of the backdrop color."
                },
                {
                    "name": "luminosity",
                    "browsers": [
                        "E79",
                        "FF32",
                        "FFA32",
                        "S8",
                        "SM8",
                        "C41",
                        "CA41",
                        "O28"
                    ],
                    "description": "Creates a color with the luminosity of the source color and the hue and saturation of the backdrop color."
                }
            ],
            "syntax": "<blend-mode> | plus-lighter",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mix-blend-mode"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Defines the formula that must be used to mix the colors with the backdrop.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "motion",
            "browsers": [
                "C46",
                "O33"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No motion path gets created."
                },
                {
                    "name": "path()",
                    "description": "Defines an SVG path as a string, with optional 'fill-rule' as the first argument."
                },
                {
                    "name": "auto",
                    "description": "Indicates that the object is rotated by the angle of the direction of the motion path."
                },
                {
                    "name": "reverse",
                    "description": "Indicates that the object is rotated by the angle of the direction of the motion path plus 180 degrees."
                }
            ],
            "relevance": 50,
            "description": "Shorthand property for setting 'motion-path', 'motion-offset' and 'motion-rotation'.",
            "restrictions": [
                "url",
                "length",
                "percentage",
                "angle",
                "shape",
                "geometry-box",
                "enum"
            ]
        },
        {
            "name": "motion-offset",
            "browsers": [
                "C46",
                "O33"
            ],
            "relevance": 50,
            "description": "A distance that describes the position along the specified motion path.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "motion-path",
            "browsers": [
                "C46",
                "O33"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No motion path gets created."
                },
                {
                    "name": "path()",
                    "description": "Defines an SVG path as a string, with optional 'fill-rule' as the first argument."
                }
            ],
            "relevance": 50,
            "description": "Specifies the motion path the element gets positioned at.",
            "restrictions": [
                "url",
                "shape",
                "geometry-box",
                "enum"
            ]
        },
        {
            "name": "motion-rotation",
            "browsers": [
                "C46",
                "O33"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Indicates that the object is rotated by the angle of the direction of the motion path."
                },
                {
                    "name": "reverse",
                    "description": "Indicates that the object is rotated by the angle of the direction of the motion path plus 180 degrees."
                }
            ],
            "relevance": 50,
            "description": "Defines the direction of the element while positioning along the motion path.",
            "restrictions": [
                "angle"
            ]
        },
        {
            "name": "-moz-animation",
            "browsers": [
                "FF9"
            ],
            "values": [
                {
                    "name": "alternate",
                    "description": "The animation cycle iterations that are odd counts are played in the normal direction, and the animation cycle iterations that are even counts are played in a reverse direction."
                },
                {
                    "name": "alternate-reverse",
                    "description": "The animation cycle iterations that are odd counts are played in the reverse direction, and the animation cycle iterations that are even counts are played in a normal direction."
                },
                {
                    "name": "backwards",
                    "description": "The beginning property value (as defined in the first @keyframes at-rule) is applied before the animation is displayed, during the period defined by 'animation-delay'."
                },
                {
                    "name": "both",
                    "description": "Both forwards and backwards fill modes are applied."
                },
                {
                    "name": "forwards",
                    "description": "The final property value (as defined in the last @keyframes at-rule) is maintained after the animation completes."
                },
                {
                    "name": "infinite",
                    "description": "Causes the animation to repeat forever."
                },
                {
                    "name": "none",
                    "description": "No animation is performed"
                },
                {
                    "name": "normal",
                    "description": "Normal playback."
                },
                {
                    "name": "reverse",
                    "description": "All iterations of the animation are played in the reverse direction from the way they were specified."
                }
            ],
            "relevance": 50,
            "description": "Shorthand property combines six of the animation properties into a single property.",
            "restrictions": [
                "time",
                "enum",
                "timing-function",
                "identifier",
                "number"
            ]
        },
        {
            "name": "-moz-animation-delay",
            "browsers": [
                "FF9"
            ],
            "relevance": 50,
            "description": "Defines when the animation will start.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "-moz-animation-direction",
            "browsers": [
                "FF9"
            ],
            "values": [
                {
                    "name": "alternate",
                    "description": "The animation cycle iterations that are odd counts are played in the normal direction, and the animation cycle iterations that are even counts are played in a reverse direction."
                },
                {
                    "name": "alternate-reverse",
                    "description": "The animation cycle iterations that are odd counts are played in the reverse direction, and the animation cycle iterations that are even counts are played in a normal direction."
                },
                {
                    "name": "normal",
                    "description": "Normal playback."
                },
                {
                    "name": "reverse",
                    "description": "All iterations of the animation are played in the reverse direction from the way they were specified."
                }
            ],
            "relevance": 50,
            "description": "Defines whether or not the animation should play in reverse on alternate cycles.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-moz-animation-duration",
            "browsers": [
                "FF9"
            ],
            "relevance": 50,
            "description": "Defines the length of time that an animation takes to complete one cycle.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "-moz-animation-iteration-count",
            "browsers": [
                "FF9"
            ],
            "values": [
                {
                    "name": "infinite",
                    "description": "Causes the animation to repeat forever."
                }
            ],
            "relevance": 50,
            "description": "Defines the number of times an animation cycle is played. The default value is one, meaning the animation will play from beginning to end once.",
            "restrictions": [
                "number",
                "enum"
            ]
        },
        {
            "name": "-moz-animation-name",
            "browsers": [
                "FF9"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No animation is performed"
                }
            ],
            "relevance": 50,
            "description": "Defines a list of animations that apply. Each name is used to select the keyframe at-rule that provides the property values for the animation.",
            "restrictions": [
                "identifier",
                "enum"
            ]
        },
        {
            "name": "-moz-animation-play-state",
            "browsers": [
                "FF9"
            ],
            "values": [
                {
                    "name": "paused",
                    "description": "A running animation will be paused."
                },
                {
                    "name": "running",
                    "description": "Resume playback of a paused animation."
                }
            ],
            "relevance": 50,
            "description": "Defines whether the animation is running or paused.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-moz-animation-timing-function",
            "browsers": [
                "FF9"
            ],
            "relevance": 50,
            "description": "Describes how the animation will progress over one cycle of its duration. See the 'transition-timing-function'.",
            "restrictions": [
                "timing-function"
            ]
        },
        {
            "name": "-moz-appearance",
            "browsers": [
                "FF1"
            ],
            "values": [
                {
                    "name": "button"
                },
                {
                    "name": "button-arrow-down"
                },
                {
                    "name": "button-arrow-next"
                },
                {
                    "name": "button-arrow-previous"
                },
                {
                    "name": "button-arrow-up"
                },
                {
                    "name": "button-bevel"
                },
                {
                    "name": "checkbox"
                },
                {
                    "name": "checkbox-container"
                },
                {
                    "name": "checkbox-label"
                },
                {
                    "name": "dialog"
                },
                {
                    "name": "groupbox"
                },
                {
                    "name": "listbox"
                },
                {
                    "name": "menuarrow"
                },
                {
                    "name": "menuimage"
                },
                {
                    "name": "menuitem"
                },
                {
                    "name": "menuitemtext"
                },
                {
                    "name": "menulist"
                },
                {
                    "name": "menulist-button"
                },
                {
                    "name": "menulist-text"
                },
                {
                    "name": "menulist-textfield"
                },
                {
                    "name": "menupopup"
                },
                {
                    "name": "menuradio"
                },
                {
                    "name": "menuseparator"
                },
                {
                    "name": "-moz-mac-unified-toolbar"
                },
                {
                    "name": "-moz-win-borderless-glass"
                },
                {
                    "name": "-moz-win-browsertabbar-toolbox"
                },
                {
                    "name": "-moz-win-communications-toolbox"
                },
                {
                    "name": "-moz-win-glass"
                },
                {
                    "name": "-moz-win-media-toolbox"
                },
                {
                    "name": "none"
                },
                {
                    "name": "progressbar"
                },
                {
                    "name": "progresschunk"
                },
                {
                    "name": "radio"
                },
                {
                    "name": "radio-container"
                },
                {
                    "name": "radio-label"
                },
                {
                    "name": "radiomenuitem"
                },
                {
                    "name": "resizer"
                },
                {
                    "name": "resizerpanel"
                },
                {
                    "name": "scrollbarbutton-down"
                },
                {
                    "name": "scrollbarbutton-left"
                },
                {
                    "name": "scrollbarbutton-right"
                },
                {
                    "name": "scrollbarbutton-up"
                },
                {
                    "name": "scrollbar-small"
                },
                {
                    "name": "scrollbartrack-horizontal"
                },
                {
                    "name": "scrollbartrack-vertical"
                },
                {
                    "name": "separator"
                },
                {
                    "name": "spinner"
                },
                {
                    "name": "spinner-downbutton"
                },
                {
                    "name": "spinner-textfield"
                },
                {
                    "name": "spinner-upbutton"
                },
                {
                    "name": "statusbar"
                },
                {
                    "name": "statusbarpanel"
                },
                {
                    "name": "tab"
                },
                {
                    "name": "tabpanels"
                },
                {
                    "name": "tab-scroll-arrow-back"
                },
                {
                    "name": "tab-scroll-arrow-forward"
                },
                {
                    "name": "textfield"
                },
                {
                    "name": "textfield-multiline"
                },
                {
                    "name": "toolbar"
                },
                {
                    "name": "toolbox"
                },
                {
                    "name": "tooltip"
                },
                {
                    "name": "treeheadercell"
                },
                {
                    "name": "treeheadersortarrow"
                },
                {
                    "name": "treeitem"
                },
                {
                    "name": "treetwistyopen"
                },
                {
                    "name": "treeview"
                },
                {
                    "name": "treewisty"
                },
                {
                    "name": "window"
                }
            ],
            "status": "nonstandard",
            "syntax": "none | button | button-arrow-down | button-arrow-next | button-arrow-previous | button-arrow-up | button-bevel | button-focus | caret | checkbox | checkbox-container | checkbox-label | checkmenuitem | dualbutton | groupbox | listbox | listitem | menuarrow | menubar | menucheckbox | menuimage | menuitem | menuitemtext | menulist | menulist-button | menulist-text | menulist-textfield | menupopup | menuradio | menuseparator | meterbar | meterchunk | progressbar | progressbar-vertical | progresschunk | progresschunk-vertical | radio | radio-container | radio-label | radiomenuitem | range | range-thumb | resizer | resizerpanel | scale-horizontal | scalethumbend | scalethumb-horizontal | scalethumbstart | scalethumbtick | scalethumb-vertical | scale-vertical | scrollbarbutton-down | scrollbarbutton-left | scrollbarbutton-right | scrollbarbutton-up | scrollbarthumb-horizontal | scrollbarthumb-vertical | scrollbartrack-horizontal | scrollbartrack-vertical | searchfield | separator | sheet | spinner | spinner-downbutton | spinner-textfield | spinner-upbutton | splitter | statusbar | statusbarpanel | tab | tabpanel | tabpanels | tab-scroll-arrow-back | tab-scroll-arrow-forward | textfield | textfield-multiline | toolbar | toolbarbutton | toolbarbutton-dropdown | toolbargripper | toolbox | tooltip | treeheader | treeheadercell | treeheadersortarrow | treeitem | treeline | treetwisty | treetwistyopen | treeview | -moz-mac-unified-toolbar | -moz-win-borderless-glass | -moz-win-browsertabbar-toolbox | -moz-win-communicationstext | -moz-win-communications-toolbox | -moz-win-exclude-glass | -moz-win-glass | -moz-win-mediatext | -moz-win-media-toolbox | -moz-window-button-box | -moz-window-button-box-maximized | -moz-window-button-close | -moz-window-button-maximize | -moz-window-button-minimize | -moz-window-button-restore | -moz-window-frame-bottom | -moz-window-frame-left | -moz-window-frame-right | -moz-window-titlebar | -moz-window-titlebar-maximized",
            "relevance": 0,
            "description": "Used in Gecko (Firefox) to display an element using a platform-native styling based on the operating system's theme.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-moz-backface-visibility",
            "browsers": [
                "FF10"
            ],
            "values": [
                {
                    "name": "hidden"
                },
                {
                    "name": "visible"
                }
            ],
            "relevance": 50,
            "description": "Determines whether or not the 'back' side of a transformed element is visible when facing the viewer. With an identity transform, the front side of an element faces the viewer.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-moz-background-clip",
            "browsers": [
                "FF1-3.6"
            ],
            "values": [
                {
                    "name": "padding"
                }
            ],
            "relevance": 50,
            "description": "Determines the background painting area.",
            "restrictions": [
                "box",
                "enum"
            ]
        },
        {
            "name": "-moz-background-inline-policy",
            "browsers": [
                "FF1"
            ],
            "values": [
                {
                    "name": "bounding-box"
                },
                {
                    "name": "continuous"
                },
                {
                    "name": "each-box"
                }
            ],
            "relevance": 50,
            "description": "In Gecko-based applications like Firefox, the -moz-background-inline-policy CSS property specifies how the background image of an inline element is determined when the content of the inline element wraps onto multiple lines. The choice of position has significant effects on repetition.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-moz-background-origin",
            "browsers": [
                "FF1"
            ],
            "relevance": 50,
            "description": "For elements rendered as a single box, specifies the background positioning area. For elements rendered as multiple boxes (e.g., inline boxes on several lines, boxes on several pages) specifies which boxes 'box-decoration-break' operates on to determine the background positioning area(s).",
            "restrictions": [
                "box"
            ]
        },
        {
            "name": "-moz-border-bottom-colors",
            "browsers": [
                "FF1"
            ],
            "status": "nonstandard",
            "syntax": "<color>+ | none",
            "relevance": 0,
            "description": "Sets a list of colors for the bottom border.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-moz-border-image",
            "browsers": [
                "FF3.6"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "If 'auto' is specified then the border image width is the intrinsic width or height (whichever is applicable) of the corresponding image slice. If the image does not have the required intrinsic dimension then the corresponding border-width is used instead."
                },
                {
                    "name": "fill",
                    "description": "Causes the middle part of the border-image to be preserved."
                },
                {
                    "name": "none"
                },
                {
                    "name": "repeat",
                    "description": "The image is tiled (repeated) to fill the area."
                },
                {
                    "name": "round",
                    "description": "The image is tiled (repeated) to fill the area. If it does not fill the area with a whole number of tiles, the image is rescaled so that it does."
                },
                {
                    "name": "space",
                    "description": "The image is tiled (repeated) to fill the area. If it does not fill the area with a whole number of tiles, the extra space is distributed around the tiles."
                },
                {
                    "name": "stretch",
                    "description": "The image is stretched to fill the area."
                },
                {
                    "name": "url()"
                }
            ],
            "relevance": 50,
            "description": "Shorthand property for setting 'border-image-source', 'border-image-slice', 'border-image-width', 'border-image-outset' and 'border-image-repeat'. Omitted values are set to their initial values.",
            "restrictions": [
                "length",
                "percentage",
                "number",
                "url",
                "enum"
            ]
        },
        {
            "name": "-moz-border-left-colors",
            "browsers": [
                "FF1"
            ],
            "status": "nonstandard",
            "syntax": "<color>+ | none",
            "relevance": 0,
            "description": "Sets a list of colors for the bottom border.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-moz-border-right-colors",
            "browsers": [
                "FF1"
            ],
            "status": "nonstandard",
            "syntax": "<color>+ | none",
            "relevance": 0,
            "description": "Sets a list of colors for the bottom border.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-moz-border-top-colors",
            "browsers": [
                "FF1"
            ],
            "status": "nonstandard",
            "syntax": "<color>+ | none",
            "relevance": 0,
            "description": "Ske Firefox, -moz-border-bottom-colors sets a list of colors for the bottom border.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-moz-box-align",
            "browsers": [
                "FF1"
            ],
            "values": [
                {
                    "name": "baseline",
                    "description": "If this box orientation is inline-axis or horizontal, all children are placed with their baselines aligned, and extra space placed before or after as necessary. For block flows, the baseline of the first non-empty line box located within the element is used. For tables, the baseline of the first cell is used."
                },
                {
                    "name": "center",
                    "description": "Any extra space is divided evenly, with half placed above the child and the other half placed after the child."
                },
                {
                    "name": "end",
                    "description": "For normal direction boxes, the bottom edge of each child is placed along the bottom of the box. Extra space is placed above the element. For reverse direction boxes, the top edge of each child is placed along the top of the box. Extra space is placed below the element."
                },
                {
                    "name": "start",
                    "description": "For normal direction boxes, the top edge of each child is placed along the top of the box. Extra space is placed below the element. For reverse direction boxes, the bottom edge of each child is placed along the bottom of the box. Extra space is placed above the element."
                },
                {
                    "name": "stretch",
                    "description": "The height of each child is adjusted to that of the containing block."
                }
            ],
            "relevance": 50,
            "description": "Specifies how a XUL box aligns its contents across (perpendicular to) the direction of its layout. The effect of this is only visible if there is extra space in the box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-moz-box-direction",
            "browsers": [
                "FF1"
            ],
            "values": [
                {
                    "name": "normal",
                    "description": "A box with a computed value of horizontal for box-orient displays its children from left to right. A box with a computed value of vertical displays its children from top to bottom."
                },
                {
                    "name": "reverse",
                    "description": "A box with a computed value of horizontal for box-orient displays its children from right to left. A box with a computed value of vertical displays its children from bottom to top."
                }
            ],
            "relevance": 50,
            "description": "Specifies whether a box lays out its contents normally (from the top or left edge), or in reverse (from the bottom or right edge).",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-moz-box-flex",
            "browsers": [
                "FF1"
            ],
            "relevance": 50,
            "description": "Specifies how a box grows to fill the box that contains it, in the direction of the containing box's layout.",
            "restrictions": [
                "number"
            ]
        },
        {
            "name": "-moz-box-flexgroup",
            "browsers": [
                "FF1"
            ],
            "relevance": 50,
            "description": "Flexible elements can be assigned to flex groups using the 'box-flex-group' property.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "-moz-box-ordinal-group",
            "browsers": [
                "FF1"
            ],
            "relevance": 50,
            "description": "Indicates the ordinal group the element belongs to. Elements with a lower ordinal group are displayed before those with a higher ordinal group.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "-moz-box-orient",
            "browsers": [
                "FF1"
            ],
            "values": [
                {
                    "name": "block-axis",
                    "description": "Elements are oriented along the box's axis."
                },
                {
                    "name": "horizontal",
                    "description": "The box displays its children from left to right in a horizontal line."
                },
                {
                    "name": "inline-axis",
                    "description": "Elements are oriented vertically."
                },
                {
                    "name": "vertical",
                    "description": "The box displays its children from stacked from top to bottom vertically."
                }
            ],
            "relevance": 50,
            "description": "In Mozilla applications, -moz-box-orient specifies whether a box lays out its contents horizontally or vertically.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-moz-box-pack",
            "browsers": [
                "FF1"
            ],
            "values": [
                {
                    "name": "center",
                    "description": "The extra space is divided evenly, with half placed before the first child and the other half placed after the last child."
                },
                {
                    "name": "end",
                    "description": "For normal direction boxes, the right edge of the last child is placed at the right side, with all extra space placed before the first child. For reverse direction boxes, the left edge of the first child is placed at the left side, with all extra space placed after the last child."
                },
                {
                    "name": "justify",
                    "description": "The space is divided evenly in-between each child, with none of the extra space placed before the first child or after the last child. If there is only one child, treat the pack value as if it were start."
                },
                {
                    "name": "start",
                    "description": "For normal direction boxes, the left edge of the first child is placed at the left side, with all extra space placed after the last child. For reverse direction boxes, the right edge of the last child is placed at the right side, with all extra space placed before the first child."
                }
            ],
            "relevance": 50,
            "description": "Specifies how a box packs its contents in the direction of its layout. The effect of this is only visible if there is extra space in the box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-moz-box-sizing",
            "browsers": [
                "FF1"
            ],
            "values": [
                {
                    "name": "border-box",
                    "description": "The specified width and height (and respective min/max properties) on this element determine the border box of the element."
                },
                {
                    "name": "content-box",
                    "description": "Behavior of width and height as specified by CSS2.1. The specified width and height (and respective min/max properties) apply to the width and height respectively of the content box of the element."
                },
                {
                    "name": "padding-box",
                    "description": "The specified width and height (and respective min/max properties) on this element determine the padding box of the element."
                }
            ],
            "relevance": 50,
            "description": "Box Model addition in CSS3.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-moz-column-count",
            "browsers": [
                "FF3.5"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Determines the number of columns by the 'column-width' property and the element width."
                }
            ],
            "relevance": 50,
            "description": "Describes the optimal number of columns into which the content of the element will be flowed.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "-moz-column-gap",
            "browsers": [
                "FF3.5"
            ],
            "values": [
                {
                    "name": "normal",
                    "description": "User agent specific and typically equivalent to 1em."
                }
            ],
            "relevance": 50,
            "description": "Sets the gap between columns. If there is a column rule between columns, it will appear in the middle of the gap.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "-moz-column-rule",
            "browsers": [
                "FF3.5"
            ],
            "relevance": 50,
            "description": "Shorthand for setting 'column-rule-width', 'column-rule-style', and 'column-rule-color' at the same place in the style sheet. Omitted values are set to their initial values.",
            "restrictions": [
                "length",
                "line-width",
                "line-style",
                "color"
            ]
        },
        {
            "name": "-moz-column-rule-color",
            "browsers": [
                "FF3.5"
            ],
            "relevance": 50,
            "description": "Sets the color of the column rule",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-moz-column-rule-style",
            "browsers": [
                "FF3.5"
            ],
            "relevance": 50,
            "description": "Sets the style of the rule between columns of an element.",
            "restrictions": [
                "line-style"
            ]
        },
        {
            "name": "-moz-column-rule-width",
            "browsers": [
                "FF3.5"
            ],
            "relevance": 50,
            "description": "Sets the width of the rule between columns. Negative values are not allowed.",
            "restrictions": [
                "length",
                "line-width"
            ]
        },
        {
            "name": "-moz-columns",
            "browsers": [
                "FF9"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The width depends on the values of other properties."
                }
            ],
            "relevance": 50,
            "description": "A shorthand property which sets both 'column-width' and 'column-count'.",
            "restrictions": [
                "length",
                "integer"
            ]
        },
        {
            "name": "-moz-column-width",
            "browsers": [
                "FF3.5"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The width depends on the values of other properties."
                }
            ],
            "relevance": 50,
            "description": "This property describes the width of columns in multicol elements.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "-moz-font-feature-settings",
            "browsers": [
                "FF4"
            ],
            "values": [
                {
                    "name": "\"c2cs\""
                },
                {
                    "name": "\"dlig\""
                },
                {
                    "name": "\"kern\""
                },
                {
                    "name": "\"liga\""
                },
                {
                    "name": "\"lnum\""
                },
                {
                    "name": "\"onum\""
                },
                {
                    "name": "\"smcp\""
                },
                {
                    "name": "\"swsh\""
                },
                {
                    "name": "\"tnum\""
                },
                {
                    "name": "normal",
                    "description": "No change in glyph substitution or positioning occurs."
                },
                {
                    "name": "off",
                    "browsers": [
                        "FF4"
                    ]
                },
                {
                    "name": "on",
                    "browsers": [
                        "FF4"
                    ]
                }
            ],
            "relevance": 50,
            "description": "Provides low-level control over OpenType font features. It is intended as a way of providing access to font features that are not widely used but are needed for a particular use case.",
            "restrictions": [
                "string",
                "integer"
            ]
        },
        {
            "name": "-moz-hyphens",
            "browsers": [
                "FF9"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Conditional hyphenation characters inside a word, if present, take priority over automatic resources when determining hyphenation points within the word."
                },
                {
                    "name": "manual",
                    "description": "Words are only broken at line breaks where there are characters inside the word that suggest line break opportunities"
                },
                {
                    "name": "none",
                    "description": "Words are not broken at line breaks, even if characters inside the word suggest line break points."
                }
            ],
            "relevance": 50,
            "description": "Controls whether hyphenation is allowed to create more break opportunities within a line of text.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-moz-perspective",
            "browsers": [
                "FF10"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No perspective transform is applied."
                }
            ],
            "relevance": 50,
            "description": "Applies the same transform as the perspective(<number>) transform function, except that it applies only to the positioned or transformed children of the element, not to the transform on the element itself.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "-moz-perspective-origin",
            "browsers": [
                "FF10"
            ],
            "relevance": 50,
            "description": "Establishes the origin for the perspective property. It effectively sets the X and Y position at which the viewer appears to be looking at the children of the element.",
            "restrictions": [
                "position",
                "percentage",
                "length"
            ]
        },
        {
            "name": "-moz-text-align-last",
            "browsers": [
                "FF12"
            ],
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "center",
                    "description": "The inline contents are centered within the line box."
                },
                {
                    "name": "justify",
                    "description": "The text is justified according to the method specified by the 'text-justify' property."
                },
                {
                    "name": "left",
                    "description": "The inline contents are aligned to the left edge of the line box. In vertical text, 'left' aligns to the edge of the line box that would be the start edge for left-to-right text."
                },
                {
                    "name": "right",
                    "description": "The inline contents are aligned to the right edge of the line box. In vertical text, 'right' aligns to the edge of the line box that would be the end edge for left-to-right text."
                }
            ],
            "relevance": 50,
            "description": "Describes how the last line of a block or a line right before a forced line break is aligned when 'text-align' is set to 'justify'.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-moz-text-decoration-color",
            "browsers": [
                "FF6"
            ],
            "relevance": 50,
            "description": "Specifies the color of text decoration (underlines overlines, and line-throughs) set on the element with text-decoration-line.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-moz-text-decoration-line",
            "browsers": [
                "FF6"
            ],
            "values": [
                {
                    "name": "line-through",
                    "description": "Each line of text has a line through the middle."
                },
                {
                    "name": "none",
                    "description": "Neither produces nor inhibits text decoration."
                },
                {
                    "name": "overline",
                    "description": "Each line of text has a line above it."
                },
                {
                    "name": "underline",
                    "description": "Each line of text is underlined."
                }
            ],
            "relevance": 50,
            "description": "Specifies what line decorations, if any, are added to the element.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-moz-text-decoration-style",
            "browsers": [
                "FF6"
            ],
            "values": [
                {
                    "name": "dashed",
                    "description": "Produces a dashed line style."
                },
                {
                    "name": "dotted",
                    "description": "Produces a dotted line."
                },
                {
                    "name": "double",
                    "description": "Produces a double line."
                },
                {
                    "name": "none",
                    "description": "Produces no line."
                },
                {
                    "name": "solid",
                    "description": "Produces a solid line."
                },
                {
                    "name": "wavy",
                    "description": "Produces a wavy line."
                }
            ],
            "relevance": 50,
            "description": "Specifies the line style for underline, line-through and overline text decoration.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-moz-text-size-adjust",
            "browsers": [
                "FF"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Renderers must use the default size adjustment when displaying on a small device."
                },
                {
                    "name": "none",
                    "description": "Renderers must not do size adjustment when displaying on a small device."
                }
            ],
            "relevance": 50,
            "description": "Specifies a size adjustment for displaying text content in mobile browsers.",
            "restrictions": [
                "enum",
                "percentage"
            ]
        },
        {
            "name": "-moz-transform",
            "browsers": [
                "FF3.5"
            ],
            "values": [
                {
                    "name": "matrix()",
                    "description": "Specifies a 2D transformation in the form of a transformation matrix of six values. matrix(a,b,c,d,e,f) is equivalent to applying the transformation matrix [a b c d e f]"
                },
                {
                    "name": "matrix3d()",
                    "description": "Specifies a 3D transformation as a 4x4 homogeneous matrix of 16 values in column-major order."
                },
                {
                    "name": "none"
                },
                {
                    "name": "perspective",
                    "description": "Specifies a perspective projection matrix."
                },
                {
                    "name": "rotate()",
                    "description": "Specifies a 2D rotation by the angle specified in the parameter about the origin of the element, as defined by the transform-origin property."
                },
                {
                    "name": "rotate3d()",
                    "description": "Specifies a clockwise 3D rotation by the angle specified in last parameter about the [x,y,z] direction vector described by the first 3 parameters."
                },
                {
                    "name": "rotateX('angle')",
                    "description": "Specifies a clockwise rotation by the given angle about the X axis."
                },
                {
                    "name": "rotateY('angle')",
                    "description": "Specifies a clockwise rotation by the given angle about the Y axis."
                },
                {
                    "name": "rotateZ('angle')",
                    "description": "Specifies a clockwise rotation by the given angle about the Z axis."
                },
                {
                    "name": "scale()",
                    "description": "Specifies a 2D scale operation by the [sx,sy] scaling vector described by the 2 parameters. If the second parameter is not provided, it is takes a value equal to the first."
                },
                {
                    "name": "scale3d()",
                    "description": "Specifies a 3D scale operation by the [sx,sy,sz] scaling vector described by the 3 parameters."
                },
                {
                    "name": "scaleX()",
                    "description": "Specifies a scale operation using the [sx,1] scaling vector, where sx is given as the parameter."
                },
                {
                    "name": "scaleY()",
                    "description": "Specifies a scale operation using the [sy,1] scaling vector, where sy is given as the parameter."
                },
                {
                    "name": "scaleZ()",
                    "description": "Specifies a scale operation using the [1,1,sz] scaling vector, where sz is given as the parameter."
                },
                {
                    "name": "skew()",
                    "description": "Specifies a skew transformation along the X and Y axes. The first angle parameter specifies the skew on the X axis. The second angle parameter specifies the skew on the Y axis. If the second parameter is not given then a value of 0 is used for the Y angle (ie: no skew on the Y axis)."
                },
                {
                    "name": "skewX()",
                    "description": "Specifies a skew transformation along the X axis by the given angle."
                },
                {
                    "name": "skewY()",
                    "description": "Specifies a skew transformation along the Y axis by the given angle."
                },
                {
                    "name": "translate()",
                    "description": "Specifies a 2D translation by the vector [tx, ty], where tx is the first translation-value parameter and ty is the optional second translation-value parameter."
                },
                {
                    "name": "translate3d()",
                    "description": "Specifies a 3D translation by the vector [tx,ty,tz], with tx, ty and tz being the first, second and third translation-value parameters respectively."
                },
                {
                    "name": "translateX()",
                    "description": "Specifies a translation by the given amount in the X direction."
                },
                {
                    "name": "translateY()",
                    "description": "Specifies a translation by the given amount in the Y direction."
                },
                {
                    "name": "translateZ()",
                    "description": "Specifies a translation by the given amount in the Z direction. Note that percentage values are not allowed in the translateZ translation-value, and if present are evaluated as 0."
                }
            ],
            "relevance": 50,
            "description": "A two-dimensional transformation is applied to an element through the 'transform' property. This property contains a list of transform functions similar to those allowed by SVG.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-moz-transform-origin",
            "browsers": [
                "FF3.5"
            ],
            "relevance": 50,
            "description": "Establishes the origin of transformation for an element.",
            "restrictions": [
                "position",
                "length",
                "percentage"
            ]
        },
        {
            "name": "-moz-transition",
            "browsers": [
                "FF4"
            ],
            "values": [
                {
                    "name": "all",
                    "description": "Every property that is able to undergo a transition will do so."
                },
                {
                    "name": "none",
                    "description": "No property will transition."
                }
            ],
            "relevance": 50,
            "description": "Shorthand property combines four of the transition properties into a single property.",
            "restrictions": [
                "time",
                "property",
                "timing-function",
                "enum"
            ]
        },
        {
            "name": "-moz-transition-delay",
            "browsers": [
                "FF4"
            ],
            "relevance": 50,
            "description": "Defines when the transition will start. It allows a transition to begin execution some period of time from when it is applied.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "-moz-transition-duration",
            "browsers": [
                "FF4"
            ],
            "relevance": 50,
            "description": "Specifies how long the transition from the old value to the new value should take.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "-moz-transition-property",
            "browsers": [
                "FF4"
            ],
            "values": [
                {
                    "name": "all",
                    "description": "Every property that is able to undergo a transition will do so."
                },
                {
                    "name": "none",
                    "description": "No property will transition."
                }
            ],
            "relevance": 50,
            "description": "Specifies the name of the CSS property to which the transition is applied.",
            "restrictions": [
                "property"
            ]
        },
        {
            "name": "-moz-transition-timing-function",
            "browsers": [
                "FF4"
            ],
            "relevance": 50,
            "description": "Describes how the intermediate values used during a transition will be calculated.",
            "restrictions": [
                "timing-function"
            ]
        },
        {
            "name": "-moz-user-focus",
            "values": [
                {
                    "name": "ignore"
                },
                {
                    "name": "normal"
                }
            ],
            "status": "obsolete",
            "syntax": "ignore | normal | select-after | select-before | select-menu | select-same | select-all | none",
            "relevance": 0,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-moz-user-focus"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Used to indicate whether the element can have focus."
        },
        {
            "name": "-moz-user-select",
            "browsers": [
                "FF1.5"
            ],
            "values": [
                {
                    "name": "all"
                },
                {
                    "name": "element"
                },
                {
                    "name": "elements"
                },
                {
                    "name": "-moz-all"
                },
                {
                    "name": "-moz-none"
                },
                {
                    "name": "none"
                },
                {
                    "name": "text"
                },
                {
                    "name": "toggle"
                }
            ],
            "relevance": 50,
            "description": "Controls the appearance of selection.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-accelerator",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "false",
                    "description": "The element does not contain an accelerator key sequence."
                },
                {
                    "name": "true",
                    "description": "The element contains an accelerator key sequence."
                }
            ],
            "status": "nonstandard",
            "syntax": "false | true",
            "relevance": 0,
            "description": "IE only. Has the ability to turn off its system underlines for accelerator keys until the ALT key is pressed",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-behavior",
            "browsers": [
                "IE8"
            ],
            "relevance": 50,
            "description": "IE only. Used to extend behaviors of the browser",
            "restrictions": [
                "url"
            ]
        },
        {
            "name": "-ms-block-progression",
            "browsers": [
                "IE8"
            ],
            "values": [
                {
                    "name": "bt",
                    "description": "Bottom-to-top block flow. Layout is horizontal."
                },
                {
                    "name": "lr",
                    "description": "Left-to-right direction. The flow orientation is vertical."
                },
                {
                    "name": "rl",
                    "description": "Right-to-left direction. The flow orientation is vertical."
                },
                {
                    "name": "tb",
                    "description": "Top-to-bottom direction. The flow orientation is horizontal."
                }
            ],
            "status": "nonstandard",
            "syntax": "tb | rl | bt | lr",
            "relevance": 0,
            "description": "Sets the block-progression value and the flow orientation",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-content-zoom-chaining",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "chained",
                    "description": "The nearest zoomable parent element begins zooming when the user hits a zoom limit during a manipulation. No bounce effect is shown."
                },
                {
                    "name": "none",
                    "description": "A bounce effect is shown when the user hits a zoom limit during a manipulation."
                }
            ],
            "status": "nonstandard",
            "syntax": "none | chained",
            "relevance": 0,
            "description": "Specifies the zoom behavior that occurs when a user hits the zoom limit during a manipulation."
        },
        {
            "name": "-ms-content-zooming",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "The element is not zoomable."
                },
                {
                    "name": "zoom",
                    "description": "The element is zoomable."
                }
            ],
            "status": "nonstandard",
            "syntax": "none | zoom",
            "relevance": 0,
            "description": "Specifies whether zooming is enabled.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-content-zoom-limit",
            "browsers": [
                "E",
                "IE10"
            ],
            "status": "nonstandard",
            "syntax": "<'-ms-content-zoom-limit-min'> <'-ms-content-zoom-limit-max'>",
            "relevance": 0,
            "description": "Shorthand property for the -ms-content-zoom-limit-min and -ms-content-zoom-limit-max properties.",
            "restrictions": [
                "percentage"
            ]
        },
        {
            "name": "-ms-content-zoom-limit-max",
            "browsers": [
                "E",
                "IE10"
            ],
            "status": "nonstandard",
            "syntax": "<percentage>",
            "relevance": 0,
            "description": "Specifies the maximum zoom factor.",
            "restrictions": [
                "percentage"
            ]
        },
        {
            "name": "-ms-content-zoom-limit-min",
            "browsers": [
                "E",
                "IE10"
            ],
            "status": "nonstandard",
            "syntax": "<percentage>",
            "relevance": 0,
            "description": "Specifies the minimum zoom factor.",
            "restrictions": [
                "percentage"
            ]
        },
        {
            "name": "-ms-content-zoom-snap",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "mandatory",
                    "description": "Indicates that the motion of the content after the contact is picked up is always adjusted so that it lands on a snap-point."
                },
                {
                    "name": "none",
                    "description": "Indicates that zooming is unaffected by any defined snap-points."
                },
                {
                    "name": "proximity",
                    "description": "Indicates that the motion of the content after the contact is picked up may be adjusted if the content would normally stop \"close enough\" to a snap-point."
                },
                {
                    "name": "snapInterval(100%, 100%)",
                    "description": "Specifies where the snap-points will be placed."
                },
                {
                    "name": "snapList()",
                    "description": "Specifies the position of individual snap-points as a comma-separated list of zoom factors."
                }
            ],
            "status": "nonstandard",
            "syntax": "<'-ms-content-zoom-snap-type'> || <'-ms-content-zoom-snap-points'>",
            "relevance": 0,
            "description": "Shorthand property for the -ms-content-zoom-snap-type and -ms-content-zoom-snap-points properties."
        },
        {
            "name": "-ms-content-zoom-snap-points",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "snapInterval(100%, 100%)",
                    "description": "Specifies where the snap-points will be placed."
                },
                {
                    "name": "snapList()",
                    "description": "Specifies the position of individual snap-points as a comma-separated list of zoom factors."
                }
            ],
            "status": "nonstandard",
            "syntax": "snapInterval( <percentage>, <percentage> ) | snapList( <percentage># )",
            "relevance": 0,
            "description": "Defines where zoom snap-points are located."
        },
        {
            "name": "-ms-content-zoom-snap-type",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "mandatory",
                    "description": "Indicates that the motion of the content after the contact is picked up is always adjusted so that it lands on a snap-point."
                },
                {
                    "name": "none",
                    "description": "Indicates that zooming is unaffected by any defined snap-points."
                },
                {
                    "name": "proximity",
                    "description": "Indicates that the motion of the content after the contact is picked up may be adjusted if the content would normally stop \"close enough\" to a snap-point."
                }
            ],
            "status": "nonstandard",
            "syntax": "none | proximity | mandatory",
            "relevance": 0,
            "description": "Specifies how zooming is affected by defined snap-points.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-filter",
            "browsers": [
                "IE8-9"
            ],
            "status": "nonstandard",
            "syntax": "<string>",
            "relevance": 0,
            "description": "IE only. Used to produce visual effects.",
            "restrictions": [
                "string"
            ]
        },
        {
            "name": "-ms-flex",
            "browsers": [
                "IE10"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Retrieves the value of the main size property as the used 'flex-basis'."
                },
                {
                    "name": "none",
                    "description": "Expands to '0 0 auto'."
                }
            ],
            "relevance": 50,
            "description": "specifies the parameters of a flexible length: the positive and negative flexibility, and the preferred size.",
            "restrictions": [
                "length",
                "number",
                "percentage"
            ]
        },
        {
            "name": "-ms-flex-align",
            "browsers": [
                "IE10"
            ],
            "values": [
                {
                    "name": "baseline",
                    "description": "If the flex item's inline axis is the same as the cross axis, this value is identical to 'flex-start'. Otherwise, it participates in baseline alignment."
                },
                {
                    "name": "center",
                    "description": "The flex item's margin box is centered in the cross axis within the line."
                },
                {
                    "name": "end",
                    "description": "The cross-end margin edge of the flex item is placed flush with the cross-end edge of the line."
                },
                {
                    "name": "start",
                    "description": "The cross-start margin edge of the flexbox item is placed flush with the cross-start edge of the line."
                },
                {
                    "name": "stretch",
                    "description": "If the cross size property of the flexbox item is anything other than 'auto', this value is identical to 'start'."
                }
            ],
            "relevance": 50,
            "description": "Aligns flex items along the cross axis of the current line of the flex container.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-flex-direction",
            "browsers": [
                "IE10"
            ],
            "values": [
                {
                    "name": "column",
                    "description": "The flex container's main axis has the same orientation as the block axis of the current writing mode."
                },
                {
                    "name": "column-reverse",
                    "description": "Same as 'column', except the main-start and main-end directions are swapped."
                },
                {
                    "name": "row",
                    "description": "The flex container's main axis has the same orientation as the inline axis of the current writing mode."
                },
                {
                    "name": "row-reverse",
                    "description": "Same as 'row', except the main-start and main-end directions are swapped."
                }
            ],
            "relevance": 50,
            "description": "Specifies how flex items are placed in the flex container, by setting the direction of the flex container's main axis.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-flex-flow",
            "browsers": [
                "IE10"
            ],
            "values": [
                {
                    "name": "column",
                    "description": "The flex container's main axis has the same orientation as the block axis of the current writing mode."
                },
                {
                    "name": "column-reverse",
                    "description": "Same as 'column', except the main-start and main-end directions are swapped."
                },
                {
                    "name": "nowrap",
                    "description": "The flex container is single-line."
                },
                {
                    "name": "row",
                    "description": "The flex container's main axis has the same orientation as the inline axis of the current writing mode."
                },
                {
                    "name": "wrap",
                    "description": "The flexbox is multi-line."
                },
                {
                    "name": "wrap-reverse",
                    "description": "Same as 'wrap', except the cross-start and cross-end directions are swapped."
                }
            ],
            "relevance": 50,
            "description": "Specifies how flexbox items are placed in the flexbox.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-flex-item-align",
            "browsers": [
                "IE10"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Computes to the value of 'align-items' on the element's parent, or 'stretch' if the element has no parent. On absolutely positioned elements, it computes to itself."
                },
                {
                    "name": "baseline",
                    "description": "If the flex item's inline axis is the same as the cross axis, this value is identical to 'flex-start'. Otherwise, it participates in baseline alignment."
                },
                {
                    "name": "center",
                    "description": "The flex item's margin box is centered in the cross axis within the line."
                },
                {
                    "name": "end",
                    "description": "The cross-end margin edge of the flex item is placed flush with the cross-end edge of the line."
                },
                {
                    "name": "start",
                    "description": "The cross-start margin edge of the flex item is placed flush with the cross-start edge of the line."
                },
                {
                    "name": "stretch",
                    "description": "If the cross size property of the flex item computes to auto, and neither of the cross-axis margins are auto, the flex item is stretched."
                }
            ],
            "relevance": 50,
            "description": "Allows the default alignment along the cross axis to be overridden for individual flex items.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-flex-line-pack",
            "browsers": [
                "IE10"
            ],
            "values": [
                {
                    "name": "center",
                    "description": "Lines are packed toward the center of the flex container."
                },
                {
                    "name": "distribute",
                    "description": "Lines are evenly distributed in the flex container, with half-size spaces on either end."
                },
                {
                    "name": "end",
                    "description": "Lines are packed toward the end of the flex container."
                },
                {
                    "name": "justify",
                    "description": "Lines are evenly distributed in the flex container."
                },
                {
                    "name": "start",
                    "description": "Lines are packed toward the start of the flex container."
                },
                {
                    "name": "stretch",
                    "description": "Lines stretch to take up the remaining space."
                }
            ],
            "relevance": 50,
            "description": "Aligns a flex container's lines within the flex container when there is extra space in the cross-axis, similar to how 'justify-content' aligns individual items within the main-axis.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-flex-order",
            "browsers": [
                "IE10"
            ],
            "relevance": 50,
            "description": "Controls the order in which children of a flex container appear within the flex container, by assigning them to ordinal groups.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "-ms-flex-pack",
            "browsers": [
                "IE10"
            ],
            "values": [
                {
                    "name": "center",
                    "description": "Flex items are packed toward the center of the line."
                },
                {
                    "name": "distribute",
                    "description": "Flex items are evenly distributed in the line, with half-size spaces on either end."
                },
                {
                    "name": "end",
                    "description": "Flex items are packed toward the end of the line."
                },
                {
                    "name": "justify",
                    "description": "Flex items are evenly distributed in the line."
                },
                {
                    "name": "start",
                    "description": "Flex items are packed toward the start of the line."
                }
            ],
            "relevance": 50,
            "description": "Aligns flex items along the main axis of the current line of the flex container.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-flex-wrap",
            "browsers": [
                "IE10"
            ],
            "values": [
                {
                    "name": "nowrap",
                    "description": "The flex container is single-line."
                },
                {
                    "name": "wrap",
                    "description": "The flexbox is multi-line."
                },
                {
                    "name": "wrap-reverse",
                    "description": "Same as 'wrap', except the cross-start and cross-end directions are swapped."
                }
            ],
            "relevance": 50,
            "description": "Controls whether the flex container is single-line or multi-line, and the direction of the cross-axis, which determines the direction new lines are stacked in.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-flow-from",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "The block container is not a CSS Region."
                }
            ],
            "status": "nonstandard",
            "syntax": "[ none | <custom-ident> ]#",
            "relevance": 0,
            "description": "Makes a block container a region and associates it with a named flow.",
            "restrictions": [
                "identifier"
            ]
        },
        {
            "name": "-ms-flow-into",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "The element is not moved to a named flow and normal CSS processing takes place."
                }
            ],
            "status": "nonstandard",
            "syntax": "[ none | <custom-ident> ]#",
            "relevance": 0,
            "description": "Places an element or its contents into a named flow.",
            "restrictions": [
                "identifier"
            ]
        },
        {
            "name": "-ms-grid-column",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "end"
                },
                {
                    "name": "start"
                }
            ],
            "relevance": 50,
            "description": "Used to place grid items and explicitly defined grid cells in the Grid.",
            "restrictions": [
                "integer",
                "string",
                "enum"
            ]
        },
        {
            "name": "-ms-grid-column-align",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "center",
                    "description": "Places the center of the Grid Item's margin box at the center of the Grid Item's column."
                },
                {
                    "name": "end",
                    "description": "Aligns the end edge of the Grid Item's margin box to the end edge of the Grid Item's column."
                },
                {
                    "name": "start",
                    "description": "Aligns the starting edge of the Grid Item's margin box to the starting edge of the Grid Item's column."
                },
                {
                    "name": "stretch",
                    "description": "Ensures that the Grid Item's margin box is equal to the size of the Grid Item's column."
                }
            ],
            "relevance": 50,
            "description": "Aligns the columns in a grid.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-grid-columns",
            "browsers": [
                "E",
                "IE10"
            ],
            "status": "nonstandard",
            "syntax": "none | <track-list> | <auto-track-list>",
            "relevance": 0,
            "description": "Lays out the columns of the grid."
        },
        {
            "name": "-ms-grid-column-span",
            "browsers": [
                "E",
                "IE10"
            ],
            "relevance": 50,
            "description": "Specifies the number of columns to span.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "-ms-grid-layer",
            "browsers": [
                "E",
                "IE10"
            ],
            "relevance": 50,
            "description": "Grid-layer is similar in concept to z-index, but avoids overloading the meaning of the z-index property, which is applicable only to positioned elements.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "-ms-grid-row",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "end"
                },
                {
                    "name": "start"
                }
            ],
            "relevance": 50,
            "description": "grid-row is used to place grid items and explicitly defined grid cells in the Grid.",
            "restrictions": [
                "integer",
                "string",
                "enum"
            ]
        },
        {
            "name": "-ms-grid-row-align",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "center",
                    "description": "Places the center of the Grid Item's margin box at the center of the Grid Item's row."
                },
                {
                    "name": "end",
                    "description": "Aligns the end edge of the Grid Item's margin box to the end edge of the Grid Item's row."
                },
                {
                    "name": "start",
                    "description": "Aligns the starting edge of the Grid Item's margin box to the starting edge of the Grid Item's row."
                },
                {
                    "name": "stretch",
                    "description": "Ensures that the Grid Item's margin box is equal to the size of the Grid Item's row."
                }
            ],
            "relevance": 50,
            "description": "Aligns the rows in a grid.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-grid-rows",
            "browsers": [
                "E",
                "IE10"
            ],
            "status": "nonstandard",
            "syntax": "none | <track-list> | <auto-track-list>",
            "relevance": 0,
            "description": "Lays out the columns of the grid."
        },
        {
            "name": "-ms-grid-row-span",
            "browsers": [
                "E",
                "IE10"
            ],
            "relevance": 50,
            "description": "Specifies the number of rows to span.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "-ms-high-contrast-adjust",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Properties will be adjusted as applicable."
                },
                {
                    "name": "none",
                    "description": "No adjustments will be applied."
                }
            ],
            "status": "nonstandard",
            "syntax": "auto | none",
            "relevance": 0,
            "description": "Specifies if properties should be adjusted in high contrast mode.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-hyphenate-limit-chars",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The user agent chooses a value that adapts to the current layout."
                }
            ],
            "status": "nonstandard",
            "syntax": "auto | <integer>{1,3}",
            "relevance": 0,
            "description": "Specifies the minimum number of characters in a hyphenated word.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "-ms-hyphenate-limit-lines",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "no-limit",
                    "description": "There is no limit."
                }
            ],
            "status": "nonstandard",
            "syntax": "no-limit | <integer>",
            "relevance": 0,
            "description": "Indicates the maximum number of successive hyphenated lines in an element.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "-ms-hyphenate-limit-zone",
            "browsers": [
                "E",
                "IE10"
            ],
            "status": "nonstandard",
            "syntax": "<percentage> | <length>",
            "relevance": 0,
            "description": "Specifies the maximum amount of unfilled space (before justification) that may be left in the line box before hyphenation is triggered to pull part of a word from the next line back up into the current line.",
            "restrictions": [
                "percentage",
                "length"
            ]
        },
        {
            "name": "-ms-hyphens",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Conditional hyphenation characters inside a word, if present, take priority over automatic resources when determining hyphenation points within the word."
                },
                {
                    "name": "manual",
                    "description": "Words are only broken at line breaks where there are characters inside the word that suggest line break opportunities"
                },
                {
                    "name": "none",
                    "description": "Words are not broken at line breaks, even if characters inside the word suggest line break points."
                }
            ],
            "relevance": 50,
            "description": "Controls whether hyphenation is allowed to create more break opportunities within a line of text.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-ime-mode",
            "browsers": [
                "IE10"
            ],
            "values": [
                {
                    "name": "active",
                    "description": "The input method editor is initially active; text entry is performed using it unless the user specifically dismisses it."
                },
                {
                    "name": "auto",
                    "description": "No change is made to the current input method editor state. This is the default."
                },
                {
                    "name": "disabled",
                    "description": "The input method editor is disabled and may not be activated by the user."
                },
                {
                    "name": "inactive",
                    "description": "The input method editor is initially inactive, but the user may activate it if they wish."
                },
                {
                    "name": "normal",
                    "description": "The IME state should be normal; this value can be used in a user style sheet to override the page setting."
                }
            ],
            "relevance": 50,
            "description": "Controls the state of the input method editor for text fields.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-interpolation-mode",
            "browsers": [
                "IE7"
            ],
            "values": [
                {
                    "name": "bicubic"
                },
                {
                    "name": "nearest-neighbor"
                }
            ],
            "relevance": 50,
            "description": "Gets or sets the interpolation (resampling) method used to stretch images.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-layout-grid",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "char",
                    "description": "Any of the range of character values available to the -ms-layout-grid-char property."
                },
                {
                    "name": "line",
                    "description": "Any of the range of line values available to the -ms-layout-grid-line property."
                },
                {
                    "name": "mode",
                    "description": "Any of the range of mode values available to the -ms-layout-grid-mode property."
                },
                {
                    "name": "type",
                    "description": "Any of the range of type values available to the -ms-layout-grid-type property."
                }
            ],
            "relevance": 50,
            "description": "Sets or retrieves the composite document grid properties that specify the layout of text characters."
        },
        {
            "name": "-ms-layout-grid-char",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Largest character in the font of the element is used to set the character grid."
                },
                {
                    "name": "none",
                    "description": "Default. No character grid is set."
                }
            ],
            "relevance": 50,
            "description": "Sets or retrieves the size of the character grid used for rendering the text content of an element.",
            "restrictions": [
                "enum",
                "length",
                "percentage"
            ]
        },
        {
            "name": "-ms-layout-grid-line",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Largest character in the font of the element is used to set the character grid."
                },
                {
                    "name": "none",
                    "description": "Default. No grid line is set."
                }
            ],
            "relevance": 50,
            "description": "Sets or retrieves the gridline value used for rendering the text content of an element.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "-ms-layout-grid-mode",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "both",
                    "description": "Default. Both the char and line grid modes are enabled. This setting is necessary to fully enable the layout grid on an element."
                },
                {
                    "name": "char",
                    "description": "Only a character grid is used. This is recommended for use with block-level elements, such as a blockquote, where the line grid is intended to be disabled."
                },
                {
                    "name": "line",
                    "description": "Only a line grid is used. This is recommended for use with inline elements, such as a span, to disable the horizontal grid on runs of text that act as a single entity in the grid layout."
                },
                {
                    "name": "none",
                    "description": "No grid is used."
                }
            ],
            "relevance": 50,
            "description": "Gets or sets whether the text layout grid uses two dimensions.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-layout-grid-type",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "fixed",
                    "description": "Grid used for monospaced layout. All noncursive characters are treated as equal; every character is centered within a single grid space by default."
                },
                {
                    "name": "loose",
                    "description": "Default. Grid used for Japanese and Korean characters."
                },
                {
                    "name": "strict",
                    "description": "Grid used for Chinese, as well as Japanese (Genko) and Korean characters. Only the ideographs, kanas, and wide characters are snapped to the grid."
                }
            ],
            "relevance": 50,
            "description": "Sets or retrieves the type of grid used for rendering the text content of an element.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-line-break",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The UA determines the set of line-breaking restrictions to use for CJK scripts, and it may vary the restrictions based on the length of the line; e.g., use a less restrictive set of line-break rules for short lines."
                },
                {
                    "name": "keep-all",
                    "description": "Sequences of CJK characters can no longer break on implied break points. This option should only be used where the presence of word separator characters still creates line-breaking opportunities, as in Korean."
                },
                {
                    "name": "newspaper",
                    "description": "Breaks CJK scripts using the least restrictive set of line-breaking rules. Typically used for short lines, such as in newspapers."
                },
                {
                    "name": "normal",
                    "description": "Breaks CJK scripts using a normal set of line-breaking rules."
                },
                {
                    "name": "strict",
                    "description": "Breaks CJK scripts using a more restrictive set of line-breaking rules than 'normal'."
                }
            ],
            "relevance": 50,
            "description": "Specifies what set of line breaking restrictions are in effect within the element.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-overflow-style",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "No preference, UA should use the first scrolling method in the list that it supports."
                },
                {
                    "name": "-ms-autohiding-scrollbar",
                    "description": "Indicates the element displays auto-hiding scrollbars during mouse interactions and panning indicators during touch and keyboard interactions."
                },
                {
                    "name": "none",
                    "description": "Indicates the element does not display scrollbars or panning indicators, even when its content overflows."
                },
                {
                    "name": "scrollbar",
                    "description": "Scrollbars are typically narrow strips inserted on one or two edges of an element and which often have arrows to click on and a \"thumb\" to drag up and down (or left and right) to move the contents of the element."
                }
            ],
            "status": "nonstandard",
            "syntax": "auto | none | scrollbar | -ms-autohiding-scrollbar",
            "relevance": 0,
            "description": "Specify whether content is clipped when it overflows the element's content area.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-perspective",
            "browsers": [
                "IE10"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No perspective transform is applied."
                }
            ],
            "relevance": 50,
            "description": "Applies the same transform as the perspective(<number>) transform function, except that it applies only to the positioned or transformed children of the element, not to the transform on the element itself.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "-ms-perspective-origin",
            "browsers": [
                "IE10"
            ],
            "relevance": 50,
            "description": "Establishes the origin for the perspective property. It effectively sets the X and Y position at which the viewer appears to be looking at the children of the element.",
            "restrictions": [
                "position",
                "percentage",
                "length"
            ]
        },
        {
            "name": "-ms-perspective-origin-x",
            "browsers": [
                "IE10"
            ],
            "relevance": 50,
            "description": "Establishes the origin for the perspective property. It effectively sets the X  position at which the viewer appears to be looking at the children of the element.",
            "restrictions": [
                "position",
                "percentage",
                "length"
            ]
        },
        {
            "name": "-ms-perspective-origin-y",
            "browsers": [
                "IE10"
            ],
            "relevance": 50,
            "description": "Establishes the origin for the perspective property. It effectively sets the Y position at which the viewer appears to be looking at the children of the element.",
            "restrictions": [
                "position",
                "percentage",
                "length"
            ]
        },
        {
            "name": "-ms-progress-appearance",
            "browsers": [
                "IE10"
            ],
            "values": [
                {
                    "name": "bar"
                },
                {
                    "name": "ring"
                }
            ],
            "relevance": 50,
            "description": "Gets or sets a value that specifies whether a progress control displays as a bar or a ring.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-scrollbar-3dlight-color",
            "browsers": [
                "IE8"
            ],
            "status": "nonstandard",
            "syntax": "<color>",
            "relevance": 0,
            "description": "Determines the color of the top and left edges of the scroll box and scroll arrows of a scroll bar.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-ms-scrollbar-arrow-color",
            "browsers": [
                "IE8"
            ],
            "status": "nonstandard",
            "syntax": "<color>",
            "relevance": 0,
            "description": "Determines the color of the arrow elements of a scroll arrow.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-ms-scrollbar-base-color",
            "browsers": [
                "IE8"
            ],
            "status": "nonstandard",
            "syntax": "<color>",
            "relevance": 0,
            "description": "Determines the color of the main elements of a scroll bar, which include the scroll box, track, and scroll arrows.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-ms-scrollbar-darkshadow-color",
            "browsers": [
                "IE8"
            ],
            "status": "nonstandard",
            "syntax": "<color>",
            "relevance": 0,
            "description": "Determines the color of the gutter of a scroll bar.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-ms-scrollbar-face-color",
            "browsers": [
                "IE8"
            ],
            "status": "nonstandard",
            "syntax": "<color>",
            "relevance": 0,
            "description": "Determines the color of the scroll box and scroll arrows of a scroll bar.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-ms-scrollbar-highlight-color",
            "browsers": [
                "IE8"
            ],
            "status": "nonstandard",
            "syntax": "<color>",
            "relevance": 0,
            "description": "Determines the color of the top and left edges of the scroll box and scroll arrows of a scroll bar.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-ms-scrollbar-shadow-color",
            "browsers": [
                "IE8"
            ],
            "status": "nonstandard",
            "syntax": "<color>",
            "relevance": 0,
            "description": "Determines the color of the bottom and right edges of the scroll box and scroll arrows of a scroll bar.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-ms-scrollbar-track-color",
            "browsers": [
                "IE8"
            ],
            "status": "nonstandard",
            "syntax": "<color>",
            "relevance": 0,
            "description": "Determines the color of the track element of a scroll bar.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-ms-scroll-chaining",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "chained"
                },
                {
                    "name": "none"
                }
            ],
            "status": "nonstandard",
            "syntax": "chained | none",
            "relevance": 0,
            "description": "Gets or sets a value that indicates the scrolling behavior that occurs when a user hits the content boundary during a manipulation.",
            "restrictions": [
                "enum",
                "length"
            ]
        },
        {
            "name": "-ms-scroll-limit",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "auto"
                }
            ],
            "status": "nonstandard",
            "syntax": "<'-ms-scroll-limit-x-min'> <'-ms-scroll-limit-y-min'> <'-ms-scroll-limit-x-max'> <'-ms-scroll-limit-y-max'>",
            "relevance": 0,
            "description": "Gets or sets a shorthand value that sets values for the -ms-scroll-limit-x-min, -ms-scroll-limit-y-min, -ms-scroll-limit-x-max, and -ms-scroll-limit-y-max properties.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "-ms-scroll-limit-x-max",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "auto"
                }
            ],
            "status": "nonstandard",
            "syntax": "auto | <length>",
            "relevance": 0,
            "description": "Gets or sets a value that specifies the maximum value for the scrollLeft property.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "-ms-scroll-limit-x-min",
            "browsers": [
                "E",
                "IE10"
            ],
            "status": "nonstandard",
            "syntax": "<length>",
            "relevance": 0,
            "description": "Gets or sets a value that specifies the minimum value for the scrollLeft property.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "-ms-scroll-limit-y-max",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "auto"
                }
            ],
            "status": "nonstandard",
            "syntax": "auto | <length>",
            "relevance": 0,
            "description": "Gets or sets a value that specifies the maximum value for the scrollTop property.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "-ms-scroll-limit-y-min",
            "browsers": [
                "E",
                "IE10"
            ],
            "status": "nonstandard",
            "syntax": "<length>",
            "relevance": 0,
            "description": "Gets or sets a value that specifies the minimum value for the scrollTop property.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "-ms-scroll-rails",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "none"
                },
                {
                    "name": "railed"
                }
            ],
            "status": "nonstandard",
            "syntax": "none | railed",
            "relevance": 0,
            "description": "Gets or sets a value that indicates whether or not small motions perpendicular to the primary axis of motion will result in either changes to both the scrollTop and scrollLeft properties or a change to the primary axis (for instance, either the scrollTop or scrollLeft properties will change, but not both).",
            "restrictions": [
                "enum",
                "length"
            ]
        },
        {
            "name": "-ms-scroll-snap-points-x",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "snapInterval(100%, 100%)"
                },
                {
                    "name": "snapList()"
                }
            ],
            "status": "nonstandard",
            "syntax": "snapInterval( <length-percentage>, <length-percentage> ) | snapList( <length-percentage># )",
            "relevance": 0,
            "description": "Gets or sets a value that defines where snap-points will be located along the x-axis.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-scroll-snap-points-y",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "snapInterval(100%, 100%)"
                },
                {
                    "name": "snapList()"
                }
            ],
            "status": "nonstandard",
            "syntax": "snapInterval( <length-percentage>, <length-percentage> ) | snapList( <length-percentage># )",
            "relevance": 0,
            "description": "Gets or sets a value that defines where snap-points will be located along the y-axis.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-scroll-snap-type",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "The visual viewport of this scroll container must ignore snap points, if any, when scrolled."
                },
                {
                    "name": "mandatory",
                    "description": "The visual viewport of this scroll container is guaranteed to rest on a snap point when there are no active scrolling operations."
                },
                {
                    "name": "proximity",
                    "description": "The visual viewport of this scroll container may come to rest on a snap point at the termination of a scroll at the discretion of the UA given the parameters of the scroll."
                }
            ],
            "status": "nonstandard",
            "syntax": "none | proximity | mandatory",
            "relevance": 0,
            "description": "Gets or sets a value that defines what type of snap-point should be used for the current element. There are two type of snap-points, with the primary difference being whether or not the user is guaranteed to always stop on a snap-point.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-scroll-snap-x",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "mandatory"
                },
                {
                    "name": "none"
                },
                {
                    "name": "proximity"
                },
                {
                    "name": "snapInterval(100%, 100%)"
                },
                {
                    "name": "snapList()"
                }
            ],
            "status": "nonstandard",
            "syntax": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-x'>",
            "relevance": 0,
            "description": "Gets or sets a shorthand value that sets values for the -ms-scroll-snap-type and -ms-scroll-snap-points-x properties.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-scroll-snap-y",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "mandatory"
                },
                {
                    "name": "none"
                },
                {
                    "name": "proximity"
                },
                {
                    "name": "snapInterval(100%, 100%)"
                },
                {
                    "name": "snapList()"
                }
            ],
            "status": "nonstandard",
            "syntax": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-y'>",
            "relevance": 0,
            "description": "Gets or sets a shorthand value that sets values for the -ms-scroll-snap-type and -ms-scroll-snap-points-y properties.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-scroll-translation",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "none"
                },
                {
                    "name": "vertical-to-horizontal"
                }
            ],
            "status": "nonstandard",
            "syntax": "none | vertical-to-horizontal",
            "relevance": 0,
            "description": "Gets or sets a value that specifies whether vertical-to-horizontal scroll wheel translation occurs on the specified element.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-text-align-last",
            "browsers": [
                "E",
                "IE8"
            ],
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "center",
                    "description": "The inline contents are centered within the line box."
                },
                {
                    "name": "justify",
                    "description": "The text is justified according to the method specified by the 'text-justify' property."
                },
                {
                    "name": "left",
                    "description": "The inline contents are aligned to the left edge of the line box. In vertical text, 'left' aligns to the edge of the line box that would be the start edge for left-to-right text."
                },
                {
                    "name": "right",
                    "description": "The inline contents are aligned to the right edge of the line box. In vertical text, 'right' aligns to the edge of the line box that would be the end edge for left-to-right text."
                }
            ],
            "relevance": 50,
            "description": "Describes how the last line of a block or a line right before a forced line break is aligned when 'text-align' is set to 'justify'.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-text-autospace",
            "browsers": [
                "E",
                "IE8"
            ],
            "values": [
                {
                    "name": "ideograph-alpha",
                    "description": "Creates 1/4em extra spacing between runs of ideographic letters and non-ideographic letters, such as Latin-based, Cyrillic, Greek, Arabic or Hebrew."
                },
                {
                    "name": "ideograph-numeric",
                    "description": "Creates 1/4em extra spacing between runs of ideographic letters and numeric glyphs."
                },
                {
                    "name": "ideograph-parenthesis",
                    "description": "Creates extra spacing between normal (non wide) parenthesis and ideographs."
                },
                {
                    "name": "ideograph-space",
                    "description": "Extends the width of the space character while surrounded by ideographs."
                },
                {
                    "name": "none",
                    "description": "No extra space is created."
                },
                {
                    "name": "punctuation",
                    "description": "Creates extra non-breaking spacing around punctuation as required by language-specific typographic conventions."
                }
            ],
            "status": "nonstandard",
            "syntax": "none | ideograph-alpha | ideograph-numeric | ideograph-parenthesis | ideograph-space",
            "relevance": 0,
            "description": "Determines whether or not a full-width punctuation mark character should be trimmed if it appears at the beginning of a line, so that its 'ink' lines up with the first glyph in the line above and below.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-text-combine-horizontal",
            "browsers": [
                "E",
                "IE11"
            ],
            "values": [
                {
                    "name": "all",
                    "description": "Attempt to typeset horizontally all consecutive characters within the box such that they take up the space of a single character within the vertical line box."
                },
                {
                    "name": "digits",
                    "description": "Attempt to typeset horizontally each maximal sequence of consecutive ASCII digits (U+0030-U+0039) that has as many or fewer characters than the specified integer such that it takes up the space of a single character within the vertical line box."
                },
                {
                    "name": "none",
                    "description": "No special processing."
                }
            ],
            "relevance": 50,
            "description": "This property specifies the combination of multiple characters into the space of a single character.",
            "restrictions": [
                "enum",
                "integer"
            ]
        },
        {
            "name": "-ms-text-justify",
            "browsers": [
                "E",
                "IE8"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The UA determines the justification algorithm to follow, based on a balance between performance and adequate presentation quality."
                },
                {
                    "name": "distribute",
                    "description": "Justification primarily changes spacing both at word separators and at grapheme cluster boundaries in all scripts except those in the connected and cursive groups. This value is sometimes used in e.g. Japanese, often with the 'text-align-last' property."
                },
                {
                    "name": "inter-cluster",
                    "description": "Justification primarily changes spacing at word separators and at grapheme cluster boundaries in clustered scripts. This value is typically used for Southeast Asian scripts such as Thai."
                },
                {
                    "name": "inter-ideograph",
                    "description": "Justification primarily changes spacing at word separators and at inter-graphemic boundaries in scripts that use no word spaces. This value is typically used for CJK languages."
                },
                {
                    "name": "inter-word",
                    "description": "Justification primarily changes spacing at word separators. This value is typically used for languages that separate words using spaces, like English or (sometimes) Korean."
                },
                {
                    "name": "kashida",
                    "description": "Justification primarily stretches Arabic and related scripts through the use of kashida or other calligraphic elongation."
                }
            ],
            "relevance": 50,
            "description": "Selects the justification algorithm used when 'text-align' is set to 'justify'. The property applies to block containers, but the UA may (but is not required to) also support it on inline elements.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-text-kashida-space",
            "browsers": [
                "E",
                "IE10"
            ],
            "relevance": 50,
            "description": "Sets or retrieves the ratio of kashida expansion to white space expansion when justifying lines of text in the object.",
            "restrictions": [
                "percentage"
            ]
        },
        {
            "name": "-ms-text-overflow",
            "browsers": [
                "IE10"
            ],
            "values": [
                {
                    "name": "clip",
                    "description": "Clip inline content that overflows. Characters may be only partially rendered."
                },
                {
                    "name": "ellipsis",
                    "description": "Render an ellipsis character (U+2026) to represent clipped inline content."
                }
            ],
            "relevance": 50,
            "description": "Text can overflow for example when it is prevented from wrapping",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-text-size-adjust",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Renderers must use the default size adjustment when displaying on a small device."
                },
                {
                    "name": "none",
                    "description": "Renderers must not do size adjustment when displaying on a small device."
                }
            ],
            "relevance": 50,
            "description": "Specifies a size adjustment for displaying text content in mobile browsers.",
            "restrictions": [
                "enum",
                "percentage"
            ]
        },
        {
            "name": "-ms-text-underline-position",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "alphabetic",
                    "description": "The underline is aligned with the alphabetic baseline. In this case the underline is likely to cross some descenders."
                },
                {
                    "name": "auto",
                    "description": "The user agent may use any algorithm to determine the underline's position. In horizontal line layout, the underline should be aligned as for alphabetic. In vertical line layout, if the language is set to Japanese or Korean, the underline should be aligned as for over."
                },
                {
                    "name": "over",
                    "description": "The underline is aligned with the 'top' (right in vertical writing) edge of the element's em-box. In this mode, an overline also switches sides."
                },
                {
                    "name": "under",
                    "description": "The underline is aligned with the 'bottom' (left in vertical writing) edge of the element's em-box. In this case the underline usually does not cross the descenders. This is sometimes called 'accounting' underline."
                }
            ],
            "relevance": 50,
            "description": "Sets the position of an underline specified on the same element: it does not affect underlines specified by ancestor elements.This property is typically used in vertical writing contexts such as in Japanese documents where it often desired to have the underline appear 'over' (to the right of) the affected run of text",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-touch-action",
            "browsers": [
                "IE10"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The element is a passive element, with several exceptions."
                },
                {
                    "name": "double-tap-zoom",
                    "description": "The element will zoom on double-tap."
                },
                {
                    "name": "manipulation",
                    "description": "The element is a manipulation-causing element."
                },
                {
                    "name": "none",
                    "description": "The element is a manipulation-blocking element."
                },
                {
                    "name": "pan-x",
                    "description": "The element permits touch-driven panning on the horizontal axis. The touch pan is performed on the nearest ancestor with horizontally scrollable content."
                },
                {
                    "name": "pan-y",
                    "description": "The element permits touch-driven panning on the vertical axis. The touch pan is performed on the nearest ancestor with vertically scrollable content."
                },
                {
                    "name": "pinch-zoom",
                    "description": "The element permits pinch-zooming. The pinch-zoom is performed on the nearest ancestor with zoomable content."
                }
            ],
            "relevance": 50,
            "description": "Gets or sets a value that indicates whether and how a given region can be manipulated by the user.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-touch-select",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "grippers",
                    "description": "Grippers are always on."
                },
                {
                    "name": "none",
                    "description": "Grippers are always off."
                }
            ],
            "status": "nonstandard",
            "syntax": "grippers | none",
            "relevance": 0,
            "description": "Gets or sets a value that toggles the 'gripper' visual elements that enable touch text selection.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-transform",
            "browsers": [
                "IE9-9"
            ],
            "values": [
                {
                    "name": "matrix()",
                    "description": "Specifies a 2D transformation in the form of a transformation matrix of six values. matrix(a,b,c,d,e,f) is equivalent to applying the transformation matrix [a b c d e f]"
                },
                {
                    "name": "matrix3d()",
                    "description": "Specifies a 3D transformation as a 4x4 homogeneous matrix of 16 values in column-major order."
                },
                {
                    "name": "none"
                },
                {
                    "name": "rotate()",
                    "description": "Specifies a 2D rotation by the angle specified in the parameter about the origin of the element, as defined by the transform-origin property."
                },
                {
                    "name": "rotate3d()",
                    "description": "Specifies a clockwise 3D rotation by the angle specified in last parameter about the [x,y,z] direction vector described by the first 3 parameters."
                },
                {
                    "name": "rotateX('angle')",
                    "description": "Specifies a clockwise rotation by the given angle about the X axis."
                },
                {
                    "name": "rotateY('angle')",
                    "description": "Specifies a clockwise rotation by the given angle about the Y axis."
                },
                {
                    "name": "rotateZ('angle')",
                    "description": "Specifies a clockwise rotation by the given angle about the Z axis."
                },
                {
                    "name": "scale()",
                    "description": "Specifies a 2D scale operation by the [sx,sy] scaling vector described by the 2 parameters. If the second parameter is not provided, it is takes a value equal to the first."
                },
                {
                    "name": "scale3d()",
                    "description": "Specifies a 3D scale operation by the [sx,sy,sz] scaling vector described by the 3 parameters."
                },
                {
                    "name": "scaleX()",
                    "description": "Specifies a scale operation using the [sx,1] scaling vector, where sx is given as the parameter."
                },
                {
                    "name": "scaleY()",
                    "description": "Specifies a scale operation using the [sy,1] scaling vector, where sy is given as the parameter."
                },
                {
                    "name": "scaleZ()",
                    "description": "Specifies a scale operation using the [1,1,sz] scaling vector, where sz is given as the parameter."
                },
                {
                    "name": "skew()",
                    "description": "Specifies a skew transformation along the X and Y axes. The first angle parameter specifies the skew on the X axis. The second angle parameter specifies the skew on the Y axis. If the second parameter is not given then a value of 0 is used for the Y angle (ie: no skew on the Y axis)."
                },
                {
                    "name": "skewX()",
                    "description": "Specifies a skew transformation along the X axis by the given angle."
                },
                {
                    "name": "skewY()",
                    "description": "Specifies a skew transformation along the Y axis by the given angle."
                },
                {
                    "name": "translate()",
                    "description": "Specifies a 2D translation by the vector [tx, ty], where tx is the first translation-value parameter and ty is the optional second translation-value parameter."
                },
                {
                    "name": "translate3d()",
                    "description": "Specifies a 3D translation by the vector [tx,ty,tz], with tx, ty and tz being the first, second and third translation-value parameters respectively."
                },
                {
                    "name": "translateX()",
                    "description": "Specifies a translation by the given amount in the X direction."
                },
                {
                    "name": "translateY()",
                    "description": "Specifies a translation by the given amount in the Y direction."
                },
                {
                    "name": "translateZ()",
                    "description": "Specifies a translation by the given amount in the Z direction. Note that percentage values are not allowed in the translateZ translation-value, and if present are evaluated as 0."
                }
            ],
            "relevance": 50,
            "description": "A two-dimensional transformation is applied to an element through the 'transform' property. This property contains a list of transform functions similar to those allowed by SVG.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-transform-origin",
            "browsers": [
                "IE9-9"
            ],
            "relevance": 50,
            "description": "Establishes the origin of transformation for an element.",
            "restrictions": [
                "position",
                "length",
                "percentage"
            ]
        },
        {
            "name": "-ms-transform-origin-x",
            "browsers": [
                "IE10"
            ],
            "relevance": 50,
            "description": "The x coordinate of the origin for transforms applied to an element with respect to its border box.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "-ms-transform-origin-y",
            "browsers": [
                "IE10"
            ],
            "relevance": 50,
            "description": "The y coordinate of the origin for transforms applied to an element with respect to its border box.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "-ms-transform-origin-z",
            "browsers": [
                "IE10"
            ],
            "relevance": 50,
            "description": "The z coordinate of the origin for transforms applied to an element with respect to its border box.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "-ms-user-select",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "element"
                },
                {
                    "name": "none"
                },
                {
                    "name": "text"
                }
            ],
            "status": "nonstandard",
            "syntax": "none | element | text",
            "relevance": 0,
            "description": "Controls the appearance of selection.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-word-break",
            "browsers": [
                "IE8"
            ],
            "values": [
                {
                    "name": "break-all",
                    "description": "Lines may break between any two grapheme clusters for non-CJK scripts."
                },
                {
                    "name": "keep-all",
                    "description": "Block characters can no longer create implied break points."
                },
                {
                    "name": "normal",
                    "description": "Breaks non-CJK scripts according to their own rules."
                }
            ],
            "relevance": 50,
            "description": "Specifies line break opportunities for non-CJK scripts.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-word-wrap",
            "browsers": [
                "IE8"
            ],
            "values": [
                {
                    "name": "break-word",
                    "description": "An unbreakable 'word' may be broken at an arbitrary point if there are no otherwise-acceptable break points in the line."
                },
                {
                    "name": "normal",
                    "description": "Lines may break only at allowed break points."
                }
            ],
            "relevance": 50,
            "description": "Specifies whether the UA may break within a word to prevent overflow when an otherwise-unbreakable string is too long to fit.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-wrap-flow",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "For floats an exclusion is created, for all other elements an exclusion is not created."
                },
                {
                    "name": "both",
                    "description": "Inline flow content can flow on all sides of the exclusion."
                },
                {
                    "name": "clear",
                    "description": "Inline flow content can only wrap on top and bottom of the exclusion and must leave the areas to the start and end edges of the exclusion box empty."
                },
                {
                    "name": "end",
                    "description": "Inline flow content can wrap on the end side of the exclusion area but must leave the area to the start edge of the exclusion area empty."
                },
                {
                    "name": "maximum",
                    "description": "Inline flow content can wrap on the side of the exclusion with the largest available space for the given line, and must leave the other side of the exclusion empty."
                },
                {
                    "name": "minimum",
                    "description": "Inline flow content can flow around the edge of the exclusion with the smallest available space within the flow content's containing block, and must leave the other edge of the exclusion empty."
                },
                {
                    "name": "start",
                    "description": "Inline flow content can wrap on the start edge of the exclusion area but must leave the area to end edge of the exclusion area empty."
                }
            ],
            "status": "nonstandard",
            "syntax": "auto | both | start | end | maximum | clear",
            "relevance": 0,
            "description": "An element becomes an exclusion when its 'wrap-flow' property has a computed value other than 'auto'.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-wrap-margin",
            "browsers": [
                "E",
                "IE10"
            ],
            "status": "nonstandard",
            "syntax": "<length>",
            "relevance": 0,
            "description": "Gets or sets a value that is used to offset the inner wrap shape from other shapes.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "-ms-wrap-through",
            "browsers": [
                "E",
                "IE10"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "The exclusion element does not inherit its parent node's wrapping context. Its descendants are only subject to exclusion shapes defined inside the element."
                },
                {
                    "name": "wrap",
                    "description": "The exclusion element inherits its parent node's wrapping context. Its descendant inline content wraps around exclusions defined outside the element."
                }
            ],
            "status": "nonstandard",
            "syntax": "wrap | none",
            "relevance": 0,
            "description": "Specifies if an element inherits its parent wrapping context. In other words if it is subject to the exclusions defined outside the element.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-writing-mode",
            "browsers": [
                "IE8"
            ],
            "values": [
                {
                    "name": "bt-lr"
                },
                {
                    "name": "bt-rl"
                },
                {
                    "name": "lr-bt"
                },
                {
                    "name": "lr-tb"
                },
                {
                    "name": "rl-bt"
                },
                {
                    "name": "rl-tb"
                },
                {
                    "name": "tb-lr"
                },
                {
                    "name": "tb-rl"
                }
            ],
            "relevance": 50,
            "description": "Shorthand property for both 'direction' and 'block-progression'.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-ms-zoom",
            "browsers": [
                "IE8"
            ],
            "values": [
                {
                    "name": "normal"
                }
            ],
            "relevance": 50,
            "description": "Sets or retrieves the magnification scale of the object.",
            "restrictions": [
                "enum",
                "integer",
                "number",
                "percentage"
            ]
        },
        {
            "name": "-ms-zoom-animation",
            "browsers": [
                "IE10"
            ],
            "values": [
                {
                    "name": "default"
                },
                {
                    "name": "none"
                }
            ],
            "relevance": 50,
            "description": "Gets or sets a value that indicates whether an animation is used when zooming.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "nav-down",
            "browsers": [
                "O9.5"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The user agent automatically determines which element to navigate the focus to in response to directional navigational input."
                },
                {
                    "name": "current",
                    "description": "Indicates that the user agent should target the frame that the element is in."
                },
                {
                    "name": "root",
                    "description": "Indicates that the user agent should target the full window."
                }
            ],
            "relevance": 50,
            "description": "Provides an way to control directional focus navigation.",
            "restrictions": [
                "enum",
                "identifier",
                "string"
            ]
        },
        {
            "name": "nav-index",
            "browsers": [
                "O9.5"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The element's sequential navigation order is assigned automatically by the user agent."
                }
            ],
            "relevance": 50,
            "description": "Provides an input-method-neutral way of specifying the sequential navigation order (also known as 'tabbing order').",
            "restrictions": [
                "number"
            ]
        },
        {
            "name": "nav-left",
            "browsers": [
                "O9.5"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The user agent automatically determines which element to navigate the focus to in response to directional navigational input."
                },
                {
                    "name": "current",
                    "description": "Indicates that the user agent should target the frame that the element is in."
                },
                {
                    "name": "root",
                    "description": "Indicates that the user agent should target the full window."
                }
            ],
            "relevance": 50,
            "description": "Provides an way to control directional focus navigation.",
            "restrictions": [
                "enum",
                "identifier",
                "string"
            ]
        },
        {
            "name": "nav-right",
            "browsers": [
                "O9.5"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The user agent automatically determines which element to navigate the focus to in response to directional navigational input."
                },
                {
                    "name": "current",
                    "description": "Indicates that the user agent should target the frame that the element is in."
                },
                {
                    "name": "root",
                    "description": "Indicates that the user agent should target the full window."
                }
            ],
            "relevance": 50,
            "description": "Provides an way to control directional focus navigation.",
            "restrictions": [
                "enum",
                "identifier",
                "string"
            ]
        },
        {
            "name": "nav-up",
            "browsers": [
                "O9.5"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The user agent automatically determines which element to navigate the focus to in response to directional navigational input."
                },
                {
                    "name": "current",
                    "description": "Indicates that the user agent should target the frame that the element is in."
                },
                {
                    "name": "root",
                    "description": "Indicates that the user agent should target the full window."
                }
            ],
            "relevance": 50,
            "description": "Provides an way to control directional focus navigation.",
            "restrictions": [
                "enum",
                "identifier",
                "string"
            ]
        },
        {
            "name": "negative",
            "browsers": [
                "FF33"
            ],
            "atRule": "@counter-style",
            "syntax": "<symbol> <symbol>?",
            "relevance": 50,
            "description": "@counter-style descriptor. Defines how to alter the representation when the counter value is negative.",
            "restrictions": [
                "image",
                "identifier",
                "string"
            ]
        },
        {
            "name": "-o-animation",
            "browsers": [
                "O12"
            ],
            "values": [
                {
                    "name": "alternate",
                    "description": "The animation cycle iterations that are odd counts are played in the normal direction, and the animation cycle iterations that are even counts are played in a reverse direction."
                },
                {
                    "name": "alternate-reverse",
                    "description": "The animation cycle iterations that are odd counts are played in the reverse direction, and the animation cycle iterations that are even counts are played in a normal direction."
                },
                {
                    "name": "backwards",
                    "description": "The beginning property value (as defined in the first @keyframes at-rule) is applied before the animation is displayed, during the period defined by 'animation-delay'."
                },
                {
                    "name": "both",
                    "description": "Both forwards and backwards fill modes are applied."
                },
                {
                    "name": "forwards",
                    "description": "The final property value (as defined in the last @keyframes at-rule) is maintained after the animation completes."
                },
                {
                    "name": "infinite",
                    "description": "Causes the animation to repeat forever."
                },
                {
                    "name": "none",
                    "description": "No animation is performed"
                },
                {
                    "name": "normal",
                    "description": "Normal playback."
                },
                {
                    "name": "reverse",
                    "description": "All iterations of the animation are played in the reverse direction from the way they were specified."
                }
            ],
            "relevance": 50,
            "description": "Shorthand property combines six of the animation properties into a single property.",
            "restrictions": [
                "time",
                "enum",
                "timing-function",
                "identifier",
                "number"
            ]
        },
        {
            "name": "-o-animation-delay",
            "browsers": [
                "O12"
            ],
            "relevance": 50,
            "description": "Defines when the animation will start.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "-o-animation-direction",
            "browsers": [
                "O12"
            ],
            "values": [
                {
                    "name": "alternate",
                    "description": "The animation cycle iterations that are odd counts are played in the normal direction, and the animation cycle iterations that are even counts are played in a reverse direction."
                },
                {
                    "name": "alternate-reverse",
                    "description": "The animation cycle iterations that are odd counts are played in the reverse direction, and the animation cycle iterations that are even counts are played in a normal direction."
                },
                {
                    "name": "normal",
                    "description": "Normal playback."
                },
                {
                    "name": "reverse",
                    "description": "All iterations of the animation are played in the reverse direction from the way they were specified."
                }
            ],
            "relevance": 50,
            "description": "Defines whether or not the animation should play in reverse on alternate cycles.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-o-animation-duration",
            "browsers": [
                "O12"
            ],
            "relevance": 50,
            "description": "Defines the length of time that an animation takes to complete one cycle.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "-o-animation-fill-mode",
            "browsers": [
                "O12"
            ],
            "values": [
                {
                    "name": "backwards",
                    "description": "The beginning property value (as defined in the first @keyframes at-rule) is applied before the animation is displayed, during the period defined by 'animation-delay'."
                },
                {
                    "name": "both",
                    "description": "Both forwards and backwards fill modes are applied."
                },
                {
                    "name": "forwards",
                    "description": "The final property value (as defined in the last @keyframes at-rule) is maintained after the animation completes."
                },
                {
                    "name": "none",
                    "description": "There is no change to the property value between the time the animation is applied and the time the animation begins playing or after the animation completes."
                }
            ],
            "relevance": 50,
            "description": "Defines what values are applied by the animation outside the time it is executing.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-o-animation-iteration-count",
            "browsers": [
                "O12"
            ],
            "values": [
                {
                    "name": "infinite",
                    "description": "Causes the animation to repeat forever."
                }
            ],
            "relevance": 50,
            "description": "Defines the number of times an animation cycle is played. The default value is one, meaning the animation will play from beginning to end once.",
            "restrictions": [
                "number",
                "enum"
            ]
        },
        {
            "name": "-o-animation-name",
            "browsers": [
                "O12"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No animation is performed"
                }
            ],
            "relevance": 50,
            "description": "Defines a list of animations that apply. Each name is used to select the keyframe at-rule that provides the property values for the animation.",
            "restrictions": [
                "identifier",
                "enum"
            ]
        },
        {
            "name": "-o-animation-play-state",
            "browsers": [
                "O12"
            ],
            "values": [
                {
                    "name": "paused",
                    "description": "A running animation will be paused."
                },
                {
                    "name": "running",
                    "description": "Resume playback of a paused animation."
                }
            ],
            "relevance": 50,
            "description": "Defines whether the animation is running or paused.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-o-animation-timing-function",
            "browsers": [
                "O12"
            ],
            "relevance": 50,
            "description": "Describes how the animation will progress over one cycle of its duration. See the 'transition-timing-function'.",
            "restrictions": [
                "timing-function"
            ]
        },
        {
            "name": "object-fit",
            "browsers": [
                "E79",
                "FF36",
                "FFA36",
                "S10",
                "SM10",
                "C32",
                "CA32",
                "O19"
            ],
            "values": [
                {
                    "name": "contain",
                    "description": "The replaced content is sized to maintain its aspect ratio while fitting within the element's content box: its concrete object size is resolved as a contain constraint against the element's used width and height."
                },
                {
                    "name": "cover",
                    "description": "The replaced content is sized to maintain its aspect ratio while filling the element's entire content box: its concrete object size is resolved as a cover constraint against the element's used width and height."
                },
                {
                    "name": "fill",
                    "description": "The replaced content is sized to fill the element's content box: the object's concrete object size is the element's used width and height."
                },
                {
                    "name": "none",
                    "description": "The replaced content is not resized to fit inside the element's content box"
                },
                {
                    "name": "scale-down",
                    "description": "Size the content as if 'none' or 'contain' were specified, whichever would result in a smaller concrete object size."
                }
            ],
            "syntax": "fill | contain | cover | none | scale-down",
            "relevance": 75,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/object-fit"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Specifies how the contents of a replaced element should be scaled relative to the box established by its used height and width.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "object-position",
            "browsers": [
                "E79",
                "FF36",
                "FFA36",
                "S10",
                "SM10",
                "C32",
                "CA32",
                "O19"
            ],
            "syntax": "<position>",
            "relevance": 58,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/object-position"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Determines the alignment of the replaced element inside its box.",
            "restrictions": [
                "position",
                "length",
                "percentage"
            ]
        },
        {
            "name": "-o-border-image",
            "browsers": [
                "O11.6"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "If 'auto' is specified then the border image width is the intrinsic width or height (whichever is applicable) of the corresponding image slice. If the image does not have the required intrinsic dimension then the corresponding border-width is used instead."
                },
                {
                    "name": "fill",
                    "description": "Causes the middle part of the border-image to be preserved."
                },
                {
                    "name": "none"
                },
                {
                    "name": "repeat",
                    "description": "The image is tiled (repeated) to fill the area."
                },
                {
                    "name": "round",
                    "description": "The image is tiled (repeated) to fill the area. If it does not fill the area with a whole number of tiles, the image is rescaled so that it does."
                },
                {
                    "name": "space",
                    "description": "The image is tiled (repeated) to fill the area. If it does not fill the area with a whole number of tiles, the extra space is distributed around the tiles."
                },
                {
                    "name": "stretch",
                    "description": "The image is stretched to fill the area."
                }
            ],
            "relevance": 50,
            "description": "Shorthand property for setting 'border-image-source', 'border-image-slice', 'border-image-width', 'border-image-outset' and 'border-image-repeat'. Omitted values are set to their initial values.",
            "restrictions": [
                "length",
                "percentage",
                "number",
                "image",
                "enum"
            ]
        },
        {
            "name": "-o-object-fit",
            "browsers": [
                "O10.6"
            ],
            "values": [
                {
                    "name": "contain",
                    "description": "The replaced content is sized to maintain its aspect ratio while fitting within the element's content box: its concrete object size is resolved as a contain constraint against the element's used width and height."
                },
                {
                    "name": "cover",
                    "description": "The replaced content is sized to maintain its aspect ratio while filling the element's entire content box: its concrete object size is resolved as a cover constraint against the element's used width and height."
                },
                {
                    "name": "fill",
                    "description": "The replaced content is sized to fill the element's content box: the object's concrete object size is the element's used width and height."
                },
                {
                    "name": "none",
                    "description": "The replaced content is not resized to fit inside the element's content box"
                },
                {
                    "name": "scale-down",
                    "description": "Size the content as if 'none' or 'contain' were specified, whichever would result in a smaller concrete object size."
                }
            ],
            "relevance": 50,
            "description": "Specifies how the contents of a replaced element should be scaled relative to the box established by its used height and width.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-o-object-position",
            "browsers": [
                "O10.6"
            ],
            "relevance": 50,
            "description": "Determines the alignment of the replaced element inside its box.",
            "restrictions": [
                "position",
                "length",
                "percentage"
            ]
        },
        {
            "name": "opacity",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S2",
                "SM1",
                "C1",
                "CA18",
                "IE9",
                "O9"
            ],
            "syntax": "<opacity-value>",
            "relevance": 93,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/opacity"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Opacity of an element's text, where 1 is opaque and 0 is entirely transparent.",
            "restrictions": [
                "number(0-1)"
            ]
        },
        {
            "name": "order",
            "browsers": [
                "E12",
                "FF20",
                "FFA20",
                "S9",
                "SM9",
                "C29",
                "CA29",
                "IE11",
                "O12.1"
            ],
            "syntax": "<integer>",
            "relevance": 69,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/order"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Controls the order in which children of a flex container appear within the flex container, by assigning them to ordinal groups.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "orphans",
            "browsers": [
                "E12",
                "S1.3",
                "SM1",
                "C25",
                "CA25",
                "IE8",
                "O9.2"
            ],
            "syntax": "<integer>",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/orphans"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Specifies the minimum number of line boxes in a block container that must be left in a fragment before a fragmentation break.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "-o-table-baseline",
            "browsers": [
                "O9.6"
            ],
            "relevance": 50,
            "description": "Determines which row of a inline-table should be used as baseline of inline-table.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "-o-tab-size",
            "browsers": [
                "O10.6"
            ],
            "relevance": 50,
            "description": "This property determines the width of the tab character (U+0009), in space characters (U+0020), when rendered.",
            "restrictions": [
                "integer",
                "length"
            ]
        },
        {
            "name": "-o-text-overflow",
            "browsers": [
                "O10"
            ],
            "values": [
                {
                    "name": "clip",
                    "description": "Clip inline content that overflows. Characters may be only partially rendered."
                },
                {
                    "name": "ellipsis",
                    "description": "Render an ellipsis character (U+2026) to represent clipped inline content."
                }
            ],
            "relevance": 50,
            "description": "Text can overflow for example when it is prevented from wrapping",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-o-transform",
            "browsers": [
                "O10.5"
            ],
            "values": [
                {
                    "name": "matrix()",
                    "description": "Specifies a 2D transformation in the form of a transformation matrix of six values. matrix(a,b,c,d,e,f) is equivalent to applying the transformation matrix [a b c d e f]"
                },
                {
                    "name": "matrix3d()",
                    "description": "Specifies a 3D transformation as a 4x4 homogeneous matrix of 16 values in column-major order."
                },
                {
                    "name": "none"
                },
                {
                    "name": "rotate()",
                    "description": "Specifies a 2D rotation by the angle specified in the parameter about the origin of the element, as defined by the transform-origin property."
                },
                {
                    "name": "rotate3d()",
                    "description": "Specifies a clockwise 3D rotation by the angle specified in last parameter about the [x,y,z] direction vector described by the first 3 parameters."
                },
                {
                    "name": "rotateX('angle')",
                    "description": "Specifies a clockwise rotation by the given angle about the X axis."
                },
                {
                    "name": "rotateY('angle')",
                    "description": "Specifies a clockwise rotation by the given angle about the Y axis."
                },
                {
                    "name": "rotateZ('angle')",
                    "description": "Specifies a clockwise rotation by the given angle about the Z axis."
                },
                {
                    "name": "scale()",
                    "description": "Specifies a 2D scale operation by the [sx,sy] scaling vector described by the 2 parameters. If the second parameter is not provided, it is takes a value equal to the first."
                },
                {
                    "name": "scale3d()",
                    "description": "Specifies a 3D scale operation by the [sx,sy,sz] scaling vector described by the 3 parameters."
                },
                {
                    "name": "scaleX()",
                    "description": "Specifies a scale operation using the [sx,1] scaling vector, where sx is given as the parameter."
                },
                {
                    "name": "scaleY()",
                    "description": "Specifies a scale operation using the [sy,1] scaling vector, where sy is given as the parameter."
                },
                {
                    "name": "scaleZ()",
                    "description": "Specifies a scale operation using the [1,1,sz] scaling vector, where sz is given as the parameter."
                },
                {
                    "name": "skew()",
                    "description": "Specifies a skew transformation along the X and Y axes. The first angle parameter specifies the skew on the X axis. The second angle parameter specifies the skew on the Y axis. If the second parameter is not given then a value of 0 is used for the Y angle (ie: no skew on the Y axis)."
                },
                {
                    "name": "skewX()",
                    "description": "Specifies a skew transformation along the X axis by the given angle."
                },
                {
                    "name": "skewY()",
                    "description": "Specifies a skew transformation along the Y axis by the given angle."
                },
                {
                    "name": "translate()",
                    "description": "Specifies a 2D translation by the vector [tx, ty], where tx is the first translation-value parameter and ty is the optional second translation-value parameter."
                },
                {
                    "name": "translate3d()",
                    "description": "Specifies a 3D translation by the vector [tx,ty,tz], with tx, ty and tz being the first, second and third translation-value parameters respectively."
                },
                {
                    "name": "translateX()",
                    "description": "Specifies a translation by the given amount in the X direction."
                },
                {
                    "name": "translateY()",
                    "description": "Specifies a translation by the given amount in the Y direction."
                },
                {
                    "name": "translateZ()",
                    "description": "Specifies a translation by the given amount in the Z direction. Note that percentage values are not allowed in the translateZ translation-value, and if present are evaluated as 0."
                }
            ],
            "relevance": 50,
            "description": "A two-dimensional transformation is applied to an element through the 'transform' property. This property contains a list of transform functions similar to those allowed by SVG.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-o-transform-origin",
            "browsers": [
                "O10.5"
            ],
            "relevance": 50,
            "description": "Establishes the origin of transformation for an element.",
            "restrictions": [
                "positon",
                "length",
                "percentage"
            ]
        },
        {
            "name": "-o-transition",
            "browsers": [
                "O11.5"
            ],
            "values": [
                {
                    "name": "all",
                    "description": "Every property that is able to undergo a transition will do so."
                },
                {
                    "name": "none",
                    "description": "No property will transition."
                }
            ],
            "relevance": 50,
            "description": "Shorthand property combines four of the transition properties into a single property.",
            "restrictions": [
                "time",
                "property",
                "timing-function",
                "enum"
            ]
        },
        {
            "name": "-o-transition-delay",
            "browsers": [
                "O11.5"
            ],
            "relevance": 50,
            "description": "Defines when the transition will start. It allows a transition to begin execution some period of time from when it is applied.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "-o-transition-duration",
            "browsers": [
                "O11.5"
            ],
            "relevance": 50,
            "description": "Specifies how long the transition from the old value to the new value should take.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "-o-transition-property",
            "browsers": [
                "O11.5"
            ],
            "values": [
                {
                    "name": "all",
                    "description": "Every property that is able to undergo a transition will do so."
                },
                {
                    "name": "none",
                    "description": "No property will transition."
                }
            ],
            "relevance": 50,
            "description": "Specifies the name of the CSS property to which the transition is applied.",
            "restrictions": [
                "property"
            ]
        },
        {
            "name": "-o-transition-timing-function",
            "browsers": [
                "O11.5"
            ],
            "relevance": 50,
            "description": "Describes how the intermediate values used during a transition will be calculated.",
            "restrictions": [
                "timing-function"
            ]
        },
        {
            "name": "offset-block-end",
            "browsers": [
                "FF41"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "For non-replaced elements, the effect of this value depends on which of related properties have the value 'auto' as well."
                }
            ],
            "relevance": 50,
            "description": "Logical 'bottom'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "offset-block-start",
            "browsers": [
                "FF41"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "For non-replaced elements, the effect of this value depends on which of related properties have the value 'auto' as well."
                }
            ],
            "relevance": 50,
            "description": "Logical 'top'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "offset-inline-end",
            "browsers": [
                "FF41"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "For non-replaced elements, the effect of this value depends on which of related properties have the value 'auto' as well."
                }
            ],
            "relevance": 50,
            "description": "Logical 'right'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "offset-inline-start",
            "browsers": [
                "FF41"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "For non-replaced elements, the effect of this value depends on which of related properties have the value 'auto' as well."
                }
            ],
            "relevance": 50,
            "description": "Logical 'left'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "outline",
            "browsers": [
                "E94",
                "FF88",
                "FFA88",
                "S16.4",
                "SM16.4",
                "C94",
                "CA94",
                "IE8",
                "O80"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Permits the user agent to render a custom outline style, typically the default platform style."
                },
                {
                    "name": "invert",
                    "browsers": [
                        "E94",
                        "FF88",
                        "FFA88",
                        "S16.4",
                        "SM16.4",
                        "C94",
                        "CA94",
                        "IE8",
                        "O80"
                    ],
                    "description": "Performs a color inversion on the pixels on the screen."
                }
            ],
            "syntax": "<'outline-width'> || <'outline-style'> || <'outline-color'>",
            "relevance": 88,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/outline"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-03-27"
            },
            "description": "Shorthand property for 'outline-style', 'outline-width', and 'outline-color'.",
            "restrictions": [
                "length",
                "line-width",
                "line-style",
                "color",
                "enum"
            ]
        },
        {
            "name": "outline-color",
            "browsers": [
                "E12",
                "FF1.5",
                "FFA4",
                "S1.2",
                "SM1",
                "C1",
                "CA18",
                "IE8",
                "O7"
            ],
            "values": [
                {
                    "name": "invert",
                    "browsers": [
                        "E12",
                        "FF1.5",
                        "FFA4",
                        "S1.2",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE8",
                        "O7"
                    ],
                    "description": "Performs a color inversion on the pixels on the screen."
                }
            ],
            "syntax": "auto | <color>",
            "relevance": 62,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/outline-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "The color of the outline.",
            "restrictions": [
                "enum",
                "color"
            ]
        },
        {
            "name": "outline-offset",
            "browsers": [
                "E15",
                "FF1.5",
                "FFA4",
                "S1.2",
                "SM1",
                "C1",
                "CA18",
                "O9.5"
            ],
            "syntax": "<length>",
            "relevance": 70,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/outline-offset"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Offset the outline and draw it beyond the border edge.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "outline-style",
            "browsers": [
                "E12",
                "FF1.5",
                "FFA4",
                "S1.2",
                "SM1",
                "C1",
                "CA18",
                "IE8",
                "O7"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Permits the user agent to render a custom outline style, typically the default platform style."
                }
            ],
            "syntax": "auto | <outline-line-style>",
            "relevance": 60,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/outline-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Style of the outline.",
            "restrictions": [
                "line-style",
                "enum"
            ]
        },
        {
            "name": "outline-width",
            "browsers": [
                "E12",
                "FF1.5",
                "FFA4",
                "S1.2",
                "SM1",
                "C1",
                "CA18",
                "IE8",
                "O7"
            ],
            "syntax": "<line-width>",
            "relevance": 63,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/outline-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Width of the outline.",
            "restrictions": [
                "length",
                "line-width"
            ]
        },
        {
            "name": "overflow",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O7"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The behavior of the 'auto' value is UA-dependent, but should cause a scrolling mechanism to be provided for overflowing boxes."
                },
                {
                    "name": "hidden",
                    "description": "Content is clipped and no scrolling mechanism should be provided to view the content outside the clipping region."
                },
                {
                    "name": "-moz-hidden-unscrollable",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O7"
                    ],
                    "description": "Same as the standardized 'clip', except doesn't establish a block formatting context."
                },
                {
                    "name": "scroll",
                    "description": "Content is clipped and if the user agent uses a scrolling mechanism that is visible on the screen (such as a scroll bar or a panner), that mechanism should be displayed for a box whether or not any of its content is clipped."
                },
                {
                    "name": "visible",
                    "description": "Content is not clipped, i.e., it may be rendered outside the content box."
                }
            ],
            "syntax": "[ visible | hidden | clip | scroll | auto ]{1,2}",
            "relevance": 93,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/overflow"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand for setting 'overflow-x' and 'overflow-y'.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "overflow-wrap",
            "browsers": [
                "E18",
                "FF49",
                "FFA49",
                "S7",
                "SM7",
                "C23",
                "CA25",
                "IE5.5",
                "O12.1"
            ],
            "values": [
                {
                    "name": "break-word",
                    "description": "An otherwise unbreakable sequence of characters may be broken at an arbitrary point if there are no otherwise-acceptable break points in the line."
                },
                {
                    "name": "normal",
                    "description": "Lines may break only at allowed break points."
                },
                {
                    "name": "anywhere",
                    "description": "There is a soft wrap opportunity around every typographic character unit, including around any punctuation character or preserved white spaces, or in the middle of words, disregarding any prohibition against line breaks, even those introduced by characters with the GL, WJ, or ZWJ line breaking classes or mandated by the word-break property."
                }
            ],
            "syntax": "normal | break-word | anywhere",
            "relevance": 66,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/overflow-wrap"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2018-10-02",
                "baseline_high_date": "2021-04-02"
            },
            "description": "Specifies whether the UA may break within a word to prevent overflow when an otherwise-unbreakable string is too long to fit within the line box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "overflow-x",
            "browsers": [
                "E12",
                "FF3.5",
                "FFA4",
                "S3",
                "SM1",
                "C1",
                "CA18",
                "IE5",
                "O9.5"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The behavior of the 'auto' value is UA-dependent, but should cause a scrolling mechanism to be provided for overflowing boxes."
                },
                {
                    "name": "hidden",
                    "description": "Content is clipped and no scrolling mechanism should be provided to view the content outside the clipping region."
                },
                {
                    "name": "scroll",
                    "description": "Content is clipped and if the user agent uses a scrolling mechanism that is visible on the screen (such as a scroll bar or a panner), that mechanism should be displayed for a box whether or not any of its content is clipped."
                },
                {
                    "name": "visible",
                    "description": "Content is not clipped, i.e., it may be rendered outside the content box."
                }
            ],
            "syntax": "visible | hidden | clip | scroll | auto",
            "relevance": 81,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/overflow-x"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies the handling of overflow in the horizontal direction.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "overflow-y",
            "browsers": [
                "E12",
                "FF3.5",
                "FFA4",
                "S3",
                "SM1",
                "C1",
                "CA18",
                "IE5",
                "O9.5"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The behavior of the 'auto' value is UA-dependent, but should cause a scrolling mechanism to be provided for overflowing boxes."
                },
                {
                    "name": "hidden",
                    "description": "Content is clipped and no scrolling mechanism should be provided to view the content outside the clipping region."
                },
                {
                    "name": "scroll",
                    "description": "Content is clipped and if the user agent uses a scrolling mechanism that is visible on the screen (such as a scroll bar or a panner), that mechanism should be displayed for a box whether or not any of its content is clipped."
                },
                {
                    "name": "visible",
                    "description": "Content is not clipped, i.e., it may be rendered outside the content box."
                }
            ],
            "syntax": "visible | hidden | clip | scroll | auto",
            "relevance": 83,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/overflow-y"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies the handling of overflow in the vertical direction.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "pad",
            "browsers": [
                "FF33"
            ],
            "atRule": "@counter-style",
            "syntax": "<integer> && <symbol>",
            "relevance": 50,
            "description": "@counter-style descriptor. Specifies a \"fixed-width\" counter style, where representations shorter than the pad value are padded with a particular <symbol>",
            "restrictions": [
                "integer",
                "image",
                "string",
                "identifier"
            ]
        },
        {
            "name": "padding",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "values": [],
            "syntax": "<'padding-top'>{1,4}",
            "relevance": 95,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/padding"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property to set values for the thickness of the padding area. If left is omitted, it is the same as right. If bottom is omitted it is the same as top, if right is omitted it is the same as top. The value may not be negative.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "padding-bottom",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<length-percentage [0,\u221E]>",
            "relevance": 89,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/padding-bottom"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property to set values for the thickness of the padding area. If left is omitted, it is the same as right. If bottom is omitted it is the same as top, if right is omitted it is the same as top. The value may not be negative.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "padding-block-end",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'padding-top'>",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/padding-block-end"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'padding-bottom'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "padding-block-start",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'padding-top'>",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/padding-block-start"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'padding-top'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "padding-inline-end",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'padding-top'>",
            "relevance": 56,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/padding-inline-end"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'padding-right'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "padding-inline-start",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S12.1",
                "SM12.2",
                "C69",
                "CA69",
                "O56"
            ],
            "syntax": "<'padding-top'>",
            "relevance": 58,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/padding-inline-start"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Logical 'padding-left'. Mapping depends on the parent element's 'writing-mode', 'direction', and 'text-orientation'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "padding-left",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<length-percentage [0,\u221E]>",
            "relevance": 90,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/padding-left"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property to set values for the thickness of the padding area. If left is omitted, it is the same as right. If bottom is omitted it is the same as top, if right is omitted it is the same as top. The value may not be negative.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "padding-right",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<length-percentage [0,\u221E]>",
            "relevance": 89,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/padding-right"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property to set values for the thickness of the padding area. If left is omitted, it is the same as right. If bottom is omitted it is the same as top, if right is omitted it is the same as top. The value may not be negative.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "padding-top",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "syntax": "<length-percentage [0,\u221E]>",
            "relevance": 89,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/padding-top"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Shorthand property to set values for the thickness of the padding area. If left is omitted, it is the same as right. If bottom is omitted it is the same as top, if right is omitted it is the same as top. The value may not be negative.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "page-break-after",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1.2",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O7"
            ],
            "values": [
                {
                    "name": "always",
                    "description": "Always force a page break after the generated box."
                },
                {
                    "name": "auto",
                    "description": "Neither force nor forbid a page break after generated box."
                },
                {
                    "name": "avoid",
                    "description": "Avoid a page break after the generated box."
                },
                {
                    "name": "left",
                    "description": "Force one or two page breaks after the generated box so that the next page is formatted as a left page."
                },
                {
                    "name": "right",
                    "description": "Force one or two page breaks after the generated box so that the next page is formatted as a right page."
                }
            ],
            "status": "obsolete",
            "syntax": "auto | always | avoid | left | right | recto | verso",
            "relevance": 1,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/page-break-after"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Defines rules for page breaks after an element.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "page-break-before",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1.2",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O7"
            ],
            "values": [
                {
                    "name": "always",
                    "description": "Always force a page break before the generated box."
                },
                {
                    "name": "auto",
                    "description": "Neither force nor forbid a page break before the generated box."
                },
                {
                    "name": "avoid",
                    "description": "Avoid a page break before the generated box."
                },
                {
                    "name": "left",
                    "description": "Force one or two page breaks before the generated box so that the next page is formatted as a left page."
                },
                {
                    "name": "right",
                    "description": "Force one or two page breaks before the generated box so that the next page is formatted as a right page."
                }
            ],
            "status": "obsolete",
            "syntax": "auto | always | avoid | left | right | recto | verso",
            "relevance": 0,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/page-break-before"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Defines rules for page breaks before an element.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "page-break-inside",
            "browsers": [
                "E12",
                "FF19",
                "FFA19",
                "S1.3",
                "SM1",
                "C1",
                "CA18",
                "IE8",
                "O7"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Neither force nor forbid a page break inside the generated box."
                },
                {
                    "name": "avoid",
                    "description": "Avoid a page break inside the generated box."
                }
            ],
            "status": "obsolete",
            "syntax": "auto | avoid",
            "relevance": 2,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/page-break-inside"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Defines rules for page breaks inside an element.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "paint-order",
            "browsers": [
                "E123",
                "FF60",
                "FFA60",
                "S11",
                "SM11",
                "C123",
                "CA123",
                "O109"
            ],
            "values": [
                {
                    "name": "fill"
                },
                {
                    "name": "markers"
                },
                {
                    "name": "normal",
                    "description": "The element is painted with the standard order of painting operations: the 'fill' is painted first, then its 'stroke' and finally its markers."
                },
                {
                    "name": "stroke"
                }
            ],
            "syntax": "normal | [ fill || stroke || markers ]",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/paint-order"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-03-22"
            },
            "description": "Controls the order that the three paint operations that shapes and text are rendered with: their fill, their stroke and any markers they might have.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "perspective",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C36",
                "CA36",
                "IE10",
                "O23"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No perspective transform is applied."
                }
            ],
            "syntax": "none | <length>",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/perspective"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Applies the same transform as the perspective(<number>) transform function, except that it applies only to the positioned or transformed children of the element, not to the transform on the element itself.",
            "restrictions": [
                "length",
                "enum"
            ]
        },
        {
            "name": "perspective-origin",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C36",
                "CA36",
                "IE10",
                "O23"
            ],
            "syntax": "<position>",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/perspective-origin"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Establishes the origin for the perspective property. It effectively sets the X and Y position at which the viewer appears to be looking at the children of the element.",
            "restrictions": [
                "position",
                "percentage",
                "length"
            ]
        },
        {
            "name": "pointer-events",
            "browsers": [
                "E12",
                "FF1.5",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "IE11",
                "O9"
            ],
            "values": [
                {
                    "name": "all",
                    "description": "The given element can be the target element for pointer events whenever the pointer is over either the interior or the perimeter of the element."
                },
                {
                    "name": "fill",
                    "description": "The given element can be the target element for pointer events whenever the pointer is over the interior of the element."
                },
                {
                    "name": "none",
                    "description": "The given element does not receive pointer events."
                },
                {
                    "name": "painted",
                    "description": "The given element can be the target element for pointer events when the pointer is over a \"painted\" area. "
                },
                {
                    "name": "stroke",
                    "description": "The given element can be the target element for pointer events whenever the pointer is over the perimeter of the element."
                },
                {
                    "name": "visible",
                    "description": "The given element can be the target element for pointer events when the 'visibility' property is set to visible and the pointer is over either the interior or the perimeter of the element."
                },
                {
                    "name": "visibleFill",
                    "description": "The given element can be the target element for pointer events when the 'visibility' property is set to visible and when the pointer is over the interior of the element."
                },
                {
                    "name": "visiblePainted",
                    "description": "The given element can be the target element for pointer events when the 'visibility' property is set to visible and when the pointer is over a 'painted' area."
                },
                {
                    "name": "visibleStroke",
                    "description": "The given element can be the target element for pointer events when the 'visibility' property is set to visible and when the pointer is over the perimeter of the element."
                }
            ],
            "syntax": "auto | none | visiblePainted | visibleFill | visibleStroke | visible | painted | fill | stroke | all | inherit",
            "relevance": 83,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/pointer-events"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies under what circumstances a given element can be the target element for a pointer event.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "position",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O4"
            ],
            "values": [
                {
                    "name": "absolute",
                    "description": "The box's position (and possibly size) is specified with the 'top', 'right', 'bottom', and 'left' properties. These properties specify offsets with respect to the box's 'containing block'."
                },
                {
                    "name": "fixed",
                    "description": "The box's position is calculated according to the 'absolute' model, but in addition, the box is fixed with respect to some reference. As with the 'absolute' model, the box's margins do not collapse with any other margins."
                },
                {
                    "name": "-ms-page",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O4"
                    ],
                    "description": "The box's position is calculated according to the 'absolute' model."
                },
                {
                    "name": "relative",
                    "description": "The box's position is calculated according to the normal flow (this is called the position in normal flow). Then the box is offset relative to its normal position."
                },
                {
                    "name": "static",
                    "description": "The box is a normal box, laid out according to the normal flow. The 'top', 'right', 'bottom', and 'left' properties do not apply."
                },
                {
                    "name": "sticky",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O4"
                    ],
                    "description": "The box's position is calculated according to the normal flow. Then the box is offset relative to its flow root and containing block and in all cases, including table elements, does not affect the position of any following boxes."
                },
                {
                    "name": "-webkit-sticky",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O4"
                    ],
                    "description": "The box's position is calculated according to the normal flow. Then the box is offset relative to its flow root and containing block and in all cases, including table elements, does not affect the position of any following boxes."
                }
            ],
            "syntax": "static | relative | absolute | sticky | fixed",
            "relevance": 95,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/position"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "The position CSS property sets how an element is positioned in a document. The top, right, bottom, and left properties determine the final location of positioned elements.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "prefix",
            "browsers": [
                "FF33"
            ],
            "atRule": "@counter-style",
            "syntax": "<symbol>",
            "relevance": 50,
            "description": "@counter-style descriptor. Specifies a <symbol> that is prepended to the marker representation.",
            "restrictions": [
                "image",
                "string",
                "identifier"
            ]
        },
        {
            "name": "quotes",
            "browsers": [
                "E12",
                "FF1.5",
                "FFA4",
                "S9",
                "SM9",
                "C11",
                "CA18",
                "IE8",
                "O4"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "The 'open-quote' and 'close-quote' values of the 'content' property produce no quotations marks, as if they were 'no-open-quote' and 'no-close-quote' respectively."
                }
            ],
            "syntax": "none | auto | [ <string> <string> ]+",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/quotes"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Specifies quotation marks for any number of embedded quotations.",
            "restrictions": [
                "string"
            ]
        },
        {
            "name": "range",
            "browsers": [
                "FF33"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The range depends on the counter system."
                },
                {
                    "name": "infinite",
                    "description": "If used as the first value in a range, it represents negative infinity; if used as the second value, it represents positive infinity."
                }
            ],
            "atRule": "@counter-style",
            "syntax": "[ [ <integer> | infinite ]{2} ]# | auto",
            "relevance": 50,
            "description": "@counter-style descriptor. Defines the ranges over which the counter style is defined.",
            "restrictions": [
                "integer",
                "enum"
            ]
        },
        {
            "name": "resize",
            "browsers": [
                "E79",
                "FF4",
                "FFA4",
                "S3",
                "C1",
                "CA18",
                "O12.1"
            ],
            "values": [
                {
                    "name": "both",
                    "description": "The UA presents a bidirectional resizing mechanism to allow the user to adjust both the height and the width of the element."
                },
                {
                    "name": "horizontal",
                    "description": "The UA presents a unidirectional horizontal resizing mechanism to allow the user to adjust only the width of the element."
                },
                {
                    "name": "none",
                    "description": "The UA does not present a resizing mechanism on the element, and the user is given no direct manipulation mechanism to resize the element."
                },
                {
                    "name": "vertical",
                    "description": "The UA presents a unidirectional vertical resizing mechanism to allow the user to adjust only the height of the element."
                }
            ],
            "syntax": "none | both | horizontal | vertical | block | inline",
            "relevance": 65,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/resize"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Specifies whether or not an element is resizable by the user, and if so, along which axis/axes.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "right",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE5.5",
                "O5"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "For non-replaced elements, the effect of this value depends on which of related properties have the value 'auto' as well"
                }
            ],
            "syntax": "<length> | <percentage> | auto",
            "relevance": 91,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/right"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies how far an absolutely positioned box's right margin edge is offset to the left of the right edge of the box's 'containing block'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "ruby-align",
            "browsers": [
                "E128",
                "FF38",
                "FFA38",
                "S18.2",
                "SM18.2",
                "C128",
                "CA128",
                "O114"
            ],
            "values": [
                {
                    "name": "auto",
                    "browsers": [
                        "E128",
                        "FF38",
                        "FFA38",
                        "S18.2",
                        "SM18.2",
                        "C128",
                        "CA128",
                        "O114"
                    ],
                    "description": "The user agent determines how the ruby contents are aligned. This is the initial value."
                },
                {
                    "name": "center",
                    "description": "The ruby content is centered within its box."
                },
                {
                    "name": "distribute-letter",
                    "browsers": [
                        "E128",
                        "FF38",
                        "FFA38",
                        "S18.2",
                        "SM18.2",
                        "C128",
                        "CA128",
                        "O114"
                    ],
                    "description": "If the width of the ruby text is smaller than that of the base, then the ruby text contents are evenly distributed across the width of the base, with the first and last ruby text glyphs lining up with the corresponding first and last base glyphs. If the width of the ruby text is at least the width of the base, then the letters of the base are evenly distributed across the width of the ruby text."
                },
                {
                    "name": "distribute-space",
                    "browsers": [
                        "E128",
                        "FF38",
                        "FFA38",
                        "S18.2",
                        "SM18.2",
                        "C128",
                        "CA128",
                        "O114"
                    ],
                    "description": "If the width of the ruby text is smaller than that of the base, then the ruby text contents are evenly distributed across the width of the base, with a certain amount of white space preceding the first and following the last character in the ruby text. That amount of white space is normally equal to half the amount of inter-character space of the ruby text."
                },
                {
                    "name": "left",
                    "description": "The ruby text content is aligned with the start edge of the base."
                },
                {
                    "name": "line-edge",
                    "browsers": [
                        "E128",
                        "FF38",
                        "FFA38",
                        "S18.2",
                        "SM18.2",
                        "C128",
                        "CA128",
                        "O114"
                    ],
                    "description": "If the ruby text is not adjacent to a line edge, it is aligned as in 'auto'. If it is adjacent to a line edge, then it is still aligned as in auto, but the side of the ruby text that touches the end of the line is lined up with the corresponding edge of the base."
                },
                {
                    "name": "right",
                    "browsers": [
                        "E128",
                        "FF38",
                        "FFA38",
                        "S18.2",
                        "SM18.2",
                        "C128",
                        "CA128",
                        "O114"
                    ],
                    "description": "The ruby text content is aligned with the end edge of the base."
                },
                {
                    "name": "start",
                    "browsers": [
                        "E128",
                        "FF38",
                        "FFA38",
                        "S18.2",
                        "SM18.2",
                        "C128",
                        "CA128",
                        "O114"
                    ],
                    "description": "The ruby text content is aligned with the start edge of the base."
                },
                {
                    "name": "space-between",
                    "browsers": [
                        "E128",
                        "FF38",
                        "FFA38",
                        "S18.2",
                        "SM18.2",
                        "C128",
                        "CA128",
                        "O114"
                    ],
                    "description": "The ruby content expands as defined for normal text justification (as defined by 'text-justify'),"
                },
                {
                    "name": "space-around",
                    "browsers": [
                        "E128",
                        "FF38",
                        "FFA38",
                        "S18.2",
                        "SM18.2",
                        "C128",
                        "CA128",
                        "O114"
                    ],
                    "description": "As for 'space-between' except that there exists an extra justification opportunities whose space is distributed half before and half after the ruby content."
                }
            ],
            "syntax": "start | center | space-between | space-around",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/ruby-align"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-12-11"
            },
            "description": "Specifies how text is distributed within the various ruby boxes when their contents do not exactly fill their respective boxes.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "ruby-overhang",
            "browsers": [
                "S18.2",
                "SM18.2"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The ruby text can overhang text adjacent to the base on either side. This is the initial value."
                },
                {
                    "name": "end",
                    "description": "The ruby text can overhang the text that follows it."
                },
                {
                    "name": "none",
                    "description": "The ruby text cannot overhang any text adjacent to its base, only its own base."
                },
                {
                    "name": "start",
                    "description": "The ruby text can overhang the text that precedes it."
                }
            ],
            "relevance": 50,
            "baseline": {
                "status": "false"
            },
            "description": "Determines whether, and on which side, ruby text is allowed to partially overhang any adjacent text in addition to its own base, when the ruby text is wider than the ruby base.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "ruby-position",
            "browsers": [
                "E84",
                "FF38",
                "FFA38",
                "S18.2",
                "SM18.2",
                "C84",
                "CA84",
                "O70"
            ],
            "values": [
                {
                    "name": "after",
                    "description": "The ruby text appears after the base. This is a relatively rare setting used in ideographic East Asian writing systems, most easily found in educational text."
                },
                {
                    "name": "before",
                    "description": "The ruby text appears before the base. This is the most common setting used in ideographic East Asian writing systems."
                },
                {
                    "name": "inline"
                },
                {
                    "name": "right",
                    "description": "The ruby text appears on the right of the base. Unlike 'before' and 'after', this value is not relative to the text flow direction."
                }
            ],
            "syntax": "[ alternate || [ over | under ] ] | inter-character",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/ruby-position"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-12-11"
            },
            "description": "Used by the parent of elements with display: ruby-text to control the position of the ruby text with respect to its base.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "ruby-span",
            "browsers": [
                "FF10"
            ],
            "values": [
                {
                    "name": "attr(x)",
                    "description": "The value of attribute 'x' is a string value. The string value is evaluated as a <number> to determine the number of ruby base elements to be spanned by the annotation element."
                },
                {
                    "name": "none",
                    "description": "No spanning. The computed value is '1'."
                }
            ],
            "relevance": 50,
            "description": "Determines whether, and on which side, ruby text is allowed to partially overhang any adjacent text in addition to its own base, when the ruby text is wider than the ruby base.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "scrollbar-3dlight-color",
            "browsers": [
                "IE6"
            ],
            "relevance": 50,
            "description": "Determines the color of the top and left edges of the scroll box and scroll arrows of a scroll bar.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "scrollbar-arrow-color",
            "browsers": [
                "IE6"
            ],
            "relevance": 50,
            "description": "Determines the color of the arrow elements of a scroll arrow.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "scrollbar-base-color",
            "browsers": [
                "IE6"
            ],
            "relevance": 50,
            "description": "Determines the color of the main elements of a scroll bar, which include the scroll box, track, and scroll arrows.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "scrollbar-darkshadow-color",
            "browsers": [
                "IE6"
            ],
            "relevance": 50,
            "description": "Determines the color of the gutter of a scroll bar.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "scrollbar-face-color",
            "browsers": [
                "IE6"
            ],
            "relevance": 50,
            "description": "Determines the color of the scroll box and scroll arrows of a scroll bar.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "scrollbar-highlight-color",
            "browsers": [
                "IE6"
            ],
            "relevance": 50,
            "description": "Determines the color of the top and left edges of the scroll box and scroll arrows of a scroll bar.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "scrollbar-shadow-color",
            "browsers": [
                "IE6"
            ],
            "relevance": 50,
            "description": "Determines the color of the bottom and right edges of the scroll box and scroll arrows of a scroll bar.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "scrollbar-track-color",
            "browsers": [
                "IE6"
            ],
            "relevance": 50,
            "description": "Determines the color of the track element of a scroll bar.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "scroll-behavior",
            "browsers": [
                "E79",
                "FF36",
                "FFA36",
                "S15.4",
                "SM15.4",
                "C61",
                "CA61",
                "O48"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Scrolls in an instant fashion."
                },
                {
                    "name": "smooth",
                    "description": "Scrolls in a smooth fashion using a user-agent-defined timing function and time period."
                }
            ],
            "syntax": "auto | smooth",
            "relevance": 58,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-behavior"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-03-14",
                "baseline_high_date": "2024-09-14"
            },
            "description": "Specifies the scrolling behavior for a scrolling box, when scrolling happens due to navigation or CSSOM scrolling APIs.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "scroll-snap-coordinate",
            "browsers": [
                "FF39"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "Specifies that this element does not contribute a snap point."
                }
            ],
            "status": "obsolete",
            "syntax": "none | <position>#",
            "relevance": 0,
            "description": "Defines the x and y coordinate within the element which will align with the nearest ancestor scroll container's snap-destination for the respective axis.",
            "restrictions": [
                "position",
                "length",
                "percentage",
                "enum"
            ]
        },
        {
            "name": "scroll-snap-destination",
            "browsers": [
                "FF39"
            ],
            "status": "obsolete",
            "syntax": "<position>",
            "relevance": 0,
            "description": "Define the x and y coordinate within the scroll container's visual viewport which element snap points will align with.",
            "restrictions": [
                "position",
                "length",
                "percentage"
            ]
        },
        {
            "name": "scroll-snap-points-x",
            "browsers": [
                "FF39"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No snap points are defined by this scroll container."
                },
                {
                    "name": "repeat()",
                    "description": "Defines an interval at which snap points are defined, starting from the container's relevant start edge."
                }
            ],
            "status": "obsolete",
            "syntax": "none | repeat( <length-percentage> )",
            "relevance": 0,
            "description": "Defines the positioning of snap points along the x axis of the scroll container it is applied to.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "scroll-snap-points-y",
            "browsers": [
                "FF39"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No snap points are defined by this scroll container."
                },
                {
                    "name": "repeat()",
                    "description": "Defines an interval at which snap points are defined, starting from the container's relevant start edge."
                }
            ],
            "status": "obsolete",
            "syntax": "none | repeat( <length-percentage> )",
            "relevance": 0,
            "description": "Defines the positioning of snap points along the y axis of the scroll container it is applied to.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "scroll-snap-type",
            "browsers": [
                "E79",
                "FF99",
                "FFA68",
                "S11",
                "SM11",
                "C69",
                "CA69",
                "IE10",
                "O56"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "The visual viewport of this scroll container must ignore snap points, if any, when scrolled."
                },
                {
                    "name": "mandatory",
                    "description": "The visual viewport of this scroll container is guaranteed to rest on a snap point when there are no active scrolling operations."
                },
                {
                    "name": "proximity",
                    "description": "The visual viewport of this scroll container may come to rest on a snap point at the termination of a scroll at the discretion of the UA given the parameters of the scroll."
                }
            ],
            "syntax": "none | [ x | y | block | inline | both ] [ mandatory | proximity ]?",
            "relevance": 57,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-snap-type"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-04-05",
                "baseline_high_date": "2024-10-05"
            },
            "description": "Defines how strictly snap points are enforced on the scroll container.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "shape-image-threshold",
            "browsers": [
                "E79",
                "FF62",
                "FFA62",
                "S10.1",
                "SM10.3",
                "C37",
                "CA37",
                "O24"
            ],
            "syntax": "<opacity-value>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/shape-image-threshold"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Defines the alpha channel threshold used to extract the shape using an image. A value of 0.5 means that the shape will enclose all the pixels that are more than 50% opaque.",
            "restrictions": [
                "number"
            ]
        },
        {
            "name": "shape-margin",
            "browsers": [
                "E79",
                "FF62",
                "FFA62",
                "S10.1",
                "SM10.3",
                "C37",
                "CA37",
                "O24"
            ],
            "syntax": "<length-percentage>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/shape-margin"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Adds a margin to a 'shape-outside'. This defines a new shape that is the smallest contour that includes all the points that are the 'shape-margin' distance outward in the perpendicular direction from a point on the underlying shape.",
            "restrictions": [
                "url",
                "length",
                "percentage"
            ]
        },
        {
            "name": "shape-outside",
            "browsers": [
                "E79",
                "FF62",
                "FFA62",
                "S10.1",
                "SM10.3",
                "C37",
                "CA37",
                "O24"
            ],
            "values": [
                {
                    "name": "margin-box",
                    "description": "The background is painted within (clipped to) the margin box."
                },
                {
                    "name": "none",
                    "description": "The float area is unaffected."
                }
            ],
            "syntax": "none | [ <shape-box> || <basic-shape> ] | <image>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/shape-outside"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Specifies an orthogonal rotation to be applied to an image before it is laid out.",
            "restrictions": [
                "image",
                "box",
                "shape",
                "enum"
            ]
        },
        {
            "name": "shape-rendering",
            "browsers": [
                "E79",
                "FF3",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Suppresses aural rendering."
                },
                {
                    "name": "crispEdges",
                    "description": "Emphasize the contrast between clean edges of artwork over rendering speed and geometric precision."
                },
                {
                    "name": "geometricPrecision",
                    "description": "Emphasize geometric precision over speed and crisp edges."
                },
                {
                    "name": "optimizeSpeed",
                    "description": "Emphasize rendering speed over geometric precision and crisp edges."
                }
            ],
            "syntax": "auto | optimizeSpeed | crispEdges | geometricPrecision",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/shape-rendering"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Provides hints about what tradeoffs to make as it renders vector graphics elements such as <path> elements and basic shapes such as circles and rectangles.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "size",
            "browsers": [
                "C",
                "O8"
            ],
            "atRule": "@page",
            "syntax": "<length [0,\u221E]>{1,2} | auto | [ <page-size> || [ portrait | landscape ] ]",
            "relevance": 53,
            "description": "The size CSS at-rule descriptor, used with the @page at-rule, defines the size and orientation of the box which is used to represent a page. Most of the time, this size corresponds to the target size of the printed page if applicable.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "src",
            "values": [
                {
                    "name": "url()",
                    "description": "Reference font by URL"
                },
                {
                    "name": "format()",
                    "description": "Optional hint describing the format of the font resource."
                },
                {
                    "name": "local()",
                    "description": "Format-specific string that identifies a locally available copy of a given font."
                }
            ],
            "atRule": "@font-face",
            "syntax": "[ <url> [ format( <string># ) ]? | local( <family-name> ) ]#",
            "relevance": 85,
            "description": "@font-face descriptor. Specifies the resource containing font data. It is required, whether the font is downloadable or locally installed.",
            "restrictions": [
                "enum",
                "url",
                "identifier"
            ]
        },
        {
            "name": "stop-color",
            "browsers": [
                "E15",
                "FF3",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "syntax": "<'color'>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/stop-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Indicates what color to use at that gradient stop.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "stop-opacity",
            "browsers": [
                "E15",
                "FF3",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "syntax": "<'opacity'>",
            "relevance": 52,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/stop-opacity"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Defines the opacity of a given gradient stop.",
            "restrictions": [
                "number(0-1)"
            ]
        },
        {
            "name": "stroke",
            "browsers": [
                "E15",
                "FF1.5",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "url()",
                    "description": "A URL reference to a paint server element, which is an element that defines a paint server: 'hatch', 'linearGradient', 'mesh', 'pattern', 'radialGradient' and 'solidcolor'."
                },
                {
                    "name": "none",
                    "description": "No paint is applied in this layer."
                }
            ],
            "syntax": "<paint>",
            "relevance": 68,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/stroke"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Paints along the outline of the given graphical element.",
            "restrictions": [
                "color",
                "enum",
                "url"
            ]
        },
        {
            "name": "stroke-dasharray",
            "browsers": [
                "E15",
                "FF1.5",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "Indicates that no dashing is used."
                }
            ],
            "syntax": "none | <dasharray>",
            "relevance": 61,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/stroke-dasharray"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Controls the pattern of dashes and gaps used to stroke paths.",
            "restrictions": [
                "length",
                "percentage",
                "number",
                "enum"
            ]
        },
        {
            "name": "stroke-dashoffset",
            "browsers": [
                "E15",
                "FF1.5",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "syntax": "<length-percentage> | <number>",
            "relevance": 63,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/stroke-dashoffset"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Specifies the distance into the dash pattern to start the dash.",
            "restrictions": [
                "percentage",
                "length"
            ]
        },
        {
            "name": "stroke-linecap",
            "browsers": [
                "E15",
                "FF1.5",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "butt",
                    "description": "Indicates that the stroke for each subpath does not extend beyond its two endpoints."
                },
                {
                    "name": "round",
                    "description": "Indicates that at each end of each subpath, the shape representing the stroke will be extended by a half circle with a radius equal to the stroke width."
                },
                {
                    "name": "square",
                    "description": "Indicates that at the end of each subpath, the shape representing the stroke will be extended by a rectangle with the same width as the stroke width and whose length is half of the stroke width."
                }
            ],
            "syntax": "butt | round | square",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/stroke-linecap"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Specifies the shape to be used at the end of open subpaths when they are stroked.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "stroke-linejoin",
            "browsers": [
                "E15",
                "FF1.5",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "bevel",
                    "description": "Indicates that a bevelled corner is to be used to join path segments."
                },
                {
                    "name": "miter",
                    "description": "Indicates that a sharp corner is to be used to join path segments."
                },
                {
                    "name": "round",
                    "description": "Indicates that a round corner is to be used to join path segments."
                }
            ],
            "syntax": "miter | miter-clip | round | bevel | arcs",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/stroke-linejoin"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Specifies the shape to be used at the corners of paths or basic shapes when they are stroked.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "stroke-miterlimit",
            "browsers": [
                "E15",
                "FF1.5",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "syntax": "<number>",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/stroke-miterlimit"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "When two line segments meet at a sharp angle and miter joins have been specified for 'stroke-linejoin', it is possible for the miter to extend far beyond the thickness of the line stroking the path.",
            "restrictions": [
                "number"
            ]
        },
        {
            "name": "stroke-opacity",
            "browsers": [
                "E15",
                "FF1.5",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "syntax": "<'opacity'>",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/stroke-opacity"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Specifies the opacity of the painting operation used to stroke the current object.",
            "restrictions": [
                "number(0-1)"
            ]
        },
        {
            "name": "stroke-width",
            "browsers": [
                "E15",
                "FF1.5",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "syntax": "<length-percentage> | <number>",
            "relevance": 69,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/stroke-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "description": "Specifies the width of the stroke on the current object.",
            "restrictions": [
                "percentage",
                "length"
            ]
        },
        {
            "name": "suffix",
            "browsers": [
                "FF33"
            ],
            "atRule": "@counter-style",
            "syntax": "<symbol>",
            "relevance": 50,
            "description": "@counter-style descriptor. Specifies a <symbol> that is appended to the marker representation.",
            "restrictions": [
                "image",
                "string",
                "identifier"
            ]
        },
        {
            "name": "system",
            "browsers": [
                "FF33"
            ],
            "values": [
                {
                    "name": "additive",
                    "description": "Represents \"sign-value\" numbering systems, which, rather than using reusing digits in different positions to change their value, define additional digits with much larger values, so that the value of the number can be obtained by adding all the digits together."
                },
                {
                    "name": "alphabetic",
                    "description": "Interprets the list of counter symbols as digits to an alphabetic numbering system, similar to the default lower-alpha counter style, which wraps from \"a\", \"b\", \"c\", to \"aa\", \"ab\", \"ac\"."
                },
                {
                    "name": "cyclic",
                    "description": "Cycles repeatedly through its provided symbols, looping back to the beginning when it reaches the end of the list."
                },
                {
                    "name": "extends",
                    "description": "Use the algorithm of another counter style, but alter other aspects."
                },
                {
                    "name": "fixed",
                    "description": "Runs through its list of counter symbols once, then falls back."
                },
                {
                    "name": "numeric",
                    "description": "interprets the list of counter symbols as digits to a \"place-value\" numbering system, similar to the default 'decimal' counter style."
                },
                {
                    "name": "symbolic",
                    "description": "Cycles repeatedly through its provided symbols, doubling, tripling, etc. the symbols on each successive pass through the list."
                }
            ],
            "atRule": "@counter-style",
            "syntax": "cyclic | numeric | alphabetic | symbolic | additive | [ fixed <integer>? ] | [ extends <counter-style-name> ]",
            "relevance": 50,
            "description": "@counter-style descriptor. Specifies which algorithm will be used to construct the counter's representation based on the counter value.",
            "restrictions": [
                "enum",
                "integer"
            ]
        },
        {
            "name": "symbols",
            "browsers": [
                "FF33"
            ],
            "atRule": "@counter-style",
            "syntax": "<symbol>+",
            "relevance": 50,
            "description": "@counter-style descriptor. Specifies the symbols used by the marker-construction algorithm specified by the system descriptor.",
            "restrictions": [
                "image",
                "string",
                "identifier"
            ]
        },
        {
            "name": "table-layout",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM3",
                "C14",
                "CA18",
                "IE5",
                "O7"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Use any automatic table layout algorithm."
                },
                {
                    "name": "fixed",
                    "description": "Use the fixed table layout algorithm."
                }
            ],
            "syntax": "auto | fixed",
            "relevance": 58,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/table-layout"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Controls the algorithm used to lay out the table cells, rows, and columns.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "tab-size",
            "browsers": [
                "E79",
                "FF91",
                "FFA91",
                "S7",
                "SM7",
                "C21",
                "CA25",
                "O15"
            ],
            "syntax": "<integer> | <length>",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/tab-size"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-08-10",
                "baseline_high_date": "2024-02-10"
            },
            "description": "Determines the width of the tab character (U+0009), in space characters (U+0020), when rendered.",
            "restrictions": [
                "integer",
                "length"
            ]
        },
        {
            "name": "text-align",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE3",
                "O3.5"
            ],
            "values": [
                {
                    "name": "center",
                    "description": "The inline contents are centered within the line box."
                },
                {
                    "name": "end",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE3",
                        "O3.5"
                    ],
                    "description": "The inline contents are aligned to the end edge of the line box."
                },
                {
                    "name": "justify",
                    "description": "The text is justified according to the method specified by the 'text-justify' property."
                },
                {
                    "name": "left",
                    "description": "The inline contents are aligned to the left edge of the line box. In vertical text, 'left' aligns to the edge of the line box that would be the start edge for left-to-right text."
                },
                {
                    "name": "right",
                    "description": "The inline contents are aligned to the right edge of the line box. In vertical text, 'right' aligns to the edge of the line box that would be the end edge for left-to-right text."
                },
                {
                    "name": "start",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE3",
                        "O3.5"
                    ],
                    "description": "The inline contents are aligned to the start edge of the line box."
                }
            ],
            "syntax": "start | end | left | right | center | justify | match-parent",
            "relevance": 93,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-align"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Describes how inline contents of a block are horizontally aligned if the contents do not completely fill the line box.",
            "restrictions": [
                "string"
            ]
        },
        {
            "name": "text-align-last",
            "browsers": [
                "E12",
                "FF49",
                "FFA49",
                "S16",
                "SM16",
                "C47",
                "CA47",
                "IE5.5",
                "O34"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Content on the affected line is aligned per 'text-align' unless 'text-align' is set to 'justify', in which case it is 'start-aligned'."
                },
                {
                    "name": "center",
                    "description": "The inline contents are centered within the line box."
                },
                {
                    "name": "justify",
                    "description": "The text is justified according to the method specified by the 'text-justify' property."
                },
                {
                    "name": "left",
                    "description": "The inline contents are aligned to the left edge of the line box. In vertical text, 'left' aligns to the edge of the line box that would be the start edge for left-to-right text."
                },
                {
                    "name": "right",
                    "description": "The inline contents are aligned to the right edge of the line box. In vertical text, 'right' aligns to the edge of the line box that would be the end edge for left-to-right text."
                }
            ],
            "syntax": "auto | start | end | left | right | center | justify",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-align-last"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-09-12",
                "baseline_high_date": "2025-03-12"
            },
            "description": "Describes how the last line of a block or a line right before a forced line break is aligned when 'text-align' is set to 'justify'.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "text-anchor",
            "browsers": [
                "E14",
                "FF3",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "end",
                    "description": "The rendered characters are aligned such that the end of the resulting rendered text is at the initial current text position."
                },
                {
                    "name": "middle",
                    "description": "The rendered characters are aligned such that the geometric middle of the resulting rendered text is at the initial current text position."
                },
                {
                    "name": "start",
                    "description": "The rendered characters are aligned such that the start of the resulting rendered text is at the initial current text position."
                }
            ],
            "syntax": "start | middle | end",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-anchor"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2016-08-02",
                "baseline_high_date": "2019-02-02"
            },
            "description": "Used to align (start-, middle- or end-alignment) a string of text relative to a given point.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "text-decoration",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE3",
                "O3.5"
            ],
            "values": [
                {
                    "name": "dashed",
                    "description": "Produces a dashed line style."
                },
                {
                    "name": "dotted",
                    "description": "Produces a dotted line."
                },
                {
                    "name": "double",
                    "description": "Produces a double line."
                },
                {
                    "name": "line-through",
                    "description": "Each line of text has a line through the middle."
                },
                {
                    "name": "none",
                    "description": "Produces no line."
                },
                {
                    "name": "overline",
                    "description": "Each line of text has a line above it."
                },
                {
                    "name": "solid",
                    "description": "Produces a solid line."
                },
                {
                    "name": "underline",
                    "description": "Each line of text is underlined."
                },
                {
                    "name": "wavy",
                    "description": "Produces a wavy line."
                }
            ],
            "syntax": "<'text-decoration-line'> || <'text-decoration-style'> || <'text-decoration-color'> || <'text-decoration-thickness'>",
            "relevance": 91,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-decoration"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Decorations applied to font used for an element's text.",
            "restrictions": [
                "enum",
                "color"
            ]
        },
        {
            "name": "text-decoration-color",
            "browsers": [
                "E79",
                "FF36",
                "FFA36",
                "S12.1",
                "SM12.2",
                "C57",
                "CA57",
                "O44"
            ],
            "syntax": "<color>",
            "relevance": 58,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-decoration-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Specifies the color of text decoration (underlines overlines, and line-throughs) set on the element with text-decoration-line.",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "text-decoration-line",
            "browsers": [
                "E79",
                "FF36",
                "FFA36",
                "S12.1",
                "SM12.2",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "line-through",
                    "description": "Each line of text has a line through the middle."
                },
                {
                    "name": "none",
                    "description": "Neither produces nor inhibits text decoration."
                },
                {
                    "name": "overline",
                    "description": "Each line of text has a line above it."
                },
                {
                    "name": "underline",
                    "description": "Each line of text is underlined."
                }
            ],
            "syntax": "none | [ underline || overline || line-through || blink ] | spelling-error | grammar-error",
            "relevance": 60,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-decoration-line"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Specifies what line decorations, if any, are added to the element.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "text-decoration-style",
            "browsers": [
                "E79",
                "FF36",
                "FFA36",
                "S12.1",
                "SM12.2",
                "C57",
                "CA57",
                "O44"
            ],
            "values": [
                {
                    "name": "dashed",
                    "description": "Produces a dashed line style."
                },
                {
                    "name": "dotted",
                    "description": "Produces a dotted line."
                },
                {
                    "name": "double",
                    "description": "Produces a double line."
                },
                {
                    "name": "none",
                    "description": "Produces no line."
                },
                {
                    "name": "solid",
                    "description": "Produces a solid line."
                },
                {
                    "name": "wavy",
                    "description": "Produces a wavy line."
                }
            ],
            "syntax": "solid | double | dotted | dashed | wavy",
            "relevance": 54,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-decoration-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Specifies the line style for underline, line-through and overline text decoration.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "text-indent",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE3",
                "O3.5"
            ],
            "values": [],
            "syntax": "<length-percentage> && hanging? && each-line?",
            "relevance": 67,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-indent"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies the indentation applied to lines of inline content in a block. The indentation only affects the first line of inline content in the block unless the 'hanging' keyword is specified, in which case it affects all lines except the first.",
            "restrictions": [
                "percentage",
                "length"
            ]
        },
        {
            "name": "text-justify",
            "browsers": [
                "FF55",
                "FFA55",
                "IE11",
                "O19"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The UA determines the justification algorithm to follow, based on a balance between performance and adequate presentation quality."
                },
                {
                    "name": "distribute",
                    "description": "Justification primarily changes spacing both at word separators and at grapheme cluster boundaries in all scripts except those in the connected and cursive groups. This value is sometimes used in e.g. Japanese, often with the 'text-align-last' property."
                },
                {
                    "name": "distribute-all-lines"
                },
                {
                    "name": "inter-cluster",
                    "description": "Justification primarily changes spacing at word separators and at grapheme cluster boundaries in clustered scripts. This value is typically used for Southeast Asian scripts such as Thai."
                },
                {
                    "name": "inter-ideograph",
                    "description": "Justification primarily changes spacing at word separators and at inter-graphemic boundaries in scripts that use no word spaces. This value is typically used for CJK languages."
                },
                {
                    "name": "inter-word",
                    "description": "Justification primarily changes spacing at word separators. This value is typically used for languages that separate words using spaces, like English or (sometimes) Korean."
                },
                {
                    "name": "kashida",
                    "description": "Justification primarily stretches Arabic and related scripts through the use of kashida or other calligraphic elongation."
                },
                {
                    "name": "newspaper"
                }
            ],
            "syntax": "auto | inter-character | inter-word | none",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-justify"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Selects the justification algorithm used when 'text-align' is set to 'justify'. The property applies to block containers, but the UA may (but is not required to) also support it on inline elements.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "text-orientation",
            "browsers": [
                "E79",
                "FF41",
                "FFA41",
                "S14",
                "SM14",
                "C48",
                "CA48",
                "O35"
            ],
            "values": [
                {
                    "name": "sideways",
                    "browsers": [
                        "E79",
                        "FF41",
                        "FFA41",
                        "S14",
                        "SM14",
                        "C48",
                        "CA48",
                        "O35"
                    ],
                    "description": "This value is equivalent to 'sideways-right' in 'vertical-rl' writing mode and equivalent to 'sideways-left' in 'vertical-lr' writing mode."
                },
                {
                    "name": "sideways-right",
                    "browsers": [
                        "E79",
                        "FF41",
                        "FFA41",
                        "S14",
                        "SM14",
                        "C48",
                        "CA48",
                        "O35"
                    ],
                    "description": "In vertical writing modes, this causes text to be set as if in a horizontal layout, but rotated 90\xb0 clockwise."
                },
                {
                    "name": "upright",
                    "description": "In vertical writing modes, characters from horizontal-only scripts are rendered upright, i.e. in their standard horizontal orientation."
                }
            ],
            "syntax": "mixed | upright | sideways",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-orientation"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-09-16",
                "baseline_high_date": "2023-03-16"
            },
            "description": "Specifies the orientation of text within a line.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "text-overflow",
            "browsers": [
                "E12",
                "FF7",
                "FFA7",
                "S1.3",
                "SM1",
                "C1",
                "CA18",
                "IE6",
                "O11"
            ],
            "values": [
                {
                    "name": "clip",
                    "description": "Clip inline content that overflows. Characters may be only partially rendered."
                },
                {
                    "name": "ellipsis",
                    "description": "Render an ellipsis character (U+2026) to represent clipped inline content."
                }
            ],
            "syntax": "[ clip | ellipsis | <string> ]{1,2}",
            "relevance": 82,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-overflow"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Text can overflow for example when it is prevented from wrapping.",
            "restrictions": [
                "enum",
                "string"
            ]
        },
        {
            "name": "text-rendering",
            "browsers": [
                "E79",
                "FF1",
                "FFA46",
                "S5",
                "SM4.2",
                "C4",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "geometricPrecision",
                    "description": "Indicates that the user agent shall emphasize geometric precision over legibility and rendering speed."
                },
                {
                    "name": "optimizeLegibility",
                    "description": "Indicates that the user agent shall emphasize legibility over rendering speed and geometric precision."
                },
                {
                    "name": "optimizeSpeed",
                    "description": "Indicates that the user agent shall emphasize rendering speed over legibility and geometric precision."
                }
            ],
            "syntax": "auto | optimizeSpeed | optimizeLegibility | geometricPrecision",
            "relevance": 66,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-rendering"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "The creator of SVG content might want to provide a hint to the implementation about what tradeoffs to make as it renders text. The 'text-rendering' property provides these hints.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "text-shadow",
            "browsers": [
                "E12",
                "FF3.5",
                "FFA4",
                "S1.1",
                "SM1",
                "C2",
                "CA18",
                "IE10",
                "O9.5"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No shadow."
                }
            ],
            "syntax": "none | <shadow-t>#",
            "relevance": 72,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-shadow"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Enables shadow effects to be applied to the text of the element.",
            "restrictions": [
                "length",
                "color"
            ]
        },
        {
            "name": "text-transform",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O7"
            ],
            "values": [
                {
                    "name": "capitalize",
                    "description": "Puts the first typographic letter unit of each word in titlecase."
                },
                {
                    "name": "lowercase",
                    "description": "Puts all letters in lowercase."
                },
                {
                    "name": "none",
                    "description": "No effects."
                },
                {
                    "name": "uppercase",
                    "description": "Puts all letters in uppercase."
                }
            ],
            "syntax": "none | [ capitalize | uppercase | lowercase ] || full-width || full-size-kana | math-auto",
            "relevance": 86,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-transform"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Controls capitalization effects of an element's text.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "text-underline-position",
            "browsers": [
                "E12",
                "FF74",
                "FFA79",
                "S12.1",
                "SM12.2",
                "C33",
                "CA33",
                "IE6",
                "O20"
            ],
            "values": [
                {
                    "name": "above"
                },
                {
                    "name": "auto",
                    "description": "The user agent may use any algorithm to determine the underline's position. In horizontal line layout, the underline should be aligned as for alphabetic. In vertical line layout, if the language is set to Japanese or Korean, the underline should be aligned as for over."
                },
                {
                    "name": "below",
                    "description": "The underline is aligned with the under edge of the element's content box."
                }
            ],
            "syntax": "auto | from-font | [ under || [ left | right ] ]",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-underline-position"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-07-28",
                "baseline_high_date": "2023-01-28"
            },
            "description": "Sets the position of an underline specified on the same element: it does not affect underlines specified by ancestor elements. This property is typically used in vertical writing contexts such as in Japanese documents where it often desired to have the underline appear 'over' (to the right of) the affected run of text",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "top",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE5",
                "O6"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "For non-replaced elements, the effect of this value depends on which of related properties have the value 'auto' as well"
                }
            ],
            "syntax": "<length> | <percentage> | auto",
            "relevance": 94,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/top"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies how far an absolutely positioned box's top margin edge is offset below the top edge of the box's 'containing block'.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "touch-action",
            "browsers": [
                "E12",
                "FF52",
                "FFA52",
                "S13",
                "SM9.3",
                "C36",
                "CA36",
                "IE11",
                "O23"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The user agent may determine any permitted touch behaviors for touches that begin on the element."
                },
                {
                    "name": "cross-slide-x",
                    "browsers": [
                        "E12",
                        "FF52",
                        "FFA52",
                        "S13",
                        "SM9.3",
                        "C36",
                        "CA36",
                        "IE11",
                        "O23"
                    ]
                },
                {
                    "name": "cross-slide-y",
                    "browsers": [
                        "E12",
                        "FF52",
                        "FFA52",
                        "S13",
                        "SM9.3",
                        "C36",
                        "CA36",
                        "IE11",
                        "O23"
                    ]
                },
                {
                    "name": "double-tap-zoom",
                    "browsers": [
                        "E12",
                        "FF52",
                        "FFA52",
                        "S13",
                        "SM9.3",
                        "C36",
                        "CA36",
                        "IE11",
                        "O23"
                    ]
                },
                {
                    "name": "manipulation",
                    "description": "The user agent may consider touches that begin on the element only for the purposes of scrolling and continuous zooming."
                },
                {
                    "name": "none",
                    "description": "Touches that begin on the element must not trigger default touch behaviors."
                },
                {
                    "name": "pan-x",
                    "description": "The user agent may consider touches that begin on the element only for the purposes of horizontally scrolling the element's nearest ancestor with horizontally scrollable content."
                },
                {
                    "name": "pan-y",
                    "description": "The user agent may consider touches that begin on the element only for the purposes of vertically scrolling the element's nearest ancestor with vertically scrollable content."
                },
                {
                    "name": "pinch-zoom",
                    "browsers": [
                        "E12",
                        "FF52",
                        "FFA52",
                        "S13",
                        "SM9.3",
                        "C36",
                        "CA36",
                        "IE11",
                        "O23"
                    ]
                }
            ],
            "syntax": "auto | none | [ [ pan-x | pan-left | pan-right ] || [ pan-y | pan-up | pan-down ] || pinch-zoom ] | manipulation",
            "relevance": 70,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/touch-action"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2019-09-19",
                "baseline_high_date": "2022-03-19"
            },
            "description": "Determines whether touch input may trigger default behavior supplied by user agent.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "transform",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C36",
                "CA36",
                "IE10",
                "O23"
            ],
            "values": [
                {
                    "name": "matrix()",
                    "description": "Specifies a 2D transformation in the form of a transformation matrix of six values. matrix(a,b,c,d,e,f) is equivalent to applying the transformation matrix [a b c d e f]"
                },
                {
                    "name": "matrix3d()",
                    "description": "Specifies a 3D transformation as a 4x4 homogeneous matrix of 16 values in column-major order."
                },
                {
                    "name": "none"
                },
                {
                    "name": "perspective()",
                    "description": "Specifies a perspective projection matrix."
                },
                {
                    "name": "rotate()",
                    "description": "Specifies a 2D rotation by the angle specified in the parameter about the origin of the element, as defined by the transform-origin property."
                },
                {
                    "name": "rotate3d()",
                    "description": "Specifies a clockwise 3D rotation by the angle specified in last parameter about the [x,y,z] direction vector described by the first 3 parameters."
                },
                {
                    "name": "rotateX('angle')",
                    "description": "Specifies a clockwise rotation by the given angle about the X axis."
                },
                {
                    "name": "rotateY('angle')",
                    "description": "Specifies a clockwise rotation by the given angle about the Y axis."
                },
                {
                    "name": "rotateZ('angle')",
                    "description": "Specifies a clockwise rotation by the given angle about the Z axis."
                },
                {
                    "name": "scale()",
                    "description": "Specifies a 2D scale operation by the [sx,sy] scaling vector described by the 2 parameters. If the second parameter is not provided, it is takes a value equal to the first."
                },
                {
                    "name": "scale3d()",
                    "description": "Specifies a 3D scale operation by the [sx,sy,sz] scaling vector described by the 3 parameters."
                },
                {
                    "name": "scaleX()",
                    "description": "Specifies a scale operation using the [sx,1] scaling vector, where sx is given as the parameter."
                },
                {
                    "name": "scaleY()",
                    "description": "Specifies a scale operation using the [sy,1] scaling vector, where sy is given as the parameter."
                },
                {
                    "name": "scaleZ()",
                    "description": "Specifies a scale operation using the [1,1,sz] scaling vector, where sz is given as the parameter."
                },
                {
                    "name": "skew()",
                    "description": "Specifies a skew transformation along the X and Y axes. The first angle parameter specifies the skew on the X axis. The second angle parameter specifies the skew on the Y axis. If the second parameter is not given then a value of 0 is used for the Y angle (ie: no skew on the Y axis)."
                },
                {
                    "name": "skewX()",
                    "description": "Specifies a skew transformation along the X axis by the given angle."
                },
                {
                    "name": "skewY()",
                    "description": "Specifies a skew transformation along the Y axis by the given angle."
                },
                {
                    "name": "translate()",
                    "description": "Specifies a 2D translation by the vector [tx, ty], where tx is the first translation-value parameter and ty is the optional second translation-value parameter."
                },
                {
                    "name": "translate3d()",
                    "description": "Specifies a 3D translation by the vector [tx,ty,tz], with tx, ty and tz being the first, second and third translation-value parameters respectively."
                },
                {
                    "name": "translateX()",
                    "description": "Specifies a translation by the given amount in the X direction."
                },
                {
                    "name": "translateY()",
                    "description": "Specifies a translation by the given amount in the Y direction."
                },
                {
                    "name": "translateZ()",
                    "description": "Specifies a translation by the given amount in the Z direction. Note that percentage values are not allowed in the translateZ translation-value, and if present are evaluated as 0."
                }
            ],
            "syntax": "none | <transform-list>",
            "relevance": 91,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/transform"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "A two-dimensional transformation is applied to an element through the 'transform' property. This property contains a list of transform functions similar to those allowed by SVG.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "transform-origin",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C36",
                "CA36",
                "IE10",
                "O23"
            ],
            "syntax": "[ <length-percentage> | left | center | right | top | bottom ] | [ [ <length-percentage> | left | center | right ] && [ <length-percentage> | top | center | bottom ] ] <length>?",
            "relevance": 75,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/transform-origin"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Establishes the origin of transformation for an element.",
            "restrictions": [
                "position",
                "length",
                "percentage"
            ]
        },
        {
            "name": "transform-style",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C36",
                "CA36",
                "O23"
            ],
            "values": [
                {
                    "name": "flat",
                    "description": "All children of this element are rendered flattened into the 2D plane of the element."
                },
                {
                    "name": "preserve-3d",
                    "browsers": [
                        "E12",
                        "FF16",
                        "FFA16",
                        "S9",
                        "SM9",
                        "C36",
                        "CA36",
                        "O23"
                    ],
                    "description": "Flattening is not performed, so children maintain their position in 3D space."
                }
            ],
            "syntax": "flat | preserve-3d",
            "relevance": 56,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/transform-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Defines how nested elements are rendered in 3D space.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "transition",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C26",
                "CA26",
                "IE10",
                "O12.1"
            ],
            "values": [
                {
                    "name": "all",
                    "description": "Every property that is able to undergo a transition will do so."
                },
                {
                    "name": "none",
                    "description": "No property will transition."
                }
            ],
            "syntax": "<single-transition>#",
            "relevance": 89,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/transition"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Shorthand property combines four of the transition properties into a single property.",
            "restrictions": [
                "time",
                "property",
                "timing-function",
                "enum"
            ]
        },
        {
            "name": "transition-delay",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C26",
                "CA26",
                "IE10",
                "O12.1"
            ],
            "syntax": "<time>#",
            "relevance": 64,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/transition-delay"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Defines when the transition will start. It allows a transition to begin execution some period of time from when it is applied.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "transition-duration",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C26",
                "CA26",
                "IE10",
                "O12.1"
            ],
            "syntax": "<time>#",
            "relevance": 69,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/transition-duration"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Specifies how long the transition from the old value to the new value should take.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "transition-property",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C26",
                "CA26",
                "IE10",
                "O12.1"
            ],
            "values": [
                {
                    "name": "all",
                    "description": "Every property that is able to undergo a transition will do so."
                },
                {
                    "name": "none",
                    "description": "No property will transition."
                }
            ],
            "syntax": "none | <single-transition-property>#",
            "relevance": 69,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/transition-property"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Specifies the name of the CSS property to which the transition is applied.",
            "restrictions": [
                "property"
            ]
        },
        {
            "name": "transition-timing-function",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C26",
                "CA26",
                "IE10",
                "O12.1"
            ],
            "syntax": "<easing-function>#",
            "relevance": 68,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/transition-timing-function"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Describes how the intermediate values used during a transition will be calculated.",
            "restrictions": [
                "timing-function"
            ]
        },
        {
            "name": "unicode-bidi",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1.3",
                "SM1",
                "C2",
                "CA18",
                "IE5.5",
                "O9.2"
            ],
            "values": [
                {
                    "name": "bidi-override",
                    "description": "Inside the element, reordering is strictly in sequence according to the 'direction' property; the implicit part of the bidirectional algorithm is ignored."
                },
                {
                    "name": "embed",
                    "description": "If the element is inline-level, this value opens an additional level of embedding with respect to the bidirectional algorithm. The direction of this embedding level is given by the 'direction' property."
                },
                {
                    "name": "isolate",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1.3",
                        "SM1",
                        "C2",
                        "CA18",
                        "IE5.5",
                        "O9.2"
                    ],
                    "description": "The contents of the element are considered to be inside a separate, independent paragraph."
                },
                {
                    "name": "isolate-override",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1.3",
                        "SM1",
                        "C2",
                        "CA18",
                        "IE5.5",
                        "O9.2"
                    ],
                    "description": "This combines the isolation behavior of 'isolate' with the directional override behavior of 'bidi-override'"
                },
                {
                    "name": "normal",
                    "description": "The element does not open an additional level of embedding with respect to the bidirectional algorithm. For inline-level elements, implicit reordering works across element boundaries."
                },
                {
                    "name": "plaintext",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1.3",
                        "SM1",
                        "C2",
                        "CA18",
                        "IE5.5",
                        "O9.2"
                    ],
                    "description": "For the purposes of the Unicode bidirectional algorithm, the base directionality of each bidi paragraph for which the element forms the containing block is determined not by the element's computed 'direction'."
                }
            ],
            "syntax": "normal | embed | isolate | bidi-override | isolate-override | plaintext",
            "relevance": 56,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/unicode-bidi"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "The level of embedding with respect to the bidirectional algorithm.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "unicode-range",
            "values": [
                {
                    "name": "U+26",
                    "description": "Ampersand."
                },
                {
                    "name": "U+20-24F, U+2B0-2FF, U+370-4FF, U+1E00-1EFF, U+2000-20CF, U+2100-23FF, U+2500-26FF, U+E000-F8FF, U+FB00-FB4F",
                    "description": "WGL4 character set (Pan-European)."
                },
                {
                    "name": "U+20-17F, U+2B0-2FF, U+2000-206F, U+20A0-20CF, U+2100-21FF, U+2600-26FF",
                    "description": "The Multilingual European Subset No. 1. Latin. Covers ~44 languages."
                },
                {
                    "name": "U+20-2FF, U+370-4FF, U+1E00-20CF, U+2100-23FF, U+2500-26FF, U+FB00-FB4F, U+FFF0-FFFD",
                    "description": "The Multilingual European Subset No. 2. Latin, Greek, and Cyrillic. Covers ~128 language."
                },
                {
                    "name": "U+20-4FF, U+530-58F, U+10D0-10FF, U+1E00-23FF, U+2440-245F, U+2500-26FF, U+FB00-FB4F, U+FE20-FE2F, U+FFF0-FFFD",
                    "description": "The Multilingual European Subset No. 3. Covers all characters belonging to European scripts."
                },
                {
                    "name": "U+00-7F",
                    "description": "Basic Latin (ASCII)."
                },
                {
                    "name": "U+80-FF",
                    "description": "Latin-1 Supplement. Accented characters for Western European languages, common punctuation characters, multiplication and division signs."
                },
                {
                    "name": "U+100-17F",
                    "description": "Latin Extended-A. Accented characters for for Czech, Dutch, Polish, and Turkish."
                },
                {
                    "name": "U+180-24F",
                    "description": "Latin Extended-B. Croatian, Slovenian, Romanian, Non-European and historic latin, Khoisan, Pinyin, Livonian, Sinology."
                },
                {
                    "name": "U+1E00-1EFF",
                    "description": "Latin Extended Additional. Vietnamese, German captial sharp s, Medievalist, Latin general use."
                },
                {
                    "name": "U+250-2AF",
                    "description": "International Phonetic Alphabet Extensions."
                },
                {
                    "name": "U+370-3FF",
                    "description": "Greek and Coptic."
                },
                {
                    "name": "U+1F00-1FFF",
                    "description": "Greek Extended. Accented characters for polytonic Greek."
                },
                {
                    "name": "U+400-4FF",
                    "description": "Cyrillic."
                },
                {
                    "name": "U+500-52F",
                    "description": "Cyrillic Supplement. Extra letters for Komi, Khanty, Chukchi, Mordvin, Kurdish, Aleut, Chuvash, Abkhaz, Azerbaijani, and Orok."
                },
                {
                    "name": "U+00-52F, U+1E00-1FFF, U+2200-22FF",
                    "description": "Latin, Greek, Cyrillic, some punctuation and symbols."
                },
                {
                    "name": "U+530-58F",
                    "description": "Armenian."
                },
                {
                    "name": "U+590-5FF",
                    "description": "Hebrew."
                },
                {
                    "name": "U+600-6FF",
                    "description": "Arabic."
                },
                {
                    "name": "U+750-77F",
                    "description": "Arabic Supplement. Additional letters for African languages, Khowar, Torwali, Burushaski, and early Persian."
                },
                {
                    "name": "U+8A0-8FF",
                    "description": "Arabic Extended-A. Additional letters for African languages, European and Central Asian languages, Rohingya, Tamazight, Arwi, and Koranic annotation signs."
                },
                {
                    "name": "U+700-74F",
                    "description": "Syriac."
                },
                {
                    "name": "U+900-97F",
                    "description": "Devanagari."
                },
                {
                    "name": "U+980-9FF",
                    "description": "Bengali."
                },
                {
                    "name": "U+A00-A7F",
                    "description": "Gurmukhi."
                },
                {
                    "name": "U+A80-AFF",
                    "description": "Gujarati."
                },
                {
                    "name": "U+B00-B7F",
                    "description": "Oriya."
                },
                {
                    "name": "U+B80-BFF",
                    "description": "Tamil."
                },
                {
                    "name": "U+C00-C7F",
                    "description": "Telugu."
                },
                {
                    "name": "U+C80-CFF",
                    "description": "Kannada."
                },
                {
                    "name": "U+D00-D7F",
                    "description": "Malayalam."
                },
                {
                    "name": "U+D80-DFF",
                    "description": "Sinhala."
                },
                {
                    "name": "U+118A0-118FF",
                    "description": "Warang Citi."
                },
                {
                    "name": "U+E00-E7F",
                    "description": "Thai."
                },
                {
                    "name": "U+1A20-1AAF",
                    "description": "Tai Tham."
                },
                {
                    "name": "U+AA80-AADF",
                    "description": "Tai Viet."
                },
                {
                    "name": "U+E80-EFF",
                    "description": "Lao."
                },
                {
                    "name": "U+F00-FFF",
                    "description": "Tibetan."
                },
                {
                    "name": "U+1000-109F",
                    "description": "Myanmar (Burmese)."
                },
                {
                    "name": "U+10A0-10FF",
                    "description": "Georgian."
                },
                {
                    "name": "U+1200-137F",
                    "description": "Ethiopic."
                },
                {
                    "name": "U+1380-139F",
                    "description": "Ethiopic Supplement. Extra Syllables for Sebatbeit, and Tonal marks"
                },
                {
                    "name": "U+2D80-2DDF",
                    "description": "Ethiopic Extended. Extra Syllables for Me'en, Blin, and Sebatbeit."
                },
                {
                    "name": "U+AB00-AB2F",
                    "description": "Ethiopic Extended-A. Extra characters for Gamo-Gofa-Dawro, Basketo, and Gumuz."
                },
                {
                    "name": "U+1780-17FF",
                    "description": "Khmer."
                },
                {
                    "name": "U+1800-18AF",
                    "description": "Mongolian."
                },
                {
                    "name": "U+1B80-1BBF",
                    "description": "Sundanese."
                },
                {
                    "name": "U+1CC0-1CCF",
                    "description": "Sundanese Supplement. Punctuation."
                },
                {
                    "name": "U+4E00-9FD5",
                    "description": "CJK (Chinese, Japanese, Korean) Unified Ideographs. Most common ideographs for modern Chinese and Japanese."
                },
                {
                    "name": "U+3400-4DB5",
                    "description": "CJK Unified Ideographs Extension A. Rare ideographs."
                },
                {
                    "name": "U+2F00-2FDF",
                    "description": "Kangxi Radicals."
                },
                {
                    "name": "U+2E80-2EFF",
                    "description": "CJK Radicals Supplement. Alternative forms of Kangxi Radicals."
                },
                {
                    "name": "U+1100-11FF",
                    "description": "Hangul Jamo."
                },
                {
                    "name": "U+AC00-D7AF",
                    "description": "Hangul Syllables."
                },
                {
                    "name": "U+3040-309F",
                    "description": "Hiragana."
                },
                {
                    "name": "U+30A0-30FF",
                    "description": "Katakana."
                },
                {
                    "name": "U+A5, U+4E00-9FFF, U+30??, U+FF00-FF9F",
                    "description": "Japanese Kanji, Hiragana and Katakana characters plus Yen/Yuan symbol."
                },
                {
                    "name": "U+A4D0-A4FF",
                    "description": "Lisu."
                },
                {
                    "name": "U+A000-A48F",
                    "description": "Yi Syllables."
                },
                {
                    "name": "U+A490-A4CF",
                    "description": "Yi Radicals."
                },
                {
                    "name": "U+2000-206F",
                    "description": "General Punctuation."
                },
                {
                    "name": "U+3000-303F",
                    "description": "CJK Symbols and Punctuation."
                },
                {
                    "name": "U+2070-209F",
                    "description": "Superscripts and Subscripts."
                },
                {
                    "name": "U+20A0-20CF",
                    "description": "Currency Symbols."
                },
                {
                    "name": "U+2100-214F",
                    "description": "Letterlike Symbols."
                },
                {
                    "name": "U+2150-218F",
                    "description": "Number Forms."
                },
                {
                    "name": "U+2190-21FF",
                    "description": "Arrows."
                },
                {
                    "name": "U+2200-22FF",
                    "description": "Mathematical Operators."
                },
                {
                    "name": "U+2300-23FF",
                    "description": "Miscellaneous Technical."
                },
                {
                    "name": "U+E000-F8FF",
                    "description": "Private Use Area."
                },
                {
                    "name": "U+FB00-FB4F",
                    "description": "Alphabetic Presentation Forms. Ligatures for latin, Armenian, and Hebrew."
                },
                {
                    "name": "U+FB50-FDFF",
                    "description": "Arabic Presentation Forms-A. Contextual forms / ligatures for Persian, Urdu, Sindhi, Central Asian languages, etc, Arabic pedagogical symbols, word ligatures."
                },
                {
                    "name": "U+1F600-1F64F",
                    "description": "Emoji: Emoticons."
                },
                {
                    "name": "U+2600-26FF",
                    "description": "Emoji: Miscellaneous Symbols."
                },
                {
                    "name": "U+1F300-1F5FF",
                    "description": "Emoji: Miscellaneous Symbols and Pictographs."
                },
                {
                    "name": "U+1F900-1F9FF",
                    "description": "Emoji: Supplemental Symbols and Pictographs."
                },
                {
                    "name": "U+1F680-1F6FF",
                    "description": "Emoji: Transport and Map Symbols."
                }
            ],
            "atRule": "@font-face",
            "syntax": "<unicode-range-token>#",
            "relevance": 72,
            "description": "@font-face descriptor. Defines the set of Unicode codepoints that may be supported by the font face for which it is declared.",
            "restrictions": [
                "unicode-range"
            ]
        },
        {
            "name": "user-select",
            "browsers": [
                "E79",
                "FF69",
                "FFA79",
                "C54",
                "CA54",
                "IE10",
                "O41"
            ],
            "values": [
                {
                    "name": "all",
                    "description": "The content of the element must be selected atomically"
                },
                {
                    "name": "auto"
                },
                {
                    "name": "contain",
                    "description": "UAs must not allow a selection which is started in this element to be extended outside of this element."
                },
                {
                    "name": "none",
                    "description": "The UA must not allow selections to be started in this element."
                },
                {
                    "name": "text",
                    "description": "The element imposes no constraint on the selection."
                }
            ],
            "syntax": "auto | text | none | all",
            "relevance": 82,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/user-select"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Controls the appearance of selection.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "vertical-align",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O4"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Align the dominant baseline of the parent box with the equivalent, or heuristically reconstructed, baseline of the element inline box."
                },
                {
                    "name": "baseline",
                    "description": "Align the 'alphabetic' baseline of the element with the 'alphabetic' baseline of the parent element."
                },
                {
                    "name": "bottom",
                    "description": "Align the after edge of the extended inline box with the after-edge of the line box."
                },
                {
                    "name": "middle",
                    "description": "Align the 'middle' baseline of the inline element with the middle baseline of the parent."
                },
                {
                    "name": "sub",
                    "description": "Lower the baseline of the box to the proper position for subscripts of the parent's box. (This value has no effect on the font size of the element's text.)"
                },
                {
                    "name": "super",
                    "description": "Raise the baseline of the box to the proper position for superscripts of the parent's box. (This value has no effect on the font size of the element's text.)"
                },
                {
                    "name": "text-bottom",
                    "description": "Align the bottom of the box with the after-edge of the parent element's font."
                },
                {
                    "name": "text-top",
                    "description": "Align the top of the box with the before-edge of the parent element's font."
                },
                {
                    "name": "top",
                    "description": "Align the before edge of the extended inline box with the before-edge of the line box."
                },
                {
                    "name": "-webkit-baseline-middle",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O4"
                    ]
                }
            ],
            "syntax": "baseline | sub | super | text-top | text-bottom | middle | top | bottom | <percentage> | <length>",
            "relevance": 90,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/vertical-align"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Affects the vertical positioning of the inline boxes generated by an inline-level element inside a line box.",
            "restrictions": [
                "percentage",
                "length"
            ]
        },
        {
            "name": "visibility",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O4"
            ],
            "values": [
                {
                    "name": "collapse",
                    "description": "Table-specific. If used on elements other than rows, row groups, columns, or column groups, 'collapse' has the same meaning as 'hidden'."
                },
                {
                    "name": "hidden",
                    "description": "The generated box is invisible (fully transparent, nothing is drawn), but still affects layout."
                },
                {
                    "name": "visible",
                    "description": "The generated box is visible."
                }
            ],
            "syntax": "visible | hidden | collapse",
            "relevance": 87,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/visibility"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies whether the boxes generated by an element are rendered. Invisible boxes still affect layout (set the 'display' property to 'none' to suppress box generation altogether).",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-animation",
            "browsers": [
                "C",
                "S5"
            ],
            "values": [
                {
                    "name": "alternate",
                    "description": "The animation cycle iterations that are odd counts are played in the normal direction, and the animation cycle iterations that are even counts are played in a reverse direction."
                },
                {
                    "name": "alternate-reverse",
                    "description": "The animation cycle iterations that are odd counts are played in the reverse direction, and the animation cycle iterations that are even counts are played in a normal direction."
                },
                {
                    "name": "backwards",
                    "description": "The beginning property value (as defined in the first @keyframes at-rule) is applied before the animation is displayed, during the period defined by 'animation-delay'."
                },
                {
                    "name": "both",
                    "description": "Both forwards and backwards fill modes are applied."
                },
                {
                    "name": "forwards",
                    "description": "The final property value (as defined in the last @keyframes at-rule) is maintained after the animation completes."
                },
                {
                    "name": "infinite",
                    "description": "Causes the animation to repeat forever."
                },
                {
                    "name": "none",
                    "description": "No animation is performed"
                },
                {
                    "name": "normal",
                    "description": "Normal playback."
                },
                {
                    "name": "reverse",
                    "description": "All iterations of the animation are played in the reverse direction from the way they were specified."
                }
            ],
            "relevance": 50,
            "description": "Shorthand property combines six of the animation properties into a single property.",
            "restrictions": [
                "time",
                "enum",
                "timing-function",
                "identifier",
                "number"
            ]
        },
        {
            "name": "-webkit-animation-delay",
            "browsers": [
                "C",
                "S5"
            ],
            "relevance": 50,
            "description": "Defines when the animation will start.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "-webkit-animation-direction",
            "browsers": [
                "C",
                "S5"
            ],
            "values": [
                {
                    "name": "alternate",
                    "description": "The animation cycle iterations that are odd counts are played in the normal direction, and the animation cycle iterations that are even counts are played in a reverse direction."
                },
                {
                    "name": "alternate-reverse",
                    "description": "The animation cycle iterations that are odd counts are played in the reverse direction, and the animation cycle iterations that are even counts are played in a normal direction."
                },
                {
                    "name": "normal",
                    "description": "Normal playback."
                },
                {
                    "name": "reverse",
                    "description": "All iterations of the animation are played in the reverse direction from the way they were specified."
                }
            ],
            "relevance": 50,
            "description": "Defines whether or not the animation should play in reverse on alternate cycles.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-animation-duration",
            "browsers": [
                "C",
                "S5"
            ],
            "relevance": 50,
            "description": "Defines the length of time that an animation takes to complete one cycle.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "-webkit-animation-fill-mode",
            "browsers": [
                "C",
                "S5"
            ],
            "values": [
                {
                    "name": "backwards",
                    "description": "The beginning property value (as defined in the first @keyframes at-rule) is applied before the animation is displayed, during the period defined by 'animation-delay'."
                },
                {
                    "name": "both",
                    "description": "Both forwards and backwards fill modes are applied."
                },
                {
                    "name": "forwards",
                    "description": "The final property value (as defined in the last @keyframes at-rule) is maintained after the animation completes."
                },
                {
                    "name": "none",
                    "description": "There is no change to the property value between the time the animation is applied and the time the animation begins playing or after the animation completes."
                }
            ],
            "relevance": 50,
            "description": "Defines what values are applied by the animation outside the time it is executing.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-animation-iteration-count",
            "browsers": [
                "C",
                "S5"
            ],
            "values": [
                {
                    "name": "infinite",
                    "description": "Causes the animation to repeat forever."
                }
            ],
            "relevance": 50,
            "description": "Defines the number of times an animation cycle is played. The default value is one, meaning the animation will play from beginning to end once.",
            "restrictions": [
                "number",
                "enum"
            ]
        },
        {
            "name": "-webkit-animation-name",
            "browsers": [
                "C",
                "S5"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No animation is performed"
                }
            ],
            "relevance": 50,
            "description": "Defines a list of animations that apply. Each name is used to select the keyframe at-rule that provides the property values for the animation.",
            "restrictions": [
                "identifier",
                "enum"
            ]
        },
        {
            "name": "-webkit-animation-play-state",
            "browsers": [
                "C",
                "S5"
            ],
            "values": [
                {
                    "name": "paused",
                    "description": "A running animation will be paused."
                },
                {
                    "name": "running",
                    "description": "Resume playback of a paused animation."
                }
            ],
            "relevance": 50,
            "description": "Defines whether the animation is running or paused.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-animation-timing-function",
            "browsers": [
                "C",
                "S5"
            ],
            "relevance": 50,
            "description": "Describes how the animation will progress over one cycle of its duration. See the 'transition-timing-function'.",
            "restrictions": [
                "timing-function"
            ]
        },
        {
            "name": "-webkit-appearance",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "button"
                },
                {
                    "name": "button-bevel"
                },
                {
                    "name": "caps-lock-indicator"
                },
                {
                    "name": "caret"
                },
                {
                    "name": "checkbox"
                },
                {
                    "name": "default-button"
                },
                {
                    "name": "listbox"
                },
                {
                    "name": "listitem"
                },
                {
                    "name": "media-fullscreen-button"
                },
                {
                    "name": "media-mute-button"
                },
                {
                    "name": "media-play-button"
                },
                {
                    "name": "media-seek-back-button"
                },
                {
                    "name": "media-seek-forward-button"
                },
                {
                    "name": "media-slider"
                },
                {
                    "name": "media-sliderthumb"
                },
                {
                    "name": "menulist"
                },
                {
                    "name": "menulist-button"
                },
                {
                    "name": "menulist-text"
                },
                {
                    "name": "menulist-textfield"
                },
                {
                    "name": "none"
                },
                {
                    "name": "push-button"
                },
                {
                    "name": "radio"
                },
                {
                    "name": "scrollbarbutton-down"
                },
                {
                    "name": "scrollbarbutton-left"
                },
                {
                    "name": "scrollbarbutton-right"
                },
                {
                    "name": "scrollbarbutton-up"
                },
                {
                    "name": "scrollbargripper-horizontal"
                },
                {
                    "name": "scrollbargripper-vertical"
                },
                {
                    "name": "scrollbarthumb-horizontal"
                },
                {
                    "name": "scrollbarthumb-vertical"
                },
                {
                    "name": "scrollbartrack-horizontal"
                },
                {
                    "name": "scrollbartrack-vertical"
                },
                {
                    "name": "searchfield"
                },
                {
                    "name": "searchfield-cancel-button"
                },
                {
                    "name": "searchfield-decoration"
                },
                {
                    "name": "searchfield-results-button"
                },
                {
                    "name": "searchfield-results-decoration"
                },
                {
                    "name": "slider-horizontal"
                },
                {
                    "name": "sliderthumb-horizontal"
                },
                {
                    "name": "sliderthumb-vertical"
                },
                {
                    "name": "slider-vertical"
                },
                {
                    "name": "square-button"
                },
                {
                    "name": "textarea"
                },
                {
                    "name": "textfield"
                }
            ],
            "status": "nonstandard",
            "syntax": "none | button | button-bevel | caret | checkbox | default-button | inner-spin-button | listbox | listitem | media-controls-background | media-controls-fullscreen-background | media-current-time-display | media-enter-fullscreen-button | media-exit-fullscreen-button | media-fullscreen-button | media-mute-button | media-overlay-play-button | media-play-button | media-seek-back-button | media-seek-forward-button | media-slider | media-sliderthumb | media-time-remaining-display | media-toggle-closed-captions-button | media-volume-slider | media-volume-slider-container | media-volume-sliderthumb | menulist | menulist-button | menulist-text | menulist-textfield | meter | progress-bar | progress-bar-value | push-button | radio | searchfield | searchfield-cancel-button | searchfield-decoration | searchfield-results-button | searchfield-results-decoration | slider-horizontal | slider-vertical | sliderthumb-horizontal | sliderthumb-vertical | square-button | textarea | textfield | -apple-pay-button",
            "relevance": 0,
            "description": "Changes the appearance of buttons and other controls to resemble native controls.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-backdrop-filter",
            "browsers": [
                "S9"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No filter effects are applied."
                },
                {
                    "name": "blur()",
                    "description": "Applies a Gaussian blur to the input image."
                },
                {
                    "name": "brightness()",
                    "description": "Applies a linear multiplier to input image, making it appear more or less bright."
                },
                {
                    "name": "contrast()",
                    "description": "Adjusts the contrast of the input."
                },
                {
                    "name": "drop-shadow()",
                    "description": "Applies a drop shadow effect to the input image."
                },
                {
                    "name": "grayscale()",
                    "description": "Converts the input image to grayscale."
                },
                {
                    "name": "hue-rotate()",
                    "description": "Applies a hue rotation on the input image. "
                },
                {
                    "name": "invert()",
                    "description": "Inverts the samples in the input image."
                },
                {
                    "name": "opacity()",
                    "description": "Applies transparency to the samples in the input image."
                },
                {
                    "name": "saturate()",
                    "description": "Saturates the input image."
                },
                {
                    "name": "sepia()",
                    "description": "Converts the input image to sepia."
                },
                {
                    "name": "url()",
                    "description": "A filter reference to a <filter> element."
                }
            ],
            "relevance": 50,
            "description": "Applies a filter effect where the first filter in the list takes the element's background image as the input image.",
            "restrictions": [
                "enum",
                "url"
            ]
        },
        {
            "name": "-webkit-backface-visibility",
            "browsers": [
                "C",
                "S5"
            ],
            "values": [
                {
                    "name": "hidden"
                },
                {
                    "name": "visible"
                }
            ],
            "relevance": 50,
            "description": "Determines whether or not the 'back' side of a transformed element is visible when facing the viewer. With an identity transform, the front side of an element faces the viewer.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-background-clip",
            "browsers": [
                "C",
                "S3"
            ],
            "relevance": 50,
            "description": "Determines the background painting area.",
            "restrictions": [
                "box"
            ]
        },
        {
            "name": "-webkit-background-composite",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "border"
                },
                {
                    "name": "padding"
                }
            ],
            "relevance": 50,
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-background-origin",
            "browsers": [
                "C",
                "S3"
            ],
            "relevance": 50,
            "description": "For elements rendered as a single box, specifies the background positioning area. For elements rendered as multiple boxes (e.g., inline boxes on several lines, boxes on several pages) specifies which boxes 'box-decoration-break' operates on to determine the background positioning area(s).",
            "restrictions": [
                "box"
            ]
        },
        {
            "name": "-webkit-border-image",
            "browsers": [
                "C",
                "S5"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "If 'auto' is specified then the border image width is the intrinsic width or height (whichever is applicable) of the corresponding image slice. If the image does not have the required intrinsic dimension then the corresponding border-width is used instead."
                },
                {
                    "name": "fill",
                    "description": "Causes the middle part of the border-image to be preserved."
                },
                {
                    "name": "none"
                },
                {
                    "name": "repeat",
                    "description": "The image is tiled (repeated) to fill the area."
                },
                {
                    "name": "round",
                    "description": "The image is tiled (repeated) to fill the area. If it does not fill the area with a whole number of tiles, the image is rescaled so that it does."
                },
                {
                    "name": "space",
                    "description": "The image is tiled (repeated) to fill the area. If it does not fill the area with a whole number of tiles, the extra space is distributed around the tiles."
                },
                {
                    "name": "stretch",
                    "description": "The image is stretched to fill the area."
                },
                {
                    "name": "url()"
                }
            ],
            "relevance": 50,
            "description": "Shorthand property for setting 'border-image-source', 'border-image-slice', 'border-image-width', 'border-image-outset' and 'border-image-repeat'. Omitted values are set to their initial values.",
            "restrictions": [
                "length",
                "percentage",
                "number",
                "url",
                "enum"
            ]
        },
        {
            "name": "-webkit-box-align",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "baseline",
                    "description": "If this box orientation is inline-axis or horizontal, all children are placed with their baselines aligned, and extra space placed before or after as necessary. For block flows, the baseline of the first non-empty line box located within the element is used. For tables, the baseline of the first cell is used."
                },
                {
                    "name": "center",
                    "description": "Any extra space is divided evenly, with half placed above the child and the other half placed after the child."
                },
                {
                    "name": "end",
                    "description": "For normal direction boxes, the bottom edge of each child is placed along the bottom of the box. Extra space is placed above the element. For reverse direction boxes, the top edge of each child is placed along the top of the box. Extra space is placed below the element."
                },
                {
                    "name": "start",
                    "description": "For normal direction boxes, the top edge of each child is placed along the top of the box. Extra space is placed below the element. For reverse direction boxes, the bottom edge of each child is placed along the bottom of the box. Extra space is placed above the element."
                },
                {
                    "name": "stretch",
                    "description": "The height of each child is adjusted to that of the containing block."
                }
            ],
            "relevance": 50,
            "description": "Specifies the alignment of nested elements within an outer flexible box element.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-box-direction",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "normal",
                    "description": "A box with a computed value of horizontal for box-orient displays its children from left to right. A box with a computed value of vertical displays its children from top to bottom."
                },
                {
                    "name": "reverse",
                    "description": "A box with a computed value of horizontal for box-orient displays its children from right to left. A box with a computed value of vertical displays its children from bottom to top."
                }
            ],
            "relevance": 50,
            "description": "In webkit applications, -webkit-box-direction specifies whether a box lays out its contents normally (from the top or left edge), or in reverse (from the bottom or right edge).",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-box-flex",
            "browsers": [
                "C",
                "S3"
            ],
            "relevance": 50,
            "description": "Specifies an element's flexibility.",
            "restrictions": [
                "number"
            ]
        },
        {
            "name": "-webkit-box-flex-group",
            "browsers": [
                "C",
                "S3"
            ],
            "relevance": 50,
            "description": "Flexible elements can be assigned to flex groups using the 'box-flex-group' property.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "-webkit-box-ordinal-group",
            "browsers": [
                "C",
                "S3"
            ],
            "relevance": 50,
            "description": "Indicates the ordinal group the element belongs to. Elements with a lower ordinal group are displayed before those with a higher ordinal group.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "-webkit-box-orient",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "block-axis",
                    "description": "Elements are oriented along the box's axis."
                },
                {
                    "name": "horizontal",
                    "description": "The box displays its children from left to right in a horizontal line."
                },
                {
                    "name": "inline-axis",
                    "description": "Elements are oriented vertically."
                },
                {
                    "name": "vertical",
                    "description": "The box displays its children from stacked from top to bottom vertically."
                }
            ],
            "relevance": 50,
            "description": "In webkit applications, -webkit-box-orient specifies whether a box lays out its contents horizontally or vertically.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-box-pack",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "center",
                    "description": "The extra space is divided evenly, with half placed before the first child and the other half placed after the last child."
                },
                {
                    "name": "end",
                    "description": "For normal direction boxes, the right edge of the last child is placed at the right side, with all extra space placed before the first child. For reverse direction boxes, the left edge of the first child is placed at the left side, with all extra space placed after the last child."
                },
                {
                    "name": "justify",
                    "description": "The space is divided evenly in-between each child, with none of the extra space placed before the first child or after the last child. If there is only one child, treat the pack value as if it were start."
                },
                {
                    "name": "start",
                    "description": "For normal direction boxes, the left edge of the first child is placed at the left side, with all extra space placed after the last child. For reverse direction boxes, the right edge of the last child is placed at the right side, with all extra space placed before the first child."
                }
            ],
            "relevance": 50,
            "description": "Specifies alignment of child elements within the current element in the direction of orientation.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-box-reflect",
            "browsers": [
                "E79",
                "S4",
                "SM3.2",
                "C4",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "above",
                    "description": "The reflection appears above the border box."
                },
                {
                    "name": "below",
                    "description": "The reflection appears below the border box."
                },
                {
                    "name": "left",
                    "description": "The reflection appears to the left of the border box."
                },
                {
                    "name": "right",
                    "description": "The reflection appears to the right of the border box."
                }
            ],
            "status": "nonstandard",
            "syntax": "[ above | below | right | left ]? <length>? <image>?",
            "relevance": 0,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-webkit-box-reflect"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Defines a reflection of a border box."
        },
        {
            "name": "-webkit-box-sizing",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "border-box",
                    "description": "The specified width and height (and respective min/max properties) on this element determine the border box of the element."
                },
                {
                    "name": "content-box",
                    "description": "Behavior of width and height as specified by CSS2.1. The specified width and height (and respective min/max properties) apply to the width and height respectively of the content box of the element."
                }
            ],
            "relevance": 50,
            "description": "Box Model addition in CSS3.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-break-after",
            "browsers": [
                "S7"
            ],
            "values": [
                {
                    "name": "always",
                    "description": "Always force a page break before/after the generated box."
                },
                {
                    "name": "auto",
                    "description": "Neither force nor forbid a page/column break before/after the generated box."
                },
                {
                    "name": "avoid",
                    "description": "Avoid a page/column break before/after the generated box."
                },
                {
                    "name": "avoid-column",
                    "description": "Avoid a column break before/after the generated box."
                },
                {
                    "name": "avoid-page",
                    "description": "Avoid a page break before/after the generated box."
                },
                {
                    "name": "avoid-region"
                },
                {
                    "name": "column",
                    "description": "Always force a column break before/after the generated box."
                },
                {
                    "name": "left",
                    "description": "Force one or two page breaks before/after the generated box so that the next page is formatted as a left page."
                },
                {
                    "name": "page",
                    "description": "Always force a page break before/after the generated box."
                },
                {
                    "name": "region"
                },
                {
                    "name": "right",
                    "description": "Force one or two page breaks before/after the generated box so that the next page is formatted as a right page."
                }
            ],
            "relevance": 50,
            "description": "Describes the page/column break behavior before the generated box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-break-before",
            "browsers": [
                "S7"
            ],
            "values": [
                {
                    "name": "always",
                    "description": "Always force a page break before/after the generated box."
                },
                {
                    "name": "auto",
                    "description": "Neither force nor forbid a page/column break before/after the generated box."
                },
                {
                    "name": "avoid",
                    "description": "Avoid a page/column break before/after the generated box."
                },
                {
                    "name": "avoid-column",
                    "description": "Avoid a column break before/after the generated box."
                },
                {
                    "name": "avoid-page",
                    "description": "Avoid a page break before/after the generated box."
                },
                {
                    "name": "avoid-region"
                },
                {
                    "name": "column",
                    "description": "Always force a column break before/after the generated box."
                },
                {
                    "name": "left",
                    "description": "Force one or two page breaks before/after the generated box so that the next page is formatted as a left page."
                },
                {
                    "name": "page",
                    "description": "Always force a page break before/after the generated box."
                },
                {
                    "name": "region"
                },
                {
                    "name": "right",
                    "description": "Force one or two page breaks before/after the generated box so that the next page is formatted as a right page."
                }
            ],
            "relevance": 50,
            "description": "Describes the page/column break behavior before the generated box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-break-inside",
            "browsers": [
                "S7"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Neither force nor forbid a page/column break inside the generated box."
                },
                {
                    "name": "avoid",
                    "description": "Avoid a page/column break inside the generated box."
                },
                {
                    "name": "avoid-column",
                    "description": "Avoid a column break inside the generated box."
                },
                {
                    "name": "avoid-page",
                    "description": "Avoid a page break inside the generated box."
                },
                {
                    "name": "avoid-region"
                }
            ],
            "relevance": 50,
            "description": "Describes the page/column break behavior inside the generated box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-column-break-after",
            "browsers": [
                "E79",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "always",
                    "description": "Always force a page break before/after the generated box."
                },
                {
                    "name": "auto",
                    "description": "Neither force nor forbid a page/column break before/after the generated box."
                },
                {
                    "name": "avoid",
                    "description": "Avoid a page/column break before/after the generated box."
                },
                {
                    "name": "avoid-column",
                    "description": "Avoid a column break before/after the generated box."
                },
                {
                    "name": "avoid-page",
                    "description": "Avoid a page break before/after the generated box."
                },
                {
                    "name": "avoid-region"
                },
                {
                    "name": "column",
                    "description": "Always force a column break before/after the generated box."
                },
                {
                    "name": "left",
                    "description": "Force one or two page breaks before/after the generated box so that the next page is formatted as a left page."
                },
                {
                    "name": "page",
                    "description": "Always force a page break before/after the generated box."
                },
                {
                    "name": "region"
                },
                {
                    "name": "right",
                    "description": "Force one or two page breaks before/after the generated box so that the next page is formatted as a right page."
                }
            ],
            "relevance": 50,
            "baseline": {
                "status": "false"
            },
            "description": "Describes the page/column break behavior before the generated box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-column-break-before",
            "browsers": [
                "E79",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "always",
                    "description": "Always force a page break before/after the generated box."
                },
                {
                    "name": "auto",
                    "description": "Neither force nor forbid a page/column break before/after the generated box."
                },
                {
                    "name": "avoid",
                    "description": "Avoid a page/column break before/after the generated box."
                },
                {
                    "name": "avoid-column",
                    "description": "Avoid a column break before/after the generated box."
                },
                {
                    "name": "avoid-page",
                    "description": "Avoid a page break before/after the generated box."
                },
                {
                    "name": "avoid-region"
                },
                {
                    "name": "column",
                    "description": "Always force a column break before/after the generated box."
                },
                {
                    "name": "left",
                    "description": "Force one or two page breaks before/after the generated box so that the next page is formatted as a left page."
                },
                {
                    "name": "page",
                    "description": "Always force a page break before/after the generated box."
                },
                {
                    "name": "region"
                },
                {
                    "name": "right",
                    "description": "Force one or two page breaks before/after the generated box so that the next page is formatted as a right page."
                }
            ],
            "relevance": 50,
            "baseline": {
                "status": "false"
            },
            "description": "Describes the page/column break behavior before the generated box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-column-break-inside",
            "browsers": [
                "E79",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Neither force nor forbid a page/column break inside the generated box."
                },
                {
                    "name": "avoid",
                    "description": "Avoid a page/column break inside the generated box."
                },
                {
                    "name": "avoid-column",
                    "description": "Avoid a column break inside the generated box."
                },
                {
                    "name": "avoid-page",
                    "description": "Avoid a page break inside the generated box."
                },
                {
                    "name": "avoid-region"
                }
            ],
            "relevance": 50,
            "baseline": {
                "status": "false"
            },
            "description": "Describes the page/column break behavior inside the generated box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-column-count",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Determines the number of columns by the 'column-width' property and the element width."
                }
            ],
            "relevance": 50,
            "description": "Describes the optimal number of columns into which the content of the element will be flowed.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "-webkit-column-gap",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "normal",
                    "description": "User agent specific and typically equivalent to 1em."
                }
            ],
            "relevance": 50,
            "description": "Sets the gap between columns. If there is a column rule between columns, it will appear in the middle of the gap.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "-webkit-column-rule",
            "browsers": [
                "C",
                "S3"
            ],
            "relevance": 50,
            "description": "This property is a shorthand for setting 'column-rule-width', 'column-rule-style', and 'column-rule-color' at the same place in the style sheet. Omitted values are set to their initial values.",
            "restrictions": [
                "length",
                "line-width",
                "line-style",
                "color"
            ]
        },
        {
            "name": "-webkit-column-rule-color",
            "browsers": [
                "C",
                "S3"
            ],
            "relevance": 50,
            "description": "Sets the color of the column rule",
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-webkit-column-rule-style",
            "browsers": [
                "C",
                "S3"
            ],
            "relevance": 50,
            "description": "Sets the style of the rule between columns of an element.",
            "restrictions": [
                "line-style"
            ]
        },
        {
            "name": "-webkit-column-rule-width",
            "browsers": [
                "C",
                "S3"
            ],
            "relevance": 50,
            "description": "Sets the width of the rule between columns. Negative values are not allowed.",
            "restrictions": [
                "length",
                "line-width"
            ]
        },
        {
            "name": "-webkit-columns",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The width depends on the values of other properties."
                }
            ],
            "relevance": 50,
            "description": "A shorthand property which sets both 'column-width' and 'column-count'.",
            "restrictions": [
                "length",
                "integer"
            ]
        },
        {
            "name": "-webkit-column-span",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "all",
                    "description": "The element spans across all columns. Content in the normal flow that appears before the element is automatically balanced across all columns before the element appear."
                },
                {
                    "name": "none",
                    "description": "The element does not span multiple columns."
                }
            ],
            "relevance": 50,
            "description": "Describes the page/column break behavior after the generated box.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-column-width",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The width depends on the values of other properties."
                }
            ],
            "relevance": 50,
            "description": "This property describes the width of columns in multicol elements.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "-webkit-filter",
            "browsers": [
                "C18",
                "O15",
                "S6"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No filter effects are applied."
                },
                {
                    "name": "blur()",
                    "description": "Applies a Gaussian blur to the input image."
                },
                {
                    "name": "brightness()",
                    "description": "Applies a linear multiplier to input image, making it appear more or less bright."
                },
                {
                    "name": "contrast()",
                    "description": "Adjusts the contrast of the input."
                },
                {
                    "name": "drop-shadow()",
                    "description": "Applies a drop shadow effect to the input image."
                },
                {
                    "name": "grayscale()",
                    "description": "Converts the input image to grayscale."
                },
                {
                    "name": "hue-rotate()",
                    "description": "Applies a hue rotation on the input image. "
                },
                {
                    "name": "invert()",
                    "description": "Inverts the samples in the input image."
                },
                {
                    "name": "opacity()",
                    "description": "Applies transparency to the samples in the input image."
                },
                {
                    "name": "saturate()",
                    "description": "Saturates the input image."
                },
                {
                    "name": "sepia()",
                    "description": "Converts the input image to sepia."
                },
                {
                    "name": "url()",
                    "description": "A filter reference to a <filter> element."
                }
            ],
            "relevance": 50,
            "description": "Processes an element's rendering before it is displayed in the document, by applying one or more filter effects.",
            "restrictions": [
                "enum",
                "url"
            ]
        },
        {
            "name": "-webkit-flow-from",
            "browsers": [
                "S6.1"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "The block container is not a CSS Region."
                }
            ],
            "relevance": 50,
            "description": "Makes a block container a region and associates it with a named flow.",
            "restrictions": [
                "identifier"
            ]
        },
        {
            "name": "-webkit-flow-into",
            "browsers": [
                "S6.1"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "The element is not moved to a named flow and normal CSS processing takes place."
                }
            ],
            "relevance": 50,
            "description": "Places an element or its contents into a named flow.",
            "restrictions": [
                "identifier"
            ]
        },
        {
            "name": "-webkit-font-feature-settings",
            "browsers": [
                "C16"
            ],
            "values": [
                {
                    "name": "\"c2cs\""
                },
                {
                    "name": "\"dlig\""
                },
                {
                    "name": "\"kern\""
                },
                {
                    "name": "\"liga\""
                },
                {
                    "name": "\"lnum\""
                },
                {
                    "name": "\"onum\""
                },
                {
                    "name": "\"smcp\""
                },
                {
                    "name": "\"swsh\""
                },
                {
                    "name": "\"tnum\""
                },
                {
                    "name": "normal",
                    "description": "No change in glyph substitution or positioning occurs."
                },
                {
                    "name": "off"
                },
                {
                    "name": "on"
                }
            ],
            "relevance": 50,
            "description": "This property provides low-level control over OpenType font features. It is intended as a way of providing access to font features that are not widely used but are needed for a particular use case.",
            "restrictions": [
                "string",
                "integer"
            ]
        },
        {
            "name": "-webkit-hyphens",
            "browsers": [
                "S5.1"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Conditional hyphenation characters inside a word, if present, take priority over automatic resources when determining hyphenation points within the word."
                },
                {
                    "name": "manual",
                    "description": "Words are only broken at line breaks where there are characters inside the word that suggest line break opportunities"
                },
                {
                    "name": "none",
                    "description": "Words are not broken at line breaks, even if characters inside the word suggest line break points."
                }
            ],
            "relevance": 50,
            "description": "Controls whether hyphenation is allowed to create more break opportunities within a line of text.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-line-break",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "after-white-space"
                },
                {
                    "name": "normal"
                }
            ],
            "relevance": 50,
            "description": "Specifies line-breaking rules for CJK (Chinese, Japanese, and Korean) text."
        },
        {
            "name": "-webkit-margin-bottom-collapse",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "collapse"
                },
                {
                    "name": "discard"
                },
                {
                    "name": "separate"
                }
            ],
            "relevance": 50,
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-margin-collapse",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "collapse"
                },
                {
                    "name": "discard"
                },
                {
                    "name": "separate"
                }
            ],
            "relevance": 50,
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-margin-start",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "auto"
                }
            ],
            "relevance": 50,
            "restrictions": [
                "percentage",
                "length"
            ]
        },
        {
            "name": "-webkit-margin-top-collapse",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "collapse"
                },
                {
                    "name": "discard"
                },
                {
                    "name": "separate"
                }
            ],
            "relevance": 50,
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-mask-clip",
            "browsers": [
                "C",
                "O15",
                "S4"
            ],
            "status": "nonstandard",
            "syntax": "[ <coord-box> | no-clip | border | padding | content | text ]#",
            "relevance": 0,
            "description": "Determines the mask painting area, which determines the area that is affected by the mask.",
            "restrictions": [
                "box"
            ]
        },
        {
            "name": "-webkit-mask-image",
            "browsers": [
                "C",
                "O15",
                "S4"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "Counts as a transparent black image layer."
                },
                {
                    "name": "url()",
                    "description": "Reference to a <mask element or to a CSS image."
                }
            ],
            "status": "nonstandard",
            "syntax": "<mask-reference>#",
            "relevance": 0,
            "description": "Sets the mask layer image of an element.",
            "restrictions": [
                "url",
                "image",
                "enum"
            ]
        },
        {
            "name": "-webkit-mask-origin",
            "browsers": [
                "C",
                "O15",
                "S4"
            ],
            "status": "nonstandard",
            "syntax": "[ <coord-box> | border | padding | content ]#",
            "relevance": 0,
            "description": "Specifies the mask positioning area.",
            "restrictions": [
                "box"
            ]
        },
        {
            "name": "-webkit-mask-repeat",
            "browsers": [
                "C",
                "O15",
                "S4"
            ],
            "status": "nonstandard",
            "syntax": "<repeat-style>#",
            "relevance": 0,
            "description": "Specifies how mask layer images are tiled after they have been sized and positioned.",
            "restrictions": [
                "repeat"
            ]
        },
        {
            "name": "-webkit-mask-size",
            "browsers": [
                "C",
                "O15",
                "S4"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Resolved by using the image's intrinsic ratio and the size of the other dimension, or failing that, using the image's intrinsic size, or failing that, treating it as 100%."
                },
                {
                    "name": "contain",
                    "description": "Scale the image, while preserving its intrinsic aspect ratio (if any), to the largest size such that both its width and its height can fit inside the background positioning area."
                },
                {
                    "name": "cover",
                    "description": "Scale the image, while preserving its intrinsic aspect ratio (if any), to the smallest size such that both its width and its height can completely cover the background positioning area."
                }
            ],
            "status": "nonstandard",
            "syntax": "<bg-size>#",
            "relevance": 0,
            "description": "Specifies the size of the mask layer images.",
            "restrictions": [
                "length",
                "percentage",
                "enum"
            ]
        },
        {
            "name": "-webkit-nbsp-mode",
            "browsers": [
                "S4",
                "SM3.2"
            ],
            "values": [
                {
                    "name": "normal"
                },
                {
                    "name": "space"
                }
            ],
            "relevance": 50,
            "baseline": {
                "status": "false"
            },
            "description": "Defines the behavior of nonbreaking spaces within text."
        },
        {
            "name": "-webkit-overflow-scrolling",
            "browsers": [
                "C",
                "S5"
            ],
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "touch"
                }
            ],
            "status": "nonstandard",
            "syntax": "auto | touch",
            "relevance": 0,
            "description": "Specifies whether to use native-style scrolling in an overflow:scroll element."
        },
        {
            "name": "-webkit-padding-start",
            "browsers": [
                "C",
                "S3"
            ],
            "relevance": 50,
            "restrictions": [
                "percentage",
                "length"
            ]
        },
        {
            "name": "-webkit-perspective",
            "browsers": [
                "C",
                "S4"
            ],
            "values": [
                {
                    "name": "none",
                    "description": "No perspective transform is applied."
                }
            ],
            "relevance": 50,
            "description": "Applies the same transform as the perspective(<number>) transform function, except that it applies only to the positioned or transformed children of the element, not to the transform on the element itself.",
            "restrictions": [
                "length"
            ]
        },
        {
            "name": "-webkit-perspective-origin",
            "browsers": [
                "C",
                "S4"
            ],
            "relevance": 50,
            "description": "Establishes the origin for the perspective property. It effectively sets the X and Y position at which the viewer appears to be looking at the children of the element.",
            "restrictions": [
                "position",
                "percentage",
                "length"
            ]
        },
        {
            "name": "-webkit-region-fragment",
            "browsers": [
                "S7"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Content flows as it would in a regular content box."
                },
                {
                    "name": "break",
                    "description": "If the content fits within the CSS Region, then this property has no effect."
                }
            ],
            "relevance": 50,
            "description": "The 'region-fragment' property controls the behavior of the last region associated with a named flow.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-tap-highlight-color",
            "browsers": [
                "E12",
                "SM4",
                "C16",
                "CA18",
                "O15"
            ],
            "status": "nonstandard",
            "syntax": "<color>",
            "relevance": 0,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-webkit-tap-highlight-color"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-webkit-text-fill-color",
            "browsers": [
                "E12",
                "FF49",
                "FFA49",
                "S3",
                "SM2",
                "C1",
                "CA18",
                "O15"
            ],
            "syntax": "<color>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-webkit-text-fill-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2016-09-20",
                "baseline_high_date": "2019-03-20"
            },
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-webkit-text-size-adjust",
            "browsers": [
                "E",
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Renderers must use the default size adjustment when displaying on a small device."
                },
                {
                    "name": "none",
                    "description": "Renderers must not do size adjustment when displaying on a small device."
                }
            ],
            "relevance": 50,
            "description": "Specifies a size adjustment for displaying text content in mobile browsers.",
            "restrictions": [
                "percentage"
            ]
        },
        {
            "name": "-webkit-text-stroke",
            "browsers": [
                "E15",
                "FF49",
                "FFA49",
                "S3",
                "SM2",
                "C4",
                "CA18",
                "O15"
            ],
            "syntax": "<length> || <color>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-webkit-text-stroke"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "restrictions": [
                "length",
                "line-width",
                "color",
                "percentage"
            ]
        },
        {
            "name": "-webkit-text-stroke-color",
            "browsers": [
                "E15",
                "FF49",
                "FFA49",
                "S3",
                "SM2",
                "C1",
                "CA18",
                "O15"
            ],
            "syntax": "<color>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-webkit-text-stroke-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "restrictions": [
                "color"
            ]
        },
        {
            "name": "-webkit-text-stroke-width",
            "browsers": [
                "E15",
                "FF49",
                "FFA49",
                "S3",
                "SM2",
                "C1",
                "CA18",
                "O15"
            ],
            "syntax": "<length>",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-webkit-text-stroke-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-04-05",
                "baseline_high_date": "2019-10-05"
            },
            "restrictions": [
                "length",
                "line-width",
                "percentage"
            ]
        },
        {
            "name": "-webkit-touch-callout",
            "browsers": [
                "SM2"
            ],
            "values": [
                {
                    "name": "none"
                }
            ],
            "status": "nonstandard",
            "syntax": "default | none",
            "relevance": 0,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-webkit-touch-callout"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-transform",
            "browsers": [
                "C",
                "O12",
                "S3.1"
            ],
            "values": [
                {
                    "name": "matrix()",
                    "description": "Specifies a 2D transformation in the form of a transformation matrix of six values. matrix(a,b,c,d,e,f) is equivalent to applying the transformation matrix [a b c d e f]"
                },
                {
                    "name": "matrix3d()",
                    "description": "Specifies a 3D transformation as a 4x4 homogeneous matrix of 16 values in column-major order."
                },
                {
                    "name": "none"
                },
                {
                    "name": "perspective()",
                    "description": "Specifies a perspective projection matrix."
                },
                {
                    "name": "rotate()",
                    "description": "Specifies a 2D rotation by the angle specified in the parameter about the origin of the element, as defined by the transform-origin property."
                },
                {
                    "name": "rotate3d()",
                    "description": "Specifies a clockwise 3D rotation by the angle specified in last parameter about the [x,y,z] direction vector described by the first 3 parameters."
                },
                {
                    "name": "rotateX('angle')",
                    "description": "Specifies a clockwise rotation by the given angle about the X axis."
                },
                {
                    "name": "rotateY('angle')",
                    "description": "Specifies a clockwise rotation by the given angle about the Y axis."
                },
                {
                    "name": "rotateZ('angle')",
                    "description": "Specifies a clockwise rotation by the given angle about the Z axis."
                },
                {
                    "name": "scale()",
                    "description": "Specifies a 2D scale operation by the [sx,sy] scaling vector described by the 2 parameters. If the second parameter is not provided, it is takes a value equal to the first."
                },
                {
                    "name": "scale3d()",
                    "description": "Specifies a 3D scale operation by the [sx,sy,sz] scaling vector described by the 3 parameters."
                },
                {
                    "name": "scaleX()",
                    "description": "Specifies a scale operation using the [sx,1] scaling vector, where sx is given as the parameter."
                },
                {
                    "name": "scaleY()",
                    "description": "Specifies a scale operation using the [sy,1] scaling vector, where sy is given as the parameter."
                },
                {
                    "name": "scaleZ()",
                    "description": "Specifies a scale operation using the [1,1,sz] scaling vector, where sz is given as the parameter."
                },
                {
                    "name": "skew()",
                    "description": "Specifies a skew transformation along the X and Y axes. The first angle parameter specifies the skew on the X axis. The second angle parameter specifies the skew on the Y axis. If the second parameter is not given then a value of 0 is used for the Y angle (ie: no skew on the Y axis)."
                },
                {
                    "name": "skewX()",
                    "description": "Specifies a skew transformation along the X axis by the given angle."
                },
                {
                    "name": "skewY()",
                    "description": "Specifies a skew transformation along the Y axis by the given angle."
                },
                {
                    "name": "translate()",
                    "description": "Specifies a 2D translation by the vector [tx, ty], where tx is the first translation-value parameter and ty is the optional second translation-value parameter."
                },
                {
                    "name": "translate3d()",
                    "description": "Specifies a 3D translation by the vector [tx,ty,tz], with tx, ty and tz being the first, second and third translation-value parameters respectively."
                },
                {
                    "name": "translateX()",
                    "description": "Specifies a translation by the given amount in the X direction."
                },
                {
                    "name": "translateY()",
                    "description": "Specifies a translation by the given amount in the Y direction."
                },
                {
                    "name": "translateZ()",
                    "description": "Specifies a translation by the given amount in the Z direction. Note that percentage values are not allowed in the translateZ translation-value, and if present are evaluated as 0."
                }
            ],
            "relevance": 50,
            "description": "A two-dimensional transformation is applied to an element through the 'transform' property. This property contains a list of transform functions similar to those allowed by SVG.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-transform-origin",
            "browsers": [
                "C",
                "O15",
                "S3.1"
            ],
            "relevance": 50,
            "description": "Establishes the origin of transformation for an element.",
            "restrictions": [
                "position",
                "length",
                "percentage"
            ]
        },
        {
            "name": "-webkit-transform-origin-x",
            "browsers": [
                "E79",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "relevance": 50,
            "baseline": {
                "status": "false"
            },
            "description": "The x coordinate of the origin for transforms applied to an element with respect to its border box.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "-webkit-transform-origin-y",
            "browsers": [
                "E79",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "relevance": 50,
            "baseline": {
                "status": "false"
            },
            "description": "The y coordinate of the origin for transforms applied to an element with respect to its border box.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "-webkit-transform-origin-z",
            "browsers": [
                "E79",
                "S4",
                "SM3.2",
                "C2",
                "CA18",
                "O15"
            ],
            "relevance": 50,
            "baseline": {
                "status": "false"
            },
            "description": "The z coordinate of the origin for transforms applied to an element with respect to its border box.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "-webkit-transform-style",
            "browsers": [
                "C",
                "S4"
            ],
            "values": [
                {
                    "name": "flat",
                    "description": "All children of this element are rendered flattened into the 2D plane of the element."
                }
            ],
            "relevance": 50,
            "description": "Defines how nested elements are rendered in 3D space.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-transition",
            "browsers": [
                "C",
                "O12",
                "S5"
            ],
            "values": [
                {
                    "name": "all",
                    "description": "Every property that is able to undergo a transition will do so."
                },
                {
                    "name": "none",
                    "description": "No property will transition."
                }
            ],
            "relevance": 50,
            "description": "Shorthand property combines four of the transition properties into a single property.",
            "restrictions": [
                "time",
                "property",
                "timing-function",
                "enum"
            ]
        },
        {
            "name": "-webkit-transition-delay",
            "browsers": [
                "C",
                "O12",
                "S5"
            ],
            "relevance": 50,
            "description": "Defines when the transition will start. It allows a transition to begin execution some period of time from when it is applied.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "-webkit-transition-duration",
            "browsers": [
                "C",
                "O12",
                "S5"
            ],
            "relevance": 50,
            "description": "Specifies how long the transition from the old value to the new value should take.",
            "restrictions": [
                "time"
            ]
        },
        {
            "name": "-webkit-transition-property",
            "browsers": [
                "C",
                "O12",
                "S5"
            ],
            "values": [
                {
                    "name": "all",
                    "description": "Every property that is able to undergo a transition will do so."
                },
                {
                    "name": "none",
                    "description": "No property will transition."
                }
            ],
            "relevance": 50,
            "description": "Specifies the name of the CSS property to which the transition is applied.",
            "restrictions": [
                "property"
            ]
        },
        {
            "name": "-webkit-transition-timing-function",
            "browsers": [
                "C",
                "O12",
                "S5"
            ],
            "relevance": 50,
            "description": "Describes how the intermediate values used during a transition will be calculated.",
            "restrictions": [
                "timing-function"
            ]
        },
        {
            "name": "-webkit-user-drag",
            "browsers": [
                "E79",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "element"
                },
                {
                    "name": "none"
                }
            ],
            "relevance": 50,
            "baseline": {
                "status": "false"
            },
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-user-modify",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "read-only"
                },
                {
                    "name": "read-write"
                },
                {
                    "name": "read-write-plaintext-only"
                }
            ],
            "status": "nonstandard",
            "syntax": "read-only | read-write | read-write-plaintext-only",
            "relevance": 0,
            "description": "Determines whether a user can edit the content of an element.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "-webkit-user-select",
            "browsers": [
                "C",
                "S3"
            ],
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "none"
                },
                {
                    "name": "text"
                }
            ],
            "status": "nonstandard",
            "syntax": "auto | text | none | all",
            "relevance": 0,
            "description": "Controls the appearance of selection.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "widows",
            "browsers": [
                "E12",
                "S1.3",
                "SM1",
                "C25",
                "CA25",
                "IE8",
                "O9.2"
            ],
            "syntax": "<integer>",
            "relevance": 51,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/widows"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Specifies the minimum number of line boxes of a block container that must be left in a fragment after a break.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "width",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The width depends on the values of other properties."
                },
                {
                    "name": "fit-content",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O3.5"
                    ],
                    "description": "Use the fit-content inline size or fit-content block size, as appropriate to the writing mode."
                },
                {
                    "name": "max-content",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O3.5"
                    ],
                    "description": "Use the max-content inline size or max-content block size, as appropriate to the writing mode."
                },
                {
                    "name": "min-content",
                    "browsers": [
                        "E12",
                        "FF1",
                        "FFA4",
                        "S1",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE4",
                        "O3.5"
                    ],
                    "description": "Use the min-content inline size or min-content block size, as appropriate to the writing mode."
                }
            ],
            "syntax": "auto | <length-percentage [0,\u221E]> | min-content | max-content | fit-content | fit-content(<length-percentage [0,\u221E]>) | <calc-size()> | <anchor-size()>",
            "relevance": 96,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies the width of the content area, padding area or border area (depending on 'box-sizing') of certain boxes.",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "will-change",
            "browsers": [
                "E79",
                "FF36",
                "FFA36",
                "S9.1",
                "SM9.3",
                "C36",
                "CA36",
                "O23"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "Expresses no particular intent."
                },
                {
                    "name": "contents",
                    "description": "Indicates that the author expects to animate or change something about the element's contents in the near future."
                },
                {
                    "name": "scroll-position",
                    "description": "Indicates that the author expects to animate or change the scroll position of the element in the near future."
                }
            ],
            "syntax": "auto | <animateable-feature>#",
            "relevance": 67,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/will-change"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Provides a rendering hint to the user agent, stating what kinds of changes the author expects to perform on the element.",
            "restrictions": [
                "enum",
                "identifier"
            ]
        },
        {
            "name": "word-break",
            "browsers": [
                "E12",
                "FF15",
                "FFA15",
                "S3",
                "SM2",
                "C1",
                "CA18",
                "IE5.5",
                "O15"
            ],
            "values": [
                {
                    "name": "break-all",
                    "description": "Lines may break between any two grapheme clusters for non-CJK scripts."
                },
                {
                    "name": "keep-all",
                    "description": "Block characters can no longer create implied break points."
                },
                {
                    "name": "normal",
                    "description": "Breaks non-CJK scripts according to their own rules."
                }
            ],
            "syntax": "normal | break-all | keep-all | break-word | auto-phrase",
            "relevance": 77,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/word-break"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies line break opportunities for non-CJK scripts.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "word-spacing",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE6",
                "O3.5"
            ],
            "values": [
                {
                    "name": "normal",
                    "description": "No additional spacing is applied. Computes to zero."
                }
            ],
            "syntax": "normal | <length>",
            "relevance": 56,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/word-spacing"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies additional spacing between \"words\".",
            "restrictions": [
                "length",
                "percentage"
            ]
        },
        {
            "name": "word-wrap",
            "values": [
                {
                    "name": "break-word",
                    "description": "An otherwise unbreakable sequence of characters may be broken at an arbitrary point if there are no otherwise-acceptable break points in the line."
                },
                {
                    "name": "normal",
                    "description": "Lines may break only at allowed break points."
                }
            ],
            "syntax": "normal | break-word",
            "relevance": 77,
            "description": "Specifies whether the UA may break within a word to prevent overflow when an otherwise-unbreakable string is too long to fit.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "writing-mode",
            "browsers": [
                "E12",
                "FF41",
                "FFA41",
                "S10.1",
                "SM10.3",
                "C48",
                "CA48",
                "IE9",
                "O35"
            ],
            "values": [
                {
                    "name": "horizontal-tb",
                    "description": "Top-to-bottom block flow direction. The writing mode is horizontal."
                },
                {
                    "name": "sideways-lr",
                    "browsers": [
                        "E12",
                        "FF41",
                        "FFA41",
                        "S10.1",
                        "SM10.3",
                        "C48",
                        "CA48",
                        "IE9",
                        "O35"
                    ],
                    "description": "Left-to-right block flow direction. The writing mode is vertical, while the typographic mode is horizontal."
                },
                {
                    "name": "sideways-rl",
                    "browsers": [
                        "E12",
                        "FF41",
                        "FFA41",
                        "S10.1",
                        "SM10.3",
                        "C48",
                        "CA48",
                        "IE9",
                        "O35"
                    ],
                    "description": "Right-to-left block flow direction. The writing mode is vertical, while the typographic mode is horizontal."
                },
                {
                    "name": "vertical-lr",
                    "description": "Left-to-right block flow direction. The writing mode is vertical."
                },
                {
                    "name": "vertical-rl",
                    "description": "Right-to-left block flow direction. The writing mode is vertical."
                }
            ],
            "syntax": "horizontal-tb | vertical-rl | vertical-lr | sideways-rl | sideways-lr",
            "relevance": 53,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/writing-mode"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-03-27",
                "baseline_high_date": "2019-09-27"
            },
            "description": "This is a shorthand property for both 'direction' and 'block-progression'.",
            "restrictions": [
                "enum"
            ]
        },
        {
            "name": "z-index",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O4"
            ],
            "values": [
                {
                    "name": "auto",
                    "description": "The stack level of the generated box in the current stacking context is 0. The box does not establish a new stacking context unless it is the root element."
                }
            ],
            "syntax": "auto | <integer>",
            "relevance": 92,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/z-index"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "For a positioned box, the 'z-index' property specifies the stack level of the box in the current stacking context and whether the box establishes a local stacking context.",
            "restrictions": [
                "integer"
            ]
        },
        {
            "name": "zoom",
            "browsers": [
                "E12",
                "FF126",
                "FFA126",
                "S3.1",
                "SM3",
                "C1",
                "CA18",
                "IE5.5",
                "O15"
            ],
            "values": [
                {
                    "name": "normal"
                }
            ],
            "syntax": "normal | reset | <number [0,\u221E]> || <percentage [0,\u221E]>",
            "relevance": 65,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/zoom"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-05-14"
            },
            "description": "Non-standard. Specifies the magnification scale of the object. See 'transform: scale()' for a standards-based alternative.",
            "restrictions": [
                "enum",
                "integer",
                "number",
                "percentage"
            ]
        },
        {
            "name": "-ms-ime-align",
            "status": "nonstandard",
            "syntax": "auto | after",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "after"
                }
            ],
            "relevance": 0,
            "description": "Aligns the Input Method Editor (IME) candidate window box relative to the element on which the IME composition is active."
        },
        {
            "name": "-moz-binding",
            "status": "nonstandard",
            "syntax": "<url> | none",
            "relevance": 0,
            "description": "The -moz-binding CSS property is used by Mozilla-based applications to attach an XBL binding to a DOM element."
        },
        {
            "name": "-moz-context-properties",
            "status": "nonstandard",
            "syntax": "none | [ fill | fill-opacity | stroke | stroke-opacity ]#",
            "relevance": 0,
            "description": "If you reference an SVG image in a webpage (such as with the <img> element or as a background image), the SVG image can coordinate with the embedding element (its context) to have the image adopt property values set on the embedding element. To do this the embedding element needs to list the properties that are to be made available to the image by listing them as values of the -moz-context-properties property, and the image needs to opt in to using those properties by using values such as the context-fill value.\n\nThis feature is available since Firefox 55, but is only currently supported with SVG images loaded via chrome:// or resource:// URLs. To experiment with the feature in SVG on the Web it is necessary to set the svg.context-properties.content.enabled pref to true."
        },
        {
            "name": "-moz-float-edge",
            "status": "obsolete",
            "syntax": "border-box | content-box | margin-box | padding-box",
            "values": [
                {
                    "name": "border-box"
                },
                {
                    "name": "content-box"
                },
                {
                    "name": "margin-box"
                },
                {
                    "name": "padding-box"
                }
            ],
            "relevance": 0,
            "browsers": [
                "FF1",
                "FFA4"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-moz-float-edge"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The non-standard -moz-float-edge CSS property specifies whether the height and width properties of the element include the margin, border, or padding thickness."
        },
        {
            "name": "-moz-force-broken-image-icon",
            "status": "obsolete",
            "syntax": "0 | 1",
            "values": [
                {
                    "name": "0"
                },
                {
                    "name": "1"
                }
            ],
            "relevance": 0,
            "browsers": [
                "FF1",
                "FFA4"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-moz-force-broken-image-icon"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The -moz-force-broken-image-icon extended CSS property can be used to force the broken image icon to be shown even when a broken image has an alt attribute."
        },
        {
            "name": "-moz-image-region",
            "status": "nonstandard",
            "syntax": "<shape> | auto",
            "relevance": 0,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-moz-image-region"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "For certain XUL elements and pseudo-elements that use an image from the list-style-image property, this property specifies a region of the image that is used in place of the whole image. This allows elements to use different pieces of the same image to improve performance."
        },
        {
            "name": "-moz-orient",
            "status": "nonstandard",
            "syntax": "inline | block | horizontal | vertical",
            "values": [
                {
                    "name": "inline"
                },
                {
                    "name": "block"
                },
                {
                    "name": "horizontal"
                },
                {
                    "name": "vertical"
                }
            ],
            "relevance": 0,
            "browsers": [
                "FF6",
                "FFA6"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-moz-orient"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The -moz-orient CSS property specifies the orientation of the element to which it's applied."
        },
        {
            "name": "-moz-outline-radius",
            "status": "nonstandard",
            "syntax": "<outline-radius>{1,4} [ / <outline-radius>{1,4} ]?",
            "relevance": 0,
            "description": "In Mozilla applications like Firefox, the -moz-outline-radius CSS property can be used to give an element's outline rounded corners."
        },
        {
            "name": "-moz-outline-radius-bottomleft",
            "status": "nonstandard",
            "syntax": "<outline-radius>",
            "relevance": 0,
            "description": "In Mozilla applications, the -moz-outline-radius-bottomleft CSS property can be used to round the bottom-left corner of an element's outline."
        },
        {
            "name": "-moz-outline-radius-bottomright",
            "status": "nonstandard",
            "syntax": "<outline-radius>",
            "relevance": 0,
            "description": "In Mozilla applications, the -moz-outline-radius-bottomright CSS property can be used to round the bottom-right corner of an element's outline."
        },
        {
            "name": "-moz-outline-radius-topleft",
            "status": "nonstandard",
            "syntax": "<outline-radius>",
            "relevance": 0,
            "description": "In Mozilla applications, the -moz-outline-radius-topleft CSS property can be used to round the top-left corner of an element's outline."
        },
        {
            "name": "-moz-outline-radius-topright",
            "status": "nonstandard",
            "syntax": "<outline-radius>",
            "relevance": 0,
            "description": "In Mozilla applications, the -moz-outline-radius-topright CSS property can be used to round the top-right corner of an element's outline."
        },
        {
            "name": "-moz-stack-sizing",
            "status": "nonstandard",
            "syntax": "ignore | stretch-to-fit",
            "values": [
                {
                    "name": "ignore"
                },
                {
                    "name": "stretch-to-fit"
                }
            ],
            "relevance": 0,
            "description": "-moz-stack-sizing is an extended CSS property. Normally, a stack will change its size so that all of its child elements are completely visible. For example, moving a child of the stack far to the right will widen the stack so the child remains visible."
        },
        {
            "name": "-moz-text-blink",
            "status": "nonstandard",
            "syntax": "none | blink",
            "values": [
                {
                    "name": "none"
                },
                {
                    "name": "blink"
                }
            ],
            "relevance": 0,
            "description": "The -moz-text-blink non-standard Mozilla CSS extension specifies the blink mode."
        },
        {
            "name": "-moz-user-input",
            "status": "obsolete",
            "syntax": "auto | none | enabled | disabled",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "none"
                },
                {
                    "name": "enabled"
                },
                {
                    "name": "disabled"
                }
            ],
            "relevance": 0,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-moz-user-input"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "In Mozilla applications, -moz-user-input determines if an element will accept user input."
        },
        {
            "name": "-moz-user-modify",
            "status": "nonstandard",
            "syntax": "read-only | read-write | write-only",
            "values": [
                {
                    "name": "read-only"
                },
                {
                    "name": "read-write"
                },
                {
                    "name": "write-only"
                }
            ],
            "relevance": 0,
            "description": "The -moz-user-modify property has no effect. It was originally planned to determine whether or not the content of an element can be edited by a user."
        },
        {
            "name": "-moz-window-dragging",
            "status": "nonstandard",
            "syntax": "drag | no-drag",
            "values": [
                {
                    "name": "drag"
                },
                {
                    "name": "no-drag"
                }
            ],
            "relevance": 0,
            "description": "The -moz-window-dragging CSS property specifies whether a window is draggable or not. It only works in Chrome code, and only on Mac OS X."
        },
        {
            "name": "-moz-window-shadow",
            "status": "nonstandard",
            "syntax": "default | menu | tooltip | sheet | none",
            "values": [
                {
                    "name": "default"
                },
                {
                    "name": "menu"
                },
                {
                    "name": "tooltip"
                },
                {
                    "name": "sheet"
                },
                {
                    "name": "none"
                }
            ],
            "relevance": 0,
            "description": "The -moz-window-shadow CSS property specifies whether a window will have a shadow. It only works on Mac OS X."
        },
        {
            "name": "-webkit-border-before",
            "status": "nonstandard",
            "syntax": "<'border-width'> || <'border-style'> || <color>",
            "relevance": 0,
            "browsers": [
                "E79",
                "S5.1",
                "SM5",
                "C8",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-webkit-border-before"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The -webkit-border-before CSS property is a shorthand property for setting the individual logical block start border property values in a single place in the style sheet."
        },
        {
            "name": "-webkit-border-before-color",
            "status": "nonstandard",
            "syntax": "<color>",
            "relevance": 0,
            "description": "The -webkit-border-before-color CSS property sets the color of the individual logical block start border in a single place in the style sheet."
        },
        {
            "name": "-webkit-border-before-style",
            "status": "nonstandard",
            "syntax": "<'border-style'>",
            "relevance": 0,
            "description": "The -webkit-border-before-style CSS property sets the style of the individual logical block start border in a single place in the style sheet."
        },
        {
            "name": "-webkit-border-before-width",
            "status": "nonstandard",
            "syntax": "<'border-width'>",
            "relevance": 0,
            "description": "The -webkit-border-before-width CSS property sets the width of the individual logical block start border in a single place in the style sheet."
        },
        {
            "name": "-webkit-line-clamp",
            "syntax": "none | <integer>",
            "relevance": 50,
            "description": "The -webkit-line-clamp CSS property allows limiting of the contents of a block container to the specified number of lines."
        },
        {
            "name": "-webkit-mask",
            "status": "nonstandard",
            "syntax": "[ <mask-reference> || <position> [ / <bg-size> ]? || <repeat-style> || [ <visual-box> | border | padding | content | text ] || [ <visual-box> | border | padding | content ] ]#",
            "relevance": 0,
            "description": "The mask CSS property alters the visibility of an element by either partially or fully hiding it. This is accomplished by either masking or clipping the image at specific points."
        },
        {
            "name": "-webkit-mask-attachment",
            "status": "nonstandard",
            "syntax": "<attachment>#",
            "relevance": 0,
            "description": "If a -webkit-mask-image is specified, -webkit-mask-attachment determines whether the mask image's position is fixed within the viewport, or scrolls along with its containing block."
        },
        {
            "name": "-webkit-mask-composite",
            "status": "nonstandard",
            "syntax": "<composite-style>#",
            "relevance": 0,
            "browsers": [
                "E18",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-webkit-mask-composite"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The -webkit-mask-composite property specifies the manner in which multiple mask images applied to the same element are composited with one another. Mask images are composited in the opposite order that they are declared with the -webkit-mask-image property."
        },
        {
            "name": "-webkit-mask-position",
            "status": "nonstandard",
            "syntax": "<position>#",
            "relevance": 0,
            "description": "The mask-position CSS property sets the initial position, relative to the mask position layer defined by mask-origin, for each defined mask image."
        },
        {
            "name": "-webkit-mask-position-x",
            "status": "nonstandard",
            "syntax": "[ <length-percentage> | left | center | right ]#",
            "relevance": 0,
            "browsers": [
                "E18",
                "FF49",
                "FFA49",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-webkit-mask-position-x"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2018-10-02",
                "baseline_high_date": "2021-04-02"
            },
            "description": "The -webkit-mask-position-x CSS property sets the initial horizontal position of a mask image."
        },
        {
            "name": "-webkit-mask-position-y",
            "status": "nonstandard",
            "syntax": "[ <length-percentage> | top | center | bottom ]#",
            "relevance": 0,
            "browsers": [
                "E18",
                "FF49",
                "FFA49",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-webkit-mask-position-y"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2018-10-02",
                "baseline_high_date": "2021-04-02"
            },
            "description": "The -webkit-mask-position-y CSS property sets the initial vertical position of a mask image."
        },
        {
            "name": "-webkit-mask-repeat-x",
            "status": "nonstandard",
            "syntax": "repeat | no-repeat | space | round",
            "values": [
                {
                    "name": "repeat"
                },
                {
                    "name": "no-repeat"
                },
                {
                    "name": "space"
                },
                {
                    "name": "round"
                }
            ],
            "relevance": 0,
            "browsers": [
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-webkit-mask-repeat-x"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The -webkit-mask-repeat-x property specifies whether and how a mask image is repeated (tiled) horizontally."
        },
        {
            "name": "-webkit-mask-repeat-y",
            "status": "nonstandard",
            "syntax": "repeat | no-repeat | space | round",
            "values": [
                {
                    "name": "repeat"
                },
                {
                    "name": "no-repeat"
                },
                {
                    "name": "space"
                },
                {
                    "name": "round"
                }
            ],
            "relevance": 0,
            "browsers": [
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/-webkit-mask-repeat-y"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The -webkit-mask-repeat-y property specifies whether and how a mask image is repeated (tiled) vertically."
        },
        {
            "name": "accent-color",
            "syntax": "auto | <color>",
            "relevance": 50,
            "browsers": [
                "E93",
                "FF92",
                "FFA92",
                "C93",
                "O79"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/accent-color"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Sets the color of the elements accent"
        },
        {
            "name": "align-tracks",
            "status": "nonstandard",
            "syntax": "[ normal | <baseline-position> | <content-distribution> | <overflow-position>? <content-position> ]#",
            "relevance": 0,
            "description": "The align-tracks CSS property sets the alignment in the masonry axis for grid containers that have masonry in their block axis."
        },
        {
            "name": "alignment-baseline",
            "syntax": "baseline | alphabetic | ideographic | middle | central | mathematical | text-before-edge | text-after-edge",
            "values": [
                {
                    "name": "baseline"
                },
                {
                    "name": "alphabetic"
                },
                {
                    "name": "ideographic"
                },
                {
                    "name": "middle"
                },
                {
                    "name": "central"
                },
                {
                    "name": "mathematical"
                },
                {
                    "name": "text-before-edge"
                },
                {
                    "name": "text-after-edge"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E79",
                "S5.1",
                "SM5",
                "C1",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/alignment-baseline"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The alignment-baseline CSS property specifies the specific baseline used to align the box's text and inline-level contents. Baseline alignment is the relationship among the baselines of multiple alignment subjects within an alignment context. When performing baseline alignment, the alignment-baseline property value specifies which baseline of the box is aligned to the corresponding baseline of its alignment context."
        },
        {
            "name": "anchor-name",
            "status": "experimental",
            "syntax": "none | <dashed-ident>#",
            "relevance": 50,
            "browsers": [
                "E125",
                "C125",
                "CA125",
                "O111"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/anchor-name"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The anchor-name property declares that an element is an anchor element, and gives it a list of anchor names to be targeted by."
        },
        {
            "name": "anchor-scope",
            "status": "experimental",
            "syntax": "none | all | <dashed-ident>#",
            "relevance": 50,
            "browsers": [
                "E131",
                "C131",
                "CA131",
                "O116"
            ],
            "baseline": {
                "status": "false"
            },
            "description": "This property scopes the specified anchor names, and lookups for these anchor names, to this element\u2019s subtree"
        },
        {
            "name": "animation-composition",
            "syntax": "<single-animation-composition>#",
            "relevance": 50,
            "browsers": [
                "E112",
                "FF115",
                "FFA115",
                "S16",
                "SM16",
                "C112",
                "CA112",
                "O98"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/animation-composition"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-07-04"
            },
            "description": "The composite operation to use when multiple animations affect the same property."
        },
        {
            "name": "animation-range",
            "status": "experimental",
            "syntax": "[ <'animation-range-start'> <'animation-range-end'>? ]#",
            "relevance": 50,
            "browsers": [
                "E115",
                "C115",
                "CA115",
                "O101"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/animation-range"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The animation-range CSS shorthand property is used to set the start and end of an animation's attachment range along its timeline, i.e. where along the timeline an animation will start and end."
        },
        {
            "name": "animation-range-end",
            "status": "experimental",
            "syntax": "[ normal | <length-percentage> | <timeline-range-name> <length-percentage>? ]#",
            "relevance": 50,
            "browsers": [
                "E115",
                "C115",
                "CA115",
                "O101"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/animation-range-end"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The animation-range-end CSS property is used to set the end of an animation's attachment range along its timeline, i.e. where along the timeline an animation will end."
        },
        {
            "name": "animation-range-start",
            "status": "experimental",
            "syntax": "[ normal | <length-percentage> | <timeline-range-name> <length-percentage>? ]#",
            "relevance": 50,
            "browsers": [
                "E115",
                "C115",
                "CA115",
                "O101"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/animation-range-start"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The animation-range-start CSS property is used to set the start of an animation's attachment range along its timeline, i.e. where along the timeline an animation will start."
        },
        {
            "name": "animation-timeline",
            "status": "experimental",
            "syntax": "<single-animation-timeline>#",
            "relevance": 50,
            "browsers": [
                "E115",
                "C115",
                "CA115",
                "O101"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/animation-timeline"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Specifies the names of one or more @scroll-timeline at-rules to describe the element's scroll animations."
        },
        {
            "name": "appearance",
            "syntax": "none | auto | textfield | menulist-button | <compat-auto>",
            "relevance": 72,
            "browsers": [
                "E84",
                "FF80",
                "FFA80",
                "S15.4",
                "SM15.4",
                "C84",
                "CA84",
                "O70"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/appearance"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-03-14",
                "baseline_high_date": "2024-09-14"
            },
            "description": "Changes the appearance of buttons and other controls to resemble native controls."
        },
        {
            "name": "aspect-ratio",
            "syntax": "auto || <ratio>",
            "relevance": 64,
            "browsers": [
                "E88",
                "FF89",
                "FFA89",
                "S15",
                "SM15",
                "C88",
                "CA88",
                "O74"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/aspect-ratio"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The aspect-ratio   CSS property sets a preferred aspect ratio for the box, which will be used in the calculation of auto sizes and some other layout functions."
        },
        {
            "name": "backdrop-filter",
            "syntax": "none | <filter-value-list>",
            "relevance": 63,
            "browsers": [
                "E79",
                "FF103",
                "FFA103",
                "S18",
                "SM18",
                "C76",
                "CA76",
                "O63"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/backdrop-filter"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-09-16"
            },
            "description": "The backdrop-filter CSS property lets you apply graphical effects such as blurring or color shifting to the area behind an element. Because it applies to everything behind the element, to see the effect you must make the element or its background at least partially transparent."
        },
        {
            "name": "baseline-shift",
            "syntax": "<length-percentage> | sub | super | baseline",
            "relevance": 50,
            "browsers": [
                "E79",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "baseline": {
                "status": "false"
            },
            "description": ""
        },
        {
            "name": "border-block",
            "syntax": "<'border-block-start'>",
            "relevance": 50,
            "browsers": [
                "E87",
                "FF66",
                "FFA66",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-block"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The border-block CSS property is a shorthand property for setting the individual logical block border property values in a single place in the style sheet."
        },
        {
            "name": "border-block-color",
            "syntax": "<'border-top-color'>{1,2}",
            "relevance": 50,
            "browsers": [
                "E87",
                "FF66",
                "FFA66",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-block-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The border-block-color CSS property defines the color of the logical block borders of an element, which maps to a physical border color depending on the element's writing mode, directionality, and text orientation. It corresponds to the border-top-color and border-bottom-color, or border-right-color and border-left-color property depending on the values defined for writing-mode, direction, and text-orientation."
        },
        {
            "name": "border-block-style",
            "syntax": "<'border-top-style'>{1,2}",
            "relevance": 50,
            "browsers": [
                "E87",
                "FF66",
                "FFA66",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-block-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The border-block-style CSS property defines the style of the logical block borders of an element, which maps to a physical border style depending on the element's writing mode, directionality, and text orientation. It corresponds to the border-top-style and border-bottom-style, or border-left-style and border-right-style properties depending on the values defined for writing-mode, direction, and text-orientation."
        },
        {
            "name": "border-block-width",
            "syntax": "<'border-top-width'>{1,2}",
            "relevance": 50,
            "browsers": [
                "E87",
                "FF66",
                "FFA66",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-block-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The border-block-width CSS property defines the width of the logical block borders of an element, which maps to a physical border width depending on the element's writing mode, directionality, and text orientation. It corresponds to the border-top-width and border-bottom-width, or border-left-width, and border-right-width property depending on the values defined for writing-mode, direction, and text-orientation."
        },
        {
            "name": "border-end-end-radius",
            "syntax": "<'border-top-left-radius'>",
            "relevance": 54,
            "browsers": [
                "E89",
                "FF66",
                "FFA66",
                "S15",
                "SM15",
                "C89",
                "CA89",
                "O75"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-end-end-radius"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The border-end-end-radius CSS property defines a logical border radius on an element, which maps to a physical border radius that depends on on the element's writing-mode, direction, and text-orientation."
        },
        {
            "name": "border-end-start-radius",
            "syntax": "<'border-top-left-radius'>",
            "relevance": 54,
            "browsers": [
                "E89",
                "FF66",
                "FFA66",
                "S15",
                "SM15",
                "C89",
                "CA89",
                "O75"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-end-start-radius"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The border-end-start-radius CSS property defines a logical border radius on an element, which maps to a physical border radius depending on the element's writing-mode, direction, and text-orientation."
        },
        {
            "name": "border-inline",
            "syntax": "<'border-block-start'>",
            "relevance": 50,
            "browsers": [
                "E87",
                "FF66",
                "FFA66",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-inline"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The border-inline CSS property is a shorthand property for setting the individual logical inline border property values in a single place in the style sheet."
        },
        {
            "name": "border-inline-color",
            "syntax": "<'border-top-color'>{1,2}",
            "relevance": 50,
            "browsers": [
                "E87",
                "FF66",
                "FFA66",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-inline-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The border-inline-color CSS property defines the color of the logical inline borders of an element, which maps to a physical border color depending on the element's writing mode, directionality, and text orientation. It corresponds to the border-top-color and border-bottom-color, or border-right-color and border-left-color property depending on the values defined for writing-mode, direction, and text-orientation."
        },
        {
            "name": "border-inline-style",
            "syntax": "<'border-top-style'>{1,2}",
            "relevance": 50,
            "browsers": [
                "E87",
                "FF66",
                "FFA66",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-inline-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The border-inline-style CSS property defines the style of the logical inline borders of an element, which maps to a physical border style depending on the element's writing mode, directionality, and text orientation. It corresponds to the border-top-style and border-bottom-style, or border-left-style and border-right-style properties depending on the values defined for writing-mode, direction, and text-orientation."
        },
        {
            "name": "border-inline-width",
            "syntax": "<'border-top-width'>{1,2}",
            "relevance": 50,
            "browsers": [
                "E87",
                "FF66",
                "FFA66",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-inline-width"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The border-inline-width CSS property defines the width of the logical inline borders of an element, which maps to a physical border width depending on the element's writing mode, directionality, and text orientation. It corresponds to the border-top-width and border-bottom-width, or border-left-width, and border-right-width property depending on the values defined for writing-mode, direction, and text-orientation."
        },
        {
            "name": "border-start-end-radius",
            "syntax": "<'border-top-left-radius'>",
            "relevance": 54,
            "browsers": [
                "E89",
                "FF66",
                "FFA66",
                "S15",
                "SM15",
                "C89",
                "CA89",
                "O75"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-start-end-radius"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The border-start-end-radius CSS property defines a logical border radius on an element, which maps to a physical border radius depending on the element's writing-mode, direction, and text-orientation."
        },
        {
            "name": "border-start-start-radius",
            "syntax": "<'border-top-left-radius'>",
            "relevance": 54,
            "browsers": [
                "E89",
                "FF66",
                "FFA66",
                "S15",
                "SM15",
                "C89",
                "CA89",
                "O75"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/border-start-start-radius"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The border-start-start-radius CSS property defines a logical border radius on an element, which maps to a physical border radius that depends on the element's writing-mode, direction, and text-orientation."
        },
        {
            "name": "box-align",
            "status": "obsolete",
            "syntax": "start | center | end | baseline | stretch",
            "values": [
                {
                    "name": "start"
                },
                {
                    "name": "center"
                },
                {
                    "name": "end"
                },
                {
                    "name": "baseline"
                },
                {
                    "name": "stretch"
                }
            ],
            "relevance": 0,
            "browsers": [
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/box-align"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The box-align CSS property specifies how an element aligns its contents across its layout in a perpendicular direction. The effect of the property is only visible if there is extra space in the box."
        },
        {
            "name": "box-direction",
            "status": "obsolete",
            "syntax": "normal | reverse | inherit",
            "values": [
                {
                    "name": "normal"
                },
                {
                    "name": "reverse"
                },
                {
                    "name": "inherit"
                }
            ],
            "relevance": 0,
            "browsers": [
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/box-direction"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The box-direction CSS property specifies whether a box lays out its contents normally (from the top or left edge), or in reverse (from the bottom or right edge)."
        },
        {
            "name": "box-flex",
            "status": "obsolete",
            "syntax": "<number>",
            "relevance": 0,
            "browsers": [
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/box-flex"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The -moz-box-flex and -webkit-box-flex CSS properties specify how a -moz-box or -webkit-box grows to fill the box that contains it, in the direction of the containing box's layout."
        },
        {
            "name": "box-flex-group",
            "status": "obsolete",
            "syntax": "<integer>",
            "relevance": 0,
            "browsers": [
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/box-flex-group"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The box-flex-group CSS property assigns the flexbox's child elements to a flex group."
        },
        {
            "name": "box-lines",
            "status": "obsolete",
            "syntax": "single | multiple",
            "values": [
                {
                    "name": "single"
                },
                {
                    "name": "multiple"
                }
            ],
            "relevance": 0,
            "browsers": [
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/box-lines"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The box-lines CSS property determines whether the box may have a single or multiple lines (rows for horizontally oriented boxes, columns for vertically oriented boxes)."
        },
        {
            "name": "box-ordinal-group",
            "status": "obsolete",
            "syntax": "<integer>",
            "relevance": 0,
            "browsers": [
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/box-ordinal-group"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The box-ordinal-group CSS property assigns the flexbox's child elements to an ordinal group."
        },
        {
            "name": "box-orient",
            "status": "obsolete",
            "syntax": "horizontal | vertical | inline-axis | block-axis | inherit",
            "values": [
                {
                    "name": "horizontal"
                },
                {
                    "name": "vertical"
                },
                {
                    "name": "inline-axis"
                },
                {
                    "name": "block-axis"
                },
                {
                    "name": "inherit"
                }
            ],
            "relevance": 0,
            "browsers": [
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/box-orient"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The box-orient CSS property specifies whether an element lays out its contents horizontally or vertically."
        },
        {
            "name": "box-pack",
            "status": "obsolete",
            "syntax": "start | center | end | justify",
            "values": [
                {
                    "name": "start"
                },
                {
                    "name": "center"
                },
                {
                    "name": "end"
                },
                {
                    "name": "justify"
                }
            ],
            "relevance": 0,
            "browsers": [
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/box-pack"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The -moz-box-pack and -webkit-box-pack CSS properties specify how a -moz-box or -webkit-box packs its contents in the direction of its layout. The effect of this is only visible if there is extra space in the box."
        },
        {
            "name": "caret",
            "syntax": "<'caret-color'> || <'caret-shape'>",
            "relevance": 50,
            "description": "Shorthand for setting caret-color and caret-shape."
        },
        {
            "name": "caret-shape",
            "syntax": "auto | bar | block | underscore",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "bar"
                },
                {
                    "name": "block"
                },
                {
                    "name": "underscore"
                }
            ],
            "relevance": 50,
            "description": "Specifies the desired shape of the text insertion caret."
        },
        {
            "name": "color-scheme",
            "syntax": "normal | [ light | dark | <custom-ident> ]+ && only?",
            "relevance": 58,
            "browsers": [
                "E81",
                "FF96",
                "FFA96",
                "S13",
                "SM13",
                "C81",
                "CA81",
                "O68"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/color-scheme"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-01-11",
                "baseline_high_date": "2024-07-11"
            },
            "description": "The color-scheme CSS property allows an element to indicate which color schemes it can comfortably be rendered in."
        },
        {
            "name": "contain-intrinsic-block-size",
            "syntax": "auto? [ none | <length> ]",
            "relevance": 50,
            "browsers": [
                "E95",
                "FF107",
                "FFA107",
                "S17",
                "SM17",
                "C95",
                "CA95",
                "O81"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/contain-intrinsic-block-size"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-09-18"
            },
            "description": "Block size of an element when the element is subject to size containment."
        },
        {
            "name": "contain-intrinsic-height",
            "syntax": "auto? [ none | <length> ]",
            "relevance": 50,
            "browsers": [
                "E95",
                "FF107",
                "FFA107",
                "S17",
                "SM17",
                "C95",
                "CA95",
                "O81"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/contain-intrinsic-height"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-09-18"
            },
            "description": "Height of an element when the element is subject to size containment."
        },
        {
            "name": "contain-intrinsic-inline-size",
            "syntax": "auto? [ none | <length> ]",
            "relevance": 50,
            "browsers": [
                "E95",
                "FF107",
                "FFA107",
                "S17",
                "SM17",
                "C95",
                "CA95",
                "O81"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/contain-intrinsic-inline-size"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-09-18"
            },
            "description": "Inline size of an element when the element is subject to size containment."
        },
        {
            "name": "contain-intrinsic-size",
            "syntax": "[ auto? [ none | <length> ] ]{1,2}",
            "relevance": 50,
            "browsers": [
                "E83",
                "FF107",
                "FFA107",
                "S17",
                "SM17",
                "C83",
                "CA83",
                "O69"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/contain-intrinsic-size"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-09-18"
            },
            "description": "Size of an element when the element is subject to size containment."
        },
        {
            "name": "contain-intrinsic-width",
            "syntax": "auto? [ none | <length> ]",
            "relevance": 50,
            "browsers": [
                "E95",
                "FF107",
                "FFA107",
                "S17",
                "SM17",
                "C95",
                "CA95",
                "O81"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/contain-intrinsic-width"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-09-18"
            },
            "description": "Width of an element when the element is subject to size containment."
        },
        {
            "name": "container",
            "syntax": "<'container-name'> [ / <'container-type'> ]?",
            "relevance": 53,
            "browsers": [
                "E105",
                "FF110",
                "FFA110",
                "S16",
                "SM16",
                "C105",
                "CA105",
                "O91"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/container"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-02-14"
            },
            "description": "The container shorthand CSS property establishes the element as a query container and specifies the name or name for the containment context used in a container query."
        },
        {
            "name": "container-name",
            "syntax": "none | <custom-ident>+",
            "relevance": 50,
            "browsers": [
                "E105",
                "FF110",
                "FFA110",
                "S16",
                "SM16",
                "C105",
                "CA105",
                "O91"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/container-name"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-02-14"
            },
            "description": "The container-name CSS property specifies a list of query container names used by the @container at-rule in a container query."
        },
        {
            "name": "container-type",
            "syntax": "normal | [ [ size | inline-size ] || scroll-state ]",
            "relevance": 52,
            "browsers": [
                "E105",
                "FF110",
                "FFA110",
                "S16",
                "SM16",
                "C105",
                "CA105",
                "O91"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/container-type"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-02-14"
            },
            "description": "The container-type CSS property is used to define the type of containment used in a container query."
        },
        {
            "name": "content-visibility",
            "syntax": "visible | auto | hidden",
            "values": [
                {
                    "name": "visible"
                },
                {
                    "name": "auto"
                },
                {
                    "name": "hidden"
                }
            ],
            "relevance": 52,
            "browsers": [
                "E85",
                "FF125",
                "FFA125",
                "S18",
                "SM18",
                "C85",
                "CA85",
                "O71"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/content-visibility"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-09-16"
            },
            "description": "Controls whether or not an element renders its contents at all, along with forcing a strong set of containments, allowing user agents to potentially omit large swathes of layout and rendering work until it becomes needed."
        },
        {
            "name": "counter-set",
            "syntax": "[ <counter-name> <integer>? ]+ | none",
            "relevance": 50,
            "browsers": [
                "E85",
                "FF68",
                "FFA68",
                "S17.2",
                "SM17.2",
                "C85",
                "CA85",
                "O71"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/counter-set"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-12-11"
            },
            "description": "The counter-set CSS property sets a CSS counter to a given value. It manipulates the value of existing counters, and will only create new counters if there isn't already a counter of the given name on the element."
        },
        {
            "name": "cx",
            "syntax": "<length> | <percentage>",
            "relevance": 51,
            "browsers": [
                "E79",
                "FF69",
                "FFA79",
                "S9",
                "SM9",
                "C43",
                "CA43",
                "O30"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/cx"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-07-28",
                "baseline_high_date": "2023-01-28"
            },
            "description": "The cx CSS property defines the x-axis center point of an SVG circle or ellipse element. If present, it overrides the element's cx attribute."
        },
        {
            "name": "cy",
            "syntax": "<length> | <percentage>",
            "relevance": 51,
            "browsers": [
                "E79",
                "FF69",
                "FFA79",
                "S9",
                "SM9",
                "C43",
                "CA43",
                "O30"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/cy"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-07-28",
                "baseline_high_date": "2023-01-28"
            },
            "description": "The cy CSS property defines the y-axis center point of an SVG circle or ellipse elements. If present, it overrides the element's cy attribute."
        },
        {
            "name": "d",
            "syntax": "none | path(<string>)",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF97",
                "FFA97",
                "C52",
                "CA52",
                "O39"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/d"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The d CSS property defines a path to be drawn by the SVG path element. If present, it overrides the element's d attribute."
        },
        {
            "name": "dominant-baseline",
            "syntax": "auto | text-bottom | alphabetic | ideographic | middle | central | mathematical | hanging | text-top",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "text-bottom"
                },
                {
                    "name": "alphabetic"
                },
                {
                    "name": "ideographic"
                },
                {
                    "name": "middle"
                },
                {
                    "name": "central"
                },
                {
                    "name": "mathematical"
                },
                {
                    "name": "hanging"
                },
                {
                    "name": "text-top"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E79",
                "FF1",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/dominant-baseline"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "The dominant-baseline CSS property specifies the specific baseline used to align the box's text and inline-level contents. It also indicates the default alignment baseline of any boxes participating in baseline alignment in the box's alignment context. If present, it overrides the shape's dominant-baseline attribute."
        },
        {
            "name": "field-sizing",
            "status": "experimental",
            "syntax": "content | fixed",
            "values": [
                {
                    "name": "content"
                },
                {
                    "name": "fixed"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E123",
                "C123",
                "CA123",
                "O109"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/field-sizing"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The field-sizing CSS property enables you to control the sizing behavior of elements that are given a default preferred size, such as form control elements. This property enables you to override the default sizing behavior, allowing form controls to adjust in size to fit their contents."
        },
        {
            "name": "font-optical-sizing",
            "syntax": "auto | none",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "none"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E17",
                "FF62",
                "FFA62",
                "S13.1",
                "SM13.4",
                "C79",
                "CA79",
                "O66"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-optical-sizing"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-03-24",
                "baseline_high_date": "2022-09-24"
            },
            "description": "The font-optical-sizing CSS property allows developers to control whether browsers render text with slightly differing visual representations to optimize viewing at different sizes, or not. This only works for fonts that have an optical size variation axis."
        },
        {
            "name": "font-palette",
            "syntax": "normal | light | dark | <palette-identifier> | <palette-mix()>",
            "relevance": 50,
            "browsers": [
                "E101",
                "FF107",
                "FFA107",
                "S15.4",
                "SM15.4",
                "C101",
                "CA101",
                "O87"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-palette"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-11-15",
                "baseline_high_date": "2025-05-15"
            },
            "description": "The font-palette CSS property allows specifying one of the many palettes contained in a font that a user agent should use for the font. Users can also override the values in a palette or create a new palette by using the @font-palette-values at-rule."
        },
        {
            "name": "font-smooth",
            "status": "nonstandard",
            "syntax": "auto | never | always | <absolute-size> | <length>",
            "relevance": 0,
            "browsers": [
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-smooth"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The font-smooth CSS property controls the application of anti-aliasing when fonts are rendered."
        },
        {
            "name": "font-synthesis-position",
            "status": "experimental",
            "syntax": "auto | none",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "none"
                }
            ],
            "relevance": 50,
            "browsers": [
                "FF118",
                "FFA118"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-synthesis-position"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The font-synthesis-position CSS property lets you specify whether or not a browser may synthesize the subscript and superscript \"position\" typefaces when they are missing in a font family, while using font-variant-position to set the positions."
        },
        {
            "name": "font-synthesis-small-caps",
            "syntax": "auto | none",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "none"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E97",
                "FF111",
                "FFA111",
                "S16.4",
                "SM16.4",
                "C97",
                "CA97",
                "O83"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-synthesis-small-caps"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-03-27"
            },
            "description": "The font-synthesis-small-caps CSS property lets you specify whether or not the browser may synthesize small-caps typeface when it is missing in a font family. Small-caps glyphs typically use the form of uppercase letters but are reduced to the size of lowercase letters."
        },
        {
            "name": "font-synthesis-style",
            "syntax": "auto | none",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "none"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E97",
                "FF111",
                "FFA111",
                "S16.4",
                "SM16.4",
                "C97",
                "CA97",
                "O83"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-synthesis-style"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-03-27"
            },
            "description": "The font-synthesis-style CSS property lets you specify whether or not the browser may synthesize the oblique typeface when it is missing in a font family."
        },
        {
            "name": "font-synthesis-weight",
            "syntax": "auto | none",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "none"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E97",
                "FF111",
                "FFA111",
                "S16.4",
                "SM16.4",
                "C97",
                "CA97",
                "O83"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-synthesis-weight"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-03-27"
            },
            "description": "The font-synthesis-weight CSS property lets you specify whether or not the browser may synthesize the bold typeface when it is missing in a font family."
        },
        {
            "name": "font-variant-emoji",
            "syntax": "normal | text | emoji | unicode",
            "values": [
                {
                    "name": "normal"
                },
                {
                    "name": "text"
                },
                {
                    "name": "emoji"
                },
                {
                    "name": "unicode"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E131",
                "C131",
                "CA131",
                "O116"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-variant-emoji"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The font-variant-emoji CSS property specifies the default presentation style for displaying emojis."
        },
        {
            "name": "font-variation-settings",
            "atRule": "@font-face",
            "syntax": "normal | [ <string> <number> ]#",
            "relevance": 57,
            "browsers": [
                "E17",
                "FF62",
                "FFA62",
                "S11",
                "SM11",
                "C62",
                "CA62",
                "O49"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/font-variation-settings"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2018-09-05",
                "baseline_high_date": "2021-03-05"
            },
            "description": "The font-variation-settings CSS property provides low-level control over OpenType or TrueType font variations, by specifying the four letter axis names of the features you want to vary, along with their variation values."
        },
        {
            "name": "forced-color-adjust",
            "syntax": "auto | none | preserve-parent-color",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "none"
                },
                {
                    "name": "preserve-parent-color"
                }
            ],
            "relevance": 58,
            "browsers": [
                "E79",
                "FF113",
                "FFA113",
                "C89",
                "CA89",
                "IE10",
                "O75"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/forced-color-adjust"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Allows authors to opt certain elements out of forced colors mode. This then restores the control of those values to CSS"
        },
        {
            "name": "gap",
            "syntax": "<'row-gap'> <'column-gap'>?",
            "relevance": 76,
            "browsers": [
                "E16",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "O44"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/gap"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "The gap CSS property is a shorthand property for row-gap and column-gap specifying the gutters between grid rows and columns."
        },
        {
            "name": "hanging-punctuation",
            "syntax": "none | [ first || [ force-end | allow-end ] || last ]",
            "relevance": 50,
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/hanging-punctuation"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The hanging-punctuation CSS property specifies whether a punctuation mark should hang at the start or end of a line of text. Hanging punctuation may be placed outside the line box."
        },
        {
            "name": "hyphenate-character",
            "syntax": "auto | <string>",
            "relevance": 50,
            "browsers": [
                "E106",
                "FF98",
                "FFA98",
                "S17",
                "SM17",
                "C106",
                "CA106",
                "O92"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/hyphenate-character"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-09-18"
            },
            "description": "A hyphenate character used at the end of a line."
        },
        {
            "name": "hyphenate-limit-chars",
            "syntax": "[ auto | <integer> ]{1,3}",
            "relevance": 50,
            "browsers": [
                "E109",
                "FF137",
                "FFA137",
                "C109",
                "CA109",
                "O95"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/hyphenate-limit-chars"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The hyphenate-limit-chars CSS property specifies the minimum word length to allow hyphenation of words as well as the minimum number of characters before and after the hyphen."
        },
        {
            "name": "image-resolution",
            "status": "experimental",
            "syntax": "[ from-image || <resolution> ] && snap?",
            "relevance": 50,
            "description": "The image-resolution property specifies the intrinsic resolution of all raster images used in or on the element. It affects both content images (e.g. replaced elements and generated content) and decorative images (such as background-image). The intrinsic resolution of an image is used to determine the image\u2019s intrinsic dimensions."
        },
        {
            "name": "initial-letter",
            "syntax": "normal | [ <number> <integer>? ]",
            "relevance": 50,
            "browsers": [
                "E110",
                "C110",
                "CA110",
                "O96"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/initial-letter"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The initial-letter CSS property specifies styling for dropped, raised, and sunken initial letters."
        },
        {
            "name": "initial-letter-align",
            "status": "experimental",
            "syntax": "[ auto | alphabetic | hanging | ideographic ]",
            "relevance": 50,
            "description": "The initial-letter-align CSS property specifies the alignment of initial letters within a paragraph."
        },
        {
            "name": "inset",
            "syntax": "<'top'>{1,4}",
            "relevance": 64,
            "browsers": [
                "E87",
                "FF66",
                "FFA66",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/inset"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The inset CSS property defines the logical block and inline start and end offsets of an element, which map to physical offsets depending on the element's writing mode, directionality, and text orientation. It corresponds to the top and bottom, or right and left properties depending on the values defined for writing-mode, direction, and text-orientation."
        },
        {
            "name": "inset-block",
            "syntax": "<'top'>{1,2}",
            "relevance": 53,
            "browsers": [
                "E87",
                "FF63",
                "FFA63",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/inset-block"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The inset-block CSS property defines the logical block start and end offsets of an element, which maps to physical offsets depending on the element's writing mode, directionality, and text orientation. It corresponds to the top and bottom, or right and left properties depending on the values defined for writing-mode, direction, and text-orientation."
        },
        {
            "name": "inset-block-end",
            "syntax": "<'top'>",
            "relevance": 53,
            "browsers": [
                "E87",
                "FF63",
                "FFA63",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/inset-block-end"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The inset-block-end CSS property defines the logical block end offset of an element, which maps to a physical offset depending on the element's writing mode, directionality, and text orientation. It corresponds to the top, right, bottom, or left property depending on the values defined for writing-mode, direction, and text-orientation."
        },
        {
            "name": "inset-block-start",
            "syntax": "<'top'>",
            "relevance": 54,
            "browsers": [
                "E87",
                "FF63",
                "FFA63",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/inset-block-start"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The inset-block-start CSS property defines the logical block start offset of an element, which maps to a physical offset depending on the element's writing mode, directionality, and text orientation. It corresponds to the top, right, bottom, or left property depending on the values defined for writing-mode, direction, and text-orientation."
        },
        {
            "name": "inset-inline",
            "syntax": "<'top'>{1,2}",
            "relevance": 53,
            "browsers": [
                "E87",
                "FF63",
                "FFA63",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/inset-inline"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The inset-inline CSS property defines the logical block start and end offsets of an element, which maps to physical offsets depending on the element's writing mode, directionality, and text orientation. It corresponds to the top and bottom, or right and left properties depending on the values defined for writing-mode, direction, and text-orientation."
        },
        {
            "name": "inset-inline-end",
            "syntax": "<'top'>",
            "relevance": 54,
            "browsers": [
                "E87",
                "FF63",
                "FFA63",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/inset-inline-end"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The inset-inline-end CSS property defines the logical inline end inset of an element, which maps to a physical inset depending on the element's writing mode, directionality, and text orientation. It corresponds to the top, right, bottom, or left property depending on the values defined for writing-mode, direction, and text-orientation."
        },
        {
            "name": "inset-inline-start",
            "syntax": "<'top'>",
            "relevance": 55,
            "browsers": [
                "E87",
                "FF63",
                "FFA63",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/inset-inline-start"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The inset-inline-start CSS property defines the logical inline start inset of an element, which maps to a physical offset depending on the element's writing mode, directionality, and text orientation. It corresponds to the top, right, bottom, or left property depending on the values defined for writing-mode, direction, and text-orientation."
        },
        {
            "name": "interpolate-size",
            "status": "experimental",
            "syntax": "numeric-only | allow-keywords",
            "values": [
                {
                    "name": "numeric-only"
                },
                {
                    "name": "allow-keywords"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E129",
                "C129",
                "CA129",
                "O115"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/interpolate-size"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The interpolate-size CSS property allows you to enable animations and transitions between a <length-percentage> value and an intrinsic size value such as auto, fit-content, or max-content."
        },
        {
            "name": "justify-tracks",
            "status": "nonstandard",
            "syntax": "[ normal | <content-distribution> | <overflow-position>? [ <content-position> | left | right ] ]#",
            "relevance": 0,
            "description": "The justify-tracks CSS property sets the alignment in the masonry axis for grid containers that have masonry in their inline axis"
        },
        {
            "name": "line-clamp",
            "syntax": "none | <integer>",
            "relevance": 50,
            "browsers": [
                "S18.2",
                "SM18.2",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/line-clamp"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The line-clamp property allows limiting the contents of a block container to the specified number of lines; remaining content is fragmented away and neither rendered nor measured. Optionally, it also allows inserting content into the last line box to indicate the continuity of truncated/interrupted content."
        },
        {
            "name": "line-height-step",
            "status": "experimental",
            "syntax": "<length>",
            "relevance": 50,
            "description": "The line-height-step CSS property defines the step units for line box heights. When the step unit is positive, line box heights are rounded up to the closest multiple of the unit. Negative values are invalid."
        },
        {
            "name": "margin-block",
            "syntax": "<'margin-top'>{1,2}",
            "relevance": 55,
            "browsers": [
                "E87",
                "FF66",
                "FFA66",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/margin-block"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The margin-block CSS property defines the logical block start and end margins of an element, which maps to physical margins depending on the element's writing mode, directionality, and text orientation."
        },
        {
            "name": "margin-inline",
            "syntax": "<'margin-top'>{1,2}",
            "relevance": 55,
            "browsers": [
                "E87",
                "FF66",
                "FFA66",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/margin-inline"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The margin-inline CSS property defines the logical inline start and end margins of an element, which maps to physical margins depending on the element's writing mode, directionality, and text orientation."
        },
        {
            "name": "margin-trim",
            "status": "experimental",
            "syntax": "none | in-flow | all",
            "values": [
                {
                    "name": "none"
                },
                {
                    "name": "in-flow"
                },
                {
                    "name": "all"
                }
            ],
            "relevance": 50,
            "browsers": [
                "S16.4",
                "SM16.4"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/margin-trim"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The margin-trim property allows the container to trim the margins of its children where they adjoin the container\u2019s edges."
        },
        {
            "name": "mask",
            "syntax": "<mask-layer>#",
            "relevance": 58,
            "browsers": [
                "E120",
                "FF53",
                "FFA53",
                "S15.4",
                "SM15.4",
                "C120",
                "CA120",
                "O106"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-12-07"
            },
            "description": "The mask CSS property alters the visibility of an element by either partially or fully hiding it. This is accomplished by either masking or clipping the image at specific points."
        },
        {
            "name": "mask-border",
            "syntax": "<'mask-border-source'> || <'mask-border-slice'> [ / <'mask-border-width'>? [ / <'mask-border-outset'> ]? ]? || <'mask-border-repeat'> || <'mask-border-mode'>",
            "relevance": 50,
            "browsers": [
                "S17.2",
                "SM17.2",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask-border"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The mask-border CSS property lets you create a mask along the edge of an element's border.\n\nThis property is a shorthand for mask-border-source, mask-border-slice, mask-border-width, mask-border-outset, mask-border-repeat, and mask-border-mode. As with all shorthand properties, any omitted sub-values will be set to their initial value."
        },
        {
            "name": "mask-border-mode",
            "syntax": "luminance | alpha",
            "values": [
                {
                    "name": "luminance"
                },
                {
                    "name": "alpha"
                }
            ],
            "relevance": 50,
            "description": "The mask-border-mode CSS property specifies the blending mode used in a mask border."
        },
        {
            "name": "mask-border-outset",
            "syntax": "[ <length> | <number> ]{1,4}",
            "relevance": 50,
            "browsers": [
                "S17.2",
                "SM17.2",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask-border-outset"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The mask-border-outset CSS property specifies the distance by which an element's mask border is set out from its border box."
        },
        {
            "name": "mask-border-repeat",
            "syntax": "[ stretch | repeat | round | space ]{1,2}",
            "relevance": 50,
            "browsers": [
                "S17.2",
                "SM17.2",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask-border-repeat"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The mask-border-repeat CSS property defines how the edge regions of a source image are adjusted to fit the dimensions of an element's mask border."
        },
        {
            "name": "mask-border-slice",
            "syntax": "<number-percentage>{1,4} fill?",
            "relevance": 50,
            "browsers": [
                "S17.2",
                "SM17.2",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask-border-slice"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The mask-border-slice CSS property divides the image specified by mask-border-source into regions. These regions are used to form the components of an element's mask border."
        },
        {
            "name": "mask-border-source",
            "syntax": "none | <image>",
            "relevance": 50,
            "browsers": [
                "S17.2",
                "SM17.2",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask-border-source"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The mask-border-source CSS property specifies the source image used to create an element's mask border.\n\nThe mask-border-slice property is used to divide the source image into regions, which are then dynamically applied to the final mask border."
        },
        {
            "name": "mask-border-width",
            "syntax": "[ <length-percentage> | <number> | auto ]{1,4}",
            "relevance": 50,
            "browsers": [
                "S17.2",
                "SM17.2",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask-border-width"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The mask-border-width CSS property specifies the width of an element's mask border."
        },
        {
            "name": "mask-clip",
            "syntax": "[ <coord-box> | no-clip ]#",
            "relevance": 50,
            "browsers": [
                "E120",
                "FF53",
                "FFA53",
                "S15.4",
                "SM15.4",
                "C120",
                "CA120",
                "O106"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask-clip"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-12-07"
            },
            "description": "The mask-clip CSS property determines the area, which is affected by a mask. The painted content of an element must be restricted to this area."
        },
        {
            "name": "mask-composite",
            "syntax": "<compositing-operator>#",
            "relevance": 54,
            "browsers": [
                "E120",
                "FF53",
                "FFA53",
                "S15.4",
                "SM15.4",
                "C120",
                "CA120",
                "O106"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/mask-composite"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-12-07"
            },
            "description": "The mask-composite CSS property represents a compositing operation used on the current mask layer with the mask layers below it."
        },
        {
            "name": "masonry-auto-flow",
            "status": "nonstandard",
            "syntax": "[ pack | next ] || [ definite-first | ordered ]",
            "relevance": 0,
            "description": "The masonry-auto-flow CSS property modifies how items are placed when using masonry in CSS Grid Layout."
        },
        {
            "name": "math-depth",
            "syntax": "auto-add | add(<integer>) | <integer>",
            "relevance": 50,
            "browsers": [
                "E109",
                "FF117",
                "FFA117",
                "C109",
                "CA109",
                "O95"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/math-depth"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Describe a notion of \"depth\" for each element of a mathematical formula, with respect to the top-level container of that formula."
        },
        {
            "name": "math-shift",
            "status": "experimental",
            "syntax": "normal | compact",
            "values": [
                {
                    "name": "normal"
                },
                {
                    "name": "compact"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E109",
                "C109",
                "CA109",
                "O95"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/math-shift"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Used for positioning superscript during the layout of MathML scripted elements."
        },
        {
            "name": "math-style",
            "syntax": "normal | compact",
            "values": [
                {
                    "name": "normal"
                },
                {
                    "name": "compact"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E109",
                "FF117",
                "FFA117",
                "S14.1",
                "SM14.5",
                "C109",
                "CA109",
                "O95"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/math-style"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-08-29"
            },
            "description": "The math-style property indicates whether MathML equations should render with normal or compact height."
        },
        {
            "name": "max-lines",
            "status": "experimental",
            "syntax": "none | <integer>",
            "relevance": 50,
            "description": "The max-lines property forces a break after a set number of lines"
        },
        {
            "name": "object-view-box",
            "status": "experimental",
            "syntax": "none | <basic-shape-rect>",
            "relevance": 50,
            "browsers": [
                "E104",
                "C104",
                "CA104",
                "O90"
            ],
            "baseline": {
                "status": "false"
            },
            "description": ""
        },
        {
            "name": "offset",
            "syntax": "[ <'offset-position'>? [ <'offset-path'> [ <'offset-distance'> || <'offset-rotate'> ]? ]? ]! [ / <'offset-anchor'> ]?",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF72",
                "FFA79",
                "S16",
                "SM16",
                "C55",
                "CA55",
                "O42"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/offset"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-09-12",
                "baseline_high_date": "2025-03-12"
            },
            "description": "The offset CSS property is a shorthand property for animating an element along a defined path."
        },
        {
            "name": "offset-anchor",
            "syntax": "auto | <position>",
            "relevance": 50,
            "browsers": [
                "E116",
                "FF72",
                "FFA79",
                "S16",
                "SM16",
                "C116",
                "CA116",
                "O102"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/offset-anchor"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-08-21"
            },
            "description": "Defines an anchor point of the box positioned along the path. The anchor point specifies the point of the box which is to be considered as the point that is moved along the path."
        },
        {
            "name": "offset-distance",
            "syntax": "<length-percentage>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF72",
                "FFA79",
                "S16",
                "SM16",
                "C55",
                "CA55",
                "O42"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/offset-distance"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-09-12",
                "baseline_high_date": "2025-03-12"
            },
            "description": "The offset-distance CSS property specifies a position along an offset-path."
        },
        {
            "name": "offset-path",
            "syntax": "none | <offset-path> || <coord-box>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF72",
                "FFA79",
                "S15.4",
                "SM15.4",
                "C55",
                "CA55",
                "O45"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/offset-path"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-03-14",
                "baseline_high_date": "2024-09-14"
            },
            "description": 'The offset-path CSS property specifies the offset path where the element gets positioned. The exact element\u2019s position on the offset path is determined by the offset-distance property. An offset path is either a specified path with one or multiple sub-paths or the geometry of a not-styled basic shape. Each shape or path must define an initial position for the computed value of "0" for offset-distance and an initial direction which specifies the rotation of the object to the initial position.\n\nIn this specification, a direction (or rotation) of 0 degrees is equivalent to the direction of the positive x-axis in the object\u2019s local coordinate system. In other words, a rotation of 0 degree points to the right side of the UA if the object and its ancestors have no transformation applied.'
        },
        {
            "name": "offset-position",
            "syntax": "normal | auto | <position>",
            "relevance": 50,
            "browsers": [
                "E116",
                "FF122",
                "FFA122",
                "S16",
                "SM16",
                "C116",
                "CA116",
                "O102"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/offset-position"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-01-23"
            },
            "description": "Specifies the initial position of the offset path. If position is specified with static, offset-position would be ignored."
        },
        {
            "name": "offset-rotate",
            "syntax": "[ auto | reverse ] || <angle>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF72",
                "FFA79",
                "S16",
                "SM16",
                "C56",
                "CA56",
                "O43"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/offset-rotate"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-09-12",
                "baseline_high_date": "2025-03-12"
            },
            "description": "The offset-rotate CSS property defines the direction of the element while positioning along the offset path."
        },
        {
            "name": "overflow-anchor",
            "syntax": "auto | none",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "none"
                }
            ],
            "relevance": 52,
            "browsers": [
                "E79",
                "FF66",
                "FFA66",
                "Spreview",
                "C56",
                "CA56",
                "O43"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/overflow-anchor"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The overflow-anchor CSS property provides a way to opt out browser scroll anchoring behavior which adjusts scroll position to minimize content shifts."
        },
        {
            "name": "overflow-block",
            "syntax": "visible | hidden | clip | scroll | auto",
            "values": [
                {
                    "name": "visible"
                },
                {
                    "name": "hidden"
                },
                {
                    "name": "clip"
                },
                {
                    "name": "scroll"
                },
                {
                    "name": "auto"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E135",
                "FF69",
                "FFA79",
                "C135",
                "CA135",
                "O120"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/overflow-block"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The overflow-block CSS media feature can be used to test how the output device handles content that overflows the initial containing block along the block axis."
        },
        {
            "name": "overflow-clip-box",
            "status": "nonstandard",
            "syntax": "padding-box | content-box",
            "values": [
                {
                    "name": "padding-box"
                },
                {
                    "name": "content-box"
                }
            ],
            "relevance": 0,
            "description": "The overflow-clip-box CSS property specifies relative to which box the clipping happens when there is an overflow. It is short hand for the overflow-clip-box-inline and overflow-clip-box-block properties."
        },
        {
            "name": "overflow-clip-margin",
            "syntax": "<visual-box> || <length [0,\u221E]>",
            "relevance": 50,
            "browsers": [
                "O76"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/overflow-clip-margin"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The overflow-clip-margin CSS property determines how far outside its bounds an element with overflow: clip may be painted before being clipped."
        },
        {
            "name": "overflow-inline",
            "syntax": "visible | hidden | clip | scroll | auto",
            "values": [
                {
                    "name": "visible"
                },
                {
                    "name": "hidden"
                },
                {
                    "name": "clip"
                },
                {
                    "name": "scroll"
                },
                {
                    "name": "auto"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E135",
                "FF69",
                "FFA79",
                "C135",
                "CA135",
                "O120"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/overflow-inline"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The overflow-inline CSS media feature can be used to test how the output device handles content that overflows the initial containing block along the inline axis."
        },
        {
            "name": "overlay",
            "status": "experimental",
            "syntax": "none | auto",
            "values": [
                {
                    "name": "none"
                },
                {
                    "name": "auto"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E117",
                "C117",
                "CA117",
                "O103"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/overlay"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The overlay CSS property specifies whether an element appearing in the top layer (for example, a shown popover or modal {{htmlelement(\"dialog\")}} element) is actually rendered in the top layer. This property is only relevant within a list of transition-property values, and only if allow-discrete is set as the transition-behavior."
        },
        {
            "name": "overscroll-behavior",
            "syntax": "[ contain | none | auto ]{1,2}",
            "relevance": 50,
            "browsers": [
                "E18",
                "FF59",
                "FFA59",
                "S16",
                "SM16",
                "C63",
                "CA63",
                "O50"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/overscroll-behavior"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-09-12",
                "baseline_high_date": "2025-03-12"
            },
            "description": "The overscroll-behavior CSS property is shorthand for the overscroll-behavior-x and overscroll-behavior-y properties, which allow you to control the browser's scroll overflow behavior \u2014 what happens when the boundary of a scrolling area is reached."
        },
        {
            "name": "overscroll-behavior-block",
            "syntax": "contain | none | auto",
            "values": [
                {
                    "name": "contain"
                },
                {
                    "name": "none"
                },
                {
                    "name": "auto"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E79",
                "FF73",
                "FFA79",
                "S16",
                "SM16",
                "C77",
                "CA77",
                "O64"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/overscroll-behavior-block"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-09-12",
                "baseline_high_date": "2025-03-12"
            },
            "description": "The overscroll-behavior-block CSS property sets the browser's behavior when the block direction boundary of a scrolling area is reached."
        },
        {
            "name": "overscroll-behavior-inline",
            "syntax": "contain | none | auto",
            "values": [
                {
                    "name": "contain"
                },
                {
                    "name": "none"
                },
                {
                    "name": "auto"
                }
            ],
            "relevance": 51,
            "browsers": [
                "E79",
                "FF73",
                "FFA79",
                "S16",
                "SM16",
                "C77",
                "CA77",
                "O64"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/overscroll-behavior-inline"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-09-12",
                "baseline_high_date": "2025-03-12"
            },
            "description": "The overscroll-behavior-inline CSS property sets the browser's behavior when the inline direction boundary of a scrolling area is reached."
        },
        {
            "name": "overscroll-behavior-x",
            "syntax": "contain | none | auto",
            "values": [
                {
                    "name": "contain"
                },
                {
                    "name": "none"
                },
                {
                    "name": "auto"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E18",
                "FF59",
                "FFA59",
                "S16",
                "SM16",
                "C63",
                "CA63",
                "O50"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/overscroll-behavior-x"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-09-12",
                "baseline_high_date": "2025-03-12"
            },
            "description": "The overscroll-behavior-x CSS property is allows you to control the browser's scroll overflow behavior \u2014 what happens when the boundary of a scrolling area is reached \u2014 in the x axis direction."
        },
        {
            "name": "overscroll-behavior-y",
            "syntax": "contain | none | auto",
            "values": [
                {
                    "name": "contain"
                },
                {
                    "name": "none"
                },
                {
                    "name": "auto"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E18",
                "FF59",
                "FFA59",
                "S16",
                "SM16",
                "C63",
                "CA63",
                "O50"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/overscroll-behavior-y"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-09-12",
                "baseline_high_date": "2025-03-12"
            },
            "description": "The overscroll-behavior-y CSS property is allows you to control the browser's scroll overflow behavior \u2014 what happens when the boundary of a scrolling area is reached \u2014 in the y axis direction."
        },
        {
            "name": "padding-block",
            "syntax": "<'padding-top'>{1,2}",
            "relevance": 57,
            "browsers": [
                "E87",
                "FF66",
                "FFA66",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/padding-block"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The padding-block CSS property defines the logical block start and end padding of an element, which maps to physical padding properties depending on the element's writing mode, directionality, and text orientation."
        },
        {
            "name": "padding-inline",
            "syntax": "<'padding-top'>{1,2}",
            "relevance": 57,
            "browsers": [
                "E87",
                "FF66",
                "FFA66",
                "S14.1",
                "SM14.5",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/padding-inline"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The padding-inline CSS property defines the logical inline start and end padding of an element, which maps to physical padding properties depending on the element's writing mode, directionality, and text orientation."
        },
        {
            "name": "page",
            "syntax": "auto | <custom-ident>",
            "relevance": 50,
            "browsers": [
                "E85",
                "FF110",
                "FFA110",
                "S1",
                "SM1",
                "C85",
                "CA85",
                "O71"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/page"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-02-14"
            },
            "description": "The page CSS property is used to specify the named page, a specific type of page defined by the @page at-rule."
        },
        {
            "name": "place-content",
            "syntax": "<'align-content'> <'justify-content'>?",
            "relevance": 56,
            "browsers": [
                "E79",
                "FF45",
                "FFA45",
                "S9",
                "SM9",
                "C59",
                "CA59",
                "O46"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/place-content"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "The place-content CSS shorthand property sets both the align-content and justify-content properties."
        },
        {
            "name": "place-items",
            "syntax": "<'align-items'> <'justify-items'>?",
            "relevance": 56,
            "browsers": [
                "E79",
                "FF45",
                "FFA45",
                "S11",
                "SM11",
                "C59",
                "CA59",
                "O46"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/place-items"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "The CSS place-items shorthand property sets both the align-items and justify-items properties. The first value is the align-items property value, the second the justify-items one. If the second value is not present, the first value is also used for it."
        },
        {
            "name": "place-self",
            "syntax": "<'align-self'> <'justify-self'>?",
            "relevance": 51,
            "browsers": [
                "E79",
                "FF45",
                "FFA45",
                "S11",
                "SM11",
                "C59",
                "CA59",
                "O46"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/place-self"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "The place-self CSS property is a shorthand property sets both the align-self and justify-self properties. The first value is the align-self property value, the second the justify-self one. If the second value is not present, the first value is also used for it."
        },
        {
            "name": "position-anchor",
            "status": "experimental",
            "syntax": "auto | <anchor-name>",
            "relevance": 50,
            "browsers": [
                "E125",
                "C125",
                "CA125",
                "O111"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/position-anchor"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The position-anchor property defines the default anchor specifier for all anchor functions on the element, allowing multiple elements to use the same set of anchor functions (and position options lists!) while changing which anchor element each is referring to."
        },
        {
            "name": "position-area",
            "status": "experimental",
            "syntax": "none | <position-area>",
            "relevance": 50,
            "browsers": [
                "E129",
                "C129",
                "CA129",
                "O115"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/position-area"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The position-area CSS property enables an anchor-positioned element to be positioned relative to the edges of its associated anchor element by placing the positioned element on one or more tiles of an implicit 3x3 grid, where the anchoring element is the center cell."
        },
        {
            "name": "position-try",
            "status": "experimental",
            "syntax": "<'position-try-order'>? <'position-try-fallbacks'>",
            "relevance": 50,
            "browsers": [
                "E125",
                "C125",
                "CA125",
                "O111"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/position-try"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "This shorthand sets both position-try-options and position-try-order. If <'position-try-order'> is omitted, it\u2019s set to the property\u2019s initial value."
        },
        {
            "name": "position-try-fallbacks",
            "status": "experimental",
            "syntax": "none | [ [<dashed-ident> || <try-tactic>] | <'position-area'> ]#",
            "relevance": 50,
            "browsers": [
                "E128",
                "C128",
                "CA128",
                "O114"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/position-try-fallbacks"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The position-try-fallbacks CSS property enables you to specify a list of one or more alternative position try fallback options for anchor-positioned elements to be placed relative to their associated anchor elements. When the element would otherwise overflow its inset-modified containing block, the browser will try placing the positioned element in these different fallback positions, in the order provided, until it finds a value that stops it from overflowing its container or the viewport."
        },
        {
            "name": "position-try-order",
            "status": "experimental",
            "syntax": "normal | <try-size>",
            "relevance": 50,
            "browsers": [
                "E125",
                "C125",
                "CA125",
                "O111"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/position-try-order"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "This property specifies the order in which the position options list will be tried."
        },
        {
            "name": "position-visibility",
            "status": "experimental",
            "syntax": "always | [ anchors-valid || anchors-visible || no-overflow ]",
            "relevance": 50,
            "browsers": [
                "E125",
                "C125",
                "CA125",
                "O111"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/position-visibility"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "There are times when an element\u2019s anchors are not appropriate for positioning the element with, and it would be better to simply not display the element at all. position-visibility provides several conditions where this could be the case."
        },
        {
            "name": "print-color-adjust",
            "syntax": "economy | exact",
            "values": [
                {
                    "name": "economy"
                },
                {
                    "name": "exact"
                }
            ],
            "relevance": 51,
            "browsers": [
                "FF97",
                "FFA97",
                "S15.4",
                "SM15.4",
                "C136",
                "CA136",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/print-color-adjust"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Defines what optimization the user agent is allowed to do when adjusting the appearance for an output device."
        },
        {
            "name": "r",
            "syntax": "<length> | <percentage>",
            "relevance": 52,
            "browsers": [
                "E79",
                "FF69",
                "FFA79",
                "S9",
                "SM9",
                "C43",
                "CA43",
                "O30"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/r"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-07-28",
                "baseline_high_date": "2023-01-28"
            },
            "description": "The r CSS property defines the radius of a circle. It can only be used with the SVG circle element. If present, it overrides the circle's r attribute."
        },
        {
            "name": "rotate",
            "syntax": "none | <angle> | [ x | y | z | <number>{3} ] && <angle>",
            "relevance": 52,
            "browsers": [
                "E104",
                "FF72",
                "FFA79",
                "S14.1",
                "SM14.5",
                "C104",
                "CA104",
                "O90"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/rotate"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-08-05",
                "baseline_high_date": "2025-02-05"
            },
            "description": "The rotate CSS property allows you to specify rotation transforms individually and independently of the transform property. This maps better to typical user interface usage, and saves having to remember the exact order of transform functions to specify in the transform value."
        },
        {
            "name": "row-gap",
            "syntax": "normal | <length-percentage>",
            "relevance": 60,
            "browsers": [
                "E16",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C47",
                "CA47",
                "O34"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/row-gap"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2017-10-17",
                "baseline_high_date": "2020-04-17"
            },
            "description": "The row-gap CSS property specifies the gutter between grid rows."
        },
        {
            "name": "ruby-merge",
            "status": "experimental",
            "syntax": "separate | collapse | auto",
            "values": [
                {
                    "name": "separate"
                },
                {
                    "name": "collapse"
                },
                {
                    "name": "auto"
                }
            ],
            "relevance": 50,
            "description": "This property controls how ruby annotation boxes should be rendered when there are more than one in a ruby container box: whether each pair should be kept separate, the annotations should be collapsed and rendered as a group, or the separation should be determined based on the space available."
        },
        {
            "name": "rx",
            "syntax": "<length> | <percentage>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF69",
                "FFA79",
                "C43",
                "CA43",
                "O30"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/rx"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The rx CSS property defines the x-axis, or horizontal, radius of an SVG ellipse and the horizontal curve of the corners of an SVG rect rectangle. If present, it overrides the shape's rx attribute."
        },
        {
            "name": "ry",
            "syntax": "<length> | <percentage>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF69",
                "FFA79",
                "C43",
                "CA43",
                "O30"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/ry"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The ry CSS property defines the y-axis, or vertical, radius of an SVG ellipse and the vertical curve of the corners of an SVG rect rectangle. If present, it overrides the shape's ry attribute."
        },
        {
            "name": "scale",
            "syntax": "none | [ <number> | <percentage> ]{1,3}",
            "relevance": 52,
            "browsers": [
                "E104",
                "FF72",
                "FFA79",
                "S14.1",
                "SM14.5",
                "C104",
                "CA104",
                "O90"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scale"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-08-05",
                "baseline_high_date": "2025-02-05"
            },
            "description": "The scale CSS property allows you to specify scale transforms individually and independently of the transform property. This maps better to typical user interface usage, and saves having to remember the exact order of transform functions to specify in the transform value."
        },
        {
            "name": "scroll-initial-target",
            "status": "experimental",
            "syntax": "none | nearest",
            "values": [
                {
                    "name": "none"
                },
                {
                    "name": "nearest"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E133",
                "C133",
                "CA133",
                "O118"
            ],
            "baseline": {
                "status": "false"
            },
            "description": ""
        },
        {
            "name": "scroll-margin",
            "syntax": "<length>{1,4}",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF90",
                "FFA90",
                "S14.1",
                "SM14.5",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-margin"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-07-13",
                "baseline_high_date": "2024-01-13"
            },
            "description": "The scroll-margin property is a shorthand property which sets all of the scroll-margin longhands, assigning values much like the margin property does for the margin-* longhands."
        },
        {
            "name": "scroll-margin-block",
            "syntax": "<length>{1,2}",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S15",
                "SM15",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-margin-block"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The scroll-margin-block property is a shorthand property which sets the scroll-margin longhands in the block dimension."
        },
        {
            "name": "scroll-margin-block-end",
            "syntax": "<length>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S15",
                "SM15",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-margin-block-end"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The scroll-margin-block-end property defines the margin of the scroll snap area at the end of the block dimension that is used for snapping this box to the snapport. The scroll snap area is determined by taking the transformed border box, finding its rectangular bounding box (axis-aligned in the scroll container\u2019s coordinate space), then adding the specified outsets."
        },
        {
            "name": "scroll-margin-block-start",
            "syntax": "<length>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S15",
                "SM15",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-margin-block-start"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The scroll-margin-block-start property defines the margin of the scroll snap area at the start of the block dimension that is used for snapping this box to the snapport. The scroll snap area is determined by taking the transformed border box, finding its rectangular bounding box (axis-aligned in the scroll container\u2019s coordinate space), then adding the specified outsets."
        },
        {
            "name": "scroll-margin-bottom",
            "syntax": "<length>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S14.1",
                "SM14.5",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-margin-bottom"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The scroll-margin-bottom property defines the bottom margin of the scroll snap area that is used for snapping this box to the snapport. The scroll snap area is determined by taking the transformed border box, finding its rectangular bounding box (axis-aligned in the scroll container\u2019s coordinate space), then adding the specified outsets."
        },
        {
            "name": "scroll-margin-inline",
            "syntax": "<length>{1,2}",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S15",
                "SM15",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-margin-inline"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The scroll-margin-inline property is a shorthand property which sets the scroll-margin longhands in the inline dimension."
        },
        {
            "name": "scroll-margin-inline-end",
            "syntax": "<length>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S15",
                "SM15",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-margin-inline-end"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The scroll-margin-inline-end property defines the margin of the scroll snap area at the end of the inline dimension that is used for snapping this box to the snapport. The scroll snap area is determined by taking the transformed border box, finding its rectangular bounding box (axis-aligned in the scroll container\u2019s coordinate space), then adding the specified outsets."
        },
        {
            "name": "scroll-margin-inline-start",
            "syntax": "<length>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S15",
                "SM15",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-margin-inline-start"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The scroll-margin-inline-start property defines the margin of the scroll snap area at the start of the inline dimension that is used for snapping this box to the snapport. The scroll snap area is determined by taking the transformed border box, finding its rectangular bounding box (axis-aligned in the scroll container\u2019s coordinate space), then adding the specified outsets."
        },
        {
            "name": "scroll-margin-left",
            "syntax": "<length>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S14.1",
                "SM14.5",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-margin-left"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The scroll-margin-left property defines the left margin of the scroll snap area that is used for snapping this box to the snapport. The scroll snap area is determined by taking the transformed border box, finding its rectangular bounding box (axis-aligned in the scroll container\u2019s coordinate space), then adding the specified outsets."
        },
        {
            "name": "scroll-margin-right",
            "syntax": "<length>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S14.1",
                "SM14.5",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-margin-right"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The scroll-margin-right property defines the right margin of the scroll snap area that is used for snapping this box to the snapport. The scroll snap area is determined by taking the transformed border box, finding its rectangular bounding box (axis-aligned in the scroll container\u2019s coordinate space), then adding the specified outsets."
        },
        {
            "name": "scroll-margin-top",
            "syntax": "<length>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S14.1",
                "SM14.5",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-margin-top"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The scroll-margin-top property defines the top margin of the scroll snap area that is used for snapping this box to the snapport. The scroll snap area is determined by taking the transformed border box, finding its rectangular bounding box (axis-aligned in the scroll container\u2019s coordinate space), then adding the specified outsets."
        },
        {
            "name": "scroll-padding",
            "syntax": "[ auto | <length-percentage> ]{1,4}",
            "relevance": 53,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S14.1",
                "SM14.5",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-padding"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The scroll-padding property is a shorthand property which sets all of the scroll-padding longhands, assigning values much like the padding property does for the padding-* longhands."
        },
        {
            "name": "scroll-padding-block",
            "syntax": "[ auto | <length-percentage> ]{1,2}",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S15",
                "SM15",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-padding-block"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The scroll-padding-block property is a shorthand property which sets the scroll-padding longhands for the block dimension."
        },
        {
            "name": "scroll-padding-block-end",
            "syntax": "auto | <length-percentage>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S15",
                "SM15",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-padding-block-end"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The scroll-padding-block-end property defines offsets for the end edge in the block dimension of the optimal viewing region of the scrollport: the region used as the target region for placing things in view of the user. This allows the author to exclude regions of the scrollport that are obscured by other content (such as fixed-positioned toolbars or sidebars) or simply to put more breathing room between a targeted element and the edges of the scrollport."
        },
        {
            "name": "scroll-padding-block-start",
            "syntax": "auto | <length-percentage>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S15",
                "SM15",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-padding-block-start"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The scroll-padding-block-start property defines offsets for the start edge in the block dimension of the optimal viewing region of the scrollport: the region used as the target region for placing things in view of the user. This allows the author to exclude regions of the scrollport that are obscured by other content (such as fixed-positioned toolbars or sidebars) or simply to put more breathing room between a targeted element and the edges of the scrollport."
        },
        {
            "name": "scroll-padding-bottom",
            "syntax": "auto | <length-percentage>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S14.1",
                "SM14.5",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-padding-bottom"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The scroll-padding-bottom property defines offsets for the bottom of the optimal viewing region of the scrollport: the region used as the target region for placing things in view of the user. This allows the author to exclude regions of the scrollport that are obscured by other content (such as fixed-positioned toolbars or sidebars) or simply to put more breathing room between a targeted element and the edges of the scrollport."
        },
        {
            "name": "scroll-padding-inline",
            "syntax": "[ auto | <length-percentage> ]{1,2}",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S15",
                "SM15",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-padding-inline"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The scroll-padding-inline property is a shorthand property which sets the scroll-padding longhands for the inline dimension."
        },
        {
            "name": "scroll-padding-inline-end",
            "syntax": "auto | <length-percentage>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S15",
                "SM15",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-padding-inline-end"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The scroll-padding-inline-end property defines offsets for the end edge in the inline dimension of the optimal viewing region of the scrollport: the region used as the target region for placing things in view of the user. This allows the author to exclude regions of the scrollport that are obscured by other content (such as fixed-positioned toolbars or sidebars) or simply to put more breathing room between a targeted element and the edges of the scrollport."
        },
        {
            "name": "scroll-padding-inline-start",
            "syntax": "auto | <length-percentage>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S15",
                "SM15",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-padding-inline-start"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-09-20",
                "baseline_high_date": "2024-03-20"
            },
            "description": "The scroll-padding-inline-start property defines offsets for the start edge in the inline dimension of the optimal viewing region of the scrollport: the region used as the target region for placing things in view of the user. This allows the author to exclude regions of the scrollport that are obscured by other content (such as fixed-positioned toolbars or sidebars) or simply to put more breathing room between a targeted element and the edges of the scrollport."
        },
        {
            "name": "scroll-padding-left",
            "syntax": "auto | <length-percentage>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S14.1",
                "SM14.5",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-padding-left"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The scroll-padding-left property defines offsets for the left of the optimal viewing region of the scrollport: the region used as the target region for placing things in view of the user. This allows the author to exclude regions of the scrollport that are obscured by other content (such as fixed-positioned toolbars or sidebars) or simply to put more breathing room between a targeted element and the edges of the scrollport."
        },
        {
            "name": "scroll-padding-right",
            "syntax": "auto | <length-percentage>",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S14.1",
                "SM14.5",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-padding-right"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The scroll-padding-right property defines offsets for the right of the optimal viewing region of the scrollport: the region used as the target region for placing things in view of the user. This allows the author to exclude regions of the scrollport that are obscured by other content (such as fixed-positioned toolbars or sidebars) or simply to put more breathing room between a targeted element and the edges of the scrollport."
        },
        {
            "name": "scroll-padding-top",
            "syntax": "auto | <length-percentage>",
            "relevance": 51,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S14.1",
                "SM14.5",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-padding-top"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            },
            "description": "The scroll-padding-top property defines offsets for the top of the optimal viewing region of the scrollport: the region used as the target region for placing things in view of the user. This allows the author to exclude regions of the scrollport that are obscured by other content (such as fixed-positioned toolbars or sidebars) or simply to put more breathing room between a targeted element and the edges of the scrollport."
        },
        {
            "name": "scroll-snap-align",
            "syntax": "[ none | start | end | center ]{1,2}",
            "relevance": 54,
            "browsers": [
                "E79",
                "FF68",
                "FFA68",
                "S11",
                "SM11",
                "C69",
                "CA69",
                "O56"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-snap-align"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "The scroll-snap-align property specifies the box\u2019s snap position as an alignment of its snap area (as the alignment subject) within its snap container\u2019s snapport (as the alignment container). The two values specify the snapping alignment in the block axis and inline axis, respectively. If only one value is specified, the second value defaults to the same value."
        },
        {
            "name": "scroll-snap-stop",
            "syntax": "normal | always",
            "values": [
                {
                    "name": "normal"
                },
                {
                    "name": "always"
                }
            ],
            "relevance": 52,
            "browsers": [
                "E79",
                "FF103",
                "FFA103",
                "S15",
                "SM15",
                "C75",
                "CA75",
                "O62"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-snap-stop"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-07-26",
                "baseline_high_date": "2025-01-26"
            },
            "description": "The scroll-snap-stop CSS property defines whether the scroll container is allowed to \"pass over\" possible snap positions."
        },
        {
            "name": "scroll-snap-type-x",
            "status": "obsolete",
            "syntax": "none | mandatory | proximity",
            "values": [
                {
                    "name": "none"
                },
                {
                    "name": "mandatory"
                },
                {
                    "name": "proximity"
                }
            ],
            "relevance": 0,
            "description": "The scroll-snap-type-x CSS property defines how strictly snap points are enforced on the horizontal axis of the scroll container in case there is one.\n\nSpecifying any precise animations or physics used to enforce those snap points is not covered by this property but instead left up to the user agent."
        },
        {
            "name": "scroll-snap-type-y",
            "status": "obsolete",
            "syntax": "none | mandatory | proximity",
            "values": [
                {
                    "name": "none"
                },
                {
                    "name": "mandatory"
                },
                {
                    "name": "proximity"
                }
            ],
            "relevance": 0,
            "description": "The scroll-snap-type-y CSS property defines how strictly snap points are enforced on the vertical axis of the scroll container in case there is one.\n\nSpecifying any precise animations or physics used to enforce those snap points is not covered by this property but instead left up to the user agent."
        },
        {
            "name": "scroll-timeline",
            "status": "experimental",
            "syntax": "[ <'scroll-timeline-name'> <'scroll-timeline-axis'>? ]#",
            "relevance": 50,
            "browsers": [
                "E115",
                "C115",
                "CA115",
                "O101"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-timeline"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Defines a name that can be used to identify the source element of a scroll timeline, along with the scrollbar axis that should provide the timeline."
        },
        {
            "name": "scroll-timeline-axis",
            "status": "experimental",
            "syntax": "[ block | inline | x | y ]#",
            "relevance": 50,
            "browsers": [
                "E115",
                "C115",
                "CA115",
                "O101"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-timeline-axis"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Specifies the scrollbar that will be used to provide the timeline for a scroll-timeline animation"
        },
        {
            "name": "scroll-timeline-name",
            "status": "experimental",
            "syntax": "[ none | <dashed-ident> ]#",
            "relevance": 50,
            "browsers": [
                "E115",
                "C115",
                "CA115",
                "O101"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scroll-timeline-name"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Defines a name that can be used to identify an element as the source of a scroll-timeline."
        },
        {
            "name": "scrollbar-color",
            "syntax": "auto | <color>{2}",
            "relevance": 55,
            "browsers": [
                "E121",
                "FF64",
                "FFA64",
                "C121",
                "CA121",
                "O107"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scrollbar-color"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The scrollbar-color CSS property sets the color of the scrollbar track and thumb."
        },
        {
            "name": "scrollbar-gutter",
            "syntax": "auto | stable && both-edges?",
            "relevance": 54,
            "browsers": [
                "E94",
                "FF97",
                "FFA97",
                "S18.2",
                "SM18.2",
                "C94",
                "CA94",
                "O80"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scrollbar-gutter"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-12-11"
            },
            "description": "The scrollbar-gutter CSS property allows authors to reserve space for the scrollbar, preventing unwanted layout changes as the content grows while also avoiding unnecessary visuals when scrolling isn't needed."
        },
        {
            "name": "scrollbar-width",
            "syntax": "auto | thin | none",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "thin"
                },
                {
                    "name": "none"
                }
            ],
            "relevance": 68,
            "browsers": [
                "E121",
                "FF64",
                "FFA64",
                "S18.2",
                "SM18.2",
                "C121",
                "CA121",
                "O107"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/scrollbar-width"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-12-11"
            },
            "description": "The scrollbar-width property allows the author to set the maximum thickness of an element\u2019s scrollbars when they are shown. "
        },
        {
            "name": "speak-as",
            "atRule": "@counter-style",
            "syntax": "auto | bullets | numbers | words | spell-out | <counter-style-name>",
            "relevance": 50,
            "browsers": [
                "S11.1",
                "SM11.3"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/speak-as"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The speak-as descriptor specifies how a counter symbol constructed with a given @counter-style will be represented in the spoken form. For example, an author can specify a counter symbol to be either spoken as its numerical value or just represented with an audio cue."
        },
        {
            "name": "text-box",
            "syntax": "normal | <'text-box-trim'> || <'text-box-edge'>",
            "relevance": 50,
            "browsers": [
                "E133",
                "S18.2",
                "SM18.2",
                "C133",
                "CA133",
                "O118"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-box"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The text-box CSS property is a shorthand that corresponds to the text-box-trim and text-box-edge properties, which together specify the amount of space to trim from the block-start edge and block-end edge of a text element's block container."
        },
        {
            "name": "text-box-edge",
            "syntax": "auto | <text-edge>",
            "relevance": 50,
            "browsers": [
                "E133",
                "S18.2",
                "SM18.2",
                "C133",
                "CA133",
                "O118"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-box-edge"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The text-box-edge CSS property specifies an amount of space to trim from a text element's block container."
        },
        {
            "name": "text-box-trim",
            "syntax": "none | trim-start | trim-end | trim-both",
            "values": [
                {
                    "name": "none"
                },
                {
                    "name": "trim-start"
                },
                {
                    "name": "trim-end"
                },
                {
                    "name": "trim-both"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E133",
                "S18.2",
                "SM18.2",
                "C133",
                "CA133",
                "O118"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-box-trim"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The text-box-trim CSS property specifies which of the over and under edges of text content to trim from a text element's block container."
        },
        {
            "name": "text-combine-upright",
            "syntax": "none | all | [ digits <integer>? ]",
            "relevance": 50,
            "browsers": [
                "E79",
                "FF48",
                "FFA48",
                "S15.4",
                "SM15.4",
                "C48",
                "CA48",
                "IE11",
                "O35"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-combine-upright"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-03-14",
                "baseline_high_date": "2024-09-14"
            },
            "description": "The text-combine-upright CSS property specifies the combination of multiple characters into the space of a single character. If the combined text is wider than 1em, the user agent must fit the contents within 1em. The resulting composition is treated as a single upright glyph for layout and decoration. This property only has an effect in vertical writing modes.\n\nThis is used to produce an effect that is known as tate-ch\u016B-yoko (\u7E26\u4E2D\u6A2A) in Japanese, or as \u76F4\u66F8\u6A6B\u5411 in Chinese."
        },
        {
            "name": "text-decoration-skip",
            "status": "experimental",
            "syntax": "none | [ objects || [ spaces | [ leading-spaces || trailing-spaces ] ] || edges || box-decoration ]",
            "relevance": 50,
            "browsers": [
                "S12.1",
                "SM12.2",
                "O44"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-decoration-skip"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The text-decoration-skip CSS property specifies what parts of the element\u2019s content any text decoration affecting the element must skip over. It controls all text decoration lines drawn by the element and also any text decoration lines drawn by its ancestors."
        },
        {
            "name": "text-decoration-skip-ink",
            "syntax": "auto | all | none",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "all"
                },
                {
                    "name": "none"
                }
            ],
            "relevance": 51,
            "browsers": [
                "E79",
                "FF70",
                "FFA79",
                "S15.4",
                "SM15.4",
                "C64",
                "CA64",
                "O50"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-decoration-skip-ink"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-03-14",
                "baseline_high_date": "2024-09-14"
            },
            "description": "The text-decoration-skip-ink CSS property specifies how overlines and underlines are drawn when they pass over glyph ascenders and descenders."
        },
        {
            "name": "text-decoration-thickness",
            "syntax": "auto | from-font | <length> | <percentage> ",
            "relevance": 55,
            "browsers": [
                "E89",
                "FF70",
                "FFA79",
                "S12.1",
                "SM12.2",
                "C89",
                "CA89",
                "O75"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-decoration-thickness"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-03-04",
                "baseline_high_date": "2023-09-04"
            },
            "description": "The text-decoration-thickness CSS property sets the thickness, or width, of the decoration line that is used on text in an element, such as a line-through, underline, or overline."
        },
        {
            "name": "text-emphasis",
            "syntax": "<'text-emphasis-style'> || <'text-emphasis-color'>",
            "relevance": 50,
            "browsers": [
                "E99",
                "FF46",
                "FFA46",
                "S7",
                "SM7",
                "C99",
                "CA99",
                "O85"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-emphasis"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-03-03",
                "baseline_high_date": "2024-09-03"
            },
            "description": "The text-emphasis CSS property is a shorthand property for setting text-emphasis-style and text-emphasis-color in one declaration. This property will apply the specified emphasis mark to each character of the element's text, except separator characters, like spaces,  and control characters."
        },
        {
            "name": "text-emphasis-color",
            "syntax": "<color>",
            "relevance": 50,
            "browsers": [
                "E99",
                "FF46",
                "FFA46",
                "S7",
                "SM7",
                "C99",
                "CA99",
                "O85"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-emphasis-color"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-03-03",
                "baseline_high_date": "2024-09-03"
            },
            "description": "The text-emphasis-color CSS property defines the color used to draw emphasis marks on text being rendered in the HTML document. This value can also be set and reset using the text-emphasis shorthand."
        },
        {
            "name": "text-emphasis-position",
            "syntax": "auto | [ over | under ] && [ right | left ]?",
            "relevance": 50,
            "browsers": [
                "E99",
                "FF46",
                "FFA46",
                "S7",
                "SM7",
                "C99",
                "CA99",
                "O85"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-emphasis-position"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-03-03",
                "baseline_high_date": "2024-09-03"
            },
            "description": "The text-emphasis-position CSS property describes where emphasis marks are drawn at. The effect of emphasis marks on the line height is the same as for ruby text: if there isn't enough place, the line height is increased."
        },
        {
            "name": "text-emphasis-style",
            "syntax": "none | [ [ filled | open ] || [ dot | circle | double-circle | triangle | sesame ] ] | <string>",
            "relevance": 50,
            "browsers": [
                "E99",
                "FF46",
                "FFA46",
                "S7",
                "SM7",
                "C99",
                "CA99",
                "O85"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-emphasis-style"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-03-03",
                "baseline_high_date": "2024-09-03"
            },
            "description": "The text-emphasis-style CSS property defines the type of emphasis used. It can also be set, and reset, using the text-emphasis shorthand."
        },
        {
            "name": "text-size-adjust",
            "status": "experimental",
            "syntax": "none | auto | <percentage>",
            "relevance": 61,
            "browsers": [
                "E79",
                "C54",
                "CA54",
                "O41"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-size-adjust"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The text-size-adjust CSS property controls the text inflation algorithm used on some smartphones and tablets. Other browsers will ignore this property."
        },
        {
            "name": "text-spacing-trim",
            "status": "experimental",
            "syntax": "space-all | normal | space-first | trim-start",
            "values": [
                {
                    "name": "space-all"
                },
                {
                    "name": "normal"
                },
                {
                    "name": "space-first"
                },
                {
                    "name": "trim-start"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E123",
                "C123",
                "CA123",
                "O109"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-spacing-trim"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The text-spacing-trim CSS property controls the internal spacing set on Chinese/Japanese/Korean (CJK) punctuation characters between adjacent characters (kerning) and at the start or end of text lines."
        },
        {
            "name": "text-underline-offset",
            "syntax": "auto | <length> | <percentage> ",
            "relevance": 55,
            "browsers": [
                "E87",
                "FF70",
                "FFA79",
                "S12.1",
                "SM12.2",
                "C87",
                "CA87",
                "O73"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-underline-offset"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-11-19",
                "baseline_high_date": "2023-05-19"
            },
            "description": "The text-underline-offset CSS property sets the offset distance of an underline text decoration line (applied using text-decoration) from its original position."
        },
        {
            "name": "text-wrap",
            "syntax": "<'text-wrap-mode'> || <'text-wrap-style'>",
            "relevance": 58,
            "browsers": [
                "E114",
                "FF121",
                "FFA121",
                "S17.4",
                "SM17.4",
                "C114",
                "CA114",
                "O100"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-wrap"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-03-05"
            },
            "description": "The text-wrap CSS property controls how text inside an element is wrapped."
        },
        {
            "name": "text-wrap-mode",
            "syntax": "wrap | nowrap",
            "values": [
                {
                    "name": "wrap"
                },
                {
                    "name": "nowrap"
                }
            ],
            "relevance": 51,
            "browsers": [
                "E130",
                "FF124",
                "FFA124",
                "S17.4",
                "SM17.4",
                "C130",
                "CA130",
                "O115"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-wrap-mode"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-10-17"
            },
            "description": "The text-wrap-mode CSS property controls whether the text inside an element is wrapped. The different values provide alternate ways of wrapping the content of a block element. It can also be set, and reset, using the {{CSSXRef(\"text-wrap\")}} shorthand."
        },
        {
            "name": "text-wrap-style",
            "syntax": "auto | balance | stable | pretty",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "balance"
                },
                {
                    "name": "stable"
                },
                {
                    "name": "pretty"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E130",
                "FF124",
                "FFA124",
                "S17.5",
                "SM17.5",
                "C130",
                "CA130",
                "O115"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/text-wrap-style"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-10-17"
            },
            "description": "The text-wrap-style CSS property controls how text inside an element is wrapped. The different values provide alternate ways of wrapping the content of a block element. It can also be set, and reset, using the {{CSSXRef(\"text-wrap\")}} shorthand."
        },
        {
            "name": "timeline-scope",
            "status": "experimental",
            "syntax": "none | <dashed-ident>#",
            "relevance": 50,
            "browsers": [
                "E116",
                "C116",
                "CA116",
                "O102"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/timeline-scope"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The timeline-scope CSS property modifies the scope of a named animation timeline."
        },
        {
            "name": "transform-box",
            "syntax": "content-box | border-box | fill-box | stroke-box | view-box",
            "values": [
                {
                    "name": "content-box"
                },
                {
                    "name": "border-box"
                },
                {
                    "name": "fill-box"
                },
                {
                    "name": "stroke-box"
                },
                {
                    "name": "view-box"
                }
            ],
            "relevance": 51,
            "browsers": [
                "E79",
                "FF55",
                "FFA55",
                "S11",
                "SM11",
                "C64",
                "CA64",
                "O51"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/transform-box"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "The transform-box CSS property defines the layout box to which the transform and transform-origin properties relate."
        },
        {
            "name": "transition-behavior",
            "syntax": "<transition-behavior-value>#",
            "relevance": 50,
            "browsers": [
                "E117",
                "FF129",
                "FFA129",
                "S17.4",
                "SM17.4",
                "C117",
                "CA117",
                "O103"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/transition-behavior"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-08-06"
            },
            "description": "The transition-behavior CSS property specifies whether transitions will be started for properties whose animation behavior is discrete."
        },
        {
            "name": "translate",
            "syntax": "none | <length-percentage> [ <length-percentage> <length>? ]?",
            "relevance": 52,
            "browsers": [
                "E104",
                "FF72",
                "FFA79",
                "S14.1",
                "SM14.5",
                "C104",
                "CA104",
                "O90"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/translate"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-08-05",
                "baseline_high_date": "2025-02-05"
            },
            "description": "The translate CSS property allows you to specify translation transforms individually and independently of the transform property. This maps better to typical user interface usage, and saves having to remember the exact order of transform functions to specify in the transform value."
        },
        {
            "name": "vector-effect",
            "syntax": "none | non-scaling-stroke | non-scaling-size | non-rotation | fixed-position",
            "values": [
                {
                    "name": "none"
                },
                {
                    "name": "non-scaling-stroke"
                },
                {
                    "name": "non-scaling-size"
                },
                {
                    "name": "non-rotation"
                },
                {
                    "name": "fixed-position"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E79",
                "FF15",
                "FFA15",
                "S5.1",
                "SM5",
                "C6",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/vector-effect"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "The vector-effect CSS property suppresses specific transformation effects in SVG, thus permitting effects like a road on a map staying the same width no matter how the map is zoomed, or allowing a diagram key to retain its position and size regardless of other transforms. It can only be used with SVG elements that accept the vector-effect attribute. When used, the CSS value overrides any values of the element's vector-effect attribute."
        },
        {
            "name": "view-timeline",
            "status": "experimental",
            "syntax": "[ <'view-timeline-name'> [ <'view-timeline-axis'> || <'view-timeline-inset'> ]? ]#",
            "relevance": 50,
            "browsers": [
                "E115",
                "C115",
                "CA115",
                "O101"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/view-timeline"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The view-timeline CSS shorthand property is used to define a named view progress timeline, which is progressed through based on the change in visibility of an element (known as the subject) inside a scrollable element (scroller). view-timeline is set on the subject."
        },
        {
            "name": "view-timeline-axis",
            "status": "experimental",
            "syntax": "[ block | inline | x | y ]#",
            "relevance": 50,
            "browsers": [
                "E115",
                "C115",
                "CA115",
                "O101"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/view-timeline-axis"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The view-timeline-axis CSS property is used to specify the scrollbar direction that will be used to provide the timeline for a named view progress timeline animation, which is progressed through based on the change in visibility of an element (known as the subject) inside a scrollable element (scroller). view-timeline-axis is set on the subject. See CSS scroll-driven animations for more details."
        },
        {
            "name": "view-timeline-inset",
            "status": "experimental",
            "syntax": "[ [ auto | <length-percentage> ]{1,2} ]#",
            "relevance": 50,
            "browsers": [
                "E115",
                "C115",
                "CA115",
                "O101"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/view-timeline-inset"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The view-timeline-inset CSS property is used to specify one or two values representing an adjustment to the position of the scrollport (see Scroll container for more details) in which the subject element of a named view progress timeline animation is deemed to be visible. Put another way, this allows you to specify start and/or end inset (or outset) values that offset the position of the timeline."
        },
        {
            "name": "view-timeline-name",
            "status": "experimental",
            "syntax": "[ none | <dashed-ident> ]#",
            "relevance": 50,
            "browsers": [
                "E115",
                "C115",
                "CA115",
                "O101"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/view-timeline-name"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The view-timeline-name CSS property is used to define the name of a named view progress timeline, which is progressed through based on the change in visibility of an element (known as the subject) inside a scrollable element (scroller). view-timeline is set on the subject."
        },
        {
            "name": "view-transition-class",
            "syntax": "none | <custom-ident>+",
            "relevance": 50,
            "browsers": [
                "E125",
                "FFpreview",
                "S18.2",
                "SM18.2",
                "C125",
                "CA125",
                "O111"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/view-transition-class"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The view-transition-class CSS property provides the selected elements with an identifying class (a custom-ident), providing an additional method of styling the view transitions for those elements."
        },
        {
            "name": "view-transition-name",
            "syntax": "none | <custom-ident>",
            "relevance": 50,
            "browsers": [
                "E111",
                "FFpreview",
                "S18",
                "SM18",
                "C111",
                "CA111",
                "O97"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/view-transition-name"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The view-transition-name CSS property provides the selected element with a distinct identifying name (a custom-ident) and causes it to participate in a separate view transition from the root view transition \u2014 or no view transition if the none value is specified."
        },
        {
            "name": "white-space",
            "syntax": "normal | pre | pre-wrap | pre-line | <'white-space-collapse'> || <'text-wrap-mode'>",
            "relevance": 90,
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE5.5",
                "O4"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/white-space"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Specifies how whitespace is handled in an element."
        },
        {
            "name": "white-space-collapse",
            "syntax": "collapse | preserve | preserve-breaks | preserve-spaces | break-spaces",
            "values": [
                {
                    "name": "collapse"
                },
                {
                    "name": "preserve"
                },
                {
                    "name": "preserve-breaks"
                },
                {
                    "name": "preserve-spaces"
                },
                {
                    "name": "break-spaces"
                }
            ],
            "relevance": 50,
            "browsers": [
                "E114",
                "FF124",
                "FFA124",
                "S17.4",
                "SM17.4",
                "C114",
                "CA114",
                "O100"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/white-space-collapse"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-03-19"
            },
            "description": "The white-space-collapse CSS property controls how white space inside an element is collapsed."
        },
        {
            "name": "x",
            "syntax": "<length> | <percentage>",
            "relevance": 51,
            "browsers": [
                "E79",
                "FF69",
                "FFA79",
                "S9",
                "SM9",
                "C42",
                "CA42",
                "O29"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/x"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-07-28",
                "baseline_high_date": "2023-01-28"
            },
            "description": "The x CSS property defines the x-axis coordinate of the top left corner of the SVG rect shape, image image, foreignObject viewport or nested svg viewport relative to the nearest <svg> ancestor's user coordinate system. If present, it overrides the element's x attribute."
        },
        {
            "name": "y",
            "syntax": "<length> | <percentage>",
            "relevance": 51,
            "browsers": [
                "E79",
                "FF69",
                "FFA79",
                "S9",
                "SM9",
                "C42",
                "CA42",
                "O29"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/y"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-07-28",
                "baseline_high_date": "2023-01-28"
            },
            "description": "The y CSS property defines the y-axis coordinate of the top left corner of the SVG rect shape, image image, foreignObject viewport and nested svg viewport relative to the nearest <svg> ancestor's user coordinate system. If present, it overrides the element's y attribute."
        },
        {
            "name": "ascent-override",
            "atRule": "@font-face",
            "syntax": "normal | <percentage>",
            "relevance": 50,
            "description": "Describes the ascent metric of a font."
        },
        {
            "name": "descent-override",
            "atRule": "@font-face",
            "syntax": "normal | <percentage>",
            "relevance": 50,
            "description": "Describes the descent metric of a font."
        },
        {
            "name": "font-display",
            "atRule": "@font-face",
            "syntax": "auto | block | swap | fallback | optional",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "block"
                },
                {
                    "name": "swap"
                },
                {
                    "name": "fallback"
                },
                {
                    "name": "optional"
                }
            ],
            "relevance": 75,
            "description": "The font-display descriptor determines how a font face is displayed based on whether and when it is downloaded and ready to use."
        },
        {
            "name": "line-gap-override",
            "atRule": "@font-face",
            "syntax": "normal | <percentage>",
            "relevance": 50,
            "description": "Describes the line-gap metric of a font."
        },
        {
            "name": "size-adjust",
            "atRule": "@font-face",
            "syntax": "<percentage>",
            "relevance": 50,
            "description": "A multiplier for glyph outlines and metrics of a font."
        },
        {
            "name": "base-palette",
            "atRule": "@font-palette-values",
            "syntax": "light | dark | <integer [0,\u221E]>",
            "relevance": 50,
            "description": "The base-palette CSS descriptor is used to specify the name or index of a pre-defined palette to be used for creating a new palette. If the specified base-palette does not exist, then the palette defined at index 0 will be used."
        },
        {
            "name": "override-colors",
            "atRule": "@font-palette-values",
            "syntax": "[ <integer [0,\u221E]> <color> ]#",
            "relevance": 50,
            "description": "The override-colors CSS descriptor is used to override colors in the chosen base-palette for a color font."
        },
        {
            "name": "bleed",
            "atRule": "@page",
            "syntax": "auto | <length>",
            "relevance": 50,
            "description": "The bleed CSS at-rule descriptor, used with the @page at-rule, specifies the extent of the page bleed area outside the page box. This property only has effect if crop marks are enabled using the marks property."
        },
        {
            "name": "marks",
            "atRule": "@page",
            "syntax": "none | [ crop || cross ]",
            "relevance": 50,
            "description": "The marks CSS at-rule descriptor, used with the @page at-rule, adds crop and/or cross marks to the presentation of the document. Crop marks indicate where the page should be cut. Cross marks are used to align sheets."
        },
        {
            "name": "page-orientation",
            "atRule": "@page",
            "syntax": "upright | rotate-left | rotate-right ",
            "relevance": 50,
            "description": "The page-orientation CSS descriptor for the @page at-rule controls the rotation of a printed page. It handles the flow of content across pages when the orientation of a page is changed. This behavior differs from the size descriptor in that a user can define the direction in which to rotate the page."
        },
        {
            "name": "inherits",
            "atRule": "@property",
            "syntax": "true | false",
            "values": [
                {
                    "name": "true"
                },
                {
                    "name": "false"
                }
            ],
            "relevance": 50,
            "description": "Specifies the inherit flag of the custom property registration represented by the @property rule, controlling whether or not the property inherits by default."
        },
        {
            "name": "initial-value",
            "atRule": "@property",
            "syntax": "<declaration-value>?",
            "relevance": 50,
            "description": "Specifies the initial value of the custom property registration represented by the @property rule, controlling the property\u2019s initial value."
        },
        {
            "name": "syntax",
            "atRule": "@property",
            "syntax": "<string>",
            "relevance": 51,
            "description": "Specifies the syntax of the custom property registration represented by the @property rule, controlling how the property\u2019s value is parsed at computed value time."
        },
        {
            "name": "navigation",
            "atRule": "@view-transition",
            "syntax": "auto | none",
            "values": [
                {
                    "name": "auto"
                },
                {
                    "name": "none"
                }
            ],
            "relevance": 50,
            "description": ""
        },
        {
            "name": "types",
            "atRule": "@view-transition",
            "syntax": "none | <custom-ident>+",
            "relevance": 50,
            "description": ""
        }
    ],
    "atDirectives": [
        {
            "name": "@charset",
            "browsers": [
                "E12",
                "FF1.5",
                "FFA4",
                "S4",
                "SM4",
                "C2",
                "CA18",
                "IE5.5",
                "O9"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@charset"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Defines character set of the document."
        },
        {
            "name": "@counter-style",
            "browsers": [
                "E91",
                "FF33",
                "FFA33",
                "S17",
                "SM17",
                "C91",
                "CA91",
                "O77"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@counter-style"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-09-18"
            },
            "description": "Defines a custom counter style."
        },
        {
            "name": "@font-face",
            "browsers": [
                "E12",
                "FF3.5",
                "FFA4",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "IE4",
                "O10"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@font-face"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Allows for linking to fonts that are automatically activated when needed. This permits authors to work around the limitation of 'web-safe' fonts, allowing for consistent rendering independent of the fonts available in a given user's environment."
        },
        {
            "name": "@font-feature-values",
            "browsers": [
                "E111",
                "FF34",
                "FFA34",
                "S9.1",
                "SM9.3",
                "C111",
                "CA111",
                "O97"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@font-feature-values"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-03-13"
            },
            "description": "Defines named values for the indices used to select alternate glyphs for a given font family."
        },
        {
            "name": "@import",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE5.5",
                "O3.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@import"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Includes content of another file."
        },
        {
            "name": "@keyframes",
            "browsers": [
                "E12",
                "FF16",
                "FFA16",
                "S9",
                "SM9",
                "C43",
                "CA43",
                "IE10",
                "O30"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@keyframes"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "Defines set of animation key frames."
        },
        {
            "name": "@layer",
            "browsers": [
                "E99",
                "FF97",
                "FFA97",
                "S15.4",
                "SM15.4",
                "C99",
                "CA99",
                "O85"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@layer"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-03-14",
                "baseline_high_date": "2024-09-14"
            },
            "description": "Declare a cascade layer and the order of precedence in case of multiple cascade layers."
        },
        {
            "name": "@media",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S3",
                "SM1",
                "C1",
                "CA18",
                "IE6",
                "O9.2"
            ],
            "descriptors": [
                {
                    "name": "width",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-width"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/width"
                        }
                    ],
                    "type": "range",
                    "syntax": "<length>",
                    "description": "The width CSS media feature can be used to test the width of the viewport (or the page box, for paged media).",
                    "browsers": [
                        "E12",
                        "FF2",
                        "FFA4",
                        "S3",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE9",
                        "O10"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2015-07-29",
                        "baseline_high_date": "2018-01-29"
                    }
                },
                {
                    "name": "height",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-height"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/height"
                        }
                    ],
                    "type": "range",
                    "syntax": "<length>",
                    "description": "The height CSS media feature can be used to apply styles based on the height of the viewport (or the page box, for paged media).",
                    "browsers": [
                        "E12",
                        "FF2",
                        "FFA4",
                        "S3",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE9",
                        "O10"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2015-07-29",
                        "baseline_high_date": "2018-01-29"
                    }
                },
                {
                    "name": "aspect-ratio",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-aspect-ratio"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/aspect-ratio"
                        }
                    ],
                    "type": "range",
                    "syntax": "<ratio>",
                    "description": "The aspect-ratio CSS media feature can be used to test the aspect ratio of the viewport.",
                    "browsers": [
                        "E12",
                        "FF3.5",
                        "FFA4",
                        "S5",
                        "SM4.2",
                        "C3",
                        "CA18",
                        "IE9",
                        "O10"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2015-07-29",
                        "baseline_high_date": "2018-01-29"
                    }
                },
                {
                    "name": "orientation",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-orientation"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/orientation"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "portrait | landscape",
                    "values": [
                        {
                            "name": "portrait",
                            "description": "The orientation media feature is portrait when the value of the height media feature is greater than or equal to the value of the width media feature.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-orientation-portrait"
                                }
                            ]
                        },
                        {
                            "name": "landscape",
                            "description": "Otherwise orientation is landscape.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-orientation-landscape"
                                }
                            ]
                        }
                    ],
                    "description": "The orientation CSS media feature can be used to test the orientation of the viewport (or the page box, for paged media).",
                    "browsers": [
                        "E12",
                        "FF2",
                        "FFA4",
                        "S5",
                        "SM4.2",
                        "C3",
                        "CA18",
                        "IE9",
                        "O10.6"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2015-07-29",
                        "baseline_high_date": "2018-01-29"
                    }
                },
                {
                    "name": "overflow-block",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-overflow-block"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/overflow-block"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "none | scroll | paged",
                    "values": [
                        {
                            "name": "none",
                            "description": "There is no affordance for overflow in the block axis; any overflowing content is simply not displayed. Examples: billboards",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-overflow-block-none"
                                }
                            ]
                        },
                        {
                            "name": "scroll",
                            "description": "Overflowing content in the block axis is exposed by allowing users to scroll to it. Examples: computer screens",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-overflow-block-scroll"
                                }
                            ]
                        },
                        {
                            "name": "paged",
                            "description": "Content is broken up into discrete pages; content that overflows one page in the block axis is displayed on the following page. Examples: printers, ebook readers",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-overflow-block-paged"
                                }
                            ]
                        }
                    ],
                    "description": "The overflow-block CSS media feature can be used to test how the output device handles content that overflows the initial containing block along the block axis.",
                    "browsers": [
                        "E113",
                        "FF66",
                        "FFA66",
                        "S17",
                        "SM17",
                        "C113",
                        "CA113",
                        "O99"
                    ],
                    "baseline": {
                        "status": "low",
                        "baseline_low_date": "2023-09-18"
                    }
                },
                {
                    "name": "overflow-inline",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-overflow-inline"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/overflow-inline"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "none | scroll",
                    "values": [
                        {
                            "name": "none",
                            "description": "There is no affordance for overflow in the inline axis; any overflowing content is simply not displayed.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-overflow-inline-none"
                                }
                            ]
                        },
                        {
                            "name": "scroll",
                            "description": "Overflowing content in the inline axis is exposed by allowing users to scroll to it.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-overflow-inline-scroll"
                                }
                            ]
                        }
                    ],
                    "description": "The overflow-inline CSS media feature can be used to test how the output device handles content that overflows the initial containing block along the inline axis.",
                    "browsers": [
                        "E113",
                        "FF66",
                        "FFA66",
                        "S17",
                        "SM17",
                        "C113",
                        "CA113",
                        "O99"
                    ],
                    "baseline": {
                        "status": "low",
                        "baseline_low_date": "2023-09-18"
                    }
                },
                {
                    "name": "horizontal-viewport-segments",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-horizontal-viewport-segments"
                        }
                    ],
                    "type": "range",
                    "syntax": "<integer>",
                    "description": ""
                },
                {
                    "name": "vertical-viewport-segments",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-vertical-viewport-segments"
                        }
                    ],
                    "type": "range",
                    "syntax": "<integer>",
                    "description": ""
                },
                {
                    "name": "display-mode",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-display-mode"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/display-mode"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "fullscreen | standalone | minimal-ui | browser | picture-in-picture",
                    "values": [
                        {
                            "name": "fullscreen",
                            "description": "The browsing context is displayed with browser UI elements hidden and takes up the entirety of the available display area. The fullscreen context may have been caused by the fullscreen display mode in the application manifest, by the requestFullscreen() method of the Fullscreen API, or through some other means (such as the user manually activating fullscreen mode using the user agent\u2019s built-in controls). Corresponds to the fullscreen display mode.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-display-mode-fullscreen"
                                }
                            ]
                        },
                        {
                            "name": "standalone",
                            "description": "The standalone display mode is in use. Only applicable in an application context.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-display-mode-standalone"
                                }
                            ]
                        },
                        {
                            "name": "minimal-ui",
                            "description": "The minimal-ui display mode is in use. Only applicable in an application context.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-display-mode-minimal-ui"
                                }
                            ]
                        },
                        {
                            "name": "browser",
                            "description": "The browsing context is displayed using the platform-specific convention for opening hyperlinks in the user agent (e.g., in a browser tab or web browser window with controls such as an address bar). This should be used for non-application contexts where no other display mode is appropriate. Corresponds to the browser display mode.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-display-mode-browser"
                                }
                            ]
                        },
                        {
                            "name": "picture-in-picture",
                            "description": "This mode allows users to continue consuming media while they interact with other sites or applications on their device. The browsing context is displayed in a floating and always-on-top window. A user agent may include other platform specific UI elements, such as \"back-to-tab\" and \"site information\" buttons or whatever is customary on the platform and user agent.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-display-mode-picture-in-picture"
                                }
                            ]
                        }
                    ],
                    "description": "The display-mode CSS media feature can be used to test whether a web app is being displayed in a normal browser tab or in some alternative way, such as a standalone app or fullscreen mode.",
                    "browsers": [
                        "E79",
                        "FF47",
                        "S13",
                        "SM12.2",
                        "C42",
                        "CA42",
                        "O29"
                    ],
                    "baseline": {
                        "status": "false"
                    }
                },
                {
                    "name": "resolution",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-resolution"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/resolution"
                        }
                    ],
                    "type": "range",
                    "syntax": "<resolution> | infinite",
                    "values": [
                        {
                            "name": "infinite",
                            "description": "For output mediums that have no physical constraints on resolution (such as outputting to vector graphics), this feature must match the infinite value. For the purpose of evaluating this media feature in the range context, infinite must be treated as larger than any possible <resolution>. (That is, a query like (resolution > 1000dpi) will be true for an infinite media.)",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-resolution-infinite"
                                }
                            ]
                        }
                    ],
                    "description": "The resolution CSS media feature can be used to test the pixel density of the output device.",
                    "browsers": [
                        "E12",
                        "FF8",
                        "FFA8",
                        "S16",
                        "SM16",
                        "C29",
                        "CA29",
                        "IE9",
                        "O16"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2022-09-12",
                        "baseline_high_date": "2025-03-12"
                    }
                },
                {
                    "name": "scan",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-scan"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "interlace | progressive",
                    "values": [
                        {
                            "name": "interlace",
                            "description": "CRT and some types of plasma TV screens used \u201Cinterlaced\u201D rendering, where video frames alternated between specifying only the \u201Ceven\u201D lines on the screen and only the \u201Codd\u201D lines, exploiting various automatic mental image-correction abilities to produce smooth motion. This allowed them to simulate a higher FPS broadcast at half the bandwidth cost. When displaying on interlaced screens, authors should avoid very fast movement across the screen to avoid \u201Ccombing\u201D, and should ensure that details on the screen are wider than 1px to avoid \u201Ctwitter\u201D.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-scan-interlace"
                                }
                            ]
                        },
                        {
                            "name": "progressive",
                            "description": "A screen using \u201Cprogressive\u201D rendering displays each screen fully, and needs no special treatment. Most modern screens, and all computer screens, use progressive rendering.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-scan-progressive"
                                }
                            ]
                        }
                    ],
                    "description": "The scan CSS media feature is used to apply CSS styles based on the scanning process of the output device."
                },
                {
                    "name": "grid",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-grid"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/grid"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "<mq-boolean>",
                    "description": "The grid CSS media feature can be used to test whether the output device uses a grid-based screen.",
                    "browsers": [
                        "E12",
                        "FF2",
                        "FFA4",
                        "S3",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE10",
                        "O10"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2015-07-29",
                        "baseline_high_date": "2018-01-29"
                    }
                },
                {
                    "name": "update",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-update"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/update"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "none | slow | fast",
                    "values": [
                        {
                            "name": "none",
                            "description": "Once it has been rendered, the layout can no longer be updated. Example: documents printed on paper.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-update-none"
                                }
                            ]
                        },
                        {
                            "name": "slow",
                            "description": "The layout may change dynamically according to the usual rules of CSS, but the output device is not able to render or display changes quickly enough for them to be perceived as a smooth animation. Example: E-ink screens or severely under-powered devices.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-update-slow"
                                }
                            ]
                        },
                        {
                            "name": "fast",
                            "description": "The layout may change dynamically according to the usual rules of CSS, and the output device is not unusually constrained in speed, so regularly-updating things like CSS Animations can be used. Example: computer screens.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-update-fast"
                                }
                            ]
                        }
                    ],
                    "description": "The update CSS media feature can be used to test how frequently (if at all) the output device is able to modify the appearance of content once rendered.",
                    "browsers": [
                        "E113",
                        "FF102",
                        "FFA102",
                        "S17",
                        "SM17",
                        "C113",
                        "CA113",
                        "O99"
                    ],
                    "baseline": {
                        "status": "low",
                        "baseline_low_date": "2023-09-18"
                    }
                },
                {
                    "name": "environment-blending",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-environment-blending"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "opaque | additive | subtractive",
                    "values": [
                        {
                            "name": "opaque",
                            "description": "The document is rendered on an opaque medium, such as a traditional monitor or paper. Black is dark and white is 100% light.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-environment-blending-opaque"
                                }
                            ]
                        },
                        {
                            "name": "additive",
                            "description": "The display blends the colors of the canvas with the real world using additive mixing. Black is fully transparent and white is 100% light. For example: a head-up display in a car.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-environment-blending-additive"
                                }
                            ]
                        },
                        {
                            "name": "subtractive",
                            "description": "The display blends the colors of the canvas with the real world using subtractive mixing. White is fully transparent and dark colors have the most contrast. For example: an LCD display embedded in a bathroom mirror.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-environment-blending-subtractive"
                                }
                            ]
                        }
                    ],
                    "description": ""
                },
                {
                    "name": "color",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-color"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/color"
                        }
                    ],
                    "type": "range",
                    "syntax": "<integer>",
                    "description": "The color CSS media feature can be used to test the number of bits per color component (red, green, blue) of the output device.",
                    "browsers": [
                        "E12",
                        "FF2",
                        "FFA4",
                        "S3",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE9",
                        "O10"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2015-07-29",
                        "baseline_high_date": "2018-01-29"
                    }
                },
                {
                    "name": "color-index",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-color-index"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/color-index"
                        }
                    ],
                    "type": "range",
                    "syntax": "<integer>",
                    "description": "The color-index CSS media feature can be used to test the number of entries in the output device's color lookup table.",
                    "browsers": [
                        "E79",
                        "S8",
                        "SM8",
                        "C29",
                        "CA29",
                        "O16"
                    ],
                    "baseline": {
                        "status": "false"
                    }
                },
                {
                    "name": "monochrome",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-monochrome"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/monochrome"
                        }
                    ],
                    "type": "range",
                    "syntax": "<integer>",
                    "description": "The monochrome CSS media feature can be used to test the number of bits per pixel in the monochrome frame buffer of the output device.",
                    "browsers": [
                        "E79",
                        "FF2",
                        "FFA4",
                        "S3",
                        "SM1",
                        "C1",
                        "CA18",
                        "O10"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2020-01-15",
                        "baseline_high_date": "2022-07-15"
                    }
                },
                {
                    "name": "color-gamut",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-color-gamut"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/color-gamut"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "srgb | p3 | rec2020",
                    "values": [
                        {
                            "name": "srgb",
                            "description": "The UA and output device can support approximately the sRGB gamut or more.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-color-gamut-srgb"
                                }
                            ]
                        },
                        {
                            "name": "p3",
                            "description": "The UA and output device can support approximately the gamut specified by the Display P3 [Display-P3] Color Space or more.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-color-gamut-p3"
                                }
                            ]
                        },
                        {
                            "name": "rec2020",
                            "description": "The UA and output device can support approximately the gamut specified by the ITU-R Recommendation BT.2020 Color Space or more.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-color-gamut-rec2020"
                                }
                            ]
                        }
                    ],
                    "description": "The color-gamut CSS media feature is used to apply CSS styles based on the approximate range of color gamut supported by the user agent and the output device.",
                    "browsers": [
                        "E79",
                        "FF110",
                        "FFA110",
                        "S10",
                        "SM10",
                        "C58",
                        "CA58",
                        "O45"
                    ],
                    "baseline": {
                        "status": "low",
                        "baseline_low_date": "2023-02-14"
                    }
                },
                {
                    "name": "dynamic-range",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-dynamic-range"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/dynamic-range"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "standard | high",
                    "values": [
                        {
                            "name": "high",
                            "description": "The user agent and the output device fulfill all of the following criteria: they support a high peak brightness they support a high contrast ratio the color depth is greater than 24 bit or 8 bit per color component of RGB",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-dynamic-range-high"
                                }
                            ]
                        },
                        {
                            "name": "standard",
                            "description": "This value matches on any visual device, and not on devices lacking visual capabilities.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-dynamic-range-standard"
                                }
                            ]
                        }
                    ],
                    "description": "The dynamic-range CSS media feature can be used to test the combination of brightness, contrast ratio, and color depth that are supported by the user agent and the output device.",
                    "browsers": [
                        "E98",
                        "FF100",
                        "FFA100",
                        "S13.1",
                        "SM13.4",
                        "C98",
                        "CA98",
                        "O84"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2022-05-03",
                        "baseline_high_date": "2024-11-03"
                    }
                },
                {
                    "name": "inverted-colors",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-inverted-colors"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/inverted-colors"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "none | inverted",
                    "values": [
                        {
                            "name": "none",
                            "description": "Colors are displayed normally.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-inverted-colors-none"
                                }
                            ]
                        },
                        {
                            "name": "inverted",
                            "description": "All pixels within the displayed area have been inverted. This value must not match if the user agent has done some kind of content aware inversion such as one that preserves the images.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-inverted-colors-inverted"
                                }
                            ]
                        }
                    ],
                    "description": "The inverted-colors CSS media feature is used to test if the user agent or the underlying operating system has inverted all colors.",
                    "browsers": [
                        "S9.1",
                        "SM10"
                    ],
                    "baseline": {
                        "status": "false"
                    }
                },
                {
                    "name": "pointer",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-pointer"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/pointer"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "none | coarse | fine",
                    "values": [
                        {
                            "name": "none",
                            "description": "The primary input mechanism of the device does not include a pointing device.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-pointer-none"
                                }
                            ]
                        },
                        {
                            "name": "coarse",
                            "description": "The primary input mechanism of the device includes a pointing device of limited accuracy. Examples include touchscreens and motion-detection sensors (like the Kinect peripheral for the Xbox.)",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-pointer-coarse"
                                }
                            ]
                        },
                        {
                            "name": "fine",
                            "description": "The primary input mechanism of the device includes an accurate pointing device. Examples include mice, touchpads, and drawing styluses.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-pointer-fine"
                                }
                            ]
                        }
                    ],
                    "description": "The pointer CSS media feature tests whether the user has a pointing device (such as a mouse), and if so, how accurate the primary pointing device is.",
                    "browsers": [
                        "E12",
                        "FF64",
                        "FFA64",
                        "S9",
                        "SM9",
                        "C41",
                        "CA50",
                        "O28"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2018-12-11",
                        "baseline_high_date": "2021-06-11"
                    }
                },
                {
                    "name": "hover",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-hover"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/hover"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "none | hover",
                    "values": [
                        {
                            "name": "none",
                            "description": "Indicates that the primary pointing device can\u2019t hover, or that there is no pointing device. Examples include touchscreens and screens that use a basic drawing stylus. Pointing devices that can hover, but for which doing so is inconvenient and not part of the normal way they are used, also match this value. For example, a touchscreen where a long press is treated as hovering would match hover: none.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-hover-none"
                                }
                            ]
                        },
                        {
                            "name": "hover",
                            "description": "Indicates that the primary pointing device can easily hover over parts of the page. Examples include mice and devices that physically point at the screen, like the Nintendo Wii controller.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-hover-hover"
                                }
                            ]
                        }
                    ],
                    "description": "The hover CSS media feature can be used to test whether the user's primary input mechanism can hover over elements.",
                    "browsers": [
                        "E12",
                        "FF64",
                        "FFA64",
                        "S9",
                        "SM9",
                        "C38",
                        "CA50",
                        "O25"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2018-12-11",
                        "baseline_high_date": "2021-06-11"
                    }
                },
                {
                    "name": "any-pointer",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-any-pointer"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/any-pointer"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "none | coarse | fine",
                    "description": "The any-pointer CSS media feature tests whether the user has any pointing device (such as a mouse), and if so, how accurate it is.",
                    "browsers": [
                        "E12",
                        "FF64",
                        "FFA64",
                        "S9",
                        "SM9",
                        "C41",
                        "CA41",
                        "O28"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2018-12-11",
                        "baseline_high_date": "2021-06-11"
                    }
                },
                {
                    "name": "any-hover",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-any-hover"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/any-hover"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "none | hover",
                    "description": "The any-hover CSS media feature can be used to test whether any available input mechanism can hover over elements.",
                    "browsers": [
                        "E16",
                        "FF64",
                        "FFA64",
                        "S9",
                        "SM9",
                        "C41",
                        "CA41",
                        "O28"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2018-12-11",
                        "baseline_high_date": "2021-06-11"
                    }
                },
                {
                    "name": "nav-controls",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-nav-controls"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "none | back",
                    "values": [
                        {
                            "name": "none",
                            "description": "The user agent does not have any obviously discoverable navigation controls, and in particular none that cause the user agent to move back one page in the joint session history.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-nav-controls-none"
                                }
                            ]
                        },
                        {
                            "name": "back",
                            "description": "The user agent provides navigation controls, including at least an obviously discoverable control causing the user agent to move back one page in the joint session history (typically, a \u201Cback\u201D button).",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-nav-controls-back"
                                }
                            ]
                        }
                    ],
                    "description": ""
                },
                {
                    "name": "video-color-gamut",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-video-color-gamut"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "srgb | p3 | rec2020",
                    "description": ""
                },
                {
                    "name": "video-dynamic-range",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-video-dynamic-range"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/video-dynamic-range"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "standard | high",
                    "description": "The video-dynamic-range CSS media feature can be used to test the combination of brightness, contrast ratio, and color depth that are supported by the video plane of the user agent and the output device.",
                    "browsers": [
                        "FF100",
                        "FFA100",
                        "O84"
                    ],
                    "baseline": {
                        "status": "false"
                    }
                },
                {
                    "name": "scripting",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-scripting"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/scripting"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "none | initial-only | enabled",
                    "values": [
                        {
                            "name": "enabled",
                            "description": "Indicates that the user agent supports scripting of the page, and that scripting in the current document is enabled for the lifetime of the document.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-scripting-enabled"
                                }
                            ]
                        },
                        {
                            "name": "initial-only",
                            "description": "Indicates that the user agent supports scripting of the page, and that scripting in the current document is enabled during the initial page load, but is not supported afterwards. Examples are printed pages, or pre-rendering network proxies that render a page on a server and send a nearly-static version of the page to the user. Should there be an explicit minimum threshold to meet before a UA is allowed to claim initial-only? Having one would mean authors would know what they can depend on, and could tailor their scripts accordingly. On the other hand, pinpointing that threshold is difficult: if it is set too low, the scripting facilities that authors can depend on may be to constrained to be practical, even though actual UAs may potentially all support significantly more. But trying to set it higher may cause us to exclude UAs that do support scripting at loading time, but restrict it in some cases based on complex heuristics. For instance, conservative definitions likely include at least running all inline scripts and firing the DOMContentLoaded event. But it does not seem useful for authors to constrain themselves to this if most (or maybe all) initial-only UAs also load external scripts (including async and defer) and fire the load event. On the other hand, requiring external scripts to be loaded and the load event to be fired could exclude UAs like Opera mini, which typically do run them, but may decide not to based on timeouts and other heuristics. [Issue #503]",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-scripting-initial-only"
                                }
                            ]
                        },
                        {
                            "name": "none",
                            "description": "Indicates that the user agent will not run scripts for this document; either it doesn\u2019t support a scripting language, or the support isn\u2019t active for the current document.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-scripting-none"
                                }
                            ]
                        }
                    ],
                    "description": "The scripting CSS media feature can be used to test whether scripting (such as JavaScript) is available.",
                    "browsers": [
                        "E120",
                        "FF113",
                        "FFA113",
                        "S17",
                        "SM17",
                        "C120",
                        "CA120",
                        "O106"
                    ],
                    "baseline": {
                        "status": "low",
                        "baseline_low_date": "2023-12-07"
                    }
                },
                {
                    "name": "prefers-reduced-motion",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-prefers-reduced-motion"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/prefers-reduced-motion"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "no-preference | reduce",
                    "values": [
                        {
                            "name": "no-preference",
                            "description": "Indicates that the user has made no preference known to the system. This keyword value evaluates as false in the boolean context.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-prefers-reduced-motion-no-preference"
                                }
                            ]
                        },
                        {
                            "name": "reduce",
                            "description": "Indicates that user has notified the system that they prefer an interface that removes or replaces the types of motion-based animation that either trigger discomfort for those with vestibular motion sensitivity, or distraction for those with attention deficits.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-prefers-reduced-motion-reduce"
                                }
                            ]
                        }
                    ],
                    "description": "The prefers-reduced-motion CSS media feature is used to detect if a user has enabled a setting on their device to minimize the amount of non-essential motion. The setting is used to convey to the browser on the device that the user prefers an interface that removes, reduces, or replaces motion-based animations.",
                    "browsers": [
                        "E79",
                        "FF63",
                        "FFA64",
                        "S10.1",
                        "SM10.3",
                        "C74",
                        "CA74",
                        "O62"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2020-01-15",
                        "baseline_high_date": "2022-07-15"
                    }
                },
                {
                    "name": "prefers-reduced-transparency",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-prefers-reduced-transparency"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/prefers-reduced-transparency"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "no-preference | reduce",
                    "values": [
                        {
                            "name": "no-preference",
                            "description": "Indicates that the user has made no preference known to the system. This keyword value evaluates as false in the boolean context.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-prefers-reduced-transparency-no-preference"
                                }
                            ]
                        },
                        {
                            "name": "reduce",
                            "description": "Indicates that user has notified the system that they prefer an interface that minimizes the amount of transparent or translucent layer effects.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-prefers-reduced-transparency-reduce"
                                }
                            ]
                        }
                    ],
                    "description": "The prefers-reduced-transparency CSS media feature is used to detect if a user has enabled a setting on their device to reduce the transparent or translucent layer effects used on the device. Switching on such a setting can help improve contrast and readability for some users.",
                    "status": "experimental",
                    "browsers": [
                        "E118",
                        "C118",
                        "CA118",
                        "O104"
                    ],
                    "baseline": {
                        "status": "false"
                    }
                },
                {
                    "name": "prefers-contrast",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-prefers-contrast"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/prefers-contrast"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "no-preference | less | more | custom",
                    "values": [
                        {
                            "name": "no-preference",
                            "description": "Indicates that the user has made no preference known to the system. This keyword value evaluates as false in the boolean context.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-prefers-contrast-no-preference"
                                }
                            ]
                        },
                        {
                            "name": "less",
                            "description": "Indicates that user has notified the system that they prefer an interface that has a lower level of contrast.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-prefers-contrast-less"
                                }
                            ]
                        },
                        {
                            "name": "more",
                            "description": "Indicates that user has notified the system that they prefer an interface that has a higher level of contrast.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-prefers-contrast-more"
                                }
                            ]
                        },
                        {
                            "name": "custom",
                            "description": "Indicates that the user has indicated wanting a specific set of colors to be used, but the contrast implied by these particular colors is such that neither more nor less match. A user calling for cyan text over a rust background is not\u2014\u200Bat least in terms of luminosity\u2014\u200Bexpressing a need for particularly high or low contrast, but this is not a lack of a preference either.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-prefers-contrast-custom"
                                }
                            ]
                        }
                    ],
                    "description": "The prefers-contrast CSS media feature is used to detect whether the user has requested the web content to be presented with a lower or higher contrast.",
                    "browsers": [
                        "E96",
                        "FF101",
                        "FFA101",
                        "S14.1",
                        "SM14.5",
                        "C96",
                        "CA96",
                        "O82"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2022-05-31",
                        "baseline_high_date": "2024-11-30"
                    }
                },
                {
                    "name": "forced-colors",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-forced-colors"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/forced-colors"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "none | active",
                    "values": [
                        {
                            "name": "active",
                            "description": "Indicates that forced colors mode is active: the user agent enforces a user-chosen limited color palette on the page, The UA will provide the color palette to authors through the CSS system color keywords. See CSS Color Adjustment 1 \xa7 3 Forced Color Palettes for details. This does not necessarily indicate a preference for more contrast. The colors have been forcibly adjusted to match the preference of the user, but that preference can be for less or more contrast, or some other arrangement that is neither particularly low or high contrast. In addition to forced-colors: active, the user agent must also match one of prefers-contrast: more or prefers-contrast: less if it can determine that the forced color palette chosen by the user has a particularly high or low contrast, and must make prefers-contrast: custom match otherwise. Similarly, if the forced color palette chosen by the user fits within one of the color schemes described by prefers-color-scheme, the corresponding value must also match.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-forced-colors-active"
                                }
                            ]
                        },
                        {
                            "name": "none",
                            "description": "Forced colors mode is not active.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-forced-colors-none"
                                }
                            ]
                        }
                    ],
                    "description": "The forced-colors CSS media feature is used to detect if the user agent has enabled a forced colors mode where it enforces a user-chosen limited color palette on the page. An example of a forced colors mode is Windows High Contrast mode.",
                    "browsers": [
                        "E79",
                        "FF89",
                        "FFA89",
                        "S16",
                        "SM16",
                        "C89",
                        "CA89",
                        "O75"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2022-09-12",
                        "baseline_high_date": "2025-03-12"
                    }
                },
                {
                    "name": "prefers-color-scheme",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-prefers-color-scheme"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/prefers-color-scheme"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "light | dark",
                    "values": [
                        {
                            "name": "light",
                            "description": "Indicates that user has expressed the preference for a page that has a light theme (dark text on light background), or has not expressed an active preference (and thus should receive the \"web default\" of a light theme).",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-prefers-color-scheme-light"
                                }
                            ]
                        },
                        {
                            "name": "dark",
                            "description": "Indicates that user has expressed the preference for a page that has a dark theme (light text on dark background).",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-prefers-color-scheme-dark"
                                }
                            ]
                        }
                    ],
                    "description": "The prefers-color-scheme CSS media feature is used to detect if a user has requested light or dark color themes.",
                    "browsers": [
                        "E79",
                        "FF67",
                        "FFA67",
                        "S12.1",
                        "SM13",
                        "C76",
                        "CA76",
                        "O62"
                    ],
                    "baseline": {
                        "status": "high",
                        "baseline_low_date": "2020-01-15",
                        "baseline_high_date": "2022-07-15"
                    }
                },
                {
                    "name": "prefers-reduced-data",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-prefers-reduced-data"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/prefers-reduced-data"
                        }
                    ],
                    "type": "discrete",
                    "syntax": "no-preference | reduce",
                    "values": [
                        {
                            "name": "no-preference",
                            "description": "Indicates that the user has made no preference known to the system. This keyword value evaluates as false in the boolean context.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-prefers-reduced-data-no-preference"
                                }
                            ]
                        },
                        {
                            "name": "reduce",
                            "description": "Indicates that user has expressed the preference for lightweight alternate content.",
                            "references": [
                                {
                                    "name": "W3C Reference",
                                    "url": "https://drafts.csswg.org/mediaqueries-5/#valdef-media-prefers-reduced-data-reduce"
                                }
                            ]
                        }
                    ],
                    "description": "The prefers-reduced-data CSS media feature is used to detect if the user has requested the web content that consumes less internet traffic.",
                    "status": "experimental",
                    "browsers": [
                        "O71"
                    ],
                    "baseline": {
                        "status": "false"
                    }
                },
                {
                    "name": "device-width",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-device-width"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/device-width"
                        }
                    ],
                    "type": "range",
                    "syntax": "<length>",
                    "description": "The device-width CSS media feature can be used to test the width of an output device's rendering surface.",
                    "status": "obsolete",
                    "browsers": [
                        "E12",
                        "FF2",
                        "FFA4",
                        "S3",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE9",
                        "O10"
                    ],
                    "baseline": {
                        "status": "false"
                    }
                },
                {
                    "name": "device-height",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-device-height"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/device-height"
                        }
                    ],
                    "type": "range",
                    "syntax": "<length>",
                    "description": "The device-height CSS media feature can be used to test the height of an output device's rendering surface.",
                    "status": "obsolete",
                    "browsers": [
                        "E12",
                        "FF2",
                        "FFA4",
                        "S3",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE9",
                        "O10"
                    ],
                    "baseline": {
                        "status": "false"
                    }
                },
                {
                    "name": "device-aspect-ratio",
                    "references": [
                        {
                            "name": "W3C Reference",
                            "url": "https://drafts.csswg.org/mediaqueries-5/#descdef-media-device-aspect-ratio"
                        },
                        {
                            "name": "MDN Reference",
                            "url": "https://developer.mozilla.org/docs/Web/CSS/@media/device-aspect-ratio"
                        }
                    ],
                    "type": "range",
                    "syntax": "<ratio>",
                    "description": "The device-aspect-ratio CSS media feature can be used to test the width-to-height aspect ratio of an output device.",
                    "status": "obsolete",
                    "browsers": [
                        "E12",
                        "FF2",
                        "FFA4",
                        "S3",
                        "SM1",
                        "C1",
                        "CA18",
                        "IE9",
                        "O10"
                    ],
                    "baseline": {
                        "status": "false"
                    }
                }
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@media"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Defines a stylesheet for a particular media type."
        },
        {
            "name": "@-moz-document",
            "browsers": [
                "FF1.8"
            ],
            "description": "Gecko-specific at-rule that restricts the style rules contained within it based on the URL of the document."
        },
        {
            "name": "@-moz-keyframes",
            "browsers": [
                "FF5"
            ],
            "description": "Defines set of animation key frames."
        },
        {
            "name": "@-ms-viewport",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Specifies the size, zoom factor, and orientation of the viewport."
        },
        {
            "name": "@namespace",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE9",
                "O8"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@namespace"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Declares a prefix and associates it with a namespace name."
        },
        {
            "name": "@-o-keyframes",
            "browsers": [
                "O12"
            ],
            "description": "Defines set of animation key frames."
        },
        {
            "name": "@-o-viewport",
            "browsers": [
                "O11"
            ],
            "description": "Specifies the size, zoom factor, and orientation of the viewport."
        },
        {
            "name": "@page",
            "browsers": [
                "E12",
                "FF19",
                "FFA19",
                "S18.2",
                "SM18.2",
                "C2",
                "CA18",
                "IE8",
                "O6"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@page"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-12-11"
            },
            "description": "Directive defines various page parameters."
        },
        {
            "name": "@property",
            "browsers": [
                "E85",
                "FF128",
                "FFA128",
                "S16.4",
                "SM16.4",
                "C85",
                "CA85",
                "O71"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@property"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-07-09"
            },
            "description": "Describes the aspect of custom properties and variables."
        },
        {
            "name": "@supports",
            "browsers": [
                "E12",
                "FF22",
                "FFA22",
                "S9",
                "SM9",
                "C28",
                "CA28",
                "O12.1"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@supports"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-09-30",
                "baseline_high_date": "2018-03-30"
            },
            "description": "A conditional group rule whose condition tests whether the user agent supports CSS property:value pairs."
        },
        {
            "name": "@-webkit-keyframes",
            "browsers": [
                "C",
                "S4"
            ],
            "description": "Defines set of animation key frames."
        },
        {
            "name": "@container",
            "description": "The @container CSS at-rule is a conditional group rule that applies styles to a containment context.",
            "browsers": [
                "E105",
                "FF110",
                "FFA110",
                "S16",
                "SM16",
                "C105",
                "CA105",
                "O91"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@container"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-02-14"
            }
        },
        {
            "name": "@document",
            "description": "The @document CSS at-rule restricts the style rules contained within it based on the URL of the document. It is designed primarily for user-defined style sheets (see userchrome.org for more information), though it can be used on author-defined style sheets, too.",
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@document"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "@font-palette-values",
            "description": "The @font-palette-values CSS at-rule allows you to customize the default values of font-palette created by the font-maker.",
            "browsers": [
                "E101",
                "FF107",
                "FFA107",
                "S15.4",
                "SM15.4",
                "C101",
                "CA101",
                "O87"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@font-palette-values"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-11-15",
                "baseline_high_date": "2025-05-15"
            }
        },
        {
            "name": "@position-try",
            "description": "The @position-try CSS at-rule is used to define a custom position try fallback option, which can be used to define positioning and alignment for anchor-positioned elements. One or more sets of position try fallback options can be applied to the anchored element via the position-try-fallbacks property or position-try shorthand. When the positioned element is moved to a position where it starts to overflow its containing block or the viewport, the browser will select the first position try fallback option it finds that places the positioned element fully back on-screen.",
            "browsers": [
                "E125",
                "C125",
                "CA125",
                "O111"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@position-try"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "@scope",
            "description": "The @scope CSS at-rule enables you to select elements in specific DOM subtrees, targeting elements precisely without writing overly-specific selectors that are hard to override, and without coupling your selectors too tightly to the DOM structure.",
            "browsers": [
                "E118",
                "S17.4",
                "SM17.4",
                "C118",
                "CA118",
                "O104"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@scope"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "@starting-style",
            "description": "The @starting-style CSS at-rule is used to define starting values for properties set on an element that you want to transition from when the element receives its first style update, i.e., when an element is first displayed on a previously loaded page.",
            "browsers": [
                "E117",
                "FF129",
                "FFA129",
                "S17.5",
                "SM17.5",
                "C117",
                "CA117",
                "O103"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@starting-style"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-08-06"
            }
        },
        {
            "name": "@view-transition",
            "description": "The @view-transition CSS at-rule is used to opt in the current and destination documents to undergo a view transition, in the case of a cross-document navigation.",
            "browsers": [
                "E126",
                "S18.2",
                "SM18.2",
                "C126",
                "CA126",
                "O112"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/@view-transition"
                }
            ],
            "baseline": {
                "status": "false"
            }
        }
    ],
    "pseudoClasses": [
        {
            "name": ":active",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:active"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Applies while an element is being activated by the user. For example, between the times the user presses the mouse button and releases it."
        },
        {
            "name": ":any-link",
            "browsers": [
                "E79",
                "FF50",
                "FFA50",
                "S9",
                "SM9",
                "C65",
                "CA65",
                "O52"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:any-link"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Represents an element that acts as the source anchor of a hyperlink. Applies to both visited and unvisited links."
        },
        {
            "name": ":checked",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "IE9",
                "O9"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:checked"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Radio and checkbox elements can be toggled by the user. Some menu items are 'checked' when the user selects them. When such elements are toggled 'on' the :checked pseudo-class applies."
        },
        {
            "name": ":corner-present",
            "browsers": [
                "C",
                "S5"
            ],
            "description": "Non-standard. Indicates whether or not a scrollbar corner is present."
        },
        {
            "name": ":decrement",
            "browsers": [
                "C",
                "S5"
            ],
            "description": "Non-standard. Applies to buttons and track pieces. Indicates whether or not the button or track piece will decrement the view's position when used."
        },
        {
            "name": ":default",
            "browsers": [
                "E79",
                "FF4",
                "FFA4",
                "S5",
                "SM5",
                "C10",
                "CA18",
                "O10"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:default"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Applies to the one or more UI elements that are the default among a set of similar elements. Typically applies to context menu items, buttons, and select lists/menus."
        },
        {
            "name": ":disabled",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "IE9",
                "O9"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:disabled"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Represents user interface elements that are in a disabled state; such elements have a corresponding enabled state."
        },
        {
            "name": ":double-button",
            "browsers": [
                "C",
                "S5"
            ],
            "description": "Non-standard. Applies to buttons and track pieces. Applies when both buttons are displayed together at the same end of the scrollbar."
        },
        {
            "name": ":empty",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "IE9",
                "O9.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:empty"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Represents an element that has no children at all."
        },
        {
            "name": ":enabled",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "IE9",
                "O9"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:enabled"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Represents user interface elements that are in an enabled state; such elements have a corresponding disabled state."
        },
        {
            "name": ":end",
            "browsers": [
                "C",
                "S5"
            ],
            "description": "Non-standard. Applies to buttons and track pieces. Indicates whether the object is placed after the thumb."
        },
        {
            "name": ":first",
            "browsers": [
                "E12",
                "FF116",
                "FFA116",
                "S6",
                "SM6",
                "C18",
                "CA18",
                "IE8",
                "O9.2"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:first"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-08-01"
            },
            "description": "When printing double-sided documents, the page boxes on left and right pages may be different. This can be expressed through CSS pseudo-classes defined in the  page context."
        },
        {
            "name": ":first-child",
            "browsers": [
                "E12",
                "FF3",
                "FFA4",
                "S3.1",
                "SM4",
                "C4",
                "CA18",
                "IE7",
                "O9.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:first-child"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Same as :nth-child(1). Represents an element that is the first child of some other element."
        },
        {
            "name": ":first-of-type",
            "browsers": [
                "E12",
                "FF3.5",
                "FFA4",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "IE9",
                "O9.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:first-of-type"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Same as :nth-of-type(1). Represents an element that is the first sibling of its type in the list of children of its parent element."
        },
        {
            "name": ":focus",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE8",
                "O7"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:focus"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Applies while an element has the focus (accepts keyboard or mouse events, or other forms of input)."
        },
        {
            "name": ":fullscreen",
            "browsers": [
                "E12",
                "FF64",
                "FFA64",
                "S16.4",
                "C71",
                "CA71",
                "IE11",
                "O58"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:fullscreen"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Matches any element that has its fullscreen flag set."
        },
        {
            "name": ":future",
            "browsers": [
                "E79",
                "S7",
                "SM7",
                "C23",
                "CA25",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:future"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Represents any element that is defined to occur entirely after a :current element."
        },
        {
            "name": ":horizontal",
            "browsers": [
                "C",
                "S5"
            ],
            "description": "Non-standard. Applies to any scrollbar pieces that have a horizontal orientation."
        },
        {
            "name": ":host",
            "browsers": [
                "E79",
                "FF63",
                "FFA63",
                "S10",
                "SM10",
                "C54",
                "CA54",
                "O41"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:host"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "When evaluated in the context of a shadow tree, matches the shadow tree's host element."
        },
        {
            "name": ":host",
            "browsers": [
                "E79",
                "FF63",
                "FFA63",
                "S10",
                "SM10",
                "C54",
                "CA54",
                "O41"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:host"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "When evaluated in the context of a shadow tree, it matches the shadow tree's host element if the host element, in its normal context, matches the selector argument."
        },
        {
            "name": ":host-context",
            "browsers": [
                "E79",
                "C54",
                "CA54",
                "O41"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:host-context"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Tests whether there is an ancestor, outside the shadow tree, which matches a particular selector."
        },
        {
            "name": ":hover",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S2",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O4"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:hover"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Applies while the user designates an element with a pointing device, but does not necessarily activate it. For example, a visual user agent could apply this pseudo-class when the cursor (mouse pointer) hovers over a box generated by the element."
        },
        {
            "name": ":increment",
            "browsers": [
                "C",
                "S5"
            ],
            "description": "Non-standard. Applies to buttons and track pieces. Indicates whether or not the button or track piece will increment the view's position when used."
        },
        {
            "name": ":indeterminate",
            "browsers": [
                "E12",
                "FF2",
                "FFA4",
                "S3",
                "SM1",
                "C1",
                "CA18",
                "IE10",
                "O9"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:indeterminate"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Applies to UI elements whose value is in an indeterminate state."
        },
        {
            "name": ":in-range",
            "browsers": [
                "E13",
                "FF29",
                "FFA16",
                "S5.1",
                "SM5",
                "C10",
                "CA18",
                "O11"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:in-range"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-11-12",
                "baseline_high_date": "2018-05-12"
            },
            "description": "Used in conjunction with the min and max attributes, whether on a range input, a number field, or any other types that accept those attributes."
        },
        {
            "name": ":invalid",
            "browsers": [
                "E12",
                "FF4",
                "FFA4",
                "S5",
                "SM5",
                "C10",
                "CA18",
                "IE10",
                "O10"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:invalid"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "An element is :valid or :invalid when it is, respectively, valid or invalid with respect to data validity semantics defined by a different specification."
        },
        {
            "name": ":lang",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "IE8",
                "O8"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:lang"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Represents an element that is in language specified."
        },
        {
            "name": ":last-child",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "IE9",
                "O9.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:last-child"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Same as :nth-last-child(1). Represents an element that is the last child of some other element."
        },
        {
            "name": ":last-of-type",
            "browsers": [
                "E12",
                "FF3.5",
                "FFA4",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "IE9",
                "O9.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:last-of-type"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Same as :nth-last-of-type(1). Represents an element that is the last sibling of its type in the list of children of its parent element."
        },
        {
            "name": ":left",
            "browsers": [
                "E12",
                "S5",
                "SM4.2",
                "C6",
                "CA18",
                "IE8",
                "O9.2"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:left"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "When printing double-sided documents, the page boxes on left and right pages may be different. This can be expressed through CSS pseudo-classes defined in the  page context."
        },
        {
            "name": ":link",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM3.2",
                "C1",
                "CA18",
                "IE3",
                "O3.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:link"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Applies to links that have not yet been visited."
        },
        {
            "name": ":matches",
            "browsers": [
                "S9"
            ],
            "description": "Takes a selector list as its argument. It represents an element that is represented by its argument."
        },
        {
            "name": ":-moz-any",
            "browsers": [
                "FF4"
            ],
            "description": "Represents an element that is represented by the selector list passed as its argument. Standardized as :matches()."
        },
        {
            "name": ":-moz-any-link",
            "browsers": [
                "FF1"
            ],
            "description": "Represents an element that acts as the source anchor of a hyperlink. Applies to both visited and unvisited links."
        },
        {
            "name": ":-moz-broken",
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:-moz-broken"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Non-standard. Matches elements representing broken images."
        },
        {
            "name": ":-moz-drag-over",
            "browsers": [
                "FF1"
            ],
            "description": "Non-standard. Matches elements when a drag-over event applies to it."
        },
        {
            "name": ":-moz-first-node",
            "browsers": [
                "FF72",
                "FFA79"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:-moz-first-node"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Non-standard. Represents an element that is the first child node of some other element."
        },
        {
            "name": ":-moz-focusring",
            "browsers": [
                "FF4"
            ],
            "description": "Non-standard. Matches an element that has focus and focus ring drawing is enabled in the browser."
        },
        {
            "name": ":-moz-full-screen",
            "browsers": [
                "FF9"
            ],
            "description": "Matches any element that has its fullscreen flag set. Standardized as :fullscreen."
        },
        {
            "name": ":-moz-last-node",
            "browsers": [
                "FF72",
                "FFA79"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:-moz-last-node"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Non-standard. Represents an element that is the last child node of some other element."
        },
        {
            "name": ":-moz-loading",
            "browsers": [
                "FF3"
            ],
            "description": "Non-standard. Matches elements, such as images, that haven't started loading yet."
        },
        {
            "name": ":-moz-only-whitespace",
            "browsers": [
                "FF1",
                "FFA4"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:-moz-only-whitespace"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "The same as :empty, except that it additionally matches elements that only contain code points affected by whitespace processing. Standardized as :blank."
        },
        {
            "name": ":-moz-placeholder",
            "browsers": [
                "FF4"
            ],
            "description": "Deprecated. Represents placeholder text in an input field. Use ::-moz-placeholder for Firefox 19+."
        },
        {
            "name": ":-moz-submit-invalid",
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:-moz-submit-invalid"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Non-standard. Represents any submit button when the contents of the associated form are not valid."
        },
        {
            "name": ":-moz-suppressed",
            "browsers": [
                "FF3"
            ],
            "description": "Non-standard. Matches elements representing images that have been blocked from loading."
        },
        {
            "name": ":-moz-ui-invalid",
            "browsers": [
                "FF4"
            ],
            "description": "Non-standard. Represents any validated form element whose value isn't valid "
        },
        {
            "name": ":-moz-ui-valid",
            "browsers": [
                "FF4"
            ],
            "description": "Non-standard. Represents any validated form element whose value is valid "
        },
        {
            "name": ":-moz-user-disabled",
            "browsers": [
                "FF3"
            ],
            "description": "Non-standard. Matches elements representing images that have been disabled due to the user's preferences."
        },
        {
            "name": ":-moz-window-inactive",
            "browsers": [
                "FF4"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:-moz-window-inactive"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Non-standard. Matches elements in an inactive window."
        },
        {
            "name": ":-ms-fullscreen",
            "browsers": [
                "IE11"
            ],
            "description": "Matches any element that has its fullscreen flag set."
        },
        {
            "name": ":-ms-input-placeholder",
            "browsers": [
                "IE10"
            ],
            "description": "Represents placeholder text in an input field. Note: for Edge use the pseudo-element ::-ms-input-placeholder. Standardized as ::placeholder."
        },
        {
            "name": ":-ms-keyboard-active",
            "browsers": [
                "IE10"
            ],
            "description": "Windows Store apps only. Applies one or more styles to an element when it has focus and the user presses the space bar."
        },
        {
            "name": ":-ms-lang",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Represents an element that is in the language specified. Accepts a comma separated list of language tokens."
        },
        {
            "name": ":no-button",
            "browsers": [
                "C",
                "S5"
            ],
            "description": "Non-standard. Applies to track pieces. Applies when there is no button at that end of the track."
        },
        {
            "name": ":not",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "IE9",
                "O9.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:not"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "The negation pseudo-class, :not(X), is a functional notation taking a simple selector (excluding the negation pseudo-class itself) as an argument. It represents an element that is not represented by its argument."
        },
        {
            "name": ":nth-child",
            "browsers": [
                "E12",
                "FF3.5",
                "FFA4",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "IE9",
                "O9.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:nth-child"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Represents an element that has an+b-1 siblings before it in the document tree, for any positive integer or zero value of n, and has a parent element."
        },
        {
            "name": ":nth-last-child",
            "browsers": [
                "E12",
                "FF3.5",
                "FFA4",
                "S3.1",
                "SM2",
                "C4",
                "CA18",
                "IE9",
                "O9"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:nth-last-child"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Represents an element that has an+b-1 siblings after it in the document tree, for any positive integer or zero value of n, and has a parent element."
        },
        {
            "name": ":nth-last-of-type",
            "browsers": [
                "E12",
                "FF3.5",
                "FFA4",
                "S3.1",
                "SM2",
                "C4",
                "CA18",
                "IE9",
                "O9.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:nth-last-of-type"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Represents an element that has an+b-1 siblings with the same expanded element name after it in the document tree, for any zero or positive integer value of n, and has a parent element."
        },
        {
            "name": ":nth-of-type",
            "browsers": [
                "E12",
                "FF3.5",
                "FFA4",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "IE9",
                "O9.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:nth-of-type"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Represents an element that has an+b-1 siblings with the same expanded element name before it in the document tree, for any zero or positive integer value of n, and has a parent element."
        },
        {
            "name": ":only-child",
            "browsers": [
                "E12",
                "FF1.5",
                "FFA4",
                "S3.1",
                "SM2",
                "C2",
                "CA18",
                "IE9",
                "O9.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:only-child"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Represents an element that has a parent element and whose parent element has no other element children. Same as :first-child:last-child or :nth-child(1):nth-last-child(1), but with a lower specificity."
        },
        {
            "name": ":only-of-type",
            "browsers": [
                "E12",
                "FF3.5",
                "FFA4",
                "S3.1",
                "SM2",
                "C1",
                "CA18",
                "IE9",
                "O9.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:only-of-type"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Matches every element that is the only child of its type, of its parent. Same as :first-of-type:last-of-type or :nth-of-type(1):nth-last-of-type(1), but with a lower specificity."
        },
        {
            "name": ":optional",
            "browsers": [
                "E12",
                "FF4",
                "FFA4",
                "S5",
                "SM5",
                "C10",
                "CA18",
                "IE10",
                "O10"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:optional"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "A form element is :required or :optional if a value for it is, respectively, required or optional before the form it belongs to is submitted. Elements that are not form elements are neither required nor optional."
        },
        {
            "name": ":out-of-range",
            "browsers": [
                "E13",
                "FF29",
                "FFA16",
                "S5.1",
                "SM5",
                "C10",
                "CA18",
                "O11"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:out-of-range"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-11-12",
                "baseline_high_date": "2018-05-12"
            },
            "description": "Used in conjunction with the min and max attributes, whether on a range input, a number field, or any other types that accept those attributes."
        },
        {
            "name": ":past",
            "browsers": [
                "E79",
                "S7",
                "SM7",
                "C23",
                "CA25",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:past"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Represents any element that is defined to occur entirely prior to a :current element."
        },
        {
            "name": ":read-only",
            "browsers": [
                "E13",
                "FF78",
                "FFA79",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O9"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:read-only"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-07-28",
                "baseline_high_date": "2023-01-28"
            },
            "description": "An element whose contents are not user-alterable is :read-only. However, elements whose contents are user-alterable (such as text input fields) are considered to be in a :read-write state. In typical documents, most elements are :read-only."
        },
        {
            "name": ":read-write",
            "browsers": [
                "E13",
                "FF78",
                "FFA79",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "O9"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:read-write"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-07-28",
                "baseline_high_date": "2023-01-28"
            },
            "description": "An element whose contents are not user-alterable is :read-only. However, elements whose contents are user-alterable (such as text input fields) are considered to be in a :read-write state. In typical documents, most elements are :read-only."
        },
        {
            "name": ":required",
            "browsers": [
                "E12",
                "FF4",
                "FFA4",
                "S5",
                "SM5",
                "C10",
                "CA18",
                "IE10",
                "O10"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:required"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "A form element is :required or :optional if a value for it is, respectively, required or optional before the form it belongs to is submitted. Elements that are not form elements are neither required nor optional."
        },
        {
            "name": ":right",
            "browsers": [
                "E12",
                "S5",
                "SM4.2",
                "C6",
                "CA18",
                "IE8",
                "O9.2"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:right"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "When printing double-sided documents, the page boxes on left and right pages may be different. This can be expressed through CSS pseudo-classes defined in the  page context."
        },
        {
            "name": ":root",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE9",
                "O9.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:root"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Represents an element that is the root of the document. In HTML 4, this is always the HTML element."
        },
        {
            "name": ":scope",
            "browsers": [
                "E79",
                "FF32",
                "FFA32",
                "S7",
                "SM7",
                "C27",
                "CA27",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:scope"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            },
            "description": "Represents any element that is in the contextual reference element set."
        },
        {
            "name": ":single-button",
            "browsers": [
                "C",
                "S5"
            ],
            "description": "Non-standard. Applies to buttons and track pieces. Applies when both buttons are displayed separately at either end of the scrollbar."
        },
        {
            "name": ":start",
            "browsers": [
                "C",
                "S5"
            ],
            "description": "Non-standard. Applies to buttons and track pieces. Indicates whether the object is placed before the thumb."
        },
        {
            "name": ":target",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1.3",
                "SM2",
                "C1",
                "CA18",
                "IE9",
                "O9.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:target"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Some URIs refer to a location within a resource. This kind of URI ends with a 'number sign' (#) followed by an anchor identifier (called the fragment identifier)."
        },
        {
            "name": ":valid",
            "browsers": [
                "E12",
                "FF4",
                "FFA4",
                "S5",
                "SM5",
                "C10",
                "CA18",
                "IE10",
                "O10"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:valid"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "An element is :valid or :invalid when it is, respectively, valid or invalid with respect to data validity semantics defined by a different specification."
        },
        {
            "name": ":vertical",
            "browsers": [
                "C",
                "S5"
            ],
            "description": "Non-standard. Applies to any scrollbar pieces that have a vertical orientation."
        },
        {
            "name": ":visited",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE4",
                "O3.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:visited"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Applies once the link has been visited by the user."
        },
        {
            "name": ":-webkit-any",
            "browsers": [
                "C",
                "S5"
            ],
            "description": "Represents an element that is represented by the selector list passed as its argument. Standardized as :matches()."
        },
        {
            "name": ":-webkit-full-screen",
            "browsers": [
                "C",
                "S6"
            ],
            "description": "Matches any element that has its fullscreen flag set. Standardized as :fullscreen."
        },
        {
            "name": ":window-inactive",
            "browsers": [
                "C",
                "S3"
            ],
            "description": "Non-standard. Applies to all scrollbar pieces. Indicates whether or not the window containing the scrollbar is currently active."
        },
        {
            "name": ":active-view-transition",
            "description": "",
            "browsers": [
                "E125",
                "S18",
                "SM18",
                "C125",
                "CA125",
                "O111"
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": ":active-view-transition-type",
            "description": "",
            "browsers": [
                "E125",
                "S18.2",
                "SM18.2",
                "C125",
                "CA125",
                "O111"
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": ":autofill",
            "description": "The :autofill CSS pseudo-class matches when an input element has its value autofilled by the browser. The class stops matching if the user edits the field.",
            "browsers": [
                "E110",
                "FF86",
                "FFA86",
                "S15",
                "SM15",
                "C110",
                "CA110",
                "O96"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:autofill"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-02-09"
            }
        },
        {
            "name": ":blank",
            "description": "The :blank CSS pseudo-class selects empty user input elements (eg. <input> or <textarea>).",
            "status": "experimental"
        },
        {
            "name": ":buffering",
            "description": "The :buffering CSS pseudo-class selector represents an element that is playable, such as audio or video, when the playable element is buffering a media resource.",
            "browsers": [
                "S15.4",
                "SM15.4"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:buffering"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": ":current",
            "description": "The :current CSS pseudo-class selector is a time-dimensional pseudo-class that represents the element, or an ancestor of the element, that is currently being displayed",
            "status": "experimental"
        },
        {
            "name": ":defined",
            "description": "The :defined CSS pseudo-class represents any element that has been defined. This includes any standard element built in to the browser, and custom elements that have been successfully defined (i.e. with the CustomElementRegistry.define() method).",
            "browsers": [
                "E79",
                "FF63",
                "FFA63",
                "S10",
                "SM10",
                "C54",
                "CA54",
                "O41"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:defined"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            }
        },
        {
            "name": ":dir",
            "description": "The :dir() CSS pseudo-class matches elements based on the directionality of the text contained in them.",
            "browsers": [
                "E120",
                "FF49",
                "FFA49",
                "S16.4",
                "SM16.4",
                "C120",
                "CA120",
                "O106"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:dir"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-12-07"
            }
        },
        {
            "name": ":focus-visible",
            "description": "The :focus-visible pseudo-class applies while an element matches the :focus pseudo-class and the UA determines via heuristics that the focus should be made evident on the element.",
            "browsers": [
                "E86",
                "FF85",
                "FFA85",
                "S15.4",
                "SM15.4",
                "C86",
                "CA86",
                "O72"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:focus-visible"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-03-14",
                "baseline_high_date": "2024-09-14"
            }
        },
        {
            "name": ":focus-within",
            "description": "The :focus-within pseudo-class applies to any element for which the :focus pseudo class applies as well as to an element whose descendant in the flat tree (including non-element nodes, such as text nodes) matches the conditions for matching :focus.",
            "browsers": [
                "E79",
                "FF52",
                "FFA52",
                "S10.1",
                "SM10.3",
                "C60",
                "CA60",
                "O47"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:focus-within"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            }
        },
        {
            "name": ":has",
            "description": "The functional :has() CSS pseudo-class represents an element if any of the relative selectors that are passed as an argument match at least one element when anchored against this element. ",
            "browsers": [
                "E105",
                "FF121",
                "FFA121",
                "S15.4",
                "SM15.4",
                "C105",
                "CA105",
                "O91"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:has"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-12-19"
            }
        },
        {
            "name": ":has-slotted",
            "description": "The :has-slotted CSS pseudo-class matches when the content of a slot element is not empty or not using the default value (see Using templates and slots for more information).",
            "browsers": [
                "E134",
                "FF136",
                "FFA136",
                "C134",
                "CA134",
                "O119"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:has-slotted"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": ":is",
            "description": "The :is() CSS pseudo-class function takes a selector list as its argument, and selects any element that can be selected by one of the selectors in that list. This is useful for writing large selectors in a more compact form.",
            "browsers": [
                "E88",
                "FF78",
                "FFA79",
                "S14",
                "SM14",
                "C88",
                "CA88",
                "O74"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:is"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-01-21",
                "baseline_high_date": "2023-07-21"
            }
        },
        {
            "name": ":local-link",
            "description": "The :local-link CSS pseudo-class represents an link to the same document",
            "status": "experimental"
        },
        {
            "name": ":modal",
            "description": "The :modal CSS pseudo-class matches an element that is in a state in which it excludes all interaction with elements outside it until the interaction has been dismissed. Multiple elements can be selected by the :modal pseudo-class at the same time, but only one of them will be active and able to receive input.",
            "browsers": [
                "E105",
                "FF103",
                "FFA103",
                "S15.6",
                "SM15.6",
                "C105",
                "CA105",
                "O91"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:modal"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-09-02",
                "baseline_high_date": "2025-03-02"
            }
        },
        {
            "name": ":muted",
            "description": "The :muted CSS pseudo-class selector represents an element that is capable of making sound, such as audio or video, but is muted (forced silent).",
            "browsers": [
                "S15.4",
                "SM15.4"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:muted"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": ":open",
            "description": "The :open CSS pseudo-class represents an element that has open and closed states, only when it is currently in the open state.",
            "browsers": [
                "E133",
                "FF136",
                "FFA136",
                "C133",
                "CA133",
                "O118"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:open"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": ":paused",
            "description": "The :paused CSS pseudo-class selector is a resource state pseudo-class that will match an audio, video, or similar resource that is capable of being \u201Cplayed\u201D or \u201Cpaused\u201D, when that element is \u201Cpaused\u201D.",
            "browsers": [
                "S15.4",
                "SM15.4"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:paused"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": ":picture-in-picture",
            "description": "The :picture-in-picture CSS pseudo-class matches the element which is currently in picture-in-picture mode.",
            "browsers": [
                "E110",
                "S13.1",
                "SM13.4",
                "C110",
                "CA110",
                "O96"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:picture-in-picture"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": ":placeholder-shown",
            "description": "The :placeholder-shown CSS pseudo-class represents any <input> or <textarea> element that is currently displaying placeholder text.",
            "browsers": [
                "E79",
                "FF51",
                "FFA51",
                "S9",
                "SM9",
                "C47",
                "CA47",
                "IE10",
                "O34"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:placeholder-shown"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            }
        },
        {
            "name": ":playing",
            "description": "The :playing CSS pseudo-class selector is a resource state pseudo-class that will match an audio, video, or similar resource that is capable of being \u201Cplayed\u201D or \u201Cpaused\u201D, when that element is \u201Cplaying\u201D. ",
            "browsers": [
                "S15.4",
                "SM15.4"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:playing"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": ":popover-open",
            "description": "The :popover-open CSS pseudo-class represents a {{domxref(\"Popover API\", \"popover\", \"\", \"nocode\")}} element (i.e. one with a popover attribute) that is in the showing state. You can use this to apply style to popover elements only when they are shown.",
            "browsers": [
                "E114",
                "FF125",
                "FFA125",
                "S17",
                "SM17",
                "C114",
                "CA114",
                "O100"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:popover-open"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-04-16"
            }
        },
        {
            "name": ":seeking",
            "description": "The :seeking CSS pseudo-class selector represents an element that is playable, such as audio or video, when the playable element is seeking a playback position in the media resource.",
            "browsers": [
                "S15.4",
                "SM15.4"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:seeking"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": ":stalled",
            "description": "The :stalled CSS pseudo-class selector represents an element that is playable, such as audio or video, when playback is stalled.",
            "browsers": [
                "S15.4",
                "SM15.4"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:stalled"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": ":state",
            "description": "The :state() CSS pseudo-class matches custom elements that have the specified custom state.",
            "browsers": [
                "E125",
                "FF126",
                "FFA126",
                "S17.4",
                "SM17.4",
                "C125",
                "CA125",
                "O111"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:state"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-05-17"
            }
        },
        {
            "name": ":target-current",
            "description": "The :target-current CSS pseudo-class selects the active scroll marker \u2014 the ::scroll-marker pseudo-element of a scroll-marker-group that is currently scrolled to. This selector can be used to style the active navigation position within a scroll marker group.",
            "status": "experimental",
            "browsers": [
                "E135",
                "C135",
                "O120"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:target-current"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": ":target-within",
            "description": "The :target-within CSS pseudo-class represents an element that is a target element or contains an element that is a target. A target element is a unique element with an id matching the URL's fragment.",
            "status": "experimental"
        },
        {
            "name": ":user-invalid",
            "description": "The :user-invalid CSS pseudo-class represents any validated form element whose value isn't valid based on their validation constraints, after the user has interacted with it.",
            "browsers": [
                "E119",
                "FF88",
                "FFA88",
                "S16.5",
                "SM16.5",
                "C119",
                "CA119",
                "O105"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:user-invalid"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-11-02"
            }
        },
        {
            "name": ":user-valid",
            "description": "The :user-valid CSS pseudo-class represents any validated form element whose value validates correctly based on its validation constraints. However, unlike :valid it only matches once the user has interacted with it.",
            "browsers": [
                "E119",
                "FF88",
                "FFA88",
                "S16.5",
                "SM16.5",
                "C119",
                "CA119",
                "O105"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:user-valid"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2023-11-02"
            }
        },
        {
            "name": ":volume-locked",
            "description": "The :volume-locked CSS pseudo-class selector represents an element that is capable of making sound, such as audio or video, but the audio volume of the media element is currently \"locked\" by the user.",
            "browsers": [
                "S15.4",
                "SM15.4"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:volume-locked"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": ":where",
            "description": "The :where() CSS pseudo-class function takes a selector list as its argument, and selects any element that can be selected by one of the selectors in that list.",
            "browsers": [
                "E88",
                "FF78",
                "FFA79",
                "S14",
                "SM14",
                "C88",
                "CA88",
                "O74"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/:where"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-01-21",
                "baseline_high_date": "2023-07-21"
            }
        },
        {
            "name": ":xr-overlay",
            "description": "",
            "status": "experimental",
            "browsers": [
                "E83",
                "C83",
                "CA83",
                "O69"
            ],
            "baseline": {
                "status": "false"
            }
        }
    ],
    "pseudoElements": [
        {
            "name": "::after",
            "browsers": [
                "E12",
                "FF1.5",
                "FFA4",
                "S4",
                "SM3.2",
                "C1",
                "CA18",
                "IE9",
                "O7"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::after"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Represents a styleable child pseudo-element immediately after the originating element's actual content."
        },
        {
            "name": "::backdrop",
            "browsers": [
                "E79",
                "FF47",
                "FFA47",
                "S15.4",
                "SM15.4",
                "C37",
                "CA37",
                "IE11",
                "O24"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::backdrop"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2022-03-14",
                "baseline_high_date": "2024-09-14"
            },
            "description": "Used to create a backdrop that hides the underlying document for an element in a top layer (such as an element that is displayed fullscreen)."
        },
        {
            "name": "::before",
            "browsers": [
                "E12",
                "FF1.5",
                "FFA4",
                "S4",
                "SM3",
                "C1",
                "CA18",
                "IE9",
                "O7"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::before"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Represents a styleable child pseudo-element immediately before the originating element's actual content."
        },
        {
            "name": "::content",
            "browsers": [
                "C35",
                "O22"
            ],
            "description": "Deprecated. Matches the distribution list itself, on elements that have one. Use ::slotted for forward compatibility."
        },
        {
            "name": "::cue",
            "browsers": [
                "E79",
                "FF55",
                "FFA55",
                "S7",
                "SM7",
                "C26",
                "CA26",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::cue"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            }
        },
        {
            "name": "::cue",
            "browsers": [
                "E79",
                "FF55",
                "FFA55",
                "S7",
                "SM7",
                "C26",
                "CA26",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::cue"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            }
        },
        {
            "name": "::cue-region",
            "browsers": [
                "C",
                "O16",
                "S6"
            ]
        },
        {
            "name": "::cue-region",
            "browsers": [
                "C",
                "O16",
                "S6"
            ]
        },
        {
            "name": "::first-letter",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE9",
                "O7"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::first-letter"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Represents the first letter of an element, if it is not preceded by any other content (such as images or inline tables) on its line."
        },
        {
            "name": "::first-line",
            "browsers": [
                "E12",
                "FF1",
                "FFA4",
                "S1",
                "SM1",
                "C1",
                "CA18",
                "IE9",
                "O7"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::first-line"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2015-07-29",
                "baseline_high_date": "2018-01-29"
            },
            "description": "Describes the contents of the first formatted line of its originating element."
        },
        {
            "name": "::-moz-focus-inner",
            "browsers": [
                "FF72",
                "FFA79"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-moz-focus-inner"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-moz-focus-outer",
            "browsers": [
                "FF4"
            ]
        },
        {
            "name": "::-moz-list-bullet",
            "browsers": [
                "FF72",
                "FFA79"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-moz-list-bullet"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Used to style the bullet of a list element. Similar to the standardized ::marker."
        },
        {
            "name": "::-moz-list-number",
            "browsers": [
                "FF72",
                "FFA79"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-moz-list-number"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Used to style the numbers of a list element. Similar to the standardized ::marker."
        },
        {
            "name": "::-moz-placeholder",
            "browsers": [
                "FF19"
            ],
            "description": "Represents placeholder text in an input field"
        },
        {
            "name": "::-moz-progress-bar",
            "browsers": [
                "FF72",
                "FFA79"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-moz-progress-bar"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Represents the bar portion of a progress bar."
        },
        {
            "name": "::-moz-selection",
            "browsers": [
                "FF1"
            ],
            "description": "Represents the portion of a document that has been highlighted by the user."
        },
        {
            "name": "::-ms-backdrop",
            "browsers": [
                "IE11"
            ],
            "description": "Used to create a backdrop that hides the underlying document for an element in a top layer (such as an element that is displayed fullscreen)."
        },
        {
            "name": "::-ms-browse",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Represents the browse button of an input type=file control."
        },
        {
            "name": "::-ms-check",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Represents the check of a checkbox or radio button input control."
        },
        {
            "name": "::-ms-clear",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Represents the clear button of a text input control"
        },
        {
            "name": "::-ms-expand",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Represents the drop-down button of a select control."
        },
        {
            "name": "::-ms-fill",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Represents the bar portion of a progress bar."
        },
        {
            "name": "::-ms-fill-lower",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Represents the portion of the slider track from its smallest value up to the value currently selected by the thumb. In a left-to-right layout, this is the portion of the slider track to the left of the thumb."
        },
        {
            "name": "::-ms-fill-upper",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Represents the portion of the slider track from the value currently selected by the thumb up to the slider's largest value. In a left-to-right layout, this is the portion of the slider track to the right of the thumb."
        },
        {
            "name": "::-ms-reveal",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Represents the password reveal button of an input type=password control."
        },
        {
            "name": "::-ms-thumb",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Represents the portion of range input control (also known as a slider control) that the user drags."
        },
        {
            "name": "::-ms-ticks-after",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Represents the tick marks of a slider that begin just after the thumb and continue up to the slider's largest value. In a left-to-right layout, these are the ticks to the right of the thumb."
        },
        {
            "name": "::-ms-ticks-before",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Represents the tick marks of a slider that represent its smallest values up to the value currently selected by the thumb. In a left-to-right layout, these are the ticks to the left of the thumb."
        },
        {
            "name": "::-ms-tooltip",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Represents the tooltip of a slider (input type=range)."
        },
        {
            "name": "::-ms-track",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Represents the track of a slider."
        },
        {
            "name": "::-ms-value",
            "browsers": [
                "E",
                "IE10"
            ],
            "description": "Represents the content of a text or password input control, or a select control."
        },
        {
            "name": "::selection",
            "browsers": [
                "E12",
                "FF62",
                "FFA62",
                "S1.1",
                "C1",
                "CA18",
                "IE9",
                "O9.5"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::selection"
                }
            ],
            "baseline": {
                "status": "false"
            },
            "description": "Represents the portion of a document that has been highlighted by the user."
        },
        {
            "name": "::shadow",
            "browsers": [
                "C35",
                "O22"
            ],
            "description": "Matches the shadow root if an element has a shadow tree."
        },
        {
            "name": "::-webkit-file-upload-button",
            "browsers": [
                "C",
                "O",
                "S6"
            ]
        },
        {
            "name": "::-webkit-inner-spin-button",
            "browsers": [
                "E79",
                "S5",
                "SM4.2",
                "C6",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-inner-spin-button"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-input-placeholder",
            "browsers": [
                "C",
                "S4"
            ]
        },
        {
            "name": "::-webkit-keygen-select",
            "browsers": [
                "C",
                "O",
                "S6"
            ]
        },
        {
            "name": "::-webkit-meter-bar",
            "browsers": [
                "E79",
                "S5.1",
                "SM5",
                "C12",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-meter-bar"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-meter-even-less-good-value",
            "browsers": [
                "E79",
                "S5.1",
                "SM5",
                "C12",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-meter-even-less-good-value"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-meter-optimum-value",
            "browsers": [
                "E79",
                "S5.1",
                "SM5",
                "C12",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-meter-optimum-value"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-meter-suboptimum-value",
            "browsers": [
                "E79",
                "S5.1",
                "SM5",
                "C12",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-meter-suboptimum-value"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-outer-spin-button",
            "browsers": [
                "C",
                "O",
                "S6"
            ]
        },
        {
            "name": "::-webkit-progress-bar",
            "browsers": [
                "E79",
                "S7",
                "SM7",
                "C25",
                "CA25",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-progress-bar"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-progress-inner-element",
            "browsers": [
                "E79",
                "S7",
                "SM7",
                "C23",
                "CA25",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-progress-inner-element"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-progress-value",
            "browsers": [
                "E79",
                "S7",
                "SM7",
                "C25",
                "CA25",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-progress-value"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-resizer",
            "browsers": [
                "E79",
                "S4",
                "SM3.2",
                "C2",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-scrollbar"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-scrollbar",
            "browsers": [
                "E79",
                "S4",
                "SM3",
                "C2",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-scrollbar"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-scrollbar-button",
            "browsers": [
                "E79",
                "S4",
                "C2",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-scrollbar"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-scrollbar-corner",
            "browsers": [
                "E79",
                "S4",
                "C2",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-scrollbar"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-scrollbar-thumb",
            "browsers": [
                "E79",
                "S4",
                "C2",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-scrollbar"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-scrollbar-track",
            "browsers": [
                "E79",
                "S4",
                "C2",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-scrollbar"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-scrollbar-track-piece",
            "browsers": [
                "E79",
                "S4",
                "C2",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-scrollbar"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-search-cancel-button",
            "browsers": [
                "E79",
                "S3",
                "SM1",
                "C1",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-search-cancel-button"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-search-decoration",
            "browsers": [
                "C",
                "S4"
            ]
        },
        {
            "name": "::-webkit-search-results-button",
            "browsers": [
                "E79",
                "S3",
                "SM1",
                "C1",
                "CA18",
                "O15"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-search-results-button"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-search-results-decoration",
            "browsers": [
                "C",
                "S4"
            ]
        },
        {
            "name": "::-webkit-slider-runnable-track",
            "browsers": [
                "E83",
                "S18",
                "SM18",
                "C83",
                "CA83",
                "O69"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-slider-runnable-track"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-slider-thumb",
            "browsers": [
                "E83",
                "S18",
                "SM18",
                "C83",
                "CA83",
                "O69"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-webkit-slider-thumb"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-textfield-decoration-container",
            "browsers": [
                "C",
                "O",
                "S6"
            ]
        },
        {
            "name": "::-webkit-validation-bubble",
            "browsers": [
                "C",
                "O",
                "S6"
            ]
        },
        {
            "name": "::-webkit-validation-bubble-arrow",
            "browsers": [
                "C",
                "O",
                "S6"
            ]
        },
        {
            "name": "::-webkit-validation-bubble-arrow-clipper",
            "browsers": [
                "C",
                "O",
                "S6"
            ]
        },
        {
            "name": "::-webkit-validation-bubble-heading",
            "browsers": [
                "C",
                "O",
                "S6"
            ]
        },
        {
            "name": "::-webkit-validation-bubble-message",
            "browsers": [
                "C",
                "O",
                "S6"
            ]
        },
        {
            "name": "::-webkit-validation-bubble-text-block",
            "browsers": [
                "C",
                "O",
                "S6"
            ]
        },
        {
            "name": "::-moz-range-progress",
            "description": "The ::-moz-range-progress CSS pseudo-element is a Mozilla extension that represents the lower portion of the track (i.e., groove) in which the indicator slides in an <input> of type=\"range\". This portion corresponds to values lower than the value currently selected by the thumb (i.e., virtual knob).",
            "status": "nonstandard",
            "browsers": [
                "FF22",
                "FFA22"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-moz-range-progress"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-moz-range-thumb",
            "description": "The ::-moz-range-thumb CSS pseudo-element is a Mozilla extension that represents the thumb (i.e., virtual knob) of an <input> of type=\"range\". The user can move the thumb along the input's track to alter its numerical value.",
            "status": "nonstandard",
            "browsers": [
                "FF21",
                "FFA21"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-moz-range-thumb"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-moz-range-track",
            "description": "The ::-moz-range-track CSS pseudo-element is a Mozilla extension that represents the track (i.e., groove) in which the indicator slides in an <input> of type=\"range\".",
            "status": "nonstandard",
            "browsers": [
                "FF21",
                "FFA21"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::-moz-range-track"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::-webkit-progress-inner-value",
            "description": "The ::-webkit-progress-value CSS pseudo-element represents the filled-in portion of the bar of a <progress> element. It is a child of the ::-webkit-progress-bar pseudo-element.\n\nIn order to let ::-webkit-progress-value take effect, -webkit-appearance needs to be set to none on the <progress> element.",
            "status": "nonstandard"
        },
        {
            "name": "::checkmark",
            "description": "The ::checkmark CSS pseudo-element targets the checkmark placed inside the currently-selected option element of a customizable select element. It can be used to provide a visual indication of which option is selected.",
            "browsers": [
                "E133",
                "C133",
                "CA133",
                "O118"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::checkmark"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::details-content",
            "description": "The ::details-content CSS pseudo-element represents the expandable/collapsible contents of a details element.",
            "browsers": [
                "E131",
                "S18.4",
                "SM18.4",
                "C131",
                "CA131",
                "O116"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::details-content"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::file-selector-button",
            "description": "The ::file-selector-button CSS pseudo-element represents the button of an input of type=\"file\".",
            "browsers": [
                "E89",
                "FF82",
                "FFA82",
                "S14.1",
                "SM14.5",
                "C89",
                "CA89",
                "IE10",
                "O75"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::file-selector-button"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2021-04-26",
                "baseline_high_date": "2023-10-26"
            }
        },
        {
            "name": "::grammar-error",
            "description": "The ::grammar-error CSS pseudo-element represents a text segment which the user agent has flagged as grammatically incorrect.",
            "browsers": [
                "E121",
                "S17.4",
                "SM17.4",
                "C121",
                "CA121",
                "O107"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::grammar-error"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::highlight",
            "description": "The ::highlight() CSS pseudo-element applies styles to a custom highlight.",
            "browsers": [
                "E105",
                "S17.2",
                "SM17.2",
                "C105",
                "CA105",
                "O91"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::highlight"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::marker",
            "description": "The ::marker CSS pseudo-element selects the marker box of a list item, which typically contains a bullet or number. It works on any element or pseudo-element set to display: list-item, such as the <li> and <summary> elements.",
            "browsers": [
                "E86",
                "FF68",
                "FFA68",
                "C86",
                "CA86",
                "O72"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::marker"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::part",
            "description": "The ::part CSS pseudo-element represents any element within a shadow tree that has a matching part attribute.",
            "browsers": [
                "E79",
                "FF72",
                "FFA79",
                "S13.1",
                "SM13.4",
                "C73",
                "CA73",
                "O60"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::part"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-07-28",
                "baseline_high_date": "2023-01-28"
            }
        },
        {
            "name": "::picker-icon",
            "description": "The ::picker-icon CSS pseudo-element targets the picker icon inside form controls that have an icon associated with them. In the case of a customizable select element, it selects the arrow icon shown on the <select> element that points down when it is closed.",
            "browsers": [
                "E133",
                "C133",
                "CA133",
                "O118"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::picker-icon"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::picker",
            "description": "The ::picker() CSS pseudo-element targets the picker part of an element, for example the drop-down picker of a customizable select element.",
            "browsers": [
                "E134",
                "C134",
                "CA134",
                "O119"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::picker"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::placeholder",
            "description": "The ::placeholder CSS pseudo-element represents the placeholder text of a form element.",
            "browsers": [
                "E79",
                "FF51",
                "FFA51",
                "S10.1",
                "SM10.3",
                "C57",
                "CA57",
                "O44"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::placeholder"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            }
        },
        {
            "name": "::scroll-marker",
            "description": "The ::scroll-marker CSS pseudo-element can be generated inside any element and represents its scroll marker. All elements can have a ::scroll-marker pseudo-element, which is placed into the ::scroll-marker-group of the nearest scroll container ancestor. A scroll marker behaves like an anchor (a element) whose scroll target is the marker's originating element \u2014 and scrolls the scroll container to that element when activated.",
            "status": "experimental",
            "browsers": [
                "E135",
                "C135",
                "O120"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::scroll-marker"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::scroll-marker-group",
            "description": "The ::scroll-marker-group CSS pseudo-element is generated inside a scroll container and contains any ::scroll-marker pseudo-elements generated on descendants of the scroll container.",
            "status": "experimental",
            "browsers": [
                "E135",
                "C135",
                "O120"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::scroll-marker-group"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::slotted",
            "description": "The ::slotted() CSS pseudo-element represents any element that has been placed into a slot inside an HTML template (see Using templates and slots for more information).",
            "browsers": [
                "E79",
                "FF63",
                "FFA63",
                "S10",
                "SM10",
                "C50",
                "CA50",
                "O37"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::slotted"
                }
            ],
            "baseline": {
                "status": "high",
                "baseline_low_date": "2020-01-15",
                "baseline_high_date": "2022-07-15"
            }
        },
        {
            "name": "::spelling-error",
            "description": "The ::spelling-error CSS pseudo-element represents a text segment which the user agent has flagged as incorrectly spelled.",
            "browsers": [
                "E121",
                "S17.4",
                "SM17.4",
                "C121",
                "CA121",
                "O107"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::spelling-error"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::target-text",
            "description": "The ::target-text CSS pseudo-element represents the text that has been scrolled to if the browser supports scroll-to-text fragments. It allows authors to choose how to highlight that section of text.",
            "browsers": [
                "E89",
                "FF131",
                "FFA131",
                "S18.2",
                "SM18.2",
                "C89",
                "CA89",
                "O75"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::target-text"
                }
            ],
            "baseline": {
                "status": "low",
                "baseline_low_date": "2024-12-11"
            }
        },
        {
            "name": "::view-transition",
            "description": "The ::view-transition CSS pseudo-element represents the root of the view transitions overlay, which contains all view transitions and sits over the top of all other page content.",
            "browsers": [
                "E109",
                "FFpreview",
                "S18",
                "SM18",
                "C109",
                "CA109",
                "O95"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::view-transition"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::view-transition-group",
            "description": "The ::view-transition-group CSS pseudo-element represents a single view transition snapshot group.",
            "browsers": [
                "E109",
                "FFpreview",
                "S18",
                "SM18",
                "C109",
                "CA109",
                "O95"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::view-transition-group"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::view-transition-image-pair",
            "description": 'The ::view-transition-image-pair CSS pseudo-element represents a container for a view transition\'s "old" and "new" view states \u2014 before and after the transition.',
            "browsers": [
                "E109",
                "FFpreview",
                "S18",
                "SM18",
                "C109",
                "CA109",
                "O95"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::view-transition-image-pair"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::view-transition-new",
            "description": 'The ::view-transition-new CSS pseudo-element represents the "new" view state of a view transition \u2014 a snapshot live representation of the state after the transition.',
            "browsers": [
                "E109",
                "FFpreview",
                "S18",
                "SM18",
                "C109",
                "CA109",
                "O95"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::view-transition-new"
                }
            ],
            "baseline": {
                "status": "false"
            }
        },
        {
            "name": "::view-transition-old",
            "description": 'The ::view-transition-old CSS pseudo-element represents the "old" view state of a view transition \u2014 a static snapshot of the old view, before the transition.',
            "browsers": [
                "E109",
                "FFpreview",
                "S18",
                "SM18",
                "C109",
                "CA109",
                "O95"
            ],
            "references": [
                {
                    "name": "MDN Reference",
                    "url": "https://developer.mozilla.org/docs/Web/CSS/::view-transition-old"
                }
            ],
            "baseline": {
                "status": "false"
            }
        }
    ]
};


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 'use strict';
class $45cbb8eddbe7f8fa$export$2057e1882a1e5cdb {
    /**
     * Currently, unversioned data uses the V1 implementation
     * In the future when the provider handles multiple versions of HTML custom data,
     * use the latest implementation for unversioned data
     */ constructor(data){
        this._properties = [];
        this._atDirectives = [];
        this._pseudoClasses = [];
        this._pseudoElements = [];
        this.addData(data);
    }
    provideProperties() {
        return this._properties;
    }
    provideAtDirectives() {
        return this._atDirectives;
    }
    providePseudoClasses() {
        return this._pseudoClasses;
    }
    providePseudoElements() {
        return this._pseudoElements;
    }
    addData(data) {
        if (Array.isArray(data.properties)) {
            for (const prop of data.properties)if ($45cbb8eddbe7f8fa$var$isPropertyData(prop)) this._properties.push(prop);
        }
        if (Array.isArray(data.atDirectives)) {
            for (const prop of data.atDirectives)if ($45cbb8eddbe7f8fa$var$isAtDirective(prop)) this._atDirectives.push(prop);
        }
        if (Array.isArray(data.pseudoClasses)) {
            for (const prop of data.pseudoClasses)if ($45cbb8eddbe7f8fa$var$isPseudoClassData(prop)) this._pseudoClasses.push(prop);
        }
        if (Array.isArray(data.pseudoElements)) {
            for (const prop of data.pseudoElements)if ($45cbb8eddbe7f8fa$var$isPseudoElementData(prop)) this._pseudoElements.push(prop);
        }
    }
}
function $45cbb8eddbe7f8fa$var$isPropertyData(d) {
    return typeof d.name === 'string';
}
function $45cbb8eddbe7f8fa$var$isAtDirective(d) {
    return typeof d.name === 'string';
}
function $45cbb8eddbe7f8fa$var$isPseudoClassData(d) {
    return typeof d.name === 'string';
}
function $45cbb8eddbe7f8fa$var$isPseudoElementData(d) {
    return typeof d.name === 'string';
}


'use strict';
class $7280658853b575f9$export$341915a4e412d5c7 {
    constructor(options){
        this.dataProviders = [];
        this._propertySet = {};
        this._atDirectiveSet = {};
        this._pseudoClassSet = {};
        this._pseudoElementSet = {};
        this._properties = [];
        this._atDirectives = [];
        this._pseudoClasses = [];
        this._pseudoElements = [];
        this.setDataProviders(options?.useDefaultDataProvider !== false, options?.customDataProviders || []);
    }
    setDataProviders(builtIn, providers) {
        this.dataProviders = [];
        if (builtIn) this.dataProviders.push(new (0, $45cbb8eddbe7f8fa$export$2057e1882a1e5cdb)((0, $62f4aa6a9f7f37a5$export$a300ecb306a53ef5)));
        this.dataProviders.push(...providers);
        this.collectData();
    }
    /**
     * Collect all data  & handle duplicates
     */ collectData() {
        this._propertySet = {};
        this._atDirectiveSet = {};
        this._pseudoClassSet = {};
        this._pseudoElementSet = {};
        this.dataProviders.forEach((provider)=>{
            provider.provideProperties().forEach((p)=>{
                if (!this._propertySet[p.name]) this._propertySet[p.name] = p;
            });
            provider.provideAtDirectives().forEach((p)=>{
                if (!this._atDirectiveSet[p.name]) this._atDirectiveSet[p.name] = p;
            });
            provider.providePseudoClasses().forEach((p)=>{
                if (!this._pseudoClassSet[p.name]) this._pseudoClassSet[p.name] = p;
            });
            provider.providePseudoElements().forEach((p)=>{
                if (!this._pseudoElementSet[p.name]) this._pseudoElementSet[p.name] = p;
            });
        });
        this._properties = $e213756046234466$export$68c286be0e7e55b7(this._propertySet);
        this._atDirectives = $e213756046234466$export$68c286be0e7e55b7(this._atDirectiveSet);
        this._pseudoClasses = $e213756046234466$export$68c286be0e7e55b7(this._pseudoClassSet);
        this._pseudoElements = $e213756046234466$export$68c286be0e7e55b7(this._pseudoElementSet);
    }
    getProperty(name) {
        return this._propertySet[name];
    }
    getAtDirective(name) {
        return this._atDirectiveSet[name];
    }
    getPseudoClass(name) {
        return this._pseudoClassSet[name];
    }
    getPseudoElement(name) {
        return this._pseudoElementSet[name];
    }
    getProperties() {
        return this._properties;
    }
    getAtDirectives() {
        return this._atDirectives;
    }
    getPseudoClasses() {
        return this._pseudoClasses;
    }
    getPseudoElements() {
        return this._pseudoElements;
    }
    isKnownProperty(name) {
        return name.toLowerCase() in this._propertySet;
    }
    isStandardProperty(name) {
        return this.isKnownProperty(name) && (!this._propertySet[name.toLowerCase()].status || this._propertySet[name.toLowerCase()].status === 'standard');
    }
}



/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 

'use strict';
function $12bb92033019218f$export$9bb1ff330035127f(document, positions, stylesheet) {
    function getSelectionRange(position) {
        const applicableRanges = getApplicableRanges(position);
        let current = undefined;
        for(let index = applicableRanges.length - 1; index >= 0; index--)current = (0, $1345bdc33671c7a9$exports.SelectionRange).create((0, $1345bdc33671c7a9$exports.Range).create(document.positionAt(applicableRanges[index][0]), document.positionAt(applicableRanges[index][1])), current);
        if (!current) current = (0, $1345bdc33671c7a9$exports.SelectionRange).create((0, $1345bdc33671c7a9$exports.Range).create(position, position));
        return current;
    }
    return positions.map(getSelectionRange);
    function getApplicableRanges(position) {
        const offset = document.offsetAt(position);
        let currNode = stylesheet.findChildAtOffset(offset, true);
        if (!currNode) return [];
        const result = [];
        while(currNode){
            if (currNode.parent && currNode.offset === currNode.parent.offset && currNode.end === currNode.parent.end) {
                currNode = currNode.parent;
                continue;
            }
            // The `{ }` part of `.a { }`
            if (currNode.type === (0, $bd0cebf2eccc0e7e$export$f06e977173f1857c).Declarations) {
                if (offset > currNode.offset && offset < currNode.end) // Return `{ }` and the range inside `{` and `}`
                result.push([
                    currNode.offset + 1,
                    currNode.end - 1
                ]);
            }
            result.push([
                currNode.offset,
                currNode.end
            ]);
            currNode = currNode.parent;
        }
        return result;
    }
}


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ 




'use strict';
class $38df6c20bb0ecdd7$export$b0473cc8a31cdc94 extends (0, $dcc89f559ec3166a$export$939adce22595f374) {
    constructor(fileSystemProvider){
        super(fileSystemProvider, true);
    }
    isRawStringDocumentLinkNode(node) {
        return super.isRawStringDocumentLinkNode(node) || node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Use || node.type === $bd0cebf2eccc0e7e$export$f06e977173f1857c.Forward;
    }
    async mapReference(target, isRawLink) {
        if (this.fileSystemProvider && target && isRawLink) {
            const pathVariations = $38df6c20bb0ecdd7$var$toPathVariations(target);
            for (const variation of pathVariations){
                if (await this.fileExists(variation)) return variation;
            }
        }
        return target;
    }
    async resolveReference(target, documentUri, documentContext, isRawLink = false) {
        if ((0, $3383aa02dc8dfba4$export$68326237475e9a7d)(target, 'sass:')) return undefined; // sass library
        // Following the [sass package importer](https://github.com/sass/sass/blob/f6832f974c61e35c42ff08b3640ff155071a02dd/js-api-doc/importer.d.ts#L349),
        // look for the `exports` field of the module and any `sass`, `style` or `default` that matches the import.
        // If it's only `pkg:module`, also look for `sass` and `style` on the root of package.json.
        if (target.startsWith('pkg:')) return this.resolvePkgModulePath(target, documentUri, documentContext);
        return super.resolveReference(target, documentUri, documentContext, isRawLink);
    }
    async resolvePkgModulePath(target, documentUri, documentContext) {
        const bareTarget = target.replace('pkg:', '');
        const moduleName = bareTarget.includes('/') ? (0, $dcc89f559ec3166a$export$d1517c6a48a13687)(bareTarget) : bareTarget;
        const rootFolderUri = documentContext.resolveReference('/', documentUri);
        const documentFolderUri = (0, $a2a0b9096fdc2c46$export$7f7b8152cc673abe)(documentUri);
        const modulePath = await this.resolvePathToModule(moduleName, documentFolderUri, rootFolderUri);
        if (!modulePath) return undefined;
        // Since submodule exports import strings don't match the file system,
        // we need the contents of `package.json` to look up the correct path.
        let packageJsonContent = await this.getContent((0, $a2a0b9096fdc2c46$export$b891921babc70093)(modulePath, 'package.json'));
        if (!packageJsonContent) return undefined;
        let packageJson;
        try {
            packageJson = JSON.parse(packageJsonContent);
        } catch (e) {
            // problems parsing package.json
            return undefined;
        }
        const subpath = bareTarget.substring(moduleName.length + 1);
        if (packageJson.exports) {
            if (!subpath) {
                // exports may look like { "sass": "./_index.scss" } or { ".": { "sass": "./_index.scss" } }
                const rootExport = packageJson.exports["."] || packageJson.exports;
                // look for the default/index export
                // @ts-expect-error If ['.'] is a string this just produces undefined
                const entry = rootExport && (rootExport['sass'] || rootExport['style'] || rootExport['default']);
                // the 'default' entry can be whatever, typically .js – confirm it looks like `scss`
                if (entry && entry.endsWith('.scss')) {
                    const entryPath = (0, $a2a0b9096fdc2c46$export$b891921babc70093)(modulePath, entry);
                    return entryPath;
                }
            } else {
                // The import string may be with or without .scss.
                // Likewise the exports entry. Look up both paths.
                // However, they need to be relative (start with ./).
                const lookupSubpath = subpath.endsWith('.scss') ? `./${subpath.replace('.scss', '')}` : `./${subpath}`;
                const lookupSubpathScss = subpath.endsWith('.scss') ? `./${subpath}` : `./${subpath}.scss`;
                const subpathObject = packageJson.exports[lookupSubpathScss] || packageJson.exports[lookupSubpath];
                if (subpathObject) {
                    // @ts-expect-error If subpathObject is a string this just produces undefined
                    const entry = subpathObject['sass'] || subpathObject['styles'] || subpathObject['default'];
                    // the 'default' entry can be whatever, typically .js – confirm it looks like `scss`
                    if (entry && entry.endsWith('.scss')) {
                        const entryPath = (0, $a2a0b9096fdc2c46$export$b891921babc70093)(modulePath, entry);
                        return entryPath;
                    }
                } else // We have a subpath, but found no matches on direct lookup.
                // It may be a [subpath pattern](https://nodejs.org/api/packages.html#subpath-patterns).
                for (const [maybePattern, subpathObject] of Object.entries(packageJson.exports)){
                    if (!maybePattern.includes("*")) continue;
                    // Patterns may also be without `.scss` on the left side, so compare without on both sides
                    const re = new RegExp((0, $3383aa02dc8dfba4$export$4d4f3e97266c6260)(maybePattern.replace('.scss', '')).replace(/\.\*/g, '(.*)'));
                    const match = re.exec(lookupSubpath);
                    if (match) {
                        // @ts-expect-error If subpathObject is a string this just produces undefined
                        const entry = subpathObject['sass'] || subpathObject['styles'] || subpathObject['default'];
                        // the 'default' entry can be whatever, typically .js – confirm it looks like `scss`
                        if (entry && entry.endsWith('.scss')) {
                            // The right-hand side of a subpath pattern is also a pattern.
                            // Replace the pattern with the match from our regexp capture group above.
                            const expandedPattern = entry.replace('*', match[1]);
                            const entryPath = (0, $a2a0b9096fdc2c46$export$b891921babc70093)(modulePath, expandedPattern);
                            return entryPath;
                        }
                    }
                }
            }
        } else if (!subpath && (packageJson.sass || packageJson.style)) {
            // Fall back to a direct lookup on `sass` and `style` on package root
            const entry = packageJson.sass || packageJson.style;
            if (entry) {
                const entryPath = (0, $a2a0b9096fdc2c46$export$b891921babc70093)(modulePath, entry);
                return entryPath;
            }
        }
        return undefined;
    }
}
function $38df6c20bb0ecdd7$var$toPathVariations(target) {
    // No variation for links that ends with .css suffix
    if (target.endsWith('.css')) return [
        target
    ];
    // If a link is like a/, try resolving a/index.scss and a/_index.scss
    if (target.endsWith('/')) return [
        target + 'index.scss',
        target + '_index.scss'
    ];
    const targetUri = (0, $4b379b9378e55f86$exports.URI).parse(target.replace(/\.scss$/, ''));
    const basename = (0, $4b379b9378e55f86$exports.Utils).basename(targetUri);
    const dirname = (0, $4b379b9378e55f86$exports.Utils).dirname(targetUri);
    if (basename.startsWith('_')) // No variation for links such as _a
    return [
        (0, $4b379b9378e55f86$exports.Utils).joinPath(dirname, basename + '.scss').toString(true)
    ];
    return [
        (0, $4b379b9378e55f86$exports.Utils).joinPath(dirname, basename + '.scss').toString(true),
        (0, $4b379b9378e55f86$exports.Utils).joinPath(dirname, '_' + basename + '.scss').toString(true),
        target + '/index.scss',
        target + '/_index.scss',
        (0, $4b379b9378e55f86$exports.Utils).joinPath(dirname, basename + '.css').toString(true)
    ];
}




'use strict';
function $9ae2f18f1c2bccce$export$8af89f7dc98e57ea() {
    return $9ae2f18f1c2bccce$export$489d288f22ed8c63((0, $62f4aa6a9f7f37a5$export$a300ecb306a53ef5));
}
function $9ae2f18f1c2bccce$export$489d288f22ed8c63(data) {
    return new (0, $45cbb8eddbe7f8fa$export$2057e1882a1e5cdb)(data);
}
function $9ae2f18f1c2bccce$var$createFacade(parser, completion, hover, navigation, codeActions, validation, cssDataManager) {
    return {
        configure: (settings)=>{
            validation.configure(settings);
            completion.configure(settings?.completion);
            hover.configure(settings?.hover);
            navigation.configure(settings?.importAliases);
        },
        setDataProviders: cssDataManager.setDataProviders.bind(cssDataManager),
        doValidation: validation.doValidation.bind(validation),
        parseStylesheet: parser.parseStylesheet.bind(parser),
        doComplete: completion.doComplete.bind(completion),
        doComplete2: completion.doComplete2.bind(completion),
        setCompletionParticipants: completion.setCompletionParticipants.bind(completion),
        doHover: hover.doHover.bind(hover),
        format: $9549d350c78fd43f$export$d9468344d3651243,
        findDefinition: navigation.findDefinition.bind(navigation),
        findReferences: navigation.findReferences.bind(navigation),
        findDocumentHighlights: navigation.findDocumentHighlights.bind(navigation),
        findDocumentLinks: navigation.findDocumentLinks.bind(navigation),
        findDocumentLinks2: navigation.findDocumentLinks2.bind(navigation),
        findDocumentSymbols: navigation.findSymbolInformations.bind(navigation),
        findDocumentSymbols2: navigation.findDocumentSymbols.bind(navigation),
        doCodeActions: codeActions.doCodeActions.bind(codeActions),
        doCodeActions2: codeActions.doCodeActions2.bind(codeActions),
        findDocumentColors: navigation.findDocumentColors.bind(navigation),
        getColorPresentations: navigation.getColorPresentations.bind(navigation),
        prepareRename: navigation.prepareRename.bind(navigation),
        doRename: navigation.doRename.bind(navigation),
        getFoldingRanges: $72b66e11fef70fdd$export$8f757cf446e2053f,
        getSelectionRanges: $12bb92033019218f$export$9bb1ff330035127f
    };
}
const $9ae2f18f1c2bccce$var$defaultLanguageServiceOptions = {};
function $9ae2f18f1c2bccce$export$d4015ead1dc7e1e7(options = $9ae2f18f1c2bccce$var$defaultLanguageServiceOptions) {
    const cssDataManager = new (0, $7280658853b575f9$export$341915a4e412d5c7)(options);
    return $9ae2f18f1c2bccce$var$createFacade(new (0, $48c6713331b54e18$export$7acfa6ed01010e37)(), new (0, $0e5c8ce9d229cf3c$export$59dbe4ad1c157302)(null, options, cssDataManager), new (0, $647885fd6d687e9c$export$104da7ab2cb9bcf5)(options && options.clientCapabilities, cssDataManager), new (0, $dcc89f559ec3166a$export$939adce22595f374)(options && options.fileSystemProvider, false), new (0, $4fcb1dcc3ec12ae1$export$66703fcd648c0ccf)(cssDataManager), new (0, $9791bfc028751c44$export$1500a191fd69c663)(cssDataManager), cssDataManager);
}
function $9ae2f18f1c2bccce$export$8da97332c9f00931(options = $9ae2f18f1c2bccce$var$defaultLanguageServiceOptions) {
    const cssDataManager = new (0, $7280658853b575f9$export$341915a4e412d5c7)(options);
    return $9ae2f18f1c2bccce$var$createFacade(new (0, $459ca5e86e85a7eb$export$9c43cb3656f18101)(), new (0, $ea77810d78e96a69$export$40585303d8501a99)(options, cssDataManager), new (0, $647885fd6d687e9c$export$104da7ab2cb9bcf5)(options && options.clientCapabilities, cssDataManager), new (0, $38df6c20bb0ecdd7$export$b0473cc8a31cdc94)(options && options.fileSystemProvider), new (0, $4fcb1dcc3ec12ae1$export$66703fcd648c0ccf)(cssDataManager), new (0, $9791bfc028751c44$export$1500a191fd69c663)(cssDataManager), cssDataManager);
}
function $9ae2f18f1c2bccce$export$b38b97a3aad0b95a(options = $9ae2f18f1c2bccce$var$defaultLanguageServiceOptions) {
    const cssDataManager = new (0, $7280658853b575f9$export$341915a4e412d5c7)(options);
    return $9ae2f18f1c2bccce$var$createFacade(new (0, $cfc7658025b46be5$export$76e4c1f90ea15bb9)(), new (0, $3f97c9b26c40b19d$export$16c78b003ba04a14)(options, cssDataManager), new (0, $647885fd6d687e9c$export$104da7ab2cb9bcf5)(options && options.clientCapabilities, cssDataManager), new (0, $dcc89f559ec3166a$export$939adce22595f374)(options && options.fileSystemProvider, true), new (0, $4fcb1dcc3ec12ae1$export$66703fcd648c0ccf)(cssDataManager), new (0, $9791bfc028751c44$export$1500a191fd69c663)(cssDataManager), cssDataManager);
}



var $bad0d01969ce5ee2$var$r = {
    ARTICLE: "article",
    BLOCKQUOTE: "blockquote",
    BUTTON: "button",
    CAPTION: "caption",
    CELL: "cell",
    CHECKBOX: "checkbox",
    CODE: "code",
    COMBOBOX: "combobox",
    COMPLEMENTARY: "complementary",
    CONTENTINFO: "contentinfo",
    DELETION: "deletion",
    DIALOG: "dialog",
    DOCUMENT: "document",
    EMPHASIS: "emphasis",
    FIGURE: "figure",
    FORM: "form",
    GENERIC: "generic",
    GROUP: "group",
    HEADING: "heading",
    IMG: "img",
    INSERTION: "insertion",
    LINK: "link",
    LIST: "list",
    LISTBOX: "listbox",
    MAIN: "main",
    METER: "meter",
    NAVIGATION: "navigation",
    OPTION: "option",
    PARAGRAPH: "paragraph",
    PROGRESSBAR: "progressbar",
    RADIO: "radio",
    ROW: "row",
    ROWGROUP: "rowgroup",
    SEARCH: "search",
    SEARCHBOX: "searchbox",
    SEPARATOR: "separator",
    SLIDER: "slider",
    SPINBUTTON: "spinbutton",
    STATUS: "status",
    STRONG: "strong",
    TABLE: "table",
    TERM: "term",
    TEXTBOX: "textbox",
    TIME: "time"
};
var $bad0d01969ce5ee2$var$ut = {
    get (y) {
        return null;
    }
};
var $bad0d01969ce5ee2$var$it = class {
    constructor(t = $bad0d01969ce5ee2$var$ut){
        this.options = t;
    }
    get(t) {
        return this.options.get(t);
    }
    has(t) {
        return this.options.get(t) !== null;
    }
};
var $bad0d01969ce5ee2$var$ot = class y {
    constructor(t, e){
        this.options = e;
        this.name = t.toLowerCase();
    }
    get attributes() {
        return new $bad0d01969ce5ee2$var$it(this.options.attributes);
    }
    parent() {
        if (!this.options.ancestors) return null;
        let e = this.options.ancestors()[Symbol.iterator]().next();
        return e.done || !e.value ? null : new y(e.value.name, e.value);
    }
    ancestors() {
        var t, e;
        return ((e = (t = this.options).ancestors) == null ? void 0 : e.call(t)) || [];
    }
};
var $bad0d01969ce5ee2$var$dt = {
    a: (y)=>y.attributes.has("href") ? $bad0d01969ce5ee2$var$r.LINK : $bad0d01969ce5ee2$var$r.GENERIC,
    abbr: ()=>null,
    address: ()=>$bad0d01969ce5ee2$var$r.GROUP,
    area: (y)=>y.attributes.has("href") ? $bad0d01969ce5ee2$var$r.LINK : $bad0d01969ce5ee2$var$r.GENERIC,
    article: ()=>$bad0d01969ce5ee2$var$r.ARTICLE,
    aside: ()=>$bad0d01969ce5ee2$var$r.COMPLEMENTARY,
    audio: ()=>null,
    b: ()=>$bad0d01969ce5ee2$var$r.GENERIC,
    base: ()=>null,
    bdi: ()=>$bad0d01969ce5ee2$var$r.GENERIC,
    bdo: ()=>$bad0d01969ce5ee2$var$r.GENERIC,
    blockquote: ()=>$bad0d01969ce5ee2$var$r.BLOCKQUOTE,
    body: ()=>$bad0d01969ce5ee2$var$r.GENERIC,
    br: ()=>null,
    button: ()=>$bad0d01969ce5ee2$var$r.BUTTON,
    canvas: ()=>null,
    caption: ()=>$bad0d01969ce5ee2$var$r.CAPTION,
    cite: ()=>null,
    code: ()=>$bad0d01969ce5ee2$var$r.CODE,
    col: ()=>null,
    colgroup: ()=>null,
    data: ()=>$bad0d01969ce5ee2$var$r.GENERIC,
    datalist: ()=>$bad0d01969ce5ee2$var$r.LISTBOX,
    dd: ()=>null,
    del: ()=>$bad0d01969ce5ee2$var$r.DELETION,
    details: ()=>$bad0d01969ce5ee2$var$r.GROUP,
    dfn: ()=>$bad0d01969ce5ee2$var$r.TERM,
    dialog: ()=>$bad0d01969ce5ee2$var$r.DIALOG,
    div: ()=>$bad0d01969ce5ee2$var$r.GENERIC,
    dl: ()=>null,
    dt: ()=>null,
    em: ()=>$bad0d01969ce5ee2$var$r.EMPHASIS,
    embed: ()=>null,
    fieldset: ()=>$bad0d01969ce5ee2$var$r.GROUP,
    figcaption: ()=>null,
    figure: ()=>$bad0d01969ce5ee2$var$r.FIGURE,
    footer: (y)=>{
        let t = [
            "article",
            "aside",
            "main",
            "nav",
            "section"
        ];
        for (let e of y.ancestors())if (t.includes(e.name.toLowerCase())) return $bad0d01969ce5ee2$var$r.GENERIC;
        return $bad0d01969ce5ee2$var$r.CONTENTINFO;
    },
    form: ()=>$bad0d01969ce5ee2$var$r.FORM,
    h1: ()=>$bad0d01969ce5ee2$var$r.HEADING,
    h2: ()=>$bad0d01969ce5ee2$var$r.HEADING,
    h3: ()=>$bad0d01969ce5ee2$var$r.HEADING,
    h4: ()=>$bad0d01969ce5ee2$var$r.HEADING,
    h5: ()=>$bad0d01969ce5ee2$var$r.HEADING,
    h6: ()=>$bad0d01969ce5ee2$var$r.HEADING,
    head: ()=>null,
    header: ()=>null,
    hgroup: ()=>$bad0d01969ce5ee2$var$r.GROUP,
    hr: ()=>$bad0d01969ce5ee2$var$r.SEPARATOR,
    html: ()=>$bad0d01969ce5ee2$var$r.DOCUMENT,
    i: ()=>$bad0d01969ce5ee2$var$r.GENERIC,
    iframe: ()=>null,
    img: (y)=>y.attributes.get("alt") === "" ? null : $bad0d01969ce5ee2$var$r.IMG,
    input: (y)=>{
        switch(y.attributes.get("type") || "text"){
            case "button":
            case "image":
            case "reset":
            case "submit":
                return $bad0d01969ce5ee2$var$r.BUTTON;
            case "checkbox":
                return $bad0d01969ce5ee2$var$r.CHECKBOX;
            case "color":
            case "date":
            case "datetime-local":
            case "file":
            case "hidden":
            case "month":
            case "password":
            case "time":
            case "week":
                return null;
            case "email":
            case "tel":
            case "text":
            case "url":
                return $bad0d01969ce5ee2$var$r.TEXTBOX;
            case "number":
                return $bad0d01969ce5ee2$var$r.SPINBUTTON;
            case "radio":
                return $bad0d01969ce5ee2$var$r.RADIO;
            case "range":
                return $bad0d01969ce5ee2$var$r.SLIDER;
            case "search":
                return $bad0d01969ce5ee2$var$r.SEARCHBOX;
            default:
                return $bad0d01969ce5ee2$var$r.TEXTBOX;
        }
    },
    ins: ()=>$bad0d01969ce5ee2$var$r.INSERTION,
    kbd: ()=>null,
    label: ()=>null,
    legend: ()=>null,
    li: ()=>null,
    link: ()=>null,
    main: ()=>$bad0d01969ce5ee2$var$r.MAIN,
    map: ()=>null,
    mark: ()=>null,
    menu: ()=>$bad0d01969ce5ee2$var$r.LIST,
    meta: ()=>null,
    meter: ()=>$bad0d01969ce5ee2$var$r.METER,
    nav: ()=>$bad0d01969ce5ee2$var$r.NAVIGATION,
    noscript: ()=>null,
    object: ()=>null,
    ol: ()=>$bad0d01969ce5ee2$var$r.LIST,
    optgroup: ()=>$bad0d01969ce5ee2$var$r.GROUP,
    option: ()=>$bad0d01969ce5ee2$var$r.OPTION,
    output: ()=>$bad0d01969ce5ee2$var$r.STATUS,
    p: ()=>$bad0d01969ce5ee2$var$r.PARAGRAPH,
    param: ()=>null,
    picture: ()=>null,
    pre: ()=>$bad0d01969ce5ee2$var$r.GENERIC,
    progress: ()=>$bad0d01969ce5ee2$var$r.PROGRESSBAR,
    q: ()=>$bad0d01969ce5ee2$var$r.GENERIC,
    rp: ()=>null,
    rt: ()=>null,
    ruby: ()=>null,
    s: ()=>$bad0d01969ce5ee2$var$r.DELETION,
    samp: ()=>$bad0d01969ce5ee2$var$r.GENERIC,
    script: ()=>null,
    search: ()=>$bad0d01969ce5ee2$var$r.SEARCH,
    section: ()=>null,
    select: (y)=>y.attributes.has("multiple") ? $bad0d01969ce5ee2$var$r.LISTBOX : $bad0d01969ce5ee2$var$r.COMBOBOX,
    slot: ()=>null,
    small: ()=>$bad0d01969ce5ee2$var$r.GENERIC,
    span: ()=>$bad0d01969ce5ee2$var$r.GENERIC,
    strong: ()=>$bad0d01969ce5ee2$var$r.STRONG,
    style: ()=>null,
    sub: ()=>null,
    summary: ()=>$bad0d01969ce5ee2$var$r.BUTTON,
    sup: ()=>null,
    svg: ()=>null,
    table: ()=>$bad0d01969ce5ee2$var$r.TABLE,
    tbody: ()=>$bad0d01969ce5ee2$var$r.ROWGROUP,
    td: ()=>$bad0d01969ce5ee2$var$r.CELL,
    template: ()=>null,
    textarea: ()=>$bad0d01969ce5ee2$var$r.TEXTBOX,
    tfoot: ()=>$bad0d01969ce5ee2$var$r.ROWGROUP,
    th: ()=>null,
    thead: ()=>$bad0d01969ce5ee2$var$r.ROWGROUP,
    time: ()=>$bad0d01969ce5ee2$var$r.TIME,
    title: ()=>null,
    tr: ()=>$bad0d01969ce5ee2$var$r.ROW,
    track: ()=>null,
    u: ()=>null,
    ul: ()=>$bad0d01969ce5ee2$var$r.LIST,
    var: ()=>null,
    video: ()=>null,
    wbr: ()=>null
};
var $bad0d01969ce5ee2$var$bt = {
    valid: !0
};
function $bad0d01969ce5ee2$var$p() {
    return $bad0d01969ce5ee2$var$bt;
}
function $bad0d01969ce5ee2$var$o(y) {
    return {
        valid: !1,
        reason: y
    };
}
var $bad0d01969ce5ee2$var$Z = class Z {
    constructor(t){
        this.attributeKey = t;
    }
    validateValue(t) {
        return t ? this.attributeKey === (t == null ? void 0 : t.toLowerCase()) ? $bad0d01969ce5ee2$var$p() : $bad0d01969ce5ee2$var$o(`Boolean attribute value must be empty or match the attribute name "${this.attributeKey}", got: "${t}"`) : $bad0d01969ce5ee2$var$p();
    }
};
$bad0d01969ce5ee2$var$Z.type = "BooleanAttribute", $bad0d01969ce5ee2$var$Z.Type = {
    type: $bad0d01969ce5ee2$var$Z.type
};
var $bad0d01969ce5ee2$var$n = $bad0d01969ce5ee2$var$Z;
var $bad0d01969ce5ee2$var$W = {
    VALUE_MUST_BE_STRING: "Value must be a string",
    VALUE_CANNOT_BE_EMPTY: "Value cannot be empty",
    INVALID_MEDIA_QUERY_LIST: "Invalid media query list"
};
var $bad0d01969ce5ee2$var$i = class {
    constructor(t){
        this.options = t;
    }
    validateValue(t) {
        let e = t.toLowerCase();
        return this.options.keywords.includes(e) ? $bad0d01969ce5ee2$var$p() : $bad0d01969ce5ee2$var$o(`Value "${t}" is not a valid keyword. Expected one of: ${this.options.keywords.join(", ")}`);
    }
};
$bad0d01969ce5ee2$var$i.type = "EnumeratedAttribute";
var $bad0d01969ce5ee2$var$M = class M {
    validateValue(t) {
        return M.PATTERN.test(t) ? $bad0d01969ce5ee2$var$p() : $bad0d01969ce5ee2$var$o(`Invalid signed integer: "${t}"`);
    }
};
$bad0d01969ce5ee2$var$M.type = "SignedInteger", $bad0d01969ce5ee2$var$M.Type = {
    type: $bad0d01969ce5ee2$var$M.type
}, $bad0d01969ce5ee2$var$M.PATTERN = /^-?\d+$/;
var $bad0d01969ce5ee2$var$w = $bad0d01969ce5ee2$var$M;
var $bad0d01969ce5ee2$var$at = /[\u0009\u000A\u000C\u000D\u0020]/;
var $bad0d01969ce5ee2$var$m = class {
    constructor(t){
        this.options = t;
    }
    parse(t) {
        return t.split($bad0d01969ce5ee2$var$at);
    }
    validateValue(t) {
        let e = this.parse(t).filter((a)=>a !== "");
        if (this.options.unique) {
            let a = new Set(e);
            if (e.length !== a.size) return $bad0d01969ce5ee2$var$o("Tokens must be unique");
        }
        if (this.options.allowed) {
            for (let a of e)if (!this.options.allowed.some((b)=>a.toLowerCase() === b.toLowerCase())) return $bad0d01969ce5ee2$var$o(`Invalid token: "${a}". Allowed tokens: ${this.options.allowed.join(", ")}`);
        }
        if (typeof this.options.validateToken == "function") {
            for (let a of e)if (!this.options.validateToken(a)) return $bad0d01969ce5ee2$var$o(`Invalid token: "${a}"`);
        }
        return $bad0d01969ce5ee2$var$p();
    }
};
$bad0d01969ce5ee2$var$m.type = "SpaceSeparatedTokens";
var $bad0d01969ce5ee2$var$F = class F {
    validateValue(t) {
        return $bad0d01969ce5ee2$var$p();
    }
};
$bad0d01969ce5ee2$var$F.type = "Text", $bad0d01969ce5ee2$var$F.Type = {
    type: $bad0d01969ce5ee2$var$F.type
};
var $bad0d01969ce5ee2$var$l = $bad0d01969ce5ee2$var$F;
var $bad0d01969ce5ee2$var$$ = class $ {
    constructor(t = {}){
        this.options = t;
    }
    validateValue(t) {
        let e = t;
        if (this.options.potentiallySurroundedBySpaces && (e = this.stripASCIIWhitespace(t)), e === "") return $bad0d01969ce5ee2$var$p();
        if (this.hasInvalidURLCharacters(e)) return $bad0d01969ce5ee2$var$o("URL contains invalid characters");
        try {
            return new URL(e), $bad0d01969ce5ee2$var$p();
        } catch (a) {
            try {
                return new URL(e, "https://www.base.com"), $bad0d01969ce5ee2$var$p();
            } catch (u) {
                return $bad0d01969ce5ee2$var$o("Invalid URL format");
            }
        }
    }
    stripASCIIWhitespace(t) {
        return t.replace(/^[\x20\x09\x0A\x0C\x0D]+|[\x20\x09\x0A\x0C\x0D]+$/g, "");
    }
    hasInvalidURLCharacters(t) {
        for(let e = 0; e < t.length; e++){
            let a = t.charCodeAt(e);
            if (a <= 32 || a === 127) return !0;
        }
        return !1;
    }
};
$bad0d01969ce5ee2$var$$.type = "ValidURL", $bad0d01969ce5ee2$var$$.PotentiallySurroundedBySpaces = {
    type: $bad0d01969ce5ee2$var$$.type,
    potentiallySurroundedBySpaces: !0
}, $bad0d01969ce5ee2$var$$.NonEmptyPotentiallySurroundedBySpaces = {
    type: $bad0d01969ce5ee2$var$$.type,
    potentiallySurroundedBySpaces: !0
};
var $bad0d01969ce5ee2$var$d = $bad0d01969ce5ee2$var$$;
var $bad0d01969ce5ee2$var$v = class v {
    constructor(t){
        this.options = t;
    }
    validateValue(t) {
        var a, u;
        if (!v.PATTERN.test(t)) return $bad0d01969ce5ee2$var$o(`Invalid non-negative integer: "${t}"`);
        let e = parseInt(t, 10);
        return ((a = this.options) == null ? void 0 : a.min) !== void 0 && e < this.options.min ? $bad0d01969ce5ee2$var$o(`Value must be at least ${this.options.min}: "${t}"`) : ((u = this.options) == null ? void 0 : u.max) !== void 0 && e > this.options.max ? $bad0d01969ce5ee2$var$o(`Value must be at most ${this.options.max}: "${t}"`) : $bad0d01969ce5ee2$var$p();
    }
};
$bad0d01969ce5ee2$var$v.type = "NonNegativeInteger", $bad0d01969ce5ee2$var$v.Type = {
    type: $bad0d01969ce5ee2$var$v.type
}, $bad0d01969ce5ee2$var$v.GreaterThanZero = {
    type: $bad0d01969ce5ee2$var$v.type,
    min: 1
}, $bad0d01969ce5ee2$var$v.PATTERN = /^\d+$/;
var $bad0d01969ce5ee2$var$c = $bad0d01969ce5ee2$var$v;
var $bad0d01969ce5ee2$var$X = class X {
    constructor(){}
    validateValue(t) {
        return $bad0d01969ce5ee2$var$p();
    }
};
$bad0d01969ce5ee2$var$X.type = "ID", $bad0d01969ce5ee2$var$X.Type = {
    type: $bad0d01969ce5ee2$var$X.type
};
var $bad0d01969ce5ee2$var$g = $bad0d01969ce5ee2$var$X;
var $bad0d01969ce5ee2$var$U = class U {
    validateValue(t) {
        return U.PATTERN.test(t) ? $bad0d01969ce5ee2$var$p() : $bad0d01969ce5ee2$var$o(`Invalid floating-point number: "${t}"`);
    }
};
$bad0d01969ce5ee2$var$U.type = "FloatingPointNumber", $bad0d01969ce5ee2$var$U.Type = {
    type: $bad0d01969ce5ee2$var$U.type
}, $bad0d01969ce5ee2$var$U.PATTERN = /^-?(?:\d+(?:\.\d+)?|\.\d+)(?:[eE][+-]?\d+)?$/;
var $bad0d01969ce5ee2$var$f = $bad0d01969ce5ee2$var$U;
var $bad0d01969ce5ee2$var$C = class {
    validateValue(t) {
        return $bad0d01969ce5ee2$var$p();
    }
};
$bad0d01969ce5ee2$var$C.type = "CommaSeparatedTokens";
var $bad0d01969ce5ee2$var$K = class K {
    validateValue(t) {
        return $bad0d01969ce5ee2$var$p();
    }
};
$bad0d01969ce5ee2$var$K.type = "CSSColor", $bad0d01969ce5ee2$var$K.Type = {
    type: $bad0d01969ce5ee2$var$K.type
};
var $bad0d01969ce5ee2$var$D = $bad0d01969ce5ee2$var$K;
var $bad0d01969ce5ee2$var$j = class j {
    validateValue(t) {
        if (t === "") return $bad0d01969ce5ee2$var$p();
        if (!j.PATTERN.test(t)) return $bad0d01969ce5ee2$var$o(`Invalid BCP 47 language tag: "${t}"`);
        let e = t.split("-");
        for(let a = 0; a < e.length; a++){
            let u = e[a];
            if (u.length === 0) return $bad0d01969ce5ee2$var$o(`Invalid BCP 47 language tag: empty subtag in "${t}"`);
            if (a === 0) {
                if (u === "x") continue;
                if (!/^[a-zA-Z]{2,8}$/.test(u)) return $bad0d01969ce5ee2$var$o(`Invalid language subtag in "${t}": "${u}"`);
            }
        }
        return $bad0d01969ce5ee2$var$p();
    }
};
$bad0d01969ce5ee2$var$j.type = "BCP47", $bad0d01969ce5ee2$var$j.Type = {
    type: $bad0d01969ce5ee2$var$j.type
}, $bad0d01969ce5ee2$var$j.PATTERN = /^[a-zA-Z]{2,3}(?:-[a-zA-Z]{3}){0,3}(?:-[a-zA-Z]{4})?(?:-(?:[a-zA-Z]{2}|[0-9]{3}))?(?:-(?:[a-zA-Z0-9]{5,8}|[0-9][a-zA-Z0-9]{3}))*(?:-[0-9a-wyzA-WYZ](?:-[a-zA-Z0-9]{2,8})+)*(?:-x(?:-[a-zA-Z0-9]{1,8})+)?$|^x(?:-[a-zA-Z0-9]{1,8})+$|^[a-zA-Z]{4,8}$/;
var $bad0d01969ce5ee2$var$E = $bad0d01969ce5ee2$var$j;
var $bad0d01969ce5ee2$var$q = class q {
    constructor(){}
    validateValue(t) {
        return q.PATTERN.test(t) ? $bad0d01969ce5ee2$var$p() : $bad0d01969ce5ee2$var$o(`Invalid MIME type: "${t}"`);
    }
};
$bad0d01969ce5ee2$var$q.type = "MIMEType", $bad0d01969ce5ee2$var$q.Type = {
    type: $bad0d01969ce5ee2$var$q.type
}, $bad0d01969ce5ee2$var$q.PATTERN = /^[a-zA-Z0-9!#$%&'*+\-.^_`{|}~]+\/[a-zA-Z0-9!#$%&'*+\-.^_`{|}~]+(?:\s*;\s*[a-zA-Z0-9!#$%&'*+\-.^_`{|}~]+=(?:[a-zA-Z0-9!#$%&'*+\-.^_`{|}~]+|"[^"]*"))*$/;
var $bad0d01969ce5ee2$var$h = $bad0d01969ce5ee2$var$q;
var $bad0d01969ce5ee2$var$I = class I {
    constructor(){}
    validateValue(t) {
        if (!I.DATE_PATTERN.test(t) && !I.DATETIME_PATTERN.test(t)) return $bad0d01969ce5ee2$var$o(`Invalid date or datetime string: "${t}"`);
        let e = t.match(/^(\d{4,})-(\d{2})-(\d{2})/);
        if (e) {
            let u = parseInt(e[1], 10), b = parseInt(e[2], 10), A = parseInt(e[3], 10);
            if (u === 0) return $bad0d01969ce5ee2$var$o(`Year must be greater than 0: "${t}"`);
            if (b < 1 || b > 12) return $bad0d01969ce5ee2$var$o(`Month must be between 1 and 12: "${t}"`);
            if (A < 1 || A > 31) return $bad0d01969ce5ee2$var$o(`Day must be between 1 and 31: "${t}"`);
        }
        let a = t.match(/[T ](\d{2}):(\d{2})/);
        if (a) {
            let u = parseInt(a[1], 10), b = parseInt(a[2], 10);
            if (u > 23) return $bad0d01969ce5ee2$var$o(`Hour must be between 0 and 23: "${t}"`);
            if (b > 59) return $bad0d01969ce5ee2$var$o(`Minute must be between 0 and 59: "${t}"`);
            let A = t.match(/[T ]\d{2}:\d{2}:(\d{2})/);
            if (A && parseInt(A[1], 10) > 59) return $bad0d01969ce5ee2$var$o(`Second must be between 0 and 59: "${t}"`);
        }
        return $bad0d01969ce5ee2$var$p();
    }
};
$bad0d01969ce5ee2$var$I.type = "DateString", $bad0d01969ce5ee2$var$I.Type = {
    type: $bad0d01969ce5ee2$var$I.type
}, $bad0d01969ce5ee2$var$I.DATE_PATTERN = /^\d{4,}-\d{2}-\d{2}$/, $bad0d01969ce5ee2$var$I.DATETIME_PATTERN = /^\d{4,}-\d{2}-\d{2}[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:\d{2})?$/;
var $bad0d01969ce5ee2$var$V = $bad0d01969ce5ee2$var$I;
var $bad0d01969ce5ee2$var$Y = class Y {
    constructor(){}
    validateValue(t) {
        try {
            return new RegExp(t), $bad0d01969ce5ee2$var$p();
        } catch (e) {
            return $bad0d01969ce5ee2$var$o(`Invalid regular expression: "${t}" - ${e instanceof Error ? e.message : String(e)}`);
        }
    }
};
$bad0d01969ce5ee2$var$Y.type = "RegularExpression", $bad0d01969ce5ee2$var$Y.Type = {
    type: $bad0d01969ce5ee2$var$Y.type
};
var $bad0d01969ce5ee2$var$_ = $bad0d01969ce5ee2$var$Y;
var $bad0d01969ce5ee2$var$Q = class Q {
    validateValue(t) {
        return t.startsWith("#") ? t.length === 1 ? $bad0d01969ce5ee2$var$o(`Hash-name reference must have a name after "#": "${t}"`) : $bad0d01969ce5ee2$var$p() : $bad0d01969ce5ee2$var$o(`Hash-name reference must start with "#": "${t}"`);
    }
};
$bad0d01969ce5ee2$var$Q.type = "HashNameReference", $bad0d01969ce5ee2$var$Q.Type = {
    type: $bad0d01969ce5ee2$var$Q.type
};
var $bad0d01969ce5ee2$var$z = $bad0d01969ce5ee2$var$Q;
var $bad0d01969ce5ee2$var$H = class H {
    constructor(){}
    validateValue(t) {
        return t.length === 0 ? $bad0d01969ce5ee2$var$o("Navigable target name must have at least one character") : t.startsWith("_") ? $bad0d01969ce5ee2$var$o(`Navigable target name cannot start with "_" (reserved for keywords like _blank, _self): "${t}"`) : H.INVALID_CHARS_PATTERN.test(t) ? $bad0d01969ce5ee2$var$o(`Navigable target name cannot contain tab, newline, or "<" character: "${t}"`) : $bad0d01969ce5ee2$var$p();
    }
};
$bad0d01969ce5ee2$var$H.type = "NavigableTargetName", $bad0d01969ce5ee2$var$H.Type = {
    type: $bad0d01969ce5ee2$var$H.type
}, $bad0d01969ce5ee2$var$H.INVALID_CHARS_PATTERN = /[\t\n<]/;
var $bad0d01969ce5ee2$var$T = $bad0d01969ce5ee2$var$H;
var $bad0d01969ce5ee2$var$J = class J {
    validateValue(t) {
        if (t.trim() === "") return $bad0d01969ce5ee2$var$o("Srcset cannot be empty");
        let e = t.split(",");
        for(let a = 0; a < e.length; a++){
            let u = e[a].trim();
            if (u === "") return $bad0d01969ce5ee2$var$o(`Image candidate string ${a + 1} is empty`);
            let b = u.split(/\s+/), A = b[0];
            if (A.startsWith(",") || A.endsWith(",")) return $bad0d01969ce5ee2$var$o(`URL cannot start or end with comma: "${A}"`);
            if (A === "") return $bad0d01969ce5ee2$var$o(`URL in candidate string ${a + 1} is empty`);
            if (b.length > 1) {
                let S = b[b.length - 1];
                if (S.endsWith("w")) {
                    let P = S.slice(0, -1), x = parseInt(P, 10);
                    if (!/^\d+$/.test(P) || x <= 0) return $bad0d01969ce5ee2$var$o(`Invalid width descriptor: "${S}" (must be positive integer followed by 'w')`);
                } else if (S.endsWith("x")) {
                    let P = S.slice(0, -1), x = parseFloat(P);
                    if (!/^-?(?:\d+(?:\.\d+)?|\.\d+)(?:[eE][+-]?\d+)?$/.test(P) || x <= 0) return $bad0d01969ce5ee2$var$o(`Invalid pixel density descriptor: "${S}" (must be positive number followed by 'x')`);
                } else return $bad0d01969ce5ee2$var$o(`Invalid descriptor: "${S}" (must end with 'w' or 'x')`);
                if (b.length > 2 && b.slice(1, -1).some((x)=>x !== "")) return $bad0d01969ce5ee2$var$o(`Invalid image candidate string: "${u}" (extra tokens found)`);
            }
        }
        return $bad0d01969ce5ee2$var$p();
    }
};
$bad0d01969ce5ee2$var$J.type = "SrcsetAttribute", $bad0d01969ce5ee2$var$J.Type = {
    type: $bad0d01969ce5ee2$var$J.type
};
var $bad0d01969ce5ee2$var$k = $bad0d01969ce5ee2$var$J;
var $bad0d01969ce5ee2$var$tt = class tt {
    constructor(){
        this.cssLanguageService = (0, $9ae2f18f1c2bccce$export$d4015ead1dc7e1e7)();
    }
    validateValue(t) {
        try {
            let e = `@media ${t} {}`, a = (0, $01050fa442f244fa$exports.TextDocument).create("test.css", "css", 1, e), u = this.cssLanguageService.parseStylesheet(a);
            return this.cssLanguageService.doValidation(a, u).length > 0 ? $bad0d01969ce5ee2$var$o($bad0d01969ce5ee2$var$W.INVALID_MEDIA_QUERY_LIST) : $bad0d01969ce5ee2$var$p();
        } catch (e) {
            return $bad0d01969ce5ee2$var$o($bad0d01969ce5ee2$var$W.INVALID_MEDIA_QUERY_LIST);
        }
    }
};
$bad0d01969ce5ee2$var$tt.type = "MediaQueryList", $bad0d01969ce5ee2$var$tt.Type = {
    type: $bad0d01969ce5ee2$var$tt.type
};
var $bad0d01969ce5ee2$var$R = $bad0d01969ce5ee2$var$tt;
var $bad0d01969ce5ee2$var$et = class et {
    validateValue(t) {
        return $bad0d01969ce5ee2$var$p();
    }
};
$bad0d01969ce5ee2$var$et.type = "SourceSizeList", $bad0d01969ce5ee2$var$et.Type = {
    type: $bad0d01969ce5ee2$var$et.type
};
var $bad0d01969ce5ee2$var$O = $bad0d01969ce5ee2$var$et;
var $bad0d01969ce5ee2$var$G = class {
    constructor(){
        this.floatingPointNumberValidator = new $bad0d01969ce5ee2$var$f;
    }
    validateValue(t) {
        if (t.length === 0) return $bad0d01969ce5ee2$var$o($bad0d01969ce5ee2$var$W.VALUE_CANNOT_BE_EMPTY);
        let e = t.split(",");
        for(let a = 0; a < e.length; a++){
            let u = e[a];
            if (u.length === 0) return $bad0d01969ce5ee2$var$o(`Empty value at position ${a + 1}`);
            if (!this.floatingPointNumberValidator.validateValue(u).valid) return $bad0d01969ce5ee2$var$o(`Invalid floating-point number at position ${a + 1}: "${u}"`);
        }
        return $bad0d01969ce5ee2$var$p();
    }
};
$bad0d01969ce5ee2$var$G.type = "FloatingPointNumberList";
var $bad0d01969ce5ee2$var$B = class {
    constructor(t){
        this.options = t;
    }
    validateValue(t) {
        let e;
        for (let a of this.options.items){
            let b = $bad0d01969ce5ee2$var$st("", a).validateValue(t);
            if (b.valid) return $bad0d01969ce5ee2$var$p();
            e = b.reason;
        }
        return $bad0d01969ce5ee2$var$o(e != null ? e : "Value does not match any of the allowed formats");
    }
};
$bad0d01969ce5ee2$var$B.type = "#or";
var $bad0d01969ce5ee2$var$N = class N {
    validateValue(t) {
        var ct;
        if (t === "") return $bad0d01969ce5ee2$var$p();
        let e = t.toLowerCase().trim();
        if (e === "on" || e === "off") return $bad0d01969ce5ee2$var$p();
        let a = e.split($bad0d01969ce5ee2$var$at).filter(Boolean);
        if (a.length === 0) return $bad0d01969ce5ee2$var$o("Autocomplete value cannot be empty");
        let u = 0, b = !1, A = !1, S = !1, P = !1, x = "";
        if ((ct = a[u]) != null && ct.startsWith("section-") && (b = !0, u++), (a[u] === "billing" || a[u] === "shipping") && (A = !0, u++), u < a.length) {
            let lt = a[u];
            if (N.AUTOFILL_FIELD_NAMES.has(lt)) S = !0, x = lt, u++;
            else return $bad0d01969ce5ee2$var$o(`Invalid autofill field name: "${lt}". Must be one of the standard autofill field names.`);
        } else return $bad0d01969ce5ee2$var$o("Autocomplete value must include an autofill field name");
        if (u < a.length && a[u] === "webauthn") {
            if (!N.WEBAUTHN_COMPATIBLE_FIELDS.has(x)) return $bad0d01969ce5ee2$var$o(`"webauthn" token is only valid with username or current-password fields, not "${x}"`);
            P = !0, u++;
        }
        return u < a.length ? $bad0d01969ce5ee2$var$o(`Invalid extra token in autocomplete value: "${a[u]}"`) : $bad0d01969ce5ee2$var$p();
    }
};
$bad0d01969ce5ee2$var$N.type = "AutocompleteAttribute", $bad0d01969ce5ee2$var$N.Type = {
    type: $bad0d01969ce5ee2$var$N.type
}, $bad0d01969ce5ee2$var$N.AUTOFILL_FIELD_NAMES = new Set([
    "name",
    "honorific-prefix",
    "given-name",
    "additional-name",
    "family-name",
    "honorific-suffix",
    "nickname",
    "username",
    "new-password",
    "current-password",
    "one-time-code",
    "organization-title",
    "organization",
    "street-address",
    "address-line1",
    "address-line2",
    "address-line3",
    "address-level4",
    "address-level3",
    "address-level2",
    "address-level1",
    "country",
    "country-name",
    "postal-code",
    "cc-name",
    "cc-given-name",
    "cc-additional-name",
    "cc-family-name",
    "cc-number",
    "cc-exp",
    "cc-exp-month",
    "cc-exp-year",
    "cc-csc",
    "cc-type",
    "transaction-currency",
    "transaction-amount",
    "language",
    "bday",
    "bday-day",
    "bday-month",
    "bday-year",
    "sex",
    "url",
    "photo",
    "tel",
    "tel-country-code",
    "tel-national",
    "tel-area-code",
    "tel-local",
    "tel-local-prefix",
    "tel-local-suffix",
    "tel-extension",
    "email",
    "impp"
]), $bad0d01969ce5ee2$var$N.WEBAUTHN_COMPATIBLE_FIELDS = new Set([
    "username",
    "current-password"
]);
var $bad0d01969ce5ee2$var$L = $bad0d01969ce5ee2$var$N;
function $bad0d01969ce5ee2$var$st(y, t) {
    switch(t.type){
        case $bad0d01969ce5ee2$var$m.type:
            return new $bad0d01969ce5ee2$var$m({
                unique: t.unique,
                allowed: t.allowed,
                validateToken: t.validateToken
            });
        case $bad0d01969ce5ee2$var$i.type:
            return new $bad0d01969ce5ee2$var$i({
                keywords: t.keywords
            });
        case $bad0d01969ce5ee2$var$n.type:
            return new $bad0d01969ce5ee2$var$n(y);
        case $bad0d01969ce5ee2$var$w.type:
            return new $bad0d01969ce5ee2$var$w;
        case $bad0d01969ce5ee2$var$l.type:
            return new $bad0d01969ce5ee2$var$l;
        case $bad0d01969ce5ee2$var$d.type:
            return new $bad0d01969ce5ee2$var$d({
                nonEmpty: t.nonEmpty,
                potentiallySurroundedBySpaces: t.potentiallySurroundedBySpaces
            });
        case $bad0d01969ce5ee2$var$c.type:
            return new $bad0d01969ce5ee2$var$c({
                min: t.min,
                max: t.max
            });
        case $bad0d01969ce5ee2$var$g.type:
            return new $bad0d01969ce5ee2$var$g;
        case $bad0d01969ce5ee2$var$f.type:
            return new $bad0d01969ce5ee2$var$f;
        case $bad0d01969ce5ee2$var$C.type:
            return new $bad0d01969ce5ee2$var$C;
        case $bad0d01969ce5ee2$var$D.type:
            return new $bad0d01969ce5ee2$var$D;
        case $bad0d01969ce5ee2$var$E.type:
            return new $bad0d01969ce5ee2$var$E;
        case $bad0d01969ce5ee2$var$h.type:
            return new $bad0d01969ce5ee2$var$h;
        case $bad0d01969ce5ee2$var$V.type:
            return new $bad0d01969ce5ee2$var$V;
        case $bad0d01969ce5ee2$var$_.type:
            return new $bad0d01969ce5ee2$var$_;
        case $bad0d01969ce5ee2$var$z.type:
            return new $bad0d01969ce5ee2$var$z;
        case $bad0d01969ce5ee2$var$T.type:
            return new $bad0d01969ce5ee2$var$T;
        case $bad0d01969ce5ee2$var$k.type:
            return new $bad0d01969ce5ee2$var$k;
        case $bad0d01969ce5ee2$var$R.type:
            return new $bad0d01969ce5ee2$var$R;
        case $bad0d01969ce5ee2$var$O.type:
            return new $bad0d01969ce5ee2$var$O;
        case $bad0d01969ce5ee2$var$G.type:
            return new $bad0d01969ce5ee2$var$G;
        case $bad0d01969ce5ee2$var$B.type:
            return new $bad0d01969ce5ee2$var$B({
                items: t.items
            });
        case $bad0d01969ce5ee2$var$L.type:
            return new $bad0d01969ce5ee2$var$L;
    }
}
var $bad0d01969ce5ee2$var$rt = class {
    constructor(t, e){
        this.key = t;
        this.definition = e;
    }
    validateValue(t) {
        return $bad0d01969ce5ee2$var$st(this.key, this.definition).validateValue(t);
    }
};
var $bad0d01969ce5ee2$var$yt = new Map([
    [
        "accesskey",
        {
            type: $bad0d01969ce5ee2$var$m.type,
            unique: !0,
            validateToken (y) {
                return Array.from(y).length === 1;
            }
        }
    ],
    [
        "autocapitalize",
        {
            type: $bad0d01969ce5ee2$var$i.type,
            keywords: [
                "off",
                "none",
                "on",
                "sentences",
                "words",
                "characters"
            ]
        }
    ],
    [
        "autocorrect",
        {
            type: $bad0d01969ce5ee2$var$i.type,
            keywords: [
                "on",
                "off"
            ]
        }
    ],
    [
        "autofocus",
        $bad0d01969ce5ee2$var$n.Type
    ],
    [
        "contenteditable",
        {
            type: $bad0d01969ce5ee2$var$i.type,
            keywords: [
                "true",
                "false",
                "plaintext-only"
            ]
        }
    ],
    [
        "dir",
        {
            type: $bad0d01969ce5ee2$var$i.type,
            keywords: [
                "ltr",
                "rtl",
                "auto"
            ]
        }
    ],
    [
        "draggable",
        {
            type: $bad0d01969ce5ee2$var$i.type,
            keywords: [
                "true",
                "false"
            ]
        }
    ],
    [
        "enterkeyhint",
        {
            type: $bad0d01969ce5ee2$var$i.type,
            keywords: [
                "enter",
                "done",
                "go",
                "next",
                "previous",
                "search",
                "send"
            ]
        }
    ],
    [
        "headingoffset",
        {
            type: $bad0d01969ce5ee2$var$c.type,
            min: 0,
            max: 8
        }
    ],
    [
        "headingreset",
        $bad0d01969ce5ee2$var$n.Type
    ],
    [
        "hidden",
        {
            type: $bad0d01969ce5ee2$var$i.type,
            keywords: [
                "",
                "until-found",
                "hidden"
            ]
        }
    ],
    [
        "inert",
        $bad0d01969ce5ee2$var$n.Type
    ],
    [
        "inputmode",
        {
            type: $bad0d01969ce5ee2$var$i.type,
            keywords: [
                "none",
                "text",
                "tel",
                "url",
                "email",
                "numeric",
                "decimal",
                "search"
            ]
        }
    ],
    [
        "is",
        $bad0d01969ce5ee2$var$l.Type
    ],
    [
        "itemid",
        $bad0d01969ce5ee2$var$d.PotentiallySurroundedBySpaces
    ],
    [
        "itemprop",
        {
            type: $bad0d01969ce5ee2$var$m.type,
            unique: !0
        }
    ],
    [
        "itemref",
        {
            type: $bad0d01969ce5ee2$var$m.type,
            unique: !0
        }
    ],
    [
        "itemscope",
        $bad0d01969ce5ee2$var$n.Type
    ],
    [
        "itemtype",
        {
            type: $bad0d01969ce5ee2$var$m.type,
            unique: !0,
            validateToken (y) {
                try {
                    return new URL(y), !0;
                } catch (t) {
                    return !1;
                }
            }
        }
    ],
    [
        "lang",
        $bad0d01969ce5ee2$var$E.Type
    ],
    [
        "nonce",
        $bad0d01969ce5ee2$var$l.Type
    ],
    [
        "popover",
        {
            type: "#or",
            items: [
                $bad0d01969ce5ee2$var$n.Type,
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "",
                        "auto",
                        "manual",
                        "hint"
                    ]
                }
            ]
        }
    ],
    [
        "spellcheck",
        {
            type: $bad0d01969ce5ee2$var$i.type,
            keywords: [
                "",
                "true",
                "false"
            ]
        }
    ],
    [
        "style",
        $bad0d01969ce5ee2$var$l.Type
    ],
    [
        "tabindex",
        $bad0d01969ce5ee2$var$w.Type
    ],
    [
        "title",
        $bad0d01969ce5ee2$var$l.Type
    ],
    [
        "translate",
        {
            type: $bad0d01969ce5ee2$var$i.type,
            keywords: [
                "",
                "yes",
                "no"
            ]
        }
    ],
    [
        "writingsuggestions",
        {
            type: $bad0d01969ce5ee2$var$i.type,
            keywords: [
                "",
                "true",
                "false"
            ]
        }
    ]
]);
var $bad0d01969ce5ee2$var$s = [], $bad0d01969ce5ee2$var$mt = {
    html: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    head: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    title: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    base: {
        globalAttributes: !0,
        attributes: [
            [
                "href",
                $bad0d01969ce5ee2$var$d.PotentiallySurroundedBySpaces
            ],
            [
                "target",
                {
                    type: "#or",
                    items: [
                        $bad0d01969ce5ee2$var$T.Type,
                        {
                            type: $bad0d01969ce5ee2$var$i.type,
                            keywords: [
                                "_blank",
                                "_self",
                                "_parent",
                                "_top"
                            ]
                        }
                    ]
                }
            ]
        ]
    },
    link: {
        globalAttributes: !0,
        attributes: [
            [
                "href",
                $bad0d01969ce5ee2$var$d.NonEmptyPotentiallySurroundedBySpaces
            ],
            [
                "crossorigin",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "",
                        "anonymous",
                        "use-credentials"
                    ]
                }
            ],
            [
                "rel",
                {
                    type: $bad0d01969ce5ee2$var$m.type,
                    unique: !0
                }
            ],
            [
                "media",
                $bad0d01969ce5ee2$var$R.Type
            ],
            [
                "integrity",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "hreflang",
                $bad0d01969ce5ee2$var$E.Type
            ],
            [
                "type",
                $bad0d01969ce5ee2$var$h.Type
            ],
            [
                "referrerpolicy",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "",
                        "no-referrer",
                        "no-referrer-when-downgrade",
                        "same-origin",
                        "origin",
                        "strict-origin",
                        "origin-when-cross-origin",
                        "strict-origin-when-cross-origin",
                        "unsafe-url"
                    ]
                }
            ],
            [
                "sizes",
                {
                    type: $bad0d01969ce5ee2$var$m.type,
                    unique: !0,
                    validateToken (y) {
                        if (y.toLowerCase() === "any") return !0;
                        let t = /^([1-9]\d*|0)[xX]([1-9]\d*|0)$/, e = y.match(t);
                        if (!e) return !1;
                        let [, a, u] = e;
                        return !(a.length > 1 && a.startsWith("0") || u.length > 1 && u.startsWith("0"));
                    }
                }
            ],
            [
                "imagesrcset",
                $bad0d01969ce5ee2$var$k.Type
            ],
            [
                "imagesizes",
                $bad0d01969ce5ee2$var$O.Type
            ],
            [
                "as",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "fetch",
                        "font",
                        "image",
                        "script",
                        "style",
                        "track",
                        "json",
                        "style",
                        "audioworklet",
                        "paintworklet",
                        "script",
                        "serviceworker",
                        "sharedworker",
                        "worker"
                    ]
                }
            ],
            [
                "blocking",
                {
                    type: $bad0d01969ce5ee2$var$m.type,
                    unique: !0,
                    allowed: [
                        "render"
                    ]
                }
            ],
            [
                "color",
                $bad0d01969ce5ee2$var$D.Type
            ],
            [
                "disabled",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "fetchpriority",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "high",
                        "low",
                        "auto"
                    ]
                }
            ]
        ]
    },
    meta: {
        globalAttributes: !0,
        attributes: [
            [
                "name",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "http-equiv",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "content-language",
                        "content-type",
                        "default-style",
                        "refresh",
                        "set-cookie",
                        "x-ua-compatible",
                        "content-security-policy"
                    ]
                }
            ],
            [
                "content",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "charset",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "utf-8"
                    ]
                }
            ],
            [
                "media",
                $bad0d01969ce5ee2$var$R.Type
            ]
        ]
    },
    style: {
        globalAttributes: !0,
        attributes: [
            [
                "media",
                $bad0d01969ce5ee2$var$R.Type
            ],
            [
                "blocking",
                {
                    type: $bad0d01969ce5ee2$var$m.type,
                    unique: !0,
                    allowed: [
                        "render"
                    ]
                }
            ]
        ]
    },
    body: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    article: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    section: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    nav: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    aside: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    hgroup: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    header: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    footer: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    address: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    p: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    hr: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    pre: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    blockquote: {
        globalAttributes: !0,
        attributes: [
            [
                "cite",
                $bad0d01969ce5ee2$var$d.PotentiallySurroundedBySpaces
            ]
        ]
    },
    ol: {
        globalAttributes: !0,
        attributes: [
            [
                "reversed",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "start",
                $bad0d01969ce5ee2$var$w.Type
            ],
            [
                "type",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "1",
                        "a",
                        "A",
                        "i",
                        "I"
                    ]
                }
            ]
        ]
    },
    ul: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    menu: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    li: {
        globalAttributes: !0,
        attributes: [
            [
                "value",
                $bad0d01969ce5ee2$var$w.Type
            ]
        ]
    },
    dl: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    dt: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    dd: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    figure: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    figcaption: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    main: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    search: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    div: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    a: {
        globalAttributes: !0,
        attributes: [
            [
                "href",
                $bad0d01969ce5ee2$var$d.PotentiallySurroundedBySpaces
            ],
            [
                "target",
                {
                    type: "#or",
                    items: [
                        $bad0d01969ce5ee2$var$T.Type,
                        {
                            type: $bad0d01969ce5ee2$var$i.type,
                            keywords: [
                                "_blank",
                                "_self",
                                "_parent",
                                "_top"
                            ]
                        }
                    ]
                }
            ],
            [
                "download",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "ping",
                {
                    type: $bad0d01969ce5ee2$var$m.type,
                    unique: !1,
                    validateToken (y) {
                        if (y.length === 0) return !1;
                        try {
                            let t = new URL(y);
                            return t.protocol === "http:" || t.protocol === "https:";
                        } catch (t) {
                            return !1;
                        }
                    }
                }
            ],
            [
                "rel",
                {
                    type: $bad0d01969ce5ee2$var$m.type,
                    unique: !0,
                    allowed: [
                        "alternate",
                        "author",
                        "bookmark",
                        "external",
                        "help",
                        "license",
                        "next",
                        "nofollow",
                        "noopener",
                        "noreferrer",
                        "opener",
                        "prev",
                        "privacy-policy",
                        "search",
                        "tag",
                        "terms-of-service"
                    ]
                }
            ],
            [
                "hreflang",
                $bad0d01969ce5ee2$var$E.Type
            ],
            [
                "type",
                $bad0d01969ce5ee2$var$h.Type
            ],
            [
                "referrerpolicy",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "",
                        "no-referrer",
                        "no-referrer-when-downgrade",
                        "same-origin",
                        "origin",
                        "strict-origin",
                        "origin-when-cross-origin",
                        "strict-origin-when-cross-origin",
                        "unsafe-url"
                    ]
                }
            ]
        ]
    },
    em: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    strong: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    small: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    s: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    cite: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    q: {
        globalAttributes: !0,
        attributes: [
            [
                "cite",
                $bad0d01969ce5ee2$var$d.PotentiallySurroundedBySpaces
            ]
        ]
    },
    dfn: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    abbr: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    ruby: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    rt: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    rp: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    data: {
        globalAttributes: !0,
        attributes: [
            [
                "value",
                $bad0d01969ce5ee2$var$l.Type
            ]
        ]
    },
    time: {
        globalAttributes: !0,
        attributes: [
            [
                "datetime",
                $bad0d01969ce5ee2$var$V.Type
            ]
        ]
    },
    code: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    var: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    samp: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    kbd: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    i: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    b: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    u: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    mark: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    bdi: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    bdo: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    span: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    br: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    wbr: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    ins: {
        globalAttributes: !0,
        attributes: [
            [
                "cite",
                $bad0d01969ce5ee2$var$d.PotentiallySurroundedBySpaces
            ],
            [
                "datetime",
                $bad0d01969ce5ee2$var$V.Type
            ]
        ]
    },
    del: {
        globalAttributes: !0,
        attributes: [
            [
                "cite",
                $bad0d01969ce5ee2$var$d.PotentiallySurroundedBySpaces
            ],
            [
                "datetime",
                $bad0d01969ce5ee2$var$V.Type
            ]
        ]
    },
    picture: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    source: {
        globalAttributes: !0,
        attributes: [
            [
                "type",
                $bad0d01969ce5ee2$var$h.Type
            ],
            [
                "media",
                $bad0d01969ce5ee2$var$R.Type
            ],
            [
                "src",
                $bad0d01969ce5ee2$var$d.NonEmptyPotentiallySurroundedBySpaces
            ],
            [
                "srcset",
                $bad0d01969ce5ee2$var$k.Type
            ],
            [
                "sizes",
                $bad0d01969ce5ee2$var$O.Type
            ],
            [
                "width",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "height",
                $bad0d01969ce5ee2$var$c.Type
            ]
        ]
    },
    img: {
        globalAttributes: !0,
        attributes: [
            [
                "alt",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "src",
                $bad0d01969ce5ee2$var$d.NonEmptyPotentiallySurroundedBySpaces
            ],
            [
                "srcset",
                $bad0d01969ce5ee2$var$k.Type
            ],
            [
                "sizes",
                $bad0d01969ce5ee2$var$O.Type
            ],
            [
                "crossorigin",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "",
                        "anonymous",
                        "use-credentials"
                    ]
                }
            ],
            [
                "usemap",
                $bad0d01969ce5ee2$var$z.Type
            ],
            [
                "ismap",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "width",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "height",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "referrerpolicy",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "",
                        "no-referrer",
                        "no-referrer-when-downgrade",
                        "same-origin",
                        "origin",
                        "strict-origin",
                        "origin-when-cross-origin",
                        "strict-origin-when-cross-origin",
                        "unsafe-url"
                    ]
                }
            ],
            [
                "decoding",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "sync",
                        "async",
                        "auto"
                    ]
                }
            ],
            [
                "loading",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "eager",
                        "lazy"
                    ]
                }
            ],
            [
                "fetchpriority",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "high",
                        "low",
                        "auto"
                    ]
                }
            ]
        ]
    },
    iframe: {
        globalAttributes: !0,
        attributes: [
            [
                "src",
                $bad0d01969ce5ee2$var$d.NonEmptyPotentiallySurroundedBySpaces
            ],
            [
                "srcdoc",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "name",
                {
                    type: "#or",
                    items: [
                        $bad0d01969ce5ee2$var$T.Type,
                        {
                            type: $bad0d01969ce5ee2$var$i.type,
                            keywords: [
                                "_blank",
                                "_self",
                                "_parent",
                                "_top"
                            ]
                        }
                    ]
                }
            ],
            [
                "sandbox",
                {
                    type: $bad0d01969ce5ee2$var$m.type,
                    unique: !0,
                    allowed: [
                        "allow-downloads",
                        "allow-forms",
                        "allow-modals",
                        "allow-orientation-lock",
                        "allow-pointer-lock",
                        "allow-popups",
                        "allow-popups-to-escape-sandbox",
                        "allow-presentation",
                        "allow-same-origin",
                        "allow-scripts",
                        "allow-top-navigation",
                        "allow-top-navigation-by-user-activation",
                        "allow-top-navigation-to-custom-protocols"
                    ]
                }
            ],
            [
                "allow",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "allowfullscreen",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "width",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "height",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "referrerpolicy",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "",
                        "no-referrer",
                        "no-referrer-when-downgrade",
                        "same-origin",
                        "origin",
                        "strict-origin",
                        "origin-when-cross-origin",
                        "strict-origin-when-cross-origin",
                        "unsafe-url"
                    ]
                }
            ],
            [
                "loading",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "eager",
                        "lazy"
                    ]
                }
            ]
        ]
    },
    embed: {
        globalAttributes: !0,
        attributes: [
            [
                "src",
                $bad0d01969ce5ee2$var$d.NonEmptyPotentiallySurroundedBySpaces
            ],
            [
                "type",
                $bad0d01969ce5ee2$var$h.Type
            ],
            [
                "width",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "height",
                $bad0d01969ce5ee2$var$c.Type
            ]
        ]
    },
    object: {
        globalAttributes: !0,
        attributes: [
            [
                "data",
                $bad0d01969ce5ee2$var$d.NonEmptyPotentiallySurroundedBySpaces
            ],
            [
                "type",
                $bad0d01969ce5ee2$var$h.Type
            ],
            [
                "name",
                {
                    type: "#or",
                    items: [
                        $bad0d01969ce5ee2$var$T.Type,
                        {
                            type: $bad0d01969ce5ee2$var$i.type,
                            keywords: [
                                "_blank",
                                "_self",
                                "_parent",
                                "_top"
                            ]
                        }
                    ]
                }
            ],
            [
                "form",
                $bad0d01969ce5ee2$var$g.Type
            ],
            [
                "width",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "height",
                $bad0d01969ce5ee2$var$c.Type
            ]
        ]
    },
    video: {
        globalAttributes: !0,
        attributes: [
            [
                "src",
                $bad0d01969ce5ee2$var$d.NonEmptyPotentiallySurroundedBySpaces
            ],
            [
                "crossorigin",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "",
                        "anonymous",
                        "use-credentials"
                    ]
                }
            ],
            [
                "poster",
                $bad0d01969ce5ee2$var$d.NonEmptyPotentiallySurroundedBySpaces
            ],
            [
                "preload",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "",
                        "none",
                        "metadata",
                        "auto"
                    ]
                }
            ],
            [
                "autoplay",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "playsinline",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "loop",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "muted",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "controls",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "width",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "height",
                $bad0d01969ce5ee2$var$c.Type
            ]
        ]
    },
    audio: {
        globalAttributes: !0,
        attributes: [
            [
                "src",
                $bad0d01969ce5ee2$var$d.NonEmptyPotentiallySurroundedBySpaces
            ],
            [
                "crossorigin",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "",
                        "anonymous",
                        "use-credentials"
                    ]
                }
            ],
            [
                "preload",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "",
                        "none",
                        "metadata",
                        "auto"
                    ]
                }
            ],
            [
                "autoplay",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "loop",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "muted",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "controls",
                $bad0d01969ce5ee2$var$n.Type
            ]
        ]
    },
    track: {
        globalAttributes: !0,
        attributes: [
            [
                "kind",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "subtitles",
                        "captions",
                        "descriptions",
                        "chapters",
                        "metadata"
                    ]
                }
            ],
            [
                "src",
                $bad0d01969ce5ee2$var$d.NonEmptyPotentiallySurroundedBySpaces
            ],
            [
                "srclang",
                $bad0d01969ce5ee2$var$E.Type
            ],
            [
                "label",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "default",
                $bad0d01969ce5ee2$var$n.Type
            ]
        ]
    },
    map: {
        globalAttributes: !0,
        attributes: [
            [
                "name",
                $bad0d01969ce5ee2$var$l.Type
            ]
        ]
    },
    area: {
        globalAttributes: !0,
        attributes: [
            [
                "alt",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "coords",
                {
                    type: $bad0d01969ce5ee2$var$G.type
                }
            ],
            [
                "shape",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "circle",
                        "default",
                        "poly",
                        "rect"
                    ]
                }
            ],
            [
                "href",
                $bad0d01969ce5ee2$var$d.PotentiallySurroundedBySpaces
            ],
            [
                "target",
                {
                    type: "#or",
                    items: [
                        $bad0d01969ce5ee2$var$T.Type,
                        {
                            type: $bad0d01969ce5ee2$var$i.type,
                            keywords: [
                                "_blank",
                                "_self",
                                "_parent",
                                "_top"
                            ]
                        }
                    ]
                }
            ],
            [
                "download",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "ping",
                {
                    type: $bad0d01969ce5ee2$var$m.type,
                    unique: !1,
                    validateToken (y) {
                        if (y.length === 0) return !1;
                        try {
                            let t = new URL(y);
                            return t.protocol === "http:" || t.protocol === "https:";
                        } catch (t) {
                            return !1;
                        }
                    }
                }
            ],
            [
                "rel",
                {
                    type: $bad0d01969ce5ee2$var$m.type,
                    unique: !0,
                    allowed: [
                        "alternate",
                        "author",
                        "bookmark",
                        "external",
                        "help",
                        "license",
                        "next",
                        "nofollow",
                        "noopener",
                        "noreferrer",
                        "opener",
                        "prev",
                        "privacy-policy",
                        "search",
                        "tag",
                        "terms-of-service"
                    ]
                }
            ],
            [
                "referrerpolicy",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "",
                        "no-referrer",
                        "no-referrer-when-downgrade",
                        "same-origin",
                        "origin",
                        "strict-origin",
                        "origin-when-cross-origin",
                        "strict-origin-when-cross-origin",
                        "unsafe-url"
                    ]
                }
            ]
        ]
    },
    table: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    caption: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    colgroup: {
        globalAttributes: !0,
        attributes: [
            [
                "span",
                $bad0d01969ce5ee2$var$c.GreaterThanZero
            ]
        ]
    },
    col: {
        globalAttributes: !0,
        attributes: [
            [
                "span",
                $bad0d01969ce5ee2$var$c.GreaterThanZero
            ]
        ]
    },
    tbody: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    thead: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    tfoot: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    tr: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    td: {
        globalAttributes: !0,
        attributes: [
            [
                "colspan",
                $bad0d01969ce5ee2$var$c.GreaterThanZero
            ],
            [
                "rowspan",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "headers",
                {
                    type: $bad0d01969ce5ee2$var$m.type,
                    unique: !0
                }
            ]
        ]
    },
    th: {
        globalAttributes: !0,
        attributes: [
            [
                "colspan",
                $bad0d01969ce5ee2$var$c.GreaterThanZero
            ],
            [
                "rowspan",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "headers",
                {
                    type: $bad0d01969ce5ee2$var$m.type,
                    unique: !0
                }
            ],
            [
                "scope",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "row",
                        "col",
                        "rowgroup",
                        "colgroup"
                    ]
                }
            ],
            [
                "abbr",
                $bad0d01969ce5ee2$var$l.Type
            ]
        ]
    },
    form: {
        globalAttributes: !0,
        attributes: [
            [
                "accept-charset",
                {
                    type: $bad0d01969ce5ee2$var$m.type,
                    unique: !0
                }
            ],
            [
                "action",
                $bad0d01969ce5ee2$var$d.NonEmptyPotentiallySurroundedBySpaces
            ],
            [
                "autocomplete",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "on",
                        "off"
                    ]
                }
            ],
            [
                "enctype",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "application/x-www-form-urlencoded",
                        "multipart/form-data",
                        "text/plain"
                    ]
                }
            ],
            [
                "method",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "get",
                        "post",
                        "dialog"
                    ]
                }
            ],
            [
                "name",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "novalidate",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "target",
                {
                    type: "#or",
                    items: [
                        $bad0d01969ce5ee2$var$T.Type,
                        {
                            type: $bad0d01969ce5ee2$var$i.type,
                            keywords: [
                                "_blank",
                                "_self",
                                "_parent",
                                "_top"
                            ]
                        }
                    ]
                }
            ],
            [
                "rel",
                {
                    type: $bad0d01969ce5ee2$var$m.type,
                    unique: !0,
                    allowed: [
                        "external",
                        "help",
                        "license",
                        "next",
                        "nofollow",
                        "noopener",
                        "noreferrer",
                        "opener",
                        "prev",
                        "search"
                    ]
                }
            ]
        ]
    },
    label: {
        globalAttributes: !0,
        attributes: [
            [
                "for",
                $bad0d01969ce5ee2$var$g.Type
            ]
        ]
    },
    input: {
        globalAttributes: !0,
        attributes: [
            [
                "accept",
                {
                    type: $bad0d01969ce5ee2$var$C.type
                }
            ],
            [
                "alt",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "autocomplete",
                $bad0d01969ce5ee2$var$L.Type
            ],
            [
                "checked",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "dirname",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "disabled",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "form",
                $bad0d01969ce5ee2$var$g.Type
            ],
            [
                "formaction",
                $bad0d01969ce5ee2$var$d.NonEmptyPotentiallySurroundedBySpaces
            ],
            [
                "formenctype",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "application/x-www-form-urlencoded",
                        "multipart/form-data",
                        "text/plain"
                    ]
                }
            ],
            [
                "formmethod",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "get",
                        "post",
                        "dialog"
                    ]
                }
            ],
            [
                "formnovalidate",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "formtarget",
                {
                    type: "#or",
                    items: [
                        $bad0d01969ce5ee2$var$T.Type,
                        {
                            type: $bad0d01969ce5ee2$var$i.type,
                            keywords: [
                                "_blank",
                                "_self",
                                "_parent",
                                "_top"
                            ]
                        }
                    ]
                }
            ],
            [
                "height",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "list",
                $bad0d01969ce5ee2$var$g.Type
            ],
            [
                "max",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "maxlength",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "min",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "minlength",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "multiple",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "name",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "pattern",
                $bad0d01969ce5ee2$var$_.Type
            ],
            [
                "placeholder",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "popovertarget",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "popovertargetaction",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "hide",
                        "show",
                        "toggle"
                    ]
                }
            ],
            [
                "readonly",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "required",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "size",
                $bad0d01969ce5ee2$var$c.GreaterThanZero
            ],
            [
                "src",
                $bad0d01969ce5ee2$var$d.NonEmptyPotentiallySurroundedBySpaces
            ],
            [
                "step",
                {
                    type: "#or",
                    items: [
                        $bad0d01969ce5ee2$var$f.Type,
                        {
                            type: $bad0d01969ce5ee2$var$i.type,
                            keywords: [
                                "any"
                            ]
                        }
                    ]
                }
            ],
            [
                "type",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "hidden",
                        "text",
                        "search",
                        "tel",
                        "url",
                        "email",
                        "password",
                        "date",
                        "month",
                        "week",
                        "time",
                        "datetime-local",
                        "number",
                        "range",
                        "color",
                        "checkbox",
                        "radio",
                        "file",
                        "submit",
                        "image",
                        "reset",
                        "button"
                    ]
                }
            ],
            [
                "value",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "width",
                $bad0d01969ce5ee2$var$c.Type
            ]
        ]
    },
    button: {
        globalAttributes: !0,
        attributes: [
            [
                "disabled",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "form",
                $bad0d01969ce5ee2$var$g.Type
            ],
            [
                "formaction",
                $bad0d01969ce5ee2$var$d.NonEmptyPotentiallySurroundedBySpaces
            ],
            [
                "formenctype",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "application/x-www-form-urlencoded",
                        "multipart/form-data",
                        "text/plain"
                    ]
                }
            ],
            [
                "formmethod",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "get",
                        "post",
                        "dialog"
                    ]
                }
            ],
            [
                "formnovalidate",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "formtarget",
                {
                    type: "#or",
                    items: [
                        $bad0d01969ce5ee2$var$T.Type,
                        {
                            type: $bad0d01969ce5ee2$var$i.type,
                            keywords: [
                                "_blank",
                                "_self",
                                "_parent",
                                "_top"
                            ]
                        }
                    ]
                }
            ],
            [
                "name",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "popovertarget",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "popovertargetaction",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "hide",
                        "show",
                        "toggle"
                    ]
                }
            ],
            [
                "type",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "submit",
                        "reset",
                        "button"
                    ]
                }
            ],
            [
                "value",
                $bad0d01969ce5ee2$var$l.Type
            ]
        ]
    },
    select: {
        globalAttributes: !0,
        attributes: [
            [
                "autocomplete",
                $bad0d01969ce5ee2$var$L.Type
            ],
            [
                "disabled",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "form",
                $bad0d01969ce5ee2$var$g.Type
            ],
            [
                "multiple",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "name",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "required",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "size",
                $bad0d01969ce5ee2$var$c.GreaterThanZero
            ]
        ]
    },
    datalist: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    optgroup: {
        globalAttributes: !0,
        attributes: [
            [
                "disabled",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "label",
                $bad0d01969ce5ee2$var$l.Type
            ]
        ]
    },
    option: {
        globalAttributes: !0,
        attributes: [
            [
                "disabled",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "label",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "selected",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "value",
                $bad0d01969ce5ee2$var$l.Type
            ]
        ]
    },
    textarea: {
        globalAttributes: !0,
        attributes: [
            [
                "autocomplete",
                $bad0d01969ce5ee2$var$L.Type
            ],
            [
                "cols",
                $bad0d01969ce5ee2$var$c.GreaterThanZero
            ],
            [
                "dirname",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "disabled",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "form",
                $bad0d01969ce5ee2$var$g.Type
            ],
            [
                "maxlength",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "minlength",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "name",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "placeholder",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "readonly",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "required",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "rows",
                $bad0d01969ce5ee2$var$c.GreaterThanZero
            ],
            [
                "wrap",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "soft",
                        "hard"
                    ]
                }
            ]
        ]
    },
    output: {
        globalAttributes: !0,
        attributes: [
            [
                "for",
                {
                    type: $bad0d01969ce5ee2$var$m.type,
                    unique: !0
                }
            ],
            [
                "form",
                $bad0d01969ce5ee2$var$g.Type
            ],
            [
                "name",
                $bad0d01969ce5ee2$var$l.Type
            ]
        ]
    },
    progress: {
        globalAttributes: !0,
        attributes: [
            [
                "value",
                $bad0d01969ce5ee2$var$f.Type
            ],
            [
                "max",
                $bad0d01969ce5ee2$var$f.Type
            ]
        ]
    },
    meter: {
        globalAttributes: !0,
        attributes: [
            [
                "value",
                $bad0d01969ce5ee2$var$f.Type
            ],
            [
                "min",
                $bad0d01969ce5ee2$var$f.Type
            ],
            [
                "max",
                $bad0d01969ce5ee2$var$f.Type
            ],
            [
                "low",
                $bad0d01969ce5ee2$var$f.Type
            ],
            [
                "high",
                $bad0d01969ce5ee2$var$f.Type
            ],
            [
                "optimum",
                $bad0d01969ce5ee2$var$f.Type
            ]
        ]
    },
    fieldset: {
        globalAttributes: !0,
        attributes: [
            [
                "disabled",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "form",
                $bad0d01969ce5ee2$var$g.Type
            ],
            [
                "name",
                $bad0d01969ce5ee2$var$l.Type
            ]
        ]
    },
    legend: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    selectedcontent: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    details: {
        globalAttributes: !0,
        attributes: [
            [
                "open",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "name",
                $bad0d01969ce5ee2$var$l.Type
            ]
        ]
    },
    summary: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    dialog: {
        globalAttributes: !0,
        attributes: [
            [
                "open",
                $bad0d01969ce5ee2$var$n.Type
            ]
        ]
    },
    script: {
        globalAttributes: !0,
        attributes: [
            [
                "src",
                $bad0d01969ce5ee2$var$d.NonEmptyPotentiallySurroundedBySpaces
            ],
            [
                "type",
                {
                    type: $bad0d01969ce5ee2$var$B.type,
                    items: [
                        {
                            type: $bad0d01969ce5ee2$var$i.type,
                            keywords: [
                                "module",
                                "importmap",
                                "speculationrules"
                            ]
                        },
                        $bad0d01969ce5ee2$var$h.Type
                    ]
                }
            ],
            [
                "nomodule",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "async",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "defer",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "crossorigin",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "",
                        "anonymous",
                        "use-credentials"
                    ]
                }
            ],
            [
                "integrity",
                $bad0d01969ce5ee2$var$l.Type
            ],
            [
                "referrerpolicy",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "",
                        "no-referrer",
                        "no-referrer-when-downgrade",
                        "same-origin",
                        "origin",
                        "strict-origin",
                        "origin-when-cross-origin",
                        "strict-origin-when-cross-origin",
                        "unsafe-url"
                    ]
                }
            ],
            [
                "blocking",
                {
                    type: $bad0d01969ce5ee2$var$m.type,
                    unique: !0
                }
            ],
            [
                "fetchpriority",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "high",
                        "low",
                        "auto"
                    ]
                }
            ]
        ]
    },
    noscript: {
        globalAttributes: !0,
        attributes: $bad0d01969ce5ee2$var$s
    },
    template: {
        globalAttributes: !0,
        attributes: [
            [
                "shadowrootmode",
                {
                    type: $bad0d01969ce5ee2$var$i.type,
                    keywords: [
                        "open",
                        "closed"
                    ]
                }
            ],
            [
                "shadowrootdelegatesfocus",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "shadowrootclonable",
                $bad0d01969ce5ee2$var$n.Type
            ],
            [
                "shadowrootserializable",
                $bad0d01969ce5ee2$var$n.Type
            ]
        ]
    },
    slot: {
        globalAttributes: !0,
        attributes: [
            [
                "name",
                $bad0d01969ce5ee2$var$l.Type
            ]
        ]
    },
    canvas: {
        globalAttributes: !0,
        attributes: [
            [
                "width",
                $bad0d01969ce5ee2$var$c.Type
            ],
            [
                "height",
                $bad0d01969ce5ee2$var$c.Type
            ]
        ]
    }
};
var $bad0d01969ce5ee2$var$nt = class {
    constructor(t){
        this.state = t;
        this.get = (t)=>{
            var u, b, A;
            let e = this.getSpecDefinition();
            if (!e) return null;
            let a = null;
            return e.globalAttributes && (a = (u = $bad0d01969ce5ee2$var$yt.get(t)) != null ? u : null, a) ? new $bad0d01969ce5ee2$var$rt(t, a) : (a = (A = (b = e == null ? void 0 : e.attributes.find(([S])=>t.toLowerCase() === S)) == null ? void 0 : b[1]) != null ? A : null, a ? new $bad0d01969ce5ee2$var$rt(t, a) : null);
        };
        this.has = (t)=>{
            let e = this.getSpecDefinition();
            return e != null && e.globalAttributes && $bad0d01969ce5ee2$var$yt.has(t) ? !0 : !!(e == null ? void 0 : e.attributes.find(([u])=>t.toLowerCase() === u));
        };
    }
    getSpecDefinition() {
        let t = $bad0d01969ce5ee2$var$mt[this.state.name];
        return t != null ? t : null;
    }
};
var $bad0d01969ce5ee2$var$pt = class {
    constructor(t, e){
        this.implicitRole = ()=>{
            let t = $bad0d01969ce5ee2$var$dt[this.state.name];
            return t ? t(this.state) : null;
        };
        this.state = new $bad0d01969ce5ee2$var$ot(t, e);
    }
    get attributes() {
        return new $bad0d01969ce5ee2$var$nt(this.state);
    }
};
function $bad0d01969ce5ee2$export$8454457683f90105(y, t = {}) {
    return new $bad0d01969ce5ee2$var$pt(y, t);
}


var $404c96e82c1b1d4e$export$2db0830b5f0899da = {
    invalid: "invalid"
};
function $404c96e82c1b1d4e$export$5bd6a5451dea460e(options) {
    const allowList = options.allow || [];
    const compiledAllowList = allowList.map((rule)=>({
            tag: rule.tag.toLowerCase(),
            attr: rule.attr.toLowerCase(),
            valuePattern: rule.valuePattern ? new RegExp(rule.valuePattern) : void 0
        }));
    function shouldAllow(elementName, attrKey, attrValue) {
        return compiledAllowList.some((allowRule)=>{
            const tagMatch = allowRule.tag === elementName.toLowerCase();
            const attrMatch = allowRule.attr === attrKey.toLowerCase();
            if (!tagMatch || !attrMatch) return false;
            if (allowRule.valuePattern === void 0) return true;
            return allowRule.valuePattern.test(attrValue);
        });
    }
    return {
        /**
     * @param {ElementAdapter} adapter
     * @returns {NoInvalidAttrValueResult}
     */ checkAttributes (adapter) {
            const name = adapter.getElementName();
            if (name.includes("-")) return [];
            const spec = (0, $bad0d01969ce5ee2$export$8454457683f90105)(name);
            const result = [];
            for (const attribute of adapter.getAttributes()){
                const attributeKey = attribute.getKey();
                if (!attributeKey) continue;
                if (attributeKey.hasExpression()) continue;
                const attributeValue = attribute.getValue();
                if (attributeValue?.hasExpression()) continue;
                const attrKeyValue = attributeKey.getValue();
                const attrValueValue = attributeValue?.getValue() ?? null;
                if (attrValueValue === null) continue;
                if (attrKeyValue && shouldAllow(name, attrKeyValue, attrValueValue)) continue;
                if (!attrKeyValue || attrValueValue === null) continue;
                const validator = spec.attributes.get(attrKeyValue);
                if (validator) {
                    const validateResult = validator.validateValue(attrValueValue);
                    if (!validateResult.valid) result.push({
                        loc: attributeValue?.getLocation() ?? attributeKey?.getLocation(),
                        messageId: $404c96e82c1b1d4e$export$2db0830b5f0899da.invalid,
                        data: {
                            value: attrValueValue || "",
                            attr: attrKeyValue,
                            element: name,
                            suggestion: validateResult.reason || "Use a valid value."
                        }
                    });
                }
            }
            return result;
        }
    };
}
// lib/utils/baseline.js
var $404c96e82c1b1d4e$var$BASELINE_HIGH = 10;
var $404c96e82c1b1d4e$var$BASELINE_LOW = 5;
var $404c96e82c1b1d4e$var$elements = /* @__PURE__ */ new Map([
    [
        "a",
        "10:2015"
    ],
    [
        "a.attributionsourceid",
        "0:"
    ],
    [
        "a.attributionsrc",
        "0:"
    ],
    [
        "a.download",
        "10:2019"
    ],
    [
        "a.href",
        "10:2015"
    ],
    [
        "a.href.href_sms",
        "0:"
    ],
    [
        "a.href.href_top",
        "10:2015"
    ],
    [
        "a.hreflang",
        "10:2015"
    ],
    [
        "a.implicit_noopener",
        "10:2021"
    ],
    [
        "a.interestfor",
        "0:"
    ],
    [
        "a.ping",
        "0:"
    ],
    [
        "a.referrerpolicy",
        "10:2020"
    ],
    [
        "a.referrerpolicy.no-referrer-when-downgrade",
        "0:"
    ],
    [
        "a.referrerpolicy.origin-when-cross-origin",
        "0:"
    ],
    [
        "a.referrerpolicy.unsafe-url",
        "0:"
    ],
    [
        "a.rel",
        "10:2015"
    ],
    [
        "a.rel.noopener",
        "10:2020"
    ],
    [
        "a.rel.noreferrer",
        "10:2015"
    ],
    [
        "a.target",
        "10:2015"
    ],
    [
        "a.target.unfencedTop",
        "0:"
    ],
    [
        "a.text_fragments",
        "5:2024"
    ],
    [
        "a.type",
        "10:2015"
    ],
    [
        "abbr",
        "10:2015"
    ],
    [
        "address",
        "10:2015"
    ],
    [
        "area",
        "10:2015"
    ],
    [
        "area.alt",
        "10:2015"
    ],
    [
        "area.attributionsrc",
        "0:"
    ],
    [
        "area.coords",
        "10:2015"
    ],
    [
        "area.download",
        "10:2017"
    ],
    [
        "area.href",
        "10:2015"
    ],
    [
        "area.implicit_noopener",
        "10:2021"
    ],
    [
        "area.interestfor",
        "0:"
    ],
    [
        "area.ping",
        "0:"
    ],
    [
        "area.referrerpolicy",
        "10:2020"
    ],
    [
        "area.referrerpolicy.no-referrer-when-downgrade",
        "0:"
    ],
    [
        "area.referrerpolicy.origin-when-cross-origin",
        "0:"
    ],
    [
        "area.referrerpolicy.unsafe-url",
        "0:"
    ],
    [
        "area.rel",
        "10:2015"
    ],
    [
        "area.rel.noopener",
        "10:2020"
    ],
    [
        "area.rel.noreferrer",
        "10:2015"
    ],
    [
        "area.shape",
        "10:2015"
    ],
    [
        "area.target",
        "10:2015"
    ],
    [
        "article",
        "10:2015"
    ],
    [
        "aside",
        "10:2015"
    ],
    [
        "audio",
        "10:2015"
    ],
    [
        "audio.controls",
        "10:2015"
    ],
    [
        "audio.controlslist",
        "0:"
    ],
    [
        "audio.crossorigin",
        "10:2020"
    ],
    [
        "audio.disableremoteplayback",
        "0:"
    ],
    [
        "audio.loading",
        "0:"
    ],
    [
        "audio.loop",
        "10:2015"
    ],
    [
        "audio.muted",
        "10:2018"
    ],
    [
        "audio.preload",
        "10:2015"
    ],
    [
        "audio.src",
        "10:2015"
    ],
    [
        "b",
        "10:2015"
    ],
    [
        "base",
        "10:2015"
    ],
    [
        "base.href",
        "10:2015"
    ],
    [
        "base.href.forbid_data_javascript_urls",
        "5:2024"
    ],
    [
        "base.href.relative_url",
        "10:2015"
    ],
    [
        "base.target",
        "10:2015"
    ],
    [
        "bdi",
        "10:2020"
    ],
    [
        "bdo",
        "10:2015"
    ],
    [
        "blockquote",
        "10:2015"
    ],
    [
        "blockquote.cite",
        "10:2015"
    ],
    [
        "body",
        "10:2015"
    ],
    [
        "br",
        "10:2015"
    ],
    [
        "button",
        "10:2015"
    ],
    [
        "button.command",
        "5:2025"
    ],
    [
        "button.command.request-close",
        "5:2025"
    ],
    [
        "button.commandfor",
        "5:2025"
    ],
    [
        "button.commandfor.implicit_anchor_reference",
        "5:2026"
    ],
    [
        "button.disabled",
        "10:2015"
    ],
    [
        "button.form",
        "10:2017"
    ],
    [
        "button.formaction",
        "10:2015"
    ],
    [
        "button.formenctype",
        "10:2015"
    ],
    [
        "button.formmethod",
        "10:2015"
    ],
    [
        "button.formnovalidate",
        "10:2015"
    ],
    [
        "button.formtarget",
        "10:2015"
    ],
    [
        "button.interestfor",
        "0:"
    ],
    [
        "button.name",
        "10:2015"
    ],
    [
        "button.popovertarget",
        "5:2024"
    ],
    [
        "button.popovertarget.implicit_anchor_reference",
        "5:2026"
    ],
    [
        "button.popovertargetaction",
        "5:2024"
    ],
    [
        "button.type",
        "10:2015"
    ],
    [
        "button.value",
        "10:2015"
    ],
    [
        "canvas",
        "10:2015"
    ],
    [
        "canvas.height",
        "10:2015"
    ],
    [
        "canvas.width",
        "10:2015"
    ],
    [
        "caption",
        "10:2015"
    ],
    [
        "caption.align",
        "0:"
    ],
    [
        "cite",
        "10:2015"
    ],
    [
        "code",
        "10:2015"
    ],
    [
        "col",
        "10:2015"
    ],
    [
        "col.align",
        "0:"
    ],
    [
        "col.char",
        "0:"
    ],
    [
        "col.charoff",
        "0:"
    ],
    [
        "col.span",
        "10:2015"
    ],
    [
        "col.valign",
        "0:"
    ],
    [
        "col.width",
        "0:"
    ],
    [
        "colgroup",
        "10:2015"
    ],
    [
        "colgroup.align",
        "0:"
    ],
    [
        "colgroup.char",
        "0:"
    ],
    [
        "colgroup.charoff",
        "0:"
    ],
    [
        "colgroup.span",
        "10:2015"
    ],
    [
        "colgroup.valign",
        "0:"
    ],
    [
        "colgroup.width",
        "0:"
    ],
    [
        "data",
        "10:2017"
    ],
    [
        "data.value",
        "10:2017"
    ],
    [
        "datalist",
        "0:"
    ],
    [
        "datalist.input_type_color",
        "0:"
    ],
    [
        "datalist.input_type_date",
        "0:"
    ],
    [
        "datalist.input_type_email",
        "0:"
    ],
    [
        "datalist.input_type_number",
        "0:"
    ],
    [
        "datalist.input_type_range",
        "0:"
    ],
    [
        "datalist.input_type_search",
        "0:"
    ],
    [
        "datalist.input_type_tel",
        "0:"
    ],
    [
        "datalist.input_type_text",
        "0:"
    ],
    [
        "datalist.input_type_time",
        "0:"
    ],
    [
        "datalist.input_type_url",
        "0:"
    ],
    [
        "dd",
        "10:2015"
    ],
    [
        "del",
        "10:2015"
    ],
    [
        "del.cite",
        "10:2015"
    ],
    [
        "del.datetime",
        "10:2015"
    ],
    [
        "details",
        "10:2020"
    ],
    [
        "details.name",
        "5:2024"
    ],
    [
        "details.open",
        "10:2020"
    ],
    [
        "dfn",
        "10:2015"
    ],
    [
        "dialog",
        "10:2022"
    ],
    [
        "dialog.closedby",
        "0:"
    ],
    [
        "dialog.open",
        "10:2022"
    ],
    [
        "div",
        "10:2015"
    ],
    [
        "dl",
        "10:2015"
    ],
    [
        "dt",
        "10:2015"
    ],
    [
        "em",
        "10:2015"
    ],
    [
        "embed",
        "10:2015"
    ],
    [
        "embed.height",
        "10:2015"
    ],
    [
        "embed.src",
        "10:2015"
    ],
    [
        "embed.type",
        "10:2020"
    ],
    [
        "embed.width",
        "10:2015"
    ],
    [
        "fencedframe",
        "0:"
    ],
    [
        "fencedframe.allow",
        "0:"
    ],
    [
        "fencedframe.height",
        "0:"
    ],
    [
        "fencedframe.width",
        "0:"
    ],
    [
        "fieldset",
        "10:2015"
    ],
    [
        "fieldset.disabled",
        "10:2020"
    ],
    [
        "fieldset.form",
        "10:2015"
    ],
    [
        "fieldset.name",
        "10:2015"
    ],
    [
        "figcaption",
        "10:2015"
    ],
    [
        "figure",
        "10:2015"
    ],
    [
        "footer",
        "10:2015"
    ],
    [
        "form",
        "10:2015"
    ],
    [
        "form.accept-charset",
        "10:2015"
    ],
    [
        "form.action",
        "10:2015"
    ],
    [
        "form.autocomplete",
        "10:2015"
    ],
    [
        "form.enctype",
        "10:2015"
    ],
    [
        "form.method",
        "10:2015"
    ],
    [
        "form.name",
        "10:2015"
    ],
    [
        "form.novalidate",
        "10:2017"
    ],
    [
        "form.rel",
        "10:2023"
    ],
    [
        "form.target",
        "10:2015"
    ],
    [
        "geolocation",
        "0:"
    ],
    [
        "geolocation.autolocate",
        "0:"
    ],
    [
        "geolocation.watch",
        "0:"
    ],
    [
        "h1",
        "10:2015"
    ],
    [
        "h1.no_ua_styles_in_article_aside_nav_section",
        "0:"
    ],
    [
        "h2",
        "10:2015"
    ],
    [
        "h3",
        "10:2015"
    ],
    [
        "h4",
        "10:2015"
    ],
    [
        "h5",
        "10:2015"
    ],
    [
        "h6",
        "10:2015"
    ],
    [
        "head",
        "10:2015"
    ],
    [
        "header",
        "10:2015"
    ],
    [
        "hgroup",
        "10:2015"
    ],
    [
        "hr",
        "10:2015"
    ],
    [
        "html",
        "10:2015"
    ],
    [
        "i",
        "10:2015"
    ],
    [
        "iframe",
        "10:2015"
    ],
    [
        "iframe.allow",
        "10:2020"
    ],
    [
        "iframe.allow.accelerometer",
        "0:"
    ],
    [
        "iframe.allow.ambient-light-sensor",
        "0:"
    ],
    [
        "iframe.allow.attribution-reporting",
        "0:"
    ],
    [
        "iframe.allow.bluetooth",
        "0:"
    ],
    [
        "iframe.allow.browsing-topics",
        "0:"
    ],
    [
        "iframe.allow.camera",
        "10:2020"
    ],
    [
        "iframe.allow.compute-pressure",
        "0:"
    ],
    [
        "iframe.allow.display-capture",
        "0:"
    ],
    [
        "iframe.allow.encrypted-media",
        "0:"
    ],
    [
        "iframe.allow.fullscreen",
        "0:"
    ],
    [
        "iframe.allow.gamepad",
        "0:"
    ],
    [
        "iframe.allow.geolocation",
        "0:"
    ],
    [
        "iframe.allow.gyroscope",
        "0:"
    ],
    [
        "iframe.allow.hid",
        "0:"
    ],
    [
        "iframe.allow.idle-detection",
        "0:"
    ],
    [
        "iframe.allow.local-fonts",
        "0:"
    ],
    [
        "iframe.allow.magnetometer",
        "0:"
    ],
    [
        "iframe.allow.microphone",
        "10:2020"
    ],
    [
        "iframe.allow.midi",
        "0:"
    ],
    [
        "iframe.allow.otp-credentials",
        "0:"
    ],
    [
        "iframe.allow.payment",
        "0:"
    ],
    [
        "iframe.allow.picture-in-picture",
        "0:"
    ],
    [
        "iframe.allow.publickey-credentials-create",
        "0:"
    ],
    [
        "iframe.allow.publickey-credentials-get",
        "0:"
    ],
    [
        "iframe.allow.screen-wake-lock",
        "5:2024"
    ],
    [
        "iframe.allow.serial",
        "0:"
    ],
    [
        "iframe.allow.storage-access",
        "0:"
    ],
    [
        "iframe.allow.usb",
        "0:"
    ],
    [
        "iframe.allow.web-share",
        "0:"
    ],
    [
        "iframe.allow.window-management",
        "0:"
    ],
    [
        "iframe.allow.xr-spatial-tracking",
        "0:"
    ],
    [
        "iframe.allowfullscreen",
        "0:"
    ],
    [
        "iframe.browsingtopics",
        "0:"
    ],
    [
        "iframe.credentialless",
        "0:"
    ],
    [
        "iframe.csp",
        "0:"
    ],
    [
        "iframe.height",
        "10:2015"
    ],
    [
        "iframe.loading",
        "5:2023"
    ],
    [
        "iframe.name",
        "10:2015"
    ],
    [
        "iframe.referrerpolicy",
        "10:2020"
    ],
    [
        "iframe.referrerpolicy.no-referrer-when-downgrade",
        "0:"
    ],
    [
        "iframe.referrerpolicy.origin-when-cross-origin",
        "0:"
    ],
    [
        "iframe.referrerpolicy.unsafe-url",
        "0:"
    ],
    [
        "iframe.sandbox",
        "10:2015"
    ],
    [
        "iframe.sandbox.allow-downloads",
        "10:2023"
    ],
    [
        "iframe.sandbox.allow-forms",
        "10:2020"
    ],
    [
        "iframe.sandbox.allow-modals",
        "10:2020"
    ],
    [
        "iframe.sandbox.allow-pointer-lock",
        "0:"
    ],
    [
        "iframe.sandbox.allow-popups",
        "10:2015"
    ],
    [
        "iframe.sandbox.allow-popups-to-escape-sandbox",
        "10:2020"
    ],
    [
        "iframe.sandbox.allow-presentation",
        "0:"
    ],
    [
        "iframe.sandbox.allow-same-origin",
        "10:2020"
    ],
    [
        "iframe.sandbox.allow-scripts",
        "10:2020"
    ],
    [
        "iframe.sandbox.allow-top-navigation",
        "10:2020"
    ],
    [
        "iframe.sandbox.allow-top-navigation-by-user-activation",
        "10:2020"
    ],
    [
        "iframe.sandbox.allow-top-navigation-to-custom-protocols",
        "0:"
    ],
    [
        "iframe.src",
        "10:2015"
    ],
    [
        "iframe.srcdoc",
        "10:2020"
    ],
    [
        "iframe.width",
        "10:2015"
    ],
    [
        "img",
        "10:2015"
    ],
    [
        "img.alt",
        "10:2015"
    ],
    [
        "img.aspect_ratio_computed_from_attributes",
        "10:2021"
    ],
    [
        "img.attributionsrc",
        "0:"
    ],
    [
        "img.crossorigin",
        "10:2015"
    ],
    [
        "img.decoding",
        "10:2020"
    ],
    [
        "img.fetchpriority",
        "5:2024"
    ],
    [
        "img.height",
        "10:2015"
    ],
    [
        "img.ismap",
        "10:2015"
    ],
    [
        "img.loading",
        "10:2022"
    ],
    [
        "img.referrerpolicy",
        "10:2020"
    ],
    [
        "img.referrerpolicy.no-referrer-when-downgrade",
        "0:"
    ],
    [
        "img.referrerpolicy.origin-when-cross-origin",
        "0:"
    ],
    [
        "img.referrerpolicy.unsafe-url",
        "0:"
    ],
    [
        "img.sizes",
        "10:2016"
    ],
    [
        "img.sizes.auto",
        "0:"
    ],
    [
        "img.src",
        "10:2015"
    ],
    [
        "img.srcset",
        "10:2015"
    ],
    [
        "img.usemap",
        "10:2015"
    ],
    [
        "img.width",
        "10:2015"
    ],
    [
        "input",
        "10:2015"
    ],
    [
        "input.accept",
        "10:2015"
    ],
    [
        "input.alpha",
        "0:"
    ],
    [
        "input.alt",
        "10:2015"
    ],
    [
        "input.capture",
        "0:"
    ],
    [
        "input.checked",
        "10:2015"
    ],
    [
        "input.colorspace",
        "0:"
    ],
    [
        "input.dirname",
        "10:2023"
    ],
    [
        "input.disabled",
        "10:2015"
    ],
    [
        "input.form",
        "10:2015"
    ],
    [
        "input.formaction",
        "10:2015"
    ],
    [
        "input.formenctype",
        "10:2015"
    ],
    [
        "input.formmethod",
        "10:2015"
    ],
    [
        "input.formnovalidate",
        "10:2015"
    ],
    [
        "input.formtarget",
        "10:2015"
    ],
    [
        "input.max",
        "10:2015"
    ],
    [
        "input.maxlength",
        "10:2015"
    ],
    [
        "input.min",
        "10:2015"
    ],
    [
        "input.minlength",
        "10:2018"
    ],
    [
        "input.multiple",
        "10:2015"
    ],
    [
        "input.name",
        "10:2015"
    ],
    [
        "input.pattern",
        "10:2015"
    ],
    [
        "input.placeholder",
        "10:2015"
    ],
    [
        "input.popovertarget",
        "5:2024"
    ],
    [
        "input.popovertarget.implicit_anchor_reference",
        "5:2026"
    ],
    [
        "input.popovertargetaction",
        "5:2024"
    ],
    [
        "input.readonly",
        "10:2015"
    ],
    [
        "input.required",
        "10:2015"
    ],
    [
        "input.size",
        "10:2015"
    ],
    [
        "input.src",
        "10:2015"
    ],
    [
        "input.step",
        "10:2015"
    ],
    [
        "input.switch",
        "0:"
    ],
    [
        "input.type_button",
        "10:2015"
    ],
    [
        "input.type_checkbox",
        "10:2015"
    ],
    [
        "input.type_color",
        "0:"
    ],
    [
        "input.type_color.accepts_css_colors",
        "0:"
    ],
    [
        "input.type_color.list",
        "0:"
    ],
    [
        "input.type_date",
        "10:2021"
    ],
    [
        "input.type_date.list",
        "0:"
    ],
    [
        "input.type_datetime-local",
        "10:2021"
    ],
    [
        "input.type_email",
        "10:2015"
    ],
    [
        "input.type_email.list",
        "10:2019"
    ],
    [
        "input.type_file",
        "10:2015"
    ],
    [
        "input.type_hidden",
        "10:2015"
    ],
    [
        "input.type_image",
        "10:2015"
    ],
    [
        "input.type_month",
        "0:"
    ],
    [
        "input.type_number",
        "10:2015"
    ],
    [
        "input.type_number.list",
        "10:2019"
    ],
    [
        "input.type_password",
        "10:2015"
    ],
    [
        "input.type_password.insecure_login_handling",
        "0:"
    ],
    [
        "input.type_radio",
        "10:2015"
    ],
    [
        "input.type_range",
        "10:2017"
    ],
    [
        "input.type_range.labeled_values",
        "0:"
    ],
    [
        "input.type_range.list",
        "0:"
    ],
    [
        "input.type_range.tick_marks",
        "10:2023"
    ],
    [
        "input.type_range.vertical_orientation",
        "5:2024"
    ],
    [
        "input.type_reset",
        "10:2015"
    ],
    [
        "input.type_search",
        "10:2015"
    ],
    [
        "input.type_search.list",
        "10:2019"
    ],
    [
        "input.type_submit",
        "10:2015"
    ],
    [
        "input.type_tel",
        "10:2015"
    ],
    [
        "input.type_tel.list",
        "10:2019"
    ],
    [
        "input.type_text",
        "10:2015"
    ],
    [
        "input.type_text.list",
        "10:2019"
    ],
    [
        "input.type_time",
        "10:2021"
    ],
    [
        "input.type_time.list",
        "0:"
    ],
    [
        "input.type_url",
        "10:2015"
    ],
    [
        "input.type_url.list",
        "10:2019"
    ],
    [
        "input.type_week",
        "0:"
    ],
    [
        "input.webkitdirectory",
        "5:2025"
    ],
    [
        "ins",
        "10:2015"
    ],
    [
        "ins.cite",
        "10:2015"
    ],
    [
        "ins.datetime",
        "10:2015"
    ],
    [
        "kbd",
        "10:2015"
    ],
    [
        "label",
        "10:2015"
    ],
    [
        "label.for",
        "10:2015"
    ],
    [
        "legend",
        "10:2015"
    ],
    [
        "li",
        "10:2015"
    ],
    [
        "li.value",
        "10:2015"
    ],
    [
        "link",
        "10:2015"
    ],
    [
        "link.as",
        "10:2018"
    ],
    [
        "link.blocking",
        "0:"
    ],
    [
        "link.crossorigin",
        "10:2018"
    ],
    [
        "link.disabled",
        "10:2015"
    ],
    [
        "link.fetchpriority",
        "5:2024"
    ],
    [
        "link.href",
        "10:2015"
    ],
    [
        "link.hreflang",
        "10:2015"
    ],
    [
        "link.imagesizes",
        "5:2023"
    ],
    [
        "link.imagesrcset",
        "5:2023"
    ],
    [
        "link.integrity",
        "10:2018"
    ],
    [
        "link.media",
        "10:2015"
    ],
    [
        "link.referrerpolicy",
        "10:2020"
    ],
    [
        "link.referrerpolicy.no-referrer-when-downgrade",
        "0:"
    ],
    [
        "link.referrerpolicy.origin-when-cross-origin",
        "0:"
    ],
    [
        "link.referrerpolicy.unsafe-url",
        "0:"
    ],
    [
        "link.rel",
        "10:2015"
    ],
    [
        "link.rel.alternate_stylesheet",
        "0:"
    ],
    [
        "link.rel.compression-dictionary",
        "0:"
    ],
    [
        "link.rel.dns-prefetch",
        "5:2025"
    ],
    [
        "link.rel.expect",
        "0:"
    ],
    [
        "link.rel.manifest",
        "0:"
    ],
    [
        "link.rel.modulepreload",
        "10:2023"
    ],
    [
        "link.rel.preconnect",
        "10:2020"
    ],
    [
        "link.rel.prefetch",
        "0:"
    ],
    [
        "link.rel.preload",
        "10:2021"
    ],
    [
        "link.rel.preload.as-fetch",
        "10:2021"
    ],
    [
        "link.rel.preload.as-font",
        "10:2021"
    ],
    [
        "link.rel.preload.as-image",
        "10:2021"
    ],
    [
        "link.rel.preload.as-script",
        "10:2021"
    ],
    [
        "link.rel.preload.as-style",
        "10:2021"
    ],
    [
        "link.rel.preload.as-track",
        "0:"
    ],
    [
        "link.sizes",
        "10:2020"
    ],
    [
        "link.type",
        "10:2015"
    ],
    [
        "main",
        "10:2015"
    ],
    [
        "map",
        "10:2015"
    ],
    [
        "map.name",
        "10:2015"
    ],
    [
        "mark",
        "10:2015"
    ],
    [
        "menu",
        "10:2015"
    ],
    [
        "meta",
        "10:2015"
    ],
    [
        "meta.charset",
        "10:2015"
    ],
    [
        "meta.content",
        "10:2015"
    ],
    [
        "meta.http-equiv",
        "10:2015"
    ],
    [
        "meta.http-equiv.content-security-policy",
        "10:2017"
    ],
    [
        "meta.http-equiv.content-type",
        "10:2017"
    ],
    [
        "meta.http-equiv.refresh",
        "10:2015"
    ],
    [
        "meta.name",
        "10:2015"
    ],
    [
        "meta.name.application-title",
        "0:"
    ],
    [
        "meta.name.color-scheme",
        "10:2022"
    ],
    [
        "meta.name.referrer",
        "10:2020"
    ],
    [
        "meta.name.text-scale",
        "0:"
    ],
    [
        "meta.name.theme-color",
        "0:"
    ],
    [
        "meter",
        "10:2017"
    ],
    [
        "meter.high",
        "10:2017"
    ],
    [
        "meter.low",
        "10:2017"
    ],
    [
        "meter.max",
        "10:2017"
    ],
    [
        "meter.min",
        "10:2017"
    ],
    [
        "meter.optimum",
        "10:2017"
    ],
    [
        "meter.value",
        "10:2017"
    ],
    [
        "nav",
        "10:2015"
    ],
    [
        "noscript",
        "10:2015"
    ],
    [
        "object",
        "10:2015"
    ],
    [
        "object.data",
        "10:2015"
    ],
    [
        "object.form",
        "10:2015"
    ],
    [
        "object.height",
        "10:2015"
    ],
    [
        "object.name",
        "10:2015"
    ],
    [
        "object.type",
        "10:2015"
    ],
    [
        "object.width",
        "10:2015"
    ],
    [
        "ol",
        "10:2015"
    ],
    [
        "ol.reversed",
        "10:2020"
    ],
    [
        "ol.start",
        "10:2015"
    ],
    [
        "ol.type",
        "10:2015"
    ],
    [
        "optgroup",
        "10:2015"
    ],
    [
        "optgroup.disabled",
        "0:"
    ],
    [
        "optgroup.label",
        "10:2015"
    ],
    [
        "option",
        "10:2015"
    ],
    [
        "option.disabled",
        "10:2015"
    ],
    [
        "option.label",
        "10:2015"
    ],
    [
        "option.selected",
        "10:2015"
    ],
    [
        "option.value",
        "10:2015"
    ],
    [
        "output",
        "10:2018"
    ],
    [
        "output.for",
        "10:2018"
    ],
    [
        "output.form",
        "10:2018"
    ],
    [
        "output.name",
        "10:2018"
    ],
    [
        "p",
        "10:2015"
    ],
    [
        "picture",
        "10:2016"
    ],
    [
        "pre",
        "10:2015"
    ],
    [
        "progress",
        "10:2015"
    ],
    [
        "progress.max",
        "10:2015"
    ],
    [
        "progress.value",
        "10:2015"
    ],
    [
        "q",
        "10:2015"
    ],
    [
        "q.cite",
        "10:2015"
    ],
    [
        "rp",
        "10:2015"
    ],
    [
        "rt",
        "10:2015"
    ],
    [
        "ruby",
        "10:2015"
    ],
    [
        "s",
        "10:2015"
    ],
    [
        "samp",
        "10:2015"
    ],
    [
        "script",
        "10:2015"
    ],
    [
        "script.async",
        "10:2015"
    ],
    [
        "script.attributionsrc",
        "0:"
    ],
    [
        "script.blocking",
        "0:"
    ],
    [
        "script.crossorigin",
        "10:2016"
    ],
    [
        "script.defer",
        "10:2015"
    ],
    [
        "script.fetchpriority",
        "5:2024"
    ],
    [
        "script.integrity",
        "10:2018"
    ],
    [
        "script.integrity.ed25519_public_key",
        "0:"
    ],
    [
        "script.nomodule",
        "10:2018"
    ],
    [
        "script.referrerpolicy",
        "10:2020"
    ],
    [
        "script.referrerpolicy.no-referrer-when-downgrade",
        "0:"
    ],
    [
        "script.referrerpolicy.origin-when-cross-origin",
        "0:"
    ],
    [
        "script.referrerpolicy.unsafe-url",
        "0:"
    ],
    [
        "script.src",
        "10:2015"
    ],
    [
        "script.type",
        "10:2015"
    ],
    [
        "script.type.importmap",
        "10:2023"
    ],
    [
        "script.type.module",
        "10:2018"
    ],
    [
        "script.type.speculationrules",
        "0:"
    ],
    [
        "script.type.speculationrules.eagerness",
        "0:"
    ],
    [
        "script.type.speculationrules.expects_no_vary_search",
        "0:"
    ],
    [
        "script.type.speculationrules.prefetch",
        "0:"
    ],
    [
        "script.type.speculationrules.prerender",
        "0:"
    ],
    [
        "script.type.speculationrules.referrer_policy",
        "0:"
    ],
    [
        "script.type.speculationrules.relative_to",
        "0:"
    ],
    [
        "script.type.speculationrules.requires",
        "0:"
    ],
    [
        "script.type.speculationrules.requires.anonymous-client-ip-when-cross-origin",
        "0:"
    ],
    [
        "script.type.speculationrules.source_optional",
        "0:"
    ],
    [
        "script.type.speculationrules.tag",
        "0:"
    ],
    [
        "script.type.speculationrules.target_hint",
        "0:"
    ],
    [
        "script.type.speculationrules.urls",
        "0:"
    ],
    [
        "script.type.speculationrules.where",
        "0:"
    ],
    [
        "search",
        "10:2023"
    ],
    [
        "section",
        "10:2015"
    ],
    [
        "select",
        "10:2015"
    ],
    [
        "select.disabled",
        "10:2015"
    ],
    [
        "select.form",
        "10:2015"
    ],
    [
        "select.hr_in_select",
        "0:"
    ],
    [
        "select.multiple",
        "10:2015"
    ],
    [
        "select.name",
        "10:2015"
    ],
    [
        "select.required",
        "10:2015"
    ],
    [
        "select.size",
        "0:"
    ],
    [
        "selectedcontent",
        "0:"
    ],
    [
        "slot",
        "10:2020"
    ],
    [
        "slot.name",
        "10:2020"
    ],
    [
        "small",
        "10:2015"
    ],
    [
        "source",
        "10:2015"
    ],
    [
        "source.height",
        "10:2022"
    ],
    [
        "source.media",
        "10:2015"
    ],
    [
        "source.sizes",
        "10:2016"
    ],
    [
        "source.src",
        "10:2015"
    ],
    [
        "source.srcset",
        "10:2016"
    ],
    [
        "source.type",
        "10:2015"
    ],
    [
        "source.width",
        "10:2022"
    ],
    [
        "span",
        "10:2015"
    ],
    [
        "strong",
        "10:2015"
    ],
    [
        "style",
        "10:2015"
    ],
    [
        "style.blocking",
        "0:"
    ],
    [
        "style.media",
        "10:2015"
    ],
    [
        "sub",
        "10:2015"
    ],
    [
        "summary",
        "10:2020"
    ],
    [
        "summary.display_list_item",
        "0:"
    ],
    [
        "sup",
        "10:2015"
    ],
    [
        "table",
        "10:2015"
    ],
    [
        "table.align",
        "0:"
    ],
    [
        "table.bgcolor",
        "0:"
    ],
    [
        "table.border",
        "0:"
    ],
    [
        "table.cellpadding",
        "0:"
    ],
    [
        "table.cellspacing",
        "0:"
    ],
    [
        "table.frame",
        "0:"
    ],
    [
        "table.rules",
        "0:"
    ],
    [
        "table.summary",
        "0:"
    ],
    [
        "table.width",
        "0:"
    ],
    [
        "tbody",
        "10:2015"
    ],
    [
        "tbody.align",
        "0:"
    ],
    [
        "tbody.bgcolor",
        "0:"
    ],
    [
        "tbody.char",
        "0:"
    ],
    [
        "tbody.charoff",
        "0:"
    ],
    [
        "tbody.valign",
        "0:"
    ],
    [
        "td",
        "10:2015"
    ],
    [
        "td.abbr",
        "0:"
    ],
    [
        "td.align",
        "0:"
    ],
    [
        "td.axis",
        "0:"
    ],
    [
        "td.bgcolor",
        "0:"
    ],
    [
        "td.char",
        "0:"
    ],
    [
        "td.charoff",
        "0:"
    ],
    [
        "td.colspan",
        "10:2015"
    ],
    [
        "td.headers",
        "10:2015"
    ],
    [
        "td.rowspan",
        "10:2015"
    ],
    [
        "td.rowspan.rowspan_zero",
        "0:"
    ],
    [
        "td.scope",
        "0:"
    ],
    [
        "td.valign",
        "0:"
    ],
    [
        "td.width",
        "0:"
    ],
    [
        "template",
        "10:2015"
    ],
    [
        "template.shadowrootclonable",
        "5:2024"
    ],
    [
        "template.shadowrootcustomelementregistry",
        "0:"
    ],
    [
        "template.shadowrootdelegatesfocus",
        "5:2024"
    ],
    [
        "template.shadowrootmode",
        "5:2024"
    ],
    [
        "template.shadowrootreferencetarget",
        "0:"
    ],
    [
        "template.shadowrootserializable",
        "0:"
    ],
    [
        "template.shadowrootslotassignment",
        "0:"
    ],
    [
        "textarea",
        "10:2015"
    ],
    [
        "textarea.autocomplete",
        "10:2020"
    ],
    [
        "textarea.cols",
        "10:2015"
    ],
    [
        "textarea.dirname",
        "10:2023"
    ],
    [
        "textarea.disabled",
        "10:2015"
    ],
    [
        "textarea.form",
        "10:2015"
    ],
    [
        "textarea.maxlength",
        "10:2015"
    ],
    [
        "textarea.minlength",
        "10:2018"
    ],
    [
        "textarea.name",
        "10:2015"
    ],
    [
        "textarea.placeholder",
        "10:2015"
    ],
    [
        "textarea.placeholder.line_breaks",
        "10:2022"
    ],
    [
        "textarea.readonly",
        "10:2015"
    ],
    [
        "textarea.required",
        "10:2015"
    ],
    [
        "textarea.rows",
        "10:2015"
    ],
    [
        "textarea.wrap",
        "10:2015"
    ],
    [
        "textarea.wrap.hard",
        "0:"
    ],
    [
        "tfoot",
        "10:2015"
    ],
    [
        "tfoot.align",
        "0:"
    ],
    [
        "tfoot.bgcolor",
        "0:"
    ],
    [
        "tfoot.char",
        "0:"
    ],
    [
        "tfoot.charoff",
        "0:"
    ],
    [
        "tfoot.valign",
        "0:"
    ],
    [
        "th",
        "10:2015"
    ],
    [
        "th.abbr",
        "10:2015"
    ],
    [
        "th.align",
        "0:"
    ],
    [
        "th.axis",
        "0:"
    ],
    [
        "th.bgcolor",
        "0:"
    ],
    [
        "th.char",
        "0:"
    ],
    [
        "th.charoff",
        "0:"
    ],
    [
        "th.colspan",
        "10:2015"
    ],
    [
        "th.headers",
        "10:2015"
    ],
    [
        "th.rowspan",
        "10:2015"
    ],
    [
        "th.rowspan.rowspan_zero",
        "0:"
    ],
    [
        "th.scope",
        "10:2015"
    ],
    [
        "th.valign",
        "0:"
    ],
    [
        "th.width",
        "0:"
    ],
    [
        "thead",
        "10:2015"
    ],
    [
        "thead.align",
        "0:"
    ],
    [
        "thead.bgcolor",
        "0:"
    ],
    [
        "thead.char",
        "0:"
    ],
    [
        "thead.charoff",
        "0:"
    ],
    [
        "thead.valign",
        "0:"
    ],
    [
        "time",
        "10:2017"
    ],
    [
        "time.datetime",
        "10:2017"
    ],
    [
        "title",
        "10:2015"
    ],
    [
        "tr",
        "10:2015"
    ],
    [
        "tr.align",
        "0:"
    ],
    [
        "tr.bgcolor",
        "0:"
    ],
    [
        "tr.char",
        "0:"
    ],
    [
        "tr.charoff",
        "0:"
    ],
    [
        "tr.valign",
        "0:"
    ],
    [
        "track",
        "10:2015"
    ],
    [
        "track.default",
        "10:2015"
    ],
    [
        "track.kind",
        "10:2015"
    ],
    [
        "track.label",
        "10:2015"
    ],
    [
        "track.src",
        "10:2016"
    ],
    [
        "track.srclang",
        "10:2015"
    ],
    [
        "u",
        "10:2015"
    ],
    [
        "ul",
        "10:2015"
    ],
    [
        "var",
        "10:2015"
    ],
    [
        "video",
        "10:2015"
    ],
    [
        "video.aspect_ratio_computed_from_attributes",
        "10:2020"
    ],
    [
        "video.autoplay",
        "10:2016"
    ],
    [
        "video.controls",
        "10:2015"
    ],
    [
        "video.controlslist",
        "0:"
    ],
    [
        "video.crossorigin",
        "10:2020"
    ],
    [
        "video.disablepictureinpicture",
        "0:"
    ],
    [
        "video.disableremoteplayback",
        "0:"
    ],
    [
        "video.height",
        "10:2015"
    ],
    [
        "video.loading",
        "0:"
    ],
    [
        "video.loop",
        "10:2015"
    ],
    [
        "video.muted",
        "10:2015"
    ],
    [
        "video.playsinline",
        "0:"
    ],
    [
        "video.poster",
        "10:2015"
    ],
    [
        "video.preload",
        "10:2015"
    ],
    [
        "video.src",
        "10:2015"
    ],
    [
        "video.width",
        "10:2015"
    ],
    [
        "wbr",
        "10:2015"
    ]
]);
var $404c96e82c1b1d4e$var$globalAttributes = /* @__PURE__ */ new Map([
    [
        "accesskey",
        "10:2015"
    ],
    [
        "autocapitalize",
        "0:"
    ],
    [
        "autocorrect",
        "0:"
    ],
    [
        "autofocus",
        "10:2023"
    ],
    [
        "contenteditable",
        "10:2015"
    ],
    [
        "contenteditable.plaintext-only",
        "5:2025"
    ],
    [
        "enterkeyhint",
        "10:2021"
    ],
    [
        "exportparts",
        "10:2020"
    ],
    [
        "inert",
        "10:2023"
    ],
    [
        "inert.ignores_find_in_page",
        "0:"
    ],
    [
        "inputmode",
        "10:2021"
    ],
    [
        "is",
        "0:"
    ],
    [
        "lang",
        "10:2015"
    ],
    [
        "nonce",
        "10:2022"
    ],
    [
        "part",
        "10:2020"
    ],
    [
        "popover",
        "5:2024"
    ],
    [
        "popover.hint",
        "0:"
    ],
    [
        "slot",
        "10:2020"
    ],
    [
        "spellcheck",
        "10:2017"
    ],
    [
        "style",
        "10:2015"
    ],
    [
        "tabindex",
        "10:2015"
    ],
    [
        "title",
        "10:2015"
    ],
    [
        "title.multi-line_titles",
        "10:2018"
    ],
    [
        "translate",
        "10:2023"
    ],
    [
        "virtualkeyboardpolicy",
        "0:"
    ],
    [
        "writingsuggestions",
        "0:"
    ]
]);
// lib/utils/node.js
function $404c96e82c1b1d4e$var$isCustomElement(name) {
    return name.includes("-");
}
// lib/rules/use-baseline.js
var $404c96e82c1b1d4e$export$7ac25aba97301625 = {
    noBaselineElement: "noBaselineElement",
    notBaselineElementAttribute: "notBaselineElementAttribute",
    notBaselineGlobalAttribute: "notBaselineGlobalAttribute"
};
function $404c96e82c1b1d4e$var$toStatusKey(...parts) {
    return parts.map((part)=>part.toLowerCase().trim()).join(".");
}
function $404c96e82c1b1d4e$var$decodeStatus(encoded) {
    const [status, year = NaN] = encoded.split(":").map((part)=>Number(part));
    return [
        status,
        year
    ];
}
function $404c96e82c1b1d4e$var$getElementAttributeSpecificStatusKey(element2, key, value) {
    const elementName = element2.toLowerCase();
    const attributeKey = key.toLowerCase();
    const attributeValue = value.toLowerCase();
    if (elementName === "input" && attributeKey === "type") return `input.type_${attributeValue}`;
    if (elementName === "a" && attributeKey === "href" && attributeValue.trim().startsWith("sms:")) return "a.href.href_sms";
    if ((elementName === "td" || elementName === "th") && attributeKey === "rowspan" && attributeValue === "0") return `${elementName}.rowspan.rowspan_zero`;
    return null;
}
function $404c96e82c1b1d4e$export$af5ef811749334ac({ available: available }) {
    const baseYear = typeof available === "number" ? available : null;
    const baseStatus = available === "widely" ? $404c96e82c1b1d4e$var$BASELINE_HIGH : $404c96e82c1b1d4e$var$BASELINE_LOW;
    const availability = String(available);
    function isSupported(encoded) {
        const [status, year = NaN] = $404c96e82c1b1d4e$var$decodeStatus(encoded);
        if (baseYear) return year <= baseYear;
        return status >= baseStatus;
    }
    function isSupportedElementAttributeKey(element2, key) {
        const elementStatus = $404c96e82c1b1d4e$var$elements.get($404c96e82c1b1d4e$var$toStatusKey(element2, key));
        if (!elementStatus) return true;
        return isSupported(elementStatus);
    }
    function isSupportedGlobalAttributeKey(key) {
        const globalAttrStatus = $404c96e82c1b1d4e$var$globalAttributes.get($404c96e82c1b1d4e$var$toStatusKey(key));
        if (!globalAttrStatus) return true;
        return isSupported(globalAttrStatus);
    }
    function isSupportedElementAttributeKeyValue(element2, key, value) {
        const elementStatus = $404c96e82c1b1d4e$var$elements.get($404c96e82c1b1d4e$var$toStatusKey(element2, key, value));
        if (!elementStatus) return true;
        return isSupported(elementStatus);
    }
    function isSupportedGlobalAttributeKeyValue(key, value) {
        const globalAttrStatus = $404c96e82c1b1d4e$var$globalAttributes.get($404c96e82c1b1d4e$var$toStatusKey(key, value));
        if (!globalAttrStatus) return true;
        return isSupported(globalAttrStatus);
    }
    function isSupportedElementSpecificAttributeKeyValue(element2, key, value) {
        const statusKey = $404c96e82c1b1d4e$var$getElementAttributeSpecificStatusKey(element2, key, value);
        if (!statusKey) return true;
        const elementStatus = $404c96e82c1b1d4e$var$elements.get(statusKey);
        if (!elementStatus) return true;
        return isSupported(elementStatus);
    }
    function isSupportedElement(element2) {
        const elementEncoded = $404c96e82c1b1d4e$var$elements.get(element2);
        if (!elementEncoded) return true;
        return isSupported(elementEncoded);
    }
    return {
        /**
     * @param {ElementAdapter} adapter
     * @returns {UseBaselineResult}
     */ checkAttributes (adapter) {
            const elementName = adapter.getElementName();
            if ($404c96e82c1b1d4e$var$isCustomElement(elementName)) return [];
            if (!isSupportedElement(elementName)) return [
                {
                    messageId: $404c96e82c1b1d4e$export$7ac25aba97301625.noBaselineElement,
                    loc: adapter.getLocation(),
                    data: {
                        element: `<${elementName}>`,
                        availability: availability
                    }
                }
            ];
            const result = [];
            for (const attribute of adapter.getAttributes()){
                const attributeKey = attribute.getKey();
                if (!attributeKey) continue;
                const attributeKeyValue = attributeKey.getValue();
                const attributeKeyHasExpression = attributeKey.hasExpression();
                if (!attributeKeyValue || attributeKeyHasExpression) continue;
                const attributeValue = attribute.getValue();
                const attributeValueValue = attributeValue?.getValue();
                if (attributeValueValue === null) continue;
                if (!isSupportedElementAttributeKey(elementName, attributeKeyValue)) result.push({
                    messageId: $404c96e82c1b1d4e$export$7ac25aba97301625.notBaselineElementAttribute,
                    loc: attributeKey.getLocation(),
                    data: {
                        element: `<${elementName}>`,
                        attr: attributeKey.getValue(),
                        availability: availability
                    }
                });
                else if (!isSupportedGlobalAttributeKey(attributeKeyValue)) result.push({
                    messageId: $404c96e82c1b1d4e$export$7ac25aba97301625.notBaselineGlobalAttribute,
                    loc: attributeKey.getLocation(),
                    data: {
                        attr: attributeKey.getValue(),
                        availability: availability
                    }
                });
                else if (attributeValue !== null) {
                    if (!isSupportedElementAttributeKeyValue(elementName, attributeKeyValue, attributeValueValue || "") || !isSupportedElementSpecificAttributeKeyValue(elementName, attributeKeyValue, attributeValueValue || "")) result.push({
                        messageId: $404c96e82c1b1d4e$export$7ac25aba97301625.notBaselineElementAttribute,
                        loc: attributeValue.getLocation(),
                        data: {
                            element: `<${elementName}>`,
                            attr: `${attributeKeyValue}="${attributeValueValue}"`,
                            availability: availability
                        }
                    });
                    else if (!isSupportedGlobalAttributeKeyValue(attributeKeyValue, attributeValueValue || "")) result.push({
                        messageId: $404c96e82c1b1d4e$export$7ac25aba97301625.notBaselineGlobalAttribute,
                        loc: attributeValue.getLocation(),
                        data: {
                            attr: `${attributeKeyValue}="${attributeValueValue}"`,
                            availability: availability
                        }
                    });
                }
            }
            return result;
        }
    };
}
// lib/rules/no-ineffective-attrs.js
var $404c96e82c1b1d4e$export$9b2977d355552fdc = {
    ineffective: "ineffective"
};
function $404c96e82c1b1d4e$export$1669b57000ee831b() {
    function getAttrValue(adapter, attrName) {
        for (const attribute of adapter.getAttributes()){
            const attrKeyValue = attribute.getKey()?.getValue();
            if (attrKeyValue && attrKeyValue === attrName) {
                const value = attribute.getValue()?.getValue();
                return value || null;
            }
        }
        return null;
    }
    function hasAttr(adapter, attrName) {
        for (const attribute of adapter.getAttributes()){
            const keyValue = attribute.getKey()?.getValue();
            if (keyValue && keyValue.toLocaleLowerCase() === attrName.toLocaleLowerCase()) return true;
        }
        return false;
    }
    function isAttrValueExpression(adapter, attrName) {
        return adapter.getAttributes().some((attr)=>{
            const key = attr.getKey();
            return key?.getValue() === attrName && !!attr?.getValue()?.hasExpression();
        });
    }
    const checkersByTag = {
        input: [
            {
                attr: "multiple",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "text";
                    return [
                        "text",
                        "password",
                        "radio",
                        "checkbox",
                        "image",
                        "hidden",
                        "reset",
                        "button"
                    ].includes(type);
                },
                message: 'The "multiple" attribute has no effect on this input type.'
            },
            {
                attr: "accept",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "text";
                    return type !== "file";
                },
                message: 'The "accept" attribute has no effect unless input type is "file".'
            },
            {
                attr: "readonly",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "text";
                    return [
                        "checkbox",
                        "radio",
                        "file",
                        "range",
                        "color"
                    ].includes(type);
                },
                message: 'The "readonly" attribute has no effect on this input type.'
            },
            {
                attr: "min",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "text";
                    return ![
                        "number",
                        "range",
                        "date",
                        "datetime-local",
                        "month",
                        "time",
                        "week"
                    ].includes(type);
                },
                message: 'The "min" attribute only works with numeric, date, and time input types.'
            },
            {
                attr: "max",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "text";
                    return ![
                        "number",
                        "range",
                        "date",
                        "datetime-local",
                        "month",
                        "time",
                        "week"
                    ].includes(type);
                },
                message: 'The "max" attribute only works with numeric, date, and time input types.'
            },
            {
                attr: "step",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "text";
                    return ![
                        "number",
                        "range",
                        "date",
                        "datetime-local",
                        "month",
                        "time",
                        "week"
                    ].includes(type);
                },
                message: 'The "step" attribute only works with numeric, date, and time input types.'
            },
            {
                attr: "pattern",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "text";
                    return ![
                        "text",
                        "search",
                        "url",
                        "tel",
                        "email",
                        "password"
                    ].includes(type);
                },
                message: 'The "pattern" attribute only works with text-based input types.'
            },
            {
                attr: "maxlength",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "text";
                    return ![
                        "text",
                        "search",
                        "url",
                        "tel",
                        "email",
                        "password"
                    ].includes(type);
                },
                message: 'The "maxlength" attribute only works with text-based input types.'
            },
            {
                attr: "minlength",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "text";
                    return ![
                        "text",
                        "search",
                        "url",
                        "tel",
                        "email",
                        "password"
                    ].includes(type);
                },
                message: 'The "minlength" attribute only works with text-based input types.'
            },
            {
                attr: "placeholder",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "text";
                    return ![
                        "text",
                        "search",
                        "url",
                        "tel",
                        "email",
                        "password",
                        "number"
                    ].includes(type);
                },
                message: 'The "placeholder" attribute has no effect on this input type.'
            },
            {
                attr: "size",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "text";
                    return ![
                        "text",
                        "search",
                        "url",
                        "tel",
                        "email",
                        "password"
                    ].includes(type);
                },
                message: 'The "size" attribute only works with text-based input types.'
            },
            {
                attr: "list",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "text";
                    return [
                        "checkbox",
                        "radio",
                        "file",
                        "submit",
                        "image",
                        "reset",
                        "button",
                        "hidden"
                    ].includes(type);
                },
                message: 'The "list" attribute has no effect on this input type.'
            }
        ],
        script: [
            {
                attr: "defer",
                when: (adapter)=>!hasAttr(adapter, "src"),
                message: 'The "defer" attribute has no effect on inline scripts.'
            },
            {
                attr: "async",
                when: (adapter)=>!hasAttr(adapter, "src"),
                message: 'The "async" attribute has no effect on inline scripts.'
            }
        ],
        a: [
            {
                attr: "download",
                when: (adapter)=>!hasAttr(adapter, "href"),
                message: 'The "download" attribute has no effect without an "href".'
            },
            {
                attr: "ping",
                when: (adapter)=>!hasAttr(adapter, "href"),
                message: 'The "ping" attribute has no effect without an "href".'
            },
            {
                attr: "target",
                when: (adapter)=>!hasAttr(adapter, "href"),
                message: 'The "target" attribute has no effect without an "href".'
            }
        ],
        audio: [
            {
                attr: "controlslist",
                when: (adapter)=>!hasAttr(adapter, "controls"),
                message: 'The "controlslist" attribute has no effect without "controls".'
            }
        ],
        video: [
            {
                attr: "controlslist",
                when: (adapter)=>!hasAttr(adapter, "controls"),
                message: 'The "controlslist" attribute has no effect without "controls".'
            }
        ],
        form: [
            {
                attr: "enctype",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "method")) return false;
                    const method = getAttrValue(adapter, "method") || "get";
                    return method ? method.toLowerCase() !== "post" : false;
                },
                message: 'The "enctype" attribute only has effect when method is "post".'
            }
        ],
        button: [
            {
                attr: "formaction",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "submit";
                    return type !== "submit";
                },
                message: 'The "formaction" attribute only works with type="submit".'
            },
            {
                attr: "formmethod",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "submit";
                    return type !== "submit";
                },
                message: 'The "formmethod" attribute only works with type="submit".'
            },
            {
                attr: "formenctype",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "submit";
                    return type !== "submit";
                },
                message: 'The "formenctype" attribute only works with type="submit".'
            },
            {
                attr: "formnovalidate",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "submit";
                    return type !== "submit";
                },
                message: 'The "formnovalidate" attribute only works with type="submit".'
            },
            {
                attr: "formtarget",
                when: (adapter)=>{
                    if (isAttrValueExpression(adapter, "type")) return false;
                    const type = getAttrValue(adapter, "type") || "submit";
                    return type !== "submit";
                },
                message: 'The "formtarget" attribute only works with type="submit".'
            }
        ],
        area: [
            {
                attr: "download",
                when: (adapter)=>!hasAttr(adapter, "href"),
                message: 'The "download" attribute has no effect without an "href".'
            },
            {
                attr: "ping",
                when: (adapter)=>!hasAttr(adapter, "href"),
                message: 'The "ping" attribute has no effect without an "href".'
            },
            {
                attr: "target",
                when: (adapter)=>!hasAttr(adapter, "href"),
                message: 'The "target" attribute has no effect without an "href".'
            }
        ],
        img: [
            {
                attr: "usemap",
                when: (adapter)=>hasAttr(adapter, "ismap"),
                message: 'The "usemap" and "ismap" attributes cannot be used together.'
            }
        ]
    };
    return {
        /**
     * @param {ElementAdapter} adapter
     * @returns {NoIneffectiveAttrsResult}
     */ checkAttributes (adapter) {
            const elementName = adapter.getElementName();
            const tagCheckers = checkersByTag[elementName];
            if (!tagCheckers) return [];
            const result = [];
            for (const check of tagCheckers)for (const attribute of adapter.getAttributes()){
                const attributeKey = attribute.getKey();
                if (!attributeKey) continue;
                if (attributeKey.hasExpression()) continue;
                const attributeValue = attribute.getValue();
                if (attributeValue?.hasExpression()) continue;
                const attributeKeyValue = attributeKey.getValue();
                const attributeValueValue = attributeValue?.getValue();
                if (attributeValueValue === null || attributeKeyValue?.toLowerCase() !== check.attr) continue;
                if (check.when(adapter)) result.push({
                    loc: attributeKey.getLocation(),
                    messageId: $404c96e82c1b1d4e$export$9b2977d355552fdc.ineffective,
                    data: {
                        message: check.message
                    }
                });
            }
            return result;
        }
    };
}
// lib/rules/no-obsolete-tags.js
var $404c96e82c1b1d4e$var$OBSOLETE_TAGS = [
    "applet",
    "acronym",
    "bgsound",
    "dir",
    "frame",
    "frameset",
    "noframes",
    "isindex",
    "keygen",
    "listing",
    "menuitem",
    "nextid",
    "noembed",
    "plaintext",
    "rb",
    "rtc",
    "strike",
    "xmp",
    "basefont",
    "big",
    "blink",
    "center",
    "font",
    "marquee",
    "multicol",
    "nobr",
    "spacer",
    "tt"
];
var $404c96e82c1b1d4e$var$OBSOLETE_TAGS_SET = new Set($404c96e82c1b1d4e$var$OBSOLETE_TAGS);
var $404c96e82c1b1d4e$export$4b0242017845dbc3 = {
    unexpected: "unexpected"
};
function $404c96e82c1b1d4e$export$c0e82f9203f788d4() {
    return {
        /**
     * @param {ElementAdapter} adapter
     * @returns {NoObsoleteTagsResult}
     */ checkElement (adapter) {
            const tagName = adapter.getElementName();
            if ($404c96e82c1b1d4e$var$OBSOLETE_TAGS_SET.has(tagName)) return [
                {
                    messageId: $404c96e82c1b1d4e$export$4b0242017845dbc3.unexpected,
                    loc: adapter.getOpenStartLocation(),
                    data: {
                        tag: tagName
                    }
                }
            ];
            return [];
        }
    };
}
// lib/utils/obsolete-attrs.js
var $404c96e82c1b1d4e$var$OBSOLETE_ATTRS = {
    charset: [
        {
            elements: [
                "a",
                "link"
            ],
            suggestion: "Use an HTTP `Content-Type` header on the linked resource instead."
        },
        {
            elements: [
                "script"
            ],
            suggestion: "It is redundant to specify it on the script element since it inherits from the document."
        }
    ],
    coords: [
        {
            elements: [
                "a"
            ],
            suggestion: "Use area instead of a for image maps."
        }
    ],
    shape: [
        {
            elements: [
                "a"
            ],
            suggestion: "Use area instead of a for image maps."
        }
    ],
    methods: [
        {
            elements: [
                "a",
                "link"
            ],
            suggestion: "Use the HTTP OPTIONS feature instead."
        }
    ],
    name: [
        {
            elements: [
                "a",
                "embed",
                "img",
                "option"
            ],
            suggestion: "Use the id attribute instead."
        }
    ],
    rev: [
        {
            elements: [
                "a",
                "link"
            ],
            suggestion: 'Use the rel attribute instead, with an opposite term. (For example, instead of rev="made", use rel="author".)'
        }
    ],
    urn: [
        {
            elements: [
                "a",
                "link"
            ],
            suggestion: "Specify the preferred persistent identifier using the href attribute instead."
        }
    ],
    accept: [
        {
            elements: [
                "form"
            ],
            suggestion: "Use the accept attribute directly on the input elements instead."
        }
    ],
    hreflang: [
        {
            elements: [
                "area"
            ],
            suggestion: "These attributes do not do anything useful, and for historical reasons there are no corresponding IDL attributes on area elements. Omit them altogether."
        }
    ],
    type: [
        {
            elements: [
                "area"
            ],
            suggestion: "These attributes do not do anything useful, and for historical reasons there are no corresponding IDL attributes on area elements. Omit them altogether."
        },
        {
            elements: [
                "li"
            ],
            suggestion: "Use CSS instead."
        },
        {
            elements: [
                "menu"
            ],
            suggestion: "To implement a custom context menu, use script to handle the contextmenu event. For toolbar menus, omit the attribute."
        },
        {
            elements: [
                "style"
            ],
            suggestion: "Omit the attribute for CSS; for data blocks, use script as the container instead of style."
        },
        {
            elements: [
                "ul"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    nohref: [
        {
            elements: [
                "area"
            ],
            suggestion: "Omitting the href attribute is sufficient; the nohref attribute is unnecessary. Omit it altogether."
        }
    ],
    profile: [
        {
            elements: [
                "head"
            ],
            suggestion: "Unnecessary. Omit it altogether."
        }
    ],
    manifest: [
        {
            elements: [
                "html"
            ],
            suggestion: "Use service workers instead."
        }
    ],
    version: [
        {
            elements: [
                "html"
            ],
            suggestion: "Unnecessary. Omit it altogether."
        }
    ],
    ismap: [
        {
            elements: [
                "input"
            ],
            suggestion: "Unnecessary. Omit it altogether. All input elements with a type attribute in the Image Button state are processed as server-side image maps."
        }
    ],
    usemap: [
        {
            elements: [
                "input",
                "object"
            ],
            suggestion: "Use the img element for image maps."
        }
    ],
    longdesc: [
        {
            elements: [
                "iframe",
                "img"
            ],
            suggestion: "Use a regular a element to link to the description, or (in the case of images) use an image map to provide a link from the image to the image's description."
        }
    ],
    lowsrc: [
        {
            elements: [
                "img"
            ],
            suggestion: "Use a progressive JPEG image (given in the src attribute), instead of using two separate images."
        }
    ],
    target: [
        {
            elements: [
                "link"
            ],
            suggestion: "Unnecessary. Omit it altogether."
        }
    ],
    label: [
        {
            elements: [
                "menu"
            ],
            suggestion: "To implement a custom context menu, use script to handle the contextmenu event."
        }
    ],
    contextmenu: [
        {
            elements: [
                "*"
            ],
            suggestion: "To implement a custom context menu, use script to handle the contextmenu event."
        }
    ],
    onshow: [
        {
            elements: [
                "*"
            ],
            suggestion: "To implement a custom context menu, use script to handle the contextmenu event."
        }
    ],
    scheme: [
        {
            elements: [
                "meta"
            ],
            suggestion: "Use only one scheme per field, or make the scheme declaration part of the value."
        }
    ],
    archive: [
        {
            elements: [
                "object"
            ],
            suggestion: "Use the data and type attributes to invoke plugins."
        }
    ],
    classid: [
        {
            elements: [
                "object"
            ],
            suggestion: "Use the data and type attributes to invoke plugins."
        }
    ],
    code: [
        {
            elements: [
                "object"
            ],
            suggestion: "Use the data and type attributes to invoke plugins."
        }
    ],
    codebase: [
        {
            elements: [
                "object"
            ],
            suggestion: "Use the data and type attributes to invoke plugins."
        }
    ],
    codetype: [
        {
            elements: [
                "object"
            ],
            suggestion: "Use the data and type attributes to invoke plugins."
        }
    ],
    declare: [
        {
            elements: [
                "object"
            ],
            suggestion: "Repeat the object element completely each time the resource is to be reused."
        }
    ],
    standby: [
        {
            elements: [
                "object"
            ],
            suggestion: "Optimize the linked resource so that it loads quickly or, at least, incrementally."
        }
    ],
    typemustmatch: [
        {
            elements: [
                "object"
            ],
            suggestion: "Avoid using object elements with untrusted resources."
        }
    ],
    language: [
        {
            elements: [
                "script"
            ],
            suggestion: "Omit the attribute for JavaScript; for data blocks, use the type attribute instead."
        }
    ],
    event: [
        {
            elements: [
                "script"
            ],
            suggestion: "Use DOM events mechanisms to register event listeners."
        }
    ],
    for: [
        {
            elements: [
                "script"
            ],
            suggestion: "Use DOM events mechanisms to register event listeners."
        }
    ],
    datapagesize: [
        {
            elements: [
                "table"
            ],
            suggestion: "Unnecessary. Omit it altogether."
        }
    ],
    summary: [
        {
            elements: [
                "table"
            ],
            suggestion: "Use one of the techniques for describing tables given in the table section instead."
        }
    ],
    abbr: [
        {
            elements: [
                "td"
            ],
            suggestion: "Use text that begins in an unambiguous and terse manner, and include any more elaborate text after that. The title attribute can also be useful in including more detailed text, so that the cell's contents can be made terse. If it's a heading, use th (which has an abbr attribute)."
        }
    ],
    axis: [
        {
            elements: [
                "td",
                "th"
            ],
            suggestion: "Use the scope attribute on the relevant th."
        }
    ],
    scope: [
        {
            elements: [
                "td"
            ],
            suggestion: "Use th elements for heading cells."
        }
    ],
    datasrc: [
        {
            elements: [
                "a",
                "button",
                "div",
                "frame",
                "iframe",
                "img",
                "input",
                "label",
                "legend",
                "marquee",
                "object",
                "option",
                "select",
                "span",
                "table",
                "textarea"
            ],
            suggestion: "Use script and a mechanism such as XMLHttpRequest to populate the page dynamically."
        }
    ],
    datafld: [
        {
            elements: [
                "a",
                "button",
                "div",
                "fieldset",
                "frame",
                "iframe",
                "img",
                "input",
                "label",
                "legend",
                "marquee",
                "object",
                "select",
                "span",
                "textarea"
            ],
            suggestion: "Use script and a mechanism such as XMLHttpRequest to populate the page dynamically."
        }
    ],
    dataformatas: [
        {
            elements: [
                "button",
                "div",
                "input",
                "label",
                "legend",
                "marquee",
                "object",
                "option",
                "select",
                "span",
                "table"
            ],
            suggestion: "Use script and a mechanism such as XMLHttpRequest to populate the page dynamically."
        }
    ],
    dropzone: [
        {
            elements: [
                "*"
            ],
            suggestion: "Use script to handle the dragenter and dragover events instead."
        }
    ],
    alink: [
        {
            elements: [
                "body"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    bgcolor: [
        {
            elements: [
                "body",
                "table",
                "td",
                "th",
                "tr"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    bottommargin: [
        {
            elements: [
                "body"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    leftmargin: [
        {
            elements: [
                "body"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    link: [
        {
            elements: [
                "body"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    marginheight: [
        {
            elements: [
                "body",
                "iframe"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    marginwidth: [
        {
            elements: [
                "body",
                "iframe"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    rightmargin: [
        {
            elements: [
                "body"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    text: [
        {
            elements: [
                "body"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    topmargin: [
        {
            elements: [
                "body"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    vlink: [
        {
            elements: [
                "body"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    clear: [
        {
            elements: [
                "br"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    align: [
        {
            elements: [
                "caption",
                "col",
                "div",
                "embed",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "hr",
                "iframe",
                "input",
                "img",
                "legend",
                "object",
                "p",
                "table",
                "tbody",
                "thead",
                "tfoot",
                "td",
                "th",
                "tr"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    char: [
        {
            elements: [
                "col",
                "tbody",
                "thead",
                "tfoot",
                "td",
                "th",
                "tr"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    charoff: [
        {
            elements: [
                "col",
                "tbody",
                "thead",
                "tfoot",
                "td",
                "th",
                "tr"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    valign: [
        {
            elements: [
                "col",
                "tbody",
                "thead",
                "tfoot",
                "td",
                "th",
                "tr"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    width: [
        {
            elements: [
                "col",
                "hr",
                "pre",
                "table",
                "td",
                "th"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    compact: [
        {
            elements: [
                "dl",
                "menu",
                "ol",
                "ul"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    hspace: [
        {
            elements: [
                "embed",
                "iframe",
                "input",
                "img",
                "object"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    vspace: [
        {
            elements: [
                "embed",
                "iframe",
                "input",
                "img",
                "object"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    color: [
        {
            elements: [
                "hr"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    noshade: [
        {
            elements: [
                "hr"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    size: [
        {
            elements: [
                "hr"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    allowtransparency: [
        {
            elements: [
                "iframe"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    frameborder: [
        {
            elements: [
                "iframe"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    framespacing: [
        {
            elements: [
                "iframe"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    scrolling: [
        {
            elements: [
                "iframe"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    border: [
        {
            elements: [
                "input",
                "img",
                "object",
                "table"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    frame: [
        {
            elements: [
                "table"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    bordercolor: [
        {
            elements: [
                "table"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    cellpadding: [
        {
            elements: [
                "table"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    cellspacing: [
        {
            elements: [
                "table"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    height: [
        {
            elements: [
                "table",
                "thead",
                "tbody",
                "tfoot",
                "td",
                "th",
                "tr"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    rules: [
        {
            elements: [
                "table"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    nowrap: [
        {
            elements: [
                "td",
                "th"
            ],
            suggestion: "Use CSS instead."
        }
    ],
    background: [
        {
            elements: [
                "body",
                "table",
                "thead",
                "tbody",
                "tfoot",
                "tr",
                "td",
                "th"
            ],
            suggestion: "Use CSS instead."
        }
    ]
};
// lib/rules/no-obsolete-attrs.js
var $404c96e82c1b1d4e$export$12a148edcce6f2e6 = {
    obsolete: "obsolete"
};
function $404c96e82c1b1d4e$export$d46aff0fc39f994d() {
    return {
        /**
     * @param {ElementAdapter} adapter
     * @returns {NoObsoleteAttrsResult}
     */ checkAttributes (adapter) {
            const elementName = adapter.getElementName();
            const result = [];
            for (const attribute of adapter.getAttributes()){
                const attributeKey = attribute.getKey();
                if (!attributeKey) continue;
                const attrKeyValue = attributeKey.getValue();
                const attributeValue = attribute.getValue();
                const attrValueValueValue = attributeValue?.getValue();
                if (attributeKey.hasExpression() || attrKeyValue === null || attrValueValueValue === null) continue;
                const attrName = attrKeyValue.toLowerCase();
                if ($404c96e82c1b1d4e$var$OBSOLETE_ATTRS[attrName]) {
                    const obsoleteConfigs = $404c96e82c1b1d4e$var$OBSOLETE_ATTRS[attrName];
                    for (const config of obsoleteConfigs)if (config.elements.includes("*") || config.elements.includes(elementName)) {
                        result.push({
                            loc: attributeKey.getLocation(),
                            messageId: $404c96e82c1b1d4e$export$12a148edcce6f2e6.obsolete,
                            data: {
                                attr: attrName,
                                element: elementName,
                                suggestion: config.suggestion
                            }
                        });
                        break;
                    }
                }
            }
            return result;
        }
    };
}
// lib/rules/class-spacing.js
var $404c96e82c1b1d4e$var$CLASS_BETWEEN_EXTRA_SPACES_REGEX = /\s{2,}/;
var $404c96e82c1b1d4e$var$CLASS_BETWEEN_EXTRA_SPACES_REGEX_GLOBAL = /\s{2,}/g;
var $404c96e82c1b1d4e$var$LINE_BREAK_REGEX = /\r\n|[\r\n\u2028\u2029]/u;
var $404c96e82c1b1d4e$export$1329c1ec5f658703 = {
    extraSpacing: "extraSpacing"
};
function $404c96e82c1b1d4e$var$checkLeading(value, loc, range, result) {
    if (value.startsWith("\n")) return;
    if (value.startsWith(" ")) {
        const leadingSpaces = value.length - value.trimStart().length;
        const spacingStart = loc.start;
        const spacingEnd = {
            line: spacingStart.line,
            column: spacingStart.column + leadingSpaces
        };
        const spacingRange = [
            range[0],
            range[0] + leadingSpaces
        ];
        result.push({
            messageId: $404c96e82c1b1d4e$export$1329c1ec5f658703.extraSpacing,
            loc: {
                start: spacingStart,
                end: spacingEnd
            },
            range: spacingRange
        });
    }
}
function $404c96e82c1b1d4e$var$splitLines(value) {
    const lines = value.split($404c96e82c1b1d4e$var$LINE_BREAK_REGEX);
    let pos = 0;
    return lines.map((line, i)=>{
        const entry = {
            line: line,
            start: pos
        };
        const lineBreakLength = i < lines.length - 1 ? 1 : 0;
        pos += line.length + lineBreakLength;
        return entry;
    });
}
function $404c96e82c1b1d4e$var$toColumn(lineIndex, columnInLine, loc) {
    return lineIndex === 0 ? loc.start.column + columnInLine : columnInLine;
}
function $404c96e82c1b1d4e$var$checkBetween(value, loc, range, result) {
    const lineEntries = $404c96e82c1b1d4e$var$splitLines(value);
    for(let lineIndex = 0; lineIndex < lineEntries.length; lineIndex++){
        const { line: line, start: lineStart } = lineEntries[lineIndex];
        const trimmedLine = line.trim();
        if (!$404c96e82c1b1d4e$var$CLASS_BETWEEN_EXTRA_SPACES_REGEX.test(trimmedLine)) continue;
        const lineLeadingSpaces = line.length - line.trimStart().length;
        for (const match of trimmedLine.matchAll($404c96e82c1b1d4e$var$CLASS_BETWEEN_EXTRA_SPACES_REGEX_GLOBAL)){
            const matchStartInLine = lineLeadingSpaces + match.index;
            const matchEndInLine = matchStartInLine + match[0].length;
            result.push({
                messageId: $404c96e82c1b1d4e$export$1329c1ec5f658703.extraSpacing,
                loc: {
                    start: {
                        line: loc.start.line + lineIndex,
                        column: $404c96e82c1b1d4e$var$toColumn(lineIndex, matchStartInLine, loc) + 1
                    },
                    end: {
                        line: loc.start.line + lineIndex,
                        column: $404c96e82c1b1d4e$var$toColumn(lineIndex, matchEndInLine, loc)
                    }
                },
                range: [
                    range[0] + lineStart + matchStartInLine + 1,
                    range[0] + lineStart + matchEndInLine
                ]
            });
        }
    }
}
function $404c96e82c1b1d4e$var$trailingLoc(line, lineIndex, isSingleLine, loc) {
    const trailingSpaces = line.length - line.trimEnd().length;
    if (isSingleLine) return {
        start: {
            line: loc.end.line,
            column: loc.end.column - trailingSpaces
        },
        end: {
            line: loc.end.line,
            column: loc.end.column
        }
    };
    const columnOffset = lineIndex === 0 ? loc.start.column : 0;
    return {
        start: {
            line: loc.start.line + lineIndex,
            column: columnOffset + line.length - trailingSpaces
        },
        end: {
            line: loc.start.line + lineIndex,
            column: columnOffset + line.length
        }
    };
}
function $404c96e82c1b1d4e$var$checkTrailing(value, loc, range, result) {
    const lineEntries = $404c96e82c1b1d4e$var$splitLines(value);
    const isSingleLine = lineEntries.length === 1;
    for(let i = 0; i < lineEntries.length; i++){
        const { line: line, start: lineStart } = lineEntries[i];
        if (!line.endsWith(" ")) continue;
        const trailingSpaces = line.length - line.trimEnd().length;
        result.push({
            messageId: $404c96e82c1b1d4e$export$1329c1ec5f658703.extraSpacing,
            loc: $404c96e82c1b1d4e$var$trailingLoc(line, i, isSingleLine, loc),
            range: [
                range[0] + lineStart + line.length - trailingSpaces,
                range[0] + lineStart + line.length
            ]
        });
    }
}
function $404c96e82c1b1d4e$export$7108f91a0f8d44f8() {
    return {
        /**
     * @param {AttributeValueAdapter} classValue
     * @returns {ClassSpacingResult}
     */ checkClassValue (classValue) {
            const result = [];
            if (classValue.hasExpression()) return result;
            const value = classValue.getValue();
            if (!value) return result;
            const loc = classValue.getLocation();
            const range = classValue.getRange();
            $404c96e82c1b1d4e$var$checkLeading(value, loc, range, result);
            $404c96e82c1b1d4e$var$checkBetween(value, loc, range, result);
            $404c96e82c1b1d4e$var$checkTrailing(value, loc, range, result);
            return result;
        }
    };
}
// lib/rules/no-duplicate-class.js
var $404c96e82c1b1d4e$export$e175ab31a1e21871 = {
    duplicateClass: "duplicateClass"
};
function $404c96e82c1b1d4e$var$splitClassAndSpaces(value) {
    const result = [];
    const regex = /(\s+|\S+)/g;
    let match = null;
    while((match = regex.exec(value)) !== null)result.push({
        value: match[0],
        pos: match.index
    });
    return result;
}
function $404c96e82c1b1d4e$export$f162233fbd04d00f() {
    return {
        /**
     * @param {AttributeValueAdapter} classValue
     * @returns {NoDuplicateClassResult}
     */ checkClassValue (classValue) {
            const result = [];
            if (classValue.hasExpression()) return result;
            const value = classValue.getValue();
            if (!value) return result;
            const loc = classValue.getLocation();
            const range = classValue.getRange();
            const classesAndSpaces = $404c96e82c1b1d4e$var$splitClassAndSpaces(value);
            const classSet = /* @__PURE__ */ new Set();
            classesAndSpaces.forEach(({ value: value2, pos: pos })=>{
                const className = value2.trim();
                if (className.length) {
                    if (classSet.has(className)) {
                        const classStart = {
                            line: loc.start.line,
                            column: loc.start.column + pos
                        };
                        const classEnd = {
                            line: loc.start.line,
                            column: loc.start.column + pos + value2.length
                        };
                        result.push({
                            messageId: $404c96e82c1b1d4e$export$e175ab31a1e21871.duplicateClass,
                            loc: {
                                start: classStart,
                                end: classEnd
                            },
                            range: [
                                range[0] + pos,
                                range[0] + pos + value2.length
                            ],
                            data: {
                                className: className
                            }
                        });
                    } else classSet.add(className);
                }
            });
            return result;
        }
    };
}


var $a3cc22c4efdf071f$require$noObsoleteTags = $404c96e82c1b1d4e$export$c0e82f9203f788d4;
var $a3cc22c4efdf071f$require$NO_OBSOLETE_TAGS_MESSAGE_IDS = $404c96e82c1b1d4e$export$4b0242017845dbc3;
var $65279e6012804295$exports = {};
/**
 * @import {
 *   Attribute,
 *   AttributeKey,
 *   AttributeValue,
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 */ var $4558f632d44690ae$exports = {};
/**
 * @import {AttributeAdapter} from "@html-eslint/core"
 * @import {Attribute} from "@html-eslint/types"
 */ var $9d52cc1ac2defb4e$exports = {};
/**
 * @import {AttributeKeyAdapter} from "@html-eslint/core"
 * @import {AttributeKey} from "@html-eslint/types"
 */ 
var $9d52cc1ac2defb4e$require$hasTemplate = $7dabedd289de3a0a$exports.hasTemplate;
/** @implements {AttributeKeyAdapter} */ class $9d52cc1ac2defb4e$var$HTMLAttributeKeyAdapter {
    /** @param {AttributeKey} node */ constructor(node){
        this.node = node;
    }
    getValue() {
        return this.node.value;
    }
    hasExpression() {
        return $9d52cc1ac2defb4e$require$hasTemplate(this.node);
    }
    getRange() {
        return this.node.range;
    }
    getLocation() {
        return this.node.loc;
    }
}
$9d52cc1ac2defb4e$exports = {
    HTMLAttributeKeyAdapter: $9d52cc1ac2defb4e$var$HTMLAttributeKeyAdapter
};


var $4558f632d44690ae$require$HTMLAttributeKeyAdapter = $9d52cc1ac2defb4e$exports.HTMLAttributeKeyAdapter;
var $9d27903f813dbd43$exports = {};
/**
 * @import {AttributeValueAdapter} from "@html-eslint/core"
 * @import {AttributeValue} from "@html-eslint/types"
 */ /** @implements {AttributeValueAdapter} */ class $9d27903f813dbd43$var$HTMLAttributeValueAdapter {
    /** @param {AttributeValue} node */ constructor(node){
        this.node = node;
    }
    getLocation() {
        return this.node.loc;
    }
    getRange() {
        return this.node.range;
    }
    hasExpression() {
        return !!this.node.parts.length;
    }
    getValue() {
        return this.node.value;
    }
}
$9d27903f813dbd43$exports = {
    HTMLAttributeValueAdapter: $9d27903f813dbd43$var$HTMLAttributeValueAdapter
};


var $4558f632d44690ae$require$HTMLAttributeValueAdapter = $9d27903f813dbd43$exports.HTMLAttributeValueAdapter;
/** @implements {AttributeAdapter} */ class $4558f632d44690ae$var$HTMLAttributeAdapter {
    /** @param {Attribute} node */ constructor(node){
        this.node = node;
    }
    getKey() {
        return new $4558f632d44690ae$require$HTMLAttributeKeyAdapter(this.node.key);
    }
    getValue() {
        if (!this.node.value) return null;
        return new $4558f632d44690ae$require$HTMLAttributeValueAdapter(this.node.value);
    }
}
$4558f632d44690ae$exports = {
    HTMLAttributeAdapter: $4558f632d44690ae$var$HTMLAttributeAdapter
};


var $65279e6012804295$require$HTMLAttributeAdapter = $4558f632d44690ae$exports.HTMLAttributeAdapter;

var $65279e6012804295$require$HTMLAttributeKeyAdapter = $9d52cc1ac2defb4e$exports.HTMLAttributeKeyAdapter;

var $65279e6012804295$require$HTMLAttributeValueAdapter = $9d27903f813dbd43$exports.HTMLAttributeValueAdapter;
var $ca9fc2490119d3d2$exports = {};
/**
 * @import {ElementAdapter} from "@html-eslint/core"
 * @import {
 *   AttributeValue,
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 */ 
var $ca9fc2490119d3d2$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;

var $ca9fc2490119d3d2$require$HTMLAttributeAdapter = $4558f632d44690ae$exports.HTMLAttributeAdapter;
/** @implements {ElementAdapter} */ class $ca9fc2490119d3d2$var$HTMLElementAdapter {
    /** @param {Tag | ScriptTag | StyleTag} node */ constructor(node){
        this.node = node;
    }
    getLocation() {
        return this.node.loc;
    }
    getRange() {
        return this.node.range;
    }
    getElementName() {
        return $ca9fc2490119d3d2$require$getNameOf(this.node);
    }
    getOpenStartLocation() {
        return this.node.openStart.loc;
    }
    getOpenStartRange() {
        return this.node.openStart.range;
    }
    getAttributes() {
        return this.node.attributes.map((attribute)=>new $ca9fc2490119d3d2$require$HTMLAttributeAdapter(attribute));
    }
}
$ca9fc2490119d3d2$exports = {
    HTMLElementAdapter: $ca9fc2490119d3d2$var$HTMLElementAdapter
};


var $65279e6012804295$require$HTMLElementAdapter = $ca9fc2490119d3d2$exports.HTMLElementAdapter;
/** @param {ScriptTag | StyleTag | Tag} node */ function $65279e6012804295$var$createElementAdapter(node) {
    return new $65279e6012804295$require$HTMLElementAdapter(node);
}
/** @param {Attribute} node */ function $65279e6012804295$var$createAttributeAdapter(node) {
    return new $65279e6012804295$require$HTMLAttributeAdapter(node);
}
/** @param {AttributeKey} node */ function $65279e6012804295$var$createAttributeKeyAdapter(node) {
    return new $65279e6012804295$require$HTMLAttributeKeyAdapter(node);
}
/** @param {AttributeValue} node */ function $65279e6012804295$var$createAttributeValueAdapter(node) {
    return new $65279e6012804295$require$HTMLAttributeValueAdapter(node);
}
$65279e6012804295$exports = {
    createElementAdapter: $65279e6012804295$var$createElementAdapter,
    createAttributeAdapter: $65279e6012804295$var$createAttributeAdapter,
    createAttributeKeyAdapter: $65279e6012804295$var$createAttributeKeyAdapter,
    createAttributeValueAdapter: $65279e6012804295$var$createAttributeValueAdapter
};


var $a3cc22c4efdf071f$require$createElementAdapter = $65279e6012804295$exports.createElementAdapter;
/** @type {RuleModule<[]>} */ $a3cc22c4efdf071f$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow use of obsolete elements in HTML5",
            category: $a3cc22c4efdf071f$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: true,
            url: $a3cc22c4efdf071f$require$getRuleUrl("no-obsolete-tags")
        },
        fixable: null,
        schema: [],
        messages: {
            [$a3cc22c4efdf071f$require$NO_OBSOLETE_TAGS_MESSAGE_IDS.unexpected]: "Unexpected use of obsolete tag <{{tag}}>"
        }
    },
    create (context) {
        const { checkElement: checkElement } = $a3cc22c4efdf071f$require$noObsoleteTags();
        /** @param {Tag | ScriptTag | StyleTag} node */ function check(node) {
            const adapter = $a3cc22c4efdf071f$require$createElementAdapter(node);
            const result = checkElement(adapter);
            for (const { loc: loc, messageId: messageId, data: data } of result)context.report({
                loc: loc,
                messageId: messageId,
                data: data
            });
        }
        return $a3cc22c4efdf071f$require$createVisitors(context, {
            Tag: check,
            ScriptTag: check,
            StyleTag: check
        });
    }
};


var $e93dcc8bba8a84dc$exports = {};
/**
 * @import {
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 * @typedef {Object} Option
 * @property {"always" | "never"} [Option.selfClosing]
 * @property {string[]} [Option.selfClosingCustomPatterns]
 */ 
var $e93dcc8bba8a84dc$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;
var $e93dcc8bba8a84dc$require$VOID_ELEMENTS = $25c931d91929d6ab$exports.VOID_ELEMENTS;

var $e93dcc8bba8a84dc$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $e93dcc8bba8a84dc$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;

var $e93dcc8bba8a84dc$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;
const $e93dcc8bba8a84dc$var$VOID_ELEMENTS_SET = new Set($e93dcc8bba8a84dc$require$VOID_ELEMENTS);
const $e93dcc8bba8a84dc$var$MESSAGE_IDS = {
    MISSING: "missing",
    MISSING_SELF: "missingSelf",
    UNEXPECTED: "unexpected"
};
/** @type {RuleModule<[Option]>} */ $e93dcc8bba8a84dc$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Require closing tags.",
            category: $e93dcc8bba8a84dc$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: true,
            url: $e93dcc8bba8a84dc$require$getRuleUrl("require-closing-tags")
        },
        fixable: true,
        schema: [
            {
                type: "object",
                properties: {
                    selfClosing: {
                        enum: [
                            "always",
                            "never"
                        ]
                    },
                    selfClosingCustomPatterns: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$e93dcc8bba8a84dc$var$MESSAGE_IDS.MISSING]: "Missing closing tag for {{tag}}.",
            [$e93dcc8bba8a84dc$var$MESSAGE_IDS.MISSING_SELF]: "Missing self closing tag for {{tag}}",
            [$e93dcc8bba8a84dc$var$MESSAGE_IDS.UNEXPECTED]: "Unexpected self closing tag for {{tag}}."
        }
    },
    create (context) {
        /** @type {string[]} */ const foreignContext = [];
        const shouldSelfCloseVoid = context.options?.length ? context.options[0].selfClosing === "always" : false;
        /** @type {string[]} */ const selfClosingCustomPatternsOption = context.options?.[0]?.selfClosingCustomPatterns || [];
        const selfClosingCustomPatterns = selfClosingCustomPatternsOption.map((i)=>new RegExp(i));
        /** @param {Tag | ScriptTag | StyleTag} node */ function checkClosing(node) {
            const name = $e93dcc8bba8a84dc$require$getNameOf(node);
            if (!node.close) context.report({
                node: node,
                data: {
                    tag: name
                },
                messageId: $e93dcc8bba8a84dc$var$MESSAGE_IDS.MISSING
            });
        }
        /**
     * @param {Tag} node
     * @param {boolean} shouldSelfClose
     * @param {boolean} fixable
     */ function checkVoidElement(node, shouldSelfClose, fixable) {
            const hasSelfClose = node.openEnd.value === "/>";
            if (shouldSelfClose && !hasSelfClose) context.report({
                node: node.openEnd,
                data: {
                    tag: node.name
                },
                messageId: $e93dcc8bba8a84dc$var$MESSAGE_IDS.MISSING_SELF,
                fix (fixer) {
                    if (!fixable) return null;
                    const fixes = [];
                    fixes.push(fixer.replaceText(node.openEnd, " />"));
                    if (node.close) fixes.push(fixer.remove(node.close));
                    return fixes;
                }
            });
            if (!shouldSelfClose && hasSelfClose) context.report({
                node: node.openEnd,
                data: {
                    tag: node.name
                },
                messageId: $e93dcc8bba8a84dc$var$MESSAGE_IDS.UNEXPECTED,
                fix (fixer) {
                    if (!fixable) return null;
                    return fixer.replaceText(node.openEnd, ">");
                }
            });
        }
        return $e93dcc8bba8a84dc$require$createVisitors(context, {
            Tag (node) {
                const isVoidElement = $e93dcc8bba8a84dc$var$VOID_ELEMENTS_SET.has(node.name);
                const isSelfClosingCustomElement = !!selfClosingCustomPatterns.some((i)=>node.name.match(i));
                const isForeign = foreignContext.length > 0;
                const shouldSelfCloseCustom = isSelfClosingCustomElement && !node.children.length;
                const shouldSelfCloseForeign = node.selfClosing;
                const shouldSelfClose = isVoidElement && shouldSelfCloseVoid || isSelfClosingCustomElement && shouldSelfCloseCustom || isForeign && shouldSelfCloseForeign;
                const canSelfClose = isVoidElement || isSelfClosingCustomElement || isForeign;
                if (node.selfClosing || canSelfClose) checkVoidElement(node, shouldSelfClose, canSelfClose);
                else if (node.openEnd.value !== "/>") checkClosing(node);
                if ([
                    "svg",
                    "math"
                ].includes(node.name)) foreignContext.push(node.name);
            },
            /** @param {Tag} node */ "Tag:exit" (node) {
                if (node.name === foreignContext[foreignContext.length - 1]) foreignContext.pop();
            },
            ScriptTag (node) {
                if (!node.close) checkClosing(node);
            },
            StyleTag (node) {
                if (!node.close) checkClosing(node);
            }
        });
    }
};


var $55a2c8ed5f18f27e$exports = {};
/**
 * @import {
 *   AnyNode,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $55a2c8ed5f18f27e$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $55a2c8ed5f18f27e$require$filter = $c7fec554e020284f$exports.filter;

var $55a2c8ed5f18f27e$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $55a2c8ed5f18f27e$require$isTag = $7dabedd289de3a0a$exports.isTag;

var $55a2c8ed5f18f27e$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $55a2c8ed5f18f27e$var$MESSAGE_IDS = {
    MISSING: "missing",
    EMPTY: "empty"
};
/**
 * @param {AnyNode} node
 * @returns {node is Tag}
 */ function $55a2c8ed5f18f27e$var$isMetaTagNode(node) {
    return $55a2c8ed5f18f27e$require$isTag(node) && node.name === "meta";
}
/** @type {RuleModule<[]>} */ $55a2c8ed5f18f27e$exports = {
    meta: {
        type: "code",
        docs: {
            description: 'Require use of `<meta name="description">` in `<head>`',
            category: $55a2c8ed5f18f27e$require$RULE_CATEGORY.SEO,
            recommended: false,
            url: $55a2c8ed5f18f27e$require$getRuleUrl("require-meta-description")
        },
        fixable: null,
        schema: [],
        messages: {
            [$55a2c8ed5f18f27e$var$MESSAGE_IDS.MISSING]: 'Missing `<meta name="description">`.',
            [$55a2c8ed5f18f27e$var$MESSAGE_IDS.EMPTY]: 'Unexpected empty `content` in `<meta name="description">`'
        }
    },
    create (context) {
        return {
            Tag (node) {
                if (node.name !== "head") return;
                const metaTags = $55a2c8ed5f18f27e$require$filter(node.children, $55a2c8ed5f18f27e$var$isMetaTagNode);
                const descriptionMetaTags = metaTags.filter((meta)=>{
                    const nameAttr = $55a2c8ed5f18f27e$require$findAttr(meta, "name");
                    return nameAttr?.value?.value.toLowerCase() === "description";
                });
                if (descriptionMetaTags.length === 0) context.report({
                    node: node,
                    messageId: $55a2c8ed5f18f27e$var$MESSAGE_IDS.MISSING
                });
                else descriptionMetaTags.forEach((meta)=>{
                    const content = $55a2c8ed5f18f27e$require$findAttr(meta, "content");
                    if (!content || !content.value || !content.value.value.trim().length) context.report({
                        node: content || meta,
                        messageId: $55a2c8ed5f18f27e$var$MESSAGE_IDS.EMPTY
                    });
                });
            }
        };
    }
};


var $8777f1f287384e8e$exports = {};
/** @import {RuleModule} from "../types" */ 
var $8777f1f287384e8e$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $8777f1f287384e8e$require$findAttr = $7dabedd289de3a0a$exports.findAttr;

var $8777f1f287384e8e$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $8777f1f287384e8e$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $8777f1f287384e8e$var$MESSAGE_IDS = {
    MISSING: "missing",
    UNEXPECTED: "unexpected"
};
/** @type {RuleModule<[]>} */ $8777f1f287384e8e$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Require `title` in `<frame>`, `<iframe>`",
            category: $8777f1f287384e8e$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $8777f1f287384e8e$require$getRuleUrl("require-frame-title")
        },
        fixable: false,
        schema: [],
        messages: {
            [$8777f1f287384e8e$var$MESSAGE_IDS.MISSING]: "Missing `title` attribute in {{frame}}.",
            [$8777f1f287384e8e$var$MESSAGE_IDS.UNEXPECTED]: "Unexpected empty `title`."
        }
    },
    create (context) {
        return $8777f1f287384e8e$require$createVisitors(context, {
            Tag (node) {
                if (node.name !== "frame" && node.name !== "iframe") return;
                const title = $8777f1f287384e8e$require$findAttr(node, "title");
                if (!title) context.report({
                    node: node.openStart,
                    data: {
                        frame: `<${node.name}>`
                    },
                    messageId: $8777f1f287384e8e$var$MESSAGE_IDS.MISSING
                });
                else if (!title.value || title.value.value.trim().length === 0) context.report({
                    node: title,
                    messageId: $8777f1f287384e8e$var$MESSAGE_IDS.UNEXPECTED
                });
            }
        });
    }
};


var $41df0d1b593b470c$exports = {};
/** @import {RuleModule} from "../types" */ 
var $41df0d1b593b470c$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $41df0d1b593b470c$require$findAttr = $7dabedd289de3a0a$exports.findAttr;

var $41df0d1b593b470c$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $41df0d1b593b470c$var$MESSAGE_IDS = {
    UNEXPECTED: "unexpected"
};
/** @type {RuleModule<[]>} */ $41df0d1b593b470c$exports = {
    meta: {
        type: "code",
        docs: {
            description: 'Disallow use of `user-scalable=no` in `<meta name="viewport">`.',
            category: $41df0d1b593b470c$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $41df0d1b593b470c$require$getRuleUrl("no-non-scalable-viewport")
        },
        fixable: null,
        schema: [],
        messages: {
            [$41df0d1b593b470c$var$MESSAGE_IDS.UNEXPECTED]: "Unexpected use of `user-scalable=no`."
        }
    },
    create (context) {
        return {
            Tag (node) {
                if (node.name !== "meta") return;
                const nameAttr = $41df0d1b593b470c$require$findAttr(node, "name");
                const contentAttr = $41df0d1b593b470c$require$findAttr(node, "content");
                if (nameAttr?.value?.value.toLowerCase() === "viewport" && contentAttr?.value?.value.match(/user-scalable\s*=\s*no/i)) context.report({
                    node: contentAttr,
                    messageId: $41df0d1b593b470c$var$MESSAGE_IDS.UNEXPECTED
                });
            }
        };
    }
};


var $41f7e6997995c7bb$exports = {};
/**
 * @import {
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $41f7e6997995c7bb$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $41f7e6997995c7bb$require$findAttr = $7dabedd289de3a0a$exports.findAttr;

var $41f7e6997995c7bb$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $41f7e6997995c7bb$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $41f7e6997995c7bb$var$MESSAGE_IDS = {
    UNEXPECTED: "unexpected"
};
/** @type {RuleModule<[]>} */ $41f7e6997995c7bb$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow use of positive `tabindex`.",
            category: $41f7e6997995c7bb$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $41f7e6997995c7bb$require$getRuleUrl("no-positive-tabindex")
        },
        fixable: null,
        schema: [],
        messages: {
            [$41f7e6997995c7bb$var$MESSAGE_IDS.UNEXPECTED]: "Unexpected use of positive `tabindex`."
        }
    },
    create (context) {
        /** @param {Tag | StyleTag | ScriptTag} node */ function check(node) {
            const tabIndexAttr = $41f7e6997995c7bb$require$findAttr(node, "tabindex");
            if (tabIndexAttr?.value && !tabIndexAttr.value.parts.length && parseInt(tabIndexAttr.value.value, 10) > 0) context.report({
                node: tabIndexAttr,
                messageId: $41f7e6997995c7bb$var$MESSAGE_IDS.UNEXPECTED
            });
        }
        return $41f7e6997995c7bb$require$createVisitors(context, {
            Tag: check,
            StyleTag: check,
            ScriptTag: check
        });
    }
};


var $85cf17ee296bba4d$exports = {};
/**
 * @import {
 *   AnyNode,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $85cf17ee296bba4d$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $85cf17ee296bba4d$require$find = $c7fec554e020284f$exports.find;

var $85cf17ee296bba4d$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $85cf17ee296bba4d$require$isTag = $7dabedd289de3a0a$exports.isTag;

var $85cf17ee296bba4d$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $85cf17ee296bba4d$var$MESSAGE_IDS = {
    MISSING: "missing",
    EMPTY: "empty"
};
/**
 * @param {AnyNode} node
 * @returns {node is Tag}
 */ function $85cf17ee296bba4d$var$isMetaViewport(node) {
    if ($85cf17ee296bba4d$require$isTag(node) && node.name === "meta") {
        const nameAttribute = $85cf17ee296bba4d$require$findAttr(node, "name");
        return !!(nameAttribute && nameAttribute.value && nameAttribute.value.value.toLowerCase() === "viewport");
    }
    return false;
}
/** @type {RuleModule<[]>} */ $85cf17ee296bba4d$exports = {
    meta: {
        type: "code",
        docs: {
            description: 'Enforce use of `<meta name="viewport">` in `<head>`',
            category: $85cf17ee296bba4d$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $85cf17ee296bba4d$require$getRuleUrl("require-meta-viewport")
        },
        fixable: null,
        schema: [],
        messages: {
            [$85cf17ee296bba4d$var$MESSAGE_IDS.MISSING]: 'Missing `<meta name="viewport">`.',
            [$85cf17ee296bba4d$var$MESSAGE_IDS.EMPTY]: 'Unexpected empty `content` attribute in `<meta name="viewport">`.'
        }
    },
    create (context) {
        return {
            Tag (node) {
                if (node.name !== "head") return;
                const metaViewport = $85cf17ee296bba4d$require$find(node.children, $85cf17ee296bba4d$var$isMetaViewport);
                if (!metaViewport) {
                    context.report({
                        node: node,
                        messageId: $85cf17ee296bba4d$var$MESSAGE_IDS.MISSING
                    });
                    return;
                }
                const contentAttribute = $85cf17ee296bba4d$require$findAttr(metaViewport, "content");
                const isAttributeEmpty = !contentAttribute || !contentAttribute.value || !contentAttribute.value.value.length;
                if (isAttributeEmpty) {
                    const reportTarget = !contentAttribute || !contentAttribute.value ? metaViewport : contentAttribute;
                    context.report({
                        node: reportTarget,
                        messageId: $85cf17ee296bba4d$var$MESSAGE_IDS.EMPTY
                    });
                }
            }
        };
    }
};


var $a7c098e78644b4b1$exports = {};
/**
 * @import {
 *   AnyNode,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $a7c098e78644b4b1$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $a7c098e78644b4b1$require$find = $c7fec554e020284f$exports.find;

var $a7c098e78644b4b1$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $a7c098e78644b4b1$require$isTag = $7dabedd289de3a0a$exports.isTag;

var $a7c098e78644b4b1$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $a7c098e78644b4b1$var$MESSAGE_IDS = {
    MISSING: "missing",
    EMPTY: "empty"
};
/**
 * @param {AnyNode} node
 * @returns {node is Tag}
 */ function $a7c098e78644b4b1$var$isMetaCharset(node) {
    return $a7c098e78644b4b1$require$isTag(node) && node.name === "meta" && !!$a7c098e78644b4b1$require$findAttr(node, "charset");
}
/**
 * Get the indentation string for inserting a new child inside a head tag.
 *
 * @param {Tag} headNode
 * @returns {string}
 */ function $a7c098e78644b4b1$var$getChildIndent(headNode) {
    const { children: children } = headNode;
    if (children.length > 0) {
        // If first child is a text node (e.g. "\n    "), extract trailing whitespace
        const first = children[0];
        if (first.type === "Text" && first.value) {
            const match = first.value.match(/\n([ \t]*)$/);
            if (match) return match[1];
        }
        // Non-text first child: use its column position
        return " ".repeat(first.loc.start.column);
    }
    // Empty head: use head's column + 2-space indent
    return " ".repeat(headNode.loc.start.column + 2);
}
/** @type {RuleModule<[]>} */ $a7c098e78644b4b1$exports = {
    meta: {
        type: "code",
        docs: {
            description: 'Enforce use of `<meta charset="...">` in `<head>`',
            category: $a7c098e78644b4b1$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $a7c098e78644b4b1$require$getRuleUrl("require-meta-charset")
        },
        fixable: "code",
        schema: [],
        messages: {
            [$a7c098e78644b4b1$var$MESSAGE_IDS.MISSING]: 'Missing `<meta charset="...">`.',
            [$a7c098e78644b4b1$var$MESSAGE_IDS.EMPTY]: "Unexpected empty charset."
        }
    },
    create (context) {
        return {
            Tag (node) {
                if (node.name !== "head") return;
                const metaCharset = $a7c098e78644b4b1$require$find(node.children, $a7c098e78644b4b1$var$isMetaCharset);
                if (!metaCharset) {
                    context.report({
                        node: node,
                        messageId: $a7c098e78644b4b1$var$MESSAGE_IDS.MISSING,
                        fix (fixer) {
                            const indent = $a7c098e78644b4b1$var$getChildIndent(node);
                            return fixer.insertTextAfterRange(node.openEnd.range, `\n${indent}<meta charset="UTF-8">`);
                        }
                    });
                    return;
                }
                const charsetAttr = $a7c098e78644b4b1$require$findAttr(metaCharset, "charset");
                if (charsetAttr) {
                    if (!charsetAttr.value || !charsetAttr.value.value.length) context.report({
                        node: charsetAttr,
                        messageId: $a7c098e78644b4b1$var$MESSAGE_IDS.EMPTY,
                        fix (fixer) {
                            if (charsetAttr.value) // <meta charset=""> — replace empty value with UTF-8
                            return fixer.replaceTextRange(charsetAttr.value.range, "UTF-8");
                            else // <meta charset> — append ="UTF-8" after key
                            return fixer.insertTextAfterRange(charsetAttr.key.range, '="UTF-8"');
                        }
                    });
                }
            }
        };
    }
};


var $2f88baced4c3e503$exports = {};
/** @import {RuleModule} from "../types" */ 
var $2f88baced4c3e503$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $2f88baced4c3e503$require$findAttr = $7dabedd289de3a0a$exports.findAttr;

var $2f88baced4c3e503$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $2f88baced4c3e503$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $2f88baced4c3e503$var$MESSAGE_IDS = {
    MISSING: "missing"
};
/** @type {RuleModule<[]>} */ $2f88baced4c3e503$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow usage of unsafe `target='_blank'`",
            category: $2f88baced4c3e503$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $2f88baced4c3e503$require$getRuleUrl("no-target-blank")
        },
        fixable: null,
        schema: [],
        messages: {
            [$2f88baced4c3e503$var$MESSAGE_IDS.MISSING]: 'Missing `rel="noreferrer"` attribute in a tag.'
        }
    },
    create (context) {
        /**
     * Checks whether a link is an external link or not.
     *
     * @param {string} link A link to check
     * @returns {boolean}
     */ function isExternalLink(link) {
            return /^(?:\w+:|\/\/)/.test(link);
        }
        return $2f88baced4c3e503$require$createVisitors(context, {
            Tag (node) {
                if (node.name !== "a") return;
                const target = $2f88baced4c3e503$require$findAttr(node, "target");
                if (target?.value?.value === "_blank") {
                    const href = $2f88baced4c3e503$require$findAttr(node, "href");
                    if (href?.value && isExternalLink(href.value.value)) {
                        const rel = $2f88baced4c3e503$require$findAttr(node, "rel");
                        if (rel?.value?.parts?.length) return;
                        if (!rel?.value?.value.includes("noreferrer")) context.report({
                            node: target,
                            messageId: $2f88baced4c3e503$var$MESSAGE_IDS.MISSING
                        });
                    }
                }
            }
        });
    }
};


var $f3cd358514291eac$exports = {};
/**
 * @import {
 *   Attribute,
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {
 *   RuleModule,
 *   SuggestionReportDescriptor
 * } from "../types"
 */ 
var $f3cd358514291eac$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $f3cd358514291eac$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $f3cd358514291eac$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;

var $f3cd358514291eac$require$hasTemplate = $7dabedd289de3a0a$exports.hasTemplate;
const $f3cd358514291eac$var$MESSAGE_IDS = {
    DUPLICATE_ATTRS: "duplicateAttrs",
    REMOVE_ATTR: "removeAttr"
};
/** @type {RuleModule<[]>} */ $f3cd358514291eac$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow duplicate attributes",
            category: $f3cd358514291eac$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: true,
            url: $f3cd358514291eac$require$getRuleUrl("no-duplicate-attrs")
        },
        fixable: null,
        hasSuggestions: true,
        schema: [],
        messages: {
            [$f3cd358514291eac$var$MESSAGE_IDS.DUPLICATE_ATTRS]: "The attribute '{{attrName}}' is duplicated.",
            [$f3cd358514291eac$var$MESSAGE_IDS.REMOVE_ATTR]: "Remove this duplicate '{{attrName}}' attribute."
        }
    },
    create (context) {
        /**
     * @param {Attribute} node
     * @returns {SuggestionReportDescriptor[]}
     */ function getSuggestions(node) {
            return [
                {
                    messageId: $f3cd358514291eac$var$MESSAGE_IDS.REMOVE_ATTR,
                    fix: (fixer)=>fixer.removeRange(node.range),
                    data: {
                        attrName: node.key.value
                    }
                }
            ];
        }
        /** @param {Tag | StyleTag | ScriptTag} node */ function check(node) {
            if (Array.isArray(node.attributes)) {
                const attrsSet = new Set();
                node.attributes.forEach((attr)=>{
                    if ($f3cd358514291eac$require$hasTemplate(attr.key)) return;
                    if (attrsSet.has(attr.key.value.toLowerCase())) context.report({
                        node: attr,
                        data: {
                            attrName: attr.key.value
                        },
                        messageId: $f3cd358514291eac$var$MESSAGE_IDS.DUPLICATE_ATTRS,
                        suggest: getSuggestions(attr)
                    });
                    else attrsSet.add(attr.key.value.toLowerCase());
                });
            }
        }
        return $f3cd358514291eac$require$createVisitors(context, {
            Tag: check,
            StyleTag: check,
            ScriptTag: check
        });
    }
};


var $2f2570ff16ce8817$exports = {};
/**
 * @import {
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $2f2570ff16ce8817$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $2f2570ff16ce8817$require$findAttr = $7dabedd289de3a0a$exports.findAttr;

var $2f2570ff16ce8817$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $2f2570ff16ce8817$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $2f2570ff16ce8817$var$MESSAGE_IDS = {
    UNEXPECTED: "unexpected"
};
const $2f2570ff16ce8817$var$ABSTRACT_ROLE_SET = new Set([
    "command",
    "composite",
    "input",
    "landmark",
    "range",
    "roletype",
    "section",
    "sectionhead",
    "select",
    "structure",
    "widget",
    "window"
]);
/** @type {RuleModule<[]>} */ $2f2570ff16ce8817$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow use of abstract roles",
            category: $2f2570ff16ce8817$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $2f2570ff16ce8817$require$getRuleUrl("no-abstract-roles")
        },
        fixable: null,
        schema: [],
        messages: {
            [$2f2570ff16ce8817$var$MESSAGE_IDS.UNEXPECTED]: "Unexpected use of an abstract role."
        }
    },
    create (context) {
        /** @param {Tag | ScriptTag | StyleTag} node */ function check(node) {
            const roleAttr = $2f2570ff16ce8817$require$findAttr(node, "role");
            if (roleAttr?.value && $2f2570ff16ce8817$var$ABSTRACT_ROLE_SET.has(roleAttr.value.value)) context.report({
                messageId: $2f2570ff16ce8817$var$MESSAGE_IDS.UNEXPECTED,
                node: roleAttr
            });
        }
        return $2f2570ff16ce8817$require$createVisitors(context, {
            Tag: check,
            ScriptTag: check,
            StyleTag: check
        });
    }
};


var $298e7ffb7782b38b$exports = {};
/**
 * @import {AttributeValue} from "@html-eslint/types"
 * @import {
 *   RuleModule,
 *   SuggestionReportDescriptor
 * } from "../types"
 */ 
var $298e7ffb7782b38b$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $298e7ffb7782b38b$require$findAttr = $7dabedd289de3a0a$exports.findAttr;

var $298e7ffb7782b38b$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $298e7ffb7782b38b$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $298e7ffb7782b38b$var$MESSAGE_IDS = {
    MISSING: "missing",
    INVALID: "invalid",
    REPLACE_TO_SUBMIT: "replaceToSubmit",
    REPLACE_TO_BUTTON: "replaceToButton",
    REPLACE_TO_RESET: "replaceToReset"
};
const $298e7ffb7782b38b$var$VALID_BUTTON_TYPES_SET = new Set([
    "submit",
    "button",
    "reset"
]);
/** @type {RuleModule<[]>} */ $298e7ffb7782b38b$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Require use of the button element with a valid type attribute.",
            category: $298e7ffb7782b38b$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $298e7ffb7782b38b$require$getRuleUrl("require-button-type")
        },
        fixable: true,
        hasSuggestions: true,
        schema: [],
        messages: {
            [$298e7ffb7782b38b$var$MESSAGE_IDS.MISSING]: "Missing a type attribute for button",
            [$298e7ffb7782b38b$var$MESSAGE_IDS.INVALID]: '"{{type}}" is an invalid value for button type attribute.',
            [$298e7ffb7782b38b$var$MESSAGE_IDS.REPLACE_TO_BUTTON]: "Replace the type with 'button'",
            [$298e7ffb7782b38b$var$MESSAGE_IDS.REPLACE_TO_SUBMIT]: "Replace the type with 'submit'",
            [$298e7ffb7782b38b$var$MESSAGE_IDS.REPLACE_TO_RESET]: "Replace the type with 'reset'"
        }
    },
    create (context) {
        /**
     * @param {AttributeValue} node
     * @returns {SuggestionReportDescriptor[]}
     */ function getSuggestions(node) {
            return [
                {
                    messageId: $298e7ffb7782b38b$var$MESSAGE_IDS.REPLACE_TO_SUBMIT,
                    fix: (fixer)=>fixer.replaceTextRange(node.range, "submit")
                },
                {
                    messageId: $298e7ffb7782b38b$var$MESSAGE_IDS.REPLACE_TO_BUTTON,
                    fix: (fixer)=>fixer.replaceTextRange(node.range, "button")
                },
                {
                    messageId: $298e7ffb7782b38b$var$MESSAGE_IDS.REPLACE_TO_RESET,
                    fix: (fixer)=>fixer.replaceTextRange(node.range, "reset")
                }
            ];
        }
        return $298e7ffb7782b38b$require$createVisitors(context, {
            Tag (node) {
                if (node.name !== "button") return;
                const typeAttr = $298e7ffb7782b38b$require$findAttr(node, "type");
                if (!typeAttr?.value) context.report({
                    node: node.openStart,
                    messageId: $298e7ffb7782b38b$var$MESSAGE_IDS.MISSING,
                    fix (fixer) {
                        return fixer.insertTextAfter(node.openStart, ' type="submit"');
                    }
                });
                else if (!$298e7ffb7782b38b$var$VALID_BUTTON_TYPES_SET.has(typeAttr.value.value) && !typeAttr.value.parts.length) context.report({
                    node: typeAttr,
                    messageId: $298e7ffb7782b38b$var$MESSAGE_IDS.INVALID,
                    data: {
                        type: typeAttr.value.value
                    },
                    suggest: getSuggestions(typeAttr.value)
                });
            }
        });
    }
};


var $39a7aa79b8052c7f$exports = {};
/** @import {RuleModule} from "../types" */ 
var $39a7aa79b8052c7f$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $39a7aa79b8052c7f$require$findAttr = $7dabedd289de3a0a$exports.findAttr;

var $39a7aa79b8052c7f$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $39a7aa79b8052c7f$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $39a7aa79b8052c7f$var$MESSAGE_IDS = {
    UNEXPECTED: "unexpected"
};
/** @type {RuleModule<[]>} */ $39a7aa79b8052c7f$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow use of aria-hidden attributes on the `body` element.",
            category: $39a7aa79b8052c7f$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $39a7aa79b8052c7f$require$getRuleUrl("no-aria-hidden-body")
        },
        fixable: null,
        schema: [],
        messages: {
            [$39a7aa79b8052c7f$var$MESSAGE_IDS.UNEXPECTED]: "Unexpected aria-hidden on body tag."
        }
    },
    create (context) {
        return $39a7aa79b8052c7f$require$createVisitors(context, {
            Tag (node) {
                if (node.name !== "body") return;
                const ariaHiddenAttr = $39a7aa79b8052c7f$require$findAttr(node, "aria-hidden");
                if (!ariaHiddenAttr) return;
                if (ariaHiddenAttr.value?.parts.length) return;
                if (ariaHiddenAttr.value?.value !== "false" || !ariaHiddenAttr.value) context.report({
                    node: ariaHiddenAttr,
                    messageId: $39a7aa79b8052c7f$var$MESSAGE_IDS.UNEXPECTED
                });
            }
        });
    }
};


var $cd15c0fd04462af9$exports = {};
/**
 * @import {Tag} from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $cd15c0fd04462af9$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $cd15c0fd04462af9$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $cd15c0fd04462af9$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;

var $cd15c0fd04462af9$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $cd15c0fd04462af9$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $cd15c0fd04462af9$var$MESSAGE_IDS = {
    UNEXPECTED: "unexpected"
};
// List of elements that are inherently focusable
const $cd15c0fd04462af9$var$FOCUSABLE_ELEMENTS = new Set([
    "a",
    "button",
    "input",
    "select",
    "textarea",
    "video",
    "audio",
    "details",
    "embed",
    "iframe",
    "summary"
]);
/** @type {RuleModule<[]>} */ $cd15c0fd04462af9$exports = {
    meta: {
        type: "code",
        docs: {
            description: 'Disallow aria-hidden="true" on focusable elements',
            category: $cd15c0fd04462af9$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $cd15c0fd04462af9$require$getRuleUrl("no-aria-hidden-on-focusable")
        },
        fixable: null,
        schema: [],
        messages: {
            [$cd15c0fd04462af9$var$MESSAGE_IDS.UNEXPECTED]: 'Unexpected aria-hidden="true" on focusable element.'
        }
    },
    create (context) {
        /**
     * Checks if an element is focusable
     *
     * @param {Tag} node
     * @returns {boolean}
     */ function isFocusable(node) {
            const tagName = $cd15c0fd04462af9$require$getNameOf(node);
            const contentEditableAttr = $cd15c0fd04462af9$require$findAttr(node, "contenteditable");
            if (contentEditableAttr) {
                const value = contentEditableAttr.value?.value.toLowerCase() ?? "";
                if (value === "" || value === "true" || value === "plaintext-only") return true;
            }
            // Check for tabindex attribute
            const tabIndexAttr = $cd15c0fd04462af9$require$findAttr(node, "tabindex");
            if (tabIndexAttr?.value) {
                const tabIndexValue = tabIndexAttr.value.value;
                // If tabindex is -1, the element is not focusable
                if (tabIndexValue === "-1") return false;
                // If tabindex is present and not -1, the element is focusable
                return true;
            }
            // Special cases for elements that are only focusable with certain attributes
            if (tagName === "a") return !!$cd15c0fd04462af9$require$findAttr(node, "href");
            if (tagName === "audio" || tagName === "video") return !!$cd15c0fd04462af9$require$findAttr(node, "controls");
            // Check if element is inherently focusable
            return $cd15c0fd04462af9$var$FOCUSABLE_ELEMENTS.has(tagName);
        }
        return $cd15c0fd04462af9$require$createVisitors(context, {
            Tag (node) {
                const ariaHiddenAttr = $cd15c0fd04462af9$require$findAttr(node, "aria-hidden");
                if (!ariaHiddenAttr?.value) return;
                // Only check for aria-hidden="true"
                if (ariaHiddenAttr.value.value !== "true") return;
                // Check if the element is focusable
                if (isFocusable(node)) context.report({
                    node: ariaHiddenAttr,
                    messageId: $cd15c0fd04462af9$var$MESSAGE_IDS.UNEXPECTED
                });
            }
        });
    }
};


var $7a646d3e0a3caa11$exports = {};
/**
 * @import {
 *   CommentContent,
 *   Text
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 * @typedef {Object} Option
 * @property {number} Option.max
 */ 
var $7a646d3e0a3caa11$require$parseTemplateLiteral = $7038c80d40859759$exports.parseTemplateLiteral;

var $7a646d3e0a3caa11$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $7a646d3e0a3caa11$require$shouldCheckTaggedTemplateExpression = $82257e454733f104$exports.shouldCheckTaggedTemplateExpression;
var $7a646d3e0a3caa11$require$shouldCheckTemplateLiteral = $82257e454733f104$exports.shouldCheckTemplateLiteral;

var $7a646d3e0a3caa11$require$getSourceCode = $2abd6ce2c4a2d841$exports.getSourceCode;

var $7a646d3e0a3caa11$require$codeToLines = $7dabedd289de3a0a$exports.codeToLines;
var $7a646d3e0a3caa11$require$isRangesOverlap = $7dabedd289de3a0a$exports.isRangesOverlap;
var $7a646d3e0a3caa11$require$getTemplateTokens = $7dabedd289de3a0a$exports.getTemplateTokens;

var $7a646d3e0a3caa11$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $7a646d3e0a3caa11$var$MESSAGE_IDS = {
    UNEXPECTED: "unexpected"
};
/** @type {RuleModule<[Option]>} */ $7a646d3e0a3caa11$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow multiple empty lines",
            category: $7a646d3e0a3caa11$require$RULE_CATEGORY.STYLE,
            recommended: false,
            url: $7a646d3e0a3caa11$require$getRuleUrl("no-multiple-empty-lines")
        },
        fixable: "whitespace",
        schema: [
            {
                type: "object",
                properties: {
                    max: {
                        type: "integer",
                        minimum: 0
                    }
                },
                required: [
                    "max"
                ],
                additionalProperties: false
            }
        ],
        messages: {
            [$7a646d3e0a3caa11$var$MESSAGE_IDS.UNEXPECTED]: "More than {{max}} blank lines not allowed."
        }
    },
    create (context) {
        const max = context.options.length ? context.options[0].max : 2;
        const sourceCode = $7a646d3e0a3caa11$require$getSourceCode(context);
        /**
     * @param {string[]} lines
     * @param {number} lineOffset
     * @param {(CommentContent | Text)["parts"][number][]} tokens
     */ function check(lines, lineOffset, tokens) {
            /** @type {number[]} */ const nonEmptyLineNumbers = [];
            lines.forEach((line, index)=>{
                if (line.trim().length > 0) nonEmptyLineNumbers.push(index + lineOffset);
            });
            nonEmptyLineNumbers.forEach((current, index, arr)=>{
                const before = arr[index - 1];
                if (typeof before === "number") {
                    if (current - before - 1 > max) {
                        const start = sourceCode.getIndexFromLoc({
                            line: before + 1,
                            column: 0
                        });
                        const end = sourceCode.getIndexFromLoc({
                            line: current - max,
                            column: 0
                        });
                        if (tokens.some((token)=>$7a646d3e0a3caa11$require$isRangesOverlap(token.range, [
                                start,
                                end
                            ]))) return;
                        context.report({
                            loc: {
                                start: {
                                    line: before,
                                    column: 0
                                },
                                end: {
                                    line: current,
                                    column: 0
                                }
                            },
                            messageId: $7a646d3e0a3caa11$var$MESSAGE_IDS.UNEXPECTED,
                            data: {
                                max: `${max}`
                            },
                            fix (fixer) {
                                return fixer.removeRange([
                                    start,
                                    end
                                ]);
                            }
                        });
                    }
                }
            });
        }
        return {
            "Document:exit" () {
                check(sourceCode.lines, 1, []);
            },
            TaggedTemplateExpression (node) {
                if ($7a646d3e0a3caa11$require$shouldCheckTaggedTemplateExpression(node, context)) {
                    const { html: html, tokens: tokens } = $7a646d3e0a3caa11$require$parseTemplateLiteral(node.quasi, $7a646d3e0a3caa11$require$getSourceCode(context));
                    const lines = $7a646d3e0a3caa11$require$codeToLines(html);
                    check(lines, // @ts-ignore
                    node.quasi.loc.start.line, $7a646d3e0a3caa11$require$getTemplateTokens(tokens));
                }
            },
            TemplateLiteral (node) {
                if ($7a646d3e0a3caa11$require$shouldCheckTemplateLiteral(node, context)) {
                    const { html: html, tokens: tokens } = $7a646d3e0a3caa11$require$parseTemplateLiteral(node, $7a646d3e0a3caa11$require$getSourceCode(context));
                    const lines = $7a646d3e0a3caa11$require$codeToLines(html);
                    check(lines, // @ts-ignore
                    node.loc.start.line, $7a646d3e0a3caa11$require$getTemplateTokens(tokens));
                }
            }
        };
    }
};


var $9fcc77af4fe57f36$exports = {};
/**
 * @import {
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $9fcc77af4fe57f36$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $9fcc77af4fe57f36$require$findAttr = $7dabedd289de3a0a$exports.findAttr;

var $9fcc77af4fe57f36$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $9fcc77af4fe57f36$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $9fcc77af4fe57f36$var$MESSAGE_IDS = {
    UNEXPECTED: "unexpected"
};
/** @type {RuleModule<[]>} */ $9fcc77af4fe57f36$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow use of accesskey attribute",
            category: $9fcc77af4fe57f36$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $9fcc77af4fe57f36$require$getRuleUrl("no-accesskey-attrs")
        },
        fixable: null,
        schema: [],
        messages: {
            [$9fcc77af4fe57f36$var$MESSAGE_IDS.UNEXPECTED]: "Unexpected use of accesskey attribute."
        }
    },
    create (context) {
        /** @param {Tag | ScriptTag | StyleTag} node */ function check(node) {
            const accessKeyAttr = $9fcc77af4fe57f36$require$findAttr(node, "accesskey");
            if (accessKeyAttr) context.report({
                node: accessKeyAttr,
                messageId: $9fcc77af4fe57f36$var$MESSAGE_IDS.UNEXPECTED
            });
        }
        return $9fcc77af4fe57f36$require$createVisitors(context, {
            Tag: check,
            ScriptTag: check,
            StyleTag: check
        });
    }
};


var $7dfb9da6f67a9d43$exports = {};
/**
 * @import {
 *   Attribute,
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 * @typedef {{
 *   tagPatterns: string[];
 *   attrPatterns: string[];
 *   message?: string;
 * }[]} Options
 */ 
var $7dfb9da6f67a9d43$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $7dfb9da6f67a9d43$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $7dfb9da6f67a9d43$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;

var $7dfb9da6f67a9d43$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;
const $7dfb9da6f67a9d43$var$MESSAGE_IDS = {
    RESTRICTED: "restricted"
};
/** @type {RuleModule<Options>} */ $7dfb9da6f67a9d43$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow specified attributes",
            category: $7dfb9da6f67a9d43$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $7dfb9da6f67a9d43$require$getRuleUrl("no-restricted-attrs")
        },
        fixable: null,
        schema: {
            type: "array",
            items: {
                type: "object",
                required: [
                    "tagPatterns",
                    "attrPatterns"
                ],
                properties: {
                    tagPatterns: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    },
                    attrPatterns: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    },
                    message: {
                        type: "string"
                    }
                },
                additionalProperties: false
            }
        },
        messages: {
            [$7dfb9da6f67a9d43$var$MESSAGE_IDS.RESTRICTED]: "'{{attr}}' is restricted from being used."
        }
    },
    create (context) {
        const { options: options } = context;
        const checkers = options.map((option)=>new $7dfb9da6f67a9d43$var$PatternChecker(option));
        /** @param {Tag | StyleTag | ScriptTag} node */ function check(node) {
            const tagName = $7dfb9da6f67a9d43$require$getNameOf(node);
            node.attributes.forEach((attr)=>{
                if (!attr.key?.value) return;
                const matched = checkers.find((checker)=>checker.test(tagName, attr.key.value));
                if (!matched) return;
                /** @type {{ node: Attribute; message: string; messageId?: string }} */ const result = {
                    node: attr,
                    message: ""
                };
                const customMessage = matched.getMessage();
                if (customMessage) result.message = customMessage;
                else result.messageId = $7dfb9da6f67a9d43$var$MESSAGE_IDS.RESTRICTED;
                context.report({
                    ...result,
                    data: {
                        attr: attr.key.value
                    }
                });
            });
        }
        return $7dfb9da6f67a9d43$require$createVisitors(context, {
            Tag: check,
            StyleTag: check,
            ScriptTag: check
        });
    }
};
class $7dfb9da6f67a9d43$var$PatternChecker {
    /** @param {Options[number]} option */ constructor(option){
        this.option = option;
        this.tagRegExps = option.tagPatterns.map((pattern)=>new RegExp(pattern, "u"));
        this.attrRegExps = option.attrPatterns.map((pattern)=>new RegExp(pattern, "u"));
        this.message = option.message;
    }
    /**
   * @param {string} tagName
   * @param {string} attrName
   * @returns {boolean}
   */ test(tagName, attrName) {
        const result = this.tagRegExps.some((exp)=>exp.test(tagName)) && this.attrRegExps.some((exp)=>exp.test(attrName));
        return result;
    }
    /** @returns {string} */ getMessage() {
        return this.message || "";
    }
}


var $ba6b178874b46a0b$exports = {};
/**
 * @import {
 *   CommentContent,
 *   Text
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $ba6b178874b46a0b$require$parseTemplateLiteral = $7038c80d40859759$exports.parseTemplateLiteral;

var $ba6b178874b46a0b$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $ba6b178874b46a0b$require$getTemplateTokens = $7dabedd289de3a0a$exports.getTemplateTokens;
var $ba6b178874b46a0b$require$codeToLines = $7dabedd289de3a0a$exports.codeToLines;
var $ba6b178874b46a0b$require$isRangesOverlap = $7dabedd289de3a0a$exports.isRangesOverlap;

var $ba6b178874b46a0b$require$shouldCheckTaggedTemplateExpression = $82257e454733f104$exports.shouldCheckTaggedTemplateExpression;
var $ba6b178874b46a0b$require$shouldCheckTemplateLiteral = $82257e454733f104$exports.shouldCheckTemplateLiteral;

var $ba6b178874b46a0b$require$getSourceCode = $2abd6ce2c4a2d841$exports.getSourceCode;

var $ba6b178874b46a0b$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $ba6b178874b46a0b$var$MESSAGE_IDS = {
    TRAILING_SPACE: "trailingSpace"
};
/** @type {RuleModule<[]>} */ $ba6b178874b46a0b$exports = {
    meta: {
        type: "layout",
        docs: {
            description: "Disallow trailing whitespace at the end of lines",
            recommended: false,
            category: $ba6b178874b46a0b$require$RULE_CATEGORY.STYLE,
            url: $ba6b178874b46a0b$require$getRuleUrl("no-trailing-spaces")
        },
        fixable: true,
        schema: [],
        messages: {
            [$ba6b178874b46a0b$var$MESSAGE_IDS.TRAILING_SPACE]: "Trailing spaces not allowed"
        }
    },
    create (context) {
        const sourceCode = $ba6b178874b46a0b$require$getSourceCode(context);
        /**
     * @param {string} source
     * @param {string[]} lines
     * @param {Object} offset
     * @param {number} offset.range
     * @param {number} offset.line
     * @param {number} offset.column
     * @param {(CommentContent | Text)["parts"][number][]} tokens
     */ function check(source, lines, offset, tokens) {
            const lineBreaks = source.match(/\r\n|[\r\n\u2028\u2029]/gu);
            lines.forEach((line, index)=>{
                const lineNumber = index + offset.line;
                const match = line.match(/[ \t\u00a0\u2000-\u200b\u3000]+$/);
                const lineBreakLength = lineBreaks?.[index]?.length ?? 1;
                const lineLength = line.length + lineBreakLength;
                const columnOffset = index === 0 ? offset.column : 0;
                if (match) {
                    if (typeof match.index === "number" && match.index > 0) {
                        const loc = {
                            start: {
                                line: lineNumber,
                                column: match.index + columnOffset
                            },
                            end: {
                                line: lineNumber,
                                column: lineLength - lineBreakLength + columnOffset
                            }
                        };
                        const start = sourceCode.getIndexFromLoc(loc.start);
                        const end = sourceCode.getIndexFromLoc(loc.end);
                        if (tokens.some((token)=>$ba6b178874b46a0b$require$isRangesOverlap(token.range, [
                                start,
                                end
                            ]))) return;
                        context.report({
                            messageId: $ba6b178874b46a0b$var$MESSAGE_IDS.TRAILING_SPACE,
                            loc: loc,
                            fix (fixer) {
                                return fixer.removeRange([
                                    start,
                                    end
                                ]);
                            }
                        });
                    }
                }
            });
        }
        return {
            Document () {
                check(sourceCode.getText(), sourceCode.getLines(), {
                    range: 0,
                    line: 1,
                    column: 0
                }, []);
            },
            TaggedTemplateExpression (node) {
                if ($ba6b178874b46a0b$require$shouldCheckTaggedTemplateExpression(node, context)) {
                    const { html: html, tokens: tokens } = $ba6b178874b46a0b$require$parseTemplateLiteral(node.quasi, $ba6b178874b46a0b$require$getSourceCode(context));
                    const lines = $ba6b178874b46a0b$require$codeToLines(html);
                    check(html, lines, {
                        range: node.quasi.range[0] + 1,
                        line: node.quasi.loc.start.line,
                        column: node.quasi.loc.start.column + 1
                    }, $ba6b178874b46a0b$require$getTemplateTokens(tokens));
                }
            },
            TemplateLiteral (node) {
                if ($ba6b178874b46a0b$require$shouldCheckTemplateLiteral(node, context)) {
                    const { html: html, tokens: tokens } = $ba6b178874b46a0b$require$parseTemplateLiteral(node, $ba6b178874b46a0b$require$getSourceCode(context));
                    const lines = $ba6b178874b46a0b$require$codeToLines(html);
                    check(html, lines, {
                        range: node.range[0] + 1,
                        line: node.loc.start.line,
                        column: node.loc.start.column + 1
                    }, $ba6b178874b46a0b$require$getTemplateTokens(tokens));
                }
            }
        };
    }
};


var $502d48dc3bbacb39$exports = {};
/**
 * @import {
 *   Attribute,
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {
 *   ReportFixFunction,
 *   RuleModule
 * } from "../types"
 * @typedef {Object} Option
 * @property {string} tag
 * @property {string} attr
 * @property {string} [value]
 * @property {string} [message]
 */ 
var $502d48dc3bbacb39$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $502d48dc3bbacb39$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $502d48dc3bbacb39$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;

var $502d48dc3bbacb39$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $502d48dc3bbacb39$var$MESSAGE_IDS = {
    MISSING: "missing",
    UNEXPECTED: "unexpected"
};
/** @type {RuleModule<Option[]>} */ $502d48dc3bbacb39$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Require specified attributes",
            category: $502d48dc3bbacb39$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $502d48dc3bbacb39$require$getRuleUrl("require-attrs")
        },
        fixable: "code",
        schema: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    tag: {
                        type: "string"
                    },
                    attr: {
                        type: "string"
                    },
                    value: {
                        type: "string"
                    },
                    message: {
                        type: "string"
                    }
                },
                required: [
                    "tag",
                    "attr"
                ],
                additionalProperties: false
            }
        },
        messages: {
            [$502d48dc3bbacb39$var$MESSAGE_IDS.MISSING]: "Missing '{{attr}}' attribute on '{{tag}}' tag",
            [$502d48dc3bbacb39$var$MESSAGE_IDS.UNEXPECTED]: "Unexpected '{{attr}}' attribute value. '{{expected}}' is expected"
        }
    },
    create (context) {
        /** @type {Option[]} */ const options = context.options || [];
        /**
     * @type {Map<
     *   string,
     *   { tag: string; attr: string; value?: string; message?: string }[]
     * >}
     */ const tagOptionsMap = new Map();
        options.forEach((option)=>{
            const tagName = option.tag.toLowerCase();
            if (tagOptionsMap.has(tagName)) tagOptionsMap.set(tagName, [
                ...tagOptionsMap.get(tagName) || [],
                option
            ]);
            else tagOptionsMap.set(tagName, [
                option
            ]);
        });
        /**
     * @param {StyleTag | ScriptTag | Tag} node
     * @param {string} tagName
     */ function check(node, tagName) {
            const tagOptions = tagOptionsMap.get(tagName) || [];
            const attributes = node.attributes || [];
            tagOptions.forEach((option)=>{
                const attrName = option.attr;
                const attr = attributes.find((attr)=>attr.key?.value === attrName);
                if (!attr) context.report({
                    ...option.message ? {
                        message: option.message
                    } : {
                        messageId: $502d48dc3bbacb39$var$MESSAGE_IDS.MISSING
                    },
                    node: node,
                    data: {
                        attr: attrName,
                        tag: tagName
                    },
                    fix (fixer) {
                        if (!option.value) return null;
                        return fixer.insertTextAfter(node.openStart, ` ${attrName}="${option.value}"`);
                    }
                });
                else if (typeof option.value === "string" && (!attr.value || attr.value.value !== option.value)) context.report({
                    ...option.message ? {
                        message: option.message
                    } : {
                        messageId: $502d48dc3bbacb39$var$MESSAGE_IDS.UNEXPECTED
                    },
                    node: attr,
                    data: {
                        attr: attrName,
                        expected: option.value
                    },
                    fix (fixer) {
                        if (option.value) {
                            if (attr.value) return fixer.replaceText(attr.value, option.value);
                            return fixer.insertTextAfter(attr.key, `="${option.value}"`);
                        }
                        return null;
                    }
                });
            });
        }
        /** @param {StyleTag | ScriptTag} node */ function checkStyleOrScript(node) {
            const tagName = $502d48dc3bbacb39$require$getNameOf(node);
            if (!tagOptionsMap.has(tagName)) return;
            check(node, tagName);
        }
        /** @param {Tag} node */ function checkTag(node) {
            const tagName = $502d48dc3bbacb39$require$getNameOf(node);
            if (!tagOptionsMap.has(tagName)) return;
            check(node, tagName);
        }
        return $502d48dc3bbacb39$require$createVisitors(context, {
            StyleTag: checkStyleOrScript,
            ScriptTag: checkStyleOrScript,
            Tag: checkTag
        });
    }
};


var $8e6b29843b46a31d$exports = {};
/**
 * @import {
 *   Attribute,
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 * @typedef {{
 *   attrPatterns: string[];
 *   attrValuePatterns: string[];
 *   message?: string;
 * }[]} Options
 */ 
var $8e6b29843b46a31d$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $8e6b29843b46a31d$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $8e6b29843b46a31d$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $8e6b29843b46a31d$var$MESSAGE_IDS = {
    RESTRICTED: "restricted"
};
/** @type {RuleModule<Options>} */ $8e6b29843b46a31d$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow specified attributes",
            category: $8e6b29843b46a31d$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $8e6b29843b46a31d$require$getRuleUrl("no-restricted-attr-values")
        },
        fixable: null,
        schema: {
            type: "array",
            items: {
                type: "object",
                required: [
                    "attrPatterns",
                    "attrValuePatterns"
                ],
                properties: {
                    attrPatterns: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    },
                    attrValuePatterns: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    },
                    message: {
                        type: "string"
                    }
                },
                additionalProperties: false
            }
        },
        messages: {
            [$8e6b29843b46a31d$var$MESSAGE_IDS.RESTRICTED]: "'{{attrValuePatterns}}' is restricted from being used."
        }
    },
    create (context) {
        const { options: options } = context;
        const checkers = options.map((option)=>new $8e6b29843b46a31d$var$PatternChecker(option));
        /** @param {Tag | StyleTag | ScriptTag} node */ function check(node) {
            node.attributes.forEach((attr)=>{
                if (!attr.key || !attr.key.value || !attr.value || typeof attr.value.value !== "string") return;
                const matched = checkers.find((checker)=>attr.value && checker.test(attr.key.value, attr.value.value));
                if (!matched) return;
                /** @type {{ node: Attribute; message: string; messageId?: string }} */ const result = {
                    node: attr,
                    message: ""
                };
                const customMessage = matched.getMessage();
                if (customMessage) result.message = customMessage;
                else result.messageId = $8e6b29843b46a31d$var$MESSAGE_IDS.RESTRICTED;
                context.report({
                    ...result,
                    data: {
                        attrValuePatterns: attr.value.value
                    }
                });
            });
        }
        return $8e6b29843b46a31d$require$createVisitors(context, {
            Tag: check,
            StyleTag: check,
            ScriptTag: check
        });
    }
};
class $8e6b29843b46a31d$var$PatternChecker {
    /** @param {Options[number]} option */ constructor(option){
        this.option = option;
        this.attrRegExps = option.attrPatterns.map((pattern)=>new RegExp(pattern, "u"));
        this.valueRegExps = option.attrValuePatterns.map((pattern)=>new RegExp(pattern, "u"));
        this.message = option.message;
    }
    /**
   * @param {string} attrName
   * @param {string} attrValue
   * @returns {boolean}
   */ test(attrName, attrValue) {
        const result = this.attrRegExps.some((exp)=>exp.test(attrName)) && this.valueRegExps.some((exp)=>exp.test(attrValue));
        return result;
    }
    /** @returns {string} */ getMessage() {
        return this.message || "";
    }
}


var $99d51521607c2508$exports = {};
/**
 * @import {
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $99d51521607c2508$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $99d51521607c2508$require$findAttr = $7dabedd289de3a0a$exports.findAttr;

var $99d51521607c2508$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $99d51521607c2508$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $99d51521607c2508$var$MESSAGE_IDS = {
    UNNECESSARY: "unnecessary"
};
/** @type {RuleModule<[]>} */ $99d51521607c2508$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Enforce to omit type attributes for style sheets and scripts",
            category: $99d51521607c2508$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $99d51521607c2508$require$getRuleUrl("no-script-style-type")
        },
        fixable: "code",
        schema: [],
        messages: {
            [$99d51521607c2508$var$MESSAGE_IDS.UNNECESSARY]: "Unnecessary type attributes"
        }
    },
    create (context) {
        /**
     * @param {ScriptTag | Tag | StyleTag} node
     * @param {string} unnecessaryValue
     */ function check(node, unnecessaryValue) {
            const type = $99d51521607c2508$require$findAttr(node, "type");
            if (type?.value?.value?.trim().toLocaleLowerCase() === unnecessaryValue) context.report({
                node: type,
                messageId: $99d51521607c2508$var$MESSAGE_IDS.UNNECESSARY,
                fix (fixer) {
                    return fixer.remove(type);
                }
            });
        }
        return $99d51521607c2508$require$createVisitors(context, {
            ScriptTag (node) {
                check(node, "text/javascript");
            },
            StyleTag (node) {
                check(node, "text/css");
            },
            Tag (node) {
                if (node.name === "link") {
                    const rel = $99d51521607c2508$require$findAttr(node, "rel");
                    if (rel?.value?.value === "stylesheet") check(node, "text/css");
                }
            }
        });
    }
};


var $7df1ae7270c3035f$exports = {};
/**
 * @import {
 *   Doctype,
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $7df1ae7270c3035f$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;
var $080ef9ed5fcac630$exports = {};
$080ef9ed5fcac630$exports = [
    "allowReorder",
    "attributeName",
    "attributeType",
    "autoReverse",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPath",
    "clipPathUnits",
    "contentScriptType",
    "contentStyleType",
    "diffuseConstant",
    "edgeMode",
    "externalResourcesRequired",
    "filterRes",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyUp",
    "onLoad",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
];



var $7df1ae7270c3035f$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $7df1ae7270c3035f$require$hasTemplate = $7dabedd289de3a0a$exports.hasTemplate;
var $7df1ae7270c3035f$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;

var $7df1ae7270c3035f$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $7df1ae7270c3035f$var$MESSAGE_IDS = {
    UNEXPECTED: "unexpected"
};
/** @type {RuleModule<[]>} */ $7df1ae7270c3035f$exports = {
    meta: {
        type: "suggestion",
        docs: {
            description: "Enforce use of lowercase for tag and attribute names.",
            category: $7df1ae7270c3035f$require$RULE_CATEGORY.STYLE,
            recommended: false,
            url: $7df1ae7270c3035f$require$getRuleUrl("lowercase")
        },
        fixable: "code",
        schema: [],
        messages: {
            [$7df1ae7270c3035f$var$MESSAGE_IDS.UNEXPECTED]: "'{{name}}' is not in lowercase."
        }
    },
    create (context) {
        const allowedAttrKeySet = new Set($080ef9ed5fcac630$exports);
        /** @type {Tag[]} */ const svgStack = [];
        /** @param {Tag} node */ function enterSvg(node) {
            svgStack.push(node);
        }
        function exitSvg() {
            svgStack.pop();
        }
        /**
     * @param {string} key
     * @returns {boolean}
     */ function isAllowedAttributeKey(key) {
            return !!svgStack.length && allowedAttrKeySet.has(key);
        }
        /** @param {Tag | StyleTag | ScriptTag} node */ function check(node) {
            const raw = node.openStart.value.slice(1);
            const name = $7df1ae7270c3035f$require$getNameOf(node);
            if (name !== raw && (svgStack.length === 0 || name.toLowerCase() === "svg")) context.report({
                node: node.openStart,
                messageId: $7df1ae7270c3035f$var$MESSAGE_IDS.UNEXPECTED,
                data: {
                    name: raw
                },
                fix (fixer) {
                    const fixes = [
                        fixer.replaceTextRange(node.openStart.range, `<${name}`)
                    ];
                    if (node.close) fixes.push(fixer.replaceTextRange(node.close.range, `</${name}>`));
                    return fixes;
                }
            });
            if (node.attributes?.length) node.attributes.forEach((attribute)=>{
                if (isAllowedAttributeKey(attribute.key.value)) return;
                if ($7df1ae7270c3035f$require$hasTemplate(attribute.key)) return;
                if (attribute.key.value !== attribute.key.value.toLowerCase()) context.report({
                    node: attribute.key,
                    messageId: $7df1ae7270c3035f$var$MESSAGE_IDS.UNEXPECTED,
                    data: {
                        name: attribute.key.value
                    },
                    fix (fixer) {
                        return fixer.replaceText(attribute.key, attribute.key.value.toLowerCase());
                    }
                });
            });
        }
        /** @param {Doctype} doctype */ function checkDoctype(doctype) {
            if (doctype.open.value !== doctype.open.value.toLowerCase()) context.report({
                node: doctype.open,
                messageId: $7df1ae7270c3035f$var$MESSAGE_IDS.UNEXPECTED,
                data: {
                    name: doctype.open.value.slice(1)
                },
                fix (fixer) {
                    return fixer.replaceTextRange(doctype.open.range, "<!doctype");
                }
            });
            if (doctype.attributes?.length) doctype.attributes.forEach((attribute)=>{
                if (attribute.value && attribute.value.value !== attribute.value.value.toLowerCase()) context.report({
                    node: attribute.value,
                    messageId: $7df1ae7270c3035f$var$MESSAGE_IDS.UNEXPECTED,
                    data: {
                        name: attribute.value.value
                    },
                    fix (fixer) {
                        return fixer.replaceText(// @ts-ignore
                        attribute.value, // @ts-ignore
                        attribute.value.value.toLowerCase());
                    }
                });
            });
        }
        return $7df1ae7270c3035f$require$createVisitors(context, {
            Tag (node) {
                if (node.name.toLocaleLowerCase() === "svg") enterSvg(node);
                check(node);
            },
            "Tag:exit" (node) {
                if (node.name.toLocaleLowerCase() === "svg") exitSvg();
            },
            StyleTag: check,
            ScriptTag: check,
            Doctype: checkDoctype
        });
    }
};


var $31cd1f9fa66895a9$exports = {};
/**
 * @import {
 *   AnyNode,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 * @typedef {string[]} Option
 */ 
var $31cd1f9fa66895a9$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $31cd1f9fa66895a9$require$filter = $c7fec554e020284f$exports.filter;

var $31cd1f9fa66895a9$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $31cd1f9fa66895a9$require$isTag = $7dabedd289de3a0a$exports.isTag;

var $31cd1f9fa66895a9$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $31cd1f9fa66895a9$var$MESSAGE_IDS = {
    MISSING: "missing",
    EMPTY: "empty"
};
const $31cd1f9fa66895a9$var$DEFAULT_REQUIRED_PROPERTIES = [
    "og:title",
    "og:type",
    "og:url",
    "og:image"
];
/**
 * @param {string[]} properties
 * @returns {string[]}
 */ function $31cd1f9fa66895a9$var$normalize(properties) {
    return properties.map((prop)=>{
        if (prop.indexOf("og:") === 0) return prop;
        return `og:${prop}`;
    });
}
/** @type {RuleModule<[Option]>} */ $31cd1f9fa66895a9$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Enforce use of specified meta tags for open graph protocol.",
            category: $31cd1f9fa66895a9$require$RULE_CATEGORY.SEO,
            recommended: false,
            url: $31cd1f9fa66895a9$require$getRuleUrl("require-open-graph-protocol")
        },
        fixable: null,
        schema: [
            {
                type: "array",
                items: {
                    type: "string"
                },
                uniqueItems: true
            }
        ],
        messages: {
            [$31cd1f9fa66895a9$var$MESSAGE_IDS.MISSING]: "Require use of meta tags for OGP. ({{properties}})",
            [$31cd1f9fa66895a9$var$MESSAGE_IDS.EMPTY]: "Unexpected empty 'content' attribute"
        }
    },
    create (context) {
        /** @type {string[]} */ const requiredProperties = $31cd1f9fa66895a9$var$normalize(context.options && context.options[0] || $31cd1f9fa66895a9$var$DEFAULT_REQUIRED_PROPERTIES);
        /**
     * @param {AnyNode} node
     * @returns {node is Tag}
     */ function isOgpMeta(node) {
            const isMeta = $31cd1f9fa66895a9$require$isTag(node) && node.name === "meta";
            const property = isMeta ? $31cd1f9fa66895a9$require$findAttr(node, "property") : undefined;
            const hasOgProperty = property?.value?.value?.indexOf("og:") === 0;
            return hasOgProperty;
        }
        return {
            Tag (node) {
                if (node.name !== "head") return;
                const { children: children } = node;
                const metaTags = $31cd1f9fa66895a9$require$filter(children, isOgpMeta);
                const missingProperties = requiredProperties.filter((required)=>{
                    return !metaTags.some((meta)=>{
                        const property = $31cd1f9fa66895a9$require$findAttr(meta, "property");
                        if (property?.value) return property.value.value === required;
                        return false;
                    });
                });
                const emptyContentMetaTags = metaTags.filter((meta)=>{
                    const property = $31cd1f9fa66895a9$require$findAttr(meta, "property");
                    if (property?.value && requiredProperties.includes(property.value.value)) {
                        const content = $31cd1f9fa66895a9$require$findAttr(meta, "content");
                        return !content?.value?.value;
                    }
                    return false;
                });
                if (missingProperties.length) context.report({
                    node: node.openStart,
                    data: {
                        properties: missingProperties.join(", ")
                    },
                    messageId: $31cd1f9fa66895a9$var$MESSAGE_IDS.MISSING
                });
                if (emptyContentMetaTags.length) emptyContentMetaTags.forEach((meta)=>{
                    const content = $31cd1f9fa66895a9$require$findAttr(meta, "content");
                    context.report({
                        node: content || meta,
                        messageId: $31cd1f9fa66895a9$var$MESSAGE_IDS.EMPTY
                    });
                });
            }
        };
    }
};


var $6b63449bdb2cfeb6$exports = {};
/**
 * @import {Attribute} from "@html-eslint/types"
 * @import {
 *   RuleFixer,
 *   RuleModule
 * } from "../types"
 * @typedef {Object} Option
 * @property {(string | { pattern: string })[]} [Option.priority]
 */ 
var $6b63449bdb2cfeb6$require$hasTemplate = $7dabedd289de3a0a$exports.hasTemplate;

var $6b63449bdb2cfeb6$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $6b63449bdb2cfeb6$require$getSourceCode = $2abd6ce2c4a2d841$exports.getSourceCode;

var $6b63449bdb2cfeb6$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $6b63449bdb2cfeb6$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $6b63449bdb2cfeb6$var$MESSAGE_IDS = {
    UNSORTED: "unsorted"
};
/** @type {RuleModule<[Option]>} */ $6b63449bdb2cfeb6$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Enforce priority and alphabetical sorting of attributes",
            category: $6b63449bdb2cfeb6$require$RULE_CATEGORY.STYLE,
            recommended: false,
            url: $6b63449bdb2cfeb6$require$getRuleUrl("sort-attrs")
        },
        fixable: "code",
        schema: [
            {
                type: "object",
                properties: {
                    priority: {
                        type: "array",
                        items: {
                            oneOf: [
                                {
                                    type: "string"
                                },
                                {
                                    type: "object",
                                    properties: {
                                        pattern: {
                                            type: "string"
                                        }
                                    },
                                    required: [
                                        "pattern"
                                    ],
                                    additionalProperties: false
                                }
                            ]
                        },
                        uniqueItems: true
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$6b63449bdb2cfeb6$var$MESSAGE_IDS.UNSORTED]: "Attributes should be sorted by priority and alphabetically"
        }
    },
    create (context) {
        const sourceCode = $6b63449bdb2cfeb6$require$getSourceCode(context);
        const option = context.options[0] || {
            priority: [
                "id",
                "type",
                "class",
                "style"
            ]
        };
        /** @type {(string | { pattern: string; regex: RegExp })[]} */ const priority = (option.priority || []).map((item)=>{
            if (item && typeof item === "object" && "pattern" in item) return {
                ...item,
                regex: new RegExp(item.pattern, "u")
            };
            return item;
        });
        /**
     * @param {string} attrName
     * @param {string | { pattern: string; regex: RegExp }} priorityItem
     * @returns {boolean}
     */ function matchesPriority(attrName, priorityItem) {
            if (typeof priorityItem === "string") return attrName === priorityItem;
            if (priorityItem && typeof priorityItem === "object" && priorityItem.regex) return priorityItem.regex.test(attrName);
            return false;
        }
        /**
     * @param {string} attrName
     * @returns {number}
     */ function getPriorityIndex(attrName) {
            for(let i = 0; i < priority.length; i++){
                if (matchesPriority(attrName, priority[i])) return i;
            }
            return -1;
        }
        /**
     * @param {Attribute} attrA
     * @param {Attribute} attrB
     * @returns {number}
     */ function compare(attrA, attrB) {
            const keyA = attrA.key.value;
            const keyB = attrB.key.value;
            const keyAReservedValue = getPriorityIndex(keyA);
            const keyBReservedValue = getPriorityIndex(keyB);
            if (keyAReservedValue >= 0 && keyBReservedValue >= 0) return keyAReservedValue - keyBReservedValue;
            else if (keyAReservedValue >= 0) return -1;
            else if (keyBReservedValue >= 0) return 1;
            return keyA.localeCompare(keyB);
        }
        /**
     * @param {string} source
     * @param {Attribute[]} unsorted
     * @param {Attribute[]} sorted
     * @returns {string}
     */ function getSortedCode(source, unsorted, sorted) {
            let result = "";
            unsorted.forEach((unsortedAttr, index)=>{
                const sortedAttr = sorted[index];
                result += source.slice(sortedAttr.range[0], sortedAttr.range[1]);
                const nextUnsortedAttr = unsorted[index + 1];
                if (nextUnsortedAttr) result += source.slice(unsortedAttr.range[1], nextUnsortedAttr.range[0]);
            });
            return result;
        }
        /**
     * @param {RuleFixer} fixer
     * @param {Attribute[]} unsorted
     * @param {Attribute[]} sorted
     */ function fix(fixer, unsorted, sorted) {
            const source = sourceCode.getText();
            return fixer.replaceTextRange([
                unsorted[0].range[0],
                unsorted[unsorted.length - 1].range[1]
            ], getSortedCode(source, unsorted, sorted));
        }
        /**
     * @param {Attribute[]} before
     * @param {Attribute[]} after
     * @returns {boolean}
     */ function isChanged(before, after) {
            for(let i = 0; i < before.length; i++){
                if (before[i] !== after[i]) return true;
            }
            return false;
        }
        /**
     * @param {Attribute[]} attributes
     * @returns {Attribute[][]}
     */ function groupAttributes(attributes) {
            /** @type {Attribute[][]} */ const attributesList = [];
            let index = 0;
            for (const attribute of attributes){
                if ($6b63449bdb2cfeb6$require$hasTemplate(attribute.key)) {
                    index = attributesList.length;
                    continue;
                }
                if (!attributesList[index]) attributesList[index] = [];
                attributesList[index].push(attribute);
            }
            return attributesList;
        }
        /** @param {Attribute[]} unsorted */ function checkSorting(unsorted) {
            if (unsorted.length <= 1) return;
            const grouped = groupAttributes(unsorted);
            grouped.forEach((unsorted)=>{
                const sorted = [
                    ...unsorted
                ].sort(compare);
                if (!isChanged(unsorted, sorted)) return;
                const first = unsorted[0];
                const last = unsorted[unsorted.length - 1];
                context.report({
                    loc: {
                        start: first.loc.start,
                        end: last.loc.end
                    },
                    messageId: $6b63449bdb2cfeb6$var$MESSAGE_IDS.UNSORTED,
                    fix (fixer) {
                        return fix(fixer, unsorted, sorted);
                    }
                });
            });
        }
        return $6b63449bdb2cfeb6$require$createVisitors(context, {
            ScriptTag (node) {
                checkSorting(node.attributes);
            },
            Tag (node) {
                checkSorting(node.attributes);
            },
            StyleTag (node) {
                checkSorting(node.attributes);
            }
        });
    }
};


var $c8d54b951b835b60$exports = {};
/**
 * @import {
 *   Attribute,
 *   AttributeValue,
 *   ScriptTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $c8d54b951b835b60$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $c8d54b951b835b60$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $c8d54b951b835b60$require$isScript = $7dabedd289de3a0a$exports.isScript;
var $c8d54b951b835b60$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;

var $c8d54b951b835b60$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $c8d54b951b835b60$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $c8d54b951b835b60$var$MESSAGE_IDS = {
    UNEXPECTED: "unexpected"
};
/** @param {string} url */ function $c8d54b951b835b60$var$getProtocol(url) {
    try {
        return new URL(url).protocol;
    // eslint-disable-next-line no-unused-vars
    } catch (_) {
        return null;
    }
}
/**
 * @param {Tag | ScriptTag} node
 * @returns {AttributeValue | undefined}
 */ function $c8d54b951b835b60$var$getResourceAttributeValue(node) {
    /** @type {Attribute | undefined} */ let attribute;
    if ($c8d54b951b835b60$require$isScript(node)) attribute = $c8d54b951b835b60$require$findAttr(node, "src");
    else switch($c8d54b951b835b60$require$getNameOf(node)){
        case "img":
        case "iframe":
        case "audio":
        case "video":
        case "source":
        case "embed":
            attribute = $c8d54b951b835b60$require$findAttr(node, "src");
            break;
        case "link":
            attribute = $c8d54b951b835b60$require$findAttr(node, "href");
            break;
        case "object":
            attribute = $c8d54b951b835b60$require$findAttr(node, "data");
            break;
    }
    if (attribute) return attribute.value;
    return undefined;
}
/** @type {RuleModule<[]>} */ $c8d54b951b835b60$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Prefer to use HTTPS for embedded resources",
            recommended: false,
            category: $c8d54b951b835b60$require$RULE_CATEGORY.BEST_PRACTICE,
            url: $c8d54b951b835b60$require$getRuleUrl("prefer-https")
        },
        fixable: false,
        schema: [],
        messages: {
            [$c8d54b951b835b60$var$MESSAGE_IDS.UNEXPECTED]: "Unexpected use 'HTTP' protocol."
        }
    },
    create (context) {
        /** @param {Tag | ScriptTag} node */ function check(node) {
            const attributeValue = $c8d54b951b835b60$var$getResourceAttributeValue(node);
            if (attributeValue && !attributeValue.parts.length) {
                const protocol = $c8d54b951b835b60$var$getProtocol(attributeValue.value);
                if (protocol === "http:") context.report({
                    node: attributeValue,
                    messageId: $c8d54b951b835b60$var$MESSAGE_IDS.UNEXPECTED
                });
            }
        }
        return $c8d54b951b835b60$require$createVisitors(context, {
            ScriptTag: check,
            Tag: check
        });
    }
};


var $4681833c1379aefb$exports = {};
/**
 * @import {Tag} from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $4681833c1379aefb$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $4681833c1379aefb$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $4681833c1379aefb$require$findParent = $7dabedd289de3a0a$exports.findParent;
var $4681833c1379aefb$require$isTag = $7dabedd289de3a0a$exports.isTag;
var $4681833c1379aefb$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;

var $4681833c1379aefb$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $4681833c1379aefb$var$MESSAGE_IDS = {
    MISSING: "missingLabel"
};
const $4681833c1379aefb$var$INPUT_TAGS = new Set([
    "input",
    "textarea",
    "select"
]);
const $4681833c1379aefb$var$LABEL_ATTRIBUTES = new Set([
    "id",
    "aria-labelledby",
    "aria-label"
]);
/** @type {RuleModule<[]>} */ $4681833c1379aefb$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Enforces use of label for form elements(`input`, `textarea`, `select`)",
            category: $4681833c1379aefb$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $4681833c1379aefb$require$getRuleUrl("require-input-label")
        },
        fixable: null,
        schema: [],
        messages: {
            [$4681833c1379aefb$var$MESSAGE_IDS.MISSING]: "Missing an associated label"
        }
    },
    create (context) {
        return $4681833c1379aefb$require$createVisitors(context, {
            Tag (node) {
                if (!$4681833c1379aefb$var$INPUT_TAGS.has($4681833c1379aefb$require$getNameOf(node))) return;
                for (const attr of node.attributes){
                    if ($4681833c1379aefb$var$LABEL_ATTRIBUTES.has(attr.key.value.toLowerCase()) && attr.value?.value) return;
                    if (attr.key.value.toLowerCase() === "type" && attr.value?.value === "hidden") return;
                }
                const label = $4681833c1379aefb$require$findParent(node, (parent)=>{
                    return $4681833c1379aefb$require$isTag(parent) && $4681833c1379aefb$require$getNameOf(parent) === "label";
                });
                if (label) return;
                context.report({
                    node: node,
                    messageId: "missingLabel"
                });
            }
        });
    }
};


var $2f3571cf8f9af717$exports = {};
/** @import {RuleModule} from "../types" */ 
var $2f3571cf8f9af717$require$NODE_TYPES = $f03705736c6cdfcd$exports.NODE_TYPES;

var $2f3571cf8f9af717$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $2f3571cf8f9af717$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $2f3571cf8f9af717$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;

var $2f3571cf8f9af717$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $2f3571cf8f9af717$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $2f3571cf8f9af717$var$MESSAGE_IDS = {
    MISSING: "missing",
    MISSING_VALUE: "missingValue",
    UNEXPECTED: "unexpected"
};
const $2f3571cf8f9af717$var$ALLOWED_METHODS = new Set([
    "GET",
    "POST",
    "DIALOG"
]);
/** @type {RuleModule<[]>} */ $2f3571cf8f9af717$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Require `method` attribute in `<form>`",
            category: $2f3571cf8f9af717$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $2f3571cf8f9af717$require$getRuleUrl("require-form-method")
        },
        fixable: false,
        schema: [],
        messages: {
            [$2f3571cf8f9af717$var$MESSAGE_IDS.MISSING]: "The 'method' attribute is missing on the <form>.",
            [$2f3571cf8f9af717$var$MESSAGE_IDS.MISSING_VALUE]: "The 'method' attribute value is missing on the <form>",
            [$2f3571cf8f9af717$var$MESSAGE_IDS.UNEXPECTED]: "The 'method' attribute has an invalid value on the <form>."
        }
    },
    create (context) {
        return $2f3571cf8f9af717$require$createVisitors(context, {
            Tag (node) {
                if ($2f3571cf8f9af717$require$getNameOf(node) !== "form") return;
                const method = $2f3571cf8f9af717$require$findAttr(node, "method");
                if (!method) {
                    context.report({
                        node: node.openStart,
                        messageId: $2f3571cf8f9af717$var$MESSAGE_IDS.MISSING
                    });
                    return;
                }
                if (!method.value) {
                    context.report({
                        node: node.openStart,
                        messageId: $2f3571cf8f9af717$var$MESSAGE_IDS.MISSING_VALUE
                    });
                    return;
                }
                if (method.value.parts?.some((part)=>part.type !== $2f3571cf8f9af717$require$NODE_TYPES.Part)) return;
                if (!$2f3571cf8f9af717$var$ALLOWED_METHODS.has(method.value.value.toUpperCase())) context.report({
                    node: node.openStart,
                    messageId: $2f3571cf8f9af717$var$MESSAGE_IDS.UNEXPECTED
                });
            }
        });
    }
};


var $580d8e9970f85f14$exports = {};
/** @import {RuleModule} from "../types" */ 
var $580d8e9970f85f14$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $580d8e9970f85f14$require$findParent = $7dabedd289de3a0a$exports.findParent;
var $580d8e9970f85f14$require$isTag = $7dabedd289de3a0a$exports.isTag;
var $580d8e9970f85f14$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;

var $580d8e9970f85f14$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $580d8e9970f85f14$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $580d8e9970f85f14$var$MESSAGE_IDS = {
    UNEXPECTED: "unexpected"
};
const $580d8e9970f85f14$var$HEADING_NAMES = new Set([
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
]);
/** @type {RuleModule<[]>} */ $580d8e9970f85f14$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallows the use of heading elements inside <button>.",
            category: $580d8e9970f85f14$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $580d8e9970f85f14$require$getRuleUrl("no-heading-inside-button")
        },
        fixable: null,
        schema: [],
        messages: {
            [$580d8e9970f85f14$var$MESSAGE_IDS.UNEXPECTED]: "Unexpected heading inside button"
        }
    },
    create (context) {
        return $580d8e9970f85f14$require$createVisitors(context, {
            Tag (node) {
                if (!$580d8e9970f85f14$var$HEADING_NAMES.has($580d8e9970f85f14$require$getNameOf(node))) return;
                const button = $580d8e9970f85f14$require$findParent(node, (parent)=>$580d8e9970f85f14$require$isTag(parent) && $580d8e9970f85f14$require$getNameOf(parent) === "button");
                if (button) context.report({
                    node: node,
                    messageId: $580d8e9970f85f14$var$MESSAGE_IDS.UNEXPECTED
                });
            }
        });
    }
};


var $f5b59aba1c30a844$exports = {};
/** @import {RuleModule} from "../types" */ 
var $f5b59aba1c30a844$require$NODE_TYPES = $f03705736c6cdfcd$exports.NODE_TYPES;

var $f5b59aba1c30a844$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $f5b59aba1c30a844$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $f5b59aba1c30a844$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;

var $f5b59aba1c30a844$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $f5b59aba1c30a844$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $f5b59aba1c30a844$var$MESSAGE_IDS = {
    INVALID: "invalid",
    INVALID_PRESENTATION: "invalidPresentation"
};
/**
 * Elements and role attribute constants are taken from ember-template-lint.
 * https://github.com/ember-template-lint/ember-template-lint/blob/master/lib/rules/no-invalid-role.js
 */ // https://www.w3.org/TR/wai-aria/#document_structure_roles
const $f5b59aba1c30a844$var$DOCUMENT_STRUCTURE_ROLES = new Set([
    "application",
    "article",
    "associationlist",
    "associationlistitemkey",
    "associationlistitemvalue",
    "blockquote",
    "caption",
    "cell",
    "code",
    "columnheader",
    "comment",
    "definition",
    "deletion",
    "directory",
    "document",
    "emphasis",
    "feed",
    "figure",
    "generic",
    "group",
    "heading",
    "img",
    "insertion",
    "list",
    "listitem",
    "mark",
    "math",
    "meter",
    "none",
    "note",
    "paragraph",
    "presentation",
    "row",
    "rowgroup",
    "rowheader",
    "separator",
    "strong",
    "subscript",
    "suggestion",
    "superscript",
    "table",
    "term",
    "time",
    "toolbar",
    "tooltip"
]);
// https://www.w3.org/TR/wai-aria/#widget_roles
const $f5b59aba1c30a844$var$WIDGET_ROLES = new Set([
    "button",
    "checkbox",
    "gridcell",
    "link",
    "menuitem",
    "menuitemcheckbox",
    "menuitemradio",
    "option",
    "progressbar",
    "radio",
    "scrollbar",
    "searchbox",
    "separator",
    "slider",
    "spinbutton",
    "switch",
    "tab",
    "tabpanel",
    "textbox",
    "treeitem"
]);
const $f5b59aba1c30a844$var$COMPOSITE_WIDGET_ROLES = new Set([
    "combobox",
    "grid",
    "listbox",
    "menu",
    "menubar",
    "radiogroup",
    "tablist",
    "tree",
    "treegrid"
]);
// https://www.w3.org/TR/wai-aria/#landmark_roles
const $f5b59aba1c30a844$var$LANDMARK_ROLES = new Set([
    "banner",
    "complementary",
    "contentinfo",
    "form",
    "main",
    "navigation",
    "region",
    "search"
]);
// https://www.w3.org/TR/wai-aria/#live_region_roles
const $f5b59aba1c30a844$var$LIVE_REGION_ROLES = new Set([
    "alert",
    "log",
    "marquee",
    "status",
    "timer"
]);
// https://www.w3.org/TR/wai-aria/#window_roles
const $f5b59aba1c30a844$var$WINDOW_ROLES = new Set([
    "alertdialog",
    "dialog"
]);
const $f5b59aba1c30a844$var$ALL_ROLES = new Set([
    ...$f5b59aba1c30a844$var$DOCUMENT_STRUCTURE_ROLES,
    ...$f5b59aba1c30a844$var$WIDGET_ROLES,
    ...$f5b59aba1c30a844$var$COMPOSITE_WIDGET_ROLES,
    ...$f5b59aba1c30a844$var$LANDMARK_ROLES,
    ...$f5b59aba1c30a844$var$LIVE_REGION_ROLES,
    ...$f5b59aba1c30a844$var$WINDOW_ROLES
]);
const $f5b59aba1c30a844$var$ELEMENTS_DISALLOWING_PRESENTATION_OR_NONE_ROLE = new Set([
    "a",
    "abbr",
    "applet",
    "area",
    "audio",
    "b",
    "bdi",
    "bdo",
    "blockquote",
    "br",
    "button",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "dir",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "form",
    "hr",
    "i",
    "iframe",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meter",
    "noembed",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "pre",
    "progress",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "select",
    "small",
    "source",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "tt",
    "u",
    "ul",
    "var",
    "video",
    "wbr"
]);
/** @type {RuleModule<[]>} */ $f5b59aba1c30a844$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallows use of invalid role.",
            category: $f5b59aba1c30a844$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $f5b59aba1c30a844$require$getRuleUrl("no-invalid-role")
        },
        fixable: null,
        schema: [],
        messages: {
            [$f5b59aba1c30a844$var$MESSAGE_IDS.INVALID]: "Unexpected use of invalid role '{{role}}'",
            [$f5b59aba1c30a844$var$MESSAGE_IDS.INVALID_PRESENTATION]: "Unexpected use of presentation role on <{{element}}>"
        }
    },
    create (context) {
        return $f5b59aba1c30a844$require$createVisitors(context, {
            Tag (node) {
                const role = $f5b59aba1c30a844$require$findAttr(node, "role");
                if (!role) return;
                /** Allow template expression. ex: html`<div role=${role}></div>` */ if (role.value?.parts.some((part)=>part.type === $f5b59aba1c30a844$require$NODE_TYPES.Template)) return;
                const roleValue = (role.value?.value || "").toLowerCase();
                if ((roleValue === "presentation" || roleValue === "none") && $f5b59aba1c30a844$var$ELEMENTS_DISALLOWING_PRESENTATION_OR_NONE_ROLE.has($f5b59aba1c30a844$require$getNameOf(node))) context.report({
                    node: role,
                    messageId: $f5b59aba1c30a844$var$MESSAGE_IDS.INVALID_PRESENTATION,
                    data: {
                        element: node.name
                    }
                });
                if (!$f5b59aba1c30a844$var$ALL_ROLES.has(roleValue)) context.report({
                    node: role,
                    messageId: $f5b59aba1c30a844$var$MESSAGE_IDS.INVALID,
                    data: {
                        role: roleValue
                    }
                });
            }
        });
    }
};


var $1ed0708197baff6b$exports = {};
/**
 * @import {Tag} from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $1ed0708197baff6b$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $1ed0708197baff6b$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $1ed0708197baff6b$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;

var $1ed0708197baff6b$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $1ed0708197baff6b$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $1ed0708197baff6b$var$MESSAGE_IDS = {
    UNEXPECTED: "unexpected"
};
/**
 * @param {Tag} tag
 * @returns {boolean}
 * @see https://html.spec.whatwg.org/multipage/dom.html#interactive-content-2
 */ function $1ed0708197baff6b$var$isInteractive(tag) {
    const tagName = $1ed0708197baff6b$require$getNameOf(tag);
    switch(tagName){
        // a (if the href attribute is present)
        case "a":
            return !!$1ed0708197baff6b$require$findAttr(tag, "href");
        // audio (if the controls attribute is present)
        // video (if the controls attribute is present)
        case "audio":
        case "video":
            return !!$1ed0708197baff6b$require$findAttr(tag, "controls");
        // img (if the usemap attribute is present)
        case "img":
            return !!$1ed0708197baff6b$require$findAttr(tag, "usemap");
        // input (if the type attribute is not in the Hidden state)
        case "input":
            {
                const typeAttr = $1ed0708197baff6b$require$findAttr(tag, "type");
                return typeAttr?.value?.value !== "hidden";
            }
        // case "details": see https://github.com/yeonjuan/html-eslint/issues/518
        case "summary":
        case "button":
        case "embed":
        case "iframe":
        case "label":
        case "select":
        case "textarea":
            return true;
        default:
            return false;
    }
}
/** @type {RuleModule<[]>} */ $1ed0708197baff6b$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallows nested interactive elements",
            category: $1ed0708197baff6b$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $1ed0708197baff6b$require$getRuleUrl("no-nested-interactive")
        },
        fixable: null,
        schema: [],
        messages: {
            [$1ed0708197baff6b$var$MESSAGE_IDS.UNEXPECTED]: "Unexpected interactive elements nested (parent interactive: <{{tag}}>)"
        }
    },
    create (context) {
        /** @type {Tag[]} */ let interactiveStack = [];
        return $1ed0708197baff6b$require$createVisitors(context, {
            Document () {
                interactiveStack = [];
            },
            Tag (node) {
                if (!$1ed0708197baff6b$var$isInteractive(node)) return;
                if (interactiveStack.length) {
                    if (interactiveStack.length === 1) {
                        const parentLabel = interactiveStack.find((tag)=>$1ed0708197baff6b$require$getNameOf(tag) === "label");
                        if (parentLabel && $1ed0708197baff6b$require$getNameOf(node) !== "label") return;
                    }
                    context.report({
                        node: node,
                        messageId: $1ed0708197baff6b$var$MESSAGE_IDS.UNEXPECTED,
                        data: {
                            tag: interactiveStack[interactiveStack.length - 1].name
                        }
                    });
                }
                interactiveStack.push(node);
            },
            "Tag:exit" (node) {
                if (interactiveStack[interactiveStack.length - 1] === node) interactiveStack.pop();
            }
        });
    }
};


var $eeb7c6826caeaea6$exports = {};
/**
 * @import {
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 * @typedef {Object} Option
 * @property {number} [Option.max]
 */ 
var $eeb7c6826caeaea6$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $eeb7c6826caeaea6$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $eeb7c6826caeaea6$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $eeb7c6826caeaea6$var$MESSAGE_IDS = {
    MAX_DEPTH_EXCEEDED: "maxDepthExceeded"
};
/** @type {RuleModule<[Option]>} */ $eeb7c6826caeaea6$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Enforce maximum element depth",
            category: $eeb7c6826caeaea6$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $eeb7c6826caeaea6$require$getRuleUrl("max-element-depth")
        },
        fixable: null,
        schema: [
            {
                type: "object",
                properties: {
                    max: {
                        type: "integer",
                        minimum: 1,
                        default: 32
                    }
                },
                required: [
                    "max"
                ],
                additionalProperties: false
            }
        ],
        messages: {
            [$eeb7c6826caeaea6$var$MESSAGE_IDS.MAX_DEPTH_EXCEEDED]: "Expected the depth of nested elements to be <= {{needed}}, but found {{found}}"
        }
    },
    create (context) {
        const maxDepth = typeof context.options?.[0]?.max === "number" ? context.options[0].max : 32;
        let depth = 0;
        function resetDepth() {
            depth = 0;
        }
        /** @param {Tag | ScriptTag | StyleTag} node */ function increaseDepth(node) {
            depth++;
            if (depth > maxDepth) context.report({
                node: node,
                messageId: $eeb7c6826caeaea6$var$MESSAGE_IDS.MAX_DEPTH_EXCEEDED,
                data: {
                    needed: `${maxDepth}`,
                    found: String(depth)
                }
            });
        }
        function decreaseDepth() {
            depth--;
        }
        return $eeb7c6826caeaea6$require$createVisitors(context, {
            Document: resetDepth,
            "Document:exit": resetDepth,
            Tag: increaseDepth,
            "Tag:exit": decreaseDepth,
            ScriptTag: increaseDepth,
            "ScriptTag:exit": decreaseDepth,
            StyleTag: increaseDepth,
            "StyleTag:exit": decreaseDepth
        });
    }
};


var $a338db40692f7a39$exports = {};
/**
 * @import {RuleModule} from "../types"
 * @typedef {Object} Option
 * @property {string[]} [Option.allowClass]
 * @property {string[]} [Option.allowId]
 */ 
var $a338db40692f7a39$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $a338db40692f7a39$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $a338db40692f7a39$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;

var $a338db40692f7a39$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $a338db40692f7a39$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $a338db40692f7a39$var$MESSAGE_IDS = {
    MISSING_HEIGHT: "missingHeight",
    MISSING_WIDTH: "missingWidth"
};
const $a338db40692f7a39$var$TARGET_ELEMENTS = [
    "img",
    "iframe"
];
/** @type {RuleModule<[Option]>} */ $a338db40692f7a39$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Enforces that some elements (img, iframe) have explicitly defined width and height attributes.",
            category: $a338db40692f7a39$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $a338db40692f7a39$require$getRuleUrl("require-explicit-size")
        },
        fixable: null,
        schema: [
            {
                type: "object",
                properties: {
                    allowClass: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    },
                    allowId: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$a338db40692f7a39$var$MESSAGE_IDS.MISSING_HEIGHT]: "Missing `width` attribute for <{{name}}>",
            [$a338db40692f7a39$var$MESSAGE_IDS.MISSING_WIDTH]: "Missing `height` attribute for <{{name}}>"
        }
    },
    create (context) {
        const allowClass = context.options?.[0]?.allowClass || [];
        const allowId = context.options?.[0]?.allowId || [];
        const allowClassSet = new Set(allowClass);
        const allowIdSet = new Set(allowId);
        return $a338db40692f7a39$require$createVisitors(context, {
            Tag (node) {
                if (!$a338db40692f7a39$var$TARGET_ELEMENTS.some((element)=>element === $a338db40692f7a39$require$getNameOf(node))) return;
                const classAttr = $a338db40692f7a39$require$findAttr(node, "class");
                if (classAttr?.value?.value.split(" ").some((cls)=>allowClassSet.has(cls))) return;
                const idAttr = $a338db40692f7a39$require$findAttr(node, "id");
                if (idAttr?.value?.value.split(" ").some((id)=>allowIdSet.has(id))) return;
                const width = $a338db40692f7a39$require$findAttr(node, "width");
                const height = $a338db40692f7a39$require$findAttr(node, "height");
                if (!height || !height.value) context.report({
                    node: node.openStart,
                    messageId: $a338db40692f7a39$var$MESSAGE_IDS.MISSING_HEIGHT,
                    data: {
                        name: node.name
                    }
                });
                if (!width?.value) context.report({
                    node: node.openStart,
                    messageId: $a338db40692f7a39$var$MESSAGE_IDS.MISSING_WIDTH,
                    data: {
                        name: node.name
                    }
                });
            }
        });
    }
};


var $d4810f61f63fbd5c$exports = {};
/**
 * @import {
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 * @typedef {Object} Option
 * @property {"widely" | "newly" | number} Option.available
 */ 
var $d4810f61f63fbd5c$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $d4810f61f63fbd5c$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $d4810f61f63fbd5c$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;

var $d4810f61f63fbd5c$require$useBaseline = $404c96e82c1b1d4e$export$af5ef811749334ac;
var $d4810f61f63fbd5c$require$USE_BASELINE_MESSAGE_IDS = $404c96e82c1b1d4e$export$7ac25aba97301625;

var $d4810f61f63fbd5c$require$createElementAdapter = $65279e6012804295$exports.createElementAdapter;
/** @type {RuleModule<[Option]>} */ $d4810f61f63fbd5c$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Enforce the use of baseline features.",
            recommended: true,
            category: $d4810f61f63fbd5c$require$RULE_CATEGORY.BEST_PRACTICE,
            url: $d4810f61f63fbd5c$require$getRuleUrl("use-baseline")
        },
        fixable: null,
        schema: [
            {
                type: "object",
                properties: {
                    available: {
                        anyOf: [
                            {
                                enum: [
                                    "widely",
                                    "newly"
                                ]
                            },
                            {
                                // baseline year
                                type: "integer",
                                minimum: 2000,
                                maximum: new Date().getFullYear()
                            }
                        ]
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$d4810f61f63fbd5c$require$USE_BASELINE_MESSAGE_IDS.noBaselineElement]: "Element '{{element}}' is not a {{availability}} available baseline feature.",
            [$d4810f61f63fbd5c$require$USE_BASELINE_MESSAGE_IDS.notBaselineElementAttribute]: "Attribute '{{attr}}' on '{{element}}' is not a {{availability}} available baseline feature.",
            [$d4810f61f63fbd5c$require$USE_BASELINE_MESSAGE_IDS.notBaselineGlobalAttribute]: "Attribute '{{attr}}' is not a {{availability}} available baseline feature."
        }
    },
    create (context) {
        const options = context.options[0] || {
            available: "widely"
        };
        const { checkAttributes: checkAttributes } = $d4810f61f63fbd5c$require$useBaseline(options);
        /** @param {Tag | ScriptTag | StyleTag} node */ function check(node) {
            const adapter = $d4810f61f63fbd5c$require$createElementAdapter(node);
            const result = checkAttributes(adapter);
            for (const { messageId: messageId, data: data, loc: loc } of result)context.report({
                loc: loc,
                messageId: messageId,
                data: data
            });
        }
        return $d4810f61f63fbd5c$require$createVisitors(context, {
            ScriptTag: check,
            StyleTag: check,
            Tag: check
        });
    }
};


var $3f481eb8bcf658ee$exports = {};
/** @import {RuleModule} from "../types" */ 
var $3f481eb8bcf658ee$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $3f481eb8bcf658ee$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $3f481eb8bcf658ee$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;

var $3f481eb8bcf658ee$require$noDuplicateClass = $404c96e82c1b1d4e$export$f162233fbd04d00f;
var $3f481eb8bcf658ee$require$NO_DUPLICATE_CLASS_MESSAGE_IDS = $404c96e82c1b1d4e$export$e175ab31a1e21871;

var $3f481eb8bcf658ee$require$createAttributeValueAdapter = $65279e6012804295$exports.createAttributeValueAdapter;
/** @type {RuleModule<[]>} */ $3f481eb8bcf658ee$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow duplicate class names",
            category: $3f481eb8bcf658ee$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $3f481eb8bcf658ee$require$getRuleUrl("no-duplicate-class")
        },
        fixable: "code",
        schema: [],
        messages: {
            [$3f481eb8bcf658ee$require$NO_DUPLICATE_CLASS_MESSAGE_IDS.duplicateClass]: "The class '{{className}}' is duplicated."
        }
    },
    create (context) {
        const { checkClassValue: checkClassValue } = $3f481eb8bcf658ee$require$noDuplicateClass();
        return $3f481eb8bcf658ee$require$createVisitors(context, {
            Attribute (node) {
                if (node.key.value.toLowerCase() !== "class" || !node.value) return;
                const adapter = $3f481eb8bcf658ee$require$createAttributeValueAdapter(node.value);
                const result = checkClassValue(adapter);
                for (const { loc: loc, messageId: messageId, range: range, data: data } of result)context.report({
                    loc: loc,
                    messageId: messageId,
                    data: data,
                    fix (fixer) {
                        return fixer.removeRange(range);
                    }
                });
            }
        });
    }
};


var $ff1a173857c2285e$exports = {};
/**
 * @import {
 *   Tag,
 *   Text
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $ff1a173857c2285e$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $ff1a173857c2285e$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $ff1a173857c2285e$require$isTag = $7dabedd289de3a0a$exports.isTag;
var $ff1a173857c2285e$require$isText = $7dabedd289de3a0a$exports.isText;
var $ff1a173857c2285e$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;

var $ff1a173857c2285e$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $ff1a173857c2285e$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $ff1a173857c2285e$var$MESSAGE_IDS = {
    EMPTY_HEADING: "emptyHeading",
    INACCESSIBLE_HEADING: "inaccessibleHeading"
};
const $ff1a173857c2285e$var$HEADING_NAMES = new Set([
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
]);
/** @param {Tag} node */ function $ff1a173857c2285e$var$isAriaHidden(node) {
    const ariaHiddenAttr = $ff1a173857c2285e$require$findAttr(node, "aria-hidden");
    return ariaHiddenAttr?.value?.value === "true";
}
/**
 * @param {Tag} node
 * @returns {boolean}
 */ function $ff1a173857c2285e$var$isRoleHeading(node) {
    const roleAttr = $ff1a173857c2285e$require$findAttr(node, "role");
    return roleAttr?.value?.value === "heading";
}
/**
 * @param {Tag} node
 * @returns {string}
 */ function $ff1a173857c2285e$var$getAltText(node) {
    if ($ff1a173857c2285e$require$getNameOf(node) === "img") {
        const altAttr = $ff1a173857c2285e$require$findAttr(node, "alt");
        if (altAttr?.value?.value) return altAttr.value.value;
    }
    return "";
}
/**
 * @param {Text | Tag} node
 * @returns {string}
 */ function $ff1a173857c2285e$var$getAllText(node) {
    if (!$ff1a173857c2285e$require$isTag(node)) return "";
    let text = "";
    for (const child of node.children){
        if ($ff1a173857c2285e$require$isText(child)) text += child.value.trim();
        else if ($ff1a173857c2285e$require$isTag(child)) text += $ff1a173857c2285e$var$getAllText(child) || $ff1a173857c2285e$var$getAltText(child);
    }
    return text;
}
/**
 * @param {Text | Tag} node
 * @returns {string}
 */ function $ff1a173857c2285e$var$getAccessibleText(node) {
    if (!$ff1a173857c2285e$require$isTag(node) || !node.children.length) return "";
    let text = "";
    for (const child of node.children){
        if ($ff1a173857c2285e$require$isText(child)) text += child.value.trim();
        else if ($ff1a173857c2285e$require$isTag(child) && !$ff1a173857c2285e$var$isAriaHidden(child)) text += $ff1a173857c2285e$var$getAccessibleText(child) || $ff1a173857c2285e$var$getAltText(child);
    }
    return text;
}
/** @type {RuleModule<[]>} */ $ff1a173857c2285e$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow empty or inaccessible headings.",
            category: $ff1a173857c2285e$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $ff1a173857c2285e$require$getRuleUrl("no-empty-headings")
        },
        fixable: null,
        schema: [],
        messages: {
            [$ff1a173857c2285e$var$MESSAGE_IDS.EMPTY_HEADING]: "Headings must not be empty.",
            [$ff1a173857c2285e$var$MESSAGE_IDS.INACCESSIBLE_HEADING]: "Heading text is inaccessible to assistive technology."
        }
    },
    create (context) {
        return $ff1a173857c2285e$require$createVisitors(context, {
            Tag (node) {
                const tagName = $ff1a173857c2285e$require$getNameOf(node);
                const isHeadingTag = $ff1a173857c2285e$var$HEADING_NAMES.has(tagName);
                const isRoleHeadingEl = $ff1a173857c2285e$var$isRoleHeading(node);
                if (!isHeadingTag && !isRoleHeadingEl) return;
                // Gather all text (including aria-hidden)
                const allText = $ff1a173857c2285e$var$getAllText(node);
                if (!allText) {
                    context.report({
                        node: node,
                        messageId: $ff1a173857c2285e$var$MESSAGE_IDS.EMPTY_HEADING
                    });
                    return;
                }
                // Gather accessible text (not aria-hidden)
                const accessibleText = $ff1a173857c2285e$var$getAccessibleText(node);
                if (!accessibleText) context.report({
                    node: node,
                    messageId: $ff1a173857c2285e$var$MESSAGE_IDS.INACCESSIBLE_HEADING
                });
            }
        });
    }
};


var $ab94be7fccabd533$exports = {};
/**
 * @import {
 *   Tag,
 *   Text
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $ab94be7fccabd533$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $ab94be7fccabd533$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $ab94be7fccabd533$require$isTag = $7dabedd289de3a0a$exports.isTag;
var $ab94be7fccabd533$require$isText = $7dabedd289de3a0a$exports.isText;

var $ab94be7fccabd533$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $ab94be7fccabd533$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $ab94be7fccabd533$var$MESSAGE_IDS = {
    REQUIRE_CONTENT: "requireContent"
};
/**
 * Default set of elements that must have meaningful content. These are elements
 * where empty content is almost always a bug or an accessibility failure.
 */ const $ab94be7fccabd533$var$DEFAULT_ELEMENTS = new Set([
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "p",
    "a",
    "button",
    "li",
    "dt",
    "dd",
    "option",
    "label"
]);
/**
 * Returns true if the element has an accessible name via ARIA attributes,
 * making visible text content optional.
 *
 * @param {Tag} node
 * @returns {boolean}
 */ function $ab94be7fccabd533$var$hasAriaAccessibleName(node) {
    return !!($ab94be7fccabd533$require$findAttr(node, "aria-label") || $ab94be7fccabd533$require$findAttr(node, "aria-labelledby"));
}
/**
 * Returns true if the element is hidden from the accessibility tree.
 *
 * @param {Tag} node
 * @returns {boolean}
 */ function $ab94be7fccabd533$var$isHidden(node) {
    if ($ab94be7fccabd533$require$findAttr(node, "hidden")) return true;
    const ariaHidden = $ab94be7fccabd533$require$findAttr(node, "aria-hidden");
    return ariaHidden?.value?.value === "true";
}
/**
 * Returns true if the element has meaningful content — at least one child that
 * is a non-whitespace text node or a non-hidden child element.
 *
 * @param {Tag} node
 * @returns {boolean}
 */ function $ab94be7fccabd533$var$hasContent(node) {
    for (const child of node.children){
        if ($ab94be7fccabd533$require$isText(child) && child.value.trim().length > 0) return true;
        if ($ab94be7fccabd533$require$isTag(child) && !$ab94be7fccabd533$var$isHidden(child)) return true;
    }
    return false;
}
/** @type {RuleModule<[]>} */ $ab94be7fccabd533$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Require that certain elements have meaningful content.",
            category: $ab94be7fccabd533$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $ab94be7fccabd533$require$getRuleUrl("require-content")
        },
        fixable: null,
        schema: [],
        messages: {
            [$ab94be7fccabd533$var$MESSAGE_IDS.REQUIRE_CONTENT]: "<{{name}}> must have meaningful content or an accessible name (aria-label / aria-labelledby)."
        }
    },
    create (context) {
        return $ab94be7fccabd533$require$createVisitors(context, {
            Tag (node) {
                const tagName = node.name.toLowerCase();
                if (!$ab94be7fccabd533$var$DEFAULT_ELEMENTS.has(tagName)) return;
                if ($ab94be7fccabd533$var$isHidden(node)) return;
                if ($ab94be7fccabd533$var$hasAriaAccessibleName(node)) return;
                if (!$ab94be7fccabd533$var$hasContent(node)) context.report({
                    loc: {
                        start: node.openStart.loc.start,
                        end: node.openEnd.loc.end
                    },
                    data: {
                        name: node.name
                    },
                    messageId: $ab94be7fccabd533$var$MESSAGE_IDS.REQUIRE_CONTENT
                });
            }
        });
    }
};


var $fedc0e6536e8766c$exports = {};
/**
 * @import {Tag} from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $fedc0e6536e8766c$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $fedc0e6536e8766c$require$isTag = $7dabedd289de3a0a$exports.isTag;

var $fedc0e6536e8766c$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $fedc0e6536e8766c$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $fedc0e6536e8766c$var$MESSAGE_IDS = {
    MISSING_SUMMARY: "missingSummary",
    SUMMARY_NOT_FIRST: "summaryNotFirst"
};
/**
 * Returns the first element child of a node (skipping text/comment nodes).
 *
 * @param {Tag} node
 * @returns {Tag | null}
 */ function $fedc0e6536e8766c$var$firstElementChild(node) {
    for (const child of node.children){
        if ($fedc0e6536e8766c$require$isTag(child)) return child;
    }
    return null;
}
/** @type {RuleModule<[]>} */ $fedc0e6536e8766c$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Require `<details>` elements to have a `<summary>` as their first child element.",
            category: $fedc0e6536e8766c$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $fedc0e6536e8766c$require$getRuleUrl("require-details-summary")
        },
        fixable: null,
        schema: [],
        messages: {
            [$fedc0e6536e8766c$var$MESSAGE_IDS.MISSING_SUMMARY]: "The <details> element must contain a <summary> child element.",
            [$fedc0e6536e8766c$var$MESSAGE_IDS.SUMMARY_NOT_FIRST]: "The <summary> element must be the first child element of <details>."
        }
    },
    create (context) {
        return $fedc0e6536e8766c$require$createVisitors(context, {
            Tag (node) {
                if (node.name.toLowerCase() !== "details") return;
                const first = $fedc0e6536e8766c$var$firstElementChild(node);
                if (!first) {
                    // <details> with no element children at all
                    context.report({
                        node: node,
                        messageId: $fedc0e6536e8766c$var$MESSAGE_IDS.MISSING_SUMMARY
                    });
                    return;
                }
                if (first.name.toLowerCase() !== "summary") {
                    // Has element children but <summary> is not first (or absent)
                    const hasSummary = node.children.some((child)=>$fedc0e6536e8766c$require$isTag(child) && child.name.toLowerCase() === "summary");
                    context.report({
                        node: first,
                        messageId: hasSummary ? $fedc0e6536e8766c$var$MESSAGE_IDS.SUMMARY_NOT_FIRST : $fedc0e6536e8766c$var$MESSAGE_IDS.MISSING_SUMMARY
                    });
                }
            }
        });
    }
};


var $f81e92191d20d3e6$exports = {};
/**
 * @import {Text} from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ // Define the type for entities.json
/**
 * @typedef {Object} EntityData
 * @property {number[]} codepoints
 * @property {string} characters
 */ /** @type {{ [key: string]: EntityData }} */ var $f2f06edfac326d42$exports = {};
$f2f06edfac326d42$exports = JSON.parse('{"&AElig":{"codepoints":[198],"characters":"\xc6"},"&AElig;":{"codepoints":[198],"characters":"\xc6"},"&AMP":{"codepoints":[38],"characters":"&"},"&AMP;":{"codepoints":[38],"characters":"&"},"&Aacute":{"codepoints":[193],"characters":"\xc1"},"&Aacute;":{"codepoints":[193],"characters":"\xc1"},"&Abreve;":{"codepoints":[258],"characters":"\u0102"},"&Acirc":{"codepoints":[194],"characters":"\xc2"},"&Acirc;":{"codepoints":[194],"characters":"\xc2"},"&Acy;":{"codepoints":[1040],"characters":"\u0410"},"&Afr;":{"codepoints":[120068],"characters":"\uD835\uDD04"},"&Agrave":{"codepoints":[192],"characters":"\xc0"},"&Agrave;":{"codepoints":[192],"characters":"\xc0"},"&Alpha;":{"codepoints":[913],"characters":"\u0391"},"&Amacr;":{"codepoints":[256],"characters":"\u0100"},"&And;":{"codepoints":[10835],"characters":"\u2A53"},"&Aogon;":{"codepoints":[260],"characters":"\u0104"},"&Aopf;":{"codepoints":[120120],"characters":"\uD835\uDD38"},"&ApplyFunction;":{"codepoints":[8289],"characters":"\u2061"},"&Aring":{"codepoints":[197],"characters":"\xc5"},"&Aring;":{"codepoints":[197],"characters":"\xc5"},"&Ascr;":{"codepoints":[119964],"characters":"\uD835\uDC9C"},"&Assign;":{"codepoints":[8788],"characters":"\u2254"},"&Atilde":{"codepoints":[195],"characters":"\xc3"},"&Atilde;":{"codepoints":[195],"characters":"\xc3"},"&Auml":{"codepoints":[196],"characters":"\xc4"},"&Auml;":{"codepoints":[196],"characters":"\xc4"},"&Backslash;":{"codepoints":[8726],"characters":"\u2216"},"&Barv;":{"codepoints":[10983],"characters":"\u2AE7"},"&Barwed;":{"codepoints":[8966],"characters":"\u2306"},"&Bcy;":{"codepoints":[1041],"characters":"\u0411"},"&Because;":{"codepoints":[8757],"characters":"\u2235"},"&Bernoullis;":{"codepoints":[8492],"characters":"\u212C"},"&Beta;":{"codepoints":[914],"characters":"\u0392"},"&Bfr;":{"codepoints":[120069],"characters":"\uD835\uDD05"},"&Bopf;":{"codepoints":[120121],"characters":"\uD835\uDD39"},"&Breve;":{"codepoints":[728],"characters":"\u02D8"},"&Bscr;":{"codepoints":[8492],"characters":"\u212C"},"&Bumpeq;":{"codepoints":[8782],"characters":"\u224E"},"&CHcy;":{"codepoints":[1063],"characters":"\u0427"},"&COPY":{"codepoints":[169],"characters":"\xa9"},"&COPY;":{"codepoints":[169],"characters":"\xa9"},"&Cacute;":{"codepoints":[262],"characters":"\u0106"},"&Cap;":{"codepoints":[8914],"characters":"\u22D2"},"&CapitalDifferentialD;":{"codepoints":[8517],"characters":"\u2145"},"&Cayleys;":{"codepoints":[8493],"characters":"\u212D"},"&Ccaron;":{"codepoints":[268],"characters":"\u010C"},"&Ccedil":{"codepoints":[199],"characters":"\xc7"},"&Ccedil;":{"codepoints":[199],"characters":"\xc7"},"&Ccirc;":{"codepoints":[264],"characters":"\u0108"},"&Cconint;":{"codepoints":[8752],"characters":"\u2230"},"&Cdot;":{"codepoints":[266],"characters":"\u010A"},"&Cedilla;":{"codepoints":[184],"characters":"\xb8"},"&CenterDot;":{"codepoints":[183],"characters":"\xb7"},"&Cfr;":{"codepoints":[8493],"characters":"\u212D"},"&Chi;":{"codepoints":[935],"characters":"\u03A7"},"&CircleDot;":{"codepoints":[8857],"characters":"\u2299"},"&CircleMinus;":{"codepoints":[8854],"characters":"\u2296"},"&CirclePlus;":{"codepoints":[8853],"characters":"\u2295"},"&CircleTimes;":{"codepoints":[8855],"characters":"\u2297"},"&ClockwiseContourIntegral;":{"codepoints":[8754],"characters":"\u2232"},"&CloseCurlyDoubleQuote;":{"codepoints":[8221],"characters":"\u201D"},"&CloseCurlyQuote;":{"codepoints":[8217],"characters":"\u2019"},"&Colon;":{"codepoints":[8759],"characters":"\u2237"},"&Colone;":{"codepoints":[10868],"characters":"\u2A74"},"&Congruent;":{"codepoints":[8801],"characters":"\u2261"},"&Conint;":{"codepoints":[8751],"characters":"\u222F"},"&ContourIntegral;":{"codepoints":[8750],"characters":"\u222E"},"&Copf;":{"codepoints":[8450],"characters":"\u2102"},"&Coproduct;":{"codepoints":[8720],"characters":"\u2210"},"&CounterClockwiseContourIntegral;":{"codepoints":[8755],"characters":"\u2233"},"&Cross;":{"codepoints":[10799],"characters":"\u2A2F"},"&Cscr;":{"codepoints":[119966],"characters":"\uD835\uDC9E"},"&Cup;":{"codepoints":[8915],"characters":"\u22D3"},"&CupCap;":{"codepoints":[8781],"characters":"\u224D"},"&DD;":{"codepoints":[8517],"characters":"\u2145"},"&DDotrahd;":{"codepoints":[10513],"characters":"\u2911"},"&DJcy;":{"codepoints":[1026],"characters":"\u0402"},"&DScy;":{"codepoints":[1029],"characters":"\u0405"},"&DZcy;":{"codepoints":[1039],"characters":"\u040F"},"&Dagger;":{"codepoints":[8225],"characters":"\u2021"},"&Darr;":{"codepoints":[8609],"characters":"\u21A1"},"&Dashv;":{"codepoints":[10980],"characters":"\u2AE4"},"&Dcaron;":{"codepoints":[270],"characters":"\u010E"},"&Dcy;":{"codepoints":[1044],"characters":"\u0414"},"&Del;":{"codepoints":[8711],"characters":"\u2207"},"&Delta;":{"codepoints":[916],"characters":"\u0394"},"&Dfr;":{"codepoints":[120071],"characters":"\uD835\uDD07"},"&DiacriticalAcute;":{"codepoints":[180],"characters":"\xb4"},"&DiacriticalDot;":{"codepoints":[729],"characters":"\u02D9"},"&DiacriticalDoubleAcute;":{"codepoints":[733],"characters":"\u02DD"},"&DiacriticalGrave;":{"codepoints":[96],"characters":"`"},"&DiacriticalTilde;":{"codepoints":[732],"characters":"\u02DC"},"&Diamond;":{"codepoints":[8900],"characters":"\u22C4"},"&DifferentialD;":{"codepoints":[8518],"characters":"\u2146"},"&Dopf;":{"codepoints":[120123],"characters":"\uD835\uDD3B"},"&Dot;":{"codepoints":[168],"characters":"\xa8"},"&DotDot;":{"codepoints":[8412],"characters":"\u20DC"},"&DotEqual;":{"codepoints":[8784],"characters":"\u2250"},"&DoubleContourIntegral;":{"codepoints":[8751],"characters":"\u222F"},"&DoubleDot;":{"codepoints":[168],"characters":"\xa8"},"&DoubleDownArrow;":{"codepoints":[8659],"characters":"\u21D3"},"&DoubleLeftArrow;":{"codepoints":[8656],"characters":"\u21D0"},"&DoubleLeftRightArrow;":{"codepoints":[8660],"characters":"\u21D4"},"&DoubleLeftTee;":{"codepoints":[10980],"characters":"\u2AE4"},"&DoubleLongLeftArrow;":{"codepoints":[10232],"characters":"\u27F8"},"&DoubleLongLeftRightArrow;":{"codepoints":[10234],"characters":"\u27FA"},"&DoubleLongRightArrow;":{"codepoints":[10233],"characters":"\u27F9"},"&DoubleRightArrow;":{"codepoints":[8658],"characters":"\u21D2"},"&DoubleRightTee;":{"codepoints":[8872],"characters":"\u22A8"},"&DoubleUpArrow;":{"codepoints":[8657],"characters":"\u21D1"},"&DoubleUpDownArrow;":{"codepoints":[8661],"characters":"\u21D5"},"&DoubleVerticalBar;":{"codepoints":[8741],"characters":"\u2225"},"&DownArrow;":{"codepoints":[8595],"characters":"\u2193"},"&DownArrowBar;":{"codepoints":[10515],"characters":"\u2913"},"&DownArrowUpArrow;":{"codepoints":[8693],"characters":"\u21F5"},"&DownBreve;":{"codepoints":[785],"characters":"\u0311"},"&DownLeftRightVector;":{"codepoints":[10576],"characters":"\u2950"},"&DownLeftTeeVector;":{"codepoints":[10590],"characters":"\u295E"},"&DownLeftVector;":{"codepoints":[8637],"characters":"\u21BD"},"&DownLeftVectorBar;":{"codepoints":[10582],"characters":"\u2956"},"&DownRightTeeVector;":{"codepoints":[10591],"characters":"\u295F"},"&DownRightVector;":{"codepoints":[8641],"characters":"\u21C1"},"&DownRightVectorBar;":{"codepoints":[10583],"characters":"\u2957"},"&DownTee;":{"codepoints":[8868],"characters":"\u22A4"},"&DownTeeArrow;":{"codepoints":[8615],"characters":"\u21A7"},"&Downarrow;":{"codepoints":[8659],"characters":"\u21D3"},"&Dscr;":{"codepoints":[119967],"characters":"\uD835\uDC9F"},"&Dstrok;":{"codepoints":[272],"characters":"\u0110"},"&ENG;":{"codepoints":[330],"characters":"\u014A"},"&ETH":{"codepoints":[208],"characters":"\xd0"},"&ETH;":{"codepoints":[208],"characters":"\xd0"},"&Eacute":{"codepoints":[201],"characters":"\xc9"},"&Eacute;":{"codepoints":[201],"characters":"\xc9"},"&Ecaron;":{"codepoints":[282],"characters":"\u011A"},"&Ecirc":{"codepoints":[202],"characters":"\xca"},"&Ecirc;":{"codepoints":[202],"characters":"\xca"},"&Ecy;":{"codepoints":[1069],"characters":"\u042D"},"&Edot;":{"codepoints":[278],"characters":"\u0116"},"&Efr;":{"codepoints":[120072],"characters":"\uD835\uDD08"},"&Egrave":{"codepoints":[200],"characters":"\xc8"},"&Egrave;":{"codepoints":[200],"characters":"\xc8"},"&Element;":{"codepoints":[8712],"characters":"\u2208"},"&Emacr;":{"codepoints":[274],"characters":"\u0112"},"&EmptySmallSquare;":{"codepoints":[9723],"characters":"\u25FB"},"&EmptyVerySmallSquare;":{"codepoints":[9643],"characters":"\u25AB"},"&Eogon;":{"codepoints":[280],"characters":"\u0118"},"&Eopf;":{"codepoints":[120124],"characters":"\uD835\uDD3C"},"&Epsilon;":{"codepoints":[917],"characters":"\u0395"},"&Equal;":{"codepoints":[10869],"characters":"\u2A75"},"&EqualTilde;":{"codepoints":[8770],"characters":"\u2242"},"&Equilibrium;":{"codepoints":[8652],"characters":"\u21CC"},"&Escr;":{"codepoints":[8496],"characters":"\u2130"},"&Esim;":{"codepoints":[10867],"characters":"\u2A73"},"&Eta;":{"codepoints":[919],"characters":"\u0397"},"&Euml":{"codepoints":[203],"characters":"\xcb"},"&Euml;":{"codepoints":[203],"characters":"\xcb"},"&Exists;":{"codepoints":[8707],"characters":"\u2203"},"&ExponentialE;":{"codepoints":[8519],"characters":"\u2147"},"&Fcy;":{"codepoints":[1060],"characters":"\u0424"},"&Ffr;":{"codepoints":[120073],"characters":"\uD835\uDD09"},"&FilledSmallSquare;":{"codepoints":[9724],"characters":"\u25FC"},"&FilledVerySmallSquare;":{"codepoints":[9642],"characters":"\u25AA"},"&Fopf;":{"codepoints":[120125],"characters":"\uD835\uDD3D"},"&ForAll;":{"codepoints":[8704],"characters":"\u2200"},"&Fouriertrf;":{"codepoints":[8497],"characters":"\u2131"},"&Fscr;":{"codepoints":[8497],"characters":"\u2131"},"&GJcy;":{"codepoints":[1027],"characters":"\u0403"},"&GT":{"codepoints":[62],"characters":">"},"&GT;":{"codepoints":[62],"characters":">"},"&Gamma;":{"codepoints":[915],"characters":"\u0393"},"&Gammad;":{"codepoints":[988],"characters":"\u03DC"},"&Gbreve;":{"codepoints":[286],"characters":"\u011E"},"&Gcedil;":{"codepoints":[290],"characters":"\u0122"},"&Gcirc;":{"codepoints":[284],"characters":"\u011C"},"&Gcy;":{"codepoints":[1043],"characters":"\u0413"},"&Gdot;":{"codepoints":[288],"characters":"\u0120"},"&Gfr;":{"codepoints":[120074],"characters":"\uD835\uDD0A"},"&Gg;":{"codepoints":[8921],"characters":"\u22D9"},"&Gopf;":{"codepoints":[120126],"characters":"\uD835\uDD3E"},"&GreaterEqual;":{"codepoints":[8805],"characters":"\u2265"},"&GreaterEqualLess;":{"codepoints":[8923],"characters":"\u22DB"},"&GreaterFullEqual;":{"codepoints":[8807],"characters":"\u2267"},"&GreaterGreater;":{"codepoints":[10914],"characters":"\u2AA2"},"&GreaterLess;":{"codepoints":[8823],"characters":"\u2277"},"&GreaterSlantEqual;":{"codepoints":[10878],"characters":"\u2A7E"},"&GreaterTilde;":{"codepoints":[8819],"characters":"\u2273"},"&Gscr;":{"codepoints":[119970],"characters":"\uD835\uDCA2"},"&Gt;":{"codepoints":[8811],"characters":"\u226B"},"&HARDcy;":{"codepoints":[1066],"characters":"\u042A"},"&Hacek;":{"codepoints":[711],"characters":"\u02C7"},"&Hat;":{"codepoints":[94],"characters":"^"},"&Hcirc;":{"codepoints":[292],"characters":"\u0124"},"&Hfr;":{"codepoints":[8460],"characters":"\u210C"},"&HilbertSpace;":{"codepoints":[8459],"characters":"\u210B"},"&Hopf;":{"codepoints":[8461],"characters":"\u210D"},"&HorizontalLine;":{"codepoints":[9472],"characters":"\u2500"},"&Hscr;":{"codepoints":[8459],"characters":"\u210B"},"&Hstrok;":{"codepoints":[294],"characters":"\u0126"},"&HumpDownHump;":{"codepoints":[8782],"characters":"\u224E"},"&HumpEqual;":{"codepoints":[8783],"characters":"\u224F"},"&IEcy;":{"codepoints":[1045],"characters":"\u0415"},"&IJlig;":{"codepoints":[306],"characters":"\u0132"},"&IOcy;":{"codepoints":[1025],"characters":"\u0401"},"&Iacute":{"codepoints":[205],"characters":"\xcd"},"&Iacute;":{"codepoints":[205],"characters":"\xcd"},"&Icirc":{"codepoints":[206],"characters":"\xce"},"&Icirc;":{"codepoints":[206],"characters":"\xce"},"&Icy;":{"codepoints":[1048],"characters":"\u0418"},"&Idot;":{"codepoints":[304],"characters":"\u0130"},"&Ifr;":{"codepoints":[8465],"characters":"\u2111"},"&Igrave":{"codepoints":[204],"characters":"\xcc"},"&Igrave;":{"codepoints":[204],"characters":"\xcc"},"&Im;":{"codepoints":[8465],"characters":"\u2111"},"&Imacr;":{"codepoints":[298],"characters":"\u012A"},"&ImaginaryI;":{"codepoints":[8520],"characters":"\u2148"},"&Implies;":{"codepoints":[8658],"characters":"\u21D2"},"&Int;":{"codepoints":[8748],"characters":"\u222C"},"&Integral;":{"codepoints":[8747],"characters":"\u222B"},"&Intersection;":{"codepoints":[8898],"characters":"\u22C2"},"&InvisibleComma;":{"codepoints":[8291],"characters":"\u2063"},"&InvisibleTimes;":{"codepoints":[8290],"characters":"\u2062"},"&Iogon;":{"codepoints":[302],"characters":"\u012E"},"&Iopf;":{"codepoints":[120128],"characters":"\uD835\uDD40"},"&Iota;":{"codepoints":[921],"characters":"\u0399"},"&Iscr;":{"codepoints":[8464],"characters":"\u2110"},"&Itilde;":{"codepoints":[296],"characters":"\u0128"},"&Iukcy;":{"codepoints":[1030],"characters":"\u0406"},"&Iuml":{"codepoints":[207],"characters":"\xcf"},"&Iuml;":{"codepoints":[207],"characters":"\xcf"},"&Jcirc;":{"codepoints":[308],"characters":"\u0134"},"&Jcy;":{"codepoints":[1049],"characters":"\u0419"},"&Jfr;":{"codepoints":[120077],"characters":"\uD835\uDD0D"},"&Jopf;":{"codepoints":[120129],"characters":"\uD835\uDD41"},"&Jscr;":{"codepoints":[119973],"characters":"\uD835\uDCA5"},"&Jsercy;":{"codepoints":[1032],"characters":"\u0408"},"&Jukcy;":{"codepoints":[1028],"characters":"\u0404"},"&KHcy;":{"codepoints":[1061],"characters":"\u0425"},"&KJcy;":{"codepoints":[1036],"characters":"\u040C"},"&Kappa;":{"codepoints":[922],"characters":"\u039A"},"&Kcedil;":{"codepoints":[310],"characters":"\u0136"},"&Kcy;":{"codepoints":[1050],"characters":"\u041A"},"&Kfr;":{"codepoints":[120078],"characters":"\uD835\uDD0E"},"&Kopf;":{"codepoints":[120130],"characters":"\uD835\uDD42"},"&Kscr;":{"codepoints":[119974],"characters":"\uD835\uDCA6"},"&LJcy;":{"codepoints":[1033],"characters":"\u0409"},"&LT":{"codepoints":[60],"characters":"<"},"&LT;":{"codepoints":[60],"characters":"<"},"&Lacute;":{"codepoints":[313],"characters":"\u0139"},"&Lambda;":{"codepoints":[923],"characters":"\u039B"},"&Lang;":{"codepoints":[10218],"characters":"\u27EA"},"&Laplacetrf;":{"codepoints":[8466],"characters":"\u2112"},"&Larr;":{"codepoints":[8606],"characters":"\u219E"},"&Lcaron;":{"codepoints":[317],"characters":"\u013D"},"&Lcedil;":{"codepoints":[315],"characters":"\u013B"},"&Lcy;":{"codepoints":[1051],"characters":"\u041B"},"&LeftAngleBracket;":{"codepoints":[10216],"characters":"\u27E8"},"&LeftArrow;":{"codepoints":[8592],"characters":"\u2190"},"&LeftArrowBar;":{"codepoints":[8676],"characters":"\u21E4"},"&LeftArrowRightArrow;":{"codepoints":[8646],"characters":"\u21C6"},"&LeftCeiling;":{"codepoints":[8968],"characters":"\u2308"},"&LeftDoubleBracket;":{"codepoints":[10214],"characters":"\u27E6"},"&LeftDownTeeVector;":{"codepoints":[10593],"characters":"\u2961"},"&LeftDownVector;":{"codepoints":[8643],"characters":"\u21C3"},"&LeftDownVectorBar;":{"codepoints":[10585],"characters":"\u2959"},"&LeftFloor;":{"codepoints":[8970],"characters":"\u230A"},"&LeftRightArrow;":{"codepoints":[8596],"characters":"\u2194"},"&LeftRightVector;":{"codepoints":[10574],"characters":"\u294E"},"&LeftTee;":{"codepoints":[8867],"characters":"\u22A3"},"&LeftTeeArrow;":{"codepoints":[8612],"characters":"\u21A4"},"&LeftTeeVector;":{"codepoints":[10586],"characters":"\u295A"},"&LeftTriangle;":{"codepoints":[8882],"characters":"\u22B2"},"&LeftTriangleBar;":{"codepoints":[10703],"characters":"\u29CF"},"&LeftTriangleEqual;":{"codepoints":[8884],"characters":"\u22B4"},"&LeftUpDownVector;":{"codepoints":[10577],"characters":"\u2951"},"&LeftUpTeeVector;":{"codepoints":[10592],"characters":"\u2960"},"&LeftUpVector;":{"codepoints":[8639],"characters":"\u21BF"},"&LeftUpVectorBar;":{"codepoints":[10584],"characters":"\u2958"},"&LeftVector;":{"codepoints":[8636],"characters":"\u21BC"},"&LeftVectorBar;":{"codepoints":[10578],"characters":"\u2952"},"&Leftarrow;":{"codepoints":[8656],"characters":"\u21D0"},"&Leftrightarrow;":{"codepoints":[8660],"characters":"\u21D4"},"&LessEqualGreater;":{"codepoints":[8922],"characters":"\u22DA"},"&LessFullEqual;":{"codepoints":[8806],"characters":"\u2266"},"&LessGreater;":{"codepoints":[8822],"characters":"\u2276"},"&LessLess;":{"codepoints":[10913],"characters":"\u2AA1"},"&LessSlantEqual;":{"codepoints":[10877],"characters":"\u2A7D"},"&LessTilde;":{"codepoints":[8818],"characters":"\u2272"},"&Lfr;":{"codepoints":[120079],"characters":"\uD835\uDD0F"},"&Ll;":{"codepoints":[8920],"characters":"\u22D8"},"&Lleftarrow;":{"codepoints":[8666],"characters":"\u21DA"},"&Lmidot;":{"codepoints":[319],"characters":"\u013F"},"&LongLeftArrow;":{"codepoints":[10229],"characters":"\u27F5"},"&LongLeftRightArrow;":{"codepoints":[10231],"characters":"\u27F7"},"&LongRightArrow;":{"codepoints":[10230],"characters":"\u27F6"},"&Longleftarrow;":{"codepoints":[10232],"characters":"\u27F8"},"&Longleftrightarrow;":{"codepoints":[10234],"characters":"\u27FA"},"&Longrightarrow;":{"codepoints":[10233],"characters":"\u27F9"},"&Lopf;":{"codepoints":[120131],"characters":"\uD835\uDD43"},"&LowerLeftArrow;":{"codepoints":[8601],"characters":"\u2199"},"&LowerRightArrow;":{"codepoints":[8600],"characters":"\u2198"},"&Lscr;":{"codepoints":[8466],"characters":"\u2112"},"&Lsh;":{"codepoints":[8624],"characters":"\u21B0"},"&Lstrok;":{"codepoints":[321],"characters":"\u0141"},"&Lt;":{"codepoints":[8810],"characters":"\u226A"},"&Map;":{"codepoints":[10501],"characters":"\u2905"},"&Mcy;":{"codepoints":[1052],"characters":"\u041C"},"&MediumSpace;":{"codepoints":[8287],"characters":"\u205F"},"&Mellintrf;":{"codepoints":[8499],"characters":"\u2133"},"&Mfr;":{"codepoints":[120080],"characters":"\uD835\uDD10"},"&MinusPlus;":{"codepoints":[8723],"characters":"\u2213"},"&Mopf;":{"codepoints":[120132],"characters":"\uD835\uDD44"},"&Mscr;":{"codepoints":[8499],"characters":"\u2133"},"&Mu;":{"codepoints":[924],"characters":"\u039C"},"&NJcy;":{"codepoints":[1034],"characters":"\u040A"},"&Nacute;":{"codepoints":[323],"characters":"\u0143"},"&Ncaron;":{"codepoints":[327],"characters":"\u0147"},"&Ncedil;":{"codepoints":[325],"characters":"\u0145"},"&Ncy;":{"codepoints":[1053],"characters":"\u041D"},"&NegativeMediumSpace;":{"codepoints":[8203],"characters":"\u200B"},"&NegativeThickSpace;":{"codepoints":[8203],"characters":"\u200B"},"&NegativeThinSpace;":{"codepoints":[8203],"characters":"\u200B"},"&NegativeVeryThinSpace;":{"codepoints":[8203],"characters":"\u200B"},"&NestedGreaterGreater;":{"codepoints":[8811],"characters":"\u226B"},"&NestedLessLess;":{"codepoints":[8810],"characters":"\u226A"},"&NewLine;":{"codepoints":[10],"characters":"\\n"},"&Nfr;":{"codepoints":[120081],"characters":"\uD835\uDD11"},"&NoBreak;":{"codepoints":[8288],"characters":"\u2060"},"&NonBreakingSpace;":{"codepoints":[160],"characters":"\xa0"},"&Nopf;":{"codepoints":[8469],"characters":"\u2115"},"&Not;":{"codepoints":[10988],"characters":"\u2AEC"},"&NotCongruent;":{"codepoints":[8802],"characters":"\u2262"},"&NotCupCap;":{"codepoints":[8813],"characters":"\u226D"},"&NotDoubleVerticalBar;":{"codepoints":[8742],"characters":"\u2226"},"&NotElement;":{"codepoints":[8713],"characters":"\u2209"},"&NotEqual;":{"codepoints":[8800],"characters":"\u2260"},"&NotEqualTilde;":{"codepoints":[8770,824],"characters":"\u2242\u0338"},"&NotExists;":{"codepoints":[8708],"characters":"\u2204"},"&NotGreater;":{"codepoints":[8815],"characters":"\u226F"},"&NotGreaterEqual;":{"codepoints":[8817],"characters":"\u2271"},"&NotGreaterFullEqual;":{"codepoints":[8807,824],"characters":"\u2267\u0338"},"&NotGreaterGreater;":{"codepoints":[8811,824],"characters":"\u226B\u0338"},"&NotGreaterLess;":{"codepoints":[8825],"characters":"\u2279"},"&NotGreaterSlantEqual;":{"codepoints":[10878,824],"characters":"\u2A7E\u0338"},"&NotGreaterTilde;":{"codepoints":[8821],"characters":"\u2275"},"&NotHumpDownHump;":{"codepoints":[8782,824],"characters":"\u224E\u0338"},"&NotHumpEqual;":{"codepoints":[8783,824],"characters":"\u224F\u0338"},"&NotLeftTriangle;":{"codepoints":[8938],"characters":"\u22EA"},"&NotLeftTriangleBar;":{"codepoints":[10703,824],"characters":"\u29CF\u0338"},"&NotLeftTriangleEqual;":{"codepoints":[8940],"characters":"\u22EC"},"&NotLess;":{"codepoints":[8814],"characters":"\u226E"},"&NotLessEqual;":{"codepoints":[8816],"characters":"\u2270"},"&NotLessGreater;":{"codepoints":[8824],"characters":"\u2278"},"&NotLessLess;":{"codepoints":[8810,824],"characters":"\u226A\u0338"},"&NotLessSlantEqual;":{"codepoints":[10877,824],"characters":"\u2A7D\u0338"},"&NotLessTilde;":{"codepoints":[8820],"characters":"\u2274"},"&NotNestedGreaterGreater;":{"codepoints":[10914,824],"characters":"\u2AA2\u0338"},"&NotNestedLessLess;":{"codepoints":[10913,824],"characters":"\u2AA1\u0338"},"&NotPrecedes;":{"codepoints":[8832],"characters":"\u2280"},"&NotPrecedesEqual;":{"codepoints":[10927,824],"characters":"\u2AAF\u0338"},"&NotPrecedesSlantEqual;":{"codepoints":[8928],"characters":"\u22E0"},"&NotReverseElement;":{"codepoints":[8716],"characters":"\u220C"},"&NotRightTriangle;":{"codepoints":[8939],"characters":"\u22EB"},"&NotRightTriangleBar;":{"codepoints":[10704,824],"characters":"\u29D0\u0338"},"&NotRightTriangleEqual;":{"codepoints":[8941],"characters":"\u22ED"},"&NotSquareSubset;":{"codepoints":[8847,824],"characters":"\u228F\u0338"},"&NotSquareSubsetEqual;":{"codepoints":[8930],"characters":"\u22E2"},"&NotSquareSuperset;":{"codepoints":[8848,824],"characters":"\u2290\u0338"},"&NotSquareSupersetEqual;":{"codepoints":[8931],"characters":"\u22E3"},"&NotSubset;":{"codepoints":[8834,8402],"characters":"\u2282\u20D2"},"&NotSubsetEqual;":{"codepoints":[8840],"characters":"\u2288"},"&NotSucceeds;":{"codepoints":[8833],"characters":"\u2281"},"&NotSucceedsEqual;":{"codepoints":[10928,824],"characters":"\u2AB0\u0338"},"&NotSucceedsSlantEqual;":{"codepoints":[8929],"characters":"\u22E1"},"&NotSucceedsTilde;":{"codepoints":[8831,824],"characters":"\u227F\u0338"},"&NotSuperset;":{"codepoints":[8835,8402],"characters":"\u2283\u20D2"},"&NotSupersetEqual;":{"codepoints":[8841],"characters":"\u2289"},"&NotTilde;":{"codepoints":[8769],"characters":"\u2241"},"&NotTildeEqual;":{"codepoints":[8772],"characters":"\u2244"},"&NotTildeFullEqual;":{"codepoints":[8775],"characters":"\u2247"},"&NotTildeTilde;":{"codepoints":[8777],"characters":"\u2249"},"&NotVerticalBar;":{"codepoints":[8740],"characters":"\u2224"},"&Nscr;":{"codepoints":[119977],"characters":"\uD835\uDCA9"},"&Ntilde":{"codepoints":[209],"characters":"\xd1"},"&Ntilde;":{"codepoints":[209],"characters":"\xd1"},"&Nu;":{"codepoints":[925],"characters":"\u039D"},"&OElig;":{"codepoints":[338],"characters":"\u0152"},"&Oacute":{"codepoints":[211],"characters":"\xd3"},"&Oacute;":{"codepoints":[211],"characters":"\xd3"},"&Ocirc":{"codepoints":[212],"characters":"\xd4"},"&Ocirc;":{"codepoints":[212],"characters":"\xd4"},"&Ocy;":{"codepoints":[1054],"characters":"\u041E"},"&Odblac;":{"codepoints":[336],"characters":"\u0150"},"&Ofr;":{"codepoints":[120082],"characters":"\uD835\uDD12"},"&Ograve":{"codepoints":[210],"characters":"\xd2"},"&Ograve;":{"codepoints":[210],"characters":"\xd2"},"&Omacr;":{"codepoints":[332],"characters":"\u014C"},"&Omega;":{"codepoints":[937],"characters":"\u03A9"},"&Omicron;":{"codepoints":[927],"characters":"\u039F"},"&Oopf;":{"codepoints":[120134],"characters":"\uD835\uDD46"},"&OpenCurlyDoubleQuote;":{"codepoints":[8220],"characters":"\u201C"},"&OpenCurlyQuote;":{"codepoints":[8216],"characters":"\u2018"},"&Or;":{"codepoints":[10836],"characters":"\u2A54"},"&Oscr;":{"codepoints":[119978],"characters":"\uD835\uDCAA"},"&Oslash":{"codepoints":[216],"characters":"\xd8"},"&Oslash;":{"codepoints":[216],"characters":"\xd8"},"&Otilde":{"codepoints":[213],"characters":"\xd5"},"&Otilde;":{"codepoints":[213],"characters":"\xd5"},"&Otimes;":{"codepoints":[10807],"characters":"\u2A37"},"&Ouml":{"codepoints":[214],"characters":"\xd6"},"&Ouml;":{"codepoints":[214],"characters":"\xd6"},"&OverBar;":{"codepoints":[8254],"characters":"\u203E"},"&OverBrace;":{"codepoints":[9182],"characters":"\u23DE"},"&OverBracket;":{"codepoints":[9140],"characters":"\u23B4"},"&OverParenthesis;":{"codepoints":[9180],"characters":"\u23DC"},"&PartialD;":{"codepoints":[8706],"characters":"\u2202"},"&Pcy;":{"codepoints":[1055],"characters":"\u041F"},"&Pfr;":{"codepoints":[120083],"characters":"\uD835\uDD13"},"&Phi;":{"codepoints":[934],"characters":"\u03A6"},"&Pi;":{"codepoints":[928],"characters":"\u03A0"},"&PlusMinus;":{"codepoints":[177],"characters":"\xb1"},"&Poincareplane;":{"codepoints":[8460],"characters":"\u210C"},"&Popf;":{"codepoints":[8473],"characters":"\u2119"},"&Pr;":{"codepoints":[10939],"characters":"\u2ABB"},"&Precedes;":{"codepoints":[8826],"characters":"\u227A"},"&PrecedesEqual;":{"codepoints":[10927],"characters":"\u2AAF"},"&PrecedesSlantEqual;":{"codepoints":[8828],"characters":"\u227C"},"&PrecedesTilde;":{"codepoints":[8830],"characters":"\u227E"},"&Prime;":{"codepoints":[8243],"characters":"\u2033"},"&Product;":{"codepoints":[8719],"characters":"\u220F"},"&Proportion;":{"codepoints":[8759],"characters":"\u2237"},"&Proportional;":{"codepoints":[8733],"characters":"\u221D"},"&Pscr;":{"codepoints":[119979],"characters":"\uD835\uDCAB"},"&Psi;":{"codepoints":[936],"characters":"\u03A8"},"&QUOT":{"codepoints":[34],"characters":"\\""},"&QUOT;":{"codepoints":[34],"characters":"\\""},"&Qfr;":{"codepoints":[120084],"characters":"\uD835\uDD14"},"&Qopf;":{"codepoints":[8474],"characters":"\u211A"},"&Qscr;":{"codepoints":[119980],"characters":"\uD835\uDCAC"},"&RBarr;":{"codepoints":[10512],"characters":"\u2910"},"&REG":{"codepoints":[174],"characters":"\xae"},"&REG;":{"codepoints":[174],"characters":"\xae"},"&Racute;":{"codepoints":[340],"characters":"\u0154"},"&Rang;":{"codepoints":[10219],"characters":"\u27EB"},"&Rarr;":{"codepoints":[8608],"characters":"\u21A0"},"&Rarrtl;":{"codepoints":[10518],"characters":"\u2916"},"&Rcaron;":{"codepoints":[344],"characters":"\u0158"},"&Rcedil;":{"codepoints":[342],"characters":"\u0156"},"&Rcy;":{"codepoints":[1056],"characters":"\u0420"},"&Re;":{"codepoints":[8476],"characters":"\u211C"},"&ReverseElement;":{"codepoints":[8715],"characters":"\u220B"},"&ReverseEquilibrium;":{"codepoints":[8651],"characters":"\u21CB"},"&ReverseUpEquilibrium;":{"codepoints":[10607],"characters":"\u296F"},"&Rfr;":{"codepoints":[8476],"characters":"\u211C"},"&Rho;":{"codepoints":[929],"characters":"\u03A1"},"&RightAngleBracket;":{"codepoints":[10217],"characters":"\u27E9"},"&RightArrow;":{"codepoints":[8594],"characters":"\u2192"},"&RightArrowBar;":{"codepoints":[8677],"characters":"\u21E5"},"&RightArrowLeftArrow;":{"codepoints":[8644],"characters":"\u21C4"},"&RightCeiling;":{"codepoints":[8969],"characters":"\u2309"},"&RightDoubleBracket;":{"codepoints":[10215],"characters":"\u27E7"},"&RightDownTeeVector;":{"codepoints":[10589],"characters":"\u295D"},"&RightDownVector;":{"codepoints":[8642],"characters":"\u21C2"},"&RightDownVectorBar;":{"codepoints":[10581],"characters":"\u2955"},"&RightFloor;":{"codepoints":[8971],"characters":"\u230B"},"&RightTee;":{"codepoints":[8866],"characters":"\u22A2"},"&RightTeeArrow;":{"codepoints":[8614],"characters":"\u21A6"},"&RightTeeVector;":{"codepoints":[10587],"characters":"\u295B"},"&RightTriangle;":{"codepoints":[8883],"characters":"\u22B3"},"&RightTriangleBar;":{"codepoints":[10704],"characters":"\u29D0"},"&RightTriangleEqual;":{"codepoints":[8885],"characters":"\u22B5"},"&RightUpDownVector;":{"codepoints":[10575],"characters":"\u294F"},"&RightUpTeeVector;":{"codepoints":[10588],"characters":"\u295C"},"&RightUpVector;":{"codepoints":[8638],"characters":"\u21BE"},"&RightUpVectorBar;":{"codepoints":[10580],"characters":"\u2954"},"&RightVector;":{"codepoints":[8640],"characters":"\u21C0"},"&RightVectorBar;":{"codepoints":[10579],"characters":"\u2953"},"&Rightarrow;":{"codepoints":[8658],"characters":"\u21D2"},"&Ropf;":{"codepoints":[8477],"characters":"\u211D"},"&RoundImplies;":{"codepoints":[10608],"characters":"\u2970"},"&Rrightarrow;":{"codepoints":[8667],"characters":"\u21DB"},"&Rscr;":{"codepoints":[8475],"characters":"\u211B"},"&Rsh;":{"codepoints":[8625],"characters":"\u21B1"},"&RuleDelayed;":{"codepoints":[10740],"characters":"\u29F4"},"&SHCHcy;":{"codepoints":[1065],"characters":"\u0429"},"&SHcy;":{"codepoints":[1064],"characters":"\u0428"},"&SOFTcy;":{"codepoints":[1068],"characters":"\u042C"},"&Sacute;":{"codepoints":[346],"characters":"\u015A"},"&Sc;":{"codepoints":[10940],"characters":"\u2ABC"},"&Scaron;":{"codepoints":[352],"characters":"\u0160"},"&Scedil;":{"codepoints":[350],"characters":"\u015E"},"&Scirc;":{"codepoints":[348],"characters":"\u015C"},"&Scy;":{"codepoints":[1057],"characters":"\u0421"},"&Sfr;":{"codepoints":[120086],"characters":"\uD835\uDD16"},"&ShortDownArrow;":{"codepoints":[8595],"characters":"\u2193"},"&ShortLeftArrow;":{"codepoints":[8592],"characters":"\u2190"},"&ShortRightArrow;":{"codepoints":[8594],"characters":"\u2192"},"&ShortUpArrow;":{"codepoints":[8593],"characters":"\u2191"},"&Sigma;":{"codepoints":[931],"characters":"\u03A3"},"&SmallCircle;":{"codepoints":[8728],"characters":"\u2218"},"&Sopf;":{"codepoints":[120138],"characters":"\uD835\uDD4A"},"&Sqrt;":{"codepoints":[8730],"characters":"\u221A"},"&Square;":{"codepoints":[9633],"characters":"\u25A1"},"&SquareIntersection;":{"codepoints":[8851],"characters":"\u2293"},"&SquareSubset;":{"codepoints":[8847],"characters":"\u228F"},"&SquareSubsetEqual;":{"codepoints":[8849],"characters":"\u2291"},"&SquareSuperset;":{"codepoints":[8848],"characters":"\u2290"},"&SquareSupersetEqual;":{"codepoints":[8850],"characters":"\u2292"},"&SquareUnion;":{"codepoints":[8852],"characters":"\u2294"},"&Sscr;":{"codepoints":[119982],"characters":"\uD835\uDCAE"},"&Star;":{"codepoints":[8902],"characters":"\u22C6"},"&Sub;":{"codepoints":[8912],"characters":"\u22D0"},"&Subset;":{"codepoints":[8912],"characters":"\u22D0"},"&SubsetEqual;":{"codepoints":[8838],"characters":"\u2286"},"&Succeeds;":{"codepoints":[8827],"characters":"\u227B"},"&SucceedsEqual;":{"codepoints":[10928],"characters":"\u2AB0"},"&SucceedsSlantEqual;":{"codepoints":[8829],"characters":"\u227D"},"&SucceedsTilde;":{"codepoints":[8831],"characters":"\u227F"},"&SuchThat;":{"codepoints":[8715],"characters":"\u220B"},"&Sum;":{"codepoints":[8721],"characters":"\u2211"},"&Sup;":{"codepoints":[8913],"characters":"\u22D1"},"&Superset;":{"codepoints":[8835],"characters":"\u2283"},"&SupersetEqual;":{"codepoints":[8839],"characters":"\u2287"},"&Supset;":{"codepoints":[8913],"characters":"\u22D1"},"&THORN":{"codepoints":[222],"characters":"\xde"},"&THORN;":{"codepoints":[222],"characters":"\xde"},"&TRADE;":{"codepoints":[8482],"characters":"\u2122"},"&TSHcy;":{"codepoints":[1035],"characters":"\u040B"},"&TScy;":{"codepoints":[1062],"characters":"\u0426"},"&Tab;":{"codepoints":[9],"characters":"\\t"},"&Tau;":{"codepoints":[932],"characters":"\u03A4"},"&Tcaron;":{"codepoints":[356],"characters":"\u0164"},"&Tcedil;":{"codepoints":[354],"characters":"\u0162"},"&Tcy;":{"codepoints":[1058],"characters":"\u0422"},"&Tfr;":{"codepoints":[120087],"characters":"\uD835\uDD17"},"&Therefore;":{"codepoints":[8756],"characters":"\u2234"},"&Theta;":{"codepoints":[920],"characters":"\u0398"},"&ThickSpace;":{"codepoints":[8287,8202],"characters":"\u205F\u200A"},"&ThinSpace;":{"codepoints":[8201],"characters":"\u2009"},"&Tilde;":{"codepoints":[8764],"characters":"\u223C"},"&TildeEqual;":{"codepoints":[8771],"characters":"\u2243"},"&TildeFullEqual;":{"codepoints":[8773],"characters":"\u2245"},"&TildeTilde;":{"codepoints":[8776],"characters":"\u2248"},"&Topf;":{"codepoints":[120139],"characters":"\uD835\uDD4B"},"&TripleDot;":{"codepoints":[8411],"characters":"\u20DB"},"&Tscr;":{"codepoints":[119983],"characters":"\uD835\uDCAF"},"&Tstrok;":{"codepoints":[358],"characters":"\u0166"},"&Uacute":{"codepoints":[218],"characters":"\xda"},"&Uacute;":{"codepoints":[218],"characters":"\xda"},"&Uarr;":{"codepoints":[8607],"characters":"\u219F"},"&Uarrocir;":{"codepoints":[10569],"characters":"\u2949"},"&Ubrcy;":{"codepoints":[1038],"characters":"\u040E"},"&Ubreve;":{"codepoints":[364],"characters":"\u016C"},"&Ucirc":{"codepoints":[219],"characters":"\xdb"},"&Ucirc;":{"codepoints":[219],"characters":"\xdb"},"&Ucy;":{"codepoints":[1059],"characters":"\u0423"},"&Udblac;":{"codepoints":[368],"characters":"\u0170"},"&Ufr;":{"codepoints":[120088],"characters":"\uD835\uDD18"},"&Ugrave":{"codepoints":[217],"characters":"\xd9"},"&Ugrave;":{"codepoints":[217],"characters":"\xd9"},"&Umacr;":{"codepoints":[362],"characters":"\u016A"},"&UnderBar;":{"codepoints":[95],"characters":"_"},"&UnderBrace;":{"codepoints":[9183],"characters":"\u23DF"},"&UnderBracket;":{"codepoints":[9141],"characters":"\u23B5"},"&UnderParenthesis;":{"codepoints":[9181],"characters":"\u23DD"},"&Union;":{"codepoints":[8899],"characters":"\u22C3"},"&UnionPlus;":{"codepoints":[8846],"characters":"\u228E"},"&Uogon;":{"codepoints":[370],"characters":"\u0172"},"&Uopf;":{"codepoints":[120140],"characters":"\uD835\uDD4C"},"&UpArrow;":{"codepoints":[8593],"characters":"\u2191"},"&UpArrowBar;":{"codepoints":[10514],"characters":"\u2912"},"&UpArrowDownArrow;":{"codepoints":[8645],"characters":"\u21C5"},"&UpDownArrow;":{"codepoints":[8597],"characters":"\u2195"},"&UpEquilibrium;":{"codepoints":[10606],"characters":"\u296E"},"&UpTee;":{"codepoints":[8869],"characters":"\u22A5"},"&UpTeeArrow;":{"codepoints":[8613],"characters":"\u21A5"},"&Uparrow;":{"codepoints":[8657],"characters":"\u21D1"},"&Updownarrow;":{"codepoints":[8661],"characters":"\u21D5"},"&UpperLeftArrow;":{"codepoints":[8598],"characters":"\u2196"},"&UpperRightArrow;":{"codepoints":[8599],"characters":"\u2197"},"&Upsi;":{"codepoints":[978],"characters":"\u03D2"},"&Upsilon;":{"codepoints":[933],"characters":"\u03A5"},"&Uring;":{"codepoints":[366],"characters":"\u016E"},"&Uscr;":{"codepoints":[119984],"characters":"\uD835\uDCB0"},"&Utilde;":{"codepoints":[360],"characters":"\u0168"},"&Uuml":{"codepoints":[220],"characters":"\xdc"},"&Uuml;":{"codepoints":[220],"characters":"\xdc"},"&VDash;":{"codepoints":[8875],"characters":"\u22AB"},"&Vbar;":{"codepoints":[10987],"characters":"\u2AEB"},"&Vcy;":{"codepoints":[1042],"characters":"\u0412"},"&Vdash;":{"codepoints":[8873],"characters":"\u22A9"},"&Vdashl;":{"codepoints":[10982],"characters":"\u2AE6"},"&Vee;":{"codepoints":[8897],"characters":"\u22C1"},"&Verbar;":{"codepoints":[8214],"characters":"\u2016"},"&Vert;":{"codepoints":[8214],"characters":"\u2016"},"&VerticalBar;":{"codepoints":[8739],"characters":"\u2223"},"&VerticalLine;":{"codepoints":[124],"characters":"|"},"&VerticalSeparator;":{"codepoints":[10072],"characters":"\u2758"},"&VerticalTilde;":{"codepoints":[8768],"characters":"\u2240"},"&VeryThinSpace;":{"codepoints":[8202],"characters":"\u200A"},"&Vfr;":{"codepoints":[120089],"characters":"\uD835\uDD19"},"&Vopf;":{"codepoints":[120141],"characters":"\uD835\uDD4D"},"&Vscr;":{"codepoints":[119985],"characters":"\uD835\uDCB1"},"&Vvdash;":{"codepoints":[8874],"characters":"\u22AA"},"&Wcirc;":{"codepoints":[372],"characters":"\u0174"},"&Wedge;":{"codepoints":[8896],"characters":"\u22C0"},"&Wfr;":{"codepoints":[120090],"characters":"\uD835\uDD1A"},"&Wopf;":{"codepoints":[120142],"characters":"\uD835\uDD4E"},"&Wscr;":{"codepoints":[119986],"characters":"\uD835\uDCB2"},"&Xfr;":{"codepoints":[120091],"characters":"\uD835\uDD1B"},"&Xi;":{"codepoints":[926],"characters":"\u039E"},"&Xopf;":{"codepoints":[120143],"characters":"\uD835\uDD4F"},"&Xscr;":{"codepoints":[119987],"characters":"\uD835\uDCB3"},"&YAcy;":{"codepoints":[1071],"characters":"\u042F"},"&YIcy;":{"codepoints":[1031],"characters":"\u0407"},"&YUcy;":{"codepoints":[1070],"characters":"\u042E"},"&Yacute":{"codepoints":[221],"characters":"\xdd"},"&Yacute;":{"codepoints":[221],"characters":"\xdd"},"&Ycirc;":{"codepoints":[374],"characters":"\u0176"},"&Ycy;":{"codepoints":[1067],"characters":"\u042B"},"&Yfr;":{"codepoints":[120092],"characters":"\uD835\uDD1C"},"&Yopf;":{"codepoints":[120144],"characters":"\uD835\uDD50"},"&Yscr;":{"codepoints":[119988],"characters":"\uD835\uDCB4"},"&Yuml;":{"codepoints":[376],"characters":"\u0178"},"&ZHcy;":{"codepoints":[1046],"characters":"\u0416"},"&Zacute;":{"codepoints":[377],"characters":"\u0179"},"&Zcaron;":{"codepoints":[381],"characters":"\u017D"},"&Zcy;":{"codepoints":[1047],"characters":"\u0417"},"&Zdot;":{"codepoints":[379],"characters":"\u017B"},"&ZeroWidthSpace;":{"codepoints":[8203],"characters":"\u200B"},"&Zeta;":{"codepoints":[918],"characters":"\u0396"},"&Zfr;":{"codepoints":[8488],"characters":"\u2128"},"&Zopf;":{"codepoints":[8484],"characters":"\u2124"},"&Zscr;":{"codepoints":[119989],"characters":"\uD835\uDCB5"},"&aacute":{"codepoints":[225],"characters":"\xe1"},"&aacute;":{"codepoints":[225],"characters":"\xe1"},"&abreve;":{"codepoints":[259],"characters":"\u0103"},"&ac;":{"codepoints":[8766],"characters":"\u223E"},"&acE;":{"codepoints":[8766,819],"characters":"\u223E\u0333"},"&acd;":{"codepoints":[8767],"characters":"\u223F"},"&acirc":{"codepoints":[226],"characters":"\xe2"},"&acirc;":{"codepoints":[226],"characters":"\xe2"},"&acute":{"codepoints":[180],"characters":"\xb4"},"&acute;":{"codepoints":[180],"characters":"\xb4"},"&acy;":{"codepoints":[1072],"characters":"\u0430"},"&aelig":{"codepoints":[230],"characters":"\xe6"},"&aelig;":{"codepoints":[230],"characters":"\xe6"},"&af;":{"codepoints":[8289],"characters":"\u2061"},"&afr;":{"codepoints":[120094],"characters":"\uD835\uDD1E"},"&agrave":{"codepoints":[224],"characters":"\xe0"},"&agrave;":{"codepoints":[224],"characters":"\xe0"},"&alefsym;":{"codepoints":[8501],"characters":"\u2135"},"&aleph;":{"codepoints":[8501],"characters":"\u2135"},"&alpha;":{"codepoints":[945],"characters":"\u03B1"},"&amacr;":{"codepoints":[257],"characters":"\u0101"},"&amalg;":{"codepoints":[10815],"characters":"\u2A3F"},"&amp":{"codepoints":[38],"characters":"&"},"&amp;":{"codepoints":[38],"characters":"&"},"&and;":{"codepoints":[8743],"characters":"\u2227"},"&andand;":{"codepoints":[10837],"characters":"\u2A55"},"&andd;":{"codepoints":[10844],"characters":"\u2A5C"},"&andslope;":{"codepoints":[10840],"characters":"\u2A58"},"&andv;":{"codepoints":[10842],"characters":"\u2A5A"},"&ang;":{"codepoints":[8736],"characters":"\u2220"},"&ange;":{"codepoints":[10660],"characters":"\u29A4"},"&angle;":{"codepoints":[8736],"characters":"\u2220"},"&angmsd;":{"codepoints":[8737],"characters":"\u2221"},"&angmsdaa;":{"codepoints":[10664],"characters":"\u29A8"},"&angmsdab;":{"codepoints":[10665],"characters":"\u29A9"},"&angmsdac;":{"codepoints":[10666],"characters":"\u29AA"},"&angmsdad;":{"codepoints":[10667],"characters":"\u29AB"},"&angmsdae;":{"codepoints":[10668],"characters":"\u29AC"},"&angmsdaf;":{"codepoints":[10669],"characters":"\u29AD"},"&angmsdag;":{"codepoints":[10670],"characters":"\u29AE"},"&angmsdah;":{"codepoints":[10671],"characters":"\u29AF"},"&angrt;":{"codepoints":[8735],"characters":"\u221F"},"&angrtvb;":{"codepoints":[8894],"characters":"\u22BE"},"&angrtvbd;":{"codepoints":[10653],"characters":"\u299D"},"&angsph;":{"codepoints":[8738],"characters":"\u2222"},"&angst;":{"codepoints":[197],"characters":"\xc5"},"&angzarr;":{"codepoints":[9084],"characters":"\u237C"},"&aogon;":{"codepoints":[261],"characters":"\u0105"},"&aopf;":{"codepoints":[120146],"characters":"\uD835\uDD52"},"&ap;":{"codepoints":[8776],"characters":"\u2248"},"&apE;":{"codepoints":[10864],"characters":"\u2A70"},"&apacir;":{"codepoints":[10863],"characters":"\u2A6F"},"&ape;":{"codepoints":[8778],"characters":"\u224A"},"&apid;":{"codepoints":[8779],"characters":"\u224B"},"&apos;":{"codepoints":[39],"characters":"\'"},"&approx;":{"codepoints":[8776],"characters":"\u2248"},"&approxeq;":{"codepoints":[8778],"characters":"\u224A"},"&aring":{"codepoints":[229],"characters":"\xe5"},"&aring;":{"codepoints":[229],"characters":"\xe5"},"&ascr;":{"codepoints":[119990],"characters":"\uD835\uDCB6"},"&ast;":{"codepoints":[42],"characters":"*"},"&asymp;":{"codepoints":[8776],"characters":"\u2248"},"&asympeq;":{"codepoints":[8781],"characters":"\u224D"},"&atilde":{"codepoints":[227],"characters":"\xe3"},"&atilde;":{"codepoints":[227],"characters":"\xe3"},"&auml":{"codepoints":[228],"characters":"\xe4"},"&auml;":{"codepoints":[228],"characters":"\xe4"},"&awconint;":{"codepoints":[8755],"characters":"\u2233"},"&awint;":{"codepoints":[10769],"characters":"\u2A11"},"&bNot;":{"codepoints":[10989],"characters":"\u2AED"},"&backcong;":{"codepoints":[8780],"characters":"\u224C"},"&backepsilon;":{"codepoints":[1014],"characters":"\u03F6"},"&backprime;":{"codepoints":[8245],"characters":"\u2035"},"&backsim;":{"codepoints":[8765],"characters":"\u223D"},"&backsimeq;":{"codepoints":[8909],"characters":"\u22CD"},"&barvee;":{"codepoints":[8893],"characters":"\u22BD"},"&barwed;":{"codepoints":[8965],"characters":"\u2305"},"&barwedge;":{"codepoints":[8965],"characters":"\u2305"},"&bbrk;":{"codepoints":[9141],"characters":"\u23B5"},"&bbrktbrk;":{"codepoints":[9142],"characters":"\u23B6"},"&bcong;":{"codepoints":[8780],"characters":"\u224C"},"&bcy;":{"codepoints":[1073],"characters":"\u0431"},"&bdquo;":{"codepoints":[8222],"characters":"\u201E"},"&becaus;":{"codepoints":[8757],"characters":"\u2235"},"&because;":{"codepoints":[8757],"characters":"\u2235"},"&bemptyv;":{"codepoints":[10672],"characters":"\u29B0"},"&bepsi;":{"codepoints":[1014],"characters":"\u03F6"},"&bernou;":{"codepoints":[8492],"characters":"\u212C"},"&beta;":{"codepoints":[946],"characters":"\u03B2"},"&beth;":{"codepoints":[8502],"characters":"\u2136"},"&between;":{"codepoints":[8812],"characters":"\u226C"},"&bfr;":{"codepoints":[120095],"characters":"\uD835\uDD1F"},"&bigcap;":{"codepoints":[8898],"characters":"\u22C2"},"&bigcirc;":{"codepoints":[9711],"characters":"\u25EF"},"&bigcup;":{"codepoints":[8899],"characters":"\u22C3"},"&bigodot;":{"codepoints":[10752],"characters":"\u2A00"},"&bigoplus;":{"codepoints":[10753],"characters":"\u2A01"},"&bigotimes;":{"codepoints":[10754],"characters":"\u2A02"},"&bigsqcup;":{"codepoints":[10758],"characters":"\u2A06"},"&bigstar;":{"codepoints":[9733],"characters":"\u2605"},"&bigtriangledown;":{"codepoints":[9661],"characters":"\u25BD"},"&bigtriangleup;":{"codepoints":[9651],"characters":"\u25B3"},"&biguplus;":{"codepoints":[10756],"characters":"\u2A04"},"&bigvee;":{"codepoints":[8897],"characters":"\u22C1"},"&bigwedge;":{"codepoints":[8896],"characters":"\u22C0"},"&bkarow;":{"codepoints":[10509],"characters":"\u290D"},"&blacklozenge;":{"codepoints":[10731],"characters":"\u29EB"},"&blacksquare;":{"codepoints":[9642],"characters":"\u25AA"},"&blacktriangle;":{"codepoints":[9652],"characters":"\u25B4"},"&blacktriangledown;":{"codepoints":[9662],"characters":"\u25BE"},"&blacktriangleleft;":{"codepoints":[9666],"characters":"\u25C2"},"&blacktriangleright;":{"codepoints":[9656],"characters":"\u25B8"},"&blank;":{"codepoints":[9251],"characters":"\u2423"},"&blk12;":{"codepoints":[9618],"characters":"\u2592"},"&blk14;":{"codepoints":[9617],"characters":"\u2591"},"&blk34;":{"codepoints":[9619],"characters":"\u2593"},"&block;":{"codepoints":[9608],"characters":"\u2588"},"&bne;":{"codepoints":[61,8421],"characters":"=\u20E5"},"&bnequiv;":{"codepoints":[8801,8421],"characters":"\u2261\u20E5"},"&bnot;":{"codepoints":[8976],"characters":"\u2310"},"&bopf;":{"codepoints":[120147],"characters":"\uD835\uDD53"},"&bot;":{"codepoints":[8869],"characters":"\u22A5"},"&bottom;":{"codepoints":[8869],"characters":"\u22A5"},"&bowtie;":{"codepoints":[8904],"characters":"\u22C8"},"&boxDL;":{"codepoints":[9559],"characters":"\u2557"},"&boxDR;":{"codepoints":[9556],"characters":"\u2554"},"&boxDl;":{"codepoints":[9558],"characters":"\u2556"},"&boxDr;":{"codepoints":[9555],"characters":"\u2553"},"&boxH;":{"codepoints":[9552],"characters":"\u2550"},"&boxHD;":{"codepoints":[9574],"characters":"\u2566"},"&boxHU;":{"codepoints":[9577],"characters":"\u2569"},"&boxHd;":{"codepoints":[9572],"characters":"\u2564"},"&boxHu;":{"codepoints":[9575],"characters":"\u2567"},"&boxUL;":{"codepoints":[9565],"characters":"\u255D"},"&boxUR;":{"codepoints":[9562],"characters":"\u255A"},"&boxUl;":{"codepoints":[9564],"characters":"\u255C"},"&boxUr;":{"codepoints":[9561],"characters":"\u2559"},"&boxV;":{"codepoints":[9553],"characters":"\u2551"},"&boxVH;":{"codepoints":[9580],"characters":"\u256C"},"&boxVL;":{"codepoints":[9571],"characters":"\u2563"},"&boxVR;":{"codepoints":[9568],"characters":"\u2560"},"&boxVh;":{"codepoints":[9579],"characters":"\u256B"},"&boxVl;":{"codepoints":[9570],"characters":"\u2562"},"&boxVr;":{"codepoints":[9567],"characters":"\u255F"},"&boxbox;":{"codepoints":[10697],"characters":"\u29C9"},"&boxdL;":{"codepoints":[9557],"characters":"\u2555"},"&boxdR;":{"codepoints":[9554],"characters":"\u2552"},"&boxdl;":{"codepoints":[9488],"characters":"\u2510"},"&boxdr;":{"codepoints":[9484],"characters":"\u250C"},"&boxh;":{"codepoints":[9472],"characters":"\u2500"},"&boxhD;":{"codepoints":[9573],"characters":"\u2565"},"&boxhU;":{"codepoints":[9576],"characters":"\u2568"},"&boxhd;":{"codepoints":[9516],"characters":"\u252C"},"&boxhu;":{"codepoints":[9524],"characters":"\u2534"},"&boxminus;":{"codepoints":[8863],"characters":"\u229F"},"&boxplus;":{"codepoints":[8862],"characters":"\u229E"},"&boxtimes;":{"codepoints":[8864],"characters":"\u22A0"},"&boxuL;":{"codepoints":[9563],"characters":"\u255B"},"&boxuR;":{"codepoints":[9560],"characters":"\u2558"},"&boxul;":{"codepoints":[9496],"characters":"\u2518"},"&boxur;":{"codepoints":[9492],"characters":"\u2514"},"&boxv;":{"codepoints":[9474],"characters":"\u2502"},"&boxvH;":{"codepoints":[9578],"characters":"\u256A"},"&boxvL;":{"codepoints":[9569],"characters":"\u2561"},"&boxvR;":{"codepoints":[9566],"characters":"\u255E"},"&boxvh;":{"codepoints":[9532],"characters":"\u253C"},"&boxvl;":{"codepoints":[9508],"characters":"\u2524"},"&boxvr;":{"codepoints":[9500],"characters":"\u251C"},"&bprime;":{"codepoints":[8245],"characters":"\u2035"},"&breve;":{"codepoints":[728],"characters":"\u02D8"},"&brvbar":{"codepoints":[166],"characters":"\xa6"},"&brvbar;":{"codepoints":[166],"characters":"\xa6"},"&bscr;":{"codepoints":[119991],"characters":"\uD835\uDCB7"},"&bsemi;":{"codepoints":[8271],"characters":"\u204F"},"&bsim;":{"codepoints":[8765],"characters":"\u223D"},"&bsime;":{"codepoints":[8909],"characters":"\u22CD"},"&bsol;":{"codepoints":[92],"characters":"\\\\"},"&bsolb;":{"codepoints":[10693],"characters":"\u29C5"},"&bsolhsub;":{"codepoints":[10184],"characters":"\u27C8"},"&bull;":{"codepoints":[8226],"characters":"\u2022"},"&bullet;":{"codepoints":[8226],"characters":"\u2022"},"&bump;":{"codepoints":[8782],"characters":"\u224E"},"&bumpE;":{"codepoints":[10926],"characters":"\u2AAE"},"&bumpe;":{"codepoints":[8783],"characters":"\u224F"},"&bumpeq;":{"codepoints":[8783],"characters":"\u224F"},"&cacute;":{"codepoints":[263],"characters":"\u0107"},"&cap;":{"codepoints":[8745],"characters":"\u2229"},"&capand;":{"codepoints":[10820],"characters":"\u2A44"},"&capbrcup;":{"codepoints":[10825],"characters":"\u2A49"},"&capcap;":{"codepoints":[10827],"characters":"\u2A4B"},"&capcup;":{"codepoints":[10823],"characters":"\u2A47"},"&capdot;":{"codepoints":[10816],"characters":"\u2A40"},"&caps;":{"codepoints":[8745,65024],"characters":"\u2229\uFE00"},"&caret;":{"codepoints":[8257],"characters":"\u2041"},"&caron;":{"codepoints":[711],"characters":"\u02C7"},"&ccaps;":{"codepoints":[10829],"characters":"\u2A4D"},"&ccaron;":{"codepoints":[269],"characters":"\u010D"},"&ccedil":{"codepoints":[231],"characters":"\xe7"},"&ccedil;":{"codepoints":[231],"characters":"\xe7"},"&ccirc;":{"codepoints":[265],"characters":"\u0109"},"&ccups;":{"codepoints":[10828],"characters":"\u2A4C"},"&ccupssm;":{"codepoints":[10832],"characters":"\u2A50"},"&cdot;":{"codepoints":[267],"characters":"\u010B"},"&cedil":{"codepoints":[184],"characters":"\xb8"},"&cedil;":{"codepoints":[184],"characters":"\xb8"},"&cemptyv;":{"codepoints":[10674],"characters":"\u29B2"},"&cent":{"codepoints":[162],"characters":"\xa2"},"&cent;":{"codepoints":[162],"characters":"\xa2"},"&centerdot;":{"codepoints":[183],"characters":"\xb7"},"&cfr;":{"codepoints":[120096],"characters":"\uD835\uDD20"},"&chcy;":{"codepoints":[1095],"characters":"\u0447"},"&check;":{"codepoints":[10003],"characters":"\u2713"},"&checkmark;":{"codepoints":[10003],"characters":"\u2713"},"&chi;":{"codepoints":[967],"characters":"\u03C7"},"&cir;":{"codepoints":[9675],"characters":"\u25CB"},"&cirE;":{"codepoints":[10691],"characters":"\u29C3"},"&circ;":{"codepoints":[710],"characters":"\u02C6"},"&circeq;":{"codepoints":[8791],"characters":"\u2257"},"&circlearrowleft;":{"codepoints":[8634],"characters":"\u21BA"},"&circlearrowright;":{"codepoints":[8635],"characters":"\u21BB"},"&circledR;":{"codepoints":[174],"characters":"\xae"},"&circledS;":{"codepoints":[9416],"characters":"\u24C8"},"&circledast;":{"codepoints":[8859],"characters":"\u229B"},"&circledcirc;":{"codepoints":[8858],"characters":"\u229A"},"&circleddash;":{"codepoints":[8861],"characters":"\u229D"},"&cire;":{"codepoints":[8791],"characters":"\u2257"},"&cirfnint;":{"codepoints":[10768],"characters":"\u2A10"},"&cirmid;":{"codepoints":[10991],"characters":"\u2AEF"},"&cirscir;":{"codepoints":[10690],"characters":"\u29C2"},"&clubs;":{"codepoints":[9827],"characters":"\u2663"},"&clubsuit;":{"codepoints":[9827],"characters":"\u2663"},"&colon;":{"codepoints":[58],"characters":":"},"&colone;":{"codepoints":[8788],"characters":"\u2254"},"&coloneq;":{"codepoints":[8788],"characters":"\u2254"},"&comma;":{"codepoints":[44],"characters":","},"&commat;":{"codepoints":[64],"characters":"@"},"&comp;":{"codepoints":[8705],"characters":"\u2201"},"&compfn;":{"codepoints":[8728],"characters":"\u2218"},"&complement;":{"codepoints":[8705],"characters":"\u2201"},"&complexes;":{"codepoints":[8450],"characters":"\u2102"},"&cong;":{"codepoints":[8773],"characters":"\u2245"},"&congdot;":{"codepoints":[10861],"characters":"\u2A6D"},"&conint;":{"codepoints":[8750],"characters":"\u222E"},"&copf;":{"codepoints":[120148],"characters":"\uD835\uDD54"},"&coprod;":{"codepoints":[8720],"characters":"\u2210"},"&copy":{"codepoints":[169],"characters":"\xa9"},"&copy;":{"codepoints":[169],"characters":"\xa9"},"&copysr;":{"codepoints":[8471],"characters":"\u2117"},"&crarr;":{"codepoints":[8629],"characters":"\u21B5"},"&cross;":{"codepoints":[10007],"characters":"\u2717"},"&cscr;":{"codepoints":[119992],"characters":"\uD835\uDCB8"},"&csub;":{"codepoints":[10959],"characters":"\u2ACF"},"&csube;":{"codepoints":[10961],"characters":"\u2AD1"},"&csup;":{"codepoints":[10960],"characters":"\u2AD0"},"&csupe;":{"codepoints":[10962],"characters":"\u2AD2"},"&ctdot;":{"codepoints":[8943],"characters":"\u22EF"},"&cudarrl;":{"codepoints":[10552],"characters":"\u2938"},"&cudarrr;":{"codepoints":[10549],"characters":"\u2935"},"&cuepr;":{"codepoints":[8926],"characters":"\u22DE"},"&cuesc;":{"codepoints":[8927],"characters":"\u22DF"},"&cularr;":{"codepoints":[8630],"characters":"\u21B6"},"&cularrp;":{"codepoints":[10557],"characters":"\u293D"},"&cup;":{"codepoints":[8746],"characters":"\u222A"},"&cupbrcap;":{"codepoints":[10824],"characters":"\u2A48"},"&cupcap;":{"codepoints":[10822],"characters":"\u2A46"},"&cupcup;":{"codepoints":[10826],"characters":"\u2A4A"},"&cupdot;":{"codepoints":[8845],"characters":"\u228D"},"&cupor;":{"codepoints":[10821],"characters":"\u2A45"},"&cups;":{"codepoints":[8746,65024],"characters":"\u222A\uFE00"},"&curarr;":{"codepoints":[8631],"characters":"\u21B7"},"&curarrm;":{"codepoints":[10556],"characters":"\u293C"},"&curlyeqprec;":{"codepoints":[8926],"characters":"\u22DE"},"&curlyeqsucc;":{"codepoints":[8927],"characters":"\u22DF"},"&curlyvee;":{"codepoints":[8910],"characters":"\u22CE"},"&curlywedge;":{"codepoints":[8911],"characters":"\u22CF"},"&curren":{"codepoints":[164],"characters":"\xa4"},"&curren;":{"codepoints":[164],"characters":"\xa4"},"&curvearrowleft;":{"codepoints":[8630],"characters":"\u21B6"},"&curvearrowright;":{"codepoints":[8631],"characters":"\u21B7"},"&cuvee;":{"codepoints":[8910],"characters":"\u22CE"},"&cuwed;":{"codepoints":[8911],"characters":"\u22CF"},"&cwconint;":{"codepoints":[8754],"characters":"\u2232"},"&cwint;":{"codepoints":[8753],"characters":"\u2231"},"&cylcty;":{"codepoints":[9005],"characters":"\u232D"},"&dArr;":{"codepoints":[8659],"characters":"\u21D3"},"&dHar;":{"codepoints":[10597],"characters":"\u2965"},"&dagger;":{"codepoints":[8224],"characters":"\u2020"},"&daleth;":{"codepoints":[8504],"characters":"\u2138"},"&darr;":{"codepoints":[8595],"characters":"\u2193"},"&dash;":{"codepoints":[8208],"characters":"\u2010"},"&dashv;":{"codepoints":[8867],"characters":"\u22A3"},"&dbkarow;":{"codepoints":[10511],"characters":"\u290F"},"&dblac;":{"codepoints":[733],"characters":"\u02DD"},"&dcaron;":{"codepoints":[271],"characters":"\u010F"},"&dcy;":{"codepoints":[1076],"characters":"\u0434"},"&dd;":{"codepoints":[8518],"characters":"\u2146"},"&ddagger;":{"codepoints":[8225],"characters":"\u2021"},"&ddarr;":{"codepoints":[8650],"characters":"\u21CA"},"&ddotseq;":{"codepoints":[10871],"characters":"\u2A77"},"&deg":{"codepoints":[176],"characters":"\xb0"},"&deg;":{"codepoints":[176],"characters":"\xb0"},"&delta;":{"codepoints":[948],"characters":"\u03B4"},"&demptyv;":{"codepoints":[10673],"characters":"\u29B1"},"&dfisht;":{"codepoints":[10623],"characters":"\u297F"},"&dfr;":{"codepoints":[120097],"characters":"\uD835\uDD21"},"&dharl;":{"codepoints":[8643],"characters":"\u21C3"},"&dharr;":{"codepoints":[8642],"characters":"\u21C2"},"&diam;":{"codepoints":[8900],"characters":"\u22C4"},"&diamond;":{"codepoints":[8900],"characters":"\u22C4"},"&diamondsuit;":{"codepoints":[9830],"characters":"\u2666"},"&diams;":{"codepoints":[9830],"characters":"\u2666"},"&die;":{"codepoints":[168],"characters":"\xa8"},"&digamma;":{"codepoints":[989],"characters":"\u03DD"},"&disin;":{"codepoints":[8946],"characters":"\u22F2"},"&div;":{"codepoints":[247],"characters":"\xf7"},"&divide":{"codepoints":[247],"characters":"\xf7"},"&divide;":{"codepoints":[247],"characters":"\xf7"},"&divideontimes;":{"codepoints":[8903],"characters":"\u22C7"},"&divonx;":{"codepoints":[8903],"characters":"\u22C7"},"&djcy;":{"codepoints":[1106],"characters":"\u0452"},"&dlcorn;":{"codepoints":[8990],"characters":"\u231E"},"&dlcrop;":{"codepoints":[8973],"characters":"\u230D"},"&dollar;":{"codepoints":[36],"characters":"$"},"&dopf;":{"codepoints":[120149],"characters":"\uD835\uDD55"},"&dot;":{"codepoints":[729],"characters":"\u02D9"},"&doteq;":{"codepoints":[8784],"characters":"\u2250"},"&doteqdot;":{"codepoints":[8785],"characters":"\u2251"},"&dotminus;":{"codepoints":[8760],"characters":"\u2238"},"&dotplus;":{"codepoints":[8724],"characters":"\u2214"},"&dotsquare;":{"codepoints":[8865],"characters":"\u22A1"},"&doublebarwedge;":{"codepoints":[8966],"characters":"\u2306"},"&downarrow;":{"codepoints":[8595],"characters":"\u2193"},"&downdownarrows;":{"codepoints":[8650],"characters":"\u21CA"},"&downharpoonleft;":{"codepoints":[8643],"characters":"\u21C3"},"&downharpoonright;":{"codepoints":[8642],"characters":"\u21C2"},"&drbkarow;":{"codepoints":[10512],"characters":"\u2910"},"&drcorn;":{"codepoints":[8991],"characters":"\u231F"},"&drcrop;":{"codepoints":[8972],"characters":"\u230C"},"&dscr;":{"codepoints":[119993],"characters":"\uD835\uDCB9"},"&dscy;":{"codepoints":[1109],"characters":"\u0455"},"&dsol;":{"codepoints":[10742],"characters":"\u29F6"},"&dstrok;":{"codepoints":[273],"characters":"\u0111"},"&dtdot;":{"codepoints":[8945],"characters":"\u22F1"},"&dtri;":{"codepoints":[9663],"characters":"\u25BF"},"&dtrif;":{"codepoints":[9662],"characters":"\u25BE"},"&duarr;":{"codepoints":[8693],"characters":"\u21F5"},"&duhar;":{"codepoints":[10607],"characters":"\u296F"},"&dwangle;":{"codepoints":[10662],"characters":"\u29A6"},"&dzcy;":{"codepoints":[1119],"characters":"\u045F"},"&dzigrarr;":{"codepoints":[10239],"characters":"\u27FF"},"&eDDot;":{"codepoints":[10871],"characters":"\u2A77"},"&eDot;":{"codepoints":[8785],"characters":"\u2251"},"&eacute":{"codepoints":[233],"characters":"\xe9"},"&eacute;":{"codepoints":[233],"characters":"\xe9"},"&easter;":{"codepoints":[10862],"characters":"\u2A6E"},"&ecaron;":{"codepoints":[283],"characters":"\u011B"},"&ecir;":{"codepoints":[8790],"characters":"\u2256"},"&ecirc":{"codepoints":[234],"characters":"\xea"},"&ecirc;":{"codepoints":[234],"characters":"\xea"},"&ecolon;":{"codepoints":[8789],"characters":"\u2255"},"&ecy;":{"codepoints":[1101],"characters":"\u044D"},"&edot;":{"codepoints":[279],"characters":"\u0117"},"&ee;":{"codepoints":[8519],"characters":"\u2147"},"&efDot;":{"codepoints":[8786],"characters":"\u2252"},"&efr;":{"codepoints":[120098],"characters":"\uD835\uDD22"},"&eg;":{"codepoints":[10906],"characters":"\u2A9A"},"&egrave":{"codepoints":[232],"characters":"\xe8"},"&egrave;":{"codepoints":[232],"characters":"\xe8"},"&egs;":{"codepoints":[10902],"characters":"\u2A96"},"&egsdot;":{"codepoints":[10904],"characters":"\u2A98"},"&el;":{"codepoints":[10905],"characters":"\u2A99"},"&elinters;":{"codepoints":[9191],"characters":"\u23E7"},"&ell;":{"codepoints":[8467],"characters":"\u2113"},"&els;":{"codepoints":[10901],"characters":"\u2A95"},"&elsdot;":{"codepoints":[10903],"characters":"\u2A97"},"&emacr;":{"codepoints":[275],"characters":"\u0113"},"&empty;":{"codepoints":[8709],"characters":"\u2205"},"&emptyset;":{"codepoints":[8709],"characters":"\u2205"},"&emptyv;":{"codepoints":[8709],"characters":"\u2205"},"&emsp13;":{"codepoints":[8196],"characters":"\u2004"},"&emsp14;":{"codepoints":[8197],"characters":"\u2005"},"&emsp;":{"codepoints":[8195],"characters":"\u2003"},"&eng;":{"codepoints":[331],"characters":"\u014B"},"&ensp;":{"codepoints":[8194],"characters":"\u2002"},"&eogon;":{"codepoints":[281],"characters":"\u0119"},"&eopf;":{"codepoints":[120150],"characters":"\uD835\uDD56"},"&epar;":{"codepoints":[8917],"characters":"\u22D5"},"&eparsl;":{"codepoints":[10723],"characters":"\u29E3"},"&eplus;":{"codepoints":[10865],"characters":"\u2A71"},"&epsi;":{"codepoints":[949],"characters":"\u03B5"},"&epsilon;":{"codepoints":[949],"characters":"\u03B5"},"&epsiv;":{"codepoints":[1013],"characters":"\u03F5"},"&eqcirc;":{"codepoints":[8790],"characters":"\u2256"},"&eqcolon;":{"codepoints":[8789],"characters":"\u2255"},"&eqsim;":{"codepoints":[8770],"characters":"\u2242"},"&eqslantgtr;":{"codepoints":[10902],"characters":"\u2A96"},"&eqslantless;":{"codepoints":[10901],"characters":"\u2A95"},"&equals;":{"codepoints":[61],"characters":"="},"&equest;":{"codepoints":[8799],"characters":"\u225F"},"&equiv;":{"codepoints":[8801],"characters":"\u2261"},"&equivDD;":{"codepoints":[10872],"characters":"\u2A78"},"&eqvparsl;":{"codepoints":[10725],"characters":"\u29E5"},"&erDot;":{"codepoints":[8787],"characters":"\u2253"},"&erarr;":{"codepoints":[10609],"characters":"\u2971"},"&escr;":{"codepoints":[8495],"characters":"\u212F"},"&esdot;":{"codepoints":[8784],"characters":"\u2250"},"&esim;":{"codepoints":[8770],"characters":"\u2242"},"&eta;":{"codepoints":[951],"characters":"\u03B7"},"&eth":{"codepoints":[240],"characters":"\xf0"},"&eth;":{"codepoints":[240],"characters":"\xf0"},"&euml":{"codepoints":[235],"characters":"\xeb"},"&euml;":{"codepoints":[235],"characters":"\xeb"},"&euro;":{"codepoints":[8364],"characters":"\u20AC"},"&excl;":{"codepoints":[33],"characters":"!"},"&exist;":{"codepoints":[8707],"characters":"\u2203"},"&expectation;":{"codepoints":[8496],"characters":"\u2130"},"&exponentiale;":{"codepoints":[8519],"characters":"\u2147"},"&fallingdotseq;":{"codepoints":[8786],"characters":"\u2252"},"&fcy;":{"codepoints":[1092],"characters":"\u0444"},"&female;":{"codepoints":[9792],"characters":"\u2640"},"&ffilig;":{"codepoints":[64259],"characters":"\uFB03"},"&fflig;":{"codepoints":[64256],"characters":"\uFB00"},"&ffllig;":{"codepoints":[64260],"characters":"\uFB04"},"&ffr;":{"codepoints":[120099],"characters":"\uD835\uDD23"},"&filig;":{"codepoints":[64257],"characters":"\uFB01"},"&fjlig;":{"codepoints":[102,106],"characters":"fj"},"&flat;":{"codepoints":[9837],"characters":"\u266D"},"&fllig;":{"codepoints":[64258],"characters":"\uFB02"},"&fltns;":{"codepoints":[9649],"characters":"\u25B1"},"&fnof;":{"codepoints":[402],"characters":"\u0192"},"&fopf;":{"codepoints":[120151],"characters":"\uD835\uDD57"},"&forall;":{"codepoints":[8704],"characters":"\u2200"},"&fork;":{"codepoints":[8916],"characters":"\u22D4"},"&forkv;":{"codepoints":[10969],"characters":"\u2AD9"},"&fpartint;":{"codepoints":[10765],"characters":"\u2A0D"},"&frac12":{"codepoints":[189],"characters":"\xbd"},"&frac12;":{"codepoints":[189],"characters":"\xbd"},"&frac13;":{"codepoints":[8531],"characters":"\u2153"},"&frac14":{"codepoints":[188],"characters":"\xbc"},"&frac14;":{"codepoints":[188],"characters":"\xbc"},"&frac15;":{"codepoints":[8533],"characters":"\u2155"},"&frac16;":{"codepoints":[8537],"characters":"\u2159"},"&frac18;":{"codepoints":[8539],"characters":"\u215B"},"&frac23;":{"codepoints":[8532],"characters":"\u2154"},"&frac25;":{"codepoints":[8534],"characters":"\u2156"},"&frac34":{"codepoints":[190],"characters":"\xbe"},"&frac34;":{"codepoints":[190],"characters":"\xbe"},"&frac35;":{"codepoints":[8535],"characters":"\u2157"},"&frac38;":{"codepoints":[8540],"characters":"\u215C"},"&frac45;":{"codepoints":[8536],"characters":"\u2158"},"&frac56;":{"codepoints":[8538],"characters":"\u215A"},"&frac58;":{"codepoints":[8541],"characters":"\u215D"},"&frac78;":{"codepoints":[8542],"characters":"\u215E"},"&frasl;":{"codepoints":[8260],"characters":"\u2044"},"&frown;":{"codepoints":[8994],"characters":"\u2322"},"&fscr;":{"codepoints":[119995],"characters":"\uD835\uDCBB"},"&gE;":{"codepoints":[8807],"characters":"\u2267"},"&gEl;":{"codepoints":[10892],"characters":"\u2A8C"},"&gacute;":{"codepoints":[501],"characters":"\u01F5"},"&gamma;":{"codepoints":[947],"characters":"\u03B3"},"&gammad;":{"codepoints":[989],"characters":"\u03DD"},"&gap;":{"codepoints":[10886],"characters":"\u2A86"},"&gbreve;":{"codepoints":[287],"characters":"\u011F"},"&gcirc;":{"codepoints":[285],"characters":"\u011D"},"&gcy;":{"codepoints":[1075],"characters":"\u0433"},"&gdot;":{"codepoints":[289],"characters":"\u0121"},"&ge;":{"codepoints":[8805],"characters":"\u2265"},"&gel;":{"codepoints":[8923],"characters":"\u22DB"},"&geq;":{"codepoints":[8805],"characters":"\u2265"},"&geqq;":{"codepoints":[8807],"characters":"\u2267"},"&geqslant;":{"codepoints":[10878],"characters":"\u2A7E"},"&ges;":{"codepoints":[10878],"characters":"\u2A7E"},"&gescc;":{"codepoints":[10921],"characters":"\u2AA9"},"&gesdot;":{"codepoints":[10880],"characters":"\u2A80"},"&gesdoto;":{"codepoints":[10882],"characters":"\u2A82"},"&gesdotol;":{"codepoints":[10884],"characters":"\u2A84"},"&gesl;":{"codepoints":[8923,65024],"characters":"\u22DB\uFE00"},"&gesles;":{"codepoints":[10900],"characters":"\u2A94"},"&gfr;":{"codepoints":[120100],"characters":"\uD835\uDD24"},"&gg;":{"codepoints":[8811],"characters":"\u226B"},"&ggg;":{"codepoints":[8921],"characters":"\u22D9"},"&gimel;":{"codepoints":[8503],"characters":"\u2137"},"&gjcy;":{"codepoints":[1107],"characters":"\u0453"},"&gl;":{"codepoints":[8823],"characters":"\u2277"},"&glE;":{"codepoints":[10898],"characters":"\u2A92"},"&gla;":{"codepoints":[10917],"characters":"\u2AA5"},"&glj;":{"codepoints":[10916],"characters":"\u2AA4"},"&gnE;":{"codepoints":[8809],"characters":"\u2269"},"&gnap;":{"codepoints":[10890],"characters":"\u2A8A"},"&gnapprox;":{"codepoints":[10890],"characters":"\u2A8A"},"&gne;":{"codepoints":[10888],"characters":"\u2A88"},"&gneq;":{"codepoints":[10888],"characters":"\u2A88"},"&gneqq;":{"codepoints":[8809],"characters":"\u2269"},"&gnsim;":{"codepoints":[8935],"characters":"\u22E7"},"&gopf;":{"codepoints":[120152],"characters":"\uD835\uDD58"},"&grave;":{"codepoints":[96],"characters":"`"},"&gscr;":{"codepoints":[8458],"characters":"\u210A"},"&gsim;":{"codepoints":[8819],"characters":"\u2273"},"&gsime;":{"codepoints":[10894],"characters":"\u2A8E"},"&gsiml;":{"codepoints":[10896],"characters":"\u2A90"},"&gt":{"codepoints":[62],"characters":">"},"&gt;":{"codepoints":[62],"characters":">"},"&gtcc;":{"codepoints":[10919],"characters":"\u2AA7"},"&gtcir;":{"codepoints":[10874],"characters":"\u2A7A"},"&gtdot;":{"codepoints":[8919],"characters":"\u22D7"},"&gtlPar;":{"codepoints":[10645],"characters":"\u2995"},"&gtquest;":{"codepoints":[10876],"characters":"\u2A7C"},"&gtrapprox;":{"codepoints":[10886],"characters":"\u2A86"},"&gtrarr;":{"codepoints":[10616],"characters":"\u2978"},"&gtrdot;":{"codepoints":[8919],"characters":"\u22D7"},"&gtreqless;":{"codepoints":[8923],"characters":"\u22DB"},"&gtreqqless;":{"codepoints":[10892],"characters":"\u2A8C"},"&gtrless;":{"codepoints":[8823],"characters":"\u2277"},"&gtrsim;":{"codepoints":[8819],"characters":"\u2273"},"&gvertneqq;":{"codepoints":[8809,65024],"characters":"\u2269\uFE00"},"&gvnE;":{"codepoints":[8809,65024],"characters":"\u2269\uFE00"},"&hArr;":{"codepoints":[8660],"characters":"\u21D4"},"&hairsp;":{"codepoints":[8202],"characters":"\u200A"},"&half;":{"codepoints":[189],"characters":"\xbd"},"&hamilt;":{"codepoints":[8459],"characters":"\u210B"},"&hardcy;":{"codepoints":[1098],"characters":"\u044A"},"&harr;":{"codepoints":[8596],"characters":"\u2194"},"&harrcir;":{"codepoints":[10568],"characters":"\u2948"},"&harrw;":{"codepoints":[8621],"characters":"\u21AD"},"&hbar;":{"codepoints":[8463],"characters":"\u210F"},"&hcirc;":{"codepoints":[293],"characters":"\u0125"},"&hearts;":{"codepoints":[9829],"characters":"\u2665"},"&heartsuit;":{"codepoints":[9829],"characters":"\u2665"},"&hellip;":{"codepoints":[8230],"characters":"\u2026"},"&hercon;":{"codepoints":[8889],"characters":"\u22B9"},"&hfr;":{"codepoints":[120101],"characters":"\uD835\uDD25"},"&hksearow;":{"codepoints":[10533],"characters":"\u2925"},"&hkswarow;":{"codepoints":[10534],"characters":"\u2926"},"&hoarr;":{"codepoints":[8703],"characters":"\u21FF"},"&homtht;":{"codepoints":[8763],"characters":"\u223B"},"&hookleftarrow;":{"codepoints":[8617],"characters":"\u21A9"},"&hookrightarrow;":{"codepoints":[8618],"characters":"\u21AA"},"&hopf;":{"codepoints":[120153],"characters":"\uD835\uDD59"},"&horbar;":{"codepoints":[8213],"characters":"\u2015"},"&hscr;":{"codepoints":[119997],"characters":"\uD835\uDCBD"},"&hslash;":{"codepoints":[8463],"characters":"\u210F"},"&hstrok;":{"codepoints":[295],"characters":"\u0127"},"&hybull;":{"codepoints":[8259],"characters":"\u2043"},"&hyphen;":{"codepoints":[8208],"characters":"\u2010"},"&iacute":{"codepoints":[237],"characters":"\xed"},"&iacute;":{"codepoints":[237],"characters":"\xed"},"&ic;":{"codepoints":[8291],"characters":"\u2063"},"&icirc":{"codepoints":[238],"characters":"\xee"},"&icirc;":{"codepoints":[238],"characters":"\xee"},"&icy;":{"codepoints":[1080],"characters":"\u0438"},"&iecy;":{"codepoints":[1077],"characters":"\u0435"},"&iexcl":{"codepoints":[161],"characters":"\xa1"},"&iexcl;":{"codepoints":[161],"characters":"\xa1"},"&iff;":{"codepoints":[8660],"characters":"\u21D4"},"&ifr;":{"codepoints":[120102],"characters":"\uD835\uDD26"},"&igrave":{"codepoints":[236],"characters":"\xec"},"&igrave;":{"codepoints":[236],"characters":"\xec"},"&ii;":{"codepoints":[8520],"characters":"\u2148"},"&iiiint;":{"codepoints":[10764],"characters":"\u2A0C"},"&iiint;":{"codepoints":[8749],"characters":"\u222D"},"&iinfin;":{"codepoints":[10716],"characters":"\u29DC"},"&iiota;":{"codepoints":[8489],"characters":"\u2129"},"&ijlig;":{"codepoints":[307],"characters":"\u0133"},"&imacr;":{"codepoints":[299],"characters":"\u012B"},"&image;":{"codepoints":[8465],"characters":"\u2111"},"&imagline;":{"codepoints":[8464],"characters":"\u2110"},"&imagpart;":{"codepoints":[8465],"characters":"\u2111"},"&imath;":{"codepoints":[305],"characters":"\u0131"},"&imof;":{"codepoints":[8887],"characters":"\u22B7"},"&imped;":{"codepoints":[437],"characters":"\u01B5"},"&in;":{"codepoints":[8712],"characters":"\u2208"},"&incare;":{"codepoints":[8453],"characters":"\u2105"},"&infin;":{"codepoints":[8734],"characters":"\u221E"},"&infintie;":{"codepoints":[10717],"characters":"\u29DD"},"&inodot;":{"codepoints":[305],"characters":"\u0131"},"&int;":{"codepoints":[8747],"characters":"\u222B"},"&intcal;":{"codepoints":[8890],"characters":"\u22BA"},"&integers;":{"codepoints":[8484],"characters":"\u2124"},"&intercal;":{"codepoints":[8890],"characters":"\u22BA"},"&intlarhk;":{"codepoints":[10775],"characters":"\u2A17"},"&intprod;":{"codepoints":[10812],"characters":"\u2A3C"},"&iocy;":{"codepoints":[1105],"characters":"\u0451"},"&iogon;":{"codepoints":[303],"characters":"\u012F"},"&iopf;":{"codepoints":[120154],"characters":"\uD835\uDD5A"},"&iota;":{"codepoints":[953],"characters":"\u03B9"},"&iprod;":{"codepoints":[10812],"characters":"\u2A3C"},"&iquest":{"codepoints":[191],"characters":"\xbf"},"&iquest;":{"codepoints":[191],"characters":"\xbf"},"&iscr;":{"codepoints":[119998],"characters":"\uD835\uDCBE"},"&isin;":{"codepoints":[8712],"characters":"\u2208"},"&isinE;":{"codepoints":[8953],"characters":"\u22F9"},"&isindot;":{"codepoints":[8949],"characters":"\u22F5"},"&isins;":{"codepoints":[8948],"characters":"\u22F4"},"&isinsv;":{"codepoints":[8947],"characters":"\u22F3"},"&isinv;":{"codepoints":[8712],"characters":"\u2208"},"&it;":{"codepoints":[8290],"characters":"\u2062"},"&itilde;":{"codepoints":[297],"characters":"\u0129"},"&iukcy;":{"codepoints":[1110],"characters":"\u0456"},"&iuml":{"codepoints":[239],"characters":"\xef"},"&iuml;":{"codepoints":[239],"characters":"\xef"},"&jcirc;":{"codepoints":[309],"characters":"\u0135"},"&jcy;":{"codepoints":[1081],"characters":"\u0439"},"&jfr;":{"codepoints":[120103],"characters":"\uD835\uDD27"},"&jmath;":{"codepoints":[567],"characters":"\u0237"},"&jopf;":{"codepoints":[120155],"characters":"\uD835\uDD5B"},"&jscr;":{"codepoints":[119999],"characters":"\uD835\uDCBF"},"&jsercy;":{"codepoints":[1112],"characters":"\u0458"},"&jukcy;":{"codepoints":[1108],"characters":"\u0454"},"&kappa;":{"codepoints":[954],"characters":"\u03BA"},"&kappav;":{"codepoints":[1008],"characters":"\u03F0"},"&kcedil;":{"codepoints":[311],"characters":"\u0137"},"&kcy;":{"codepoints":[1082],"characters":"\u043A"},"&kfr;":{"codepoints":[120104],"characters":"\uD835\uDD28"},"&kgreen;":{"codepoints":[312],"characters":"\u0138"},"&khcy;":{"codepoints":[1093],"characters":"\u0445"},"&kjcy;":{"codepoints":[1116],"characters":"\u045C"},"&kopf;":{"codepoints":[120156],"characters":"\uD835\uDD5C"},"&kscr;":{"codepoints":[120000],"characters":"\uD835\uDCC0"},"&lAarr;":{"codepoints":[8666],"characters":"\u21DA"},"&lArr;":{"codepoints":[8656],"characters":"\u21D0"},"&lAtail;":{"codepoints":[10523],"characters":"\u291B"},"&lBarr;":{"codepoints":[10510],"characters":"\u290E"},"&lE;":{"codepoints":[8806],"characters":"\u2266"},"&lEg;":{"codepoints":[10891],"characters":"\u2A8B"},"&lHar;":{"codepoints":[10594],"characters":"\u2962"},"&lacute;":{"codepoints":[314],"characters":"\u013A"},"&laemptyv;":{"codepoints":[10676],"characters":"\u29B4"},"&lagran;":{"codepoints":[8466],"characters":"\u2112"},"&lambda;":{"codepoints":[955],"characters":"\u03BB"},"&lang;":{"codepoints":[10216],"characters":"\u27E8"},"&langd;":{"codepoints":[10641],"characters":"\u2991"},"&langle;":{"codepoints":[10216],"characters":"\u27E8"},"&lap;":{"codepoints":[10885],"characters":"\u2A85"},"&laquo":{"codepoints":[171],"characters":"\xab"},"&laquo;":{"codepoints":[171],"characters":"\xab"},"&larr;":{"codepoints":[8592],"characters":"\u2190"},"&larrb;":{"codepoints":[8676],"characters":"\u21E4"},"&larrbfs;":{"codepoints":[10527],"characters":"\u291F"},"&larrfs;":{"codepoints":[10525],"characters":"\u291D"},"&larrhk;":{"codepoints":[8617],"characters":"\u21A9"},"&larrlp;":{"codepoints":[8619],"characters":"\u21AB"},"&larrpl;":{"codepoints":[10553],"characters":"\u2939"},"&larrsim;":{"codepoints":[10611],"characters":"\u2973"},"&larrtl;":{"codepoints":[8610],"characters":"\u21A2"},"&lat;":{"codepoints":[10923],"characters":"\u2AAB"},"&latail;":{"codepoints":[10521],"characters":"\u2919"},"&late;":{"codepoints":[10925],"characters":"\u2AAD"},"&lates;":{"codepoints":[10925,65024],"characters":"\u2AAD\uFE00"},"&lbarr;":{"codepoints":[10508],"characters":"\u290C"},"&lbbrk;":{"codepoints":[10098],"characters":"\u2772"},"&lbrace;":{"codepoints":[123],"characters":"{"},"&lbrack;":{"codepoints":[91],"characters":"["},"&lbrke;":{"codepoints":[10635],"characters":"\u298B"},"&lbrksld;":{"codepoints":[10639],"characters":"\u298F"},"&lbrkslu;":{"codepoints":[10637],"characters":"\u298D"},"&lcaron;":{"codepoints":[318],"characters":"\u013E"},"&lcedil;":{"codepoints":[316],"characters":"\u013C"},"&lceil;":{"codepoints":[8968],"characters":"\u2308"},"&lcub;":{"codepoints":[123],"characters":"{"},"&lcy;":{"codepoints":[1083],"characters":"\u043B"},"&ldca;":{"codepoints":[10550],"characters":"\u2936"},"&ldquo;":{"codepoints":[8220],"characters":"\u201C"},"&ldquor;":{"codepoints":[8222],"characters":"\u201E"},"&ldrdhar;":{"codepoints":[10599],"characters":"\u2967"},"&ldrushar;":{"codepoints":[10571],"characters":"\u294B"},"&ldsh;":{"codepoints":[8626],"characters":"\u21B2"},"&le;":{"codepoints":[8804],"characters":"\u2264"},"&leftarrow;":{"codepoints":[8592],"characters":"\u2190"},"&leftarrowtail;":{"codepoints":[8610],"characters":"\u21A2"},"&leftharpoondown;":{"codepoints":[8637],"characters":"\u21BD"},"&leftharpoonup;":{"codepoints":[8636],"characters":"\u21BC"},"&leftleftarrows;":{"codepoints":[8647],"characters":"\u21C7"},"&leftrightarrow;":{"codepoints":[8596],"characters":"\u2194"},"&leftrightarrows;":{"codepoints":[8646],"characters":"\u21C6"},"&leftrightharpoons;":{"codepoints":[8651],"characters":"\u21CB"},"&leftrightsquigarrow;":{"codepoints":[8621],"characters":"\u21AD"},"&leftthreetimes;":{"codepoints":[8907],"characters":"\u22CB"},"&leg;":{"codepoints":[8922],"characters":"\u22DA"},"&leq;":{"codepoints":[8804],"characters":"\u2264"},"&leqq;":{"codepoints":[8806],"characters":"\u2266"},"&leqslant;":{"codepoints":[10877],"characters":"\u2A7D"},"&les;":{"codepoints":[10877],"characters":"\u2A7D"},"&lescc;":{"codepoints":[10920],"characters":"\u2AA8"},"&lesdot;":{"codepoints":[10879],"characters":"\u2A7F"},"&lesdoto;":{"codepoints":[10881],"characters":"\u2A81"},"&lesdotor;":{"codepoints":[10883],"characters":"\u2A83"},"&lesg;":{"codepoints":[8922,65024],"characters":"\u22DA\uFE00"},"&lesges;":{"codepoints":[10899],"characters":"\u2A93"},"&lessapprox;":{"codepoints":[10885],"characters":"\u2A85"},"&lessdot;":{"codepoints":[8918],"characters":"\u22D6"},"&lesseqgtr;":{"codepoints":[8922],"characters":"\u22DA"},"&lesseqqgtr;":{"codepoints":[10891],"characters":"\u2A8B"},"&lessgtr;":{"codepoints":[8822],"characters":"\u2276"},"&lesssim;":{"codepoints":[8818],"characters":"\u2272"},"&lfisht;":{"codepoints":[10620],"characters":"\u297C"},"&lfloor;":{"codepoints":[8970],"characters":"\u230A"},"&lfr;":{"codepoints":[120105],"characters":"\uD835\uDD29"},"&lg;":{"codepoints":[8822],"characters":"\u2276"},"&lgE;":{"codepoints":[10897],"characters":"\u2A91"},"&lhard;":{"codepoints":[8637],"characters":"\u21BD"},"&lharu;":{"codepoints":[8636],"characters":"\u21BC"},"&lharul;":{"codepoints":[10602],"characters":"\u296A"},"&lhblk;":{"codepoints":[9604],"characters":"\u2584"},"&ljcy;":{"codepoints":[1113],"characters":"\u0459"},"&ll;":{"codepoints":[8810],"characters":"\u226A"},"&llarr;":{"codepoints":[8647],"characters":"\u21C7"},"&llcorner;":{"codepoints":[8990],"characters":"\u231E"},"&llhard;":{"codepoints":[10603],"characters":"\u296B"},"&lltri;":{"codepoints":[9722],"characters":"\u25FA"},"&lmidot;":{"codepoints":[320],"characters":"\u0140"},"&lmoust;":{"codepoints":[9136],"characters":"\u23B0"},"&lmoustache;":{"codepoints":[9136],"characters":"\u23B0"},"&lnE;":{"codepoints":[8808],"characters":"\u2268"},"&lnap;":{"codepoints":[10889],"characters":"\u2A89"},"&lnapprox;":{"codepoints":[10889],"characters":"\u2A89"},"&lne;":{"codepoints":[10887],"characters":"\u2A87"},"&lneq;":{"codepoints":[10887],"characters":"\u2A87"},"&lneqq;":{"codepoints":[8808],"characters":"\u2268"},"&lnsim;":{"codepoints":[8934],"characters":"\u22E6"},"&loang;":{"codepoints":[10220],"characters":"\u27EC"},"&loarr;":{"codepoints":[8701],"characters":"\u21FD"},"&lobrk;":{"codepoints":[10214],"characters":"\u27E6"},"&longleftarrow;":{"codepoints":[10229],"characters":"\u27F5"},"&longleftrightarrow;":{"codepoints":[10231],"characters":"\u27F7"},"&longmapsto;":{"codepoints":[10236],"characters":"\u27FC"},"&longrightarrow;":{"codepoints":[10230],"characters":"\u27F6"},"&looparrowleft;":{"codepoints":[8619],"characters":"\u21AB"},"&looparrowright;":{"codepoints":[8620],"characters":"\u21AC"},"&lopar;":{"codepoints":[10629],"characters":"\u2985"},"&lopf;":{"codepoints":[120157],"characters":"\uD835\uDD5D"},"&loplus;":{"codepoints":[10797],"characters":"\u2A2D"},"&lotimes;":{"codepoints":[10804],"characters":"\u2A34"},"&lowast;":{"codepoints":[8727],"characters":"\u2217"},"&lowbar;":{"codepoints":[95],"characters":"_"},"&loz;":{"codepoints":[9674],"characters":"\u25CA"},"&lozenge;":{"codepoints":[9674],"characters":"\u25CA"},"&lozf;":{"codepoints":[10731],"characters":"\u29EB"},"&lpar;":{"codepoints":[40],"characters":"("},"&lparlt;":{"codepoints":[10643],"characters":"\u2993"},"&lrarr;":{"codepoints":[8646],"characters":"\u21C6"},"&lrcorner;":{"codepoints":[8991],"characters":"\u231F"},"&lrhar;":{"codepoints":[8651],"characters":"\u21CB"},"&lrhard;":{"codepoints":[10605],"characters":"\u296D"},"&lrm;":{"codepoints":[8206],"characters":"\u200E"},"&lrtri;":{"codepoints":[8895],"characters":"\u22BF"},"&lsaquo;":{"codepoints":[8249],"characters":"\u2039"},"&lscr;":{"codepoints":[120001],"characters":"\uD835\uDCC1"},"&lsh;":{"codepoints":[8624],"characters":"\u21B0"},"&lsim;":{"codepoints":[8818],"characters":"\u2272"},"&lsime;":{"codepoints":[10893],"characters":"\u2A8D"},"&lsimg;":{"codepoints":[10895],"characters":"\u2A8F"},"&lsqb;":{"codepoints":[91],"characters":"["},"&lsquo;":{"codepoints":[8216],"characters":"\u2018"},"&lsquor;":{"codepoints":[8218],"characters":"\u201A"},"&lstrok;":{"codepoints":[322],"characters":"\u0142"},"&lt":{"codepoints":[60],"characters":"<"},"&lt;":{"codepoints":[60],"characters":"<"},"&ltcc;":{"codepoints":[10918],"characters":"\u2AA6"},"&ltcir;":{"codepoints":[10873],"characters":"\u2A79"},"&ltdot;":{"codepoints":[8918],"characters":"\u22D6"},"&lthree;":{"codepoints":[8907],"characters":"\u22CB"},"&ltimes;":{"codepoints":[8905],"characters":"\u22C9"},"&ltlarr;":{"codepoints":[10614],"characters":"\u2976"},"&ltquest;":{"codepoints":[10875],"characters":"\u2A7B"},"&ltrPar;":{"codepoints":[10646],"characters":"\u2996"},"&ltri;":{"codepoints":[9667],"characters":"\u25C3"},"&ltrie;":{"codepoints":[8884],"characters":"\u22B4"},"&ltrif;":{"codepoints":[9666],"characters":"\u25C2"},"&lurdshar;":{"codepoints":[10570],"characters":"\u294A"},"&luruhar;":{"codepoints":[10598],"characters":"\u2966"},"&lvertneqq;":{"codepoints":[8808,65024],"characters":"\u2268\uFE00"},"&lvnE;":{"codepoints":[8808,65024],"characters":"\u2268\uFE00"},"&mDDot;":{"codepoints":[8762],"characters":"\u223A"},"&macr":{"codepoints":[175],"characters":"\xaf"},"&macr;":{"codepoints":[175],"characters":"\xaf"},"&male;":{"codepoints":[9794],"characters":"\u2642"},"&malt;":{"codepoints":[10016],"characters":"\u2720"},"&maltese;":{"codepoints":[10016],"characters":"\u2720"},"&map;":{"codepoints":[8614],"characters":"\u21A6"},"&mapsto;":{"codepoints":[8614],"characters":"\u21A6"},"&mapstodown;":{"codepoints":[8615],"characters":"\u21A7"},"&mapstoleft;":{"codepoints":[8612],"characters":"\u21A4"},"&mapstoup;":{"codepoints":[8613],"characters":"\u21A5"},"&marker;":{"codepoints":[9646],"characters":"\u25AE"},"&mcomma;":{"codepoints":[10793],"characters":"\u2A29"},"&mcy;":{"codepoints":[1084],"characters":"\u043C"},"&mdash;":{"codepoints":[8212],"characters":"\u2014"},"&measuredangle;":{"codepoints":[8737],"characters":"\u2221"},"&mfr;":{"codepoints":[120106],"characters":"\uD835\uDD2A"},"&mho;":{"codepoints":[8487],"characters":"\u2127"},"&micro":{"codepoints":[181],"characters":"\xb5"},"&micro;":{"codepoints":[181],"characters":"\xb5"},"&mid;":{"codepoints":[8739],"characters":"\u2223"},"&midast;":{"codepoints":[42],"characters":"*"},"&midcir;":{"codepoints":[10992],"characters":"\u2AF0"},"&middot":{"codepoints":[183],"characters":"\xb7"},"&middot;":{"codepoints":[183],"characters":"\xb7"},"&minus;":{"codepoints":[8722],"characters":"\u2212"},"&minusb;":{"codepoints":[8863],"characters":"\u229F"},"&minusd;":{"codepoints":[8760],"characters":"\u2238"},"&minusdu;":{"codepoints":[10794],"characters":"\u2A2A"},"&mlcp;":{"codepoints":[10971],"characters":"\u2ADB"},"&mldr;":{"codepoints":[8230],"characters":"\u2026"},"&mnplus;":{"codepoints":[8723],"characters":"\u2213"},"&models;":{"codepoints":[8871],"characters":"\u22A7"},"&mopf;":{"codepoints":[120158],"characters":"\uD835\uDD5E"},"&mp;":{"codepoints":[8723],"characters":"\u2213"},"&mscr;":{"codepoints":[120002],"characters":"\uD835\uDCC2"},"&mstpos;":{"codepoints":[8766],"characters":"\u223E"},"&mu;":{"codepoints":[956],"characters":"\u03BC"},"&multimap;":{"codepoints":[8888],"characters":"\u22B8"},"&mumap;":{"codepoints":[8888],"characters":"\u22B8"},"&nGg;":{"codepoints":[8921,824],"characters":"\u22D9\u0338"},"&nGt;":{"codepoints":[8811,8402],"characters":"\u226B\u20D2"},"&nGtv;":{"codepoints":[8811,824],"characters":"\u226B\u0338"},"&nLeftarrow;":{"codepoints":[8653],"characters":"\u21CD"},"&nLeftrightarrow;":{"codepoints":[8654],"characters":"\u21CE"},"&nLl;":{"codepoints":[8920,824],"characters":"\u22D8\u0338"},"&nLt;":{"codepoints":[8810,8402],"characters":"\u226A\u20D2"},"&nLtv;":{"codepoints":[8810,824],"characters":"\u226A\u0338"},"&nRightarrow;":{"codepoints":[8655],"characters":"\u21CF"},"&nVDash;":{"codepoints":[8879],"characters":"\u22AF"},"&nVdash;":{"codepoints":[8878],"characters":"\u22AE"},"&nabla;":{"codepoints":[8711],"characters":"\u2207"},"&nacute;":{"codepoints":[324],"characters":"\u0144"},"&nang;":{"codepoints":[8736,8402],"characters":"\u2220\u20D2"},"&nap;":{"codepoints":[8777],"characters":"\u2249"},"&napE;":{"codepoints":[10864,824],"characters":"\u2A70\u0338"},"&napid;":{"codepoints":[8779,824],"characters":"\u224B\u0338"},"&napos;":{"codepoints":[329],"characters":"\u0149"},"&napprox;":{"codepoints":[8777],"characters":"\u2249"},"&natur;":{"codepoints":[9838],"characters":"\u266E"},"&natural;":{"codepoints":[9838],"characters":"\u266E"},"&naturals;":{"codepoints":[8469],"characters":"\u2115"},"&nbsp":{"codepoints":[160],"characters":"\xa0"},"&nbsp;":{"codepoints":[160],"characters":"\xa0"},"&nbump;":{"codepoints":[8782,824],"characters":"\u224E\u0338"},"&nbumpe;":{"codepoints":[8783,824],"characters":"\u224F\u0338"},"&ncap;":{"codepoints":[10819],"characters":"\u2A43"},"&ncaron;":{"codepoints":[328],"characters":"\u0148"},"&ncedil;":{"codepoints":[326],"characters":"\u0146"},"&ncong;":{"codepoints":[8775],"characters":"\u2247"},"&ncongdot;":{"codepoints":[10861,824],"characters":"\u2A6D\u0338"},"&ncup;":{"codepoints":[10818],"characters":"\u2A42"},"&ncy;":{"codepoints":[1085],"characters":"\u043D"},"&ndash;":{"codepoints":[8211],"characters":"\u2013"},"&ne;":{"codepoints":[8800],"characters":"\u2260"},"&neArr;":{"codepoints":[8663],"characters":"\u21D7"},"&nearhk;":{"codepoints":[10532],"characters":"\u2924"},"&nearr;":{"codepoints":[8599],"characters":"\u2197"},"&nearrow;":{"codepoints":[8599],"characters":"\u2197"},"&nedot;":{"codepoints":[8784,824],"characters":"\u2250\u0338"},"&nequiv;":{"codepoints":[8802],"characters":"\u2262"},"&nesear;":{"codepoints":[10536],"characters":"\u2928"},"&nesim;":{"codepoints":[8770,824],"characters":"\u2242\u0338"},"&nexist;":{"codepoints":[8708],"characters":"\u2204"},"&nexists;":{"codepoints":[8708],"characters":"\u2204"},"&nfr;":{"codepoints":[120107],"characters":"\uD835\uDD2B"},"&ngE;":{"codepoints":[8807,824],"characters":"\u2267\u0338"},"&nge;":{"codepoints":[8817],"characters":"\u2271"},"&ngeq;":{"codepoints":[8817],"characters":"\u2271"},"&ngeqq;":{"codepoints":[8807,824],"characters":"\u2267\u0338"},"&ngeqslant;":{"codepoints":[10878,824],"characters":"\u2A7E\u0338"},"&nges;":{"codepoints":[10878,824],"characters":"\u2A7E\u0338"},"&ngsim;":{"codepoints":[8821],"characters":"\u2275"},"&ngt;":{"codepoints":[8815],"characters":"\u226F"},"&ngtr;":{"codepoints":[8815],"characters":"\u226F"},"&nhArr;":{"codepoints":[8654],"characters":"\u21CE"},"&nharr;":{"codepoints":[8622],"characters":"\u21AE"},"&nhpar;":{"codepoints":[10994],"characters":"\u2AF2"},"&ni;":{"codepoints":[8715],"characters":"\u220B"},"&nis;":{"codepoints":[8956],"characters":"\u22FC"},"&nisd;":{"codepoints":[8954],"characters":"\u22FA"},"&niv;":{"codepoints":[8715],"characters":"\u220B"},"&njcy;":{"codepoints":[1114],"characters":"\u045A"},"&nlArr;":{"codepoints":[8653],"characters":"\u21CD"},"&nlE;":{"codepoints":[8806,824],"characters":"\u2266\u0338"},"&nlarr;":{"codepoints":[8602],"characters":"\u219A"},"&nldr;":{"codepoints":[8229],"characters":"\u2025"},"&nle;":{"codepoints":[8816],"characters":"\u2270"},"&nleftarrow;":{"codepoints":[8602],"characters":"\u219A"},"&nleftrightarrow;":{"codepoints":[8622],"characters":"\u21AE"},"&nleq;":{"codepoints":[8816],"characters":"\u2270"},"&nleqq;":{"codepoints":[8806,824],"characters":"\u2266\u0338"},"&nleqslant;":{"codepoints":[10877,824],"characters":"\u2A7D\u0338"},"&nles;":{"codepoints":[10877,824],"characters":"\u2A7D\u0338"},"&nless;":{"codepoints":[8814],"characters":"\u226E"},"&nlsim;":{"codepoints":[8820],"characters":"\u2274"},"&nlt;":{"codepoints":[8814],"characters":"\u226E"},"&nltri;":{"codepoints":[8938],"characters":"\u22EA"},"&nltrie;":{"codepoints":[8940],"characters":"\u22EC"},"&nmid;":{"codepoints":[8740],"characters":"\u2224"},"&nopf;":{"codepoints":[120159],"characters":"\uD835\uDD5F"},"&not":{"codepoints":[172],"characters":"\xac"},"&not;":{"codepoints":[172],"characters":"\xac"},"&notin;":{"codepoints":[8713],"characters":"\u2209"},"&notinE;":{"codepoints":[8953,824],"characters":"\u22F9\u0338"},"&notindot;":{"codepoints":[8949,824],"characters":"\u22F5\u0338"},"&notinva;":{"codepoints":[8713],"characters":"\u2209"},"&notinvb;":{"codepoints":[8951],"characters":"\u22F7"},"&notinvc;":{"codepoints":[8950],"characters":"\u22F6"},"&notni;":{"codepoints":[8716],"characters":"\u220C"},"&notniva;":{"codepoints":[8716],"characters":"\u220C"},"&notnivb;":{"codepoints":[8958],"characters":"\u22FE"},"&notnivc;":{"codepoints":[8957],"characters":"\u22FD"},"&npar;":{"codepoints":[8742],"characters":"\u2226"},"&nparallel;":{"codepoints":[8742],"characters":"\u2226"},"&nparsl;":{"codepoints":[11005,8421],"characters":"\u2AFD\u20E5"},"&npart;":{"codepoints":[8706,824],"characters":"\u2202\u0338"},"&npolint;":{"codepoints":[10772],"characters":"\u2A14"},"&npr;":{"codepoints":[8832],"characters":"\u2280"},"&nprcue;":{"codepoints":[8928],"characters":"\u22E0"},"&npre;":{"codepoints":[10927,824],"characters":"\u2AAF\u0338"},"&nprec;":{"codepoints":[8832],"characters":"\u2280"},"&npreceq;":{"codepoints":[10927,824],"characters":"\u2AAF\u0338"},"&nrArr;":{"codepoints":[8655],"characters":"\u21CF"},"&nrarr;":{"codepoints":[8603],"characters":"\u219B"},"&nrarrc;":{"codepoints":[10547,824],"characters":"\u2933\u0338"},"&nrarrw;":{"codepoints":[8605,824],"characters":"\u219D\u0338"},"&nrightarrow;":{"codepoints":[8603],"characters":"\u219B"},"&nrtri;":{"codepoints":[8939],"characters":"\u22EB"},"&nrtrie;":{"codepoints":[8941],"characters":"\u22ED"},"&nsc;":{"codepoints":[8833],"characters":"\u2281"},"&nsccue;":{"codepoints":[8929],"characters":"\u22E1"},"&nsce;":{"codepoints":[10928,824],"characters":"\u2AB0\u0338"},"&nscr;":{"codepoints":[120003],"characters":"\uD835\uDCC3"},"&nshortmid;":{"codepoints":[8740],"characters":"\u2224"},"&nshortparallel;":{"codepoints":[8742],"characters":"\u2226"},"&nsim;":{"codepoints":[8769],"characters":"\u2241"},"&nsime;":{"codepoints":[8772],"characters":"\u2244"},"&nsimeq;":{"codepoints":[8772],"characters":"\u2244"},"&nsmid;":{"codepoints":[8740],"characters":"\u2224"},"&nspar;":{"codepoints":[8742],"characters":"\u2226"},"&nsqsube;":{"codepoints":[8930],"characters":"\u22E2"},"&nsqsupe;":{"codepoints":[8931],"characters":"\u22E3"},"&nsub;":{"codepoints":[8836],"characters":"\u2284"},"&nsubE;":{"codepoints":[10949,824],"characters":"\u2AC5\u0338"},"&nsube;":{"codepoints":[8840],"characters":"\u2288"},"&nsubset;":{"codepoints":[8834,8402],"characters":"\u2282\u20D2"},"&nsubseteq;":{"codepoints":[8840],"characters":"\u2288"},"&nsubseteqq;":{"codepoints":[10949,824],"characters":"\u2AC5\u0338"},"&nsucc;":{"codepoints":[8833],"characters":"\u2281"},"&nsucceq;":{"codepoints":[10928,824],"characters":"\u2AB0\u0338"},"&nsup;":{"codepoints":[8837],"characters":"\u2285"},"&nsupE;":{"codepoints":[10950,824],"characters":"\u2AC6\u0338"},"&nsupe;":{"codepoints":[8841],"characters":"\u2289"},"&nsupset;":{"codepoints":[8835,8402],"characters":"\u2283\u20D2"},"&nsupseteq;":{"codepoints":[8841],"characters":"\u2289"},"&nsupseteqq;":{"codepoints":[10950,824],"characters":"\u2AC6\u0338"},"&ntgl;":{"codepoints":[8825],"characters":"\u2279"},"&ntilde":{"codepoints":[241],"characters":"\xf1"},"&ntilde;":{"codepoints":[241],"characters":"\xf1"},"&ntlg;":{"codepoints":[8824],"characters":"\u2278"},"&ntriangleleft;":{"codepoints":[8938],"characters":"\u22EA"},"&ntrianglelefteq;":{"codepoints":[8940],"characters":"\u22EC"},"&ntriangleright;":{"codepoints":[8939],"characters":"\u22EB"},"&ntrianglerighteq;":{"codepoints":[8941],"characters":"\u22ED"},"&nu;":{"codepoints":[957],"characters":"\u03BD"},"&num;":{"codepoints":[35],"characters":"#"},"&numero;":{"codepoints":[8470],"characters":"\u2116"},"&numsp;":{"codepoints":[8199],"characters":"\u2007"},"&nvDash;":{"codepoints":[8877],"characters":"\u22AD"},"&nvHarr;":{"codepoints":[10500],"characters":"\u2904"},"&nvap;":{"codepoints":[8781,8402],"characters":"\u224D\u20D2"},"&nvdash;":{"codepoints":[8876],"characters":"\u22AC"},"&nvge;":{"codepoints":[8805,8402],"characters":"\u2265\u20D2"},"&nvgt;":{"codepoints":[62,8402],"characters":">\u20D2"},"&nvinfin;":{"codepoints":[10718],"characters":"\u29DE"},"&nvlArr;":{"codepoints":[10498],"characters":"\u2902"},"&nvle;":{"codepoints":[8804,8402],"characters":"\u2264\u20D2"},"&nvlt;":{"codepoints":[60,8402],"characters":"<\u20D2"},"&nvltrie;":{"codepoints":[8884,8402],"characters":"\u22B4\u20D2"},"&nvrArr;":{"codepoints":[10499],"characters":"\u2903"},"&nvrtrie;":{"codepoints":[8885,8402],"characters":"\u22B5\u20D2"},"&nvsim;":{"codepoints":[8764,8402],"characters":"\u223C\u20D2"},"&nwArr;":{"codepoints":[8662],"characters":"\u21D6"},"&nwarhk;":{"codepoints":[10531],"characters":"\u2923"},"&nwarr;":{"codepoints":[8598],"characters":"\u2196"},"&nwarrow;":{"codepoints":[8598],"characters":"\u2196"},"&nwnear;":{"codepoints":[10535],"characters":"\u2927"},"&oS;":{"codepoints":[9416],"characters":"\u24C8"},"&oacute":{"codepoints":[243],"characters":"\xf3"},"&oacute;":{"codepoints":[243],"characters":"\xf3"},"&oast;":{"codepoints":[8859],"characters":"\u229B"},"&ocir;":{"codepoints":[8858],"characters":"\u229A"},"&ocirc":{"codepoints":[244],"characters":"\xf4"},"&ocirc;":{"codepoints":[244],"characters":"\xf4"},"&ocy;":{"codepoints":[1086],"characters":"\u043E"},"&odash;":{"codepoints":[8861],"characters":"\u229D"},"&odblac;":{"codepoints":[337],"characters":"\u0151"},"&odiv;":{"codepoints":[10808],"characters":"\u2A38"},"&odot;":{"codepoints":[8857],"characters":"\u2299"},"&odsold;":{"codepoints":[10684],"characters":"\u29BC"},"&oelig;":{"codepoints":[339],"characters":"\u0153"},"&ofcir;":{"codepoints":[10687],"characters":"\u29BF"},"&ofr;":{"codepoints":[120108],"characters":"\uD835\uDD2C"},"&ogon;":{"codepoints":[731],"characters":"\u02DB"},"&ograve":{"codepoints":[242],"characters":"\xf2"},"&ograve;":{"codepoints":[242],"characters":"\xf2"},"&ogt;":{"codepoints":[10689],"characters":"\u29C1"},"&ohbar;":{"codepoints":[10677],"characters":"\u29B5"},"&ohm;":{"codepoints":[937],"characters":"\u03A9"},"&oint;":{"codepoints":[8750],"characters":"\u222E"},"&olarr;":{"codepoints":[8634],"characters":"\u21BA"},"&olcir;":{"codepoints":[10686],"characters":"\u29BE"},"&olcross;":{"codepoints":[10683],"characters":"\u29BB"},"&oline;":{"codepoints":[8254],"characters":"\u203E"},"&olt;":{"codepoints":[10688],"characters":"\u29C0"},"&omacr;":{"codepoints":[333],"characters":"\u014D"},"&omega;":{"codepoints":[969],"characters":"\u03C9"},"&omicron;":{"codepoints":[959],"characters":"\u03BF"},"&omid;":{"codepoints":[10678],"characters":"\u29B6"},"&ominus;":{"codepoints":[8854],"characters":"\u2296"},"&oopf;":{"codepoints":[120160],"characters":"\uD835\uDD60"},"&opar;":{"codepoints":[10679],"characters":"\u29B7"},"&operp;":{"codepoints":[10681],"characters":"\u29B9"},"&oplus;":{"codepoints":[8853],"characters":"\u2295"},"&or;":{"codepoints":[8744],"characters":"\u2228"},"&orarr;":{"codepoints":[8635],"characters":"\u21BB"},"&ord;":{"codepoints":[10845],"characters":"\u2A5D"},"&order;":{"codepoints":[8500],"characters":"\u2134"},"&orderof;":{"codepoints":[8500],"characters":"\u2134"},"&ordf":{"codepoints":[170],"characters":"\xaa"},"&ordf;":{"codepoints":[170],"characters":"\xaa"},"&ordm":{"codepoints":[186],"characters":"\xba"},"&ordm;":{"codepoints":[186],"characters":"\xba"},"&origof;":{"codepoints":[8886],"characters":"\u22B6"},"&oror;":{"codepoints":[10838],"characters":"\u2A56"},"&orslope;":{"codepoints":[10839],"characters":"\u2A57"},"&orv;":{"codepoints":[10843],"characters":"\u2A5B"},"&oscr;":{"codepoints":[8500],"characters":"\u2134"},"&oslash":{"codepoints":[248],"characters":"\xf8"},"&oslash;":{"codepoints":[248],"characters":"\xf8"},"&osol;":{"codepoints":[8856],"characters":"\u2298"},"&otilde":{"codepoints":[245],"characters":"\xf5"},"&otilde;":{"codepoints":[245],"characters":"\xf5"},"&otimes;":{"codepoints":[8855],"characters":"\u2297"},"&otimesas;":{"codepoints":[10806],"characters":"\u2A36"},"&ouml":{"codepoints":[246],"characters":"\xf6"},"&ouml;":{"codepoints":[246],"characters":"\xf6"},"&ovbar;":{"codepoints":[9021],"characters":"\u233D"},"&par;":{"codepoints":[8741],"characters":"\u2225"},"&para":{"codepoints":[182],"characters":"\xb6"},"&para;":{"codepoints":[182],"characters":"\xb6"},"&parallel;":{"codepoints":[8741],"characters":"\u2225"},"&parsim;":{"codepoints":[10995],"characters":"\u2AF3"},"&parsl;":{"codepoints":[11005],"characters":"\u2AFD"},"&part;":{"codepoints":[8706],"characters":"\u2202"},"&pcy;":{"codepoints":[1087],"characters":"\u043F"},"&percnt;":{"codepoints":[37],"characters":"%"},"&period;":{"codepoints":[46],"characters":"."},"&permil;":{"codepoints":[8240],"characters":"\u2030"},"&perp;":{"codepoints":[8869],"characters":"\u22A5"},"&pertenk;":{"codepoints":[8241],"characters":"\u2031"},"&pfr;":{"codepoints":[120109],"characters":"\uD835\uDD2D"},"&phi;":{"codepoints":[966],"characters":"\u03C6"},"&phiv;":{"codepoints":[981],"characters":"\u03D5"},"&phmmat;":{"codepoints":[8499],"characters":"\u2133"},"&phone;":{"codepoints":[9742],"characters":"\u260E"},"&pi;":{"codepoints":[960],"characters":"\u03C0"},"&pitchfork;":{"codepoints":[8916],"characters":"\u22D4"},"&piv;":{"codepoints":[982],"characters":"\u03D6"},"&planck;":{"codepoints":[8463],"characters":"\u210F"},"&planckh;":{"codepoints":[8462],"characters":"\u210E"},"&plankv;":{"codepoints":[8463],"characters":"\u210F"},"&plus;":{"codepoints":[43],"characters":"+"},"&plusacir;":{"codepoints":[10787],"characters":"\u2A23"},"&plusb;":{"codepoints":[8862],"characters":"\u229E"},"&pluscir;":{"codepoints":[10786],"characters":"\u2A22"},"&plusdo;":{"codepoints":[8724],"characters":"\u2214"},"&plusdu;":{"codepoints":[10789],"characters":"\u2A25"},"&pluse;":{"codepoints":[10866],"characters":"\u2A72"},"&plusmn":{"codepoints":[177],"characters":"\xb1"},"&plusmn;":{"codepoints":[177],"characters":"\xb1"},"&plussim;":{"codepoints":[10790],"characters":"\u2A26"},"&plustwo;":{"codepoints":[10791],"characters":"\u2A27"},"&pm;":{"codepoints":[177],"characters":"\xb1"},"&pointint;":{"codepoints":[10773],"characters":"\u2A15"},"&popf;":{"codepoints":[120161],"characters":"\uD835\uDD61"},"&pound":{"codepoints":[163],"characters":"\xa3"},"&pound;":{"codepoints":[163],"characters":"\xa3"},"&pr;":{"codepoints":[8826],"characters":"\u227A"},"&prE;":{"codepoints":[10931],"characters":"\u2AB3"},"&prap;":{"codepoints":[10935],"characters":"\u2AB7"},"&prcue;":{"codepoints":[8828],"characters":"\u227C"},"&pre;":{"codepoints":[10927],"characters":"\u2AAF"},"&prec;":{"codepoints":[8826],"characters":"\u227A"},"&precapprox;":{"codepoints":[10935],"characters":"\u2AB7"},"&preccurlyeq;":{"codepoints":[8828],"characters":"\u227C"},"&preceq;":{"codepoints":[10927],"characters":"\u2AAF"},"&precnapprox;":{"codepoints":[10937],"characters":"\u2AB9"},"&precneqq;":{"codepoints":[10933],"characters":"\u2AB5"},"&precnsim;":{"codepoints":[8936],"characters":"\u22E8"},"&precsim;":{"codepoints":[8830],"characters":"\u227E"},"&prime;":{"codepoints":[8242],"characters":"\u2032"},"&primes;":{"codepoints":[8473],"characters":"\u2119"},"&prnE;":{"codepoints":[10933],"characters":"\u2AB5"},"&prnap;":{"codepoints":[10937],"characters":"\u2AB9"},"&prnsim;":{"codepoints":[8936],"characters":"\u22E8"},"&prod;":{"codepoints":[8719],"characters":"\u220F"},"&profalar;":{"codepoints":[9006],"characters":"\u232E"},"&profline;":{"codepoints":[8978],"characters":"\u2312"},"&profsurf;":{"codepoints":[8979],"characters":"\u2313"},"&prop;":{"codepoints":[8733],"characters":"\u221D"},"&propto;":{"codepoints":[8733],"characters":"\u221D"},"&prsim;":{"codepoints":[8830],"characters":"\u227E"},"&prurel;":{"codepoints":[8880],"characters":"\u22B0"},"&pscr;":{"codepoints":[120005],"characters":"\uD835\uDCC5"},"&psi;":{"codepoints":[968],"characters":"\u03C8"},"&puncsp;":{"codepoints":[8200],"characters":"\u2008"},"&qfr;":{"codepoints":[120110],"characters":"\uD835\uDD2E"},"&qint;":{"codepoints":[10764],"characters":"\u2A0C"},"&qopf;":{"codepoints":[120162],"characters":"\uD835\uDD62"},"&qprime;":{"codepoints":[8279],"characters":"\u2057"},"&qscr;":{"codepoints":[120006],"characters":"\uD835\uDCC6"},"&quaternions;":{"codepoints":[8461],"characters":"\u210D"},"&quatint;":{"codepoints":[10774],"characters":"\u2A16"},"&quest;":{"codepoints":[63],"characters":"?"},"&questeq;":{"codepoints":[8799],"characters":"\u225F"},"&quot":{"codepoints":[34],"characters":"\\""},"&quot;":{"codepoints":[34],"characters":"\\""},"&rAarr;":{"codepoints":[8667],"characters":"\u21DB"},"&rArr;":{"codepoints":[8658],"characters":"\u21D2"},"&rAtail;":{"codepoints":[10524],"characters":"\u291C"},"&rBarr;":{"codepoints":[10511],"characters":"\u290F"},"&rHar;":{"codepoints":[10596],"characters":"\u2964"},"&race;":{"codepoints":[8765,817],"characters":"\u223D\u0331"},"&racute;":{"codepoints":[341],"characters":"\u0155"},"&radic;":{"codepoints":[8730],"characters":"\u221A"},"&raemptyv;":{"codepoints":[10675],"characters":"\u29B3"},"&rang;":{"codepoints":[10217],"characters":"\u27E9"},"&rangd;":{"codepoints":[10642],"characters":"\u2992"},"&range;":{"codepoints":[10661],"characters":"\u29A5"},"&rangle;":{"codepoints":[10217],"characters":"\u27E9"},"&raquo":{"codepoints":[187],"characters":"\xbb"},"&raquo;":{"codepoints":[187],"characters":"\xbb"},"&rarr;":{"codepoints":[8594],"characters":"\u2192"},"&rarrap;":{"codepoints":[10613],"characters":"\u2975"},"&rarrb;":{"codepoints":[8677],"characters":"\u21E5"},"&rarrbfs;":{"codepoints":[10528],"characters":"\u2920"},"&rarrc;":{"codepoints":[10547],"characters":"\u2933"},"&rarrfs;":{"codepoints":[10526],"characters":"\u291E"},"&rarrhk;":{"codepoints":[8618],"characters":"\u21AA"},"&rarrlp;":{"codepoints":[8620],"characters":"\u21AC"},"&rarrpl;":{"codepoints":[10565],"characters":"\u2945"},"&rarrsim;":{"codepoints":[10612],"characters":"\u2974"},"&rarrtl;":{"codepoints":[8611],"characters":"\u21A3"},"&rarrw;":{"codepoints":[8605],"characters":"\u219D"},"&ratail;":{"codepoints":[10522],"characters":"\u291A"},"&ratio;":{"codepoints":[8758],"characters":"\u2236"},"&rationals;":{"codepoints":[8474],"characters":"\u211A"},"&rbarr;":{"codepoints":[10509],"characters":"\u290D"},"&rbbrk;":{"codepoints":[10099],"characters":"\u2773"},"&rbrace;":{"codepoints":[125],"characters":"}"},"&rbrack;":{"codepoints":[93],"characters":"]"},"&rbrke;":{"codepoints":[10636],"characters":"\u298C"},"&rbrksld;":{"codepoints":[10638],"characters":"\u298E"},"&rbrkslu;":{"codepoints":[10640],"characters":"\u2990"},"&rcaron;":{"codepoints":[345],"characters":"\u0159"},"&rcedil;":{"codepoints":[343],"characters":"\u0157"},"&rceil;":{"codepoints":[8969],"characters":"\u2309"},"&rcub;":{"codepoints":[125],"characters":"}"},"&rcy;":{"codepoints":[1088],"characters":"\u0440"},"&rdca;":{"codepoints":[10551],"characters":"\u2937"},"&rdldhar;":{"codepoints":[10601],"characters":"\u2969"},"&rdquo;":{"codepoints":[8221],"characters":"\u201D"},"&rdquor;":{"codepoints":[8221],"characters":"\u201D"},"&rdsh;":{"codepoints":[8627],"characters":"\u21B3"},"&real;":{"codepoints":[8476],"characters":"\u211C"},"&realine;":{"codepoints":[8475],"characters":"\u211B"},"&realpart;":{"codepoints":[8476],"characters":"\u211C"},"&reals;":{"codepoints":[8477],"characters":"\u211D"},"&rect;":{"codepoints":[9645],"characters":"\u25AD"},"&reg":{"codepoints":[174],"characters":"\xae"},"&reg;":{"codepoints":[174],"characters":"\xae"},"&rfisht;":{"codepoints":[10621],"characters":"\u297D"},"&rfloor;":{"codepoints":[8971],"characters":"\u230B"},"&rfr;":{"codepoints":[120111],"characters":"\uD835\uDD2F"},"&rhard;":{"codepoints":[8641],"characters":"\u21C1"},"&rharu;":{"codepoints":[8640],"characters":"\u21C0"},"&rharul;":{"codepoints":[10604],"characters":"\u296C"},"&rho;":{"codepoints":[961],"characters":"\u03C1"},"&rhov;":{"codepoints":[1009],"characters":"\u03F1"},"&rightarrow;":{"codepoints":[8594],"characters":"\u2192"},"&rightarrowtail;":{"codepoints":[8611],"characters":"\u21A3"},"&rightharpoondown;":{"codepoints":[8641],"characters":"\u21C1"},"&rightharpoonup;":{"codepoints":[8640],"characters":"\u21C0"},"&rightleftarrows;":{"codepoints":[8644],"characters":"\u21C4"},"&rightleftharpoons;":{"codepoints":[8652],"characters":"\u21CC"},"&rightrightarrows;":{"codepoints":[8649],"characters":"\u21C9"},"&rightsquigarrow;":{"codepoints":[8605],"characters":"\u219D"},"&rightthreetimes;":{"codepoints":[8908],"characters":"\u22CC"},"&ring;":{"codepoints":[730],"characters":"\u02DA"},"&risingdotseq;":{"codepoints":[8787],"characters":"\u2253"},"&rlarr;":{"codepoints":[8644],"characters":"\u21C4"},"&rlhar;":{"codepoints":[8652],"characters":"\u21CC"},"&rlm;":{"codepoints":[8207],"characters":"\u200F"},"&rmoust;":{"codepoints":[9137],"characters":"\u23B1"},"&rmoustache;":{"codepoints":[9137],"characters":"\u23B1"},"&rnmid;":{"codepoints":[10990],"characters":"\u2AEE"},"&roang;":{"codepoints":[10221],"characters":"\u27ED"},"&roarr;":{"codepoints":[8702],"characters":"\u21FE"},"&robrk;":{"codepoints":[10215],"characters":"\u27E7"},"&ropar;":{"codepoints":[10630],"characters":"\u2986"},"&ropf;":{"codepoints":[120163],"characters":"\uD835\uDD63"},"&roplus;":{"codepoints":[10798],"characters":"\u2A2E"},"&rotimes;":{"codepoints":[10805],"characters":"\u2A35"},"&rpar;":{"codepoints":[41],"characters":")"},"&rpargt;":{"codepoints":[10644],"characters":"\u2994"},"&rppolint;":{"codepoints":[10770],"characters":"\u2A12"},"&rrarr;":{"codepoints":[8649],"characters":"\u21C9"},"&rsaquo;":{"codepoints":[8250],"characters":"\u203A"},"&rscr;":{"codepoints":[120007],"characters":"\uD835\uDCC7"},"&rsh;":{"codepoints":[8625],"characters":"\u21B1"},"&rsqb;":{"codepoints":[93],"characters":"]"},"&rsquo;":{"codepoints":[8217],"characters":"\u2019"},"&rsquor;":{"codepoints":[8217],"characters":"\u2019"},"&rthree;":{"codepoints":[8908],"characters":"\u22CC"},"&rtimes;":{"codepoints":[8906],"characters":"\u22CA"},"&rtri;":{"codepoints":[9657],"characters":"\u25B9"},"&rtrie;":{"codepoints":[8885],"characters":"\u22B5"},"&rtrif;":{"codepoints":[9656],"characters":"\u25B8"},"&rtriltri;":{"codepoints":[10702],"characters":"\u29CE"},"&ruluhar;":{"codepoints":[10600],"characters":"\u2968"},"&rx;":{"codepoints":[8478],"characters":"\u211E"},"&sacute;":{"codepoints":[347],"characters":"\u015B"},"&sbquo;":{"codepoints":[8218],"characters":"\u201A"},"&sc;":{"codepoints":[8827],"characters":"\u227B"},"&scE;":{"codepoints":[10932],"characters":"\u2AB4"},"&scap;":{"codepoints":[10936],"characters":"\u2AB8"},"&scaron;":{"codepoints":[353],"characters":"\u0161"},"&sccue;":{"codepoints":[8829],"characters":"\u227D"},"&sce;":{"codepoints":[10928],"characters":"\u2AB0"},"&scedil;":{"codepoints":[351],"characters":"\u015F"},"&scirc;":{"codepoints":[349],"characters":"\u015D"},"&scnE;":{"codepoints":[10934],"characters":"\u2AB6"},"&scnap;":{"codepoints":[10938],"characters":"\u2ABA"},"&scnsim;":{"codepoints":[8937],"characters":"\u22E9"},"&scpolint;":{"codepoints":[10771],"characters":"\u2A13"},"&scsim;":{"codepoints":[8831],"characters":"\u227F"},"&scy;":{"codepoints":[1089],"characters":"\u0441"},"&sdot;":{"codepoints":[8901],"characters":"\u22C5"},"&sdotb;":{"codepoints":[8865],"characters":"\u22A1"},"&sdote;":{"codepoints":[10854],"characters":"\u2A66"},"&seArr;":{"codepoints":[8664],"characters":"\u21D8"},"&searhk;":{"codepoints":[10533],"characters":"\u2925"},"&searr;":{"codepoints":[8600],"characters":"\u2198"},"&searrow;":{"codepoints":[8600],"characters":"\u2198"},"&sect":{"codepoints":[167],"characters":"\xa7"},"&sect;":{"codepoints":[167],"characters":"\xa7"},"&semi;":{"codepoints":[59],"characters":";"},"&seswar;":{"codepoints":[10537],"characters":"\u2929"},"&setminus;":{"codepoints":[8726],"characters":"\u2216"},"&setmn;":{"codepoints":[8726],"characters":"\u2216"},"&sext;":{"codepoints":[10038],"characters":"\u2736"},"&sfr;":{"codepoints":[120112],"characters":"\uD835\uDD30"},"&sfrown;":{"codepoints":[8994],"characters":"\u2322"},"&sharp;":{"codepoints":[9839],"characters":"\u266F"},"&shchcy;":{"codepoints":[1097],"characters":"\u0449"},"&shcy;":{"codepoints":[1096],"characters":"\u0448"},"&shortmid;":{"codepoints":[8739],"characters":"\u2223"},"&shortparallel;":{"codepoints":[8741],"characters":"\u2225"},"&shy":{"codepoints":[173],"characters":"\xad"},"&shy;":{"codepoints":[173],"characters":"\xad"},"&sigma;":{"codepoints":[963],"characters":"\u03C3"},"&sigmaf;":{"codepoints":[962],"characters":"\u03C2"},"&sigmav;":{"codepoints":[962],"characters":"\u03C2"},"&sim;":{"codepoints":[8764],"characters":"\u223C"},"&simdot;":{"codepoints":[10858],"characters":"\u2A6A"},"&sime;":{"codepoints":[8771],"characters":"\u2243"},"&simeq;":{"codepoints":[8771],"characters":"\u2243"},"&simg;":{"codepoints":[10910],"characters":"\u2A9E"},"&simgE;":{"codepoints":[10912],"characters":"\u2AA0"},"&siml;":{"codepoints":[10909],"characters":"\u2A9D"},"&simlE;":{"codepoints":[10911],"characters":"\u2A9F"},"&simne;":{"codepoints":[8774],"characters":"\u2246"},"&simplus;":{"codepoints":[10788],"characters":"\u2A24"},"&simrarr;":{"codepoints":[10610],"characters":"\u2972"},"&slarr;":{"codepoints":[8592],"characters":"\u2190"},"&smallsetminus;":{"codepoints":[8726],"characters":"\u2216"},"&smashp;":{"codepoints":[10803],"characters":"\u2A33"},"&smeparsl;":{"codepoints":[10724],"characters":"\u29E4"},"&smid;":{"codepoints":[8739],"characters":"\u2223"},"&smile;":{"codepoints":[8995],"characters":"\u2323"},"&smt;":{"codepoints":[10922],"characters":"\u2AAA"},"&smte;":{"codepoints":[10924],"characters":"\u2AAC"},"&smtes;":{"codepoints":[10924,65024],"characters":"\u2AAC\uFE00"},"&softcy;":{"codepoints":[1100],"characters":"\u044C"},"&sol;":{"codepoints":[47],"characters":"/"},"&solb;":{"codepoints":[10692],"characters":"\u29C4"},"&solbar;":{"codepoints":[9023],"characters":"\u233F"},"&sopf;":{"codepoints":[120164],"characters":"\uD835\uDD64"},"&spades;":{"codepoints":[9824],"characters":"\u2660"},"&spadesuit;":{"codepoints":[9824],"characters":"\u2660"},"&spar;":{"codepoints":[8741],"characters":"\u2225"},"&sqcap;":{"codepoints":[8851],"characters":"\u2293"},"&sqcaps;":{"codepoints":[8851,65024],"characters":"\u2293\uFE00"},"&sqcup;":{"codepoints":[8852],"characters":"\u2294"},"&sqcups;":{"codepoints":[8852,65024],"characters":"\u2294\uFE00"},"&sqsub;":{"codepoints":[8847],"characters":"\u228F"},"&sqsube;":{"codepoints":[8849],"characters":"\u2291"},"&sqsubset;":{"codepoints":[8847],"characters":"\u228F"},"&sqsubseteq;":{"codepoints":[8849],"characters":"\u2291"},"&sqsup;":{"codepoints":[8848],"characters":"\u2290"},"&sqsupe;":{"codepoints":[8850],"characters":"\u2292"},"&sqsupset;":{"codepoints":[8848],"characters":"\u2290"},"&sqsupseteq;":{"codepoints":[8850],"characters":"\u2292"},"&squ;":{"codepoints":[9633],"characters":"\u25A1"},"&square;":{"codepoints":[9633],"characters":"\u25A1"},"&squarf;":{"codepoints":[9642],"characters":"\u25AA"},"&squf;":{"codepoints":[9642],"characters":"\u25AA"},"&srarr;":{"codepoints":[8594],"characters":"\u2192"},"&sscr;":{"codepoints":[120008],"characters":"\uD835\uDCC8"},"&ssetmn;":{"codepoints":[8726],"characters":"\u2216"},"&ssmile;":{"codepoints":[8995],"characters":"\u2323"},"&sstarf;":{"codepoints":[8902],"characters":"\u22C6"},"&star;":{"codepoints":[9734],"characters":"\u2606"},"&starf;":{"codepoints":[9733],"characters":"\u2605"},"&straightepsilon;":{"codepoints":[1013],"characters":"\u03F5"},"&straightphi;":{"codepoints":[981],"characters":"\u03D5"},"&strns;":{"codepoints":[175],"characters":"\xaf"},"&sub;":{"codepoints":[8834],"characters":"\u2282"},"&subE;":{"codepoints":[10949],"characters":"\u2AC5"},"&subdot;":{"codepoints":[10941],"characters":"\u2ABD"},"&sube;":{"codepoints":[8838],"characters":"\u2286"},"&subedot;":{"codepoints":[10947],"characters":"\u2AC3"},"&submult;":{"codepoints":[10945],"characters":"\u2AC1"},"&subnE;":{"codepoints":[10955],"characters":"\u2ACB"},"&subne;":{"codepoints":[8842],"characters":"\u228A"},"&subplus;":{"codepoints":[10943],"characters":"\u2ABF"},"&subrarr;":{"codepoints":[10617],"characters":"\u2979"},"&subset;":{"codepoints":[8834],"characters":"\u2282"},"&subseteq;":{"codepoints":[8838],"characters":"\u2286"},"&subseteqq;":{"codepoints":[10949],"characters":"\u2AC5"},"&subsetneq;":{"codepoints":[8842],"characters":"\u228A"},"&subsetneqq;":{"codepoints":[10955],"characters":"\u2ACB"},"&subsim;":{"codepoints":[10951],"characters":"\u2AC7"},"&subsub;":{"codepoints":[10965],"characters":"\u2AD5"},"&subsup;":{"codepoints":[10963],"characters":"\u2AD3"},"&succ;":{"codepoints":[8827],"characters":"\u227B"},"&succapprox;":{"codepoints":[10936],"characters":"\u2AB8"},"&succcurlyeq;":{"codepoints":[8829],"characters":"\u227D"},"&succeq;":{"codepoints":[10928],"characters":"\u2AB0"},"&succnapprox;":{"codepoints":[10938],"characters":"\u2ABA"},"&succneqq;":{"codepoints":[10934],"characters":"\u2AB6"},"&succnsim;":{"codepoints":[8937],"characters":"\u22E9"},"&succsim;":{"codepoints":[8831],"characters":"\u227F"},"&sum;":{"codepoints":[8721],"characters":"\u2211"},"&sung;":{"codepoints":[9834],"characters":"\u266A"},"&sup1":{"codepoints":[185],"characters":"\xb9"},"&sup1;":{"codepoints":[185],"characters":"\xb9"},"&sup2":{"codepoints":[178],"characters":"\xb2"},"&sup2;":{"codepoints":[178],"characters":"\xb2"},"&sup3":{"codepoints":[179],"characters":"\xb3"},"&sup3;":{"codepoints":[179],"characters":"\xb3"},"&sup;":{"codepoints":[8835],"characters":"\u2283"},"&supE;":{"codepoints":[10950],"characters":"\u2AC6"},"&supdot;":{"codepoints":[10942],"characters":"\u2ABE"},"&supdsub;":{"codepoints":[10968],"characters":"\u2AD8"},"&supe;":{"codepoints":[8839],"characters":"\u2287"},"&supedot;":{"codepoints":[10948],"characters":"\u2AC4"},"&suphsol;":{"codepoints":[10185],"characters":"\u27C9"},"&suphsub;":{"codepoints":[10967],"characters":"\u2AD7"},"&suplarr;":{"codepoints":[10619],"characters":"\u297B"},"&supmult;":{"codepoints":[10946],"characters":"\u2AC2"},"&supnE;":{"codepoints":[10956],"characters":"\u2ACC"},"&supne;":{"codepoints":[8843],"characters":"\u228B"},"&supplus;":{"codepoints":[10944],"characters":"\u2AC0"},"&supset;":{"codepoints":[8835],"characters":"\u2283"},"&supseteq;":{"codepoints":[8839],"characters":"\u2287"},"&supseteqq;":{"codepoints":[10950],"characters":"\u2AC6"},"&supsetneq;":{"codepoints":[8843],"characters":"\u228B"},"&supsetneqq;":{"codepoints":[10956],"characters":"\u2ACC"},"&supsim;":{"codepoints":[10952],"characters":"\u2AC8"},"&supsub;":{"codepoints":[10964],"characters":"\u2AD4"},"&supsup;":{"codepoints":[10966],"characters":"\u2AD6"},"&swArr;":{"codepoints":[8665],"characters":"\u21D9"},"&swarhk;":{"codepoints":[10534],"characters":"\u2926"},"&swarr;":{"codepoints":[8601],"characters":"\u2199"},"&swarrow;":{"codepoints":[8601],"characters":"\u2199"},"&swnwar;":{"codepoints":[10538],"characters":"\u292A"},"&szlig":{"codepoints":[223],"characters":"\xdf"},"&szlig;":{"codepoints":[223],"characters":"\xdf"},"&target;":{"codepoints":[8982],"characters":"\u2316"},"&tau;":{"codepoints":[964],"characters":"\u03C4"},"&tbrk;":{"codepoints":[9140],"characters":"\u23B4"},"&tcaron;":{"codepoints":[357],"characters":"\u0165"},"&tcedil;":{"codepoints":[355],"characters":"\u0163"},"&tcy;":{"codepoints":[1090],"characters":"\u0442"},"&tdot;":{"codepoints":[8411],"characters":"\u20DB"},"&telrec;":{"codepoints":[8981],"characters":"\u2315"},"&tfr;":{"codepoints":[120113],"characters":"\uD835\uDD31"},"&there4;":{"codepoints":[8756],"characters":"\u2234"},"&therefore;":{"codepoints":[8756],"characters":"\u2234"},"&theta;":{"codepoints":[952],"characters":"\u03B8"},"&thetasym;":{"codepoints":[977],"characters":"\u03D1"},"&thetav;":{"codepoints":[977],"characters":"\u03D1"},"&thickapprox;":{"codepoints":[8776],"characters":"\u2248"},"&thicksim;":{"codepoints":[8764],"characters":"\u223C"},"&thinsp;":{"codepoints":[8201],"characters":"\u2009"},"&thkap;":{"codepoints":[8776],"characters":"\u2248"},"&thksim;":{"codepoints":[8764],"characters":"\u223C"},"&thorn":{"codepoints":[254],"characters":"\xfe"},"&thorn;":{"codepoints":[254],"characters":"\xfe"},"&tilde;":{"codepoints":[732],"characters":"\u02DC"},"&times":{"codepoints":[215],"characters":"\xd7"},"&times;":{"codepoints":[215],"characters":"\xd7"},"&timesb;":{"codepoints":[8864],"characters":"\u22A0"},"&timesbar;":{"codepoints":[10801],"characters":"\u2A31"},"&timesd;":{"codepoints":[10800],"characters":"\u2A30"},"&tint;":{"codepoints":[8749],"characters":"\u222D"},"&toea;":{"codepoints":[10536],"characters":"\u2928"},"&top;":{"codepoints":[8868],"characters":"\u22A4"},"&topbot;":{"codepoints":[9014],"characters":"\u2336"},"&topcir;":{"codepoints":[10993],"characters":"\u2AF1"},"&topf;":{"codepoints":[120165],"characters":"\uD835\uDD65"},"&topfork;":{"codepoints":[10970],"characters":"\u2ADA"},"&tosa;":{"codepoints":[10537],"characters":"\u2929"},"&tprime;":{"codepoints":[8244],"characters":"\u2034"},"&trade;":{"codepoints":[8482],"characters":"\u2122"},"&triangle;":{"codepoints":[9653],"characters":"\u25B5"},"&triangledown;":{"codepoints":[9663],"characters":"\u25BF"},"&triangleleft;":{"codepoints":[9667],"characters":"\u25C3"},"&trianglelefteq;":{"codepoints":[8884],"characters":"\u22B4"},"&triangleq;":{"codepoints":[8796],"characters":"\u225C"},"&triangleright;":{"codepoints":[9657],"characters":"\u25B9"},"&trianglerighteq;":{"codepoints":[8885],"characters":"\u22B5"},"&tridot;":{"codepoints":[9708],"characters":"\u25EC"},"&trie;":{"codepoints":[8796],"characters":"\u225C"},"&triminus;":{"codepoints":[10810],"characters":"\u2A3A"},"&triplus;":{"codepoints":[10809],"characters":"\u2A39"},"&trisb;":{"codepoints":[10701],"characters":"\u29CD"},"&tritime;":{"codepoints":[10811],"characters":"\u2A3B"},"&trpezium;":{"codepoints":[9186],"characters":"\u23E2"},"&tscr;":{"codepoints":[120009],"characters":"\uD835\uDCC9"},"&tscy;":{"codepoints":[1094],"characters":"\u0446"},"&tshcy;":{"codepoints":[1115],"characters":"\u045B"},"&tstrok;":{"codepoints":[359],"characters":"\u0167"},"&twixt;":{"codepoints":[8812],"characters":"\u226C"},"&twoheadleftarrow;":{"codepoints":[8606],"characters":"\u219E"},"&twoheadrightarrow;":{"codepoints":[8608],"characters":"\u21A0"},"&uArr;":{"codepoints":[8657],"characters":"\u21D1"},"&uHar;":{"codepoints":[10595],"characters":"\u2963"},"&uacute":{"codepoints":[250],"characters":"\xfa"},"&uacute;":{"codepoints":[250],"characters":"\xfa"},"&uarr;":{"codepoints":[8593],"characters":"\u2191"},"&ubrcy;":{"codepoints":[1118],"characters":"\u045E"},"&ubreve;":{"codepoints":[365],"characters":"\u016D"},"&ucirc":{"codepoints":[251],"characters":"\xfb"},"&ucirc;":{"codepoints":[251],"characters":"\xfb"},"&ucy;":{"codepoints":[1091],"characters":"\u0443"},"&udarr;":{"codepoints":[8645],"characters":"\u21C5"},"&udblac;":{"codepoints":[369],"characters":"\u0171"},"&udhar;":{"codepoints":[10606],"characters":"\u296E"},"&ufisht;":{"codepoints":[10622],"characters":"\u297E"},"&ufr;":{"codepoints":[120114],"characters":"\uD835\uDD32"},"&ugrave":{"codepoints":[249],"characters":"\xf9"},"&ugrave;":{"codepoints":[249],"characters":"\xf9"},"&uharl;":{"codepoints":[8639],"characters":"\u21BF"},"&uharr;":{"codepoints":[8638],"characters":"\u21BE"},"&uhblk;":{"codepoints":[9600],"characters":"\u2580"},"&ulcorn;":{"codepoints":[8988],"characters":"\u231C"},"&ulcorner;":{"codepoints":[8988],"characters":"\u231C"},"&ulcrop;":{"codepoints":[8975],"characters":"\u230F"},"&ultri;":{"codepoints":[9720],"characters":"\u25F8"},"&umacr;":{"codepoints":[363],"characters":"\u016B"},"&uml":{"codepoints":[168],"characters":"\xa8"},"&uml;":{"codepoints":[168],"characters":"\xa8"},"&uogon;":{"codepoints":[371],"characters":"\u0173"},"&uopf;":{"codepoints":[120166],"characters":"\uD835\uDD66"},"&uparrow;":{"codepoints":[8593],"characters":"\u2191"},"&updownarrow;":{"codepoints":[8597],"characters":"\u2195"},"&upharpoonleft;":{"codepoints":[8639],"characters":"\u21BF"},"&upharpoonright;":{"codepoints":[8638],"characters":"\u21BE"},"&uplus;":{"codepoints":[8846],"characters":"\u228E"},"&upsi;":{"codepoints":[965],"characters":"\u03C5"},"&upsih;":{"codepoints":[978],"characters":"\u03D2"},"&upsilon;":{"codepoints":[965],"characters":"\u03C5"},"&upuparrows;":{"codepoints":[8648],"characters":"\u21C8"},"&urcorn;":{"codepoints":[8989],"characters":"\u231D"},"&urcorner;":{"codepoints":[8989],"characters":"\u231D"},"&urcrop;":{"codepoints":[8974],"characters":"\u230E"},"&uring;":{"codepoints":[367],"characters":"\u016F"},"&urtri;":{"codepoints":[9721],"characters":"\u25F9"},"&uscr;":{"codepoints":[120010],"characters":"\uD835\uDCCA"},"&utdot;":{"codepoints":[8944],"characters":"\u22F0"},"&utilde;":{"codepoints":[361],"characters":"\u0169"},"&utri;":{"codepoints":[9653],"characters":"\u25B5"},"&utrif;":{"codepoints":[9652],"characters":"\u25B4"},"&uuarr;":{"codepoints":[8648],"characters":"\u21C8"},"&uuml":{"codepoints":[252],"characters":"\xfc"},"&uuml;":{"codepoints":[252],"characters":"\xfc"},"&uwangle;":{"codepoints":[10663],"characters":"\u29A7"},"&vArr;":{"codepoints":[8661],"characters":"\u21D5"},"&vBar;":{"codepoints":[10984],"characters":"\u2AE8"},"&vBarv;":{"codepoints":[10985],"characters":"\u2AE9"},"&vDash;":{"codepoints":[8872],"characters":"\u22A8"},"&vangrt;":{"codepoints":[10652],"characters":"\u299C"},"&varepsilon;":{"codepoints":[1013],"characters":"\u03F5"},"&varkappa;":{"codepoints":[1008],"characters":"\u03F0"},"&varnothing;":{"codepoints":[8709],"characters":"\u2205"},"&varphi;":{"codepoints":[981],"characters":"\u03D5"},"&varpi;":{"codepoints":[982],"characters":"\u03D6"},"&varpropto;":{"codepoints":[8733],"characters":"\u221D"},"&varr;":{"codepoints":[8597],"characters":"\u2195"},"&varrho;":{"codepoints":[1009],"characters":"\u03F1"},"&varsigma;":{"codepoints":[962],"characters":"\u03C2"},"&varsubsetneq;":{"codepoints":[8842,65024],"characters":"\u228A\uFE00"},"&varsubsetneqq;":{"codepoints":[10955,65024],"characters":"\u2ACB\uFE00"},"&varsupsetneq;":{"codepoints":[8843,65024],"characters":"\u228B\uFE00"},"&varsupsetneqq;":{"codepoints":[10956,65024],"characters":"\u2ACC\uFE00"},"&vartheta;":{"codepoints":[977],"characters":"\u03D1"},"&vartriangleleft;":{"codepoints":[8882],"characters":"\u22B2"},"&vartriangleright;":{"codepoints":[8883],"characters":"\u22B3"},"&vcy;":{"codepoints":[1074],"characters":"\u0432"},"&vdash;":{"codepoints":[8866],"characters":"\u22A2"},"&vee;":{"codepoints":[8744],"characters":"\u2228"},"&veebar;":{"codepoints":[8891],"characters":"\u22BB"},"&veeeq;":{"codepoints":[8794],"characters":"\u225A"},"&vellip;":{"codepoints":[8942],"characters":"\u22EE"},"&verbar;":{"codepoints":[124],"characters":"|"},"&vert;":{"codepoints":[124],"characters":"|"},"&vfr;":{"codepoints":[120115],"characters":"\uD835\uDD33"},"&vltri;":{"codepoints":[8882],"characters":"\u22B2"},"&vnsub;":{"codepoints":[8834,8402],"characters":"\u2282\u20D2"},"&vnsup;":{"codepoints":[8835,8402],"characters":"\u2283\u20D2"},"&vopf;":{"codepoints":[120167],"characters":"\uD835\uDD67"},"&vprop;":{"codepoints":[8733],"characters":"\u221D"},"&vrtri;":{"codepoints":[8883],"characters":"\u22B3"},"&vscr;":{"codepoints":[120011],"characters":"\uD835\uDCCB"},"&vsubnE;":{"codepoints":[10955,65024],"characters":"\u2ACB\uFE00"},"&vsubne;":{"codepoints":[8842,65024],"characters":"\u228A\uFE00"},"&vsupnE;":{"codepoints":[10956,65024],"characters":"\u2ACC\uFE00"},"&vsupne;":{"codepoints":[8843,65024],"characters":"\u228B\uFE00"},"&vzigzag;":{"codepoints":[10650],"characters":"\u299A"},"&wcirc;":{"codepoints":[373],"characters":"\u0175"},"&wedbar;":{"codepoints":[10847],"characters":"\u2A5F"},"&wedge;":{"codepoints":[8743],"characters":"\u2227"},"&wedgeq;":{"codepoints":[8793],"characters":"\u2259"},"&weierp;":{"codepoints":[8472],"characters":"\u2118"},"&wfr;":{"codepoints":[120116],"characters":"\uD835\uDD34"},"&wopf;":{"codepoints":[120168],"characters":"\uD835\uDD68"},"&wp;":{"codepoints":[8472],"characters":"\u2118"},"&wr;":{"codepoints":[8768],"characters":"\u2240"},"&wreath;":{"codepoints":[8768],"characters":"\u2240"},"&wscr;":{"codepoints":[120012],"characters":"\uD835\uDCCC"},"&xcap;":{"codepoints":[8898],"characters":"\u22C2"},"&xcirc;":{"codepoints":[9711],"characters":"\u25EF"},"&xcup;":{"codepoints":[8899],"characters":"\u22C3"},"&xdtri;":{"codepoints":[9661],"characters":"\u25BD"},"&xfr;":{"codepoints":[120117],"characters":"\uD835\uDD35"},"&xhArr;":{"codepoints":[10234],"characters":"\u27FA"},"&xharr;":{"codepoints":[10231],"characters":"\u27F7"},"&xi;":{"codepoints":[958],"characters":"\u03BE"},"&xlArr;":{"codepoints":[10232],"characters":"\u27F8"},"&xlarr;":{"codepoints":[10229],"characters":"\u27F5"},"&xmap;":{"codepoints":[10236],"characters":"\u27FC"},"&xnis;":{"codepoints":[8955],"characters":"\u22FB"},"&xodot;":{"codepoints":[10752],"characters":"\u2A00"},"&xopf;":{"codepoints":[120169],"characters":"\uD835\uDD69"},"&xoplus;":{"codepoints":[10753],"characters":"\u2A01"},"&xotime;":{"codepoints":[10754],"characters":"\u2A02"},"&xrArr;":{"codepoints":[10233],"characters":"\u27F9"},"&xrarr;":{"codepoints":[10230],"characters":"\u27F6"},"&xscr;":{"codepoints":[120013],"characters":"\uD835\uDCCD"},"&xsqcup;":{"codepoints":[10758],"characters":"\u2A06"},"&xuplus;":{"codepoints":[10756],"characters":"\u2A04"},"&xutri;":{"codepoints":[9651],"characters":"\u25B3"},"&xvee;":{"codepoints":[8897],"characters":"\u22C1"},"&xwedge;":{"codepoints":[8896],"characters":"\u22C0"},"&yacute":{"codepoints":[253],"characters":"\xfd"},"&yacute;":{"codepoints":[253],"characters":"\xfd"},"&yacy;":{"codepoints":[1103],"characters":"\u044F"},"&ycirc;":{"codepoints":[375],"characters":"\u0177"},"&ycy;":{"codepoints":[1099],"characters":"\u044B"},"&yen":{"codepoints":[165],"characters":"\xa5"},"&yen;":{"codepoints":[165],"characters":"\xa5"},"&yfr;":{"codepoints":[120118],"characters":"\uD835\uDD36"},"&yicy;":{"codepoints":[1111],"characters":"\u0457"},"&yopf;":{"codepoints":[120170],"characters":"\uD835\uDD6A"},"&yscr;":{"codepoints":[120014],"characters":"\uD835\uDCCE"},"&yucy;":{"codepoints":[1102],"characters":"\u044E"},"&yuml":{"codepoints":[255],"characters":"\xff"},"&yuml;":{"codepoints":[255],"characters":"\xff"},"&zacute;":{"codepoints":[378],"characters":"\u017A"},"&zcaron;":{"codepoints":[382],"characters":"\u017E"},"&zcy;":{"codepoints":[1079],"characters":"\u0437"},"&zdot;":{"codepoints":[380],"characters":"\u017C"},"&zeetrf;":{"codepoints":[8488],"characters":"\u2128"},"&zeta;":{"codepoints":[950],"characters":"\u03B6"},"&zfr;":{"codepoints":[120119],"characters":"\uD835\uDD37"},"&zhcy;":{"codepoints":[1078],"characters":"\u0436"},"&zigrarr;":{"codepoints":[8669],"characters":"\u21DD"},"&zopf;":{"codepoints":[120171],"characters":"\uD835\uDD6B"},"&zscr;":{"codepoints":[120015],"characters":"\uD835\uDCCF"},"&zwj;":{"codepoints":[8205],"characters":"\u200D"},"&zwnj;":{"codepoints":[8204],"characters":"\u200C"}}');



var $f81e92191d20d3e6$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $f81e92191d20d3e6$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $f81e92191d20d3e6$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $f81e92191d20d3e6$var$MESSAGE_IDS = {
    INVALID_ENTITY: "invalidEntity"
};
/** @type {RuleModule<[]>} */ $f81e92191d20d3e6$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallows the use of invalid HTML entities",
            category: $f81e92191d20d3e6$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $f81e92191d20d3e6$require$getRuleUrl("no-invalid-entity")
        },
        fixable: null,
        hasSuggestions: false,
        schema: [],
        messages: {
            [$f81e92191d20d3e6$var$MESSAGE_IDS.INVALID_ENTITY]: "Invalid HTML entity '{{entity}}' used."
        }
    },
    create (context) {
        /** @param {Text} node */ function check(node) {
            const text = node.value;
            // Regular expression to match named and numeric entities
            const entityRegex = /&([a-zA-Z]+|#[0-9]+|#x[0-9a-fA-F]+|[#][^;]+);/g;
            let match;
            while((match = entityRegex.exec(text)) !== null){
                const entity = match[0];
                const entityName = match[1];
                // Check named entities
                if (!entityName.startsWith("#")) {
                    const fullEntity = `&${entityName};`;
                    if (!Object.prototype.hasOwnProperty.call($f2f06edfac326d42$exports, fullEntity)) context.report({
                        node: node,
                        messageId: $f81e92191d20d3e6$var$MESSAGE_IDS.INVALID_ENTITY,
                        data: {
                            entity: entity
                        }
                    });
                } else {
                    const isHex = entityName[1] === "x";
                    const numStr = isHex ? entityName.slice(2) : entityName.slice(1);
                    const num = isHex ? parseInt(numStr, 16) : parseInt(numStr, 10);
                    // If the number is not a valid integer, report an error
                    if (isNaN(num)) {
                        context.report({
                            node: node,
                            messageId: $f81e92191d20d3e6$var$MESSAGE_IDS.INVALID_ENTITY,
                            data: {
                                entity: entity
                            }
                        });
                        continue;
                    }
                    // Check if the numeric entity is valid (exists in entities.json or within valid Unicode range)
                    const entityKey = Object.values($f2f06edfac326d42$exports).find(({ codepoints: codepoints })=>{
                        return codepoints.length === 1 && codepoints[0] === num;
                    });
                    if (!entityKey && (num < 0 || num > 0x10ffff)) context.report({
                        node: node,
                        messageId: $f81e92191d20d3e6$var$MESSAGE_IDS.INVALID_ENTITY,
                        data: {
                            entity: entity
                        }
                    });
                }
            }
        }
        return $f81e92191d20d3e6$require$createVisitors(context, {
            Text: check
        });
    }
};


var $1f4912ce36372af8$exports = {};
/**
 * @import {Tag} from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $1f4912ce36372af8$require$parseTemplateLiteral = $7038c80d40859759$exports.parseTemplateLiteral;

var $1f4912ce36372af8$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $1f4912ce36372af8$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $1f4912ce36372af8$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;

var $1f4912ce36372af8$require$shouldCheckTaggedTemplateExpression = $82257e454733f104$exports.shouldCheckTaggedTemplateExpression;
var $1f4912ce36372af8$require$shouldCheckTemplateLiteral = $82257e454733f104$exports.shouldCheckTemplateLiteral;

var $1f4912ce36372af8$require$getSourceCode = $2abd6ce2c4a2d841$exports.getSourceCode;

var $1f4912ce36372af8$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $1f4912ce36372af8$var$MESSAGE_IDS = {
    DUPLICATE_TAG: "duplicateTag"
};
/**
 * Returns a formatted string representing a tag's key detail. E.g.,
 * meta[charset=UTF-8], meta[name=viewport], link[rel=canonical]
 *
 * @param {Tag} node
 * @returns {string | null}
 */ function $1f4912ce36372af8$var$getTrackingKey(node) {
    const tagName = $1f4912ce36372af8$require$getNameOf(node);
    if ([
        "title",
        "base"
    ].includes(tagName)) return tagName;
    if (tagName === "meta") {
        const charsetAttr = $1f4912ce36372af8$require$findAttr(node, "charset");
        if (charsetAttr) return "meta[charset]";
        const nameAttr = $1f4912ce36372af8$require$findAttr(node, "name");
        if (nameAttr?.value?.value === "viewport") return "meta[name=viewport]";
    }
    if (tagName === "link") {
        const relAttr = $1f4912ce36372af8$require$findAttr(node, "rel");
        const hrefAttr = $1f4912ce36372af8$require$findAttr(node, "href");
        if (relAttr?.value?.value === "canonical" && hrefAttr) return "link[rel=canonical]";
    }
    return null;
}
/** @type {RuleModule<[]>} */ $1f4912ce36372af8$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow duplicate tags in `<head>`",
            category: $1f4912ce36372af8$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $1f4912ce36372af8$require$getRuleUrl("no-duplicate-in-head")
        },
        fixable: null,
        schema: [],
        messages: {
            [$1f4912ce36372af8$var$MESSAGE_IDS.DUPLICATE_TAG]: "Duplicate <{{tag}}> tag in <head>."
        }
    },
    create (context) {
        const htmlTagsMap = new Map();
        let headCount = 0;
        /**
     * @param {Map<string, Tag[]>} map
     * @param {{ count: number } | null} headCountRef
     */ function createTagVisitor(map, headCountRef = null) {
            return {
                /** @param {Tag} node */ Tag (node) {
                    const tagName = $1f4912ce36372af8$require$getNameOf(node);
                    if (tagName === "head") {
                        if (headCountRef !== null) headCountRef.count++;
                        else headCount++;
                        return;
                    }
                    const currentHeadCount = headCountRef?.count ?? headCount;
                    if (currentHeadCount === 0) return;
                    const trackingKey = $1f4912ce36372af8$var$getTrackingKey(node);
                    if (typeof trackingKey !== "string") return;
                    if (!map.has(trackingKey)) map.set(trackingKey, []);
                    const nodes = map.get(trackingKey);
                    if (nodes) nodes.push(node);
                },
                /** @param {Tag} node */ "Tag:exit" (node) {
                    const tagName = $1f4912ce36372af8$require$getNameOf(node);
                    if (tagName === "head") {
                        if (headCountRef !== null) headCountRef.count--;
                        else headCount--;
                    }
                }
            };
        }
        /** @param {Map<string, Tag[]>} map */ function report(map) {
            map.forEach((tags, tagKey)=>{
                if (Array.isArray(tags) && tags.length > 1) tags.slice(1).forEach((tag)=>{
                    context.report({
                        node: tag,
                        data: {
                            tag: tagKey
                        },
                        messageId: $1f4912ce36372af8$var$MESSAGE_IDS.DUPLICATE_TAG
                    });
                });
            });
        }
        const htmlVisitor = createTagVisitor(htmlTagsMap);
        return {
            Tag: htmlVisitor.Tag,
            "Tag:exit": htmlVisitor["Tag:exit"],
            "Document:exit" () {
                report(htmlTagsMap);
            },
            TaggedTemplateExpression (node) {
                const tagsMap = new Map();
                const headCountRef = {
                    count: 0
                };
                if ($1f4912ce36372af8$require$shouldCheckTaggedTemplateExpression(node, context)) {
                    const visitor = createTagVisitor(tagsMap, headCountRef);
                    $1f4912ce36372af8$require$parseTemplateLiteral(node.quasi, $1f4912ce36372af8$require$getSourceCode(context), visitor);
                    report(tagsMap);
                }
            },
            TemplateLiteral (node) {
                const tagsMap = new Map();
                const headCountRef = {
                    count: 0
                };
                if ($1f4912ce36372af8$require$shouldCheckTemplateLiteral(node, context)) {
                    const visitor = createTagVisitor(tagsMap, headCountRef);
                    $1f4912ce36372af8$require$parseTemplateLiteral(node, $1f4912ce36372af8$require$getSourceCode(context), visitor);
                    report(tagsMap);
                }
            }
        };
    }
};


var $0ac36197050563a6$exports = {};
/**
 * @import {
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $0ac36197050563a6$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $0ac36197050563a6$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $0ac36197050563a6$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;

var $0ac36197050563a6$require$noIneffectiveAttrs = $404c96e82c1b1d4e$export$1669b57000ee831b;
var $0ac36197050563a6$require$NO_INEFFECTIVE_ATTRS_MESSAGE_IDS = $404c96e82c1b1d4e$export$9b2977d355552fdc;

var $0ac36197050563a6$require$createElementAdapter = $65279e6012804295$exports.createElementAdapter;
/** @type {RuleModule<[]>} */ $0ac36197050563a6$exports = {
    meta: {
        type: "problem",
        docs: {
            description: "Disallow HTML attributes that have no effect in their context",
            category: $0ac36197050563a6$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $0ac36197050563a6$require$getRuleUrl("no-ineffective-attrs")
        },
        fixable: null,
        schema: [],
        messages: {
            [$0ac36197050563a6$require$NO_INEFFECTIVE_ATTRS_MESSAGE_IDS.ineffective]: "{{ message }}"
        }
    },
    create (context) {
        const ruleCore = /** @type {ReturnType<typeof noIneffectiveAttrs>} */ $0ac36197050563a6$require$noIneffectiveAttrs();
        /** @param {Tag | ScriptTag | StyleTag} node */ function checkAttributes(node) {
            const adapter = $0ac36197050563a6$require$createElementAdapter(node);
            const result = ruleCore.checkAttributes(adapter);
            for (const { loc: loc, messageId: messageId, data: data } of result)context.report({
                loc: loc,
                messageId: messageId,
                data: data
            });
        }
        return $0ac36197050563a6$require$createVisitors(context, {
            Tag: checkAttributes,
            ScriptTag: checkAttributes,
            StyleTag: checkAttributes
        });
    }
};


var $78090dd8f7b91dcd$exports = {};
/**
 * @import {
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 * @typedef {{ tagPatterns: string[]; message?: string }[]} Options
 */ 
var $78090dd8f7b91dcd$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $78090dd8f7b91dcd$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $78090dd8f7b91dcd$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;

var $78090dd8f7b91dcd$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;
const $78090dd8f7b91dcd$var$MESSAGE_IDS = {
    RESTRICTED: "restricted"
};
/** @type {RuleModule<Options>} */ $78090dd8f7b91dcd$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow specified tags",
            category: $78090dd8f7b91dcd$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $78090dd8f7b91dcd$require$getRuleUrl("no-restricted-tags")
        },
        fixable: null,
        schema: {
            type: "array",
            items: {
                type: "object",
                required: [
                    "tagPatterns"
                ],
                properties: {
                    tagPatterns: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    },
                    message: {
                        type: "string"
                    }
                },
                additionalProperties: false
            }
        },
        messages: {
            [$78090dd8f7b91dcd$var$MESSAGE_IDS.RESTRICTED]: "'{{tag}}' tag is restricted from being used."
        }
    },
    create (context) {
        const { options: options } = context;
        const checkers = options.map((option)=>new $78090dd8f7b91dcd$var$PatternChecker(option));
        /** @param {Tag | StyleTag | ScriptTag} node */ function check(node) {
            const tagName = $78090dd8f7b91dcd$require$getNameOf(node);
            const matched = checkers.find((checker)=>checker.test(tagName));
            if (!matched) return;
            /**
       * @type {{
       *   node: Tag | StyleTag | ScriptTag;
       *   message: string;
       *   messageId?: string;
       * }}
       */ const result = {
                node: node,
                message: ""
            };
            const customMessage = matched.getMessage();
            if (customMessage) result.message = customMessage;
            else result.messageId = $78090dd8f7b91dcd$var$MESSAGE_IDS.RESTRICTED;
            context.report({
                ...result,
                data: {
                    tag: tagName
                }
            });
        }
        return $78090dd8f7b91dcd$require$createVisitors(context, {
            Tag: check,
            StyleTag: check,
            ScriptTag: check
        });
    }
};
class $78090dd8f7b91dcd$var$PatternChecker {
    /** @param {Options[number]} option */ constructor(option){
        this.option = option;
        this.tagRegExps = option.tagPatterns.map((pattern)=>new RegExp(pattern, "u"));
        this.message = option.message;
    }
    /**
   * @param {string} tagName
   * @returns {boolean}
   */ test(tagName) {
        const result = this.tagRegExps.some((exp)=>exp.test(tagName));
        return result;
    }
    /** @returns {string} */ getMessage() {
        return this.message || "";
    }
}


var $265e3d3823e60bbb$exports = {};
/**
 * @import {
 *   Tag,
 *   Text
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $265e3d3823e60bbb$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $265e3d3823e60bbb$require$isText = $7dabedd289de3a0a$exports.isText;
var $265e3d3823e60bbb$require$isComment = $7dabedd289de3a0a$exports.isComment;
var $265e3d3823e60bbb$require$getLocBetween = $7dabedd289de3a0a$exports.getLocBetween;
var $265e3d3823e60bbb$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;

var $265e3d3823e60bbb$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $265e3d3823e60bbb$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
const $265e3d3823e60bbb$var$MESSAGE_IDS = {
    WHITESPACE_ONLY_CHILDREN: "whitespaceOnlyChildren"
};
/** @param {Tag} node */ function $265e3d3823e60bbb$var$hasOnlyWhitespaceChildren(node) {
    if (!node.children || node.children.length === 0) return false;
    if (node.children.every((child)=>$265e3d3823e60bbb$require$isComment(child))) return false;
    for (const child of node.children){
        if ($265e3d3823e60bbb$require$isComment(child)) continue;
        if ($265e3d3823e60bbb$require$isText(child)) {
            if (child.value?.trim().length > 0) return false;
        } else return false;
    }
    return true;
}
/** @type {RuleModule<[{ tagPatterns?: string[] }]>} */ $265e3d3823e60bbb$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow tags with only whitespace children.",
            recommended: false,
            category: $265e3d3823e60bbb$require$RULE_CATEGORY.BEST_PRACTICE,
            url: $265e3d3823e60bbb$require$getRuleUrl("no-whitespace-only-children")
        },
        fixable: "whitespace",
        schema: [
            {
                type: "object",
                properties: {
                    tagPatterns: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$265e3d3823e60bbb$var$MESSAGE_IDS.WHITESPACE_ONLY_CHILDREN]: "Tag should not have only whitespace children."
        }
    },
    create (context) {
        const options = context.options[0] || {};
        const tagPatterns = (options.tagPatterns || []).map((pattern)=>new RegExp(pattern, "u"));
        return $265e3d3823e60bbb$require$createVisitors(context, {
            Tag (node) {
                if (!node.close) return;
                if (tagPatterns.length <= 0) return;
                const tagName = $265e3d3823e60bbb$require$getNameOf(node);
                // If tagPatterns is specified, check if tag name matches any pattern
                const matches = tagPatterns.some((pattern)=>pattern.test(tagName));
                if (!matches) return;
                if ($265e3d3823e60bbb$var$hasOnlyWhitespaceChildren(node)) {
                    const loc = $265e3d3823e60bbb$require$getLocBetween(node.openEnd, node.close);
                    context.report({
                        loc: loc,
                        messageId: $265e3d3823e60bbb$var$MESSAGE_IDS.WHITESPACE_ONLY_CHILDREN,
                        fix (fixer) {
                            return node.children.filter((child)=>$265e3d3823e60bbb$require$isText(child)).map((child)=>fixer.removeRange(child.range));
                        }
                    });
                }
            }
        });
    }
};


var $de1f055da137aec9$exports = {};
/**
 * @import {
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $de1f055da137aec9$require$noObsoleteAttrs = $404c96e82c1b1d4e$export$d46aff0fc39f994d;
var $de1f055da137aec9$require$NO_OBSOLETE_ATTRS_MESSAGE_IDS = $404c96e82c1b1d4e$export$12a148edcce6f2e6;

var $de1f055da137aec9$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $de1f055da137aec9$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $de1f055da137aec9$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;

var $de1f055da137aec9$require$createElementAdapter = $65279e6012804295$exports.createElementAdapter;
/** @type {RuleModule<[]>} */ $de1f055da137aec9$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow use of obsolete attributes in HTML5",
            category: $de1f055da137aec9$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: true,
            url: $de1f055da137aec9$require$getRuleUrl("no-obsolete-attrs")
        },
        fixable: null,
        schema: [],
        messages: {
            [$de1f055da137aec9$require$NO_OBSOLETE_ATTRS_MESSAGE_IDS.obsolete]: "The {{attr}} attribute on <{{element}}> is obsolete. {{suggestion}}"
        }
    },
    create (context) {
        const ruleCore = $de1f055da137aec9$require$noObsoleteAttrs();
        /** @param {Tag | ScriptTag | StyleTag} node */ function checkObsoleteAttrs(node) {
            const adapter = $de1f055da137aec9$require$createElementAdapter(node);
            const result = ruleCore.checkAttributes(adapter);
            for (const { loc: loc, messageId: messageId, data: data } of result)context.report({
                loc: loc,
                messageId: messageId,
                data: data
            });
        }
        return $de1f055da137aec9$require$createVisitors(context, {
            Tag: checkObsoleteAttrs,
            ScriptTag: checkObsoleteAttrs,
            StyleTag: checkObsoleteAttrs
        });
    }
};


var $a079f908f22e8def$exports = {};
/** @import {RuleModule} from "../types" */ 
var $a079f908f22e8def$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $a079f908f22e8def$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $a079f908f22e8def$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;

var $a079f908f22e8def$require$classSpacing = $404c96e82c1b1d4e$export$7108f91a0f8d44f8;
var $a079f908f22e8def$require$CLASS_SPACING_MESSAGE_IDS = $404c96e82c1b1d4e$export$1329c1ec5f658703;

var $a079f908f22e8def$require$createAttributeValueAdapter = $65279e6012804295$exports.createAttributeValueAdapter;
/** @type {RuleModule<[]>} */ $a079f908f22e8def$exports = {
    meta: {
        type: "layout",
        docs: {
            description: "Disallow extra spacing in class attribute values",
            recommended: false,
            category: $a079f908f22e8def$require$RULE_CATEGORY.STYLE,
            url: $a079f908f22e8def$require$getRuleUrl("class-spacing")
        },
        fixable: "code",
        schema: [],
        messages: {
            [$a079f908f22e8def$require$CLASS_SPACING_MESSAGE_IDS.extraSpacing]: "Unexpected extra spacing in class attribute value"
        }
    },
    create (context) {
        const { checkClassValue: checkClassValue } = $a079f908f22e8def$require$classSpacing();
        return $a079f908f22e8def$require$createVisitors(context, {
            Attribute (node) {
                if (node.key.value.toLowerCase() !== "class" || !node.value) return;
                const adapter = $a079f908f22e8def$require$createAttributeValueAdapter(node.value);
                const result = checkClassValue(adapter);
                for (const { loc: loc, messageId: messageId, range: range } of result)context.report({
                    loc: loc,
                    messageId: messageId,
                    fix (fixer) {
                        return fixer.removeRange(range);
                    }
                });
            }
        });
    }
};


var $119cd0d46999dc3f$exports = {};
/** @import {RuleModule} from "../types" */ 
var $119cd0d46999dc3f$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;
const $119cd0d46999dc3f$var$MESSAGE_IDS = {
    EMPTY_BLOCK: "emptyBlock"
};
/** @type {RuleModule<[]>} */ $119cd0d46999dc3f$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallows empty CSS blocks in `<style>` tags.",
            recommended: false,
            category: $119cd0d46999dc3f$require$RULE_CATEGORY.BEST_PRACTICE
        },
        messages: {
            [$119cd0d46999dc3f$var$MESSAGE_IDS.EMPTY_BLOCK]: "Unexpected empty block found."
        }
    },
    fixable: null,
    schema: [],
    create (context) {
        return {
            CssBlock (node) {
                if (node.children.length === 0) context.report({
                    loc: node.loc,
                    messageId: $119cd0d46999dc3f$var$MESSAGE_IDS.EMPTY_BLOCK
                });
            }
        };
    }
};


var $659b814eef393d7f$exports = {};
/** @import {RuleModule} from "../types" */ 
var $659b814eef393d7f$require$NODE_TYPES = $f03705736c6cdfcd$exports.NODE_TYPES;

var $659b814eef393d7f$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $659b814eef393d7f$require$findAttr = $7dabedd289de3a0a$exports.findAttr;

var $659b814eef393d7f$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $659b814eef393d7f$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;

var $659b814eef393d7f$require$element = $bad0d01969ce5ee2$export$8454457683f90105;
const $659b814eef393d7f$var$MESSAGE_IDS = {
    REDUNDANT: "redundant"
};
/** @type {RuleModule<[]>} */ $659b814eef393d7f$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow redundant role attributes that match the element's implicit role",
            category: $659b814eef393d7f$require$RULE_CATEGORY.ACCESSIBILITY,
            recommended: false,
            url: $659b814eef393d7f$require$getRuleUrl("no-redundant-role")
        },
        fixable: "code",
        schema: [],
        messages: {
            [$659b814eef393d7f$var$MESSAGE_IDS.REDUNDANT]: "Redundant role '{{role}}'. The element <{{element}}> already has an implicit role of '{{role}}'."
        }
    },
    create (context) {
        return $659b814eef393d7f$require$createVisitors(context, {
            Tag (node) {
                const role = $659b814eef393d7f$require$findAttr(node, "role");
                if (!role?.value?.value) return;
                /** Allow template expression. ex: html`<div role=${role}></div>` */ if (role.value.parts.some((part)=>part.type === $659b814eef393d7f$require$NODE_TYPES.Template)) return;
                const roleValue = role.value.value.toLowerCase();
                const elem = $659b814eef393d7f$require$element(node.name, {
                    attributes: {
                        get (key) {
                            const attr = $659b814eef393d7f$require$findAttr(node, key);
                            if (attr?.value) return attr.value.value;
                            return null;
                        }
                    }
                });
                const implicitRole = elem.implicitRole();
                if (implicitRole?.toLowerCase() === roleValue) context.report({
                    node: role,
                    messageId: $659b814eef393d7f$var$MESSAGE_IDS.REDUNDANT,
                    data: {
                        role: roleValue,
                        element: node.name
                    },
                    fix (fixer) {
                        return fixer.removeRange(role.range);
                    }
                });
            }
        });
    }
};


var $9fe8f85aa47c0320$exports = {};
/**
 * @import {
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $9fe8f85aa47c0320$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $9fe8f85aa47c0320$require$createVisitors = $6e393e774f061794$exports.createVisitors;

var $9fe8f85aa47c0320$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;

var $9fe8f85aa47c0320$require$noInvalidAttrValue = $404c96e82c1b1d4e$export$5bd6a5451dea460e;
var $9fe8f85aa47c0320$require$NO_INVALID_ATTR_VALUE_MESSAGE_IDS = $404c96e82c1b1d4e$export$2db0830b5f0899da;

var $9fe8f85aa47c0320$require$createElementAdapter = $65279e6012804295$exports.createElementAdapter;
/**
 * @type {RuleModule<
 *   [{ allow?: { tag: string; attr: string; valuePattern?: string }[] }]
 * >}
 */ $9fe8f85aa47c0320$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow invalid attribute values according to HTML standards",
            category: $9fe8f85aa47c0320$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $9fe8f85aa47c0320$require$getRuleUrl("no-invalid-attr-value")
        },
        fixable: null,
        schema: [
            {
                type: "object",
                properties: {
                    allow: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                tag: {
                                    type: "string"
                                },
                                attr: {
                                    type: "string"
                                },
                                valuePattern: {
                                    type: "string"
                                }
                            },
                            required: [
                                "tag",
                                "attr"
                            ],
                            additionalProperties: false
                        }
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$9fe8f85aa47c0320$require$NO_INVALID_ATTR_VALUE_MESSAGE_IDS.invalid]: "Invalid value '{{value}}' for attribute '{{attr}}' on <{{element}}>. {{suggestion}}"
        }
    },
    create (context) {
        const options = context.options[0] || {};
        const { checkAttributes: checkAttributes } = $9fe8f85aa47c0320$require$noInvalidAttrValue(options);
        /** @param {Tag | ScriptTag | StyleTag} node */ function check(node) {
            const adapter = $9fe8f85aa47c0320$require$createElementAdapter(node);
            const result = checkAttributes(adapter);
            for (const { loc: loc, messageId: messageId, data: data } of result)context.report({
                loc: loc,
                messageId: messageId,
                data: data
            });
        }
        return $9fe8f85aa47c0320$require$createVisitors(context, {
            Tag: check,
            ScriptTag: check,
            StyleTag: check
        });
    }
};


var $e77b82cb9a0d6b56$exports = {};
/** @import {RuleModule} from "../types" */ 
var $e77b82cb9a0d6b56$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $e77b82cb9a0d6b56$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;
var $5fb15ef29b1275b2$exports = {};
/**
 * @import {
 *   AnyNode,
 *   ScriptTag,
 *   StyleTag,
 *   Tag
 * } from "@html-eslint/types"
 */ 
var $5fb15ef29b1275b2$require$NODE_TYPES = $f03705736c6cdfcd$exports.NODE_TYPES;

var $5fb15ef29b1275b2$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $5fb15ef29b1275b2$require$getNameOf = $7dabedd289de3a0a$exports.getNameOf;
/** Adapter for HTML ESLint AST nodes to work with capo.js */ class $5fb15ef29b1275b2$var$HtmlEslintAdapter {
    /**
   * Check if node is an Element (Tag, ScriptTag, or StyleTag)
   *
   * @param {AnyNode} node - The node to check
   * @returns {node is Tag | ScriptTag | StyleTag}
   */ isElement(node) {
        return node.type === $5fb15ef29b1275b2$require$NODE_TYPES.Tag || node.type === $5fb15ef29b1275b2$require$NODE_TYPES.ScriptTag || node.type === $5fb15ef29b1275b2$require$NODE_TYPES.StyleTag;
    }
    /**
   * Get the tag name of an element (lowercase)
   *
   * @param {Tag | StyleTag | ScriptTag} node - Element node
   * @returns {string} - Tag name like 'meta', 'link', 'script'
   */ getTagName(node) {
        if (!this.isElement(node)) return "";
        return $5fb15ef29b1275b2$require$getNameOf(node);
    }
    /**
   * Get attribute value from element
   *
   * @param {Tag | StyleTag | ScriptTag} node - Element node
   * @param {string} attrName - Attribute name (case-insensitive)
   * @returns {string | null} - Attribute value or null if not found
   */ getAttribute(node, attrName) {
        if (!this.isElement(node)) return null;
        const attr = $5fb15ef29b1275b2$require$findAttr(node, attrName);
        if (!attr || !attr.value) return null;
        return attr.value.value || null;
    }
    /**
   * Check if element has a specific attribute
   *
   * @param {Tag | StyleTag | ScriptTag} node - Element node
   * @param {string} attrName - Attribute name (case-insensitive)
   * @returns {boolean} - True if attribute exists
   */ hasAttribute(node, attrName) {
        if (!this.isElement(node)) return false;
        return !!$5fb15ef29b1275b2$require$findAttr(node, attrName);
    }
    /**
   * @param {Tag | StyleTag | ScriptTag} node - Element node
   * @returns {string[]} - Array of attribute names
   */ getAttributeNames(node) {
        if (!this.isElement(node) || !node.attributes) return [];
        return node.attributes.filter((attr)=>attr.type === $5fb15ef29b1275b2$require$NODE_TYPES.Attribute && attr.key).map((attr)=>attr.key.value);
    }
    /**
   * @param {Tag | StyleTag | ScriptTag} node - Element node
   * @returns {string} - Text content
   */ getTextContent(node) {
        if (!this.isElement(node)) return "";
        // ScriptTag and StyleTag have a value property containing the content
        if (node.type === $5fb15ef29b1275b2$require$NODE_TYPES.ScriptTag || node.type === $5fb15ef29b1275b2$require$NODE_TYPES.StyleTag) {
            if (node.value && node.value.value) return node.value.value;
        }
        return "";
    }
    /**
   * Get child elements of a node
   *
   * @param {Tag | StyleTag | ScriptTag} node - Parent node
   * @returns {Tag["children"]} - Array of child element nodes (excluding
   *   text/comment nodes)
   */ getChildren(node) {
        if (node.type !== $5fb15ef29b1275b2$require$NODE_TYPES.Tag || !node.children) return [];
        return node.children.filter((child)=>this.isElement(child));
    }
    /**
   * Get parent element of a node
   *
   * @param {AnyNode} node - Child node
   * @returns {any | null} - Parent element node, or null if no parent
   */ getParent(node) {
        return node && node.parent ? node.parent : null;
    }
    /**
   * Get sibling elements of a node
   *
   * @param {AnyNode} node - Element node
   * @returns {AnyNode[]} - Array of sibling element nodes (excluding the node
   *   itself)
   */ getSiblings(node) {
        const parent = this.getParent(node);
        if (!parent) return [];
        const children = this.getChildren(parent);
        return children.filter((child)=>child !== node);
    }
    /**
   * Get source location for a node
   *
   * @param {any} node - Element node
   * @returns {{
   *   line: number;
   *   column: number;
   *   endLine?: number;
   *   endColumn?: number;
   * } | null}
   */ getLocation(node) {
        if (!node || !node.loc) return null;
        return {
            line: node.loc.start.line,
            column: node.loc.start.column,
            endLine: node.loc.end.line,
            endColumn: node.loc.end.column
        };
    }
    /**
   * Stringify element for logging/debugging
   *
   * @param {AnyNode} node - Element node
   * @returns {string} - String representation like "<meta charset='utf-8'>"
   */ /* istanbul ignore next */ stringify(node) {
        if (!this.isElement(node)) return "";
        const tagName = this.getTagName(node);
        const attrNames = this.getAttributeNames(node);
        if (attrNames.length === 0) return `<${tagName}>`;
        const attrs = attrNames.map((name)=>{
            const value = this.getAttribute(node, name);
            if (value === null) return name;
            return `${name}="${value}"`;
        }).join(" ");
        return `<${tagName} ${attrs}>`;
    }
}
$5fb15ef29b1275b2$exports = {
    HtmlEslintAdapter: $5fb15ef29b1275b2$var$HtmlEslintAdapter
};


var $e77b82cb9a0d6b56$require$HtmlEslintAdapter = $5fb15ef29b1275b2$exports.HtmlEslintAdapter;
/**
 * Capo.js v2 - DOM-agnostic HTML <head> analyzer
 * 
 * Main entry point for programmatic usage.
 * Exports both the core analyzer API and adapter implementations.
 * 
 * @module capo
 */ // Core Analysis API
/**
 * Core DOM-agnostic analyzer for capo.js
 * Provides single-pass analysis of HTML <head> elements
 * 
 * @module analyzer
 */ const $575b4d5b5a39ee58$export$881088883fcab450 = {
    META: 10,
    TITLE: 9,
    PRECONNECT: 8,
    ASYNC_SCRIPT: 7,
    IMPORT_STYLES: 6,
    SYNC_SCRIPT: 5,
    SYNC_STYLES: 4,
    PRELOAD: 3,
    DEFER_SCRIPT: 2,
    PREFETCH_PRERENDER: 1,
    OTHER: 0
};
const $575b4d5b5a39ee58$export$6ade8bb3620eb74b = {
    META: $575b4d5b5a39ee58$export$daeb0db0c224decd,
    TITLE: $575b4d5b5a39ee58$export$e55aad21605f020a,
    PRECONNECT: $575b4d5b5a39ee58$export$a3316bd0a640eb8b,
    ASYNC_SCRIPT: $575b4d5b5a39ee58$export$20e2051ffd813ee3,
    IMPORT_STYLES: $575b4d5b5a39ee58$export$be443fc6335656f0,
    SYNC_SCRIPT: $575b4d5b5a39ee58$export$65983fc0a5543400,
    SYNC_STYLES: $575b4d5b5a39ee58$export$9d6cdbffb13bee21,
    PRELOAD: $575b4d5b5a39ee58$export$226ad5ba23be83f0,
    DEFER_SCRIPT: $575b4d5b5a39ee58$export$3d269f86e8bd1d24,
    PREFETCH_PRERENDER: $575b4d5b5a39ee58$export$4d2ed086e1fec499
};
const $575b4d5b5a39ee58$export$b7417cf4a2235f73 = [
    'accept-ch',
    'content-security-policy',
    'content-type',
    'default-style',
    'delegate-ch',
    'origin-trial',
    'x-dns-prefetch-control'
];
function $575b4d5b5a39ee58$export$daeb0db0c224decd(element, adapter) {
    const tagName = adapter.getTagName(element);
    // Check if it's a base element
    if (tagName === 'base') return true;
    // Check if it's a meta element with charset, viewport, or critical http-equiv
    if (tagName !== 'meta') return false;
    // Check for charset attribute
    if (adapter.hasAttribute(element, 'charset')) return true;
    // Check for viewport meta
    const name = adapter.getAttribute(element, 'name');
    if (name && name.toLowerCase() === 'viewport') return true;
    // Check for critical http-equiv values
    const httpEquiv = adapter.getAttribute(element, 'http-equiv');
    if (httpEquiv) {
        const normalizedValue = httpEquiv.toLowerCase();
        return $575b4d5b5a39ee58$export$b7417cf4a2235f73.includes(normalizedValue);
    }
    return false;
}
function $575b4d5b5a39ee58$export$e55aad21605f020a(element, adapter) {
    return adapter.getTagName(element) === 'title';
}
function $575b4d5b5a39ee58$export$a3316bd0a640eb8b(element, adapter) {
    if (adapter.getTagName(element) !== 'link') return false;
    const rel = adapter.getAttribute(element, 'rel');
    return rel?.toLowerCase() === 'preconnect';
}
function $575b4d5b5a39ee58$export$20e2051ffd813ee3(element, adapter) {
    return adapter.getTagName(element) === 'script' && adapter.hasAttribute(element, 'src') && adapter.hasAttribute(element, 'async');
}
function $575b4d5b5a39ee58$export$be443fc6335656f0(element, adapter) {
    const importRe = /@import/;
    if (adapter.getTagName(element) === 'style') return importRe.test(adapter.getTextContent(element));
    /* TODO: Support external stylesheets.
  if (adapter.getTagName(element) === 'link' && 
      adapter.getAttribute(element, 'rel')?.toLowerCase() === 'stylesheet' &&
      adapter.hasAttribute(element, 'href')) {
    let response = fetch(adapter.getAttribute(element, 'href'));
    response = response.text();
    return importRe.test(response);
  } */ return false;
}
function $575b4d5b5a39ee58$export$65983fc0a5543400(element, adapter) {
    // Must be a script element
    if (adapter.getTagName(element) !== 'script') return false;
    // Original selector: script:not([src][defer],[src][type=module],[src][async],[type*=json])
    // This excludes scripts that match ANY of these compound conditions:
    // Exclude: scripts with src AND defer
    if (adapter.hasAttribute(element, 'src') && adapter.hasAttribute(element, 'defer')) return false;
    // Exclude: scripts with src AND type=module
    if (adapter.hasAttribute(element, 'src')) {
        const type = adapter.getAttribute(element, 'type');
        if (type && type.toLowerCase() === 'module') return false;
    }
    // Exclude: scripts with src AND async
    if (adapter.hasAttribute(element, 'src') && adapter.hasAttribute(element, 'async')) return false;
    // Exclude: scripts with type containing "json"
    const type = adapter.getAttribute(element, 'type');
    if (type && type.toLowerCase().includes('json')) return false;
    return true;
}
function $575b4d5b5a39ee58$export$9d6cdbffb13bee21(element, adapter) {
    const tagName = adapter.getTagName(element);
    // Check if it's a style element
    if (tagName === 'style') return true;
    // Check if it's a stylesheet link
    if (tagName === 'link') {
        const rel = adapter.getAttribute(element, 'rel');
        return rel?.toLowerCase() === 'stylesheet';
    }
    return false;
}
function $575b4d5b5a39ee58$export$226ad5ba23be83f0(element, adapter) {
    if (adapter.getTagName(element) !== 'link') return false;
    const rel = adapter.getAttribute(element, 'rel');
    if (!rel) return false;
    const relLower = rel.toLowerCase();
    return relLower === 'preload' || relLower === 'modulepreload';
}
function $575b4d5b5a39ee58$export$3d269f86e8bd1d24(element, adapter) {
    if (adapter.getTagName(element) !== 'script') return false;
    if (!adapter.hasAttribute(element, 'src')) return false;
    // Script with defer attribute
    if (adapter.hasAttribute(element, 'defer')) return true;
    // Module scripts are defer by default, unless they have async
    const type = adapter.getAttribute(element, 'type');
    if (type && type.toLowerCase() === 'module') return !adapter.hasAttribute(element, 'async');
    return false;
}
function $575b4d5b5a39ee58$export$4d2ed086e1fec499(element, adapter) {
    if (adapter.getTagName(element) !== 'link') return false;
    const rel = adapter.getAttribute(element, 'rel');
    if (!rel) return false;
    const relLower = rel.toLowerCase();
    return relLower === 'prefetch' || relLower === 'dns-prefetch' || relLower === 'prerender';
}
function $575b4d5b5a39ee58$export$38a04d482ec50f88(element, adapter) {
    if (adapter.getTagName(element) !== 'meta') return false;
    const httpEquiv = adapter.getAttribute(element, 'http-equiv');
    return httpEquiv?.toLowerCase() === 'origin-trial';
}
function $575b4d5b5a39ee58$export$14b1a2f64a600585(element, adapter) {
    if (adapter.getTagName(element) !== 'meta') return false;
    const httpEquiv = adapter.getAttribute(element, 'http-equiv');
    if (!httpEquiv) return false;
    const httpEquivLower = httpEquiv.toLowerCase();
    return httpEquivLower === 'content-security-policy' || httpEquivLower === 'content-security-policy-report-only';
}
function $575b4d5b5a39ee58$export$de32fe5d64aee40c(element, adapter) {
    for (let [id, detector] of Object.entries($575b4d5b5a39ee58$export$6ade8bb3620eb74b)){
        if (detector(element, adapter)) return $575b4d5b5a39ee58$export$881088883fcab450[id];
    }
    return $575b4d5b5a39ee58$export$881088883fcab450.OTHER;
}
function $575b4d5b5a39ee58$export$5cc4a311ddbe699c(head, adapter) {
    const headChildren = adapter.getChildren(head);
    return headChildren.filter((element)=>{
        // Filter out text nodes and comments - only include actual elements
        const tagName = adapter.getTagName(element);
        return tagName && tagName !== '';
    }).map((element)=>{
        return {
            element: element,
            weight: $575b4d5b5a39ee58$export$de32fe5d64aee40c(element, adapter)
        };
    });
}



const $5e36c71c9d07f4d8$export$79e124b7caef7aa9 = new Set([
    "base",
    "link",
    "meta",
    "noscript",
    "script",
    "style",
    "template",
    "title"
]);
const $5e36c71c9d07f4d8$export$2f975f13375faaa1 = 'meta[http-equiv="content-type" i], meta[charset]';
const $5e36c71c9d07f4d8$export$9739336dee0b3205 = "meta[http-equiv]";
const $5e36c71c9d07f4d8$export$5540ac2a18901364 = 'link:is([rel="preload" i], [rel="modulepreload" i])';
function $5e36c71c9d07f4d8$export$a8257692ac88316c(element, adapter) {
    const tagName = adapter.getTagName(element);
    // Text nodes and comment nodes are valid (they don't have tag names)
    if (!tagName || tagName === '') return true;
    return $5e36c71c9d07f4d8$export$79e124b7caef7aa9.has(tagName.toLowerCase());
}
/**
 * Check if element has any invalid child elements
 * @param {any} element - Element to check
 * @param {any} adapter - Adapter instance
 * @returns {boolean}
 */ function $5e36c71c9d07f4d8$var$hasInvalidChildren(element, adapter) {
    const children = adapter.getChildren(element);
    return children.some((child)=>!$5e36c71c9d07f4d8$export$a8257692ac88316c(child, adapter));
}
/**
 * Check if this is a duplicate title element (2nd+ occurrence)
 * @param {any} element - Element to check
 * @param {any} adapter - Adapter instance
 * @returns {boolean}
 */ function $5e36c71c9d07f4d8$var$isDuplicateTitle(element, adapter) {
    if (adapter.getTagName(element) !== 'title') return false;
    const parent = adapter.getParent(element);
    if (!parent) return false;
    // Check if this is the first title element
    let foundFirst = false;
    for (const child of adapter.getChildren(parent))if (adapter.getTagName(child) === 'title') {
        if (child === element) // This is the element we're checking - it's a duplicate if we already found a title
        return foundFirst;
        // Found a title element - mark that we've seen one
        foundFirst = true;
    }
    return false;
}
/**
 * Check if this is a duplicate base element
 * @param {any} element - Element to check  
 * @param {any} adapter - Adapter instance
 * @returns {boolean}
 */ function $5e36c71c9d07f4d8$var$isDuplicateBase(element, adapter) {
    if (adapter.getTagName(element) !== 'base') return false;
    const siblings = adapter.getSiblings(element);
    return siblings.some((sibling)=>adapter.getTagName(sibling) === 'base');
}
function $5e36c71c9d07f4d8$export$eeefd08c3a6f8db7(element, adapter) {
    // Element itself is not valid.
    if (!$5e36c71c9d07f4d8$export$a8257692ac88316c(element, adapter)) return true;
    // Children are not valid.
    if ($5e36c71c9d07f4d8$var$hasInvalidChildren(element, adapter)) return true;
    // <title> is not the first of its type.
    if ($5e36c71c9d07f4d8$var$isDuplicateTitle(element, adapter)) return true;
    // <base> is not the first of its type.
    if ($5e36c71c9d07f4d8$var$isDuplicateBase(element, adapter)) return true;
    // CSP meta tag anywhere.
    if ((0, $575b4d5b5a39ee58$export$14b1a2f64a600585)(element, adapter)) return true;
    // Invalid http-equiv.
    if ($5e36c71c9d07f4d8$var$isInvalidHttpEquiv(element, adapter)) return true;
    // Invalid meta viewport.
    if ($5e36c71c9d07f4d8$var$isInvalidMetaViewport(element, adapter)) return true;
    // Invalid default-style.
    if ($5e36c71c9d07f4d8$var$isInvalidDefaultStyle(element, adapter)) return true;
    // Invalid character encoding.
    if ($5e36c71c9d07f4d8$var$isInvalidContentType(element, adapter)) return true;
    // Origin trial expired, or invalid origin.
    if ($5e36c71c9d07f4d8$var$isInvalidOriginTrial(element, adapter)) return true;
    // Preload is unnecessary.
    if ($5e36c71c9d07f4d8$var$isUnnecessaryPreload(element, adapter)) return true;
    // Preload is missing crossorigin.
    if ($5e36c71c9d07f4d8$var$isInvalidFontPreload(element, adapter)) return true;
    return false;
}
function $5e36c71c9d07f4d8$export$b01ab94d0cd042a0(head, adapter) {
    const validationWarnings = [];
    // Get all children of head element
    const children = adapter.getChildren(head);
    // Check for title elements
    const titleElements = children.filter((child)=>adapter.getTagName(child) === 'title');
    const titleElementCount = titleElements.length;
    if (titleElementCount != 1) validationWarnings.push({
        ruleId: titleElementCount === 0 ? 'require-title' : 'no-duplicate-title',
        warning: `Expected exactly 1 <title> element, found ${titleElementCount}`,
        elements: titleElements
    });
    // Check for meta viewport
    const metaViewport = children.filter((child)=>{
        if (adapter.getTagName(child) !== 'meta') return false;
        const name = adapter.getAttribute(child, 'name');
        return name && name.toLowerCase() === 'viewport';
    });
    if (metaViewport.length != 1) validationWarnings.push({
        ruleId: metaViewport.length === 0 ? 'require-meta-viewport' : 'valid-meta-viewport',
        warning: `Expected exactly 1 <meta name=viewport> element, found ${metaViewport.length}`,
        elements: metaViewport
    });
    // Check for base elements
    const baseElements = children.filter((child)=>adapter.getTagName(child) === 'base');
    const baseElementCount = baseElements.length;
    if (baseElementCount > 1) validationWarnings.push({
        ruleId: 'no-duplicate-base',
        warning: `Expected at most 1 <base> element, found ${baseElementCount}`,
        elements: baseElements
    });
    // Note: CSP meta tags are validated in customValidations, not here
    // to avoid duplicate reporting
    // Check for invalid elements
    children.forEach((element)=>{
        if ($5e36c71c9d07f4d8$export$a8257692ac88316c(element, adapter)) return;
        // For invalid elements, we just report the element itself
        // (adapter doesn't have parentElement concept, so we can't find root)
        validationWarnings.push({
            ruleId: 'no-invalid-head-elements',
            warning: `${adapter.getTagName(element)} elements are not allowed in the <head>`,
            element: element
        });
    });
    // Note: Origin trials are validated in customValidations, not here
    // to avoid duplicate reporting
    return validationWarnings;
}
function $5e36c71c9d07f4d8$export$6c93e2175c028eeb(element, adapter, parentElement = null) {
    const results = [];
    if ((0, $575b4d5b5a39ee58$export$38a04d482ec50f88)(element, adapter)) results.push($5e36c71c9d07f4d8$var$validateOriginTrial(element, adapter));
    if ((0, $575b4d5b5a39ee58$export$14b1a2f64a600585)(element, adapter)) results.push($5e36c71c9d07f4d8$var$validateCSP(element, adapter));
    if ($5e36c71c9d07f4d8$var$isDefaultStyle(element, adapter)) results.push($5e36c71c9d07f4d8$var$validateDefaultStyle(element, adapter));
    if ($5e36c71c9d07f4d8$var$isMetaViewport(element, adapter)) results.push($5e36c71c9d07f4d8$var$validateMetaViewport(element, adapter));
    if ($5e36c71c9d07f4d8$var$isContentType(element, adapter)) results.push($5e36c71c9d07f4d8$var$validateContentType(element, adapter));
    if ($5e36c71c9d07f4d8$var$isHttpEquiv(element, adapter)) results.push($5e36c71c9d07f4d8$var$validateHttpEquiv(element, adapter));
    if ($5e36c71c9d07f4d8$var$isUnnecessaryPreload(element, adapter, parentElement)) results.push($5e36c71c9d07f4d8$var$validateUnnecessaryPreload(element, adapter, parentElement));
    if ($5e36c71c9d07f4d8$var$isInvalidFontPreload(element, adapter)) results.push($5e36c71c9d07f4d8$var$validateInvalidFontPreload(element, adapter));
    if (results.length === 0) return {};
    if (results.length === 1) return results[0];
    // Merge results
    const combined = {
        warnings: [],
        payload: {},
        ruleId: results[0].ruleId
    };
    results.forEach((result)=>{
        if (result.warnings) combined.warnings.push(...result.warnings);
        if (result.payload) Object.assign(combined.payload, result.payload);
    });
    return combined;
}
function $5e36c71c9d07f4d8$var$validateCSP(element, adapter) {
    const warnings = [];
    let payload = null;
    const httpEquiv = adapter.getAttribute(element, 'http-equiv');
    const httpEquivLower = httpEquiv?.toLowerCase();
    if (httpEquivLower === 'content-security-policy-report-only') {
        //https://w3c.github.io/webappsec-csp/#meta-element
        warnings.push("CSP Report-Only is forbidden in meta tags");
        return {
            ruleId: 'no-meta-csp',
            warnings: warnings,
            payload: payload
        };
    }
    if (httpEquivLower === 'content-security-policy') warnings.push("meta CSP discouraged. See https://crbug.com/1458493.");
    const content = adapter.getAttribute(element, "content");
    if (!content) {
        warnings.push("Invalid CSP. The content attribute must be set.");
        return {
            warnings: warnings,
            payload: payload
        };
    }
    const directives = Object.fromEntries(content.split(/\s*;\s*/).map((directive)=>{
        const [key, ...value] = directive.split(" ");
        return [
            key,
            value.join(" ")
        ];
    }));
    payload = payload ?? {};
    payload.directives = directives;
    if ("report-uri" in directives) warnings.push("The report-uri directive is not supported. Use the Content-Security-Policy-Report-Only HTTP header instead.");
    if ("frame-ancestors" in directives) warnings.push("The frame-ancestors directive is not supported. Use the Content-Security-Policy HTTP header instead.");
    if ("sandbox" in directives) warnings.push("The sandbox directive is not supported. Use the Content-Security-Policy HTTP header instead.");
    return {
        ruleId: 'no-meta-csp',
        warnings: warnings,
        payload: payload
    };
}
function $5e36c71c9d07f4d8$var$isInvalidOriginTrial(element, adapter) {
    if (!(0, $575b4d5b5a39ee58$export$38a04d482ec50f88)(element, adapter)) return false;
    const { warnings: warnings } = $5e36c71c9d07f4d8$var$validateOriginTrial(element, adapter);
    return warnings.length > 0;
}
function $5e36c71c9d07f4d8$var$validateOriginTrial(element, adapter) {
    const metadata = {
        ruleId: 'no-invalid-origin-trial',
        payload: null,
        warnings: []
    };
    const token = adapter.getAttribute(element, "content");
    try {
        metadata.payload = $5e36c71c9d07f4d8$var$decodeOriginTrialToken(token);
    } catch  {
        metadata.warnings.push("Invalid origin trial token: invalid token");
        return metadata;
    }
    if (metadata.payload.expiry < new Date()) metadata.warnings.push("Invalid origin trial token: expired");
    // Origin validation only works in browser context with document.location
    if (typeof document !== 'undefined' && document.location && document.location.href) {
        if (!$5e36c71c9d07f4d8$var$isSameOrigin(metadata.payload.origin, document.location.href)) {
            const subdomain = $5e36c71c9d07f4d8$var$isSubdomain(metadata.payload.origin, document.location.href);
            // Cross-origin OTs are only valid if:
            //   1. The document is a subdomain of the OT origin and the isSubdomain config is set
            //   2. The isThirdParty config is set
            if (subdomain && !metadata.payload.isSubdomain) metadata.warnings.push("Invalid origin trial token: invalid subdomain");
            else if (!subdomain && !metadata.payload.isThirdParty) metadata.warnings.push("Invalid origin trial token: invalid third-party origin");
        }
    }
    return metadata;
}
// Adapted from https://glitch.com/~ot-decode.
function $5e36c71c9d07f4d8$var$decodeOriginTrialToken(token) {
    const buffer = new Uint8Array([
        ...atob(token)
    ].map((a)=>a.charCodeAt(0)));
    const view = new DataView(buffer.buffer);
    const length = view.getUint32(65, false);
    const payload = JSON.parse(new TextDecoder().decode(buffer.slice(69, 69 + length)));
    payload.expiry = new Date(payload.expiry * 1000);
    return payload;
}
function $5e36c71c9d07f4d8$var$isSameOrigin(a, b) {
    return new URL(a).origin === new URL(b).origin;
}
// Whether b is a subdomain of a
function $5e36c71c9d07f4d8$var$isSubdomain(a, b) {
    // www.example.com ends with .example.com
    a = new URL(a);
    b = new URL(b);
    return b.host.endsWith(`.${a.host}`);
}
function $5e36c71c9d07f4d8$var$isDefaultStyle(element, adapter) {
    if (adapter.getTagName(element) !== 'meta') return false;
    const httpEquiv = adapter.getAttribute(element, 'http-equiv');
    return httpEquiv?.toLowerCase() === 'default-style';
}
function $5e36c71c9d07f4d8$var$isContentType(element, adapter) {
    // Matches: meta[http-equiv="content-type" i], meta[charset]
    if (adapter.getTagName(element) !== 'meta') return false;
    if (adapter.hasAttribute(element, 'charset')) return true;
    const httpEquiv = adapter.getAttribute(element, 'http-equiv');
    return httpEquiv?.toLowerCase() === 'content-type';
}
function $5e36c71c9d07f4d8$var$isHttpEquiv(element, adapter) {
    // Matches: meta[http-equiv]
    if (adapter.getTagName(element) !== 'meta') return false;
    return adapter.hasAttribute(element, 'http-equiv');
}
function $5e36c71c9d07f4d8$var$isMetaViewport(element, adapter) {
    if (adapter.getTagName(element) !== 'meta') return false;
    const name = adapter.getAttribute(element, 'name');
    return name?.toLowerCase() === 'viewport';
}
function $5e36c71c9d07f4d8$var$isInvalidDefaultStyle(element, adapter) {
    if (!$5e36c71c9d07f4d8$var$isDefaultStyle(element, adapter)) return false;
    const { warnings: warnings } = $5e36c71c9d07f4d8$var$validateDefaultStyle(element, adapter);
    return warnings.length > 0;
}
function $5e36c71c9d07f4d8$var$isInvalidContentType(element, adapter) {
    if (!$5e36c71c9d07f4d8$var$isContentType(element, adapter)) return false;
    const { warnings: warnings } = $5e36c71c9d07f4d8$var$validateContentType(element, adapter);
    return warnings.length > 0;
}
function $5e36c71c9d07f4d8$var$isInvalidHttpEquiv(element, adapter) {
    if (!$5e36c71c9d07f4d8$var$isHttpEquiv(element, adapter)) return false;
    const { warnings: warnings } = $5e36c71c9d07f4d8$var$validateHttpEquiv(element, adapter);
    return warnings.length > 0;
}
function $5e36c71c9d07f4d8$var$isInvalidMetaViewport(element, adapter) {
    if (!$5e36c71c9d07f4d8$var$isMetaViewport(element, adapter)) return false;
    const { warnings: warnings } = $5e36c71c9d07f4d8$var$validateMetaViewport(element, adapter);
    return warnings.length > 0;
}
function $5e36c71c9d07f4d8$var$isUnnecessaryPreload(element, adapter, parentElement = null) {
    // Matches: link:is([rel="preload" i], [rel="modulepreload" i])
    const tagName = adapter.getTagName(element);
    if (tagName !== 'link') return false;
    const rel = adapter.getAttribute(element, 'rel');
    const relLower = rel?.toLowerCase();
    if (relLower !== 'preload' && relLower !== 'modulepreload') return false;
    const href = adapter.getAttribute(element, "href");
    if (!href) return false;
    const parent = parentElement || adapter.getParent(element);
    if (!parent) return false;
    const found = $5e36c71c9d07f4d8$var$findElementWithSource(parent, href, element, adapter);
    return found != null;
}
function $5e36c71c9d07f4d8$var$isInvalidFontPreload(element, adapter) {
    const tagName = adapter.getTagName(element);
    if (tagName !== 'link') return false;
    const rel = adapter.getAttribute(element, 'rel');
    if (rel?.toLowerCase() !== 'preload') return false;
    const as = adapter.getAttribute(element, 'as');
    if (as?.toLowerCase() !== 'font') return false;
    // crossorigin must be present (even if empty, which means anonymous)
    return !adapter.hasAttribute(element, 'crossorigin');
}
function $5e36c71c9d07f4d8$var$validateInvalidFontPreload(element, adapter) {
    const warnings = [
        "Font preloads must have the crossorigin attribute set, even for same-origin fonts."
    ];
    return {
        ruleId: 'valid-font-preload',
        warnings: warnings,
        payload: null
    };
}
/**
 * Find an element with matching source using adapter (non-browser)
 * @param {*} parent - Parent element to search within
 * @param {string} sourceUrl - URL to match
 * @param {*} excludeElement - Element to exclude from search (the preload itself)
 * @param {*} adapter - Adapter instance
 * @returns {*|null} - Matching element or null
 */ function $5e36c71c9d07f4d8$var$findElementWithSource(parent, sourceUrl, excludeElement, adapter) {
    const children = adapter.getChildren(parent);
    for (const child of children){
        // Skip the preload element itself
        if (child === excludeElement) continue;
        const tagName = adapter.getTagName(child);
        // Check link elements (but not preload/modulepreload)
        if (tagName === 'link') {
            const rel = adapter.getAttribute(child, 'rel');
            if (rel && /\b(preload|modulepreload)\b/i.test(rel)) continue; // Skip other preloads
            const childHref = adapter.getAttribute(child, 'href');
            if (childHref === sourceUrl) return child;
        }
        // Check script elements
        if (tagName === 'script') {
            const src = adapter.getAttribute(child, 'src');
            if (src === sourceUrl) return child;
        }
    }
    return null;
}
function $5e36c71c9d07f4d8$var$absolutifyUrl(href) {
    // Browser-only function
    if (typeof document === 'undefined' || !document.baseURI) // In non-browser context, return href as-is
    return href;
    return new URL(href, document.baseURI).href;
}
function $5e36c71c9d07f4d8$var$validateDefaultStyle(element, adapter) {
    const warnings = [];
    let payload = null;
    // Check if the value points to an alternate stylesheet with that title
    const title = adapter.getAttribute(element, "content");
    // Browser-only validation
    if (element.parentElement && element.parentElement.querySelector) {
        const stylesheet = element.parentElement.querySelector(`link[rel~="alternate" i][rel~="stylesheet" i][title="${title}"]`);
        if (!title) warnings.push("This has no effect. The content attribute must be set to a valid stylesheet title.");
        else if (!stylesheet) {
            payload = {
                alternateStylesheets: Array.from(element.parentElement.querySelectorAll('link[rel~="alternate" i][rel~="stylesheet" i]'))
            };
            warnings.push(`This has no effect. No alternate stylesheet found having title="${title}".`);
        }
    } else if (!title) // In non-browser context, we can still check for missing title
    warnings.push("This has no effect. The content attribute must be set to a valid stylesheet title.");
    warnings.push("Even when used correctly, the default-style method of setting a preferred stylesheet results in a flash of unstyled content. Use modern CSS features like @media rules instead.");
    return {
        ruleId: 'no-default-style',
        warnings: warnings,
        payload: payload
    };
}
function $5e36c71c9d07f4d8$var$validateContentType(element, adapter) {
    const warnings = [];
    let payload = null;
    // https://html.spec.whatwg.org/multipage/semantics.html#character-encoding-declaration
    // Check if there exists both meta[http-equiv] and meta[chartset] variations
    // Check if this is a charset or content-type meta
    const isCharset = adapter.hasAttribute(element, 'charset');
    const httpEquiv = adapter.getAttribute(element, 'http-equiv');
    const isContentTypeMeta = httpEquiv?.toLowerCase() === 'content-type';
    if (isCharset || isContentTypeMeta) {
        // Check for duplicate charset declarations among siblings
        const siblings = adapter.getSiblings(element);
        const hasDuplicateCharset = siblings.some((sibling)=>{
            if (adapter.getTagName(sibling) !== 'meta') return false;
            // Check if sibling is also a charset declaration
            if (adapter.hasAttribute(sibling, 'charset')) return true;
            const siblingHttpEquiv = adapter.getAttribute(sibling, 'http-equiv');
            return siblingHttpEquiv?.toLowerCase() === 'content-type';
        });
        if (hasDuplicateCharset) {
            const parent = adapter.getParent(element);
            if (parent) {
                const charsetElements = adapter.getChildren(parent).filter((child)=>{
                    if (adapter.getTagName(child) !== 'meta') return false;
                    if (adapter.hasAttribute(child, 'charset')) return true;
                    const childHttpEquiv = adapter.getAttribute(child, 'http-equiv');
                    return childHttpEquiv?.toLowerCase() === 'content-type';
                });
                // Find the first one (not this element)
                const encodingDeclaration = charsetElements.find((el)=>el !== element);
                if (encodingDeclaration) {
                    payload = payload ?? {};
                    payload.encodingDeclaration = encodingDeclaration;
                    warnings.push(`There can only be one meta-based character encoding declaration per document. Already found \`${adapter.stringify(encodingDeclaration)}\`.`);
                }
            }
        }
    }
    // Check if it completely exists in the first 1024 bytes
    // This check only works in browser context with ownerDocument
    if (element.ownerDocument?.documentElement?.outerHTML && element.outerHTML) {
        const charPos = element.ownerDocument.documentElement.outerHTML.indexOf(element.outerHTML) + element.outerHTML.length;
        if (charPos > 1024) {
            payload = payload ?? {};
            payload.characterPosition = charPos;
            warnings.push(`The element containing the character encoding declaration must be serialized completely within the first 1024 bytes of the document. Found at byte ${charPos}.`);
        }
    }
    // Check that the character encoding is UTF-8
    let charset = null;
    if (isCharset) charset = adapter.getAttribute(element, "charset");
    else {
        const charsetPattern = /text\/html;\s*charset=(.*)/i;
        charset = adapter.getAttribute(element, "content")?.match(charsetPattern)?.[1]?.trim();
    }
    if (charset?.toLowerCase() != "utf-8") {
        payload = payload ?? {};
        payload.charset = charset;
        warnings.push(`Documents are required to use UTF-8 encoding. Found "${charset}".`);
    }
    if (warnings.length) // Append the spec source to the last warning
    warnings[warnings.length - 1] += "\nLearn more: https://html.spec.whatwg.org/multipage/semantics.html#character-encoding-declaration";
    return {
        ruleId: 'valid-charset',
        warnings: warnings,
        payload: payload
    };
}
function $5e36c71c9d07f4d8$var$validateHttpEquiv(element, adapter) {
    const warnings = [];
    const type = adapter.getAttribute(element, "http-equiv").toLowerCase();
    const content = adapter.getAttribute(element, "content")?.toLowerCase();
    switch(type){
        case "content-security-policy":
        case "content-security-policy-report-only":
        case "origin-trial":
        case "content-type":
        case "default-style":
            break;
        case "refresh":
            if (!content) {
                warnings.push("This doesn't do anything. The content attribute must be set. However, using refresh is discouraged.");
                break;
            }
            if (content.includes("url=")) warnings.push("Meta auto-redirects are discouraged. Use HTTP 3XX responses instead.");
            else warnings.push("Meta auto-refreshes are discouraged unless users have the ability to disable it.");
            break;
        case "x-dns-prefetch-control":
            if (content == "on") warnings.push(`DNS prefetching is enabled by default. Setting it to "${content}" has no effect.`);
            else if (content != "off") warnings.push(`This is a non-standard way of disabling DNS prefetching, which is a performance optimization. Found content="${content}". Use content="off" if you have a legitimate security concern, otherwise remove it.`);
            else warnings.push("This is non-standard, however most browsers support disabling speculative DNS prefetching. It should still be noted that DNS prefetching is a generally accepted performance optimization and you should only disable it if you have specific security concerns.");
            break;
        case "cache-control":
        case "etag":
        case "pragma":
        case "expires":
        case "last-modified":
            warnings.push("This doesn't do anything. Use HTTP headers for any cache directives.");
            break;
        case "x-frame-options":
            warnings.push("This doesn't do anything. Use the CSP HTTP header with the frame-ancestors directive instead.");
            break;
        case "x-ua-compatible":
        case "content-style-type":
        case "content-script-type":
        case "imagetoolbar":
        case "cleartype":
        case "page-enter":
        case "page-exit":
        case "site-enter":
        case "site-exit":
        case "msthemecompatible":
        case "window-target":
            warnings.push("This doesn't do anything. It was an Internet Explorer feature and is now deprecated.");
            break;
        case "content-language":
        case "language":
            warnings.push("This is non-conforming. Use the html[lang] attribute instead.");
            break;
        case "set-cookie":
            warnings.push("This is non-conforming. Use the Set-Cookie HTTP header instead.");
            break;
        case "application-name":
        case "author":
        case "description":
        case "generator":
        case "keywords":
        case "referrer":
        case "theme-color":
        case "color-scheme":
        case "viewport":
        case "creator":
        case "googlebot":
        case "publisher":
        case "robots":
            warnings.push(`This doesn't do anything. Did you mean \`meta[name=${type}]\`?`);
            break;
        case "encoding":
            warnings.push("This doesn't do anything. Did you mean `meta[charset]`?");
            break;
        case "title":
            warnings.push("This doesn't do anything. Did you mean to use the `title` tag instead?");
            break;
        case "accept-ch":
        case "delegate-ch":
            warnings.push("This is non-standard and may not work across browsers. Use HTTP headers instead.");
            break;
        default:
            warnings.push("This is non-standard and may not work across browsers. http-equiv is not an alternative to HTTP headers.");
            break;
    }
    return {
        ruleId: 'no-invalid-http-equiv',
        warnings: warnings
    };
}
function $5e36c71c9d07f4d8$var$validateMetaViewport(element, adapter) {
    const warnings = [];
    let payload = null;
    // Redundant meta viewport validation.
    // Check if there are other viewport meta elements among siblings
    const siblings = adapter.getSiblings(element);
    const hasDuplicateViewport = siblings.some((sibling)=>{
        if (adapter.getTagName(sibling) !== 'meta') return false;
        const name = adapter.getAttribute(sibling, 'name');
        return name?.toLowerCase() === 'viewport';
    });
    if (hasDuplicateViewport) {
        const parent = adapter.getParent(element);
        if (parent) {
            const viewportElements = adapter.getChildren(parent).filter((child)=>{
                if (adapter.getTagName(child) !== 'meta') return false;
                const name = adapter.getAttribute(child, 'name');
                return name?.toLowerCase() === 'viewport';
            });
            // Find the first one (not this element)
            const firstMetaViewport = viewportElements.find((el)=>el !== element);
            if (firstMetaViewport) {
                payload = {
                    firstMetaViewport: firstMetaViewport
                };
                warnings.push("Another meta viewport element has already been declared. Having multiple viewport settings can lead to unexpected behavior.");
                return {
                    warnings: warnings,
                    payload: payload
                };
            }
        }
    }
    // Additional validation performed only on the first meta viewport.
    const content = adapter.getAttribute(element, "content")?.toLowerCase();
    if (!content) {
        warnings.push("Invalid viewport. The content attribute must be set.");
        return {
            warnings: warnings,
            payload: payload
        };
    }
    const directives = Object.fromEntries(content.split(",").map((directive)=>{
        const [key, value] = directive.split("=");
        return [
            key?.trim(),
            value?.trim()
        ];
    }));
    if ("width" in directives) {
        const width = directives["width"];
        if (Number(width) < 1 || Number(width) > 10000) warnings.push(`Invalid width "${width}". Numeric values must be between 1 and 10000.`);
        else if (width != "device-width") warnings.push(`Invalid width "${width}".`);
    }
    if ("height" in directives) {
        const height = directives["height"];
        if (Number(height) < 1 || Number(height) > 10000) warnings.push(`Invalid height "${height}". Numeric values must be between 1 and 10000.`);
        else if (height != "device-height") warnings.push(`Invalid height "${height}".`);
    }
    if ("initial-scale" in directives) {
        const initialScale = Number(directives["initial-scale"]);
        if (isNaN(initialScale)) warnings.push(`Invalid initial zoom level "${directives["initial-scale"]}". Values must be numeric.`);
        if (initialScale < 0.1 || initialScale > 10) warnings.push(`Invalid initial zoom level "${initialScale}". Values must be between 0.1 and 10.`);
    }
    if ("minimum-scale" in directives) {
        const minimumScale = Number(directives["minimum-scale"]);
        if (isNaN(minimumScale)) warnings.push(`Invalid minimum zoom level "${directives["minimum-scale"]}". Values must be numeric.`);
        if (minimumScale < 0.1 || minimumScale > 10) warnings.push(`Invalid minimum zoom level "${minimumScale}". Values must be between 0.1 and 10.`);
    }
    if ("maximum-scale" in directives) {
        const maxScale = Number(directives["maximum-scale"]);
        if (isNaN(maxScale)) warnings.push(`Invalid maximum zoom level "${directives["maximum-scale"]}". Values must be numeric.`);
        if (maxScale < 0.1 || maxScale > 10) warnings.push(`Invalid maximum zoom level "${maxScale}". Values must be between 0.1 and 10.`);
        if (maxScale < 2) warnings.push(`Disabling zoom levels under 2x can cause accessibility issues. Found "${maxScale}".`);
    }
    if ("user-scalable" in directives) {
        const userScalable = directives["user-scalable"];
        if (userScalable == "no" || userScalable == "0") warnings.push(`Disabling zooming can cause accessibility issues to users with visual impairments. Found "${userScalable}".`);
        if (![
            "0",
            "1",
            "yes",
            "no"
        ].includes(userScalable)) warnings.push(`Unsupported value "${userScalable}" found.`);
    }
    if ("interactive-widget" in directives) {
        const interactiveWidget = directives["interactive-widget"];
        const validValues = [
            "resizes-visual",
            "resizes-content",
            "overlays-content"
        ];
        if (!validValues.includes(interactiveWidget)) warnings.push(`Unsupported value "${interactiveWidget}" found.`);
    }
    if ("viewport-fit" in directives) {
        const viewportFit = directives["viewport-fit"];
        const validValues = [
            "auto",
            "contain",
            "cover"
        ];
        if (!validValues.includes(viewportFit)) warnings.push(`Unsupported value "${viewportFit}" found. Should be one of: ${validValues.join(", ")}.`);
    }
    if ("shrink-to-fit" in directives) warnings.push("The shrink-to-fit directive has been obsolete since iOS 9.2.\n  See https://www.scottohara.me/blog/2018/12/11/shrink-to-fit.html");
    const validDirectives = new Set([
        "width",
        "height",
        "initial-scale",
        "minimum-scale",
        "maximum-scale",
        "user-scalable",
        "interactive-widget"
    ]);
    Object.keys(directives).filter((directive)=>{
        if (validDirectives.has(directive)) // The directive is valid.
        return false;
        if (directive == "shrink-to-fit") // shrink-to-fit is not valid, but we have a separate warning for it.
        return false;
        directive;
        return true;
    }).forEach((directive)=>{
        warnings.push(`Invalid viewport directive "${directive}".`);
    });
    return {
        ruleId: 'valid-meta-viewport',
        warnings: warnings,
        payload: payload
    };
}
function $5e36c71c9d07f4d8$var$validateUnnecessaryPreload(element, adapter, parentElement = null) {
    const href = adapter.getAttribute(element, "href");
    if (!href) return {
        ruleId: 'no-unnecessary-preload',
        warnings: []
    };
    const parent = parentElement || adapter.getParent(element);
    if (!parent) return {
        ruleId: 'no-unnecessary-preload',
        warnings: []
    };
    const preloadedElement = $5e36c71c9d07f4d8$var$findElementWithSource(parent, href, element, adapter);
    if (!preloadedElement) return {
        ruleId: 'no-unnecessary-preload',
        warnings: []
    };
    return {
        ruleId: 'no-unnecessary-preload',
        warnings: [
            `This preload has little to no effect. ${href} is already discoverable by another ${adapter.getTagName(preloadedElement)} element.`
        ]
    };
}


function $199df24bfdfd3404$export$66aa292af6e88fd9(headNode, adapter, options = {}) {
    const { includeValidation: includeValidation = true, includeCustomValidations: includeCustomValidations = true } = options;
    // Pass 1: Compute weights for all elements
    const weights = $575b4d5b5a39ee58$export$5cc4a311ddbe699c(headNode, adapter);
    // Pass 2: Get document-level validation warnings
    const validationWarnings = includeValidation ? (0, $5e36c71c9d07f4d8$export$b01ab94d0cd042a0)(headNode, adapter) : [];
    // Pass 3: Get element-level custom validations
    const customValidations = includeCustomValidations ? $199df24bfdfd3404$var$getElementValidations(headNode, adapter) : [];
    return {
        weights: weights,
        validationWarnings: validationWarnings,
        customValidations: customValidations,
        headElement: headNode
    };
}
/**
 * Get custom validations for all elements in head
 * 
 * @param {any} headNode - The <head> element
 * @param {Object} adapter - HTMLAdapter implementation
 * @returns {Array<CustomValidation>}
 * @private
 */ function $199df24bfdfd3404$var$getElementValidations(headNode, adapter) {
    const customValidations = [];
    const children = adapter.getChildren(headNode);
    for (const element of children){
        const validation = (0, $5e36c71c9d07f4d8$export$6c93e2175c028eeb)(element, adapter, headNode);
        if (validation && validation.warnings && validation.warnings.length > 0) customValidations.push({
            ruleId: validation.ruleId,
            element: element,
            warnings: validation.warnings,
            payload: validation.payload
        });
    }
    return customValidations;
}
function $199df24bfdfd3404$export$a824357f4ceaf2cf(weight) {
    // Find the category that matches this weight
    for (const [category, value] of Object.entries($575b4d5b5a39ee58$export$881088883fcab450)){
        if (value === weight) return category;
    }
    return 'UNKNOWN';
}
function $199df24bfdfd3404$export$9d3d5cf01843f4a8(weights) {
    const violations = [];
    for(let i = 0; i < weights.length - 1; i++){
        const current = weights[i];
        const next = weights[i + 1];
        if (current.weight < next.weight) {
            const currentCategory = $199df24bfdfd3404$export$a824357f4ceaf2cf(current.weight);
            const nextCategory = $199df24bfdfd3404$export$a824357f4ceaf2cf(next.weight);
            violations.push({
                index: i + 1,
                currentElement: current.element,
                nextElement: next.element,
                currentWeight: current.weight,
                nextWeight: next.weight,
                currentCategory: currentCategory,
                nextCategory: nextCategory,
                message: `${nextCategory} element should come before ${currentCategory} element`
            });
        }
    }
    return violations;
}
function $199df24bfdfd3404$export$283ccd6e4ed2051d(headNode, adapter, options = {}) {
    const result = $199df24bfdfd3404$export$66aa292af6e88fd9(headNode, adapter, options);
    const orderingViolations = $199df24bfdfd3404$export$9d3d5cf01843f4a8(result.weights);
    return {
        ...result,
        orderingViolations: orderingViolations
    };
}




/**
 * @file Browser DOM adapter
 * 
 * Wraps native DOM Element APIs to implement the HTMLAdapter interface.
 * This adapter is used in browser environments where capo.js operates
 * on actual DOM elements.
 */ /**
 * @file Base adapter interface for HTML tree operations
 * 
 * This file defines the contract that all adapters must implement.
 * Adapters abstract away environment-specific operations (browser DOM vs AST nodes)
 * to make capo.js core logic reusable across different contexts.
 * 
 * @interface HTMLAdapter
 */ const $8dba25bed55014f4$var$REQUIRED_METHODS = [
    'isElement',
    'getTagName',
    'getAttribute',
    'hasAttribute',
    'getAttributeNames',
    'getTextContent',
    'getChildren',
    'getParent',
    'getSiblings',
    'stringify'
];
class $8dba25bed55014f4$export$d1d100ae3c773a95 {
    /**
   * Check if node is an Element (not text, comment, etc.)
   * @param {any} node - The node to check
   * @returns {boolean}
   */ isElement(node) {
        throw new Error('isElement() not implemented');
    }
    /**
   * Get the tag name of an element (lowercase)
   * @param {any} node - Element node
   * @returns {string} - Tag name like 'meta', 'link', 'script'
   */ getTagName(node) {
        throw new Error('getTagName() not implemented');
    }
    /**
   * Get attribute value from element
   * @param {any} node - Element node
   * @param {string} attrName - Attribute name (case-insensitive)
   * @returns {string | null} - Attribute value or null if not found
   */ getAttribute(node, attrName) {
        throw new Error('getAttribute() not implemented');
    }
    /**
   * Check if element has a specific attribute
   * @param {any} node - Element node
   * @param {string} attrName - Attribute name (case-insensitive)
   * @returns {boolean} - True if attribute exists
   */ hasAttribute(node, attrName) {
        throw new Error('hasAttribute() not implemented');
    }
    /**
   * Get all attribute names for an element
   * @param {any} node - Element node
   * @returns {string[]} - Array of attribute names
   */ getAttributeNames(node) {
        throw new Error('getAttributeNames() not implemented');
    }
    /**
   * Get text content of a node (for inline scripts/styles)
   * @param {any} node - Element node
   * @returns {string} - Text content
   */ getTextContent(node) {
        throw new Error('getTextContent() not implemented');
    }
    /**
   * Get child elements of a node
   * @param {any} node - Parent node
   * @returns {any[]} - Array of child element nodes (excluding text/comment nodes)
   */ getChildren(node) {
        throw new Error('getChildren() not implemented');
    }
    /**
   * Get parent element of a node
   * @param {any} node - Child node
   * @returns {any | null} - Parent element node, or null if no parent
   */ getParent(node) {
        throw new Error('getParent() not implemented');
    }
    /**
   * Get sibling elements of a node
   * @param {any} node - Element node
   * @returns {any[]} - Array of sibling element nodes (excluding the node itself)
   */ getSiblings(node) {
        throw new Error('getSiblings() not implemented');
    }
    /**
   * Get source location for a node (optional, for linting)
   * @param {any} node - Element node
   * @returns {{ line: number, column: number, endLine?: number, endColumn?: number } | null}
   */ getLocation(node) {
        return null;
    }
    /**
   * Stringify element for logging/debugging
   * @param {any} node - Element node
   * @returns {string} - String representation like "<meta charset='utf-8'>"
   */ stringify(node) {
        throw new Error('stringify() not implemented');
    }
}
function $8dba25bed55014f4$export$8b0c6d51edeaa8b(adapter) {
    for (const method of $8dba25bed55014f4$var$REQUIRED_METHODS){
        if (typeof adapter[method] !== 'function') throw new Error(`Adapter missing required method: ${method}()`);
    }
}


class $5ba5b99bca626038$export$e467cc3399500025 extends (0, $8dba25bed55014f4$export$d1d100ae3c773a95) {
    /**
   * Check if node is an Element (not text, comment, etc.)
   * @param {any} node - The node to check
   * @returns {boolean}
   */ isElement(node) {
        if (!node) return false;
        // Node.ELEMENT_NODE === 1
        return node.nodeType === 1;
    }
    /**
   * Get the tag name of an element (lowercase)
   * @param {any} node - Element node
   * @returns {string} - Tag name like 'meta', 'link', 'script'
   */ getTagName(node) {
        if (!node || !node.tagName) return '';
        return node.tagName.toLowerCase();
    }
    /**
   * Get attribute value from element
   * @param {any} node - Element node
   * @param {string} attrName - Attribute name (case-insensitive)
   * @returns {string | null} - Attribute value or null if not found
   */ getAttribute(node, attrName) {
        if (!node || typeof node.getAttribute !== 'function') return null;
        return node.getAttribute(attrName);
    }
    /**
   * Check if element has a specific attribute
   * @param {any} node - Element node
   * @param {string} attrName - Attribute name (case-insensitive)
   * @returns {boolean} - True if attribute exists
   */ hasAttribute(node, attrName) {
        if (!node || typeof node.hasAttribute !== 'function') return false;
        return node.hasAttribute(attrName);
    }
    /**
   * Get all attribute names for an element
   * @param {any} node - Element node
   * @returns {string[]} - Array of attribute names
   */ getAttributeNames(node) {
        if (!node || typeof node.getAttributeNames !== 'function') return [];
        return node.getAttributeNames();
    }
    /**
   * Get text content of a node (for inline scripts/styles)
   * @param {any} node - Element node
   * @returns {string} - Text content
   */ getTextContent(node) {
        if (!node) return '';
        return node.textContent || '';
    }
    /**
   * Get child elements of a node
   * @param {any} node - Parent node
   * @returns {any[]} - Array of child element nodes (excluding text/comment nodes)
   */ getChildren(node) {
        if (!node || !node.children) return [];
        return Array.from(node.children);
    }
    /**
   * Get parent element of a node
   * @param {any} node - Child node
   * @returns {any | null} - Parent element node, or null if no parent
   */ getParent(node) {
        if (!node) return null;
        return node.parentElement || null;
    }
    /**
   * Get sibling elements of a node
   * @param {any} node - Element node
   * @returns {any[]} - Array of sibling element nodes (excluding the node itself)
   */ getSiblings(node) {
        if (!node) return [];
        const parent = node.parentElement;
        if (!parent) return [];
        return Array.from(parent.children).filter((child)=>child !== node);
    }
    /**
   * Get source location for a node (optional, for linting)
   * 
   * Browser DOM elements don't have source location information,
   * so this always returns null.
   * 
   * @param {any} node - Element node
   * @returns {null}
   */ getLocation(node) {
        // Not available in browser DOM
        return null;
    }
    /**
   * Stringify element for logging/debugging
   * @param {any} node - Element node
   * @returns {string} - String representation like "<meta charset='utf-8'>"
   */ stringify(node) {
        if (!node || !node.nodeName) return '[invalid node]';
        const tagName = this.getTagName(node);
        const attrNames = this.getAttributeNames(node);
        if (attrNames.length === 0) return `<${tagName}>`;
        // Build attribute string
        const attrs = attrNames.map((attr)=>{
            const value = this.getAttribute(node, attr);
            // Escape value for display
            const escapedValue = value ? value.replace(/"/g, '&quot;') : '';
            return `${attr}="${escapedValue}"`;
        }).join(' ');
        return `<${tagName} ${attrs}>`;
    }
}



 // Test utilities for custom adapters
 // These are exported via package.json for node usage only
 // to avoid bundling node:test in the browser.


var $e77b82cb9a0d6b56$require$analyzeHeadWithOrdering = $199df24bfdfd3404$export$283ccd6e4ed2051d;
var $e77b82cb9a0d6b56$require$getWeight = $575b4d5b5a39ee58$export$de32fe5d64aee40c;

var $e77b82cb9a0d6b56$require$getSourceCode = $2abd6ce2c4a2d841$exports.getSourceCode;

var $e77b82cb9a0d6b56$require$parseTemplateLiteral = $7038c80d40859759$exports.parseTemplateLiteral;

var $e77b82cb9a0d6b56$require$shouldCheckTaggedTemplateExpression = $82257e454733f104$exports.shouldCheckTaggedTemplateExpression;
var $e77b82cb9a0d6b56$require$shouldCheckTemplateLiteral = $82257e454733f104$exports.shouldCheckTemplateLiteral;

var $e77b82cb9a0d6b56$require$NODE_TYPES = $f03705736c6cdfcd$exports.NODE_TYPES;
const $e77b82cb9a0d6b56$var$MESSAGE_IDS = {
    WRONG_ORDER: "wrongOrder"
};
/**
 * @typedef {Object} IgnorePattern
 * @property {string} [tagPattern] - Regex pattern for tag (e.g., "script",
 *   "link")
 * @property {string} [attrKeyPattern] - Regex pattern for attribute key (e.g.,
 *   "rel", "src")
 * @property {string} [attrValuePattern] - Regex pattern for attribute value
 */ /**
 * @typedef {Object} RuleOptions
 * @property {IgnorePattern[]} [ignores] - Array of ignore pattern objects
 */ /** @type {RuleModule<[RuleOptions?]>} */ $e77b82cb9a0d6b56$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Enforce optimal ordering of elements in `<head>`",
            category: $e77b82cb9a0d6b56$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $e77b82cb9a0d6b56$require$getRuleUrl("head-order")
        },
        fixable: "code",
        schema: [
            {
                type: "object",
                properties: {
                    ignores: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                tagPattern: {
                                    type: "string"
                                },
                                attrKeyPattern: {
                                    type: "string"
                                },
                                attrValuePattern: {
                                    type: "string"
                                }
                            },
                            additionalProperties: false
                        }
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$e77b82cb9a0d6b56$var$MESSAGE_IDS.WRONG_ORDER]: "{{nextCategory}} element should come before {{currentCategory}} element for optimal performance"
        }
    },
    create (context) {
        const adapter = new $e77b82cb9a0d6b56$require$HtmlEslintAdapter();
        const sourceCode = $e77b82cb9a0d6b56$require$getSourceCode(context);
        /** @type {RuleOptions} */ const options = context.options[0] || {};
        const ignorePatterns = (options.ignores || []).map((pattern)=>({
                tagRegex: pattern.tagPattern ? new RegExp(pattern.tagPattern, "u") : null,
                attrKeyRegex: pattern.attrKeyPattern ? new RegExp(pattern.attrKeyPattern, "u") : null,
                attrValueRegex: pattern.attrValuePattern ? new RegExp(pattern.attrValuePattern, "u") : null
            }));
        /**
     * Check if a tag should be ignored based on ignore patterns or if it's a
     * comment
     *
     * @param {any} element - Element node to check
     * @returns {boolean} - True if the element should be ignored
     */ function shouldIgnoreElement(element) {
            // Ignore HTML comments
            if (element.type === $e77b82cb9a0d6b56$require$NODE_TYPES.Comment) return true;
            return ignorePatterns.some(({ tagRegex: tagRegex, attrKeyRegex: attrKeyRegex, attrValueRegex: attrValueRegex })=>{
                /** @type {boolean[]} */ const checks = [];
                if (tagRegex) {
                    const tagName = adapter.getTagName(element);
                    checks.push(tagRegex.test(tagName));
                }
                if (attrKeyRegex) {
                    const attrNames = adapter.getAttributeNames(element);
                    checks.push(attrNames.some((name)=>attrKeyRegex.test(name)));
                }
                if (attrValueRegex) {
                    const attrNames = adapter.getAttributeNames(element);
                    const hasMatchingValue = attrNames.some((name)=>{
                        const value = adapter.getAttribute(element, name);
                        return value !== null && attrValueRegex.test(value);
                    });
                    checks.push(hasMatchingValue);
                }
                // All specified patterns must match (AND condition)
                return checks.length > 0 && checks.every((check)=>check === true);
            });
        }
        /**
     * Process a head tag node and report violations
     *
     * @param {any} node - Head tag node to process
     */ function processHeadTag(node) {
            if (node.name !== "head") return;
            const analysis = $e77b82cb9a0d6b56$require$analyzeHeadWithOrdering(node, adapter);
            if (analysis.orderingViolations.length === 0) return;
            const children = adapter.getChildren(node);
            // Filter violations to exclude ignored elements
            const filteredViolations = analysis.orderingViolations.filter((violation)=>!shouldIgnoreElement(violation.nextElement) && !shouldIgnoreElement(violation.currentElement));
            for (const violation of filteredViolations)context.report({
                node: violation.nextElement,
                messageId: $e77b82cb9a0d6b56$var$MESSAGE_IDS.WRONG_ORDER,
                data: {
                    nextCategory: violation.nextCategory,
                    currentCategory: violation.currentCategory
                },
                fix (fixer) {
                    // Separate children into ignored and non-ignored
                    const childrenWithIgnoreFlag = children.map((child)=>({
                            element: child,
                            ignored: shouldIgnoreElement(child),
                            originalIndex: children.indexOf(child)
                        }));
                    // Get non-ignored children and sort them
                    const nonIgnoredChildren = childrenWithIgnoreFlag.filter((item)=>!item.ignored).map((item)=>item.element);
                    const sortedNonIgnored = [
                        ...nonIgnoredChildren
                    ].sort((a, b)=>{
                        const weightA = $e77b82cb9a0d6b56$require$getWeight(a, adapter);
                        const weightB = $e77b82cb9a0d6b56$require$getWeight(b, adapter);
                        return weightB - weightA;
                    });
                    const fixes = [];
                    // Only replace non-ignored children
                    let sortedIndex = 0;
                    for(let i = 0; i < children.length; i++){
                        const originalChild = children[i];
                        if (!shouldIgnoreElement(originalChild)) {
                            const sortedChild = sortedNonIgnored[sortedIndex];
                            sortedIndex++;
                            if (originalChild !== sortedChild) {
                                // @ts-ignore
                                const sortedText = sourceCode.getText(sortedChild);
                                fixes.push(fixer.replaceText(originalChild, sortedText));
                            }
                        }
                    }
                    return fixes;
                }
            });
        }
        return {
            Tag (node) {
                processHeadTag(node);
            },
            TaggedTemplateExpression (node) {
                if ($e77b82cb9a0d6b56$require$shouldCheckTaggedTemplateExpression(node, context)) {
                    const visitor = {
                        Tag: processHeadTag
                    };
                    $e77b82cb9a0d6b56$require$parseTemplateLiteral(node.quasi, sourceCode, visitor);
                }
            },
            TemplateLiteral (node) {
                if ($e77b82cb9a0d6b56$require$shouldCheckTemplateLiteral(node, context)) {
                    const visitor = {
                        Tag: processHeadTag
                    };
                    $e77b82cb9a0d6b56$require$parseTemplateLiteral(node, sourceCode, visitor);
                }
            }
        };
    }
};


var $95d6285113bcc76c$exports = {};
/** @import {RuleModule} from "../types" */ 
var $95d6285113bcc76c$require$RULE_CATEGORY = $25c931d91929d6ab$exports.RULE_CATEGORY;

var $95d6285113bcc76c$require$findAttr = $7dabedd289de3a0a$exports.findAttr;
var $95d6285113bcc76c$require$hasTemplate = $7dabedd289de3a0a$exports.hasTemplate;

var $95d6285113bcc76c$require$getRuleUrl = $6a86dcf564257278$exports.getRuleUrl;

var $95d6285113bcc76c$require$createVisitors = $6e393e774f061794$exports.createVisitors;
const $95d6285113bcc76c$var$MESSAGE_IDS = {
    MISSING: "missing",
    EMPTY: "empty"
};
/** @type {RuleModule<[]>} */ $95d6285113bcc76c$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Require `viewBox` attribute on `<svg>` elements",
            category: $95d6285113bcc76c$require$RULE_CATEGORY.BEST_PRACTICE,
            recommended: false,
            url: $95d6285113bcc76c$require$getRuleUrl("svg-require-viewbox")
        },
        fixable: null,
        schema: [],
        messages: {
            [$95d6285113bcc76c$var$MESSAGE_IDS.MISSING]: "Missing `viewBox` attribute on `<svg>`.",
            [$95d6285113bcc76c$var$MESSAGE_IDS.EMPTY]: "Empty `viewBox` attribute on `<svg>`."
        }
    },
    create (context) {
        return $95d6285113bcc76c$require$createVisitors(context, {
            Tag (node) {
                if (node.name !== "svg") return;
                const viewBoxAttr = $95d6285113bcc76c$require$findAttr(node, "viewBox");
                if (!viewBoxAttr) {
                    context.report({
                        node: node.openStart,
                        messageId: $95d6285113bcc76c$var$MESSAGE_IDS.MISSING
                    });
                    return;
                }
                const { value: value } = viewBoxAttr;
                if (value && $95d6285113bcc76c$require$hasTemplate(value)) return;
                if (!value || !value.value || value.value.trim() === "") context.report({
                    node: viewBoxAttr,
                    messageId: $95d6285113bcc76c$var$MESSAGE_IDS.EMPTY
                });
            }
        });
    }
};


// import new rule here ↑
// DO NOT REMOVE THIS COMMENT
const $aae83cc78a26c8db$var$rules = {
    "require-lang": $cd1ae531f71e6bfe$exports,
    "require-img-alt": $3899496f4387d368$exports,
    "require-doctype": $40622b6fb641b995$exports,
    "require-title": $8df233e0bd9b4858$exports,
    "no-duplicate-id": $c8a0553aa885b660$exports,
    "no-inline-styles": $005acf3d79da7a92$exports,
    "no-multiple-h1": $58eb9fa824f3db09$exports,
    "no-extra-spacing-attrs": $4d64e4ad9efe6d5f$exports,
    "no-extra-spacing-tags": $dd0615a95c427b06$exports,
    "no-extra-spacing-text": $ea2a92963957e180$exports,
    "attrs-newline": $6ed6c53bbac913f8$exports,
    "element-newline": $2225097c51b29b91$exports,
    "no-skip-heading-levels": $4432e2472621352e$exports,
    "require-li-container": $1986d63494746be2$exports,
    indent: $50316cf58633e636$exports,
    quotes: $038e8564917e2c5e$exports,
    "id-naming-convention": $53dd157a204315c1$exports,
    "no-obsolete-tags": $a3cc22c4efdf071f$exports,
    "require-attrs": $502d48dc3bbacb39$exports,
    "require-closing-tags": $e93dcc8bba8a84dc$exports,
    "require-meta-description": $55a2c8ed5f18f27e$exports,
    "require-frame-title": $8777f1f287384e8e$exports,
    "no-non-scalable-viewport": $41df0d1b593b470c$exports,
    "no-positive-tabindex": $41f7e6997995c7bb$exports,
    "require-meta-viewport": $85cf17ee296bba4d$exports,
    "require-meta-charset": $a7c098e78644b4b1$exports,
    "no-target-blank": $2f88baced4c3e503$exports,
    "no-duplicate-attrs": $f3cd358514291eac$exports,
    "no-abstract-roles": $2f2570ff16ce8817$exports,
    "require-button-type": $298e7ffb7782b38b$exports,
    "no-aria-hidden-body": $39a7aa79b8052c7f$exports,
    "no-aria-hidden-on-focusable": $cd15c0fd04462af9$exports,
    "no-multiple-empty-lines": $7a646d3e0a3caa11$exports,
    "no-accesskey-attrs": $9fcc77af4fe57f36$exports,
    "no-restricted-attrs": $7dfb9da6f67a9d43$exports,
    "no-trailing-spaces": $ba6b178874b46a0b$exports,
    "no-restricted-attr-values": $8e6b29843b46a31d$exports,
    "no-script-style-type": $99d51521607c2508$exports,
    "no-heading-inside-button": $580d8e9970f85f14$exports,
    "no-invalid-role": $f5b59aba1c30a844$exports,
    "no-nested-interactive": $1ed0708197baff6b$exports,
    lowercase: $7df1ae7270c3035f$exports,
    "require-open-graph-protocol": $31cd1f9fa66895a9$exports,
    "require-form-method": $2f3571cf8f9af717$exports,
    "sort-attrs": $6b63449bdb2cfeb6$exports,
    "prefer-https": $c8d54b951b835b60$exports,
    "require-input-label": $4681833c1379aefb$exports,
    "max-element-depth": $eeb7c6826caeaea6$exports,
    "require-explicit-size": $a338db40692f7a39$exports,
    "use-baseline": $d4810f61f63fbd5c$exports,
    "no-duplicate-class": $3f481eb8bcf658ee$exports,
    "no-empty-headings": $ff1a173857c2285e$exports,
    "require-content": $ab94be7fccabd533$exports,
    "no-invalid-entity": $f81e92191d20d3e6$exports,
    "no-duplicate-in-head": $1f4912ce36372af8$exports,
    "no-ineffective-attrs": $0ac36197050563a6$exports,
    "no-restricted-tags": $78090dd8f7b91dcd$exports,
    "no-whitespace-only-children": $265e3d3823e60bbb$exports,
    "no-obsolete-attrs": $de1f055da137aec9$exports,
    "class-spacing": $a079f908f22e8def$exports,
    "css-no-empty-blocks": $119cd0d46999dc3f$exports,
    "no-redundant-role": $659b814eef393d7f$exports,
    "no-invalid-attr-value": $9fe8f85aa47c0320$exports,
    "head-order": $e77b82cb9a0d6b56$exports,
    "require-details-summary": $fedc0e6536e8766c$exports,
    "svg-require-viewbox": $95d6285113bcc76c$exports
};
$aae83cc78a26c8db$exports = /** @type {unknown} */ $aae83cc78a26c8db$var$rules;


var $36a7c6fe056ad952$exports = {};
var $34efd57f223c87b3$exports = {};
/** @import {RuleModule} from "../types" */ 
var $34efd57f223c87b3$require$NO_INVALID_ATTR_VALUE_MESSAGE_IDS = $404c96e82c1b1d4e$export$2db0830b5f0899da;

var $34efd57f223c87b3$require$noInvalidAttrValue = $404c96e82c1b1d4e$export$5bd6a5451dea460e;
var $f7b7d8083db5fc3d$exports = {};
/**
 * AST Node Types Re-defined from @typescript-eslint/types AST_NODE_TYPES enum
 * as string constants to avoid runtime dependency on @typescript-eslint/types
 */ const $f7b7d8083db5fc3d$var$AST_NODE_TYPES = /** @type {const} */ {
    AccessorProperty: "AccessorProperty",
    ArrayExpression: "ArrayExpression",
    ArrayPattern: "ArrayPattern",
    ArrowFunctionExpression: "ArrowFunctionExpression",
    AssignmentExpression: "AssignmentExpression",
    AssignmentPattern: "AssignmentPattern",
    AwaitExpression: "AwaitExpression",
    BinaryExpression: "BinaryExpression",
    BlockStatement: "BlockStatement",
    BreakStatement: "BreakStatement",
    CallExpression: "CallExpression",
    CatchClause: "CatchClause",
    ChainExpression: "ChainExpression",
    ClassBody: "ClassBody",
    ClassDeclaration: "ClassDeclaration",
    ClassExpression: "ClassExpression",
    ConditionalExpression: "ConditionalExpression",
    ContinueStatement: "ContinueStatement",
    DebuggerStatement: "DebuggerStatement",
    Decorator: "Decorator",
    DoWhileStatement: "DoWhileStatement",
    EmptyStatement: "EmptyStatement",
    ExportAllDeclaration: "ExportAllDeclaration",
    ExportDefaultDeclaration: "ExportDefaultDeclaration",
    ExportNamedDeclaration: "ExportNamedDeclaration",
    ExportSpecifier: "ExportSpecifier",
    ExpressionStatement: "ExpressionStatement",
    ForInStatement: "ForInStatement",
    ForOfStatement: "ForOfStatement",
    ForStatement: "ForStatement",
    FunctionDeclaration: "FunctionDeclaration",
    FunctionExpression: "FunctionExpression",
    Identifier: "Identifier",
    IfStatement: "IfStatement",
    ImportAttribute: "ImportAttribute",
    ImportDeclaration: "ImportDeclaration",
    ImportDefaultSpecifier: "ImportDefaultSpecifier",
    ImportExpression: "ImportExpression",
    ImportNamespaceSpecifier: "ImportNamespaceSpecifier",
    ImportSpecifier: "ImportSpecifier",
    JSXAttribute: "JSXAttribute",
    JSXClosingElement: "JSXClosingElement",
    JSXClosingFragment: "JSXClosingFragment",
    JSXElement: "JSXElement",
    JSXEmptyExpression: "JSXEmptyExpression",
    JSXExpressionContainer: "JSXExpressionContainer",
    JSXFragment: "JSXFragment",
    JSXIdentifier: "JSXIdentifier",
    JSXMemberExpression: "JSXMemberExpression",
    JSXNamespacedName: "JSXNamespacedName",
    JSXOpeningElement: "JSXOpeningElement",
    JSXOpeningFragment: "JSXOpeningFragment",
    JSXSpreadAttribute: "JSXSpreadAttribute",
    JSXSpreadChild: "JSXSpreadChild",
    JSXText: "JSXText",
    LabeledStatement: "LabeledStatement",
    Literal: "Literal",
    LogicalExpression: "LogicalExpression",
    MemberExpression: "MemberExpression",
    MetaProperty: "MetaProperty",
    MethodDefinition: "MethodDefinition",
    NewExpression: "NewExpression",
    ObjectExpression: "ObjectExpression",
    ObjectPattern: "ObjectPattern",
    PrivateIdentifier: "PrivateIdentifier",
    Program: "Program",
    Property: "Property",
    PropertyDefinition: "PropertyDefinition",
    RestElement: "RestElement",
    ReturnStatement: "ReturnStatement",
    SequenceExpression: "SequenceExpression",
    SpreadElement: "SpreadElement",
    StaticBlock: "StaticBlock",
    Super: "Super",
    SwitchCase: "SwitchCase",
    SwitchStatement: "SwitchStatement",
    TaggedTemplateExpression: "TaggedTemplateExpression",
    TemplateLiteral: "TemplateLiteral",
    TemplateElement: "TemplateElement",
    ThisExpression: "ThisExpression",
    ThrowStatement: "ThrowStatement",
    TryStatement: "TryStatement",
    TSAbstractAccessorProperty: "TSAbstractAccessorProperty",
    TSAbstractKeyword: "TSAbstractKeyword",
    TSAbstractMethodDefinition: "TSAbstractMethodDefinition",
    TSAbstractPropertyDefinition: "TSAbstractPropertyDefinition",
    TSAnyKeyword: "TSAnyKeyword",
    TSArrayType: "TSArrayType",
    TSAsExpression: "TSAsExpression",
    TSAsyncKeyword: "TSAsyncKeyword",
    TSBigIntKeyword: "TSBigIntKeyword",
    TSBooleanKeyword: "TSBooleanKeyword",
    TSCallSignatureDeclaration: "TSCallSignatureDeclaration",
    TSClassImplements: "TSClassImplements",
    TSConditionalType: "TSConditionalType",
    TSConstructorType: "TSConstructorType",
    TSConstructSignatureDeclaration: "TSConstructSignatureDeclaration",
    TSDeclareFunction: "TSDeclareFunction",
    TSDeclareKeyword: "TSDeclareKeyword",
    TSEmptyBodyFunctionExpression: "TSEmptyBodyFunctionExpression",
    TSEnumBody: "TSEnumBody",
    TSEnumDeclaration: "TSEnumDeclaration",
    TSEnumMember: "TSEnumMember",
    TSExportAssignment: "TSExportAssignment",
    TSExportKeyword: "TSExportKeyword",
    TSExternalModuleReference: "TSExternalModuleReference",
    TSFunctionType: "TSFunctionType",
    TSImportEqualsDeclaration: "TSImportEqualsDeclaration",
    TSImportType: "TSImportType",
    TSIndexedAccessType: "TSIndexedAccessType",
    TSIndexSignature: "TSIndexSignature",
    TSInferType: "TSInferType",
    TSInstantiationExpression: "TSInstantiationExpression",
    TSInterfaceBody: "TSInterfaceBody",
    TSInterfaceDeclaration: "TSInterfaceDeclaration",
    TSInterfaceHeritage: "TSInterfaceHeritage",
    TSIntersectionType: "TSIntersectionType",
    TSIntrinsicKeyword: "TSIntrinsicKeyword",
    TSLiteralType: "TSLiteralType",
    TSMappedType: "TSMappedType",
    TSMethodSignature: "TSMethodSignature",
    TSModuleBlock: "TSModuleBlock",
    TSModuleDeclaration: "TSModuleDeclaration",
    TSNamedTupleMember: "TSNamedTupleMember",
    TSNamespaceExportDeclaration: "TSNamespaceExportDeclaration",
    TSNeverKeyword: "TSNeverKeyword",
    TSNonNullExpression: "TSNonNullExpression",
    TSNullKeyword: "TSNullKeyword",
    TSNumberKeyword: "TSNumberKeyword",
    TSObjectKeyword: "TSObjectKeyword",
    TSOptionalType: "TSOptionalType",
    TSParameterProperty: "TSParameterProperty",
    TSPrivateKeyword: "TSPrivateKeyword",
    TSPropertySignature: "TSPropertySignature",
    TSProtectedKeyword: "TSProtectedKeyword",
    TSPublicKeyword: "TSPublicKeyword",
    TSQualifiedName: "TSQualifiedName",
    TSReadonlyKeyword: "TSReadonlyKeyword",
    TSRestType: "TSRestType",
    TSSatisfiesExpression: "TSSatisfiesExpression",
    TSStaticKeyword: "TSStaticKeyword",
    TSStringKeyword: "TSStringKeyword",
    TSSymbolKeyword: "TSSymbolKeyword",
    TSTemplateLiteralType: "TSTemplateLiteralType",
    TSThisType: "TSThisType",
    TSTupleType: "TSTupleType",
    TSTypeAliasDeclaration: "TSTypeAliasDeclaration",
    TSTypeAnnotation: "TSTypeAnnotation",
    TSTypeAssertion: "TSTypeAssertion",
    TSTypeLiteral: "TSTypeLiteral",
    TSTypeOperator: "TSTypeOperator",
    TSTypeParameter: "TSTypeParameter",
    TSTypeParameterDeclaration: "TSTypeParameterDeclaration",
    TSTypeParameterInstantiation: "TSTypeParameterInstantiation",
    TSTypePredicate: "TSTypePredicate",
    TSTypeQuery: "TSTypeQuery",
    TSTypeReference: "TSTypeReference",
    TSUndefinedKeyword: "TSUndefinedKeyword",
    TSUnionType: "TSUnionType",
    TSUnknownKeyword: "TSUnknownKeyword",
    TSVoidKeyword: "TSVoidKeyword",
    UnaryExpression: "UnaryExpression",
    UpdateExpression: "UpdateExpression",
    VariableDeclaration: "VariableDeclaration",
    VariableDeclarator: "VariableDeclarator",
    WhileStatement: "WhileStatement",
    WithStatement: "WithStatement",
    YieldExpression: "YieldExpression"
};
$f7b7d8083db5fc3d$exports = {
    AST_NODE_TYPES: $f7b7d8083db5fc3d$var$AST_NODE_TYPES
};


var $34efd57f223c87b3$require$AST_NODE_TYPES = $f7b7d8083db5fc3d$exports.AST_NODE_TYPES;
var $c41cc83f0597f2b1$exports = {};
/**
 * @import {ElementAdapter} from "@html-eslint/core"
 * @import {JSXElement} from "../../types"
 */ var $3db1ef50ecae121c$exports = {};
/**
 * @import {
 *   AttributeAdapter,
 *   ElementAdapter
 * } from "@html-eslint/core"
 * @import {
 *   Range,
 *   SourceLocation
 * } from "@html-eslint/types"
 * @import {
 *   JSXElement,
 *   JSXMemberExpression
 * } from "../../types"
 */ 
var $3db1ef50ecae121c$require$AST_NODE_TYPES = $f7b7d8083db5fc3d$exports.AST_NODE_TYPES;
var $1c3590f3f513347e$exports = {};
/**
 * @import {AttributeAdapter} from "@html-eslint/core"
 * @import {
 *   JSXAttribute,
 *   JSXSpreadAttribute
 * } from "../../types"
 */ 
var $1c3590f3f513347e$require$AST_NODE_TYPES = $f7b7d8083db5fc3d$exports.AST_NODE_TYPES;
var $22a3dd69c83fec4a$exports = {};
/**
 * @import {AttributeAdapter} from "@html-eslint/core"
 * @import {JSXAttribute} from "../../types"
 */ 
var $22a3dd69c83fec4a$require$AST_NODE_TYPES = $f7b7d8083db5fc3d$exports.AST_NODE_TYPES;
var $22b542248517a72f$exports = {};
/**
 * @import {AttributeKeyAdapter} from "@html-eslint/core"
 * @import {
 *   JSXIdentifier,
 *   JSXNamespacedName
 * } from "../../types"
 */ 
var $22b542248517a72f$require$AST_NODE_TYPES = $f7b7d8083db5fc3d$exports.AST_NODE_TYPES;
var $48ebf09b3366bd5f$exports = {};
/**
 * @import {AttributeKeyAdapter} from "@html-eslint/core"
 * @import {
 *   Range,
 *   SourceLocation
 * } from "@html-eslint/types"
 * @import {JSXIdentifier} from "../../types"
 */ /** @implements {AttributeKeyAdapter} */ class $48ebf09b3366bd5f$var$JSXIdentifierAttributeKeyAdapter {
    /** @param {JSXIdentifier} node */ constructor(node){
        this.node = node;
    }
    /** @returns {SourceLocation} */ getLocation() {
        return this.node.loc;
    }
    /** @returns {Range} */ getRange() {
        return this.node.range;
    }
    /** @returns {string} */ getValue() {
        return this.node.name;
    }
    /** @returns {boolean} */ hasExpression() {
        return false;
    }
}
$48ebf09b3366bd5f$exports = {
    JSXIdentifierAttributeKeyAdapter: $48ebf09b3366bd5f$var$JSXIdentifierAttributeKeyAdapter
};


var $22b542248517a72f$require$JSXIdentifierAttributeKeyAdapter = $48ebf09b3366bd5f$exports.JSXIdentifierAttributeKeyAdapter;
var $f56d81053a928019$exports = {};
/**
 * @import {AttributeKeyAdapter} from "@html-eslint/core"
 * @import {
 *   Range,
 *   SourceLocation
 * } from "@html-eslint/types"
 * @import {JSXNamespacedName} from "../../types"
 */ /** @implements {AttributeKeyAdapter} */ class $f56d81053a928019$var$JSXNamespaceNameAttributeKeyAdapter {
    /** @param {JSXNamespacedName} node */ constructor(node){
        this.node = node;
    }
    /** @returns {SourceLocation} */ getLocation() {
        return this.node.loc;
    }
    /** @returns {Range} */ getRange() {
        return this.node.range;
    }
    /** @returns {string} */ getValue() {
        return `${this.node.namespace.name}:${this.node.name.name}`;
    }
    /** @returns {boolean} */ hasExpression() {
        return false;
    }
}
$f56d81053a928019$exports = {
    JSXNamespaceNameAttributeKeyAdapter: $f56d81053a928019$var$JSXNamespaceNameAttributeKeyAdapter
};


var $22b542248517a72f$require$JSXNamespaceNameAttributeKeyAdapter = $f56d81053a928019$exports.JSXNamespaceNameAttributeKeyAdapter;
/**
 * @param {JSXIdentifier | JSXNamespacedName} node
 * @returns {AttributeKeyAdapter}
 */ function $22b542248517a72f$var$createAttributeKeyAdapter(node) {
    switch(node.type){
        case $22b542248517a72f$require$AST_NODE_TYPES.JSXIdentifier:
            return new $22b542248517a72f$require$JSXIdentifierAttributeKeyAdapter(node);
        case $22b542248517a72f$require$AST_NODE_TYPES.JSXNamespacedName:
            return new $22b542248517a72f$require$JSXNamespaceNameAttributeKeyAdapter(node);
    }
}
$22b542248517a72f$exports = {
    createAttributeKeyAdapter: $22b542248517a72f$var$createAttributeKeyAdapter
};


var $22a3dd69c83fec4a$require$createAttributeKeyAdapter = $22b542248517a72f$exports.createAttributeKeyAdapter;
var $80c0b1f130b8da00$exports = {};
/**
 * @import {AttributeValueAdapter} from "@html-eslint/core"
 * @import {
 *   JSXExpressionContainer,
 *   Literal,
 *   TemplateLiteral
 * } from "../../types"
 */ 
var $80c0b1f130b8da00$require$AST_NODE_TYPES = $f7b7d8083db5fc3d$exports.AST_NODE_TYPES;
var $9a03146eef634983$exports = {};
/**
 * @import {AttributeValueAdapter} from "@html-eslint/core"
 * @import {
 *   Range,
 *   SourceLocation
 * } from "@html-eslint/types"
 * @import {JSXExpressionContainer} from "../../types"
 */ 
var $9a03146eef634983$require$AST_NODE_TYPES = $f7b7d8083db5fc3d$exports.AST_NODE_TYPES;
var $14ef2dad24b9f38d$exports = {};
/**
 * @import {AttributeValueAdapter} from "@html-eslint/core"
 * @import {Range} from "@html-eslint/types"
 * @import {Literal} from "../../types"
 */ /** @implements {AttributeValueAdapter} */ class $14ef2dad24b9f38d$var$LiteralAttributeValueAdapter {
    /** @param {Literal} node */ constructor(node){
        this.node = node;
    }
    getLocation() {
        return {
            start: {
                column: this.node.loc.start.column + 1,
                line: this.node.loc.start.line
            },
            end: {
                column: this.node.loc.end.column - 1,
                line: this.node.loc.end.line
            }
        };
    }
    getRange() {
        return /** @type {Range} */ [
            this.node.range[0] + 1,
            this.node.range[1] - 1
        ];
    }
    hasExpression() {
        return false;
    }
    getValue() {
        if (typeof this.node.value === "string") return this.node.value;
        else if (typeof this.node.value === "number") return String(this.node.value);
        return null;
    }
}
$14ef2dad24b9f38d$exports = {
    LiteralAttributeValueAdapter: $14ef2dad24b9f38d$var$LiteralAttributeValueAdapter
};


var $9a03146eef634983$require$LiteralAttributeValueAdapter = $14ef2dad24b9f38d$exports.LiteralAttributeValueAdapter;
var $825955a59540a55c$exports = {};
/**
 * @import {AttributeValueAdapter} from "@html-eslint/core"
 * @import {
 *   Range,
 *   SourceLocation
 * } from "@html-eslint/types"
 * @import {TemplateLiteral} from "../../types"
 */ /** @implements {AttributeValueAdapter} */ class $825955a59540a55c$var$TemplateLiteralAttributeValueAdapter {
    /** @param {TemplateLiteral} node */ constructor(node){
        /** @private */ this.node = node;
    }
    /** @returns {SourceLocation} */ getLocation() {
        return {
            start: {
                column: this.node.loc.start.column + 1,
                line: this.node.loc.start.line
            },
            end: {
                column: this.node.loc.end.column - 1,
                line: this.node.loc.end.line
            }
        };
    }
    /** @returns {Range} */ getRange() {
        return /** @type {Range} */ [
            this.node.range[0] + 1,
            this.node.range[1] - 1
        ];
    }
    /** @returns {string | null} */ getValue() {
        if (this.hasExpression()) return null;
        const quasis = this.node.quasis[0];
        return quasis.value.cooked;
    }
    /** @returns {boolean} */ hasExpression() {
        return !!this.node.expressions.length;
    }
}
$825955a59540a55c$exports = {
    TemplateLiteralAttributeValueAdapter: $825955a59540a55c$var$TemplateLiteralAttributeValueAdapter
};


var $9a03146eef634983$require$TemplateLiteralAttributeValueAdapter = $825955a59540a55c$exports.TemplateLiteralAttributeValueAdapter;
/** @implements {AttributeValueAdapter} */ class $9a03146eef634983$var$JSXExpressionAttributeValueAdapter {
    /** @param {JSXExpressionContainer} node */ constructor(node){
        this.node = node;
        this.adapter = this.getAdapter();
    }
    /**
   * @private
   * @returns {AttributeValueAdapter | null}
   */ getAdapter() {
        if (this.node.expression.type === $9a03146eef634983$require$AST_NODE_TYPES.Literal) return new $9a03146eef634983$require$LiteralAttributeValueAdapter(this.node.expression);
        if (this.node.expression.type === $9a03146eef634983$require$AST_NODE_TYPES.TemplateLiteral) return new $9a03146eef634983$require$TemplateLiteralAttributeValueAdapter(this.node.expression);
        return null;
    }
    /** @returns {SourceLocation} */ getLocation() {
        return this.adapter?.getLocation() ?? this.node.expression.loc;
    }
    /** @returns {Range} */ getRange() {
        return this.adapter?.getRange() ?? this.node.expression.range;
    }
    getValue() {
        return this.adapter?.getValue() ?? null;
    }
    hasExpression() {
        return this.adapter?.hasExpression() ?? true;
    }
}
$9a03146eef634983$exports = {
    JSXExpressionAttributeValueAdapter: $9a03146eef634983$var$JSXExpressionAttributeValueAdapter
};


var $80c0b1f130b8da00$require$JSXExpressionAttributeValueAdapter = $9a03146eef634983$exports.JSXExpressionAttributeValueAdapter;

var $80c0b1f130b8da00$require$LiteralAttributeValueAdapter = $14ef2dad24b9f38d$exports.LiteralAttributeValueAdapter;

var $80c0b1f130b8da00$require$TemplateLiteralAttributeValueAdapter = $825955a59540a55c$exports.TemplateLiteralAttributeValueAdapter;
/**
 * @param {Literal | TemplateLiteral | JSXExpressionContainer} node
 * @returns {AttributeValueAdapter}
 */ function $80c0b1f130b8da00$var$createAttributeValueAdapter(node) {
    switch(node.type){
        case $80c0b1f130b8da00$require$AST_NODE_TYPES.Literal:
            return new $80c0b1f130b8da00$require$LiteralAttributeValueAdapter(node);
        case $80c0b1f130b8da00$require$AST_NODE_TYPES.TemplateLiteral:
            return new $80c0b1f130b8da00$require$TemplateLiteralAttributeValueAdapter(node);
        case $80c0b1f130b8da00$require$AST_NODE_TYPES.JSXExpressionContainer:
            return new $80c0b1f130b8da00$require$JSXExpressionAttributeValueAdapter(node);
    }
}
$80c0b1f130b8da00$exports = {
    createAttributeValueAdapter: $80c0b1f130b8da00$var$createAttributeValueAdapter
};


var $22a3dd69c83fec4a$require$createAttributeValueAdapter = $80c0b1f130b8da00$exports.createAttributeValueAdapter;
/** @implements {AttributeAdapter} */ class $22a3dd69c83fec4a$var$JSXAttributeAttributeAdapter {
    /** @param {JSXAttribute} node */ constructor(node){
        this.node = node;
    }
    getKey() {
        return $22a3dd69c83fec4a$require$createAttributeKeyAdapter(this.node.name);
    }
    getValue() {
        if (!this.node.value || this.node.value.type === $22a3dd69c83fec4a$require$AST_NODE_TYPES.JSXElement || this.node.value.type === $22a3dd69c83fec4a$require$AST_NODE_TYPES.JSXSpreadChild) return null;
        return $22a3dd69c83fec4a$require$createAttributeValueAdapter(this.node.value);
    }
}
$22a3dd69c83fec4a$exports = {
    JSXAttributeAttributeAdapter: $22a3dd69c83fec4a$var$JSXAttributeAttributeAdapter
};


var $1c3590f3f513347e$require$JSXAttributeAttributeAdapter = $22a3dd69c83fec4a$exports.JSXAttributeAttributeAdapter;
var $abdaf107a5c7b81e$exports = {};
/**
 * @import {AttributeAdapter} from "@html-eslint/core"
 * @import {JSXSpreadAttribute} from "../../types"
 */ /** @implements {AttributeAdapter} */ class $abdaf107a5c7b81e$var$JSXSpreadAttributeAdapter {
    /** @param {JSXSpreadAttribute} node */ constructor(node){
        this.node = node;
    }
    getKey() {
        return null;
    }
    getValue() {
        return null;
    }
}
$abdaf107a5c7b81e$exports = {
    JSXSpreadAttributeAdapter: $abdaf107a5c7b81e$var$JSXSpreadAttributeAdapter
};


var $1c3590f3f513347e$require$JSXSpreadAttributeAdapter = $abdaf107a5c7b81e$exports.JSXSpreadAttributeAdapter;
/**
 * @param {JSXAttribute | JSXSpreadAttribute} node
 * @returns {AttributeAdapter}
 */ function $1c3590f3f513347e$var$createAttributeAdapter(node) {
    switch(node.type){
        case $1c3590f3f513347e$require$AST_NODE_TYPES.JSXAttribute:
            return new $1c3590f3f513347e$require$JSXAttributeAttributeAdapter(node);
        case $1c3590f3f513347e$require$AST_NODE_TYPES.JSXSpreadAttribute:
            return new $1c3590f3f513347e$require$JSXSpreadAttributeAdapter(node);
    }
}
$1c3590f3f513347e$exports = {
    createAttributeAdapter: $1c3590f3f513347e$var$createAttributeAdapter
};


var $3db1ef50ecae121c$require$createAttributeAdapter = $1c3590f3f513347e$exports.createAttributeAdapter;
/**
 * Recursively builds the string representation of a JSXMemberExpression. For
 * example, <a.b.c> becomes "a.b.c"
 *
 * @param {JSXMemberExpression} node
 * @returns {string}
 */ function $3db1ef50ecae121c$var$getJSXMemberExpressionName(node) {
    const objectName = node.object.type === $3db1ef50ecae121c$require$AST_NODE_TYPES.JSXIdentifier ? node.object.name : node.object.type === $3db1ef50ecae121c$require$AST_NODE_TYPES.JSXNamespacedName ? `${node.object.namespace.name}:${node.object.name.name}` : $3db1ef50ecae121c$var$getJSXMemberExpressionName(node.object);
    return `${objectName}.${node.property.name}`;
}
/** @implements {ElementAdapter} */ class $3db1ef50ecae121c$var$JSXElementElementAdapter {
    /** @param {JSXElement} node */ constructor(node){
        this.node = node;
    }
    /** @returns {string} */ getElementName() {
        if (this.node.openingElement.name.type === $3db1ef50ecae121c$require$AST_NODE_TYPES.JSXNamespacedName) return `${this.node.openingElement.name.namespace.name}:${this.node.openingElement.name.name.name}`;
        if (this.node.openingElement.name.type === $3db1ef50ecae121c$require$AST_NODE_TYPES.JSXMemberExpression) return $3db1ef50ecae121c$var$getJSXMemberExpressionName(this.node.openingElement.name);
        return this.node.openingElement.name.name;
    }
    /** @returns {SourceLocation} */ getLocation() {
        return this.node.loc;
    }
    /** @returns {Range} */ getRange() {
        return this.node.range;
    }
    /** @returns {AttributeAdapter[]} */ getAttributes() {
        return this.node.openingElement.attributes.map((attribute)=>$3db1ef50ecae121c$require$createAttributeAdapter(attribute));
    }
    /** @returns {SourceLocation} */ getOpenStartLocation() {
        return this.node.openingElement.name.loc;
    }
    /** @returns {Range} */ getOpenStartRange() {
        return this.node.openingElement.name.range;
    }
}
$3db1ef50ecae121c$exports = {
    JSXElementElementAdapter: $3db1ef50ecae121c$var$JSXElementElementAdapter
};


var $c41cc83f0597f2b1$require$JSXElementElementAdapter = $3db1ef50ecae121c$exports.JSXElementElementAdapter;
/**
 * @param {JSXElement} node
 * @returns {ElementAdapter}
 */ function $c41cc83f0597f2b1$var$createElementAdapter(node) {
    return new $c41cc83f0597f2b1$require$JSXElementElementAdapter(node);
}
$c41cc83f0597f2b1$exports = {
    createElementAdapter: $c41cc83f0597f2b1$var$createElementAdapter
};


var $34efd57f223c87b3$require$createElementAdapter = $c41cc83f0597f2b1$exports.createElementAdapter;
/**
 * @type {RuleModule<
 *   [{ allow?: { tag: string; attr: string; valuePattern?: string }[] }]
 * >}
 */ $34efd57f223c87b3$exports = {
    meta: {
        type: "problem",
        docs: {
            description: "Disallow invalid attribute values according to HTML standards",
            category: "Best Practice",
            recommended: true,
            url: "https://html-eslint.org/docs/react/rules/no-invalid-attr-value"
        },
        fixable: null,
        schema: [
            {
                type: "object",
                properties: {
                    allow: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                tag: {
                                    type: "string"
                                },
                                attr: {
                                    type: "string"
                                },
                                valuePattern: {
                                    type: "string"
                                }
                            },
                            required: [
                                "tag",
                                "attr"
                            ],
                            additionalProperties: false
                        }
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$34efd57f223c87b3$require$NO_INVALID_ATTR_VALUE_MESSAGE_IDS.invalid]: "Invalid value '{{value}}' for attribute '{{attr}}' on <{{element}}>. {{suggestion}}"
        }
    },
    create (context) {
        const options = context.options[0] || {};
        const { checkAttributes: checkAttributes } = $34efd57f223c87b3$require$noInvalidAttrValue(options);
        return {
            JSXElement (node) {
                if (node.openingElement.name.type !== $34efd57f223c87b3$require$AST_NODE_TYPES.JSXIdentifier || node.openingElement.name.name.toLocaleLowerCase() !== node.openingElement.name.name || node.openingElement.name.name.includes("-")) return;
                const adapter = $34efd57f223c87b3$require$createElementAdapter(node);
                const result = checkAttributes(adapter);
                for (const { loc: loc, messageId: messageId, data: data } of result)context.report({
                    loc: loc,
                    messageId: messageId,
                    data: data
                });
            }
        };
    }
};


var $f990ee3bb942419b$exports = {};
/**
 * @import {
 *   JSXAttribute,
 *   JSXIdentifier,
 *   JSXOpeningElement,
 *   JSXSpreadAttribute,
 *   Literal,
 *   RuleModule,
 *   TemplateLiteral
 * } from "../types"
 * @typedef {Object} Option
 * @property {"widely" | "newly" | number} Option.available
 */ 
var $f990ee3bb942419b$require$useBaseline = $404c96e82c1b1d4e$export$af5ef811749334ac;
var $f990ee3bb942419b$require$USE_BASELINE_MESSAGE_IDS = $404c96e82c1b1d4e$export$7ac25aba97301625;

var $f990ee3bb942419b$require$AST_NODE_TYPES = $f7b7d8083db5fc3d$exports.AST_NODE_TYPES;

var $f990ee3bb942419b$require$createElementAdapter = $c41cc83f0597f2b1$exports.createElementAdapter;
/** @type {RuleModule<[Option]>} */ $f990ee3bb942419b$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Enforce the use of baseline features.",
            recommended: true,
            category: "Best Practice",
            url: "https://html-eslint.org/docs/react/rules/use-baseline"
        },
        fixable: null,
        schema: [
            {
                type: "object",
                properties: {
                    available: {
                        anyOf: [
                            {
                                enum: [
                                    "widely",
                                    "newly"
                                ]
                            },
                            {
                                // baseline year
                                type: "integer",
                                minimum: 2000,
                                maximum: new Date().getFullYear()
                            }
                        ]
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$f990ee3bb942419b$require$USE_BASELINE_MESSAGE_IDS.noBaselineElement]: "Element '{{element}}' is not a {{availability}} available baseline feature.",
            [$f990ee3bb942419b$require$USE_BASELINE_MESSAGE_IDS.notBaselineElementAttribute]: "Attribute '{{attr}}' on '{{element}}' is not a {{availability}} available baseline feature.",
            [$f990ee3bb942419b$require$USE_BASELINE_MESSAGE_IDS.notBaselineGlobalAttribute]: "Attribute '{{attr}}' is not a {{availability}} available baseline feature."
        }
    },
    create (context) {
        const options = context.options[0] || {
            available: "widely"
        };
        const { checkAttributes: checkAttributes } = $f990ee3bb942419b$require$useBaseline(options);
        return {
            JSXElement (node) {
                if (node.openingElement.name.type !== $f990ee3bb942419b$require$AST_NODE_TYPES.JSXIdentifier || node.openingElement.name.name.toLocaleLowerCase() !== node.openingElement.name.name || node.openingElement.name.name.includes("-")) return;
                const adapter = $f990ee3bb942419b$require$createElementAdapter(node);
                const result = checkAttributes(adapter);
                for (const { loc: loc, messageId: messageId, data: data } of result)context.report({
                    loc: loc,
                    messageId: messageId,
                    data: data
                });
            }
        };
    }
};


var $0bc3b75bbef068ad$exports = {};
/**
 * @import {
 *   JSXAttribute,
 *   JSXIdentifier,
 *   JSXOpeningElement,
 *   JSXSpreadAttribute,
 *   Literal,
 *   RuleModule,
 *   TemplateLiteral
 * } from "../types"
 */ 
var $0bc3b75bbef068ad$require$noIneffectiveAttrs = $404c96e82c1b1d4e$export$1669b57000ee831b;
var $0bc3b75bbef068ad$require$NO_INEFFECTIVE_ATTRS_MESSAGE_IDS = $404c96e82c1b1d4e$export$9b2977d355552fdc;

var $0bc3b75bbef068ad$require$AST_NODE_TYPES = $f7b7d8083db5fc3d$exports.AST_NODE_TYPES;

var $0bc3b75bbef068ad$require$createElementAdapter = $c41cc83f0597f2b1$exports.createElementAdapter;
/** @type {RuleModule<[]>} */ $0bc3b75bbef068ad$exports = {
    meta: {
        type: "problem",
        docs: {
            description: "Disallow HTML attributes that have no effect in their context",
            category: "Best Practice",
            recommended: true,
            url: "https://html-eslint.org/docs/react/rules/no-ineffective-attrs"
        },
        fixable: null,
        schema: [],
        messages: {
            [$0bc3b75bbef068ad$require$NO_INEFFECTIVE_ATTRS_MESSAGE_IDS.ineffective]: "{{ message }}"
        }
    },
    create (context) {
        const ruleCore = /** @type {ReturnType<typeof noIneffectiveAttrs>} */ $0bc3b75bbef068ad$require$noIneffectiveAttrs();
        return {
            JSXElement (node) {
                if (node.openingElement.name.type !== $0bc3b75bbef068ad$require$AST_NODE_TYPES.JSXIdentifier || node.openingElement.name.name.toLocaleLowerCase() !== node.openingElement.name.name || node.openingElement.name.name.includes("-")) return;
                const adapter = $0bc3b75bbef068ad$require$createElementAdapter(node);
                const result = ruleCore.checkAttributes(adapter);
                for (const { loc: loc, messageId: messageId, data: data } of result)context.report({
                    loc: loc,
                    messageId: messageId,
                    data: data
                });
            }
        };
    }
};


var $08f5b7b06ca536bd$exports = {};
/** @import {RuleModule} from "../types" */ 
var $08f5b7b06ca536bd$require$noObsoleteTags = $404c96e82c1b1d4e$export$c0e82f9203f788d4;
var $08f5b7b06ca536bd$require$NO_OBSOLETE_TAGS_MESSAGE_IDS = $404c96e82c1b1d4e$export$4b0242017845dbc3;

var $08f5b7b06ca536bd$require$AST_NODE_TYPES = $f7b7d8083db5fc3d$exports.AST_NODE_TYPES;

var $08f5b7b06ca536bd$require$createElementAdapter = $c41cc83f0597f2b1$exports.createElementAdapter;
/**
 * @type {RuleModule<
 *   [{ allow?: { tag: string; attr: string; valuePattern?: string }[] }]
 * >}
 */ $08f5b7b06ca536bd$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow use of obsolete elements in HTML5",
            category: "Best Practice",
            recommended: true
        },
        fixable: null,
        schema: [],
        messages: {
            [$08f5b7b06ca536bd$require$NO_OBSOLETE_TAGS_MESSAGE_IDS.unexpected]: "Unexpected use of obsolete tag <{{tag}}>"
        }
    },
    create (context) {
        const ruleCore = $08f5b7b06ca536bd$require$noObsoleteTags();
        return {
            JSXElement (node) {
                if (node.openingElement.name.type !== $08f5b7b06ca536bd$require$AST_NODE_TYPES.JSXIdentifier || node.openingElement.name.name.toLocaleLowerCase() !== node.openingElement.name.name || node.openingElement.name.name.includes("-")) return;
                const adapter = $08f5b7b06ca536bd$require$createElementAdapter(node);
                const result = ruleCore.checkElement(adapter);
                for (const { loc: loc, messageId: messageId, data: data } of result)context.report({
                    loc: loc,
                    messageId: messageId,
                    data: data
                });
            }
        };
    }
};


var $639a4c2fc57bfaa8$exports = {};
/**
 * @import {TSESTree} from "@typescript-eslint/types"
 * @import {RuleModule} from "../types"
 */ 
var $639a4c2fc57bfaa8$require$noObsoleteAttrs = $404c96e82c1b1d4e$export$d46aff0fc39f994d;
var $639a4c2fc57bfaa8$require$NO_OBSOLETE_ATTRS_MESSAGE_IDS = $404c96e82c1b1d4e$export$12a148edcce6f2e6;

var $639a4c2fc57bfaa8$require$AST_NODE_TYPES = $f7b7d8083db5fc3d$exports.AST_NODE_TYPES;

var $639a4c2fc57bfaa8$require$createElementAdapter = $c41cc83f0597f2b1$exports.createElementAdapter;
/** @type {RuleModule<[]>} */ $639a4c2fc57bfaa8$exports = {
    meta: {
        type: "problem",
        docs: {
            description: "Disallow use of obsolete attributes in HTML5",
            category: "Best Practice",
            recommended: true,
            url: "https://html-eslint.org/docs/react/rules/no-obsolete-attrs"
        },
        fixable: null,
        schema: [],
        messages: {
            [$639a4c2fc57bfaa8$require$NO_OBSOLETE_ATTRS_MESSAGE_IDS.obsolete]: "The {{attr}} attribute on <{{element}}> is obsolete. {{suggestion}}"
        }
    },
    create (context) {
        const { checkAttributes: checkAttributes } = $639a4c2fc57bfaa8$require$noObsoleteAttrs();
        return {
            JSXElement (node) {
                if (node.openingElement.name.type !== $639a4c2fc57bfaa8$require$AST_NODE_TYPES.JSXIdentifier || node.openingElement.name.name.toLocaleLowerCase() !== node.openingElement.name.name || node.openingElement.name.name.includes("-")) return;
                const adapter = $639a4c2fc57bfaa8$require$createElementAdapter(node);
                const result = checkAttributes(adapter);
                for (const { loc: loc, messageId: messageId, data: data } of result)context.report({
                    loc: loc,
                    messageId: messageId,
                    data: data
                });
            }
        };
    }
};


var $72bdc6d553a9ab57$exports = {};
/**
 * @import {ClassSpacingResult} from "@html-eslint/core"
 * @import {AST} from "eslint"
 * @import {
 *   ConditionalExpression,
 *   JSXExpressionContainer,
 *   Literal,
 *   LogicalExpression,
 *   NodeOrToken,
 *   RuleModule,
 *   TemplateLiteral
 * } from "../types"
 * @typedef {Object} Option
 * @property {string[]} [Option.callees]
 */ 
var $72bdc6d553a9ab57$require$classSpacing = $404c96e82c1b1d4e$export$7108f91a0f8d44f8;
var $72bdc6d553a9ab57$require$CLASS_SPACING_MESSAGE_IDS = $404c96e82c1b1d4e$export$1329c1ec5f658703;

var $72bdc6d553a9ab57$require$AST_NODE_TYPES = $f7b7d8083db5fc3d$exports.AST_NODE_TYPES;
var $5d3ec3569e9537b8$exports = {};
/**
 * @import {AST} from "eslint"
 * @import {
 *   ConditionalExpression,
 *   JSXAttribute,
 *   JSXIdentifier,
 *   Literal,
 *   LogicalExpression,
 *   Node,
 *   NodeOrToken,
 *   TemplateLiteral
 * } from "../../types"
 */ 
var $5d3ec3569e9537b8$require$AST_NODE_TYPES = $f7b7d8083db5fc3d$exports.AST_NODE_TYPES;
/**
 * Check if a node represents a static string value
 *
 * A node is considered a static string if it's either:
 *
 * - A Literal node (e.g., "foo", 'bar')
 * - A TemplateLiteral without any expressions (e.g., `foo`)
 *
 * @example
 *   isStaticString("foo"); // true - Literal
 *   isStaticString(`bar`); // true - TemplateLiteral without expressions
 *   isStaticString(`${foo}`); // false - has expression
 *   isStaticString(someVariable); // false - not a string literal
 *
 * @param {Node} node - The AST node to check
 * @returns {node is Literal | TemplateLiteral} True if the node is a static
 *   string
 */ function $5d3ec3569e9537b8$var$isStaticString(node) {
    return node.type === $5d3ec3569e9537b8$require$AST_NODE_TYPES.Literal && typeof node.value === "string" || node.type === $5d3ec3569e9537b8$require$AST_NODE_TYPES.TemplateLiteral && node.expressions.length === 0 && node.quasis.length === 1;
}
/**
 * @param {JSXAttribute} node
 * @returns {Literal | TemplateLiteral | JSXIdentifier | null}
 */ function $5d3ec3569e9537b8$var$findAttributeValueNode(node) {
    // boolean props
    if (!node.value && node.name.type === $5d3ec3569e9537b8$require$AST_NODE_TYPES.JSXIdentifier) return node.name;
    if (node.value?.type === $5d3ec3569e9537b8$require$AST_NODE_TYPES.Literal) return node.value;
    if (node.value?.type === $5d3ec3569e9537b8$require$AST_NODE_TYPES.JSXExpressionContainer && (node.value?.expression.type === $5d3ec3569e9537b8$require$AST_NODE_TYPES.Literal || node.value?.expression.type === $5d3ec3569e9537b8$require$AST_NODE_TYPES.TemplateLiteral && node.value?.expression.expressions.length === 0 && node.value?.expression.quasis.length === 1)) return node.value?.expression;
    return null;
}
/**
 * Adjust the column position of a source location
 *
 * @param {AST.SourceLocation} location - The source location to adjust
 * @param {number} columnOffset - The number of columns to add
 * @returns {AST.SourceLocation} A new location with adjusted columns
 */ function $5d3ec3569e9537b8$var$adjustLocationColumn(location, columnOffset) {
    return {
        start: {
            line: location.start.line,
            column: location.start.column + columnOffset
        },
        end: {
            line: location.end.line,
            column: location.end.column + columnOffset
        }
    };
}
/**
 * @param {NodeOrToken} node
 * @returns {node is Literal}
 */ function $5d3ec3569e9537b8$var$isLiteral(node) {
    return node.type === $5d3ec3569e9537b8$require$AST_NODE_TYPES.Literal;
}
/**
 * @param {NodeOrToken} node
 * @returns {node is TemplateLiteral}
 */ function $5d3ec3569e9537b8$var$isTemplateLiteral(node) {
    return node.type === $5d3ec3569e9537b8$require$AST_NODE_TYPES.TemplateLiteral;
}
/**
 * @param {NodeOrToken} node
 * @returns {node is LogicalExpression}
 */ function $5d3ec3569e9537b8$var$isLogicalExpression(node) {
    return node.type === $5d3ec3569e9537b8$require$AST_NODE_TYPES.LogicalExpression;
}
/**
 * @param {NodeOrToken} node
 * @returns {node is ConditionalExpression}
 */ function $5d3ec3569e9537b8$var$isConditionalExpression(node) {
    return node.type === $5d3ec3569e9537b8$require$AST_NODE_TYPES.ConditionalExpression;
}
$5d3ec3569e9537b8$exports = {
    isStaticString: $5d3ec3569e9537b8$var$isStaticString,
    findAttributeValueNode: $5d3ec3569e9537b8$var$findAttributeValueNode,
    adjustLocationColumn: $5d3ec3569e9537b8$var$adjustLocationColumn,
    isLiteral: $5d3ec3569e9537b8$var$isLiteral,
    isTemplateLiteral: $5d3ec3569e9537b8$var$isTemplateLiteral,
    isLogicalExpression: $5d3ec3569e9537b8$var$isLogicalExpression,
    isConditionalExpression: $5d3ec3569e9537b8$var$isConditionalExpression
};


var $72bdc6d553a9ab57$require$isLiteral = $5d3ec3569e9537b8$exports.isLiteral;
var $72bdc6d553a9ab57$require$isTemplateLiteral = $5d3ec3569e9537b8$exports.isTemplateLiteral;
var $72bdc6d553a9ab57$require$isLogicalExpression = $5d3ec3569e9537b8$exports.isLogicalExpression;
var $72bdc6d553a9ab57$require$isConditionalExpression = $5d3ec3569e9537b8$exports.isConditionalExpression;

var $72bdc6d553a9ab57$require$createAttributeValueAdapter = $80c0b1f130b8da00$exports.createAttributeValueAdapter;
/** @type {RuleModule<[Option]>} */ $72bdc6d553a9ab57$exports = {
    meta: {
        type: "layout",
        docs: {
            description: "Disallow extra spacing in className values",
            category: "Stylistic Issues",
            recommended: true,
            url: "https://html-eslint.org/docs/react/rules/classname-spacing"
        },
        fixable: "code",
        schema: [
            {
                type: "object",
                properties: {
                    callees: {
                        type: "array",
                        items: {
                            type: "string"
                        },
                        uniqueItems: true
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$72bdc6d553a9ab57$require$CLASS_SPACING_MESSAGE_IDS.extraSpacing]: "Unexpected extra spacing in className value"
        }
    },
    create (context) {
        const options = context.options[0] || {};
        const callees = options.callees || [];
        const ruleCore = $72bdc6d553a9ab57$require$classSpacing();
        /**
     * Check if a node matches the callees option
     *
     * @param {any} node
     * @returns {boolean}
     */ function isTargetCallee(node) {
            if (node.callee.type === $72bdc6d553a9ab57$require$AST_NODE_TYPES.Identifier) return callees.includes(node.callee.name);
            return false;
        }
        /** @param {Literal | TemplateLiteral} node */ function checkLiteral(node) {
            const adapter = $72bdc6d553a9ab57$require$createAttributeValueAdapter(node);
            const result = ruleCore.checkClassValue(adapter);
            for (const { loc: loc, messageId: messageId, range: range } of result)context.report({
                loc: loc,
                messageId: messageId,
                fix (fixer) {
                    return fixer.removeRange(range);
                }
            });
        }
        /** @param {LogicalExpression} node */ function checkLogicalExpression(node) {
            [
                node.left,
                node.right
            ].forEach((n)=>{
                if ($72bdc6d553a9ab57$require$isLiteral(n) || $72bdc6d553a9ab57$require$isTemplateLiteral(n)) checkLiteral(n);
                else if ($72bdc6d553a9ab57$require$isLogicalExpression(n)) checkLogicalExpression(n);
                else if ($72bdc6d553a9ab57$require$isConditionalExpression(n)) checkConditionalExpression(n);
            });
        }
        /** @param {ConditionalExpression} node */ function checkConditionalExpression(node) {
            [
                node.consequent,
                node.alternate
            ].forEach((n)=>{
                if ($72bdc6d553a9ab57$require$isLiteral(n) || $72bdc6d553a9ab57$require$isTemplateLiteral(n)) checkLiteral(n);
                else if ($72bdc6d553a9ab57$require$isLogicalExpression(n)) checkLogicalExpression(n);
                else if ($72bdc6d553a9ab57$require$isConditionalExpression(n)) checkConditionalExpression(n);
            });
        }
        /**
     * Check if node is a checkable expression and process it
     *
     * @param {NodeOrToken} node
     */ function checkExpression(node) {
            if ($72bdc6d553a9ab57$require$isLiteral(node) || $72bdc6d553a9ab57$require$isTemplateLiteral(node)) checkLiteral(node);
            else if ($72bdc6d553a9ab57$require$isLogicalExpression(node)) checkLogicalExpression(node);
            else if ($72bdc6d553a9ab57$require$isConditionalExpression(node)) checkConditionalExpression(node);
        }
        /** @param {JSXExpressionContainer} node */ function checkJSXExpressionContainer(node) {
            checkExpression(node.expression);
        }
        return {
            CallExpression (node) {
                if (!isTargetCallee(node)) return;
                for (const arg of node.arguments)checkExpression(arg);
            },
            JSXAttribute (node) {
                if (node.name.type !== $72bdc6d553a9ab57$require$AST_NODE_TYPES.JSXIdentifier || node.name.name.toLowerCase() !== "classname" || !node.value) return;
                if ($72bdc6d553a9ab57$require$isLiteral(node.value)) checkLiteral(node.value);
                else if (node.value.type === $72bdc6d553a9ab57$require$AST_NODE_TYPES.JSXExpressionContainer) checkJSXExpressionContainer(node.value);
            }
        };
    }
};


var $bff37fa60b652bd6$exports = {};
/**
 * @import {
 *   ConditionalExpression,
 *   JSXExpressionContainer,
 *   Literal,
 *   LogicalExpression,
 *   Node,
 *   NodeOrToken,
 *   RuleModule,
 *   TemplateLiteral
 * } from "../types"
 * @typedef {Object} Option
 * @property {string[]} [Option.callees]
 */ 
var $bff37fa60b652bd6$require$noDuplicateClass = $404c96e82c1b1d4e$export$f162233fbd04d00f;
var $bff37fa60b652bd6$require$NO_DUPLICATE_CLASS_MESSAGE_IDS = $404c96e82c1b1d4e$export$e175ab31a1e21871;

var $bff37fa60b652bd6$require$AST_NODE_TYPES = $f7b7d8083db5fc3d$exports.AST_NODE_TYPES;

var $bff37fa60b652bd6$require$isTemplateLiteral = $5d3ec3569e9537b8$exports.isTemplateLiteral;
var $bff37fa60b652bd6$require$isLiteral = $5d3ec3569e9537b8$exports.isLiteral;
var $bff37fa60b652bd6$require$isLogicalExpression = $5d3ec3569e9537b8$exports.isLogicalExpression;
var $bff37fa60b652bd6$require$isConditionalExpression = $5d3ec3569e9537b8$exports.isConditionalExpression;

var $bff37fa60b652bd6$require$createAttributeValueAdapter = $80c0b1f130b8da00$exports.createAttributeValueAdapter;
/** @type {RuleModule<[Option]>} */ $bff37fa60b652bd6$exports = {
    meta: {
        type: "code",
        docs: {
            description: "Disallow duplicate class names in className",
            category: "Best Practices",
            recommended: true,
            url: "https://html-eslint.org/docs/react/rules/no-duplicate-classname"
        },
        fixable: "code",
        schema: [
            {
                type: "object",
                properties: {
                    callees: {
                        type: "array",
                        items: {
                            type: "string"
                        },
                        uniqueItems: true
                    }
                },
                additionalProperties: false
            }
        ],
        messages: {
            [$bff37fa60b652bd6$require$NO_DUPLICATE_CLASS_MESSAGE_IDS.duplicateClass]: "The class '{{className}}' is duplicated."
        }
    },
    create (context) {
        const options = context.options[0] || {};
        const callees = options.callees || [];
        const { checkClassValue: checkClassValue } = $bff37fa60b652bd6$require$noDuplicateClass();
        /**
     * Check if a node matches the callees option
     *
     * @param {any} node
     * @returns {boolean}
     */ function isTargetCallee(node) {
            if (node.callee.type === $bff37fa60b652bd6$require$AST_NODE_TYPES.Identifier) return callees.includes(node.callee.name);
            return false;
        }
        /** @param {Literal | TemplateLiteral} node */ function checkLiteral(node) {
            const adapter = $bff37fa60b652bd6$require$createAttributeValueAdapter(node);
            const result = checkClassValue(adapter);
            for (const { loc: loc, messageId: messageId, range: range, data: data } of result)context.report({
                loc: loc,
                messageId: messageId,
                data: data,
                fix (fixer) {
                    return fixer.removeRange(range);
                }
            });
        }
        /** @param {LogicalExpression} node */ function checkLogicalExpression(node) {
            [
                node.left,
                node.right
            ].forEach((n)=>{
                if ($bff37fa60b652bd6$require$isLiteral(n) || $bff37fa60b652bd6$require$isTemplateLiteral(n)) checkLiteral(n);
                else if ($bff37fa60b652bd6$require$isLogicalExpression(n)) checkLogicalExpression(n);
                else if ($bff37fa60b652bd6$require$isConditionalExpression(n)) checkConditionalExpression(n);
            });
        }
        /** @param {ConditionalExpression} node */ function checkConditionalExpression(node) {
            [
                node.consequent,
                node.alternate
            ].forEach((n)=>{
                if ($bff37fa60b652bd6$require$isLiteral(n) || $bff37fa60b652bd6$require$isTemplateLiteral(n)) checkLiteral(n);
                else if ($bff37fa60b652bd6$require$isLogicalExpression(n)) checkLogicalExpression(n);
                else if ($bff37fa60b652bd6$require$isConditionalExpression(n)) checkConditionalExpression(n);
            });
        }
        /** @param {NodeOrToken} node */ function checkExpression(node) {
            if ($bff37fa60b652bd6$require$isLiteral(node) || $bff37fa60b652bd6$require$isTemplateLiteral(node)) checkLiteral(node);
            else if ($bff37fa60b652bd6$require$isLogicalExpression(node)) checkLogicalExpression(node);
            else if ($bff37fa60b652bd6$require$isConditionalExpression(node)) checkConditionalExpression(node);
        }
        /** @param {JSXExpressionContainer} node */ function checkJSXExpressionContainer(node) {
            checkExpression(node.expression);
        }
        return {
            CallExpression (node) {
                if (!isTargetCallee(node)) return;
                for (const arg of node.arguments)checkExpression(arg);
            },
            JSXAttribute (node) {
                if (node.name.type !== $bff37fa60b652bd6$require$AST_NODE_TYPES.JSXIdentifier || node.name.name.toLowerCase() !== "classname" || !node.value) return;
                if ($bff37fa60b652bd6$require$isLiteral(node.value)) checkLiteral(node.value);
                else if (node.value.type === $bff37fa60b652bd6$require$AST_NODE_TYPES.JSXExpressionContainer) checkJSXExpressionContainer(node.value);
            }
        };
    }
};


// import new rule here ↑
const $36a7c6fe056ad952$var$rules = {
    "no-invalid-attr-value": $34efd57f223c87b3$exports,
    "use-baseline": $f990ee3bb942419b$exports,
    "no-ineffective-attrs": $0bc3b75bbef068ad$exports,
    "no-obsolete-tags": $08f5b7b06ca536bd$exports,
    "no-obsolete-attrs": $639a4c2fc57bfaa8$exports,
    "classname-spacing": $72bdc6d553a9ab57$exports,
    "no-duplicate-classname": $bff37fa60b652bd6$exports
};
$36a7c6fe056ad952$exports = $36a7c6fe056ad952$var$rules;


var $15bcbe493910c39c$exports = {};

!function(e1, t) {
    t($15bcbe493910c39c$exports);
}($15bcbe493910c39c$exports, function(e1) {
    "use strict";
    function t(e1) {
        return e1 && Object.prototype.hasOwnProperty.call(e1, "default") ? e1.default : e1;
    }
    var r, n = {}, s = {}, i = {
        get exports () {
            return s;
        },
        set exports (e){
            s = e;
        }
    };
    var o = "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {};
    function a() {
        throw new Error("setTimeout has not been defined");
    }
    function u() {
        throw new Error("clearTimeout has not been defined");
    }
    var l = a, c = u;
    function p(e1) {
        if (l === setTimeout) return setTimeout(e1, 0);
        if ((l === a || !l) && setTimeout) return l = setTimeout, setTimeout(e1, 0);
        try {
            return l(e1, 0);
        } catch (t) {
            try {
                return l.call(null, e1, 0);
            } catch (t) {
                return l.call(this, e1, 0);
            }
        }
    }
    "function" == typeof o.setTimeout && (l = setTimeout), "function" == typeof o.clearTimeout && (c = clearTimeout);
    var f, d = [], h = !1, m = -1;
    function g() {
        h && f && (h = !1, f.length ? d = f.concat(d) : m = -1, d.length && y());
    }
    function y() {
        if (!h) {
            var e1 = p(g);
            h = !0;
            for(var t = d.length; t;){
                for(f = d, d = []; ++m < t;)f && f[m].run();
                m = -1, t = d.length;
            }
            f = null, h = !1, function(e1) {
                if (c === clearTimeout) return clearTimeout(e1);
                if ((c === u || !c) && clearTimeout) return c = clearTimeout, clearTimeout(e1);
                try {
                    return c(e1);
                } catch (t) {
                    try {
                        return c.call(null, e1);
                    } catch (t) {
                        return c.call(this, e1);
                    }
                }
            }(e1);
        }
    }
    function E(e1, t) {
        this.fun = e1, this.array = t;
    }
    E.prototype.run = function() {
        this.fun.apply(null, this.array);
    };
    function x() {}
    var C = x, S = x, b = x, v = x, A = x, T = x, R = x;
    var D = o.performance || {}, w = D.now || D.mozNow || D.msNow || D.oNow || D.webkitNow || function() {
        return (new Date).getTime();
    };
    var _ = new Date;
    var k = {
        nextTick: function(e1) {
            var t = new Array(arguments.length - 1);
            if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
            d.push(new E(e1, t)), 1 !== d.length || h || p(y);
        },
        title: "browser",
        browser: !0,
        env: {},
        argv: [],
        version: "",
        versions: {},
        on: C,
        addListener: S,
        once: b,
        off: v,
        removeListener: A,
        removeAllListeners: T,
        emit: R,
        binding: function(e1) {
            throw new Error("process.binding is not supported");
        },
        cwd: function() {
            return "/";
        },
        chdir: function(e1) {
            throw new Error("process.chdir is not supported");
        },
        umask: function() {
            return 0;
        },
        hrtime: function(e1) {
            var t = .001 * w.call(D), r = Math.floor(t), n = Math.floor(t % 1 * 1e9);
            return e1 && (r -= e1[0], (n -= e1[1]) < 0 && (r--, n += 1e9)), [
                r,
                n
            ];
        },
        platform: "browser",
        release: {},
        config: {},
        uptime: function() {
            return (new Date - _) / 1e3;
        }
    };
    function B(e1, t) {
        for(var r = 0, n = e1.length - 1; n >= 0; n--){
            var s = e1[n];
            "." === s ? e1.splice(n, 1) : ".." === s ? (e1.splice(n, 1), r++) : r && (e1.splice(n, 1), r--);
        }
        if (t) for(; r--; r)e1.unshift("..");
        return e1;
    }
    var L = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/, P = function(e1) {
        return L.exec(e1).slice(1);
    };
    function I() {
        for(var e1 = "", t = !1, r = arguments.length - 1; r >= -1 && !t; r--){
            var n = r >= 0 ? arguments[r] : "/";
            if ("string" != typeof n) throw new TypeError("Arguments to path.resolve must be strings");
            n && (e1 = n + "/" + e1, t = "/" === n.charAt(0));
        }
        return e1 = B($(e1.split("/"), function(e1) {
            return !!e1;
        }), !t).join("/"), (t ? "/" : "") + e1 || ".";
    }
    function F(e1) {
        var t = N(e1), r = "/" === q(e1, -1);
        return e1 = B($(e1.split("/"), function(e1) {
            return !!e1;
        }), !t).join("/"), e1 || t || (e1 = "."), e1 && r && (e1 += "/"), (t ? "/" : "") + e1;
    }
    function N(e1) {
        return "/" === e1.charAt(0);
    }
    function O() {
        return F($(Array.prototype.slice.call(arguments, 0), function(e1, t) {
            if ("string" != typeof e1) throw new TypeError("Arguments to path.join must be strings");
            return e1;
        }).join("/"));
    }
    function U(e1, t) {
        function r(e1) {
            for(var t = 0; t < e1.length && "" === e1[t]; t++);
            for(var r = e1.length - 1; r >= 0 && "" === e1[r]; r--);
            return t > r ? [] : e1.slice(t, r - t + 1);
        }
        e1 = I(e1).substr(1), t = I(t).substr(1);
        for(var n = r(e1.split("/")), s = r(t.split("/")), i = Math.min(n.length, s.length), o = i, a = 0; a < i; a++)if (n[a] !== s[a]) {
            o = a;
            break;
        }
        var u = [];
        for(a = o; a < n.length; a++)u.push("..");
        return (u = u.concat(s.slice(o))).join("/");
    }
    function j(e1) {
        var t = P(e1), r = t[0], n = t[1];
        return r || n ? (n && (n = n.substr(0, n.length - 1)), r + n) : ".";
    }
    function V(e1, t) {
        var r = P(e1)[2];
        return t && r.substr(-1 * t.length) === t && (r = r.substr(0, r.length - t.length)), r;
    }
    function K(e1) {
        return P(e1)[3];
    }
    var M = {
        extname: K,
        basename: V,
        dirname: j,
        sep: "/",
        delimiter: ":",
        relative: U,
        join: O,
        isAbsolute: N,
        normalize: F,
        resolve: I
    };
    function $(e1, t) {
        if (e1.filter) return e1.filter(t);
        for(var r = [], n = 0; n < e1.length; n++)t(e1[n], n, e1) && r.push(e1[n]);
        return r;
    }
    var q = "b" === "ab".substr(-1) ? function(e1, t, r) {
        return e1.substr(t, r);
    } : function(e1, t, r) {
        return t < 0 && (t = e1.length + t), e1.substr(t, r);
    }, G = t(Object.freeze({
        __proto__: null,
        basename: V,
        default: M,
        delimiter: ":",
        dirname: j,
        extname: K,
        isAbsolute: N,
        join: O,
        normalize: F,
        relative: U,
        resolve: I,
        sep: "/"
    })), W = {}, X = [], z = [], H = "undefined" != typeof Uint8Array ? Uint8Array : Array, J = !1;
    function Q() {
        J = !0;
        for(var e1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", t = 0; t < 64; ++t)X[t] = e1[t], z[e1.charCodeAt(t)] = t;
        z["-".charCodeAt(0)] = 62, z["_".charCodeAt(0)] = 63;
    }
    function Y(e1, t, r) {
        for(var n, s, i = [], o = t; o < r; o += 3)n = (e1[o] << 16) + (e1[o + 1] << 8) + e1[o + 2], i.push(X[(s = n) >> 18 & 63] + X[s >> 12 & 63] + X[s >> 6 & 63] + X[63 & s]);
        return i.join("");
    }
    function Z(e1) {
        var t;
        J || Q();
        for(var r = e1.length, n = r % 3, s = "", i = [], o = 16383, a = 0, u = r - n; a < u; a += o)i.push(Y(e1, a, a + o > u ? u : a + o));
        return 1 === n ? (t = e1[r - 1], s += X[t >> 2], s += X[t << 4 & 63], s += "==") : 2 === n && (t = (e1[r - 2] << 8) + e1[r - 1], s += X[t >> 10], s += X[t >> 4 & 63], s += X[t << 2 & 63], s += "="), i.push(s), i.join("");
    }
    function ee(e1, t, r, n, s) {
        var i, o, a = 8 * s - n - 1, u = (1 << a) - 1, l = u >> 1, c = -7, p = r ? s - 1 : 0, f = r ? -1 : 1, d = e1[t + p];
        for(p += f, i = d & (1 << -c) - 1, d >>= -c, c += a; c > 0; i = 256 * i + e1[t + p], p += f, c -= 8);
        for(o = i & (1 << -c) - 1, i >>= -c, c += n; c > 0; o = 256 * o + e1[t + p], p += f, c -= 8);
        if (0 === i) i = 1 - l;
        else {
            if (i === u) return o ? NaN : 1 / 0 * (d ? -1 : 1);
            o += Math.pow(2, n), i -= l;
        }
        return (d ? -1 : 1) * o * Math.pow(2, i - n);
    }
    function te(e1, t, r, n, s, i) {
        var o, a, u, l = 8 * i - s - 1, c = (1 << l) - 1, p = c >> 1, f = 23 === s ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : i - 1, h = n ? 1 : -1, m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
        for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, o = c) : (o = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -o)) < 1 && (o--, u *= 2), (t += o + p >= 1 ? f / u : f * Math.pow(2, 1 - p)) * u >= 2 && (o++, u /= 2), o + p >= c ? (a = 0, o = c) : o + p >= 1 ? (a = (t * u - 1) * Math.pow(2, s), o += p) : (a = t * Math.pow(2, p - 1) * Math.pow(2, s), o = 0)); s >= 8; e1[r + d] = 255 & a, d += h, a /= 256, s -= 8);
        for(o = o << s | a, l += s; l > 0; e1[r + d] = 255 & o, d += h, o /= 256, l -= 8);
        e1[r + d - h] |= 128 * m;
    }
    var re = {}.toString, ne = Array.isArray || function(e1) {
        return "[object Array]" == re.call(e1);
    };
    function se() {
        return oe.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
    }
    function ie(e1, t) {
        if (se() < t) throw new RangeError("Invalid typed array length");
        return oe.TYPED_ARRAY_SUPPORT ? (e1 = new Uint8Array(t)).__proto__ = oe.prototype : (null === e1 && (e1 = new oe(t)), e1.length = t), e1;
    }
    function oe(e1, t, r) {
        if (!(oe.TYPED_ARRAY_SUPPORT || this instanceof oe)) return new oe(e1, t, r);
        if ("number" == typeof e1) {
            if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
            return le(this, e1);
        }
        return ae(this, e1, t, r);
    }
    function ae(e1, t, r, n) {
        if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function(e1, t, r, n) {
            if (t.byteLength, r < 0 || t.byteLength < r) throw new RangeError("'offset' is out of bounds");
            if (t.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
            t = void 0 === r && void 0 === n ? new Uint8Array(t) : void 0 === n ? new Uint8Array(t, r) : new Uint8Array(t, r, n);
            oe.TYPED_ARRAY_SUPPORT ? (e1 = t).__proto__ = oe.prototype : e1 = ce(e1, t);
            return e1;
        }(e1, t, r, n) : "string" == typeof t ? function(e1, t, r) {
            "string" == typeof r && "" !== r || (r = "utf8");
            if (!oe.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
            var n = 0 | de(t, r);
            e1 = ie(e1, n);
            var s = e1.write(t, r);
            s !== n && (e1 = e1.slice(0, s));
            return e1;
        }(e1, t, r) : function(e1, t) {
            if (fe(t)) {
                var r = 0 | pe(t.length);
                return 0 === (e1 = ie(e1, r)).length || t.copy(e1, 0, 0, r), e1;
            }
            if (t) {
                if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (n = t.length) != n ? ie(e1, 0) : ce(e1, t);
                if ("Buffer" === t.type && ne(t.data)) return ce(e1, t.data);
            }
            var n;
            throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(e1, t);
    }
    function ue(e1) {
        if ("number" != typeof e1) throw new TypeError('"size" argument must be a number');
        if (e1 < 0) throw new RangeError('"size" argument must not be negative');
    }
    function le(e1, t) {
        if (ue(t), e1 = ie(e1, t < 0 ? 0 : 0 | pe(t)), !oe.TYPED_ARRAY_SUPPORT) for(var r = 0; r < t; ++r)e1[r] = 0;
        return e1;
    }
    function ce(e1, t) {
        var r = t.length < 0 ? 0 : 0 | pe(t.length);
        e1 = ie(e1, r);
        for(var n = 0; n < r; n += 1)e1[n] = 255 & t[n];
        return e1;
    }
    function pe(e1) {
        if (e1 >= se()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + se().toString(16) + " bytes");
        return 0 | e1;
    }
    function fe(e1) {
        return !(null == e1 || !e1._isBuffer);
    }
    function de(e1, t) {
        if (fe(e1)) return e1.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e1) || e1 instanceof ArrayBuffer)) return e1.byteLength;
        "string" != typeof e1 && (e1 = "" + e1);
        var r = e1.length;
        if (0 === r) return 0;
        for(var n = !1;;)switch(t){
            case "ascii":
            case "latin1":
            case "binary":
                return r;
            case "utf8":
            case "utf-8":
            case void 0:
                return Ve(e1).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return 2 * r;
            case "hex":
                return r >>> 1;
            case "base64":
                return Ke(e1).length;
            default:
                if (n) return Ve(e1).length;
                t = ("" + t).toLowerCase(), n = !0;
        }
    }
    function he(e1, t, r) {
        var n = !1;
        if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
        if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
        if ((r >>>= 0) <= (t >>>= 0)) return "";
        for(e1 || (e1 = "utf8");;)switch(e1){
            case "hex":
                return _e(this, t, r);
            case "utf8":
            case "utf-8":
                return Te(this, t, r);
            case "ascii":
                return De(this, t, r);
            case "latin1":
            case "binary":
                return we(this, t, r);
            case "base64":
                return Ae(this, t, r);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return ke(this, t, r);
            default:
                if (n) throw new TypeError("Unknown encoding: " + e1);
                e1 = (e1 + "").toLowerCase(), n = !0;
        }
    }
    function me(e1, t, r) {
        var n = e1[t];
        e1[t] = e1[r], e1[r] = n;
    }
    function ge(e1, t, r, n, s) {
        if (0 === e1.length) return -1;
        if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = s ? 0 : e1.length - 1), r < 0 && (r = e1.length + r), r >= e1.length) {
            if (s) return -1;
            r = e1.length - 1;
        } else if (r < 0) {
            if (!s) return -1;
            r = 0;
        }
        if ("string" == typeof t && (t = oe.from(t, n)), fe(t)) return 0 === t.length ? -1 : ye(e1, t, r, n, s);
        if ("number" == typeof t) return t &= 255, oe.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? s ? Uint8Array.prototype.indexOf.call(e1, t, r) : Uint8Array.prototype.lastIndexOf.call(e1, t, r) : ye(e1, [
            t
        ], r, n, s);
        throw new TypeError("val must be string, number or Buffer");
    }
    function ye(e1, t, r, n, s) {
        var i, o = 1, a = e1.length, u = t.length;
        if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
            if (e1.length < 2 || t.length < 2) return -1;
            o = 2, a /= 2, u /= 2, r /= 2;
        }
        function l(e1, t) {
            return 1 === o ? e1[t] : e1.readUInt16BE(t * o);
        }
        if (s) {
            var c = -1;
            for(i = r; i < a; i++)if (l(e1, i) === l(t, -1 === c ? 0 : i - c)) {
                if (-1 === c && (c = i), i - c + 1 === u) return c * o;
            } else -1 !== c && (i -= i - c), c = -1;
        } else for(r + u > a && (r = a - u), i = r; i >= 0; i--){
            for(var p = !0, f = 0; f < u; f++)if (l(e1, i + f) !== l(t, f)) {
                p = !1;
                break;
            }
            if (p) return i;
        }
        return -1;
    }
    function Ee(e1, t, r, n) {
        r = Number(r) || 0;
        var s = e1.length - r;
        n ? (n = Number(n)) > s && (n = s) : n = s;
        var i = t.length;
        if (i % 2 != 0) throw new TypeError("Invalid hex string");
        n > i / 2 && (n = i / 2);
        for(var o = 0; o < n; ++o){
            var a = parseInt(t.substr(2 * o, 2), 16);
            if (isNaN(a)) return o;
            e1[r + o] = a;
        }
        return o;
    }
    function xe(e1, t, r, n) {
        return Me(Ve(t, e1.length - r), e1, r, n);
    }
    function Ce(e1, t, r, n) {
        return Me(function(e1) {
            for(var t = [], r = 0; r < e1.length; ++r)t.push(255 & e1.charCodeAt(r));
            return t;
        }(t), e1, r, n);
    }
    function Se(e1, t, r, n) {
        return Ce(e1, t, r, n);
    }
    function be(e1, t, r, n) {
        return Me(Ke(t), e1, r, n);
    }
    function ve(e1, t, r, n) {
        return Me(function(e1, t) {
            for(var r, n, s, i = [], o = 0; o < e1.length && !((t -= 2) < 0); ++o)n = (r = e1.charCodeAt(o)) >> 8, s = r % 256, i.push(s), i.push(n);
            return i;
        }(t, e1.length - r), e1, r, n);
    }
    function Ae(e1, t, r) {
        return 0 === t && r === e1.length ? Z(e1) : Z(e1.slice(t, r));
    }
    function Te(e1, t, r) {
        r = Math.min(e1.length, r);
        for(var n = [], s = t; s < r;){
            var i, o, a, u, l = e1[s], c = null, p = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
            if (s + p <= r) switch(p){
                case 1:
                    l < 128 && (c = l);
                    break;
                case 2:
                    128 == (192 & (i = e1[s + 1])) && (u = (31 & l) << 6 | 63 & i) > 127 && (c = u);
                    break;
                case 3:
                    i = e1[s + 1], o = e1[s + 2], 128 == (192 & i) && 128 == (192 & o) && (u = (15 & l) << 12 | (63 & i) << 6 | 63 & o) > 2047 && (u < 55296 || u > 57343) && (c = u);
                    break;
                case 4:
                    i = e1[s + 1], o = e1[s + 2], a = e1[s + 3], 128 == (192 & i) && 128 == (192 & o) && 128 == (192 & a) && (u = (15 & l) << 18 | (63 & i) << 12 | (63 & o) << 6 | 63 & a) > 65535 && u < 1114112 && (c = u);
            }
            null === c ? (c = 65533, p = 1) : c > 65535 && (c -= 65536, n.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n.push(c), s += p;
        }
        return function(e1) {
            var t = e1.length;
            if (t <= Re) return String.fromCharCode.apply(String, e1);
            var r = "", n = 0;
            for(; n < t;)r += String.fromCharCode.apply(String, e1.slice(n, n += Re));
            return r;
        }(n);
    }
    oe.TYPED_ARRAY_SUPPORT = void 0 === o.TYPED_ARRAY_SUPPORT || o.TYPED_ARRAY_SUPPORT, se(), oe.poolSize = 8192, oe._augment = function(e1) {
        return e1.__proto__ = oe.prototype, e1;
    }, oe.from = function(e1, t, r) {
        return ae(null, e1, t, r);
    }, oe.TYPED_ARRAY_SUPPORT && (oe.prototype.__proto__ = Uint8Array.prototype, oe.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && oe[Symbol.species]), oe.alloc = function(e1, t, r) {
        return function(e1, t, r, n) {
            return ue(t), t <= 0 ? ie(e1, t) : void 0 !== r ? "string" == typeof n ? ie(e1, t).fill(r, n) : ie(e1, t).fill(r) : ie(e1, t);
        }(null, e1, t, r);
    }, oe.allocUnsafe = function(e1) {
        return le(null, e1);
    }, oe.allocUnsafeSlow = function(e1) {
        return le(null, e1);
    }, oe.isBuffer = $e, oe.compare = function(e1, t) {
        if (!fe(e1) || !fe(t)) throw new TypeError("Arguments must be Buffers");
        if (e1 === t) return 0;
        for(var r = e1.length, n = t.length, s = 0, i = Math.min(r, n); s < i; ++s)if (e1[s] !== t[s]) {
            r = e1[s], n = t[s];
            break;
        }
        return r < n ? -1 : n < r ? 1 : 0;
    }, oe.isEncoding = function(e1) {
        switch(String(e1).toLowerCase()){
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return !0;
            default:
                return !1;
        }
    }, oe.concat = function(e1, t) {
        if (!ne(e1)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === e1.length) return oe.alloc(0);
        var r;
        if (void 0 === t) for(t = 0, r = 0; r < e1.length; ++r)t += e1[r].length;
        var n = oe.allocUnsafe(t), s = 0;
        for(r = 0; r < e1.length; ++r){
            var i = e1[r];
            if (!fe(i)) throw new TypeError('"list" argument must be an Array of Buffers');
            i.copy(n, s), s += i.length;
        }
        return n;
    }, oe.byteLength = de, oe.prototype._isBuffer = !0, oe.prototype.swap16 = function() {
        var e1 = this.length;
        if (e1 % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
        for(var t = 0; t < e1; t += 2)me(this, t, t + 1);
        return this;
    }, oe.prototype.swap32 = function() {
        var e1 = this.length;
        if (e1 % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
        for(var t = 0; t < e1; t += 4)me(this, t, t + 3), me(this, t + 1, t + 2);
        return this;
    }, oe.prototype.swap64 = function() {
        var e1 = this.length;
        if (e1 % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
        for(var t = 0; t < e1; t += 8)me(this, t, t + 7), me(this, t + 1, t + 6), me(this, t + 2, t + 5), me(this, t + 3, t + 4);
        return this;
    }, oe.prototype.toString = function() {
        var e1 = 0 | this.length;
        return 0 === e1 ? "" : 0 === arguments.length ? Te(this, 0, e1) : he.apply(this, arguments);
    }, oe.prototype.equals = function(e1) {
        if (!fe(e1)) throw new TypeError("Argument must be a Buffer");
        return this === e1 || 0 === oe.compare(this, e1);
    }, oe.prototype.inspect = function() {
        var e1 = "";
        return this.length > 0 && (e1 = this.toString("hex", 0, 50).match(/.{2}/g).join(" "), this.length > 50 && (e1 += " ... ")), "<Buffer " + e1 + ">";
    }, oe.prototype.compare = function(e1, t, r, n, s) {
        if (!fe(e1)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === t && (t = 0), void 0 === r && (r = e1 ? e1.length : 0), void 0 === n && (n = 0), void 0 === s && (s = this.length), t < 0 || r > e1.length || n < 0 || s > this.length) throw new RangeError("out of range index");
        if (n >= s && t >= r) return 0;
        if (n >= s) return -1;
        if (t >= r) return 1;
        if (this === e1) return 0;
        for(var i = (s >>>= 0) - (n >>>= 0), o = (r >>>= 0) - (t >>>= 0), a = Math.min(i, o), u = this.slice(n, s), l = e1.slice(t, r), c = 0; c < a; ++c)if (u[c] !== l[c]) {
            i = u[c], o = l[c];
            break;
        }
        return i < o ? -1 : o < i ? 1 : 0;
    }, oe.prototype.includes = function(e1, t, r) {
        return -1 !== this.indexOf(e1, t, r);
    }, oe.prototype.indexOf = function(e1, t, r) {
        return ge(this, e1, t, r, !0);
    }, oe.prototype.lastIndexOf = function(e1, t, r) {
        return ge(this, e1, t, r, !1);
    }, oe.prototype.write = function(e1, t, r, n) {
        if (void 0 === t) n = "utf8", r = this.length, t = 0;
        else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;
        else {
            if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            t |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
        }
        var s = this.length - t;
        if ((void 0 === r || r > s) && (r = s), e1.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        n || (n = "utf8");
        for(var i = !1;;)switch(n){
            case "hex":
                return Ee(this, e1, t, r);
            case "utf8":
            case "utf-8":
                return xe(this, e1, t, r);
            case "ascii":
                return Ce(this, e1, t, r);
            case "latin1":
            case "binary":
                return Se(this, e1, t, r);
            case "base64":
                return be(this, e1, t, r);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return ve(this, e1, t, r);
            default:
                if (i) throw new TypeError("Unknown encoding: " + n);
                n = ("" + n).toLowerCase(), i = !0;
        }
    }, oe.prototype.toJSON = function() {
        return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
        };
    };
    var Re = 4096;
    function De(e1, t, r) {
        var n = "";
        r = Math.min(e1.length, r);
        for(var s = t; s < r; ++s)n += String.fromCharCode(127 & e1[s]);
        return n;
    }
    function we(e1, t, r) {
        var n = "";
        r = Math.min(e1.length, r);
        for(var s = t; s < r; ++s)n += String.fromCharCode(e1[s]);
        return n;
    }
    function _e(e1, t, r) {
        var n = e1.length;
        (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);
        for(var s = "", i = t; i < r; ++i)s += je(e1[i]);
        return s;
    }
    function ke(e1, t, r) {
        for(var n = e1.slice(t, r), s = "", i = 0; i < n.length; i += 2)s += String.fromCharCode(n[i] + 256 * n[i + 1]);
        return s;
    }
    function Be(e1, t, r) {
        if (e1 % 1 != 0 || e1 < 0) throw new RangeError("offset is not uint");
        if (e1 + t > r) throw new RangeError("Trying to access beyond buffer length");
    }
    function Le(e1, t, r, n, s, i) {
        if (!fe(e1)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (t > s || t < i) throw new RangeError('"value" argument is out of bounds');
        if (r + n > e1.length) throw new RangeError("Index out of range");
    }
    function Pe(e1, t, r, n) {
        t < 0 && (t = 65535 + t + 1);
        for(var s = 0, i = Math.min(e1.length - r, 2); s < i; ++s)e1[r + s] = (t & 255 << 8 * (n ? s : 1 - s)) >>> 8 * (n ? s : 1 - s);
    }
    function Ie(e1, t, r, n) {
        t < 0 && (t = 4294967295 + t + 1);
        for(var s = 0, i = Math.min(e1.length - r, 4); s < i; ++s)e1[r + s] = t >>> 8 * (n ? s : 3 - s) & 255;
    }
    function Fe(e1, t, r, n, s, i) {
        if (r + n > e1.length) throw new RangeError("Index out of range");
        if (r < 0) throw new RangeError("Index out of range");
    }
    function Ne(e1, t, r, n, s) {
        return s || Fe(e1, 0, r, 4), te(e1, t, r, n, 23, 4), r + 4;
    }
    function Oe(e1, t, r, n, s) {
        return s || Fe(e1, 0, r, 8), te(e1, t, r, n, 52, 8), r + 8;
    }
    oe.prototype.slice = function(e1, t) {
        var r, n = this.length;
        if ((e1 = ~~e1) < 0 ? (e1 += n) < 0 && (e1 = 0) : e1 > n && (e1 = n), (t = void 0 === t ? n : ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), t < e1 && (t = e1), oe.TYPED_ARRAY_SUPPORT) (r = this.subarray(e1, t)).__proto__ = oe.prototype;
        else {
            var s = t - e1;
            r = new oe(s, void 0);
            for(var i = 0; i < s; ++i)r[i] = this[i + e1];
        }
        return r;
    }, oe.prototype.readUIntLE = function(e1, t, r) {
        e1 |= 0, t |= 0, r || Be(e1, t, this.length);
        for(var n = this[e1], s = 1, i = 0; ++i < t && (s *= 256);)n += this[e1 + i] * s;
        return n;
    }, oe.prototype.readUIntBE = function(e1, t, r) {
        e1 |= 0, t |= 0, r || Be(e1, t, this.length);
        for(var n = this[e1 + --t], s = 1; t > 0 && (s *= 256);)n += this[e1 + --t] * s;
        return n;
    }, oe.prototype.readUInt8 = function(e1, t) {
        return t || Be(e1, 1, this.length), this[e1];
    }, oe.prototype.readUInt16LE = function(e1, t) {
        return t || Be(e1, 2, this.length), this[e1] | this[e1 + 1] << 8;
    }, oe.prototype.readUInt16BE = function(e1, t) {
        return t || Be(e1, 2, this.length), this[e1] << 8 | this[e1 + 1];
    }, oe.prototype.readUInt32LE = function(e1, t) {
        return t || Be(e1, 4, this.length), (this[e1] | this[e1 + 1] << 8 | this[e1 + 2] << 16) + 16777216 * this[e1 + 3];
    }, oe.prototype.readUInt32BE = function(e1, t) {
        return t || Be(e1, 4, this.length), 16777216 * this[e1] + (this[e1 + 1] << 16 | this[e1 + 2] << 8 | this[e1 + 3]);
    }, oe.prototype.readIntLE = function(e1, t, r) {
        e1 |= 0, t |= 0, r || Be(e1, t, this.length);
        for(var n = this[e1], s = 1, i = 0; ++i < t && (s *= 256);)n += this[e1 + i] * s;
        return n >= (s *= 128) && (n -= Math.pow(2, 8 * t)), n;
    }, oe.prototype.readIntBE = function(e1, t, r) {
        e1 |= 0, t |= 0, r || Be(e1, t, this.length);
        for(var n = t, s = 1, i = this[e1 + --n]; n > 0 && (s *= 256);)i += this[e1 + --n] * s;
        return i >= (s *= 128) && (i -= Math.pow(2, 8 * t)), i;
    }, oe.prototype.readInt8 = function(e1, t) {
        return t || Be(e1, 1, this.length), 128 & this[e1] ? -1 * (255 - this[e1] + 1) : this[e1];
    }, oe.prototype.readInt16LE = function(e1, t) {
        t || Be(e1, 2, this.length);
        var r = this[e1] | this[e1 + 1] << 8;
        return 32768 & r ? 4294901760 | r : r;
    }, oe.prototype.readInt16BE = function(e1, t) {
        t || Be(e1, 2, this.length);
        var r = this[e1 + 1] | this[e1] << 8;
        return 32768 & r ? 4294901760 | r : r;
    }, oe.prototype.readInt32LE = function(e1, t) {
        return t || Be(e1, 4, this.length), this[e1] | this[e1 + 1] << 8 | this[e1 + 2] << 16 | this[e1 + 3] << 24;
    }, oe.prototype.readInt32BE = function(e1, t) {
        return t || Be(e1, 4, this.length), this[e1] << 24 | this[e1 + 1] << 16 | this[e1 + 2] << 8 | this[e1 + 3];
    }, oe.prototype.readFloatLE = function(e1, t) {
        return t || Be(e1, 4, this.length), ee(this, e1, !0, 23, 4);
    }, oe.prototype.readFloatBE = function(e1, t) {
        return t || Be(e1, 4, this.length), ee(this, e1, !1, 23, 4);
    }, oe.prototype.readDoubleLE = function(e1, t) {
        return t || Be(e1, 8, this.length), ee(this, e1, !0, 52, 8);
    }, oe.prototype.readDoubleBE = function(e1, t) {
        return t || Be(e1, 8, this.length), ee(this, e1, !1, 52, 8);
    }, oe.prototype.writeUIntLE = function(e1, t, r, n) {
        (e1 = +e1, t |= 0, r |= 0, n) || Le(this, e1, t, r, Math.pow(2, 8 * r) - 1, 0);
        var s = 1, i = 0;
        for(this[t] = 255 & e1; ++i < r && (s *= 256);)this[t + i] = e1 / s & 255;
        return t + r;
    }, oe.prototype.writeUIntBE = function(e1, t, r, n) {
        (e1 = +e1, t |= 0, r |= 0, n) || Le(this, e1, t, r, Math.pow(2, 8 * r) - 1, 0);
        var s = r - 1, i = 1;
        for(this[t + s] = 255 & e1; --s >= 0 && (i *= 256);)this[t + s] = e1 / i & 255;
        return t + r;
    }, oe.prototype.writeUInt8 = function(e1, t, r) {
        return e1 = +e1, t |= 0, r || Le(this, e1, t, 1, 255, 0), oe.TYPED_ARRAY_SUPPORT || (e1 = Math.floor(e1)), this[t] = 255 & e1, t + 1;
    }, oe.prototype.writeUInt16LE = function(e1, t, r) {
        return e1 = +e1, t |= 0, r || Le(this, e1, t, 2, 65535, 0), oe.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e1, this[t + 1] = e1 >>> 8) : Pe(this, e1, t, !0), t + 2;
    }, oe.prototype.writeUInt16BE = function(e1, t, r) {
        return e1 = +e1, t |= 0, r || Le(this, e1, t, 2, 65535, 0), oe.TYPED_ARRAY_SUPPORT ? (this[t] = e1 >>> 8, this[t + 1] = 255 & e1) : Pe(this, e1, t, !1), t + 2;
    }, oe.prototype.writeUInt32LE = function(e1, t, r) {
        return e1 = +e1, t |= 0, r || Le(this, e1, t, 4, 4294967295, 0), oe.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e1 >>> 24, this[t + 2] = e1 >>> 16, this[t + 1] = e1 >>> 8, this[t] = 255 & e1) : Ie(this, e1, t, !0), t + 4;
    }, oe.prototype.writeUInt32BE = function(e1, t, r) {
        return e1 = +e1, t |= 0, r || Le(this, e1, t, 4, 4294967295, 0), oe.TYPED_ARRAY_SUPPORT ? (this[t] = e1 >>> 24, this[t + 1] = e1 >>> 16, this[t + 2] = e1 >>> 8, this[t + 3] = 255 & e1) : Ie(this, e1, t, !1), t + 4;
    }, oe.prototype.writeIntLE = function(e1, t, r, n) {
        if (e1 = +e1, t |= 0, !n) {
            var s = Math.pow(2, 8 * r - 1);
            Le(this, e1, t, r, s - 1, -s);
        }
        var i = 0, o = 1, a = 0;
        for(this[t] = 255 & e1; ++i < r && (o *= 256);)e1 < 0 && 0 === a && 0 !== this[t + i - 1] && (a = 1), this[t + i] = (e1 / o | 0) - a & 255;
        return t + r;
    }, oe.prototype.writeIntBE = function(e1, t, r, n) {
        if (e1 = +e1, t |= 0, !n) {
            var s = Math.pow(2, 8 * r - 1);
            Le(this, e1, t, r, s - 1, -s);
        }
        var i = r - 1, o = 1, a = 0;
        for(this[t + i] = 255 & e1; --i >= 0 && (o *= 256);)e1 < 0 && 0 === a && 0 !== this[t + i + 1] && (a = 1), this[t + i] = (e1 / o | 0) - a & 255;
        return t + r;
    }, oe.prototype.writeInt8 = function(e1, t, r) {
        return e1 = +e1, t |= 0, r || Le(this, e1, t, 1, 127, -128), oe.TYPED_ARRAY_SUPPORT || (e1 = Math.floor(e1)), e1 < 0 && (e1 = 255 + e1 + 1), this[t] = 255 & e1, t + 1;
    }, oe.prototype.writeInt16LE = function(e1, t, r) {
        return e1 = +e1, t |= 0, r || Le(this, e1, t, 2, 32767, -32768), oe.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e1, this[t + 1] = e1 >>> 8) : Pe(this, e1, t, !0), t + 2;
    }, oe.prototype.writeInt16BE = function(e1, t, r) {
        return e1 = +e1, t |= 0, r || Le(this, e1, t, 2, 32767, -32768), oe.TYPED_ARRAY_SUPPORT ? (this[t] = e1 >>> 8, this[t + 1] = 255 & e1) : Pe(this, e1, t, !1), t + 2;
    }, oe.prototype.writeInt32LE = function(e1, t, r) {
        return e1 = +e1, t |= 0, r || Le(this, e1, t, 4, 2147483647, -2147483648), oe.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e1, this[t + 1] = e1 >>> 8, this[t + 2] = e1 >>> 16, this[t + 3] = e1 >>> 24) : Ie(this, e1, t, !0), t + 4;
    }, oe.prototype.writeInt32BE = function(e1, t, r) {
        return e1 = +e1, t |= 0, r || Le(this, e1, t, 4, 2147483647, -2147483648), e1 < 0 && (e1 = 4294967295 + e1 + 1), oe.TYPED_ARRAY_SUPPORT ? (this[t] = e1 >>> 24, this[t + 1] = e1 >>> 16, this[t + 2] = e1 >>> 8, this[t + 3] = 255 & e1) : Ie(this, e1, t, !1), t + 4;
    }, oe.prototype.writeFloatLE = function(e1, t, r) {
        return Ne(this, e1, t, !0, r);
    }, oe.prototype.writeFloatBE = function(e1, t, r) {
        return Ne(this, e1, t, !1, r);
    }, oe.prototype.writeDoubleLE = function(e1, t, r) {
        return Oe(this, e1, t, !0, r);
    }, oe.prototype.writeDoubleBE = function(e1, t, r) {
        return Oe(this, e1, t, !1, r);
    }, oe.prototype.copy = function(e1, t, r, n) {
        if (r || (r = 0), n || 0 === n || (n = this.length), t >= e1.length && (t = e1.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
        if (0 === e1.length || 0 === this.length) return 0;
        if (t < 0) throw new RangeError("targetStart out of bounds");
        if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
        if (n < 0) throw new RangeError("sourceEnd out of bounds");
        n > this.length && (n = this.length), e1.length - t < n - r && (n = e1.length - t + r);
        var s, i = n - r;
        if (this === e1 && r < t && t < n) for(s = i - 1; s >= 0; --s)e1[s + t] = this[s + r];
        else if (i < 1e3 || !oe.TYPED_ARRAY_SUPPORT) for(s = 0; s < i; ++s)e1[s + t] = this[s + r];
        else Uint8Array.prototype.set.call(e1, this.subarray(r, r + i), t);
        return i;
    }, oe.prototype.fill = function(e1, t, r, n) {
        if ("string" == typeof e1) {
            if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === e1.length) {
                var s = e1.charCodeAt(0);
                s < 256 && (e1 = s);
            }
            if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
            if ("string" == typeof n && !oe.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
        } else "number" == typeof e1 && (e1 &= 255);
        if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
        if (r <= t) return this;
        var i;
        if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e1 || (e1 = 0), "number" == typeof e1) for(i = t; i < r; ++i)this[i] = e1;
        else {
            var o = fe(e1) ? e1 : Ve(new oe(e1, n).toString()), a = o.length;
            for(i = 0; i < r - t; ++i)this[i + t] = o[i % a];
        }
        return this;
    };
    var Ue = /[^+\/0-9A-Za-z-_]/g;
    function je(e1) {
        return e1 < 16 ? "0" + e1.toString(16) : e1.toString(16);
    }
    function Ve(e1, t) {
        var r;
        t = t || 1 / 0;
        for(var n = e1.length, s = null, i = [], o = 0; o < n; ++o){
            if ((r = e1.charCodeAt(o)) > 55295 && r < 57344) {
                if (!s) {
                    if (r > 56319) {
                        (t -= 3) > -1 && i.push(239, 191, 189);
                        continue;
                    }
                    if (o + 1 === n) {
                        (t -= 3) > -1 && i.push(239, 191, 189);
                        continue;
                    }
                    s = r;
                    continue;
                }
                if (r < 56320) {
                    (t -= 3) > -1 && i.push(239, 191, 189), s = r;
                    continue;
                }
                r = 65536 + (s - 55296 << 10 | r - 56320);
            } else s && (t -= 3) > -1 && i.push(239, 191, 189);
            if (s = null, r < 128) {
                if ((t -= 1) < 0) break;
                i.push(r);
            } else if (r < 2048) {
                if ((t -= 2) < 0) break;
                i.push(r >> 6 | 192, 63 & r | 128);
            } else if (r < 65536) {
                if ((t -= 3) < 0) break;
                i.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
            } else {
                if (!(r < 1114112)) throw new Error("Invalid code point");
                if ((t -= 4) < 0) break;
                i.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
            }
        }
        return i;
    }
    function Ke(e1) {
        return function(e1) {
            var t, r, n, s, i, o;
            J || Q();
            var a = e1.length;
            if (a % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
            i = "=" === e1[a - 2] ? 2 : "=" === e1[a - 1] ? 1 : 0, o = new H(3 * a / 4 - i), n = i > 0 ? a - 4 : a;
            var u = 0;
            for(t = 0, r = 0; t < n; t += 4, r += 3)s = z[e1.charCodeAt(t)] << 18 | z[e1.charCodeAt(t + 1)] << 12 | z[e1.charCodeAt(t + 2)] << 6 | z[e1.charCodeAt(t + 3)], o[u++] = s >> 16 & 255, o[u++] = s >> 8 & 255, o[u++] = 255 & s;
            return 2 === i ? (s = z[e1.charCodeAt(t)] << 2 | z[e1.charCodeAt(t + 1)] >> 4, o[u++] = 255 & s) : 1 === i && (s = z[e1.charCodeAt(t)] << 10 | z[e1.charCodeAt(t + 1)] << 4 | z[e1.charCodeAt(t + 2)] >> 2, o[u++] = s >> 8 & 255, o[u++] = 255 & s), o;
        }(function(e1) {
            if ((e1 = (function(e1) {
                return e1.trim ? e1.trim() : e1.replace(/^\s+|\s+$/g, "");
            })(e1).replace(Ue, "")).length < 2) return "";
            for(; e1.length % 4 != 0;)e1 += "=";
            return e1;
        }(e1));
    }
    function Me(e1, t, r, n) {
        for(var s = 0; s < n && !(s + r >= t.length || s >= e1.length); ++s)t[s + r] = e1[s];
        return s;
    }
    function $e(e1) {
        return null != e1 && (!!e1._isBuffer || qe(e1) || function(e1) {
            return "function" == typeof e1.readFloatLE && "function" == typeof e1.slice && qe(e1.slice(0, 0));
        }(e1));
    }
    function qe(e1) {
        return !!e1.constructor && "function" == typeof e1.constructor.isBuffer && e1.constructor.isBuffer(e1);
    }
    var Ge = "function" == typeof Object.create ? function(e1, t) {
        e1.super_ = t, e1.prototype = Object.create(t.prototype, {
            constructor: {
                value: e1,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        });
    } : function(e1, t) {
        e1.super_ = t;
        var r = function() {};
        r.prototype = t.prototype, e1.prototype = new r, e1.prototype.constructor = e1;
    }, We = /%[sdj%]/g;
    function Xe(e1) {
        if (!lt(e1)) {
            for(var t = [], r = 0; r < arguments.length; r++)t.push(Ye(arguments[r]));
            return t.join(" ");
        }
        r = 1;
        for(var n = arguments, s = n.length, i = String(e1).replace(We, function(e1) {
            if ("%%" === e1) return "%";
            if (r >= s) return e1;
            switch(e1){
                case "%s":
                    return String(n[r++]);
                case "%d":
                    return Number(n[r++]);
                case "%j":
                    try {
                        return JSON.stringify(n[r++]);
                    } catch (e1) {
                        return "[Circular]";
                    }
                default:
                    return e1;
            }
        }), o = n[r]; r < s; o = n[++r])ot(o) || !dt(o) ? i += " " + o : i += " " + Ye(o);
        return i;
    }
    function ze(e1, t) {
        if (pt(o.process)) return function() {
            return ze(e1, t).apply(this, arguments);
        };
        if (!0 === k.noDeprecation) return e1;
        var r = !1;
        return function() {
            if (!r) {
                if (k.throwDeprecation) throw new Error(t);
                k.traceDeprecation ? console.trace(t) : console.error(t), r = !0;
            }
            return e1.apply(this, arguments);
        };
    }
    var He, Je = {};
    function Qe(e1) {
        if (pt(He) && (He = k.env.NODE_DEBUG || ""), e1 = e1.toUpperCase(), !Je[e1]) {
            if (new RegExp("\\b" + e1 + "\\b", "i").test(He)) Je[e1] = function() {
                var t = Xe.apply(null, arguments);
                console.error("%s %d: %s", e1, 0, t);
            };
            else Je[e1] = function() {};
        }
        return Je[e1];
    }
    function Ye(e1, t) {
        var r = {
            seen: [],
            stylize: et
        };
        return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), it(t) ? r.showHidden = t : t && vt(r, t), pt(r.showHidden) && (r.showHidden = !1), pt(r.depth) && (r.depth = 2), pt(r.colors) && (r.colors = !1), pt(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = Ze), tt(r, e1, r.depth);
    }
    function Ze(e1, t) {
        var r = Ye.styles[t];
        return r ? "[" + Ye.colors[r][0] + "m" + e1 + "[" + Ye.colors[r][1] + "m" : e1;
    }
    function et(e1, t) {
        return e1;
    }
    function tt(e1, t, r) {
        if (e1.customInspect && t && gt(t.inspect) && t.inspect !== Ye && (!t.constructor || t.constructor.prototype !== t)) {
            var n = t.inspect(r, e1);
            return lt(n) || (n = tt(e1, n, r)), n;
        }
        var s = function(e1, t) {
            if (pt(t)) return e1.stylize("undefined", "undefined");
            if (lt(t)) {
                var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                return e1.stylize(r, "string");
            }
            if (ut(t)) return e1.stylize("" + t, "number");
            if (it(t)) return e1.stylize("" + t, "boolean");
            if (ot(t)) return e1.stylize("null", "null");
        }(e1, t);
        if (s) return s;
        var i = Object.keys(t), o = function(e1) {
            var t = {};
            return e1.forEach(function(e1, r) {
                t[e1] = !0;
            }), t;
        }(i);
        if (e1.showHidden && (i = Object.getOwnPropertyNames(t)), mt(t) && (i.indexOf("message") >= 0 || i.indexOf("description") >= 0)) return rt(t);
        if (0 === i.length) {
            if (gt(t)) {
                var a = t.name ? ": " + t.name : "";
                return e1.stylize("[Function" + a + "]", "special");
            }
            if (ft(t)) return e1.stylize(RegExp.prototype.toString.call(t), "regexp");
            if (ht(t)) return e1.stylize(Date.prototype.toString.call(t), "date");
            if (mt(t)) return rt(t);
        }
        var u, l = "", c = !1, p = [
            "{",
            "}"
        ];
        (st(t) && (c = !0, p = [
            "[",
            "]"
        ]), gt(t)) && (l = " [Function" + (t.name ? ": " + t.name : "") + "]");
        return ft(t) && (l = " " + RegExp.prototype.toString.call(t)), ht(t) && (l = " " + Date.prototype.toUTCString.call(t)), mt(t) && (l = " " + rt(t)), 0 !== i.length || c && 0 != t.length ? r < 0 ? ft(t) ? e1.stylize(RegExp.prototype.toString.call(t), "regexp") : e1.stylize("[Object]", "special") : (e1.seen.push(t), u = c ? function(e1, t, r, n, s) {
            for(var i = [], o = 0, a = t.length; o < a; ++o)At(t, String(o)) ? i.push(nt(e1, t, r, n, String(o), !0)) : i.push("");
            return s.forEach(function(s) {
                s.match(/^\d+$/) || i.push(nt(e1, t, r, n, s, !0));
            }), i;
        }(e1, t, r, o, i) : i.map(function(n) {
            return nt(e1, t, r, o, n, c);
        }), e1.seen.pop(), function(e1, t, r) {
            var n = e1.reduce(function(e1, t) {
                return t.indexOf("\n"), e1 + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
            }, 0);
            if (n > 60) return r[0] + ("" === t ? "" : t + "\n ") + " " + e1.join(",\n  ") + " " + r[1];
            return r[0] + t + " " + e1.join(", ") + " " + r[1];
        }(u, l, p)) : p[0] + l + p[1];
    }
    function rt(e1) {
        return "[" + Error.prototype.toString.call(e1) + "]";
    }
    function nt(e1, t, r, n, s, i) {
        var o, a, u;
        if ((u = Object.getOwnPropertyDescriptor(t, s) || {
            value: t[s]
        }).get ? a = u.set ? e1.stylize("[Getter/Setter]", "special") : e1.stylize("[Getter]", "special") : u.set && (a = e1.stylize("[Setter]", "special")), At(n, s) || (o = "[" + s + "]"), a || (e1.seen.indexOf(u.value) < 0 ? (a = ot(r) ? tt(e1, u.value, null) : tt(e1, u.value, r - 1)).indexOf("\n") > -1 && (a = i ? a.split("\n").map(function(e1) {
            return "  " + e1;
        }).join("\n").substr(2) : "\n" + a.split("\n").map(function(e1) {
            return "   " + e1;
        }).join("\n")) : a = e1.stylize("[Circular]", "special")), pt(o)) {
            if (i && s.match(/^\d+$/)) return a;
            (o = JSON.stringify("" + s)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = e1.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = e1.stylize(o, "string"));
        }
        return o + ": " + a;
    }
    function st(e1) {
        return Array.isArray(e1);
    }
    function it(e1) {
        return "boolean" == typeof e1;
    }
    function ot(e1) {
        return null === e1;
    }
    function at(e1) {
        return null == e1;
    }
    function ut(e1) {
        return "number" == typeof e1;
    }
    function lt(e1) {
        return "string" == typeof e1;
    }
    function ct(e1) {
        return "symbol" == typeof e1;
    }
    function pt(e1) {
        return void 0 === e1;
    }
    function ft(e1) {
        return dt(e1) && "[object RegExp]" === xt(e1);
    }
    function dt(e1) {
        return "object" == typeof e1 && null !== e1;
    }
    function ht(e1) {
        return dt(e1) && "[object Date]" === xt(e1);
    }
    function mt(e1) {
        return dt(e1) && ("[object Error]" === xt(e1) || e1 instanceof Error);
    }
    function gt(e1) {
        return "function" == typeof e1;
    }
    function yt(e1) {
        return null === e1 || "boolean" == typeof e1 || "number" == typeof e1 || "string" == typeof e1 || "symbol" == typeof e1 || void 0 === e1;
    }
    function Et(e1) {
        return oe.isBuffer(e1);
    }
    function xt(e1) {
        return Object.prototype.toString.call(e1);
    }
    function Ct(e1) {
        return e1 < 10 ? "0" + e1.toString(10) : e1.toString(10);
    }
    Ye.colors = {
        bold: [
            1,
            22
        ],
        italic: [
            3,
            23
        ],
        underline: [
            4,
            24
        ],
        inverse: [
            7,
            27
        ],
        white: [
            37,
            39
        ],
        grey: [
            90,
            39
        ],
        black: [
            30,
            39
        ],
        blue: [
            34,
            39
        ],
        cyan: [
            36,
            39
        ],
        green: [
            32,
            39
        ],
        magenta: [
            35,
            39
        ],
        red: [
            31,
            39
        ],
        yellow: [
            33,
            39
        ]
    }, Ye.styles = {
        special: "cyan",
        number: "yellow",
        boolean: "yellow",
        undefined: "grey",
        null: "bold",
        string: "green",
        date: "magenta",
        regexp: "red"
    };
    var St = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    function bt() {
        console.log("%s - %s", function() {
            var e1 = new Date, t = [
                Ct(e1.getHours()),
                Ct(e1.getMinutes()),
                Ct(e1.getSeconds())
            ].join(":");
            return [
                e1.getDate(),
                St[e1.getMonth()],
                t
            ].join(" ");
        }(), Xe.apply(null, arguments));
    }
    function vt(e1, t) {
        if (!t || !dt(t)) return e1;
        for(var r = Object.keys(t), n = r.length; n--;)e1[r[n]] = t[r[n]];
        return e1;
    }
    function At(e1, t) {
        return Object.prototype.hasOwnProperty.call(e1, t);
    }
    var Tt = {
        inherits: Ge,
        _extend: vt,
        log: bt,
        isBuffer: Et,
        isPrimitive: yt,
        isFunction: gt,
        isError: mt,
        isDate: ht,
        isObject: dt,
        isRegExp: ft,
        isUndefined: pt,
        isSymbol: ct,
        isString: lt,
        isNumber: ut,
        isNullOrUndefined: at,
        isNull: ot,
        isBoolean: it,
        isArray: st,
        inspect: Ye,
        deprecate: ze,
        format: Xe,
        debuglog: Qe
    }, Rt = Object.freeze({
        __proto__: null,
        _extend: vt,
        debuglog: Qe,
        default: Tt,
        deprecate: ze,
        format: Xe,
        inherits: Ge,
        inspect: Ye,
        isArray: st,
        isBoolean: it,
        isBuffer: Et,
        isDate: ht,
        isError: mt,
        isFunction: gt,
        isNull: ot,
        isNullOrUndefined: at,
        isNumber: ut,
        isObject: dt,
        isPrimitive: yt,
        isRegExp: ft,
        isString: lt,
        isSymbol: ct,
        isUndefined: pt,
        log: bt
    });
    function Dt(e1, t) {
        if (e1 === t) return 0;
        for(var r = e1.length, n = t.length, s = 0, i = Math.min(r, n); s < i; ++s)if (e1[s] !== t[s]) {
            r = e1[s], n = t[s];
            break;
        }
        return r < n ? -1 : n < r ? 1 : 0;
    }
    var wt, _t = Object.prototype.hasOwnProperty, kt = Object.keys || function(e1) {
        var t = [];
        for(var r in e1)_t.call(e1, r) && t.push(r);
        return t;
    }, Bt = Array.prototype.slice;
    function Lt() {
        return void 0 !== wt ? wt : wt = "foo" === (function() {}).name;
    }
    function Pt(e1) {
        return Object.prototype.toString.call(e1);
    }
    function It(e1) {
        return !$e(e1) && "function" == typeof o.ArrayBuffer && ("function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(e1) : !!e1 && (e1 instanceof DataView || !!(e1.buffer && e1.buffer instanceof ArrayBuffer)));
    }
    function Ft(e1, t) {
        e1 || Kt(e1, !0, t, "==", Mt);
    }
    var Nt = /\s*function\s+([^\(\s]*)\s*/;
    function Ot(e1) {
        if (gt(e1)) {
            if (Lt()) return e1.name;
            var t = e1.toString().match(Nt);
            return t && t[1];
        }
    }
    function Ut(e1) {
        this.name = "AssertionError", this.actual = e1.actual, this.expected = e1.expected, this.operator = e1.operator, e1.message ? (this.message = e1.message, this.generatedMessage = !1) : (this.message = function(e1) {
            return jt(Vt(e1.actual), 128) + " " + e1.operator + " " + jt(Vt(e1.expected), 128);
        }(this), this.generatedMessage = !0);
        var t = e1.stackStartFunction || Kt;
        if (Error.captureStackTrace) Error.captureStackTrace(this, t);
        else {
            var r = new Error;
            if (r.stack) {
                var n = r.stack, s = Ot(t), i = n.indexOf("\n" + s);
                if (i >= 0) {
                    var o = n.indexOf("\n", i + 1);
                    n = n.substring(o + 1);
                }
                this.stack = n;
            }
        }
    }
    function jt(e1, t) {
        return "string" == typeof e1 ? e1.length < t ? e1 : e1.slice(0, t) : e1;
    }
    function Vt(e1) {
        if (Lt() || !gt(e1)) return Ye(e1);
        var t = Ot(e1);
        return "[Function" + (t ? ": " + t : "") + "]";
    }
    function Kt(e1, t, r, n, s) {
        throw new Ut({
            message: r,
            actual: e1,
            expected: t,
            operator: n,
            stackStartFunction: s
        });
    }
    function Mt(e1, t) {
        e1 || Kt(e1, !0, t, "==", Mt);
    }
    function $t(e1, t, r) {
        e1 != t && Kt(e1, t, r, "==", $t);
    }
    function qt(e1, t, r) {
        e1 == t && Kt(e1, t, r, "!=", qt);
    }
    function Gt(e1, t, r) {
        Xt(e1, t, !1) || Kt(e1, t, r, "deepEqual", Gt);
    }
    function Wt(e1, t, r) {
        Xt(e1, t, !0) || Kt(e1, t, r, "deepStrictEqual", Wt);
    }
    function Xt(e1, t, r, n) {
        if (e1 === t) return !0;
        if ($e(e1) && $e(t)) return 0 === Dt(e1, t);
        if (ht(e1) && ht(t)) return e1.getTime() === t.getTime();
        if (ft(e1) && ft(t)) return e1.source === t.source && e1.global === t.global && e1.multiline === t.multiline && e1.lastIndex === t.lastIndex && e1.ignoreCase === t.ignoreCase;
        if (null !== e1 && "object" == typeof e1 || null !== t && "object" == typeof t) {
            if (It(e1) && It(t) && Pt(e1) === Pt(t) && !(e1 instanceof Float32Array || e1 instanceof Float64Array)) return 0 === Dt(new Uint8Array(e1.buffer), new Uint8Array(t.buffer));
            if ($e(e1) !== $e(t)) return !1;
            var s = (n = n || {
                actual: [],
                expected: []
            }).actual.indexOf(e1);
            return -1 !== s && s === n.expected.indexOf(t) || (n.actual.push(e1), n.expected.push(t), function(e1, t, r, n) {
                if (null == e1 || null == t) return !1;
                if (yt(e1) || yt(t)) return e1 === t;
                if (r && Object.getPrototypeOf(e1) !== Object.getPrototypeOf(t)) return !1;
                var s = zt(e1), i = zt(t);
                if (s && !i || !s && i) return !1;
                if (s) return Xt(e1 = Bt.call(e1), t = Bt.call(t), r);
                var o, a, u = kt(e1), l = kt(t);
                if (u.length !== l.length) return !1;
                for(u.sort(), l.sort(), a = u.length - 1; a >= 0; a--)if (u[a] !== l[a]) return !1;
                for(a = u.length - 1; a >= 0; a--)if (!Xt(e1[o = u[a]], t[o], r, n)) return !1;
                return !0;
            }(e1, t, r, n));
        }
        return r ? e1 === t : e1 == t;
    }
    function zt(e1) {
        return "[object Arguments]" == Object.prototype.toString.call(e1);
    }
    function Ht(e1, t, r) {
        Xt(e1, t, !1) && Kt(e1, t, r, "notDeepEqual", Ht);
    }
    function Jt(e1, t, r) {
        Xt(e1, t, !0) && Kt(e1, t, r, "notDeepStrictEqual", Jt);
    }
    function Qt(e1, t, r) {
        e1 !== t && Kt(e1, t, r, "===", Qt);
    }
    function Yt(e1, t, r) {
        e1 === t && Kt(e1, t, r, "!==", Yt);
    }
    function Zt(e1, t) {
        if (!e1 || !t) return !1;
        if ("[object RegExp]" == Object.prototype.toString.call(t)) return t.test(e1);
        try {
            if (e1 instanceof t) return !0;
        } catch (e1) {}
        return !Error.isPrototypeOf(t) && !0 === t.call({}, e1);
    }
    function er(e1, t, r, n) {
        var s;
        if ("function" != typeof t) throw new TypeError('"block" argument must be a function');
        "string" == typeof r && (n = r, r = null), s = function(e1) {
            var t;
            try {
                e1();
            } catch (e1) {
                t = e1;
            }
            return t;
        }(t), n = (r && r.name ? " (" + r.name + ")." : ".") + (n ? " " + n : "."), e1 && !s && Kt(s, r, "Missing expected exception" + n);
        var i = "string" == typeof n, o = !e1 && s && !r;
        if ((!e1 && mt(s) && i && Zt(s, r) || o) && Kt(s, r, "Got unwanted exception" + n), e1 && s && r && !Zt(s, r) || !e1 && s) throw s;
    }
    function tr(e1, t, r) {
        er(!0, e1, t, r);
    }
    function rr(e1, t, r) {
        er(!1, e1, t, r);
    }
    function nr(e1) {
        if (e1) throw e1;
    }
    Ft.AssertionError = Ut, Ge(Ut, Error), Ft.fail = Kt, Ft.ok = Mt, Ft.equal = $t, Ft.notEqual = qt, Ft.deepEqual = Gt, Ft.deepStrictEqual = Wt, Ft.notDeepEqual = Ht, Ft.notDeepStrictEqual = Jt, Ft.strictEqual = Qt, Ft.notStrictEqual = Yt, Ft.throws = tr, Ft.doesNotThrow = rr, Ft.ifError = nr;
    var sr, ir = t(Object.freeze({
        __proto__: null,
        AssertionError: Ut,
        assert: Mt,
        deepEqual: Gt,
        deepStrictEqual: Wt,
        default: Ft,
        doesNotThrow: rr,
        equal: $t,
        fail: Kt,
        ifError: nr,
        notDeepEqual: Ht,
        notDeepStrictEqual: Jt,
        notEqual: qt,
        notStrictEqual: Yt,
        ok: Mt,
        strictEqual: Qt,
        throws: tr
    })), or = {};
    function ar() {
        return sr || (sr = 1, function(e1) {
            !function e1(t) {
                var r, n, s, i, o, a;
                function u(e1) {
                    var t, r, n = {};
                    for(t in e1)e1.hasOwnProperty(t) && (r = e1[t], n[t] = "object" == typeof r && null !== r ? u(r) : r);
                    return n;
                }
                function l(e1, t) {
                    this.parent = e1, this.key = t;
                }
                function c(e1, t, r, n) {
                    this.node = e1, this.path = t, this.wrap = r, this.ref = n;
                }
                function p() {}
                function f(e1) {
                    return null != e1 && "object" == typeof e1 && "string" == typeof e1.type;
                }
                function d(e1, t) {
                    return (e1 === r.ObjectExpression || e1 === r.ObjectPattern) && "properties" === t;
                }
                function h(e1, t) {
                    for(var r = e1.length - 1; r >= 0; --r)if (e1[r].node === t) return !0;
                    return !1;
                }
                function m(e1, t) {
                    return (new p).traverse(e1, t);
                }
                function g(e1, t) {
                    var r;
                    return r = function(e1, t) {
                        var r, n, s, i;
                        for(n = e1.length, s = 0; n;)t(e1[i = s + (r = n >>> 1)]) ? n = r : (s = i + 1, n -= r + 1);
                        return s;
                    }(t, function(t) {
                        return t.range[0] > e1.range[0];
                    }), e1.extendedRange = [
                        e1.range[0],
                        e1.range[1]
                    ], r !== t.length && (e1.extendedRange[1] = t[r].range[0]), (r -= 1) >= 0 && (e1.extendedRange[0] = t[r].range[1]), e1;
                }
                return r = {
                    AssignmentExpression: "AssignmentExpression",
                    AssignmentPattern: "AssignmentPattern",
                    ArrayExpression: "ArrayExpression",
                    ArrayPattern: "ArrayPattern",
                    ArrowFunctionExpression: "ArrowFunctionExpression",
                    AwaitExpression: "AwaitExpression",
                    BlockStatement: "BlockStatement",
                    BinaryExpression: "BinaryExpression",
                    BreakStatement: "BreakStatement",
                    CallExpression: "CallExpression",
                    CatchClause: "CatchClause",
                    ChainExpression: "ChainExpression",
                    ClassBody: "ClassBody",
                    ClassDeclaration: "ClassDeclaration",
                    ClassExpression: "ClassExpression",
                    ComprehensionBlock: "ComprehensionBlock",
                    ComprehensionExpression: "ComprehensionExpression",
                    ConditionalExpression: "ConditionalExpression",
                    ContinueStatement: "ContinueStatement",
                    DebuggerStatement: "DebuggerStatement",
                    DirectiveStatement: "DirectiveStatement",
                    DoWhileStatement: "DoWhileStatement",
                    EmptyStatement: "EmptyStatement",
                    ExportAllDeclaration: "ExportAllDeclaration",
                    ExportDefaultDeclaration: "ExportDefaultDeclaration",
                    ExportNamedDeclaration: "ExportNamedDeclaration",
                    ExportSpecifier: "ExportSpecifier",
                    ExpressionStatement: "ExpressionStatement",
                    ForStatement: "ForStatement",
                    ForInStatement: "ForInStatement",
                    ForOfStatement: "ForOfStatement",
                    FunctionDeclaration: "FunctionDeclaration",
                    FunctionExpression: "FunctionExpression",
                    GeneratorExpression: "GeneratorExpression",
                    Identifier: "Identifier",
                    IfStatement: "IfStatement",
                    ImportExpression: "ImportExpression",
                    ImportDeclaration: "ImportDeclaration",
                    ImportDefaultSpecifier: "ImportDefaultSpecifier",
                    ImportNamespaceSpecifier: "ImportNamespaceSpecifier",
                    ImportSpecifier: "ImportSpecifier",
                    Literal: "Literal",
                    LabeledStatement: "LabeledStatement",
                    LogicalExpression: "LogicalExpression",
                    MemberExpression: "MemberExpression",
                    MetaProperty: "MetaProperty",
                    MethodDefinition: "MethodDefinition",
                    ModuleSpecifier: "ModuleSpecifier",
                    NewExpression: "NewExpression",
                    ObjectExpression: "ObjectExpression",
                    ObjectPattern: "ObjectPattern",
                    PrivateIdentifier: "PrivateIdentifier",
                    Program: "Program",
                    Property: "Property",
                    PropertyDefinition: "PropertyDefinition",
                    RestElement: "RestElement",
                    ReturnStatement: "ReturnStatement",
                    SequenceExpression: "SequenceExpression",
                    SpreadElement: "SpreadElement",
                    Super: "Super",
                    SwitchStatement: "SwitchStatement",
                    SwitchCase: "SwitchCase",
                    TaggedTemplateExpression: "TaggedTemplateExpression",
                    TemplateElement: "TemplateElement",
                    TemplateLiteral: "TemplateLiteral",
                    ThisExpression: "ThisExpression",
                    ThrowStatement: "ThrowStatement",
                    TryStatement: "TryStatement",
                    UnaryExpression: "UnaryExpression",
                    UpdateExpression: "UpdateExpression",
                    VariableDeclaration: "VariableDeclaration",
                    VariableDeclarator: "VariableDeclarator",
                    WhileStatement: "WhileStatement",
                    WithStatement: "WithStatement",
                    YieldExpression: "YieldExpression"
                }, s = {
                    AssignmentExpression: [
                        "left",
                        "right"
                    ],
                    AssignmentPattern: [
                        "left",
                        "right"
                    ],
                    ArrayExpression: [
                        "elements"
                    ],
                    ArrayPattern: [
                        "elements"
                    ],
                    ArrowFunctionExpression: [
                        "params",
                        "body"
                    ],
                    AwaitExpression: [
                        "argument"
                    ],
                    BlockStatement: [
                        "body"
                    ],
                    BinaryExpression: [
                        "left",
                        "right"
                    ],
                    BreakStatement: [
                        "label"
                    ],
                    CallExpression: [
                        "callee",
                        "arguments"
                    ],
                    CatchClause: [
                        "param",
                        "body"
                    ],
                    ChainExpression: [
                        "expression"
                    ],
                    ClassBody: [
                        "body"
                    ],
                    ClassDeclaration: [
                        "id",
                        "superClass",
                        "body"
                    ],
                    ClassExpression: [
                        "id",
                        "superClass",
                        "body"
                    ],
                    ComprehensionBlock: [
                        "left",
                        "right"
                    ],
                    ComprehensionExpression: [
                        "blocks",
                        "filter",
                        "body"
                    ],
                    ConditionalExpression: [
                        "test",
                        "consequent",
                        "alternate"
                    ],
                    ContinueStatement: [
                        "label"
                    ],
                    DebuggerStatement: [],
                    DirectiveStatement: [],
                    DoWhileStatement: [
                        "body",
                        "test"
                    ],
                    EmptyStatement: [],
                    ExportAllDeclaration: [
                        "source"
                    ],
                    ExportDefaultDeclaration: [
                        "declaration"
                    ],
                    ExportNamedDeclaration: [
                        "declaration",
                        "specifiers",
                        "source"
                    ],
                    ExportSpecifier: [
                        "exported",
                        "local"
                    ],
                    ExpressionStatement: [
                        "expression"
                    ],
                    ForStatement: [
                        "init",
                        "test",
                        "update",
                        "body"
                    ],
                    ForInStatement: [
                        "left",
                        "right",
                        "body"
                    ],
                    ForOfStatement: [
                        "left",
                        "right",
                        "body"
                    ],
                    FunctionDeclaration: [
                        "id",
                        "params",
                        "body"
                    ],
                    FunctionExpression: [
                        "id",
                        "params",
                        "body"
                    ],
                    GeneratorExpression: [
                        "blocks",
                        "filter",
                        "body"
                    ],
                    Identifier: [],
                    IfStatement: [
                        "test",
                        "consequent",
                        "alternate"
                    ],
                    ImportExpression: [
                        "source"
                    ],
                    ImportDeclaration: [
                        "specifiers",
                        "source"
                    ],
                    ImportDefaultSpecifier: [
                        "local"
                    ],
                    ImportNamespaceSpecifier: [
                        "local"
                    ],
                    ImportSpecifier: [
                        "imported",
                        "local"
                    ],
                    Literal: [],
                    LabeledStatement: [
                        "label",
                        "body"
                    ],
                    LogicalExpression: [
                        "left",
                        "right"
                    ],
                    MemberExpression: [
                        "object",
                        "property"
                    ],
                    MetaProperty: [
                        "meta",
                        "property"
                    ],
                    MethodDefinition: [
                        "key",
                        "value"
                    ],
                    ModuleSpecifier: [],
                    NewExpression: [
                        "callee",
                        "arguments"
                    ],
                    ObjectExpression: [
                        "properties"
                    ],
                    ObjectPattern: [
                        "properties"
                    ],
                    PrivateIdentifier: [],
                    Program: [
                        "body"
                    ],
                    Property: [
                        "key",
                        "value"
                    ],
                    PropertyDefinition: [
                        "key",
                        "value"
                    ],
                    RestElement: [
                        "argument"
                    ],
                    ReturnStatement: [
                        "argument"
                    ],
                    SequenceExpression: [
                        "expressions"
                    ],
                    SpreadElement: [
                        "argument"
                    ],
                    Super: [],
                    SwitchStatement: [
                        "discriminant",
                        "cases"
                    ],
                    SwitchCase: [
                        "test",
                        "consequent"
                    ],
                    TaggedTemplateExpression: [
                        "tag",
                        "quasi"
                    ],
                    TemplateElement: [],
                    TemplateLiteral: [
                        "quasis",
                        "expressions"
                    ],
                    ThisExpression: [],
                    ThrowStatement: [
                        "argument"
                    ],
                    TryStatement: [
                        "block",
                        "handler",
                        "finalizer"
                    ],
                    UnaryExpression: [
                        "argument"
                    ],
                    UpdateExpression: [
                        "argument"
                    ],
                    VariableDeclaration: [
                        "declarations"
                    ],
                    VariableDeclarator: [
                        "id",
                        "init"
                    ],
                    WhileStatement: [
                        "test",
                        "body"
                    ],
                    WithStatement: [
                        "object",
                        "body"
                    ],
                    YieldExpression: [
                        "argument"
                    ]
                }, n = {
                    Break: i = {},
                    Skip: o = {},
                    Remove: a = {}
                }, l.prototype.replace = function(e1) {
                    this.parent[this.key] = e1;
                }, l.prototype.remove = function() {
                    return Array.isArray(this.parent) ? (this.parent.splice(this.key, 1), !0) : (this.replace(null), !1);
                }, p.prototype.path = function() {
                    var e1, t, r, n, s;
                    function i(e1, t) {
                        if (Array.isArray(t)) for(r = 0, n = t.length; r < n; ++r)e1.push(t[r]);
                        else e1.push(t);
                    }
                    if (!this.__current.path) return null;
                    for(s = [], e1 = 2, t = this.__leavelist.length; e1 < t; ++e1)i(s, this.__leavelist[e1].path);
                    return i(s, this.__current.path), s;
                }, p.prototype.type = function() {
                    return this.current().type || this.__current.wrap;
                }, p.prototype.parents = function() {
                    var e1, t, r;
                    for(r = [], e1 = 1, t = this.__leavelist.length; e1 < t; ++e1)r.push(this.__leavelist[e1].node);
                    return r;
                }, p.prototype.current = function() {
                    return this.__current.node;
                }, p.prototype.__execute = function(e1, t) {
                    var r, n;
                    return n = void 0, r = this.__current, this.__current = t, this.__state = null, e1 && (n = e1.call(this, t.node, this.__leavelist[this.__leavelist.length - 1].node)), this.__current = r, n;
                }, p.prototype.notify = function(e1) {
                    this.__state = e1;
                }, p.prototype.skip = function() {
                    this.notify(o);
                }, p.prototype.break = function() {
                    this.notify(i);
                }, p.prototype.remove = function() {
                    this.notify(a);
                }, p.prototype.__initialize = function(e1, t) {
                    this.visitor = t, this.root = e1, this.__worklist = [], this.__leavelist = [], this.__current = null, this.__state = null, this.__fallback = null, "iteration" === t.fallback ? this.__fallback = Object.keys : "function" == typeof t.fallback && (this.__fallback = t.fallback), this.__keys = s, t.keys && (this.__keys = Object.assign(Object.create(this.__keys), t.keys));
                }, p.prototype.traverse = function(e1, t) {
                    var r, n, s, a, u, l, p, m, g, y, E, x;
                    for(this.__initialize(e1, t), x = {}, r = this.__worklist, n = this.__leavelist, r.push(new c(e1, null, null, null)), n.push(new c(null, null, null, null)); r.length;)if ((s = r.pop()) !== x) {
                        if (s.node) {
                            if (l = this.__execute(t.enter, s), this.__state === i || l === i) return;
                            if (r.push(x), n.push(s), this.__state === o || l === o) continue;
                            if (u = (a = s.node).type || s.wrap, !(y = this.__keys[u])) {
                                if (!this.__fallback) throw new Error("Unknown node type " + u + ".");
                                y = this.__fallback(a);
                            }
                            for(m = y.length; (m -= 1) >= 0;)if (E = a[p = y[m]]) {
                                if (Array.isArray(E)) {
                                    for(g = E.length; (g -= 1) >= 0;)if (E[g] && !h(n, E[g])) {
                                        if (d(u, y[m])) s = new c(E[g], [
                                            p,
                                            g
                                        ], "Property", null);
                                        else {
                                            if (!f(E[g])) continue;
                                            s = new c(E[g], [
                                                p,
                                                g
                                            ], null, null);
                                        }
                                        r.push(s);
                                    }
                                } else if (f(E)) {
                                    if (h(n, E)) continue;
                                    r.push(new c(E, p, null, null));
                                }
                            }
                        }
                    } else if (s = n.pop(), l = this.__execute(t.leave, s), this.__state === i || l === i) return;
                }, p.prototype.replace = function(e1, t) {
                    var r, n, s, u, p, h, m, g, y, E, x, C, S;
                    function b(e1) {
                        var t, n, s, i;
                        if (e1.ref.remove()) {
                            for(n = e1.ref.key, i = e1.ref.parent, t = r.length; t--;)if ((s = r[t]).ref && s.ref.parent === i) {
                                if (s.ref.key < n) break;
                                --s.ref.key;
                            }
                        }
                    }
                    for(this.__initialize(e1, t), x = {}, r = this.__worklist, n = this.__leavelist, h = new c(e1, null, null, new l(C = {
                        root: e1
                    }, "root")), r.push(h), n.push(h); r.length;)if ((h = r.pop()) !== x) {
                        if (void 0 !== (p = this.__execute(t.enter, h)) && p !== i && p !== o && p !== a && (h.ref.replace(p), h.node = p), this.__state !== a && p !== a || (b(h), h.node = null), this.__state === i || p === i) return C.root;
                        if ((s = h.node) && (r.push(x), n.push(h), this.__state !== o && p !== o)) {
                            if (u = s.type || h.wrap, !(y = this.__keys[u])) {
                                if (!this.__fallback) throw new Error("Unknown node type " + u + ".");
                                y = this.__fallback(s);
                            }
                            for(m = y.length; (m -= 1) >= 0;)if (E = s[S = y[m]]) {
                                if (Array.isArray(E)) {
                                    for(g = E.length; (g -= 1) >= 0;)if (E[g]) {
                                        if (d(u, y[m])) h = new c(E[g], [
                                            S,
                                            g
                                        ], "Property", new l(E, g));
                                        else {
                                            if (!f(E[g])) continue;
                                            h = new c(E[g], [
                                                S,
                                                g
                                            ], null, new l(E, g));
                                        }
                                        r.push(h);
                                    }
                                } else f(E) && r.push(new c(E, S, null, new l(s, S)));
                            }
                        }
                    } else if (h = n.pop(), void 0 !== (p = this.__execute(t.leave, h)) && p !== i && p !== o && p !== a && h.ref.replace(p), this.__state !== a && p !== a || b(h), this.__state === i || p === i) return C.root;
                    return C.root;
                }, t.Syntax = r, t.traverse = m, t.replace = function(e1, t) {
                    return (new p).replace(e1, t);
                }, t.attachComments = function(e1, t, r) {
                    var s, i, o, a, l = [];
                    if (!e1.range) throw new Error("attachComments needs range information");
                    if (!r.length) {
                        if (t.length) {
                            for(o = 0, i = t.length; o < i; o += 1)(s = u(t[o])).extendedRange = [
                                0,
                                e1.range[0]
                            ], l.push(s);
                            e1.leadingComments = l;
                        }
                        return e1;
                    }
                    for(o = 0, i = t.length; o < i; o += 1)l.push(g(u(t[o]), r));
                    return a = 0, m(e1, {
                        enter: function(e1) {
                            for(var t; a < l.length && !((t = l[a]).extendedRange[1] > e1.range[0]);)t.extendedRange[1] === e1.range[0] ? (e1.leadingComments || (e1.leadingComments = []), e1.leadingComments.push(t), l.splice(a, 1)) : a += 1;
                            return a === l.length ? n.Break : l[a].extendedRange[0] > e1.range[1] ? n.Skip : void 0;
                        }
                    }), a = 0, m(e1, {
                        leave: function(e1) {
                            for(var t; a < l.length && (t = l[a], !(e1.range[1] < t.extendedRange[0]));)e1.range[1] === t.extendedRange[0] ? (e1.trailingComments || (e1.trailingComments = []), e1.trailingComments.push(t), l.splice(a, 1)) : a += 1;
                            return a === l.length ? n.Break : l[a].extendedRange[0] > e1.range[1] ? n.Skip : void 0;
                        }
                    }), e1;
                }, t.VisitorKeys = s, t.VisitorOption = n, t.Controller = p, t.cloneEnvironment = function() {
                    return e1({});
                }, t;
            }(e1);
        }(or)), or;
    }
    var ur, lr, cr = {}, pr = "4.3.0";
    function fr() {
        return ur || (ur = 1, function() {
            var e1 = ar();
            function t(e1) {
                return null != e1 && "object" == typeof e1 && "string" == typeof e1.type;
            }
            function r(t, r) {
                r = r || {}, this.__visitor = t || this, this.__childVisitorKeys = r.childVisitorKeys ? Object.assign({}, e1.VisitorKeys, r.childVisitorKeys) : e1.VisitorKeys, "iteration" === r.fallback ? this.__fallback = Object.keys : "function" == typeof r.fallback && (this.__fallback = r.fallback);
            }
            r.prototype.visitChildren = function(r) {
                var n, s, i, o, a, u, l;
                if (null != r) {
                    if (n = r.type || e1.Syntax.Property, !(s = this.__childVisitorKeys[n])) {
                        if (!this.__fallback) throw new Error("Unknown node type " + n + ".");
                        s = this.__fallback(r);
                    }
                    for(i = 0, o = s.length; i < o; ++i)if (l = r[s[i]]) {
                        if (Array.isArray(l)) for(a = 0, u = l.length; a < u; ++a)l[a] && (!t(l[a]) && (c = n, p = s[i], c !== e1.Syntax.ObjectExpression && c !== e1.Syntax.ObjectPattern || "properties" !== p) || this.visit(l[a]));
                        else t(l) && this.visit(l);
                    }
                    var c, p;
                }
            }, r.prototype.visit = function(t) {
                var r;
                null != t && (r = t.type || e1.Syntax.Property, this.__visitor[r] ? this.__visitor[r].call(this, t) : this.visitChildren(t));
            }, cr.version = pr, cr.Visitor = r, cr.visit = function(e1, t, n) {
                new r(t, n).visit(e1);
            };
        }()), cr;
    }
    function dr() {
        if (lr) return W;
        lr = 1, Object.defineProperty(W, "__esModule", {
            value: !0
        });
        var e1 = ir, t = ar(), r = fr();
        function n(e1) {
            return e1 && "object" == typeof e1 && "default" in e1 ? e1 : {
                default: e1
            };
        }
        var s = n(e1), i = n(t), o = n(r);
        class a {
            constructor(e1, t, r, n, s, i, o){
                this.identifier = e1, this.from = t, this.tainted = !1, this.resolved = null, this.flag = r, this.isWrite() && (this.writeExpr = n, this.partial = i, this.init = o), this.__maybeImplicitGlobal = s;
            }
            isStatic() {
                return !this.tainted && this.resolved && this.resolved.scope.isStatic();
            }
            isWrite() {
                return !!(this.flag & a.WRITE);
            }
            isRead() {
                return !!(this.flag & a.READ);
            }
            isReadOnly() {
                return this.flag === a.READ;
            }
            isWriteOnly() {
                return this.flag === a.WRITE;
            }
            isReadWrite() {
                return this.flag === a.RW;
            }
        }
        a.READ = 1, a.WRITE = 2, a.RW = 3;
        class u {
            constructor(e1, t){
                this.name = e1, this.identifiers = [], this.references = [], this.defs = [], this.tainted = !1, this.stack = !0, this.scope = t;
            }
        }
        u.CatchClause = "CatchClause", u.Parameter = "Parameter", u.FunctionName = "FunctionName", u.ClassName = "ClassName", u.Variable = "Variable", u.ImportBinding = "ImportBinding", u.ImplicitGlobalVariable = "ImplicitGlobalVariable";
        class l {
            constructor(e1, t, r, n, s, i){
                this.type = e1, this.name = t, this.node = r, this.parent = n, this.index = s, this.kind = i;
            }
        }
        class c extends l {
            constructor(e1, t, r, n){
                super(u.Parameter, e1, t, null, r, null), this.rest = n;
            }
        }
        const { Syntax: p } = i.default;
        function f(e1) {
            return e1.type === u.ClassName || e1.type === u.Variable && "var" !== e1.parent.kind;
        }
        class d {
            constructor(e1, t, r, n, s){
                this.type = t, this.set = new Map, this.taints = new Map, this.dynamic = "global" === this.type || "with" === this.type, this.block = n, this.through = [], this.variables = [], this.references = [], this.variableScope = "global" === this.type || "module" === this.type || "function" === this.type || "class-field-initializer" === this.type || "class-static-block" === this.type ? this : r.variableScope, this.functionExpressionScope = !1, this.directCallToEvalScope = !1, this.thisFound = !1, this.__left = [], this.upper = r, this.isStrict = !!e1.isStrictModeSupported() && function(e1, t, r, n) {
                    let s;
                    if (e1.upper && e1.upper.isStrict) return !0;
                    if (r) return !0;
                    if ("class" === e1.type || "module" === e1.type) return !0;
                    if ("block" === e1.type || "switch" === e1.type) return !1;
                    if ("function" === e1.type) {
                        if (t.type === p.ArrowFunctionExpression && t.body.type !== p.BlockStatement) return !1;
                        if (s = t.type === p.Program ? t : t.body, !s) return !1;
                    } else {
                        if ("global" !== e1.type) return !1;
                        s = t;
                    }
                    if (n) for(let e1 = 0, t = s.body.length; e1 < t; ++e1){
                        const t = s.body[e1];
                        if (t.type !== p.DirectiveStatement) break;
                        if ('"use strict"' === t.raw || "'use strict'" === t.raw) return !0;
                    }
                    else for(let e1 = 0, t = s.body.length; e1 < t; ++e1){
                        const t = s.body[e1];
                        if (t.type !== p.ExpressionStatement) break;
                        const r = t.expression;
                        if (r.type !== p.Literal || "string" != typeof r.value) break;
                        if (null !== r.raw && void 0 !== r.raw) {
                            if ('"use strict"' === r.raw || "'use strict'" === r.raw) return !0;
                        } else if ("use strict" === r.value) return !0;
                    }
                    return !1;
                }(this, n, s, e1.__useDirective()), this.childScopes = [], this.upper && this.upper.childScopes.push(this), this.__declaredVariables = e1.__declaredVariables, function(e1, t) {
                    e1.scopes.push(t);
                    const r = e1.__nodeToScope.get(t.block);
                    r ? r.push(t) : e1.__nodeToScope.set(t.block, [
                        t
                    ]);
                }(e1, this);
            }
            __shouldStaticallyClose(e1) {
                return !this.dynamic || e1.__isOptimistic();
            }
            __shouldStaticallyCloseForGlobal(e1) {
                const t = e1.identifier.name;
                if (!this.set.has(t)) return !1;
                const r = this.set.get(t).defs;
                return r.length > 0 && r.every(f);
            }
            __staticCloseRef(e1) {
                this.__resolve(e1) || this.__delegateToUpperScope(e1);
            }
            __dynamicCloseRef(e1) {
                let t = this;
                do t.through.push(e1), t = t.upper;
                while (t);
            }
            __globalCloseRef(e1) {
                this.__shouldStaticallyCloseForGlobal(e1) ? this.__staticCloseRef(e1) : this.__dynamicCloseRef(e1);
            }
            __close(e1) {
                let t;
                t = this.__shouldStaticallyClose(e1) ? this.__staticCloseRef : "global" !== this.type ? this.__dynamicCloseRef : this.__globalCloseRef;
                for(let e1 = 0, r = this.__left.length; e1 < r; ++e1){
                    const r = this.__left[e1];
                    t.call(this, r);
                }
                return this.__left = null, this.upper;
            }
            __isValidResolution(e1, t) {
                return !0;
            }
            __resolve(e1) {
                const t = e1.identifier.name;
                if (!this.set.has(t)) return !1;
                const r = this.set.get(t);
                return !!this.__isValidResolution(e1, r) && (r.references.push(e1), r.stack = r.stack && e1.from.variableScope === this.variableScope, e1.tainted && (r.tainted = !0, this.taints.set(r.name, !0)), e1.resolved = r, !0);
            }
            __delegateToUpperScope(e1) {
                this.upper && this.upper.__left.push(e1), this.through.push(e1);
            }
            __addDeclaredVariablesOfNode(e1, t) {
                if (null == t) return;
                let r = this.__declaredVariables.get(t);
                null == r && (r = [], this.__declaredVariables.set(t, r)), -1 === r.indexOf(e1) && r.push(e1);
            }
            __defineGeneric(e1, t, r, n, s) {
                let i;
                i = t.get(e1), i || (i = new u(e1, this), t.set(e1, i), r.push(i)), s && (i.defs.push(s), this.__addDeclaredVariablesOfNode(i, s.node), this.__addDeclaredVariablesOfNode(i, s.parent)), n && i.identifiers.push(n);
            }
            __define(e1, t) {
                e1 && e1.type === p.Identifier && this.__defineGeneric(e1.name, this.set, this.variables, e1, t);
            }
            __referencing(e1, t, r, n, s, i) {
                if (!e1 || e1.type !== p.Identifier) return;
                if ("super" === e1.name) return;
                const o = new a(e1, this, t || a.READ, r, n, !!s, !!i);
                this.references.push(o), this.__left.push(o);
            }
            __detectEval() {
                let e1 = this;
                this.directCallToEvalScope = !0;
                do e1.dynamic = !0, e1 = e1.upper;
                while (e1);
            }
            __detectThis() {
                this.thisFound = !0;
            }
            __isClosed() {
                return null === this.__left;
            }
            resolve(e1) {
                let t, r, n;
                for(s.default(this.__isClosed(), "Scope should be closed."), s.default(e1.type === p.Identifier, "Target should be identifier."), r = 0, n = this.references.length; r < n; ++r)if (t = this.references[r], t.identifier === e1) return t;
                return null;
            }
            isStatic() {
                return !this.dynamic;
            }
            isArgumentsMaterialized() {
                return !0;
            }
            isThisMaterialized() {
                return !0;
            }
            isUsedName(e1) {
                if (this.set.has(e1)) return !0;
                for(let t = 0, r = this.through.length; t < r; ++t)if (this.through[t].identifier.name === e1) return !0;
                return !1;
            }
        }
        class h extends d {
            constructor(e1, t){
                super(e1, "global", null, t, !1), this.implicit = {
                    set: new Map,
                    variables: [],
                    left: []
                };
            }
            __close(e1) {
                const t = [];
                for(let e1 = 0, r = this.__left.length; e1 < r; ++e1){
                    const r = this.__left[e1];
                    r.__maybeImplicitGlobal && !this.set.has(r.identifier.name) && t.push(r.__maybeImplicitGlobal);
                }
                for(let e1 = 0, r = t.length; e1 < r; ++e1){
                    const r = t[e1];
                    this.__defineImplicit(r.pattern, new l(u.ImplicitGlobalVariable, r.pattern, r.node, null, null, null));
                }
                return this.implicit.left = this.__left, super.__close(e1);
            }
            __defineImplicit(e1, t) {
                e1 && e1.type === p.Identifier && this.__defineGeneric(e1.name, this.implicit.set, this.implicit.variables, e1, t);
            }
        }
        class m extends d {
            constructor(e1, t, r){
                super(e1, "module", t, r, !1);
            }
        }
        class g extends d {
            constructor(e1, t, r){
                super(e1, "function-expression-name", t, r, !1), this.__define(r.id, new l(u.FunctionName, r.id, r, null, null, null)), this.functionExpressionScope = !0;
            }
        }
        class y extends d {
            constructor(e1, t, r){
                super(e1, "catch", t, r, !1);
            }
        }
        class E extends d {
            constructor(e1, t, r){
                super(e1, "with", t, r, !1);
            }
            __close(e1) {
                if (this.__shouldStaticallyClose(e1)) return super.__close(e1);
                for(let e1 = 0, t = this.__left.length; e1 < t; ++e1){
                    const t = this.__left[e1];
                    t.tainted = !0, this.__delegateToUpperScope(t);
                }
                return this.__left = null, this.upper;
            }
        }
        class x extends d {
            constructor(e1, t, r){
                super(e1, "block", t, r, !1);
            }
        }
        class C extends d {
            constructor(e1, t, r){
                super(e1, "switch", t, r, !1);
            }
        }
        class S extends d {
            constructor(e1, t, r, n){
                super(e1, "function", t, r, n), this.block.type !== p.ArrowFunctionExpression && this.__defineArguments();
            }
            isArgumentsMaterialized() {
                if (this.block.type === p.ArrowFunctionExpression) return !1;
                if (!this.isStatic()) return !0;
                const e1 = this.set.get("arguments");
                return s.default(e1, "Always have arguments variable."), e1.tainted || 0 !== e1.references.length;
            }
            isThisMaterialized() {
                return !this.isStatic() || this.thisFound;
            }
            __defineArguments() {
                this.__defineGeneric("arguments", this.set, this.variables, null, null), this.taints.set("arguments", !0);
            }
            __isValidResolution(e1, t) {
                if ("Program" === this.block.type) return !0;
                const r = this.block.body.range[0];
                return !(t.scope === this && e1.identifier.range[0] < r && t.defs.every((e1)=>e1.name.range[0] >= r));
            }
        }
        class b extends d {
            constructor(e1, t, r){
                super(e1, "for", t, r, !1);
            }
        }
        class v extends d {
            constructor(e1, t, r){
                super(e1, "class", t, r, !1);
            }
        }
        class A extends d {
            constructor(e1, t, r){
                super(e1, "class-field-initializer", t, r, !0);
            }
        }
        class T extends d {
            constructor(e1, t, r){
                super(e1, "class-static-block", t, r, !0);
            }
        }
        class R {
            constructor(e1){
                this.scopes = [], this.globalScope = null, this.__nodeToScope = new WeakMap, this.__currentScope = null, this.__options = e1, this.__declaredVariables = new WeakMap;
            }
            __useDirective() {
                return this.__options.directive;
            }
            __isOptimistic() {
                return this.__options.optimistic;
            }
            __ignoreEval() {
                return this.__options.ignoreEval;
            }
            isGlobalReturn() {
                return this.__options.nodejsScope || "commonjs" === this.__options.sourceType;
            }
            isModule() {
                return "module" === this.__options.sourceType;
            }
            isImpliedStrict() {
                return this.__options.impliedStrict;
            }
            isStrictModeSupported() {
                return this.__options.ecmaVersion >= 5;
            }
            __get(e1) {
                return this.__nodeToScope.get(e1);
            }
            getDeclaredVariables(e1) {
                return this.__declaredVariables.get(e1) || [];
            }
            acquire(e1, t) {
                function r(e1) {
                    return "function" !== e1.type || !e1.functionExpressionScope;
                }
                const n = this.__get(e1);
                if (!n || 0 === n.length) return null;
                if (1 === n.length) return n[0];
                if (t) for(let e1 = n.length - 1; e1 >= 0; --e1){
                    const t = n[e1];
                    if (r(t)) return t;
                }
                else for(let e1 = 0, t = n.length; e1 < t; ++e1){
                    const t = n[e1];
                    if (r(t)) return t;
                }
                return null;
            }
            acquireAll(e1) {
                return this.__get(e1);
            }
            release(e1, t) {
                const r = this.__get(e1);
                if (r && r.length) {
                    const e1 = r[0].upper;
                    return e1 ? this.acquire(e1.block, t) : null;
                }
                return null;
            }
            attach() {}
            detach() {}
            __nestScope(e1) {
                return e1 instanceof h && (s.default(null === this.__currentScope), this.globalScope = e1), this.__currentScope = e1, e1;
            }
            __nestGlobalScope(e1) {
                return this.__nestScope(new h(this, e1));
            }
            __nestBlockScope(e1) {
                return this.__nestScope(new x(this, this.__currentScope, e1));
            }
            __nestFunctionScope(e1, t) {
                return this.__nestScope(new S(this, this.__currentScope, e1, t));
            }
            __nestForScope(e1) {
                return this.__nestScope(new b(this, this.__currentScope, e1));
            }
            __nestCatchScope(e1) {
                return this.__nestScope(new y(this, this.__currentScope, e1));
            }
            __nestWithScope(e1) {
                return this.__nestScope(new E(this, this.__currentScope, e1));
            }
            __nestClassScope(e1) {
                return this.__nestScope(new v(this, this.__currentScope, e1));
            }
            __nestClassFieldInitializerScope(e1) {
                return this.__nestScope(new A(this, this.__currentScope, e1));
            }
            __nestClassStaticBlockScope(e1) {
                return this.__nestScope(new T(this, this.__currentScope, e1));
            }
            __nestSwitchScope(e1) {
                return this.__nestScope(new C(this, this.__currentScope, e1));
            }
            __nestModuleScope(e1) {
                return this.__nestScope(new m(this, this.__currentScope, e1));
            }
            __nestFunctionExpressionNameScope(e1) {
                return this.__nestScope(new g(this, this.__currentScope, e1));
            }
            __isES6() {
                return this.__options.ecmaVersion >= 6;
            }
        }
        const { Syntax: D } = i.default;
        class w extends o.default.Visitor {
            static isPattern(e1) {
                const t = e1.type;
                return t === D.Identifier || t === D.ObjectPattern || t === D.ArrayPattern || t === D.SpreadElement || t === D.RestElement || t === D.AssignmentPattern;
            }
            constructor(e1, t, r){
                super(null, e1), this.rootPattern = t, this.callback = r, this.assignments = [], this.rightHandNodes = [], this.restElements = [];
            }
            Identifier(e1) {
                const t = (r = this.restElements)[r.length - 1] || null;
                var r;
                this.callback(e1, {
                    topLevel: e1 === this.rootPattern,
                    rest: null != t && t.argument === e1,
                    assignments: this.assignments
                });
            }
            Property(e1) {
                e1.computed && this.rightHandNodes.push(e1.key), this.visit(e1.value);
            }
            ArrayPattern(e1) {
                for(let t = 0, r = e1.elements.length; t < r; ++t){
                    const r = e1.elements[t];
                    this.visit(r);
                }
            }
            AssignmentPattern(e1) {
                this.assignments.push(e1), this.visit(e1.left), this.rightHandNodes.push(e1.right), this.assignments.pop();
            }
            RestElement(e1) {
                this.restElements.push(e1), this.visit(e1.argument), this.restElements.pop();
            }
            MemberExpression(e1) {
                e1.computed && this.rightHandNodes.push(e1.property), this.rightHandNodes.push(e1.object);
            }
            SpreadElement(e1) {
                this.visit(e1.argument);
            }
            ArrayExpression(e1) {
                e1.elements.forEach(this.visit, this);
            }
            AssignmentExpression(e1) {
                this.assignments.push(e1), this.visit(e1.left), this.rightHandNodes.push(e1.right), this.assignments.pop();
            }
            CallExpression(e1) {
                e1.arguments.forEach((e1)=>{
                    this.rightHandNodes.push(e1);
                }), this.visit(e1.callee);
            }
        }
        const { Syntax: _ } = i.default;
        class k extends o.default.Visitor {
            constructor(e1, t){
                super(null, t.options), this.declaration = e1, this.referencer = t;
            }
            visitImport(e1, t) {
                this.referencer.visitPattern(e1, (e1)=>{
                    this.referencer.currentScope().__define(e1, new l(u.ImportBinding, e1, t, this.declaration, null, null));
                });
            }
            ImportNamespaceSpecifier(e1) {
                const t = e1.local || e1.id;
                t && this.visitImport(t, e1);
            }
            ImportDefaultSpecifier(e1) {
                const t = e1.local || e1.id;
                this.visitImport(t, e1);
            }
            ImportSpecifier(e1) {
                const t = e1.local || e1.id;
                e1.name ? this.visitImport(e1.name, e1) : this.visitImport(t, e1);
            }
        }
        class B extends o.default.Visitor {
            constructor(e1, t){
                super(null, e1), this.options = e1, this.scopeManager = t, this.parent = null, this.isInnerMethodDefinition = !1;
            }
            currentScope() {
                return this.scopeManager.__currentScope;
            }
            close(e1) {
                for(; this.currentScope() && e1 === this.currentScope().block;)this.scopeManager.__currentScope = this.currentScope().__close(this.scopeManager);
            }
            pushInnerMethodDefinition(e1) {
                const t = this.isInnerMethodDefinition;
                return this.isInnerMethodDefinition = e1, t;
            }
            popInnerMethodDefinition(e1) {
                this.isInnerMethodDefinition = e1;
            }
            referencingDefaultValue(e1, t, r, n) {
                const s = this.currentScope();
                t.forEach((t)=>{
                    s.__referencing(e1, a.WRITE, t.right, r, e1 !== t.left, n);
                });
            }
            visitPattern(e1, t, r) {
                let n = t, s = r;
                "function" == typeof t && (s = t, n = {
                    processRightHandNodes: !1
                }), function(e1, t, r, n) {
                    const s = new w(e1, t, n);
                    s.visit(t), null != r && s.rightHandNodes.forEach(r.visit, r);
                }(this.options, e1, n.processRightHandNodes ? this : null, s);
            }
            visitFunction(e1) {
                let t, r;
                e1.type === _.FunctionDeclaration && this.currentScope().__define(e1.id, new l(u.FunctionName, e1.id, e1, null, null, null)), e1.type === _.FunctionExpression && e1.id && this.scopeManager.__nestFunctionExpressionNameScope(e1), this.scopeManager.__nestFunctionScope(e1, this.isInnerMethodDefinition);
                const n = this;
                function s(r, s) {
                    n.currentScope().__define(r, new c(r, e1, t, s.rest)), n.referencingDefaultValue(r, s.assignments, null, !0);
                }
                for(t = 0, r = e1.params.length; t < r; ++t)this.visitPattern(e1.params[t], {
                    processRightHandNodes: !0
                }, s);
                e1.rest && this.visitPattern({
                    type: "RestElement",
                    argument: e1.rest
                }, (t)=>{
                    this.currentScope().__define(t, new c(t, e1, e1.params.length, !0));
                }), e1.body && (e1.body.type === _.BlockStatement ? this.visitChildren(e1.body) : this.visit(e1.body)), this.close(e1);
            }
            visitClass(e1) {
                e1.type === _.ClassDeclaration && this.currentScope().__define(e1.id, new l(u.ClassName, e1.id, e1, null, null, null)), this.visit(e1.superClass), this.scopeManager.__nestClassScope(e1), e1.id && this.currentScope().__define(e1.id, new l(u.ClassName, e1.id, e1)), this.visit(e1.body), this.close(e1);
            }
            visitProperty(e1) {
                let t;
                e1.computed && this.visit(e1.key);
                const r = e1.type === _.MethodDefinition;
                r && (t = this.pushInnerMethodDefinition(!0)), this.visit(e1.value), r && this.popInnerMethodDefinition(t);
            }
            visitForIn(e1) {
                e1.left.type === _.VariableDeclaration && "var" !== e1.left.kind && this.scopeManager.__nestForScope(e1), e1.left.type === _.VariableDeclaration ? (this.visit(e1.left), this.visitPattern(e1.left.declarations[0].id, (t)=>{
                    this.currentScope().__referencing(t, a.WRITE, e1.right, null, !0, !0);
                })) : this.visitPattern(e1.left, {
                    processRightHandNodes: !0
                }, (t, r)=>{
                    let n = null;
                    this.currentScope().isStrict || (n = {
                        pattern: t,
                        node: e1
                    }), this.referencingDefaultValue(t, r.assignments, n, !1), this.currentScope().__referencing(t, a.WRITE, e1.right, n, !0, !1);
                }), this.visit(e1.right), this.visit(e1.body), this.close(e1);
            }
            visitVariableDeclaration(e1, t, r, n) {
                const s = r.declarations[n], i = s.init;
                this.visitPattern(s.id, {
                    processRightHandNodes: !0
                }, (o, u)=>{
                    e1.__define(o, new l(t, o, s, r, n, r.kind)), this.referencingDefaultValue(o, u.assignments, null, !0), i && this.currentScope().__referencing(o, a.WRITE, i, null, !u.topLevel, !0);
                });
            }
            AssignmentExpression(e1) {
                w.isPattern(e1.left) ? "=" === e1.operator ? this.visitPattern(e1.left, {
                    processRightHandNodes: !0
                }, (t, r)=>{
                    let n = null;
                    this.currentScope().isStrict || (n = {
                        pattern: t,
                        node: e1
                    }), this.referencingDefaultValue(t, r.assignments, n, !1), this.currentScope().__referencing(t, a.WRITE, e1.right, n, !r.topLevel, !1);
                }) : this.currentScope().__referencing(e1.left, a.RW, e1.right) : this.visit(e1.left), this.visit(e1.right);
            }
            CatchClause(e1) {
                this.scopeManager.__nestCatchScope(e1), this.visitPattern(e1.param, {
                    processRightHandNodes: !0
                }, (t, r)=>{
                    this.currentScope().__define(t, new l(u.CatchClause, e1.param, e1, null, null, null)), this.referencingDefaultValue(t, r.assignments, null, !0);
                }), this.visit(e1.body), this.close(e1);
            }
            Program(e1) {
                this.scopeManager.__nestGlobalScope(e1), this.scopeManager.isGlobalReturn() && (this.currentScope().isStrict = !1, this.scopeManager.__nestFunctionScope(e1, !1)), this.scopeManager.__isES6() && this.scopeManager.isModule() && this.scopeManager.__nestModuleScope(e1), this.scopeManager.isStrictModeSupported() && this.scopeManager.isImpliedStrict() && (this.currentScope().isStrict = !0), this.visitChildren(e1), this.close(e1);
            }
            Identifier(e1) {
                this.currentScope().__referencing(e1);
            }
            PrivateIdentifier() {}
            UpdateExpression(e1) {
                w.isPattern(e1.argument) ? this.currentScope().__referencing(e1.argument, a.RW, null) : this.visitChildren(e1);
            }
            MemberExpression(e1) {
                this.visit(e1.object), e1.computed && this.visit(e1.property);
            }
            Property(e1) {
                this.visitProperty(e1);
            }
            PropertyDefinition(e1) {
                const { computed: t, key: r, value: n } = e1;
                t && this.visit(r), n && (this.scopeManager.__nestClassFieldInitializerScope(n), this.visit(n), this.close(n));
            }
            StaticBlock(e1) {
                this.scopeManager.__nestClassStaticBlockScope(e1), this.visitChildren(e1), this.close(e1);
            }
            MethodDefinition(e1) {
                this.visitProperty(e1);
            }
            BreakStatement() {}
            ContinueStatement() {}
            LabeledStatement(e1) {
                this.visit(e1.body);
            }
            ForStatement(e1) {
                e1.init && e1.init.type === _.VariableDeclaration && "var" !== e1.init.kind && this.scopeManager.__nestForScope(e1), this.visitChildren(e1), this.close(e1);
            }
            ClassExpression(e1) {
                this.visitClass(e1);
            }
            ClassDeclaration(e1) {
                this.visitClass(e1);
            }
            CallExpression(e1) {
                this.scopeManager.__ignoreEval() || e1.callee.type !== _.Identifier || "eval" !== e1.callee.name || this.currentScope().variableScope.__detectEval(), this.visitChildren(e1);
            }
            BlockStatement(e1) {
                this.scopeManager.__isES6() && this.scopeManager.__nestBlockScope(e1), this.visitChildren(e1), this.close(e1);
            }
            ThisExpression() {
                this.currentScope().variableScope.__detectThis();
            }
            WithStatement(e1) {
                this.visit(e1.object), this.scopeManager.__nestWithScope(e1), this.visit(e1.body), this.close(e1);
            }
            VariableDeclaration(e1) {
                const t = "var" === e1.kind ? this.currentScope().variableScope : this.currentScope();
                for(let r = 0, n = e1.declarations.length; r < n; ++r){
                    const n = e1.declarations[r];
                    this.visitVariableDeclaration(t, u.Variable, e1, r), n.init && this.visit(n.init);
                }
            }
            SwitchStatement(e1) {
                this.visit(e1.discriminant), this.scopeManager.__isES6() && this.scopeManager.__nestSwitchScope(e1);
                for(let t = 0, r = e1.cases.length; t < r; ++t)this.visit(e1.cases[t]);
                this.close(e1);
            }
            FunctionDeclaration(e1) {
                this.visitFunction(e1);
            }
            FunctionExpression(e1) {
                this.visitFunction(e1);
            }
            ForOfStatement(e1) {
                this.visitForIn(e1);
            }
            ForInStatement(e1) {
                this.visitForIn(e1);
            }
            ArrowFunctionExpression(e1) {
                this.visitFunction(e1);
            }
            ImportDeclaration(e1) {
                s.default(this.scopeManager.__isES6() && this.scopeManager.isModule(), "ImportDeclaration should appear when the mode is ES6 and in the module context.");
                new k(e1, this).visit(e1);
            }
            visitExportDeclaration(e1) {
                e1.source || (e1.declaration ? this.visit(e1.declaration) : this.visitChildren(e1));
            }
            ExportDeclaration(e1) {
                this.visitExportDeclaration(e1);
            }
            ExportAllDeclaration(e1) {
                this.visitExportDeclaration(e1);
            }
            ExportDefaultDeclaration(e1) {
                this.visitExportDeclaration(e1);
            }
            ExportNamedDeclaration(e1) {
                this.visitExportDeclaration(e1);
            }
            ExportSpecifier(e1) {
                const t = e1.id || e1.local;
                this.visit(t);
            }
            MetaProperty() {}
        }
        function L(e1, t) {
            function r(e1) {
                return "object" == typeof e1 && e1 instanceof Object && !(e1 instanceof Array) && !(e1 instanceof RegExp);
            }
            for(const n in t)if (Object.prototype.hasOwnProperty.call(t, n)) {
                const s = t[n];
                r(s) ? r(e1[n]) ? L(e1[n], s) : e1[n] = L({}, s) : e1[n] = s;
            }
            return e1;
        }
        return W.Definition = l, W.PatternVisitor = w, W.Reference = a, W.Referencer = B, W.Scope = d, W.ScopeManager = R, W.Variable = u, W.analyze = function(e1, t) {
            const r = L({
                optimistic: !1,
                directive: !1,
                nodejsScope: !1,
                impliedStrict: !1,
                sourceType: "script",
                ecmaVersion: 5,
                childVisitorKeys: null,
                fallback: "iteration"
            }, t), n = new R(r);
            return new B(r, n).visit(e1), s.default(null === n.__currentScope, "currentScope should be null."), n;
        }, W.version = "7.2.2", W;
    }
    var hr, mr = {};
    function gr() {
        if (hr) return mr;
        hr = 1, Object.defineProperty(mr, "__esModule", {
            value: !0
        });
        const e1 = {
            ArrayExpression: [
                "elements"
            ],
            ArrayPattern: [
                "elements"
            ],
            ArrowFunctionExpression: [
                "params",
                "body"
            ],
            AssignmentExpression: [
                "left",
                "right"
            ],
            AssignmentPattern: [
                "left",
                "right"
            ],
            AwaitExpression: [
                "argument"
            ],
            BinaryExpression: [
                "left",
                "right"
            ],
            BlockStatement: [
                "body"
            ],
            BreakStatement: [
                "label"
            ],
            CallExpression: [
                "callee",
                "arguments"
            ],
            CatchClause: [
                "param",
                "body"
            ],
            ChainExpression: [
                "expression"
            ],
            ClassBody: [
                "body"
            ],
            ClassDeclaration: [
                "id",
                "superClass",
                "body"
            ],
            ClassExpression: [
                "id",
                "superClass",
                "body"
            ],
            ConditionalExpression: [
                "test",
                "consequent",
                "alternate"
            ],
            ContinueStatement: [
                "label"
            ],
            DebuggerStatement: [],
            DoWhileStatement: [
                "body",
                "test"
            ],
            EmptyStatement: [],
            ExperimentalRestProperty: [
                "argument"
            ],
            ExperimentalSpreadProperty: [
                "argument"
            ],
            ExportAllDeclaration: [
                "exported",
                "source"
            ],
            ExportDefaultDeclaration: [
                "declaration"
            ],
            ExportNamedDeclaration: [
                "declaration",
                "specifiers",
                "source"
            ],
            ExportSpecifier: [
                "exported",
                "local"
            ],
            ExpressionStatement: [
                "expression"
            ],
            ForInStatement: [
                "left",
                "right",
                "body"
            ],
            ForOfStatement: [
                "left",
                "right",
                "body"
            ],
            ForStatement: [
                "init",
                "test",
                "update",
                "body"
            ],
            FunctionDeclaration: [
                "id",
                "params",
                "body"
            ],
            FunctionExpression: [
                "id",
                "params",
                "body"
            ],
            Identifier: [],
            IfStatement: [
                "test",
                "consequent",
                "alternate"
            ],
            ImportDeclaration: [
                "specifiers",
                "source"
            ],
            ImportDefaultSpecifier: [
                "local"
            ],
            ImportExpression: [
                "source"
            ],
            ImportNamespaceSpecifier: [
                "local"
            ],
            ImportSpecifier: [
                "imported",
                "local"
            ],
            JSXAttribute: [
                "name",
                "value"
            ],
            JSXClosingElement: [
                "name"
            ],
            JSXClosingFragment: [],
            JSXElement: [
                "openingElement",
                "children",
                "closingElement"
            ],
            JSXEmptyExpression: [],
            JSXExpressionContainer: [
                "expression"
            ],
            JSXFragment: [
                "openingFragment",
                "children",
                "closingFragment"
            ],
            JSXIdentifier: [],
            JSXMemberExpression: [
                "object",
                "property"
            ],
            JSXNamespacedName: [
                "namespace",
                "name"
            ],
            JSXOpeningElement: [
                "name",
                "attributes"
            ],
            JSXOpeningFragment: [],
            JSXSpreadAttribute: [
                "argument"
            ],
            JSXSpreadChild: [
                "expression"
            ],
            JSXText: [],
            LabeledStatement: [
                "label",
                "body"
            ],
            Literal: [],
            LogicalExpression: [
                "left",
                "right"
            ],
            MemberExpression: [
                "object",
                "property"
            ],
            MetaProperty: [
                "meta",
                "property"
            ],
            MethodDefinition: [
                "key",
                "value"
            ],
            NewExpression: [
                "callee",
                "arguments"
            ],
            ObjectExpression: [
                "properties"
            ],
            ObjectPattern: [
                "properties"
            ],
            PrivateIdentifier: [],
            Program: [
                "body"
            ],
            Property: [
                "key",
                "value"
            ],
            PropertyDefinition: [
                "key",
                "value"
            ],
            RestElement: [
                "argument"
            ],
            ReturnStatement: [
                "argument"
            ],
            SequenceExpression: [
                "expressions"
            ],
            SpreadElement: [
                "argument"
            ],
            StaticBlock: [
                "body"
            ],
            Super: [],
            SwitchCase: [
                "test",
                "consequent"
            ],
            SwitchStatement: [
                "discriminant",
                "cases"
            ],
            TaggedTemplateExpression: [
                "tag",
                "quasi"
            ],
            TemplateElement: [],
            TemplateLiteral: [
                "quasis",
                "expressions"
            ],
            ThisExpression: [],
            ThrowStatement: [
                "argument"
            ],
            TryStatement: [
                "block",
                "handler",
                "finalizer"
            ],
            UnaryExpression: [
                "argument"
            ],
            UpdateExpression: [
                "argument"
            ],
            VariableDeclaration: [
                "declarations"
            ],
            VariableDeclarator: [
                "id",
                "init"
            ],
            WhileStatement: [
                "test",
                "body"
            ],
            WithStatement: [
                "object",
                "body"
            ],
            YieldExpression: [
                "argument"
            ]
        }, t = Object.keys(e1);
        for (const r of t)Object.freeze(e1[r]);
        Object.freeze(e1);
        const r = new Set([
            "parent",
            "leadingComments",
            "trailingComments"
        ]);
        function n(e1) {
            return !r.has(e1) && "_" !== e1[0];
        }
        return mr.KEYS = e1, mr.getKeys = function(e1) {
            return Object.keys(e1).filter(n);
        }, mr.unionWith = function(t) {
            const r = Object.assign({}, e1);
            for (const e1 of Object.keys(t))if (Object.prototype.hasOwnProperty.call(r, e1)) {
                const n = new Set(t[e1]);
                for (const t of r[e1])n.add(t);
                r[e1] = Object.freeze(Array.from(n));
            } else r[e1] = Object.freeze(Array.from(t[e1]));
            return Object.freeze(r);
        }, mr;
    }
    var yr, Er = {}, xr = {};
    function Cr() {
        return yr || (yr = 1, function(e1, t) {
            !function(e1) {
                var t = [
                    509,
                    0,
                    227,
                    0,
                    150,
                    4,
                    294,
                    9,
                    1368,
                    2,
                    2,
                    1,
                    6,
                    3,
                    41,
                    2,
                    5,
                    0,
                    166,
                    1,
                    574,
                    3,
                    9,
                    9,
                    7,
                    9,
                    32,
                    4,
                    318,
                    1,
                    80,
                    3,
                    71,
                    10,
                    50,
                    3,
                    123,
                    2,
                    54,
                    14,
                    32,
                    10,
                    3,
                    1,
                    11,
                    3,
                    46,
                    10,
                    8,
                    0,
                    46,
                    9,
                    7,
                    2,
                    37,
                    13,
                    2,
                    9,
                    6,
                    1,
                    45,
                    0,
                    13,
                    2,
                    49,
                    13,
                    9,
                    3,
                    2,
                    11,
                    83,
                    11,
                    7,
                    0,
                    3,
                    0,
                    158,
                    11,
                    6,
                    9,
                    7,
                    3,
                    56,
                    1,
                    2,
                    6,
                    3,
                    1,
                    3,
                    2,
                    10,
                    0,
                    11,
                    1,
                    3,
                    6,
                    4,
                    4,
                    68,
                    8,
                    2,
                    0,
                    3,
                    0,
                    2,
                    3,
                    2,
                    4,
                    2,
                    0,
                    15,
                    1,
                    83,
                    17,
                    10,
                    9,
                    5,
                    0,
                    82,
                    19,
                    13,
                    9,
                    214,
                    6,
                    3,
                    8,
                    28,
                    1,
                    83,
                    16,
                    16,
                    9,
                    82,
                    12,
                    9,
                    9,
                    7,
                    19,
                    58,
                    14,
                    5,
                    9,
                    243,
                    14,
                    166,
                    9,
                    71,
                    5,
                    2,
                    1,
                    3,
                    3,
                    2,
                    0,
                    2,
                    1,
                    13,
                    9,
                    120,
                    6,
                    3,
                    6,
                    4,
                    0,
                    29,
                    9,
                    41,
                    6,
                    2,
                    3,
                    9,
                    0,
                    10,
                    10,
                    47,
                    15,
                    343,
                    9,
                    54,
                    7,
                    2,
                    7,
                    17,
                    9,
                    57,
                    21,
                    2,
                    13,
                    123,
                    5,
                    4,
                    0,
                    2,
                    1,
                    2,
                    6,
                    2,
                    0,
                    9,
                    9,
                    49,
                    4,
                    2,
                    1,
                    2,
                    4,
                    9,
                    9,
                    330,
                    3,
                    10,
                    1,
                    2,
                    0,
                    49,
                    6,
                    4,
                    4,
                    14,
                    10,
                    5350,
                    0,
                    7,
                    14,
                    11465,
                    27,
                    2343,
                    9,
                    87,
                    9,
                    39,
                    4,
                    60,
                    6,
                    26,
                    9,
                    535,
                    9,
                    470,
                    0,
                    2,
                    54,
                    8,
                    3,
                    82,
                    0,
                    12,
                    1,
                    19628,
                    1,
                    4178,
                    9,
                    519,
                    45,
                    3,
                    22,
                    543,
                    4,
                    4,
                    5,
                    9,
                    7,
                    3,
                    6,
                    31,
                    3,
                    149,
                    2,
                    1418,
                    49,
                    513,
                    54,
                    5,
                    49,
                    9,
                    0,
                    15,
                    0,
                    23,
                    4,
                    2,
                    14,
                    1361,
                    6,
                    2,
                    16,
                    3,
                    6,
                    2,
                    1,
                    2,
                    4,
                    101,
                    0,
                    161,
                    6,
                    10,
                    9,
                    357,
                    0,
                    62,
                    13,
                    499,
                    13,
                    245,
                    1,
                    2,
                    9,
                    726,
                    6,
                    110,
                    6,
                    6,
                    9,
                    4759,
                    9,
                    787719,
                    239
                ], r = [
                    0,
                    11,
                    2,
                    25,
                    2,
                    18,
                    2,
                    1,
                    2,
                    14,
                    3,
                    13,
                    35,
                    122,
                    70,
                    52,
                    268,
                    28,
                    4,
                    48,
                    48,
                    31,
                    14,
                    29,
                    6,
                    37,
                    11,
                    29,
                    3,
                    35,
                    5,
                    7,
                    2,
                    4,
                    43,
                    157,
                    19,
                    35,
                    5,
                    35,
                    5,
                    39,
                    9,
                    51,
                    13,
                    10,
                    2,
                    14,
                    2,
                    6,
                    2,
                    1,
                    2,
                    10,
                    2,
                    14,
                    2,
                    6,
                    2,
                    1,
                    4,
                    51,
                    13,
                    310,
                    10,
                    21,
                    11,
                    7,
                    25,
                    5,
                    2,
                    41,
                    2,
                    8,
                    70,
                    5,
                    3,
                    0,
                    2,
                    43,
                    2,
                    1,
                    4,
                    0,
                    3,
                    22,
                    11,
                    22,
                    10,
                    30,
                    66,
                    18,
                    2,
                    1,
                    11,
                    21,
                    11,
                    25,
                    71,
                    55,
                    7,
                    1,
                    65,
                    0,
                    16,
                    3,
                    2,
                    2,
                    2,
                    28,
                    43,
                    28,
                    4,
                    28,
                    36,
                    7,
                    2,
                    27,
                    28,
                    53,
                    11,
                    21,
                    11,
                    18,
                    14,
                    17,
                    111,
                    72,
                    56,
                    50,
                    14,
                    50,
                    14,
                    35,
                    39,
                    27,
                    10,
                    22,
                    251,
                    41,
                    7,
                    1,
                    17,
                    2,
                    60,
                    28,
                    11,
                    0,
                    9,
                    21,
                    43,
                    17,
                    47,
                    20,
                    28,
                    22,
                    13,
                    52,
                    58,
                    1,
                    3,
                    0,
                    14,
                    44,
                    33,
                    24,
                    27,
                    35,
                    30,
                    0,
                    3,
                    0,
                    9,
                    34,
                    4,
                    0,
                    13,
                    47,
                    15,
                    3,
                    22,
                    0,
                    2,
                    0,
                    36,
                    17,
                    2,
                    24,
                    20,
                    1,
                    64,
                    6,
                    2,
                    0,
                    2,
                    3,
                    2,
                    14,
                    2,
                    9,
                    8,
                    46,
                    39,
                    7,
                    3,
                    1,
                    3,
                    21,
                    2,
                    6,
                    2,
                    1,
                    2,
                    4,
                    4,
                    0,
                    19,
                    0,
                    13,
                    4,
                    31,
                    9,
                    2,
                    0,
                    3,
                    0,
                    2,
                    37,
                    2,
                    0,
                    26,
                    0,
                    2,
                    0,
                    45,
                    52,
                    19,
                    3,
                    21,
                    2,
                    31,
                    47,
                    21,
                    1,
                    2,
                    0,
                    185,
                    46,
                    42,
                    3,
                    37,
                    47,
                    21,
                    0,
                    60,
                    42,
                    14,
                    0,
                    72,
                    26,
                    38,
                    6,
                    186,
                    43,
                    117,
                    63,
                    32,
                    7,
                    3,
                    0,
                    3,
                    7,
                    2,
                    1,
                    2,
                    23,
                    16,
                    0,
                    2,
                    0,
                    95,
                    7,
                    3,
                    38,
                    17,
                    0,
                    2,
                    0,
                    29,
                    0,
                    11,
                    39,
                    8,
                    0,
                    22,
                    0,
                    12,
                    45,
                    20,
                    0,
                    19,
                    72,
                    200,
                    32,
                    32,
                    8,
                    2,
                    36,
                    18,
                    0,
                    50,
                    29,
                    113,
                    6,
                    2,
                    1,
                    2,
                    37,
                    22,
                    0,
                    26,
                    5,
                    2,
                    1,
                    2,
                    31,
                    15,
                    0,
                    328,
                    18,
                    16,
                    0,
                    2,
                    12,
                    2,
                    33,
                    125,
                    0,
                    80,
                    921,
                    103,
                    110,
                    18,
                    195,
                    2637,
                    96,
                    16,
                    1071,
                    18,
                    5,
                    26,
                    3994,
                    6,
                    582,
                    6842,
                    29,
                    1763,
                    568,
                    8,
                    30,
                    18,
                    78,
                    18,
                    29,
                    19,
                    47,
                    17,
                    3,
                    32,
                    20,
                    6,
                    18,
                    433,
                    44,
                    212,
                    63,
                    129,
                    74,
                    6,
                    0,
                    67,
                    12,
                    65,
                    1,
                    2,
                    0,
                    29,
                    6135,
                    9,
                    1237,
                    42,
                    9,
                    8936,
                    3,
                    2,
                    6,
                    2,
                    1,
                    2,
                    290,
                    16,
                    0,
                    30,
                    2,
                    3,
                    0,
                    15,
                    3,
                    9,
                    395,
                    2309,
                    106,
                    6,
                    12,
                    4,
                    8,
                    8,
                    9,
                    5991,
                    84,
                    2,
                    70,
                    2,
                    1,
                    3,
                    0,
                    3,
                    1,
                    3,
                    3,
                    2,
                    11,
                    2,
                    0,
                    2,
                    6,
                    2,
                    64,
                    2,
                    3,
                    3,
                    7,
                    2,
                    6,
                    2,
                    27,
                    2,
                    3,
                    2,
                    4,
                    2,
                    0,
                    4,
                    6,
                    2,
                    339,
                    3,
                    24,
                    2,
                    24,
                    2,
                    30,
                    2,
                    24,
                    2,
                    30,
                    2,
                    24,
                    2,
                    30,
                    2,
                    24,
                    2,
                    30,
                    2,
                    24,
                    2,
                    7,
                    1845,
                    30,
                    7,
                    5,
                    262,
                    61,
                    147,
                    44,
                    11,
                    6,
                    17,
                    0,
                    322,
                    29,
                    19,
                    43,
                    485,
                    27,
                    229,
                    29,
                    3,
                    0,
                    496,
                    6,
                    2,
                    3,
                    2,
                    1,
                    2,
                    14,
                    2,
                    196,
                    60,
                    67,
                    8,
                    0,
                    1205,
                    3,
                    2,
                    26,
                    2,
                    1,
                    2,
                    0,
                    3,
                    0,
                    2,
                    9,
                    2,
                    3,
                    2,
                    0,
                    2,
                    0,
                    7,
                    0,
                    5,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    2,
                    2,
                    1,
                    2,
                    0,
                    3,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    1,
                    2,
                    0,
                    3,
                    3,
                    2,
                    6,
                    2,
                    3,
                    2,
                    3,
                    2,
                    0,
                    2,
                    9,
                    2,
                    16,
                    6,
                    2,
                    2,
                    4,
                    2,
                    16,
                    4421,
                    42719,
                    33,
                    4153,
                    7,
                    221,
                    3,
                    5761,
                    15,
                    7472,
                    16,
                    621,
                    2467,
                    541,
                    1507,
                    4938,
                    6,
                    4191
                ], n = "\u200C\u200D\xb7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0897-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u200C\u200D\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\u30FB\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F\uFF65", s = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", i = {
                    3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
                    5: "class enum extends super const export import",
                    6: "enum",
                    strict: "implements interface let package private protected public static yield",
                    strictBind: "eval arguments"
                }, o = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", a = {
                    5: o,
                    "5module": o + " export import",
                    6: o + " const class extends export import super"
                }, u = /^in(stanceof)?$/, l = new RegExp("[" + s + "]"), c = new RegExp("[" + s + n + "]");
                function p(e1, t) {
                    for(var r = 65536, n = 0; n < t.length; n += 2){
                        if ((r += t[n]) > e1) return !1;
                        if ((r += t[n + 1]) >= e1) return !0;
                    }
                    return !1;
                }
                function f(e1, t) {
                    return e1 < 65 ? 36 === e1 : e1 < 91 || (e1 < 97 ? 95 === e1 : e1 < 123 || (e1 <= 65535 ? e1 >= 170 && l.test(String.fromCharCode(e1)) : !1 !== t && p(e1, r)));
                }
                function d(e1, n) {
                    return e1 < 48 ? 36 === e1 : e1 < 58 || !(e1 < 65) && (e1 < 91 || (e1 < 97 ? 95 === e1 : e1 < 123 || (e1 <= 65535 ? e1 >= 170 && c.test(String.fromCharCode(e1)) : !1 !== n && (p(e1, r) || p(e1, t)))));
                }
                var h = function(e1, t) {
                    void 0 === t && (t = {}), this.label = e1, this.keyword = t.keyword, this.beforeExpr = !!t.beforeExpr, this.startsExpr = !!t.startsExpr, this.isLoop = !!t.isLoop, this.isAssign = !!t.isAssign, this.prefix = !!t.prefix, this.postfix = !!t.postfix, this.binop = t.binop || null, this.updateContext = null;
                };
                function m(e1, t) {
                    return new h(e1, {
                        beforeExpr: !0,
                        binop: t
                    });
                }
                var g = {
                    beforeExpr: !0
                }, y = {
                    startsExpr: !0
                }, E = {};
                function x(e1, t) {
                    return void 0 === t && (t = {}), t.keyword = e1, E[e1] = new h(e1, t);
                }
                var C = {
                    num: new h("num", y),
                    regexp: new h("regexp", y),
                    string: new h("string", y),
                    name: new h("name", y),
                    privateId: new h("privateId", y),
                    eof: new h("eof"),
                    bracketL: new h("[", {
                        beforeExpr: !0,
                        startsExpr: !0
                    }),
                    bracketR: new h("]"),
                    braceL: new h("{", {
                        beforeExpr: !0,
                        startsExpr: !0
                    }),
                    braceR: new h("}"),
                    parenL: new h("(", {
                        beforeExpr: !0,
                        startsExpr: !0
                    }),
                    parenR: new h(")"),
                    comma: new h(",", g),
                    semi: new h(";", g),
                    colon: new h(":", g),
                    dot: new h("."),
                    question: new h("?", g),
                    questionDot: new h("?."),
                    arrow: new h("=>", g),
                    template: new h("template"),
                    invalidTemplate: new h("invalidTemplate"),
                    ellipsis: new h("...", g),
                    backQuote: new h("`", y),
                    dollarBraceL: new h("${", {
                        beforeExpr: !0,
                        startsExpr: !0
                    }),
                    eq: new h("=", {
                        beforeExpr: !0,
                        isAssign: !0
                    }),
                    assign: new h("_=", {
                        beforeExpr: !0,
                        isAssign: !0
                    }),
                    incDec: new h("++/--", {
                        prefix: !0,
                        postfix: !0,
                        startsExpr: !0
                    }),
                    prefix: new h("!/~", {
                        beforeExpr: !0,
                        prefix: !0,
                        startsExpr: !0
                    }),
                    logicalOR: m("||", 1),
                    logicalAND: m("&&", 2),
                    bitwiseOR: m("|", 3),
                    bitwiseXOR: m("^", 4),
                    bitwiseAND: m("&", 5),
                    equality: m("==/!=/===/!==", 6),
                    relational: m("</>/<=/>=", 7),
                    bitShift: m("<</>>/>>>", 8),
                    plusMin: new h("+/-", {
                        beforeExpr: !0,
                        binop: 9,
                        prefix: !0,
                        startsExpr: !0
                    }),
                    modulo: m("%", 10),
                    star: m("*", 10),
                    slash: m("/", 10),
                    starstar: new h("**", {
                        beforeExpr: !0
                    }),
                    coalesce: m("??", 1),
                    _break: x("break"),
                    _case: x("case", g),
                    _catch: x("catch"),
                    _continue: x("continue"),
                    _debugger: x("debugger"),
                    _default: x("default", g),
                    _do: x("do", {
                        isLoop: !0,
                        beforeExpr: !0
                    }),
                    _else: x("else", g),
                    _finally: x("finally"),
                    _for: x("for", {
                        isLoop: !0
                    }),
                    _function: x("function", y),
                    _if: x("if"),
                    _return: x("return", g),
                    _switch: x("switch"),
                    _throw: x("throw", g),
                    _try: x("try"),
                    _var: x("var"),
                    _const: x("const"),
                    _while: x("while", {
                        isLoop: !0
                    }),
                    _with: x("with"),
                    _new: x("new", {
                        beforeExpr: !0,
                        startsExpr: !0
                    }),
                    _this: x("this", y),
                    _super: x("super", y),
                    _class: x("class", y),
                    _extends: x("extends", g),
                    _export: x("export"),
                    _import: x("import", y),
                    _null: x("null", y),
                    _true: x("true", y),
                    _false: x("false", y),
                    _in: x("in", {
                        beforeExpr: !0,
                        binop: 7
                    }),
                    _instanceof: x("instanceof", {
                        beforeExpr: !0,
                        binop: 7
                    }),
                    _typeof: x("typeof", {
                        beforeExpr: !0,
                        prefix: !0,
                        startsExpr: !0
                    }),
                    _void: x("void", {
                        beforeExpr: !0,
                        prefix: !0,
                        startsExpr: !0
                    }),
                    _delete: x("delete", {
                        beforeExpr: !0,
                        prefix: !0,
                        startsExpr: !0
                    })
                }, S = /\r\n?|\n|\u2028|\u2029/, b = new RegExp(S.source, "g");
                function v(e1) {
                    return 10 === e1 || 13 === e1 || 8232 === e1 || 8233 === e1;
                }
                function A(e1, t, r) {
                    void 0 === r && (r = e1.length);
                    for(var n = t; n < r; n++){
                        var s = e1.charCodeAt(n);
                        if (v(s)) return n < r - 1 && 13 === s && 10 === e1.charCodeAt(n + 1) ? n + 2 : n + 1;
                    }
                    return -1;
                }
                var T = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, R = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, D = Object.prototype, w = D.hasOwnProperty, _ = D.toString, k = Object.hasOwn || function(e1, t) {
                    return w.call(e1, t);
                }, B = Array.isArray || function(e1) {
                    return "[object Array]" === _.call(e1);
                }, L = Object.create(null);
                function P(e1) {
                    return L[e1] || (L[e1] = new RegExp("^(?:" + e1.replace(/ /g, "|") + ")$"));
                }
                function I(e1) {
                    return e1 <= 65535 ? String.fromCharCode(e1) : (e1 -= 65536, String.fromCharCode(55296 + (e1 >> 10), 56320 + (1023 & e1)));
                }
                var F = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, N = function(e1, t) {
                    this.line = e1, this.column = t;
                };
                N.prototype.offset = function(e1) {
                    return new N(this.line, this.column + e1);
                };
                var O = function(e1, t, r) {
                    this.start = t, this.end = r, null !== e1.sourceFile && (this.source = e1.sourceFile);
                };
                function U(e1, t) {
                    for(var r = 1, n = 0;;){
                        var s = A(e1, n, t);
                        if (s < 0) return new N(r, t - n);
                        ++r, n = s;
                    }
                }
                var j = {
                    ecmaVersion: null,
                    sourceType: "script",
                    onInsertedSemicolon: null,
                    onTrailingComma: null,
                    allowReserved: null,
                    allowReturnOutsideFunction: !1,
                    allowImportExportEverywhere: !1,
                    allowAwaitOutsideFunction: null,
                    allowSuperOutsideMethod: null,
                    allowHashBang: !1,
                    checkPrivateFields: !0,
                    locations: !1,
                    onToken: null,
                    onComment: null,
                    ranges: !1,
                    program: null,
                    sourceFile: null,
                    directSourceFile: null,
                    preserveParens: !1
                }, V = !1;
                function K(e1) {
                    var t = {};
                    for(var r in j)t[r] = e1 && k(e1, r) ? e1[r] : j[r];
                    if ("latest" === t.ecmaVersion ? t.ecmaVersion = 1e8 : null == t.ecmaVersion ? (!V && "object" == typeof console && console.warn && (V = !0, console.warn("Since Acorn 8.0.0, options.ecmaVersion is required.\nDefaulting to 2020, but this will stop working in the future.")), t.ecmaVersion = 11) : t.ecmaVersion >= 2015 && (t.ecmaVersion -= 2009), null == t.allowReserved && (t.allowReserved = t.ecmaVersion < 5), e1 && null != e1.allowHashBang || (t.allowHashBang = t.ecmaVersion >= 14), B(t.onToken)) {
                        var n = t.onToken;
                        t.onToken = function(e1) {
                            return n.push(e1);
                        };
                    }
                    return B(t.onComment) && (t.onComment = M(t, t.onComment)), t;
                }
                function M(e1, t) {
                    return function(r, n, s, i, o, a) {
                        var u = {
                            type: r ? "Block" : "Line",
                            value: n,
                            start: s,
                            end: i
                        };
                        e1.locations && (u.loc = new O(this, o, a)), e1.ranges && (u.range = [
                            s,
                            i
                        ]), t.push(u);
                    };
                }
                var $ = 1, q = 2, G = 4, W = 8, X = 16, z = 32, H = 64, J = 128, Q = 256, Y = 512, Z = $ | q | Q;
                function ee(e1, t) {
                    return q | (e1 ? G : 0) | (t ? W : 0);
                }
                var te = 0, re = 1, ne = 2, se = 3, ie = 4, oe = 5, ae = function(e1, t, r) {
                    this.options = e1 = K(e1), this.sourceFile = e1.sourceFile, this.keywords = P(a[e1.ecmaVersion >= 6 ? 6 : "module" === e1.sourceType ? "5module" : 5]);
                    var n = "";
                    !0 !== e1.allowReserved && (n = i[e1.ecmaVersion >= 6 ? 6 : 5 === e1.ecmaVersion ? 5 : 3], "module" === e1.sourceType && (n += " await")), this.reservedWords = P(n);
                    var s = (n ? n + " " : "") + i.strict;
                    this.reservedWordsStrict = P(s), this.reservedWordsStrictBind = P(s + " " + i.strictBind), this.input = String(t), this.containsEsc = !1, r ? (this.pos = r, this.lineStart = this.input.lastIndexOf("\n", r - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(S).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = C.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = "module" === e1.sourceType, this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.potentialArrowInForAwait = !1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = Object.create(null), 0 === this.pos && e1.allowHashBang && "#!" === this.input.slice(0, 2) && this.skipLineComment(2), this.scopeStack = [], this.enterScope($), this.regexpState = null, this.privateNameStack = [];
                }, ue = {
                    inFunction: {
                        configurable: !0
                    },
                    inGenerator: {
                        configurable: !0
                    },
                    inAsync: {
                        configurable: !0
                    },
                    canAwait: {
                        configurable: !0
                    },
                    allowSuper: {
                        configurable: !0
                    },
                    allowDirectSuper: {
                        configurable: !0
                    },
                    treatFunctionsAsVar: {
                        configurable: !0
                    },
                    allowNewDotTarget: {
                        configurable: !0
                    },
                    inClassStaticBlock: {
                        configurable: !0
                    }
                };
                ae.prototype.parse = function() {
                    var e1 = this.options.program || this.startNode();
                    return this.nextToken(), this.parseTopLevel(e1);
                }, ue.inFunction.get = function() {
                    return (this.currentVarScope().flags & q) > 0;
                }, ue.inGenerator.get = function() {
                    return (this.currentVarScope().flags & W) > 0;
                }, ue.inAsync.get = function() {
                    return (this.currentVarScope().flags & G) > 0;
                }, ue.canAwait.get = function() {
                    for(var e1 = this.scopeStack.length - 1; e1 >= 0; e1--){
                        var t = this.scopeStack[e1].flags;
                        if (t & (Q | Y)) return !1;
                        if (t & q) return (t & G) > 0;
                    }
                    return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
                }, ue.allowSuper.get = function() {
                    return (this.currentThisScope().flags & H) > 0 || this.options.allowSuperOutsideMethod;
                }, ue.allowDirectSuper.get = function() {
                    return (this.currentThisScope().flags & J) > 0;
                }, ue.treatFunctionsAsVar.get = function() {
                    return this.treatFunctionsAsVarInScope(this.currentScope());
                }, ue.allowNewDotTarget.get = function() {
                    for(var e1 = this.scopeStack.length - 1; e1 >= 0; e1--){
                        var t = this.scopeStack[e1].flags;
                        if (t & (Q | Y) || t & q && !(t & X)) return !0;
                    }
                    return !1;
                }, ue.inClassStaticBlock.get = function() {
                    return (this.currentVarScope().flags & Q) > 0;
                }, ae.extend = function() {
                    for(var e1 = [], t = arguments.length; t--;)e1[t] = arguments[t];
                    for(var r = this, n = 0; n < e1.length; n++)r = e1[n](r);
                    return r;
                }, ae.parse = function(e1, t) {
                    return new this(t, e1).parse();
                }, ae.parseExpressionAt = function(e1, t, r) {
                    var n = new this(r, e1, t);
                    return n.nextToken(), n.parseExpression();
                }, ae.tokenizer = function(e1, t) {
                    return new this(t, e1);
                }, Object.defineProperties(ae.prototype, ue);
                var le = ae.prototype, ce = /^(?:'((?:\\[^]|[^'\\])*?)'|"((?:\\[^]|[^"\\])*?)")/;
                le.strictDirective = function(e1) {
                    if (this.options.ecmaVersion < 5) return !1;
                    for(;;){
                        R.lastIndex = e1, e1 += R.exec(this.input)[0].length;
                        var t = ce.exec(this.input.slice(e1));
                        if (!t) return !1;
                        if ("use strict" === (t[1] || t[2])) {
                            R.lastIndex = e1 + t[0].length;
                            var r = R.exec(this.input), n = r.index + r[0].length, s = this.input.charAt(n);
                            return ";" === s || "}" === s || S.test(r[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(s) || "!" === s && "=" === this.input.charAt(n + 1));
                        }
                        e1 += t[0].length, R.lastIndex = e1, e1 += R.exec(this.input)[0].length, ";" === this.input[e1] && e1++;
                    }
                }, le.eat = function(e1) {
                    return this.type === e1 && (this.next(), !0);
                }, le.isContextual = function(e1) {
                    return this.type === C.name && this.value === e1 && !this.containsEsc;
                }, le.eatContextual = function(e1) {
                    return !!this.isContextual(e1) && (this.next(), !0);
                }, le.expectContextual = function(e1) {
                    this.eatContextual(e1) || this.unexpected();
                }, le.canInsertSemicolon = function() {
                    return this.type === C.eof || this.type === C.braceR || S.test(this.input.slice(this.lastTokEnd, this.start));
                }, le.insertSemicolon = function() {
                    if (this.canInsertSemicolon()) return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
                }, le.semicolon = function() {
                    this.eat(C.semi) || this.insertSemicolon() || this.unexpected();
                }, le.afterTrailingComma = function(e1, t) {
                    if (this.type === e1) return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), t || this.next(), !0;
                }, le.expect = function(e1) {
                    this.eat(e1) || this.unexpected();
                }, le.unexpected = function(e1) {
                    this.raise(null != e1 ? e1 : this.start, "Unexpected token");
                };
                var pe = function() {
                    this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
                };
                le.checkPatternErrors = function(e1, t) {
                    if (e1) {
                        e1.trailingComma > -1 && this.raiseRecoverable(e1.trailingComma, "Comma is not permitted after the rest element");
                        var r = t ? e1.parenthesizedAssign : e1.parenthesizedBind;
                        r > -1 && this.raiseRecoverable(r, t ? "Assigning to rvalue" : "Parenthesized pattern");
                    }
                }, le.checkExpressionErrors = function(e1, t) {
                    if (!e1) return !1;
                    var r = e1.shorthandAssign, n = e1.doubleProto;
                    if (!t) return r >= 0 || n >= 0;
                    r >= 0 && this.raise(r, "Shorthand property assignments are valid only in destructuring patterns"), n >= 0 && this.raiseRecoverable(n, "Redefinition of __proto__ property");
                }, le.checkYieldAwaitInDefaultParams = function() {
                    this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
                }, le.isSimpleAssignTarget = function(e1) {
                    return "ParenthesizedExpression" === e1.type ? this.isSimpleAssignTarget(e1.expression) : "Identifier" === e1.type || "MemberExpression" === e1.type;
                };
                var fe = ae.prototype;
                fe.parseTopLevel = function(e1) {
                    var t = Object.create(null);
                    for(e1.body || (e1.body = []); this.type !== C.eof;){
                        var r = this.parseStatement(null, !0, t);
                        e1.body.push(r);
                    }
                    if (this.inModule) for(var n = 0, s = Object.keys(this.undefinedExports); n < s.length; n += 1){
                        var i = s[n];
                        this.raiseRecoverable(this.undefinedExports[i].start, "Export '" + i + "' is not defined");
                    }
                    return this.adaptDirectivePrologue(e1.body), this.next(), e1.sourceType = this.options.sourceType, this.finishNode(e1, "Program");
                };
                var de = {
                    kind: "loop"
                }, he = {
                    kind: "switch"
                };
                fe.isLet = function(e1) {
                    if (this.options.ecmaVersion < 6 || !this.isContextual("let")) return !1;
                    R.lastIndex = this.pos;
                    var t = R.exec(this.input), r = this.pos + t[0].length, n = this.input.charCodeAt(r);
                    if (91 === n || 92 === n) return !0;
                    if (e1) return !1;
                    if (123 === n || n > 55295 && n < 56320) return !0;
                    if (f(n, !0)) {
                        for(var s = r + 1; d(n = this.input.charCodeAt(s), !0);)++s;
                        if (92 === n || n > 55295 && n < 56320) return !0;
                        var i = this.input.slice(r, s);
                        if (!u.test(i)) return !0;
                    }
                    return !1;
                }, fe.isAsyncFunction = function() {
                    if (this.options.ecmaVersion < 8 || !this.isContextual("async")) return !1;
                    R.lastIndex = this.pos;
                    var e1, t = R.exec(this.input), r = this.pos + t[0].length;
                    return !(S.test(this.input.slice(this.pos, r)) || "function" !== this.input.slice(r, r + 8) || r + 8 !== this.input.length && (d(e1 = this.input.charCodeAt(r + 8)) || e1 > 55295 && e1 < 56320));
                }, fe.isUsingKeyword = function(e1, t) {
                    if (this.options.ecmaVersion < 17 || !this.isContextual(e1 ? "await" : "using")) return !1;
                    R.lastIndex = this.pos;
                    var r = R.exec(this.input), n = this.pos + r[0].length;
                    if (S.test(this.input.slice(this.pos, n))) return !1;
                    if (e1) {
                        var s, i = n + 5;
                        if ("using" !== this.input.slice(n, i) || i === this.input.length || d(s = this.input.charCodeAt(i)) || s > 55295 && s < 56320) return !1;
                        R.lastIndex = i;
                        var o = R.exec(this.input);
                        if (o && S.test(this.input.slice(i, i + o[0].length))) return !1;
                    }
                    if (t) {
                        var a, u = n + 2;
                        if (!("of" !== this.input.slice(n, u) || u !== this.input.length && (d(a = this.input.charCodeAt(u)) || a > 55295 && a < 56320))) return !1;
                    }
                    var l = this.input.charCodeAt(n);
                    return f(l, !0) || 92 === l;
                }, fe.isAwaitUsing = function(e1) {
                    return this.isUsingKeyword(!0, e1);
                }, fe.isUsing = function(e1) {
                    return this.isUsingKeyword(!1, e1);
                }, fe.parseStatement = function(e1, t, r) {
                    var n, s = this.type, i = this.startNode();
                    switch(this.isLet(e1) && (s = C._var, n = "let"), s){
                        case C._break:
                        case C._continue:
                            return this.parseBreakContinueStatement(i, s.keyword);
                        case C._debugger:
                            return this.parseDebuggerStatement(i);
                        case C._do:
                            return this.parseDoStatement(i);
                        case C._for:
                            return this.parseForStatement(i);
                        case C._function:
                            return e1 && (this.strict || "if" !== e1 && "label" !== e1) && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(i, !1, !e1);
                        case C._class:
                            return e1 && this.unexpected(), this.parseClass(i, !0);
                        case C._if:
                            return this.parseIfStatement(i);
                        case C._return:
                            return this.parseReturnStatement(i);
                        case C._switch:
                            return this.parseSwitchStatement(i);
                        case C._throw:
                            return this.parseThrowStatement(i);
                        case C._try:
                            return this.parseTryStatement(i);
                        case C._const:
                        case C._var:
                            return n = n || this.value, e1 && "var" !== n && this.unexpected(), this.parseVarStatement(i, n);
                        case C._while:
                            return this.parseWhileStatement(i);
                        case C._with:
                            return this.parseWithStatement(i);
                        case C.braceL:
                            return this.parseBlock(!0, i);
                        case C.semi:
                            return this.parseEmptyStatement(i);
                        case C._export:
                        case C._import:
                            if (this.options.ecmaVersion > 10 && s === C._import) {
                                R.lastIndex = this.pos;
                                var o = R.exec(this.input), a = this.pos + o[0].length, u = this.input.charCodeAt(a);
                                if (40 === u || 46 === u) return this.parseExpressionStatement(i, this.parseExpression());
                            }
                            return this.options.allowImportExportEverywhere || (t || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), s === C._import ? this.parseImport(i) : this.parseExport(i, r);
                        default:
                            if (this.isAsyncFunction()) return e1 && this.unexpected(), this.next(), this.parseFunctionStatement(i, !0, !e1);
                            var l = this.isAwaitUsing(!1) ? "await using" : this.isUsing(!1) ? "using" : null;
                            if (l) return t && "script" === this.options.sourceType && this.raise(this.start, "Using declaration cannot appear in the top level when source type is `script`"), "await using" === l && (this.canAwait || this.raise(this.start, "Await using cannot appear outside of async function"), this.next()), this.next(), this.parseVar(i, !1, l), this.semicolon(), this.finishNode(i, "VariableDeclaration");
                            var c = this.value, p = this.parseExpression();
                            return s === C.name && "Identifier" === p.type && this.eat(C.colon) ? this.parseLabeledStatement(i, c, p, e1) : this.parseExpressionStatement(i, p);
                    }
                }, fe.parseBreakContinueStatement = function(e1, t) {
                    var r = "break" === t;
                    this.next(), this.eat(C.semi) || this.insertSemicolon() ? e1.label = null : this.type !== C.name ? this.unexpected() : (e1.label = this.parseIdent(), this.semicolon());
                    for(var n = 0; n < this.labels.length; ++n){
                        var s = this.labels[n];
                        if (null == e1.label || s.name === e1.label.name) {
                            if (null != s.kind && (r || "loop" === s.kind)) break;
                            if (e1.label && r) break;
                        }
                    }
                    return n === this.labels.length && this.raise(e1.start, "Unsyntactic " + t), this.finishNode(e1, r ? "BreakStatement" : "ContinueStatement");
                }, fe.parseDebuggerStatement = function(e1) {
                    return this.next(), this.semicolon(), this.finishNode(e1, "DebuggerStatement");
                }, fe.parseDoStatement = function(e1) {
                    return this.next(), this.labels.push(de), e1.body = this.parseStatement("do"), this.labels.pop(), this.expect(C._while), e1.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(C.semi) : this.semicolon(), this.finishNode(e1, "DoWhileStatement");
                }, fe.parseForStatement = function(e1) {
                    this.next();
                    var t = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
                    if (this.labels.push(de), this.enterScope(0), this.expect(C.parenL), this.type === C.semi) return t > -1 && this.unexpected(t), this.parseFor(e1, null);
                    var r = this.isLet();
                    if (this.type === C._var || this.type === C._const || r) {
                        var n = this.startNode(), s = r ? "let" : this.value;
                        return this.next(), this.parseVar(n, !0, s), this.finishNode(n, "VariableDeclaration"), this.parseForAfterInit(e1, n, t);
                    }
                    var i = this.isContextual("let"), o = !1, a = this.isUsing(!0) ? "using" : this.isAwaitUsing(!0) ? "await using" : null;
                    if (a) {
                        var u = this.startNode();
                        return this.next(), "await using" === a && this.next(), this.parseVar(u, !0, a), this.finishNode(u, "VariableDeclaration"), this.parseForAfterInit(e1, u, t);
                    }
                    var l = this.containsEsc, c = new pe, p = this.start, f = t > -1 ? this.parseExprSubscripts(c, "await") : this.parseExpression(!0, c);
                    return this.type === C._in || (o = this.options.ecmaVersion >= 6 && this.isContextual("of")) ? (t > -1 ? (this.type === C._in && this.unexpected(t), e1.await = !0) : o && this.options.ecmaVersion >= 8 && (f.start !== p || l || "Identifier" !== f.type || "async" !== f.name ? this.options.ecmaVersion >= 9 && (e1.await = !1) : this.unexpected()), i && o && this.raise(f.start, "The left-hand side of a for-of loop may not start with 'let'."), this.toAssignable(f, !1, c), this.checkLValPattern(f), this.parseForIn(e1, f)) : (this.checkExpressionErrors(c, !0), t > -1 && this.unexpected(t), this.parseFor(e1, f));
                }, fe.parseForAfterInit = function(e1, t, r) {
                    return (this.type === C._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && 1 === t.declarations.length ? (this.options.ecmaVersion >= 9 && (this.type === C._in ? r > -1 && this.unexpected(r) : e1.await = r > -1), this.parseForIn(e1, t)) : (r > -1 && this.unexpected(r), this.parseFor(e1, t));
                }, fe.parseFunctionStatement = function(e1, t, r) {
                    return this.next(), this.parseFunction(e1, ge | (r ? 0 : ye), !1, t);
                }, fe.parseIfStatement = function(e1) {
                    return this.next(), e1.test = this.parseParenExpression(), e1.consequent = this.parseStatement("if"), e1.alternate = this.eat(C._else) ? this.parseStatement("if") : null, this.finishNode(e1, "IfStatement");
                }, fe.parseReturnStatement = function(e1) {
                    return this.inFunction || this.options.allowReturnOutsideFunction || this.raise(this.start, "'return' outside of function"), this.next(), this.eat(C.semi) || this.insertSemicolon() ? e1.argument = null : (e1.argument = this.parseExpression(), this.semicolon()), this.finishNode(e1, "ReturnStatement");
                }, fe.parseSwitchStatement = function(e1) {
                    var t;
                    this.next(), e1.discriminant = this.parseParenExpression(), e1.cases = [], this.expect(C.braceL), this.labels.push(he), this.enterScope(0);
                    for(var r = !1; this.type !== C.braceR;)if (this.type === C._case || this.type === C._default) {
                        var n = this.type === C._case;
                        t && this.finishNode(t, "SwitchCase"), e1.cases.push(t = this.startNode()), t.consequent = [], this.next(), n ? t.test = this.parseExpression() : (r && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), r = !0, t.test = null), this.expect(C.colon);
                    } else t || this.unexpected(), t.consequent.push(this.parseStatement(null));
                    return this.exitScope(), t && this.finishNode(t, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(e1, "SwitchStatement");
                }, fe.parseThrowStatement = function(e1) {
                    return this.next(), S.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), e1.argument = this.parseExpression(), this.semicolon(), this.finishNode(e1, "ThrowStatement");
                };
                var me = [];
                fe.parseCatchClauseParam = function() {
                    var e1 = this.parseBindingAtom(), t = "Identifier" === e1.type;
                    return this.enterScope(t ? z : 0), this.checkLValPattern(e1, t ? ie : ne), this.expect(C.parenR), e1;
                }, fe.parseTryStatement = function(e1) {
                    if (this.next(), e1.block = this.parseBlock(), e1.handler = null, this.type === C._catch) {
                        var t = this.startNode();
                        this.next(), this.eat(C.parenL) ? t.param = this.parseCatchClauseParam() : (this.options.ecmaVersion < 10 && this.unexpected(), t.param = null, this.enterScope(0)), t.body = this.parseBlock(!1), this.exitScope(), e1.handler = this.finishNode(t, "CatchClause");
                    }
                    return e1.finalizer = this.eat(C._finally) ? this.parseBlock() : null, e1.handler || e1.finalizer || this.raise(e1.start, "Missing catch or finally clause"), this.finishNode(e1, "TryStatement");
                }, fe.parseVarStatement = function(e1, t, r) {
                    return this.next(), this.parseVar(e1, !1, t, r), this.semicolon(), this.finishNode(e1, "VariableDeclaration");
                }, fe.parseWhileStatement = function(e1) {
                    return this.next(), e1.test = this.parseParenExpression(), this.labels.push(de), e1.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(e1, "WhileStatement");
                }, fe.parseWithStatement = function(e1) {
                    return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), e1.object = this.parseParenExpression(), e1.body = this.parseStatement("with"), this.finishNode(e1, "WithStatement");
                }, fe.parseEmptyStatement = function(e1) {
                    return this.next(), this.finishNode(e1, "EmptyStatement");
                }, fe.parseLabeledStatement = function(e1, t, r, n) {
                    for(var s = 0, i = this.labels; s < i.length; s += 1)i[s].name === t && this.raise(r.start, "Label '" + t + "' is already declared");
                    for(var o = this.type.isLoop ? "loop" : this.type === C._switch ? "switch" : null, a = this.labels.length - 1; a >= 0; a--){
                        var u = this.labels[a];
                        if (u.statementStart !== e1.start) break;
                        u.statementStart = this.start, u.kind = o;
                    }
                    return this.labels.push({
                        name: t,
                        kind: o,
                        statementStart: this.start
                    }), e1.body = this.parseStatement(n ? -1 === n.indexOf("label") ? n + "label" : n : "label"), this.labels.pop(), e1.label = r, this.finishNode(e1, "LabeledStatement");
                }, fe.parseExpressionStatement = function(e1, t) {
                    return e1.expression = t, this.semicolon(), this.finishNode(e1, "ExpressionStatement");
                }, fe.parseBlock = function(e1, t, r) {
                    for(void 0 === e1 && (e1 = !0), void 0 === t && (t = this.startNode()), t.body = [], this.expect(C.braceL), e1 && this.enterScope(0); this.type !== C.braceR;){
                        var n = this.parseStatement(null);
                        t.body.push(n);
                    }
                    return r && (this.strict = !1), this.next(), e1 && this.exitScope(), this.finishNode(t, "BlockStatement");
                }, fe.parseFor = function(e1, t) {
                    return e1.init = t, this.expect(C.semi), e1.test = this.type === C.semi ? null : this.parseExpression(), this.expect(C.semi), e1.update = this.type === C.parenR ? null : this.parseExpression(), this.expect(C.parenR), e1.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e1, "ForStatement");
                }, fe.parseForIn = function(e1, t) {
                    var r = this.type === C._in;
                    return this.next(), "VariableDeclaration" === t.type && null != t.declarations[0].init && (!r || this.options.ecmaVersion < 8 || this.strict || "var" !== t.kind || "Identifier" !== t.declarations[0].id.type) && this.raise(t.start, (r ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"), e1.left = t, e1.right = r ? this.parseExpression() : this.parseMaybeAssign(), this.expect(C.parenR), e1.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e1, r ? "ForInStatement" : "ForOfStatement");
                }, fe.parseVar = function(e1, t, r, n) {
                    for(e1.declarations = [], e1.kind = r;;){
                        var s = this.startNode();
                        if (this.parseVarId(s, r), this.eat(C.eq) ? s.init = this.parseMaybeAssign(t) : n || "const" !== r || this.type === C._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? n || "using" !== r && "await using" !== r || !(this.options.ecmaVersion >= 17) || this.type === C._in || this.isContextual("of") ? n || "Identifier" === s.id.type || t && (this.type === C._in || this.isContextual("of")) ? s.init = null : this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : this.raise(this.lastTokEnd, "Missing initializer in " + r + " declaration") : this.unexpected(), e1.declarations.push(this.finishNode(s, "VariableDeclarator")), !this.eat(C.comma)) break;
                    }
                    return e1;
                }, fe.parseVarId = function(e1, t) {
                    e1.id = "using" === t || "await using" === t ? this.parseIdent() : this.parseBindingAtom(), this.checkLValPattern(e1.id, "var" === t ? re : ne, !1);
                };
                var ge = 1, ye = 2, Ee = 4;
                function xe(e1, t) {
                    var r = t.key.name, n = e1[r], s = "true";
                    return "MethodDefinition" !== t.type || "get" !== t.kind && "set" !== t.kind || (s = (t.static ? "s" : "i") + t.kind), "iget" === n && "iset" === s || "iset" === n && "iget" === s || "sget" === n && "sset" === s || "sset" === n && "sget" === s ? (e1[r] = "true", !1) : !!n || (e1[r] = s, !1);
                }
                function Ce(e1, t) {
                    var r = e1.computed, n = e1.key;
                    return !r && ("Identifier" === n.type && n.name === t || "Literal" === n.type && n.value === t);
                }
                fe.parseFunction = function(e1, t, r, n, s) {
                    this.initFunction(e1), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !n) && (this.type === C.star && t & ye && this.unexpected(), e1.generator = this.eat(C.star)), this.options.ecmaVersion >= 8 && (e1.async = !!n), t & ge && (e1.id = t & Ee && this.type !== C.name ? null : this.parseIdent(), !e1.id || t & ye || this.checkLValSimple(e1.id, this.strict || e1.generator || e1.async ? this.treatFunctionsAsVar ? re : ne : se));
                    var i = this.yieldPos, o = this.awaitPos, a = this.awaitIdentPos;
                    return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(ee(e1.async, e1.generator)), t & ge || (e1.id = this.type === C.name ? this.parseIdent() : null), this.parseFunctionParams(e1), this.parseFunctionBody(e1, r, !1, s), this.yieldPos = i, this.awaitPos = o, this.awaitIdentPos = a, this.finishNode(e1, t & ge ? "FunctionDeclaration" : "FunctionExpression");
                }, fe.parseFunctionParams = function(e1) {
                    this.expect(C.parenL), e1.params = this.parseBindingList(C.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
                }, fe.parseClass = function(e1, t) {
                    this.next();
                    var r = this.strict;
                    this.strict = !0, this.parseClassId(e1, t), this.parseClassSuper(e1);
                    var n = this.enterClassBody(), s = this.startNode(), i = !1;
                    for(s.body = [], this.expect(C.braceL); this.type !== C.braceR;){
                        var o = this.parseClassElement(null !== e1.superClass);
                        o && (s.body.push(o), "MethodDefinition" === o.type && "constructor" === o.kind ? (i && this.raiseRecoverable(o.start, "Duplicate constructor in the same class"), i = !0) : o.key && "PrivateIdentifier" === o.key.type && xe(n, o) && this.raiseRecoverable(o.key.start, "Identifier '#" + o.key.name + "' has already been declared"));
                    }
                    return this.strict = r, this.next(), e1.body = this.finishNode(s, "ClassBody"), this.exitClassBody(), this.finishNode(e1, t ? "ClassDeclaration" : "ClassExpression");
                }, fe.parseClassElement = function(e1) {
                    if (this.eat(C.semi)) return null;
                    var t = this.options.ecmaVersion, r = this.startNode(), n = "", s = !1, i = !1, o = "method", a = !1;
                    if (this.eatContextual("static")) {
                        if (t >= 13 && this.eat(C.braceL)) return this.parseClassStaticBlock(r), r;
                        this.isClassElementNameStart() || this.type === C.star ? a = !0 : n = "static";
                    }
                    if (r.static = a, !n && t >= 8 && this.eatContextual("async") && (!this.isClassElementNameStart() && this.type !== C.star || this.canInsertSemicolon() ? n = "async" : i = !0), !n && (t >= 9 || !i) && this.eat(C.star) && (s = !0), !n && !i && !s) {
                        var u = this.value;
                        (this.eatContextual("get") || this.eatContextual("set")) && (this.isClassElementNameStart() ? o = u : n = u);
                    }
                    if (n ? (r.computed = !1, r.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc), r.key.name = n, this.finishNode(r.key, "Identifier")) : this.parseClassElementName(r), t < 13 || this.type === C.parenL || "method" !== o || s || i) {
                        var l = !r.static && Ce(r, "constructor"), c = l && e1;
                        l && "method" !== o && this.raise(r.key.start, "Constructor can't have get/set modifier"), r.kind = l ? "constructor" : o, this.parseClassMethod(r, s, i, c);
                    } else this.parseClassField(r);
                    return r;
                }, fe.isClassElementNameStart = function() {
                    return this.type === C.name || this.type === C.privateId || this.type === C.num || this.type === C.string || this.type === C.bracketL || this.type.keyword;
                }, fe.parseClassElementName = function(e1) {
                    this.type === C.privateId ? ("constructor" === this.value && this.raise(this.start, "Classes can't have an element named '#constructor'"), e1.computed = !1, e1.key = this.parsePrivateIdent()) : this.parsePropertyName(e1);
                }, fe.parseClassMethod = function(e1, t, r, n) {
                    var s = e1.key;
                    "constructor" === e1.kind ? (t && this.raise(s.start, "Constructor can't be a generator"), r && this.raise(s.start, "Constructor can't be an async method")) : e1.static && Ce(e1, "prototype") && this.raise(s.start, "Classes may not have a static property named prototype");
                    var i = e1.value = this.parseMethod(t, r, n);
                    return "get" === e1.kind && 0 !== i.params.length && this.raiseRecoverable(i.start, "getter should have no params"), "set" === e1.kind && 1 !== i.params.length && this.raiseRecoverable(i.start, "setter should have exactly one param"), "set" === e1.kind && "RestElement" === i.params[0].type && this.raiseRecoverable(i.params[0].start, "Setter cannot use rest params"), this.finishNode(e1, "MethodDefinition");
                }, fe.parseClassField = function(e1) {
                    return Ce(e1, "constructor") ? this.raise(e1.key.start, "Classes can't have a field named 'constructor'") : e1.static && Ce(e1, "prototype") && this.raise(e1.key.start, "Classes can't have a static field named 'prototype'"), this.eat(C.eq) ? (this.enterScope(Y | H), e1.value = this.parseMaybeAssign(), this.exitScope()) : e1.value = null, this.semicolon(), this.finishNode(e1, "PropertyDefinition");
                }, fe.parseClassStaticBlock = function(e1) {
                    e1.body = [];
                    var t = this.labels;
                    for(this.labels = [], this.enterScope(Q | H); this.type !== C.braceR;){
                        var r = this.parseStatement(null);
                        e1.body.push(r);
                    }
                    return this.next(), this.exitScope(), this.labels = t, this.finishNode(e1, "StaticBlock");
                }, fe.parseClassId = function(e1, t) {
                    this.type === C.name ? (e1.id = this.parseIdent(), t && this.checkLValSimple(e1.id, ne, !1)) : (!0 === t && this.unexpected(), e1.id = null);
                }, fe.parseClassSuper = function(e1) {
                    e1.superClass = this.eat(C._extends) ? this.parseExprSubscripts(null, !1) : null;
                }, fe.enterClassBody = function() {
                    var e1 = {
                        declared: Object.create(null),
                        used: []
                    };
                    return this.privateNameStack.push(e1), e1.declared;
                }, fe.exitClassBody = function() {
                    var e1 = this.privateNameStack.pop(), t = e1.declared, r = e1.used;
                    if (this.options.checkPrivateFields) for(var n = this.privateNameStack.length, s = 0 === n ? null : this.privateNameStack[n - 1], i = 0; i < r.length; ++i){
                        var o = r[i];
                        k(t, o.name) || (s ? s.used.push(o) : this.raiseRecoverable(o.start, "Private field '#" + o.name + "' must be declared in an enclosing class"));
                    }
                }, fe.parseExportAllDeclaration = function(e1, t) {
                    return this.options.ecmaVersion >= 11 && (this.eatContextual("as") ? (e1.exported = this.parseModuleExportName(), this.checkExport(t, e1.exported, this.lastTokStart)) : e1.exported = null), this.expectContextual("from"), this.type !== C.string && this.unexpected(), e1.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (e1.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(e1, "ExportAllDeclaration");
                }, fe.parseExport = function(e1, t) {
                    if (this.next(), this.eat(C.star)) return this.parseExportAllDeclaration(e1, t);
                    if (this.eat(C._default)) return this.checkExport(t, "default", this.lastTokStart), e1.declaration = this.parseExportDefaultDeclaration(), this.finishNode(e1, "ExportDefaultDeclaration");
                    if (this.shouldParseExportStatement()) e1.declaration = this.parseExportDeclaration(e1), "VariableDeclaration" === e1.declaration.type ? this.checkVariableExport(t, e1.declaration.declarations) : this.checkExport(t, e1.declaration.id, e1.declaration.id.start), e1.specifiers = [], e1.source = null, this.options.ecmaVersion >= 16 && (e1.attributes = []);
                    else {
                        if (e1.declaration = null, e1.specifiers = this.parseExportSpecifiers(t), this.eatContextual("from")) this.type !== C.string && this.unexpected(), e1.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (e1.attributes = this.parseWithClause());
                        else {
                            for(var r = 0, n = e1.specifiers; r < n.length; r += 1){
                                var s = n[r];
                                this.checkUnreserved(s.local), this.checkLocalExport(s.local), "Literal" === s.local.type && this.raise(s.local.start, "A string literal cannot be used as an exported binding without `from`.");
                            }
                            e1.source = null, this.options.ecmaVersion >= 16 && (e1.attributes = []);
                        }
                        this.semicolon();
                    }
                    return this.finishNode(e1, "ExportNamedDeclaration");
                }, fe.parseExportDeclaration = function(e1) {
                    return this.parseStatement(null);
                }, fe.parseExportDefaultDeclaration = function() {
                    var e1;
                    if (this.type === C._function || (e1 = this.isAsyncFunction())) {
                        var t = this.startNode();
                        return this.next(), e1 && this.next(), this.parseFunction(t, ge | Ee, !1, e1);
                    }
                    if (this.type === C._class) {
                        var r = this.startNode();
                        return this.parseClass(r, "nullableID");
                    }
                    var n = this.parseMaybeAssign();
                    return this.semicolon(), n;
                }, fe.checkExport = function(e1, t, r) {
                    e1 && ("string" != typeof t && (t = "Identifier" === t.type ? t.name : t.value), k(e1, t) && this.raiseRecoverable(r, "Duplicate export '" + t + "'"), e1[t] = !0);
                }, fe.checkPatternExport = function(e1, t) {
                    var r = t.type;
                    if ("Identifier" === r) this.checkExport(e1, t, t.start);
                    else if ("ObjectPattern" === r) for(var n = 0, s = t.properties; n < s.length; n += 1){
                        var i = s[n];
                        this.checkPatternExport(e1, i);
                    }
                    else if ("ArrayPattern" === r) for(var o = 0, a = t.elements; o < a.length; o += 1){
                        var u = a[o];
                        u && this.checkPatternExport(e1, u);
                    }
                    else "Property" === r ? this.checkPatternExport(e1, t.value) : "AssignmentPattern" === r ? this.checkPatternExport(e1, t.left) : "RestElement" === r && this.checkPatternExport(e1, t.argument);
                }, fe.checkVariableExport = function(e1, t) {
                    if (e1) for(var r = 0, n = t; r < n.length; r += 1){
                        var s = n[r];
                        this.checkPatternExport(e1, s.id);
                    }
                }, fe.shouldParseExportStatement = function() {
                    return "var" === this.type.keyword || "const" === this.type.keyword || "class" === this.type.keyword || "function" === this.type.keyword || this.isLet() || this.isAsyncFunction();
                }, fe.parseExportSpecifier = function(e1) {
                    var t = this.startNode();
                    return t.local = this.parseModuleExportName(), t.exported = this.eatContextual("as") ? this.parseModuleExportName() : t.local, this.checkExport(e1, t.exported, t.exported.start), this.finishNode(t, "ExportSpecifier");
                }, fe.parseExportSpecifiers = function(e1) {
                    var t = [], r = !0;
                    for(this.expect(C.braceL); !this.eat(C.braceR);){
                        if (r) r = !1;
                        else if (this.expect(C.comma), this.afterTrailingComma(C.braceR)) break;
                        t.push(this.parseExportSpecifier(e1));
                    }
                    return t;
                }, fe.parseImport = function(e1) {
                    return this.next(), this.type === C.string ? (e1.specifiers = me, e1.source = this.parseExprAtom()) : (e1.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), e1.source = this.type === C.string ? this.parseExprAtom() : this.unexpected()), this.options.ecmaVersion >= 16 && (e1.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(e1, "ImportDeclaration");
                }, fe.parseImportSpecifier = function() {
                    var e1 = this.startNode();
                    return e1.imported = this.parseModuleExportName(), this.eatContextual("as") ? e1.local = this.parseIdent() : (this.checkUnreserved(e1.imported), e1.local = e1.imported), this.checkLValSimple(e1.local, ne), this.finishNode(e1, "ImportSpecifier");
                }, fe.parseImportDefaultSpecifier = function() {
                    var e1 = this.startNode();
                    return e1.local = this.parseIdent(), this.checkLValSimple(e1.local, ne), this.finishNode(e1, "ImportDefaultSpecifier");
                }, fe.parseImportNamespaceSpecifier = function() {
                    var e1 = this.startNode();
                    return this.next(), this.expectContextual("as"), e1.local = this.parseIdent(), this.checkLValSimple(e1.local, ne), this.finishNode(e1, "ImportNamespaceSpecifier");
                }, fe.parseImportSpecifiers = function() {
                    var e1 = [], t = !0;
                    if (this.type === C.name && (e1.push(this.parseImportDefaultSpecifier()), !this.eat(C.comma))) return e1;
                    if (this.type === C.star) return e1.push(this.parseImportNamespaceSpecifier()), e1;
                    for(this.expect(C.braceL); !this.eat(C.braceR);){
                        if (t) t = !1;
                        else if (this.expect(C.comma), this.afterTrailingComma(C.braceR)) break;
                        e1.push(this.parseImportSpecifier());
                    }
                    return e1;
                }, fe.parseWithClause = function() {
                    var e1 = [];
                    if (!this.eat(C._with)) return e1;
                    this.expect(C.braceL);
                    for(var t = {}, r = !0; !this.eat(C.braceR);){
                        if (r) r = !1;
                        else if (this.expect(C.comma), this.afterTrailingComma(C.braceR)) break;
                        var n = this.parseImportAttribute(), s = "Identifier" === n.key.type ? n.key.name : n.key.value;
                        k(t, s) && this.raiseRecoverable(n.key.start, "Duplicate attribute key '" + s + "'"), t[s] = !0, e1.push(n);
                    }
                    return e1;
                }, fe.parseImportAttribute = function() {
                    var e1 = this.startNode();
                    return e1.key = this.type === C.string ? this.parseExprAtom() : this.parseIdent("never" !== this.options.allowReserved), this.expect(C.colon), this.type !== C.string && this.unexpected(), e1.value = this.parseExprAtom(), this.finishNode(e1, "ImportAttribute");
                }, fe.parseModuleExportName = function() {
                    if (this.options.ecmaVersion >= 13 && this.type === C.string) {
                        var e1 = this.parseLiteral(this.value);
                        return F.test(e1.value) && this.raise(e1.start, "An export name cannot include a lone surrogate."), e1;
                    }
                    return this.parseIdent(!0);
                }, fe.adaptDirectivePrologue = function(e1) {
                    for(var t = 0; t < e1.length && this.isDirectiveCandidate(e1[t]); ++t)e1[t].directive = e1[t].expression.raw.slice(1, -1);
                }, fe.isDirectiveCandidate = function(e1) {
                    return this.options.ecmaVersion >= 5 && "ExpressionStatement" === e1.type && "Literal" === e1.expression.type && "string" == typeof e1.expression.value && ('"' === this.input[e1.start] || "'" === this.input[e1.start]);
                };
                var Se = ae.prototype;
                Se.toAssignable = function(e1, t, r) {
                    if (this.options.ecmaVersion >= 6 && e1) switch(e1.type){
                        case "Identifier":
                            this.inAsync && "await" === e1.name && this.raise(e1.start, "Cannot use 'await' as identifier inside an async function");
                            break;
                        case "ObjectPattern":
                        case "ArrayPattern":
                        case "AssignmentPattern":
                        case "RestElement":
                            break;
                        case "ObjectExpression":
                            e1.type = "ObjectPattern", r && this.checkPatternErrors(r, !0);
                            for(var n = 0, s = e1.properties; n < s.length; n += 1){
                                var i = s[n];
                                this.toAssignable(i, t), "RestElement" !== i.type || "ArrayPattern" !== i.argument.type && "ObjectPattern" !== i.argument.type || this.raise(i.argument.start, "Unexpected token");
                            }
                            break;
                        case "Property":
                            "init" !== e1.kind && this.raise(e1.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(e1.value, t);
                            break;
                        case "ArrayExpression":
                            e1.type = "ArrayPattern", r && this.checkPatternErrors(r, !0), this.toAssignableList(e1.elements, t);
                            break;
                        case "SpreadElement":
                            e1.type = "RestElement", this.toAssignable(e1.argument, t), "AssignmentPattern" === e1.argument.type && this.raise(e1.argument.start, "Rest elements cannot have a default value");
                            break;
                        case "AssignmentExpression":
                            "=" !== e1.operator && this.raise(e1.left.end, "Only '=' operator can be used for specifying default value."), e1.type = "AssignmentPattern", delete e1.operator, this.toAssignable(e1.left, t);
                            break;
                        case "ParenthesizedExpression":
                            this.toAssignable(e1.expression, t, r);
                            break;
                        case "ChainExpression":
                            this.raiseRecoverable(e1.start, "Optional chaining cannot appear in left-hand side");
                            break;
                        case "MemberExpression":
                            if (!t) break;
                        default:
                            this.raise(e1.start, "Assigning to rvalue");
                    }
                    else r && this.checkPatternErrors(r, !0);
                    return e1;
                }, Se.toAssignableList = function(e1, t) {
                    for(var r = e1.length, n = 0; n < r; n++){
                        var s = e1[n];
                        s && this.toAssignable(s, t);
                    }
                    if (r) {
                        var i = e1[r - 1];
                        6 === this.options.ecmaVersion && t && i && "RestElement" === i.type && "Identifier" !== i.argument.type && this.unexpected(i.argument.start);
                    }
                    return e1;
                }, Se.parseSpread = function(e1) {
                    var t = this.startNode();
                    return this.next(), t.argument = this.parseMaybeAssign(!1, e1), this.finishNode(t, "SpreadElement");
                }, Se.parseRestBinding = function() {
                    var e1 = this.startNode();
                    return this.next(), 6 === this.options.ecmaVersion && this.type !== C.name && this.unexpected(), e1.argument = this.parseBindingAtom(), this.finishNode(e1, "RestElement");
                }, Se.parseBindingAtom = function() {
                    if (this.options.ecmaVersion >= 6) switch(this.type){
                        case C.bracketL:
                            var e1 = this.startNode();
                            return this.next(), e1.elements = this.parseBindingList(C.bracketR, !0, !0), this.finishNode(e1, "ArrayPattern");
                        case C.braceL:
                            return this.parseObj(!0);
                    }
                    return this.parseIdent();
                }, Se.parseBindingList = function(e1, t, r, n) {
                    for(var s = [], i = !0; !this.eat(e1);)if (i ? i = !1 : this.expect(C.comma), t && this.type === C.comma) s.push(null);
                    else {
                        if (r && this.afterTrailingComma(e1)) break;
                        if (this.type === C.ellipsis) {
                            var o = this.parseRestBinding();
                            this.parseBindingListItem(o), s.push(o), this.type === C.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.expect(e1);
                            break;
                        }
                        s.push(this.parseAssignableListItem(n));
                    }
                    return s;
                }, Se.parseAssignableListItem = function(e1) {
                    var t = this.parseMaybeDefault(this.start, this.startLoc);
                    return this.parseBindingListItem(t), t;
                }, Se.parseBindingListItem = function(e1) {
                    return e1;
                }, Se.parseMaybeDefault = function(e1, t, r) {
                    if (r = r || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(C.eq)) return r;
                    var n = this.startNodeAt(e1, t);
                    return n.left = r, n.right = this.parseMaybeAssign(), this.finishNode(n, "AssignmentPattern");
                }, Se.checkLValSimple = function(e1, t, r) {
                    void 0 === t && (t = te);
                    var n = t !== te;
                    switch(e1.type){
                        case "Identifier":
                            this.strict && this.reservedWordsStrictBind.test(e1.name) && this.raiseRecoverable(e1.start, (n ? "Binding " : "Assigning to ") + e1.name + " in strict mode"), n && (t === ne && "let" === e1.name && this.raiseRecoverable(e1.start, "let is disallowed as a lexically bound name"), r && (k(r, e1.name) && this.raiseRecoverable(e1.start, "Argument name clash"), r[e1.name] = !0), t !== oe && this.declareName(e1.name, t, e1.start));
                            break;
                        case "ChainExpression":
                            this.raiseRecoverable(e1.start, "Optional chaining cannot appear in left-hand side");
                            break;
                        case "MemberExpression":
                            n && this.raiseRecoverable(e1.start, "Binding member expression");
                            break;
                        case "ParenthesizedExpression":
                            return n && this.raiseRecoverable(e1.start, "Binding parenthesized expression"), this.checkLValSimple(e1.expression, t, r);
                        default:
                            this.raise(e1.start, (n ? "Binding" : "Assigning to") + " rvalue");
                    }
                }, Se.checkLValPattern = function(e1, t, r) {
                    switch(void 0 === t && (t = te), e1.type){
                        case "ObjectPattern":
                            for(var n = 0, s = e1.properties; n < s.length; n += 1){
                                var i = s[n];
                                this.checkLValInnerPattern(i, t, r);
                            }
                            break;
                        case "ArrayPattern":
                            for(var o = 0, a = e1.elements; o < a.length; o += 1){
                                var u = a[o];
                                u && this.checkLValInnerPattern(u, t, r);
                            }
                            break;
                        default:
                            this.checkLValSimple(e1, t, r);
                    }
                }, Se.checkLValInnerPattern = function(e1, t, r) {
                    switch(void 0 === t && (t = te), e1.type){
                        case "Property":
                            this.checkLValInnerPattern(e1.value, t, r);
                            break;
                        case "AssignmentPattern":
                            this.checkLValPattern(e1.left, t, r);
                            break;
                        case "RestElement":
                            this.checkLValPattern(e1.argument, t, r);
                            break;
                        default:
                            this.checkLValPattern(e1, t, r);
                    }
                };
                var be = function(e1, t, r, n, s) {
                    this.token = e1, this.isExpr = !!t, this.preserveSpace = !!r, this.override = n, this.generator = !!s;
                }, ve = {
                    b_stat: new be("{", !1),
                    b_expr: new be("{", !0),
                    b_tmpl: new be("${", !1),
                    p_stat: new be("(", !1),
                    p_expr: new be("(", !0),
                    q_tmpl: new be("`", !0, !0, function(e1) {
                        return e1.tryReadTemplateToken();
                    }),
                    f_stat: new be("function", !1),
                    f_expr: new be("function", !0),
                    f_expr_gen: new be("function", !0, !1, null, !0),
                    f_gen: new be("function", !1, !1, null, !0)
                }, Ae = ae.prototype;
                Ae.initialContext = function() {
                    return [
                        ve.b_stat
                    ];
                }, Ae.curContext = function() {
                    return this.context[this.context.length - 1];
                }, Ae.braceIsBlock = function(e1) {
                    var t = this.curContext();
                    return t === ve.f_expr || t === ve.f_stat || (e1 !== C.colon || t !== ve.b_stat && t !== ve.b_expr ? e1 === C._return || e1 === C.name && this.exprAllowed ? S.test(this.input.slice(this.lastTokEnd, this.start)) : e1 === C._else || e1 === C.semi || e1 === C.eof || e1 === C.parenR || e1 === C.arrow || (e1 === C.braceL ? t === ve.b_stat : e1 !== C._var && e1 !== C._const && e1 !== C.name && !this.exprAllowed) : !t.isExpr);
                }, Ae.inGeneratorContext = function() {
                    for(var e1 = this.context.length - 1; e1 >= 1; e1--){
                        var t = this.context[e1];
                        if ("function" === t.token) return t.generator;
                    }
                    return !1;
                }, Ae.updateContext = function(e1) {
                    var t, r = this.type;
                    r.keyword && e1 === C.dot ? this.exprAllowed = !1 : (t = r.updateContext) ? t.call(this, e1) : this.exprAllowed = r.beforeExpr;
                }, Ae.overrideContext = function(e1) {
                    this.curContext() !== e1 && (this.context[this.context.length - 1] = e1);
                }, C.parenR.updateContext = C.braceR.updateContext = function() {
                    if (1 !== this.context.length) {
                        var e1 = this.context.pop();
                        e1 === ve.b_stat && "function" === this.curContext().token && (e1 = this.context.pop()), this.exprAllowed = !e1.isExpr;
                    } else this.exprAllowed = !0;
                }, C.braceL.updateContext = function(e1) {
                    this.context.push(this.braceIsBlock(e1) ? ve.b_stat : ve.b_expr), this.exprAllowed = !0;
                }, C.dollarBraceL.updateContext = function() {
                    this.context.push(ve.b_tmpl), this.exprAllowed = !0;
                }, C.parenL.updateContext = function(e1) {
                    var t = e1 === C._if || e1 === C._for || e1 === C._with || e1 === C._while;
                    this.context.push(t ? ve.p_stat : ve.p_expr), this.exprAllowed = !0;
                }, C.incDec.updateContext = function() {}, C._function.updateContext = C._class.updateContext = function(e1) {
                    !e1.beforeExpr || e1 === C._else || e1 === C.semi && this.curContext() !== ve.p_stat || e1 === C._return && S.test(this.input.slice(this.lastTokEnd, this.start)) || (e1 === C.colon || e1 === C.braceL) && this.curContext() === ve.b_stat ? this.context.push(ve.f_stat) : this.context.push(ve.f_expr), this.exprAllowed = !1;
                }, C.colon.updateContext = function() {
                    "function" === this.curContext().token && this.context.pop(), this.exprAllowed = !0;
                }, C.backQuote.updateContext = function() {
                    this.curContext() === ve.q_tmpl ? this.context.pop() : this.context.push(ve.q_tmpl), this.exprAllowed = !1;
                }, C.star.updateContext = function(e1) {
                    if (e1 === C._function) {
                        var t = this.context.length - 1;
                        this.context[t] === ve.f_expr ? this.context[t] = ve.f_expr_gen : this.context[t] = ve.f_gen;
                    }
                    this.exprAllowed = !0;
                }, C.name.updateContext = function(e1) {
                    var t = !1;
                    this.options.ecmaVersion >= 6 && e1 !== C.dot && ("of" === this.value && !this.exprAllowed || "yield" === this.value && this.inGeneratorContext()) && (t = !0), this.exprAllowed = t;
                };
                var Te = ae.prototype;
                function Re(e1) {
                    return "Identifier" === e1.type || "ParenthesizedExpression" === e1.type && Re(e1.expression);
                }
                function De(e1) {
                    return "MemberExpression" === e1.type && "PrivateIdentifier" === e1.property.type || "ChainExpression" === e1.type && De(e1.expression) || "ParenthesizedExpression" === e1.type && De(e1.expression);
                }
                Te.checkPropClash = function(e1, t, r) {
                    if (!(this.options.ecmaVersion >= 9 && "SpreadElement" === e1.type || this.options.ecmaVersion >= 6 && (e1.computed || e1.method || e1.shorthand))) {
                        var n, s = e1.key;
                        switch(s.type){
                            case "Identifier":
                                n = s.name;
                                break;
                            case "Literal":
                                n = String(s.value);
                                break;
                            default:
                                return;
                        }
                        var i = e1.kind;
                        if (this.options.ecmaVersion >= 6) "__proto__" === n && "init" === i && (t.proto && (r ? r.doubleProto < 0 && (r.doubleProto = s.start) : this.raiseRecoverable(s.start, "Redefinition of __proto__ property")), t.proto = !0);
                        else {
                            var o = t[n = "$" + n];
                            o ? ("init" === i ? this.strict && o.init || o.get || o.set : o.init || o[i]) && this.raiseRecoverable(s.start, "Redefinition of property") : o = t[n] = {
                                init: !1,
                                get: !1,
                                set: !1
                            }, o[i] = !0;
                        }
                    }
                }, Te.parseExpression = function(e1, t) {
                    var r = this.start, n = this.startLoc, s = this.parseMaybeAssign(e1, t);
                    if (this.type === C.comma) {
                        var i = this.startNodeAt(r, n);
                        for(i.expressions = [
                            s
                        ]; this.eat(C.comma);)i.expressions.push(this.parseMaybeAssign(e1, t));
                        return this.finishNode(i, "SequenceExpression");
                    }
                    return s;
                }, Te.parseMaybeAssign = function(e1, t, r) {
                    if (this.isContextual("yield")) {
                        if (this.inGenerator) return this.parseYield(e1);
                        this.exprAllowed = !1;
                    }
                    var n = !1, s = -1, i = -1, o = -1;
                    t ? (s = t.parenthesizedAssign, i = t.trailingComma, o = t.doubleProto, t.parenthesizedAssign = t.trailingComma = -1) : (t = new pe, n = !0);
                    var a = this.start, u = this.startLoc;
                    this.type !== C.parenL && this.type !== C.name || (this.potentialArrowAt = this.start, this.potentialArrowInForAwait = "await" === e1);
                    var l = this.parseMaybeConditional(e1, t);
                    if (r && (l = r.call(this, l, a, u)), this.type.isAssign) {
                        var c = this.startNodeAt(a, u);
                        return c.operator = this.value, this.type === C.eq && (l = this.toAssignable(l, !1, t)), n || (t.parenthesizedAssign = t.trailingComma = t.doubleProto = -1), t.shorthandAssign >= l.start && (t.shorthandAssign = -1), this.type === C.eq ? this.checkLValPattern(l) : this.checkLValSimple(l), c.left = l, this.next(), c.right = this.parseMaybeAssign(e1), o > -1 && (t.doubleProto = o), this.finishNode(c, "AssignmentExpression");
                    }
                    return n && this.checkExpressionErrors(t, !0), s > -1 && (t.parenthesizedAssign = s), i > -1 && (t.trailingComma = i), l;
                }, Te.parseMaybeConditional = function(e1, t) {
                    var r = this.start, n = this.startLoc, s = this.parseExprOps(e1, t);
                    if (this.checkExpressionErrors(t)) return s;
                    if (this.eat(C.question)) {
                        var i = this.startNodeAt(r, n);
                        return i.test = s, i.consequent = this.parseMaybeAssign(), this.expect(C.colon), i.alternate = this.parseMaybeAssign(e1), this.finishNode(i, "ConditionalExpression");
                    }
                    return s;
                }, Te.parseExprOps = function(e1, t) {
                    var r = this.start, n = this.startLoc, s = this.parseMaybeUnary(t, !1, !1, e1);
                    return this.checkExpressionErrors(t) || s.start === r && "ArrowFunctionExpression" === s.type ? s : this.parseExprOp(s, r, n, -1, e1);
                }, Te.parseExprOp = function(e1, t, r, n, s) {
                    var i = this.type.binop;
                    if (null != i && (!s || this.type !== C._in) && i > n) {
                        var o = this.type === C.logicalOR || this.type === C.logicalAND, a = this.type === C.coalesce;
                        a && (i = C.logicalAND.binop);
                        var u = this.value;
                        this.next();
                        var l = this.start, c = this.startLoc, p = this.parseExprOp(this.parseMaybeUnary(null, !1, !1, s), l, c, i, s), f = this.buildBinary(t, r, e1, p, u, o || a);
                        return (o && this.type === C.coalesce || a && (this.type === C.logicalOR || this.type === C.logicalAND)) && this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses"), this.parseExprOp(f, t, r, n, s);
                    }
                    return e1;
                }, Te.buildBinary = function(e1, t, r, n, s, i) {
                    "PrivateIdentifier" === n.type && this.raise(n.start, "Private identifier can only be left side of binary expression");
                    var o = this.startNodeAt(e1, t);
                    return o.left = r, o.operator = s, o.right = n, this.finishNode(o, i ? "LogicalExpression" : "BinaryExpression");
                }, Te.parseMaybeUnary = function(e1, t, r, n) {
                    var s, i = this.start, o = this.startLoc;
                    if (this.isContextual("await") && this.canAwait) s = this.parseAwait(n), t = !0;
                    else if (this.type.prefix) {
                        var a = this.startNode(), u = this.type === C.incDec;
                        a.operator = this.value, a.prefix = !0, this.next(), a.argument = this.parseMaybeUnary(null, !0, u, n), this.checkExpressionErrors(e1, !0), u ? this.checkLValSimple(a.argument) : this.strict && "delete" === a.operator && Re(a.argument) ? this.raiseRecoverable(a.start, "Deleting local variable in strict mode") : "delete" === a.operator && De(a.argument) ? this.raiseRecoverable(a.start, "Private fields can not be deleted") : t = !0, s = this.finishNode(a, u ? "UpdateExpression" : "UnaryExpression");
                    } else if (t || this.type !== C.privateId) {
                        if (s = this.parseExprSubscripts(e1, n), this.checkExpressionErrors(e1)) return s;
                        for(; this.type.postfix && !this.canInsertSemicolon();){
                            var l = this.startNodeAt(i, o);
                            l.operator = this.value, l.prefix = !1, l.argument = s, this.checkLValSimple(s), this.next(), s = this.finishNode(l, "UpdateExpression");
                        }
                    } else (n || 0 === this.privateNameStack.length) && this.options.checkPrivateFields && this.unexpected(), s = this.parsePrivateIdent(), this.type !== C._in && this.unexpected();
                    return r || !this.eat(C.starstar) ? s : t ? void this.unexpected(this.lastTokStart) : this.buildBinary(i, o, s, this.parseMaybeUnary(null, !1, !1, n), "**", !1);
                }, Te.parseExprSubscripts = function(e1, t) {
                    var r = this.start, n = this.startLoc, s = this.parseExprAtom(e1, t);
                    if ("ArrowFunctionExpression" === s.type && ")" !== this.input.slice(this.lastTokStart, this.lastTokEnd)) return s;
                    var i = this.parseSubscripts(s, r, n, !1, t);
                    return e1 && "MemberExpression" === i.type && (e1.parenthesizedAssign >= i.start && (e1.parenthesizedAssign = -1), e1.parenthesizedBind >= i.start && (e1.parenthesizedBind = -1), e1.trailingComma >= i.start && (e1.trailingComma = -1)), i;
                }, Te.parseSubscripts = function(e1, t, r, n, s) {
                    for(var i = this.options.ecmaVersion >= 8 && "Identifier" === e1.type && "async" === e1.name && this.lastTokEnd === e1.end && !this.canInsertSemicolon() && e1.end - e1.start == 5 && this.potentialArrowAt === e1.start, o = !1;;){
                        var a = this.parseSubscript(e1, t, r, n, i, o, s);
                        if (a.optional && (o = !0), a === e1 || "ArrowFunctionExpression" === a.type) {
                            if (o) {
                                var u = this.startNodeAt(t, r);
                                u.expression = a, a = this.finishNode(u, "ChainExpression");
                            }
                            return a;
                        }
                        e1 = a;
                    }
                }, Te.shouldParseAsyncArrow = function() {
                    return !this.canInsertSemicolon() && this.eat(C.arrow);
                }, Te.parseSubscriptAsyncArrow = function(e1, t, r, n) {
                    return this.parseArrowExpression(this.startNodeAt(e1, t), r, !0, n);
                }, Te.parseSubscript = function(e1, t, r, n, s, i, o) {
                    var a = this.options.ecmaVersion >= 11, u = a && this.eat(C.questionDot);
                    n && u && this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
                    var l = this.eat(C.bracketL);
                    if (l || u && this.type !== C.parenL && this.type !== C.backQuote || this.eat(C.dot)) {
                        var c = this.startNodeAt(t, r);
                        c.object = e1, l ? (c.property = this.parseExpression(), this.expect(C.bracketR)) : this.type === C.privateId && "Super" !== e1.type ? c.property = this.parsePrivateIdent() : c.property = this.parseIdent("never" !== this.options.allowReserved), c.computed = !!l, a && (c.optional = u), e1 = this.finishNode(c, "MemberExpression");
                    } else if (!n && this.eat(C.parenL)) {
                        var p = new pe, f = this.yieldPos, d = this.awaitPos, h = this.awaitIdentPos;
                        this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
                        var m = this.parseExprList(C.parenR, this.options.ecmaVersion >= 8, !1, p);
                        if (s && !u && this.shouldParseAsyncArrow()) return this.checkPatternErrors(p, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = f, this.awaitPos = d, this.awaitIdentPos = h, this.parseSubscriptAsyncArrow(t, r, m, o);
                        this.checkExpressionErrors(p, !0), this.yieldPos = f || this.yieldPos, this.awaitPos = d || this.awaitPos, this.awaitIdentPos = h || this.awaitIdentPos;
                        var g = this.startNodeAt(t, r);
                        g.callee = e1, g.arguments = m, a && (g.optional = u), e1 = this.finishNode(g, "CallExpression");
                    } else if (this.type === C.backQuote) {
                        (u || i) && this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
                        var y = this.startNodeAt(t, r);
                        y.tag = e1, y.quasi = this.parseTemplate({
                            isTagged: !0
                        }), e1 = this.finishNode(y, "TaggedTemplateExpression");
                    }
                    return e1;
                }, Te.parseExprAtom = function(e1, t, r) {
                    this.type === C.slash && this.readRegexp();
                    var n, s = this.potentialArrowAt === this.start;
                    switch(this.type){
                        case C._super:
                            return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), n = this.startNode(), this.next(), this.type !== C.parenL || this.allowDirectSuper || this.raise(n.start, "super() call outside constructor of a subclass"), this.type !== C.dot && this.type !== C.bracketL && this.type !== C.parenL && this.unexpected(), this.finishNode(n, "Super");
                        case C._this:
                            return n = this.startNode(), this.next(), this.finishNode(n, "ThisExpression");
                        case C.name:
                            var i = this.start, o = this.startLoc, a = this.containsEsc, u = this.parseIdent(!1);
                            if (this.options.ecmaVersion >= 8 && !a && "async" === u.name && !this.canInsertSemicolon() && this.eat(C._function)) return this.overrideContext(ve.f_expr), this.parseFunction(this.startNodeAt(i, o), 0, !1, !0, t);
                            if (s && !this.canInsertSemicolon()) {
                                if (this.eat(C.arrow)) return this.parseArrowExpression(this.startNodeAt(i, o), [
                                    u
                                ], !1, t);
                                if (this.options.ecmaVersion >= 8 && "async" === u.name && this.type === C.name && !a && (!this.potentialArrowInForAwait || "of" !== this.value || this.containsEsc)) return u = this.parseIdent(!1), !this.canInsertSemicolon() && this.eat(C.arrow) || this.unexpected(), this.parseArrowExpression(this.startNodeAt(i, o), [
                                    u
                                ], !0, t);
                            }
                            return u;
                        case C.regexp:
                            var l = this.value;
                            return (n = this.parseLiteral(l.value)).regex = {
                                pattern: l.pattern,
                                flags: l.flags
                            }, n;
                        case C.num:
                        case C.string:
                            return this.parseLiteral(this.value);
                        case C._null:
                        case C._true:
                        case C._false:
                            return (n = this.startNode()).value = this.type === C._null ? null : this.type === C._true, n.raw = this.type.keyword, this.next(), this.finishNode(n, "Literal");
                        case C.parenL:
                            var c = this.start, p = this.parseParenAndDistinguishExpression(s, t);
                            return e1 && (e1.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(p) && (e1.parenthesizedAssign = c), e1.parenthesizedBind < 0 && (e1.parenthesizedBind = c)), p;
                        case C.bracketL:
                            return n = this.startNode(), this.next(), n.elements = this.parseExprList(C.bracketR, !0, !0, e1), this.finishNode(n, "ArrayExpression");
                        case C.braceL:
                            return this.overrideContext(ve.b_expr), this.parseObj(!1, e1);
                        case C._function:
                            return n = this.startNode(), this.next(), this.parseFunction(n, 0);
                        case C._class:
                            return this.parseClass(this.startNode(), !1);
                        case C._new:
                            return this.parseNew();
                        case C.backQuote:
                            return this.parseTemplate();
                        case C._import:
                            return this.options.ecmaVersion >= 11 ? this.parseExprImport(r) : this.unexpected();
                        default:
                            return this.parseExprAtomDefault();
                    }
                }, Te.parseExprAtomDefault = function() {
                    this.unexpected();
                }, Te.parseExprImport = function(e1) {
                    var t = this.startNode();
                    if (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword import"), this.next(), this.type === C.parenL && !e1) return this.parseDynamicImport(t);
                    if (this.type === C.dot) {
                        var r = this.startNodeAt(t.start, t.loc && t.loc.start);
                        return r.name = "import", t.meta = this.finishNode(r, "Identifier"), this.parseImportMeta(t);
                    }
                    this.unexpected();
                }, Te.parseDynamicImport = function(e1) {
                    if (this.next(), e1.source = this.parseMaybeAssign(), this.options.ecmaVersion >= 16) this.eat(C.parenR) ? e1.options = null : (this.expect(C.comma), this.afterTrailingComma(C.parenR) ? e1.options = null : (e1.options = this.parseMaybeAssign(), this.eat(C.parenR) || (this.expect(C.comma), this.afterTrailingComma(C.parenR) || this.unexpected())));
                    else if (!this.eat(C.parenR)) {
                        var t = this.start;
                        this.eat(C.comma) && this.eat(C.parenR) ? this.raiseRecoverable(t, "Trailing comma is not allowed in import()") : this.unexpected(t);
                    }
                    return this.finishNode(e1, "ImportExpression");
                }, Te.parseImportMeta = function(e1) {
                    this.next();
                    var t = this.containsEsc;
                    return e1.property = this.parseIdent(!0), "meta" !== e1.property.name && this.raiseRecoverable(e1.property.start, "The only valid meta property for import is 'import.meta'"), t && this.raiseRecoverable(e1.start, "'import.meta' must not contain escaped characters"), "module" === this.options.sourceType || this.options.allowImportExportEverywhere || this.raiseRecoverable(e1.start, "Cannot use 'import.meta' outside a module"), this.finishNode(e1, "MetaProperty");
                }, Te.parseLiteral = function(e1) {
                    var t = this.startNode();
                    return t.value = e1, t.raw = this.input.slice(this.start, this.end), 110 === t.raw.charCodeAt(t.raw.length - 1) && (t.bigint = null != t.value ? t.value.toString() : t.raw.slice(0, -1).replace(/_/g, "")), this.next(), this.finishNode(t, "Literal");
                }, Te.parseParenExpression = function() {
                    this.expect(C.parenL);
                    var e1 = this.parseExpression();
                    return this.expect(C.parenR), e1;
                }, Te.shouldParseArrow = function(e1) {
                    return !this.canInsertSemicolon();
                }, Te.parseParenAndDistinguishExpression = function(e1, t) {
                    var r, n = this.start, s = this.startLoc, i = this.options.ecmaVersion >= 8;
                    if (this.options.ecmaVersion >= 6) {
                        this.next();
                        var o, a = this.start, u = this.startLoc, l = [], c = !0, p = !1, f = new pe, d = this.yieldPos, h = this.awaitPos;
                        for(this.yieldPos = 0, this.awaitPos = 0; this.type !== C.parenR;){
                            if (c ? c = !1 : this.expect(C.comma), i && this.afterTrailingComma(C.parenR, !0)) {
                                p = !0;
                                break;
                            }
                            if (this.type === C.ellipsis) {
                                o = this.start, l.push(this.parseParenItem(this.parseRestBinding())), this.type === C.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element");
                                break;
                            }
                            l.push(this.parseMaybeAssign(!1, f, this.parseParenItem));
                        }
                        var m = this.lastTokEnd, g = this.lastTokEndLoc;
                        if (this.expect(C.parenR), e1 && this.shouldParseArrow(l) && this.eat(C.arrow)) return this.checkPatternErrors(f, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = d, this.awaitPos = h, this.parseParenArrowList(n, s, l, t);
                        l.length && !p || this.unexpected(this.lastTokStart), o && this.unexpected(o), this.checkExpressionErrors(f, !0), this.yieldPos = d || this.yieldPos, this.awaitPos = h || this.awaitPos, l.length > 1 ? ((r = this.startNodeAt(a, u)).expressions = l, this.finishNodeAt(r, "SequenceExpression", m, g)) : r = l[0];
                    } else r = this.parseParenExpression();
                    if (this.options.preserveParens) {
                        var y = this.startNodeAt(n, s);
                        return y.expression = r, this.finishNode(y, "ParenthesizedExpression");
                    }
                    return r;
                }, Te.parseParenItem = function(e1) {
                    return e1;
                }, Te.parseParenArrowList = function(e1, t, r, n) {
                    return this.parseArrowExpression(this.startNodeAt(e1, t), r, !1, n);
                };
                var we = [];
                Te.parseNew = function() {
                    this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword new");
                    var e1 = this.startNode();
                    if (this.next(), this.options.ecmaVersion >= 6 && this.type === C.dot) {
                        var t = this.startNodeAt(e1.start, e1.loc && e1.loc.start);
                        t.name = "new", e1.meta = this.finishNode(t, "Identifier"), this.next();
                        var r = this.containsEsc;
                        return e1.property = this.parseIdent(!0), "target" !== e1.property.name && this.raiseRecoverable(e1.property.start, "The only valid meta property for new is 'new.target'"), r && this.raiseRecoverable(e1.start, "'new.target' must not contain escaped characters"), this.allowNewDotTarget || this.raiseRecoverable(e1.start, "'new.target' can only be used in functions and class static block"), this.finishNode(e1, "MetaProperty");
                    }
                    var n = this.start, s = this.startLoc;
                    return e1.callee = this.parseSubscripts(this.parseExprAtom(null, !1, !0), n, s, !0, !1), this.eat(C.parenL) ? e1.arguments = this.parseExprList(C.parenR, this.options.ecmaVersion >= 8, !1) : e1.arguments = we, this.finishNode(e1, "NewExpression");
                }, Te.parseTemplateElement = function(e1) {
                    var t = e1.isTagged, r = this.startNode();
                    return this.type === C.invalidTemplate ? (t || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), r.value = {
                        raw: this.value.replace(/\r\n?/g, "\n"),
                        cooked: null
                    }) : r.value = {
                        raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, "\n"),
                        cooked: this.value
                    }, this.next(), r.tail = this.type === C.backQuote, this.finishNode(r, "TemplateElement");
                }, Te.parseTemplate = function(e1) {
                    void 0 === e1 && (e1 = {});
                    var t = e1.isTagged;
                    void 0 === t && (t = !1);
                    var r = this.startNode();
                    this.next(), r.expressions = [];
                    var n = this.parseTemplateElement({
                        isTagged: t
                    });
                    for(r.quasis = [
                        n
                    ]; !n.tail;)this.type === C.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(C.dollarBraceL), r.expressions.push(this.parseExpression()), this.expect(C.braceR), r.quasis.push(n = this.parseTemplateElement({
                        isTagged: t
                    }));
                    return this.next(), this.finishNode(r, "TemplateLiteral");
                }, Te.isAsyncProp = function(e1) {
                    return !e1.computed && "Identifier" === e1.key.type && "async" === e1.key.name && (this.type === C.name || this.type === C.num || this.type === C.string || this.type === C.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === C.star) && !S.test(this.input.slice(this.lastTokEnd, this.start));
                }, Te.parseObj = function(e1, t) {
                    var r = this.startNode(), n = !0, s = {};
                    for(r.properties = [], this.next(); !this.eat(C.braceR);){
                        if (n) n = !1;
                        else if (this.expect(C.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(C.braceR)) break;
                        var i = this.parseProperty(e1, t);
                        e1 || this.checkPropClash(i, s, t), r.properties.push(i);
                    }
                    return this.finishNode(r, e1 ? "ObjectPattern" : "ObjectExpression");
                }, Te.parseProperty = function(e1, t) {
                    var r, n, s, i, o = this.startNode();
                    if (this.options.ecmaVersion >= 9 && this.eat(C.ellipsis)) return e1 ? (o.argument = this.parseIdent(!1), this.type === C.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.finishNode(o, "RestElement")) : (o.argument = this.parseMaybeAssign(!1, t), this.type === C.comma && t && t.trailingComma < 0 && (t.trailingComma = this.start), this.finishNode(o, "SpreadElement"));
                    this.options.ecmaVersion >= 6 && (o.method = !1, o.shorthand = !1, (e1 || t) && (s = this.start, i = this.startLoc), e1 || (r = this.eat(C.star)));
                    var a = this.containsEsc;
                    return this.parsePropertyName(o), !e1 && !a && this.options.ecmaVersion >= 8 && !r && this.isAsyncProp(o) ? (n = !0, r = this.options.ecmaVersion >= 9 && this.eat(C.star), this.parsePropertyName(o)) : n = !1, this.parsePropertyValue(o, e1, r, n, s, i, t, a), this.finishNode(o, "Property");
                }, Te.parseGetterSetter = function(e1) {
                    var t = e1.key.name;
                    this.parsePropertyName(e1), e1.value = this.parseMethod(!1), e1.kind = t;
                    var r = "get" === e1.kind ? 0 : 1;
                    if (e1.value.params.length !== r) {
                        var n = e1.value.start;
                        "get" === e1.kind ? this.raiseRecoverable(n, "getter should have no params") : this.raiseRecoverable(n, "setter should have exactly one param");
                    } else "set" === e1.kind && "RestElement" === e1.value.params[0].type && this.raiseRecoverable(e1.value.params[0].start, "Setter cannot use rest params");
                }, Te.parsePropertyValue = function(e1, t, r, n, s, i, o, a) {
                    (r || n) && this.type === C.colon && this.unexpected(), this.eat(C.colon) ? (e1.value = t ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, o), e1.kind = "init") : this.options.ecmaVersion >= 6 && this.type === C.parenL ? (t && this.unexpected(), e1.method = !0, e1.value = this.parseMethod(r, n), e1.kind = "init") : t || a || !(this.options.ecmaVersion >= 5) || e1.computed || "Identifier" !== e1.key.type || "get" !== e1.key.name && "set" !== e1.key.name || this.type === C.comma || this.type === C.braceR || this.type === C.eq ? this.options.ecmaVersion >= 6 && !e1.computed && "Identifier" === e1.key.type ? ((r || n) && this.unexpected(), this.checkUnreserved(e1.key), "await" !== e1.key.name || this.awaitIdentPos || (this.awaitIdentPos = s), t ? e1.value = this.parseMaybeDefault(s, i, this.copyNode(e1.key)) : this.type === C.eq && o ? (o.shorthandAssign < 0 && (o.shorthandAssign = this.start), e1.value = this.parseMaybeDefault(s, i, this.copyNode(e1.key))) : e1.value = this.copyNode(e1.key), e1.kind = "init", e1.shorthand = !0) : this.unexpected() : ((r || n) && this.unexpected(), this.parseGetterSetter(e1));
                }, Te.parsePropertyName = function(e1) {
                    if (this.options.ecmaVersion >= 6) {
                        if (this.eat(C.bracketL)) return e1.computed = !0, e1.key = this.parseMaybeAssign(), this.expect(C.bracketR), e1.key;
                        e1.computed = !1;
                    }
                    return e1.key = this.type === C.num || this.type === C.string ? this.parseExprAtom() : this.parseIdent("never" !== this.options.allowReserved);
                }, Te.initFunction = function(e1) {
                    e1.id = null, this.options.ecmaVersion >= 6 && (e1.generator = e1.expression = !1), this.options.ecmaVersion >= 8 && (e1.async = !1);
                }, Te.parseMethod = function(e1, t, r) {
                    var n = this.startNode(), s = this.yieldPos, i = this.awaitPos, o = this.awaitIdentPos;
                    return this.initFunction(n), this.options.ecmaVersion >= 6 && (n.generator = e1), this.options.ecmaVersion >= 8 && (n.async = !!t), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(ee(t, n.generator) | H | (r ? J : 0)), this.expect(C.parenL), n.params = this.parseBindingList(C.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(n, !1, !0, !1), this.yieldPos = s, this.awaitPos = i, this.awaitIdentPos = o, this.finishNode(n, "FunctionExpression");
                }, Te.parseArrowExpression = function(e1, t, r, n) {
                    var s = this.yieldPos, i = this.awaitPos, o = this.awaitIdentPos;
                    return this.enterScope(ee(r, !1) | X), this.initFunction(e1), this.options.ecmaVersion >= 8 && (e1.async = !!r), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, e1.params = this.toAssignableList(t, !0), this.parseFunctionBody(e1, !0, !1, n), this.yieldPos = s, this.awaitPos = i, this.awaitIdentPos = o, this.finishNode(e1, "ArrowFunctionExpression");
                }, Te.parseFunctionBody = function(e1, t, r, n) {
                    var s = t && this.type !== C.braceL, i = this.strict, o = !1;
                    if (s) e1.body = this.parseMaybeAssign(n), e1.expression = !0, this.checkParams(e1, !1);
                    else {
                        var a = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(e1.params);
                        i && !a || (o = this.strictDirective(this.end)) && a && this.raiseRecoverable(e1.start, "Illegal 'use strict' directive in function with non-simple parameter list");
                        var u = this.labels;
                        this.labels = [], o && (this.strict = !0), this.checkParams(e1, !i && !o && !t && !r && this.isSimpleParamList(e1.params)), this.strict && e1.id && this.checkLValSimple(e1.id, oe), e1.body = this.parseBlock(!1, void 0, o && !i), e1.expression = !1, this.adaptDirectivePrologue(e1.body.body), this.labels = u;
                    }
                    this.exitScope();
                }, Te.isSimpleParamList = function(e1) {
                    for(var t = 0, r = e1; t < r.length; t += 1)if ("Identifier" !== r[t].type) return !1;
                    return !0;
                }, Te.checkParams = function(e1, t) {
                    for(var r = Object.create(null), n = 0, s = e1.params; n < s.length; n += 1){
                        var i = s[n];
                        this.checkLValInnerPattern(i, re, t ? null : r);
                    }
                }, Te.parseExprList = function(e1, t, r, n) {
                    for(var s = [], i = !0; !this.eat(e1);){
                        if (i) i = !1;
                        else if (this.expect(C.comma), t && this.afterTrailingComma(e1)) break;
                        var o = void 0;
                        r && this.type === C.comma ? o = null : this.type === C.ellipsis ? (o = this.parseSpread(n), n && this.type === C.comma && n.trailingComma < 0 && (n.trailingComma = this.start)) : o = this.parseMaybeAssign(!1, n), s.push(o);
                    }
                    return s;
                }, Te.checkUnreserved = function(e1) {
                    var t = e1.start, r = e1.end, n = e1.name;
                    this.inGenerator && "yield" === n && this.raiseRecoverable(t, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && "await" === n && this.raiseRecoverable(t, "Cannot use 'await' as identifier inside an async function"), this.currentThisScope().flags & Z || "arguments" !== n || this.raiseRecoverable(t, "Cannot use 'arguments' in class field initializer"), !this.inClassStaticBlock || "arguments" !== n && "await" !== n || this.raise(t, "Cannot use " + n + " in class static initialization block"), this.keywords.test(n) && this.raise(t, "Unexpected keyword '" + n + "'"), this.options.ecmaVersion < 6 && -1 !== this.input.slice(t, r).indexOf("\\") || (this.strict ? this.reservedWordsStrict : this.reservedWords).test(n) && (this.inAsync || "await" !== n || this.raiseRecoverable(t, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(t, "The keyword '" + n + "' is reserved"));
                }, Te.parseIdent = function(e1) {
                    var t = this.parseIdentNode();
                    return this.next(!!e1), this.finishNode(t, "Identifier"), e1 || (this.checkUnreserved(t), "await" !== t.name || this.awaitIdentPos || (this.awaitIdentPos = t.start)), t;
                }, Te.parseIdentNode = function() {
                    var e1 = this.startNode();
                    return this.type === C.name ? e1.name = this.value : this.type.keyword ? (e1.name = this.type.keyword, "class" !== e1.name && "function" !== e1.name || this.lastTokEnd === this.lastTokStart + 1 && 46 === this.input.charCodeAt(this.lastTokStart) || this.context.pop(), this.type = C.name) : this.unexpected(), e1;
                }, Te.parsePrivateIdent = function() {
                    var e1 = this.startNode();
                    return this.type === C.privateId ? e1.name = this.value : this.unexpected(), this.next(), this.finishNode(e1, "PrivateIdentifier"), this.options.checkPrivateFields && (0 === this.privateNameStack.length ? this.raise(e1.start, "Private field '#" + e1.name + "' must be declared in an enclosing class") : this.privateNameStack[this.privateNameStack.length - 1].used.push(e1)), e1;
                }, Te.parseYield = function(e1) {
                    this.yieldPos || (this.yieldPos = this.start);
                    var t = this.startNode();
                    return this.next(), this.type === C.semi || this.canInsertSemicolon() || this.type !== C.star && !this.type.startsExpr ? (t.delegate = !1, t.argument = null) : (t.delegate = this.eat(C.star), t.argument = this.parseMaybeAssign(e1)), this.finishNode(t, "YieldExpression");
                }, Te.parseAwait = function(e1) {
                    this.awaitPos || (this.awaitPos = this.start);
                    var t = this.startNode();
                    return this.next(), t.argument = this.parseMaybeUnary(null, !0, !1, e1), this.finishNode(t, "AwaitExpression");
                };
                var _e = ae.prototype;
                _e.raise = function(e1, t) {
                    var r = U(this.input, e1);
                    t += " (" + r.line + ":" + r.column + ")", this.sourceFile && (t += " in " + this.sourceFile);
                    var n = new SyntaxError(t);
                    throw n.pos = e1, n.loc = r, n.raisedAt = this.pos, n;
                }, _e.raiseRecoverable = _e.raise, _e.curPosition = function() {
                    if (this.options.locations) return new N(this.curLine, this.pos - this.lineStart);
                };
                var ke = ae.prototype, Be = function(e1) {
                    this.flags = e1, this.var = [], this.lexical = [], this.functions = [];
                };
                ke.enterScope = function(e1) {
                    this.scopeStack.push(new Be(e1));
                }, ke.exitScope = function() {
                    this.scopeStack.pop();
                }, ke.treatFunctionsAsVarInScope = function(e1) {
                    return e1.flags & q || !this.inModule && e1.flags & $;
                }, ke.declareName = function(e1, t, r) {
                    var n = !1;
                    if (t === ne) {
                        var s = this.currentScope();
                        n = s.lexical.indexOf(e1) > -1 || s.functions.indexOf(e1) > -1 || s.var.indexOf(e1) > -1, s.lexical.push(e1), this.inModule && s.flags & $ && delete this.undefinedExports[e1];
                    } else if (t === ie) this.currentScope().lexical.push(e1);
                    else if (t === se) {
                        var i = this.currentScope();
                        n = this.treatFunctionsAsVar ? i.lexical.indexOf(e1) > -1 : i.lexical.indexOf(e1) > -1 || i.var.indexOf(e1) > -1, i.functions.push(e1);
                    } else for(var o = this.scopeStack.length - 1; o >= 0; --o){
                        var a = this.scopeStack[o];
                        if (a.lexical.indexOf(e1) > -1 && !(a.flags & z && a.lexical[0] === e1) || !this.treatFunctionsAsVarInScope(a) && a.functions.indexOf(e1) > -1) {
                            n = !0;
                            break;
                        }
                        if (a.var.push(e1), this.inModule && a.flags & $ && delete this.undefinedExports[e1], a.flags & Z) break;
                    }
                    n && this.raiseRecoverable(r, "Identifier '" + e1 + "' has already been declared");
                }, ke.checkLocalExport = function(e1) {
                    -1 === this.scopeStack[0].lexical.indexOf(e1.name) && -1 === this.scopeStack[0].var.indexOf(e1.name) && (this.undefinedExports[e1.name] = e1);
                }, ke.currentScope = function() {
                    return this.scopeStack[this.scopeStack.length - 1];
                }, ke.currentVarScope = function() {
                    for(var e1 = this.scopeStack.length - 1;; e1--){
                        var t = this.scopeStack[e1];
                        if (t.flags & (Z | Y | Q)) return t;
                    }
                }, ke.currentThisScope = function() {
                    for(var e1 = this.scopeStack.length - 1;; e1--){
                        var t = this.scopeStack[e1];
                        if (t.flags & (Z | Y | Q) && !(t.flags & X)) return t;
                    }
                };
                var Le = function(e1, t, r) {
                    this.type = "", this.start = t, this.end = 0, e1.options.locations && (this.loc = new O(e1, r)), e1.options.directSourceFile && (this.sourceFile = e1.options.directSourceFile), e1.options.ranges && (this.range = [
                        t,
                        0
                    ]);
                }, Pe = ae.prototype;
                function Ie(e1, t, r, n) {
                    return e1.type = t, e1.end = r, this.options.locations && (e1.loc.end = n), this.options.ranges && (e1.range[1] = r), e1;
                }
                Pe.startNode = function() {
                    return new Le(this, this.start, this.startLoc);
                }, Pe.startNodeAt = function(e1, t) {
                    return new Le(this, e1, t);
                }, Pe.finishNode = function(e1, t) {
                    return Ie.call(this, e1, t, this.lastTokEnd, this.lastTokEndLoc);
                }, Pe.finishNodeAt = function(e1, t, r, n) {
                    return Ie.call(this, e1, t, r, n);
                }, Pe.copyNode = function(e1) {
                    var t = new Le(this, e1.start, this.startLoc);
                    for(var r in e1)t[r] = e1[r];
                    return t;
                };
                var Fe = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", Ne = Fe + " Extended_Pictographic", Oe = Ne + " EBase EComp EMod EPres ExtPict", Ue = {
                    9: Fe,
                    10: Ne,
                    11: Ne,
                    12: Oe,
                    13: Oe,
                    14: Oe
                }, je = {
                    9: "",
                    10: "",
                    11: "",
                    12: "",
                    13: "",
                    14: "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji"
                }, Ve = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", Ke = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", Me = Ke + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", $e = Me + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho", qe = $e + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi", Ge = qe + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith", We = {
                    9: Ke,
                    10: Me,
                    11: $e,
                    12: qe,
                    13: Ge,
                    14: Ge + " Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sunu Sunuwar Todhri Todr Tulu_Tigalari Tutg Unknown Zzzz"
                }, Xe = {};
                function ze(e1) {
                    var t = Xe[e1] = {
                        binary: P(Ue[e1] + " " + Ve),
                        binaryOfStrings: P(je[e1]),
                        nonBinary: {
                            General_Category: P(Ve),
                            Script: P(We[e1])
                        }
                    };
                    t.nonBinary.Script_Extensions = t.nonBinary.Script, t.nonBinary.gc = t.nonBinary.General_Category, t.nonBinary.sc = t.nonBinary.Script, t.nonBinary.scx = t.nonBinary.Script_Extensions;
                }
                for(var He = 0, Je = [
                    9,
                    10,
                    11,
                    12,
                    13,
                    14
                ]; He < Je.length; He += 1)ze(Je[He]);
                var Qe = ae.prototype, Ye = function(e1, t) {
                    this.parent = e1, this.base = t || this;
                };
                Ye.prototype.separatedFrom = function(e1) {
                    for(var t = this; t; t = t.parent)for(var r = e1; r; r = r.parent)if (t.base === r.base && t !== r) return !0;
                    return !1;
                }, Ye.prototype.sibling = function() {
                    return new Ye(this.parent, this.base);
                };
                var Ze = function(e1) {
                    this.parser = e1, this.validFlags = "gim" + (e1.options.ecmaVersion >= 6 ? "uy" : "") + (e1.options.ecmaVersion >= 9 ? "s" : "") + (e1.options.ecmaVersion >= 13 ? "d" : "") + (e1.options.ecmaVersion >= 15 ? "v" : ""), this.unicodeProperties = Xe[e1.options.ecmaVersion >= 14 ? 14 : e1.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchV = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = Object.create(null), this.backReferenceNames = [], this.branchID = null;
                };
                function et(e1) {
                    for(var t in e1)return !0;
                    return !1;
                }
                function tt(e1) {
                    return 105 === e1 || 109 === e1 || 115 === e1;
                }
                function rt(e1) {
                    return 36 === e1 || e1 >= 40 && e1 <= 43 || 46 === e1 || 63 === e1 || e1 >= 91 && e1 <= 94 || e1 >= 123 && e1 <= 125;
                }
                function nt(e1) {
                    return f(e1, !0) || 36 === e1 || 95 === e1;
                }
                function st(e1) {
                    return d(e1, !0) || 36 === e1 || 95 === e1 || 8204 === e1 || 8205 === e1;
                }
                function it(e1) {
                    return e1 >= 65 && e1 <= 90 || e1 >= 97 && e1 <= 122;
                }
                function ot(e1) {
                    return e1 >= 0 && e1 <= 1114111;
                }
                Ze.prototype.reset = function(e1, t, r) {
                    var n = -1 !== r.indexOf("v"), s = -1 !== r.indexOf("u");
                    this.start = 0 | e1, this.source = t + "", this.flags = r, n && this.parser.options.ecmaVersion >= 15 ? (this.switchU = !0, this.switchV = !0, this.switchN = !0) : (this.switchU = s && this.parser.options.ecmaVersion >= 6, this.switchV = !1, this.switchN = s && this.parser.options.ecmaVersion >= 9);
                }, Ze.prototype.raise = function(e1) {
                    this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + e1);
                }, Ze.prototype.at = function(e1, t) {
                    void 0 === t && (t = !1);
                    var r = this.source, n = r.length;
                    if (e1 >= n) return -1;
                    var s = r.charCodeAt(e1);
                    if (!t && !this.switchU || s <= 55295 || s >= 57344 || e1 + 1 >= n) return s;
                    var i = r.charCodeAt(e1 + 1);
                    return i >= 56320 && i <= 57343 ? (s << 10) + i - 56613888 : s;
                }, Ze.prototype.nextIndex = function(e1, t) {
                    void 0 === t && (t = !1);
                    var r = this.source, n = r.length;
                    if (e1 >= n) return n;
                    var s, i = r.charCodeAt(e1);
                    return !t && !this.switchU || i <= 55295 || i >= 57344 || e1 + 1 >= n || (s = r.charCodeAt(e1 + 1)) < 56320 || s > 57343 ? e1 + 1 : e1 + 2;
                }, Ze.prototype.current = function(e1) {
                    return void 0 === e1 && (e1 = !1), this.at(this.pos, e1);
                }, Ze.prototype.lookahead = function(e1) {
                    return void 0 === e1 && (e1 = !1), this.at(this.nextIndex(this.pos, e1), e1);
                }, Ze.prototype.advance = function(e1) {
                    void 0 === e1 && (e1 = !1), this.pos = this.nextIndex(this.pos, e1);
                }, Ze.prototype.eat = function(e1, t) {
                    return void 0 === t && (t = !1), this.current(t) === e1 && (this.advance(t), !0);
                }, Ze.prototype.eatChars = function(e1, t) {
                    void 0 === t && (t = !1);
                    for(var r = this.pos, n = 0, s = e1; n < s.length; n += 1){
                        var i = s[n], o = this.at(r, t);
                        if (-1 === o || o !== i) return !1;
                        r = this.nextIndex(r, t);
                    }
                    return this.pos = r, !0;
                }, Qe.validateRegExpFlags = function(e1) {
                    for(var t = e1.validFlags, r = e1.flags, n = !1, s = !1, i = 0; i < r.length; i++){
                        var o = r.charAt(i);
                        -1 === t.indexOf(o) && this.raise(e1.start, "Invalid regular expression flag"), r.indexOf(o, i + 1) > -1 && this.raise(e1.start, "Duplicate regular expression flag"), "u" === o && (n = !0), "v" === o && (s = !0);
                    }
                    this.options.ecmaVersion >= 15 && n && s && this.raise(e1.start, "Invalid regular expression flag");
                }, Qe.validateRegExpPattern = function(e1) {
                    this.regexp_pattern(e1), !e1.switchN && this.options.ecmaVersion >= 9 && et(e1.groupNames) && (e1.switchN = !0, this.regexp_pattern(e1));
                }, Qe.regexp_pattern = function(e1) {
                    e1.pos = 0, e1.lastIntValue = 0, e1.lastStringValue = "", e1.lastAssertionIsQuantifiable = !1, e1.numCapturingParens = 0, e1.maxBackReference = 0, e1.groupNames = Object.create(null), e1.backReferenceNames.length = 0, e1.branchID = null, this.regexp_disjunction(e1), e1.pos !== e1.source.length && (e1.eat(41) && e1.raise("Unmatched ')'"), (e1.eat(93) || e1.eat(125)) && e1.raise("Lone quantifier brackets")), e1.maxBackReference > e1.numCapturingParens && e1.raise("Invalid escape");
                    for(var t = 0, r = e1.backReferenceNames; t < r.length; t += 1){
                        var n = r[t];
                        e1.groupNames[n] || e1.raise("Invalid named capture referenced");
                    }
                }, Qe.regexp_disjunction = function(e1) {
                    var t = this.options.ecmaVersion >= 16;
                    for(t && (e1.branchID = new Ye(e1.branchID, null)), this.regexp_alternative(e1); e1.eat(124);)t && (e1.branchID = e1.branchID.sibling()), this.regexp_alternative(e1);
                    t && (e1.branchID = e1.branchID.parent), this.regexp_eatQuantifier(e1, !0) && e1.raise("Nothing to repeat"), e1.eat(123) && e1.raise("Lone quantifier brackets");
                }, Qe.regexp_alternative = function(e1) {
                    for(; e1.pos < e1.source.length && this.regexp_eatTerm(e1););
                }, Qe.regexp_eatTerm = function(e1) {
                    return this.regexp_eatAssertion(e1) ? (e1.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(e1) && e1.switchU && e1.raise("Invalid quantifier"), !0) : !!(e1.switchU ? this.regexp_eatAtom(e1) : this.regexp_eatExtendedAtom(e1)) && (this.regexp_eatQuantifier(e1), !0);
                }, Qe.regexp_eatAssertion = function(e1) {
                    var t = e1.pos;
                    if (e1.lastAssertionIsQuantifiable = !1, e1.eat(94) || e1.eat(36)) return !0;
                    if (e1.eat(92)) {
                        if (e1.eat(66) || e1.eat(98)) return !0;
                        e1.pos = t;
                    }
                    if (e1.eat(40) && e1.eat(63)) {
                        var r = !1;
                        if (this.options.ecmaVersion >= 9 && (r = e1.eat(60)), e1.eat(61) || e1.eat(33)) return this.regexp_disjunction(e1), e1.eat(41) || e1.raise("Unterminated group"), e1.lastAssertionIsQuantifiable = !r, !0;
                    }
                    return e1.pos = t, !1;
                }, Qe.regexp_eatQuantifier = function(e1, t) {
                    return void 0 === t && (t = !1), !!this.regexp_eatQuantifierPrefix(e1, t) && (e1.eat(63), !0);
                }, Qe.regexp_eatQuantifierPrefix = function(e1, t) {
                    return e1.eat(42) || e1.eat(43) || e1.eat(63) || this.regexp_eatBracedQuantifier(e1, t);
                }, Qe.regexp_eatBracedQuantifier = function(e1, t) {
                    var r = e1.pos;
                    if (e1.eat(123)) {
                        var n = 0, s = -1;
                        if (this.regexp_eatDecimalDigits(e1) && (n = e1.lastIntValue, e1.eat(44) && this.regexp_eatDecimalDigits(e1) && (s = e1.lastIntValue), e1.eat(125))) return -1 !== s && s < n && !t && e1.raise("numbers out of order in {} quantifier"), !0;
                        e1.switchU && !t && e1.raise("Incomplete quantifier"), e1.pos = r;
                    }
                    return !1;
                }, Qe.regexp_eatAtom = function(e1) {
                    return this.regexp_eatPatternCharacters(e1) || e1.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e1) || this.regexp_eatCharacterClass(e1) || this.regexp_eatUncapturingGroup(e1) || this.regexp_eatCapturingGroup(e1);
                }, Qe.regexp_eatReverseSolidusAtomEscape = function(e1) {
                    var t = e1.pos;
                    if (e1.eat(92)) {
                        if (this.regexp_eatAtomEscape(e1)) return !0;
                        e1.pos = t;
                    }
                    return !1;
                }, Qe.regexp_eatUncapturingGroup = function(e1) {
                    var t = e1.pos;
                    if (e1.eat(40)) {
                        if (e1.eat(63)) {
                            if (this.options.ecmaVersion >= 16) {
                                var r = this.regexp_eatModifiers(e1), n = e1.eat(45);
                                if (r || n) {
                                    for(var s = 0; s < r.length; s++){
                                        var i = r.charAt(s);
                                        r.indexOf(i, s + 1) > -1 && e1.raise("Duplicate regular expression modifiers");
                                    }
                                    if (n) {
                                        var o = this.regexp_eatModifiers(e1);
                                        r || o || 58 !== e1.current() || e1.raise("Invalid regular expression modifiers");
                                        for(var a = 0; a < o.length; a++){
                                            var u = o.charAt(a);
                                            (o.indexOf(u, a + 1) > -1 || r.indexOf(u) > -1) && e1.raise("Duplicate regular expression modifiers");
                                        }
                                    }
                                }
                            }
                            if (e1.eat(58)) {
                                if (this.regexp_disjunction(e1), e1.eat(41)) return !0;
                                e1.raise("Unterminated group");
                            }
                        }
                        e1.pos = t;
                    }
                    return !1;
                }, Qe.regexp_eatCapturingGroup = function(e1) {
                    if (e1.eat(40)) {
                        if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(e1) : 63 === e1.current() && e1.raise("Invalid group"), this.regexp_disjunction(e1), e1.eat(41)) return e1.numCapturingParens += 1, !0;
                        e1.raise("Unterminated group");
                    }
                    return !1;
                }, Qe.regexp_eatModifiers = function(e1) {
                    for(var t = "", r = 0; -1 !== (r = e1.current()) && tt(r);)t += I(r), e1.advance();
                    return t;
                }, Qe.regexp_eatExtendedAtom = function(e1) {
                    return e1.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e1) || this.regexp_eatCharacterClass(e1) || this.regexp_eatUncapturingGroup(e1) || this.regexp_eatCapturingGroup(e1) || this.regexp_eatInvalidBracedQuantifier(e1) || this.regexp_eatExtendedPatternCharacter(e1);
                }, Qe.regexp_eatInvalidBracedQuantifier = function(e1) {
                    return this.regexp_eatBracedQuantifier(e1, !0) && e1.raise("Nothing to repeat"), !1;
                }, Qe.regexp_eatSyntaxCharacter = function(e1) {
                    var t = e1.current();
                    return !!rt(t) && (e1.lastIntValue = t, e1.advance(), !0);
                }, Qe.regexp_eatPatternCharacters = function(e1) {
                    for(var t = e1.pos, r = 0; -1 !== (r = e1.current()) && !rt(r);)e1.advance();
                    return e1.pos !== t;
                }, Qe.regexp_eatExtendedPatternCharacter = function(e1) {
                    var t = e1.current();
                    return !(-1 === t || 36 === t || t >= 40 && t <= 43 || 46 === t || 63 === t || 91 === t || 94 === t || 124 === t || (e1.advance(), 0));
                }, Qe.regexp_groupSpecifier = function(e1) {
                    if (e1.eat(63)) {
                        this.regexp_eatGroupName(e1) || e1.raise("Invalid group");
                        var t = this.options.ecmaVersion >= 16, r = e1.groupNames[e1.lastStringValue];
                        if (r) {
                            if (t) for(var n = 0, s = r; n < s.length; n += 1)s[n].separatedFrom(e1.branchID) || e1.raise("Duplicate capture group name");
                            else e1.raise("Duplicate capture group name");
                        }
                        t ? (r || (e1.groupNames[e1.lastStringValue] = [])).push(e1.branchID) : e1.groupNames[e1.lastStringValue] = !0;
                    }
                }, Qe.regexp_eatGroupName = function(e1) {
                    if (e1.lastStringValue = "", e1.eat(60)) {
                        if (this.regexp_eatRegExpIdentifierName(e1) && e1.eat(62)) return !0;
                        e1.raise("Invalid capture group name");
                    }
                    return !1;
                }, Qe.regexp_eatRegExpIdentifierName = function(e1) {
                    if (e1.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(e1)) {
                        for(e1.lastStringValue += I(e1.lastIntValue); this.regexp_eatRegExpIdentifierPart(e1);)e1.lastStringValue += I(e1.lastIntValue);
                        return !0;
                    }
                    return !1;
                }, Qe.regexp_eatRegExpIdentifierStart = function(e1) {
                    var t = e1.pos, r = this.options.ecmaVersion >= 11, n = e1.current(r);
                    return e1.advance(r), 92 === n && this.regexp_eatRegExpUnicodeEscapeSequence(e1, r) && (n = e1.lastIntValue), nt(n) ? (e1.lastIntValue = n, !0) : (e1.pos = t, !1);
                }, Qe.regexp_eatRegExpIdentifierPart = function(e1) {
                    var t = e1.pos, r = this.options.ecmaVersion >= 11, n = e1.current(r);
                    return e1.advance(r), 92 === n && this.regexp_eatRegExpUnicodeEscapeSequence(e1, r) && (n = e1.lastIntValue), st(n) ? (e1.lastIntValue = n, !0) : (e1.pos = t, !1);
                }, Qe.regexp_eatAtomEscape = function(e1) {
                    return !!(this.regexp_eatBackReference(e1) || this.regexp_eatCharacterClassEscape(e1) || this.regexp_eatCharacterEscape(e1) || e1.switchN && this.regexp_eatKGroupName(e1)) || (e1.switchU && (99 === e1.current() && e1.raise("Invalid unicode escape"), e1.raise("Invalid escape")), !1);
                }, Qe.regexp_eatBackReference = function(e1) {
                    var t = e1.pos;
                    if (this.regexp_eatDecimalEscape(e1)) {
                        var r = e1.lastIntValue;
                        if (e1.switchU) return r > e1.maxBackReference && (e1.maxBackReference = r), !0;
                        if (r <= e1.numCapturingParens) return !0;
                        e1.pos = t;
                    }
                    return !1;
                }, Qe.regexp_eatKGroupName = function(e1) {
                    if (e1.eat(107)) {
                        if (this.regexp_eatGroupName(e1)) return e1.backReferenceNames.push(e1.lastStringValue), !0;
                        e1.raise("Invalid named reference");
                    }
                    return !1;
                }, Qe.regexp_eatCharacterEscape = function(e1) {
                    return this.regexp_eatControlEscape(e1) || this.regexp_eatCControlLetter(e1) || this.regexp_eatZero(e1) || this.regexp_eatHexEscapeSequence(e1) || this.regexp_eatRegExpUnicodeEscapeSequence(e1, !1) || !e1.switchU && this.regexp_eatLegacyOctalEscapeSequence(e1) || this.regexp_eatIdentityEscape(e1);
                }, Qe.regexp_eatCControlLetter = function(e1) {
                    var t = e1.pos;
                    if (e1.eat(99)) {
                        if (this.regexp_eatControlLetter(e1)) return !0;
                        e1.pos = t;
                    }
                    return !1;
                }, Qe.regexp_eatZero = function(e1) {
                    return 48 === e1.current() && !gt(e1.lookahead()) && (e1.lastIntValue = 0, e1.advance(), !0);
                }, Qe.regexp_eatControlEscape = function(e1) {
                    var t = e1.current();
                    return 116 === t ? (e1.lastIntValue = 9, e1.advance(), !0) : 110 === t ? (e1.lastIntValue = 10, e1.advance(), !0) : 118 === t ? (e1.lastIntValue = 11, e1.advance(), !0) : 102 === t ? (e1.lastIntValue = 12, e1.advance(), !0) : 114 === t && (e1.lastIntValue = 13, e1.advance(), !0);
                }, Qe.regexp_eatControlLetter = function(e1) {
                    var t = e1.current();
                    return !!it(t) && (e1.lastIntValue = t % 32, e1.advance(), !0);
                }, Qe.regexp_eatRegExpUnicodeEscapeSequence = function(e1, t) {
                    void 0 === t && (t = !1);
                    var r = e1.pos, n = t || e1.switchU;
                    if (e1.eat(117)) {
                        if (this.regexp_eatFixedHexDigits(e1, 4)) {
                            var s = e1.lastIntValue;
                            if (n && s >= 55296 && s <= 56319) {
                                var i = e1.pos;
                                if (e1.eat(92) && e1.eat(117) && this.regexp_eatFixedHexDigits(e1, 4)) {
                                    var o = e1.lastIntValue;
                                    if (o >= 56320 && o <= 57343) return e1.lastIntValue = 1024 * (s - 55296) + (o - 56320) + 65536, !0;
                                }
                                e1.pos = i, e1.lastIntValue = s;
                            }
                            return !0;
                        }
                        if (n && e1.eat(123) && this.regexp_eatHexDigits(e1) && e1.eat(125) && ot(e1.lastIntValue)) return !0;
                        n && e1.raise("Invalid unicode escape"), e1.pos = r;
                    }
                    return !1;
                }, Qe.regexp_eatIdentityEscape = function(e1) {
                    if (e1.switchU) return !!this.regexp_eatSyntaxCharacter(e1) || !!e1.eat(47) && (e1.lastIntValue = 47, !0);
                    var t = e1.current();
                    return !(99 === t || e1.switchN && 107 === t || (e1.lastIntValue = t, e1.advance(), 0));
                }, Qe.regexp_eatDecimalEscape = function(e1) {
                    e1.lastIntValue = 0;
                    var t = e1.current();
                    if (t >= 49 && t <= 57) {
                        do e1.lastIntValue = 10 * e1.lastIntValue + (t - 48), e1.advance();
                        while ((t = e1.current()) >= 48 && t <= 57);
                        return !0;
                    }
                    return !1;
                };
                var at = 0, ut = 1, lt = 2;
                function ct(e1) {
                    return 100 === e1 || 68 === e1 || 115 === e1 || 83 === e1 || 119 === e1 || 87 === e1;
                }
                function pt(e1) {
                    return it(e1) || 95 === e1;
                }
                function ft(e1) {
                    return pt(e1) || gt(e1);
                }
                function dt(e1) {
                    return 33 === e1 || e1 >= 35 && e1 <= 38 || e1 >= 42 && e1 <= 44 || 46 === e1 || e1 >= 58 && e1 <= 64 || 94 === e1 || 96 === e1 || 126 === e1;
                }
                function ht(e1) {
                    return 40 === e1 || 41 === e1 || 45 === e1 || 47 === e1 || e1 >= 91 && e1 <= 93 || e1 >= 123 && e1 <= 125;
                }
                function mt(e1) {
                    return 33 === e1 || 35 === e1 || 37 === e1 || 38 === e1 || 44 === e1 || 45 === e1 || e1 >= 58 && e1 <= 62 || 64 === e1 || 96 === e1 || 126 === e1;
                }
                function gt(e1) {
                    return e1 >= 48 && e1 <= 57;
                }
                function yt(e1) {
                    return e1 >= 48 && e1 <= 57 || e1 >= 65 && e1 <= 70 || e1 >= 97 && e1 <= 102;
                }
                function Et(e1) {
                    return e1 >= 65 && e1 <= 70 ? e1 - 65 + 10 : e1 >= 97 && e1 <= 102 ? e1 - 97 + 10 : e1 - 48;
                }
                function xt(e1) {
                    return e1 >= 48 && e1 <= 55;
                }
                Qe.regexp_eatCharacterClassEscape = function(e1) {
                    var t = e1.current();
                    if (ct(t)) return e1.lastIntValue = -1, e1.advance(), ut;
                    var r = !1;
                    if (e1.switchU && this.options.ecmaVersion >= 9 && ((r = 80 === t) || 112 === t)) {
                        var n;
                        if (e1.lastIntValue = -1, e1.advance(), e1.eat(123) && (n = this.regexp_eatUnicodePropertyValueExpression(e1)) && e1.eat(125)) return r && n === lt && e1.raise("Invalid property name"), n;
                        e1.raise("Invalid property name");
                    }
                    return at;
                }, Qe.regexp_eatUnicodePropertyValueExpression = function(e1) {
                    var t = e1.pos;
                    if (this.regexp_eatUnicodePropertyName(e1) && e1.eat(61)) {
                        var r = e1.lastStringValue;
                        if (this.regexp_eatUnicodePropertyValue(e1)) {
                            var n = e1.lastStringValue;
                            return this.regexp_validateUnicodePropertyNameAndValue(e1, r, n), ut;
                        }
                    }
                    if (e1.pos = t, this.regexp_eatLoneUnicodePropertyNameOrValue(e1)) {
                        var s = e1.lastStringValue;
                        return this.regexp_validateUnicodePropertyNameOrValue(e1, s);
                    }
                    return at;
                }, Qe.regexp_validateUnicodePropertyNameAndValue = function(e1, t, r) {
                    k(e1.unicodeProperties.nonBinary, t) || e1.raise("Invalid property name"), e1.unicodeProperties.nonBinary[t].test(r) || e1.raise("Invalid property value");
                }, Qe.regexp_validateUnicodePropertyNameOrValue = function(e1, t) {
                    return e1.unicodeProperties.binary.test(t) ? ut : e1.switchV && e1.unicodeProperties.binaryOfStrings.test(t) ? lt : void e1.raise("Invalid property name");
                }, Qe.regexp_eatUnicodePropertyName = function(e1) {
                    var t = 0;
                    for(e1.lastStringValue = ""; pt(t = e1.current());)e1.lastStringValue += I(t), e1.advance();
                    return "" !== e1.lastStringValue;
                }, Qe.regexp_eatUnicodePropertyValue = function(e1) {
                    var t = 0;
                    for(e1.lastStringValue = ""; ft(t = e1.current());)e1.lastStringValue += I(t), e1.advance();
                    return "" !== e1.lastStringValue;
                }, Qe.regexp_eatLoneUnicodePropertyNameOrValue = function(e1) {
                    return this.regexp_eatUnicodePropertyValue(e1);
                }, Qe.regexp_eatCharacterClass = function(e1) {
                    if (e1.eat(91)) {
                        var t = e1.eat(94), r = this.regexp_classContents(e1);
                        return e1.eat(93) || e1.raise("Unterminated character class"), t && r === lt && e1.raise("Negated character class may contain strings"), !0;
                    }
                    return !1;
                }, Qe.regexp_classContents = function(e1) {
                    return 93 === e1.current() ? ut : e1.switchV ? this.regexp_classSetExpression(e1) : (this.regexp_nonEmptyClassRanges(e1), ut);
                }, Qe.regexp_nonEmptyClassRanges = function(e1) {
                    for(; this.regexp_eatClassAtom(e1);){
                        var t = e1.lastIntValue;
                        if (e1.eat(45) && this.regexp_eatClassAtom(e1)) {
                            var r = e1.lastIntValue;
                            !e1.switchU || -1 !== t && -1 !== r || e1.raise("Invalid character class"), -1 !== t && -1 !== r && t > r && e1.raise("Range out of order in character class");
                        }
                    }
                }, Qe.regexp_eatClassAtom = function(e1) {
                    var t = e1.pos;
                    if (e1.eat(92)) {
                        if (this.regexp_eatClassEscape(e1)) return !0;
                        if (e1.switchU) {
                            var r = e1.current();
                            (99 === r || xt(r)) && e1.raise("Invalid class escape"), e1.raise("Invalid escape");
                        }
                        e1.pos = t;
                    }
                    var n = e1.current();
                    return 93 !== n && (e1.lastIntValue = n, e1.advance(), !0);
                }, Qe.regexp_eatClassEscape = function(e1) {
                    var t = e1.pos;
                    if (e1.eat(98)) return e1.lastIntValue = 8, !0;
                    if (e1.switchU && e1.eat(45)) return e1.lastIntValue = 45, !0;
                    if (!e1.switchU && e1.eat(99)) {
                        if (this.regexp_eatClassControlLetter(e1)) return !0;
                        e1.pos = t;
                    }
                    return this.regexp_eatCharacterClassEscape(e1) || this.regexp_eatCharacterEscape(e1);
                }, Qe.regexp_classSetExpression = function(e1) {
                    var t, r = ut;
                    if (this.regexp_eatClassSetRange(e1)) ;
                    else if (t = this.regexp_eatClassSetOperand(e1)) {
                        t === lt && (r = lt);
                        for(var n = e1.pos; e1.eatChars([
                            38,
                            38
                        ]);)38 !== e1.current() && (t = this.regexp_eatClassSetOperand(e1)) ? t !== lt && (r = ut) : e1.raise("Invalid character in character class");
                        if (n !== e1.pos) return r;
                        for(; e1.eatChars([
                            45,
                            45
                        ]);)this.regexp_eatClassSetOperand(e1) || e1.raise("Invalid character in character class");
                        if (n !== e1.pos) return r;
                    } else e1.raise("Invalid character in character class");
                    for(;;)if (!this.regexp_eatClassSetRange(e1)) {
                        if (!(t = this.regexp_eatClassSetOperand(e1))) return r;
                        t === lt && (r = lt);
                    }
                }, Qe.regexp_eatClassSetRange = function(e1) {
                    var t = e1.pos;
                    if (this.regexp_eatClassSetCharacter(e1)) {
                        var r = e1.lastIntValue;
                        if (e1.eat(45) && this.regexp_eatClassSetCharacter(e1)) {
                            var n = e1.lastIntValue;
                            return -1 !== r && -1 !== n && r > n && e1.raise("Range out of order in character class"), !0;
                        }
                        e1.pos = t;
                    }
                    return !1;
                }, Qe.regexp_eatClassSetOperand = function(e1) {
                    return this.regexp_eatClassSetCharacter(e1) ? ut : this.regexp_eatClassStringDisjunction(e1) || this.regexp_eatNestedClass(e1);
                }, Qe.regexp_eatNestedClass = function(e1) {
                    var t = e1.pos;
                    if (e1.eat(91)) {
                        var r = e1.eat(94), n = this.regexp_classContents(e1);
                        if (e1.eat(93)) return r && n === lt && e1.raise("Negated character class may contain strings"), n;
                        e1.pos = t;
                    }
                    if (e1.eat(92)) {
                        var s = this.regexp_eatCharacterClassEscape(e1);
                        if (s) return s;
                        e1.pos = t;
                    }
                    return null;
                }, Qe.regexp_eatClassStringDisjunction = function(e1) {
                    var t = e1.pos;
                    if (e1.eatChars([
                        92,
                        113
                    ])) {
                        if (e1.eat(123)) {
                            var r = this.regexp_classStringDisjunctionContents(e1);
                            if (e1.eat(125)) return r;
                        } else e1.raise("Invalid escape");
                        e1.pos = t;
                    }
                    return null;
                }, Qe.regexp_classStringDisjunctionContents = function(e1) {
                    for(var t = this.regexp_classString(e1); e1.eat(124);)this.regexp_classString(e1) === lt && (t = lt);
                    return t;
                }, Qe.regexp_classString = function(e1) {
                    for(var t = 0; this.regexp_eatClassSetCharacter(e1);)t++;
                    return 1 === t ? ut : lt;
                }, Qe.regexp_eatClassSetCharacter = function(e1) {
                    var t = e1.pos;
                    if (e1.eat(92)) return !(!this.regexp_eatCharacterEscape(e1) && !this.regexp_eatClassSetReservedPunctuator(e1) && (e1.eat(98) ? (e1.lastIntValue = 8, 0) : (e1.pos = t, 1)));
                    var r = e1.current();
                    return !(r < 0 || r === e1.lookahead() && dt(r) || ht(r) || (e1.advance(), e1.lastIntValue = r, 0));
                }, Qe.regexp_eatClassSetReservedPunctuator = function(e1) {
                    var t = e1.current();
                    return !!mt(t) && (e1.lastIntValue = t, e1.advance(), !0);
                }, Qe.regexp_eatClassControlLetter = function(e1) {
                    var t = e1.current();
                    return !(!gt(t) && 95 !== t || (e1.lastIntValue = t % 32, e1.advance(), 0));
                }, Qe.regexp_eatHexEscapeSequence = function(e1) {
                    var t = e1.pos;
                    if (e1.eat(120)) {
                        if (this.regexp_eatFixedHexDigits(e1, 2)) return !0;
                        e1.switchU && e1.raise("Invalid escape"), e1.pos = t;
                    }
                    return !1;
                }, Qe.regexp_eatDecimalDigits = function(e1) {
                    var t = e1.pos, r = 0;
                    for(e1.lastIntValue = 0; gt(r = e1.current());)e1.lastIntValue = 10 * e1.lastIntValue + (r - 48), e1.advance();
                    return e1.pos !== t;
                }, Qe.regexp_eatHexDigits = function(e1) {
                    var t = e1.pos, r = 0;
                    for(e1.lastIntValue = 0; yt(r = e1.current());)e1.lastIntValue = 16 * e1.lastIntValue + Et(r), e1.advance();
                    return e1.pos !== t;
                }, Qe.regexp_eatLegacyOctalEscapeSequence = function(e1) {
                    if (this.regexp_eatOctalDigit(e1)) {
                        var t = e1.lastIntValue;
                        if (this.regexp_eatOctalDigit(e1)) {
                            var r = e1.lastIntValue;
                            t <= 3 && this.regexp_eatOctalDigit(e1) ? e1.lastIntValue = 64 * t + 8 * r + e1.lastIntValue : e1.lastIntValue = 8 * t + r;
                        } else e1.lastIntValue = t;
                        return !0;
                    }
                    return !1;
                }, Qe.regexp_eatOctalDigit = function(e1) {
                    var t = e1.current();
                    return xt(t) ? (e1.lastIntValue = t - 48, e1.advance(), !0) : (e1.lastIntValue = 0, !1);
                }, Qe.regexp_eatFixedHexDigits = function(e1, t) {
                    var r = e1.pos;
                    e1.lastIntValue = 0;
                    for(var n = 0; n < t; ++n){
                        var s = e1.current();
                        if (!yt(s)) return e1.pos = r, !1;
                        e1.lastIntValue = 16 * e1.lastIntValue + Et(s), e1.advance();
                    }
                    return !0;
                };
                var Ct = function(e1) {
                    this.type = e1.type, this.value = e1.value, this.start = e1.start, this.end = e1.end, e1.options.locations && (this.loc = new O(e1, e1.startLoc, e1.endLoc)), e1.options.ranges && (this.range = [
                        e1.start,
                        e1.end
                    ]);
                }, St = ae.prototype;
                function bt(e1, t) {
                    return t ? parseInt(e1, 8) : parseFloat(e1.replace(/_/g, ""));
                }
                function vt(e1) {
                    return "function" != typeof BigInt ? null : BigInt(e1.replace(/_/g, ""));
                }
                St.next = function(e1) {
                    !e1 && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword), this.options.onToken && this.options.onToken(new Ct(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
                }, St.getToken = function() {
                    return this.next(), new Ct(this);
                }, "undefined" != typeof Symbol && (St[Symbol.iterator] = function() {
                    var e1 = this;
                    return {
                        next: function() {
                            var t = e1.getToken();
                            return {
                                done: t.type === C.eof,
                                value: t
                            };
                        }
                    };
                }), St.nextToken = function() {
                    var e1 = this.curContext();
                    return e1 && e1.preserveSpace || this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length ? this.finishToken(C.eof) : e1.override ? e1.override(this) : void this.readToken(this.fullCharCodeAtPos());
                }, St.readToken = function(e1) {
                    return f(e1, this.options.ecmaVersion >= 6) || 92 === e1 ? this.readWord() : this.getTokenFromCode(e1);
                }, St.fullCharCodeAtPos = function() {
                    var e1 = this.input.charCodeAt(this.pos);
                    if (e1 <= 55295 || e1 >= 56320) return e1;
                    var t = this.input.charCodeAt(this.pos + 1);
                    return t <= 56319 || t >= 57344 ? e1 : (e1 << 10) + t - 56613888;
                }, St.skipBlockComment = function() {
                    var e1 = this.options.onComment && this.curPosition(), t = this.pos, r = this.input.indexOf("*/", this.pos += 2);
                    if (-1 === r && this.raise(this.pos - 2, "Unterminated comment"), this.pos = r + 2, this.options.locations) for(var n = void 0, s = t; (n = A(this.input, s, this.pos)) > -1;)++this.curLine, s = this.lineStart = n;
                    this.options.onComment && this.options.onComment(!0, this.input.slice(t + 2, r), t, this.pos, e1, this.curPosition());
                }, St.skipLineComment = function(e1) {
                    for(var t = this.pos, r = this.options.onComment && this.curPosition(), n = this.input.charCodeAt(this.pos += e1); this.pos < this.input.length && !v(n);)n = this.input.charCodeAt(++this.pos);
                    this.options.onComment && this.options.onComment(!1, this.input.slice(t + e1, this.pos), t, this.pos, r, this.curPosition());
                }, St.skipSpace = function() {
                    e: for(; this.pos < this.input.length;){
                        var e1 = this.input.charCodeAt(this.pos);
                        switch(e1){
                            case 32:
                            case 160:
                                ++this.pos;
                                break;
                            case 13:
                                10 === this.input.charCodeAt(this.pos + 1) && ++this.pos;
                            case 10:
                            case 8232:
                            case 8233:
                                ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
                                break;
                            case 47:
                                switch(this.input.charCodeAt(this.pos + 1)){
                                    case 42:
                                        this.skipBlockComment();
                                        break;
                                    case 47:
                                        this.skipLineComment(2);
                                        break;
                                    default:
                                        break e;
                                }
                                break;
                            default:
                                if (!(e1 > 8 && e1 < 14 || e1 >= 5760 && T.test(String.fromCharCode(e1)))) break e;
                                ++this.pos;
                        }
                    }
                }, St.finishToken = function(e1, t) {
                    this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
                    var r = this.type;
                    this.type = e1, this.value = t, this.updateContext(r);
                }, St.readToken_dot = function() {
                    var e1 = this.input.charCodeAt(this.pos + 1);
                    if (e1 >= 48 && e1 <= 57) return this.readNumber(!0);
                    var t = this.input.charCodeAt(this.pos + 2);
                    return this.options.ecmaVersion >= 6 && 46 === e1 && 46 === t ? (this.pos += 3, this.finishToken(C.ellipsis)) : (++this.pos, this.finishToken(C.dot));
                }, St.readToken_slash = function() {
                    var e1 = this.input.charCodeAt(this.pos + 1);
                    return this.exprAllowed ? (++this.pos, this.readRegexp()) : 61 === e1 ? this.finishOp(C.assign, 2) : this.finishOp(C.slash, 1);
                }, St.readToken_mult_modulo_exp = function(e1) {
                    var t = this.input.charCodeAt(this.pos + 1), r = 1, n = 42 === e1 ? C.star : C.modulo;
                    return this.options.ecmaVersion >= 7 && 42 === e1 && 42 === t && (++r, n = C.starstar, t = this.input.charCodeAt(this.pos + 2)), 61 === t ? this.finishOp(C.assign, r + 1) : this.finishOp(n, r);
                }, St.readToken_pipe_amp = function(e1) {
                    var t = this.input.charCodeAt(this.pos + 1);
                    return t === e1 ? this.options.ecmaVersion >= 12 && 61 === this.input.charCodeAt(this.pos + 2) ? this.finishOp(C.assign, 3) : this.finishOp(124 === e1 ? C.logicalOR : C.logicalAND, 2) : 61 === t ? this.finishOp(C.assign, 2) : this.finishOp(124 === e1 ? C.bitwiseOR : C.bitwiseAND, 1);
                }, St.readToken_caret = function() {
                    return 61 === this.input.charCodeAt(this.pos + 1) ? this.finishOp(C.assign, 2) : this.finishOp(C.bitwiseXOR, 1);
                }, St.readToken_plus_min = function(e1) {
                    var t = this.input.charCodeAt(this.pos + 1);
                    return t === e1 ? 45 !== t || this.inModule || 62 !== this.input.charCodeAt(this.pos + 2) || 0 !== this.lastTokEnd && !S.test(this.input.slice(this.lastTokEnd, this.pos)) ? this.finishOp(C.incDec, 2) : (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : 61 === t ? this.finishOp(C.assign, 2) : this.finishOp(C.plusMin, 1);
                }, St.readToken_lt_gt = function(e1) {
                    var t = this.input.charCodeAt(this.pos + 1), r = 1;
                    return t === e1 ? (r = 62 === e1 && 62 === this.input.charCodeAt(this.pos + 2) ? 3 : 2, 61 === this.input.charCodeAt(this.pos + r) ? this.finishOp(C.assign, r + 1) : this.finishOp(C.bitShift, r)) : 33 !== t || 60 !== e1 || this.inModule || 45 !== this.input.charCodeAt(this.pos + 2) || 45 !== this.input.charCodeAt(this.pos + 3) ? (61 === t && (r = 2), this.finishOp(C.relational, r)) : (this.skipLineComment(4), this.skipSpace(), this.nextToken());
                }, St.readToken_eq_excl = function(e1) {
                    var t = this.input.charCodeAt(this.pos + 1);
                    return 61 === t ? this.finishOp(C.equality, 61 === this.input.charCodeAt(this.pos + 2) ? 3 : 2) : 61 === e1 && 62 === t && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(C.arrow)) : this.finishOp(61 === e1 ? C.eq : C.prefix, 1);
                }, St.readToken_question = function() {
                    var e1 = this.options.ecmaVersion;
                    if (e1 >= 11) {
                        var t = this.input.charCodeAt(this.pos + 1);
                        if (46 === t) {
                            var r = this.input.charCodeAt(this.pos + 2);
                            if (r < 48 || r > 57) return this.finishOp(C.questionDot, 2);
                        }
                        if (63 === t) return e1 >= 12 && 61 === this.input.charCodeAt(this.pos + 2) ? this.finishOp(C.assign, 3) : this.finishOp(C.coalesce, 2);
                    }
                    return this.finishOp(C.question, 1);
                }, St.readToken_numberSign = function() {
                    var e1 = 35;
                    if (this.options.ecmaVersion >= 13 && (++this.pos, f(e1 = this.fullCharCodeAtPos(), !0) || 92 === e1)) return this.finishToken(C.privateId, this.readWord1());
                    this.raise(this.pos, "Unexpected character '" + I(e1) + "'");
                }, St.getTokenFromCode = function(e1) {
                    switch(e1){
                        case 46:
                            return this.readToken_dot();
                        case 40:
                            return ++this.pos, this.finishToken(C.parenL);
                        case 41:
                            return ++this.pos, this.finishToken(C.parenR);
                        case 59:
                            return ++this.pos, this.finishToken(C.semi);
                        case 44:
                            return ++this.pos, this.finishToken(C.comma);
                        case 91:
                            return ++this.pos, this.finishToken(C.bracketL);
                        case 93:
                            return ++this.pos, this.finishToken(C.bracketR);
                        case 123:
                            return ++this.pos, this.finishToken(C.braceL);
                        case 125:
                            return ++this.pos, this.finishToken(C.braceR);
                        case 58:
                            return ++this.pos, this.finishToken(C.colon);
                        case 96:
                            if (this.options.ecmaVersion < 6) break;
                            return ++this.pos, this.finishToken(C.backQuote);
                        case 48:
                            var t = this.input.charCodeAt(this.pos + 1);
                            if (120 === t || 88 === t) return this.readRadixNumber(16);
                            if (this.options.ecmaVersion >= 6) {
                                if (111 === t || 79 === t) return this.readRadixNumber(8);
                                if (98 === t || 66 === t) return this.readRadixNumber(2);
                            }
                        case 49:
                        case 50:
                        case 51:
                        case 52:
                        case 53:
                        case 54:
                        case 55:
                        case 56:
                        case 57:
                            return this.readNumber(!1);
                        case 34:
                        case 39:
                            return this.readString(e1);
                        case 47:
                            return this.readToken_slash();
                        case 37:
                        case 42:
                            return this.readToken_mult_modulo_exp(e1);
                        case 124:
                        case 38:
                            return this.readToken_pipe_amp(e1);
                        case 94:
                            return this.readToken_caret();
                        case 43:
                        case 45:
                            return this.readToken_plus_min(e1);
                        case 60:
                        case 62:
                            return this.readToken_lt_gt(e1);
                        case 61:
                        case 33:
                            return this.readToken_eq_excl(e1);
                        case 63:
                            return this.readToken_question();
                        case 126:
                            return this.finishOp(C.prefix, 1);
                        case 35:
                            return this.readToken_numberSign();
                    }
                    this.raise(this.pos, "Unexpected character '" + I(e1) + "'");
                }, St.finishOp = function(e1, t) {
                    var r = this.input.slice(this.pos, this.pos + t);
                    return this.pos += t, this.finishToken(e1, r);
                }, St.readRegexp = function() {
                    for(var e1, t, r = this.pos;;){
                        this.pos >= this.input.length && this.raise(r, "Unterminated regular expression");
                        var n = this.input.charAt(this.pos);
                        if (S.test(n) && this.raise(r, "Unterminated regular expression"), e1) e1 = !1;
                        else {
                            if ("[" === n) t = !0;
                            else if ("]" === n && t) t = !1;
                            else if ("/" === n && !t) break;
                            e1 = "\\" === n;
                        }
                        ++this.pos;
                    }
                    var s = this.input.slice(r, this.pos);
                    ++this.pos;
                    var i = this.pos, o = this.readWord1();
                    this.containsEsc && this.unexpected(i);
                    var a = this.regexpState || (this.regexpState = new Ze(this));
                    a.reset(r, s, o), this.validateRegExpFlags(a), this.validateRegExpPattern(a);
                    var u = null;
                    try {
                        u = new RegExp(s, o);
                    } catch (e1) {}
                    return this.finishToken(C.regexp, {
                        pattern: s,
                        flags: o,
                        value: u
                    });
                }, St.readInt = function(e1, t, r) {
                    for(var n = this.options.ecmaVersion >= 12 && void 0 === t, s = r && 48 === this.input.charCodeAt(this.pos), i = this.pos, o = 0, a = 0, u = 0, l = null == t ? 1 / 0 : t; u < l; ++u, ++this.pos){
                        var c = this.input.charCodeAt(this.pos), p = void 0;
                        if (n && 95 === c) s && this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"), 95 === a && this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"), 0 === u && this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"), a = c;
                        else {
                            if ((p = c >= 97 ? c - 97 + 10 : c >= 65 ? c - 65 + 10 : c >= 48 && c <= 57 ? c - 48 : 1 / 0) >= e1) break;
                            a = c, o = o * e1 + p;
                        }
                    }
                    return n && 95 === a && this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"), this.pos === i || null != t && this.pos - i !== t ? null : o;
                }, St.readRadixNumber = function(e1) {
                    var t = this.pos;
                    this.pos += 2;
                    var r = this.readInt(e1);
                    return null == r && this.raise(this.start + 2, "Expected number in radix " + e1), this.options.ecmaVersion >= 11 && 110 === this.input.charCodeAt(this.pos) ? (r = vt(this.input.slice(t, this.pos)), ++this.pos) : f(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(C.num, r);
                }, St.readNumber = function(e1) {
                    var t = this.pos;
                    e1 || null !== this.readInt(10, void 0, !0) || this.raise(t, "Invalid number");
                    var r = this.pos - t >= 2 && 48 === this.input.charCodeAt(t);
                    r && this.strict && this.raise(t, "Invalid number");
                    var n = this.input.charCodeAt(this.pos);
                    if (!r && !e1 && this.options.ecmaVersion >= 11 && 110 === n) {
                        var s = vt(this.input.slice(t, this.pos));
                        return ++this.pos, f(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(C.num, s);
                    }
                    r && /[89]/.test(this.input.slice(t, this.pos)) && (r = !1), 46 !== n || r || (++this.pos, this.readInt(10), n = this.input.charCodeAt(this.pos)), 69 !== n && 101 !== n || r || (43 !== (n = this.input.charCodeAt(++this.pos)) && 45 !== n || ++this.pos, null === this.readInt(10) && this.raise(t, "Invalid number")), f(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
                    var i = bt(this.input.slice(t, this.pos), r);
                    return this.finishToken(C.num, i);
                }, St.readCodePoint = function() {
                    var e1;
                    if (123 === this.input.charCodeAt(this.pos)) {
                        this.options.ecmaVersion < 6 && this.unexpected();
                        var t = ++this.pos;
                        e1 = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, e1 > 1114111 && this.invalidStringToken(t, "Code point out of bounds");
                    } else e1 = this.readHexChar(4);
                    return e1;
                }, St.readString = function(e1) {
                    for(var t = "", r = ++this.pos;;){
                        this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
                        var n = this.input.charCodeAt(this.pos);
                        if (n === e1) break;
                        92 === n ? (t += this.input.slice(r, this.pos), t += this.readEscapedChar(!1), r = this.pos) : 8232 === n || 8233 === n ? (this.options.ecmaVersion < 10 && this.raise(this.start, "Unterminated string constant"), ++this.pos, this.options.locations && (this.curLine++, this.lineStart = this.pos)) : (v(n) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
                    }
                    return t += this.input.slice(r, this.pos++), this.finishToken(C.string, t);
                };
                var At = {};
                St.tryReadTemplateToken = function() {
                    this.inTemplateElement = !0;
                    try {
                        this.readTmplToken();
                    } catch (e1) {
                        if (e1 !== At) throw e1;
                        this.readInvalidTemplateToken();
                    }
                    this.inTemplateElement = !1;
                }, St.invalidStringToken = function(e1, t) {
                    if (this.inTemplateElement && this.options.ecmaVersion >= 9) throw At;
                    this.raise(e1, t);
                }, St.readTmplToken = function() {
                    for(var e1 = "", t = this.pos;;){
                        this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
                        var r = this.input.charCodeAt(this.pos);
                        if (96 === r || 36 === r && 123 === this.input.charCodeAt(this.pos + 1)) return this.pos !== this.start || this.type !== C.template && this.type !== C.invalidTemplate ? (e1 += this.input.slice(t, this.pos), this.finishToken(C.template, e1)) : 36 === r ? (this.pos += 2, this.finishToken(C.dollarBraceL)) : (++this.pos, this.finishToken(C.backQuote));
                        if (92 === r) e1 += this.input.slice(t, this.pos), e1 += this.readEscapedChar(!0), t = this.pos;
                        else if (v(r)) {
                            switch(e1 += this.input.slice(t, this.pos), ++this.pos, r){
                                case 13:
                                    10 === this.input.charCodeAt(this.pos) && ++this.pos;
                                case 10:
                                    e1 += "\n";
                                    break;
                                default:
                                    e1 += String.fromCharCode(r);
                            }
                            this.options.locations && (++this.curLine, this.lineStart = this.pos), t = this.pos;
                        } else ++this.pos;
                    }
                }, St.readInvalidTemplateToken = function() {
                    for(; this.pos < this.input.length; this.pos++)switch(this.input[this.pos]){
                        case "\\":
                            ++this.pos;
                            break;
                        case "$":
                            if ("{" !== this.input[this.pos + 1]) break;
                        case "`":
                            return this.finishToken(C.invalidTemplate, this.input.slice(this.start, this.pos));
                        case "\r":
                            "\n" === this.input[this.pos + 1] && ++this.pos;
                        case "\n":
                        case "\u2028":
                        case "\u2029":
                            ++this.curLine, this.lineStart = this.pos + 1;
                    }
                    this.raise(this.start, "Unterminated template");
                }, St.readEscapedChar = function(e1) {
                    var t = this.input.charCodeAt(++this.pos);
                    switch(++this.pos, t){
                        case 110:
                            return "\n";
                        case 114:
                            return "\r";
                        case 120:
                            return String.fromCharCode(this.readHexChar(2));
                        case 117:
                            return I(this.readCodePoint());
                        case 116:
                            return "\t";
                        case 98:
                            return "\b";
                        case 118:
                            return "\v";
                        case 102:
                            return "\f";
                        case 13:
                            10 === this.input.charCodeAt(this.pos) && ++this.pos;
                        case 10:
                            return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
                        case 56:
                        case 57:
                            if (this.strict && this.invalidStringToken(this.pos - 1, "Invalid escape sequence"), e1) {
                                var r = this.pos - 1;
                                this.invalidStringToken(r, "Invalid escape sequence in template string");
                            }
                        default:
                            if (t >= 48 && t <= 55) {
                                var n = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], s = parseInt(n, 8);
                                return s > 255 && (n = n.slice(0, -1), s = parseInt(n, 8)), this.pos += n.length - 1, t = this.input.charCodeAt(this.pos), "0" === n && 56 !== t && 57 !== t || !this.strict && !e1 || this.invalidStringToken(this.pos - 1 - n.length, e1 ? "Octal literal in template string" : "Octal literal in strict mode"), String.fromCharCode(s);
                            }
                            return v(t) ? (this.options.locations && (this.lineStart = this.pos, ++this.curLine), "") : String.fromCharCode(t);
                    }
                }, St.readHexChar = function(e1) {
                    var t = this.pos, r = this.readInt(16, e1);
                    return null === r && this.invalidStringToken(t, "Bad character escape sequence"), r;
                }, St.readWord1 = function() {
                    this.containsEsc = !1;
                    for(var e1 = "", t = !0, r = this.pos, n = this.options.ecmaVersion >= 6; this.pos < this.input.length;){
                        var s = this.fullCharCodeAtPos();
                        if (d(s, n)) this.pos += s <= 65535 ? 1 : 2;
                        else {
                            if (92 !== s) break;
                            this.containsEsc = !0, e1 += this.input.slice(r, this.pos);
                            var i = this.pos;
                            117 !== this.input.charCodeAt(++this.pos) && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
                            var o = this.readCodePoint();
                            (t ? f : d)(o, n) || this.invalidStringToken(i, "Invalid Unicode escape"), e1 += I(o), r = this.pos;
                        }
                        t = !1;
                    }
                    return e1 + this.input.slice(r, this.pos);
                }, St.readWord = function() {
                    var e1 = this.readWord1(), t = C.name;
                    return this.keywords.test(e1) && (t = E[e1]), this.finishToken(t, e1);
                };
                var Tt = "8.15.0";
                function Rt(e1, t) {
                    return ae.parse(e1, t);
                }
                function Dt(e1, t, r) {
                    return ae.parseExpressionAt(e1, t, r);
                }
                function wt(e1, t) {
                    return ae.tokenizer(e1, t);
                }
                ae.acorn = {
                    Parser: ae,
                    version: Tt,
                    defaultOptions: j,
                    Position: N,
                    SourceLocation: O,
                    getLineInfo: U,
                    Node: Le,
                    TokenType: h,
                    tokTypes: C,
                    keywordTypes: E,
                    TokContext: be,
                    tokContexts: ve,
                    isIdentifierChar: d,
                    isIdentifierStart: f,
                    Token: Ct,
                    isNewLine: v,
                    lineBreak: S,
                    lineBreakG: b,
                    nonASCIIwhitespace: T
                }, e1.Node = Le, e1.Parser = ae, e1.Position = N, e1.SourceLocation = O, e1.TokContext = be, e1.Token = Ct, e1.TokenType = h, e1.defaultOptions = j, e1.getLineInfo = U, e1.isIdentifierChar = d, e1.isIdentifierStart = f, e1.isNewLine = v, e1.keywordTypes = E, e1.lineBreak = S, e1.lineBreakG = b, e1.nonASCIIwhitespace = T, e1.parse = Rt, e1.parseExpressionAt = Dt, e1.tokContexts = ve, e1.tokTypes = C, e1.tokenizer = wt, e1.version = Tt;
            }(t);
        }(0, xr)), xr;
    }
    var Sr, br, vr, Ar, Tr = {}, Rr = {
        get exports () {
            return Tr;
        },
        set exports (e){
            Tr = e;
        }
    };
    function Dr() {
        return vr || (vr = 1, function(e1) {
            const t = br ? Sr : (br = 1, Sr = {
                quot: '"',
                amp: "&",
                apos: "'",
                lt: "<",
                gt: ">",
                nbsp: "\xa0",
                iexcl: "\xa1",
                cent: "\xa2",
                pound: "\xa3",
                curren: "\xa4",
                yen: "\xa5",
                brvbar: "\xa6",
                sect: "\xa7",
                uml: "\xa8",
                copy: "\xa9",
                ordf: "\xaa",
                laquo: "\xab",
                not: "\xac",
                shy: "\xad",
                reg: "\xae",
                macr: "\xaf",
                deg: "\xb0",
                plusmn: "\xb1",
                sup2: "\xb2",
                sup3: "\xb3",
                acute: "\xb4",
                micro: "\xb5",
                para: "\xb6",
                middot: "\xb7",
                cedil: "\xb8",
                sup1: "\xb9",
                ordm: "\xba",
                raquo: "\xbb",
                frac14: "\xbc",
                frac12: "\xbd",
                frac34: "\xbe",
                iquest: "\xbf",
                Agrave: "\xc0",
                Aacute: "\xc1",
                Acirc: "\xc2",
                Atilde: "\xc3",
                Auml: "\xc4",
                Aring: "\xc5",
                AElig: "\xc6",
                Ccedil: "\xc7",
                Egrave: "\xc8",
                Eacute: "\xc9",
                Ecirc: "\xca",
                Euml: "\xcb",
                Igrave: "\xcc",
                Iacute: "\xcd",
                Icirc: "\xce",
                Iuml: "\xcf",
                ETH: "\xd0",
                Ntilde: "\xd1",
                Ograve: "\xd2",
                Oacute: "\xd3",
                Ocirc: "\xd4",
                Otilde: "\xd5",
                Ouml: "\xd6",
                times: "\xd7",
                Oslash: "\xd8",
                Ugrave: "\xd9",
                Uacute: "\xda",
                Ucirc: "\xdb",
                Uuml: "\xdc",
                Yacute: "\xdd",
                THORN: "\xde",
                szlig: "\xdf",
                agrave: "\xe0",
                aacute: "\xe1",
                acirc: "\xe2",
                atilde: "\xe3",
                auml: "\xe4",
                aring: "\xe5",
                aelig: "\xe6",
                ccedil: "\xe7",
                egrave: "\xe8",
                eacute: "\xe9",
                ecirc: "\xea",
                euml: "\xeb",
                igrave: "\xec",
                iacute: "\xed",
                icirc: "\xee",
                iuml: "\xef",
                eth: "\xf0",
                ntilde: "\xf1",
                ograve: "\xf2",
                oacute: "\xf3",
                ocirc: "\xf4",
                otilde: "\xf5",
                ouml: "\xf6",
                divide: "\xf7",
                oslash: "\xf8",
                ugrave: "\xf9",
                uacute: "\xfa",
                ucirc: "\xfb",
                uuml: "\xfc",
                yacute: "\xfd",
                thorn: "\xfe",
                yuml: "\xff",
                OElig: "\u0152",
                oelig: "\u0153",
                Scaron: "\u0160",
                scaron: "\u0161",
                Yuml: "\u0178",
                fnof: "\u0192",
                circ: "\u02C6",
                tilde: "\u02DC",
                Alpha: "\u0391",
                Beta: "\u0392",
                Gamma: "\u0393",
                Delta: "\u0394",
                Epsilon: "\u0395",
                Zeta: "\u0396",
                Eta: "\u0397",
                Theta: "\u0398",
                Iota: "\u0399",
                Kappa: "\u039A",
                Lambda: "\u039B",
                Mu: "\u039C",
                Nu: "\u039D",
                Xi: "\u039E",
                Omicron: "\u039F",
                Pi: "\u03A0",
                Rho: "\u03A1",
                Sigma: "\u03A3",
                Tau: "\u03A4",
                Upsilon: "\u03A5",
                Phi: "\u03A6",
                Chi: "\u03A7",
                Psi: "\u03A8",
                Omega: "\u03A9",
                alpha: "\u03B1",
                beta: "\u03B2",
                gamma: "\u03B3",
                delta: "\u03B4",
                epsilon: "\u03B5",
                zeta: "\u03B6",
                eta: "\u03B7",
                theta: "\u03B8",
                iota: "\u03B9",
                kappa: "\u03BA",
                lambda: "\u03BB",
                mu: "\u03BC",
                nu: "\u03BD",
                xi: "\u03BE",
                omicron: "\u03BF",
                pi: "\u03C0",
                rho: "\u03C1",
                sigmaf: "\u03C2",
                sigma: "\u03C3",
                tau: "\u03C4",
                upsilon: "\u03C5",
                phi: "\u03C6",
                chi: "\u03C7",
                psi: "\u03C8",
                omega: "\u03C9",
                thetasym: "\u03D1",
                upsih: "\u03D2",
                piv: "\u03D6",
                ensp: "\u2002",
                emsp: "\u2003",
                thinsp: "\u2009",
                zwnj: "\u200C",
                zwj: "\u200D",
                lrm: "\u200E",
                rlm: "\u200F",
                ndash: "\u2013",
                mdash: "\u2014",
                lsquo: "\u2018",
                rsquo: "\u2019",
                sbquo: "\u201A",
                ldquo: "\u201C",
                rdquo: "\u201D",
                bdquo: "\u201E",
                dagger: "\u2020",
                Dagger: "\u2021",
                bull: "\u2022",
                hellip: "\u2026",
                permil: "\u2030",
                prime: "\u2032",
                Prime: "\u2033",
                lsaquo: "\u2039",
                rsaquo: "\u203A",
                oline: "\u203E",
                frasl: "\u2044",
                euro: "\u20AC",
                image: "\u2111",
                weierp: "\u2118",
                real: "\u211C",
                trade: "\u2122",
                alefsym: "\u2135",
                larr: "\u2190",
                uarr: "\u2191",
                rarr: "\u2192",
                darr: "\u2193",
                harr: "\u2194",
                crarr: "\u21B5",
                lArr: "\u21D0",
                uArr: "\u21D1",
                rArr: "\u21D2",
                dArr: "\u21D3",
                hArr: "\u21D4",
                forall: "\u2200",
                part: "\u2202",
                exist: "\u2203",
                empty: "\u2205",
                nabla: "\u2207",
                isin: "\u2208",
                notin: "\u2209",
                ni: "\u220B",
                prod: "\u220F",
                sum: "\u2211",
                minus: "\u2212",
                lowast: "\u2217",
                radic: "\u221A",
                prop: "\u221D",
                infin: "\u221E",
                ang: "\u2220",
                and: "\u2227",
                or: "\u2228",
                cap: "\u2229",
                cup: "\u222A",
                int: "\u222B",
                there4: "\u2234",
                sim: "\u223C",
                cong: "\u2245",
                asymp: "\u2248",
                ne: "\u2260",
                equiv: "\u2261",
                le: "\u2264",
                ge: "\u2265",
                sub: "\u2282",
                sup: "\u2283",
                nsub: "\u2284",
                sube: "\u2286",
                supe: "\u2287",
                oplus: "\u2295",
                otimes: "\u2297",
                perp: "\u22A5",
                sdot: "\u22C5",
                lceil: "\u2308",
                rceil: "\u2309",
                lfloor: "\u230A",
                rfloor: "\u230B",
                lang: "\u2329",
                rang: "\u232A",
                loz: "\u25CA",
                spades: "\u2660",
                clubs: "\u2663",
                hearts: "\u2665",
                diams: "\u2666"
            }), r = /^[\da-fA-F]+$/, n = /^\d+$/, s = new WeakMap;
            function i(e1) {
                e1 = e1.Parser.acorn || e1;
                let t = s.get(e1);
                if (!t) {
                    const r = e1.tokTypes, n = e1.TokContext, i = e1.TokenType, o = new n("<tag", !1), a = new n("</tag", !1), u = new n("<tag>...</tag>", !0, !0), l = {
                        tc_oTag: o,
                        tc_cTag: a,
                        tc_expr: u
                    }, c = {
                        jsxName: new i("jsxName"),
                        jsxText: new i("jsxText", {
                            beforeExpr: !0
                        }),
                        jsxTagStart: new i("jsxTagStart", {
                            startsExpr: !0
                        }),
                        jsxTagEnd: new i("jsxTagEnd")
                    };
                    c.jsxTagStart.updateContext = function() {
                        this.context.push(u), this.context.push(o), this.exprAllowed = !1;
                    }, c.jsxTagEnd.updateContext = function(e1) {
                        let t = this.context.pop();
                        t === o && e1 === r.slash || t === a ? (this.context.pop(), this.exprAllowed = this.curContext() === u) : this.exprAllowed = !0;
                    }, t = {
                        tokContexts: l,
                        tokTypes: c
                    }, s.set(e1, t);
                }
                return t;
            }
            function o(e1) {
                return e1 ? "JSXIdentifier" === e1.type ? e1.name : "JSXNamespacedName" === e1.type ? e1.namespace.name + ":" + e1.name.name : "JSXMemberExpression" === e1.type ? o(e1.object) + "." + o(e1.property) : void 0 : e1;
            }
            e1.exports = function(e1) {
                return e1 = e1 || {}, function(s) {
                    return function(e1, s) {
                        const a = s.acorn || Cr(), u = i(a), l = a.tokTypes, c = u.tokTypes, p = a.tokContexts, f = u.tokContexts.tc_oTag, d = u.tokContexts.tc_cTag, h = u.tokContexts.tc_expr, m = a.isNewLine, g = a.isIdentifierStart, y = a.isIdentifierChar;
                        return class extends s {
                            static get acornJsx() {
                                return u;
                            }
                            jsx_readToken() {
                                let e1 = "", t = this.pos;
                                for(;;){
                                    this.pos >= this.input.length && this.raise(this.start, "Unterminated JSX contents");
                                    let r = this.input.charCodeAt(this.pos);
                                    switch(r){
                                        case 60:
                                        case 123:
                                            return this.pos === this.start ? 60 === r && this.exprAllowed ? (++this.pos, this.finishToken(c.jsxTagStart)) : this.getTokenFromCode(r) : (e1 += this.input.slice(t, this.pos), this.finishToken(c.jsxText, e1));
                                        case 38:
                                            e1 += this.input.slice(t, this.pos), e1 += this.jsx_readEntity(), t = this.pos;
                                            break;
                                        case 62:
                                        case 125:
                                            this.raise(this.pos, "Unexpected token `" + this.input[this.pos] + "`. Did you mean `" + (62 === r ? "&gt;" : "&rbrace;") + '` or `{"' + this.input[this.pos] + '"}`?');
                                        default:
                                            m(r) ? (e1 += this.input.slice(t, this.pos), e1 += this.jsx_readNewLine(!0), t = this.pos) : ++this.pos;
                                    }
                                }
                            }
                            jsx_readNewLine(e1) {
                                let t, r = this.input.charCodeAt(this.pos);
                                return ++this.pos, 13 === r && 10 === this.input.charCodeAt(this.pos) ? (++this.pos, t = e1 ? "\n" : "\r\n") : t = String.fromCharCode(r), this.options.locations && (++this.curLine, this.lineStart = this.pos), t;
                            }
                            jsx_readString(e1) {
                                let t = "", r = ++this.pos;
                                for(;;){
                                    this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
                                    let n = this.input.charCodeAt(this.pos);
                                    if (n === e1) break;
                                    38 === n ? (t += this.input.slice(r, this.pos), t += this.jsx_readEntity(), r = this.pos) : m(n) ? (t += this.input.slice(r, this.pos), t += this.jsx_readNewLine(!1), r = this.pos) : ++this.pos;
                                }
                                return t += this.input.slice(r, this.pos++), this.finishToken(l.string, t);
                            }
                            jsx_readEntity() {
                                let e1, s = "", i = 0, o = this.input[this.pos];
                                "&" !== o && this.raise(this.pos, "Entity must start with an ampersand");
                                let a = ++this.pos;
                                for(; this.pos < this.input.length && i++ < 10;){
                                    if (o = this.input[this.pos++], ";" === o) {
                                        "#" === s[0] ? "x" === s[1] ? (s = s.substr(2), r.test(s) && (e1 = String.fromCharCode(parseInt(s, 16)))) : (s = s.substr(1), n.test(s) && (e1 = String.fromCharCode(parseInt(s, 10)))) : e1 = t[s];
                                        break;
                                    }
                                    s += o;
                                }
                                return e1 || (this.pos = a, "&");
                            }
                            jsx_readWord() {
                                let e1, t = this.pos;
                                do e1 = this.input.charCodeAt(++this.pos);
                                while (y(e1) || 45 === e1);
                                return this.finishToken(c.jsxName, this.input.slice(t, this.pos));
                            }
                            jsx_parseIdentifier() {
                                let e1 = this.startNode();
                                return this.type === c.jsxName ? e1.name = this.value : this.type.keyword ? e1.name = this.type.keyword : this.unexpected(), this.next(), this.finishNode(e1, "JSXIdentifier");
                            }
                            jsx_parseNamespacedName() {
                                let t = this.start, r = this.startLoc, n = this.jsx_parseIdentifier();
                                if (!e1.allowNamespaces || !this.eat(l.colon)) return n;
                                var s = this.startNodeAt(t, r);
                                return s.namespace = n, s.name = this.jsx_parseIdentifier(), this.finishNode(s, "JSXNamespacedName");
                            }
                            jsx_parseElementName() {
                                if (this.type === c.jsxTagEnd) return "";
                                let t = this.start, r = this.startLoc, n = this.jsx_parseNamespacedName();
                                for(this.type !== l.dot || "JSXNamespacedName" !== n.type || e1.allowNamespacedObjects || this.unexpected(); this.eat(l.dot);){
                                    let e1 = this.startNodeAt(t, r);
                                    e1.object = n, e1.property = this.jsx_parseIdentifier(), n = this.finishNode(e1, "JSXMemberExpression");
                                }
                                return n;
                            }
                            jsx_parseAttributeValue() {
                                switch(this.type){
                                    case l.braceL:
                                        let e1 = this.jsx_parseExpressionContainer();
                                        return "JSXEmptyExpression" === e1.expression.type && this.raise(e1.start, "JSX attributes must only be assigned a non-empty expression"), e1;
                                    case c.jsxTagStart:
                                    case l.string:
                                        return this.parseExprAtom();
                                    default:
                                        this.raise(this.start, "JSX value should be either an expression or a quoted JSX text");
                                }
                            }
                            jsx_parseEmptyExpression() {
                                let e1 = this.startNodeAt(this.lastTokEnd, this.lastTokEndLoc);
                                return this.finishNodeAt(e1, "JSXEmptyExpression", this.start, this.startLoc);
                            }
                            jsx_parseExpressionContainer() {
                                let e1 = this.startNode();
                                return this.next(), e1.expression = this.type === l.braceR ? this.jsx_parseEmptyExpression() : this.parseExpression(), this.expect(l.braceR), this.finishNode(e1, "JSXExpressionContainer");
                            }
                            jsx_parseAttribute() {
                                let e1 = this.startNode();
                                return this.eat(l.braceL) ? (this.expect(l.ellipsis), e1.argument = this.parseMaybeAssign(), this.expect(l.braceR), this.finishNode(e1, "JSXSpreadAttribute")) : (e1.name = this.jsx_parseNamespacedName(), e1.value = this.eat(l.eq) ? this.jsx_parseAttributeValue() : null, this.finishNode(e1, "JSXAttribute"));
                            }
                            jsx_parseOpeningElementAt(e1, t) {
                                let r = this.startNodeAt(e1, t);
                                r.attributes = [];
                                let n = this.jsx_parseElementName();
                                for(n && (r.name = n); this.type !== l.slash && this.type !== c.jsxTagEnd;)r.attributes.push(this.jsx_parseAttribute());
                                return r.selfClosing = this.eat(l.slash), this.expect(c.jsxTagEnd), this.finishNode(r, n ? "JSXOpeningElement" : "JSXOpeningFragment");
                            }
                            jsx_parseClosingElementAt(e1, t) {
                                let r = this.startNodeAt(e1, t), n = this.jsx_parseElementName();
                                return n && (r.name = n), this.expect(c.jsxTagEnd), this.finishNode(r, n ? "JSXClosingElement" : "JSXClosingFragment");
                            }
                            jsx_parseElementAt(e1, t) {
                                let r = this.startNodeAt(e1, t), n = [], s = this.jsx_parseOpeningElementAt(e1, t), i = null;
                                if (!s.selfClosing) {
                                    e: for(;;)switch(this.type){
                                        case c.jsxTagStart:
                                            if (e1 = this.start, t = this.startLoc, this.next(), this.eat(l.slash)) {
                                                i = this.jsx_parseClosingElementAt(e1, t);
                                                break e;
                                            }
                                            n.push(this.jsx_parseElementAt(e1, t));
                                            break;
                                        case c.jsxText:
                                            n.push(this.parseExprAtom());
                                            break;
                                        case l.braceL:
                                            n.push(this.jsx_parseExpressionContainer());
                                            break;
                                        default:
                                            this.unexpected();
                                    }
                                    o(i.name) !== o(s.name) && this.raise(i.start, "Expected corresponding JSX closing tag for <" + o(s.name) + ">");
                                }
                                let a = s.name ? "Element" : "Fragment";
                                return r["opening" + a] = s, r["closing" + a] = i, r.children = n, this.type === l.relational && "<" === this.value && this.raise(this.start, "Adjacent JSX elements must be wrapped in an enclosing tag"), this.finishNode(r, "JSX" + a);
                            }
                            jsx_parseText() {
                                let e1 = this.parseLiteral(this.value);
                                return e1.type = "JSXText", e1;
                            }
                            jsx_parseElement() {
                                let e1 = this.start, t = this.startLoc;
                                return this.next(), this.jsx_parseElementAt(e1, t);
                            }
                            parseExprAtom(e1) {
                                return this.type === c.jsxText ? this.jsx_parseText() : this.type === c.jsxTagStart ? this.jsx_parseElement() : super.parseExprAtom(e1);
                            }
                            readToken(e1) {
                                let t = this.curContext();
                                if (t === h) return this.jsx_readToken();
                                if (t === f || t === d) {
                                    if (g(e1)) return this.jsx_readWord();
                                    if (62 == e1) return ++this.pos, this.finishToken(c.jsxTagEnd);
                                    if ((34 === e1 || 39 === e1) && t == f) return this.jsx_readString(e1);
                                }
                                return 60 === e1 && this.exprAllowed && 33 !== this.input.charCodeAt(this.pos + 1) ? (++this.pos, this.finishToken(c.jsxTagStart)) : super.readToken(e1);
                            }
                            updateContext(e1) {
                                if (this.type == l.braceL) {
                                    var t = this.curContext();
                                    t == f ? this.context.push(p.b_expr) : t == h ? this.context.push(p.b_tmpl) : super.updateContext(e1), this.exprAllowed = !0;
                                } else {
                                    if (this.type !== l.slash || e1 !== c.jsxTagStart) return super.updateContext(e1);
                                    this.context.length -= 2, this.context.push(d), this.exprAllowed = !1;
                                }
                            }
                        };
                    }({
                        allowNamespaces: !1 !== e1.allowNamespaces,
                        allowNamespacedObjects: !!e1.allowNamespacedObjects
                    }, s);
                };
            }, Object.defineProperty(e1.exports, "tokTypes", {
                get: function() {
                    return i(Cr()).tokTypes;
                },
                configurable: !0,
                enumerable: !0
            });
        }(Rr)), Tr;
    }
    function wr() {
        if (Ar) return Er;
        Ar = 1, Object.defineProperty(Er, "__esModule", {
            value: !0
        });
        var e1 = Cr(), t = Dr(), r = gr();
        function n(e1) {
            return e1 && "object" == typeof e1 && "default" in e1 ? e1 : {
                default: e1
            };
        }
        function s(e1) {
            if (e1 && e1.__esModule) return e1;
            var t = Object.create(null);
            return e1 && Object.keys(e1).forEach(function(r) {
                if ("default" !== r) {
                    var n = Object.getOwnPropertyDescriptor(e1, r);
                    Object.defineProperty(t, r, n.get ? n : {
                        enumerable: !0,
                        get: function() {
                            return e1[r];
                        }
                    });
                }
            }), t.default = e1, Object.freeze(t);
        }
        var i = s(e1), o = n(t), a = s(r);
        const u = "Boolean", l = "Identifier", c = "PrivateIdentifier", p = "Keyword", f = "Null", d = "Numeric", h = "Punctuator", m = "String", g = "RegularExpression", y = "Template", E = "JSXIdentifier", x = "JSXText";
        function C(e1, t) {
            this._acornTokTypes = e1, this._tokens = [], this._curlyBrace = null, this._code = t;
        }
        C.prototype = {
            constructor: C,
            translate (e1, t) {
                const r = e1.type, n = this._acornTokTypes;
                if (r === n.name) e1.type = l, "static" === e1.value && (e1.type = p), t.ecmaVersion > 5 && ("yield" === e1.value || "let" === e1.value) && (e1.type = p);
                else if (r === n.privateId) e1.type = c;
                else if (r === n.semi || r === n.comma || r === n.parenL || r === n.parenR || r === n.braceL || r === n.braceR || r === n.dot || r === n.bracketL || r === n.colon || r === n.question || r === n.bracketR || r === n.ellipsis || r === n.arrow || r === n.jsxTagStart || r === n.incDec || r === n.starstar || r === n.jsxTagEnd || r === n.prefix || r === n.questionDot || r.binop && !r.keyword || r.isAssign) e1.type = h, e1.value = this._code.slice(e1.start, e1.end);
                else if (r === n.jsxName) e1.type = E;
                else if ("jsxText" === r.label || r === n.jsxAttrValueToken) e1.type = x;
                else if (r.keyword) "true" === r.keyword || "false" === r.keyword ? e1.type = u : "null" === r.keyword ? e1.type = f : e1.type = p;
                else if (r === n.num) e1.type = d, e1.value = this._code.slice(e1.start, e1.end);
                else if (r === n.string) t.jsxAttrValueToken ? (t.jsxAttrValueToken = !1, e1.type = x) : e1.type = m, e1.value = this._code.slice(e1.start, e1.end);
                else if (r === n.regexp) {
                    e1.type = g;
                    const t = e1.value;
                    e1.regex = {
                        flags: t.flags,
                        pattern: t.pattern
                    }, e1.value = `/${t.pattern}/${t.flags}`;
                }
                return e1;
            },
            onToken (e1, t) {
                const r = this._acornTokTypes, n = t.tokens, s = this._tokens, i = ()=>{
                    n.push(function(e1, t) {
                        const r = e1[0], n = e1[e1.length - 1], s = {
                            type: y,
                            value: t.slice(r.start, n.end)
                        };
                        return r.loc && (s.loc = {
                            start: r.loc.start,
                            end: n.loc.end
                        }), r.range && (s.start = r.range[0], s.end = n.range[1], s.range = [
                            s.start,
                            s.end
                        ]), s;
                    }(this._tokens, this._code)), this._tokens = [];
                };
                if (e1.type !== r.eof) {
                    if (e1.type === r.backQuote) return this._curlyBrace && (n.push(this.translate(this._curlyBrace, t)), this._curlyBrace = null), s.push(e1), void (s.length > 1 && i());
                    if (e1.type === r.dollarBraceL) return s.push(e1), void i();
                    if (e1.type === r.braceR) return this._curlyBrace && n.push(this.translate(this._curlyBrace, t)), void (this._curlyBrace = e1);
                    if (e1.type === r.template || e1.type === r.invalidTemplate) return this._curlyBrace && (s.push(this._curlyBrace), this._curlyBrace = null), void s.push(e1);
                    this._curlyBrace && (n.push(this.translate(this._curlyBrace, t)), this._curlyBrace = null), n.push(this.translate(e1, t));
                } else this._curlyBrace && n.push(this.translate(this._curlyBrace, t));
            }
        };
        const S = [
            3,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15
        ];
        function b() {
            return S[S.length - 1];
        }
        function v(e1) {
            const t = function(e1 = 5) {
                let t = "latest" === e1 ? b() : e1;
                if ("number" != typeof t) throw new Error(`ecmaVersion must be a number or "latest". Received value of type ${typeof e1} instead.`);
                if (t >= 2015 && (t -= 2009), !S.includes(t)) throw new Error("Invalid ecmaVersion.");
                return t;
            }(e1.ecmaVersion), r = function(e1 = "script") {
                if ("script" === e1 || "module" === e1) return e1;
                if ("commonjs" === e1) return "script";
                throw new Error("Invalid sourceType.");
            }(e1.sourceType), n = !0 === e1.range, s = !0 === e1.loc;
            if (3 !== t && e1.allowReserved) throw new Error("`allowReserved` is only supported when ecmaVersion is 3");
            if (void 0 !== e1.allowReserved && "boolean" != typeof e1.allowReserved) throw new Error("`allowReserved`, when present, must be `true` or `false`");
            const i = 3 === t && (e1.allowReserved || "never"), o = e1.ecmaFeatures || {}, a = "commonjs" === e1.sourceType || Boolean(o.globalReturn);
            if ("module" === r && t < 6) throw new Error("sourceType 'module' is not supported when ecmaVersion < 2015. Consider adding `{ ecmaVersion: 2015 }` to the parser options.");
            return Object.assign({}, e1, {
                ecmaVersion: t,
                sourceType: r,
                ranges: n,
                locations: s,
                allowReserved: i,
                allowReturnOutsideFunction: a
            });
        }
        const A = Symbol("espree's internal state"), T = Symbol("espree's esprimaFinishNode");
        var R = ()=>(e1)=>{
                const t = Object.assign({}, e1.acorn.tokTypes);
                return e1.acornJsx && Object.assign(t, e1.acornJsx.tokTypes), class extends e1 {
                    constructor(e1, r){
                        "object" == typeof e1 && null !== e1 || (e1 = {}), "string" == typeof r || r instanceof String || (r = String(r));
                        const n = e1.sourceType, s = v(e1), i = s.ecmaFeatures || {}, o = !0 === s.tokens ? new C(t, r) : null, a = {
                            originalSourceType: n || s.sourceType,
                            tokens: o ? [] : null,
                            comments: !0 === s.comment ? [] : null,
                            impliedStrict: !0 === i.impliedStrict && s.ecmaVersion >= 5,
                            ecmaVersion: s.ecmaVersion,
                            jsxAttrValueToken: !1,
                            lastToken: null,
                            templateElements: []
                        };
                        super({
                            ecmaVersion: s.ecmaVersion,
                            sourceType: s.sourceType,
                            ranges: s.ranges,
                            locations: s.locations,
                            allowReserved: s.allowReserved,
                            allowReturnOutsideFunction: s.allowReturnOutsideFunction,
                            onToken (e1) {
                                o && o.onToken(e1, a), e1.type !== t.eof && (a.lastToken = e1);
                            },
                            onComment (e1, t, n, s, i, o) {
                                if (a.comments) {
                                    const u = function(e1, t, r, n, s, i, o) {
                                        let a;
                                        a = e1 ? "Block" : "#!" === o.slice(r, r + 2) ? "Hashbang" : "Line";
                                        const u = {
                                            type: a,
                                            value: t
                                        };
                                        return "number" == typeof r && (u.start = r, u.end = n, u.range = [
                                            r,
                                            n
                                        ]), "object" == typeof s && (u.loc = {
                                            start: s,
                                            end: i
                                        }), u;
                                    }(e1, t, n, s, i, o, r);
                                    a.comments.push(u);
                                }
                            }
                        }, r), this[A] = a;
                    }
                    tokenize() {
                        do this.next();
                        while (this.type !== t.eof);
                        this.next();
                        const e1 = this[A], r = e1.tokens;
                        return e1.comments && (r.comments = e1.comments), r;
                    }
                    finishNode(...e1) {
                        const t = super.finishNode(...e1);
                        return this[T](t);
                    }
                    finishNodeAt(...e1) {
                        const t = super.finishNodeAt(...e1);
                        return this[T](t);
                    }
                    parse() {
                        const e1 = this[A], t = super.parse();
                        if (t.sourceType = e1.originalSourceType, e1.comments && (t.comments = e1.comments), e1.tokens && (t.tokens = e1.tokens), t.body.length) {
                            const [e1] = t.body;
                            t.range && (t.range[0] = e1.range[0]), t.loc && (t.loc.start = e1.loc.start), t.start = e1.start;
                        }
                        return e1.lastToken && (t.range && (t.range[1] = e1.lastToken.range[1]), t.loc && (t.loc.end = e1.lastToken.loc.end), t.end = e1.lastToken.end), this[A].templateElements.forEach((e1)=>{
                            const t = e1.tail ? 1 : 2;
                            e1.start += -1, e1.end += t, e1.range && (e1.range[0] += -1, e1.range[1] += t), e1.loc && (e1.loc.start.column += -1, e1.loc.end.column += t);
                        }), t;
                    }
                    parseTopLevel(e1) {
                        return this[A].impliedStrict && (this.strict = !0), super.parseTopLevel(e1);
                    }
                    raise(t, r) {
                        const n = e1.acorn.getLineInfo(this.input, t), s = new SyntaxError(r);
                        throw s.index = t, s.lineNumber = n.line, s.column = n.column + 1, s;
                    }
                    raiseRecoverable(e1, t) {
                        this.raise(e1, t);
                    }
                    unexpected(e1) {
                        let t = "Unexpected token";
                        if (null != e1) {
                            if (this.pos = e1, this.options.locations) for(; this.pos < this.lineStart;)this.lineStart = this.input.lastIndexOf("\n", this.lineStart - 2) + 1, --this.curLine;
                            this.nextToken();
                        }
                        this.end > this.start && (t += ` ${this.input.slice(this.start, this.end)}`), this.raise(this.start, t);
                    }
                    jsx_readString(e1) {
                        const r = super.jsx_readString(e1);
                        return this.type === t.string && (this[A].jsxAttrValueToken = !0), r;
                    }
                    [T](e1) {
                        return "TemplateElement" === e1.type && this[A].templateElements.push(e1), e1.type.includes("Function") && !e1.generator && (e1.generator = !1), e1;
                    }
                };
            };
        const D = {
            _regular: null,
            _jsx: null,
            get regular () {
                return null === this._regular && (this._regular = i.Parser.extend(R())), this._regular;
            },
            get jsx () {
                return null === this._jsx && (this._jsx = i.Parser.extend(o.default(), R())), this._jsx;
            },
            get (e1) {
                return Boolean(e1 && e1.ecmaFeatures && e1.ecmaFeatures.jsx) ? this.jsx : this.regular;
            }
        };
        const w = a.KEYS, _ = function() {
            let e1, t = {};
            for(e1 in "function" == typeof Object.create && (t = Object.create(null)), w)Object.hasOwnProperty.call(w, e1) && (t[e1] = e1);
            return "function" == typeof Object.freeze && Object.freeze(t), t;
        }(), k = b(), B = [
            ...S
        ];
        return Er.Syntax = _, Er.VisitorKeys = w, Er.latestEcmaVersion = k, Er.name = "espree", Er.parse = function(e1, t) {
            return new (D.get(t))(t, e1).parse();
        }, Er.supportedEcmaVersions = B, Er.tokenize = function(e1, t) {
            const r = D.get(t);
            return t && !0 === t.tokens || (t = Object.assign({}, t, {
                tokens: !0
            })), new r(t, e1).tokenize();
        }, Er.version = "9.6.1", Er;
    }
    var _r, kr = {}, Br = {
        get exports () {
            return kr;
        },
        set exports (e){
            kr = e;
        }
    };
    function Lr() {
        return _r || (_r = 1, function(e1, t) {
            var r = "__lodash_hash_undefined__", n = 9007199254740991, s = "[object Arguments]", i = "[object Function]", o = "[object Object]", a = /^\[object .+?Constructor\]$/, u = /^(?:0|[1-9]\d*)$/, l = {};
            l["[object Float32Array]"] = l["[object Float64Array]"] = l["[object Int8Array]"] = l["[object Int16Array]"] = l["[object Int32Array]"] = l["[object Uint8Array]"] = l["[object Uint8ClampedArray]"] = l["[object Uint16Array]"] = l["[object Uint32Array]"] = !0, l[s] = l["[object Array]"] = l["[object ArrayBuffer]"] = l["[object Boolean]"] = l["[object DataView]"] = l["[object Date]"] = l["[object Error]"] = l[i] = l["[object Map]"] = l["[object Number]"] = l[o] = l["[object RegExp]"] = l["[object Set]"] = l["[object String]"] = l["[object WeakMap]"] = !1;
            var c = "object" == typeof $parcel$global && $parcel$global && $parcel$global.Object === Object && $parcel$global, p = "object" == typeof self && self && self.Object === Object && self, f = c || p || Function("return this")(), d = t && !t.nodeType && t, h = d && e1 && !e1.nodeType && e1, m = h && h.exports === d, g = m && c.process, y = function() {
                try {
                    var e1 = h && h.require && h.require("util").types;
                    return e1 || g && g.binding && g.binding("util");
                } catch (e1) {}
            }(), E = y && y.isTypedArray;
            var x, C, S, b = Array.prototype, v = Function.prototype, A = Object.prototype, T = f["__core-js_shared__"], R = v.toString, D = A.hasOwnProperty, w = (x = /[^.]+$/.exec(T && T.keys && T.keys.IE_PROTO || "")) ? "Symbol(src)_1." + x : "", _ = A.toString, k = R.call(Object), B = RegExp("^" + R.call(D).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), L = m ? f.Buffer : void 0, P = f.Symbol, I = f.Uint8Array, F = L ? L.allocUnsafe : void 0, N = (C = Object.getPrototypeOf, S = Object, function(e1) {
                return C(S(e1));
            }), O = Object.create, U = A.propertyIsEnumerable, j = b.splice, V = P ? P.toStringTag : void 0, K = function() {
                try {
                    var e1 = de(Object, "defineProperty");
                    return e1({}, "", {}), e1;
                } catch (e1) {}
            }(), M = L ? L.isBuffer : void 0, $ = Math.max, q = Date.now, G = de(f, "Map"), W = de(Object, "create"), X = function() {
                function e1() {}
                return function(t) {
                    if (!Te(t)) return {};
                    if (O) return O(t);
                    e1.prototype = t;
                    var r = new e1;
                    return e1.prototype = void 0, r;
                };
            }();
            function z(e1) {
                var t = -1, r = null == e1 ? 0 : e1.length;
                for(this.clear(); ++t < r;){
                    var n = e1[t];
                    this.set(n[0], n[1]);
                }
            }
            function H(e1) {
                var t = -1, r = null == e1 ? 0 : e1.length;
                for(this.clear(); ++t < r;){
                    var n = e1[t];
                    this.set(n[0], n[1]);
                }
            }
            function J(e1) {
                var t = -1, r = null == e1 ? 0 : e1.length;
                for(this.clear(); ++t < r;){
                    var n = e1[t];
                    this.set(n[0], n[1]);
                }
            }
            function Q(e1) {
                var t = this.__data__ = new H(e1);
                this.size = t.size;
            }
            function Y(e1, t) {
                var r = Ce(e1), n = !r && xe(e1), s = !r && !n && be(e1), i = !r && !n && !s && De(e1), o = r || n || s || i, a = o ? function(e1, t) {
                    for(var r = -1, n = Array(e1); ++r < e1;)n[r] = t(r);
                    return n;
                }(e1.length, String) : [], u = a.length;
                for(var l in e1)!t && !D.call(e1, l) || o && ("length" == l || s && ("offset" == l || "parent" == l) || i && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || he(l, u)) || a.push(l);
                return a;
            }
            function Z(e1, t, r) {
                (void 0 !== r && !Ee(e1[t], r) || void 0 === r && !(t in e1)) && re(e1, t, r);
            }
            function ee(e1, t, r) {
                var n = e1[t];
                D.call(e1, t) && Ee(n, r) && (void 0 !== r || t in e1) || re(e1, t, r);
            }
            function te(e1, t) {
                for(var r = e1.length; r--;)if (Ee(e1[r][0], t)) return r;
                return -1;
            }
            function re(e1, t, r) {
                "__proto__" == t && K ? K(e1, t, {
                    configurable: !0,
                    enumerable: !0,
                    value: r,
                    writable: !0
                }) : e1[t] = r;
            }
            z.prototype.clear = function() {
                this.__data__ = W ? W(null) : {}, this.size = 0;
            }, z.prototype.delete = function(e1) {
                var t = this.has(e1) && delete this.__data__[e1];
                return this.size -= t ? 1 : 0, t;
            }, z.prototype.get = function(e1) {
                var t = this.__data__;
                if (W) {
                    var n = t[e1];
                    return n === r ? void 0 : n;
                }
                return D.call(t, e1) ? t[e1] : void 0;
            }, z.prototype.has = function(e1) {
                var t = this.__data__;
                return W ? void 0 !== t[e1] : D.call(t, e1);
            }, z.prototype.set = function(e1, t) {
                var n = this.__data__;
                return this.size += this.has(e1) ? 0 : 1, n[e1] = W && void 0 === t ? r : t, this;
            }, H.prototype.clear = function() {
                this.__data__ = [], this.size = 0;
            }, H.prototype.delete = function(e1) {
                var t = this.__data__, r = te(t, e1);
                return !(r < 0) && (r == t.length - 1 ? t.pop() : j.call(t, r, 1), --this.size, !0);
            }, H.prototype.get = function(e1) {
                var t = this.__data__, r = te(t, e1);
                return r < 0 ? void 0 : t[r][1];
            }, H.prototype.has = function(e1) {
                return te(this.__data__, e1) > -1;
            }, H.prototype.set = function(e1, t) {
                var r = this.__data__, n = te(r, e1);
                return n < 0 ? (++this.size, r.push([
                    e1,
                    t
                ])) : r[n][1] = t, this;
            }, J.prototype.clear = function() {
                this.size = 0, this.__data__ = {
                    hash: new z,
                    map: new (G || H),
                    string: new z
                };
            }, J.prototype.delete = function(e1) {
                var t = fe(this, e1).delete(e1);
                return this.size -= t ? 1 : 0, t;
            }, J.prototype.get = function(e1) {
                return fe(this, e1).get(e1);
            }, J.prototype.has = function(e1) {
                return fe(this, e1).has(e1);
            }, J.prototype.set = function(e1, t) {
                var r = fe(this, e1), n = r.size;
                return r.set(e1, t), this.size += r.size == n ? 0 : 1, this;
            }, Q.prototype.clear = function() {
                this.__data__ = new H, this.size = 0;
            }, Q.prototype.delete = function(e1) {
                var t = this.__data__, r = t.delete(e1);
                return this.size = t.size, r;
            }, Q.prototype.get = function(e1) {
                return this.__data__.get(e1);
            }, Q.prototype.has = function(e1) {
                return this.__data__.has(e1);
            }, Q.prototype.set = function(e1, t) {
                var r = this.__data__;
                if (r instanceof H) {
                    var n = r.__data__;
                    if (!G || n.length < 199) return n.push([
                        e1,
                        t
                    ]), this.size = ++r.size, this;
                    r = this.__data__ = new J(n);
                }
                return r.set(e1, t), this.size = r.size, this;
            };
            var ne, se = function(e1, t, r) {
                for(var n = -1, s = Object(e1), i = r(e1), o = i.length; o--;){
                    var a = i[ne ? o : ++n];
                    if (!1 === t(s[a], a, s)) break;
                }
                return e1;
            };
            function ie(e1) {
                return null == e1 ? void 0 === e1 ? "[object Undefined]" : "[object Null]" : V && V in Object(e1) ? function(e1) {
                    var t = D.call(e1, V), r = e1[V];
                    try {
                        e1[V] = void 0;
                        var n = !0;
                    } catch (e1) {}
                    var s = _.call(e1);
                    n && (t ? e1[V] = r : delete e1[V]);
                    return s;
                }(e1) : function(e1) {
                    return _.call(e1);
                }(e1);
            }
            function oe(e1) {
                return Re(e1) && ie(e1) == s;
            }
            function ae(e1) {
                return !(!Te(e1) || function(e1) {
                    return !!w && w in e1;
                }(e1)) && (ve(e1) ? B : a).test(function(e1) {
                    if (null != e1) {
                        try {
                            return R.call(e1);
                        } catch (e1) {}
                        try {
                            return e1 + "";
                        } catch (e1) {}
                    }
                    return "";
                }(e1));
            }
            function ue(e1) {
                if (!Te(e1)) return function(e1) {
                    var t = [];
                    if (null != e1) for(var r in Object(e1))t.push(r);
                    return t;
                }(e1);
                var t = me(e1), r = [];
                for(var n in e1)("constructor" != n || !t && D.call(e1, n)) && r.push(n);
                return r;
            }
            function le(e1, t, r, n, s) {
                e1 !== t && se(t, function(i, a) {
                    if (s || (s = new Q), Te(i)) !function(e1, t, r, n, s, i, a) {
                        var u = ge(e1, r), l = ge(t, r), c = a.get(l);
                        if (c) return void Z(e1, r, c);
                        var p = i ? i(u, l, r + "", e1, t, a) : void 0, f = void 0 === p;
                        if (f) {
                            var d = Ce(l), h = !d && be(l), m = !d && !h && De(l);
                            p = l, d || h || m ? Ce(u) ? p = u : Re(C = u) && Se(C) ? p = function(e1, t) {
                                var r = -1, n = e1.length;
                                t || (t = Array(n));
                                for(; ++r < n;)t[r] = e1[r];
                                return t;
                            }(u) : h ? (f = !1, p = function(e1, t) {
                                if (t) return e1.slice();
                                var r = e1.length, n = F ? F(r) : new e1.constructor(r);
                                return e1.copy(n), n;
                            }(l, !0)) : m ? (f = !1, g = l, y = (E = g.buffer, x = new E.constructor(E.byteLength), new I(x).set(new I(E)), x), p = new g.constructor(y, g.byteOffset, g.length)) : p = [] : function(e1) {
                                if (!Re(e1) || ie(e1) != o) return !1;
                                var t = N(e1);
                                if (null === t) return !0;
                                var r = D.call(t, "constructor") && t.constructor;
                                return "function" == typeof r && r instanceof r && R.call(r) == k;
                            }(l) || xe(l) ? (p = u, xe(u) ? p = function(e1) {
                                return function(e1, t, r, n) {
                                    var s = !r;
                                    r || (r = {});
                                    var i = -1, o = t.length;
                                    for(; ++i < o;){
                                        var a = t[i], u = n ? n(r[a], e1[a], a, r, e1) : void 0;
                                        void 0 === u && (u = e1[a]), s ? re(r, a, u) : ee(r, a, u);
                                    }
                                    return r;
                                }(e1, we(e1));
                            }(u) : Te(u) && !ve(u) || (p = function(e1) {
                                return "function" != typeof e1.constructor || me(e1) ? {} : X(N(e1));
                            }(l))) : f = !1;
                        }
                        var g, y, E, x;
                        var C;
                        f && (a.set(l, p), s(p, l, n, i, a), a.delete(l));
                        Z(e1, r, p);
                    }(e1, t, a, r, le, n, s);
                    else {
                        var u = n ? n(ge(e1, a), i, a + "", e1, t, s) : void 0;
                        void 0 === u && (u = i), Z(e1, a, u);
                    }
                }, we);
            }
            function ce(e1, t) {
                return ye(function(e1, t, r) {
                    return t = $(void 0 === t ? e1.length - 1 : t, 0), function() {
                        for(var n = arguments, s = -1, i = $(n.length - t, 0), o = Array(i); ++s < i;)o[s] = n[t + s];
                        s = -1;
                        for(var a = Array(t + 1); ++s < t;)a[s] = n[s];
                        return a[t] = r(o), function(e1, t, r) {
                            switch(r.length){
                                case 0:
                                    return e1.call(t);
                                case 1:
                                    return e1.call(t, r[0]);
                                case 2:
                                    return e1.call(t, r[0], r[1]);
                                case 3:
                                    return e1.call(t, r[0], r[1], r[2]);
                            }
                            return e1.apply(t, r);
                        }(e1, this, a);
                    };
                }(e1, t, Be), e1 + "");
            }
            var pe = K ? function(e1, t) {
                var r;
                return K(e1, "toString", {
                    configurable: !0,
                    enumerable: !1,
                    value: (r = t, function() {
                        return r;
                    }),
                    writable: !0
                });
            } : Be;
            function fe(e1, t) {
                var r = e1.__data__;
                return function(e1) {
                    var t = typeof e1;
                    return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e1 : null === e1;
                }(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
            }
            function de(e1, t) {
                var r = function(e1, t) {
                    return null == e1 ? void 0 : e1[t];
                }(e1, t);
                return ae(r) ? r : void 0;
            }
            function he(e1, t) {
                var r = typeof e1;
                return !!(t = null == t ? n : t) && ("number" == r || "symbol" != r && u.test(e1)) && e1 > -1 && e1 % 1 == 0 && e1 < t;
            }
            function me(e1) {
                var t = e1 && e1.constructor;
                return e1 === ("function" == typeof t && t.prototype || A);
            }
            function ge(e1, t) {
                if (("constructor" !== t || "function" != typeof e1[t]) && "__proto__" != t) return e1[t];
            }
            var ye = function(e1) {
                var t = 0, r = 0;
                return function() {
                    var n = q(), s = 16 - (n - r);
                    if (r = n, s > 0) {
                        if (++t >= 800) return arguments[0];
                    } else t = 0;
                    return e1.apply(void 0, arguments);
                };
            }(pe);
            function Ee(e1, t) {
                return e1 === t || e1 != e1 && t != t;
            }
            var xe = oe(function() {
                return arguments;
            }()) ? oe : function(e1) {
                return Re(e1) && D.call(e1, "callee") && !U.call(e1, "callee");
            }, Ce = Array.isArray;
            function Se(e1) {
                return null != e1 && Ae(e1.length) && !ve(e1);
            }
            var be = M || function() {
                return !1;
            };
            function ve(e1) {
                if (!Te(e1)) return !1;
                var t = ie(e1);
                return t == i || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
            }
            function Ae(e1) {
                return "number" == typeof e1 && e1 > -1 && e1 % 1 == 0 && e1 <= n;
            }
            function Te(e1) {
                var t = typeof e1;
                return null != e1 && ("object" == t || "function" == t);
            }
            function Re(e1) {
                return null != e1 && "object" == typeof e1;
            }
            var De = E ? function(e1) {
                return function(t) {
                    return e1(t);
                };
            }(E) : function(e1) {
                return Re(e1) && Ae(e1.length) && !!l[ie(e1)];
            };
            function we(e1) {
                return Se(e1) ? Y(e1, !0) : ue(e1);
            }
            var _e, ke = (_e = function(e1, t, r) {
                le(e1, t, r);
            }, ce(function(e1, t) {
                var r = -1, n = t.length, s = n > 1 ? t[n - 1] : void 0, i = n > 2 ? t[2] : void 0;
                for(s = _e.length > 3 && "function" == typeof s ? (n--, s) : void 0, i && function(e1, t, r) {
                    if (!Te(r)) return !1;
                    var n = typeof t;
                    return !!("number" == n ? Se(r) && he(t, r.length) : "string" == n && t in r) && Ee(r[t], e1);
                }(t[0], t[1], i) && (s = n < 3 ? void 0 : s, n = 1), e1 = Object(e1); ++r < n;){
                    var o = t[r];
                    o && _e(e1, o, r, s);
                }
                return e1;
            }));
            function Be(e1) {
                return e1;
            }
            e1.exports = ke;
        }(Br, kr)), kr;
    }
    var Pr, Ir, Fr, Nr, Or = {
        name: "eslint",
        version: "8.57.1",
        author: "Nicholas C. Zakas <nicholas+npm@nczconsulting.com>",
        description: "An AST-based pattern checker for JavaScript.",
        bin: {
            eslint: "./bin/eslint.js"
        },
        main: "./lib/api.js",
        exports: {
            "./package.json": "./package.json",
            ".": "./lib/api.js",
            "./use-at-your-own-risk": "./lib/unsupported-api.js"
        },
        scripts: {
            "build:docs:update-links": "node tools/fetch-docs-links.js",
            "build:site": "node Makefile.js gensite",
            "build:webpack": "node Makefile.js webpack",
            "build:readme": "node tools/update-readme.js",
            lint: "node Makefile.js lint",
            "lint:docs:js": "node Makefile.js lintDocsJS",
            "lint:docs:rule-examples": "node Makefile.js checkRuleExamples",
            "lint:fix": "node Makefile.js lint -- fix",
            "lint:fix:docs:js": "node Makefile.js lintDocsJS -- fix",
            "release:generate:alpha": "node Makefile.js generatePrerelease -- alpha",
            "release:generate:beta": "node Makefile.js generatePrerelease -- beta",
            "release:generate:latest": "node Makefile.js generateRelease -- latest",
            "release:generate:maintenance": "node Makefile.js generateRelease -- maintenance",
            "release:generate:rc": "node Makefile.js generatePrerelease -- rc",
            "release:publish": "node Makefile.js publishRelease",
            test: "node Makefile.js test",
            "test:cli": "mocha",
            "test:fuzz": "node Makefile.js fuzz",
            "test:performance": "node Makefile.js perf"
        },
        gitHooks: {
            "pre-commit": "lint-staged"
        },
        "lint-staged": {
            "*.js": "eslint --fix",
            "*.md": "markdownlint --fix",
            "lib/rules/*.js": [
                "node tools/update-eslint-all.js",
                "git add packages/js/src/configs/eslint-all.js"
            ],
            "docs/src/rules/*.md": [
                "node tools/check-rule-examples.js",
                "node tools/fetch-docs-links.js",
                "git add docs/src/_data/further_reading_links.json"
            ],
            "docs/**/*.svg": "npx svgo -r --multipass"
        },
        files: [
            "LICENSE",
            "README.md",
            "bin",
            "conf",
            "lib",
            "messages"
        ],
        repository: "eslint/eslint",
        funding: "https://opencollective.com/eslint",
        homepage: "https://eslint.org",
        bugs: "https://github.com/eslint/eslint/issues/",
        dependencies: {
            "@eslint-community/eslint-utils": "^4.2.0",
            "@eslint-community/regexpp": "^4.6.1",
            "@eslint/eslintrc": "^2.1.4",
            "@eslint/js": "8.57.1",
            "@humanwhocodes/config-array": "^0.13.0",
            "@humanwhocodes/module-importer": "^1.0.1",
            "@nodelib/fs.walk": "^1.2.8",
            "@ungap/structured-clone": "^1.2.0",
            ajv: "^6.12.4",
            chalk: "^4.0.0",
            "cross-spawn": "^7.0.2",
            debug: "^4.3.2",
            doctrine: "^3.0.0",
            "escape-string-regexp": "^4.0.0",
            "eslint-scope": "^7.2.2",
            "eslint-visitor-keys": "^3.4.3",
            espree: "^9.6.1",
            esquery: "^1.4.2",
            esutils: "^2.0.2",
            "fast-deep-equal": "^3.1.3",
            "file-entry-cache": "^6.0.1",
            "find-up": "^5.0.0",
            "glob-parent": "^6.0.2",
            globals: "^13.19.0",
            graphemer: "^1.4.0",
            ignore: "^5.2.0",
            imurmurhash: "^0.1.4",
            "is-glob": "^4.0.0",
            "is-path-inside": "^3.0.3",
            "js-yaml": "^4.1.0",
            "json-stable-stringify-without-jsonify": "^1.0.1",
            levn: "^0.4.1",
            "lodash.merge": "^4.6.2",
            minimatch: "^3.1.2",
            "natural-compare": "^1.4.0",
            optionator: "^0.9.3",
            "strip-ansi": "^6.0.1",
            "text-table": "^0.2.0"
        },
        devDependencies: {
            "@babel/core": "^7.4.3",
            "@babel/preset-env": "^7.4.3",
            "@sinonjs/fake-timers": "11.2.2",
            "@wdio/browser-runner": "^8.14.6",
            "@wdio/cli": "^8.14.6",
            "@wdio/concise-reporter": "^8.14.0",
            "@wdio/globals": "^8.14.6",
            "@wdio/mocha-framework": "^8.14.0",
            "babel-loader": "^8.0.5",
            c8: "^7.12.0",
            chai: "^4.0.1",
            cheerio: "^0.22.0",
            "common-tags": "^1.8.0",
            "core-js": "^3.1.3",
            ejs: "^3.0.2",
            eslint: "file:.",
            "eslint-config-eslint": "file:packages/eslint-config-eslint",
            "eslint-plugin-eslint-comments": "^3.2.0",
            "eslint-plugin-eslint-plugin": "^5.2.1",
            "eslint-plugin-internal-rules": "file:tools/internal-rules",
            "eslint-plugin-jsdoc": "^46.2.5",
            "eslint-plugin-n": "^16.6.0",
            "eslint-plugin-unicorn": "^49.0.0",
            "eslint-release": "^3.3.0",
            eslump: "^3.0.0",
            esprima: "^4.0.1",
            "fast-glob": "^3.2.11",
            "fs-teardown": "^0.1.3",
            glob: "^7.1.6",
            got: "^11.8.3",
            "gray-matter": "^4.0.3",
            "lint-staged": "^11.0.0",
            "load-perf": "^0.2.0",
            "markdown-it": "^12.2.0",
            "markdown-it-container": "^3.0.0",
            markdownlint: "^0.32.0",
            "markdownlint-cli": "^0.37.0",
            marked: "^4.0.8",
            memfs: "^3.0.1",
            metascraper: "^5.25.7",
            "metascraper-description": "^5.25.7",
            "metascraper-image": "^5.29.3",
            "metascraper-logo": "^5.25.7",
            "metascraper-logo-favicon": "^5.25.7",
            "metascraper-title": "^5.25.7",
            mocha: "^8.3.2",
            "mocha-junit-reporter": "^2.0.0",
            "node-polyfill-webpack-plugin": "^1.0.3",
            "npm-license": "^0.3.3",
            pirates: "^4.0.5",
            progress: "^2.0.3",
            proxyquire: "^2.0.1",
            recast: "^0.23.0",
            "regenerator-runtime": "^0.14.0",
            "rollup-plugin-node-polyfills": "^0.2.1",
            semver: "^7.5.3",
            shelljs: "^0.8.2",
            sinon: "^11.0.0",
            "vite-plugin-commonjs": "0.10.1",
            webdriverio: "^8.14.6",
            webpack: "^5.23.0",
            "webpack-cli": "^4.5.0",
            yorkie: "^2.0.0"
        },
        keywords: [
            "ast",
            "lint",
            "javascript",
            "ecmascript",
            "espree"
        ],
        license: "MIT",
        engines: {
            node: "^12.22.0 || ^14.17.0 || >=16.0.0"
        }
    };
    function Ur() {
        if (Ir) return Pr;
        Ir = 1;
        const e1 = /\r\n|[\r\n\u2028\u2029]/u;
        return Pr = {
            breakableTypePattern: /^(?:(?:Do)?While|For(?:In|Of)?|Switch)Statement$/u,
            lineBreakPattern: e1,
            createGlobalLinebreakMatcher: function() {
                return new RegExp(e1.source, "gu");
            },
            shebangPattern: /^#!([^\r\n]+)/u
        };
    }
    function jr() {
        if (Nr) return Fr;
        Nr = 1;
        return Fr = {
            directivesPattern: /^(eslint(?:-env|-enable|-disable(?:(?:-next)?-line)?)?|exported|globals?)(?:\s|$)/u
        };
    }
    var Vr, Kr, Mr, $r, qr, Gr, Wr, Xr, zr, Hr = {}, Jr = t(Rt), Qr = {};
    function Yr() {
        return Vr || (Vr = 1, function(e1, t) {
            !function(e1) {
                function t() {
                    for(var e1 = arguments.length, t = Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    if (t.length > 1) {
                        t[0] = t[0].slice(0, -1);
                        for(var n = t.length - 1, s = 1; s < n; ++s)t[s] = t[s].slice(1, -1);
                        return t[n] = t[n].slice(1), t.join("");
                    }
                    return t[0];
                }
                function r(e1) {
                    return "(?:" + e1 + ")";
                }
                function n(e1) {
                    return void 0 === e1 ? "undefined" : null === e1 ? "null" : Object.prototype.toString.call(e1).split(" ").pop().split("]").shift().toLowerCase();
                }
                function s(e1) {
                    return e1.toUpperCase();
                }
                function i(e1) {
                    return null != e1 ? e1 instanceof Array ? e1 : "number" != typeof e1.length || e1.split || e1.setInterval || e1.call ? [
                        e1
                    ] : Array.prototype.slice.call(e1) : [];
                }
                function o(e1, t) {
                    var r = e1;
                    if (t) for(var n in t)r[n] = t[n];
                    return r;
                }
                function a(e1) {
                    var n = "[A-Za-z]", s = "[0-9]", i = t(s, "[A-Fa-f]"), o = r(r("%[EFef]" + i + "%" + i + i + "%" + i + i) + "|" + r("%[89A-Fa-f]" + i + "%" + i + i) + "|" + r("%" + i + i)), a = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", u = t("[\\:\\/\\?\\#\\[\\]\\@]", a), l = e1 ? "[\\uE000-\\uF8FF]" : "[]", c = t(n, s, "[\\-\\.\\_\\~]", e1 ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]");
                    r(n + t(n, s, "[\\+\\-\\.]") + "*"), r(r(o + "|" + t(c, a, "[\\:]")) + "*");
                    var p = r(r("25[0-5]") + "|" + r("2[0-4]" + s) + "|" + r("1" + s + s) + "|" + r("0?[1-9]" + s) + "|0?0?" + s), f = r(p + "\\." + p + "\\." + p + "\\." + p), d = r(i + "{1,4}"), h = r(r(d + "\\:" + d) + "|" + f), m = r(r(d + "\\:") + "{6}" + h), g = r("\\:\\:" + r(d + "\\:") + "{5}" + h), y = r(r(d) + "?\\:\\:" + r(d + "\\:") + "{4}" + h), E = r(r(r(d + "\\:") + "{0,1}" + d) + "?\\:\\:" + r(d + "\\:") + "{3}" + h), x = r(r(r(d + "\\:") + "{0,2}" + d) + "?\\:\\:" + r(d + "\\:") + "{2}" + h), C = r(r(r(d + "\\:") + "{0,3}" + d) + "?\\:\\:" + d + "\\:" + h), S = r(r(r(d + "\\:") + "{0,4}" + d) + "?\\:\\:" + h), b = r(r(r(d + "\\:") + "{0,5}" + d) + "?\\:\\:" + d), v = r(r(r(d + "\\:") + "{0,6}" + d) + "?\\:\\:"), A = r([
                        m,
                        g,
                        y,
                        E,
                        x,
                        C,
                        S,
                        b,
                        v
                    ].join("|")), T = r(r(c + "|" + o) + "+");
                    r("[vV]" + i + "+\\." + t(c, a, "[\\:]") + "+"), r(r(o + "|" + t(c, a)) + "*");
                    var R = r(o + "|" + t(c, a, "[\\:\\@]"));
                    return r(r(o + "|" + t(c, a, "[\\@]")) + "+"), r(r(R + "|" + t("[\\/\\?]", l)) + "*"), {
                        NOT_SCHEME: new RegExp(t("[^]", n, s, "[\\+\\-\\.]"), "g"),
                        NOT_USERINFO: new RegExp(t("[^\\%\\:]", c, a), "g"),
                        NOT_HOST: new RegExp(t("[^\\%\\[\\]\\:]", c, a), "g"),
                        NOT_PATH: new RegExp(t("[^\\%\\/\\:\\@]", c, a), "g"),
                        NOT_PATH_NOSCHEME: new RegExp(t("[^\\%\\/\\@]", c, a), "g"),
                        NOT_QUERY: new RegExp(t("[^\\%]", c, a, "[\\:\\@\\/\\?]", l), "g"),
                        NOT_FRAGMENT: new RegExp(t("[^\\%]", c, a, "[\\:\\@\\/\\?]"), "g"),
                        ESCAPE: new RegExp(t("[^]", c, a), "g"),
                        UNRESERVED: new RegExp(c, "g"),
                        OTHER_CHARS: new RegExp(t("[^\\%]", c, u), "g"),
                        PCT_ENCODED: new RegExp(o, "g"),
                        IPV4ADDRESS: new RegExp("^(" + f + ")$"),
                        IPV6ADDRESS: new RegExp("^\\[?(" + A + ")" + r(r("\\%25|\\%(?!" + i + "{2})") + "(" + T + ")") + "?\\]?$")
                    };
                }
                var u = a(!1), l = a(!0), c = function() {
                    function e1(e1, t) {
                        var r = [], n = !0, s = !1, i = void 0;
                        try {
                            for(var o, a = e1[Symbol.iterator](); !(n = (o = a.next()).done) && (r.push(o.value), !t || r.length !== t); n = !0);
                        } catch (e1) {
                            s = !0, i = e1;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (s) throw i;
                            }
                        }
                        return r;
                    }
                    return function(t, r) {
                        if (Array.isArray(t)) return t;
                        if (Symbol.iterator in Object(t)) return e1(t, r);
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    };
                }(), p = function(e1) {
                    if (Array.isArray(e1)) {
                        for(var t = 0, r = Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                        return r;
                    }
                    return Array.from(e1);
                }, f = 2147483647, d = 36, h = 1, m = 26, g = 38, y = 700, E = 72, x = 128, C = "-", S = /^xn--/, b = /[^\0-\x7E]/, v = /[\x2E\u3002\uFF0E\uFF61]/g, A = {
                    overflow: "Overflow: input needs wider integers to process",
                    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                    "invalid-input": "Invalid input"
                }, T = d - h, R = Math.floor, D = String.fromCharCode;
                function w(e1) {
                    throw new RangeError(A[e1]);
                }
                function _(e1, t) {
                    for(var r = [], n = e1.length; n--;)r[n] = t(e1[n]);
                    return r;
                }
                function k(e1, t) {
                    var r = e1.split("@"), n = "";
                    return r.length > 1 && (n = r[0] + "@", e1 = r[1]), n + _((e1 = e1.replace(v, ".")).split("."), t).join(".");
                }
                function B(e1) {
                    for(var t = [], r = 0, n = e1.length; r < n;){
                        var s = e1.charCodeAt(r++);
                        if (s >= 55296 && s <= 56319 && r < n) {
                            var i = e1.charCodeAt(r++);
                            56320 == (64512 & i) ? t.push(((1023 & s) << 10) + (1023 & i) + 65536) : (t.push(s), r--);
                        } else t.push(s);
                    }
                    return t;
                }
                var L = function(e1) {
                    return e1 - 48 < 10 ? e1 - 22 : e1 - 65 < 26 ? e1 - 65 : e1 - 97 < 26 ? e1 - 97 : d;
                }, P = function(e1, t) {
                    return e1 + 22 + 75 * (e1 < 26) - ((0 != t) << 5);
                }, I = function(e1, t, r) {
                    var n = 0;
                    for(e1 = r ? R(e1 / y) : e1 >> 1, e1 += R(e1 / t); e1 > T * m >> 1; n += d)e1 = R(e1 / T);
                    return R(n + (T + 1) * e1 / (e1 + g));
                }, F = function(e1) {
                    var t = [], r = e1.length, n = 0, s = x, i = E, o = e1.lastIndexOf(C);
                    o < 0 && (o = 0);
                    for(var a = 0; a < o; ++a)e1.charCodeAt(a) >= 128 && w("not-basic"), t.push(e1.charCodeAt(a));
                    for(var u = o > 0 ? o + 1 : 0; u < r;){
                        for(var l = n, c = 1, p = d;; p += d){
                            u >= r && w("invalid-input");
                            var g = L(e1.charCodeAt(u++));
                            (g >= d || g > R((f - n) / c)) && w("overflow"), n += g * c;
                            var y = p <= i ? h : p >= i + m ? m : p - i;
                            if (g < y) break;
                            var S = d - y;
                            c > R(f / S) && w("overflow"), c *= S;
                        }
                        var b = t.length + 1;
                        i = I(n - l, b, 0 == l), R(n / b) > f - s && w("overflow"), s += R(n / b), n %= b, t.splice(n++, 0, s);
                    }
                    return String.fromCodePoint.apply(String, t);
                }, N = function(e1) {
                    var t = [], r = (e1 = B(e1)).length, n = x, s = 0, i = E, o = !0, a = !1, u = void 0;
                    try {
                        for(var l, c = e1[Symbol.iterator](); !(o = (l = c.next()).done); o = !0){
                            var p = l.value;
                            p < 128 && t.push(D(p));
                        }
                    } catch (e1) {
                        a = !0, u = e1;
                    } finally{
                        try {
                            !o && c.return && c.return();
                        } finally{
                            if (a) throw u;
                        }
                    }
                    var g = t.length, y = g;
                    for(g && t.push(C); y < r;){
                        var S = f, b = !0, v = !1, A = void 0;
                        try {
                            for(var T, _ = e1[Symbol.iterator](); !(b = (T = _.next()).done); b = !0){
                                var k = T.value;
                                k >= n && k < S && (S = k);
                            }
                        } catch (e1) {
                            v = !0, A = e1;
                        } finally{
                            try {
                                !b && _.return && _.return();
                            } finally{
                                if (v) throw A;
                            }
                        }
                        var L = y + 1;
                        S - n > R((f - s) / L) && w("overflow"), s += (S - n) * L, n = S;
                        var F = !0, N = !1, O = void 0;
                        try {
                            for(var U, j = e1[Symbol.iterator](); !(F = (U = j.next()).done); F = !0){
                                var V = U.value;
                                if (V < n && ++s > f && w("overflow"), V == n) {
                                    for(var K = s, M = d;; M += d){
                                        var $ = M <= i ? h : M >= i + m ? m : M - i;
                                        if (K < $) break;
                                        var q = K - $, G = d - $;
                                        t.push(D(P($ + q % G, 0))), K = R(q / G);
                                    }
                                    t.push(D(P(K, 0))), i = I(s, L, y == g), s = 0, ++y;
                                }
                            }
                        } catch (e1) {
                            N = !0, O = e1;
                        } finally{
                            try {
                                !F && j.return && j.return();
                            } finally{
                                if (N) throw O;
                            }
                        }
                        ++s, ++n;
                    }
                    return t.join("");
                }, O = function(e1) {
                    return k(e1, function(e1) {
                        return S.test(e1) ? F(e1.slice(4).toLowerCase()) : e1;
                    });
                }, U = function(e1) {
                    return k(e1, function(e1) {
                        return b.test(e1) ? "xn--" + N(e1) : e1;
                    });
                }, j = {
                    version: "2.1.0",
                    ucs2: {
                        decode: B,
                        encode: function(e1) {
                            return String.fromCodePoint.apply(String, p(e1));
                        }
                    },
                    decode: F,
                    encode: N,
                    toASCII: U,
                    toUnicode: O
                }, V = {};
                function K(e1) {
                    var t = e1.charCodeAt(0);
                    return t < 16 ? "%0" + t.toString(16).toUpperCase() : t < 128 ? "%" + t.toString(16).toUpperCase() : t < 2048 ? "%" + (t >> 6 | 192).toString(16).toUpperCase() + "%" + (63 & t | 128).toString(16).toUpperCase() : "%" + (t >> 12 | 224).toString(16).toUpperCase() + "%" + (t >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (63 & t | 128).toString(16).toUpperCase();
                }
                function M(e1) {
                    for(var t = "", r = 0, n = e1.length; r < n;){
                        var s = parseInt(e1.substr(r + 1, 2), 16);
                        if (s < 128) t += String.fromCharCode(s), r += 3;
                        else if (s >= 194 && s < 224) {
                            if (n - r >= 6) {
                                var i = parseInt(e1.substr(r + 4, 2), 16);
                                t += String.fromCharCode((31 & s) << 6 | 63 & i);
                            } else t += e1.substr(r, 6);
                            r += 6;
                        } else if (s >= 224) {
                            if (n - r >= 9) {
                                var o = parseInt(e1.substr(r + 4, 2), 16), a = parseInt(e1.substr(r + 7, 2), 16);
                                t += String.fromCharCode((15 & s) << 12 | (63 & o) << 6 | 63 & a);
                            } else t += e1.substr(r, 9);
                            r += 9;
                        } else t += e1.substr(r, 3), r += 3;
                    }
                    return t;
                }
                function $(e1, t) {
                    function r(e1) {
                        var r = M(e1);
                        return r.match(t.UNRESERVED) ? r : e1;
                    }
                    return e1.scheme && (e1.scheme = String(e1.scheme).replace(t.PCT_ENCODED, r).toLowerCase().replace(t.NOT_SCHEME, "")), void 0 !== e1.userinfo && (e1.userinfo = String(e1.userinfo).replace(t.PCT_ENCODED, r).replace(t.NOT_USERINFO, K).replace(t.PCT_ENCODED, s)), void 0 !== e1.host && (e1.host = String(e1.host).replace(t.PCT_ENCODED, r).toLowerCase().replace(t.NOT_HOST, K).replace(t.PCT_ENCODED, s)), void 0 !== e1.path && (e1.path = String(e1.path).replace(t.PCT_ENCODED, r).replace(e1.scheme ? t.NOT_PATH : t.NOT_PATH_NOSCHEME, K).replace(t.PCT_ENCODED, s)), void 0 !== e1.query && (e1.query = String(e1.query).replace(t.PCT_ENCODED, r).replace(t.NOT_QUERY, K).replace(t.PCT_ENCODED, s)), void 0 !== e1.fragment && (e1.fragment = String(e1.fragment).replace(t.PCT_ENCODED, r).replace(t.NOT_FRAGMENT, K).replace(t.PCT_ENCODED, s)), e1;
                }
                function q(e1) {
                    return e1.replace(/^0*(.*)/, "$1") || "0";
                }
                function G(e1, t) {
                    var r = e1.match(t.IPV4ADDRESS) || [], n = c(r, 2)[1];
                    return n ? n.split(".").map(q).join(".") : e1;
                }
                function W(e1, t) {
                    var r = e1.match(t.IPV6ADDRESS) || [], n = c(r, 3), s = n[1], i = n[2];
                    if (s) {
                        for(var o = s.toLowerCase().split("::").reverse(), a = c(o, 2), u = a[0], l = a[1], p = l ? l.split(":").map(q) : [], f = u.split(":").map(q), d = t.IPV4ADDRESS.test(f[f.length - 1]), h = d ? 7 : 8, m = f.length - h, g = Array(h), y = 0; y < h; ++y)g[y] = p[y] || f[m + y] || "";
                        d && (g[h - 1] = G(g[h - 1], t));
                        var E = g.reduce(function(e1, t, r) {
                            if (!t || "0" === t) {
                                var n = e1[e1.length - 1];
                                n && n.index + n.length === r ? n.length++ : e1.push({
                                    index: r,
                                    length: 1
                                });
                            }
                            return e1;
                        }, []).sort(function(e1, t) {
                            return t.length - e1.length;
                        })[0], x = void 0;
                        if (E && E.length > 1) {
                            var C = g.slice(0, E.index), S = g.slice(E.index + E.length);
                            x = C.join(":") + "::" + S.join(":");
                        } else x = g.join(":");
                        return i && (x += "%" + i), x;
                    }
                    return e1;
                }
                var X = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i, z = void 0 === "".match(/(){0}/)[1];
                function H(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = {}, n = !1 !== t.iri ? l : u;
                    "suffix" === t.reference && (e1 = (t.scheme ? t.scheme + ":" : "") + "//" + e1);
                    var s = e1.match(X);
                    if (s) {
                        z ? (r.scheme = s[1], r.userinfo = s[3], r.host = s[4], r.port = parseInt(s[5], 10), r.path = s[6] || "", r.query = s[7], r.fragment = s[8], isNaN(r.port) && (r.port = s[5])) : (r.scheme = s[1] || void 0, r.userinfo = -1 !== e1.indexOf("@") ? s[3] : void 0, r.host = -1 !== e1.indexOf("//") ? s[4] : void 0, r.port = parseInt(s[5], 10), r.path = s[6] || "", r.query = -1 !== e1.indexOf("?") ? s[7] : void 0, r.fragment = -1 !== e1.indexOf("#") ? s[8] : void 0, isNaN(r.port) && (r.port = e1.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? s[4] : void 0)), r.host && (r.host = W(G(r.host, n), n)), void 0 !== r.scheme || void 0 !== r.userinfo || void 0 !== r.host || void 0 !== r.port || r.path || void 0 !== r.query ? void 0 === r.scheme ? r.reference = "relative" : void 0 === r.fragment ? r.reference = "absolute" : r.reference = "uri" : r.reference = "same-document", t.reference && "suffix" !== t.reference && t.reference !== r.reference && (r.error = r.error || "URI is not a " + t.reference + " reference.");
                        var i = V[(t.scheme || r.scheme || "").toLowerCase()];
                        if (t.unicodeSupport || i && i.unicodeSupport) $(r, n);
                        else {
                            if (r.host && (t.domainHost || i && i.domainHost)) try {
                                r.host = j.toASCII(r.host.replace(n.PCT_ENCODED, M).toLowerCase());
                            } catch (e1) {
                                r.error = r.error || "Host's domain name can not be converted to ASCII via punycode: " + e1;
                            }
                            $(r, u);
                        }
                        i && i.parse && i.parse(r, t);
                    } else r.error = r.error || "URI can not be parsed.";
                    return r;
                }
                function J(e1, t) {
                    var r = !1 !== t.iri ? l : u, n = [];
                    return void 0 !== e1.userinfo && (n.push(e1.userinfo), n.push("@")), void 0 !== e1.host && n.push(W(G(String(e1.host), r), r).replace(r.IPV6ADDRESS, function(e1, t, r) {
                        return "[" + t + (r ? "%25" + r : "") + "]";
                    })), "number" != typeof e1.port && "string" != typeof e1.port || (n.push(":"), n.push(String(e1.port))), n.length ? n.join("") : void 0;
                }
                var Q = /^\.\.?\//, Y = /^\/\.(\/|$)/, Z = /^\/\.\.(\/|$)/, ee = /^\/?(?:.|\n)*?(?=\/|$)/;
                function te(e1) {
                    for(var t = []; e1.length;)if (e1.match(Q)) e1 = e1.replace(Q, "");
                    else if (e1.match(Y)) e1 = e1.replace(Y, "/");
                    else if (e1.match(Z)) e1 = e1.replace(Z, "/"), t.pop();
                    else if ("." === e1 || ".." === e1) e1 = "";
                    else {
                        var r = e1.match(ee);
                        if (!r) throw new Error("Unexpected dot segment condition");
                        var n = r[0];
                        e1 = e1.slice(n.length), t.push(n);
                    }
                    return t.join("");
                }
                function re(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.iri ? l : u, n = [], s = V[(t.scheme || e1.scheme || "").toLowerCase()];
                    if (s && s.serialize && s.serialize(e1, t), e1.host) {
                        if (r.IPV6ADDRESS.test(e1.host)) ;
                        else if (t.domainHost || s && s.domainHost) try {
                            e1.host = t.iri ? j.toUnicode(e1.host) : j.toASCII(e1.host.replace(r.PCT_ENCODED, M).toLowerCase());
                        } catch (r) {
                            e1.error = e1.error || "Host's domain name can not be converted to " + (t.iri ? "Unicode" : "ASCII") + " via punycode: " + r;
                        }
                    }
                    $(e1, r), "suffix" !== t.reference && e1.scheme && (n.push(e1.scheme), n.push(":"));
                    var i = J(e1, t);
                    if (void 0 !== i && ("suffix" !== t.reference && n.push("//"), n.push(i), e1.path && "/" !== e1.path.charAt(0) && n.push("/")), void 0 !== e1.path) {
                        var o = e1.path;
                        t.absolutePath || s && s.absolutePath || (o = te(o)), void 0 === i && (o = o.replace(/^\/\//, "/%2F")), n.push(o);
                    }
                    return void 0 !== e1.query && (n.push("?"), n.push(e1.query)), void 0 !== e1.fragment && (n.push("#"), n.push(e1.fragment)), n.join("");
                }
                function ne(e1, t) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, n = {};
                    return arguments[3] || (e1 = H(re(e1, r), r), t = H(re(t, r), r)), !(r = r || {}).tolerant && t.scheme ? (n.scheme = t.scheme, n.userinfo = t.userinfo, n.host = t.host, n.port = t.port, n.path = te(t.path || ""), n.query = t.query) : (void 0 !== t.userinfo || void 0 !== t.host || void 0 !== t.port ? (n.userinfo = t.userinfo, n.host = t.host, n.port = t.port, n.path = te(t.path || ""), n.query = t.query) : (t.path ? ("/" === t.path.charAt(0) ? n.path = te(t.path) : (void 0 === e1.userinfo && void 0 === e1.host && void 0 === e1.port || e1.path ? e1.path ? n.path = e1.path.slice(0, e1.path.lastIndexOf("/") + 1) + t.path : n.path = t.path : n.path = "/" + t.path, n.path = te(n.path)), n.query = t.query) : (n.path = e1.path, void 0 !== t.query ? n.query = t.query : n.query = e1.query), n.userinfo = e1.userinfo, n.host = e1.host, n.port = e1.port), n.scheme = e1.scheme), n.fragment = t.fragment, n;
                }
                function se(e1, t, r) {
                    var n = o({
                        scheme: "null"
                    }, r);
                    return re(ne(H(e1, n), H(t, n), n, !0), n);
                }
                function ie(e1, t) {
                    return "string" == typeof e1 ? e1 = re(H(e1, t), t) : "object" === n(e1) && (e1 = H(re(e1, t), t)), e1;
                }
                function oe(e1, t, r) {
                    return "string" == typeof e1 ? e1 = re(H(e1, r), r) : "object" === n(e1) && (e1 = re(e1, r)), "string" == typeof t ? t = re(H(t, r), r) : "object" === n(t) && (t = re(t, r)), e1 === t;
                }
                function ae(e1, t) {
                    return e1 && e1.toString().replace(t && t.iri ? l.ESCAPE : u.ESCAPE, K);
                }
                function ue(e1, t) {
                    return e1 && e1.toString().replace(t && t.iri ? l.PCT_ENCODED : u.PCT_ENCODED, M);
                }
                var le = {
                    scheme: "http",
                    domainHost: !0,
                    parse: function(e1, t) {
                        return e1.host || (e1.error = e1.error || "HTTP URIs must have a host."), e1;
                    },
                    serialize: function(e1, t) {
                        var r = "https" === String(e1.scheme).toLowerCase();
                        return e1.port !== (r ? 443 : 80) && "" !== e1.port || (e1.port = void 0), e1.path || (e1.path = "/"), e1;
                    }
                }, ce = {
                    scheme: "https",
                    domainHost: le.domainHost,
                    parse: le.parse,
                    serialize: le.serialize
                };
                function pe(e1) {
                    return "boolean" == typeof e1.secure ? e1.secure : "wss" === String(e1.scheme).toLowerCase();
                }
                var fe = {
                    scheme: "ws",
                    domainHost: !0,
                    parse: function(e1, t) {
                        var r = e1;
                        return r.secure = pe(r), r.resourceName = (r.path || "/") + (r.query ? "?" + r.query : ""), r.path = void 0, r.query = void 0, r;
                    },
                    serialize: function(e1, t) {
                        if (e1.port !== (pe(e1) ? 443 : 80) && "" !== e1.port || (e1.port = void 0), "boolean" == typeof e1.secure && (e1.scheme = e1.secure ? "wss" : "ws", e1.secure = void 0), e1.resourceName) {
                            var r = e1.resourceName.split("?"), n = c(r, 2), s = n[0], i = n[1];
                            e1.path = s && "/" !== s ? s : void 0, e1.query = i, e1.resourceName = void 0;
                        }
                        return e1.fragment = void 0, e1;
                    }
                }, de = {
                    scheme: "wss",
                    domainHost: fe.domainHost,
                    parse: fe.parse,
                    serialize: fe.serialize
                }, he = {}, me = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]", ge = "[0-9A-Fa-f]", ye = r(r("%[EFef]" + ge + "%" + ge + ge + "%" + ge + ge) + "|" + r("%[89A-Fa-f]" + ge + "%" + ge + ge) + "|" + r("%" + ge + ge)), Ee = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]", xe = t("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", '[\\"\\\\]'), Ce = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]", Se = new RegExp(me, "g"), be = new RegExp(ye, "g"), ve = new RegExp(t("[^]", Ee, "[\\.]", '[\\"]', xe), "g"), Ae = new RegExp(t("[^]", me, Ce), "g"), Te = Ae;
                function Re(e1) {
                    var t = M(e1);
                    return t.match(Se) ? t : e1;
                }
                var De = {
                    scheme: "mailto",
                    parse: function(e1, t) {
                        var r = e1, n = r.to = r.path ? r.path.split(",") : [];
                        if (r.path = void 0, r.query) {
                            for(var s = !1, i = {}, o = r.query.split("&"), a = 0, u = o.length; a < u; ++a){
                                var l = o[a].split("=");
                                switch(l[0]){
                                    case "to":
                                        for(var c = l[1].split(","), p = 0, f = c.length; p < f; ++p)n.push(c[p]);
                                        break;
                                    case "subject":
                                        r.subject = ue(l[1], t);
                                        break;
                                    case "body":
                                        r.body = ue(l[1], t);
                                        break;
                                    default:
                                        s = !0, i[ue(l[0], t)] = ue(l[1], t);
                                }
                            }
                            s && (r.headers = i);
                        }
                        r.query = void 0;
                        for(var d = 0, h = n.length; d < h; ++d){
                            var m = n[d].split("@");
                            if (m[0] = ue(m[0]), t.unicodeSupport) m[1] = ue(m[1], t).toLowerCase();
                            else try {
                                m[1] = j.toASCII(ue(m[1], t).toLowerCase());
                            } catch (e1) {
                                r.error = r.error || "Email address's domain name can not be converted to ASCII via punycode: " + e1;
                            }
                            n[d] = m.join("@");
                        }
                        return r;
                    },
                    serialize: function(e1, t) {
                        var r = e1, n = i(e1.to);
                        if (n) {
                            for(var o = 0, a = n.length; o < a; ++o){
                                var u = String(n[o]), l = u.lastIndexOf("@"), c = u.slice(0, l).replace(be, Re).replace(be, s).replace(ve, K), p = u.slice(l + 1);
                                try {
                                    p = t.iri ? j.toUnicode(p) : j.toASCII(ue(p, t).toLowerCase());
                                } catch (e1) {
                                    r.error = r.error || "Email address's domain name can not be converted to " + (t.iri ? "Unicode" : "ASCII") + " via punycode: " + e1;
                                }
                                n[o] = c + "@" + p;
                            }
                            r.path = n.join(",");
                        }
                        var f = e1.headers = e1.headers || {};
                        e1.subject && (f.subject = e1.subject), e1.body && (f.body = e1.body);
                        var d = [];
                        for(var h in f)f[h] !== he[h] && d.push(h.replace(be, Re).replace(be, s).replace(Ae, K) + "=" + f[h].replace(be, Re).replace(be, s).replace(Te, K));
                        return d.length && (r.query = d.join("&")), r;
                    }
                }, we = /^([^\:]+)\:(.*)/, _e = {
                    scheme: "urn",
                    parse: function(e1, t) {
                        var r = e1.path && e1.path.match(we), n = e1;
                        if (r) {
                            var s = t.scheme || n.scheme || "urn", i = r[1].toLowerCase(), o = r[2], a = s + ":" + (t.nid || i), u = V[a];
                            n.nid = i, n.nss = o, n.path = void 0, u && (n = u.parse(n, t));
                        } else n.error = n.error || "URN can not be parsed.";
                        return n;
                    },
                    serialize: function(e1, t) {
                        var r = t.scheme || e1.scheme || "urn", n = e1.nid, s = r + ":" + (t.nid || n), i = V[s];
                        i && (e1 = i.serialize(e1, t));
                        var o = e1, a = e1.nss;
                        return o.path = (n || t.nid) + ":" + a, o;
                    }
                }, ke = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/, Be = {
                    scheme: "urn:uuid",
                    parse: function(e1, t) {
                        var r = e1;
                        return r.uuid = r.nss, r.nss = void 0, t.tolerant || r.uuid && r.uuid.match(ke) || (r.error = r.error || "UUID is not valid."), r;
                    },
                    serialize: function(e1, t) {
                        var r = e1;
                        return r.nss = (e1.uuid || "").toLowerCase(), r;
                    }
                };
                V[le.scheme] = le, V[ce.scheme] = ce, V[fe.scheme] = fe, V[de.scheme] = de, V[De.scheme] = De, V[_e.scheme] = _e, V[Be.scheme] = Be, e1.SCHEMES = V, e1.pctEncChar = K, e1.pctDecChars = M, e1.parse = H, e1.removeDotSegments = te, e1.serialize = re, e1.resolveComponents = ne, e1.resolve = se, e1.normalize = ie, e1.equal = oe, e1.escapeComponent = ae, e1.unescapeComponent = ue, Object.defineProperty(e1, "__esModule", {
                    value: !0
                });
            }(t);
        }(0, Qr)), Qr;
    }
    function Zr() {
        return Mr || (Mr = 1, Kr = function e1(t, r) {
            if (t === r) return !0;
            if (t && r && "object" == typeof t && "object" == typeof r) {
                if (t.constructor !== r.constructor) return !1;
                var n, s, i;
                if (Array.isArray(t)) {
                    if ((n = t.length) != r.length) return !1;
                    for(s = n; 0 != s--;)if (!e1(t[s], r[s])) return !1;
                    return !0;
                }
                if (t.constructor === RegExp) return t.source === r.source && t.flags === r.flags;
                if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === r.valueOf();
                if (t.toString !== Object.prototype.toString) return t.toString() === r.toString();
                if ((n = (i = Object.keys(t)).length) !== Object.keys(r).length) return !1;
                for(s = n; 0 != s--;)if (!Object.prototype.hasOwnProperty.call(r, i[s])) return !1;
                for(s = n; 0 != s--;){
                    var o = i[s];
                    if (!e1(t[o], r[o])) return !1;
                }
                return !0;
            }
            return t != t && r != r;
        }), Kr;
    }
    function en() {
        if (Wr) return Gr;
        function e1(e1, t, r, n) {
            var s = n ? " !== " : " === ", i = n ? " || " : " && ", o = n ? "!" : "", a = n ? "" : "!";
            switch(e1){
                case "null":
                    return t + s + "null";
                case "array":
                    return o + "Array.isArray(" + t + ")";
                case "object":
                    return "(" + o + t + i + "typeof " + t + s + '"object"' + i + a + "Array.isArray(" + t + "))";
                case "integer":
                    return "(typeof " + t + s + '"number"' + i + a + "(" + t + " % 1)" + i + t + s + t + (r ? i + o + "isFinite(" + t + ")" : "") + ")";
                case "number":
                    return "(typeof " + t + s + '"' + e1 + '"' + (r ? i + o + "isFinite(" + t + ")" : "") + ")";
                default:
                    return "typeof " + t + s + '"' + e1 + '"';
            }
        }
        Wr = 1, Gr = {
            copy: function(e1, t) {
                for(var r in t = t || {}, e1)t[r] = e1[r];
                return t;
            },
            checkDataType: e1,
            checkDataTypes: function(t, n, s) {
                if (1 === t.length) return e1(t[0], n, s, !0);
                var i = "", o = r(t);
                for(var a in o.array && o.object && (i = o.null ? "(" : "(!" + n + " || ", i += "typeof " + n + ' !== "object")', delete o.null, delete o.array, delete o.object), o.number && delete o.integer, o)i += (i ? " && " : "") + e1(a, n, s, !0);
                return i;
            },
            coerceToTypes: function(e1, r) {
                if (Array.isArray(r)) {
                    for(var n = [], s = 0; s < r.length; s++){
                        var i = r[s];
                        (t[i] || "array" === e1 && "array" === i) && (n[n.length] = i);
                    }
                    if (n.length) return n;
                } else {
                    if (t[r]) return [
                        r
                    ];
                    if ("array" === e1 && "array" === r) return [
                        "array"
                    ];
                }
            },
            toHash: r,
            getProperty: i,
            escapeQuotes: o,
            equal: Zr(),
            ucs2length: qr ? $r : (qr = 1, $r = function(e1) {
                for(var t, r = 0, n = e1.length, s = 0; s < n;)r++, (t = e1.charCodeAt(s++)) >= 55296 && t <= 56319 && s < n && 56320 == (64512 & (t = e1.charCodeAt(s))) && s++;
                return r;
            }),
            varOccurences: function(e1, t) {
                t += "[^0-9]";
                var r = e1.match(new RegExp(t, "g"));
                return r ? r.length : 0;
            },
            varReplace: function(e1, t, r) {
                return t += "([^0-9])", r = r.replace(/\$/g, "$$$$"), e1.replace(new RegExp(t, "g"), r + "$1");
            },
            schemaHasRules: function(e1, t) {
                if ("boolean" == typeof e1) return !e1;
                for(var r in e1)if (t[r]) return !0;
            },
            schemaHasRulesExcept: function(e1, t, r) {
                if ("boolean" == typeof e1) return !e1 && "not" != r;
                for(var n in e1)if (n != r && t[n]) return !0;
            },
            schemaUnknownRules: function(e1, t) {
                if ("boolean" == typeof e1) return;
                for(var r in e1)if (!t[r]) return r;
            },
            toQuotedString: a,
            getPathExpr: function(e1, t, r, n) {
                var s = r ? "'/' + " + t + (n ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : n ? "'[' + " + t + " + ']'" : "'[\\'' + " + t + " + '\\']'";
                return c(e1, s);
            },
            getPath: function(e1, t, r) {
                var n = a(r ? "/" + p(t) : i(t));
                return c(e1, n);
            },
            getData: function(e1, t, r) {
                var n, s, o, a;
                if ("" === e1) return "rootData";
                if ("/" == e1[0]) {
                    if (!u.test(e1)) throw new Error("Invalid JSON-pointer: " + e1);
                    s = e1, o = "rootData";
                } else {
                    if (!(a = e1.match(l))) throw new Error("Invalid JSON-pointer: " + e1);
                    if (n = +a[1], "#" == (s = a[2])) {
                        if (n >= t) throw new Error("Cannot access property/index " + n + " levels up, current level is " + t);
                        return r[t - n];
                    }
                    if (n > t) throw new Error("Cannot access data " + n + " levels up, current level is " + t);
                    if (o = "data" + (t - n || ""), !s) return o;
                }
                for(var c = o, p = s.split("/"), d = 0; d < p.length; d++){
                    var h = p[d];
                    h && (c += " && " + (o += i(f(h))));
                }
                return c;
            },
            unescapeFragment: function(e1) {
                return f(decodeURIComponent(e1));
            },
            unescapeJsonPointer: f,
            escapeFragment: function(e1) {
                return encodeURIComponent(p(e1));
            },
            escapeJsonPointer: p
        };
        var t = r([
            "string",
            "number",
            "integer",
            "boolean",
            "null"
        ]);
        function r(e1) {
            for(var t = {}, r = 0; r < e1.length; r++)t[e1[r]] = !0;
            return t;
        }
        var n = /^[a-z$_][a-z$_0-9]*$/i, s = /'|\\/g;
        function i(e1) {
            return "number" == typeof e1 ? "[" + e1 + "]" : n.test(e1) ? "." + e1 : "['" + o(e1) + "']";
        }
        function o(e1) {
            return e1.replace(s, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
        }
        function a(e1) {
            return "'" + o(e1) + "'";
        }
        var u = /^\/(?:[^~]|~0|~1)*$/, l = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
        function c(e1, t) {
            return '""' == e1 ? t : (e1 + " + " + t).replace(/([^\\])' \+ '/g, "$1");
        }
        function p(e1) {
            return e1.replace(/~/g, "~0").replace(/\//g, "~1");
        }
        function f(e1) {
            return e1.replace(/~1/g, "/").replace(/~0/g, "~");
        }
        return Gr;
    }
    function tn() {
        if (zr) return Xr;
        zr = 1;
        var e1 = en();
        return Xr = function(t) {
            e1.copy(t, this);
        };
    }
    var rn, nn, sn, on, an, un, ln, cn, pn, fn, dn, hn = {}, mn = {
        get exports () {
            return hn;
        },
        set exports (e){
            hn = e;
        }
    };
    function gn() {
        if (rn) return hn;
        rn = 1;
        var e1 = mn.exports = function(e1, r, n) {
            "function" == typeof r && (n = r, r = {}), t(r, "function" == typeof (n = r.cb || n) ? n : n.pre || function() {}, n.post || function() {}, e1, "", e1);
        };
        function t(r, n, s, i, o, a, u, l, c, p) {
            if (i && "object" == typeof i && !Array.isArray(i)) {
                for(var f in n(i, o, a, u, l, c, p), i){
                    var d = i[f];
                    if (Array.isArray(d)) {
                        if (f in e1.arrayKeywords) for(var h = 0; h < d.length; h++)t(r, n, s, d[h], o + "/" + f + "/" + h, a, o, f, i, h);
                    } else if (f in e1.propsKeywords) {
                        if (d && "object" == typeof d) for(var m in d)t(r, n, s, d[m], o + "/" + f + "/" + m.replace(/~/g, "~0").replace(/\//g, "~1"), a, o, f, i, m);
                    } else (f in e1.keywords || r.allKeys && !(f in e1.skipKeywords)) && t(r, n, s, d, o + "/" + f, a, o, f, i);
                }
                s(i, o, a, u, l, c, p);
            }
        }
        return e1.keywords = {
            additionalItems: !0,
            items: !0,
            contains: !0,
            additionalProperties: !0,
            propertyNames: !0,
            not: !0
        }, e1.arrayKeywords = {
            items: !0,
            allOf: !0,
            anyOf: !0,
            oneOf: !0
        }, e1.propsKeywords = {
            definitions: !0,
            properties: !0,
            patternProperties: !0,
            dependencies: !0
        }, e1.skipKeywords = {
            default: !0,
            enum: !0,
            const: !0,
            required: !0,
            maximum: !0,
            minimum: !0,
            exclusiveMaximum: !0,
            exclusiveMinimum: !0,
            multipleOf: !0,
            maxLength: !0,
            minLength: !0,
            pattern: !0,
            format: !0,
            maxItems: !0,
            minItems: !0,
            uniqueItems: !0,
            maxProperties: !0,
            minProperties: !0
        }, hn;
    }
    function yn() {
        if (sn) return nn;
        sn = 1;
        var e1 = Yr(), t = Zr(), r = en(), n = tn(), s = gn();
        function i(e1, t, r) {
            var s = this._refs[r];
            if ("string" == typeof s) {
                if (!this._refs[s]) return i.call(this, e1, t, s);
                s = this._refs[s];
            }
            if ((s = s || this._schemas[r]) instanceof n) return p(s.schema, this._opts.inlineRefs) ? s.schema : s.validate || this._compile(s);
            var a, u, l, c = o.call(this, t, r);
            return c && (a = c.schema, t = c.root, l = c.baseId), a instanceof n ? u = a.validate || e1.call(this, a.schema, t, void 0, l) : void 0 !== a && (u = p(a, this._opts.inlineRefs) ? a : e1.call(this, a, t, void 0, l)), u;
        }
        function o(t, r) {
            var s = e1.parse(r), i = m(s), o = h(this._getId(t.schema));
            if (0 === Object.keys(t.schema).length || i !== o) {
                var u = y(i), c = this._refs[u];
                if ("string" == typeof c) return a.call(this, t, c, s);
                if (c instanceof n) c.validate || this._compile(c), t = c;
                else {
                    if (!((c = this._schemas[u]) instanceof n)) return;
                    if (c.validate || this._compile(c), u == y(r)) return {
                        schema: c,
                        root: t,
                        baseId: o
                    };
                    t = c;
                }
                if (!t.schema) return;
                o = h(this._getId(t.schema));
            }
            return l.call(this, s, o, t.schema, t);
        }
        function a(e1, t, r) {
            var n = o.call(this, e1, t);
            if (n) {
                var s = n.schema, i = n.baseId;
                e1 = n.root;
                var a = this._getId(s);
                return a && (i = E(i, a)), l.call(this, r, i, s, e1);
            }
        }
        nn = i, i.normalizeId = y, i.fullPath = h, i.url = E, i.ids = function(n) {
            var i = y(this._getId(n)), o = {
                "": i
            }, a = {
                "": h(i, !1)
            }, u = {}, l = this;
            return s(n, {
                allKeys: !0
            }, function(n, s, i, c, p, f, d) {
                if ("" !== s) {
                    var h = l._getId(n), m = o[c], g = a[c] + "/" + p;
                    if (void 0 !== d && (g += "/" + ("number" == typeof d ? d : r.escapeFragment(d))), "string" == typeof h) {
                        h = m = y(m ? e1.resolve(m, h) : h);
                        var E = l._refs[h];
                        if ("string" == typeof E && (E = l._refs[E]), E && E.schema) {
                            if (!t(n, E.schema)) throw new Error('id "' + h + '" resolves to more than one schema');
                        } else if (h != y(g)) {
                            if ("#" == h[0]) {
                                if (u[h] && !t(n, u[h])) throw new Error('id "' + h + '" resolves to more than one schema');
                                u[h] = n;
                            } else l._refs[h] = g;
                        }
                    }
                    o[s] = m, a[s] = g;
                }
            }), u;
        }, i.inlineRef = p, i.schema = o;
        var u = r.toHash([
            "properties",
            "patternProperties",
            "enum",
            "dependencies",
            "definitions"
        ]);
        function l(e1, t, n, s) {
            if (e1.fragment = e1.fragment || "", "/" == e1.fragment.slice(0, 1)) {
                for(var i = e1.fragment.split("/"), a = 1; a < i.length; a++){
                    var l = i[a];
                    if (l) {
                        if (void 0 === (n = n[l = r.unescapeFragment(l)])) break;
                        var c;
                        if (!u[l] && ((c = this._getId(n)) && (t = E(t, c)), n.$ref)) {
                            var p = E(t, n.$ref), f = o.call(this, s, p);
                            f && (n = f.schema, s = f.root, t = f.baseId);
                        }
                    }
                }
                return void 0 !== n && n !== s.schema ? {
                    schema: n,
                    root: s,
                    baseId: t
                } : void 0;
            }
        }
        var c = r.toHash([
            "type",
            "format",
            "pattern",
            "maxLength",
            "minLength",
            "maxProperties",
            "minProperties",
            "maxItems",
            "minItems",
            "maximum",
            "minimum",
            "uniqueItems",
            "multipleOf",
            "required",
            "enum"
        ]);
        function p(e1, t) {
            return !1 !== t && (void 0 === t || !0 === t ? f(e1) : t ? d(e1) <= t : void 0);
        }
        function f(e1) {
            var t;
            if (Array.isArray(e1)) {
                for(var r = 0; r < e1.length; r++)if ("object" == typeof (t = e1[r]) && !f(t)) return !1;
            } else for(var n in e1){
                if ("$ref" == n) return !1;
                if ("object" == typeof (t = e1[n]) && !f(t)) return !1;
            }
            return !0;
        }
        function d(e1) {
            var t, r = 0;
            if (Array.isArray(e1)) {
                for(var n = 0; n < e1.length; n++)if ("object" == typeof (t = e1[n]) && (r += d(t)), r == 1 / 0) return 1 / 0;
            } else for(var s in e1){
                if ("$ref" == s) return 1 / 0;
                if (c[s]) r++;
                else if ("object" == typeof (t = e1[s]) && (r += d(t) + 1), r == 1 / 0) return 1 / 0;
            }
            return r;
        }
        function h(t, r) {
            return !1 !== r && (t = y(t)), m(e1.parse(t));
        }
        function m(t) {
            return e1.serialize(t).split("#")[0] + "#";
        }
        var g = /#\/?$/;
        function y(e1) {
            return e1 ? e1.replace(g, "") : "";
        }
        function E(t, r) {
            return r = y(r), e1.resolve(t, r);
        }
        return nn;
    }
    function En() {
        if (an) return on;
        an = 1;
        var e1 = yn();
        function t(r, n, s) {
            this.message = s || t.message(r, n), this.missingRef = e1.url(r, n), this.missingSchema = e1.normalizeId(e1.fullPath(this.missingRef));
        }
        function r(e1) {
            return e1.prototype = Object.create(Error.prototype), e1.prototype.constructor = e1, e1;
        }
        return on = {
            Validation: r(function(e1) {
                this.message = "validation failed", this.errors = e1, this.ajv = this.validation = !0;
            }),
            MissingRef: r(t)
        }, t.message = function(e1, t) {
            return "can't resolve reference " + t + " from id " + e1;
        }, on;
    }
    function xn() {
        return ln || (ln = 1, un = function(e1, t) {
            t || (t = {}), "function" == typeof t && (t = {
                cmp: t
            });
            var r = "boolean" == typeof t.cycles && t.cycles, n = t.cmp && function(e1) {
                return function(t) {
                    return function(r, n) {
                        var s = {
                            key: r,
                            value: t[r]
                        }, i = {
                            key: n,
                            value: t[n]
                        };
                        return e1(s, i);
                    };
                };
            }(t.cmp), s = [];
            return function e1(t) {
                if (t && t.toJSON && "function" == typeof t.toJSON && (t = t.toJSON()), void 0 !== t) {
                    if ("number" == typeof t) return isFinite(t) ? "" + t : "null";
                    if ("object" != typeof t) return JSON.stringify(t);
                    var i, o;
                    if (Array.isArray(t)) {
                        for(o = "[", i = 0; i < t.length; i++)i && (o += ","), o += e1(t[i]) || "null";
                        return o + "]";
                    }
                    if (null === t) return "null";
                    if (-1 !== s.indexOf(t)) {
                        if (r) return JSON.stringify("__cycle__");
                        throw new TypeError("Converting circular structure to JSON");
                    }
                    var a = s.push(t) - 1, u = Object.keys(t).sort(n && n(t));
                    for(o = "", i = 0; i < u.length; i++){
                        var l = u[i], c = e1(t[l]);
                        c && (o && (o += ","), o += JSON.stringify(l) + ":" + c);
                    }
                    return s.splice(a, 1), "{" + o + "}";
                }
            }(e1);
        }), un;
    }
    function Cn() {
        return pn || (pn = 1, cn = function(e1, t, r) {
            var n = "", s = !0 === e1.schema.$async, i = e1.util.schemaHasRulesExcept(e1.schema, e1.RULES.all, "$ref"), o = e1.self._getId(e1.schema);
            if (e1.opts.strictKeywords) {
                var a = e1.util.schemaUnknownRules(e1.schema, e1.RULES.keywords);
                if (a) {
                    var u = "unknown keyword: " + a;
                    if ("log" !== e1.opts.strictKeywords) throw new Error(u);
                    e1.logger.warn(u);
                }
            }
            if (e1.isTop && (n += " var validate = ", s && (e1.async = !0, n += "async "), n += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ", o && (e1.opts.sourceCode || e1.opts.processCode) && (n += " /*# sourceURL=" + o + " */ ")), "boolean" == typeof e1.schema || !i && !e1.schema.$ref) {
                t = "false schema";
                var l = e1.level, c = e1.dataLevel, p = e1.schema[t], f = e1.schemaPath + e1.util.getProperty(t), d = e1.errSchemaPath + "/" + t, h = !e1.opts.allErrors, m = "data" + (c || ""), g = "valid" + l;
                if (!1 === e1.schema) {
                    e1.isTop ? h = !0 : n += " var " + g + " = false; ", (J = J || []).push(n), n = "", !1 !== e1.createErrors ? (n += " { keyword: 'false schema' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(d) + " , params: {} ", !1 !== e1.opts.messages && (n += " , message: 'boolean schema is false' "), e1.opts.verbose && (n += " , schema: false , parentSchema: validate.schema" + e1.schemaPath + " , data: " + m + " "), n += " } ") : n += " {} ";
                    var y = n;
                    n = J.pop(), !e1.compositeRule && h ? e1.async ? n += " throw new ValidationError([" + y + "]); " : n += " validate.errors = [" + y + "]; return false; " : n += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                } else e1.isTop ? n += s ? " return data; " : " validate.errors = null; return true; " : n += " var " + g + " = true; ";
                return e1.isTop && (n += " }; return validate; "), n;
            }
            if (e1.isTop) {
                var E = e1.isTop;
                l = e1.level = 0, c = e1.dataLevel = 0, m = "data";
                if (e1.rootId = e1.resolve.fullPath(e1.self._getId(e1.root.schema)), e1.baseId = e1.baseId || e1.rootId, delete e1.isTop, e1.dataPathArr = [
                    ""
                ], void 0 !== e1.schema.default && e1.opts.useDefaults && e1.opts.strictDefaults) {
                    var x = "default is ignored in the schema root";
                    if ("log" !== e1.opts.strictDefaults) throw new Error(x);
                    e1.logger.warn(x);
                }
                n += " var vErrors = null; ", n += " var errors = 0;     ", n += " if (rootData === undefined) rootData = data; ";
            } else {
                l = e1.level, m = "data" + ((c = e1.dataLevel) || "");
                if (o && (e1.baseId = e1.resolve.url(e1.baseId, o)), s && !e1.async) throw new Error("async schema in sync schema");
                n += " var errs_" + l + " = errors;";
            }
            g = "valid" + l, h = !e1.opts.allErrors;
            var C = "", S = "", b = e1.schema.type, v = Array.isArray(b);
            if (b && e1.opts.nullable && !0 === e1.schema.nullable && (v ? -1 == b.indexOf("null") && (b = b.concat("null")) : "null" != b && (b = [
                b,
                "null"
            ], v = !0)), v && 1 == b.length && (b = b[0], v = !1), e1.schema.$ref && i) {
                if ("fail" == e1.opts.extendRefs) throw new Error('$ref: validation keywords used in schema at path "' + e1.errSchemaPath + '" (see option extendRefs)');
                !0 !== e1.opts.extendRefs && (i = !1, e1.logger.warn('$ref: keywords ignored in schema at path "' + e1.errSchemaPath + '"'));
            }
            if (e1.schema.$comment && e1.opts.$comment && (n += " " + e1.RULES.all.$comment.code(e1, "$comment")), b) {
                if (e1.opts.coerceTypes) var A = e1.util.coerceToTypes(e1.opts.coerceTypes, b);
                var T = e1.RULES.types[b];
                if (A || v || !0 === T || T && !Q(T)) {
                    f = e1.schemaPath + ".type", d = e1.errSchemaPath + "/type", f = e1.schemaPath + ".type", d = e1.errSchemaPath + "/type";
                    var R = v ? "checkDataTypes" : "checkDataType";
                    if (n += " if (" + e1.util[R](b, m, e1.opts.strictNumbers, !0) + ") { ", A) {
                        var D = "dataType" + l, w = "coerced" + l;
                        n += " var " + D + " = typeof " + m + "; var " + w + " = undefined; ", "array" == e1.opts.coerceTypes && (n += " if (" + D + " == 'object' && Array.isArray(" + m + ") && " + m + ".length == 1) { " + m + " = " + m + "[0]; " + D + " = typeof " + m + "; if (" + e1.util.checkDataType(e1.schema.type, m, e1.opts.strictNumbers) + ") " + w + " = " + m + "; } "), n += " if (" + w + " !== undefined) ; ";
                        var _ = A;
                        if (_) for(var k, B = -1, L = _.length - 1; B < L;)"string" == (k = _[B += 1]) ? n += " else if (" + D + " == 'number' || " + D + " == 'boolean') " + w + " = '' + " + m + "; else if (" + m + " === null) " + w + " = ''; " : "number" == k || "integer" == k ? (n += " else if (" + D + " == 'boolean' || " + m + " === null || (" + D + " == 'string' && " + m + " && " + m + " == +" + m + " ", "integer" == k && (n += " && !(" + m + " % 1)"), n += ")) " + w + " = +" + m + "; ") : "boolean" == k ? n += " else if (" + m + " === 'false' || " + m + " === 0 || " + m + " === null) " + w + " = false; else if (" + m + " === 'true' || " + m + " === 1) " + w + " = true; " : "null" == k ? n += " else if (" + m + " === '' || " + m + " === 0 || " + m + " === false) " + w + " = null; " : "array" == e1.opts.coerceTypes && "array" == k && (n += " else if (" + D + " == 'string' || " + D + " == 'number' || " + D + " == 'boolean' || " + m + " == null) " + w + " = [" + m + "]; ");
                        n += " else {   ", (J = J || []).push(n), n = "", !1 !== e1.createErrors ? (n += " { keyword: 'type' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(d) + " , params: { type: '", n += v ? "" + b.join(",") : "" + b, n += "' } ", !1 !== e1.opts.messages && (n += " , message: 'should be ", n += v ? "" + b.join(",") : "" + b, n += "' "), e1.opts.verbose && (n += " , schema: validate.schema" + f + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + m + " "), n += " } ") : n += " {} ";
                        y = n;
                        n = J.pop(), !e1.compositeRule && h ? e1.async ? n += " throw new ValidationError([" + y + "]); " : n += " validate.errors = [" + y + "]; return false; " : n += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } if (" + w + " !== undefined) {  ";
                        var P = c ? "data" + (c - 1 || "") : "parentData";
                        n += " " + m + " = " + w + "; ", c || (n += "if (" + P + " !== undefined)"), n += " " + P + "[" + (c ? e1.dataPathArr[c] : "parentDataProperty") + "] = " + w + "; } ";
                    } else {
                        (J = J || []).push(n), n = "", !1 !== e1.createErrors ? (n += " { keyword: 'type' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(d) + " , params: { type: '", n += v ? "" + b.join(",") : "" + b, n += "' } ", !1 !== e1.opts.messages && (n += " , message: 'should be ", n += v ? "" + b.join(",") : "" + b, n += "' "), e1.opts.verbose && (n += " , schema: validate.schema" + f + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + m + " "), n += " } ") : n += " {} ";
                        y = n;
                        n = J.pop(), !e1.compositeRule && h ? e1.async ? n += " throw new ValidationError([" + y + "]); " : n += " validate.errors = [" + y + "]; return false; " : n += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                    }
                    n += " } ";
                }
            }
            if (e1.schema.$ref && !i) n += " " + e1.RULES.all.$ref.code(e1, "$ref") + " ", h && (n += " } if (errors === ", n += E ? "0" : "errs_" + l, n += ") { ", S += "}");
            else {
                var I = e1.RULES;
                if (I) {
                    for(var F = -1, N = I.length - 1; F < N;)if (Q(T = I[F += 1])) {
                        if (T.type && (n += " if (" + e1.util.checkDataType(T.type, m, e1.opts.strictNumbers) + ") { "), e1.opts.useDefaults) {
                            if ("object" == T.type && e1.schema.properties) {
                                p = e1.schema.properties;
                                var O = Object.keys(p);
                                if (O) {
                                    for(var U, j = -1, V = O.length - 1; j < V;)if (void 0 !== ($ = p[U = O[j += 1]]).default) {
                                        var K = m + e1.util.getProperty(U);
                                        if (e1.compositeRule) {
                                            if (e1.opts.strictDefaults) {
                                                x = "default is ignored for: " + K;
                                                if ("log" !== e1.opts.strictDefaults) throw new Error(x);
                                                e1.logger.warn(x);
                                            }
                                        } else n += " if (" + K + " === undefined ", "empty" == e1.opts.useDefaults && (n += " || " + K + " === null || " + K + " === '' "), n += " ) " + K + " = ", "shared" == e1.opts.useDefaults ? n += " " + e1.useDefault($.default) + " " : n += " " + JSON.stringify($.default) + " ", n += "; ";
                                    }
                                }
                            } else if ("array" == T.type && Array.isArray(e1.schema.items)) {
                                var M = e1.schema.items;
                                if (M) {
                                    B = -1;
                                    for(var $, q = M.length - 1; B < q;)if (void 0 !== ($ = M[B += 1]).default) {
                                        K = m + "[" + B + "]";
                                        if (e1.compositeRule) {
                                            if (e1.opts.strictDefaults) {
                                                x = "default is ignored for: " + K;
                                                if ("log" !== e1.opts.strictDefaults) throw new Error(x);
                                                e1.logger.warn(x);
                                            }
                                        } else n += " if (" + K + " === undefined ", "empty" == e1.opts.useDefaults && (n += " || " + K + " === null || " + K + " === '' "), n += " ) " + K + " = ", "shared" == e1.opts.useDefaults ? n += " " + e1.useDefault($.default) + " " : n += " " + JSON.stringify($.default) + " ", n += "; ";
                                    }
                                }
                            }
                        }
                        var G = T.rules;
                        if (G) {
                            for(var W, X = -1, z = G.length - 1; X < z;)if (Y(W = G[X += 1])) {
                                var H = W.code(e1, W.keyword, T.type);
                                H && (n += " " + H + " ", h && (C += "}"));
                            }
                        }
                        if (h && (n += " " + C + " ", C = ""), T.type && (n += " } ", b && b === T.type && !A)) {
                            n += " else { ";
                            var J;
                            f = e1.schemaPath + ".type", d = e1.errSchemaPath + "/type";
                            (J = J || []).push(n), n = "", !1 !== e1.createErrors ? (n += " { keyword: 'type' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(d) + " , params: { type: '", n += v ? "" + b.join(",") : "" + b, n += "' } ", !1 !== e1.opts.messages && (n += " , message: 'should be ", n += v ? "" + b.join(",") : "" + b, n += "' "), e1.opts.verbose && (n += " , schema: validate.schema" + f + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + m + " "), n += " } ") : n += " {} ";
                            y = n;
                            n = J.pop(), !e1.compositeRule && h ? e1.async ? n += " throw new ValidationError([" + y + "]); " : n += " validate.errors = [" + y + "]; return false; " : n += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } ";
                        }
                        h && (n += " if (errors === ", n += E ? "0" : "errs_" + l, n += ") { ", S += "}");
                    }
                }
            }
            function Q(e1) {
                for(var t = e1.rules, r = 0; r < t.length; r++)if (Y(t[r])) return !0;
            }
            function Y(t) {
                return void 0 !== e1.schema[t.keyword] || t.implements && function(t) {
                    for(var r = t.implements, n = 0; n < r.length; n++)if (void 0 !== e1.schema[r[n]]) return !0;
                }(t);
            }
            return h && (n += " " + S + " "), E ? (s ? (n += " if (errors === 0) return data;           ", n += " else throw new ValidationError(vErrors); ") : (n += " validate.errors = vErrors; ", n += " return errors === 0;       "), n += " }; return validate;") : n += " var " + g + " = errors === errs_" + l + ";", n;
        }), cn;
    }
    function Sn() {
        if (dn) return fn;
        dn = 1;
        var e1 = yn(), t = en(), r = En(), n = xn(), s = Cn(), i = t.ucs2length, o = Zr(), a = r.Validation;
        function u(e1, t, r) {
            var n = c.call(this, e1, t, r);
            return n >= 0 ? {
                index: n,
                compiling: !0
            } : (n = this._compilations.length, this._compilations[n] = {
                schema: e1,
                root: t,
                baseId: r
            }, {
                index: n,
                compiling: !1
            });
        }
        function l(e1, t, r) {
            var n = c.call(this, e1, t, r);
            n >= 0 && this._compilations.splice(n, 1);
        }
        function c(e1, t, r) {
            for(var n = 0; n < this._compilations.length; n++){
                var s = this._compilations[n];
                if (s.schema == e1 && s.root == t && s.baseId == r) return n;
            }
            return -1;
        }
        function p(e1) {
            return "var default" + e1 + " = defaults[" + e1 + "];";
        }
        function f(e1, t) {
            return void 0 === t[e1] ? "" : "var refVal" + e1 + " = refVal[" + e1 + "];";
        }
        function d(e1) {
            return "var customRule" + e1 + " = customRules[" + e1 + "];";
        }
        function h(e1, t) {
            if (!e1.length) return "";
            for(var r = "", n = 0; n < e1.length; n++)r += t(n, e1);
            return r;
        }
        return fn = function c(m, g, y, E) {
            var x = this, C = this._opts, S = [
                void 0
            ], b = {}, v = [], A = {}, T = [], R = {}, D = [];
            function w(e1, r) {
                return "var pattern" + e1 + " = " + (C.regExp ? "regExp" : "new RegExp") + "(" + t.toQuotedString(r[e1]) + ");";
            }
            g = g || {
                schema: m,
                refVal: S,
                refs: b
            };
            var _ = u.call(this, m, g, E), k = this._compilations[_.index];
            if (_.compiling) return k.callValidate = function e1() {
                var t = k.validate, r = t.apply(this, arguments);
                return e1.errors = t.errors, r;
            };
            var B = this._formats, L = this.RULES;
            try {
                var P = F(m, g, y, E);
                k.validate = P;
                var I = k.callValidate;
                return I && (I.schema = P.schema, I.errors = null, I.refs = P.refs, I.refVal = P.refVal, I.root = P.root, I.$async = P.$async, C.sourceCode && (I.source = P.source)), P;
            } finally{
                l.call(this, m, g, E);
            }
            function F(n, u, l, m) {
                var y = !u || u && u.schema == n;
                if (u.schema != g.schema) return c.call(x, n, u, l, m);
                var E, A = !0 === n.$async, R = s({
                    isTop: !0,
                    schema: n,
                    isRoot: y,
                    baseId: m,
                    root: u,
                    schemaPath: "",
                    errSchemaPath: "#",
                    errorPath: '""',
                    MissingRefError: r.MissingRef,
                    RULES: L,
                    validate: s,
                    util: t,
                    resolve: e1,
                    resolveRef: N,
                    usePattern: j,
                    useDefault: V,
                    useCustomRule: K,
                    opts: C,
                    formats: B,
                    logger: x.logger,
                    self: x
                });
                R = h(S, f) + h(v, w) + h(T, p) + h(D, d) + R, C.processCode && (R = C.processCode(R, n));
                try {
                    E = new Function("self", "RULES", "formats", "root", "refVal", "defaults", "customRules", "equal", "ucs2length", "ValidationError", "regExp", R)(x, L, B, g, S, T, D, o, i, a, C.regExp), S[0] = E;
                } catch (e1) {
                    throw x.logger.error("Error compiling schema, function code:", R), e1;
                }
                return E.schema = n, E.errors = null, E.refs = b, E.refVal = S, E.root = y ? E : u, A && (E.$async = !0), !0 === C.sourceCode && (E.source = {
                    code: R,
                    patterns: v,
                    defaults: T
                }), E;
            }
            function N(t, r, n) {
                r = e1.url(t, r);
                var s, i, o = b[r];
                if (void 0 !== o) return U(s = S[o], i = "refVal[" + o + "]");
                if (!n && g.refs) {
                    var a = g.refs[r];
                    if (void 0 !== a) return U(s = g.refVal[a], i = O(r, s));
                }
                i = O(r);
                var u = e1.call(x, F, g, r);
                if (void 0 === u) {
                    var l = y && y[r];
                    l && (u = e1.inlineRef(l, C.inlineRefs) ? l : c.call(x, l, g, y, t));
                }
                if (void 0 !== u) return function(e1, t) {
                    var r = b[e1];
                    S[r] = t;
                }(r, u), U(u, i);
                !function(e1) {
                    delete b[e1];
                }(r);
            }
            function O(e1, t) {
                var r = S.length;
                return S[r] = t, b[e1] = r, "refVal" + r;
            }
            function U(e1, t) {
                return "object" == typeof e1 || "boolean" == typeof e1 ? {
                    code: t,
                    schema: e1,
                    inline: !0
                } : {
                    code: t,
                    $async: e1 && !!e1.$async
                };
            }
            function j(e1) {
                var t = A[e1];
                return void 0 === t && (t = A[e1] = v.length, v[t] = e1), "pattern" + t;
            }
            function V(e1) {
                switch(typeof e1){
                    case "boolean":
                    case "number":
                        return "" + e1;
                    case "string":
                        return t.toQuotedString(e1);
                    case "object":
                        if (null === e1) return "null";
                        var r = n(e1), s = R[r];
                        return void 0 === s && (s = R[r] = T.length, T[s] = e1), "default" + s;
                }
            }
            function K(e1, t, r, n) {
                if (!1 !== x._opts.validateSchema) {
                    var s = e1.definition.dependencies;
                    if (s && !s.every(function(e1) {
                        return Object.prototype.hasOwnProperty.call(r, e1);
                    })) throw new Error("parent schema must have all required keywords: " + s.join(","));
                    var i = e1.definition.validateSchema;
                    if (i) {
                        if (!i(t)) {
                            var o = "keyword schema is invalid: " + x.errorsText(i.errors);
                            if ("log" != x._opts.validateSchema) throw new Error(o);
                            x.logger.error(o);
                        }
                    }
                }
                var a, u = e1.definition.compile, l = e1.definition.inline, c = e1.definition.macro;
                if (u) a = u.call(x, t, r, n);
                else if (c) a = c.call(x, t, r, n), !1 !== C.validateSchema && x.validateSchema(a, !0);
                else if (l) a = l.call(x, n, e1.keyword, t, r);
                else if (!(a = e1.definition.validate)) return;
                if (void 0 === a) throw new Error('custom keyword "' + e1.keyword + '"failed to compile');
                var p = D.length;
                return D[p] = a, {
                    code: "customRule" + p,
                    validate: a
                };
            }
        }, fn;
    }
    var bn, vn, An, Tn, Rn, Dn, wn, _n, kn, Bn, Ln, Pn, In, Fn, Nn, On, Un, jn, Vn, Kn, Mn, $n, qn, Gn, Wn, Xn, zn, Hn, Jn, Qn, Yn, Zn, es, ts, rs, ns, ss, is, os, as, us, ls, cs, ps, fs, ds, hs, ms, gs, ys, Es, xs, Cs, Ss, bs, vs, As, Ts, Rs, Ds = {}, ws = {
        get exports () {
            return Ds;
        },
        set exports (e){
            Ds = e;
        }
    };
    function _s() {
        return zn || (zn = 1, Xn = function(e1, t, r) {
            var n, s = " ", i = e1.level, o = e1.dataLevel, a = e1.schema[t], u = e1.schemaPath + e1.util.getProperty(t), l = e1.errSchemaPath + "/" + t, c = !e1.opts.allErrors, p = "data" + (o || ""), f = e1.opts.$data && a && a.$data;
            f ? (s += " var schema" + i + " = " + e1.util.getData(a.$data, o, e1.dataPathArr) + "; ", n = "schema" + i) : n = a;
            var d = "maximum" == t, h = d ? "exclusiveMaximum" : "exclusiveMinimum", m = e1.schema[h], g = e1.opts.$data && m && m.$data, y = d ? "<" : ">", E = d ? ">" : "<", x = void 0;
            if (!f && "number" != typeof a && void 0 !== a) throw new Error(t + " must be number");
            if (!g && void 0 !== m && "number" != typeof m && "boolean" != typeof m) throw new Error(h + " must be number or boolean");
            if (g) {
                var C = e1.util.getData(m.$data, o, e1.dataPathArr), S = "exclusive" + i, b = "exclType" + i, v = "exclIsNumber" + i, A = "' + " + (D = "op" + i) + " + '";
                s += " var schemaExcl" + i + " = " + C + "; ", s += " var " + S + "; var " + b + " = typeof " + (C = "schemaExcl" + i) + "; if (" + b + " != 'boolean' && " + b + " != 'undefined' && " + b + " != 'number') { ";
                var T;
                x = h;
                (T = T || []).push(s), s = "", !1 !== e1.createErrors ? (s += " { keyword: '" + (x || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(l) + " , params: {} ", !1 !== e1.opts.messages && (s += " , message: '" + h + " should be boolean' "), e1.opts.verbose && (s += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + p + " "), s += " } ") : s += " {} ";
                var R = s;
                s = T.pop(), !e1.compositeRule && c ? e1.async ? s += " throw new ValidationError([" + R + "]); " : s += " validate.errors = [" + R + "]; return false; " : s += " var err = " + R + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += " } else if ( ", f && (s += " (" + n + " !== undefined && typeof " + n + " != 'number') || "), s += " " + b + " == 'number' ? ( (" + S + " = " + n + " === undefined || " + C + " " + y + "= " + n + ") ? " + p + " " + E + "= " + C + " : " + p + " " + E + " " + n + " ) : ( (" + S + " = " + C + " === true) ? " + p + " " + E + "= " + n + " : " + p + " " + E + " " + n + " ) || " + p + " !== " + p + ") { var op" + i + " = " + S + " ? '" + y + "' : '" + y + "='; ", void 0 === a && (x = h, l = e1.errSchemaPath + "/" + h, n = C, f = g);
            } else {
                A = y;
                if ((v = "number" == typeof m) && f) {
                    var D = "'" + A + "'";
                    s += " if ( ", f && (s += " (" + n + " !== undefined && typeof " + n + " != 'number') || "), s += " ( " + n + " === undefined || " + m + " " + y + "= " + n + " ? " + p + " " + E + "= " + m + " : " + p + " " + E + " " + n + " ) || " + p + " !== " + p + ") { ";
                } else {
                    v && void 0 === a ? (S = !0, x = h, l = e1.errSchemaPath + "/" + h, n = m, E += "=") : (v && (n = Math[d ? "min" : "max"](m, a)), m === (!v || n) ? (S = !0, x = h, l = e1.errSchemaPath + "/" + h, E += "=") : (S = !1, A += "="));
                    D = "'" + A + "'";
                    s += " if ( ", f && (s += " (" + n + " !== undefined && typeof " + n + " != 'number') || "), s += " " + p + " " + E + " " + n + " || " + p + " !== " + p + ") { ";
                }
            }
            x = x || t, (T = T || []).push(s), s = "", !1 !== e1.createErrors ? (s += " { keyword: '" + (x || "_limit") + "' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(l) + " , params: { comparison: " + D + ", limit: " + n + ", exclusive: " + S + " } ", !1 !== e1.opts.messages && (s += " , message: 'should be " + A + " ", s += f ? "' + " + n : n + "'"), e1.opts.verbose && (s += " , schema:  ", s += f ? "validate.schema" + u : "" + a, s += "         , parentSchema: validate.schema" + e1.schemaPath + " , data: " + p + " "), s += " } ") : s += " {} ";
            R = s;
            return s = T.pop(), !e1.compositeRule && c ? e1.async ? s += " throw new ValidationError([" + R + "]); " : s += " validate.errors = [" + R + "]; return false; " : s += " var err = " + R + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += " } ", c && (s += " else { "), s;
        }), Xn;
    }
    function ks() {
        return Jn || (Jn = 1, Hn = function(e1, t, r) {
            var n, s = " ", i = e1.level, o = e1.dataLevel, a = e1.schema[t], u = e1.schemaPath + e1.util.getProperty(t), l = e1.errSchemaPath + "/" + t, c = !e1.opts.allErrors, p = "data" + (o || ""), f = e1.opts.$data && a && a.$data;
            if (f ? (s += " var schema" + i + " = " + e1.util.getData(a.$data, o, e1.dataPathArr) + "; ", n = "schema" + i) : n = a, !f && "number" != typeof a) throw new Error(t + " must be number");
            s += "if ( ", f && (s += " (" + n + " !== undefined && typeof " + n + " != 'number') || "), s += " " + p + ".length " + ("maxItems" == t ? ">" : "<") + " " + n + ") { ";
            var d = t, h = h || [];
            h.push(s), s = "", !1 !== e1.createErrors ? (s += " { keyword: '" + (d || "_limitItems") + "' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(l) + " , params: { limit: " + n + " } ", !1 !== e1.opts.messages && (s += " , message: 'should NOT have ", s += "maxItems" == t ? "more" : "fewer", s += " than ", s += f ? "' + " + n + " + '" : "" + a, s += " items' "), e1.opts.verbose && (s += " , schema:  ", s += f ? "validate.schema" + u : "" + a, s += "         , parentSchema: validate.schema" + e1.schemaPath + " , data: " + p + " "), s += " } ") : s += " {} ";
            var m = s;
            return s = h.pop(), !e1.compositeRule && c ? e1.async ? s += " throw new ValidationError([" + m + "]); " : s += " validate.errors = [" + m + "]; return false; " : s += " var err = " + m + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += "} ", c && (s += " else { "), s;
        }), Hn;
    }
    function Bs() {
        return Yn || (Yn = 1, Qn = function(e1, t, r) {
            var n, s = " ", i = e1.level, o = e1.dataLevel, a = e1.schema[t], u = e1.schemaPath + e1.util.getProperty(t), l = e1.errSchemaPath + "/" + t, c = !e1.opts.allErrors, p = "data" + (o || ""), f = e1.opts.$data && a && a.$data;
            if (f ? (s += " var schema" + i + " = " + e1.util.getData(a.$data, o, e1.dataPathArr) + "; ", n = "schema" + i) : n = a, !f && "number" != typeof a) throw new Error(t + " must be number");
            var d = "maxLength" == t ? ">" : "<";
            s += "if ( ", f && (s += " (" + n + " !== undefined && typeof " + n + " != 'number') || "), !1 === e1.opts.unicode ? s += " " + p + ".length " : s += " ucs2length(" + p + ") ", s += " " + d + " " + n + ") { ";
            var h = t, m = m || [];
            m.push(s), s = "", !1 !== e1.createErrors ? (s += " { keyword: '" + (h || "_limitLength") + "' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(l) + " , params: { limit: " + n + " } ", !1 !== e1.opts.messages && (s += " , message: 'should NOT be ", s += "maxLength" == t ? "longer" : "shorter", s += " than ", s += f ? "' + " + n + " + '" : "" + a, s += " characters' "), e1.opts.verbose && (s += " , schema:  ", s += f ? "validate.schema" + u : "" + a, s += "         , parentSchema: validate.schema" + e1.schemaPath + " , data: " + p + " "), s += " } ") : s += " {} ";
            var g = s;
            return s = m.pop(), !e1.compositeRule && c ? e1.async ? s += " throw new ValidationError([" + g + "]); " : s += " validate.errors = [" + g + "]; return false; " : s += " var err = " + g + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += "} ", c && (s += " else { "), s;
        }), Qn;
    }
    function Ls() {
        return es || (es = 1, Zn = function(e1, t, r) {
            var n, s = " ", i = e1.level, o = e1.dataLevel, a = e1.schema[t], u = e1.schemaPath + e1.util.getProperty(t), l = e1.errSchemaPath + "/" + t, c = !e1.opts.allErrors, p = "data" + (o || ""), f = e1.opts.$data && a && a.$data;
            if (f ? (s += " var schema" + i + " = " + e1.util.getData(a.$data, o, e1.dataPathArr) + "; ", n = "schema" + i) : n = a, !f && "number" != typeof a) throw new Error(t + " must be number");
            s += "if ( ", f && (s += " (" + n + " !== undefined && typeof " + n + " != 'number') || "), s += " Object.keys(" + p + ").length " + ("maxProperties" == t ? ">" : "<") + " " + n + ") { ";
            var d = t, h = h || [];
            h.push(s), s = "", !1 !== e1.createErrors ? (s += " { keyword: '" + (d || "_limitProperties") + "' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(l) + " , params: { limit: " + n + " } ", !1 !== e1.opts.messages && (s += " , message: 'should NOT have ", s += "maxProperties" == t ? "more" : "fewer", s += " than ", s += f ? "' + " + n + " + '" : "" + a, s += " properties' "), e1.opts.verbose && (s += " , schema:  ", s += f ? "validate.schema" + u : "" + a, s += "         , parentSchema: validate.schema" + e1.schemaPath + " , data: " + p + " "), s += " } ") : s += " {} ";
            var m = s;
            return s = h.pop(), !e1.compositeRule && c ? e1.async ? s += " throw new ValidationError([" + m + "]); " : s += " validate.errors = [" + m + "]; return false; " : s += " var err = " + m + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += "} ", c && (s += " else { "), s;
        }), Zn;
    }
    function Ps() {
        if (Cs) return xs;
        Cs = 1;
        var e1 = (Es || (Es = 1, ys = {
            $ref: (Rn || (Rn = 1, Tn = function(e1, t, r) {
                var n, s, i = " ", o = e1.level, a = e1.dataLevel, u = e1.schema[t], l = e1.errSchemaPath + "/" + t, c = !e1.opts.allErrors, p = "data" + (a || ""), f = "valid" + o;
                if ("#" == u || "#/" == u) e1.isRoot ? (n = e1.async, s = "validate") : (n = !0 === e1.root.schema.$async, s = "root.refVal[0]");
                else {
                    var d = e1.resolveRef(e1.baseId, u, e1.isRoot);
                    if (void 0 === d) {
                        var h = e1.MissingRefError.message(e1.baseId, u);
                        if ("fail" == e1.opts.missingRefs) {
                            e1.logger.error(h), (E = E || []).push(i), i = "", !1 !== e1.createErrors ? (i += " { keyword: '$ref' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(l) + " , params: { ref: '" + e1.util.escapeQuotes(u) + "' } ", !1 !== e1.opts.messages && (i += " , message: 'can\\'t resolve reference " + e1.util.escapeQuotes(u) + "' "), e1.opts.verbose && (i += " , schema: " + e1.util.toQuotedString(u) + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + p + " "), i += " } ") : i += " {} ";
                            var m = i;
                            i = E.pop(), !e1.compositeRule && c ? e1.async ? i += " throw new ValidationError([" + m + "]); " : i += " validate.errors = [" + m + "]; return false; " : i += " var err = " + m + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c && (i += " if (false) { ");
                        } else {
                            if ("ignore" != e1.opts.missingRefs) throw new e1.MissingRefError(e1.baseId, u, h);
                            e1.logger.warn(h), c && (i += " if (true) { ");
                        }
                    } else if (d.inline) {
                        var g = e1.util.copy(e1);
                        g.level++;
                        var y = "valid" + g.level;
                        g.schema = d.schema, g.schemaPath = "", g.errSchemaPath = u, i += " " + e1.validate(g).replace(/validate\.schema/g, d.code) + " ", c && (i += " if (" + y + ") { ");
                    } else n = !0 === d.$async || e1.async && !1 !== d.$async, s = d.code;
                }
                if (s) {
                    var E;
                    (E = E || []).push(i), i = "", e1.opts.passContext ? i += " " + s + ".call(this, " : i += " " + s + "( ", i += " " + p + ", (dataPath || '')", '""' != e1.errorPath && (i += " + " + e1.errorPath);
                    var x = i += " , " + (a ? "data" + (a - 1 || "") : "parentData") + " , " + (a ? e1.dataPathArr[a] : "parentDataProperty") + ", rootData)  ";
                    if (i = E.pop(), n) {
                        if (!e1.async) throw new Error("async schema referenced by sync schema");
                        c && (i += " var " + f + "; "), i += " try { await " + x + "; ", c && (i += " " + f + " = true; "), i += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ", c && (i += " " + f + " = false; "), i += " } ", c && (i += " if (" + f + ") { ");
                    } else i += " if (!" + x + ") { if (vErrors === null) vErrors = " + s + ".errors; else vErrors = vErrors.concat(" + s + ".errors); errors = vErrors.length; } ", c && (i += " else { ");
                }
                return i;
            }), Tn),
            allOf: (wn || (wn = 1, Dn = function(e1, t, r) {
                var n = " ", s = e1.schema[t], i = e1.schemaPath + e1.util.getProperty(t), o = e1.errSchemaPath + "/" + t, a = !e1.opts.allErrors, u = e1.util.copy(e1), l = "";
                u.level++;
                var c = "valid" + u.level, p = u.baseId, f = !0, d = s;
                if (d) for(var h, m = -1, g = d.length - 1; m < g;)h = d[m += 1], (e1.opts.strictKeywords ? "object" == typeof h && Object.keys(h).length > 0 || !1 === h : e1.util.schemaHasRules(h, e1.RULES.all)) && (f = !1, u.schema = h, u.schemaPath = i + "[" + m + "]", u.errSchemaPath = o + "/" + m, n += "  " + e1.validate(u) + " ", u.baseId = p, a && (n += " if (" + c + ") { ", l += "}"));
                return a && (n += f ? " if (true) { " : " " + l.slice(0, -1) + " "), n;
            }), Dn),
            anyOf: (kn || (kn = 1, _n = function(e1, t, r) {
                var n = " ", s = e1.level, i = e1.dataLevel, o = e1.schema[t], a = e1.schemaPath + e1.util.getProperty(t), u = e1.errSchemaPath + "/" + t, l = !e1.opts.allErrors, c = "data" + (i || ""), p = "valid" + s, f = "errs__" + s, d = e1.util.copy(e1), h = "";
                d.level++;
                var m = "valid" + d.level, g = o.every(function(t) {
                    return e1.opts.strictKeywords ? "object" == typeof t && Object.keys(t).length > 0 || !1 === t : e1.util.schemaHasRules(t, e1.RULES.all);
                });
                if (g) {
                    var y = d.baseId;
                    n += " var " + f + " = errors; var " + p + " = false;  ";
                    var E = e1.compositeRule;
                    e1.compositeRule = d.compositeRule = !0;
                    var x = o;
                    if (x) for(var C, S = -1, b = x.length - 1; S < b;)C = x[S += 1], d.schema = C, d.schemaPath = a + "[" + S + "]", d.errSchemaPath = u + "/" + S, n += "  " + e1.validate(d) + " ", d.baseId = y, n += " " + p + " = " + p + " || " + m + "; if (!" + p + ") { ", h += "}";
                    e1.compositeRule = d.compositeRule = E, n += " " + h + " if (!" + p + ") {   var err =   ", !1 !== e1.createErrors ? (n += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: {} ", !1 !== e1.opts.messages && (n += " , message: 'should match some schema in anyOf' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e1.compositeRule && l && (e1.async ? n += " throw new ValidationError(vErrors); " : n += " validate.errors = vErrors; return false; "), n += " } else {  errors = " + f + "; if (vErrors !== null) { if (" + f + ") vErrors.length = " + f + "; else vErrors = null; } ", e1.opts.allErrors && (n += " } ");
                } else l && (n += " if (true) { ");
                return n;
            }), _n),
            $comment: (Ln || (Ln = 1, Bn = function(e1, t, r) {
                var n = " ", s = e1.schema[t], i = e1.errSchemaPath + "/" + t;
                e1.opts.allErrors;
                var o = e1.util.toQuotedString(s);
                return !0 === e1.opts.$comment ? n += " console.log(" + o + ");" : "function" == typeof e1.opts.$comment && (n += " self._opts.$comment(" + o + ", " + e1.util.toQuotedString(i) + ", validate.root.schema);"), n;
            }), Bn),
            const: (In || (In = 1, Pn = function(e1, t, r) {
                var n = " ", s = e1.level, i = e1.dataLevel, o = e1.schema[t], a = e1.schemaPath + e1.util.getProperty(t), u = e1.errSchemaPath + "/" + t, l = !e1.opts.allErrors, c = "data" + (i || ""), p = "valid" + s, f = e1.opts.$data && o && o.$data;
                f && (n += " var schema" + s + " = " + e1.util.getData(o.$data, i, e1.dataPathArr) + "; "), f || (n += " var schema" + s + " = validate.schema" + a + ";"), n += "var " + p + " = equal(" + c + ", schema" + s + "); if (!" + p + ") {   ";
                var d = d || [];
                d.push(n), n = "", !1 !== e1.createErrors ? (n += " { keyword: 'const' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { allowedValue: schema" + s + " } ", !1 !== e1.opts.messages && (n += " , message: 'should be equal to constant' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ";
                var h = n;
                return n = d.pop(), !e1.compositeRule && l ? e1.async ? n += " throw new ValidationError([" + h + "]); " : n += " validate.errors = [" + h + "]; return false; " : n += " var err = " + h + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " }", l && (n += " else { "), n;
            }), Pn),
            contains: (Nn || (Nn = 1, Fn = function(e1, t, r) {
                var n = " ", s = e1.level, i = e1.dataLevel, o = e1.schema[t], a = e1.schemaPath + e1.util.getProperty(t), u = e1.errSchemaPath + "/" + t, l = !e1.opts.allErrors, c = "data" + (i || ""), p = "valid" + s, f = "errs__" + s, d = e1.util.copy(e1);
                d.level++;
                var h = "valid" + d.level, m = "i" + s, g = d.dataLevel = e1.dataLevel + 1, y = "data" + g, E = e1.baseId, x = e1.opts.strictKeywords ? "object" == typeof o && Object.keys(o).length > 0 || !1 === o : e1.util.schemaHasRules(o, e1.RULES.all);
                if (n += "var " + f + " = errors;var " + p + ";", x) {
                    var C = e1.compositeRule;
                    e1.compositeRule = d.compositeRule = !0, d.schema = o, d.schemaPath = a, d.errSchemaPath = u, n += " var " + h + " = false; for (var " + m + " = 0; " + m + " < " + c + ".length; " + m + "++) { ", d.errorPath = e1.util.getPathExpr(e1.errorPath, m, e1.opts.jsonPointers, !0);
                    var S = c + "[" + m + "]";
                    d.dataPathArr[g] = m;
                    var b = e1.validate(d);
                    d.baseId = E, e1.util.varOccurences(b, y) < 2 ? n += " " + e1.util.varReplace(b, y, S) + " " : n += " var " + y + " = " + S + "; " + b + " ", n += " if (" + h + ") break; }  ", e1.compositeRule = d.compositeRule = C, n += "  if (!" + h + ") {";
                } else n += " if (" + c + ".length == 0) {";
                var v = v || [];
                v.push(n), n = "", !1 !== e1.createErrors ? (n += " { keyword: 'contains' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: {} ", !1 !== e1.opts.messages && (n += " , message: 'should contain a valid item' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ";
                var A = n;
                return n = v.pop(), !e1.compositeRule && l ? e1.async ? n += " throw new ValidationError([" + A + "]); " : n += " validate.errors = [" + A + "]; return false; " : n += " var err = " + A + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } else { ", x && (n += "  errors = " + f + "; if (vErrors !== null) { if (" + f + ") vErrors.length = " + f + "; else vErrors = null; } "), e1.opts.allErrors && (n += " } "), n;
            }), Fn),
            dependencies: (Un || (Un = 1, On = function(e1, t, r) {
                var n = " ", s = e1.level, i = e1.dataLevel, o = e1.schema[t], a = e1.schemaPath + e1.util.getProperty(t), u = e1.errSchemaPath + "/" + t, l = !e1.opts.allErrors, c = "data" + (i || ""), p = "errs__" + s, f = e1.util.copy(e1), d = "";
                f.level++;
                var h = "valid" + f.level, m = {}, g = {}, y = e1.opts.ownProperties;
                for(S in o)if ("__proto__" != S) {
                    var E = o[S], x = Array.isArray(E) ? g : m;
                    x[S] = E;
                }
                n += "var " + p + " = errors;";
                var C = e1.errorPath;
                for(var S in n += "var missing" + s + ";", g)if ((x = g[S]).length) {
                    if (n += " if ( " + c + e1.util.getProperty(S) + " !== undefined ", y && (n += " && Object.prototype.hasOwnProperty.call(" + c + ", '" + e1.util.escapeQuotes(S) + "') "), l) {
                        n += " && ( ";
                        var b = x;
                        if (b) for(var v = -1, A = b.length - 1; v < A;)k = b[v += 1], v && (n += " || "), n += " ( ( " + (I = c + (P = e1.util.getProperty(k))) + " === undefined ", y && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e1.util.escapeQuotes(k) + "') "), n += ") && (missing" + s + " = " + e1.util.toQuotedString(e1.opts.jsonPointers ? k : P) + ") ) ";
                        n += ")) {  ";
                        var T = "missing" + s, R = "' + " + T + " + '";
                        e1.opts._errorDataPathProperty && (e1.errorPath = e1.opts.jsonPointers ? e1.util.getPathExpr(C, T, !0) : C + " + " + T);
                        var D = D || [];
                        D.push(n), n = "", !1 !== e1.createErrors ? (n += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { property: '" + e1.util.escapeQuotes(S) + "', missingProperty: '" + R + "', depsCount: " + x.length + ", deps: '" + e1.util.escapeQuotes(1 == x.length ? x[0] : x.join(", ")) + "' } ", !1 !== e1.opts.messages && (n += " , message: 'should have ", 1 == x.length ? n += "property " + e1.util.escapeQuotes(x[0]) : n += "properties " + e1.util.escapeQuotes(x.join(", ")), n += " when property " + e1.util.escapeQuotes(S) + " is present' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ";
                        var w = n;
                        n = D.pop(), !e1.compositeRule && l ? e1.async ? n += " throw new ValidationError([" + w + "]); " : n += " validate.errors = [" + w + "]; return false; " : n += " var err = " + w + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                    } else {
                        n += " ) { ";
                        var _ = x;
                        if (_) for(var k, B = -1, L = _.length - 1; B < L;){
                            k = _[B += 1];
                            var P = e1.util.getProperty(k), I = (R = e1.util.escapeQuotes(k), c + P);
                            e1.opts._errorDataPathProperty && (e1.errorPath = e1.util.getPath(C, k, e1.opts.jsonPointers)), n += " if ( " + I + " === undefined ", y && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e1.util.escapeQuotes(k) + "') "), n += ") {  var err =   ", !1 !== e1.createErrors ? (n += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { property: '" + e1.util.escapeQuotes(S) + "', missingProperty: '" + R + "', depsCount: " + x.length + ", deps: '" + e1.util.escapeQuotes(1 == x.length ? x[0] : x.join(", ")) + "' } ", !1 !== e1.opts.messages && (n += " , message: 'should have ", 1 == x.length ? n += "property " + e1.util.escapeQuotes(x[0]) : n += "properties " + e1.util.escapeQuotes(x.join(", ")), n += " when property " + e1.util.escapeQuotes(S) + " is present' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
                        }
                    }
                    n += " }   ", l && (d += "}", n += " else { ");
                }
                e1.errorPath = C;
                var F = f.baseId;
                for(var S in m)E = m[S], (e1.opts.strictKeywords ? "object" == typeof E && Object.keys(E).length > 0 || !1 === E : e1.util.schemaHasRules(E, e1.RULES.all)) && (n += " " + h + " = true; if ( " + c + e1.util.getProperty(S) + " !== undefined ", y && (n += " && Object.prototype.hasOwnProperty.call(" + c + ", '" + e1.util.escapeQuotes(S) + "') "), n += ") { ", f.schema = E, f.schemaPath = a + e1.util.getProperty(S), f.errSchemaPath = u + "/" + e1.util.escapeFragment(S), n += "  " + e1.validate(f) + " ", f.baseId = F, n += " }  ", l && (n += " if (" + h + ") { ", d += "}"));
                return l && (n += "   " + d + " if (" + p + " == errors) {"), n;
            }), On),
            enum: (Vn || (Vn = 1, jn = function(e1, t, r) {
                var n = " ", s = e1.level, i = e1.dataLevel, o = e1.schema[t], a = e1.schemaPath + e1.util.getProperty(t), u = e1.errSchemaPath + "/" + t, l = !e1.opts.allErrors, c = "data" + (i || ""), p = "valid" + s, f = e1.opts.$data && o && o.$data;
                f && (n += " var schema" + s + " = " + e1.util.getData(o.$data, i, e1.dataPathArr) + "; ");
                var d = "i" + s, h = "schema" + s;
                f || (n += " var " + h + " = validate.schema" + a + ";"), n += "var " + p + ";", f && (n += " if (schema" + s + " === undefined) " + p + " = true; else if (!Array.isArray(schema" + s + ")) " + p + " = false; else {"), n += p + " = false;for (var " + d + "=0; " + d + "<" + h + ".length; " + d + "++) if (equal(" + c + ", " + h + "[" + d + "])) { " + p + " = true; break; }", f && (n += "  }  "), n += " if (!" + p + ") {   ";
                var m = m || [];
                m.push(n), n = "", !1 !== e1.createErrors ? (n += " { keyword: 'enum' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { allowedValues: schema" + s + " } ", !1 !== e1.opts.messages && (n += " , message: 'should be equal to one of the allowed values' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ";
                var g = n;
                return n = m.pop(), !e1.compositeRule && l ? e1.async ? n += " throw new ValidationError([" + g + "]); " : n += " validate.errors = [" + g + "]; return false; " : n += " var err = " + g + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " }", l && (n += " else { "), n;
            }), jn),
            format: (Mn || (Mn = 1, Kn = function(e1, t, r) {
                var n = " ", s = e1.level, i = e1.dataLevel, o = e1.schema[t], a = e1.schemaPath + e1.util.getProperty(t), u = e1.errSchemaPath + "/" + t, l = !e1.opts.allErrors, c = "data" + (i || "");
                if (!1 === e1.opts.format) return l && (n += " if (true) { "), n;
                var p, f = e1.opts.$data && o && o.$data;
                f ? (n += " var schema" + s + " = " + e1.util.getData(o.$data, i, e1.dataPathArr) + "; ", p = "schema" + s) : p = o;
                var d = e1.opts.unknownFormats, h = Array.isArray(d);
                if (f) n += " var " + (m = "format" + s) + " = formats[" + p + "]; var " + (g = "isObject" + s) + " = typeof " + m + " == 'object' && !(" + m + " instanceof RegExp) && " + m + ".validate; var " + (y = "formatType" + s) + " = " + g + " && " + m + ".type || 'string'; if (" + g + ") { ", e1.async && (n += " var async" + s + " = " + m + ".async; "), n += " " + m + " = " + m + ".validate; } if (  ", f && (n += " (" + p + " !== undefined && typeof " + p + " != 'string') || "), n += " (", "ignore" != d && (n += " (" + p + " && !" + m + " ", h && (n += " && self._opts.unknownFormats.indexOf(" + p + ") == -1 "), n += ") || "), n += " (" + m + " && " + y + " == '" + r + "' && !(typeof " + m + " == 'function' ? ", e1.async ? n += " (async" + s + " ? await " + m + "(" + c + ") : " + m + "(" + c + ")) " : n += " " + m + "(" + c + ") ", n += " : " + m + ".test(" + c + "))))) {";
                else {
                    var m;
                    if (!(m = e1.formats[o])) {
                        if ("ignore" == d) return e1.logger.warn('unknown format "' + o + '" ignored in schema at path "' + e1.errSchemaPath + '"'), l && (n += " if (true) { "), n;
                        if (h && d.indexOf(o) >= 0) return l && (n += " if (true) { "), n;
                        throw new Error('unknown format "' + o + '" is used in schema at path "' + e1.errSchemaPath + '"');
                    }
                    var g, y = (g = "object" == typeof m && !(m instanceof RegExp) && m.validate) && m.type || "string";
                    if (g) {
                        var E = !0 === m.async;
                        m = m.validate;
                    }
                    if (y != r) return l && (n += " if (true) { "), n;
                    if (E) {
                        if (!e1.async) throw new Error("async format in sync schema");
                        n += " if (!(await " + (x = "formats" + e1.util.getProperty(o) + ".validate") + "(" + c + "))) { ";
                    } else {
                        n += " if (! ";
                        var x = "formats" + e1.util.getProperty(o);
                        g && (x += ".validate"), n += "function" == typeof m ? " " + x + "(" + c + ") " : " " + x + ".test(" + c + ") ", n += ") { ";
                    }
                }
                var C = C || [];
                C.push(n), n = "", !1 !== e1.createErrors ? (n += " { keyword: 'format' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { format:  ", n += f ? "" + p : "" + e1.util.toQuotedString(o), n += "  } ", !1 !== e1.opts.messages && (n += " , message: 'should match format \"", n += f ? "' + " + p + " + '" : "" + e1.util.escapeQuotes(o), n += "\"' "), e1.opts.verbose && (n += " , schema:  ", n += f ? "validate.schema" + a : "" + e1.util.toQuotedString(o), n += "         , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ";
                var S = n;
                return n = C.pop(), !e1.compositeRule && l ? e1.async ? n += " throw new ValidationError([" + S + "]); " : n += " validate.errors = [" + S + "]; return false; " : n += " var err = " + S + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } ", l && (n += " else { "), n;
            }), Kn),
            if: (qn || (qn = 1, $n = function(e1, t, r) {
                var n = " ", s = e1.level, i = e1.dataLevel, o = e1.schema[t], a = e1.schemaPath + e1.util.getProperty(t), u = e1.errSchemaPath + "/" + t, l = !e1.opts.allErrors, c = "data" + (i || ""), p = "valid" + s, f = "errs__" + s, d = e1.util.copy(e1);
                d.level++;
                var h = "valid" + d.level, m = e1.schema.then, g = e1.schema.else, y = void 0 !== m && (e1.opts.strictKeywords ? "object" == typeof m && Object.keys(m).length > 0 || !1 === m : e1.util.schemaHasRules(m, e1.RULES.all)), E = void 0 !== g && (e1.opts.strictKeywords ? "object" == typeof g && Object.keys(g).length > 0 || !1 === g : e1.util.schemaHasRules(g, e1.RULES.all)), x = d.baseId;
                if (y || E) {
                    var C;
                    d.createErrors = !1, d.schema = o, d.schemaPath = a, d.errSchemaPath = u, n += " var " + f + " = errors; var " + p + " = true;  ";
                    var S = e1.compositeRule;
                    e1.compositeRule = d.compositeRule = !0, n += "  " + e1.validate(d) + " ", d.baseId = x, d.createErrors = !0, n += "  errors = " + f + "; if (vErrors !== null) { if (" + f + ") vErrors.length = " + f + "; else vErrors = null; }  ", e1.compositeRule = d.compositeRule = S, y ? (n += " if (" + h + ") {  ", d.schema = e1.schema.then, d.schemaPath = e1.schemaPath + ".then", d.errSchemaPath = e1.errSchemaPath + "/then", n += "  " + e1.validate(d) + " ", d.baseId = x, n += " " + p + " = " + h + "; ", y && E ? n += " var " + (C = "ifClause" + s) + " = 'then'; " : C = "'then'", n += " } ", E && (n += " else { ")) : n += " if (!" + h + ") { ", E && (d.schema = e1.schema.else, d.schemaPath = e1.schemaPath + ".else", d.errSchemaPath = e1.errSchemaPath + "/else", n += "  " + e1.validate(d) + " ", d.baseId = x, n += " " + p + " = " + h + "; ", y && E ? n += " var " + (C = "ifClause" + s) + " = 'else'; " : C = "'else'", n += " } "), n += " if (!" + p + ") {   var err =   ", !1 !== e1.createErrors ? (n += " { keyword: 'if' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { failingKeyword: " + C + " } ", !1 !== e1.opts.messages && (n += " , message: 'should match \"' + " + C + " + '\" schema' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e1.compositeRule && l && (e1.async ? n += " throw new ValidationError(vErrors); " : n += " validate.errors = vErrors; return false; "), n += " }   ", l && (n += " else { ");
                } else l && (n += " if (true) { ");
                return n;
            }), $n),
            items: (Wn || (Wn = 1, Gn = function(e1, t, r) {
                var n = " ", s = e1.level, i = e1.dataLevel, o = e1.schema[t], a = e1.schemaPath + e1.util.getProperty(t), u = e1.errSchemaPath + "/" + t, l = !e1.opts.allErrors, c = "data" + (i || ""), p = "valid" + s, f = "errs__" + s, d = e1.util.copy(e1), h = "";
                d.level++;
                var m = "valid" + d.level, g = "i" + s, y = d.dataLevel = e1.dataLevel + 1, E = "data" + y, x = e1.baseId;
                if (n += "var " + f + " = errors;var " + p + ";", Array.isArray(o)) {
                    var C = e1.schema.additionalItems;
                    if (!1 === C) {
                        n += " " + p + " = " + c + ".length <= " + o.length + "; ";
                        var S = u;
                        u = e1.errSchemaPath + "/additionalItems", n += "  if (!" + p + ") {   ";
                        var b = b || [];
                        b.push(n), n = "", !1 !== e1.createErrors ? (n += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { limit: " + o.length + " } ", !1 !== e1.opts.messages && (n += " , message: 'should NOT have more than " + o.length + " items' "), e1.opts.verbose && (n += " , schema: false , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ";
                        var v = n;
                        n = b.pop(), !e1.compositeRule && l ? e1.async ? n += " throw new ValidationError([" + v + "]); " : n += " validate.errors = [" + v + "]; return false; " : n += " var err = " + v + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } ", u = S, l && (h += "}", n += " else { ");
                    }
                    var A = o;
                    if (A) {
                        for(var T, R = -1, D = A.length - 1; R < D;)if (T = A[R += 1], e1.opts.strictKeywords ? "object" == typeof T && Object.keys(T).length > 0 || !1 === T : e1.util.schemaHasRules(T, e1.RULES.all)) {
                            n += " " + m + " = true; if (" + c + ".length > " + R + ") { ";
                            var w = c + "[" + R + "]";
                            d.schema = T, d.schemaPath = a + "[" + R + "]", d.errSchemaPath = u + "/" + R, d.errorPath = e1.util.getPathExpr(e1.errorPath, R, e1.opts.jsonPointers, !0), d.dataPathArr[y] = R;
                            var _ = e1.validate(d);
                            d.baseId = x, e1.util.varOccurences(_, E) < 2 ? n += " " + e1.util.varReplace(_, E, w) + " " : n += " var " + E + " = " + w + "; " + _ + " ", n += " }  ", l && (n += " if (" + m + ") { ", h += "}");
                        }
                    }
                    "object" == typeof C && (e1.opts.strictKeywords ? "object" == typeof C && Object.keys(C).length > 0 || !1 === C : e1.util.schemaHasRules(C, e1.RULES.all)) && (d.schema = C, d.schemaPath = e1.schemaPath + ".additionalItems", d.errSchemaPath = e1.errSchemaPath + "/additionalItems", n += " " + m + " = true; if (" + c + ".length > " + o.length + ") {  for (var " + g + " = " + o.length + "; " + g + " < " + c + ".length; " + g + "++) { ", d.errorPath = e1.util.getPathExpr(e1.errorPath, g, e1.opts.jsonPointers, !0), w = c + "[" + g + "]", d.dataPathArr[y] = g, _ = e1.validate(d), d.baseId = x, e1.util.varOccurences(_, E) < 2 ? n += " " + e1.util.varReplace(_, E, w) + " " : n += " var " + E + " = " + w + "; " + _ + " ", l && (n += " if (!" + m + ") break; "), n += " } }  ", l && (n += " if (" + m + ") { ", h += "}"));
                } else (e1.opts.strictKeywords ? "object" == typeof o && Object.keys(o).length > 0 || !1 === o : e1.util.schemaHasRules(o, e1.RULES.all)) && (d.schema = o, d.schemaPath = a, d.errSchemaPath = u, n += "  for (var " + g + " = 0; " + g + " < " + c + ".length; " + g + "++) { ", d.errorPath = e1.util.getPathExpr(e1.errorPath, g, e1.opts.jsonPointers, !0), w = c + "[" + g + "]", d.dataPathArr[y] = g, _ = e1.validate(d), d.baseId = x, e1.util.varOccurences(_, E) < 2 ? n += " " + e1.util.varReplace(_, E, w) + " " : n += " var " + E + " = " + w + "; " + _ + " ", l && (n += " if (!" + m + ") break; "), n += " }");
                return l && (n += " " + h + " if (" + f + " == errors) {"), n;
            }), Gn),
            maximum: _s(),
            minimum: _s(),
            maxItems: ks(),
            minItems: ks(),
            maxLength: Bs(),
            minLength: Bs(),
            maxProperties: Ls(),
            minProperties: Ls(),
            multipleOf: (rs || (rs = 1, ts = function(e1, t, r) {
                var n, s = " ", i = e1.level, o = e1.dataLevel, a = e1.schema[t], u = e1.schemaPath + e1.util.getProperty(t), l = e1.errSchemaPath + "/" + t, c = !e1.opts.allErrors, p = "data" + (o || ""), f = e1.opts.$data && a && a.$data;
                if (f ? (s += " var schema" + i + " = " + e1.util.getData(a.$data, o, e1.dataPathArr) + "; ", n = "schema" + i) : n = a, !f && "number" != typeof a) throw new Error(t + " must be number");
                s += "var division" + i + ";if (", f && (s += " " + n + " !== undefined && ( typeof " + n + " != 'number' || "), s += " (division" + i + " = " + p + " / " + n + ", ", e1.opts.multipleOfPrecision ? s += " Math.abs(Math.round(division" + i + ") - division" + i + ") > 1e-" + e1.opts.multipleOfPrecision + " " : s += " division" + i + " !== parseInt(division" + i + ") ", s += " ) ", f && (s += "  )  "), s += " ) {   ";
                var d = d || [];
                d.push(s), s = "", !1 !== e1.createErrors ? (s += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(l) + " , params: { multipleOf: " + n + " } ", !1 !== e1.opts.messages && (s += " , message: 'should be multiple of ", s += f ? "' + " + n : n + "'"), e1.opts.verbose && (s += " , schema:  ", s += f ? "validate.schema" + u : "" + a, s += "         , parentSchema: validate.schema" + e1.schemaPath + " , data: " + p + " "), s += " } ") : s += " {} ";
                var h = s;
                return s = d.pop(), !e1.compositeRule && c ? e1.async ? s += " throw new ValidationError([" + h + "]); " : s += " validate.errors = [" + h + "]; return false; " : s += " var err = " + h + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += "} ", c && (s += " else { "), s;
            }), ts),
            not: (ss || (ss = 1, ns = function(e1, t, r) {
                var n = " ", s = e1.level, i = e1.dataLevel, o = e1.schema[t], a = e1.schemaPath + e1.util.getProperty(t), u = e1.errSchemaPath + "/" + t, l = !e1.opts.allErrors, c = "data" + (i || ""), p = "errs__" + s, f = e1.util.copy(e1);
                f.level++;
                var d = "valid" + f.level;
                if (e1.opts.strictKeywords ? "object" == typeof o && Object.keys(o).length > 0 || !1 === o : e1.util.schemaHasRules(o, e1.RULES.all)) {
                    f.schema = o, f.schemaPath = a, f.errSchemaPath = u, n += " var " + p + " = errors;  ";
                    var h, m = e1.compositeRule;
                    e1.compositeRule = f.compositeRule = !0, f.createErrors = !1, f.opts.allErrors && (h = f.opts.allErrors, f.opts.allErrors = !1), n += " " + e1.validate(f) + " ", f.createErrors = !0, h && (f.opts.allErrors = h), e1.compositeRule = f.compositeRule = m, n += " if (" + d + ") {   ";
                    var g = g || [];
                    g.push(n), n = "", !1 !== e1.createErrors ? (n += " { keyword: 'not' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: {} ", !1 !== e1.opts.messages && (n += " , message: 'should NOT be valid' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ";
                    var y = n;
                    n = g.pop(), !e1.compositeRule && l ? e1.async ? n += " throw new ValidationError([" + y + "]); " : n += " validate.errors = [" + y + "]; return false; " : n += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } else {  errors = " + p + "; if (vErrors !== null) { if (" + p + ") vErrors.length = " + p + "; else vErrors = null; } ", e1.opts.allErrors && (n += " } ");
                } else n += "  var err =   ", !1 !== e1.createErrors ? (n += " { keyword: 'not' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: {} ", !1 !== e1.opts.messages && (n += " , message: 'should NOT be valid' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", l && (n += " if (false) { ");
                return n;
            }), ns),
            oneOf: (os || (os = 1, is = function(e1, t, r) {
                var n = " ", s = e1.level, i = e1.dataLevel, o = e1.schema[t], a = e1.schemaPath + e1.util.getProperty(t), u = e1.errSchemaPath + "/" + t, l = !e1.opts.allErrors, c = "data" + (i || ""), p = "valid" + s, f = "errs__" + s, d = e1.util.copy(e1), h = "";
                d.level++;
                var m = "valid" + d.level, g = d.baseId, y = "prevValid" + s, E = "passingSchemas" + s;
                n += "var " + f + " = errors , " + y + " = false , " + p + " = false , " + E + " = null; ";
                var x = e1.compositeRule;
                e1.compositeRule = d.compositeRule = !0;
                var C = o;
                if (C) for(var S, b = -1, v = C.length - 1; b < v;)S = C[b += 1], (e1.opts.strictKeywords ? "object" == typeof S && Object.keys(S).length > 0 || !1 === S : e1.util.schemaHasRules(S, e1.RULES.all)) ? (d.schema = S, d.schemaPath = a + "[" + b + "]", d.errSchemaPath = u + "/" + b, n += "  " + e1.validate(d) + " ", d.baseId = g) : n += " var " + m + " = true; ", b && (n += " if (" + m + " && " + y + ") { " + p + " = false; " + E + " = [" + E + ", " + b + "]; } else { ", h += "}"), n += " if (" + m + ") { " + p + " = " + y + " = true; " + E + " = " + b + "; }";
                return e1.compositeRule = d.compositeRule = x, n += h + "if (!" + p + ") {   var err =   ", !1 !== e1.createErrors ? (n += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { passingSchemas: " + E + " } ", !1 !== e1.opts.messages && (n += " , message: 'should match exactly one schema in oneOf' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e1.compositeRule && l && (e1.async ? n += " throw new ValidationError(vErrors); " : n += " validate.errors = vErrors; return false; "), n += "} else {  errors = " + f + "; if (vErrors !== null) { if (" + f + ") vErrors.length = " + f + "; else vErrors = null; }", e1.opts.allErrors && (n += " } "), n;
            }), is),
            pattern: (us || (us = 1, as = function(e1, t, r) {
                var n, s = " ", i = e1.level, o = e1.dataLevel, a = e1.schema[t], u = e1.schemaPath + e1.util.getProperty(t), l = e1.errSchemaPath + "/" + t, c = !e1.opts.allErrors, p = "data" + (o || ""), f = "valid" + i, d = e1.opts.$data && a && a.$data;
                d ? (s += " var schema" + i + " = " + e1.util.getData(a.$data, o, e1.dataPathArr) + "; ", n = "schema" + i) : n = a;
                var h = e1.opts.regExp ? "regExp" : "new RegExp";
                d ? (s += " var " + f + " = true; try { " + f + " = " + h + "(" + n + ").test(" + p + "); } catch(e) { " + f + " = false; } if ( ", d && (s += " (" + n + " !== undefined && typeof " + n + " != 'string') || "), s += " !" + f + ") {") : (s += " if ( ", d && (s += " (" + n + " !== undefined && typeof " + n + " != 'string') || "), s += " !" + e1.usePattern(a) + ".test(" + p + ") ) {");
                var m = m || [];
                m.push(s), s = "", !1 !== e1.createErrors ? (s += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(l) + " , params: { pattern:  ", s += d ? "" + n : "" + e1.util.toQuotedString(a), s += "  } ", !1 !== e1.opts.messages && (s += " , message: 'should match pattern \"", s += d ? "' + " + n + " + '" : "" + e1.util.escapeQuotes(a), s += "\"' "), e1.opts.verbose && (s += " , schema:  ", s += d ? "validate.schema" + u : "" + e1.util.toQuotedString(a), s += "         , parentSchema: validate.schema" + e1.schemaPath + " , data: " + p + " "), s += " } ") : s += " {} ";
                var g = s;
                return s = m.pop(), !e1.compositeRule && c ? e1.async ? s += " throw new ValidationError([" + g + "]); " : s += " validate.errors = [" + g + "]; return false; " : s += " var err = " + g + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += "} ", c && (s += " else { "), s;
            }), as),
            properties: (cs || (cs = 1, ls = function(e1, t, r) {
                var n = " ", s = e1.level, i = e1.dataLevel, o = e1.schema[t], a = e1.schemaPath + e1.util.getProperty(t), u = e1.errSchemaPath + "/" + t, l = !e1.opts.allErrors, c = "data" + (i || ""), p = "errs__" + s, f = e1.util.copy(e1), d = "";
                f.level++;
                var h = "valid" + f.level, m = "key" + s, g = "idx" + s, y = f.dataLevel = e1.dataLevel + 1, E = "data" + y, x = "dataProperties" + s, C = Object.keys(o || {}).filter(P), S = e1.schema.patternProperties || {}, b = Object.keys(S).filter(P), v = e1.schema.additionalProperties, A = C.length || b.length, T = !1 === v, R = "object" == typeof v && Object.keys(v).length, D = e1.opts.removeAdditional, w = T || R || D, _ = e1.opts.ownProperties, k = e1.baseId, B = e1.schema.required;
                if (B && (!e1.opts.$data || !B.$data) && B.length < e1.opts.loopRequired) var L = e1.util.toHash(B);
                function P(e1) {
                    return "__proto__" !== e1;
                }
                if (n += "var " + p + " = errors;var " + h + " = true;", _ && (n += " var " + x + " = undefined;"), w) {
                    if (n += _ ? " " + x + " = " + x + " || Object.keys(" + c + "); for (var " + g + "=0; " + g + "<" + x + ".length; " + g + "++) { var " + m + " = " + x + "[" + g + "]; " : " for (var " + m + " in " + c + ") { ", A) {
                        if (n += " var isAdditional" + s + " = !(false ", C.length) {
                            if (C.length > 8) n += " || validate.schema" + a + ".hasOwnProperty(" + m + ") ";
                            else {
                                var I = C;
                                if (I) for(var F = -1, N = I.length - 1; F < N;)H = I[F += 1], n += " || " + m + " == " + e1.util.toQuotedString(H) + " ";
                            }
                        }
                        if (b.length) {
                            var O = b;
                            if (O) for(var U = -1, j = O.length - 1; U < j;)ie = O[U += 1], n += " || " + e1.usePattern(ie) + ".test(" + m + ") ";
                        }
                        n += " ); if (isAdditional" + s + ") { ";
                    }
                    if ("all" == D) n += " delete " + c + "[" + m + "]; ";
                    else {
                        var V = e1.errorPath, K = "' + " + m + " + '";
                        if (e1.opts._errorDataPathProperty && (e1.errorPath = e1.util.getPathExpr(e1.errorPath, m, e1.opts.jsonPointers)), T) {
                            if (D) n += " delete " + c + "[" + m + "]; ";
                            else {
                                n += " " + h + " = false; ";
                                var M = u;
                                u = e1.errSchemaPath + "/additionalProperties", (re = re || []).push(n), n = "", !1 !== e1.createErrors ? (n += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { additionalProperty: '" + K + "' } ", !1 !== e1.opts.messages && (n += " , message: '", e1.opts._errorDataPathProperty ? n += "is an invalid additional property" : n += "should NOT have additional properties", n += "' "), e1.opts.verbose && (n += " , schema: false , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ";
                                var $ = n;
                                n = re.pop(), !e1.compositeRule && l ? e1.async ? n += " throw new ValidationError([" + $ + "]); " : n += " validate.errors = [" + $ + "]; return false; " : n += " var err = " + $ + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", u = M, l && (n += " break; ");
                            }
                        } else if (R) {
                            if ("failing" == D) {
                                n += " var " + p + " = errors;  ";
                                var q = e1.compositeRule;
                                e1.compositeRule = f.compositeRule = !0, f.schema = v, f.schemaPath = e1.schemaPath + ".additionalProperties", f.errSchemaPath = e1.errSchemaPath + "/additionalProperties", f.errorPath = e1.opts._errorDataPathProperty ? e1.errorPath : e1.util.getPathExpr(e1.errorPath, m, e1.opts.jsonPointers);
                                var G = c + "[" + m + "]";
                                f.dataPathArr[y] = m;
                                var W = e1.validate(f);
                                f.baseId = k, e1.util.varOccurences(W, E) < 2 ? n += " " + e1.util.varReplace(W, E, G) + " " : n += " var " + E + " = " + G + "; " + W + " ", n += " if (!" + h + ") { errors = " + p + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + c + "[" + m + "]; }  ", e1.compositeRule = f.compositeRule = q;
                            } else f.schema = v, f.schemaPath = e1.schemaPath + ".additionalProperties", f.errSchemaPath = e1.errSchemaPath + "/additionalProperties", f.errorPath = e1.opts._errorDataPathProperty ? e1.errorPath : e1.util.getPathExpr(e1.errorPath, m, e1.opts.jsonPointers), G = c + "[" + m + "]", f.dataPathArr[y] = m, W = e1.validate(f), f.baseId = k, e1.util.varOccurences(W, E) < 2 ? n += " " + e1.util.varReplace(W, E, G) + " " : n += " var " + E + " = " + G + "; " + W + " ", l && (n += " if (!" + h + ") break; ");
                        }
                        e1.errorPath = V;
                    }
                    A && (n += " } "), n += " }  ", l && (n += " if (" + h + ") { ", d += "}");
                }
                var X = e1.opts.useDefaults && !e1.compositeRule;
                if (C.length) {
                    var z = C;
                    if (z) for(var H, J = -1, Q = z.length - 1; J < Q;){
                        var Y = o[H = z[J += 1]];
                        if (e1.opts.strictKeywords ? "object" == typeof Y && Object.keys(Y).length > 0 || !1 === Y : e1.util.schemaHasRules(Y, e1.RULES.all)) {
                            var Z = e1.util.getProperty(H), ee = (G = c + Z, X && void 0 !== Y.default);
                            if (f.schema = Y, f.schemaPath = a + Z, f.errSchemaPath = u + "/" + e1.util.escapeFragment(H), f.errorPath = e1.util.getPath(e1.errorPath, H, e1.opts.jsonPointers), f.dataPathArr[y] = e1.util.toQuotedString(H), W = e1.validate(f), f.baseId = k, e1.util.varOccurences(W, E) < 2) {
                                W = e1.util.varReplace(W, E, G);
                                var te = G;
                            } else te = E, n += " var " + E + " = " + G + "; ";
                            if (ee) n += " " + W + " ";
                            else {
                                if (L && L[H]) {
                                    n += " if ( " + te + " === undefined ", _ && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e1.util.escapeQuotes(H) + "') "), n += ") { " + h + " = false; ", V = e1.errorPath, M = u;
                                    var re, ne = e1.util.escapeQuotes(H);
                                    e1.opts._errorDataPathProperty && (e1.errorPath = e1.util.getPath(V, H, e1.opts.jsonPointers)), u = e1.errSchemaPath + "/required", (re = re || []).push(n), n = "", !1 !== e1.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { missingProperty: '" + ne + "' } ", !1 !== e1.opts.messages && (n += " , message: '", e1.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + ne + "\\'", n += "' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", $ = n, n = re.pop(), !e1.compositeRule && l ? e1.async ? n += " throw new ValidationError([" + $ + "]); " : n += " validate.errors = [" + $ + "]; return false; " : n += " var err = " + $ + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", u = M, e1.errorPath = V, n += " } else { ";
                                } else l ? (n += " if ( " + te + " === undefined ", _ && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e1.util.escapeQuotes(H) + "') "), n += ") { " + h + " = true; } else { ") : (n += " if (" + te + " !== undefined ", _ && (n += " &&   Object.prototype.hasOwnProperty.call(" + c + ", '" + e1.util.escapeQuotes(H) + "') "), n += " ) { ");
                                n += " " + W + " } ";
                            }
                        }
                        l && (n += " if (" + h + ") { ", d += "}");
                    }
                }
                if (b.length) {
                    var se = b;
                    if (se) for(var ie, oe = -1, ae = se.length - 1; oe < ae;)Y = S[ie = se[oe += 1]], (e1.opts.strictKeywords ? "object" == typeof Y && Object.keys(Y).length > 0 || !1 === Y : e1.util.schemaHasRules(Y, e1.RULES.all)) && (f.schema = Y, f.schemaPath = e1.schemaPath + ".patternProperties" + e1.util.getProperty(ie), f.errSchemaPath = e1.errSchemaPath + "/patternProperties/" + e1.util.escapeFragment(ie), n += _ ? " " + x + " = " + x + " || Object.keys(" + c + "); for (var " + g + "=0; " + g + "<" + x + ".length; " + g + "++) { var " + m + " = " + x + "[" + g + "]; " : " for (var " + m + " in " + c + ") { ", n += " if (" + e1.usePattern(ie) + ".test(" + m + ")) { ", f.errorPath = e1.util.getPathExpr(e1.errorPath, m, e1.opts.jsonPointers), G = c + "[" + m + "]", f.dataPathArr[y] = m, W = e1.validate(f), f.baseId = k, e1.util.varOccurences(W, E) < 2 ? n += " " + e1.util.varReplace(W, E, G) + " " : n += " var " + E + " = " + G + "; " + W + " ", l && (n += " if (!" + h + ") break; "), n += " } ", l && (n += " else " + h + " = true; "), n += " }  ", l && (n += " if (" + h + ") { ", d += "}"));
                }
                return l && (n += " " + d + " if (" + p + " == errors) {"), n;
            }), ls),
            propertyNames: (fs || (fs = 1, ps = function(e1, t, r) {
                var n = " ", s = e1.level, i = e1.dataLevel, o = e1.schema[t], a = e1.schemaPath + e1.util.getProperty(t), u = e1.errSchemaPath + "/" + t, l = !e1.opts.allErrors, c = "data" + (i || ""), p = "errs__" + s, f = e1.util.copy(e1);
                f.level++;
                var d = "valid" + f.level;
                if (n += "var " + p + " = errors;", e1.opts.strictKeywords ? "object" == typeof o && Object.keys(o).length > 0 || !1 === o : e1.util.schemaHasRules(o, e1.RULES.all)) {
                    f.schema = o, f.schemaPath = a, f.errSchemaPath = u;
                    var h = "key" + s, m = "idx" + s, g = "i" + s, y = "' + " + h + " + '", E = "data" + (f.dataLevel = e1.dataLevel + 1), x = "dataProperties" + s, C = e1.opts.ownProperties, S = e1.baseId;
                    C && (n += " var " + x + " = undefined; "), n += C ? " " + x + " = " + x + " || Object.keys(" + c + "); for (var " + m + "=0; " + m + "<" + x + ".length; " + m + "++) { var " + h + " = " + x + "[" + m + "]; " : " for (var " + h + " in " + c + ") { ", n += " var startErrs" + s + " = errors; ";
                    var b = h, v = e1.compositeRule;
                    e1.compositeRule = f.compositeRule = !0;
                    var A = e1.validate(f);
                    f.baseId = S, e1.util.varOccurences(A, E) < 2 ? n += " " + e1.util.varReplace(A, E, b) + " " : n += " var " + E + " = " + b + "; " + A + " ", e1.compositeRule = f.compositeRule = v, n += " if (!" + d + ") { for (var " + g + "=startErrs" + s + "; " + g + "<errors; " + g + "++) { vErrors[" + g + "].propertyName = " + h + "; }   var err =   ", !1 !== e1.createErrors ? (n += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { propertyName: '" + y + "' } ", !1 !== e1.opts.messages && (n += " , message: 'property name \\'" + y + "\\' is invalid' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e1.compositeRule && l && (e1.async ? n += " throw new ValidationError(vErrors); " : n += " validate.errors = vErrors; return false; "), l && (n += " break; "), n += " } }";
                }
                return l && (n += "  if (" + p + " == errors) {"), n;
            }), ps),
            required: (hs || (hs = 1, ds = function(e1, t, r) {
                var n = " ", s = e1.level, i = e1.dataLevel, o = e1.schema[t], a = e1.schemaPath + e1.util.getProperty(t), u = e1.errSchemaPath + "/" + t, l = !e1.opts.allErrors, c = "data" + (i || ""), p = "valid" + s, f = e1.opts.$data && o && o.$data;
                f && (n += " var schema" + s + " = " + e1.util.getData(o.$data, i, e1.dataPathArr) + "; ");
                var d = "schema" + s;
                if (!f) {
                    if (o.length < e1.opts.loopRequired && e1.schema.properties && Object.keys(e1.schema.properties).length) {
                        var h = [], m = o;
                        if (m) for(var g, y = -1, E = m.length - 1; y < E;){
                            g = m[y += 1];
                            var x = e1.schema.properties[g];
                            x && (e1.opts.strictKeywords ? "object" == typeof x && Object.keys(x).length > 0 || !1 === x : e1.util.schemaHasRules(x, e1.RULES.all)) || (h[h.length] = g);
                        }
                    } else h = o;
                }
                if (f || h.length) {
                    var C = e1.errorPath, S = f || h.length >= e1.opts.loopRequired, b = e1.opts.ownProperties;
                    if (l) {
                        if (n += " var missing" + s + "; ", S) {
                            f || (n += " var " + d + " = validate.schema" + a + "; ");
                            var v = "' + " + (_ = "schema" + s + "[" + (D = "i" + s) + "]") + " + '";
                            e1.opts._errorDataPathProperty && (e1.errorPath = e1.util.getPathExpr(C, _, e1.opts.jsonPointers)), n += " var " + p + " = true; ", f && (n += " if (schema" + s + " === undefined) " + p + " = true; else if (!Array.isArray(schema" + s + ")) " + p + " = false; else {"), n += " for (var " + D + " = 0; " + D + " < " + d + ".length; " + D + "++) { " + p + " = " + c + "[" + d + "[" + D + "]] !== undefined ", b && (n += " &&   Object.prototype.hasOwnProperty.call(" + c + ", " + d + "[" + D + "]) "), n += "; if (!" + p + ") break; } ", f && (n += "  }  "), n += "  if (!" + p + ") {   ", (T = T || []).push(n), n = "", !1 !== e1.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { missingProperty: '" + v + "' } ", !1 !== e1.opts.messages && (n += " , message: '", e1.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + v + "\\'", n += "' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ";
                            var A = n;
                            n = T.pop(), !e1.compositeRule && l ? e1.async ? n += " throw new ValidationError([" + A + "]); " : n += " validate.errors = [" + A + "]; return false; " : n += " var err = " + A + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } else { ";
                        } else {
                            n += " if ( ";
                            var T, R = h;
                            if (R) for(var D = -1, w = R.length - 1; D < w;)B = R[D += 1], D && (n += " || "), n += " ( ( " + (F = c + (I = e1.util.getProperty(B))) + " === undefined ", b && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e1.util.escapeQuotes(B) + "') "), n += ") && (missing" + s + " = " + e1.util.toQuotedString(e1.opts.jsonPointers ? B : I) + ") ) ";
                            n += ") {  ", v = "' + " + (_ = "missing" + s) + " + '", e1.opts._errorDataPathProperty && (e1.errorPath = e1.opts.jsonPointers ? e1.util.getPathExpr(C, _, !0) : C + " + " + _), (T = T || []).push(n), n = "", !1 !== e1.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { missingProperty: '" + v + "' } ", !1 !== e1.opts.messages && (n += " , message: '", e1.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + v + "\\'", n += "' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", A = n, n = T.pop(), !e1.compositeRule && l ? e1.async ? n += " throw new ValidationError([" + A + "]); " : n += " validate.errors = [" + A + "]; return false; " : n += " var err = " + A + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } else { ";
                        }
                    } else if (S) {
                        var _;
                        f || (n += " var " + d + " = validate.schema" + a + "; "), v = "' + " + (_ = "schema" + s + "[" + (D = "i" + s) + "]") + " + '", e1.opts._errorDataPathProperty && (e1.errorPath = e1.util.getPathExpr(C, _, e1.opts.jsonPointers)), f && (n += " if (" + d + " && !Array.isArray(" + d + ")) {  var err =   ", !1 !== e1.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { missingProperty: '" + v + "' } ", !1 !== e1.opts.messages && (n += " , message: '", e1.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + v + "\\'", n += "' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + d + " !== undefined) { "), n += " for (var " + D + " = 0; " + D + " < " + d + ".length; " + D + "++) { if (" + c + "[" + d + "[" + D + "]] === undefined ", b && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", " + d + "[" + D + "]) "), n += ") {  var err =   ", !1 !== e1.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { missingProperty: '" + v + "' } ", !1 !== e1.opts.messages && (n += " , message: '", e1.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + v + "\\'", n += "' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ", f && (n += "  }  ");
                    } else {
                        var k = h;
                        if (k) for(var B, L = -1, P = k.length - 1; L < P;){
                            B = k[L += 1];
                            var I = e1.util.getProperty(B), F = (v = e1.util.escapeQuotes(B), c + I);
                            e1.opts._errorDataPathProperty && (e1.errorPath = e1.util.getPath(C, B, e1.opts.jsonPointers)), n += " if ( " + F + " === undefined ", b && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e1.util.escapeQuotes(B) + "') "), n += ") {  var err =   ", !1 !== e1.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(u) + " , params: { missingProperty: '" + v + "' } ", !1 !== e1.opts.messages && (n += " , message: '", e1.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + v + "\\'", n += "' "), e1.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
                        }
                    }
                    e1.errorPath = C;
                } else l && (n += " if (true) {");
                return n;
            }), ds),
            uniqueItems: (gs || (gs = 1, ms = function(e1, t, r) {
                var n, s = " ", i = e1.level, o = e1.dataLevel, a = e1.schema[t], u = e1.schemaPath + e1.util.getProperty(t), l = e1.errSchemaPath + "/" + t, c = !e1.opts.allErrors, p = "data" + (o || ""), f = "valid" + i, d = e1.opts.$data && a && a.$data;
                if (d ? (s += " var schema" + i + " = " + e1.util.getData(a.$data, o, e1.dataPathArr) + "; ", n = "schema" + i) : n = a, (a || d) && !1 !== e1.opts.uniqueItems) {
                    d && (s += " var " + f + "; if (" + n + " === false || " + n + " === undefined) " + f + " = true; else if (typeof " + n + " != 'boolean') " + f + " = false; else { "), s += " var i = " + p + ".length , " + f + " = true , j; if (i > 1) { ";
                    var h = e1.schema.items && e1.schema.items.type, m = Array.isArray(h);
                    if (!h || "object" == h || "array" == h || m && (h.indexOf("object") >= 0 || h.indexOf("array") >= 0)) s += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + p + "[i], " + p + "[j])) { " + f + " = false; break outer; } } } ";
                    else {
                        s += " var itemIndices = {}, item; for (;i--;) { var item = " + p + "[i]; ";
                        var g = "checkDataType" + (m ? "s" : "");
                        s += " if (" + e1.util[g](h, "item", e1.opts.strictNumbers, !0) + ") continue; ", m && (s += " if (typeof item == 'string') item = '\"' + item; "), s += " if (typeof itemIndices[item] == 'number') { " + f + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ";
                    }
                    s += " } ", d && (s += "  }  "), s += " if (!" + f + ") {   ";
                    var y = y || [];
                    y.push(s), s = "", !1 !== e1.createErrors ? (s += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(l) + " , params: { i: i, j: j } ", !1 !== e1.opts.messages && (s += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' "), e1.opts.verbose && (s += " , schema:  ", s += d ? "validate.schema" + u : "" + a, s += "         , parentSchema: validate.schema" + e1.schemaPath + " , data: " + p + " "), s += " } ") : s += " {} ";
                    var E = s;
                    s = y.pop(), !e1.compositeRule && c ? e1.async ? s += " throw new ValidationError([" + E + "]); " : s += " validate.errors = [" + E + "]; return false; " : s += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += " } ", c && (s += " else { ");
                } else c && (s += " if (true) { ");
                return s;
            }), ms),
            validate: Cn()
        }), ys), t = en().toHash;
        return xs = function() {
            var r = [
                {
                    type: "number",
                    rules: [
                        {
                            maximum: [
                                "exclusiveMaximum"
                            ]
                        },
                        {
                            minimum: [
                                "exclusiveMinimum"
                            ]
                        },
                        "multipleOf",
                        "format"
                    ]
                },
                {
                    type: "string",
                    rules: [
                        "maxLength",
                        "minLength",
                        "pattern",
                        "format"
                    ]
                },
                {
                    type: "array",
                    rules: [
                        "maxItems",
                        "minItems",
                        "items",
                        "contains",
                        "uniqueItems"
                    ]
                },
                {
                    type: "object",
                    rules: [
                        "maxProperties",
                        "minProperties",
                        "required",
                        "dependencies",
                        "propertyNames",
                        {
                            properties: [
                                "additionalProperties",
                                "patternProperties"
                            ]
                        }
                    ]
                },
                {
                    rules: [
                        "$ref",
                        "const",
                        "enum",
                        "not",
                        "anyOf",
                        "oneOf",
                        "allOf",
                        "if"
                    ]
                }
            ], n = [
                "type",
                "$comment"
            ];
            return r.all = t(n), r.types = t([
                "number",
                "integer",
                "string",
                "array",
                "object",
                "boolean",
                "null"
            ]), r.forEach(function(t) {
                t.rules = t.rules.map(function(t) {
                    var s;
                    if ("object" == typeof t) {
                        var i = Object.keys(t)[0];
                        s = t[i], t = i, s.forEach(function(e1) {
                            n.push(e1), r.all[e1] = !0;
                        });
                    }
                    return n.push(t), r.all[t] = {
                        keyword: t,
                        code: e1[t],
                        implements: s
                    };
                }), r.all.$comment = {
                    keyword: "$comment",
                    code: e1.$comment
                }, t.type && (r.types[t.type] = t);
            }), r.keywords = t(n.concat([
                "$schema",
                "$id",
                "id",
                "$data",
                "$async",
                "title",
                "description",
                "default",
                "definitions",
                "examples",
                "readOnly",
                "writeOnly",
                "contentMediaType",
                "contentEncoding",
                "additionalItems",
                "then",
                "else"
            ])), r.custom = {}, r;
        }, xs;
    }
    function Is() {
        if (As) return vs;
        As = 1;
        var e1 = En().MissingRef;
        return vs = function t(r, n, s) {
            var i = this;
            if ("function" != typeof this._opts.loadSchema) throw new Error("options.loadSchema should be a function");
            "function" == typeof n && (s = n, n = void 0);
            var o = a(r).then(function() {
                var e1 = i._addSchema(r, void 0, n);
                return e1.validate || u(e1);
            });
            s && o.then(function(e1) {
                s(null, e1);
            }, s);
            return o;
            function a(e1) {
                var r = e1.$schema;
                return r && !i.getSchema(r) ? t.call(i, {
                    $ref: r
                }, !0) : Promise.resolve();
            }
            function u(t) {
                try {
                    return i._compile(t);
                } catch (r) {
                    if (r instanceof e1) return function(e1) {
                        var r = e1.missingSchema;
                        if (l(r)) throw new Error("Schema " + r + " is loaded but " + e1.missingRef + " cannot be resolved");
                        var s = i._loadingSchemas[r];
                        s || (s = i._loadingSchemas[r] = i._opts.loadSchema(r)).then(o, o);
                        return s.then(function(e1) {
                            if (!l(r)) return a(e1).then(function() {
                                l(r) || i.addSchema(e1, r, void 0, n);
                            });
                        }).then(function() {
                            return u(t);
                        });
                        function o() {
                            delete i._loadingSchemas[r];
                        }
                        function l(e1) {
                            return i._refs[e1] || i._schemas[e1];
                        }
                    }(r);
                    throw r;
                }
            }
        }, vs;
    }
    var Fs, Ns, Os, Us, js = {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "http://json-schema.org/draft-07/schema#",
        title: "Core schema meta-schema",
        definitions: {
            schemaArray: {
                type: "array",
                minItems: 1,
                items: {
                    $ref: "#"
                }
            },
            nonNegativeInteger: {
                type: "integer",
                minimum: 0
            },
            nonNegativeIntegerDefault0: {
                allOf: [
                    {
                        $ref: "#/definitions/nonNegativeInteger"
                    },
                    {
                        default: 0
                    }
                ]
            },
            simpleTypes: {
                enum: [
                    "array",
                    "boolean",
                    "integer",
                    "null",
                    "number",
                    "object",
                    "string"
                ]
            },
            stringArray: {
                type: "array",
                items: {
                    type: "string"
                },
                uniqueItems: !0,
                default: []
            }
        },
        type: [
            "object",
            "boolean"
        ],
        properties: {
            $id: {
                type: "string",
                format: "uri-reference"
            },
            $schema: {
                type: "string",
                format: "uri"
            },
            $ref: {
                type: "string",
                format: "uri-reference"
            },
            $comment: {
                type: "string"
            },
            title: {
                type: "string"
            },
            description: {
                type: "string"
            },
            default: !0,
            readOnly: {
                type: "boolean",
                default: !1
            },
            examples: {
                type: "array",
                items: !0
            },
            multipleOf: {
                type: "number",
                exclusiveMinimum: 0
            },
            maximum: {
                type: "number"
            },
            exclusiveMaximum: {
                type: "number"
            },
            minimum: {
                type: "number"
            },
            exclusiveMinimum: {
                type: "number"
            },
            maxLength: {
                $ref: "#/definitions/nonNegativeInteger"
            },
            minLength: {
                $ref: "#/definitions/nonNegativeIntegerDefault0"
            },
            pattern: {
                type: "string",
                format: "regex"
            },
            additionalItems: {
                $ref: "#"
            },
            items: {
                anyOf: [
                    {
                        $ref: "#"
                    },
                    {
                        $ref: "#/definitions/schemaArray"
                    }
                ],
                default: !0
            },
            maxItems: {
                $ref: "#/definitions/nonNegativeInteger"
            },
            minItems: {
                $ref: "#/definitions/nonNegativeIntegerDefault0"
            },
            uniqueItems: {
                type: "boolean",
                default: !1
            },
            contains: {
                $ref: "#"
            },
            maxProperties: {
                $ref: "#/definitions/nonNegativeInteger"
            },
            minProperties: {
                $ref: "#/definitions/nonNegativeIntegerDefault0"
            },
            required: {
                $ref: "#/definitions/stringArray"
            },
            additionalProperties: {
                $ref: "#"
            },
            definitions: {
                type: "object",
                additionalProperties: {
                    $ref: "#"
                },
                default: {}
            },
            properties: {
                type: "object",
                additionalProperties: {
                    $ref: "#"
                },
                default: {}
            },
            patternProperties: {
                type: "object",
                additionalProperties: {
                    $ref: "#"
                },
                propertyNames: {
                    format: "regex"
                },
                default: {}
            },
            dependencies: {
                type: "object",
                additionalProperties: {
                    anyOf: [
                        {
                            $ref: "#"
                        },
                        {
                            $ref: "#/definitions/stringArray"
                        }
                    ]
                }
            },
            propertyNames: {
                $ref: "#"
            },
            const: !0,
            enum: {
                type: "array",
                items: !0,
                minItems: 1,
                uniqueItems: !0
            },
            type: {
                anyOf: [
                    {
                        $ref: "#/definitions/simpleTypes"
                    },
                    {
                        type: "array",
                        items: {
                            $ref: "#/definitions/simpleTypes"
                        },
                        minItems: 1,
                        uniqueItems: !0
                    }
                ]
            },
            format: {
                type: "string"
            },
            contentMediaType: {
                type: "string"
            },
            contentEncoding: {
                type: "string"
            },
            if: {
                $ref: "#"
            },
            then: {
                $ref: "#"
            },
            else: {
                $ref: "#"
            },
            allOf: {
                $ref: "#/definitions/schemaArray"
            },
            anyOf: {
                $ref: "#/definitions/schemaArray"
            },
            oneOf: {
                $ref: "#/definitions/schemaArray"
            },
            not: {
                $ref: "#"
            }
        },
        default: !0
    };
    function Vs() {
        if (Us) return Os;
        Us = 1;
        var e1 = /^[a-z_$][a-z0-9_$-]*$/i, t = (Rs || (Rs = 1, Ts = function(e1, t, r) {
            var n, s, i = " ", o = e1.level, a = e1.dataLevel, u = e1.schema[t], l = e1.schemaPath + e1.util.getProperty(t), c = e1.errSchemaPath + "/" + t, p = !e1.opts.allErrors, f = "data" + (a || ""), d = "valid" + o, h = "errs__" + o, m = e1.opts.$data && u && u.$data;
            m ? (i += " var schema" + o + " = " + e1.util.getData(u.$data, a, e1.dataPathArr) + "; ", s = "schema" + o) : s = u;
            var g, y, E, x, C, S = this, b = "definition" + o, v = S.definition, A = "";
            if (m && v.$data) {
                C = "keywordValidate" + o;
                var T = v.validateSchema;
                i += " var " + b + " = RULES.custom['" + t + "'].definition; var " + C + " = " + b + ".validate;";
            } else {
                if (!(x = e1.useCustomRule(S, u, e1.schema, e1))) return;
                s = "validate.schema" + l, C = x.code, g = v.compile, y = v.inline, E = v.macro;
            }
            var R = C + ".errors", D = "i" + o, w = "ruleErr" + o, _ = v.async;
            if (_ && !e1.async) throw new Error("async keyword in sync schema");
            if (y || E || (i += R + " = null;"), i += "var " + h + " = errors;var " + d + ";", m && v.$data && (A += "}", i += " if (" + s + " === undefined) { " + d + " = true; } else { ", T && (A += "}", i += " " + d + " = " + b + ".validateSchema(" + s + "); if (" + d + ") { ")), y) v.statements ? i += " " + x.validate + " " : i += " " + d + " = " + x.validate + "; ";
            else if (E) {
                var k = e1.util.copy(e1);
                A = "", k.level++;
                var B = "valid" + k.level;
                k.schema = x.validate, k.schemaPath = "";
                var L = e1.compositeRule;
                e1.compositeRule = k.compositeRule = !0;
                var P = e1.validate(k).replace(/validate\.schema/g, C);
                e1.compositeRule = k.compositeRule = L, i += " " + P;
            } else {
                (O = O || []).push(i), i = "", i += "  " + C + ".call( ", e1.opts.passContext ? i += "this" : i += "self", g || !1 === v.schema ? i += " , " + f + " " : i += " , " + s + " , " + f + " , validate.schema" + e1.schemaPath + " ", i += " , (dataPath || '')", '""' != e1.errorPath && (i += " + " + e1.errorPath);
                var I = a ? "data" + (a - 1 || "") : "parentData", F = a ? e1.dataPathArr[a] : "parentDataProperty", N = i += " , " + I + " , " + F + " , rootData )  ";
                i = O.pop(), !1 === v.errors ? (i += " " + d + " = ", _ && (i += "await "), i += N + "; ") : i += _ ? " var " + (R = "customErrors" + o) + " = null; try { " + d + " = await " + N + "; } catch (e) { " + d + " = false; if (e instanceof ValidationError) " + R + " = e.errors; else throw e; } " : " " + R + " = null; " + d + " = " + N + "; ";
            }
            if (v.modifying && (i += " if (" + I + ") " + f + " = " + I + "[" + F + "];"), i += "" + A, v.valid) p && (i += " if (true) { ");
            else {
                var O;
                i += " if ( ", void 0 === v.valid ? (i += " !", i += E ? "" + B : "" + d) : i += " " + !v.valid + " ", i += ") { ", n = S.keyword, (O = O || []).push(i), i = "", (O = O || []).push(i), i = "", !1 !== e1.createErrors ? (i += " { keyword: '" + (n || "custom") + "' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(c) + " , params: { keyword: '" + S.keyword + "' } ", !1 !== e1.opts.messages && (i += " , message: 'should pass \"" + S.keyword + "\" keyword validation' "), e1.opts.verbose && (i += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + f + " "), i += " } ") : i += " {} ";
                var U = i;
                i = O.pop(), !e1.compositeRule && p ? e1.async ? i += " throw new ValidationError([" + U + "]); " : i += " validate.errors = [" + U + "]; return false; " : i += " var err = " + U + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                var j = i;
                i = O.pop(), y ? v.errors ? "full" != v.errors && (i += "  for (var " + D + "=" + h + "; " + D + "<errors; " + D + "++) { var " + w + " = vErrors[" + D + "]; if (" + w + ".dataPath === undefined) " + w + ".dataPath = (dataPath || '') + " + e1.errorPath + "; if (" + w + ".schemaPath === undefined) { " + w + '.schemaPath = "' + c + '"; } ', e1.opts.verbose && (i += " " + w + ".schema = " + s + "; " + w + ".data = " + f + "; "), i += " } ") : !1 === v.errors ? i += " " + j + " " : (i += " if (" + h + " == errors) { " + j + " } else {  for (var " + D + "=" + h + "; " + D + "<errors; " + D + "++) { var " + w + " = vErrors[" + D + "]; if (" + w + ".dataPath === undefined) " + w + ".dataPath = (dataPath || '') + " + e1.errorPath + "; if (" + w + ".schemaPath === undefined) { " + w + '.schemaPath = "' + c + '"; } ', e1.opts.verbose && (i += " " + w + ".schema = " + s + "; " + w + ".data = " + f + "; "), i += " } } ") : E ? (i += "   var err =   ", !1 !== e1.createErrors ? (i += " { keyword: '" + (n || "custom") + "' , dataPath: (dataPath || '') + " + e1.errorPath + " , schemaPath: " + e1.util.toQuotedString(c) + " , params: { keyword: '" + S.keyword + "' } ", !1 !== e1.opts.messages && (i += " , message: 'should pass \"" + S.keyword + "\" keyword validation' "), e1.opts.verbose && (i += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e1.schemaPath + " , data: " + f + " "), i += " } ") : i += " {} ", i += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e1.compositeRule && p && (e1.async ? i += " throw new ValidationError(vErrors); " : i += " validate.errors = vErrors; return false; ")) : !1 === v.errors ? i += " " + j + " " : (i += " if (Array.isArray(" + R + ")) { if (vErrors === null) vErrors = " + R + "; else vErrors = vErrors.concat(" + R + "); errors = vErrors.length;  for (var " + D + "=" + h + "; " + D + "<errors; " + D + "++) { var " + w + " = vErrors[" + D + "]; if (" + w + ".dataPath === undefined) " + w + ".dataPath = (dataPath || '') + " + e1.errorPath + ";  " + w + '.schemaPath = "' + c + '";  ', e1.opts.verbose && (i += " " + w + ".schema = " + s + "; " + w + ".data = " + f + "; "), i += " } } else { " + j + " } "), i += " } ", p && (i += " else { ");
            }
            return i;
        }), Ts), r = function() {
            if (Ns) return Fs;
            Ns = 1;
            var e1 = js;
            return Fs = {
                $id: "https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js",
                definitions: {
                    simpleTypes: e1.definitions.simpleTypes
                },
                type: "object",
                dependencies: {
                    schema: [
                        "validate"
                    ],
                    $data: [
                        "validate"
                    ],
                    statements: [
                        "inline"
                    ],
                    valid: {
                        not: {
                            required: [
                                "macro"
                            ]
                        }
                    }
                },
                properties: {
                    type: e1.properties.type,
                    schema: {
                        type: "boolean"
                    },
                    statements: {
                        type: "boolean"
                    },
                    dependencies: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    },
                    metaSchema: {
                        type: "object"
                    },
                    modifying: {
                        type: "boolean"
                    },
                    valid: {
                        type: "boolean"
                    },
                    $data: {
                        type: "boolean"
                    },
                    async: {
                        type: "boolean"
                    },
                    errors: {
                        anyOf: [
                            {
                                type: "boolean"
                            },
                            {
                                const: "full"
                            }
                        ]
                    }
                }
            };
        }();
        return Os = {
            add: function(r, n) {
                var s = this.RULES;
                if (s.keywords[r]) throw new Error("Keyword " + r + " is already defined");
                if (!e1.test(r)) throw new Error("Keyword " + r + " is not a valid identifier");
                if (n) {
                    this.validateKeyword(n, !0);
                    var i = n.type;
                    if (Array.isArray(i)) for(var o = 0; o < i.length; o++)u(r, i[o], n);
                    else u(r, i, n);
                    var a = n.metaSchema;
                    a && (n.$data && this._opts.$data && (a = {
                        anyOf: [
                            a,
                            {
                                $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
                            }
                        ]
                    }), n.validateSchema = this.compile(a, !0));
                }
                function u(e1, r, n) {
                    for(var i, o = 0; o < s.length; o++){
                        var a = s[o];
                        if (a.type == r) {
                            i = a;
                            break;
                        }
                    }
                    i || (i = {
                        type: r,
                        rules: []
                    }, s.push(i));
                    var u = {
                        keyword: e1,
                        definition: n,
                        custom: !0,
                        code: t,
                        implements: n.implements
                    };
                    i.rules.push(u), s.custom[e1] = u;
                }
                return s.keywords[r] = s.all[r] = !0, this;
            },
            get: function(e1) {
                var t = this.RULES.custom[e1];
                return t ? t.definition : this.RULES.keywords[e1] || !1;
            },
            remove: function(e1) {
                var t = this.RULES;
                delete t.keywords[e1], delete t.all[e1], delete t.custom[e1];
                for(var r = 0; r < t.length; r++)for(var n = t[r].rules, s = 0; s < n.length; s++)if (n[s].keyword == e1) {
                    n.splice(s, 1);
                    break;
                }
                return this;
            },
            validate: function e1(t, n) {
                e1.errors = null;
                var s = this._validateKeyword = this._validateKeyword || this.compile(r, !0);
                if (s(t)) return !0;
                if (e1.errors = s.errors, n) throw new Error("custom keyword definition is invalid: " + this.errorsText(s.errors));
                return !1;
            }
        }, Os;
    }
    var Ks, Ms, $s = {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#",
        description: "Meta-schema for $data reference (JSON Schema extension proposal)",
        type: "object",
        required: [
            "$data"
        ],
        properties: {
            $data: {
                type: "string",
                anyOf: [
                    {
                        format: "relative-json-pointer"
                    },
                    {
                        format: "json-pointer"
                    }
                ]
            }
        },
        additionalProperties: !1
    };
    function qs() {
        if (Ms) return Ks;
        Ms = 1;
        var e1 = Sn(), t = yn(), r = function() {
            if (bn) return Ds;
            bn = 1;
            var e1 = ws.exports = function() {
                this._cache = {};
            };
            return e1.prototype.put = function(e1, t) {
                this._cache[e1] = t;
            }, e1.prototype.get = function(e1) {
                return this._cache[e1];
            }, e1.prototype.del = function(e1) {
                delete this._cache[e1];
            }, e1.prototype.clear = function() {
                this._cache = {};
            }, Ds;
        }(), n = tn(), s = xn(), i = function() {
            if (An) return vn;
            An = 1;
            var e1 = en(), t = /^(\d\d\d\d)-(\d\d)-(\d\d)$/, r = [
                0,
                31,
                28,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ], n = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i, s = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i, i = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i, o = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i, a = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i, u = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i, l = /^(?:\/(?:[^~/]|~0|~1)*)*$/, c = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i, p = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
            function f(t) {
                return t = "full" == t ? "full" : "fast", e1.copy(f[t]);
            }
            function d(e1) {
                var n = e1.match(t);
                if (!n) return !1;
                var s = +n[1], i = +n[2], o = +n[3];
                return i >= 1 && i <= 12 && o >= 1 && o <= (2 == i && function(e1) {
                    return e1 % 4 == 0 && (e1 % 100 != 0 || e1 % 400 == 0);
                }(s) ? 29 : r[i]);
            }
            function h(e1, t) {
                var r = e1.match(n);
                if (!r) return !1;
                var s = r[1], i = r[2], o = r[3], a = r[5];
                return (s <= 23 && i <= 59 && o <= 59 || 23 == s && 59 == i && 60 == o) && (!t || a);
            }
            vn = f, f.fast = {
                date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
                time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
                "date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
                uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
                "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
                "uri-template": o,
                url: a,
                email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
                hostname: s,
                ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
                ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
                regex: E,
                uuid: u,
                "json-pointer": l,
                "json-pointer-uri-fragment": c,
                "relative-json-pointer": p
            }, f.full = {
                date: d,
                time: h,
                "date-time": function(e1) {
                    var t = e1.split(m);
                    return 2 == t.length && d(t[0]) && h(t[1], !0);
                },
                uri: function(e1) {
                    return g.test(e1) && i.test(e1);
                },
                "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
                "uri-template": o,
                url: a,
                email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
                hostname: s,
                ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
                ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
                regex: E,
                uuid: u,
                "json-pointer": l,
                "json-pointer-uri-fragment": c,
                "relative-json-pointer": p
            };
            var m = /t|\s/i, g = /\/|:/, y = /[^\\]\\Z/;
            function E(e1) {
                if (y.test(e1)) return !1;
                try {
                    return new RegExp(e1), !0;
                } catch (e1) {
                    return !1;
                }
            }
            return vn;
        }(), o = Ps(), a = function() {
            if (bs) return Ss;
            bs = 1;
            var e1 = [
                "multipleOf",
                "maximum",
                "exclusiveMaximum",
                "minimum",
                "exclusiveMinimum",
                "maxLength",
                "minLength",
                "pattern",
                "additionalItems",
                "maxItems",
                "minItems",
                "uniqueItems",
                "maxProperties",
                "minProperties",
                "required",
                "additionalProperties",
                "enum",
                "format",
                "const"
            ];
            return Ss = function(t, r) {
                for(var n = 0; n < r.length; n++){
                    t = JSON.parse(JSON.stringify(t));
                    var s, i = r[n].split("/"), o = t;
                    for(s = 1; s < i.length; s++)o = o[i[s]];
                    for(s = 0; s < e1.length; s++){
                        var a = e1[s], u = o[a];
                        u && (o[a] = {
                            anyOf: [
                                u,
                                {
                                    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
                                }
                            ]
                        });
                    }
                }
                return t;
            }, Ss;
        }(), u = en();
        Ks = h, h.prototype.validate = function(e1, t) {
            var r;
            if ("string" == typeof e1) {
                if (!(r = this.getSchema(e1))) throw new Error('no schema with key or ref "' + e1 + '"');
            } else {
                var n = this._addSchema(e1);
                r = n.validate || this._compile(n);
            }
            var s = r(t);
            !0 !== r.$async && (this.errors = r.errors);
            return s;
        }, h.prototype.compile = function(e1, t) {
            var r = this._addSchema(e1, void 0, t);
            return r.validate || this._compile(r);
        }, h.prototype.addSchema = function(e1, r, n, s) {
            if (Array.isArray(e1)) {
                for(var i = 0; i < e1.length; i++)this.addSchema(e1[i], void 0, n, s);
                return this;
            }
            var o = this._getId(e1);
            if (void 0 !== o && "string" != typeof o) throw new Error("schema id must be string");
            return r = t.normalizeId(r || o), C(this, r), this._schemas[r] = this._addSchema(e1, n, s, !0), this;
        }, h.prototype.addMetaSchema = function(e1, t, r) {
            return this.addSchema(e1, t, r, !0), this;
        }, h.prototype.validateSchema = function(e1, t) {
            var r = e1.$schema;
            if (void 0 !== r && "string" != typeof r) throw new Error("$schema must be a string");
            if (r = r || this._opts.defaultMeta || function(e1) {
                var t = e1._opts.meta;
                return e1._opts.defaultMeta = "object" == typeof t ? e1._getId(t) || t : e1.getSchema(p) ? p : void 0, e1._opts.defaultMeta;
            }(this), !r) return this.logger.warn("meta-schema not available"), this.errors = null, !0;
            var n = this.validate(r, e1);
            if (!n && t) {
                var s = "schema is invalid: " + this.errorsText();
                if ("log" != this._opts.validateSchema) throw new Error(s);
                this.logger.error(s);
            }
            return n;
        }, h.prototype.getSchema = function(r) {
            var s = m(this, r);
            switch(typeof s){
                case "object":
                    return s.validate || this._compile(s);
                case "string":
                    return this.getSchema(s);
                case "undefined":
                    return function(r, s) {
                        var i = t.schema.call(r, {
                            schema: {}
                        }, s);
                        if (i) {
                            var o = i.schema, a = i.root, u = i.baseId, l = e1.call(r, o, a, void 0, u);
                            return r._fragments[s] = new n({
                                ref: s,
                                fragment: !0,
                                schema: o,
                                root: a,
                                baseId: u,
                                validate: l
                            }), l;
                        }
                    }(this, r);
            }
        }, h.prototype.removeSchema = function(e1) {
            if (e1 instanceof RegExp) return g(this, this._schemas, e1), g(this, this._refs, e1), this;
            switch(typeof e1){
                case "undefined":
                    return g(this, this._schemas), g(this, this._refs), this._cache.clear(), this;
                case "string":
                    var r = m(this, e1);
                    return r && this._cache.del(r.cacheKey), delete this._schemas[e1], delete this._refs[e1], this;
                case "object":
                    var n = this._opts.serialize, s = n ? n(e1) : e1;
                    this._cache.del(s);
                    var i = this._getId(e1);
                    i && (i = t.normalizeId(i), delete this._schemas[i], delete this._refs[i]);
            }
            return this;
        }, h.prototype.addFormat = function(e1, t) {
            "string" == typeof t && (t = new RegExp(t));
            return this._formats[e1] = t, this;
        }, h.prototype.errorsText = function(e1, t) {
            if (!(e1 = e1 || this.errors)) return "No errors";
            for(var r = void 0 === (t = t || {}).separator ? ", " : t.separator, n = void 0 === t.dataVar ? "data" : t.dataVar, s = "", i = 0; i < e1.length; i++){
                var o = e1[i];
                o && (s += n + o.dataPath + " " + o.message + r);
            }
            return s.slice(0, -r.length);
        }, h.prototype._addSchema = function(e1, r, s, i) {
            if ("object" != typeof e1 && "boolean" != typeof e1) throw new Error("schema should be object or boolean");
            var o = this._opts.serialize, a = o ? o(e1) : e1, u = this._cache.get(a);
            if (u) return u;
            i = i || !1 !== this._opts.addUsedSchema;
            var l = t.normalizeId(this._getId(e1));
            l && i && C(this, l);
            var c, p = !1 !== this._opts.validateSchema && !r;
            p && !(c = l && l == t.normalizeId(e1.$schema)) && this.validateSchema(e1, !0);
            var f = t.ids.call(this, e1), d = new n({
                id: l,
                schema: e1,
                localRefs: f,
                cacheKey: a,
                meta: s
            });
            "#" != l[0] && i && (this._refs[l] = d);
            this._cache.put(a, d), p && c && this.validateSchema(e1, !0);
            return d;
        }, h.prototype._compile = function(t, r) {
            if (t.compiling) return t.validate = i, i.schema = t.schema, i.errors = null, i.root = r || i, !0 === t.schema.$async && (i.$async = !0), i;
            var n, s;
            t.compiling = !0, t.meta && (n = this._opts, this._opts = this._metaOpts);
            try {
                s = e1.call(this, t.schema, r, t.localRefs);
            } catch (e1) {
                throw delete t.validate, e1;
            } finally{
                t.compiling = !1, t.meta && (this._opts = n);
            }
            return t.validate = s, t.refs = s.refs, t.refVal = s.refVal, t.root = s.root, s;
            function i() {
                var e1 = t.validate, r = e1.apply(this, arguments);
                return i.errors = e1.errors, r;
            }
        }, h.prototype.compileAsync = Is();
        var l = Vs();
        h.prototype.addKeyword = l.add, h.prototype.getKeyword = l.get, h.prototype.removeKeyword = l.remove, h.prototype.validateKeyword = l.validate;
        var c = En();
        h.ValidationError = c.Validation, h.MissingRefError = c.MissingRef, h.$dataMetaSchema = a;
        var p = "http://json-schema.org/draft-07/schema", f = [
            "removeAdditional",
            "useDefaults",
            "coerceTypes",
            "strictDefaults"
        ], d = [
            "/properties"
        ];
        function h(e1) {
            if (!(this instanceof h)) return new h(e1);
            e1 = this._opts = u.copy(e1) || {}, function(e1) {
                var t = e1._opts.logger;
                if (!1 === t) e1.logger = {
                    log: S,
                    warn: S,
                    error: S
                };
                else {
                    if (void 0 === t && (t = console), !("object" == typeof t && t.log && t.warn && t.error)) throw new Error("logger must implement log, warn and error methods");
                    e1.logger = t;
                }
            }(this), this._schemas = {}, this._refs = {}, this._fragments = {}, this._formats = i(e1.format), this._cache = e1.cache || new r, this._loadingSchemas = {}, this._compilations = [], this.RULES = o(), this._getId = function(e1) {
                switch(e1.schemaId){
                    case "auto":
                        return x;
                    case "id":
                        return y;
                    default:
                        return E;
                }
            }(e1), e1.loopRequired = e1.loopRequired || 1 / 0, "property" == e1.errorDataPath && (e1._errorDataPathProperty = !0), void 0 === e1.serialize && (e1.serialize = s), this._metaOpts = function(e1) {
                for(var t = u.copy(e1._opts), r = 0; r < f.length; r++)delete t[f[r]];
                return t;
            }(this), e1.formats && function(e1) {
                for(var t in e1._opts.formats){
                    var r = e1._opts.formats[t];
                    e1.addFormat(t, r);
                }
            }(this), e1.keywords && function(e1) {
                for(var t in e1._opts.keywords){
                    var r = e1._opts.keywords[t];
                    e1.addKeyword(t, r);
                }
            }(this), function(e1) {
                var t;
                e1._opts.$data && (t = $s, e1.addMetaSchema(t, t.$id, !0));
                if (!1 === e1._opts.meta) return;
                var r = js;
                e1._opts.$data && (r = a(r, d));
                e1.addMetaSchema(r, p, !0), e1._refs["http://json-schema.org/schema"] = p;
            }(this), "object" == typeof e1.meta && this.addMetaSchema(e1.meta), e1.nullable && this.addKeyword("nullable", {
                metaSchema: {
                    type: "boolean"
                }
            }), function(e1) {
                var t = e1._opts.schemas;
                if (!t) return;
                if (Array.isArray(t)) e1.addSchema(t);
                else for(var r in t)e1.addSchema(t[r], r);
            }(this);
        }
        function m(e1, r) {
            return r = t.normalizeId(r), e1._schemas[r] || e1._refs[r] || e1._fragments[r];
        }
        function g(e1, t, r) {
            for(var n in t){
                var s = t[n];
                s.meta || r && !r.test(n) || (e1._cache.del(s.cacheKey), delete t[n]);
            }
        }
        function y(e1) {
            return e1.$id && this.logger.warn("schema $id ignored", e1.$id), e1.id;
        }
        function E(e1) {
            return e1.id && this.logger.warn("schema id ignored", e1.id), e1.$id;
        }
        function x(e1) {
            if (e1.$id && e1.id && e1.$id != e1.id) throw new Error("schema $id is different from id");
            return e1.$id || e1.id;
        }
        function C(e1, t) {
            if (e1._schemas[t] || e1._refs[t]) throw new Error('schema with key or id "' + t + '" already exists');
        }
        function S() {}
        return Ks;
    }
    var Gs, Ws, Xs = {}, zs = {
        get exports () {
            return Xs;
        },
        set exports (e){
            Xs = e;
        }
    }, Hs = {
        builtin: {
            AggregateError: !1,
            Array: !1,
            ArrayBuffer: !1,
            Atomics: !1,
            BigInt: !1,
            BigInt64Array: !1,
            BigUint64Array: !1,
            Boolean: !1,
            constructor: !1,
            DataView: !1,
            Date: !1,
            decodeURI: !1,
            decodeURIComponent: !1,
            encodeURI: !1,
            encodeURIComponent: !1,
            Error: !1,
            escape: !1,
            eval: !1,
            EvalError: !1,
            FinalizationRegistry: !1,
            Float32Array: !1,
            Float64Array: !1,
            Function: !1,
            globalThis: !1,
            hasOwnProperty: !1,
            Infinity: !1,
            Int16Array: !1,
            Int32Array: !1,
            Int8Array: !1,
            isFinite: !1,
            isNaN: !1,
            isPrototypeOf: !1,
            JSON: !1,
            Map: !1,
            Math: !1,
            NaN: !1,
            Number: !1,
            Object: !1,
            parseFloat: !1,
            parseInt: !1,
            Promise: !1,
            propertyIsEnumerable: !1,
            Proxy: !1,
            RangeError: !1,
            ReferenceError: !1,
            Reflect: !1,
            RegExp: !1,
            Set: !1,
            SharedArrayBuffer: !1,
            String: !1,
            Symbol: !1,
            SyntaxError: !1,
            toLocaleString: !1,
            toString: !1,
            TypeError: !1,
            Uint16Array: !1,
            Uint32Array: !1,
            Uint8Array: !1,
            Uint8ClampedArray: !1,
            undefined: !1,
            unescape: !1,
            URIError: !1,
            valueOf: !1,
            WeakMap: !1,
            WeakRef: !1,
            WeakSet: !1
        },
        es5: {
            Array: !1,
            Boolean: !1,
            constructor: !1,
            Date: !1,
            decodeURI: !1,
            decodeURIComponent: !1,
            encodeURI: !1,
            encodeURIComponent: !1,
            Error: !1,
            escape: !1,
            eval: !1,
            EvalError: !1,
            Function: !1,
            hasOwnProperty: !1,
            Infinity: !1,
            isFinite: !1,
            isNaN: !1,
            isPrototypeOf: !1,
            JSON: !1,
            Math: !1,
            NaN: !1,
            Number: !1,
            Object: !1,
            parseFloat: !1,
            parseInt: !1,
            propertyIsEnumerable: !1,
            RangeError: !1,
            ReferenceError: !1,
            RegExp: !1,
            String: !1,
            SyntaxError: !1,
            toLocaleString: !1,
            toString: !1,
            TypeError: !1,
            undefined: !1,
            unescape: !1,
            URIError: !1,
            valueOf: !1
        },
        es2015: {
            Array: !1,
            ArrayBuffer: !1,
            Boolean: !1,
            constructor: !1,
            DataView: !1,
            Date: !1,
            decodeURI: !1,
            decodeURIComponent: !1,
            encodeURI: !1,
            encodeURIComponent: !1,
            Error: !1,
            escape: !1,
            eval: !1,
            EvalError: !1,
            Float32Array: !1,
            Float64Array: !1,
            Function: !1,
            hasOwnProperty: !1,
            Infinity: !1,
            Int16Array: !1,
            Int32Array: !1,
            Int8Array: !1,
            isFinite: !1,
            isNaN: !1,
            isPrototypeOf: !1,
            JSON: !1,
            Map: !1,
            Math: !1,
            NaN: !1,
            Number: !1,
            Object: !1,
            parseFloat: !1,
            parseInt: !1,
            Promise: !1,
            propertyIsEnumerable: !1,
            Proxy: !1,
            RangeError: !1,
            ReferenceError: !1,
            Reflect: !1,
            RegExp: !1,
            Set: !1,
            String: !1,
            Symbol: !1,
            SyntaxError: !1,
            toLocaleString: !1,
            toString: !1,
            TypeError: !1,
            Uint16Array: !1,
            Uint32Array: !1,
            Uint8Array: !1,
            Uint8ClampedArray: !1,
            undefined: !1,
            unescape: !1,
            URIError: !1,
            valueOf: !1,
            WeakMap: !1,
            WeakSet: !1
        },
        es2017: {
            Array: !1,
            ArrayBuffer: !1,
            Atomics: !1,
            Boolean: !1,
            constructor: !1,
            DataView: !1,
            Date: !1,
            decodeURI: !1,
            decodeURIComponent: !1,
            encodeURI: !1,
            encodeURIComponent: !1,
            Error: !1,
            escape: !1,
            eval: !1,
            EvalError: !1,
            Float32Array: !1,
            Float64Array: !1,
            Function: !1,
            hasOwnProperty: !1,
            Infinity: !1,
            Int16Array: !1,
            Int32Array: !1,
            Int8Array: !1,
            isFinite: !1,
            isNaN: !1,
            isPrototypeOf: !1,
            JSON: !1,
            Map: !1,
            Math: !1,
            NaN: !1,
            Number: !1,
            Object: !1,
            parseFloat: !1,
            parseInt: !1,
            Promise: !1,
            propertyIsEnumerable: !1,
            Proxy: !1,
            RangeError: !1,
            ReferenceError: !1,
            Reflect: !1,
            RegExp: !1,
            Set: !1,
            SharedArrayBuffer: !1,
            String: !1,
            Symbol: !1,
            SyntaxError: !1,
            toLocaleString: !1,
            toString: !1,
            TypeError: !1,
            Uint16Array: !1,
            Uint32Array: !1,
            Uint8Array: !1,
            Uint8ClampedArray: !1,
            undefined: !1,
            unescape: !1,
            URIError: !1,
            valueOf: !1,
            WeakMap: !1,
            WeakSet: !1
        },
        es2020: {
            Array: !1,
            ArrayBuffer: !1,
            Atomics: !1,
            BigInt: !1,
            BigInt64Array: !1,
            BigUint64Array: !1,
            Boolean: !1,
            constructor: !1,
            DataView: !1,
            Date: !1,
            decodeURI: !1,
            decodeURIComponent: !1,
            encodeURI: !1,
            encodeURIComponent: !1,
            Error: !1,
            escape: !1,
            eval: !1,
            EvalError: !1,
            Float32Array: !1,
            Float64Array: !1,
            Function: !1,
            globalThis: !1,
            hasOwnProperty: !1,
            Infinity: !1,
            Int16Array: !1,
            Int32Array: !1,
            Int8Array: !1,
            isFinite: !1,
            isNaN: !1,
            isPrototypeOf: !1,
            JSON: !1,
            Map: !1,
            Math: !1,
            NaN: !1,
            Number: !1,
            Object: !1,
            parseFloat: !1,
            parseInt: !1,
            Promise: !1,
            propertyIsEnumerable: !1,
            Proxy: !1,
            RangeError: !1,
            ReferenceError: !1,
            Reflect: !1,
            RegExp: !1,
            Set: !1,
            SharedArrayBuffer: !1,
            String: !1,
            Symbol: !1,
            SyntaxError: !1,
            toLocaleString: !1,
            toString: !1,
            TypeError: !1,
            Uint16Array: !1,
            Uint32Array: !1,
            Uint8Array: !1,
            Uint8ClampedArray: !1,
            undefined: !1,
            unescape: !1,
            URIError: !1,
            valueOf: !1,
            WeakMap: !1,
            WeakSet: !1
        },
        es2021: {
            AggregateError: !1,
            Array: !1,
            ArrayBuffer: !1,
            Atomics: !1,
            BigInt: !1,
            BigInt64Array: !1,
            BigUint64Array: !1,
            Boolean: !1,
            constructor: !1,
            DataView: !1,
            Date: !1,
            decodeURI: !1,
            decodeURIComponent: !1,
            encodeURI: !1,
            encodeURIComponent: !1,
            Error: !1,
            escape: !1,
            eval: !1,
            EvalError: !1,
            FinalizationRegistry: !1,
            Float32Array: !1,
            Float64Array: !1,
            Function: !1,
            globalThis: !1,
            hasOwnProperty: !1,
            Infinity: !1,
            Int16Array: !1,
            Int32Array: !1,
            Int8Array: !1,
            isFinite: !1,
            isNaN: !1,
            isPrototypeOf: !1,
            JSON: !1,
            Map: !1,
            Math: !1,
            NaN: !1,
            Number: !1,
            Object: !1,
            parseFloat: !1,
            parseInt: !1,
            Promise: !1,
            propertyIsEnumerable: !1,
            Proxy: !1,
            RangeError: !1,
            ReferenceError: !1,
            Reflect: !1,
            RegExp: !1,
            Set: !1,
            SharedArrayBuffer: !1,
            String: !1,
            Symbol: !1,
            SyntaxError: !1,
            toLocaleString: !1,
            toString: !1,
            TypeError: !1,
            Uint16Array: !1,
            Uint32Array: !1,
            Uint8Array: !1,
            Uint8ClampedArray: !1,
            undefined: !1,
            unescape: !1,
            URIError: !1,
            valueOf: !1,
            WeakMap: !1,
            WeakRef: !1,
            WeakSet: !1
        },
        browser: {
            AbortController: !1,
            AbortSignal: !1,
            addEventListener: !1,
            alert: !1,
            AnalyserNode: !1,
            Animation: !1,
            AnimationEffectReadOnly: !1,
            AnimationEffectTiming: !1,
            AnimationEffectTimingReadOnly: !1,
            AnimationEvent: !1,
            AnimationPlaybackEvent: !1,
            AnimationTimeline: !1,
            applicationCache: !1,
            ApplicationCache: !1,
            ApplicationCacheErrorEvent: !1,
            atob: !1,
            Attr: !1,
            Audio: !1,
            AudioBuffer: !1,
            AudioBufferSourceNode: !1,
            AudioContext: !1,
            AudioDestinationNode: !1,
            AudioListener: !1,
            AudioNode: !1,
            AudioParam: !1,
            AudioProcessingEvent: !1,
            AudioScheduledSourceNode: !1,
            AudioWorkletGlobalScope: !1,
            AudioWorkletNode: !1,
            AudioWorkletProcessor: !1,
            BarProp: !1,
            BaseAudioContext: !1,
            BatteryManager: !1,
            BeforeUnloadEvent: !1,
            BiquadFilterNode: !1,
            Blob: !1,
            BlobEvent: !1,
            blur: !1,
            BroadcastChannel: !1,
            btoa: !1,
            BudgetService: !1,
            ByteLengthQueuingStrategy: !1,
            Cache: !1,
            caches: !1,
            CacheStorage: !1,
            cancelAnimationFrame: !1,
            cancelIdleCallback: !1,
            CanvasCaptureMediaStreamTrack: !1,
            CanvasGradient: !1,
            CanvasPattern: !1,
            CanvasRenderingContext2D: !1,
            ChannelMergerNode: !1,
            ChannelSplitterNode: !1,
            CharacterData: !1,
            clearInterval: !1,
            clearTimeout: !1,
            clientInformation: !1,
            ClipboardEvent: !1,
            ClipboardItem: !1,
            close: !1,
            closed: !1,
            CloseEvent: !1,
            Comment: !1,
            CompositionEvent: !1,
            CompressionStream: !1,
            confirm: !1,
            console: !1,
            ConstantSourceNode: !1,
            ConvolverNode: !1,
            CountQueuingStrategy: !1,
            createImageBitmap: !1,
            Credential: !1,
            CredentialsContainer: !1,
            crypto: !1,
            Crypto: !1,
            CryptoKey: !1,
            CSS: !1,
            CSSConditionRule: !1,
            CSSFontFaceRule: !1,
            CSSGroupingRule: !1,
            CSSImportRule: !1,
            CSSKeyframeRule: !1,
            CSSKeyframesRule: !1,
            CSSMatrixComponent: !1,
            CSSMediaRule: !1,
            CSSNamespaceRule: !1,
            CSSPageRule: !1,
            CSSPerspective: !1,
            CSSRotate: !1,
            CSSRule: !1,
            CSSRuleList: !1,
            CSSScale: !1,
            CSSSkew: !1,
            CSSSkewX: !1,
            CSSSkewY: !1,
            CSSStyleDeclaration: !1,
            CSSStyleRule: !1,
            CSSStyleSheet: !1,
            CSSSupportsRule: !1,
            CSSTransformValue: !1,
            CSSTranslate: !1,
            CustomElementRegistry: !1,
            customElements: !1,
            CustomEvent: !1,
            DataTransfer: !1,
            DataTransferItem: !1,
            DataTransferItemList: !1,
            DecompressionStream: !1,
            defaultstatus: !1,
            defaultStatus: !1,
            DelayNode: !1,
            DeviceMotionEvent: !1,
            DeviceOrientationEvent: !1,
            devicePixelRatio: !1,
            dispatchEvent: !1,
            document: !1,
            Document: !1,
            DocumentFragment: !1,
            DocumentType: !1,
            DOMError: !1,
            DOMException: !1,
            DOMImplementation: !1,
            DOMMatrix: !1,
            DOMMatrixReadOnly: !1,
            DOMParser: !1,
            DOMPoint: !1,
            DOMPointReadOnly: !1,
            DOMQuad: !1,
            DOMRect: !1,
            DOMRectList: !1,
            DOMRectReadOnly: !1,
            DOMStringList: !1,
            DOMStringMap: !1,
            DOMTokenList: !1,
            DragEvent: !1,
            DynamicsCompressorNode: !1,
            Element: !1,
            ErrorEvent: !1,
            event: !1,
            Event: !1,
            EventSource: !1,
            EventTarget: !1,
            external: !1,
            fetch: !1,
            File: !1,
            FileList: !1,
            FileReader: !1,
            find: !1,
            focus: !1,
            FocusEvent: !1,
            FontFace: !1,
            FontFaceSetLoadEvent: !1,
            FormData: !1,
            FormDataEvent: !1,
            frameElement: !1,
            frames: !1,
            GainNode: !1,
            Gamepad: !1,
            GamepadButton: !1,
            GamepadEvent: !1,
            getComputedStyle: !1,
            getSelection: !1,
            HashChangeEvent: !1,
            Headers: !1,
            history: !1,
            History: !1,
            HTMLAllCollection: !1,
            HTMLAnchorElement: !1,
            HTMLAreaElement: !1,
            HTMLAudioElement: !1,
            HTMLBaseElement: !1,
            HTMLBodyElement: !1,
            HTMLBRElement: !1,
            HTMLButtonElement: !1,
            HTMLCanvasElement: !1,
            HTMLCollection: !1,
            HTMLContentElement: !1,
            HTMLDataElement: !1,
            HTMLDataListElement: !1,
            HTMLDetailsElement: !1,
            HTMLDialogElement: !1,
            HTMLDirectoryElement: !1,
            HTMLDivElement: !1,
            HTMLDListElement: !1,
            HTMLDocument: !1,
            HTMLElement: !1,
            HTMLEmbedElement: !1,
            HTMLFieldSetElement: !1,
            HTMLFontElement: !1,
            HTMLFormControlsCollection: !1,
            HTMLFormElement: !1,
            HTMLFrameElement: !1,
            HTMLFrameSetElement: !1,
            HTMLHeadElement: !1,
            HTMLHeadingElement: !1,
            HTMLHRElement: !1,
            HTMLHtmlElement: !1,
            HTMLIFrameElement: !1,
            HTMLImageElement: !1,
            HTMLInputElement: !1,
            HTMLLabelElement: !1,
            HTMLLegendElement: !1,
            HTMLLIElement: !1,
            HTMLLinkElement: !1,
            HTMLMapElement: !1,
            HTMLMarqueeElement: !1,
            HTMLMediaElement: !1,
            HTMLMenuElement: !1,
            HTMLMetaElement: !1,
            HTMLMeterElement: !1,
            HTMLModElement: !1,
            HTMLObjectElement: !1,
            HTMLOListElement: !1,
            HTMLOptGroupElement: !1,
            HTMLOptionElement: !1,
            HTMLOptionsCollection: !1,
            HTMLOutputElement: !1,
            HTMLParagraphElement: !1,
            HTMLParamElement: !1,
            HTMLPictureElement: !1,
            HTMLPreElement: !1,
            HTMLProgressElement: !1,
            HTMLQuoteElement: !1,
            HTMLScriptElement: !1,
            HTMLSelectElement: !1,
            HTMLShadowElement: !1,
            HTMLSlotElement: !1,
            HTMLSourceElement: !1,
            HTMLSpanElement: !1,
            HTMLStyleElement: !1,
            HTMLTableCaptionElement: !1,
            HTMLTableCellElement: !1,
            HTMLTableColElement: !1,
            HTMLTableElement: !1,
            HTMLTableRowElement: !1,
            HTMLTableSectionElement: !1,
            HTMLTemplateElement: !1,
            HTMLTextAreaElement: !1,
            HTMLTimeElement: !1,
            HTMLTitleElement: !1,
            HTMLTrackElement: !1,
            HTMLUListElement: !1,
            HTMLUnknownElement: !1,
            HTMLVideoElement: !1,
            IDBCursor: !1,
            IDBCursorWithValue: !1,
            IDBDatabase: !1,
            IDBFactory: !1,
            IDBIndex: !1,
            IDBKeyRange: !1,
            IDBObjectStore: !1,
            IDBOpenDBRequest: !1,
            IDBRequest: !1,
            IDBTransaction: !1,
            IDBVersionChangeEvent: !1,
            IdleDeadline: !1,
            IIRFilterNode: !1,
            Image: !1,
            ImageBitmap: !1,
            ImageBitmapRenderingContext: !1,
            ImageCapture: !1,
            ImageData: !1,
            indexedDB: !1,
            innerHeight: !1,
            innerWidth: !1,
            InputEvent: !1,
            IntersectionObserver: !1,
            IntersectionObserverEntry: !1,
            Intl: !1,
            isSecureContext: !1,
            KeyboardEvent: !1,
            KeyframeEffect: !1,
            KeyframeEffectReadOnly: !1,
            length: !1,
            localStorage: !1,
            location: !0,
            Location: !1,
            locationbar: !1,
            matchMedia: !1,
            MediaDeviceInfo: !1,
            MediaDevices: !1,
            MediaElementAudioSourceNode: !1,
            MediaEncryptedEvent: !1,
            MediaError: !1,
            MediaKeyMessageEvent: !1,
            MediaKeySession: !1,
            MediaKeyStatusMap: !1,
            MediaKeySystemAccess: !1,
            MediaList: !1,
            MediaMetadata: !1,
            MediaQueryList: !1,
            MediaQueryListEvent: !1,
            MediaRecorder: !1,
            MediaSettingsRange: !1,
            MediaSource: !1,
            MediaStream: !1,
            MediaStreamAudioDestinationNode: !1,
            MediaStreamAudioSourceNode: !1,
            MediaStreamConstraints: !1,
            MediaStreamEvent: !1,
            MediaStreamTrack: !1,
            MediaStreamTrackEvent: !1,
            menubar: !1,
            MessageChannel: !1,
            MessageEvent: !1,
            MessagePort: !1,
            MIDIAccess: !1,
            MIDIConnectionEvent: !1,
            MIDIInput: !1,
            MIDIInputMap: !1,
            MIDIMessageEvent: !1,
            MIDIOutput: !1,
            MIDIOutputMap: !1,
            MIDIPort: !1,
            MimeType: !1,
            MimeTypeArray: !1,
            MouseEvent: !1,
            moveBy: !1,
            moveTo: !1,
            MutationEvent: !1,
            MutationObserver: !1,
            MutationRecord: !1,
            name: !1,
            NamedNodeMap: !1,
            NavigationPreloadManager: !1,
            navigator: !1,
            Navigator: !1,
            NavigatorUAData: !1,
            NetworkInformation: !1,
            Node: !1,
            NodeFilter: !1,
            NodeIterator: !1,
            NodeList: !1,
            Notification: !1,
            OfflineAudioCompletionEvent: !1,
            OfflineAudioContext: !1,
            offscreenBuffering: !1,
            OffscreenCanvas: !0,
            OffscreenCanvasRenderingContext2D: !1,
            onabort: !0,
            onafterprint: !0,
            onanimationend: !0,
            onanimationiteration: !0,
            onanimationstart: !0,
            onappinstalled: !0,
            onauxclick: !0,
            onbeforeinstallprompt: !0,
            onbeforeprint: !0,
            onbeforeunload: !0,
            onblur: !0,
            oncancel: !0,
            oncanplay: !0,
            oncanplaythrough: !0,
            onchange: !0,
            onclick: !0,
            onclose: !0,
            oncontextmenu: !0,
            oncuechange: !0,
            ondblclick: !0,
            ondevicemotion: !0,
            ondeviceorientation: !0,
            ondeviceorientationabsolute: !0,
            ondrag: !0,
            ondragend: !0,
            ondragenter: !0,
            ondragleave: !0,
            ondragover: !0,
            ondragstart: !0,
            ondrop: !0,
            ondurationchange: !0,
            onemptied: !0,
            onended: !0,
            onerror: !0,
            onfocus: !0,
            ongotpointercapture: !0,
            onhashchange: !0,
            oninput: !0,
            oninvalid: !0,
            onkeydown: !0,
            onkeypress: !0,
            onkeyup: !0,
            onlanguagechange: !0,
            onload: !0,
            onloadeddata: !0,
            onloadedmetadata: !0,
            onloadstart: !0,
            onlostpointercapture: !0,
            onmessage: !0,
            onmessageerror: !0,
            onmousedown: !0,
            onmouseenter: !0,
            onmouseleave: !0,
            onmousemove: !0,
            onmouseout: !0,
            onmouseover: !0,
            onmouseup: !0,
            onmousewheel: !0,
            onoffline: !0,
            ononline: !0,
            onpagehide: !0,
            onpageshow: !0,
            onpause: !0,
            onplay: !0,
            onplaying: !0,
            onpointercancel: !0,
            onpointerdown: !0,
            onpointerenter: !0,
            onpointerleave: !0,
            onpointermove: !0,
            onpointerout: !0,
            onpointerover: !0,
            onpointerup: !0,
            onpopstate: !0,
            onprogress: !0,
            onratechange: !0,
            onrejectionhandled: !0,
            onreset: !0,
            onresize: !0,
            onscroll: !0,
            onsearch: !0,
            onseeked: !0,
            onseeking: !0,
            onselect: !0,
            onstalled: !0,
            onstorage: !0,
            onsubmit: !0,
            onsuspend: !0,
            ontimeupdate: !0,
            ontoggle: !0,
            ontransitionend: !0,
            onunhandledrejection: !0,
            onunload: !0,
            onvolumechange: !0,
            onwaiting: !0,
            onwheel: !0,
            open: !1,
            openDatabase: !1,
            opener: !1,
            Option: !1,
            origin: !1,
            OscillatorNode: !1,
            outerHeight: !1,
            outerWidth: !1,
            OverconstrainedError: !1,
            PageTransitionEvent: !1,
            pageXOffset: !1,
            pageYOffset: !1,
            PannerNode: !1,
            parent: !1,
            Path2D: !1,
            PaymentAddress: !1,
            PaymentRequest: !1,
            PaymentRequestUpdateEvent: !1,
            PaymentResponse: !1,
            performance: !1,
            Performance: !1,
            PerformanceEntry: !1,
            PerformanceLongTaskTiming: !1,
            PerformanceMark: !1,
            PerformanceMeasure: !1,
            PerformanceNavigation: !1,
            PerformanceNavigationTiming: !1,
            PerformanceObserver: !1,
            PerformanceObserverEntryList: !1,
            PerformancePaintTiming: !1,
            PerformanceResourceTiming: !1,
            PerformanceTiming: !1,
            PeriodicWave: !1,
            Permissions: !1,
            PermissionStatus: !1,
            personalbar: !1,
            PhotoCapabilities: !1,
            Plugin: !1,
            PluginArray: !1,
            PointerEvent: !1,
            PopStateEvent: !1,
            postMessage: !1,
            Presentation: !1,
            PresentationAvailability: !1,
            PresentationConnection: !1,
            PresentationConnectionAvailableEvent: !1,
            PresentationConnectionCloseEvent: !1,
            PresentationConnectionList: !1,
            PresentationReceiver: !1,
            PresentationRequest: !1,
            print: !1,
            ProcessingInstruction: !1,
            ProgressEvent: !1,
            PromiseRejectionEvent: !1,
            prompt: !1,
            PushManager: !1,
            PushSubscription: !1,
            PushSubscriptionOptions: !1,
            queueMicrotask: !1,
            RadioNodeList: !1,
            Range: !1,
            ReadableByteStreamController: !1,
            ReadableStream: !1,
            ReadableStreamBYOBReader: !1,
            ReadableStreamBYOBRequest: !1,
            ReadableStreamDefaultController: !1,
            ReadableStreamDefaultReader: !1,
            registerProcessor: !1,
            RemotePlayback: !1,
            removeEventListener: !1,
            reportError: !1,
            Request: !1,
            requestAnimationFrame: !1,
            requestIdleCallback: !1,
            resizeBy: !1,
            ResizeObserver: !1,
            ResizeObserverEntry: !1,
            resizeTo: !1,
            Response: !1,
            RTCCertificate: !1,
            RTCDataChannel: !1,
            RTCDataChannelEvent: !1,
            RTCDtlsTransport: !1,
            RTCIceCandidate: !1,
            RTCIceGatherer: !1,
            RTCIceTransport: !1,
            RTCPeerConnection: !1,
            RTCPeerConnectionIceEvent: !1,
            RTCRtpContributingSource: !1,
            RTCRtpReceiver: !1,
            RTCRtpSender: !1,
            RTCSctpTransport: !1,
            RTCSessionDescription: !1,
            RTCStatsReport: !1,
            RTCTrackEvent: !1,
            screen: !1,
            Screen: !1,
            screenLeft: !1,
            ScreenOrientation: !1,
            screenTop: !1,
            screenX: !1,
            screenY: !1,
            ScriptProcessorNode: !1,
            scroll: !1,
            scrollbars: !1,
            scrollBy: !1,
            scrollTo: !1,
            scrollX: !1,
            scrollY: !1,
            SecurityPolicyViolationEvent: !1,
            Selection: !1,
            self: !1,
            ServiceWorker: !1,
            ServiceWorkerContainer: !1,
            ServiceWorkerRegistration: !1,
            sessionStorage: !1,
            setInterval: !1,
            setTimeout: !1,
            ShadowRoot: !1,
            SharedWorker: !1,
            SourceBuffer: !1,
            SourceBufferList: !1,
            speechSynthesis: !1,
            SpeechSynthesisEvent: !1,
            SpeechSynthesisUtterance: !1,
            StaticRange: !1,
            status: !1,
            statusbar: !1,
            StereoPannerNode: !1,
            stop: !1,
            Storage: !1,
            StorageEvent: !1,
            StorageManager: !1,
            structuredClone: !1,
            styleMedia: !1,
            StyleSheet: !1,
            StyleSheetList: !1,
            SubmitEvent: !1,
            SubtleCrypto: !1,
            SVGAElement: !1,
            SVGAngle: !1,
            SVGAnimatedAngle: !1,
            SVGAnimatedBoolean: !1,
            SVGAnimatedEnumeration: !1,
            SVGAnimatedInteger: !1,
            SVGAnimatedLength: !1,
            SVGAnimatedLengthList: !1,
            SVGAnimatedNumber: !1,
            SVGAnimatedNumberList: !1,
            SVGAnimatedPreserveAspectRatio: !1,
            SVGAnimatedRect: !1,
            SVGAnimatedString: !1,
            SVGAnimatedTransformList: !1,
            SVGAnimateElement: !1,
            SVGAnimateMotionElement: !1,
            SVGAnimateTransformElement: !1,
            SVGAnimationElement: !1,
            SVGCircleElement: !1,
            SVGClipPathElement: !1,
            SVGComponentTransferFunctionElement: !1,
            SVGDefsElement: !1,
            SVGDescElement: !1,
            SVGDiscardElement: !1,
            SVGElement: !1,
            SVGEllipseElement: !1,
            SVGFEBlendElement: !1,
            SVGFEColorMatrixElement: !1,
            SVGFEComponentTransferElement: !1,
            SVGFECompositeElement: !1,
            SVGFEConvolveMatrixElement: !1,
            SVGFEDiffuseLightingElement: !1,
            SVGFEDisplacementMapElement: !1,
            SVGFEDistantLightElement: !1,
            SVGFEDropShadowElement: !1,
            SVGFEFloodElement: !1,
            SVGFEFuncAElement: !1,
            SVGFEFuncBElement: !1,
            SVGFEFuncGElement: !1,
            SVGFEFuncRElement: !1,
            SVGFEGaussianBlurElement: !1,
            SVGFEImageElement: !1,
            SVGFEMergeElement: !1,
            SVGFEMergeNodeElement: !1,
            SVGFEMorphologyElement: !1,
            SVGFEOffsetElement: !1,
            SVGFEPointLightElement: !1,
            SVGFESpecularLightingElement: !1,
            SVGFESpotLightElement: !1,
            SVGFETileElement: !1,
            SVGFETurbulenceElement: !1,
            SVGFilterElement: !1,
            SVGForeignObjectElement: !1,
            SVGGElement: !1,
            SVGGeometryElement: !1,
            SVGGradientElement: !1,
            SVGGraphicsElement: !1,
            SVGImageElement: !1,
            SVGLength: !1,
            SVGLengthList: !1,
            SVGLinearGradientElement: !1,
            SVGLineElement: !1,
            SVGMarkerElement: !1,
            SVGMaskElement: !1,
            SVGMatrix: !1,
            SVGMetadataElement: !1,
            SVGMPathElement: !1,
            SVGNumber: !1,
            SVGNumberList: !1,
            SVGPathElement: !1,
            SVGPatternElement: !1,
            SVGPoint: !1,
            SVGPointList: !1,
            SVGPolygonElement: !1,
            SVGPolylineElement: !1,
            SVGPreserveAspectRatio: !1,
            SVGRadialGradientElement: !1,
            SVGRect: !1,
            SVGRectElement: !1,
            SVGScriptElement: !1,
            SVGSetElement: !1,
            SVGStopElement: !1,
            SVGStringList: !1,
            SVGStyleElement: !1,
            SVGSVGElement: !1,
            SVGSwitchElement: !1,
            SVGSymbolElement: !1,
            SVGTextContentElement: !1,
            SVGTextElement: !1,
            SVGTextPathElement: !1,
            SVGTextPositioningElement: !1,
            SVGTitleElement: !1,
            SVGTransform: !1,
            SVGTransformList: !1,
            SVGTSpanElement: !1,
            SVGUnitTypes: !1,
            SVGUseElement: !1,
            SVGViewElement: !1,
            TaskAttributionTiming: !1,
            Text: !1,
            TextDecoder: !1,
            TextDecoderStream: !1,
            TextEncoder: !1,
            TextEncoderStream: !1,
            TextEvent: !1,
            TextMetrics: !1,
            TextTrack: !1,
            TextTrackCue: !1,
            TextTrackCueList: !1,
            TextTrackList: !1,
            TimeRanges: !1,
            ToggleEvent: !1,
            toolbar: !1,
            top: !1,
            Touch: !1,
            TouchEvent: !1,
            TouchList: !1,
            TrackEvent: !1,
            TransformStream: !1,
            TransformStreamDefaultController: !1,
            TransitionEvent: !1,
            TreeWalker: !1,
            UIEvent: !1,
            URL: !1,
            URLSearchParams: !1,
            ValidityState: !1,
            visualViewport: !1,
            VisualViewport: !1,
            VTTCue: !1,
            WaveShaperNode: !1,
            WebAssembly: !1,
            WebGL2RenderingContext: !1,
            WebGLActiveInfo: !1,
            WebGLBuffer: !1,
            WebGLContextEvent: !1,
            WebGLFramebuffer: !1,
            WebGLProgram: !1,
            WebGLQuery: !1,
            WebGLRenderbuffer: !1,
            WebGLRenderingContext: !1,
            WebGLSampler: !1,
            WebGLShader: !1,
            WebGLShaderPrecisionFormat: !1,
            WebGLSync: !1,
            WebGLTexture: !1,
            WebGLTransformFeedback: !1,
            WebGLUniformLocation: !1,
            WebGLVertexArrayObject: !1,
            WebSocket: !1,
            WheelEvent: !1,
            window: !1,
            Window: !1,
            Worker: !1,
            WritableStream: !1,
            WritableStreamDefaultController: !1,
            WritableStreamDefaultWriter: !1,
            XMLDocument: !1,
            XMLHttpRequest: !1,
            XMLHttpRequestEventTarget: !1,
            XMLHttpRequestUpload: !1,
            XMLSerializer: !1,
            XPathEvaluator: !1,
            XPathExpression: !1,
            XPathResult: !1,
            XRAnchor: !1,
            XRBoundedReferenceSpace: !1,
            XRCPUDepthInformation: !1,
            XRDepthInformation: !1,
            XRFrame: !1,
            XRInputSource: !1,
            XRInputSourceArray: !1,
            XRInputSourceEvent: !1,
            XRInputSourcesChangeEvent: !1,
            XRPose: !1,
            XRReferenceSpace: !1,
            XRReferenceSpaceEvent: !1,
            XRRenderState: !1,
            XRRigidTransform: !1,
            XRSession: !1,
            XRSessionEvent: !1,
            XRSpace: !1,
            XRSystem: !1,
            XRView: !1,
            XRViewerPose: !1,
            XRViewport: !1,
            XRWebGLBinding: !1,
            XRWebGLDepthInformation: !1,
            XRWebGLLayer: !1,
            XSLTProcessor: !1
        },
        worker: {
            addEventListener: !1,
            applicationCache: !1,
            atob: !1,
            Blob: !1,
            BroadcastChannel: !1,
            btoa: !1,
            ByteLengthQueuingStrategy: !1,
            Cache: !1,
            caches: !1,
            clearInterval: !1,
            clearTimeout: !1,
            close: !0,
            CompressionStream: !1,
            console: !1,
            CountQueuingStrategy: !1,
            crypto: !1,
            Crypto: !1,
            CryptoKey: !1,
            CustomEvent: !1,
            DecompressionStream: !1,
            ErrorEvent: !1,
            Event: !1,
            fetch: !1,
            File: !1,
            FileReaderSync: !1,
            FormData: !1,
            Headers: !1,
            IDBCursor: !1,
            IDBCursorWithValue: !1,
            IDBDatabase: !1,
            IDBFactory: !1,
            IDBIndex: !1,
            IDBKeyRange: !1,
            IDBObjectStore: !1,
            IDBOpenDBRequest: !1,
            IDBRequest: !1,
            IDBTransaction: !1,
            IDBVersionChangeEvent: !1,
            ImageData: !1,
            importScripts: !0,
            indexedDB: !1,
            location: !1,
            MessageChannel: !1,
            MessageEvent: !1,
            MessagePort: !1,
            name: !1,
            navigator: !1,
            Notification: !1,
            onclose: !0,
            onconnect: !0,
            onerror: !0,
            onlanguagechange: !0,
            onmessage: !0,
            onoffline: !0,
            ononline: !0,
            onrejectionhandled: !0,
            onunhandledrejection: !0,
            performance: !1,
            Performance: !1,
            PerformanceEntry: !1,
            PerformanceMark: !1,
            PerformanceMeasure: !1,
            PerformanceNavigation: !1,
            PerformanceObserver: !1,
            PerformanceObserverEntryList: !1,
            PerformanceResourceTiming: !1,
            PerformanceTiming: !1,
            postMessage: !0,
            Promise: !1,
            queueMicrotask: !1,
            ReadableByteStreamController: !1,
            ReadableStream: !1,
            ReadableStreamBYOBReader: !1,
            ReadableStreamBYOBRequest: !1,
            ReadableStreamDefaultController: !1,
            ReadableStreamDefaultReader: !1,
            removeEventListener: !1,
            reportError: !1,
            Request: !1,
            Response: !1,
            self: !0,
            ServiceWorkerRegistration: !1,
            setInterval: !1,
            setTimeout: !1,
            SubtleCrypto: !1,
            TextDecoder: !1,
            TextDecoderStream: !1,
            TextEncoder: !1,
            TextEncoderStream: !1,
            TransformStream: !1,
            TransformStreamDefaultController: !1,
            URL: !1,
            URLSearchParams: !1,
            WebAssembly: !1,
            WebSocket: !1,
            Worker: !1,
            WorkerGlobalScope: !1,
            WritableStream: !1,
            WritableStreamDefaultController: !1,
            WritableStreamDefaultWriter: !1,
            XMLHttpRequest: !1
        },
        node: {
            __dirname: !1,
            __filename: !1,
            AbortController: !1,
            AbortSignal: !1,
            atob: !1,
            Blob: !1,
            BroadcastChannel: !1,
            btoa: !1,
            Buffer: !1,
            ByteLengthQueuingStrategy: !1,
            clearImmediate: !1,
            clearInterval: !1,
            clearTimeout: !1,
            CompressionStream: !1,
            console: !1,
            CountQueuingStrategy: !1,
            crypto: !1,
            Crypto: !1,
            CryptoKey: !1,
            CustomEvent: !1,
            DecompressionStream: !1,
            DOMException: !1,
            Event: !1,
            EventTarget: !1,
            exports: !0,
            fetch: !1,
            File: !1,
            FormData: !1,
            global: !1,
            Headers: !1,
            Intl: !1,
            MessageChannel: !1,
            MessageEvent: !1,
            MessagePort: !1,
            module: !1,
            performance: !1,
            PerformanceEntry: !1,
            PerformanceMark: !1,
            PerformanceMeasure: !1,
            PerformanceObserver: !1,
            PerformanceObserverEntryList: !1,
            PerformanceResourceTiming: !1,
            process: !1,
            queueMicrotask: !1,
            ReadableByteStreamController: !1,
            ReadableStream: !1,
            ReadableStreamBYOBReader: !1,
            ReadableStreamBYOBRequest: !1,
            ReadableStreamDefaultController: !1,
            ReadableStreamDefaultReader: !1,
            Request: !1,
            require: !1,
            Response: !1,
            setImmediate: !1,
            setInterval: !1,
            setTimeout: !1,
            structuredClone: !1,
            SubtleCrypto: !1,
            TextDecoder: !1,
            TextDecoderStream: !1,
            TextEncoder: !1,
            TextEncoderStream: !1,
            TransformStream: !1,
            TransformStreamDefaultController: !1,
            URL: !1,
            URLSearchParams: !1,
            WebAssembly: !1,
            WritableStream: !1,
            WritableStreamDefaultController: !1,
            WritableStreamDefaultWriter: !1
        },
        nodeBuiltin: {
            AbortController: !1,
            AbortSignal: !1,
            atob: !1,
            Blob: !1,
            BroadcastChannel: !1,
            btoa: !1,
            Buffer: !1,
            ByteLengthQueuingStrategy: !1,
            clearImmediate: !1,
            clearInterval: !1,
            clearTimeout: !1,
            CompressionStream: !1,
            console: !1,
            CountQueuingStrategy: !1,
            crypto: !1,
            Crypto: !1,
            CryptoKey: !1,
            CustomEvent: !1,
            DecompressionStream: !1,
            DOMException: !1,
            Event: !1,
            EventTarget: !1,
            fetch: !1,
            File: !1,
            FormData: !1,
            global: !1,
            Headers: !1,
            Intl: !1,
            MessageChannel: !1,
            MessageEvent: !1,
            MessagePort: !1,
            performance: !1,
            PerformanceEntry: !1,
            PerformanceMark: !1,
            PerformanceMeasure: !1,
            PerformanceObserver: !1,
            PerformanceObserverEntryList: !1,
            PerformanceResourceTiming: !1,
            process: !1,
            queueMicrotask: !1,
            ReadableByteStreamController: !1,
            ReadableStream: !1,
            ReadableStreamBYOBReader: !1,
            ReadableStreamBYOBRequest: !1,
            ReadableStreamDefaultController: !1,
            ReadableStreamDefaultReader: !1,
            Request: !1,
            Response: !1,
            setImmediate: !1,
            setInterval: !1,
            setTimeout: !1,
            structuredClone: !1,
            SubtleCrypto: !1,
            TextDecoder: !1,
            TextDecoderStream: !1,
            TextEncoder: !1,
            TextEncoderStream: !1,
            TransformStream: !1,
            TransformStreamDefaultController: !1,
            URL: !1,
            URLSearchParams: !1,
            WebAssembly: !1,
            WritableStream: !1,
            WritableStreamDefaultController: !1,
            WritableStreamDefaultWriter: !1
        },
        commonjs: {
            exports: !0,
            global: !1,
            module: !1,
            require: !1
        },
        amd: {
            define: !1,
            require: !1
        },
        mocha: {
            after: !1,
            afterEach: !1,
            before: !1,
            beforeEach: !1,
            context: !1,
            describe: !1,
            it: !1,
            mocha: !1,
            run: !1,
            setup: !1,
            specify: !1,
            suite: !1,
            suiteSetup: !1,
            suiteTeardown: !1,
            teardown: !1,
            test: !1,
            xcontext: !1,
            xdescribe: !1,
            xit: !1,
            xspecify: !1
        },
        jasmine: {
            afterAll: !1,
            afterEach: !1,
            beforeAll: !1,
            beforeEach: !1,
            describe: !1,
            expect: !1,
            expectAsync: !1,
            fail: !1,
            fdescribe: !1,
            fit: !1,
            it: !1,
            jasmine: !1,
            pending: !1,
            runs: !1,
            spyOn: !1,
            spyOnAllFunctions: !1,
            spyOnProperty: !1,
            waits: !1,
            waitsFor: !1,
            xdescribe: !1,
            xit: !1
        },
        jest: {
            afterAll: !1,
            afterEach: !1,
            beforeAll: !1,
            beforeEach: !1,
            describe: !1,
            expect: !1,
            fdescribe: !1,
            fit: !1,
            it: !1,
            jest: !1,
            pit: !1,
            require: !1,
            test: !1,
            xdescribe: !1,
            xit: !1,
            xtest: !1
        },
        qunit: {
            asyncTest: !1,
            deepEqual: !1,
            equal: !1,
            expect: !1,
            module: !1,
            notDeepEqual: !1,
            notEqual: !1,
            notOk: !1,
            notPropEqual: !1,
            notStrictEqual: !1,
            ok: !1,
            propEqual: !1,
            QUnit: !1,
            raises: !1,
            start: !1,
            stop: !1,
            strictEqual: !1,
            test: !1,
            throws: !1
        },
        phantomjs: {
            console: !0,
            exports: !0,
            phantom: !0,
            require: !0,
            WebPage: !0
        },
        couch: {
            emit: !1,
            exports: !1,
            getRow: !1,
            log: !1,
            module: !1,
            provides: !1,
            require: !1,
            respond: !1,
            send: !1,
            start: !1,
            sum: !1
        },
        rhino: {
            defineClass: !1,
            deserialize: !1,
            gc: !1,
            help: !1,
            importClass: !1,
            importPackage: !1,
            java: !1,
            load: !1,
            loadClass: !1,
            Packages: !1,
            print: !1,
            quit: !1,
            readFile: !1,
            readUrl: !1,
            runCommand: !1,
            seal: !1,
            serialize: !1,
            spawn: !1,
            sync: !1,
            toint32: !1,
            version: !1
        },
        nashorn: {
            __DIR__: !1,
            __FILE__: !1,
            __LINE__: !1,
            com: !1,
            edu: !1,
            exit: !1,
            java: !1,
            Java: !1,
            javafx: !1,
            JavaImporter: !1,
            javax: !1,
            JSAdapter: !1,
            load: !1,
            loadWithNewGlobal: !1,
            org: !1,
            Packages: !1,
            print: !1,
            quit: !1
        },
        wsh: {
            ActiveXObject: !1,
            CollectGarbage: !1,
            Debug: !1,
            Enumerator: !1,
            GetObject: !1,
            RuntimeObject: !1,
            ScriptEngine: !1,
            ScriptEngineBuildVersion: !1,
            ScriptEngineMajorVersion: !1,
            ScriptEngineMinorVersion: !1,
            VBArray: !1,
            WScript: !1,
            WSH: !1
        },
        jquery: {
            $: !1,
            jQuery: !1
        },
        yui: {
            YAHOO: !1,
            YAHOO_config: !1,
            YUI: !1,
            YUI_config: !1
        },
        shelljs: {
            cat: !1,
            cd: !1,
            chmod: !1,
            config: !1,
            cp: !1,
            dirs: !1,
            echo: !1,
            env: !1,
            error: !1,
            exec: !1,
            exit: !1,
            find: !1,
            grep: !1,
            ln: !1,
            ls: !1,
            mkdir: !1,
            mv: !1,
            popd: !1,
            pushd: !1,
            pwd: !1,
            rm: !1,
            sed: !1,
            set: !1,
            target: !1,
            tempdir: !1,
            test: !1,
            touch: !1,
            which: !1
        },
        prototypejs: {
            $: !1,
            $$: !1,
            $A: !1,
            $break: !1,
            $continue: !1,
            $F: !1,
            $H: !1,
            $R: !1,
            $w: !1,
            Abstract: !1,
            Ajax: !1,
            Autocompleter: !1,
            Builder: !1,
            Class: !1,
            Control: !1,
            Draggable: !1,
            Draggables: !1,
            Droppables: !1,
            Effect: !1,
            Element: !1,
            Enumerable: !1,
            Event: !1,
            Field: !1,
            Form: !1,
            Hash: !1,
            Insertion: !1,
            ObjectRange: !1,
            PeriodicalExecuter: !1,
            Position: !1,
            Prototype: !1,
            Scriptaculous: !1,
            Selector: !1,
            Sortable: !1,
            SortableObserver: !1,
            Sound: !1,
            Template: !1,
            Toggle: !1,
            Try: !1
        },
        meteor: {
            $: !1,
            Accounts: !1,
            AccountsClient: !1,
            AccountsCommon: !1,
            AccountsServer: !1,
            App: !1,
            Assets: !1,
            Blaze: !1,
            check: !1,
            Cordova: !1,
            DDP: !1,
            DDPRateLimiter: !1,
            DDPServer: !1,
            Deps: !1,
            EJSON: !1,
            Email: !1,
            HTTP: !1,
            Log: !1,
            Match: !1,
            Meteor: !1,
            Mongo: !1,
            MongoInternals: !1,
            Npm: !1,
            Package: !1,
            Plugin: !1,
            process: !1,
            Random: !1,
            ReactiveDict: !1,
            ReactiveVar: !1,
            Router: !1,
            ServiceConfiguration: !1,
            Session: !1,
            share: !1,
            Spacebars: !1,
            Template: !1,
            Tinytest: !1,
            Tracker: !1,
            UI: !1,
            Utils: !1,
            WebApp: !1,
            WebAppInternals: !1
        },
        mongo: {
            _isWindows: !1,
            _rand: !1,
            BulkWriteResult: !1,
            cat: !1,
            cd: !1,
            connect: !1,
            db: !1,
            getHostName: !1,
            getMemInfo: !1,
            hostname: !1,
            ISODate: !1,
            listFiles: !1,
            load: !1,
            ls: !1,
            md5sumFile: !1,
            mkdir: !1,
            Mongo: !1,
            NumberInt: !1,
            NumberLong: !1,
            ObjectId: !1,
            PlanCache: !1,
            print: !1,
            printjson: !1,
            pwd: !1,
            quit: !1,
            removeFile: !1,
            rs: !1,
            sh: !1,
            UUID: !1,
            version: !1,
            WriteResult: !1
        },
        applescript: {
            $: !1,
            Application: !1,
            Automation: !1,
            console: !1,
            delay: !1,
            Library: !1,
            ObjC: !1,
            ObjectSpecifier: !1,
            Path: !1,
            Progress: !1,
            Ref: !1
        },
        serviceworker: {
            addEventListener: !1,
            applicationCache: !1,
            atob: !1,
            Blob: !1,
            BroadcastChannel: !1,
            btoa: !1,
            ByteLengthQueuingStrategy: !1,
            Cache: !1,
            caches: !1,
            CacheStorage: !1,
            clearInterval: !1,
            clearTimeout: !1,
            Client: !1,
            clients: !1,
            Clients: !1,
            close: !0,
            CompressionStream: !1,
            console: !1,
            CountQueuingStrategy: !1,
            crypto: !1,
            Crypto: !1,
            CryptoKey: !1,
            CustomEvent: !1,
            DecompressionStream: !1,
            ErrorEvent: !1,
            Event: !1,
            ExtendableEvent: !1,
            ExtendableMessageEvent: !1,
            fetch: !1,
            FetchEvent: !1,
            File: !1,
            FileReaderSync: !1,
            FormData: !1,
            Headers: !1,
            IDBCursor: !1,
            IDBCursorWithValue: !1,
            IDBDatabase: !1,
            IDBFactory: !1,
            IDBIndex: !1,
            IDBKeyRange: !1,
            IDBObjectStore: !1,
            IDBOpenDBRequest: !1,
            IDBRequest: !1,
            IDBTransaction: !1,
            IDBVersionChangeEvent: !1,
            ImageData: !1,
            importScripts: !1,
            indexedDB: !1,
            location: !1,
            MessageChannel: !1,
            MessageEvent: !1,
            MessagePort: !1,
            name: !1,
            navigator: !1,
            Notification: !1,
            onclose: !0,
            onconnect: !0,
            onerror: !0,
            onfetch: !0,
            oninstall: !0,
            onlanguagechange: !0,
            onmessage: !0,
            onmessageerror: !0,
            onnotificationclick: !0,
            onnotificationclose: !0,
            onoffline: !0,
            ononline: !0,
            onpush: !0,
            onpushsubscriptionchange: !0,
            onrejectionhandled: !0,
            onsync: !0,
            onunhandledrejection: !0,
            performance: !1,
            Performance: !1,
            PerformanceEntry: !1,
            PerformanceMark: !1,
            PerformanceMeasure: !1,
            PerformanceNavigation: !1,
            PerformanceObserver: !1,
            PerformanceObserverEntryList: !1,
            PerformanceResourceTiming: !1,
            PerformanceTiming: !1,
            postMessage: !0,
            Promise: !1,
            queueMicrotask: !1,
            ReadableByteStreamController: !1,
            ReadableStream: !1,
            ReadableStreamBYOBReader: !1,
            ReadableStreamBYOBRequest: !1,
            ReadableStreamDefaultController: !1,
            ReadableStreamDefaultReader: !1,
            registration: !1,
            removeEventListener: !1,
            Request: !1,
            Response: !1,
            self: !1,
            ServiceWorker: !1,
            ServiceWorkerContainer: !1,
            ServiceWorkerGlobalScope: !1,
            ServiceWorkerMessageEvent: !1,
            ServiceWorkerRegistration: !1,
            setInterval: !1,
            setTimeout: !1,
            skipWaiting: !1,
            SubtleCrypto: !1,
            TextDecoder: !1,
            TextDecoderStream: !1,
            TextEncoder: !1,
            TextEncoderStream: !1,
            TransformStream: !1,
            TransformStreamDefaultController: !1,
            URL: !1,
            URLSearchParams: !1,
            WebAssembly: !1,
            WebSocket: !1,
            WindowClient: !1,
            Worker: !1,
            WorkerGlobalScope: !1,
            WritableStream: !1,
            WritableStreamDefaultController: !1,
            WritableStreamDefaultWriter: !1,
            XMLHttpRequest: !1
        },
        atomtest: {
            advanceClock: !1,
            atom: !1,
            fakeClearInterval: !1,
            fakeClearTimeout: !1,
            fakeSetInterval: !1,
            fakeSetTimeout: !1,
            resetTimeouts: !1,
            waitsForPromise: !1
        },
        embertest: {
            andThen: !1,
            click: !1,
            currentPath: !1,
            currentRouteName: !1,
            currentURL: !1,
            fillIn: !1,
            find: !1,
            findAll: !1,
            findWithAssert: !1,
            keyEvent: !1,
            pauseTest: !1,
            resumeTest: !1,
            triggerEvent: !1,
            visit: !1,
            wait: !1
        },
        protractor: {
            $: !1,
            $$: !1,
            browser: !1,
            by: !1,
            By: !1,
            DartObject: !1,
            element: !1,
            protractor: !1
        },
        "shared-node-browser": {
            AbortController: !1,
            AbortSignal: !1,
            atob: !1,
            Blob: !1,
            BroadcastChannel: !1,
            btoa: !1,
            ByteLengthQueuingStrategy: !1,
            clearInterval: !1,
            clearTimeout: !1,
            CompressionStream: !1,
            console: !1,
            CountQueuingStrategy: !1,
            crypto: !1,
            Crypto: !1,
            CryptoKey: !1,
            CustomEvent: !1,
            DecompressionStream: !1,
            DOMException: !1,
            Event: !1,
            EventTarget: !1,
            fetch: !1,
            File: !1,
            FormData: !1,
            Headers: !1,
            Intl: !1,
            MessageChannel: !1,
            MessageEvent: !1,
            MessagePort: !1,
            performance: !1,
            PerformanceEntry: !1,
            PerformanceMark: !1,
            PerformanceMeasure: !1,
            PerformanceObserver: !1,
            PerformanceObserverEntryList: !1,
            PerformanceResourceTiming: !1,
            queueMicrotask: !1,
            ReadableByteStreamController: !1,
            ReadableStream: !1,
            ReadableStreamBYOBReader: !1,
            ReadableStreamBYOBRequest: !1,
            ReadableStreamDefaultController: !1,
            ReadableStreamDefaultReader: !1,
            Request: !1,
            Response: !1,
            setInterval: !1,
            setTimeout: !1,
            structuredClone: !1,
            SubtleCrypto: !1,
            TextDecoder: !1,
            TextDecoderStream: !1,
            TextEncoder: !1,
            TextEncoderStream: !1,
            TransformStream: !1,
            TransformStreamDefaultController: !1,
            URL: !1,
            URLSearchParams: !1,
            WebAssembly: !1,
            WritableStream: !1,
            WritableStreamDefaultController: !1,
            WritableStreamDefaultWriter: !1
        },
        webextensions: {
            browser: !1,
            chrome: !1,
            opr: !1
        },
        greasemonkey: {
            cloneInto: !1,
            createObjectIn: !1,
            exportFunction: !1,
            GM: !1,
            GM_addElement: !1,
            GM_addStyle: !1,
            GM_addValueChangeListener: !1,
            GM_deleteValue: !1,
            GM_download: !1,
            GM_getResourceText: !1,
            GM_getResourceURL: !1,
            GM_getTab: !1,
            GM_getTabs: !1,
            GM_getValue: !1,
            GM_info: !1,
            GM_listValues: !1,
            GM_log: !1,
            GM_notification: !1,
            GM_openInTab: !1,
            GM_registerMenuCommand: !1,
            GM_removeValueChangeListener: !1,
            GM_saveTab: !1,
            GM_setClipboard: !1,
            GM_setValue: !1,
            GM_unregisterMenuCommand: !1,
            GM_xmlhttpRequest: !1,
            unsafeWindow: !1
        },
        devtools: {
            $: !1,
            $_: !1,
            $$: !1,
            $0: !1,
            $1: !1,
            $2: !1,
            $3: !1,
            $4: !1,
            $x: !1,
            chrome: !1,
            clear: !1,
            copy: !1,
            debug: !1,
            dir: !1,
            dirxml: !1,
            getEventListeners: !1,
            inspect: !1,
            keys: !1,
            monitor: !1,
            monitorEvents: !1,
            profile: !1,
            profileEnd: !1,
            queryObjects: !1,
            table: !1,
            undebug: !1,
            unmonitor: !1,
            unmonitorEvents: !1,
            values: !1
        }
    };
    function Js() {
        return Gs || (Gs = 1, function(e1) {
            e1.exports = Hs;
        }(zs)), Xs;
    }
    function Qs() {
        if (Ws) return Hr;
        Ws = 1, Object.defineProperty(Hr, "__esModule", {
            value: !0
        });
        var e1 = Jr, t = G, r = qs(), n = Js();
        function s(e1) {
            return e1 && "object" == typeof e1 && "default" in e1 ? e1 : {
                default: e1
            };
        }
        var i = s(e1), o = s(t), a = s(r), u = s(n);
        const l = [
            "off",
            "warn",
            "error"
        ], c = l.reduce((e1, t, r)=>(e1[t] = r, e1), {}), p = [
            0,
            1,
            2,
            "off",
            "warn",
            "error"
        ];
        function f(e1) {
            const t = Array.isArray(e1) ? e1[0] : e1;
            return 0 === t || 1 === t || 2 === t ? t : "string" == typeof t && c[t.toLowerCase()] || 0;
        }
        function d(e1) {
            let t = Array.isArray(e1) ? e1[0] : e1;
            return "string" == typeof t && (t = t.toLowerCase()), -1 !== p.indexOf(t);
        }
        function h(e1) {
            switch(e1){
                case "off":
                    return "off";
                case !0:
                case "true":
                case "writeable":
                case "writable":
                    return "writable";
                case null:
                case !1:
                case "false":
                case "readable":
                case "readonly":
                    return "readonly";
                default:
                    throw new Error(`'${e1}' is not a valid configuration for a global (use 'readonly', 'writable', or 'off')`);
            }
        }
        var m = {
            __proto__: null,
            getRuleSeverity: f,
            normalizeToStrings: function(e1) {
                e1.rules && Object.keys(e1.rules).forEach((t)=>{
                    const r = e1.rules[t];
                    "number" == typeof r ? e1.rules[t] = l[r] || l[0] : Array.isArray(r) && "number" == typeof r[0] && (r[0] = l[r[0]] || l[0]);
                });
            },
            isErrorSeverity: function(e1) {
                return 2 === f(e1);
            },
            isValidSeverity: d,
            isEverySeverityValid: function(e1) {
                return Object.keys(e1).every((t)=>d(e1[t]));
            },
            normalizeConfigGlobal: h
        };
        const g = {
            ESLINT_LEGACY_ECMAFEATURES: "The 'ecmaFeatures' config file property is deprecated and has no effect.",
            ESLINT_PERSONAL_CONFIG_LOAD: "'~/.eslintrc.*' config files have been deprecated. Please use a config file per project or the '--config' option.",
            ESLINT_PERSONAL_CONFIG_SUPPRESS: "'~/.eslintrc.*' config files have been deprecated. Please remove it or add 'root:true' to the config files in your projects in order to avoid loading '~/.eslintrc.*' accidentally."
        }, y = new Set;
        const E = {
            id: "http://json-schema.org/draft-04/schema#",
            $schema: "http://json-schema.org/draft-04/schema#",
            description: "Core schema meta-schema",
            definitions: {
                schemaArray: {
                    type: "array",
                    minItems: 1,
                    items: {
                        $ref: "#"
                    }
                },
                positiveInteger: {
                    type: "integer",
                    minimum: 0
                },
                positiveIntegerDefault0: {
                    allOf: [
                        {
                            $ref: "#/definitions/positiveInteger"
                        },
                        {
                            default: 0
                        }
                    ]
                },
                simpleTypes: {
                    enum: [
                        "array",
                        "boolean",
                        "integer",
                        "null",
                        "number",
                        "object",
                        "string"
                    ]
                },
                stringArray: {
                    type: "array",
                    items: {
                        type: "string"
                    },
                    minItems: 1,
                    uniqueItems: !0
                }
            },
            type: "object",
            properties: {
                id: {
                    type: "string"
                },
                $schema: {
                    type: "string"
                },
                title: {
                    type: "string"
                },
                description: {
                    type: "string"
                },
                default: {},
                multipleOf: {
                    type: "number",
                    minimum: 0,
                    exclusiveMinimum: !0
                },
                maximum: {
                    type: "number"
                },
                exclusiveMaximum: {
                    type: "boolean",
                    default: !1
                },
                minimum: {
                    type: "number"
                },
                exclusiveMinimum: {
                    type: "boolean",
                    default: !1
                },
                maxLength: {
                    $ref: "#/definitions/positiveInteger"
                },
                minLength: {
                    $ref: "#/definitions/positiveIntegerDefault0"
                },
                pattern: {
                    type: "string",
                    format: "regex"
                },
                additionalItems: {
                    anyOf: [
                        {
                            type: "boolean"
                        },
                        {
                            $ref: "#"
                        }
                    ],
                    default: {}
                },
                items: {
                    anyOf: [
                        {
                            $ref: "#"
                        },
                        {
                            $ref: "#/definitions/schemaArray"
                        }
                    ],
                    default: {}
                },
                maxItems: {
                    $ref: "#/definitions/positiveInteger"
                },
                minItems: {
                    $ref: "#/definitions/positiveIntegerDefault0"
                },
                uniqueItems: {
                    type: "boolean",
                    default: !1
                },
                maxProperties: {
                    $ref: "#/definitions/positiveInteger"
                },
                minProperties: {
                    $ref: "#/definitions/positiveIntegerDefault0"
                },
                required: {
                    $ref: "#/definitions/stringArray"
                },
                additionalProperties: {
                    anyOf: [
                        {
                            type: "boolean"
                        },
                        {
                            $ref: "#"
                        }
                    ],
                    default: {}
                },
                definitions: {
                    type: "object",
                    additionalProperties: {
                        $ref: "#"
                    },
                    default: {}
                },
                properties: {
                    type: "object",
                    additionalProperties: {
                        $ref: "#"
                    },
                    default: {}
                },
                patternProperties: {
                    type: "object",
                    additionalProperties: {
                        $ref: "#"
                    },
                    default: {}
                },
                dependencies: {
                    type: "object",
                    additionalProperties: {
                        anyOf: [
                            {
                                $ref: "#"
                            },
                            {
                                $ref: "#/definitions/stringArray"
                            }
                        ]
                    }
                },
                enum: {
                    type: "array",
                    minItems: 1,
                    uniqueItems: !0
                },
                type: {
                    anyOf: [
                        {
                            $ref: "#/definitions/simpleTypes"
                        },
                        {
                            type: "array",
                            items: {
                                $ref: "#/definitions/simpleTypes"
                            },
                            minItems: 1,
                            uniqueItems: !0
                        }
                    ]
                },
                format: {
                    type: "string"
                },
                allOf: {
                    $ref: "#/definitions/schemaArray"
                },
                anyOf: {
                    $ref: "#/definitions/schemaArray"
                },
                oneOf: {
                    $ref: "#/definitions/schemaArray"
                },
                not: {
                    $ref: "#"
                }
            },
            dependencies: {
                exclusiveMaximum: [
                    "maximum"
                ],
                exclusiveMinimum: [
                    "minimum"
                ]
            },
            default: {}
        };
        const x = {
            $schema: {
                type: "string"
            },
            env: {
                type: "object"
            },
            extends: {
                $ref: "#/definitions/stringOrStrings"
            },
            globals: {
                type: "object"
            },
            overrides: {
                type: "array",
                items: {
                    $ref: "#/definitions/overrideConfig"
                },
                additionalItems: !1
            },
            parser: {
                type: [
                    "string",
                    "null"
                ]
            },
            parserOptions: {
                type: "object"
            },
            plugins: {
                type: "array"
            },
            processor: {
                type: "string"
            },
            rules: {
                type: "object"
            },
            settings: {
                type: "object"
            },
            noInlineConfig: {
                type: "boolean"
            },
            reportUnusedDisableDirectives: {
                type: "boolean"
            },
            ecmaFeatures: {
                type: "object"
            }
        }, C = {
            definitions: {
                stringOrStrings: {
                    oneOf: [
                        {
                            type: "string"
                        },
                        {
                            type: "array",
                            items: {
                                type: "string"
                            },
                            additionalItems: !1
                        }
                    ]
                },
                stringOrStringsRequired: {
                    oneOf: [
                        {
                            type: "string"
                        },
                        {
                            type: "array",
                            items: {
                                type: "string"
                            },
                            additionalItems: !1,
                            minItems: 1
                        }
                    ]
                },
                objectConfig: {
                    type: "object",
                    properties: {
                        root: {
                            type: "boolean"
                        },
                        ignorePatterns: {
                            $ref: "#/definitions/stringOrStrings"
                        },
                        ...x
                    },
                    additionalProperties: !1
                },
                overrideConfig: {
                    type: "object",
                    properties: {
                        excludedFiles: {
                            $ref: "#/definitions/stringOrStrings"
                        },
                        files: {
                            $ref: "#/definitions/stringOrStringsRequired"
                        },
                        ...x
                    },
                    required: [
                        "files"
                    ],
                    additionalProperties: !1
                }
            },
            $ref: "#/definitions/objectConfig"
        };
        const S = function(e1, t) {
            const r = {};
            for (const [n, s] of Object.entries(e1))Object.hasOwnProperty.call(t, n) || (r[n] = s);
            return r;
        }(u.default.es2015, u.default.es5), b = {
            Atomics: !1,
            SharedArrayBuffer: !1
        }, v = {
            BigInt: !1,
            BigInt64Array: !1,
            BigUint64Array: !1,
            globalThis: !1
        }, A = {
            AggregateError: !1,
            FinalizationRegistry: !1,
            WeakRef: !1
        };
        var T = new Map(Object.entries({
            builtin: {
                globals: u.default.es5
            },
            es6: {
                globals: S,
                parserOptions: {
                    ecmaVersion: 6
                }
            },
            es2015: {
                globals: S,
                parserOptions: {
                    ecmaVersion: 6
                }
            },
            es2016: {
                globals: S,
                parserOptions: {
                    ecmaVersion: 7
                }
            },
            es2017: {
                globals: {
                    ...S,
                    ...b
                },
                parserOptions: {
                    ecmaVersion: 8
                }
            },
            es2018: {
                globals: {
                    ...S,
                    ...b
                },
                parserOptions: {
                    ecmaVersion: 9
                }
            },
            es2019: {
                globals: {
                    ...S,
                    ...b
                },
                parserOptions: {
                    ecmaVersion: 10
                }
            },
            es2020: {
                globals: {
                    ...S,
                    ...b,
                    ...v
                },
                parserOptions: {
                    ecmaVersion: 11
                }
            },
            es2021: {
                globals: {
                    ...S,
                    ...b,
                    ...v,
                    ...A
                },
                parserOptions: {
                    ecmaVersion: 12
                }
            },
            es2022: {
                globals: {
                    ...S,
                    ...b,
                    ...v,
                    ...A
                },
                parserOptions: {
                    ecmaVersion: 13
                }
            },
            es2023: {
                globals: {
                    ...S,
                    ...b,
                    ...v,
                    ...A
                },
                parserOptions: {
                    ecmaVersion: 14
                }
            },
            es2024: {
                globals: {
                    ...S,
                    ...b,
                    ...v,
                    ...A
                },
                parserOptions: {
                    ecmaVersion: 15
                }
            },
            browser: {
                globals: u.default.browser
            },
            node: {
                globals: u.default.node,
                parserOptions: {
                    ecmaFeatures: {
                        globalReturn: !0
                    }
                }
            },
            "shared-node-browser": {
                globals: u.default["shared-node-browser"]
            },
            worker: {
                globals: u.default.worker
            },
            serviceworker: {
                globals: u.default.serviceworker
            },
            commonjs: {
                globals: u.default.commonjs,
                parserOptions: {
                    ecmaFeatures: {
                        globalReturn: !0
                    }
                }
            },
            amd: {
                globals: u.default.amd
            },
            mocha: {
                globals: u.default.mocha
            },
            jasmine: {
                globals: u.default.jasmine
            },
            jest: {
                globals: u.default.jest
            },
            phantomjs: {
                globals: u.default.phantomjs
            },
            jquery: {
                globals: u.default.jquery
            },
            qunit: {
                globals: u.default.qunit
            },
            prototypejs: {
                globals: u.default.prototypejs
            },
            shelljs: {
                globals: u.default.shelljs
            },
            meteor: {
                globals: u.default.meteor
            },
            mongo: {
                globals: u.default.mongo
            },
            protractor: {
                globals: u.default.protractor
            },
            applescript: {
                globals: u.default.applescript
            },
            nashorn: {
                globals: u.default.nashorn
            },
            atomtest: {
                globals: u.default.atomtest
            },
            embertest: {
                globals: u.default.embertest
            },
            webextensions: {
                globals: u.default.webextensions
            },
            greasemonkey: {
                globals: u.default.greasemonkey
            }
        }));
        const R = ((e1 = {})=>{
            const t = new a.default({
                meta: !1,
                useDefaults: !0,
                validateSchema: !1,
                missingRefs: "ignore",
                verbose: !0,
                schemaId: "auto",
                ...e1
            });
            return t.addMetaSchema(E), t._opts.defaultMeta = E.id, t;
        })(), D = new WeakMap, w = Function.prototype;
        let _;
        const k = {
            error: 2,
            warn: 1,
            off: 0
        }, B = new WeakSet;
        const L = /^@.*\//iu;
        var P = {
            __proto__: null,
            normalizePackageName: function(e1, t) {
                let r = e1;
                if (r.includes("\\") && (r = r.replace(/\\/gu, "/")), "@" === r.charAt(0)) {
                    const e1 = new RegExp(`^(@[^/]+)(?:/(?:${t})?)?$`, "u"), n = new RegExp(`^${t}(-|$)`, "u");
                    e1.test(r) ? r = r.replace(e1, `$1/${t}`) : n.test(r.split("/")[1]) || (r = r.replace(/^@([^/]+)\/(.*)$/u, `@$1/${t}-$2`));
                } else r.startsWith(`${t}-`) || (r = `${t}-${r}`);
                return r;
            },
            getShorthandName: function(e1, t) {
                if ("@" === e1[0]) {
                    let r = new RegExp(`^(@[^/]+)/${t}$`, "u").exec(e1);
                    if (r) return r[1];
                    if (r = new RegExp(`^(@[^/]+)/${t}-(.+)$`, "u").exec(e1), r) return `${r[1]}/${r[2]}`;
                } else if (e1.startsWith(`${t}-`)) return e1.slice(t.length + 1);
                return e1;
            },
            getNamespaceFromTerm: function(e1) {
                const t = e1.match(L);
                return t ? t[0] : "";
            }
        };
        const I = {
            environments: T,
            ConfigOps: m,
            ConfigValidator: class {
                constructor({ builtInRules: e1 = new Map } = {}){
                    this.builtInRules = e1;
                }
                getRuleOptionsSchema(e1) {
                    if (!e1) return null;
                    const t = e1.schema || e1.meta && e1.meta.schema;
                    return Array.isArray(t) ? t.length ? {
                        type: "array",
                        items: t,
                        minItems: 0,
                        maxItems: t.length
                    } : {
                        type: "array",
                        minItems: 0,
                        maxItems: 0
                    } : t || null;
                }
                validateRuleSeverity(e1) {
                    const t = Array.isArray(e1) ? e1[0] : e1, r = "string" == typeof t ? k[t.toLowerCase()] : t;
                    if (0 === r || 1 === r || 2 === r) return r;
                    throw new Error(`\tSeverity should be one of the following: 0 = off, 1 = warn, 2 = error (you passed '${i.default.inspect(t).replace(/'/gu, '"').replace(/\n/gu, "")}').\n`);
                }
                validateRuleSchema(e1, t) {
                    if (!D.has(e1)) {
                        const t = this.getRuleOptionsSchema(e1);
                        t && D.set(e1, R.compile(t));
                    }
                    const r = D.get(e1);
                    if (r && (r(t), r.errors)) throw new Error(r.errors.map((e1)=>`\tValue ${JSON.stringify(e1.data)} ${e1.message}.\n`).join(""));
                }
                validateRuleOptions(e1, t, r, n = null) {
                    try {
                        0 !== this.validateRuleSeverity(r) && this.validateRuleSchema(e1, Array.isArray(r) ? r.slice(1) : []);
                    } catch (e1) {
                        const r = `Configuration for rule "${t}" is invalid:\n${e1.message}`;
                        throw "string" == typeof n ? new Error(`${n}:\n\t${r}`) : new Error(r);
                    }
                }
                validateEnvironment(e1, t, r = w) {
                    e1 && Object.keys(e1).forEach((e1)=>{
                        if (!(r(e1) || T.get(e1) || null)) throw new Error(`${t}:\n\tEnvironment key "${e1}" is unknown\n`);
                    });
                }
                validateRules(e1, t, r = w) {
                    e1 && Object.keys(e1).forEach((n)=>{
                        const s = r(n) || this.builtInRules.get(n) || null;
                        this.validateRuleOptions(s, n, e1[n], t);
                    });
                }
                validateGlobals(e1, t = null) {
                    e1 && Object.entries(e1).forEach(([e1, r])=>{
                        try {
                            h(r);
                        } catch (r) {
                            throw new Error(`ESLint configuration of global '${e1}' in ${t} is invalid:\n${r.message}`);
                        }
                    });
                }
                validateProcessor(e1, t, r) {
                    if (e1 && !r(e1)) throw new Error(`ESLint configuration of processor in '${t}' is invalid: '${e1}' was not found.`);
                }
                formatErrors(e1) {
                    return e1.map((e1)=>{
                        if ("additionalProperties" === e1.keyword) return `Unexpected top-level property "${e1.dataPath.length ? `${e1.dataPath.slice(1)}.${e1.params.additionalProperty}` : e1.params.additionalProperty}"`;
                        if ("type" === e1.keyword) return `Property "${e1.dataPath.slice(1)}" is the wrong type (expected ${Array.isArray(e1.schema) ? e1.schema.join("/") : e1.schema} but got \`${JSON.stringify(e1.data)}\`)`;
                        return `"${"." === e1.dataPath[0] ? e1.dataPath.slice(1) : e1.dataPath}" ${e1.message}. Value: ${JSON.stringify(e1.data)}`;
                    }).map((e1)=>`\t- ${e1}.\n`).join("");
                }
                validateConfigSchema(e1, t = null) {
                    if (_ = _ || R.compile(C), !_(e1)) throw new Error(`ESLint configuration in ${t} is invalid:\n${this.formatErrors(_.errors)}`);
                    Object.hasOwnProperty.call(e1, "ecmaFeatures") && function(e1, t) {
                        const r = JSON.stringify({
                            source: e1,
                            errorCode: t
                        });
                        if (y.has(r)) return;
                        y.add(r);
                        const n = o.default.relative($391299e0893a3dfa$exports.cwd(), e1), s = g[t];
                        $391299e0893a3dfa$exports.emitWarning(`${s} (found in "${n}")`, "DeprecationWarning", t);
                    }(t, "ESLINT_LEGACY_ECMAFEATURES");
                }
                validate(e1, t, r, n) {
                    this.validateConfigSchema(e1, t), this.validateRules(e1.rules, t, r), this.validateEnvironment(e1.env, t, n), this.validateGlobals(e1.globals, t);
                    for (const s of e1.overrides || [])this.validateRules(s.rules, t, r), this.validateEnvironment(s.env, t, n), this.validateGlobals(e1.globals, t);
                }
                validateConfigArray(e1) {
                    const t = Map.prototype.get.bind(e1.pluginEnvironments), r = Map.prototype.get.bind(e1.pluginProcessors), n = Map.prototype.get.bind(e1.pluginRules);
                    for (const s of e1)B.has(s) || (B.add(s), this.validateEnvironment(s.env, s.name, t), this.validateGlobals(s.globals, s.name), this.validateProcessor(s.processor, s.name, r), this.validateRules(s.rules, s.name, n));
                }
            },
            naming: P
        };
        return Hr.Legacy = I, Hr;
    }
    var Ys, Zs, ei, ti, ri, ni = {}, si = {
        get exports () {
            return ni;
        },
        set exports (e){
            ni = e;
        }
    }, ii = {}, oi = {
        get exports () {
            return ii;
        },
        set exports (e){
            ii = e;
        }
    };
    function ai() {
        if (Zs) return Ys;
        Zs = 1;
        var e1 = 1e3, t = 60 * e1, r = 60 * t, n = 24 * r, s = 7 * n, i = 365.25 * n;
        function o(e1, t, r, n) {
            var s = t >= 1.5 * r;
            return Math.round(e1 / r) + " " + n + (s ? "s" : "");
        }
        return Ys = function(a, u) {
            u = u || {};
            var l = typeof a;
            if ("string" === l && a.length > 0) return function(o) {
                if ((o = String(o)).length > 100) return;
                var a = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(o);
                if (!a) return;
                var u = parseFloat(a[1]);
                switch((a[2] || "ms").toLowerCase()){
                    case "years":
                    case "year":
                    case "yrs":
                    case "yr":
                    case "y":
                        return u * i;
                    case "weeks":
                    case "week":
                    case "w":
                        return u * s;
                    case "days":
                    case "day":
                    case "d":
                        return u * n;
                    case "hours":
                    case "hour":
                    case "hrs":
                    case "hr":
                    case "h":
                        return u * r;
                    case "minutes":
                    case "minute":
                    case "mins":
                    case "min":
                    case "m":
                        return u * t;
                    case "seconds":
                    case "second":
                    case "secs":
                    case "sec":
                    case "s":
                        return u * e1;
                    case "milliseconds":
                    case "millisecond":
                    case "msecs":
                    case "msec":
                    case "ms":
                        return u;
                    default:
                        return;
                }
            }(a);
            if ("number" === l && isFinite(a)) return u.long ? function(s) {
                var i = Math.abs(s);
                if (i >= n) return o(s, i, n, "day");
                if (i >= r) return o(s, i, r, "hour");
                if (i >= t) return o(s, i, t, "minute");
                if (i >= e1) return o(s, i, e1, "second");
                return s + " ms";
            }(a) : function(s) {
                var i = Math.abs(s);
                if (i >= n) return Math.round(s / n) + "d";
                if (i >= r) return Math.round(s / r) + "h";
                if (i >= t) return Math.round(s / t) + "m";
                if (i >= e1) return Math.round(s / e1) + "s";
                return s + "ms";
            }(a);
            throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(a));
        }, Ys;
    }
    function ui() {
        if (ti) return ei;
        return ti = 1, ei = function(e1) {
            function t(e1) {
                let n, s, i, o = null;
                function a(...e1) {
                    if (!a.enabled) return;
                    const r = a, s = Number(new Date), i = s - (n || s);
                    r.diff = i, r.prev = n, r.curr = s, n = s, e1[0] = t.coerce(e1[0]), "string" != typeof e1[0] && e1.unshift("%O");
                    let o = 0;
                    e1[0] = e1[0].replace(/%([a-zA-Z%])/g, (n, s)=>{
                        if ("%%" === n) return "%";
                        o++;
                        const i = t.formatters[s];
                        if ("function" == typeof i) {
                            const t = e1[o];
                            n = i.call(r, t), e1.splice(o, 1), o--;
                        }
                        return n;
                    }), t.formatArgs.call(r, e1);
                    (r.log || t.log).apply(r, e1);
                }
                return a.namespace = e1, a.useColors = t.useColors(), a.color = t.selectColor(e1), a.extend = r, a.destroy = t.destroy, Object.defineProperty(a, "enabled", {
                    enumerable: !0,
                    configurable: !1,
                    get: ()=>null !== o ? o : (s !== t.namespaces && (s = t.namespaces, i = t.enabled(e1)), i),
                    set: (e1)=>{
                        o = e1;
                    }
                }), "function" == typeof t.init && t.init(a), a;
            }
            function r(e1, r) {
                const n = t(this.namespace + (void 0 === r ? ":" : r) + e1);
                return n.log = this.log, n;
            }
            function n(e1, t) {
                let r = 0, n = 0, s = -1, i = 0;
                for(; r < e1.length;)if (n < t.length && (t[n] === e1[r] || "*" === t[n])) "*" === t[n] ? (s = n, i = r, n++) : (r++, n++);
                else {
                    if (-1 === s) return !1;
                    n = s + 1, i++, r = i;
                }
                for(; n < t.length && "*" === t[n];)n++;
                return n === t.length;
            }
            return t.debug = t, t.default = t, t.coerce = function(e1) {
                if (e1 instanceof Error) return e1.stack || e1.message;
                return e1;
            }, t.disable = function() {
                const e1 = [
                    ...t.names,
                    ...t.skips.map((e1)=>"-" + e1)
                ].join(",");
                return t.enable(""), e1;
            }, t.enable = function(e1) {
                t.save(e1), t.namespaces = e1, t.names = [], t.skips = [];
                const r = ("string" == typeof e1 ? e1 : "").trim().replace(/\s+/g, ",").split(",").filter(Boolean);
                for (const e1 of r)"-" === e1[0] ? t.skips.push(e1.slice(1)) : t.names.push(e1);
            }, t.enabled = function(e1) {
                for (const r of t.skips)if (n(e1, r)) return !1;
                for (const r of t.names)if (n(e1, r)) return !0;
                return !1;
            }, t.humanize = ai(), t.destroy = function() {
                console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
            }, Object.keys(e1).forEach((r)=>{
                t[r] = e1[r];
            }), t.names = [], t.skips = [], t.formatters = {}, t.selectColor = function(e1) {
                let r = 0;
                for(let t = 0; t < e1.length; t++)r = (r << 5) - r + e1.charCodeAt(t), r |= 0;
                return t.colors[Math.abs(r) % t.colors.length];
            }, t.enable(t.load()), t;
        }, ei;
    }
    var li = {}, ci = {
        get exports () {
            return li;
        },
        set exports (e){
            li = e;
        }
    };
    function pi() {
        return !1;
    }
    function fi() {
        throw new Error("tty.ReadStream is not implemented");
    }
    function di() {
        throw new Error("tty.ReadStream is not implemented");
    }
    var hi, mi = {
        isatty: pi,
        ReadStream: fi,
        WriteStream: di
    }, gi = t(Object.freeze({
        __proto__: null,
        ReadStream: fi,
        WriteStream: di,
        default: mi,
        isatty: pi
    }));
    function yi() {
        if (void 0 === hi) {
            var e1 = new ArrayBuffer(2), t = new Uint8Array(e1), r = new Uint16Array(e1);
            if (t[0] = 1, t[1] = 2, 258 === r[0]) hi = "BE";
            else {
                if (513 !== r[0]) throw new Error("unable to figure out endianess");
                hi = "LE";
            }
        }
        return hi;
    }
    function Ei() {
        return void 0 !== o.location ? o.location.hostname : "";
    }
    function xi() {
        return [];
    }
    function Ci() {
        return 0;
    }
    function Si() {
        return Number.MAX_VALUE;
    }
    function bi() {
        return Number.MAX_VALUE;
    }
    function vi() {
        return [];
    }
    function Ai() {
        return "Browser";
    }
    function Ti() {
        return void 0 !== o.navigator ? o.navigator.appVersion : "";
    }
    function Ri() {
        return {};
    }
    function Di() {
        return {};
    }
    function wi() {
        return "javascript";
    }
    function _i() {
        return "browser";
    }
    function ki() {
        return "/tmp";
    }
    var Bi = ki;
    function Li() {
        return "$HOME";
    }
    var Pi, Ii, Fi, Ni, Oi, Ui, ji, Vi, Ki = {
        homedir: Li,
        EOL: "\n",
        arch: wi,
        platform: _i,
        tmpdir: Bi,
        tmpDir: ki,
        networkInterfaces: Ri,
        getNetworkInterfaces: Di,
        release: Ti,
        type: Ai,
        cpus: vi,
        totalmem: bi,
        freemem: Si,
        uptime: Ci,
        loadavg: xi,
        hostname: Ei,
        endianness: yi
    }, Mi = t(Object.freeze({
        __proto__: null,
        EOL: "\n",
        arch: wi,
        cpus: vi,
        default: Ki,
        endianness: yi,
        freemem: Si,
        getNetworkInterfaces: Di,
        homedir: Li,
        hostname: Ei,
        loadavg: xi,
        networkInterfaces: Ri,
        platform: _i,
        release: Ti,
        tmpDir: ki,
        tmpdir: Bi,
        totalmem: bi,
        type: Ai,
        uptime: Ci
    }));
    function $i() {
        return Ii || (Ii = 1, Pi = (e1, t = $391299e0893a3dfa$exports.argv)=>{
            const r = e1.startsWith("-") ? "" : 1 === e1.length ? "-" : "--", n = t.indexOf(r + e1), s = t.indexOf("--");
            return -1 !== n && (-1 === s || n < s);
        }), Pi;
    }
    function qi() {
        return Oi || (Oi = 1, function(e1, t) {
            const r = gi, n = Jr;
            t.init = function(e1) {
                e1.inspectOpts = {};
                const r = Object.keys(t.inspectOpts);
                for(let n = 0; n < r.length; n++)e1.inspectOpts[r[n]] = t.inspectOpts[r[n]];
            }, t.log = function(...e1) {
                return $391299e0893a3dfa$exports.stderr.write(n.formatWithOptions(t.inspectOpts, ...e1) + "\n");
            }, t.formatArgs = function(r) {
                const { namespace: n, useColors: s } = this;
                if (s) {
                    const t = this.color, s = "[3" + (t < 8 ? t : "8;5;" + t), i = `  ${s};1m${n} [0m`;
                    r[0] = i + r[0].split("\n").join("\n" + i), r.push(s + "m+" + e1.exports.humanize(this.diff) + "[0m");
                } else r[0] = function() {
                    if (t.inspectOpts.hideDate) return "";
                    return (new Date).toISOString() + " ";
                }() + n + " " + r[0];
            }, t.save = function(e1) {}, t.load = function() {
                return undefined;
            }, t.useColors = function() {
                return "colors" in t.inspectOpts ? Boolean(t.inspectOpts.colors) : r.isatty($391299e0893a3dfa$exports.stderr.fd);
            }, t.destroy = n.deprecate(()=>{}, "Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."), t.colors = [
                6,
                2,
                3,
                4,
                5,
                1
            ];
            try {
                const e1 = function() {
                    if (Ni) return Fi;
                    Ni = 1;
                    const e1 = Mi, t = gi, r = $i(), { env: n } = $391299e0893a3dfa$exports;
                    let s;
                    function i(e1) {
                        return 0 !== e1 && {
                            level: e1,
                            hasBasic: !0,
                            has256: e1 >= 2,
                            has16m: e1 >= 3
                        };
                    }
                    function o(t, i) {
                        if (0 === s) return 0;
                        if (r("color=16m") || r("color=full") || r("color=truecolor")) return 3;
                        if (r("color=256")) return 2;
                        if (t && !i && void 0 === s) return 0;
                        const o = s || 0;
                        if ("dumb" === n.TERM) return o;
                        if ("win32" === $391299e0893a3dfa$exports.platform) {
                            const t = e1.release().split(".");
                            return Number(t[0]) >= 10 && Number(t[2]) >= 10586 ? Number(t[2]) >= 14931 ? 3 : 2 : 1;
                        }
                        if ("CI" in n) return [
                            "TRAVIS",
                            "CIRCLECI",
                            "APPVEYOR",
                            "GITLAB_CI",
                            "GITHUB_ACTIONS",
                            "BUILDKITE"
                        ].some((e1)=>e1 in n) || "codeship" === n.CI_NAME ? 1 : o;
                        if ("TEAMCITY_VERSION" in n) return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(n.TEAMCITY_VERSION) ? 1 : 0;
                        if ("truecolor" === n.COLORTERM) return 3;
                        if ("TERM_PROGRAM" in n) {
                            const e1 = parseInt((n.TERM_PROGRAM_VERSION || "").split(".")[0], 10);
                            switch(n.TERM_PROGRAM){
                                case "iTerm.app":
                                    return e1 >= 3 ? 3 : 2;
                                case "Apple_Terminal":
                                    return 2;
                            }
                        }
                        return /-256(color)?$/i.test(n.TERM) ? 2 : /^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(n.TERM) || "COLORTERM" in n ? 1 : o;
                    }
                    return r("no-color") || r("no-colors") || r("color=false") || r("color=never") ? s = 0 : (r("color") || r("colors") || r("color=true") || r("color=always")) && (s = 1), "FORCE_COLOR" in n && (s = "true" === n.FORCE_COLOR ? 1 : "false" === n.FORCE_COLOR ? 0 : 0 === n.FORCE_COLOR.length ? 1 : Math.min(parseInt(n.FORCE_COLOR, 10), 3)), Fi = {
                        supportsColor: function(e1) {
                            return i(o(e1, e1 && e1.isTTY));
                        },
                        stdout: i(o(!0, t.isatty(1))),
                        stderr: i(o(!0, t.isatty(2)))
                    };
                }();
                e1 && (e1.stderr || e1).level >= 2 && (t.colors = [
                    20,
                    21,
                    26,
                    27,
                    32,
                    33,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    56,
                    57,
                    62,
                    63,
                    68,
                    69,
                    74,
                    75,
                    76,
                    77,
                    78,
                    79,
                    80,
                    81,
                    92,
                    93,
                    98,
                    99,
                    112,
                    113,
                    128,
                    129,
                    134,
                    135,
                    148,
                    149,
                    160,
                    161,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    171,
                    172,
                    173,
                    178,
                    179,
                    184,
                    185,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    203,
                    204,
                    205,
                    206,
                    207,
                    208,
                    209,
                    214,
                    215,
                    220,
                    221
                ]);
            } catch (e1) {}
            t.inspectOpts = Object.keys($391299e0893a3dfa$exports.env).filter((e1)=>/^debug_/i.test(e1)).reduce((e1, t)=>{
                const r = t.substring(6).toLowerCase().replace(/_([a-z])/g, (e1, t)=>t.toUpperCase());
                let n = $391299e0893a3dfa$exports.env[t];
                return n = !!/^(yes|on|true|enabled)$/i.test(n) || !/^(no|off|false|disabled)$/i.test(n) && ("null" === n ? null : Number(n)), e1[r] = n, e1;
            }, {}), e1.exports = ui()(t);
            const { formatters: s } = e1.exports;
            s.o = function(e1) {
                return this.inspectOpts.colors = this.useColors, n.inspect(e1, this.inspectOpts).split("\n").map((e1)=>e1.trim()).join(" ");
            }, s.O = function(e1) {
                return this.inspectOpts.colors = this.useColors, n.inspect(e1, this.inspectOpts);
            };
        }(ci, li)), li;
    }
    function Gi() {
        return Ui || (Ui = 1, function(e1) {
            e1.exports = (ri || (ri = 1, function(e1, t) {
                t.formatArgs = function(t) {
                    if (t[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + t[0] + (this.useColors ? "%c " : " ") + "+" + e1.exports.humanize(this.diff), !this.useColors) return;
                    const r = "color: " + this.color;
                    t.splice(1, 0, r, "color: inherit");
                    let n = 0, s = 0;
                    t[0].replace(/%[a-zA-Z%]/g, (e1)=>{
                        "%%" !== e1 && (n++, "%c" === e1 && (s = n));
                    }), t.splice(s, 0, r);
                }, t.save = function(e1) {
                    try {
                        e1 ? t.storage.setItem("debug", e1) : t.storage.removeItem("debug");
                    } catch (e1) {}
                }, t.load = function() {
                    let e1;
                    try {
                        e1 = t.storage.getItem("debug") || t.storage.getItem("DEBUG");
                    } catch (e1) {}
                    return e1, e1;
                }, t.useColors = function() {
                    if ("undefined" != typeof window && window.process && ("renderer" === window.process.type || window.process.__nwjs)) return !0;
                    if ("undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return !1;
                    let e1;
                    return "undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && (e1 = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(e1[1], 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
                }, t.storage = function() {
                    try {
                        return localStorage;
                    } catch (e1) {}
                }(), t.destroy = (()=>{
                    let e1 = !1;
                    return ()=>{
                        e1 || (e1 = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
                    };
                })(), t.colors = [
                    "#0000CC",
                    "#0000FF",
                    "#0033CC",
                    "#0033FF",
                    "#0066CC",
                    "#0066FF",
                    "#0099CC",
                    "#0099FF",
                    "#00CC00",
                    "#00CC33",
                    "#00CC66",
                    "#00CC99",
                    "#00CCCC",
                    "#00CCFF",
                    "#3300CC",
                    "#3300FF",
                    "#3333CC",
                    "#3333FF",
                    "#3366CC",
                    "#3366FF",
                    "#3399CC",
                    "#3399FF",
                    "#33CC00",
                    "#33CC33",
                    "#33CC66",
                    "#33CC99",
                    "#33CCCC",
                    "#33CCFF",
                    "#6600CC",
                    "#6600FF",
                    "#6633CC",
                    "#6633FF",
                    "#66CC00",
                    "#66CC33",
                    "#9900CC",
                    "#9900FF",
                    "#9933CC",
                    "#9933FF",
                    "#99CC00",
                    "#99CC33",
                    "#CC0000",
                    "#CC0033",
                    "#CC0066",
                    "#CC0099",
                    "#CC00CC",
                    "#CC00FF",
                    "#CC3300",
                    "#CC3333",
                    "#CC3366",
                    "#CC3399",
                    "#CC33CC",
                    "#CC33FF",
                    "#CC6600",
                    "#CC6633",
                    "#CC9900",
                    "#CC9933",
                    "#CCCC00",
                    "#CCCC33",
                    "#FF0000",
                    "#FF0033",
                    "#FF0066",
                    "#FF0099",
                    "#FF00CC",
                    "#FF00FF",
                    "#FF3300",
                    "#FF3333",
                    "#FF3366",
                    "#FF3399",
                    "#FF33CC",
                    "#FF33FF",
                    "#FF6600",
                    "#FF6633",
                    "#FF9900",
                    "#FF9933",
                    "#FFCC00",
                    "#FFCC33"
                ], t.log = console.debug || console.log || (()=>{}), e1.exports = ui()(t);
                const { formatters: r } = e1.exports;
                r.j = function(e1) {
                    try {
                        return JSON.stringify(e1);
                    } catch (e1) {
                        return "[UnexpectedJSONParseError]: " + e1.message;
                    }
                };
            }(oi, ii)), ii);
        }(si)), ni;
    }
    function Wi() {
        if (Vi) return ji;
        Vi = 1;
        const e1 = gr(), t = Gi()("eslint:traverser");
        function r() {}
        class n {
            constructor(){
                this._current = null, this._parents = [], this._skipped = !1, this._broken = !1, this._visitorKeys = null, this._enter = null, this._leave = null;
            }
            current() {
                return this._current;
            }
            parents() {
                return this._parents.slice(0);
            }
            break() {
                this._broken = !0;
            }
            skip() {
                this._skipped = !0;
            }
            traverse(t, n) {
                this._current = null, this._parents = [], this._skipped = !1, this._broken = !1, this._visitorKeys = n.visitorKeys || e1.KEYS, this._enter = n.enter || r, this._leave = n.leave || r, this._traverse(t, null);
            }
            _traverse(r, n) {
                if (function(e1) {
                    return null !== e1 && "object" == typeof e1 && "string" == typeof e1.type;
                }(r)) {
                    if (this._current = r, this._skipped = !1, this._enter(r, n), !this._skipped && !this._broken) {
                        const n = function(r, n) {
                            let s = r[n.type];
                            return s || (s = e1.getKeys(n), t('Unknown node type "%s": Estimated visitor keys %j', n.type, s)), s;
                        }(this._visitorKeys, r);
                        if (n.length >= 1) {
                            this._parents.push(r);
                            for(let e1 = 0; e1 < n.length && !this._broken; ++e1){
                                const t = r[n[e1]];
                                if (Array.isArray(t)) for(let e1 = 0; e1 < t.length && !this._broken; ++e1)this._traverse(t[e1], r);
                                else this._traverse(t, r);
                            }
                            this._parents.pop();
                        }
                    }
                    this._broken || this._leave(r, n), this._current = n;
                }
            }
            static getKeys(t) {
                return e1.getKeys(t);
            }
            static traverse(e1, t) {
                (new n).traverse(e1, t);
            }
            static get DEFAULT_VISITOR_KEYS() {
                return e1.KEYS;
            }
        }
        return ji = n;
    }
    var Xi, zi = {};
    function Hi() {
        return Xi || (Xi = 1, function(e1) {
            Object.defineProperty(e1, "__esModule", {
                value: !0
            });
            var t = gr();
            function r(e1, t) {
                const r = t.range[0];
                let n = e1, s = !1;
                do {
                    s = !1;
                    for (const e1 of n.childScopes){
                        const t = e1.block.range;
                        if (t[0] <= r && r < t[1]) {
                            n = e1, s = !0;
                            break;
                        }
                    }
                }while (s);
                return n;
            }
            function n(e1, t) {
                let n = "", s = e1;
                for("string" == typeof t ? n = t : (n = t.name, s = r(s, t)); null != s;){
                    const e1 = s.set.get(n);
                    if (null != e1) return e1;
                    s = s.upper;
                }
                return null;
            }
            function s(e1) {
                return (t)=>!e1(t);
            }
            function i(e1, t) {
                return "Punctuator" === e1.type && e1.value === t;
            }
            function a(e1) {
                return i(e1, "=>");
            }
            function u(e1) {
                return i(e1, ",");
            }
            function l(e1) {
                return i(e1, ";");
            }
            function c(e1) {
                return i(e1, ":");
            }
            function p(e1) {
                return i(e1, "(");
            }
            function f(e1) {
                return i(e1, ")");
            }
            function d(e1) {
                return i(e1, "[");
            }
            function h(e1) {
                return i(e1, "]");
            }
            function m(e1) {
                return i(e1, "{");
            }
            function g(e1) {
                return i(e1, "}");
            }
            function y(e1) {
                return [
                    "Block",
                    "Line",
                    "Shebang"
                ].includes(e1.type);
            }
            const E = s(a), x = s(u), C = s(l), S = s(c), b = s(p), v = s(f), A = s(d), T = s(h), R = s(m), D = s(g), w = s(y);
            function _(e1, t) {
                return e1.id ? t.getTokenAfter(e1.id, p) : t.getFirstToken(e1, p);
            }
            function k(e1, t) {
                const r = e1.parent;
                let n = null, s = null;
                if ("ArrowFunctionExpression" === e1.type) {
                    const r = t.getTokenBefore(e1.body, a);
                    n = r.loc.start, s = r.loc.end;
                } else "Property" === r.type || "MethodDefinition" === r.type || "PropertyDefinition" === r.type ? (n = r.loc.start, s = _(e1, t).loc.start) : (n = e1.loc.start, s = _(e1, t).loc.start);
                return {
                    start: {
                        ...n
                    },
                    end: {
                        ...s
                    }
                };
            }
            const B = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== o ? o : {}, L = Object.freeze(new Set([
                "Array",
                "ArrayBuffer",
                "BigInt",
                "BigInt64Array",
                "BigUint64Array",
                "Boolean",
                "DataView",
                "Date",
                "decodeURI",
                "decodeURIComponent",
                "encodeURI",
                "encodeURIComponent",
                "escape",
                "Float32Array",
                "Float64Array",
                "Function",
                "Infinity",
                "Int16Array",
                "Int32Array",
                "Int8Array",
                "isFinite",
                "isNaN",
                "isPrototypeOf",
                "JSON",
                "Map",
                "Math",
                "NaN",
                "Number",
                "Object",
                "parseFloat",
                "parseInt",
                "Promise",
                "Proxy",
                "Reflect",
                "RegExp",
                "Set",
                "String",
                "Symbol",
                "Uint16Array",
                "Uint32Array",
                "Uint8Array",
                "Uint8ClampedArray",
                "undefined",
                "unescape",
                "WeakMap",
                "WeakSet"
            ])), P = new Set([
                Array.isArray,
                Array.of,
                Array.prototype.at,
                Array.prototype.concat,
                Array.prototype.entries,
                Array.prototype.every,
                Array.prototype.filter,
                Array.prototype.find,
                Array.prototype.findIndex,
                Array.prototype.flat,
                Array.prototype.includes,
                Array.prototype.indexOf,
                Array.prototype.join,
                Array.prototype.keys,
                Array.prototype.lastIndexOf,
                Array.prototype.slice,
                Array.prototype.some,
                Array.prototype.toString,
                Array.prototype.values,
                "function" == typeof BigInt ? BigInt : void 0,
                Boolean,
                Date,
                Date.parse,
                decodeURI,
                decodeURIComponent,
                encodeURI,
                encodeURIComponent,
                escape,
                isFinite,
                isNaN,
                isPrototypeOf,
                Map,
                Map.prototype.entries,
                Map.prototype.get,
                Map.prototype.has,
                Map.prototype.keys,
                Map.prototype.values,
                ...Object.getOwnPropertyNames(Math).filter((e1)=>"random" !== e1).map((e1)=>Math[e1]).filter((e1)=>"function" == typeof e1),
                Number,
                Number.isFinite,
                Number.isNaN,
                Number.parseFloat,
                Number.parseInt,
                Number.prototype.toExponential,
                Number.prototype.toFixed,
                Number.prototype.toPrecision,
                Number.prototype.toString,
                Object,
                Object.entries,
                Object.is,
                Object.isExtensible,
                Object.isFrozen,
                Object.isSealed,
                Object.keys,
                Object.values,
                parseFloat,
                parseInt,
                RegExp,
                Set,
                Set.prototype.entries,
                Set.prototype.has,
                Set.prototype.keys,
                Set.prototype.values,
                String,
                String.fromCharCode,
                String.fromCodePoint,
                String.raw,
                String.prototype.at,
                String.prototype.charAt,
                String.prototype.charCodeAt,
                String.prototype.codePointAt,
                String.prototype.concat,
                String.prototype.endsWith,
                String.prototype.includes,
                String.prototype.indexOf,
                String.prototype.lastIndexOf,
                String.prototype.normalize,
                String.prototype.padEnd,
                String.prototype.padStart,
                String.prototype.slice,
                String.prototype.startsWith,
                String.prototype.substr,
                String.prototype.substring,
                String.prototype.toLowerCase,
                String.prototype.toString,
                String.prototype.toUpperCase,
                String.prototype.trim,
                String.prototype.trimEnd,
                String.prototype.trimLeft,
                String.prototype.trimRight,
                String.prototype.trimStart,
                Symbol.for,
                Symbol.keyFor,
                unescape
            ].filter((e1)=>"function" == typeof e1)), I = new Set([
                Object.freeze,
                Object.preventExtensions,
                Object.seal
            ]), F = [
                [
                    Map,
                    new Set([
                        "size"
                    ])
                ],
                [
                    RegExp,
                    new Set([
                        "dotAll",
                        "flags",
                        "global",
                        "hasIndices",
                        "ignoreCase",
                        "multiline",
                        "source",
                        "sticky",
                        "unicode"
                    ])
                ],
                [
                    Set,
                    new Set([
                        "size"
                    ])
                ]
            ];
            function N(e1, t) {
                const r = function(e1, t) {
                    let r = e1;
                    for(; ("object" == typeof r || "function" == typeof r) && null !== r;){
                        const e1 = Object.getOwnPropertyDescriptor(r, t);
                        if (e1) return e1;
                        r = Object.getPrototypeOf(r);
                    }
                    return null;
                }(e1, t);
                return null != r && null != r.get;
            }
            function O(e1, t) {
                const r = [];
                for(let n = 0; n < e1.length; ++n){
                    const s = e1[n];
                    if (null == s) r.length = n + 1;
                    else if ("SpreadElement" === s.type) {
                        const e1 = j(s.argument, t);
                        if (null == e1) return null;
                        r.push(...e1.value);
                    } else {
                        const e1 = j(s, t);
                        if (null == e1) return null;
                        r.push(e1.value);
                    }
                }
                return r;
            }
            const U = Object.freeze({
                ArrayExpression (e1, t) {
                    const r = O(e1.elements, t);
                    return null != r ? {
                        value: r
                    } : null;
                },
                AssignmentExpression: (e1, t)=>"=" === e1.operator ? j(e1.right, t) : null,
                BinaryExpression (e1, t) {
                    if ("in" === e1.operator || "instanceof" === e1.operator) return null;
                    const r = j(e1.left, t), n = j(e1.right, t);
                    if (null != r && null != n) switch(e1.operator){
                        case "==":
                            return {
                                value: r.value == n.value
                            };
                        case "!=":
                            return {
                                value: r.value != n.value
                            };
                        case "===":
                            return {
                                value: r.value === n.value
                            };
                        case "!==":
                            return {
                                value: r.value !== n.value
                            };
                        case "<":
                            return {
                                value: r.value < n.value
                            };
                        case "<=":
                            return {
                                value: r.value <= n.value
                            };
                        case ">":
                            return {
                                value: r.value > n.value
                            };
                        case ">=":
                            return {
                                value: r.value >= n.value
                            };
                        case "<<":
                            return {
                                value: r.value << n.value
                            };
                        case ">>":
                            return {
                                value: r.value >> n.value
                            };
                        case ">>>":
                            return {
                                value: r.value >>> n.value
                            };
                        case "+":
                            return {
                                value: r.value + n.value
                            };
                        case "-":
                            return {
                                value: r.value - n.value
                            };
                        case "*":
                            return {
                                value: r.value * n.value
                            };
                        case "/":
                            return {
                                value: r.value / n.value
                            };
                        case "%":
                            return {
                                value: r.value % n.value
                            };
                        case "**":
                            return {
                                value: r.value ** n.value
                            };
                        case "|":
                            return {
                                value: r.value | n.value
                            };
                        case "^":
                            return {
                                value: r.value ^ n.value
                            };
                        case "&":
                            return {
                                value: r.value & n.value
                            };
                    }
                    return null;
                },
                CallExpression (e1, t) {
                    const r = e1.callee, n = O(e1.arguments, t);
                    if (null != n) {
                        if ("MemberExpression" === r.type) {
                            if ("PrivateIdentifier" === r.property.type) return null;
                            const s = j(r.object, t);
                            if (null != s) {
                                if (null == s.value && (s.optional || e1.optional)) return {
                                    value: void 0,
                                    optional: !0
                                };
                                const i = V(r, t);
                                if (null != i) {
                                    const e1 = s.value, t = i.value;
                                    if (P.has(e1[t])) return {
                                        value: e1[t](...n)
                                    };
                                    if (I.has(e1[t])) return {
                                        value: n[0]
                                    };
                                }
                            }
                        } else {
                            const s = j(r, t);
                            if (null != s) {
                                if (null == s.value && e1.optional) return {
                                    value: void 0,
                                    optional: !0
                                };
                                const t = s.value;
                                if (P.has(t)) return {
                                    value: t(...n)
                                };
                                if (I.has(t)) return {
                                    value: n[0]
                                };
                            }
                        }
                    }
                    return null;
                },
                ConditionalExpression (e1, t) {
                    const r = j(e1.test, t);
                    return null != r ? r.value ? j(e1.consequent, t) : j(e1.alternate, t) : null;
                },
                ExpressionStatement: (e1, t)=>j(e1.expression, t),
                Identifier (e1, t) {
                    if (null != t) {
                        const r = n(t, e1);
                        if (null != r) {
                            if (function(e1) {
                                return null != e1 && 0 === e1.defs.length && L.has(e1.name) && e1.name in B;
                            }(r)) return {
                                value: B[r.name]
                            };
                            if (function(e1) {
                                if (1 !== e1.defs.length) return !1;
                                const t = e1.defs[0];
                                return Boolean(t.parent && "Variable" === t.type && ("const" === t.parent.kind || function(e1) {
                                    const t = e1.references, r = t.filter((e1)=>e1.init).length, n = t.filter((e1)=>e1.isReadOnly()).length;
                                    return 1 === r && n + r === t.length;
                                }(e1)));
                            }(r)) {
                                const e1 = r.defs[0];
                                if ("Identifier" === e1.node.id.type) {
                                    const n = j(e1.node.init, t);
                                    return n && "object" == typeof n.value && null !== n.value && function(e1, t) {
                                        for (const n of e1.references){
                                            let e1 = n.identifier;
                                            for(; e1 && e1.parent && "MemberExpression" === e1.parent.type;)e1 = e1.parent;
                                            if (e1 && e1.parent) {
                                                if ("AssignmentExpression" === e1.parent.type && e1.parent.left === e1 || "UpdateExpression" === e1.parent.type && e1.parent.argument === e1) return !0;
                                                if ("CallExpression" === e1.parent.type && e1.parent.callee === e1 && "MemberExpression" === e1.type && r(V(e1, t))) return !0;
                                            }
                                        }
                                        return !1;
                                        function r(e1) {
                                            if (null == e1 || null == e1.value) return !1;
                                            const t = e1.value;
                                            return "copyWithin" === t || "fill" === t || "pop" === t || "push" === t || "reverse" === t || "shift" === t || "sort" === t || "splice" === t || "unshift" === t;
                                        }
                                    }(r, t) ? null : n;
                                }
                            }
                        }
                    }
                    return null;
                },
                Literal (e1) {
                    const t = e1;
                    return null == t.regex && null == t.bigint || null != t.value ? {
                        value: t.value
                    } : null;
                },
                LogicalExpression (e1, t) {
                    const r = j(e1.left, t);
                    if (null != r) {
                        if ("||" === e1.operator && !0 === Boolean(r.value) || "&&" === e1.operator && !1 === Boolean(r.value) || "??" === e1.operator && null != r.value) return r;
                        const n = j(e1.right, t);
                        if (null != n) return n;
                    }
                    return null;
                },
                MemberExpression (e1, t) {
                    if ("PrivateIdentifier" === e1.property.type) return null;
                    const r = j(e1.object, t);
                    if (null != r) {
                        if (null == r.value && (r.optional || e1.optional)) return {
                            value: void 0,
                            optional: !0
                        };
                        const n = V(e1, t);
                        if (null != n) {
                            if (!N(r.value, n.value)) return {
                                value: r.value[n.value]
                            };
                            for (const [e1, t] of F)if (r.value instanceof e1 && t.has(n.value)) return {
                                value: r.value[n.value]
                            };
                        }
                    }
                    return null;
                },
                ChainExpression (e1, t) {
                    const r = j(e1.expression, t);
                    return null != r ? {
                        value: r.value
                    } : null;
                },
                NewExpression (e1, t) {
                    const r = j(e1.callee, t), n = O(e1.arguments, t);
                    if (null != r && null != n) {
                        const e1 = r.value;
                        if (P.has(e1)) return {
                            value: new e1(...n)
                        };
                    }
                    return null;
                },
                ObjectExpression (e1, t) {
                    const r = {};
                    for (const n of e1.properties)if ("Property" === n.type) {
                        if ("init" !== n.kind) return null;
                        const e1 = V(n, t), s = j(n.value, t);
                        if (null == e1 || null == s) return null;
                        r[e1.value] = s.value;
                    } else {
                        if ("SpreadElement" !== n.type && "ExperimentalSpreadProperty" !== n.type) return null;
                        {
                            const e1 = j(n.argument, t);
                            if (null == e1) return null;
                            Object.assign(r, e1.value);
                        }
                    }
                    return {
                        value: r
                    };
                },
                SequenceExpression: (e1, t)=>j(e1.expressions[e1.expressions.length - 1], t),
                TaggedTemplateExpression (e1, t) {
                    const r = j(e1.tag, t), n = O(e1.quasi.expressions, t);
                    if (null != r && null != n) {
                        const t = r.value, s = e1.quasi.quasis.map((e1)=>e1.value.cooked);
                        if (s.raw = e1.quasi.quasis.map((e1)=>e1.value.raw), t === String.raw) return {
                            value: t(s, ...n)
                        };
                    }
                    return null;
                },
                TemplateLiteral (e1, t) {
                    const r = O(e1.expressions, t);
                    if (null != r) {
                        let t = e1.quasis[0].value.cooked;
                        for(let n = 0; n < r.length; ++n)t += r[n], t += e1.quasis[n + 1].value.cooked;
                        return {
                            value: t
                        };
                    }
                    return null;
                },
                UnaryExpression (e1, t) {
                    if ("delete" === e1.operator) return null;
                    if ("void" === e1.operator) return {
                        value: void 0
                    };
                    const r = j(e1.argument, t);
                    if (null != r) switch(e1.operator){
                        case "-":
                            return {
                                value: -r.value
                            };
                        case "+":
                            return {
                                value: +r.value
                            };
                        case "!":
                            return {
                                value: !r.value
                            };
                        case "~":
                            return {
                                value: ~r.value
                            };
                        case "typeof":
                            return {
                                value: typeof r.value
                            };
                    }
                    return null;
                },
                TSAsExpression: (e1, t)=>j(e1.expression, t),
                TSSatisfiesExpression: (e1, t)=>j(e1.expression, t),
                TSTypeAssertion: (e1, t)=>j(e1.expression, t),
                TSNonNullExpression: (e1, t)=>j(e1.expression, t),
                TSInstantiationExpression: (e1, t)=>j(e1.expression, t)
            });
            function j(e1, t) {
                return null != e1 && Object.hasOwnProperty.call(U, e1.type) ? U[e1.type](e1, t) : null;
            }
            function V(e1, t) {
                const r = "Property" === e1.type ? e1.key : e1.property;
                return e1.computed ? j(r, t) : "Identifier" === r.type ? {
                    value: r.name
                } : "Literal" === r.type ? r.bigint ? {
                    value: r.bigint
                } : {
                    value: String(r.value)
                } : null;
            }
            function K(e1, t = null) {
                try {
                    return j(e1, t);
                } catch (e1) {
                    return null;
                }
            }
            function M(e1, t = null) {
                if (e1 && "Literal" === e1.type && null === e1.value) {
                    const t = e1;
                    if (t.regex) return `/${t.regex.pattern}/${t.regex.flags}`;
                    if (t.bigint) return t.bigint;
                }
                const r = K(e1, t);
                if (r) try {
                    return String(r.value);
                } catch  {}
                return null;
            }
            function $(e1, t) {
                switch(e1.type){
                    case "MemberExpression":
                        return e1.computed ? M(e1.property, t) : "PrivateIdentifier" === e1.property.type ? null : e1.property.name;
                    case "Property":
                    case "MethodDefinition":
                    case "PropertyDefinition":
                        return e1.computed ? M(e1.key, t) : "Literal" === e1.key.type ? String(e1.key.value) : "PrivateIdentifier" === e1.key.type ? null : e1.key.name;
                }
                return null;
            }
            function q(e1, t) {
                const r = e1.parent, n = [], s = "Property" === r.type && r.value === e1, i = "MethodDefinition" === r.type && r.value === e1, o = "PropertyDefinition" === r.type && r.value === e1;
                if ((i || o) && (r.static && n.push("static"), "PrivateIdentifier" === r.key.type && n.push("private")), e1.async && n.push("async"), e1.generator && n.push("generator"), s || i) {
                    if ("constructor" === r.kind) return "constructor";
                    "get" === r.kind ? n.push("getter") : "set" === r.kind ? n.push("setter") : n.push("method");
                } else o ? n.push("method") : ("ArrowFunctionExpression" === e1.type && n.push("arrow"), n.push("function"));
                if (s || i || o) {
                    if ("PrivateIdentifier" === r.key.type) n.push(`#${r.key.name}`);
                    else {
                        const e1 = $(r);
                        if (e1) n.push(`'${e1}'`);
                        else if (t) {
                            const e1 = t.getText(r.key);
                            e1.includes("\n") || n.push(`[${e1}]`);
                        }
                    }
                } else !function(e1) {
                    return Boolean(e1.id);
                }(e1) ? "VariableDeclarator" === r.type && r.id && "Identifier" === r.id.type ? n.push(`'${r.id.name}'`) : "AssignmentExpression" !== r.type && "AssignmentPattern" !== r.type || !r.left || "Identifier" !== r.left.type ? "ExportDefaultDeclaration" === r.type && r.declaration === e1 && n.push("'default'") : n.push(`'${r.left.name}'`) : n.push(`'${e1.id.name}'`);
                return n.join(" ");
            }
            const G = Object.freeze(new Set([
                "==",
                "!=",
                "<",
                "<=",
                ">",
                ">=",
                "<<",
                ">>",
                ">>>",
                "+",
                "-",
                "*",
                "/",
                "%",
                "|",
                "^",
                "&",
                "in"
            ])), W = Object.freeze(new Set([
                "-",
                "+",
                "!",
                "~"
            ]));
            function X(e1) {
                return null !== e1 && "object" == typeof e1 && "string" == typeof e1.type;
            }
            const z = Object.freeze(Object.assign(Object.create(null), {
                $visit (e1, t, r) {
                    const { type: n } = e1;
                    return "function" == typeof this[n] ? this[n](e1, t, r) : this.$visitChildren(e1, t, r);
                },
                $visitChildren (e1, r, n) {
                    const { type: s } = e1;
                    for (const i of n[s] || t.getKeys(e1)){
                        const t = e1[i];
                        if (Array.isArray(t)) {
                            for (const e1 of t)if (X(e1) && this.$visit(e1, r, n)) return !0;
                        } else if (X(t) && this.$visit(t, r, n)) return !0;
                    }
                    return !1;
                },
                ArrowFunctionExpression: ()=>!1,
                AssignmentExpression: ()=>!0,
                AwaitExpression: ()=>!0,
                BinaryExpression (e1, t, r) {
                    return !(!t.considerImplicitTypeConversion || !G.has(e1.operator) || "Literal" === e1.left.type && "Literal" === e1.right.type) || this.$visitChildren(e1, t, r);
                },
                CallExpression: ()=>!0,
                FunctionExpression: ()=>!1,
                ImportExpression: ()=>!0,
                MemberExpression (e1, t, r) {
                    return !!t.considerGetters || !(!t.considerImplicitTypeConversion || !e1.computed || "Literal" === e1.property.type) || this.$visitChildren(e1, t, r);
                },
                MethodDefinition (e1, t, r) {
                    return !(!t.considerImplicitTypeConversion || !e1.computed || "Literal" === e1.key.type) || this.$visitChildren(e1, t, r);
                },
                NewExpression: ()=>!0,
                Property (e1, t, r) {
                    return !(!t.considerImplicitTypeConversion || !e1.computed || "Literal" === e1.key.type) || this.$visitChildren(e1, t, r);
                },
                PropertyDefinition (e1, t, r) {
                    return !(!t.considerImplicitTypeConversion || !e1.computed || "Literal" === e1.key.type) || this.$visitChildren(e1, t, r);
                },
                UnaryExpression (e1, t, r) {
                    return "delete" === e1.operator || !(!t.considerImplicitTypeConversion || !W.has(e1.operator) || "Literal" === e1.argument.type) || this.$visitChildren(e1, t, r);
                },
                UpdateExpression: ()=>!0,
                YieldExpression: ()=>!0
            }));
            function H(e1, r, n = {}) {
                const { considerGetters: s = !1, considerImplicitTypeConversion: i = !1 } = n;
                return z.$visit(e1, {
                    considerGetters: s,
                    considerImplicitTypeConversion: i
                }, r.visitorKeys || t.KEYS);
            }
            function J(e1, t) {
                const r = e1.parent;
                switch(r.type){
                    case "CallExpression":
                    case "NewExpression":
                        return 1 === r.arguments.length && r.arguments[0] === e1 ? t.getTokenAfter(r.typeArguments || r.typeParameters || r.callee, p) : null;
                    case "DoWhileStatement":
                        return r.test === e1 ? t.getTokenAfter(r.body, p) : null;
                    case "IfStatement":
                    case "WhileStatement":
                        return r.test === e1 ? t.getFirstToken(r, 1) : null;
                    case "ImportExpression":
                        return r.source === e1 ? t.getFirstToken(r, 1) : null;
                    case "SwitchStatement":
                        return r.discriminant === e1 ? t.getFirstToken(r, 1) : null;
                    case "WithStatement":
                        return r.object === e1 ? t.getFirstToken(r, 1) : null;
                    default:
                        return null;
                }
            }
            function Q(e1, t, r) {
                let n, s, i, o, a;
                if ("number" == typeof e1) {
                    if (n = 0 | e1, s = t, i = r, !(n >= 1)) throw new TypeError("'times' should be a positive integer.");
                } else n = 1, s = e1, i = t;
                if (null == s || null == s.parent || "CatchClause" === s.parent.type && s.parent.param === s) return !1;
                o = a = s;
                do o = i.getTokenBefore(o), a = i.getTokenAfter(a);
                while (null != o && null != a && p(o) && f(a) && o !== J(s, i) && --n > 0);
                return 0 === n;
            }
            const Y = /\$(?:[$&`']|[1-9][0-9]?)/gu, Z = new WeakMap;
            function ee(e1, t) {
                let r = !1;
                for(let n = t - 1; n >= 0 && 92 === e1.charCodeAt(n); --n)r = !r;
                return r;
            }
            class te {
                constructor(e1, t = {}){
                    const { escaped: r = !1 } = t;
                    if (!(e1 instanceof RegExp)) throw new TypeError("'pattern' should be a RegExp instance.");
                    if (!e1.flags.includes("g")) throw new Error("'pattern' should contains 'g' flag.");
                    Z.set(this, {
                        pattern: new RegExp(e1.source, e1.flags),
                        escaped: Boolean(r)
                    });
                }
                *execAll(e1) {
                    const { pattern: t, escaped: r } = Z.get(this);
                    let n = null, s = 0;
                    for(t.lastIndex = 0; null != (n = t.exec(e1));)!r && ee(e1, n.index) || (s = t.lastIndex, yield n, t.lastIndex = s);
                }
                test(e1) {
                    return !this.execAll(e1).next().done;
                }
                [Symbol.replace](e1, t) {
                    return "function" == typeof t ? function(e1, t, r) {
                        const n = [];
                        let s = 0;
                        for (const i of e1.execAll(t))n.push(t.slice(s, i.index)), n.push(String(r(...i, i.index, i.input))), s = i.index + i[0].length;
                        return n.push(t.slice(s)), n.join("");
                    }(this, String(e1), t) : function(e1, t, r) {
                        const n = [];
                        let s = 0;
                        function i(e1, r) {
                            switch(e1){
                                case "$$":
                                    return "$";
                                case "$&":
                                    return r[0];
                                case "$`":
                                    return t.slice(0, r.index);
                                case "$'":
                                    return t.slice(r.index + r[0].length);
                                default:
                                    {
                                        const t = e1.slice(1);
                                        return t in r ? r[t] : e1;
                                    }
                            }
                        }
                        for (const o of e1.execAll(t))n.push(t.slice(s, o.index)), n.push(r.replace(Y, (e1)=>i(e1, o))), s = o.index + o[0].length;
                        return n.push(t.slice(s)), n.join("");
                    }(this, String(e1), String(t));
                }
            }
            const re = /^(?:Import|Export(?:All|Default|Named))Declaration$/u;
            function ne(e1) {
                return re.test(e1.type) && null != e1.source;
            }
            const se = Function.call.bind(Object.hasOwnProperty), ie = Symbol("read"), oe = Symbol("call"), ae = Symbol("construct"), ue = Symbol("esm"), le = {
                require: {
                    [oe]: !0
                }
            };
            function ce(e1) {
                return null == e1 || 0 !== e1.defs.length || e1.references.some((e1)=>e1.isWrite());
            }
            function pe(e1) {
                const t = e1.parent;
                if (t) switch(t.type){
                    case "ConditionalExpression":
                        return t.consequent === e1 || t.alternate === e1;
                    case "LogicalExpression":
                    case "ChainExpression":
                    case "TSAsExpression":
                    case "TSSatisfiesExpression":
                    case "TSTypeAssertion":
                    case "TSNonNullExpression":
                    case "TSInstantiationExpression":
                        return !0;
                    case "SequenceExpression":
                        return t.expressions[t.expressions.length - 1] === e1;
                    default:
                        return !1;
                }
                return !1;
            }
            class fe {
                constructor(e1, t = {}){
                    const { mode: r = "strict", globalObjectNames: n = [
                        "global",
                        "globalThis",
                        "self",
                        "window"
                    ] } = t;
                    this.variableStack = [], this.globalScope = e1, this.mode = r, this.globalObjectNames = n.slice(0);
                }
                *iterateGlobalReferences(e1) {
                    for (const t of Object.keys(e1)){
                        const r = e1[t], n = [
                            t
                        ], s = this.globalScope.set.get(t);
                        ce(s) || (yield* this._iterateVariableReferences(s, n, r, !0));
                    }
                    for (const t of this.globalObjectNames){
                        const r = [], n = this.globalScope.set.get(t);
                        ce(n) || (yield* this._iterateVariableReferences(n, r, e1, !1));
                    }
                }
                *iterateCjsReferences(e1) {
                    for (const { node: t } of this.iterateGlobalReferences(le)){
                        const r = M(t.arguments[0]);
                        if (null == r || !se(e1, r)) continue;
                        const n = e1[r], s = [
                            r
                        ];
                        n[ie] && (yield {
                            node: t,
                            path: s,
                            type: ie,
                            info: n[ie]
                        }), yield* this._iteratePropertyReferences(t, s, n);
                    }
                }
                *iterateEsmReferences(e1) {
                    const t = this.globalScope.block;
                    for (const r of t.body){
                        if (!ne(r)) continue;
                        const t = r.source.value;
                        if (!se(e1, t)) continue;
                        const n = e1[t], s = [
                            t
                        ];
                        if (n[ie] && (yield {
                            node: r,
                            path: s,
                            type: ie,
                            info: n[ie]
                        }), "ExportAllDeclaration" === r.type) for (const e1 of Object.keys(n)){
                            const t = n[e1];
                            t[ie] && (yield {
                                node: r,
                                path: s.concat(e1),
                                type: ie,
                                info: t[ie]
                            });
                        }
                        else for (const e1 of r.specifiers){
                            const t = se(n, ue), r = this._iterateImportReferences(e1, s, t ? n : "legacy" === this.mode ? {
                                default: n,
                                ...n
                            } : {
                                default: n
                            });
                            if (t) yield* r;
                            else for (const e1 of r)e1.path = e1.path.filter(de), (e1.path.length >= 2 || e1.type !== ie) && (yield e1);
                        }
                    }
                }
                *iteratePropertyReferences(e1, t) {
                    yield* this._iteratePropertyReferences(e1, [], t);
                }
                *_iterateVariableReferences(e1, t, r, n) {
                    if (!this.variableStack.includes(e1)) {
                        this.variableStack.push(e1);
                        try {
                            for (const s of e1.references){
                                if (!s.isRead()) continue;
                                const e1 = s.identifier;
                                n && r[ie] && (yield {
                                    node: e1,
                                    path: t,
                                    type: ie,
                                    info: r[ie]
                                }), yield* this._iteratePropertyReferences(e1, t, r);
                            }
                        } finally{
                            this.variableStack.pop();
                        }
                    }
                }
                *_iteratePropertyReferences(e1, t, r) {
                    let n = e1;
                    for(; pe(n);)n = n.parent;
                    const s = n.parent;
                    if ("MemberExpression" !== s.type) "CallExpression" !== s.type ? "NewExpression" !== s.type ? "AssignmentExpression" !== s.type ? "AssignmentPattern" !== s.type ? "VariableDeclarator" === s.type && s.init === n && (yield* this._iterateLhsReferences(s.id, t, r)) : s.right === n && (yield* this._iterateLhsReferences(s.left, t, r)) : s.right === n && (yield* this._iterateLhsReferences(s.left, t, r), yield* this._iteratePropertyReferences(s, t, r)) : s.callee === n && r[ae] && (yield {
                        node: s,
                        path: t,
                        type: ae,
                        info: r[ae]
                    }) : s.callee === n && r[oe] && (yield {
                        node: s,
                        path: t,
                        type: oe,
                        info: r[oe]
                    });
                    else if (s.object === n) {
                        const e1 = $(s);
                        if (null == e1 || !se(r, e1)) return;
                        t = t.concat(e1);
                        const n = r[e1];
                        n[ie] && (yield {
                            node: s,
                            path: t,
                            type: ie,
                            info: n[ie]
                        }), yield* this._iteratePropertyReferences(s, t, n);
                    }
                }
                *_iterateLhsReferences(e1, t, r) {
                    if ("Identifier" !== e1.type) {
                        if ("ObjectPattern" !== e1.type) "AssignmentPattern" === e1.type && (yield* this._iterateLhsReferences(e1.left, t, r));
                        else for (const n of e1.properties){
                            const e1 = $(n);
                            if (null == e1 || !se(r, e1)) continue;
                            const s = t.concat(e1), i = r[e1];
                            i[ie] && (yield {
                                node: n,
                                path: s,
                                type: ie,
                                info: i[ie]
                            }), yield* this._iterateLhsReferences(n.value, s, i);
                        }
                    } else {
                        const s = n(this.globalScope, e1);
                        null != s && (yield* this._iterateVariableReferences(s, t, r, !1));
                    }
                }
                *_iterateImportReferences(e1, t, r) {
                    const s = e1.type;
                    if ("ImportSpecifier" === s || "ImportDefaultSpecifier" === s) {
                        const i = "ImportDefaultSpecifier" === s ? "default" : "Identifier" === e1.imported.type ? e1.imported.name : e1.imported.value;
                        if (!se(r, i)) return;
                        t = t.concat(i);
                        const o = r[i];
                        return o[ie] && (yield {
                            node: e1,
                            path: t,
                            type: ie,
                            info: o[ie]
                        }), void (yield* this._iterateVariableReferences(n(this.globalScope, e1.local), t, o, !1));
                    }
                    if ("ImportNamespaceSpecifier" !== s) {
                        if ("ExportSpecifier" === s) {
                            const n = "Identifier" === e1.local.type ? e1.local.name : e1.local.value;
                            if (!se(r, n)) return;
                            t = t.concat(n);
                            const s = r[n];
                            s[ie] && (yield {
                                node: e1,
                                path: t,
                                type: ie,
                                info: s[ie]
                            });
                        }
                    } else yield* this._iterateVariableReferences(n(this.globalScope, e1.local), t, r, !1);
                }
            }
            function de(e1, t) {
                return !(1 === t && "default" === e1);
            }
            fe.READ = ie, fe.CALL = oe, fe.CONSTRUCT = ae, fe.ESM = ue;
            var he = {
                CALL: oe,
                CONSTRUCT: ae,
                ESM: ue,
                findVariable: n,
                getFunctionHeadLocation: k,
                getFunctionNameWithKind: q,
                getInnermostScope: r,
                getPropertyName: $,
                getStaticValue: K,
                getStringIfConstant: M,
                hasSideEffect: H,
                isArrowToken: a,
                isClosingBraceToken: g,
                isClosingBracketToken: h,
                isClosingParenToken: f,
                isColonToken: c,
                isCommaToken: u,
                isCommentToken: y,
                isNotArrowToken: E,
                isNotClosingBraceToken: D,
                isNotClosingBracketToken: T,
                isNotClosingParenToken: v,
                isNotColonToken: S,
                isNotCommaToken: x,
                isNotCommentToken: w,
                isNotOpeningBraceToken: R,
                isNotOpeningBracketToken: A,
                isNotOpeningParenToken: b,
                isNotSemicolonToken: C,
                isOpeningBraceToken: m,
                isOpeningBracketToken: d,
                isOpeningParenToken: p,
                isParenthesized: Q,
                isSemicolonToken: l,
                PatternMatcher: te,
                READ: ie,
                ReferenceTracker: fe
            };
            e1.CALL = oe, e1.CONSTRUCT = ae, e1.ESM = ue, e1.PatternMatcher = te, e1.READ = ie, e1.ReferenceTracker = fe, e1.default = he, e1.findVariable = n, e1.getFunctionHeadLocation = k, e1.getFunctionNameWithKind = q, e1.getInnermostScope = r, e1.getPropertyName = $, e1.getStaticValue = K, e1.getStringIfConstant = M, e1.hasSideEffect = H, e1.isArrowToken = a, e1.isClosingBraceToken = g, e1.isClosingBracketToken = h, e1.isClosingParenToken = f, e1.isColonToken = c, e1.isCommaToken = u, e1.isCommentToken = y, e1.isNotArrowToken = E, e1.isNotClosingBraceToken = D, e1.isNotClosingBracketToken = T, e1.isNotClosingParenToken = v, e1.isNotColonToken = S, e1.isNotCommaToken = x, e1.isNotCommentToken = w, e1.isNotOpeningBraceToken = R, e1.isNotOpeningBracketToken = A, e1.isNotOpeningParenToken = b, e1.isNotSemicolonToken = C, e1.isOpeningBraceToken = m, e1.isOpeningBracketToken = d, e1.isOpeningParenToken = p, e1.isParenthesized = Q, e1.isSemicolonToken = l;
        }(zi)), zi;
    }
    var Ji, Qi, Yi = {};
    function Zi() {
        return Qi ? Ji : (Qi = 1, Ji = class {
            constructor(){
                this.current = null;
            }
            getOneToken() {
                return this.moveNext() ? this.current : null;
            }
            getAllTokens() {
                const e1 = [];
                for(; this.moveNext();)e1.push(this.current);
                return e1;
            }
            moveNext() {
                throw new Error("Not implemented.");
            }
        });
    }
    var eo, to, ro, no, so, io, oo, ao, uo, lo, co, po, fo, ho, mo, go, yo, Eo, xo, Co, So, bo, vo, Ao, To = {};
    function Ro() {
        return eo || (eo = 1, To.search = function(e1, t) {
            for(let r = 0, n = e1.length - 1; r <= n;){
                const s = (r + n) / 2 | 0;
                if (t <= e1[s].range[0]) {
                    if (s === r) return s;
                    n = s;
                } else r = s + 1;
            }
            return e1.length;
        }, To.getFirstIndex = function(e1, t, r) {
            if (r in t) return t[r];
            if (r - 1 in t) {
                const n = t[r - 1], s = e1[n];
                return s ? s.range[0] >= r ? n : n + 1 : e1.length;
            }
            return 0;
        }, To.getLastIndex = function(e1, t, r) {
            if (r in t) return t[r] - 1;
            if (r - 1 in t) {
                const n = t[r - 1], s = e1[n];
                return s ? s.range[1] > r ? n - 1 : n : e1.length - 1;
            }
            return e1.length - 1;
        }), To;
    }
    function Do() {
        if (oo) return io;
        oo = 1;
        const e1 = Zi();
        return io = class extends e1 {
            constructor(e1){
                super(), this.cursor = e1;
            }
            moveNext() {
                const e1 = this.cursor.moveNext();
                return this.current = this.cursor.current, e1;
            }
        }, io;
    }
    function wo() {
        if (fo) return po;
        fo = 1;
        const e1 = Zi(), t = Ro();
        return po = class extends e1 {
            constructor(e1, r, n, s, i){
                super(), this.tokens = e1, this.index = t.getFirstIndex(e1, n, s), this.indexEnd = t.getLastIndex(e1, n, i);
            }
            moveNext() {
                return this.index <= this.indexEnd && (this.current = this.tokens[this.index], this.index += 1, !0);
            }
            getOneToken() {
                return this.index <= this.indexEnd ? this.tokens[this.index] : null;
            }
            getAllTokens() {
                return this.tokens.slice(this.index, this.indexEnd + 1);
            }
        };
    }
    function _o() {
        if (Eo) return Yi;
        Eo = 1;
        const e1 = function() {
            if (ro) return to;
            ro = 1;
            const e1 = Zi(), t = Ro();
            return to = class extends e1 {
                constructor(e1, r, n, s, i){
                    super(), this.tokens = e1, this.comments = r, this.tokenIndex = t.getLastIndex(e1, n, i), this.commentIndex = t.search(r, i) - 1, this.border = s;
                }
                moveNext() {
                    const e1 = this.tokenIndex >= 0 ? this.tokens[this.tokenIndex] : null, t = this.commentIndex >= 0 ? this.comments[this.commentIndex] : null;
                    return e1 && (!t || e1.range[1] > t.range[1]) ? (this.current = e1, this.tokenIndex -= 1) : t ? (this.current = t, this.commentIndex -= 1) : this.current = null, Boolean(this.current) && (-1 === this.border || this.current.range[0] >= this.border);
                }
            }, to;
        }(), t = function() {
            if (so) return no;
            so = 1;
            const e1 = Zi(), t = Ro();
            return no = class extends e1 {
                constructor(e1, r, n, s, i){
                    super(), this.tokens = e1, this.index = t.getLastIndex(e1, n, i), this.indexEnd = t.getFirstIndex(e1, n, s);
                }
                moveNext() {
                    return this.index >= this.indexEnd && (this.current = this.tokens[this.index], this.index -= 1, !0);
                }
                getOneToken() {
                    return this.index >= this.indexEnd ? this.tokens[this.index] : null;
                }
            };
        }(), r = function() {
            if (uo) return ao;
            uo = 1;
            const e1 = Do();
            return ao = class extends e1 {
                constructor(e1, t){
                    super(e1), this.predicate = t;
                }
                moveNext() {
                    const e1 = this.predicate;
                    for(; super.moveNext();)if (e1(this.current)) return !0;
                    return !1;
                }
            }, ao;
        }(), n = function() {
            if (co) return lo;
            co = 1;
            const e1 = Zi(), t = Ro();
            return lo = class extends e1 {
                constructor(e1, r, n, s, i){
                    super(), this.tokens = e1, this.comments = r, this.tokenIndex = t.getFirstIndex(e1, n, s), this.commentIndex = t.search(r, s), this.border = i;
                }
                moveNext() {
                    const e1 = this.tokenIndex < this.tokens.length ? this.tokens[this.tokenIndex] : null, t = this.commentIndex < this.comments.length ? this.comments[this.commentIndex] : null;
                    return e1 && (!t || e1.range[0] < t.range[0]) ? (this.current = e1, this.tokenIndex += 1) : t ? (this.current = t, this.commentIndex += 1) : this.current = null, Boolean(this.current) && (-1 === this.border || this.current.range[1] <= this.border);
                }
            }, lo;
        }(), s = wo(), i = function() {
            if (mo) return ho;
            mo = 1;
            const e1 = Do();
            return ho = class extends e1 {
                constructor(e1, t){
                    super(e1), this.count = t;
                }
                moveNext() {
                    return this.count > 0 && (this.count -= 1, super.moveNext());
                }
            }, ho;
        }(), o = function() {
            if (yo) return go;
            yo = 1;
            const e1 = Do();
            return go = class extends e1 {
                constructor(e1, t){
                    super(e1), this.count = t;
                }
                moveNext() {
                    for(; this.count > 0;)if (this.count -= 1, !super.moveNext()) return !1;
                    return super.moveNext();
                }
            }, go;
        }();
        class a {
            constructor(e1, t){
                this.TokenCursor = e1, this.TokenCommentCursor = t;
            }
            createBaseCursor(e1, t, r, n, s, i) {
                return new (i ? this.TokenCommentCursor : this.TokenCursor)(e1, t, r, n, s);
            }
            createCursor(e1, t, n, s, a, u, l, c, p) {
                let f = this.createBaseCursor(e1, t, n, s, a, u);
                return l && (f = new r(f, l)), c >= 1 && (f = new o(f, c)), p >= 0 && (f = new i(f, p)), f;
            }
        }
        return Yi.forward = new a(s, n), Yi.backward = new a(t, e1), Yi;
    }
    function ko() {
        if (bo) return So;
        bo = 1;
        const e1 = ir, { isCommentToken: t } = Hi(), r = _o(), n = wo(), s = function() {
            if (Co) return xo;
            Co = 1;
            const e1 = wo();
            return xo = class extends e1 {
                constructor(e1, t, r, n, s, i, o){
                    super(e1, t, r, n, s), this.index = Math.max(0, this.index - i), this.indexEnd = Math.min(e1.length - 1, this.indexEnd + o);
                }
            };
        }(), i = Ro(), o = Symbol("tokens"), a = Symbol("comments"), u = Symbol("indexMap");
        function l(t, r, n, s, i, o, a) {
            let u = !1, l = 0, c = null;
            return "number" == typeof a ? l = 0 | a : "function" == typeof a ? c = a : a && (u = !!a.includeComments, l = 0 | a.skip, c = a.filter || null), e1(l >= 0, "options.skip should be zero or a positive integer."), e1(!c || "function" == typeof c, "options.filter should be a function."), t.createCursor(r, n, s, i, o, u, c, l, -1);
        }
        function c(t, r, n, s, i, o, a) {
            let u = !1, l = 0, c = !1, p = null;
            return "number" == typeof a ? (l = 0 | a, c = !0) : "function" == typeof a ? p = a : a && (u = !!a.includeComments, l = 0 | a.count, c = "number" == typeof a.count, p = a.filter || null), e1(l >= 0, "options.count should be zero or a positive integer."), e1(!p || "function" == typeof p, "options.filter should be a function."), t.createCursor(r, n, s, i, o, u, p, 0, c ? l : -1);
        }
        function p(e1, t, i, o, a, u, l) {
            return void 0 === u && void 0 === l ? new n(e1, t, i, o, a) : "number" == typeof u || void 0 === u ? new s(e1, t, i, o, a, 0 | u, 0 | l) : c(r.forward, e1, t, i, o, a, u);
        }
        function f(e1) {
            const r = [];
            let n = e1.getOneToken();
            for(; n && t(n);)r.push(n), n = e1.getOneToken();
            return r;
        }
        return So = class {
            constructor(e1, t){
                this[o] = e1, this[a] = t, this[u] = function(e1, t) {
                    const r = Object.create(null);
                    let n = 0, s = 0, i = 0, o = null;
                    for(; n < e1.length || s < t.length;){
                        for(i = s < t.length ? t[s].range[0] : Number.MAX_SAFE_INTEGER; n < e1.length && (o = e1[n].range)[0] < i;)r[o[0]] = n, r[o[1] - 1] = n, n += 1;
                        for(i = n < e1.length ? e1[n].range[0] : Number.MAX_SAFE_INTEGER; s < t.length && (o = t[s].range)[0] < i;)r[o[0]] = n, r[o[1] - 1] = n, s += 1;
                    }
                    return r;
                }(e1, t);
            }
            getTokenByRangeStart(e1, t) {
                const n = t && t.includeComments, s = r.forward.createBaseCursor(this[o], this[a], this[u], e1, -1, n).getOneToken();
                return s && s.range[0] === e1 ? s : null;
            }
            getFirstToken(e1, t) {
                return l(r.forward, this[o], this[a], this[u], e1.range[0], e1.range[1], t).getOneToken();
            }
            getLastToken(e1, t) {
                return l(r.backward, this[o], this[a], this[u], e1.range[0], e1.range[1], t).getOneToken();
            }
            getTokenBefore(e1, t) {
                return l(r.backward, this[o], this[a], this[u], -1, e1.range[0], t).getOneToken();
            }
            getTokenAfter(e1, t) {
                return l(r.forward, this[o], this[a], this[u], e1.range[1], -1, t).getOneToken();
            }
            getFirstTokenBetween(e1, t, n) {
                return l(r.forward, this[o], this[a], this[u], e1.range[1], t.range[0], n).getOneToken();
            }
            getLastTokenBetween(e1, t, n) {
                return l(r.backward, this[o], this[a], this[u], e1.range[1], t.range[0], n).getOneToken();
            }
            getTokenOrCommentBefore(e1, t) {
                return this.getTokenBefore(e1, {
                    includeComments: !0,
                    skip: t
                });
            }
            getTokenOrCommentAfter(e1, t) {
                return this.getTokenAfter(e1, {
                    includeComments: !0,
                    skip: t
                });
            }
            getFirstTokens(e1, t) {
                return c(r.forward, this[o], this[a], this[u], e1.range[0], e1.range[1], t).getAllTokens();
            }
            getLastTokens(e1, t) {
                return c(r.backward, this[o], this[a], this[u], e1.range[0], e1.range[1], t).getAllTokens().reverse();
            }
            getTokensBefore(e1, t) {
                return c(r.backward, this[o], this[a], this[u], -1, e1.range[0], t).getAllTokens().reverse();
            }
            getTokensAfter(e1, t) {
                return c(r.forward, this[o], this[a], this[u], e1.range[1], -1, t).getAllTokens();
            }
            getFirstTokensBetween(e1, t, n) {
                return c(r.forward, this[o], this[a], this[u], e1.range[1], t.range[0], n).getAllTokens();
            }
            getLastTokensBetween(e1, t, n) {
                return c(r.backward, this[o], this[a], this[u], e1.range[1], t.range[0], n).getAllTokens().reverse();
            }
            getTokens(e1, t, r) {
                return p(this[o], this[a], this[u], e1.range[0], e1.range[1], t, r).getAllTokens();
            }
            getTokensBetween(e1, t, r) {
                return p(this[o], this[a], this[u], e1.range[1], t.range[0], r, r).getAllTokens();
            }
            commentsExistBetween(e1, t) {
                const r = i.search(this[a], e1.range[1]);
                return r < this[a].length && this[a][r].range[1] <= t.range[0];
            }
            getCommentsBefore(e1) {
                return f(c(r.backward, this[o], this[a], this[u], -1, e1.range[0], {
                    includeComments: !0
                })).reverse();
            }
            getCommentsAfter(e1) {
                return f(c(r.forward, this[o], this[a], this[u], e1.range[1], -1, {
                    includeComments: !0
                }));
            }
            getCommentsInside(e1) {
                return this.getTokens(e1, {
                    includeComments: !0,
                    filter: t
                });
            }
        }, So;
    }
    function Bo() {
        if (Ao) return vo;
        Ao = 1;
        const e1 = {
            Array: !1,
            Boolean: !1,
            constructor: !1,
            Date: !1,
            decodeURI: !1,
            decodeURIComponent: !1,
            encodeURI: !1,
            encodeURIComponent: !1,
            Error: !1,
            escape: !1,
            eval: !1,
            EvalError: !1,
            Function: !1,
            hasOwnProperty: !1,
            Infinity: !1,
            isFinite: !1,
            isNaN: !1,
            isPrototypeOf: !1,
            Math: !1,
            NaN: !1,
            Number: !1,
            Object: !1,
            parseFloat: !1,
            parseInt: !1,
            propertyIsEnumerable: !1,
            RangeError: !1,
            ReferenceError: !1,
            RegExp: !1,
            String: !1,
            SyntaxError: !1,
            toLocaleString: !1,
            toString: !1,
            TypeError: !1,
            undefined: !1,
            unescape: !1,
            URIError: !1,
            valueOf: !1
        }, t = {
            ...e1,
            JSON: !1
        }, r = {
            ...t,
            ArrayBuffer: !1,
            DataView: !1,
            Float32Array: !1,
            Float64Array: !1,
            Int16Array: !1,
            Int32Array: !1,
            Int8Array: !1,
            Map: !1,
            Promise: !1,
            Proxy: !1,
            Reflect: !1,
            Set: !1,
            Symbol: !1,
            Uint16Array: !1,
            Uint32Array: !1,
            Uint8Array: !1,
            Uint8ClampedArray: !1,
            WeakMap: !1,
            WeakSet: !1
        }, n = {
            ...r
        }, s = {
            ...n,
            Atomics: !1,
            SharedArrayBuffer: !1
        }, i = {
            ...s
        }, o = {
            ...i
        }, a = {
            ...o,
            BigInt: !1,
            BigInt64Array: !1,
            BigUint64Array: !1,
            globalThis: !1
        }, u = {
            ...a,
            AggregateError: !1,
            FinalizationRegistry: !1,
            WeakRef: !1
        }, l = {
            ...u
        }, c = {
            ...l
        }, p = {
            ...c
        };
        return vo = {
            commonjs: {
                exports: !0,
                global: !1,
                module: !1,
                require: !1
            },
            es3: e1,
            es5: t,
            es2015: r,
            es2016: n,
            es2017: s,
            es2018: i,
            es2019: o,
            es2020: a,
            es2021: u,
            es2022: l,
            es2023: c,
            es2024: p
        };
    }
    var Lo, Po, Io, Fo, No, Oo, Uo, jo, Vo, Ko, Mo, $o, qo, Go = {}, Wo = {
        get exports () {
            return Go;
        },
        set exports (e){
            Go = e;
        }
    }, Xo = {}, zo = {
        get exports () {
            return Xo;
        },
        set exports (e){
            Xo = e;
        }
    };
    function Ho() {
        if (Po) return Lo;
        Po = 1;
        var e1, t, r, n, s, i, o = {}.toString;
        function a(e1, t) {
            var r, n = function(s) {
                return e1.length > 1 ? function() {
                    var i = s ? s.concat() : [];
                    return r = t && r || this, i.push.apply(i, arguments) < e1.length && arguments.length ? n.call(r, i) : e1.apply(r, i);
                } : e1;
            };
            return n();
        }
        return e1 = a(function(e1, t) {
            return e1.apply(null, t);
        }), t = function(e1) {
            return a(e1);
        }, r = a(function(e1, t, r) {
            return e1(r, t);
        }), n = function(e1) {
            return function(t) {
                return function() {
                    return e1(t(t)).apply(null, arguments);
                };
            }(function(t) {
                return function() {
                    return e1(t(t)).apply(null, arguments);
                };
            });
        }, s = a(function(e1, t, r, n) {
            return e1(t(r), t(n));
        }), i = function(e1) {
            var t;
            return t = {}, function() {
                var r, n, s, i, a, u;
                for(n = [], s = 0, i = arguments.length; s < i; ++s)n.push(arguments[s]);
                return r = n, a = (function() {
                    var e1, t, n, s = [];
                    for(e1 = 0, n = (t = r).length; e1 < n; ++e1)u = t[e1], s.push(u + o.call(u).slice(8, -1));
                    return s;
                })().join(""), t[a] = a in t ? t[a] : e1.apply(null, r);
            };
        }, Lo = {
            curry: t,
            flip: r,
            fix: n,
            apply: e1,
            over: s,
            memoize: i
        };
    }
    function Jo() {
        if (Fo) return Io;
        Fo = 1;
        var e1, t, r, n, s, i, o, a, u, l, c, p, f, d, h, m, g, y, E, x, C, S, b, v, A, T, R, D, w, _, k, B, L, P, I, F, N, O, U, j, V, K, M, $, q, G, W, X, z, H, J, Q, Y, Z, ee, te, re, ne, se, ie, oe, ae, ue, le, ce, pe, fe, de, he, me, ge = {}.toString;
        function ye(e1, t) {
            var r, n = function(s) {
                return e1.length > 1 ? function() {
                    var i = s ? s.concat() : [];
                    return r = t && r || this, i.push.apply(i, arguments) < e1.length && arguments.length ? n.call(r, i) : e1.apply(r, i);
                } : e1;
            };
            return n();
        }
        function Ee(e1, t) {
            for(var r = -1, n = t.length >>> 0; ++r < n;)if (e1 === t[r]) return !0;
            return !1;
        }
        function xe(e1) {
            return !e1;
        }
        return e1 = ye(function(e1, t) {
            var r, n;
            for(r = 0, n = t.length; r < n; ++r)e1(t[r]);
            return t;
        }), t = ye(function(e1, t) {
            var r, n, s, i = [];
            for(r = 0, n = t.length; r < n; ++r)s = t[r], i.push(e1(s));
            return i;
        }), r = function(e1) {
            var t, r, n, s = [];
            for(t = 0, r = e1.length; t < r; ++t)(n = e1[t]) && s.push(n);
            return s;
        }, n = ye(function(e1, t) {
            var r, n, s, i = [];
            for(r = 0, n = t.length; r < n; ++r)e1(s = t[r]) && i.push(s);
            return i;
        }), s = ye(function(e1, t) {
            var r, n, s, i = [];
            for(r = 0, n = t.length; r < n; ++r)e1(s = t[r]) || i.push(s);
            return i;
        }), i = ye(function(e1, t) {
            var r, n;
            return r = fe(e1, t), n = t.slice(), null != r && n.splice(r, 1), n;
        }), o = ye(function(e1, t) {
            var r, n, s, i, o;
            for(r = [], n = [], s = 0, i = t.length; s < i; ++s)(e1(o = t[s]) ? r : n).push(o);
            return [
                r,
                n
            ];
        }), a = ye(function(e1, t) {
            var r, n, s;
            for(r = 0, n = t.length; r < n; ++r)if (e1(s = t[r])) return s;
        }), u = l = function(e1) {
            return e1[0];
        }, c = function(e1) {
            if (e1.length) return e1.slice(1);
        }, p = function(e1) {
            return e1[e1.length - 1];
        }, f = function(e1) {
            if (e1.length) return e1.slice(0, -1);
        }, d = function(e1) {
            return !e1.length;
        }, h = function(e1) {
            return e1.concat().reverse();
        }, m = function(e1) {
            var t, r, n, s;
            for(t = [], r = 0, n = e1.length; r < n; ++r)Ee(s = e1[r], t) || t.push(s);
            return t;
        }, g = ye(function(e1, t) {
            var r, n, s, i, o, a = [];
            for(r = [], n = 0, s = t.length; n < s; ++n)Ee(o = e1(i = t[n]), r) || (r.push(o), a.push(i));
            return a;
        }), y = E = ye(function(e1, t, r) {
            var n, s;
            for(n = 0, s = r.length; n < s; ++n)t = e1(t, r[n]);
            return t;
        }), x = C = ye(function(e1, t) {
            return y(e1, t[0], t.slice(1));
        }), S = ye(function(e1, t, r) {
            var n;
            for(n = r.length - 1; n >= 0; --n)t = e1(r[n], t);
            return t;
        }), b = ye(function(e1, t) {
            return S(e1, t[t.length - 1], t.slice(0, -1));
        }), v = ye(function(e1, t) {
            var r, n, s;
            for(r = [], n = t; null != (s = e1(n));)r.push(s[0]), n = s[1];
            return r;
        }), A = function(e1) {
            return [].concat.apply([], e1);
        }, T = ye(function(e1, t) {
            var r;
            return [].concat.apply([], function() {
                var n, s, i, o = [];
                for(n = 0, i = (s = t).length; n < i; ++n)r = s[n], o.push(e1(r));
                return o;
            }());
        }), R = function(e1) {
            var t;
            return [].concat.apply([], function() {
                var r, n, s, i = [];
                for(r = 0, s = (n = e1).length; r < s; ++r)t = n[r], "Array" === ge.call(t).slice(8, -1) ? i.push(R(t)) : i.push(t);
                return i;
            }());
        }, D = function(e1) {
            var t, r, n, s, i, o, a, u, l;
            for(r = [], n = 1, s = arguments.length; n < s; ++n)r.push(arguments[n]);
            t = r, i = [];
            e: for(n = 0, o = e1.length; n < o; ++n){
                for(a = e1[n], u = 0, l = t.length; u < l; ++u)if (Ee(a, t[u])) continue e;
                i.push(a);
            }
            return i;
        }, w = function(e1) {
            var t, r, n, s, i, o, a, u, l;
            for(r = [], n = 1, s = arguments.length; n < s; ++n)r.push(arguments[n]);
            t = r, i = [];
            e: for(n = 0, o = e1.length; n < o; ++n){
                for(a = e1[n], u = 0, l = t.length; u < l; ++u)if (!Ee(a, t[u])) continue e;
                i.push(a);
            }
            return i;
        }, _ = function() {
            var e1, t, r, n, s, i, o, a, u, l;
            for(t = [], r = 0, n = arguments.length; r < n; ++r)t.push(arguments[r]);
            for(s = [], r = 0, i = (e1 = t).length; r < i; ++r)for(a = 0, u = (o = e1[r]).length; a < u; ++a)Ee(l = o[a], s) || s.push(l);
            return s;
        }, k = ye(function(e1, t) {
            var r, n, s, i;
            for(r = {}, n = 0, s = t.length; n < s; ++n)(i = e1(t[n])) in r ? r[i] += 1 : r[i] = 1;
            return r;
        }), B = ye(function(e1, t) {
            var r, n, s, i, o;
            for(r = {}, n = 0, s = t.length; n < s; ++n)(o = e1(i = t[n])) in r ? r[o].push(i) : r[o] = [
                i
            ];
            return r;
        }), L = function(e1) {
            var t, r;
            for(t = 0, r = e1.length; t < r; ++t)if (!e1[t]) return !1;
            return !0;
        }, P = function(e1) {
            var t, r;
            for(t = 0, r = e1.length; t < r; ++t)if (e1[t]) return !0;
            return !1;
        }, I = ye(function(e1, t) {
            var r, n;
            for(r = 0, n = t.length; r < n; ++r)if (e1(t[r])) return !0;
            return !1;
        }), F = ye(function(e1, t) {
            var r, n;
            for(r = 0, n = t.length; r < n; ++r)if (!e1(t[r])) return !1;
            return !0;
        }), N = function(e1) {
            return e1.concat().sort(function(e1, t) {
                return e1 > t ? 1 : e1 < t ? -1 : 0;
            });
        }, O = ye(function(e1, t) {
            return t.concat().sort(e1);
        }), U = ye(function(e1, t) {
            return t.concat().sort(function(t, r) {
                return e1(t) > e1(r) ? 1 : e1(t) < e1(r) ? -1 : 0;
            });
        }), j = function(e1) {
            var t, r, n;
            for(t = 0, r = 0, n = e1.length; r < n; ++r)t += e1[r];
            return t;
        }, V = function(e1) {
            var t, r, n;
            for(t = 1, r = 0, n = e1.length; r < n; ++r)t *= e1[r];
            return t;
        }, K = M = function(e1) {
            var t, r, n;
            for(t = 0, r = 0, n = e1.length; r < n; ++r)t += e1[r];
            return t / e1.length;
        }, $ = function(e1) {
            var t, r, n, s, i;
            for(t = e1[0], r = 0, s = (n = e1.slice(1)).length; r < s; ++r)(i = n[r]) > t && (t = i);
            return t;
        }, q = function(e1) {
            var t, r, n, s, i;
            for(t = e1[0], r = 0, s = (n = e1.slice(1)).length; r < s; ++r)(i = n[r]) < t && (t = i);
            return t;
        }, G = ye(function(e1, t) {
            var r, n, s, i, o;
            for(r = t[0], n = 0, i = (s = t.slice(1)).length; n < i; ++n)e1(o = s[n]) > e1(r) && (r = o);
            return r;
        }), W = ye(function(e1, t) {
            var r, n, s, i, o;
            for(r = t[0], n = 0, i = (s = t.slice(1)).length; n < i; ++n)e1(o = s[n]) < e1(r) && (r = o);
            return r;
        }), X = z = ye(function(e1, t, r) {
            var n, s;
            return n = t, [
                t
            ].concat(function() {
                var t, i, o, a = [];
                for(t = 0, o = (i = r).length; t < o; ++t)s = i[t], a.push(n = e1(n, s));
                return a;
            }());
        }), H = J = ye(function(e1, t) {
            if (t.length) return X(e1, t[0], t.slice(1));
        }), Q = ye(function(e1, t, r) {
            return r = r.concat().reverse(), X(e1, t, r).reverse();
        }), Y = ye(function(e1, t) {
            if (t.length) return t = t.concat().reverse(), X(e1, t[0], t.slice(1)).reverse();
        }), Z = ye(function(e1, t, r) {
            return r.slice(e1, t);
        }), ee = ye(function(e1, t) {
            return e1 <= 0 ? t.slice(0, 0) : t.slice(0, e1);
        }), te = ye(function(e1, t) {
            return e1 <= 0 ? t : t.slice(e1);
        }), re = ye(function(e1, t) {
            return [
                ee(e1, t),
                te(e1, t)
            ];
        }), ne = ye(function(e1, t) {
            var r, n;
            if (!(r = t.length)) return t;
            for(n = 0; n < r && e1(t[n]);)n += 1;
            return t.slice(0, n);
        }), se = ye(function(e1, t) {
            var r, n;
            if (!(r = t.length)) return t;
            for(n = 0; n < r && e1(t[n]);)n += 1;
            return t.slice(n);
        }), ie = ye(function(e1, t) {
            return [
                ne(e1, t),
                se(e1, t)
            ];
        }), oe = ye(function(e1, t) {
            return ie(function() {
                var e1 = arguments;
                return function() {
                    var t, r;
                    for(r = e1[0].apply(this, arguments), t = 1; t < e1.length; ++t)r = e1[t](r);
                    return r;
                };
            }(e1, xe), t);
        }), ae = ye(function(e1, t) {
            var r, n, s, i, o, a;
            for(r = [], n = t.length, s = 0, i = e1.length; s < i && (o = s, a = e1[s], o !== n); ++s)r.push([
                a,
                t[o]
            ]);
            return r;
        }), ue = ye(function(e1, t, r) {
            var n, s, i, o, a, u;
            for(n = [], s = r.length, i = 0, o = t.length; i < o && (a = i, u = t[i], a !== s); ++i)n.push(e1(u, r[a]));
            return n;
        }), le = function() {
            var e1, t, r, n, s, i, o, a, u, l, c, p = [];
            for(t = [], r = 0, n = arguments.length; r < n; ++r)t.push(arguments[r]);
            for(s = void 0, r = 0, i = (e1 = t).length; r < i; ++r)s <= (a = (o = e1[r]).length) || (s = a);
            for(r = 0; r < s; ++r){
                for(u = r, l = [], c = 0, i = e1.length; c < i; ++c)o = e1[c], l.push(o[u]);
                p.push(l);
            }
            return p;
        }, ce = function(e1) {
            var t, r, n, s, i, o, a, u, l, c = [];
            for(r = [], n = 1, s = arguments.length; n < s; ++n)r.push(arguments[n]);
            for(i = void 0, n = 0, o = (t = r).length; n < o; ++n)i <= (u = (a = t[n]).length) || (i = u);
            for(n = 0; n < i; ++n)l = n, c.push(e1.apply(null, p()));
            return c;
            function p() {
                var e1, r, n, s = [];
                for(e1 = 0, n = (r = t).length; e1 < n; ++e1)a = r[e1], s.push(a[l]);
                return s;
            }
        }, pe = ye(function(e1, t) {
            return e1 < 0 ? t[t.length + e1] : t[e1];
        }), fe = ye(function(e1, t) {
            var r, n, s;
            for(r = 0, n = t.length; r < n; ++r)if (s = r, t[r] === e1) return s;
        }), de = ye(function(e1, t) {
            var r, n, s, i = [];
            for(r = 0, n = t.length; r < n; ++r)s = r, t[r] === e1 && i.push(s);
            return i;
        }), he = ye(function(e1, t) {
            var r, n, s;
            for(r = 0, n = t.length; r < n; ++r)if (s = r, e1(t[r])) return s;
        }), me = ye(function(e1, t) {
            var r, n, s, i = [];
            for(r = 0, n = t.length; r < n; ++r)s = r, e1(t[r]) && i.push(s);
            return i;
        }), Io = {
            each: e1,
            map: t,
            filter: n,
            compact: r,
            reject: s,
            remove: i,
            partition: o,
            find: a,
            head: u,
            first: l,
            tail: c,
            last: p,
            initial: f,
            empty: d,
            reverse: h,
            difference: D,
            intersection: w,
            union: _,
            countBy: k,
            groupBy: B,
            fold: y,
            fold1: x,
            foldl: E,
            foldl1: C,
            foldr: S,
            foldr1: b,
            unfoldr: v,
            andList: L,
            orList: P,
            any: I,
            all: F,
            unique: m,
            uniqueBy: g,
            sort: N,
            sortWith: O,
            sortBy: U,
            sum: j,
            product: V,
            mean: K,
            average: M,
            concat: A,
            concatMap: T,
            flatten: R,
            maximum: $,
            minimum: q,
            maximumBy: G,
            minimumBy: W,
            scan: X,
            scan1: H,
            scanl: z,
            scanl1: J,
            scanr: Q,
            scanr1: Y,
            slice: Z,
            take: ee,
            drop: te,
            splitAt: re,
            takeWhile: ne,
            dropWhile: se,
            span: ie,
            breakList: oe,
            zip: ae,
            zipWith: ue,
            zipAll: le,
            zipAllWith: ce,
            at: pe,
            elemIndex: fe,
            elemIndices: de,
            findIndex: he,
            findIndices: me
        };
    }
    function Qo() {
        if (Oo) return No;
        var e1, t, r, n, s, i, o, a, u, l, c, p, f, d;
        function h(e1, t) {
            var r, n = function(s) {
                return e1.length > 1 ? function() {
                    var i = s ? s.concat() : [];
                    return r = t && r || this, i.push.apply(i, arguments) < e1.length && arguments.length ? n.call(r, i) : e1.apply(r, i);
                } : e1;
            };
            return n();
        }
        return Oo = 1, e1 = function(e1) {
            var t, r, n = [];
            for(t in e1)r = e1[t], n.push(r);
            return n;
        }, t = function(e1) {
            var t, r = [];
            for(t in e1)r.push(t);
            return r;
        }, r = function(e1) {
            var t, r, n, s = {};
            for(t = 0, r = e1.length; t < r; ++t)s[(n = e1[t])[0]] = n[1];
            return s;
        }, n = function(e1) {
            var t, r, n = [];
            for(t in e1)r = e1[t], n.push([
                t,
                r
            ]);
            return n;
        }, s = h(function(e1, t) {
            var r, n, s, i = {};
            for(r = 0, n = e1.length; r < n; ++r)s = r, i[e1[r]] = t[s];
            return i;
        }), i = function(e1) {
            var t, r, n, s;
            for(n in t = [], r = [], e1)s = e1[n], t.push(n), r.push(s);
            return [
                t,
                r
            ];
        }, o = function(e1) {
            var t;
            for(t in e1)return !1;
            return !0;
        }, a = h(function(e1, t) {
            var r;
            for(r in t)e1(t[r]);
            return t;
        }), u = h(function(e1, t) {
            var r, n, s = {};
            for(r in t)n = t[r], s[r] = e1(n);
            return s;
        }), l = function(e1) {
            var t, r, n = {};
            for(t in e1)(r = e1[t]) && (n[t] = r);
            return n;
        }, c = h(function(e1, t) {
            var r, n, s = {};
            for(r in t)e1(n = t[r]) && (s[r] = n);
            return s;
        }), p = h(function(e1, t) {
            var r, n, s = {};
            for(r in t)e1(n = t[r]) || (s[r] = n);
            return s;
        }), f = h(function(e1, t) {
            var r, n, s, i;
            for(s in r = {}, n = {}, t)(e1(i = t[s]) ? r : n)[s] = i;
            return [
                r,
                n
            ];
        }), d = h(function(e1, t) {
            var r, n;
            for(r in t)if (e1(n = t[r])) return n;
        }), No = {
            values: e1,
            keys: t,
            pairsToObj: r,
            objToPairs: n,
            listsToObj: s,
            objToLists: i,
            empty: o,
            each: a,
            map: u,
            filter: c,
            compact: l,
            reject: p,
            partition: f,
            find: d
        };
    }
    function Yo() {
        if (jo) return Uo;
        var e1, t, r, n, s, i, o, a, u, l, c;
        function p(e1, t) {
            var r, n = function(s) {
                return e1.length > 1 ? function() {
                    var i = s ? s.concat() : [];
                    return r = t && r || this, i.push.apply(i, arguments) < e1.length && arguments.length ? n.call(r, i) : e1.apply(r, i);
                } : e1;
            };
            return n();
        }
        return jo = 1, e1 = p(function(e1, t) {
            return t.split(e1);
        }), t = p(function(e1, t) {
            return t.join(e1);
        }), r = function(e1) {
            return e1.length ? e1.split("\n") : [];
        }, n = function(e1) {
            return e1.join("\n");
        }, s = function(e1) {
            return e1.length ? e1.split(/[ ]+/) : [];
        }, i = function(e1) {
            return e1.join(" ");
        }, o = function(e1) {
            return e1.split("");
        }, a = function(e1) {
            return e1.join("");
        }, u = function(e1) {
            return e1.split("").reverse().join("");
        }, l = p(function(e1, t) {
            var r, n;
            for(r = "", n = 0; n < e1; ++n)r += t;
            return r;
        }), c = function(e1) {
            return e1.replace(/[-_]+(.)?/g, function(e1, t) {
                return (null != t ? t : "").toUpperCase();
            });
        }, Uo = {
            split: e1,
            join: t,
            lines: r,
            unlines: n,
            words: s,
            unwords: i,
            chars: o,
            unchars: a,
            reverse: u,
            repeat: l,
            capitalize: function(e1) {
                return e1.charAt(0).toUpperCase() + e1.slice(1);
            },
            camelize: c,
            dasherize: function(e1) {
                return e1.replace(/([^-A-Z])([A-Z]+)/g, function(e1, t, r) {
                    return t + "-" + (r.length > 1 ? r : r.toLowerCase());
                }).replace(/^([A-Z]+)/, function(e1, t) {
                    return t.length > 1 ? t + "-" : t.toLowerCase();
                });
            }
        };
    }
    function Zo() {
        if (Ko) return Vo;
        var e1, t, r, n, s, i, o, a, u, l, c, p, f, d, h, m, g, y, E, x, C, S, b, v, A, T, R, D, w, _, k, B;
        function L(e1, t) {
            var r, n = function(s) {
                return e1.length > 1 ? function() {
                    var i = s ? s.concat() : [];
                    return r = t && r || this, i.push.apply(i, arguments) < e1.length && arguments.length ? n.call(r, i) : e1.apply(r, i);
                } : e1;
            };
            return n();
        }
        return Ko = 1, e1 = L(function(e1, t) {
            return e1 > t ? e1 : t;
        }), t = L(function(e1, t) {
            return e1 < t ? e1 : t;
        }), r = function(e1) {
            return -e1;
        }, n = Math.abs, s = function(e1) {
            return e1 < 0 ? -1 : e1 > 0 ? 1 : 0;
        }, i = L(function(e1, t) {
            return ~~(e1 / t);
        }), o = L(function(e1, t) {
            return e1 % t;
        }), a = L(function(e1, t) {
            return Math.floor(e1 / t);
        }), u = L(function(e1, t) {
            var r;
            return (e1 % (r = t) + r) % r;
        }), l = function(e1) {
            return 1 / e1;
        }, p = 2 * (c = Math.PI), f = Math.exp, d = Math.sqrt, h = Math.log, m = L(function(e1, t) {
            return Math.pow(e1, t);
        }), g = Math.sin, y = Math.tan, E = Math.cos, x = Math.asin, C = Math.acos, S = Math.atan, b = L(function(e1, t) {
            return Math.atan2(e1, t);
        }), v = function(e1) {
            return ~~e1;
        }, A = Math.round, T = Math.ceil, R = Math.floor, D = function(e1) {
            return e1 != e1;
        }, w = function(e1) {
            return e1 % 2 == 0;
        }, _ = function(e1) {
            return e1 % 2 != 0;
        }, k = L(function(e1, t) {
            var r;
            for(e1 = Math.abs(e1), t = Math.abs(t); 0 !== t;)r = e1 % t, e1 = t, t = r;
            return e1;
        }), B = L(function(e1, t) {
            return Math.abs(Math.floor(e1 / k(e1, t) * t));
        }), Vo = {
            max: e1,
            min: t,
            negate: r,
            abs: n,
            signum: s,
            quot: i,
            rem: o,
            div: a,
            mod: u,
            recip: l,
            pi: c,
            tau: p,
            exp: f,
            sqrt: d,
            ln: h,
            pow: m,
            sin: g,
            tan: y,
            cos: E,
            acos: C,
            asin: x,
            atan: S,
            atan2: b,
            truncate: v,
            round: A,
            ceiling: T,
            floor: R,
            isItNaN: D,
            even: w,
            odd: _,
            gcd: k,
            lcm: B
        };
    }
    function ea() {
        if ($o) return Mo;
        $o = 1;
        var e1, t, r, n, s, i, o, a, u, l = {}.toString;
        function c(e1, t) {
            var r, n = function(s) {
                return e1.length > 1 ? function() {
                    var i = s ? s.concat() : [];
                    return r = t && r || this, i.push.apply(i, arguments) < e1.length && arguments.length ? n.call(r, i) : e1.apply(r, i);
                } : e1;
            };
            return n();
        }
        return e1 = Ho(), t = Jo(), r = Qo(), n = Yo(), s = Zo(), i = function(e1) {
            return e1;
        }, o = c(function(e1, t) {
            return l.call(t).slice(8, -1) === e1;
        }), a = c(function(e1, t) {
            var r, n = [];
            for(r = 0; r < e1; ++r)n.push(t);
            return n;
        }), n.empty = t.empty, n.slice = t.slice, n.take = t.take, n.drop = t.drop, n.splitAt = t.splitAt, n.takeWhile = t.takeWhile, n.dropWhile = t.dropWhile, n.span = t.span, n.breakStr = t.breakList, (u = {
            Func: e1,
            List: t,
            Obj: r,
            Str: n,
            Num: s,
            id: i,
            isType: o,
            replicate: a
        }).each = t.each, u.map = t.map, u.filter = t.filter, u.compact = t.compact, u.reject = t.reject, u.partition = t.partition, u.find = t.find, u.head = t.head, u.first = t.first, u.tail = t.tail, u.last = t.last, u.initial = t.initial, u.empty = t.empty, u.reverse = t.reverse, u.difference = t.difference, u.intersection = t.intersection, u.union = t.union, u.countBy = t.countBy, u.groupBy = t.groupBy, u.fold = t.fold, u.foldl = t.foldl, u.fold1 = t.fold1, u.foldl1 = t.foldl1, u.foldr = t.foldr, u.foldr1 = t.foldr1, u.unfoldr = t.unfoldr, u.andList = t.andList, u.orList = t.orList, u.any = t.any, u.all = t.all, u.unique = t.unique, u.uniqueBy = t.uniqueBy, u.sort = t.sort, u.sortWith = t.sortWith, u.sortBy = t.sortBy, u.sum = t.sum, u.product = t.product, u.mean = t.mean, u.average = t.average, u.concat = t.concat, u.concatMap = t.concatMap, u.flatten = t.flatten, u.maximum = t.maximum, u.minimum = t.minimum, u.maximumBy = t.maximumBy, u.minimumBy = t.minimumBy, u.scan = t.scan, u.scanl = t.scanl, u.scan1 = t.scan1, u.scanl1 = t.scanl1, u.scanr = t.scanr, u.scanr1 = t.scanr1, u.slice = t.slice, u.take = t.take, u.drop = t.drop, u.splitAt = t.splitAt, u.takeWhile = t.takeWhile, u.dropWhile = t.dropWhile, u.span = t.span, u.breakList = t.breakList, u.zip = t.zip, u.zipWith = t.zipWith, u.zipAll = t.zipAll, u.zipAllWith = t.zipAllWith, u.at = t.at, u.elemIndex = t.elemIndex, u.elemIndices = t.elemIndices, u.findIndex = t.findIndex, u.findIndices = t.findIndices, u.apply = e1.apply, u.curry = e1.curry, u.flip = e1.flip, u.fix = e1.fix, u.over = e1.over, u.split = n.split, u.join = n.join, u.lines = n.lines, u.unlines = n.unlines, u.words = n.words, u.unwords = n.unwords, u.chars = n.chars, u.unchars = n.unchars, u.repeat = n.repeat, u.capitalize = n.capitalize, u.camelize = n.camelize, u.dasherize = n.dasherize, u.values = r.values, u.keys = r.keys, u.pairsToObj = r.pairsToObj, u.objToPairs = r.objToPairs, u.listsToObj = r.listsToObj, u.objToLists = r.objToLists, u.max = s.max, u.min = s.min, u.negate = s.negate, u.abs = s.abs, u.signum = s.signum, u.quot = s.quot, u.rem = s.rem, u.div = s.div, u.mod = s.mod, u.recip = s.recip, u.pi = s.pi, u.tau = s.tau, u.exp = s.exp, u.sqrt = s.sqrt, u.ln = s.ln, u.pow = s.pow, u.sin = s.sin, u.tan = s.tan, u.cos = s.cos, u.acos = s.acos, u.asin = s.asin, u.atan = s.atan, u.atan2 = s.atan2, u.truncate = s.truncate, u.round = s.round, u.ceiling = s.ceiling, u.floor = s.floor, u.isItNaN = s.isItNaN, u.even = s.even, u.odd = s.odd, u.gcd = s.gcd, u.lcm = s.lcm, u.VERSION = "1.2.1", Mo = u;
    }
    function ta() {
        return qo || (qo = 1, (function() {
            var e1, t, r;
            function n(e1, t) {
                if (e1[0] === t) return e1.shift();
                throw new Error("Expected '" + t + "', but got '" + e1[0] + "' instead in " + JSON.stringify(e1) + ".");
            }
            function s(e1, t) {
                if (e1[0] === t) return e1.shift();
            }
            function i(e1, t, r) {
                var i, o, a, u;
                for(i = t[0], o = t[1], r && n(e1, i), a = [], u = "," + (r ? o : ""); e1.length && r && e1[0] !== o;)a.push(c(e1, u)), s(e1, ",");
                return r && n(e1, o), a;
            }
            function o(e1, t) {
                return i(e1, [
                    "[",
                    "]"
                ], t);
            }
            function a(e1, t) {
                return i(e1, [
                    "(",
                    ")"
                ], t);
            }
            function u(e1, t) {
                var r, i, o;
                for(t && n(e1, "{"), r = {}, i = "," + (t ? "}" : ""); e1.length && (!t || "}" !== e1[0]);)o = l(e1, ":"), n(e1, ":"), r[o] = c(e1, i), s(e1, ",");
                return t && n(e1, "}"), r;
            }
            function l(e1, t) {
                var r;
                for(null == t && (t = ""), r = ""; e1.length && -1 === t.indexOf(e1[0]);)r += e1.shift();
                return r;
            }
            function c(e1, t) {
                switch(e1[0]){
                    case "[":
                        return o(e1, !0);
                    case "(":
                        return a(e1, !0);
                    case "{":
                        return u(e1, !0);
                    default:
                        return l(e1, t);
                }
            }
            function p(e1) {
                return !e1;
            }
            e1 = ea().reject, t = /\[\]\(\)}{:,/.source, r = RegExp("(\"(?:\\\\\"|[^\"])*\")|('(?:\\\\'|[^'])*')|(/(?:\\\\/|[^/])*/[a-zA-Z]*)|(#.*#)|([" + t + "])|([^\\s" + t + "](?:\\s*[^\\s" + t + "]+)*)|\\s*"), zo.exports = function(t, n, s) {
                var i;
                if (null == s && (s = {}), !s.explicit && 1 === t.length && "String" === t[0].type) return n;
                if (i = function(e1, t, r) {
                    var n, s, i, l, p, f, d, h;
                    return s = (n = t[0]).type, i = n.structure, l = e1.concat(), r.explicit || 1 !== t.length || (s || !i) && "Array" !== s && "Object" !== s ? f = c(e1) : (p = "array" === i || "Array" === s ? o(e1, "[" === e1[0]) : "tuple" === i ? a(e1, "(" === e1[0]) : u(e1, "{" === e1[0]), f = e1.length ? c("array" === i || "Array" === s ? ((d = l).unshift("["), d.push("]"), d) : ((h = l).unshift("("), h.push(")"), h)) : p), f;
                }(e1(p, n.split(r)), t, s), !i) throw new Error("Error parsing '" + n + "'.");
                return i;
            };
        }).call(this)), Xo;
    }
    var ra, na = {}, sa = {
        get exports () {
            return na;
        },
        set exports (e){
            na = e;
        }
    }, ia = {}, oa = {
        get exports () {
            return ia;
        },
        set exports (e){
            ia = e;
        }
    }, aa = {}, ua = {
        get exports () {
            return aa;
        },
        set exports (e){
            aa = e;
        }
    };
    function la() {
        return ra || (ra = 1, (function() {
            var e1, t;
            function r(e1) {
                var t;
                if (null == (t = e1[0])) throw new Error("Unexpected end of input.");
                return t;
            }
            function n(t) {
                var n;
                if (n = r(t), !e1.test(n)) throw new Error("Expected text, got '" + n + "' instead.");
                return t.shift();
            }
            function s(e1, t) {
                var n;
                if ((n = r(e1)) !== t) throw new Error("Expected '" + t + "', got '" + n + "' instead.");
                return e1.shift();
            }
            function i(e1, t) {
                return e1[0] === t ? e1.shift() : null;
            }
            function o(e1) {
                var t;
                return t = n(e1), s(e1, ":"), [
                    t,
                    l(e1)
                ];
            }
            function a(e1) {
                switch(e1[0]){
                    case "[":
                        return function(e1) {
                            var t;
                            if (s(e1, "["), "]" === r(e1)) throw new Error("Must specify type of Array - eg. [Type], got [] instead.");
                            return t = l(e1), s(e1, "]"), {
                                structure: "array",
                                of: t
                            };
                        }(e1);
                    case "(":
                        return function(e1) {
                            var t;
                            if (t = [], s(e1, "("), ")" === r(e1)) throw new Error("Tuple must be of at least length 1 - eg. (Type), got () instead.");
                            for(; t.push(l(e1)), i(e1, ","), ")" !== r(e1););
                            return s(e1, ")"), {
                                structure: "tuple",
                                of: t
                            };
                        }(e1);
                    case "{":
                        return function(e1) {
                            var t, n, a, u, l;
                            for(t = {}, s(e1, "{"), n = !1;;){
                                if (i(e1, "...")) {
                                    n = !0;
                                    break;
                                }
                                if (u = (a = o(e1))[0], l = a[1], t[u] = l, i(e1, ","), "}" === r(e1)) break;
                            }
                            return s(e1, "}"), {
                                structure: "fields",
                                of: t,
                                subset: n
                            };
                        }(e1);
                }
            }
            function u(t) {
                var i, o, u, l;
                if ((o = "*" === (i = r(t))) || e1.test(i)) return u = o ? s(t, "*") : n(t), (l = a(t)) ? (l.type = u, l) : {
                    type: u
                };
                if (!(l = a(t))) throw new Error("Unexpected character: " + i);
                return l;
            }
            function l(e1) {
                var t, n, s, o, a, l;
                if ("::" === r(e1)) throw new Error("No comment before comment separator '::' found.");
                for(null != (t = e1[1]) && "::" === t && (e1.shift(), e1.shift()), n = [], s = {}, "Maybe" === r(e1) && (e1.shift(), n = [
                    {
                        type: "Undefined"
                    },
                    {
                        type: "Null"
                    }
                ], s = {
                    Undefined: !0,
                    Null: !0
                }); a = (o = u(e1)).type, l = o.structure, s[a] || n.push(o), null == l && (s[a] = !0), i(e1, "|"););
                return n;
            }
            e1 = /[\$\w]+/, t = RegExp("\\.\\.\\.|::|->|" + e1.source + "|\\S", "g"), ua.exports = function(e1) {
                var r;
                if (!e1.length) throw new Error("No type specified.");
                if (function(e1, t) {
                    var r = -1, n = t.length >>> 0;
                    for(; ++r < n;)if (e1 === t[r]) return !0;
                    return !1;
                }("->", r = e1.match(t) || [])) throw new Error("Function types are not supported. To validate that something is a function, you may use 'Function'.");
                try {
                    return l(r);
                } catch (t) {
                    throw new Error(t.message + " - Remaining tokens: " + JSON.stringify(r) + " - Initial input: '" + e1 + "'");
                }
            };
        }).call(this)), aa;
    }
    var ca, pa, fa, da, ha, ma, ga, ya, Ea, xa, Ca, Sa, ba, va, Aa, Ta, Ra, Da, wa, _a, ka, Ba, La, Pa, Ia, Fa, Na, Oa, Ua = {}, ja = {
        get exports () {
            return Ua;
        },
        set exports (e){
            Ua = e;
        }
    };
    function Va() {
        return ca || (ca = 1, (function() {
            var e1, t, r, n, s, i, o = {}.toString;
            function a(e1, t, n) {
                if (!(e1 instanceof Object)) return !1;
                switch(t.structure){
                    case "fields":
                        return function(e1, t, r) {
                            var n, s, i, o, a, u, c;
                            for(i in n = {}, s = 0, e1)n[i] = !0, s++;
                            for(a in o = 0, u = t.of){
                                if (c = u[a], !l(e1[a], c, r)) return !1;
                                n[a] && o++;
                            }
                            return t.subset || s === o;
                        }(e1, t, n);
                    case "array":
                        return function(e1, t, n) {
                            return r(function(e1) {
                                return l(e1, t.of, n);
                            }, e1);
                        }(e1, t, n);
                    case "tuple":
                        return function(e1, t, r) {
                            var n, s, i, o, a;
                            for(n = 0, s = 0, o = (i = t.of).length; s < o; ++s){
                                if (a = i[s], !l(e1[n], a, r)) return !1;
                                n++;
                            }
                            return e1.length <= n;
                        }(e1, t, n);
                }
            }
            function u(e1, t, r) {
                var n, u, l, c;
                if (n = t.type, u = t.structure, n) return "*" === n || ((l = r.customTypes[n] || s[n]) ? (void 0 === l.typeOf || l.typeOf === o.call(e1).slice(8, -1)) && l.validate(e1) : n === o.call(e1).slice(8, -1) && (!u || a(e1, t, r)));
                if (u) return (!(c = i[u]) || c === o.call(e1).slice(8, -1)) && a(e1, t, r);
                throw new Error("No type defined. Input: " + e1 + ".");
            }
            function l(e1, r, n) {
                if ("Array" !== o.call(r).slice(8, -1)) throw new Error("Types must be in an array. Input: " + e1 + ".");
                return t(function(t) {
                    return u(e1, t, n);
                }, r);
            }
            e1 = ea(), t = e1.any, r = e1.all, n = e1.isItNaN, s = {
                Number: {
                    typeOf: "Number",
                    validate: function(e1) {
                        return !n(e1);
                    }
                },
                NaN: {
                    typeOf: "Number",
                    validate: n
                },
                Int: {
                    typeOf: "Number",
                    validate: function(e1) {
                        return !n(e1) && e1 % 1 == 0;
                    }
                },
                Float: {
                    typeOf: "Number",
                    validate: function(e1) {
                        return !n(e1);
                    }
                },
                Date: {
                    typeOf: "Date",
                    validate: function(e1) {
                        return !n(e1.getTime());
                    }
                }
            }, i = {
                array: "Array",
                tuple: "Array"
            }, ja.exports = function(e1, t, r) {
                return null == r && (r = {}), null == r.customTypes && (r.customTypes = {}), l(t, e1, r);
            };
        }).call(this)), Ua;
    }
    function Ka() {
        return pa || (pa = 1, (function() {
            var e1, t, r;
            e1 = la(), t = Va(), r = function(r, n, s) {
                return t(e1(r), n, s);
            }, oa.exports = {
                VERSION: "0.4.0",
                typeCheck: r,
                parsedTypeCheck: t,
                parseType: e1
            };
        }).call(this)), ia;
    }
    function Ma() {
        return fa || (fa = 1, (function() {
            var e1, t, r = {}.toString;
            function n(e1, t, n) {
                var s, i;
                return "Array" !== r.call(e1).slice(8, -1) ? {
                    type: "Nothing"
                } : (s = t.of, {
                    type: "Just",
                    value: function() {
                        var t, r, a, u = [];
                        for(t = 0, a = (r = e1).length; t < a; ++t)i = r[t], u.push(o(i, s, n));
                        return u;
                    }()
                });
            }
            function s(e1, t, n) {
                var s, i, a;
                return "Object" !== r.call(e1).slice(8, -1) ? {
                    type: "Nothing"
                } : (s = t.of, {
                    type: "Just",
                    value: function() {
                        var t, r = {};
                        for(i in t = e1)a = t[i], r[o(i, [
                            {
                                type: "String"
                            }
                        ], n)] = o(a, s[i] || [
                            {
                                type: "*"
                            }
                        ], n);
                        return r;
                    }()
                });
            }
            function i(e1, i, a) {
                var u, l, c, p;
                if (u = i.type, l = i.structure, u) {
                    if (!(c = (null != (p = a.customTypes[u]) ? p.cast : void 0) || t[u])) throw new Error("Type not defined: " + u + ".");
                    return c(e1, a, o);
                }
                switch(l){
                    case "array":
                        return n(e1, i, a);
                    case "tuple":
                        return function(e1, t, n) {
                            var s, i, a, u, l, c, p;
                            if ("Array" !== r.call(e1).slice(8, -1)) return {
                                type: "Nothing"
                            };
                            for(s = [], i = 0, a = 0, l = (u = t.of).length; a < l; ++a)c = u[a], p = o(e1[i], c, n), "Undefined" !== r.call(p).slice(8, -1) && s.push(p), i++;
                            return e1.length <= i ? {
                                type: "Just",
                                value: s
                            } : {
                                type: "Nothing"
                            };
                        }(e1, i, a);
                    case "fields":
                        return s(e1, i, a);
                }
            }
            function o(t, r, n) {
                var s, o, a, u, l, c;
                for(s = 0, o = r.length; s < o; ++s)if (l = (u = i(t, a = r[s], n)).type, c = u.value, "Nothing" !== l && e1([
                    a
                ], c, {
                    customTypes: n.customTypes
                })) return c;
                throw new Error("Value " + JSON.stringify(t) + " does not type check against " + JSON.stringify(r) + ".");
            }
            e1 = Ka().parsedTypeCheck, t = {
                "*": function(e1, t) {
                    switch(r.call(e1).slice(8, -1)){
                        case "Array":
                            return i(e1, {
                                type: "Array"
                            }, t);
                        case "Object":
                            return i(e1, {
                                type: "Object"
                            }, t);
                        default:
                            return {
                                type: "Just",
                                value: o(e1, [
                                    {
                                        type: "Undefined"
                                    },
                                    {
                                        type: "Null"
                                    },
                                    {
                                        type: "NaN"
                                    },
                                    {
                                        type: "Boolean"
                                    },
                                    {
                                        type: "Number"
                                    },
                                    {
                                        type: "Date"
                                    },
                                    {
                                        type: "RegExp"
                                    },
                                    {
                                        type: "Array"
                                    },
                                    {
                                        type: "Object"
                                    },
                                    {
                                        type: "String"
                                    }
                                ], (t.explicit = !0, t))
                            };
                    }
                },
                Undefined: function(e1) {
                    return "undefined" === e1 || void 0 === e1 ? {
                        type: "Just",
                        value: void 0
                    } : {
                        type: "Nothing"
                    };
                },
                Null: function(e1) {
                    return "null" === e1 ? {
                        type: "Just",
                        value: null
                    } : {
                        type: "Nothing"
                    };
                },
                NaN: function(e1) {
                    return "NaN" === e1 ? {
                        type: "Just",
                        value: NaN
                    } : {
                        type: "Nothing"
                    };
                },
                Boolean: function(e1) {
                    return "true" === e1 ? {
                        type: "Just",
                        value: !0
                    } : "false" === e1 ? {
                        type: "Just",
                        value: !1
                    } : {
                        type: "Nothing"
                    };
                },
                Number: function(e1) {
                    return {
                        type: "Just",
                        value: +e1
                    };
                },
                Int: function(e1) {
                    return {
                        type: "Just",
                        value: +e1
                    };
                },
                Float: function(e1) {
                    return {
                        type: "Just",
                        value: +e1
                    };
                },
                Date: function(e1, t) {
                    var r;
                    return (r = /^\#([\s\S]*)\#$/.exec(e1)) ? {
                        type: "Just",
                        value: new Date(+r[1] || r[1])
                    } : t.explicit ? {
                        type: "Nothing"
                    } : {
                        type: "Just",
                        value: new Date(+e1 || e1)
                    };
                },
                RegExp: function(e1, t) {
                    var r;
                    return (r = /^\/([\s\S]*)\/([gimy]*)$/.exec(e1)) ? {
                        type: "Just",
                        value: new RegExp(r[1], r[2])
                    } : t.explicit ? {
                        type: "Nothing"
                    } : {
                        type: "Just",
                        value: new RegExp(e1)
                    };
                },
                Array: function(e1, t) {
                    return n(e1, {
                        of: [
                            {
                                type: "*"
                            }
                        ]
                    }, t);
                },
                Object: function(e1, t) {
                    return s(e1, {
                        of: {}
                    }, t);
                },
                String: function(e1) {
                    var t, n;
                    return "String" !== r.call(e1).slice(8, -1) ? {
                        type: "Nothing"
                    } : (t = function(e1, t) {
                        return e1.replace(/\\([^u]|u[0-9a-fA-F]{4})/g, function(e1, r) {
                            switch(r[0]){
                                case t:
                                    return t;
                                case "\\":
                                    return "\\";
                                case "b":
                                    return "\b";
                                case "f":
                                    return "\f";
                                case "n":
                                    return "\n";
                                case "r":
                                    return "\r";
                                case "t":
                                    return "\t";
                                case "u":
                                    return JSON.parse('"' + e1 + '"');
                                default:
                                    return r;
                            }
                        });
                    }, (n = e1.match(/^'([\s\S]*)'$/)) ? {
                        type: "Just",
                        value: t(n[1], "'")
                    } : (n = e1.match(/^"([\s\S]*)"$/)) ? {
                        type: "Just",
                        value: t(n[1], '"')
                    } : {
                        type: "Just",
                        value: e1
                    });
                }
            }, sa.exports = function(e1, t, r) {
                return r.explicit || 1 !== t.length || "String" !== t[0].type ? o(e1, t, r) : e1;
            };
        }).call(this)), na;
    }
    function $a() {
        if (ma) return ha;
        ma = 1;
        const e1 = function() {
            return da || (da = 1, (function() {
                var e1, t, r, n, s;
                e1 = ta(), t = Ma(), r = Ka().parseType, n = function(r, n, s) {
                    return null == s && (s = {}), null == s.explicit && (s.explicit = !1), null == s.customTypes && (s.customTypes = {}), t(e1(r, n, s), r, s);
                }, s = function(e1, t, s) {
                    return n(r(e1), t, s);
                }, Wo.exports = {
                    VERSION: "0.4.1",
                    parse: s,
                    parsedTypeParse: n
                };
            }).call(this)), Go;
        }(), { Legacy: { ConfigOps: t } } = Qs(), { directivesPattern: r } = jr(), n = Gi()("eslint:config-comment-parser");
        return ha = class {
            parseStringConfig(e1, t) {
                n("Parsing String config");
                const r = {};
                return e1.replace(/\s*([:,])\s*/gu, "$1").split(/\s|,+/u).forEach((e1)=>{
                    if (!e1) return;
                    const [n, s = null] = e1.split(":");
                    r[n] = {
                        value: s,
                        comment: t
                    };
                }), r;
            }
            parseJsonConfig(r, s) {
                n("Parsing JSON config");
                let i = {};
                try {
                    if (i = e1.parse("Object", r) || {}, t.isEverySeverityValid(i)) return {
                        success: !0,
                        config: i
                    };
                } catch  {
                    n("Levn parsing failed; falling back to manual parsing.");
                }
                i = {};
                const o = r.replace(/([-a-zA-Z0-9/]+):/gu, '"$1":').replace(/(\]|[0-9])\s+(?=")/u, "$1,");
                try {
                    i = JSON.parse(`{${o}}`);
                } catch (e1) {
                    return n("Manual parsing failed."), {
                        success: !1,
                        error: {
                            ruleId: null,
                            fatal: !0,
                            severity: 2,
                            message: `Failed to parse JSON from '${o}': ${e1.message}`,
                            line: s.start.line,
                            column: s.start.column + 1,
                            nodeType: null
                        }
                    };
                }
                return {
                    success: !0,
                    config: i
                };
            }
            parseListConfig(e1) {
                n("Parsing list config");
                const t = {};
                return e1.split(",").forEach((e1)=>{
                    const r = e1.trim().replace(/^(?<quote>['"]?)(?<ruleId>.*)\k<quote>$/su, "$<ruleId>");
                    r && (t[r] = !0);
                }), t;
            }
            extractDirectiveComment(e1) {
                const t = /\s-{2,}\s/u.exec(e1);
                if (!t) return {
                    directivePart: e1.trim(),
                    justificationPart: ""
                };
                return {
                    directivePart: e1.slice(0, t.index).trim(),
                    justificationPart: e1.slice(t.index + t[0].length).trim()
                };
            }
            parseDirective(e1) {
                const { directivePart: t } = this.extractDirectiveComment(e1.value), n = r.exec(t), s = n[1];
                return {
                    directiveText: s,
                    directiveValue: t.slice(n.index + s.length)
                };
            }
        }, ha;
    }
    function qa() {
        if (ya) return ga;
        ya = 1;
        const { isCommentToken: e1 } = Hi(), t = ko(), r = Ur(), n = Wi(), s = Bo(), { directivesPattern: i } = jr(), o = $a(), a = dr(), u = new o;
        function l(e1) {
            switch(e1){
                case "off":
                    return "off";
                case !0:
                case "true":
                case "writeable":
                case "writable":
                    return "writable";
                case null:
                case !1:
                case "false":
                case "readable":
                case "readonly":
                    return "readonly";
                default:
                    throw new Error(`'${e1}' is not a valid configuration for a global (use 'readonly', 'writable', or 'off')`);
            }
        }
        function c(e1, t, r, n) {
            if (function(e1, t) {
                return e1.range[0] <= t.range[0] && e1.range[1] >= t.range[0] || t.range[0] <= e1.range[0] && t.range[1] >= e1.range[0];
            }(t, r)) return !1;
            const [s, i] = t.range[1] <= r.range[0] ? [
                t,
                r
            ] : [
                r,
                t
            ], o = e1.getLastToken(s) || s, a = e1.getFirstToken(i) || i;
            let u = o;
            for(; u !== a;){
                const t = e1.getTokenAfter(u, {
                    includeComments: !0
                });
                if (u.range[1] !== t.range[0] || n && t !== a && "JSXText" === t.type && /\s/u.test(t.value)) return !0;
                u = t;
            }
            return !1;
        }
        const p = Symbol("caches");
        return ga = class extends t {
            constructor(e1, t){
                let s, i, o, a, u;
                "string" == typeof e1 ? (s = e1, i = t) : "object" == typeof e1 && null !== e1 && (s = e1.text, i = e1.ast, o = e1.parserServices, a = e1.scopeManager, u = e1.visitorKeys), function(e1) {
                    if (!e1.tokens) throw new Error("AST is missing the tokens array.");
                    if (!e1.comments) throw new Error("AST is missing the comments array.");
                    if (!e1.loc) throw new Error("AST is missing location information.");
                    if (!e1.range) throw new Error("AST is missing range information");
                }(i), super(i.tokens, i.comments), this[p] = new Map([
                    [
                        "scopes",
                        new WeakMap
                    ],
                    [
                        "vars",
                        new Map
                    ],
                    [
                        "configNodes",
                        void 0
                    ]
                ]), this.hasBOM = 65279 === s.charCodeAt(0), this.text = this.hasBOM ? s.slice(1) : s, this.ast = i, this.parserServices = o || {}, this.scopeManager = a || null, this.visitorKeys = u || n.DEFAULT_VISITOR_KEYS;
                const l = this.text.match(r.shebangPattern);
                l && i.comments.length && i.comments[0].value === l[1] && (i.comments[0].type = "Shebang"), this.tokensAndComments = function(e1, t) {
                    const r = [];
                    let n = 0, s = 0;
                    for(; n < e1.length || s < t.length;)s >= t.length || n < e1.length && e1[n].range[0] < t[s].range[0] ? r.push(e1[n++]) : r.push(t[s++]);
                    return r;
                }(i.tokens, i.comments), this.lines = [], this.lineStartIndices = [
                    0
                ];
                const c = r.createGlobalLinebreakMatcher();
                let f;
                for(; f = c.exec(this.text);)this.lines.push(this.text.slice(this.lineStartIndices[this.lineStartIndices.length - 1], f.index)), this.lineStartIndices.push(f.index + f[0].length);
                this.lines.push(this.text.slice(this.lineStartIndices[this.lineStartIndices.length - 1])), this._commentCache = new WeakMap, Object.freeze(this), Object.freeze(this.lines);
            }
            static splitLines(e1) {
                return e1.split(r.createGlobalLinebreakMatcher());
            }
            getText(e1, t, r) {
                return e1 ? this.text.slice(Math.max(e1.range[0] - (t || 0), 0), e1.range[1] + (r || 0)) : this.text;
            }
            getLines() {
                return this.lines;
            }
            getAllComments() {
                return this.ast.comments;
            }
            getComments(t) {
                if (this._commentCache.has(t)) return this._commentCache.get(t);
                const r = {
                    leading: [],
                    trailing: []
                };
                if ("Program" === t.type) 0 === t.body.length && (r.leading = t.comments);
                else {
                    (("BlockStatement" === t.type || "ClassBody" === t.type) && 0 === t.body.length || "ObjectExpression" === t.type && 0 === t.properties.length || "ArrayExpression" === t.type && 0 === t.elements.length || "SwitchStatement" === t.type && 0 === t.cases.length) && (r.trailing = this.getTokens(t, {
                        includeComments: !0,
                        filter: e1
                    }));
                    let n = this.getTokenBefore(t, {
                        includeComments: !0
                    });
                    for(; n && e1(n) && !(t.parent && "Program" !== t.parent.type && n.start < t.parent.start);)r.leading.push(n), n = this.getTokenBefore(n, {
                        includeComments: !0
                    });
                    for(r.leading.reverse(), n = this.getTokenAfter(t, {
                        includeComments: !0
                    }); n && e1(n) && !(t.parent && "Program" !== t.parent.type && n.end > t.parent.end);)r.trailing.push(n), n = this.getTokenAfter(n, {
                        includeComments: !0
                    });
                }
                return this._commentCache.set(t, r), r;
            }
            getJSDocComment(t) {
                const r = (t)=>{
                    const r = this.getTokenBefore(t, {
                        includeComments: !0
                    });
                    return r && e1(r) && "Block" === r.type && "*" === r.value.charAt(0) && t.loc.start.line - r.loc.end.line <= 1 ? r : null;
                };
                let n = t.parent;
                switch(t.type){
                    case "ClassDeclaration":
                    case "FunctionDeclaration":
                        return r("ExportDefaultDeclaration" === (s = n).type || "ExportNamedDeclaration" === s.type || "ExportAllDeclaration" === s.type || "ExportSpecifier" === s.type ? n : t);
                    case "ClassExpression":
                        return r(n.parent);
                    case "ArrowFunctionExpression":
                    case "FunctionExpression":
                        if ("CallExpression" !== n.type && "NewExpression" !== n.type) {
                            for(; !this.getCommentsBefore(n).length && !/Function/u.test(n.type) && "MethodDefinition" !== n.type && "Property" !== n.type && (n = n.parent, n););
                            if (n && "FunctionDeclaration" !== n.type && "Program" !== n.type) return r(n);
                        }
                        return r(t);
                    default:
                        return null;
                }
                var s;
            }
            getNodeByRangeIndex(e1) {
                let t = null;
                return n.traverse(this.ast, {
                    visitorKeys: this.visitorKeys,
                    enter (r) {
                        r.range[0] <= e1 && e1 < r.range[1] ? t = r : this.skip();
                    },
                    leave (e1) {
                        e1 === t && this.break();
                    }
                }), t;
            }
            isSpaceBetween(e1, t) {
                return c(this, e1, t, !1);
            }
            isSpaceBetweenTokens(e1, t) {
                return c(this, e1, t, !0);
            }
            getLocFromIndex(e1) {
                if ("number" != typeof e1) throw new TypeError("Expected `index` to be a number.");
                if (e1 < 0 || e1 > this.text.length) throw new RangeError(`Index out of range (requested index ${e1}, but source text has length ${this.text.length}).`);
                if (e1 === this.text.length) return {
                    line: this.lines.length,
                    column: this.lines[this.lines.length - 1].length
                };
                const t = e1 >= this.lineStartIndices[this.lineStartIndices.length - 1] ? this.lineStartIndices.length : this.lineStartIndices.findIndex((t)=>e1 < t);
                return {
                    line: t,
                    column: e1 - this.lineStartIndices[t - 1]
                };
            }
            getIndexFromLoc(e1) {
                if ("object" != typeof e1 || "number" != typeof e1.line || "number" != typeof e1.column) throw new TypeError("Expected `loc` to be an object with numeric `line` and `column` properties.");
                if (e1.line <= 0) throw new RangeError(`Line number out of range (line ${e1.line} requested). Line numbers should be 1-based.`);
                if (e1.line > this.lineStartIndices.length) throw new RangeError(`Line number out of range (line ${e1.line} requested, but only ${this.lineStartIndices.length} lines present).`);
                const t = this.lineStartIndices[e1.line - 1], r = e1.line === this.lineStartIndices.length ? this.text.length : this.lineStartIndices[e1.line], n = t + e1.column;
                if (e1.line === this.lineStartIndices.length && n > r || e1.line < this.lineStartIndices.length && n >= r) throw new RangeError(`Column number out of range (column ${e1.column} requested, but the length of line ${e1.line} is ${r - t}).`);
                return n;
            }
            getScope(e1) {
                if (!e1) throw new TypeError("Missing required argument: node.");
                const t = this[p].get("scopes"), r = t.get(e1);
                if (r) return r;
                const n = "Program" !== e1.type;
                for(let r = e1; r; r = r.parent){
                    const s = this.scopeManager.acquire(r, n);
                    if (s) return "function-expression-name" === s.type ? (t.set(e1, s.childScopes[0]), s.childScopes[0]) : (t.set(e1, s), s);
                }
                return t.set(e1, this.scopeManager.scopes[0]), this.scopeManager.scopes[0];
            }
            getDeclaredVariables(e1) {
                return this.scopeManager.getDeclaredVariables(e1);
            }
            getAncestors(e1) {
                if (!e1) throw new TypeError("Missing required argument: node.");
                const t = [];
                for(let r = e1.parent; r; r = r.parent)t.push(r);
                return t.reverse();
            }
            markVariableAsUsed(e1, t = this.ast) {
                const r = this.getScope(t);
                let n = r;
                "global" === r.type && r.childScopes.length > 0 && r.childScopes[0].block === this.ast && (n = r.childScopes[0]);
                for(let t = n; t; t = t.upper){
                    const r = t.variables.find((t)=>t.name === e1);
                    if (r) return r.eslintUsed = !0, !0;
                }
                return !1;
            }
            getInlineConfigNodes() {
                let e1 = this[p].get("configNodes");
                return e1 || (e1 = this.ast.comments.filter((e1)=>{
                    if ("Shebang" === e1.type) return !1;
                    const { directivePart: t } = u.extractDirectiveComment(e1.value), r = i.exec(t);
                    return !!r && ("Line" !== e1.type || !!/^eslint-disable-(next-)?line$/u.test(r[1]));
                }), this[p].set("configNodes", e1), e1);
            }
            applyLanguageOptions(e1) {
                const t = Object.assign(Object.create(null), function(e1) {
                    switch(e1){
                        case 3:
                            return s.es3;
                        case 5:
                            return s.es5;
                        default:
                            return e1 < 2015 ? s[`es${e1 + 2009}`] : s[`es${e1}`];
                    }
                }(e1.ecmaVersion), "commonjs" === e1.sourceType ? s.commonjs : void 0, e1.globals);
                this[p].get("vars").set("configGlobals", t);
            }
            applyInlineConfig() {
                const e1 = [], t = [], r = {}, n = Object.create(null);
                this.getInlineConfigNodes().forEach((s)=>{
                    const { directiveText: i, directiveValue: o } = u.parseDirective(s);
                    switch(i){
                        case "exported":
                            Object.assign(r, u.parseStringConfig(o, s));
                            break;
                        case "globals":
                        case "global":
                            for (const [t, { value: r }] of Object.entries(u.parseStringConfig(o, s))){
                                let i;
                                try {
                                    i = l(r);
                                } catch (t) {
                                    e1.push({
                                        ruleId: null,
                                        loc: s.loc,
                                        message: t.message
                                    });
                                    continue;
                                }
                                n[t] ? (n[t].comments.push(s), n[t].value = i) : n[t] = {
                                    comments: [
                                        s
                                    ],
                                    value: i
                                };
                            }
                            break;
                        case "eslint":
                            {
                                const r = u.parseJsonConfig(o, s.loc);
                                r.success ? t.push({
                                    config: {
                                        rules: r.config
                                    },
                                    node: s
                                }) : e1.push(r.error);
                                break;
                            }
                    }
                });
                const s = this[p].get("vars");
                return s.set("inlineGlobals", n), s.set("exportedVariables", r), {
                    configs: t,
                    problems: e1
                };
            }
            finalize() {
                const e1 = this[p].get("vars"), t = this.scopeManager.scopes[0], r = e1.get("configGlobals"), n = e1.get("inlineGlobals"), s = e1.get("exportedVariables");
                !function(e1, t = {}, r = {}) {
                    for (const n of new Set([
                        ...Object.keys(t),
                        ...Object.keys(r)
                    ])){
                        const s = void 0 === t[n] ? void 0 : l(t[n]), i = r[n] && r[n].value || s, o = r[n] && r[n].comments;
                        if ("off" === i) continue;
                        let u = e1.set.get(n);
                        u || (u = new a.Variable(n, e1), e1.variables.push(u), e1.set.set(n, u)), u.eslintImplicitGlobalSetting = s, u.eslintExplicitGlobal = void 0 !== o, u.eslintExplicitGlobalComments = o, u.writeable = "writable" === i;
                    }
                    e1.through = e1.through.filter((t)=>{
                        const r = t.identifier.name, n = e1.set.get(r);
                        return !n || (t.resolved = n, n.references.push(t), !1);
                    });
                }(t, r, n), s && function(e1, t) {
                    Object.keys(t).forEach((t)=>{
                        const r = e1.set.get(t);
                        r && (r.eslintUsed = !0, r.eslintExported = !0);
                    });
                }(t, s);
            }
        }, ga;
    }
    function Ga() {
        if (Sa) return Ca;
        Sa = 1;
        const e1 = Gi()("eslint:code-path");
        function t(e1) {
            return e1.id + (e1.reachable ? "" : "!");
        }
        function r(e1, t) {
            const r = t ? `:${t}` : "";
            switch(e1.type){
                case "Identifier":
                    return `${e1.type}${r} (${e1.name})`;
                case "Literal":
                    return `${e1.type}${r} (${e1.value})`;
                default:
                    return `${e1.type}${r}`;
            }
        }
        return Ca = {
            enabled: e1.enabled,
            dump: e1,
            dumpState: e1.enabled ? function(n, s, i) {
                for(let e1 = 0; e1 < s.currentSegments.length; ++e1){
                    const t = s.currentSegments[e1].internal;
                    if (i) {
                        const e1 = t.nodes.length - 1;
                        e1 >= 0 && t.nodes[e1] === r(n, "enter") ? t.nodes[e1] = r(n, void 0) : t.nodes.push(r(n, "exit"));
                    } else t.nodes.push(r(n, "enter"));
                }
                e1([
                    `${s.currentSegments.map(t).join(",")})`,
                    `${n.type}${i ? ":exit" : ""}`
                ].join(" "));
            } : e1,
            dumpDot: e1.enabled ? function(t) {
                let r = '\ndigraph {\nnode[shape=box,style="rounded,filled",fillcolor=white];\ninitial[label="",shape=circle,style=filled,fillcolor=black,width=0.25,height=0.25];\n';
                t.returnedSegments.length > 0 && (r += 'final[label="",shape=doublecircle,style=filled,fillcolor=black,width=0.25,height=0.25];\n'), t.thrownSegments.length > 0 && (r += 'thrown[label="\u2718",shape=circle,width=0.3,height=0.3,fixedsize=true];\n');
                const n = Object.create(null), s = this.makeDotArrows(t, n);
                for(const e1 in n){
                    const t = n[e1];
                    r += `${e1}[`, t.reachable ? r += 'label="' : r += 'style="rounded,dashed,filled",fillcolor="#FF9800",label="<<unreachable>>\\n', t.internal.nodes.length > 0 ? r += t.internal.nodes.join("\\n") : r += "????", r += '"];\n';
                }
                r += `${s}\n`, r += "}", e1("DOT", r);
            } : e1,
            makeDotArrows (e1, t) {
                const r = [
                    [
                        e1.initialSegment,
                        0
                    ]
                ], n = t || Object.create(null);
                let s = e1.initialSegment.id, i = `initial->${e1.initialSegment.id}`;
                for(; r.length > 0;){
                    const e1 = r.pop(), t = e1[0], o = e1[1];
                    if (n[t.id] && 0 === o) continue;
                    n[t.id] = t;
                    const a = t.allNextSegments[o];
                    a && (s === t.id ? i += `->${a.id}` : i += `;\n${t.id}->${a.id}`, s = a.id, r.unshift([
                        t,
                        1 + o
                    ]), r.push([
                        a,
                        0
                    ]));
                }
                return e1.returnedSegments.forEach((e1)=>{
                    s === e1.id ? i += "->final" : i += `;\n${e1.id}->final`, s = null;
                }), e1.thrownSegments.forEach((e1)=>{
                    s === e1.id ? i += "->thrown" : i += `;\n${e1.id}->thrown`, s = null;
                }), `${i};`;
            }
        }, Ca;
    }
    function Wa() {
        if (va) return ba;
        va = 1;
        const e1 = Ga();
        function t(e1) {
            return e1.reachable;
        }
        class r {
            constructor(r, n, s){
                this.id = r, this.nextSegments = [], this.prevSegments = n.filter(t), this.allNextSegments = [], this.allPrevSegments = n, this.reachable = s, Object.defineProperty(this, "internal", {
                    value: {
                        used: !1,
                        loopedPrevSegments: []
                    }
                }), e1.enabled && (this.internal.nodes = []);
            }
            isLoopedPrevSegment(e1) {
                return this.internal.loopedPrevSegments.includes(e1);
            }
            static newRoot(e1) {
                return new r(e1, [], !0);
            }
            static newNext(e1, n) {
                return new r(e1, r.flattenUnusedSegments(n), n.some(t));
            }
            static newUnreachable(e1, t) {
                const n = new r(e1, r.flattenUnusedSegments(t), !1);
                return r.markUsed(n), n;
            }
            static newDisconnected(e1, n) {
                return new r(e1, [], n.some(t));
            }
            static markUsed(e1) {
                if (e1.internal.used) return;
                let t;
                if (e1.internal.used = !0, e1.reachable) for(t = 0; t < e1.allPrevSegments.length; ++t){
                    const r = e1.allPrevSegments[t];
                    r.allNextSegments.push(e1), r.nextSegments.push(e1);
                }
                else for(t = 0; t < e1.allPrevSegments.length; ++t)e1.allPrevSegments[t].allNextSegments.push(e1);
            }
            static markPrevSegmentAsLooped(e1, t) {
                e1.internal.loopedPrevSegments.push(t);
            }
            static flattenUnusedSegments(e1) {
                const t = new Set;
                for(let r = 0; r < e1.length; ++r){
                    const n = e1[r];
                    if (!t.has(n)) {
                        if (n.internal.used) t.add(n);
                        else for(let e1 = 0; e1 < n.allPrevSegments.length; ++e1){
                            const r = n.allPrevSegments[e1];
                            t.has(r) || t.add(r);
                        }
                    }
                }
                return [
                    ...t
                ];
            }
        }
        return ba = r;
    }
    function Xa() {
        if (Da) return Ra;
        Da = 1;
        const e1 = Wa(), t = function() {
            if (Ta) return Aa;
            Ta = 1;
            const e1 = ir, t = Wa();
            function r(e1) {
                return e1.reachable;
            }
            function n(e1, t, r, n) {
                const s = e1.segmentsList, i = t >= 0 ? t : s.length + t, o = r >= 0 ? r : s.length + r, a = [];
                for(let t = 0; t < e1.count; ++t){
                    const r = [];
                    for(let e1 = i; e1 <= o; ++e1)r.push(s[e1][t]);
                    a.push(n(e1.idGenerator.next(), r));
                }
                return a;
            }
            function s(e1, r) {
                let n = r;
                for(; n.length > e1.count;){
                    const r = [];
                    for(let s = 0, i = Math.floor(n.length / 2); s < i; ++s)r.push(t.newNext(e1.idGenerator.next(), [
                        n[s],
                        n[s + i]
                    ]));
                    n = r;
                }
                return n;
            }
            class i {
                constructor(e1, t, r){
                    this.idGenerator = e1, this.upper = t, this.count = r, this.segmentsList = [];
                }
                get head() {
                    const e1 = this.segmentsList;
                    return 0 === e1.length ? [] : e1[e1.length - 1];
                }
                get empty() {
                    return 0 === this.segmentsList.length;
                }
                get reachable() {
                    const e1 = this.head;
                    return e1.length > 0 && e1.some(r);
                }
                makeNext(e1, r) {
                    return n(this, e1, r, t.newNext);
                }
                makeUnreachable(e1, r) {
                    return n(this, e1, r, t.newUnreachable);
                }
                makeDisconnected(e1, r) {
                    return n(this, e1, r, t.newDisconnected);
                }
                add(t) {
                    e1(t.length >= this.count, `${t.length} >= ${this.count}`), this.segmentsList.push(s(this, t));
                }
                replaceHead(t) {
                    e1(t.length >= this.count, `${t.length} >= ${this.count}`), this.segmentsList.splice(-1, 1, s(this, t));
                }
                addAll(t) {
                    e1(t.count === this.count), this.segmentsList.push(...t.segmentsList);
                }
                clear() {
                    this.segmentsList = [];
                }
                static newRoot(e1) {
                    const r = new i(e1, null, 1);
                    return r.add([
                        t.newRoot(e1.next())
                    ]), r;
                }
                static newEmpty(e1, t) {
                    return new i(e1.idGenerator, e1, (t ? 2 : 1) * e1.count);
                }
            }
            return Aa = i;
        }();
        class r {
            constructor(e1, r, n, s){
                this.upper = e1, this.breakable = r, this.label = n, this.brokenForkContext = t.newEmpty(s);
            }
        }
        class n {
            constructor(e1){
                this.upper = e1, this.choiceContextCount = 0;
            }
        }
        class s {
            constructor(e1, r, n, s){
                this.upper = e1, this.kind = r, this.isForkingAsResult = n, this.trueForkContext = t.newEmpty(s), this.falseForkContext = t.newEmpty(s), this.nullishForkContext = t.newEmpty(s), this.processed = !1;
            }
        }
        class i {
            constructor(e1, t, r, n){
                this.upper = e1, this.type = t, this.label = r, this.brokenForkContext = n.brokenForkContext;
            }
        }
        class o extends i {
            constructor(e1, t, r){
                super(e1, "WhileStatement", t, r), this.test = void 0, this.continueDestSegments = null;
            }
        }
        class a extends i {
            constructor(e1, r, n, s){
                super(e1, "DoWhileStatement", r, n), this.test = void 0, this.entrySegments = null, this.continueForkContext = t.newEmpty(s);
            }
        }
        class u extends i {
            constructor(e1, t, r){
                super(e1, "ForStatement", t, r), this.test = void 0, this.endOfInitSegments = null, this.testSegments = null, this.endOfTestSegments = null, this.updateSegments = null, this.endOfUpdateSegments = null, this.continueDestSegments = null;
            }
        }
        class l extends i {
            constructor(e1, t, r){
                super(e1, "ForInStatement", t, r), this.prevSegments = null, this.leftSegments = null, this.endOfLeftSegments = null, this.continueDestSegments = null;
            }
        }
        class c extends i {
            constructor(e1, t, r){
                super(e1, "ForOfStatement", t, r), this.prevSegments = null, this.leftSegments = null, this.endOfLeftSegments = null, this.continueDestSegments = null;
            }
        }
        class p {
            constructor(e1, t){
                this.upper = e1, this.hasCase = t, this.defaultSegments = null, this.defaultBodySegments = null, this.foundEmptyDefault = !1, this.lastIsDefault = !1, this.forkCount = 0;
            }
        }
        class f {
            constructor(e1, r, n){
                this.upper = e1, this.hasFinalizer = r, this.position = "try", this.returnedForkContext = r ? t.newEmpty(n) : null, this.thrownForkContext = t.newEmpty(n), this.lastOfTryIsReachable = !1, this.lastOfCatchIsReachable = !1;
            }
        }
        function d(e1, t, r, n) {
            for(let s = 0; s < n.length; ++s){
                const i = n[s];
                e1.push(i), t.includes(i) || r.push(i);
            }
        }
        function h(e1) {
            let t = e1.tryContext;
            for(; t;){
                if (t.hasFinalizer && "finally" !== t.position) return t;
                t = t.upper;
            }
            return e1;
        }
        function m(e1) {
            let t = e1.tryContext;
            for(; t;){
                if ("try" === t.position || t.hasFinalizer && "catch" === t.position) return t;
                t = t.upper;
            }
            return e1;
        }
        function g(e1, t) {
            e1.splice(e1.indexOf(t), 1);
        }
        function y(t, r, n) {
            const s = e1.flattenUnusedSegments(r), i = e1.flattenUnusedSegments(n), o = Math.min(s.length, i.length);
            for(let r = 0; r < o; ++r){
                const n = s[r], o = i[r];
                o.reachable && n.nextSegments.push(o), n.reachable && o.prevSegments.push(n), n.allNextSegments.push(o), o.allPrevSegments.push(n), o.allPrevSegments.length >= 2 && e1.markPrevSegmentAsLooped(o, n), t.notifyLooped(n, o);
            }
        }
        function E(e1, t, r) {
            t.processed || (t.trueForkContext.add(r), t.falseForkContext.add(r), t.nullishForkContext.add(r)), !0 !== e1.test && e1.brokenForkContext.addAll(t.falseForkContext), e1.endOfTestSegments = t.trueForkContext.makeNext(0, -1);
        }
        return Ra = class {
            constructor(e1, r){
                this.idGenerator = e1, this.notifyLooped = r, this.forkContext = t.newRoot(e1), this.choiceContext = null, this.switchContext = null, this.tryContext = null, this.loopContext = null, this.breakContext = null, this.chainContext = null, this.currentSegments = [], this.initialSegment = this.forkContext.head[0], this.finalSegments = [], this.returnedForkContext = [], this.thrownForkContext = [];
                const n = this.finalSegments, s = this.returnedForkContext, i = this.thrownForkContext;
                s.add = d.bind(null, s, i, n), i.add = d.bind(null, i, s, n);
            }
            get headSegments() {
                return this.forkContext.head;
            }
            get parentForkContext() {
                const e1 = this.forkContext;
                return e1 && e1.upper;
            }
            pushForkContext(e1) {
                return this.forkContext = t.newEmpty(this.forkContext, e1), this.forkContext;
            }
            popForkContext() {
                const e1 = this.forkContext;
                return this.forkContext = e1.upper, this.forkContext.replaceHead(e1.makeNext(0, -1)), e1;
            }
            forkPath() {
                this.forkContext.add(this.parentForkContext.makeNext(-1, -1));
            }
            forkBypassPath() {
                this.forkContext.add(this.parentForkContext.head);
            }
            pushChoiceContext(e1, t) {
                this.choiceContext = new s(this.choiceContext, e1, t, this.forkContext);
            }
            popChoiceContext() {
                const e1 = this.choiceContext, t = this.forkContext, r = t.head;
                switch(this.choiceContext = e1.upper, e1.kind){
                    case "&&":
                    case "||":
                    case "??":
                        if (e1.processed || (e1.trueForkContext.add(r), e1.falseForkContext.add(r), e1.nullishForkContext.add(r)), e1.isForkingAsResult) {
                            const t = this.choiceContext;
                            return t.trueForkContext.addAll(e1.trueForkContext), t.falseForkContext.addAll(e1.falseForkContext), t.nullishForkContext.addAll(e1.nullishForkContext), t.processed = !0, e1;
                        }
                        break;
                    case "test":
                        e1.processed ? (e1.falseForkContext.clear(), e1.falseForkContext.add(r)) : (e1.trueForkContext.clear(), e1.trueForkContext.add(r));
                        break;
                    case "loop":
                        return e1;
                    default:
                        throw new Error("unreachable");
                }
                const n = e1.trueForkContext;
                return n.addAll(e1.falseForkContext), t.replaceHead(n.makeNext(0, -1)), e1;
            }
            makeLogicalRight() {
                const e1 = this.choiceContext, t = this.forkContext;
                if (e1.processed) {
                    let r;
                    switch(e1.kind){
                        case "&&":
                            r = e1.trueForkContext;
                            break;
                        case "||":
                            r = e1.falseForkContext;
                            break;
                        case "??":
                            r = e1.nullishForkContext;
                            break;
                        default:
                            throw new Error("unreachable");
                    }
                    t.replaceHead(r.makeNext(0, -1)), r.clear(), e1.processed = !1;
                } else {
                    switch(e1.kind){
                        case "&&":
                            e1.falseForkContext.add(t.head), e1.nullishForkContext.add(t.head);
                            break;
                        case "||":
                            e1.trueForkContext.add(t.head);
                            break;
                        case "??":
                            e1.trueForkContext.add(t.head), e1.falseForkContext.add(t.head);
                            break;
                        default:
                            throw new Error("unreachable");
                    }
                    t.replaceHead(t.makeNext(-1, -1));
                }
            }
            makeIfConsequent() {
                const e1 = this.choiceContext, t = this.forkContext;
                e1.processed || (e1.trueForkContext.add(t.head), e1.falseForkContext.add(t.head), e1.nullishForkContext.add(t.head)), e1.processed = !1, t.replaceHead(e1.trueForkContext.makeNext(0, -1));
            }
            makeIfAlternate() {
                const e1 = this.choiceContext, t = this.forkContext;
                e1.trueForkContext.clear(), e1.trueForkContext.add(t.head), e1.processed = !0, t.replaceHead(e1.falseForkContext.makeNext(0, -1));
            }
            pushChainContext() {
                this.chainContext = new n(this.chainContext);
            }
            popChainContext() {
                const e1 = this.chainContext;
                this.chainContext = e1.upper;
                for(let t = e1.choiceContextCount; t > 0; --t)this.popChoiceContext();
            }
            makeOptionalNode() {
                this.chainContext && (this.chainContext.choiceContextCount += 1, this.pushChoiceContext("??", !1));
            }
            makeOptionalRight() {
                this.chainContext && this.makeLogicalRight();
            }
            pushSwitchContext(e1, t) {
                this.switchContext = new p(this.switchContext, e1), this.pushBreakContext(!0, t);
            }
            popSwitchContext() {
                const e1 = this.switchContext;
                this.switchContext = e1.upper;
                const t = this.forkContext, r = this.popBreakContext().brokenForkContext;
                if (0 === e1.forkCount) return void (r.empty || (r.add(t.makeNext(-1, -1)), t.replaceHead(r.makeNext(0, -1))));
                const n = t.head;
                this.forkBypassPath();
                const s = t.head;
                r.add(n), e1.lastIsDefault || (e1.defaultBodySegments ? (!function(e1, t) {
                    for(let r = 0; r < e1.length; ++r){
                        const n = e1[r], s = t[r];
                        g(n.nextSegments, s), g(n.allNextSegments, s), g(s.prevSegments, n), g(s.allPrevSegments, n);
                    }
                }(e1.defaultSegments, e1.defaultBodySegments), y(this, s, e1.defaultBodySegments)) : r.add(s));
                for(let t = 0; t < e1.forkCount; ++t)this.forkContext = this.forkContext.upper;
                this.forkContext.replaceHead(r.makeNext(0, -1));
            }
            makeSwitchCaseBody(e1, t) {
                const r = this.switchContext;
                if (!r.hasCase) return;
                const n = this.forkContext, s = this.pushForkContext();
                s.add(n.makeNext(0, -1)), t ? (r.defaultSegments = n.head, e1 ? r.foundEmptyDefault = !0 : r.defaultBodySegments = s.head) : !e1 && r.foundEmptyDefault && (r.foundEmptyDefault = !1, r.defaultBodySegments = s.head), r.lastIsDefault = t, r.forkCount += 1;
            }
            pushTryContext(e1) {
                this.tryContext = new f(this.tryContext, e1, this.forkContext);
            }
            popTryContext() {
                const e1 = this.tryContext;
                if (this.tryContext = e1.upper, "catch" === e1.position) return void this.popForkContext();
                const t = e1.returnedForkContext, r = e1.thrownForkContext;
                if (t.empty && r.empty) return;
                const n = this.forkContext.head;
                this.forkContext = this.forkContext.upper;
                const s = n.slice(0, n.length / 2 | 0), i = n.slice(n.length / 2 | 0);
                t.empty || h(this).returnedForkContext.add(i), r.empty || m(this).thrownForkContext.add(i), this.forkContext.replaceHead(s), e1.lastOfTryIsReachable || e1.lastOfCatchIsReachable || this.forkContext.makeUnreachable();
            }
            makeCatchBlock() {
                const e1 = this.tryContext, r = this.forkContext, n = e1.thrownForkContext;
                e1.position = "catch", e1.thrownForkContext = t.newEmpty(r), e1.lastOfTryIsReachable = r.reachable, n.add(r.head);
                const s = n.makeNext(0, -1);
                this.pushForkContext(), this.forkBypassPath(), this.forkContext.add(s);
            }
            makeFinallyBlock() {
                const t = this.tryContext;
                let r = this.forkContext;
                const n = t.returnedForkContext, s = t.thrownForkContext, i = r.head;
                if ("catch" === t.position ? (this.popForkContext(), r = this.forkContext, t.lastOfCatchIsReachable = r.reachable) : t.lastOfTryIsReachable = r.reachable, t.position = "finally", n.empty && s.empty) return;
                const o = r.makeNext(-1, -1);
                for(let t = 0; t < r.count; ++t){
                    const r = [
                        i[t]
                    ];
                    for(let e1 = 0; e1 < n.segmentsList.length; ++e1)r.push(n.segmentsList[e1][t]);
                    for(let e1 = 0; e1 < s.segmentsList.length; ++e1)r.push(s.segmentsList[e1][t]);
                    o.push(e1.newNext(this.idGenerator.next(), r));
                }
                this.pushForkContext(!0), this.forkContext.add(o);
            }
            makeFirstThrowablePathInTryBlock() {
                const e1 = this.forkContext;
                if (!e1.reachable) return;
                const t = m(this);
                t !== this && "try" === t.position && t.thrownForkContext.empty && (t.thrownForkContext.add(e1.head), e1.replaceHead(e1.makeNext(-1, -1)));
            }
            pushLoopContext(e1, t) {
                const r = this.forkContext, n = this.pushBreakContext(!0, t);
                switch(e1){
                    case "WhileStatement":
                        this.pushChoiceContext("loop", !1), this.loopContext = new o(this.loopContext, t, n);
                        break;
                    case "DoWhileStatement":
                        this.pushChoiceContext("loop", !1), this.loopContext = new a(this.loopContext, t, n, r);
                        break;
                    case "ForStatement":
                        this.pushChoiceContext("loop", !1), this.loopContext = new u(this.loopContext, t, n);
                        break;
                    case "ForInStatement":
                        this.loopContext = new l(this.loopContext, t, n);
                        break;
                    case "ForOfStatement":
                        this.loopContext = new c(this.loopContext, t, n);
                        break;
                    default:
                        throw new Error(`unknown type: "${e1}"`);
                }
            }
            popLoopContext() {
                const e1 = this.loopContext;
                this.loopContext = e1.upper;
                const t = this.forkContext, r = this.popBreakContext().brokenForkContext;
                switch(e1.type){
                    case "WhileStatement":
                    case "ForStatement":
                        this.popChoiceContext(), y(this, t.head, e1.continueDestSegments);
                        break;
                    case "DoWhileStatement":
                        {
                            const n = this.popChoiceContext();
                            n.processed || (n.trueForkContext.add(t.head), n.falseForkContext.add(t.head)), !0 !== e1.test && r.addAll(n.falseForkContext);
                            const s = n.trueForkContext.segmentsList;
                            for(let t = 0; t < s.length; ++t)y(this, s[t], e1.entrySegments);
                            break;
                        }
                    case "ForInStatement":
                    case "ForOfStatement":
                        r.add(t.head), y(this, t.head, e1.leftSegments);
                        break;
                    default:
                        throw new Error("unreachable");
                }
                r.empty ? t.replaceHead(t.makeUnreachable(-1, -1)) : t.replaceHead(r.makeNext(0, -1));
            }
            makeWhileTest(e1) {
                const t = this.loopContext, r = this.forkContext, n = r.makeNext(0, -1);
                t.test = e1, t.continueDestSegments = n, r.replaceHead(n);
            }
            makeWhileBody() {
                const e1 = this.loopContext, t = this.choiceContext, r = this.forkContext;
                t.processed || (t.trueForkContext.add(r.head), t.falseForkContext.add(r.head)), !0 !== e1.test && e1.brokenForkContext.addAll(t.falseForkContext), r.replaceHead(t.trueForkContext.makeNext(0, -1));
            }
            makeDoWhileBody() {
                const e1 = this.loopContext, t = this.forkContext, r = t.makeNext(-1, -1);
                e1.entrySegments = r, t.replaceHead(r);
            }
            makeDoWhileTest(e1) {
                const t = this.loopContext, r = this.forkContext;
                if (t.test = e1, !t.continueForkContext.empty) {
                    t.continueForkContext.add(r.head);
                    const e1 = t.continueForkContext.makeNext(0, -1);
                    r.replaceHead(e1);
                }
            }
            makeForTest(e1) {
                const t = this.loopContext, r = this.forkContext, n = r.head, s = r.makeNext(-1, -1);
                t.test = e1, t.endOfInitSegments = n, t.continueDestSegments = t.testSegments = s, r.replaceHead(s);
            }
            makeForUpdate() {
                const e1 = this.loopContext, t = this.choiceContext, r = this.forkContext;
                e1.testSegments ? E(e1, t, r.head) : e1.endOfInitSegments = r.head;
                const n = r.makeDisconnected(-1, -1);
                e1.continueDestSegments = e1.updateSegments = n, r.replaceHead(n);
            }
            makeForBody() {
                const e1 = this.loopContext, r = this.choiceContext, n = this.forkContext;
                e1.updateSegments ? (e1.endOfUpdateSegments = n.head, e1.testSegments && y(this, e1.endOfUpdateSegments, e1.testSegments)) : e1.testSegments ? E(e1, r, n.head) : e1.endOfInitSegments = n.head;
                let s = e1.endOfTestSegments;
                if (!s) {
                    const r = t.newEmpty(n);
                    r.add(e1.endOfInitSegments), e1.endOfUpdateSegments && r.add(e1.endOfUpdateSegments), s = r.makeNext(0, -1);
                }
                e1.continueDestSegments = e1.continueDestSegments || s, n.replaceHead(s);
            }
            makeForInOfLeft() {
                const e1 = this.loopContext, t = this.forkContext, r = t.makeDisconnected(-1, -1);
                e1.prevSegments = t.head, e1.leftSegments = e1.continueDestSegments = r, t.replaceHead(r);
            }
            makeForInOfRight() {
                const e1 = this.loopContext, r = this.forkContext, n = t.newEmpty(r);
                n.add(e1.prevSegments);
                const s = n.makeNext(-1, -1);
                e1.endOfLeftSegments = r.head, r.replaceHead(s);
            }
            makeForInOfBody() {
                const e1 = this.loopContext, r = this.forkContext, n = t.newEmpty(r);
                n.add(e1.endOfLeftSegments);
                const s = n.makeNext(-1, -1);
                y(this, r.head, e1.leftSegments), e1.brokenForkContext.add(r.head), r.replaceHead(s);
            }
            pushBreakContext(e1, t) {
                return this.breakContext = new r(this.breakContext, e1, t, this.forkContext), this.breakContext;
            }
            popBreakContext() {
                const e1 = this.breakContext, t = this.forkContext;
                if (this.breakContext = e1.upper, !e1.breakable) {
                    const r = e1.brokenForkContext;
                    r.empty || (r.add(t.head), t.replaceHead(r.makeNext(0, -1)));
                }
                return e1;
            }
            makeBreak(e1) {
                const t = this.forkContext;
                if (!t.reachable) return;
                const r = function(e1, t) {
                    let r = e1.breakContext;
                    for(; r;){
                        if (t ? r.label === t : r.breakable) return r;
                        r = r.upper;
                    }
                    return null;
                }(this, e1);
                r && r.brokenForkContext.add(t.head), t.replaceHead(t.makeUnreachable(-1, -1));
            }
            makeContinue(e1) {
                const t = this.forkContext;
                if (!t.reachable) return;
                const r = function(e1, t) {
                    if (!t) return e1.loopContext;
                    let r = e1.loopContext;
                    for(; r;){
                        if (r.label === t) return r;
                        r = r.upper;
                    }
                    return null;
                }(this, e1);
                r && (r.continueDestSegments ? (y(this, t.head, r.continueDestSegments), "ForInStatement" !== r.type && "ForOfStatement" !== r.type || r.brokenForkContext.add(t.head)) : r.continueForkContext.add(t.head)), t.replaceHead(t.makeUnreachable(-1, -1));
            }
            makeReturn() {
                const e1 = this.forkContext;
                e1.reachable && (h(this).returnedForkContext.add(e1.head), e1.replaceHead(e1.makeUnreachable(-1, -1)));
            }
            makeThrow() {
                const e1 = this.forkContext;
                e1.reachable && (m(this).thrownForkContext.add(e1.head), e1.replaceHead(e1.makeUnreachable(-1, -1)));
            }
            makeFinal() {
                const e1 = this.currentSegments;
                e1.length > 0 && e1[0].reachable && this.returnedForkContext.add(e1);
            }
        }, Ra;
    }
    function za() {
        if (_a) return wa;
        _a = 1;
        return wa = class {
            constructor(e1){
                this.prefix = String(e1), this.n = 0;
            }
            next() {
                return this.n = 1 + this.n | 0, this.n < 0 && (this.n = 1), this.prefix + this.n;
            }
        };
    }
    function Ha() {
        if (Pa) return La;
        Pa = 1;
        const e1 = ir, { breakableTypePattern: t } = Ur(), r = function() {
            if (Ba) return ka;
            Ba = 1;
            const e1 = Xa(), t = za();
            return ka = class {
                constructor({ id: r, origin: n, upper: s, onLooped: i }){
                    this.id = r, this.origin = n, this.upper = s, this.childCodePaths = [], Object.defineProperty(this, "internal", {
                        value: new e1(new t(`${r}_`), i)
                    }), s && s.childCodePaths.push(this);
                }
                static getState(e1) {
                    return e1.internal;
                }
                get initialSegment() {
                    return this.internal.initialSegment;
                }
                get finalSegments() {
                    return this.internal.finalSegments;
                }
                get returnedSegments() {
                    return this.internal.returnedForkContext;
                }
                get thrownSegments() {
                    return this.internal.thrownForkContext;
                }
                get currentSegments() {
                    return this.internal.currentSegments;
                }
                traverseSegments(e1, t) {
                    let r, n;
                    "function" == typeof e1 ? (n = e1, r = {}) : (r = e1 || {}, n = t);
                    const s = r.first || this.internal.initialSegment, i = r.last;
                    let o = null, a = 0, u = 0, l = null;
                    const c = new Set, p = [
                        [
                            s,
                            0
                        ]
                    ];
                    let f = null, d = !1;
                    const h = {
                        skip () {
                            p.length <= 1 ? d = !0 : f = p[p.length - 2][0];
                        },
                        break () {
                            d = !0;
                        }
                    };
                    function m(e1) {
                        return c.has(e1) || l.isLoopedPrevSegment(e1);
                    }
                    for(; p.length > 0;){
                        if (o = p[p.length - 1], l = o[0], a = o[1], 0 === a) {
                            if (c.has(l)) {
                                p.pop();
                                continue;
                            }
                            if (l !== s && l.prevSegments.length > 0 && !l.prevSegments.every(m)) {
                                p.pop();
                                continue;
                            }
                            if (f && l.prevSegments.includes(f) && (f = null), c.add(l), !f && (n.call(this, l, h), l === i && h.skip(), d)) break;
                        }
                        u = l.nextSegments.length - 1, a < u ? (o[1] += 1, p.push([
                            l.nextSegments[a],
                            0
                        ])) : a === u ? (o[0] = l.nextSegments[a], o[1] = 0) : p.pop();
                    }
                }
            }, ka;
        }(), n = Wa(), s = za(), i = Ga();
        function o(e1) {
            return Boolean(e1.test);
        }
        function a(e1) {
            const t = e1.parent;
            return t && "PropertyDefinition" === t.type && t.value === e1;
        }
        function u(e1) {
            return "&&" === e1 || "||" === e1 || "??" === e1;
        }
        function l(e1) {
            return "&&=" === e1 || "||=" === e1 || "??=" === e1;
        }
        function c(e1) {
            return "LabeledStatement" === e1.parent.type ? e1.parent.label.name : null;
        }
        function p(e1) {
            const t = e1.parent;
            switch(t.type){
                case "ConditionalExpression":
                case "IfStatement":
                case "WhileStatement":
                case "DoWhileStatement":
                case "ForStatement":
                    return t.test === e1;
                case "LogicalExpression":
                    return u(t.operator);
                case "AssignmentExpression":
                    return l(t.operator);
                default:
                    return !1;
            }
        }
        function f(e1) {
            if ("Literal" === e1.type) return Boolean(e1.value);
        }
        function d(e1, t) {
            const s = e1.codePath, o = r.getState(s), a = o.currentSegments, u = o.headSegments, l = Math.max(a.length, u.length);
            let c, p, f;
            for(c = 0; c < l; ++c)if (p = a[c], f = u[c], p !== f && p) {
                const r = p.reachable ? "onCodePathSegmentEnd" : "onUnreachableCodePathSegmentEnd";
                i.dump(`${r} ${p.id}`), e1.emitter.emit(r, p, t);
            }
            for(o.currentSegments = u, c = 0; c < l; ++c)if (p = a[c], f = u[c], p !== f && f) {
                const r = f.reachable ? "onCodePathSegmentStart" : "onUnreachableCodePathSegmentStart";
                i.dump(`${r} ${f.id}`), n.markUsed(f), e1.emitter.emit(r, f, t);
            }
        }
        function h(e1, t) {
            function n() {
                let n = e1.codePath;
                r.getState(n).makeFinal(), function(e1, t) {
                    const n = r.getState(e1.codePath), s = n.currentSegments;
                    for(let r = 0; r < s.length; ++r){
                        const n = s[r], o = n.reachable ? "onCodePathSegmentEnd" : "onUnreachableCodePathSegmentEnd";
                        i.dump(`${o} ${n.id}`), e1.emitter.emit(o, n, t);
                    }
                    n.currentSegments = [];
                }(e1, t), i.dump(`onCodePathEnd ${n.id}`), e1.emitter.emit("onCodePathEnd", n, t), i.dumpDot(n), n = e1.codePath = e1.codePath.upper, n && i.dumpState(t, r.getState(n), !0);
            }
            switch(t.type){
                case "Program":
                case "FunctionDeclaration":
                case "FunctionExpression":
                case "ArrowFunctionExpression":
                case "StaticBlock":
                    n();
                    break;
                case "CallExpression":
                    !0 === t.optional && 0 === t.arguments.length && r.getState(e1.codePath).makeOptionalRight();
            }
            a(t) && n();
        }
        return La = class {
            constructor(e1){
                this.original = e1, this.emitter = e1.emitter, this.codePath = null, this.idGenerator = new s("s"), this.currentNode = null, this.onLooped = this.onLooped.bind(this);
            }
            enterNode(n) {
                this.currentNode = n, n.parent && function(t, n) {
                    const s = t.codePath, i = r.getState(s), o = n.parent;
                    switch(o.type){
                        case "CallExpression":
                            !0 === o.optional && o.arguments.length >= 1 && o.arguments[0] === n && i.makeOptionalRight();
                            break;
                        case "MemberExpression":
                            !0 === o.optional && o.property === n && i.makeOptionalRight();
                            break;
                        case "LogicalExpression":
                            o.right === n && u(o.operator) && i.makeLogicalRight();
                            break;
                        case "AssignmentExpression":
                            o.right === n && l(o.operator) && i.makeLogicalRight();
                            break;
                        case "ConditionalExpression":
                        case "IfStatement":
                            o.consequent === n ? i.makeIfConsequent() : o.alternate === n && i.makeIfAlternate();
                            break;
                        case "SwitchCase":
                            o.consequent[0] === n && i.makeSwitchCaseBody(!1, !o.test);
                            break;
                        case "TryStatement":
                            o.handler === n ? i.makeCatchBlock() : o.finalizer === n && i.makeFinallyBlock();
                            break;
                        case "WhileStatement":
                            o.test === n ? i.makeWhileTest(f(n)) : (e1(o.body === n), i.makeWhileBody());
                            break;
                        case "DoWhileStatement":
                            o.body === n ? i.makeDoWhileBody() : (e1(o.test === n), i.makeDoWhileTest(f(n)));
                            break;
                        case "ForStatement":
                            o.test === n ? i.makeForTest(f(n)) : o.update === n ? i.makeForUpdate() : o.body === n && i.makeForBody();
                            break;
                        case "ForInStatement":
                        case "ForOfStatement":
                            o.left === n ? i.makeForInOfLeft() : o.right === n ? i.makeForInOfRight() : (e1(o.body === n), i.makeForInOfBody());
                            break;
                        case "AssignmentPattern":
                            o.right === n && (i.pushForkContext(), i.forkBypassPath(), i.forkPath());
                    }
                }(this, n), function(e1, n) {
                    let s = e1.codePath, f = s && r.getState(s);
                    const h = n.parent;
                    function m(t) {
                        s && (d(e1, n), i.dumpState(n, f, !1)), s = e1.codePath = new r({
                            id: e1.idGenerator.next(),
                            origin: t,
                            upper: s,
                            onLooped: e1.onLooped
                        }), f = r.getState(s), i.dump(`onCodePathStart ${s.id}`), e1.emitter.emit("onCodePathStart", s, n);
                    }
                    switch(a(n) && m("class-field-initializer"), n.type){
                        case "Program":
                            m("program");
                            break;
                        case "FunctionDeclaration":
                        case "FunctionExpression":
                        case "ArrowFunctionExpression":
                            m("function");
                            break;
                        case "StaticBlock":
                            m("class-static-block");
                            break;
                        case "ChainExpression":
                            f.pushChainContext();
                            break;
                        case "CallExpression":
                        case "MemberExpression":
                            !0 === n.optional && f.makeOptionalNode();
                            break;
                        case "LogicalExpression":
                            u(n.operator) && f.pushChoiceContext(n.operator, p(n));
                            break;
                        case "AssignmentExpression":
                            l(n.operator) && f.pushChoiceContext(n.operator.slice(0, -1), p(n));
                            break;
                        case "ConditionalExpression":
                        case "IfStatement":
                            f.pushChoiceContext("test", !1);
                            break;
                        case "SwitchStatement":
                            f.pushSwitchContext(n.cases.some(o), c(n));
                            break;
                        case "TryStatement":
                            f.pushTryContext(Boolean(n.finalizer));
                            break;
                        case "SwitchCase":
                            h.discriminant !== n && h.cases[0] !== n && f.forkPath();
                            break;
                        case "WhileStatement":
                        case "DoWhileStatement":
                        case "ForStatement":
                        case "ForInStatement":
                        case "ForOfStatement":
                            f.pushLoopContext(n.type, c(n));
                            break;
                        case "LabeledStatement":
                            t.test(n.body.type) || f.pushBreakContext(!1, n.label.name);
                    }
                    d(e1, n), i.dumpState(n, f, !1);
                }(this, n), this.original.enterNode(n), this.currentNode = null;
            }
            leaveNode(e1) {
                this.currentNode = e1, function(e1, n) {
                    const s = e1.codePath, o = r.getState(s);
                    let a = !1;
                    switch(n.type){
                        case "ChainExpression":
                            o.popChainContext();
                            break;
                        case "IfStatement":
                        case "ConditionalExpression":
                            o.popChoiceContext();
                            break;
                        case "LogicalExpression":
                            u(n.operator) && o.popChoiceContext();
                            break;
                        case "AssignmentExpression":
                            l(n.operator) && o.popChoiceContext();
                            break;
                        case "SwitchStatement":
                            o.popSwitchContext();
                            break;
                        case "SwitchCase":
                            0 === n.consequent.length && o.makeSwitchCaseBody(!0, !n.test), o.forkContext.reachable && (a = !0);
                            break;
                        case "TryStatement":
                            o.popTryContext();
                            break;
                        case "BreakStatement":
                            d(e1, n), o.makeBreak(n.label && n.label.name), a = !0;
                            break;
                        case "ContinueStatement":
                            d(e1, n), o.makeContinue(n.label && n.label.name), a = !0;
                            break;
                        case "ReturnStatement":
                            d(e1, n), o.makeReturn(), a = !0;
                            break;
                        case "ThrowStatement":
                            d(e1, n), o.makeThrow(), a = !0;
                            break;
                        case "Identifier":
                            (function(e1) {
                                const t = e1.parent;
                                switch(t.type){
                                    case "LabeledStatement":
                                    case "BreakStatement":
                                    case "ContinueStatement":
                                    case "ArrayPattern":
                                    case "RestElement":
                                    case "ImportSpecifier":
                                    case "ImportDefaultSpecifier":
                                    case "ImportNamespaceSpecifier":
                                    case "CatchClause":
                                        return !1;
                                    case "FunctionDeclaration":
                                    case "FunctionExpression":
                                    case "ArrowFunctionExpression":
                                    case "ClassDeclaration":
                                    case "ClassExpression":
                                    case "VariableDeclarator":
                                        return t.id !== e1;
                                    case "Property":
                                    case "PropertyDefinition":
                                    case "MethodDefinition":
                                        return t.key !== e1 || t.computed || t.shorthand;
                                    case "AssignmentPattern":
                                        return t.key !== e1;
                                    default:
                                        return !0;
                                }
                            })(n) && (o.makeFirstThrowablePathInTryBlock(), a = !0);
                            break;
                        case "CallExpression":
                        case "ImportExpression":
                        case "MemberExpression":
                        case "NewExpression":
                        case "YieldExpression":
                            o.makeFirstThrowablePathInTryBlock();
                            break;
                        case "WhileStatement":
                        case "DoWhileStatement":
                        case "ForStatement":
                        case "ForInStatement":
                        case "ForOfStatement":
                            o.popLoopContext();
                            break;
                        case "AssignmentPattern":
                            o.popForkContext();
                            break;
                        case "LabeledStatement":
                            t.test(n.body.type) || o.popBreakContext();
                    }
                    a || d(e1, n), i.dumpState(n, o, !0);
                }(this, e1), this.original.leaveNode(e1), h(this, e1), this.currentNode = null;
            }
            onLooped(e1, t) {
                e1.reachable && t.reachable && (i.dump(`onCodePathSegmentLoop ${e1.id} -> ${t.id}`), this.emitter.emit("onCodePathSegmentLoop", e1, t, this.currentNode));
            }
        }, La;
    }
    function Ja() {
        return Fa ? Ia : (Fa = 1, Ia = (e1)=>{
            if ("string" != typeof e1) throw new TypeError("Expected a string");
            return e1.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
        });
    }
    function Qa() {
        if (Oa) return Na;
        Oa = 1;
        const e1 = Ja();
        function t(e1, t) {
            return e1.line - t.line || e1.column - t.column;
        }
        function r(e1, t) {
            const { range: r } = t, n = e1.filter((e1)=>e1.ruleId).map((e1)=>`'${e1.ruleId}'`);
            return {
                description: n.length <= 2 ? n.join(" or ") : `${n.slice(0, n.length - 1).join(", ")}, or ${n[n.length - 1]}`,
                fix: {
                    range: r,
                    text: " "
                },
                unprocessedDirective: e1[0].unprocessedDirective
            };
        }
        function n(t) {
            const n = function(e1) {
                const t = new Map;
                for (const r of e1){
                    const { unprocessedDirective: { parentComment: e1 } } = r;
                    t.has(e1) ? t.get(e1).push(r) : t.set(e1, [
                        r
                    ]);
                }
                return [
                    ...t.values()
                ];
            }(t);
            return n.flatMap((t)=>{
                const { parentComment: n } = t[0].unprocessedDirective, s = new Set(n.ruleIds);
                for (const e1 of t)s.delete(e1.ruleId);
                return s.size ? function(t, r) {
                    const n = r.range[0] + 2, s = /^\s*\S+\s+/u.exec(r.value)[0].length, i = r.value.slice(s).split(/\s-{2,}\s/u)[0].trimEnd();
                    return t.map((t)=>{
                        const { ruleId: r } = t, o = new RegExp(String.raw`(?:^|\s*,\s*)(?<quote>['"]?)${e1(r)}\k<quote>(?:\s*,\s*|$)`, "u").exec(i), a = o[0], u = s + o.index, l = u + a.length, c = a.indexOf(","), p = a.lastIndexOf(",");
                        let f, d;
                        return c !== p ? (f = u + c, d = u + p) : (f = u, d = l), {
                            description: `'${r}'`,
                            fix: {
                                range: [
                                    n + f,
                                    n + d
                                ],
                                text: ""
                            },
                            unprocessedDirective: t.unprocessedDirective
                        };
                    });
                }(t, n.commentToken) : [
                    r(t, n.commentToken)
                ];
            });
        }
        function s(e1) {
            const r = [], s = new Set;
            for (const n of e1.problems){
                let i = [], o = 0;
                for(; o < e1.directives.length && t(e1.directives[o], n) <= 0;){
                    const t = e1.directives[o++];
                    if (null === t.ruleId || t.ruleId === n.ruleId) switch(t.type){
                        case "disable":
                            i.push(t);
                            break;
                        case "enable":
                            i = [];
                    }
                }
                if (i.length > 0) {
                    const e1 = i.map((e1)=>({
                            kind: "directive",
                            justification: e1.unprocessedDirective.justification
                        }));
                    n.suppressions ? n.suppressions = n.suppressions.concat(e1) : (n.suppressions = e1, s.add(i[i.length - 1]));
                }
                r.push(n);
            }
            const i = e1.directives.filter((e1)=>"disable" === e1.type && !s.has(e1)), o = new Set(e1.directives.filter((e1)=>"enable" === e1.unprocessedDirective.type));
            if (o.size > 0) for (const t of function(e1) {
                const t = new Map, r = new Set;
                for(let n = e1.length - 1; n >= 0; n--){
                    const s = e1[n];
                    if ("disable" === s.type) {
                        if (0 === t.size) continue;
                        if (null === s.ruleId) {
                            for (const e1 of t.values())r.add(e1);
                            t.clear();
                        } else {
                            const e1 = t.get(s.ruleId);
                            if (e1) r.add(e1);
                            else {
                                const e1 = t.get(null);
                                e1 && r.add(e1);
                            }
                        }
                    } else "enable" === s.type && (null === s.ruleId ? (t.clear(), t.set(null, s)) : t.set(s.ruleId, s));
                }
                return r;
            }(e1.directives))o.delete(t);
            const a = n(i).concat(n(o)).map(({ description: t, fix: r, unprocessedDirective: n })=>{
                const { parentComment: s, type: i, line: o, column: a } = n;
                let u;
                return u = "enable" === i ? t ? `Unused eslint-enable directive (no matching eslint-disable directives were found for ${t}).` : "Unused eslint-enable directive (no matching eslint-disable directives were found)." : t ? `Unused eslint-disable directive (no problems were reported from ${t}).` : "Unused eslint-disable directive (no problems were reported).", {
                    ruleId: null,
                    message: u,
                    line: "disable-next-line" === i ? s.commentToken.loc.start.line : o,
                    column: "disable-next-line" === i ? s.commentToken.loc.start.column + 1 : a,
                    severity: "warn" === e1.reportUnusedDisableDirectives ? 1 : 2,
                    nodeType: null,
                    ...e1.disableFixes ? {} : {
                        fix: r
                    }
                };
            });
            return {
                problems: r,
                unusedDirectives: a
            };
        }
        return Na = ({ directives: e1, disableFixes: r, problems: n, reportUnusedDisableDirectives: i = "off" })=>{
            const o = e1.filter((e1)=>"disable" === e1.type || "enable" === e1.type).map((e1)=>Object.assign({}, e1, {
                    unprocessedDirective: e1
                })).sort(t), a = e1.flatMap((e1)=>{
                switch(e1.type){
                    case "disable":
                    case "enable":
                        return [];
                    case "disable-line":
                        return [
                            {
                                type: "disable",
                                line: e1.line,
                                column: 1,
                                ruleId: e1.ruleId,
                                unprocessedDirective: e1
                            },
                            {
                                type: "enable",
                                line: e1.line + 1,
                                column: 0,
                                ruleId: e1.ruleId,
                                unprocessedDirective: e1
                            }
                        ];
                    case "disable-next-line":
                        return [
                            {
                                type: "disable",
                                line: e1.line + 1,
                                column: 1,
                                ruleId: e1.ruleId,
                                unprocessedDirective: e1
                            },
                            {
                                type: "enable",
                                line: e1.line + 2,
                                column: 0,
                                ruleId: e1.ruleId,
                                unprocessedDirective: e1
                            }
                        ];
                    default:
                        throw new TypeError(`Unrecognized directive type '${e1.type}'`);
                }
            }).sort(t), u = s({
                problems: n,
                directives: o,
                disableFixes: r,
                reportUnusedDisableDirectives: i
            }), l = s({
                problems: u.problems,
                directives: a,
                disableFixes: r,
                reportUnusedDisableDirectives: i
            });
            return "off" !== i ? l.problems.concat(u.unusedDirectives).concat(l.unusedDirectives).sort(t) : l.problems;
        }, Na;
    }
    function Ya(e1) {
        return (Ya = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
            return typeof e1;
        } : function(e1) {
            return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
        })(e1);
    }
    function Za(e1, t) {
        return function(e1) {
            if (Array.isArray(e1)) return e1;
        }(e1) || function(e1, t) {
            var r = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
            if (null != r) {
                var n, s, i, o, a = [], u = !0, l = !1;
                try {
                    if (i = (r = r.call(e1)).next, 0 === t) {
                        if (Object(r) !== r) return;
                        u = !1;
                    } else for(; !(u = (n = i.call(r)).done) && (a.push(n.value), a.length !== t); u = !0);
                } catch (e1) {
                    l = !0, s = e1;
                } finally{
                    try {
                        if (!u && null != r.return && (o = r.return(), Object(o) !== o)) return;
                    } finally{
                        if (l) throw s;
                    }
                }
                return a;
            }
        }(e1, t) || tu(e1, t) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function eu(e1) {
        return function(e1) {
            if (Array.isArray(e1)) return ru(e1);
        }(e1) || function(e1) {
            if ("undefined" != typeof Symbol && null != e1[Symbol.iterator] || null != e1["@@iterator"]) return Array.from(e1);
        }(e1) || tu(e1) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function tu(e1, t) {
        if (e1) {
            if ("string" == typeof e1) return ru(e1, t);
            var r = Object.prototype.toString.call(e1).slice(8, -1);
            return "Object" === r && e1.constructor && (r = e1.constructor.name), "Map" === r || "Set" === r ? Array.from(e1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ru(e1, t) : void 0;
        }
    }
    function ru(e1, t) {
        (null == t || t > e1.length) && (t = e1.length);
        for(var r = 0, n = new Array(t); r < t; r++)n[r] = e1[r];
        return n;
    }
    function nu(e1, t) {
        return e1(t = {
            exports: {}
        }, t.exports), t.exports;
    }
    var su = nu(function(e1, t) {
        !function e1(t) {
            var r, n, s, i, o, a;
            function u(e1) {
                var t, r, n = {};
                for(t in e1)e1.hasOwnProperty(t) && (r = e1[t], n[t] = "object" == typeof r && null !== r ? u(r) : r);
                return n;
            }
            function l(e1, t) {
                this.parent = e1, this.key = t;
            }
            function c(e1, t, r, n) {
                this.node = e1, this.path = t, this.wrap = r, this.ref = n;
            }
            function p() {}
            function f(e1) {
                return null != e1 && "object" == typeof e1 && "string" == typeof e1.type;
            }
            function d(e1, t) {
                return (e1 === r.ObjectExpression || e1 === r.ObjectPattern) && "properties" === t;
            }
            function h(e1, t) {
                for(var r = e1.length - 1; r >= 0; --r)if (e1[r].node === t) return !0;
                return !1;
            }
            function m(e1, t) {
                return (new p).traverse(e1, t);
            }
            function g(e1, t) {
                var r;
                return r = function(e1, t) {
                    var r, n, s, i;
                    for(n = e1.length, s = 0; n;)t(e1[i = s + (r = n >>> 1)]) ? n = r : (s = i + 1, n -= r + 1);
                    return s;
                }(t, function(t) {
                    return t.range[0] > e1.range[0];
                }), e1.extendedRange = [
                    e1.range[0],
                    e1.range[1]
                ], r !== t.length && (e1.extendedRange[1] = t[r].range[0]), (r -= 1) >= 0 && (e1.extendedRange[0] = t[r].range[1]), e1;
            }
            return r = {
                AssignmentExpression: "AssignmentExpression",
                AssignmentPattern: "AssignmentPattern",
                ArrayExpression: "ArrayExpression",
                ArrayPattern: "ArrayPattern",
                ArrowFunctionExpression: "ArrowFunctionExpression",
                AwaitExpression: "AwaitExpression",
                BlockStatement: "BlockStatement",
                BinaryExpression: "BinaryExpression",
                BreakStatement: "BreakStatement",
                CallExpression: "CallExpression",
                CatchClause: "CatchClause",
                ChainExpression: "ChainExpression",
                ClassBody: "ClassBody",
                ClassDeclaration: "ClassDeclaration",
                ClassExpression: "ClassExpression",
                ComprehensionBlock: "ComprehensionBlock",
                ComprehensionExpression: "ComprehensionExpression",
                ConditionalExpression: "ConditionalExpression",
                ContinueStatement: "ContinueStatement",
                DebuggerStatement: "DebuggerStatement",
                DirectiveStatement: "DirectiveStatement",
                DoWhileStatement: "DoWhileStatement",
                EmptyStatement: "EmptyStatement",
                ExportAllDeclaration: "ExportAllDeclaration",
                ExportDefaultDeclaration: "ExportDefaultDeclaration",
                ExportNamedDeclaration: "ExportNamedDeclaration",
                ExportSpecifier: "ExportSpecifier",
                ExpressionStatement: "ExpressionStatement",
                ForStatement: "ForStatement",
                ForInStatement: "ForInStatement",
                ForOfStatement: "ForOfStatement",
                FunctionDeclaration: "FunctionDeclaration",
                FunctionExpression: "FunctionExpression",
                GeneratorExpression: "GeneratorExpression",
                Identifier: "Identifier",
                IfStatement: "IfStatement",
                ImportExpression: "ImportExpression",
                ImportDeclaration: "ImportDeclaration",
                ImportDefaultSpecifier: "ImportDefaultSpecifier",
                ImportNamespaceSpecifier: "ImportNamespaceSpecifier",
                ImportSpecifier: "ImportSpecifier",
                Literal: "Literal",
                LabeledStatement: "LabeledStatement",
                LogicalExpression: "LogicalExpression",
                MemberExpression: "MemberExpression",
                MetaProperty: "MetaProperty",
                MethodDefinition: "MethodDefinition",
                ModuleSpecifier: "ModuleSpecifier",
                NewExpression: "NewExpression",
                ObjectExpression: "ObjectExpression",
                ObjectPattern: "ObjectPattern",
                PrivateIdentifier: "PrivateIdentifier",
                Program: "Program",
                Property: "Property",
                PropertyDefinition: "PropertyDefinition",
                RestElement: "RestElement",
                ReturnStatement: "ReturnStatement",
                SequenceExpression: "SequenceExpression",
                SpreadElement: "SpreadElement",
                Super: "Super",
                SwitchStatement: "SwitchStatement",
                SwitchCase: "SwitchCase",
                TaggedTemplateExpression: "TaggedTemplateExpression",
                TemplateElement: "TemplateElement",
                TemplateLiteral: "TemplateLiteral",
                ThisExpression: "ThisExpression",
                ThrowStatement: "ThrowStatement",
                TryStatement: "TryStatement",
                UnaryExpression: "UnaryExpression",
                UpdateExpression: "UpdateExpression",
                VariableDeclaration: "VariableDeclaration",
                VariableDeclarator: "VariableDeclarator",
                WhileStatement: "WhileStatement",
                WithStatement: "WithStatement",
                YieldExpression: "YieldExpression"
            }, s = {
                AssignmentExpression: [
                    "left",
                    "right"
                ],
                AssignmentPattern: [
                    "left",
                    "right"
                ],
                ArrayExpression: [
                    "elements"
                ],
                ArrayPattern: [
                    "elements"
                ],
                ArrowFunctionExpression: [
                    "params",
                    "body"
                ],
                AwaitExpression: [
                    "argument"
                ],
                BlockStatement: [
                    "body"
                ],
                BinaryExpression: [
                    "left",
                    "right"
                ],
                BreakStatement: [
                    "label"
                ],
                CallExpression: [
                    "callee",
                    "arguments"
                ],
                CatchClause: [
                    "param",
                    "body"
                ],
                ChainExpression: [
                    "expression"
                ],
                ClassBody: [
                    "body"
                ],
                ClassDeclaration: [
                    "id",
                    "superClass",
                    "body"
                ],
                ClassExpression: [
                    "id",
                    "superClass",
                    "body"
                ],
                ComprehensionBlock: [
                    "left",
                    "right"
                ],
                ComprehensionExpression: [
                    "blocks",
                    "filter",
                    "body"
                ],
                ConditionalExpression: [
                    "test",
                    "consequent",
                    "alternate"
                ],
                ContinueStatement: [
                    "label"
                ],
                DebuggerStatement: [],
                DirectiveStatement: [],
                DoWhileStatement: [
                    "body",
                    "test"
                ],
                EmptyStatement: [],
                ExportAllDeclaration: [
                    "source"
                ],
                ExportDefaultDeclaration: [
                    "declaration"
                ],
                ExportNamedDeclaration: [
                    "declaration",
                    "specifiers",
                    "source"
                ],
                ExportSpecifier: [
                    "exported",
                    "local"
                ],
                ExpressionStatement: [
                    "expression"
                ],
                ForStatement: [
                    "init",
                    "test",
                    "update",
                    "body"
                ],
                ForInStatement: [
                    "left",
                    "right",
                    "body"
                ],
                ForOfStatement: [
                    "left",
                    "right",
                    "body"
                ],
                FunctionDeclaration: [
                    "id",
                    "params",
                    "body"
                ],
                FunctionExpression: [
                    "id",
                    "params",
                    "body"
                ],
                GeneratorExpression: [
                    "blocks",
                    "filter",
                    "body"
                ],
                Identifier: [],
                IfStatement: [
                    "test",
                    "consequent",
                    "alternate"
                ],
                ImportExpression: [
                    "source"
                ],
                ImportDeclaration: [
                    "specifiers",
                    "source"
                ],
                ImportDefaultSpecifier: [
                    "local"
                ],
                ImportNamespaceSpecifier: [
                    "local"
                ],
                ImportSpecifier: [
                    "imported",
                    "local"
                ],
                Literal: [],
                LabeledStatement: [
                    "label",
                    "body"
                ],
                LogicalExpression: [
                    "left",
                    "right"
                ],
                MemberExpression: [
                    "object",
                    "property"
                ],
                MetaProperty: [
                    "meta",
                    "property"
                ],
                MethodDefinition: [
                    "key",
                    "value"
                ],
                ModuleSpecifier: [],
                NewExpression: [
                    "callee",
                    "arguments"
                ],
                ObjectExpression: [
                    "properties"
                ],
                ObjectPattern: [
                    "properties"
                ],
                PrivateIdentifier: [],
                Program: [
                    "body"
                ],
                Property: [
                    "key",
                    "value"
                ],
                PropertyDefinition: [
                    "key",
                    "value"
                ],
                RestElement: [
                    "argument"
                ],
                ReturnStatement: [
                    "argument"
                ],
                SequenceExpression: [
                    "expressions"
                ],
                SpreadElement: [
                    "argument"
                ],
                Super: [],
                SwitchStatement: [
                    "discriminant",
                    "cases"
                ],
                SwitchCase: [
                    "test",
                    "consequent"
                ],
                TaggedTemplateExpression: [
                    "tag",
                    "quasi"
                ],
                TemplateElement: [],
                TemplateLiteral: [
                    "quasis",
                    "expressions"
                ],
                ThisExpression: [],
                ThrowStatement: [
                    "argument"
                ],
                TryStatement: [
                    "block",
                    "handler",
                    "finalizer"
                ],
                UnaryExpression: [
                    "argument"
                ],
                UpdateExpression: [
                    "argument"
                ],
                VariableDeclaration: [
                    "declarations"
                ],
                VariableDeclarator: [
                    "id",
                    "init"
                ],
                WhileStatement: [
                    "test",
                    "body"
                ],
                WithStatement: [
                    "object",
                    "body"
                ],
                YieldExpression: [
                    "argument"
                ]
            }, n = {
                Break: i = {},
                Skip: o = {},
                Remove: a = {}
            }, l.prototype.replace = function(e1) {
                this.parent[this.key] = e1;
            }, l.prototype.remove = function() {
                return Array.isArray(this.parent) ? (this.parent.splice(this.key, 1), !0) : (this.replace(null), !1);
            }, p.prototype.path = function() {
                var e1, t, r, n, s;
                function i(e1, t) {
                    if (Array.isArray(t)) for(r = 0, n = t.length; r < n; ++r)e1.push(t[r]);
                    else e1.push(t);
                }
                if (!this.__current.path) return null;
                for(s = [], e1 = 2, t = this.__leavelist.length; e1 < t; ++e1)i(s, this.__leavelist[e1].path);
                return i(s, this.__current.path), s;
            }, p.prototype.type = function() {
                return this.current().type || this.__current.wrap;
            }, p.prototype.parents = function() {
                var e1, t, r;
                for(r = [], e1 = 1, t = this.__leavelist.length; e1 < t; ++e1)r.push(this.__leavelist[e1].node);
                return r;
            }, p.prototype.current = function() {
                return this.__current.node;
            }, p.prototype.__execute = function(e1, t) {
                var r, n;
                return n = void 0, r = this.__current, this.__current = t, this.__state = null, e1 && (n = e1.call(this, t.node, this.__leavelist[this.__leavelist.length - 1].node)), this.__current = r, n;
            }, p.prototype.notify = function(e1) {
                this.__state = e1;
            }, p.prototype.skip = function() {
                this.notify(o);
            }, p.prototype.break = function() {
                this.notify(i);
            }, p.prototype.remove = function() {
                this.notify(a);
            }, p.prototype.__initialize = function(e1, t) {
                this.visitor = t, this.root = e1, this.__worklist = [], this.__leavelist = [], this.__current = null, this.__state = null, this.__fallback = null, "iteration" === t.fallback ? this.__fallback = Object.keys : "function" == typeof t.fallback && (this.__fallback = t.fallback), this.__keys = s, t.keys && (this.__keys = Object.assign(Object.create(this.__keys), t.keys));
            }, p.prototype.traverse = function(e1, t) {
                var r, n, s, a, u, l, p, m, g, y, E, x;
                for(this.__initialize(e1, t), x = {}, r = this.__worklist, n = this.__leavelist, r.push(new c(e1, null, null, null)), n.push(new c(null, null, null, null)); r.length;)if ((s = r.pop()) !== x) {
                    if (s.node) {
                        if (l = this.__execute(t.enter, s), this.__state === i || l === i) return;
                        if (r.push(x), n.push(s), this.__state === o || l === o) continue;
                        if (u = (a = s.node).type || s.wrap, !(y = this.__keys[u])) {
                            if (!this.__fallback) throw new Error("Unknown node type " + u + ".");
                            y = this.__fallback(a);
                        }
                        for(m = y.length; (m -= 1) >= 0;)if (E = a[p = y[m]]) {
                            if (Array.isArray(E)) {
                                for(g = E.length; (g -= 1) >= 0;)if (E[g] && !h(n, E[g])) {
                                    if (d(u, y[m])) s = new c(E[g], [
                                        p,
                                        g
                                    ], "Property", null);
                                    else {
                                        if (!f(E[g])) continue;
                                        s = new c(E[g], [
                                            p,
                                            g
                                        ], null, null);
                                    }
                                    r.push(s);
                                }
                            } else if (f(E)) {
                                if (h(n, E)) continue;
                                r.push(new c(E, p, null, null));
                            }
                        }
                    }
                } else if (s = n.pop(), l = this.__execute(t.leave, s), this.__state === i || l === i) return;
            }, p.prototype.replace = function(e1, t) {
                var r, n, s, u, p, h, m, g, y, E, x, C, S;
                function b(e1) {
                    var t, n, s, i;
                    if (e1.ref.remove()) {
                        for(n = e1.ref.key, i = e1.ref.parent, t = r.length; t--;)if ((s = r[t]).ref && s.ref.parent === i) {
                            if (s.ref.key < n) break;
                            --s.ref.key;
                        }
                    }
                }
                for(this.__initialize(e1, t), x = {}, r = this.__worklist, n = this.__leavelist, h = new c(e1, null, null, new l(C = {
                    root: e1
                }, "root")), r.push(h), n.push(h); r.length;)if ((h = r.pop()) !== x) {
                    if (void 0 !== (p = this.__execute(t.enter, h)) && p !== i && p !== o && p !== a && (h.ref.replace(p), h.node = p), this.__state !== a && p !== a || (b(h), h.node = null), this.__state === i || p === i) return C.root;
                    if ((s = h.node) && (r.push(x), n.push(h), this.__state !== o && p !== o)) {
                        if (u = s.type || h.wrap, !(y = this.__keys[u])) {
                            if (!this.__fallback) throw new Error("Unknown node type " + u + ".");
                            y = this.__fallback(s);
                        }
                        for(m = y.length; (m -= 1) >= 0;)if (E = s[S = y[m]]) {
                            if (Array.isArray(E)) {
                                for(g = E.length; (g -= 1) >= 0;)if (E[g]) {
                                    if (d(u, y[m])) h = new c(E[g], [
                                        S,
                                        g
                                    ], "Property", new l(E, g));
                                    else {
                                        if (!f(E[g])) continue;
                                        h = new c(E[g], [
                                            S,
                                            g
                                        ], null, new l(E, g));
                                    }
                                    r.push(h);
                                }
                            } else f(E) && r.push(new c(E, S, null, new l(s, S)));
                        }
                    }
                } else if (h = n.pop(), void 0 !== (p = this.__execute(t.leave, h)) && p !== i && p !== o && p !== a && h.ref.replace(p), this.__state !== a && p !== a || b(h), this.__state === i || p === i) return C.root;
                return C.root;
            }, t.Syntax = r, t.traverse = m, t.replace = function(e1, t) {
                return (new p).replace(e1, t);
            }, t.attachComments = function(e1, t, r) {
                var s, i, o, a, l = [];
                if (!e1.range) throw new Error("attachComments needs range information");
                if (!r.length) {
                    if (t.length) {
                        for(o = 0, i = t.length; o < i; o += 1)(s = u(t[o])).extendedRange = [
                            0,
                            e1.range[0]
                        ], l.push(s);
                        e1.leadingComments = l;
                    }
                    return e1;
                }
                for(o = 0, i = t.length; o < i; o += 1)l.push(g(u(t[o]), r));
                return a = 0, m(e1, {
                    enter: function(e1) {
                        for(var t; a < l.length && !((t = l[a]).extendedRange[1] > e1.range[0]);)t.extendedRange[1] === e1.range[0] ? (e1.leadingComments || (e1.leadingComments = []), e1.leadingComments.push(t), l.splice(a, 1)) : a += 1;
                        return a === l.length ? n.Break : l[a].extendedRange[0] > e1.range[1] ? n.Skip : void 0;
                    }
                }), a = 0, m(e1, {
                    leave: function(e1) {
                        for(var t; a < l.length && (t = l[a], !(e1.range[1] < t.extendedRange[0]));)e1.range[1] === t.extendedRange[0] ? (e1.trailingComments || (e1.trailingComments = []), e1.trailingComments.push(t), l.splice(a, 1)) : a += 1;
                        return a === l.length ? n.Break : l[a].extendedRange[0] > e1.range[1] ? n.Skip : void 0;
                    }
                }), e1;
            }, t.VisitorKeys = s, t.VisitorOption = n, t.Controller = p, t.cloneEnvironment = function() {
                return e1({});
            }, t;
        }(t);
    }), iu = nu(function(e1) {
        e1.exports && (e1.exports = function() {
            function e1(t, r, n, s) {
                this.message = t, this.expected = r, this.found = n, this.location = s, this.name = "SyntaxError", "function" == typeof Error.captureStackTrace && Error.captureStackTrace(this, e1);
            }
            return function(e1, t) {
                function r() {
                    this.constructor = e1;
                }
                r.prototype = t.prototype, e1.prototype = new r;
            }(e1, Error), e1.buildMessage = function(e1, t) {
                var r = {
                    literal: function(e1) {
                        return '"' + s(e1.text) + '"';
                    },
                    class: function(e1) {
                        var t, r = "";
                        for(t = 0; t < e1.parts.length; t++)r += e1.parts[t] instanceof Array ? i(e1.parts[t][0]) + "-" + i(e1.parts[t][1]) : i(e1.parts[t]);
                        return "[" + (e1.inverted ? "^" : "") + r + "]";
                    },
                    any: function(e1) {
                        return "any character";
                    },
                    end: function(e1) {
                        return "end of input";
                    },
                    other: function(e1) {
                        return e1.description;
                    }
                };
                function n(e1) {
                    return e1.charCodeAt(0).toString(16).toUpperCase();
                }
                function s(e1) {
                    return e1.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(e1) {
                        return "\\x0" + n(e1);
                    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(e1) {
                        return "\\x" + n(e1);
                    });
                }
                function i(e1) {
                    return e1.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(e1) {
                        return "\\x0" + n(e1);
                    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(e1) {
                        return "\\x" + n(e1);
                    });
                }
                return "Expected " + function(e1) {
                    var t, n, s, i = new Array(e1.length);
                    for(t = 0; t < e1.length; t++)i[t] = (s = e1[t], r[s.type](s));
                    if (i.sort(), i.length > 0) {
                        for(t = 1, n = 1; t < i.length; t++)i[t - 1] !== i[t] && (i[n] = i[t], n++);
                        i.length = n;
                    }
                    switch(i.length){
                        case 1:
                            return i[0];
                        case 2:
                            return i[0] + " or " + i[1];
                        default:
                            return i.slice(0, -1).join(", ") + ", or " + i[i.length - 1];
                    }
                }(e1) + " but " + function(e1) {
                    return e1 ? '"' + s(e1) + '"' : "end of input";
                }(t) + " found.";
            }, {
                SyntaxError: e1,
                parse: function(t, r) {
                    r = void 0 !== r ? r : {};
                    var n, s, i, o, a = {}, u = {
                        start: ge
                    }, l = ge, c = pe(" ", !1), p = /^[^ [\],():#!=><~+.]/, f = fe([
                        " ",
                        "[",
                        "]",
                        ",",
                        "(",
                        ")",
                        ":",
                        "#",
                        "!",
                        "=",
                        ">",
                        "<",
                        "~",
                        "+",
                        "."
                    ], !0, !1), d = pe(">", !1), h = pe("~", !1), m = pe("+", !1), g = pe(",", !1), y = function(e1, t) {
                        return [
                            e1
                        ].concat(t.map(function(e1) {
                            return e1[3];
                        }));
                    }, E = pe("!", !1), x = pe("*", !1), C = pe("#", !1), S = pe("[", !1), b = pe("]", !1), v = /^[><!]/, A = fe([
                        ">",
                        "<",
                        "!"
                    ], !1, !1), T = pe("=", !1), R = function(e1) {
                        return (e1 || "") + "=";
                    }, D = /^[><]/, w = fe([
                        ">",
                        "<"
                    ], !1, !1), _ = pe(".", !1), k = function(e1, t, r) {
                        return {
                            type: "attribute",
                            name: e1,
                            operator: t,
                            value: r
                        };
                    }, B = pe('"', !1), L = /^[^\\"]/, P = fe([
                        "\\",
                        '"'
                    ], !0, !1), I = pe("\\", !1), F = {
                        type: "any"
                    }, N = function(e1, t) {
                        return e1 + t;
                    }, O = function(e1) {
                        var t;
                        return {
                            type: "literal",
                            value: (t = e1.join(""), t.replace(/\\(.)/g, function(e1, t) {
                                switch(t){
                                    case "b":
                                        return "\b";
                                    case "f":
                                        return "\f";
                                    case "n":
                                        return "\n";
                                    case "r":
                                        return "\r";
                                    case "t":
                                        return "\t";
                                    case "v":
                                        return "\v";
                                    default:
                                        return t;
                                }
                            }))
                        };
                    }, U = pe("'", !1), j = /^[^\\']/, V = fe([
                        "\\",
                        "'"
                    ], !0, !1), K = /^[0-9]/, M = fe([
                        [
                            "0",
                            "9"
                        ]
                    ], !1, !1), $ = pe("type(", !1), q = /^[^ )]/, G = fe([
                        " ",
                        ")"
                    ], !0, !1), W = pe(")", !1), X = /^[imsu]/, z = fe([
                        "i",
                        "m",
                        "s",
                        "u"
                    ], !1, !1), H = pe("/", !1), J = /^[^\/]/, Q = fe([
                        "/"
                    ], !0, !1), Y = pe(":not(", !1), Z = pe(":matches(", !1), ee = pe(":has(", !1), te = pe(":first-child", !1), re = pe(":last-child", !1), ne = pe(":nth-child(", !1), se = pe(":nth-last-child(", !1), ie = pe(":", !1), oe = 0, ae = [
                        {
                            line: 1,
                            column: 1
                        }
                    ], ue = 0, le = [], ce = {};
                    if ("startRule" in r) {
                        if (!(r.startRule in u)) throw new Error("Can't start parsing from rule \"" + r.startRule + '".');
                        l = u[r.startRule];
                    }
                    function pe(e1, t) {
                        return {
                            type: "literal",
                            text: e1,
                            ignoreCase: t
                        };
                    }
                    function fe(e1, t, r) {
                        return {
                            type: "class",
                            parts: e1,
                            inverted: t,
                            ignoreCase: r
                        };
                    }
                    function de(e1) {
                        var r, n = ae[e1];
                        if (n) return n;
                        for(r = e1 - 1; !ae[r];)r--;
                        for(n = {
                            line: (n = ae[r]).line,
                            column: n.column
                        }; r < e1;)10 === t.charCodeAt(r) ? (n.line++, n.column = 1) : n.column++, r++;
                        return ae[e1] = n, n;
                    }
                    function he(e1, t) {
                        var r = de(e1), n = de(t);
                        return {
                            start: {
                                offset: e1,
                                line: r.line,
                                column: r.column
                            },
                            end: {
                                offset: t,
                                line: n.line,
                                column: n.column
                            }
                        };
                    }
                    function me(e1) {
                        oe < ue || (oe > ue && (ue = oe, le = []), le.push(e1));
                    }
                    function ge() {
                        var e1, t, r, n, s = 32 * oe + 0, i = ce[s];
                        return i ? (oe = i.nextPos, i.result) : (e1 = oe, (t = ye()) !== a && (r = Ce()) !== a && ye() !== a ? e1 = t = 1 === (n = r).length ? n[0] : {
                            type: "matches",
                            selectors: n
                        } : (oe = e1, e1 = a), e1 === a && (e1 = oe, (t = ye()) !== a && (t = void 0), e1 = t), ce[s] = {
                            nextPos: oe,
                            result: e1
                        }, e1);
                    }
                    function ye() {
                        var e1, r, n = 32 * oe + 1, s = ce[n];
                        if (s) return oe = s.nextPos, s.result;
                        for(e1 = [], 32 === t.charCodeAt(oe) ? (r = " ", oe++) : (r = a, me(c)); r !== a;)e1.push(r), 32 === t.charCodeAt(oe) ? (r = " ", oe++) : (r = a, me(c));
                        return ce[n] = {
                            nextPos: oe,
                            result: e1
                        }, e1;
                    }
                    function Ee() {
                        var e1, r, n, s = 32 * oe + 2, i = ce[s];
                        if (i) return oe = i.nextPos, i.result;
                        if (r = [], p.test(t.charAt(oe)) ? (n = t.charAt(oe), oe++) : (n = a, me(f)), n !== a) for(; n !== a;)r.push(n), p.test(t.charAt(oe)) ? (n = t.charAt(oe), oe++) : (n = a, me(f));
                        else r = a;
                        return r !== a && (r = r.join("")), e1 = r, ce[s] = {
                            nextPos: oe,
                            result: e1
                        }, e1;
                    }
                    function xe() {
                        var e1, r, n, s = 32 * oe + 3, i = ce[s];
                        return i ? (oe = i.nextPos, i.result) : (e1 = oe, (r = ye()) !== a ? (62 === t.charCodeAt(oe) ? (n = ">", oe++) : (n = a, me(d)), n !== a && ye() !== a ? e1 = r = "child" : (oe = e1, e1 = a)) : (oe = e1, e1 = a), e1 === a && (e1 = oe, (r = ye()) !== a ? (126 === t.charCodeAt(oe) ? (n = "~", oe++) : (n = a, me(h)), n !== a && ye() !== a ? e1 = r = "sibling" : (oe = e1, e1 = a)) : (oe = e1, e1 = a), e1 === a && (e1 = oe, (r = ye()) !== a ? (43 === t.charCodeAt(oe) ? (n = "+", oe++) : (n = a, me(m)), n !== a && ye() !== a ? e1 = r = "adjacent" : (oe = e1, e1 = a)) : (oe = e1, e1 = a), e1 === a && (e1 = oe, 32 === t.charCodeAt(oe) ? (r = " ", oe++) : (r = a, me(c)), r !== a && (n = ye()) !== a ? e1 = r = "descendant" : (oe = e1, e1 = a)))), ce[s] = {
                            nextPos: oe,
                            result: e1
                        }, e1);
                    }
                    function Ce() {
                        var e1, r, n, s, i, o, u, l, c = 32 * oe + 5, p = ce[c];
                        if (p) return oe = p.nextPos, p.result;
                        if (e1 = oe, (r = be()) !== a) {
                            for(n = [], s = oe, (i = ye()) !== a ? (44 === t.charCodeAt(oe) ? (o = ",", oe++) : (o = a, me(g)), o !== a && (u = ye()) !== a && (l = be()) !== a ? s = i = [
                                i,
                                o,
                                u,
                                l
                            ] : (oe = s, s = a)) : (oe = s, s = a); s !== a;)n.push(s), s = oe, (i = ye()) !== a ? (44 === t.charCodeAt(oe) ? (o = ",", oe++) : (o = a, me(g)), o !== a && (u = ye()) !== a && (l = be()) !== a ? s = i = [
                                i,
                                o,
                                u,
                                l
                            ] : (oe = s, s = a)) : (oe = s, s = a);
                            n !== a ? e1 = r = y(r, n) : (oe = e1, e1 = a);
                        } else oe = e1, e1 = a;
                        return ce[c] = {
                            nextPos: oe,
                            result: e1
                        }, e1;
                    }
                    function Se() {
                        var e1, t, r, n, s, i = 32 * oe + 6, o = ce[i];
                        return o ? (oe = o.nextPos, o.result) : (e1 = oe, (t = xe()) === a && (t = null), t !== a && (r = be()) !== a ? (s = r, e1 = t = (n = t) ? {
                            type: n,
                            left: {
                                type: "exactNode"
                            },
                            right: s
                        } : s) : (oe = e1, e1 = a), ce[i] = {
                            nextPos: oe,
                            result: e1
                        }, e1);
                    }
                    function be() {
                        var e1, t, r, n, s, i, o, u = 32 * oe + 7, l = ce[u];
                        if (l) return oe = l.nextPos, l.result;
                        if (e1 = oe, (t = ve()) !== a) {
                            for(r = [], n = oe, (s = xe()) !== a && (i = ve()) !== a ? n = s = [
                                s,
                                i
                            ] : (oe = n, n = a); n !== a;)r.push(n), n = oe, (s = xe()) !== a && (i = ve()) !== a ? n = s = [
                                s,
                                i
                            ] : (oe = n, n = a);
                            r !== a ? (o = t, e1 = t = r.reduce(function(e1, t) {
                                return {
                                    type: t[0],
                                    left: e1,
                                    right: t[1]
                                };
                            }, o)) : (oe = e1, e1 = a);
                        } else oe = e1, e1 = a;
                        return ce[u] = {
                            nextPos: oe,
                            result: e1
                        }, e1;
                    }
                    function ve() {
                        var e1, r, n, s, i, o, u, l = 32 * oe + 8, c = ce[l];
                        if (c) return oe = c.nextPos, c.result;
                        if (e1 = oe, 33 === t.charCodeAt(oe) ? (r = "!", oe++) : (r = a, me(E)), r === a && (r = null), r !== a) {
                            if (n = [], (s = Ae()) !== a) for(; s !== a;)n.push(s), s = Ae();
                            else n = a;
                            n !== a ? (i = r, u = 1 === (o = n).length ? o[0] : {
                                type: "compound",
                                selectors: o
                            }, i && (u.subject = !0), e1 = r = u) : (oe = e1, e1 = a);
                        } else oe = e1, e1 = a;
                        return ce[l] = {
                            nextPos: oe,
                            result: e1
                        }, e1;
                    }
                    function Ae() {
                        var e1, r = 32 * oe + 9, n = ce[r];
                        return n ? (oe = n.nextPos, n.result) : ((e1 = function() {
                            var e1, r, n = 32 * oe + 10, s = ce[n];
                            return s ? (oe = s.nextPos, s.result) : (42 === t.charCodeAt(oe) ? (r = "*", oe++) : (r = a, me(x)), r !== a && (r = {
                                type: "wildcard",
                                value: r
                            }), e1 = r, ce[n] = {
                                nextPos: oe,
                                result: e1
                            }, e1);
                        }()) === a && (e1 = function() {
                            var e1, r, n, s = 32 * oe + 11, i = ce[s];
                            return i ? (oe = i.nextPos, i.result) : (e1 = oe, 35 === t.charCodeAt(oe) ? (r = "#", oe++) : (r = a, me(C)), r === a && (r = null), r !== a && (n = Ee()) !== a ? e1 = r = {
                                type: "identifier",
                                value: n
                            } : (oe = e1, e1 = a), ce[s] = {
                                nextPos: oe,
                                result: e1
                            }, e1);
                        }()) === a && (e1 = function() {
                            var e1, r, n, s, i = 32 * oe + 12, o = ce[i];
                            return o ? (oe = o.nextPos, o.result) : (e1 = oe, 91 === t.charCodeAt(oe) ? (r = "[", oe++) : (r = a, me(S)), r !== a && ye() !== a && (n = function() {
                                var e1, r, n, s, i = 32 * oe + 16, o = ce[i];
                                return o ? (oe = o.nextPos, o.result) : (e1 = oe, (r = Te()) !== a && ye() !== a && (n = function() {
                                    var e1, r, n, s = 32 * oe + 14, i = ce[s];
                                    return i ? (oe = i.nextPos, i.result) : (e1 = oe, 33 === t.charCodeAt(oe) ? (r = "!", oe++) : (r = a, me(E)), r === a && (r = null), r !== a ? (61 === t.charCodeAt(oe) ? (n = "=", oe++) : (n = a, me(T)), n !== a ? e1 = r = R(r) : (oe = e1, e1 = a)) : (oe = e1, e1 = a), ce[s] = {
                                        nextPos: oe,
                                        result: e1
                                    }, e1);
                                }()) !== a && ye() !== a ? ((s = function() {
                                    var e1, r, n, s, i, o = 32 * oe + 20, u = ce[o];
                                    if (u) return oe = u.nextPos, u.result;
                                    if (e1 = oe, "type(" === t.substr(oe, 5) ? (r = "type(", oe += 5) : (r = a, me($)), r !== a) {
                                        if (ye() !== a) {
                                            if (n = [], q.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(G)), s !== a) for(; s !== a;)n.push(s), q.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(G));
                                            else n = a;
                                            n !== a && (s = ye()) !== a ? (41 === t.charCodeAt(oe) ? (i = ")", oe++) : (i = a, me(W)), i !== a ? e1 = r = {
                                                type: "type",
                                                value: n.join("")
                                            } : (oe = e1, e1 = a)) : (oe = e1, e1 = a);
                                        } else oe = e1, e1 = a;
                                    } else oe = e1, e1 = a;
                                    return ce[o] = {
                                        nextPos: oe,
                                        result: e1
                                    }, e1;
                                }()) === a && (s = function() {
                                    var e1, r, n, s, i, o, u = 32 * oe + 22, l = ce[u];
                                    if (l) return oe = l.nextPos, l.result;
                                    if (e1 = oe, 47 === t.charCodeAt(oe) ? (r = "/", oe++) : (r = a, me(H)), r !== a) {
                                        if (n = [], J.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(Q)), s !== a) for(; s !== a;)n.push(s), J.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(Q));
                                        else n = a;
                                        n !== a ? (47 === t.charCodeAt(oe) ? (s = "/", oe++) : (s = a, me(H)), s !== a ? ((i = function() {
                                            var e1, r, n = 32 * oe + 21, s = ce[n];
                                            if (s) return oe = s.nextPos, s.result;
                                            if (e1 = [], X.test(t.charAt(oe)) ? (r = t.charAt(oe), oe++) : (r = a, me(z)), r !== a) for(; r !== a;)e1.push(r), X.test(t.charAt(oe)) ? (r = t.charAt(oe), oe++) : (r = a, me(z));
                                            else e1 = a;
                                            return ce[n] = {
                                                nextPos: oe,
                                                result: e1
                                            }, e1;
                                        }()) === a && (i = null), i !== a ? (o = i, e1 = r = {
                                            type: "regexp",
                                            value: new RegExp(n.join(""), o ? o.join("") : "")
                                        }) : (oe = e1, e1 = a)) : (oe = e1, e1 = a)) : (oe = e1, e1 = a);
                                    } else oe = e1, e1 = a;
                                    return ce[u] = {
                                        nextPos: oe,
                                        result: e1
                                    }, e1;
                                }()), s !== a ? e1 = r = k(r, n, s) : (oe = e1, e1 = a)) : (oe = e1, e1 = a), e1 === a && (e1 = oe, (r = Te()) !== a && ye() !== a && (n = function() {
                                    var e1, r, n, s = 32 * oe + 13, i = ce[s];
                                    return i ? (oe = i.nextPos, i.result) : (e1 = oe, v.test(t.charAt(oe)) ? (r = t.charAt(oe), oe++) : (r = a, me(A)), r === a && (r = null), r !== a ? (61 === t.charCodeAt(oe) ? (n = "=", oe++) : (n = a, me(T)), n !== a ? e1 = r = R(r) : (oe = e1, e1 = a)) : (oe = e1, e1 = a), e1 === a && (D.test(t.charAt(oe)) ? (e1 = t.charAt(oe), oe++) : (e1 = a, me(w))), ce[s] = {
                                        nextPos: oe,
                                        result: e1
                                    }, e1);
                                }()) !== a && ye() !== a ? ((s = function() {
                                    var e1, r, n, s, i, o, u = 32 * oe + 17, l = ce[u];
                                    if (l) return oe = l.nextPos, l.result;
                                    if (e1 = oe, 34 === t.charCodeAt(oe) ? (r = '"', oe++) : (r = a, me(B)), r !== a) {
                                        for(n = [], L.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(P)), s === a && (s = oe, 92 === t.charCodeAt(oe) ? (i = "\\", oe++) : (i = a, me(I)), i !== a ? (t.length > oe ? (o = t.charAt(oe), oe++) : (o = a, me(F)), o !== a ? s = i = N(i, o) : (oe = s, s = a)) : (oe = s, s = a)); s !== a;)n.push(s), L.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(P)), s === a && (s = oe, 92 === t.charCodeAt(oe) ? (i = "\\", oe++) : (i = a, me(I)), i !== a ? (t.length > oe ? (o = t.charAt(oe), oe++) : (o = a, me(F)), o !== a ? s = i = N(i, o) : (oe = s, s = a)) : (oe = s, s = a));
                                        n !== a ? (34 === t.charCodeAt(oe) ? (s = '"', oe++) : (s = a, me(B)), s !== a ? e1 = r = O(n) : (oe = e1, e1 = a)) : (oe = e1, e1 = a);
                                    } else oe = e1, e1 = a;
                                    if (e1 === a) {
                                        if (e1 = oe, 39 === t.charCodeAt(oe) ? (r = "'", oe++) : (r = a, me(U)), r !== a) {
                                            for(n = [], j.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(V)), s === a && (s = oe, 92 === t.charCodeAt(oe) ? (i = "\\", oe++) : (i = a, me(I)), i !== a ? (t.length > oe ? (o = t.charAt(oe), oe++) : (o = a, me(F)), o !== a ? s = i = N(i, o) : (oe = s, s = a)) : (oe = s, s = a)); s !== a;)n.push(s), j.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(V)), s === a && (s = oe, 92 === t.charCodeAt(oe) ? (i = "\\", oe++) : (i = a, me(I)), i !== a ? (t.length > oe ? (o = t.charAt(oe), oe++) : (o = a, me(F)), o !== a ? s = i = N(i, o) : (oe = s, s = a)) : (oe = s, s = a));
                                            n !== a ? (39 === t.charCodeAt(oe) ? (s = "'", oe++) : (s = a, me(U)), s !== a ? e1 = r = O(n) : (oe = e1, e1 = a)) : (oe = e1, e1 = a);
                                        } else oe = e1, e1 = a;
                                    }
                                    return ce[u] = {
                                        nextPos: oe,
                                        result: e1
                                    }, e1;
                                }()) === a && (s = function() {
                                    var e1, r, n, s, i, o, u, l = 32 * oe + 18, c = ce[l];
                                    if (c) return oe = c.nextPos, c.result;
                                    for(e1 = oe, r = oe, n = [], K.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(M)); s !== a;)n.push(s), K.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(M));
                                    if (n !== a ? (46 === t.charCodeAt(oe) ? (s = ".", oe++) : (s = a, me(_)), s !== a ? r = n = [
                                        n,
                                        s
                                    ] : (oe = r, r = a)) : (oe = r, r = a), r === a && (r = null), r !== a) {
                                        if (n = [], K.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(M)), s !== a) for(; s !== a;)n.push(s), K.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(M));
                                        else n = a;
                                        n !== a ? (o = n, u = (i = r) ? [].concat.apply([], i).join("") : "", e1 = r = {
                                            type: "literal",
                                            value: parseFloat(u + o.join(""))
                                        }) : (oe = e1, e1 = a);
                                    } else oe = e1, e1 = a;
                                    return ce[l] = {
                                        nextPos: oe,
                                        result: e1
                                    }, e1;
                                }()) === a && (s = function() {
                                    var e1, t, r = 32 * oe + 19, n = ce[r];
                                    return n ? (oe = n.nextPos, n.result) : ((t = Ee()) !== a && (t = {
                                        type: "literal",
                                        value: t
                                    }), e1 = t, ce[r] = {
                                        nextPos: oe,
                                        result: e1
                                    }, e1);
                                }()), s !== a ? e1 = r = k(r, n, s) : (oe = e1, e1 = a)) : (oe = e1, e1 = a), e1 === a && (e1 = oe, (r = Te()) !== a && (r = {
                                    type: "attribute",
                                    name: r
                                }), e1 = r)), ce[i] = {
                                    nextPos: oe,
                                    result: e1
                                }, e1);
                            }()) !== a && ye() !== a ? (93 === t.charCodeAt(oe) ? (s = "]", oe++) : (s = a, me(b)), s !== a ? e1 = r = n : (oe = e1, e1 = a)) : (oe = e1, e1 = a), ce[i] = {
                                nextPos: oe,
                                result: e1
                            }, e1);
                        }()) === a && (e1 = function() {
                            var e1, r, n, s, i, o, u, l, c = 32 * oe + 23, p = ce[c];
                            if (p) return oe = p.nextPos, p.result;
                            if (e1 = oe, 46 === t.charCodeAt(oe) ? (r = ".", oe++) : (r = a, me(_)), r !== a) {
                                if ((n = Ee()) !== a) {
                                    for(s = [], i = oe, 46 === t.charCodeAt(oe) ? (o = ".", oe++) : (o = a, me(_)), o !== a && (u = Ee()) !== a ? i = o = [
                                        o,
                                        u
                                    ] : (oe = i, i = a); i !== a;)s.push(i), i = oe, 46 === t.charCodeAt(oe) ? (o = ".", oe++) : (o = a, me(_)), o !== a && (u = Ee()) !== a ? i = o = [
                                        o,
                                        u
                                    ] : (oe = i, i = a);
                                    s !== a ? (l = n, r = {
                                        type: "field",
                                        name: s.reduce(function(e1, t) {
                                            return e1 + t[0] + t[1];
                                        }, l)
                                    }, e1 = r) : (oe = e1, e1 = a);
                                } else oe = e1, e1 = a;
                            } else oe = e1, e1 = a;
                            return ce[c] = {
                                nextPos: oe,
                                result: e1
                            }, e1;
                        }()) === a && (e1 = function() {
                            var e1, r, n, s, i = 32 * oe + 24, o = ce[i];
                            return o ? (oe = o.nextPos, o.result) : (e1 = oe, ":not(" === t.substr(oe, 5) ? (r = ":not(", oe += 5) : (r = a, me(Y)), r !== a && ye() !== a && (n = Ce()) !== a && ye() !== a ? (41 === t.charCodeAt(oe) ? (s = ")", oe++) : (s = a, me(W)), s !== a ? e1 = r = {
                                type: "not",
                                selectors: n
                            } : (oe = e1, e1 = a)) : (oe = e1, e1 = a), ce[i] = {
                                nextPos: oe,
                                result: e1
                            }, e1);
                        }()) === a && (e1 = function() {
                            var e1, r, n, s, i = 32 * oe + 25, o = ce[i];
                            return o ? (oe = o.nextPos, o.result) : (e1 = oe, ":matches(" === t.substr(oe, 9) ? (r = ":matches(", oe += 9) : (r = a, me(Z)), r !== a && ye() !== a && (n = Ce()) !== a && ye() !== a ? (41 === t.charCodeAt(oe) ? (s = ")", oe++) : (s = a, me(W)), s !== a ? e1 = r = {
                                type: "matches",
                                selectors: n
                            } : (oe = e1, e1 = a)) : (oe = e1, e1 = a), ce[i] = {
                                nextPos: oe,
                                result: e1
                            }, e1);
                        }()) === a && (e1 = function() {
                            var e1, r, n, s, i = 32 * oe + 26, o = ce[i];
                            return o ? (oe = o.nextPos, o.result) : (e1 = oe, ":has(" === t.substr(oe, 5) ? (r = ":has(", oe += 5) : (r = a, me(ee)), r !== a && ye() !== a && (n = function() {
                                var e1, r, n, s, i, o, u, l, c = 32 * oe + 4, p = ce[c];
                                if (p) return oe = p.nextPos, p.result;
                                if (e1 = oe, (r = Se()) !== a) {
                                    for(n = [], s = oe, (i = ye()) !== a ? (44 === t.charCodeAt(oe) ? (o = ",", oe++) : (o = a, me(g)), o !== a && (u = ye()) !== a && (l = Se()) !== a ? s = i = [
                                        i,
                                        o,
                                        u,
                                        l
                                    ] : (oe = s, s = a)) : (oe = s, s = a); s !== a;)n.push(s), s = oe, (i = ye()) !== a ? (44 === t.charCodeAt(oe) ? (o = ",", oe++) : (o = a, me(g)), o !== a && (u = ye()) !== a && (l = Se()) !== a ? s = i = [
                                        i,
                                        o,
                                        u,
                                        l
                                    ] : (oe = s, s = a)) : (oe = s, s = a);
                                    n !== a ? e1 = r = y(r, n) : (oe = e1, e1 = a);
                                } else oe = e1, e1 = a;
                                return ce[c] = {
                                    nextPos: oe,
                                    result: e1
                                }, e1;
                            }()) !== a && ye() !== a ? (41 === t.charCodeAt(oe) ? (s = ")", oe++) : (s = a, me(W)), s !== a ? e1 = r = {
                                type: "has",
                                selectors: n
                            } : (oe = e1, e1 = a)) : (oe = e1, e1 = a), ce[i] = {
                                nextPos: oe,
                                result: e1
                            }, e1);
                        }()) === a && (e1 = function() {
                            var e1, r, n = 32 * oe + 27, s = ce[n];
                            return s ? (oe = s.nextPos, s.result) : (":first-child" === t.substr(oe, 12) ? (r = ":first-child", oe += 12) : (r = a, me(te)), r !== a && (r = Re(1)), e1 = r, ce[n] = {
                                nextPos: oe,
                                result: e1
                            }, e1);
                        }()) === a && (e1 = function() {
                            var e1, r, n = 32 * oe + 28, s = ce[n];
                            return s ? (oe = s.nextPos, s.result) : (":last-child" === t.substr(oe, 11) ? (r = ":last-child", oe += 11) : (r = a, me(re)), r !== a && (r = De(1)), e1 = r, ce[n] = {
                                nextPos: oe,
                                result: e1
                            }, e1);
                        }()) === a && (e1 = function() {
                            var e1, r, n, s, i, o = 32 * oe + 29, u = ce[o];
                            if (u) return oe = u.nextPos, u.result;
                            if (e1 = oe, ":nth-child(" === t.substr(oe, 11) ? (r = ":nth-child(", oe += 11) : (r = a, me(ne)), r !== a) {
                                if (ye() !== a) {
                                    if (n = [], K.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(M)), s !== a) for(; s !== a;)n.push(s), K.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(M));
                                    else n = a;
                                    n !== a && (s = ye()) !== a ? (41 === t.charCodeAt(oe) ? (i = ")", oe++) : (i = a, me(W)), i !== a ? e1 = r = Re(parseInt(n.join(""), 10)) : (oe = e1, e1 = a)) : (oe = e1, e1 = a);
                                } else oe = e1, e1 = a;
                            } else oe = e1, e1 = a;
                            return ce[o] = {
                                nextPos: oe,
                                result: e1
                            }, e1;
                        }()) === a && (e1 = function() {
                            var e1, r, n, s, i, o = 32 * oe + 30, u = ce[o];
                            if (u) return oe = u.nextPos, u.result;
                            if (e1 = oe, ":nth-last-child(" === t.substr(oe, 16) ? (r = ":nth-last-child(", oe += 16) : (r = a, me(se)), r !== a) {
                                if (ye() !== a) {
                                    if (n = [], K.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(M)), s !== a) for(; s !== a;)n.push(s), K.test(t.charAt(oe)) ? (s = t.charAt(oe), oe++) : (s = a, me(M));
                                    else n = a;
                                    n !== a && (s = ye()) !== a ? (41 === t.charCodeAt(oe) ? (i = ")", oe++) : (i = a, me(W)), i !== a ? e1 = r = De(parseInt(n.join(""), 10)) : (oe = e1, e1 = a)) : (oe = e1, e1 = a);
                                } else oe = e1, e1 = a;
                            } else oe = e1, e1 = a;
                            return ce[o] = {
                                nextPos: oe,
                                result: e1
                            }, e1;
                        }()) === a && (e1 = function() {
                            var e1, r, n, s = 32 * oe + 31, i = ce[s];
                            return i ? (oe = i.nextPos, i.result) : (e1 = oe, 58 === t.charCodeAt(oe) ? (r = ":", oe++) : (r = a, me(ie)), r !== a && (n = Ee()) !== a ? e1 = r = {
                                type: "class",
                                name: n
                            } : (oe = e1, e1 = a), ce[s] = {
                                nextPos: oe,
                                result: e1
                            }, e1);
                        }()), ce[r] = {
                            nextPos: oe,
                            result: e1
                        }, e1);
                    }
                    function Te() {
                        var e1, r, n, s, i, o, u, l, c = 32 * oe + 15, p = ce[c];
                        if (p) return oe = p.nextPos, p.result;
                        if (e1 = oe, (r = Ee()) !== a) {
                            for(n = [], s = oe, 46 === t.charCodeAt(oe) ? (i = ".", oe++) : (i = a, me(_)), i !== a && (o = Ee()) !== a ? s = i = [
                                i,
                                o
                            ] : (oe = s, s = a); s !== a;)n.push(s), s = oe, 46 === t.charCodeAt(oe) ? (i = ".", oe++) : (i = a, me(_)), i !== a && (o = Ee()) !== a ? s = i = [
                                i,
                                o
                            ] : (oe = s, s = a);
                            n !== a ? (u = r, l = n, e1 = r = [].concat.apply([
                                u
                            ], l).join("")) : (oe = e1, e1 = a);
                        } else oe = e1, e1 = a;
                        return ce[c] = {
                            nextPos: oe,
                            result: e1
                        }, e1;
                    }
                    function Re(e1) {
                        return {
                            type: "nth-child",
                            index: {
                                type: "literal",
                                value: e1
                            }
                        };
                    }
                    function De(e1) {
                        return {
                            type: "nth-last-child",
                            index: {
                                type: "literal",
                                value: e1
                            }
                        };
                    }
                    if ((n = l()) !== a && oe === t.length) return n;
                    throw n !== a && oe < t.length && me({
                        type: "end"
                    }), s = le, i = ue < t.length ? t.charAt(ue) : null, o = ue < t.length ? he(ue, ue + 1) : he(ue, ue), new e1(e1.buildMessage(s, i), s, i, o);
                }
            };
        }());
    });
    function ou(e1, t) {
        for(var r = 0; r < t.length; ++r){
            if (null == e1) return e1;
            e1 = e1[t[r]];
        }
        return e1;
    }
    var au, uu, lu, cu, pu, fu, du, hu, mu, gu, yu = "function" == typeof WeakMap ? new WeakMap : null;
    function Eu(e1) {
        if (null == e1) return function() {
            return !0;
        };
        if (null != yu) {
            var t = yu.get(e1);
            return null != t || (t = xu(e1), yu.set(e1, t)), t;
        }
        return xu(e1);
    }
    function xu(e1) {
        switch(e1.type){
            case "wildcard":
                return function() {
                    return !0;
                };
            case "identifier":
                var t = e1.value.toLowerCase();
                return function(e1, r, n) {
                    var s = n && n.nodeTypeKey || "type";
                    return t === e1[s].toLowerCase();
                };
            case "exactNode":
                return function(e1, t) {
                    return 0 === t.length;
                };
            case "field":
                var r = e1.name.split(".");
                return function(e1, t) {
                    return function e1(t, r, n, s) {
                        for(var i = r, o = s; o < n.length; ++o){
                            if (null == i) return !1;
                            var a = i[n[o]];
                            if (Array.isArray(a)) {
                                for(var u = 0; u < a.length; ++u)if (e1(t, a[u], n, o + 1)) return !0;
                                return !1;
                            }
                            i = a;
                        }
                        return t === i;
                    }(e1, t[r.length - 1], r, 0);
                };
            case "matches":
                var n = e1.selectors.map(Eu);
                return function(e1, t, r) {
                    for(var s = 0; s < n.length; ++s)if (n[s](e1, t, r)) return !0;
                    return !1;
                };
            case "compound":
                var s = e1.selectors.map(Eu);
                return function(e1, t, r) {
                    for(var n = 0; n < s.length; ++n)if (!s[n](e1, t, r)) return !1;
                    return !0;
                };
            case "not":
                var i = e1.selectors.map(Eu);
                return function(e1, t, r) {
                    for(var n = 0; n < i.length; ++n)if (i[n](e1, t, r)) return !1;
                    return !0;
                };
            case "has":
                var o = e1.selectors.map(Eu);
                return function(e1, t, r) {
                    var n = !1, s = [];
                    return su.traverse(e1, {
                        enter: function(e1, t) {
                            null != t && s.unshift(t);
                            for(var i = 0; i < o.length; ++i)if (o[i](e1, s, r)) return n = !0, void this.break();
                        },
                        leave: function() {
                            s.shift();
                        },
                        keys: r && r.visitorKeys,
                        fallback: r && r.fallback || "iteration"
                    }), n;
                };
            case "child":
                var a = Eu(e1.left), u = Eu(e1.right);
                return function(e1, t, r) {
                    return !!(t.length > 0 && u(e1, t, r)) && a(t[0], t.slice(1), r);
                };
            case "descendant":
                var l = Eu(e1.left), c = Eu(e1.right);
                return function(e1, t, r) {
                    if (c(e1, t, r)) {
                        for(var n = 0, s = t.length; n < s; ++n)if (l(t[n], t.slice(n + 1), r)) return !0;
                    }
                    return !1;
                };
            case "attribute":
                var p = e1.name.split(".");
                switch(e1.operator){
                    case void 0:
                        return function(e1) {
                            return null != ou(e1, p);
                        };
                    case "=":
                        switch(e1.value.type){
                            case "regexp":
                                return function(t) {
                                    var r = ou(t, p);
                                    return "string" == typeof r && e1.value.value.test(r);
                                };
                            case "literal":
                                var f = "".concat(e1.value.value);
                                return function(e1) {
                                    return f === "".concat(ou(e1, p));
                                };
                            case "type":
                                return function(t) {
                                    return e1.value.value === Ya(ou(t, p));
                                };
                        }
                        throw new Error("Unknown selector value type: ".concat(e1.value.type));
                    case "!=":
                        switch(e1.value.type){
                            case "regexp":
                                return function(t) {
                                    return !e1.value.value.test(ou(t, p));
                                };
                            case "literal":
                                var d = "".concat(e1.value.value);
                                return function(e1) {
                                    return d !== "".concat(ou(e1, p));
                                };
                            case "type":
                                return function(t) {
                                    return e1.value.value !== Ya(ou(t, p));
                                };
                        }
                        throw new Error("Unknown selector value type: ".concat(e1.value.type));
                    case "<=":
                        return function(t) {
                            return ou(t, p) <= e1.value.value;
                        };
                    case "<":
                        return function(t) {
                            return ou(t, p) < e1.value.value;
                        };
                    case ">":
                        return function(t) {
                            return ou(t, p) > e1.value.value;
                        };
                    case ">=":
                        return function(t) {
                            return ou(t, p) >= e1.value.value;
                        };
                }
                throw new Error("Unknown operator: ".concat(e1.operator));
            case "sibling":
                var h = Eu(e1.left), m = Eu(e1.right);
                return function(t, r, n) {
                    return m(t, r, n) && bu(t, h, r, "LEFT_SIDE", n) || e1.left.subject && h(t, r, n) && bu(t, m, r, "RIGHT_SIDE", n);
                };
            case "adjacent":
                var g = Eu(e1.left), y = Eu(e1.right);
                return function(t, r, n) {
                    return y(t, r, n) && vu(t, g, r, "LEFT_SIDE", n) || e1.right.subject && g(t, r, n) && vu(t, y, r, "RIGHT_SIDE", n);
                };
            case "nth-child":
                var E = e1.index.value, x = Eu(e1.right);
                return function(e1, t, r) {
                    return x(e1, t, r) && Au(e1, t, E, r);
                };
            case "nth-last-child":
                var C = -e1.index.value, S = Eu(e1.right);
                return function(e1, t, r) {
                    return S(e1, t, r) && Au(e1, t, C, r);
                };
            case "class":
                var b = e1.name.toLowerCase();
                return function(t, r, n) {
                    if (n && n.matchClass) return n.matchClass(e1.name, t, r);
                    if (n && n.nodeTypeKey) return !1;
                    switch(b){
                        case "statement":
                            if ("Statement" === t.type.slice(-9)) return !0;
                        case "declaration":
                            return "Declaration" === t.type.slice(-11);
                        case "pattern":
                            if ("Pattern" === t.type.slice(-7)) return !0;
                        case "expression":
                            return "Expression" === t.type.slice(-10) || "Literal" === t.type.slice(-7) || "Identifier" === t.type && (0 === r.length || "MetaProperty" !== r[0].type) || "MetaProperty" === t.type;
                        case "function":
                            return "FunctionDeclaration" === t.type || "FunctionExpression" === t.type || "ArrowFunctionExpression" === t.type;
                    }
                    throw new Error("Unknown class name: ".concat(e1.name));
                };
        }
        throw new Error("Unknown selector type: ".concat(e1.type));
    }
    function Cu(e1, t) {
        var r = t && t.nodeTypeKey || "type", n = e1[r];
        return t && t.visitorKeys && t.visitorKeys[n] ? t.visitorKeys[n] : su.VisitorKeys[n] ? su.VisitorKeys[n] : t && "function" == typeof t.fallback ? t.fallback(e1) : Object.keys(e1).filter(function(e1) {
            return e1 !== r;
        });
    }
    function Su(e1, t) {
        var r = t && t.nodeTypeKey || "type";
        return null !== e1 && "object" === Ya(e1) && "string" == typeof e1[r];
    }
    function bu(e1, t, r, n, s) {
        var i = Za(r, 1)[0];
        if (!i) return !1;
        for(var o = Cu(i, s), a = 0; a < o.length; ++a){
            var u = i[o[a]];
            if (Array.isArray(u)) {
                var l = u.indexOf(e1);
                if (l < 0) continue;
                var c = void 0, p = void 0;
                "LEFT_SIDE" === n ? (c = 0, p = l) : (c = l + 1, p = u.length);
                for(var f = c; f < p; ++f)if (Su(u[f], s) && t(u[f], r, s)) return !0;
            }
        }
        return !1;
    }
    function vu(e1, t, r, n, s) {
        var i = Za(r, 1)[0];
        if (!i) return !1;
        for(var o = Cu(i, s), a = 0; a < o.length; ++a){
            var u = i[o[a]];
            if (Array.isArray(u)) {
                var l = u.indexOf(e1);
                if (l < 0) continue;
                if ("LEFT_SIDE" === n && l > 0 && Su(u[l - 1], s) && t(u[l - 1], r, s)) return !0;
                if ("RIGHT_SIDE" === n && l < u.length - 1 && Su(u[l + 1], s) && t(u[l + 1], r, s)) return !0;
            }
        }
        return !1;
    }
    function Au(e1, t, r, n) {
        if (0 === r) return !1;
        var s = Za(t, 1)[0];
        if (!s) return !1;
        for(var i = Cu(s, n), o = 0; o < i.length; ++o){
            var a = s[i[o]];
            if (Array.isArray(a)) {
                var u = r < 0 ? a.length + r : r - 1;
                if (u >= 0 && u < a.length && a[u] === e1) return !0;
            }
        }
        return !1;
    }
    function Tu(e1, t, r, n) {
        if (t) {
            var s = [], i = Eu(t), o = (function e1(t, r) {
                if (null == t || "object" != Ya(t)) return [];
                null == r && (r = t);
                for(var n = t.subject ? [
                    r
                ] : [], s = Object.keys(t), i = 0; i < s.length; ++i){
                    var o = s[i], a = t[o];
                    n.push.apply(n, eu(e1(a, "left" === o ? a : r)));
                }
                return n;
            })(t).map(Eu);
            su.traverse(e1, {
                enter: function(e1, t) {
                    if (null != t && s.unshift(t), i(e1, s, n)) {
                        if (o.length) for(var a = 0, u = o.length; a < u; ++a){
                            o[a](e1, s, n) && r(e1, t, s);
                            for(var l = 0, c = s.length; l < c; ++l){
                                var p = s.slice(l + 1);
                                o[a](s[l], p, n) && r(s[l], t, p);
                            }
                        }
                        else r(e1, t, s);
                    }
                },
                leave: function() {
                    s.shift();
                },
                keys: n && n.visitorKeys,
                fallback: n && n.fallback || "iteration"
            });
        }
    }
    function Ru(e1, t, r) {
        var n = [];
        return Tu(e1, t, function(e1) {
            n.push(e1);
        }, r), n;
    }
    function Du(e1) {
        return iu.parse(e1);
    }
    function wu(e1, t, r) {
        return Ru(e1, Du(t), r);
    }
    function _u() {
        if (uu) return au;
        uu = 1;
        const e1 = wu;
        function t(e1) {
            switch(e1.type){
                case "identifier":
                    return [
                        e1.value
                    ];
                case "matches":
                    {
                        const r = e1.selectors.map(t);
                        return r.every(Boolean) ? function(...e1) {
                            return [
                                ...new Set(e1.flat())
                            ];
                        }(...r) : null;
                    }
                case "compound":
                    {
                        const r = e1.selectors.map(t).filter((e1)=>e1);
                        return r.length ? function(...e1) {
                            if (0 === e1.length) return [];
                            let t = [
                                ...new Set(e1[0])
                            ];
                            for (const r of e1.slice(1))t = t.filter((e1)=>r.includes(e1));
                            return t;
                        }(...r) : null;
                    }
                case "child":
                case "descendant":
                case "sibling":
                case "adjacent":
                    return t(e1.right);
                case "class":
                    return "function" === e1.name ? [
                        "FunctionDeclaration",
                        "FunctionExpression",
                        "ArrowFunctionExpression"
                    ] : null;
                default:
                    return null;
            }
        }
        function r(e1) {
            switch(e1.type){
                case "child":
                case "descendant":
                case "sibling":
                case "adjacent":
                    return r(e1.left) + r(e1.right);
                case "compound":
                case "not":
                case "matches":
                    return e1.selectors.reduce((e1, t)=>e1 + r(t), 0);
                case "attribute":
                case "field":
                case "nth-child":
                case "nth-last-child":
                    return 1;
                default:
                    return 0;
            }
        }
        function n(e1) {
            switch(e1.type){
                case "child":
                case "descendant":
                case "sibling":
                case "adjacent":
                    return n(e1.left) + n(e1.right);
                case "compound":
                case "not":
                case "matches":
                    return e1.selectors.reduce((e1, t)=>e1 + n(t), 0);
                case "identifier":
                    return 1;
                default:
                    return 0;
            }
        }
        function s(e1, t) {
            return e1.attributeCount - t.attributeCount || e1.identifierCount - t.identifierCount || (e1.rawSelector <= t.rawSelector ? -1 : 1);
        }
        const i = new Map;
        function o(s) {
            if (i.has(s)) return i.get(s);
            const o = function(t) {
                try {
                    return e1.parse(t.replace(/:exit$/u, ""));
                } catch (e1) {
                    if (e1.location && e1.location.start && "number" == typeof e1.location.start.offset) throw new SyntaxError(`Syntax error in selector "${t}" at position ${e1.location.start.offset}: ${e1.message}`);
                    throw e1;
                }
            }(s), a = {
                rawSelector: s,
                isExit: s.endsWith(":exit"),
                parsedSelector: o,
                listenerTypes: t(o),
                attributeCount: r(o),
                identifierCount: n(o)
            };
            return i.set(s, a), a;
        }
        return au = class {
            constructor(e1, t){
                this.emitter = e1, this.esqueryOptions = t, this.currentAncestry = [], this.enterSelectorsByNodeType = new Map, this.exitSelectorsByNodeType = new Map, this.anyTypeEnterSelectors = [], this.anyTypeExitSelectors = [], e1.eventNames().forEach((e1)=>{
                    const t = o(e1);
                    if (t.listenerTypes) {
                        const e1 = t.isExit ? this.exitSelectorsByNodeType : this.enterSelectorsByNodeType;
                        return void t.listenerTypes.forEach((r)=>{
                            e1.has(r) || e1.set(r, []), e1.get(r).push(t);
                        });
                    }
                    (t.isExit ? this.anyTypeExitSelectors : this.anyTypeEnterSelectors).push(t);
                }), this.anyTypeEnterSelectors.sort(s), this.anyTypeExitSelectors.sort(s), this.enterSelectorsByNodeType.forEach((e1)=>e1.sort(s)), this.exitSelectorsByNodeType.forEach((e1)=>e1.sort(s));
            }
            applySelector(t, r) {
                e1.matches(t, r.parsedSelector, this.currentAncestry, this.esqueryOptions) && this.emitter.emit(r.rawSelector, t);
            }
            applySelectors(e1, t) {
                const r = (t ? this.exitSelectorsByNodeType : this.enterSelectorsByNodeType).get(e1.type) || [], n = t ? this.anyTypeExitSelectors : this.anyTypeEnterSelectors;
                let i = 0, o = 0;
                for(; i < r.length || o < n.length;)i >= r.length || o < n.length && s(n[o], r[i]) < 0 ? this.applySelector(e1, n[o++]) : this.applySelector(e1, r[i++]);
            }
            enterNode(e1) {
                e1.parent && this.currentAncestry.unshift(e1.parent), this.applySelectors(e1, !1);
            }
            leaveNode(e1) {
                this.applySelectors(e1, !0), this.currentAncestry.shift();
            }
        }, au;
    }
    function ku() {
        return fu || (fu = 1, pu = (e1, t)=>t ? e1.replace(/\{\{([^{}]+?)\}\}/gu, (e1, r)=>{
                const n = r.trim();
                return n in t ? t[n] : e1;
            }) : e1), pu;
    }
    function Bu() {
        if (hu) return du;
        hu = 1;
        const e1 = ir, t = function() {
            if (cu) return lu;
            function e1(e1, t) {
                return {
                    range: [
                        e1,
                        e1
                    ],
                    text: t
                };
            }
            cu = 1;
            const t = Object.freeze({
                insertTextAfter (e1, t) {
                    return this.insertTextAfterRange(e1.range, t);
                },
                insertTextAfterRange: (t, r)=>e1(t[1], r),
                insertTextBefore (e1, t) {
                    return this.insertTextBeforeRange(e1.range, t);
                },
                insertTextBeforeRange: (t, r)=>e1(t[0], r),
                replaceText (e1, t) {
                    return this.replaceTextRange(e1.range, t);
                },
                replaceTextRange: (e1, t)=>({
                        range: e1,
                        text: t
                    }),
                remove (e1) {
                    return this.removeRange(e1.range);
                },
                removeRange: (e1)=>({
                        range: e1,
                        text: ""
                    })
            });
            return lu = t;
        }(), r = ku();
        function n(e1) {
            return e1.loc ? e1.loc.start ? e1.loc : {
                start: e1.loc,
                end: null
            } : e1.node.loc;
        }
        function s(e1) {
            return e1 ? {
                range: [
                    e1.range[0],
                    e1.range[1]
                ],
                text: e1.text
            } : null;
        }
        function i(t) {
            t && e1(t.range && "number" == typeof t.range[0] && "number" == typeof t.range[1], `Fix has invalid range: ${JSON.stringify(t, null, 2)}`);
        }
        function o(e1, t) {
            return e1.range[0] - t.range[0] || e1.range[1] - t.range[1];
        }
        function a(r, n) {
            if ("function" != typeof r.fix) return null;
            const a = r.fix(t);
            return a && Symbol.iterator in a ? function(t, r) {
                for (const e1 of t)i(e1);
                if (0 === t.length) return null;
                if (1 === t.length) return s(t[0]);
                t.sort(o);
                const n = r.text, a = t[0].range[0], u = t[t.length - 1].range[1];
                let l = "", c = Number.MIN_SAFE_INTEGER;
                for (const r of t)e1(r.range[0] >= c, "Fix objects must not be overlapped in a report."), r.range[0] >= 0 && (l += n.slice(Math.max(0, a, c), r.range[0])), l += r.text, c = r.range[1];
                return l += n.slice(Math.max(0, a, c), u), {
                    range: [
                        a,
                        u
                    ],
                    text: l
                };
            }(Array.from(a), n) : (i(a), s(a));
        }
        function u(e1, t, n) {
            return e1.suggest && Array.isArray(e1.suggest) ? e1.suggest.map((e1)=>{
                const s = e1.desc || n[e1.messageId];
                return {
                    ...e1,
                    desc: r(s, e1.data),
                    fix: a(e1, t)
                };
            }).filter(({ fix: e1 })=>e1) : [];
        }
        return du = function(t) {
            return (...s)=>{
                const i = function(...e1) {
                    return 1 === e1.length ? Object.assign({}, e1[0]) : "string" == typeof e1[1] ? {
                        node: e1[0],
                        message: e1[1],
                        data: e1[2],
                        fix: e1[3]
                    } : {
                        node: e1[0],
                        loc: e1[1],
                        message: e1[2],
                        data: e1[3],
                        fix: e1[4]
                    };
                }(...s), o = t.messageIds;
                let l;
                if (function(t) {
                    t.node ? e1("object" == typeof t.node, "Node must be an object") : e1(t.loc, "Node must be provided when reporting error if location is not provided");
                }(i), i.messageId) {
                    if (!o) throw new TypeError("context.report() called with a messageId, but no messages were present in the rule metadata.");
                    const e1 = i.messageId;
                    if (i.message) throw new TypeError("context.report() called with a message and a messageId. Please only pass one.");
                    if (!o || !Object.prototype.hasOwnProperty.call(o, e1)) throw new TypeError(`context.report() called with a messageId of '${e1}' which is not present in the 'messages' config: ${JSON.stringify(o, null, 2)}`);
                    l = o[e1];
                } else {
                    if (!i.message) throw new TypeError("Missing `message` property in report() call; add a message that describes the linting problem.");
                    l = i.message;
                }
                return function(e1, t) {
                    e1 && Array.isArray(e1) && e1.forEach((e1)=>{
                        if (e1.messageId) {
                            const { messageId: r } = e1;
                            if (!t) throw new TypeError(`context.report() called with a suggest option with a messageId '${r}', but no messages were present in the rule metadata.`);
                            if (!t[r]) throw new TypeError(`context.report() called with a suggest option with a messageId '${r}' which is not present in the 'messages' config: ${JSON.stringify(t, null, 2)}`);
                            if (e1.desc) throw new TypeError("context.report() called with a suggest option that defines both a 'messageId' and an 'desc'. Please only pass one.");
                        } else if (!e1.desc) throw new TypeError("context.report() called with a suggest option that doesn't have either a `desc` or `messageId`");
                        if ("function" != typeof e1.fix) throw new TypeError(`context.report() called with a suggest option without a fix function. See: ${e1}`);
                    });
                }(i.suggest, o), function(e1) {
                    const t = {
                        ruleId: e1.ruleId,
                        severity: e1.severity,
                        message: e1.message,
                        line: e1.loc.start.line,
                        column: e1.loc.start.column + 1,
                        nodeType: e1.node && e1.node.type || null
                    };
                    return e1.messageId && (t.messageId = e1.messageId), e1.loc.end && (t.endLine = e1.loc.end.line, t.endColumn = e1.loc.end.column + 1), e1.fix && (t.fix = e1.fix), e1.suggestions && e1.suggestions.length > 0 && (t.suggestions = e1.suggestions), t;
                }({
                    ruleId: t.ruleId,
                    severity: t.severity,
                    node: i.node,
                    message: r(l, i.data),
                    messageId: i.messageId,
                    loc: n(i),
                    fix: t.disableFixes ? null : a(i, t.sourceCode),
                    suggestions: t.disableFixes ? [] : u(i, t.sourceCode, o)
                });
            };
        }, du;
    }
    wu.parse = Du, wu.match = Ru, wu.traverse = Tu, wu.matches = function(e1, t, r, n) {
        return !t || !!e1 && (r || (r = []), Eu(t)(e1, r, n));
    }, wu.query = wu;
    var Lu, Pu = {}, Iu = {
        get exports () {
            return Pu;
        },
        set exports (e){
            Pu = e;
        }
    }, Fu = {}, Nu = {}, Ou = {
        get exports () {
            return Nu;
        },
        set exports (e){
            Nu = e;
        }
    };
    var Uu, ju = {}, Vu = {
        get exports () {
            return ju;
        },
        set exports (e){
            ju = e;
        }
    };
    function Ku() {
        return Uu || (Uu = 1, function() {
            var e1, t, r, n, s, i;
            function o(e1) {
                return e1 <= 65535 ? String.fromCharCode(e1) : String.fromCharCode(Math.floor((e1 - 65536) / 1024) + 55296) + String.fromCharCode((e1 - 65536) % 1024 + 56320);
            }
            for(t = {
                NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
                NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/
            }, e1 = {
                NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
                NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
            }, r = [
                5760,
                8192,
                8193,
                8194,
                8195,
                8196,
                8197,
                8198,
                8199,
                8200,
                8201,
                8202,
                8239,
                8287,
                12288,
                65279
            ], n = new Array(128), i = 0; i < 128; ++i)n[i] = i >= 97 && i <= 122 || i >= 65 && i <= 90 || 36 === i || 95 === i;
            for(s = new Array(128), i = 0; i < 128; ++i)s[i] = i >= 97 && i <= 122 || i >= 65 && i <= 90 || i >= 48 && i <= 57 || 36 === i || 95 === i;
            Vu.exports = {
                isDecimalDigit: function(e1) {
                    return 48 <= e1 && e1 <= 57;
                },
                isHexDigit: function(e1) {
                    return 48 <= e1 && e1 <= 57 || 97 <= e1 && e1 <= 102 || 65 <= e1 && e1 <= 70;
                },
                isOctalDigit: function(e1) {
                    return e1 >= 48 && e1 <= 55;
                },
                isWhiteSpace: function(e1) {
                    return 32 === e1 || 9 === e1 || 11 === e1 || 12 === e1 || 160 === e1 || e1 >= 5760 && r.indexOf(e1) >= 0;
                },
                isLineTerminator: function(e1) {
                    return 10 === e1 || 13 === e1 || 8232 === e1 || 8233 === e1;
                },
                isIdentifierStartES5: function(e1) {
                    return e1 < 128 ? n[e1] : t.NonAsciiIdentifierStart.test(o(e1));
                },
                isIdentifierPartES5: function(e1) {
                    return e1 < 128 ? s[e1] : t.NonAsciiIdentifierPart.test(o(e1));
                },
                isIdentifierStartES6: function(t) {
                    return t < 128 ? n[t] : e1.NonAsciiIdentifierStart.test(o(t));
                },
                isIdentifierPartES6: function(t) {
                    return t < 128 ? s[t] : e1.NonAsciiIdentifierPart.test(o(t));
                }
            };
        }()), ju;
    }
    var Mu, $u, qu, Gu, Wu, Xu, zu, Hu, Ju, Qu, Yu, Zu, el, tl, rl, nl, sl, il, ol, al, ul, ll, cl, pl, fl, dl, hl, ml, gl, yl, El, xl, Cl, Sl, bl, vl, Al, Tl, Rl, Dl, wl, _l = {}, kl = {
        get exports () {
            return _l;
        },
        set exports (e){
            _l = e;
        }
    };
    function Bl() {
        return $u || ($u = 1, Fu.ast = (Lu || (Lu = 1, function() {
            function e1(e1) {
                if (null == e1) return !1;
                switch(e1.type){
                    case "BlockStatement":
                    case "BreakStatement":
                    case "ContinueStatement":
                    case "DebuggerStatement":
                    case "DoWhileStatement":
                    case "EmptyStatement":
                    case "ExpressionStatement":
                    case "ForInStatement":
                    case "ForStatement":
                    case "IfStatement":
                    case "LabeledStatement":
                    case "ReturnStatement":
                    case "SwitchStatement":
                    case "ThrowStatement":
                    case "TryStatement":
                    case "VariableDeclaration":
                    case "WhileStatement":
                    case "WithStatement":
                        return !0;
                }
                return !1;
            }
            function t(e1) {
                switch(e1.type){
                    case "IfStatement":
                        return null != e1.alternate ? e1.alternate : e1.consequent;
                    case "LabeledStatement":
                    case "ForStatement":
                    case "ForInStatement":
                    case "WhileStatement":
                    case "WithStatement":
                        return e1.body;
                }
                return null;
            }
            Ou.exports = {
                isExpression: function(e1) {
                    if (null == e1) return !1;
                    switch(e1.type){
                        case "ArrayExpression":
                        case "AssignmentExpression":
                        case "BinaryExpression":
                        case "CallExpression":
                        case "ConditionalExpression":
                        case "FunctionExpression":
                        case "Identifier":
                        case "Literal":
                        case "LogicalExpression":
                        case "MemberExpression":
                        case "NewExpression":
                        case "ObjectExpression":
                        case "SequenceExpression":
                        case "ThisExpression":
                        case "UnaryExpression":
                        case "UpdateExpression":
                            return !0;
                    }
                    return !1;
                },
                isStatement: e1,
                isIterationStatement: function(e1) {
                    if (null == e1) return !1;
                    switch(e1.type){
                        case "DoWhileStatement":
                        case "ForInStatement":
                        case "ForStatement":
                        case "WhileStatement":
                            return !0;
                    }
                    return !1;
                },
                isSourceElement: function(t) {
                    return e1(t) || null != t && "FunctionDeclaration" === t.type;
                },
                isProblematicIfStatement: function(e1) {
                    var r;
                    if ("IfStatement" !== e1.type) return !1;
                    if (null == e1.alternate) return !1;
                    r = e1.consequent;
                    do {
                        if ("IfStatement" === r.type && null == r.alternate) return !0;
                        r = t(r);
                    }while (r);
                    return !1;
                },
                trailingStatement: t
            };
        }()), Nu), Fu.code = Ku(), Fu.keyword = (Mu || (Mu = 1, function() {
            var e1 = Ku();
            function t(e1, t) {
                return !(!t && "yield" === e1) && r(e1, t);
            }
            function r(e1, t) {
                if (t && function(e1) {
                    switch(e1){
                        case "implements":
                        case "interface":
                        case "package":
                        case "private":
                        case "protected":
                        case "public":
                        case "static":
                        case "let":
                            return !0;
                        default:
                            return !1;
                    }
                }(e1)) return !0;
                switch(e1.length){
                    case 2:
                        return "if" === e1 || "in" === e1 || "do" === e1;
                    case 3:
                        return "var" === e1 || "for" === e1 || "new" === e1 || "try" === e1;
                    case 4:
                        return "this" === e1 || "else" === e1 || "case" === e1 || "void" === e1 || "with" === e1 || "enum" === e1;
                    case 5:
                        return "while" === e1 || "break" === e1 || "catch" === e1 || "throw" === e1 || "const" === e1 || "yield" === e1 || "class" === e1 || "super" === e1;
                    case 6:
                        return "return" === e1 || "typeof" === e1 || "delete" === e1 || "switch" === e1 || "export" === e1 || "import" === e1;
                    case 7:
                        return "default" === e1 || "finally" === e1 || "extends" === e1;
                    case 8:
                        return "function" === e1 || "continue" === e1 || "debugger" === e1;
                    case 10:
                        return "instanceof" === e1;
                    default:
                        return !1;
                }
            }
            function n(e1, r) {
                return "null" === e1 || "true" === e1 || "false" === e1 || t(e1, r);
            }
            function s(e1, t) {
                return "null" === e1 || "true" === e1 || "false" === e1 || r(e1, t);
            }
            function i(t) {
                var r, n, s;
                if (0 === t.length) return !1;
                if (s = t.charCodeAt(0), !e1.isIdentifierStartES5(s)) return !1;
                for(r = 1, n = t.length; r < n; ++r)if (s = t.charCodeAt(r), !e1.isIdentifierPartES5(s)) return !1;
                return !0;
            }
            function o(t) {
                var r, n, s, i, o;
                if (0 === t.length) return !1;
                for(o = e1.isIdentifierStartES6, r = 0, n = t.length; r < n; ++r){
                    if (55296 <= (s = t.charCodeAt(r)) && s <= 56319) {
                        if (++r >= n) return !1;
                        if (!(56320 <= (i = t.charCodeAt(r)) && i <= 57343)) return !1;
                        s = 1024 * (s - 55296) + (i - 56320) + 65536;
                    }
                    if (!o(s)) return !1;
                    o = e1.isIdentifierPartES6;
                }
                return !0;
            }
            kl.exports = {
                isKeywordES5: t,
                isKeywordES6: r,
                isReservedWordES5: n,
                isReservedWordES6: s,
                isRestrictedWord: function(e1) {
                    return "eval" === e1 || "arguments" === e1;
                },
                isIdentifierNameES5: i,
                isIdentifierNameES6: o,
                isIdentifierES5: function(e1, t) {
                    return i(e1) && !n(e1, t);
                },
                isIdentifierES6: function(e1, t) {
                    return o(e1) && !s(e1, t);
                }
            };
        }()), _l)), Fu;
    }
    function Ll() {
        return qu || (qu = 1, function(e1) {
            const { KEYS: t } = gr(), r = Bl(), n = wr(), s = Ja(), { breakableTypePattern: i, createGlobalLinebreakMatcher: o, lineBreakPattern: a, shebangPattern: u } = Ur(), l = /^(?:Function(?:Declaration|Expression)|ArrowFunctionExpression)$/u, c = /^(?:DoWhile|For|ForIn|ForOf|While)Statement$/u, p = /^(?:every|filter|find(?:Last)?(?:Index)?|flatMap|forEach|map|some)$/u, f = /Array$/u, d = /^(?:bind|call|apply)$/u, h = /^[\s*]*@this/mu, m = /^(?:eslint[- ]|(?:globals?|exported) )/u, g = new Set([
                "\r\n",
                "\r",
                "\n",
                "\u2028",
                "\u2029"
            ]), y = new Set([
                "Program",
                "BlockStatement",
                "StaticBlock",
                "SwitchCase"
            ]), E = /^(?:0|0[0-7]*[89]\d*|[1-9](?:_?\d)*)$/u, x = /^(?:[^\\]|\\.)*\\(?:[1-9]|0[0-9])/su, C = new Set([
                "&&=",
                "||=",
                "??="
            ]);
            function S(e1, t, r) {
                const n = e1.identifier, s = 0 === t || r[t - 1].identifier !== n;
                return n && !1 === e1.init && e1.isWrite() && s;
            }
            function b(e1) {
                return e1[0] !== e1[0].toLocaleLowerCase();
            }
            function v(e1) {
                return e1.id && b(e1.id.name);
            }
            function A(e1) {
                for(let t = e1; t; t = t.parent)if (l.test(t.type)) return t;
                return null;
            }
            function T(e1) {
                return Boolean(e1 && l.test(e1.type));
            }
            function R(e1) {
                return Boolean(e1 && c.test(e1.type));
            }
            function D(e1) {
                return "Literal" === e1.type && null === e1.value && !e1.regex && !e1.bigint;
            }
            function w(e1) {
                return D(e1) || "Identifier" === e1.type && "undefined" === e1.name || "UnaryExpression" === e1.type && "void" === e1.operator;
            }
            function _(e1) {
                return "CallExpression" === e1.parent.type && e1.parent.callee === e1;
            }
            function k(e1) {
                switch(e1.type){
                    case "Literal":
                        if (null !== e1.value) return String(e1.value);
                        if (D(e1)) return String(e1.value);
                        if (e1.regex) return `/${e1.regex.pattern}/${e1.regex.flags}`;
                        if (e1.bigint) return e1.bigint;
                        break;
                    case "TemplateLiteral":
                        if (0 === e1.expressions.length && 1 === e1.quasis.length) return e1.quasis[0].value.cooked;
                }
                return null;
            }
            function B(e1) {
                let t;
                switch(e1 && e1.type){
                    case "ChainExpression":
                        return B(e1.expression);
                    case "Property":
                    case "PropertyDefinition":
                    case "MethodDefinition":
                        t = e1.key;
                        break;
                    case "MemberExpression":
                        t = e1.property;
                }
                return t ? "Identifier" !== t.type || e1.computed ? k(t) : t.name : null;
            }
            function L(e1) {
                return e1 && "ChainExpression" === e1.type ? e1.expression : e1;
            }
            function P(e1, t) {
                return "string" == typeof t ? e1 === t : t.test(e1);
            }
            function I(e1, t) {
                return "Identifier" === e1.type && P(e1.name, t);
            }
            function F(e1, t, r) {
                const n = L(e1);
                if ("MemberExpression" !== n.type) return !1;
                if (t && !I(n.object, t)) return !1;
                if (r) {
                    const e1 = B(n);
                    if ("string" != typeof e1 || !P(e1, r)) return !1;
                }
                return !0;
            }
            function N(e1, t) {
                return e1.regex || t.regex ? Boolean(e1.regex && t.regex && e1.regex.pattern === t.regex.pattern && e1.regex.flags === t.regex.flags) : e1.bigint || t.bigint ? e1.bigint === t.bigint : e1.value === t.value;
            }
            function O(e1) {
                return F(e1, "Reflect", "apply");
            }
            function U(e1) {
                return F(e1, f, "from");
            }
            function j(e1) {
                return F(e1, null, p);
            }
            function V(e1) {
                return (t)=>!e1(t);
            }
            function K(e1) {
                return "=>" === e1.value && "Punctuator" === e1.type;
            }
            function M(e1) {
                return "," === e1.value && "Punctuator" === e1.type;
            }
            function $(e1) {
                return "." === e1.value && "Punctuator" === e1.type;
            }
            function q(e1) {
                return "?." === e1.value && "Punctuator" === e1.type;
            }
            function G(e1) {
                return ";" === e1.value && "Punctuator" === e1.type;
            }
            function W(e1) {
                return ":" === e1.value && "Punctuator" === e1.type;
            }
            function X(e1) {
                return "(" === e1.value && "Punctuator" === e1.type;
            }
            function z(e1) {
                return ")" === e1.value && "Punctuator" === e1.type;
            }
            function H(e1) {
                return "[" === e1.value && "Punctuator" === e1.type;
            }
            function J(e1) {
                return "]" === e1.value && "Punctuator" === e1.type;
            }
            function Q(e1) {
                return "{" === e1.value && "Punctuator" === e1.type;
            }
            function Y(e1) {
                return "}" === e1.value && "Punctuator" === e1.type;
            }
            function Z(e1, t) {
                if ("ArrowFunctionExpression" === e1.type && 1 === e1.params.length) {
                    const r = t.getFirstToken(e1.params[0]), n = t.getTokenBefore(r);
                    return X(n) ? n : r;
                }
                return e1.id ? t.getTokenAfter(e1.id, X) : t.getFirstToken(e1, X);
            }
            function ee(e1) {
                return "LogicalExpression" === e1.type && ("&&" === e1.operator || "||" === e1.operator);
            }
            function te(e1) {
                return "LogicalExpression" === e1.type && "??" === e1.operator;
            }
            function re(e1) {
                return null === e1.value ? "null" !== e1.raw && ("object" == typeof e1.regex || null) : !!e1.value;
            }
            function ne(e1, t) {
                switch(e1.type){
                    case "Literal":
                        return "||" === t && !0 === re(e1) || "&&" === t && !1 === re(e1);
                    case "UnaryExpression":
                        return "&&" === t && "void" === e1.operator;
                    case "LogicalExpression":
                        return t === e1.operator && (ne(e1.left, t) || ne(e1.right, t));
                    case "AssignmentExpression":
                        return [
                            "||=",
                            "&&="
                        ].includes(e1.operator) && t === e1.operator.slice(0, -1) && ne(e1.right, t);
                }
                return !1;
            }
            function se(e1, t) {
                const r = e1.references.find((e1)=>e1.identifier === t);
                return Boolean(r && r.resolved && "global" === r.resolved.scope.type && 0 === r.resolved.defs.length);
            }
            let ie;
            {
                const e1 = new Set([
                    "BreakStatement",
                    "ContinueStatement"
                ]), t = new Set([
                    "ExportAllDeclaration",
                    "ExportNamedDeclaration",
                    "ImportDeclaration"
                ]), r = new Set([
                    "Identifier",
                    "Keyword"
                ]), n = {
                    __proto__: null,
                    break: "BreakStatement",
                    continue: "ContinueStatement",
                    debugger: "DebuggerStatement",
                    do: "DoWhileStatement",
                    else: "IfStatement",
                    return: "ReturnStatement",
                    yield: "YieldExpression"
                }, s = new Set([
                    ":",
                    ";",
                    "{",
                    "=>",
                    "++",
                    "--"
                ]), i = new Set([
                    "DoWhileStatement",
                    "ForInStatement",
                    "ForOfStatement",
                    "ForStatement",
                    "IfStatement",
                    "WhileStatement",
                    "WithStatement"
                ]);
                ie = function(o, a) {
                    const u = o.getTokenBefore(a);
                    if (!u || "Punctuator" === u.type && s.has(u.value)) return !1;
                    const l = o.getNodeByRangeIndex(u.range[0]);
                    if (z(u)) return !i.has(l.type);
                    if (Y(u)) return "BlockStatement" === l.type && "FunctionExpression" === l.parent.type || "ClassBody" === l.type && "ClassExpression" === l.parent.type || "ObjectExpression" === l.type;
                    if (r.has(u.type)) {
                        if (e1.has(l.parent.type)) return !1;
                        const t = u.value, r = n[t];
                        return l.type !== r;
                    }
                    return "String" !== u.type || !t.has(l.parent.type);
                };
            }
            e1.exports = {
                COMMENTS_IGNORE_PATTERN: /^\s*(?:eslint|jshint\s+|jslint\s+|istanbul\s+|globals?\s+|exported\s+|jscs)/u,
                LINEBREAKS: g,
                LINEBREAK_MATCHER: a,
                SHEBANG_MATCHER: u,
                STATEMENT_LIST_PARENTS: y,
                isTokenOnSameLine: (e1, t)=>e1.loc.end.line === t.loc.start.line,
                isNullOrUndefined: w,
                isCallee: _,
                isES5Constructor: v,
                getUpperFunction: A,
                isFunction: T,
                isLoop: R,
                isInLoop: function(e1) {
                    for(let t = e1; t && !T(t); t = t.parent)if (R(t)) return !0;
                    return !1;
                },
                isArrayFromMethod: U,
                isParenthesised: function(e1, t) {
                    const r = e1.getTokenBefore(t), n = e1.getTokenAfter(t);
                    return Boolean(r && n) && "(" === r.value && r.range[1] <= t.range[0] && ")" === n.value && n.range[0] >= t.range[1];
                },
                createGlobalLinebreakMatcher: o,
                equalTokens: function(e1, t, r) {
                    const n = r.getTokens(e1), s = r.getTokens(t);
                    if (n.length !== s.length) return !1;
                    for(let e1 = 0; e1 < n.length; ++e1)if (n[e1].type !== s[e1].type || n[e1].value !== s[e1].value) return !1;
                    return !0;
                },
                isArrowToken: K,
                isClosingBraceToken: Y,
                isClosingBracketToken: J,
                isClosingParenToken: z,
                isColonToken: W,
                isCommaToken: M,
                isCommentToken: function(e1) {
                    return "Line" === e1.type || "Block" === e1.type || "Shebang" === e1.type;
                },
                isDotToken: $,
                isQuestionDotToken: q,
                isKeywordToken: function(e1) {
                    return "Keyword" === e1.type;
                },
                isNotClosingBraceToken: V(Y),
                isNotClosingBracketToken: V(J),
                isNotClosingParenToken: V(z),
                isNotColonToken: V(W),
                isNotCommaToken: V(M),
                isNotDotToken: V($),
                isNotQuestionDotToken: V(q),
                isNotOpeningBraceToken: V(Q),
                isNotOpeningBracketToken: V(H),
                isNotOpeningParenToken: V(X),
                isNotSemicolonToken: V(G),
                isOpeningBraceToken: Q,
                isOpeningBracketToken: H,
                isOpeningParenToken: X,
                isSemicolonToken: G,
                isEqToken: function(e1) {
                    return "=" === e1.value && "Punctuator" === e1.type;
                },
                isStringLiteral: (e1)=>"Literal" === e1.type && "string" == typeof e1.value || "TemplateLiteral" === e1.type,
                isBreakableStatement: (e1)=>i.test(e1.type),
                getModifyingReferences: (e1)=>e1.filter(S),
                isSurroundedBy: (e1, t)=>e1[0] === t && e1[e1.length - 1] === t,
                isDirectiveComment (e1) {
                    const t = e1.value.trim();
                    return "Line" === e1.type && t.startsWith("eslint-") || "Block" === e1.type && m.test(t);
                },
                getTrailingStatement: r.ast.trailingStatement,
                getVariableByName (e1, t) {
                    let r = e1;
                    for(; r;){
                        const e1 = r.set.get(t);
                        if (e1) return e1;
                        r = r.upper;
                    }
                    return null;
                },
                isDefaultThisBinding (e1, t, { capIsConstructor: r = !0 } = {}) {
                    if ("PropertyDefinition" === e1.parent.type && e1.parent.value === e1) return !1;
                    if ("StaticBlock" === e1.type) return !1;
                    if (r && v(e1) || function(e1, t) {
                        const r = t.getJSDocComment(e1);
                        return !(!r || !h.test(r.value)) || t.getCommentsBefore(e1).some((e1)=>h.test(e1.value));
                    }(e1, t)) return !1;
                    const n = null === e1.id;
                    let s = e1;
                    for(; s;){
                        const e1 = s.parent;
                        switch(e1.type){
                            case "LogicalExpression":
                            case "ConditionalExpression":
                            case "ChainExpression":
                                s = e1;
                                break;
                            case "ReturnStatement":
                                {
                                    const t = A(e1);
                                    if (null === t || !_(t)) return !0;
                                    s = t.parent;
                                    break;
                                }
                            case "ArrowFunctionExpression":
                                if (s !== e1.body || !_(e1)) return !0;
                                s = e1.parent;
                                break;
                            case "Property":
                            case "PropertyDefinition":
                            case "MethodDefinition":
                                return e1.value !== s;
                            case "AssignmentExpression":
                            case "AssignmentPattern":
                                return "MemberExpression" !== e1.left.type && !(r && n && "Identifier" === e1.left.type && b(e1.left.name));
                            case "VariableDeclarator":
                                return !(r && n && e1.init === s && "Identifier" === e1.id.type && b(e1.id.name));
                            case "MemberExpression":
                                if (e1.object === s && F(e1, null, d)) {
                                    const t = "ChainExpression" === e1.parent.type ? e1.parent : e1;
                                    return !(_(t) && t.parent.arguments.length >= 1 && !w(t.parent.arguments[0]));
                                }
                                return !0;
                            case "CallExpression":
                                return O(e1.callee) ? 3 !== e1.arguments.length || e1.arguments[0] !== s || w(e1.arguments[1]) : U(e1.callee) ? 3 !== e1.arguments.length || e1.arguments[1] !== s || w(e1.arguments[2]) : !j(e1.callee) || 2 !== e1.arguments.length || e1.arguments[0] !== s || w(e1.arguments[1]);
                            default:
                                return !0;
                        }
                    }
                    return !0;
                },
                getPrecedence (e1) {
                    switch(e1.type){
                        case "SequenceExpression":
                            return 0;
                        case "AssignmentExpression":
                        case "ArrowFunctionExpression":
                        case "YieldExpression":
                            return 1;
                        case "ConditionalExpression":
                            return 3;
                        case "LogicalExpression":
                            switch(e1.operator){
                                case "||":
                                case "??":
                                    return 4;
                                case "&&":
                                    return 5;
                            }
                        case "BinaryExpression":
                            switch(e1.operator){
                                case "|":
                                    return 6;
                                case "^":
                                    return 7;
                                case "&":
                                    return 8;
                                case "==":
                                case "!=":
                                case "===":
                                case "!==":
                                    return 9;
                                case "<":
                                case "<=":
                                case ">":
                                case ">=":
                                case "in":
                                case "instanceof":
                                    return 10;
                                case "<<":
                                case ">>":
                                case ">>>":
                                    return 11;
                                case "+":
                                case "-":
                                    return 12;
                                case "*":
                                case "/":
                                case "%":
                                    return 13;
                                case "**":
                                    return 15;
                            }
                        case "UnaryExpression":
                        case "AwaitExpression":
                            return 16;
                        case "UpdateExpression":
                            return 17;
                        case "CallExpression":
                        case "ChainExpression":
                        case "ImportExpression":
                            return 18;
                        case "NewExpression":
                            return 19;
                        default:
                            return e1.type in t ? 20 : -1;
                    }
                },
                isEmptyBlock: (e1)=>Boolean(e1 && "BlockStatement" === e1.type && 0 === e1.body.length),
                isEmptyFunction: (t)=>T(t) && e1.exports.isEmptyBlock(t.body),
                getDirectivePrologue (e1) {
                    const t = [];
                    if ("Program" === e1.type || "FunctionDeclaration" === e1.type || "FunctionExpression" === e1.type || "ArrowFunctionExpression" === e1.type && "BlockStatement" === e1.body.type) {
                        const r = "Program" === e1.type ? e1.body : e1.body.body;
                        for (const e1 of r){
                            if ("ExpressionStatement" !== e1.type || "Literal" !== e1.expression.type) break;
                            t.push(e1);
                        }
                    }
                    return t;
                },
                isDecimalInteger: (e1)=>"Literal" === e1.type && "number" == typeof e1.value && E.test(e1.raw),
                isDecimalIntegerNumericToken: (e1)=>"Numeric" === e1.type && E.test(e1.value),
                getFunctionNameWithKind (e1) {
                    const t = e1.parent, r = [];
                    if ("MethodDefinition" !== t.type && "PropertyDefinition" !== t.type || (t.static && r.push("static"), t.computed || "PrivateIdentifier" !== t.key.type || r.push("private")), e1.async && r.push("async"), e1.generator && r.push("generator"), "Property" === t.type || "MethodDefinition" === t.type) {
                        if ("constructor" === t.kind) return "constructor";
                        "get" === t.kind ? r.push("getter") : "set" === t.kind ? r.push("setter") : r.push("method");
                    } else "PropertyDefinition" === t.type ? r.push("method") : ("ArrowFunctionExpression" === e1.type && r.push("arrow"), r.push("function"));
                    if ("Property" === t.type || "MethodDefinition" === t.type || "PropertyDefinition" === t.type) {
                        if (t.computed || "PrivateIdentifier" !== t.key.type) {
                            const n = B(t);
                            null !== n ? r.push(`'${n}'`) : e1.id && r.push(`'${e1.id.name}'`);
                        } else r.push(`#${t.key.name}`);
                    } else e1.id && r.push(`'${e1.id.name}'`);
                    return r.join(" ");
                },
                getFunctionHeadLoc (e1, t) {
                    const r = e1.parent;
                    let n = null, s = null;
                    if ("Property" === r.type || "MethodDefinition" === r.type || "PropertyDefinition" === r.type) n = r.loc.start, s = Z(e1, t).loc.start;
                    else if ("ArrowFunctionExpression" === e1.type) {
                        const r = t.getTokenBefore(e1.body, K);
                        n = r.loc.start, s = r.loc.end;
                    } else n = e1.loc.start, s = Z(e1, t).loc.start;
                    return {
                        start: Object.assign({}, n),
                        end: Object.assign({}, s)
                    };
                },
                getNextLocation: (e1, { line: t, column: r })=>r < e1.lines[t - 1].length ? {
                        line: t,
                        column: r + 1
                    } : t < e1.lines.length ? {
                        line: t + 1,
                        column: 0
                    } : null,
                getParenthesisedText (e1, t) {
                    let r = e1.getFirstToken(t), n = e1.getLastToken(t);
                    for(; e1.getTokenBefore(r) && "Punctuator" === e1.getTokenBefore(r).type && "(" === e1.getTokenBefore(r).value && e1.getTokenAfter(n) && "Punctuator" === e1.getTokenAfter(n).type && ")" === e1.getTokenAfter(n).value;)r = e1.getTokenBefore(r), n = e1.getTokenAfter(n);
                    return e1.getText().slice(r.range[0], n.range[1]);
                },
                couldBeError (t) {
                    switch(t.type){
                        case "Identifier":
                        case "CallExpression":
                        case "NewExpression":
                        case "MemberExpression":
                        case "TaggedTemplateExpression":
                        case "YieldExpression":
                        case "AwaitExpression":
                        case "ChainExpression":
                            return !0;
                        case "AssignmentExpression":
                            return [
                                "=",
                                "&&="
                            ].includes(t.operator) ? e1.exports.couldBeError(t.right) : !![
                                "||=",
                                "??="
                            ].includes(t.operator) && (e1.exports.couldBeError(t.left) || e1.exports.couldBeError(t.right));
                        case "SequenceExpression":
                            {
                                const r = t.expressions;
                                return 0 !== r.length && e1.exports.couldBeError(r[r.length - 1]);
                            }
                        case "LogicalExpression":
                            return "&&" === t.operator ? e1.exports.couldBeError(t.right) : e1.exports.couldBeError(t.left) || e1.exports.couldBeError(t.right);
                        case "ConditionalExpression":
                            return e1.exports.couldBeError(t.consequent) || e1.exports.couldBeError(t.alternate);
                        default:
                            return !1;
                    }
                },
                isNumericLiteral: (e1)=>"Literal" === e1.type && ("number" == typeof e1.value || Boolean(e1.bigint)),
                canTokensBeAdjacent (e1, t) {
                    const r = {
                        ecmaVersion: n.latestEcmaVersion,
                        comment: !0,
                        range: !0
                    };
                    let s, i;
                    if ("string" == typeof e1) {
                        let t;
                        try {
                            t = n.tokenize(e1, r);
                        } catch  {
                            return !1;
                        }
                        const i = t.comments;
                        if (s = t[t.length - 1], i.length) {
                            const e1 = i[i.length - 1];
                            (!s || e1.range[0] > s.range[0]) && (s = e1);
                        }
                    } else s = e1;
                    if ("Shebang" === s.type || "Hashbang" === s.type) return !1;
                    if ("string" == typeof t) {
                        let e1;
                        try {
                            e1 = n.tokenize(t, r);
                        } catch  {
                            return !1;
                        }
                        const s = e1.comments;
                        if (i = e1[0], s.length) {
                            const e1 = s[0];
                            (!i || e1.range[0] < i.range[0]) && (i = e1);
                        }
                    } else i = t;
                    if ("Punctuator" === s.type || "Punctuator" === i.type) {
                        if ("Punctuator" === s.type && "Punctuator" === i.type) {
                            const e1 = new Set([
                                "+",
                                "++"
                            ]), t = new Set([
                                "-",
                                "--"
                            ]);
                            return !(e1.has(s.value) && e1.has(i.value) || t.has(s.value) && t.has(i.value));
                        }
                        return "Punctuator" !== s.type || "/" !== s.value || ![
                            "Block",
                            "Line",
                            "RegularExpression"
                        ].includes(i.type);
                    }
                    return "String" === s.type || "String" === i.type || "Template" === s.type || "Template" === i.type || !("Numeric" === s.type || "Numeric" !== i.type || !i.value.startsWith(".")) || "Block" === s.type || "Block" === i.type || "Line" === i.type || "PrivateIdentifier" === i.type;
                },
                getNameLocationInGlobalDirectiveComment (e1, t, r) {
                    const n = new RegExp(`[\\s,]${s(r)}(?:$|[\\s,:])`, "gu");
                    n.lastIndex = t.value.indexOf("global") + 6;
                    const i = n.exec(t.value), o = e1.getLocFromIndex(t.range[0] + 2 + (i ? i.index + 1 : 0));
                    return {
                        start: o,
                        end: {
                            line: o.line,
                            column: o.column + (i ? r.length : 1)
                        }
                    };
                },
                hasOctalOrNonOctalDecimalEscapeSequence: (e1)=>x.test(e1),
                isStaticTemplateLiteral: (e1)=>"TemplateLiteral" === e1.type && 0 === e1.expressions.length,
                isReferenceToGlobalVariable: se,
                isLogicalExpression: ee,
                isCoalesceExpression: te,
                isMixedLogicalAndCoalesceExpressions: function(e1, t) {
                    return ee(e1) && te(t) || te(e1) && ee(t);
                },
                isNullLiteral: D,
                getStaticStringValue: k,
                getStaticPropertyName: B,
                skipChainExpression: L,
                isSpecificId: I,
                isSpecificMemberAccess: F,
                equalLiteralValue: N,
                isSameReference: function e1(t, r, n = !1) {
                    if (t.type !== r.type) return "ChainExpression" === t.type ? e1(t.expression, r, n) : "ChainExpression" === r.type && e1(t, r.expression, n);
                    switch(t.type){
                        case "Super":
                        case "ThisExpression":
                            return !0;
                        case "Identifier":
                        case "PrivateIdentifier":
                            return t.name === r.name;
                        case "Literal":
                            return N(t, r);
                        case "ChainExpression":
                            return e1(t.expression, r.expression, n);
                        case "MemberExpression":
                            if (!n) {
                                const s = B(t);
                                if (null !== s) return e1(t.object, r.object, n) && s === B(r);
                            }
                            return t.computed === r.computed && e1(t.object, r.object, n) && e1(t.property, r.property, n);
                        default:
                            return !1;
                    }
                },
                isLogicalAssignmentOperator: function(e1) {
                    return C.has(e1);
                },
                getSwitchCaseColonToken: function(e1, t) {
                    return e1.test ? t.getTokenAfter(e1.test, W) : t.getFirstToken(e1, 1);
                },
                getModuleExportName: function(e1) {
                    return "Identifier" === e1.type ? e1.name : e1.value;
                },
                isConstant: function e1(t, r, n) {
                    if (!r) return !0;
                    switch(r.type){
                        case "Literal":
                        case "ArrowFunctionExpression":
                        case "FunctionExpression":
                        case "ClassExpression":
                        case "ObjectExpression":
                            return !0;
                        case "TemplateLiteral":
                            return n && r.quasis.some((e1)=>e1.value.cooked.length) || r.expressions.every((r)=>e1(t, r, !1));
                        case "ArrayExpression":
                            return !!n || r.elements.every((r)=>e1(t, r, !1));
                        case "UnaryExpression":
                            return !!("void" === r.operator || "typeof" === r.operator && n) || ("!" === r.operator ? e1(t, r.argument, !0) : e1(t, r.argument, !1));
                        case "BinaryExpression":
                            return e1(t, r.left, !1) && e1(t, r.right, !1) && "in" !== r.operator;
                        case "LogicalExpression":
                            {
                                const s = e1(t, r.left, n), i = e1(t, r.right, n), o = s && ne(r.left, r.operator), a = n && i && ne(r.right, r.operator);
                                return s && i || o || a;
                            }
                        case "NewExpression":
                            return n;
                        case "AssignmentExpression":
                            return "=" === r.operator ? e1(t, r.right, n) : !(![
                                "||=",
                                "&&="
                            ].includes(r.operator) || !n) && ne(r.right, r.operator.slice(0, -1));
                        case "SequenceExpression":
                            return e1(t, r.expressions[r.expressions.length - 1], n);
                        case "SpreadElement":
                            return e1(t, r.argument, n);
                        case "CallExpression":
                            return !("Identifier" !== r.callee.type || "Boolean" !== r.callee.name || 0 !== r.arguments.length && !e1(t, r.arguments[0], !0)) && se(t, r.callee);
                        case "Identifier":
                            return "undefined" === r.name && se(t, r);
                    }
                    return !1;
                },
                isTopLevelExpressionStatement: function(e1) {
                    if ("ExpressionStatement" !== e1.type) return !1;
                    const t = e1.parent;
                    return "Program" === t.type || "BlockStatement" === t.type && T(t.parent);
                },
                isDirective: function(e1) {
                    return "ExpressionStatement" === e1.type && "string" == typeof e1.directive;
                },
                isStartOfExpressionStatement: function(e1) {
                    const t = e1.range[0];
                    let r = e1;
                    for(; (r = r.parent) && r.range[0] === t;)if ("ExpressionStatement" === r.type) return !0;
                    return !1;
                },
                needsPrecedingSemicolon: ie
            };
        }(Iu)), Pu;
    }
    function Pl() {
        if (Wu) return Gu;
        Wu = 1;
        const e1 = Ll();
        function t(e1) {
            return "get" === e1.kind || "set" === e1.kind;
        }
        function r(t, r, n, s) {
            const i = t.parent;
            return "CallExpression" === i.type && e1.isSpecificMemberAccess(i.callee, n, s) && i.arguments[r] === t;
        }
        return Gu = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Enforce getter and setter pairs in objects and classes",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/accessor-pairs"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            getWithoutSet: {
                                type: "boolean",
                                default: !1
                            },
                            setWithoutGet: {
                                type: "boolean",
                                default: !0
                            },
                            enforceForClassMembers: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    missingGetterInPropertyDescriptor: "Getter is not present in property descriptor.",
                    missingSetterInPropertyDescriptor: "Setter is not present in property descriptor.",
                    missingGetterInObjectLiteral: "Getter is not present for {{ name }}.",
                    missingSetterInObjectLiteral: "Setter is not present for {{ name }}.",
                    missingGetterInClass: "Getter is not present for class {{ name }}.",
                    missingSetterInClass: "Setter is not present for class {{ name }}."
                }
            },
            create (n) {
                const s = n.options[0] || {}, i = !0 === s.getWithoutSet, o = !1 !== s.setWithoutGet, a = !1 !== s.enforceForClassMembers, u = n.sourceCode;
                function l(t, r) {
                    "Property" === t.type ? n.report({
                        node: t,
                        messageId: `${r}InObjectLiteral`,
                        loc: e1.getFunctionHeadLoc(t.value, u),
                        data: {
                            name: e1.getFunctionNameWithKind(t.value)
                        }
                    }) : "MethodDefinition" === t.type ? n.report({
                        node: t,
                        messageId: `${r}InClass`,
                        loc: e1.getFunctionHeadLoc(t.value, u),
                        data: {
                            name: e1.getFunctionNameWithKind(t.value)
                        }
                    }) : n.report({
                        node: t,
                        messageId: `${r}InPropertyDescriptor`
                    });
                }
                function c(e1, t) {
                    for (const r of e1)l(r, t);
                }
                function p(r) {
                    const n = [];
                    let s = !1;
                    for(let i = 0; i < r.length; i++){
                        const o = r[i];
                        if (t(o)) {
                            const t = e1.getStaticPropertyName(o), r = null !== t ? t : u.getTokens(o.key);
                            for(let e1 = 0; e1 < n.length; e1++){
                                const t = n[e1];
                                if (a = t.key, l = r, "string" == typeof a && "string" == typeof l ? a === l : Array.isArray(a) && Array.isArray(l) && function(e1, t) {
                                    if (e1.length !== t.length) return !1;
                                    for(let r = 0; r < e1.length; r++){
                                        const n = e1[r], s = t[r];
                                        if (n.type !== s.type || n.value !== s.value) return !1;
                                    }
                                    return !0;
                                }(a, l)) {
                                    t.getters.push(..."get" === o.kind ? [
                                        o
                                    ] : []), t.setters.push(..."set" === o.kind ? [
                                        o
                                    ] : []), s = !0;
                                    break;
                                }
                            }
                            s || n.push({
                                key: r,
                                getters: "get" === o.kind ? [
                                    o
                                ] : [],
                                setters: "set" === o.kind ? [
                                    o
                                ] : []
                            }), s = !1;
                        }
                    }
                    var a, l;
                    for (const { getters: e1, setters: t } of n)o && t.length && !e1.length && c(t, "missingGetter"), i && e1.length && !t.length && c(e1, "missingSetter");
                }
                const f = {};
                return (o || i) && (f.ObjectExpression = function(e1) {
                    !function(e1) {
                        p(e1.properties.filter((e1)=>"Property" === e1.type));
                    }(e1), function(e1) {
                        if (r(e1, 2, "Object", "defineProperty") || r(e1, 2, "Reflect", "defineProperty")) return !0;
                        const t = e1.parent.parent;
                        return "ObjectExpression" === t.type && (r(t, 1, "Object", "create") || r(t, 1, "Object", "defineProperties"));
                    }(e1) && function(e1) {
                        const t = new Set(e1.properties.filter((e1)=>"Property" === e1.type && "init" === e1.kind && !e1.computed).map(({ key: e1 })=>e1.name)), r = t.has("get"), n = t.has("set");
                        o && n && !r && l(e1, "missingGetter"), i && r && !n && l(e1, "missingSetter");
                    }(e1);
                }, a && (f.ClassBody = function(e1) {
                    const t = e1.body.filter((e1)=>"MethodDefinition" === e1.type);
                    p(t.filter((e1)=>e1.static)), p(t.filter((e1)=>!e1.static));
                })), f;
            }
        }, Gu;
    }
    function Il() {
        if (zu) return Xu;
        zu = 1;
        const e1 = Ll();
        return Xu = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce linebreaks after opening and before closing array brackets",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/array-bracket-newline"
                },
                fixable: "whitespace",
                schema: [
                    {
                        oneOf: [
                            {
                                enum: [
                                    "always",
                                    "never",
                                    "consistent"
                                ]
                            },
                            {
                                type: "object",
                                properties: {
                                    multiline: {
                                        type: "boolean"
                                    },
                                    minItems: {
                                        type: [
                                            "integer",
                                            "null"
                                        ],
                                        minimum: 0
                                    }
                                },
                                additionalProperties: !1
                            }
                        ]
                    }
                ],
                messages: {
                    unexpectedOpeningLinebreak: "There should be no linebreak after '['.",
                    unexpectedClosingLinebreak: "There should be no linebreak before ']'.",
                    missingOpeningLinebreak: "A linebreak is required after '['.",
                    missingClosingLinebreak: "A linebreak is required before ']'."
                }
            },
            create (t) {
                const r = t.sourceCode;
                function n(e1) {
                    const t = function(e1) {
                        let t = !1, r = !1, n = 0;
                        return e1 ? "consistent" === e1 ? (t = !0, n = Number.POSITIVE_INFINITY) : "always" === e1 || 0 === e1.minItems ? n = 0 : "never" === e1 ? n = Number.POSITIVE_INFINITY : (r = Boolean(e1.multiline), n = e1.minItems || Number.POSITIVE_INFINITY) : (t = !1, r = !0, n = Number.POSITIVE_INFINITY), {
                            consistent: t,
                            multiline: r,
                            minItems: n
                        };
                    }(e1);
                    return {
                        ArrayExpression: t,
                        ArrayPattern: t
                    };
                }
                function s(s) {
                    const i = s.elements, o = n(t.options[0])[s.type], a = r.getFirstToken(s), u = r.getLastToken(s), l = r.getTokenAfter(a, {
                        includeComments: !0
                    }), c = r.getTokenBefore(u, {
                        includeComments: !0
                    }), p = r.getTokenAfter(a), f = r.getTokenBefore(u);
                    i.length >= o.minItems || o.multiline && i.length > 0 && l.loc.start.line !== c.loc.end.line || 0 === i.length && "Block" === l.type && l.loc.start.line !== c.loc.end.line && l === c || o.consistent && a.loc.end.line !== p.loc.start.line ? (e1.isTokenOnSameLine(a, p) && function(e1, r) {
                        t.report({
                            node: e1,
                            loc: r.loc,
                            messageId: "missingOpeningLinebreak",
                            fix: (e1)=>e1.insertTextAfter(r, "\n")
                        });
                    }(s, a), e1.isTokenOnSameLine(f, u) && function(e1, r) {
                        t.report({
                            node: e1,
                            loc: r.loc,
                            messageId: "missingClosingLinebreak",
                            fix: (e1)=>e1.insertTextBefore(r, "\n")
                        });
                    }(s, u)) : (e1.isTokenOnSameLine(a, p) || function(n, s) {
                        t.report({
                            node: n,
                            loc: s.loc,
                            messageId: "unexpectedOpeningLinebreak",
                            fix (t) {
                                const n = r.getTokenAfter(s, {
                                    includeComments: !0
                                });
                                return e1.isCommentToken(n) ? null : t.removeRange([
                                    s.range[1],
                                    n.range[0]
                                ]);
                            }
                        });
                    }(s, a), e1.isTokenOnSameLine(f, u) || function(n, s) {
                        t.report({
                            node: n,
                            loc: s.loc,
                            messageId: "unexpectedClosingLinebreak",
                            fix (t) {
                                const n = r.getTokenBefore(s, {
                                    includeComments: !0
                                });
                                return e1.isCommentToken(n) ? null : t.removeRange([
                                    n.range[1],
                                    s.range[0]
                                ]);
                            }
                        });
                    }(s, u));
                }
                return {
                    ArrayPattern: s,
                    ArrayExpression: s
                };
            }
        }, Xu;
    }
    function Fl() {
        if (Ju) return Hu;
        Ju = 1;
        const e1 = Ll();
        return Hu = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent spacing inside array brackets",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/array-bracket-spacing"
                },
                fixable: "whitespace",
                schema: [
                    {
                        enum: [
                            "always",
                            "never"
                        ]
                    },
                    {
                        type: "object",
                        properties: {
                            singleValue: {
                                type: "boolean"
                            },
                            objectsInArrays: {
                                type: "boolean"
                            },
                            arraysInArrays: {
                                type: "boolean"
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unexpectedSpaceAfter: "There should be no space after '{{tokenValue}}'.",
                    unexpectedSpaceBefore: "There should be no space before '{{tokenValue}}'.",
                    missingSpaceAfter: "A space is required after '{{tokenValue}}'.",
                    missingSpaceBefore: "A space is required before '{{tokenValue}}'."
                }
            },
            create (t) {
                const r = "always" === t.options[0], n = t.sourceCode;
                function s(e1) {
                    return !!t.options[1] && t.options[1][e1] === !r;
                }
                const i = {
                    spaced: r,
                    singleElementException: s("singleValue"),
                    objectsInArraysException: s("objectsInArrays"),
                    arraysInArraysException: s("arraysInArrays")
                };
                function o(e1) {
                    return e1 && ("ObjectExpression" === e1.type || "ObjectPattern" === e1.type);
                }
                function a(e1) {
                    return e1 && ("ArrayExpression" === e1.type || "ArrayPattern" === e1.type);
                }
                function u(r) {
                    if (i.spaced && 0 === r.elements.length) return;
                    const s = n.getFirstToken(r), u = n.getFirstToken(r, 1), l = r.typeAnnotation ? n.getTokenBefore(r.typeAnnotation) : n.getLastToken(r), c = n.getTokenBefore(l), p = r.elements[0], f = r.elements[r.elements.length - 1], d = i.objectsInArraysException && o(p) || i.arraysInArraysException && a(p) || i.singleElementException && 1 === r.elements.length ? !i.spaced : i.spaced, h = i.objectsInArraysException && o(f) || i.arraysInArraysException && a(f) || i.singleElementException && 1 === r.elements.length ? !i.spaced : i.spaced;
                    e1.isTokenOnSameLine(s, u) && (d && !n.isSpaceBetweenTokens(s, u) && function(e1, r) {
                        t.report({
                            node: e1,
                            loc: r.loc,
                            messageId: "missingSpaceAfter",
                            data: {
                                tokenValue: r.value
                            },
                            fix: (e1)=>e1.insertTextAfter(r, " ")
                        });
                    }(r, s), !d && n.isSpaceBetweenTokens(s, u) && function(e1, r) {
                        const s = n.getTokenAfter(r);
                        t.report({
                            node: e1,
                            loc: {
                                start: r.loc.end,
                                end: s.loc.start
                            },
                            messageId: "unexpectedSpaceAfter",
                            data: {
                                tokenValue: r.value
                            },
                            fix: (e1)=>e1.removeRange([
                                    r.range[1],
                                    s.range[0]
                                ])
                        });
                    }(r, s)), s !== c && e1.isTokenOnSameLine(c, l) && (h && !n.isSpaceBetweenTokens(c, l) && function(e1, r) {
                        t.report({
                            node: e1,
                            loc: r.loc,
                            messageId: "missingSpaceBefore",
                            data: {
                                tokenValue: r.value
                            },
                            fix: (e1)=>e1.insertTextBefore(r, " ")
                        });
                    }(r, l), !h && n.isSpaceBetweenTokens(c, l) && function(e1, r) {
                        const s = n.getTokenBefore(r);
                        t.report({
                            node: e1,
                            loc: {
                                start: s.loc.end,
                                end: r.loc.start
                            },
                            messageId: "unexpectedSpaceBefore",
                            data: {
                                tokenValue: r.value
                            },
                            fix: (e1)=>e1.removeRange([
                                    s.range[1],
                                    r.range[0]
                                ])
                        });
                    }(r, l));
                }
                return {
                    ArrayPattern: u,
                    ArrayExpression: u
                };
            }
        }, Hu;
    }
    function Nl() {
        if (Yu) return Qu;
        Yu = 1;
        const e1 = Ll(), t = /^(?:Arrow)?FunctionExpression$/u, r = /^(?:every|filter|find(?:Last)?(?:Index)?|flatMap|forEach|map|reduce(?:Right)?|some|sort|toSorted)$/u;
        function n(t) {
            return e1.isSpecificMemberAccess(t, null, r);
        }
        function s(e1) {
            return [
                "from",
                "of",
                "isArray"
            ].includes(e1) ? "Array.".concat(e1) : "Array.prototype.".concat(e1);
        }
        function i(e1) {
            return "UnaryExpression" === e1.type && "void" === e1.operator;
        }
        function o(t, r, n) {
            const s = e1.getPrecedence(r) < e1.getPrecedence({
                type: "UnaryExpression",
                operator: "void"
            }) && !e1.isParenthesised(t, r), i = t.getTokenBefore(r, "ArrowFunctionExpression" === r.parent.type ? e1.isArrowToken : (e1)=>"Keyword" === e1.type && "return" === e1.value), o = t.getTokenAfter(i), a = "return" === i.value && i.range[1] === o.range[0];
            return [
                n.insertTextBefore(o, `${a ? " " : ""}void ${s ? "(" : ""}`),
                n.insertTextAfter(r, s ? ")" : "")
            ];
        }
        function a(t, r, n) {
            const s = t.getTokenBefore(r.body, e1.isArrowToken), i = t.getTokenAfter(s), o = t.getLastToken(r);
            return [
                n.insertTextBefore(i, "{"),
                n.insertTextAfter(o, "}")
            ];
        }
        return Qu = {
            meta: {
                type: "problem",
                docs: {
                    description: "Enforce `return` statements in callbacks of array methods",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/array-callback-return"
                },
                hasSuggestions: !0,
                schema: [
                    {
                        type: "object",
                        properties: {
                            allowImplicit: {
                                type: "boolean",
                                default: !1
                            },
                            checkForEach: {
                                type: "boolean",
                                default: !1
                            },
                            allowVoid: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    expectedAtEnd: "{{arrayMethodName}}() expects a value to be returned at the end of {{name}}.",
                    expectedInside: "{{arrayMethodName}}() expects a return value from {{name}}.",
                    expectedReturnValue: "{{arrayMethodName}}() expects a return value from {{name}}.",
                    expectedNoReturnValue: "{{arrayMethodName}}() expects no useless return value from {{name}}.",
                    wrapBraces: "Wrap the expression in `{}`.",
                    prependVoid: "Prepend `void` to the expression."
                }
            },
            create (r) {
                const u = r.options[0] || {
                    allowImplicit: !1,
                    checkForEach: !1,
                    allowVoid: !1
                }, l = r.sourceCode;
                let c = {
                    arrayMethodName: null,
                    upper: null,
                    codePath: null,
                    hasReturn: !1,
                    shouldCheck: !1,
                    node: null
                };
                function p(t) {
                    if (!c.shouldCheck) return;
                    const n = {
                        messageId: "",
                        suggest: []
                    };
                    if ("forEach" === c.arrayMethodName) {
                        if (u.checkForEach && "ArrowFunctionExpression" === t.type && t.expression) {
                            if (u.allowVoid) {
                                if (i(t.body)) return;
                                n.messageId = "expectedNoReturnValue", n.suggest = [
                                    {
                                        messageId: "wrapBraces",
                                        fix: (e1)=>a(l, t, e1)
                                    },
                                    {
                                        messageId: "prependVoid",
                                        fix: (e1)=>o(l, t.body, e1)
                                    }
                                ];
                            } else n.messageId = "expectedNoReturnValue", n.suggest = [
                                {
                                    messageId: "wrapBraces",
                                    fix: (e1)=>a(l, t, e1)
                                }
                            ];
                        }
                    } else "BlockStatement" === t.body.type && function(e1) {
                        for (const t of e1)if (t.reachable) return !0;
                        return !1;
                    }(c.currentSegments) && (n.messageId = c.hasReturn ? "expectedAtEnd" : "expectedInside");
                    if (n.messageId) {
                        const i = e1.getFunctionNameWithKind(t);
                        r.report({
                            node: t,
                            loc: e1.getFunctionHeadLoc(t, l),
                            messageId: n.messageId,
                            data: {
                                name: i,
                                arrayMethodName: s(c.arrayMethodName)
                            },
                            suggest: 0 !== n.suggest.length ? n.suggest : null
                        });
                    }
                }
                return {
                    onCodePathStart (r, s) {
                        let i = null;
                        t.test(s.type) && (i = function(t) {
                            let r = t;
                            for(; r;){
                                const t = r.parent;
                                switch(t.type){
                                    case "LogicalExpression":
                                    case "ConditionalExpression":
                                    case "ChainExpression":
                                        r = t;
                                        break;
                                    case "ReturnStatement":
                                        {
                                            const n = e1.getUpperFunction(t);
                                            if (null === n || !e1.isCallee(n)) return null;
                                            r = n.parent;
                                            break;
                                        }
                                    case "CallExpression":
                                        return e1.isArrayFromMethod(t.callee) && t.arguments.length >= 2 && t.arguments[1] === r ? "from" : n(t.callee) && t.arguments.length >= 1 && t.arguments[0] === r ? e1.getStaticPropertyName(t.callee) : null;
                                    default:
                                        return null;
                                }
                            }
                            return null;
                        }(s)), c = {
                            arrayMethodName: i,
                            upper: c,
                            codePath: r,
                            hasReturn: !1,
                            shouldCheck: i && !s.async && !s.generator,
                            node: s,
                            currentSegments: new Set
                        };
                    },
                    onCodePathEnd () {
                        c = c.upper;
                    },
                    onUnreachableCodePathSegmentStart (e1) {
                        c.currentSegments.add(e1);
                    },
                    onUnreachableCodePathSegmentEnd (e1) {
                        c.currentSegments.delete(e1);
                    },
                    onCodePathSegmentStart (e1) {
                        c.currentSegments.add(e1);
                    },
                    onCodePathSegmentEnd (e1) {
                        c.currentSegments.delete(e1);
                    },
                    ReturnStatement (t) {
                        if (!c.shouldCheck) return;
                        c.hasReturn = !0;
                        const n = {
                            messageId: "",
                            suggest: []
                        };
                        if ("forEach" === c.arrayMethodName) {
                            if (u.checkForEach && t.argument) {
                                if (u.allowVoid) {
                                    if (i(t.argument)) return;
                                    n.messageId = "expectedNoReturnValue", n.suggest = [
                                        {
                                            messageId: "prependVoid",
                                            fix: (e1)=>o(l, t.argument, e1)
                                        }
                                    ];
                                } else n.messageId = "expectedNoReturnValue";
                            }
                        } else u.allowImplicit || t.argument || (n.messageId = "expectedReturnValue");
                        n.messageId && r.report({
                            node: t,
                            messageId: n.messageId,
                            data: {
                                name: e1.getFunctionNameWithKind(c.node),
                                arrayMethodName: s(c.arrayMethodName)
                            },
                            suggest: 0 !== n.suggest.length ? n.suggest : null
                        });
                    },
                    "FunctionExpression:exit": p,
                    "ArrowFunctionExpression:exit": p
                };
            }
        }, Qu;
    }
    function Ol() {
        if (el) return Zu;
        el = 1;
        const e1 = Ll();
        return Zu = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce line breaks after each array element",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/array-element-newline"
                },
                fixable: "whitespace",
                schema: {
                    definitions: {
                        basicConfig: {
                            oneOf: [
                                {
                                    enum: [
                                        "always",
                                        "never",
                                        "consistent"
                                    ]
                                },
                                {
                                    type: "object",
                                    properties: {
                                        multiline: {
                                            type: "boolean"
                                        },
                                        minItems: {
                                            type: [
                                                "integer",
                                                "null"
                                            ],
                                            minimum: 0
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ]
                        }
                    },
                    type: "array",
                    items: [
                        {
                            oneOf: [
                                {
                                    $ref: "#/definitions/basicConfig"
                                },
                                {
                                    type: "object",
                                    properties: {
                                        ArrayExpression: {
                                            $ref: "#/definitions/basicConfig"
                                        },
                                        ArrayPattern: {
                                            $ref: "#/definitions/basicConfig"
                                        }
                                    },
                                    additionalProperties: !1,
                                    minProperties: 1
                                }
                            ]
                        }
                    ]
                },
                messages: {
                    unexpectedLineBreak: "There should be no linebreak here.",
                    missingLineBreak: "There should be a linebreak after this element."
                }
            },
            create (t) {
                const r = t.sourceCode;
                function n(e1) {
                    let t, r = !1, n = !1;
                    const s = e1 || "always";
                    return s && "always" !== s && 0 !== s.minItems ? "never" === s ? t = Number.POSITIVE_INFINITY : "consistent" === s ? (r = !0, t = Number.POSITIVE_INFINITY) : (n = Boolean(s.multiline), t = s.minItems || Number.POSITIVE_INFINITY) : t = 0, {
                        consistent: r,
                        multiline: n,
                        minItems: t
                    };
                }
                function s(s) {
                    const i = s.elements, o = function(e1) {
                        if (e1 && (e1.ArrayExpression || e1.ArrayPattern)) {
                            let t, r;
                            return e1.ArrayExpression && (t = n(e1.ArrayExpression)), e1.ArrayPattern && (r = n(e1.ArrayPattern)), {
                                ArrayExpression: t,
                                ArrayPattern: r
                            };
                        }
                        const t = n(e1);
                        return {
                            ArrayExpression: t,
                            ArrayPattern: t
                        };
                    }(t.options[0]), a = o[s.type];
                    if (!a) return;
                    let u = !1;
                    a.multiline && (u = i.filter((e1)=>null !== e1).some((e1)=>e1.loc.start.line !== e1.loc.end.line));
                    let l = 0;
                    for(let t = 0; t < s.elements.length; t++){
                        const n = s.elements[t], o = i[t - 1];
                        if (0 === t || null === n || null === o) continue;
                        const a = r.getFirstTokenBetween(o, n, e1.isCommaToken), u = r.getTokenBefore(a), c = r.getTokenAfter(a);
                        e1.isTokenOnSameLine(u, c) || l++;
                    }
                    const c = i.length >= a.minItems || a.multiline && u || a.consistent && l > 0 && l < s.elements.length;
                    i.forEach((n, s)=>{
                        const o = i[s - 1];
                        if (0 === s || null === n || null === o) return;
                        const a = r.getFirstTokenBetween(o, n, e1.isCommaToken), u = r.getTokenBefore(a), l = r.getTokenAfter(a);
                        c ? e1.isTokenOnSameLine(u, l) && function(e1) {
                            const n = r.getTokenBefore(e1, {
                                includeComments: !0
                            });
                            t.report({
                                loc: {
                                    start: n.loc.end,
                                    end: e1.loc.start
                                },
                                messageId: "missingLineBreak",
                                fix: (t)=>t.replaceTextRange([
                                        n.range[1],
                                        e1.range[0]
                                    ], "\n")
                            });
                        }(l) : e1.isTokenOnSameLine(u, l) || function(n) {
                            const s = r.getTokenBefore(n, {
                                includeComments: !0
                            });
                            t.report({
                                loc: {
                                    start: s.loc.end,
                                    end: n.loc.start
                                },
                                messageId: "unexpectedLineBreak",
                                fix (t) {
                                    if (e1.isCommentToken(s)) return null;
                                    if (!e1.isTokenOnSameLine(s, n)) return t.replaceTextRange([
                                        s.range[1],
                                        n.range[0]
                                    ], " ");
                                    const i = r.getTokenBefore(s, {
                                        includeComments: !0
                                    });
                                    return e1.isCommentToken(i) ? null : t.replaceTextRange([
                                        i.range[1],
                                        s.range[0]
                                    ], "");
                                }
                            });
                        }(l);
                    });
                }
                return {
                    ArrayPattern: s,
                    ArrayExpression: s
                };
            }
        }, Zu;
    }
    function Ul() {
        if (rl) return tl;
        rl = 1;
        const e1 = Ll();
        return tl = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require braces around arrow function bodies",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/arrow-body-style"
                },
                schema: {
                    anyOf: [
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "always",
                                        "never"
                                    ]
                                }
                            ],
                            minItems: 0,
                            maxItems: 1
                        },
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "as-needed"
                                    ]
                                },
                                {
                                    type: "object",
                                    properties: {
                                        requireReturnForObjectLiteral: {
                                            type: "boolean"
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            minItems: 0,
                            maxItems: 2
                        }
                    ]
                },
                fixable: "code",
                messages: {
                    unexpectedOtherBlock: "Unexpected block statement surrounding arrow body.",
                    unexpectedEmptyBlock: "Unexpected block statement surrounding arrow body; put a value of `undefined` immediately after the `=>`.",
                    unexpectedObjectBlock: "Unexpected block statement surrounding arrow body; parenthesize the returned value and move it immediately after the `=>`.",
                    unexpectedSingleBlock: "Unexpected block statement surrounding arrow body; move the returned value immediately after the `=>`.",
                    expectedBlock: "Expected block statement surrounding arrow body."
                }
            },
            create (t) {
                const r = t.options, n = "always" === r[0], s = !r[0] || "as-needed" === r[0], i = "never" === r[0], o = r[1] && r[1].requireReturnForObjectLiteral, a = t.sourceCode;
                let u = null;
                function l(e1) {
                    return !(!e1 || !e1.parent) && ("ForStatement" === e1.parent.type && e1.parent.init === e1 || l(e1.parent));
                }
                function c(r) {
                    const c = r.body;
                    if ("BlockStatement" === c.type) {
                        const n = c.body;
                        if (1 !== n.length && !i) return;
                        if (s && o && "ReturnStatement" === n[0].type && n[0].argument && "ObjectExpression" === n[0].argument.type) return;
                        if (i || s && "ReturnStatement" === n[0].type) {
                            let s;
                            s = 0 === n.length ? "unexpectedEmptyBlock" : n.length > 1 ? "unexpectedOtherBlock" : null === n[0].argument ? "unexpectedSingleBlock" : e1.isOpeningBraceToken(a.getFirstToken(n[0], {
                                skip: 1
                            })) ? "unexpectedObjectBlock" : "unexpectedSingleBlock", t.report({
                                node: r,
                                loc: c.loc,
                                messageId: s,
                                fix (t) {
                                    const s = [];
                                    if (1 !== n.length || "ReturnStatement" !== n[0].type || !n[0].argument || (i = a.getTokenAfter(c)) && "Punctuator" === i.type && /^[([/`+-]/u.test(i.value)) return s;
                                    var i;
                                    const o = a.getFirstToken(c), p = a.getLastToken(c), f = a.getFirstToken(n[0], 1), d = a.getLastToken(n[0]);
                                    return a.commentsExistBetween(o, f) || a.commentsExistBetween(d, p) ? s.push(t.remove(o), t.remove(p), t.remove(a.getTokenAfter(o))) : s.push(t.removeRange([
                                        o.range[0],
                                        f.range[0]
                                    ]), t.removeRange([
                                        d.range[1],
                                        p.range[1]
                                    ])), (e1.isOpeningBraceToken(f) || "SequenceExpression" === n[0].argument.type || u.hasInOperator && l(r)) && (e1.isParenthesised(a, n[0].argument) || s.push(t.insertTextBefore(f, "("), t.insertTextAfter(d, ")"))), e1.isSemicolonToken(d) && s.push(t.remove(d)), s;
                                }
                            });
                        }
                    } else (n || s && o && "ObjectExpression" === c.type) && t.report({
                        node: r,
                        loc: c.loc,
                        messageId: "expectedBlock",
                        fix (t) {
                            const n = [], s = a.getTokenBefore(c, e1.isArrowToken), [i, o] = a.getTokensAfter(s, {
                                count: 2
                            }), u = a.getLastToken(r);
                            let l = null;
                            if (e1.isOpeningParenToken(i) && e1.isOpeningBraceToken(o)) {
                                const e1 = a.getNodeByRangeIndex(o.range[0]);
                                "ObjectExpression" === e1.type && (l = e1);
                            }
                            if (l) {
                                const r = i, s = o;
                                e1.isTokenOnSameLine(r, s) ? n.push(t.replaceText(r, "{return ")) : n.push(t.replaceText(r, "{"), t.insertTextBefore(s, "return ")), n.push(t.remove(function(t) {
                                    let r = t;
                                    for(; !e1.isParenthesised(a, r);)r = r.parent;
                                    return a.getTokenAfter(r);
                                }(l))), n.push(t.insertTextAfter(u, "}"));
                            } else n.push(t.insertTextBefore(i, "{return ")), n.push(t.insertTextAfter(u, "}"));
                            return n;
                        }
                    });
                }
                return {
                    "BinaryExpression[operator='in']" () {
                        let e1 = u;
                        for(; e1;)e1.hasInOperator = !0, e1 = e1.upper;
                    },
                    ArrowFunctionExpression () {
                        u = {
                            upper: u,
                            hasInOperator: !1
                        };
                    },
                    "ArrowFunctionExpression:exit" (e1) {
                        c(e1), u = u.upper;
                    }
                };
            }
        }, tl;
    }
    function jl() {
        if (sl) return nl;
        sl = 1;
        const e1 = Ll();
        return nl = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Require parentheses around arrow function arguments",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/arrow-parens"
                },
                fixable: "code",
                schema: [
                    {
                        enum: [
                            "always",
                            "as-needed"
                        ]
                    },
                    {
                        type: "object",
                        properties: {
                            requireForBlockBody: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unexpectedParens: "Unexpected parentheses around single function argument.",
                    expectedParens: "Expected parentheses around arrow function argument.",
                    unexpectedParensInline: "Unexpected parentheses around single function argument having a body with no curly braces.",
                    expectedParensBlock: "Expected parentheses around arrow function argument having a body with curly braces."
                }
            },
            create (t) {
                const r = "as-needed" === t.options[0], n = r && t.options[1] && !0 === t.options[1].requireForBlockBody, s = t.sourceCode;
                function i(t) {
                    return s.getTokenAfter(t.params[0], e1.isClosingParenToken);
                }
                return {
                    "ArrowFunctionExpression[params.length=1]" (o) {
                        const a = !r || n && function(e1) {
                            return "BlockStatement" === e1.body.type;
                        }(o), u = function(t) {
                            const r = s.getTokenBefore(t.params[0]);
                            return r && e1.isOpeningParenToken(r) && t.range[0] <= r.range[0] ? r : null;
                        }(o), l = null !== u, [c] = o.params;
                        a && !l && t.report({
                            node: o,
                            messageId: n ? "expectedParensBlock" : "expectedParens",
                            loc: c.loc,
                            *fix (e1) {
                                yield e1.insertTextBefore(c, "("), yield e1.insertTextAfter(c, ")");
                            }
                        }), a || !l || "Identifier" !== c.type || c.typeAnnotation || o.returnType || function(e1, t) {
                            return s.commentsExistBetween(t, i(e1));
                        }(o, u) || function(e1, t) {
                            const r = e1.async ? 1 : 0;
                            return s.getFirstToken(e1, {
                                skip: r
                            }) !== t;
                        }(o, u) || t.report({
                            node: o,
                            messageId: n ? "unexpectedParensInline" : "unexpectedParens",
                            loc: c.loc,
                            *fix (t) {
                                const r = s.getTokenBefore(u), n = i(o);
                                r && r.range[1] === u.range[0] && !e1.canTokensBeAdjacent(r, s.getFirstToken(c)) && (yield t.insertTextBefore(u, " ")), yield t.removeRange([
                                    u.range[0],
                                    c.range[0]
                                ]), yield t.removeRange([
                                    c.range[1],
                                    n.range[1]
                                ]);
                            }
                        });
                    }
                };
            }
        }, nl;
    }
    function Vl() {
        if (ol) return il;
        ol = 1;
        const e1 = Ll();
        return il = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent spacing before and after the arrow in arrow functions",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/arrow-spacing"
                },
                fixable: "whitespace",
                schema: [
                    {
                        type: "object",
                        properties: {
                            before: {
                                type: "boolean",
                                default: !0
                            },
                            after: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    expectedBefore: "Missing space before =>.",
                    unexpectedBefore: "Unexpected space before =>.",
                    expectedAfter: "Missing space after =>.",
                    unexpectedAfter: "Unexpected space after =>."
                }
            },
            create (t) {
                const r = Object.assign({}, t.options[0]);
                r.before = !1 !== r.before, r.after = !1 !== r.after;
                const n = t.sourceCode;
                return {
                    ArrowFunctionExpression: function(s) {
                        const i = function(t) {
                            const r = n.getTokenBefore(t.body, e1.isArrowToken);
                            return {
                                before: n.getTokenBefore(r),
                                arrow: r,
                                after: n.getTokenAfter(r)
                            };
                        }(s), o = function(e1) {
                            return {
                                before: e1.arrow.range[0] - e1.before.range[1],
                                after: e1.after.range[0] - e1.arrow.range[1]
                            };
                        }(i);
                        r.before ? 0 === o.before && t.report({
                            node: i.before,
                            messageId: "expectedBefore",
                            fix: (e1)=>e1.insertTextBefore(i.arrow, " ")
                        }) : o.before > 0 && t.report({
                            node: i.before,
                            messageId: "unexpectedBefore",
                            fix: (e1)=>e1.removeRange([
                                    i.before.range[1],
                                    i.arrow.range[0]
                                ])
                        }), r.after ? 0 === o.after && t.report({
                            node: i.after,
                            messageId: "expectedAfter",
                            fix: (e1)=>e1.insertTextAfter(i.arrow, " ")
                        }) : o.after > 0 && t.report({
                            node: i.after,
                            messageId: "unexpectedAfter",
                            fix: (e1)=>e1.removeRange([
                                    i.arrow.range[1],
                                    i.after.range[0]
                                ])
                        });
                    }
                };
            }
        }, il;
    }
    function Kl() {
        if (cl) return ll;
        cl = 1;
        const e1 = Ll();
        return ll = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Disallow or enforce spaces inside of blocks after opening block and before closing block",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/block-spacing"
                },
                fixable: "whitespace",
                schema: [
                    {
                        enum: [
                            "always",
                            "never"
                        ]
                    }
                ],
                messages: {
                    missing: "Requires a space {{location}} '{{token}}'.",
                    extra: "Unexpected space(s) {{location}} '{{token}}'."
                }
            },
            create (t) {
                const r = "never" !== t.options[0], n = r ? "missing" : "extra", s = t.sourceCode;
                function i(t, n) {
                    return !e1.isTokenOnSameLine(t, n) || s.isSpaceBetweenTokens(t, n) === r;
                }
                function o(e1) {
                    const o = function(e1) {
                        return "SwitchStatement" === e1.type ? e1.cases.length > 0 ? s.getTokenBefore(e1.cases[0]) : s.getLastToken(e1, 1) : "StaticBlock" === e1.type ? s.getFirstToken(e1, {
                            skip: 1
                        }) : s.getFirstToken(e1);
                    }(e1), a = s.getLastToken(e1), u = s.getTokenAfter(o, {
                        includeComments: !0
                    }), l = s.getTokenBefore(a, {
                        includeComments: !0
                    });
                    if ("Punctuator" === o.type && "{" === o.value && "Punctuator" === a.type && "}" === a.value && u !== a && (r || "Line" !== u.type)) {
                        if (!i(o, u)) {
                            let s = o.loc;
                            "extra" === n && (s = {
                                start: o.loc.end,
                                end: u.loc.start
                            }), t.report({
                                node: e1,
                                loc: s,
                                messageId: n,
                                data: {
                                    location: "after",
                                    token: o.value
                                },
                                fix: (e1)=>r ? e1.insertTextBefore(u, " ") : e1.removeRange([
                                        o.range[1],
                                        u.range[0]
                                    ])
                            });
                        }
                        if (!i(l, a)) {
                            let s = a.loc;
                            "extra" === n && (s = {
                                start: l.loc.end,
                                end: a.loc.start
                            }), t.report({
                                node: e1,
                                loc: s,
                                messageId: n,
                                data: {
                                    location: "before",
                                    token: a.value
                                },
                                fix: (e1)=>r ? e1.insertTextAfter(l, " ") : e1.removeRange([
                                        l.range[1],
                                        a.range[0]
                                    ])
                            });
                        }
                    }
                }
                return {
                    BlockStatement: o,
                    StaticBlock: o,
                    SwitchStatement: o
                };
            }
        }, ll;
    }
    function Ml() {
        return hl || (hl = 1, dl = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "suggestion",
                docs: {
                    description: "Require `return` statements after callbacks",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/callback-return"
                },
                schema: [
                    {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    }
                ],
                messages: {
                    missingReturn: "Expected return with your callback function."
                }
            },
            create (e1) {
                const t = e1.options[0] || [
                    "callback",
                    "cb",
                    "next"
                ], r = e1.sourceCode;
                function n(e1, t) {
                    return e1.parent ? t.includes(e1.parent.type) ? e1.parent : n(e1.parent, t) : null;
                }
                function s(e1) {
                    if ("Identifier" === e1.type) return !0;
                    if ("MemberExpression" === e1.type) {
                        if ("Identifier" === e1.object.type) return !0;
                        if ("MemberExpression" === e1.object.type) return s(e1.object);
                    }
                    return !1;
                }
                function i(e1) {
                    return s(e1.callee) && t.includes(r.getText(e1.callee));
                }
                function o(e1, t) {
                    return !(!t || "ExpressionStatement" !== t.type) && (t.expression === e1 || ("BinaryExpression" === t.expression.type || "LogicalExpression" === t.expression.type) && t.expression.right === e1);
                }
                return {
                    CallExpression (t) {
                        if (!i(t)) return;
                        const r = n(t, [
                            "BlockStatement",
                            "ReturnStatement",
                            "ArrowFunctionExpression"
                        ]) || {};
                        if ("ReturnStatement" !== r.type && "ArrowFunctionExpression" !== r.type) {
                            if ("BlockStatement" === r.type) {
                                const e1 = r.body[r.body.length - 1];
                                if (o(t, e1)) {
                                    const e1 = r.parent.type;
                                    if ("FunctionExpression" === e1 || "FunctionDeclaration" === e1 || "ArrowFunctionExpression" === e1) return;
                                }
                                if ("ReturnStatement" === e1.type && o(t, r.body[r.body.length - 2])) return;
                            }
                            n(t, [
                                "FunctionDeclaration",
                                "FunctionExpression",
                                "ArrowFunctionExpression"
                            ]) && e1.report({
                                node: t,
                                messageId: "missingReturn"
                            });
                        }
                    }
                };
            }
        }), dl;
    }
    function $l() {
        if (gl) return ml;
        gl = 1;
        const e1 = Ll();
        return ml = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Enforce camelcase naming convention",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/camelcase"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            ignoreDestructuring: {
                                type: "boolean",
                                default: !1
                            },
                            ignoreImports: {
                                type: "boolean",
                                default: !1
                            },
                            ignoreGlobals: {
                                type: "boolean",
                                default: !1
                            },
                            properties: {
                                enum: [
                                    "always",
                                    "never"
                                ]
                            },
                            allow: {
                                type: "array",
                                items: [
                                    {
                                        type: "string"
                                    }
                                ],
                                minItems: 0,
                                uniqueItems: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    notCamelCase: "Identifier '{{name}}' is not in camel case.",
                    notCamelCasePrivate: "#{{name}} is not in camel case."
                }
            },
            create (t) {
                const r = t.options[0] || {}, n = "never" === r.properties ? "never" : "always", s = r.ignoreDestructuring, i = r.ignoreImports, o = r.ignoreGlobals, a = r.allow || [], u = t.sourceCode, l = new Set;
                function c(e1) {
                    return !function(e1) {
                        const t = e1.replace(/^_+|_+$/gu, "");
                        return t.includes("_") && t !== t.toUpperCase();
                    }(e1) || function(e1) {
                        return a.some((t)=>e1 === t || e1.match(new RegExp(t, "u")));
                    }(e1);
                }
                function p(t) {
                    const r = t.name, n = "AssignmentPattern" === t.parent.type ? t.parent : t, s = n.parent;
                    switch(s.type){
                        case "Property":
                            return ("ObjectPattern" === s.parent.type || "ObjectExpression" === s.parent.type) && s.value === n && !s.computed && "Identifier" === s.key.type && s.key.name === r;
                        case "ImportSpecifier":
                            return s.local === t && e1.getModuleExportName(s.imported) === r;
                        default:
                            return !1;
                    }
                }
                function f(e1) {
                    l.has(e1.range[0]) || (l.add(e1.range[0]), t.report({
                        node: e1,
                        messageId: "PrivateIdentifier" === e1.type ? "notCamelCasePrivate" : "notCamelCase",
                        data: {
                            name: e1.name
                        }
                    }));
                }
                function d(e1) {
                    "CallExpression" !== e1.parent.type && "NewExpression" !== e1.parent.type && ("AssignmentPattern" === e1.parent.type && e1.parent.right === e1 || s && p(e1) || f(e1));
                }
                return {
                    Program (e1) {
                        const t = u.getScope(e1);
                        if (!o) {
                            for (const e1 of t.variables)if (!(e1.identifiers.length > 0 || c(e1.name))) for (const t of e1.references)d(t.identifier);
                        }
                        for (const e1 of t.through){
                            const t = e1.identifier;
                            c(t.name) || d(t);
                        }
                    },
                    [[
                        "VariableDeclaration",
                        "FunctionDeclaration",
                        "FunctionExpression",
                        "ArrowFunctionExpression",
                        "ClassDeclaration",
                        "ClassExpression",
                        "CatchClause"
                    ]] (e1) {
                        for (const t of u.getDeclaredVariables(e1)){
                            if (c(t.name)) continue;
                            const e1 = t.identifiers[0];
                            s && p(e1) || f(e1);
                            for (const e1 of t.references)e1.init || d(e1.identifier);
                        }
                    },
                    [[
                        "ObjectExpression > Property[computed!=true] > Identifier.key",
                        "MethodDefinition[computed!=true] > Identifier.key",
                        "PropertyDefinition[computed!=true] > Identifier.key",
                        "MethodDefinition > PrivateIdentifier.key",
                        "PropertyDefinition > PrivateIdentifier.key"
                    ]] (e1) {
                        "never" === n || c(e1.name) || f(e1);
                    },
                    "MemberExpression[computed!=true] > Identifier.property" (e1) {
                        "never" !== n && function(e1) {
                            const t = e1.parent;
                            switch(t.type){
                                case "AssignmentExpression":
                                case "AssignmentPattern":
                                    return t.left === e1;
                                case "Property":
                                    return "ObjectPattern" === t.parent.type && t.value === e1;
                                case "ArrayPattern":
                                case "RestElement":
                                    return !0;
                                default:
                                    return !1;
                            }
                        }(e1.parent) && !c(e1.name) && f(e1);
                    },
                    ImportDeclaration (e1) {
                        for (const t of u.getDeclaredVariables(e1)){
                            if (c(t.name)) continue;
                            const e1 = t.identifiers[0];
                            i && p(e1) || f(e1);
                            for (const e1 of t.references)d(e1.identifier);
                        }
                    },
                    [[
                        "ExportAllDeclaration > Identifier.exported",
                        "ExportSpecifier > Identifier.exported"
                    ]] (e1) {
                        c(e1.name) || f(e1);
                    },
                    [[
                        "LabeledStatement > Identifier.label",
                        "BreakStatement > Identifier.label",
                        "ContinueStatement > Identifier.label"
                    ]] (e1) {
                        c(e1.name) || f(e1);
                    }
                };
            }
        }, ml;
    }
    /**
	 * @fileoverview Pattern for detecting any letter (even letters outside of ASCII).
	 * NOTE: This file was generated using this script in JSCS based on the Unicode 7.0.0 standard: https://github.com/jscs-dev/node-jscs/blob/f5ed14427deb7e7aac84f3056a5aab2d9f3e563e/publish/helpers/generate-patterns.js
	 * Do not edit this file by hand-- please use https://github.com/mathiasbynens/regenerate to regenerate the regular expression exported from this file.
	 * @author Kevin Partington
	 * @license MIT License (from JSCS). See below.
	 */ function ql() {
        if (Cl) return xl;
        Cl = 1;
        const e1 = El ? yl : (El = 1, yl = /[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B2\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDE00-\uDE11\uDE13-\uDE2B\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF5D-\uDF61]|\uD805[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDE00-\uDE2F\uDE44\uDE80-\uDEAA]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF98]|[\uD80C\uD840-\uD868\uD86A-\uD86C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D]|\uD87E[\uDC00-\uDE1D]/u), t = Ll().COMMENTS_IGNORE_PATTERN, r = /\s/gu, n = /^\s*[^:/?#\s]+:\/\/[^?#]/u, s = {
            type: "object",
            properties: {
                ignorePattern: {
                    type: "string"
                },
                ignoreInlineComments: {
                    type: "boolean"
                },
                ignoreConsecutiveComments: {
                    type: "boolean"
                }
            },
            additionalProperties: !1
        }, i = {
            ignorePattern: "",
            ignoreInlineComments: !1,
            ignoreConsecutiveComments: !1
        };
        function o(e1, t) {
            return Object.assign({}, i, e1[t] || e1);
        }
        return xl = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Enforce or disallow capitalization of the first letter of a comment",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/capitalized-comments"
                },
                fixable: "code",
                schema: [
                    {
                        enum: [
                            "always",
                            "never"
                        ]
                    },
                    {
                        oneOf: [
                            s,
                            {
                                type: "object",
                                properties: {
                                    line: s,
                                    block: s
                                },
                                additionalProperties: !1
                            }
                        ]
                    }
                ],
                messages: {
                    unexpectedLowercaseComment: "Comments should not begin with a lowercase character.",
                    unexpectedUppercaseComment: "Comments should not begin with an uppercase character."
                }
            },
            create (s) {
                const i = s.options[0] || "always", a = function(e1 = {}) {
                    return {
                        Line: o(e1, "line"),
                        Block: o(e1, "block")
                    };
                }(s.options[1]), u = s.sourceCode;
                function l(s, o) {
                    if (t.test(s.value)) return !0;
                    const a = s.value.replace(/\*/gu, "");
                    if (o.ignorePatternRegExp && o.ignorePatternRegExp.test(a)) return !0;
                    if (o.ignoreInlineComments && function(e1) {
                        const t = u.getTokenBefore(e1, {
                            includeComments: !0
                        }), r = u.getTokenAfter(e1, {
                            includeComments: !0
                        });
                        return Boolean(t && r && e1.loc.start.line === t.loc.end.line && e1.loc.end.line === r.loc.start.line);
                    }(s)) return !0;
                    if (o.ignoreConsecutiveComments && function(e1) {
                        const t = u.getTokenBefore(e1, {
                            includeComments: !0
                        });
                        return Boolean(t && [
                            "Block",
                            "Line"
                        ].includes(t.type));
                    }(s)) return !0;
                    if (n.test(a)) return !0;
                    const l = a.replace(r, "");
                    if (0 === l.length) return !0;
                    const c = l[0];
                    if (!e1.test(c)) return !0;
                    const p = c !== c.toLocaleLowerCase(), f = c !== c.toLocaleUpperCase();
                    return ("always" !== i || !f) && ("never" !== i || !p);
                }
                function c(t) {
                    const r = a[t.type];
                    if (!l(t, r)) {
                        const r = "always" === i ? "unexpectedLowercaseComment" : "unexpectedUppercaseComment";
                        s.report({
                            node: null,
                            loc: t.loc,
                            messageId: r,
                            fix (r) {
                                const n = t.value.match(e1);
                                return r.replaceTextRange([
                                    t.range[0] + n.index + 2,
                                    t.range[0] + n.index + 3
                                ], "always" === i ? n[0].toLocaleUpperCase() : n[0].toLocaleLowerCase());
                            }
                        });
                    }
                }
                return function(e1) {
                    Object.keys(e1).forEach((t)=>{
                        const r = e1[t].ignorePattern;
                        if (r) {
                            const n = RegExp(`^\\s*(?:${r})`, "u");
                            e1[t].ignorePatternRegExp = n;
                        }
                    });
                }(a), {
                    Program () {
                        u.getAllComments().filter((e1)=>"Shebang" !== e1.type).forEach(c);
                    }
                };
            }
        }, xl;
    }
    function Gl() {
        if (bl) return Sl;
        bl = 1;
        const e1 = Ll();
        return Sl = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Enforce that class methods utilize `this`",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/class-methods-use-this"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            exceptMethods: {
                                type: "array",
                                items: {
                                    type: "string"
                                }
                            },
                            enforceForClassFields: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    missingThis: "Expected 'this' to be used by class {{name}}."
                }
            },
            create (t) {
                const r = Object.assign({}, t.options[0]), n = !1 !== r.enforceForClassFields, s = new Set(r.exceptMethods || []), i = [];
                function o() {
                    i.push(!1);
                }
                function a() {
                    return i.pop();
                }
                function u() {
                    o();
                }
                function l(t) {
                    if (function(e1) {
                        switch(e1.type){
                            case "MethodDefinition":
                                return !e1.static && "constructor" !== e1.kind;
                            case "PropertyDefinition":
                                return !e1.static && n;
                            default:
                                return !1;
                        }
                    }(t)) {
                        if (t.computed) return !0;
                        const r = "PrivateIdentifier" === t.key.type ? "#" : "", n = "Literal" === t.key.type ? e1.getStaticStringValue(t.key) : t.key.name || "";
                        return !s.has(r + n);
                    }
                    return !1;
                }
                function c(r) {
                    const n = a();
                    l(r.parent) && !n && t.report({
                        node: r,
                        loc: e1.getFunctionHeadLoc(r, t.sourceCode),
                        messageId: "missingThis",
                        data: {
                            name: e1.getFunctionNameWithKind(r)
                        }
                    });
                }
                function p() {
                    i.length && (i[i.length - 1] = !0);
                }
                return {
                    FunctionDeclaration: u,
                    "FunctionDeclaration:exit": c,
                    FunctionExpression: u,
                    "FunctionExpression:exit": c,
                    "PropertyDefinition > *.key:exit": o,
                    "PropertyDefinition:exit": a,
                    StaticBlock: o,
                    "StaticBlock:exit": a,
                    ThisExpression: p,
                    Super: p,
                    ...n && {
                        "PropertyDefinition > ArrowFunctionExpression.value": u,
                        "PropertyDefinition > ArrowFunctionExpression.value:exit": c
                    }
                };
            }
        }, Sl;
    }
    function Wl() {
        if (Al) return vl;
        Al = 1;
        const e1 = Ll(), t = Object.freeze({
            arrays: "never",
            objects: "never",
            imports: "never",
            exports: "never",
            functions: "never"
        });
        return vl = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Require or disallow trailing commas",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/comma-dangle"
                },
                fixable: "code",
                schema: {
                    definitions: {
                        value: {
                            enum: [
                                "always-multiline",
                                "always",
                                "never",
                                "only-multiline"
                            ]
                        },
                        valueWithIgnore: {
                            enum: [
                                "always-multiline",
                                "always",
                                "ignore",
                                "never",
                                "only-multiline"
                            ]
                        }
                    },
                    type: "array",
                    items: [
                        {
                            oneOf: [
                                {
                                    $ref: "#/definitions/value"
                                },
                                {
                                    type: "object",
                                    properties: {
                                        arrays: {
                                            $ref: "#/definitions/valueWithIgnore"
                                        },
                                        objects: {
                                            $ref: "#/definitions/valueWithIgnore"
                                        },
                                        imports: {
                                            $ref: "#/definitions/valueWithIgnore"
                                        },
                                        exports: {
                                            $ref: "#/definitions/valueWithIgnore"
                                        },
                                        functions: {
                                            $ref: "#/definitions/valueWithIgnore"
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ]
                        }
                    ],
                    additionalItems: !1
                },
                messages: {
                    unexpected: "Unexpected trailing comma.",
                    missing: "Missing trailing comma."
                }
            },
            create (r) {
                const n = (s = r.options[0], i = r.languageOptions.ecmaVersion, "string" == typeof s ? {
                    arrays: s,
                    objects: s,
                    imports: s,
                    exports: s,
                    functions: i < 2017 ? "ignore" : s
                } : "object" == typeof s && null !== s ? {
                    arrays: s.arrays || t.arrays,
                    objects: s.objects || t.objects,
                    imports: s.imports || t.imports,
                    exports: s.exports || t.exports,
                    functions: s.functions || t.functions
                } : t);
                var s, i;
                const o = r.sourceCode;
                function a(e1) {
                    function t(e1) {
                        return e1[e1.length - 1];
                    }
                    switch(e1.type){
                        case "ObjectExpression":
                        case "ObjectPattern":
                            return t(e1.properties);
                        case "ArrayExpression":
                        case "ArrayPattern":
                            return t(e1.elements);
                        case "ImportDeclaration":
                        case "ExportNamedDeclaration":
                            return t(e1.specifiers);
                        case "FunctionDeclaration":
                        case "FunctionExpression":
                        case "ArrowFunctionExpression":
                            return t(e1.params);
                        case "CallExpression":
                        case "NewExpression":
                            return t(e1.arguments);
                        default:
                            return null;
                    }
                }
                function u(t, r) {
                    switch(t.type){
                        case "ObjectExpression":
                        case "ArrayExpression":
                        case "CallExpression":
                        case "NewExpression":
                            return o.getLastToken(t, 1);
                        default:
                            {
                                const t = o.getTokenAfter(r);
                                return e1.isCommaToken(t) ? t : o.getLastToken(r);
                            }
                    }
                }
                function l(e1) {
                    const t = a(e1);
                    if (!t) return !1;
                    const r = u(e1, t);
                    return o.getTokenAfter(r).loc.end.line !== r.loc.end.line;
                }
                function c(t) {
                    const n = a(t);
                    if (!n || "ImportDeclaration" === t.type && "ImportSpecifier" !== n.type) return;
                    const s = u(t, n);
                    e1.isCommaToken(s) && r.report({
                        node: n,
                        loc: s.loc,
                        messageId: "unexpected",
                        *fix (e1) {
                            yield e1.remove(s), yield e1.insertTextBefore(o.getTokenBefore(s), ""), yield e1.insertTextAfter(o.getTokenAfter(s), "");
                        }
                    });
                }
                function p(t) {
                    const n = a(t);
                    if (!n || "ImportDeclaration" === t.type && "ImportSpecifier" !== n.type) return;
                    if (!function(e1) {
                        return !("RestElement" === e1.type || "RestProperty" === e1.type || "ExperimentalRestProperty" === e1.type);
                    }(n)) return void c(t);
                    const s = u(t, n);
                    "," !== s.value && r.report({
                        node: n,
                        loc: {
                            start: s.loc.end,
                            end: e1.getNextLocation(o, s.loc.end)
                        },
                        messageId: "missing",
                        *fix (e1) {
                            yield e1.insertTextAfter(s, ","), yield e1.insertTextBefore(s, ""), yield e1.insertTextAfter(o.getTokenAfter(s), "");
                        }
                    });
                }
                const f = {
                    always: p,
                    "always-multiline": function(e1) {
                        l(e1) ? p(e1) : c(e1);
                    },
                    "only-multiline": function(e1) {
                        l(e1) || c(e1);
                    },
                    never: c,
                    ignore () {}
                };
                return {
                    ObjectExpression: f[n.objects],
                    ObjectPattern: f[n.objects],
                    ArrayExpression: f[n.arrays],
                    ArrayPattern: f[n.arrays],
                    ImportDeclaration: f[n.imports],
                    ExportNamedDeclaration: f[n.exports],
                    FunctionDeclaration: f[n.functions],
                    FunctionExpression: f[n.functions],
                    ArrowFunctionExpression: f[n.functions],
                    CallExpression: f[n.functions],
                    NewExpression: f[n.functions]
                };
            }
        }, vl;
    }
    function Xl() {
        if (wl) return Dl;
        wl = 1;
        const e1 = Ll();
        return Dl = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent comma style",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/comma-style"
                },
                fixable: "code",
                schema: [
                    {
                        enum: [
                            "first",
                            "last"
                        ]
                    },
                    {
                        type: "object",
                        properties: {
                            exceptions: {
                                type: "object",
                                additionalProperties: {
                                    type: "boolean"
                                }
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unexpectedLineBeforeAndAfterComma: "Bad line breaking before and after ','.",
                    expectedCommaFirst: "',' should be placed first.",
                    expectedCommaLast: "',' should be placed last."
                }
            },
            create (t) {
                const r = t.options[0] || "last", n = t.sourceCode, s = {
                    ArrayPattern: !0,
                    ArrowFunctionExpression: !0,
                    CallExpression: !0,
                    FunctionDeclaration: !0,
                    FunctionExpression: !0,
                    ImportDeclaration: !0,
                    ObjectPattern: !0,
                    NewExpression: !0
                };
                if (2 === t.options.length && Object.prototype.hasOwnProperty.call(t.options[1], "exceptions")) {
                    const e1 = Object.keys(t.options[1].exceptions);
                    for(let r = 0; r < e1.length; r++)s[e1[r]] = t.options[1].exceptions[e1[r]];
                }
                function i(t, r, s, i) {
                    const o = n.text.slice(r.range[1], s.range[0]) + n.text.slice(s.range[1], i.range[0]), a = [
                        r.range[1],
                        i.range[0]
                    ];
                    return function(r) {
                        return r.replaceTextRange(a, function(t, r) {
                            switch(t){
                                case "between":
                                    return `,${r.replace(e1.LINEBREAK_MATCHER, "")}`;
                                case "first":
                                    return `${r},`;
                                case "last":
                                    return `,${r}`;
                                default:
                                    return "";
                            }
                        }(t, o));
                    };
                }
                function o(s, o, a, u) {
                    if (e1.isTokenOnSameLine(o, a) && e1.isTokenOnSameLine(s, o)) ;
                    else if (e1.isTokenOnSameLine(o, a) || e1.isTokenOnSameLine(s, o)) "first" !== r || e1.isTokenOnSameLine(o, a) ? "last" === r && e1.isTokenOnSameLine(o, a) && t.report({
                        node: u,
                        loc: o.loc,
                        messageId: "expectedCommaLast",
                        fix: i(r, s, o, a)
                    }) : t.report({
                        node: u,
                        loc: o.loc,
                        messageId: "expectedCommaFirst",
                        fix: i(r, s, o, a)
                    });
                    else {
                        const l = n.getCommentsAfter(o)[0], c = l && "Block" === l.type && e1.isTokenOnSameLine(o, l) ? r : "between";
                        t.report({
                            node: u,
                            loc: o.loc,
                            messageId: "unexpectedLineBeforeAndAfterComma",
                            fix: i(c, s, o, a)
                        });
                    }
                }
                function a(t, r) {
                    const s = t[r], i = "ArrayExpression" === t.type || "ArrayPattern" === t.type;
                    if (s.length > 1 || i) {
                        let r = n.getFirstToken(t);
                        if (s.forEach((t)=>{
                            const s = t ? n.getTokenBefore(t) : r, i = t ? n.getFirstToken(t) : n.getTokenAfter(s), a = t || i;
                            if (e1.isCommaToken(s) && o(r, s, i, a), t) {
                                const s = n.getTokenAfter(t, e1.isNotClosingParenToken);
                                r = s ? n.getTokenBefore(s) : n.ast.tokens[n.ast.tokens.length - 1];
                            } else r = i;
                        }), i) {
                            const r = n.getLastToken(t), s = n.getTokenBefore(r);
                            e1.isCommaToken(s) && o(n.getTokenBefore(s), s, r, r);
                        }
                    }
                }
                const u = {};
                return s.VariableDeclaration || (u.VariableDeclaration = function(e1) {
                    a(e1, "declarations");
                }), s.ObjectExpression || (u.ObjectExpression = function(e1) {
                    a(e1, "properties");
                }), s.ObjectPattern || (u.ObjectPattern = function(e1) {
                    a(e1, "properties");
                }), s.ArrayExpression || (u.ArrayExpression = function(e1) {
                    a(e1, "elements");
                }), s.ArrayPattern || (u.ArrayPattern = function(e1) {
                    a(e1, "elements");
                }), s.FunctionDeclaration || (u.FunctionDeclaration = function(e1) {
                    a(e1, "params");
                }), s.FunctionExpression || (u.FunctionExpression = function(e1) {
                    a(e1, "params");
                }), s.ArrowFunctionExpression || (u.ArrowFunctionExpression = function(e1) {
                    a(e1, "params");
                }), s.CallExpression || (u.CallExpression = function(e1) {
                    a(e1, "arguments");
                }), s.ImportDeclaration || (u.ImportDeclaration = function(e1) {
                    a(e1, "specifiers");
                }), s.NewExpression || (u.NewExpression = function(e1) {
                    a(e1, "arguments");
                }), u;
            }
        }, Dl;
    }
    var zl, Hl = {}, Jl = {}, Ql = {};
    function Yl() {
        return zl || (zl = 1, function(e1) {
            var t;
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }), e1.EXTENDED_PICTOGRAPHIC = e1.CLUSTER_BREAK = void 0, (t = e1.CLUSTER_BREAK || (e1.CLUSTER_BREAK = {}))[t.CR = 0] = "CR", t[t.LF = 1] = "LF", t[t.CONTROL = 2] = "CONTROL", t[t.EXTEND = 3] = "EXTEND", t[t.REGIONAL_INDICATOR = 4] = "REGIONAL_INDICATOR", t[t.SPACINGMARK = 5] = "SPACINGMARK", t[t.L = 6] = "L", t[t.V = 7] = "V", t[t.T = 8] = "T", t[t.LV = 9] = "LV", t[t.LVT = 10] = "LVT", t[t.OTHER = 11] = "OTHER", t[t.PREPEND = 12] = "PREPEND", t[t.E_BASE = 13] = "E_BASE", t[t.E_MODIFIER = 14] = "E_MODIFIER", t[t.ZWJ = 15] = "ZWJ", t[t.GLUE_AFTER_ZWJ = 16] = "GLUE_AFTER_ZWJ", t[t.E_BASE_GAZ = 17] = "E_BASE_GAZ", e1.EXTENDED_PICTOGRAPHIC = 101;
        }(Ql)), Ql;
    }
    var Zl, ec = {};
    var tc, rc, nc, sc, ic, oc, ac, uc, lc, cc, pc, fc, dc, hc, mc, gc, yc, Ec, xc, Cc, Sc, bc, vc, Ac, Tc, Rc, Dc, wc, _c, kc, Bc, Lc, Pc, Ic, Fc, Nc, Oc, Uc, jc, Vc, Kc, Mc, $c, qc, Gc, Wc, Xc, zc, Hc, Jc, Qc, Yc, Zc, ep, tp, rp, np, sp, ip, op, ap, up, lp, cp, pp, fp, dp, hp, mp, gp, yp, Ep, xp, Cp, Sp, bp, vp, Ap, Tp, Rp, Dp, wp, _p, kp, Bp, Lp, Pp, Ip, Fp, Np, Op, Up, jp, Vp, Kp, Mp, $p, qp, Gp, Wp, Xp, zp, Hp, Jp, Qp, Yp, Zp, ef, tf, rf, nf, sf, of, af, uf, lf, cf, pf, ff, df, hf, mf, gf, yf, Ef, xf, Cf, Sf, bf, vf, Af, Tf, Rf, Df, wf, _f, kf, Bf, Lf, Pf, If, Ff, Nf, Of, Uf, jf, Vf, Kf, Mf, $f, qf, Gf, Wf, Xf, zf, Hf, Jf, Qf, Yf, Zf, ed, td, rd, nd = {};
    function sd() {
        if (rc) return Jl;
        rc = 1;
        var e1 = this && this.__importDefault || function(e1) {
            return e1 && e1.__esModule ? e1 : {
                default: e1
            };
        };
        Object.defineProperty(Jl, "__esModule", {
            value: !0
        });
        const t = Yl(), r = e1(function() {
            if (Zl) return ec;
            Zl = 1, Object.defineProperty(ec, "__esModule", {
                value: !0
            });
            const e1 = Yl();
            return ec.default = class {
                static isSurrogate(e1, t) {
                    return 55296 <= e1.charCodeAt(t) && e1.charCodeAt(t) <= 56319 && 56320 <= e1.charCodeAt(t + 1) && e1.charCodeAt(t + 1) <= 57343;
                }
                static codePointAt(e1, t) {
                    void 0 === t && (t = 0);
                    const r = e1.charCodeAt(t);
                    if (55296 <= r && r <= 56319 && t < e1.length - 1) {
                        const n = r, s = e1.charCodeAt(t + 1);
                        return 56320 <= s && s <= 57343 ? 1024 * (n - 55296) + (s - 56320) + 65536 : n;
                    }
                    if (56320 <= r && r <= 57343 && t >= 1) {
                        const n = e1.charCodeAt(t - 1);
                        return 55296 <= n && n <= 56319 ? 1024 * (n - 55296) + (r - 56320) + 65536 : r;
                    }
                    return r;
                }
                static shouldBreak(t, r, n, s, i, o) {
                    const a = [
                        t
                    ].concat(r).concat([
                        n
                    ]), u = [
                        s
                    ].concat(i).concat([
                        o
                    ]), l = a[a.length - 2], c = n, p = o, f = a.lastIndexOf(e1.CLUSTER_BREAK.REGIONAL_INDICATOR);
                    if (f > 0 && a.slice(1, f).every(function(t) {
                        return t === e1.CLUSTER_BREAK.REGIONAL_INDICATOR;
                    }) && -1 === [
                        e1.CLUSTER_BREAK.PREPEND,
                        e1.CLUSTER_BREAK.REGIONAL_INDICATOR
                    ].indexOf(l)) return a.filter(function(t) {
                        return t === e1.CLUSTER_BREAK.REGIONAL_INDICATOR;
                    }).length % 2 == 1 ? 3 : 4;
                    if (l === e1.CLUSTER_BREAK.CR && c === e1.CLUSTER_BREAK.LF) return 0;
                    if (l === e1.CLUSTER_BREAK.CONTROL || l === e1.CLUSTER_BREAK.CR || l === e1.CLUSTER_BREAK.LF) return 1;
                    if (c === e1.CLUSTER_BREAK.CONTROL || c === e1.CLUSTER_BREAK.CR || c === e1.CLUSTER_BREAK.LF) return 1;
                    if (l === e1.CLUSTER_BREAK.L && (c === e1.CLUSTER_BREAK.L || c === e1.CLUSTER_BREAK.V || c === e1.CLUSTER_BREAK.LV || c === e1.CLUSTER_BREAK.LVT)) return 0;
                    if (!(l !== e1.CLUSTER_BREAK.LV && l !== e1.CLUSTER_BREAK.V || c !== e1.CLUSTER_BREAK.V && c !== e1.CLUSTER_BREAK.T)) return 0;
                    if ((l === e1.CLUSTER_BREAK.LVT || l === e1.CLUSTER_BREAK.T) && c === e1.CLUSTER_BREAK.T) return 0;
                    if (c === e1.CLUSTER_BREAK.EXTEND || c === e1.CLUSTER_BREAK.ZWJ) return 0;
                    if (c === e1.CLUSTER_BREAK.SPACINGMARK) return 0;
                    if (l === e1.CLUSTER_BREAK.PREPEND) return 0;
                    const d = u.slice(0, -1).lastIndexOf(e1.EXTENDED_PICTOGRAPHIC);
                    return -1 !== d && u[d] === e1.EXTENDED_PICTOGRAPHIC && a.slice(d + 1, -2).every(function(t) {
                        return t === e1.CLUSTER_BREAK.EXTEND;
                    }) && l === e1.CLUSTER_BREAK.ZWJ && p === e1.EXTENDED_PICTOGRAPHIC ? 0 : -1 !== r.indexOf(e1.CLUSTER_BREAK.REGIONAL_INDICATOR) ? 2 : l === e1.CLUSTER_BREAK.REGIONAL_INDICATOR && c === e1.CLUSTER_BREAK.REGIONAL_INDICATOR ? 0 : 1;
                }
            }, ec;
        }()), n = e1(function() {
            if (tc) return nd;
            tc = 1, Object.defineProperty(nd, "__esModule", {
                value: !0
            });
            let e1 = class {
                constructor(e1, t){
                    this._index = 0, this._str = e1, this._nextBreak = t;
                }
                [Symbol.iterator]() {
                    return this;
                }
                next() {
                    let e1;
                    if ((e1 = this._nextBreak(this._str, this._index)) < this._str.length) {
                        const t = this._str.slice(this._index, e1);
                        return this._index = e1, {
                            value: t,
                            done: !1
                        };
                    }
                    if (this._index < this._str.length) {
                        const e1 = this._str.slice(this._index);
                        return this._index = this._str.length, {
                            value: e1,
                            done: !1
                        };
                    }
                    return {
                        value: void 0,
                        done: !0
                    };
                }
            };
            return nd.default = e1, nd;
        }());
        return Jl.default = class e1 {
            static nextBreak(t, n) {
                if (void 0 === n && (n = 0), n < 0) return 0;
                if (n >= t.length - 1) return t.length;
                const s = r.default.codePointAt(t, n), i = e1.getGraphemeBreakProperty(s), o = e1.getEmojiProperty(s), a = [], u = [];
                for(let s = n + 1; s < t.length; s++){
                    if (r.default.isSurrogate(t, s - 1)) continue;
                    const n = r.default.codePointAt(t, s), l = e1.getGraphemeBreakProperty(n), c = e1.getEmojiProperty(n);
                    if (r.default.shouldBreak(i, a, l, o, u, c)) return s;
                    a.push(l), u.push(c);
                }
                return t.length;
            }
            splitGraphemes(t) {
                const r = [];
                let n, s = 0;
                for(; (n = e1.nextBreak(t, s)) < t.length;)r.push(t.slice(s, n)), s = n;
                return s < t.length && r.push(t.slice(s)), r;
            }
            iterateGraphemes(t) {
                return new n.default(t, e1.nextBreak);
            }
            countGraphemes(t) {
                let r, n = 0, s = 0;
                for(; (r = e1.nextBreak(t, s)) < t.length;)s = r, n++;
                return s < t.length && n++, n;
            }
            static getGraphemeBreakProperty(e1) {
                if (e1 < 48905) {
                    if (e1 < 44116) {
                        if (e1 < 4141) {
                            if (e1 < 2818) {
                                if (e1 < 2363) {
                                    if (e1 < 1759) {
                                        if (e1 < 1471) {
                                            if (e1 < 127) {
                                                if (e1 < 11) {
                                                    if (e1 < 10) {
                                                        if (0 <= e1 && e1 <= 9) return t.CLUSTER_BREAK.CONTROL;
                                                    } else if (10 === e1) return t.CLUSTER_BREAK.LF;
                                                } else if (e1 < 13) {
                                                    if (11 <= e1 && e1 <= 12) return t.CLUSTER_BREAK.CONTROL;
                                                } else if (e1 < 14) {
                                                    if (13 === e1) return t.CLUSTER_BREAK.CR;
                                                } else if (14 <= e1 && e1 <= 31) return t.CLUSTER_BREAK.CONTROL;
                                            } else if (e1 < 768) {
                                                if (e1 < 173) {
                                                    if (127 <= e1 && e1 <= 159) return t.CLUSTER_BREAK.CONTROL;
                                                } else if (173 === e1) return t.CLUSTER_BREAK.CONTROL;
                                            } else if (e1 < 1155) {
                                                if (768 <= e1 && e1 <= 879) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (e1 < 1425) {
                                                if (1155 <= e1 && e1 <= 1161) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (1425 <= e1 && e1 <= 1469) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 1552) {
                                            if (e1 < 1476) {
                                                if (e1 < 1473) {
                                                    if (1471 === e1) return t.CLUSTER_BREAK.EXTEND;
                                                } else if (1473 <= e1 && e1 <= 1474) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (e1 < 1479) {
                                                if (1476 <= e1 && e1 <= 1477) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (e1 < 1536) {
                                                if (1479 === e1) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (1536 <= e1 && e1 <= 1541) return t.CLUSTER_BREAK.PREPEND;
                                        } else if (e1 < 1648) {
                                            if (e1 < 1564) {
                                                if (1552 <= e1 && e1 <= 1562) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (e1 < 1611) {
                                                if (1564 === e1) return t.CLUSTER_BREAK.CONTROL;
                                            } else if (1611 <= e1 && e1 <= 1631) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 1750) {
                                            if (1648 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 1757) {
                                            if (1750 <= e1 && e1 <= 1756) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (1757 === e1) return t.CLUSTER_BREAK.PREPEND;
                                    } else if (e1 < 2075) {
                                        if (e1 < 1840) {
                                            if (e1 < 1770) {
                                                if (e1 < 1767) {
                                                    if (1759 <= e1 && e1 <= 1764) return t.CLUSTER_BREAK.EXTEND;
                                                } else if (1767 <= e1 && e1 <= 1768) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (e1 < 1807) {
                                                if (1770 <= e1 && e1 <= 1773) return t.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                if (1807 === e1) return t.CLUSTER_BREAK.PREPEND;
                                                if (1809 === e1) return t.CLUSTER_BREAK.EXTEND;
                                            }
                                        } else if (e1 < 2027) {
                                            if (e1 < 1958) {
                                                if (1840 <= e1 && e1 <= 1866) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (1958 <= e1 && e1 <= 1968) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 2045) {
                                            if (2027 <= e1 && e1 <= 2035) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 2070) {
                                            if (2045 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (2070 <= e1 && e1 <= 2073) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 2200) {
                                        if (e1 < 2089) {
                                            if (e1 < 2085) {
                                                if (2075 <= e1 && e1 <= 2083) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (2085 <= e1 && e1 <= 2087) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 2137) {
                                            if (2089 <= e1 && e1 <= 2093) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 2192) {
                                            if (2137 <= e1 && e1 <= 2139) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (2192 <= e1 && e1 <= 2193) return t.CLUSTER_BREAK.PREPEND;
                                    } else if (e1 < 2275) {
                                        if (e1 < 2250) {
                                            if (2200 <= e1 && e1 <= 2207) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 2274) {
                                            if (2250 <= e1 && e1 <= 2273) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (2274 === e1) return t.CLUSTER_BREAK.PREPEND;
                                    } else if (e1 < 2307) {
                                        if (2275 <= e1 && e1 <= 2306) return t.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        if (2307 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                        if (2362 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (e1 < 2561) {
                                    if (e1 < 2434) {
                                        if (e1 < 2381) {
                                            if (e1 < 2366) {
                                                if (2363 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                                if (2364 === e1) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (e1 < 2369) {
                                                if (2366 <= e1 && e1 <= 2368) return t.CLUSTER_BREAK.SPACINGMARK;
                                            } else if (e1 < 2377) {
                                                if (2369 <= e1 && e1 <= 2376) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (2377 <= e1 && e1 <= 2380) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (e1 < 2385) {
                                            if (e1 < 2382) {
                                                if (2381 === e1) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (2382 <= e1 && e1 <= 2383) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (e1 < 2402) {
                                            if (2385 <= e1 && e1 <= 2391) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 2433) {
                                            if (2402 <= e1 && e1 <= 2403) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (2433 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 2503) {
                                        if (e1 < 2494) {
                                            if (e1 < 2492) {
                                                if (2434 <= e1 && e1 <= 2435) return t.CLUSTER_BREAK.SPACINGMARK;
                                            } else if (2492 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 2495) {
                                            if (2494 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 2497) {
                                            if (2495 <= e1 && e1 <= 2496) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (2497 <= e1 && e1 <= 2500) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 2519) {
                                        if (e1 < 2507) {
                                            if (2503 <= e1 && e1 <= 2504) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (e1 < 2509) {
                                            if (2507 <= e1 && e1 <= 2508) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (2509 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 2530) {
                                        if (2519 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 2558) {
                                        if (2530 <= e1 && e1 <= 2531) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (2558 === e1) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 2691) {
                                    if (e1 < 2631) {
                                        if (e1 < 2620) {
                                            if (e1 < 2563) {
                                                if (2561 <= e1 && e1 <= 2562) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (2563 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (e1 < 2622) {
                                            if (2620 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 2625) {
                                            if (2622 <= e1 && e1 <= 2624) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (2625 <= e1 && e1 <= 2626) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 2672) {
                                        if (e1 < 2635) {
                                            if (2631 <= e1 && e1 <= 2632) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 2641) {
                                            if (2635 <= e1 && e1 <= 2637) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (2641 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 2677) {
                                        if (2672 <= e1 && e1 <= 2673) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 2689) {
                                        if (2677 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (2689 <= e1 && e1 <= 2690) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 2761) {
                                    if (e1 < 2750) {
                                        if (2691 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                        if (2748 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 2753) {
                                        if (2750 <= e1 && e1 <= 2752) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (e1 < 2759) {
                                        if (2753 <= e1 && e1 <= 2757) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (2759 <= e1 && e1 <= 2760) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 2786) {
                                    if (e1 < 2763) {
                                        if (2761 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (e1 < 2765) {
                                        if (2763 <= e1 && e1 <= 2764) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (2765 === e1) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 2810) {
                                    if (2786 <= e1 && e1 <= 2787) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 2817) {
                                    if (2810 <= e1 && e1 <= 2815) return t.CLUSTER_BREAK.EXTEND;
                                } else if (2817 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 3315) {
                                if (e1 < 3076) {
                                    if (e1 < 2946) {
                                        if (e1 < 2887) {
                                            if (e1 < 2878) {
                                                if (e1 < 2876) {
                                                    if (2818 <= e1 && e1 <= 2819) return t.CLUSTER_BREAK.SPACINGMARK;
                                                } else if (2876 === e1) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (e1 < 2880) {
                                                if (2878 <= e1 && e1 <= 2879) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (e1 < 2881) {
                                                if (2880 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                            } else if (2881 <= e1 && e1 <= 2884) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 2893) {
                                            if (e1 < 2891) {
                                                if (2887 <= e1 && e1 <= 2888) return t.CLUSTER_BREAK.SPACINGMARK;
                                            } else if (2891 <= e1 && e1 <= 2892) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (e1 < 2901) {
                                            if (2893 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 2914) {
                                            if (2901 <= e1 && e1 <= 2903) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (2914 <= e1 && e1 <= 2915) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 3014) {
                                        if (e1 < 3007) {
                                            if (2946 === e1) return t.CLUSTER_BREAK.EXTEND;
                                            if (3006 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 3008) {
                                            if (3007 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (e1 < 3009) {
                                            if (3008 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (3009 <= e1 && e1 <= 3010) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (e1 < 3031) {
                                        if (e1 < 3018) {
                                            if (3014 <= e1 && e1 <= 3016) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (e1 < 3021) {
                                            if (3018 <= e1 && e1 <= 3020) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (3021 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 3072) {
                                        if (3031 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 3073) {
                                        if (3072 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (3073 <= e1 && e1 <= 3075) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 3262) {
                                    if (e1 < 3146) {
                                        if (e1 < 3134) {
                                            if (3076 === e1) return t.CLUSTER_BREAK.EXTEND;
                                            if (3132 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 3137) {
                                            if (3134 <= e1 && e1 <= 3136) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 3142) {
                                            if (3137 <= e1 && e1 <= 3140) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (3142 <= e1 && e1 <= 3144) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 3201) {
                                        if (e1 < 3157) {
                                            if (3146 <= e1 && e1 <= 3149) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 3170) {
                                            if (3157 <= e1 && e1 <= 3158) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (3170 <= e1 && e1 <= 3171) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 3202) {
                                        if (3201 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 3260) {
                                        if (3202 <= e1 && e1 <= 3203) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (3260 === e1) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 3270) {
                                    if (e1 < 3264) {
                                        if (3262 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                        if (3263 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 3266) {
                                        if (3264 <= e1 && e1 <= 3265) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (e1 < 3267) {
                                        if (3266 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (3267 <= e1 && e1 <= 3268) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 3276) {
                                    if (e1 < 3271) {
                                        if (3270 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 3274) {
                                        if (3271 <= e1 && e1 <= 3272) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (3274 <= e1 && e1 <= 3275) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 3285) {
                                    if (3276 <= e1 && e1 <= 3277) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 3298) {
                                    if (3285 <= e1 && e1 <= 3286) return t.CLUSTER_BREAK.EXTEND;
                                } else if (3298 <= e1 && e1 <= 3299) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 3551) {
                                if (e1 < 3406) {
                                    if (e1 < 3391) {
                                        if (e1 < 3330) {
                                            if (e1 < 3328) {
                                                if (3315 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                            } else if (3328 <= e1 && e1 <= 3329) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 3387) {
                                            if (3330 <= e1 && e1 <= 3331) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (e1 < 3390) {
                                            if (3387 <= e1 && e1 <= 3388) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (3390 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 3398) {
                                        if (e1 < 3393) {
                                            if (3391 <= e1 && e1 <= 3392) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (3393 <= e1 && e1 <= 3396) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 3402) {
                                        if (3398 <= e1 && e1 <= 3400) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (e1 < 3405) {
                                        if (3402 <= e1 && e1 <= 3404) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (3405 === e1) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 3530) {
                                    if (e1 < 3426) {
                                        if (3406 === e1) return t.CLUSTER_BREAK.PREPEND;
                                        if (3415 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 3457) {
                                        if (3426 <= e1 && e1 <= 3427) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 3458) {
                                        if (3457 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (3458 <= e1 && e1 <= 3459) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 3538) {
                                    if (e1 < 3535) {
                                        if (3530 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 3536) {
                                        if (3535 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (3536 <= e1 && e1 <= 3537) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 3542) {
                                    if (3538 <= e1 && e1 <= 3540) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 3544) {
                                    if (3542 === e1) return t.CLUSTER_BREAK.EXTEND;
                                } else if (3544 <= e1 && e1 <= 3550) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 3893) {
                                if (e1 < 3655) {
                                    if (e1 < 3633) {
                                        if (e1 < 3570) {
                                            if (3551 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (3570 <= e1 && e1 <= 3571) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (e1 < 3635) {
                                        if (3633 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 3636) {
                                        if (3635 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (3636 <= e1 && e1 <= 3642) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 3764) {
                                    if (e1 < 3761) {
                                        if (3655 <= e1 && e1 <= 3662) return t.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        if (3761 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        if (3763 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else if (e1 < 3784) {
                                    if (3764 <= e1 && e1 <= 3772) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 3864) {
                                    if (3784 <= e1 && e1 <= 3790) return t.CLUSTER_BREAK.EXTEND;
                                } else if (3864 <= e1 && e1 <= 3865) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 3967) {
                                if (e1 < 3897) {
                                    if (3893 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    if (3895 === e1) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 3902) {
                                    if (3897 === e1) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 3953) {
                                    if (3902 <= e1 && e1 <= 3903) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (3953 <= e1 && e1 <= 3966) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 3981) {
                                if (e1 < 3968) {
                                    if (3967 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 3974) {
                                    if (3968 <= e1 && e1 <= 3972) return t.CLUSTER_BREAK.EXTEND;
                                } else if (3974 <= e1 && e1 <= 3975) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 3993) {
                                if (3981 <= e1 && e1 <= 3991) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 4038) {
                                if (3993 <= e1 && e1 <= 4028) return t.CLUSTER_BREAK.EXTEND;
                            } else if (4038 === e1) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 7204) {
                            if (e1 < 6448) {
                                if (e1 < 5938) {
                                    if (e1 < 4226) {
                                        if (e1 < 4157) {
                                            if (e1 < 4146) {
                                                if (e1 < 4145) {
                                                    if (4141 <= e1 && e1 <= 4144) return t.CLUSTER_BREAK.EXTEND;
                                                } else if (4145 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                            } else if (e1 < 4153) {
                                                if (4146 <= e1 && e1 <= 4151) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (e1 < 4155) {
                                                if (4153 <= e1 && e1 <= 4154) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (4155 <= e1 && e1 <= 4156) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (e1 < 4184) {
                                            if (e1 < 4182) {
                                                if (4157 <= e1 && e1 <= 4158) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (4182 <= e1 && e1 <= 4183) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (e1 < 4190) {
                                            if (4184 <= e1 && e1 <= 4185) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 4209) {
                                            if (4190 <= e1 && e1 <= 4192) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (4209 <= e1 && e1 <= 4212) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 4352) {
                                        if (e1 < 4229) {
                                            if (4226 === e1) return t.CLUSTER_BREAK.EXTEND;
                                            if (4228 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (e1 < 4237) {
                                            if (4229 <= e1 && e1 <= 4230) return t.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            if (4237 === e1) return t.CLUSTER_BREAK.EXTEND;
                                            if (4253 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else if (e1 < 4957) {
                                        if (e1 < 4448) {
                                            if (4352 <= e1 && e1 <= 4447) return t.CLUSTER_BREAK.L;
                                        } else if (e1 < 4520) {
                                            if (4448 <= e1 && e1 <= 4519) return t.CLUSTER_BREAK.V;
                                        } else if (4520 <= e1 && e1 <= 4607) return t.CLUSTER_BREAK.T;
                                    } else if (e1 < 5906) {
                                        if (4957 <= e1 && e1 <= 4959) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 5909) {
                                        if (5906 <= e1 && e1 <= 5908) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (5909 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 6089) {
                                    if (e1 < 6070) {
                                        if (e1 < 5970) {
                                            if (e1 < 5940) {
                                                if (5938 <= e1 && e1 <= 5939) return t.CLUSTER_BREAK.EXTEND;
                                            } else if (5940 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (e1 < 6002) {
                                            if (5970 <= e1 && e1 <= 5971) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 6068) {
                                            if (6002 <= e1 && e1 <= 6003) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (6068 <= e1 && e1 <= 6069) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 6078) {
                                        if (e1 < 6071) {
                                            if (6070 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (6071 <= e1 && e1 <= 6077) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 6086) {
                                        if (6078 <= e1 && e1 <= 6085) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (e1 < 6087) {
                                        if (6086 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (6087 <= e1 && e1 <= 6088) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 6277) {
                                    if (e1 < 6155) {
                                        if (e1 < 6109) {
                                            if (6089 <= e1 && e1 <= 6099) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (6109 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 6158) {
                                        if (6155 <= e1 && e1 <= 6157) return t.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        if (6158 === e1) return t.CLUSTER_BREAK.CONTROL;
                                        if (6159 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (e1 < 6435) {
                                    if (e1 < 6313) {
                                        if (6277 <= e1 && e1 <= 6278) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 6432) {
                                        if (6313 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (6432 <= e1 && e1 <= 6434) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 6439) {
                                    if (6435 <= e1 && e1 <= 6438) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 6441) {
                                    if (6439 <= e1 && e1 <= 6440) return t.CLUSTER_BREAK.EXTEND;
                                } else if (6441 <= e1 && e1 <= 6443) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 6971) {
                                if (e1 < 6744) {
                                    if (e1 < 6681) {
                                        if (e1 < 6451) {
                                            if (e1 < 6450) {
                                                if (6448 <= e1 && e1 <= 6449) return t.CLUSTER_BREAK.SPACINGMARK;
                                            } else if (6450 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 6457) {
                                            if (6451 <= e1 && e1 <= 6456) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (e1 < 6679) {
                                            if (6457 <= e1 && e1 <= 6459) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (6679 <= e1 && e1 <= 6680) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 6741) {
                                        if (e1 < 6683) {
                                            if (6681 <= e1 && e1 <= 6682) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (6683 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 6742) {
                                        if (6741 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        if (6742 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        if (6743 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else if (e1 < 6771) {
                                    if (e1 < 6754) {
                                        if (e1 < 6752) {
                                            if (6744 <= e1 && e1 <= 6750) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (6752 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 6757) {
                                        if (6754 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 6765) {
                                        if (6757 <= e1 && e1 <= 6764) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (6765 <= e1 && e1 <= 6770) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 6912) {
                                    if (e1 < 6783) {
                                        if (6771 <= e1 && e1 <= 6780) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 6832) {
                                        if (6783 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (6832 <= e1 && e1 <= 6862) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 6916) {
                                    if (6912 <= e1 && e1 <= 6915) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 6964) {
                                    if (6916 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (6964 <= e1 && e1 <= 6970) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 7080) {
                                if (e1 < 7019) {
                                    if (e1 < 6973) {
                                        if (6971 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                        if (6972 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 6978) {
                                        if (6973 <= e1 && e1 <= 6977) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (e1 < 6979) {
                                        if (6978 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (6979 <= e1 && e1 <= 6980) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 7073) {
                                    if (e1 < 7040) {
                                        if (7019 <= e1 && e1 <= 7027) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 7042) {
                                        if (7040 <= e1 && e1 <= 7041) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (7042 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 7074) {
                                    if (7073 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 7078) {
                                    if (7074 <= e1 && e1 <= 7077) return t.CLUSTER_BREAK.EXTEND;
                                } else if (7078 <= e1 && e1 <= 7079) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 7144) {
                                if (e1 < 7083) {
                                    if (e1 < 7082) {
                                        if (7080 <= e1 && e1 <= 7081) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (7082 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 7142) {
                                    if (7083 <= e1 && e1 <= 7085) return t.CLUSTER_BREAK.EXTEND;
                                } else {
                                    if (7142 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    if (7143 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else if (e1 < 7150) {
                                if (e1 < 7146) {
                                    if (7144 <= e1 && e1 <= 7145) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 7149) {
                                    if (7146 <= e1 && e1 <= 7148) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (7149 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 7151) {
                                if (7150 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 7154) {
                                if (7151 <= e1 && e1 <= 7153) return t.CLUSTER_BREAK.EXTEND;
                            } else if (7154 <= e1 && e1 <= 7155) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e1 < 43346) {
                            if (e1 < 11647) {
                                if (e1 < 7415) {
                                    if (e1 < 7380) {
                                        if (e1 < 7220) {
                                            if (e1 < 7212) {
                                                if (7204 <= e1 && e1 <= 7211) return t.CLUSTER_BREAK.SPACINGMARK;
                                            } else if (7212 <= e1 && e1 <= 7219) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (e1 < 7222) {
                                            if (7220 <= e1 && e1 <= 7221) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (e1 < 7376) {
                                            if (7222 <= e1 && e1 <= 7223) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (7376 <= e1 && e1 <= 7378) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 7394) {
                                        if (e1 < 7393) {
                                            if (7380 <= e1 && e1 <= 7392) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (7393 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (e1 < 7405) {
                                        if (7394 <= e1 && e1 <= 7400) return t.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        if (7405 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        if (7412 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (e1 < 8205) {
                                    if (e1 < 7616) {
                                        if (e1 < 7416) {
                                            if (7415 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (7416 <= e1 && e1 <= 7417) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 8203) {
                                        if (7616 <= e1 && e1 <= 7679) return t.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        if (8203 === e1) return t.CLUSTER_BREAK.CONTROL;
                                        if (8204 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (e1 < 8288) {
                                    if (e1 < 8206) {
                                        if (8205 === e1) return t.CLUSTER_BREAK.ZWJ;
                                    } else if (e1 < 8232) {
                                        if (8206 <= e1 && e1 <= 8207) return t.CLUSTER_BREAK.CONTROL;
                                    } else if (8232 <= e1 && e1 <= 8238) return t.CLUSTER_BREAK.CONTROL;
                                } else if (e1 < 8400) {
                                    if (8288 <= e1 && e1 <= 8303) return t.CLUSTER_BREAK.CONTROL;
                                } else if (e1 < 11503) {
                                    if (8400 <= e1 && e1 <= 8432) return t.CLUSTER_BREAK.EXTEND;
                                } else if (11503 <= e1 && e1 <= 11505) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 43043) {
                                if (e1 < 42612) {
                                    if (e1 < 12330) {
                                        if (e1 < 11744) {
                                            if (11647 === e1) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (11744 <= e1 && e1 <= 11775) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 12441) {
                                        if (12330 <= e1 && e1 <= 12335) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 42607) {
                                        if (12441 <= e1 && e1 <= 12442) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (42607 <= e1 && e1 <= 42610) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 43010) {
                                    if (e1 < 42654) {
                                        if (42612 <= e1 && e1 <= 42621) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 42736) {
                                        if (42654 <= e1 && e1 <= 42655) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (42736 <= e1 && e1 <= 42737) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 43014) {
                                    if (43010 === e1) return t.CLUSTER_BREAK.EXTEND;
                                } else {
                                    if (43014 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    if (43019 === e1) return t.CLUSTER_BREAK.EXTEND;
                                }
                            } else if (e1 < 43188) {
                                if (e1 < 43047) {
                                    if (e1 < 43045) {
                                        if (43043 <= e1 && e1 <= 43044) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (43045 <= e1 && e1 <= 43046) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 43052) {
                                    if (43047 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 43136) {
                                    if (43052 === e1) return t.CLUSTER_BREAK.EXTEND;
                                } else if (43136 <= e1 && e1 <= 43137) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 43263) {
                                if (e1 < 43204) {
                                    if (43188 <= e1 && e1 <= 43203) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 43232) {
                                    if (43204 <= e1 && e1 <= 43205) return t.CLUSTER_BREAK.EXTEND;
                                } else if (43232 <= e1 && e1 <= 43249) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 43302) {
                                if (43263 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 43335) {
                                if (43302 <= e1 && e1 <= 43309) return t.CLUSTER_BREAK.EXTEND;
                            } else if (43335 <= e1 && e1 <= 43345) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 43698) {
                            if (e1 < 43493) {
                                if (e1 < 43444) {
                                    if (e1 < 43392) {
                                        if (e1 < 43360) {
                                            if (43346 <= e1 && e1 <= 43347) return t.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (43360 <= e1 && e1 <= 43388) return t.CLUSTER_BREAK.L;
                                    } else if (e1 < 43395) {
                                        if (43392 <= e1 && e1 <= 43394) return t.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        if (43395 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                        if (43443 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (e1 < 43450) {
                                    if (e1 < 43446) {
                                        if (43444 <= e1 && e1 <= 43445) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (43446 <= e1 && e1 <= 43449) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 43452) {
                                    if (43450 <= e1 && e1 <= 43451) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 43454) {
                                    if (43452 <= e1 && e1 <= 43453) return t.CLUSTER_BREAK.EXTEND;
                                } else if (43454 <= e1 && e1 <= 43456) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 43573) {
                                if (e1 < 43567) {
                                    if (e1 < 43561) {
                                        if (43493 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (43561 <= e1 && e1 <= 43566) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 43569) {
                                    if (43567 <= e1 && e1 <= 43568) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 43571) {
                                    if (43569 <= e1 && e1 <= 43570) return t.CLUSTER_BREAK.EXTEND;
                                } else if (43571 <= e1 && e1 <= 43572) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 43597) {
                                if (e1 < 43587) {
                                    if (43573 <= e1 && e1 <= 43574) return t.CLUSTER_BREAK.EXTEND;
                                } else {
                                    if (43587 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    if (43596 === e1) return t.CLUSTER_BREAK.EXTEND;
                                }
                            } else if (e1 < 43644) {
                                if (43597 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else {
                                if (43644 === e1) return t.CLUSTER_BREAK.EXTEND;
                                if (43696 === e1) return t.CLUSTER_BREAK.EXTEND;
                            }
                        } else if (e1 < 44006) {
                            if (e1 < 43756) {
                                if (e1 < 43710) {
                                    if (e1 < 43703) {
                                        if (43698 <= e1 && e1 <= 43700) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (43703 <= e1 && e1 <= 43704) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 43713) {
                                    if (43710 <= e1 && e1 <= 43711) return t.CLUSTER_BREAK.EXTEND;
                                } else {
                                    if (43713 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    if (43755 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else if (e1 < 43766) {
                                if (e1 < 43758) {
                                    if (43756 <= e1 && e1 <= 43757) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 43765) {
                                    if (43758 <= e1 && e1 <= 43759) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (43765 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 44003) {
                                if (43766 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 44005) {
                                if (44003 <= e1 && e1 <= 44004) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (44005 === e1) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 44032) {
                            if (e1 < 44009) {
                                if (e1 < 44008) {
                                    if (44006 <= e1 && e1 <= 44007) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (44008 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 44012) {
                                if (44009 <= e1 && e1 <= 44010) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else {
                                if (44012 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                if (44013 === e1) return t.CLUSTER_BREAK.EXTEND;
                            }
                        } else if (e1 < 44061) {
                            if (e1 < 44033) {
                                if (44032 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 44060) {
                                if (44033 <= e1 && e1 <= 44059) return t.CLUSTER_BREAK.LVT;
                            } else if (44060 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 44088) {
                            if (44061 <= e1 && e1 <= 44087) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 44089) {
                            if (44088 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (44089 <= e1 && e1 <= 44115) return t.CLUSTER_BREAK.LVT;
                    } else if (e1 < 46497) {
                        if (e1 < 45293) {
                            if (e1 < 44704) {
                                if (e1 < 44397) {
                                    if (e1 < 44256) {
                                        if (e1 < 44173) {
                                            if (e1 < 44144) {
                                                if (e1 < 44117) {
                                                    if (44116 === e1) return t.CLUSTER_BREAK.LV;
                                                } else if (44117 <= e1 && e1 <= 44143) return t.CLUSTER_BREAK.LVT;
                                            } else if (e1 < 44145) {
                                                if (44144 === e1) return t.CLUSTER_BREAK.LV;
                                            } else if (e1 < 44172) {
                                                if (44145 <= e1 && e1 <= 44171) return t.CLUSTER_BREAK.LVT;
                                            } else if (44172 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (e1 < 44201) {
                                            if (e1 < 44200) {
                                                if (44173 <= e1 && e1 <= 44199) return t.CLUSTER_BREAK.LVT;
                                            } else if (44200 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (e1 < 44228) {
                                            if (44201 <= e1 && e1 <= 44227) return t.CLUSTER_BREAK.LVT;
                                        } else if (e1 < 44229) {
                                            if (44228 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (44229 <= e1 && e1 <= 44255) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 44313) {
                                        if (e1 < 44284) {
                                            if (e1 < 44257) {
                                                if (44256 === e1) return t.CLUSTER_BREAK.LV;
                                            } else if (44257 <= e1 && e1 <= 44283) return t.CLUSTER_BREAK.LVT;
                                        } else if (e1 < 44285) {
                                            if (44284 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (e1 < 44312) {
                                            if (44285 <= e1 && e1 <= 44311) return t.CLUSTER_BREAK.LVT;
                                        } else if (44312 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 44368) {
                                        if (e1 < 44340) {
                                            if (44313 <= e1 && e1 <= 44339) return t.CLUSTER_BREAK.LVT;
                                        } else if (e1 < 44341) {
                                            if (44340 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (44341 <= e1 && e1 <= 44367) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 44369) {
                                        if (44368 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 44396) {
                                        if (44369 <= e1 && e1 <= 44395) return t.CLUSTER_BREAK.LVT;
                                    } else if (44396 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 44537) {
                                    if (e1 < 44480) {
                                        if (e1 < 44425) {
                                            if (e1 < 44424) {
                                                if (44397 <= e1 && e1 <= 44423) return t.CLUSTER_BREAK.LVT;
                                            } else if (44424 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (e1 < 44452) {
                                            if (44425 <= e1 && e1 <= 44451) return t.CLUSTER_BREAK.LVT;
                                        } else if (e1 < 44453) {
                                            if (44452 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (44453 <= e1 && e1 <= 44479) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 44508) {
                                        if (e1 < 44481) {
                                            if (44480 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (44481 <= e1 && e1 <= 44507) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 44509) {
                                        if (44508 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 44536) {
                                        if (44509 <= e1 && e1 <= 44535) return t.CLUSTER_BREAK.LVT;
                                    } else if (44536 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 44620) {
                                    if (e1 < 44565) {
                                        if (e1 < 44564) {
                                            if (44537 <= e1 && e1 <= 44563) return t.CLUSTER_BREAK.LVT;
                                        } else if (44564 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 44592) {
                                        if (44565 <= e1 && e1 <= 44591) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 44593) {
                                        if (44592 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (44593 <= e1 && e1 <= 44619) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 44649) {
                                    if (e1 < 44621) {
                                        if (44620 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 44648) {
                                        if (44621 <= e1 && e1 <= 44647) return t.CLUSTER_BREAK.LVT;
                                    } else if (44648 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 44676) {
                                    if (44649 <= e1 && e1 <= 44675) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 44677) {
                                    if (44676 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (44677 <= e1 && e1 <= 44703) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 44985) {
                                if (e1 < 44844) {
                                    if (e1 < 44761) {
                                        if (e1 < 44732) {
                                            if (e1 < 44705) {
                                                if (44704 === e1) return t.CLUSTER_BREAK.LV;
                                            } else if (44705 <= e1 && e1 <= 44731) return t.CLUSTER_BREAK.LVT;
                                        } else if (e1 < 44733) {
                                            if (44732 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (e1 < 44760) {
                                            if (44733 <= e1 && e1 <= 44759) return t.CLUSTER_BREAK.LVT;
                                        } else if (44760 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 44789) {
                                        if (e1 < 44788) {
                                            if (44761 <= e1 && e1 <= 44787) return t.CLUSTER_BREAK.LVT;
                                        } else if (44788 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 44816) {
                                        if (44789 <= e1 && e1 <= 44815) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 44817) {
                                        if (44816 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (44817 <= e1 && e1 <= 44843) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 44901) {
                                    if (e1 < 44872) {
                                        if (e1 < 44845) {
                                            if (44844 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (44845 <= e1 && e1 <= 44871) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 44873) {
                                        if (44872 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 44900) {
                                        if (44873 <= e1 && e1 <= 44899) return t.CLUSTER_BREAK.LVT;
                                    } else if (44900 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 44956) {
                                    if (e1 < 44928) {
                                        if (44901 <= e1 && e1 <= 44927) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 44929) {
                                        if (44928 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (44929 <= e1 && e1 <= 44955) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 44957) {
                                    if (44956 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 44984) {
                                    if (44957 <= e1 && e1 <= 44983) return t.CLUSTER_BREAK.LVT;
                                } else if (44984 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 45152) {
                                if (e1 < 45068) {
                                    if (e1 < 45013) {
                                        if (e1 < 45012) {
                                            if (44985 <= e1 && e1 <= 45011) return t.CLUSTER_BREAK.LVT;
                                        } else if (45012 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 45040) {
                                        if (45013 <= e1 && e1 <= 45039) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 45041) {
                                        if (45040 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (45041 <= e1 && e1 <= 45067) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 45097) {
                                    if (e1 < 45069) {
                                        if (45068 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 45096) {
                                        if (45069 <= e1 && e1 <= 45095) return t.CLUSTER_BREAK.LVT;
                                    } else if (45096 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 45124) {
                                    if (45097 <= e1 && e1 <= 45123) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 45125) {
                                    if (45124 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (45125 <= e1 && e1 <= 45151) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 45209) {
                                if (e1 < 45180) {
                                    if (e1 < 45153) {
                                        if (45152 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (45153 <= e1 && e1 <= 45179) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 45181) {
                                    if (45180 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 45208) {
                                    if (45181 <= e1 && e1 <= 45207) return t.CLUSTER_BREAK.LVT;
                                } else if (45208 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 45264) {
                                if (e1 < 45236) {
                                    if (45209 <= e1 && e1 <= 45235) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 45237) {
                                    if (45236 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (45237 <= e1 && e1 <= 45263) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 45265) {
                                if (45264 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 45292) {
                                if (45265 <= e1 && e1 <= 45291) return t.CLUSTER_BREAK.LVT;
                            } else if (45292 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 45908) {
                            if (e1 < 45600) {
                                if (e1 < 45433) {
                                    if (e1 < 45376) {
                                        if (e1 < 45321) {
                                            if (e1 < 45320) {
                                                if (45293 <= e1 && e1 <= 45319) return t.CLUSTER_BREAK.LVT;
                                            } else if (45320 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (e1 < 45348) {
                                            if (45321 <= e1 && e1 <= 45347) return t.CLUSTER_BREAK.LVT;
                                        } else if (e1 < 45349) {
                                            if (45348 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (45349 <= e1 && e1 <= 45375) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 45404) {
                                        if (e1 < 45377) {
                                            if (45376 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (45377 <= e1 && e1 <= 45403) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 45405) {
                                        if (45404 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 45432) {
                                        if (45405 <= e1 && e1 <= 45431) return t.CLUSTER_BREAK.LVT;
                                    } else if (45432 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 45516) {
                                    if (e1 < 45461) {
                                        if (e1 < 45460) {
                                            if (45433 <= e1 && e1 <= 45459) return t.CLUSTER_BREAK.LVT;
                                        } else if (45460 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 45488) {
                                        if (45461 <= e1 && e1 <= 45487) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 45489) {
                                        if (45488 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (45489 <= e1 && e1 <= 45515) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 45545) {
                                    if (e1 < 45517) {
                                        if (45516 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 45544) {
                                        if (45517 <= e1 && e1 <= 45543) return t.CLUSTER_BREAK.LVT;
                                    } else if (45544 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 45572) {
                                    if (45545 <= e1 && e1 <= 45571) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 45573) {
                                    if (45572 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (45573 <= e1 && e1 <= 45599) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 45741) {
                                if (e1 < 45657) {
                                    if (e1 < 45628) {
                                        if (e1 < 45601) {
                                            if (45600 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (45601 <= e1 && e1 <= 45627) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 45629) {
                                        if (45628 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 45656) {
                                        if (45629 <= e1 && e1 <= 45655) return t.CLUSTER_BREAK.LVT;
                                    } else if (45656 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 45712) {
                                    if (e1 < 45684) {
                                        if (45657 <= e1 && e1 <= 45683) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 45685) {
                                        if (45684 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (45685 <= e1 && e1 <= 45711) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 45713) {
                                    if (45712 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 45740) {
                                    if (45713 <= e1 && e1 <= 45739) return t.CLUSTER_BREAK.LVT;
                                } else if (45740 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 45824) {
                                if (e1 < 45769) {
                                    if (e1 < 45768) {
                                        if (45741 <= e1 && e1 <= 45767) return t.CLUSTER_BREAK.LVT;
                                    } else if (45768 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 45796) {
                                    if (45769 <= e1 && e1 <= 45795) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 45797) {
                                    if (45796 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (45797 <= e1 && e1 <= 45823) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 45853) {
                                if (e1 < 45825) {
                                    if (45824 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 45852) {
                                    if (45825 <= e1 && e1 <= 45851) return t.CLUSTER_BREAK.LVT;
                                } else if (45852 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 45880) {
                                if (45853 <= e1 && e1 <= 45879) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 45881) {
                                if (45880 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (45881 <= e1 && e1 <= 45907) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 46189) {
                            if (e1 < 46048) {
                                if (e1 < 45965) {
                                    if (e1 < 45936) {
                                        if (e1 < 45909) {
                                            if (45908 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (45909 <= e1 && e1 <= 45935) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 45937) {
                                        if (45936 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 45964) {
                                        if (45937 <= e1 && e1 <= 45963) return t.CLUSTER_BREAK.LVT;
                                    } else if (45964 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 45993) {
                                    if (e1 < 45992) {
                                        if (45965 <= e1 && e1 <= 45991) return t.CLUSTER_BREAK.LVT;
                                    } else if (45992 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 46020) {
                                    if (45993 <= e1 && e1 <= 46019) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 46021) {
                                    if (46020 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (46021 <= e1 && e1 <= 46047) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 46105) {
                                if (e1 < 46076) {
                                    if (e1 < 46049) {
                                        if (46048 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (46049 <= e1 && e1 <= 46075) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 46077) {
                                    if (46076 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 46104) {
                                    if (46077 <= e1 && e1 <= 46103) return t.CLUSTER_BREAK.LVT;
                                } else if (46104 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 46160) {
                                if (e1 < 46132) {
                                    if (46105 <= e1 && e1 <= 46131) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 46133) {
                                    if (46132 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (46133 <= e1 && e1 <= 46159) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 46161) {
                                if (46160 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 46188) {
                                if (46161 <= e1 && e1 <= 46187) return t.CLUSTER_BREAK.LVT;
                            } else if (46188 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 46356) {
                            if (e1 < 46272) {
                                if (e1 < 46217) {
                                    if (e1 < 46216) {
                                        if (46189 <= e1 && e1 <= 46215) return t.CLUSTER_BREAK.LVT;
                                    } else if (46216 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 46244) {
                                    if (46217 <= e1 && e1 <= 46243) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 46245) {
                                    if (46244 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (46245 <= e1 && e1 <= 46271) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 46301) {
                                if (e1 < 46273) {
                                    if (46272 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 46300) {
                                    if (46273 <= e1 && e1 <= 46299) return t.CLUSTER_BREAK.LVT;
                                } else if (46300 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 46328) {
                                if (46301 <= e1 && e1 <= 46327) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 46329) {
                                if (46328 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (46329 <= e1 && e1 <= 46355) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 46413) {
                            if (e1 < 46384) {
                                if (e1 < 46357) {
                                    if (46356 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (46357 <= e1 && e1 <= 46383) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 46385) {
                                if (46384 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 46412) {
                                if (46385 <= e1 && e1 <= 46411) return t.CLUSTER_BREAK.LVT;
                            } else if (46412 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 46468) {
                            if (e1 < 46440) {
                                if (46413 <= e1 && e1 <= 46439) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 46441) {
                                if (46440 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (46441 <= e1 && e1 <= 46467) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 46469) {
                            if (46468 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 46496) {
                            if (46469 <= e1 && e1 <= 46495) return t.CLUSTER_BREAK.LVT;
                        } else if (46496 === e1) return t.CLUSTER_BREAK.LV;
                    } else if (e1 < 47701) {
                        if (e1 < 47112) {
                            if (e1 < 46804) {
                                if (e1 < 46637) {
                                    if (e1 < 46580) {
                                        if (e1 < 46525) {
                                            if (e1 < 46524) {
                                                if (46497 <= e1 && e1 <= 46523) return t.CLUSTER_BREAK.LVT;
                                            } else if (46524 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (e1 < 46552) {
                                            if (46525 <= e1 && e1 <= 46551) return t.CLUSTER_BREAK.LVT;
                                        } else if (e1 < 46553) {
                                            if (46552 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (46553 <= e1 && e1 <= 46579) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 46608) {
                                        if (e1 < 46581) {
                                            if (46580 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (46581 <= e1 && e1 <= 46607) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 46609) {
                                        if (46608 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 46636) {
                                        if (46609 <= e1 && e1 <= 46635) return t.CLUSTER_BREAK.LVT;
                                    } else if (46636 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 46720) {
                                    if (e1 < 46665) {
                                        if (e1 < 46664) {
                                            if (46637 <= e1 && e1 <= 46663) return t.CLUSTER_BREAK.LVT;
                                        } else if (46664 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 46692) {
                                        if (46665 <= e1 && e1 <= 46691) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 46693) {
                                        if (46692 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (46693 <= e1 && e1 <= 46719) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 46749) {
                                    if (e1 < 46721) {
                                        if (46720 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 46748) {
                                        if (46721 <= e1 && e1 <= 46747) return t.CLUSTER_BREAK.LVT;
                                    } else if (46748 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 46776) {
                                    if (46749 <= e1 && e1 <= 46775) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 46777) {
                                    if (46776 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (46777 <= e1 && e1 <= 46803) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 46945) {
                                if (e1 < 46861) {
                                    if (e1 < 46832) {
                                        if (e1 < 46805) {
                                            if (46804 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (46805 <= e1 && e1 <= 46831) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 46833) {
                                        if (46832 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 46860) {
                                        if (46833 <= e1 && e1 <= 46859) return t.CLUSTER_BREAK.LVT;
                                    } else if (46860 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 46916) {
                                    if (e1 < 46888) {
                                        if (46861 <= e1 && e1 <= 46887) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 46889) {
                                        if (46888 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (46889 <= e1 && e1 <= 46915) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 46917) {
                                    if (46916 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 46944) {
                                    if (46917 <= e1 && e1 <= 46943) return t.CLUSTER_BREAK.LVT;
                                } else if (46944 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 47028) {
                                if (e1 < 46973) {
                                    if (e1 < 46972) {
                                        if (46945 <= e1 && e1 <= 46971) return t.CLUSTER_BREAK.LVT;
                                    } else if (46972 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 47e3) {
                                    if (46973 <= e1 && e1 <= 46999) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 47001) {
                                    if (47e3 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (47001 <= e1 && e1 <= 47027) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 47057) {
                                if (e1 < 47029) {
                                    if (47028 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 47056) {
                                    if (47029 <= e1 && e1 <= 47055) return t.CLUSTER_BREAK.LVT;
                                } else if (47056 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 47084) {
                                if (47057 <= e1 && e1 <= 47083) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 47085) {
                                if (47084 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (47085 <= e1 && e1 <= 47111) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 47393) {
                            if (e1 < 47252) {
                                if (e1 < 47169) {
                                    if (e1 < 47140) {
                                        if (e1 < 47113) {
                                            if (47112 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (47113 <= e1 && e1 <= 47139) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 47141) {
                                        if (47140 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 47168) {
                                        if (47141 <= e1 && e1 <= 47167) return t.CLUSTER_BREAK.LVT;
                                    } else if (47168 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 47197) {
                                    if (e1 < 47196) {
                                        if (47169 <= e1 && e1 <= 47195) return t.CLUSTER_BREAK.LVT;
                                    } else if (47196 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 47224) {
                                    if (47197 <= e1 && e1 <= 47223) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 47225) {
                                    if (47224 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (47225 <= e1 && e1 <= 47251) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 47309) {
                                if (e1 < 47280) {
                                    if (e1 < 47253) {
                                        if (47252 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (47253 <= e1 && e1 <= 47279) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 47281) {
                                    if (47280 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 47308) {
                                    if (47281 <= e1 && e1 <= 47307) return t.CLUSTER_BREAK.LVT;
                                } else if (47308 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 47364) {
                                if (e1 < 47336) {
                                    if (47309 <= e1 && e1 <= 47335) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 47337) {
                                    if (47336 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (47337 <= e1 && e1 <= 47363) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 47365) {
                                if (47364 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 47392) {
                                if (47365 <= e1 && e1 <= 47391) return t.CLUSTER_BREAK.LVT;
                            } else if (47392 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 47560) {
                            if (e1 < 47476) {
                                if (e1 < 47421) {
                                    if (e1 < 47420) {
                                        if (47393 <= e1 && e1 <= 47419) return t.CLUSTER_BREAK.LVT;
                                    } else if (47420 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 47448) {
                                    if (47421 <= e1 && e1 <= 47447) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 47449) {
                                    if (47448 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (47449 <= e1 && e1 <= 47475) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 47505) {
                                if (e1 < 47477) {
                                    if (47476 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 47504) {
                                    if (47477 <= e1 && e1 <= 47503) return t.CLUSTER_BREAK.LVT;
                                } else if (47504 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 47532) {
                                if (47505 <= e1 && e1 <= 47531) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 47533) {
                                if (47532 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (47533 <= e1 && e1 <= 47559) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 47617) {
                            if (e1 < 47588) {
                                if (e1 < 47561) {
                                    if (47560 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (47561 <= e1 && e1 <= 47587) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 47589) {
                                if (47588 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 47616) {
                                if (47589 <= e1 && e1 <= 47615) return t.CLUSTER_BREAK.LVT;
                            } else if (47616 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 47672) {
                            if (e1 < 47644) {
                                if (47617 <= e1 && e1 <= 47643) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 47645) {
                                if (47644 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (47645 <= e1 && e1 <= 47671) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 47673) {
                            if (47672 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 47700) {
                            if (47673 <= e1 && e1 <= 47699) return t.CLUSTER_BREAK.LVT;
                        } else if (47700 === e1) return t.CLUSTER_BREAK.LV;
                    } else if (e1 < 48316) {
                        if (e1 < 48008) {
                            if (e1 < 47841) {
                                if (e1 < 47784) {
                                    if (e1 < 47729) {
                                        if (e1 < 47728) {
                                            if (47701 <= e1 && e1 <= 47727) return t.CLUSTER_BREAK.LVT;
                                        } else if (47728 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 47756) {
                                        if (47729 <= e1 && e1 <= 47755) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 47757) {
                                        if (47756 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (47757 <= e1 && e1 <= 47783) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 47812) {
                                    if (e1 < 47785) {
                                        if (47784 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (47785 <= e1 && e1 <= 47811) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 47813) {
                                    if (47812 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 47840) {
                                    if (47813 <= e1 && e1 <= 47839) return t.CLUSTER_BREAK.LVT;
                                } else if (47840 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 47924) {
                                if (e1 < 47869) {
                                    if (e1 < 47868) {
                                        if (47841 <= e1 && e1 <= 47867) return t.CLUSTER_BREAK.LVT;
                                    } else if (47868 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 47896) {
                                    if (47869 <= e1 && e1 <= 47895) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 47897) {
                                    if (47896 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (47897 <= e1 && e1 <= 47923) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 47953) {
                                if (e1 < 47925) {
                                    if (47924 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 47952) {
                                    if (47925 <= e1 && e1 <= 47951) return t.CLUSTER_BREAK.LVT;
                                } else if (47952 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 47980) {
                                if (47953 <= e1 && e1 <= 47979) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 47981) {
                                if (47980 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (47981 <= e1 && e1 <= 48007) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 48149) {
                            if (e1 < 48065) {
                                if (e1 < 48036) {
                                    if (e1 < 48009) {
                                        if (48008 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (48009 <= e1 && e1 <= 48035) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 48037) {
                                    if (48036 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 48064) {
                                    if (48037 <= e1 && e1 <= 48063) return t.CLUSTER_BREAK.LVT;
                                } else if (48064 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 48120) {
                                if (e1 < 48092) {
                                    if (48065 <= e1 && e1 <= 48091) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 48093) {
                                    if (48092 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (48093 <= e1 && e1 <= 48119) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 48121) {
                                if (48120 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 48148) {
                                if (48121 <= e1 && e1 <= 48147) return t.CLUSTER_BREAK.LVT;
                            } else if (48148 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 48232) {
                            if (e1 < 48177) {
                                if (e1 < 48176) {
                                    if (48149 <= e1 && e1 <= 48175) return t.CLUSTER_BREAK.LVT;
                                } else if (48176 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 48204) {
                                if (48177 <= e1 && e1 <= 48203) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 48205) {
                                if (48204 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (48205 <= e1 && e1 <= 48231) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 48261) {
                            if (e1 < 48233) {
                                if (48232 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 48260) {
                                if (48233 <= e1 && e1 <= 48259) return t.CLUSTER_BREAK.LVT;
                            } else if (48260 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 48288) {
                            if (48261 <= e1 && e1 <= 48287) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 48289) {
                            if (48288 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (48289 <= e1 && e1 <= 48315) return t.CLUSTER_BREAK.LVT;
                    } else if (e1 < 48597) {
                        if (e1 < 48456) {
                            if (e1 < 48373) {
                                if (e1 < 48344) {
                                    if (e1 < 48317) {
                                        if (48316 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (48317 <= e1 && e1 <= 48343) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 48345) {
                                    if (48344 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 48372) {
                                    if (48345 <= e1 && e1 <= 48371) return t.CLUSTER_BREAK.LVT;
                                } else if (48372 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 48401) {
                                if (e1 < 48400) {
                                    if (48373 <= e1 && e1 <= 48399) return t.CLUSTER_BREAK.LVT;
                                } else if (48400 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 48428) {
                                if (48401 <= e1 && e1 <= 48427) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 48429) {
                                if (48428 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (48429 <= e1 && e1 <= 48455) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 48513) {
                            if (e1 < 48484) {
                                if (e1 < 48457) {
                                    if (48456 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (48457 <= e1 && e1 <= 48483) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 48485) {
                                if (48484 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 48512) {
                                if (48485 <= e1 && e1 <= 48511) return t.CLUSTER_BREAK.LVT;
                            } else if (48512 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 48568) {
                            if (e1 < 48540) {
                                if (48513 <= e1 && e1 <= 48539) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 48541) {
                                if (48540 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (48541 <= e1 && e1 <= 48567) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 48569) {
                            if (48568 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 48596) {
                            if (48569 <= e1 && e1 <= 48595) return t.CLUSTER_BREAK.LVT;
                        } else if (48596 === e1) return t.CLUSTER_BREAK.LV;
                    } else if (e1 < 48764) {
                        if (e1 < 48680) {
                            if (e1 < 48625) {
                                if (e1 < 48624) {
                                    if (48597 <= e1 && e1 <= 48623) return t.CLUSTER_BREAK.LVT;
                                } else if (48624 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 48652) {
                                if (48625 <= e1 && e1 <= 48651) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 48653) {
                                if (48652 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (48653 <= e1 && e1 <= 48679) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 48709) {
                            if (e1 < 48681) {
                                if (48680 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 48708) {
                                if (48681 <= e1 && e1 <= 48707) return t.CLUSTER_BREAK.LVT;
                            } else if (48708 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 48736) {
                            if (48709 <= e1 && e1 <= 48735) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 48737) {
                            if (48736 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (48737 <= e1 && e1 <= 48763) return t.CLUSTER_BREAK.LVT;
                    } else if (e1 < 48821) {
                        if (e1 < 48792) {
                            if (e1 < 48765) {
                                if (48764 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (48765 <= e1 && e1 <= 48791) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 48793) {
                            if (48792 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 48820) {
                            if (48793 <= e1 && e1 <= 48819) return t.CLUSTER_BREAK.LVT;
                        } else if (48820 === e1) return t.CLUSTER_BREAK.LV;
                    } else if (e1 < 48876) {
                        if (e1 < 48848) {
                            if (48821 <= e1 && e1 <= 48847) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 48849) {
                            if (48848 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (48849 <= e1 && e1 <= 48875) return t.CLUSTER_BREAK.LVT;
                    } else if (e1 < 48877) {
                        if (48876 === e1) return t.CLUSTER_BREAK.LV;
                    } else if (e1 < 48904) {
                        if (48877 <= e1 && e1 <= 48903) return t.CLUSTER_BREAK.LVT;
                    } else if (48904 === e1) return t.CLUSTER_BREAK.LV;
                } else if (e1 < 53720) {
                    if (e1 < 51312) {
                        if (e1 < 50108) {
                            if (e1 < 49493) {
                                if (e1 < 49212) {
                                    if (e1 < 49045) {
                                        if (e1 < 48988) {
                                            if (e1 < 48933) {
                                                if (e1 < 48932) {
                                                    if (48905 <= e1 && e1 <= 48931) return t.CLUSTER_BREAK.LVT;
                                                } else if (48932 === e1) return t.CLUSTER_BREAK.LV;
                                            } else if (e1 < 48960) {
                                                if (48933 <= e1 && e1 <= 48959) return t.CLUSTER_BREAK.LVT;
                                            } else if (e1 < 48961) {
                                                if (48960 === e1) return t.CLUSTER_BREAK.LV;
                                            } else if (48961 <= e1 && e1 <= 48987) return t.CLUSTER_BREAK.LVT;
                                        } else if (e1 < 49016) {
                                            if (e1 < 48989) {
                                                if (48988 === e1) return t.CLUSTER_BREAK.LV;
                                            } else if (48989 <= e1 && e1 <= 49015) return t.CLUSTER_BREAK.LVT;
                                        } else if (e1 < 49017) {
                                            if (49016 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (e1 < 49044) {
                                            if (49017 <= e1 && e1 <= 49043) return t.CLUSTER_BREAK.LVT;
                                        } else if (49044 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 49128) {
                                        if (e1 < 49073) {
                                            if (e1 < 49072) {
                                                if (49045 <= e1 && e1 <= 49071) return t.CLUSTER_BREAK.LVT;
                                            } else if (49072 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (e1 < 49100) {
                                            if (49073 <= e1 && e1 <= 49099) return t.CLUSTER_BREAK.LVT;
                                        } else if (e1 < 49101) {
                                            if (49100 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (49101 <= e1 && e1 <= 49127) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 49157) {
                                        if (e1 < 49129) {
                                            if (49128 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (e1 < 49156) {
                                            if (49129 <= e1 && e1 <= 49155) return t.CLUSTER_BREAK.LVT;
                                        } else if (49156 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 49184) {
                                        if (49157 <= e1 && e1 <= 49183) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 49185) {
                                        if (49184 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (49185 <= e1 && e1 <= 49211) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 49352) {
                                    if (e1 < 49269) {
                                        if (e1 < 49240) {
                                            if (e1 < 49213) {
                                                if (49212 === e1) return t.CLUSTER_BREAK.LV;
                                            } else if (49213 <= e1 && e1 <= 49239) return t.CLUSTER_BREAK.LVT;
                                        } else if (e1 < 49241) {
                                            if (49240 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (e1 < 49268) {
                                            if (49241 <= e1 && e1 <= 49267) return t.CLUSTER_BREAK.LVT;
                                        } else if (49268 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 49297) {
                                        if (e1 < 49296) {
                                            if (49269 <= e1 && e1 <= 49295) return t.CLUSTER_BREAK.LVT;
                                        } else if (49296 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 49324) {
                                        if (49297 <= e1 && e1 <= 49323) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 49325) {
                                        if (49324 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (49325 <= e1 && e1 <= 49351) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 49409) {
                                    if (e1 < 49380) {
                                        if (e1 < 49353) {
                                            if (49352 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (49353 <= e1 && e1 <= 49379) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 49381) {
                                        if (49380 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 49408) {
                                        if (49381 <= e1 && e1 <= 49407) return t.CLUSTER_BREAK.LVT;
                                    } else if (49408 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 49464) {
                                    if (e1 < 49436) {
                                        if (49409 <= e1 && e1 <= 49435) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 49437) {
                                        if (49436 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (49437 <= e1 && e1 <= 49463) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 49465) {
                                    if (49464 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 49492) {
                                    if (49465 <= e1 && e1 <= 49491) return t.CLUSTER_BREAK.LVT;
                                } else if (49492 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 49800) {
                                if (e1 < 49633) {
                                    if (e1 < 49576) {
                                        if (e1 < 49521) {
                                            if (e1 < 49520) {
                                                if (49493 <= e1 && e1 <= 49519) return t.CLUSTER_BREAK.LVT;
                                            } else if (49520 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (e1 < 49548) {
                                            if (49521 <= e1 && e1 <= 49547) return t.CLUSTER_BREAK.LVT;
                                        } else if (e1 < 49549) {
                                            if (49548 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (49549 <= e1 && e1 <= 49575) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 49604) {
                                        if (e1 < 49577) {
                                            if (49576 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (49577 <= e1 && e1 <= 49603) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 49605) {
                                        if (49604 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 49632) {
                                        if (49605 <= e1 && e1 <= 49631) return t.CLUSTER_BREAK.LVT;
                                    } else if (49632 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 49716) {
                                    if (e1 < 49661) {
                                        if (e1 < 49660) {
                                            if (49633 <= e1 && e1 <= 49659) return t.CLUSTER_BREAK.LVT;
                                        } else if (49660 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 49688) {
                                        if (49661 <= e1 && e1 <= 49687) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 49689) {
                                        if (49688 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (49689 <= e1 && e1 <= 49715) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 49745) {
                                    if (e1 < 49717) {
                                        if (49716 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 49744) {
                                        if (49717 <= e1 && e1 <= 49743) return t.CLUSTER_BREAK.LVT;
                                    } else if (49744 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 49772) {
                                    if (49745 <= e1 && e1 <= 49771) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 49773) {
                                    if (49772 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (49773 <= e1 && e1 <= 49799) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 49941) {
                                if (e1 < 49857) {
                                    if (e1 < 49828) {
                                        if (e1 < 49801) {
                                            if (49800 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (49801 <= e1 && e1 <= 49827) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 49829) {
                                        if (49828 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 49856) {
                                        if (49829 <= e1 && e1 <= 49855) return t.CLUSTER_BREAK.LVT;
                                    } else if (49856 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 49912) {
                                    if (e1 < 49884) {
                                        if (49857 <= e1 && e1 <= 49883) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 49885) {
                                        if (49884 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (49885 <= e1 && e1 <= 49911) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 49913) {
                                    if (49912 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 49940) {
                                    if (49913 <= e1 && e1 <= 49939) return t.CLUSTER_BREAK.LVT;
                                } else if (49940 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 50024) {
                                if (e1 < 49969) {
                                    if (e1 < 49968) {
                                        if (49941 <= e1 && e1 <= 49967) return t.CLUSTER_BREAK.LVT;
                                    } else if (49968 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 49996) {
                                    if (49969 <= e1 && e1 <= 49995) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 49997) {
                                    if (49996 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (49997 <= e1 && e1 <= 50023) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 50053) {
                                if (e1 < 50025) {
                                    if (50024 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 50052) {
                                    if (50025 <= e1 && e1 <= 50051) return t.CLUSTER_BREAK.LVT;
                                } else if (50052 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 50080) {
                                if (50053 <= e1 && e1 <= 50079) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 50081) {
                                if (50080 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (50081 <= e1 && e1 <= 50107) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 50697) {
                            if (e1 < 50389) {
                                if (e1 < 50248) {
                                    if (e1 < 50165) {
                                        if (e1 < 50136) {
                                            if (e1 < 50109) {
                                                if (50108 === e1) return t.CLUSTER_BREAK.LV;
                                            } else if (50109 <= e1 && e1 <= 50135) return t.CLUSTER_BREAK.LVT;
                                        } else if (e1 < 50137) {
                                            if (50136 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (e1 < 50164) {
                                            if (50137 <= e1 && e1 <= 50163) return t.CLUSTER_BREAK.LVT;
                                        } else if (50164 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 50193) {
                                        if (e1 < 50192) {
                                            if (50165 <= e1 && e1 <= 50191) return t.CLUSTER_BREAK.LVT;
                                        } else if (50192 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 50220) {
                                        if (50193 <= e1 && e1 <= 50219) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 50221) {
                                        if (50220 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (50221 <= e1 && e1 <= 50247) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 50305) {
                                    if (e1 < 50276) {
                                        if (e1 < 50249) {
                                            if (50248 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (50249 <= e1 && e1 <= 50275) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 50277) {
                                        if (50276 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 50304) {
                                        if (50277 <= e1 && e1 <= 50303) return t.CLUSTER_BREAK.LVT;
                                    } else if (50304 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 50360) {
                                    if (e1 < 50332) {
                                        if (50305 <= e1 && e1 <= 50331) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 50333) {
                                        if (50332 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (50333 <= e1 && e1 <= 50359) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 50361) {
                                    if (50360 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 50388) {
                                    if (50361 <= e1 && e1 <= 50387) return t.CLUSTER_BREAK.LVT;
                                } else if (50388 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 50556) {
                                if (e1 < 50472) {
                                    if (e1 < 50417) {
                                        if (e1 < 50416) {
                                            if (50389 <= e1 && e1 <= 50415) return t.CLUSTER_BREAK.LVT;
                                        } else if (50416 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 50444) {
                                        if (50417 <= e1 && e1 <= 50443) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 50445) {
                                        if (50444 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (50445 <= e1 && e1 <= 50471) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 50501) {
                                    if (e1 < 50473) {
                                        if (50472 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 50500) {
                                        if (50473 <= e1 && e1 <= 50499) return t.CLUSTER_BREAK.LVT;
                                    } else if (50500 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 50528) {
                                    if (50501 <= e1 && e1 <= 50527) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 50529) {
                                    if (50528 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (50529 <= e1 && e1 <= 50555) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 50613) {
                                if (e1 < 50584) {
                                    if (e1 < 50557) {
                                        if (50556 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (50557 <= e1 && e1 <= 50583) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 50585) {
                                    if (50584 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 50612) {
                                    if (50585 <= e1 && e1 <= 50611) return t.CLUSTER_BREAK.LVT;
                                } else if (50612 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 50668) {
                                if (e1 < 50640) {
                                    if (50613 <= e1 && e1 <= 50639) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 50641) {
                                    if (50640 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (50641 <= e1 && e1 <= 50667) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 50669) {
                                if (50668 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 50696) {
                                if (50669 <= e1 && e1 <= 50695) return t.CLUSTER_BREAK.LVT;
                            } else if (50696 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 51004) {
                            if (e1 < 50837) {
                                if (e1 < 50780) {
                                    if (e1 < 50725) {
                                        if (e1 < 50724) {
                                            if (50697 <= e1 && e1 <= 50723) return t.CLUSTER_BREAK.LVT;
                                        } else if (50724 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 50752) {
                                        if (50725 <= e1 && e1 <= 50751) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 50753) {
                                        if (50752 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (50753 <= e1 && e1 <= 50779) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 50808) {
                                    if (e1 < 50781) {
                                        if (50780 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (50781 <= e1 && e1 <= 50807) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 50809) {
                                    if (50808 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 50836) {
                                    if (50809 <= e1 && e1 <= 50835) return t.CLUSTER_BREAK.LVT;
                                } else if (50836 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 50920) {
                                if (e1 < 50865) {
                                    if (e1 < 50864) {
                                        if (50837 <= e1 && e1 <= 50863) return t.CLUSTER_BREAK.LVT;
                                    } else if (50864 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 50892) {
                                    if (50865 <= e1 && e1 <= 50891) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 50893) {
                                    if (50892 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (50893 <= e1 && e1 <= 50919) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 50949) {
                                if (e1 < 50921) {
                                    if (50920 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 50948) {
                                    if (50921 <= e1 && e1 <= 50947) return t.CLUSTER_BREAK.LVT;
                                } else if (50948 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 50976) {
                                if (50949 <= e1 && e1 <= 50975) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 50977) {
                                if (50976 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (50977 <= e1 && e1 <= 51003) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 51145) {
                            if (e1 < 51061) {
                                if (e1 < 51032) {
                                    if (e1 < 51005) {
                                        if (51004 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (51005 <= e1 && e1 <= 51031) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 51033) {
                                    if (51032 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 51060) {
                                    if (51033 <= e1 && e1 <= 51059) return t.CLUSTER_BREAK.LVT;
                                } else if (51060 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 51116) {
                                if (e1 < 51088) {
                                    if (51061 <= e1 && e1 <= 51087) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 51089) {
                                    if (51088 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (51089 <= e1 && e1 <= 51115) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 51117) {
                                if (51116 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 51144) {
                                if (51117 <= e1 && e1 <= 51143) return t.CLUSTER_BREAK.LVT;
                            } else if (51144 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 51228) {
                            if (e1 < 51173) {
                                if (e1 < 51172) {
                                    if (51145 <= e1 && e1 <= 51171) return t.CLUSTER_BREAK.LVT;
                                } else if (51172 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 51200) {
                                if (51173 <= e1 && e1 <= 51199) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 51201) {
                                if (51200 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (51201 <= e1 && e1 <= 51227) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 51257) {
                            if (e1 < 51229) {
                                if (51228 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 51256) {
                                if (51229 <= e1 && e1 <= 51255) return t.CLUSTER_BREAK.LVT;
                            } else if (51256 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 51284) {
                            if (51257 <= e1 && e1 <= 51283) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 51285) {
                            if (51284 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (51285 <= e1 && e1 <= 51311) return t.CLUSTER_BREAK.LVT;
                    } else if (e1 < 52516) {
                        if (e1 < 51901) {
                            if (e1 < 51593) {
                                if (e1 < 51452) {
                                    if (e1 < 51369) {
                                        if (e1 < 51340) {
                                            if (e1 < 51313) {
                                                if (51312 === e1) return t.CLUSTER_BREAK.LV;
                                            } else if (51313 <= e1 && e1 <= 51339) return t.CLUSTER_BREAK.LVT;
                                        } else if (e1 < 51341) {
                                            if (51340 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (e1 < 51368) {
                                            if (51341 <= e1 && e1 <= 51367) return t.CLUSTER_BREAK.LVT;
                                        } else if (51368 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 51397) {
                                        if (e1 < 51396) {
                                            if (51369 <= e1 && e1 <= 51395) return t.CLUSTER_BREAK.LVT;
                                        } else if (51396 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 51424) {
                                        if (51397 <= e1 && e1 <= 51423) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 51425) {
                                        if (51424 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (51425 <= e1 && e1 <= 51451) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 51509) {
                                    if (e1 < 51480) {
                                        if (e1 < 51453) {
                                            if (51452 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (51453 <= e1 && e1 <= 51479) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 51481) {
                                        if (51480 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 51508) {
                                        if (51481 <= e1 && e1 <= 51507) return t.CLUSTER_BREAK.LVT;
                                    } else if (51508 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 51564) {
                                    if (e1 < 51536) {
                                        if (51509 <= e1 && e1 <= 51535) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 51537) {
                                        if (51536 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (51537 <= e1 && e1 <= 51563) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 51565) {
                                    if (51564 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 51592) {
                                    if (51565 <= e1 && e1 <= 51591) return t.CLUSTER_BREAK.LVT;
                                } else if (51592 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 51760) {
                                if (e1 < 51676) {
                                    if (e1 < 51621) {
                                        if (e1 < 51620) {
                                            if (51593 <= e1 && e1 <= 51619) return t.CLUSTER_BREAK.LVT;
                                        } else if (51620 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 51648) {
                                        if (51621 <= e1 && e1 <= 51647) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 51649) {
                                        if (51648 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (51649 <= e1 && e1 <= 51675) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 51705) {
                                    if (e1 < 51677) {
                                        if (51676 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 51704) {
                                        if (51677 <= e1 && e1 <= 51703) return t.CLUSTER_BREAK.LVT;
                                    } else if (51704 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 51732) {
                                    if (51705 <= e1 && e1 <= 51731) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 51733) {
                                    if (51732 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (51733 <= e1 && e1 <= 51759) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 51817) {
                                if (e1 < 51788) {
                                    if (e1 < 51761) {
                                        if (51760 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (51761 <= e1 && e1 <= 51787) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 51789) {
                                    if (51788 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 51816) {
                                    if (51789 <= e1 && e1 <= 51815) return t.CLUSTER_BREAK.LVT;
                                } else if (51816 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 51872) {
                                if (e1 < 51844) {
                                    if (51817 <= e1 && e1 <= 51843) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 51845) {
                                    if (51844 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (51845 <= e1 && e1 <= 51871) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 51873) {
                                if (51872 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 51900) {
                                if (51873 <= e1 && e1 <= 51899) return t.CLUSTER_BREAK.LVT;
                            } else if (51900 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 52208) {
                            if (e1 < 52041) {
                                if (e1 < 51984) {
                                    if (e1 < 51929) {
                                        if (e1 < 51928) {
                                            if (51901 <= e1 && e1 <= 51927) return t.CLUSTER_BREAK.LVT;
                                        } else if (51928 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 51956) {
                                        if (51929 <= e1 && e1 <= 51955) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 51957) {
                                        if (51956 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (51957 <= e1 && e1 <= 51983) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 52012) {
                                    if (e1 < 51985) {
                                        if (51984 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (51985 <= e1 && e1 <= 52011) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 52013) {
                                    if (52012 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 52040) {
                                    if (52013 <= e1 && e1 <= 52039) return t.CLUSTER_BREAK.LVT;
                                } else if (52040 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 52124) {
                                if (e1 < 52069) {
                                    if (e1 < 52068) {
                                        if (52041 <= e1 && e1 <= 52067) return t.CLUSTER_BREAK.LVT;
                                    } else if (52068 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 52096) {
                                    if (52069 <= e1 && e1 <= 52095) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 52097) {
                                    if (52096 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (52097 <= e1 && e1 <= 52123) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 52153) {
                                if (e1 < 52125) {
                                    if (52124 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 52152) {
                                    if (52125 <= e1 && e1 <= 52151) return t.CLUSTER_BREAK.LVT;
                                } else if (52152 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 52180) {
                                if (52153 <= e1 && e1 <= 52179) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 52181) {
                                if (52180 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (52181 <= e1 && e1 <= 52207) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 52349) {
                            if (e1 < 52265) {
                                if (e1 < 52236) {
                                    if (e1 < 52209) {
                                        if (52208 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (52209 <= e1 && e1 <= 52235) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 52237) {
                                    if (52236 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 52264) {
                                    if (52237 <= e1 && e1 <= 52263) return t.CLUSTER_BREAK.LVT;
                                } else if (52264 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 52320) {
                                if (e1 < 52292) {
                                    if (52265 <= e1 && e1 <= 52291) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 52293) {
                                    if (52292 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (52293 <= e1 && e1 <= 52319) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 52321) {
                                if (52320 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 52348) {
                                if (52321 <= e1 && e1 <= 52347) return t.CLUSTER_BREAK.LVT;
                            } else if (52348 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 52432) {
                            if (e1 < 52377) {
                                if (e1 < 52376) {
                                    if (52349 <= e1 && e1 <= 52375) return t.CLUSTER_BREAK.LVT;
                                } else if (52376 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 52404) {
                                if (52377 <= e1 && e1 <= 52403) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 52405) {
                                if (52404 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (52405 <= e1 && e1 <= 52431) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 52461) {
                            if (e1 < 52433) {
                                if (52432 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 52460) {
                                if (52433 <= e1 && e1 <= 52459) return t.CLUSTER_BREAK.LVT;
                            } else if (52460 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 52488) {
                            if (52461 <= e1 && e1 <= 52487) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 52489) {
                            if (52488 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (52489 <= e1 && e1 <= 52515) return t.CLUSTER_BREAK.LVT;
                    } else if (e1 < 53105) {
                        if (e1 < 52797) {
                            if (e1 < 52656) {
                                if (e1 < 52573) {
                                    if (e1 < 52544) {
                                        if (e1 < 52517) {
                                            if (52516 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (52517 <= e1 && e1 <= 52543) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 52545) {
                                        if (52544 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 52572) {
                                        if (52545 <= e1 && e1 <= 52571) return t.CLUSTER_BREAK.LVT;
                                    } else if (52572 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 52601) {
                                    if (e1 < 52600) {
                                        if (52573 <= e1 && e1 <= 52599) return t.CLUSTER_BREAK.LVT;
                                    } else if (52600 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 52628) {
                                    if (52601 <= e1 && e1 <= 52627) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 52629) {
                                    if (52628 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (52629 <= e1 && e1 <= 52655) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 52713) {
                                if (e1 < 52684) {
                                    if (e1 < 52657) {
                                        if (52656 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (52657 <= e1 && e1 <= 52683) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 52685) {
                                    if (52684 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 52712) {
                                    if (52685 <= e1 && e1 <= 52711) return t.CLUSTER_BREAK.LVT;
                                } else if (52712 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 52768) {
                                if (e1 < 52740) {
                                    if (52713 <= e1 && e1 <= 52739) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 52741) {
                                    if (52740 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (52741 <= e1 && e1 <= 52767) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 52769) {
                                if (52768 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 52796) {
                                if (52769 <= e1 && e1 <= 52795) return t.CLUSTER_BREAK.LVT;
                            } else if (52796 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 52964) {
                            if (e1 < 52880) {
                                if (e1 < 52825) {
                                    if (e1 < 52824) {
                                        if (52797 <= e1 && e1 <= 52823) return t.CLUSTER_BREAK.LVT;
                                    } else if (52824 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 52852) {
                                    if (52825 <= e1 && e1 <= 52851) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 52853) {
                                    if (52852 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (52853 <= e1 && e1 <= 52879) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 52909) {
                                if (e1 < 52881) {
                                    if (52880 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 52908) {
                                    if (52881 <= e1 && e1 <= 52907) return t.CLUSTER_BREAK.LVT;
                                } else if (52908 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 52936) {
                                if (52909 <= e1 && e1 <= 52935) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 52937) {
                                if (52936 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (52937 <= e1 && e1 <= 52963) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 53021) {
                            if (e1 < 52992) {
                                if (e1 < 52965) {
                                    if (52964 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (52965 <= e1 && e1 <= 52991) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 52993) {
                                if (52992 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 53020) {
                                if (52993 <= e1 && e1 <= 53019) return t.CLUSTER_BREAK.LVT;
                            } else if (53020 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 53076) {
                            if (e1 < 53048) {
                                if (53021 <= e1 && e1 <= 53047) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 53049) {
                                if (53048 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (53049 <= e1 && e1 <= 53075) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 53077) {
                            if (53076 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 53104) {
                            if (53077 <= e1 && e1 <= 53103) return t.CLUSTER_BREAK.LVT;
                        } else if (53104 === e1) return t.CLUSTER_BREAK.LV;
                    } else if (e1 < 53412) {
                        if (e1 < 53245) {
                            if (e1 < 53188) {
                                if (e1 < 53133) {
                                    if (e1 < 53132) {
                                        if (53105 <= e1 && e1 <= 53131) return t.CLUSTER_BREAK.LVT;
                                    } else if (53132 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 53160) {
                                    if (53133 <= e1 && e1 <= 53159) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 53161) {
                                    if (53160 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (53161 <= e1 && e1 <= 53187) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 53216) {
                                if (e1 < 53189) {
                                    if (53188 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (53189 <= e1 && e1 <= 53215) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 53217) {
                                if (53216 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 53244) {
                                if (53217 <= e1 && e1 <= 53243) return t.CLUSTER_BREAK.LVT;
                            } else if (53244 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 53328) {
                            if (e1 < 53273) {
                                if (e1 < 53272) {
                                    if (53245 <= e1 && e1 <= 53271) return t.CLUSTER_BREAK.LVT;
                                } else if (53272 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 53300) {
                                if (53273 <= e1 && e1 <= 53299) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 53301) {
                                if (53300 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (53301 <= e1 && e1 <= 53327) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 53357) {
                            if (e1 < 53329) {
                                if (53328 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 53356) {
                                if (53329 <= e1 && e1 <= 53355) return t.CLUSTER_BREAK.LVT;
                            } else if (53356 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 53384) {
                            if (53357 <= e1 && e1 <= 53383) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 53385) {
                            if (53384 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (53385 <= e1 && e1 <= 53411) return t.CLUSTER_BREAK.LVT;
                    } else if (e1 < 53553) {
                        if (e1 < 53469) {
                            if (e1 < 53440) {
                                if (e1 < 53413) {
                                    if (53412 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (53413 <= e1 && e1 <= 53439) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 53441) {
                                if (53440 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 53468) {
                                if (53441 <= e1 && e1 <= 53467) return t.CLUSTER_BREAK.LVT;
                            } else if (53468 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 53524) {
                            if (e1 < 53496) {
                                if (53469 <= e1 && e1 <= 53495) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 53497) {
                                if (53496 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (53497 <= e1 && e1 <= 53523) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 53525) {
                            if (53524 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 53552) {
                            if (53525 <= e1 && e1 <= 53551) return t.CLUSTER_BREAK.LVT;
                        } else if (53552 === e1) return t.CLUSTER_BREAK.LV;
                    } else if (e1 < 53636) {
                        if (e1 < 53581) {
                            if (e1 < 53580) {
                                if (53553 <= e1 && e1 <= 53579) return t.CLUSTER_BREAK.LVT;
                            } else if (53580 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 53608) {
                            if (53581 <= e1 && e1 <= 53607) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 53609) {
                            if (53608 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (53609 <= e1 && e1 <= 53635) return t.CLUSTER_BREAK.LVT;
                    } else if (e1 < 53665) {
                        if (e1 < 53637) {
                            if (53636 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 53664) {
                            if (53637 <= e1 && e1 <= 53663) return t.CLUSTER_BREAK.LVT;
                        } else if (53664 === e1) return t.CLUSTER_BREAK.LV;
                    } else if (e1 < 53692) {
                        if (53665 <= e1 && e1 <= 53691) return t.CLUSTER_BREAK.LVT;
                    } else if (e1 < 53693) {
                        if (53692 === e1) return t.CLUSTER_BREAK.LV;
                    } else if (53693 <= e1 && e1 <= 53719) return t.CLUSTER_BREAK.LVT;
                } else if (e1 < 70459) {
                    if (e1 < 54897) {
                        if (e1 < 54308) {
                            if (e1 < 54001) {
                                if (e1 < 53860) {
                                    if (e1 < 53777) {
                                        if (e1 < 53748) {
                                            if (e1 < 53721) {
                                                if (53720 === e1) return t.CLUSTER_BREAK.LV;
                                            } else if (53721 <= e1 && e1 <= 53747) return t.CLUSTER_BREAK.LVT;
                                        } else if (e1 < 53749) {
                                            if (53748 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (e1 < 53776) {
                                            if (53749 <= e1 && e1 <= 53775) return t.CLUSTER_BREAK.LVT;
                                        } else if (53776 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 53805) {
                                        if (e1 < 53804) {
                                            if (53777 <= e1 && e1 <= 53803) return t.CLUSTER_BREAK.LVT;
                                        } else if (53804 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 53832) {
                                        if (53805 <= e1 && e1 <= 53831) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 53833) {
                                        if (53832 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (53833 <= e1 && e1 <= 53859) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 53917) {
                                    if (e1 < 53888) {
                                        if (e1 < 53861) {
                                            if (53860 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (53861 <= e1 && e1 <= 53887) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 53889) {
                                        if (53888 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 53916) {
                                        if (53889 <= e1 && e1 <= 53915) return t.CLUSTER_BREAK.LVT;
                                    } else if (53916 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 53972) {
                                    if (e1 < 53944) {
                                        if (53917 <= e1 && e1 <= 53943) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 53945) {
                                        if (53944 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (53945 <= e1 && e1 <= 53971) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 53973) {
                                    if (53972 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 54e3) {
                                    if (53973 <= e1 && e1 <= 53999) return t.CLUSTER_BREAK.LVT;
                                } else if (54e3 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 54141) {
                                if (e1 < 54084) {
                                    if (e1 < 54029) {
                                        if (e1 < 54028) {
                                            if (54001 <= e1 && e1 <= 54027) return t.CLUSTER_BREAK.LVT;
                                        } else if (54028 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 54056) {
                                        if (54029 <= e1 && e1 <= 54055) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 54057) {
                                        if (54056 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (54057 <= e1 && e1 <= 54083) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 54112) {
                                    if (e1 < 54085) {
                                        if (54084 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (54085 <= e1 && e1 <= 54111) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 54113) {
                                    if (54112 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 54140) {
                                    if (54113 <= e1 && e1 <= 54139) return t.CLUSTER_BREAK.LVT;
                                } else if (54140 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 54224) {
                                if (e1 < 54169) {
                                    if (e1 < 54168) {
                                        if (54141 <= e1 && e1 <= 54167) return t.CLUSTER_BREAK.LVT;
                                    } else if (54168 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 54196) {
                                    if (54169 <= e1 && e1 <= 54195) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 54197) {
                                    if (54196 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (54197 <= e1 && e1 <= 54223) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 54253) {
                                if (e1 < 54225) {
                                    if (54224 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 54252) {
                                    if (54225 <= e1 && e1 <= 54251) return t.CLUSTER_BREAK.LVT;
                                } else if (54252 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 54280) {
                                if (54253 <= e1 && e1 <= 54279) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 54281) {
                                if (54280 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (54281 <= e1 && e1 <= 54307) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 54589) {
                            if (e1 < 54448) {
                                if (e1 < 54365) {
                                    if (e1 < 54336) {
                                        if (e1 < 54309) {
                                            if (54308 === e1) return t.CLUSTER_BREAK.LV;
                                        } else if (54309 <= e1 && e1 <= 54335) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 54337) {
                                        if (54336 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 54364) {
                                        if (54337 <= e1 && e1 <= 54363) return t.CLUSTER_BREAK.LVT;
                                    } else if (54364 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 54393) {
                                    if (e1 < 54392) {
                                        if (54365 <= e1 && e1 <= 54391) return t.CLUSTER_BREAK.LVT;
                                    } else if (54392 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 54420) {
                                    if (54393 <= e1 && e1 <= 54419) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 54421) {
                                    if (54420 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (54421 <= e1 && e1 <= 54447) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 54505) {
                                if (e1 < 54476) {
                                    if (e1 < 54449) {
                                        if (54448 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (54449 <= e1 && e1 <= 54475) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 54477) {
                                    if (54476 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 54504) {
                                    if (54477 <= e1 && e1 <= 54503) return t.CLUSTER_BREAK.LVT;
                                } else if (54504 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 54560) {
                                if (e1 < 54532) {
                                    if (54505 <= e1 && e1 <= 54531) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 54533) {
                                    if (54532 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (54533 <= e1 && e1 <= 54559) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 54561) {
                                if (54560 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 54588) {
                                if (54561 <= e1 && e1 <= 54587) return t.CLUSTER_BREAK.LVT;
                            } else if (54588 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 54756) {
                            if (e1 < 54672) {
                                if (e1 < 54617) {
                                    if (e1 < 54616) {
                                        if (54589 <= e1 && e1 <= 54615) return t.CLUSTER_BREAK.LVT;
                                    } else if (54616 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 54644) {
                                    if (54617 <= e1 && e1 <= 54643) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 54645) {
                                    if (54644 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (54645 <= e1 && e1 <= 54671) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 54701) {
                                if (e1 < 54673) {
                                    if (54672 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 54700) {
                                    if (54673 <= e1 && e1 <= 54699) return t.CLUSTER_BREAK.LVT;
                                } else if (54700 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 54728) {
                                if (54701 <= e1 && e1 <= 54727) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 54729) {
                                if (54728 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (54729 <= e1 && e1 <= 54755) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 54813) {
                            if (e1 < 54784) {
                                if (e1 < 54757) {
                                    if (54756 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (54757 <= e1 && e1 <= 54783) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 54785) {
                                if (54784 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 54812) {
                                if (54785 <= e1 && e1 <= 54811) return t.CLUSTER_BREAK.LVT;
                            } else if (54812 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 54868) {
                            if (e1 < 54840) {
                                if (54813 <= e1 && e1 <= 54839) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 54841) {
                                if (54840 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (54841 <= e1 && e1 <= 54867) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 54869) {
                            if (54868 === e1) return t.CLUSTER_BREAK.LV;
                        } else if (e1 < 54896) {
                            if (54869 <= e1 && e1 <= 54895) return t.CLUSTER_BREAK.LVT;
                        } else if (54896 === e1) return t.CLUSTER_BREAK.LV;
                    } else if (e1 < 69632) {
                        if (e1 < 55216) {
                            if (e1 < 55037) {
                                if (e1 < 54980) {
                                    if (e1 < 54925) {
                                        if (e1 < 54924) {
                                            if (54897 <= e1 && e1 <= 54923) return t.CLUSTER_BREAK.LVT;
                                        } else if (54924 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (e1 < 54952) {
                                        if (54925 <= e1 && e1 <= 54951) return t.CLUSTER_BREAK.LVT;
                                    } else if (e1 < 54953) {
                                        if (54952 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (54953 <= e1 && e1 <= 54979) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 55008) {
                                    if (e1 < 54981) {
                                        if (54980 === e1) return t.CLUSTER_BREAK.LV;
                                    } else if (54981 <= e1 && e1 <= 55007) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 55009) {
                                    if (55008 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 55036) {
                                    if (55009 <= e1 && e1 <= 55035) return t.CLUSTER_BREAK.LVT;
                                } else if (55036 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 55120) {
                                if (e1 < 55065) {
                                    if (e1 < 55064) {
                                        if (55037 <= e1 && e1 <= 55063) return t.CLUSTER_BREAK.LVT;
                                    } else if (55064 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 55092) {
                                    if (55065 <= e1 && e1 <= 55091) return t.CLUSTER_BREAK.LVT;
                                } else if (e1 < 55093) {
                                    if (55092 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (55093 <= e1 && e1 <= 55119) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 55149) {
                                if (e1 < 55121) {
                                    if (55120 === e1) return t.CLUSTER_BREAK.LV;
                                } else if (e1 < 55148) {
                                    if (55121 <= e1 && e1 <= 55147) return t.CLUSTER_BREAK.LVT;
                                } else if (55148 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (e1 < 55176) {
                                if (55149 <= e1 && e1 <= 55175) return t.CLUSTER_BREAK.LVT;
                            } else if (e1 < 55177) {
                                if (55176 === e1) return t.CLUSTER_BREAK.LV;
                            } else if (55177 <= e1 && e1 <= 55203) return t.CLUSTER_BREAK.LVT;
                        } else if (e1 < 68097) {
                            if (e1 < 65279) {
                                if (e1 < 64286) {
                                    if (e1 < 55243) {
                                        if (55216 <= e1 && e1 <= 55238) return t.CLUSTER_BREAK.V;
                                    } else if (55243 <= e1 && e1 <= 55291) return t.CLUSTER_BREAK.T;
                                } else if (e1 < 65024) {
                                    if (64286 === e1) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 65056) {
                                    if (65024 <= e1 && e1 <= 65039) return t.CLUSTER_BREAK.EXTEND;
                                } else if (65056 <= e1 && e1 <= 65071) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 66045) {
                                if (e1 < 65438) {
                                    if (65279 === e1) return t.CLUSTER_BREAK.CONTROL;
                                } else if (e1 < 65520) {
                                    if (65438 <= e1 && e1 <= 65439) return t.CLUSTER_BREAK.EXTEND;
                                } else if (65520 <= e1 && e1 <= 65531) return t.CLUSTER_BREAK.CONTROL;
                            } else if (e1 < 66272) {
                                if (66045 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 66422) {
                                if (66272 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (66422 <= e1 && e1 <= 66426) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 68325) {
                            if (e1 < 68108) {
                                if (e1 < 68101) {
                                    if (68097 <= e1 && e1 <= 68099) return t.CLUSTER_BREAK.EXTEND;
                                } else if (68101 <= e1 && e1 <= 68102) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 68152) {
                                if (68108 <= e1 && e1 <= 68111) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 68159) {
                                if (68152 <= e1 && e1 <= 68154) return t.CLUSTER_BREAK.EXTEND;
                            } else if (68159 === e1) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 69373) {
                            if (e1 < 68900) {
                                if (68325 <= e1 && e1 <= 68326) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 69291) {
                                if (68900 <= e1 && e1 <= 68903) return t.CLUSTER_BREAK.EXTEND;
                            } else if (69291 <= e1 && e1 <= 69292) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 69446) {
                            if (69373 <= e1 && e1 <= 69375) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 69506) {
                            if (69446 <= e1 && e1 <= 69456) return t.CLUSTER_BREAK.EXTEND;
                        } else if (69506 <= e1 && e1 <= 69509) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 70016) {
                        if (e1 < 69815) {
                            if (e1 < 69747) {
                                if (e1 < 69634) {
                                    if (69632 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                    if (69633 === e1) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 69688) {
                                    if (69634 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 69744) {
                                    if (69688 <= e1 && e1 <= 69702) return t.CLUSTER_BREAK.EXTEND;
                                } else if (69744 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 69762) {
                                if (e1 < 69759) {
                                    if (69747 <= e1 && e1 <= 69748) return t.CLUSTER_BREAK.EXTEND;
                                } else if (69759 <= e1 && e1 <= 69761) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 69808) {
                                if (69762 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 69811) {
                                if (69808 <= e1 && e1 <= 69810) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (69811 <= e1 && e1 <= 69814) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 69888) {
                            if (e1 < 69821) {
                                if (e1 < 69817) {
                                    if (69815 <= e1 && e1 <= 69816) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (69817 <= e1 && e1 <= 69818) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 69826) {
                                if (69821 === e1) return t.CLUSTER_BREAK.PREPEND;
                            } else {
                                if (69826 === e1) return t.CLUSTER_BREAK.EXTEND;
                                if (69837 === e1) return t.CLUSTER_BREAK.PREPEND;
                            }
                        } else if (e1 < 69933) {
                            if (e1 < 69927) {
                                if (69888 <= e1 && e1 <= 69890) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 69932) {
                                if (69927 <= e1 && e1 <= 69931) return t.CLUSTER_BREAK.EXTEND;
                            } else if (69932 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e1 < 69957) {
                            if (69933 <= e1 && e1 <= 69940) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 70003) {
                            if (69957 <= e1 && e1 <= 69958) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else if (70003 === e1) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 70194) {
                        if (e1 < 70082) {
                            if (e1 < 70067) {
                                if (e1 < 70018) {
                                    if (70016 <= e1 && e1 <= 70017) return t.CLUSTER_BREAK.EXTEND;
                                } else if (70018 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 70070) {
                                if (70067 <= e1 && e1 <= 70069) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 70079) {
                                if (70070 <= e1 && e1 <= 70078) return t.CLUSTER_BREAK.EXTEND;
                            } else if (70079 <= e1 && e1 <= 70080) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e1 < 70095) {
                            if (e1 < 70089) {
                                if (70082 <= e1 && e1 <= 70083) return t.CLUSTER_BREAK.PREPEND;
                            } else if (e1 < 70094) {
                                if (70089 <= e1 && e1 <= 70092) return t.CLUSTER_BREAK.EXTEND;
                            } else if (70094 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e1 < 70188) {
                            if (70095 === e1) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 70191) {
                            if (70188 <= e1 && e1 <= 70190) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else if (70191 <= e1 && e1 <= 70193) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 70209) {
                        if (e1 < 70197) {
                            if (e1 < 70196) {
                                if (70194 <= e1 && e1 <= 70195) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (70196 === e1) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 70198) {
                            if (70197 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e1 < 70206) {
                            if (70198 <= e1 && e1 <= 70199) return t.CLUSTER_BREAK.EXTEND;
                        } else if (70206 === e1) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 70371) {
                        if (e1 < 70367) {
                            if (70209 === e1) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 70368) {
                            if (70367 === e1) return t.CLUSTER_BREAK.EXTEND;
                        } else if (70368 <= e1 && e1 <= 70370) return t.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e1 < 70400) {
                        if (70371 <= e1 && e1 <= 70378) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 70402) {
                        if (70400 <= e1 && e1 <= 70401) return t.CLUSTER_BREAK.EXTEND;
                    } else if (70402 <= e1 && e1 <= 70403) return t.CLUSTER_BREAK.SPACINGMARK;
                } else if (e1 < 72343) {
                    if (e1 < 71339) {
                        if (e1 < 70841) {
                            if (e1 < 70512) {
                                if (e1 < 70471) {
                                    if (e1 < 70463) {
                                        if (e1 < 70462) {
                                            if (70459 <= e1 && e1 <= 70460) return t.CLUSTER_BREAK.EXTEND;
                                        } else if (70462 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (e1 < 70464) {
                                        if (70463 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (e1 < 70465) {
                                        if (70464 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (70465 <= e1 && e1 <= 70468) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 70487) {
                                    if (e1 < 70475) {
                                        if (70471 <= e1 && e1 <= 70472) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (70475 <= e1 && e1 <= 70477) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 70498) {
                                    if (70487 === e1) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 70502) {
                                    if (70498 <= e1 && e1 <= 70499) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (70502 <= e1 && e1 <= 70508) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 70725) {
                                if (e1 < 70712) {
                                    if (e1 < 70709) {
                                        if (70512 <= e1 && e1 <= 70516) return t.CLUSTER_BREAK.EXTEND;
                                    } else if (70709 <= e1 && e1 <= 70711) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 70720) {
                                    if (70712 <= e1 && e1 <= 70719) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 70722) {
                                    if (70720 <= e1 && e1 <= 70721) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (70722 <= e1 && e1 <= 70724) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 70832) {
                                if (e1 < 70726) {
                                    if (70725 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    if (70726 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    if (70750 === e1) return t.CLUSTER_BREAK.EXTEND;
                                }
                            } else if (e1 < 70833) {
                                if (70832 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 70835) {
                                if (70833 <= e1 && e1 <= 70834) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (70835 <= e1 && e1 <= 70840) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 71096) {
                            if (e1 < 70847) {
                                if (e1 < 70843) {
                                    if (70841 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                    if (70842 === e1) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 70845) {
                                    if (70843 <= e1 && e1 <= 70844) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    if (70845 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    if (70846 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else if (e1 < 71087) {
                                if (e1 < 70849) {
                                    if (70847 <= e1 && e1 <= 70848) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 70850) {
                                    if (70849 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (70850 <= e1 && e1 <= 70851) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 71088) {
                                if (71087 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 71090) {
                                if (71088 <= e1 && e1 <= 71089) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (71090 <= e1 && e1 <= 71093) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 71216) {
                            if (e1 < 71102) {
                                if (e1 < 71100) {
                                    if (71096 <= e1 && e1 <= 71099) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (71100 <= e1 && e1 <= 71101) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 71103) {
                                if (71102 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 71132) {
                                if (71103 <= e1 && e1 <= 71104) return t.CLUSTER_BREAK.EXTEND;
                            } else if (71132 <= e1 && e1 <= 71133) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 71229) {
                            if (e1 < 71219) {
                                if (71216 <= e1 && e1 <= 71218) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 71227) {
                                if (71219 <= e1 && e1 <= 71226) return t.CLUSTER_BREAK.EXTEND;
                            } else if (71227 <= e1 && e1 <= 71228) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e1 < 71230) {
                            if (71229 === e1) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 71231) {
                            if (71230 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else if (71231 <= e1 && e1 <= 71232) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 71999) {
                        if (e1 < 71463) {
                            if (e1 < 71350) {
                                if (e1 < 71341) {
                                    if (71339 === e1) return t.CLUSTER_BREAK.EXTEND;
                                    if (71340 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 71342) {
                                    if (71341 === e1) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 71344) {
                                    if (71342 <= e1 && e1 <= 71343) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (71344 <= e1 && e1 <= 71349) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 71453) {
                                if (71350 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                if (71351 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 71458) {
                                if (71453 <= e1 && e1 <= 71455) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 71462) {
                                if (71458 <= e1 && e1 <= 71461) return t.CLUSTER_BREAK.EXTEND;
                            } else if (71462 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e1 < 71984) {
                            if (e1 < 71727) {
                                if (e1 < 71724) {
                                    if (71463 <= e1 && e1 <= 71467) return t.CLUSTER_BREAK.EXTEND;
                                } else if (71724 <= e1 && e1 <= 71726) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 71736) {
                                if (71727 <= e1 && e1 <= 71735) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 71737) {
                                if (71736 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (71737 <= e1 && e1 <= 71738) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 71995) {
                            if (e1 < 71985) {
                                if (71984 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 71991) {
                                if (71985 <= e1 && e1 <= 71989) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (71991 <= e1 && e1 <= 71992) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e1 < 71997) {
                            if (71995 <= e1 && e1 <= 71996) return t.CLUSTER_BREAK.EXTEND;
                        } else {
                            if (71997 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                            if (71998 === e1) return t.CLUSTER_BREAK.EXTEND;
                        }
                    } else if (e1 < 72193) {
                        if (e1 < 72145) {
                            if (e1 < 72001) {
                                if (71999 === e1) return t.CLUSTER_BREAK.PREPEND;
                                if (72e3 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 72002) {
                                if (72001 === e1) return t.CLUSTER_BREAK.PREPEND;
                            } else {
                                if (72002 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                if (72003 === e1) return t.CLUSTER_BREAK.EXTEND;
                            }
                        } else if (e1 < 72156) {
                            if (e1 < 72148) {
                                if (72145 <= e1 && e1 <= 72147) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 72154) {
                                if (72148 <= e1 && e1 <= 72151) return t.CLUSTER_BREAK.EXTEND;
                            } else if (72154 <= e1 && e1 <= 72155) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 72160) {
                            if (72156 <= e1 && e1 <= 72159) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else {
                            if (72160 === e1) return t.CLUSTER_BREAK.EXTEND;
                            if (72164 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                        }
                    } else if (e1 < 72263) {
                        if (e1 < 72249) {
                            if (e1 < 72243) {
                                if (72193 <= e1 && e1 <= 72202) return t.CLUSTER_BREAK.EXTEND;
                            } else if (72243 <= e1 && e1 <= 72248) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 72250) {
                            if (72249 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e1 < 72251) {
                            if (72250 === e1) return t.CLUSTER_BREAK.PREPEND;
                        } else if (72251 <= e1 && e1 <= 72254) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 72281) {
                        if (e1 < 72273) {
                            if (72263 === e1) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 72279) {
                            if (72273 <= e1 && e1 <= 72278) return t.CLUSTER_BREAK.EXTEND;
                        } else if (72279 <= e1 && e1 <= 72280) return t.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e1 < 72324) {
                        if (72281 <= e1 && e1 <= 72283) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 72330) {
                        if (72324 <= e1 && e1 <= 72329) return t.CLUSTER_BREAK.PREPEND;
                    } else if (72330 <= e1 && e1 <= 72342) return t.CLUSTER_BREAK.EXTEND;
                } else if (e1 < 94033) {
                    if (e1 < 73104) {
                        if (e1 < 72881) {
                            if (e1 < 72766) {
                                if (e1 < 72751) {
                                    if (e1 < 72344) {
                                        if (72343 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (72344 <= e1 && e1 <= 72345) return t.CLUSTER_BREAK.EXTEND;
                                } else if (e1 < 72752) {
                                    if (72751 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (e1 < 72760) {
                                    if (72752 <= e1 && e1 <= 72758) return t.CLUSTER_BREAK.EXTEND;
                                } else if (72760 <= e1 && e1 <= 72765) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 72850) {
                                if (72766 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                if (72767 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 72873) {
                                if (72850 <= e1 && e1 <= 72871) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 72874) {
                                if (72873 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (72874 <= e1 && e1 <= 72880) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 73018) {
                            if (e1 < 72884) {
                                if (e1 < 72882) {
                                    if (72881 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (72882 <= e1 && e1 <= 72883) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 72885) {
                                if (72884 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 73009) {
                                if (72885 <= e1 && e1 <= 72886) return t.CLUSTER_BREAK.EXTEND;
                            } else if (73009 <= e1 && e1 <= 73014) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 73030) {
                            if (e1 < 73020) {
                                if (73018 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 73023) {
                                if (73020 <= e1 && e1 <= 73021) return t.CLUSTER_BREAK.EXTEND;
                            } else if (73023 <= e1 && e1 <= 73029) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 73031) {
                            if (73030 === e1) return t.CLUSTER_BREAK.PREPEND;
                        } else if (e1 < 73098) {
                            if (73031 === e1) return t.CLUSTER_BREAK.EXTEND;
                        } else if (73098 <= e1 && e1 <= 73102) return t.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e1 < 73526) {
                        if (e1 < 73459) {
                            if (e1 < 73109) {
                                if (e1 < 73107) {
                                    if (73104 <= e1 && e1 <= 73105) return t.CLUSTER_BREAK.EXTEND;
                                } else if (73107 <= e1 && e1 <= 73108) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (e1 < 73110) {
                                if (73109 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else {
                                if (73110 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                                if (73111 === e1) return t.CLUSTER_BREAK.EXTEND;
                            }
                        } else if (e1 < 73474) {
                            if (e1 < 73461) {
                                if (73459 <= e1 && e1 <= 73460) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 73472) {
                                if (73461 <= e1 && e1 <= 73462) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (73472 <= e1 && e1 <= 73473) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 73475) {
                            if (73474 === e1) return t.CLUSTER_BREAK.PREPEND;
                        } else if (e1 < 73524) {
                            if (73475 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else if (73524 <= e1 && e1 <= 73525) return t.CLUSTER_BREAK.SPACINGMARK;
                    } else if (e1 < 78896) {
                        if (e1 < 73536) {
                            if (e1 < 73534) {
                                if (73526 <= e1 && e1 <= 73530) return t.CLUSTER_BREAK.EXTEND;
                            } else if (73534 <= e1 && e1 <= 73535) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e1 < 73537) {
                            if (73536 === e1) return t.CLUSTER_BREAK.EXTEND;
                        } else {
                            if (73537 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                            if (73538 === e1) return t.CLUSTER_BREAK.EXTEND;
                        }
                    } else if (e1 < 92912) {
                        if (e1 < 78912) {
                            if (78896 <= e1 && e1 <= 78911) return t.CLUSTER_BREAK.CONTROL;
                        } else if (e1 < 78919) {
                            if (78912 === e1) return t.CLUSTER_BREAK.EXTEND;
                        } else if (78919 <= e1 && e1 <= 78933) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 92976) {
                        if (92912 <= e1 && e1 <= 92916) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 94031) {
                        if (92976 <= e1 && e1 <= 92982) return t.CLUSTER_BREAK.EXTEND;
                    } else if (94031 === e1) return t.CLUSTER_BREAK.EXTEND;
                } else if (e1 < 121476) {
                    if (e1 < 119143) {
                        if (e1 < 113824) {
                            if (e1 < 94180) {
                                if (e1 < 94095) {
                                    if (94033 <= e1 && e1 <= 94087) return t.CLUSTER_BREAK.SPACINGMARK;
                                } else if (94095 <= e1 && e1 <= 94098) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 94192) {
                                if (94180 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (e1 < 113821) {
                                if (94192 <= e1 && e1 <= 94193) return t.CLUSTER_BREAK.SPACINGMARK;
                            } else if (113821 <= e1 && e1 <= 113822) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 118576) {
                            if (e1 < 118528) {
                                if (113824 <= e1 && e1 <= 113827) return t.CLUSTER_BREAK.CONTROL;
                            } else if (118528 <= e1 && e1 <= 118573) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 119141) {
                            if (118576 <= e1 && e1 <= 118598) return t.CLUSTER_BREAK.EXTEND;
                        } else {
                            if (119141 === e1) return t.CLUSTER_BREAK.EXTEND;
                            if (119142 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                        }
                    } else if (e1 < 119173) {
                        if (e1 < 119150) {
                            if (e1 < 119149) {
                                if (119143 <= e1 && e1 <= 119145) return t.CLUSTER_BREAK.EXTEND;
                            } else if (119149 === e1) return t.CLUSTER_BREAK.SPACINGMARK;
                        } else if (e1 < 119155) {
                            if (119150 <= e1 && e1 <= 119154) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 119163) {
                            if (119155 <= e1 && e1 <= 119162) return t.CLUSTER_BREAK.CONTROL;
                        } else if (119163 <= e1 && e1 <= 119170) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 121344) {
                        if (e1 < 119210) {
                            if (119173 <= e1 && e1 <= 119179) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 119362) {
                            if (119210 <= e1 && e1 <= 119213) return t.CLUSTER_BREAK.EXTEND;
                        } else if (119362 <= e1 && e1 <= 119364) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 121403) {
                        if (121344 <= e1 && e1 <= 121398) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 121461) {
                        if (121403 <= e1 && e1 <= 121452) return t.CLUSTER_BREAK.EXTEND;
                    } else if (121461 === e1) return t.CLUSTER_BREAK.EXTEND;
                } else if (e1 < 123628) {
                    if (e1 < 122907) {
                        if (e1 < 121505) {
                            if (e1 < 121499) {
                                if (121476 === e1) return t.CLUSTER_BREAK.EXTEND;
                            } else if (121499 <= e1 && e1 <= 121503) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 122880) {
                            if (121505 <= e1 && e1 <= 121519) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 122888) {
                            if (122880 <= e1 && e1 <= 122886) return t.CLUSTER_BREAK.EXTEND;
                        } else if (122888 <= e1 && e1 <= 122904) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 123023) {
                        if (e1 < 122915) {
                            if (122907 <= e1 && e1 <= 122913) return t.CLUSTER_BREAK.EXTEND;
                        } else if (e1 < 122918) {
                            if (122915 <= e1 && e1 <= 122916) return t.CLUSTER_BREAK.EXTEND;
                        } else if (122918 <= e1 && e1 <= 122922) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 123184) {
                        if (123023 === e1) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 123566) {
                        if (123184 <= e1 && e1 <= 123190) return t.CLUSTER_BREAK.EXTEND;
                    } else if (123566 === e1) return t.CLUSTER_BREAK.EXTEND;
                } else if (e1 < 127995) {
                    if (e1 < 125136) {
                        if (e1 < 124140) {
                            if (123628 <= e1 && e1 <= 123631) return t.CLUSTER_BREAK.EXTEND;
                        } else if (124140 <= e1 && e1 <= 124143) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 125252) {
                        if (125136 <= e1 && e1 <= 125142) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 127462) {
                        if (125252 <= e1 && e1 <= 125258) return t.CLUSTER_BREAK.EXTEND;
                    } else if (127462 <= e1 && e1 <= 127487) return t.CLUSTER_BREAK.REGIONAL_INDICATOR;
                } else if (e1 < 917632) {
                    if (e1 < 917504) {
                        if (127995 <= e1 && e1 <= 127999) return t.CLUSTER_BREAK.EXTEND;
                    } else if (e1 < 917536) {
                        if (917504 <= e1 && e1 <= 917535) return t.CLUSTER_BREAK.CONTROL;
                    } else if (917536 <= e1 && e1 <= 917631) return t.CLUSTER_BREAK.EXTEND;
                } else if (e1 < 917760) {
                    if (917632 <= e1 && e1 <= 917759) return t.CLUSTER_BREAK.CONTROL;
                } else if (e1 < 918e3) {
                    if (917760 <= e1 && e1 <= 917999) return t.CLUSTER_BREAK.EXTEND;
                } else if (918e3 <= e1 && e1 <= 921599) return t.CLUSTER_BREAK.CONTROL;
                return t.CLUSTER_BREAK.OTHER;
            }
            static getEmojiProperty(e1) {
                if (e1 < 10160) {
                    if (e1 < 9728) {
                        if (e1 < 9e3) {
                            if (e1 < 8482) {
                                if (e1 < 8252) {
                                    if (169 === e1) return t.EXTENDED_PICTOGRAPHIC;
                                    if (174 === e1) return t.EXTENDED_PICTOGRAPHIC;
                                } else {
                                    if (8252 === e1) return t.EXTENDED_PICTOGRAPHIC;
                                    if (8265 === e1) return t.EXTENDED_PICTOGRAPHIC;
                                }
                            } else if (e1 < 8596) {
                                if (8482 === e1) return t.EXTENDED_PICTOGRAPHIC;
                                if (8505 === e1) return t.EXTENDED_PICTOGRAPHIC;
                            } else if (e1 < 8617) {
                                if (8596 <= e1 && e1 <= 8601) return t.EXTENDED_PICTOGRAPHIC;
                            } else if (e1 < 8986) {
                                if (8617 <= e1 && e1 <= 8618) return t.EXTENDED_PICTOGRAPHIC;
                            } else if (8986 <= e1 && e1 <= 8987) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (e1 < 9410) {
                            if (e1 < 9167) {
                                if (9e3 === e1) return t.EXTENDED_PICTOGRAPHIC;
                                if (9096 === e1) return t.EXTENDED_PICTOGRAPHIC;
                            } else if (e1 < 9193) {
                                if (9167 === e1) return t.EXTENDED_PICTOGRAPHIC;
                            } else if (e1 < 9208) {
                                if (9193 <= e1 && e1 <= 9203) return t.EXTENDED_PICTOGRAPHIC;
                            } else if (9208 <= e1 && e1 <= 9210) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (e1 < 9654) {
                            if (e1 < 9642) {
                                if (9410 === e1) return t.EXTENDED_PICTOGRAPHIC;
                            } else if (9642 <= e1 && e1 <= 9643) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (e1 < 9664) {
                            if (9654 === e1) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (e1 < 9723) {
                            if (9664 === e1) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (9723 <= e1 && e1 <= 9726) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (e1 < 10035) {
                        if (e1 < 10004) {
                            if (e1 < 9748) {
                                if (e1 < 9735) {
                                    if (9728 <= e1 && e1 <= 9733) return t.EXTENDED_PICTOGRAPHIC;
                                } else if (9735 <= e1 && e1 <= 9746) return t.EXTENDED_PICTOGRAPHIC;
                            } else if (e1 < 9872) {
                                if (9748 <= e1 && e1 <= 9861) return t.EXTENDED_PICTOGRAPHIC;
                            } else if (e1 < 9992) {
                                if (9872 <= e1 && e1 <= 9989) return t.EXTENDED_PICTOGRAPHIC;
                            } else if (9992 <= e1 && e1 <= 10002) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (e1 < 10013) {
                            if (10004 === e1) return t.EXTENDED_PICTOGRAPHIC;
                            if (10006 === e1) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (e1 < 10017) {
                            if (10013 === e1) return t.EXTENDED_PICTOGRAPHIC;
                        } else {
                            if (10017 === e1) return t.EXTENDED_PICTOGRAPHIC;
                            if (10024 === e1) return t.EXTENDED_PICTOGRAPHIC;
                        }
                    } else if (e1 < 10067) {
                        if (e1 < 10055) {
                            if (e1 < 10052) {
                                if (10035 <= e1 && e1 <= 10036) return t.EXTENDED_PICTOGRAPHIC;
                            } else if (10052 === e1) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (e1 < 10060) {
                            if (10055 === e1) return t.EXTENDED_PICTOGRAPHIC;
                        } else {
                            if (10060 === e1) return t.EXTENDED_PICTOGRAPHIC;
                            if (10062 === e1) return t.EXTENDED_PICTOGRAPHIC;
                        }
                    } else if (e1 < 10083) {
                        if (e1 < 10071) {
                            if (10067 <= e1 && e1 <= 10069) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (10071 === e1) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (e1 < 10133) {
                        if (10083 <= e1 && e1 <= 10087) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (e1 < 10145) {
                        if (10133 <= e1 && e1 <= 10135) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (10145 === e1) return t.EXTENDED_PICTOGRAPHIC;
                } else if (e1 < 127489) {
                    if (e1 < 12951) {
                        if (e1 < 11035) {
                            if (e1 < 10548) {
                                if (10160 === e1) return t.EXTENDED_PICTOGRAPHIC;
                                if (10175 === e1) return t.EXTENDED_PICTOGRAPHIC;
                            } else if (e1 < 11013) {
                                if (10548 <= e1 && e1 <= 10549) return t.EXTENDED_PICTOGRAPHIC;
                            } else if (11013 <= e1 && e1 <= 11015) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (e1 < 11093) {
                            if (e1 < 11088) {
                                if (11035 <= e1 && e1 <= 11036) return t.EXTENDED_PICTOGRAPHIC;
                            } else if (11088 === e1) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (e1 < 12336) {
                            if (11093 === e1) return t.EXTENDED_PICTOGRAPHIC;
                        } else {
                            if (12336 === e1) return t.EXTENDED_PICTOGRAPHIC;
                            if (12349 === e1) return t.EXTENDED_PICTOGRAPHIC;
                        }
                    } else if (e1 < 127340) {
                        if (e1 < 126976) {
                            if (12951 === e1) return t.EXTENDED_PICTOGRAPHIC;
                            if (12953 === e1) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (e1 < 127245) {
                            if (126976 <= e1 && e1 <= 127231) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (e1 < 127279) {
                            if (127245 <= e1 && e1 <= 127247) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (127279 === e1) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (e1 < 127374) {
                        if (e1 < 127358) {
                            if (127340 <= e1 && e1 <= 127345) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (127358 <= e1 && e1 <= 127359) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (e1 < 127377) {
                        if (127374 === e1) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (e1 < 127405) {
                        if (127377 <= e1 && e1 <= 127386) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (127405 <= e1 && e1 <= 127461) return t.EXTENDED_PICTOGRAPHIC;
                } else if (e1 < 128981) {
                    if (e1 < 127561) {
                        if (e1 < 127535) {
                            if (e1 < 127514) {
                                if (127489 <= e1 && e1 <= 127503) return t.EXTENDED_PICTOGRAPHIC;
                            } else if (127514 === e1) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (e1 < 127538) {
                            if (127535 === e1) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (e1 < 127548) {
                            if (127538 <= e1 && e1 <= 127546) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (127548 <= e1 && e1 <= 127551) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (e1 < 128326) {
                        if (e1 < 128e3) {
                            if (127561 <= e1 && e1 <= 127994) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (128e3 <= e1 && e1 <= 128317) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (e1 < 128640) {
                        if (128326 <= e1 && e1 <= 128591) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (e1 < 128884) {
                        if (128640 <= e1 && e1 <= 128767) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (128884 <= e1 && e1 <= 128895) return t.EXTENDED_PICTOGRAPHIC;
                } else if (e1 < 129198) {
                    if (e1 < 129096) {
                        if (e1 < 129036) {
                            if (128981 <= e1 && e1 <= 129023) return t.EXTENDED_PICTOGRAPHIC;
                        } else if (129036 <= e1 && e1 <= 129039) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (e1 < 129114) {
                        if (129096 <= e1 && e1 <= 129103) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (e1 < 129160) {
                        if (129114 <= e1 && e1 <= 129119) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (129160 <= e1 && e1 <= 129167) return t.EXTENDED_PICTOGRAPHIC;
                } else if (e1 < 129340) {
                    if (e1 < 129292) {
                        if (129198 <= e1 && e1 <= 129279) return t.EXTENDED_PICTOGRAPHIC;
                    } else if (129292 <= e1 && e1 <= 129338) return t.EXTENDED_PICTOGRAPHIC;
                } else if (e1 < 129351) {
                    if (129340 <= e1 && e1 <= 129349) return t.EXTENDED_PICTOGRAPHIC;
                } else if (e1 < 130048) {
                    if (129351 <= e1 && e1 <= 129791) return t.EXTENDED_PICTOGRAPHIC;
                } else if (130048 <= e1 && e1 <= 131069) return t.EXTENDED_PICTOGRAPHIC;
                return t.CLUSTER_BREAK.OTHER;
            }
        }, Jl;
    }
    function id() {
        if (ic) return sc;
        ic = 1;
        const e1 = function() {
            if (nc) return Hl;
            nc = 1;
            var e1 = this && this.__importDefault || function(e1) {
                return e1 && e1.__esModule ? e1 : {
                    default: e1
                };
            };
            Object.defineProperty(Hl, "__esModule", {
                value: !0
            });
            const t = e1(sd());
            return Hl.default = t.default, Hl;
        }().default, t = /^[\u0000-\u007f]*$/u;
        let r;
        return sc = {
            upperCaseFirst: function(e1) {
                return e1.length <= 1 ? e1.toUpperCase() : e1[0].toUpperCase() + e1.slice(1);
            },
            getGraphemeCount: function(n) {
                return t.test(n) ? n.length : (r || (r = new e1), r.countGraphemes(n));
            }
        };
    }
    function od() {
        if (lc) return uc;
        lc = 1;
        const e1 = Ll();
        return uc = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent spacing inside computed property brackets",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/computed-property-spacing"
                },
                fixable: "whitespace",
                schema: [
                    {
                        enum: [
                            "always",
                            "never"
                        ]
                    },
                    {
                        type: "object",
                        properties: {
                            enforceForClassMembers: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unexpectedSpaceBefore: "There should be no space before '{{tokenValue}}'.",
                    unexpectedSpaceAfter: "There should be no space after '{{tokenValue}}'.",
                    missingSpaceBefore: "A space is required before '{{tokenValue}}'.",
                    missingSpaceAfter: "A space is required after '{{tokenValue}}'."
                }
            },
            create (t) {
                const r = t.sourceCode, n = "always" === t.options[0], s = !t.options[1] || t.options[1].enforceForClassMembers;
                function i(s) {
                    return function(i) {
                        if (!i.computed) return;
                        const o = i[s], a = r.getTokenBefore(o, e1.isOpeningBracketToken), u = r.getTokenAfter(a, {
                            includeComments: !0
                        }), l = r.getTokenAfter(o, e1.isClosingBracketToken), c = r.getTokenBefore(l, {
                            includeComments: !0
                        });
                        e1.isTokenOnSameLine(a, u) && (n ? !r.isSpaceBetweenTokens(a, u) && e1.isTokenOnSameLine(a, u) && function(e1, r) {
                            t.report({
                                node: e1,
                                loc: r.loc,
                                messageId: "missingSpaceAfter",
                                data: {
                                    tokenValue: r.value
                                },
                                fix: (e1)=>e1.insertTextAfter(r, " ")
                            });
                        }(i, a) : r.isSpaceBetweenTokens(a, u) && function(e1, r, n) {
                            t.report({
                                node: e1,
                                loc: {
                                    start: r.loc.end,
                                    end: n.loc.start
                                },
                                messageId: "unexpectedSpaceAfter",
                                data: {
                                    tokenValue: r.value
                                },
                                fix: (e1)=>e1.removeRange([
                                        r.range[1],
                                        n.range[0]
                                    ])
                            });
                        }(i, a, u)), e1.isTokenOnSameLine(c, l) && (n ? !r.isSpaceBetweenTokens(c, l) && e1.isTokenOnSameLine(c, l) && function(e1, r) {
                            t.report({
                                node: e1,
                                loc: r.loc,
                                messageId: "missingSpaceBefore",
                                data: {
                                    tokenValue: r.value
                                },
                                fix: (e1)=>e1.insertTextBefore(r, " ")
                            });
                        }(i, l) : r.isSpaceBetweenTokens(c, l) && function(e1, r, n) {
                            t.report({
                                node: e1,
                                loc: {
                                    start: n.loc.end,
                                    end: r.loc.start
                                },
                                messageId: "unexpectedSpaceBefore",
                                data: {
                                    tokenValue: r.value
                                },
                                fix: (e1)=>e1.removeRange([
                                        n.range[1],
                                        r.range[0]
                                    ])
                            });
                        }(i, l, c));
                    };
                }
                const o = {
                    Property: i("key"),
                    MemberExpression: i("property")
                };
                return s && (o.MethodDefinition = o.PropertyDefinition = o.Property), o;
            }
        }, uc;
    }
    function ad() {
        return dc || (dc = 1, fc = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Enforce consistent naming when capturing the current execution context",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/consistent-this"
                },
                schema: {
                    type: "array",
                    items: {
                        type: "string",
                        minLength: 1
                    },
                    uniqueItems: !0
                },
                messages: {
                    aliasNotAssignedToThis: "Designated alias '{{name}}' is not assigned to 'this'.",
                    unexpectedAlias: "Unexpected alias '{{name}}' for 'this'."
                }
            },
            create (e1) {
                let t = [];
                const r = e1.sourceCode;
                function n(t, r) {
                    e1.report({
                        node: t,
                        messageId: "aliasNotAssignedToThis",
                        data: {
                            name: r
                        }
                    });
                }
                function s(r, s, i) {
                    const o = "ThisExpression" === i.type;
                    t.includes(s) ? (!o || r.operator && "=" !== r.operator) && n(r, s) : o && e1.report({
                        node: r,
                        messageId: "unexpectedAlias",
                        data: {
                            name: s
                        }
                    });
                }
                function i(e1) {
                    const s = r.getScope(e1);
                    t.forEach((e1)=>{
                        !function(e1, t) {
                            const r = t.set.get(e1);
                            r && (r.defs.some((e1)=>"VariableDeclarator" === e1.node.type && null !== e1.node.init) || r.references.some((e1)=>{
                                const r = e1.writeExpr;
                                return e1.from === t && r && "ThisExpression" === r.type && "=" === r.parent.operator;
                            }) || r.defs.map((e1)=>e1.node).forEach((t)=>{
                                n(t, e1);
                            }));
                        }(e1, s);
                    });
                }
                return 0 === e1.options.length ? t.push("that") : t = e1.options, {
                    "Program:exit": i,
                    "FunctionExpression:exit": i,
                    "FunctionDeclaration:exit": i,
                    VariableDeclarator (e1) {
                        const t = e1.id, r = "ArrayPattern" === t.type || "ObjectPattern" === t.type;
                        null === e1.init || r || s(e1, t.name, e1.init);
                    },
                    AssignmentExpression (e1) {
                        "Identifier" === e1.left.type && s(e1, e1.left.name, e1.right);
                    }
                };
            }
        }), fc;
    }
    function ud() {
        if (yc) return gc;
        yc = 1;
        const e1 = Ll();
        return gc = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Enforce consistent brace style for all control statements",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/curly"
                },
                schema: {
                    anyOf: [
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "all"
                                    ]
                                }
                            ],
                            minItems: 0,
                            maxItems: 1
                        },
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "multi",
                                        "multi-line",
                                        "multi-or-nest"
                                    ]
                                },
                                {
                                    enum: [
                                        "consistent"
                                    ]
                                }
                            ],
                            minItems: 0,
                            maxItems: 2
                        }
                    ]
                },
                fixable: "code",
                messages: {
                    missingCurlyAfter: "Expected { after '{{name}}'.",
                    missingCurlyAfterCondition: "Expected { after '{{name}}' condition.",
                    unexpectedCurlyAfter: "Unnecessary { after '{{name}}'.",
                    unexpectedCurlyAfterCondition: "Unnecessary { after '{{name}}' condition."
                }
            },
            create (t) {
                const r = "multi" === t.options[0], n = "multi-line" === t.options[0], s = "multi-or-nest" === t.options[0], i = "consistent" === t.options[1], o = t.sourceCode;
                function a(t) {
                    if ("EmptyStatement" === t.type) return !0;
                    const r = o.getFirstToken(t), n = o.getLastToken(t), s = e1.isSemicolonToken(n) ? o.getTokenBefore(n) : n;
                    return r.loc.start.line === s.loc.end.line;
                }
                function u(e1) {
                    switch(e1.type){
                        case "IfStatement":
                            return !e1.alternate || u(e1.alternate);
                        case "ForStatement":
                        case "ForInStatement":
                        case "ForOfStatement":
                        case "LabeledStatement":
                        case "WithStatement":
                        case "WhileStatement":
                            return u(e1.body);
                        default:
                            return !1;
                    }
                }
                function l(e1) {
                    const t = e1.body[0];
                    return function(e1) {
                        return "VariableDeclaration" === e1.type ? "const" === e1.kind || "let" === e1.kind : "FunctionDeclaration" === e1.type || "ClassDeclaration" === e1.type;
                    }(t) || u(t) && function(e1) {
                        const t = o.getTokenAfter(e1);
                        var r;
                        return Boolean(t) && "else" === (r = t).value && "Keyword" === r.type;
                    }(e1);
                }
                function c(i, u, c, p) {
                    const f = "BlockStatement" === u.type;
                    let d = null;
                    if (f && (1 !== u.body.length || l(u))) d = !0;
                    else if (r) d = !1;
                    else if (n) (function(t) {
                        const r = o.getTokenBefore(t), n = o.getLastToken(t), s = e1.isSemicolonToken(n) ? o.getTokenBefore(n) : n;
                        return r.loc.start.line === s.loc.end.line;
                    })(u) || (d = !0);
                    else if (s) {
                        if (f) {
                            const e1 = u.body[0], t = o.getCommentsBefore(e1);
                            d = !a(e1) || t.length > 0;
                        } else d = !a(u);
                    } else d = !0;
                    return {
                        actual: f,
                        expected: d,
                        check () {
                            null !== this.expected && this.expected !== this.actual && (this.expected ? t.report({
                                node: i,
                                loc: u.loc,
                                messageId: p && p.condition ? "missingCurlyAfterCondition" : "missingCurlyAfter",
                                data: {
                                    name: c
                                },
                                fix: (e1)=>e1.replaceText(u, `{${o.getText(u)}}`)
                            }) : t.report({
                                node: i,
                                loc: u.loc,
                                messageId: p && p.condition ? "unexpectedCurlyAfterCondition" : "unexpectedCurlyAfter",
                                data: {
                                    name: c
                                },
                                fix (t) {
                                    const r = "DoWhileStatement" === i.type && o.getTokenBefore(u).range[1] === u.range[0] && !e1.canTokensBeAdjacent("do", o.getFirstToken(u, {
                                        skip: 1
                                    })), n = o.getFirstToken(u), s = o.getLastToken(u), a = o.getTokenBefore(s);
                                    if (function(t) {
                                        const r = o.getTokenBefore(t), n = o.getTokenAfter(t), s = o.getNodeByRangeIndex(r.range[0]);
                                        return !(e1.isSemicolonToken(r) || !n || "BlockStatement" === s.type && "FunctionExpression" !== s.parent.type && "ArrowFunctionExpression" !== s.parent.type || r.loc.end.line !== n.loc.start.line && !/^[([/`+-]/u.test(n.value) && ("Punctuator" !== r.type || "++" !== r.value && "--" !== r.value));
                                    }(s)) return null;
                                    const l = o.getText().slice(n.range[1], a.range[0]) + o.getText(a) + o.getText().slice(a.range[1], s.range[0]);
                                    return t.replaceText(u, (r ? " " : "") + l);
                                }
                            }));
                        }
                    };
                }
                return {
                    IfStatement (e1) {
                        const t = e1.parent;
                        "IfStatement" === t.type && t.alternate === e1 || (function(e1) {
                            const t = [];
                            for(let r = e1; r; r = r.alternate)if (t.push(c(r, r.consequent, "if", {
                                condition: !0
                            })), r.alternate && "IfStatement" !== r.alternate.type) {
                                t.push(c(r, r.alternate, "else"));
                                break;
                            }
                            if (i) {
                                const e1 = t.some((e1)=>null !== e1.expected ? e1.expected : e1.actual);
                                t.forEach((t)=>{
                                    t.expected = e1;
                                });
                            }
                            return t;
                        })(e1).forEach((e1)=>{
                            e1.check();
                        });
                    },
                    WhileStatement (e1) {
                        c(e1, e1.body, "while", {
                            condition: !0
                        }).check();
                    },
                    DoWhileStatement (e1) {
                        c(e1, e1.body, "do").check();
                    },
                    ForStatement (e1) {
                        c(e1, e1.body, "for", {
                            condition: !0
                        }).check();
                    },
                    ForInStatement (e1) {
                        c(e1, e1.body, "for-in").check();
                    },
                    ForOfStatement (e1) {
                        c(e1, e1.body, "for-of").check();
                    }
                };
            }
        }, gc;
    }
    function ld() {
        if (Tc) return Ac;
        Tc = 1;
        const e1 = Ll();
        return Ac = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent newlines before and after dots",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/dot-location"
                },
                schema: [
                    {
                        enum: [
                            "object",
                            "property"
                        ]
                    }
                ],
                fixable: "code",
                messages: {
                    expectedDotAfterObject: "Expected dot to be on same line as object.",
                    expectedDotBeforeProperty: "Expected dot to be on same line as property."
                }
            },
            create (t) {
                const r = t.options[0], n = "object" === r || !r, s = t.sourceCode;
                return {
                    MemberExpression: function(r) {
                        r.computed || function(r) {
                            const i = r.property, o = s.getTokenBefore(i);
                            if (n) {
                                const n = s.getTokenBefore(o);
                                e1.isTokenOnSameLine(n, o) || t.report({
                                    node: r,
                                    loc: o.loc,
                                    messageId: "expectedDotAfterObject",
                                    *fix (t) {
                                        o.value.startsWith(".") && e1.isDecimalIntegerNumericToken(n) ? yield t.insertTextAfter(n, ` ${o.value}`) : yield t.insertTextAfter(n, o.value), yield t.remove(o);
                                    }
                                });
                            } else e1.isTokenOnSameLine(o, i) || t.report({
                                node: r,
                                loc: o.loc,
                                messageId: "expectedDotBeforeProperty",
                                *fix (e1) {
                                    yield e1.remove(o), yield e1.insertTextBefore(i, o.value);
                                }
                            });
                        }(r);
                    }
                };
            }
        }, Ac;
    }
    function cd() {
        return Dc ? Rc : (Dc = 1, Rc = [
            "abstract",
            "boolean",
            "break",
            "byte",
            "case",
            "catch",
            "char",
            "class",
            "const",
            "continue",
            "debugger",
            "default",
            "delete",
            "do",
            "double",
            "else",
            "enum",
            "export",
            "extends",
            "false",
            "final",
            "finally",
            "float",
            "for",
            "function",
            "goto",
            "if",
            "implements",
            "import",
            "in",
            "instanceof",
            "int",
            "interface",
            "long",
            "native",
            "new",
            "null",
            "package",
            "private",
            "protected",
            "public",
            "return",
            "short",
            "static",
            "super",
            "switch",
            "synchronized",
            "this",
            "throw",
            "throws",
            "transient",
            "true",
            "try",
            "typeof",
            "var",
            "void",
            "volatile",
            "while",
            "with"
        ]);
    }
    function pd() {
        if (Pc) return Lc;
        Pc = 1;
        const e1 = Ll();
        return Lc = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require the use of `===` and `!==`",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/eqeqeq"
                },
                schema: {
                    anyOf: [
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "always"
                                    ]
                                },
                                {
                                    type: "object",
                                    properties: {
                                        null: {
                                            enum: [
                                                "always",
                                                "never",
                                                "ignore"
                                            ]
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            additionalItems: !1
                        },
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "smart",
                                        "allow-null"
                                    ]
                                }
                            ],
                            additionalItems: !1
                        }
                    ]
                },
                fixable: "code",
                messages: {
                    unexpected: "Expected '{{expectedOperator}}' and instead saw '{{actualOperator}}'."
                }
            },
            create (t) {
                const r = t.options[0] || "always", n = t.options[1] || {}, s = t.sourceCode, i = "always" === r ? n.null || "always" : "ignore", o = "always" === i, a = "never" === i;
                function u(e1) {
                    return "UnaryExpression" === e1.type && "typeof" === e1.operator;
                }
                function l(e1) {
                    return u(e1.left) || u(e1.right);
                }
                function c(e1) {
                    return "Literal" === e1.left.type && "Literal" === e1.right.type && typeof e1.left.value == typeof e1.right.value;
                }
                function p(e1, r) {
                    const n = s.getFirstTokenBetween(e1.left, e1.right, (t)=>t.value === e1.operator);
                    t.report({
                        node: e1,
                        loc: n.loc,
                        messageId: "unexpected",
                        data: {
                            expectedOperator: r,
                            actualOperator: e1.operator
                        },
                        fix: (t)=>l(e1) || c(e1) ? t.replaceText(n, r) : null
                    });
                }
                return {
                    BinaryExpression (t) {
                        const n = function(t) {
                            return e1.isNullLiteral(t.right) || e1.isNullLiteral(t.left);
                        }(t);
                        "==" === t.operator || "!=" === t.operator ? "smart" === r && (l(t) || c(t) || n) || !o && n || p(t, `${t.operator}=`) : a && n && p(t, t.operator.slice(0, -1));
                    }
                };
            }
        }, Lc;
    }
    function fd() {
        if (Kc) return Vc;
        Kc = 1;
        const e1 = Ll();
        return Vc = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require or disallow named `function` expressions",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/func-names"
                },
                schema: {
                    definitions: {
                        value: {
                            enum: [
                                "always",
                                "as-needed",
                                "never"
                            ]
                        }
                    },
                    items: [
                        {
                            $ref: "#/definitions/value"
                        },
                        {
                            type: "object",
                            properties: {
                                generators: {
                                    $ref: "#/definitions/value"
                                }
                            },
                            additionalProperties: !1
                        }
                    ]
                },
                messages: {
                    unnamed: "Unexpected unnamed {{name}}.",
                    named: "Unexpected named {{name}}."
                }
            },
            create (t) {
                const r = t.sourceCode;
                function n(e1) {
                    const t = e1.parent;
                    return "MethodDefinition" === t.type || "Property" === t.type && (t.method || "get" === t.kind || "set" === t.kind);
                }
                function s(n) {
                    t.report({
                        node: n,
                        messageId: "unnamed",
                        loc: e1.getFunctionHeadLoc(n, r),
                        data: {
                            name: e1.getFunctionNameWithKind(n)
                        }
                    });
                }
                function i(i) {
                    const o = r.getDeclaredVariables(i)[0];
                    if ((a = o) && "FunctionName" === a.defs[0].type && o.references.length > 0) return;
                    var a;
                    const u = Boolean(i.id && i.id.name), l = function(e1) {
                        return e1.generator && t.options.length > 1 && t.options[1].generators ? t.options[1].generators : t.options[0] || "always";
                    }(i);
                    "never" === l ? u && "FunctionDeclaration" !== i.type && function(n) {
                        t.report({
                            node: n,
                            messageId: "named",
                            loc: e1.getFunctionHeadLoc(n, r),
                            data: {
                                name: e1.getFunctionNameWithKind(n)
                            }
                        });
                    }(i) : "as-needed" === l ? u || function(e1) {
                        const t = e1.parent;
                        return n(e1) || "VariableDeclarator" === t.type && "Identifier" === t.id.type && t.init === e1 || "Property" === t.type && t.value === e1 || "PropertyDefinition" === t.type && t.value === e1 || "AssignmentExpression" === t.type && "Identifier" === t.left.type && t.right === e1 || "AssignmentPattern" === t.type && "Identifier" === t.left.type && t.right === e1;
                    }(i) || s(i) : u || n(i) || s(i);
                }
                return {
                    "FunctionExpression:exit": i,
                    "ExportDefaultDeclaration > FunctionDeclaration": i
                };
            }
        }, Vc;
    }
    function dd() {
        if (Xc) return Wc;
        Xc = 1;
        const e1 = Ll();
        return Wc = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent line breaks inside function parentheses",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/function-paren-newline"
                },
                fixable: "whitespace",
                schema: [
                    {
                        oneOf: [
                            {
                                enum: [
                                    "always",
                                    "never",
                                    "consistent",
                                    "multiline",
                                    "multiline-arguments"
                                ]
                            },
                            {
                                type: "object",
                                properties: {
                                    minItems: {
                                        type: "integer",
                                        minimum: 0
                                    }
                                },
                                additionalProperties: !1
                            }
                        ]
                    }
                ],
                messages: {
                    expectedBefore: "Expected newline before ')'.",
                    expectedAfter: "Expected newline after '('.",
                    expectedBetween: "Expected newline between arguments/params.",
                    unexpectedBefore: "Unexpected newline before ')'.",
                    unexpectedAfter: "Unexpected newline after '('."
                }
            },
            create (t) {
                const r = t.sourceCode, n = t.options[0] || "multiline", s = "multiline" === n, i = "multiline-arguments" === n, o = "consistent" === n;
                let a;
                function u(e1, t) {
                    return i && 1 === e1.length ? t : s || i ? e1.some((t, r)=>r !== e1.length - 1 && t.loc.end.line !== e1[r + 1].loc.start.line) : o ? t : e1.length >= a;
                }
                return a = "object" == typeof n ? n.minItems : "always" === n ? 0 : "never" === n ? 1 / 0 : null, {
                    [[
                        "ArrowFunctionExpression",
                        "CallExpression",
                        "FunctionDeclaration",
                        "FunctionExpression",
                        "ImportExpression",
                        "NewExpression"
                    ]] (n) {
                        const s = function(t) {
                            switch(t.type){
                                case "NewExpression":
                                    if (!(t.arguments.length || e1.isOpeningParenToken(r.getLastToken(t, {
                                        skip: 1
                                    })) && e1.isClosingParenToken(r.getLastToken(t)) && t.callee.range[1] < t.range[1])) return null;
                                case "CallExpression":
                                    return {
                                        leftParen: r.getTokenAfter(t.callee, e1.isOpeningParenToken),
                                        rightParen: r.getLastToken(t)
                                    };
                                case "FunctionDeclaration":
                                case "FunctionExpression":
                                    {
                                        const n = r.getFirstToken(t, e1.isOpeningParenToken);
                                        return {
                                            leftParen: n,
                                            rightParen: t.params.length ? r.getTokenAfter(t.params[t.params.length - 1], e1.isClosingParenToken) : r.getTokenAfter(n)
                                        };
                                    }
                                case "ArrowFunctionExpression":
                                    {
                                        const n = r.getFirstToken(t, {
                                            skip: t.async ? 1 : 0
                                        });
                                        return e1.isOpeningParenToken(n) ? {
                                            leftParen: n,
                                            rightParen: t.params.length ? r.getTokenAfter(t.params[t.params.length - 1], e1.isClosingParenToken) : r.getTokenAfter(n)
                                        } : null;
                                    }
                                case "ImportExpression":
                                    return {
                                        leftParen: r.getFirstToken(t, 1),
                                        rightParen: r.getLastToken(t)
                                    };
                                default:
                                    throw new TypeError(`unexpected node with type ${t.type}`);
                            }
                        }(n);
                        let o;
                        o = "ImportExpression" === n.type ? [
                            n.source
                        ] : e1.isFunction(n) ? n.params : n.arguments, s && (function(n, s) {
                            const i = n.leftParen, o = n.rightParen, a = r.getTokenAfter(i), l = r.getTokenBefore(o), c = !e1.isTokenOnSameLine(i, a), p = !e1.isTokenOnSameLine(l, o), f = u(s, c);
                            c && !f ? t.report({
                                node: i,
                                messageId: "unexpectedAfter",
                                fix: (e1)=>r.getText().slice(i.range[1], a.range[0]).trim() ? null : e1.removeRange([
                                        i.range[1],
                                        a.range[0]
                                    ])
                            }) : !c && f && t.report({
                                node: i,
                                messageId: "expectedAfter",
                                fix: (e1)=>e1.insertTextAfter(i, "\n")
                            }), p && !f ? t.report({
                                node: o,
                                messageId: "unexpectedBefore",
                                fix: (e1)=>r.getText().slice(l.range[1], o.range[0]).trim() ? null : e1.removeRange([
                                        l.range[1],
                                        o.range[0]
                                    ])
                            }) : !p && f && t.report({
                                node: o,
                                messageId: "expectedBefore",
                                fix: (e1)=>e1.insertTextBefore(o, "\n")
                            });
                        }(s, o), i && function(n, s) {
                            const i = n.leftParen, o = r.getTokenAfter(i), a = u(s, !e1.isTokenOnSameLine(i, o));
                            for(let e1 = 0; e1 <= s.length - 2; e1++){
                                const r = s[e1], n = s[e1 + 1];
                                r.loc.end.line === n.loc.start.line && a && t.report({
                                    node: r,
                                    messageId: "expectedBetween",
                                    fix: (e1)=>e1.insertTextBefore(n, "\n")
                                });
                            }
                        }(s, o));
                    }
                };
            }
        }, Wc;
    }
    function hd() {
        if (Hc) return zc;
        Hc = 1;
        const e1 = {
            oneOf: [
                {
                    enum: [
                        "before",
                        "after",
                        "both",
                        "neither"
                    ]
                },
                {
                    type: "object",
                    properties: {
                        before: {
                            type: "boolean"
                        },
                        after: {
                            type: "boolean"
                        }
                    },
                    additionalProperties: !1
                }
            ]
        };
        return zc = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent spacing around `*` operators in generator functions",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/generator-star-spacing"
                },
                fixable: "whitespace",
                schema: [
                    {
                        oneOf: [
                            {
                                enum: [
                                    "before",
                                    "after",
                                    "both",
                                    "neither"
                                ]
                            },
                            {
                                type: "object",
                                properties: {
                                    before: {
                                        type: "boolean"
                                    },
                                    after: {
                                        type: "boolean"
                                    },
                                    named: e1,
                                    anonymous: e1,
                                    method: e1
                                },
                                additionalProperties: !1
                            }
                        ]
                    }
                ],
                messages: {
                    missingBefore: "Missing space before *.",
                    missingAfter: "Missing space after *.",
                    unexpectedBefore: "Unexpected space before *.",
                    unexpectedAfter: "Unexpected space after *."
                }
            },
            create (e1) {
                const t = {
                    before: {
                        before: !0,
                        after: !1
                    },
                    after: {
                        before: !1,
                        after: !0
                    },
                    both: {
                        before: !0,
                        after: !0
                    },
                    neither: {
                        before: !1,
                        after: !1
                    }
                };
                function r(e1, r) {
                    return e1 ? "string" == typeof e1 ? t[e1] : Object.assign({}, r, e1) : r;
                }
                const n = function(e1) {
                    const n = r(e1, t.before);
                    return {
                        named: r(e1.named, n),
                        anonymous: r(e1.anonymous, n),
                        method: r(e1.method, n)
                    };
                }(e1.options[0] || {}), s = e1.sourceCode;
                function i(e1) {
                    return "*" === e1.value && "Punctuator" === e1.type;
                }
                function o(t, r, s, i) {
                    if (!!(i.range[0] - s.range[1]) !== n[t][r]) {
                        const a = "*" === s.value, u = n[t][r], l = a ? s : i, c = `${u ? "missing" : "unexpected"}${(o = r, o[0].toUpperCase() + o.slice(1))}`;
                        e1.report({
                            node: l,
                            messageId: c,
                            fix: (e1)=>u ? a ? e1.insertTextAfter(l, " ") : e1.insertTextBefore(l, " ") : e1.removeRange([
                                    s.range[1],
                                    i.range[0]
                                ])
                        });
                    }
                    var o;
                }
                function a(e1) {
                    if (!e1.generator) return;
                    const t = function(e1) {
                        return s.getFirstToken(e1.parent.method || "MethodDefinition" === e1.parent.type ? e1.parent : e1, i);
                    }(e1), r = s.getTokenBefore(t), n = s.getTokenAfter(t);
                    let a = "named";
                    "MethodDefinition" === e1.parent.type || "Property" === e1.parent.type && e1.parent.method ? a = "method" : e1.id || (a = "anonymous"), "method" === a && t === s.getFirstToken(e1.parent) || o(a, "before", r, t), o(a, "after", t, n);
                }
                return {
                    FunctionDeclaration: a,
                    FunctionExpression: a
                };
            }
        }, zc;
    }
    function md() {
        return ip || (ip = 1, sp = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "suggestion",
                docs: {
                    description: "Require error handling in callbacks",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/handle-callback-err"
                },
                schema: [
                    {
                        type: "string"
                    }
                ],
                messages: {
                    expected: "Expected error to be handled."
                }
            },
            create (e1) {
                const t = e1.options[0] || "err", r = e1.sourceCode;
                function n(n) {
                    const s = function(e1) {
                        return e1.variables.filter((e1)=>e1.defs[0] && "Parameter" === e1.defs[0].type);
                    }(r.getScope(n)), i = s[0];
                    i && function(e1) {
                        if ("^" === t[0]) return new RegExp(t, "u").test(e1);
                        return e1 === t;
                    }(i.name) && 0 === i.references.length && e1.report({
                        node: n,
                        messageId: "expected"
                    });
                }
                return {
                    FunctionDeclaration: n,
                    FunctionExpression: n,
                    ArrowFunctionExpression: n
                };
            }
        }), sp;
    }
    function gd() {
        if (ap) return op;
        return ap = 1, op = {
            meta: {
                deprecated: !0,
                replacedBy: [
                    "id-denylist"
                ],
                type: "suggestion",
                docs: {
                    description: "Disallow specified identifiers",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/id-blacklist"
                },
                schema: {
                    type: "array",
                    items: {
                        type: "string"
                    },
                    uniqueItems: !0
                },
                messages: {
                    restricted: "Identifier '{{name}}' is restricted."
                }
            },
            create (e1) {
                const t = new Set(e1.options), r = new Set, n = e1.sourceCode;
                let s;
                function i(e1) {
                    const t = e1.parent;
                    return "MemberExpression" !== t.type || t.property !== e1 || t.computed ? !("CallExpression" === t.type || "NewExpression" === t.type || function(e1) {
                        const t = e1.parent;
                        return "ImportSpecifier" === t.type && t.imported !== t.local && t.imported === e1 || "ExportSpecifier" === t.type && t.parent.source && t.local !== t.exported && t.local === e1;
                    }(e1) || function(e1) {
                        const t = e1.parent;
                        return !t.computed && "Property" === t.type && "ObjectPattern" === t.parent.type && t.value !== e1 && t.key === e1;
                    }(e1) || function(e1) {
                        const t = s.set.get(e1.name);
                        return t && 0 === t.defs.length && t.references.some((t)=>t.identifier === e1);
                    }(e1) && !function(e1) {
                        const t = e1.parent;
                        return "Property" === t.type && "ObjectExpression" === t.parent.type && t.shorthand;
                    }(e1)) : function(e1) {
                        const t = e1.parent;
                        return "AssignmentExpression" === t.type && t.left === e1 || "ArrayPattern" === t.type || "RestElement" === t.type || "Property" === t.type && t.value === e1 && "ObjectPattern" === t.parent.type || "AssignmentPattern" === t.type && t.left === e1;
                    }(t);
                }
                return {
                    Program (e1) {
                        s = n.getScope(e1);
                    },
                    Identifier (n) {
                        (function(e1) {
                            return t.has(e1);
                        })(n.name) && i(n) && function(t) {
                            r.has(t.range.toString()) || (e1.report({
                                node: t,
                                messageId: "restricted",
                                data: {
                                    name: t.name
                                }
                            }), r.add(t.range.toString()));
                        }(n);
                    }
                };
            }
        }, op;
    }
    function yd() {
        if (lp) return up;
        return lp = 1, up = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow specified identifiers",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/id-denylist"
                },
                schema: {
                    type: "array",
                    items: {
                        type: "string"
                    },
                    uniqueItems: !0
                },
                messages: {
                    restricted: "Identifier '{{name}}' is restricted.",
                    restrictedPrivate: "Identifier '#{{name}}' is restricted."
                }
            },
            create (e1) {
                const t = new Set(e1.options), r = new Set, n = e1.sourceCode;
                let s;
                function i(e1) {
                    const t = e1.parent;
                    return "MemberExpression" !== t.type || t.property !== e1 || t.computed ? "CallExpression" !== t.type && "NewExpression" !== t.type && !function(e1) {
                        const t = e1.parent;
                        return "ImportSpecifier" === t.type && t.imported !== t.local && t.imported === e1 || "ExportSpecifier" === t.type && t.parent.source && t.local !== t.exported && t.local === e1;
                    }(e1) && !function(e1) {
                        const t = e1.parent;
                        return !t.computed && "Property" === t.type && "ObjectPattern" === t.parent.type && t.key === e1;
                    }(e1) && !function(e1) {
                        const t = s.set.get(e1.name);
                        return t && 0 === t.defs.length && t.references.some((t)=>t.identifier === e1);
                    }(e1) : function(e1) {
                        const t = e1.parent;
                        return "AssignmentExpression" === t.type && t.left === e1 || "ArrayPattern" === t.type || "RestElement" === t.type || "Property" === t.type && t.value === e1 && "ObjectPattern" === t.parent.type || "AssignmentPattern" === t.type && t.left === e1;
                    }(t);
                }
                return {
                    Program (e1) {
                        s = n.getScope(e1);
                    },
                    [[
                        "Identifier",
                        "PrivateIdentifier"
                    ]] (n) {
                        (function(e1) {
                            return t.has(e1);
                        })(n.name) && i(n) && function(t) {
                            if (!r.has(t.range.toString())) {
                                const n = "PrivateIdentifier" === t.type;
                                e1.report({
                                    node: t,
                                    messageId: n ? "restrictedPrivate" : "restricted",
                                    data: {
                                        name: t.name
                                    }
                                }), r.add(t.range.toString());
                            }
                        }(n);
                    }
                };
            }
        }, up;
    }
    function Ed() {
        if (pp) return cp;
        pp = 1;
        const { getGraphemeCount: e1 } = id();
        return cp = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Enforce minimum and maximum identifier lengths",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/id-length"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            min: {
                                type: "integer",
                                default: 2
                            },
                            max: {
                                type: "integer"
                            },
                            exceptions: {
                                type: "array",
                                uniqueItems: !0,
                                items: {
                                    type: "string"
                                }
                            },
                            exceptionPatterns: {
                                type: "array",
                                uniqueItems: !0,
                                items: {
                                    type: "string"
                                }
                            },
                            properties: {
                                enum: [
                                    "always",
                                    "never"
                                ]
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    tooShort: "Identifier name '{{name}}' is too short (< {{min}}).",
                    tooShortPrivate: "Identifier name '#{{name}}' is too short (< {{min}}).",
                    tooLong: "Identifier name '{{name}}' is too long (> {{max}}).",
                    tooLongPrivate: "Identifier name #'{{name}}' is too long (> {{max}})."
                }
            },
            create (t) {
                const r = t.options[0] || {}, n = void 0 !== r.min ? r.min : 2, s = void 0 !== r.max ? r.max : 1 / 0, i = "never" !== r.properties, o = new Set(r.exceptions), a = (r.exceptionPatterns || []).map((e1)=>new RegExp(e1, "u")), u = new Set;
                const l = {
                    MemberExpression: i && function(e1) {
                        return !e1.computed && (e1.parent.left === e1 && "AssignmentExpression" === e1.parent.type || "Property" === e1.parent.type && e1.parent.value === e1 && "ObjectPattern" === e1.parent.parent.type && e1.parent.parent.parent.left === e1.parent.parent);
                    },
                    AssignmentPattern: (e1, t)=>e1.left === t,
                    VariableDeclarator: (e1, t)=>e1.id === t,
                    Property (e1, t) {
                        if ("ObjectPattern" === e1.parent.type) {
                            const r = e1.value.name === e1.key.name;
                            return !r && e1.value === t || r && e1.key === t && i;
                        }
                        return i && !e1.computed && e1.key.name === t.name;
                    },
                    ImportDefaultSpecifier: !0,
                    RestElement: !0,
                    FunctionExpression: !0,
                    ArrowFunctionExpression: !0,
                    ClassDeclaration: !0,
                    FunctionDeclaration: !0,
                    MethodDefinition: !0,
                    PropertyDefinition: !0,
                    CatchClause: !0,
                    ArrayPattern: !0
                };
                return {
                    [[
                        "Identifier",
                        "PrivateIdentifier"
                    ]] (r) {
                        const i = r.name, c = r.parent, p = e1(i), f = p < n;
                        if (!f && !(p > s) || o.has(i) || function(e1) {
                            return a.some((t)=>t.test(e1));
                        }(i)) return;
                        const d = l[c.type];
                        if (d && !u.has(r.range.toString()) && (!0 === d || d(c, r))) {
                            u.add(r.range.toString());
                            let e1 = f ? "tooShort" : "tooLong";
                            "PrivateIdentifier" === r.type && (e1 += "Private"), t.report({
                                node: r,
                                messageId: e1,
                                data: {
                                    name: i,
                                    min: n,
                                    max: s
                                }
                            });
                        }
                    }
                };
            }
        }, cp;
    }
    function xd() {
        return dp || (dp = 1, fp = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require identifiers to match a specified regular expression",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/id-match"
                },
                schema: [
                    {
                        type: "string"
                    },
                    {
                        type: "object",
                        properties: {
                            properties: {
                                type: "boolean",
                                default: !1
                            },
                            classFields: {
                                type: "boolean",
                                default: !1
                            },
                            onlyDeclarations: {
                                type: "boolean",
                                default: !1
                            },
                            ignoreDestructuring: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    notMatch: "Identifier '{{name}}' does not match the pattern '{{pattern}}'.",
                    notMatchPrivate: "Identifier '#{{name}}' does not match the pattern '{{pattern}}'."
                }
            },
            create (e1) {
                const t = e1.options[0] || "^.+$", r = new RegExp(t, "u"), n = e1.options[1] || {}, s = !!n.properties, i = !!n.classFields, o = !!n.onlyDeclarations, a = !!n.ignoreDestructuring, u = e1.sourceCode;
                let l;
                const c = new Set, p = new Set([
                    "CallExpression",
                    "NewExpression"
                ]), f = new Set([
                    "FunctionDeclaration",
                    "VariableDeclarator"
                ]), d = new Set([
                    "ImportSpecifier",
                    "ImportNamespaceSpecifier",
                    "ImportDefaultSpecifier"
                ]);
                function h(e1) {
                    return !r.test(e1);
                }
                function m(e1, t) {
                    return (!o || f.has(e1.type)) && !p.has(e1.type) && h(t);
                }
                function g(r) {
                    if (!c.has(r.range.toString())) {
                        const n = "PrivateIdentifier" === r.type ? "notMatchPrivate" : "notMatch";
                        e1.report({
                            node: r,
                            messageId: n,
                            data: {
                                name: r.name,
                                pattern: t
                            }
                        }), c.add(r.range.toString());
                    }
                }
                return {
                    Program (e1) {
                        l = u.getScope(e1);
                    },
                    Identifier (e1) {
                        const t = e1.name, r = e1.parent, n = "MemberExpression" === r.type ? r.parent : r;
                        if (!function(e1) {
                            const t = l.set.get(e1.name);
                            return t && 0 === t.defs.length && t.references.some((t)=>t.identifier === e1);
                        }(e1)) {
                            if ("MemberExpression" === r.type) {
                                if (!s) return;
                                "Identifier" === r.object.type && r.object.name === t || "AssignmentExpression" === n.type && "MemberExpression" === n.left.type && n.left.property.name === e1.name ? h(t) && g(e1) : "AssignmentExpression" === n.type && "MemberExpression" !== n.right.type && h(t) && g(e1);
                            } else if ("Property" !== r.type || "ObjectExpression" !== r.parent.type || r.key !== e1 || r.computed) {
                                if ("Property" === r.type || "AssignmentPattern" === r.type) {
                                    if (r.parent && "ObjectPattern" === r.parent.type) {
                                        !a && r.shorthand && r.value.left && h(t) && g(e1);
                                        const n = r.key.name === r.value.name;
                                        if (!n && r.key === e1) return;
                                        !(r.value.name && h(t)) || n && a || g(e1);
                                    }
                                    if (!s && !r.computed || a && function(e1) {
                                        let { parent: t } = e1;
                                        for(; t;){
                                            if ("ObjectPattern" === t.type) return !0;
                                            t = t.parent;
                                        }
                                        return !1;
                                    }(e1)) return;
                                    r.right !== e1 && m(n, t) && g(e1);
                                } else d.has(r.type) ? r.local && r.local.name === e1.name && h(t) && g(e1) : "PropertyDefinition" === r.type ? i && h(t) && g(e1) : m(n, t) && g(e1);
                            } else s && h(t) && g(e1);
                        }
                    },
                    PrivateIdentifier (e1) {
                        "PropertyDefinition" === e1.parent.type && !i || h(e1.name) && g(e1);
                    }
                };
            }
        }), fp;
    }
    function Cd() {
        if (mp) return hp;
        mp = 1;
        const { isCommentToken: e1, isNotOpeningParenToken: t } = Ll();
        return hp = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce the location of arrow function bodies",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/implicit-arrow-linebreak"
                },
                fixable: "whitespace",
                schema: [
                    {
                        enum: [
                            "beside",
                            "below"
                        ]
                    }
                ],
                messages: {
                    expected: "Expected a linebreak before this expression.",
                    unexpected: "Expected no linebreak before this expression."
                }
            },
            create (r) {
                const n = r.sourceCode, s = r.options[0] || "beside";
                return {
                    ArrowFunctionExpression: (i)=>(function(i) {
                            if ("BlockStatement" === i.body.type) return;
                            const o = n.getTokenBefore(i.body, t), a = n.getTokenAfter(o);
                            o.loc.end.line === a.loc.start.line && "below" === s ? r.report({
                                node: a,
                                messageId: "expected",
                                fix: (e1)=>e1.insertTextBefore(a, "\n")
                            }) : o.loc.end.line !== a.loc.start.line && "beside" === s && r.report({
                                node: a,
                                messageId: "unexpected",
                                fix: (t)=>n.getFirstTokenBetween(o, a, {
                                        includeComments: !0,
                                        filter: e1
                                    }) ? null : t.replaceTextRange([
                                        o.range[1],
                                        a.range[0]
                                    ], " ")
                            });
                        })(i)
                };
            }
        }, hp;
    }
    function Sd() {
        if (yp) return gp;
        yp = 1;
        const e1 = Ll(), t = new Set([
            "AssignmentExpression",
            "AssignmentPattern",
            "ArrayExpression",
            "ArrayPattern",
            "ArrowFunctionExpression",
            "AwaitExpression",
            "BlockStatement",
            "BinaryExpression",
            "BreakStatement",
            "CallExpression",
            "CatchClause",
            "ChainExpression",
            "ClassBody",
            "ClassDeclaration",
            "ClassExpression",
            "ConditionalExpression",
            "ContinueStatement",
            "DoWhileStatement",
            "DebuggerStatement",
            "EmptyStatement",
            "ExperimentalRestProperty",
            "ExperimentalSpreadProperty",
            "ExpressionStatement",
            "ForStatement",
            "ForInStatement",
            "ForOfStatement",
            "FunctionDeclaration",
            "FunctionExpression",
            "Identifier",
            "IfStatement",
            "Literal",
            "LabeledStatement",
            "LogicalExpression",
            "MemberExpression",
            "MetaProperty",
            "MethodDefinition",
            "NewExpression",
            "ObjectExpression",
            "ObjectPattern",
            "PrivateIdentifier",
            "Program",
            "Property",
            "PropertyDefinition",
            "RestElement",
            "ReturnStatement",
            "SequenceExpression",
            "SpreadElement",
            "StaticBlock",
            "Super",
            "SwitchCase",
            "SwitchStatement",
            "TaggedTemplateExpression",
            "TemplateElement",
            "TemplateLiteral",
            "ThisExpression",
            "ThrowStatement",
            "TryStatement",
            "UnaryExpression",
            "UpdateExpression",
            "VariableDeclaration",
            "VariableDeclarator",
            "WhileStatement",
            "WithStatement",
            "YieldExpression",
            "JSXFragment",
            "JSXOpeningFragment",
            "JSXClosingFragment",
            "JSXIdentifier",
            "JSXNamespacedName",
            "JSXMemberExpression",
            "JSXEmptyExpression",
            "JSXExpressionContainer",
            "JSXElement",
            "JSXClosingElement",
            "JSXOpeningElement",
            "JSXAttribute",
            "JSXSpreadAttribute",
            "JSXText",
            "ExportDefaultDeclaration",
            "ExportNamedDeclaration",
            "ExportAllDeclaration",
            "ExportSpecifier",
            "ImportDeclaration",
            "ImportSpecifier",
            "ImportDefaultSpecifier",
            "ImportNamespaceSpecifier",
            "ImportExpression"
        ]);
        class r {
            constructor(e1){
                this._values = Array(e1 + 1);
            }
            insert(e1, t) {
                this._values[e1] = t;
            }
            findLastNotAfter(e1) {
                const t = this._values;
                for(let r = e1; r >= 0; r--){
                    const e1 = t[r];
                    if (e1) return e1;
                }
            }
            deleteRange(e1, t) {
                this._values.fill(void 0, e1, t);
            }
        }
        class n {
            constructor(e1){
                this.sourceCode = e1, this.firstTokensByLineNumber = new Map;
                const t = e1.tokensAndComments;
                for(let r = 0; r < t.length; r++){
                    const n = t[r];
                    this.firstTokensByLineNumber.has(n.loc.start.line) || this.firstTokensByLineNumber.set(n.loc.start.line, n), !this.firstTokensByLineNumber.has(n.loc.end.line) && e1.text.slice(n.range[1] - n.loc.end.column, n.range[1]).trim() && this.firstTokensByLineNumber.set(n.loc.end.line, n);
                }
            }
            getFirstTokenOfLine(e1) {
                return this.firstTokensByLineNumber.get(e1.loc.start.line);
            }
            isFirstTokenOfLine(e1) {
                return this.getFirstTokenOfLine(e1) === e1;
            }
            getTokenIndent(e1) {
                return this.sourceCode.text.slice(e1.range[0] - e1.loc.start.column, e1.range[0]);
            }
        }
        class s {
            constructor(e1, t, n, s){
                this._tokenInfo = e1, this._indentSize = t, this._indentType = n, this._indexMap = new r(s), this._indexMap.insert(0, {
                    offset: 0,
                    from: null,
                    force: !1
                }), this._lockedFirstTokens = new WeakMap, this._desiredIndentCache = new WeakMap, this._ignoredTokens = new WeakSet;
            }
            _getOffsetDescriptor(e1) {
                return this._indexMap.findLastNotAfter(e1.range[0]);
            }
            matchOffsetOf(e1, t) {
                this._lockedFirstTokens.set(t, e1);
            }
            setDesiredOffset(e1, t, r) {
                return this.setDesiredOffsets(e1.range, t, r);
            }
            setDesiredOffsets(e1, t, r, n) {
                const s = {
                    offset: r,
                    from: t,
                    force: n
                }, i = this._indexMap.findLastNotAfter(e1[1]), o = t && t.range[0] >= e1[0] && t.range[1] <= e1[1], a = o && this._getOffsetDescriptor(t);
                this._indexMap.deleteRange(e1[0] + 1, e1[1]), this._indexMap.insert(e1[0], s), o && (this._indexMap.insert(t.range[0], a), this._indexMap.insert(t.range[1], s)), this._indexMap.insert(e1[1], i);
            }
            getDesiredIndent(e1) {
                if (!this._desiredIndentCache.has(e1)) {
                    if (this._ignoredTokens.has(e1)) this._desiredIndentCache.set(e1, this._tokenInfo.getTokenIndent(e1));
                    else if (this._lockedFirstTokens.has(e1)) {
                        const t = this._lockedFirstTokens.get(e1);
                        this._desiredIndentCache.set(e1, this.getDesiredIndent(this._tokenInfo.getFirstTokenOfLine(t)) + this._indentType.repeat(t.loc.start.column - this._tokenInfo.getFirstTokenOfLine(t).loc.start.column));
                    } else {
                        const t = this._getOffsetDescriptor(e1), r = !t.from || t.from.loc.start.line !== e1.loc.start.line || /^\s*?\n/u.test(e1.value) || t.force ? t.offset * this._indentSize : 0;
                        this._desiredIndentCache.set(e1, (t.from ? this.getDesiredIndent(t.from) : "") + this._indentType.repeat(r));
                    }
                }
                return this._desiredIndentCache.get(e1);
            }
            ignoreToken(e1) {
                this._tokenInfo.isFirstTokenOfLine(e1) && this._ignoredTokens.add(e1);
            }
            getFirstDependency(e1) {
                return this._getOffsetDescriptor(e1).from;
            }
        }
        const i = {
            oneOf: [
                {
                    type: "integer",
                    minimum: 0
                },
                {
                    enum: [
                        "first",
                        "off"
                    ]
                }
            ]
        };
        return gp = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent indentation",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/indent"
                },
                fixable: "whitespace",
                schema: [
                    {
                        oneOf: [
                            {
                                enum: [
                                    "tab"
                                ]
                            },
                            {
                                type: "integer",
                                minimum: 0
                            }
                        ]
                    },
                    {
                        type: "object",
                        properties: {
                            SwitchCase: {
                                type: "integer",
                                minimum: 0,
                                default: 0
                            },
                            VariableDeclarator: {
                                oneOf: [
                                    i,
                                    {
                                        type: "object",
                                        properties: {
                                            var: i,
                                            let: i,
                                            const: i
                                        },
                                        additionalProperties: !1
                                    }
                                ]
                            },
                            outerIIFEBody: {
                                oneOf: [
                                    {
                                        type: "integer",
                                        minimum: 0
                                    },
                                    {
                                        enum: [
                                            "off"
                                        ]
                                    }
                                ]
                            },
                            MemberExpression: {
                                oneOf: [
                                    {
                                        type: "integer",
                                        minimum: 0
                                    },
                                    {
                                        enum: [
                                            "off"
                                        ]
                                    }
                                ]
                            },
                            FunctionDeclaration: {
                                type: "object",
                                properties: {
                                    parameters: i,
                                    body: {
                                        type: "integer",
                                        minimum: 0
                                    }
                                },
                                additionalProperties: !1
                            },
                            FunctionExpression: {
                                type: "object",
                                properties: {
                                    parameters: i,
                                    body: {
                                        type: "integer",
                                        minimum: 0
                                    }
                                },
                                additionalProperties: !1
                            },
                            StaticBlock: {
                                type: "object",
                                properties: {
                                    body: {
                                        type: "integer",
                                        minimum: 0
                                    }
                                },
                                additionalProperties: !1
                            },
                            CallExpression: {
                                type: "object",
                                properties: {
                                    arguments: i
                                },
                                additionalProperties: !1
                            },
                            ArrayExpression: i,
                            ObjectExpression: i,
                            ImportDeclaration: i,
                            flatTernaryExpressions: {
                                type: "boolean",
                                default: !1
                            },
                            offsetTernaryExpressions: {
                                type: "boolean",
                                default: !1
                            },
                            ignoredNodes: {
                                type: "array",
                                items: {
                                    type: "string",
                                    not: {
                                        pattern: ":exit$"
                                    }
                                }
                            },
                            ignoreComments: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    wrongIndentation: "Expected indentation of {{expected}} but found {{actual}}."
                }
            },
            create (r) {
                let i = "space", o = 4;
                const a = {
                    SwitchCase: 0,
                    VariableDeclarator: {
                        var: 1,
                        let: 1,
                        const: 1
                    },
                    outerIIFEBody: 1,
                    FunctionDeclaration: {
                        parameters: 1,
                        body: 1
                    },
                    FunctionExpression: {
                        parameters: 1,
                        body: 1
                    },
                    StaticBlock: {
                        body: 1
                    },
                    CallExpression: {
                        arguments: 1
                    },
                    MemberExpression: 1,
                    ArrayExpression: 1,
                    ObjectExpression: 1,
                    ImportDeclaration: 1,
                    flatTernaryExpressions: !1,
                    ignoredNodes: [],
                    ignoreComments: !1
                };
                r.options.length && ("tab" === r.options[0] ? (o = 1, i = "tab") : (o = r.options[0], i = "space"), r.options[1] && (Object.assign(a, r.options[1]), "number" != typeof a.VariableDeclarator && "first" !== a.VariableDeclarator || (a.VariableDeclarator = {
                    var: a.VariableDeclarator,
                    let: a.VariableDeclarator,
                    const: a.VariableDeclarator
                })));
                const u = r.sourceCode, l = new n(u), c = new s(l, o, "space" === i ? " " : "\t", u.text.length), p = new WeakSet;
                function f(e1, t, r) {
                    let n;
                    return n = t > 0 ? "space" === i ? t : `${t} ${"space" + (1 === t ? "" : "s")}` : r > 0 ? "tab" === i ? r : `${r} ${"tab" + (1 === r ? "" : "s")}` : "0", {
                        expected: `${e1} ${i}${1 === e1 ? "" : "s"}`,
                        actual: n
                    };
                }
                function d(e1, t) {
                    const n = Array.from(l.getTokenIndent(e1)), s = n.filter((e1)=>" " === e1).length, i = n.filter((e1)=>"\t" === e1).length;
                    r.report({
                        node: e1,
                        messageId: "wrongIndentation",
                        data: f(t.length, s, i),
                        loc: {
                            start: {
                                line: e1.loc.start.line,
                                column: 0
                            },
                            end: {
                                line: e1.loc.start.line,
                                column: e1.loc.start.column
                            }
                        },
                        fix (r) {
                            const n = [
                                e1.range[0] - e1.loc.start.column,
                                e1.range[0]
                            ], s = t;
                            return r.replaceTextRange(n, s);
                        }
                    });
                }
                function h(e1, t) {
                    const r = l.getTokenIndent(e1);
                    return r === t || r.includes(" ") && r.includes("\t");
                }
                function m(t, r, n, s) {
                    function i(t) {
                        let n = u.getTokenBefore(t);
                        for(; e1.isOpeningParenToken(n) && n !== r;)n = u.getTokenBefore(n);
                        return u.getTokenAfter(n);
                    }
                    c.setDesiredOffsets([
                        r.range[1],
                        n.range[0]
                    ], r, "number" == typeof s ? s : 1), c.setDesiredOffset(n, r, 0), "first" === s && t.length && !t[0] || t.forEach((n, o)=>{
                        if (n && ("off" === s && c.ignoreToken(i(n)), 0 !== o)) {
                            if ("first" === s && l.isFirstTokenOfLine(i(n))) c.matchOffsetOf(i(t[0]), i(n));
                            else {
                                const s = t[o - 1], a = s && i(s), l = s && u.getLastToken(s);
                                s && l.loc.end.line - function(t) {
                                    const r = t.match(/\s*$/u)[0].match(e1.createGlobalLinebreakMatcher());
                                    return null === r ? 0 : r.length;
                                }(l.value) > r.loc.end.line && c.setDesiredOffsets([
                                    s.range[1],
                                    n.range[1]
                                ], a, 0);
                            }
                        }
                    });
                }
                function g(t) {
                    if ("BlockStatement" !== t.type) {
                        const r = u.getTokenBefore(t, e1.isNotOpeningParenToken);
                        let n = u.getFirstToken(t), s = u.getLastToken(t);
                        for(; e1.isOpeningParenToken(u.getTokenBefore(n)) && e1.isClosingParenToken(u.getTokenAfter(s));)n = u.getTokenBefore(n), s = u.getTokenAfter(s);
                        c.setDesiredOffsets([
                            n.range[0],
                            s.range[1]
                        ], r, 1);
                    }
                }
                function y(t) {
                    let r;
                    r = t.arguments.length ? u.getFirstTokenBetween(t.callee, t.arguments[0], e1.isOpeningParenToken) : u.getLastToken(t, 1);
                    const n = u.getLastToken(t);
                    if (p.add(r), p.add(n), t.optional) {
                        const n = u.getTokenAfter(t.callee, e1.isQuestionDotToken), s = u.getTokensBetween(t.callee, n, {
                            filter: e1.isClosingParenToken
                        }).length, i = s ? u.getTokenBefore(t.callee, {
                            skip: s - 1
                        }) : u.getFirstToken(t.callee), o = u.getTokenBefore(n), a = o.loc.end.line === r.loc.start.line ? o : i;
                        c.setDesiredOffset(n, a, 1);
                    }
                    const s = "TaggedTemplateExpression" === t.callee.type ? u.getFirstToken(t.callee.quasi) : r, i = u.getTokenBefore(s);
                    c.setDesiredOffset(r, i, 0), m(t.arguments, r, n, a.CallExpression.arguments);
                }
                function E(e1) {
                    const t = new Set(u.getTokens(e1, {
                        includeComments: !0
                    }));
                    t.forEach((e1)=>{
                        if (!t.has(c.getFirstDependency(e1))) {
                            const t = l.getFirstTokenOfLine(e1);
                            e1 === t ? c.ignoreToken(e1) : c.setDesiredOffset(e1, t, 0);
                        }
                    });
                }
                function x(e1, t) {
                    const r = e1.loc.end.line, n = t.loc.start.line;
                    if (r === n || r === n - 1) return !1;
                    for(let e1 = r + 1; e1 < n; ++e1)if (!l.firstTokensByLineNumber.has(e1)) return !0;
                    return !1;
                }
                const C = new Set, S = {
                    "ArrayExpression, ArrayPattern" (t) {
                        const r = u.getFirstToken(t), n = u.getTokenAfter([
                            ...t.elements
                        ].reverse().find((e1)=>e1) || r, e1.isClosingBracketToken);
                        m(t.elements, r, n, a.ArrayExpression);
                    },
                    "ObjectExpression, ObjectPattern" (t) {
                        const r = u.getFirstToken(t), n = u.getTokenAfter(t.properties.length ? t.properties[t.properties.length - 1] : r, e1.isClosingBraceToken);
                        m(t.properties, r, n, a.ObjectExpression);
                    },
                    ArrowFunctionExpression (t) {
                        const r = u.getFirstToken(t, {
                            skip: t.async ? 1 : 0
                        });
                        if (e1.isOpeningParenToken(r)) {
                            const n = r, s = u.getTokenBefore(t.body, e1.isClosingParenToken);
                            p.add(n), p.add(s), m(t.params, n, s, a.FunctionExpression.parameters);
                        }
                        g(t.body);
                    },
                    AssignmentExpression (e1) {
                        const t = u.getFirstTokenBetween(e1.left, e1.right, (t)=>t.value === e1.operator);
                        c.setDesiredOffsets([
                            t.range[0],
                            e1.range[1]
                        ], u.getLastToken(e1.left), 1), c.ignoreToken(t), c.ignoreToken(u.getTokenAfter(t));
                    },
                    "BinaryExpression, LogicalExpression" (e1) {
                        const t = u.getFirstTokenBetween(e1.left, e1.right, (t)=>t.value === e1.operator), r = u.getTokenAfter(t);
                        c.ignoreToken(t), c.ignoreToken(r), c.setDesiredOffset(r, t, 0);
                    },
                    "BlockStatement, ClassBody" (t) {
                        let r;
                        r = t.parent && function(e1) {
                            if (!e1.parent || "CallExpression" !== e1.parent.type || e1.parent.callee !== e1) return !1;
                            let t = e1.parent && e1.parent.parent;
                            for(; "UnaryExpression" === t.type && [
                                "!",
                                "~",
                                "+",
                                "-"
                            ].includes(t.operator) || "AssignmentExpression" === t.type || "LogicalExpression" === t.type || "SequenceExpression" === t.type || "VariableDeclarator" === t.type;)t = t.parent;
                            return ("ExpressionStatement" === t.type || "VariableDeclaration" === t.type) && "Program" === t.parent.type;
                        }(t.parent) ? a.outerIIFEBody : !t.parent || "FunctionExpression" !== t.parent.type && "ArrowFunctionExpression" !== t.parent.type ? t.parent && "FunctionDeclaration" === t.parent.type ? a.FunctionDeclaration.body : 1 : a.FunctionExpression.body, e1.STATEMENT_LIST_PARENTS.has(t.parent.type) || c.setDesiredOffset(u.getFirstToken(t), u.getFirstToken(t.parent), 0), m(t.body, u.getFirstToken(t), u.getLastToken(t), r);
                    },
                    CallExpression: y,
                    "ClassDeclaration[superClass], ClassExpression[superClass]" (t) {
                        const r = u.getFirstToken(t), n = u.getTokenBefore(t.superClass, e1.isNotOpeningParenToken);
                        c.setDesiredOffsets([
                            n.range[0],
                            t.body.range[0]
                        ], r, 1);
                    },
                    ConditionalExpression (t) {
                        const r = u.getFirstToken(t);
                        if (!a.flatTernaryExpressions || !e1.isTokenOnSameLine(t.test, t.consequent) || function(e1, t) {
                            let r = t;
                            for(; r.parent && !r.parent.type.endsWith("Statement") && !r.parent.type.endsWith("Declaration");)r = r.parent;
                            return r = r.parent, !r || r.loc.start.line === e1.loc.start.line;
                        }(r, t)) {
                            const e1 = u.getFirstTokenBetween(t.test, t.consequent, (e1)=>"Punctuator" === e1.type && "?" === e1.value), n = u.getFirstTokenBetween(t.consequent, t.alternate, (e1)=>"Punctuator" === e1.type && ":" === e1.value), s = u.getTokenAfter(e1), i = u.getTokenBefore(n), o = u.getTokenAfter(n);
                            c.setDesiredOffset(e1, r, 1), c.setDesiredOffset(n, r, 1), c.setDesiredOffset(s, r, "Punctuator" === s.type && a.offsetTernaryExpressions ? 2 : 1), i.loc.end.line === o.loc.start.line ? c.setDesiredOffset(o, s, 0) : c.setDesiredOffset(o, r, "Punctuator" === o.type && a.offsetTernaryExpressions ? 2 : 1);
                        }
                    },
                    "DoWhileStatement, WhileStatement, ForInStatement, ForOfStatement, WithStatement": (e1)=>g(e1.body),
                    ExportNamedDeclaration (t) {
                        if (null === t.declaration) {
                            const r = u.getLastToken(t, e1.isClosingBraceToken);
                            m(t.specifiers, u.getFirstToken(t, {
                                skip: 1
                            }), r, 1), t.source && c.setDesiredOffsets([
                                r.range[1],
                                t.range[1]
                            ], u.getFirstToken(t), 1);
                        }
                    },
                    ForStatement (e1) {
                        const t = u.getFirstToken(e1, 1);
                        e1.init && c.setDesiredOffsets(e1.init.range, t, 1), e1.test && c.setDesiredOffsets(e1.test.range, t, 1), e1.update && c.setDesiredOffsets(e1.update.range, t, 1), g(e1.body);
                    },
                    "FunctionDeclaration, FunctionExpression" (e1) {
                        const t = u.getTokenBefore(e1.body), r = u.getTokenBefore(e1.params.length ? e1.params[0] : t);
                        p.add(r), p.add(t), m(e1.params, r, t, a[e1.type].parameters);
                    },
                    IfStatement (e1) {
                        g(e1.consequent), e1.alternate && g(e1.alternate);
                    },
                    ":matches(DoWhileStatement, ForStatement, ForInStatement, ForOfStatement, IfStatement, WhileStatement, WithStatement):exit" (t) {
                        let r;
                        "IfStatement" === t.type ? (r = [
                            t.consequent
                        ], t.alternate && r.push(t.alternate)) : r = [
                            t.body
                        ];
                        for (const n of r){
                            const r = u.getLastToken(n);
                            if (e1.isSemicolonToken(r)) {
                                const n = u.getTokenBefore(r), s = u.getTokenAfter(r);
                                !e1.isTokenOnSameLine(n, r) && s && e1.isTokenOnSameLine(r, s) && c.setDesiredOffset(r, u.getFirstToken(t), 0);
                            }
                        }
                    },
                    ImportDeclaration (t) {
                        if (t.specifiers.some((e1)=>"ImportSpecifier" === e1.type)) {
                            const r = u.getFirstToken(t, e1.isOpeningBraceToken), n = u.getLastToken(t, e1.isClosingBraceToken);
                            m(t.specifiers.filter((e1)=>"ImportSpecifier" === e1.type), r, n, a.ImportDeclaration);
                        }
                        const r = u.getLastToken(t, (e1)=>"Identifier" === e1.type && "from" === e1.value), n = u.getLastToken(t, (e1)=>"String" === e1.type), s = u.getLastToken(t, (e1)=>"Punctuator" === e1.type && ";" === e1.value);
                        if (r) {
                            const e1 = s && s.range[1] === n.range[1] ? t.range[1] : n.range[1];
                            c.setDesiredOffsets([
                                r.range[0],
                                e1
                            ], u.getFirstToken(t), 1);
                        }
                    },
                    ImportExpression (e1) {
                        const t = u.getFirstToken(e1, 1), r = u.getLastToken(e1);
                        p.add(t), p.add(r), c.setDesiredOffset(t, u.getTokenBefore(t), 0), m([
                            e1.source
                        ], t, r, a.CallExpression.arguments);
                    },
                    "MemberExpression, JSXMemberExpression, MetaProperty" (t) {
                        const r = "MetaProperty" === t.type ? t.meta : t.object, n = u.getFirstTokenBetween(r, t.property, e1.isNotClosingParenToken), s = u.getTokenAfter(n), i = u.getTokensBetween(r, t.property, {
                            filter: e1.isClosingParenToken
                        }).length, o = i ? u.getTokenBefore(r, {
                            skip: i - 1
                        }) : u.getFirstToken(r), l = u.getTokenBefore(n), p = t.computed ? n : s;
                        t.computed && (c.setDesiredOffset(u.getLastToken(t), n, 0), c.setDesiredOffsets(t.property.range, n, 1));
                        const f = l.loc.end.line === p.loc.start.line ? l : o;
                        "number" == typeof a.MemberExpression ? (c.setDesiredOffset(n, f, a.MemberExpression), c.setDesiredOffset(s, t.computed ? n : f, a.MemberExpression)) : (c.ignoreToken(n), c.ignoreToken(s), c.setDesiredOffset(n, f, 0), c.setDesiredOffset(s, n, 0));
                    },
                    NewExpression (t) {
                        (t.arguments.length > 0 || e1.isClosingParenToken(u.getLastToken(t)) && e1.isOpeningParenToken(u.getLastToken(t, 1))) && y(t);
                    },
                    Property (t) {
                        if (!t.shorthand && !t.method && "init" === t.kind) {
                            const r = u.getFirstTokenBetween(t.key, t.value, e1.isColonToken);
                            c.ignoreToken(u.getTokenAfter(r));
                        }
                    },
                    PropertyDefinition (t) {
                        const r = u.getFirstToken(t), n = u.getLastToken(t);
                        let s = null;
                        if (t.computed) {
                            const n = u.getTokenBefore(t.key, e1.isOpeningBracketToken), i = s = u.getTokenAfter(t.key, e1.isClosingBracketToken), o = [
                                n.range[1],
                                i.range[0]
                            ];
                            n !== r && c.setDesiredOffset(n, r, 0), c.setDesiredOffsets(o, n, 1), c.setDesiredOffset(i, n, 0);
                        } else {
                            const e1 = s = u.getFirstToken(t.key);
                            e1 !== r && c.setDesiredOffset(e1, r, 1);
                        }
                        if (t.value) {
                            const r = u.getTokenBefore(t.value, e1.isEqToken), i = u.getTokenAfter(r);
                            c.setDesiredOffset(r, s, 1), c.setDesiredOffset(i, r, 1), e1.isSemicolonToken(n) && c.setDesiredOffset(n, r, 1);
                        } else e1.isSemicolonToken(n) && c.setDesiredOffset(n, s, 1);
                    },
                    StaticBlock (e1) {
                        const t = u.getFirstToken(e1, {
                            skip: 1
                        }), r = u.getLastToken(e1);
                        m(e1.body, t, r, a.StaticBlock.body);
                    },
                    SwitchStatement (t) {
                        const r = u.getTokenAfter(t.discriminant, e1.isOpeningBraceToken), n = u.getLastToken(t);
                        c.setDesiredOffsets([
                            r.range[1],
                            n.range[0]
                        ], r, a.SwitchCase), t.cases.length && u.getTokensBetween(t.cases[t.cases.length - 1], n, {
                            includeComments: !0,
                            filter: e1.isCommentToken
                        }).forEach((e1)=>c.ignoreToken(e1));
                    },
                    SwitchCase (e1) {
                        if (1 !== e1.consequent.length || "BlockStatement" !== e1.consequent[0].type) {
                            const t = u.getFirstToken(e1), r = u.getTokenAfter(e1);
                            c.setDesiredOffsets([
                                t.range[1],
                                r.range[0]
                            ], t, 1);
                        }
                    },
                    TemplateLiteral (e1) {
                        e1.expressions.forEach((t, r)=>{
                            const n = e1.quasis[r], s = e1.quasis[r + 1], i = n.loc.start.line === n.loc.end.line ? u.getFirstToken(n) : null;
                            c.setDesiredOffsets([
                                n.range[1],
                                s.range[0]
                            ], i, 1), c.setDesiredOffset(u.getFirstToken(s), i, 0);
                        });
                    },
                    VariableDeclaration (t) {
                        let r = Object.prototype.hasOwnProperty.call(a.VariableDeclarator, t.kind) ? a.VariableDeclarator[t.kind] : 1;
                        const n = u.getFirstToken(t), s = u.getLastToken(t);
                        if ("first" === a.VariableDeclarator[t.kind]) {
                            if (t.declarations.length > 1) return void m(t.declarations, n, s, "first");
                            r = 1;
                        }
                        t.declarations[t.declarations.length - 1].loc.start.line > t.loc.start.line ? c.setDesiredOffsets(t.range, n, r, !0) : c.setDesiredOffsets(t.range, n, r), e1.isSemicolonToken(s) && c.ignoreToken(s);
                    },
                    VariableDeclarator (t) {
                        if (t.init) {
                            const r = u.getTokenBefore(t.init, e1.isNotOpeningParenToken), n = u.getTokenAfter(r);
                            c.ignoreToken(r), c.ignoreToken(n), c.setDesiredOffsets([
                                n.range[0],
                                t.range[1]
                            ], r, 1), c.setDesiredOffset(r, u.getLastToken(t.id), 0);
                        }
                    },
                    "JSXAttribute[value]" (e1) {
                        const t = u.getFirstTokenBetween(e1.name, e1.value, (e1)=>"Punctuator" === e1.type && "=" === e1.value);
                        c.setDesiredOffsets([
                            t.range[0],
                            e1.value.range[1]
                        ], u.getFirstToken(e1.name), 1);
                    },
                    JSXElement (e1) {
                        e1.closingElement && m(e1.children, u.getFirstToken(e1.openingElement), u.getFirstToken(e1.closingElement), 1);
                    },
                    JSXOpeningElement (e1) {
                        const t = u.getFirstToken(e1);
                        let r;
                        e1.selfClosing ? (r = u.getLastToken(e1, {
                            skip: 1
                        }), c.setDesiredOffset(u.getLastToken(e1), r, 0)) : r = u.getLastToken(e1), c.setDesiredOffsets(e1.name.range, u.getFirstToken(e1)), m(e1.attributes, t, r, 1);
                    },
                    JSXClosingElement (e1) {
                        const t = u.getFirstToken(e1);
                        c.setDesiredOffsets(e1.name.range, t, 1);
                    },
                    JSXFragment (e1) {
                        const t = u.getFirstToken(e1.openingFragment), r = u.getFirstToken(e1.closingFragment);
                        m(e1.children, t, r, 1);
                    },
                    JSXOpeningFragment (e1) {
                        const t = u.getFirstToken(e1), r = u.getLastToken(e1);
                        c.setDesiredOffsets(e1.range, t, 1), c.matchOffsetOf(t, r);
                    },
                    JSXClosingFragment (t) {
                        const r = u.getFirstToken(t), n = u.getLastToken(t, {
                            skip: 1
                        }), s = u.getLastToken(t), i = e1.isTokenOnSameLine(n, s) ? n : s;
                        c.setDesiredOffsets(t.range, r, 1), c.matchOffsetOf(r, i);
                    },
                    JSXExpressionContainer (e1) {
                        const t = u.getFirstToken(e1), r = u.getLastToken(e1);
                        c.setDesiredOffsets([
                            t.range[1],
                            r.range[0]
                        ], t, 1);
                    },
                    JSXSpreadAttribute (e1) {
                        const t = u.getFirstToken(e1), r = u.getLastToken(e1);
                        c.setDesiredOffsets([
                            t.range[1],
                            r.range[0]
                        ], t, 1);
                    },
                    "*" (e1) {
                        const t = u.getFirstToken(e1);
                        t && !C.has(t) && c.setDesiredOffsets(e1.range, t, 0);
                    }
                }, b = [], v = {};
                for (const [e1, t] of Object.entries(S))v[e1] = (e1)=>b.push({
                        listener: t,
                        node: e1
                    });
                const A = new Set;
                function T(e1) {
                    A.add(e1), C.add(u.getFirstToken(e1));
                }
                const R = a.ignoredNodes.reduce((e1, t)=>Object.assign(e1, {
                        [t]: T
                    }), {});
                return Object.assign(v, R, {
                    "*:exit" (e1) {
                        t.has(e1.type) || T(e1);
                    },
                    "Program:exit" () {
                        a.ignoreComments && u.getAllComments().forEach((e1)=>c.ignoreToken(e1));
                        for(let e1 = 0; e1 < b.length; e1++){
                            const t = b[e1];
                            A.has(t.node) || t.listener(t.node);
                        }
                        A.forEach(E), function(t) {
                            const r = [], n = [];
                            for(let s = 0; s < t.length; s++){
                                const i = t[s];
                                e1.isOpeningParenToken(i) ? r.push(i) : e1.isClosingParenToken(i) && n.push({
                                    left: r.pop(),
                                    right: i
                                });
                            }
                            for(let e1 = n.length - 1; e1 >= 0; e1--){
                                const t = n[e1].left, r = n[e1].right;
                                if (!p.has(t) && !p.has(r)) {
                                    const e1 = new Set(u.getTokensBetween(t, r));
                                    e1.forEach((r)=>{
                                        e1.has(c.getFirstDependency(r)) || c.setDesiredOffset(r, t, 1);
                                    });
                                }
                                c.setDesiredOffset(r, t, 0);
                            }
                        }(u.ast.tokens);
                        const t = new WeakMap;
                        for(let e1 = 0; e1 < u.ast.comments.length; e1++){
                            const r = u.ast.comments[e1], n = u.getTokenBefore(r, {
                                includeComments: !0
                            }), s = t.has(n) ? t.get(n) : n;
                            t.set(r, s);
                        }
                        for(let r = 1; r < u.lines.length + 1; r++){
                            if (!l.firstTokensByLineNumber.has(r)) continue;
                            const n = l.firstTokensByLineNumber.get(r);
                            if (n.loc.start.line === r) {
                                if (e1.isCommentToken(n)) {
                                    const r = t.get(n), s = r ? u.getTokenAfter(r) : u.ast.tokens[0], i = r && !x(r, n), o = s && !x(n, s);
                                    if (s && e1.isSemicolonToken(s) && !e1.isTokenOnSameLine(n, s) && c.setDesiredOffset(n, s, 0), i && h(n, c.getDesiredIndent(r)) || o && h(n, c.getDesiredIndent(s))) continue;
                                }
                                h(n, c.getDesiredIndent(n)) || d(n, c.getDesiredIndent(n));
                            }
                        }
                    }
                });
            }
        }, gp;
    }
    function bd() {
        if (xp) return Ep;
        xp = 1;
        const e1 = Ll();
        return Ep = {
            meta: {
                type: "layout",
                docs: {
                    description: "Enforce consistent indentation",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/indent-legacy"
                },
                deprecated: !0,
                replacedBy: [
                    "indent"
                ],
                fixable: "whitespace",
                schema: [
                    {
                        oneOf: [
                            {
                                enum: [
                                    "tab"
                                ]
                            },
                            {
                                type: "integer",
                                minimum: 0
                            }
                        ]
                    },
                    {
                        type: "object",
                        properties: {
                            SwitchCase: {
                                type: "integer",
                                minimum: 0
                            },
                            VariableDeclarator: {
                                oneOf: [
                                    {
                                        type: "integer",
                                        minimum: 0
                                    },
                                    {
                                        type: "object",
                                        properties: {
                                            var: {
                                                type: "integer",
                                                minimum: 0
                                            },
                                            let: {
                                                type: "integer",
                                                minimum: 0
                                            },
                                            const: {
                                                type: "integer",
                                                minimum: 0
                                            }
                                        }
                                    }
                                ]
                            },
                            outerIIFEBody: {
                                type: "integer",
                                minimum: 0
                            },
                            MemberExpression: {
                                type: "integer",
                                minimum: 0
                            },
                            FunctionDeclaration: {
                                type: "object",
                                properties: {
                                    parameters: {
                                        oneOf: [
                                            {
                                                type: "integer",
                                                minimum: 0
                                            },
                                            {
                                                enum: [
                                                    "first"
                                                ]
                                            }
                                        ]
                                    },
                                    body: {
                                        type: "integer",
                                        minimum: 0
                                    }
                                }
                            },
                            FunctionExpression: {
                                type: "object",
                                properties: {
                                    parameters: {
                                        oneOf: [
                                            {
                                                type: "integer",
                                                minimum: 0
                                            },
                                            {
                                                enum: [
                                                    "first"
                                                ]
                                            }
                                        ]
                                    },
                                    body: {
                                        type: "integer",
                                        minimum: 0
                                    }
                                }
                            },
                            CallExpression: {
                                type: "object",
                                properties: {
                                    parameters: {
                                        oneOf: [
                                            {
                                                type: "integer",
                                                minimum: 0
                                            },
                                            {
                                                enum: [
                                                    "first"
                                                ]
                                            }
                                        ]
                                    }
                                }
                            },
                            ArrayExpression: {
                                oneOf: [
                                    {
                                        type: "integer",
                                        minimum: 0
                                    },
                                    {
                                        enum: [
                                            "first"
                                        ]
                                    }
                                ]
                            },
                            ObjectExpression: {
                                oneOf: [
                                    {
                                        type: "integer",
                                        minimum: 0
                                    },
                                    {
                                        enum: [
                                            "first"
                                        ]
                                    }
                                ]
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    expected: "Expected indentation of {{expected}} but found {{actual}}."
                }
            },
            create (t) {
                const r = null;
                let n = "space", s = 4;
                const i = {
                    SwitchCase: 0,
                    VariableDeclarator: {
                        var: 1,
                        let: 1,
                        const: 1
                    },
                    outerIIFEBody: null,
                    FunctionDeclaration: {
                        parameters: r,
                        body: 1
                    },
                    FunctionExpression: {
                        parameters: r,
                        body: 1
                    },
                    CallExpression: {
                        arguments: r
                    },
                    ArrayExpression: 1,
                    ObjectExpression: 1
                }, o = t.sourceCode;
                if (t.options.length && ("tab" === t.options[0] ? (s = 1, n = "tab") : "number" == typeof t.options[0] && (s = t.options[0], n = "space"), t.options[1])) {
                    const e1 = t.options[1];
                    i.SwitchCase = e1.SwitchCase || 0;
                    const r = e1.VariableDeclarator;
                    "number" == typeof r ? i.VariableDeclarator = {
                        var: r,
                        let: r,
                        const: r
                    } : "object" == typeof r && Object.assign(i.VariableDeclarator, r), "number" == typeof e1.outerIIFEBody && (i.outerIIFEBody = e1.outerIIFEBody), "number" == typeof e1.MemberExpression && (i.MemberExpression = e1.MemberExpression), "object" == typeof e1.FunctionDeclaration && Object.assign(i.FunctionDeclaration, e1.FunctionDeclaration), "object" == typeof e1.FunctionExpression && Object.assign(i.FunctionExpression, e1.FunctionExpression), "object" == typeof e1.CallExpression && Object.assign(i.CallExpression, e1.CallExpression), "number" != typeof e1.ArrayExpression && "string" != typeof e1.ArrayExpression || (i.ArrayExpression = e1.ArrayExpression), "number" != typeof e1.ObjectExpression && "string" != typeof e1.ObjectExpression || (i.ObjectExpression = e1.ObjectExpression);
                }
                const a = {};
                function u(e1, t, r) {
                    const s = "space" + (1 === t ? "" : "s"), i = "tab" + (1 === r ? "" : "s");
                    let o;
                    return o = t > 0 && r > 0 ? `${t} ${s} and ${r} ${i}` : t > 0 ? "space" === n ? t : `${t} ${s}` : r > 0 ? "tab" === n ? r : `${r} ${i}` : "0", {
                        expected: `${e1} ${n}${1 === e1 ? "" : "s"}`,
                        actual: o
                    };
                }
                function l(e1, r, s, i, o, a) {
                    if (s && i) return;
                    const l = ("space" === n ? " " : "\t").repeat(r), c = a ? [
                        e1.range[1] - e1.loc.end.column,
                        e1.range[1] - e1.loc.end.column + s + i
                    ] : [
                        e1.range[0] - e1.loc.start.column,
                        e1.range[0] - e1.loc.start.column + s + i
                    ];
                    t.report({
                        node: e1,
                        loc: o,
                        messageId: "expected",
                        data: u(r, s, i),
                        fix: (e1)=>e1.replaceTextRange(c, l)
                    });
                }
                function c(e1, t) {
                    const r = t ? o.getLastToken(e1) : o.getFirstToken(e1), s = o.getText(r, r.loc.start.column).split(""), i = s.slice(0, s.findIndex((e1)=>" " !== e1 && "\t" !== e1)), a = i.filter((e1)=>" " === e1).length, u = i.filter((e1)=>"\t" === e1).length;
                    return {
                        space: a,
                        tab: u,
                        goodChar: "space" === n ? a : u,
                        badChar: "space" === n ? u : a
                    };
                }
                function p(e1, t) {
                    const r = !0 === t ? o.getLastToken(e1, 1) : o.getTokenBefore(e1);
                    return (!0 === t ? e1.loc.end.line : e1.loc.start.line) !== (r ? r.loc.end.line : -1);
                }
                function f(e1, t) {
                    const r = c(e1, !1);
                    if ("ArrayExpression" === e1.type || "ObjectExpression" === e1.type || r.goodChar === t && 0 === r.badChar || !p(e1) || l(e1, t, r.space, r.tab), "IfStatement" === e1.type && e1.alternate) f(o.getTokenBefore(e1.alternate), t), p(e1.alternate) || f(e1.alternate, t);
                    if ("TryStatement" === e1.type && e1.handler) f(o.getFirstToken(e1.handler), t);
                    if ("TryStatement" === e1.type && e1.finalizer) f(o.getTokenBefore(e1.finalizer), t);
                    if ("DoWhileStatement" === e1.type) f(o.getTokenAfter(e1.body), t);
                }
                function d(e1, t) {
                    e1.forEach((e1)=>f(e1, t));
                }
                function h(e1, t) {
                    const r = o.getLastToken(e1), n = c(r, !0);
                    n.goodChar === t && 0 === n.badChar || !p(e1, !0) || l(e1, t, n.space, n.tab, {
                        line: r.loc.start.line,
                        column: r.loc.start.column
                    }, !0);
                }
                function m(e1, t, r) {
                    let n = e1.parent;
                    const s = new Set(r || [
                        "Program"
                    ]);
                    for(; n.type !== t && !s.has(n.type) && "Program" !== n.type;)n = n.parent;
                    return n.type === t ? n : null;
                }
                function g(e1) {
                    return m(e1, "VariableDeclarator");
                }
                function y(e1, t) {
                    return t && t.parent.loc.start.line === e1.loc.start.line && t.parent.declarations.length > 1;
                }
                function E(e1) {
                    const t = o.getLastToken(e1);
                    return e1.loc.start.line === t.loc.end.line;
                }
                function x(e1) {
                    if (E(e1)) return;
                    let t, r, n = "ArrayExpression" === e1.type ? e1.elements : e1.properties;
                    n = n.filter((e1)=>null !== e1);
                    const o = g(e1);
                    if (p(e1)) {
                        const r = e1.parent;
                        if (t = c(r).goodChar, !(o && o.loc.start.line === e1.loc.start.line || "VariableDeclarator" === r.type && o !== o.parent.declarations[0])) {
                            if ("VariableDeclarator" === r.type && o.loc.start.line === r.loc.start.line) t += s * i.VariableDeclarator[o.parent.kind];
                            else if ("ObjectExpression" === r.type || "ArrayExpression" === r.type) {
                                const n = "ObjectExpression" === e1.parent.type ? e1.parent.properties : e1.parent.elements;
                                n[0] && n[0].loc.start.line === r.loc.start.line && n[0].loc.end.line !== r.loc.start.line || ("number" == typeof i[r.type] ? t += i[r.type] * s : t = n[0].loc.start.column);
                            } else "CallExpression" === r.type || "NewExpression" === r.type ? "number" == typeof i.CallExpression.arguments ? t += i.CallExpression.arguments * s : "first" === i.CallExpression.arguments ? r.arguments.includes(e1) && (t = r.arguments[0].loc.start.column) : t += s : "LogicalExpression" !== r.type && "ArrowFunctionExpression" !== r.type || (t += s);
                        }
                        !function(e1, t) {
                            const r = c(e1, !1);
                            r.goodChar === t && 0 === r.badChar || !p(e1) || l(e1, t, r.space, r.tab, {
                                line: e1.loc.start.line,
                                column: e1.loc.start.column
                            });
                        }(e1, t);
                    } else t = c(e1).goodChar;
                    r = "first" === i[e1.type] ? n.length ? n[0].loc.start.column : 0 : t + s * i[e1.type], y(e1, o) && (r += s * i.VariableDeclarator[o.parent.kind]), d(n, r), n.length > 0 && n[n.length - 1].loc.end.line === e1.loc.end.line || h(e1, t + (y(e1, o) ? i.VariableDeclarator[o.parent.kind] * s : 0));
                }
                function C(e1) {
                    if (E(e1)) return;
                    if (e1.parent && ("FunctionExpression" === e1.parent.type || "FunctionDeclaration" === e1.parent.type || "ArrowFunctionExpression" === e1.parent.type)) return void function(e1) {
                        const t = e1.parent;
                        let r;
                        if (r = !t.parent || "Property" !== t.parent.type && "ArrayExpression" !== t.parent.type ? c(t).goodChar : c(t, !1).goodChar, "CallExpression" === t.parent.type) {
                            const n = t.parent;
                            "FunctionExpression" !== t.type && "ArrowFunctionExpression" !== t.type ? n && n.loc.start.line < e1.loc.start.line && (r = c(n).goodChar) : function(e1) {
                                const t = e1.parent;
                                return t.arguments.length >= 2 && t.arguments[1] === e1 && t.arguments[0].loc.end.line > t.arguments[0].loc.start.line;
                            }(t) && n.callee.loc.start.line === n.callee.loc.end.line && !p(t) && (r = c(n).goodChar);
                        }
                        let n = s;
                        null !== i.outerIIFEBody && function(e1) {
                            const t = e1.parent;
                            let r = t.parent;
                            if ("CallExpression" !== t.type || t.callee !== e1) return !1;
                            for(; "UnaryExpression" === r.type && ("!" === r.operator || "~" === r.operator || "+" === r.operator || "-" === r.operator) || "AssignmentExpression" === r.type || "LogicalExpression" === r.type || "SequenceExpression" === r.type || "VariableDeclarator" === r.type;)r = r.parent;
                            return ("ExpressionStatement" === r.type || "VariableDeclaration" === r.type) && r.parent && "Program" === r.parent.type;
                        }(t) ? n = i.outerIIFEBody * s : "FunctionExpression" === t.type ? n = i.FunctionExpression.body * s : "FunctionDeclaration" === t.type && (n = i.FunctionDeclaration.body * s), r += n;
                        const o = g(e1);
                        o && y(e1, o) && (r += s * i.VariableDeclarator[o.parent.kind]), e1.body.length > 0 && d(e1.body, r), h(e1, r - n);
                    }(e1);
                    let t, r = [];
                    t = e1.parent && [
                        "IfStatement",
                        "WhileStatement",
                        "ForStatement",
                        "ForInStatement",
                        "ForOfStatement",
                        "DoWhileStatement",
                        "ClassDeclaration",
                        "TryStatement"
                    ].includes(e1.parent.type) && function(e1) {
                        return "BlockStatement" === e1.type || "ClassBody" === e1.type || e1.body && "BlockStatement" === e1.body.type || e1.consequent && "BlockStatement" === e1.consequent.type;
                    }(e1) ? c(e1.parent).goodChar : e1.parent && "CatchClause" === e1.parent.type ? c(e1.parent.parent).goodChar : c(e1).goodChar, r = "IfStatement" === e1.type && "BlockStatement" !== e1.consequent.type ? [
                        e1.consequent
                    ] : Array.isArray(e1.body) ? e1.body : [
                        e1.body
                    ], r.length > 0 && d(r, t + s), "BlockStatement" === e1.type && h(e1, t);
                }
                function S(e1) {
                    "BlockStatement" !== e1.body.type && C(e1);
                }
                function b(e1, t) {
                    const r = "SwitchStatement" === e1.type ? e1 : e1.parent, n = void 0 === t ? c(r).goodChar : t;
                    let o;
                    return a[r.loc.start.line] ? a[r.loc.start.line] : (o = r.cases.length > 0 && 0 === i.SwitchCase ? n : n + s * i.SwitchCase, a[r.loc.start.line] = o, o);
                }
                return {
                    Program (e1) {
                        e1.body.length > 0 && d(e1.body, c(e1).goodChar);
                    },
                    ClassBody: C,
                    BlockStatement: C,
                    WhileStatement: S,
                    ForStatement: S,
                    ForInStatement: S,
                    ForOfStatement: S,
                    DoWhileStatement: S,
                    IfStatement (e1) {
                        "BlockStatement" !== e1.consequent.type && e1.consequent.loc.start.line > e1.loc.start.line && C(e1);
                    },
                    VariableDeclaration (e1) {
                        e1.declarations[e1.declarations.length - 1].loc.start.line > e1.declarations[0].loc.start.line && function(e1) {
                            const t = function(e1) {
                                return e1.declarations.reduce((t, r)=>{
                                    const n = t[t.length - 1];
                                    return (r.loc.start.line !== e1.loc.start.line && !n || n && n.loc.start.line !== r.loc.start.line) && t.push(r), t;
                                }, []);
                            }(e1), r = c(e1).goodChar, n = t[t.length - 1], a = r + s * i.VariableDeclarator[e1.kind];
                            if (d(t, a), o.getLastToken(e1).loc.end.line <= n.loc.end.line) return;
                            const u = o.getTokenBefore(n);
                            "," === u.value ? h(e1, c(u).goodChar) : h(e1, a - s);
                        }(e1);
                    },
                    ObjectExpression (e1) {
                        x(e1);
                    },
                    ArrayExpression (e1) {
                        x(e1);
                    },
                    MemberExpression (e1) {
                        if (void 0 === i.MemberExpression) return;
                        if (E(e1)) return;
                        if (m(e1, "VariableDeclarator", [
                            "FunctionExpression",
                            "ArrowFunctionExpression"
                        ])) return;
                        if (m(e1, "AssignmentExpression", [
                            "FunctionExpression"
                        ])) return;
                        const t = c(e1).goodChar + s * i.MemberExpression, r = [
                            e1.property
                        ], n = o.getTokenBefore(e1.property);
                        "Punctuator" === n.type && "." === n.value && r.push(n), d(r, t);
                    },
                    SwitchStatement (e1) {
                        const t = c(e1).goodChar, r = b(e1, t);
                        d(e1.cases, r), h(e1, t);
                    },
                    SwitchCase (e1) {
                        if (E(e1)) return;
                        const t = b(e1);
                        d(e1.consequent, t + s);
                    },
                    FunctionDeclaration (e1) {
                        E(e1) || ("first" === i.FunctionDeclaration.parameters && e1.params.length ? d(e1.params.slice(1), e1.params[0].loc.start.column) : null !== i.FunctionDeclaration.parameters && d(e1.params, c(e1).goodChar + s * i.FunctionDeclaration.parameters));
                    },
                    FunctionExpression (e1) {
                        E(e1) || ("first" === i.FunctionExpression.parameters && e1.params.length ? d(e1.params.slice(1), e1.params[0].loc.start.column) : null !== i.FunctionExpression.parameters && d(e1.params, c(e1).goodChar + s * i.FunctionExpression.parameters));
                    },
                    ReturnStatement (t) {
                        if (E(t)) return;
                        const r = c(t).goodChar;
                        !function(e1) {
                            const t = o.getText(e1).replace(o.getText(e1.argument), "");
                            return /^return\s*?\(\s*?\);*?/u.test(t);
                        }(t) ? f(t, r) : function(t, r) {
                            const n = o.getLastToken(t, e1.isClosingParenToken);
                            if (o.getText(n, n.loc.start.column).slice(0, -1).trim()) return;
                            const s = c(n, !0);
                            s.goodChar !== r && l(t, r, s.space, s.tab, {
                                line: n.loc.start.line,
                                column: n.loc.start.column
                            }, !0);
                        }(t, r);
                    },
                    CallExpression (e1) {
                        E(e1) || ("first" === i.CallExpression.arguments && e1.arguments.length ? d(e1.arguments.slice(1), e1.arguments[0].loc.start.column) : null !== i.CallExpression.arguments && d(e1.arguments, c(e1).goodChar + s * i.CallExpression.arguments));
                    }
                };
            }
        }, Ep;
    }
    function vd() {
        if (vp) return bp;
        vp = 1;
        const e1 = Ll(), t = {
            "prefer-double": {
                quote: '"',
                description: "singlequote",
                convert: (e1)=>e1.replace(/'/gu, '"')
            },
            "prefer-single": {
                quote: "'",
                description: "doublequote",
                convert: (e1)=>e1.replace(/"/gu, "'")
            }
        };
        return bp = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce the consistent use of either double or single quotes in JSX attributes",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/jsx-quotes"
                },
                fixable: "whitespace",
                schema: [
                    {
                        enum: [
                            "prefer-single",
                            "prefer-double"
                        ]
                    }
                ],
                messages: {
                    unexpected: "Unexpected usage of {{description}}."
                }
            },
            create (r) {
                const n = r.options[0] || "prefer-double", s = t[n];
                return {
                    JSXAttribute (t) {
                        const n = t.value;
                        n && e1.isStringLiteral(n) && !function(t) {
                            return t.value.includes(s.quote) || e1.isSurroundedBy(t.raw, s.quote);
                        }(n) && r.report({
                            node: n,
                            messageId: "unexpected",
                            data: {
                                description: s.description
                            },
                            fix: (e1)=>e1.replaceText(n, s.convert(n.raw))
                        });
                    }
                };
            }
        }, bp;
    }
    function Ad() {
        if (Tp) return Ap;
        Tp = 1;
        const e1 = Ll(), { getGraphemeCount: t } = id();
        function r(e1) {
            return e1[e1.length - 1];
        }
        function n(e1) {
            return e1.loc.end.line === e1.loc.start.line;
        }
        function s(e1, t) {
            return e1.mode = t.mode || "strict", void 0 !== t.beforeColon ? e1.beforeColon = +t.beforeColon : e1.beforeColon = 0, void 0 !== t.afterColon ? e1.afterColon = +t.afterColon : e1.afterColon = 1, void 0 !== t.align && ("object" == typeof t.align ? e1.align = t.align : e1.align = {
                on: t.align,
                mode: e1.mode,
                beforeColon: e1.beforeColon,
                afterColon: e1.afterColon
            }), e1;
        }
        return Ap = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent spacing between keys and values in object literal properties",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/key-spacing"
                },
                fixable: "whitespace",
                schema: [
                    {
                        anyOf: [
                            {
                                type: "object",
                                properties: {
                                    align: {
                                        anyOf: [
                                            {
                                                enum: [
                                                    "colon",
                                                    "value"
                                                ]
                                            },
                                            {
                                                type: "object",
                                                properties: {
                                                    mode: {
                                                        enum: [
                                                            "strict",
                                                            "minimum"
                                                        ]
                                                    },
                                                    on: {
                                                        enum: [
                                                            "colon",
                                                            "value"
                                                        ]
                                                    },
                                                    beforeColon: {
                                                        type: "boolean"
                                                    },
                                                    afterColon: {
                                                        type: "boolean"
                                                    }
                                                },
                                                additionalProperties: !1
                                            }
                                        ]
                                    },
                                    mode: {
                                        enum: [
                                            "strict",
                                            "minimum"
                                        ]
                                    },
                                    beforeColon: {
                                        type: "boolean"
                                    },
                                    afterColon: {
                                        type: "boolean"
                                    }
                                },
                                additionalProperties: !1
                            },
                            {
                                type: "object",
                                properties: {
                                    singleLine: {
                                        type: "object",
                                        properties: {
                                            mode: {
                                                enum: [
                                                    "strict",
                                                    "minimum"
                                                ]
                                            },
                                            beforeColon: {
                                                type: "boolean"
                                            },
                                            afterColon: {
                                                type: "boolean"
                                            }
                                        },
                                        additionalProperties: !1
                                    },
                                    multiLine: {
                                        type: "object",
                                        properties: {
                                            align: {
                                                anyOf: [
                                                    {
                                                        enum: [
                                                            "colon",
                                                            "value"
                                                        ]
                                                    },
                                                    {
                                                        type: "object",
                                                        properties: {
                                                            mode: {
                                                                enum: [
                                                                    "strict",
                                                                    "minimum"
                                                                ]
                                                            },
                                                            on: {
                                                                enum: [
                                                                    "colon",
                                                                    "value"
                                                                ]
                                                            },
                                                            beforeColon: {
                                                                type: "boolean"
                                                            },
                                                            afterColon: {
                                                                type: "boolean"
                                                            }
                                                        },
                                                        additionalProperties: !1
                                                    }
                                                ]
                                            },
                                            mode: {
                                                enum: [
                                                    "strict",
                                                    "minimum"
                                                ]
                                            },
                                            beforeColon: {
                                                type: "boolean"
                                            },
                                            afterColon: {
                                                type: "boolean"
                                            }
                                        },
                                        additionalProperties: !1
                                    }
                                },
                                additionalProperties: !1
                            },
                            {
                                type: "object",
                                properties: {
                                    singleLine: {
                                        type: "object",
                                        properties: {
                                            mode: {
                                                enum: [
                                                    "strict",
                                                    "minimum"
                                                ]
                                            },
                                            beforeColon: {
                                                type: "boolean"
                                            },
                                            afterColon: {
                                                type: "boolean"
                                            }
                                        },
                                        additionalProperties: !1
                                    },
                                    multiLine: {
                                        type: "object",
                                        properties: {
                                            mode: {
                                                enum: [
                                                    "strict",
                                                    "minimum"
                                                ]
                                            },
                                            beforeColon: {
                                                type: "boolean"
                                            },
                                            afterColon: {
                                                type: "boolean"
                                            }
                                        },
                                        additionalProperties: !1
                                    },
                                    align: {
                                        type: "object",
                                        properties: {
                                            mode: {
                                                enum: [
                                                    "strict",
                                                    "minimum"
                                                ]
                                            },
                                            on: {
                                                enum: [
                                                    "colon",
                                                    "value"
                                                ]
                                            },
                                            beforeColon: {
                                                type: "boolean"
                                            },
                                            afterColon: {
                                                type: "boolean"
                                            }
                                        },
                                        additionalProperties: !1
                                    }
                                },
                                additionalProperties: !1
                            }
                        ]
                    }
                ],
                messages: {
                    extraKey: "Extra space after {{computed}}key '{{key}}'.",
                    extraValue: "Extra space before value for {{computed}}key '{{key}}'.",
                    missingKey: "Missing space after {{computed}}key '{{key}}'.",
                    missingValue: "Missing space before value for {{computed}}key '{{key}}'."
                }
            },
            create (i) {
                const o = i.options[0] || {}, a = (p = {}, "object" == typeof (f = o).align ? (p.align = s({}, f.align), p.align.on = f.align.on || "colon", p.align.mode = f.align.mode || "strict", p.multiLine = s({}, f.multiLine || f), p.singleLine = s({}, f.singleLine || f)) : (p.multiLine = s({}, f.multiLine || f), p.singleLine = s({}, f.singleLine || f), p.multiLine.align && (p.align = {
                    on: p.multiLine.align.on,
                    mode: p.multiLine.align.mode || p.multiLine.mode,
                    beforeColon: p.multiLine.align.beforeColon,
                    afterColon: p.multiLine.align.afterColon
                })), p), u = a.multiLine, l = a.singleLine, c = a.align || null;
                var p, f;
                const d = i.sourceCode;
                function h(e1) {
                    return !(e1.method || e1.shorthand || "init" !== e1.kind || "Property" !== e1.type);
                }
                function m(t) {
                    return d.getTokenAfter(t, e1.isColonToken);
                }
                function g(e1, t) {
                    const n = e1.loc.start.line, s = (h(t) ? function(e1) {
                        const t = m(e1);
                        return d.getTokenAfter(t);
                    }(t.key) : t).loc.start.line;
                    if (s - n <= 1) return !0;
                    const i = d.getCommentsBefore(t);
                    if (i.length && i[0].loc.start.line - n <= 1 && s - r(i).loc.end.line <= 1) {
                        for(let e1 = 1; e1 < i.length; e1++)if (i[e1].loc.start.line - i[e1 - 1].loc.end.line > 1) return !1;
                        return !0;
                    }
                    return !1;
                }
                function y(t) {
                    const r = t.key;
                    return t.computed ? d.getText().slice(r.range[0], r.range[1]) : e1.getStaticPropertyName(t);
                }
                function E(t, r, n, s, o) {
                    const a = n.length - s;
                    if ((a && "strict" === o || a < 0 && "minimum" === o || a > 0 && !s && "minimum" === o) && (!s || (u = n, !e1.LINEBREAK_MATCHER.test(u)))) {
                        const e1 = m(t.key), n = d.getTokenBefore(e1, {
                            includeComments: !0
                        }), s = d.getTokenAfter(e1, {
                            includeComments: !0
                        }), o = "key" === r, u = a > 0, l = Math.abs(a), c = Array(l + 1).join(" "), p = o ? n.loc.end : e1.loc.start, f = o ? e1.loc.start : s.loc.start, h = o ? n.loc : s.loc, g = u ? {
                            start: p,
                            end: f
                        } : h;
                        let E;
                        if (u) {
                            let e1;
                            e1 = o ? [
                                n.range[1],
                                n.range[1] + l
                            ] : [
                                s.range[0] - l,
                                s.range[0]
                            ], E = function(t) {
                                return t.removeRange(e1);
                            };
                        } else E = o ? function(e1) {
                            return e1.insertTextAfter(n, c);
                        } : function(e1) {
                            return e1.insertTextBefore(s, c);
                        };
                        let x = "";
                        x = u ? "key" === r ? "extraKey" : "extraValue" : "key" === r ? "missingKey" : "missingValue", i.report({
                            node: t[r],
                            loc: g,
                            messageId: x,
                            data: {
                                computed: t.computed ? "computed " : "",
                                key: y(t)
                            },
                            fix: E
                        });
                    }
                    var u;
                }
                function x(e1) {
                    const r = d.getFirstToken(e1), n = function(e1) {
                        const t = m(e1);
                        return d.getTokenBefore(t);
                    }(e1.key);
                    return t(d.getText().slice(r.range[0], n.range[1]));
                }
                function C(e1) {
                    const t = /(\s*):(\s*)/u.exec(d.getText().slice(e1.key.range[1], e1.value.range[0]));
                    return t ? {
                        beforeColon: t[1],
                        afterColon: t[2]
                    } : null;
                }
                function S(e1, t) {
                    const r = C(e1);
                    r && (E(e1, "key", r.beforeColon, t.beforeColon, t.mode), E(e1, "value", r.afterColon, t.afterColon, t.mode));
                }
                function b(e1, t) {
                    const r = e1.length;
                    for(let n = 0; n < r; n++)S(e1[n], t);
                }
                function v(e1) {
                    (function(e1) {
                        return 1 === e1.properties.length ? [
                            e1.properties
                        ] : e1.properties.reduce((e1, t)=>{
                            const n = r(e1), s = r(n);
                            return !s || g(s, t) ? n.push(t) : e1.push([
                                t
                            ]), e1;
                        }, [
                            []
                        ]);
                    })(e1).forEach((e1)=>{
                        const t = e1.filter(h);
                        t.length > 0 && function(e1) {
                            const [t] = e1, n = r(e1);
                            return t.loc.start.line === n.loc.end.line;
                        }(t) ? b(t, u) : function(e1) {
                            const t = e1.length, r = e1.map(x), n = c.on;
                            let s, i, o, a = Math.max(...r);
                            c && t > 1 ? (s = c.beforeColon, i = c.afterColon, o = c.mode) : (s = u.beforeColon, i = u.afterColon, o = c.mode), a += "colon" === n ? s : i;
                            for(let u = 0; u < t; u++){
                                const t = e1[u], l = C(t);
                                if (l) {
                                    const e1 = r[u];
                                    "value" === n ? (E(t, "key", l.beforeColon, s, o), E(t, "value", l.afterColon, a - e1, o)) : (E(t, "key", l.beforeColon, a - e1, o), E(t, "value", l.afterColon, i, o));
                                }
                            }
                        }(t);
                    });
                }
                return c ? {
                    ObjectExpression (e1) {
                        n(e1) ? b(e1.properties.filter(h), l) : v(e1);
                    }
                } : {
                    Property (e1) {
                        S(e1, n(e1.parent) ? l : u);
                    }
                };
            }
        }, Ap;
    }
    function Td() {
        if (Pp) return Lp;
        Pp = 1;
        const e1 = Ll();
        return Lp = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Require empty lines around comments",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/lines-around-comment"
                },
                fixable: "whitespace",
                schema: [
                    {
                        type: "object",
                        properties: {
                            beforeBlockComment: {
                                type: "boolean",
                                default: !0
                            },
                            afterBlockComment: {
                                type: "boolean",
                                default: !1
                            },
                            beforeLineComment: {
                                type: "boolean",
                                default: !1
                            },
                            afterLineComment: {
                                type: "boolean",
                                default: !1
                            },
                            allowBlockStart: {
                                type: "boolean",
                                default: !1
                            },
                            allowBlockEnd: {
                                type: "boolean",
                                default: !1
                            },
                            allowClassStart: {
                                type: "boolean"
                            },
                            allowClassEnd: {
                                type: "boolean"
                            },
                            allowObjectStart: {
                                type: "boolean"
                            },
                            allowObjectEnd: {
                                type: "boolean"
                            },
                            allowArrayStart: {
                                type: "boolean"
                            },
                            allowArrayEnd: {
                                type: "boolean"
                            },
                            ignorePattern: {
                                type: "string"
                            },
                            applyDefaultIgnorePatterns: {
                                type: "boolean"
                            },
                            afterHashbangComment: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    after: "Expected line after comment.",
                    before: "Expected line before comment."
                }
            },
            create (t) {
                const r = Object.assign({}, t.options[0]), n = r.ignorePattern, s = e1.COMMENTS_IGNORE_PATTERN, i = new RegExp(n, "u"), o = !1 !== r.applyDefaultIgnorePatterns;
                r.beforeBlockComment = void 0 === r.beforeBlockComment || r.beforeBlockComment;
                const a = t.sourceCode, u = a.lines, l = u.length + 1, c = a.getAllComments(), p = function(e1) {
                    const t = [];
                    return e1.forEach((e1)=>{
                        const r = e1.loc.start.line, n = e1.loc.end.line;
                        t.push(r, n);
                    }), t;
                }(c), f = function(e1) {
                    const t = e1.map((e1, t)=>({
                            code: e1.trim(),
                            num: t + 1
                        })).filter((e1)=>!e1.code).map((e1)=>e1.num);
                    return t;
                }(u), d = new Set(p.concat(f));
                function h(e1, t) {
                    return e1.type === t || e1.body && e1.body.type === t || e1.consequent && e1.consequent.type === t;
                }
                function m(e1) {
                    const t = a.getNodeByRangeIndex(e1.range[0]);
                    if (t && "StaticBlock" === t.type) {
                        const r = a.getFirstToken(t, {
                            skip: 1
                        });
                        return e1.range[0] >= r.range[0] ? t : null;
                    }
                    return t;
                }
                function g(t, r) {
                    const n = m(t);
                    if (n && h(n, r)) {
                        let r = n;
                        return "StaticBlock" === n.type ? r = a.getFirstToken(n, {
                            skip: 1
                        }) : "SwitchStatement" === n.type && (r = a.getTokenAfter(n.discriminant, {
                            filter: e1.isOpeningBraceToken
                        })), t.loc.start.line - r.loc.start.line == 1;
                    }
                    return !1;
                }
                function y(e1, t) {
                    const r = m(e1);
                    return !!r && h(r, t) && r.loc.end.line - e1.loc.end.line == 1;
                }
                function E(e1) {
                    return g(e1, "ClassBody");
                }
                function x(e1) {
                    return y(e1, "ClassBody");
                }
                function C(u, c) {
                    if (o && s.test(u.value)) return;
                    if (n && i.test(u.value)) return;
                    let p = c.after, f = c.before;
                    const h = u.loc.start.line - 1, m = u.loc.end.line + 1, C = function(t) {
                        let r = t;
                        do r = a.getTokenBefore(r, {
                            includeComments: !0
                        });
                        while (r && e1.isCommentToken(r));
                        if (r && e1.isTokenOnSameLine(r, t)) return !0;
                        r = t;
                        do r = a.getTokenAfter(r, {
                            includeComments: !0
                        });
                        while (r && e1.isCommentToken(r));
                        return !(!r || !e1.isTokenOnSameLine(t, r));
                    }(u), S = r.allowBlockStart && function(e1) {
                        return g(e1, "ClassBody") || g(e1, "BlockStatement") || g(e1, "StaticBlock") || g(e1, "SwitchCase") || g(e1, "SwitchStatement");
                    }(u) && !(!1 === r.allowClassStart && E(u)), b = r.allowBlockEnd && function(e1) {
                        return y(e1, "ClassBody") || y(e1, "BlockStatement") || y(e1, "StaticBlock") || y(e1, "SwitchCase") || y(e1, "SwitchStatement");
                    }(u) && !(!1 === r.allowClassEnd && x(u)), v = r.allowClassStart && E(u), A = r.allowClassEnd && x(u), T = r.allowObjectStart && function(e1) {
                        return g(e1, "ObjectExpression") || g(e1, "ObjectPattern");
                    }(u), R = r.allowObjectEnd && function(e1) {
                        return y(e1, "ObjectExpression") || y(e1, "ObjectPattern");
                    }(u), D = r.allowArrayStart && function(e1) {
                        return g(e1, "ArrayExpression") || g(e1, "ArrayPattern");
                    }(u), w = r.allowArrayEnd && function(e1) {
                        return y(e1, "ArrayExpression") || y(e1, "ArrayPattern");
                    }(u), _ = S || v || T || D, k = b || A || R || w;
                    if (h < 1 && (f = !1), m >= l && (p = !1), C) return;
                    const B = a.getTokenBefore(u, {
                        includeComments: !0
                    }), L = a.getTokenAfter(u, {
                        includeComments: !0
                    });
                    if (!_ && f && !d.has(h) && (!e1.isCommentToken(B) || !e1.isTokenOnSameLine(B, u))) {
                        const e1 = u.range[0] - u.loc.start.column, r = [
                            e1,
                            e1
                        ];
                        t.report({
                            node: u,
                            messageId: "before",
                            fix: (e1)=>e1.insertTextBeforeRange(r, "\n")
                        });
                    }
                    k || !p || d.has(m) || e1.isCommentToken(L) && e1.isTokenOnSameLine(u, L) || t.report({
                        node: u,
                        messageId: "after",
                        fix: (e1)=>e1.insertTextAfter(u, "\n")
                    });
                }
                return {
                    Program () {
                        c.forEach((e1)=>{
                            "Line" === e1.type ? (r.beforeLineComment || r.afterLineComment) && C(e1, {
                                after: r.afterLineComment,
                                before: r.beforeLineComment
                            }) : "Block" === e1.type ? (r.beforeBlockComment || r.afterBlockComment) && C(e1, {
                                after: r.afterBlockComment,
                                before: r.beforeBlockComment
                            }) : "Shebang" === e1.type && r.afterHashbangComment && C(e1, {
                                after: r.afterHashbangComment,
                                before: !1
                            });
                        });
                    }
                };
            }
        }, Lp;
    }
    function Rd() {
        if (jp) return Up;
        jp = 1;
        const e1 = Ll(), t = new Set([
            "Identifier",
            "Super",
            "ThisExpression"
        ]);
        function r(t, r) {
            return "Identifier" === t.type && "undefined" === t.name ? e1.isReferenceToGlobalVariable(r, t) : "UnaryExpression" === t.type && "void" === t.operator && "Literal" === t.argument.type && 0 === t.argument.value;
        }
        function n(e1) {
            return "Identifier" === e1.type && "undefined" !== e1.name || "MemberExpression" === e1.type;
        }
        function s(t, s) {
            const i = "UnaryExpression" === t.type && "!" === t.operator, o = i ? t.argument : t;
            switch(!0){
                case n(o):
                    return {
                        reference: o,
                        operator: i ? "||" : "&&"
                    };
                case "UnaryExpression" === o.type && "!" === o.operator && n(o.argument):
                    return {
                        reference: o.argument,
                        operator: "&&"
                    };
                case function(t, r) {
                    return "CallExpression" === t.type && "Boolean" === t.callee.name && 1 === t.arguments.length && e1.isReferenceToGlobalVariable(r, t.callee);
                }(o, s) && n(o.arguments[0]):
                    return {
                        reference: o.arguments[0],
                        operator: i ? "||" : "&&"
                    };
                case function(t, s) {
                    if ("BinaryExpression" !== t.type || "==" !== t.operator) return !1;
                    const i = n(t.left) ? "left" : "right", o = "left" === i ? "right" : "left";
                    return n(t[i]) && (e1.isNullLiteral(t[o]) || r(t[o], s));
                }(t, s):
                    return {
                        reference: n(t.left) ? t.left : t.right,
                        operator: "??"
                    };
                case function(t, s) {
                    if (!function(e1) {
                        return "LogicalExpression" === e1.type && "||" === e1.operator && "BinaryExpression" === e1.left.type && "===" === e1.left.operator && "BinaryExpression" === e1.right.type && "===" === e1.right.operator;
                    }(t)) return !1;
                    const i = n(t.left.left) ? "left" : "right", o = "left" === i ? "right" : "left", a = n(t.right.left) ? "left" : "right", u = "left" === a ? "right" : "left";
                    return e1.isSameReference(t.left[i], t.right[a]) && (e1.isNullLiteral(t.left[o]) && r(t.right[u], s) || r(t.left[o], s) && e1.isNullLiteral(t.right[u]));
                }(t, s):
                    return {
                        reference: n(t.left.left) ? t.left.left : t.left.right,
                        operator: "??"
                    };
                default:
                    return null;
            }
        }
        function i(e1) {
            return "Program" !== e1.type && ("WithStatement" === e1.parent.type && e1.parent.body === e1 || i(e1.parent));
        }
        return Up = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require or disallow logical assignment operator shorthand",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/logical-assignment-operators"
                },
                schema: {
                    type: "array",
                    oneOf: [
                        {
                            items: [
                                {
                                    const: "always"
                                },
                                {
                                    type: "object",
                                    properties: {
                                        enforceForIfStatements: {
                                            type: "boolean"
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            minItems: 0,
                            maxItems: 2
                        },
                        {
                            items: [
                                {
                                    const: "never"
                                }
                            ],
                            minItems: 1,
                            maxItems: 1
                        }
                    ]
                },
                fixable: "code",
                hasSuggestions: !0,
                messages: {
                    assignment: "Assignment (=) can be replaced with operator assignment ({{operator}}).",
                    useLogicalOperator: "Convert this assignment to use the operator {{ operator }}.",
                    logical: "Logical expression can be replaced with an assignment ({{ operator }}).",
                    convertLogical: "Replace this logical expression with an assignment with the operator {{ operator }}.",
                    if: "'if' statement can be replaced with a logical operator assignment with operator {{ operator }}.",
                    convertIf: "Replace this 'if' statement with a logical assignment with operator {{ operator }}.",
                    unexpected: "Unexpected logical operator assignment ({{operator}}) shorthand.",
                    separate: "Separate the logical assignment into an assignment with a logical operator."
                }
            },
            create (r) {
                const o = "never" === r.options[0] ? "never" : "always", a = "always" === o && r.options.length > 1 && r.options[1].enforceForIfStatements, u = r.sourceCode, l = u.getScope(u.ast).isStrict;
                function c(e1) {
                    return "Identifier" === e1.type && (l || !i(e1));
                }
                function p(e1) {
                    return !l && i(e1) ? "Identifier" === e1.type : "MemberExpression" === e1.type && t.has(e1.object.type) && (!e1.computed || "MemberExpression" !== e1.property.type && "ChainExpression" !== e1.property.type);
                }
                function f(e1, t, r) {
                    return r ? {
                        ...e1,
                        fix: t.fix
                    } : {
                        ...e1,
                        suggest: [
                            t
                        ]
                    };
                }
                function d(e1) {
                    return u.getFirstTokenBetween(e1.left, e1.right, (t)=>t.value === e1.operator);
                }
                return "never" === o ? {
                    AssignmentExpression (t) {
                        if (!e1.isLogicalAssignmentOperator(t.operator)) return;
                        const n = {
                            messageId: "unexpected",
                            node: t,
                            data: {
                                operator: t.operator
                            }
                        }, s = {
                            messageId: "separate",
                            *fix (r) {
                                if (u.getCommentsInside(t).length > 0) return;
                                const n = d(t);
                                yield r.replaceText(n, "=");
                                const s = u.getText(t.left), i = t.operator.slice(0, -1);
                                yield r.insertTextAfter(n, ` ${s} ${i}`);
                                const o = e1.getPrecedence(t.right) <= e1.getPrecedence({
                                    type: "LogicalExpression",
                                    operator: i
                                }), a = "??=" === t.operator && e1.isLogicalExpression(t.right);
                                e1.isParenthesised(u, t.right) || !o && !a || (yield r.insertTextBefore(t.right, "("), yield r.insertTextAfter(t.right, ")"));
                            }
                        };
                        r.report(f(n, s, c(t.left)));
                    }
                } : {
                    "AssignmentExpression[operator='='][right.type='LogicalExpression']" (t) {
                        const n = function(t, r) {
                            let n = r.left;
                            for(; "LogicalExpression" === n.type && n.operator === r.operator;){
                                if (e1.isParenthesised(t, n)) return n;
                                n = n.left;
                            }
                            return n;
                        }(u, t.right);
                        if (!e1.isSameReference(t.left, n)) return;
                        const s = {
                            messageId: "assignment",
                            node: t,
                            data: {
                                operator: `${t.right.operator}=`
                            }
                        }, i = {
                            messageId: "useLogicalOperator",
                            data: {
                                operator: `${t.right.operator}=`
                            },
                            *fix (e1) {
                                if (u.getCommentsInside(t).length > 0) return;
                                const r = d(t);
                                yield e1.insertTextBefore(r, t.right.operator);
                                const s = d(n.parent), i = u.getTokenAfter(s);
                                yield e1.removeRange([
                                    n.parent.range[0],
                                    i.range[0]
                                ]);
                            }
                        };
                        r.report(f(s, i, c(t.left)));
                    },
                    'LogicalExpression[right.type="AssignmentExpression"][right.operator="="]' (t) {
                        if (n(t.left) && e1.isSameReference(t.left, t.right.left)) {
                            const n = {
                                messageId: "logical",
                                node: t,
                                data: {
                                    operator: `${t.operator}=`
                                }
                            }, s = {
                                messageId: "convertLogical",
                                data: {
                                    operator: `${t.operator}=`
                                },
                                *fix (r) {
                                    if (u.getCommentsInside(t).length > 0) return;
                                    const n = e1.getPrecedence(t.parent), s = "ExpressionStatement" !== t.parent.type && (-1 === n || e1.getPrecedence({
                                        type: "AssignmentExpression"
                                    }) < n);
                                    !e1.isParenthesised(u, t) && s && (yield r.insertTextBefore(t, "("), yield r.insertTextAfter(t, ")")), yield r.removeRange([
                                        t.range[0],
                                        t.right.range[0]
                                    ]), yield r.removeRange([
                                        t.right.range[1],
                                        t.range[1]
                                    ]);
                                    const i = d(t.right);
                                    yield r.insertTextBefore(i, t.operator);
                                }
                            }, i = c(t.left) || p(t.left);
                            r.report(f(n, s, i));
                        }
                    },
                    "IfStatement[alternate=null]" (t) {
                        if (!a) return;
                        const n = "BlockStatement" === t.consequent.type;
                        if (n && 1 !== t.consequent.body.length) return;
                        const i = n ? t.consequent.body[0] : t.consequent, o = u.getScope(t), l = s(t.test, o);
                        if ("ExpressionStatement" === i.type && "AssignmentExpression" === i.expression.type && "=" === i.expression.operator && null !== l && e1.isSameReference(l.reference, i.expression.left)) {
                            const e1 = {
                                messageId: "if",
                                node: t,
                                data: {
                                    operator: `${l.operator}=`
                                }
                            }, s = {
                                messageId: "convertIf",
                                data: {
                                    operator: `${l.operator}=`
                                },
                                *fix (e1) {
                                    if (u.getCommentsInside(t).length > 0) return;
                                    const r = u.getFirstToken(i), s = u.getTokenBefore(t);
                                    if (null !== s && ";" !== s.value && "{" !== s.value && "Identifier" !== r.type && "Keyword" !== r.type) return;
                                    const o = d(i.expression);
                                    yield e1.insertTextBefore(o, l.operator), yield e1.removeRange([
                                        t.range[0],
                                        i.range[0]
                                    ]), yield e1.removeRange([
                                        i.range[1],
                                        t.range[1]
                                    ]);
                                    const a = u.getTokenAfter(i.expression);
                                    n && null !== a && ";" !== a.value && (yield e1.insertTextAfter(t, ";"));
                                }
                            }, o = c(l.reference) || "LogicalExpression" !== t.test.type && p(l.reference);
                            r.report(f(e1, s, o));
                        }
                    }
                };
            }
        }, Up;
    }
    function Dd() {
        if (Gp) return qp;
        Gp = 1;
        const e1 = {
            type: "object",
            properties: {
                code: {
                    type: "integer",
                    minimum: 0
                },
                comments: {
                    type: "integer",
                    minimum: 0
                },
                tabWidth: {
                    type: "integer",
                    minimum: 0
                },
                ignorePattern: {
                    type: "string"
                },
                ignoreComments: {
                    type: "boolean"
                },
                ignoreStrings: {
                    type: "boolean"
                },
                ignoreUrls: {
                    type: "boolean"
                },
                ignoreTemplateLiterals: {
                    type: "boolean"
                },
                ignoreRegExpLiterals: {
                    type: "boolean"
                },
                ignoreTrailingComments: {
                    type: "boolean"
                }
            },
            additionalProperties: !1
        }, t = {
            anyOf: [
                e1,
                {
                    type: "integer",
                    minimum: 0
                }
            ]
        };
        return qp = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce a maximum line length",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/max-len"
                },
                schema: [
                    t,
                    t,
                    e1
                ],
                messages: {
                    max: "This line has a length of {{lineLength}}. Maximum allowed is {{maxLength}}.",
                    maxComment: "This line has a comment length of {{lineLength}}. Maximum allowed is {{maxCommentLength}}."
                }
            },
            create (e1) {
                const t = /[^:/?#]:\/\/[^?#]/u, r = e1.sourceCode;
                const n = Object.assign({}, e1.options[e1.options.length - 1]);
                "number" == typeof e1.options[0] && (n.code = e1.options[0]), "number" == typeof e1.options[1] && (n.tabWidth = e1.options[1]);
                const s = "number" == typeof n.code ? n.code : 80, i = "number" == typeof n.tabWidth ? n.tabWidth : 4, o = !!n.ignoreComments, a = !!n.ignoreStrings, u = !!n.ignoreTemplateLiterals, l = !!n.ignoreRegExpLiterals, c = !!n.ignoreTrailingComments || !!n.ignoreComments, p = !!n.ignoreUrls, f = n.comments;
                let d = n.ignorePattern || null;
                function h(e1, t, r) {
                    return r && r.loc.start.line === t && t <= r.loc.end.line && (r.loc.end.line > t || r.loc.end.column === e1.length);
                }
                function m(e1, t) {
                    return e1.slice(0, t.loc.start.column).replace(/\s+$/u, "");
                }
                function g(e1) {
                    const t = {};
                    for(let i = 0; i < e1.length; i++){
                        const o = e1[i];
                        for(let e1 = o.loc.start.line; e1 <= o.loc.end.line; ++e1)r = t, n = e1, s = o, Array.isArray(r[n]) || (r[n] = []), r[n].push(s);
                    }
                    var r, n, s;
                    return t;
                }
                return d && (d = new RegExp(d, "u")), {
                    Program: function(n) {
                        const y = r.lines, E = o || f || c ? function() {
                            const e1 = [];
                            return r.getAllComments().forEach((t)=>{
                                const n = r.getNodeByRangeIndex(t.range[0]);
                                !function(e1) {
                                    if (!e1 || !e1.parent || "JSXEmptyExpression" !== e1.type || "JSXExpressionContainer" !== e1.parent.type) return !1;
                                    const t = e1.parent;
                                    return t.loc.start.line === t.loc.end.line;
                                }(n) ? e1.push(t) : e1[e1.length - 1] !== n.parent && e1.push(n.parent);
                            }), e1;
                        }() : [];
                        let x = 0;
                        const C = g(r.ast.tokens.filter((e1)=>"String" === e1.type || "JSXText" === e1.type && "JSXAttribute" === r.getNodeByRangeIndex(e1.range[0] - 1).type)), S = g(r.ast.tokens.filter((e1)=>"Template" === e1.type)), b = g(r.ast.tokens.filter((e1)=>"RegularExpression" === e1.type));
                        y.forEach((r, g)=>{
                            const y = g + 1;
                            let v, A = !1;
                            if (x < E.length) {
                                let e1 = null;
                                do e1 = E[++x];
                                while (e1 && e1.loc.start.line <= y);
                                if (e1 = E[--x], function(e1, t, r) {
                                    const n = r.loc.start, s = r.loc.end, i = !e1.slice(0, r.loc.start.column).trim();
                                    return r && (n.line < t || n.line === t && i) && (s.line > t || s.line === t && s.column === e1.length);
                                }(r, y, e1)) A = !0, v = r;
                                else if (c && h(r, y, e1)) {
                                    v = m(r, e1);
                                    let t = x;
                                    for(; h(v, y, E[--t]);)v = m(v, E[t]);
                                } else v = r;
                            } else v = r;
                            if (d && d.test(v) || p && t.test(v) || a && C[y] || u && S[y] || l && b[y]) return;
                            const T = function(e1, t) {
                                let r = 0;
                                return e1.replace(/\t/gu, (e1, n)=>{
                                    r += t - (t ? (n + r) % t : 0) - 1;
                                }), Array.from(e1).length + r;
                            }(v, i), R = A && f;
                            if (A && o) return;
                            const D = {
                                start: {
                                    line: y,
                                    column: 0
                                },
                                end: {
                                    line: y,
                                    column: v.length
                                }
                            };
                            R ? T > f && e1.report({
                                node: n,
                                loc: D,
                                messageId: "maxComment",
                                data: {
                                    lineLength: T,
                                    maxCommentLength: f
                                }
                            }) : T > s && e1.report({
                                node: n,
                                loc: D,
                                messageId: "max",
                                data: {
                                    lineLength: T,
                                    maxLength: s
                                }
                            });
                        });
                    }
                };
            }
        }, qp;
    }
    function wd() {
        if (Xp) return Wp;
        Xp = 1;
        const e1 = Ll();
        return Wp = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Enforce a maximum number of lines per file",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/max-lines"
                },
                schema: [
                    {
                        oneOf: [
                            {
                                type: "integer",
                                minimum: 0
                            },
                            {
                                type: "object",
                                properties: {
                                    max: {
                                        type: "integer",
                                        minimum: 0
                                    },
                                    skipComments: {
                                        type: "boolean"
                                    },
                                    skipBlankLines: {
                                        type: "boolean"
                                    }
                                },
                                additionalProperties: !1
                            }
                        ]
                    }
                ],
                messages: {
                    exceed: "File has too many lines ({{actual}}). Maximum allowed is {{max}}."
                }
            },
            create (t) {
                const r = t.options[0];
                let n = 300;
                "object" == typeof r && Object.prototype.hasOwnProperty.call(r, "max") ? n = r.max : "number" == typeof r && (n = r);
                const s = r && r.skipComments, i = r && r.skipBlankLines, o = t.sourceCode;
                function a(e1) {
                    return e1 && ("Block" === e1.type || "Line" === e1.type);
                }
                function u(t) {
                    let r, n = t.loc.start.line, s = t.loc.end.line;
                    r = t;
                    do r = o.getTokenBefore(r, {
                        includeComments: !0
                    });
                    while (a(r));
                    r && e1.isTokenOnSameLine(r, t) && (n += 1), r = t;
                    do r = o.getTokenAfter(r, {
                        includeComments: !0
                    });
                    while (a(r));
                    return r && e1.isTokenOnSameLine(t, r) && (s -= 1), n <= s ? function(e1, t) {
                        return [
                            ...Array(t - e1).keys()
                        ].map((t)=>t + e1);
                    }(n, s + 1) : [];
                }
                return {
                    "Program:exit" () {
                        let e1 = o.lines.map((e1, t)=>({
                                lineNumber: t + 1,
                                text: e1
                            }));
                        if (e1.length > 1 && "" === e1[e1.length - 1].text && e1.pop(), i && (e1 = e1.filter((e1)=>"" !== e1.text.trim())), s) {
                            const t = o.getAllComments(), r = new Set(t.flatMap(u));
                            e1 = e1.filter((e1)=>!r.has(e1.lineNumber));
                        }
                        if (e1.length > n) {
                            const r = {
                                start: {
                                    line: e1[n].lineNumber,
                                    column: 0
                                },
                                end: {
                                    line: o.lines.length,
                                    column: o.lines[o.lines.length - 1].length
                                }
                            };
                            t.report({
                                loc: r,
                                messageId: "exceed",
                                data: {
                                    max: n,
                                    actual: e1.length
                                }
                            });
                        }
                    }
                };
            }
        }, Wp;
    }
    function _d() {
        if (Hp) return zp;
        Hp = 1;
        const e1 = Ll(), { upperCaseFirst: t } = id();
        return zp = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Enforce a maximum number of lines of code in a function",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/max-lines-per-function"
                },
                schema: [
                    {
                        oneOf: [
                            {
                                type: "object",
                                properties: {
                                    max: {
                                        type: "integer",
                                        minimum: 0
                                    },
                                    skipComments: {
                                        type: "boolean"
                                    },
                                    skipBlankLines: {
                                        type: "boolean"
                                    },
                                    IIFEs: {
                                        type: "boolean"
                                    }
                                },
                                additionalProperties: !1
                            },
                            {
                                type: "integer",
                                minimum: 1
                            }
                        ]
                    }
                ],
                messages: {
                    exceed: "{{name}} has too many lines ({{lineCount}}). Maximum allowed is {{maxLines}}."
                }
            },
            create (r) {
                const n = r.sourceCode, s = n.lines, i = r.options[0];
                let o = 50, a = !1, u = !1, l = !1;
                "object" == typeof i ? (o = "number" == typeof i.max ? i.max : 50, a = !!i.skipComments, u = !!i.skipBlankLines, l = !!i.IIFEs) : "number" == typeof i && (o = i);
                const c = function(e1) {
                    const t = new Map;
                    return e1.forEach((e1)=>{
                        for(let r = e1.loc.start.line; r <= e1.loc.end.line; r++)t.set(r, e1);
                    }), t;
                }(n.getAllComments());
                function p(e1, t, r) {
                    const n = r.loc.start, s = r.loc.end, i = n.line === t && !e1.slice(0, n.column).trim(), o = s.line === t && !e1.slice(s.column).trim();
                    return r && (n.line < t || i) && (s.line > t || o);
                }
                function f(n) {
                    const i = function(e1) {
                        return !!e1.parent && e1 === e1.parent.value && ("MethodDefinition" === e1.parent.type || "Property" === e1.parent.type && (!0 === e1.parent.method || "get" === e1.parent.kind || "set" === e1.parent.kind));
                    }(n) ? n.parent : n;
                    if (!l && function(e1) {
                        return ("FunctionExpression" === e1.type || "ArrowFunctionExpression" === e1.type) && e1.parent && "CallExpression" === e1.parent.type && e1.parent.callee === e1;
                    }(i)) return;
                    let f = 0;
                    for(let e1 = i.loc.start.line - 1; e1 < i.loc.end.line; ++e1){
                        const t = s[e1];
                        a && c.has(e1 + 1) && p(t, e1 + 1, c.get(e1 + 1)) || u && t.match(/^\s*$/u) || f++;
                    }
                    if (f > o) {
                        const s = t(e1.getFunctionNameWithKind(n));
                        r.report({
                            node: i,
                            messageId: "exceed",
                            data: {
                                name: s,
                                lineCount: f,
                                maxLines: o
                            }
                        });
                    }
                }
                return {
                    FunctionDeclaration: f,
                    FunctionExpression: f,
                    ArrowFunctionExpression: f
                };
            }
        }, zp;
    }
    function kd() {
        if (nf) return rf;
        nf = 1;
        const e1 = Ll();
        return rf = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce a maximum number of statements allowed per line",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/max-statements-per-line"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            max: {
                                type: "integer",
                                minimum: 1,
                                default: 1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    exceed: "This line has {{numberOfStatementsOnThisLine}} {{statements}}. Maximum allowed is {{maxStatementsPerLine}}."
                }
            },
            create (t) {
                const r = t.sourceCode, n = t.options[0] || {}, s = void 0 !== n.max ? n.max : 1;
                let i, o = 0, a = 0;
                const u = /^(?:(?:DoWhile|For|ForIn|ForOf|If|Labeled|While)Statement|Export(?:Default|Named)Declaration)$/u;
                function l() {
                    i && t.report({
                        node: i,
                        messageId: "exceed",
                        data: {
                            numberOfStatementsOnThisLine: a,
                            maxStatementsPerLine: s,
                            statements: 1 === a ? "statement" : "statements"
                        }
                    }), i = null;
                }
                function c(e1) {
                    const t = e1.loc.start.line;
                    u.test(e1.parent.type) && e1.parent.alternate !== e1 || (t === o ? a += 1 : (l(), a = 1, o = t), a === s + 1 && (i = i || e1));
                }
                function p(t) {
                    const n = function(t) {
                        return r.getLastToken(t, e1.isNotSemicolonToken);
                    }(t).loc.end.line;
                    n !== o && (l(), a = 1, o = n);
                }
                return {
                    BreakStatement: c,
                    ClassDeclaration: c,
                    ContinueStatement: c,
                    DebuggerStatement: c,
                    DoWhileStatement: c,
                    ExpressionStatement: c,
                    ForInStatement: c,
                    ForOfStatement: c,
                    ForStatement: c,
                    FunctionDeclaration: c,
                    IfStatement: c,
                    ImportDeclaration: c,
                    LabeledStatement: c,
                    ReturnStatement: c,
                    SwitchStatement: c,
                    ThrowStatement: c,
                    TryStatement: c,
                    VariableDeclaration: c,
                    WhileStatement: c,
                    WithStatement: c,
                    ExportNamedDeclaration: c,
                    ExportDefaultDeclaration: c,
                    ExportAllDeclaration: c,
                    "BreakStatement:exit": p,
                    "ClassDeclaration:exit": p,
                    "ContinueStatement:exit": p,
                    "DebuggerStatement:exit": p,
                    "DoWhileStatement:exit": p,
                    "ExpressionStatement:exit": p,
                    "ForInStatement:exit": p,
                    "ForOfStatement:exit": p,
                    "ForStatement:exit": p,
                    "FunctionDeclaration:exit": p,
                    "IfStatement:exit": p,
                    "ImportDeclaration:exit": p,
                    "LabeledStatement:exit": p,
                    "ReturnStatement:exit": p,
                    "SwitchStatement:exit": p,
                    "ThrowStatement:exit": p,
                    "TryStatement:exit": p,
                    "VariableDeclaration:exit": p,
                    "WhileStatement:exit": p,
                    "WithStatement:exit": p,
                    "ExportNamedDeclaration:exit": p,
                    "ExportDefaultDeclaration:exit": p,
                    "ExportAllDeclaration:exit": p,
                    "Program:exit": l
                };
            }
        }, rf;
    }
    function Bd() {
        if (of) return sf;
        of = 1;
        const e1 = Ll();
        return sf = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Enforce a particular style for multiline comments",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/multiline-comment-style"
                },
                fixable: "whitespace",
                schema: {
                    anyOf: [
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "starred-block",
                                        "bare-block"
                                    ]
                                }
                            ],
                            additionalItems: !1
                        },
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "separate-lines"
                                    ]
                                },
                                {
                                    type: "object",
                                    properties: {
                                        checkJSDoc: {
                                            type: "boolean"
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            additionalItems: !1
                        }
                    ]
                },
                messages: {
                    expectedBlock: "Expected a block comment instead of consecutive line comments.",
                    expectedBareBlock: "Expected a block comment without padding stars.",
                    startNewline: "Expected a linebreak after '/*'.",
                    endNewline: "Expected a linebreak before '*/'.",
                    missingStar: "Expected a '*' at the start of this line.",
                    alignment: "Expected this line to be aligned with the start of the comment.",
                    expectedLines: "Expected multiple line comments instead of a block comment."
                }
            },
            create (t) {
                const r = t.sourceCode, n = t.options[0] || "starred-block", s = !!(t.options[1] || {}).checkJSDoc;
                function i([t]) {
                    if ("Block" !== t.type) return !1;
                    const r = t.value.split(e1.LINEBREAK_MATCHER);
                    return r.length > 0 && r.every((e1, t)=>(0 === t || t === r.length - 1 ? /^\s*$/u : /^\s*\*/u).test(e1));
                }
                function o([t]) {
                    if ("Block" !== t.type) return !1;
                    const r = t.value.split(e1.LINEBREAK_MATCHER);
                    return /^\*\s*$/u.test(r[0]) && r.slice(1, -1).every((e1)=>/^\s* /u.test(e1)) && /^\s*$/u.test(r[r.length - 1]);
                }
                function a(t) {
                    const [n] = t;
                    return "Line" === n.type ? function(e1) {
                        const t = e1.map(({ value: e1 })=>e1).filter((e1)=>e1.trim().length).every((e1)=>e1.startsWith(" "));
                        return e1.map(({ value: e1 })=>t ? e1.replace(/^ /u, "") : e1);
                    }(t) : i(t) ? function(t) {
                        const r = t.value.split(e1.LINEBREAK_MATCHER).filter((e1, t, r)=>!(0 === t || t === r.length - 1)).map((e1)=>e1.replace(/^\s*$/u, "")), n = r.map((e1)=>e1.replace(/\s*\*/u, "")).filter((e1)=>e1.trim().length).every((e1)=>e1.startsWith(" "));
                        return r.map((e1)=>e1.replace(n ? /\s*\* ?/u : /\s*\*/u, ""));
                    }(n) : function(t) {
                        const n = t.value.split(e1.LINEBREAK_MATCHER).map((e1)=>e1.replace(/^\s*$/u, "")), s = `${r.text.slice(t.range[0] - t.loc.start.column, t.range[0])}   `;
                        let i = "";
                        for (const [e1, t] of n.entries()){
                            if (!t.trim().length || 0 === e1) continue;
                            const [, r] = t.match(/^(\s*\*?\s*)/u);
                            if (r.length < s.length) {
                                const e1 = s.slice(r.length - s.length);
                                e1.length > i.length && (i = e1);
                            }
                        }
                        return n.map((e1)=>{
                            const t = e1.match(/^(\s*\*?\s*)(.*)/u), [, r, n] = t;
                            return r.length > s.length ? `${r.slice(s.length - (i.length + r.length))}${n}` : r.length < s.length ? `${r.slice(s.length)}${n}` : n;
                        });
                    }(n);
                }
                function u(e1) {
                    return r.text.slice(e1.range[0] - e1.loc.start.column, e1.range[0]);
                }
                function l(e1, t) {
                    return `/* ${t.join(`\n${u(e1)}   `)} */`;
                }
                const c = {
                    "starred-block" (n) {
                        const [s] = n, i = a(n);
                        if (!i.some((e1)=>e1.includes("*/"))) {
                            if (n.length > 1) t.report({
                                loc: {
                                    start: s.loc.start,
                                    end: n[n.length - 1].loc.end
                                },
                                messageId: "expectedBlock",
                                fix (e1) {
                                    const t = [
                                        s.range[0],
                                        n[n.length - 1].range[1]
                                    ];
                                    return i.some((e1)=>e1.startsWith("/")) ? null : e1.replaceTextRange(t, function(e1, t) {
                                        const r = u(e1);
                                        return `/*\n${t.map((e1)=>`${r} * ${e1}`).join("\n")}\n${r} */`;
                                    }(s, i));
                                }
                            });
                            else {
                                const n = s.value.split(e1.LINEBREAK_MATCHER), i = `${u(s)} *`;
                                if (!/^\*?\s*$/u.test(n[0])) {
                                    const e1 = s.value.startsWith("*") ? s.range[0] + 1 : s.range[0];
                                    t.report({
                                        loc: {
                                            start: s.loc.start,
                                            end: {
                                                line: s.loc.start.line,
                                                column: s.loc.start.column + 2
                                            }
                                        },
                                        messageId: "startNewline",
                                        fix: (t)=>t.insertTextAfterRange([
                                                e1,
                                                e1 + 2
                                            ], `\n${i}`)
                                    });
                                }
                                /^\s*$/u.test(n[n.length - 1]) || t.report({
                                    loc: {
                                        start: {
                                            line: s.loc.end.line,
                                            column: s.loc.end.column - 2
                                        },
                                        end: s.loc.end
                                    },
                                    messageId: "endNewline",
                                    fix: (e1)=>e1.replaceTextRange([
                                            s.range[1] - 2,
                                            s.range[1]
                                        ], `\n${i}/`)
                                });
                                for(let e1 = s.loc.start.line + 1; e1 <= s.loc.end.line; e1++){
                                    const o = r.lines[e1 - 1], a = /^\s*\*/u.test(o) ? "alignment" : "missingStar";
                                    o.startsWith(i) || t.report({
                                        loc: {
                                            start: {
                                                line: e1,
                                                column: 0
                                            },
                                            end: {
                                                line: e1,
                                                column: o.length
                                            }
                                        },
                                        messageId: a,
                                        fix (t) {
                                            const u = r.getIndexFromLoc({
                                                line: e1,
                                                column: 0
                                            });
                                            if ("alignment" === a) {
                                                const [, e1 = ""] = o.match(/^(\s*\*)/u) || [], r = u + e1.length;
                                                return t.replaceTextRange([
                                                    u,
                                                    r
                                                ], i);
                                            }
                                            const [, l = ""] = o.match(/^(\s*)/u) || [], c = u + l.length;
                                            let p;
                                            for (const [e1, t] of n.entries()){
                                                if (!/\S+/u.test(t)) continue;
                                                const n = r.lines[s.loc.start.line - 1 + e1], [, i = "", a = ""] = n.match(/^(\s*(?:\/?\*)?(\s*))/u) || [];
                                                p = `${l.slice(i.length)}${a}`, /^\s*\//u.test(o) && 0 === p.length && (p += " ");
                                                break;
                                            }
                                            return t.replaceTextRange([
                                                u,
                                                c
                                            ], `${i}${p}`);
                                        }
                                    });
                                }
                            }
                        }
                    },
                    "separate-lines" (e1) {
                        const [n] = e1, i = o(e1);
                        if ("Block" !== n.type || !s && i) return;
                        let l = a(e1);
                        i && (l = l.slice(1, l.length - 1));
                        const c = r.getTokenAfter(n, {
                            includeComments: !0
                        });
                        c && n.loc.end.line === c.loc.start.line || t.report({
                            loc: {
                                start: n.loc.start,
                                end: {
                                    line: n.loc.start.line,
                                    column: n.loc.start.column + 2
                                }
                            },
                            messageId: "expectedLines",
                            fix: (e1)=>e1.replaceText(n, function(e1, t) {
                                    return t.map((e1)=>`// ${e1}`).join(`\n${u(e1)}`);
                                }(n, l))
                        });
                    },
                    "bare-block" (e1) {
                        if (o(e1)) return;
                        const [r] = e1, n = a(e1);
                        "Line" === r.type && n.length > 1 && !n.some((e1)=>e1.includes("*/")) && t.report({
                            loc: {
                                start: r.loc.start,
                                end: e1[e1.length - 1].loc.end
                            },
                            messageId: "expectedBlock",
                            fix: (t)=>t.replaceTextRange([
                                    r.range[0],
                                    e1[e1.length - 1].range[1]
                                ], l(r, n))
                        }), i(e1) && t.report({
                            loc: {
                                start: r.loc.start,
                                end: {
                                    line: r.loc.start.line,
                                    column: r.loc.start.column + 2
                                }
                            },
                            messageId: "expectedBareBlock",
                            fix: (e1)=>e1.replaceText(r, l(r, n))
                        });
                    }
                };
                return {
                    Program: ()=>r.getAllComments().filter((e1)=>"Shebang" !== e1.type).filter((t)=>!e1.COMMENTS_IGNORE_PATTERN.test(t.value)).filter((e1)=>{
                            const t = r.getTokenBefore(e1, {
                                includeComments: !0
                            });
                            return !t || t.loc.end.line < e1.loc.start.line;
                        }).reduce((e1, t, n, s)=>{
                            const i = r.getTokenBefore(t, {
                                includeComments: !0
                            });
                            return "Line" === t.type && n && "Line" === s[n - 1].type && i && i.loc.end.line === t.loc.start.line - 1 && i === s[n - 1] ? e1[e1.length - 1].push(t) : e1.push([
                                t
                            ]), e1;
                        }, []).filter((e1)=>!(1 === e1.length && e1[0].loc.start.line === e1[0].loc.end.line)).forEach(c[n])
                };
            }
        }, sf;
    }
    function Ld() {
        if (cf) return lf;
        cf = 1;
        const e1 = Ll(), t = [
            "Array",
            "Boolean",
            "Date",
            "Error",
            "Function",
            "Number",
            "Object",
            "RegExp",
            "String",
            "Symbol",
            "BigInt"
        ];
        function r(e1, t, r) {
            if (Object.prototype.hasOwnProperty.call(e1, t) && !Array.isArray(e1[t])) throw new TypeError(`${t}, if provided, must be an Array`);
            return e1[t] || r;
        }
        function n(e1, t) {
            return e1[t] = !0, e1;
        }
        return lf = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require constructor names to begin with a capital letter",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/new-cap"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            newIsCap: {
                                type: "boolean",
                                default: !0
                            },
                            capIsNew: {
                                type: "boolean",
                                default: !0
                            },
                            newIsCapExceptions: {
                                type: "array",
                                items: {
                                    type: "string"
                                }
                            },
                            newIsCapExceptionPattern: {
                                type: "string"
                            },
                            capIsNewExceptions: {
                                type: "array",
                                items: {
                                    type: "string"
                                }
                            },
                            capIsNewExceptionPattern: {
                                type: "string"
                            },
                            properties: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    upper: "A function with a name starting with an uppercase letter should only be used as a constructor.",
                    lower: "A constructor name should not start with a lowercase letter."
                }
            },
            create (s) {
                const i = Object.assign({}, s.options[0]);
                i.newIsCap = !1 !== i.newIsCap, i.capIsNew = !1 !== i.capIsNew;
                const o = !1 === i.properties, a = r(i, "newIsCapExceptions", []).reduce(n, {}), u = i.newIsCapExceptionPattern ? new RegExp(i.newIsCapExceptionPattern, "u") : null, l = function(e1) {
                    let s = r(e1, "capIsNewExceptions", t);
                    return s !== t && (s = s.concat(t)), s.reduce(n, {});
                }(i), c = i.capIsNewExceptionPattern ? new RegExp(i.capIsNewExceptionPattern, "u") : null, p = {}, f = s.sourceCode;
                function d(t) {
                    return "Identifier" === t.callee.type ? t.callee.name : e1.getStaticPropertyName(t.callee) || "";
                }
                function h(e1) {
                    const t = e1.charAt(0), r = t.toLowerCase();
                    return r === t.toUpperCase() ? "non-alpha" : t === r ? "lower" : "upper";
                }
                function m(t, r, n, s) {
                    const i = f.getText(r.callee);
                    if (t[n] || t[i]) return !0;
                    if (s && s.test(i)) return !0;
                    const a = e1.skipChainExpression(r.callee);
                    return "UTC" === n && "MemberExpression" === a.type ? "Identifier" === a.object.type && "Date" === a.object.name : o && "MemberExpression" === a.type;
                }
                function g(t, r) {
                    let n = e1.skipChainExpression(t.callee);
                    "MemberExpression" === n.type && (n = n.property), s.report({
                        node: t,
                        loc: n.loc,
                        messageId: r
                    });
                }
                return i.newIsCap && (p.NewExpression = function(e1) {
                    const t = d(e1);
                    if (t) "lower" !== h(t) || m(a, e1, t, u) || g(e1, "lower");
                }), i.capIsNew && (p.CallExpression = function(e1) {
                    const t = d(e1);
                    if (t) "upper" !== h(t) || m(l, e1, t, c) || g(e1, "upper");
                }), p;
            }
        }, lf;
    }
    function Pd() {
        if (hf) return df;
        hf = 1;
        const e1 = Ll();
        return df = {
            meta: {
                type: "layout",
                docs: {
                    description: "Require or disallow an empty line after variable declarations",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/newline-after-var"
                },
                schema: [
                    {
                        enum: [
                            "never",
                            "always"
                        ]
                    }
                ],
                fixable: "whitespace",
                messages: {
                    expected: "Expected blank line after variable declarations.",
                    unexpected: "Unexpected blank line after variable declarations."
                },
                deprecated: !0,
                replacedBy: [
                    "padding-line-between-statements"
                ]
            },
            create (t) {
                const r = t.sourceCode, n = "never" === t.options[0] ? "never" : "always", s = r.getAllComments().reduce((e1, t)=>(e1[t.loc.start.line] = t.loc.end.line, e1), {});
                function i(e1) {
                    const t = s[e1];
                    return s[t + 1] ? i(t + 1) : t;
                }
                return {
                    VariableDeclaration: function(o) {
                        const a = function(e1) {
                            const t = r.getLastToken(e1);
                            if ("Punctuator" === t.type && ";" === t.value) {
                                const e1 = r.getTokenBefore(t);
                                if (e1.loc.end.line !== t.loc.start.line) return e1;
                            }
                            return t;
                        }(o), u = a === r.getLastToken(o) ? r.getTokenAfter(o) : r.getLastToken(o), l = a.loc.end.line + 1;
                        if (!u) return;
                        if (function(e1) {
                            return "ForStatement" === e1 || "ForInStatement" === e1 || "ForOfStatement" === e1;
                        }(o.parent.type)) return;
                        if ("ExportNamedDeclaration" === (c = o.parent.type) || "ExportSpecifier" === c || "ExportDefaultDeclaration" === c || "ExportAllDeclaration" === c) return;
                        var c;
                        if ("Keyword" === u.type && function(e1) {
                            return "var" === e1 || "let" === e1 || "const" === e1;
                        }(u.value)) return;
                        if (function(e1) {
                            const t = r.getTokenAfter(e1);
                            return !t || "Punctuator" === t.type && "}" === t.value;
                        }(o)) return;
                        const p = u.loc.start.line > l, f = void 0 !== s[l];
                        var d;
                        "never" === n && p && !f && t.report({
                            node: o,
                            messageId: "unexpected",
                            fix (t) {
                                const n = r.getText().slice(a.range[1], u.range[0]).split(e1.LINEBREAK_MATCHER);
                                return t.replaceTextRange([
                                    a.range[1],
                                    u.range[0]
                                ], `${n.slice(0, -1).join("")}\n${n[n.length - 1]}`);
                            }
                        }), "always" !== n || p && (!f || (d = l, u.loc.start.line > i(d) + 1)) || t.report({
                            node: o,
                            messageId: "expected",
                            fix: (e1)=>(p ? i(l) : a.loc.end.line) === u.loc.start.line ? e1.insertTextBefore(u, "\n\n") : e1.insertTextBeforeRange([
                                    u.range[0] - u.loc.start.column,
                                    u.range[1]
                                ], "\n")
                        });
                    }
                };
            }
        }, df;
    }
    function Id() {
        return gf || (gf = 1, mf = {
            meta: {
                type: "layout",
                docs: {
                    description: "Require an empty line before `return` statements",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/newline-before-return"
                },
                fixable: "whitespace",
                schema: [],
                messages: {
                    expected: "Expected newline before return statement."
                },
                deprecated: !0,
                replacedBy: [
                    "padding-line-between-statements"
                ]
            },
            create (e1) {
                const t = e1.sourceCode;
                function r(e1, r) {
                    const n = t.getTokenBefore(e1);
                    return r.includes(n.value);
                }
                function n(e1) {
                    const r = e1.loc.start.line, n = function(e1) {
                        const r = t.getTokenBefore(e1);
                        let n;
                        return n = r ? r.loc.end.line : 0, n;
                    }(e1), s = function(e1, r) {
                        const n = t.getCommentsBefore(e1);
                        let s = 0;
                        return n.length ? (n.forEach((t)=>{
                            s++, "Block" === t.type && (s += t.loc.end.line - t.loc.start.line), t.loc.start.line === r && s--, t.loc.end.line === e1.loc.start.line && s--;
                        }), s) : s;
                    }(e1, n);
                    return r - n - s > 1;
                }
                return {
                    ReturnStatement (s) {
                        (function(e1) {
                            const t = e1.parent.type;
                            return e1.parent.body ? Array.isArray(e1.parent.body) ? e1.parent.body[0] === e1 : e1.parent.body === e1 : r(e1, "IfStatement" === t ? [
                                "else",
                                ")"
                            ] : "DoWhileStatement" === t ? [
                                "do"
                            ] : "SwitchCase" === t ? [
                                ":"
                            ] : [
                                ")"
                            ]);
                        })(s) || n(s) || e1.report({
                            node: s,
                            messageId: "expected",
                            fix (e1) {
                                if (function(e1) {
                                    const r = t.getCommentsBefore(e1), n = r[r.length - 1], s = t.getTokenBefore(e1);
                                    return 0 === r.length || n.loc.end.line === s.loc.end.line && n.loc.end.line !== e1.loc.start.line;
                                }(s)) {
                                    const r = t.getTokenBefore(s), n = s.loc.start.line === r.loc.end.line ? "\n\n" : "\n";
                                    return e1.insertTextBefore(s, n);
                                }
                                return null;
                            }
                        });
                    }
                };
            }
        }), mf;
    }
    function Fd() {
        if (Cf) return xf;
        Cf = 1;
        const { getStaticPropertyName: e1, getVariableByName: t, skipChainExpression: r } = Ll();
        function n(e1) {
            return /^(alert|confirm|prompt)$/u.test(e1);
        }
        function s(e1, t) {
            const r = function(e1, t) {
                const r = e1.references.filter((e1)=>e1.identifier.range[0] === t.range[0] && e1.identifier.range[1] === t.range[1]);
                return 1 === r.length ? r[0] : null;
            }(e1, t);
            return r && r.resolved && r.resolved.defs.length > 0;
        }
        return xf = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow the use of `alert`, `confirm`, and `prompt`",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-alert"
                },
                schema: [],
                messages: {
                    unexpected: "Unexpected {{name}}."
                }
            },
            create (i) {
                const o = i.sourceCode;
                return {
                    CallExpression (a) {
                        const u = r(a.callee), l = o.getScope(a);
                        if ("Identifier" === u.type) {
                            const e1 = u.name;
                            !s(l, u) && n(u.name) && i.report({
                                node: a,
                                messageId: "unexpected",
                                data: {
                                    name: e1
                                }
                            });
                        } else if ("MemberExpression" === u.type && function(e1, r) {
                            return "global" === e1.type && "ThisExpression" === r.type || !("Identifier" !== r.type || !("window" === r.name || "globalThis" === r.name && t(e1, "globalThis"))) && !s(e1, r);
                        }(l, u.object)) {
                            const t = e1(u);
                            n(t) && i.report({
                                node: a,
                                messageId: "unexpected",
                                data: {
                                    name: t
                                }
                            });
                        }
                    }
                };
            }
        }, xf;
    }
    function Nd() {
        if (bf) return Sf;
        bf = 1;
        const { getVariableByName: e1, isClosingParenToken: t, isOpeningParenToken: r, isStartOfExpressionStatement: n, needsPrecedingSemicolon: s } = Ll();
        return Sf = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow `Array` constructors",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-array-constructor"
                },
                hasSuggestions: !0,
                schema: [],
                messages: {
                    preferLiteral: "The array literal notation [] is preferable.",
                    useLiteral: "Replace with an array literal.",
                    useLiteralAfterSemicolon: "Replace with an array literal, add preceding semicolon."
                }
            },
            create (i) {
                const o = i.sourceCode;
                function a(a) {
                    if ("Identifier" !== a.callee.type || "Array" !== a.callee.name || 1 === a.arguments.length && "SpreadElement" !== a.arguments[0].type) return;
                    const u = e1(o.getScope(a), "Array");
                    if (u && 0 === u.identifiers.length) {
                        const e1 = function(e1) {
                            const n = o.getLastToken(e1);
                            if (!t(n)) return "";
                            let s = e1.callee;
                            do {
                                if (s = o.getTokenAfter(s), !s || s === n) return "";
                            }while (!r(s));
                            return o.text.slice(s.range[1], n.range[0]);
                        }(a);
                        let u, l;
                        n(a) && s(o, a) ? (u = `;[${e1}]`, l = "useLiteralAfterSemicolon") : (u = `[${e1}]`, l = "useLiteral"), i.report({
                            node: a,
                            messageId: "preferLiteral",
                            suggest: [
                                {
                                    messageId: l,
                                    fix: (e1)=>e1.replaceText(a, u)
                                }
                            ]
                        });
                    }
                }
                return {
                    CallExpression: a,
                    NewExpression: a
                };
            }
        }, Sf;
    }
    function Od() {
        if (wf) return Df;
        wf = 1;
        const e1 = [
            "^",
            "|",
            "&",
            "<<",
            ">>",
            ">>>",
            "^=",
            "|=",
            "&=",
            "<<=",
            ">>=",
            ">>>=",
            "~"
        ];
        return Df = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow bitwise operators",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-bitwise"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            allow: {
                                type: "array",
                                items: {
                                    enum: e1
                                },
                                uniqueItems: !0
                            },
                            int32Hint: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unexpected: "Unexpected use of '{{operator}}'."
                }
            },
            create (t) {
                const r = t.options[0] || {}, n = r.allow || [], s = !0 === r.int32Hint;
                function i(r) {
                    !function(t) {
                        return e1.includes(t.operator);
                    }(r) || function(e1) {
                        return n.includes(e1.operator);
                    }(r) || function(e1) {
                        return s && "|" === e1.operator && e1.right && "Literal" === e1.right.type && 0 === e1.right.value;
                    }(r) || function(e1) {
                        t.report({
                            node: e1,
                            messageId: "unexpected",
                            data: {
                                operator: e1.operator
                            }
                        });
                    }(r);
                }
                return {
                    AssignmentExpression: i,
                    BinaryExpression: i,
                    UnaryExpression: i
                };
            }
        }, Df;
    }
    function Ud() {
        if (Nf) return Ff;
        Nf = 1;
        const e1 = Ll();
        return Ff = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow `catch` clause parameters from shadowing variables in the outer scope",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-catch-shadow"
                },
                replacedBy: [
                    "no-shadow"
                ],
                deprecated: !0,
                schema: [],
                messages: {
                    mutable: "Value of '{{name}}' may be overwritten in IE 8 and earlier."
                }
            },
            create (t) {
                const r = t.sourceCode;
                return {
                    "CatchClause[param!=null]" (n) {
                        let s = r.getScope(n);
                        s.block === n && (s = s.upper), function(t, r) {
                            return null !== e1.getVariableByName(t, r);
                        }(s, n.param.name) && t.report({
                            node: n,
                            messageId: "mutable",
                            data: {
                                name: n.param.name
                            }
                        });
                    }
                };
            }
        }, Ff;
    }
    function jd() {
        if (Mf) return Kf;
        Mf = 1;
        const e1 = Ll(), t = new Set([
            "IfStatement",
            "WhileStatement",
            "DoWhileStatement",
            "ForStatement",
            "ConditionalExpression"
        ]), r = {
            DoWhileStatement: "a 'do...while' statement",
            ForStatement: "a 'for' statement",
            IfStatement: "an 'if' statement",
            WhileStatement: "a 'while' statement"
        };
        return Kf = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow assignment operators in conditional expressions",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-cond-assign"
                },
                schema: [
                    {
                        enum: [
                            "except-parens",
                            "always"
                        ]
                    }
                ],
                messages: {
                    unexpected: "Unexpected assignment within {{type}}.",
                    missing: "Expected a conditional expression and instead saw an assignment."
                }
            },
            create (n) {
                const s = n.options[0] || "except-parens", i = n.sourceCode;
                function o(e1) {
                    return e1.parent && t.has(e1.parent.type) && e1 === e1.parent.test;
                }
                function a(t) {
                    !t.test || "AssignmentExpression" !== t.test.type || ("ForStatement" === t.type ? e1.isParenthesised(i, t.test) : function(t) {
                        const r = i.getTokenBefore(t, 1), n = i.getTokenAfter(t, 1);
                        return e1.isParenthesised(i, t) && r && e1.isOpeningParenToken(r) && r.range[1] <= t.range[0] && e1.isClosingParenToken(n) && n.range[0] >= t.range[1];
                    }(t.test)) || n.report({
                        node: t.test,
                        messageId: "missing"
                    });
                }
                return "always" === s ? {
                    AssignmentExpression: function(t) {
                        const s = function(t) {
                            let r = t;
                            do {
                                if (o(r)) return r.parent;
                            }while ((r = r.parent) && !e1.isFunction(r));
                            return null;
                        }(t);
                        s && n.report({
                            node: t,
                            messageId: "unexpected",
                            data: {
                                type: r[s.type] || s.type
                            }
                        });
                    }
                } : {
                    DoWhileStatement: a,
                    ForStatement: a,
                    IfStatement: a,
                    WhileStatement: a,
                    ConditionalExpression: a
                };
            }
        }, Kf;
    }
    function Vd() {
        if (Wf) return Gf;
        Wf = 1;
        const e1 = Ll();
        return Gf = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow the use of `console`",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-console"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            allow: {
                                type: "array",
                                items: {
                                    type: "string"
                                },
                                minItems: 1,
                                uniqueItems: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                hasSuggestions: !0,
                messages: {
                    unexpected: "Unexpected console statement.",
                    removeConsole: "Remove the console.{{ propertyName }}()."
                }
            },
            create (t) {
                const r = (t.options[0] || {}).allow || [], n = t.sourceCode;
                function s(e1) {
                    const t = e1.identifier;
                    return t && "console" === t.name;
                }
                function i(t) {
                    const n = t.identifier, s = n.parent;
                    return "MemberExpression" === s.type && s.object === n && !function(t) {
                        const n = e1.getStaticPropertyName(t);
                        return n && r.includes(n);
                    }(s);
                }
                function o(t) {
                    return "CallExpression" === t.parent.type && t.parent.callee === t && "ExpressionStatement" === t.parent.parent.type && e1.STATEMENT_LIST_PARENTS.has(t.parent.parent.parent.type) && !function(e1) {
                        const t = n.getTokenBefore(e1), r = n.getTokenAfter(e1);
                        return Boolean(r) && /^[-[(/+`]/u.test(r.value) && "++" !== r.value && "--" !== r.value && Boolean(t) && !/^[:;{]$/u.test(t.value);
                    }(t.parent.parent);
                }
                function a(r) {
                    const n = r.identifier.parent, s = e1.getStaticPropertyName(n);
                    t.report({
                        node: n,
                        loc: n.loc,
                        messageId: "unexpected",
                        suggest: o(n) ? [
                            {
                                messageId: "removeConsole",
                                data: {
                                    propertyName: s
                                },
                                fix: (e1)=>e1.remove(n.parent.parent)
                            }
                        ] : []
                    });
                }
                return {
                    "Program:exit" (t) {
                        const r = n.getScope(t), o = e1.getVariableByName(r, "console"), u = o && o.defs.length > 0, l = o ? o.references : r.through.filter(s);
                        u || l.filter(i).forEach(a);
                    }
                };
            }
        }, Gf;
    }
    function Kd() {
        if (Jf) return Hf;
        Jf = 1;
        const e1 = Js(), { isNullLiteral: t, isConstant: r, isReferenceToGlobalVariable: n, isLogicalAssignmentOperator: s } = Ll(), i = new Set([
            "+",
            "-",
            "*",
            "/",
            "%",
            "|",
            "^",
            "&",
            "**",
            "<<",
            ">>",
            ">>>"
        ]);
        function o(e1, r) {
            return t(r) || "Identifier" === r.type && "undefined" === r.name && n(e1, r) || "UnaryExpression" === r.type && "void" === r.operator;
        }
        function a(e1, t, r) {
            if (r && o(e1, t)) return !1;
            switch(t.type){
                case "ObjectExpression":
                case "ArrayExpression":
                case "ArrowFunctionExpression":
                case "FunctionExpression":
                case "ClassExpression":
                case "NewExpression":
                case "Literal":
                case "TemplateLiteral":
                case "UpdateExpression":
                case "BinaryExpression":
                case "UnaryExpression":
                    return !0;
                case "CallExpression":
                    {
                        if ("Identifier" !== t.callee.type) return !1;
                        const r = t.callee.name;
                        return ("Boolean" === r || "String" === r || "Number" === r) && n(e1, t.callee);
                    }
                case "LogicalExpression":
                    return "??" === t.operator && a(e1, t.right, !0);
                case "AssignmentExpression":
                    return "=" === t.operator ? a(e1, t.right, r) : !s(t.operator);
                case "SequenceExpression":
                    return a(e1, t.expressions[t.expressions.length - 1], r);
                case "Identifier":
                    return "undefined" === t.name && n(e1, t);
                default:
                    return !1;
            }
        }
        function u(e1, t) {
            switch(t.type){
                case "Literal":
                    return "boolean" == typeof t.value;
                case "CallExpression":
                    return "Identifier" === t.callee.type && "Boolean" === t.callee.name && n(e1, t.callee) && (0 === t.arguments.length || r(e1, t.arguments[0], !0));
                case "UnaryExpression":
                    return "!" === t.operator && r(e1, t.argument, !0);
                default:
                    return !1;
            }
        }
        function l(e1, t) {
            switch(t.type){
                case "ObjectExpression":
                case "ClassExpression":
                case "ArrowFunctionExpression":
                case "FunctionExpression":
                case "Literal":
                    return !0;
                case "ArrayExpression":
                    {
                        const e1 = t.elements.filter((e1)=>null !== e1 && "SpreadElement" !== e1.type);
                        return 0 === t.elements.length || e1.length > 1;
                    }
                case "UnaryExpression":
                    return "void" === t.operator || "typeof" === t.operator || "!" === t.operator && r(e1, t.argument, !0);
                case "NewExpression":
                case "JSXElement":
                case "JSXFragment":
                default:
                    return !1;
                case "CallExpression":
                    return !("Identifier" !== t.callee.type || "Boolean" !== t.callee.name || !n(e1, t.callee)) && (0 === t.arguments.length || r(e1, t.arguments[0], !0));
                case "Identifier":
                    return "undefined" === t.name && n(e1, t);
                case "TemplateLiteral":
                    return 0 === t.expressions.length;
                case "AssignmentExpression":
                    return "=" === t.operator && l(e1, t.right);
                case "SequenceExpression":
                    return l(e1, t.expressions[t.expressions.length - 1]);
            }
        }
        function c(e1, t) {
            switch(t.type){
                case "ObjectExpression":
                case "ArrayExpression":
                case "ArrowFunctionExpression":
                case "FunctionExpression":
                case "ClassExpression":
                case "NewExpression":
                case "TemplateLiteral":
                case "Literal":
                case "UpdateExpression":
                    return !0;
                case "BinaryExpression":
                    return i.has(t.operator);
                case "UnaryExpression":
                    return "delete" !== t.operator && ("!" !== t.operator || r(e1, t.argument, !0));
                case "SequenceExpression":
                    return c(e1, t.expressions[t.expressions.length - 1]);
                case "Identifier":
                    return "undefined" === t.name && n(e1, t);
                case "AssignmentExpression":
                    return "=" === t.operator ? c(e1, t.right) : !s(t.operator);
                case "CallExpression":
                    {
                        if ("Identifier" !== t.callee.type) return !1;
                        const s = t.callee.name;
                        return !("String" !== s && "Number" !== s || !n(e1, t.callee)) || !("Boolean" !== s || !n(e1, t.callee)) && (0 === t.arguments.length || r(e1, t.arguments[0], !0));
                    }
                default:
                    return !1;
            }
        }
        function p(t, r) {
            switch(r.type){
                case "ObjectExpression":
                case "ArrayExpression":
                case "ArrowFunctionExpression":
                case "FunctionExpression":
                case "ClassExpression":
                    return !0;
                case "NewExpression":
                    return "Identifier" === r.callee.type && Object.hasOwnProperty.call(e1.builtin, r.callee.name) && n(t, r.callee);
                case "Literal":
                    return "object" == typeof r.regex;
                case "SequenceExpression":
                    return p(t, r.expressions[r.expressions.length - 1]);
                case "AssignmentExpression":
                    return "=" === r.operator && p(t, r.right);
                case "ConditionalExpression":
                    return p(t, r.consequent) && p(t, r.alternate);
                default:
                    return !1;
            }
        }
        function f(e1, t, r, n) {
            if ("==" === n || "!=" === n) {
                if (o(e1, t) && a(e1, r, !1) || u(e1, t) && l(e1, r)) return r;
            } else if (("===" === n || "!==" === n) && (o(e1, t) && a(e1, r, !1) || u(e1, t) && c(e1, r))) return r;
            return null;
        }
        return Hf = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow expressions where the operation doesn't affect the value",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-constant-binary-expression"
                },
                schema: [],
                messages: {
                    constantBinaryOperand: "Unexpected constant binary expression. Compares constantly with the {{otherSide}}-hand side of the `{{operator}}`.",
                    constantShortCircuit: "Unexpected constant {{property}} on the left-hand side of a `{{operator}}` expression.",
                    alwaysNew: "Unexpected comparison to newly constructed object. These two values can never be equal.",
                    bothAlwaysNew: "Unexpected comparison of two newly constructed objects. These two values can never be equal."
                }
            },
            create (e1) {
                const t = e1.sourceCode;
                return {
                    LogicalExpression (n) {
                        const { operator: s, left: i } = n, o = t.getScope(n);
                        "&&" !== s && "||" !== s || !r(o, i, !0) ? "??" === s && a(o, i, !1) && e1.report({
                            node: i,
                            messageId: "constantShortCircuit",
                            data: {
                                property: "nullishness",
                                operator: s
                            }
                        }) : e1.report({
                            node: i,
                            messageId: "constantShortCircuit",
                            data: {
                                property: "truthiness",
                                operator: s
                            }
                        });
                    },
                    BinaryExpression (r) {
                        const n = t.getScope(r), { right: s, left: i, operator: o } = r, a = f(n, i, s, o), u = f(n, s, i, o);
                        a ? e1.report({
                            node: a,
                            messageId: "constantBinaryOperand",
                            data: {
                                operator: o,
                                otherSide: "left"
                            }
                        }) : u ? e1.report({
                            node: u,
                            messageId: "constantBinaryOperand",
                            data: {
                                operator: o,
                                otherSide: "right"
                            }
                        }) : "===" === o || "!==" === o ? p(n, i) ? e1.report({
                            node: i,
                            messageId: "alwaysNew"
                        }) : p(n, s) && e1.report({
                            node: s,
                            messageId: "alwaysNew"
                        }) : "==" !== o && "!=" !== o || p(n, i) && p(n, s) && e1.report({
                            node: i,
                            messageId: "bothAlwaysNew"
                        });
                    }
                };
            }
        }, Hf;
    }
    function Md() {
        if (Yf) return Qf;
        Yf = 1;
        const { isConstant: e1 } = Ll();
        return Qf = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow constant expressions in conditions",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-constant-condition"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            checkLoops: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unexpected: "Unexpected constant condition."
                }
            },
            create (t) {
                const r = !1 !== (t.options[0] || {}).checkLoops, n = [], s = t.sourceCode;
                let i = new Set;
                function o(e1) {
                    i.has(e1) && (i.delete(e1), t.report({
                        node: e1.test,
                        messageId: "unexpected"
                    }));
                }
                function a(r) {
                    r.test && e1(s.getScope(r), r.test, !0) && t.report({
                        node: r.test,
                        messageId: "unexpected"
                    });
                }
                function u() {
                    n.push(i), i = new Set;
                }
                function l() {
                    i = n.pop();
                }
                function c(t) {
                    r && function(t) {
                        t.test && e1(s.getScope(t), t.test, !0) && i.add(t);
                    }(t);
                }
                return {
                    ConditionalExpression: a,
                    IfStatement: a,
                    WhileStatement: c,
                    "WhileStatement:exit": o,
                    DoWhileStatement: c,
                    "DoWhileStatement:exit": o,
                    ForStatement: c,
                    "ForStatement > .test": (e1)=>c(e1.parent),
                    "ForStatement:exit": o,
                    FunctionDeclaration: u,
                    "FunctionDeclaration:exit": l,
                    FunctionExpression: u,
                    "FunctionExpression:exit": l,
                    YieldExpression: ()=>i.clear()
                };
            }
        }, Qf;
    }
    var $d, qd, Gd, Wd, Xd, zd, Hd, Jd, Qd, Yd, Zd, eh, th, rh, nh, sh, ih, oh, ah, uh, lh, ch, ph, fh, dh, hh, mh, gh, yh, Eh, xh, Ch, Sh, bh, vh, Ah, Th, Rh, Dh, wh, _h, kh, Bh, Lh, Ph, Ih, Fh, Nh, Oh, Uh, jh, Vh, Kh, Mh, $h, qh, Gh, Wh, Xh, zh, Hh, Jh, Qh, Yh, Zh, em, tm, rm, nm, sm, im, om, am, um, lm, cm, pm, fm, dm, hm, mm, gm, ym, Em, xm, Cm, Sm, bm, vm, Am, Tm, Rm, Dm, wm, _m, km, Bm, Lm, Pm, Im, Fm, Nm, Om, Um, jm, Vm, Km, Mm, $m, qm, Gm, Wm, Xm, zm, Hm, Jm, Qm, Ym, Zm, eg, tg, rg, ng, sg, ig, og, ag, ug, lg, cg, pg, fg, dg, hg, mg, gg, yg, Eg, xg, Cg, Sg, bg, vg, Ag, Tg, Rg, Dg, wg, _g, kg, Bg, Lg, Pg, Ig, Fg, Ng, Og, Ug, jg, Vg, Kg, Mg, $g, qg, Gg, Wg, Xg, zg, Hg, Jg, Qg, Yg, Zg, ey, ty, ry, ny, sy, iy, oy, ay, uy, ly, cy, py, fy, dy, hy, my, gy, yy, Ey, xy, Cy, Sy, by, vy, Ay, Ty, Ry, Dy, wy, _y, ky, By, Ly, Py, Iy, Fy, Ny, Oy, Uy, jy, Vy, Ky, My, $y, qy, Gy, Wy, Xy, zy, Hy, Jy, Qy, Yy, Zy, eE, tE, rE, nE, sE, iE, oE, aE, uE, lE, cE, pE, fE, dE, hE, mE, gE, yE, EE, xE, CE, SE, bE, vE, AE, TE, RE, DE, wE, _E, kE, BE, LE, PE, IE, FE, NE, OE, UE, jE, VE, KE, ME, $E, qE, GE, WE, XE, zE, HE, JE, QE, YE, ZE, ex, tx, rx, nx, sx, ix, ox, ax, ux, lx, cx, px, fx, dx, hx, mx, gx, yx, Ex, xx, Cx, Sx, bx, vx, Ax, Tx, Rx, Dx, wx, _x, kx, Bx, Lx, Px, Ix, Fx, Nx, Ox, Ux, jx, Vx, Kx, Mx, $x, qx, Gx, Wx, Xx, zx, Hx, Jx, Qx, Yx, Zx, eC, tC, rC, nC, sC, iC, oC, aC, uC, lC, cC, pC, fC, dC, hC, mC, gC, yC, EC, xC, CC, SC, bC, vC, AC, TC, RC, DC, wC = {};
    function _C() {
        if ($d) return wC;
        $d = 1, Object.defineProperty(wC, "__esModule", {
            value: !0
        });
        var e1 = Object.freeze({
            __proto__: null
        });
        let t, r;
        function n(e1) {
            return !(e1 < 48) && (e1 < 58 || !(e1 < 65) && (e1 < 91 || 95 === e1 || !(e1 < 97) && (e1 < 123 || s(e1) || function(e1) {
                return i(e1, null != r ? r : r = o("53 0 g9 33 o 0 70 4 7e 18 2 0 2 1 2 1 2 0 21 a 1d u 7 0 2u 6 3 5 3 1 2 3 3 9 o 0 v q 2k a g 9 y 8 a 0 p 3 2 8 2 2 2 4 18 2 1o 8 17 n 2 w 1j 2 2 h 2 6 b 1 3 9 i 2 1l 0 2 6 3 1 3 2 a 0 b 1 3 9 f 0 3 2 1l 0 2 4 5 1 3 2 4 0 l b 4 0 c 2 1l 0 2 7 2 2 2 2 l 1 3 9 b 5 2 2 1l 0 2 6 3 1 3 2 8 2 b 1 3 9 j 0 1o 4 4 2 2 3 a 0 f 9 h 4 1k 0 2 6 2 2 2 3 8 1 c 1 3 9 i 2 1l 0 2 6 2 2 2 3 8 1 c 1 3 9 4 0 d 3 1k 1 2 6 2 2 2 3 a 0 b 1 3 9 i 2 1z 0 5 5 2 0 2 7 7 9 3 1 1q 0 3 6 d 7 2 9 2g 0 3 8 c 6 2 9 1r 1 7 9 c 0 2 0 2 0 5 1 1e j 2 1 6 a 2 z a 0 2t j 2 9 d 3 5 2 2 2 3 6 4 3 e b 2 e jk 2 a 8 pt 3 t 2 u 1 v 1 1t v a 0 3 9 y 2 2 a 40 0 3b b 5 b b 9 3l a 1p 4 1m 9 2 s 3 a 7 9 n d 2 u 3 b l 4 1c g c 9 i 8 d 2 v c 3 9 19 d 1d j 9 9 7 9 3b 2 2 k 5 0 7 0 3 2 5j 1r el 1 1e 1 k 0 3g c 5 0 4 b 2db 2 3y 0 2p v ff 5 2y 1 2p 0 n51 9 1y 0 5 9 x 1 29 1 7l 0 4 0 5 0 o 4 5 0 2c 1 1f h b 9 7 h e a t 7 q c 19 3 1c d g 9 c 0 b 9 1c d d 0 9 1 3 9 y 2 1f 0 2 2 3 1 6 1 2 0 16 4 6 1 6l 7 2 1 3 9 fmt 0 ki f h f 4 1 p 2 5d 9 12 0 12 0 ig 0 6b 0 46 4 86 9 120 2 2 1 6 3 15 2 5 0 4m 1 fy 3 9 9 7 9 w 4 8u 1 26 5 1z a 1e 3 3f 2 1i e w a 3 1 b 3 1a a 8 0 1a 9 7 2 11 d 2 9 6 1 19 0 d 2 1d d 9 3 2 b 2b b 7 0 3 0 4e b 6 9 7 3 1k 1 2 6 3 1 3 2 a 0 b 1 3 6 4 4 1w 8 2 0 3 0 2 3 2 4 2 0 f 1 2b h a 9 5 0 2a j d 9 5y 6 3 8 s 1 2b g g 9 2a c 9 9 7 j 1m e 5 9 6r e 4m 9 1z 5 2 1 3 3 2 0 2 1 d 9 3c 6 3 6 4 0 t 9 15 6 2 3 9 0 a a 1b f 5j 7 3t 9 1i 7 2 7 h 9 1l l 2 d 3f 5 4 0 2 1 2 6 2 0 9 9 1d 4 2 1 2 4 9 9 1j 9 7e 3 a 1 2 0 1d 6 4 4 e a 44m 0 7 e 8uh r 1t3 9 2f 9 13 4 1o 6 q 9 ev 9 d2 0 2 1i 8 3 2a 0 c 1 f58 1 382 9 ef 19 3 m f3 4 4 5 9 7 3 6 v 3 45 2 13e 1d e9 1i 5 1d 9 0 f 0 n 4 2 e 11t 6 2 g 3 6 2 1 2 4 2t 0 4h 6 a 9 9x 0 1q d dv d 6t 1 2 9 6h 0 3 0 8 1 6 0 d7 6 32 6 6 9 3o7 9 gvt3 6n"));
            }(e1))));
        }
        function s(e1) {
            return i(e1, null != t ? t : t = o("4q 0 b 0 5 0 6 m 2 u 2 cp 5 b f 4 8 0 2 0 3m 4 2 1 3 3 2 0 7 0 2 2 2 0 2 j 2 2a 2 3u 9 4l 2 11 3 0 7 14 20 q 5 3 1a 16 10 1 2 2q 2 0 g 1 8 1 b 2 3 0 h 0 2 t u 2g c 0 p w a 1 5 0 6 l 5 0 a 0 4 0 o o 8 a 6 n 2 6 h 15 1n 1h 4 0 j 0 8 9 g f 5 7 3 1 3 l 2 6 2 0 4 3 4 0 h 0 e 1 2 2 f 1 b 0 9 5 5 1 3 l 2 6 2 1 2 1 2 1 w 3 2 0 k 2 h 8 2 2 2 l 2 6 2 1 2 4 4 0 j 0 g 1 o 0 c 7 3 1 3 l 2 6 2 1 2 4 4 0 v 1 2 2 g 0 i 0 2 5 4 2 2 3 4 1 2 0 2 1 4 1 4 2 4 b n 0 1h 7 2 2 2 m 2 f 4 0 r 2 2 1 3 1 v 0 5 7 2 2 2 m 2 9 2 4 4 0 v 2 2 1 g 1 i 8 2 2 2 14 3 0 h 0 6 2 9 2 p 5 6 h 4 n 2 8 2 0 3 6 1n 1b 2 1 d 6 1n 1 2 0 2 4 2 n 2 0 2 9 2 1 a 0 3 4 2 0 m 3 x 0 1s 7 2 z s 4 38 16 l 0 h 5 5 3 4 0 4 1 8 2 5 c d 0 i 11 2 0 6 0 3 16 2 98 2 3 3 6 2 0 2 3 3 14 2 3 3 w 2 3 3 6 2 0 2 3 3 e 2 1k 2 3 3 1u 12 f h 2d 3 5 4 h7 3 g 2 p 6 22 4 a 8 h e i f h f c 2 2 g 1f 10 0 5 0 1w 2g 8 14 2 0 6 1x b u 1e t 3 4 c 17 5 p 1j m a 1g 2b 0 2m 1a i 7 1j t e 1 b 17 r z 16 2 b z 3 a 6 16 3 2 16 3 2 5 2 1 4 0 6 5b 1t 7p 3 5 3 11 3 5 3 7 2 0 2 0 2 0 2 u 3 1g 2 6 2 0 4 2 2 6 4 3 3 5 5 c 6 2 2 6 39 0 e 0 h c 2u 0 5 0 3 9 2 0 3 5 7 0 2 0 2 0 2 f 3 3 6 4 5 0 i 14 22g 6c 7 3 4 1 d 11 2 0 6 0 3 1j 8 0 h m a 6 2 6 2 6 2 6 2 6 2 6 2 6 2 6 fb 2 q 8 8 4 3 4 5 2d 5 4 2 2h 2 3 6 16 2 2l i v 1d f e9 533 1t h3g 1w 19 3 7g 4 f b 1 l 1a h u 3 27 14 8 3 2u 3 29 l g 2 2 2 3 2 m u 1f f 1d 1r 5 4 0 2 1 c r b m q s 8 1a t 0 h 4 2 9 b 4 2 14 o 2 2 7 l m 4 0 4 1d 2 0 4 1 3 4 3 0 2 0 p 2 3 a 8 2 d 5 3 5 3 5 a 6 2 6 2 16 2 d 7 36 u 8mb d m 5 1c 6it a5 3 2x 13 6 d 4 6 0 2 9 2 c 2 4 2 0 2 1 2 1 2 2z y a2 j 1r 3 1h 15 b 39 4 2 3q 11 p 7 p c 2g 4 5 3 5 3 5 3 2 10 b 2 p 2 i 2 1 2 e 3 d z 3e 1y 1g 7g s 4 1c 1c v e t 6 11 b t 3 z 5 7 2 4 17 4d j z 5 z 5 13 9 1f d a 2 e 2 6 2 1 2 a 2 e 2 6 2 1 4 1f d 8m a l b 7 p 5 2 15 2 8 1y 5 3 0 2 17 2 1 4 0 3 m b m a u 1u i 2 1 b l b p 7 p 13 1j 7 1 1t 0 g 3 2 2 2 s 17 s 4 s 10 7 2 r s 1h b l b i e h 33 20 1k 1e e 1e e z 13 r a m 6z 15 7 1 h 5 1l s b 0 9 l 17 h 1b k s m d 1g 1m 1 3 0 e 18 x o r z u 0 3 0 9 y 4 0 d 1b f 3 m 0 2 0 10 h 2 o k 1 1s 6 2 0 2 3 2 e 2 9 8 1a 13 7 3 1 3 l 2 6 2 1 2 4 4 0 j 0 d 4 v 9 2 0 3 0 2 11 2 0 q 0 2 0 19 1g j 3 l 2 v 1b l 1 2 0 55 1a 16 3 11 1b l 0 1o 16 e 0 20 q 12 6 56 17 39 1r w 7 3 0 3 7 2 1 2 n g 0 2 0 2n 7 3 12 h 0 2 0 t 0 b 13 8 0 m 0 c 19 k 0 j 20 5k w w 8 2 10 i 0 1e t 35 6 2 1 2 11 m 0 q 5 2 1 2 v f 0 o 17 79 i g 0 2 c 2 x 3h 0 28 pl 2v 32 i 5f 219 2o g tr i 5 q 32y 6 g6 5a2 t 1cz fs 8 u i 26 i t j 1b h 3 w k 6 i c1 18 5w 1r x o 3 o 19 22 6 0 1v c 1t 1 2 0 f 4 a 5p1 16 v 2q 36 6pq 3 2 6 2 1 2 82 g 0 u 2 3 0 f 3 9 az 1s5 2y 6 c 4 8 8 9 4mf 2c 2 1y 2 1 3 0 3 1 3 3 2 b 2 0 2 6 2 1s 2 3 3 7 2 6 2 r 2 3 2 4 2 0 4 6 2 9f 3 o 2 o 2 u 2 o 2 u 2 o 2 u 2 o 2 u 2 o 2 7 1f9 u 7 5 7a 1p 43 18 b 6 h 0 8y t j 17 dh r 6d t 3 0 5s u 2 2 2 1 2 6 3 4 a 1 69 6 2 3 2 1 2 e 2 5g 1o 1v 8 0 xh 3 2 q 2 1 2 0 3 0 2 9 2 3 2 0 2 0 7 0 5 0 2 0 2 0 2 2 2 1 2 0 3 0 2 0 2 0 2 0 2 0 2 1 2 0 3 3 2 6 2 3 2 3 2 0 2 9 2 g 6 2 2 4 2 g 3et wyn x 3dp 3 4gd 3 5rk g h9 1wj f1 15v 3t6 6 6jt"));
        }
        function i(e1, t) {
            let r = 0, n = t.length / 2 | 0, s = 0, i = 0, o = 0;
            for(; r < n;)if (s = (r + n) / 2 | 0, i = t[2 * s], o = t[2 * s + 1], e1 < i) n = s;
            else {
                if (!(e1 > o)) return !0;
                r = s + 1;
            }
            return !1;
        }
        function o(e1) {
            let t = 0;
            return e1.split(" ").map((e1)=>t += 0 | parseInt(e1, 36));
        }
        class a {
            constructor(e1, t, r, n, s, i, o, a, u){
                this._raw2018 = e1, this._raw2019 = t, this._raw2020 = r, this._raw2021 = n, this._raw2022 = s, this._raw2023 = i, this._raw2024 = o, this._raw2025 = a, this._raw2026 = u;
            }
            get es2018() {
                var e1;
                return null !== (e1 = this._set2018) && void 0 !== e1 ? e1 : this._set2018 = new Set(this._raw2018.split(" "));
            }
            get es2019() {
                var e1;
                return null !== (e1 = this._set2019) && void 0 !== e1 ? e1 : this._set2019 = new Set(this._raw2019.split(" "));
            }
            get es2020() {
                var e1;
                return null !== (e1 = this._set2020) && void 0 !== e1 ? e1 : this._set2020 = new Set(this._raw2020.split(" "));
            }
            get es2021() {
                var e1;
                return null !== (e1 = this._set2021) && void 0 !== e1 ? e1 : this._set2021 = new Set(this._raw2021.split(" "));
            }
            get es2022() {
                var e1;
                return null !== (e1 = this._set2022) && void 0 !== e1 ? e1 : this._set2022 = new Set(this._raw2022.split(" "));
            }
            get es2023() {
                var e1;
                return null !== (e1 = this._set2023) && void 0 !== e1 ? e1 : this._set2023 = new Set(this._raw2023.split(" "));
            }
            get es2024() {
                var e1;
                return null !== (e1 = this._set2024) && void 0 !== e1 ? e1 : this._set2024 = new Set(this._raw2024.split(" "));
            }
            get es2025() {
                var e1;
                return null !== (e1 = this._set2025) && void 0 !== e1 ? e1 : this._set2025 = new Set(this._raw2025.split(" "));
            }
            get es2026() {
                var e1;
                return null !== (e1 = this._set2026) && void 0 !== e1 ? e1 : this._set2026 = new Set(this._raw2026.split(" "));
            }
        }
        const u = new Set([
            "General_Category",
            "gc"
        ]), l = new Set([
            "Script",
            "Script_Extensions",
            "sc",
            "scx"
        ]), c = new a("C Cased_Letter Cc Cf Close_Punctuation Cn Co Combining_Mark Connector_Punctuation Control Cs Currency_Symbol Dash_Punctuation Decimal_Number Enclosing_Mark Final_Punctuation Format Initial_Punctuation L LC Letter Letter_Number Line_Separator Ll Lm Lo Lowercase_Letter Lt Lu M Mark Math_Symbol Mc Me Mn Modifier_Letter Modifier_Symbol N Nd Nl No Nonspacing_Mark Number Open_Punctuation Other Other_Letter Other_Number Other_Punctuation Other_Symbol P Paragraph_Separator Pc Pd Pe Pf Pi Po Private_Use Ps Punctuation S Sc Separator Sk Sm So Space_Separator Spacing_Mark Surrogate Symbol Titlecase_Letter Unassigned Uppercase_Letter Z Zl Zp Zs cntrl digit punct", "", "", "", "", "", "", "", ""), p = new a("Adlam Adlm Aghb Ahom Anatolian_Hieroglyphs Arab Arabic Armenian Armi Armn Avestan Avst Bali Balinese Bamu Bamum Bass Bassa_Vah Batak Batk Beng Bengali Bhaiksuki Bhks Bopo Bopomofo Brah Brahmi Brai Braille Bugi Buginese Buhd Buhid Cakm Canadian_Aboriginal Cans Cari Carian Caucasian_Albanian Chakma Cham Cher Cherokee Common Copt Coptic Cprt Cuneiform Cypriot Cyrillic Cyrl Deseret Deva Devanagari Dsrt Dupl Duployan Egyp Egyptian_Hieroglyphs Elba Elbasan Ethi Ethiopic Geor Georgian Glag Glagolitic Gonm Goth Gothic Gran Grantha Greek Grek Gujarati Gujr Gurmukhi Guru Han Hang Hangul Hani Hano Hanunoo Hatr Hatran Hebr Hebrew Hira Hiragana Hluw Hmng Hung Imperial_Aramaic Inherited Inscriptional_Pahlavi Inscriptional_Parthian Ital Java Javanese Kaithi Kali Kana Kannada Katakana Kayah_Li Khar Kharoshthi Khmer Khmr Khoj Khojki Khudawadi Knda Kthi Lana Lao Laoo Latin Latn Lepc Lepcha Limb Limbu Lina Linb Linear_A Linear_B Lisu Lyci Lycian Lydi Lydian Mahajani Mahj Malayalam Mand Mandaic Mani Manichaean Marc Marchen Masaram_Gondi Meetei_Mayek Mend Mende_Kikakui Merc Mero Meroitic_Cursive Meroitic_Hieroglyphs Miao Mlym Modi Mong Mongolian Mro Mroo Mtei Mult Multani Myanmar Mymr Nabataean Narb Nbat New_Tai_Lue Newa Nko Nkoo Nshu Nushu Ogam Ogham Ol_Chiki Olck Old_Hungarian Old_Italic Old_North_Arabian Old_Permic Old_Persian Old_South_Arabian Old_Turkic Oriya Orkh Orya Osage Osge Osma Osmanya Pahawh_Hmong Palm Palmyrene Pau_Cin_Hau Pauc Perm Phag Phags_Pa Phli Phlp Phnx Phoenician Plrd Prti Psalter_Pahlavi Qaac Qaai Rejang Rjng Runic Runr Samaritan Samr Sarb Saur Saurashtra Sgnw Sharada Shavian Shaw Shrd Sidd Siddham SignWriting Sind Sinh Sinhala Sora Sora_Sompeng Soyo Soyombo Sund Sundanese Sylo Syloti_Nagri Syrc Syriac Tagalog Tagb Tagbanwa Tai_Le Tai_Tham Tai_Viet Takr Takri Tale Talu Tamil Taml Tang Tangut Tavt Telu Telugu Tfng Tglg Thaa Thaana Thai Tibetan Tibt Tifinagh Tirh Tirhuta Ugar Ugaritic Vai Vaii Wara Warang_Citi Xpeo Xsux Yi Yiii Zanabazar_Square Zanb Zinh Zyyy", "Dogr Dogra Gong Gunjala_Gondi Hanifi_Rohingya Maka Makasar Medefaidrin Medf Old_Sogdian Rohg Sogd Sogdian Sogo", "Elym Elymaic Hmnp Nand Nandinagari Nyiakeng_Puachue_Hmong Wancho Wcho", "Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi", "Cpmn Cypro_Minoan Old_Uyghur Ougr Tangsa Tnsa Toto Vith Vithkuqi", "Berf Beria_Erfe Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sidetic Sidt Sunu Sunuwar Tai_Yo Tayo Todhri Todr Tolong_Siki Tols Tulu_Tigalari Tutg Unknown Zzzz", "", "", ""), f = new a("AHex ASCII ASCII_Hex_Digit Alpha Alphabetic Any Assigned Bidi_C Bidi_Control Bidi_M Bidi_Mirrored CI CWCF CWCM CWKCF CWL CWT CWU Case_Ignorable Cased Changes_When_Casefolded Changes_When_Casemapped Changes_When_Lowercased Changes_When_NFKC_Casefolded Changes_When_Titlecased Changes_When_Uppercased DI Dash Default_Ignorable_Code_Point Dep Deprecated Dia Diacritic Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Ext Extender Gr_Base Gr_Ext Grapheme_Base Grapheme_Extend Hex Hex_Digit IDC IDS IDSB IDST IDS_Binary_Operator IDS_Trinary_Operator ID_Continue ID_Start Ideo Ideographic Join_C Join_Control LOE Logical_Order_Exception Lower Lowercase Math NChar Noncharacter_Code_Point Pat_Syn Pat_WS Pattern_Syntax Pattern_White_Space QMark Quotation_Mark RI Radical Regional_Indicator SD STerm Sentence_Terminal Soft_Dotted Term Terminal_Punctuation UIdeo Unified_Ideograph Upper Uppercase VS Variation_Selector White_Space XIDC XIDS XID_Continue XID_Start space", "Extended_Pictographic", "", "EBase EComp EMod EPres ExtPict", "", "", "", "", ""), d = new a("", "", "", "", "", "", "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji RGI_Emoji_Flag_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence", "", "");
        function h(e1, t, r) {
            return u.has(t) ? e1 >= 2018 && c.es2018.has(r) : !!l.has(t) && (e1 >= 2018 && p.es2018.has(r) || e1 >= 2019 && p.es2019.has(r) || e1 >= 2020 && p.es2020.has(r) || e1 >= 2021 && p.es2021.has(r) || e1 >= 2022 && p.es2022.has(r) || e1 >= 2023 && p.es2023.has(r));
        }
        const m = 36, g = 38, y = 40, E = 41, x = 45, C = 48, S = 63, b = 99, v = 115, A = 117, T = 91, R = 92, D = 93, w = 94, _ = 123, k = 124, B = 125;
        function L(e1) {
            return e1 >= 65 && e1 <= 90 || e1 >= 97 && e1 <= 122;
        }
        function P(e1) {
            return e1 >= C && e1 <= 57;
        }
        function I(e1) {
            return e1 >= C && e1 <= 57 || e1 >= 65 && e1 <= 70 || e1 >= 97 && e1 <= 102;
        }
        function F(e1) {
            return 10 === e1 || 13 === e1 || 8232 === e1 || 8233 === e1;
        }
        function N(e1) {
            return e1 >= 97 && e1 <= 102 ? e1 - 97 + 10 : e1 >= 65 && e1 <= 70 ? e1 - 65 + 10 : e1 - C;
        }
        function O(e1) {
            return e1 >= 55296 && e1 <= 56319;
        }
        function U(e1) {
            return e1 >= 56320 && e1 <= 57343;
        }
        function j(e1, t) {
            return 1024 * (e1 - 55296) + (t - 56320) + 65536;
        }
        class V {
            constructor(){
                this.groupName = new Set;
            }
            clear() {
                this.groupName.clear();
            }
            isEmpty() {
                return !this.groupName.size;
            }
            hasInPattern(e1) {
                return this.groupName.has(e1);
            }
            hasInScope(e1) {
                return this.hasInPattern(e1);
            }
            addToScope(e1) {
                this.groupName.add(e1);
            }
            enterDisjunction() {}
            enterAlternative() {}
            leaveDisjunction() {}
        }
        class K {
            constructor(e1, t){
                this.parent = e1, this.base = null != t ? t : this;
            }
            separatedFrom(e1) {
                var t, r;
                return this.base === e1.base && this !== e1 || !(!e1.parent || !this.separatedFrom(e1.parent)) || null !== (r = null === (t = this.parent) || void 0 === t ? void 0 : t.separatedFrom(e1)) && void 0 !== r && r;
            }
            child() {
                return new K(this, null);
            }
            sibling() {
                return new K(this.parent, this.base);
            }
        }
        class M {
            constructor(){
                this.branchID = new K(null, null), this.groupNames = new Map;
            }
            clear() {
                this.branchID = new K(null, null), this.groupNames.clear();
            }
            isEmpty() {
                return !this.groupNames.size;
            }
            enterDisjunction() {
                this.branchID = this.branchID.child();
            }
            enterAlternative(e1) {
                0 !== e1 && (this.branchID = this.branchID.sibling());
            }
            leaveDisjunction() {
                this.branchID = this.branchID.parent;
            }
            hasInPattern(e1) {
                return this.groupNames.has(e1);
            }
            hasInScope(e1) {
                const t = this.groupNames.get(e1);
                if (!t) return !1;
                for (const e1 of t)if (!e1.separatedFrom(this.branchID)) return !0;
                return !1;
            }
            addToScope(e1) {
                const t = this.groupNames.get(e1);
                t ? t.push(this.branchID) : this.groupNames.set(e1, [
                    this.branchID
                ]);
            }
        }
        const $ = {
            at: (e1, t, r)=>r < t ? e1.charCodeAt(r) : -1,
            width: (e1)=>1
        }, q = {
            at: (e1, t, r)=>r < t ? e1.codePointAt(r) : -1,
            width: (e1)=>e1 > 65535 ? 2 : 1
        };
        class G {
            constructor(){
                this._impl = $, this._s = "", this._i = 0, this._end = 0, this._cp1 = -1, this._w1 = 1, this._cp2 = -1, this._w2 = 1, this._cp3 = -1, this._w3 = 1, this._cp4 = -1;
            }
            get source() {
                return this._s;
            }
            get index() {
                return this._i;
            }
            get currentCodePoint() {
                return this._cp1;
            }
            get nextCodePoint() {
                return this._cp2;
            }
            get nextCodePoint2() {
                return this._cp3;
            }
            get nextCodePoint3() {
                return this._cp4;
            }
            reset(e1, t, r, n) {
                this._impl = n ? q : $, this._s = e1, this._end = r, this.rewind(t);
            }
            rewind(e1) {
                const t = this._impl;
                this._i = e1, this._cp1 = t.at(this._s, this._end, e1), this._w1 = t.width(this._cp1), this._cp2 = t.at(this._s, this._end, e1 + this._w1), this._w2 = t.width(this._cp2), this._cp3 = t.at(this._s, this._end, e1 + this._w1 + this._w2), this._w3 = t.width(this._cp3), this._cp4 = t.at(this._s, this._end, e1 + this._w1 + this._w2 + this._w3);
            }
            advance() {
                if (-1 !== this._cp1) {
                    const e1 = this._impl;
                    this._i += this._w1, this._cp1 = this._cp2, this._w1 = this._w2, this._cp2 = this._cp3, this._w2 = e1.width(this._cp2), this._cp3 = this._cp4, this._w3 = e1.width(this._cp3), this._cp4 = e1.at(this._s, this._end, this._i + this._w1 + this._w2 + this._w3);
                }
            }
            eat(e1) {
                return this._cp1 === e1 && (this.advance(), !0);
            }
            eat2(e1, t) {
                return this._cp1 === e1 && this._cp2 === t && (this.advance(), this.advance(), !0);
            }
            eat3(e1, t, r) {
                return this._cp1 === e1 && this._cp2 === t && this._cp3 === r && (this.advance(), this.advance(), this.advance(), !0);
            }
        }
        class W extends SyntaxError {
            constructor(e1, t){
                super(e1), this.index = t;
            }
        }
        const X = new Set([
            w,
            m,
            R,
            46,
            42,
            43,
            S,
            y,
            E,
            T,
            D,
            _,
            B,
            k
        ]), z = new Set([
            g,
            33,
            35,
            m,
            37,
            42,
            43,
            44,
            46,
            58,
            59,
            60,
            61,
            62,
            S,
            64,
            w,
            96,
            126
        ]), H = new Set([
            y,
            E,
            T,
            D,
            _,
            B,
            47,
            x,
            R,
            k
        ]), J = new Set([
            g,
            x,
            33,
            35,
            37,
            44,
            58,
            59,
            60,
            61,
            62,
            64,
            96,
            126
        ]), Q = {
            global: 103,
            ignoreCase: 105,
            multiline: 109,
            unicode: A,
            sticky: 121,
            dotAll: v,
            hasIndices: 100,
            unicodeSets: 118
        }, Y = Object.fromEntries(Object.entries(Q).map(([e1, t])=>[
                t,
                e1
            ]));
        function Z(e1) {
            return X.has(e1);
        }
        function ee(e1) {
            return z.has(e1);
        }
        function te(e1) {
            return function(e1) {
                return !(e1 < 65) && (e1 < 91 || !(e1 < 97) && (e1 < 123 || s(e1)));
            }(e1) || e1 === m || 95 === e1;
        }
        function re(e1) {
            return L(e1) || 95 === e1;
        }
        class ne {
            constructor(e1){
                this._reader = new G, this._unicodeMode = !1, this._unicodeSetsMode = !1, this._nFlag = !1, this._lastIntValue = 0, this._lastRange = {
                    min: 0,
                    max: Number.POSITIVE_INFINITY
                }, this._lastStrValue = "", this._lastAssertionIsQuantifiable = !1, this._numCapturingParens = 0, this._backreferenceNames = new Set, this._srcCtx = null, this._options = null != e1 ? e1 : {}, this._groupSpecifiers = this.ecmaVersion >= 2025 ? new M : new V;
            }
            validateLiteral(e1, t = 0, r = e1.length) {
                if (this._srcCtx = {
                    source: e1,
                    start: t,
                    end: r,
                    kind: "literal"
                }, this._unicodeSetsMode = this._unicodeMode = this._nFlag = !1, this.reset(e1, t, r), this.onLiteralEnter(t), this.eat(47) && this.eatRegExpBody() && this.eat(47)) {
                    const n = this.index, s = e1.includes("u", n), i = e1.includes("v", n);
                    this.validateFlagsInternal(e1, n, r), this.validatePatternInternal(e1, t + 1, n - 1, {
                        unicode: s,
                        unicodeSets: i
                    });
                } else if (t >= r) this.raise("Empty");
                else {
                    const e1 = String.fromCodePoint(this.currentCodePoint);
                    this.raise(`Unexpected character '${e1}'`);
                }
                this.onLiteralLeave(t, r);
            }
            validateFlags(e1, t = 0, r = e1.length) {
                this._srcCtx = {
                    source: e1,
                    start: t,
                    end: r,
                    kind: "flags"
                }, this.validateFlagsInternal(e1, t, r);
            }
            validatePattern(e1, t = 0, r = e1.length, n) {
                this._srcCtx = {
                    source: e1,
                    start: t,
                    end: r,
                    kind: "pattern"
                }, this.validatePatternInternal(e1, t, r, n);
            }
            validatePatternInternal(e1, t = 0, r = e1.length, n) {
                const s = this._parseFlagsOptionToMode(n, r);
                this._unicodeMode = s.unicodeMode, this._nFlag = s.nFlag, this._unicodeSetsMode = s.unicodeSetsMode, this.reset(e1, t, r), this.consumePattern(), !this._nFlag && this.ecmaVersion >= 2018 && !this._groupSpecifiers.isEmpty() && (this._nFlag = !0, this.rewind(t), this.consumePattern());
            }
            validateFlagsInternal(e1, t, r) {
                const n = this.parseFlags(e1, t, r);
                this.onRegExpFlags(t, r, n);
            }
            _parseFlagsOptionToMode(e1, t) {
                let r = !1, n = !1;
                e1 && this.ecmaVersion >= 2015 && ("object" == typeof e1 ? (r = Boolean(e1.unicode), this.ecmaVersion >= 2024 && (n = Boolean(e1.unicodeSets))) : r = e1), r && n && this.raise("Invalid regular expression flags", {
                    index: t + 1,
                    unicode: r,
                    unicodeSets: n
                });
                return {
                    unicodeMode: r || n,
                    nFlag: r && this.ecmaVersion >= 2018 || n || Boolean(this._options.strict && this.ecmaVersion >= 2023),
                    unicodeSetsMode: n
                };
            }
            get strict() {
                return Boolean(this._options.strict) || this._unicodeMode;
            }
            get ecmaVersion() {
                var e1;
                return null !== (e1 = this._options.ecmaVersion) && void 0 !== e1 ? e1 : 2025;
            }
            onLiteralEnter(e1) {
                this._options.onLiteralEnter && this._options.onLiteralEnter(e1);
            }
            onLiteralLeave(e1, t) {
                this._options.onLiteralLeave && this._options.onLiteralLeave(e1, t);
            }
            onRegExpFlags(e1, t, r) {
                this._options.onRegExpFlags && this._options.onRegExpFlags(e1, t, r), this._options.onFlags && this._options.onFlags(e1, t, r.global, r.ignoreCase, r.multiline, r.unicode, r.sticky, r.dotAll, r.hasIndices);
            }
            onPatternEnter(e1) {
                this._options.onPatternEnter && this._options.onPatternEnter(e1);
            }
            onPatternLeave(e1, t) {
                this._options.onPatternLeave && this._options.onPatternLeave(e1, t);
            }
            onDisjunctionEnter(e1) {
                this._options.onDisjunctionEnter && this._options.onDisjunctionEnter(e1);
            }
            onDisjunctionLeave(e1, t) {
                this._options.onDisjunctionLeave && this._options.onDisjunctionLeave(e1, t);
            }
            onAlternativeEnter(e1, t) {
                this._options.onAlternativeEnter && this._options.onAlternativeEnter(e1, t);
            }
            onAlternativeLeave(e1, t, r) {
                this._options.onAlternativeLeave && this._options.onAlternativeLeave(e1, t, r);
            }
            onGroupEnter(e1) {
                this._options.onGroupEnter && this._options.onGroupEnter(e1);
            }
            onGroupLeave(e1, t) {
                this._options.onGroupLeave && this._options.onGroupLeave(e1, t);
            }
            onModifiersEnter(e1) {
                this._options.onModifiersEnter && this._options.onModifiersEnter(e1);
            }
            onModifiersLeave(e1, t) {
                this._options.onModifiersLeave && this._options.onModifiersLeave(e1, t);
            }
            onAddModifiers(e1, t, r) {
                this._options.onAddModifiers && this._options.onAddModifiers(e1, t, r);
            }
            onRemoveModifiers(e1, t, r) {
                this._options.onRemoveModifiers && this._options.onRemoveModifiers(e1, t, r);
            }
            onCapturingGroupEnter(e1, t) {
                this._options.onCapturingGroupEnter && this._options.onCapturingGroupEnter(e1, t);
            }
            onCapturingGroupLeave(e1, t, r) {
                this._options.onCapturingGroupLeave && this._options.onCapturingGroupLeave(e1, t, r);
            }
            onQuantifier(e1, t, r, n, s) {
                this._options.onQuantifier && this._options.onQuantifier(e1, t, r, n, s);
            }
            onLookaroundAssertionEnter(e1, t, r) {
                this._options.onLookaroundAssertionEnter && this._options.onLookaroundAssertionEnter(e1, t, r);
            }
            onLookaroundAssertionLeave(e1, t, r, n) {
                this._options.onLookaroundAssertionLeave && this._options.onLookaroundAssertionLeave(e1, t, r, n);
            }
            onEdgeAssertion(e1, t, r) {
                this._options.onEdgeAssertion && this._options.onEdgeAssertion(e1, t, r);
            }
            onWordBoundaryAssertion(e1, t, r, n) {
                this._options.onWordBoundaryAssertion && this._options.onWordBoundaryAssertion(e1, t, r, n);
            }
            onAnyCharacterSet(e1, t, r) {
                this._options.onAnyCharacterSet && this._options.onAnyCharacterSet(e1, t, r);
            }
            onEscapeCharacterSet(e1, t, r, n) {
                this._options.onEscapeCharacterSet && this._options.onEscapeCharacterSet(e1, t, r, n);
            }
            onUnicodePropertyCharacterSet(e1, t, r, n, s, i, o) {
                this._options.onUnicodePropertyCharacterSet && this._options.onUnicodePropertyCharacterSet(e1, t, r, n, s, i, o);
            }
            onCharacter(e1, t, r) {
                this._options.onCharacter && this._options.onCharacter(e1, t, r);
            }
            onBackreference(e1, t, r) {
                this._options.onBackreference && this._options.onBackreference(e1, t, r);
            }
            onCharacterClassEnter(e1, t, r) {
                this._options.onCharacterClassEnter && this._options.onCharacterClassEnter(e1, t, r);
            }
            onCharacterClassLeave(e1, t, r) {
                this._options.onCharacterClassLeave && this._options.onCharacterClassLeave(e1, t, r);
            }
            onCharacterClassRange(e1, t, r, n) {
                this._options.onCharacterClassRange && this._options.onCharacterClassRange(e1, t, r, n);
            }
            onClassIntersection(e1, t) {
                this._options.onClassIntersection && this._options.onClassIntersection(e1, t);
            }
            onClassSubtraction(e1, t) {
                this._options.onClassSubtraction && this._options.onClassSubtraction(e1, t);
            }
            onClassStringDisjunctionEnter(e1) {
                this._options.onClassStringDisjunctionEnter && this._options.onClassStringDisjunctionEnter(e1);
            }
            onClassStringDisjunctionLeave(e1, t) {
                this._options.onClassStringDisjunctionLeave && this._options.onClassStringDisjunctionLeave(e1, t);
            }
            onStringAlternativeEnter(e1, t) {
                this._options.onStringAlternativeEnter && this._options.onStringAlternativeEnter(e1, t);
            }
            onStringAlternativeLeave(e1, t, r) {
                this._options.onStringAlternativeLeave && this._options.onStringAlternativeLeave(e1, t, r);
            }
            get index() {
                return this._reader.index;
            }
            get currentCodePoint() {
                return this._reader.currentCodePoint;
            }
            get nextCodePoint() {
                return this._reader.nextCodePoint;
            }
            get nextCodePoint2() {
                return this._reader.nextCodePoint2;
            }
            get nextCodePoint3() {
                return this._reader.nextCodePoint3;
            }
            reset(e1, t, r) {
                this._reader.reset(e1, t, r, this._unicodeMode);
            }
            rewind(e1) {
                this._reader.rewind(e1);
            }
            advance() {
                this._reader.advance();
            }
            eat(e1) {
                return this._reader.eat(e1);
            }
            eat2(e1, t) {
                return this._reader.eat2(e1, t);
            }
            eat3(e1, t, r) {
                return this._reader.eat3(e1, t, r);
            }
            raise(e1, t) {
                var r, n, s;
                throw function(e1, t, r, n) {
                    let s = "";
                    if ("literal" === e1.kind) {
                        const t = e1.source.slice(e1.start, e1.end);
                        t && (s = `: ${t}`);
                    } else "pattern" === e1.kind && (s = `: /${e1.source.slice(e1.start, e1.end)}/${t.unicode ? "u" : ""}${t.unicodeSets ? "v" : ""}`);
                    return new W(`Invalid regular expression${s}: ${n}`, r);
                }(this._srcCtx, {
                    unicode: null !== (r = null == t ? void 0 : t.unicode) && void 0 !== r ? r : this._unicodeMode && !this._unicodeSetsMode,
                    unicodeSets: null !== (n = null == t ? void 0 : t.unicodeSets) && void 0 !== n ? n : this._unicodeSetsMode
                }, null !== (s = null == t ? void 0 : t.index) && void 0 !== s ? s : this.index, e1);
            }
            eatRegExpBody() {
                const e1 = this.index;
                let t = !1, r = !1;
                for(;;){
                    const n = this.currentCodePoint;
                    if (-1 === n || F(n)) {
                        const e1 = t ? "character class" : "regular expression";
                        this.raise(`Unterminated ${e1}`);
                    }
                    if (r) r = !1;
                    else if (n === R) r = !0;
                    else if (n === T) t = !0;
                    else if (n === D) t = !1;
                    else if (47 === n && !t || 42 === n && this.index === e1) break;
                    this.advance();
                }
                return this.index !== e1;
            }
            consumePattern() {
                const e1 = this.index;
                this._numCapturingParens = this.countCapturingParens(), this._groupSpecifiers.clear(), this._backreferenceNames.clear(), this.onPatternEnter(e1), this.consumeDisjunction();
                const t = this.currentCodePoint;
                if (-1 !== this.currentCodePoint) {
                    t === E && this.raise("Unmatched ')'"), t === R && this.raise("\\ at end of pattern"), t !== D && t !== B || this.raise("Lone quantifier brackets");
                    const e1 = String.fromCodePoint(t);
                    this.raise(`Unexpected character '${e1}'`);
                }
                for (const e1 of this._backreferenceNames)this._groupSpecifiers.hasInPattern(e1) || this.raise("Invalid named capture referenced");
                this.onPatternLeave(e1, this.index);
            }
            countCapturingParens() {
                const e1 = this.index;
                let t = !1, r = !1, n = 0, s = 0;
                for(; -1 !== (s = this.currentCodePoint);)r ? r = !1 : s === R ? r = !0 : s === T ? t = !0 : s === D ? t = !1 : s !== y || t || this.nextCodePoint === S && (60 !== this.nextCodePoint2 || 61 === this.nextCodePoint3 || 33 === this.nextCodePoint3) || (n += 1), this.advance();
                return this.rewind(e1), n;
            }
            consumeDisjunction() {
                const e1 = this.index;
                let t = 0;
                this._groupSpecifiers.enterDisjunction(), this.onDisjunctionEnter(e1);
                do this.consumeAlternative(t++);
                while (this.eat(k));
                this.consumeQuantifier(!0) && this.raise("Nothing to repeat"), this.eat(_) && this.raise("Lone quantifier brackets"), this.onDisjunctionLeave(e1, this.index), this._groupSpecifiers.leaveDisjunction();
            }
            consumeAlternative(e1) {
                const t = this.index;
                for(this._groupSpecifiers.enterAlternative(e1), this.onAlternativeEnter(t, e1); -1 !== this.currentCodePoint && this.consumeTerm(););
                this.onAlternativeLeave(t, this.index, e1);
            }
            consumeTerm() {
                return this._unicodeMode || this.strict ? this.consumeAssertion() || this.consumeAtom() && this.consumeOptionalQuantifier() : this.consumeAssertion() && (!this._lastAssertionIsQuantifiable || this.consumeOptionalQuantifier()) || this.consumeExtendedAtom() && this.consumeOptionalQuantifier();
            }
            consumeOptionalQuantifier() {
                return this.consumeQuantifier(), !0;
            }
            consumeAssertion() {
                const e1 = this.index;
                if (this._lastAssertionIsQuantifiable = !1, this.eat(w)) return this.onEdgeAssertion(e1, this.index, "start"), !0;
                if (this.eat(m)) return this.onEdgeAssertion(e1, this.index, "end"), !0;
                if (this.eat2(R, 66)) return this.onWordBoundaryAssertion(e1, this.index, "word", !0), !0;
                if (this.eat2(R, 98)) return this.onWordBoundaryAssertion(e1, this.index, "word", !1), !0;
                if (this.eat2(y, S)) {
                    const t = this.ecmaVersion >= 2018 && this.eat(60);
                    let r = !1;
                    if (this.eat(61) || (r = this.eat(33))) {
                        const n = t ? "lookbehind" : "lookahead";
                        return this.onLookaroundAssertionEnter(e1, n, r), this.consumeDisjunction(), this.eat(E) || this.raise("Unterminated group"), this._lastAssertionIsQuantifiable = !t && !this.strict, this.onLookaroundAssertionLeave(e1, this.index, n, r), !0;
                    }
                    this.rewind(e1);
                }
                return !1;
            }
            consumeQuantifier(e1 = !1) {
                const t = this.index;
                let r = 0, n = 0, s = !1;
                if (this.eat(42)) r = 0, n = Number.POSITIVE_INFINITY;
                else if (this.eat(43)) r = 1, n = Number.POSITIVE_INFINITY;
                else if (this.eat(S)) r = 0, n = 1;
                else {
                    if (!this.eatBracedQuantifier(e1)) return !1;
                    ({ min: r, max: n } = this._lastRange);
                }
                return s = !this.eat(S), e1 || this.onQuantifier(t, this.index, r, n, s), !0;
            }
            eatBracedQuantifier(e1) {
                const t = this.index;
                if (this.eat(_)) {
                    if (this.eatDecimalDigits()) {
                        const t = this._lastIntValue;
                        let r = t;
                        if (this.eat(44) && (r = this.eatDecimalDigits() ? this._lastIntValue : Number.POSITIVE_INFINITY), this.eat(B)) return !e1 && r < t && this.raise("numbers out of order in {} quantifier"), this._lastRange = {
                            min: t,
                            max: r
                        }, !0;
                    }
                    e1 || !this._unicodeMode && !this.strict || this.raise("Incomplete quantifier"), this.rewind(t);
                }
                return !1;
            }
            consumeAtom() {
                return this.consumePatternCharacter() || this.consumeDot() || this.consumeReverseSolidusAtomEscape() || Boolean(this.consumeCharacterClass()) || this.consumeCapturingGroup() || this.consumeUncapturingGroup();
            }
            consumeDot() {
                return !!this.eat(46) && (this.onAnyCharacterSet(this.index - 1, this.index, "any"), !0);
            }
            consumeReverseSolidusAtomEscape() {
                const e1 = this.index;
                if (this.eat(R)) {
                    if (this.consumeAtomEscape()) return !0;
                    this.rewind(e1);
                }
                return !1;
            }
            consumeUncapturingGroup() {
                const e1 = this.index;
                return !!this.eat2(y, S) && (this.onGroupEnter(e1), this.ecmaVersion >= 2025 && this.consumeModifiers(), this.eat(58) || (this.rewind(e1 + 1), this.raise("Invalid group")), this.consumeDisjunction(), this.eat(E) || this.raise("Unterminated group"), this.onGroupLeave(e1, this.index), !0);
            }
            consumeModifiers() {
                const e1 = this.index, t = this.eatModifiers(), r = this.index, n = this.eat(x);
                if (!t && !n) return !1;
                this.onModifiersEnter(e1);
                const s = this.parseModifiers(e1, r);
                if (this.onAddModifiers(e1, r, s), n) {
                    const e1 = this.index;
                    this.eatModifiers() || t || 58 !== this.currentCodePoint || this.raise("Invalid empty flags");
                    const r = this.parseModifiers(e1, this.index);
                    for (const [e1] of Object.entries(r).filter(([, e1])=>e1))s[e1] && this.raise(`Duplicated flag '${String.fromCodePoint(Q[e1])}'`);
                    this.onRemoveModifiers(e1, this.index, r);
                }
                return this.onModifiersLeave(e1, this.index), !0;
            }
            consumeCapturingGroup() {
                const e1 = this.index;
                if (this.eat(y)) {
                    let t = null;
                    if (this.ecmaVersion >= 2018) {
                        if (this.consumeGroupSpecifier()) t = this._lastStrValue;
                        else if (this.currentCodePoint === S) return this.rewind(e1), !1;
                    } else if (this.currentCodePoint === S) return this.rewind(e1), !1;
                    return this.onCapturingGroupEnter(e1, t), this.consumeDisjunction(), this.eat(E) || this.raise("Unterminated group"), this.onCapturingGroupLeave(e1, this.index, t), !0;
                }
                return !1;
            }
            consumeExtendedAtom() {
                return this.consumeDot() || this.consumeReverseSolidusAtomEscape() || this.consumeReverseSolidusFollowedByC() || Boolean(this.consumeCharacterClass()) || this.consumeCapturingGroup() || this.consumeUncapturingGroup() || this.consumeInvalidBracedQuantifier() || this.consumeExtendedPatternCharacter();
            }
            consumeReverseSolidusFollowedByC() {
                const e1 = this.index;
                return this.currentCodePoint === R && this.nextCodePoint === b && (this._lastIntValue = this.currentCodePoint, this.advance(), this.onCharacter(e1, this.index, R), !0);
            }
            consumeInvalidBracedQuantifier() {
                return this.eatBracedQuantifier(!0) && this.raise("Nothing to repeat"), !1;
            }
            consumePatternCharacter() {
                const e1 = this.index, t = this.currentCodePoint;
                return -1 !== t && !Z(t) && (this.advance(), this.onCharacter(e1, this.index, t), !0);
            }
            consumeExtendedPatternCharacter() {
                const e1 = this.index, t = this.currentCodePoint;
                return -1 !== t && t !== w && t !== m && t !== R && 46 !== t && 42 !== t && 43 !== t && t !== S && t !== y && t !== E && t !== T && t !== k && (this.advance(), this.onCharacter(e1, this.index, t), !0);
            }
            consumeGroupSpecifier() {
                const e1 = this.index;
                if (this.eat(S)) {
                    if (this.eatGroupName()) {
                        if (!this._groupSpecifiers.hasInScope(this._lastStrValue)) return this._groupSpecifiers.addToScope(this._lastStrValue), !0;
                        this.raise("Duplicate capture group name");
                    }
                    this.rewind(e1);
                }
                return !1;
            }
            consumeAtomEscape() {
                return !!(this.consumeBackreference() || this.consumeCharacterClassEscape() || this.consumeCharacterEscape() || this._nFlag && this.consumeKGroupName()) || ((this.strict || this._unicodeMode) && this.raise("Invalid escape"), !1);
            }
            consumeBackreference() {
                const e1 = this.index;
                if (this.eatDecimalEscape()) {
                    const t = this._lastIntValue;
                    if (t <= this._numCapturingParens) return this.onBackreference(e1 - 1, this.index, t), !0;
                    (this.strict || this._unicodeMode) && this.raise("Invalid escape"), this.rewind(e1);
                }
                return !1;
            }
            consumeCharacterClassEscape() {
                var e1;
                const t = this.index;
                if (this.eat(100)) return this._lastIntValue = -1, this.onEscapeCharacterSet(t - 1, this.index, "digit", !1), {};
                if (this.eat(68)) return this._lastIntValue = -1, this.onEscapeCharacterSet(t - 1, this.index, "digit", !0), {};
                if (this.eat(v)) return this._lastIntValue = -1, this.onEscapeCharacterSet(t - 1, this.index, "space", !1), {};
                if (this.eat(83)) return this._lastIntValue = -1, this.onEscapeCharacterSet(t - 1, this.index, "space", !0), {};
                if (this.eat(119)) return this._lastIntValue = -1, this.onEscapeCharacterSet(t - 1, this.index, "word", !1), {};
                if (this.eat(87)) return this._lastIntValue = -1, this.onEscapeCharacterSet(t - 1, this.index, "word", !0), {};
                let r = !1;
                if (this._unicodeMode && this.ecmaVersion >= 2018 && (this.eat(112) || (r = this.eat(80)))) {
                    this._lastIntValue = -1;
                    let n = null;
                    if (this.eat(_) && (n = this.eatUnicodePropertyValueExpression()) && this.eat(B)) return r && n.strings && this.raise("Invalid property name"), this.onUnicodePropertyCharacterSet(t - 1, this.index, "property", n.key, n.value, r, null !== (e1 = n.strings) && void 0 !== e1 && e1), {
                        mayContainStrings: n.strings
                    };
                    this.raise("Invalid property name");
                }
                return null;
            }
            consumeCharacterEscape() {
                const e1 = this.index;
                return !!(this.eatControlEscape() || this.eatCControlLetter() || this.eatZero() || this.eatHexEscapeSequence() || this.eatRegExpUnicodeEscapeSequence() || !this.strict && !this._unicodeMode && this.eatLegacyOctalEscapeSequence() || this.eatIdentityEscape()) && (this.onCharacter(e1 - 1, this.index, this._lastIntValue), !0);
            }
            consumeKGroupName() {
                const e1 = this.index;
                if (this.eat(107)) {
                    if (this.eatGroupName()) {
                        const t = this._lastStrValue;
                        return this._backreferenceNames.add(t), this.onBackreference(e1 - 1, this.index, t), !0;
                    }
                    this.raise("Invalid named reference");
                }
                return !1;
            }
            consumeCharacterClass() {
                const e1 = this.index;
                if (this.eat(T)) {
                    const t = this.eat(w);
                    this.onCharacterClassEnter(e1, t, this._unicodeSetsMode);
                    const r = this.consumeClassContents();
                    return this.eat(D) || (-1 === this.currentCodePoint && this.raise("Unterminated character class"), this.raise("Invalid character in character class")), t && r.mayContainStrings && this.raise("Negated character class may contain strings"), this.onCharacterClassLeave(e1, this.index, t), r;
                }
                return null;
            }
            consumeClassContents() {
                if (this._unicodeSetsMode) {
                    if (this.currentCodePoint === D) return {};
                    return this.consumeClassSetExpression();
                }
                const e1 = this.strict || this._unicodeMode;
                for(;;){
                    const t = this.index;
                    if (!this.consumeClassAtom()) break;
                    const r = this._lastIntValue;
                    if (!this.eat(x)) continue;
                    if (this.onCharacter(this.index - 1, this.index, x), !this.consumeClassAtom()) break;
                    const n = this._lastIntValue;
                    -1 !== r && -1 !== n ? (r > n && this.raise("Range out of order in character class"), this.onCharacterClassRange(t, this.index, r, n)) : e1 && this.raise("Invalid character class");
                }
                return {};
            }
            consumeClassAtom() {
                const e1 = this.index, t = this.currentCodePoint;
                if (-1 !== t && t !== R && t !== D) return this.advance(), this._lastIntValue = t, this.onCharacter(e1, this.index, this._lastIntValue), !0;
                if (this.eat(R)) {
                    if (this.consumeClassEscape()) return !0;
                    if (!this.strict && this.currentCodePoint === b) return this._lastIntValue = R, this.onCharacter(e1, this.index, this._lastIntValue), !0;
                    (this.strict || this._unicodeMode) && this.raise("Invalid escape"), this.rewind(e1);
                }
                return !1;
            }
            consumeClassEscape() {
                const e1 = this.index;
                if (this.eat(98)) return this._lastIntValue = 8, this.onCharacter(e1 - 1, this.index, this._lastIntValue), !0;
                if (this._unicodeMode && this.eat(x)) return this._lastIntValue = x, this.onCharacter(e1 - 1, this.index, this._lastIntValue), !0;
                let t = 0;
                return this.strict || this._unicodeMode || this.currentCodePoint !== b || !P(t = this.nextCodePoint) && 95 !== t ? Boolean(this.consumeCharacterClassEscape()) || this.consumeCharacterEscape() : (this.advance(), this.advance(), this._lastIntValue = t % 32, this.onCharacter(e1 - 1, this.index, this._lastIntValue), !0);
            }
            consumeClassSetExpression() {
                const e1 = this.index;
                let t = !1, r = null;
                if (this.consumeClassSetCharacter()) {
                    if (this.consumeClassSetRangeFromOperator(e1)) return this.consumeClassUnionRight({}), {};
                    t = !1;
                } else if (r = this.consumeClassSetOperand()) t = r.mayContainStrings;
                else {
                    const e1 = this.currentCodePoint;
                    e1 === R && (this.advance(), this.raise("Invalid escape")), e1 === this.nextCodePoint && ee(e1) && this.raise("Invalid set operation in character class"), this.raise("Invalid character in character class");
                }
                if (this.eat2(g, g)) {
                    for(; this.currentCodePoint !== g && (r = this.consumeClassSetOperand());)if (this.onClassIntersection(e1, this.index), r.mayContainStrings || (t = !1), !this.eat2(g, g)) return {
                        mayContainStrings: t
                    };
                    this.raise("Invalid character in character class");
                }
                if (this.eat2(x, x)) {
                    for(; this.consumeClassSetOperand();)if (this.onClassSubtraction(e1, this.index), !this.eat2(x, x)) return {
                        mayContainStrings: t
                    };
                    this.raise("Invalid character in character class");
                }
                return this.consumeClassUnionRight({
                    mayContainStrings: t
                });
            }
            consumeClassUnionRight(e1) {
                let t = e1.mayContainStrings;
                for(;;){
                    const e1 = this.index;
                    if (this.consumeClassSetCharacter()) {
                        this.consumeClassSetRangeFromOperator(e1);
                        continue;
                    }
                    const r = this.consumeClassSetOperand();
                    if (!r) break;
                    r.mayContainStrings && (t = !0);
                }
                return {
                    mayContainStrings: t
                };
            }
            consumeClassSetRangeFromOperator(e1) {
                const t = this.index, r = this._lastIntValue;
                if (this.eat(x)) {
                    if (this.consumeClassSetCharacter()) {
                        const t = this._lastIntValue;
                        return -1 !== r && -1 !== t || this.raise("Invalid character class"), r > t && this.raise("Range out of order in character class"), this.onCharacterClassRange(e1, this.index, r, t), !0;
                    }
                    this.rewind(t);
                }
                return !1;
            }
            consumeClassSetOperand() {
                let e1 = null;
                return (e1 = this.consumeNestedClass()) || (e1 = this.consumeClassStringDisjunction()) ? e1 : this.consumeClassSetCharacter() ? {} : null;
            }
            consumeNestedClass() {
                const e1 = this.index;
                if (this.eat(T)) {
                    const t = this.eat(w);
                    this.onCharacterClassEnter(e1, t, !0);
                    const r = this.consumeClassContents();
                    return this.eat(D) || this.raise("Unterminated character class"), t && r.mayContainStrings && this.raise("Negated character class may contain strings"), this.onCharacterClassLeave(e1, this.index, t), r;
                }
                if (this.eat(R)) {
                    const t = this.consumeCharacterClassEscape();
                    if (t) return t;
                    this.rewind(e1);
                }
                return null;
            }
            consumeClassStringDisjunction() {
                const e1 = this.index;
                if (this.eat3(R, 113, _)) {
                    this.onClassStringDisjunctionEnter(e1);
                    let t = 0, r = !1;
                    do this.consumeClassString(t++).mayContainStrings && (r = !0);
                    while (this.eat(k));
                    if (this.eat(B)) return this.onClassStringDisjunctionLeave(e1, this.index), {
                        mayContainStrings: r
                    };
                    this.raise("Unterminated class string disjunction");
                }
                return null;
            }
            consumeClassString(e1) {
                const t = this.index;
                let r = 0;
                for(this.onStringAlternativeEnter(t, e1); -1 !== this.currentCodePoint && this.consumeClassSetCharacter();)r++;
                return this.onStringAlternativeLeave(t, this.index, e1), {
                    mayContainStrings: 1 !== r
                };
            }
            consumeClassSetCharacter() {
                const e1 = this.index, t = this.currentCodePoint;
                if (!(t === this.nextCodePoint && ee(t) || -1 === t || function(e1) {
                    return H.has(e1);
                }(t))) return this._lastIntValue = t, this.advance(), this.onCharacter(e1, this.index, this._lastIntValue), !0;
                if (this.eat(R)) {
                    if (this.consumeCharacterEscape()) return !0;
                    if (function(e1) {
                        return J.has(e1);
                    }(this.currentCodePoint)) return this._lastIntValue = this.currentCodePoint, this.advance(), this.onCharacter(e1, this.index, this._lastIntValue), !0;
                    if (this.eat(98)) return this._lastIntValue = 8, this.onCharacter(e1, this.index, this._lastIntValue), !0;
                    this.rewind(e1);
                }
                return !1;
            }
            eatGroupName() {
                if (this.eat(60)) {
                    if (this.eatRegExpIdentifierName() && this.eat(62)) return !0;
                    this.raise("Invalid capture group name");
                }
                return !1;
            }
            eatRegExpIdentifierName() {
                if (this.eatRegExpIdentifierStart()) {
                    for(this._lastStrValue = String.fromCodePoint(this._lastIntValue); this.eatRegExpIdentifierPart();)this._lastStrValue += String.fromCodePoint(this._lastIntValue);
                    return !0;
                }
                return !1;
            }
            eatRegExpIdentifierStart() {
                const e1 = this.index, t = !this._unicodeMode && this.ecmaVersion >= 2020;
                let r = this.currentCodePoint;
                return this.advance(), r === R && this.eatRegExpUnicodeEscapeSequence(t) ? r = this._lastIntValue : t && O(r) && U(this.currentCodePoint) && (r = j(r, this.currentCodePoint), this.advance()), te(r) ? (this._lastIntValue = r, !0) : (this.index !== e1 && this.rewind(e1), !1);
            }
            eatRegExpIdentifierPart() {
                const e1 = this.index, t = !this._unicodeMode && this.ecmaVersion >= 2020;
                let r = this.currentCodePoint;
                return this.advance(), r === R && this.eatRegExpUnicodeEscapeSequence(t) ? r = this._lastIntValue : t && O(r) && U(this.currentCodePoint) && (r = j(r, this.currentCodePoint), this.advance()), function(e1) {
                    return n(e1) || e1 === m || 8204 === e1 || 8205 === e1;
                }(r) ? (this._lastIntValue = r, !0) : (this.index !== e1 && this.rewind(e1), !1);
            }
            eatCControlLetter() {
                const e1 = this.index;
                if (this.eat(b)) {
                    if (this.eatControlLetter()) return !0;
                    this.rewind(e1);
                }
                return !1;
            }
            eatZero() {
                return this.currentCodePoint === C && !P(this.nextCodePoint) && (this._lastIntValue = 0, this.advance(), !0);
            }
            eatControlEscape() {
                return this.eat(102) ? (this._lastIntValue = 12, !0) : this.eat(110) ? (this._lastIntValue = 10, !0) : this.eat(114) ? (this._lastIntValue = 13, !0) : this.eat(116) ? (this._lastIntValue = 9, !0) : !!this.eat(118) && (this._lastIntValue = 11, !0);
            }
            eatControlLetter() {
                const e1 = this.currentCodePoint;
                return !!L(e1) && (this.advance(), this._lastIntValue = e1 % 32, !0);
            }
            eatRegExpUnicodeEscapeSequence(e1 = !1) {
                const t = this.index, r = e1 || this._unicodeMode;
                if (this.eat(A)) {
                    if (r && this.eatRegExpUnicodeSurrogatePairEscape() || this.eatFixedHexDigits(4) || r && this.eatRegExpUnicodeCodePointEscape()) return !0;
                    (this.strict || r) && this.raise("Invalid unicode escape"), this.rewind(t);
                }
                return !1;
            }
            eatRegExpUnicodeSurrogatePairEscape() {
                const e1 = this.index;
                if (this.eatFixedHexDigits(4)) {
                    const t = this._lastIntValue;
                    if (O(t) && this.eat(R) && this.eat(A) && this.eatFixedHexDigits(4)) {
                        const e1 = this._lastIntValue;
                        if (U(e1)) return this._lastIntValue = j(t, e1), !0;
                    }
                    this.rewind(e1);
                }
                return !1;
            }
            eatRegExpUnicodeCodePointEscape() {
                const e1 = this.index;
                return !!(this.eat(_) && this.eatHexDigits() && this.eat(B) && function(e1) {
                    return e1 >= 0 && e1 <= 1114111;
                }(this._lastIntValue)) || (this.rewind(e1), !1);
            }
            eatIdentityEscape() {
                const e1 = this.currentCodePoint;
                return !!this.isValidIdentityEscape(e1) && (this._lastIntValue = e1, this.advance(), !0);
            }
            isValidIdentityEscape(e1) {
                return -1 !== e1 && (this._unicodeMode ? Z(e1) || 47 === e1 : this.strict ? !n(e1) : this._nFlag ? !(e1 === b || 107 === e1) : e1 !== b);
            }
            eatDecimalEscape() {
                this._lastIntValue = 0;
                let e1 = this.currentCodePoint;
                if (e1 >= 49 && e1 <= 57) {
                    do this._lastIntValue = 10 * this._lastIntValue + (e1 - C), this.advance();
                    while ((e1 = this.currentCodePoint) >= C && e1 <= 57);
                    return !0;
                }
                return !1;
            }
            eatUnicodePropertyValueExpression() {
                const e1 = this.index;
                if (this.eatUnicodePropertyName() && this.eat(61)) {
                    const e1 = this._lastStrValue;
                    if (this.eatUnicodePropertyValue()) {
                        const t = this._lastStrValue;
                        if (h(this.ecmaVersion, e1, t)) return {
                            key: e1,
                            value: t || null
                        };
                        this.raise("Invalid property name");
                    }
                }
                if (this.rewind(e1), this.eatLoneUnicodePropertyNameOrValue()) {
                    const e1 = this._lastStrValue;
                    if (h(this.ecmaVersion, "General_Category", e1)) return {
                        key: "General_Category",
                        value: e1 || null
                    };
                    if (function(e1, t) {
                        return e1 >= 2018 && f.es2018.has(t) || e1 >= 2019 && f.es2019.has(t) || e1 >= 2021 && f.es2021.has(t);
                    }(this.ecmaVersion, e1)) return {
                        key: e1,
                        value: null
                    };
                    if (this._unicodeSetsMode && function(e1, t) {
                        return e1 >= 2024 && d.es2024.has(t);
                    }(this.ecmaVersion, e1)) return {
                        key: e1,
                        value: null,
                        strings: !0
                    };
                    this.raise("Invalid property name");
                }
                return null;
            }
            eatUnicodePropertyName() {
                for(this._lastStrValue = ""; re(this.currentCodePoint);)this._lastStrValue += String.fromCodePoint(this.currentCodePoint), this.advance();
                return "" !== this._lastStrValue;
            }
            eatUnicodePropertyValue() {
                for(this._lastStrValue = ""; re(e1 = this.currentCodePoint) || P(e1);)this._lastStrValue += String.fromCodePoint(this.currentCodePoint), this.advance();
                var e1;
                return "" !== this._lastStrValue;
            }
            eatLoneUnicodePropertyNameOrValue() {
                return this.eatUnicodePropertyValue();
            }
            eatHexEscapeSequence() {
                const e1 = this.index;
                if (this.eat(120)) {
                    if (this.eatFixedHexDigits(2)) return !0;
                    (this._unicodeMode || this.strict) && this.raise("Invalid escape"), this.rewind(e1);
                }
                return !1;
            }
            eatDecimalDigits() {
                const e1 = this.index;
                for(this._lastIntValue = 0; P(this.currentCodePoint);)this._lastIntValue = 10 * this._lastIntValue + N(this.currentCodePoint), this.advance();
                return this.index !== e1;
            }
            eatHexDigits() {
                const e1 = this.index;
                for(this._lastIntValue = 0; I(this.currentCodePoint);)this._lastIntValue = 16 * this._lastIntValue + N(this.currentCodePoint), this.advance();
                return this.index !== e1;
            }
            eatLegacyOctalEscapeSequence() {
                if (this.eatOctalDigit()) {
                    const e1 = this._lastIntValue;
                    if (this.eatOctalDigit()) {
                        const t = this._lastIntValue;
                        e1 <= 3 && this.eatOctalDigit() ? this._lastIntValue = 64 * e1 + 8 * t + this._lastIntValue : this._lastIntValue = 8 * e1 + t;
                    } else this._lastIntValue = e1;
                    return !0;
                }
                return !1;
            }
            eatOctalDigit() {
                const e1 = this.currentCodePoint;
                return function(e1) {
                    return e1 >= C && e1 <= 55;
                }(e1) ? (this.advance(), this._lastIntValue = e1 - C, !0) : (this._lastIntValue = 0, !1);
            }
            eatFixedHexDigits(e1) {
                const t = this.index;
                this._lastIntValue = 0;
                for(let r = 0; r < e1; ++r){
                    const e1 = this.currentCodePoint;
                    if (!I(e1)) return this.rewind(t), !1;
                    this._lastIntValue = 16 * this._lastIntValue + N(e1), this.advance();
                }
                return !0;
            }
            eatModifiers() {
                let e1 = !1;
                for(; 105 === (t = this.currentCodePoint) || 109 === t || t === v;)this.advance(), e1 = !0;
                var t;
                return e1;
            }
            parseModifiers(e1, t) {
                const { ignoreCase: r, multiline: n, dotAll: s } = this.parseFlags(this._reader.source, e1, t);
                return {
                    ignoreCase: r,
                    multiline: n,
                    dotAll: s
                };
            }
            parseFlags(e1, t, r) {
                const n = {
                    global: !1,
                    ignoreCase: !1,
                    multiline: !1,
                    unicode: !1,
                    sticky: !1,
                    dotAll: !1,
                    hasIndices: !1,
                    unicodeSets: !1
                }, s = new Set;
                s.add(103), s.add(105), s.add(109), this.ecmaVersion >= 2015 && (s.add(A), s.add(121), this.ecmaVersion >= 2018 && (s.add(v), this.ecmaVersion >= 2022 && (s.add(100), this.ecmaVersion >= 2024 && s.add(118))));
                for(let i = t; i < r; ++i){
                    const r = e1.charCodeAt(i);
                    if (s.has(r)) {
                        const s = Y[r];
                        n[s] && this.raise(`Duplicated flag '${e1[i]}'`, {
                            index: t
                        }), n[s] = !0;
                    } else this.raise(`Invalid flag '${e1[i]}'`, {
                        index: t
                    });
                }
                return n;
            }
        }
        const se = {}, ie = {}, oe = {};
        function ae(e1) {
            return "Character" === e1.type || "CharacterSet" === e1.type || "CharacterClass" === e1.type || "ExpressionCharacterClass" === e1.type || "ClassStringDisjunction" === e1.type;
        }
        class ue {
            constructor(e1){
                var t;
                this._node = se, this._expressionBufferMap = new Map, this._flags = ie, this._backreferences = [], this._capturingGroups = [], this.source = "", this.strict = Boolean(null == e1 ? void 0 : e1.strict), this.ecmaVersion = null !== (t = null == e1 ? void 0 : e1.ecmaVersion) && void 0 !== t ? t : 2025;
            }
            get pattern() {
                if ("Pattern" !== this._node.type) throw new Error("UnknownError");
                return this._node;
            }
            get flags() {
                if ("Flags" !== this._flags.type) throw new Error("UnknownError");
                return this._flags;
            }
            onRegExpFlags(e1, t, { global: r, ignoreCase: n, multiline: s, unicode: i, sticky: o, dotAll: a, hasIndices: u, unicodeSets: l }) {
                this._flags = {
                    type: "Flags",
                    parent: null,
                    start: e1,
                    end: t,
                    raw: this.source.slice(e1, t),
                    global: r,
                    ignoreCase: n,
                    multiline: s,
                    unicode: i,
                    sticky: o,
                    dotAll: a,
                    hasIndices: u,
                    unicodeSets: l
                };
            }
            onPatternEnter(e1) {
                this._node = {
                    type: "Pattern",
                    parent: null,
                    start: e1,
                    end: e1,
                    raw: "",
                    alternatives: []
                }, this._backreferences.length = 0, this._capturingGroups.length = 0;
            }
            onPatternLeave(e1, t) {
                this._node.end = t, this._node.raw = this.source.slice(e1, t);
                for (const e1 of this._backreferences){
                    const t = e1.ref, r = "number" == typeof t ? [
                        this._capturingGroups[t - 1]
                    ] : this._capturingGroups.filter((e1)=>e1.name === t);
                    if (1 === r.length) {
                        const t = r[0];
                        e1.ambiguous = !1, e1.resolved = t;
                    } else e1.ambiguous = !0, e1.resolved = r;
                    for (const t of r)t.references.push(e1);
                }
            }
            onAlternativeEnter(e1) {
                const t = this._node;
                if ("Assertion" !== t.type && "CapturingGroup" !== t.type && "Group" !== t.type && "Pattern" !== t.type) throw new Error("UnknownError");
                this._node = {
                    type: "Alternative",
                    parent: t,
                    start: e1,
                    end: e1,
                    raw: "",
                    elements: []
                }, t.alternatives.push(this._node);
            }
            onAlternativeLeave(e1, t) {
                const r = this._node;
                if ("Alternative" !== r.type) throw new Error("UnknownError");
                r.end = t, r.raw = this.source.slice(e1, t), this._node = r.parent;
            }
            onGroupEnter(e1) {
                const t = this._node;
                if ("Alternative" !== t.type) throw new Error("UnknownError");
                const r = {
                    type: "Group",
                    parent: t,
                    start: e1,
                    end: e1,
                    raw: "",
                    modifiers: null,
                    alternatives: []
                };
                this._node = r, t.elements.push(this._node);
            }
            onGroupLeave(e1, t) {
                const r = this._node;
                if ("Group" !== r.type || "Alternative" !== r.parent.type) throw new Error("UnknownError");
                r.end = t, r.raw = this.source.slice(e1, t), this._node = r.parent;
            }
            onModifiersEnter(e1) {
                const t = this._node;
                if ("Group" !== t.type) throw new Error("UnknownError");
                this._node = {
                    type: "Modifiers",
                    parent: t,
                    start: e1,
                    end: e1,
                    raw: "",
                    add: null,
                    remove: null
                }, t.modifiers = this._node;
            }
            onModifiersLeave(e1, t) {
                const r = this._node;
                if ("Modifiers" !== r.type || "Group" !== r.parent.type) throw new Error("UnknownError");
                r.end = t, r.raw = this.source.slice(e1, t), this._node = r.parent;
            }
            onAddModifiers(e1, t, { ignoreCase: r, multiline: n, dotAll: s }) {
                const i = this._node;
                if ("Modifiers" !== i.type) throw new Error("UnknownError");
                i.add = {
                    type: "ModifierFlags",
                    parent: i,
                    start: e1,
                    end: t,
                    raw: this.source.slice(e1, t),
                    ignoreCase: r,
                    multiline: n,
                    dotAll: s
                };
            }
            onRemoveModifiers(e1, t, { ignoreCase: r, multiline: n, dotAll: s }) {
                const i = this._node;
                if ("Modifiers" !== i.type) throw new Error("UnknownError");
                i.remove = {
                    type: "ModifierFlags",
                    parent: i,
                    start: e1,
                    end: t,
                    raw: this.source.slice(e1, t),
                    ignoreCase: r,
                    multiline: n,
                    dotAll: s
                };
            }
            onCapturingGroupEnter(e1, t) {
                const r = this._node;
                if ("Alternative" !== r.type) throw new Error("UnknownError");
                this._node = {
                    type: "CapturingGroup",
                    parent: r,
                    start: e1,
                    end: e1,
                    raw: "",
                    name: t,
                    alternatives: [],
                    references: []
                }, r.elements.push(this._node), this._capturingGroups.push(this._node);
            }
            onCapturingGroupLeave(e1, t) {
                const r = this._node;
                if ("CapturingGroup" !== r.type || "Alternative" !== r.parent.type) throw new Error("UnknownError");
                r.end = t, r.raw = this.source.slice(e1, t), this._node = r.parent;
            }
            onQuantifier(e1, t, r, n, s) {
                const i = this._node;
                if ("Alternative" !== i.type) throw new Error("UnknownError");
                const o = i.elements.pop();
                if (null == o || "Quantifier" === o.type || "Assertion" === o.type && "lookahead" !== o.kind) throw new Error("UnknownError");
                const a = {
                    type: "Quantifier",
                    parent: i,
                    start: o.start,
                    end: t,
                    raw: this.source.slice(o.start, t),
                    min: r,
                    max: n,
                    greedy: s,
                    element: o
                };
                i.elements.push(a), o.parent = a;
            }
            onLookaroundAssertionEnter(e1, t, r) {
                const n = this._node;
                if ("Alternative" !== n.type) throw new Error("UnknownError");
                const s = this._node = {
                    type: "Assertion",
                    parent: n,
                    start: e1,
                    end: e1,
                    raw: "",
                    kind: t,
                    negate: r,
                    alternatives: []
                };
                n.elements.push(s);
            }
            onLookaroundAssertionLeave(e1, t) {
                const r = this._node;
                if ("Assertion" !== r.type || "Alternative" !== r.parent.type) throw new Error("UnknownError");
                r.end = t, r.raw = this.source.slice(e1, t), this._node = r.parent;
            }
            onEdgeAssertion(e1, t, r) {
                const n = this._node;
                if ("Alternative" !== n.type) throw new Error("UnknownError");
                n.elements.push({
                    type: "Assertion",
                    parent: n,
                    start: e1,
                    end: t,
                    raw: this.source.slice(e1, t),
                    kind: r
                });
            }
            onWordBoundaryAssertion(e1, t, r, n) {
                const s = this._node;
                if ("Alternative" !== s.type) throw new Error("UnknownError");
                s.elements.push({
                    type: "Assertion",
                    parent: s,
                    start: e1,
                    end: t,
                    raw: this.source.slice(e1, t),
                    kind: r,
                    negate: n
                });
            }
            onAnyCharacterSet(e1, t, r) {
                const n = this._node;
                if ("Alternative" !== n.type) throw new Error("UnknownError");
                n.elements.push({
                    type: "CharacterSet",
                    parent: n,
                    start: e1,
                    end: t,
                    raw: this.source.slice(e1, t),
                    kind: r
                });
            }
            onEscapeCharacterSet(e1, t, r, n) {
                const s = this._node;
                if ("Alternative" !== s.type && "CharacterClass" !== s.type) throw new Error("UnknownError");
                s.elements.push({
                    type: "CharacterSet",
                    parent: s,
                    start: e1,
                    end: t,
                    raw: this.source.slice(e1, t),
                    kind: r,
                    negate: n
                });
            }
            onUnicodePropertyCharacterSet(e1, t, r, n, s, i, o) {
                const a = this._node;
                if ("Alternative" !== a.type && "CharacterClass" !== a.type) throw new Error("UnknownError");
                const u = {
                    type: "CharacterSet",
                    parent: null,
                    start: e1,
                    end: t,
                    raw: this.source.slice(e1, t),
                    kind: r,
                    strings: null,
                    key: n
                };
                if (o) {
                    if ("CharacterClass" === a.type && !a.unicodeSets || i || null !== s) throw new Error("UnknownError");
                    a.elements.push(Object.assign(Object.assign({}, u), {
                        parent: a,
                        strings: o,
                        value: s,
                        negate: i
                    }));
                } else a.elements.push(Object.assign(Object.assign({}, u), {
                    parent: a,
                    strings: o,
                    value: s,
                    negate: i
                }));
            }
            onCharacter(e1, t, r) {
                const n = this._node;
                if ("Alternative" !== n.type && "CharacterClass" !== n.type && "StringAlternative" !== n.type) throw new Error("UnknownError");
                n.elements.push({
                    type: "Character",
                    parent: n,
                    start: e1,
                    end: t,
                    raw: this.source.slice(e1, t),
                    value: r
                });
            }
            onBackreference(e1, t, r) {
                const n = this._node;
                if ("Alternative" !== n.type) throw new Error("UnknownError");
                const s = {
                    type: "Backreference",
                    parent: n,
                    start: e1,
                    end: t,
                    raw: this.source.slice(e1, t),
                    ref: r,
                    ambiguous: !1,
                    resolved: oe
                };
                n.elements.push(s), this._backreferences.push(s);
            }
            onCharacterClassEnter(e1, t, r) {
                const n = this._node, s = {
                    type: "CharacterClass",
                    parent: n,
                    start: e1,
                    end: e1,
                    raw: "",
                    unicodeSets: r,
                    negate: t,
                    elements: []
                };
                if ("Alternative" === n.type) {
                    const e1 = Object.assign(Object.assign({}, s), {
                        parent: n
                    });
                    this._node = e1, n.elements.push(e1);
                } else {
                    if ("CharacterClass" !== n.type || !n.unicodeSets || !r) throw new Error("UnknownError");
                    {
                        const e1 = Object.assign(Object.assign({}, s), {
                            parent: n,
                            unicodeSets: r
                        });
                        this._node = e1, n.elements.push(e1);
                    }
                }
            }
            onCharacterClassLeave(e1, t) {
                const r = this._node;
                if ("CharacterClass" !== r.type || "Alternative" !== r.parent.type && "CharacterClass" !== r.parent.type) throw new Error("UnknownError");
                const n = r.parent;
                r.end = t, r.raw = this.source.slice(e1, t), this._node = n;
                const s = this._expressionBufferMap.get(r);
                if (!s) return;
                if (r.elements.length > 0) throw new Error("UnknownError");
                this._expressionBufferMap.delete(r);
                const i = {
                    type: "ExpressionCharacterClass",
                    parent: n,
                    start: r.start,
                    end: r.end,
                    raw: r.raw,
                    negate: r.negate,
                    expression: s
                };
                if (s.parent = i, r !== n.elements.pop()) throw new Error("UnknownError");
                n.elements.push(i);
            }
            onCharacterClassRange(e1, t) {
                const r = this._node;
                if ("CharacterClass" !== r.type) throw new Error("UnknownError");
                const n = r.elements, s = n.pop();
                if (!s || "Character" !== s.type) throw new Error("UnknownError");
                if (!r.unicodeSets) {
                    const e1 = n.pop();
                    if (!e1 || "Character" !== e1.type || e1.value !== x) throw new Error("UnknownError");
                }
                const i = n.pop();
                if (!i || "Character" !== i.type) throw new Error("UnknownError");
                const o = {
                    type: "CharacterClassRange",
                    parent: r,
                    start: e1,
                    end: t,
                    raw: this.source.slice(e1, t),
                    min: i,
                    max: s
                };
                i.parent = o, s.parent = o, n.push(o);
            }
            onClassIntersection(e1, t) {
                var r;
                const n = this._node;
                if ("CharacterClass" !== n.type || !n.unicodeSets) throw new Error("UnknownError");
                const s = n.elements.pop(), i = null !== (r = this._expressionBufferMap.get(n)) && void 0 !== r ? r : n.elements.pop();
                if (!i || !s || "ClassSubtraction" === i.type || "ClassIntersection" !== i.type && !ae(i) || !ae(s)) throw new Error("UnknownError");
                const o = {
                    type: "ClassIntersection",
                    parent: n,
                    start: e1,
                    end: t,
                    raw: this.source.slice(e1, t),
                    left: i,
                    right: s
                };
                i.parent = o, s.parent = o, this._expressionBufferMap.set(n, o);
            }
            onClassSubtraction(e1, t) {
                var r;
                const n = this._node;
                if ("CharacterClass" !== n.type || !n.unicodeSets) throw new Error("UnknownError");
                const s = n.elements.pop(), i = null !== (r = this._expressionBufferMap.get(n)) && void 0 !== r ? r : n.elements.pop();
                if (!i || !s || "ClassIntersection" === i.type || "ClassSubtraction" !== i.type && !ae(i) || !ae(s)) throw new Error("UnknownError");
                const o = {
                    type: "ClassSubtraction",
                    parent: n,
                    start: e1,
                    end: t,
                    raw: this.source.slice(e1, t),
                    left: i,
                    right: s
                };
                i.parent = o, s.parent = o, this._expressionBufferMap.set(n, o);
            }
            onClassStringDisjunctionEnter(e1) {
                const t = this._node;
                if ("CharacterClass" !== t.type || !t.unicodeSets) throw new Error("UnknownError");
                this._node = {
                    type: "ClassStringDisjunction",
                    parent: t,
                    start: e1,
                    end: e1,
                    raw: "",
                    alternatives: []
                }, t.elements.push(this._node);
            }
            onClassStringDisjunctionLeave(e1, t) {
                const r = this._node;
                if ("ClassStringDisjunction" !== r.type || "CharacterClass" !== r.parent.type) throw new Error("UnknownError");
                r.end = t, r.raw = this.source.slice(e1, t), this._node = r.parent;
            }
            onStringAlternativeEnter(e1) {
                const t = this._node;
                if ("ClassStringDisjunction" !== t.type) throw new Error("UnknownError");
                this._node = {
                    type: "StringAlternative",
                    parent: t,
                    start: e1,
                    end: e1,
                    raw: "",
                    elements: []
                }, t.alternatives.push(this._node);
            }
            onStringAlternativeLeave(e1, t) {
                const r = this._node;
                if ("StringAlternative" !== r.type) throw new Error("UnknownError");
                r.end = t, r.raw = this.source.slice(e1, t), this._node = r.parent;
            }
        }
        class le {
            constructor(e1){
                this._state = new ue(e1), this._validator = new ne(this._state);
            }
            parseLiteral(e1, t = 0, r = e1.length) {
                this._state.source = e1, this._validator.validateLiteral(e1, t, r);
                const n = this._state.pattern, s = this._state.flags, i = {
                    type: "RegExpLiteral",
                    parent: null,
                    start: t,
                    end: r,
                    raw: e1,
                    pattern: n,
                    flags: s
                };
                return n.parent = i, s.parent = i, i;
            }
            parseFlags(e1, t = 0, r = e1.length) {
                return this._state.source = e1, this._validator.validateFlags(e1, t, r), this._state.flags;
            }
            parsePattern(e1, t = 0, r = e1.length, n) {
                return this._state.source = e1, this._validator.validatePattern(e1, t, r, n), this._state.pattern;
            }
        }
        class ce {
            constructor(e1){
                this._handlers = e1;
            }
            visit(e1) {
                switch(e1.type){
                    case "Alternative":
                        this.visitAlternative(e1);
                        break;
                    case "Assertion":
                        this.visitAssertion(e1);
                        break;
                    case "Backreference":
                        this.visitBackreference(e1);
                        break;
                    case "CapturingGroup":
                        this.visitCapturingGroup(e1);
                        break;
                    case "Character":
                        this.visitCharacter(e1);
                        break;
                    case "CharacterClass":
                        this.visitCharacterClass(e1);
                        break;
                    case "CharacterClassRange":
                        this.visitCharacterClassRange(e1);
                        break;
                    case "CharacterSet":
                        this.visitCharacterSet(e1);
                        break;
                    case "ClassIntersection":
                        this.visitClassIntersection(e1);
                        break;
                    case "ClassStringDisjunction":
                        this.visitClassStringDisjunction(e1);
                        break;
                    case "ClassSubtraction":
                        this.visitClassSubtraction(e1);
                        break;
                    case "ExpressionCharacterClass":
                        this.visitExpressionCharacterClass(e1);
                        break;
                    case "Flags":
                        this.visitFlags(e1);
                        break;
                    case "Group":
                        this.visitGroup(e1);
                        break;
                    case "Modifiers":
                        this.visitModifiers(e1);
                        break;
                    case "ModifierFlags":
                        this.visitModifierFlags(e1);
                        break;
                    case "Pattern":
                        this.visitPattern(e1);
                        break;
                    case "Quantifier":
                        this.visitQuantifier(e1);
                        break;
                    case "RegExpLiteral":
                        this.visitRegExpLiteral(e1);
                        break;
                    case "StringAlternative":
                        this.visitStringAlternative(e1);
                        break;
                    default:
                        throw new Error(`Unknown type: ${e1.type}`);
                }
            }
            visitAlternative(e1) {
                this._handlers.onAlternativeEnter && this._handlers.onAlternativeEnter(e1), e1.elements.forEach(this.visit, this), this._handlers.onAlternativeLeave && this._handlers.onAlternativeLeave(e1);
            }
            visitAssertion(e1) {
                this._handlers.onAssertionEnter && this._handlers.onAssertionEnter(e1), "lookahead" !== e1.kind && "lookbehind" !== e1.kind || e1.alternatives.forEach(this.visit, this), this._handlers.onAssertionLeave && this._handlers.onAssertionLeave(e1);
            }
            visitBackreference(e1) {
                this._handlers.onBackreferenceEnter && this._handlers.onBackreferenceEnter(e1), this._handlers.onBackreferenceLeave && this._handlers.onBackreferenceLeave(e1);
            }
            visitCapturingGroup(e1) {
                this._handlers.onCapturingGroupEnter && this._handlers.onCapturingGroupEnter(e1), e1.alternatives.forEach(this.visit, this), this._handlers.onCapturingGroupLeave && this._handlers.onCapturingGroupLeave(e1);
            }
            visitCharacter(e1) {
                this._handlers.onCharacterEnter && this._handlers.onCharacterEnter(e1), this._handlers.onCharacterLeave && this._handlers.onCharacterLeave(e1);
            }
            visitCharacterClass(e1) {
                this._handlers.onCharacterClassEnter && this._handlers.onCharacterClassEnter(e1), e1.elements.forEach(this.visit, this), this._handlers.onCharacterClassLeave && this._handlers.onCharacterClassLeave(e1);
            }
            visitCharacterClassRange(e1) {
                this._handlers.onCharacterClassRangeEnter && this._handlers.onCharacterClassRangeEnter(e1), this.visitCharacter(e1.min), this.visitCharacter(e1.max), this._handlers.onCharacterClassRangeLeave && this._handlers.onCharacterClassRangeLeave(e1);
            }
            visitCharacterSet(e1) {
                this._handlers.onCharacterSetEnter && this._handlers.onCharacterSetEnter(e1), this._handlers.onCharacterSetLeave && this._handlers.onCharacterSetLeave(e1);
            }
            visitClassIntersection(e1) {
                this._handlers.onClassIntersectionEnter && this._handlers.onClassIntersectionEnter(e1), this.visit(e1.left), this.visit(e1.right), this._handlers.onClassIntersectionLeave && this._handlers.onClassIntersectionLeave(e1);
            }
            visitClassStringDisjunction(e1) {
                this._handlers.onClassStringDisjunctionEnter && this._handlers.onClassStringDisjunctionEnter(e1), e1.alternatives.forEach(this.visit, this), this._handlers.onClassStringDisjunctionLeave && this._handlers.onClassStringDisjunctionLeave(e1);
            }
            visitClassSubtraction(e1) {
                this._handlers.onClassSubtractionEnter && this._handlers.onClassSubtractionEnter(e1), this.visit(e1.left), this.visit(e1.right), this._handlers.onClassSubtractionLeave && this._handlers.onClassSubtractionLeave(e1);
            }
            visitExpressionCharacterClass(e1) {
                this._handlers.onExpressionCharacterClassEnter && this._handlers.onExpressionCharacterClassEnter(e1), this.visit(e1.expression), this._handlers.onExpressionCharacterClassLeave && this._handlers.onExpressionCharacterClassLeave(e1);
            }
            visitFlags(e1) {
                this._handlers.onFlagsEnter && this._handlers.onFlagsEnter(e1), this._handlers.onFlagsLeave && this._handlers.onFlagsLeave(e1);
            }
            visitGroup(e1) {
                this._handlers.onGroupEnter && this._handlers.onGroupEnter(e1), e1.modifiers && this.visit(e1.modifiers), e1.alternatives.forEach(this.visit, this), this._handlers.onGroupLeave && this._handlers.onGroupLeave(e1);
            }
            visitModifiers(e1) {
                this._handlers.onModifiersEnter && this._handlers.onModifiersEnter(e1), e1.add && this.visit(e1.add), e1.remove && this.visit(e1.remove), this._handlers.onModifiersLeave && this._handlers.onModifiersLeave(e1);
            }
            visitModifierFlags(e1) {
                this._handlers.onModifierFlagsEnter && this._handlers.onModifierFlagsEnter(e1), this._handlers.onModifierFlagsLeave && this._handlers.onModifierFlagsLeave(e1);
            }
            visitPattern(e1) {
                this._handlers.onPatternEnter && this._handlers.onPatternEnter(e1), e1.alternatives.forEach(this.visit, this), this._handlers.onPatternLeave && this._handlers.onPatternLeave(e1);
            }
            visitQuantifier(e1) {
                this._handlers.onQuantifierEnter && this._handlers.onQuantifierEnter(e1), this.visit(e1.element), this._handlers.onQuantifierLeave && this._handlers.onQuantifierLeave(e1);
            }
            visitRegExpLiteral(e1) {
                this._handlers.onRegExpLiteralEnter && this._handlers.onRegExpLiteralEnter(e1), this.visitPattern(e1.pattern), this.visitFlags(e1.flags), this._handlers.onRegExpLiteralLeave && this._handlers.onRegExpLiteralLeave(e1);
            }
            visitStringAlternative(e1) {
                this._handlers.onStringAlternativeEnter && this._handlers.onStringAlternativeEnter(e1), e1.elements.forEach(this.visit, this), this._handlers.onStringAlternativeLeave && this._handlers.onStringAlternativeLeave(e1);
            }
        }
        return wC.AST = e1, wC.RegExpParser = le, wC.RegExpSyntaxError = W, wC.RegExpValidator = ne, wC.parseRegExpLiteral = function(e1, t) {
            return new le(t).parseLiteral(String(e1));
        }, wC.validateRegExpLiteral = function(e1, t) {
            new ne(t).validateLiteral(e1);
        }, wC.visitRegExpAST = function(e1, t) {
            new ce(t).visit(e1);
        }, wC;
    }
    function kC() {
        if (th) return eh;
        th = 1;
        const e1 = Ll();
        return eh = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow duplicate class members",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-dupe-class-members"
                },
                schema: [],
                messages: {
                    unexpected: "Duplicate name '{{name}}'."
                }
            },
            create (t) {
                let r = [];
                return {
                    Program () {
                        r = [];
                    },
                    ClassBody () {
                        r.push(Object.create(null));
                    },
                    "ClassBody:exit" () {
                        r.pop();
                    },
                    "MethodDefinition, PropertyDefinition" (n) {
                        const s = e1.getStaticPropertyName(n), i = "MethodDefinition" === n.type ? n.kind : "field";
                        if (null === s || "constructor" === i) return;
                        const o = function(e1, t) {
                            const n = r[r.length - 1], s = `$${e1}`;
                            return n[s] || (n[s] = {
                                nonStatic: {
                                    init: !1,
                                    get: !1,
                                    set: !1
                                },
                                static: {
                                    init: !1,
                                    get: !1,
                                    set: !1
                                }
                            }), n[s][t ? "static" : "nonStatic"];
                        }(s, n.static);
                        let a = !1;
                        "get" === i ? (a = o.init || o.get, o.get = !0) : "set" === i ? (a = o.init || o.set, o.set = !0) : (a = o.init || o.get || o.set, o.init = !0), a && t.report({
                            node: n,
                            messageId: "unexpected",
                            data: {
                                name: s
                            }
                        });
                    }
                };
            }
        }, eh;
    }
    function BC() {
        if (lh) return uh;
        lh = 1;
        const e1 = [
            "ImportSpecifier",
            "ExportSpecifier"
        ], t = [
            "ImportNamespaceSpecifier",
            "ExportNamespaceSpecifier"
        ];
        function r(r, n) {
            return ("named" === n ? e1 : t).includes(r);
        }
        function n(e1) {
            if (e1.specifiers && e1.specifiers.length > 0) {
                const t = e1.specifiers, n = t.findIndex(({ type: e1 })=>r(e1, "named") || r(e1, "namespace"));
                return t[n > -1 ? n : 0].type;
            }
            return "ExportAllDeclaration" === e1.type ? e1.exported ? "ExportNamespaceSpecifier" : "ExportAll" : "SideEffectImport";
        }
        function s(e1, t) {
            const s = n(e1), i = n(t);
            return !("ExportAll" === s && "ExportAll" !== i && "SideEffectImport" !== i || "ExportAll" !== s && "SideEffectImport" !== s && "ExportAll" === i) && !(r(s, "namespace") && r(i, "named") || r(i, "namespace") && r(s, "named"));
        }
        function i(e1, t) {
            let r = 0;
            for(; r < t.length;){
                if (s(e1, t[r])) return !0;
                r++;
            }
            return !1;
        }
        function o(e1, t) {
            return e1.filter(({ declarationType: e1 })=>e1 === t).map(({ node: e1 })=>e1);
        }
        function a(e1) {
            return e1 && e1.source && e1.source.value ? e1.source.value.trim() : "";
        }
        function u(e1, t, r, n) {
            return function(s) {
                const u = a(s);
                if (u) {
                    !function(e1, t, r, n, s) {
                        const u = a(t);
                        if (r.has(u)) {
                            const a = r.get(u), l = [], c = o(a, "import");
                            let p;
                            s && (p = o(a, "export")), "import" === n ? (i(t, c) && l.push("import"), s && i(t, p) && l.push("importAs")) : "export" === n && (i(t, p) && l.push("export"), i(t, c) && l.push("exportAs")), l.forEach((r)=>e1.report({
                                    node: t,
                                    messageId: r,
                                    data: {
                                        module: u
                                    }
                                }));
                        }
                    }(e1, s, t, r, n);
                    const l = {
                        node: s,
                        declarationType: r
                    };
                    let c = [
                        l
                    ];
                    if (t.has(u)) c = [
                        ...t.get(u),
                        l
                    ];
                    t.set(u, c);
                }
            };
        }
        return uh = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow duplicate module imports",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-duplicate-imports"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            includeExports: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    import: "'{{module}}' import is duplicated.",
                    importAs: "'{{module}}' import is duplicated as export.",
                    export: "'{{module}}' export is duplicated.",
                    exportAs: "'{{module}}' export is duplicated as import."
                }
            },
            create (e1) {
                const t = (e1.options[0] || {}).includeExports, r = new Map, n = {
                    ImportDeclaration: u(e1, r, "import", t)
                };
                return t && (n.ExportNamedDeclaration = u(e1, r, "export", t), n.ExportAllDeclaration = u(e1, r, "export", t)), n;
            }
        };
    }
    function LC() {
        if (ph) return ch;
        ph = 1;
        const e1 = Ll();
        return ch = class {
            constructor(e1, t){
                this.fixer = e1, this.sourceCode = t, this.retainedRange = null;
            }
            retainRange(e1) {
                return this.retainedRange = e1, this;
            }
            retainEnclosingFunction(t) {
                const r = e1.getUpperFunction(t);
                return this.retainRange(r ? r.range : this.sourceCode.ast.range);
            }
            retainSurroundingTokens(e1) {
                const t = this.sourceCode.getTokenBefore(e1) || e1, r = this.sourceCode.getTokenAfter(e1) || e1;
                return this.retainRange([
                    t.range[0],
                    r.range[1]
                ]);
            }
            replaceTextRange(e1, t) {
                let r;
                return r = this.retainedRange ? [
                    Math.min(this.retainedRange[0], e1[0]),
                    Math.max(this.retainedRange[1], e1[1])
                ] : e1, this.fixer.replaceTextRange(r, this.sourceCode.text.slice(r[0], e1[0]) + t + this.sourceCode.text.slice(e1[1], r[1]));
            }
            remove(e1) {
                return this.replaceTextRange(e1.range, "");
            }
        }, ch;
    }
    function PC() {
        if (dh) return fh;
        dh = 1;
        const e1 = Ll(), t = LC();
        return fh = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow `else` blocks after `return` statements in `if` statements",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-else-return"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            allowElseIf: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                fixable: "code",
                messages: {
                    unexpected: "Unnecessary 'else' after 'return'."
                }
            },
            create (r) {
                const n = r.sourceCode;
                function s(e1) {
                    const s = n.getScope(e1.parent);
                    r.report({
                        node: e1,
                        messageId: "unexpected",
                        fix (r) {
                            if (!function(e1, t) {
                                if ("FunctionDeclaration" === e1.type) return !1;
                                if ("BlockStatement" !== e1.type) return !0;
                                const r = t.childScopes.find(({ block: t })=>t === e1);
                                if (!r) return !0;
                                const n = r.variables.map(({ name: e1 })=>e1);
                                return function(e1, t) {
                                    if (0 === e1.length) return !0;
                                    const r = t.variableScope;
                                    if (t.variables.filter(({ defs: e1 })=>e1.length > 0).some(({ name: t })=>e1.includes(t))) return !1;
                                    if (t !== r && "catch" === t.upper.type && t.upper.variables.some(({ name: t })=>e1.includes(t))) return !1;
                                    if (t.variables.filter(({ defs: e1, references: t })=>0 === e1.length && t.length > 0).some(({ name: t })=>e1.includes(t))) return !1;
                                    if (t.through.some((t)=>e1.includes(t.identifier.name))) return !1;
                                    if (t !== r) {
                                        const n = t.block.range, s = r.variables.filter(({ name: t })=>e1.includes(t));
                                        if (s.some((e1)=>e1.defs.some(({ node: { range: e1 } })=>n[0] <= e1[0] && e1[1] <= n[1]))) return !1;
                                    }
                                    return !0;
                                }(n, t);
                            }(e1, s)) return null;
                            const i = n.getFirstToken(e1), o = n.getTokenBefore(i), a = n.getText(e1), u = n.getTokenBefore(o);
                            let l, c;
                            c = "Punctuator" === i.type && "{" === i.value ? n.getTokenAfter(i) : i;
                            const p = "BlockStatement" !== e1.parent.consequent.type && ";" !== u.value, f = /^[([/+`-]/u.test(c.value);
                            if (p && f) return null;
                            const d = n.getLastToken(e1), h = n.getTokenBefore(d);
                            if (";" !== h.value) {
                                const e1 = n.getTokenAfter(d), t = e1 && /^[([/+`-]/u.test(e1.value), r = e1 && e1.loc.start.line === h.loc.start.line;
                                if (t || r && "}" !== e1.value) return null;
                            }
                            return l = "Punctuator" === i.type && "{" === i.value ? a.slice(1, -1) : a, new t(r, n).retainEnclosingFunction(e1).replaceTextRange([
                                o.range[0],
                                e1.range[1]
                            ], l);
                        }
                    });
                }
                function i(e1) {
                    return "ReturnStatement" === e1.type;
                }
                function o(e1) {
                    if ("BlockStatement" === e1.type) {
                        const t = e1.body, r = t[t.length - 1];
                        return r && i(r);
                    }
                    return i(e1);
                }
                function a(e1) {
                    return i(e1) || function(e1) {
                        return "IfStatement" === e1.type && function(e1) {
                            return e1.alternate && e1.consequent;
                        }(e1) && o(e1.alternate) && o(e1.consequent);
                    }(e1);
                }
                function u(e1) {
                    return "BlockStatement" === e1.type ? e1.body.some(a) : a(e1);
                }
                return {
                    "IfStatement:exit": !(r.options[0] && !1 === r.options[0].allowElseIf) ? function(t) {
                        const r = t.parent;
                        if (!e1.STATEMENT_LIST_PARENTS.has(r.type)) return;
                        const n = [];
                        let i;
                        for(let e1 = t; "IfStatement" === e1.type; e1 = e1.alternate){
                            if (!e1.alternate) return;
                            n.push(e1.consequent), i = e1.alternate;
                        }
                        n.every(u) && s(i);
                    } : function(t) {
                        const r = t.parent;
                        if (!e1.STATEMENT_LIST_PARENTS.has(r.type)) return;
                        const n = t.alternate;
                        n && u(t.consequent) && s(n);
                    }
                };
            }
        }, fh;
    }
    function IC() {
        if (Dh) return Rh;
        Dh = 1;
        const e1 = Ll(), t = Object.freeze([
            "global",
            "window",
            "globalThis"
        ]);
        function r(t, r) {
            return e1.isSpecificMemberAccess(t, null, r);
        }
        return Rh = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow the use of `eval()`",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-eval"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            allowIndirect: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unexpected: "eval can be harmful."
                }
            },
            create (n) {
                const s = Boolean(n.options[0] && n.options[0].allowIndirect), i = n.sourceCode;
                let o = null;
                function a(e1) {
                    const t = i.getScope(e1).isStrict;
                    o = {
                        upper: o,
                        node: e1,
                        strict: t,
                        isTopLevelOfScript: !1,
                        defaultThis: !1,
                        initialized: t
                    };
                }
                function u() {
                    o = o.upper;
                }
                function l(e1) {
                    const t = e1.parent, r = "MemberExpression" === e1.type ? e1.property : e1, s = "CallExpression" === t.type && t.callee === e1 ? t : e1;
                    n.report({
                        node: s,
                        loc: r.loc,
                        messageId: "unexpected"
                    });
                }
                return s ? {
                    "CallExpression:exit" (t) {
                        const r = t.callee;
                        !t.optional && e1.isSpecificId(r, "eval") && l(r);
                    }
                } : {
                    "CallExpression:exit" (t) {
                        const r = t.callee;
                        e1.isSpecificId(r, "eval") && l(r);
                    },
                    Program (e1) {
                        const t = i.getScope(e1), r = n.parserOptions.ecmaFeatures || {}, s = t.isStrict || "module" === e1.sourceType || r.globalReturn && t.childScopes[0].isStrict, a = "module" !== e1.sourceType && !r.globalReturn;
                        o = {
                            upper: null,
                            node: e1,
                            strict: s,
                            isTopLevelOfScript: a,
                            defaultThis: !0,
                            initialized: !0
                        };
                    },
                    "Program:exit" (n) {
                        const s = i.getScope(n);
                        u(), function(t) {
                            const r = e1.getVariableByName(t, "eval");
                            if (!r) return;
                            const n = r.references;
                            for(let t = 0; t < n.length; ++t){
                                const r = n[t].identifier;
                                "eval" !== r.name || e1.isCallee(r) || l(r);
                            }
                        }(s), function(n) {
                            for(let s = 0; s < t.length; ++s){
                                const i = t[s], o = e1.getVariableByName(n, i);
                                if (!o) continue;
                                const a = o.references;
                                for(let e1 = 0; e1 < a.length; ++e1){
                                    let t = a[e1].identifier.parent;
                                    for(; r(t, i);)t = t.parent;
                                    r(t, "eval") && l(t);
                                }
                            }
                        }(s);
                    },
                    FunctionDeclaration: a,
                    "FunctionDeclaration:exit": u,
                    FunctionExpression: a,
                    "FunctionExpression:exit": u,
                    "PropertyDefinition > *.value": a,
                    "PropertyDefinition > *.value:exit": u,
                    StaticBlock: a,
                    "StaticBlock:exit": u,
                    ThisExpression (t) {
                        r(t.parent, "eval") && (o.initialized || (o.initialized = !0, o.defaultThis = e1.isDefaultThisBinding(o.node, i)), (o.isTopLevelOfScript || !o.strict && o.defaultThis) && l(t.parent));
                    }
                };
            }
        }, Rh;
    }
    function FC() {
        if (Bh) return kh;
        Bh = 1;
        const e1 = Ll(), t = Js();
        return kh = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow extending native types",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-extend-native"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            exceptions: {
                                type: "array",
                                items: {
                                    type: "string"
                                },
                                uniqueItems: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unexpected: "{{builtin}} prototype is read only, properties should not be added."
                }
            },
            create (r) {
                const n = r.options[0] || {}, s = r.sourceCode, i = new Set(n.exceptions || []), o = new Set(Object.keys(t.builtin).filter((e1)=>e1[0].toUpperCase() === e1[0]).filter((e1)=>!i.has(e1)));
                function a(e1, t) {
                    r.report({
                        node: e1,
                        messageId: "unexpected",
                        data: {
                            builtin: t
                        }
                    });
                }
                function u(t) {
                    if (!function(t) {
                        return Boolean(t && t.parent && "MemberExpression" === t.parent.type && t.parent.object === t && "prototype" === e1.getStaticPropertyName(t.parent));
                    }(t)) return;
                    const r = "ChainExpression" === t.parent.parent.type ? t.parent.parent : t.parent;
                    !function(e1) {
                        return "MemberExpression" === e1.parent.type && e1.parent.object === e1 && "AssignmentExpression" === e1.parent.parent.type && e1.parent.parent.left === e1.parent;
                    }(r) ? function(t) {
                        return "CallExpression" === t.parent.type && t.parent.arguments[0] === t && e1.isSpecificMemberAccess(t.parent.callee, "Object", /^definePropert(?:y|ies)$/u);
                    }(r) && a(r.parent, t.name) : a(r.parent.parent, t.name);
                }
                return {
                    "Program:exit" (e1) {
                        const t = s.getScope(e1);
                        o.forEach((e1)=>{
                            const r = t.set.get(e1);
                            r && r.references && r.references.map((e1)=>e1.identifier).forEach(u);
                        });
                    }
                };
            }
        }, kh;
    }
    function NC() {
        if (Ph) return Lh;
        Ph = 1;
        const e1 = Ll(), t = new Set([
            "Literal",
            "Identifier",
            "ThisExpression",
            "FunctionExpression"
        ]);
        return Lh = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow unnecessary calls to `.bind()`",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-extra-bind"
                },
                schema: [],
                fixable: "code",
                messages: {
                    unexpected: "The function binding is unnecessary."
                }
            },
            create (r) {
                const n = r.sourceCode;
                let s = null;
                function i(s) {
                    const i = s.parent, o = "ChainExpression" === i.parent.type ? i.parent.parent : i.parent;
                    r.report({
                        node: o,
                        messageId: "unexpected",
                        loc: i.property.loc,
                        fix (r) {
                            if (!function(e1) {
                                return t.has(e1.type);
                            }(o.arguments[0])) return null;
                            const s = [
                                [
                                    n.getTokenAfter(i.object, e1.isNotClosingParenToken),
                                    n.getLastToken(i)
                                ],
                                [
                                    n.getTokenAfter(i, e1.isNotClosingParenToken),
                                    n.getLastToken(o)
                                ]
                            ], a = s[0][0], u = s[1][1];
                            return n.commentsExistBetween(a, u) ? null : s.map(([e1, t])=>r.removeRange([
                                    e1.range[0],
                                    t.range[1]
                                ]));
                        }
                    });
                }
                function o(t) {
                    if (!e1.isSpecificMemberAccess(t.parent, null, "bind")) return !1;
                    const r = "ChainExpression" === t.parent.parent.type ? t.parent.parent : t.parent;
                    return "CallExpression" === r.parent.type && r.parent.callee === r && 1 === r.parent.arguments.length && "SpreadElement" !== r.parent.arguments[0].type;
                }
                function a(e1) {
                    s = {
                        isBound: o(e1),
                        thisFound: !1,
                        upper: s
                    };
                }
                function u(e1) {
                    s.isBound && !s.thisFound && i(e1), s = s.upper;
                }
                return {
                    "ArrowFunctionExpression:exit": function(e1) {
                        o(e1) && i(e1);
                    },
                    FunctionDeclaration: a,
                    "FunctionDeclaration:exit": u,
                    FunctionExpression: a,
                    "FunctionExpression:exit": u,
                    ThisExpression: function() {
                        s && (s.thisFound = !0);
                    }
                };
            }
        }, Lh;
    }
    function OC() {
        if (Fh) return Ih;
        Fh = 1;
        const e1 = Ll(), t = Hi(), r = e1.getPrecedence;
        return Ih = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow unnecessary boolean casts",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-extra-boolean-cast"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            enforceForLogicalOperands: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                fixable: "code",
                messages: {
                    unexpectedCall: "Redundant Boolean call.",
                    unexpectedNegation: "Redundant double negation."
                }
            },
            create (n) {
                const s = n.sourceCode, i = new Set([
                    "IfStatement",
                    "DoWhileStatement",
                    "WhileStatement",
                    "ConditionalExpression",
                    "ForStatement"
                ]);
                function o(e1) {
                    return "ChainExpression" === e1.parent.type ? o(e1.parent) : function(e1) {
                        return function(e1) {
                            return ("CallExpression" === e1.type || "NewExpression" === e1.type) && "Identifier" === e1.callee.type && "Boolean" === e1.callee.name;
                        }(e1.parent) && e1 === e1.parent.arguments[0] || i.has(e1.parent.type) && e1 === e1.parent.test || "UnaryExpression" === e1.parent.type && "!" === e1.parent.operator;
                    }(e1) || function(e1) {
                        return "LogicalExpression" === e1.type && ("||" === e1.operator || "&&" === e1.operator) && n.options.length && !0 === n.options[0].enforceForLogicalOperands;
                    }(e1.parent) && o(e1.parent);
                }
                function a(e1) {
                    return Boolean(s.getCommentsInside(e1).length);
                }
                function u(n, i) {
                    if ("ChainExpression" === n.parent.type) return u(n.parent, i);
                    if (function(e1) {
                        return t.isParenthesized(1, e1, s);
                    }(n)) return !1;
                    const o = n.parent;
                    switch(o.type){
                        case "CallExpression":
                        case "NewExpression":
                            return "SequenceExpression" === i.type;
                        case "IfStatement":
                        case "DoWhileStatement":
                        case "WhileStatement":
                        case "ForStatement":
                            return !1;
                        case "ConditionalExpression":
                            return r(i) <= r(o);
                        case "UnaryExpression":
                            return r(i) < r(o);
                        case "LogicalExpression":
                            return !!e1.isMixedLogicalAndCoalesceExpressions(i, o) || (n === o.left ? r(i) < r(o) : r(i) <= r(o));
                        default:
                            throw new Error(`Unexpected parent type: ${o.type}`);
                    }
                }
                return {
                    UnaryExpression (t) {
                        const r = t.parent;
                        "!" === t.operator && "UnaryExpression" === r.type && "!" === r.operator && o(r) && n.report({
                            node: r,
                            messageId: "unexpectedNegation",
                            fix (n) {
                                if (a(r)) return null;
                                if (u(r, t.argument)) return n.replaceText(r, `(${s.getText(t.argument)})`);
                                let i = "";
                                const o = s.getTokenBefore(r), l = s.getFirstToken(t.argument);
                                return o && o.range[1] === r.range[0] && !e1.canTokensBeAdjacent(o, l) && (i = " "), n.replaceText(r, i + s.getText(t.argument));
                            }
                        });
                    },
                    CallExpression (t) {
                        "Identifier" === t.callee.type && "Boolean" === t.callee.name && o(t) && n.report({
                            node: t,
                            messageId: "unexpectedCall",
                            fix (r) {
                                const n = t.parent;
                                if (0 === t.arguments.length) {
                                    if ("UnaryExpression" === n.type && "!" === n.operator) {
                                        if (a(n)) return null;
                                        const t = "true";
                                        let i = "";
                                        const o = s.getTokenBefore(n);
                                        return o && o.range[1] === n.range[0] && !e1.canTokensBeAdjacent(o, t) && (i = " "), r.replaceText(n, i + t);
                                    }
                                    return a(t) ? null : r.replaceText(t, "false");
                                }
                                if (1 === t.arguments.length) {
                                    const e1 = t.arguments[0];
                                    return "SpreadElement" === e1.type || a(t) ? null : u(t, e1) ? r.replaceText(t, `(${s.getText(e1)})`) : r.replaceText(t, s.getText(e1));
                                }
                                return null;
                            }
                        });
                    }
                };
            }
        }, Ih;
    }
    function UC() {
        if (jh) return Uh;
        jh = 1;
        const { isParenthesized: e1 } = Hi(), t = Ll();
        return Uh = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Disallow unnecessary parentheses",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-extra-parens"
                },
                fixable: "code",
                schema: {
                    anyOf: [
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "functions"
                                    ]
                                }
                            ],
                            minItems: 0,
                            maxItems: 1
                        },
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "all"
                                    ]
                                },
                                {
                                    type: "object",
                                    properties: {
                                        conditionalAssign: {
                                            type: "boolean"
                                        },
                                        ternaryOperandBinaryExpressions: {
                                            type: "boolean"
                                        },
                                        nestedBinaryExpressions: {
                                            type: "boolean"
                                        },
                                        returnAssign: {
                                            type: "boolean"
                                        },
                                        ignoreJSX: {
                                            enum: [
                                                "none",
                                                "all",
                                                "single-line",
                                                "multi-line"
                                            ]
                                        },
                                        enforceForArrowConditionals: {
                                            type: "boolean"
                                        },
                                        enforceForSequenceExpressions: {
                                            type: "boolean"
                                        },
                                        enforceForNewInMemberExpressions: {
                                            type: "boolean"
                                        },
                                        enforceForFunctionPrototypeMethods: {
                                            type: "boolean"
                                        },
                                        allowParensAfterCommentPattern: {
                                            type: "string"
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            minItems: 0,
                            maxItems: 2
                        }
                    ]
                },
                messages: {
                    unexpected: "Unnecessary parentheses around expression."
                }
            },
            create (r) {
                const n = r.sourceCode, s = new WeakSet, i = t.getPrecedence, o = "functions" !== r.options[0], a = o && r.options[1] && !1 === r.options[1].conditionalAssign, u = o && r.options[1] && !1 === r.options[1].ternaryOperandBinaryExpressions, l = o && r.options[1] && !1 === r.options[1].nestedBinaryExpressions, c = o && r.options[1] && !1 === r.options[1].returnAssign, p = o && r.options[1] && r.options[1].ignoreJSX, f = o && r.options[1] && !1 === r.options[1].enforceForArrowConditionals, d = o && r.options[1] && !1 === r.options[1].enforceForSequenceExpressions, h = o && r.options[1] && !1 === r.options[1].enforceForNewInMemberExpressions, m = o && r.options[1] && !1 === r.options[1].enforceForFunctionPrototypeMethods, g = o && r.options[1] && r.options[1].allowParensAfterCommentPattern, y = i({
                    type: "AssignmentExpression"
                }), E = i({
                    type: "UpdateExpression"
                });
                let x;
                function C(e1) {
                    const r = t.skipChainExpression(e1);
                    if ("CallExpression" !== r.type) return !1;
                    const n = t.skipChainExpression(r.callee);
                    return "MemberExpression" === n.type && "FunctionExpression" === n.object.type && [
                        "call",
                        "apply"
                    ].includes(t.getStaticPropertyName(n));
                }
                function S(e1) {
                    if ("JSXElement" === e1.type || "JSXFragment" === e1.type) {
                        const t = e1.loc.start.line === e1.loc.end.line;
                        switch(p){
                            case "all":
                                return !1;
                            case "multi-line":
                                return t;
                            case "single-line":
                                return !t;
                        }
                    }
                    return ("SequenceExpression" !== e1.type || !d) && (!C(e1) || !m) && (o || "FunctionExpression" === e1.type || "ArrowFunctionExpression" === e1.type);
                }
                function b(t) {
                    return e1(1, t, n);
                }
                function v(t) {
                    return e1(2, t, n);
                }
                function A(e1) {
                    return S(e1) && b(e1);
                }
                function T(e1) {
                    return S(e1) && v(e1);
                }
                function R(e1, t) {
                    return !!(S(e1) && b(e1) && (i(e1) >= t || v(e1)));
                }
                function D(e1) {
                    return a && "AssignmentExpression" === e1.test.type;
                }
                function w(e1) {
                    const r = n.getLastToken(e1), s = n.getTokenBefore(r);
                    return e1.arguments.length > 0 || t.isOpeningParenToken(s) && t.isClosingParenToken(r) && e1.callee.range[1] < e1.range[1];
                }
                function _(e1) {
                    return "AssignmentExpression" === e1.type || "ConditionalExpression" === e1.type && ("AssignmentExpression" === e1.consequent.type || "AssignmentExpression" === e1.alternate.type) || !!(e1.left && "AssignmentExpression" === e1.left.type || e1.right && "AssignmentExpression" === e1.right.type);
                }
                function k(e1) {
                    return !(!c || !function(e1) {
                        for(let t = e1; t; t = t.parent)if ("ReturnStatement" === t.type || "ArrowFunctionExpression" === t.type && "BlockStatement" !== t.body.type) return !0;
                        return !1;
                    }(e1)) && ("ReturnStatement" === e1.type ? e1.argument && _(e1.argument) : "ArrowFunctionExpression" === e1.type && "BlockStatement" !== e1.body.type ? _(e1.body) : _(e1));
                }
                function B(e1, t) {
                    return e1.loc.end.line === t.loc.start.line ? A(t) : T(t);
                }
                function L(e1) {
                    const r = t.skipChainExpression(e1);
                    return "CallExpression" === r.type && "FunctionExpression" === r.callee.type;
                }
                function P(e1) {
                    return e1 && ("Identifier" === e1.type || "MemberExpression" === e1.type);
                }
                function I(e1) {
                    return "Literal" !== e1.type || "string" != typeof e1.value || !!v(e1) || !t.isTopLevelExpressionStatement(e1.parent);
                }
                function F(e1) {
                    const i = n.getTokenBefore(e1), o = n.getTokenAfter(e1);
                    if (!v(e1)) {
                        if (s.has(n.getFirstToken(e1))) return;
                        if (L(e1) && !b(e1.callee)) return;
                        if (g) {
                            const e1 = n.getCommentsBefore(i), t = e1.length, r = new RegExp(g, "u");
                            if (t > 0 && r.test(e1[t - 1].value)) return;
                        }
                    }
                    function a() {
                        r.report({
                            node: e1,
                            loc: i.loc,
                            messageId: "unexpected",
                            fix: I(e1) ? (r)=>{
                                const s = n.text.slice(i.range[1], o.range[0]);
                                return r.replaceTextRange([
                                    i.range[0],
                                    o.range[1]
                                ], (function(e1) {
                                    const r = n.getTokenBefore(e1), s = n.getTokenBefore(r, {
                                        includeComments: !0
                                    }), i = n.getTokenAfter(r, {
                                        includeComments: !0
                                    });
                                    return s && s.range[1] === r.range[0] && r.range[1] === i.range[0] && !t.canTokensBeAdjacent(s, i);
                                }(e1) ? " " : "") + s + (function(e1) {
                                    const r = n.getTokensAfter(e1, {
                                        count: 2
                                    }), s = r[0], i = r[1], o = n.getLastToken(e1);
                                    return s && i && !n.isSpaceBetweenTokens(s, i) && !t.canTokensBeAdjacent(o, i);
                                }(e1) ? " " : ""));
                            } : null
                        });
                    }
                    x ? x.reports.push({
                        node: e1,
                        finishReport: a
                    }) : a();
                }
                function N(e1) {
                    R(e1.argument, i(e1)) && F(e1.argument);
                }
                function O(e1) {
                    let t = e1.object, r = e1.object.type;
                    for(; "MemberExpression" === r;)t = t.object, r = t.type;
                    return "CallExpression" === r;
                }
                function U(e1) {
                    const t = e1.callee;
                    R(t, i(e1)) && (!T(t) && (L(e1) || "NewExpression" === t.type && !w(t) && ("NewExpression" !== e1.type || w(e1)) || "NewExpression" === e1.type && "MemberExpression" === t.type && O(t) || !e1.optional && "ChainExpression" === t.type) || F(e1.callee)), e1.arguments.filter((e1)=>R(e1, y)).forEach(F);
                }
                function j(e1) {
                    const r = i(e1), n = i(e1.left), s = i(e1.right), o = "**" === e1.operator, a = l && ("BinaryExpression" === e1.left.type || "LogicalExpression" === e1.left.type), u = l && ("BinaryExpression" === e1.right.type || "LogicalExpression" === e1.right.type);
                    !a && A(e1.left) && (([
                        "AwaitExpression",
                        "UnaryExpression"
                    ].includes(e1.left.type) && o || t.isMixedLogicalAndCoalesceExpressions(e1.left, e1) || !(n > r || n === r && !o)) && !v(e1.left) || F(e1.left)), !u && A(e1.right) && (!t.isMixedLogicalAndCoalesceExpressions(e1.right, e1) && (s > r || s === r && o) || v(e1.right)) && F(e1.right);
                }
                function V(e1) {
                    if (!e1.superClass) return;
                    (i(e1.superClass) > E ? A(e1.superClass) : T(e1.superClass)) && F(e1.superClass);
                }
                function K(e1) {
                    R(e1.argument, y) && F(e1.argument);
                }
                function M(e1) {
                    const r = b(e1) ? n.getTokenBefore(e1) : n.getFirstToken(e1), i = n.getTokenAfter(r, t.isNotOpeningParenToken), o = i ? n.getTokenAfter(i) : null, a = i ? n.getTokenAfter(i, t.isNotClosingParenToken) : null;
                    t.isOpeningParenToken(r) && (t.isOpeningBraceToken(i) || "Keyword" === i.type && ("function" === i.value || "class" === i.value || "let" === i.value && a && (t.isOpeningBracketToken(a) || "Identifier" === a.type)) || i && "Identifier" === i.type && "async" === i.value && o && "Keyword" === o.type && "function" === o.value) && s.add(i);
                    ("ExportDefaultDeclaration" === e1.parent.type ? R(e1, y) : A(e1)) && F(e1);
                }
                function $(e1, t) {
                    return (function(e1, t) {
                        const r = [
                            e1
                        ];
                        let n = e1;
                        for(; n !== t;){
                            if (n = n.parent, null === n) throw new Error("Nodes are not in the ancestor-descendant relationship.");
                            r.push(n);
                        }
                        return r;
                    })(t, e1).reverse();
                }
                function q(e1, t) {
                    switch(e1.type){
                        case "ArrayExpression":
                        case "ArrayPattern":
                        case "BlockStatement":
                        case "ObjectExpression":
                        case "ObjectPattern":
                        case "TemplateLiteral":
                            return !0;
                        case "ArrowFunctionExpression":
                        case "FunctionExpression":
                            return e1.params.includes(t);
                        case "CallExpression":
                        case "NewExpression":
                            return e1.arguments.includes(t);
                        case "MemberExpression":
                            return e1.computed && e1.property === t;
                        case "ConditionalExpression":
                            return e1.consequent === t;
                        default:
                            return !1;
                    }
                }
                function G(e1) {
                    return x.reports.some((t)=>t.node === e1);
                }
                function W(e1) {
                    return "MemberExpression" === e1.type && ("NewExpression" === e1.parent.type && e1.parent.callee === e1 || e1.parent.object === e1 && W(e1.parent));
                }
                return {
                    ArrayExpression (e1) {
                        e1.elements.filter((e1)=>e1 && R(e1, y)).forEach(F);
                    },
                    ArrayPattern (e1) {
                        e1.elements.filter((e1)=>P(e1) && A(e1)).forEach(F);
                    },
                    ArrowFunctionExpression (e1) {
                        if (!(k(e1) || "ConditionalExpression" === e1.body.type && f || "BlockStatement" === e1.body.type)) {
                            const r = n.getFirstToken(e1.body, t.isNotOpeningParenToken), i = n.getTokenBefore(r);
                            t.isOpeningParenToken(i) && t.isOpeningBraceToken(r) && s.add(r), R(e1.body, y) && F(e1.body);
                        }
                    },
                    AssignmentExpression (e1) {
                        P(e1.left) && A(e1.left) && (!function({ left: e1, operator: t, right: r }) {
                            if ("Identifier" === e1.type && [
                                "=",
                                "&&=",
                                "||=",
                                "??="
                            ].includes(t)) {
                                const e1 = r.type;
                                if ("ArrowFunctionExpression" === e1) return !0;
                                if (("FunctionExpression" === e1 || "ClassExpression" === e1) && !r.id) return !0;
                            }
                            return !1;
                        }(e1) || v(e1.left)) && F(e1.left), !k(e1) && R(e1.right, i(e1)) && F(e1.right);
                    },
                    BinaryExpression (e1) {
                        x && "in" === e1.operator && x.inExpressionNodes.push(e1), j(e1);
                    },
                    CallExpression: U,
                    ConditionalExpression (e1) {
                        if (k(e1)) return;
                        const t = new Set([
                            "BinaryExpression",
                            "LogicalExpression"
                        ]);
                        u && t.has(e1.test.type) || D(e1) || !R(e1.test, i({
                            type: "LogicalExpression",
                            operator: "||"
                        })) || F(e1.test), u && t.has(e1.consequent.type) || !R(e1.consequent, y) || F(e1.consequent), u && t.has(e1.alternate.type) || !R(e1.alternate, y) || F(e1.alternate);
                    },
                    DoWhileStatement (e1) {
                        A(e1.test) && !D(e1) && F(e1.test);
                    },
                    ExportDefaultDeclaration: (e1)=>M(e1.declaration),
                    ExpressionStatement: (e1)=>M(e1.expression),
                    ForInStatement (e1) {
                        if ("VariableDeclaration" !== e1.left.type) {
                            const r = n.getFirstToken(e1.left, t.isNotOpeningParenToken);
                            "let" === r.value && t.isOpeningBracketToken(n.getTokenAfter(r, t.isNotClosingParenToken)) && s.add(r);
                        }
                        A(e1.left) && F(e1.left), A(e1.right) && F(e1.right);
                    },
                    ForOfStatement (e1) {
                        if ("VariableDeclaration" !== e1.left.type) {
                            const r = n.getFirstToken(e1.left, t.isNotOpeningParenToken);
                            "let" === r.value && s.add(r);
                        }
                        A(e1.left) && F(e1.left), R(e1.right, y) && F(e1.right);
                    },
                    ForStatement (e1) {
                        if (e1.test && A(e1.test) && !D(e1) && F(e1.test), e1.update && A(e1.update) && F(e1.update), e1.init) {
                            if ("VariableDeclaration" !== e1.init.type) {
                                const r = n.getFirstToken(e1.init, t.isNotOpeningParenToken);
                                "let" === r.value && t.isOpeningBracketToken(n.getTokenAfter(r, t.isNotClosingParenToken)) && s.add(r);
                            }
                            x = {
                                upper: x,
                                inExpressionNodes: [],
                                reports: []
                            }, A(e1.init) && F(e1.init);
                        }
                    },
                    "ForStatement > *.init:exit" (e1) {
                        x.reports.length && x.inExpressionNodes.forEach((t)=>{
                            const r = $(e1, t);
                            let n;
                            for(let e1 = 0; e1 < r.length; e1++){
                                const t = r[e1];
                                if (e1 < r.length - 1) {
                                    if (q(t, r[e1 + 1])) return;
                                }
                                if (b(t)) {
                                    if (!G(t)) return;
                                    if (v(t)) return;
                                    n || (n = t);
                                }
                            }
                            !function(e1) {
                                x.reports = x.reports.filter((t)=>t.node !== e1);
                            }(n);
                        }), function() {
                            const { upper: e1, inExpressionNodes: t, reports: r } = x;
                            e1 ? (e1.inExpressionNodes.push(...t), e1.reports.push(...r)) : r.forEach(({ finishReport: e1 })=>e1()), x = e1;
                        }();
                    },
                    IfStatement (e1) {
                        A(e1.test) && !D(e1) && F(e1.test);
                    },
                    ImportExpression (e1) {
                        const { source: t } = e1;
                        "SequenceExpression" === t.type ? T(t) && F(t) : A(t) && F(t);
                    },
                    LogicalExpression: j,
                    MemberExpression (e1) {
                        const r = W(e1) && O(e1) ? T(e1.object) : A(e1.object) && !(C(e1.parent) && e1.parent.callee === e1 && m);
                        r && i(e1.object) >= i(e1) && (e1.computed || !(t.isDecimalInteger(e1.object) || "Literal" === e1.object.type && e1.object.regex)) && F(e1.object), r && "CallExpression" === e1.object.type && F(e1.object), r && !h && "NewExpression" === e1.object.type && w(e1.object) && F(e1.object), r && e1.optional && "ChainExpression" === e1.object.type && F(e1.object), e1.computed && A(e1.property) && F(e1.property);
                    },
                    "MethodDefinition[computed=true]" (e1) {
                        R(e1.key, y) && F(e1.key);
                    },
                    NewExpression: U,
                    ObjectExpression (e1) {
                        e1.properties.filter((e1)=>e1.value && R(e1.value, y)).forEach((e1)=>F(e1.value));
                    },
                    ObjectPattern (e1) {
                        e1.properties.filter((e1)=>{
                            const t = e1.value;
                            return P(t) && A(t);
                        }).forEach((e1)=>F(e1.value));
                    },
                    Property (e1) {
                        if (e1.computed) {
                            const { key: t } = e1;
                            t && R(t, y) && F(t);
                        }
                    },
                    PropertyDefinition (e1) {
                        e1.computed && R(e1.key, y) && F(e1.key), e1.value && R(e1.value, y) && F(e1.value);
                    },
                    RestElement (e1) {
                        const t = e1.argument;
                        P(t) && A(t) && F(t);
                    },
                    ReturnStatement (e1) {
                        const t = n.getFirstToken(e1);
                        k(e1) || !e1.argument || !B(t, e1.argument) || "Literal" === e1.argument.type && e1.argument.regex || F(e1.argument);
                    },
                    SequenceExpression (e1) {
                        const t = i(e1);
                        e1.expressions.filter((e1)=>R(e1, t)).forEach(F);
                    },
                    SwitchCase (e1) {
                        e1.test && A(e1.test) && F(e1.test);
                    },
                    SwitchStatement (e1) {
                        A(e1.discriminant) && F(e1.discriminant);
                    },
                    ThrowStatement (e1) {
                        B(n.getFirstToken(e1), e1.argument) && F(e1.argument);
                    },
                    UnaryExpression: N,
                    UpdateExpression (e1) {
                        if (e1.prefix) N(e1);
                        else {
                            const { argument: t } = e1, r = n.getLastToken(e1);
                            t.loc.end.line === r.loc.start.line ? N(e1) : T(t) && F(t);
                        }
                    },
                    AwaitExpression: N,
                    VariableDeclarator (e1) {
                        !e1.init || !R(e1.init, y) || "Literal" === e1.init.type && e1.init.regex || F(e1.init);
                    },
                    WhileStatement (e1) {
                        A(e1.test) && !D(e1) && F(e1.test);
                    },
                    WithStatement (e1) {
                        A(e1.object) && F(e1.object);
                    },
                    YieldExpression (e1) {
                        if (e1.argument) {
                            const t = n.getFirstToken(e1);
                            (i(e1.argument) >= i(e1) && B(t, e1.argument) || T(e1.argument)) && F(e1.argument);
                        }
                    },
                    ClassDeclaration: V,
                    ClassExpression: V,
                    SpreadElement: K,
                    SpreadProperty: K,
                    ExperimentalSpreadProperty: K,
                    TemplateLiteral (e1) {
                        e1.expressions.filter((e1)=>e1 && A(e1)).forEach(F);
                    },
                    AssignmentPattern (e1) {
                        const { left: t, right: r } = e1;
                        P(t) && A(t) && F(t), r && R(r, y) && F(r);
                    }
                };
            }
        }, Uh;
    }
    function jC() {
        if ($h) return Mh;
        $h = 1;
        const { directivesPattern: e1 } = jr(), t = /falls?\s?through/iu;
        function r(t, r) {
            return r.test(t) && !e1.test(t.trim());
        }
        return Mh = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow fallthrough of `case` statements",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-fallthrough"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            commentPattern: {
                                type: "string",
                                default: ""
                            },
                            allowEmptyCase: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    case: "Expected a 'break' statement before 'case'.",
                    default: "Expected a 'break' statement before 'default'."
                }
            },
            create (e1) {
                const n = e1.options[0] || {}, s = [];
                let i = new Set;
                const o = e1.sourceCode, a = n.allowEmptyCase || !1;
                let u = null, l = null;
                return l = n.commentPattern ? new RegExp(n.commentPattern, "u") : t, {
                    onCodePathStart () {
                        s.push(i), i = new Set;
                    },
                    onCodePathEnd () {
                        i = s.pop();
                    },
                    onUnreachableCodePathSegmentStart (e1) {
                        i.add(e1);
                    },
                    onUnreachableCodePathSegmentEnd (e1) {
                        i.delete(e1);
                    },
                    onCodePathSegmentStart (e1) {
                        i.add(e1);
                    },
                    onCodePathSegmentEnd (e1) {
                        i.delete(e1);
                    },
                    SwitchCase (t) {
                        u && !function(e1, t, n, s) {
                            const i = n.sourceCode;
                            if (1 === e1.consequent.length && "BlockStatement" === e1.consequent[0].type) {
                                const t = i.getLastToken(e1.consequent[0]), n = i.getCommentsBefore(t).pop();
                                if (n && r(n.value, s)) return !0;
                            }
                            const o = i.getCommentsBefore(t).pop();
                            return Boolean(o && r(o.value, s));
                        }(u, t, e1, l) && e1.report({
                            messageId: t.test ? "case" : "default",
                            node: t
                        }), u = null;
                    },
                    "SwitchCase:exit" (e1) {
                        const t = o.getTokenAfter(e1);
                        (function(e1) {
                            for (const t of e1)if (t.reachable) return !0;
                            return !1;
                        })(i) && (e1.consequent.length > 0 || !a && function(e1, t) {
                            return t.loc.start.line > e1.loc.end.line + 1;
                        }(e1, t)) && e1.parent.cases[e1.parent.cases.length - 1] !== e1 && (u = e1);
                    }
                };
            }
        }, Mh;
    }
    function VC() {
        if (Xh) return Wh;
        Xh = 1;
        const e1 = Ll();
        return Wh = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow reassigning `function` declarations",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-func-assign"
                },
                schema: [],
                messages: {
                    isAFunction: "'{{name}}' is a function."
                }
            },
            create (t) {
                const r = t.sourceCode;
                function n(r) {
                    var n;
                    "FunctionName" === r.defs[0].type && (n = r.references, e1.getModifyingReferences(n).forEach((e1)=>{
                        t.report({
                            node: e1.identifier,
                            messageId: "isAFunction",
                            data: {
                                name: e1.identifier.name
                            }
                        });
                    }));
                }
                function s(e1) {
                    r.getDeclaredVariables(e1).forEach(n);
                }
                return {
                    FunctionDeclaration: s,
                    FunctionExpression: s
                };
            }
        }, Wh;
    }
    function KC() {
        if (Qh) return Jh;
        Qh = 1;
        const e1 = Ll(), t = /^(?:i|lastI)ndexOf$/u;
        function r(e1) {
            return "Literal" === e1.type && "number" == typeof e1.value || "CallExpression" === e1.type && ("Number" === e1.callee.name || "parseInt" === e1.callee.name || "parseFloat" === e1.callee.name);
        }
        function n(t) {
            return e1.isStringLiteral(t) || "CallExpression" === t.type && "Identifier" === t.callee.type && "String" === t.callee.name;
        }
        function s(t) {
            return e1.isStringLiteral(t) && ("" === t.value || "TemplateLiteral" === t.type && 1 === t.quasis.length && "" === t.quasis[0].value.cooked);
        }
        function i(e1) {
            return s(e1.left) ? e1.right : e1.left;
        }
        return Jh = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow shorthand type conversions",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-implicit-coercion"
                },
                fixable: "code",
                schema: [
                    {
                        type: "object",
                        properties: {
                            boolean: {
                                type: "boolean",
                                default: !0
                            },
                            number: {
                                type: "boolean",
                                default: !0
                            },
                            string: {
                                type: "boolean",
                                default: !0
                            },
                            disallowTemplateShorthand: {
                                type: "boolean",
                                default: !1
                            },
                            allow: {
                                type: "array",
                                items: {
                                    enum: [
                                        "~",
                                        "!!",
                                        "+",
                                        "*"
                                    ]
                                },
                                uniqueItems: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    useRecommendation: "use `{{recommendation}}` instead."
                }
            },
            create (o) {
                const a = function(e1) {
                    return {
                        boolean: !("boolean" in e1) || e1.boolean,
                        number: !("number" in e1) || e1.number,
                        string: !("string" in e1) || e1.string,
                        disallowTemplateShorthand: "disallowTemplateShorthand" in e1 && e1.disallowTemplateShorthand,
                        allow: e1.allow || []
                    };
                }(o.options[0] || {}), u = o.sourceCode;
                function l(t, r, n) {
                    o.report({
                        node: t,
                        messageId: "useRecommendation",
                        data: {
                            recommendation: r
                        },
                        fix (s) {
                            if (!n) return null;
                            const i = u.getTokenBefore(t);
                            return i && i.range[1] === t.range[0] && !e1.canTokensBeAdjacent(i, r) ? s.replaceText(t, ` ${r}`) : s.replaceText(t, r);
                        }
                    });
                }
                return {
                    UnaryExpression (n) {
                        let s;
                        if (s = a.allow.includes("!!"), !s && a.boolean && function(e1) {
                            return "!" === e1.operator && "UnaryExpression" === e1.argument.type && "!" === e1.argument.operator;
                        }(n)) l(n, `Boolean(${u.getText(n.argument.argument)})`, !0);
                        if (s = a.allow.includes("~"), !s && a.boolean && function(r) {
                            if ("~" !== r.operator) return !1;
                            const n = e1.skipChainExpression(r.argument);
                            return "CallExpression" === n.type && e1.isSpecificMemberAccess(n.callee, null, t);
                        }(n)) {
                            const e1 = "ChainExpression" === n.argument.type ? ">= 0" : "!== -1";
                            l(n, `${u.getText(n.argument)} ${e1}`, !1);
                        }
                        if (s = a.allow.includes("+"), !s && a.number && "+" === n.operator && !r(n.argument)) l(n, `Number(${u.getText(n.argument)})`, !0);
                    },
                    "BinaryExpression:exit" (t) {
                        let o;
                        o = a.allow.includes("*");
                        const c = !o && a.number && function(e1) {
                            return "*" === e1.operator && ("Literal" === e1.left.type && 1 === e1.left.value || "Literal" === e1.right.type && 1 === e1.right.value);
                        }(t) && !function(t, r) {
                            return "BinaryExpression" === t.type && "*" === t.operator && "Literal" === t.right.type && 1 === t.right.value && "BinaryExpression" === t.parent.type && "/" === t.parent.operator && t.parent.left === t && !e1.isParenthesised(r, t);
                        }(t, u) && function(e1) {
                            const t = e1.left, n = e1.right;
                            return "BinaryExpression" === n.type || r(n) ? "BinaryExpression" === t.type || r(t) ? null : t : n;
                        }(t);
                        if (c) l(t, `Number(${u.getText(c)})`, !0);
                        if (o = a.allow.includes("+"), !o && a.string && function(e1) {
                            return "+" === e1.operator && (s(e1.left) && !n(e1.right) || s(e1.right) && !n(e1.left));
                        }(t)) l(t, `String(${u.getText(i(t))})`, !0);
                    },
                    AssignmentExpression (e1) {
                        if (!a.allow.includes("+") && a.string && function(e1) {
                            return "+=" === e1.operator && s(e1.right);
                        }(e1)) {
                            const t = u.getText(i(e1));
                            l(e1, `${t} = String(${t})`, !0);
                        }
                    },
                    TemplateLiteral (e1) {
                        if (!a.disallowTemplateShorthand) return;
                        if ("TaggedTemplateExpression" === e1.parent.type) return;
                        if (1 !== e1.expressions.length) return;
                        if ("" !== e1.quasis[0].value.cooked) return;
                        if ("" !== e1.quasis[1].value.cooked) return;
                        if (n(e1.expressions[0])) return;
                        l(e1, `String(${u.getText(e1.expressions[0])})`, !0);
                    }
                };
            }
        }, Jh;
    }
    function MC() {
        if (tm) return em;
        tm = 1;
        const e1 = Ll(), { getStaticValue: t } = Hi();
        return em = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow the use of `eval()`-like methods",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-implied-eval"
                },
                schema: [],
                messages: {
                    impliedEval: "Implied eval. Consider passing a function instead of a string."
                }
            },
            create (r) {
                const n = Object.freeze([
                    "global",
                    "window",
                    "globalThis"
                ]), s = /^(?:set(?:Interval|Timeout)|execScript)$/u, i = r.sourceCode;
                function o(e1) {
                    return "Literal" === e1.type && "string" == typeof e1.value || "TemplateLiteral" === e1.type || "BinaryExpression" === e1.type && "+" === e1.operator && (o(e1.left) || o(e1.right));
                }
                function a(e1) {
                    const [n] = e1.arguments;
                    if (n) {
                        const s = t(n, i.getScope(e1));
                        (s && "string" == typeof s.value || o(n)) && r.report({
                            node: e1,
                            messageId: "impliedEval"
                        });
                    }
                }
                function u(t) {
                    const { references: r, name: n } = t;
                    r.forEach((t)=>{
                        let r = t.identifier.parent;
                        for(; e1.isSpecificMemberAccess(r, null, n);)r = r.parent;
                        if (e1.isSpecificMemberAccess(r, null, s)) {
                            const e1 = "ChainExpression" === r.parent.type ? r.parent : r, t = e1.parent;
                            "CallExpression" === t.type && t.callee === e1 && a(t);
                        }
                    });
                }
                return {
                    CallExpression (t) {
                        e1.isSpecificId(t.callee, s) && a(t);
                    },
                    "Program:exit" (t) {
                        const r = i.getScope(t);
                        n.map((t)=>e1.getVariableByName(r, t)).filter((e1)=>!!e1 && 0 === e1.defs.length).forEach(u);
                    }
                };
            }
        }, em;
    }
    function $C() {
        if (nm) return rm;
        nm = 1;
        const { findVariable: e1 } = Hi(), t = Ll(), r = /^(?:assign|definePropert(?:y|ies)|freeze|setPrototypeOf)$/u, n = /^(?:(?:define|delete)Property|set(?:PrototypeOf)?)$/u;
        function s(s, i) {
            const { parent: o } = s;
            return "MemberExpression" === o.type && o.object === s && (function(e1) {
                const { parent: t } = e1;
                return "AssignmentExpression" === t.type && t.left === e1 || "ArrayPattern" === t.type || "Property" === t.type && t.value === e1 && "ObjectPattern" === t.parent.type || "RestElement" === t.type || "AssignmentPattern" === t.type && t.left === e1;
            }(o) || function(e1) {
                const t = "ChainExpression" === e1.parent.type ? e1.parent : e1, { parent: r } = t;
                return "UpdateExpression" === r.type && r.argument === t || "UnaryExpression" === r.type && "delete" === r.operator && r.argument === t;
            }(o) || function(e1) {
                const { parent: t } = e1;
                return "ForInStatement" === t.type && t.left === e1 || "ForOfStatement" === t.type && t.left === e1;
            }(o)) || function(s, i) {
                const { parent: o } = s;
                if ("CallExpression" !== o.type || o.arguments[0] !== s) return !1;
                const a = t.skipChainExpression(o.callee);
                if (!t.isSpecificMemberAccess(a, "Object", r) && !t.isSpecificMemberAccess(a, "Reflect", n)) return !1;
                const u = e1(i, a.object);
                return null !== u && "global" === u.scope.type;
            }(s, i);
        }
        function i(e1) {
            let t = e1.parent;
            for(; t && "AssignmentExpression" !== t.type && "UpdateExpression" !== t.type && "UnaryExpression" !== t.type && "CallExpression" !== t.type && "ForInStatement" !== t.type && "ForOfStatement" !== t.type;)t = t.parent;
            return t || e1;
        }
        return rm = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow assigning to imported bindings",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-import-assign"
                },
                schema: [],
                messages: {
                    readonly: "'{{name}}' is read-only.",
                    readonlyMember: "The members of '{{name}}' are read-only."
                }
            },
            create (e1) {
                const t = e1.sourceCode;
                return {
                    ImportDeclaration (r) {
                        const n = t.getScope(r);
                        for (const o of t.getDeclaredVariables(r)){
                            const t = o.defs.some((e1)=>"ImportNamespaceSpecifier" === e1.node.type);
                            let r = null;
                            for (const a of o.references){
                                const o = a.identifier;
                                o !== r && (r = o, a.isWrite() ? e1.report({
                                    node: i(o),
                                    messageId: "readonly",
                                    data: {
                                        name: o.name
                                    }
                                }) : t && s(o, n) && e1.report({
                                    node: i(o),
                                    messageId: "readonlyMember",
                                    data: {
                                        name: o.name
                                    }
                                }));
                            }
                        }
                    }
                };
            }
        }, rm;
    }
    function qC() {
        if (lm) return um;
        lm = 1;
        const e1 = new (_C()).RegExpValidator, t = /[dgimsuvy]/gu, r = void 0;
        return um = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow invalid regular expression strings in `RegExp` constructors",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-invalid-regexp"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            allowConstructorFlags: {
                                type: "array",
                                items: {
                                    type: "string"
                                }
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    regexMessage: "{{message}}."
                }
            },
            create (n) {
                const s = n.options[0];
                let i = null;
                if (s && s.allowConstructorFlags) {
                    const e1 = s.allowConstructorFlags.join("").replace(t, "");
                    e1 && (i = new RegExp(`[${e1}]`, "giu"));
                }
                function o(e1, t) {
                    n.report({
                        node: e1,
                        messageId: "regexMessage",
                        data: {
                            message: t
                        }
                    });
                }
                function a(e1) {
                    return e1 && "Literal" === e1.type && "string" == typeof e1.value;
                }
                function u(t, n) {
                    try {
                        return e1.validatePattern(t, r, r, n), null;
                    } catch (e1) {
                        return e1.message;
                    }
                }
                return {
                    "CallExpression, NewExpression" (t) {
                        if ("Identifier" !== t.callee.type || "RegExp" !== t.callee.name) return;
                        let r = function(e1) {
                            return e1.arguments.length < 2 ? "" : a(e1.arguments[1]) ? e1.arguments[1].value : null;
                        }(t);
                        r && i && (r = r.replace(i, ""));
                        let n = function(t) {
                            if (!t) return null;
                            try {
                                e1.validateFlags(t);
                            } catch  {
                                return `Invalid flags supplied to RegExp constructor '${t}'`;
                            }
                            return t.includes("u") && t.includes("v") ? "Regex 'u' and 'v' flags cannot be used together" : null;
                        }(r);
                        if (n) return void o(t, n);
                        if (!a(t.arguments[0])) return;
                        const s = t.arguments[0].value;
                        n = null === r ? u(s, {
                            unicode: !0,
                            unicodeSets: !1
                        }) && u(s, {
                            unicode: !1,
                            unicodeSets: !0
                        }) && u(s, {
                            unicode: !1,
                            unicodeSets: !1
                        }) : u(s, {
                            unicode: r.includes("u"),
                            unicodeSets: r.includes("v")
                        }), n && o(t, n);
                    }
                };
            }
        }, um;
    }
    function GC() {
        if (dm) return fm;
        dm = 1;
        const e1 = Ll(), t = /[\f\v\u0085\ufeff\u00a0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u202f\u205f\u3000\u2028\u2029]/u, r = /[\f\v\u0085\ufeff\u00a0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u202f\u205f\u3000]+/gmu, n = /[\u2028\u2029]/gmu, s = e1.createGlobalLinebreakMatcher();
        return fm = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow irregular whitespace",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-irregular-whitespace"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            skipComments: {
                                type: "boolean",
                                default: !1
                            },
                            skipStrings: {
                                type: "boolean",
                                default: !0
                            },
                            skipTemplates: {
                                type: "boolean",
                                default: !1
                            },
                            skipRegExps: {
                                type: "boolean",
                                default: !1
                            },
                            skipJSXText: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    noIrregularWhitespace: "Irregular whitespace not allowed."
                }
            },
            create (e1) {
                let i = [];
                const o = e1.options[0] || {}, a = !!o.skipComments, u = !1 !== o.skipStrings, l = !!o.skipRegExps, c = !!o.skipTemplates, p = !!o.skipJSXText, f = e1.sourceCode, d = f.getAllComments();
                function h(e1) {
                    const t = e1.loc.start, r = e1.loc.end;
                    i = i.filter(({ loc: { start: e1 } })=>e1.line < t.line || e1.line === t.line && e1.column < t.column || e1.line === r.line && e1.column >= r.column || e1.line > r.line);
                }
                function m(e1) {
                    t.test(e1.value) && h(e1);
                }
                function g() {}
                const y = {};
                return t.test(f.getText()) ? (y.Program = function(e1) {
                    !function(e1) {
                        f.lines.forEach((t, n)=>{
                            const s = n + 1;
                            let o;
                            for(; null !== (o = r.exec(t));)i.push({
                                node: e1,
                                messageId: "noIrregularWhitespace",
                                loc: {
                                    start: {
                                        line: s,
                                        column: o.index
                                    },
                                    end: {
                                        line: s,
                                        column: o.index + o[0].length
                                    }
                                }
                            });
                        });
                    }(e1), function(e1) {
                        const t = f.getText(), r = f.lines, o = t.match(s);
                        let a, u = -1;
                        for(; null !== (a = n.exec(t));){
                            const t = o.indexOf(a[0], u + 1) || 0;
                            i.push({
                                node: e1,
                                messageId: "noIrregularWhitespace",
                                loc: {
                                    start: {
                                        line: t + 1,
                                        column: r[t].length
                                    },
                                    end: {
                                        line: t + 2,
                                        column: 0
                                    }
                                }
                            }), u = t;
                        }
                    }(e1);
                }, y.Literal = function(e1) {
                    const r = u && "string" == typeof e1.value, n = l && Boolean(e1.regex);
                    (r || n) && t.test(e1.raw) && h(e1);
                }, y.TemplateElement = c ? function(e1) {
                    "string" == typeof e1.value.raw && t.test(e1.value.raw) && h(e1);
                } : g, y.JSXText = p ? function(e1) {
                    t.test(e1.raw) && h(e1);
                } : g, y["Program:exit"] = function() {
                    a && d.forEach(m), i.forEach((t)=>e1.report(t));
                }) : y.Program = g, y;
            }
        }, fm;
    }
    function WC() {
        if (ym) return gm;
        ym = 1;
        const e1 = Ll();
        return gm = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow labels that share a name with a variable",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-label-var"
                },
                schema: [],
                messages: {
                    identifierClashWithLabel: "Found identifier with same name as label."
                }
            },
            create (t) {
                const r = t.sourceCode;
                return {
                    LabeledStatement (n) {
                        (function(t, r) {
                            return null !== e1.getVariableByName(t, r);
                        })(r.getScope(n), n.label.name) && t.report({
                            node: n,
                            messageId: "identifierClashWithLabel"
                        });
                    }
                };
            }
        }, gm;
    }
    function XC() {
        if (Tm) return Am;
        function e1(e1) {
            for(let t = e1; t.parent; t = t.parent){
                const e1 = t.parent;
                switch(e1.type){
                    case "WhileStatement":
                    case "DoWhileStatement":
                        return e1;
                    case "ForStatement":
                        if (e1.init !== t) return e1;
                        break;
                    case "ForInStatement":
                    case "ForOfStatement":
                        if (e1.right !== t) return e1;
                        break;
                    case "ArrowFunctionExpression":
                    case "FunctionExpression":
                    case "FunctionDeclaration":
                        return null;
                }
            }
            return null;
        }
        function t(t, r) {
            const n = r.resolved, s = n && n.defs[0], i = s && s.parent, o = i && "VariableDeclaration" === i.type ? i.kind : "";
            if ("const" === o) return !0;
            if ("let" === o && i.range[0] > t.range[0] && i.range[1] < t.range[1]) return !0;
            const a = function(t, r) {
                const n = r ? r.range[1] : 0;
                let s = t, i = t;
                for(; i && i.range[0] >= n;)s = i, i = e1(i);
                return s;
            }(t, "let" === o ? i : null).range[0];
            return Boolean(n) && n.references.every(function(e1) {
                const t = e1.identifier;
                return !e1.isWrite() || n.scope.variableScope === e1.from.variableScope && t.range[0] < a;
            });
        }
        return Tm = 1, Am = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow function declarations that contain unsafe references inside loop statements",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-loop-func"
                },
                schema: [],
                messages: {
                    unsafeRefs: "Function declared in a loop contains unsafe references to variable(s) {{ varNames }}."
                }
            },
            create (r) {
                const n = r.sourceCode;
                function s(s) {
                    const i = e1(s);
                    if (!i) return;
                    const o = n.getScope(s).through.filter((e1)=>e1.resolved && !t(i, e1)).map((e1)=>e1.identifier.name);
                    o.length > 0 && r.report({
                        node: s,
                        messageId: "unsafeRefs",
                        data: {
                            varNames: `'${o.join("', '")}'`
                        }
                    });
                }
                return {
                    ArrowFunctionExpression: s,
                    FunctionExpression: s,
                    FunctionDeclaration: s
                };
            }
        }, Am;
    }
    function zC() {
        return Dm || (Dm = 1, Rm = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow literal numbers that lose precision",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-loss-of-precision"
                },
                schema: [],
                messages: {
                    noLossOfPrecision: "This number literal will lose precision at runtime."
                }
            },
            create (e1) {
                function t(e1) {
                    return e1.raw.replace(/_/gu, "");
                }
                function r(e1) {
                    return `${e1[0]}.${e1.slice(1)}`;
                }
                function n(e1) {
                    for(let t = 0; t < e1.length; t++)if ("0" !== e1[t]) return e1.slice(t);
                    return e1;
                }
                function s(e1) {
                    const t = e1.replace("E", "e").split("e"), s = t[0], i = e1.includes(".") ? function(e1) {
                        const t = n(e1);
                        if (t.startsWith(".")) {
                            const e1 = t.slice(1), s = n(e1);
                            return {
                                magnitude: s.length - e1.length - 1,
                                coefficient: r(s)
                            };
                        }
                        return {
                            magnitude: t.indexOf(".") - 1,
                            coefficient: r(t.replace(".", ""))
                        };
                    }(s) : function(e1) {
                        const t = function(e1) {
                            for(let t = e1.length - 1; t >= 0; t--)if ("0" !== e1[t]) return e1.slice(0, t + 1);
                            return e1;
                        }(n(e1));
                        return {
                            magnitude: e1.startsWith("0") ? e1.length - 2 : e1.length - 1,
                            coefficient: r(t)
                        };
                    }(s);
                    return `${i.coefficient}e${t.length > 1 ? parseInt(t[1], 10) + i.magnitude : i.magnitude}`;
                }
                function i(e1) {
                    return function(e1) {
                        return [
                            "0x",
                            "0X",
                            "0b",
                            "0B",
                            "0o",
                            "0O"
                        ].every((t)=>!e1.raw.startsWith(t)) && !/^0[0-7]+$/u.test(e1.raw);
                    }(e1) ? function(e1) {
                        const r = s(t(e1)), n = r.split("e")[0].replace(".", "").length;
                        return n > 100 || r !== s(e1.value.toPrecision(n));
                    }(e1) : function(e1) {
                        const r = t(e1).toUpperCase();
                        let n = 0;
                        return n = r.startsWith("0B") ? 2 : r.startsWith("0X") ? 16 : 8, !r.endsWith(e1.value.toString(n).toUpperCase());
                    }(e1);
                }
                return {
                    Literal (t) {
                        t.value && function(e1) {
                            return "number" == typeof e1.value;
                        }(t) && i(t) && e1.report({
                            messageId: "noLossOfPrecision",
                            node: t
                        });
                    }
                };
            }
        }), Rm;
    }
    function HC() {
        if (_m) return wm;
        _m = 1;
        const e1 = Ll();
        function t(e1) {
            return "string" == typeof e1 ? BigInt(e1.slice(0, -1)) : e1;
        }
        return wm = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow magic numbers",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-magic-numbers"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            detectObjects: {
                                type: "boolean",
                                default: !1
                            },
                            enforceConst: {
                                type: "boolean",
                                default: !1
                            },
                            ignore: {
                                type: "array",
                                items: {
                                    anyOf: [
                                        {
                                            type: "number"
                                        },
                                        {
                                            type: "string",
                                            pattern: "^[+-]?(?:0|[1-9][0-9]*)n$"
                                        }
                                    ]
                                },
                                uniqueItems: !0
                            },
                            ignoreArrayIndexes: {
                                type: "boolean",
                                default: !1
                            },
                            ignoreDefaultValues: {
                                type: "boolean",
                                default: !1
                            },
                            ignoreClassFieldInitialValues: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    useConst: "Number constants declarations must use 'const'.",
                    noMagic: "No magic number: {{raw}}."
                }
            },
            create (r) {
                const n = r.options[0] || {}, s = !!n.detectObjects, i = !!n.enforceConst, o = new Set((n.ignore || []).map(t)), a = !!n.ignoreArrayIndexes, u = !!n.ignoreDefaultValues, l = !!n.ignoreClassFieldInitialValues, c = s ? [] : [
                    "ObjectExpression",
                    "Property",
                    "AssignmentExpression"
                ];
                return {
                    Literal (t) {
                        if (!e1.isNumericLiteral(t)) return;
                        let n, s, p;
                        "UnaryExpression" === t.parent.type && "-" === t.parent.operator ? (n = t.parent, s = -t.value, p = `-${t.raw}`) : (n = t, s = t.value, p = t.raw);
                        const f = n.parent;
                        (function(e1) {
                            return o.has(e1);
                        })(s) || u && function(e1) {
                            const t = e1.parent;
                            return "AssignmentPattern" === t.type && t.right === e1;
                        }(n) || l && function(e1) {
                            const t = e1.parent;
                            return "PropertyDefinition" === t.type && t.value === e1;
                        }(n) || function(t) {
                            const r = t.parent;
                            return "CallExpression" === r.type && t === r.arguments[1] && (e1.isSpecificId(r.callee, "parseInt") || e1.isSpecificMemberAccess(r.callee, "Number", "parseInt"));
                        }(n) || function(e1) {
                            return 0 === e1.parent.type.indexOf("JSX");
                        }(n) || a && function(e1, t) {
                            const r = e1.parent;
                            return "MemberExpression" === r.type && r.property === e1 && (Number.isInteger(t) || "bigint" == typeof t) && t >= 0 && t < 4294967295;
                        }(n, s) || ("VariableDeclarator" === f.type ? i && "const" !== f.parent.kind && r.report({
                            node: n,
                            messageId: "useConst"
                        }) : (!c.includes(f.type) || "AssignmentExpression" === f.type && "Identifier" === f.left.type) && r.report({
                            node: n,
                            messageId: "noMagic",
                            data: {
                                raw: p
                            }
                        }));
                    }
                };
            }
        }, wm;
    }
    function JC() {
        return jm || (jm = 1, Um = {
            isCombiningCharacter: Bm ? km : (Bm = 1, km = function(e1) {
                return /^[\p{Mc}\p{Me}\p{Mn}]$/u.test(String.fromCodePoint(e1));
            }),
            isEmojiModifier: (Pm || (Pm = 1, Lm = function(e1) {
                return e1 >= 127995 && e1 <= 127999;
            }), Lm),
            isRegionalIndicatorSymbol: (Fm || (Fm = 1, Im = function(e1) {
                return e1 >= 127462 && e1 <= 127487;
            }), Im),
            isSurrogatePair: Om ? Nm : (Om = 1, Nm = function(e1, t) {
                return e1 >= 55296 && e1 < 56320 && t >= 56320 && t < 57344;
            })
        }), Um;
    }
    function QC() {
        if (Km) return Vm;
        Km = 1;
        const { RegExpValidator: e1 } = _C();
        return Vm = {
            isValidWithUnicodeFlag: function(t, r) {
                if (t <= 5) return !1;
                const n = new e1({
                    ecmaVersion: Math.min(t, 2024)
                });
                try {
                    n.validatePattern(r, void 0, void 0, {
                        unicode: !0
                    });
                } catch  {
                    return !1;
                }
                return !0;
            },
            REGEXPP_LATEST_ECMA_VERSION: 2024
        }, Vm;
    }
    function YC() {
        if (Gm) return qm;
        Gm = 1;
        const e1 = Ll(), t = [
            "+",
            "-",
            "*",
            "/",
            "%",
            "**"
        ], r = [
            "&",
            "|",
            "^",
            "~",
            "<<",
            ">>",
            ">>>"
        ], n = [
            "==",
            "!=",
            "===",
            "!==",
            ">",
            ">=",
            "<",
            "<="
        ], s = [
            "&&",
            "||"
        ], i = [
            "in",
            "instanceof"
        ], o = [].concat(t, r, n, s, i, [
            "?:"
        ], [
            "??"
        ]), a = [
            t,
            r,
            n,
            s,
            i
        ], u = /^(?:Binary|Logical|Conditional)Expression$/u;
        function l(e1) {
            return "ConditionalExpression" === e1.type ? e1.test : e1.left;
        }
        return qm = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "suggestion",
                docs: {
                    description: "Disallow mixed binary operators",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-mixed-operators"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            groups: {
                                type: "array",
                                items: {
                                    type: "array",
                                    items: {
                                        enum: o
                                    },
                                    minItems: 2,
                                    uniqueItems: !0
                                },
                                uniqueItems: !0
                            },
                            allowSamePrecedence: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unexpectedMixedOperator: "Unexpected mix of '{{leftOperator}}' and '{{rightOperator}}'. Use parentheses to clarify the intended order of operations."
                }
            },
            create (t) {
                const r = t.sourceCode, n = function(e1 = {}) {
                    return {
                        groups: e1.groups && e1.groups.length > 0 ? e1.groups : a,
                        allowSamePrecedence: !1 !== e1.allowSamePrecedence
                    };
                }(t.options[0]);
                function s(t) {
                    return r.getTokenAfter(l(t), e1.isNotClosingParenToken);
                }
                function i(i) {
                    u.test(i.parent.type) && function(t) {
                        return t.operator !== t.parent.operator && !e1.isParenthesised(r, t);
                    }(i) && !function(t) {
                        const r = t, s = t.parent;
                        var i, o, a;
                        return i = n.groups, o = r.operator, a = "ConditionalExpression" === s.type ? "?:" : s.operator, !i.some((e1)=>e1.includes(o) && e1.includes(a)) || n.allowSamePrecedence && e1.getPrecedence(r) === e1.getPrecedence(s);
                    }(i) && function(e1) {
                        const r = e1.parent, n = l(r) === e1 ? e1 : r, i = l(r) !== e1 ? e1 : r, o = {
                            leftOperator: n.operator || "?:",
                            rightOperator: i.operator || "?:"
                        };
                        t.report({
                            node: n,
                            loc: s(n).loc,
                            messageId: "unexpectedMixedOperator",
                            data: o
                        }), t.report({
                            node: i,
                            loc: s(i).loc,
                            messageId: "unexpectedMixedOperator",
                            data: o
                        });
                    }(i);
                }
                return {
                    BinaryExpression: i,
                    LogicalExpression: i
                };
            }
        }, qm;
    }
    function ZC() {
        return Xm || (Xm = 1, Wm = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "suggestion",
                docs: {
                    description: "Disallow `require` calls to be mixed with regular variable declarations",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-mixed-requires"
                },
                schema: [
                    {
                        oneOf: [
                            {
                                type: "boolean"
                            },
                            {
                                type: "object",
                                properties: {
                                    grouping: {
                                        type: "boolean"
                                    },
                                    allowCall: {
                                        type: "boolean"
                                    }
                                },
                                additionalProperties: !1
                            }
                        ]
                    }
                ],
                messages: {
                    noMixRequire: "Do not mix 'require' and other declarations.",
                    noMixCoreModuleFileComputed: "Do not mix core, module, file and computed requires."
                }
            },
            create (e1) {
                const t = e1.options[0];
                let r = !1, n = !1;
                "object" == typeof t ? (r = t.grouping, n = t.allowCall) : r = !!t;
                const s = [
                    "assert",
                    "buffer",
                    "child_process",
                    "cluster",
                    "crypto",
                    "dgram",
                    "dns",
                    "domain",
                    "events",
                    "fs",
                    "http",
                    "https",
                    "net",
                    "os",
                    "path",
                    "punycode",
                    "querystring",
                    "readline",
                    "repl",
                    "smalloc",
                    "stream",
                    "string_decoder",
                    "tls",
                    "tty",
                    "url",
                    "util",
                    "v8",
                    "vm",
                    "zlib"
                ], i = "require", o = "uninitialized", a = "other", u = "computed";
                function l(e1) {
                    return e1 ? "CallExpression" === e1.type && "Identifier" === e1.callee.type && "require" === e1.callee.name ? i : n && "CallExpression" === e1.type && "CallExpression" === e1.callee.type ? l(e1.callee) : "MemberExpression" === e1.type ? l(e1.object) : a : o;
                }
                function c(e1) {
                    if ("MemberExpression" === e1.type) return c(e1.object);
                    if (0 === e1.arguments.length) return u;
                    const t = e1.arguments[0];
                    return "Literal" !== t.type || "string" != typeof t.value ? u : s.includes(t.value) ? "core" : /^\.{0,2}\//u.test(t.value) ? "file" : "module";
                }
                function p(e1) {
                    const t = {};
                    return e1.forEach((e1)=>{
                        l(e1.init) === i && (t[c(e1.init)] = !0);
                    }), Object.keys(t).length <= 1;
                }
                return {
                    VariableDeclaration (t) {
                        !function(e1) {
                            const t = {};
                            return e1.forEach((e1)=>{
                                const r = l(e1.init);
                                t[r] = !0;
                            }), !(!t[i] || !t[o] && !t[a]);
                        }(t.declarations) ? r && !p(t.declarations) && e1.report({
                            node: t,
                            messageId: "noMixCoreModuleFileComputed"
                        }) : e1.report({
                            node: t,
                            messageId: "noMixRequire"
                        });
                    }
                };
            }
        }), Wm;
    }
    function eS() {
        if (Bg) return kg;
        Bg = 1;
        const { getVariableByName: e1, isArrowToken: t, isStartOfExpressionStatement: r, needsPrecedingSemicolon: n } = Ll();
        return kg = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow calls to the `Object` constructor without an argument",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-object-constructor"
                },
                hasSuggestions: !0,
                schema: [],
                messages: {
                    preferLiteral: "The object literal notation {} is preferable.",
                    useLiteral: "Replace with '{{replacement}}'.",
                    useLiteralAfterSemicolon: "Replace with '{{replacement}}', add preceding semicolon."
                }
            },
            create (s) {
                const i = s.sourceCode;
                function o(o) {
                    if ("Identifier" !== o.callee.type || "Object" !== o.callee.name || o.arguments.length) return;
                    const a = e1(i.getScope(o), "Object");
                    if (a && 0 === a.identifiers.length) {
                        let e1, a, u = "useLiteral";
                        !function(e1) {
                            if (r(e1)) return !0;
                            const n = i.getTokenBefore(e1);
                            return !(!n || !t(n));
                        }(o) ? e1 = a = "{}" : (e1 = "({})", n(i, o) ? (a = ";({})", u = "useLiteralAfterSemicolon") : a = "({})"), s.report({
                            node: o,
                            messageId: "preferLiteral",
                            suggest: [
                                {
                                    messageId: u,
                                    data: {
                                        replacement: e1
                                    },
                                    fix: (e1)=>e1.replaceText(o, a)
                                }
                            ]
                        });
                    }
                }
                return {
                    CallExpression: o,
                    NewExpression: o
                };
            }
        }, kg;
    }
    function tS() {
        if (Og) return Ng;
        Og = 1;
        const e1 = /(?:Statement|Declaration|Function(?:Expression)?|Program)$/u;
        return Ng = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow reassigning `function` parameters",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-param-reassign"
                },
                schema: [
                    {
                        oneOf: [
                            {
                                type: "object",
                                properties: {
                                    props: {
                                        enum: [
                                            !1
                                        ]
                                    }
                                },
                                additionalProperties: !1
                            },
                            {
                                type: "object",
                                properties: {
                                    props: {
                                        enum: [
                                            !0
                                        ]
                                    },
                                    ignorePropertyModificationsFor: {
                                        type: "array",
                                        items: {
                                            type: "string"
                                        },
                                        uniqueItems: !0
                                    },
                                    ignorePropertyModificationsForRegex: {
                                        type: "array",
                                        items: {
                                            type: "string"
                                        },
                                        uniqueItems: !0
                                    }
                                },
                                additionalProperties: !1
                            }
                        ]
                    }
                ],
                messages: {
                    assignmentToFunctionParam: "Assignment to function parameter '{{name}}'.",
                    assignmentToFunctionParamProp: "Assignment to property of function parameter '{{name}}'."
                }
            },
            create (t) {
                const r = t.options[0] && t.options[0].props, n = t.options[0] && t.options[0].ignorePropertyModificationsFor || [], s = t.options[0] && t.options[0].ignorePropertyModificationsForRegex || [], i = t.sourceCode;
                function o(i, o, a) {
                    const u = i.identifier;
                    var l;
                    !u || i.init || 0 !== o && a[o - 1].identifier === u || (i.isWrite() ? t.report({
                        node: u,
                        messageId: "assignmentToFunctionParam",
                        data: {
                            name: u.name
                        }
                    }) : r && function(t) {
                        let r = t.identifier, n = r.parent;
                        for(; n && (!e1.test(n.type) || "ForInStatement" === n.type || "ForOfStatement" === n.type);){
                            switch(n.type){
                                case "AssignmentExpression":
                                case "ForInStatement":
                                case "ForOfStatement":
                                    return n.left === r;
                                case "UpdateExpression":
                                    return !0;
                                case "UnaryExpression":
                                    if ("delete" === n.operator) return !0;
                                    break;
                                case "CallExpression":
                                    if (n.callee !== r) return !1;
                                    break;
                                case "MemberExpression":
                                    if (n.property === r) return !1;
                                    break;
                                case "Property":
                                    if (n.key === r) return !1;
                                    break;
                                case "ConditionalExpression":
                                    if (n.test === r) return !1;
                            }
                            r = n, n = r.parent;
                        }
                        return !1;
                    }(i) && (l = u.name, !n.includes(l) && !s.some((e1)=>new RegExp(e1, "u").test(l))) && t.report({
                        node: u,
                        messageId: "assignmentToFunctionParamProp",
                        data: {
                            name: u.name
                        }
                    }));
                }
                function a(e1) {
                    "Parameter" === e1.defs[0].type && e1.references.forEach(o);
                }
                function u(e1) {
                    i.getDeclaredVariables(e1).forEach(a);
                }
                return {
                    "FunctionDeclaration:exit": u,
                    "FunctionExpression:exit": u,
                    "ArrowFunctionExpression:exit": u
                };
            }
        }, Ng;
    }
    function rS() {
        if (Kg) return Vg;
        function e1(t) {
            const r = t.parent;
            return "SequenceExpression" === r.type ? e1(r) : function(e1) {
                const t = e1.parent;
                return "ForStatement" === t.type && t.update === e1;
            }(t);
        }
        return Kg = 1, Vg = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow the unary operators `++` and `--`",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-plusplus"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            allowForLoopAfterthoughts: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unexpectedUnaryOp: "Unary operator '{{operator}}' used."
                }
            },
            create (t) {
                const r = t.options[0];
                let n = !1;
                return "object" == typeof r && (n = !0 === r.allowForLoopAfterthoughts), {
                    UpdateExpression (r) {
                        n && e1(r) || t.report({
                            node: r,
                            messageId: "unexpectedUnaryOp",
                            data: {
                                operator: r.operator
                            }
                        });
                    }
                };
            }
        }, Vg;
    }
    function nS() {
        if (Xg) return Wg;
        Xg = 1;
        const { findVariable: e1 } = Hi(), t = Ll(), r = new Set([
            "ArrowFunctionExpression",
            "FunctionExpression"
        ]);
        function n(t, r) {
            const n = t.parent;
            return "NewExpression" === n.type && n.arguments[0] === t && "Identifier" === n.callee.type && "Promise" === n.callee.name && function(t, r) {
                const n = e1(r, t);
                return null !== n && "global" === n.scope.type && 0 === n.defs.length;
            }(n.callee, function(e1) {
                const t = e1.upper;
                return "function-expression-name" === t.type ? t.upper : t;
            }(r));
        }
        function s(e1) {
            return "UnaryExpression" === e1.type && "void" === e1.operator;
        }
        function i(e1, r, n) {
            const s = t.getPrecedence(r) < t.getPrecedence({
                type: "UnaryExpression",
                operator: "void"
            }) && !t.isParenthesised(e1, r), i = e1.getTokenBefore(r, "ArrowFunctionExpression" === r.parent.type ? t.isArrowToken : (e1)=>"Keyword" === e1.type && "return" === e1.value), o = e1.getTokenAfter(i), a = "return" === i.value && i.range[1] === o.range[0];
            return [
                n.insertTextBefore(o, `${a ? " " : ""}void ${s ? "(" : ""}`),
                n.insertTextAfter(r, s ? ")" : "")
            ];
        }
        return Wg = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow returning values from Promise executor functions",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-promise-executor-return"
                },
                hasSuggestions: !0,
                schema: [
                    {
                        type: "object",
                        properties: {
                            allowVoid: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    returnsValue: "Return values from promise executor functions cannot be read.",
                    prependVoid: "Prepend `void` to the expression.",
                    wrapBraces: "Wrap the expression in `{}`."
                }
            },
            create (e1) {
                let o = null;
                const a = e1.sourceCode, { allowVoid: u = !1 } = e1.options[0] || {};
                return {
                    onCodePathStart (l, c) {
                        if (o = {
                            upper: o,
                            shouldCheck: r.has(c.type) && n(c, a.getScope(c))
                        }, o.shouldCheck && "ArrowFunctionExpression" === c.type && c.expression && (!u || !s(c.body))) {
                            const r = [];
                            u && r.push({
                                messageId: "prependVoid",
                                fix: (e1)=>i(a, c.body, e1)
                            }), ("FunctionExpression" !== c.body.type || c.body.id) && r.push({
                                messageId: "wrapBraces",
                                fix: (e1)=>(function(e1, r, n) {
                                        const s = e1.getTokenBefore(r.body, t.isArrowToken), i = e1.getTokenAfter(s), o = e1.getLastToken(r);
                                        return [
                                            n.insertTextBefore(i, "{"),
                                            n.insertTextAfter(o, "}")
                                        ];
                                    })(a, c, e1)
                            }), e1.report({
                                node: c.body,
                                messageId: "returnsValue",
                                suggest: r
                            });
                        }
                    },
                    onCodePathEnd () {
                        o = o.upper;
                    },
                    ReturnStatement (t) {
                        o.shouldCheck && t.argument && (u ? s(t.argument) || e1.report({
                            node: t,
                            messageId: "returnsValue",
                            suggest: [
                                {
                                    messageId: "prependVoid",
                                    fix: (e1)=>i(a, t.argument, e1)
                                }
                            ]
                        }) : e1.report({
                            node: t,
                            messageId: "returnsValue"
                        }));
                    }
                };
            }
        }, Wg;
    }
    function sS() {
        if (Qg) return Jg;
        Qg = 1;
        const e1 = Ll();
        function t(e1) {
            let r;
            if ("MemberExpression" === e1.type) r = e1.object;
            else {
                if ("CallExpression" !== e1.type) return !1;
                r = e1.callee;
            }
            return !!e1.optional || t(r);
        }
        return Jg = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow calling some `Object.prototype` methods directly on objects",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-prototype-builtins"
                },
                hasSuggestions: !0,
                schema: [],
                messages: {
                    prototypeBuildIn: "Do not access Object.prototype method '{{prop}}' from target object.",
                    callObjectPrototype: "Call Object.prototype.{{prop}} explicitly."
                }
            },
            create (r) {
                const n = new Set([
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable"
                ]);
                return {
                    CallExpression: function(s) {
                        const i = e1.skipChainExpression(s.callee);
                        if ("MemberExpression" !== i.type) return;
                        const o = e1.getStaticPropertyName(i);
                        null !== o && n.has(o) && r.report({
                            messageId: "prototypeBuildIn",
                            loc: i.property.loc,
                            data: {
                                prop: o
                            },
                            node: s,
                            suggest: [
                                {
                                    messageId: "callObjectPrototype",
                                    data: {
                                        prop: o
                                    },
                                    fix (n) {
                                        const a = r.sourceCode;
                                        if (t(s)) return null;
                                        if ("ChainExpression" === s.callee.type) return null;
                                        const u = e1.getVariableByName(a.getScope(s), "Object");
                                        if (!u || "global" !== u.scope.type || u.defs.length > 0) return null;
                                        let l = a.getText(i.object);
                                        e1.getPrecedence(i.object) <= e1.getPrecedence({
                                            type: "SequenceExpression"
                                        }) && (l = `(${l})`);
                                        const c = a.getTokenAfter(s.callee, e1.isOpeningParenToken), p = 0 === s.arguments.length ? "" : ", ";
                                        return [
                                            n.replaceText(i, `Object.prototype.${o}.call`),
                                            n.insertTextAfter(c, l + p)
                                        ];
                                    }
                                }
                            ]
                        });
                    }
                };
            }
        }, Jg;
    }
    function iS() {
        if (ay) return oy;
        function e1(e1) {
            return Array.isArray(e1) ? e1 : [
                e1
            ];
        }
        ay = 1;
        const t = /^\s+$/, r = /(?:[^\\]|^)\\$/, n = /^\\!/, s = /^\\#/, i = /\r?\n/g, o = /^\.*\/|^\.+$/;
        let a = "node-ignore";
        "undefined" != typeof Symbol && (a = Symbol.for("node-ignore"));
        const u = a, l = /([0-z])-([0-z])/g, c = ()=>!1, p = [
            [
                /^\uFEFF/,
                ()=>""
            ],
            [
                /((?:\\\\)*?)(\\?\s+)$/,
                (e1, t, r)=>t + (0 === r.indexOf("\\") ? " " : "")
            ],
            [
                /(\\+?)\s/g,
                (e1, t)=>{
                    const { length: r } = t;
                    return t.slice(0, r - r % 2) + " ";
                }
            ],
            [
                /[\\$.|*+(){^]/g,
                (e1)=>`\\${e1}`
            ],
            [
                /(?!\\)\?/g,
                ()=>"[^/]"
            ],
            [
                /^\//,
                ()=>"^"
            ],
            [
                /\//g,
                ()=>"\\/"
            ],
            [
                /^\^*\\\*\\\*\\\//,
                ()=>"^(?:.*\\/)?"
            ],
            [
                /^(?=[^^])/,
                function() {
                    return /\/(?!$)/.test(this) ? "^" : "(?:^|\\/)";
                }
            ],
            [
                /\\\/\\\*\\\*(?=\\\/|$)/g,
                (e1, t, r)=>t + 6 < r.length ? "(?:\\/[^\\/]+)*" : "\\/.+"
            ],
            [
                /(^|[^\\]+)(\\\*)+(?=.+)/g,
                (e1, t, r)=>t + r.replace(/\\\*/g, "[^\\/]*")
            ],
            [
                /\\\\\\(?=[$.|*+(){^])/g,
                ()=>"\\"
            ],
            [
                /\\\\/g,
                ()=>"\\"
            ],
            [
                /(\\)?\[([^\]/]*?)(\\*)($|\])/g,
                (e1, t, r, n, s)=>"\\" === t ? `\\[${r}${((e1)=>{
                        const { length: t } = e1;
                        return e1.slice(0, t - t % 2);
                    })(n)}${s}` : "]" === s && n.length % 2 == 0 ? `[${((e1)=>e1.replace(l, (e1, t, r)=>t.charCodeAt(0) <= r.charCodeAt(0) ? e1 : ""))(r)}${n}]` : "[]"
            ],
            [
                /(?:[^*])$/,
                (e1)=>/\/$/.test(e1) ? `${e1}$` : `${e1}(?=$|\\/$)`
            ],
            [
                /(\^|\\\/)?\\\*$/,
                (e1, t)=>`${t ? `${t}[^/]+` : "[^/]*"}(?=$|\\/$)`
            ]
        ], f = Object.create(null), d = (e1)=>"string" == typeof e1;
        class h {
            constructor(e1, t, r, n){
                this.origin = e1, this.pattern = t, this.negative = r, this.regex = n;
            }
        }
        const m = (e1, t)=>{
            const r = e1;
            let i = !1;
            0 === e1.indexOf("!") && (i = !0, e1 = e1.substr(1));
            const o = ((e1, t)=>{
                let r = f[e1];
                return r || (r = p.reduce((t, [r, n])=>t.replace(r, n.bind(e1)), e1), f[e1] = r), t ? new RegExp(r, "i") : new RegExp(r);
            })(e1 = e1.replace(n, "!").replace(s, "#"), t);
            return new h(r, e1, i, o);
        }, g = (e1, t)=>{
            throw new t(e1);
        }, y = (e1, t, r)=>{
            if (!d(e1)) return r(`path must be a string, but got \`${t}\``, TypeError);
            if (!e1) return r("path must not be empty", TypeError);
            if (y.isNotRelative(e1)) return r(`path should be a ${"`path.relative()`d"} string, but got "${t}"`, RangeError);
            return !0;
        }, E = (e1)=>o.test(e1);
        y.isNotRelative = E, y.convert = (e1)=>e1;
        class x {
            constructor({ ignorecase: e1 = !0, ignoreCase: t = e1, allowRelativePaths: r = !1 } = {}){
                var n, s, i;
                n = this, s = u, i = !0, Object.defineProperty(n, s, {
                    value: i
                }), this._rules = [], this._ignoreCase = t, this._allowRelativePaths = r, this._initCache();
            }
            _initCache() {
                this._ignoreCache = Object.create(null), this._testCache = Object.create(null);
            }
            _addPattern(e1) {
                if (e1 && e1[u]) return this._rules = this._rules.concat(e1._rules), void (this._added = !0);
                if (((e1)=>e1 && d(e1) && !t.test(e1) && !r.test(e1) && 0 !== e1.indexOf("#"))(e1)) {
                    const t = m(e1, this._ignoreCase);
                    this._added = !0, this._rules.push(t);
                }
            }
            add(t) {
                return this._added = !1, e1(d(t) ? ((e1)=>e1.split(i))(t) : t).forEach(this._addPattern, this), this._added && this._initCache(), this;
            }
            addPattern(e1) {
                return this.add(e1);
            }
            _testOne(e1, t) {
                let r = !1, n = !1;
                return this._rules.forEach((s)=>{
                    const { negative: i } = s;
                    if (n === i && r !== n || i && !r && !n && !t) return;
                    s.regex.test(e1) && (r = !i, n = i);
                }), {
                    ignored: r,
                    unignored: n
                };
            }
            _test(e1, t, r, n) {
                const s = e1 && y.convert(e1);
                return y(s, e1, this._allowRelativePaths ? c : g), this._t(s, t, r, n);
            }
            _t(e1, t, r, n) {
                if (e1 in t) return t[e1];
                if (n || (n = e1.split("/")), n.pop(), !n.length) return t[e1] = this._testOne(e1, r);
                const s = this._t(n.join("/") + "/", t, r, n);
                return t[e1] = s.ignored ? s : this._testOne(e1, r);
            }
            ignores(e1) {
                return this._test(e1, this._ignoreCache, !1).ignored;
            }
            createFilter() {
                return (e1)=>!this.ignores(e1);
            }
            filter(t) {
                return e1(t).filter(this.createFilter());
            }
            test(e1) {
                return this._test(e1, this._testCache, !0);
            }
        }
        const C = (e1)=>new x(e1);
        C.isPathValid = (e1)=>y(e1 && y.convert(e1), e1, c), C.default = C, oy = C;
        var e2;
        return oy;
    }
    function oS() {
        if (ly) return uy;
        ly = 1;
        const e1 = Ll(), t = iS(), r = {
            type: "array",
            items: {
                anyOf: [
                    {
                        type: "string"
                    },
                    {
                        type: "object",
                        properties: {
                            name: {
                                type: "string"
                            },
                            message: {
                                type: "string",
                                minLength: 1
                            },
                            importNames: {
                                type: "array",
                                items: {
                                    type: "string"
                                }
                            }
                        },
                        additionalProperties: !1,
                        required: [
                            "name"
                        ]
                    }
                ]
            },
            uniqueItems: !0
        };
        return uy = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow specified modules when loaded by `import`",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-restricted-imports"
                },
                messages: {
                    path: "'{{importSource}}' import is restricted from being used.",
                    pathWithCustomMessage: "'{{importSource}}' import is restricted from being used. {{customMessage}}",
                    patterns: "'{{importSource}}' import is restricted from being used by a pattern.",
                    patternWithCustomMessage: "'{{importSource}}' import is restricted from being used by a pattern. {{customMessage}}",
                    patternAndImportName: "'{{importName}}' import from '{{importSource}}' is restricted from being used by a pattern.",
                    patternAndImportNameWithCustomMessage: "'{{importName}}' import from '{{importSource}}' is restricted from being used by a pattern. {{customMessage}}",
                    patternAndEverything: "* import is invalid because '{{importNames}}' from '{{importSource}}' is restricted from being used by a pattern.",
                    patternAndEverythingWithRegexImportName: "* import is invalid because import name matching '{{importNames}}' pattern from '{{importSource}}' is restricted from being used.",
                    patternAndEverythingWithCustomMessage: "* import is invalid because '{{importNames}}' from '{{importSource}}' is restricted from being used by a pattern. {{customMessage}}",
                    patternAndEverythingWithRegexImportNameAndCustomMessage: "* import is invalid because import name matching '{{importNames}}' pattern from '{{importSource}}' is restricted from being used. {{customMessage}}",
                    everything: "* import is invalid because '{{importNames}}' from '{{importSource}}' is restricted.",
                    everythingWithCustomMessage: "* import is invalid because '{{importNames}}' from '{{importSource}}' is restricted. {{customMessage}}",
                    importName: "'{{importName}}' import from '{{importSource}}' is restricted.",
                    importNameWithCustomMessage: "'{{importName}}' import from '{{importSource}}' is restricted. {{customMessage}}"
                },
                schema: {
                    anyOf: [
                        r,
                        {
                            type: "array",
                            items: [
                                {
                                    type: "object",
                                    properties: {
                                        paths: r,
                                        patterns: {
                                            anyOf: [
                                                {
                                                    type: "array",
                                                    items: {
                                                        type: "string"
                                                    },
                                                    uniqueItems: !0
                                                },
                                                {
                                                    type: "array",
                                                    items: {
                                                        type: "object",
                                                        properties: {
                                                            importNames: {
                                                                type: "array",
                                                                items: {
                                                                    type: "string"
                                                                },
                                                                minItems: 1,
                                                                uniqueItems: !0
                                                            },
                                                            group: {
                                                                type: "array",
                                                                items: {
                                                                    type: "string"
                                                                },
                                                                minItems: 1,
                                                                uniqueItems: !0
                                                            },
                                                            importNamePattern: {
                                                                type: "string"
                                                            },
                                                            message: {
                                                                type: "string",
                                                                minLength: 1
                                                            },
                                                            caseSensitive: {
                                                                type: "boolean"
                                                            }
                                                        },
                                                        additionalProperties: !1,
                                                        required: [
                                                            "group"
                                                        ]
                                                    },
                                                    uniqueItems: !0
                                                }
                                            ]
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            additionalItems: !1
                        }
                    ]
                }
            },
            create (r) {
                const n = r.sourceCode, s = Array.isArray(r.options) ? r.options : [], i = "object" == typeof s[0] && (Object.prototype.hasOwnProperty.call(s[0], "paths") || Object.prototype.hasOwnProperty.call(s[0], "patterns")), o = (i ? s[0].paths : r.options) || [], a = o.reduce((e1, t)=>("string" == typeof t ? e1[t] = {
                        message: null
                    } : e1[t.name] = {
                        message: t.message,
                        importNames: t.importNames
                    }, e1), {});
                let u = (i ? s[0].patterns : []) || [];
                u.length > 0 && "string" == typeof u[0] && (u = [
                    {
                        group: u
                    }
                ]);
                const l = u.map(({ group: e1, message: r, caseSensitive: n, importNames: s, importNamePattern: i })=>({
                        matcher: t({
                            allowRelativePaths: !0,
                            ignorecase: !n
                        }).add(e1),
                        customMessage: r,
                        importNames: s,
                        importNamePattern: i
                    }));
                if (0 === Object.keys(o).length && 0 === l.length) return {};
                function c(t) {
                    const s = t.source.value.trim(), i = new Map;
                    if ("ExportAllDeclaration" === t.type) {
                        const e1 = n.getFirstToken(t, 1);
                        i.set("*", [
                            {
                                loc: e1.loc
                            }
                        ]);
                    } else if (t.specifiers) for (const r of t.specifiers){
                        let t;
                        const n = {
                            loc: r.loc
                        };
                        "ImportDefaultSpecifier" === r.type ? t = "default" : "ImportNamespaceSpecifier" === r.type ? t = "*" : r.imported ? t = e1.getModuleExportName(r.imported) : r.local && (t = e1.getModuleExportName(r.local)), "string" == typeof t && (i.has(t) ? i.get(t).push(n) : i.set(t, [
                            n
                        ]));
                    }
                    !function(e1, t, n) {
                        if (!Object.prototype.hasOwnProperty.call(a, e1)) return;
                        const s = a[e1].message, i = a[e1].importNames;
                        if (i) {
                            if (t.has("*")) {
                                const o = t.get("*")[0];
                                r.report({
                                    node: n,
                                    messageId: s ? "everythingWithCustomMessage" : "everything",
                                    loc: o.loc,
                                    data: {
                                        importSource: e1,
                                        importNames: i,
                                        customMessage: s
                                    }
                                });
                            }
                            i.forEach((i)=>{
                                t.has(i) && t.get(i).forEach((t)=>{
                                    r.report({
                                        node: n,
                                        messageId: s ? "importNameWithCustomMessage" : "importName",
                                        loc: t.loc,
                                        data: {
                                            importSource: e1,
                                            customMessage: s,
                                            importName: i
                                        }
                                    });
                                });
                            });
                        } else r.report({
                            node: n,
                            messageId: s ? "pathWithCustomMessage" : "path",
                            data: {
                                importSource: e1,
                                customMessage: s
                            }
                        });
                    }(s, i, t), l.forEach((e1)=>{
                        (function(e1, t) {
                            return t.matcher.ignores(e1);
                        })(s, e1) && function(e1, t, n) {
                            const s = e1.source.value.trim(), i = t.customMessage, o = t.importNames, a = t.importNamePattern ? new RegExp(t.importNamePattern, "u") : null;
                            o || a ? n.forEach((t, n)=>{
                                if ("*" !== n) (o && o.includes(n) || a && a.test(n)) && t.forEach((t)=>{
                                    r.report({
                                        node: e1,
                                        messageId: i ? "patternAndImportNameWithCustomMessage" : "patternAndImportName",
                                        loc: t.loc,
                                        data: {
                                            importSource: s,
                                            customMessage: i,
                                            importName: n
                                        }
                                    });
                                });
                                else {
                                    const [n] = t;
                                    o ? r.report({
                                        node: e1,
                                        messageId: i ? "patternAndEverythingWithCustomMessage" : "patternAndEverything",
                                        loc: n.loc,
                                        data: {
                                            importSource: s,
                                            importNames: o,
                                            customMessage: i
                                        }
                                    }) : r.report({
                                        node: e1,
                                        messageId: i ? "patternAndEverythingWithRegexImportNameAndCustomMessage" : "patternAndEverythingWithRegexImportName",
                                        loc: n.loc,
                                        data: {
                                            importSource: s,
                                            importNames: a,
                                            customMessage: i
                                        }
                                    });
                                }
                            }) : r.report({
                                node: e1,
                                messageId: i ? "patternWithCustomMessage" : "patterns",
                                data: {
                                    importSource: s,
                                    customMessage: i
                                }
                            });
                        }(t, e1, i);
                    });
                }
                return {
                    ImportDeclaration: c,
                    ExportNamedDeclaration (e1) {
                        e1.source && c(e1);
                    },
                    ExportAllDeclaration: c
                };
            }
        }, uy;
    }
    function aS() {
        if (py) return cy;
        py = 1;
        const e1 = Ll(), t = iS(), r = {
            type: "array",
            items: {
                anyOf: [
                    {
                        type: "string"
                    },
                    {
                        type: "object",
                        properties: {
                            name: {
                                type: "string"
                            },
                            message: {
                                type: "string",
                                minLength: 1
                            }
                        },
                        additionalProperties: !1,
                        required: [
                            "name"
                        ]
                    }
                ]
            },
            uniqueItems: !0
        };
        return cy = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "suggestion",
                docs: {
                    description: "Disallow specified modules when loaded by `require`",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-restricted-modules"
                },
                schema: {
                    anyOf: [
                        r,
                        {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    paths: r,
                                    patterns: {
                                        type: "array",
                                        items: {
                                            type: "string"
                                        },
                                        uniqueItems: !0
                                    }
                                },
                                additionalProperties: !1
                            },
                            additionalItems: !1
                        }
                    ]
                },
                messages: {
                    defaultMessage: "'{{name}}' module is restricted from being used.",
                    customMessage: "'{{name}}' module is restricted from being used. {{customMessage}}",
                    patternMessage: "'{{name}}' module is restricted from being used by a pattern."
                }
            },
            create (r) {
                const n = Array.isArray(r.options) ? r.options : [], s = "object" == typeof n[0] && (Object.prototype.hasOwnProperty.call(n[0], "paths") || Object.prototype.hasOwnProperty.call(n[0], "patterns")), i = (s ? n[0].paths : r.options) || [], o = (s ? n[0].patterns : []) || [], a = i.reduce((e1, t)=>("string" == typeof t ? e1[t] = null : e1[t.name] = t.message, e1), {});
                if (0 === Object.keys(i).length && 0 === o.length) return {};
                const u = t({
                    allowRelativePaths: !0
                }).add(o);
                return {
                    CallExpression (t) {
                        if (function(e1) {
                            return "Identifier" === e1.callee.type && "require" === e1.callee.name;
                        }(t) && t.arguments.length) {
                            const n = function(t) {
                                return function(e1) {
                                    return e1 && "Literal" === e1.type && "string" == typeof e1.value;
                                }(t) ? t.value.trim() : e1.isStaticTemplateLiteral(t) ? t.quasis[0].value.cooked.trim() : null;
                            }(t.arguments[0]);
                            n && (function(e1) {
                                return Object.prototype.hasOwnProperty.call(a, e1);
                            }(n) && function(e1, t) {
                                const n = a[t], s = n ? "customMessage" : "defaultMessage";
                                r.report({
                                    node: e1,
                                    messageId: s,
                                    data: {
                                        name: t,
                                        customMessage: n
                                    }
                                });
                            }(t, n), o.length > 0 && u.ignores(n) && r.report({
                                node: t,
                                messageId: "patternMessage",
                                data: {
                                    name: n
                                }
                            }));
                        }
                    }
                };
            }
        }, cy;
    }
    function uS() {
        if (xy) return Ey;
        xy = 1;
        const e1 = Ll();
        return Ey = {
            meta: {
                hasSuggestions: !0,
                type: "suggestion",
                docs: {
                    description: "Disallow unnecessary `return await`",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-return-await"
                },
                fixable: null,
                deprecated: !0,
                replacedBy: [],
                schema: [],
                messages: {
                    removeAwait: "Remove redundant `await`.",
                    redundantUseOfAwait: "Redundant use of `await` on a return value."
                }
            },
            create (t) {
                function r(t) {
                    let r = t;
                    for(; !e1.isFunction(r) && "Program" !== r.type;){
                        if ("TryStatement" === r.parent.type && (r === r.parent.block || r === r.parent.handler && r.parent.finalizer)) return !0;
                        r = r.parent;
                    }
                    return !1;
                }
                function n(e1) {
                    return "ArrowFunctionExpression" === e1.parent.type || ("ReturnStatement" === e1.parent.type ? !r(e1.parent) : "ConditionalExpression" !== e1.parent.type || e1 !== e1.parent.consequent && e1 !== e1.parent.alternate ? ("LogicalExpression" === e1.parent.type && e1 === e1.parent.right || "SequenceExpression" === e1.parent.type && e1 === e1.parent.expressions[e1.parent.expressions.length - 1]) && n(e1.parent) : n(e1.parent));
                }
                return {
                    AwaitExpression (e1) {
                        n(e1) && !r(e1) && function(e1) {
                            t.report({
                                node: t.sourceCode.getFirstToken(e1),
                                loc: e1.loc,
                                messageId: "redundantUseOfAwait",
                                suggest: [
                                    {
                                        messageId: "removeAwait",
                                        fix (r) {
                                            const n = t.sourceCode, [s, i] = n.getFirstTokens(e1, 2);
                                            if (s.loc.start.line !== i.loc.start.line) return null;
                                            const [o, a] = s.range, u = [
                                                o,
                                                a + (" " === n.text[a] ? 1 : 0)
                                            ];
                                            return r.removeRange(u);
                                        }
                                    }
                                ]
                            });
                        }(e1);
                    }
                };
            }
        }, Ey;
    }
    function lS() {
        if (vy) return by;
        vy = 1;
        const e1 = Ll(), t = /\s+/gu;
        function r(t, n, s, i) {
            if (t && n) {
                if ("Identifier" === t.type && "Identifier" === n.type && t.name === n.name) i(n);
                else if ("ArrayPattern" === t.type && "ArrayExpression" === n.type) {
                    const e1 = Math.min(t.elements.length, n.elements.length);
                    for(let o = 0; o < e1; ++o){
                        const e1 = t.elements[o], a = n.elements[o];
                        if (e1 && "RestElement" === e1.type && o < n.elements.length - 1) break;
                        if (r(e1, a, s, i), a && "SpreadElement" === a.type) break;
                    }
                } else if ("RestElement" === t.type && "SpreadElement" === n.type) r(t.argument, n.argument, s, i);
                else if ("ObjectPattern" === t.type && "ObjectExpression" === n.type && n.properties.length >= 1) {
                    let e1 = 0;
                    for(let t = n.properties.length - 1; t >= 0; --t){
                        const r = n.properties[t].type;
                        if ("SpreadElement" === r || "ExperimentalSpreadProperty" === r) {
                            e1 = t + 1;
                            break;
                        }
                    }
                    for(let o = 0; o < t.properties.length; ++o)for(let a = e1; a < n.properties.length; ++a)r(t.properties[o], n.properties[a], s, i);
                } else if ("Property" !== t.type || "Property" !== n.type || "init" !== n.kind || n.method) s && "MemberExpression" === e1.skipChainExpression(t).type && "MemberExpression" === e1.skipChainExpression(n).type && e1.isSameReference(t, n) && i(n);
                else {
                    const o = e1.getStaticPropertyName(t);
                    null !== o && o === e1.getStaticPropertyName(n) && r(t.value, n.value, s, i);
                }
            } else ;
        }
        return by = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow assignments where both sides are exactly the same",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-self-assign"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            props: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    selfAssignment: "'{{name}}' is assigned to itself."
                }
            },
            create (e1) {
                const n = e1.sourceCode, [{ props: s = !0 } = {}] = e1.options;
                function i(r) {
                    e1.report({
                        node: r,
                        messageId: "selfAssignment",
                        data: {
                            name: n.getText(r).replace(t, "")
                        }
                    });
                }
                return {
                    AssignmentExpression (e1) {
                        [
                            "=",
                            "&&=",
                            "||=",
                            "??="
                        ].includes(e1.operator) && r(e1.left, e1.right, s, i);
                    }
                };
            }
        }, by;
    }
    function cS() {
        return Ty || (Ty = 1, Ay = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow comparisons where both sides are exactly the same",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-self-compare"
                },
                schema: [],
                messages: {
                    comparingToSelf: "Comparing to itself is potentially pointless."
                }
            },
            create (e1) {
                const t = e1.sourceCode;
                return {
                    BinaryExpression (r) {
                        new Set([
                            "===",
                            "==",
                            "!==",
                            "!=",
                            ">",
                            "<",
                            ">=",
                            "<="
                        ]).has(r.operator) && function(e1, r) {
                            const n = t.getTokens(e1), s = t.getTokens(r);
                            return n.length === s.length && n.every((e1, t)=>e1.type === s[t].type && e1.value === s[t].value);
                        }(r.left, r.right) && e1.report({
                            node: r,
                            messageId: "comparingToSelf"
                        });
                    }
                };
            }
        }), Ay;
    }
    function pS() {
        if (Dy) return Ry;
        Dy = 1;
        const e1 = Ll(), t = {
            allowInParentheses: !0
        };
        return Ry = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow comma operators",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-sequences"
                },
                schema: [
                    {
                        properties: {
                            allowInParentheses: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unexpectedCommaExpression: "Unexpected use of comma operator."
                }
            },
            create (r) {
                const n = Object.assign({}, t, r.options[0]), s = r.sourceCode, i = {
                    DoWhileStatement: "test",
                    IfStatement: "test",
                    SwitchStatement: "discriminant",
                    WhileStatement: "test",
                    WithStatement: "object",
                    ArrowFunctionExpression: "body"
                };
                function o(t) {
                    return e1.isParenthesised(s, t);
                }
                return {
                    SequenceExpression (t) {
                        if ("ForStatement" === t.parent.type && (t === t.parent.init || t === t.parent.update)) return;
                        if (n.allowInParentheses) {
                            if (function(e1) {
                                return e1.parent && i[e1.parent.type] && e1 === e1.parent[i[e1.parent.type]];
                            }(t)) {
                                if (function(t) {
                                    const r = s.getTokenBefore(t, 1), n = s.getTokenAfter(t, 1);
                                    return o(t) && r && n && e1.isOpeningParenToken(r) && r.range[1] <= t.range[0] && e1.isClosingParenToken(n) && n.range[0] >= t.range[1];
                                }(t)) return;
                            } else if (o(t)) return;
                        }
                        const a = s.getTokenAfter(t.expressions[0], e1.isCommaToken);
                        r.report({
                            node: t,
                            loc: a.loc,
                            messageId: "unexpectedCommaExpression"
                        });
                    }
                };
            }
        }, Ry;
    }
    function fS() {
        if (_y) return wy;
        _y = 1;
        const e1 = Ll(), { findVariable: t } = Hi();
        function r(r, n, s, i, o) {
            const a = r.parent;
            return "CallExpression" === a.type && a.arguments[o] === r && e1.isSpecificMemberAccess(a.callee, s, i) && function(e1, r) {
                const n = t(r, e1);
                return null !== n && "global" === n.scope.type && 0 === n.defs.length;
            }(e1.skipChainExpression(a.callee).object, n);
        }
        function n(t, n) {
            const s = t.parent;
            return ("Property" === s.type || "MethodDefinition" === s.type) && "set" === s.kind && s.value === t || !("Property" !== s.type || s.value !== t || "set" !== e1.getStaticPropertyName(s) || "ObjectExpression" !== s.parent.type || !function(e1, t) {
                if (r(e1, t, "Object", "defineProperty", 2) || r(e1, t, "Reflect", "defineProperty", 2)) return !0;
                const n = e1.parent;
                if ("Property" === n.type && n.value === e1) {
                    const e1 = n.parent;
                    if ("ObjectExpression" === e1.type && (r(e1, t, "Object", "create", 1) || r(e1, t, "Object", "defineProperties", 1))) return !0;
                }
                return !1;
            }(s.parent, n));
        }
        return wy = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow returning values from setters",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-setter-return"
                },
                schema: [],
                messages: {
                    returnsValue: "Setter cannot return a value."
                }
            },
            create (e1) {
                let t = null;
                const r = e1.sourceCode;
                function s(e1) {
                    const s = function(e1) {
                        const t = e1.upper;
                        return "function-expression-name" === t.type ? t.upper : t;
                    }(r.getScope(e1));
                    t = {
                        upper: t,
                        isSetter: n(e1, s)
                    };
                }
                function i() {
                    t = t.upper;
                }
                function o(t) {
                    e1.report({
                        node: t,
                        messageId: "returnsValue"
                    });
                }
                return {
                    FunctionDeclaration: s,
                    FunctionExpression: s,
                    ArrowFunctionExpression (e1) {
                        s(e1), t.isSetter && e1.expression && o(e1.body);
                    },
                    "FunctionDeclaration:exit": i,
                    "FunctionExpression:exit": i,
                    "ArrowFunctionExpression:exit": i,
                    ReturnStatement (e1) {
                        t && t.isSetter && e1.argument && o(e1);
                    }
                };
            }
        }, wy;
    }
    function dS() {
        if (Xy) return Wy;
        Xy = 1;
        const e1 = Ll();
        return Wy = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow `this`/`super` before calling `super()` in constructors",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-this-before-super"
                },
                schema: [],
                messages: {
                    noBeforeSuper: "'{{kind}}' is not allowed before 'super()'."
                }
            },
            create (t) {
                let r = null, n = Object.create(null);
                function s(e1) {
                    return !e1.reachable || n[e1.id].superCalled;
                }
                function i() {
                    return Boolean(r && r.isConstructor && r.hasExtends);
                }
                function o() {
                    return i() && !function(e1) {
                        for (const t of e1)if (!s(t)) return !1;
                        return !0;
                    }(r.currentSegments);
                }
                function a(e1) {
                    const t = r.currentSegments;
                    for (const r of t)r.reachable && n[r.id].invalidNodes.push(e1);
                }
                return {
                    onCodePathStart (t, n) {
                        if (function(e1) {
                            return "FunctionExpression" === e1.type && "MethodDefinition" === e1.parent.type && "constructor" === e1.parent.kind;
                        }(n)) {
                            const s = n.parent.parent.parent;
                            r = {
                                upper: r,
                                isConstructor: !0,
                                hasExtends: Boolean(s.superClass && !e1.isNullOrUndefined(s.superClass)),
                                codePath: t,
                                currentSegments: new Set
                            };
                        } else r = {
                            upper: r,
                            isConstructor: !1,
                            hasExtends: !1,
                            codePath: t,
                            currentSegments: new Set
                        };
                    },
                    onCodePathEnd (e1) {
                        const s = r.hasExtends;
                        r = r.upper, s && e1.traverseSegments((e1, r)=>{
                            const s = n[e1.id];
                            for(let e1 = 0; e1 < s.invalidNodes.length; ++e1){
                                const r = s.invalidNodes[e1];
                                t.report({
                                    messageId: "noBeforeSuper",
                                    node: r,
                                    data: {
                                        kind: "Super" === r.type ? "super" : "this"
                                    }
                                });
                            }
                            s.superCalled && r.skip();
                        });
                    },
                    onCodePathSegmentStart (e1) {
                        r.currentSegments.add(e1), i() && (n[e1.id] = {
                            superCalled: e1.prevSegments.length > 0 && e1.prevSegments.every(s),
                            invalidNodes: []
                        });
                    },
                    onUnreachableCodePathSegmentStart (e1) {
                        r.currentSegments.add(e1);
                    },
                    onUnreachableCodePathSegmentEnd (e1) {
                        r.currentSegments.delete(e1);
                    },
                    onCodePathSegmentEnd (e1) {
                        r.currentSegments.delete(e1);
                    },
                    onCodePathSegmentLoop (e1, t) {
                        i() && r.codePath.traverseSegments({
                            first: t,
                            last: e1
                        }, (e1, t)=>{
                            const r = n[e1.id];
                            r.superCalled ? (r.invalidNodes = [], t.skip()) : e1.prevSegments.length > 0 && e1.prevSegments.every(s) && (r.superCalled = !0, r.invalidNodes = []);
                        });
                    },
                    ThisExpression (e1) {
                        o() && a(e1);
                    },
                    Super (t) {
                        !e1.isCallee(t) && o() && a(t);
                    },
                    "CallExpression:exit" (e1) {
                        "Super" === e1.callee.type && o() && function() {
                            const e1 = r.currentSegments;
                            for (const t of e1)t.reachable && (n[t.id].superCalled = !0);
                        }();
                    },
                    "Program:exit" () {
                        n = Object.create(null);
                    }
                };
            }
        }, Wy;
    }
    function hS() {
        if (Qy) return Jy;
        Qy = 1;
        const e1 = Ll();
        return Jy = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Disallow trailing whitespace at the end of lines",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-trailing-spaces"
                },
                fixable: "whitespace",
                schema: [
                    {
                        type: "object",
                        properties: {
                            skipBlankLines: {
                                type: "boolean",
                                default: !1
                            },
                            ignoreComments: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    trailingSpace: "Trailing spaces not allowed."
                }
            },
            create (t) {
                const r = t.sourceCode, n = "[ 	\xa0\u2000-\u200B\u3000]", s = `^${n}*$`, i = `${n}+$`, o = t.options[0] || {}, a = o.skipBlankLines || !1, u = o.ignoreComments || !1;
                function l(e1, r, n) {
                    t.report({
                        node: e1,
                        loc: r,
                        messageId: "trailingSpace",
                        fix: (e1)=>e1.removeRange(n)
                    });
                }
                return {
                    Program: function(t) {
                        const n = new RegExp(i, "u"), o = new RegExp(s, "u"), c = r.lines, p = r.getText().match(e1.createGlobalLinebreakMatcher()), f = function(e1) {
                            const t = new Set;
                            return e1.forEach((e1)=>{
                                const r = "Block" === e1.type ? e1.loc.end.line - 1 : e1.loc.end.line;
                                for(let n = e1.loc.start.line; n <= r; n++)t.add(n);
                            }), t;
                        }(r.getAllComments());
                        let d = 0, h = [];
                        for(let e1 = 0, s = c.length; e1 < s; e1++){
                            const s = e1 + 1, i = p && p[e1] ? p[e1].length : 1, m = c[e1].length + i, g = n.exec(c[e1]);
                            if (g) {
                                const n = {
                                    start: {
                                        line: s,
                                        column: g.index
                                    },
                                    end: {
                                        line: s,
                                        column: m - i
                                    }
                                }, p = d + n.start.column, y = d + n.end.column, E = r.getNodeByRangeIndex(p);
                                if (E && "TemplateElement" === E.type && p > E.parent.range[0] && y < E.parent.range[1]) {
                                    d += m;
                                    continue;
                                }
                                if (a && o.test(c[e1])) {
                                    d += m;
                                    continue;
                                }
                                h = [
                                    p,
                                    y
                                ], u && f.has(s) || l(t, n, h);
                            }
                            d += m;
                        }
                    }
                };
            }
        }, Jy;
    }
    function mS() {
        return iE || (iE = 1, sE = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow dangling underscores in identifiers",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-underscore-dangle"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            allow: {
                                type: "array",
                                items: {
                                    type: "string"
                                }
                            },
                            allowAfterThis: {
                                type: "boolean",
                                default: !1
                            },
                            allowAfterSuper: {
                                type: "boolean",
                                default: !1
                            },
                            allowAfterThisConstructor: {
                                type: "boolean",
                                default: !1
                            },
                            enforceInMethodNames: {
                                type: "boolean",
                                default: !1
                            },
                            allowFunctionParams: {
                                type: "boolean",
                                default: !0
                            },
                            enforceInClassFields: {
                                type: "boolean",
                                default: !1
                            },
                            allowInArrayDestructuring: {
                                type: "boolean",
                                default: !0
                            },
                            allowInObjectDestructuring: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unexpectedUnderscore: "Unexpected dangling '_' in '{{identifier}}'."
                }
            },
            create (e1) {
                const t = e1.options[0] || {}, r = t.allow ? t.allow : [], n = void 0 !== t.allowAfterThis && t.allowAfterThis, s = void 0 !== t.allowAfterSuper && t.allowAfterSuper, i = void 0 !== t.allowAfterThisConstructor && t.allowAfterThisConstructor, o = void 0 !== t.enforceInMethodNames && t.enforceInMethodNames, a = void 0 !== t.enforceInClassFields && t.enforceInClassFields, u = void 0 === t.allowFunctionParams || t.allowFunctionParams, l = void 0 === t.allowInArrayDestructuring || t.allowInArrayDestructuring, c = void 0 === t.allowInObjectDestructuring || t.allowInObjectDestructuring, p = e1.sourceCode;
                function f(e1) {
                    return r.includes(e1);
                }
                function d(e1) {
                    const t = e1.length;
                    return "_" !== e1 && ("_" === e1[0] || "_" === e1[t - 1]);
                }
                function h(t) {
                    if ("FunctionDeclaration" === t.type && t.id) {
                        const r = t.id.name;
                        void 0 !== r && d(r) && !f(r) && e1.report({
                            node: t,
                            messageId: "unexpectedUnderscore",
                            data: {
                                identifier: r
                            }
                        });
                    }
                    !function(t) {
                        u || t.params.forEach((t)=>{
                            const { type: r } = t;
                            let n;
                            if (n = "RestElement" === r ? t.argument : "AssignmentPattern" === r ? t.left : t, "Identifier" === n.type) {
                                const r = n.name;
                                d(r) && !f(r) && e1.report({
                                    node: t,
                                    messageId: "unexpectedUnderscore",
                                    data: {
                                        identifier: r
                                    }
                                });
                            }
                        });
                    }(t);
                }
                function m(t) {
                    const r = t.key.name, n = "MethodDefinition" === t.type || "Property" === t.type && t.method;
                    void 0 !== r && o && n && d(r) && !f(r) && e1.report({
                        node: t,
                        messageId: "unexpectedUnderscore",
                        data: {
                            identifier: "PrivateIdentifier" === t.key.type ? `#${r}` : r
                        }
                    });
                }
                return {
                    FunctionDeclaration: h,
                    VariableDeclarator: function(t) {
                        p.getDeclaredVariables(t).forEach((r)=>{
                            const n = r.defs.find((e1)=>e1.node === t).name, s = n.name;
                            let i = n.parent;
                            for(; ![
                                "VariableDeclarator",
                                "ArrayPattern",
                                "ObjectPattern"
                            ].includes(i.type);)i = i.parent;
                            !d(s) || function(e1) {
                                return "_" === e1;
                            }(s) || f(s) || l && "ArrayPattern" === i.type || c && "ObjectPattern" === i.type || e1.report({
                                node: t,
                                messageId: "unexpectedUnderscore",
                                data: {
                                    identifier: s
                                }
                            });
                        });
                    },
                    MemberExpression: function(t) {
                        const r = t.property.name, o = "ThisExpression" === t.object.type, a = "Super" === t.object.type, u = function(e1) {
                            return "MemberExpression" === e1.object.type && "constructor" === e1.object.property.name && "ThisExpression" === e1.object.object.type;
                        }(t);
                        void 0 === r || !d(r) || o && n || a && s || u && i || function(e1) {
                            return "__proto__" === e1;
                        }(r) || f(r) || e1.report({
                            node: t,
                            messageId: "unexpectedUnderscore",
                            data: {
                                identifier: r
                            }
                        });
                    },
                    MethodDefinition: m,
                    PropertyDefinition: function(t) {
                        const r = t.key.name;
                        void 0 !== r && d(r) && a && !f(r) && e1.report({
                            node: t,
                            messageId: "unexpectedUnderscore",
                            data: {
                                identifier: "PrivateIdentifier" === t.key.type ? `#${r}` : r
                            }
                        });
                    },
                    Property: m,
                    FunctionExpression: h,
                    ArrowFunctionExpression: h
                };
            }
        }), sE;
    }
    function gS() {
        if (lE) return uE;
        lE = 1;
        const e1 = Wi(), t = Ll(), r = /(?:(?:Call|Class|Function|Member|New|Yield)Expression|Statement|Declaration)$/u, n = /^(?:DoWhile|For|While)Statement$/u, s = /^(?:BinaryExpression|ConditionalExpression)$/u, i = /^(?:ArrowFunction|Class|Function)Expression$/u, o = /^(?:Call|Member|New|TaggedTemplate|Yield)Expression$/u;
        function a(e1) {
            if (e1.init) {
                const t = e1.resolved && e1.resolved.defs[0];
                if (!t || "Variable" !== t.type || "var" !== t.parent.kind) return !1;
            }
            return e1.isWrite();
        }
        function u(e1) {
            return !e1.modified;
        }
        function l(e1) {
            return !(e1.modified || e1.group);
        }
        function c(e1, t) {
            const r = e1.range, n = t.identifier.range;
            return r[0] <= n[0] && n[1] <= r[1];
        }
        const p = {
            WhileStatement: c,
            DoWhileStatement: c,
            ForStatement: (e1, t)=>c(e1, t) && !(e1.init && c(e1.init, t))
        };
        function f(e1) {
            let t = e1.identifier;
            for(; t;){
                if ("FunctionDeclaration" === t.type) return t.id ? t : null;
                t = t.parent;
            }
            return null;
        }
        return uE = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow unmodified loop conditions",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-unmodified-loop-condition"
                },
                schema: [],
                messages: {
                    loopConditionNotModified: "'{{name}}' is not modified in this loop."
                }
            },
            create (c) {
                const d = c.sourceCode;
                let h = null;
                function m(e1) {
                    const t = e1.reference.identifier;
                    c.report({
                        node: t,
                        messageId: "loopConditionNotModified",
                        data: t
                    });
                }
                function g(e1) {
                    e1.every(u) && e1.forEach(m);
                }
                function y(t) {
                    let r = !1;
                    return e1.traverse(t, {
                        visitorKeys: d.visitorKeys,
                        enter (e1) {
                            o.test(e1.type) ? (r = !0, this.break()) : i.test(e1.type) && this.skip();
                        }
                    }), r;
                }
                function E(e1) {
                    if (e1.init) return null;
                    let t = null, i = e1.identifier, o = i.parent;
                    for(; o;){
                        if (r.test(o.type)) {
                            if (n.test(o.type) && o.test === i) return {
                                reference: e1,
                                group: t,
                                isInLoop: p[o.type].bind(null, o),
                                modified: !1
                            };
                            break;
                        }
                        if (s.test(o.type)) {
                            if (y(o)) break;
                            t = o;
                        }
                        i = o, o = o.parent;
                    }
                    return null;
                }
                function x(e1) {
                    const r = e1.references.map(E).filter(Boolean);
                    if (0 === r.length) return;
                    !function(e1) {
                        for(let t = 0; t < e1.length; ++t){
                            const r = e1[t];
                            if (r.group) {
                                let e1 = h.get(r.group);
                                e1 || (e1 = [], h.set(r.group, e1)), e1.push(r);
                            }
                        }
                    }(r);
                    const n = e1.references.filter(a);
                    n.length > 0 && function(e1, r) {
                        for(let n = 0; n < e1.length; ++n){
                            const s = e1[n];
                            for(let e1 = 0; !s.modified && e1 < r.length; ++e1){
                                const n = r[e1];
                                let i, o;
                                const a = s.isInLoop(n) || Boolean((i = f(n)) && (o = t.getVariableByName(n.from.upper, i.id.name)) && o.references.some(s.isInLoop));
                                s.modified = a;
                            }
                        }
                    }(r, n), r.filter(l).forEach(m);
                }
                return {
                    "Program:exit" (e1) {
                        const t = [
                            d.getScope(e1)
                        ];
                        let r;
                        for(h = new Map; r = t.pop();)t.push(...r.childScopes), r.variables.forEach(x);
                        h.forEach(g), h = null;
                    }
                };
            }
        }, uE;
    }
    function yS() {
        if (pE) return cE;
        pE = 1;
        const e1 = Ll(), t = new Set([
            "==",
            "===",
            "!=",
            "!==",
            ">",
            ">=",
            "<",
            "<=",
            "in",
            "instanceof"
        ]), r = {
            "==": "!=",
            "!=": "==",
            "===": "!==",
            "!==": "==="
        }, n = e1.getPrecedence({
            type: "LogicalExpression",
            operator: "||"
        });
        return cE = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow ternary operators when simpler alternatives exist",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-unneeded-ternary"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            defaultAssignment: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                fixable: "code",
                messages: {
                    unnecessaryConditionalExpression: "Unnecessary use of boolean literals in conditional expression.",
                    unnecessaryConditionalAssignment: "Unnecessary use of conditional expression for default assignment."
                }
            },
            create (s) {
                const i = !1 !== (s.options[0] || {}).defaultAssignment, o = s.sourceCode;
                function a(e1) {
                    return "Literal" === e1.type && "boolean" == typeof e1.value;
                }
                function u(t) {
                    if ("BinaryExpression" === t.type && Object.prototype.hasOwnProperty.call(r, t.operator)) {
                        const e1 = o.getFirstTokenBetween(t.left, t.right, (e1)=>e1.value === t.operator), n = o.getText();
                        return n.slice(t.range[0], e1.range[0]) + r[t.operator] + n.slice(e1.range[1], t.range[1]);
                    }
                    return e1.getPrecedence(t) < e1.getPrecedence({
                        type: "UnaryExpression"
                    }) ? `!(${e1.getParenthesisedText(o, t)})` : `!${e1.getParenthesisedText(o, t)}`;
                }
                return {
                    ConditionalExpression (r) {
                        a(r.alternate) && a(r.consequent) ? s.report({
                            node: r,
                            messageId: "unnecessaryConditionalExpression",
                            fix: (n)=>r.consequent.value === r.alternate.value ? "Identifier" === r.test.type ? n.replaceText(r, r.consequent.value.toString()) : null : r.alternate.value ? n.replaceText(r, u(r.test)) : n.replaceText(r, function(e1) {
                                    return "BinaryExpression" === e1.type && t.has(e1.operator) || "UnaryExpression" === e1.type && "!" === e1.operator;
                                }(r.test) ? e1.getParenthesisedText(o, r.test) : `!${u(r.test)}`)
                        }) : !i && function(e1) {
                            return "Identifier" === e1.test.type && "Identifier" === e1.consequent.type && e1.test.name === e1.consequent.name;
                        }(r) && s.report({
                            node: r,
                            messageId: "unnecessaryConditionalAssignment",
                            fix (t) {
                                const s = (e1.getPrecedence(r.alternate) < n || e1.isCoalesceExpression(r.alternate)) && !e1.isParenthesised(o, r.alternate) ? `(${o.getText(r.alternate)})` : e1.getParenthesisedText(o, r.alternate), i = e1.getParenthesisedText(o, r.test);
                                return t.replaceText(r, `${i} || ${s}`);
                            }
                        });
                    }
                };
            }
        }, cE;
    }
    function ES() {
        if (yE) return gE;
        yE = 1;
        const e1 = /^(?:Program|(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression)$/u, t = /^(?:Program|(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression|DoWhileStatement|WhileStatement|ForOfStatement|ForInStatement|ForStatement|SwitchStatement)$/u, r = /^(?:Program|(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression|DoWhileStatement|WhileStatement|ForOfStatement|ForInStatement|ForStatement)$/u;
        return gE = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow control flow statements in `finally` blocks",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-unsafe-finally"
                },
                schema: [],
                messages: {
                    unsafeUsage: "Unsafe usage of {{nodeType}}."
                }
            },
            create (n) {
                function s(e1) {
                    return "TryStatement" === e1.parent.type && e1.parent.finalizer === e1;
                }
                function i(i) {
                    (function(n, i) {
                        let o, a = !1;
                        o = "BreakStatement" !== n.type || n.label ? "ContinueStatement" === n.type ? r : e1 : t;
                        for(let e1 = n; e1 && !o.test(e1.type); e1 = e1.parent)if (e1.parent.label && i && e1.parent.label.name === i.name && (a = !0), s(e1)) return !i || !a;
                        return !1;
                    })(i, i.label) && n.report({
                        messageId: "unsafeUsage",
                        data: {
                            nodeType: i.type
                        },
                        node: i,
                        line: i.loc.line,
                        column: i.loc.column
                    });
                }
                return {
                    ReturnStatement: i,
                    ThrowStatement: i,
                    BreakStatement: i,
                    ContinueStatement: i
                };
            }
        }, gE;
    }
    function xS() {
        if (vE) return bE;
        vE = 1;
        const e1 = Ll();
        function t() {
            return !0;
        }
        function r() {
            return !1;
        }
        return bE = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow unused expressions",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-unused-expressions"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            allowShortCircuit: {
                                type: "boolean",
                                default: !1
                            },
                            allowTernary: {
                                type: "boolean",
                                default: !1
                            },
                            allowTaggedTemplates: {
                                type: "boolean",
                                default: !1
                            },
                            enforceForJSX: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unusedExpression: "Expected an assignment or function call and instead saw an expression."
                }
            },
            create (n) {
                const s = n.options[0] || {}, i = s.allowShortCircuit || !1, o = s.allowTernary || !1, a = s.allowTaggedTemplates || !1, u = s.enforceForJSX || !1;
                function l(e1) {
                    return "ExpressionStatement" === e1.type && "Literal" === e1.expression.type && "string" == typeof e1.expression.value;
                }
                function c(t) {
                    return e1.isTopLevelExpressionStatement(t) && (function(e1) {
                        return function(e1, t) {
                            for(let r = 0; r < t.length; ++r)if (!e1(t[r])) return t.slice(0, r);
                            return t.slice();
                        }(l, e1.body);
                    })(t.parent).includes(t);
                }
                const p = Object.assign(Object.create(null), {
                    isDisallowed: (e1)=>(p[e1.type] || r)(e1),
                    ArrayExpression: t,
                    ArrowFunctionExpression: t,
                    BinaryExpression: t,
                    ChainExpression: (e1)=>p.isDisallowed(e1.expression),
                    ClassExpression: t,
                    ConditionalExpression: (e1)=>!o || p.isDisallowed(e1.consequent) || p.isDisallowed(e1.alternate),
                    FunctionExpression: t,
                    Identifier: t,
                    JSXElement: ()=>u,
                    JSXFragment: ()=>u,
                    Literal: t,
                    LogicalExpression: (e1)=>!i || p.isDisallowed(e1.right),
                    MemberExpression: t,
                    MetaProperty: t,
                    ObjectExpression: t,
                    SequenceExpression: t,
                    TaggedTemplateExpression: ()=>!a,
                    TemplateLiteral: t,
                    ThisExpression: t,
                    UnaryExpression: (e1)=>"void" !== e1.operator && "delete" !== e1.operator
                });
                return {
                    ExpressionStatement (e1) {
                        p.isDisallowed(e1.expression) && !c(e1) && n.report({
                            node: e1,
                            messageId: "unusedExpression"
                        });
                    }
                };
            }
        }, bE;
    }
    function CS() {
        if (_E) return wE;
        _E = 1;
        const e1 = Ll();
        return wE = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow unused variables",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-unused-vars"
                },
                schema: [
                    {
                        oneOf: [
                            {
                                enum: [
                                    "all",
                                    "local"
                                ]
                            },
                            {
                                type: "object",
                                properties: {
                                    vars: {
                                        enum: [
                                            "all",
                                            "local"
                                        ]
                                    },
                                    varsIgnorePattern: {
                                        type: "string"
                                    },
                                    args: {
                                        enum: [
                                            "all",
                                            "after-used",
                                            "none"
                                        ]
                                    },
                                    ignoreRestSiblings: {
                                        type: "boolean"
                                    },
                                    argsIgnorePattern: {
                                        type: "string"
                                    },
                                    caughtErrors: {
                                        enum: [
                                            "all",
                                            "none"
                                        ]
                                    },
                                    caughtErrorsIgnorePattern: {
                                        type: "string"
                                    },
                                    destructuredArrayIgnorePattern: {
                                        type: "string"
                                    }
                                },
                                additionalProperties: !1
                            }
                        ]
                    }
                ],
                messages: {
                    unusedVar: "'{{varName}}' is {{action}} but never used{{additional}}."
                }
            },
            create (t) {
                const r = t.sourceCode, n = /^(?:RestElement|(?:Experimental)?RestProperty)$/u, s = {
                    vars: "all",
                    args: "after-used",
                    ignoreRestSiblings: !1,
                    caughtErrors: "none"
                }, i = t.options[0];
                function o(e1) {
                    const t = e1.defs && e1.defs[0] && e1.defs[0].type;
                    let r, n;
                    "CatchClause" === t && s.caughtErrorsIgnorePattern ? (r = "args", n = s.caughtErrorsIgnorePattern.toString()) : "Parameter" === t && s.argsIgnorePattern ? (r = "args", n = s.argsIgnorePattern.toString()) : "Parameter" !== t && s.varsIgnorePattern && (r = "vars", n = s.varsIgnorePattern.toString());
                    const i = r ? `. Allowed unused ${r} must match ${n}` : "";
                    return {
                        varName: e1.name,
                        action: "defined",
                        additional: i
                    };
                }
                function a(e1) {
                    const t = e1.defs[0];
                    let r = "";
                    return s.destructuredArrayIgnorePattern && t && "ArrayPattern" === t.name.parent.type ? r = `. Allowed unused elements of array destructuring patterns must match ${s.destructuredArrayIgnorePattern.toString()}` : s.varsIgnorePattern && (r = `. Allowed unused vars must match ${s.varsIgnorePattern.toString()}`), {
                        varName: e1.name,
                        action: "assigned a value",
                        additional: r
                    };
                }
                i && ("string" == typeof i ? s.vars = i : (s.vars = i.vars || s.vars, s.args = i.args || s.args, s.ignoreRestSiblings = i.ignoreRestSiblings || s.ignoreRestSiblings, s.caughtErrors = i.caughtErrors || s.caughtErrors, i.varsIgnorePattern && (s.varsIgnorePattern = new RegExp(i.varsIgnorePattern, "u")), i.argsIgnorePattern && (s.argsIgnorePattern = new RegExp(i.argsIgnorePattern, "u")), i.caughtErrorsIgnorePattern && (s.caughtErrorsIgnorePattern = new RegExp(i.caughtErrorsIgnorePattern, "u")), i.destructuredArrayIgnorePattern && (s.destructuredArrayIgnorePattern = new RegExp(i.destructuredArrayIgnorePattern, "u"))));
                const u = /(?:Statement|Declaration)$/u;
                function l(e1) {
                    const t = e1.defs[0];
                    if (t) {
                        let e1 = t.node;
                        if ("VariableDeclarator" === e1.type) e1 = e1.parent;
                        else if ("Parameter" === t.type) return !1;
                        return 0 === e1.parent.type.indexOf("Export");
                    }
                    return !1;
                }
                function c(e1) {
                    return "Property" === e1.type && "ObjectPattern" === e1.parent.type && n.test(e1.parent.properties[e1.parent.properties.length - 1].type);
                }
                function p(e1) {
                    if (s.ignoreRestSiblings) {
                        const t = e1.defs.some((e1)=>c(e1.name.parent)), r = e1.references.some((e1)=>c(e1.identifier.parent));
                        return t || r;
                    }
                    return !1;
                }
                function f(e1, t) {
                    return e1.range[0] >= t.range[0] && e1.range[1] <= t.range[1];
                }
                function d(e1) {
                    const t = e1.parent;
                    if ("ExpressionStatement" === t.type) return !0;
                    if ("SequenceExpression" === t.type) return !(t.expressions[t.expressions.length - 1] === e1) || d(t);
                    return !1;
                }
                function h(t, r) {
                    const n = e1.getUpperFunction(t);
                    return n && f(n, r) && function(e1, t) {
                        let r = e1, n = e1.parent;
                        for(; n && f(n, t);){
                            switch(n.type){
                                case "SequenceExpression":
                                    if (n.expressions[n.expressions.length - 1] !== r) return !1;
                                    break;
                                case "CallExpression":
                                case "NewExpression":
                                    return n.callee !== r;
                                case "AssignmentExpression":
                                case "TaggedTemplateExpression":
                                case "YieldExpression":
                                    return !0;
                                default:
                                    if (u.test(n.type)) return !0;
                            }
                            r = n, n = n.parent;
                        }
                        return !1;
                    }(n, r);
                }
                function m(t) {
                    const r = function(e1) {
                        const t = [];
                        return e1.defs.forEach((e1)=>{
                            const { type: r, node: n } = e1;
                            "FunctionName" === r && t.push(n), "Variable" !== r || !n.init || "FunctionExpression" !== n.init.type && "ArrowFunctionExpression" !== n.init.type || t.push(n.init);
                        }), t;
                    }(t), n = r.length > 0;
                    let s = null;
                    return t.references.some((t)=>{
                        if (function(e1) {
                            let t = e1.identifier.parent;
                            return "VariableDeclarator" === t.type && (t = t.parent.parent), ("ForInStatement" === t.type || "ForOfStatement" === t.type) && (t = "BlockStatement" === t.body.type ? t.body.body[0] : t.body, !!t && "ReturnStatement" === t.type);
                        }(t)) return !0;
                        const i = function(t, r) {
                            const n = t.identifier, s = n.parent;
                            return t.isRead() && ("AssignmentExpression" === s.type && s.left === n && d(s) && !e1.isLogicalAssignmentOperator(s.operator) || "UpdateExpression" === s.type && d(s) || r && f(n, r) && !h(n, r));
                        }(t, s);
                        return s = function(t, r) {
                            const n = t.identifier, s = n.parent, i = t.from.variableScope !== t.resolved.scope.variableScope || e1.isInLoop(n);
                            return r && f(n, r) ? r : "AssignmentExpression" === s.type && d(s) && n === s.left && !i ? s.right : null;
                        }(t, s), function(e1) {
                            return e1.isRead();
                        }(t) && !i && !(n && function(e1, t) {
                            let r = e1.from;
                            for(; r;){
                                if (t.includes(r.block)) return !0;
                                r = r.upper;
                            }
                            return !1;
                        }(t, r));
                    });
                }
                function g(e1) {
                    const t = e1.defs[0], n = r.getDeclaredVariables(t.node);
                    return !n.slice(n.indexOf(e1) + 1).some((e1)=>e1.references.length > 0 || e1.eslintUsed);
                }
                function y(t, r) {
                    const n = t.variables, i = t.childScopes;
                    let o, a;
                    if ("global" !== t.type || "all" === s.vars) for(o = 0, a = n.length; o < a; ++o){
                        const i = n[o];
                        if ("class" === t.type && t.block.id === i.identifiers[0]) continue;
                        if (t.functionExpressionScope || i.eslintUsed) continue;
                        if ("function" === t.type && "arguments" === i.name && 0 === i.identifiers.length) continue;
                        const a = i.defs[0];
                        if (a) {
                            const t = a.type, r = i.references.some((e1)=>"ArrayPattern" === e1.identifier.parent.type);
                            if (("ArrayPattern" === a.name.parent.type || r) && s.destructuredArrayIgnorePattern && s.destructuredArrayIgnorePattern.test(a.name.name)) continue;
                            if ("CatchClause" === t) {
                                if ("none" === s.caughtErrors) continue;
                                if (s.caughtErrorsIgnorePattern && s.caughtErrorsIgnorePattern.test(a.name.name)) continue;
                            }
                            if ("Parameter" === t) {
                                if (("Property" === a.node.parent.type || "MethodDefinition" === a.node.parent.type) && "set" === a.node.parent.kind) continue;
                                if ("none" === s.args) continue;
                                if (s.argsIgnorePattern && s.argsIgnorePattern.test(a.name.name)) continue;
                                if ("after-used" === s.args && e1.isFunction(a.name.parent) && !g(i)) continue;
                            } else if (s.varsIgnorePattern && s.varsIgnorePattern.test(a.name.name)) continue;
                        }
                        m(i) || l(i) || p(i) || r.push(i);
                    }
                    for(o = 0, a = i.length; o < a; ++o)y(i[o], r);
                    return r;
                }
                return {
                    "Program:exit" (n) {
                        const s = y(r.getScope(n), []);
                        for(let i = 0, u = s.length; i < u; ++i){
                            const u = s[i];
                            if (u.defs.length > 0) {
                                const e1 = u.references.filter((e1)=>e1.isWrite() && e1.from.variableScope === u.scope.variableScope);
                                let r;
                                e1.length > 0 && (r = e1[e1.length - 1]), t.report({
                                    node: r ? r.identifier : u.identifiers[0],
                                    messageId: "unusedVar",
                                    data: u.references.some((e1)=>e1.isWrite()) ? a(u) : o(u)
                                });
                            } else if (u.eslintExplicitGlobalComments) {
                                const s = u.eslintExplicitGlobalComments[0];
                                t.report({
                                    node: n,
                                    loc: e1.getNameLocationInGlobalDirectiveComment(r, s, u.name),
                                    messageId: "unusedVar",
                                    data: o(u)
                                });
                            }
                        }
                    }
                };
            }
        }, wE;
    }
    function SS() {
        if (BE) return kE;
        BE = 1;
        const e1 = /^(?:(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression|CatchClause|ImportDeclaration|ExportNamedDeclaration)$/u, t = /^For(?:In|Of)Statement$/u;
        function r(e1, t) {
            return e1 && e1.range[0] <= t && t <= e1.range[1];
        }
        function n(e1) {
            if ("class-static-block" === e1.type) return !0;
            if ("class-field-initializer" === e1.type) return e1.block.parent.static;
            return !1;
        }
        function s(e1) {
            const t = e1.resolved;
            let r = e1.from;
            for(; t.scope.variableScope !== r.variableScope;){
                if (!n(r.variableScope)) return !0;
                r = r.variableScope.upper;
            }
            return !1;
        }
        function i(n) {
            if (s(n)) return !1;
            const i = n.identifier.range[1], o = n.resolved.defs[0];
            if ("ClassName" === o.type) {
                const e1 = o.node;
                return r(e1, i) && !function(e1, t) {
                    return e1.body.some((e1)=>"StaticBlock" === e1.type && r(e1, t) || "PropertyDefinition" === e1.type && e1.static && e1.value && r(e1.value, t));
                }(e1.body, i);
            }
            let a = o.name.parent;
            for(; a;){
                if ("VariableDeclarator" === a.type) {
                    if (r(a.init, i)) return !0;
                    if (t.test(a.parent.parent.type) && r(a.parent.parent.right, i)) return !0;
                    break;
                }
                if ("AssignmentPattern" === a.type) {
                    if (r(a.right, i)) return !0;
                } else if (e1.test(a.type)) break;
                a = a.parent;
            }
            return !1;
        }
        return kE = {
            meta: {
                type: "problem",
                docs: {
                    description: "Disallow the use of variables before they are defined",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-use-before-define"
                },
                schema: [
                    {
                        oneOf: [
                            {
                                enum: [
                                    "nofunc"
                                ]
                            },
                            {
                                type: "object",
                                properties: {
                                    functions: {
                                        type: "boolean"
                                    },
                                    classes: {
                                        type: "boolean"
                                    },
                                    variables: {
                                        type: "boolean"
                                    },
                                    allowNamedExports: {
                                        type: "boolean"
                                    }
                                },
                                additionalProperties: !1
                            }
                        ]
                    }
                ],
                messages: {
                    usedBeforeDefined: "'{{name}}' was used before it was defined."
                }
            },
            create (e1) {
                const t = function(e1) {
                    let t = !0, r = !0, n = !0, s = !1;
                    return "string" == typeof e1 ? t = "nofunc" !== e1 : "object" == typeof e1 && null !== e1 && (t = !1 !== e1.functions, r = !1 !== e1.classes, n = !1 !== e1.variables, s = !!e1.allowNamedExports), {
                        functions: t,
                        classes: r,
                        variables: n,
                        allowNamedExports: s
                    };
                }(e1.options[0]), r = e1.sourceCode;
                function n(e1) {
                    if (e1.init) return !1;
                    const { identifier: r } = e1;
                    if (t.allowNamedExports && "ExportSpecifier" === r.parent.type && r.parent.local === r) return !1;
                    const n = e1.resolved;
                    if (!n || 0 === n.defs.length) return !1;
                    const i = n.defs[0].type;
                    return !(!t.functions && "FunctionName" === i) && !((!t.variables && "Variable" === i || !t.classes && "ClassName" === i) && s(e1));
                }
                function o(t) {
                    t.references.filter(n).forEach((t)=>{
                        const r = t.resolved.defs[0].name;
                        (t.identifier.range[1] < r.range[1] || i(t)) && e1.report({
                            node: t.identifier,
                            messageId: "usedBeforeDefined",
                            data: t.identifier
                        });
                    }), t.childScopes.forEach(o);
                }
                return {
                    Program (e1) {
                        o(r.getScope(e1));
                    }
                };
            }
        }, kE;
    }
    function bS() {
        if (FE) return IE;
        FE = 1;
        const e1 = Ll();
        return IE = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow unnecessary calls to `.call()` and `.apply()`",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-useless-call"
                },
                schema: [],
                messages: {
                    unnecessaryCall: "Unnecessary '.{{name}}()'."
                }
            },
            create (t) {
                const r = t.sourceCode;
                return {
                    CallExpression (n) {
                        if (!function(t) {
                            const r = e1.skipChainExpression(t.callee);
                            return "MemberExpression" === r.type && "Identifier" === r.property.type && !1 === r.computed && ("call" === r.property.name && t.arguments.length >= 1 || "apply" === r.property.name && 2 === t.arguments.length && "ArrayExpression" === t.arguments[1].type);
                        }(n)) return;
                        const s = e1.skipChainExpression(n.callee), i = e1.skipChainExpression(s.object);
                        (function(t, r, n) {
                            return t ? e1.equalTokens(t, r, n) : e1.isNullOrUndefined(r);
                        })("MemberExpression" === i.type ? i.object : null, n.arguments[0], r) && t.report({
                            node: n,
                            messageId: "unnecessaryCall",
                            data: {
                                name: s.property.name
                            }
                        });
                    }
                };
            }
        }, IE;
    }
    function vS() {
        if (jE) return UE;
        jE = 1;
        const e1 = Ll();
        return UE = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow unnecessary computed property keys in objects and classes",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-useless-computed-key"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            enforceForClassMembers: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                fixable: "code",
                messages: {
                    unnecessarilyComputedProperty: "Unnecessarily computed property [{{property}}] found."
                }
            },
            create (t) {
                const r = t.sourceCode, n = t.options[0] && t.options[0].enforceForClassMembers;
                function s(n) {
                    if (function(e1) {
                        if (!e1.computed) return !1;
                        const { key: t } = e1;
                        if ("Literal" !== t.type) return !1;
                        const { value: r } = t;
                        if ("number" != typeof r && "string" != typeof r) return !1;
                        switch(e1.type){
                            case "Property":
                                return "__proto__" !== r;
                            case "PropertyDefinition":
                                return e1.static ? "constructor" !== r && "prototype" !== r : "constructor" !== r;
                            case "MethodDefinition":
                                return e1.static ? "prototype" !== r : "constructor" !== r;
                            default:
                                throw new Error(`Unexpected node type: ${e1.type}`);
                        }
                    }(n)) {
                        const { key: s } = n;
                        t.report({
                            node: n,
                            messageId: "unnecessarilyComputedProperty",
                            data: {
                                property: r.getText(s)
                            },
                            fix (t) {
                                const n = r.getTokenBefore(s, e1.isOpeningBracketToken), i = r.getTokenAfter(s, e1.isClosingBracketToken);
                                if (r.commentsExistBetween(n, i)) return null;
                                const o = r.getTokenBefore(n), a = (o.range[1] === n.range[0] && !e1.canTokensBeAdjacent(o, r.getFirstToken(s)) ? " " : "") + s.raw;
                                return t.replaceTextRange([
                                    n.range[0],
                                    i.range[1]
                                ], a);
                            }
                        });
                    }
                }
                function i() {}
                return {
                    Property: s,
                    MethodDefinition: n ? s : i,
                    PropertyDefinition: n ? s : i
                };
            }
        }, UE;
    }
    function AS() {
        if (KE) return VE;
        KE = 1;
        const e1 = Ll();
        function t(e1) {
            return "BinaryExpression" === e1.type && "+" === e1.operator;
        }
        function r(e1) {
            return "+" === e1.value && "Punctuator" === e1.type;
        }
        return VE = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow unnecessary concatenation of literals or template literals",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-useless-concat"
                },
                schema: [],
                messages: {
                    unexpectedConcat: "Unexpected string concatenation of literals."
                }
            },
            create (n) {
                const s = n.sourceCode;
                return {
                    BinaryExpression (i) {
                        if ("+" !== i.operator) return;
                        const o = function(e1) {
                            let r = e1.left;
                            for(; t(r);)r = r.right;
                            return r;
                        }(i), a = function(e1) {
                            let r = e1.right;
                            for(; t(r);)r = r.left;
                            return r;
                        }(i);
                        if (e1.isStringLiteral(o) && e1.isStringLiteral(a) && e1.isTokenOnSameLine(o, a)) {
                            const e1 = s.getFirstTokenBetween(o, a, r);
                            n.report({
                                node: i,
                                loc: e1.loc,
                                messageId: "unexpectedConcat"
                            });
                        }
                    }
                };
            }
        }, VE;
    }
    function TS() {
        if ($E) return ME;
        function e1(e1) {
            return "Identifier" === e1.type || "RestElement" === e1.type;
        }
        function t(e1, t) {
            return "Identifier" === e1.type && "Identifier" === t.type && e1.name === t.name;
        }
        function r(e1, r) {
            return t(e1, r) || function(e1, r) {
                return "RestElement" === e1.type && "SpreadElement" === r.type && t(e1.argument, r.argument);
            }(e1, r);
        }
        function n(t, n) {
            var s;
            return function(e1) {
                return 1 === e1.length && "ExpressionStatement" === e1[0].type && "CallExpression" === e1[0].expression.type && "Super" === e1[0].expression.callee.type;
            }(t) && n.every(e1) && (1 === (s = t[0].expression.arguments).length && "SpreadElement" === s[0].type && "Identifier" === s[0].argument.type && "arguments" === s[0].argument.name || function(e1, t) {
                if (e1.length !== t.length) return !1;
                for(let n = 0; n < e1.length; ++n)if (!r(e1[n], t[n])) return !1;
                return !0;
            }(n, t[0].expression.arguments));
        }
        return $E = 1, ME = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow unnecessary constructors",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-useless-constructor"
                },
                schema: [],
                messages: {
                    noUselessConstructor: "Useless constructor."
                }
            },
            create: (e1)=>({
                    MethodDefinition: function(t) {
                        if ("constructor" !== t.kind) return;
                        if (!t.value.body) return;
                        const r = t.value.body.body, s = t.value.params;
                        (t.parent.parent.superClass ? n(r, s) : 0 === r.length) && e1.report({
                            node: t,
                            messageId: "noUselessConstructor"
                        });
                    }
                })
        }, ME;
    }
    function RS() {
        if (GE) return qE;
        GE = 1;
        const e1 = Ll(), { RegExpParser: t, visitRegExpAST: r } = _C();
        function n(e1, t) {
            return new Set(function*() {
                yield* e1, yield* t;
            }());
        }
        const s = n(new Set("\\nrvtbfux"), e1.LINEBREAKS), i = new Set("\\bcdDfnpPrsStvwWxu0123456789]"), o = n(i, new Set("^/.$*+?[{}|()Bk")), a = n(i, new Set("q/[{}|()-")), u = new Set("!#$%&*+,.:;<=>?@^`~");
        return qE = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow unnecessary escape characters",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/no-useless-escape"
                },
                hasSuggestions: !0,
                messages: {
                    unnecessaryEscape: "Unnecessary escape character: \\{{character}}.",
                    removeEscape: "Remove the `\\`. This maintains the current functionality.",
                    removeEscapeDoNotKeepSemantics: "Remove the `\\` if it was inserted by mistake.",
                    escapeBackslash: "Replace the `\\` with `\\\\` to include the actual backslash character."
                },
                schema: []
            },
            create (n) {
                const l = n.sourceCode, c = new t;
                function p(t, r, s, i) {
                    const o = t.range[0] + r, a = [
                        o,
                        o + 1
                    ], u = l.getLocFromIndex(o);
                    n.report({
                        node: t,
                        loc: {
                            start: u,
                            end: {
                                line: u.line,
                                column: u.column + 1
                            }
                        },
                        messageId: "unnecessaryEscape",
                        data: {
                            character: s
                        },
                        suggest: [
                            {
                                messageId: e1.isDirective(t.parent) ? "removeEscapeDoNotKeepSemantics" : "removeEscape",
                                fix: (e1)=>e1.removeRange(a)
                            },
                            ...i ? [] : [
                                {
                                    messageId: "escapeBackslash",
                                    fix: (e1)=>e1.insertTextBeforeRange(a, "\\")
                                }
                            ]
                        ]
                    });
                }
                function f(e1, t) {
                    const r = "TemplateElement" === e1.type, n = t[0][1];
                    let i, o = !s.has(n);
                    r ? (i = "`" === n, "$" === n ? o = "{" !== t.input[t.index + 2] : "{" === n && (o = "$" !== t.input[t.index - 1])) : i = n === e1.raw[0], o && !i && p(e1, t.index, t[0].slice(1));
                }
                function d(e1) {
                    const t = "TemplateElement" === e1.type;
                    if (!(t && e1.parent && e1.parent.parent && "TaggedTemplateExpression" === e1.parent.parent.type && e1.parent === e1.parent.parent.quasi)) {
                        if ("string" == typeof e1.value || t) {
                            if ("JSXAttribute" === e1.parent.type || "JSXElement" === e1.parent.type || "JSXFragment" === e1.parent.type) return;
                            const r = t ? l.getText(e1) : e1.raw, n = /\\[^\d]/gu;
                            let s;
                            for(; s = n.exec(r);)f(e1, s);
                        } else e1.regex && function(e1) {
                            const { pattern: t, flags: n } = e1.regex;
                            let s;
                            const l = n.includes("u"), f = n.includes("v");
                            try {
                                s = c.parsePattern(t, 0, t.length, {
                                    unicode: l,
                                    unicodeSets: f
                                });
                            } catch  {
                                return;
                            }
                            const d = [];
                            r(s, {
                                onCharacterClassEnter: (e1)=>d.unshift(e1),
                                onCharacterClassLeave: ()=>d.shift(),
                                onExpressionCharacterClassEnter: (e1)=>d.unshift(e1),
                                onExpressionCharacterClassLeave: ()=>d.shift(),
                                onCharacterEnter (r) {
                                    if (!r.raw.startsWith("\\")) return;
                                    const n = r.raw.slice(1);
                                    if (n !== String.fromCodePoint(r.value)) return;
                                    let s;
                                    if (s = d.length ? f ? a : i : o, s.has(n)) return;
                                    const l = r.start + 1;
                                    let c = !1;
                                    if (d.length) {
                                        const e1 = d[0];
                                        if ("^" === n && e1.start + 1 === r.start) return;
                                        if (f) {
                                            if (u.has(n)) {
                                                if (t[r.end] === n) return;
                                                if (t[r.start - 1] === n) {
                                                    if ("^" !== n) return;
                                                    if (!e1.negate) return;
                                                    if (e1.start + 1 < r.start - 1) return;
                                                }
                                            }
                                            "ClassIntersection" !== r.parent.type && "ClassSubtraction" !== r.parent.type || (c = !0);
                                        } else if ("-" === n && e1.start + 1 !== r.start && r.end !== e1.end - 1) return;
                                    }
                                    p(e1, l, n, c);
                                }
                            });
                        }(e1);
                    }
                }
                return {
                    Literal: d,
                    TemplateElement: d
                };
            }
        }, qE;
    }
    function DS() {
        if (HE) return zE;
        HE = 1;
        const e1 = Ll(), t = LC();
        function r(t) {
            return e1.STATEMENT_LIST_PARENTS.has(t.parent.type);
        }
        return zE = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow redundant return statements",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-useless-return"
                },
                fixable: "code",
                schema: [],
                messages: {
                    unnecessaryReturn: "Unnecessary return statement."
                }
            },
            create (n) {
                const s = new WeakMap, i = n.sourceCode;
                let o = null;
                function a(e1) {
                    const t = s.get(e1);
                    return !t || t.returned;
                }
                function u(e1, t, r) {
                    const n = r || new WeakSet;
                    for (const r of t)r.reachable ? e1.push(...s.get(r).uselessReturns) : n.has(r) || (n.add(r), u(e1, r.allPrevSegments.filter(a), n));
                    return e1;
                }
                function l(e1, t) {
                    if (!e1.reachable) return t.add(e1), void e1.allPrevSegments.filter(a).filter((e1)=>!t.has(e1)).forEach((e1)=>l(e1, t));
                    const r = s.get(e1);
                    r.uselessReturns = r.uselessReturns.filter((e1)=>{
                        if (o.traversedTryBlockStatements && o.traversedTryBlockStatements.length > 0) {
                            const t = e1.range[0], r = e1.range[1];
                            if (o.traversedTryBlockStatements.some((e1)=>{
                                const n = e1.range[0], s = e1.range[1];
                                return t >= n && r <= s;
                            })) return !0;
                        }
                        return function(e1, t) {
                            const r = e1.indexOf(t);
                            -1 !== r && e1.splice(r, 1);
                        }(o.uselessReturns, e1), !1;
                    });
                }
                function c() {
                    o.currentSegments.forEach((e1)=>l(e1, new Set));
                }
                return {
                    onCodePathStart (e1) {
                        o = {
                            upper: o,
                            uselessReturns: [],
                            traversedTryBlockStatements: [],
                            codePath: e1,
                            currentSegments: new Set
                        };
                    },
                    onCodePathEnd () {
                        for (const e1 of o.uselessReturns)n.report({
                            node: e1,
                            loc: e1.loc,
                            messageId: "unnecessaryReturn",
                            fix: (n)=>r(e1) && !i.getCommentsInside(e1).length ? new t(n, i).retainEnclosingFunction(e1).remove(e1) : null
                        });
                        o = o.upper;
                    },
                    onCodePathSegmentStart (e1) {
                        o.currentSegments.add(e1);
                        const t = {
                            uselessReturns: u([], e1.allPrevSegments),
                            returned: !1
                        };
                        s.set(e1, t);
                    },
                    onUnreachableCodePathSegmentStart (e1) {
                        o.currentSegments.add(e1);
                    },
                    onUnreachableCodePathSegmentEnd (e1) {
                        o.currentSegments.delete(e1);
                    },
                    onCodePathSegmentEnd (e1) {
                        o.currentSegments.delete(e1);
                    },
                    ReturnStatement (t) {
                        if (t.argument && c(), !(t.argument || e1.isInLoop(t) || function(t) {
                            for(let r = t; r && r.parent && !e1.isFunction(r); r = r.parent)if ("TryStatement" === r.parent.type && r.parent.finalizer === r) return !0;
                            return !1;
                        }(t)) && function(e1) {
                            for (const t of e1)if (t.reachable) return !0;
                            return !1;
                        }(o.currentSegments)) {
                            for (const e1 of o.currentSegments){
                                const r = s.get(e1);
                                r && (r.uselessReturns.push(t), r.returned = !0);
                            }
                            o.uselessReturns.push(t);
                        }
                    },
                    "TryStatement > BlockStatement.block:exit" (e1) {
                        o.traversedTryBlockStatements.push(e1);
                    },
                    "TryStatement:exit" () {
                        o.traversedTryBlockStatements.pop();
                    },
                    ClassDeclaration: c,
                    ContinueStatement: c,
                    DebuggerStatement: c,
                    DoWhileStatement: c,
                    EmptyStatement: c,
                    ExpressionStatement: c,
                    ForInStatement: c,
                    ForOfStatement: c,
                    ForStatement: c,
                    IfStatement: c,
                    ImportDeclaration: c,
                    LabeledStatement: c,
                    SwitchStatement: c,
                    ThrowStatement: c,
                    TryStatement: c,
                    VariableDeclaration: c,
                    WhileStatement: c,
                    WithStatement: c,
                    ExportNamedDeclaration: c,
                    ExportDefaultDeclaration: c,
                    ExportAllDeclaration: c
                };
            }
        }, zE;
    }
    function wS() {
        if (QE) return JE;
        QE = 1;
        const e1 = Ll();
        function t(e1) {
            return Boolean(e1.scope) && "global" === e1.scope.type;
        }
        function r(e1) {
            let t = e1;
            for(; "function" !== t.type && "global" !== t.type;)t = t.upper;
            return t;
        }
        function n(e1) {
            const t = r(e1.scope);
            return e1.references.some((e1)=>r(e1.from) !== t);
        }
        function s(e1) {
            return ("ForOfStatement" === e1.parent.type || "ForInStatement" === e1.parent.type) && e1 === e1.parent.left;
        }
        const i = /^(?:Program|BlockStatement|SwitchStatement|ForStatement|ForInStatement|ForOfStatement)$/u;
        function o(e1) {
            return e1.defs.length >= 2;
        }
        function a(e1) {
            return "let" === e1.name;
        }
        return JE = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require `let` or `const` instead of `var`",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-var"
                },
                schema: [],
                fixable: "code",
                messages: {
                    unexpectedVar: "Unexpected var, use let or const instead."
                }
            },
            create (r) {
                const u = r.sourceCode;
                function l(t) {
                    if (!t.init) return !1;
                    return u.getDeclaredVariables(t).some(function(t) {
                        const r = t.range[0], n = t.range[1];
                        return (s)=>{
                            const i = s.defs[0].name, o = i.range[0], a = "AssignmentPattern" === i.parent.type ? i.parent.right : null, u = a && a.range[0], l = a && a.range[1];
                            return s.references.some((s)=>{
                                const i = s.identifier.range[0], c = s.identifier.range[1];
                                return !s.init && (i < o || null !== a && i >= u && c <= l || !e1.isFunction(t) && i >= r && c <= n);
                            });
                        };
                    }(t.init));
                }
                function c(r) {
                    const c = u.getDeclaredVariables(r), p = function(e1) {
                        for(let t = e1; t; t = t.parent)if (i.test(t.type)) return t;
                        return null;
                    }(r);
                    if ("SwitchCase" === r.parent.type || r.declarations.some(l) || c.some(t) || c.some(o) || c.some(function(e1) {
                        function t(t) {
                            const r = e1.range, n = t.identifier.range;
                            return n[0] < r[0] || n[1] > r[1];
                        }
                        return function(e1) {
                            return e1.references.some(t);
                        };
                    }(p)) || c.some(a)) return !1;
                    if (e1.isInLoop(r)) {
                        if (c.some(n)) return !1;
                        if (!s(r) && !function(e1) {
                            return e1.declarations.every((e1)=>null !== e1.init);
                        }(r)) return !1;
                    }
                    return !!(s(r) || "ForStatement" === r.parent.type && r.parent.init === r || e1.STATEMENT_LIST_PARENTS.has(r.parent.type));
                }
                return {
                    "VariableDeclaration:exit" (e1) {
                        "var" === e1.kind && function(e1) {
                            r.report({
                                node: e1,
                                messageId: "unexpectedVar",
                                fix (t) {
                                    const r = u.getFirstToken(e1, {
                                        filter: (e1)=>"var" === e1.value
                                    });
                                    return c(e1) ? t.replaceText(r, "let") : null;
                                }
                            });
                        }(e1);
                    }
                };
            }
        }, JE;
    }
    function _S() {
        if (tx) return ex;
        tx = 1;
        const e1 = Ja(), t = Ll();
        return ex = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow specified warning terms in comments",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-warning-comments"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            terms: {
                                type: "array",
                                items: {
                                    type: "string"
                                }
                            },
                            location: {
                                enum: [
                                    "start",
                                    "anywhere"
                                ]
                            },
                            decoration: {
                                type: "array",
                                items: {
                                    type: "string",
                                    pattern: "^\\S$"
                                },
                                minItems: 1,
                                uniqueItems: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unexpectedComment: "Unexpected '{{matchedTerm}}' comment: '{{comment}}'."
                }
            },
            create (r) {
                const n = r.sourceCode, s = r.options[0] || {}, i = s.terms || [
                    "todo",
                    "fixme",
                    "xxx"
                ], o = s.location || "start", a = [
                    ...s.decoration || []
                ].join(""), u = /\bno-warning-comments\b/u;
                const l = i.map(function(t) {
                    const r = e1(t), n = e1(a);
                    let s = "";
                    "start" === o ? s = `^[\\s${n}]*` : /^\w/u.test(t) && (s = "\\b");
                    const i = /\w$/u.test(t) ? "\\b" : "";
                    return new RegExp(`${s}${r}${i}`, "iu");
                });
                function c(e1) {
                    const n = e1.value;
                    if (t.isDirectiveComment(e1) && u.test(n)) return;
                    const s = function(e1) {
                        const t = [];
                        return l.forEach((r, n)=>{
                            r.test(e1) && t.push(i[n]);
                        }), t;
                    }(n);
                    s.forEach((t)=>{
                        let s = "", i = !1;
                        for (const e1 of n.trim().split(/\s+/u)){
                            const t = s ? `${s} ${e1}` : e1;
                            if (!(t.length <= 40)) {
                                i = !0;
                                break;
                            }
                            s = t;
                        }
                        r.report({
                            node: e1,
                            messageId: "unexpectedComment",
                            data: {
                                matchedTerm: t,
                                comment: `${s}${i ? "..." : ""}`
                            }
                        });
                    });
                }
                return {
                    Program () {
                        n.getAllComments().filter((e1)=>"Shebang" !== e1.type).forEach(c);
                    }
                };
            }
        }, ex;
    }
    function kS() {
        if (nx) return rx;
        nx = 1;
        const e1 = Ll();
        return rx = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Disallow whitespace before properties",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/no-whitespace-before-property"
                },
                fixable: "whitespace",
                schema: [],
                messages: {
                    unexpectedWhitespace: "Unexpected whitespace before property {{propName}}."
                }
            },
            create (t) {
                const r = t.sourceCode;
                return {
                    MemberExpression (n) {
                        let s, i;
                        e1.isTokenOnSameLine(n.object, n.property) && (n.computed ? (s = r.getTokenBefore(n.property, e1.isOpeningBracketToken), i = r.getTokenBefore(s, n.optional ? 1 : 0)) : (s = r.getFirstToken(n.property), i = r.getTokenBefore(s, 1)), r.isSpaceBetweenTokens(i, s) && function(n, s, i) {
                            t.report({
                                node: n,
                                messageId: "unexpectedWhitespace",
                                data: {
                                    propName: r.getText(n.property)
                                },
                                fix (t) {
                                    let o = "";
                                    return n.computed || n.optional || !e1.isDecimalInteger(n.object) ? r.commentsExistBetween(s, i) ? null : (n.optional ? o = "?." : n.computed || (o = "."), t.replaceTextRange([
                                        s.range[1],
                                        i.range[0]
                                    ], o)) : null;
                                }
                            });
                        }(n, i, s));
                    }
                };
            }
        }, rx;
    }
    function BS() {
        if (ax) return ox;
        ax = 1;
        const e1 = {
            enum: [
                "beside",
                "below",
                "any"
            ]
        };
        return ox = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce the location of single-line statements",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/nonblock-statement-body-position"
                },
                fixable: "whitespace",
                schema: [
                    e1,
                    {
                        properties: {
                            overrides: {
                                properties: {
                                    if: e1,
                                    else: e1,
                                    while: e1,
                                    do: e1,
                                    for: e1
                                },
                                additionalProperties: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    expectNoLinebreak: "Expected no linebreak before this statement.",
                    expectLinebreak: "Expected a linebreak before this statement."
                }
            },
            create (e1) {
                const t = e1.sourceCode;
                function r(r, n) {
                    const s = function(t) {
                        return e1.options[1] && e1.options[1].overrides && e1.options[1].overrides[t] || e1.options[0] || "beside";
                    }(n);
                    if ("BlockStatement" === r.type || "any" === s) return;
                    const i = t.getTokenBefore(r);
                    i.loc.end.line === r.loc.start.line && "below" === s ? e1.report({
                        node: r,
                        messageId: "expectLinebreak",
                        fix: (e1)=>e1.insertTextBefore(r, "\n")
                    }) : i.loc.end.line !== r.loc.start.line && "beside" === s && e1.report({
                        node: r,
                        messageId: "expectNoLinebreak",
                        fix: (e1)=>t.getText().slice(i.range[1], r.range[0]).trim() ? null : e1.replaceTextRange([
                                i.range[1],
                                r.range[0]
                            ], " ")
                    });
                }
                return {
                    IfStatement (e1) {
                        r(e1.consequent, "if"), e1.alternate && "IfStatement" !== e1.alternate.type && r(e1.alternate, "else");
                    },
                    WhileStatement: (e1)=>r(e1.body, "while"),
                    DoWhileStatement: (e1)=>r(e1.body, "do"),
                    ForStatement: (e1)=>r(e1.body, "for"),
                    ForInStatement: (e1)=>r(e1.body, "for"),
                    ForOfStatement: (e1)=>r(e1.body, "for")
                };
            }
        }, ox;
    }
    function LS() {
        if (lx) return ux;
        lx = 1;
        const e1 = Ll(), t = {
            oneOf: [
                {
                    enum: [
                        "always",
                        "never"
                    ]
                },
                {
                    type: "object",
                    properties: {
                        multiline: {
                            type: "boolean"
                        },
                        minProperties: {
                            type: "integer",
                            minimum: 0
                        },
                        consistent: {
                            type: "boolean"
                        }
                    },
                    additionalProperties: !1,
                    minProperties: 1
                }
            ]
        };
        function r(e1) {
            let t = !1, r = Number.POSITIVE_INFINITY, n = !1;
            return e1 ? "always" === e1 ? r = 0 : "never" === e1 ? r = Number.POSITIVE_INFINITY : (t = Boolean(e1.multiline), r = e1.minProperties || Number.POSITIVE_INFINITY, n = Boolean(e1.consistent)) : n = !0, {
                multiline: t,
                minProperties: r,
                consistent: n
            };
        }
        function n(e1) {
            return "object" == typeof e1 && null !== e1;
        }
        function s(e1) {
            return n(e1) || "string" == typeof e1;
        }
        return ux = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent line breaks after opening and before closing braces",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/object-curly-newline"
                },
                fixable: "whitespace",
                schema: [
                    {
                        oneOf: [
                            t,
                            {
                                type: "object",
                                properties: {
                                    ObjectExpression: t,
                                    ObjectPattern: t,
                                    ImportDeclaration: t,
                                    ExportDeclaration: t
                                },
                                additionalProperties: !1,
                                minProperties: 1
                            }
                        ]
                    }
                ],
                messages: {
                    unexpectedLinebreakBeforeClosingBrace: "Unexpected line break before this closing brace.",
                    unexpectedLinebreakAfterOpeningBrace: "Unexpected line break after this opening brace.",
                    expectedLinebreakBeforeClosingBrace: "Expected a line break before this closing brace.",
                    expectedLinebreakAfterOpeningBrace: "Expected a line break after this opening brace."
                }
            },
            create (t) {
                const i = t.sourceCode, o = function(e1) {
                    if (n(e1) && Object.values(e1).some(s)) return {
                        ObjectExpression: r(e1.ObjectExpression),
                        ObjectPattern: r(e1.ObjectPattern),
                        ImportDeclaration: r(e1.ImportDeclaration),
                        ExportNamedDeclaration: r(e1.ExportDeclaration)
                    };
                    const t = r(e1);
                    return {
                        ObjectExpression: t,
                        ObjectPattern: t,
                        ImportDeclaration: t,
                        ExportNamedDeclaration: t
                    };
                }(t.options[0]);
                function a(r) {
                    const n = o[r.type];
                    if ("ImportDeclaration" === r.type && !r.specifiers.some((e1)=>"ImportSpecifier" === e1.type) || "ExportNamedDeclaration" === r.type && !r.specifiers.some((e1)=>"ExportSpecifier" === e1.type)) return;
                    const s = i.getFirstToken(r, (e1)=>"{" === e1.value);
                    let a;
                    a = r.typeAnnotation ? i.getTokenBefore(r.typeAnnotation) : i.getLastToken(r, (e1)=>"}" === e1.value);
                    let u = i.getTokenAfter(s, {
                        includeComments: !0
                    }), l = i.getTokenBefore(a, {
                        includeComments: !0
                    });
                    const c = function(e1, t, r, n) {
                        let s;
                        return s = "ObjectExpression" === e1.type || "ObjectPattern" === e1.type ? e1.properties : e1.specifiers.filter((e1)=>"ImportSpecifier" === e1.type || "ExportSpecifier" === e1.type), s.length >= t.minProperties || t.multiline && s.length > 0 && r.loc.start.line !== n.loc.end.line;
                    }(r, n, u, l), p = e1.isCommentToken(u), f = e1.isCommentToken(l);
                    if (u = i.getTokenAfter(s), l = i.getTokenBefore(a), c) e1.isTokenOnSameLine(s, u) && t.report({
                        messageId: "expectedLinebreakAfterOpeningBrace",
                        node: r,
                        loc: s.loc,
                        fix: (e1)=>p ? null : e1.insertTextAfter(s, "\n")
                    }), e1.isTokenOnSameLine(l, a) && t.report({
                        messageId: "expectedLinebreakBeforeClosingBrace",
                        node: r,
                        loc: a.loc,
                        fix: (e1)=>f ? null : e1.insertTextBefore(a, "\n")
                    });
                    else {
                        const i = n.consistent, o = !e1.isTokenOnSameLine(s, u), c = !e1.isTokenOnSameLine(l, a);
                        (!i && o || i && o && !c) && t.report({
                            messageId: "unexpectedLinebreakAfterOpeningBrace",
                            node: r,
                            loc: s.loc,
                            fix: (e1)=>p ? null : e1.removeRange([
                                    s.range[1],
                                    u.range[0]
                                ])
                        }), (!i && c || i && !o && c) && t.report({
                            messageId: "unexpectedLinebreakBeforeClosingBrace",
                            node: r,
                            loc: a.loc,
                            fix: (e1)=>f ? null : e1.removeRange([
                                    l.range[1],
                                    a.range[0]
                                ])
                        });
                    }
                }
                return {
                    ObjectExpression: a,
                    ObjectPattern: a,
                    ImportDeclaration: a,
                    ExportNamedDeclaration: a
                };
            }
        }, ux;
    }
    function PS() {
        if (px) return cx;
        px = 1;
        const e1 = Ll();
        return cx = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent spacing inside braces",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/object-curly-spacing"
                },
                fixable: "whitespace",
                schema: [
                    {
                        enum: [
                            "always",
                            "never"
                        ]
                    },
                    {
                        type: "object",
                        properties: {
                            arraysInObjects: {
                                type: "boolean"
                            },
                            objectsInObjects: {
                                type: "boolean"
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    requireSpaceBefore: "A space is required before '{{token}}'.",
                    requireSpaceAfter: "A space is required after '{{token}}'.",
                    unexpectedSpaceBefore: "There should be no space before '{{token}}'.",
                    unexpectedSpaceAfter: "There should be no space after '{{token}}'."
                }
            },
            create (t) {
                const r = "always" === t.options[0], n = t.sourceCode;
                function s(e1) {
                    return !!t.options[1] && t.options[1][e1] === !r;
                }
                const i = {
                    spaced: r,
                    arraysInObjectsException: s("arraysInObjects"),
                    objectsInObjectsException: s("objectsInObjects")
                };
                function o(r, s, o, a, u) {
                    if (e1.isTokenOnSameLine(s, o)) {
                        const e1 = n.isSpaceBetweenTokens(s, o);
                        i.spaced && !e1 && function(e1, r) {
                            t.report({
                                node: e1,
                                loc: r.loc,
                                messageId: "requireSpaceAfter",
                                data: {
                                    token: r.value
                                },
                                fix: (e1)=>e1.insertTextAfter(r, " ")
                            });
                        }(r, s), !i.spaced && e1 && "Line" !== o.type && function(e1, r) {
                            const n = t.sourceCode.getTokenAfter(r, {
                                includeComments: !0
                            });
                            t.report({
                                node: e1,
                                loc: {
                                    start: r.loc.end,
                                    end: n.loc.start
                                },
                                messageId: "unexpectedSpaceAfter",
                                data: {
                                    token: r.value
                                },
                                fix: (e1)=>e1.removeRange([
                                        r.range[1],
                                        n.range[0]
                                    ])
                            });
                        }(r, s);
                    }
                    if (e1.isTokenOnSameLine(a, u)) {
                        const s = (i.arraysInObjectsException && e1.isClosingBracketToken(a) || i.objectsInObjectsException && e1.isClosingBraceToken(a)) && n.getNodeByRangeIndex(a.range[0]).type, o = i.arraysInObjectsException && "ArrayExpression" === s || i.objectsInObjectsException && ("ObjectExpression" === s || "ObjectPattern" === s) ? !i.spaced : i.spaced, l = n.isSpaceBetweenTokens(a, u);
                        o && !l && function(e1, r) {
                            t.report({
                                node: e1,
                                loc: r.loc,
                                messageId: "requireSpaceBefore",
                                data: {
                                    token: r.value
                                },
                                fix: (e1)=>e1.insertTextBefore(r, " ")
                            });
                        }(r, u), !o && l && function(e1, r) {
                            const n = t.sourceCode.getTokenBefore(r, {
                                includeComments: !0
                            });
                            t.report({
                                node: e1,
                                loc: {
                                    start: n.loc.end,
                                    end: r.loc.start
                                },
                                messageId: "unexpectedSpaceBefore",
                                data: {
                                    token: r.value
                                },
                                fix: (e1)=>e1.removeRange([
                                        n.range[1],
                                        r.range[0]
                                    ])
                            });
                        }(r, u);
                    }
                }
                function a(t) {
                    if (0 === t.properties.length) return;
                    const r = n.getFirstToken(t), s = function(t) {
                        const r = t.properties[t.properties.length - 1];
                        return n.getTokenAfter(r, e1.isClosingBraceToken);
                    }(t);
                    o(t, r, n.getTokenAfter(r, {
                        includeComments: !0
                    }), n.getTokenBefore(s, {
                        includeComments: !0
                    }), s);
                }
                return {
                    ObjectPattern: a,
                    ObjectExpression: a,
                    ImportDeclaration: function(t) {
                        if (0 === t.specifiers.length) return;
                        let r = t.specifiers[0];
                        const s = t.specifiers[t.specifiers.length - 1];
                        if ("ImportSpecifier" !== s.type) return;
                        "ImportSpecifier" !== r.type && (r = t.specifiers[1]);
                        const i = n.getTokenBefore(r), a = n.getTokenAfter(s, e1.isNotCommaToken);
                        o(t, i, n.getTokenAfter(i, {
                            includeComments: !0
                        }), n.getTokenBefore(a, {
                            includeComments: !0
                        }), a);
                    },
                    ExportNamedDeclaration: function(t) {
                        if (0 === t.specifiers.length) return;
                        const r = t.specifiers[0], s = t.specifiers[t.specifiers.length - 1], i = n.getTokenBefore(r), a = n.getTokenAfter(s, e1.isNotCommaToken);
                        o(t, i, n.getTokenAfter(i, {
                            includeComments: !0
                        }), n.getTokenBefore(a, {
                            includeComments: !0
                        }), a);
                    }
                };
            }
        }, cx;
    }
    function IS() {
        if (mx) return hx;
        mx = 1;
        const e1 = "always", t = "never", r = "methods", n = "properties", s = "consistent", i = "consistent-as-needed", o = Ll();
        return hx = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require or disallow method and property shorthand syntax for object literals",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/object-shorthand"
                },
                fixable: "code",
                schema: {
                    anyOf: [
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "always",
                                        "methods",
                                        "properties",
                                        "never",
                                        "consistent",
                                        "consistent-as-needed"
                                    ]
                                }
                            ],
                            minItems: 0,
                            maxItems: 1
                        },
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "always",
                                        "methods",
                                        "properties"
                                    ]
                                },
                                {
                                    type: "object",
                                    properties: {
                                        avoidQuotes: {
                                            type: "boolean"
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            minItems: 0,
                            maxItems: 2
                        },
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "always",
                                        "methods"
                                    ]
                                },
                                {
                                    type: "object",
                                    properties: {
                                        ignoreConstructors: {
                                            type: "boolean"
                                        },
                                        methodsIgnorePattern: {
                                            type: "string"
                                        },
                                        avoidQuotes: {
                                            type: "boolean"
                                        },
                                        avoidExplicitReturnArrows: {
                                            type: "boolean"
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            minItems: 0,
                            maxItems: 2
                        }
                    ]
                },
                messages: {
                    expectedAllPropertiesShorthanded: "Expected shorthand for all properties.",
                    expectedLiteralMethodLongform: "Expected longform method syntax for string literal keys.",
                    expectedPropertyShorthand: "Expected property shorthand.",
                    expectedPropertyLongform: "Expected longform property syntax.",
                    expectedMethodShorthand: "Expected method shorthand.",
                    expectedMethodLongform: "Expected longform method syntax.",
                    unexpectedMix: "Unexpected mix of shorthand and non-shorthand properties."
                }
            },
            create (a) {
                const u = a.options[0] || e1, l = u === r || u === e1, c = u === n || u === e1, p = u === t, f = u === s, d = u === i, h = a.options[1] || {}, m = h.ignoreConstructors, g = h.methodsIgnorePattern ? new RegExp(h.methodsIgnorePattern, "u") : null, y = h.avoidQuotes, E = !!h.avoidExplicitReturnArrows, x = a.sourceCode, C = /[^_$0-9]/u;
                function S(e1) {
                    return "set" !== e1.kind && "get" !== e1.kind && "SpreadElement" !== e1.type && "SpreadProperty" !== e1.type && "ExperimentalSpreadProperty" !== e1.type;
                }
                function b(e1) {
                    return "Literal" === e1.type && "string" == typeof e1.value;
                }
                function v(e1) {
                    return e1.shorthand || e1.method;
                }
                function A(e1) {
                    const t = e1.value;
                    return "FunctionExpression" === t.type ? !t.id : "Identifier" === t.type && o.getStaticPropertyName(e1) === t.name;
                }
                function T(e1, t) {
                    const r = e1.properties.filter(S);
                    if (r.length > 0) {
                        const n = r.filter(v);
                        if (n.length !== r.length) {
                            if (n.length > 0) a.report({
                                node: e1,
                                messageId: "unexpectedMix"
                            });
                            else if (t) r.every(A) && a.report({
                                node: e1,
                                messageId: "expectedAllPropertiesShorthanded"
                            });
                        }
                    }
                }
                const R = [], D = new WeakSet, w = new WeakSet;
                function _(e1) {
                    R.unshift(new Set), x.getScope(e1).variables.filter((e1)=>"arguments" === e1.name).forEach((e1)=>{
                        e1.references.map((e1)=>e1.identifier).forEach((e1)=>w.add(e1));
                    });
                }
                function k() {
                    R.shift();
                }
                function B() {
                    R[0].forEach((e1)=>D.add(e1));
                }
                return {
                    Program: _,
                    FunctionDeclaration: _,
                    FunctionExpression: _,
                    "Program:exit": k,
                    "FunctionDeclaration:exit": k,
                    "FunctionExpression:exit": k,
                    ArrowFunctionExpression (e1) {
                        R[0].add(e1);
                    },
                    "ArrowFunctionExpression:exit" (e1) {
                        R[0].delete(e1);
                    },
                    ThisExpression: B,
                    Super: B,
                    MetaProperty (e1) {
                        "new" === e1.meta.name && "target" === e1.property.name && B();
                    },
                    Identifier (e1) {
                        w.has(e1) && B();
                    },
                    ObjectExpression (e1) {
                        f ? T(e1, !1) : d && T(e1, !0);
                    },
                    "Property:exit" (e1) {
                        const t = e1.method || e1.shorthand;
                        if ("ObjectPattern" !== e1.parent.type && "get" !== e1.kind && "set" !== e1.kind && (!e1.computed || "FunctionExpression" === e1.value.type || "ArrowFunctionExpression" === e1.value.type)) {
                            if (t) {
                                if (e1.method && (p || y && b(e1.key))) {
                                    const t = p ? "expectedMethodLongform" : "expectedLiteralMethodLongform";
                                    a.report({
                                        node: e1,
                                        messageId: t,
                                        fix: (t)=>(function(e1, t) {
                                                const r = t.computed ? x.getTokens(t).find((e1)=>"[" === e1.value) : x.getFirstToken(t.key), n = t.computed ? x.getTokensBetween(t.key, t.value).find((e1)=>"]" === e1.value) : x.getLastToken(t.key), s = x.text.slice(r.range[0], n.range[1]);
                                                let i = "function";
                                                return t.value.async && (i = `async ${i}`), t.value.generator && (i = `${i}*`), e1.replaceTextRange([
                                                    t.range[0],
                                                    n.range[1]
                                                ], `${s}: ${i}`);
                                            })(t, e1)
                                    });
                                } else p && a.report({
                                    node: e1,
                                    messageId: "expectedPropertyLongform",
                                    fix: (t)=>t.insertTextAfter(e1.key, `: ${e1.key.name}`)
                                });
                            } else if (!l || e1.value.id || "FunctionExpression" !== e1.value.type && "ArrowFunctionExpression" !== e1.value.type) {
                                if ("Identifier" === e1.value.type && e1.key.name === e1.value.name && c) a.report({
                                    node: e1,
                                    messageId: "expectedPropertyShorthand",
                                    fix: (t)=>t.replaceText(e1, e1.value.name)
                                });
                                else if ("Identifier" === e1.value.type && "Literal" === e1.key.type && e1.key.value === e1.value.name && c) {
                                    if (y) return;
                                    a.report({
                                        node: e1,
                                        messageId: "expectedPropertyShorthand",
                                        fix: (t)=>t.replaceText(e1, e1.value.name)
                                    });
                                }
                            } else {
                                if (m && "Identifier" === e1.key.type && function(e1) {
                                    const t = C.exec(e1);
                                    if (!t) return !1;
                                    const r = e1.charAt(t.index);
                                    return r === r.toUpperCase();
                                }(e1.key.name)) return;
                                if (g) {
                                    const t = o.getStaticPropertyName(e1);
                                    if (null !== t && g.test(t)) return;
                                }
                                if (y && b(e1.key)) return;
                                ("FunctionExpression" === e1.value.type || "ArrowFunctionExpression" === e1.value.type && "BlockStatement" === e1.value.body.type && E && !D.has(e1.value)) && a.report({
                                    node: e1,
                                    messageId: "expectedMethodShorthand",
                                    fix: (t)=>(function(e1, t) {
                                            const r = t.computed ? x.getFirstToken(t, o.isOpeningBracketToken) : x.getFirstToken(t.key), n = t.computed ? x.getFirstTokenBetween(t.key, t.value, o.isClosingBracketToken) : x.getLastToken(t.key), s = x.text.slice(r.range[0], n.range[1]);
                                            let i = "";
                                            if (x.commentsExistBetween(n, t.value)) return null;
                                            t.value.async && (i += "async "), t.value.generator && (i += "*");
                                            const a = [
                                                r.range[0],
                                                t.range[1]
                                            ], u = i + s;
                                            if ("FunctionExpression" === t.value.type) {
                                                const r = x.getTokens(t.value).find((e1)=>"Keyword" === e1.type && "function" === e1.value), n = t.value.generator ? x.getTokenAfter(r) : r;
                                                return e1.replaceTextRange(a, u + x.text.slice(n.range[1], t.value.range[1]));
                                            }
                                            const l = x.getTokenBefore(t.value.body, o.isArrowToken), c = x.text.slice(l.range[1], t.value.range[1]);
                                            let p, f = !1;
                                            if (p = 0 === t.value.params.length ? x.getFirstToken(t.value, o.isOpeningParenToken) : x.getTokenBefore(t.value.params[0]), 1 === t.value.params.length) {
                                                const e1 = o.isOpeningParenToken(p), r = p.range[0] < t.range[0];
                                                f = !e1 || r;
                                            }
                                            const d = f ? t.value.params[0].range[0] : p.range[0], h = x.getTokenBefore(l).range[1], m = x.text.slice(d, h), g = f ? `(${m})` : m;
                                            return e1.replaceTextRange(a, u + g + c);
                                        })(t, e1)
                                });
                            }
                        }
                    }
                };
            }
        }, hx;
    }
    function FS() {
        if (yx) return gx;
        yx = 1;
        const e1 = Ll();
        return gx = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Enforce variables to be declared either together or separately in functions",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/one-var"
                },
                fixable: "code",
                schema: [
                    {
                        oneOf: [
                            {
                                enum: [
                                    "always",
                                    "never",
                                    "consecutive"
                                ]
                            },
                            {
                                type: "object",
                                properties: {
                                    separateRequires: {
                                        type: "boolean"
                                    },
                                    var: {
                                        enum: [
                                            "always",
                                            "never",
                                            "consecutive"
                                        ]
                                    },
                                    let: {
                                        enum: [
                                            "always",
                                            "never",
                                            "consecutive"
                                        ]
                                    },
                                    const: {
                                        enum: [
                                            "always",
                                            "never",
                                            "consecutive"
                                        ]
                                    }
                                },
                                additionalProperties: !1
                            },
                            {
                                type: "object",
                                properties: {
                                    initialized: {
                                        enum: [
                                            "always",
                                            "never",
                                            "consecutive"
                                        ]
                                    },
                                    uninitialized: {
                                        enum: [
                                            "always",
                                            "never",
                                            "consecutive"
                                        ]
                                    }
                                },
                                additionalProperties: !1
                            }
                        ]
                    }
                ],
                messages: {
                    combineUninitialized: "Combine this with the previous '{{type}}' statement with uninitialized variables.",
                    combineInitialized: "Combine this with the previous '{{type}}' statement with initialized variables.",
                    splitUninitialized: "Split uninitialized '{{type}}' declarations into multiple statements.",
                    splitInitialized: "Split initialized '{{type}}' declarations into multiple statements.",
                    splitRequires: "Split requires to be separated into a single block.",
                    combine: "Combine this with the previous '{{type}}' statement.",
                    split: "Split '{{type}}' declarations into multiple statements."
                }
            },
            create (t) {
                const r = "always", n = "never", s = "consecutive", i = t.options[0] || r, o = {};
                "string" == typeof i ? (o.var = {
                    uninitialized: i,
                    initialized: i
                }, o.let = {
                    uninitialized: i,
                    initialized: i
                }, o.const = {
                    uninitialized: i,
                    initialized: i
                }) : "object" == typeof i && (o.separateRequires = !!i.separateRequires, o.var = {
                    uninitialized: i.var,
                    initialized: i.var
                }, o.let = {
                    uninitialized: i.let,
                    initialized: i.let
                }, o.const = {
                    uninitialized: i.const,
                    initialized: i.const
                }, Object.prototype.hasOwnProperty.call(i, "uninitialized") && (o.var.uninitialized = i.uninitialized, o.let.uninitialized = i.uninitialized, o.const.uninitialized = i.uninitialized), Object.prototype.hasOwnProperty.call(i, "initialized") && (o.var.initialized = i.initialized, o.let.initialized = i.initialized, o.const.initialized = i.initialized));
                const a = t.sourceCode, u = [], l = [];
                function c() {
                    l.push({
                        let: {
                            initialized: !1,
                            uninitialized: !1
                        },
                        const: {
                            initialized: !1,
                            uninitialized: !1
                        }
                    });
                }
                function p() {
                    u.push({
                        initialized: !1,
                        uninitialized: !1
                    }), c();
                }
                function f() {
                    l.pop();
                }
                function d() {
                    u.pop(), f();
                }
                function h(e1) {
                    return e1.init && "CallExpression" === e1.init.type && "require" === e1.init.callee.name;
                }
                function m(e1) {
                    const t = {
                        uninitialized: 0,
                        initialized: 0
                    };
                    for(let r = 0; r < e1.length; r++)null === e1[r].init ? t.uninitialized++ : t.initialized++;
                    return t;
                }
                function g(e1, t) {
                    const n = m(t), s = o[e1] || {}, i = function(e1) {
                        let t;
                        return "var" === e1 ? t = u[u.length - 1] : "let" === e1 ? t = l[l.length - 1].let : "const" === e1 && (t = l[l.length - 1].const), t;
                    }(e1), a = t.some(h);
                    return !(s.uninitialized === r && s.initialized === r && (i.uninitialized || i.initialized) && !a) && !(n.uninitialized > 0 && s.uninitialized === r && i.uninitialized) && !(n.initialized > 0 && s.initialized === r && i.initialized && !a) && (!i.required || !a) && (function(e1, t, n) {
                        for(let s = 0; s < t.length; s++)null === t[s].init ? o[e1] && o[e1].uninitialized === r && (n.uninitialized = !0) : o[e1] && o[e1].initialized === r && (o.separateRequires && h(t[s]) ? n.required = !0 : n.initialized = !0);
                    }(e1, t, i), !0);
                }
                function y(e1) {
                    const t = e1[0], r = Array.isArray(t.parent.parent.body) ? t.parent.parent.body : [], n = r.findIndex((e1)=>e1.range[0] === t.parent.range[0]), s = r[n - 1];
                    return (e1)=>{
                        const r = a.getTokenBefore(t), n = a.getTokenBefore(r), i = [];
                        return s && s.kind === a.getText(r) && (";" === n.value ? i.push(e1.replaceText(n, ",")) : i.push(e1.insertTextAfter(n, ",")), i.push(e1.replaceText(r, ""))), i;
                    };
                }
                function E(t) {
                    const { parent: r } = t;
                    return function(t) {
                        return e1.STATEMENT_LIST_PARENTS.has(t.parent.type);
                    }("ExportNamedDeclaration" === r.type ? r : t) ? (e1)=>t.declarations.map((r)=>{
                            const n = a.getTokenAfter(r);
                            if (null === n) return null;
                            const s = a.getTokenAfter(n, {
                                includeComments: !0
                            });
                            if ("," !== n.value) return null;
                            const i = "ExportNamedDeclaration" === t.parent.type ? "export " : "";
                            if (s.range[0] === n.range[1]) return e1.replaceText(n, `; ${i}${t.kind} `);
                            if (s.loc.start.line > n.loc.end.line || "Line" === s.type || "Block" === s.type) {
                                let r = s;
                                for(; "Line" === r.type || "Block" === r.type;)r = a.getTokenAfter(r, {
                                    includeComments: !0
                                });
                                return e1.replaceTextRange([
                                    n.range[0],
                                    r.range[0]
                                ], `;${a.text.slice(n.range[1], r.range[0])}${i}${t.kind} `);
                            }
                            return e1.replaceText(n, `; ${i}${t.kind}`);
                        }).filter((e1)=>e1) : null;
                }
                return {
                    Program: p,
                    FunctionDeclaration: p,
                    FunctionExpression: p,
                    ArrowFunctionExpression: p,
                    StaticBlock: p,
                    BlockStatement: c,
                    ForStatement: c,
                    ForInStatement: c,
                    ForOfStatement: c,
                    SwitchStatement: c,
                    VariableDeclaration: function(e1) {
                        const i = e1.parent, a = e1.kind;
                        if (!o[a]) return;
                        const u = e1.declarations, l = m(u), c = u.some(h) && !u.every(h);
                        o[a].initialized === r && o.separateRequires && c && t.report({
                            node: e1,
                            messageId: "splitRequires"
                        });
                        const p = i.body && i.body.length > 0 && i.body.indexOf(e1) || 0;
                        if (p > 0) {
                            const r = i.body[p - 1], n = "VariableDeclaration" === r.type, c = u.concat(r.declarations || []);
                            if (n && r.kind === a && (!c.some(h) || c.every(h))) {
                                const n = m(r.declarations);
                                o[a].initialized === s && o[a].uninitialized === s ? t.report({
                                    node: e1,
                                    messageId: "combine",
                                    data: {
                                        type: a
                                    },
                                    fix: y(u)
                                }) : o[a].initialized === s && l.initialized > 0 && n.initialized > 0 ? t.report({
                                    node: e1,
                                    messageId: "combineInitialized",
                                    data: {
                                        type: a
                                    },
                                    fix: y(u)
                                }) : o[a].uninitialized === s && l.uninitialized > 0 && n.uninitialized > 0 && t.report({
                                    node: e1,
                                    messageId: "combineUninitialized",
                                    data: {
                                        type: a
                                    },
                                    fix: y(u)
                                });
                            }
                        }
                        if (!g(a, u)) {
                            if (o[a].initialized === r && o[a].uninitialized === r) t.report({
                                node: e1,
                                messageId: "combine",
                                data: {
                                    type: a
                                },
                                fix: y(u)
                            });
                            else if (o[a].initialized === r && l.initialized > 0 && t.report({
                                node: e1,
                                messageId: "combineInitialized",
                                data: {
                                    type: a
                                },
                                fix: y(u)
                            }), o[a].uninitialized === r && l.uninitialized > 0) {
                                if (e1.parent.left === e1 && ("ForInStatement" === e1.parent.type || "ForOfStatement" === e1.parent.type)) return;
                                t.report({
                                    node: e1,
                                    messageId: "combineUninitialized",
                                    data: {
                                        type: a
                                    },
                                    fix: y(u)
                                });
                            }
                        }
                        if ("ForStatement" !== i.type || i.init !== e1) l.uninitialized + l.initialized > 1 && (o[a].initialized === n && o[a].uninitialized === n ? t.report({
                            node: e1,
                            messageId: "split",
                            data: {
                                type: a
                            },
                            fix: E(e1)
                        }) : o[a].initialized === n && l.initialized > 0 ? t.report({
                            node: e1,
                            messageId: "splitInitialized",
                            data: {
                                type: a
                            },
                            fix: E(e1)
                        }) : o[a].uninitialized === n && l.uninitialized > 0 && t.report({
                            node: e1,
                            messageId: "splitUninitialized",
                            data: {
                                type: a
                            },
                            fix: E(e1)
                        }));
                    },
                    "ForStatement:exit": f,
                    "ForOfStatement:exit": f,
                    "ForInStatement:exit": f,
                    "SwitchStatement:exit": f,
                    "BlockStatement:exit": f,
                    "Program:exit": d,
                    "FunctionDeclaration:exit": d,
                    "FunctionExpression:exit": d,
                    "ArrowFunctionExpression:exit": d,
                    "StaticBlock:exit": d
                };
            }
        }, gx;
    }
    function NS() {
        if (vx) return bx;
        vx = 1;
        const e1 = Ll();
        return bx = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent linebreak style for operators",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/operator-linebreak"
                },
                schema: [
                    {
                        enum: [
                            "after",
                            "before",
                            "none",
                            null
                        ]
                    },
                    {
                        type: "object",
                        properties: {
                            overrides: {
                                type: "object",
                                additionalProperties: {
                                    enum: [
                                        "after",
                                        "before",
                                        "none",
                                        "ignore"
                                    ]
                                }
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                fixable: "code",
                messages: {
                    operatorAtBeginning: "'{{operator}}' should be placed at the beginning of the line.",
                    operatorAtEnd: "'{{operator}}' should be placed at the end of the line.",
                    badLinebreak: "Bad line breaking before and after '{{operator}}'.",
                    noLinebreak: "There should be no line break before or after '{{operator}}'."
                }
            },
            create (t) {
                const r = !t.options[0], n = t.options[0] || "after", s = t.options[1] || {}, i = s.overrides ? Object.assign({}, s.overrides) : {};
                r && !i["?"] && (i["?"] = "before"), r && !i[":"] && (i[":"] = "before");
                const o = t.sourceCode;
                function a(r, s, a) {
                    const u = o.getTokenBefore(s, (e1)=>e1.value === a), l = o.getTokenBefore(u), c = o.getTokenAfter(u), p = i[a], f = p || n, d = function(t, r) {
                        return (n)=>{
                            const s = o.getTokenBefore(t), i = o.getTokenAfter(t), a = o.text.slice(s.range[1], t.range[0]), u = o.text.slice(t.range[1], i.range[0]);
                            let l, c;
                            if (!e1.isTokenOnSameLine(s, t) != !e1.isTokenOnSameLine(t, i) && "none" !== r) {
                                if (o.getTokenBefore(t, {
                                    includeComments: !0
                                }) !== s && o.getTokenAfter(t, {
                                    includeComments: !0
                                }) !== i) return null;
                                l = u, c = a;
                            } else {
                                const t = e1.createGlobalLinebreakMatcher();
                                if (l = "before" === r || a.trim() ? a : a.replace(t, ""), c = "after" === r || u.trim() ? u : u.replace(t, ""), l === a && c === u) return null;
                            }
                            return "" === c && "Punctuator" === i.type && "+-".includes(t.value) && i.value === t.value && (c += " "), n.replaceTextRange([
                                s.range[1],
                                i.range[0]
                            ], l + t.value + c);
                        };
                    }(u, f);
                    e1.isTokenOnSameLine(l, u) && e1.isTokenOnSameLine(u, c) || ("ignore" === p || e1.isTokenOnSameLine(l, u) || e1.isTokenOnSameLine(u, c) ? "before" === f && e1.isTokenOnSameLine(l, u) ? t.report({
                        node: r,
                        loc: u.loc,
                        messageId: "operatorAtBeginning",
                        data: {
                            operator: a
                        },
                        fix: d
                    }) : "after" === f && e1.isTokenOnSameLine(u, c) ? t.report({
                        node: r,
                        loc: u.loc,
                        messageId: "operatorAtEnd",
                        data: {
                            operator: a
                        },
                        fix: d
                    }) : "none" === f && t.report({
                        node: r,
                        loc: u.loc,
                        messageId: "noLinebreak",
                        data: {
                            operator: a
                        },
                        fix: d
                    }) : t.report({
                        node: r,
                        loc: u.loc,
                        messageId: "badLinebreak",
                        data: {
                            operator: a
                        },
                        fix: d
                    }));
                }
                function u(e1) {
                    a(e1, e1.right, e1.operator);
                }
                return {
                    BinaryExpression: u,
                    LogicalExpression: u,
                    AssignmentExpression: u,
                    VariableDeclarator (e1) {
                        e1.init && a(e1, e1.init, "=");
                    },
                    PropertyDefinition (e1) {
                        e1.value && a(e1, e1.value, "=");
                    },
                    ConditionalExpression (e1) {
                        a(e1, e1.consequent, "?"), a(e1, e1.alternate, ":");
                    }
                };
            }
        }, bx;
    }
    function OS() {
        if (Tx) return Ax;
        Tx = 1;
        const e1 = Ll();
        return Ax = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Require or disallow padding within blocks",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/padded-blocks"
                },
                fixable: "whitespace",
                schema: [
                    {
                        oneOf: [
                            {
                                enum: [
                                    "always",
                                    "never"
                                ]
                            },
                            {
                                type: "object",
                                properties: {
                                    blocks: {
                                        enum: [
                                            "always",
                                            "never"
                                        ]
                                    },
                                    switches: {
                                        enum: [
                                            "always",
                                            "never"
                                        ]
                                    },
                                    classes: {
                                        enum: [
                                            "always",
                                            "never"
                                        ]
                                    }
                                },
                                additionalProperties: !1,
                                minProperties: 1
                            }
                        ]
                    },
                    {
                        type: "object",
                        properties: {
                            allowSingleLineBlocks: {
                                type: "boolean"
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    alwaysPadBlock: "Block must be padded by blank lines.",
                    neverPadBlock: "Block must not be padded by blank lines."
                }
            },
            create (t) {
                const r = {}, n = t.options[0] || "always", s = t.options[1] || {};
                if ("string" == typeof n) {
                    const e1 = "always" === n;
                    r.blocks = e1, r.switches = e1, r.classes = e1;
                } else Object.prototype.hasOwnProperty.call(n, "blocks") && (r.blocks = "always" === n.blocks), Object.prototype.hasOwnProperty.call(n, "switches") && (r.switches = "always" === n.switches), Object.prototype.hasOwnProperty.call(n, "classes") && (r.classes = "always" === n.classes);
                Object.prototype.hasOwnProperty.call(s, "allowSingleLineBlocks") && (r.allowSingleLineBlocks = !0 === s.allowSingleLineBlocks);
                const i = t.sourceCode;
                function o(e1) {
                    return "Line" === e1.type || "Block" === e1.type;
                }
                function a(e1, t) {
                    return t.loc.start.line - e1.loc.end.line >= 2;
                }
                function u(n) {
                    const s = function(e1) {
                        return "SwitchStatement" === e1.type ? i.getTokenBefore(e1.cases[0]) : "StaticBlock" === e1.type ? i.getFirstToken(e1, {
                            skip: 1
                        }) : i.getFirstToken(e1);
                    }(n), u = function(e1) {
                        let t, r = e1;
                        do t = r, r = i.getTokenAfter(r, {
                            includeComments: !0
                        });
                        while (o(r) && r.loc.start.line === t.loc.end.line);
                        return r;
                    }(s), l = i.getTokenBefore(u, {
                        includeComments: !0
                    }), c = function(e1) {
                        let t, r = e1;
                        do t = r, r = i.getTokenBefore(r, {
                            includeComments: !0
                        });
                        while (o(r) && r.loc.end.line === t.loc.start.line);
                        return r;
                    }(i.getLastToken(n)), p = i.getTokenAfter(c, {
                        includeComments: !0
                    }), f = a(l, u), d = a(c, p);
                    r.allowSingleLineBlocks && e1.isTokenOnSameLine(l, p) || (!function(e1) {
                        switch(e1.type){
                            case "BlockStatement":
                            case "StaticBlock":
                                return r.blocks;
                            case "SwitchStatement":
                                return r.switches;
                            case "ClassBody":
                                return r.classes;
                            default:
                                throw new Error("unreachable");
                        }
                    }(n) ? (f && t.report({
                        node: n,
                        loc: {
                            start: l.loc.start,
                            end: u.loc.start
                        },
                        fix: (e1)=>e1.replaceTextRange([
                                l.range[1],
                                u.range[0] - u.loc.start.column
                            ], "\n"),
                        messageId: "neverPadBlock"
                    }), d && t.report({
                        node: n,
                        loc: {
                            end: p.loc.start,
                            start: c.loc.end
                        },
                        messageId: "neverPadBlock",
                        fix: (e1)=>e1.replaceTextRange([
                                c.range[1],
                                p.range[0] - p.loc.start.column
                            ], "\n")
                    })) : (f || t.report({
                        node: n,
                        loc: {
                            start: l.loc.start,
                            end: u.loc.start
                        },
                        fix: (e1)=>e1.insertTextAfter(l, "\n"),
                        messageId: "alwaysPadBlock"
                    }), d || t.report({
                        node: n,
                        loc: {
                            end: p.loc.start,
                            start: c.loc.end
                        },
                        fix: (e1)=>e1.insertTextBefore(p, "\n"),
                        messageId: "alwaysPadBlock"
                    })));
                }
                const l = {};
                return Object.prototype.hasOwnProperty.call(r, "switches") && (l.SwitchStatement = function(e1) {
                    0 !== e1.cases.length && u(e1);
                }), Object.prototype.hasOwnProperty.call(r, "blocks") && (l.BlockStatement = function(e1) {
                    0 !== e1.body.length && u(e1);
                }, l.StaticBlock = l.BlockStatement), Object.prototype.hasOwnProperty.call(r, "classes") && (l.ClassBody = function(e1) {
                    0 !== e1.body.length && u(e1);
                }), l;
            }
        }, Ax;
    }
    function US() {
        if (Dx) return Rx;
        Dx = 1;
        const e1 = Ll(), t = `[${Array.from(e1.LINEBREAKS).join("")}]`, r = new RegExp(String.raw`^(\s*?${t})\s*${t}(\s*;?)$`, "u"), n = /^(?:module\s*\.\s*)?exports(?:\s*\.|\s*\[|$)/u, s = /^require\(/u;
        function i(e1) {
            return {
                test: (t, r)=>r.getFirstToken(t).value === e1
            };
        }
        function o(e1) {
            return {
                test: (t, r)=>t.loc.start.line === t.loc.end.line && r.getFirstToken(t).value === e1
            };
        }
        function a(e1) {
            return {
                test: (t, r)=>t.loc.start.line !== t.loc.end.line && r.getFirstToken(t).value === e1
            };
        }
        function u(e1) {
            return {
                test: (t)=>t.type === e1
            };
        }
        function l(t) {
            if ("ExpressionStatement" === t.type) {
                let r = e1.skipChainExpression(t.expression);
                return "UnaryExpression" === r.type && (r = e1.skipChainExpression(r.argument)), "CallExpression" === r.type && e1.isFunction(r.callee);
            }
            return !1;
        }
        function c(t, r) {
            if ("DoWhileStatement" === r.type && "BlockStatement" === r.body.type) return !0;
            if (l(r)) return !0;
            const n = t.getLastToken(r, e1.isNotSemicolonToken), s = n && e1.isClosingBraceToken(n) ? t.getNodeByRangeIndex(n.range[0]) : null;
            return Boolean(s) && ("BlockStatement" === s.type || "SwitchStatement" === s.type);
        }
        function p(t, r) {
            const n = t.getLastToken(r), s = t.getTokenBefore(n), i = t.getTokenAfter(n);
            return Boolean(s && i && s.range[0] >= r.range[0] && e1.isSemicolonToken(n) && n.loc.start.line !== s.loc.end.line && n.loc.end.line === i.loc.start.line) ? s : n;
        }
        function f(e1, t, r) {
            return t + r;
        }
        const d = {
            any: {
                verify: function() {}
            },
            never: {
                verify: function(e1, t, n, s) {
                    0 !== s.length && e1.report({
                        node: n,
                        messageId: "unexpectedBlankLine",
                        fix (t) {
                            if (s.length >= 2) return null;
                            const n = s[0][0], i = s[0][1], o = n.range[1], a = i.range[0], u = e1.sourceCode.text.slice(o, a).replace(r, f);
                            return t.replaceTextRange([
                                o,
                                a
                            ], u);
                        }
                    });
                }
            },
            always: {
                verify: function(t, r, n, s) {
                    s.length > 0 || t.report({
                        node: n,
                        messageId: "expectedBlankLine",
                        fix (s) {
                            const i = t.sourceCode;
                            let o = p(i, r);
                            const a = i.getFirstTokenBetween(o, n, {
                                includeComments: !0,
                                filter: (t)=>!e1.isTokenOnSameLine(o, t) || (o = t, !1)
                            }) || n, u = e1.isTokenOnSameLine(o, a) ? "\n\n" : "\n";
                            return s.insertTextAfter(o, u);
                        }
                    });
                }
            }
        }, h = {
            "*": {
                test: ()=>!0
            },
            "block-like": {
                test: (e1, t)=>c(t, e1)
            },
            "cjs-export": {
                test: (e1, t)=>"ExpressionStatement" === e1.type && "AssignmentExpression" === e1.expression.type && n.test(t.getText(e1.expression.left))
            },
            "cjs-import": {
                test: (e1, t)=>"VariableDeclaration" === e1.type && e1.declarations.length > 0 && Boolean(e1.declarations[0].init) && s.test(t.getText(e1.declarations[0].init))
            },
            directive: {
                test: e1.isDirective
            },
            expression: {
                test: (t)=>"ExpressionStatement" === t.type && !e1.isDirective(t)
            },
            iife: {
                test: l
            },
            "multiline-block-like": {
                test: (e1, t)=>e1.loc.start.line !== e1.loc.end.line && c(t, e1)
            },
            "multiline-expression": {
                test: (t)=>t.loc.start.line !== t.loc.end.line && "ExpressionStatement" === t.type && !e1.isDirective(t)
            },
            "multiline-const": a("const"),
            "multiline-let": a("let"),
            "multiline-var": a("var"),
            "singleline-const": o("const"),
            "singleline-let": o("let"),
            "singleline-var": o("var"),
            block: u("BlockStatement"),
            empty: u("EmptyStatement"),
            function: u("FunctionDeclaration"),
            break: i("break"),
            case: i("case"),
            class: i("class"),
            const: i("const"),
            continue: i("continue"),
            debugger: i("debugger"),
            default: i("default"),
            do: i("do"),
            export: i("export"),
            for: i("for"),
            if: i("if"),
            import: i("import"),
            let: i("let"),
            return: i("return"),
            switch: i("switch"),
            throw: i("throw"),
            try: i("try"),
            var: i("var"),
            while: i("while"),
            with: i("with")
        };
        return Rx = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Require or disallow padding lines between statements",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/padding-line-between-statements"
                },
                fixable: "whitespace",
                schema: {
                    definitions: {
                        paddingType: {
                            enum: Object.keys(d)
                        },
                        statementType: {
                            anyOf: [
                                {
                                    enum: Object.keys(h)
                                },
                                {
                                    type: "array",
                                    items: {
                                        enum: Object.keys(h)
                                    },
                                    minItems: 1,
                                    uniqueItems: !0
                                }
                            ]
                        }
                    },
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            blankLine: {
                                $ref: "#/definitions/paddingType"
                            },
                            prev: {
                                $ref: "#/definitions/statementType"
                            },
                            next: {
                                $ref: "#/definitions/statementType"
                            }
                        },
                        additionalProperties: !1,
                        required: [
                            "blankLine",
                            "prev",
                            "next"
                        ]
                    }
                },
                messages: {
                    unexpectedBlankLine: "Unexpected blank line before this statement.",
                    expectedBlankLine: "Expected blank line before this statement."
                }
            },
            create (t) {
                const r = t.sourceCode, n = t.options || [];
                let s = null;
                function i() {
                    s = {
                        upper: s,
                        prevNode: null
                    };
                }
                function o() {
                    s = s.upper;
                }
                function a(e1, t) {
                    let n = e1;
                    for(; "LabeledStatement" === n.type;)n = n.body;
                    return Array.isArray(t) ? t.some(a.bind(null, n)) : h[t].test(n, r);
                }
                function u(i) {
                    const o = i.parent.type;
                    if (!(e1.STATEMENT_LIST_PARENTS.has(o) || "SwitchStatement" === o)) return;
                    const u = s.prevNode;
                    if (u) {
                        const e1 = function(e1, t) {
                            for(let r = n.length - 1; r >= 0; --r){
                                const s = n[r];
                                if (a(e1, s.prev) && a(t, s.next)) return d[s.blankLine];
                            }
                            return d.any;
                        }(u, i), s = function(e1, t) {
                            const n = [];
                            let s = p(r, e1);
                            if (t.loc.start.line - s.loc.end.line >= 2) do {
                                const e1 = r.getTokenAfter(s, {
                                    includeComments: !0
                                });
                                e1.loc.start.line - s.loc.end.line >= 2 && n.push([
                                    s,
                                    e1
                                ]), s = e1;
                            }while (s.range[0] < t.range[0]);
                            return n;
                        }(u, i);
                        e1.verify(t, u, i, s);
                    }
                    s.prevNode = i;
                }
                return {
                    Program: i,
                    BlockStatement: i,
                    SwitchStatement: i,
                    StaticBlock: i,
                    "Program:exit": o,
                    "BlockStatement:exit": o,
                    "SwitchStatement:exit": o,
                    "StaticBlock:exit": o,
                    ":statement": u,
                    SwitchCase: function(e1) {
                        u(e1), i();
                    },
                    "SwitchCase:exit": o
                };
            }
        }, Rx;
    }
    function jS() {
        if (_x) return wx;
        _x = 1;
        const e1 = Ll();
        return wx = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require using arrow functions for callbacks",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/prefer-arrow-callback"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            allowNamedFunctions: {
                                type: "boolean",
                                default: !1
                            },
                            allowUnboundThis: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                fixable: "code",
                messages: {
                    preferArrowCallback: "Unexpected function expression."
                }
            },
            create (t) {
                const r = t.options[0] || {}, n = !1 !== r.allowUnboundThis, s = r.allowNamedFunctions, i = t.sourceCode;
                let o = [];
                function a() {
                    o.push({
                        this: !1,
                        super: !1,
                        meta: !1
                    });
                }
                function u() {
                    return o.pop();
                }
                return {
                    Program () {
                        o = [];
                    },
                    ThisExpression () {
                        const e1 = o[o.length - 1];
                        e1 && (e1.this = !0);
                    },
                    Super () {
                        const e1 = o[o.length - 1];
                        e1 && (e1.super = !0);
                    },
                    MetaProperty (e1) {
                        const t = o[o.length - 1];
                        t && function(e1, t, r) {
                            return e1.meta.name === t && e1.property.name === r;
                        }(e1, "new", "target") && (t.meta = !0);
                    },
                    FunctionDeclaration: a,
                    "FunctionDeclaration:exit": u,
                    FunctionExpression: a,
                    "FunctionExpression:exit" (r) {
                        const o = u();
                        if (s && r.id && r.id.name) return;
                        if (r.generator) return;
                        const a = i.getDeclaredVariables(r)[0];
                        if (function(e1) {
                            return e1 && "FunctionName" === e1.defs[0].type;
                        }(a) && a.references.length > 0) return;
                        const l = function(e1) {
                            const t = e1.variables;
                            for(let e1 = 0; e1 < t.length; ++e1){
                                const r = t[e1];
                                if ("arguments" === r.name) return 0 === r.identifiers.length ? r : null;
                            }
                            return null;
                        }(i.getScope(r));
                        if (l && l.references.length > 0) return;
                        const c = function(t) {
                            const r = {
                                isCallback: !1,
                                isLexicalThis: !1
                            };
                            let n = t, s = t.parent, i = !1;
                            for(; n;){
                                switch(s.type){
                                    case "LogicalExpression":
                                    case "ChainExpression":
                                    case "ConditionalExpression":
                                        break;
                                    case "MemberExpression":
                                        if (s.object !== n || s.property.computed || "Identifier" !== s.property.type || "bind" !== s.property.name) return r;
                                        {
                                            const t = "ChainExpression" === s.parent.type ? s.parent : s;
                                            if (!e1.isCallee(t)) return r;
                                            i || (i = !0, r.isLexicalThis = 1 === t.parent.arguments.length && "ThisExpression" === t.parent.arguments[0].type), s = t.parent;
                                        }
                                        break;
                                    case "CallExpression":
                                    case "NewExpression":
                                        return s.callee !== n && (r.isCallback = !0), r;
                                    default:
                                        return r;
                                }
                                n = s, s = s.parent;
                            }
                            throw new Error("unreachable");
                        }(r);
                        !c.isCallback || n && o.this && !c.isLexicalThis || o.super || o.meta || t.report({
                            node: r,
                            messageId: "preferArrowCallback",
                            *fix (t) {
                                if (!c.isLexicalThis && o.this || (n = r.params).every((e1)=>"Identifier" === e1.type) && n.length !== new Set(n.map((e1)=>e1.name)).size) return;
                                var n;
                                if (c.isLexicalThis) {
                                    const n = r.parent;
                                    if ("MemberExpression" !== n.type) return;
                                    const s = n.parent, o = i.getTokenAfter(n.object, e1.isNotClosingParenToken), a = i.getLastToken(s);
                                    if (e1.isParenthesised(i, n)) return;
                                    if (i.commentsExistBetween(o, a)) return;
                                    yield t.removeRange([
                                        o.range[0],
                                        a.range[1]
                                    ]);
                                }
                                const s = i.getFirstToken(r, r.async ? 1 : 0), a = i.getTokenAfter(s, e1.isOpeningParenToken), u = i.getTokenBefore(r.body);
                                i.commentsExistBetween(s, a) ? (yield t.remove(s), r.id && (yield t.remove(r.id))) : yield t.removeRange([
                                    s.range[0],
                                    a.range[0]
                                ]), yield t.insertTextAfter(u, " =>");
                                let l = c.isLexicalThis ? r.parent.parent : r;
                                "ChainExpression" === l.type && (l = l.parent), "CallExpression" === l.parent.type || "ConditionalExpression" === l.parent.type || e1.isParenthesised(i, l) || e1.isParenthesised(i, r) || (yield t.insertTextBefore(l, "("), yield t.insertTextAfter(l, ")"));
                            }
                        });
                    }
                };
            }
        }, wx;
    }
    function VS() {
        if (Bx) return kx;
        Bx = 1;
        const e1 = LC(), t = Ll(), r = /^(?:.+?Pattern|RestElement|SpreadProperty|ExperimentalRestProperty|Property)$/u, n = /^(?:Program|BlockStatement|StaticBlock|SwitchCase)$/u, s = /^(?:VariableDeclarator|AssignmentExpression)$/u;
        function i(e1, r) {
            if (r.through.some((t)=>t.resolved && t.resolved.name === e1)) return !0;
            const n = t.getVariableByName(r, e1);
            return null !== n && n.defs.some((e1)=>"Parameter" === e1.type);
        }
        function o(e1) {
            if (!e1.isWrite()) return null;
            let t = e1.identifier.parent;
            for(; r.test(t.type);)t = t.parent;
            return s.test(t.type) ? t : null;
        }
        function a(e1) {
            switch(e1.type){
                case "ObjectPattern":
                    return e1.properties.some((e1)=>!!e1 && a(e1.argument || e1.value));
                case "ArrayPattern":
                    return e1.elements.some((e1)=>!!e1 && a(e1));
                case "AssignmentPattern":
                    return a(e1.left);
                case "MemberExpression":
                    return !0;
            }
            return !1;
        }
        function u(e1, t) {
            if (e1.eslintUsed && "global" === e1.scope.type) return null;
            let s = null, u = !1;
            const l = e1.references;
            for(let r = 0; r < l.length; ++r){
                const n = l[r];
                if (n.isWrite()) {
                    if (null !== s && s.identifier !== n.identifier) return null;
                    const t = o(n);
                    if (null !== t && void 0 !== t.left) {
                        const r = t.left;
                        let n = !1, s = !1;
                        if ("ObjectPattern" === r.type) n = r.properties.filter((e1)=>e1.value).map((e1)=>e1.value.name).some((t)=>i(t, e1.scope)), s = a(r);
                        else if ("ArrayPattern" === r.type) n = r.elements.map((e1)=>e1 && e1.name).some((t)=>i(t, e1.scope)), s = a(r);
                        if (n || s) return null;
                    }
                    s = n;
                } else if (n.isRead() && null === s) {
                    if (t) return null;
                    u = !0;
                }
            }
            const c = null !== s && s.from === e1.scope && function(e1) {
                let t = e1.parent;
                for(; r.test(t.type);)t = t.parent;
                return "VariableDeclarator" === t.type || "AssignmentExpression" === t.type && "ExpressionStatement" === t.parent.type && n.test(t.parent.parent.type);
            }(s.identifier);
            return c ? u ? e1.defs[0].name : s.identifier : null;
        }
        function l(e1, t, r) {
            return !e1 || r(e1) ? null : e1.type === t ? e1 : l(e1.parent, t, r);
        }
        return kx = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require `const` declarations for variables that are never reassigned after declared",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/prefer-const"
                },
                fixable: "code",
                schema: [
                    {
                        type: "object",
                        properties: {
                            destructuring: {
                                enum: [
                                    "any",
                                    "all"
                                ],
                                default: "any"
                            },
                            ignoreReadBeforeAssign: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    useConst: "'{{name}}' is never reassigned. Use 'const' instead."
                }
            },
            create (t) {
                const r = t.options[0] || {}, n = t.sourceCode, s = "all" !== r.destructuring, i = !0 === r.ignoreReadBeforeAssign, a = [];
                let c = 0, p = null, f = "";
                function d(r) {
                    const i = r.filter(Boolean);
                    if (r.length && (s || i.length === r.length)) {
                        const s = l(r[0], "VariableDeclaration", (e1)=>e1.type.endsWith("Statement")), o = null === s;
                        if (!o && s.declarations.length > 0) {
                            const e1 = s.declarations[0];
                            if (e1.init) {
                                const t = e1.init.parent;
                                "VariableDeclarator" === t.type && (t.id.name !== f && (f = t.id.name, c = 0), "ObjectPattern" === t.id.type && t.init.name !== f && (f = t.init.name, c = 0), t.id !== p && (p = t.id, c = 0));
                            }
                        }
                        let a = s && ("ForInStatement" === s.parent.type || "ForOfStatement" === s.parent.type || s.declarations.every((e1)=>e1.init)) && i.length === r.length;
                        if (!o && s.declarations && 1 !== s.declarations.length && s && s.declarations && s.declarations.length >= 1) {
                            c += i.length;
                            let e1 = 0;
                            s.declarations.forEach((t)=>{
                                "ObjectPattern" === t.id.type ? e1 += t.id.properties.length : "ArrayPattern" === t.id.type ? e1 += t.id.elements.length : e1 += 1;
                            }), a = a && c === e1;
                        }
                        i.forEach((r)=>{
                            t.report({
                                node: r,
                                messageId: "useConst",
                                data: r,
                                fix: a ? (t)=>{
                                    const r = n.getFirstToken(s, (e1)=>e1.value === s.kind);
                                    return new e1(t, n).retainRange(s.range).replaceTextRange(r.range, "const");
                                } : null
                            });
                        });
                    }
                }
                return {
                    "Program:exit" () {
                        (function(e1, t) {
                            const r = new Map;
                            for(let n = 0; n < e1.length; ++n){
                                const s = e1[n], i = s.references, a = u(s, t);
                                let l = null;
                                for(let e1 = 0; e1 < i.length; ++e1){
                                    const t = i[e1], n = t.identifier;
                                    if (n === l) continue;
                                    l = n;
                                    const s = o(t);
                                    s && (r.has(s) ? r.get(s).push(a) : r.set(s, [
                                        a
                                    ]));
                                }
                            }
                            return r;
                        })(a, i).forEach(d);
                    },
                    VariableDeclaration (e1) {
                        "let" !== e1.kind || function(e1) {
                            return "ForStatement" === e1.parent.type && e1.parent.init === e1;
                        }(e1) || a.push(...n.getDeclaredVariables(e1));
                    }
                };
            }
        }, kx;
    }
    function KS() {
        if (Px) return Lx;
        Px = 1;
        const e1 = Ll(), t = e1.getPrecedence({
            type: "AssignmentExpression"
        });
        return Lx = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require destructuring from arrays and/or objects",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/prefer-destructuring"
                },
                fixable: "code",
                schema: [
                    {
                        oneOf: [
                            {
                                type: "object",
                                properties: {
                                    VariableDeclarator: {
                                        type: "object",
                                        properties: {
                                            array: {
                                                type: "boolean"
                                            },
                                            object: {
                                                type: "boolean"
                                            }
                                        },
                                        additionalProperties: !1
                                    },
                                    AssignmentExpression: {
                                        type: "object",
                                        properties: {
                                            array: {
                                                type: "boolean"
                                            },
                                            object: {
                                                type: "boolean"
                                            }
                                        },
                                        additionalProperties: !1
                                    }
                                },
                                additionalProperties: !1
                            },
                            {
                                type: "object",
                                properties: {
                                    array: {
                                        type: "boolean"
                                    },
                                    object: {
                                        type: "boolean"
                                    }
                                },
                                additionalProperties: !1
                            }
                        ]
                    },
                    {
                        type: "object",
                        properties: {
                            enforceForRenamedProperties: {
                                type: "boolean"
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    preferDestructuring: "Use {{type}} destructuring."
                }
            },
            create (r) {
                const n = r.options[0], s = r.options[1] && r.options[1].enforceForRenamedProperties;
                let i = {
                    VariableDeclarator: {
                        array: !0,
                        object: !0
                    },
                    AssignmentExpression: {
                        array: !0,
                        object: !0
                    }
                };
                function o(e1, t) {
                    return i && i[e1] && i[e1][t];
                }
                function a(e1, t, n) {
                    r.report({
                        node: e1,
                        messageId: "preferDestructuring",
                        data: {
                            type: t
                        },
                        fix: n
                    });
                }
                function u(n, i, u) {
                    if ("MemberExpression" !== i.type || "Super" === i.object.type || "PrivateIdentifier" === i.property.type) return;
                    if (function(e1) {
                        return Number.isInteger(e1.property.value);
                    }(i)) return void (o(u.type, "array") && a(u, "array", null));
                    const l = function(e1) {
                        return "VariableDeclarator" === e1.type && "Identifier" === e1.id.type && "MemberExpression" === e1.init.type && !e1.init.computed && "Identifier" === e1.init.property.type && e1.id.name === e1.init.property.name;
                    }(u) ? (n)=>(function(n, s) {
                            const i = s.init, o = r.sourceCode;
                            if (o.getCommentsInside(s).length > o.getCommentsInside(i.object).length) return null;
                            let a = o.getText(i.object);
                            return e1.getPrecedence(i.object) < t && (a = `(${a})`), n.replaceText(s, `{${i.property.name}} = ${a}`);
                        })(n, u) : null;
                    if (o(u.type, "object") && s) a(u, "object", l);
                    else if (o(u.type, "object")) {
                        const e1 = i.property;
                        ("Literal" === e1.type && n.name === e1.value || "Identifier" === e1.type && n.name === e1.name && !i.computed) && a(u, "object", l);
                    }
                }
                return n && (i = void 0 !== n.array || void 0 !== n.object ? {
                    VariableDeclarator: n,
                    AssignmentExpression: n
                } : n), {
                    VariableDeclarator: function(e1) {
                        e1.init && "MemberExpression" === e1.init.type && u(e1.id, e1.init, e1);
                    },
                    AssignmentExpression: function(e1) {
                        "=" === e1.operator && u(e1.left, e1.right, e1);
                    }
                };
            }
        }, Lx;
    }
    function MS() {
        if (Fx) return Ix;
        Fx = 1;
        const e1 = Ll(), { CALL: t, ReferenceTracker: r } = Hi(), n = e1.getPrecedence({
            type: "BinaryExpression",
            operator: "**"
        });
        function s(e1, t) {
            return t ? `(${e1})` : e1;
        }
        return Ix = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow the use of `Math.pow` in favor of the `**` operator",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/prefer-exponentiation-operator"
                },
                schema: [],
                fixable: "code",
                messages: {
                    useExponentiation: "Use the '**' operator instead of 'Math.pow'."
                }
            },
            create (i) {
                const o = i.sourceCode;
                function a(t) {
                    i.report({
                        node: t,
                        messageId: "useExponentiation",
                        fix (r) {
                            if (2 !== t.arguments.length || t.arguments.some((e1)=>"SpreadElement" === e1.type) || o.getCommentsInside(t).length > 0) return null;
                            const i = t.arguments[0], a = t.arguments[1], u = o.getText(i), l = o.getText(a), c = function(t) {
                                return e1.getPrecedence(t) <= n || "AwaitExpression" === t.type || "UnaryExpression" === t.type;
                            }(i), p = function(t) {
                                return e1.getPrecedence(t) < n;
                            }(a), f = function(t, r) {
                                const s = "ChainExpression" === t.parent.type ? t.parent.parent : t.parent, i = e1.getPrecedence(s);
                                return ("ClassDeclaration" === s.type || s.type.endsWith("Expression") && (-1 === i || i >= n) && !("BinaryExpression" === s.type && "**" === s.operator && s.right === t) && !(("CallExpression" === s.type || "NewExpression" === s.type) && s.arguments.includes(t)) && !("MemberExpression" === s.type && s.computed && s.property === t) && !("ArrayExpression" === s.type)) && !e1.isParenthesised(r, t);
                            }(t, o);
                            let d = "", h = "";
                            if (!f) {
                                if (!c) {
                                    const r = o.getFirstToken(i), n = o.getTokenBefore(t);
                                    n && n.range[1] === t.range[0] && !e1.canTokensBeAdjacent(n, r) && (d = " ");
                                }
                                if (!p) {
                                    const r = o.getLastToken(a), n = o.getTokenAfter(t);
                                    n && t.range[1] === n.range[0] && !e1.canTokensBeAdjacent(r, n) && (h = " ");
                                }
                            }
                            const m = s(u, c), g = s(l, p), y = s(`${m}**${g}`, f);
                            return r.replaceText(t, `${d}${y}${h}`);
                        }
                    });
                }
                return {
                    Program (e1) {
                        const n = o.getScope(e1), s = new r(n), i = {
                            Math: {
                                pow: {
                                    [t]: !0
                                }
                            }
                        };
                        for (const { node: e1 } of s.iterateGlobalReferences(i))a(e1);
                    }
                };
            }
        }, Ix;
    }
    function $S() {
        if (Ox) return Nx;
        Ox = 1;
        const { CALL: e1, CONSTRUCT: t, ReferenceTracker: r, getStringIfConstant: n } = Hi(), s = _C(), i = new s.RegExpParser;
        return Nx = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Enforce using named capture group in regular expression",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/prefer-named-capture-group"
                },
                hasSuggestions: !0,
                schema: [],
                messages: {
                    addGroupName: "Add name to capture group.",
                    addNonCapture: "Convert group to non-capturing.",
                    required: "Capture group '{{group}}' should be converted to a named or non-capturing group."
                }
            },
            create (o) {
                const a = o.sourceCode;
                function u(e1, t, r, n) {
                    let u;
                    try {
                        u = i.parsePattern(e1, 0, e1.length, {
                            unicode: Boolean(n && n.includes("u")),
                            unicodeSets: Boolean(n && n.includes("v"))
                        });
                    } catch  {
                        return;
                    }
                    s.visitRegExpAST(u, {
                        onCapturingGroupEnter (n) {
                            if (!n.name) {
                                const s = a.getText(r), i = function(e1, t, r, n) {
                                    switch(n.type){
                                        case "Literal":
                                            if ("string" == typeof n.value && r.includes("\\")) return null;
                                            break;
                                        case "TemplateLiteral":
                                            if (n.expressions.length || r.slice(1, -1) !== t) return null;
                                            break;
                                        default:
                                            return null;
                                    }
                                    const s = n.range[0] + e1 + 2;
                                    return [
                                        {
                                            fix (e1) {
                                                const r = (t.match(/temp\d+/gu) || []).reduce((e1, t)=>Math.max(e1, Number(t.slice(4))), 0);
                                                return e1.insertTextBeforeRange([
                                                    s,
                                                    s
                                                ], `?<temp${r + 1}>`);
                                            },
                                            messageId: "addGroupName"
                                        },
                                        {
                                            fix: (e1)=>e1.insertTextBeforeRange([
                                                    s,
                                                    s
                                                ], "?:"),
                                            messageId: "addNonCapture"
                                        }
                                    ];
                                }(n.start, e1, s, r);
                                o.report({
                                    node: t,
                                    messageId: "required",
                                    data: {
                                        group: n.raw
                                    },
                                    suggest: i
                                });
                            }
                        }
                    });
                }
                return {
                    Literal (e1) {
                        e1.regex && u(e1.regex.pattern, e1, e1, e1.regex.flags);
                    },
                    Program (s) {
                        const i = a.getScope(s), o = new r(i), l = {
                            RegExp: {
                                [e1]: !0,
                                [t]: !0
                            }
                        };
                        for (const { node: e1 } of o.iterateGlobalReferences(l)){
                            const t = n(e1.arguments[0]), r = n(e1.arguments[1]);
                            t && u(t, e1, e1.arguments[0], r);
                        }
                    }
                };
            }
        }, Nx;
    }
    function qS() {
        if (jx) return Ux;
        jx = 1;
        const e1 = Ll(), t = new Map([
            [
                2,
                {
                    system: "binary",
                    literalPrefix: "0b"
                }
            ],
            [
                8,
                {
                    system: "octal",
                    literalPrefix: "0o"
                }
            ],
            [
                16,
                {
                    system: "hexadecimal",
                    literalPrefix: "0x"
                }
            ]
        ]);
        return Ux = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow `parseInt()` and `Number.parseInt()` in favor of binary, octal, and hexadecimal literals",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/prefer-numeric-literals"
                },
                schema: [],
                messages: {
                    useLiteral: "Use {{system}} literals instead of {{functionName}}()."
                },
                fixable: "code"
            },
            create (r) {
                const n = r.sourceCode;
                return {
                    "CallExpression[arguments.length=2]" (s) {
                        const [i, o] = s.arguments, a = e1.getStaticStringValue(i), u = o.value;
                        if (null !== a && e1.isStringLiteral(i) && "Literal" === o.type && "number" == typeof u && t.has(u) && (l = s.callee, e1.isSpecificId(l, "parseInt") || e1.isSpecificMemberAccess(l, "Number", "parseInt"))) {
                            const { system: i, literalPrefix: o } = t.get(u);
                            r.report({
                                node: s,
                                messageId: "useLiteral",
                                data: {
                                    system: i,
                                    functionName: n.getText(s.callee)
                                },
                                fix (t) {
                                    if (n.getCommentsInside(s).length) return null;
                                    const r = `${o}${a}`;
                                    if (+r !== parseInt(a, u)) return null;
                                    const i = n.getTokenBefore(s), l = n.getTokenAfter(s);
                                    let c = "", p = "";
                                    return i && i.range[1] === s.range[0] && !e1.canTokensBeAdjacent(i, r) && (c = " "), l && s.range[1] === l.range[0] && !e1.canTokensBeAdjacent(r, l) && (p = " "), t.replaceText(s, `${c}${r}${p}`);
                                }
                            });
                        }
                        var l;
                    }
                };
            }
        }, Ux;
    }
    function GS() {
        if (Kx) return Vx;
        Kx = 1;
        const e1 = Ll();
        return Vx = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow use of `Object.prototype.hasOwnProperty.call()` and prefer use of `Object.hasOwn()`",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/prefer-object-has-own"
                },
                schema: [],
                messages: {
                    useHasOwn: "Use 'Object.hasOwn()' instead of 'Object.prototype.hasOwnProperty.call()'."
                },
                fixable: "code"
            },
            create (t) {
                const r = t.sourceCode;
                return {
                    CallExpression (n) {
                        if ("MemberExpression" !== n.callee.type || "MemberExpression" !== n.callee.object.type) return;
                        const s = e1.getStaticPropertyName(n.callee), i = e1.getStaticPropertyName(n.callee.object), o = function(t) {
                            if ("ObjectExpression" === t.object.type && 0 === t.object.properties.length) return !0;
                            const r = "MemberExpression" === t.object.type && "prototype" === e1.getStaticPropertyName(t.object) ? t.object.object : t.object;
                            return "Identifier" === r.type && "Object" === r.name;
                        }(n.callee.object), a = r.getScope(n), u = e1.getVariableByName(a, "Object");
                        "call" === s && "hasOwnProperty" === i && o && u && "global" === u.scope.type && t.report({
                            node: n,
                            messageId: "useHasOwn",
                            fix (t) {
                                if (r.getCommentsInside(n.callee).length > 0) return null;
                                const s = r.getTokenBefore(n.callee, {
                                    includeComments: !0
                                });
                                return s && s.range[1] === n.callee.range[0] && !e1.canTokensBeAdjacent(s, "Object.hasOwn") ? t.replaceText(n.callee, " Object.hasOwn") : t.replaceText(n.callee, "Object.hasOwn");
                            }
                        });
                    }
                };
            }
        }, Vx;
    }
    function WS() {
        if ($x) return Mx;
        $x = 1;
        const { CALL: e1, ReferenceTracker: t } = Hi(), { isCommaToken: r, isOpeningParenToken: n, isClosingParenToken: s, isParenthesised: i } = Ll(), o = /\s/u;
        function a(e1) {
            return e1.arguments.some((e1)=>"SpreadElement" === e1.type);
        }
        function u(e1) {
            return "Property" === e1.type && ("get" === e1.kind || "set" === e1.kind);
        }
        function l(e1) {
            return e1.properties.some(u);
        }
        function c(e1) {
            return e1.arguments.filter((e1)=>"ObjectExpression" === e1.type).some(l);
        }
        function p(e1, t) {
            switch(e1.type){
                case "AssignmentExpression":
                case "ArrowFunctionExpression":
                case "ConditionalExpression":
                    return !i(t, e1);
                default:
                    return !1;
            }
        }
        function f(e1, t, r) {
            const i = [
                r.getFirstToken(e1),
                r.getLastToken(e1)
            ];
            let o = r.getTokenBefore(e1), a = r.getTokenAfter(e1);
            for(; o && a && o.range[0] > t.range[0] && n(o) && s(a);)i.push(o, a), o = r.getTokenBefore(o), a = r.getTokenAfter(a);
            return i.sort((e1, t)=>e1.range[0] - t.range[0]);
        }
        function d(e1, t) {
            const r = t.text;
            let n = e1.range[0];
            {
                const r = t.getTokenBefore(e1, {
                    includeComments: !0
                });
                if (r && "Line" === r.type) return n;
            }
            for(; o.test(r[n - 1] || "");)n -= 1;
            return n;
        }
        function h(e1, t) {
            const r = t.text;
            let n = e1.range[1];
            for(; o.test(r[n] || "");)n += 1;
            return n;
        }
        function m(e1, t) {
            return function*(s) {
                const o = t.getTokenAfter(e1.callee, n), a = t.getLastToken(e1);
                yield s.removeRange([
                    e1.range[0],
                    o.range[0]
                ]), !function(e1, t) {
                    const r = e1.parent;
                    switch(r.type){
                        case "VariableDeclarator":
                        case "ArrayExpression":
                        case "ReturnStatement":
                        case "CallExpression":
                        case "Property":
                            return !1;
                        case "AssignmentExpression":
                            return r.left === e1 && !i(t, e1);
                        default:
                            return !i(t, e1);
                    }
                }(e1, t) ? (yield s.replaceText(o, "{"), yield s.replaceText(a, "}")) : (yield s.replaceText(o, "({"), yield s.replaceText(a, "})"));
                for (const n of e1.arguments){
                    const e1 = f(n, o, t), i = e1.shift(), a = e1.pop();
                    if ("ObjectExpression" === n.type) {
                        const o = t.getLastToken(n, 1), u = t.getTokenAfter(a);
                        for (const t of e1)yield s.remove(t);
                        const l = [
                            i.range[0],
                            h(i, t)
                        ], c = [
                            Math.max(d(a, t), l[1]),
                            a.range[1]
                        ];
                        yield s.removeRange(l), yield s.removeRange(c), (0 === n.properties.length || r(o)) && r(u) && (yield s.remove(u));
                    } else p(n, t) ? (yield s.insertTextBefore(i, "...("), yield s.insertTextAfter(a, ")")) : yield s.insertTextBefore(i, "...");
                }
            };
        }
        return Mx = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow using Object.assign with an object literal as the first argument and prefer the use of object spread instead",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/prefer-object-spread"
                },
                schema: [],
                fixable: "code",
                messages: {
                    useSpreadMessage: "Use an object spread instead of `Object.assign` eg: `{ ...foo }`.",
                    useLiteralMessage: "Use an object literal instead of `Object.assign`. eg: `{ foo: bar }`."
                }
            },
            create (r) {
                const n = r.sourceCode;
                return {
                    Program (s) {
                        const i = n.getScope(s), o = new t(i), u = {
                            Object: {
                                assign: {
                                    [e1]: !0
                                }
                            }
                        };
                        for (const { node: e1 } of o.iterateGlobalReferences(u))if (e1.arguments.length >= 1 && "ObjectExpression" === e1.arguments[0].type && !a(e1) && !(e1.arguments.length > 1 && c(e1))) {
                            const t = 1 === e1.arguments.length ? "useLiteralMessage" : "useSpreadMessage", s = m(e1, n);
                            r.report({
                                node: e1,
                                messageId: t,
                                fix: s
                            });
                        }
                    }
                };
            }
        }, Mx;
    }
    function XS() {
        if (Gx) return qx;
        Gx = 1;
        const e1 = Ll();
        return qx = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require using Error objects as Promise rejection reasons",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/prefer-promise-reject-errors"
                },
                fixable: null,
                schema: [
                    {
                        type: "object",
                        properties: {
                            allowEmptyReject: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    rejectAnError: "Expected the Promise rejection reason to be an Error."
                }
            },
            create (t) {
                const r = t.options.length && t.options[0].allowEmptyReject, n = t.sourceCode;
                function s(n) {
                    !n.arguments.length && r || n.arguments.length && e1.couldBeError(n.arguments[0]) && ("Identifier" !== n.arguments[0].type || "undefined" !== n.arguments[0].name) || t.report({
                        node: n,
                        messageId: "rejectAnError"
                    });
                }
                return {
                    CallExpression (t) {
                        (function(t) {
                            return e1.isSpecificMemberAccess(t.callee, "Promise", "reject");
                        })(t) && s(t);
                    },
                    "NewExpression:exit" (t) {
                        "Identifier" === t.callee.type && "Promise" === t.callee.name && t.arguments.length && e1.isFunction(t.arguments[0]) && t.arguments[0].params.length > 1 && "Identifier" === t.arguments[0].params[1].type && n.getDeclaredVariables(t.arguments[0]).find((e1)=>e1.name === t.arguments[0].params[1].name).references.filter((e1)=>e1.isRead()).filter((e1)=>"CallExpression" === e1.identifier.parent.type && e1.identifier === e1.identifier.parent.callee).forEach((e1)=>s(e1.identifier.parent));
                    }
                };
            }
        }, qx;
    }
    function zS() {
        if (Hx) return zx;
        Hx = 1;
        const e1 = Ll(), { CALL: t, CONSTRUCT: r, ReferenceTracker: n, findVariable: s } = Hi(), { RegExpValidator: i, visitRegExpAST: o, RegExpParser: a } = _C(), { canTokensBeAdjacent: u } = Ll(), { REGEXPP_LATEST_ECMA_VERSION: l } = QC();
        function c(e1) {
            return "Literal" === e1.type && "string" == typeof e1.value;
        }
        function p(e1) {
            return "Literal" === e1.type && Object.prototype.hasOwnProperty.call(e1, "regex");
        }
        const f = new Set([
            "(",
            ";",
            "[",
            ",",
            "=",
            "+",
            "*",
            "-",
            "?",
            "~",
            "%",
            "**",
            "!",
            "typeof",
            "instanceof",
            "&&",
            "||",
            "??",
            "return",
            "...",
            "delete",
            "void",
            "in",
            "<",
            ">",
            "<=",
            ">=",
            "==",
            "===",
            "!=",
            "!==",
            "<<",
            ">>",
            ">>>",
            "&",
            "|",
            "^",
            ":",
            "{",
            "=>",
            "*=",
            "<<=",
            ">>=",
            ">>>=",
            "^=",
            "|=",
            "&=",
            "??=",
            "||=",
            "&&=",
            "**=",
            "+=",
            "-=",
            "/=",
            "%=",
            "/",
            "do",
            "break",
            "continue",
            "debugger",
            "case",
            "throw"
        ]);
        return zx = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Disallow use of the `RegExp` constructor in favor of regular expression literals",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/prefer-regex-literals"
                },
                hasSuggestions: !0,
                schema: [
                    {
                        type: "object",
                        properties: {
                            disallowRedundantWrapping: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unexpectedRegExp: "Use a regular expression literal instead of the 'RegExp' constructor.",
                    replaceWithLiteral: "Replace with an equivalent regular expression literal.",
                    replaceWithLiteralAndFlags: "Replace with an equivalent regular expression literal with flags '{{ flags }}'.",
                    replaceWithIntendedLiteralAndFlags: "Replace with a regular expression literal with flags '{{ flags }}'.",
                    unexpectedRedundantRegExp: "Regular expression literal is unnecessarily wrapped within a 'RegExp' constructor.",
                    unexpectedRedundantRegExpWithFlags: "Use regular expression literal with flags instead of the 'RegExp' constructor."
                }
            },
            create (d) {
                const [{ disallowRedundantWrapping: h = !1 } = {}] = d.options, m = d.sourceCode;
                function g(t) {
                    return "TaggedTemplateExpression" === t.type && e1.isSpecificMemberAccess(t.tag, "String", "raw") && function(e1) {
                        const t = m.getScope(e1), r = s(t, e1);
                        return null !== r && "global" === r.scope.type && 0 === r.defs.length;
                    }(e1.skipChainExpression(t.tag).object) && e1.isStaticTemplateLiteral(t.quasi);
                }
                function y(t) {
                    return c(t) ? t.value : e1.isStaticTemplateLiteral(t) ? t.quasis[0].value.cooked : g(t) ? t.quasi.quasis[0].value.raw : null;
                }
                function E(t) {
                    return c(t) || e1.isStaticTemplateLiteral(t) || g(t);
                }
                function x(e1) {
                    const t = e1.arguments;
                    return !(1 !== t.length && 2 !== t.length || !t.every(E));
                }
                function C(e1) {
                    const t = e1.arguments;
                    return !(1 !== t.length || !p(t[0])) || !(2 !== t.length || !p(t[0]) || !E(t[1]));
                }
                const S = (b = d.languageOptions.ecmaVersion) <= 5 ? 5 : Math.min(b, l);
                var b;
                function v(e1) {
                    switch(e1){
                        case "\n":
                        case "\\\n":
                            return "\\n";
                        case "\r":
                        case "\\\r":
                            return "\\r";
                        case "\t":
                        case "\\\t":
                            return "\\t";
                        case "\v":
                        case "\\\v":
                            return "\\v";
                        case "\f":
                        case "\\\f":
                            return "\\f";
                        case "/":
                            return "\\/";
                        default:
                            return null;
                    }
                }
                function A(e1, t) {
                    return [
                        ...e1
                    ].sort().join("") === [
                        ...t
                    ].sort().join("");
                }
                function T(e1, t, r) {
                    const n = m.getTokenBefore(e1);
                    return 0 === m.getCommentsInside(e1).length && (!n || f.has(n.value)) && function(e1, t) {
                        const r = new i({
                            ecmaVersion: S
                        });
                        try {
                            return r.validatePattern(e1, 0, e1.length, {
                                unicode: !!t && t.includes("u"),
                                unicodeSets: !!t && t.includes("v")
                            }), t && r.validateFlags(t), !0;
                        } catch  {
                            return !1;
                        }
                    }(t, r);
                }
                function R(e1, t) {
                    const r = m.getTokenBefore(e1), n = m.getTokenAfter(e1);
                    return (r && !u(r, t) && r.range[1] === e1.range[0] ? " " : "") + t + (n && !u(t, n) && e1.range[1] === n.range[0] ? " " : "");
                }
                return {
                    Program (e1) {
                        const s = m.getScope(e1), i = new n(s), u = {
                            RegExp: {
                                [t]: !0,
                                [r]: !0
                            }
                        };
                        for (const { node: e1 } of i.iterateGlobalReferences(u))if (h && C(e1)) {
                            const t = e1.arguments[0];
                            if (2 === e1.arguments.length) {
                                const r = [], n = y(e1.arguments[1]) || "";
                                T(e1, t.regex.pattern, n) && r.push({
                                    messageId: "replaceWithLiteralAndFlags",
                                    pattern: t.regex.pattern,
                                    flags: n
                                });
                                const s = t.regex.flags || "", i = (l = s, c = n, [
                                    ...new Set([
                                        ...l,
                                        ...c
                                    ])
                                ].join(""));
                                !A(i, n) && T(e1, t.regex.pattern, i) && r.push({
                                    messageId: "replaceWithIntendedLiteralAndFlags",
                                    pattern: t.regex.pattern,
                                    flags: i
                                }), d.report({
                                    node: e1,
                                    messageId: "unexpectedRedundantRegExpWithFlags",
                                    suggest: r.map(({ flags: t, pattern: r, messageId: n })=>({
                                            messageId: n,
                                            data: {
                                                flags: t
                                            },
                                            fix: (n)=>n.replaceText(e1, R(e1, `/${r}/${t}`))
                                        }))
                                });
                            } else {
                                const r = [];
                                T(e1, t.regex.pattern, t.regex.flags) && r.push(m.getText(t)), d.report({
                                    node: e1,
                                    messageId: "unexpectedRedundantRegExp",
                                    suggest: r.map((t)=>({
                                            messageId: "replaceWithLiteral",
                                            fix: (r)=>r.replaceText(e1, R(e1, t))
                                        }))
                                });
                            }
                        } else if (x(e1)) {
                            let t, r = y(e1.arguments[0]), n = !1;
                            if (e1.arguments[1] && (t = y(e1.arguments[1])), T(e1, r, t) || (n = !0), /^[-a-zA-Z0-9\\[\](){} \t\r\n\v\f!@#$%^&*+^_=/~`.><?,'"|:;]*$/u.test(r) || (n = !0), r && !n) {
                                let e1 = 0;
                                const n = new a({
                                    ecmaVersion: S
                                }).parsePattern(r, 0, r.length, {
                                    unicode: !!t && t.includes("u"),
                                    unicodeSets: !!t && t.includes("v")
                                });
                                o(n, {
                                    onCharacterEnter (t) {
                                        const n = v(t.raw);
                                        n && (r = r.slice(0, t.start + e1) + n + r.slice(t.end + e1), 1 === t.raw.length && (e1 += 1));
                                    }
                                });
                            }
                            const s = `/${r || "(?:)"}/${t || ""}`;
                            d.report({
                                node: e1,
                                messageId: "unexpectedRegExp",
                                suggest: n ? [] : [
                                    {
                                        messageId: "replaceWithLiteral",
                                        fix: (t)=>t.replaceText(e1, R(e1, s))
                                    }
                                ]
                            });
                        }
                        var l, c;
                    }
                };
            }
        }, zx;
    }
    function HS() {
        if (Zx) return Yx;
        Zx = 1;
        const e1 = Ll();
        return Yx = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require spread operators instead of `.apply()`",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/prefer-spread"
                },
                schema: [],
                fixable: null,
                messages: {
                    preferSpread: "Use the spread operator instead of '.apply()'."
                }
            },
            create (t) {
                const r = t.sourceCode;
                return {
                    CallExpression (n) {
                        if (!function(t) {
                            return e1.isSpecificMemberAccess(t.callee, null, "apply") && 2 === t.arguments.length && "ArrayExpression" !== t.arguments[1].type && "SpreadElement" !== t.arguments[1].type;
                        }(n)) return;
                        const s = e1.skipChainExpression(e1.skipChainExpression(n.callee).object);
                        (function(t, r, n) {
                            return t ? e1.equalTokens(t, r, n) : e1.isNullOrUndefined(r);
                        })("MemberExpression" === s.type ? s.object : null, n.arguments[0], r) && t.report({
                            node: n,
                            messageId: "preferSpread"
                        });
                    }
                };
            }
        }, Yx;
    }
    function JS() {
        if (tC) return eC;
        tC = 1;
        const e1 = Ll();
        function t(e1) {
            return "BinaryExpression" === e1.type && "+" === e1.operator;
        }
        function r(e1) {
            let r = e1;
            for(; t(r.parent);)r = r.parent;
            return r;
        }
        function n(r) {
            return t(r) ? n(r.left) || n(r.right) : "Literal" === r.type && "string" == typeof r.value && e1.hasOctalOrNonOctalDecimalEscapeSequence(r.raw);
        }
        function s(r) {
            return t(r) ? s(r.right) || s(r.left) : e1.isStringLiteral(r);
        }
        function i(r) {
            return t(r) ? i(r.right) || i(r.left) : !e1.isStringLiteral(r);
        }
        function o(e1) {
            return "BinaryExpression" === e1.type ? o(e1.left) : "TemplateLiteral" === e1.type ? e1.expressions.length && e1.quasis.length && e1.quasis[0].range[0] === e1.quasis[0].range[1] : "Literal" !== e1.type || "string" != typeof e1.value;
        }
        return eC = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require template literals instead of string concatenation",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/prefer-template"
                },
                schema: [],
                fixable: "code",
                messages: {
                    unexpectedStringConcatenation: "Unexpected string concatenation."
                }
            },
            create (a) {
                const u = a.sourceCode;
                let l = Object.create(null);
                function c(e1, t) {
                    const r = [
                        e1
                    ].concat(u.getTokensBetween(e1, t)).concat(t), n = u.getText();
                    return r.slice(0, -1).reduce((e1, t, s)=>e1 + n.slice(t.range[1], r[s + 1].range[0]), "");
                }
                function p(e1, r, n) {
                    if ("Literal" === e1.type && "string" == typeof e1.value) return `\`${e1.raw.slice(1, -1).replace(/\\*(\$\{|`)/gu, (e1)=>e1.lastIndexOf("\\") % 2 ? `\\${e1}` : e1).replace(new RegExp(`\\\\${e1.raw[0]}`, "gu"), e1.raw[0])}\``;
                    if ("TemplateLiteral" === e1.type) return u.getText(e1);
                    if (t(e1) && s(e1)) {
                        const t = u.getFirstTokenBetween(e1.left, e1.right, (e1)=>"+" === e1.value), s = c(e1.left, t), i = c(t, e1.right), a = function(e1) {
                            return "BinaryExpression" === e1.type ? o(e1.right) : "TemplateLiteral" === e1.type ? e1.expressions.length && e1.quasis.length && e1.quasis[e1.quasis.length - 1].range[0] === e1.quasis[e1.quasis.length - 1].range[1] : "Literal" !== e1.type || "string" != typeof e1.value;
                        }(e1.left), l = o(e1.right);
                        return a ? p(e1.left, r, s + i).slice(0, -1) + p(e1.right, null, n).slice(1) : l ? p(e1.left, r, null).slice(0, -1) + p(e1.right, s + i, n).slice(1) : `${p(e1.left, r, null)}${s}+${i}${p(e1.right, n, null)}`;
                    }
                    return `\`\${${r || ""}${u.getText(e1)}${n || ""}}\``;
                }
                function f(e1, t) {
                    const s = r(t.parent);
                    return n(s) ? null : e1.replaceText(s, p(s, null, null));
                }
                function d(n) {
                    if (!e1.isStringLiteral(n) || !t(n.parent)) return;
                    const s = r(n.parent);
                    l[s.range[0]] || (l[s.range[0]] = !0, i(s) && a.report({
                        node: s,
                        messageId: "unexpectedStringConcatenation",
                        fix: (e1)=>f(e1, n)
                    }));
                }
                return {
                    Program () {
                        l = Object.create(null);
                    },
                    Literal: d,
                    TemplateLiteral: d
                };
            }
        }, eC;
    }
    function QS() {
        if (nC) return rC;
        nC = 1;
        const e1 = wr(), t = Ll(), r = cd();
        return rC = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "suggestion",
                docs: {
                    description: "Require quotes around object literal property names",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/quote-props"
                },
                schema: {
                    anyOf: [
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "always",
                                        "as-needed",
                                        "consistent",
                                        "consistent-as-needed"
                                    ]
                                }
                            ],
                            minItems: 0,
                            maxItems: 1
                        },
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "always",
                                        "as-needed",
                                        "consistent",
                                        "consistent-as-needed"
                                    ]
                                },
                                {
                                    type: "object",
                                    properties: {
                                        keywords: {
                                            type: "boolean"
                                        },
                                        unnecessary: {
                                            type: "boolean"
                                        },
                                        numbers: {
                                            type: "boolean"
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            minItems: 0,
                            maxItems: 2
                        }
                    ]
                },
                fixable: "code",
                messages: {
                    requireQuotesDueToReservedWord: "Properties should be quoted as '{{property}}' is a reserved word.",
                    inconsistentlyQuotedProperty: "Inconsistently quoted property '{{key}}' found.",
                    unnecessarilyQuotedProperty: "Unnecessarily quoted property '{{property}}' found.",
                    unquotedReservedProperty: "Unquoted reserved word '{{property}}' used as key.",
                    unquotedNumericProperty: "Unquoted number literal '{{property}}' used as key.",
                    unquotedPropertyFound: "Unquoted property '{{property}}' found.",
                    redundantQuoting: "Properties shouldn't be quoted as all quotes are redundant."
                }
            },
            create (n) {
                const s = n.options[0], i = n.options[1] && n.options[1].keywords, o = !n.options[1] || !1 !== n.options[1].unnecessary, a = n.options[1] && n.options[1].numbers, u = n.sourceCode;
                function l(e1) {
                    return r.includes(e1);
                }
                function c(e1, t, r) {
                    return 1 === t.length && 0 === t[0].start && t[0].end === e1.length && ([
                        "Identifier",
                        "Keyword",
                        "Null",
                        "Boolean"
                    ].includes(t[0].type) || "Numeric" === t[0].type && !r && String(+t[0].value) === t[0].value);
                }
                function p(e1) {
                    return "Identifier" === e1.type ? e1.name : e1.value;
                }
                function f(e1) {
                    return "Literal" === e1.type && "string" == typeof e1.value ? u.getText(e1) : `"${"Identifier" === e1.type ? e1.name : e1.value}"`;
                }
                function d(t, r) {
                    const s = [], o = [];
                    let a = null, u = !1;
                    t.properties.forEach((t)=>{
                        const n = t.key;
                        if (n && !t.method && !t.computed && !t.shorthand) {
                            if ("Literal" === n.type && "string" == typeof n.value) {
                                if (s.push(t), r) {
                                    let t;
                                    try {
                                        t = e1.tokenize(n.value);
                                    } catch  {
                                        return void (u = !0);
                                    }
                                    u = u || !c(n.value, t) || i && l(t[0].value);
                                }
                            } else i && r && "Identifier" === n.type && l(n.name) ? (o.push(t), u = !0, a = n.name) : o.push(t);
                        }
                    }), r && s.length && !u ? s.forEach((e1)=>{
                        n.report({
                            node: e1,
                            messageId: "redundantQuoting",
                            fix: (t)=>t.replaceText(e1.key, p(e1.key))
                        });
                    }) : o.length && a ? o.forEach((e1)=>{
                        n.report({
                            node: e1,
                            messageId: "requireQuotesDueToReservedWord",
                            data: {
                                property: a
                            },
                            fix: (t)=>t.replaceText(e1.key, f(e1.key))
                        });
                    }) : s.length && o.length && o.forEach((e1)=>{
                        n.report({
                            node: e1,
                            messageId: "inconsistentlyQuotedProperty",
                            data: {
                                key: e1.key.name || e1.key.value
                            },
                            fix: (t)=>t.replaceText(e1.key, f(e1.key))
                        });
                    });
                }
                return {
                    Property (r) {
                        "always" !== s && s || function(e1) {
                            const t = e1.key;
                            e1.method || e1.computed || e1.shorthand || "Literal" === t.type && "string" == typeof t.value || n.report({
                                node: e1,
                                messageId: "unquotedPropertyFound",
                                data: {
                                    property: t.name || t.value
                                },
                                fix: (e1)=>e1.replaceText(t, f(t))
                            });
                        }(r), "as-needed" === s && function(r) {
                            const s = r.key;
                            if (!(r.method || r.computed || r.shorthand)) {
                                if ("Literal" === s.type && "string" == typeof s.value) {
                                    let t;
                                    try {
                                        t = e1.tokenize(s.value);
                                    } catch  {
                                        return;
                                    }
                                    if (1 !== t.length) return;
                                    if (l(t[0].value) && i) return;
                                    o && c(s.value, t, a) && n.report({
                                        node: r,
                                        messageId: "unnecessarilyQuotedProperty",
                                        data: {
                                            property: s.value
                                        },
                                        fix: (e1)=>e1.replaceText(s, p(s))
                                    });
                                } else i && "Identifier" === s.type && l(s.name) ? n.report({
                                    node: r,
                                    messageId: "unquotedReservedProperty",
                                    data: {
                                        property: s.name
                                    },
                                    fix: (e1)=>e1.replaceText(s, f(s))
                                }) : a && "Literal" === s.type && t.isNumericLiteral(s) && n.report({
                                    node: r,
                                    messageId: "unquotedNumericProperty",
                                    data: {
                                        property: s.value
                                    },
                                    fix: (e1)=>e1.replaceText(s, f(s))
                                });
                            }
                        }(r);
                    },
                    ObjectExpression (e1) {
                        "consistent" === s && d(e1, !1), "consistent-as-needed" === s && d(e1, !0);
                    }
                };
            }
        }, rC;
    }
    function YS() {
        if (iC) return sC;
        iC = 1;
        const e1 = Ll(), t = {
            double: {
                quote: '"',
                alternateQuote: "'",
                description: "doublequote"
            },
            single: {
                quote: "'",
                alternateQuote: '"',
                description: "singlequote"
            },
            backtick: {
                quote: "`",
                alternateQuote: '"',
                description: "backtick"
            }
        }, r = new RegExp(String.raw`(^|[^\\])(\\\\)*[${Array.from(e1.LINEBREAKS).join("")}]`, "u");
        t.double.convert = t.single.convert = t.backtick.convert = function(e1) {
            const t = this.quote, r = e1[0];
            return t === r ? e1 : t + e1.slice(1, -1).replace(/\\(\$\{|\r\n?|\n|.)|["'`]|\$\{|(\r\n?|\n)/gu, (e1, n, s)=>n === r || "`" === r && "${" === n ? n : e1 === t || "`" === t && "${" === e1 ? `\\${e1}` : s && "`" === r ? "\\n" : e1) + t;
        };
        return sC = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce the consistent use of either backticks, double, or single quotes",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/quotes"
                },
                fixable: "code",
                schema: [
                    {
                        enum: [
                            "single",
                            "double",
                            "backtick"
                        ]
                    },
                    {
                        anyOf: [
                            {
                                enum: [
                                    "avoid-escape"
                                ]
                            },
                            {
                                type: "object",
                                properties: {
                                    avoidEscape: {
                                        type: "boolean"
                                    },
                                    allowTemplateLiterals: {
                                        type: "boolean"
                                    }
                                },
                                additionalProperties: !1
                            }
                        ]
                    }
                ],
                messages: {
                    wrongQuotes: "Strings must use {{description}}."
                }
            },
            create (n) {
                const s = n.options[0], i = t[s || "double"], o = n.options[1], a = o && !0 === o.allowTemplateLiterals, u = n.sourceCode;
                let l = o && !0 === o.avoidEscape;
                function c(t) {
                    return "ExpressionStatement" === t.type && "Literal" === t.expression.type && "string" == typeof t.expression.value && !e1.isParenthesised(u, t.expression);
                }
                function p(t) {
                    const r = t.parent;
                    switch(r.type){
                        case "ExpressionStatement":
                            return !e1.isParenthesised(u, t) && function(t) {
                                if (!e1.isTopLevelExpressionStatement(t.parent)) return !1;
                                const r = t.parent.parent;
                                for(let e1 = 0; e1 < r.body.length; ++e1){
                                    const n = r.body[e1];
                                    if (n === t.parent) return !0;
                                    if (!c(n)) break;
                                }
                                return !1;
                            }(t);
                        case "Property":
                        case "PropertyDefinition":
                        case "MethodDefinition":
                            return r.key === t && !r.computed;
                        case "ImportDeclaration":
                        case "ExportNamedDeclaration":
                            return r.source === t;
                        case "ExportAllDeclaration":
                            return r.exported === t || r.source === t;
                        case "ImportSpecifier":
                            return r.imported === t;
                        case "ExportSpecifier":
                            return r.local === t || r.exported === t;
                        default:
                            return !1;
                    }
                }
                return "avoid-escape" === o && (l = !0), {
                    Literal (t) {
                        const r = t.value, o = t.raw;
                        if (i && "string" == typeof r) {
                            let r = "backtick" === s && p(t) || function(e1) {
                                return "JSXAttribute" === e1.parent.type || "JSXElement" === e1.parent.type || "JSXFragment" === e1.parent.type;
                            }(t) || e1.isSurroundedBy(o, i.quote);
                            !r && l && (r = e1.isSurroundedBy(o, i.alternateQuote) && o.includes(i.quote)), r || n.report({
                                node: t,
                                messageId: "wrongQuotes",
                                data: {
                                    description: i.description
                                },
                                fix: (r)=>"backtick" === s && e1.hasOctalOrNonOctalDecimalEscapeSequence(o) ? null : r.replaceText(t, i.convert(t.raw))
                            });
                        }
                    },
                    TemplateLiteral (t) {
                        a || "backtick" === s || function(e1) {
                            return "TaggedTemplateExpression" === e1.parent.type && e1 === e1.parent.quasi || e1.expressions.length > 0 || !!(e1.quasis.length >= 1 && r.test(e1.quasis[0].value.raw));
                        }(t) || n.report({
                            node: t,
                            messageId: "wrongQuotes",
                            data: {
                                description: i.description
                            },
                            fix: (r)=>e1.isTopLevelExpressionStatement(t.parent) && !e1.isParenthesised(u, t) ? null : r.replaceText(t, i.convert(u.getText(t)))
                        });
                    }
                };
            }
        }, sC;
    }
    function ZS() {
        if (aC) return oC;
        aC = 1;
        const e1 = Ll(), t = "always", r = new Set(Array.from({
            length: 35
        }, (e1, t)=>t + 2));
        function n(e1) {
            return e1.defs.length >= 1;
        }
        return oC = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Enforce the consistent use of the radix argument when using `parseInt()`",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/radix"
                },
                hasSuggestions: !0,
                schema: [
                    {
                        enum: [
                            "always",
                            "as-needed"
                        ]
                    }
                ],
                messages: {
                    missingParameters: "Missing parameters.",
                    redundantRadix: "Redundant radix parameter.",
                    missingRadix: "Missing radix parameter.",
                    invalidRadix: "Invalid radix parameter, must be an integer between 2 and 36.",
                    addRadixParameter10: "Add radix parameter `10` for parsing decimal numbers."
                }
            },
            create (s) {
                const i = s.options[0] || t, o = s.sourceCode;
                function a(e1) {
                    const n = e1.arguments;
                    switch(n.length){
                        case 0:
                            s.report({
                                node: e1,
                                messageId: "missingParameters"
                            });
                            break;
                        case 1:
                            i === t && s.report({
                                node: e1,
                                messageId: "missingRadix",
                                suggest: [
                                    {
                                        messageId: "addRadixParameter10",
                                        fix (t) {
                                            const r = o.getTokens(e1), n = r[r.length - 1], s = r[r.length - 2], i = "Punctuator" === s.type && "," === s.value;
                                            return t.insertTextBefore(n, i ? " 10," : ", 10");
                                        }
                                    }
                                ]
                            });
                            break;
                        default:
                            "as-needed" === i && function(e1) {
                                return "Literal" === e1.type && 10 === e1.value;
                            }(n[1]) ? s.report({
                                node: e1,
                                messageId: "redundantRadix"
                            }) : function(e1) {
                                return !("Literal" === e1.type && !r.has(e1.value) || "Identifier" === e1.type && "undefined" === e1.name);
                            }(n[1]) || s.report({
                                node: e1,
                                messageId: "invalidRadix"
                            });
                    }
                }
                return {
                    "Program:exit" (t) {
                        const r = o.getScope(t);
                        let s;
                        s = e1.getVariableByName(r, "parseInt"), s && !n(s) && s.references.forEach((t)=>{
                            const r = t.identifier;
                            e1.isCallee(r) && a(r.parent);
                        }), s = e1.getVariableByName(r, "Number"), s && !n(s) && s.references.forEach((t)=>{
                            const r = t.identifier.parent, n = "ChainExpression" === r.parent.type ? r.parent : r;
                            (function(e1) {
                                return "MemberExpression" === e1.type && !e1.computed && "Identifier" === e1.property.type && "parseInt" === e1.property.name;
                            })(r) && e1.isCallee(n) && a(n.parent);
                        });
                    }
                };
            }
        }, oC;
    }
    function eb() {
        return dC || (dC = 1, fC = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require JSDoc comments",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/require-jsdoc"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            require: {
                                type: "object",
                                properties: {
                                    ClassDeclaration: {
                                        type: "boolean",
                                        default: !1
                                    },
                                    MethodDefinition: {
                                        type: "boolean",
                                        default: !1
                                    },
                                    FunctionDeclaration: {
                                        type: "boolean",
                                        default: !0
                                    },
                                    ArrowFunctionExpression: {
                                        type: "boolean",
                                        default: !1
                                    },
                                    FunctionExpression: {
                                        type: "boolean",
                                        default: !1
                                    }
                                },
                                additionalProperties: !1,
                                default: {}
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                deprecated: !0,
                replacedBy: [],
                messages: {
                    missingJSDocComment: "Missing JSDoc comment."
                }
            },
            create (e1) {
                const t = e1.sourceCode, r = Object.assign({
                    FunctionDeclaration: !0,
                    MethodDefinition: !1,
                    ClassDeclaration: !1,
                    ArrowFunctionExpression: !1,
                    FunctionExpression: !1
                }, e1.options[0] && e1.options[0].require);
                function n(r) {
                    t.getJSDocComment(r) || function(t) {
                        e1.report({
                            node: t,
                            messageId: "missingJSDocComment"
                        });
                    }(r);
                }
                return {
                    FunctionDeclaration (e1) {
                        r.FunctionDeclaration && n(e1);
                    },
                    FunctionExpression (e1) {
                        (r.MethodDefinition && "MethodDefinition" === e1.parent.type || r.FunctionExpression && ("VariableDeclarator" === e1.parent.type || "Property" === e1.parent.type && e1 === e1.parent.value)) && n(e1);
                    },
                    ClassDeclaration (e1) {
                        r.ClassDeclaration && n(e1);
                    },
                    ArrowFunctionExpression (e1) {
                        r.ArrowFunctionExpression && "VariableDeclarator" === e1.parent.type && n(e1);
                    }
                };
            }
        }), fC;
    }
    function tb() {
        if (SC) return CC;
        SC = 1;
        const e1 = LC(), t = Ll();
        return CC = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Require or disallow semicolons instead of ASI",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/semi"
                },
                fixable: "code",
                schema: {
                    anyOf: [
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "never"
                                    ]
                                },
                                {
                                    type: "object",
                                    properties: {
                                        beforeStatementContinuationChars: {
                                            enum: [
                                                "always",
                                                "any",
                                                "never"
                                            ]
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            minItems: 0,
                            maxItems: 2
                        },
                        {
                            type: "array",
                            items: [
                                {
                                    enum: [
                                        "always"
                                    ]
                                },
                                {
                                    type: "object",
                                    properties: {
                                        omitLastInOneLineBlock: {
                                            type: "boolean"
                                        },
                                        omitLastInOneLineClassBody: {
                                            type: "boolean"
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            minItems: 0,
                            maxItems: 2
                        }
                    ]
                },
                messages: {
                    missingSemi: "Missing semicolon.",
                    extraSemi: "Extra semicolon."
                }
            },
            create (r) {
                const n = /^[-[(/+`]/u, s = new Set([
                    "get",
                    "set",
                    "static"
                ]), i = new Set([
                    "*",
                    "in",
                    "instanceof"
                ]), o = r.options[1], a = "never" === r.options[0], u = Boolean(o && o.omitLastInOneLineBlock), l = Boolean(o && o.omitLastInOneLineClassBody), c = o && o.beforeStatementContinuationChars || "any", p = r.sourceCode;
                function f(n, s) {
                    const i = p.getLastToken(n);
                    let o, a, u;
                    s ? (o = "extraSemi", u = i.loc, a = function(t) {
                        return new e1(t, p).retainSurroundingTokens(i).remove(i);
                    }) : (o = "missingSemi", u = {
                        start: i.loc.end,
                        end: t.getNextLocation(p, i.loc.end)
                    }, a = function(e1) {
                        return e1.insertTextAfter(i, ";");
                    }), r.report({
                        node: n,
                        loc: u,
                        messageId: o,
                        fix: a
                    });
                }
                function d(e1) {
                    const r = e1.type;
                    return "DoWhileStatement" !== r && "BreakStatement" !== r && "ContinueStatement" !== r && "DebuggerStatement" !== r && "ImportDeclaration" !== r && "ExportAllDeclaration" !== r && ("ReturnStatement" === r ? Boolean(e1.argument) : "ExportNamedDeclaration" === r ? Boolean(e1.declaration) : !function(e1) {
                        if (!t.isClosingBraceToken(e1)) return !1;
                        const r = p.getNodeByRangeIndex(e1.range[0]);
                        return "BlockStatement" === r.type && "ArrowFunctionExpression" === r.parent.type;
                    }(p.getLastToken(e1, 1)));
                }
                function h(e1) {
                    return Boolean(e1) && n.test(e1.value) && "++" !== e1.value && "--" !== e1.value;
                }
                function m(e1) {
                    return !!function(e1) {
                        const r = p.getTokenAfter(e1);
                        return !r || t.isClosingBraceToken(r) || t.isSemicolonToken(r);
                    }(p.getLastToken(e1)) || !function(e1) {
                        if ("PropertyDefinition" !== e1.type) return !1;
                        if (!e1.computed && "Identifier" === e1.key.type && s.has(e1.key.name) && !(e1.static && "static" === e1.key.name || e1.value)) return !0;
                        const t = p.getTokenAfter(e1);
                        return i.has(t.value);
                    }(e1) && !function(e1) {
                        const r = p.getLastToken(e1, 1), n = p.getTokenAfter(e1);
                        return !!n && t.isTokenOnSameLine(r, n);
                    }(e1) && ("PropertyDefinition" !== e1.type && "never" === c && !d(e1) || !h(p.getTokenAfter(e1)));
                }
                function g(e1) {
                    const r = t.isSemicolonToken(p.getLastToken(e1));
                    if (a) r && m(e1) ? f(e1, !0) : !r && "always" === c && "PropertyDefinition" !== e1.type && h(p.getTokenAfter(e1)) && f(e1);
                    else {
                        const t = u && function(e1) {
                            const t = e1.parent, r = p.getTokenAfter(e1);
                            if (!r || "}" !== r.value) return !1;
                            if ("BlockStatement" === t.type) return t.loc.start.line === t.loc.end.line;
                            if ("StaticBlock" === t.type) return p.getFirstToken(t, {
                                skip: 1
                            }).loc.start.line === t.loc.end.line;
                            return !1;
                        }(e1), n = l && function(e1) {
                            const t = e1.parent, r = p.getTokenAfter(e1);
                            return !(!r || "}" !== r.value) && "ClassBody" === t.type && t.loc.start.line === t.loc.end.line;
                        }(e1), s = t || n;
                        r && s ? f(e1, !0) : r || s || f(e1);
                    }
                }
                return {
                    VariableDeclaration: function(e1) {
                        const t = e1.parent;
                        "ForStatement" === t.type && t.init === e1 || /^For(?:In|Of)Statement/u.test(t.type) && t.left === e1 || g(e1);
                    },
                    ExpressionStatement: g,
                    ReturnStatement: g,
                    ThrowStatement: g,
                    DoWhileStatement: g,
                    DebuggerStatement: g,
                    BreakStatement: g,
                    ContinueStatement: g,
                    ImportDeclaration: g,
                    ExportAllDeclaration: g,
                    ExportNamedDeclaration (e1) {
                        e1.declaration || g(e1);
                    },
                    ExportDefaultDeclaration (e1) {
                        /(?:Class|Function)Declaration/u.test(e1.declaration.type) || g(e1);
                    },
                    PropertyDefinition: g
                };
            }
        }, CC;
    }
    function rb() {
        if (vC) return bC;
        vC = 1;
        const e1 = Ll();
        return bC = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent spacing before and after semicolons",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/semi-spacing"
                },
                fixable: "whitespace",
                schema: [
                    {
                        type: "object",
                        properties: {
                            before: {
                                type: "boolean",
                                default: !1
                            },
                            after: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    unexpectedWhitespaceBefore: "Unexpected whitespace before semicolon.",
                    unexpectedWhitespaceAfter: "Unexpected whitespace after semicolon.",
                    missingWhitespaceBefore: "Missing whitespace before semicolon.",
                    missingWhitespaceAfter: "Missing whitespace after semicolon."
                }
            },
            create (t) {
                const r = t.options[0], n = t.sourceCode;
                let s = !1, i = !0;
                function o(r, o) {
                    if (e1.isSemicolonToken(r)) {
                        if (function(t) {
                            const r = n.getTokenBefore(t);
                            return r && e1.isTokenOnSameLine(r, t) && n.isSpaceBetweenTokens(r, t);
                        }(r)) {
                            if (!s) {
                                const e1 = n.getTokenBefore(r), s = {
                                    start: e1.loc.end,
                                    end: r.loc.start
                                };
                                t.report({
                                    node: o,
                                    loc: s,
                                    messageId: "unexpectedWhitespaceBefore",
                                    fix: (t)=>t.removeRange([
                                            e1.range[1],
                                            r.range[0]
                                        ])
                                });
                            }
                        } else if (s) {
                            const e1 = r.loc;
                            t.report({
                                node: o,
                                loc: e1,
                                messageId: "missingWhitespaceBefore",
                                fix: (e1)=>e1.insertTextBefore(r, " ")
                            });
                        }
                        if (!function(t) {
                            const r = n.getTokenBefore(t);
                            return !(r && e1.isTokenOnSameLine(t, r));
                        }(r) && !function(t) {
                            const r = n.getTokenAfter(t);
                            return !(r && e1.isTokenOnSameLine(t, r));
                        }(r) && !function(t) {
                            const r = n.getTokenAfter(t);
                            return r && e1.isClosingBraceToken(r) || e1.isClosingParenToken(r);
                        }(r)) {
                            if (function(t) {
                                const r = n.getTokenAfter(t);
                                return r && e1.isTokenOnSameLine(t, r) && n.isSpaceBetweenTokens(t, r);
                            }(r)) {
                                if (!i) {
                                    const e1 = n.getTokenAfter(r), s = {
                                        start: r.loc.end,
                                        end: e1.loc.start
                                    };
                                    t.report({
                                        node: o,
                                        loc: s,
                                        messageId: "unexpectedWhitespaceAfter",
                                        fix: (t)=>t.removeRange([
                                                r.range[1],
                                                e1.range[0]
                                            ])
                                    });
                                }
                            } else if (i) {
                                const e1 = r.loc;
                                t.report({
                                    node: o,
                                    loc: e1,
                                    messageId: "missingWhitespaceAfter",
                                    fix: (e1)=>e1.insertTextAfter(r, " ")
                                });
                            }
                        }
                    }
                }
                function a(e1) {
                    o(n.getLastToken(e1), e1);
                }
                return "object" == typeof r && (s = r.before, i = r.after), {
                    VariableDeclaration: a,
                    ExpressionStatement: a,
                    BreakStatement: a,
                    ContinueStatement: a,
                    DebuggerStatement: a,
                    DoWhileStatement: a,
                    ReturnStatement: a,
                    ThrowStatement: a,
                    ImportDeclaration: a,
                    ExportNamedDeclaration: a,
                    ExportAllDeclaration: a,
                    ExportDefaultDeclaration: a,
                    ForStatement (e1) {
                        e1.init && o(n.getTokenAfter(e1.init), e1), e1.test && o(n.getTokenAfter(e1.test), e1);
                    },
                    PropertyDefinition: a
                };
            }
        }, bC;
    }
    function nb() {
        return DC || (DC = 1, RC = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Enforce sorted import declarations within modules",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/sort-imports"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            ignoreCase: {
                                type: "boolean",
                                default: !1
                            },
                            memberSyntaxSortOrder: {
                                type: "array",
                                items: {
                                    enum: [
                                        "none",
                                        "all",
                                        "multiple",
                                        "single"
                                    ]
                                },
                                uniqueItems: !0,
                                minItems: 4,
                                maxItems: 4
                            },
                            ignoreDeclarationSort: {
                                type: "boolean",
                                default: !1
                            },
                            ignoreMemberSort: {
                                type: "boolean",
                                default: !1
                            },
                            allowSeparatedGroups: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                fixable: "code",
                messages: {
                    sortImportsAlphabetically: "Imports should be sorted alphabetically.",
                    sortMembersAlphabetically: "Member '{{memberName}}' of the import declaration should be sorted alphabetically.",
                    unexpectedSyntaxOrder: "Expected '{{syntaxA}}' syntax before '{{syntaxB}}' syntax."
                }
            },
            create (e1) {
                const t = e1.options[0] || {}, r = t.ignoreCase || !1, n = t.ignoreDeclarationSort || !1, s = t.ignoreMemberSort || !1, i = t.memberSyntaxSortOrder || [
                    "none",
                    "all",
                    "multiple",
                    "single"
                ], o = t.allowSeparatedGroups || !1, a = e1.sourceCode;
                let u = null;
                function l(e1) {
                    return i.indexOf(function(e1) {
                        return 0 === e1.specifiers.length ? "none" : "ImportNamespaceSpecifier" === e1.specifiers[0].type ? "all" : 1 === e1.specifiers.length ? "single" : "multiple";
                    }(e1));
                }
                function c(e1) {
                    return e1.specifiers[0] ? e1.specifiers[0].local.name : null;
                }
                return {
                    ImportDeclaration (t) {
                        if (!n) {
                            if (u && o && (p = u, f = t, Math.max(f.loc.start.line - p.loc.end.line - 1, 0) > 0) && (u = null), u) {
                                const n = l(t), s = l(u);
                                let o = c(t), a = c(u);
                                r && (a = a && a.toLowerCase(), o = o && o.toLowerCase()), n !== s ? n < s && e1.report({
                                    node: t,
                                    messageId: "unexpectedSyntaxOrder",
                                    data: {
                                        syntaxA: i[n],
                                        syntaxB: i[s]
                                    }
                                }) : a && o && o < a && e1.report({
                                    node: t,
                                    messageId: "sortImportsAlphabetically"
                                });
                            }
                            u = t;
                        }
                        var p, f;
                        if (!s) {
                            const n = t.specifiers.filter((e1)=>"ImportSpecifier" === e1.type), s = r ? (e1)=>e1.local.name.toLowerCase() : (e1)=>e1.local.name, i = n.map(s).findIndex((e1, t, r)=>r[t - 1] > e1);
                            -1 !== i && e1.report({
                                node: n[i],
                                messageId: "sortMembersAlphabetically",
                                data: {
                                    memberName: n[i].local.name
                                },
                                fix: (e1)=>n.some((e1)=>a.getCommentsBefore(e1).length || a.getCommentsAfter(e1).length) ? null : e1.replaceTextRange([
                                        n[0].range[0],
                                        n[n.length - 1].range[1]
                                    ], n.slice().sort((e1, t)=>s(e1) > s(t) ? 1 : -1).reduce((e1, t, r)=>{
                                        const s = r === n.length - 1 ? "" : a.getText().slice(n[r].range[1], n[r + 1].range[0]);
                                        return e1 + a.getText(t) + s;
                                    }, ""))
                            });
                        }
                    }
                };
            }
        }), RC;
    }
    var sb, ib, ob, ab, ub, lb, cb, pb, fb, db, hb, mb, gb, yb, Eb, xb, Cb, Sb, bb, vb, Ab, Tb, Rb, Db, wb, _b, kb, Bb, Lb, Pb, Ib, Fb = {}, Nb = {
        get exports () {
            return Fb;
        },
        set exports (e){
            Fb = e;
        }
    };
    function Ob() {
        if (sb) return Fb;
        sb = 1;
        /*
		 * @version    1.4.0
		 * @date       2015-10-26
		 * @stability  3 - Stable
		 * @author     Lauri Rooden (https://github.com/litejs/natural-compare-lite)
		 * @license    MIT License
		 */ var e1 = function(e1, t) {
            var r, n, s = 1, i = 0, o = 0, a = String.alphabet;
            function u(e1, t, n) {
                if (n) {
                    for(r = t; (n = u(e1, r)) < 76 && n > 65;)++r;
                    return +e1.slice(t - 1, r);
                }
                return (n = a && a.indexOf(e1.charAt(t))) > -1 ? n + 76 : (n = e1.charCodeAt(t) || 0) < 45 || n > 127 ? n : n < 46 ? 65 : n < 48 ? n - 1 : n < 58 ? n + 18 : n < 65 ? n - 11 : n < 91 ? n + 11 : n < 97 ? n - 37 : n < 123 ? n + 5 : n - 63;
            }
            if ((e1 += "") != (t += "")) {
                for(; s;)if (n = u(e1, i++), s = u(t, o++), n < 76 && s < 76 && n > 66 && s > 66 && (n = u(e1, i, i), s = u(t, o, i = r), o = r), n != s) return n < s ? -1 : 1;
            }
            return 0;
        };
        try {
            Nb.exports = e1;
        } catch (t) {
            String.naturalCompare = e1;
        }
        return Fb;
    }
    function Ub() {
        if (ob) return ib;
        ob = 1;
        const e1 = Ll(), t = Ob();
        const r = {
            asc: (e1, t)=>e1 <= t,
            ascI: (e1, t)=>e1.toLowerCase() <= t.toLowerCase(),
            ascN: (e1, r)=>t(e1, r) <= 0,
            ascIN: (e1, r)=>t(e1.toLowerCase(), r.toLowerCase()) <= 0,
            desc: (e1, t)=>r.asc(t, e1),
            descI: (e1, t)=>r.ascI(t, e1),
            descN: (e1, t)=>r.ascN(t, e1),
            descIN: (e1, t)=>r.ascIN(t, e1)
        };
        return ib = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require object keys to be sorted",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/sort-keys"
                },
                schema: [
                    {
                        enum: [
                            "asc",
                            "desc"
                        ]
                    },
                    {
                        type: "object",
                        properties: {
                            caseSensitive: {
                                type: "boolean",
                                default: !0
                            },
                            natural: {
                                type: "boolean",
                                default: !1
                            },
                            minKeys: {
                                type: "integer",
                                minimum: 2,
                                default: 2
                            },
                            allowLineSeparatedGroups: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    sortKeys: "Expected object keys to be in {{natural}}{{insensitive}}{{order}}ending order. '{{thisName}}' should be before '{{prevName}}'."
                }
            },
            create (t) {
                const n = t.options[0] || "asc", s = t.options[1], i = s && !1 === s.caseSensitive, o = s && s.natural, a = s && s.minKeys, u = s && s.allowLineSeparatedGroups || !1, l = r[n + (i ? "I" : "") + (o ? "N" : "")];
                let c = null;
                const p = t.sourceCode;
                return {
                    ObjectExpression (e1) {
                        c = {
                            upper: c,
                            prevNode: null,
                            prevBlankLine: !1,
                            prevName: null,
                            numKeys: e1.properties.length
                        };
                    },
                    "ObjectExpression:exit" () {
                        c = c.upper;
                    },
                    SpreadElement (e1) {
                        "ObjectExpression" === e1.parent.type && (c.prevName = null);
                    },
                    Property (r) {
                        if ("ObjectPattern" === r.parent.type) return;
                        const s = c.prevName, f = c.numKeys, d = function(t) {
                            const r = e1.getStaticPropertyName(t);
                            return null !== r ? r : t.key.name || null;
                        }(r), h = c.prevNode && p.getTokensBetween(c.prevNode, r, {
                            includeComments: !0
                        });
                        let m = c.prevBlankLine;
                        h && (h.forEach((e1, t)=>{
                            const r = h[t - 1];
                            r && e1.loc.start.line - r.loc.end.line > 1 && (m = !0);
                        }), !m && r.loc.start.line - h[h.length - 1].loc.end.line > 1 && (m = !0), !m && h[0].loc.start.line - c.prevNode.loc.end.line > 1 && (m = !0)), c.prevNode = r, null !== d && (c.prevName = d), u && m ? c.prevBlankLine = null === d : null === s || null === d || f < a || l(s, d) || t.report({
                            node: r,
                            loc: r.key.loc,
                            messageId: "sortKeys",
                            data: {
                                thisName: d,
                                prevName: s,
                                order: n,
                                insensitive: i ? "insensitive " : "",
                                natural: o ? "natural " : ""
                            }
                        });
                    }
                };
            }
        }, ib;
    }
    function jb() {
        if (cb) return lb;
        cb = 1;
        const e1 = Ll();
        function t(t) {
            const r = t.parent;
            return "BlockStatement" === t.type && e1.isFunction(r) && r.body === t;
        }
        return lb = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent spacing before blocks",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/space-before-blocks"
                },
                fixable: "whitespace",
                schema: [
                    {
                        oneOf: [
                            {
                                enum: [
                                    "always",
                                    "never"
                                ]
                            },
                            {
                                type: "object",
                                properties: {
                                    keywords: {
                                        enum: [
                                            "always",
                                            "never",
                                            "off"
                                        ]
                                    },
                                    functions: {
                                        enum: [
                                            "always",
                                            "never",
                                            "off"
                                        ]
                                    },
                                    classes: {
                                        enum: [
                                            "always",
                                            "never",
                                            "off"
                                        ]
                                    }
                                },
                                additionalProperties: !1
                            }
                        ]
                    }
                ],
                messages: {
                    unexpectedSpace: "Unexpected space before opening brace.",
                    missingSpace: "Missing space before opening brace."
                }
            },
            create (r) {
                const n = r.options[0], s = r.sourceCode;
                let i = !0, o = !0, a = !0, u = !1, l = !1, c = !1;
                function p(n) {
                    const p = s.getTokenBefore(n);
                    if (p && !function(r, n) {
                        return e1.isArrowToken(r) || e1.isKeywordToken(r) && !t(n) || e1.isColonToken(r) && n.parent && "SwitchCase" === n.parent.type && r === e1.getSwitchCaseColonToken(n.parent, s);
                    }(p, n) && e1.isTokenOnSameLine(p, n)) {
                        const e1 = s.isSpaceBetweenTokens(p, n);
                        let f, d;
                        t(n) ? (f = i, d = u) : "ClassBody" === n.type ? (f = a, d = c) : (f = o, d = l), f && !e1 ? r.report({
                            node: n,
                            messageId: "missingSpace",
                            fix: (e1)=>e1.insertTextBefore(n, " ")
                        }) : d && e1 && r.report({
                            node: n,
                            messageId: "unexpectedSpace",
                            fix: (e1)=>e1.removeRange([
                                    p.range[1],
                                    n.range[0]
                                ])
                        });
                    }
                }
                return "object" == typeof n ? (i = "always" === n.functions, o = "always" === n.keywords, a = "always" === n.classes, u = "never" === n.functions, l = "never" === n.keywords, c = "never" === n.classes) : "never" === n && (i = !1, o = !1, a = !1, u = !0, l = !0, c = !0), {
                    BlockStatement: p,
                    ClassBody: p,
                    SwitchStatement: function(e1) {
                        const t = e1.cases;
                        let r;
                        r = t.length > 0 ? s.getTokenBefore(t[0]) : s.getLastToken(e1, 1), p(r);
                    }
                };
            }
        }, lb;
    }
    function Vb() {
        if (fb) return pb;
        fb = 1;
        const e1 = Ll();
        return pb = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent spacing before `function` definition opening parenthesis",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/space-before-function-paren"
                },
                fixable: "whitespace",
                schema: [
                    {
                        oneOf: [
                            {
                                enum: [
                                    "always",
                                    "never"
                                ]
                            },
                            {
                                type: "object",
                                properties: {
                                    anonymous: {
                                        enum: [
                                            "always",
                                            "never",
                                            "ignore"
                                        ]
                                    },
                                    named: {
                                        enum: [
                                            "always",
                                            "never",
                                            "ignore"
                                        ]
                                    },
                                    asyncArrow: {
                                        enum: [
                                            "always",
                                            "never",
                                            "ignore"
                                        ]
                                    }
                                },
                                additionalProperties: !1
                            }
                        ]
                    }
                ],
                messages: {
                    unexpectedSpace: "Unexpected space before function parentheses.",
                    missingSpace: "Missing space before function parentheses."
                }
            },
            create (t) {
                const r = t.sourceCode, n = "string" == typeof t.options[0] ? t.options[0] : "always", s = "object" == typeof t.options[0] ? t.options[0] : {};
                function i(i) {
                    const o = function(t) {
                        if ("ArrowFunctionExpression" === t.type) {
                            if (t.async && e1.isOpeningParenToken(r.getFirstToken(t, {
                                skip: 1
                            }))) return s.asyncArrow || n;
                        } else {
                            if (function(e1) {
                                if (e1.id) return !0;
                                const t = e1.parent;
                                return "MethodDefinition" === t.type || "Property" === t.type && ("get" === t.kind || "set" === t.kind || t.method);
                            }(t)) return s.named || n;
                            if (!t.generator) return s.anonymous || n;
                        }
                        return "ignore";
                    }(i);
                    if ("ignore" === o) return;
                    const a = r.getFirstToken(i, e1.isOpeningParenToken), u = r.getTokenBefore(a), l = r.isSpaceBetweenTokens(u, a);
                    l && "never" === o ? t.report({
                        node: i,
                        loc: {
                            start: u.loc.end,
                            end: a.loc.start
                        },
                        messageId: "unexpectedSpace",
                        fix (e1) {
                            const t = r.getCommentsBefore(a);
                            return t.some((e1)=>"Line" === e1.type) ? null : e1.replaceTextRange([
                                u.range[1],
                                a.range[0]
                            ], t.reduce((e1, t)=>e1 + r.getText(t), ""));
                        }
                    }) : l || "always" !== o || t.report({
                        node: i,
                        loc: a.loc,
                        messageId: "missingSpace",
                        fix: (e1)=>e1.insertTextAfter(u, " ")
                    });
                }
                return {
                    ArrowFunctionExpression: i,
                    FunctionDeclaration: i,
                    FunctionExpression: i
                };
            }
        }, pb;
    }
    function Kb() {
        if (hb) return db;
        hb = 1;
        const e1 = Ll();
        return db = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce consistent spacing inside parentheses",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/space-in-parens"
                },
                fixable: "whitespace",
                schema: [
                    {
                        enum: [
                            "always",
                            "never"
                        ]
                    },
                    {
                        type: "object",
                        properties: {
                            exceptions: {
                                type: "array",
                                items: {
                                    enum: [
                                        "{}",
                                        "[]",
                                        "()",
                                        "empty"
                                    ]
                                },
                                uniqueItems: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    missingOpeningSpace: "There must be a space after this paren.",
                    missingClosingSpace: "There must be a space before this paren.",
                    rejectedOpeningSpace: "There should be no space after this paren.",
                    rejectedClosingSpace: "There should be no space before this paren."
                }
            },
            create (t) {
                const r = "always" === t.options[0], n = t.options[1] && t.options[1].exceptions || [], s = {};
                let i;
                n.length && (s.braceException = n.includes("{}"), s.bracketException = n.includes("[]"), s.parenException = n.includes("()"), s.empty = n.includes("empty"));
                const o = t.sourceCode;
                function a(e1) {
                    return i.openers.includes(e1.value);
                }
                function u(e1) {
                    return i.closers.includes(e1.value);
                }
                return {
                    Program: function(n) {
                        i = function() {
                            const e1 = [], t = [];
                            return s.braceException && (e1.push("{"), t.push("}")), s.bracketException && (e1.push("["), t.push("]")), s.parenException && (e1.push("("), t.push(")")), s.empty && (e1.push(")"), t.push("(")), {
                                openers: e1,
                                closers: t
                            };
                        }();
                        const l = o.tokensAndComments;
                        l.forEach((i, c)=>{
                            const p = l[c - 1], f = l[c + 1];
                            var d, h, m, g;
                            (e1.isOpeningParenToken(i) || e1.isClosingParenToken(i)) && ("(" !== i.value || (d = i, h = f, o.isSpaceBetweenTokens(d, h) || !s.empty && e1.isClosingParenToken(h) || (r ? a(h) : !a(h))) || t.report({
                                node: n,
                                loc: i.loc,
                                messageId: "missingOpeningSpace",
                                fix: (e1)=>e1.insertTextAfter(i, " ")
                            }), "(" === i.value && function(t, n) {
                                return !!e1.isTokenOnSameLine(t, n) && "Line" !== n.type && !!o.isSpaceBetweenTokens(t, n) && (r ? a(n) : !a(n));
                            }(i, f) && t.report({
                                node: n,
                                loc: {
                                    start: i.loc.end,
                                    end: f.loc.start
                                },
                                messageId: "rejectedOpeningSpace",
                                fix: (e1)=>e1.removeRange([
                                        i.range[1],
                                        f.range[0]
                                    ])
                            }), ")" !== i.value || (m = p, g = i, o.isSpaceBetweenTokens(m, g) || !s.empty && e1.isOpeningParenToken(m) || (r ? u(m) : !u(m))) || t.report({
                                node: n,
                                loc: i.loc,
                                messageId: "missingClosingSpace",
                                fix: (e1)=>e1.insertTextBefore(i, " ")
                            }), ")" === i.value && function(t, n) {
                                return !!e1.isTokenOnSameLine(t, n) && !!o.isSpaceBetweenTokens(t, n) && (r ? u(t) : !u(t));
                            }(p, i) && t.report({
                                node: n,
                                loc: {
                                    start: p.loc.end,
                                    end: i.loc.start
                                },
                                messageId: "rejectedClosingSpace",
                                fix: (e1)=>e1.removeRange([
                                        p.range[1],
                                        i.range[0]
                                    ])
                            }));
                        });
                    }
                };
            }
        }, db;
    }
    function Mb() {
        if (bb) return Sb;
        bb = 1;
        const e1 = Ll();
        function t(e1) {
            const t = [];
            for(let r = 0; r < e1.length; r++){
                const n = e1[r];
                if ("ExpressionStatement" !== n.type || "Literal" !== n.expression.type || "use strict" !== n.expression.value) break;
                t[r] = n;
            }
            return t;
        }
        function r(e1) {
            return "Identifier" === e1.type;
        }
        function n(e1) {
            return e1.every(r);
        }
        return Sb = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require or disallow strict mode directives",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/strict"
                },
                schema: [
                    {
                        enum: [
                            "never",
                            "global",
                            "function",
                            "safe"
                        ]
                    }
                ],
                fixable: "code",
                messages: {
                    function: "Use the function form of 'use strict'.",
                    global: "Use the global form of 'use strict'.",
                    multiple: "Multiple 'use strict' directives.",
                    never: "Strict mode is not permitted.",
                    unnecessary: "Unnecessary 'use strict' directive.",
                    module: "'use strict' is unnecessary inside of modules.",
                    implied: "'use strict' is unnecessary when implied strict mode is enabled.",
                    unnecessaryInClasses: "'use strict' is unnecessary inside of classes.",
                    nonSimpleParameterList: "'use strict' directive inside a function with non-simple parameter list throws a syntax error since ES2016.",
                    wrap: "Wrap {{name}} in a function with 'use strict' directive."
                }
            },
            create (r) {
                const s = r.parserOptions.ecmaFeatures || {}, i = [], o = [];
                let a = r.options[0] || "safe";
                function u(e1) {
                    return "multiple" === e1 || "unnecessary" === e1 || "module" === e1 || "implied" === e1 || "unnecessaryInClasses" === e1;
                }
                function l(e1) {
                    return (t)=>t.remove(e1);
                }
                function c(e1, t, n, s, i) {
                    e1.slice(t, n).forEach((e1)=>{
                        r.report({
                            node: e1,
                            messageId: s,
                            fix: i ? l(e1) : null
                        });
                    });
                }
                function p(e1, t, r) {
                    c(e1, 0, e1.length, t, r);
                }
                function f(e1, t, r) {
                    c(e1, 1, e1.length, t, r);
                }
                function d() {
                    i.pop();
                }
                function h(s) {
                    const c = "BlockStatement" === s.body.type ? t(s.body.body) : [];
                    "function" === a ? function(t, s) {
                        const a = o.length > 0, u = 0 === i.length && 0 === o.length, c = i.length > 0 && i[i.length - 1], p = s.length > 0;
                        p ? (n(t.params) ? c ? r.report({
                            node: s[0],
                            messageId: "unnecessary",
                            fix: l(s[0])
                        }) : a && r.report({
                            node: s[0],
                            messageId: "unnecessaryInClasses",
                            fix: l(s[0])
                        }) : r.report({
                            node: s[0],
                            messageId: "nonSimpleParameterList"
                        }), f(s, "multiple", !0)) : u && (n(t.params) ? r.report({
                            node: t,
                            messageId: "function"
                        }) : r.report({
                            node: t,
                            messageId: "wrap",
                            data: {
                                name: e1.getFunctionNameWithKind(t)
                            }
                        })), i.push(c || p);
                    }(s, c) : c.length > 0 && (n(s.params) ? p(c, a, u(a)) : (r.report({
                        node: c[0],
                        messageId: "nonSimpleParameterList"
                    }), f(c, "multiple", !0)));
                }
                s.impliedStrict ? a = "implied" : "safe" === a && (a = s.globalReturn || "commonjs" === r.languageOptions.sourceType ? "global" : "function");
                const m = {
                    Program (e1) {
                        const n = t(e1.body);
                        "module" === e1.sourceType && (a = "module"), "global" === a ? (e1.body.length > 0 && 0 === n.length && r.report({
                            node: e1,
                            messageId: "global"
                        }), f(n, "multiple", !0)) : p(n, a, u(a));
                    },
                    FunctionDeclaration: h,
                    FunctionExpression: h,
                    ArrowFunctionExpression: h
                };
                return "function" === a && Object.assign(m, {
                    ClassBody () {
                        o.push(!0);
                    },
                    "ClassBody:exit" () {
                        o.pop();
                    },
                    "FunctionDeclaration:exit": d,
                    "FunctionExpression:exit": d,
                    "ArrowFunctionExpression:exit": d
                }), m;
            }
        }, Sb;
    }
    function $b() {
        if (Ab) return vb;
        Ab = 1;
        const e1 = Ll();
        return vb = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Enforce spacing around colons of switch statements",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/switch-colon-spacing"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            before: {
                                type: "boolean",
                                default: !1
                            },
                            after: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                fixable: "whitespace",
                messages: {
                    expectedBefore: "Expected space(s) before this colon.",
                    expectedAfter: "Expected space(s) after this colon.",
                    unexpectedBefore: "Unexpected space(s) before this colon.",
                    unexpectedAfter: "Unexpected space(s) after this colon."
                }
            },
            create (t) {
                const r = t.sourceCode, n = t.options[0] || {}, s = !0 === n.before, i = !1 !== n.after;
                function o(t, n, s) {
                    return e1.isClosingBraceToken(n) || !e1.isTokenOnSameLine(t, n) || r.isSpaceBetweenTokens(t, n) === s;
                }
                function a(t, n, s, i) {
                    return function(t, n) {
                        return null !== r.getFirstTokenBetween(t, n, {
                            includeComments: !0,
                            filter: e1.isCommentToken
                        });
                    }(n, s) ? null : i ? t.insertTextAfter(n, " ") : t.removeRange([
                        n.range[1],
                        s.range[0]
                    ]);
                }
                return {
                    SwitchCase (n) {
                        const u = e1.getSwitchCaseColonToken(n, r), l = r.getTokenBefore(u), c = r.getTokenAfter(u);
                        o(l, u, s) || t.report({
                            node: n,
                            loc: u.loc,
                            messageId: s ? "expectedBefore" : "unexpectedBefore",
                            fix: (e1)=>a(e1, l, u, s)
                        }), o(u, c, i) || t.report({
                            node: n,
                            loc: u.loc,
                            messageId: i ? "expectedAfter" : "unexpectedAfter",
                            fix: (e1)=>a(e1, u, c, i)
                        });
                    }
                };
            }
        }, vb;
    }
    function qb() {
        if (Rb) return Tb;
        Rb = 1;
        const e1 = Ll();
        return Tb = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require symbol descriptions",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/symbol-description"
                },
                fixable: null,
                schema: [],
                messages: {
                    expected: "Expected Symbol to have a description."
                }
            },
            create (t) {
                const r = t.sourceCode;
                return {
                    "Program:exit" (n) {
                        const s = r.getScope(n), i = e1.getVariableByName(s, "Symbol");
                        i && 0 === i.defs.length && i.references.forEach((r)=>{
                            const n = r.identifier;
                            e1.isCallee(n) && function(e1) {
                                0 === e1.arguments.length && t.report({
                                    node: e1,
                                    messageId: "expected"
                                });
                            }(n.parent);
                        });
                    }
                };
            }
        }, Tb;
    }
    function Gb() {
        if (wb) return Db;
        wb = 1;
        const e1 = Ll();
        return Db = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Require or disallow spacing around embedded expressions of template strings",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/template-curly-spacing"
                },
                fixable: "whitespace",
                schema: [
                    {
                        enum: [
                            "always",
                            "never"
                        ]
                    }
                ],
                messages: {
                    expectedBefore: "Expected space(s) before '}'.",
                    expectedAfter: "Expected space(s) after '${'.",
                    unexpectedBefore: "Unexpected space(s) before '}'.",
                    unexpectedAfter: "Unexpected space(s) after '${'."
                }
            },
            create (t) {
                const r = t.sourceCode, n = "always" === t.options[0];
                return {
                    TemplateElement (s) {
                        const i = r.getFirstToken(s);
                        !function(s) {
                            if (!s.value.startsWith("}")) return;
                            const i = r.getTokenBefore(s, {
                                includeComments: !0
                            }), o = r.isSpaceBetween(i, s);
                            e1.isTokenOnSameLine(i, s) && (n && !o && t.report({
                                loc: {
                                    start: s.loc.start,
                                    end: {
                                        line: s.loc.start.line,
                                        column: s.loc.start.column + 1
                                    }
                                },
                                messageId: "expectedBefore",
                                fix: (e1)=>e1.insertTextBefore(s, " ")
                            }), !n && o && t.report({
                                loc: {
                                    start: i.loc.end,
                                    end: s.loc.start
                                },
                                messageId: "unexpectedBefore",
                                fix: (e1)=>e1.removeRange([
                                        i.range[1],
                                        s.range[0]
                                    ])
                            }));
                        }(i), function(s) {
                            if (!s.value.endsWith("${")) return;
                            const i = r.getTokenAfter(s, {
                                includeComments: !0
                            }), o = r.isSpaceBetween(s, i);
                            e1.isTokenOnSameLine(s, i) && (n && !o && t.report({
                                loc: {
                                    start: {
                                        line: s.loc.end.line,
                                        column: s.loc.end.column - 2
                                    },
                                    end: s.loc.end
                                },
                                messageId: "expectedAfter",
                                fix: (e1)=>e1.insertTextAfter(s, " ")
                            }), !n && o && t.report({
                                loc: {
                                    start: s.loc.end,
                                    end: i.loc.start
                                },
                                messageId: "unexpectedAfter",
                                fix: (e1)=>e1.removeRange([
                                        s.range[1],
                                        i.range[0]
                                    ])
                            }));
                        }(i);
                    }
                };
            }
        }, Db;
    }
    var Wb, Xb, zb, Hb, Jb, Qb, Yb, Zb, ev, tv, rv, nv, sv, iv, ov, av, uv, lv, cv, pv, fv, dv, hv, mv, gv, yv, Ev, xv = {}, Cv = {}, Sv = {}, bv = "3.0.0";
    function vv() {
        return Wb || (Wb = 1, function() {
            var e1, t;
            function r(e1) {
                this.name = "DoctrineError", this.message = e1;
            }
            e1 = bv, Sv.VERSION = e1, r.prototype = ((t = function() {}).prototype = Error.prototype, new t), r.prototype.constructor = r, Sv.DoctrineError = r, Sv.throwError = function(e1) {
                throw new r(e1);
            }, Sv.assert = ir;
        }()), Sv;
    }
    function Av() {
        return Xb || (Xb = 1, function() {
            var e1, t, r, n, s, i, o, a, u, l, c, p;
            function f(e1) {
                return -1 === "><(){}[],:*|?!=".indexOf(String.fromCharCode(e1)) && !u.code.isWhiteSpace(e1) && !u.code.isLineTerminator(e1);
            }
            function d(e1, t, r, n) {
                this._previous = e1, this._index = t, this._token = r, this._value = n;
            }
            function h(e1, t) {
                return p && (e1.range = [
                    t[0] + c,
                    t[1] + c
                ]), e1;
            }
            function m() {
                var e1 = r.charAt(s);
                return s += 1, e1;
            }
            function g(e1) {
                var t, i, o, a = 0;
                for(i = "u" === e1 ? 4 : 2, t = 0; t < i; ++t){
                    if (!(s < n && u.code.isHexDigit(r.charCodeAt(s)))) return "";
                    o = m(), a = 16 * a + "0123456789abcdef".indexOf(o.toLowerCase());
                }
                return String.fromCharCode(a);
            }
            function y() {
                var e1, i;
                if (e1 = "", 46 !== (i = r.charCodeAt(s))) {
                    if (e1 = m(), i = r.charCodeAt(s), "0" === e1) {
                        if (120 === i || 88 === i) {
                            for(e1 += m(); s < n && (i = r.charCodeAt(s), u.code.isHexDigit(i));)e1 += m();
                            return e1.length <= 2 && l.throwError("unexpected token"), s < n && (i = r.charCodeAt(s), u.code.isIdentifierStartES5(i) && l.throwError("unexpected token")), a = parseInt(e1, 16), t.NUMBER;
                        }
                        if (u.code.isOctalDigit(i)) {
                            for(e1 += m(); s < n && (i = r.charCodeAt(s), u.code.isOctalDigit(i));)e1 += m();
                            return s < n && (i = r.charCodeAt(s), (u.code.isIdentifierStartES5(i) || u.code.isDecimalDigit(i)) && l.throwError("unexpected token")), a = parseInt(e1, 8), t.NUMBER;
                        }
                        u.code.isDecimalDigit(i) && l.throwError("unexpected token");
                    }
                    for(; s < n && (i = r.charCodeAt(s), u.code.isDecimalDigit(i));)e1 += m();
                }
                if (46 === i) for(e1 += m(); s < n && (i = r.charCodeAt(s), u.code.isDecimalDigit(i));)e1 += m();
                if (101 === i || 69 === i) {
                    if (e1 += m(), 43 !== (i = r.charCodeAt(s)) && 45 !== i || (e1 += m()), i = r.charCodeAt(s), u.code.isDecimalDigit(i)) for(e1 += m(); s < n && (i = r.charCodeAt(s), u.code.isDecimalDigit(i));)e1 += m();
                    else l.throwError("unexpected token");
                }
                return s < n && (i = r.charCodeAt(s), u.code.isIdentifierStartES5(i) && l.throwError("unexpected token")), a = parseFloat(e1), t.NUMBER;
            }
            function E() {
                var e1;
                for(i = s; s < n && u.code.isWhiteSpace(r.charCodeAt(s));)m();
                if (s >= n) return o = t.EOF;
                switch(e1 = r.charCodeAt(s)){
                    case 39:
                    case 34:
                        return o = function() {
                            var e1, i, o, c, p, f = "";
                            for(e1 = r.charAt(s), ++s; s < n;){
                                if ((i = m()) === e1) {
                                    e1 = "";
                                    break;
                                }
                                if ("\\" === i) {
                                    if (i = m(), u.code.isLineTerminator(i.charCodeAt(0))) "\r" === i && 10 === r.charCodeAt(s) && ++s;
                                    else switch(i){
                                        case "n":
                                            f += "\n";
                                            break;
                                        case "r":
                                            f += "\r";
                                            break;
                                        case "t":
                                            f += "\t";
                                            break;
                                        case "u":
                                        case "x":
                                            p = s, (c = g(i)) ? f += c : (s = p, f += i);
                                            break;
                                        case "b":
                                            f += "\b";
                                            break;
                                        case "f":
                                            f += "\f";
                                            break;
                                        case "v":
                                            f += "\v";
                                            break;
                                        default:
                                            u.code.isOctalDigit(i.charCodeAt(0)) ? (o = "01234567".indexOf(i), s < n && u.code.isOctalDigit(r.charCodeAt(s)) && (o = 8 * o + "01234567".indexOf(m()), "0123".indexOf(i) >= 0 && s < n && u.code.isOctalDigit(r.charCodeAt(s)) && (o = 8 * o + "01234567".indexOf(m()))), f += String.fromCharCode(o)) : f += i;
                                    }
                                } else {
                                    if (u.code.isLineTerminator(i.charCodeAt(0))) break;
                                    f += i;
                                }
                            }
                            return "" !== e1 && l.throwError("unexpected quote"), a = f, t.STRING;
                        }(), o;
                    case 58:
                        return m(), o = t.COLON;
                    case 44:
                        return m(), o = t.COMMA;
                    case 40:
                        return m(), o = t.LPAREN;
                    case 41:
                        return m(), o = t.RPAREN;
                    case 91:
                        return m(), o = t.LBRACK;
                    case 93:
                        return m(), o = t.RBRACK;
                    case 123:
                        return m(), o = t.LBRACE;
                    case 125:
                        return m(), o = t.RBRACE;
                    case 46:
                        if (s + 1 < n) {
                            if (60 === (e1 = r.charCodeAt(s + 1))) return m(), m(), o = t.DOT_LT;
                            if (46 === e1 && s + 2 < n && 46 === r.charCodeAt(s + 2)) return m(), m(), m(), o = t.REST;
                            if (u.code.isDecimalDigit(e1)) return o = y();
                        }
                        return o = t.ILLEGAL;
                    case 60:
                        return m(), o = t.LT;
                    case 62:
                        return m(), o = t.GT;
                    case 42:
                        return m(), o = t.STAR;
                    case 124:
                        return m(), o = t.PIPE;
                    case 63:
                        return m(), o = t.QUESTION;
                    case 33:
                        return m(), o = t.BANG;
                    case 61:
                        return m(), o = t.EQUAL;
                    case 45:
                        return o = y();
                    default:
                        return u.code.isDecimalDigit(e1) ? o = y() : (l.assert(f(e1)), o = function() {
                            for(a = m(); s < n && f(r.charCodeAt(s));){
                                if (46 === r.charCodeAt(s)) {
                                    if (s + 1 >= n) return t.ILLEGAL;
                                    if (60 === r.charCodeAt(s + 1)) break;
                                }
                                a += m();
                            }
                            return t.NAME;
                        }());
                }
            }
            function x(e1, t) {
                l.assert(o === e1, t || "consumed token not matched"), E();
            }
            function C(e1, t) {
                o !== e1 && l.throwError(t || "unexpected token"), E();
            }
            function S() {
                var r, n = i;
                return r = function() {
                    var e1 = a;
                    return o === t.NAME || o === t.STRING ? (E(), e1) : o === t.NUMBER ? (x(t.NUMBER), String(e1)) : void l.throwError("unexpected token");
                }(), o === t.COLON ? (x(t.COLON), h({
                    type: e1.FieldType,
                    key: r,
                    value: R()
                }, [
                    n,
                    i
                ])) : h({
                    type: e1.FieldType,
                    key: r,
                    value: null
                }, [
                    n,
                    i
                ]);
            }
            function b() {
                var r, n, u = s - a.length;
                return r = function() {
                    var r = a, n = s - r.length;
                    return C(t.NAME), o !== t.COLON || "module" !== r && "external" !== r && "event" !== r || (x(t.COLON), r += ":" + a, C(t.NAME)), h({
                        type: e1.NameExpression,
                        name: r
                    }, [
                        n,
                        i
                    ]);
                }(), o === t.DOT_LT || o === t.LT ? (E(), n = function() {
                    var e1 = [];
                    for(e1.push(D()); o === t.COMMA;)x(t.COMMA), e1.push(D());
                    return e1;
                }(), C(t.GT), h({
                    type: e1.TypeApplication,
                    expression: r,
                    applications: n
                }, [
                    u,
                    i
                ])) : r;
            }
            function v() {
                for(var r, n, a, u = [], c = !1, p = !1, f = s - 3; o !== t.RPAREN;)o === t.REST && (x(t.REST), p = !0), n = i, (r = R()).type === e1.NameExpression && o === t.COLON && (a = i - r.name.length, x(t.COLON), r = h({
                    type: e1.ParameterType,
                    name: r.name,
                    expression: R()
                }, [
                    a,
                    i
                ])), o === t.EQUAL ? (x(t.EQUAL), r = h({
                    type: e1.OptionalType,
                    expression: r
                }, [
                    n,
                    i
                ]), c = !0) : c && l.throwError("unexpected token"), p && (r = h({
                    type: e1.RestType,
                    expression: r
                }, [
                    f,
                    i
                ])), u.push(r), o !== t.RPAREN && C(t.COMMA);
                return u;
            }
            function A() {
                var r, n, u, c, p, f = s - a.length;
                return l.assert(o === t.NAME && "function" === a, "FunctionType should start with 'function'"), x(t.NAME), C(t.LPAREN), r = !1, u = [], n = null, o !== t.RPAREN && (o !== t.NAME || "this" !== a && "new" !== a ? u = v() : (r = "new" === a, x(t.NAME), C(t.COLON), n = b(), o === t.COMMA && (x(t.COMMA), u = v()))), C(t.RPAREN), c = null, o === t.COLON && (x(t.COLON, "ResultType should start with :"), c = o === t.NAME && "void" === a ? (x(t.NAME), {
                    type: e1.VoidLiteral
                }) : R()), p = h({
                    type: e1.FunctionType,
                    params: u,
                    result: c
                }, [
                    f,
                    i
                ]), n && (p.this = n, r && (p.new = !0)), p;
            }
            function T() {
                var r, n;
                switch(o){
                    case t.STAR:
                        return x(t.STAR), h({
                            type: e1.AllLiteral
                        }, [
                            i - 1,
                            i
                        ]);
                    case t.LPAREN:
                        return function() {
                            var r, n = s - 1;
                            if (x(t.LPAREN, "UnionType should start with ("), r = [], o !== t.RPAREN) for(; r.push(R()), o !== t.RPAREN;)C(t.PIPE);
                            return x(t.RPAREN, "UnionType should end with )"), h({
                                type: e1.UnionType,
                                elements: r
                            }, [
                                n,
                                i
                            ]);
                        }();
                    case t.LBRACK:
                        return function() {
                            var r, n, a = s - 1;
                            for(x(t.LBRACK, "ArrayType should start with ["), r = []; o !== t.RBRACK;){
                                if (o === t.REST) {
                                    n = s - 3, x(t.REST), r.push(h({
                                        type: e1.RestType,
                                        expression: R()
                                    }, [
                                        n,
                                        i
                                    ]));
                                    break;
                                }
                                r.push(R()), o !== t.RBRACK && C(t.COMMA);
                            }
                            return C(t.RBRACK), h({
                                type: e1.ArrayType,
                                elements: r
                            }, [
                                a,
                                i
                            ]);
                        }();
                    case t.LBRACE:
                        return function() {
                            var r, n, i = s - 1;
                            if (x(t.LBRACE, "RecordType should start with {"), r = [], o === t.COMMA) x(t.COMMA);
                            else for(; o !== t.RBRACE;)r.push(S()), o !== t.RBRACE && C(t.COMMA);
                            return n = s, C(t.RBRACE), h({
                                type: e1.RecordType,
                                fields: r
                            }, [
                                i,
                                n
                            ]);
                        }();
                    case t.NAME:
                        if (n = s - a.length, "null" === a) return x(t.NAME), h({
                            type: e1.NullLiteral
                        }, [
                            n,
                            i
                        ]);
                        if ("undefined" === a) return x(t.NAME), h({
                            type: e1.UndefinedLiteral
                        }, [
                            n,
                            i
                        ]);
                        if ("true" === a || "false" === a) return x(t.NAME), h({
                            type: e1.BooleanLiteralType,
                            value: "true" === a
                        }, [
                            n,
                            i
                        ]);
                        if (r = d.save(), "function" === a) try {
                            return A();
                        } catch (e1) {
                            r.restore();
                        }
                        return b();
                    case t.STRING:
                        return E(), h({
                            type: e1.StringLiteralType,
                            value: a
                        }, [
                            i - a.length - 2,
                            i
                        ]);
                    case t.NUMBER:
                        return E(), h({
                            type: e1.NumericLiteralType,
                            value: a
                        }, [
                            i - String(a).length,
                            i
                        ]);
                    default:
                        l.throwError("unexpected token");
                }
            }
            function R() {
                var r, n;
                return o === t.QUESTION ? (n = s - 1, x(t.QUESTION), h(o === t.COMMA || o === t.EQUAL || o === t.RBRACE || o === t.RPAREN || o === t.PIPE || o === t.EOF || o === t.RBRACK || o === t.GT ? {
                    type: e1.NullableLiteral
                } : {
                    type: e1.NullableType,
                    expression: T(),
                    prefix: !0
                }, [
                    n,
                    i
                ])) : o === t.BANG ? (n = s - 1, x(t.BANG), h({
                    type: e1.NonNullableType,
                    expression: T(),
                    prefix: !0
                }, [
                    n,
                    i
                ])) : (n = i, r = T(), o === t.BANG ? (x(t.BANG), h({
                    type: e1.NonNullableType,
                    expression: r,
                    prefix: !1
                }, [
                    n,
                    i
                ])) : o === t.QUESTION ? (x(t.QUESTION), h({
                    type: e1.NullableType,
                    expression: r,
                    prefix: !1
                }, [
                    n,
                    i
                ])) : o === t.LBRACK ? (x(t.LBRACK), C(t.RBRACK, "expected an array-style type declaration (" + a + "[])"), h({
                    type: e1.TypeApplication,
                    expression: h({
                        type: e1.NameExpression,
                        name: "Array"
                    }, [
                        n,
                        i
                    ]),
                    applications: [
                        r
                    ]
                }, [
                    n,
                    i
                ])) : r);
            }
            function D() {
                var r, n;
                if (r = R(), o !== t.PIPE) return r;
                for(n = [
                    r
                ], x(t.PIPE); n.push(R()), o === t.PIPE;)x(t.PIPE);
                return h({
                    type: e1.UnionType,
                    elements: n
                }, [
                    0,
                    s
                ]);
            }
            function w(t, r, n) {
                var s, i, o;
                switch(t.type){
                    case e1.NullableLiteral:
                        s = "?";
                        break;
                    case e1.AllLiteral:
                        s = "*";
                        break;
                    case e1.NullLiteral:
                        s = "null";
                        break;
                    case e1.UndefinedLiteral:
                        s = "undefined";
                        break;
                    case e1.VoidLiteral:
                        s = "void";
                        break;
                    case e1.UnionType:
                        for(s = n ? "" : "(", i = 0, o = t.elements.length; i < o; ++i)s += w(t.elements[i], r), i + 1 !== o && (s += r ? "|" : " | ");
                        n || (s += ")");
                        break;
                    case e1.ArrayType:
                        for(s = "[", i = 0, o = t.elements.length; i < o; ++i)s += w(t.elements[i], r), i + 1 !== o && (s += r ? "," : ", ");
                        s += "]";
                        break;
                    case e1.RecordType:
                        for(s = "{", i = 0, o = t.fields.length; i < o; ++i)s += w(t.fields[i], r), i + 1 !== o && (s += r ? "," : ", ");
                        s += "}";
                        break;
                    case e1.FieldType:
                        s = t.value ? t.key + (r ? ":" : ": ") + w(t.value, r) : t.key;
                        break;
                    case e1.FunctionType:
                        for(s = r ? "function(" : "function (", t.this && (t.new ? s += r ? "new:" : "new: " : s += r ? "this:" : "this: ", s += w(t.this, r), 0 !== t.params.length && (s += r ? "," : ", ")), i = 0, o = t.params.length; i < o; ++i)s += w(t.params[i], r), i + 1 !== o && (s += r ? "," : ", ");
                        s += ")", t.result && (s += (r ? ":" : ": ") + w(t.result, r));
                        break;
                    case e1.ParameterType:
                        s = t.name + (r ? ":" : ": ") + w(t.expression, r);
                        break;
                    case e1.RestType:
                        s = "...", t.expression && (s += w(t.expression, r));
                        break;
                    case e1.NonNullableType:
                        s = t.prefix ? "!" + w(t.expression, r) : w(t.expression, r) + "!";
                        break;
                    case e1.OptionalType:
                        s = w(t.expression, r) + "=";
                        break;
                    case e1.NullableType:
                        s = t.prefix ? "?" + w(t.expression, r) : w(t.expression, r) + "?";
                        break;
                    case e1.NameExpression:
                        s = t.name;
                        break;
                    case e1.TypeApplication:
                        for(s = w(t.expression, r) + ".<", i = 0, o = t.applications.length; i < o; ++i)s += w(t.applications[i], r), i + 1 !== o && (s += r ? "," : ", ");
                        s += ">";
                        break;
                    case e1.StringLiteralType:
                        s = '"' + t.value + '"';
                        break;
                    case e1.NumericLiteralType:
                    case e1.BooleanLiteralType:
                        s = String(t.value);
                        break;
                    default:
                        l.throwError("Unknown type " + t.type);
                }
                return s;
            }
            u = Bl(), l = vv(), e1 = {
                NullableLiteral: "NullableLiteral",
                AllLiteral: "AllLiteral",
                NullLiteral: "NullLiteral",
                UndefinedLiteral: "UndefinedLiteral",
                VoidLiteral: "VoidLiteral",
                UnionType: "UnionType",
                ArrayType: "ArrayType",
                RecordType: "RecordType",
                FieldType: "FieldType",
                FunctionType: "FunctionType",
                ParameterType: "ParameterType",
                RestType: "RestType",
                NonNullableType: "NonNullableType",
                OptionalType: "OptionalType",
                NullableType: "NullableType",
                NameExpression: "NameExpression",
                TypeApplication: "TypeApplication",
                StringLiteralType: "StringLiteralType",
                NumericLiteralType: "NumericLiteralType",
                BooleanLiteralType: "BooleanLiteralType"
            }, t = {
                ILLEGAL: 0,
                DOT_LT: 1,
                REST: 2,
                LT: 3,
                GT: 4,
                LPAREN: 5,
                RPAREN: 6,
                LBRACE: 7,
                RBRACE: 8,
                LBRACK: 9,
                RBRACK: 10,
                COMMA: 11,
                COLON: 12,
                STAR: 13,
                PIPE: 14,
                QUESTION: 15,
                BANG: 16,
                EQUAL: 17,
                NAME: 18,
                STRING: 19,
                NUMBER: 20,
                EOF: 21
            }, d.prototype.restore = function() {
                i = this._previous, s = this._index, o = this._token, a = this._value;
            }, d.save = function() {
                return new d(i, s, o, a);
            }, Cv.parseType = function(e1, a) {
                var u;
                return n = (r = e1).length, s = 0, i = 0, p = a && a.range, c = a && a.startIndex || 0, E(), u = D(), a && a.midstream ? {
                    expression: u,
                    index: i
                } : (o !== t.EOF && l.throwError("not reach to EOF"), u);
            }, Cv.parseParamType = function(a, u) {
                var f;
                return n = (r = a).length, s = 0, i = 0, p = u && u.range, c = u && u.startIndex || 0, E(), f = function() {
                    var r;
                    return o === t.REST ? (x(t.REST), h({
                        type: e1.RestType,
                        expression: D()
                    }, [
                        0,
                        s
                    ])) : (r = D(), o === t.EQUAL ? (x(t.EQUAL), h({
                        type: e1.OptionalType,
                        expression: r
                    }, [
                        0,
                        s
                    ])) : r);
                }(), u && u.midstream ? {
                    expression: f,
                    index: i
                } : (o !== t.EOF && l.throwError("not reach to EOF"), f);
            }, Cv.stringify = function(e1, t) {
                return null == t && (t = {}), w(e1, t.compact, t.topLevel);
            }, Cv.Syntax = e1;
        }()), Cv;
    }
    function Tv() {
        return zb || (zb = 1, function(e1) {
            !function() {
                var t, r, n, s, i, o;
                function a(e1, t, r) {
                    return e1.slice(t, r);
                }
                function u(e1) {
                    return "param" === e1 || "argument" === e1 || "arg" === e1;
                }
                function l(e1) {
                    return "return" === e1 || "returns" === e1;
                }
                function c(e1) {
                    return "property" === e1 || "prop" === e1;
                }
                function p(e1) {
                    return u(e1) || c(e1) || "alias" === e1 || "this" === e1 || "mixes" === e1 || "requires" === e1;
                }
                function f(e1) {
                    return c(e1) || u(e1);
                }
                function d(e1) {
                    return u(e1) || l(e1) || "define" === e1 || "enum" === e1 || "implements" === e1 || "this" === e1 || "type" === e1 || "typedef" === e1 || c(e1);
                }
                s = Bl(), t = Av(), r = vv(), o = Object.prototype.hasOwnProperty, i = function(e1, t) {
                    return o.call(e1, t);
                };
                var h = "[ \\f\\t\\v\\u00a0\\u1680\\u180e\\u2000-\\u200a\\u202f\\u205f\\u3000\\ufeff]", m = "(" + h + "*(?:\\*" + h + "?)?)(.+|[\r\n\u2028\u2029])";
                function g(e1) {
                    return e1.replace(/^\/\*\*?/, "").replace(/\*\/$/, "").replace(new RegExp(m, "g"), "$2").replace(/\s*$/, "");
                }
                !function(e1) {
                    var n, o, h, y, E, x, C, S, b;
                    function v() {
                        var e1 = E.charCodeAt(o);
                        return o += 1, !s.code.isLineTerminator(e1) || 13 === e1 && 10 === E.charCodeAt(o) || (h += 1), String.fromCharCode(e1);
                    }
                    function A(e1, n, i) {
                        for(var a, u, l, c, p = !1; o < n;){
                            if (a = E.charCodeAt(o), !s.code.isWhiteSpace(a)) {
                                if (123 === a) {
                                    v();
                                    break;
                                }
                                p = !0;
                                break;
                            }
                            v();
                        }
                        if (p) return null;
                        for(u = 1, l = ""; o < n;)if (a = E.charCodeAt(o), s.code.isLineTerminator(a)) v();
                        else {
                            if (125 === a) {
                                if (0 === (u -= 1)) {
                                    v();
                                    break;
                                }
                            } else 123 === a && (u += 1);
                            "" === l && (c = o), l += v();
                        }
                        return 0 !== u ? r.throwError("Braces are not balanced") : f(e1) ? t.parseParamType(l, {
                            startIndex: w(c),
                            range: i
                        }) : t.parseType(l, {
                            startIndex: w(c),
                            range: i
                        });
                    }
                    function T(e1) {
                        var t;
                        if (!s.code.isIdentifierStartES5(E.charCodeAt(o)) && !E[o].match(/[0-9]/)) return null;
                        for(t = v(); o < e1 && s.code.isIdentifierPartES5(E.charCodeAt(o));)t += v();
                        return t;
                    }
                    function R(e1) {
                        for(; o < e1 && (s.code.isWhiteSpace(E.charCodeAt(o)) || s.code.isLineTerminator(E.charCodeAt(o)));)v();
                    }
                    function D(e1, t, r) {
                        var n, i, a = "";
                        if (R(e1), o >= e1) return null;
                        if (91 === E.charCodeAt(o)) {
                            if (!t) return null;
                            n = !0, a = v();
                        }
                        if (a += T(e1), r) for(58 !== E.charCodeAt(o) || "module" !== a && "external" !== a && "event" !== a || (a += v(), a += T(e1)), 91 === E.charCodeAt(o) && 93 === E.charCodeAt(o + 1) && (a += v(), a += v()); 46 === E.charCodeAt(o) || 47 === E.charCodeAt(o) || 35 === E.charCodeAt(o) || 45 === E.charCodeAt(o) || 126 === E.charCodeAt(o);)a += v(), a += T(e1);
                        if (n) {
                            if (R(e1), 61 === E.charCodeAt(o)) {
                                var u;
                                a += v(), R(e1);
                                for(var l = 1; o < e1;){
                                    if (u = E.charCodeAt(o), s.code.isWhiteSpace(u) && (i || (R(e1), u = E.charCodeAt(o))), 39 === u && (i ? "'" === i && (i = "") : i = "'"), 34 === u && (i ? '"' === i && (i = "") : i = '"'), 91 === u) l++;
                                    else if (93 === u && 0 == --l) break;
                                    a += v();
                                }
                            }
                            if (R(e1), o >= e1 || 93 !== E.charCodeAt(o)) return null;
                            a += v();
                        }
                        return a;
                    }
                    function w(e1) {
                        return E === x ? e1 : function(e1, t) {
                            for(var r, n = e1.replace(/^\/\*\*?/, ""), s = 0, i = new RegExp(m, "g"); r = i.exec(n);)if (s += r[1].length, r.index + r[0].length > t + s) return t + s + e1.length - n.length;
                            return e1.replace(/\*\/$/, "").replace(/\s*$/, "").length;
                        }(x, e1);
                    }
                    function _(e1, t) {
                        this._options = e1, this._title = t.toLowerCase(), this._tag = {
                            title: t,
                            description: null
                        }, this._options.lineNumbers && (this._tag.lineNumber = h), this._first = o - t.length - 1, this._last = 0, this._extra = {};
                    }
                    function k(e1) {
                        var t, n;
                        if (!function() {
                            for(; o < y && 64 !== E.charCodeAt(o);)v();
                            return !(o >= y || (r.assert(64 === E.charCodeAt(o)), 0));
                        }()) return null;
                        for(n = (t = new _(e1, function() {
                            var e1, t = "";
                            for(v(); o < y && ((e1 = E.charCodeAt(o)) >= 97 && e1 <= 122 || e1 >= 65 && e1 <= 90 || e1 >= 48 && e1 <= 57);)t += v();
                            return t;
                        }())).parse(); o < t._last;)v();
                        return n;
                    }
                    _.prototype.addError = function(e1) {
                        var t = Array.prototype.slice.call(arguments, 1), n = e1.replace(/%(\d)/g, function(e1, n) {
                            return r.assert(n < t.length, "Message reference must be in range"), t[n];
                        });
                        return this._tag.errors || (this._tag.errors = []), b && r.throwError(n), this._tag.errors.push(n), C;
                    }, _.prototype.parseType = function() {
                        if (d(this._title)) try {
                            if (this._tag.type = A(this._title, this._last, this._options.range), !(this._tag.type || u(this._title) || l(this._title) || this.addError("Missing or invalid tag type"))) return !1;
                        } catch (e1) {
                            if (this._tag.type = null, !this.addError(e1.message)) return !1;
                        }
                        else if (function(e1) {
                            return d(e1) || "throws" === e1 || "const" === e1 || "constant" === e1 || "namespace" === e1 || "member" === e1 || "var" === e1 || "module" === e1 || "constructor" === e1 || "class" === e1 || "extends" === e1 || "augments" === e1 || "public" === e1 || "private" === e1 || "protected" === e1;
                        }(this._title)) try {
                            this._tag.type = A(this._title, this._last, this._options.range);
                        } catch (e1) {}
                        return !0;
                    }, _.prototype._parseNamePath = function(e1) {
                        var t;
                        return !!((t = D(this._last, S && f(this._title), !0)) || e1 || this.addError("Missing or invalid tag name")) && (this._tag.name = t, !0);
                    }, _.prototype.parseNamePath = function() {
                        return this._parseNamePath(!1);
                    }, _.prototype.parseNamePathOptional = function() {
                        return this._parseNamePath(!0);
                    }, _.prototype.parseName = function() {
                        var e1, t;
                        if (function(e1) {
                            return p(e1) || "const" === e1 || "constant" === e1;
                        }(this._title)) {
                            if (this._tag.name = D(this._last, S && f(this._title), function(e1) {
                                return c(e1) || u(e1);
                            }(this._title)), this._tag.name) "[" === (t = this._tag.name).charAt(0) && "]" === t.charAt(t.length - 1) && ((e1 = t.substring(1, t.length - 1).split("=")).length > 1 && (this._tag.default = e1.slice(1).join("=")), this._tag.name = e1[0], this._tag.type && "OptionalType" !== this._tag.type.type && (this._tag.type = {
                                type: "OptionalType",
                                expression: this._tag.type
                            }));
                            else {
                                if (!p(this._title)) return !0;
                                if (u(this._title) && this._tag.type && this._tag.type.name) this._extra.name = this._tag.type, this._tag.name = this._tag.type.name, this._tag.type = null;
                                else if (!this.addError("Missing or invalid tag name")) return !1;
                            }
                        }
                        return !0;
                    }, _.prototype.parseDescription = function() {
                        var e1 = a(E, o, this._last).trim();
                        return e1 && (/^-\s+/.test(e1) && (e1 = e1.substring(2)), this._tag.description = e1), !0;
                    }, _.prototype.parseCaption = function() {
                        var e1 = a(E, o, this._last).trim(), t = "<caption>", r = "</caption>", n = e1.indexOf(t), s = e1.indexOf(r);
                        return n >= 0 && s >= 0 ? (this._tag.caption = e1.substring(n + 9, s).trim(), this._tag.description = e1.substring(s + 10).trim()) : this._tag.description = e1, !0;
                    }, _.prototype.parseKind = function() {
                        var e1, t;
                        return t = {
                            class: !0,
                            constant: !0,
                            event: !0,
                            external: !0,
                            file: !0,
                            function: !0,
                            member: !0,
                            mixin: !0,
                            module: !0,
                            namespace: !0,
                            typedef: !0
                        }, e1 = a(E, o, this._last).trim(), this._tag.kind = e1, !(!i(t, e1) && !this.addError("Invalid kind name '%0'", e1));
                    }, _.prototype.parseAccess = function() {
                        var e1;
                        return e1 = a(E, o, this._last).trim(), this._tag.access = e1, !("private" !== e1 && "protected" !== e1 && "public" !== e1 && !this.addError("Invalid access name '%0'", e1));
                    }, _.prototype.parseThis = function() {
                        var e1 = a(E, o, this._last).trim();
                        return e1 && "{" === e1.charAt(0) ? this.parseType() && "NameExpression" === this._tag.type.type || "UnionType" === this._tag.type.type ? (this._tag.name = this._tag.type.name, !0) : this.addError("Invalid name for this") : this.parseNamePath();
                    }, _.prototype.parseVariation = function() {
                        var e1, t;
                        return t = a(E, o, this._last).trim(), e1 = parseFloat(t, 10), this._tag.variation = e1, !(isNaN(e1) && !this.addError("Invalid variation '%0'", t));
                    }, _.prototype.ensureEnd = function() {
                        var e1 = a(E, o, this._last).trim();
                        return !(e1 && !this.addError("Unknown content '%0'", e1));
                    }, _.prototype.epilogue = function() {
                        var e1;
                        return e1 = this._tag.description, !(f(this._title) && !this._tag.type && e1 && "[" === e1.charAt(0) && (this._tag.type = this._extra.name, this._tag.name || (this._tag.name = void 0), !S && !this.addError("Missing or invalid tag name")));
                    }, n = {
                        access: [
                            "parseAccess"
                        ],
                        alias: [
                            "parseNamePath",
                            "ensureEnd"
                        ],
                        augments: [
                            "parseType",
                            "parseNamePathOptional",
                            "ensureEnd"
                        ],
                        constructor: [
                            "parseType",
                            "parseNamePathOptional",
                            "ensureEnd"
                        ],
                        class: [
                            "parseType",
                            "parseNamePathOptional",
                            "ensureEnd"
                        ],
                        extends: [
                            "parseType",
                            "parseNamePathOptional",
                            "ensureEnd"
                        ],
                        example: [
                            "parseCaption"
                        ],
                        deprecated: [
                            "parseDescription"
                        ],
                        global: [
                            "ensureEnd"
                        ],
                        inner: [
                            "ensureEnd"
                        ],
                        instance: [
                            "ensureEnd"
                        ],
                        kind: [
                            "parseKind"
                        ],
                        mixes: [
                            "parseNamePath",
                            "ensureEnd"
                        ],
                        mixin: [
                            "parseNamePathOptional",
                            "ensureEnd"
                        ],
                        member: [
                            "parseType",
                            "parseNamePathOptional",
                            "ensureEnd"
                        ],
                        method: [
                            "parseNamePathOptional",
                            "ensureEnd"
                        ],
                        module: [
                            "parseType",
                            "parseNamePathOptional",
                            "ensureEnd"
                        ],
                        func: [
                            "parseNamePathOptional",
                            "ensureEnd"
                        ],
                        function: [
                            "parseNamePathOptional",
                            "ensureEnd"
                        ],
                        var: [
                            "parseType",
                            "parseNamePathOptional",
                            "ensureEnd"
                        ],
                        name: [
                            "parseNamePath",
                            "ensureEnd"
                        ],
                        namespace: [
                            "parseType",
                            "parseNamePathOptional",
                            "ensureEnd"
                        ],
                        private: [
                            "parseType",
                            "parseDescription"
                        ],
                        protected: [
                            "parseType",
                            "parseDescription"
                        ],
                        public: [
                            "parseType",
                            "parseDescription"
                        ],
                        readonly: [
                            "ensureEnd"
                        ],
                        requires: [
                            "parseNamePath",
                            "ensureEnd"
                        ],
                        since: [
                            "parseDescription"
                        ],
                        static: [
                            "ensureEnd"
                        ],
                        summary: [
                            "parseDescription"
                        ],
                        this: [
                            "parseThis",
                            "ensureEnd"
                        ],
                        todo: [
                            "parseDescription"
                        ],
                        typedef: [
                            "parseType",
                            "parseNamePathOptional"
                        ],
                        variation: [
                            "parseVariation"
                        ],
                        version: [
                            "parseDescription"
                        ]
                    }, _.prototype.parse = function() {
                        var e1, t, r;
                        if (!this._title && !this.addError("Missing or invalid title")) return null;
                        for(this._last = function() {
                            var e1, t, r = o;
                            for(t = !1; r < y;){
                                if (e1 = E.charCodeAt(r), !s.code.isLineTerminator(e1) || 13 === e1 && 10 === E.charCodeAt(r + 1)) {
                                    if (t) {
                                        if (64 === e1) break;
                                        s.code.isWhiteSpace(e1) || (t = !1);
                                    }
                                } else t = !0;
                                r += 1;
                            }
                            return r;
                        }(this._title), this._options.range && (this._tag.range = [
                            this._first,
                            E.slice(0, this._last).replace(/\s*$/, "").length
                        ].map(w)), e1 = 0, t = (r = i(n, this._title) ? n[this._title] : [
                            "parseType",
                            "parseName",
                            "parseDescription",
                            "epilogue"
                        ]).length; e1 < t; ++e1)if (!this[r[e1]]()) return null;
                        return this._tag;
                    }, e1.parse = function(e1, t) {
                        var n, i, a, u, l, c = [];
                        if (void 0 === t && (t = {}), E = "boolean" == typeof t.unwrap && t.unwrap ? g(e1) : e1, x = e1, t.tags) {
                            if (Array.isArray(t.tags)) for(a = {}, u = 0, l = t.tags.length; u < l; u++)"string" == typeof t.tags[u] ? a[t.tags[u]] = !0 : r.throwError('Invalid "tags" parameter: ' + t.tags);
                            else r.throwError('Invalid "tags" parameter: ' + t.tags);
                        }
                        for(y = E.length, o = 0, h = 0, C = t.recoverable, S = t.sloppy, b = t.strict, i = function(e1) {
                            var t, r, n = "";
                            for(r = !0; o < y && (t = E.charCodeAt(o), !r || 64 !== t);)s.code.isLineTerminator(t) ? r = !0 : r && !s.code.isWhiteSpace(t) && (r = !1), n += v();
                            return e1 ? n : n.trim();
                        }(t.preserveWhitespace); n = k(t);)a && !a.hasOwnProperty(n.title) || c.push(n);
                        return {
                            description: i,
                            tags: c
                        };
                    };
                }(n = {}), e1.version = r.VERSION, e1.parse = n.parse, e1.parseType = t.parseType, e1.parseParamType = t.parseParamType, e1.unwrapComment = g, e1.Syntax = function(e1) {
                    var t, r = {};
                    for(t in e1)e1.hasOwnProperty(t) && (r[t] = e1[t]);
                    return r;
                }(t.Syntax), e1.Error = r.DoctrineError, e1.type = {
                    Syntax: e1.Syntax,
                    parseType: t.parseType,
                    parseParamType: t.parseParamType,
                    stringify: t.stringify
                };
            }();
        }(xv)), xv;
    }
    function Rv() {
        if (Jb) return Hb;
        Jb = 1;
        const e1 = Tv();
        return Hb = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Enforce valid JSDoc comments",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/valid-jsdoc"
                },
                schema: [
                    {
                        type: "object",
                        properties: {
                            prefer: {
                                type: "object",
                                additionalProperties: {
                                    type: "string"
                                }
                            },
                            preferType: {
                                type: "object",
                                additionalProperties: {
                                    type: "string"
                                }
                            },
                            requireReturn: {
                                type: "boolean",
                                default: !0
                            },
                            requireParamDescription: {
                                type: "boolean",
                                default: !0
                            },
                            requireReturnDescription: {
                                type: "boolean",
                                default: !0
                            },
                            matchDescription: {
                                type: "string"
                            },
                            requireReturnType: {
                                type: "boolean",
                                default: !0
                            },
                            requireParamType: {
                                type: "boolean",
                                default: !0
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                fixable: "code",
                messages: {
                    unexpectedTag: "Unexpected @{{title}} tag; function has no return statement.",
                    expected: "Expected JSDoc for '{{name}}' but found '{{jsdocName}}'.",
                    use: "Use @{{name}} instead.",
                    useType: "Use '{{expectedTypeName}}' instead of '{{currentTypeName}}'.",
                    syntaxError: "JSDoc syntax error.",
                    missingBrace: "JSDoc type missing brace.",
                    missingParamDesc: "Missing JSDoc parameter description for '{{name}}'.",
                    missingParamType: "Missing JSDoc parameter type for '{{name}}'.",
                    missingReturnType: "Missing JSDoc return type.",
                    missingReturnDesc: "Missing JSDoc return description.",
                    missingReturn: "Missing JSDoc @{{returns}} for function.",
                    missingParam: "Missing JSDoc for parameter '{{name}}'.",
                    duplicateParam: "Duplicate JSDoc parameter '{{name}}'.",
                    unsatisfiedDesc: "JSDoc description does not satisfy the regex pattern."
                },
                deprecated: !0,
                replacedBy: []
            },
            create (t) {
                const r = t.options[0] || {}, n = r.prefer || {}, s = t.sourceCode, i = !1 !== r.requireReturn, o = !1 !== r.requireParamDescription, a = !1 !== r.requireReturnDescription, u = !1 !== r.requireReturnType, l = !1 !== r.requireParamType, c = r.preferType || {}, p = 0 !== Object.keys(c).length, f = [];
                function d(e1) {
                    return "ClassExpression" === e1.type || "ClassDeclaration" === e1.type;
                }
                function h(e1) {
                    f.push({
                        returnPresent: "ArrowFunctionExpression" === e1.type && "BlockStatement" !== e1.body.type || d(e1) || e1.async
                    });
                }
                function m(e1) {
                    return null === e1.type || "void" === e1.type.name || "UndefinedLiteral" === e1.type.type;
                }
                function g(e1) {
                    let t;
                    return e1.name ? t = e1 : e1.expression && (t = e1.expression), {
                        currentType: t,
                        expectedTypeName: t && c[t.name]
                    };
                }
                function y(e1, t) {
                    return {
                        start: s.getLocFromIndex(e1.range[0] + 2 + t.range[0]),
                        end: s.getLocFromIndex(e1.range[0] + 2 + t.range[1])
                    };
                }
                function E(e1, r) {
                    if (!r || !function(e1) {
                        return "UndefinedLiteral" !== e1 && "NullLiteral" !== e1 && "NullableLiteral" !== e1 && "FunctionType" !== e1 && "AllLiteral" !== e1;
                    }(r.type)) return;
                    const n = [];
                    let s = [];
                    switch(r.type){
                        case "TypeApplication":
                            s = "UnionType" === r.applications[0].type ? r.applications[0].elements : r.applications, n.push(g(r));
                            break;
                        case "RecordType":
                            s = r.fields;
                            break;
                        case "UnionType":
                        case "ArrayType":
                            s = r.elements;
                            break;
                        case "FieldType":
                            r.value && n.push(g(r.value));
                            break;
                        default:
                            n.push(g(r));
                    }
                    s.forEach(E.bind(null, e1)), n.forEach((r)=>{
                        r.expectedTypeName && r.expectedTypeName !== r.currentType.name && t.report({
                            node: e1,
                            messageId: "useType",
                            loc: y(e1, r.currentType),
                            data: {
                                currentTypeName: r.currentType.name,
                                expectedTypeName: r.expectedTypeName
                            },
                            fix: (t)=>t.replaceTextRange(r.currentType.range.map((t)=>e1.range[0] + 2 + t), r.expectedTypeName)
                        });
                    });
                }
                function x(c) {
                    const h = s.getJSDocComment(c), g = f.pop(), x = Object.create(null), C = [];
                    let S, b = !1, v = !1, A = !1, T = !1, R = !1;
                    if (h) {
                        let s;
                        try {
                            s = e1.parse(h.value, {
                                strict: !0,
                                unwrap: !0,
                                sloppy: !0,
                                range: !0
                            });
                        } catch (e1) {
                            return void (/braces/iu.test(e1.message) ? t.report({
                                node: h,
                                messageId: "missingBrace"
                            }) : t.report({
                                node: h,
                                messageId: "syntaxError"
                            }));
                        }
                        s.tags.forEach((e1)=>{
                            switch(e1.title.toLowerCase()){
                                case "param":
                                case "arg":
                                case "argument":
                                    C.push(e1);
                                    break;
                                case "return":
                                case "returns":
                                    b = !0, S = e1;
                                    break;
                                case "constructor":
                                case "class":
                                    v = !0;
                                    break;
                                case "override":
                                case "inheritdoc":
                                    T = !0;
                                    break;
                                case "abstract":
                                case "virtual":
                                    R = !0;
                                    break;
                                case "interface":
                                    A = !0;
                            }
                            if (Object.prototype.hasOwnProperty.call(n, e1.title) && e1.title !== n[e1.title]) {
                                const r = y(h, e1);
                                t.report({
                                    node: h,
                                    messageId: "use",
                                    loc: {
                                        start: r.start,
                                        end: {
                                            line: r.start.line,
                                            column: r.start.column + `@${e1.title}`.length
                                        }
                                    },
                                    data: {
                                        name: n[e1.title]
                                    },
                                    fix: (t)=>t.replaceTextRange([
                                            h.range[0] + e1.range[0] + 3,
                                            h.range[0] + e1.range[0] + e1.title.length + 3
                                        ], n[e1.title])
                                });
                            }
                            p && e1.type && E(h, e1.type);
                        }), C.forEach((e1)=>{
                            l && !e1.type && t.report({
                                node: h,
                                messageId: "missingParamType",
                                loc: y(h, e1),
                                data: {
                                    name: e1.name
                                }
                            }), !e1.description && o && t.report({
                                node: h,
                                messageId: "missingParamDesc",
                                loc: y(h, e1),
                                data: {
                                    name: e1.name
                                }
                            }), x[e1.name] ? t.report({
                                node: h,
                                messageId: "duplicateParam",
                                loc: y(h, e1),
                                data: {
                                    name: e1.name
                                }
                            }) : e1.name.includes(".") || (x[e1.name] = e1);
                        }), b && (i || g.returnPresent || null !== S.type && m(S) || R ? (u && !S.type && t.report({
                            node: h,
                            messageId: "missingReturnType"
                        }), m(S) || S.description || !a || t.report({
                            node: h,
                            messageId: "missingReturnDesc"
                        })) : t.report({
                            node: h,
                            messageId: "unexpectedTag",
                            loc: y(h, S),
                            data: {
                                title: S.title
                            }
                        })), T || b || v || A || "get" === c.parent.kind || "constructor" === c.parent.kind || "set" === c.parent.kind || d(c) || (i || g.returnPresent && !c.async) && t.report({
                            node: h,
                            messageId: "missingReturn",
                            data: {
                                returns: n.returns || "returns"
                            }
                        });
                        const f = Object.keys(x);
                        if (c.params && c.params.forEach((e1, r)=>{
                            const n = "AssignmentPattern" === e1.type ? e1.left : e1;
                            if ("Identifier" === n.type) {
                                const e1 = n.name;
                                f[r] && e1 !== f[r] ? t.report({
                                    node: h,
                                    messageId: "expected",
                                    loc: y(h, x[f[r]]),
                                    data: {
                                        name: e1,
                                        jsdocName: f[r]
                                    }
                                }) : x[e1] || T || t.report({
                                    node: h,
                                    messageId: "missingParam",
                                    data: {
                                        name: e1
                                    }
                                });
                            }
                        }), r.matchDescription) new RegExp(r.matchDescription, "u").test(s.description) || t.report({
                            node: h,
                            messageId: "unsatisfiedDesc"
                        });
                    }
                }
                return {
                    ArrowFunctionExpression: h,
                    FunctionExpression: h,
                    FunctionDeclaration: h,
                    ClassExpression: h,
                    ClassDeclaration: h,
                    "ArrowFunctionExpression:exit": x,
                    "FunctionExpression:exit": x,
                    "FunctionDeclaration:exit": x,
                    "ClassExpression:exit": x,
                    "ClassDeclaration:exit": x,
                    ReturnStatement: function(e1) {
                        const t = f[f.length - 1];
                        t && null !== e1.argument && (t.returnPresent = !0);
                    }
                };
            }
        }, Hb;
    }
    function Dv() {
        if (Yb) return Qb;
        Yb = 1;
        const e1 = Ll();
        return Qb = {
            meta: {
                type: "problem",
                docs: {
                    description: "Enforce comparing `typeof` expressions against valid strings",
                    recommended: !0,
                    url: "https://eslint.org/docs/latest/rules/valid-typeof"
                },
                hasSuggestions: !0,
                schema: [
                    {
                        type: "object",
                        properties: {
                            requireStringLiterals: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                messages: {
                    invalidValue: "Invalid typeof comparison value.",
                    notString: "Typeof comparisons should be to string literals.",
                    suggestString: 'Use `"{{type}}"` instead of `{{type}}`.'
                }
            },
            create (t) {
                const r = new Set([
                    "symbol",
                    "undefined",
                    "object",
                    "boolean",
                    "number",
                    "string",
                    "function",
                    "bigint"
                ]), n = new Set([
                    "==",
                    "===",
                    "!=",
                    "!=="
                ]), s = t.sourceCode, i = t.options[0] && t.options[0].requireStringLiterals;
                let o;
                function a(e1) {
                    return "UnaryExpression" === e1.type && "typeof" === e1.operator;
                }
                return {
                    Program (e1) {
                        o = s.getScope(e1);
                    },
                    UnaryExpression (s) {
                        if (a(s)) {
                            const { parent: u } = s;
                            if ("BinaryExpression" === u.type && n.has(u.operator)) {
                                const n = u.left === s ? u.right : u.left;
                                if ("Literal" === n.type || e1.isStaticTemplateLiteral(n)) {
                                    const e1 = "Literal" === n.type ? n.value : n.quasis[0].value.cooked;
                                    r.has(e1) || t.report({
                                        node: n,
                                        messageId: "invalidValue"
                                    });
                                } else "Identifier" === n.type && "undefined" === n.name && function(e1) {
                                    const t = o.set.get(e1.name);
                                    return t && 0 === t.defs.length && t.references.some((t)=>t.identifier === e1);
                                }(n) ? t.report({
                                    node: n,
                                    messageId: i ? "notString" : "invalidValue",
                                    suggest: [
                                        {
                                            messageId: "suggestString",
                                            data: {
                                                type: "undefined"
                                            },
                                            fix: (e1)=>e1.replaceText(n, '"undefined"')
                                        }
                                    ]
                                }) : i && !a(n) && t.report({
                                    node: n,
                                    messageId: "notString"
                                });
                            }
                        }
                    }
                };
            }
        }, Qb;
    }
    function wv() {
        return ev || (ev = 1, Zb = {
            meta: {
                type: "suggestion",
                docs: {
                    description: "Require `var` declarations be placed at the top of their containing scope",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/vars-on-top"
                },
                schema: [],
                messages: {
                    top: "All 'var' declarations must be at the top of the function scope."
                }
            },
            create (e1) {
                function t(e1) {
                    return "ExpressionStatement" === e1.type && "Literal" === e1.expression.type && "string" == typeof e1.expression.value;
                }
                function r(e1) {
                    return "ImportDeclaration" === e1.type || "ImportSpecifier" === e1.type || "ImportDefaultSpecifier" === e1.type || "ImportNamespaceSpecifier" === e1.type;
                }
                function n(e1) {
                    return "VariableDeclaration" === e1.type || "ExportNamedDeclaration" === e1.type && e1.declaration && "VariableDeclaration" === e1.declaration.type;
                }
                function s(e1, s) {
                    const i = s.length;
                    let o = 0;
                    if ("StaticBlock" !== e1.parent.type) for(; o < i && (t(s[o]) || r(s[o])); ++o);
                    for(; o < i; ++o){
                        if (!n(s[o])) return !1;
                        if (s[o] === e1) return !0;
                    }
                    return !1;
                }
                function i(t, r) {
                    s(t, r.body) || e1.report({
                        node: t,
                        messageId: "top"
                    });
                }
                return {
                    "VariableDeclaration[kind='var']" (t) {
                        "ExportNamedDeclaration" === t.parent.type ? i(t.parent, t.parent.parent) : "Program" === t.parent.type ? i(t, t.parent) : function(t) {
                            const { parent: r } = t;
                            "BlockStatement" === r.type && /Function/u.test(r.parent.type) && s(t, r.body) || "StaticBlock" === r.type && s(t, r.body) || e1.report({
                                node: t,
                                messageId: "top"
                            });
                        }(t);
                    }
                };
            }
        }), Zb;
    }
    function _v() {
        if (rv) return tv;
        rv = 1;
        const e1 = Ll(), t = Hi();
        return tv = {
            meta: {
                deprecated: !0,
                replacedBy: [],
                type: "layout",
                docs: {
                    description: "Require parentheses around immediate `function` invocations",
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/wrap-iife"
                },
                schema: [
                    {
                        enum: [
                            "outside",
                            "inside",
                            "any"
                        ]
                    },
                    {
                        type: "object",
                        properties: {
                            functionPrototypeMethods: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                fixable: "code",
                messages: {
                    wrapInvocation: "Wrap an immediate function invocation in parentheses.",
                    wrapExpression: "Wrap only the function expression in parens.",
                    moveInvocation: "Move the invocation into the parens that contain the function."
                }
            },
            create (r) {
                const n = r.options[0] || "outside", s = r.options[1] && r.options[1].functionPrototypeMethods, i = r.sourceCode;
                function o(t) {
                    return e1.isParenthesised(i, t);
                }
                return {
                    CallExpression (a) {
                        const u = function(t) {
                            const r = e1.skipChainExpression(t.callee);
                            return "FunctionExpression" === r.type ? r : !s || "MemberExpression" !== r.type || "FunctionExpression" !== r.object.type || "call" !== e1.getStaticPropertyName(r) && "apply" !== e1.getStaticPropertyName(r) ? null : r.object;
                        }(a);
                        if (!u) return;
                        const l = o(a), c = o(u);
                        l || c ? "inside" !== n || c ? "outside" !== n || l || r.report({
                            node: a,
                            messageId: "moveInvocation",
                            fix (e1) {
                                const t = i.getTokenAfter(u);
                                return e1.replaceTextRange([
                                    t.range[0],
                                    a.range[1]
                                ], `${i.getText().slice(t.range[1], a.range[1])})`);
                            }
                        }) : r.report({
                            node: a,
                            messageId: "wrapExpression",
                            fix (e1) {
                                if (function(e1) {
                                    return t.isParenthesized(1, e1, i);
                                }(a) && !function(e1) {
                                    const t = "ChainExpression" === e1.parent.type ? e1.parent : e1;
                                    return "NewExpression" === t.parent.type && t.parent.callee === t;
                                }(a)) {
                                    const t = i.getTokenAfter(a);
                                    return e1.replaceTextRange([
                                        u.range[1],
                                        t.range[1]
                                    ], `)${i.getText().slice(u.range[1], t.range[0])}`);
                                }
                                return e1.replaceText(u, `(${i.getText(u)})`);
                            }
                        }) : r.report({
                            node: a,
                            messageId: "wrapInvocation",
                            fix (e1) {
                                const t = "inside" === n ? u : a;
                                return e1.replaceText(t, `(${i.getText(t)})`);
                            }
                        });
                    }
                };
            }
        }, tv;
    }
    function kv() {
        if (uv) return av;
        uv = 1;
        const e1 = Ll();
        function t(e1) {
            return [
                "<",
                "<="
            ].includes(e1);
        }
        function r(t) {
            return "UnaryExpression" === t.type && "-" === t.operator && t.prefix && e1.isNumericLiteral(t.argument);
        }
        function n(t) {
            return r(t) || e1.isStaticTemplateLiteral(t);
        }
        function s(t) {
            return "Literal" === t.type ? t : r(t) ? {
                type: "Literal",
                value: -t.argument.value,
                raw: `-${t.argument.value}`
            } : e1.isStaticTemplateLiteral(t) ? {
                type: "Literal",
                value: t.quasis[0].value.cooked,
                raw: t.quasis[0].value.raw
            } : null;
        }
        return av = {
            meta: {
                type: "suggestion",
                docs: {
                    description: 'Require or disallow "Yoda" conditions',
                    recommended: !1,
                    url: "https://eslint.org/docs/latest/rules/yoda"
                },
                schema: [
                    {
                        enum: [
                            "always",
                            "never"
                        ]
                    },
                    {
                        type: "object",
                        properties: {
                            exceptRange: {
                                type: "boolean",
                                default: !1
                            },
                            onlyEquality: {
                                type: "boolean",
                                default: !1
                            }
                        },
                        additionalProperties: !1
                    }
                ],
                fixable: "code",
                messages: {
                    expected: "Expected literal to be on the {{expectedSide}} side of {{operator}}."
                }
            },
            create (r) {
                const i = "always" === r.options[0], o = r.options[1] && r.options[1].exceptRange, a = r.options[1] && r.options[1].onlyEquality, u = r.sourceCode;
                const l = {
                    "===": "===",
                    "!==": "!==",
                    "==": "==",
                    "!=": "!=",
                    "<": ">",
                    ">": "<",
                    "<=": ">=",
                    ">=": "<="
                };
                return {
                    BinaryExpression (c) {
                        const p = i ? c.left : c.right, f = i ? c.right : c.left;
                        var d;
                        "Literal" !== f.type && !n(f) || "Literal" === p.type || n(p) || (d = c.operator, !/^(==|===)$/u.test(d) && a) || !function(e1) {
                            return /^(==|===|!=|!==|<|>|<=|>=)$/u.test(e1);
                        }(c.operator) || o && function(r) {
                            const n = r.left, i = r.right;
                            return "LogicalExpression" === r.type && "BinaryExpression" === n.type && "BinaryExpression" === i.type && t(n.operator) && t(i.operator) && (function() {
                                if ("&&" === r.operator && e1.isSameReference(n.right, i.left)) {
                                    const e1 = s(n.left), t = s(i.right);
                                    if (null === e1 && null === t) return !1;
                                    if (null === t || null === e1) return !0;
                                    if (e1.value <= t.value) return !0;
                                }
                                return !1;
                            }() || function() {
                                if ("||" === r.operator && e1.isSameReference(n.left, i.right)) {
                                    const e1 = s(n.right), t = s(i.left);
                                    if (null === e1 && null === t) return !1;
                                    if (null === t || null === e1) return !0;
                                    if (e1.value <= t.value) return !0;
                                }
                                return !1;
                            }()) && e1.isParenthesised(u, r);
                        }(c.parent) || r.report({
                            node: c,
                            messageId: "expected",
                            data: {
                                operator: c.operator,
                                expectedSide: i ? "left" : "right"
                            },
                            fix: (t)=>t.replaceText(c, function(t) {
                                    const r = u.getFirstTokenBetween(t.left, t.right, (e1)=>e1.value === t.operator), n = u.getTokenBefore(r), s = u.getTokenAfter(r), i = u.getText(), o = i.slice(t.range[0], n.range[1]), a = i.slice(n.range[1], r.range[0]), c = i.slice(r.range[1], s.range[0]), p = i.slice(s.range[0], t.range[1]), f = u.getTokenBefore(t), d = u.getTokenAfter(t);
                                    let h = "", m = "";
                                    return f && f.range[1] === t.range[0] && !e1.canTokensBeAdjacent(f, s) && (h = " "), d && t.range[1] === d.range[0] && !e1.canTokensBeAdjacent(n, d) && (m = " "), h + p + a + l[r.value] + c + o + m;
                                }(c))
                        });
                    }
                };
            }
        }, av;
    }
    function Bv() {
        if (cv) return lv;
        cv = 1;
        const { LazyLoadingRuleMap: e1 } = function() {
            if (gu) return mu;
            gu = 1;
            const e1 = Gi()("eslint:rules");
            class t extends Map {
                constructor(r){
                    let n = r.length;
                    super(e1.enabled ? r.map(([t, r])=>{
                        let s = null;
                        return [
                            t,
                            ()=>(s || (e1("Loading rule %o (remaining=%d)", t, --n), s = r()), s)
                        ];
                    }) : r), Object.defineProperty(t.prototype, "set", {
                        configurable: !0,
                        value: void 0
                    });
                }
                get(e1) {
                    const t = super.get(e1);
                    return t && t();
                }
                *values() {
                    for (const e1 of super.values())yield e1();
                }
                *entries() {
                    for (const [e1, t] of super.entries())yield [
                        e1,
                        t()
                    ];
                }
                forEach(e1, t) {
                    for (const [r, n] of super.entries())e1.call(t, n(), r, this);
                }
            }
            return Object.defineProperties(t.prototype, {
                clear: {
                    configurable: !0,
                    value: void 0
                },
                delete: {
                    configurable: !0,
                    value: void 0
                },
                [Symbol.iterator]: {
                    configurable: !0,
                    writable: !0,
                    value: t.prototype.entries
                }
            }), mu = {
                LazyLoadingRuleMap: t
            };
        }();
        return lv = new e1(Object.entries({
            "accessor-pairs": ()=>Pl(),
            "array-bracket-newline": ()=>Il(),
            "array-bracket-spacing": ()=>Fl(),
            "array-callback-return": ()=>Nl(),
            "array-element-newline": ()=>Ol(),
            "arrow-body-style": ()=>Ul(),
            "arrow-parens": ()=>jl(),
            "arrow-spacing": ()=>Vl(),
            "block-scoped-var": ()=>(ul || (ul = 1, al = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Enforce the use of variables within the scope they are defined",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/block-scoped-var"
                        },
                        schema: [],
                        messages: {
                            outOfScope: "'{{name}}' declared on line {{definitionLine}} column {{definitionColumn}} is used outside of binding context."
                        }
                    },
                    create (e1) {
                        let t = [];
                        const r = e1.sourceCode;
                        function n(e1) {
                            t.push(e1.range);
                        }
                        function s() {
                            t.pop();
                        }
                        function i(t, r) {
                            const n = t.identifier, s = r.name.loc.start;
                            e1.report({
                                node: n,
                                messageId: "outOfScope",
                                data: {
                                    name: n.name,
                                    definitionLine: s.line,
                                    definitionColumn: s.column + 1
                                }
                            });
                        }
                        return {
                            Program (e1) {
                                t = [
                                    e1.range
                                ];
                            },
                            BlockStatement: n,
                            "BlockStatement:exit": s,
                            ForStatement: n,
                            "ForStatement:exit": s,
                            ForInStatement: n,
                            "ForInStatement:exit": s,
                            ForOfStatement: n,
                            "ForOfStatement:exit": s,
                            SwitchStatement: n,
                            "SwitchStatement:exit": s,
                            CatchClause: n,
                            "CatchClause:exit": s,
                            StaticBlock: n,
                            "StaticBlock:exit": s,
                            VariableDeclaration: function(e1) {
                                if ("var" !== e1.kind) return;
                                const n = t[t.length - 1];
                                function s(e1) {
                                    const t = e1.identifier.range;
                                    return t[0] < n[0] || t[1] > n[1];
                                }
                                const o = r.getDeclaredVariables(e1);
                                for(let t = 0; t < o.length; ++t)o[t].references.filter(s).forEach((r)=>i(r, o[t].defs.find((t)=>t.parent === e1)));
                            }
                        };
                    }
                }), al),
            "block-spacing": ()=>Kl(),
            "brace-style": ()=>(function() {
                    if (fl) return pl;
                    fl = 1;
                    const e1 = Ll();
                    return pl = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "layout",
                            docs: {
                                description: "Enforce consistent brace style for blocks",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/brace-style"
                            },
                            schema: [
                                {
                                    enum: [
                                        "1tbs",
                                        "stroustrup",
                                        "allman"
                                    ]
                                },
                                {
                                    type: "object",
                                    properties: {
                                        allowSingleLine: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            fixable: "whitespace",
                            messages: {
                                nextLineOpen: "Opening curly brace does not appear on the same line as controlling statement.",
                                sameLineOpen: "Opening curly brace appears on the same line as controlling statement.",
                                blockSameLine: "Statement inside of curly braces should be on next line.",
                                nextLineClose: "Closing curly brace does not appear on the same line as the subsequent block.",
                                singleLineClose: "Closing curly brace should be on the same line as opening curly brace or on the line after the previous block.",
                                sameLineClose: "Closing curly brace appears on the same line as the subsequent block."
                            }
                        },
                        create (t) {
                            const r = t.options[0] || "1tbs", n = t.options[1] || {}, s = t.sourceCode;
                            function i(e1, t) {
                                const r = [
                                    e1.range[1],
                                    t.range[0]
                                ];
                                return s.text.slice(r[0], r[1]).trim() ? null : (e1)=>e1.replaceTextRange(r, " ");
                            }
                            function o(o, a) {
                                const u = s.getTokenBefore(o), l = s.getTokenAfter(o), c = s.getTokenBefore(a), p = n.allowSingleLine && e1.isTokenOnSameLine(o, a);
                                "allman" === r || e1.isTokenOnSameLine(u, o) || t.report({
                                    node: o,
                                    messageId: "nextLineOpen",
                                    fix: i(u, o)
                                }), "allman" === r && e1.isTokenOnSameLine(u, o) && !p && t.report({
                                    node: o,
                                    messageId: "sameLineOpen",
                                    fix: (e1)=>e1.insertTextBefore(o, "\n")
                                }), e1.isTokenOnSameLine(o, l) && l !== a && !p && t.report({
                                    node: o,
                                    messageId: "blockSameLine",
                                    fix: (e1)=>e1.insertTextAfter(o, "\n")
                                }), c !== o && !p && e1.isTokenOnSameLine(c, a) && t.report({
                                    node: a,
                                    messageId: "singleLineClose",
                                    fix: (e1)=>e1.insertTextBefore(a, "\n")
                                });
                            }
                            function a(n) {
                                const o = s.getTokenAfter(n);
                                "1tbs" !== r || e1.isTokenOnSameLine(n, o) || t.report({
                                    node: n,
                                    messageId: "nextLineClose",
                                    fix: i(n, o)
                                }), "1tbs" !== r && e1.isTokenOnSameLine(n, o) && t.report({
                                    node: n,
                                    messageId: "sameLineClose",
                                    fix: (e1)=>e1.insertTextAfter(n, "\n")
                                });
                            }
                            return {
                                BlockStatement (t) {
                                    e1.STATEMENT_LIST_PARENTS.has(t.parent.type) || o(s.getFirstToken(t), s.getLastToken(t));
                                },
                                StaticBlock (e1) {
                                    o(s.getFirstToken(e1, {
                                        skip: 1
                                    }), s.getLastToken(e1));
                                },
                                ClassBody (e1) {
                                    o(s.getFirstToken(e1), s.getLastToken(e1));
                                },
                                SwitchStatement (e1) {
                                    const t = s.getLastToken(e1);
                                    o(s.getTokenBefore(e1.cases.length ? e1.cases[0] : t), t);
                                },
                                IfStatement (e1) {
                                    "BlockStatement" === e1.consequent.type && e1.alternate && a(s.getLastToken(e1.consequent));
                                },
                                TryStatement (e1) {
                                    a(s.getLastToken(e1.block)), e1.handler && e1.finalizer && a(s.getLastToken(e1.handler.body));
                                }
                            };
                        }
                    }, pl;
                })(),
            "callback-return": ()=>Ml(),
            camelcase: ()=>$l(),
            "capitalized-comments": ()=>ql(),
            "class-methods-use-this": ()=>Gl(),
            "comma-dangle": ()=>Wl(),
            "comma-spacing": ()=>(function() {
                    if (Rl) return Tl;
                    Rl = 1;
                    const e1 = Ll();
                    return Tl = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "layout",
                            docs: {
                                description: "Enforce consistent spacing before and after commas",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/comma-spacing"
                            },
                            fixable: "whitespace",
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        before: {
                                            type: "boolean",
                                            default: !1
                                        },
                                        after: {
                                            type: "boolean",
                                            default: !0
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                missing: "A space is required {{loc}} ','.",
                                unexpected: "There should be no space {{loc}} ','."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode, n = r.tokensAndComments, s = {
                                before: !!t.options[0] && t.options[0].before,
                                after: !t.options[0] || t.options[0].after
                            }, i = [];
                            function o(e1, r, n) {
                                t.report({
                                    node: e1,
                                    fix (t) {
                                        if (s[r]) return "before" === r ? t.insertTextBefore(e1, " ") : t.insertTextAfter(e1, " ");
                                        let i, o;
                                        return "before" === r ? (i = n.range[1], o = e1.range[0]) : (i = e1.range[1], o = n.range[0]), t.replaceTextRange([
                                            i,
                                            o
                                        ], "");
                                    },
                                    messageId: s[r] ? "missing" : "unexpected",
                                    data: {
                                        loc: r
                                    }
                                });
                            }
                            function a(t) {
                                let n = r.getFirstToken(t);
                                t.elements.forEach((t)=>{
                                    let s;
                                    null === t ? (s = r.getTokenAfter(n), e1.isCommaToken(s) && i.push(s)) : s = r.getTokenAfter(t), n = s;
                                });
                            }
                            return {
                                "Program:exit" () {
                                    n.forEach((t, a)=>{
                                        if (!e1.isCommaToken(t)) return;
                                        const u = n[a - 1], l = n[a + 1];
                                        u && !e1.isCommaToken(u) && !i.includes(t) && e1.isTokenOnSameLine(u, t) && s.before !== r.isSpaceBetweenTokens(u, t) && o(t, "before", u), !l || e1.isCommaToken(l) || e1.isClosingParenToken(l) || e1.isClosingBracketToken(l) || e1.isClosingBraceToken(l) || !s.after && "Line" === l.type || !e1.isTokenOnSameLine(t, l) || s.after === r.isSpaceBetweenTokens(t, l) || o(t, "after", l);
                                    });
                                },
                                ArrayExpression: a,
                                ArrayPattern: a
                            };
                        }
                    }, Tl;
                })(),
            "comma-style": ()=>Xl(),
            complexity: ()=>(function() {
                    if (ac) return oc;
                    ac = 1;
                    const e1 = Ll(), { upperCaseFirst: t } = id();
                    return oc = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Enforce a maximum cyclomatic complexity allowed in a program",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/complexity"
                            },
                            schema: [
                                {
                                    oneOf: [
                                        {
                                            type: "integer",
                                            minimum: 0
                                        },
                                        {
                                            type: "object",
                                            properties: {
                                                maximum: {
                                                    type: "integer",
                                                    minimum: 0
                                                },
                                                max: {
                                                    type: "integer",
                                                    minimum: 0
                                                }
                                            },
                                            additionalProperties: !1
                                        }
                                    ]
                                }
                            ],
                            messages: {
                                complex: "{{name}} has a complexity of {{complexity}}. Maximum allowed is {{max}}."
                            }
                        },
                        create (r) {
                            const n = r.options[0];
                            let s = 20;
                            "object" == typeof n && (Object.prototype.hasOwnProperty.call(n, "maximum") || Object.prototype.hasOwnProperty.call(n, "max")) ? s = n.maximum || n.max : "number" == typeof n && (s = n);
                            const i = [];
                            function o() {
                                i[i.length - 1]++;
                            }
                            return {
                                onCodePathStart () {
                                    i.push(1);
                                },
                                CatchClause: o,
                                ConditionalExpression: o,
                                LogicalExpression: o,
                                ForStatement: o,
                                ForInStatement: o,
                                ForOfStatement: o,
                                IfStatement: o,
                                WhileStatement: o,
                                DoWhileStatement: o,
                                "SwitchCase[test]": o,
                                AssignmentExpression (t) {
                                    e1.isLogicalAssignmentOperator(t.operator) && o();
                                },
                                onCodePathEnd (n, o) {
                                    const a = i.pop();
                                    if (("function" === n.origin || "class-field-initializer" === n.origin || "class-static-block" === n.origin) && a > s) {
                                        let i;
                                        i = "class-field-initializer" === n.origin ? "class field initializer" : "class-static-block" === n.origin ? "class static block" : e1.getFunctionNameWithKind(o), r.report({
                                            node: o,
                                            messageId: "complex",
                                            data: {
                                                name: t(i),
                                                complexity: a,
                                                max: s
                                            }
                                        });
                                    }
                                }
                            };
                        }
                    }, oc;
                })(),
            "computed-property-spacing": ()=>od(),
            "consistent-return": ()=>(function() {
                    if (pc) return cc;
                    pc = 1;
                    const e1 = Ll(), { upperCaseFirst: t } = id();
                    return cc = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Require `return` statements to either always or never specify values",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/consistent-return"
                            },
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        treatUndefinedAsUnspecified: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                missingReturn: "Expected to return a value at the end of {{name}}.",
                                missingReturnValue: "{{name}} expected a return value.",
                                unexpectedReturnValue: "{{name}} expected no return value."
                            }
                        },
                        create (r) {
                            const n = !0 === (r.options[0] || {}).treatUndefinedAsUnspecified;
                            let s = null;
                            function i(t) {
                                let n, i;
                                !s.hasReturnValue || function(e1) {
                                    for (const t of e1)if (t.reachable) return !1;
                                    return !0;
                                }(s.currentSegments) || e1.isES5Constructor(t) || function(e1) {
                                    return "FunctionExpression" === e1.type && e1.parent && "MethodDefinition" === e1.parent.type && "constructor" === e1.parent.kind;
                                }(t) || ("Program" === t.type ? (n = {
                                    line: 1,
                                    column: 0
                                }, i = "program") : n = "ArrowFunctionExpression" === t.type ? r.sourceCode.getTokenBefore(t.body, e1.isArrowToken).loc : "MethodDefinition" === t.parent.type || "Property" === t.parent.type && t.parent.method ? t.parent.key.loc : (t.id || r.sourceCode.getFirstToken(t)).loc, i || (i = e1.getFunctionNameWithKind(t)), r.report({
                                    node: t,
                                    loc: n,
                                    messageId: "missingReturn",
                                    data: {
                                        name: i
                                    }
                                }));
                            }
                            return {
                                onCodePathStart (e1, t) {
                                    s = {
                                        upper: s,
                                        codePath: e1,
                                        hasReturn: !1,
                                        hasReturnValue: !1,
                                        messageId: "",
                                        node: t,
                                        currentSegments: new Set
                                    };
                                },
                                onCodePathEnd () {
                                    s = s.upper;
                                },
                                onUnreachableCodePathSegmentStart (e1) {
                                    s.currentSegments.add(e1);
                                },
                                onUnreachableCodePathSegmentEnd (e1) {
                                    s.currentSegments.delete(e1);
                                },
                                onCodePathSegmentStart (e1) {
                                    s.currentSegments.add(e1);
                                },
                                onCodePathSegmentEnd (e1) {
                                    s.currentSegments.delete(e1);
                                },
                                ReturnStatement (i) {
                                    const o = i.argument;
                                    let a = Boolean(o);
                                    n && a && (a = !e1.isSpecificId(o, "undefined") && "void" !== o.operator), s.hasReturn ? s.hasReturnValue !== a && r.report({
                                        node: i,
                                        messageId: s.messageId,
                                        data: s.data
                                    }) : (s.hasReturn = !0, s.hasReturnValue = a, s.messageId = a ? "missingReturnValue" : "unexpectedReturnValue", s.data = {
                                        name: "Program" === s.node.type ? "Program" : t(e1.getFunctionNameWithKind(s.node))
                                    });
                                },
                                "Program:exit": i,
                                "FunctionDeclaration:exit": i,
                                "FunctionExpression:exit": i,
                                "ArrowFunctionExpression:exit": i
                            };
                        }
                    }, cc;
                })(),
            "consistent-this": ()=>ad(),
            "constructor-super": ()=>(function() {
                    if (mc) return hc;
                    function e1(t) {
                        if (!t) return !1;
                        switch(t.type){
                            case "ClassExpression":
                            case "FunctionExpression":
                            case "ThisExpression":
                            case "MemberExpression":
                            case "CallExpression":
                            case "NewExpression":
                            case "ChainExpression":
                            case "YieldExpression":
                            case "TaggedTemplateExpression":
                            case "MetaProperty":
                                return !0;
                            case "Identifier":
                                return "undefined" !== t.name;
                            case "AssignmentExpression":
                                return [
                                    "=",
                                    "&&="
                                ].includes(t.operator) ? e1(t.right) : !![
                                    "||=",
                                    "??="
                                ].includes(t.operator) && (e1(t.left) || e1(t.right));
                            case "LogicalExpression":
                                return "&&" === t.operator ? e1(t.right) : e1(t.left) || e1(t.right);
                            case "ConditionalExpression":
                                return e1(t.alternate) || e1(t.consequent);
                            case "SequenceExpression":
                                return e1(t.expressions[t.expressions.length - 1]);
                            default:
                                return !1;
                        }
                    }
                    return mc = 1, hc = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Require `super()` calls in constructors",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/constructor-super"
                            },
                            schema: [],
                            messages: {
                                missingSome: "Lacked a call of 'super()' in some code paths.",
                                missingAll: "Expected to call 'super()'.",
                                duplicate: "Unexpected duplicate 'super()'.",
                                badSuper: "Unexpected 'super()' because 'super' is not a constructor.",
                                unexpected: "Unexpected 'super()'."
                            }
                        },
                        create (t) {
                            let r = null, n = Object.create(null);
                            function s(e1) {
                                return e1.reachable && n[e1.id].calledInSomePaths;
                            }
                            function i(e1) {
                                return !(1 !== e1.nextSegments.length || !e1.nextSegments[0].isLoopedPrevSegment(e1)) || e1.reachable && n[e1.id].calledInEveryPaths;
                            }
                            return {
                                onCodePathStart (t, n) {
                                    if (function(e1) {
                                        return "FunctionExpression" === e1.type && "MethodDefinition" === e1.parent.type && "constructor" === e1.parent.kind;
                                    }(n)) {
                                        const s = n.parent.parent.parent.superClass;
                                        r = {
                                            upper: r,
                                            isConstructor: !0,
                                            hasExtends: Boolean(s),
                                            superIsConstructor: e1(s),
                                            codePath: t,
                                            currentSegments: new Set
                                        };
                                    } else r = {
                                        upper: r,
                                        isConstructor: !1,
                                        hasExtends: !1,
                                        superIsConstructor: !1,
                                        codePath: t,
                                        currentSegments: new Set
                                    };
                                },
                                onCodePathEnd (e1, n) {
                                    const o = r.hasExtends;
                                    if (r = r.upper, !o) return;
                                    const a = e1.returnedSegments, u = a.every(i), l = a.some(s);
                                    u || t.report({
                                        messageId: l ? "missingSome" : "missingAll",
                                        node: n.parent
                                    });
                                },
                                onCodePathSegmentStart (e1) {
                                    if (r.currentSegments.add(e1), !(r && r.isConstructor && r.hasExtends)) return;
                                    const t = n[e1.id] = {
                                        calledInSomePaths: !1,
                                        calledInEveryPaths: !1,
                                        validNodes: []
                                    }, o = e1.prevSegments;
                                    o.length > 0 && (t.calledInSomePaths = o.some(s), t.calledInEveryPaths = o.every(i));
                                },
                                onUnreachableCodePathSegmentStart (e1) {
                                    r.currentSegments.add(e1);
                                },
                                onUnreachableCodePathSegmentEnd (e1) {
                                    r.currentSegments.delete(e1);
                                },
                                onCodePathSegmentEnd (e1) {
                                    r.currentSegments.delete(e1);
                                },
                                onCodePathSegmentLoop (e1, o) {
                                    if (!(r && r.isConstructor && r.hasExtends)) return;
                                    const a = o.prevSegments.length >= 2;
                                    r.codePath.traverseSegments({
                                        first: o,
                                        last: e1
                                    }, (e1)=>{
                                        const r = n[e1.id], o = e1.prevSegments;
                                        if (r.calledInSomePaths = o.some(s), r.calledInEveryPaths = o.every(i), r.calledInSomePaths || a) {
                                            const e1 = r.validNodes;
                                            r.validNodes = [];
                                            for(let r = 0; r < e1.length; ++r){
                                                const n = e1[r];
                                                t.report({
                                                    messageId: "duplicate",
                                                    node: n
                                                });
                                            }
                                        }
                                    });
                                },
                                "CallExpression:exit" (e1) {
                                    if (r && r.isConstructor && "Super" === e1.callee.type) {
                                        if (r.hasExtends) {
                                            const s = r.currentSegments;
                                            let i = !1, o = null;
                                            for (const e1 of s)e1.reachable && (o = n[e1.id], i = i || o.calledInSomePaths, o.calledInSomePaths = o.calledInEveryPaths = !0);
                                            o && (i ? t.report({
                                                messageId: "duplicate",
                                                node: e1
                                            }) : r.superIsConstructor ? o.validNodes.push(e1) : t.report({
                                                messageId: "badSuper",
                                                node: e1
                                            }));
                                        } else (function(e1) {
                                            for (const t of e1)if (t.reachable) return !0;
                                            return !1;
                                        })(r.currentSegments) && t.report({
                                            messageId: "unexpected",
                                            node: e1
                                        });
                                    }
                                },
                                ReturnStatement (e1) {
                                    if (!(r && r.isConstructor && r.hasExtends)) return;
                                    if (!e1.argument) return;
                                    const t = r.currentSegments;
                                    for (const e1 of t)if (e1.reachable) {
                                        const t = n[e1.id];
                                        t.calledInSomePaths = t.calledInEveryPaths = !0;
                                    }
                                },
                                "Program:exit" () {
                                    n = Object.create(null);
                                }
                            };
                        }
                    }, hc;
                })(),
            curly: ()=>ud(),
            "default-case": ()=>(function() {
                    if (xc) return Ec;
                    xc = 1;
                    const e1 = /^no default$/iu;
                    return Ec = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Require `default` cases in `switch` statements",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/default-case"
                            },
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        commentPattern: {
                                            type: "string"
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                missingDefaultCase: "Expected a default case."
                            }
                        },
                        create (t) {
                            const r = t.options[0] || {}, n = r.commentPattern ? new RegExp(r.commentPattern, "u") : e1, s = t.sourceCode;
                            function i(e1) {
                                return e1[e1.length - 1];
                            }
                            return {
                                SwitchStatement (e1) {
                                    if (!e1.cases.length) return;
                                    const r = e1.cases.some((e1)=>null === e1.test);
                                    if (!r) {
                                        let r;
                                        const o = i(e1.cases), a = s.getCommentsAfter(o);
                                        a.length && (r = i(a)), r && n.test(r.value.trim()) || t.report({
                                            node: e1,
                                            messageId: "missingDefaultCase"
                                        });
                                    }
                                }
                            };
                        }
                    }, Ec;
                })(),
            "default-case-last": ()=>(Sc || (Sc = 1, Cc = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Enforce default clauses in switch statements to be last",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/default-case-last"
                        },
                        schema: [],
                        messages: {
                            notLast: "Default clause should be the last clause."
                        }
                    },
                    create: (e1)=>({
                            SwitchStatement (t) {
                                const r = t.cases, n = r.findIndex((e1)=>null === e1.test);
                                if (-1 !== n && n !== r.length - 1) {
                                    const t = r[n];
                                    e1.report({
                                        node: t,
                                        messageId: "notLast"
                                    });
                                }
                            }
                        })
                }), Cc),
            "default-param-last": ()=>(vc || (vc = 1, bc = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Enforce default parameters to be last",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/default-param-last"
                        },
                        schema: [],
                        messages: {
                            shouldBeLast: "Default parameters should be last."
                        }
                    },
                    create (e1) {
                        function t(t) {
                            let r = !1;
                            for(let n = t.params.length - 1; n >= 0; n -= 1){
                                const s = t.params[n];
                                "AssignmentPattern" === s.type || "RestElement" === s.type ? r && "AssignmentPattern" === s.type && e1.report({
                                    node: s,
                                    messageId: "shouldBeLast"
                                }) : r = !0;
                            }
                        }
                        return {
                            FunctionDeclaration: t,
                            FunctionExpression: t,
                            ArrowFunctionExpression: t
                        };
                    }
                }), bc),
            "dot-location": ()=>ld(),
            "dot-notation": ()=>(function() {
                    if (_c) return wc;
                    _c = 1;
                    const e1 = Ll(), t = cd(), r = /^[a-zA-Z_$][a-zA-Z0-9_$]*$/u, n = new Set([
                        "string",
                        "boolean"
                    ]);
                    return wc = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Enforce dot notation whenever possible",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/dot-notation"
                            },
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        allowKeywords: {
                                            type: "boolean",
                                            default: !0
                                        },
                                        allowPattern: {
                                            type: "string",
                                            default: ""
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            fixable: "code",
                            messages: {
                                useDot: "[{{key}}] is better written in dot notation.",
                                useBrackets: ".{{key}} is a syntax error."
                            }
                        },
                        create (s) {
                            const i = s.options[0] || {}, o = void 0 === i.allowKeywords || i.allowKeywords, a = s.sourceCode;
                            let u;
                            function l(n, i) {
                                if (r.test(i) && (o || !t.includes(String(i))) && (!u || !u.test(i))) {
                                    const t = "Literal" === n.property.type ? JSON.stringify(i) : `\`${i}\``;
                                    s.report({
                                        node: n.property,
                                        messageId: "useDot",
                                        data: {
                                            key: t
                                        },
                                        *fix (t) {
                                            const r = a.getTokenAfter(n.object, e1.isOpeningBracketToken), s = a.getLastToken(n), o = a.getTokenAfter(n);
                                            a.commentsExistBetween(r, s) || (n.optional || (yield t.insertTextBefore(r, e1.isDecimalInteger(n.object) ? " ." : ".")), yield t.replaceTextRange([
                                                r.range[0],
                                                s.range[1]
                                            ], i), o && s.range[1] === o.range[0] && !e1.canTokensBeAdjacent(String(i), o) && (yield t.insertTextAfter(n, " ")));
                                        }
                                    });
                                }
                            }
                            return i.allowPattern && (u = new RegExp(i.allowPattern, "u")), {
                                MemberExpression (r) {
                                    r.computed && "Literal" === r.property.type && (n.has(typeof r.property.value) || e1.isNullLiteral(r.property)) && l(r, r.property.value), r.computed && e1.isStaticTemplateLiteral(r.property) && l(r, r.property.quasis[0].value.cooked), o || r.computed || "Identifier" !== r.property.type || !t.includes(String(r.property.name)) || s.report({
                                        node: r.property,
                                        messageId: "useBrackets",
                                        data: {
                                            key: r.property.name
                                        },
                                        *fix (e1) {
                                            const t = a.getTokenBefore(r.property);
                                            ("Identifier" !== r.object.type || "let" !== r.object.name || r.optional) && (a.commentsExistBetween(t, r.property) || (r.optional || (yield e1.remove(t)), yield e1.replaceText(r.property, `["${r.property.name}"]`)));
                                        }
                                    });
                                }
                            };
                        }
                    }, wc;
                })(),
            "eol-last": ()=>(Bc || (Bc = 1, kc = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "layout",
                        docs: {
                            description: "Require or disallow newline at the end of files",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/eol-last"
                        },
                        fixable: "whitespace",
                        schema: [
                            {
                                enum: [
                                    "always",
                                    "never",
                                    "unix",
                                    "windows"
                                ]
                            }
                        ],
                        messages: {
                            missing: "Newline required at end of file but not found.",
                            unexpected: "Newline not allowed at end of file."
                        }
                    },
                    create: (e1)=>({
                            Program: function(t) {
                                const r = e1.sourceCode, n = r.getText(), s = {
                                    column: r.lines[r.lines.length - 1].length,
                                    line: r.lines.length
                                }, i = n.endsWith("\n");
                                if (!n.length) return;
                                let o = e1.options[0] || "always", a = !1;
                                if ("unix" === o && (o = "always"), "windows" === o && (o = "always", a = !0), "always" !== o || i) {
                                    if ("never" === o && i) {
                                        const n = r.lines[r.lines.length - 2];
                                        e1.report({
                                            node: t,
                                            loc: {
                                                start: {
                                                    line: r.lines.length - 1,
                                                    column: n.length
                                                },
                                                end: {
                                                    line: r.lines.length,
                                                    column: 0
                                                }
                                            },
                                            messageId: "unexpected",
                                            fix (e1) {
                                                const t = /(?:\r?\n)+$/u.exec(r.text).index, n = r.text.length;
                                                return e1.replaceTextRange([
                                                    t,
                                                    n
                                                ], "");
                                            }
                                        });
                                    }
                                } else e1.report({
                                    node: t,
                                    loc: s,
                                    messageId: "missing",
                                    fix: (e1)=>e1.insertTextAfterRange([
                                            0,
                                            n.length
                                        ], a ? "\r\n" : "\n")
                                });
                            }
                        })
                }), kc),
            eqeqeq: ()=>pd(),
            "for-direction": ()=>(function() {
                    if (Fc) return Ic;
                    Fc = 1;
                    const { getStaticValue: e1 } = Hi();
                    return Ic = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: 'Enforce "for" loop update clause moving the counter in the right direction',
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/for-direction"
                            },
                            fixable: null,
                            schema: [],
                            messages: {
                                incorrectDirection: "The update clause in this loop moves the variable in the wrong direction."
                            }
                        },
                        create (t) {
                            const { sourceCode: r } = t;
                            function n(e1) {
                                t.report({
                                    node: e1,
                                    messageId: "incorrectDirection"
                                });
                            }
                            function s(t, n) {
                                const s = e1(t.right, r.getScope(t));
                                return s && [
                                    "bigint",
                                    "boolean",
                                    "number"
                                ].includes(typeof s.value) ? n * (Math.sign(Number(s.value)) || 0) : 0;
                            }
                            function i(e1, t) {
                                if ("Identifier" === e1.argument.type && e1.argument.name === t) {
                                    if ("++" === e1.operator) return 1;
                                    if ("--" === e1.operator) return -1;
                                }
                                return 0;
                            }
                            function o(e1, t) {
                                if (e1.left.name === t) {
                                    if ("+=" === e1.operator) return s(e1, 1);
                                    if ("-=" === e1.operator) return s(e1, -1);
                                }
                                return 0;
                            }
                            return {
                                ForStatement (e1) {
                                    if (e1.test && "BinaryExpression" === e1.test.type && e1.update) for (const t of [
                                        "left",
                                        "right"
                                    ]){
                                        if ("Identifier" !== e1.test[t].type) continue;
                                        const r = e1.test[t].name, s = e1.test.operator, a = e1.update;
                                        let u;
                                        if ("<" === s || "<=" === s) u = "left" === t ? -1 : 1;
                                        else {
                                            if (">" !== s && ">=" !== s) return;
                                            u = "left" === t ? 1 : -1;
                                        }
                                        "UpdateExpression" === a.type ? i(a, r) === u && n(e1) : "AssignmentExpression" === a.type && o(a, r) === u && n(e1);
                                    }
                                }
                            };
                        }
                    }, Ic;
                })(),
            "func-call-spacing": ()=>(function() {
                    if (Oc) return Nc;
                    Oc = 1;
                    const e1 = Ll();
                    return Nc = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "layout",
                            docs: {
                                description: "Require or disallow spacing between function identifiers and their invocations",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/func-call-spacing"
                            },
                            fixable: "whitespace",
                            schema: {
                                anyOf: [
                                    {
                                        type: "array",
                                        items: [
                                            {
                                                enum: [
                                                    "never"
                                                ]
                                            }
                                        ],
                                        minItems: 0,
                                        maxItems: 1
                                    },
                                    {
                                        type: "array",
                                        items: [
                                            {
                                                enum: [
                                                    "always"
                                                ]
                                            },
                                            {
                                                type: "object",
                                                properties: {
                                                    allowNewlines: {
                                                        type: "boolean"
                                                    }
                                                },
                                                additionalProperties: !1
                                            }
                                        ],
                                        minItems: 0,
                                        maxItems: 2
                                    }
                                ]
                            },
                            messages: {
                                unexpectedWhitespace: "Unexpected whitespace between function name and paren.",
                                unexpectedNewline: "Unexpected newline between function name and paren.",
                                missing: "Missing space between function name and paren."
                            }
                        },
                        create (t) {
                            const r = "always" !== t.options[0], n = !r && t.options[1] && t.options[1].allowNewlines, s = t.sourceCode, i = s.getText();
                            function o(o, a, u) {
                                const l = i.slice(a.range[1], u.range[0]).replace(/\/\*.*?\*\//gu, ""), c = /\s/u.test(l), p = c && e1.LINEBREAK_MATCHER.test(l);
                                r && c ? t.report({
                                    node: o,
                                    loc: {
                                        start: a.loc.end,
                                        end: {
                                            line: u.loc.start.line,
                                            column: u.loc.start.column - 1
                                        }
                                    },
                                    messageId: "unexpectedWhitespace",
                                    fix: (e1)=>s.commentsExistBetween(a, u) ? null : o.optional ? e1.replaceTextRange([
                                            a.range[1],
                                            u.range[0]
                                        ], "?.") : p ? null : e1.removeRange([
                                            a.range[1],
                                            u.range[0]
                                        ])
                                }) : r || c ? r || n || !p || t.report({
                                    node: o,
                                    loc: {
                                        start: a.loc.end,
                                        end: u.loc.start
                                    },
                                    messageId: "unexpectedNewline",
                                    fix (e1) {
                                        if (!o.optional) return null;
                                        if (s.commentsExistBetween(a, u)) return null;
                                        const t = [
                                            a.range[1],
                                            u.range[0]
                                        ], r = s.getTokenAfter(a);
                                        return r.range[0] === a.range[1] ? e1.replaceTextRange(t, "?. ") : r.range[1] === u.range[0] ? e1.replaceTextRange(t, " ?.") : e1.replaceTextRange(t, " ?. ");
                                    }
                                }) : t.report({
                                    node: o,
                                    loc: {
                                        start: {
                                            line: a.loc.end.line,
                                            column: a.loc.end.column - 1
                                        },
                                        end: u.loc.start
                                    },
                                    messageId: "missing",
                                    fix: (e1)=>o.optional ? null : e1.insertTextBefore(u, " ")
                                });
                            }
                            return {
                                "CallExpression, NewExpression" (t) {
                                    const r = s.getLastToken(t), n = s.getLastToken(t.callee), i = s.getFirstTokenBetween(n, r, e1.isOpeningParenToken), a = i && s.getTokenBefore(i, e1.isNotQuestionDotToken);
                                    i && i.range[1] < t.range[1] && o(t, a, i);
                                },
                                ImportExpression (e1) {
                                    const t = s.getFirstToken(e1);
                                    o(e1, t, s.getTokenAfter(t));
                                }
                            };
                        }
                    }, Nc;
                })(),
            "func-name-matching": ()=>(function() {
                    if (jc) return Uc;
                    jc = 1;
                    const e1 = Ll(), t = Bl();
                    function r(e1, r) {
                        return r >= 2015 ? t.keyword.isIdentifierES6(e1) : t.keyword.isIdentifierES5(e1);
                    }
                    const n = {
                        type: "object",
                        properties: {
                            considerPropertyDescriptor: {
                                type: "boolean"
                            },
                            includeCommonJSModuleExports: {
                                type: "boolean"
                            }
                        },
                        additionalProperties: !1
                    };
                    return Uc = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Require function names to match the name of the variable or property to which they are assigned",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/func-name-matching"
                            },
                            schema: {
                                anyOf: [
                                    {
                                        type: "array",
                                        additionalItems: !1,
                                        items: [
                                            {
                                                enum: [
                                                    "always",
                                                    "never"
                                                ]
                                            },
                                            n
                                        ]
                                    },
                                    {
                                        type: "array",
                                        additionalItems: !1,
                                        items: [
                                            n
                                        ]
                                    }
                                ]
                            },
                            messages: {
                                matchProperty: "Function name `{{funcName}}` should match property name `{{name}}`.",
                                matchVariable: "Function name `{{funcName}}` should match variable name `{{name}}`.",
                                notMatchProperty: "Function name `{{funcName}}` should not match property name `{{name}}`.",
                                notMatchVariable: "Function name `{{funcName}}` should not match variable name `{{name}}`."
                            }
                        },
                        create (t) {
                            const n = ("object" == typeof t.options[0] ? t.options[0] : t.options[1]) || {}, s = "string" == typeof t.options[0] ? t.options[0] : "always", i = n.considerPropertyDescriptor, o = n.includeCommonJSModuleExports, a = t.languageOptions.ecmaVersion;
                            function u(t, r, n) {
                                return !!n && "CallExpression" === n.type && e1.isSpecificMemberAccess(n.callee, t, r);
                            }
                            function l(e1, t) {
                                return "always" === s && e1 !== t || "never" === s && e1 === t;
                            }
                            function c(e1, r, n, i) {
                                let o;
                                o = "always" === s && i ? "matchProperty" : "always" === s ? "matchVariable" : i ? "notMatchProperty" : "notMatchVariable", t.report({
                                    node: e1,
                                    messageId: o,
                                    data: {
                                        name: r,
                                        funcName: n
                                    }
                                });
                            }
                            function p(e1) {
                                return "Literal" === e1.type && "string" == typeof e1.value;
                            }
                            return {
                                VariableDeclarator (e1) {
                                    e1.init && "FunctionExpression" === e1.init.type && "Identifier" === e1.id.type && e1.init.id && l(e1.id.name, e1.init.id.name) && c(e1, e1.id.name, e1.init.id.name, !1);
                                },
                                AssignmentExpression (t) {
                                    if ("FunctionExpression" !== t.right.type || t.left.computed && "Literal" !== t.left.property.type || !o && function(e1) {
                                        if ("MemberExpression" === e1.type && "Identifier" === e1.object.type && "module" === e1.object.name) {
                                            if ("Identifier" === e1.property.type && "exports" === e1.property.name) return !0;
                                            if ("Literal" === e1.property.type && "exports" === e1.property.value) return !0;
                                        }
                                        return !1;
                                    }(t.left) || "Identifier" !== t.left.type && "MemberExpression" !== t.left.type) return;
                                    const n = "MemberExpression" === t.left.type, s = n ? e1.getStaticPropertyName(t.left) : t.left.name;
                                    t.right.id && s && r(s) && l(s, t.right.id.name) && c(t, s, t.right.id.name, n);
                                },
                                "Property, PropertyDefinition[value]" (e1) {
                                    if ("FunctionExpression" === e1.value.type && e1.value.id) {
                                        if ("Identifier" !== e1.key.type || e1.computed) p(e1.key) && r(e1.key.value, a) && l(e1.key.value, e1.value.id.name) && c(e1, e1.key.value, e1.value.id.name, !0);
                                        else {
                                            const t = e1.value.id.name;
                                            let r = e1.key.name;
                                            if (i && "value" === r && "ObjectExpression" === e1.parent.type) {
                                                if (u("Object", "defineProperty", e1.parent.parent) || u("Reflect", "defineProperty", e1.parent.parent)) {
                                                    const r = e1.parent.parent.arguments[1];
                                                    p(r) && l(r.value, t) && c(e1, r.value, t, !0);
                                                } else u("Object", "defineProperties", e1.parent.parent.parent.parent) || u("Object", "create", e1.parent.parent.parent.parent) ? (r = e1.parent.parent.key.name, !e1.parent.parent.computed && l(r, t) && c(e1, r, t, !0)) : l(r, t) && c(e1, r, t, !0);
                                            } else l(r, t) && c(e1, r, t, !0);
                                        }
                                    }
                                }
                            };
                        }
                    }, Uc;
                })(),
            "func-names": ()=>fd(),
            "func-style": ()=>($c || ($c = 1, Mc = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Enforce the consistent use of either `function` declarations or expressions",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/func-style"
                        },
                        schema: [
                            {
                                enum: [
                                    "declaration",
                                    "expression"
                                ]
                            },
                            {
                                type: "object",
                                properties: {
                                    allowArrowFunctions: {
                                        type: "boolean",
                                        default: !1
                                    }
                                },
                                additionalProperties: !1
                            }
                        ],
                        messages: {
                            expression: "Expected a function expression.",
                            declaration: "Expected a function declaration."
                        }
                    },
                    create (e1) {
                        const t = e1.options[0], r = e1.options[1] && e1.options[1].allowArrowFunctions, n = "declaration" === t, s = [], i = {
                            FunctionDeclaration (t) {
                                s.push(!1), n || "ExportDefaultDeclaration" === t.parent.type || e1.report({
                                    node: t,
                                    messageId: "expression"
                                });
                            },
                            "FunctionDeclaration:exit" () {
                                s.pop();
                            },
                            FunctionExpression (t) {
                                s.push(!1), n && "VariableDeclarator" === t.parent.type && e1.report({
                                    node: t.parent,
                                    messageId: "declaration"
                                });
                            },
                            "FunctionExpression:exit" () {
                                s.pop();
                            },
                            ThisExpression () {
                                s.length > 0 && (s[s.length - 1] = !0);
                            }
                        };
                        return r || (i.ArrowFunctionExpression = function() {
                            s.push(!1);
                        }, i["ArrowFunctionExpression:exit"] = function(t) {
                            const r = s.pop();
                            n && !r && "VariableDeclarator" === t.parent.type && e1.report({
                                node: t.parent,
                                messageId: "declaration"
                            });
                        }), i;
                    }
                }), Mc),
            "function-call-argument-newline": ()=>(Gc || (Gc = 1, qc = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "layout",
                        docs: {
                            description: "Enforce line breaks between arguments of a function call",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/function-call-argument-newline"
                        },
                        fixable: "whitespace",
                        schema: [
                            {
                                enum: [
                                    "always",
                                    "never",
                                    "consistent"
                                ]
                            }
                        ],
                        messages: {
                            unexpectedLineBreak: "There should be no line break here.",
                            missingLineBreak: "There should be a line break after this argument."
                        }
                    },
                    create (e1) {
                        const t = e1.sourceCode, r = {
                            messageId: "unexpectedLineBreak",
                            check: (e1, t)=>e1.loc.end.line !== t.loc.start.line,
                            createFix: (e1, t)=>(r)=>r.replaceTextRange([
                                        t.range[1],
                                        e1.range[0]
                                    ], " ")
                        }, n = {
                            messageId: "missingLineBreak",
                            check: (e1, t)=>e1.loc.end.line === t.loc.start.line,
                            createFix: (e1, t)=>(r)=>r.replaceTextRange([
                                        t.range[1],
                                        e1.range[0]
                                    ], "\n")
                        };
                        function s(r, n) {
                            for(let s = 1; s < r.arguments.length; s++){
                                const i = t.getLastToken(r.arguments[s - 1]), o = t.getFirstToken(r.arguments[s]);
                                if (n.check(i, o)) {
                                    const s = t.getTokenBefore(o, {
                                        includeComments: !0
                                    }), i = "Line" === s.type;
                                    e1.report({
                                        node: r,
                                        loc: {
                                            start: s.loc.end,
                                            end: o.loc.start
                                        },
                                        messageId: n.messageId,
                                        fix: i ? null : n.createFix(o, s)
                                    });
                                }
                            }
                        }
                        function i(i) {
                            if (i.arguments.length < 2) return;
                            const o = e1.options[0] || "always";
                            if ("never" === o) s(i, r);
                            else if ("always" === o) s(i, n);
                            else if ("consistent" === o) {
                                const e1 = t.getLastToken(i.arguments[0]), o = t.getFirstToken(i.arguments[1]);
                                e1.loc.end.line === o.loc.start.line ? s(i, r) : s(i, n);
                            }
                        }
                        return {
                            CallExpression: i,
                            NewExpression: i
                        };
                    }
                }), qc),
            "function-paren-newline": ()=>dd(),
            "generator-star-spacing": ()=>hd(),
            "getter-return": ()=>(function() {
                    if (Qc) return Jc;
                    Qc = 1;
                    const e1 = Ll(), t = /^(?:Arrow)?FunctionExpression$/u;
                    return Jc = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Enforce `return` statements in getters",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/getter-return"
                            },
                            fixable: null,
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        allowImplicit: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                expected: "Expected to return a value in {{name}}.",
                                expectedAlways: "Expected {{name}} to always return a value."
                            }
                        },
                        create (r) {
                            const n = r.options[0] || {
                                allowImplicit: !1
                            }, s = r.sourceCode;
                            let i = {
                                upper: null,
                                codePath: null,
                                hasReturn: !1,
                                shouldCheck: !1,
                                node: null,
                                currentSegments: []
                            };
                            function o(t) {
                                i.shouldCheck && function(e1) {
                                    for (const t of e1)if (t.reachable) return !0;
                                    return !1;
                                }(i.currentSegments) && r.report({
                                    node: t,
                                    loc: e1.getFunctionHeadLoc(t, s),
                                    messageId: i.hasReturn ? "expectedAlways" : "expected",
                                    data: {
                                        name: e1.getFunctionNameWithKind(i.node)
                                    }
                                });
                            }
                            function a(r) {
                                const n = r.parent;
                                if (t.test(r.type) && "BlockStatement" === r.body.type) {
                                    if ("get" === n.kind) return !0;
                                    if ("Property" === n.type && "get" === e1.getStaticPropertyName(n) && "ObjectExpression" === n.parent.type) {
                                        if ("CallExpression" === n.parent.parent.type) {
                                            const t = n.parent.parent.callee;
                                            if (e1.isSpecificMemberAccess(t, "Object", "defineProperty") || e1.isSpecificMemberAccess(t, "Reflect", "defineProperty")) return !0;
                                        }
                                        if ("Property" === n.parent.parent.type && "ObjectExpression" === n.parent.parent.parent.type && "CallExpression" === n.parent.parent.parent.parent.type) {
                                            const t = n.parent.parent.parent.parent.callee;
                                            return e1.isSpecificMemberAccess(t, "Object", "defineProperties") || e1.isSpecificMemberAccess(t, "Object", "create");
                                        }
                                    }
                                }
                                return !1;
                            }
                            return {
                                onCodePathStart (e1, t) {
                                    i = {
                                        upper: i,
                                        codePath: e1,
                                        hasReturn: !1,
                                        shouldCheck: a(t),
                                        node: t,
                                        currentSegments: new Set
                                    };
                                },
                                onCodePathEnd () {
                                    i = i.upper;
                                },
                                onUnreachableCodePathSegmentStart (e1) {
                                    i.currentSegments.add(e1);
                                },
                                onUnreachableCodePathSegmentEnd (e1) {
                                    i.currentSegments.delete(e1);
                                },
                                onCodePathSegmentStart (e1) {
                                    i.currentSegments.add(e1);
                                },
                                onCodePathSegmentEnd (e1) {
                                    i.currentSegments.delete(e1);
                                },
                                ReturnStatement (t) {
                                    i.shouldCheck && (i.hasReturn = !0, n.allowImplicit || t.argument || r.report({
                                        node: t,
                                        messageId: "expected",
                                        data: {
                                            name: e1.getFunctionNameWithKind(i.node)
                                        }
                                    }));
                                },
                                "FunctionExpression:exit": o,
                                "ArrowFunctionExpression:exit": o
                            };
                        }
                    }, Jc;
                })(),
            "global-require": ()=>(function() {
                    if (Zc) return Yc;
                    Zc = 1;
                    const e1 = new Set([
                        "AssignmentExpression",
                        "VariableDeclarator",
                        "MemberExpression",
                        "ExpressionStatement",
                        "CallExpression",
                        "ConditionalExpression",
                        "Program",
                        "VariableDeclaration",
                        "ChainExpression"
                    ]);
                    return Yc = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "suggestion",
                            docs: {
                                description: "Require `require()` calls to be placed at top-level module scope",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/global-require"
                            },
                            schema: [],
                            messages: {
                                unexpected: "Unexpected require()."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode;
                            return {
                                CallExpression (n) {
                                    const s = r.getScope(n);
                                    "require" !== n.callee.name || function(e1, t) {
                                        const r = function(e1, t) {
                                            const r = e1.references.filter((e1)=>e1.identifier.range[0] === t.range[0] && e1.identifier.range[1] === t.range[1]);
                                            return 1 === r.length ? r[0] : null;
                                        }(e1, t);
                                        return r && r.resolved && r.resolved.defs.length > 0;
                                    }(s, n.callee) || r.getAncestors(n).every((t)=>e1.has(t.type)) || t.report({
                                        node: n,
                                        messageId: "unexpected"
                                    });
                                }
                            };
                        }
                    }, Yc;
                })(),
            "grouped-accessor-pairs": ()=>(function() {
                    if (tp) return ep;
                    tp = 1;
                    const e1 = Ll();
                    function t(e1) {
                        return "get" === e1.kind || "set" === e1.kind;
                    }
                    return ep = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Require grouped accessor pairs in object literals and classes",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/grouped-accessor-pairs"
                            },
                            schema: [
                                {
                                    enum: [
                                        "anyOrder",
                                        "getBeforeSet",
                                        "setBeforeGet"
                                    ]
                                }
                            ],
                            messages: {
                                notGrouped: "Accessor pair {{ formerName }} and {{ latterName }} should be grouped.",
                                invalidOrder: "Expected {{ latterName }} to be before {{ formerName }}."
                            }
                        },
                        create (r) {
                            const n = r.options[0] || "anyOrder", s = r.sourceCode;
                            function i(t, n, i) {
                                r.report({
                                    node: i,
                                    messageId: t,
                                    loc: e1.getFunctionHeadLoc(i.value, s),
                                    data: {
                                        formerName: e1.getFunctionNameWithKind(n.value),
                                        latterName: e1.getFunctionNameWithKind(i.value)
                                    }
                                });
                            }
                            function o(r, o) {
                                const a = [];
                                let u = !1;
                                for(let n = 0; n < r.length; n++){
                                    const i = r[n];
                                    if (o(i) && t(i)) {
                                        const t = e1.getStaticPropertyName(i), r = null !== t ? t : s.getTokens(i.key);
                                        for(let e1 = 0; e1 < a.length; e1++){
                                            const t = a[e1];
                                            if (c = r, "string" == typeof (l = t.key) && "string" == typeof c ? l === c : Array.isArray(l) && Array.isArray(c) && function(e1, t) {
                                                if (e1.length !== t.length) return !1;
                                                for(let r = 0; r < e1.length; r++){
                                                    const n = e1[r], s = t[r];
                                                    if (n.type !== s.type || n.value !== s.value) return !1;
                                                }
                                                return !0;
                                            }(l, c)) {
                                                t.getters.push(..."get" === i.kind ? [
                                                    i
                                                ] : []), t.setters.push(..."set" === i.kind ? [
                                                    i
                                                ] : []), u = !0;
                                                break;
                                            }
                                        }
                                        u || a.push({
                                            key: r,
                                            getters: "get" === i.kind ? [
                                                i
                                            ] : [],
                                            setters: "set" === i.kind ? [
                                                i
                                            ] : []
                                        }), u = !1;
                                    }
                                }
                                var l, c;
                                for (const { getters: e1, setters: t } of a)if (1 === e1.length && 1 === t.length) {
                                    const [s] = e1, [o] = t, a = r.indexOf(s), u = r.indexOf(o), l = a < u ? s : o, c = a < u ? o : s;
                                    Math.abs(a - u) > 1 ? i("notGrouped", l, c) : ("getBeforeSet" === n && a > u || "setBeforeGet" === n && a < u) && i("invalidOrder", l, c);
                                }
                            }
                            return {
                                ObjectExpression (e1) {
                                    o(e1.properties, (e1)=>"Property" === e1.type);
                                },
                                ClassBody (e1) {
                                    o(e1.body, (e1)=>"MethodDefinition" === e1.type && !e1.static), o(e1.body, (e1)=>"MethodDefinition" === e1.type && e1.static);
                                }
                            };
                        }
                    }, ep;
                })(),
            "guard-for-in": ()=>(np || (np = 1, rp = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Require `for-in` loops to include an `if` statement",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/guard-for-in"
                        },
                        schema: [],
                        messages: {
                            wrap: "The body of a for-in should be wrapped in an if statement to filter unwanted properties from the prototype."
                        }
                    },
                    create: (e1)=>({
                            ForInStatement (t) {
                                const r = t.body;
                                if ("EmptyStatement" !== r.type && "IfStatement" !== r.type && !("BlockStatement" === r.type && 0 === r.body.length || "BlockStatement" === r.type && 1 === r.body.length && "IfStatement" === r.body[0].type)) {
                                    if ("BlockStatement" === r.type && r.body.length >= 1 && "IfStatement" === r.body[0].type) {
                                        const e1 = r.body[0];
                                        if ("ContinueStatement" === e1.consequent.type) return;
                                        if ("BlockStatement" === e1.consequent.type && 1 === e1.consequent.body.length && "ContinueStatement" === e1.consequent.body[0].type) return;
                                    }
                                    e1.report({
                                        node: t,
                                        messageId: "wrap"
                                    });
                                }
                            }
                        })
                }), rp),
            "handle-callback-err": ()=>md(),
            "id-blacklist": ()=>gd(),
            "id-denylist": ()=>yd(),
            "id-length": ()=>Ed(),
            "id-match": ()=>xd(),
            "implicit-arrow-linebreak": ()=>Cd(),
            indent: ()=>Sd(),
            "indent-legacy": ()=>bd(),
            "init-declarations": ()=>(function() {
                    if (Sp) return Cp;
                    function e1(e1) {
                        return "ForInStatement" === e1.type || "ForOfStatement" === e1.type || "ForStatement" === e1.type;
                    }
                    function t(t) {
                        const r = t.parent, n = r.parent;
                        return e1(n) ? "ForStatement" === n.type ? n.init === r : n.left === r : Boolean(t.init);
                    }
                    return Sp = 1, Cp = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Require or disallow initialization in variable declarations",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/init-declarations"
                            },
                            schema: {
                                anyOf: [
                                    {
                                        type: "array",
                                        items: [
                                            {
                                                enum: [
                                                    "always"
                                                ]
                                            }
                                        ],
                                        minItems: 0,
                                        maxItems: 1
                                    },
                                    {
                                        type: "array",
                                        items: [
                                            {
                                                enum: [
                                                    "never"
                                                ]
                                            },
                                            {
                                                type: "object",
                                                properties: {
                                                    ignoreForLoopInit: {
                                                        type: "boolean"
                                                    }
                                                },
                                                additionalProperties: !1
                                            }
                                        ],
                                        minItems: 0,
                                        maxItems: 2
                                    }
                                ]
                            },
                            messages: {
                                initialized: "Variable '{{idName}}' should be initialized on declaration.",
                                notInitialized: "Variable '{{idName}}' should not be initialized on declaration."
                            }
                        },
                        create (r) {
                            const n = "always", s = r.options[0] || n, i = r.options[1] || {};
                            return {
                                "VariableDeclaration:exit" (o) {
                                    const a = o.kind, u = o.declarations;
                                    for(let l = 0; l < u.length; ++l){
                                        const c = u[l], p = c.id, f = t(c), d = i.ignoreForLoopInit && e1(o.parent);
                                        let h = "";
                                        s !== n || f ? "never" === s && "const" !== a && f && !d && (h = "notInitialized") : h = "initialized", "Identifier" === p.type && h && r.report({
                                            node: c,
                                            messageId: h,
                                            data: {
                                                idName: p.name
                                            }
                                        });
                                    }
                                }
                            };
                        }
                    }, Cp;
                })(),
            "jsx-quotes": ()=>vd(),
            "key-spacing": ()=>Ad(),
            "keyword-spacing": ()=>(function() {
                    if (Dp) return Rp;
                    Dp = 1;
                    const e1 = Ll(), t = cd(), r = /^[)\]}>]$/u, n = /^(?:[([{<~!]|\+\+?|--?)$/u, s = /^[)\]}>*]$/u, i = /^[{*]$/u, o = /\$\{$/u, a = /^\}/u, u = /^(?:JSXElement|RegularExpression|String|Template|PrivateIdentifier)$/u, l = t.concat([
                        "as",
                        "async",
                        "await",
                        "from",
                        "get",
                        "let",
                        "of",
                        "set",
                        "yield"
                    ]);
                    function c(e1) {
                        return "Template" === e1.type && o.test(e1.value);
                    }
                    function p(e1) {
                        return "Template" === e1.type && a.test(e1.value);
                    }
                    return function() {
                        l.sort();
                        for(let e1 = 1; e1 < l.length; ++e1)if (l[e1] === l[e1 - 1]) throw new Error(`Duplication was found in the keyword list: ${l[e1]}`);
                    }(), Rp = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "layout",
                            docs: {
                                description: "Enforce consistent spacing before and after keywords",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/keyword-spacing"
                            },
                            fixable: "whitespace",
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        before: {
                                            type: "boolean",
                                            default: !0
                                        },
                                        after: {
                                            type: "boolean",
                                            default: !0
                                        },
                                        overrides: {
                                            type: "object",
                                            properties: l.reduce((e1, t)=>(e1[t] = {
                                                    type: "object",
                                                    properties: {
                                                        before: {
                                                            type: "boolean"
                                                        },
                                                        after: {
                                                            type: "boolean"
                                                        }
                                                    },
                                                    additionalProperties: !1
                                                }, e1), {}),
                                            additionalProperties: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                expectedBefore: 'Expected space(s) before "{{value}}".',
                                expectedAfter: 'Expected space(s) after "{{value}}".',
                                unexpectedBefore: 'Unexpected space(s) before "{{value}}".',
                                unexpectedAfter: 'Unexpected space(s) after "{{value}}".'
                            }
                        },
                        create (t) {
                            const o = t.sourceCode, a = new WeakSet;
                            function f(r, n) {
                                const s = o.getTokenBefore(r);
                                !s || !u.test(s.type) && !n.test(s.value) || c(s) || a.has(s) || !e1.isTokenOnSameLine(s, r) || o.isSpaceBetweenTokens(s, r) || t.report({
                                    loc: r.loc,
                                    messageId: "expectedBefore",
                                    data: r,
                                    fix: (e1)=>e1.insertTextBefore(r, " ")
                                });
                            }
                            function d(r, n) {
                                const s = o.getTokenBefore(r);
                                s && (u.test(s.type) || n.test(s.value)) && !c(s) && !a.has(s) && e1.isTokenOnSameLine(s, r) && o.isSpaceBetweenTokens(s, r) && t.report({
                                    loc: {
                                        start: s.loc.end,
                                        end: r.loc.start
                                    },
                                    messageId: "unexpectedBefore",
                                    data: r,
                                    fix: (e1)=>e1.removeRange([
                                            s.range[1],
                                            r.range[0]
                                        ])
                                });
                            }
                            function h(r, n) {
                                const s = o.getTokenAfter(r);
                                !s || !u.test(s.type) && !n.test(s.value) || p(s) || a.has(s) || !e1.isTokenOnSameLine(r, s) || o.isSpaceBetweenTokens(r, s) || t.report({
                                    loc: r.loc,
                                    messageId: "expectedAfter",
                                    data: r,
                                    fix: (e1)=>e1.insertTextAfter(r, " ")
                                });
                            }
                            function m(r, n) {
                                const s = o.getTokenAfter(r);
                                s && (u.test(s.type) || n.test(s.value)) && !p(s) && !a.has(s) && e1.isTokenOnSameLine(r, s) && o.isSpaceBetweenTokens(r, s) && t.report({
                                    loc: {
                                        start: r.loc.end,
                                        end: s.loc.start
                                    },
                                    messageId: "unexpectedAfter",
                                    data: r,
                                    fix: (e1)=>e1.removeRange([
                                            r.range[1],
                                            s.range[0]
                                        ])
                                });
                            }
                            const g = function(e1 = {}) {
                                const t = !1 !== e1.before, r = !1 !== e1.after, n = {
                                    before: t ? f : d,
                                    after: r ? h : m
                                }, s = e1 && e1.overrides || {}, i = Object.create(null);
                                for(let e1 = 0; e1 < l.length; ++e1){
                                    const o = l[e1], a = s[o];
                                    if (a) {
                                        const e1 = "before" in a ? a.before : t, n = "after" in a ? a.after : r;
                                        i[o] = {
                                            before: e1 ? f : d,
                                            after: n ? h : m
                                        };
                                    } else i[o] = n;
                                }
                                return i;
                            }(t.options[0]);
                            function y(e1, t) {
                                g[e1.value].before(e1, t || r);
                            }
                            function E(e1, t) {
                                g[e1.value].after(e1, t || n);
                            }
                            function x(e1) {
                                y(e1), E(e1);
                            }
                            function C(e1) {
                                const t = e1 && o.getFirstToken(e1);
                                t && "Keyword" === t.type && x(t);
                            }
                            function S(e1) {
                                const t = e1 && o.getFirstToken(e1);
                                t && "Keyword" === t.type && y(t);
                            }
                            function b(t) {
                                t && x(o.getTokenBefore(t, e1.isKeywordToken));
                            }
                            function v(e1) {
                                const t = e1 && o.getFirstToken(e1);
                                t && ("Keyword" === t.type && "function" === t.value || "async" === t.value) && y(t);
                            }
                            function A(e1) {
                                C(e1), b(e1.superClass);
                            }
                            function T(e1) {
                                const t = o.getFirstToken(e1);
                                if (y(t, s), E(t, i), "ExportDefaultDeclaration" === e1.type && x(o.getTokenAfter(t)), "ExportAllDeclaration" === e1.type && e1.exported) {
                                    const t = o.getTokenBefore(e1.exported);
                                    y(t, s), E(t, i);
                                }
                                if (e1.source) {
                                    const t = o.getTokenBefore(e1.source);
                                    y(t, s), E(t, i);
                                }
                            }
                            function R(e1) {
                                if (e1.static && C(e1), "get" === e1.kind || "set" === e1.kind || (e1.method || "MethodDefinition" === e1.type) && e1.value.async) {
                                    const t = o.getTokenBefore(e1.key, (e1)=>{
                                        switch(e1.value){
                                            case "get":
                                            case "set":
                                            case "async":
                                                return !0;
                                            default:
                                                return !1;
                                        }
                                    });
                                    if (!t) throw new Error("Failed to find token get, set, or async beside method name");
                                    x(t);
                                }
                            }
                            return {
                                DebuggerStatement: C,
                                WithStatement: C,
                                BreakStatement: C,
                                ContinueStatement: C,
                                ReturnStatement: C,
                                ThrowStatement: C,
                                TryStatement: function(e1) {
                                    C(e1), C(e1.handler), b(e1.finalizer);
                                },
                                IfStatement: function(e1) {
                                    C(e1), b(e1.alternate);
                                },
                                SwitchStatement: C,
                                SwitchCase: C,
                                DoWhileStatement: function(e1) {
                                    C(e1), b(e1.test);
                                },
                                ForInStatement: function(t) {
                                    C(t);
                                    const r = o.getTokenBefore(t.right, e1.isNotOpeningParenToken);
                                    "PrivateIdentifier" !== o.getTokenBefore(r).type && y(r), E(r);
                                },
                                ForOfStatement: function(t) {
                                    t.await ? (y(o.getFirstToken(t, 0)), E(o.getFirstToken(t, 1))) : C(t);
                                    const r = o.getTokenBefore(t.right, e1.isNotOpeningParenToken);
                                    "PrivateIdentifier" !== o.getTokenBefore(r).type && y(r), E(r);
                                },
                                ForStatement: C,
                                WhileStatement: C,
                                ClassDeclaration: A,
                                ExportNamedDeclaration: T,
                                ExportDefaultDeclaration: T,
                                ExportAllDeclaration: T,
                                FunctionDeclaration: v,
                                ImportDeclaration: T,
                                VariableDeclaration: C,
                                ArrowFunctionExpression: v,
                                AwaitExpression: function(e1) {
                                    y(o.getFirstToken(e1));
                                },
                                ClassExpression: A,
                                FunctionExpression: v,
                                NewExpression: S,
                                Super: S,
                                ThisExpression: S,
                                UnaryExpression: S,
                                YieldExpression: S,
                                ImportSpecifier: function(e1) {
                                    e1.imported.range[0] !== e1.local.range[0] && y(o.getTokenBefore(e1.local), s);
                                },
                                ExportSpecifier: function(e1) {
                                    if (e1.local.range[0] !== e1.exported.range[0]) {
                                        const t = o.getTokenBefore(e1.exported);
                                        y(t, s), E(t, i);
                                    }
                                },
                                ImportNamespaceSpecifier: function(e1) {
                                    y(o.getFirstToken(e1, 1), s);
                                },
                                MethodDefinition: R,
                                PropertyDefinition: R,
                                StaticBlock: C,
                                Property: R,
                                "BinaryExpression[operator='>']" (t) {
                                    const r = o.getTokenBefore(t.right, e1.isNotOpeningParenToken);
                                    a.add(r);
                                }
                            };
                        }
                    }, Rp;
                })(),
            "line-comment-position": ()=>(function() {
                    if (_p) return wp;
                    _p = 1;
                    const e1 = Ll();
                    return wp = {
                        meta: {
                            type: "layout",
                            docs: {
                                description: "Enforce position of line comments",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/line-comment-position"
                            },
                            schema: [
                                {
                                    oneOf: [
                                        {
                                            enum: [
                                                "above",
                                                "beside"
                                            ]
                                        },
                                        {
                                            type: "object",
                                            properties: {
                                                position: {
                                                    enum: [
                                                        "above",
                                                        "beside"
                                                    ]
                                                },
                                                ignorePattern: {
                                                    type: "string"
                                                },
                                                applyDefaultPatterns: {
                                                    type: "boolean"
                                                },
                                                applyDefaultIgnorePatterns: {
                                                    type: "boolean"
                                                }
                                            },
                                            additionalProperties: !1
                                        }
                                    ]
                                }
                            ],
                            messages: {
                                above: "Expected comment to be above code.",
                                beside: "Expected comment to be beside code."
                            }
                        },
                        create (t) {
                            const r = t.options[0];
                            let n, s, i = !0;
                            r && "string" != typeof r ? (n = !r.position || "above" === r.position, s = r.ignorePattern, i = Object.prototype.hasOwnProperty.call(r, "applyDefaultIgnorePatterns") ? r.applyDefaultIgnorePatterns : !1 !== r.applyDefaultPatterns) : n = !r || "above" === r;
                            const o = e1.COMMENTS_IGNORE_PATTERN, a = /^\s*falls?\s?through/u, u = new RegExp(s, "u"), l = t.sourceCode;
                            return {
                                Program () {
                                    l.getAllComments().filter((e1)=>"Line" === e1.type).forEach((e1)=>{
                                        if (i && (o.test(e1.value) || a.test(e1.value))) return;
                                        if (s && u.test(e1.value)) return;
                                        const r = l.getTokenBefore(e1, {
                                            includeComments: !0
                                        }), c = r && r.loc.end.line === e1.loc.start.line;
                                        n ? c && t.report({
                                            node: e1,
                                            messageId: "above"
                                        }) : c || t.report({
                                            node: e1,
                                            messageId: "beside"
                                        });
                                    });
                                }
                            };
                        }
                    }, wp;
                })(),
            "linebreak-style": ()=>(function() {
                    if (Bp) return kp;
                    Bp = 1;
                    const e1 = Ll();
                    return kp = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "layout",
                            docs: {
                                description: "Enforce consistent linebreak style",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/linebreak-style"
                            },
                            fixable: "whitespace",
                            schema: [
                                {
                                    enum: [
                                        "unix",
                                        "windows"
                                    ]
                                }
                            ],
                            messages: {
                                expectedLF: "Expected linebreaks to be 'LF' but found 'CRLF'.",
                                expectedCRLF: "Expected linebreaks to be 'CRLF' but found 'LF'."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode;
                            function n(e1, t) {
                                return function(r) {
                                    return r.replaceTextRange(e1, t);
                                };
                            }
                            return {
                                Program: function(s) {
                                    const i = "unix" === (t.options[0] || "unix"), o = i ? "\n" : "\r\n", a = r.getText(), u = e1.createGlobalLinebreakMatcher();
                                    let l, c = 0;
                                    for(; null !== (l = u.exec(a));){
                                        if (c++, l[0] === o) continue;
                                        const e1 = l.index, a = [
                                            e1,
                                            e1 + l[0].length
                                        ];
                                        t.report({
                                            node: s,
                                            loc: {
                                                start: {
                                                    line: c,
                                                    column: r.lines[c - 1].length
                                                },
                                                end: {
                                                    line: c + 1,
                                                    column: 0
                                                }
                                            },
                                            messageId: i ? "expectedLF" : "expectedCRLF",
                                            fix: n(a, o)
                                        });
                                    }
                                }
                            };
                        }
                    }, kp;
                })(),
            "lines-around-comment": ()=>Td(),
            "lines-around-directive": ()=>(function() {
                    if (Fp) return Ip;
                    Fp = 1;
                    const e1 = Ll();
                    return Ip = {
                        meta: {
                            type: "layout",
                            docs: {
                                description: "Require or disallow newlines around directives",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/lines-around-directive"
                            },
                            schema: [
                                {
                                    oneOf: [
                                        {
                                            enum: [
                                                "always",
                                                "never"
                                            ]
                                        },
                                        {
                                            type: "object",
                                            properties: {
                                                before: {
                                                    enum: [
                                                        "always",
                                                        "never"
                                                    ]
                                                },
                                                after: {
                                                    enum: [
                                                        "always",
                                                        "never"
                                                    ]
                                                }
                                            },
                                            additionalProperties: !1,
                                            minProperties: 2
                                        }
                                    ]
                                }
                            ],
                            fixable: "whitespace",
                            messages: {
                                expected: 'Expected newline {{location}} "{{value}}" directive.',
                                unexpected: 'Unexpected newline {{location}} "{{value}}" directive.'
                            },
                            deprecated: !0,
                            replacedBy: [
                                "padding-line-between-statements"
                            ]
                        },
                        create (t) {
                            const r = t.sourceCode, n = t.options[0] || "always", s = "string" == typeof n ? n : n.before, i = "string" == typeof n ? n : n.after;
                            function o(e1) {
                                const t = r.getTokenBefore(e1, {
                                    includeComments: !0
                                }), n = t ? t.loc.end.line : 0;
                                return e1.loc.start.line - n >= 2;
                            }
                            function a(t) {
                                const n = r.getLastToken(t), s = r.getTokenBefore(n);
                                return e1.isSemicolonToken(n) && n.loc.start.line > s.loc.end.line ? s : n;
                            }
                            function u(e1) {
                                const t = a(e1);
                                return r.getTokenAfter(t, {
                                    includeComments: !0
                                }).loc.start.line - t.loc.end.line >= 2;
                            }
                            function l(e1, r, n) {
                                t.report({
                                    node: e1,
                                    messageId: n ? "expected" : "unexpected",
                                    data: {
                                        value: e1.expression.value,
                                        location: r
                                    },
                                    fix (t) {
                                        const s = a(e1);
                                        return n ? "before" === r ? t.insertTextBefore(e1, "\n") : t.insertTextAfter(s, "\n") : t.removeRange("before" === r ? [
                                            e1.range[0] - 1,
                                            e1.range[0]
                                        ] : [
                                            s.range[1],
                                            s.range[1] + 1
                                        ]);
                                    }
                                });
                            }
                            function c(t) {
                                const n = e1.getDirectivePrologue(t);
                                if (!n.length) return;
                                const a = n[0], c = r.getCommentsBefore(a);
                                c.length ? ("always" !== s || o(a) || l(a, "before", !0), "never" === s && o(a) && l(a, "before", !1)) : "Program" === t.type && "never" === s && !c.length && o(a) && l(a, "before", !1);
                                const p = n[n.length - 1], f = "Program" === t.type ? t.body : t.body.body;
                                (p !== f[f.length - 1] || p.trailingComments) && ("always" !== i || u(p) || l(p, "after", !0), "never" === i && u(p) && l(p, "after", !1));
                            }
                            return {
                                Program: c,
                                FunctionDeclaration: c,
                                FunctionExpression: c,
                                ArrowFunctionExpression: c
                            };
                        }
                    }, Ip;
                })(),
            "lines-between-class-members": ()=>(function() {
                    if (Op) return Np;
                    Op = 1;
                    const e1 = Ll(), t = {
                        "*": {
                            test: ()=>!0
                        },
                        field: {
                            test: (e1)=>"PropertyDefinition" === e1.type
                        },
                        method: {
                            test: (e1)=>"MethodDefinition" === e1.type
                        }
                    };
                    return Np = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "layout",
                            docs: {
                                description: "Require or disallow an empty line between class members",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/lines-between-class-members"
                            },
                            fixable: "whitespace",
                            schema: [
                                {
                                    anyOf: [
                                        {
                                            type: "object",
                                            properties: {
                                                enforce: {
                                                    type: "array",
                                                    items: {
                                                        type: "object",
                                                        properties: {
                                                            blankLine: {
                                                                enum: [
                                                                    "always",
                                                                    "never"
                                                                ]
                                                            },
                                                            prev: {
                                                                enum: [
                                                                    "method",
                                                                    "field",
                                                                    "*"
                                                                ]
                                                            },
                                                            next: {
                                                                enum: [
                                                                    "method",
                                                                    "field",
                                                                    "*"
                                                                ]
                                                            }
                                                        },
                                                        additionalProperties: !1,
                                                        required: [
                                                            "blankLine",
                                                            "prev",
                                                            "next"
                                                        ]
                                                    },
                                                    minItems: 1
                                                }
                                            },
                                            additionalProperties: !1,
                                            required: [
                                                "enforce"
                                            ]
                                        },
                                        {
                                            enum: [
                                                "always",
                                                "never"
                                            ]
                                        }
                                    ]
                                },
                                {
                                    type: "object",
                                    properties: {
                                        exceptAfterSingleLine: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                never: "Unexpected blank line between class members.",
                                always: "Expected blank line between class members."
                            }
                        },
                        create (r) {
                            const n = [];
                            n[0] = r.options[0] || "always", n[1] = r.options[1] || {
                                exceptAfterSingleLine: !1
                            };
                            const s = "object" == typeof n[0] ? n[0].enforce : [
                                {
                                    blankLine: n[0],
                                    prev: "*",
                                    next: "*"
                                }
                            ], i = r.sourceCode;
                            function o(t, r) {
                                const n = i.getLastToken(t), s = i.getTokenBefore(n), o = i.getFirstToken(r);
                                return e1.isSemicolonToken(n) && !e1.isTokenOnSameLine(s, n) && e1.isTokenOnSameLine(n, o) ? {
                                    curLast: s,
                                    nextFirst: n
                                } : {
                                    curLast: n,
                                    nextFirst: o
                                };
                            }
                            function a(e1, t, r) {
                                const n = i.getTokenAfter(e1, {
                                    includeComments: !0
                                });
                                return n !== t && n.loc.start.line - e1.loc.end.line <= r ? a(n, t, r) : e1;
                            }
                            function u(e1, t, r) {
                                const n = i.getTokenBefore(e1, {
                                    includeComments: !0
                                });
                                return n !== t && e1.loc.start.line - n.loc.end.line <= r ? u(n, t, r) : e1;
                            }
                            function l(e1, r) {
                                return t[r].test(e1);
                            }
                            function c(e1, t) {
                                for(let r = s.length - 1; r >= 0; --r){
                                    const n = s[r];
                                    if (l(e1, n.prev) && l(t, n.next)) return n.blankLine;
                                }
                                return null;
                            }
                            return {
                                ClassBody (t) {
                                    const s = t.body;
                                    for(let t = 0; t < s.length - 1; t++){
                                        const f = i.getFirstToken(s[t]), { curLast: d, nextFirst: h } = o(s[t], s[t + 1]), m = !!e1.isTokenOnSameLine(f, d) && n[1].exceptAfterSingleLine, g = a(d, h, 1), y = u(h, d, 1), E = y.loc.start.line - g.loc.end.line > 1, x = (l = g, p = y, 0 !== i.getTokensBetween(l, p, {
                                            includeComments: !0
                                        }).length), C = a(d, h, 0), S = c(s[t], s[t + 1]);
                                        "never" === S && E ? r.report({
                                            node: s[t + 1],
                                            messageId: "never",
                                            fix: (e1)=>x ? null : e1.replaceTextRange([
                                                    g.range[1],
                                                    y.range[0]
                                                ], "\n")
                                        }) : "always" !== S || m || E || r.report({
                                            node: s[t + 1],
                                            messageId: "always",
                                            fix: (e1)=>x ? null : e1.insertTextAfter(C, "\n")
                                        });
                                    }
                                    var l, p;
                                }
                            };
                        }
                    }, Np;
                })(),
            "logical-assignment-operators": ()=>Rd(),
            "max-classes-per-file": ()=>(Kp || (Kp = 1, Vp = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Enforce a maximum number of classes per file",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/max-classes-per-file"
                        },
                        schema: [
                            {
                                oneOf: [
                                    {
                                        type: "integer",
                                        minimum: 1
                                    },
                                    {
                                        type: "object",
                                        properties: {
                                            ignoreExpressions: {
                                                type: "boolean"
                                            },
                                            max: {
                                                type: "integer",
                                                minimum: 1
                                            }
                                        },
                                        additionalProperties: !1
                                    }
                                ]
                            }
                        ],
                        messages: {
                            maximumExceeded: "File has too many classes ({{ classCount }}). Maximum allowed is {{ max }}."
                        }
                    },
                    create (e1) {
                        const [t = {}] = e1.options, [r, n] = "number" == typeof t ? [
                            !1,
                            t || 1
                        ] : [
                            t.ignoreExpressions,
                            t.max || 1
                        ];
                        let s = 0;
                        return {
                            Program () {
                                s = 0;
                            },
                            "Program:exit" (t) {
                                s > n && e1.report({
                                    node: t,
                                    messageId: "maximumExceeded",
                                    data: {
                                        classCount: s,
                                        max: n
                                    }
                                });
                            },
                            ClassDeclaration () {
                                s++;
                            },
                            ClassExpression () {
                                r || s++;
                            }
                        };
                    }
                }), Vp),
            "max-depth": ()=>($p || ($p = 1, Mp = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Enforce a maximum depth that blocks can be nested",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/max-depth"
                        },
                        schema: [
                            {
                                oneOf: [
                                    {
                                        type: "integer",
                                        minimum: 0
                                    },
                                    {
                                        type: "object",
                                        properties: {
                                            maximum: {
                                                type: "integer",
                                                minimum: 0
                                            },
                                            max: {
                                                type: "integer",
                                                minimum: 0
                                            }
                                        },
                                        additionalProperties: !1
                                    }
                                ]
                            }
                        ],
                        messages: {
                            tooDeeply: "Blocks are nested too deeply ({{depth}}). Maximum allowed is {{maxDepth}}."
                        }
                    },
                    create (e1) {
                        const t = [], r = e1.options[0];
                        let n = 4;
                        function s() {
                            t.push(0);
                        }
                        function i() {
                            t.pop();
                        }
                        function o(r) {
                            const s = ++t[t.length - 1];
                            s > n && e1.report({
                                node: r,
                                messageId: "tooDeeply",
                                data: {
                                    depth: s,
                                    maxDepth: n
                                }
                            });
                        }
                        function a() {
                            t[t.length - 1]--;
                        }
                        return "object" == typeof r && (Object.prototype.hasOwnProperty.call(r, "maximum") || Object.prototype.hasOwnProperty.call(r, "max")) && (n = r.maximum || r.max), "number" == typeof r && (n = r), {
                            Program: s,
                            FunctionDeclaration: s,
                            FunctionExpression: s,
                            ArrowFunctionExpression: s,
                            StaticBlock: s,
                            IfStatement (e1) {
                                "IfStatement" !== e1.parent.type && o(e1);
                            },
                            SwitchStatement: o,
                            TryStatement: o,
                            DoWhileStatement: o,
                            WhileStatement: o,
                            WithStatement: o,
                            ForStatement: o,
                            ForInStatement: o,
                            ForOfStatement: o,
                            "IfStatement:exit": a,
                            "SwitchStatement:exit": a,
                            "TryStatement:exit": a,
                            "DoWhileStatement:exit": a,
                            "WhileStatement:exit": a,
                            "WithStatement:exit": a,
                            "ForStatement:exit": a,
                            "ForInStatement:exit": a,
                            "ForOfStatement:exit": a,
                            "FunctionDeclaration:exit": i,
                            "FunctionExpression:exit": i,
                            "ArrowFunctionExpression:exit": i,
                            "StaticBlock:exit": i,
                            "Program:exit": i
                        };
                    }
                }), Mp),
            "max-len": ()=>Dd(),
            "max-lines": ()=>wd(),
            "max-lines-per-function": ()=>_d(),
            "max-nested-callbacks": ()=>(Qp || (Qp = 1, Jp = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Enforce a maximum depth that callbacks can be nested",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/max-nested-callbacks"
                        },
                        schema: [
                            {
                                oneOf: [
                                    {
                                        type: "integer",
                                        minimum: 0
                                    },
                                    {
                                        type: "object",
                                        properties: {
                                            maximum: {
                                                type: "integer",
                                                minimum: 0
                                            },
                                            max: {
                                                type: "integer",
                                                minimum: 0
                                            }
                                        },
                                        additionalProperties: !1
                                    }
                                ]
                            }
                        ],
                        messages: {
                            exceed: "Too many nested callbacks ({{num}}). Maximum allowed is {{max}}."
                        }
                    },
                    create (e1) {
                        const t = e1.options[0];
                        let r = 10;
                        "object" == typeof t && (Object.prototype.hasOwnProperty.call(t, "maximum") || Object.prototype.hasOwnProperty.call(t, "max")) ? r = t.maximum || t.max : "number" == typeof t && (r = t);
                        const n = [];
                        function s(t) {
                            if ("CallExpression" === t.parent.type && n.push(t), n.length > r) {
                                const s = {
                                    num: n.length,
                                    max: r
                                };
                                e1.report({
                                    node: t,
                                    messageId: "exceed",
                                    data: s
                                });
                            }
                        }
                        function i() {
                            n.pop();
                        }
                        return {
                            ArrowFunctionExpression: s,
                            "ArrowFunctionExpression:exit": i,
                            FunctionExpression: s,
                            "FunctionExpression:exit": i
                        };
                    }
                }), Jp),
            "max-params": ()=>(function() {
                    if (Zp) return Yp;
                    Zp = 1;
                    const e1 = Ll(), { upperCaseFirst: t } = id();
                    return Yp = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Enforce a maximum number of parameters in function definitions",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/max-params"
                            },
                            schema: [
                                {
                                    oneOf: [
                                        {
                                            type: "integer",
                                            minimum: 0
                                        },
                                        {
                                            type: "object",
                                            properties: {
                                                maximum: {
                                                    type: "integer",
                                                    minimum: 0
                                                },
                                                max: {
                                                    type: "integer",
                                                    minimum: 0
                                                }
                                            },
                                            additionalProperties: !1
                                        }
                                    ]
                                }
                            ],
                            messages: {
                                exceed: "{{name}} has too many parameters ({{count}}). Maximum allowed is {{max}}."
                            }
                        },
                        create (r) {
                            const n = r.sourceCode, s = r.options[0];
                            let i = 3;
                            function o(s) {
                                s.params.length > i && r.report({
                                    loc: e1.getFunctionHeadLoc(s, n),
                                    node: s,
                                    messageId: "exceed",
                                    data: {
                                        name: t(e1.getFunctionNameWithKind(s)),
                                        count: s.params.length,
                                        max: i
                                    }
                                });
                            }
                            return "object" == typeof s && (Object.prototype.hasOwnProperty.call(s, "maximum") || Object.prototype.hasOwnProperty.call(s, "max")) && (i = s.maximum || s.max), "number" == typeof s && (i = s), {
                                FunctionDeclaration: o,
                                ArrowFunctionExpression: o,
                                FunctionExpression: o
                            };
                        }
                    }, Yp;
                })(),
            "max-statements": ()=>(function() {
                    if (tf) return ef;
                    tf = 1;
                    const e1 = Ll(), { upperCaseFirst: t } = id();
                    return ef = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Enforce a maximum number of statements allowed in function blocks",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/max-statements"
                            },
                            schema: [
                                {
                                    oneOf: [
                                        {
                                            type: "integer",
                                            minimum: 0
                                        },
                                        {
                                            type: "object",
                                            properties: {
                                                maximum: {
                                                    type: "integer",
                                                    minimum: 0
                                                },
                                                max: {
                                                    type: "integer",
                                                    minimum: 0
                                                }
                                            },
                                            additionalProperties: !1
                                        }
                                    ]
                                },
                                {
                                    type: "object",
                                    properties: {
                                        ignoreTopLevelFunctions: {
                                            type: "boolean"
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                exceed: "{{name}} has too many statements ({{count}}). Maximum allowed is {{max}}."
                            }
                        },
                        create (r) {
                            const n = [], s = r.options[0], i = r.options[1] && r.options[1].ignoreTopLevelFunctions || !1, o = [];
                            let a = 10;
                            function u(n, s, i) {
                                if (s > i) {
                                    const o = t(e1.getFunctionNameWithKind(n));
                                    r.report({
                                        node: n,
                                        messageId: "exceed",
                                        data: {
                                            name: o,
                                            count: s,
                                            max: i
                                        }
                                    });
                                }
                            }
                            function l() {
                                n.push(0);
                            }
                            function c(e1) {
                                const t = n.pop();
                                "StaticBlock" !== e1.type && (i && 0 === n.length ? o.push({
                                    node: e1,
                                    count: t
                                }) : u(e1, t, a));
                            }
                            return "object" == typeof s && (Object.prototype.hasOwnProperty.call(s, "maximum") || Object.prototype.hasOwnProperty.call(s, "max")) ? a = s.maximum || s.max : "number" == typeof s && (a = s), {
                                FunctionDeclaration: l,
                                FunctionExpression: l,
                                ArrowFunctionExpression: l,
                                StaticBlock: l,
                                BlockStatement: function(e1) {
                                    n[n.length - 1] += e1.body.length;
                                },
                                "FunctionDeclaration:exit": c,
                                "FunctionExpression:exit": c,
                                "ArrowFunctionExpression:exit": c,
                                "StaticBlock:exit": c,
                                "Program:exit" () {
                                    1 !== o.length && o.forEach((e1)=>{
                                        const t = e1.count;
                                        u(e1.node, t, a);
                                    });
                                }
                            };
                        }
                    }, ef;
                })(),
            "max-statements-per-line": ()=>kd(),
            "multiline-comment-style": ()=>Bd(),
            "multiline-ternary": ()=>(function() {
                    if (uf) return af;
                    uf = 1;
                    const e1 = Ll();
                    return af = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "layout",
                            docs: {
                                description: "Enforce newlines between operands of ternary expressions",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/multiline-ternary"
                            },
                            schema: [
                                {
                                    enum: [
                                        "always",
                                        "always-multiline",
                                        "never"
                                    ]
                                }
                            ],
                            messages: {
                                expectedTestCons: "Expected newline between test and consequent of ternary expression.",
                                expectedConsAlt: "Expected newline between consequent and alternate of ternary expression.",
                                unexpectedTestCons: "Unexpected newline between test and consequent of ternary expression.",
                                unexpectedConsAlt: "Unexpected newline between consequent and alternate of ternary expression."
                            },
                            fixable: "whitespace"
                        },
                        create (t) {
                            const r = t.sourceCode, n = t.options[0], s = "never" !== n, i = "always-multiline" === n;
                            return {
                                ConditionalExpression (n) {
                                    const o = r.getTokenAfter(n.test, e1.isNotClosingParenToken), a = r.getTokenAfter(n.consequent, e1.isNotClosingParenToken), u = r.getFirstToken(n), l = r.getTokenBefore(o), c = r.getTokenAfter(o), p = r.getTokenBefore(a), f = r.getTokenAfter(a), d = e1.isTokenOnSameLine(l, c), h = e1.isTokenOnSameLine(p, f), m = !!r.getCommentsInside(n).length;
                                    if (s) {
                                        if (i && n.loc.start.line === n.loc.end.line) return;
                                        d && t.report({
                                            node: n.test,
                                            loc: {
                                                start: u.loc.start,
                                                end: l.loc.end
                                            },
                                            messageId: "expectedTestCons",
                                            fix: (e1)=>m ? null : e1.replaceTextRange([
                                                    l.range[1],
                                                    o.range[0]
                                                ], "\n")
                                        }), h && t.report({
                                            node: n.consequent,
                                            loc: {
                                                start: c.loc.start,
                                                end: p.loc.end
                                            },
                                            messageId: "expectedConsAlt",
                                            fix: (e1)=>m ? null : e1.replaceTextRange([
                                                    p.range[1],
                                                    a.range[0]
                                                ], "\n")
                                        });
                                    } else d || t.report({
                                        node: n.test,
                                        loc: {
                                            start: u.loc.start,
                                            end: l.loc.end
                                        },
                                        messageId: "unexpectedTestCons",
                                        fix (t) {
                                            if (m) return null;
                                            const r = [], n = e1.isTokenOnSameLine(l, o), s = e1.isTokenOnSameLine(o, c);
                                            return n || r.push(t.removeRange([
                                                l.range[1],
                                                o.range[0]
                                            ])), s || r.push(t.removeRange([
                                                o.range[1],
                                                c.range[0]
                                            ])), r;
                                        }
                                    }), h || t.report({
                                        node: n.consequent,
                                        loc: {
                                            start: c.loc.start,
                                            end: p.loc.end
                                        },
                                        messageId: "unexpectedConsAlt",
                                        fix (t) {
                                            if (m) return null;
                                            const r = [], n = e1.isTokenOnSameLine(p, a), s = e1.isTokenOnSameLine(a, f);
                                            return n || r.push(t.removeRange([
                                                p.range[1],
                                                a.range[0]
                                            ])), s || r.push(t.removeRange([
                                                a.range[1],
                                                f.range[0]
                                            ])), r;
                                        }
                                    });
                                }
                            };
                        }
                    }, af;
                })(),
            "new-cap": ()=>Ld(),
            "new-parens": ()=>(function() {
                    if (ff) return pf;
                    ff = 1;
                    const e1 = Ll();
                    return pf = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "layout",
                            docs: {
                                description: "Enforce or disallow parentheses when invoking a constructor with no arguments",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/new-parens"
                            },
                            fixable: "code",
                            schema: [
                                {
                                    enum: [
                                        "always",
                                        "never"
                                    ]
                                }
                            ],
                            messages: {
                                missing: "Missing '()' invoking a constructor.",
                                unnecessary: "Unnecessary '()' invoking a constructor with no arguments."
                            }
                        },
                        create (t) {
                            const r = "never" !== t.options[0], n = t.sourceCode;
                            return {
                                NewExpression (s) {
                                    if (0 !== s.arguments.length) return;
                                    const i = n.getLastToken(s), o = i && e1.isClosingParenToken(i) && e1.isOpeningParenToken(n.getTokenBefore(i)) && s.callee.range[1] < s.range[1];
                                    r ? o || t.report({
                                        node: s,
                                        messageId: "missing",
                                        fix: (e1)=>e1.insertTextAfter(s, "()")
                                    }) : o && t.report({
                                        node: s,
                                        messageId: "unnecessary",
                                        fix: (e1)=>[
                                                e1.remove(n.getTokenBefore(i)),
                                                e1.remove(i),
                                                e1.insertTextBefore(s, "("),
                                                e1.insertTextAfter(s, ")")
                                            ]
                                    });
                                }
                            };
                        }
                    }, pf;
                })(),
            "newline-after-var": ()=>Pd(),
            "newline-before-return": ()=>Id(),
            "newline-per-chained-call": ()=>(function() {
                    if (Ef) return yf;
                    Ef = 1;
                    const e1 = Ll();
                    return yf = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "layout",
                            docs: {
                                description: "Require a newline after each call in a method chain",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/newline-per-chained-call"
                            },
                            fixable: "whitespace",
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        ignoreChainWithDepth: {
                                            type: "integer",
                                            minimum: 1,
                                            maximum: 10,
                                            default: 2
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                expected: "Expected line break before `{{callee}}`."
                            }
                        },
                        create (t) {
                            const r = (t.options[0] || {}).ignoreChainWithDepth || 2, n = t.sourceCode;
                            function s(t) {
                                const r = function(e1) {
                                    return e1.computed ? e1.optional ? "?.[" : "[" : e1.optional ? "?." : ".";
                                }(t), s = n.getText(t.property).split(e1.LINEBREAK_MATCHER), i = t.computed && 1 === s.length ? "]" : "";
                                return r + s[0] + i;
                            }
                            return {
                                "CallExpression:exit" (i) {
                                    const o = e1.skipChainExpression(i.callee);
                                    if ("MemberExpression" !== o.type) return;
                                    let a = e1.skipChainExpression(o.object), u = 1;
                                    for(; a && a.callee;)u += 1, a = e1.skipChainExpression(e1.skipChainExpression(a.callee).object);
                                    if (u > r && e1.isTokenOnSameLine(o.object, o.property)) {
                                        const r = n.getTokenAfter(o.object, e1.isNotClosingParenToken);
                                        t.report({
                                            node: o.property,
                                            loc: {
                                                start: r.loc.start,
                                                end: o.loc.end
                                            },
                                            messageId: "expected",
                                            data: {
                                                callee: s(o)
                                            },
                                            fix: (e1)=>e1.insertTextBefore(r, "\n")
                                        });
                                    }
                                }
                            };
                        }
                    }, yf;
                })(),
            "no-alert": ()=>Fd(),
            "no-array-constructor": ()=>Nd(),
            "no-async-promise-executor": ()=>(Af || (Af = 1, vf = {
                    meta: {
                        type: "problem",
                        docs: {
                            description: "Disallow using an async function as a Promise executor",
                            recommended: !0,
                            url: "https://eslint.org/docs/latest/rules/no-async-promise-executor"
                        },
                        fixable: null,
                        schema: [],
                        messages: {
                            async: "Promise executor functions should not be async."
                        }
                    },
                    create: (e1)=>({
                            "NewExpression[callee.name='Promise'][arguments.0.async=true]" (t) {
                                e1.report({
                                    node: e1.sourceCode.getFirstToken(t.arguments[0], (e1)=>"async" === e1.value),
                                    messageId: "async"
                                });
                            }
                        })
                }), vf),
            "no-await-in-loop": ()=>(function() {
                    if (Rf) return Tf;
                    function e1(e1) {
                        const t = e1.type;
                        return "FunctionDeclaration" === t || "FunctionExpression" === t || "ArrowFunctionExpression" === t || "ForOfStatement" === t && !0 === e1.await;
                    }
                    function t(e1, t) {
                        switch(t.type){
                            case "ForStatement":
                                return e1 === t.test || e1 === t.update || e1 === t.body;
                            case "ForOfStatement":
                            case "ForInStatement":
                                return e1 === t.body;
                            case "WhileStatement":
                            case "DoWhileStatement":
                                return e1 === t.test || e1 === t.body;
                            default:
                                return !1;
                        }
                    }
                    return Rf = 1, Tf = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow `await` inside of loops",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-await-in-loop"
                            },
                            schema: [],
                            messages: {
                                unexpectedAwait: "Unexpected `await` inside a loop."
                            }
                        },
                        create (r) {
                            function n(n) {
                                if ("ForOfStatement" === n.type && !n.await) return;
                                let s = n, i = s.parent;
                                for(; i && !e1(i);){
                                    if (t(s, i)) return void r.report({
                                        node: n,
                                        messageId: "unexpectedAwait"
                                    });
                                    s = i, i = i.parent;
                                }
                            }
                            return {
                                AwaitExpression: n,
                                ForOfStatement: n
                            };
                        }
                    }, Tf;
                })(),
            "no-bitwise": ()=>Od(),
            "no-buffer-constructor": ()=>(kf || (kf = 1, _f = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "problem",
                        docs: {
                            description: "Disallow use of the `Buffer()` constructor",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-buffer-constructor"
                        },
                        schema: [],
                        messages: {
                            deprecated: "{{expr}} is deprecated. Use Buffer.from(), Buffer.alloc(), or Buffer.allocUnsafe() instead."
                        }
                    },
                    create: (e1)=>({
                            "CallExpression[callee.name='Buffer'], NewExpression[callee.name='Buffer']" (t) {
                                e1.report({
                                    node: t,
                                    messageId: "deprecated",
                                    data: {
                                        expr: "CallExpression" === t.type ? "Buffer()" : "new Buffer()"
                                    }
                                });
                            }
                        })
                }), _f),
            "no-caller": ()=>(Lf || (Lf = 1, Bf = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow the use of `arguments.caller` or `arguments.callee`",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-caller"
                        },
                        schema: [],
                        messages: {
                            unexpected: "Avoid arguments.{{prop}}."
                        }
                    },
                    create: (e1)=>({
                            MemberExpression (t) {
                                const r = t.object.name, n = t.property.name;
                                "arguments" === r && !t.computed && n && n.match(/^calle[er]$/u) && e1.report({
                                    node: t,
                                    messageId: "unexpected",
                                    data: {
                                        prop: n
                                    }
                                });
                            }
                        })
                }), Bf),
            "no-case-declarations": ()=>(If || (If = 1, Pf = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow lexical declarations in case clauses",
                            recommended: !0,
                            url: "https://eslint.org/docs/latest/rules/no-case-declarations"
                        },
                        schema: [],
                        messages: {
                            unexpected: "Unexpected lexical declaration in case block."
                        }
                    },
                    create (e1) {
                        function t(e1) {
                            switch(e1.type){
                                case "FunctionDeclaration":
                                case "ClassDeclaration":
                                    return !0;
                                case "VariableDeclaration":
                                    return "var" !== e1.kind;
                                default:
                                    return !1;
                            }
                        }
                        return {
                            SwitchCase (r) {
                                for(let n = 0; n < r.consequent.length; n++){
                                    const s = r.consequent[n];
                                    t(s) && e1.report({
                                        node: s,
                                        messageId: "unexpected"
                                    });
                                }
                            }
                        };
                    }
                }), Pf),
            "no-catch-shadow": ()=>Ud(),
            "no-class-assign": ()=>(function() {
                    if (Uf) return Of;
                    Uf = 1;
                    const e1 = Ll();
                    return Of = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow reassigning class members",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-class-assign"
                            },
                            schema: [],
                            messages: {
                                class: "'{{name}}' is a class."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode;
                            function n(r) {
                                e1.getModifyingReferences(r.references).forEach((e1)=>{
                                    t.report({
                                        node: e1.identifier,
                                        messageId: "class",
                                        data: {
                                            name: e1.identifier.name
                                        }
                                    });
                                });
                            }
                            function s(e1) {
                                r.getDeclaredVariables(e1).forEach(n);
                            }
                            return {
                                ClassDeclaration: s,
                                ClassExpression: s
                            };
                        }
                    }, Of;
                })(),
            "no-compare-neg-zero": ()=>(Vf || (Vf = 1, jf = {
                    meta: {
                        type: "problem",
                        docs: {
                            description: "Disallow comparing against -0",
                            recommended: !0,
                            url: "https://eslint.org/docs/latest/rules/no-compare-neg-zero"
                        },
                        fixable: null,
                        schema: [],
                        messages: {
                            unexpected: "Do not use the '{{operator}}' operator to compare against -0."
                        }
                    },
                    create (e1) {
                        function t(e1) {
                            return "UnaryExpression" === e1.type && "-" === e1.operator && "Literal" === e1.argument.type && 0 === e1.argument.value;
                        }
                        const r = new Set([
                            ">",
                            ">=",
                            "<",
                            "<=",
                            "==",
                            "===",
                            "!=",
                            "!=="
                        ]);
                        return {
                            BinaryExpression (n) {
                                r.has(n.operator) && (t(n.left) || t(n.right)) && e1.report({
                                    node: n,
                                    messageId: "unexpected",
                                    data: {
                                        operator: n.operator
                                    }
                                });
                            }
                        };
                    }
                }), jf),
            "no-cond-assign": ()=>jd(),
            "no-confusing-arrow": ()=>(function() {
                    if (qf) return $f;
                    qf = 1;
                    const e1 = Ll();
                    return $f = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "suggestion",
                            docs: {
                                description: "Disallow arrow functions where they could be confused with comparisons",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-confusing-arrow"
                            },
                            fixable: "code",
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        allowParens: {
                                            type: "boolean",
                                            default: !0
                                        },
                                        onlyOneSimpleParam: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                confusing: "Arrow function used ambiguously with a conditional expression."
                            }
                        },
                        create (t) {
                            const r = t.options[0] || {}, n = r.allowParens || void 0 === r.allowParens, s = r.onlyOneSimpleParam, i = t.sourceCode;
                            return {
                                ArrowFunctionExpression: function(r) {
                                    const o = r.body;
                                    !function(e1) {
                                        return e1 && "ConditionalExpression" === e1.type;
                                    }(o) || n && e1.isParenthesised(i, o) || s && (1 !== r.params.length || "Identifier" !== r.params[0].type) || t.report({
                                        node: r,
                                        messageId: "confusing",
                                        fix: (e1)=>n && e1.replaceText(r.body, `(${i.getText(r.body)})`)
                                    });
                                }
                            };
                        }
                    }, $f;
                })(),
            "no-console": ()=>Vd(),
            "no-const-assign": ()=>(function() {
                    if (zf) return Xf;
                    zf = 1;
                    const e1 = Ll();
                    return Xf = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow reassigning `const` variables",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-const-assign"
                            },
                            schema: [],
                            messages: {
                                const: "'{{name}}' is constant."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode;
                            function n(r) {
                                e1.getModifyingReferences(r.references).forEach((e1)=>{
                                    t.report({
                                        node: e1.identifier,
                                        messageId: "const",
                                        data: {
                                            name: e1.identifier.name
                                        }
                                    });
                                });
                            }
                            return {
                                VariableDeclaration (e1) {
                                    "const" === e1.kind && r.getDeclaredVariables(e1).forEach(n);
                                }
                            };
                        }
                    }, Xf;
                })(),
            "no-constant-binary-expression": ()=>Kd(),
            "no-constant-condition": ()=>Md(),
            "no-constructor-return": ()=>(ed || (ed = 1, Zf = {
                    meta: {
                        type: "problem",
                        docs: {
                            description: "Disallow returning value from constructor",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-constructor-return"
                        },
                        schema: {},
                        fixable: null,
                        messages: {
                            unexpected: "Unexpected return statement in constructor."
                        }
                    },
                    create (e1) {
                        const t = [];
                        return {
                            onCodePathStart (e1, r) {
                                t.push(r);
                            },
                            onCodePathEnd () {
                                t.pop();
                            },
                            ReturnStatement (r) {
                                const n = t[t.length - 1];
                                n.parent && ("MethodDefinition" !== n.parent.type || "constructor" !== n.parent.kind || r.parent.parent !== n && !r.argument || e1.report({
                                    node: r,
                                    messageId: "unexpected"
                                }));
                            }
                        };
                    }
                }), Zf),
            "no-continue": ()=>(rd || (rd = 1, td = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow `continue` statements",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-continue"
                        },
                        schema: [],
                        messages: {
                            unexpected: "Unexpected use of continue statement."
                        }
                    },
                    create: (e1)=>({
                            ContinueStatement (t) {
                                e1.report({
                                    node: t,
                                    messageId: "unexpected"
                                });
                            }
                        })
                }), td),
            "no-control-regex": ()=>(function() {
                    if (Gd) return qd;
                    Gd = 1;
                    const e1 = _C().RegExpValidator, t = new class {
                        constructor(){
                            this._source = "", this._controlChars = [], this._validator = new e1(this);
                        }
                        onPatternEnter() {
                            this._controlChars = [];
                        }
                        onCharacter(e1, t, r) {
                            r >= 0 && r <= 31 && (this._source.codePointAt(e1) === r || this._source.slice(e1, t).startsWith("\\x") || this._source.slice(e1, t).startsWith("\\u")) && this._controlChars.push(`\\x${`0${r.toString(16)}`.slice(-2)}`);
                        }
                        collectControlChars(e1, t) {
                            const r = "string" == typeof t && t.includes("u"), n = "string" == typeof t && t.includes("v");
                            this._controlChars = [], this._source = e1;
                            try {
                                this._validator.validatePattern(e1, void 0, void 0, {
                                    unicode: r,
                                    unicodeSets: n
                                });
                            } catch  {}
                            return this._controlChars;
                        }
                    };
                    return qd = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow control characters in regular expressions",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-control-regex"
                            },
                            schema: [],
                            messages: {
                                unexpected: "Unexpected control character(s) in regular expression: {{controlChars}}."
                            }
                        },
                        create: (e1)=>({
                                Literal (r) {
                                    const n = function(e1) {
                                        return e1.regex ? e1.regex : "string" != typeof e1.value || "NewExpression" !== e1.parent.type && "CallExpression" !== e1.parent.type || "Identifier" !== e1.parent.callee.type || "RegExp" !== e1.parent.callee.name || e1.parent.arguments[0] !== e1 ? null : {
                                            pattern: e1.value,
                                            flags: e1.parent.arguments.length > 1 && "Literal" === e1.parent.arguments[1].type && "string" == typeof e1.parent.arguments[1].value ? e1.parent.arguments[1].value : null
                                        };
                                    }(r);
                                    if (n) {
                                        const { pattern: s, flags: i } = n, o = t.collectControlChars(s, i);
                                        o.length > 0 && e1.report({
                                            node: r,
                                            messageId: "unexpected",
                                            data: {
                                                controlChars: o.join(", ")
                                            }
                                        });
                                    }
                                }
                            })
                    }, qd;
                })(),
            "no-debugger": ()=>(Xd || (Xd = 1, Wd = {
                    meta: {
                        type: "problem",
                        docs: {
                            description: "Disallow the use of `debugger`",
                            recommended: !0,
                            url: "https://eslint.org/docs/latest/rules/no-debugger"
                        },
                        fixable: null,
                        schema: [],
                        messages: {
                            unexpected: "Unexpected 'debugger' statement."
                        }
                    },
                    create: (e1)=>({
                            DebuggerStatement (t) {
                                e1.report({
                                    node: t,
                                    messageId: "unexpected"
                                });
                            }
                        })
                }), Wd),
            "no-delete-var": ()=>(Hd || (Hd = 1, zd = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow deleting variables",
                            recommended: !0,
                            url: "https://eslint.org/docs/latest/rules/no-delete-var"
                        },
                        schema: [],
                        messages: {
                            unexpected: "Variables should not be deleted."
                        }
                    },
                    create: (e1)=>({
                            UnaryExpression (t) {
                                "delete" === t.operator && "Identifier" === t.argument.type && e1.report({
                                    node: t,
                                    messageId: "unexpected"
                                });
                            }
                        })
                }), zd),
            "no-div-regex": ()=>(Qd || (Qd = 1, Jd = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow equal signs explicitly at the beginning of regular expressions",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-div-regex"
                        },
                        fixable: "code",
                        schema: [],
                        messages: {
                            unexpected: "A regular expression literal can be confused with '/='."
                        }
                    },
                    create (e1) {
                        const t = e1.sourceCode;
                        return {
                            Literal (r) {
                                const n = t.getFirstToken(r);
                                "RegularExpression" === n.type && "=" === n.value[1] && e1.report({
                                    node: r,
                                    messageId: "unexpected",
                                    fix: (e1)=>e1.replaceTextRange([
                                            n.range[0] + 1,
                                            n.range[0] + 2
                                        ], "[=]")
                                });
                            }
                        };
                    }
                }), Jd),
            "no-dupe-args": ()=>(Zd || (Zd = 1, Yd = {
                    meta: {
                        type: "problem",
                        docs: {
                            description: "Disallow duplicate arguments in `function` definitions",
                            recommended: !0,
                            url: "https://eslint.org/docs/latest/rules/no-dupe-args"
                        },
                        schema: [],
                        messages: {
                            unexpected: "Duplicate param '{{name}}'."
                        }
                    },
                    create (e1) {
                        const t = e1.sourceCode;
                        function r(e1) {
                            return "Parameter" === e1.type;
                        }
                        function n(n) {
                            const s = t.getDeclaredVariables(n);
                            for(let t = 0; t < s.length; ++t){
                                const i = s[t];
                                i.defs.filter(r).length >= 2 && e1.report({
                                    node: n,
                                    messageId: "unexpected",
                                    data: {
                                        name: i.name
                                    }
                                });
                            }
                        }
                        return {
                            FunctionDeclaration: n,
                            FunctionExpression: n
                        };
                    }
                }), Yd),
            "no-dupe-class-members": ()=>kC(),
            "no-dupe-else-if": ()=>(function() {
                    if (nh) return rh;
                    nh = 1;
                    const e1 = Ll();
                    function t(e1, t, r) {
                        return t.every((t)=>r.some((r)=>e1(t, r)));
                    }
                    function r(e1, t) {
                        return "LogicalExpression" === t.type && t.operator === e1 ? [
                            ...r(e1, t.left),
                            ...r(e1, t.right)
                        ] : [
                            t
                        ];
                    }
                    const n = r.bind(null, "||"), s = r.bind(null, "&&");
                    return rh = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow duplicate conditions in if-else-if chains",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-dupe-else-if"
                            },
                            schema: [],
                            messages: {
                                unexpected: "This branch can never execute. Its condition is a duplicate or covered by previous conditions in the if-else-if chain."
                            }
                        },
                        create (r) {
                            const i = r.sourceCode, o = t.bind(null, function t(r, n) {
                                return r.type === n.type && ("LogicalExpression" !== r.type || "||" !== r.operator && "&&" !== r.operator || r.operator !== n.operator ? e1.equalTokens(r, n, i) : t(r.left, n.left) && t(r.right, n.right) || t(r.left, n.right) && t(r.right, n.left));
                            });
                            return {
                                IfStatement (e1) {
                                    const t = e1.test;
                                    let i = e1, a = ("LogicalExpression" === t.type && "&&" === t.operator ? [
                                        t,
                                        ...s(t)
                                    ] : [
                                        t
                                    ]).map((e1)=>n(e1).map(s));
                                    for(; i.parent && "IfStatement" === i.parent.type && i.parent.alternate === i;){
                                        i = i.parent;
                                        const e1 = n(i.test).map(s);
                                        if (a = a.map((t)=>t.filter((t)=>!e1.some((e1)=>o(e1, t)))), a.some((e1)=>0 === e1.length)) {
                                            r.report({
                                                node: t,
                                                messageId: "unexpected"
                                            });
                                            break;
                                        }
                                    }
                                }
                            };
                        }
                    }, rh;
                })(),
            "no-dupe-keys": ()=>(function() {
                    if (ih) return sh;
                    ih = 1;
                    const e1 = Ll(), t = /^(?:init|get)$/u, r = /^(?:init|set)$/u;
                    class n {
                        constructor(e1, t){
                            this.upper = e1, this.node = t, this.properties = new Map;
                        }
                        getPropertyInfo(t) {
                            const r = e1.getStaticPropertyName(t);
                            return this.properties.has(r) || this.properties.set(r, {
                                get: !1,
                                set: !1
                            }), this.properties.get(r);
                        }
                        isPropertyDefined(e1) {
                            const n = this.getPropertyInfo(e1);
                            return t.test(e1.kind) && n.get || r.test(e1.kind) && n.set;
                        }
                        defineProperty(e1) {
                            const n = this.getPropertyInfo(e1);
                            t.test(e1.kind) && (n.get = !0), r.test(e1.kind) && (n.set = !0);
                        }
                    }
                    return sh = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow duplicate keys in object literals",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-dupe-keys"
                            },
                            schema: [],
                            messages: {
                                unexpected: "Duplicate key '{{name}}'."
                            }
                        },
                        create (t) {
                            let r = null;
                            return {
                                ObjectExpression (e1) {
                                    r = new n(r, e1);
                                },
                                "ObjectExpression:exit" () {
                                    r = r.upper;
                                },
                                Property (n) {
                                    const s = e1.getStaticPropertyName(n);
                                    "ObjectExpression" === n.parent.type && null !== s && (r.isPropertyDefined(n) && t.report({
                                        node: r.node,
                                        loc: n.key.loc,
                                        messageId: "unexpected",
                                        data: {
                                            name: s
                                        }
                                    }), r.defineProperty(n));
                                }
                            };
                        }
                    }, sh;
                })(),
            "no-duplicate-case": ()=>(function() {
                    if (ah) return oh;
                    ah = 1;
                    const e1 = Ll();
                    return oh = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow duplicate case labels",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-duplicate-case"
                            },
                            schema: [],
                            messages: {
                                unexpected: "Duplicate case label."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode;
                            function n(t, n) {
                                return t.type === n.type && e1.equalTokens(t, n, r);
                            }
                            return {
                                SwitchStatement (e1) {
                                    const r = [];
                                    for (const s of e1.cases)if (s.test) {
                                        const e1 = s.test;
                                        r.some((t)=>n(t, e1)) ? t.report({
                                            node: s,
                                            messageId: "unexpected"
                                        }) : r.push(e1);
                                    }
                                }
                            };
                        }
                    }, oh;
                })(),
            "no-duplicate-imports": ()=>BC(),
            "no-else-return": ()=>PC(),
            "no-empty": ()=>(function() {
                    if (mh) return hh;
                    mh = 1;
                    const e1 = Ll();
                    return hh = {
                        meta: {
                            hasSuggestions: !0,
                            type: "suggestion",
                            docs: {
                                description: "Disallow empty block statements",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-empty"
                            },
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        allowEmptyCatch: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                unexpected: "Empty {{type}} statement.",
                                suggestComment: "Add comment inside empty {{type}} statement."
                            }
                        },
                        create (t) {
                            const r = (t.options[0] || {}).allowEmptyCatch || !1, n = t.sourceCode;
                            return {
                                BlockStatement (s) {
                                    0 === s.body.length && (e1.isFunction(s.parent) || r && "CatchClause" === s.parent.type || n.getCommentsInside(s).length > 0 || t.report({
                                        node: s,
                                        messageId: "unexpected",
                                        data: {
                                            type: "block"
                                        },
                                        suggest: [
                                            {
                                                messageId: "suggestComment",
                                                data: {
                                                    type: "block"
                                                },
                                                fix (e1) {
                                                    const t = [
                                                        s.range[0] + 1,
                                                        s.range[1] - 1
                                                    ];
                                                    return e1.replaceTextRange(t, " /* empty */ ");
                                                }
                                            }
                                        ]
                                    }));
                                },
                                SwitchStatement (e1) {
                                    void 0 !== e1.cases && 0 !== e1.cases.length || t.report({
                                        node: e1,
                                        messageId: "unexpected",
                                        data: {
                                            type: "switch"
                                        }
                                    });
                                }
                            };
                        }
                    }, hh;
                })(),
            "no-empty-character-class": ()=>(function() {
                    if (yh) return gh;
                    yh = 1;
                    const { RegExpParser: e1, visitRegExpAST: t } = _C(), r = new e1, n = /\[\]/u;
                    return gh = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow empty character classes in regular expressions",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-empty-character-class"
                            },
                            schema: [],
                            messages: {
                                unexpected: "Empty class."
                            }
                        },
                        create: (e1)=>({
                                "Literal[regex]" (s) {
                                    const { pattern: i, flags: o } = s.regex;
                                    if (!n.test(i)) return;
                                    let a;
                                    try {
                                        a = r.parsePattern(i, 0, i.length, {
                                            unicode: o.includes("u"),
                                            unicodeSets: o.includes("v")
                                        });
                                    } catch  {
                                        return;
                                    }
                                    t(a, {
                                        onCharacterClassEnter (t) {
                                            t.negate || 0 !== t.elements.length || e1.report({
                                                node: s,
                                                messageId: "unexpected"
                                            });
                                        }
                                    });
                                }
                            })
                    }, gh;
                })(),
            "no-empty-function": ()=>(function() {
                    if (xh) return Eh;
                    xh = 1;
                    const e1 = Ll(), t = Object.freeze([
                        "functions",
                        "arrowFunctions",
                        "generatorFunctions",
                        "methods",
                        "generatorMethods",
                        "getters",
                        "setters",
                        "constructors",
                        "asyncFunctions",
                        "asyncMethods"
                    ]);
                    return Eh = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow empty functions",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-empty-function"
                            },
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        allow: {
                                            type: "array",
                                            items: {
                                                enum: t
                                            },
                                            uniqueItems: !0
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                unexpected: "Unexpected empty {{name}}."
                            }
                        },
                        create (t) {
                            const r = (t.options[0] || {}).allow || [], n = t.sourceCode;
                            function s(s) {
                                const i = function(e1) {
                                    const t = e1.parent;
                                    let r = "";
                                    if ("ArrowFunctionExpression" === e1.type) return "arrowFunctions";
                                    if ("Property" === t.type) {
                                        if ("get" === t.kind) return "getters";
                                        if ("set" === t.kind) return "setters";
                                        r = t.method ? "methods" : "functions";
                                    } else if ("MethodDefinition" === t.type) {
                                        if ("get" === t.kind) return "getters";
                                        if ("set" === t.kind) return "setters";
                                        if ("constructor" === t.kind) return "constructors";
                                        r = "methods";
                                    } else r = "functions";
                                    let n = "";
                                    if (e1.generator) n = "generator";
                                    else {
                                        if (!e1.async) return r;
                                        n = "async";
                                    }
                                    return n + r[0].toUpperCase() + r.slice(1);
                                }(s), o = e1.getFunctionNameWithKind(s), a = n.getTokens(s.body, {
                                    includeComments: !0,
                                    filter: e1.isCommentToken
                                });
                                r.includes(i) || "BlockStatement" !== s.body.type || 0 !== s.body.body.length || 0 !== a.length || t.report({
                                    node: s,
                                    loc: s.body.loc,
                                    messageId: "unexpected",
                                    data: {
                                        name: o
                                    }
                                });
                            }
                            return {
                                ArrowFunctionExpression: s,
                                FunctionDeclaration: s,
                                FunctionExpression: s
                            };
                        }
                    }, Eh;
                })(),
            "no-empty-pattern": ()=>(function() {
                    if (Sh) return Ch;
                    Sh = 1;
                    const e1 = Ll();
                    return Ch = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow empty destructuring patterns",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-empty-pattern"
                            },
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        allowObjectPatternsAsParameters: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                unexpected: "Unexpected empty {{type}} pattern."
                            }
                        },
                        create (t) {
                            const r = (t.options[0] || {}).allowObjectPatternsAsParameters || !1;
                            return {
                                ObjectPattern (n) {
                                    n.properties.length > 0 || r && (e1.isFunction(n.parent) || "AssignmentPattern" === n.parent.type && e1.isFunction(n.parent.parent) && "ObjectExpression" === n.parent.right.type && 0 === n.parent.right.properties.length) || t.report({
                                        node: n,
                                        messageId: "unexpected",
                                        data: {
                                            type: "object"
                                        }
                                    });
                                },
                                ArrayPattern (e1) {
                                    0 === e1.elements.length && t.report({
                                        node: e1,
                                        messageId: "unexpected",
                                        data: {
                                            type: "array"
                                        }
                                    });
                                }
                            };
                        }
                    }, Ch;
                })(),
            "no-empty-static-block": ()=>(vh || (vh = 1, bh = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow empty static blocks",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-empty-static-block"
                        },
                        schema: [],
                        messages: {
                            unexpected: "Unexpected empty static block."
                        }
                    },
                    create (e1) {
                        const t = e1.sourceCode;
                        return {
                            StaticBlock (r) {
                                if (0 === r.body.length) {
                                    const n = t.getLastToken(r);
                                    0 === t.getCommentsBefore(n).length && e1.report({
                                        node: r,
                                        messageId: "unexpected"
                                    });
                                }
                            }
                        };
                    }
                }), bh),
            "no-eq-null": ()=>(Th || (Th = 1, Ah = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow `null` comparisons without type-checking operators",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-eq-null"
                        },
                        schema: [],
                        messages: {
                            unexpected: "Use '===' to compare with null."
                        }
                    },
                    create: (e1)=>({
                            BinaryExpression (t) {
                                const r = "==" === t.operator || "!=" === t.operator;
                                ("Literal" === t.right.type && "null" === t.right.raw && r || "Literal" === t.left.type && "null" === t.left.raw && r) && e1.report({
                                    node: t,
                                    messageId: "unexpected"
                                });
                            }
                        })
                }), Ah),
            "no-eval": ()=>IC(),
            "no-ex-assign": ()=>(function() {
                    if (_h) return wh;
                    _h = 1;
                    const e1 = Ll();
                    return wh = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow reassigning exceptions in `catch` clauses",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-ex-assign"
                            },
                            schema: [],
                            messages: {
                                unexpected: "Do not assign to the exception parameter."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode;
                            function n(r) {
                                e1.getModifyingReferences(r.references).forEach((e1)=>{
                                    t.report({
                                        node: e1.identifier,
                                        messageId: "unexpected"
                                    });
                                });
                            }
                            return {
                                CatchClause (e1) {
                                    r.getDeclaredVariables(e1).forEach(n);
                                }
                            };
                        }
                    }, wh;
                })(),
            "no-extend-native": ()=>FC(),
            "no-extra-bind": ()=>NC(),
            "no-extra-boolean-cast": ()=>OC(),
            "no-extra-label": ()=>(function() {
                    if (Oh) return Nh;
                    Oh = 1;
                    const e1 = Ll();
                    return Nh = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow unnecessary labels",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-extra-label"
                            },
                            schema: [],
                            fixable: "code",
                            messages: {
                                unexpected: "This label '{{name}}' is unnecessary."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode;
                            let n = null;
                            function s(e1) {
                                n = {
                                    label: "LabeledStatement" === e1.parent.type ? e1.parent.label : null,
                                    breakable: !0,
                                    upper: n
                                };
                            }
                            function i() {
                                n = n.upper;
                            }
                            function o(e1) {
                                if (!e1.label) return;
                                const s = e1.label;
                                for(let i = n; null !== i; i = i.upper)if (i.breakable || i.label && i.label.name === s.name) return void (i.breakable && i.label && i.label.name === s.name && t.report({
                                    node: s,
                                    messageId: "unexpected",
                                    data: s,
                                    fix (t) {
                                        const n = r.getFirstToken(e1);
                                        return r.commentsExistBetween(n, s) ? null : t.removeRange([
                                            n.range[1],
                                            s.range[1]
                                        ]);
                                    }
                                }));
                            }
                            return {
                                WhileStatement: s,
                                "WhileStatement:exit": i,
                                DoWhileStatement: s,
                                "DoWhileStatement:exit": i,
                                ForStatement: s,
                                "ForStatement:exit": i,
                                ForInStatement: s,
                                "ForInStatement:exit": i,
                                ForOfStatement: s,
                                "ForOfStatement:exit": i,
                                SwitchStatement: s,
                                "SwitchStatement:exit": i,
                                LabeledStatement: function(t) {
                                    e1.isBreakableStatement(t.body) || (n = {
                                        label: t.label,
                                        breakable: !1,
                                        upper: n
                                    });
                                },
                                "LabeledStatement:exit": function(t) {
                                    e1.isBreakableStatement(t.body) || (n = n.upper);
                                },
                                BreakStatement: o,
                                ContinueStatement: o
                            };
                        }
                    }, Nh;
                })(),
            "no-extra-parens": ()=>UC(),
            "no-extra-semi": ()=>(function() {
                    if (Kh) return Vh;
                    Kh = 1;
                    const e1 = LC(), t = Ll();
                    return Vh = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "suggestion",
                            docs: {
                                description: "Disallow unnecessary semicolons",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-extra-semi"
                            },
                            fixable: "code",
                            schema: [],
                            messages: {
                                unexpected: "Unnecessary semicolon."
                            }
                        },
                        create (r) {
                            const n = r.sourceCode;
                            function s(e1) {
                                const r = n.getTokenAfter(e1);
                                if (!r || "String" !== r.type) return !0;
                                const s = n.getNodeByRangeIndex(r.range[0]);
                                return !t.isTopLevelExpressionStatement(s.parent);
                            }
                            function i(t) {
                                r.report({
                                    node: t,
                                    messageId: "unexpected",
                                    fix: s(t) ? (n)=>new e1(n, r.sourceCode).retainSurroundingTokens(t).remove(t) : null
                                });
                            }
                            function o(e1) {
                                for(let r = e1; "Punctuator" === r.type && !t.isClosingBraceToken(r); r = n.getTokenAfter(r))t.isSemicolonToken(r) && i(r);
                            }
                            return {
                                EmptyStatement (e1) {
                                    const t = e1.parent;
                                    [
                                        "ForStatement",
                                        "ForInStatement",
                                        "ForOfStatement",
                                        "WhileStatement",
                                        "DoWhileStatement",
                                        "IfStatement",
                                        "LabeledStatement",
                                        "WithStatement"
                                    ].includes(t.type) || i(e1);
                                },
                                ClassBody (e1) {
                                    o(n.getFirstToken(e1, 1));
                                },
                                "MethodDefinition, PropertyDefinition, StaticBlock" (e1) {
                                    o(n.getTokenAfter(e1));
                                }
                            };
                        }
                    }, Vh;
                })(),
            "no-fallthrough": ()=>jC(),
            "no-floating-decimal": ()=>(function() {
                    if (Gh) return qh;
                    Gh = 1;
                    const e1 = Ll();
                    return qh = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "suggestion",
                            docs: {
                                description: "Disallow leading or trailing decimal points in numeric literals",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-floating-decimal"
                            },
                            schema: [],
                            fixable: "code",
                            messages: {
                                leading: "A leading decimal point can be confused with a dot.",
                                trailing: "A trailing decimal point can be confused with a dot."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode;
                            return {
                                Literal (n) {
                                    "number" == typeof n.value && (n.raw.startsWith(".") && t.report({
                                        node: n,
                                        messageId: "leading",
                                        fix (t) {
                                            const s = r.getTokenBefore(n), i = s && s.range[1] === n.range[0] && !e1.canTokensBeAdjacent(s, `0${n.raw}`);
                                            return t.insertTextBefore(n, i ? " 0" : "0");
                                        }
                                    }), n.raw.indexOf(".") === n.raw.length - 1 && t.report({
                                        node: n,
                                        messageId: "trailing",
                                        fix: (e1)=>e1.insertTextAfter(n, "0")
                                    }));
                                }
                            };
                        }
                    }, qh;
                })(),
            "no-func-assign": ()=>VC(),
            "no-global-assign": ()=>(Hh || (Hh = 1, zh = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow assignments to native objects or read-only global variables",
                            recommended: !0,
                            url: "https://eslint.org/docs/latest/rules/no-global-assign"
                        },
                        schema: [
                            {
                                type: "object",
                                properties: {
                                    exceptions: {
                                        type: "array",
                                        items: {
                                            type: "string"
                                        },
                                        uniqueItems: !0
                                    }
                                },
                                additionalProperties: !1
                            }
                        ],
                        messages: {
                            globalShouldNotBeModified: "Read-only global '{{name}}' should not be modified."
                        }
                    },
                    create (e1) {
                        const t = e1.options[0], r = e1.sourceCode, n = t && t.exceptions || [];
                        function s(t, r, n) {
                            const s = t.identifier;
                            !1 !== t.init || !t.isWrite() || 0 !== r && n[r - 1].identifier === s || e1.report({
                                node: s,
                                messageId: "globalShouldNotBeModified",
                                data: {
                                    name: s.name
                                }
                            });
                        }
                        function i(e1) {
                            !1 !== e1.writeable || n.includes(e1.name) || e1.references.forEach(s);
                        }
                        return {
                            Program (e1) {
                                r.getScope(e1).variables.forEach(i);
                            }
                        };
                    }
                }), zh),
            "no-implicit-coercion": ()=>KC(),
            "no-implicit-globals": ()=>(Zh || (Zh = 1, Yh = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow declarations in the global scope",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-implicit-globals"
                        },
                        schema: [
                            {
                                type: "object",
                                properties: {
                                    lexicalBindings: {
                                        type: "boolean",
                                        default: !1
                                    }
                                },
                                additionalProperties: !1
                            }
                        ],
                        messages: {
                            globalNonLexicalBinding: "Unexpected {{kind}} declaration in the global scope, wrap in an IIFE for a local variable, assign as global property for a global variable.",
                            globalLexicalBinding: "Unexpected {{kind}} declaration in the global scope, wrap in a block or in an IIFE.",
                            globalVariableLeak: "Global variable leak, declare the variable if it is intended to be local.",
                            assignmentToReadonlyGlobal: "Unexpected assignment to read-only global variable.",
                            redeclarationOfReadonlyGlobal: "Unexpected redeclaration of read-only global variable."
                        }
                    },
                    create (e1) {
                        const t = e1.options[0] && !0 === e1.options[0].lexicalBindings, r = e1.sourceCode;
                        function n(t, r, n) {
                            e1.report({
                                node: t,
                                messageId: r,
                                data: {
                                    kind: n
                                }
                            });
                        }
                        return {
                            Program (e1) {
                                const s = r.getScope(e1);
                                s.variables.forEach((e1)=>{
                                    const r = !1 === e1.writeable;
                                    !0 === e1.writeable || e1.eslintExported || e1.defs.forEach((e1)=>{
                                        const s = e1.node;
                                        ("FunctionName" === e1.type || "Variable" === e1.type && "var" === e1.parent.kind) && (r ? n(s, "redeclarationOfReadonlyGlobal") : n(s, "globalNonLexicalBinding", "FunctionName" === e1.type ? "function" : `'${e1.parent.kind}'`)), t && ("ClassName" !== e1.type && ("Variable" !== e1.type || "let" !== e1.parent.kind && "const" !== e1.parent.kind) || (r ? n(s, "redeclarationOfReadonlyGlobal") : n(s, "globalLexicalBinding", "ClassName" === e1.type ? "class" : `'${e1.parent.kind}'`)));
                                    });
                                }), s.implicit.variables.forEach((e1)=>{
                                    const t = s.set.get(e1.name);
                                    let r;
                                    if (t) {
                                        if (t.writeable) return;
                                        r = "assignmentToReadonlyGlobal";
                                    } else r = "globalVariableLeak";
                                    e1.defs.forEach((e1)=>{
                                        n(e1.node, r);
                                    });
                                });
                            }
                        };
                    }
                }), Yh),
            "no-implied-eval": ()=>MC(),
            "no-import-assign": ()=>$C(),
            "no-inline-comments": ()=>(function() {
                    if (im) return sm;
                    im = 1;
                    const e1 = Ll();
                    return sm = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow inline comments after code",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-inline-comments"
                            },
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        ignorePattern: {
                                            type: "string"
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                unexpectedInlineComment: "Unexpected comment inline with code."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode, n = t.options[0];
                            let s;
                            function i(n) {
                                const i = String(r.lines[n.loc.start.line - 1]), o = String(r.lines[n.loc.end.line - 1]), a = i.slice(0, n.loc.start.column).trim(), u = o.slice(n.loc.end.column).trim(), l = !a, c = !u;
                                if (!(l && c || s && s.test(n.value))) {
                                    if ((l || "{" === a) && (c || "}" === u)) {
                                        const e1 = r.getNodeByRangeIndex(n.range[0]);
                                        if (e1 && "JSXEmptyExpression" === e1.type) return;
                                    }
                                    e1.isDirectiveComment(n) || t.report({
                                        node: n,
                                        messageId: "unexpectedInlineComment"
                                    });
                                }
                            }
                            return n && n.ignorePattern && (s = new RegExp(n.ignorePattern, "u")), {
                                Program () {
                                    r.getAllComments().filter((e1)=>"Shebang" !== e1.type).forEach(i);
                                }
                            };
                        }
                    }, sm;
                })(),
            "no-inner-declarations": ()=>(function() {
                    if (am) return om;
                    am = 1;
                    const e1 = Ll(), t = new Set([
                        "Program",
                        "StaticBlock",
                        "ExportNamedDeclaration",
                        "ExportDefaultDeclaration"
                    ]), r = new Set([
                        "FunctionDeclaration",
                        "FunctionExpression",
                        "ArrowFunctionExpression"
                    ]);
                    function n(t) {
                        let { parent: r } = t;
                        for(; r;){
                            if ("StaticBlock" === r.type) return "class static block body";
                            if (e1.isFunction(r)) return "function body";
                            ({ parent: r } = r);
                        }
                        return "program";
                    }
                    return om = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow variable or `function` declarations in nested blocks",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-inner-declarations"
                            },
                            schema: [
                                {
                                    enum: [
                                        "functions",
                                        "both"
                                    ]
                                }
                            ],
                            messages: {
                                moveDeclToRoot: "Move {{type}} declaration to {{body}} root."
                            }
                        },
                        create (e1) {
                            function s(s) {
                                const i = s.parent;
                                "BlockStatement" === i.type && r.has(i.parent.type) || t.has(i.type) || e1.report({
                                    node: s,
                                    messageId: "moveDeclToRoot",
                                    data: {
                                        type: "FunctionDeclaration" === s.type ? "function" : "variable",
                                        body: n(s)
                                    }
                                });
                            }
                            return {
                                FunctionDeclaration: s,
                                VariableDeclaration (t) {
                                    "both" === e1.options[0] && "var" === t.kind && s(t);
                                }
                            };
                        }
                    }, om;
                })(),
            "no-invalid-regexp": ()=>qC(),
            "no-invalid-this": ()=>(function() {
                    if (pm) return cm;
                    pm = 1;
                    const e1 = Ll();
                    function t(e1, t) {
                        return "function" === e1.origin && "ArrowFunctionExpression" === t.type;
                    }
                    return cm = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow use of `this` in contexts where the value of `this` is `undefined`",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-invalid-this"
                            },
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        capIsConstructor: {
                                            type: "boolean",
                                            default: !0
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                unexpectedThis: "Unexpected 'this'."
                            }
                        },
                        create (r) {
                            const n = !1 !== (r.options[0] || {}).capIsConstructor, s = [], i = r.sourceCode;
                            return s.getCurrent = function() {
                                const t = this[this.length - 1];
                                return t.init || (t.init = !0, t.valid = !e1.isDefaultThisBinding(t.node, i, {
                                    capIsConstructor: n
                                })), t;
                            }, {
                                onCodePathStart (e1, n) {
                                    if (!t(e1, n)) {
                                        if ("program" !== e1.origin) s.push({
                                            init: !i.getScope(n).isStrict,
                                            node: n,
                                            valid: !0
                                        });
                                        else {
                                            const e1 = i.getScope(n), t = r.languageOptions.parserOptions.ecmaFeatures || {};
                                            s.push({
                                                init: !0,
                                                node: n,
                                                valid: !("module" === n.sourceType || t.globalReturn && e1.childScopes[0].isStrict)
                                            });
                                        }
                                    }
                                },
                                onCodePathEnd (e1, r) {
                                    t(e1, r) || s.pop();
                                },
                                ThisExpression (e1) {
                                    const t = s.getCurrent();
                                    t && !t.valid && r.report({
                                        node: e1,
                                        messageId: "unexpectedThis"
                                    });
                                }
                            };
                        }
                    }, cm;
                })(),
            "no-irregular-whitespace": ()=>GC(),
            "no-iterator": ()=>(function() {
                    if (mm) return hm;
                    mm = 1;
                    const { getStaticPropertyName: e1 } = Ll();
                    return hm = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow the use of the `__iterator__` property",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-iterator"
                            },
                            schema: [],
                            messages: {
                                noIterator: "Reserved name '__iterator__'."
                            }
                        },
                        create: (t)=>({
                                MemberExpression (r) {
                                    "__iterator__" === e1(r) && t.report({
                                        node: r,
                                        messageId: "noIterator"
                                    });
                                }
                            })
                    }, hm;
                })(),
            "no-label-var": ()=>WC(),
            "no-labels": ()=>(function() {
                    if (xm) return Em;
                    xm = 1;
                    const e1 = Ll();
                    return Em = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow labeled statements",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-labels"
                            },
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        allowLoop: {
                                            type: "boolean",
                                            default: !1
                                        },
                                        allowSwitch: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                unexpectedLabel: "Unexpected labeled statement.",
                                unexpectedLabelInBreak: "Unexpected label in break statement.",
                                unexpectedLabelInContinue: "Unexpected label in continue statement."
                            }
                        },
                        create (t) {
                            const r = t.options[0], n = r && r.allowLoop, s = r && r.allowSwitch;
                            let i = null;
                            function o(t) {
                                return e1.isLoop(t) ? "loop" : "SwitchStatement" === t.type ? "switch" : "other";
                            }
                            function a(e1) {
                                switch(e1){
                                    case "loop":
                                        return n;
                                    case "switch":
                                        return s;
                                    default:
                                        return !1;
                                }
                            }
                            function u(e1) {
                                let t = i;
                                for(; t;){
                                    if (t.label === e1) return t.kind;
                                    t = t.upper;
                                }
                                return "other";
                            }
                            return {
                                LabeledStatement (e1) {
                                    i = {
                                        label: e1.label.name,
                                        kind: o(e1.body),
                                        upper: i
                                    };
                                },
                                "LabeledStatement:exit" (e1) {
                                    a(i.kind) || t.report({
                                        node: e1,
                                        messageId: "unexpectedLabel"
                                    }), i = i.upper;
                                },
                                BreakStatement (e1) {
                                    e1.label && !a(u(e1.label.name)) && t.report({
                                        node: e1,
                                        messageId: "unexpectedLabelInBreak"
                                    });
                                },
                                ContinueStatement (e1) {
                                    e1.label && !a(u(e1.label.name)) && t.report({
                                        node: e1,
                                        messageId: "unexpectedLabelInContinue"
                                    });
                                }
                            };
                        }
                    }, Em;
                })(),
            "no-lone-blocks": ()=>(Sm || (Sm = 1, Cm = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow unnecessary nested blocks",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-lone-blocks"
                        },
                        schema: [],
                        messages: {
                            redundantBlock: "Block is redundant.",
                            redundantNestedBlock: "Nested block is redundant."
                        }
                    },
                    create (e1) {
                        const t = [];
                        let r;
                        const n = e1.sourceCode;
                        function s(t) {
                            const r = "BlockStatement" === t.parent.type || "StaticBlock" === t.parent.type ? "redundantNestedBlock" : "redundantBlock";
                            e1.report({
                                node: t,
                                messageId: r
                            });
                        }
                        function i(e1) {
                            return "BlockStatement" === e1.parent.type || "StaticBlock" === e1.parent.type || "Program" === e1.parent.type || "SwitchCase" === e1.parent.type && !(e1.parent.consequent[0] === e1 && 1 === e1.parent.consequent.length);
                        }
                        function o(e1) {
                            if (0 === t.length) return;
                            const r = e1.parent;
                            t[t.length - 1] === r && t.pop();
                        }
                        return r = {
                            BlockStatement (e1) {
                                i(e1) && s(e1);
                            }
                        }, e1.languageOptions.ecmaVersion >= 2015 && (r = {
                            BlockStatement (e1) {
                                i(e1) && t.push(e1);
                            },
                            "BlockStatement:exit" (e1) {
                                t.length > 0 && t[t.length - 1] === e1 ? (t.pop(), s(e1)) : "BlockStatement" !== e1.parent.type && "StaticBlock" !== e1.parent.type || 1 !== e1.parent.body.length || s(e1);
                            }
                        }, r.VariableDeclaration = function(e1) {
                            "let" !== e1.kind && "const" !== e1.kind || o(e1);
                        }, r.FunctionDeclaration = function(e1) {
                            n.getScope(e1).isStrict && o(e1);
                        }, r.ClassDeclaration = o), r;
                    }
                }), Cm),
            "no-lonely-if": ()=>(vm || (vm = 1, bm = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow `if` statements as the only statement in `else` blocks",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-lonely-if"
                        },
                        schema: [],
                        fixable: "code",
                        messages: {
                            unexpectedLonelyIf: "Unexpected if as the only statement in an else block."
                        }
                    },
                    create (e1) {
                        const t = e1.sourceCode;
                        return {
                            IfStatement (r) {
                                const n = r.parent, s = n.parent;
                                n && "BlockStatement" === n.type && 1 === n.body.length && s && "IfStatement" === s.type && n === s.alternate && e1.report({
                                    node: r,
                                    messageId: "unexpectedLonelyIf",
                                    fix (e1) {
                                        const s = t.getFirstToken(n), i = t.getLastToken(n), o = t.getTokenBefore(s), a = t.getTokenAfter(i), u = t.getLastToken(r.consequent), l = t.getText();
                                        return l.slice(s.range[1], r.range[0]).trim() || l.slice(r.range[1], i.range[0]).trim() || "BlockStatement" !== r.consequent.type && ";" !== u.value && a && (r.consequent.loc.end.line === a.loc.start.line || /^[([/+`-]/u.test(a.value) || "++" === u.value || "--" === u.value) ? null : e1.replaceTextRange([
                                            s.range[0],
                                            i.range[1]
                                        ], (o.range[1] === s.range[0] ? " " : "") + t.getText(r));
                                    }
                                });
                            }
                        };
                    }
                }), bm),
            "no-loop-func": ()=>XC(),
            "no-loss-of-precision": ()=>zC(),
            "no-magic-numbers": ()=>HC(),
            "no-misleading-character-class": ()=>(function() {
                    if ($m) return Mm;
                    $m = 1;
                    const { CALL: e1, CONSTRUCT: t, ReferenceTracker: r, getStringIfConstant: n } = Hi(), { RegExpParser: s, visitRegExpAST: i } = _C(), { isCombiningCharacter: o, isEmojiModifier: a, isRegionalIndicatorSymbol: u, isSurrogatePair: l } = JC(), c = Ll(), { isValidWithUnicodeFlag: p } = QC();
                    function f(e1) {
                        return /^\\u\{[\da-f]+\}$/iu.test(e1.raw);
                    }
                    const d = {
                        surrogatePairWithoutUFlag: (e1)=>e1.some((t, r)=>{
                                if (0 === r) return !1;
                                const n = e1[r - 1];
                                return l(n.value, t.value) && !f(n) && !f(t);
                            }),
                        surrogatePair: (e1)=>e1.some((t, r)=>{
                                if (0 === r) return !1;
                                const n = e1[r - 1];
                                return l(n.value, t.value) && (f(n) || f(t));
                            }),
                        combiningClass: (e1)=>e1.some((t, r)=>0 !== r && o(t.value) && !o(e1[r - 1].value)),
                        emojiModifier: (e1)=>e1.some((t, r)=>0 !== r && a(t.value) && !a(e1[r - 1].value)),
                        regionalIndicatorSymbol: (e1)=>e1.some((t, r)=>0 !== r && u(t.value) && u(e1[r - 1].value)),
                        zwj (e1) {
                            const t = e1.length - 1;
                            return e1.some((r, n)=>0 !== n && n !== t && 8205 === r.value && 8205 !== e1[n - 1].value && 8205 !== e1[n + 1].value);
                        }
                    }, h = Object.keys(d);
                    return Mm = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow characters which are made with multiple code points in character class syntax",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-misleading-character-class"
                            },
                            hasSuggestions: !0,
                            schema: [],
                            messages: {
                                surrogatePairWithoutUFlag: "Unexpected surrogate pair in character class. Use 'u' flag.",
                                surrogatePair: "Unexpected surrogate pair in character class.",
                                combiningClass: "Unexpected combined character in character class.",
                                emojiModifier: "Unexpected modified Emoji in character class.",
                                regionalIndicatorSymbol: "Unexpected national flag in character class.",
                                zwj: "Unexpected joined character sequence in character class.",
                                suggestUnicodeFlag: "Add unicode 'u' flag to regex."
                            }
                        },
                        create (o) {
                            const a = o.sourceCode, u = new s;
                            function l(e1, t, r, n) {
                                let s;
                                try {
                                    s = u.parsePattern(t, 0, t.length, {
                                        unicode: r.includes("u"),
                                        unicodeSets: r.includes("v")
                                    });
                                } catch  {
                                    return;
                                }
                                const a = new Set;
                                i(s, {
                                    onCharacterClassEnter (e1) {
                                        for (const t of function*(e1) {
                                            let t = [];
                                            for (const r of e1)switch(r.type){
                                                case "Character":
                                                    t.push(r);
                                                    break;
                                                case "CharacterClassRange":
                                                    t.push(r.min), yield t, t = [
                                                        r.max
                                                    ];
                                                    break;
                                                case "CharacterSet":
                                                case "CharacterClass":
                                                case "ClassStringDisjunction":
                                                case "ExpressionCharacterClass":
                                                    t.length > 0 && (yield t, t = []);
                                            }
                                            t.length > 0 && (yield t);
                                        }(e1.elements))for (const e1 of h)d[e1](t) && a.add(e1);
                                    }
                                });
                                for (const t of a){
                                    let r;
                                    "surrogatePairWithoutUFlag" === t && (r = [
                                        {
                                            messageId: "suggestUnicodeFlag",
                                            fix: n
                                        }
                                    ]), o.report({
                                        node: e1,
                                        messageId: t,
                                        suggest: r
                                    });
                                }
                            }
                            return {
                                "Literal[regex]" (e1) {
                                    l(e1, e1.regex.pattern, e1.regex.flags, (t)=>p(o.languageOptions.ecmaVersion, e1.regex.pattern) ? t.insertTextAfter(e1, "u") : null);
                                },
                                Program (s) {
                                    const i = a.getScope(s), u = new r(i);
                                    for (const { node: r } of u.iterateGlobalReferences({
                                        RegExp: {
                                            [e1]: !0,
                                            [t]: !0
                                        }
                                    })){
                                        const [e1, t] = r.arguments, s = n(e1, i), u = n(t, i);
                                        "string" == typeof s && l(r, s, u || "", (e1)=>{
                                            if (!p(o.languageOptions.ecmaVersion, s)) return null;
                                            if (1 === r.arguments.length) {
                                                const t = a.getLastToken(r, {
                                                    skip: 1
                                                });
                                                return e1.insertTextAfter(t, c.isCommaToken(t) ? ' "u",' : ', "u"');
                                            }
                                            if ("Literal" === t.type && "string" == typeof t.value || "TemplateLiteral" === t.type) {
                                                const r = [
                                                    t.range[0],
                                                    t.range[1] - 1
                                                ];
                                                return e1.insertTextAfterRange(r, "u");
                                            }
                                            return null;
                                        });
                                    }
                                }
                            };
                        }
                    }, Mm;
                })(),
            "no-mixed-operators": ()=>YC(),
            "no-mixed-requires": ()=>ZC(),
            "no-mixed-spaces-and-tabs": ()=>(Hm || (Hm = 1, zm = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "layout",
                        docs: {
                            description: "Disallow mixed spaces and tabs for indentation",
                            recommended: !0,
                            url: "https://eslint.org/docs/latest/rules/no-mixed-spaces-and-tabs"
                        },
                        schema: [
                            {
                                enum: [
                                    "smart-tabs",
                                    !0,
                                    !1
                                ]
                            }
                        ],
                        messages: {
                            mixedSpacesAndTabs: "Mixed spaces and tabs."
                        }
                    },
                    create (e1) {
                        const t = e1.sourceCode;
                        let r;
                        switch(e1.options[0]){
                            case !0:
                            case "smart-tabs":
                                r = !0;
                                break;
                            default:
                                r = !1;
                        }
                        return {
                            "Program:exit" (n) {
                                const s = t.lines, i = t.getAllComments(), o = new Set;
                                i.forEach((e1)=>{
                                    for(let t = e1.loc.start.line + 1; t <= e1.loc.end.line; t++)o.add(t);
                                });
                                let a = /^(?=( +|\t+))\1(?:\t| )/u;
                                r && (a = /^(?=(\t*))\1(?=( +))\2\t/u), s.forEach((r, s)=>{
                                    const i = a.exec(r);
                                    if (i) {
                                        const r = s + 1, a = {
                                            start: {
                                                line: r,
                                                column: i[0].length - 2
                                            },
                                            end: {
                                                line: r,
                                                column: i[0].length
                                            }
                                        };
                                        if (!o.has(r)) {
                                            const r = t.getNodeByRangeIndex(t.getIndexFromLoc(a.start));
                                            r && [
                                                "Literal",
                                                "TemplateElement"
                                            ].includes(r.type) || e1.report({
                                                node: n,
                                                loc: a,
                                                messageId: "mixedSpacesAndTabs"
                                            });
                                        }
                                    }
                                });
                            }
                        };
                    }
                }), zm),
            "no-multi-assign": ()=>(Qm || (Qm = 1, Jm = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow use of chained assignment expressions",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-multi-assign"
                        },
                        schema: [
                            {
                                type: "object",
                                properties: {
                                    ignoreNonDeclaration: {
                                        type: "boolean",
                                        default: !1
                                    }
                                },
                                additionalProperties: !1
                            }
                        ],
                        messages: {
                            unexpectedChain: "Unexpected chained assignment."
                        }
                    },
                    create (e1) {
                        const t = [
                            "VariableDeclarator > AssignmentExpression.init",
                            "PropertyDefinition > AssignmentExpression.value"
                        ];
                        return (e1.options[0] || {
                            ignoreNonDeclaration: !1
                        }).ignoreNonDeclaration || t.push("AssignmentExpression > AssignmentExpression.right"), {
                            [t] (t) {
                                e1.report({
                                    node: t,
                                    messageId: "unexpectedChain"
                                });
                            }
                        };
                    }
                }), Jm),
            "no-multi-spaces": ()=>(function() {
                    if (Zm) return Ym;
                    Zm = 1;
                    const e1 = Ll();
                    return Ym = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "layout",
                            docs: {
                                description: "Disallow multiple spaces",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-multi-spaces"
                            },
                            fixable: "whitespace",
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        exceptions: {
                                            type: "object",
                                            patternProperties: {
                                                "^([A-Z][a-z]*)+$": {
                                                    type: "boolean"
                                                }
                                            },
                                            additionalProperties: !1
                                        },
                                        ignoreEOLComments: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                multipleSpaces: "Multiple spaces found before '{{displayValue}}'."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode, n = t.options[0] || {}, s = n.ignoreEOLComments, i = Object.assign({
                                Property: !0
                            }, n.exceptions), o = Object.keys(i).some((e1)=>i[e1]);
                            function a(e1) {
                                const t = e1.value.split("\n"), r = t[0], n = `${r.slice(0, 12)}...`;
                                return 1 === t.length && r.length <= 12 ? r : n;
                            }
                            return {
                                Program () {
                                    r.tokensAndComments.forEach((n, u, l)=>{
                                        if (u === l.length - 1) return;
                                        const c = l[u + 1];
                                        if (!r.text.slice(n.range[1], c.range[0]).includes("  ") || n.loc.end.line < c.loc.start.line) return;
                                        if (s && e1.isCommentToken(c) && (u === l.length - 2 || c.loc.end.line < l[u + 2].loc.start.line)) return;
                                        if (o) {
                                            const e1 = r.getNodeByRangeIndex(c.range[0] - 1);
                                            if (e1 && i[e1.type]) return;
                                        }
                                        let p;
                                        p = "Block" === c.type ? `/*${a(c)}*/` : "Line" === c.type ? `//${a(c)}` : c.value, t.report({
                                            node: c,
                                            loc: {
                                                start: n.loc.end,
                                                end: c.loc.start
                                            },
                                            messageId: "multipleSpaces",
                                            data: {
                                                displayValue: p
                                            },
                                            fix: (e1)=>e1.replaceTextRange([
                                                    n.range[1],
                                                    c.range[0]
                                                ], " ")
                                        });
                                    });
                                }
                            };
                        }
                    }, Ym;
                })(),
            "no-multi-str": ()=>(function() {
                    if (tg) return eg;
                    tg = 1;
                    const e1 = Ll();
                    return eg = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow multiline strings",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-multi-str"
                            },
                            schema: [],
                            messages: {
                                multilineString: "Multiline support is limited to browsers supporting ES5 only."
                            }
                        },
                        create: (t)=>({
                                Literal (r) {
                                    e1.LINEBREAK_MATCHER.test(r.raw) && !function(e1) {
                                        return 0 === e1.type.indexOf("JSX");
                                    }(r.parent) && t.report({
                                        node: r,
                                        messageId: "multilineString"
                                    });
                                }
                            })
                    }, eg;
                })(),
            "no-multiple-empty-lines": ()=>(ng || (ng = 1, rg = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "layout",
                        docs: {
                            description: "Disallow multiple empty lines",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-multiple-empty-lines"
                        },
                        fixable: "whitespace",
                        schema: [
                            {
                                type: "object",
                                properties: {
                                    max: {
                                        type: "integer",
                                        minimum: 0
                                    },
                                    maxEOF: {
                                        type: "integer",
                                        minimum: 0
                                    },
                                    maxBOF: {
                                        type: "integer",
                                        minimum: 0
                                    }
                                },
                                required: [
                                    "max"
                                ],
                                additionalProperties: !1
                            }
                        ],
                        messages: {
                            blankBeginningOfFile: "Too many blank lines at the beginning of file. Max of {{max}} allowed.",
                            blankEndOfFile: "Too many blank lines at the end of file. Max of {{max}} allowed.",
                            consecutiveBlank: "More than {{max}} blank {{pluralizedLines}} not allowed."
                        }
                    },
                    create (e1) {
                        let t = 2, r = t, n = t;
                        e1.options.length && (t = e1.options[0].max, r = void 0 !== e1.options[0].maxEOF ? e1.options[0].maxEOF : t, n = void 0 !== e1.options[0].maxBOF ? e1.options[0].maxBOF : t);
                        const s = e1.sourceCode, i = "" === s.lines[s.lines.length - 1] ? s.lines.slice(0, -1) : s.lines, o = new Set;
                        return {
                            TemplateLiteral (e1) {
                                e1.quasis.forEach((e1)=>{
                                    for(let t = e1.loc.start.line; t < e1.loc.end.line; t++)o.add(t);
                                });
                            },
                            "Program:exit": (a)=>i.reduce((e1, t, r)=>((t.trim() || o.has(r + 1)) && e1.push(r + 1), e1), []).concat(i.length + 1).reduce((o, u)=>{
                                    let l, c;
                                    return 0 === o ? (l = "blankBeginningOfFile", c = n) : u === i.length + 1 ? (l = "blankEndOfFile", c = r) : (l = "consecutiveBlank", c = t), u - o - 1 > c && e1.report({
                                        node: a,
                                        loc: {
                                            start: {
                                                line: o + c + 1,
                                                column: 0
                                            },
                                            end: {
                                                line: u,
                                                column: 0
                                            }
                                        },
                                        messageId: l,
                                        data: {
                                            max: c,
                                            pluralizedLines: 1 === c ? "line" : "lines"
                                        },
                                        fix (e1) {
                                            const t = s.getIndexFromLoc({
                                                line: o + 1,
                                                column: 0
                                            }), r = u - c, n = r <= i.length ? s.getIndexFromLoc({
                                                line: r,
                                                column: 0
                                            }) : s.text.length;
                                            return e1.removeRange([
                                                t,
                                                n
                                            ]);
                                        }
                                    }), u;
                                }, 0)
                        };
                    }
                }), rg),
            "no-native-reassign": ()=>(ig || (ig = 1, sg = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow assignments to native objects or read-only global variables",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-native-reassign"
                        },
                        deprecated: !0,
                        replacedBy: [
                            "no-global-assign"
                        ],
                        schema: [
                            {
                                type: "object",
                                properties: {
                                    exceptions: {
                                        type: "array",
                                        items: {
                                            type: "string"
                                        },
                                        uniqueItems: !0
                                    }
                                },
                                additionalProperties: !1
                            }
                        ],
                        messages: {
                            nativeReassign: "Read-only global '{{name}}' should not be modified."
                        }
                    },
                    create (e1) {
                        const t = e1.options[0], r = t && t.exceptions || [], n = e1.sourceCode;
                        function s(t, r, n) {
                            const s = t.identifier;
                            !1 !== t.init || !t.isWrite() || 0 !== r && n[r - 1].identifier === s || e1.report({
                                node: s,
                                messageId: "nativeReassign",
                                data: s
                            });
                        }
                        function i(e1) {
                            !1 !== e1.writeable || r.includes(e1.name) || e1.references.forEach(s);
                        }
                        return {
                            Program (e1) {
                                n.getScope(e1).variables.forEach(i);
                            }
                        };
                    }
                }), sg),
            "no-negated-condition": ()=>(ag || (ag = 1, og = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow negated conditions",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-negated-condition"
                        },
                        schema: [],
                        messages: {
                            unexpectedNegated: "Unexpected negated condition."
                        }
                    },
                    create (e1) {
                        function t(e1) {
                            var t;
                            return "UnaryExpression" === (t = e1.test).type && "!" === t.operator || function(e1) {
                                return "BinaryExpression" === e1.type && ("!=" === e1.operator || "!==" === e1.operator);
                            }(e1.test);
                        }
                        return {
                            IfStatement (r) {
                                (function(e1) {
                                    return e1.alternate && "IfStatement" !== e1.alternate.type;
                                })(r) && t(r) && e1.report({
                                    node: r,
                                    messageId: "unexpectedNegated"
                                });
                            },
                            ConditionalExpression (r) {
                                t(r) && e1.report({
                                    node: r,
                                    messageId: "unexpectedNegated"
                                });
                            }
                        };
                    }
                }), og),
            "no-negated-in-lhs": ()=>(lg || (lg = 1, ug = {
                    meta: {
                        type: "problem",
                        docs: {
                            description: "Disallow negating the left operand in `in` expressions",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-negated-in-lhs"
                        },
                        replacedBy: [
                            "no-unsafe-negation"
                        ],
                        deprecated: !0,
                        schema: [],
                        messages: {
                            negatedLHS: "The 'in' expression's left operand is negated."
                        }
                    },
                    create: (e1)=>({
                            BinaryExpression (t) {
                                "in" === t.operator && "UnaryExpression" === t.left.type && "!" === t.left.operator && e1.report({
                                    node: t,
                                    messageId: "negatedLHS"
                                });
                            }
                        })
                }), ug),
            "no-nested-ternary": ()=>(pg || (pg = 1, cg = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow nested ternary expressions",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-nested-ternary"
                        },
                        schema: [],
                        messages: {
                            noNestedTernary: "Do not nest ternary expressions."
                        }
                    },
                    create: (e1)=>({
                            ConditionalExpression (t) {
                                "ConditionalExpression" !== t.alternate.type && "ConditionalExpression" !== t.consequent.type || e1.report({
                                    node: t,
                                    messageId: "noNestedTernary"
                                });
                            }
                        })
                }), cg),
            "no-new": ()=>(dg || (dg = 1, fg = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow `new` operators outside of assignments or comparisons",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-new"
                        },
                        schema: [],
                        messages: {
                            noNewStatement: "Do not use 'new' for side effects."
                        }
                    },
                    create: (e1)=>({
                            "ExpressionStatement > NewExpression" (t) {
                                e1.report({
                                    node: t.parent,
                                    messageId: "noNewStatement"
                                });
                            }
                        })
                }), fg),
            "no-new-func": ()=>(function() {
                    if (mg) return hg;
                    mg = 1;
                    const e1 = Ll(), t = new Set([
                        "apply",
                        "bind",
                        "call"
                    ]);
                    return hg = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow `new` operators with the `Function` object",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-new-func"
                            },
                            schema: [],
                            messages: {
                                noFunctionConstructor: "The Function constructor is eval."
                            }
                        },
                        create (r) {
                            const n = r.sourceCode;
                            return {
                                "Program:exit" (s) {
                                    const i = n.getScope(s).set.get("Function");
                                    i && 0 === i.defs.length && i.references.forEach((n)=>{
                                        const s = n.identifier, { parent: i } = s;
                                        let o;
                                        if (i) {
                                            if (s !== i.callee || "NewExpression" !== i.type && "CallExpression" !== i.type) {
                                                if ("MemberExpression" === i.type && s === i.object && t.has(e1.getStaticPropertyName(i))) {
                                                    const e1 = "ChainExpression" === i.parent.type ? i.parent : i;
                                                    "CallExpression" === e1.parent.type && e1.parent.callee === e1 && (o = e1.parent);
                                                }
                                            } else o = i;
                                        }
                                        o && r.report({
                                            node: o,
                                            messageId: "noFunctionConstructor"
                                        });
                                    });
                                }
                            };
                        }
                    }, hg;
                })(),
            "no-new-native-nonconstructor": ()=>(function() {
                    if (yg) return gg;
                    yg = 1;
                    const e1 = [
                        "Symbol",
                        "BigInt"
                    ];
                    return gg = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow `new` operators with global non-constructor functions",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-new-native-nonconstructor"
                            },
                            schema: [],
                            messages: {
                                noNewNonconstructor: "`{{name}}` cannot be called as a constructor."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode;
                            return {
                                "Program:exit" (n) {
                                    const s = r.getScope(n);
                                    for (const r of e1){
                                        const e1 = s.set.get(r);
                                        e1 && 0 === e1.defs.length && e1.references.forEach((e1)=>{
                                            const n = e1.identifier, s = n.parent;
                                            s && "NewExpression" === s.type && s.callee === n && t.report({
                                                node: n,
                                                messageId: "noNewNonconstructor",
                                                data: {
                                                    name: r
                                                }
                                            });
                                        });
                                    }
                                }
                            };
                        }
                    }, gg;
                })(),
            "no-new-object": ()=>(function() {
                    if (xg) return Eg;
                    xg = 1;
                    const e1 = Ll();
                    return Eg = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow `Object` constructors",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-new-object"
                            },
                            deprecated: !0,
                            replacedBy: [
                                "no-object-constructor"
                            ],
                            schema: [],
                            messages: {
                                preferLiteral: "The object literal notation {} is preferable."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode;
                            return {
                                NewExpression (n) {
                                    const s = e1.getVariableByName(r.getScope(n), n.callee.name);
                                    s && s.identifiers.length > 0 || "Object" === n.callee.name && t.report({
                                        node: n,
                                        messageId: "preferLiteral"
                                    });
                                }
                            };
                        }
                    }, Eg;
                })(),
            "no-new-require": ()=>(Sg || (Sg = 1, Cg = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "suggestion",
                        docs: {
                            description: "Disallow `new` operators with calls to `require`",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-new-require"
                        },
                        schema: [],
                        messages: {
                            noNewRequire: "Unexpected use of new with require."
                        }
                    },
                    create: (e1)=>({
                            NewExpression (t) {
                                "Identifier" === t.callee.type && "require" === t.callee.name && e1.report({
                                    node: t,
                                    messageId: "noNewRequire"
                                });
                            }
                        })
                }), Cg),
            "no-new-symbol": ()=>(vg || (vg = 1, bg = {
                    meta: {
                        type: "problem",
                        docs: {
                            description: "Disallow `new` operators with the `Symbol` object",
                            recommended: !0,
                            url: "https://eslint.org/docs/latest/rules/no-new-symbol"
                        },
                        schema: [],
                        messages: {
                            noNewSymbol: "`Symbol` cannot be called as a constructor."
                        }
                    },
                    create (e1) {
                        const t = e1.sourceCode;
                        return {
                            "Program:exit" (r) {
                                const n = t.getScope(r).set.get("Symbol");
                                n && 0 === n.defs.length && n.references.forEach((t)=>{
                                    const r = t.identifier, n = r.parent;
                                    n && "NewExpression" === n.type && n.callee === r && e1.report({
                                        node: r,
                                        messageId: "noNewSymbol"
                                    });
                                });
                            }
                        };
                    }
                }), bg),
            "no-new-wrappers": ()=>(function() {
                    if (Tg) return Ag;
                    Tg = 1;
                    const { getVariableByName: e1 } = Ll();
                    return Ag = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow `new` operators with the `String`, `Number`, and `Boolean` objects",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-new-wrappers"
                            },
                            schema: [],
                            messages: {
                                noConstructor: "Do not use {{fn}} as a constructor."
                            }
                        },
                        create (t) {
                            const { sourceCode: r } = t;
                            return {
                                NewExpression (n) {
                                    const { name: s } = n.callee;
                                    if ([
                                        "String",
                                        "Number",
                                        "Boolean"
                                    ].includes(s)) {
                                        const i = e1(r.getScope(n), s);
                                        i && 0 === i.identifiers.length && t.report({
                                            node: n,
                                            messageId: "noConstructor",
                                            data: {
                                                fn: s
                                            }
                                        });
                                    }
                                }
                            };
                        }
                    }, Ag;
                })(),
            "no-nonoctal-decimal-escape": ()=>(function() {
                    if (Dg) return Rg;
                    Dg = 1;
                    const e1 = /\\[89]/u;
                    function t(e1) {
                        return `\\u${e1.charCodeAt(0).toString(16).padStart(4, "0")}`;
                    }
                    return Rg = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow `\\8` and `\\9` escape sequences in string literals",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-nonoctal-decimal-escape"
                            },
                            hasSuggestions: !0,
                            schema: [],
                            messages: {
                                decimalEscape: "Don't use '{{decimalEscape}}' escape sequence.",
                                refactor: "Replace '{{original}}' with '{{replacement}}'. This maintains the current functionality.",
                                escapeBackslash: "Replace '{{original}}' with '{{replacement}}' to include the actual backslash character."
                            }
                        },
                        create (r) {
                            const n = r.sourceCode;
                            function s(e1, t, r) {
                                return {
                                    messageId: e1,
                                    data: {
                                        original: n.getText().slice(...t),
                                        replacement: r
                                    },
                                    fix: (e1)=>e1.replaceTextRange(t, r)
                                };
                            }
                            return {
                                Literal (i) {
                                    if ("string" != typeof i.value) return;
                                    if (!e1.test(i.raw)) return;
                                    const o = /(?:[^\\]|(?<previousEscape>\\.))*?(?<decimalEscape>\\[89])/suy;
                                    let a;
                                    for(; a = o.exec(i.raw);){
                                        const { previousEscape: e1, decimalEscape: o } = a.groups, u = i.range[0] + a.index + a[0].length, l = u - o.length, c = [
                                            l,
                                            u
                                        ], p = [];
                                        "\\0" === e1 ? p.push(s("refactor", [
                                            l - e1.length,
                                            u
                                        ], `${t("\0")}${o[1]}`), s("refactor", c, t(o[1]))) : p.push(s("refactor", c, o[1])), p.push(s("escapeBackslash", c, `\\${o}`)), r.report({
                                            node: i,
                                            loc: {
                                                start: n.getLocFromIndex(l),
                                                end: n.getLocFromIndex(u)
                                            },
                                            messageId: "decimalEscape",
                                            data: {
                                                decimalEscape: o
                                            },
                                            suggest: p
                                        });
                                    }
                                }
                            };
                        }
                    }, Rg;
                })(),
            "no-obj-calls": ()=>(function() {
                    if (_g) return wg;
                    _g = 1;
                    const { CALL: e1, CONSTRUCT: t, ReferenceTracker: r } = Hi(), n = Ll().getStaticPropertyName, s = [
                        "Atomics",
                        "JSON",
                        "Math",
                        "Reflect",
                        "Intl"
                    ];
                    function i(e1) {
                        return "ChainExpression" === e1.type ? i(e1.expression) : "MemberExpression" === e1.type ? n(e1) : e1.name;
                    }
                    return wg = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow calling global object properties as functions",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-obj-calls"
                            },
                            schema: [],
                            messages: {
                                unexpectedCall: "'{{name}}' is not a function.",
                                unexpectedRefCall: "'{{name}}' is reference to '{{ref}}', which is not a function."
                            }
                        },
                        create (n) {
                            const o = n.sourceCode;
                            return {
                                Program (a) {
                                    const u = o.getScope(a), l = new r(u), c = {};
                                    for (const r of s)c[r] = {
                                        [e1]: !0,
                                        [t]: !0
                                    };
                                    for (const { node: e1, path: t } of l.iterateGlobalReferences(c)){
                                        const r = i(e1.callee), s = t[0], o = r === s ? "unexpectedCall" : "unexpectedRefCall";
                                        n.report({
                                            node: e1,
                                            messageId: o,
                                            data: {
                                                name: r,
                                                ref: s
                                            }
                                        });
                                    }
                                }
                            };
                        }
                    }, wg;
                })(),
            "no-object-constructor": ()=>eS(),
            "no-octal": ()=>(Pg || (Pg = 1, Lg = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow octal literals",
                            recommended: !0,
                            url: "https://eslint.org/docs/latest/rules/no-octal"
                        },
                        schema: [],
                        messages: {
                            noOctal: "Octal literals should not be used."
                        }
                    },
                    create: (e1)=>({
                            Literal (t) {
                                "number" == typeof t.value && /^0[0-9]/u.test(t.raw) && e1.report({
                                    node: t,
                                    messageId: "noOctal"
                                });
                            }
                        })
                }), Lg),
            "no-octal-escape": ()=>(Fg || (Fg = 1, Ig = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow octal escape sequences in string literals",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-octal-escape"
                        },
                        schema: [],
                        messages: {
                            octalEscapeSequence: "Don't use octal: '\\{{sequence}}'. Use '\\u....' instead."
                        }
                    },
                    create: (e1)=>({
                            Literal (t) {
                                if ("string" != typeof t.value) return;
                                const r = t.raw.match(/^(?:[^\\]|\\.)*?\\([0-3][0-7]{1,2}|[4-7][0-7]|0(?=[89])|[1-7])/su);
                                r && e1.report({
                                    node: t,
                                    messageId: "octalEscapeSequence",
                                    data: {
                                        sequence: r[1]
                                    }
                                });
                            }
                        })
                }), Ig),
            "no-param-reassign": ()=>tS(),
            "no-path-concat": ()=>(jg || (jg = 1, Ug = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "suggestion",
                        docs: {
                            description: "Disallow string concatenation with `__dirname` and `__filename`",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-path-concat"
                        },
                        schema: [],
                        messages: {
                            usePathFunctions: "Use path.join() or path.resolve() instead of + to create paths."
                        }
                    },
                    create (e1) {
                        const t = /^__(?:dir|file)name$/u;
                        return {
                            BinaryExpression (r) {
                                const n = r.left, s = r.right;
                                "+" === r.operator && ("Identifier" === n.type && t.test(n.name) || "Identifier" === s.type && t.test(s.name)) && e1.report({
                                    node: r,
                                    messageId: "usePathFunctions"
                                });
                            }
                        };
                    }
                }), Ug),
            "no-plusplus": ()=>rS(),
            "no-process-env": ()=>($g || ($g = 1, Mg = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "suggestion",
                        docs: {
                            description: "Disallow the use of `process.env`",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-process-env"
                        },
                        schema: [],
                        messages: {
                            unexpectedProcessEnv: "Unexpected use of process.env."
                        }
                    },
                    create: (e1)=>({
                            MemberExpression (t) {
                                const r = t.object.name, n = t.property.name;
                                "process" === r && !t.computed && n && "env" === n && e1.report({
                                    node: t,
                                    messageId: "unexpectedProcessEnv"
                                });
                            }
                        })
                }), Mg),
            "no-process-exit": ()=>(Gg || (Gg = 1, qg = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "suggestion",
                        docs: {
                            description: "Disallow the use of `process.exit()`",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-process-exit"
                        },
                        schema: [],
                        messages: {
                            noProcessExit: "Don't use process.exit(); throw an error instead."
                        }
                    },
                    create: (e1)=>({
                            "CallExpression > MemberExpression.callee[object.name = 'process'][property.name = 'exit']" (t) {
                                e1.report({
                                    node: t.parent,
                                    messageId: "noProcessExit"
                                });
                            }
                        })
                }), qg),
            "no-promise-executor-return": ()=>nS(),
            "no-proto": ()=>(function() {
                    if (Hg) return zg;
                    Hg = 1;
                    const { getStaticPropertyName: e1 } = Ll();
                    return zg = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow the use of the `__proto__` property",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-proto"
                            },
                            schema: [],
                            messages: {
                                unexpectedProto: "The '__proto__' property is deprecated."
                            }
                        },
                        create: (t)=>({
                                MemberExpression (r) {
                                    "__proto__" === e1(r) && t.report({
                                        node: r,
                                        messageId: "unexpectedProto"
                                    });
                                }
                            })
                    }, zg;
                })(),
            "no-prototype-builtins": ()=>sS(),
            "no-redeclare": ()=>(function() {
                    if (Zg) return Yg;
                    Zg = 1;
                    const e1 = Ll();
                    return Yg = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow variable redeclaration",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-redeclare"
                            },
                            messages: {
                                redeclared: "'{{id}}' is already defined.",
                                redeclaredAsBuiltin: "'{{id}}' is already defined as a built-in global variable.",
                                redeclaredBySyntax: "'{{id}}' is already defined by a variable declaration."
                            },
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        builtinGlobals: {
                                            type: "boolean",
                                            default: !0
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ]
                        },
                        create (t) {
                            const r = Boolean(0 === t.options.length || t.options[0].builtinGlobals), n = t.sourceCode;
                            function* s(t) {
                                !r || "readonly" !== t.eslintImplicitGlobalSetting && "writable" !== t.eslintImplicitGlobalSetting || (yield {
                                    type: "builtin"
                                });
                                for (const e1 of t.identifiers)yield {
                                    type: "syntax",
                                    node: e1,
                                    loc: e1.loc
                                };
                                if (t.eslintExplicitGlobalComments) for (const r of t.eslintExplicitGlobalComments)yield {
                                    type: "comment",
                                    node: r,
                                    loc: e1.getNameLocationInGlobalDirectiveComment(n, r, t.name)
                                };
                            }
                            function i(e1) {
                                for (const r of e1.variables){
                                    const [e1, ...n] = s(r);
                                    if (0 === n.length) continue;
                                    const i = "builtin" === e1.type ? "redeclaredAsBuiltin" : "redeclaredBySyntax", o = {
                                        id: r.name
                                    };
                                    for (const { type: r, node: s, loc: a } of n){
                                        const n = r === e1.type ? "redeclared" : i;
                                        t.report({
                                            node: s,
                                            loc: a,
                                            messageId: n,
                                            data: o
                                        });
                                    }
                                }
                            }
                            function o(e1) {
                                const t = n.getScope(e1);
                                t.block === e1 && i(t);
                            }
                            return {
                                Program (e1) {
                                    const t = n.getScope(e1);
                                    i(t), "global" === t.type && t.childScopes[0] && t.block === t.childScopes[0].block && i(t.childScopes[0]);
                                },
                                FunctionDeclaration: o,
                                FunctionExpression: o,
                                ArrowFunctionExpression: o,
                                StaticBlock: o,
                                BlockStatement: o,
                                ForStatement: o,
                                ForInStatement: o,
                                ForOfStatement: o,
                                SwitchStatement: o
                            };
                        }
                    }, Yg;
                })(),
            "no-regex-spaces": ()=>(function() {
                    if (ty) return ey;
                    ty = 1;
                    const e1 = Ll(), t = _C(), r = new t.RegExpParser, n = / {2}/u;
                    function s(e1) {
                        return e1 && "Literal" === e1.type && "string" == typeof e1.value;
                    }
                    return ey = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow multiple spaces in regular expressions",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-regex-spaces"
                            },
                            schema: [],
                            fixable: "code",
                            messages: {
                                multipleSpaces: "Spaces are hard to count. Use {{{length}}}."
                            }
                        },
                        create (i) {
                            const o = i.sourceCode;
                            function a(e1, s, o, a, u) {
                                if (!n.test(o)) return;
                                const l = [];
                                let c;
                                try {
                                    c = r.parsePattern(s, 0, s.length, {
                                        unicode: u.includes("u"),
                                        unicodeSets: u.includes("v")
                                    });
                                } catch  {
                                    return;
                                }
                                t.visitRegExpAST(c, {
                                    onCharacterClassEnter (e1) {
                                        l.push(e1);
                                    }
                                });
                                const p = /( {2,})(?: [+*{?]|[^+*{?]|$)/gu;
                                let f;
                                for(; f = p.exec(s);){
                                    const { 1: { length: t }, index: r } = f;
                                    if (l.every(({ start: e1, end: t })=>r < e1 || t <= r)) return void i.report({
                                        node: e1,
                                        messageId: "multipleSpaces",
                                        data: {
                                            length: t
                                        },
                                        fix: (e1)=>s !== o ? null : e1.replaceTextRange([
                                                a + r,
                                                a + r + t
                                            ], ` {${t}}`)
                                    });
                                }
                            }
                            function u(t) {
                                const r = o.getScope(t), n = e1.getVariableByName(r, "RegExp"), i = n && n.defs.length > 0, u = t.arguments[0];
                                if ("Identifier" === t.callee.type && "RegExp" === t.callee.name && s(u) && !i) {
                                    const e1 = u.value, r = u.raw.slice(1, -1), n = u.range[0] + 1;
                                    let i;
                                    if (t.arguments.length < 2) i = "";
                                    else {
                                        const e1 = t.arguments[1];
                                        if (!s(e1)) return;
                                        i = e1.value;
                                    }
                                    a(t, e1, r, n, i);
                                }
                            }
                            return {
                                Literal: function(e1) {
                                    if (e1.regex) {
                                        const t = e1.regex.pattern, r = e1.raw.slice(1, e1.raw.lastIndexOf("/"));
                                        a(e1, t, r, e1.range[0] + 1, e1.regex.flags);
                                    }
                                },
                                CallExpression: u,
                                NewExpression: u
                            };
                        }
                    }, ey;
                })(),
            "no-restricted-exports": ()=>(function() {
                    if (ny) return ry;
                    ny = 1;
                    const e1 = Ll();
                    return ry = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow specified names in exports",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-restricted-exports"
                            },
                            schema: [
                                {
                                    anyOf: [
                                        {
                                            type: "object",
                                            properties: {
                                                restrictedNamedExports: {
                                                    type: "array",
                                                    items: {
                                                        type: "string"
                                                    },
                                                    uniqueItems: !0
                                                }
                                            },
                                            additionalProperties: !1
                                        },
                                        {
                                            type: "object",
                                            properties: {
                                                restrictedNamedExports: {
                                                    type: "array",
                                                    items: {
                                                        type: "string",
                                                        pattern: "^(?!default$)"
                                                    },
                                                    uniqueItems: !0
                                                },
                                                restrictDefaultExports: {
                                                    type: "object",
                                                    properties: {
                                                        direct: {
                                                            type: "boolean"
                                                        },
                                                        named: {
                                                            type: "boolean"
                                                        },
                                                        defaultFrom: {
                                                            type: "boolean"
                                                        },
                                                        namedFrom: {
                                                            type: "boolean"
                                                        },
                                                        namespaceFrom: {
                                                            type: "boolean"
                                                        }
                                                    },
                                                    additionalProperties: !1
                                                }
                                            },
                                            additionalProperties: !1
                                        }
                                    ]
                                }
                            ],
                            messages: {
                                restrictedNamed: "'{{name}}' is restricted from being used as an exported name.",
                                restrictedDefault: "Exporting 'default' is restricted."
                            }
                        },
                        create (t) {
                            const r = new Set(t.options[0] && t.options[0].restrictedNamedExports), n = t.options[0] && t.options[0].restrictDefaultExports, s = t.sourceCode;
                            function i(s) {
                                const i = e1.getModuleExportName(s);
                                if (r.has(i)) t.report({
                                    node: s,
                                    messageId: "restrictedNamed",
                                    data: {
                                        name: i
                                    }
                                });
                                else if ("default" === i) {
                                    if ("ExportAllDeclaration" === s.parent.type) n && n.namespaceFrom && t.report({
                                        node: s,
                                        messageId: "restrictedDefault"
                                    });
                                    else {
                                        const r = !!s.parent.parent.source, i = e1.getModuleExportName(s.parent.local);
                                        if (!r && n && n.named) return void t.report({
                                            node: s,
                                            messageId: "restrictedDefault"
                                        });
                                        r && n && ("default" === i && n.defaultFrom || "default" !== i && n.namedFrom) && t.report({
                                            node: s,
                                            messageId: "restrictedDefault"
                                        });
                                    }
                                }
                            }
                            return {
                                ExportAllDeclaration (e1) {
                                    e1.exported && i(e1.exported);
                                },
                                ExportDefaultDeclaration (e1) {
                                    n && n.direct && t.report({
                                        node: e1,
                                        messageId: "restrictedDefault"
                                    });
                                },
                                ExportNamedDeclaration (e1) {
                                    const t = e1.declaration;
                                    t ? "FunctionDeclaration" === t.type || "ClassDeclaration" === t.type ? i(t.id) : "VariableDeclaration" === t.type && s.getDeclaredVariables(t).map((e1)=>e1.defs.find((e1)=>e1.parent === t)).map((e1)=>e1.name).forEach(i) : e1.specifiers.map((e1)=>e1.exported).forEach(i);
                                }
                            };
                        }
                    }, ry;
                })(),
            "no-restricted-globals": ()=>(iy || (iy = 1, sy = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow specified global variables",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-restricted-globals"
                        },
                        schema: {
                            type: "array",
                            items: {
                                oneOf: [
                                    {
                                        type: "string"
                                    },
                                    {
                                        type: "object",
                                        properties: {
                                            name: {
                                                type: "string"
                                            },
                                            message: {
                                                type: "string"
                                            }
                                        },
                                        required: [
                                            "name"
                                        ],
                                        additionalProperties: !1
                                    }
                                ]
                            },
                            uniqueItems: !0,
                            minItems: 0
                        },
                        messages: {
                            defaultMessage: "Unexpected use of '{{name}}'.",
                            customMessage: "Unexpected use of '{{name}}'. {{customMessage}}"
                        }
                    },
                    create (e1) {
                        const t = e1.sourceCode;
                        if (0 === e1.options.length) return {};
                        const r = e1.options.reduce((e1, t)=>("string" == typeof t ? e1[t] = null : e1[t.name] = t.message, e1), {});
                        function n(t) {
                            const n = t.identifier.name, s = r[n], i = s ? "customMessage" : "defaultMessage";
                            e1.report({
                                node: t.identifier,
                                messageId: i,
                                data: {
                                    name: n,
                                    customMessage: s
                                }
                            });
                        }
                        function s(e1) {
                            return Object.prototype.hasOwnProperty.call(r, e1);
                        }
                        return {
                            Program (e1) {
                                const r = t.getScope(e1);
                                r.variables.forEach((e1)=>{
                                    !e1.defs.length && s(e1.name) && e1.references.forEach(n);
                                }), r.through.forEach((e1)=>{
                                    s(e1.identifier.name) && n(e1);
                                });
                            }
                        };
                    }
                }), sy),
            "no-restricted-imports": ()=>oS(),
            "no-restricted-modules": ()=>aS(),
            "no-restricted-properties": ()=>(function() {
                    if (dy) return fy;
                    dy = 1;
                    const e1 = Ll();
                    return fy = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow certain properties on certain objects",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-restricted-properties"
                            },
                            schema: {
                                type: "array",
                                items: {
                                    anyOf: [
                                        {
                                            type: "object",
                                            properties: {
                                                object: {
                                                    type: "string"
                                                },
                                                property: {
                                                    type: "string"
                                                },
                                                message: {
                                                    type: "string"
                                                }
                                            },
                                            additionalProperties: !1,
                                            required: [
                                                "object"
                                            ]
                                        },
                                        {
                                            type: "object",
                                            properties: {
                                                object: {
                                                    type: "string"
                                                },
                                                property: {
                                                    type: "string"
                                                },
                                                message: {
                                                    type: "string"
                                                }
                                            },
                                            additionalProperties: !1,
                                            required: [
                                                "property"
                                            ]
                                        }
                                    ]
                                },
                                uniqueItems: !0
                            },
                            messages: {
                                restrictedObjectProperty: "'{{objectName}}.{{propertyName}}' is restricted from being used.{{message}}",
                                restrictedProperty: "'{{propertyName}}' is restricted from being used.{{message}}"
                            }
                        },
                        create (t) {
                            const r = t.options;
                            if (0 === r.length) return {};
                            const n = new Map, s = new Map, i = new Map;
                            function o(e1, r, o) {
                                if (null === o) return;
                                const a = n.get(r), u = a ? a.get(o) : s.get(r), l = i.get(o);
                                if (u) {
                                    const n = u.message ? ` ${u.message}` : "";
                                    t.report({
                                        node: e1,
                                        messageId: "restrictedObjectProperty",
                                        data: {
                                            objectName: r,
                                            propertyName: o,
                                            message: n
                                        }
                                    });
                                } else if (l) {
                                    const r = l.message ? ` ${l.message}` : "";
                                    t.report({
                                        node: e1,
                                        messageId: "restrictedProperty",
                                        data: {
                                            propertyName: o,
                                            message: r
                                        }
                                    });
                                }
                            }
                            return r.forEach((e1)=>{
                                const t = e1.object, r = e1.property;
                                void 0 === t ? i.set(r, {
                                    message: e1.message
                                }) : void 0 === r ? s.set(t, {
                                    message: e1.message
                                }) : (n.has(t) || n.set(t, new Map), n.get(t).set(r, {
                                    message: e1.message
                                }));
                            }), {
                                MemberExpression (t) {
                                    o(t, t.object && t.object.name, e1.getStaticPropertyName(t));
                                },
                                ObjectPattern (t) {
                                    let r = null;
                                    "VariableDeclarator" === t.parent.type ? t.parent.init && "Identifier" === t.parent.init.type && (r = t.parent.init.name) : "AssignmentExpression" !== t.parent.type && "AssignmentPattern" !== t.parent.type || "Identifier" === t.parent.right.type && (r = t.parent.right.name), t.properties.forEach((n)=>{
                                        o(t, r, e1.getStaticPropertyName(n));
                                    });
                                }
                            };
                        }
                    }, fy;
                })(),
            "no-restricted-syntax": ()=>(my || (my = 1, hy = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow specified syntax",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-restricted-syntax"
                        },
                        schema: {
                            type: "array",
                            items: {
                                oneOf: [
                                    {
                                        type: "string"
                                    },
                                    {
                                        type: "object",
                                        properties: {
                                            selector: {
                                                type: "string"
                                            },
                                            message: {
                                                type: "string"
                                            }
                                        },
                                        required: [
                                            "selector"
                                        ],
                                        additionalProperties: !1
                                    }
                                ]
                            },
                            uniqueItems: !0,
                            minItems: 0
                        },
                        messages: {
                            restrictedSyntax: "{{message}}"
                        }
                    },
                    create: (e1)=>e1.options.reduce((t, r)=>{
                            const n = "string" == typeof r, s = !n && Boolean(r.message), i = n ? r : r.selector, o = s ? r.message : `Using '${i}' is not allowed.`;
                            return Object.assign(t, {
                                [i] (t) {
                                    e1.report({
                                        node: t,
                                        messageId: "restrictedSyntax",
                                        data: {
                                            message: o
                                        }
                                    });
                                }
                            });
                        }, {})
                }), hy),
            "no-return-assign": ()=>(function() {
                    if (yy) return gy;
                    yy = 1;
                    const e1 = Ll(), t = /^(?:[a-zA-Z]+?Statement|ArrowFunctionExpression|FunctionExpression|ClassExpression)$/u;
                    return gy = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow assignment operators in `return` statements",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-return-assign"
                            },
                            schema: [
                                {
                                    enum: [
                                        "except-parens",
                                        "always"
                                    ]
                                }
                            ],
                            messages: {
                                returnAssignment: "Return statement should not contain assignment.",
                                arrowAssignment: "Arrow function should not return assignment."
                            }
                        },
                        create (r) {
                            const n = "except-parens" !== (r.options[0] || "except-parens"), s = r.sourceCode;
                            return {
                                AssignmentExpression (i) {
                                    if (!n && e1.isParenthesised(s, i)) return;
                                    let o = i, a = o.parent;
                                    for(; a && !t.test(a.type);)o = a, a = a.parent;
                                    a && "ReturnStatement" === a.type ? r.report({
                                        node: a,
                                        messageId: "returnAssignment"
                                    }) : a && "ArrowFunctionExpression" === a.type && a.body === o && r.report({
                                        node: a,
                                        messageId: "arrowAssignment"
                                    });
                                }
                            };
                        }
                    }, gy;
                })(),
            "no-return-await": ()=>uS(),
            "no-script-url": ()=>(function() {
                    if (Sy) return Cy;
                    Sy = 1;
                    const e1 = Ll();
                    return Cy = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow `javascript:` urls",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-script-url"
                            },
                            schema: [],
                            messages: {
                                unexpectedScriptURL: "Script URL is a form of eval."
                            }
                        },
                        create (t) {
                            function r(r) {
                                const n = e1.getStaticStringValue(r);
                                "string" == typeof n && 0 === n.toLowerCase().indexOf("javascript:") && t.report({
                                    node: r,
                                    messageId: "unexpectedScriptURL"
                                });
                            }
                            return {
                                Literal (e1) {
                                    e1.value && "string" == typeof e1.value && r(e1);
                                },
                                TemplateLiteral (e1) {
                                    e1.parent && "TaggedTemplateExpression" === e1.parent.type || r(e1);
                                }
                            };
                        }
                    }, Cy;
                })(),
            "no-self-assign": ()=>lS(),
            "no-self-compare": ()=>cS(),
            "no-sequences": ()=>pS(),
            "no-setter-return": ()=>fS(),
            "no-shadow": ()=>(function() {
                    if (By) return ky;
                    By = 1;
                    const e1 = Ll(), t = new Set([
                        "ArrowFunctionExpression",
                        "FunctionExpression"
                    ]), r = new Set([
                        "CallExpression"
                    ]), n = /^For(?:In|Of)Statement$/u, s = /^(?:(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression|CatchClause|ImportDeclaration|ExportNamedDeclaration)$/u;
                    return ky = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow variable declarations from shadowing variables declared in the outer scope",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-shadow"
                            },
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        builtinGlobals: {
                                            type: "boolean",
                                            default: !1
                                        },
                                        hoist: {
                                            enum: [
                                                "all",
                                                "functions",
                                                "never"
                                            ],
                                            default: "functions"
                                        },
                                        allow: {
                                            type: "array",
                                            items: {
                                                type: "string"
                                            }
                                        },
                                        ignoreOnInitialization: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                noShadow: "'{{name}}' is already declared in the upper scope on line {{shadowedLine}} column {{shadowedColumn}}.",
                                noShadowGlobal: "'{{name}}' is already a global variable."
                            }
                        },
                        create (i) {
                            const o = {
                                builtinGlobals: i.options[0] && i.options[0].builtinGlobals,
                                hoist: i.options[0] && i.options[0].hoist || "functions",
                                allow: i.options[0] && i.options[0].allow || [],
                                ignoreOnInitialization: i.options[0] && i.options[0].ignoreOnInitialization
                            }, a = i.sourceCode;
                            function u(e1, t) {
                                return e1 && e1.range[0] <= t && t <= e1.range[1];
                            }
                            function l(e1, i) {
                                const o = i.defs[0];
                                if (!o) return !1;
                                const { variableScope: a } = e1.scope;
                                if (!t.has(a.block.type) || function(e1) {
                                    const t = e1.upper;
                                    return "function-expression-name" === t.type ? t.upper : t;
                                }(a) !== i.scope) return !1;
                                const l = a.block, { parent: c } = l, p = function(e1, t) {
                                    let r = e1;
                                    for(; r && !t(r);)r = r.parent;
                                    return r;
                                }(c, (e1)=>r.has(e1.type));
                                if (!p) return !1;
                                let f = o.name;
                                const d = p.range[1];
                                for(; f;){
                                    if ("VariableDeclarator" === f.type) {
                                        if (u(f.init, d)) return !0;
                                        if (n.test(f.parent.parent.type) && u(f.parent.parent.right, d)) return !0;
                                        break;
                                    }
                                    if ("AssignmentPattern" === f.type) {
                                        if (u(f.right, d)) return !0;
                                    } else if (s.test(f.type)) break;
                                    f = f.parent;
                                }
                                return !1;
                            }
                            function c(e1) {
                                return o.allow.includes(e1.name);
                            }
                            function p(e1) {
                                const t = e1.scope.block;
                                return "ClassDeclaration" === t.type && t.id === e1.identifiers[0];
                            }
                            function f(e1, t) {
                                const r = t.scope, n = t.defs[0], s = n && n.parent && n.parent.range, i = e1.scope, o = e1.defs[0], a = o && o.name.range;
                                return s && a && s[0] < a[0] && a[1] < s[1] && ("FunctionName" === o.type && "FunctionExpression" === o.node.type || "ClassExpression" === o.node.type) && r === i.upper;
                            }
                            function d(e1) {
                                const t = e1.defs[0];
                                return t && t.name.range;
                            }
                            function h(e1) {
                                const t = e1.identifiers[0];
                                let r;
                                return r = t ? {
                                    global: !1,
                                    line: t.loc.start.line,
                                    column: t.loc.start.column + 1
                                } : {
                                    global: !0
                                }, r;
                            }
                            function m(e1, t) {
                                const r = t.defs[0], n = d(e1), s = d(t);
                                return n && s && n[1] < s[0] && ("functions" !== o.hoist || !r || "FunctionDeclaration" !== r.node.type);
                            }
                            function g(t) {
                                const r = t.variables;
                                for(let n = 0; n < r.length; ++n){
                                    const s = r[n];
                                    if (0 === s.identifiers.length || p(s) || c(s)) continue;
                                    const a = e1.getVariableByName(t.upper, s.name);
                                    if (a && (a.identifiers.length > 0 || o.builtinGlobals && "writeable" in a) && !f(s, a) && (!o.ignoreOnInitialization || !l(s, a)) && ("all" === o.hoist || !m(s, a))) {
                                        const e1 = h(a), t = e1.global ? "noShadowGlobal" : "noShadow", r = {
                                            name: s.name
                                        };
                                        e1.global || (r.shadowedLine = e1.line, r.shadowedColumn = e1.column), i.report({
                                            node: s.identifiers[0],
                                            messageId: t,
                                            data: r
                                        });
                                    }
                                }
                            }
                            return {
                                "Program:exit" (e1) {
                                    const t = a.getScope(e1).childScopes.slice();
                                    for(; t.length;){
                                        const e1 = t.pop();
                                        t.push(...e1.childScopes), g(e1);
                                    }
                                }
                            };
                        }
                    }, ky;
                })(),
            "no-shadow-restricted-names": ()=>(function() {
                    if (Py) return Ly;
                    function e1(e1) {
                        return "undefined" === e1.name && e1.references.every((e1)=>!e1.isWrite()) && e1.defs.every((e1)=>"VariableDeclarator" === e1.node.type && null === e1.node.init);
                    }
                    return Py = 1, Ly = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow identifiers from shadowing restricted names",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-shadow-restricted-names"
                            },
                            schema: [],
                            messages: {
                                shadowingRestrictedName: "Shadowing of global property '{{name}}'."
                            }
                        },
                        create (t) {
                            const r = new Set([
                                "undefined",
                                "NaN",
                                "Infinity",
                                "arguments",
                                "eval"
                            ]), n = t.sourceCode;
                            return {
                                "VariableDeclaration, :function, CatchClause" (s) {
                                    for (const i of n.getDeclaredVariables(s))i.defs.length > 0 && r.has(i.name) && !e1(i) && t.report({
                                        node: i.defs[0].name,
                                        messageId: "shadowingRestrictedName",
                                        data: {
                                            name: i.name
                                        }
                                    });
                                }
                            };
                        }
                    }, Ly;
                })(),
            "no-spaced-func": ()=>(Fy || (Fy = 1, Iy = {
                    meta: {
                        type: "layout",
                        docs: {
                            description: "Disallow spacing between function identifiers and their applications (deprecated)",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-spaced-func"
                        },
                        deprecated: !0,
                        replacedBy: [
                            "func-call-spacing"
                        ],
                        fixable: "whitespace",
                        schema: [],
                        messages: {
                            noSpacedFunction: "Unexpected space between function name and paren."
                        }
                    },
                    create (e1) {
                        const t = e1.sourceCode;
                        function r(r) {
                            const n = t.getLastToken(r.callee);
                            let s = n, i = t.getTokenAfter(n);
                            for(; i && i.range[1] < r.range[1] && "(" !== i.value;)s = i, i = t.getTokenAfter(i);
                            i && i.range[1] < r.range[1] && t.isSpaceBetweenTokens(s, i) && e1.report({
                                node: r,
                                loc: n.loc.start,
                                messageId: "noSpacedFunction",
                                fix: (e1)=>e1.removeRange([
                                        s.range[1],
                                        i.range[0]
                                    ])
                            });
                        }
                        return {
                            CallExpression: r,
                            NewExpression: r
                        };
                    }
                }), Iy),
            "no-sparse-arrays": ()=>(Oy || (Oy = 1, Ny = {
                    meta: {
                        type: "problem",
                        docs: {
                            description: "Disallow sparse arrays",
                            recommended: !0,
                            url: "https://eslint.org/docs/latest/rules/no-sparse-arrays"
                        },
                        schema: [],
                        messages: {
                            unexpectedSparseArray: "Unexpected comma in middle of array."
                        }
                    },
                    create: (e1)=>({
                            ArrayExpression (t) {
                                t.elements.includes(null) && e1.report({
                                    node: t,
                                    messageId: "unexpectedSparseArray"
                                });
                            }
                        })
                }), Ny),
            "no-sync": ()=>(jy || (jy = 1, Uy = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "suggestion",
                        docs: {
                            description: "Disallow synchronous methods",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-sync"
                        },
                        schema: [
                            {
                                type: "object",
                                properties: {
                                    allowAtRootLevel: {
                                        type: "boolean",
                                        default: !1
                                    }
                                },
                                additionalProperties: !1
                            }
                        ],
                        messages: {
                            noSync: "Unexpected sync method: '{{propertyName}}'."
                        }
                    },
                    create (e1) {
                        const t = e1.options[0] && e1.options[0].allowAtRootLevel ? ":function MemberExpression[property.name=/.*Sync$/]" : "MemberExpression[property.name=/.*Sync$/]";
                        return {
                            [t] (t) {
                                e1.report({
                                    node: t,
                                    messageId: "noSync",
                                    data: {
                                        propertyName: t.property.name
                                    }
                                });
                            }
                        };
                    }
                }), Uy),
            "no-tabs": ()=>(function() {
                    if (Ky) return Vy;
                    Ky = 1;
                    const e1 = /\t+/gu, t = /\S/u;
                    return Vy = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "layout",
                            docs: {
                                description: "Disallow all tabs",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-tabs"
                            },
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        allowIndentationTabs: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                unexpectedTab: "Unexpected tab character."
                            }
                        },
                        create (r) {
                            const n = r.sourceCode, s = r.options && r.options[0] && r.options[0].allowIndentationTabs;
                            return {
                                Program (i) {
                                    n.getLines().forEach((n, o)=>{
                                        let a;
                                        for(; null !== (a = e1.exec(n));)s && !t.test(n.slice(0, a.index)) || r.report({
                                            node: i,
                                            loc: {
                                                start: {
                                                    line: o + 1,
                                                    column: a.index
                                                },
                                                end: {
                                                    line: o + 1,
                                                    column: a.index + a[0].length
                                                }
                                            },
                                            messageId: "unexpectedTab"
                                        });
                                    });
                                }
                            };
                        }
                    }, Vy;
                })(),
            "no-template-curly-in-string": ()=>($y || ($y = 1, My = {
                    meta: {
                        type: "problem",
                        docs: {
                            description: "Disallow template literal placeholder syntax in regular strings",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-template-curly-in-string"
                        },
                        schema: [],
                        messages: {
                            unexpectedTemplateExpression: "Unexpected template string expression."
                        }
                    },
                    create (e1) {
                        const t = /\$\{[^}]+\}/u;
                        return {
                            Literal (r) {
                                "string" == typeof r.value && t.test(r.value) && e1.report({
                                    node: r,
                                    messageId: "unexpectedTemplateExpression"
                                });
                            }
                        };
                    }
                }), My),
            "no-ternary": ()=>(Gy || (Gy = 1, qy = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow ternary operators",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-ternary"
                        },
                        schema: [],
                        messages: {
                            noTernaryOperator: "Ternary operator used."
                        }
                    },
                    create: (e1)=>({
                            ConditionalExpression (t) {
                                e1.report({
                                    node: t,
                                    messageId: "noTernaryOperator"
                                });
                            }
                        })
                }), qy),
            "no-this-before-super": ()=>dS(),
            "no-throw-literal": ()=>(function() {
                    if (Hy) return zy;
                    Hy = 1;
                    const e1 = Ll();
                    return zy = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow throwing literals as exceptions",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-throw-literal"
                            },
                            schema: [],
                            messages: {
                                object: "Expected an error object to be thrown.",
                                undef: "Do not throw undefined."
                            }
                        },
                        create: (t)=>({
                                ThrowStatement (r) {
                                    e1.couldBeError(r.argument) ? "Identifier" === r.argument.type && "undefined" === r.argument.name && t.report({
                                        node: r,
                                        messageId: "undef"
                                    }) : t.report({
                                        node: r,
                                        messageId: "object"
                                    });
                                }
                            })
                    }, zy;
                })(),
            "no-trailing-spaces": ()=>hS(),
            "no-undef": ()=>(Zy || (Zy = 1, Yy = {
                    meta: {
                        type: "problem",
                        docs: {
                            description: "Disallow the use of undeclared variables unless mentioned in `/*global */` comments",
                            recommended: !0,
                            url: "https://eslint.org/docs/latest/rules/no-undef"
                        },
                        schema: [
                            {
                                type: "object",
                                properties: {
                                    typeof: {
                                        type: "boolean",
                                        default: !1
                                    }
                                },
                                additionalProperties: !1
                            }
                        ],
                        messages: {
                            undef: "'{{name}}' is not defined."
                        }
                    },
                    create (e1) {
                        const t = e1.options[0], r = t && !0 === t.typeof || !1, n = e1.sourceCode;
                        return {
                            "Program:exit" (t) {
                                n.getScope(t).through.forEach((t)=>{
                                    const n = t.identifier;
                                    !r && function(e1) {
                                        const t = e1.parent;
                                        return "UnaryExpression" === t.type && "typeof" === t.operator;
                                    }(n) || e1.report({
                                        node: n,
                                        messageId: "undef",
                                        data: n
                                    });
                                });
                            }
                        };
                    }
                }), Yy),
            "no-undef-init": ()=>(function() {
                    if (tE) return eE;
                    tE = 1;
                    const e1 = Ll();
                    return eE = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow initializing variables to `undefined`",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-undef-init"
                            },
                            schema: [],
                            fixable: "code",
                            messages: {
                                unnecessaryUndefinedInit: "It's not necessary to initialize '{{name}}' to undefined."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode;
                            return {
                                VariableDeclarator (n) {
                                    const s = r.getText(n.id), i = n.init && n.init.name, o = r.getScope(n), a = e1.getVariableByName(o, "undefined"), u = a && a.defs.length > 0, l = r.getLastToken(n);
                                    "undefined" !== i || "const" === n.parent.kind || u || t.report({
                                        node: n,
                                        messageId: "unnecessaryUndefinedInit",
                                        data: {
                                            name: s
                                        },
                                        fix: (e1)=>"var" === n.parent.kind || "ArrayPattern" === n.id.type || "ObjectPattern" === n.id.type || r.commentsExistBetween(n.id, l) ? null : e1.removeRange([
                                                n.id.range[1],
                                                n.range[1]
                                            ])
                                    });
                                }
                            };
                        }
                    }, eE;
                })(),
            "no-undefined": ()=>(nE || (nE = 1, rE = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow the use of `undefined` as an identifier",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-undefined"
                        },
                        schema: [],
                        messages: {
                            unexpectedUndefined: "Unexpected use of undefined."
                        }
                    },
                    create (e1) {
                        const t = e1.sourceCode;
                        function r(t) {
                            e1.report({
                                node: t,
                                messageId: "unexpectedUndefined"
                            });
                        }
                        function n(e1) {
                            const t = e1.set.get("undefined");
                            if (!t) return;
                            const n = t.references, s = t.defs;
                            n.filter((e1)=>!e1.init).forEach((e1)=>r(e1.identifier)), s.forEach((e1)=>r(e1.name));
                        }
                        return {
                            "Program:exit" (e1) {
                                const r = [
                                    t.getScope(e1)
                                ];
                                for(; r.length;){
                                    const e1 = r.pop();
                                    r.push(...e1.childScopes), n(e1);
                                }
                            }
                        };
                    }
                }), rE),
            "no-underscore-dangle": ()=>mS(),
            "no-unexpected-multiline": ()=>(function() {
                    if (aE) return oE;
                    aE = 1;
                    const e1 = Ll();
                    return oE = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow confusing multiline expressions",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-unexpected-multiline"
                            },
                            schema: [],
                            messages: {
                                function: "Unexpected newline between function and ( of function call.",
                                property: "Unexpected newline between object and [ of property access.",
                                taggedTemplate: "Unexpected newline between template tag and template literal.",
                                division: "Unexpected newline between numerator and division operator."
                            }
                        },
                        create (t) {
                            const r = /^[gimsuy]+$/u, n = t.sourceCode;
                            function s(r, s) {
                                const i = n.getTokenAfter(r, e1.isNotClosingParenToken), o = n.getTokenBefore(i);
                                i.loc.start.line !== o.loc.end.line && t.report({
                                    node: r,
                                    loc: i.loc,
                                    messageId: s
                                });
                            }
                            return {
                                MemberExpression (e1) {
                                    e1.computed && !e1.optional && s(e1.object, "property");
                                },
                                TaggedTemplateExpression (e1) {
                                    const { quasi: r } = e1;
                                    n.getTokenBefore(r).loc.end.line !== r.loc.start.line && t.report({
                                        node: e1,
                                        loc: {
                                            start: r.loc.start,
                                            end: {
                                                line: r.loc.start.line,
                                                column: r.loc.start.column + 1
                                            }
                                        },
                                        messageId: "taggedTemplate"
                                    });
                                },
                                CallExpression (e1) {
                                    0 === e1.arguments.length || e1.optional || s(e1.callee, "function");
                                },
                                "BinaryExpression[operator='/'] > BinaryExpression[operator='/'].left" (e1) {
                                    const t = n.getTokenAfter(e1, (e1)=>"/" === e1.value), i = n.getTokenAfter(t);
                                    "Identifier" === i.type && r.test(i.value) && t.range[1] === i.range[0] && s(e1.left, "division");
                                }
                            };
                        }
                    }, oE;
                })(),
            "no-unmodified-loop-condition": ()=>gS(),
            "no-unneeded-ternary": ()=>yS(),
            "no-unreachable": ()=>(function() {
                    if (dE) return fE;
                    function e1(e1) {
                        return Boolean(e1.init);
                    }
                    dE = 1;
                    class t {
                        constructor(e1){
                            this.sourceCode = e1, this.startNode = null, this.endNode = null;
                        }
                        get location() {
                            return {
                                start: this.startNode.loc.start,
                                end: this.endNode.loc.end
                            };
                        }
                        get isEmpty() {
                            return !(this.startNode && this.endNode);
                        }
                        contains(e1) {
                            return e1.range[0] >= this.startNode.range[0] && e1.range[1] <= this.endNode.range[1];
                        }
                        isConsecutive(e1) {
                            return this.contains(this.sourceCode.getTokenBefore(e1));
                        }
                        merge(e1) {
                            this.endNode = e1;
                        }
                        reset(e1) {
                            this.startNode = this.endNode = e1;
                        }
                    }
                    return fE = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow unreachable code after `return`, `throw`, `continue`, and `break` statements",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-unreachable"
                            },
                            schema: [],
                            messages: {
                                unreachableCode: "Unreachable code."
                            }
                        },
                        create (r) {
                            let n = null;
                            const s = new t(r.sourceCode), i = [];
                            let o = new Set;
                            function a(e1) {
                                let t = null;
                                if (e1 && ("PropertyDefinition" === e1.type || function(e1) {
                                    for (const t of e1)if (t.reachable) return !1;
                                    return !0;
                                }(o))) {
                                    if (s.isEmpty) return void s.reset(e1);
                                    if (s.contains(e1)) return;
                                    if (s.isConsecutive(e1)) return void s.merge(e1);
                                    t = e1;
                                }
                                s.isEmpty || r.report({
                                    messageId: "unreachableCode",
                                    loc: s.location,
                                    node: s.startNode
                                }), s.reset(t);
                            }
                            return {
                                onCodePathStart () {
                                    i.push(o), o = new Set;
                                },
                                onCodePathEnd () {
                                    o = i.pop();
                                },
                                onUnreachableCodePathSegmentStart (e1) {
                                    o.add(e1);
                                },
                                onUnreachableCodePathSegmentEnd (e1) {
                                    o.delete(e1);
                                },
                                onCodePathSegmentEnd (e1) {
                                    o.delete(e1);
                                },
                                onCodePathSegmentStart (e1) {
                                    o.add(e1);
                                },
                                BlockStatement: a,
                                BreakStatement: a,
                                ClassDeclaration: a,
                                ContinueStatement: a,
                                DebuggerStatement: a,
                                DoWhileStatement: a,
                                ExpressionStatement: a,
                                ForInStatement: a,
                                ForOfStatement: a,
                                ForStatement: a,
                                IfStatement: a,
                                ImportDeclaration: a,
                                LabeledStatement: a,
                                ReturnStatement: a,
                                SwitchStatement: a,
                                ThrowStatement: a,
                                TryStatement: a,
                                VariableDeclaration (t) {
                                    ("var" !== t.kind || t.declarations.some(e1)) && a(t);
                                },
                                WhileStatement: a,
                                WithStatement: a,
                                ExportNamedDeclaration: a,
                                ExportDefaultDeclaration: a,
                                ExportAllDeclaration: a,
                                "Program:exit" () {
                                    a();
                                },
                                "MethodDefinition[kind='constructor']" () {
                                    n = {
                                        upper: n,
                                        hasSuperCall: !1
                                    };
                                },
                                "MethodDefinition[kind='constructor']:exit" (e1) {
                                    const { hasSuperCall: t } = n;
                                    if (n = n.upper, !e1.value.body) return;
                                    const r = e1.parent.parent;
                                    if (r.superClass && !t) for (const e1 of r.body.body)"PropertyDefinition" !== e1.type || e1.static || a(e1);
                                },
                                "CallExpression > Super.callee" () {
                                    n && (n.hasSuperCall = !0);
                                }
                            };
                        }
                    }, fE;
                })(),
            "no-unreachable-loop": ()=>(function() {
                    if (mE) return hE;
                    mE = 1;
                    const e1 = [
                        "WhileStatement",
                        "DoWhileStatement",
                        "ForStatement",
                        "ForInStatement",
                        "ForOfStatement"
                    ];
                    return hE = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow loops with a body that allows only one iteration",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-unreachable-loop"
                            },
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        ignore: {
                                            type: "array",
                                            items: {
                                                enum: e1
                                            },
                                            uniqueItems: !0
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                invalid: "Invalid loop. Its body allows only one iteration."
                            }
                        },
                        create (t) {
                            const r = t.options[0] && t.options[0].ignore || [], n = (a = r, e1.filter((e1)=>!a.includes(e1))), s = n.join(","), i = new Map, o = new Set;
                            var a;
                            const u = [];
                            let l = new Set;
                            return {
                                onCodePathStart () {
                                    u.push(l), l = new Set;
                                },
                                onCodePathEnd () {
                                    l = u.pop();
                                },
                                onUnreachableCodePathSegmentStart (e1) {
                                    l.add(e1);
                                },
                                onUnreachableCodePathSegmentEnd (e1) {
                                    l.delete(e1);
                                },
                                onCodePathSegmentEnd (e1) {
                                    l.delete(e1);
                                },
                                onCodePathSegmentStart (e1, t) {
                                    if (l.add(e1), function(e1) {
                                        const t = e1.parent;
                                        if (t) switch(t.type){
                                            case "WhileStatement":
                                                return e1 === t.test;
                                            case "DoWhileStatement":
                                                return e1 === t.body;
                                            case "ForStatement":
                                                return e1 === (t.update || t.test || t.body);
                                            case "ForInStatement":
                                            case "ForOfStatement":
                                                return e1 === t.left;
                                        }
                                        return !1;
                                    }(t)) {
                                        const r = t.parent;
                                        i.set(e1, r);
                                    }
                                },
                                onCodePathSegmentLoop (e1, t, r) {
                                    const n = i.get(t);
                                    r !== n && "ContinueStatement" !== r.type || o.delete(n);
                                },
                                [s] (e1) {
                                    (function(e1) {
                                        for (const t of e1)if (t.reachable) return !0;
                                        return !1;
                                    })(l) && o.add(e1);
                                },
                                "Program:exit" () {
                                    o.forEach((e1)=>t.report({
                                            node: e1,
                                            messageId: "invalid"
                                        }));
                                }
                            };
                        }
                    }, hE;
                })(),
            "no-unsafe-finally": ()=>ES(),
            "no-unsafe-negation": ()=>(function() {
                    if (xE) return EE;
                    xE = 1;
                    const e1 = Ll();
                    return EE = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow negating the left operand of relational operators",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-unsafe-negation"
                            },
                            hasSuggestions: !0,
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        enforceForOrderingRelations: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            fixable: null,
                            messages: {
                                unexpected: "Unexpected negating the left operand of '{{operator}}' operator.",
                                suggestNegatedExpression: "Negate '{{operator}}' expression instead of its left operand. This changes the current behavior.",
                                suggestParenthesisedNegation: "Wrap negation in '()' to make the intention explicit. This preserves the current behavior."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode, n = !0 === (t.options[0] || {}).enforceForOrderingRelations;
                            return {
                                BinaryExpression (s) {
                                    const i = s.operator, o = n && ("<" === (a = i) || ">" === a || ">=" === a || "<=" === a);
                                    var a;
                                    ((function(e1) {
                                        return "in" === e1 || "instanceof" === e1;
                                    })(i) || o) && function(e1) {
                                        return "UnaryExpression" === e1.type && "!" === e1.operator;
                                    }(s.left) && !e1.isParenthesised(r, s.left) && t.report({
                                        node: s,
                                        loc: s.left.loc,
                                        messageId: "unexpected",
                                        data: {
                                            operator: i
                                        },
                                        suggest: [
                                            {
                                                messageId: "suggestNegatedExpression",
                                                data: {
                                                    operator: i
                                                },
                                                fix (e1) {
                                                    const t = [
                                                        r.getFirstToken(s.left).range[1],
                                                        s.range[1]
                                                    ], n = r.text.slice(t[0], t[1]);
                                                    return e1.replaceTextRange(t, `(${n})`);
                                                }
                                            },
                                            {
                                                messageId: "suggestParenthesisedNegation",
                                                fix: (e1)=>e1.replaceText(s.left, `(${r.getText(s.left)})`)
                                            }
                                        ]
                                    });
                                }
                            };
                        }
                    }, EE;
                })(),
            "no-unsafe-optional-chaining": ()=>(function() {
                    if (SE) return CE;
                    SE = 1;
                    const e1 = new Set([
                        "+",
                        "-",
                        "/",
                        "*",
                        "%",
                        "**"
                    ]), t = new Set([
                        "+=",
                        "-=",
                        "/=",
                        "*=",
                        "%=",
                        "**="
                    ]), r = new Set([
                        "in",
                        "instanceof"
                    ]);
                    function n(e1) {
                        return "ObjectPattern" === e1.type || "ArrayPattern" === e1.type;
                    }
                    return CE = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow use of optional chaining in contexts where the `undefined` value is not allowed",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-unsafe-optional-chaining"
                            },
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        disallowArithmeticOperators: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            fixable: null,
                            messages: {
                                unsafeOptionalChain: "Unsafe usage of optional chaining. If it short-circuits with 'undefined' the evaluation will throw TypeError.",
                                unsafeArithmetic: "Unsafe arithmetic operation on optional chaining. It can result in NaN."
                            }
                        },
                        create (s) {
                            const i = (s.options[0] || {}).disallowArithmeticOperators || !1;
                            function o(e1) {
                                s.report({
                                    messageId: "unsafeOptionalChain",
                                    node: e1
                                });
                            }
                            function a(e1) {
                                s.report({
                                    messageId: "unsafeArithmetic",
                                    node: e1
                                });
                            }
                            function u(e1, t) {
                                if (e1) switch(e1.type){
                                    case "LogicalExpression":
                                        "||" === e1.operator || "??" === e1.operator ? u(e1.right, t) : "&&" === e1.operator && (u(e1.left, t), u(e1.right, t));
                                        break;
                                    case "SequenceExpression":
                                        u(e1.expressions[e1.expressions.length - 1], t);
                                        break;
                                    case "ConditionalExpression":
                                        u(e1.consequent, t), u(e1.alternate, t);
                                        break;
                                    case "AwaitExpression":
                                        u(e1.argument, t);
                                        break;
                                    case "ChainExpression":
                                        t(e1);
                                }
                            }
                            function l(e1) {
                                u(e1, o);
                            }
                            function c(e1) {
                                u(e1, a);
                            }
                            return {
                                "AssignmentExpression, AssignmentPattern" (e1) {
                                    n(e1.left) && l(e1.right);
                                },
                                "ClassDeclaration, ClassExpression" (e1) {
                                    l(e1.superClass);
                                },
                                CallExpression (e1) {
                                    e1.optional || l(e1.callee);
                                },
                                NewExpression (e1) {
                                    l(e1.callee);
                                },
                                VariableDeclarator (e1) {
                                    n(e1.id) && l(e1.init);
                                },
                                MemberExpression (e1) {
                                    e1.optional || l(e1.object);
                                },
                                TaggedTemplateExpression (e1) {
                                    l(e1.tag);
                                },
                                ForOfStatement (e1) {
                                    l(e1.right);
                                },
                                SpreadElement (e1) {
                                    e1.parent && "ObjectExpression" !== e1.parent.type && l(e1.argument);
                                },
                                BinaryExpression (t) {
                                    r.has(t.operator) && l(t.right), i && e1.has(t.operator) && (c(t.right), c(t.left));
                                },
                                WithStatement (e1) {
                                    l(e1.object);
                                },
                                UnaryExpression (t) {
                                    i && e1.has(t.operator) && c(t.argument);
                                },
                                AssignmentExpression (e1) {
                                    i && t.has(e1.operator) && c(e1.right);
                                }
                            };
                        }
                    }, CE;
                })(),
            "no-unused-expressions": ()=>xS(),
            "no-unused-labels": ()=>(function() {
                    if (TE) return AE;
                    TE = 1;
                    const e1 = Ll();
                    return AE = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow unused labels",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-unused-labels"
                            },
                            schema: [],
                            fixable: "code",
                            messages: {
                                unused: "'{{name}}:' is defined but never used."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode;
                            let n = null;
                            function s(t) {
                                if (r.getTokenAfter(t.label, {
                                    includeComments: !0
                                }) !== r.getTokenBefore(t.body, {
                                    includeComments: !0
                                })) return !1;
                                let n = t.parent;
                                for(; "LabeledStatement" === n.type;)n = n.parent;
                                if ("Program" === n.type || "BlockStatement" === n.type && e1.isFunction(n.parent)) {
                                    const { body: r } = t;
                                    if ("ExpressionStatement" === r.type && ("Literal" === r.expression.type && "string" == typeof r.expression.value || e1.isStaticTemplateLiteral(r.expression))) return !1;
                                }
                                return !0;
                            }
                            function i(e1) {
                                if (!e1.label) return;
                                const t = e1.label.name;
                                let r = n;
                                for(; r;){
                                    if (r.label === t) {
                                        r.used = !0;
                                        break;
                                    }
                                    r = r.upper;
                                }
                            }
                            return {
                                LabeledStatement: function(e1) {
                                    n = {
                                        label: e1.label.name,
                                        used: !1,
                                        upper: n
                                    };
                                },
                                "LabeledStatement:exit": function(e1) {
                                    n.used || t.report({
                                        node: e1.label,
                                        messageId: "unused",
                                        data: e1.label,
                                        fix: s(e1) ? (t)=>t.removeRange([
                                                e1.range[0],
                                                e1.body.range[0]
                                            ]) : null
                                    }), n = n.upper;
                                },
                                BreakStatement: i,
                                ContinueStatement: i
                            };
                        }
                    }, AE;
                })(),
            "no-unused-private-class-members": ()=>DE ? RE : (DE = 1, RE = {
                    meta: {
                        type: "problem",
                        docs: {
                            description: "Disallow unused private class members",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-unused-private-class-members"
                        },
                        schema: [],
                        messages: {
                            unusedPrivateClassMember: "'{{classMemberName}}' is defined but never used."
                        }
                    },
                    create (e1) {
                        const t = [];
                        return {
                            ClassBody (e1) {
                                const r = new Map;
                                t.unshift(r);
                                for (const t of e1.body)"PropertyDefinition" !== t.type && "MethodDefinition" !== t.type || "PrivateIdentifier" === t.key.type && r.set(t.key.name, {
                                    declaredNode: t,
                                    isAccessor: "MethodDefinition" === t.type && ("set" === t.kind || "get" === t.kind)
                                });
                            },
                            PrivateIdentifier (e1) {
                                const r = t.find((t)=>t.has(e1.name));
                                if (!r) return;
                                const n = r.get(e1.name);
                                if (n.isUsed) return;
                                if ("PropertyDefinition" === e1.parent.type || "MethodDefinition" === e1.parent.type) return;
                                if (n.isAccessor) return void (n.isUsed = !0);
                                if (function(e1) {
                                    const t = e1.parent.parent, r = "AssignmentExpression" === t.type;
                                    return !(!r && "ForInStatement" !== t.type && "ForOfStatement" !== t.type && "AssignmentPattern" !== t.type || t.left !== e1.parent || r && "=" !== t.operator && "ExpressionStatement" !== t.parent.type);
                                }(e1)) return;
                                const s = e1.parent.parent.type, i = e1.parent.parent.parent.type;
                                "UpdateExpression" === s && "ExpressionStatement" === i || "Property" === s && "ObjectPattern" === i && e1.parent.parent.value === e1.parent || "RestElement" !== s && "ArrayPattern" !== s && (n.isUsed = !0);
                            },
                            "ClassBody:exit" () {
                                const r = t.shift();
                                for (const [t, { declaredNode: n, isUsed: s }] of r.entries())s || e1.report({
                                    node: n,
                                    loc: n.key.loc,
                                    messageId: "unusedPrivateClassMember",
                                    data: {
                                        classMemberName: `#${t}`
                                    }
                                });
                            }
                        };
                    }
                }),
            "no-unused-vars": ()=>CS(),
            "no-use-before-define": ()=>SS(),
            "no-useless-backreference": ()=>(function() {
                    if (PE) return LE;
                    PE = 1;
                    const { CALL: e1, CONSTRUCT: t, ReferenceTracker: r, getStringIfConstant: n } = Hi(), { RegExpParser: s, visitRegExpAST: i } = _C(), o = new s;
                    function a(e1) {
                        const t = [];
                        let r = e1;
                        do t.push(r), r = r.parent;
                        while (r);
                        return t;
                    }
                    function u(e1) {
                        return "Assertion" === e1.type && ("lookahead" === e1.kind || "lookbehind" === e1.kind);
                    }
                    function l(e1) {
                        return u(e1) && e1.negate;
                    }
                    return LE = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow useless backreferences in regular expressions",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/no-useless-backreference"
                            },
                            schema: [],
                            messages: {
                                nested: "Backreference '{{ bref }}' will be ignored. It references group '{{ group }}' from within that group.",
                                forward: "Backreference '{{ bref }}' will be ignored. It references group '{{ group }}' which appears later in the pattern.",
                                backward: "Backreference '{{ bref }}' will be ignored. It references group '{{ group }}' which appears before in the same lookbehind.",
                                disjunctive: "Backreference '{{ bref }}' will be ignored. It references group '{{ group }}' which is in another alternative.",
                                intoNegativeLookaround: "Backreference '{{ bref }}' will be ignored. It references group '{{ group }}' which is in a negative lookaround."
                            }
                        },
                        create (s) {
                            const c = s.sourceCode;
                            function p(e1, t, r) {
                                let n;
                                try {
                                    n = o.parsePattern(t, 0, t.length, {
                                        unicode: r.includes("u"),
                                        unicodeSets: r.includes("v")
                                    });
                                } catch  {
                                    return;
                                }
                                i(n, {
                                    onBackreferenceEnter (t) {
                                        const r = t.resolved, n = a(t), i = a(r);
                                        let o = null;
                                        if (n.includes(r)) o = "nested";
                                        else {
                                            let e1 = n.length - 1, s = i.length - 1;
                                            do e1--, s--;
                                            while (n[e1] === i[s]);
                                            const a = s + 1, c = i.slice(0, a), p = i.slice(a).find(u), f = p && "lookbehind" === p.kind;
                                            !f && t.end <= r.start ? o = "forward" : f && r.end <= t.start ? o = "backward" : "Alternative" === c[c.length - 1].type ? o = "disjunctive" : c.some(l) && (o = "intoNegativeLookaround");
                                        }
                                        o && s.report({
                                            node: e1,
                                            messageId: o,
                                            data: {
                                                bref: t.raw,
                                                group: r.raw
                                            }
                                        });
                                    }
                                });
                            }
                            return {
                                "Literal[regex]" (e1) {
                                    const { pattern: t, flags: r } = e1.regex;
                                    p(e1, t, r);
                                },
                                Program (s) {
                                    const i = c.getScope(s), o = new r(i), a = {
                                        RegExp: {
                                            [e1]: !0,
                                            [t]: !0
                                        }
                                    };
                                    for (const { node: e1 } of o.iterateGlobalReferences(a)){
                                        const [t, r] = e1.arguments, s = n(t, i), o = n(r, i);
                                        "string" == typeof s && p(e1, s, o || "");
                                    }
                                }
                            };
                        }
                    }, LE;
                })(),
            "no-useless-call": ()=>bS(),
            "no-useless-catch": ()=>(OE || (OE = 1, NE = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow unnecessary `catch` clauses",
                            recommended: !0,
                            url: "https://eslint.org/docs/latest/rules/no-useless-catch"
                        },
                        schema: [],
                        messages: {
                            unnecessaryCatchClause: "Unnecessary catch clause.",
                            unnecessaryCatch: "Unnecessary try/catch wrapper."
                        }
                    },
                    create: (e1)=>({
                            CatchClause (t) {
                                t.param && "Identifier" === t.param.type && t.body.body.length && "ThrowStatement" === t.body.body[0].type && "Identifier" === t.body.body[0].argument.type && t.body.body[0].argument.name === t.param.name && (t.parent.finalizer ? e1.report({
                                    node: t,
                                    messageId: "unnecessaryCatchClause"
                                }) : e1.report({
                                    node: t.parent,
                                    messageId: "unnecessaryCatch"
                                }));
                            }
                        })
                }), NE),
            "no-useless-computed-key": ()=>vS(),
            "no-useless-concat": ()=>AS(),
            "no-useless-constructor": ()=>TS(),
            "no-useless-escape": ()=>RS(),
            "no-useless-rename": ()=>(function() {
                    if (XE) return WE;
                    XE = 1;
                    const e1 = Ll();
                    return WE = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow renaming import, export, and destructured assignments to the same name",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/no-useless-rename"
                            },
                            fixable: "code",
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        ignoreDestructuring: {
                                            type: "boolean",
                                            default: !1
                                        },
                                        ignoreImport: {
                                            type: "boolean",
                                            default: !1
                                        },
                                        ignoreExport: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                unnecessarilyRenamed: "{{type}} {{name}} unnecessarily renamed."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode, n = t.options[0] || {}, s = !0 === n.ignoreDestructuring, i = !0 === n.ignoreImport, o = !0 === n.ignoreExport;
                            function a(n, s, i) {
                                const o = "Identifier" === s.type ? s.name : s.value;
                                return t.report({
                                    node: n,
                                    messageId: "unnecessarilyRenamed",
                                    data: {
                                        name: o,
                                        type: i
                                    },
                                    fix (t) {
                                        const s = "Property" === n.type ? n.value : n.local;
                                        return r.getCommentsInside(n).length > r.getCommentsInside(s).length || "AssignmentPattern" === s.type && e1.isParenthesised(r, s.left) ? null : t.replaceText(n, r.getText(s));
                                    }
                                });
                            }
                            return {
                                ObjectPattern: function(e1) {
                                    if (!s) for (const t of e1.properties)"Property" !== t.type || t.shorthand || t.computed || ("Identifier" === t.key.type && t.key.name || "Literal" === t.key.type && t.key.value) === ("AssignmentPattern" === t.value.type ? t.value.left.name : t.value.name) && a(t, t.key, "Destructuring assignment");
                                },
                                ImportSpecifier: function(t) {
                                    i || t.imported.range[0] !== t.local.range[0] && e1.getModuleExportName(t.imported) === t.local.name && a(t, t.imported, "Import");
                                },
                                ExportSpecifier: function(t) {
                                    o || t.local.range[0] !== t.exported.range[0] && e1.getModuleExportName(t.local) === e1.getModuleExportName(t.exported) && a(t, t.local, "Export");
                                }
                            };
                        }
                    }, WE;
                })(),
            "no-useless-return": ()=>DS(),
            "no-var": ()=>wS(),
            "no-void": ()=>(ZE || (ZE = 1, YE = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow `void` operators",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/no-void"
                        },
                        messages: {
                            noVoid: "Expected 'undefined' and instead saw 'void'."
                        },
                        schema: [
                            {
                                type: "object",
                                properties: {
                                    allowAsStatement: {
                                        type: "boolean",
                                        default: !1
                                    }
                                },
                                additionalProperties: !1
                            }
                        ]
                    },
                    create (e1) {
                        const t = e1.options[0] && e1.options[0].allowAsStatement;
                        return {
                            'UnaryExpression[operator="void"]' (r) {
                                t && r.parent && "ExpressionStatement" === r.parent.type || e1.report({
                                    node: r,
                                    messageId: "noVoid"
                                });
                            }
                        };
                    }
                }), YE),
            "no-warning-comments": ()=>_S(),
            "no-whitespace-before-property": ()=>kS(),
            "no-with": ()=>(ix || (ix = 1, sx = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Disallow `with` statements",
                            recommended: !0,
                            url: "https://eslint.org/docs/latest/rules/no-with"
                        },
                        schema: [],
                        messages: {
                            unexpectedWith: "Unexpected use of 'with' statement."
                        }
                    },
                    create: (e1)=>({
                            WithStatement (t) {
                                e1.report({
                                    node: t,
                                    messageId: "unexpectedWith"
                                });
                            }
                        })
                }), sx),
            "nonblock-statement-body-position": ()=>BS(),
            "object-curly-newline": ()=>LS(),
            "object-curly-spacing": ()=>PS(),
            "object-property-newline": ()=>(dx || (dx = 1, fx = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "layout",
                        docs: {
                            description: "Enforce placing object properties on separate lines",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/object-property-newline"
                        },
                        schema: [
                            {
                                type: "object",
                                properties: {
                                    allowAllPropertiesOnSameLine: {
                                        type: "boolean",
                                        default: !1
                                    },
                                    allowMultiplePropertiesPerLine: {
                                        type: "boolean",
                                        default: !1
                                    }
                                },
                                additionalProperties: !1
                            }
                        ],
                        fixable: "whitespace",
                        messages: {
                            propertiesOnNewlineAll: "Object properties must go on a new line if they aren't all on the same line.",
                            propertiesOnNewline: "Object properties must go on a new line."
                        }
                    },
                    create (e1) {
                        const t = e1.options[0] && (e1.options[0].allowAllPropertiesOnSameLine || e1.options[0].allowMultiplePropertiesPerLine), r = t ? "propertiesOnNewlineAll" : "propertiesOnNewline", n = e1.sourceCode;
                        return {
                            ObjectExpression (s) {
                                if (t && s.properties.length > 1) {
                                    const e1 = n.getFirstToken(s.properties[0]), t = n.getLastToken(s.properties[s.properties.length - 1]);
                                    if (e1.loc.end.line === t.loc.start.line) return;
                                }
                                for(let t = 1; t < s.properties.length; t++){
                                    const i = n.getLastToken(s.properties[t - 1]), o = n.getFirstToken(s.properties[t]);
                                    i.loc.end.line === o.loc.start.line && e1.report({
                                        node: s,
                                        loc: o.loc,
                                        messageId: r,
                                        fix (e1) {
                                            const t = [
                                                n.getTokenBefore(o).range[1],
                                                o.range[0]
                                            ];
                                            return n.text.slice(t[0], t[1]).trim() ? null : e1.replaceTextRange(t, "\n");
                                        }
                                    });
                                }
                            }
                        };
                    }
                }), fx),
            "object-shorthand": ()=>IS(),
            "one-var": ()=>FS(),
            "one-var-declaration-per-line": ()=>(xx || (xx = 1, Ex = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "suggestion",
                        docs: {
                            description: "Require or disallow newlines around variable declarations",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/one-var-declaration-per-line"
                        },
                        schema: [
                            {
                                enum: [
                                    "always",
                                    "initializations"
                                ]
                            }
                        ],
                        fixable: "whitespace",
                        messages: {
                            expectVarOnNewline: "Expected variable declaration to be on a new line."
                        }
                    },
                    create (e1) {
                        const t = "always" === e1.options[0];
                        return {
                            VariableDeclaration: function(r) {
                                if (function(e1) {
                                    return "ForStatement" === e1 || "ForInStatement" === e1 || "ForOfStatement" === e1;
                                }(r.parent.type)) return;
                                let n;
                                r.declarations.forEach((s)=>{
                                    n && n.loc.end.line === s.loc.start.line && (t || n.init || s.init) && e1.report({
                                        node: r,
                                        messageId: "expectVarOnNewline",
                                        loc: s.loc,
                                        fix: (e1)=>e1.insertTextBefore(s, "\n")
                                    }), n = s;
                                });
                            }
                        };
                    }
                }), Ex),
            "operator-assignment": ()=>(function() {
                    if (Sx) return Cx;
                    Sx = 1;
                    const e1 = Ll();
                    function t(e1) {
                        return [
                            "*",
                            "&",
                            "^",
                            "|"
                        ].includes(e1);
                    }
                    function r(e1) {
                        return "Identifier" === e1.type || "MemberExpression" === e1.type && ("Identifier" === e1.object.type || "ThisExpression" === e1.object.type) && (!e1.computed || "Literal" === e1.property.type);
                    }
                    return Cx = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Require or disallow assignment operator shorthand where possible",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/operator-assignment"
                            },
                            schema: [
                                {
                                    enum: [
                                        "always",
                                        "never"
                                    ]
                                }
                            ],
                            fixable: "code",
                            messages: {
                                replaced: "Assignment (=) can be replaced with operator assignment ({{operator}}).",
                                unexpected: "Unexpected operator assignment ({{operator}}) shorthand."
                            }
                        },
                        create (n) {
                            const s = n.sourceCode;
                            function i(e1) {
                                return s.getFirstTokenBetween(e1.left, e1.right, (t)=>t.value === e1.operator);
                            }
                            return {
                                AssignmentExpression: "never" !== n.options[0] ? function(o) {
                                    if ("=" !== o.operator || "BinaryExpression" !== o.right.type) return;
                                    const a = o.left, u = o.right, l = u.operator;
                                    if (t(l) || function(e1) {
                                        return [
                                            "+",
                                            "-",
                                            "/",
                                            "%",
                                            "<<",
                                            ">>",
                                            ">>>",
                                            "**"
                                        ].includes(e1);
                                    }(l)) {
                                        const c = `${l}=`;
                                        e1.isSameReference(a, u.left, !0) ? n.report({
                                            node: o,
                                            messageId: "replaced",
                                            data: {
                                                operator: c
                                            },
                                            fix (e1) {
                                                if (r(a) && r(u.left)) {
                                                    const t = i(o), r = i(u), n = s.getText().slice(o.range[0], t.range[0]), a = s.getText().slice(r.range[1], o.right.range[1]);
                                                    return s.commentsExistBetween(t, r) ? null : e1.replaceText(o, `${n}${c}${a}`);
                                                }
                                                return null;
                                            }
                                        }) : e1.isSameReference(a, u.right, !0) && t(l) && n.report({
                                            node: o,
                                            messageId: "replaced",
                                            data: {
                                                operator: c
                                            }
                                        });
                                    }
                                } : function(t) {
                                    "=" === t.operator || e1.isLogicalAssignmentOperator(t.operator) || n.report({
                                        node: t,
                                        messageId: "unexpected",
                                        data: {
                                            operator: t.operator
                                        },
                                        fix (n) {
                                            if (r(t.left)) {
                                                const r = s.getFirstToken(t), o = i(t), a = s.getText().slice(t.range[0], o.range[0]), u = t.operator.slice(0, -1);
                                                let l;
                                                if (s.commentsExistBetween(r, o)) return null;
                                                if (e1.getPrecedence(t.right) <= e1.getPrecedence({
                                                    type: "BinaryExpression",
                                                    operator: u
                                                }) && !e1.isParenthesised(s, t.right)) l = `${s.text.slice(o.range[1], t.right.range[0])}(${s.getText(t.right)})`;
                                                else {
                                                    const r = s.getTokenAfter(o, {
                                                        includeComments: !0
                                                    });
                                                    let n = "";
                                                    o.range[1] !== r.range[0] || e1.canTokensBeAdjacent({
                                                        type: "Punctuator",
                                                        value: u
                                                    }, r) || (n = " "), l = `${n}${s.text.slice(o.range[1], t.range[1])}`;
                                                }
                                                return n.replaceText(t, `${a}= ${a}${u}${l}`);
                                            }
                                            return null;
                                        }
                                    });
                                }
                            };
                        }
                    }, Cx;
                })(),
            "operator-linebreak": ()=>NS(),
            "padded-blocks": ()=>OS(),
            "padding-line-between-statements": ()=>US(),
            "prefer-arrow-callback": ()=>jS(),
            "prefer-const": ()=>VS(),
            "prefer-destructuring": ()=>KS(),
            "prefer-exponentiation-operator": ()=>MS(),
            "prefer-named-capture-group": ()=>$S(),
            "prefer-numeric-literals": ()=>qS(),
            "prefer-object-has-own": ()=>GS(),
            "prefer-object-spread": ()=>WS(),
            "prefer-promise-reject-errors": ()=>XS(),
            "prefer-reflect": ()=>(Xx || (Xx = 1, Wx = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Require `Reflect` methods where applicable",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/prefer-reflect"
                        },
                        deprecated: !0,
                        replacedBy: [],
                        schema: [
                            {
                                type: "object",
                                properties: {
                                    exceptions: {
                                        type: "array",
                                        items: {
                                            enum: [
                                                "apply",
                                                "call",
                                                "delete",
                                                "defineProperty",
                                                "getOwnPropertyDescriptor",
                                                "getPrototypeOf",
                                                "setPrototypeOf",
                                                "isExtensible",
                                                "getOwnPropertyNames",
                                                "preventExtensions"
                                            ]
                                        },
                                        uniqueItems: !0
                                    }
                                },
                                additionalProperties: !1
                            }
                        ],
                        messages: {
                            preferReflect: "Avoid using {{existing}}, instead use {{substitute}}."
                        }
                    },
                    create (e1) {
                        const t = {
                            apply: "Function.prototype.apply",
                            call: "Function.prototype.call",
                            defineProperty: "Object.defineProperty",
                            getOwnPropertyDescriptor: "Object.getOwnPropertyDescriptor",
                            getPrototypeOf: "Object.getPrototypeOf",
                            setPrototypeOf: "Object.setPrototypeOf",
                            isExtensible: "Object.isExtensible",
                            getOwnPropertyNames: "Object.getOwnPropertyNames",
                            preventExtensions: "Object.preventExtensions"
                        }, r = {
                            apply: "Reflect.apply",
                            call: "Reflect.apply",
                            defineProperty: "Reflect.defineProperty",
                            getOwnPropertyDescriptor: "Reflect.getOwnPropertyDescriptor",
                            getPrototypeOf: "Reflect.getPrototypeOf",
                            setPrototypeOf: "Reflect.setPrototypeOf",
                            isExtensible: "Reflect.isExtensible",
                            getOwnPropertyNames: "Reflect.getOwnPropertyNames",
                            preventExtensions: "Reflect.preventExtensions"
                        }, n = (e1.options[0] || {}).exceptions || [];
                        function s(t, r, n) {
                            e1.report({
                                node: t,
                                messageId: "preferReflect",
                                data: {
                                    existing: r,
                                    substitute: n
                                }
                            });
                        }
                        return {
                            CallExpression (e1) {
                                const i = (e1.callee.property || {}).name, o = "Reflect" === (e1.callee.object || {}).name, a = Object.prototype.hasOwnProperty.call(r, i), u = n.includes(i);
                                !a || o || u || s(e1, t[i], r[i]);
                            },
                            UnaryExpression (e1) {
                                const t = "delete" === e1.operator, r = "Identifier" === e1.argument.type, i = n.includes("delete");
                                !t || r || i || s(e1, "the delete keyword", "Reflect.deleteProperty");
                            }
                        };
                    }
                }), Wx),
            "prefer-regex-literals": ()=>zS(),
            "prefer-rest-params": ()=>(function() {
                    if (Qx) return Jx;
                    function e1(e1) {
                        const t = e1.identifier, r = t.parent;
                        return !("MemberExpression" === r.type && r.object === t && !r.computed);
                    }
                    return Qx = 1, Jx = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Require rest parameters instead of `arguments`",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/prefer-rest-params"
                            },
                            schema: [],
                            messages: {
                                preferRestParams: "Use the rest parameters instead of 'arguments'."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode;
                            function n(e1) {
                                t.report({
                                    node: e1.identifier,
                                    loc: e1.identifier.loc,
                                    messageId: "preferRestParams"
                                });
                            }
                            function s(t) {
                                const s = function(e1) {
                                    const t = e1.variables;
                                    for(let e1 = 0; e1 < t.length; ++e1){
                                        const r = t[e1];
                                        if ("arguments" === r.name) return 0 === r.identifiers.length ? r : null;
                                    }
                                    return null;
                                }(r.getScope(t));
                                s && s.references.filter(e1).forEach(n);
                            }
                            return {
                                "FunctionDeclaration:exit": s,
                                "FunctionExpression:exit": s
                            };
                        }
                    }, Jx;
                })(),
            "prefer-spread": ()=>HS(),
            "prefer-template": ()=>JS(),
            "quote-props": ()=>QS(),
            quotes: ()=>YS(),
            radix: ()=>ZS(),
            "require-atomic-updates": ()=>(function() {
                    if (lC) return uC;
                    function e1(t, r = new Map) {
                        for (const e1 of t.references)null !== e1.resolved && r.set(e1.identifier, e1);
                        for (const n of t.childScopes)"function" !== n.type && e1(n, r);
                        return r;
                    }
                    lC = 1;
                    class t {
                        constructor(){
                            this.info = new WeakMap;
                        }
                        initialize(e1) {
                            const t = new Set, r = new Set;
                            for (const n of e1.prevSegments){
                                const e1 = this.info.get(n);
                                e1 && (e1.outdatedReadVariables.forEach(Set.prototype.add, t), e1.freshReadVariables.forEach(Set.prototype.add, r));
                            }
                            this.info.set(e1, {
                                outdatedReadVariables: t,
                                freshReadVariables: r
                            });
                        }
                        markAsRead(e1, t) {
                            for (const r of e1){
                                const e1 = this.info.get(r);
                                e1 && (e1.freshReadVariables.add(t), e1.outdatedReadVariables.delete(t));
                            }
                        }
                        makeOutdated(e1) {
                            for (const t of e1){
                                const e1 = this.info.get(t);
                                e1 && (e1.freshReadVariables.forEach(Set.prototype.add, e1.outdatedReadVariables), e1.freshReadVariables.clear());
                            }
                        }
                        isOutdated(e1, t) {
                            for (const r of e1){
                                const e1 = this.info.get(r);
                                if (e1 && e1.outdatedReadVariables.has(t)) return !0;
                            }
                            return !1;
                        }
                    }
                    return uC = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Disallow assignments that can lead to race conditions due to usage of `await` or `yield`",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/require-atomic-updates"
                            },
                            fixable: null,
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        allowProperties: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                nonAtomicUpdate: "Possible race condition: `{{value}}` might be reassigned based on an outdated value of `{{value}}`.",
                                nonAtomicObjectUpdate: "Possible race condition: `{{value}}` might be assigned based on an outdated state of `{{object}}`."
                            }
                        },
                        create (r) {
                            const n = !!r.options[0] && r.options[0].allowProperties, s = r.sourceCode, i = new Map, o = new t;
                            let a = null;
                            return {
                                onCodePathStart (t, r) {
                                    const n = s.getScope(r), i = "function" === n.type && (n.block.async || n.block.generator);
                                    a = {
                                        upper: a,
                                        codePath: t,
                                        referenceMap: i ? e1(n) : null,
                                        currentSegments: new Set
                                    };
                                },
                                onCodePathEnd () {
                                    a = a.upper;
                                },
                                onCodePathSegmentStart (e1) {
                                    o.initialize(e1), a.currentSegments.add(e1);
                                },
                                onUnreachableCodePathSegmentStart (e1) {
                                    a.currentSegments.add(e1);
                                },
                                onUnreachableCodePathSegmentEnd (e1) {
                                    a.currentSegments.delete(e1);
                                },
                                onCodePathSegmentEnd (e1) {
                                    a.currentSegments.delete(e1);
                                },
                                Identifier (e1) {
                                    const { referenceMap: t } = a, r = t && t.get(e1);
                                    if (!r) return;
                                    const n = r.resolved, s = function(e1) {
                                        if (e1.writeExpr) return e1.writeExpr;
                                        let t = e1.identifier;
                                        for(; t;){
                                            const e1 = t.parent.type;
                                            if ("AssignmentExpression" === e1 && t.parent.left === t) return t.parent.right;
                                            if ("MemberExpression" !== e1 || t.parent.object !== t) break;
                                            t = t.parent;
                                        }
                                        return null;
                                    }(r), u = "MemberExpression" === r.identifier.parent.type;
                                    if (!r.isRead() || s && "=" === s.parent.operator || o.markAsRead(a.currentSegments, n), s && s.parent.right === s && !function(e1, t) {
                                        if (!e1) return !1;
                                        if (t && e1.defs.some((e1)=>"Parameter" === e1.type)) return !1;
                                        const r = e1.scope.variableScope;
                                        return e1.references.every((e1)=>e1.from.variableScope === r);
                                    }(n, u)) {
                                        let e1 = i.get(s);
                                        e1 || (e1 = [], i.set(s, e1)), e1.push(r);
                                    }
                                },
                                ":expression:exit" (e1) {
                                    if (!a.referenceMap) return;
                                    "AwaitExpression" !== e1.type && "YieldExpression" !== e1.type || o.makeOutdated(a.currentSegments);
                                    const t = i.get(e1);
                                    if (t) {
                                        i.delete(e1);
                                        for (const i of t){
                                            const t = i.resolved;
                                            o.isOutdated(a.currentSegments, t) && (e1.parent.left === i.identifier ? r.report({
                                                node: e1.parent,
                                                messageId: "nonAtomicUpdate",
                                                data: {
                                                    value: t.name
                                                }
                                            }) : n || r.report({
                                                node: e1.parent,
                                                messageId: "nonAtomicObjectUpdate",
                                                data: {
                                                    value: s.getText(e1.parent.left),
                                                    object: t.name
                                                }
                                            }));
                                        }
                                    }
                                }
                            };
                        }
                    }, uC;
                })(),
            "require-await": ()=>(function() {
                    if (pC) return cC;
                    pC = 1;
                    const e1 = Ll();
                    return cC = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Disallow async functions which have no `await` expression",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/require-await"
                            },
                            schema: [],
                            messages: {
                                missingAwait: "{{name}} has no 'await' expression."
                            }
                        },
                        create (t) {
                            const r = t.sourceCode;
                            let n = null;
                            function s() {
                                n = {
                                    upper: n,
                                    hasAwait: !1
                                };
                            }
                            function i(s) {
                                var i;
                                s.generator || !s.async || n.hasAwait || e1.isEmptyFunction(s) || t.report({
                                    node: s,
                                    loc: e1.getFunctionHeadLoc(s, r),
                                    messageId: "missingAwait",
                                    data: {
                                        name: (i = e1.getFunctionNameWithKind(s), i[0].toUpperCase() + i.slice(1))
                                    }
                                }), n = n.upper;
                            }
                            return {
                                FunctionDeclaration: s,
                                FunctionExpression: s,
                                ArrowFunctionExpression: s,
                                "FunctionDeclaration:exit": i,
                                "FunctionExpression:exit": i,
                                "ArrowFunctionExpression:exit": i,
                                AwaitExpression () {
                                    n && (n.hasAwait = !0);
                                },
                                ForOfStatement (e1) {
                                    n && e1.await && (n.hasAwait = !0);
                                }
                            };
                        }
                    }, cC;
                })(),
            "require-jsdoc": ()=>eb(),
            "require-unicode-regexp": ()=>(function() {
                    if (mC) return hC;
                    mC = 1;
                    const { CALL: e1, CONSTRUCT: t, ReferenceTracker: r, getStringIfConstant: n } = Hi(), s = Ll(), { isValidWithUnicodeFlag: i } = QC();
                    return hC = {
                        meta: {
                            type: "suggestion",
                            docs: {
                                description: "Enforce the use of `u` or `v` flag on RegExp",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/require-unicode-regexp"
                            },
                            hasSuggestions: !0,
                            messages: {
                                addUFlag: "Add the 'u' flag.",
                                requireUFlag: "Use the 'u' flag."
                            },
                            schema: []
                        },
                        create (o) {
                            const a = o.sourceCode;
                            return {
                                "Literal[regex]" (e1) {
                                    const t = e1.regex.flags || "";
                                    t.includes("u") || t.includes("v") || o.report({
                                        messageId: "requireUFlag",
                                        node: e1,
                                        suggest: i(o.languageOptions.ecmaVersion, e1.regex.pattern) ? [
                                            {
                                                fix: (t)=>t.insertTextAfter(e1, "u"),
                                                messageId: "addUFlag"
                                            }
                                        ] : null
                                    });
                                },
                                Program (u) {
                                    const l = a.getScope(u), c = new r(l), p = {
                                        RegExp: {
                                            [e1]: !0,
                                            [t]: !0
                                        }
                                    };
                                    for (const { node: e1 } of c.iterateGlobalReferences(p)){
                                        const [t, r] = e1.arguments;
                                        if (t && "SpreadElement" === t.type) continue;
                                        const u = n(t, l), c = n(r, l);
                                        r && ("string" != typeof c || c.includes("u") || c.includes("v")) || o.report({
                                            messageId: "requireUFlag",
                                            node: e1,
                                            suggest: "string" == typeof u && i(o.languageOptions.ecmaVersion, u) ? [
                                                {
                                                    fix (t) {
                                                        if (r) {
                                                            if ("Literal" === r.type && "string" == typeof r.value || "TemplateLiteral" === r.type) {
                                                                const e1 = a.getText(r);
                                                                return t.replaceText(r, [
                                                                    e1.slice(0, e1.length - 1),
                                                                    e1.slice(e1.length - 1)
                                                                ].join("u"));
                                                            }
                                                            return null;
                                                        }
                                                        const n = a.getLastToken(e1, {
                                                            skip: 1
                                                        });
                                                        return t.insertTextAfter(n, s.isCommaToken(n) ? ' "u",' : ', "u"');
                                                    },
                                                    messageId: "addUFlag"
                                                }
                                            ] : null
                                        });
                                    }
                                }
                            };
                        }
                    }, hC;
                })(),
            "require-yield": ()=>(yC || (yC = 1, gC = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Require generator functions to contain `yield`",
                            recommended: !0,
                            url: "https://eslint.org/docs/latest/rules/require-yield"
                        },
                        schema: [],
                        messages: {
                            missingYield: "This generator function does not have 'yield'."
                        }
                    },
                    create (e1) {
                        const t = [];
                        function r(e1) {
                            e1.generator && t.push(0);
                        }
                        function n(r) {
                            r.generator && 0 === t.pop() && r.body.body.length > 0 && e1.report({
                                node: r,
                                messageId: "missingYield"
                            });
                        }
                        return {
                            FunctionDeclaration: r,
                            "FunctionDeclaration:exit": n,
                            FunctionExpression: r,
                            "FunctionExpression:exit": n,
                            YieldExpression () {
                                t.length > 0 && (t[t.length - 1] += 1);
                            }
                        };
                    }
                }), gC),
            "rest-spread-spacing": ()=>(xC || (xC = 1, EC = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "layout",
                        docs: {
                            description: "Enforce spacing between rest and spread operators and their expressions",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/rest-spread-spacing"
                        },
                        fixable: "whitespace",
                        schema: [
                            {
                                enum: [
                                    "always",
                                    "never"
                                ]
                            }
                        ],
                        messages: {
                            unexpectedWhitespace: "Unexpected whitespace after {{type}} operator.",
                            expectedWhitespace: "Expected whitespace after {{type}} operator."
                        }
                    },
                    create (e1) {
                        const t = e1.sourceCode, r = "always" === e1.options[0];
                        function n(n) {
                            const s = t.getFirstToken(n), i = t.getTokenAfter(s), o = t.isSpaceBetweenTokens(s, i);
                            let a;
                            switch(n.type){
                                case "SpreadElement":
                                    a = "spread", "ObjectExpression" === n.parent.type && (a += " property");
                                    break;
                                case "RestElement":
                                    a = "rest", "ObjectPattern" === n.parent.type && (a += " property");
                                    break;
                                case "ExperimentalSpreadProperty":
                                    a = "spread property";
                                    break;
                                case "ExperimentalRestProperty":
                                    a = "rest property";
                                    break;
                                default:
                                    return;
                            }
                            r && !o ? e1.report({
                                node: n,
                                loc: s.loc,
                                messageId: "expectedWhitespace",
                                data: {
                                    type: a
                                },
                                fix: (e1)=>e1.replaceTextRange([
                                        s.range[1],
                                        i.range[0]
                                    ], " ")
                            }) : !r && o && e1.report({
                                node: n,
                                loc: {
                                    start: s.loc.end,
                                    end: i.loc.start
                                },
                                messageId: "unexpectedWhitespace",
                                data: {
                                    type: a
                                },
                                fix: (e1)=>e1.removeRange([
                                        s.range[1],
                                        i.range[0]
                                    ])
                            });
                        }
                        return {
                            SpreadElement: n,
                            RestElement: n,
                            ExperimentalSpreadProperty: n,
                            ExperimentalRestProperty: n
                        };
                    }
                }), EC),
            semi: ()=>tb(),
            "semi-spacing": ()=>rb(),
            "semi-style": ()=>(function() {
                    if (TC) return AC;
                    TC = 1;
                    const e1 = Ll(), t = [
                        "BreakStatement",
                        "ContinueStatement",
                        "DebuggerStatement",
                        "DoWhileStatement",
                        "ExportAllDeclaration",
                        "ExportDefaultDeclaration",
                        "ExportNamedDeclaration",
                        "ExpressionStatement",
                        "ImportDeclaration",
                        "ReturnStatement",
                        "ThrowStatement",
                        "VariableDeclaration",
                        "PropertyDefinition"
                    ].join(",");
                    return AC = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "layout",
                            docs: {
                                description: "Enforce location of semicolons",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/semi-style"
                            },
                            schema: [
                                {
                                    enum: [
                                        "last",
                                        "first"
                                    ]
                                }
                            ],
                            fixable: "whitespace",
                            messages: {
                                expectedSemiColon: "Expected this semicolon to be at {{pos}}."
                            }
                        },
                        create (r) {
                            const n = r.sourceCode, s = r.options[0] || "last";
                            function i(t, s) {
                                const i = n.getTokenBefore(t), o = n.getTokenAfter(t), a = !i || e1.isTokenOnSameLine(i, t), u = !o || e1.isTokenOnSameLine(t, o);
                                ("last" === s && !a || "first" === s && !u) && r.report({
                                    loc: t.loc,
                                    messageId: "expectedSemiColon",
                                    data: {
                                        pos: "last" === s ? "the end of the previous line" : "the beginning of the next line"
                                    },
                                    fix (e1) {
                                        if (i && o && n.commentsExistBetween(i, o)) return null;
                                        const r = i ? i.range[1] : t.range[0], a = o ? o.range[0] : t.range[1], u = "last" === s ? ";\n" : "\n;";
                                        return e1.replaceTextRange([
                                            r,
                                            a
                                        ], u);
                                    }
                                });
                            }
                            return {
                                [t] (t) {
                                    if ("first" === s && function(e1) {
                                        const t = e1.parent.type;
                                        if ("IfStatement" === t && e1.parent.consequent === e1 && e1.parent.alternate) return !0;
                                        if ("DoWhileStatement" === t) return !0;
                                        const r = function(e1) {
                                            const t = e1.type;
                                            return "BlockStatement" === t || "StaticBlock" === t || "Program" === t || "ClassBody" === t ? e1.body : "SwitchCase" === t ? e1.consequent : null;
                                        }(e1.parent);
                                        return null !== r && r[r.length - 1] === e1;
                                    }(t)) return;
                                    const r = n.getLastToken(t);
                                    e1.isSemicolonToken(r) && i(r, s);
                                },
                                ForStatement (t) {
                                    const r = t.init && n.getTokenAfter(t.init, e1.isSemicolonToken), s = t.test && n.getTokenAfter(t.test, e1.isSemicolonToken);
                                    r && i(r, "last"), s && i(s, "last");
                                }
                            };
                        }
                    }, AC;
                })(),
            "sort-imports": ()=>nb(),
            "sort-keys": ()=>Ub(),
            "sort-vars": ()=>(ub || (ub = 1, ab = {
                    meta: {
                        type: "suggestion",
                        docs: {
                            description: "Require variables within the same declaration block to be sorted",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/sort-vars"
                        },
                        schema: [
                            {
                                type: "object",
                                properties: {
                                    ignoreCase: {
                                        type: "boolean",
                                        default: !1
                                    }
                                },
                                additionalProperties: !1
                            }
                        ],
                        fixable: "code",
                        messages: {
                            sortVars: "Variables within the same declaration block should be sorted alphabetically."
                        }
                    },
                    create (e1) {
                        const t = (e1.options[0] || {}).ignoreCase || !1, r = e1.sourceCode;
                        return {
                            VariableDeclaration (n) {
                                const s = n.declarations.filter((e1)=>"Identifier" === e1.id.type), i = t ? (e1)=>e1.id.name.toLowerCase() : (e1)=>e1.id.name, o = s.some((e1)=>null !== e1.init && "Literal" !== e1.init.type);
                                let a = !1;
                                s.slice(1).reduce((t, n)=>{
                                    const u = i(t);
                                    return i(n) < u ? (e1.report({
                                        node: n,
                                        messageId: "sortVars",
                                        fix: (e1)=>o || a ? null : e1.replaceTextRange([
                                                s[0].range[0],
                                                s[s.length - 1].range[1]
                                            ], s.slice().sort((e1, t)=>i(e1) > i(t) ? 1 : -1).reduce((e1, t, n)=>{
                                                const i = n === s.length - 1 ? "" : r.getText().slice(s[n].range[1], s[n + 1].range[0]);
                                                return e1 + r.getText(t) + i;
                                            }, ""))
                                    }), a = !0, t) : n;
                                }, s[0]);
                            }
                        };
                    }
                }), ab),
            "space-before-blocks": ()=>jb(),
            "space-before-function-paren": ()=>Vb(),
            "space-in-parens": ()=>Kb(),
            "space-infix-ops": ()=>(function() {
                    if (gb) return mb;
                    gb = 1;
                    const { isEqToken: e1 } = Ll();
                    return mb = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "layout",
                            docs: {
                                description: "Require spacing around infix operators",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/space-infix-ops"
                            },
                            fixable: "whitespace",
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        int32Hint: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                missingSpace: "Operator '{{operator}}' must be spaced."
                            }
                        },
                        create (t) {
                            const r = !!t.options[0] && !0 === t.options[0].int32Hint, n = t.sourceCode;
                            function s(e1, t, r) {
                                const s = n.getFirstTokenBetween(e1, t, (e1)=>e1.value === r), i = n.getTokenBefore(s), o = n.getTokenAfter(s);
                                return n.isSpaceBetweenTokens(i, s) && n.isSpaceBetweenTokens(s, o) ? null : s;
                            }
                            function i(e1, r) {
                                t.report({
                                    node: e1,
                                    loc: r.loc,
                                    messageId: "missingSpace",
                                    data: {
                                        operator: r.value
                                    },
                                    fix (e1) {
                                        const t = n.getTokenBefore(r), s = n.getTokenAfter(r);
                                        let i = "";
                                        return r.range[0] - t.range[1] == 0 && (i = " "), i += r.value, s.range[0] - r.range[1] == 0 && (i += " "), e1.replaceText(r, i);
                                    }
                                });
                            }
                            function o(e1) {
                                const t = s(e1.left.typeAnnotation ? e1.left.typeAnnotation : e1.left, e1.right, e1.operator || "=");
                                t && (r && n.getText(e1).endsWith("|0") || i(e1, t));
                            }
                            return {
                                AssignmentExpression: o,
                                AssignmentPattern: o,
                                BinaryExpression: o,
                                LogicalExpression: o,
                                ConditionalExpression: function(e1) {
                                    const t = s(e1.test, e1.consequent, "?"), r = s(e1.consequent, e1.alternate, ":");
                                    t && i(e1, t), r && i(e1, r);
                                },
                                VariableDeclarator: function(e1) {
                                    const t = e1.id.typeAnnotation ? e1.id.typeAnnotation : e1.id, r = e1.init;
                                    if (r) {
                                        const n = s(t, r, "=");
                                        n && i(e1, n);
                                    }
                                },
                                PropertyDefinition (t) {
                                    if (!t.value) return;
                                    const r = n.getTokenBefore(t.value, e1), s = n.getTokenBefore(r), o = n.getTokenAfter(r);
                                    n.isSpaceBetweenTokens(s, r) && n.isSpaceBetweenTokens(r, o) || i(t, r);
                                }
                            };
                        }
                    }, mb;
                })(),
            "space-unary-ops": ()=>(function() {
                    if (Eb) return yb;
                    Eb = 1;
                    const e1 = Ll();
                    return yb = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "layout",
                            docs: {
                                description: "Enforce consistent spacing before or after unary operators",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/space-unary-ops"
                            },
                            fixable: "whitespace",
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        words: {
                                            type: "boolean",
                                            default: !0
                                        },
                                        nonwords: {
                                            type: "boolean",
                                            default: !1
                                        },
                                        overrides: {
                                            type: "object",
                                            additionalProperties: {
                                                type: "boolean"
                                            }
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                unexpectedBefore: "Unexpected space before unary operator '{{operator}}'.",
                                unexpectedAfter: "Unexpected space after unary operator '{{operator}}'.",
                                unexpectedAfterWord: "Unexpected space after unary word operator '{{word}}'.",
                                wordOperator: "Unary word operator '{{word}}' must be followed by whitespace.",
                                operator: "Unary operator '{{operator}}' must be followed by whitespace.",
                                beforeUnaryExpressions: "Space is required before unary expressions '{{token}}'."
                            }
                        },
                        create (t) {
                            const r = t.options[0] || {
                                words: !0,
                                nonwords: !1
                            }, n = t.sourceCode;
                            function s(e1) {
                                return r.overrides && Object.prototype.hasOwnProperty.call(r.overrides, e1);
                            }
                            function i(e1) {
                                return r.overrides[e1];
                            }
                            function o(e1, r, n, s) {
                                n.range[0] === r.range[1] && t.report({
                                    node: e1,
                                    messageId: "wordOperator",
                                    data: {
                                        word: s
                                    },
                                    fix: (e1)=>e1.insertTextAfter(r, " ")
                                });
                            }
                            function a(r, n, s, i) {
                                e1.canTokensBeAdjacent(n, s) && s.range[0] > n.range[1] && t.report({
                                    node: r,
                                    messageId: "unexpectedAfterWord",
                                    data: {
                                        word: i
                                    },
                                    fix: (e1)=>e1.removeRange([
                                            n.range[1],
                                            s.range[0]
                                        ])
                                });
                            }
                            function u(e1, t, n, u) {
                                s(u) ? i(u) ? o(e1, t, n, u) : a(e1, t, n, u) : r.words ? o(e1, t, n, u) : a(e1, t, n, u);
                            }
                            function l(e1, r, n) {
                                if (e1.prefix) {
                                    if (function(e1) {
                                        return e1 && "UnaryExpression" === e1.type && "!" === e1.argument.operator && e1.argument && "UnaryExpression" === e1.argument.type && "!" === e1.argument.operator;
                                    }(e1)) return;
                                    r.range[1] === n.range[0] && t.report({
                                        node: e1,
                                        messageId: "operator",
                                        data: {
                                            operator: r.value
                                        },
                                        fix: (e1)=>e1.insertTextAfter(r, " ")
                                    });
                                } else r.range[1] === n.range[0] && t.report({
                                    node: e1,
                                    messageId: "beforeUnaryExpressions",
                                    data: {
                                        token: n.value
                                    },
                                    fix: (e1)=>e1.insertTextBefore(n, " ")
                                });
                            }
                            function c(r, n, s) {
                                r.prefix ? s.range[0] > n.range[1] && t.report({
                                    node: r,
                                    messageId: "unexpectedAfter",
                                    data: {
                                        operator: n.value
                                    },
                                    fix: (t)=>e1.canTokensBeAdjacent(n, s) ? t.removeRange([
                                            n.range[1],
                                            s.range[0]
                                        ]) : null
                                }) : s.range[0] > n.range[1] && t.report({
                                    node: r,
                                    messageId: "unexpectedBefore",
                                    data: {
                                        operator: s.value
                                    },
                                    fix: (e1)=>e1.removeRange([
                                            n.range[1],
                                            s.range[0]
                                        ])
                                });
                            }
                            function p(e1) {
                                const t = "UpdateExpression" !== e1.type || e1.prefix ? n.getFirstTokens(e1, 2) : n.getLastTokens(e1, 2), o = t[0], a = t[1];
                                if (("NewExpression" === e1.type || e1.prefix) && "Keyword" === o.type) return void u(e1, o, a, o.value);
                                const p = e1.prefix ? t[0].value : t[1].value;
                                s(p) ? i(p) ? l(e1, o, a) : c(e1, o, a) : r.nonwords ? l(e1, o, a) : c(e1, o, a);
                            }
                            return {
                                UnaryExpression: p,
                                UpdateExpression: p,
                                NewExpression: p,
                                YieldExpression: function(e1) {
                                    const t = n.getFirstTokens(e1, 3);
                                    e1.argument && !e1.delegate && u(e1, t[0], t[1], "yield");
                                },
                                AwaitExpression: function(e1) {
                                    const t = n.getFirstTokens(e1, 3);
                                    u(e1, t[0], t[1], "await");
                                }
                            };
                        }
                    }, yb;
                })(),
            "spaced-comment": ()=>(function() {
                    if (Cb) return xb;
                    Cb = 1;
                    const e1 = Ja(), t = Ll();
                    function r(t) {
                        return `(?:${e1(t)})`;
                    }
                    function n(e1) {
                        return `${r(e1)}+`;
                    }
                    function s(e1) {
                        let r = "";
                        return 0 === e1.length ? r += "\\s" : (r += "(?:\\s|", 1 === e1.length ? r += n(e1[0]) : (r += "(?:", r += e1.map(n).join("|"), r += ")"), r += `(?:$|[${Array.from(t.LINEBREAKS).join("")}]))`), r;
                    }
                    function i(e1, t) {
                        let n = "^";
                        return 1 === e1.length ? n += r(e1[0]) : (n += "(?:", n += e1.map(r).join("|"), n += ")"), n += "?", n += s(t), new RegExp(n, "u");
                    }
                    function o(e1) {
                        const t = `^(${e1.map(r).join("|")})?[ \t]+`;
                        return new RegExp(t, "u");
                    }
                    return xb = {
                        meta: {
                            deprecated: !0,
                            replacedBy: [],
                            type: "suggestion",
                            docs: {
                                description: "Enforce consistent spacing after the `//` or `/*` in a comment",
                                recommended: !1,
                                url: "https://eslint.org/docs/latest/rules/spaced-comment"
                            },
                            fixable: "whitespace",
                            schema: [
                                {
                                    enum: [
                                        "always",
                                        "never"
                                    ]
                                },
                                {
                                    type: "object",
                                    properties: {
                                        exceptions: {
                                            type: "array",
                                            items: {
                                                type: "string"
                                            }
                                        },
                                        markers: {
                                            type: "array",
                                            items: {
                                                type: "string"
                                            }
                                        },
                                        line: {
                                            type: "object",
                                            properties: {
                                                exceptions: {
                                                    type: "array",
                                                    items: {
                                                        type: "string"
                                                    }
                                                },
                                                markers: {
                                                    type: "array",
                                                    items: {
                                                        type: "string"
                                                    }
                                                }
                                            },
                                            additionalProperties: !1
                                        },
                                        block: {
                                            type: "object",
                                            properties: {
                                                exceptions: {
                                                    type: "array",
                                                    items: {
                                                        type: "string"
                                                    }
                                                },
                                                markers: {
                                                    type: "array",
                                                    items: {
                                                        type: "string"
                                                    }
                                                },
                                                balanced: {
                                                    type: "boolean",
                                                    default: !1
                                                }
                                            },
                                            additionalProperties: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                unexpectedSpaceAfterMarker: "Unexpected space or tab after marker ({{refChar}}) in comment.",
                                expectedExceptionAfter: "Expected exception block, space or tab after '{{refChar}}' in comment.",
                                unexpectedSpaceBefore: "Unexpected space or tab before '*/' in comment.",
                                unexpectedSpaceAfter: "Unexpected space or tab after '{{refChar}}' in comment.",
                                expectedSpaceBefore: "Expected space or tab before '*/' in comment.",
                                expectedSpaceAfter: "Expected space or tab after '{{refChar}}' in comment."
                            }
                        },
                        create (e1) {
                            const t = e1.sourceCode, n = "never" !== e1.options[0], a = e1.options[1] || {}, u = a.block && a.block.balanced, l = [
                                "block",
                                "line"
                            ].reduce((e1, t)=>{
                                const l = function(e1) {
                                    return e1.includes("*") ? e1 : e1.concat("*");
                                }(a[t] && a[t].markers || a.markers || []), c = a[t] && a[t].exceptions || a.exceptions || [];
                                return e1[t] = {
                                    beginRegex: n ? i(l, c) : o(l),
                                    endRegex: u && n ? new RegExp(`${s(c)}$`, "u") : new RegExp("[ \t]+$", "u"),
                                    hasExceptions: c.length > 0,
                                    captureMarker: new RegExp(`^(${l.map(r).join("|")})`, "u"),
                                    markers: new Set(l)
                                }, e1;
                            }, {});
                            function c(t, r, s, i) {
                                const o = "block" === t.type.toLowerCase() ? "/*" : "//";
                                e1.report({
                                    node: t,
                                    fix (e1) {
                                        const r = t.range[0];
                                        let i = r + 2;
                                        return n ? (s && (i += s[0].length), e1.insertTextAfterRange([
                                            r,
                                            i
                                        ], " ")) : (i += s[0].length, e1.replaceTextRange([
                                            r,
                                            i
                                        ], o + (s[1] ? s[1] : "")));
                                    },
                                    messageId: r,
                                    data: {
                                        refChar: i
                                    }
                                });
                            }
                            function p(t, r, s) {
                                e1.report({
                                    node: t,
                                    fix (e1) {
                                        if (n) return e1.insertTextAfterRange([
                                            t.range[0],
                                            t.range[1] - 2
                                        ], " ");
                                        const r = t.range[1] - 2, i = r - s[0].length;
                                        return e1.replaceTextRange([
                                            i,
                                            r
                                        ], "");
                                    },
                                    messageId: r
                                });
                            }
                            function f(e1) {
                                const t = e1.type.toLowerCase(), r = l[t], s = "block" === t ? "/*" : "//";
                                if (0 === e1.value.length || r.markers.has(e1.value)) return;
                                const i = r.beginRegex.exec(e1.value), o = r.endRegex.exec(e1.value);
                                if (n) {
                                    if (!i) {
                                        const t = r.captureMarker.exec(e1.value), n = t ? s + t[0] : s;
                                        r.hasExceptions ? c(e1, "expectedExceptionAfter", t, n) : c(e1, "expectedSpaceAfter", t, n);
                                    }
                                    u && "block" === t && !o && p(e1, "expectedSpaceBefore");
                                } else i && (i[1] ? c(e1, "unexpectedSpaceAfterMarker", i, i[1]) : c(e1, "unexpectedSpaceAfter", i, s)), u && "block" === t && o && p(e1, "unexpectedSpaceBefore", o);
                            }
                            return {
                                Program () {
                                    t.getAllComments().filter((e1)=>"Shebang" !== e1.type).forEach(f);
                                }
                            };
                        }
                    }, xb;
                })(),
            strict: ()=>Mb(),
            "switch-colon-spacing": ()=>$b(),
            "symbol-description": ()=>qb(),
            "template-curly-spacing": ()=>Gb(),
            "template-tag-spacing": ()=>(kb || (kb = 1, _b = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "layout",
                        docs: {
                            description: "Require or disallow spacing between template tags and their literals",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/template-tag-spacing"
                        },
                        fixable: "whitespace",
                        schema: [
                            {
                                enum: [
                                    "always",
                                    "never"
                                ]
                            }
                        ],
                        messages: {
                            unexpected: "Unexpected space between template tag and template literal.",
                            missing: "Missing space between template tag and template literal."
                        }
                    },
                    create (e1) {
                        const t = "always" !== e1.options[0], r = e1.sourceCode;
                        return {
                            TaggedTemplateExpression: function(n) {
                                const s = r.getTokenBefore(n.quasi), i = r.getFirstToken(n.quasi), o = r.isSpaceBetweenTokens(s, i);
                                t && o ? e1.report({
                                    node: n,
                                    loc: {
                                        start: s.loc.end,
                                        end: i.loc.start
                                    },
                                    messageId: "unexpected",
                                    fix (e1) {
                                        const t = r.getCommentsBefore(n.quasi);
                                        return t.some((e1)=>"Line" === e1.type) ? null : e1.replaceTextRange([
                                            s.range[1],
                                            i.range[0]
                                        ], t.reduce((e1, t)=>e1 + r.getText(t), ""));
                                    }
                                }) : t || o || e1.report({
                                    node: n,
                                    loc: {
                                        start: n.loc.start,
                                        end: i.loc.start
                                    },
                                    messageId: "missing",
                                    fix: (e1)=>e1.insertTextAfter(s, " ")
                                });
                            }
                        };
                    }
                }), _b),
            "unicode-bom": ()=>(Lb || (Lb = 1, Bb = {
                    meta: {
                        type: "layout",
                        docs: {
                            description: "Require or disallow Unicode byte order mark (BOM)",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/unicode-bom"
                        },
                        fixable: "whitespace",
                        schema: [
                            {
                                enum: [
                                    "always",
                                    "never"
                                ]
                            }
                        ],
                        messages: {
                            expected: "Expected Unicode BOM (Byte Order Mark).",
                            unexpected: "Unexpected Unicode BOM (Byte Order Mark)."
                        }
                    },
                    create: (e1)=>({
                            Program: function(t) {
                                const r = e1.sourceCode, n = {
                                    column: 0,
                                    line: 1
                                }, s = e1.options[0] || "never";
                                r.hasBOM || "always" !== s ? r.hasBOM && "never" === s && e1.report({
                                    node: t,
                                    loc: n,
                                    messageId: "unexpected",
                                    fix: (e1)=>e1.removeRange([
                                            -1,
                                            0
                                        ])
                                }) : e1.report({
                                    node: t,
                                    loc: n,
                                    messageId: "expected",
                                    fix: (e1)=>e1.insertTextBeforeRange([
                                            0,
                                            1
                                        ], "\ufeff")
                                });
                            }
                        })
                }), Bb),
            "use-isnan": ()=>(function() {
                    if (Ib) return Pb;
                    Ib = 1;
                    const e1 = Ll();
                    function t(t) {
                        return Boolean(t) && (e1.isSpecificId(t, "NaN") || e1.isSpecificMemberAccess(t, "Number", "NaN"));
                    }
                    return Pb = {
                        meta: {
                            type: "problem",
                            docs: {
                                description: "Require calls to `isNaN()` when checking for `NaN`",
                                recommended: !0,
                                url: "https://eslint.org/docs/latest/rules/use-isnan"
                            },
                            schema: [
                                {
                                    type: "object",
                                    properties: {
                                        enforceForSwitchCase: {
                                            type: "boolean",
                                            default: !0
                                        },
                                        enforceForIndexOf: {
                                            type: "boolean",
                                            default: !1
                                        }
                                    },
                                    additionalProperties: !1
                                }
                            ],
                            messages: {
                                comparisonWithNaN: "Use the isNaN function to compare with NaN.",
                                switchNaN: "'switch(NaN)' can never match a case clause. Use Number.isNaN instead of the switch.",
                                caseNaN: "'case NaN' can never match. Use Number.isNaN before the switch.",
                                indexOfNaN: "Array prototype method '{{ methodName }}' cannot find NaN."
                            }
                        },
                        create (r) {
                            const n = !r.options[0] || r.options[0].enforceForSwitchCase, s = r.options[0] && r.options[0].enforceForIndexOf, i = {
                                BinaryExpression: function(e1) {
                                    /^(?:[<>]|[!=]=)=?$/u.test(e1.operator) && (t(e1.left) || t(e1.right)) && r.report({
                                        node: e1,
                                        messageId: "comparisonWithNaN"
                                    });
                                }
                            };
                            return n && (i.SwitchStatement = function(e1) {
                                t(e1.discriminant) && r.report({
                                    node: e1,
                                    messageId: "switchNaN"
                                });
                                for (const n of e1.cases)t(n.test) && r.report({
                                    node: n,
                                    messageId: "caseNaN"
                                });
                            }), s && (i.CallExpression = function(n) {
                                const s = e1.skipChainExpression(n.callee);
                                if ("MemberExpression" === s.type) {
                                    const i = e1.getStaticPropertyName(s);
                                    "indexOf" !== i && "lastIndexOf" !== i || 1 !== n.arguments.length || !t(n.arguments[0]) || r.report({
                                        node: n,
                                        messageId: "indexOfNaN",
                                        data: {
                                            methodName: i
                                        }
                                    });
                                }
                            }), i;
                        }
                    }, Pb;
                })(),
            "valid-jsdoc": ()=>Rv(),
            "valid-typeof": ()=>Dv(),
            "vars-on-top": ()=>wv(),
            "wrap-iife": ()=>_v(),
            "wrap-regex": ()=>(sv || (sv = 1, nv = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "layout",
                        docs: {
                            description: "Require parenthesis around regex literals",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/wrap-regex"
                        },
                        schema: [],
                        fixable: "code",
                        messages: {
                            requireParens: "Wrap the regexp literal in parens to disambiguate the slash."
                        }
                    },
                    create (e1) {
                        const t = e1.sourceCode;
                        return {
                            Literal (r) {
                                if ("RegularExpression" === t.getFirstToken(r).type) {
                                    const n = t.getTokenBefore(r), s = t.getTokenAfter(r), { parent: i } = r;
                                    "MemberExpression" !== i.type || i.object !== r || n && "(" === n.value && s && ")" === s.value || e1.report({
                                        node: r,
                                        messageId: "requireParens",
                                        fix: (e1)=>e1.replaceText(r, `(${t.getText(r)})`)
                                    });
                                }
                            }
                        };
                    }
                }), nv),
            "yield-star-spacing": ()=>(ov || (ov = 1, iv = {
                    meta: {
                        deprecated: !0,
                        replacedBy: [],
                        type: "layout",
                        docs: {
                            description: "Require or disallow spacing around the `*` in `yield*` expressions",
                            recommended: !1,
                            url: "https://eslint.org/docs/latest/rules/yield-star-spacing"
                        },
                        fixable: "whitespace",
                        schema: [
                            {
                                oneOf: [
                                    {
                                        enum: [
                                            "before",
                                            "after",
                                            "both",
                                            "neither"
                                        ]
                                    },
                                    {
                                        type: "object",
                                        properties: {
                                            before: {
                                                type: "boolean"
                                            },
                                            after: {
                                                type: "boolean"
                                            }
                                        },
                                        additionalProperties: !1
                                    }
                                ]
                            }
                        ],
                        messages: {
                            missingBefore: "Missing space before *.",
                            missingAfter: "Missing space after *.",
                            unexpectedBefore: "Unexpected space before *.",
                            unexpectedAfter: "Unexpected space after *."
                        }
                    },
                    create (e1) {
                        const t = e1.sourceCode, r = (n = e1.options[0]) && "string" != typeof n ? n : ({
                            before: {
                                before: !0,
                                after: !1
                            },
                            after: {
                                before: !1,
                                after: !0
                            },
                            both: {
                                before: !0,
                                after: !0
                            },
                            neither: {
                                before: !1,
                                after: !1
                            }
                        })[n || "after"];
                        var n;
                        function s(n, s, i) {
                            if (t.isSpaceBetweenTokens(s, i) !== r[n]) {
                                const t = "*" === s.value, o = r[n], a = t ? s : i;
                                let u = "";
                                u = o ? "before" === n ? "missingBefore" : "missingAfter" : "before" === n ? "unexpectedBefore" : "unexpectedAfter", e1.report({
                                    node: a,
                                    messageId: u,
                                    fix: (e1)=>o ? t ? e1.insertTextAfter(a, " ") : e1.insertTextBefore(a, " ") : e1.removeRange([
                                            s.range[1],
                                            i.range[0]
                                        ])
                                });
                            }
                        }
                        return {
                            YieldExpression: function(e1) {
                                if (!e1.delegate) return;
                                const r = t.getFirstTokens(e1, 3), n = r[0], i = r[1], o = r[2];
                                s("before", n, i), s("after", i, o);
                            }
                        };
                    }
                }), iv),
            yoda: ()=>kv()
        })), lv;
    }
    function Lv() {
        if (fv) return pv;
        fv = 1;
        const e1 = Bv();
        class t {
            constructor(){
                this._rules = Object.create(null);
            }
            define(e1, t) {
                var r;
                this._rules[e1] = "function" == typeof (r = t) ? Object.assign({
                    create: r
                }, r) : r;
            }
            get(t) {
                return "string" == typeof this._rules[t] && this.define(t, function(e1) {
                    throw new Error('Could not dynamically require "' + e1 + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
                }(this._rules[t])), this._rules[t] ? this._rules[t] : e1.has(t) ? e1.get(t) : null;
            }
            *[Symbol.iterator]() {
                yield* e1;
                for (const e1 of Object.keys(this._rules))yield [
                    e1,
                    this.get(e1)
                ];
            }
        }
        return pv = t;
    }
    function Pv() {
        if (Ev) return yv;
        function e1(e1, t, r) {
            return new Array(t - e1.length + 1).join(r || " ") + e1;
        }
        Ev = 1;
        const t = !!k.env.TIMING, r = [
            "Rule",
            "Time (ms)",
            "Relative"
        ], n = [
            function(e1, t, r) {
                return e1 + new Array(t - e1.length + 1).join(r || " ");
            },
            e1,
            e1
        ];
        function s() {
            if ("string" != typeof k.env.TIMING) return 10;
            if ("all" === k.env.TIMING.toLowerCase()) return Number.POSITIVE_INFINITY;
            const e1 = Number.parseInt(k.env.TIMING, 10);
            return e1 > 10 ? e1 : 10;
        }
        return yv = function() {
            const e1 = Object.create(null);
            return t && k.on("exit", ()=>{
                !function(e1) {
                    let t = 0;
                    const i = Object.keys(e1).map((r)=>{
                        const n = e1[r];
                        return t += n, [
                            r,
                            n
                        ];
                    }).sort((e1, t)=>t[1] - e1[1]).slice(0, s());
                    i.forEach((e1)=>{
                        e1.push(`${(100 * e1[1] / t).toFixed(1)}%`), e1[1] = e1[1].toFixed(3);
                    }), i.unshift(r);
                    const o = [];
                    i.forEach((e1)=>{
                        const t = e1.length;
                        for(let r = 0; r < t; r++){
                            const t = e1[r].length;
                            (!o[r] || t > o[r]) && (o[r] = t);
                        }
                    });
                    const a = i.map((e1)=>e1.map((e1, t)=>n[t](e1, o[t])).join(" | "));
                    a.splice(1, 0, o.map((e1, t)=>{
                        const r = 0 !== t && t !== o.length - 1 ? 2 : 1;
                        return n[t](":", e1 + r, "-");
                    }).join("|")), console.log(a.join("\n"));
                }(e1);
            }), {
                time: function(t, r) {
                    return void 0 === e1[t] && (e1[t] = 0), function(...n) {
                        let s = k.hrtime();
                        const i = r(...n);
                        return s = k.hrtime(s), e1[t] += 1e3 * s[0] + s[1] / 1e6, i;
                    };
                },
                enabled: t,
                getListSize: s
            };
        }(), yv;
    }
    var Iv, Fv, Nv = {
        rules: {
            "generator-star": [
                "generator-star-spacing"
            ],
            "global-strict": [
                "strict"
            ],
            "no-arrow-condition": [
                "no-confusing-arrow",
                "no-constant-condition"
            ],
            "no-comma-dangle": [
                "comma-dangle"
            ],
            "no-empty-class": [
                "no-empty-character-class"
            ],
            "no-empty-label": [
                "no-labels"
            ],
            "no-extra-strict": [
                "strict"
            ],
            "no-reserved-keys": [
                "quote-props"
            ],
            "no-space-before-semi": [
                "semi-spacing"
            ],
            "no-wrap-func": [
                "no-extra-parens"
            ],
            "space-after-function-name": [
                "space-before-function-paren"
            ],
            "space-after-keywords": [
                "keyword-spacing"
            ],
            "space-before-function-parentheses": [
                "space-before-function-paren"
            ],
            "space-before-keywords": [
                "keyword-spacing"
            ],
            "space-in-brackets": [
                "object-curly-spacing",
                "array-bracket-spacing",
                "computed-property-spacing"
            ],
            "space-return-throw-case": [
                "keyword-spacing"
            ],
            "space-unary-word-ops": [
                "space-unary-ops"
            ],
            "spaced-line-comment": [
                "spaced-comment"
            ]
        }
    };
    function Ov() {
        if (Fv) return Iv;
        function e1(e1) {
            let t, r;
            return e1.includes("/") ? (t = e1.startsWith("@") ? e1.slice(0, e1.lastIndexOf("/")) : e1.slice(0, e1.indexOf("/")), r = e1.slice(t.length + 1)) : (t = "@", r = e1), {
                pluginName: t,
                ruleName: r
            };
        }
        return Fv = 1, Iv = {
            parseRuleId: e1,
            getRuleFromConfig: function(t, r) {
                const { pluginName: n, ruleName: s } = e1(t), i = r.plugins && r.plugins[n];
                let o = i && i.rules && i.rules[s];
                return o && "function" == typeof o && (o = {
                    create: o
                }), o;
            },
            getRuleOptionsSchema: function(e1) {
                if (!e1) return null;
                const t = e1.schema || e1.meta && e1.meta.schema;
                return Array.isArray(t) ? t.length ? {
                    type: "array",
                    items: t,
                    minItems: 0,
                    maxItems: t.length
                } : {
                    type: "array",
                    minItems: 0,
                    maxItems: 0
                } : t || null;
            }
        }, Iv;
    }
    var Uv, jv, Vv, Kv, Mv, $v, qv, Gv, Wv = {}, Xv = {};
    function zv() {
        if (jv) return Uv;
        jv = 1, Uv = function(t, r) {
            for(var n = [], s = 0; s < t.length; s++){
                var i = r(t[s], s);
                e1(i) ? n.push.apply(n, i) : n.push(i);
            }
            return n;
        };
        var e1 = Array.isArray || function(e1) {
            return "[object Array]" === Object.prototype.toString.call(e1);
        };
        return Uv;
    }
    function Hv() {
        if ($v) return Mv;
        $v = 1;
        var e1 = zv(), t = function() {
            if (Kv) return Vv;
            function e1(e1, n, s) {
                e1 instanceof RegExp && (e1 = t(e1, s)), n instanceof RegExp && (n = t(n, s));
                var i = r(e1, n, s);
                return i && {
                    start: i[0],
                    end: i[1],
                    pre: s.slice(0, i[0]),
                    body: s.slice(i[0] + e1.length, i[1]),
                    post: s.slice(i[1] + n.length)
                };
            }
            function t(e1, t) {
                var r = t.match(e1);
                return r ? r[0] : null;
            }
            function r(e1, t, r) {
                var n, s, i, o, a, u = r.indexOf(e1), l = r.indexOf(t, u + 1), c = u;
                if (u >= 0 && l > 0) {
                    if (e1 === t) return [
                        u,
                        l
                    ];
                    for(n = [], i = r.length; c >= 0 && !a;)c == u ? (n.push(c), u = r.indexOf(e1, c + 1)) : 1 == n.length ? a = [
                        n.pop(),
                        l
                    ] : ((s = n.pop()) < i && (i = s, o = l), l = r.indexOf(t, c + 1)), c = u < l && u >= 0 ? u : l;
                    n.length && (a = [
                        i,
                        o
                    ]);
                }
                return a;
            }
            return Kv = 1, Vv = e1, e1.range = r, Vv;
        }();
        Mv = function(e1) {
            if (!e1) return [];
            "{}" === e1.substr(0, 2) && (e1 = "\\{\\}" + e1.substr(2));
            return h(function(e1) {
                return e1.split("\\\\").join(r).split("\\{").join(n).split("\\}").join(s).split("\\,").join(i).split("\\.").join(o);
            }(e1), !0).map(u);
        };
        var r = "\0SLASH" + Math.random() + "\0", n = "\0OPEN" + Math.random() + "\0", s = "\0CLOSE" + Math.random() + "\0", i = "\0COMMA" + Math.random() + "\0", o = "\0PERIOD" + Math.random() + "\0";
        function a(e1) {
            return parseInt(e1, 10) == e1 ? parseInt(e1, 10) : e1.charCodeAt(0);
        }
        function u(e1) {
            return e1.split(r).join("\\").split(n).join("{").split(s).join("}").split(i).join(",").split(o).join(".");
        }
        function l(e1) {
            if (!e1) return [
                ""
            ];
            var r = [], n = t("{", "}", e1);
            if (!n) return e1.split(",");
            var s = n.pre, i = n.body, o = n.post, a = s.split(",");
            a[a.length - 1] += "{" + i + "}";
            var u = l(o);
            return o.length && (a[a.length - 1] += u.shift(), a.push.apply(a, u)), r.push.apply(r, a), r;
        }
        function c(e1) {
            return "{" + e1 + "}";
        }
        function p(e1) {
            return /^-?0\d/.test(e1);
        }
        function f(e1, t) {
            return e1 <= t;
        }
        function d(e1, t) {
            return e1 >= t;
        }
        function h(r, n) {
            var i = [], o = t("{", "}", r);
            if (!o || /\$$/.test(o.pre)) return [
                r
            ];
            var u, m = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(o.body), g = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(o.body), y = m || g, E = o.body.indexOf(",") >= 0;
            if (!y && !E) return o.post.match(/,.*\}/) ? h(r = o.pre + "{" + o.body + s + o.post) : [
                r
            ];
            if (y) u = o.body.split(/\.\./);
            else if (1 === (u = l(o.body)).length && 1 === (u = h(u[0], !1).map(c)).length) return (S = o.post.length ? h(o.post, !1) : [
                ""
            ]).map(function(e1) {
                return o.pre + u[0] + e1;
            });
            var x, C = o.pre, S = o.post.length ? h(o.post, !1) : [
                ""
            ];
            if (y) {
                var b = a(u[0]), v = a(u[1]), A = Math.max(u[0].length, u[1].length), T = 3 == u.length ? Math.abs(a(u[2])) : 1, R = f;
                v < b && (T *= -1, R = d);
                var D = u.some(p);
                x = [];
                for(var w = b; R(w, v); w += T){
                    var _;
                    if (g) "\\" === (_ = String.fromCharCode(w)) && (_ = "");
                    else if (_ = String(w), D) {
                        var k = A - _.length;
                        if (k > 0) {
                            var B = new Array(k + 1).join("0");
                            _ = w < 0 ? "-" + B + _.slice(1) : B + _;
                        }
                    }
                    x.push(_);
                }
            } else x = e1(u, function(e1) {
                return h(e1, !1);
            });
            for(var L = 0; L < x.length; L++)for(var P = 0; P < S.length; P++){
                var I = C + x[L] + S[P];
                (!n || y || I) && i.push(I);
            }
            return i;
        }
        return Mv;
    }
    var Jv, Qv = {}, Yv = {}, Zv = {};
    function eA() {
        if (Jv) return Zv;
        Jv = 1;
        return Zv.MergeStrategy = class {
            static overwrite(e1, t) {
                return t;
            }
            static replace(e1, t) {
                return void 0 !== t ? t : e1;
            }
            static assign(e1, t) {
                return Object.assign({}, e1, t);
            }
        }, Zv;
    }
    var tA, rA, nA, sA, iA = {};
    function oA() {
        if (tA) return iA;
        tA = 1;
        return iA.ValidationStrategy = class {
            static array(e1) {
                if (!Array.isArray(e1)) throw new TypeError("Expected an array.");
            }
            static boolean(e1) {
                if ("boolean" != typeof e1) throw new TypeError("Expected a Boolean.");
            }
            static number(e1) {
                if ("number" != typeof e1) throw new TypeError("Expected a number.");
            }
            static object(e1) {
                if (!e1 || "object" != typeof e1) throw new TypeError("Expected an object.");
            }
            static "object?"(e1) {
                if ("object" != typeof e1) throw new TypeError("Expected an object or null.");
            }
            static string(e1) {
                if ("string" != typeof e1) throw new TypeError("Expected a string.");
            }
            static "string!"(e1) {
                if ("string" != typeof e1 || 0 === e1.length) throw new TypeError("Expected a non-empty string.");
            }
        }, iA;
    }
    function aA() {
        return nA || (nA = 1, Qv.ObjectSchema = function() {
            if (rA) return Yv;
            rA = 1;
            const { MergeStrategy: e1 } = eA(), { ValidationStrategy: t } = oA(), r = Symbol("strategies"), n = Symbol("requiredKeys");
            function s(r, n) {
                let s = !1;
                if (n.schema) {
                    if ("object" != typeof n.schema) throw new TypeError("Schema must be an object.");
                    s = !0;
                }
                if ("string" == typeof n.merge) {
                    if (!(n.merge in e1)) throw new TypeError(`Definition for key "${r}" missing valid merge strategy.`);
                } else if (!s && "function" != typeof n.merge) throw new TypeError(`Definition for key "${r}" must have a merge property.`);
                if ("string" == typeof n.validate) {
                    if (!(n.validate in t)) throw new TypeError(`Definition for key "${r}" missing valid validation strategy.`);
                } else if (!s && "function" != typeof n.validate) throw new TypeError(`Definition for key "${r}" must have a validate() method.`);
            }
            class i extends Error {
                constructor(e1){
                    super(`Unexpected key "${e1}" found.`);
                }
            }
            class o extends Error {
                constructor(e1){
                    super(`Missing required key "${e1}".`);
                }
            }
            class a extends Error {
                constructor(e1, t){
                    super(`Key "${e1}" requires keys "${t.join('", "')}".`);
                }
            }
            class u extends Error {
                constructor(e1, t){
                    super(`Key "${e1}": ${t.message}`, {
                        cause: t
                    });
                    for (const e1 of Object.keys(t))e1 in this || (this[e1] = t[e1]);
                }
            }
            class l {
                constructor(i){
                    if (!i) throw new Error("Schema definitions missing.");
                    this[r] = new Map, this[n] = new Map;
                    for (const o of Object.keys(i)){
                        if (s(o, i[o]), "object" == typeof i[o].schema) {
                            const e1 = new l(i[o].schema);
                            i[o] = {
                                ...i[o],
                                merge: (t = {}, r = {})=>e1.merge(t, r),
                                validate (r) {
                                    t.object(r), e1.validate(r);
                                }
                            };
                        }
                        "string" == typeof i[o].merge && (i[o] = {
                            ...i[o],
                            merge: e1[i[o].merge]
                        }), "string" == typeof i[o].validate && (i[o] = {
                            ...i[o],
                            validate: t[i[o].validate]
                        }), this[r].set(o, i[o]), i[o].required && this[n].set(o, i[o]);
                    }
                }
                hasKey(e1) {
                    return this[r].has(e1);
                }
                merge(...e1) {
                    if (e1.length < 2) throw new TypeError("merge() requires at least two arguments.");
                    if (e1.some((e1)=>null == e1 || "object" != typeof e1)) throw new TypeError("All arguments must be objects.");
                    return e1.reduce((e1, t)=>{
                        this.validate(t);
                        for (const [n, s] of this[r])try {
                            if (n in e1 || n in t) {
                                const r = s.merge.call(this, e1[n], t[n]);
                                void 0 !== r && (e1[n] = r);
                            }
                        } catch (e1) {
                            throw new u(n, e1);
                        }
                        return e1;
                    }, {});
                }
                validate(e1) {
                    for (const t of Object.keys(e1)){
                        if (!this.hasKey(t)) throw new i(t);
                        const n = this[r].get(t);
                        if (Array.isArray(n.requires) && !n.requires.every((t)=>t in e1)) throw new a(t, n.requires);
                        try {
                            n.validate.call(n, e1[t]);
                        } catch (e1) {
                            throw new u(t, e1);
                        }
                    }
                    for (const [t] of this[n])if (!(t in e1)) throw new o(t);
                }
            }
            return Yv.ObjectSchema = l, Yv;
        }().ObjectSchema, Qv.MergeStrategy = eA().MergeStrategy, Qv.ValidationStrategy = oA().ValidationStrategy), Qv;
    }
    function uA() {
        if (sA) return Xv;
        sA = 1;
        var e1 = G, t = function() {
            if (Gv) return qv;
            Gv = 1, qv = l, l.Minimatch = c;
            var e1 = function() {
                try {
                    return G;
                } catch (e1) {}
            }() || {
                sep: "/"
            };
            l.sep = e1.sep;
            var t = l.GLOBSTAR = c.GLOBSTAR = {}, r = Hv(), n = {
                "!": {
                    open: "(?:(?!(?:",
                    close: "))[^/]*?)"
                },
                "?": {
                    open: "(?:",
                    close: ")?"
                },
                "+": {
                    open: "(?:",
                    close: ")+"
                },
                "*": {
                    open: "(?:",
                    close: ")*"
                },
                "@": {
                    open: "(?:",
                    close: ")"
                }
            }, s = "[^/]", i = s + "*?", o = "().*{}+?[]^$\\!".split("").reduce(function(e1, t) {
                return e1[t] = !0, e1;
            }, {}), a = /\/+/;
            function u(e1, t) {
                t = t || {};
                var r = {};
                return Object.keys(e1).forEach(function(t) {
                    r[t] = e1[t];
                }), Object.keys(t).forEach(function(e1) {
                    r[e1] = t[e1];
                }), r;
            }
            function l(e1, t, r) {
                return f(t), r || (r = {}), !(!r.nocomment && "#" === t.charAt(0)) && new c(t, r).match(e1);
            }
            function c(t, r) {
                if (!(this instanceof c)) return new c(t, r);
                f(t), r || (r = {}), t = t.trim(), r.allowWindowsEscape || "/" === e1.sep || (t = t.split(e1.sep).join("/")), this.options = r, this.set = [], this.pattern = t, this.regexp = null, this.negate = !1, this.comment = !1, this.empty = !1, this.partial = !!r.partial, this.make();
            }
            function p(e1, t) {
                return t || (t = this instanceof c ? this.options : {}), e1 = void 0 === e1 ? this.pattern : e1, f(e1), t.nobrace || !/\{(?:(?!\{).)*\}/.test(e1) ? [
                    e1
                ] : r(e1);
            }
            l.filter = function(e1, t) {
                return t = t || {}, function(r, n, s) {
                    return l(r, e1, t);
                };
            }, l.defaults = function(e1) {
                if (!e1 || "object" != typeof e1 || !Object.keys(e1).length) return l;
                var t = l, r = function(r, n, s) {
                    return t(r, n, u(e1, s));
                };
                return r.Minimatch = function(r, n) {
                    return new t.Minimatch(r, u(e1, n));
                }, r.Minimatch.defaults = function(r) {
                    return t.defaults(u(e1, r)).Minimatch;
                }, r.filter = function(r, n) {
                    return t.filter(r, u(e1, n));
                }, r.defaults = function(r) {
                    return t.defaults(u(e1, r));
                }, r.makeRe = function(r, n) {
                    return t.makeRe(r, u(e1, n));
                }, r.braceExpand = function(r, n) {
                    return t.braceExpand(r, u(e1, n));
                }, r.match = function(r, n, s) {
                    return t.match(r, n, u(e1, s));
                }, r;
            }, c.defaults = function(e1) {
                return l.defaults(e1).Minimatch;
            }, c.prototype.debug = function() {}, c.prototype.make = function() {
                var e1 = this.pattern, t = this.options;
                if (t.nocomment || "#" !== e1.charAt(0)) {
                    if (e1) {
                        this.parseNegate();
                        var r = this.globSet = this.braceExpand();
                        t.debug && (this.debug = function() {
                            console.error.apply(console, arguments);
                        }), this.debug(this.pattern, r), r = this.globParts = r.map(function(e1) {
                            return e1.split(a);
                        }), this.debug(this.pattern, r), r = r.map(function(e1, t, r) {
                            return e1.map(this.parse, this);
                        }, this), this.debug(this.pattern, r), r = r.filter(function(e1) {
                            return -1 === e1.indexOf(!1);
                        }), this.debug(this.pattern, r), this.set = r;
                    } else this.empty = !0;
                } else this.comment = !0;
            }, c.prototype.parseNegate = function() {
                var e1 = this.pattern, t = !1, r = 0;
                if (!this.options.nonegate) {
                    for(var n = 0, s = e1.length; n < s && "!" === e1.charAt(n); n++)t = !t, r++;
                    r && (this.pattern = e1.substr(r)), this.negate = t;
                }
            }, l.braceExpand = function(e1, t) {
                return p(e1, t);
            }, c.prototype.braceExpand = p;
            var f = function(e1) {
                if ("string" != typeof e1) throw new TypeError("invalid pattern");
                if (e1.length > 65536) throw new TypeError("pattern is too long");
            };
            c.prototype.parse = function(e1, r) {
                f(e1);
                var a = this.options;
                if ("**" === e1) {
                    if (!a.noglobstar) return t;
                    e1 = "*";
                }
                if ("" === e1) return "";
                var u, l = "", c = !!a.nocase, p = !1, h = [], m = [], g = !1, y = -1, E = -1, x = "." === e1.charAt(0) ? "" : a.dot ? "(?!(?:^|\\/)\\.{1,2}(?:$|\\/))" : "(?!\\.)", C = this;
                function S() {
                    if (u) {
                        switch(u){
                            case "*":
                                l += i, c = !0;
                                break;
                            case "?":
                                l += s, c = !0;
                                break;
                            default:
                                l += "\\" + u;
                        }
                        C.debug("clearStateChar %j %j", u, l), u = !1;
                    }
                }
                for(var b, v = 0, A = e1.length; v < A && (b = e1.charAt(v)); v++)if (this.debug("%s\t%s %s %j", e1, v, l, b), p && o[b]) l += "\\" + b, p = !1;
                else switch(b){
                    case "/":
                        return !1;
                    case "\\":
                        S(), p = !0;
                        continue;
                    case "?":
                    case "*":
                    case "+":
                    case "@":
                    case "!":
                        if (this.debug("%s\t%s %s %j <-- stateChar", e1, v, l, b), g) {
                            this.debug("  in class"), "!" === b && v === E + 1 && (b = "^"), l += b;
                            continue;
                        }
                        C.debug("call clearStateChar %j", u), S(), u = b, a.noext && S();
                        continue;
                    case "(":
                        if (g) {
                            l += "(";
                            continue;
                        }
                        if (!u) {
                            l += "\\(";
                            continue;
                        }
                        h.push({
                            type: u,
                            start: v - 1,
                            reStart: l.length,
                            open: n[u].open,
                            close: n[u].close
                        }), l += "!" === u ? "(?:(?!(?:" : "(?:", this.debug("plType %j %j", u, l), u = !1;
                        continue;
                    case ")":
                        if (g || !h.length) {
                            l += "\\)";
                            continue;
                        }
                        S(), c = !0;
                        var T = h.pop();
                        l += T.close, "!" === T.type && m.push(T), T.reEnd = l.length;
                        continue;
                    case "|":
                        if (g || !h.length || p) {
                            l += "\\|", p = !1;
                            continue;
                        }
                        S(), l += "|";
                        continue;
                    case "[":
                        if (S(), g) {
                            l += "\\" + b;
                            continue;
                        }
                        g = !0, E = v, y = l.length, l += b;
                        continue;
                    case "]":
                        if (v === E + 1 || !g) {
                            l += "\\" + b, p = !1;
                            continue;
                        }
                        var R = e1.substring(E + 1, v);
                        try {
                            RegExp("[" + R + "]");
                        } catch (e1) {
                            var D = this.parse(R, d);
                            l = l.substr(0, y) + "\\[" + D[0] + "\\]", c = c || D[1], g = !1;
                            continue;
                        }
                        c = !0, g = !1, l += b;
                        continue;
                    default:
                        S(), p ? p = !1 : !o[b] || "^" === b && g || (l += "\\"), l += b;
                }
                for(g && (R = e1.substr(E + 1), D = this.parse(R, d), l = l.substr(0, y) + "\\[" + D[0], c = c || D[1]), T = h.pop(); T; T = h.pop()){
                    var w = l.slice(T.reStart + T.open.length);
                    this.debug("setting tail", l, T), w = w.replace(/((?:\\{2}){0,64})(\\?)\|/g, function(e1, t, r) {
                        return r || (r = "\\"), t + t + r + "|";
                    }), this.debug("tail=%j\n   %s", w, w, T, l);
                    var _ = "*" === T.type ? i : "?" === T.type ? s : "\\" + T.type;
                    c = !0, l = l.slice(0, T.reStart) + _ + "\\(" + w;
                }
                S(), p && (l += "\\\\");
                var k = !1;
                switch(l.charAt(0)){
                    case "[":
                    case ".":
                    case "(":
                        k = !0;
                }
                for(var B = m.length - 1; B > -1; B--){
                    var L = m[B], P = l.slice(0, L.reStart), I = l.slice(L.reStart, L.reEnd - 8), F = l.slice(L.reEnd - 8, L.reEnd), N = l.slice(L.reEnd);
                    F += N;
                    var O = P.split("(").length - 1, U = N;
                    for(v = 0; v < O; v++)U = U.replace(/\)[+*?]?/, "");
                    var j = "";
                    "" === (N = U) && r !== d && (j = "$"), l = P + I + N + j + F;
                }
                if ("" !== l && c && (l = "(?=.)" + l), k && (l = x + l), r === d) return [
                    l,
                    c
                ];
                if (!c) return function(e1) {
                    return e1.replace(/\\(.)/g, "$1");
                }(e1);
                var V = a.nocase ? "i" : "";
                try {
                    var K = new RegExp("^" + l + "$", V);
                } catch (e1) {
                    return new RegExp("$.");
                }
                return K._glob = e1, K._src = l, K;
            };
            var d = {};
            return l.makeRe = function(e1, t) {
                return new c(e1, t || {}).makeRe();
            }, c.prototype.makeRe = function() {
                if (this.regexp || !1 === this.regexp) return this.regexp;
                var e1 = this.set;
                if (!e1.length) return this.regexp = !1, this.regexp;
                var r = this.options, n = r.noglobstar ? i : r.dot ? "(?:(?!(?:\\/|^)(?:\\.{1,2})($|\\/)).)*?" : "(?:(?!(?:\\/|^)\\.).)*?", s = r.nocase ? "i" : "", o = e1.map(function(e1) {
                    return e1.map(function(e1) {
                        return e1 === t ? n : "string" == typeof e1 ? function(e1) {
                            return e1.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
                        }(e1) : e1._src;
                    }).join("\\/");
                }).join("|");
                o = "^(?:" + o + ")$", this.negate && (o = "^(?!" + o + ").*$");
                try {
                    this.regexp = new RegExp(o, s);
                } catch (e1) {
                    this.regexp = !1;
                }
                return this.regexp;
            }, l.match = function(e1, t, r) {
                var n = new c(t, r = r || {});
                return e1 = e1.filter(function(e1) {
                    return n.match(e1);
                }), n.options.nonull && !e1.length && e1.push(t), e1;
            }, c.prototype.match = function(t, r) {
                if (void 0 === r && (r = this.partial), this.debug("match", t, this.pattern), this.comment) return !1;
                if (this.empty) return "" === t;
                if ("/" === t && r) return !0;
                var n = this.options;
                "/" !== e1.sep && (t = t.split(e1.sep).join("/")), t = t.split(a), this.debug(this.pattern, "split", t);
                var s, i, o = this.set;
                for(this.debug(this.pattern, "set", o), i = t.length - 1; i >= 0 && !(s = t[i]); i--);
                for(i = 0; i < o.length; i++){
                    var u = o[i], l = t;
                    if (n.matchBase && 1 === u.length && (l = [
                        s
                    ]), this.matchOne(l, u, r)) return !!n.flipNegate || !this.negate;
                }
                return !n.flipNegate && this.negate;
            }, c.prototype.matchOne = function(e1, r, n) {
                var s = this.options;
                this.debug("matchOne", {
                    this: this,
                    file: e1,
                    pattern: r
                }), this.debug("matchOne", e1.length, r.length);
                for(var i = 0, o = 0, a = e1.length, u = r.length; i < a && o < u; i++, o++){
                    this.debug("matchOne loop");
                    var l, c = r[o], p = e1[i];
                    if (this.debug(r, c, p), !1 === c) return !1;
                    if (c === t) {
                        this.debug("GLOBSTAR", [
                            r,
                            c,
                            p
                        ]);
                        var f = i, d = o + 1;
                        if (d === u) {
                            for(this.debug("** at the end"); i < a; i++)if ("." === e1[i] || ".." === e1[i] || !s.dot && "." === e1[i].charAt(0)) return !1;
                            return !0;
                        }
                        for(; f < a;){
                            var h = e1[f];
                            if (this.debug("\nglobstar while", e1, f, r, d, h), this.matchOne(e1.slice(f), r.slice(d), n)) return this.debug("globstar found match!", f, a, h), !0;
                            if ("." === h || ".." === h || !s.dot && "." === h.charAt(0)) {
                                this.debug("dot detected!", e1, f, r, d);
                                break;
                            }
                            this.debug("globstar swallow a segment, and continue"), f++;
                        }
                        return !(!n || (this.debug("\n>>> no match, partial?", e1, f, r, d), f !== a));
                    }
                    if ("string" == typeof c ? (l = p === c, this.debug("string match", c, p, l)) : (l = p.match(c), this.debug("pattern match", c, p, l)), !l) return !1;
                }
                if (i === a && o === u) return !0;
                if (i === a) return n;
                if (o === u) return i === a - 1 && "" === e1[i];
                throw new Error("wtf?");
            }, qv;
        }(), r = Gi(), n = aA();
        const s = {
            required: !1,
            merge () {},
            validate () {}
        }, i = Object.freeze({
            name: {
                required: !1,
                merge () {},
                validate (e1) {
                    if ("string" != typeof e1) throw new TypeError("Property must be a string.");
                }
            },
            files: s,
            ignores: s
        });
        function o(e1, t) {
            if (function(e1) {
                if (!Array.isArray(e1)) throw new TypeError("Expected value to be an array.");
            }(e1), e1.some((e1)=>"string" != typeof e1 && "function" != typeof e1)) throw new TypeError("Expected array to only contain strings and functions.");
        }
        const a = Object.freeze({
            files: {
                required: !1,
                merge () {},
                validate (e1) {
                    !function(e1) {
                        if (!Array.isArray(e1) || 0 === e1.length) throw new TypeError("Expected value to be a non-empty array.");
                    }(e1), e1.forEach((e1)=>{
                        if (Array.isArray(e1)) o(e1);
                        else if ("string" != typeof e1 && "function" != typeof e1) throw new TypeError("Items must be a string, a function, or an array of strings and functions.");
                    });
                }
            },
            ignores: {
                required: !1,
                merge () {},
                validate: o
            }
        }), u = t.Minimatch, l = new Map, c = new Map, p = r("@hwc/config-array"), f = {
            dot: !0
        }, d = new Set([
            "array",
            "function"
        ]), h = new Set([
            "name"
        ]), m = new n.ObjectSchema(a);
        class g extends Error {
            constructor(e1, t, { cause: r, message: n }){
                if (super(`Config ${e1}: ${n || r.message}`, {
                    cause: r
                }), r) for (const e1 of Object.keys(r))e1 in this || (this[e1] = r[e1]);
                this.name = "ConfigError", this.index = t;
            }
        }
        function y(e1) {
            return e1 && "string" == typeof e1.name && e1.name ? `"${e1.name}"` : "(unnamed)";
        }
        function E(e1, t, r) {
            const n = y(e1);
            throw new g(n, t, r);
        }
        function x(e1, t) {
            if (null === e1) throw new g(y(e1), t, {
                message: "Unexpected null config."
            });
            if (void 0 === e1) throw new g(y(e1), t, {
                message: "Unexpected undefined config."
            });
            if ("object" != typeof e1) throw new g(y(e1), t, {
                message: "Unexpected non-object config."
            });
            const r = {};
            "files" in e1 && (r.files = e1.files), "ignores" in e1 && (r.ignores = e1.ignores);
            try {
                m.validate(r);
            } catch (r) {
                E(e1, t, {
                    cause: r
                });
            }
        }
        function C(e1, t, r = {}) {
            let n = l;
            r.flipNegate && (n = c);
            let s = n.get(t);
            return s || (s = new u(t, Object.assign({}, f, r)), n.set(t, s)), s.match(e1);
        }
        function S(e1, t, r) {
            return !!r.startsWith("..") || e1.reduce((e1, n)=>e1 ? "string" == typeof n && n.startsWith("!") ? !C(r, n, {
                    flipNegate: !0
                }) : e1 : "function" == typeof n ? n(t) : !n.startsWith("!") && C(r, n), !1);
        }
        function b(t, r, n) {
            const s = e1.relative(r, t), i = (e1)=>{
                if ("string" == typeof e1) return C(s, e1);
                if ("function" == typeof e1) return e1(t);
                throw new TypeError(`Unexpected matcher type ${e1}.`);
            };
            let o = n.files.some((e1)=>Array.isArray(e1) ? e1.every(i) : i(e1));
            return o && n.ignores && (o = !S(n.ignores, t, s)), o;
        }
        function v(e1) {
            if (!e1.isNormalized()) throw new Error("ConfigArray must be normalized to perform this operation.");
        }
        const A = {
            isNormalized: Symbol("isNormalized"),
            configCache: Symbol("configCache"),
            schema: Symbol("schema"),
            finalizeConfig: Symbol("finalizeConfig"),
            preprocessConfig: Symbol("preprocessConfig")
        }, T = new WeakMap;
        class R extends Array {
            constructor(e1, { basePath: t = "", normalized: r = !1, schema: s, extraConfigTypes: o = [] } = {}){
                super(), this[A.isNormalized] = r, this[A.schema] = new n.ObjectSchema(Object.assign({}, s, i)), this.basePath = t, function(e1) {
                    if (e1.length > 2) throw new TypeError("configTypes must be an array with at most two items.");
                    for (const t of e1)if (!d.has(t)) throw new TypeError(`Unexpected config type "${t}" found. Expected one of: "object", "array", "function".`);
                }(o), this.extraConfigTypes = Object.freeze([
                    ...o
                ]), this[A.configCache] = new Map, T.set(this, {
                    explicitMatches: new Map,
                    directoryMatches: new Map,
                    files: void 0,
                    ignores: void 0
                }), Array.isArray(e1) ? this.push(...e1) : this.push(e1);
            }
            static get [Symbol.species]() {
                return Array;
            }
            get files() {
                v(this);
                const e1 = T.get(this);
                if (e1.files) return e1.files;
                const t = [];
                for (const e1 of this)e1.files && e1.files.forEach((e1)=>{
                    t.push(e1);
                });
                return e1.files = t, T.set(this, e1), t;
            }
            get ignores() {
                v(this);
                const e1 = T.get(this);
                if (e1.ignores) return e1.ignores;
                const t = [];
                for (const e1 of this)e1.ignores && 1 === Object.keys(e1).filter((e1)=>!h.has(e1)).length && t.push(...e1.ignores);
                return e1.ignores = t, T.set(this, e1), t;
            }
            isNormalized() {
                return this[A.isNormalized];
            }
            async normalize(e1 = {}) {
                if (!this.isNormalized()) {
                    const t = await async function(e1, t, r) {
                        const n = r.includes("function"), s = r.includes("array"), i = await async function* e1(r) {
                            for (let i of r){
                                if ("function" == typeof i) {
                                    if (!n) throw new TypeError("Unexpected function.");
                                    i = i(t), i.then && (i = await i);
                                }
                                if (Array.isArray(i)) {
                                    if (!s) throw new TypeError("Unexpected array.");
                                    yield* e1(i);
                                } else {
                                    if ("function" == typeof i) throw new TypeError("A config function can only return an object or array.");
                                    yield i;
                                }
                            }
                        }(e1), o = [];
                        for await (const e1 of i)o.push(e1);
                        return o;
                    }(this, e1, this.extraConfigTypes);
                    this.length = 0, this.push(...t.map(this[A.preprocessConfig].bind(this))), this.forEach(x), this[A.isNormalized] = !0, Object.freeze(this);
                }
                return this;
            }
            normalizeSync(e1 = {}) {
                if (!this.isNormalized()) {
                    const t = function(e1, t, r) {
                        const n = r.includes("function"), s = r.includes("array");
                        return [
                            ...function* e1(r) {
                                for (let i of r){
                                    if ("function" == typeof i) {
                                        if (!n) throw new TypeError("Unexpected function.");
                                        if (i = i(t), i.then) throw new TypeError("Async config functions are not supported.");
                                    }
                                    if (Array.isArray(i)) {
                                        if (!s) throw new TypeError("Unexpected array.");
                                        yield* e1(i);
                                    } else {
                                        if ("function" == typeof i) throw new TypeError("A config function can only return an object or array.");
                                        yield i;
                                    }
                                }
                            }(e1)
                        ];
                    }(this, e1, this.extraConfigTypes);
                    this.length = 0, this.push(...t.map(this[A.preprocessConfig].bind(this))), this.forEach(x), this[A.isNormalized] = !0, Object.freeze(this);
                }
                return this;
            }
            [A.finalizeConfig](e1) {
                return e1;
            }
            [A.preprocessConfig](e1) {
                return e1;
            }
            isExplicitMatch(t) {
                v(this);
                const r = T.get(this);
                let n = r.explicitMatches.get(t);
                if ("boolean" == typeof n) return n;
                const s = e1.relative(this.basePath, t);
                if (S(this.ignores, t, s)) return p(`Ignoring ${t}`), r.explicitMatches.set(t, !1), !1;
                for (const e1 of this)if (e1.files && b(t, this.basePath, e1)) return p(`Matching config found for ${t}`), r.explicitMatches.set(t, !0), !0;
                return !1;
            }
            getConfig(t) {
                v(this);
                const r = this[A.configCache];
                if (r.has(t)) return r.get(t);
                let n;
                if (this.isDirectoryIgnored(e1.dirname(t))) return p(`Ignoring ${t} based on directory pattern`), r.set(t, n), n;
                const s = e1.relative(this.basePath, t);
                if (S(this.ignores, t, s)) return p(`Ignoring ${t} based on file pattern`), r.set(t, n), n;
                const i = [];
                let o = !1;
                const a = /\/\*{1,2}$/;
                return this.forEach((r, n)=>{
                    if (!r.files) return r.ignores ? function(t, r, n) {
                        const s = e1.relative(r, t);
                        return Object.keys(n).filter((e1)=>!h.has(e1)).length > 1 && !S(n.ignores, t, s);
                    }(t, this.basePath, r) ? (p(`Matching config found for ${t} (based on ignores: ${r.ignores})`), void i.push(n)) : void p(`Skipped config found for ${t} (based on ignores: ${r.ignores})`) : (p(`Anonymous universal config found for ${t}`), void i.push(n));
                    const s = r.files.filter((e1)=>a.test(e1));
                    if (s.length) {
                        p("Universal files patterns found. Checking carefully.");
                        const e1 = r.files.filter((e1)=>!a.test(e1));
                        return e1.length && b(t, this.basePath, {
                            files: e1,
                            ignores: r.ignores
                        }) ? (p(`Matching config found for ${t}`), i.push(n), void (o = !0)) : s.length && b(t, this.basePath, {
                            files: s,
                            ignores: r.ignores
                        }) ? (p(`Matching config found for ${t}`), void i.push(n)) : void 0;
                    }
                    return b(t, this.basePath, r) ? (p(`Matching config found for ${t}`), i.push(n), void (o = !0)) : void 0;
                }), o ? (n = r.get(i.toString()), n ? (r.set(t, n), n) : (n = i.reduce((e1, t)=>{
                    try {
                        return this[A.schema].merge(e1, this[t]);
                    } catch (e1) {
                        E(this[t], t, {
                            cause: e1
                        });
                    }
                }, {}, this), n = this[A.finalizeConfig](n), r.set(t, n), r.set(i.toString(), n), n)) : (p(`No matching configs found for ${t}`), r.set(t, n), n);
            }
            isIgnored(e1) {
                return this.isFileIgnored(e1);
            }
            isFileIgnored(e1) {
                return void 0 === this.getConfig(e1);
            }
            isDirectoryIgnored(t) {
                v(this);
                const r = e1.relative(this.basePath, t).replace(/\\/g, "/");
                if (r.startsWith("..")) return !0;
                const n = T.get(this).directoryMatches;
                if (n.has(r)) return n.get(r);
                const s = r.split("/");
                let i = "", o = !1;
                do i += s.shift() + "/", o = S(this.ignores, e1.join(this.basePath, i), i), n.set(i, o);
                while (!o && s.length);
                return n.set(r, o), o;
            }
        }
        return Xv.ConfigArray = R, Xv.ConfigArraySymbol = A, Xv;
    }
    var lA, cA, pA = {}, fA = {}, dA = {};
    function hA() {
        if (lA) return dA;
        lA = 1;
        dA.VOID = -1;
        dA.PRIMITIVE = 0;
        dA.ARRAY = 1;
        dA.OBJECT = 2;
        dA.DATE = 3;
        dA.REGEXP = 4;
        dA.MAP = 5;
        dA.SET = 6;
        dA.ERROR = 7;
        return dA.BIGINT = 8, dA;
    }
    function mA() {
        if (cA) return fA;
        cA = 1;
        const { VOID: e1, PRIMITIVE: t, ARRAY: r, OBJECT: n, DATE: s, REGEXP: i, MAP: o, SET: a, ERROR: u, BIGINT: l } = hA(), c = "object" == typeof self ? self : globalThis;
        return fA.deserialize = (p)=>((p, f)=>{
                const d = (e1, t)=>(p.set(t, e1), e1), h = (m)=>{
                    if (p.has(m)) return p.get(m);
                    const [g, y] = f[m];
                    switch(g){
                        case t:
                        case e1:
                            return d(y, m);
                        case r:
                            {
                                const e1 = d([], m);
                                for (const t of y)e1.push(h(t));
                                return e1;
                            }
                        case n:
                            {
                                const e1 = d({}, m);
                                for (const [t, r] of y)e1[h(t)] = h(r);
                                return e1;
                            }
                        case s:
                            return d(new Date(y), m);
                        case i:
                            {
                                const { source: e1, flags: t } = y;
                                return d(new RegExp(e1, t), m);
                            }
                        case o:
                            {
                                const e1 = d(new Map, m);
                                for (const [t, r] of y)e1.set(h(t), h(r));
                                return e1;
                            }
                        case a:
                            {
                                const e1 = d(new Set, m);
                                for (const t of y)e1.add(h(t));
                                return e1;
                            }
                        case u:
                            {
                                const { name: e1, message: t } = y;
                                return d(new c[e1](t), m);
                            }
                        case l:
                            return d(BigInt(y), m);
                        case "BigInt":
                            return d(Object(BigInt(y)), m);
                        case "ArrayBuffer":
                            return d(new Uint8Array(y).buffer, y);
                        case "DataView":
                            {
                                const { buffer: e1 } = new Uint8Array(y);
                                return d(new DataView(e1), y);
                            }
                    }
                    return d(new c[g](y), m);
                };
                return h;
            })(new Map, p)(0), fA;
    }
    var gA, yA, EA, xA, CA, SA, bA = {};
    function vA() {
        if (gA) return bA;
        gA = 1;
        const { VOID: e1, PRIMITIVE: t, ARRAY: r, OBJECT: n, DATE: s, REGEXP: i, MAP: o, SET: a, ERROR: u, BIGINT: l } = hA(), c = "", { toString: p } = {}, { keys: f } = Object, d = (e1)=>{
            const l = typeof e1;
            if ("object" !== l || !e1) return [
                t,
                l
            ];
            const f = p.call(e1).slice(8, -1);
            switch(f){
                case "Array":
                    return [
                        r,
                        c
                    ];
                case "Object":
                    return [
                        n,
                        c
                    ];
                case "Date":
                    return [
                        s,
                        c
                    ];
                case "RegExp":
                    return [
                        i,
                        c
                    ];
                case "Map":
                    return [
                        o,
                        c
                    ];
                case "Set":
                    return [
                        a,
                        c
                    ];
                case "DataView":
                    return [
                        r,
                        f
                    ];
            }
            return f.includes("Array") ? [
                r,
                f
            ] : f.includes("Error") ? [
                u,
                f
            ] : [
                n,
                f
            ];
        }, h = ([e1, r])=>e1 === t && ("function" === r || "symbol" === r);
        return bA.serialize = (u, { json: c, lossy: p } = {})=>{
            const m = [];
            return ((u, c, p, m)=>{
                const g = (e1, t)=>{
                    const r = m.push(e1) - 1;
                    return p.set(t, r), r;
                }, y = (m)=>{
                    if (p.has(m)) return p.get(m);
                    let [E, x] = d(m);
                    switch(E){
                        case t:
                            {
                                let t = m;
                                switch(x){
                                    case "bigint":
                                        E = l, t = m.toString();
                                        break;
                                    case "function":
                                    case "symbol":
                                        if (u) throw new TypeError("unable to serialize " + x);
                                        t = null;
                                        break;
                                    case "undefined":
                                        return g([
                                            e1
                                        ], m);
                                }
                                return g([
                                    E,
                                    t
                                ], m);
                            }
                        case r:
                            {
                                if (x) {
                                    let e1 = m;
                                    return "DataView" === x ? e1 = new Uint8Array(m.buffer) : "ArrayBuffer" === x && (e1 = new Uint8Array(m)), g([
                                        x,
                                        [
                                            ...e1
                                        ]
                                    ], m);
                                }
                                const e1 = [], t = g([
                                    E,
                                    e1
                                ], m);
                                for (const t of m)e1.push(y(t));
                                return t;
                            }
                        case n:
                            {
                                if (x) switch(x){
                                    case "BigInt":
                                        return g([
                                            x,
                                            m.toString()
                                        ], m);
                                    case "Boolean":
                                    case "Number":
                                    case "String":
                                        return g([
                                            x,
                                            m.valueOf()
                                        ], m);
                                }
                                if (c && "toJSON" in m) return y(m.toJSON());
                                const e1 = [], t = g([
                                    E,
                                    e1
                                ], m);
                                for (const t of f(m))!u && h(d(m[t])) || e1.push([
                                    y(t),
                                    y(m[t])
                                ]);
                                return t;
                            }
                        case s:
                            return g([
                                E,
                                m.toISOString()
                            ], m);
                        case i:
                            {
                                const { source: e1, flags: t } = m;
                                return g([
                                    E,
                                    {
                                        source: e1,
                                        flags: t
                                    }
                                ], m);
                            }
                        case o:
                            {
                                const e1 = [], t = g([
                                    E,
                                    e1
                                ], m);
                                for (const [t, r] of m)(u || !h(d(t)) && !h(d(r))) && e1.push([
                                    y(t),
                                    y(r)
                                ]);
                                return t;
                            }
                        case a:
                            {
                                const e1 = [], t = g([
                                    E,
                                    e1
                                ], m);
                                for (const t of m)!u && h(d(t)) || e1.push(y(t));
                                return t;
                            }
                    }
                    const { message: C } = m;
                    return g([
                        E,
                        {
                            name: x,
                            message: C
                        }
                    ], m);
                };
                return y;
            })(!(c || p), !!c, new Map, m)(u), m;
        }, bA;
    }
    function AA() {
        return yA || (yA = 1, function(e1) {
            const { deserialize: t } = mA(), { serialize: r } = vA();
            Object.defineProperty(e1, "__esModule", {
                value: !0
            }).default = "function" == typeof structuredClone ? (e1, n)=>n && ("json" in n || "lossy" in n) ? t(r(e1, n)) : structuredClone(e1) : (e1, n)=>t(r(e1, n)), e1.deserialize = t, e1.serialize = r;
        }(pA)), pA;
    }
    function TA() {
        if (xA) return EA;
        return xA = 1, EA = {
            normalizeSeverityToString: function(e1) {
                if ([
                    2,
                    "2",
                    "error"
                ].includes(e1)) return "error";
                if ([
                    1,
                    "1",
                    "warn"
                ].includes(e1)) return "warn";
                if ([
                    0,
                    "0",
                    "off"
                ].includes(e1)) return "off";
                throw new Error(`Invalid severity value: ${e1}`);
            },
            normalizeSeverityToNumber: function(e1) {
                if ([
                    2,
                    "2",
                    "error"
                ].includes(e1)) return 2;
                if ([
                    1,
                    "1",
                    "warn"
                ].includes(e1)) return 1;
                if ([
                    0,
                    "0",
                    "off"
                ].includes(e1)) return 0;
                throw new Error(`Invalid severity value: ${e1}`);
            }
        };
    }
    function RA() {
        if (SA) return CA;
        SA = 1;
        const e1 = AA().default, { normalizeSeverityToNumber: t } = TA(), r = new Map([
            [
                0,
                0
            ],
            [
                "off",
                0
            ],
            [
                1,
                1
            ],
            [
                "warn",
                1
            ],
            [
                2,
                2
            ],
            [
                "error",
                2
            ]
        ]), n = new Set([
            !0,
            "true",
            "writable",
            "writeable",
            !1,
            "false",
            "readonly",
            "readable",
            null,
            "off"
        ]);
        function s(e1) {
            return "object" == typeof e1 && null !== e1;
        }
        function i(e1) {
            return s(e1) && !Array.isArray(e1);
        }
        function o(e1, t, r = new Map) {
            let n = r.get(e1);
            if (n) {
                const e1 = n.get(t);
                if (e1) return e1;
            } else n = new Map, r.set(e1, n);
            const s = {
                ...e1,
                ...t
            };
            delete s.__proto__, n.set(t, s);
            for (const n of Object.keys(t)){
                if ("__proto__" === n || !Object.prototype.propertyIsEnumerable.call(e1, n)) continue;
                const a = e1[n], u = t[n];
                i(a) && i(u) ? s[n] = o(a, u, r) : void 0 === u && (s[n] = a);
            }
            return s;
        }
        function a(t) {
            const n = Array.isArray(t) ? t.slice(0) : [
                t
            ];
            return n[0] = r.get(n[0]), e1(n);
        }
        class u extends Error {
            constructor(e1, t){
                super(`Key "${e1}": Expected severity of "off", 0, "warn", 1, "error", or 2.`), this.messageTemplate = "invalid-rule-options", this.messageData = {
                    ruleId: e1,
                    value: t
                };
            }
        }
        function l(e1, t) {
            if ("string" != typeof t && "number" != typeof t && !Array.isArray(t)) throw new u(e1, t);
        }
        class c extends Error {
            constructor(e1, t){
                super(`Key "${e1}": Expected severity of "off", 0, "warn", 1, "error", or 2.`), this.messageTemplate = "invalid-rule-severity", this.messageData = {
                    ruleId: e1,
                    value: t
                };
            }
        }
        function p(e1, t) {
            if (void 0 === r.get(t)) throw new c(e1, t);
        }
        function f(e1) {
            if (!s(e1)) throw new TypeError("Expected an object.");
        }
        class d extends Error {
            constructor(e1){
                super("This appears to be in eslintrc format rather than flat config format."), this.messageTemplate = "eslintrc-incompat", this.messageData = {
                    key: e1
                };
            }
        }
        class h extends Error {
            constructor(e1){
                super("This appears to be in eslintrc format (array of strings) rather than flat config format (object)."), this.messageTemplate = "eslintrc-plugins", this.messageData = {
                    plugins: e1
                };
            }
        }
        const m = new Set([
            "error",
            "warn",
            "off",
            2,
            1,
            0
        ]), g = {
            merge (e1, r) {
                const n = void 0 === r ? e1 : r;
                return "boolean" == typeof n ? n ? "warn" : "off" : t(n);
            },
            validate (e1) {
                if (!m.has(e1) && "boolean" != typeof e1) throw new TypeError('Expected one of: "error", "warn", "off", 0, 1, 2, or a boolean.');
            }
        }, y = {
            merge: (e1 = {}, t = {})=>o(e1, t),
            validate: "object"
        }, E = {
            merge: "assign",
            validate (e1) {
                f(e1);
                for (const t of Object.keys(e1))if ("__proto__" !== t) {
                    if (t !== t.trim()) throw new TypeError(`Global "${t}" has leading or trailing whitespace.`);
                    if (!n.has(e1[t])) throw new TypeError(`Key "${t}": Expected "readonly", "writable", or "off".`);
                }
            }
        }, x = {
            merge: "replace",
            validate (e1) {
                if (!e1 || "object" != typeof e1 || "function" != typeof e1.parse && "function" != typeof e1.parseForESLint) throw new TypeError("Expected object with parse() or parseForESLint() method.");
            }
        }, C = {
            merge (e1 = {}, t = {}) {
                const r = new Set([
                    ...Object.keys(e1),
                    ...Object.keys(t)
                ]), n = {};
                for (const s of r)if ("__proto__" !== s) {
                    if (s in e1 && s in t && e1[s] !== t[s]) throw new TypeError(`Cannot redefine plugin "${s}".`);
                    n[s] = t[s] || e1[s];
                }
                return n;
            },
            validate (e1) {
                if (null === e1 || "object" != typeof e1) throw new TypeError("Expected an object.");
                if (Array.isArray(e1)) throw new h(e1);
                for (const t of Object.keys(e1))if ("__proto__" !== t && (null === e1[t] || "object" != typeof e1[t])) throw new TypeError(`Key "${t}": Expected an object.`);
            }
        }, S = {
            merge: "replace",
            validate (e1) {
                if ("string" == typeof e1) !function(e1) {
                    if (!/[@a-z0-9-_$]+(?:\/(?:[a-z0-9-_$]+))+$/iu.test(e1)) throw new TypeError(`Expected string in the form "pluginName/objectName" but found "${e1}".`);
                }(e1);
                else {
                    if (!e1 || "object" != typeof e1) throw new TypeError("Expected an object or a string.");
                    if ("function" != typeof e1.preprocess || "function" != typeof e1.postprocess) throw new TypeError("Object must have a preprocess() and a postprocess() method.");
                }
            }
        }, b = {
            merge (e1 = {}, t = {}) {
                const r = {
                    ...e1,
                    ...t
                };
                for (const n of Object.keys(r))try {
                    if ("__proto__" === n) {
                        delete r.__proto__;
                        continue;
                    }
                    if (r[n] = a(r[n]), !(n in e1) || !(n in t)) continue;
                    const s = a(e1[n]), i = a(t[n]);
                    if (1 === i.length) {
                        r[n] = [
                            i[0],
                            ...s.slice(1)
                        ];
                        continue;
                    }
                } catch (e1) {
                    throw new Error(`Key "${n}": ${e1.message}`, {
                        cause: e1
                    });
                }
                return r;
            },
            validate (e1) {
                f(e1);
                for (const t of Object.keys(e1)){
                    if ("__proto__" === t) continue;
                    const r = e1[t];
                    l(t, r), Array.isArray(r) ? p(t, r[0]) : p(t, r);
                }
            }
        }, v = {
            merge: "replace",
            validate (e1) {
                if ("number" != typeof e1 && "latest" !== e1) throw new TypeError('Expected a number or "latest".');
            }
        }, A = {
            merge: "replace",
            validate (e1) {
                if ("string" != typeof e1 || !/^(?:script|module|commonjs)$/u.test(e1)) throw new TypeError('Expected "script", "module", or "commonjs".');
            }
        };
        function T(e1) {
            return {
                merge: "replace",
                validate () {
                    throw new d(e1);
                }
            };
        }
        const R = {
            ...Object.fromEntries([
                "env",
                "extends",
                "globals",
                "ignorePatterns",
                "noInlineConfig",
                "overrides",
                "parser",
                "parserOptions",
                "reportUnusedDisableDirectives",
                "root"
            ].map((e1)=>[
                    e1,
                    T(e1)
                ])),
            settings: y,
            linterOptions: {
                schema: {
                    noInlineConfig: {
                        merge: "replace",
                        validate: "boolean"
                    },
                    reportUnusedDisableDirectives: g
                }
            },
            languageOptions: {
                schema: {
                    ecmaVersion: v,
                    sourceType: A,
                    globals: E,
                    parser: x,
                    parserOptions: y
                }
            },
            processor: S,
            plugins: C,
            rules: b
        };
        return CA = {
            flatConfigSchema: R,
            assertIsRuleSeverity: p,
            assertIsRuleOptions: l
        };
    }
    var DA, wA, _A, kA = {}, BA = {
        id: "http://json-schema.org/draft-04/schema#",
        $schema: "http://json-schema.org/draft-04/schema#",
        description: "Core schema meta-schema",
        definitions: {
            schemaArray: {
                type: "array",
                minItems: 1,
                items: {
                    $ref: "#"
                }
            },
            positiveInteger: {
                type: "integer",
                minimum: 0
            },
            positiveIntegerDefault0: {
                allOf: [
                    {
                        $ref: "#/definitions/positiveInteger"
                    },
                    {
                        default: 0
                    }
                ]
            },
            simpleTypes: {
                enum: [
                    "array",
                    "boolean",
                    "integer",
                    "null",
                    "number",
                    "object",
                    "string"
                ]
            },
            stringArray: {
                type: "array",
                items: {
                    type: "string"
                },
                minItems: 1,
                uniqueItems: !0
            }
        },
        type: "object",
        properties: {
            id: {
                type: "string"
            },
            $schema: {
                type: "string"
            },
            title: {
                type: "string"
            },
            description: {
                type: "string"
            },
            default: {},
            multipleOf: {
                type: "number",
                minimum: 0,
                exclusiveMinimum: !0
            },
            maximum: {
                type: "number"
            },
            exclusiveMaximum: {
                type: "boolean",
                default: !1
            },
            minimum: {
                type: "number"
            },
            exclusiveMinimum: {
                type: "boolean",
                default: !1
            },
            maxLength: {
                $ref: "#/definitions/positiveInteger"
            },
            minLength: {
                $ref: "#/definitions/positiveIntegerDefault0"
            },
            pattern: {
                type: "string",
                format: "regex"
            },
            additionalItems: {
                anyOf: [
                    {
                        type: "boolean"
                    },
                    {
                        $ref: "#"
                    }
                ],
                default: {}
            },
            items: {
                anyOf: [
                    {
                        $ref: "#"
                    },
                    {
                        $ref: "#/definitions/schemaArray"
                    }
                ],
                default: {}
            },
            maxItems: {
                $ref: "#/definitions/positiveInteger"
            },
            minItems: {
                $ref: "#/definitions/positiveIntegerDefault0"
            },
            uniqueItems: {
                type: "boolean",
                default: !1
            },
            maxProperties: {
                $ref: "#/definitions/positiveInteger"
            },
            minProperties: {
                $ref: "#/definitions/positiveIntegerDefault0"
            },
            required: {
                $ref: "#/definitions/stringArray"
            },
            additionalProperties: {
                anyOf: [
                    {
                        type: "boolean"
                    },
                    {
                        $ref: "#"
                    }
                ],
                default: {}
            },
            definitions: {
                type: "object",
                additionalProperties: {
                    $ref: "#"
                },
                default: {}
            },
            properties: {
                type: "object",
                additionalProperties: {
                    $ref: "#"
                },
                default: {}
            },
            patternProperties: {
                type: "object",
                additionalProperties: {
                    $ref: "#"
                },
                default: {}
            },
            dependencies: {
                type: "object",
                additionalProperties: {
                    anyOf: [
                        {
                            $ref: "#"
                        },
                        {
                            $ref: "#/definitions/stringArray"
                        }
                    ]
                }
            },
            enum: {
                type: "array",
                minItems: 1,
                uniqueItems: !0
            },
            type: {
                anyOf: [
                    {
                        $ref: "#/definitions/simpleTypes"
                    },
                    {
                        type: "array",
                        items: {
                            $ref: "#/definitions/simpleTypes"
                        },
                        minItems: 1,
                        uniqueItems: !0
                    }
                ]
            },
            format: {
                type: "string"
            },
            allOf: {
                $ref: "#/definitions/schemaArray"
            },
            anyOf: {
                $ref: "#/definitions/schemaArray"
            },
            oneOf: {
                $ref: "#/definitions/schemaArray"
            },
            not: {
                $ref: "#"
            }
        },
        dependencies: {
            exclusiveMaximum: [
                "maximum"
            ],
            exclusiveMinimum: [
                "minimum"
            ]
        },
        default: {}
    };
    function LA() {
        if (wA) return DA;
        wA = 1;
        const e1 = qs(), t = BA;
        return DA = (r = {})=>{
            const n = new e1({
                meta: !1,
                useDefaults: !0,
                validateSchema: !1,
                missingRefs: "ignore",
                verbose: !0,
                schemaId: "auto",
                ...r
            });
            return n.addMetaSchema(t), n._opts.defaultMeta = t.id, n;
        };
    }
    function PA() {
        if (_A) return kA;
        _A = 1;
        const e1 = LA()(), { parseRuleId: t, getRuleFromConfig: r, getRuleOptionsSchema: n } = Ov(), s = Nv;
        function i({ pluginName: e1, ruleName: t }, r) {
            const n = `Key "rules": Key "${"@" === e1 ? t : `${e1}/${t}`}"`;
            let i = `${n}: Could not find plugin "${e1}".`;
            if (r.plugins && r.plugins[e1]) {
                const o = s.rules[t];
                if ("@" === e1 && o) i = `${n}: Rule "${t}" was removed and replaced by "${o}".`;
                else {
                    i = `${n}: Could not find "${t}" in plugin "${e1}".`;
                    for (const [e1, n] of Object.entries(r.plugins))if (n.rules && n.rules[t]) {
                        i += ` Did you mean "${e1}/${t}"?`;
                        break;
                    }
                }
            }
            throw new TypeError(i);
        }
        return kA.RuleValidator = class {
            constructor(){
                this.validators = new WeakMap;
            }
            validate(s) {
                if (s.rules) for (const [o, a] of Object.entries(s.rules)){
                    if ("__proto__" === o) continue;
                    if (0 === a[0]) continue;
                    const u = r(o, s);
                    if (u || i(t(o), s), !this.validators.has(u)) {
                        const t = n(u);
                        t && this.validators.set(u, e1.compile(t));
                    }
                    const l = this.validators.get(u);
                    if (l && (l(a.slice(1)), l.errors)) throw new Error(`Key "rules": Key "${o}": ${l.errors.map((e1)=>`\tValue ${JSON.stringify(e1.data)} ${e1.message}.\n`).join("")}`);
                }
            }
        }, kA;
    }
    var IA, FA, NA, OA, UA, jA, VA, KA, MA, $A, qA = {};
    function GA() {
        if (IA) return qA;
        IA = 1;
        const e1 = Bv();
        return qA.defaultConfig = [
            {
                plugins: {
                    "@": {
                        rules: new Proxy({}, {
                            get: (t, r)=>e1.get(r),
                            has: (t, r)=>e1.has(r)
                        })
                    }
                },
                languageOptions: {
                    sourceType: "module",
                    ecmaVersion: "latest",
                    parser: wr(),
                    parserOptions: {}
                }
            },
            {
                ignores: [
                    "**/node_modules/",
                    ".git/"
                ]
            },
            {
                files: [
                    "**/*.js",
                    "**/*.mjs"
                ]
            },
            {
                files: [
                    "**/*.cjs"
                ],
                languageOptions: {
                    sourceType: "commonjs",
                    ecmaVersion: "latest"
                }
            }
        ], qA;
    }
    function WA() {
        if (KA) return Wv;
        KA = 1;
        const { ConfigArray: e1, ConfigArraySymbol: t } = uA(), { flatConfigSchema: r } = RA(), { RuleValidator: n } = PA(), { defaultConfig: s } = GA(), i = VA ? jA : (VA = 1, jA = {
            configs: {
                all: NA ? FA : (NA = 1, FA = Object.freeze({
                    rules: {
                        "accessor-pairs": "error",
                        "array-callback-return": "error",
                        "arrow-body-style": "error",
                        "block-scoped-var": "error",
                        camelcase: "error",
                        "capitalized-comments": "error",
                        "class-methods-use-this": "error",
                        complexity: "error",
                        "consistent-return": "error",
                        "consistent-this": "error",
                        "constructor-super": "error",
                        curly: "error",
                        "default-case": "error",
                        "default-case-last": "error",
                        "default-param-last": "error",
                        "dot-notation": "error",
                        eqeqeq: "error",
                        "for-direction": "error",
                        "func-name-matching": "error",
                        "func-names": "error",
                        "func-style": "error",
                        "getter-return": "error",
                        "grouped-accessor-pairs": "error",
                        "guard-for-in": "error",
                        "id-denylist": "error",
                        "id-length": "error",
                        "id-match": "error",
                        "init-declarations": "error",
                        "line-comment-position": "error",
                        "logical-assignment-operators": "error",
                        "max-classes-per-file": "error",
                        "max-depth": "error",
                        "max-lines": "error",
                        "max-lines-per-function": "error",
                        "max-nested-callbacks": "error",
                        "max-params": "error",
                        "max-statements": "error",
                        "multiline-comment-style": "error",
                        "new-cap": "error",
                        "no-alert": "error",
                        "no-array-constructor": "error",
                        "no-async-promise-executor": "error",
                        "no-await-in-loop": "error",
                        "no-bitwise": "error",
                        "no-caller": "error",
                        "no-case-declarations": "error",
                        "no-class-assign": "error",
                        "no-compare-neg-zero": "error",
                        "no-cond-assign": "error",
                        "no-console": "error",
                        "no-const-assign": "error",
                        "no-constant-binary-expression": "error",
                        "no-constant-condition": "error",
                        "no-constructor-return": "error",
                        "no-continue": "error",
                        "no-control-regex": "error",
                        "no-debugger": "error",
                        "no-delete-var": "error",
                        "no-div-regex": "error",
                        "no-dupe-args": "error",
                        "no-dupe-class-members": "error",
                        "no-dupe-else-if": "error",
                        "no-dupe-keys": "error",
                        "no-duplicate-case": "error",
                        "no-duplicate-imports": "error",
                        "no-else-return": "error",
                        "no-empty": "error",
                        "no-empty-character-class": "error",
                        "no-empty-function": "error",
                        "no-empty-pattern": "error",
                        "no-empty-static-block": "error",
                        "no-eq-null": "error",
                        "no-eval": "error",
                        "no-ex-assign": "error",
                        "no-extend-native": "error",
                        "no-extra-bind": "error",
                        "no-extra-boolean-cast": "error",
                        "no-extra-label": "error",
                        "no-fallthrough": "error",
                        "no-func-assign": "error",
                        "no-global-assign": "error",
                        "no-implicit-coercion": "error",
                        "no-implicit-globals": "error",
                        "no-implied-eval": "error",
                        "no-import-assign": "error",
                        "no-inline-comments": "error",
                        "no-inner-declarations": "error",
                        "no-invalid-regexp": "error",
                        "no-invalid-this": "error",
                        "no-irregular-whitespace": "error",
                        "no-iterator": "error",
                        "no-label-var": "error",
                        "no-labels": "error",
                        "no-lone-blocks": "error",
                        "no-lonely-if": "error",
                        "no-loop-func": "error",
                        "no-loss-of-precision": "error",
                        "no-magic-numbers": "error",
                        "no-misleading-character-class": "error",
                        "no-multi-assign": "error",
                        "no-multi-str": "error",
                        "no-negated-condition": "error",
                        "no-nested-ternary": "error",
                        "no-new": "error",
                        "no-new-func": "error",
                        "no-new-native-nonconstructor": "error",
                        "no-new-symbol": "error",
                        "no-new-wrappers": "error",
                        "no-nonoctal-decimal-escape": "error",
                        "no-obj-calls": "error",
                        "no-object-constructor": "error",
                        "no-octal": "error",
                        "no-octal-escape": "error",
                        "no-param-reassign": "error",
                        "no-plusplus": "error",
                        "no-promise-executor-return": "error",
                        "no-proto": "error",
                        "no-prototype-builtins": "error",
                        "no-redeclare": "error",
                        "no-regex-spaces": "error",
                        "no-restricted-exports": "error",
                        "no-restricted-globals": "error",
                        "no-restricted-imports": "error",
                        "no-restricted-properties": "error",
                        "no-restricted-syntax": "error",
                        "no-return-assign": "error",
                        "no-script-url": "error",
                        "no-self-assign": "error",
                        "no-self-compare": "error",
                        "no-sequences": "error",
                        "no-setter-return": "error",
                        "no-shadow": "error",
                        "no-shadow-restricted-names": "error",
                        "no-sparse-arrays": "error",
                        "no-template-curly-in-string": "error",
                        "no-ternary": "error",
                        "no-this-before-super": "error",
                        "no-throw-literal": "error",
                        "no-undef": "error",
                        "no-undef-init": "error",
                        "no-undefined": "error",
                        "no-underscore-dangle": "error",
                        "no-unexpected-multiline": "error",
                        "no-unmodified-loop-condition": "error",
                        "no-unneeded-ternary": "error",
                        "no-unreachable": "error",
                        "no-unreachable-loop": "error",
                        "no-unsafe-finally": "error",
                        "no-unsafe-negation": "error",
                        "no-unsafe-optional-chaining": "error",
                        "no-unused-expressions": "error",
                        "no-unused-labels": "error",
                        "no-unused-private-class-members": "error",
                        "no-unused-vars": "error",
                        "no-use-before-define": "error",
                        "no-useless-backreference": "error",
                        "no-useless-call": "error",
                        "no-useless-catch": "error",
                        "no-useless-computed-key": "error",
                        "no-useless-concat": "error",
                        "no-useless-constructor": "error",
                        "no-useless-escape": "error",
                        "no-useless-rename": "error",
                        "no-useless-return": "error",
                        "no-var": "error",
                        "no-void": "error",
                        "no-warning-comments": "error",
                        "no-with": "error",
                        "object-shorthand": "error",
                        "one-var": "error",
                        "operator-assignment": "error",
                        "prefer-arrow-callback": "error",
                        "prefer-const": "error",
                        "prefer-destructuring": "error",
                        "prefer-exponentiation-operator": "error",
                        "prefer-named-capture-group": "error",
                        "prefer-numeric-literals": "error",
                        "prefer-object-has-own": "error",
                        "prefer-object-spread": "error",
                        "prefer-promise-reject-errors": "error",
                        "prefer-regex-literals": "error",
                        "prefer-rest-params": "error",
                        "prefer-spread": "error",
                        "prefer-template": "error",
                        radix: "error",
                        "require-atomic-updates": "error",
                        "require-await": "error",
                        "require-unicode-regexp": "error",
                        "require-yield": "error",
                        "sort-imports": "error",
                        "sort-keys": "error",
                        "sort-vars": "error",
                        strict: "error",
                        "symbol-description": "error",
                        "unicode-bom": "error",
                        "use-isnan": "error",
                        "valid-typeof": "error",
                        "vars-on-top": "error",
                        yoda: "error"
                    }
                })),
                recommended: UA ? OA : (UA = 1, OA = Object.freeze({
                    rules: Object.freeze({
                        "constructor-super": "error",
                        "for-direction": "error",
                        "getter-return": "error",
                        "no-async-promise-executor": "error",
                        "no-case-declarations": "error",
                        "no-class-assign": "error",
                        "no-compare-neg-zero": "error",
                        "no-cond-assign": "error",
                        "no-const-assign": "error",
                        "no-constant-condition": "error",
                        "no-control-regex": "error",
                        "no-debugger": "error",
                        "no-delete-var": "error",
                        "no-dupe-args": "error",
                        "no-dupe-class-members": "error",
                        "no-dupe-else-if": "error",
                        "no-dupe-keys": "error",
                        "no-duplicate-case": "error",
                        "no-empty": "error",
                        "no-empty-character-class": "error",
                        "no-empty-pattern": "error",
                        "no-ex-assign": "error",
                        "no-extra-boolean-cast": "error",
                        "no-extra-semi": "error",
                        "no-fallthrough": "error",
                        "no-func-assign": "error",
                        "no-global-assign": "error",
                        "no-import-assign": "error",
                        "no-inner-declarations": "error",
                        "no-invalid-regexp": "error",
                        "no-irregular-whitespace": "error",
                        "no-loss-of-precision": "error",
                        "no-misleading-character-class": "error",
                        "no-mixed-spaces-and-tabs": "error",
                        "no-new-symbol": "error",
                        "no-nonoctal-decimal-escape": "error",
                        "no-obj-calls": "error",
                        "no-octal": "error",
                        "no-prototype-builtins": "error",
                        "no-redeclare": "error",
                        "no-regex-spaces": "error",
                        "no-self-assign": "error",
                        "no-setter-return": "error",
                        "no-shadow-restricted-names": "error",
                        "no-sparse-arrays": "error",
                        "no-this-before-super": "error",
                        "no-undef": "error",
                        "no-unexpected-multiline": "error",
                        "no-unreachable": "error",
                        "no-unsafe-finally": "error",
                        "no-unsafe-negation": "error",
                        "no-unsafe-optional-chaining": "error",
                        "no-unused-labels": "error",
                        "no-unused-vars": "error",
                        "no-useless-backreference": "error",
                        "no-useless-catch": "error",
                        "no-useless-escape": "error",
                        "no-with": "error",
                        "require-yield": "error",
                        "use-isnan": "error",
                        "valid-typeof": "error"
                    })
                }))
            }
        }), o = new Set([
            "name"
        ]), a = new n;
        function u(e1) {
            let t = e1.name;
            if (!t) {
                if (!e1.meta) return null;
                if (t = e1.meta.name, !t) return null;
            }
            let r = e1.version;
            return r || (r = e1.meta && e1.meta.version), r ? `${t}@${r}` : t;
        }
        function l(e1, t, r) {
            let n = "user-defined", s = e1.index;
            return e1.index < r ? n = "base" : e1.index < t + r ? (n = "original", s = e1.index - r) : s = e1.index - t - r, new TypeError(`${e1.message.slice(0, -1)} at ${n} index ${s}.`, {
                cause: e1
            });
        }
        const c = Symbol("originalBaseConfig"), p = Symbol("originalLength"), f = Symbol("baseLength");
        class d extends e1 {
            constructor(e1, { basePath: t, shouldIgnore: n = !0, baseConfig: i = s } = {}){
                super(e1, {
                    basePath: t,
                    schema: r
                }), this[p] = this.length, i[Symbol.iterator] ? this.unshift(...i) : this.unshift(i), this[f] = this.length - this[p], this[c] = i, Object.defineProperty(this, c, {
                    writable: !1
                }), this.shouldIgnore = n, Object.defineProperty(this, "shouldIgnore", {
                    writable: !1
                });
            }
            normalize(e1) {
                return super.normalize(e1).catch((e1)=>{
                    if ("ConfigError" === e1.name) throw l(e1, this[p], this[f]);
                    throw e1;
                });
            }
            normalizeSync(e1) {
                try {
                    return super.normalizeSync(e1);
                } catch (e1) {
                    if ("ConfigError" === e1.name) throw l(e1, this[p], this[f]);
                    throw e1;
                }
            }
            [t.preprocessConfig](e1) {
                if ("eslint:recommended" === e1) return void 0 !== k && k.emitWarning && k.emitWarning("The 'eslint:recommended' string configuration is deprecated and will be replaced by the @eslint/js package's 'recommended' config."), i.configs.recommended;
                if ("eslint:all" === e1) return void 0 !== k && k.emitWarning && k.emitWarning("The 'eslint:all' string configuration is deprecated and will be replaced by the @eslint/js package's 'all' config."), i.configs.all;
                if (!this.shouldIgnore && !this[c].includes(e1) && e1.ignores && 1 === Object.keys(e1).filter((e1)=>!o.has(e1)).length) {
                    const { ignores: t, ...r } = e1;
                    return r;
                }
                return e1;
            }
            [t.finalizeConfig](e1) {
                const { plugins: t, languageOptions: r, processor: n } = e1;
                let s, i, o = !1, l = !1;
                if (r && r.parser) {
                    const { parser: e1 } = r;
                    "object" == typeof e1 ? (s = u(e1), s || (o = !0)) : o = !0;
                }
                if (n) {
                    if ("string" == typeof n) {
                        const { pluginName: r, objectName: s } = function(e1) {
                            const t = e1.split("/");
                            return {
                                objectName: t.pop(),
                                pluginName: t.join("/")
                            };
                        }(n);
                        if (i = n, !(t && t[r] && t[r].processors && t[r].processors[s])) throw new TypeError(`Key "processor": Could not find "${s}" in plugin "${r}".`);
                        e1.processor = t[r].processors[s];
                    } else "object" == typeof n ? (i = u(n), i || (l = !0)) : l = !0;
                }
                return a.validate(e1), Object.defineProperty(e1, "toJSON", {
                    value: function() {
                        if (o) throw new Error("Could not serialize parser object (missing 'meta' object).");
                        if (l) throw new Error("Could not serialize processor object (missing 'meta' object).");
                        return {
                            ...this,
                            plugins: Object.entries(t).map(([e1, t])=>{
                                const r = u(t);
                                return r ? `${e1}:${r}` : e1;
                            }),
                            languageOptions: {
                                ...r,
                                parser: s
                            },
                            processor: i
                        };
                    }
                }), e1;
            }
        }
        return Wv.FlatConfigArray = d, Wv;
    }
    function XA() {
        if ($A) return MA;
        $A = 1;
        const e1 = G, t = dr(), r = gr(), n = wr(), s = Lr(), i = Or, o = Ur(), { directivesPattern: a } = jr(), { Legacy: { ConfigOps: u, ConfigValidator: l, environments: c } } = Qs(), p = Wi(), { SourceCode: f } = xa ? Ea : (xa = 1, Ea = {
            SourceCode: qa()
        }), d = Ha(), h = Qa(), m = $a(), g = _u(), y = Bu(), E = Lv(), x = hv ? dv : (hv = 1, dv = ()=>{
            const e1 = Object.create(null);
            return Object.freeze({
                on (t, r) {
                    t in e1 ? e1[t].push(r) : e1[t] = [
                        r
                    ];
                },
                emit (t, ...r) {
                    t in e1 && e1[t].forEach((e1)=>e1(...r));
                },
                eventNames: ()=>Object.keys(e1)
            });
        }), C = function() {
            if (gv) return mv;
            gv = 1;
            const e1 = Gi()("eslint:source-code-fixer");
            function t(e1, t) {
                return e1.fix.range[0] - t.fix.range[0] || e1.fix.range[1] - t.fix.range[1];
            }
            function r(e1, t) {
                return e1.line - t.line || e1.column - t.column;
            }
            function n() {
                Object.freeze(this);
            }
            return n.applyFixes = function(n, s, i) {
                if (e1("Applying fixes"), !1 === i) return e1("shouldFix parameter was false, not attempting fixes"), {
                    fixed: !1,
                    messages: s,
                    output: n
                };
                const o = [], a = [], u = n.startsWith("\ufeff") ? "\ufeff" : "", l = u ? n.slice(1) : n;
                let c = Number.NEGATIVE_INFINITY, p = u;
                function f(e1) {
                    const t = e1.fix, r = t.range[0], n = t.range[1];
                    return c >= r || r > n ? (o.push(e1), !1) : ((r < 0 && n >= 0 || 0 === r && t.text.startsWith("\ufeff")) && (p = ""), p += l.slice(Math.max(0, c), Math.max(0, r)), p += t.text, c = n, !0);
                }
                if (s.forEach((e1)=>{
                    Object.prototype.hasOwnProperty.call(e1, "fix") ? a.push(e1) : o.push(e1);
                }), a.length) {
                    e1("Found fixes to apply");
                    let n = !1;
                    for (const e1 of a.sort(t))"function" != typeof i || i(e1) ? (f(e1), n = !0) : o.push(e1);
                    return p += l.slice(Math.max(0, c)), {
                        fixed: n,
                        messages: o.sort(r),
                        output: p
                    };
                }
                return e1("No fixes to apply"), {
                    fixed: !1,
                    messages: s,
                    output: u + l
                };
            }, mv = n;
        }(), S = Pv(), b = Nv, { getRuleFromConfig: v } = Ov(), { FlatConfigArray: A } = WA(), { RuleValidator: T } = PA(), { assertIsRuleOptions: R, assertIsRuleSeverity: D } = RA(), { normalizeSeverityToString: w } = TA(), _ = Gi()("eslint:linter"), B = new m, L = {
            start: {
                line: 1,
                column: 0
            },
            end: {
                line: 1,
                column: 1
            }
        }, P = Symbol.for("eslint.RuleTester.parser");
        function I(e1) {
            return !(e1 !== n && e1[P] !== n);
        }
        function F(e1) {
            return Object.prototype.hasOwnProperty.call(b.rules, e1) ? `Rule '${e1}' was removed and replaced by: ${b.rules[e1].join(", ")}` : `Definition for rule '${e1}' was not found.`;
        }
        function N(e1) {
            const { ruleId: t = null, loc: r = L, message: n = F(e1.ruleId), severity: s = 2 } = e1;
            return {
                ruleId: t,
                message: n,
                line: r.start.line,
                column: r.start.column + 1,
                endLine: r.end.line,
                endColumn: r.end.column + 1,
                severity: s,
                nodeType: null
            };
        }
        function O(e1) {
            const { commentToken: t, type: r, value: n, justification: s, ruleMapper: i } = e1, o = Object.keys(B.parseListConfig(n)), a = o.length ? o : [
                null
            ], u = {
                directives: [],
                directiveProblems: []
            }, l = {
                commentToken: t,
                ruleIds: o
            };
            for (const e1 of a)null === e1 || i(e1) ? "disable-next-line" === r ? u.directives.push({
                parentComment: l,
                type: r,
                line: t.loc.end.line,
                column: t.loc.end.column + 1,
                ruleId: e1,
                justification: s
            }) : u.directives.push({
                parentComment: l,
                type: r,
                line: t.loc.start.line,
                column: t.loc.start.column + 1,
                ruleId: e1,
                justification: s
            }) : u.directiveProblems.push(N({
                ruleId: e1,
                loc: t.loc
            }));
            return u;
        }
        function U(e1) {
            switch(e1){
                case 3:
                    return 3;
                case 5:
                case void 0:
                    return 5;
                default:
                    if ("number" == typeof e1) return e1 >= 2015 ? e1 : e1 + 2009;
            }
            return n.latestEcmaVersion + 2009;
        }
        const j = /\/\*\s*eslint-env\s(.+?)(?:\*\/|$)/gsu;
        function V(t) {
            const r = t.split(e1.sep), n = r.lastIndexOf("<text>");
            return -1 === n ? t : r.slice(n).join(e1.sep);
        }
        function K(e1, t) {
            const r = t.linterOptions || t, n = !0 === r.noInlineConfig, s = !1 === e1.allowInlineConfig, i = t.configNameOfNoInlineConfig ? ` (${t.configNameOfNoInlineConfig})` : "";
            let o = e1.reportUnusedDisableDirectives;
            return "boolean" == typeof o && (o = o ? "error" : "off"), "string" != typeof o && (o = "boolean" == typeof r.reportUnusedDisableDirectives ? r.reportUnusedDisableDirectives ? "warn" : "off" : void 0 === r.reportUnusedDisableDirectives ? "off" : w(r.reportUnusedDisableDirectives)), {
                filename: V(e1.filename || "<input>"),
                allowInlineConfig: !s,
                warnInlineConfig: n && !s ? `your config${i}` : null,
                reportUnusedDisableDirectives: o,
                disableFixes: Boolean(e1.disableFixes)
            };
        }
        function M(e1, t, r) {
            const i = r.filter((e1)=>e1.parserOptions).reduce((e1, t)=>s(e1, t.parserOptions), {}), o = s(i, t || {});
            return "module" === o.sourceType && (o.ecmaFeatures = Object.assign({}, o.ecmaFeatures, {
                globalReturn: !1
            })), o.ecmaVersion = function(e1, t) {
                return I(e1) && "latest" === t ? n.latestEcmaVersion : t >= 2015 ? t - 2009 : t;
            }(e1, o.ecmaVersion), o;
        }
        function $(e1, n, s) {
            const i = n.parserOptions.ecmaFeatures || {}, o = n.ecmaVersion || 5;
            return t.analyze(e1, {
                ignoreEval: !0,
                nodejsScope: i.globalReturn,
                impliedStrict: i.impliedStrict,
                ecmaVersion: "number" == typeof o ? o : 6,
                sourceType: n.sourceType || "script",
                childVisitorKeys: s || r.KEYS,
                fallback: p.getKeys
            });
        }
        function q(e1, t, n) {
            const s = (function(e1) {
                return 65279 === e1.charCodeAt(0) ? e1.slice(1) : e1;
            })(e1).replace(o.shebangPattern, (e1, t)=>`//${t}`), { ecmaVersion: i, sourceType: a, parser: u } = t, l = Object.assign({
                ecmaVersion: i,
                sourceType: a
            }, t.parserOptions, {
                loc: !0,
                range: !0,
                raw: !0,
                tokens: !0,
                comment: !0,
                eslintVisitorKeys: !0,
                eslintScopeManager: !0,
                filePath: n
            });
            try {
                _("Parsing:", n);
                const i = "function" == typeof u.parseForESLint ? u.parseForESLint(s, l) : {
                    ast: u.parse(s, l)
                };
                _("Parsing successful:", n);
                const o = i.ast, a = i.services || {}, c = i.visitorKeys || r.KEYS;
                _("Scope analysis:", n);
                const p = i.scopeManager || $(o, t, c);
                return _("Scope analysis successful:", n), {
                    success: !0,
                    sourceCode: new f({
                        text: e1,
                        ast: o,
                        parserServices: a,
                        scopeManager: p,
                        visitorKeys: c
                    })
                };
            } catch (e1) {
                const t = `Parsing error: ${e1.message.replace(/^line \d+:/iu, "").trim()}`;
                return _("%s\n%s", t, e1.stack), {
                    success: !1,
                    error: {
                        ruleId: null,
                        fatal: !0,
                        severity: 2,
                        message: t,
                        line: e1.lineNumber,
                        column: e1.column,
                        nodeType: null
                    }
                };
            }
        }
        function W(e1, t) {
            try {
                return e1.create(t);
            } catch (e1) {
                throw e1.message = `Error while loading rule '${t.id}': ${e1.message}`, e1;
            }
        }
        const X = {
            getSource: "getText",
            getSourceLines: "getLines",
            getAllComments: "getAllComments",
            getNodeByRangeIndex: "getNodeByRangeIndex",
            getComments: "getComments",
            getCommentsBefore: "getCommentsBefore",
            getCommentsAfter: "getCommentsAfter",
            getCommentsInside: "getCommentsInside",
            getJSDocComment: "getJSDocComment",
            getFirstToken: "getFirstToken",
            getFirstTokens: "getFirstTokens",
            getLastToken: "getLastToken",
            getLastTokens: "getLastTokens",
            getTokenAfter: "getTokenAfter",
            getTokenBefore: "getTokenBefore",
            getTokenByRangeStart: "getTokenByRangeStart",
            getTokens: "getTokens",
            getTokensAfter: "getTokensAfter",
            getTokensBefore: "getTokensBefore",
            getTokensBetween: "getTokensBetween"
        }, z = Object.freeze(Object.keys(X).reduce((e1, t)=>Object.assign(e1, {
                [t] (...e1) {
                    return this.sourceCode[X[t]](...e1);
                }
            }), {}));
        function H(e1, t, r, n, s, i, o, a, l, c) {
            const f = x(), h = [];
            let m = e1.ast;
            p.traverse(e1.ast, {
                enter (e1, t) {
                    e1.parent = t, h.push({
                        isEntering: !0,
                        node: e1
                    });
                },
                leave (e1) {
                    h.push({
                        isEntering: !1,
                        node: e1
                    });
                },
                visitorKeys: e1.visitorKeys
            });
            const E = Object.freeze(Object.assign(Object.create(z), {
                getAncestors: ()=>e1.getAncestors(m),
                getDeclaredVariables: (t)=>e1.getDeclaredVariables(t),
                getCwd: ()=>l,
                cwd: l,
                getFilename: ()=>o,
                filename: o,
                getPhysicalFilename: ()=>c || o,
                physicalFilename: c || o,
                getScope: ()=>e1.getScope(m),
                getSourceCode: ()=>e1,
                sourceCode: e1,
                markVariableAsUsed: (t)=>e1.markVariableAsUsed(t, m),
                parserOptions: {
                    ...s.parserOptions
                },
                parserPath: n,
                languageOptions: s,
                parserServices: e1.parserServices,
                settings: i
            })), C = [];
            Object.keys(t).forEach((n)=>{
                const s = u.getRuleSeverity(t[n]);
                if (0 === s) return;
                const i = r(n);
                if (!i) return void C.push(N({
                    ruleId: n
                }));
                const o = i.meta && i.meta.messages;
                let l = null;
                const c = Object.freeze(Object.assign(Object.create(E), {
                    id: n,
                    options: (p = t[n], Array.isArray(p) ? p.slice(1) : []),
                    report (...t) {
                        null === l && (l = y({
                            ruleId: n,
                            severity: s,
                            sourceCode: e1,
                            messageIds: o,
                            disableFixes: a
                        }));
                        const r = l(...t);
                        if (r.fix && (!i.meta || !i.meta.fixable)) throw new Error('Fixable rules must set the `meta.fixable` property to "code" or "whitespace".');
                        if (r.suggestions && (!i.meta || !0 !== i.meta.hasSuggestions)) {
                            if (i.meta && i.meta.docs && void 0 !== i.meta.docs.suggestion) throw new Error("Rules with suggestions must set the `meta.hasSuggestions` property to `true`. `meta.docs.suggestion` is ignored by ESLint.");
                            throw new Error("Rules with suggestions must set the `meta.hasSuggestions` property to `true`.");
                        }
                        C.push(r);
                    }
                }));
                var p;
                const d = S.enabled ? S.time(n, W)(i, c) : W(i, c);
                if (null == d) throw new Error(`The create() function for rule '${n}' did not return an object.`);
                Object.keys(d).forEach((e1)=>{
                    const t = S.enabled ? S.time(n, d[e1]) : d[e1];
                    f.on(e1, function(e1) {
                        return function(...t) {
                            try {
                                return e1(...t);
                            } catch (e1) {
                                throw e1.ruleId = n, e1;
                            }
                        };
                    }(t));
                });
            });
            const b = "Program" === h[0].node.type ? new d(new g(f, {
                visitorKeys: e1.visitorKeys,
                fallback: p.getKeys
            })) : new g(f, {
                visitorKeys: e1.visitorKeys,
                fallback: p.getKeys
            });
            return h.forEach((e1)=>{
                m = e1.node;
                try {
                    e1.isEntering ? b.enterNode(m) : b.leaveNode(m);
                } catch (e1) {
                    throw e1.currentNode = m, e1;
                }
            }), C;
        }
        function J(e1) {
            if ("object" == typeof e1) {
                const { hasBOM: t, text: r } = e1;
                return (t ? "\ufeff" : "") + r;
            }
            return String(e1);
        }
        function Q(e1, t) {
            return e1.lastConfigArray && e1.lastConfigArray.pluginRules.get(t) || e1.ruleMap.get(t);
        }
        function Y(e1) {
            return e1 || ("object" == typeof k ? k.cwd() : void 0);
        }
        const Z = new WeakMap;
        function ee(e1) {
            const { configType: t } = Z.get(e1);
            if ("flat" === t) throw new Error("This method cannot be used with flat config. Add your entries directly into the config array.");
        }
        return MA = {
            Linter: class {
                constructor({ cwd: e1, configType: t } = {}){
                    Z.set(this, {
                        cwd: Y(e1),
                        lastConfigArray: null,
                        lastSourceCode: null,
                        lastSuppressedMessages: [],
                        configType: t,
                        parserMap: new Map([
                            [
                                "espree",
                                n
                            ]
                        ]),
                        ruleMap: new E
                    }), this.version = i.version;
                }
                static get version() {
                    return i.version;
                }
                _verifyWithoutProcessors(e1, r, s) {
                    const i = Z.get(this), o = r || {}, p = K(s, o);
                    let d;
                    "string" == typeof e1 ? (i.lastSourceCode = null, d = e1) : (i.lastSourceCode = e1, d = e1.text);
                    let m = "espree", g = n;
                    if ("object" == typeof o.parser && null !== o.parser) m = o.parser.filePath, g = o.parser.definition;
                    else if ("string" == typeof o.parser) {
                        if (!i.parserMap.has(o.parser)) return [
                            {
                                ruleId: null,
                                fatal: !0,
                                severity: 2,
                                message: `Configured parser '${o.parser}' was not found.`,
                                line: 0,
                                column: 0,
                                nodeType: null
                            }
                        ];
                        m = o.parser, g = i.parserMap.get(o.parser);
                    }
                    const y = p.allowInlineConfig && !p.warnInlineConfig ? function(e1) {
                        let t, r;
                        for(j.lastIndex = 0; null !== (t = j.exec(e1));)t[0].endsWith("*/") && (r = Object.assign(r || {}, B.parseListConfig(B.extractDirectiveComment(t[1]).directivePart)));
                        return r;
                    }(d) : {}, x = Object.assign({
                        builtin: !0
                    }, o.env, y), C = Object.keys(x).filter((e1)=>x[e1]).map((e1)=>(function(e1, t) {
                            return e1.lastConfigArray && e1.lastConfigArray.pluginEnvironments.get(t) || c.get(t) || null;
                        })(i, e1)).filter((e1)=>e1), S = M(g, o.parserOptions || {}, C), b = (v = o.globals || {}, A = C, Object.assign(Object.create(null), ...A.filter((e1)=>e1.globals).map((e1)=>e1.globals), v));
                    var v, A;
                    const T = o.settings || {}, R = function({ globals: e1, parser: t, parserOptions: r }) {
                        const { ecmaVersion: n, sourceType: s } = r;
                        return {
                            globals: e1,
                            ecmaVersion: U(n),
                            sourceType: s,
                            parser: t,
                            parserOptions: r
                        };
                    }({
                        globals: o.globals,
                        parser: g,
                        parserOptions: S
                    });
                    if (i.lastSourceCode) i.lastSourceCode.scopeManager || (i.lastSourceCode = new f({
                        text: i.lastSourceCode.text,
                        ast: i.lastSourceCode.ast,
                        parserServices: i.lastSourceCode.parserServices,
                        visitorKeys: i.lastSourceCode.visitorKeys,
                        scopeManager: $(i.lastSourceCode.ast, R)
                    }));
                    else {
                        const e1 = q(d, R, p.filename);
                        if (!e1.success) return [
                            e1.error
                        ];
                        i.lastSourceCode = e1.sourceCode;
                    }
                    const D = i.lastSourceCode, w = p.allowInlineConfig ? function(e1, t, r) {
                        const n = {}, s = Object.create(null), i = {}, o = [], c = [], p = new l({
                            builtInRules: E
                        });
                        return e1.getInlineConfigNodes().filter((e1)=>"Shebang" !== e1.type).forEach((e1)=>{
                            const { directivePart: l, justificationPart: f } = B.extractDirectiveComment(e1.value), d = a.exec(l);
                            if (!d) return;
                            const h = d[1], m = /^eslint-disable-(next-)?line$/u.test(h);
                            if ("Line" === e1.type && !m) return;
                            if (r) {
                                const t = "Block" === e1.type ? `/*${h}*/` : `//${h}`;
                                return void o.push(N({
                                    ruleId: null,
                                    message: `'${t}' has no effect because you have 'noInlineConfig' setting in ${r}.`,
                                    loc: e1.loc,
                                    severity: 1
                                }));
                            }
                            if ("eslint-disable-line" === h && e1.loc.start.line !== e1.loc.end.line) {
                                const t = `${h} comment should not span multiple lines.`;
                                return void o.push(N({
                                    ruleId: null,
                                    message: t,
                                    loc: e1.loc
                                }));
                            }
                            const g = l.slice(d.index + h.length);
                            switch(h){
                                case "eslint-disable":
                                case "eslint-enable":
                                case "eslint-disable-next-line":
                                case "eslint-disable-line":
                                    {
                                        const r = h.slice(7), n = {
                                            commentToken: e1,
                                            type: r,
                                            value: g,
                                            justification: f,
                                            ruleMapper: t
                                        }, { directives: s, directiveProblems: i } = O(n);
                                        c.push(...s), o.push(...i);
                                        break;
                                    }
                                case "exported":
                                    Object.assign(i, B.parseStringConfig(g, e1));
                                    break;
                                case "globals":
                                case "global":
                                    for (const [t, { value: r }] of Object.entries(B.parseStringConfig(g, e1))){
                                        let n;
                                        try {
                                            n = u.normalizeConfigGlobal(r);
                                        } catch (t) {
                                            o.push(N({
                                                ruleId: null,
                                                loc: e1.loc,
                                                message: t.message
                                            }));
                                            continue;
                                        }
                                        s[t] ? (s[t].comments.push(e1), s[t].value = n) : s[t] = {
                                            comments: [
                                                e1
                                            ],
                                            value: n
                                        };
                                    }
                                    break;
                                case "eslint":
                                    {
                                        const r = B.parseJsonConfig(g, e1.loc);
                                        r.success ? Object.keys(r.config).forEach((s)=>{
                                            const i = t(s), a = r.config[s];
                                            if (i) {
                                                try {
                                                    p.validateRuleOptions(i, s, a);
                                                } catch (t) {
                                                    return void o.push(N({
                                                        ruleId: s,
                                                        message: t.message,
                                                        loc: e1.loc
                                                    }));
                                                }
                                                n[s] = a;
                                            } else o.push(N({
                                                ruleId: s,
                                                loc: e1.loc
                                            }));
                                        }) : o.push(r.error);
                                        break;
                                    }
                            }
                        }), {
                            configuredRules: n,
                            enabledGlobals: s,
                            exportedVariables: i,
                            problems: o,
                            disableDirectives: c
                        };
                    }(D, (e1)=>Q(i, e1), p.warnInlineConfig) : {
                        configuredRules: {},
                        enabledGlobals: {},
                        exportedVariables: {},
                        problems: [],
                        disableDirectives: []
                    };
                    !function(e1, r, { exportedVariables: n, enabledGlobals: s }) {
                        for (const n of new Set([
                            ...Object.keys(r),
                            ...Object.keys(s)
                        ])){
                            const i = void 0 === r[n] ? void 0 : u.normalizeConfigGlobal(r[n]), o = s[n] && s[n].value || i, a = s[n] && s[n].comments;
                            if ("off" === o) continue;
                            let l = e1.set.get(n);
                            l || (l = new t.Variable(n, e1), e1.variables.push(l), e1.set.set(n, l)), l.eslintImplicitGlobalSetting = i, l.eslintExplicitGlobal = void 0 !== a, l.eslintExplicitGlobalComments = a, l.writeable = "writable" === o;
                        }
                        Object.keys(n).forEach((t)=>{
                            const r = e1.set.get(t);
                            r && (r.eslintUsed = !0, r.eslintExported = !0);
                        }), e1.through = e1.through.filter((t)=>{
                            const r = t.identifier.name, n = e1.set.get(r);
                            return !n || (t.resolved = n, n.references.push(t), !1);
                        });
                    }(D.scopeManager.scopes[0], b, {
                        exportedVariables: w.exportedVariables,
                        enabledGlobals: w.enabledGlobals
                    });
                    const k = Object.assign({}, o.rules, w.configuredRules);
                    let L;
                    try {
                        L = H(D, k, (e1)=>Q(i, e1), m, R, T, p.filename, p.disableFixes, i.cwd, s.physicalFilename);
                    } catch (e1) {
                        if (e1.message += `\nOccurred while linting ${p.filename}`, _("An error occurred while traversing"), _("Filename:", p.filename), e1.currentNode) {
                            const { line: t } = e1.currentNode.loc.start;
                            _("Line:", t), e1.message += `:${t}`;
                        }
                        throw _("Parser Options:", S), _("Parser Path:", m), _("Settings:", T), e1.ruleId && (e1.message += `\nRule: "${e1.ruleId}"`), e1;
                    }
                    return h({
                        directives: w.disableDirectives,
                        disableFixes: p.disableFixes,
                        problems: L.concat(w.problems).sort((e1, t)=>e1.line - t.line || e1.column - t.column),
                        reportUnusedDisableDirectives: p.reportUnusedDisableDirectives
                    });
                }
                verify(e1, t, r) {
                    _("Verify");
                    const { configType: n, cwd: s } = Z.get(this), i = "string" == typeof r ? {
                        filename: r
                    } : r || {};
                    if (t) {
                        if ("flat" === n) {
                            let r = t;
                            return Array.isArray(t) && "function" == typeof t.getConfig || (r = new A(t, {
                                basePath: s
                            }), r.normalizeSync()), this._distinguishSuppressedMessages(this._verifyWithFlatConfigArray(e1, r, i, !0));
                        }
                        if ("function" == typeof t.extractConfig) return this._distinguishSuppressedMessages(this._verifyWithConfigArray(e1, t, i));
                    }
                    return i.preprocess || i.postprocess ? this._distinguishSuppressedMessages(this._verifyWithProcessor(e1, t, i)) : this._distinguishSuppressedMessages(this._verifyWithoutProcessors(e1, t, i));
                }
                _verifyWithFlatConfigArrayAndProcessor(t, r, n, s) {
                    const i = n.filename || "<input>", o = V(i), a = n.physicalFilename || o, u = J(t), l = n.preprocess || ((e1)=>[
                            e1
                        ]), c = n.postprocess || ((e1)=>e1.flat()), p = n.filterCodeBlock || ((e1)=>e1.endsWith(".js")), f = e1.extname(i);
                    let d;
                    try {
                        d = l(u, o);
                    } catch (e1) {
                        const t = `Preprocessing error: ${e1.message.replace(/^line \d+:/iu, "").trim()}`;
                        return _("%s\n%s", t, e1.stack), [
                            {
                                ruleId: null,
                                fatal: !0,
                                severity: 2,
                                message: t,
                                line: e1.lineNumber,
                                column: e1.column,
                                nodeType: null
                            }
                        ];
                    }
                    const h = d.map((t, o)=>{
                        if (_("A code block was found: %o", t.filename || "(unnamed)"), "string" == typeof t) return this._verifyWithFlatConfigArrayAndWithoutProcessors(t, r, n);
                        const l = t.text, c = e1.join(i, `${o}_${t.filename}`);
                        return p(c, l) ? !s || u === l && e1.extname(c) === f ? this._verifyWithFlatConfigArrayAndWithoutProcessors(l, r, {
                            ...n,
                            filename: c,
                            physicalFilename: a
                        }) : (_("Resolving configuration again because the file content or extension was changed."), this._verifyWithFlatConfigArray(l, s, {
                            ...n,
                            filename: c,
                            physicalFilename: a
                        })) : (_("This code block was skipped."), []);
                    });
                    return c(h, o);
                }
                _verifyWithFlatConfigArrayAndWithoutProcessors(e1, t, r) {
                    const n = Z.get(this), s = t || {}, i = K(r, s);
                    let o;
                    "string" == typeof e1 ? (n.lastSourceCode = null, o = e1) : (n.lastSourceCode = e1, o = e1.text);
                    const u = s.languageOptions;
                    if (u.ecmaVersion = U(u.ecmaVersion), !u.parser) throw new TypeError(`No parser specified for ${i.filename}`);
                    if (I(u.parser)) {
                        const e1 = u.parserOptions;
                        u.sourceType && (e1.sourceType = u.sourceType, "module" === e1.sourceType && e1.ecmaFeatures && e1.ecmaFeatures.globalReturn && (e1.ecmaFeatures.globalReturn = !1));
                    }
                    const l = s.settings || {};
                    if (n.lastSourceCode) n.lastSourceCode.scopeManager || (n.lastSourceCode = new f({
                        text: n.lastSourceCode.text,
                        ast: n.lastSourceCode.ast,
                        parserServices: n.lastSourceCode.parserServices,
                        visitorKeys: n.lastSourceCode.visitorKeys,
                        scopeManager: $(n.lastSourceCode.ast, u)
                    }));
                    else {
                        const e1 = q(o, u, i.filename);
                        if (!e1.success) return [
                            e1.error
                        ];
                        n.lastSourceCode = e1.sourceCode;
                    }
                    const c = n.lastSourceCode;
                    c.applyLanguageOptions(u);
                    const p = {
                        rules: {}
                    }, d = [];
                    if (i.allowInlineConfig) {
                        if (i.warnInlineConfig) c.getInlineConfigNodes().forEach((e1)=>{
                            d.push(N({
                                ruleId: null,
                                message: `'${c.text.slice(e1.range[0], e1.range[1])}' has no effect because you have 'noInlineConfig' setting in ${i.warnInlineConfig}.`,
                                loc: e1.loc,
                                severity: 1
                            }));
                        });
                        else {
                            const e1 = c.applyInlineConfig();
                            d.push(...e1.problems.map(N).map((e1)=>(e1.fatal = !0, e1)));
                            const t = new T;
                            for (const { config: r, node: n } of e1.configs)Object.keys(r.rules).forEach((e1)=>{
                                const i = v(e1, s), o = r.rules[e1];
                                if (i) try {
                                    const r = Array.isArray(o) ? o : [
                                        o
                                    ];
                                    R(e1, o), D(e1, r[0]), t.validate({
                                        plugins: s.plugins,
                                        rules: {
                                            [e1]: r
                                        }
                                    }), p.rules[e1] = o;
                                } catch (t) {
                                    let r = t.message.slice(t.message.startsWith('Key "rules":') ? t.message.indexOf(":", 12) + 1 : t.message.indexOf(":") + 1).trim();
                                    t.messageTemplate && (r += ` You passed "${o}".`), d.push(N({
                                        ruleId: e1,
                                        message: `Inline configuration for rule "${e1}" is invalid:\n\t${r}\n`,
                                        loc: n.loc
                                    }));
                                }
                                else d.push(N({
                                    ruleId: e1,
                                    loc: n.loc
                                }));
                            });
                        }
                    }
                    const m = i.allowInlineConfig && !i.warnInlineConfig ? function(e1, t) {
                        const r = [], n = [];
                        return e1.getInlineConfigNodes().filter((e1)=>"Shebang" !== e1.type).forEach((e1)=>{
                            const { directivePart: s, justificationPart: i } = B.extractDirectiveComment(e1.value), o = a.exec(s);
                            if (!o) return;
                            const u = o[1], l = /^eslint-disable-(next-)?line$/u.test(u);
                            if ("Line" === e1.type && !l) return;
                            if ("eslint-disable-line" === u && e1.loc.start.line !== e1.loc.end.line) {
                                const t = `${u} comment should not span multiple lines.`;
                                return void r.push(N({
                                    ruleId: null,
                                    message: t,
                                    loc: e1.loc
                                }));
                            }
                            const c = s.slice(o.index + u.length);
                            switch(u){
                                case "eslint-disable":
                                case "eslint-enable":
                                case "eslint-disable-next-line":
                                case "eslint-disable-line":
                                    {
                                        const s = {
                                            commentToken: e1,
                                            type: u.slice(7),
                                            value: c,
                                            justification: i,
                                            ruleMapper: t
                                        }, { directives: o, directiveProblems: a } = O(s);
                                        n.push(...o), r.push(...a);
                                        break;
                                    }
                            }
                        }), {
                            problems: r,
                            disableDirectives: n
                        };
                    }(c, (e1)=>v(e1, s)) : {
                        problems: [],
                        disableDirectives: []
                    }, g = Object.assign({}, s.rules, p.rules);
                    let y;
                    c.finalize();
                    try {
                        y = H(c, g, (e1)=>v(e1, s), void 0, u, l, i.filename, i.disableFixes, n.cwd, r.physicalFilename);
                    } catch (e1) {
                        if (e1.message += `\nOccurred while linting ${i.filename}`, _("An error occurred while traversing"), _("Filename:", i.filename), e1.currentNode) {
                            const { line: t } = e1.currentNode.loc.start;
                            _("Line:", t), e1.message += `:${t}`;
                        }
                        throw _("Parser Options:", u.parserOptions), _("Settings:", l), e1.ruleId && (e1.message += `\nRule: "${e1.ruleId}"`), e1;
                    }
                    return h({
                        directives: m.disableDirectives,
                        disableFixes: i.disableFixes,
                        problems: y.concat(m.problems).concat(d).sort((e1, t)=>e1.line - t.line || e1.column - t.column),
                        reportUnusedDisableDirectives: i.reportUnusedDisableDirectives
                    });
                }
                _verifyWithConfigArray(e1, t, r) {
                    _("With ConfigArray: %s", r.filename), Z.get(this).lastConfigArray = t;
                    const n = t.extractConfig(r.filename), s = n.processor && t.pluginProcessors.get(n.processor);
                    if (s) {
                        _("Apply the processor: %o", n.processor);
                        const { preprocess: i, postprocess: o, supportsAutofix: a } = s, u = r.disableFixes || !a;
                        return this._verifyWithProcessor(e1, n, {
                            ...r,
                            disableFixes: u,
                            postprocess: o,
                            preprocess: i
                        }, t);
                    }
                    return this._verifyWithoutProcessors(e1, n, r);
                }
                _verifyWithFlatConfigArray(e1, t, r, n = !1) {
                    _("With flat config: %s", r.filename);
                    const s = r.filename || "__placeholder__.js";
                    Z.get(this).lastConfigArray = t;
                    const i = t.getConfig(s);
                    if (!i) return [
                        {
                            ruleId: null,
                            severity: 1,
                            message: `No matching configuration found for ${s}.`,
                            line: 0,
                            column: 0,
                            nodeType: null
                        }
                    ];
                    if (i.processor) {
                        _("Apply the processor: %o", i.processor);
                        const { preprocess: n, postprocess: o, supportsAutofix: a } = i.processor, u = r.disableFixes || !a;
                        return this._verifyWithFlatConfigArrayAndProcessor(e1, i, {
                            ...r,
                            filename: s,
                            disableFixes: u,
                            postprocess: o,
                            preprocess: n
                        }, t);
                    }
                    return n && (r.preprocess || r.postprocess) ? this._verifyWithFlatConfigArrayAndProcessor(e1, i, r) : this._verifyWithFlatConfigArrayAndWithoutProcessors(e1, i, r);
                }
                _verifyWithProcessor(t, r, n, s) {
                    const i = n.filename || "<input>", o = V(i), a = n.physicalFilename || o, u = J(t), l = n.preprocess || ((e1)=>[
                            e1
                        ]), c = n.postprocess || ((e1)=>e1.flat()), p = n.filterCodeBlock || ((e1)=>e1.endsWith(".js")), f = e1.extname(i);
                    let d;
                    try {
                        d = l(u, o);
                    } catch (e1) {
                        const t = `Preprocessing error: ${e1.message.replace(/^line \d+:/iu, "").trim()}`;
                        return _("%s\n%s", t, e1.stack), [
                            {
                                ruleId: null,
                                fatal: !0,
                                severity: 2,
                                message: t,
                                line: e1.lineNumber,
                                column: e1.column,
                                nodeType: null
                            }
                        ];
                    }
                    const h = d.map((t, o)=>{
                        if (_("A code block was found: %o", t.filename || "(unnamed)"), "string" == typeof t) return this._verifyWithoutProcessors(t, r, n);
                        const l = t.text, c = e1.join(i, `${o}_${t.filename}`);
                        return p(c, l) ? !s || u === l && e1.extname(c) === f ? this._verifyWithoutProcessors(l, r, {
                            ...n,
                            filename: c,
                            physicalFilename: a
                        }) : (_("Resolving configuration again because the file content or extension was changed."), this._verifyWithConfigArray(l, s, {
                            ...n,
                            filename: c,
                            physicalFilename: a
                        })) : (_("This code block was skipped."), []);
                    });
                    return c(h, o);
                }
                _distinguishSuppressedMessages(e1) {
                    const t = [], r = [], n = Z.get(this);
                    for (const n of e1)n.suppressions ? r.push(n) : t.push(n);
                    return n.lastSuppressedMessages = r, t;
                }
                getSourceCode() {
                    return Z.get(this).lastSourceCode;
                }
                getSuppressedMessages() {
                    return Z.get(this).lastSuppressedMessages;
                }
                defineRule(e1, t) {
                    ee(this), Z.get(this).ruleMap.define(e1, t);
                }
                defineRules(e1) {
                    ee(this), Object.getOwnPropertyNames(e1).forEach((t)=>{
                        this.defineRule(t, e1[t]);
                    });
                }
                getRules() {
                    ee(this);
                    const { lastConfigArray: e1, ruleMap: t } = Z.get(this);
                    return new Map(function*() {
                        yield* t, e1 && (yield* e1.pluginRules);
                    }());
                }
                defineParser(e1, t) {
                    ee(this), Z.get(this).parserMap.set(e1, t);
                }
                verifyAndFix(e1, t, r) {
                    let n, s = [], i = !1, o = 0, a = e1;
                    const u = r && r.filename || `${e1.slice(0, 10)}...`, l = !r || void 0 === r.fix || r.fix;
                    do {
                        if (o++, _(`Linting code for ${u} (pass ${o})`), s = this.verify(a, t, r), _(`Generating fixed text for ${u} (pass ${o})`), n = C.applyFixes(a, s, l), 1 === s.length && s[0].fatal) break;
                        i = i || n.fixed, a = n.output;
                    }while (n.fixed && o < 10);
                    return n.fixed && (n.messages = this.verify(a, t, r)), n.fixed = i, n.output = a, n;
                }
            },
            getLinterInternalSlots: (e1)=>Z.get(e1)
        }, MA;
    }
    window.process = function() {
        if (r) return s;
        r = 1;
        var e1, t, n = i.exports = {};
        function o() {
            throw new Error("setTimeout has not been defined");
        }
        function a() {
            throw new Error("clearTimeout has not been defined");
        }
        function u(t) {
            if (e1 === setTimeout) return setTimeout(t, 0);
            if ((e1 === o || !e1) && setTimeout) return e1 = setTimeout, setTimeout(t, 0);
            try {
                return e1(t, 0);
            } catch (r) {
                try {
                    return e1.call(null, t, 0);
                } catch (r) {
                    return e1.call(this, t, 0);
                }
            }
        }
        !function() {
            try {
                e1 = "function" == typeof setTimeout ? setTimeout : o;
            } catch (t) {
                e1 = o;
            }
            try {
                t = "function" == typeof clearTimeout ? clearTimeout : a;
            } catch (e1) {
                t = a;
            }
        }();
        var l, c = [], p = !1, f = -1;
        function d() {
            p && l && (p = !1, l.length ? c = l.concat(c) : f = -1, c.length && h());
        }
        function h() {
            if (!p) {
                var e1 = u(d);
                p = !0;
                for(var r = c.length; r;){
                    for(l = c, c = []; ++f < r;)l && l[f].run();
                    f = -1, r = c.length;
                }
                l = null, p = !1, function(e1) {
                    if (t === clearTimeout) return clearTimeout(e1);
                    if ((t === a || !t) && clearTimeout) return t = clearTimeout, clearTimeout(e1);
                    try {
                        return t(e1);
                    } catch (r) {
                        try {
                            return t.call(null, e1);
                        } catch (r) {
                            return t.call(this, e1);
                        }
                    }
                }(e1);
            }
        }
        function m(e1, t) {
            this.fun = e1, this.array = t;
        }
        function g() {}
        return n.nextTick = function(e1) {
            var t = new Array(arguments.length - 1);
            if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
            c.push(new m(e1, t)), 1 !== c.length || p || u(h);
        }, m.prototype.run = function() {
            this.fun.apply(null, this.array);
        }, n.title = "browser", n.browser = !0, n.env = {}, n.argv = [], n.version = "", n.versions = {}, n.on = g, n.addListener = g, n.once = g, n.off = g, n.removeListener = g, n.removeAllListeners = g, n.emit = g, n.prependListener = g, n.prependOnceListener = g, n.listeners = function(e1) {
            return [];
        }, n.binding = function(e1) {
            throw new Error("process.binding is not supported");
        }, n.cwd = function() {
            return "/";
        }, n.chdir = function(e1) {
            throw new Error("process.chdir is not supported");
        }, n.umask = function() {
            return 0;
        }, s;
    }();
    var zA = n.Linter = XA().Linter;
    e1.Linter = zA, e1.default = n, Object.defineProperty(e1, "__esModule", {
        value: !0
    });
});



/**
 * @import eslint from "eslint";
 * @typedef {Object.<string, eslint.Rule.RuleModule>} RulesModules
 *
 * @callback OnChangeHadnler
 * @param {{ messages: eslint.Linter.LintMessage[], output: string }}
 * @returns {void}
 *
 * @callback OnErrorHhandler
 * @param {Error}
 * @returns {void}
 * 
 * @typedef {Object} ParserOptions
 * @property {Record<string, string>} [ParserOptions.templateEngineSyntax]
 */ /**
 * @returns {RulesModules}
 */ function $c003be0fe2ca459d$var$allRules() {
    const htmlRules = Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($aae83cc78a26c8db$exports)))).reduce((rules, [name, rule])=>({
            ...rules,
            [`@html-eslint/${name}`]: rule
        }), {});
    const reactPluginRules = Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($36a7c6fe056ad952$exports)))).reduce((rules, [name, rule])=>({
            ...rules,
            [`@html-eslint/react/${name}`]: rule
        }), {});
    return {
        ...htmlRules,
        ...reactPluginRules
    };
}
class $c003be0fe2ca459d$export$4013e5250fd300a1 {
    constructor(){
        /**
     * @type {ESLinter}
     */ this._linter = new (0, $15bcbe493910c39c$exports.Linter)({
            configType: "eslintrc"
        });
        /**
     * @type {eslint.Linter.RulesRecord}
     */ this._rules = {
            "@html-eslint/indent": "error"
        };
        /**
     * @type {ParserOptions}
     */ this._parserOptions = null;
        this._defineParser();
        this._defineRules();
    }
    /**
   * @private
   */ _defineRules() {
        this._linter.defineRules($c003be0fe2ca459d$var$allRules());
    }
    /**
   * @private
   */ _defineParser() {
        this._linter.defineParser("@html-eslint/parser", {
            parseForESLint (code, options) {
                return (0, $f03705736c6cdfcd$exports.parseForESLint)(code, options);
            }
        });
    }
    /**
   * @param {Language} language
   * @returns {string | undefined}
   */ getParser(language) {
        if (language.key === "javascript" || language.key === "jsx") return undefined;
        return "@html-eslint/parser";
    }
    /**
   * Lints the given code and returns the result.
   * @param {string} code
   * @param {Language} language
   * @param {boolean?} fix
   * @returns {{messages: eslint.Linter.LintMessage[], output: string, fatalMessage?:  eslint.Linter.LintMessage}}
   */ lint(code, language, fix = false) {
        try {
            const parserOptions = language.key === "javascript" ? {
                ecmaVersion: "latest"
            } : language.key === "jsx" ? {
                ecmaVersion: "latest",
                ecmaFeatures: {
                    jsx: true
                }
            } : this._parserOptions;
            const messages = this._linter.verify(code, {
                rules: this._rules,
                parser: this.getParser(language),
                parserOptions: parserOptions
            });
            const { output: output } = this._linter.verifyAndFix(code, {
                rules: this._rules,
                parser: this.getParser(language),
                parserOptions: parserOptions
            }, {
                fix: fix
            });
            if (messages.length && messages[0].fatal) console.error(messages[0]);
            return {
                messages: messages,
                output: output
            };
        } catch (error) {
            console.error(error);
            return {
                messages: [],
                output: "Error!"
            };
        }
    }
    /**
   * Change rules configuration.
   * @param {RulesRecord} rules
   */ setRules(rules) {
        this._rules = rules;
    }
    /**
   * @param {ParserOptions} parserOptions 
   */ setParserOptions(parserOptions) {
        this._parserOptions = parserOptions;
    }
}


class $0e4e4b9d2ca77023$export$a1edc412be3e1841 {
    constructor(){
        /**
     * @member
     * @type {string}
     */ this.fixed = "";
        /**
     * @member
     * @type {string}
     */ this.code = "";
        /**
     * @member
     * @type {RulesRecord}
     */ this.rules = null;
        /**
     * @member
     * @type {ParserOptions}
     */ this.parserOptions = null;
        /**
     * @member
     * @type {eslint.Linter.LintMessage[]}
     */ this.messages = [];
        /**
     * @member
     * @type {Language}
     */ this.language = (0, $2b0c23c0b32e13dd$export$b6e4117edbe490a2)("html");
        this.cache = {
            html: {
                code: "",
                config: {
                    rules: null
                }
            },
            javascript: {
                code: "",
                config: {
                    rules: null
                }
            },
            jsx: {
                code: "",
                config: {
                    rules: null
                }
            }
        };
        /**
     * @member
     * @type {Linter}
     */ this.linter = new (0, $c003be0fe2ca459d$export$4013e5250fd300a1)();
        /**
     * @member
     * @private
     */ this.observers = {
            lint: new Set(),
            changeLanguage: new Set(),
            autofixed: new Set()
        };
    }
    /**
   * @param {StateEventType} type
   * @param {() => void} observer
   */ on(type, observer) {
        this.observers[type].add(observer);
    }
    /**
   * @param {RulesRecord} rules
   */ setRules(rules) {
        this.rules = rules;
    }
    /**
   * @param {ParserOptions} parserOptions 
   */ setParserOptions(parserOptions) {
        this.parserOptions = parserOptions;
    }
    setCode(code) {
        this.code = code;
    }
    getCode() {
        return this.code;
    }
    /**
   * @param {"html" | "jsx" | "javascript"} language
   */ setLanguage(language) {
        this.cache[this.language.key] = {
            code: this.code,
            config: {
                rules: this.rules
            }
        };
        this.language = (0, $2b0c23c0b32e13dd$export$b6e4117edbe490a2)(language);
        this.setCode(this.cache[language].code || this.language.initialCode);
        this.setRules(this.cache[language].config.rules || this.language.initialConfig.rules);
        this.notify("changeLanguage");
    }
    /**
   * @param {string} code
   * @param {RulesRecord} rules
   */ lint() {
        this.linter.setRules(this.rules);
        this.linter.setParserOptions(this.parserOptions);
        const { messages: messages, output: output } = this.linter.lint(this.getCode(), this.language, true);
        this.fixed = output;
        this.messages = messages || [];
        this.notify("lint");
    }
    /**
   * @private
   * @param {EventType} type
   */ notify(type) {
        this.observers[type].forEach((observer)=>observer());
    }
    /**
   *
   * @param {LintMessage} message
   */ applyFix(message) {
        const { fix: fix } = message;
        if (fix) {
            const code = this.getCode();
            const [start, end] = fix.range;
            const fixed = code.slice(0, start) + fix.text + code.slice(end);
            this.setCode(fixed);
            this.lint();
            this.notify('autofixed');
        }
    }
    applySuggestion(message) {
        const { suggestions: suggestions } = message;
        if (suggestions && suggestions.length > 0) {
            const suggestion = suggestions[0];
            if (suggestion.fix) {
                const code = this.getCode();
                const [start, end] = suggestion.fix.range;
                const fixed = code.slice(0, start) + suggestion.fix.text + code.slice(end);
                this.setCode(fixed);
                this.lint();
                this.notify('autofixed');
            }
        }
    }
    /**
   * @returns {string}
   */ toHash() {
        const hash = window.btoa(unescape(encodeURIComponent(JSON.stringify({
            code: this.getCode(),
            config: {
                rules: this.rules,
                parserOptions: this.parserOptions || undefined
            },
            language: this.language.key
        }))));
        return hash;
    }
    /**
   * @param {string}
   */ load(str) {
        try {
            const parsed = JSON.parse(str);
            if (!parsed || typeof parsed !== "object") throw new Error("empty parsed");
            this.setLanguage(parsed.language);
            this.setCode(parsed.code);
            const hasConfig = parsed.config && typeof parsed.config === "object";
            const hasRule = hasConfig && parsed.config.rules && typeof parsed.config.rules === "object";
            if (hasRule) this.setRules(parsed.config.rules);
        } catch (error) {
            this.setLanguage("html");
        }
    }
}


/**
 * @import {LintMessage} from "./linter";
 * @import {Editor} from "codemirror";
 */ 




// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/5/LICENSE
(function(mod) {
    mod((parcelRequire("irZNt")), (parcelRequire("i8uuI")), (parcelRequire("76M02")), (parcelRequire("1IBC2")));
})(function(CodeMirror) {
    "use strict";
    var defaultTags = {
        script: [
            [
                "lang",
                /(javascript|babel)/i,
                "javascript"
            ],
            [
                "type",
                /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i,
                "javascript"
            ],
            [
                "type",
                /./,
                "text/plain"
            ],
            [
                null,
                null,
                "javascript"
            ]
        ],
        style: [
            [
                "lang",
                /^css$/i,
                "css"
            ],
            [
                "type",
                /^(text\/)?(x-)?(stylesheet|css)$/i,
                "css"
            ],
            [
                "type",
                /./,
                "text/plain"
            ],
            [
                null,
                null,
                "css"
            ]
        ]
    };
    function maybeBackup(stream, pat, style) {
        var cur = stream.current(), close = cur.search(pat);
        if (close > -1) stream.backUp(cur.length - close);
        else if (cur.match(/<\/?$/)) {
            stream.backUp(cur.length);
            if (!stream.match(pat, false)) stream.match(cur);
        }
        return style;
    }
    var attrRegexpCache = {};
    function getAttrRegexp(attr) {
        var regexp = attrRegexpCache[attr];
        if (regexp) return regexp;
        return attrRegexpCache[attr] = new RegExp("\\s+" + attr + "\\s*=\\s*('|\")?([^'\"]+)('|\")?\\s*");
    }
    function getAttrValue(text, attr) {
        var match = text.match(getAttrRegexp(attr));
        return match ? /^\s*(.*?)\s*$/.exec(match[2])[1] : "";
    }
    function getTagRegexp(tagName, anchored) {
        return new RegExp((anchored ? "^" : "") + "<\/\\s*" + tagName + "\\s*>", "i");
    }
    function addTags(from, to) {
        for(var tag in from){
            var dest = to[tag] || (to[tag] = []);
            var source = from[tag];
            for(var i = source.length - 1; i >= 0; i--)dest.unshift(source[i]);
        }
    }
    function findMatchingMode(tagInfo, tagText) {
        for(var i = 0; i < tagInfo.length; i++){
            var spec = tagInfo[i];
            if (!spec[0] || spec[1].test(getAttrValue(tagText, spec[0]))) return spec[2];
        }
    }
    CodeMirror.defineMode("htmlmixed", function(config, parserConfig) {
        var htmlMode = CodeMirror.getMode(config, {
            name: "xml",
            htmlMode: true,
            multilineTagIndentFactor: parserConfig.multilineTagIndentFactor,
            multilineTagIndentPastTag: parserConfig.multilineTagIndentPastTag,
            allowMissingTagName: parserConfig.allowMissingTagName
        });
        var tags = {};
        var configTags = parserConfig && parserConfig.tags, configScript = parserConfig && parserConfig.scriptTypes;
        addTags(defaultTags, tags);
        if (configTags) addTags(configTags, tags);
        if (configScript) for(var i = configScript.length - 1; i >= 0; i--)tags.script.unshift([
            "type",
            configScript[i].matches,
            configScript[i].mode
        ]);
        function html(stream, state) {
            var style = htmlMode.token(stream, state.htmlState), tag = /\btag\b/.test(style), tagName;
            if (tag && !/[<>\s\/]/.test(stream.current()) && (tagName = state.htmlState.tagName && state.htmlState.tagName.toLowerCase()) && tags.hasOwnProperty(tagName)) state.inTag = tagName + " ";
            else if (state.inTag && tag && />$/.test(stream.current())) {
                var inTag = /^([\S]+) (.*)/.exec(state.inTag);
                state.inTag = null;
                var modeSpec = stream.current() == ">" && findMatchingMode(tags[inTag[1]], inTag[2]);
                var mode = CodeMirror.getMode(config, modeSpec);
                var endTagA = getTagRegexp(inTag[1], true), endTag = getTagRegexp(inTag[1], false);
                state.token = function(stream, state) {
                    if (stream.match(endTagA, false)) {
                        state.token = html;
                        state.localState = state.localMode = null;
                        return null;
                    }
                    return maybeBackup(stream, endTag, state.localMode.token(stream, state.localState));
                };
                state.localMode = mode;
                state.localState = CodeMirror.startState(mode, htmlMode.indent(state.htmlState, "", ""));
            } else if (state.inTag) {
                state.inTag += stream.current();
                if (stream.eol()) state.inTag += " ";
            }
            return style;
        }
        return {
            startState: function() {
                var state = CodeMirror.startState(htmlMode);
                return {
                    token: html,
                    inTag: null,
                    localMode: null,
                    localState: null,
                    htmlState: state
                };
            },
            copyState: function(state) {
                var local;
                if (state.localState) local = CodeMirror.copyState(state.localMode, state.localState);
                return {
                    token: state.token,
                    inTag: state.inTag,
                    localMode: state.localMode,
                    localState: local,
                    htmlState: CodeMirror.copyState(htmlMode, state.htmlState)
                };
            },
            token: function(stream, state) {
                return state.token(stream, state);
            },
            indent: function(state, textAfter, line) {
                if (!state.localMode || /^\s*<\//.test(textAfter)) return htmlMode.indent(state.htmlState, textAfter, line);
                else if (state.localMode.indent) return state.localMode.indent(state.localState, textAfter, line);
                else return CodeMirror.Pass;
            },
            innerMode: function(state) {
                return {
                    state: state.localState || state.htmlState,
                    mode: state.localMode || htmlMode
                };
            }
        };
    }, "xml", "javascript", "css");
    CodeMirror.defineMIME("text/html", "htmlmixed");
});


parcelRequire("76M02");



// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/5/LICENSE
(function(mod) {
    mod((parcelRequire("irZNt")), (parcelRequire("i8uuI")), (parcelRequire("76M02")));
})(function(CodeMirror) {
    "use strict";
    // Depth means the amount of open braces in JS context, in XML
    // context 0 means not in tag, 1 means in tag, and 2 means in tag
    // and js block comment.
    function Context(state, mode, depth, prev) {
        this.state = state;
        this.mode = mode;
        this.depth = depth;
        this.prev = prev;
    }
    function copyContext(context) {
        return new Context(CodeMirror.copyState(context.mode, context.state), context.mode, context.depth, context.prev && copyContext(context.prev));
    }
    CodeMirror.defineMode("jsx", function(config, modeConfig) {
        var xmlMode = CodeMirror.getMode(config, {
            name: "xml",
            allowMissing: true,
            multilineTagIndentPastTag: false,
            allowMissingTagName: true
        });
        var jsMode = CodeMirror.getMode(config, modeConfig && modeConfig.base || "javascript");
        function flatXMLIndent(state) {
            var tagName = state.tagName;
            state.tagName = null;
            var result = xmlMode.indent(state, "", "");
            state.tagName = tagName;
            return result;
        }
        function token(stream, state) {
            if (state.context.mode == xmlMode) return xmlToken(stream, state, state.context);
            else return jsToken(stream, state, state.context);
        }
        function xmlToken(stream, state, cx) {
            if (cx.depth == 2) {
                if (stream.match(/^.*?\*\//)) cx.depth = 1;
                else stream.skipToEnd();
                return "comment";
            }
            if (stream.peek() == "{") {
                xmlMode.skipAttribute(cx.state);
                var indent = flatXMLIndent(cx.state), xmlContext = cx.state.context;
                // If JS starts on same line as tag
                if (xmlContext && stream.match(/^[^>]*>\s*$/, false)) {
                    while(xmlContext.prev && !xmlContext.startOfLine)xmlContext = xmlContext.prev;
                    // If tag starts the line, use XML indentation level
                    if (xmlContext.startOfLine) indent -= config.indentUnit;
                    else if (cx.prev.state.lexical) indent = cx.prev.state.lexical.indented;
                // Else if inside of tag
                } else if (cx.depth == 1) indent += config.indentUnit;
                state.context = new Context(CodeMirror.startState(jsMode, indent), jsMode, 0, state.context);
                return null;
            }
            if (cx.depth == 1) {
                if (stream.peek() == "<") {
                    xmlMode.skipAttribute(cx.state);
                    state.context = new Context(CodeMirror.startState(xmlMode, flatXMLIndent(cx.state)), xmlMode, 0, state.context);
                    return null;
                } else if (stream.match("//")) {
                    stream.skipToEnd();
                    return "comment";
                } else if (stream.match("/*")) {
                    cx.depth = 2;
                    return token(stream, state);
                }
            }
            var style = xmlMode.token(stream, cx.state), cur = stream.current(), stop;
            if (/\btag\b/.test(style)) {
                if (/>$/.test(cur)) {
                    if (cx.state.context) cx.depth = 0;
                    else state.context = state.context.prev;
                } else if (/^</.test(cur)) cx.depth = 1;
            } else if (!style && (stop = cur.indexOf("{")) > -1) stream.backUp(cur.length - stop);
            return style;
        }
        function jsToken(stream, state, cx) {
            if (stream.peek() == "<" && !stream.match(/^<([^<>]|<[^>]*>)+,\s*>/, false) && jsMode.expressionAllowed(stream, cx.state)) {
                state.context = new Context(CodeMirror.startState(xmlMode, jsMode.indent(cx.state, "", "")), xmlMode, 0, state.context);
                jsMode.skipExpression(cx.state);
                return null;
            }
            var style = jsMode.token(stream, cx.state);
            if (!style && cx.depth != null) {
                var cur = stream.current();
                if (cur == "{") cx.depth++;
                else if (cur == "}") {
                    if (--cx.depth == 0) state.context = state.context.prev;
                }
            }
            return style;
        }
        return {
            startState: function() {
                return {
                    context: new Context(CodeMirror.startState(jsMode), jsMode)
                };
            },
            copyState: function(state) {
                return {
                    context: copyContext(state.context)
                };
            },
            token: token,
            indent: function(state, textAfter, fullLine) {
                return state.context.mode.indent(state.context.state, textAfter, fullLine);
            },
            innerMode: function(state) {
                return state.context;
            }
        };
    }, "xml", "javascript");
    CodeMirror.defineMIME("text/jsx", "jsx");
    CodeMirror.defineMIME("text/typescript-jsx", {
        name: "jsx",
        base: {
            name: "javascript",
            typescript: true
        }
    });
});



// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/5/LICENSE
// declare global: DOMRect
(function(mod) {
    mod((parcelRequire("irZNt")));
})(function(CodeMirror) {
    "use strict";
    var HINT_ELEMENT_CLASS = "CodeMirror-hint";
    var ACTIVE_HINT_ELEMENT_CLASS = "CodeMirror-hint-active";
    // This is the old interface, kept around for now to stay
    // backwards-compatible.
    CodeMirror.showHint = function(cm, getHints, options) {
        if (!getHints) return cm.showHint(options);
        if (options && options.async) getHints.async = true;
        var newOpts = {
            hint: getHints
        };
        if (options) for(var prop in options)newOpts[prop] = options[prop];
        return cm.showHint(newOpts);
    };
    CodeMirror.defineExtension("showHint", function(options) {
        options = parseOptions(this, this.getCursor("start"), options);
        var selections = this.listSelections();
        if (selections.length > 1) return;
        // By default, don't allow completion when something is selected.
        // A hint function can have a `supportsSelection` property to
        // indicate that it can handle selections.
        if (this.somethingSelected()) {
            if (!options.hint.supportsSelection) return;
            // Don't try with cross-line selections
            for(var i = 0; i < selections.length; i++)if (selections[i].head.line != selections[i].anchor.line) return;
        }
        if (this.state.completionActive) this.state.completionActive.close();
        var completion = this.state.completionActive = new Completion(this, options);
        if (!completion.options.hint) return;
        CodeMirror.signal(this, "startCompletion", this);
        completion.update(true);
    });
    CodeMirror.defineExtension("closeHint", function() {
        if (this.state.completionActive) this.state.completionActive.close();
    });
    function Completion(cm, options) {
        this.cm = cm;
        this.options = options;
        this.widget = null;
        this.debounce = 0;
        this.tick = 0;
        this.startPos = this.cm.getCursor("start");
        this.startLen = this.cm.getLine(this.startPos.line).length - this.cm.getSelection().length;
        if (this.options.updateOnCursorActivity) {
            var self = this;
            cm.on("cursorActivity", this.activityFunc = function() {
                self.cursorActivity();
            });
        }
    }
    var requestAnimationFrame = window.requestAnimationFrame || function(fn) {
        return setTimeout(fn, 1000 / 60);
    };
    var cancelAnimationFrame = window.cancelAnimationFrame || clearTimeout;
    Completion.prototype = {
        close: function() {
            if (!this.active()) return;
            this.cm.state.completionActive = null;
            this.tick = null;
            if (this.options.updateOnCursorActivity) this.cm.off("cursorActivity", this.activityFunc);
            if (this.widget && this.data) CodeMirror.signal(this.data, "close");
            if (this.widget) this.widget.close();
            CodeMirror.signal(this.cm, "endCompletion", this.cm);
        },
        active: function() {
            return this.cm.state.completionActive == this;
        },
        pick: function(data, i) {
            var completion = data.list[i], self = this;
            this.cm.operation(function() {
                if (completion.hint) completion.hint(self.cm, data, completion);
                else self.cm.replaceRange(getText(completion), completion.from || data.from, completion.to || data.to, "complete");
                CodeMirror.signal(data, "pick", completion);
                self.cm.scrollIntoView();
            });
            if (this.options.closeOnPick) this.close();
        },
        cursorActivity: function() {
            if (this.debounce) {
                cancelAnimationFrame(this.debounce);
                this.debounce = 0;
            }
            var identStart = this.startPos;
            if (this.data) identStart = this.data.from;
            var pos = this.cm.getCursor(), line = this.cm.getLine(pos.line);
            if (pos.line != this.startPos.line || line.length - pos.ch != this.startLen - this.startPos.ch || pos.ch < identStart.ch || this.cm.somethingSelected() || !pos.ch || this.options.closeCharacters.test(line.charAt(pos.ch - 1))) this.close();
            else {
                var self = this;
                this.debounce = requestAnimationFrame(function() {
                    self.update();
                });
                if (this.widget) this.widget.disable();
            }
        },
        update: function(first) {
            if (this.tick == null) return;
            var self = this, myTick = ++this.tick;
            fetchHints(this.options.hint, this.cm, this.options, function(data) {
                if (self.tick == myTick) self.finishUpdate(data, first);
            });
        },
        finishUpdate: function(data, first) {
            if (this.data) CodeMirror.signal(this.data, "update");
            var picked = this.widget && this.widget.picked || first && this.options.completeSingle;
            if (this.widget) this.widget.close();
            this.data = data;
            if (data && data.list.length) {
                if (picked && data.list.length == 1) this.pick(data, 0);
                else {
                    this.widget = new Widget(this, data);
                    CodeMirror.signal(data, "shown");
                }
            }
        }
    };
    function parseOptions(cm, pos, options) {
        var editor = cm.options.hintOptions;
        var out = {};
        for(var prop in defaultOptions)out[prop] = defaultOptions[prop];
        if (editor) {
            for(var prop in editor)if (editor[prop] !== undefined) out[prop] = editor[prop];
        }
        if (options) {
            for(var prop in options)if (options[prop] !== undefined) out[prop] = options[prop];
        }
        if (out.hint.resolve) out.hint = out.hint.resolve(cm, pos);
        return out;
    }
    function getText(completion) {
        if (typeof completion == "string") return completion;
        else return completion.text;
    }
    function buildKeyMap(completion, handle) {
        var baseMap = {
            Up: function() {
                handle.moveFocus(-1);
            },
            Down: function() {
                handle.moveFocus(1);
            },
            PageUp: function() {
                handle.moveFocus(-handle.menuSize() + 1, true);
            },
            PageDown: function() {
                handle.moveFocus(handle.menuSize() - 1, true);
            },
            Home: function() {
                handle.setFocus(0);
            },
            End: function() {
                handle.setFocus(handle.length - 1);
            },
            Enter: handle.pick,
            Tab: handle.pick,
            Esc: handle.close
        };
        var mac = /Mac/.test(navigator.platform);
        if (mac) {
            baseMap["Ctrl-P"] = function() {
                handle.moveFocus(-1);
            };
            baseMap["Ctrl-N"] = function() {
                handle.moveFocus(1);
            };
        }
        var custom = completion.options.customKeys;
        var ourMap = custom ? {} : baseMap;
        function addBinding(key, val) {
            var bound;
            if (typeof val != "string") bound = function(cm) {
                return val(cm, handle);
            };
            else if (baseMap.hasOwnProperty(val)) bound = baseMap[val];
            else bound = val;
            ourMap[key] = bound;
        }
        if (custom) {
            for(var key in custom)if (custom.hasOwnProperty(key)) addBinding(key, custom[key]);
        }
        var extra = completion.options.extraKeys;
        if (extra) {
            for(var key in extra)if (extra.hasOwnProperty(key)) addBinding(key, extra[key]);
        }
        return ourMap;
    }
    function getHintElement(hintsElement, el) {
        while(el && el != hintsElement){
            if (el.nodeName.toUpperCase() === "LI" && el.parentNode == hintsElement) return el;
            el = el.parentNode;
        }
    }
    function Widget(completion, data) {
        this.id = "cm-complete-" + Math.floor(Math.random(1e6));
        this.completion = completion;
        this.data = data;
        this.picked = false;
        var widget = this, cm = completion.cm;
        var ownerDocument = cm.getInputField().ownerDocument;
        var parentWindow = ownerDocument.defaultView || ownerDocument.parentWindow;
        var hints = this.hints = ownerDocument.createElement("ul");
        hints.setAttribute("role", "listbox");
        hints.setAttribute("aria-expanded", "true");
        hints.id = this.id;
        var theme = completion.cm.options.theme;
        hints.className = "CodeMirror-hints " + theme;
        this.selectedHint = data.selectedHint || 0;
        var completions = data.list;
        for(var i = 0; i < completions.length; ++i){
            var elt = hints.appendChild(ownerDocument.createElement("li")), cur = completions[i];
            var className = HINT_ELEMENT_CLASS + (i != this.selectedHint ? "" : " " + ACTIVE_HINT_ELEMENT_CLASS);
            if (cur.className != null) className = cur.className + " " + className;
            elt.className = className;
            if (i == this.selectedHint) elt.setAttribute("aria-selected", "true");
            elt.id = this.id + "-" + i;
            elt.setAttribute("role", "option");
            if (cur.render) cur.render(elt, data, cur);
            else elt.appendChild(ownerDocument.createTextNode(cur.displayText || getText(cur)));
            elt.hintId = i;
        }
        var container = completion.options.container || ownerDocument.body;
        var pos = cm.cursorCoords(completion.options.alignWithWord ? data.from : null);
        var left = pos.left, top = pos.bottom, below = true;
        var offsetLeft = 0, offsetTop = 0;
        if (container !== ownerDocument.body) {
            // We offset the cursor position because left and top are relative to the offsetParent's top left corner.
            var isContainerPositioned = [
                'absolute',
                'relative',
                'fixed'
            ].indexOf(parentWindow.getComputedStyle(container).position) !== -1;
            var offsetParent = isContainerPositioned ? container : container.offsetParent;
            var offsetParentPosition = offsetParent.getBoundingClientRect();
            var bodyPosition = ownerDocument.body.getBoundingClientRect();
            offsetLeft = offsetParentPosition.left - bodyPosition.left - offsetParent.scrollLeft;
            offsetTop = offsetParentPosition.top - bodyPosition.top - offsetParent.scrollTop;
        }
        hints.style.left = left - offsetLeft + "px";
        hints.style.top = top - offsetTop + "px";
        // If we're at the edge of the screen, then we want the menu to appear on the left of the cursor.
        var winW = parentWindow.innerWidth || Math.max(ownerDocument.body.offsetWidth, ownerDocument.documentElement.offsetWidth);
        var winH = parentWindow.innerHeight || Math.max(ownerDocument.body.offsetHeight, ownerDocument.documentElement.offsetHeight);
        container.appendChild(hints);
        cm.getInputField().setAttribute("aria-autocomplete", "list");
        cm.getInputField().setAttribute("aria-owns", this.id);
        cm.getInputField().setAttribute("aria-activedescendant", this.id + "-" + this.selectedHint);
        var box = completion.options.moveOnOverlap ? hints.getBoundingClientRect() : new DOMRect();
        var scrolls = completion.options.paddingForScrollbar ? hints.scrollHeight > hints.clientHeight + 1 : false;
        // Compute in the timeout to avoid reflow on init
        var startScroll;
        setTimeout(function() {
            startScroll = cm.getScrollInfo();
        });
        var overlapY = box.bottom - winH;
        if (overlapY > 0) {
            var height = box.bottom - box.top, spaceAbove = box.top - (pos.bottom - pos.top) - 2;
            if (winH - box.top < spaceAbove) {
                if (height > spaceAbove) hints.style.height = (height = spaceAbove) + "px";
                hints.style.top = (top = pos.top - height) + offsetTop + "px";
                below = false;
            } else hints.style.height = winH - box.top - 2 + "px";
        }
        var overlapX = box.right - winW;
        if (scrolls) overlapX += cm.display.nativeBarWidth;
        if (overlapX > 0) {
            if (box.right - box.left > winW) {
                hints.style.width = winW - 5 + "px";
                overlapX -= box.right - box.left - winW;
            }
            hints.style.left = (left = Math.max(pos.left - overlapX - offsetLeft, 0)) + "px";
        }
        if (scrolls) for(var node = hints.firstChild; node; node = node.nextSibling)node.style.paddingRight = cm.display.nativeBarWidth + "px";
        cm.addKeyMap(this.keyMap = buildKeyMap(completion, {
            moveFocus: function(n, avoidWrap) {
                widget.changeActive(widget.selectedHint + n, avoidWrap);
            },
            setFocus: function(n) {
                widget.changeActive(n);
            },
            menuSize: function() {
                return widget.screenAmount();
            },
            length: completions.length,
            close: function() {
                completion.close();
            },
            pick: function() {
                widget.pick();
            },
            data: data
        }));
        if (completion.options.closeOnUnfocus) {
            var closingOnBlur;
            cm.on("blur", this.onBlur = function() {
                closingOnBlur = setTimeout(function() {
                    completion.close();
                }, 100);
            });
            cm.on("focus", this.onFocus = function() {
                clearTimeout(closingOnBlur);
            });
        }
        cm.on("scroll", this.onScroll = function() {
            var curScroll = cm.getScrollInfo(), editor = cm.getWrapperElement().getBoundingClientRect();
            if (!startScroll) startScroll = cm.getScrollInfo();
            var newTop = top + startScroll.top - curScroll.top;
            var point = newTop - (parentWindow.pageYOffset || (ownerDocument.documentElement || ownerDocument.body).scrollTop);
            if (!below) point += hints.offsetHeight;
            if (point <= editor.top || point >= editor.bottom) return completion.close();
            hints.style.top = newTop + "px";
            hints.style.left = left + startScroll.left - curScroll.left + "px";
        });
        CodeMirror.on(hints, "dblclick", function(e) {
            var t = getHintElement(hints, e.target || e.srcElement);
            if (t && t.hintId != null) {
                widget.changeActive(t.hintId);
                widget.pick();
            }
        });
        CodeMirror.on(hints, "click", function(e) {
            var t = getHintElement(hints, e.target || e.srcElement);
            if (t && t.hintId != null) {
                widget.changeActive(t.hintId);
                if (completion.options.completeOnSingleClick) widget.pick();
            }
        });
        CodeMirror.on(hints, "mousedown", function() {
            setTimeout(function() {
                cm.focus();
            }, 20);
        });
        // The first hint doesn't need to be scrolled to on init
        var selectedHintRange = this.getSelectedHintRange();
        if (selectedHintRange.from !== 0 || selectedHintRange.to !== 0) this.scrollToActive();
        CodeMirror.signal(data, "select", completions[this.selectedHint], hints.childNodes[this.selectedHint]);
        return true;
    }
    Widget.prototype = {
        close: function() {
            if (this.completion.widget != this) return;
            this.completion.widget = null;
            if (this.hints.parentNode) this.hints.parentNode.removeChild(this.hints);
            this.completion.cm.removeKeyMap(this.keyMap);
            var input = this.completion.cm.getInputField();
            input.removeAttribute("aria-activedescendant");
            input.removeAttribute("aria-owns");
            var cm = this.completion.cm;
            if (this.completion.options.closeOnUnfocus) {
                cm.off("blur", this.onBlur);
                cm.off("focus", this.onFocus);
            }
            cm.off("scroll", this.onScroll);
        },
        disable: function() {
            this.completion.cm.removeKeyMap(this.keyMap);
            var widget = this;
            this.keyMap = {
                Enter: function() {
                    widget.picked = true;
                }
            };
            this.completion.cm.addKeyMap(this.keyMap);
        },
        pick: function() {
            this.completion.pick(this.data, this.selectedHint);
        },
        changeActive: function(i, avoidWrap) {
            if (i >= this.data.list.length) i = avoidWrap ? this.data.list.length - 1 : 0;
            else if (i < 0) i = avoidWrap ? 0 : this.data.list.length - 1;
            if (this.selectedHint == i) return;
            var node = this.hints.childNodes[this.selectedHint];
            if (node) {
                node.className = node.className.replace(" " + ACTIVE_HINT_ELEMENT_CLASS, "");
                node.removeAttribute("aria-selected");
            }
            node = this.hints.childNodes[this.selectedHint = i];
            node.className += " " + ACTIVE_HINT_ELEMENT_CLASS;
            node.setAttribute("aria-selected", "true");
            this.completion.cm.getInputField().setAttribute("aria-activedescendant", node.id);
            this.scrollToActive();
            CodeMirror.signal(this.data, "select", this.data.list[this.selectedHint], node);
        },
        scrollToActive: function() {
            var selectedHintRange = this.getSelectedHintRange();
            var node1 = this.hints.childNodes[selectedHintRange.from];
            var node2 = this.hints.childNodes[selectedHintRange.to];
            var firstNode = this.hints.firstChild;
            if (node1.offsetTop < this.hints.scrollTop) this.hints.scrollTop = node1.offsetTop - firstNode.offsetTop;
            else if (node2.offsetTop + node2.offsetHeight > this.hints.scrollTop + this.hints.clientHeight) this.hints.scrollTop = node2.offsetTop + node2.offsetHeight - this.hints.clientHeight + firstNode.offsetTop;
        },
        screenAmount: function() {
            return Math.floor(this.hints.clientHeight / this.hints.firstChild.offsetHeight) || 1;
        },
        getSelectedHintRange: function() {
            var margin = this.completion.options.scrollMargin || 0;
            return {
                from: Math.max(0, this.selectedHint - margin),
                to: Math.min(this.data.list.length - 1, this.selectedHint + margin)
            };
        }
    };
    function applicableHelpers(cm, helpers) {
        if (!cm.somethingSelected()) return helpers;
        var result = [];
        for(var i = 0; i < helpers.length; i++)if (helpers[i].supportsSelection) result.push(helpers[i]);
        return result;
    }
    function fetchHints(hint, cm, options, callback) {
        if (hint.async) hint(cm, callback, options);
        else {
            var result = hint(cm, options);
            if (result && result.then) result.then(callback);
            else callback(result);
        }
    }
    function resolveAutoHints(cm, pos) {
        var helpers = cm.getHelpers(pos, "hint"), words;
        if (helpers.length) {
            var resolved = function(cm, callback, options) {
                var app = applicableHelpers(cm, helpers);
                function run(i) {
                    if (i == app.length) return callback(null);
                    fetchHints(app[i], cm, options, function(result) {
                        if (result && result.list.length > 0) callback(result);
                        else run(i + 1);
                    });
                }
                run(0);
            };
            resolved.async = true;
            resolved.supportsSelection = true;
            return resolved;
        } else if (words = cm.getHelper(cm.getCursor(), "hintWords")) return function(cm) {
            return CodeMirror.hint.fromList(cm, {
                words: words
            });
        };
        else if (CodeMirror.hint.anyword) return function(cm, options) {
            return CodeMirror.hint.anyword(cm, options);
        };
        else return function() {};
    }
    CodeMirror.registerHelper("hint", "auto", {
        resolve: resolveAutoHints
    });
    CodeMirror.registerHelper("hint", "fromList", function(cm, options) {
        var cur = cm.getCursor(), token = cm.getTokenAt(cur);
        var term, from = CodeMirror.Pos(cur.line, token.start), to = cur;
        if (token.start < cur.ch && /\w/.test(token.string.charAt(cur.ch - token.start - 1))) term = token.string.substr(0, cur.ch - token.start);
        else {
            term = "";
            from = cur;
        }
        var found = [];
        for(var i = 0; i < options.words.length; i++){
            var word = options.words[i];
            if (word.slice(0, term.length) == term) found.push(word);
        }
        if (found.length) return {
            list: found,
            from: from,
            to: to
        };
    });
    CodeMirror.commands.autocomplete = CodeMirror.showHint;
    var defaultOptions = {
        hint: CodeMirror.hint.auto,
        completeSingle: true,
        alignWithWord: true,
        closeCharacters: /[\s()\[\]{};:>,]/,
        closeOnPick: true,
        closeOnUnfocus: true,
        updateOnCursorActivity: true,
        completeOnSingleClick: true,
        container: null,
        customKeys: null,
        extraKeys: null,
        paddingForScrollbar: true,
        moveOnOverlap: true
    };
    CodeMirror.defineOption("hintOptions", null);
});





var $irZNt = parcelRequire("irZNt");
/**
 * @import {Position} from "codemirror";
 * @import eslint from "eslint";
 */ /**
 * @param {number} pos
 * @returns {number}
 */ function $499b2cfdbbc46160$var$toMarkerPos(pos) {
    return pos - 1;
}
function $499b2cfdbbc46160$export$1f9098f74da61591(message) {
    const from = {
        line: $499b2cfdbbc46160$var$toMarkerPos(message.line),
        ch: $499b2cfdbbc46160$var$toMarkerPos(message.column)
    };
    const to = {
        line: $499b2cfdbbc46160$var$toMarkerPos(message.endLine || message.line),
        ch: $499b2cfdbbc46160$var$toMarkerPos(message.endColumn || message.column)
    };
    return [
        from,
        to
    ];
}
function $499b2cfdbbc46160$export$5dd27816c66fb702(str) {
    return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}



// HTML ESLint rules for autocomplete
const $7ab8b90118534b5f$var$HTML_ESLINT_RULES = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($aae83cc78a26c8db$exports)))).map((rule)=>`@html-eslint/${rule}`);
const $7ab8b90118534b5f$var$HTML_REG = /"@html-eslint\//;
const $7ab8b90118534b5f$var$RULES_REG = /"rules"[\s\S]*?"@html-eslint\//;
// ESLint severity values for autocomplete
const $7ab8b90118534b5f$var$ESLINT_SEVERITIES = [
    "error",
    "warn",
    "off"
];
const $7ab8b90118534b5f$var$RULES_VALUE_REG = /"@html-eslint\/[^"]*":\s*/;
class $7ab8b90118534b5f$export$27a5bd065ad55220 {
    constructor(){
        /**
     * @member
     * @type {CodeMirror.Editor}
     */ this.codeEditor = (0, (/*@__PURE__*/$parcel$interopDefault($irZNt))).fromTextArea(document.getElementById("code-editor"), {
            mode: "text/html",
            lineNumbers: true,
            showCursorWhenSelecting: true
        });
        /**
     * @member
     * @type {CodeMirror.Editor}
     */ this.configEditor = (0, (/*@__PURE__*/$parcel$interopDefault($irZNt))).fromTextArea(document.getElementById("config-editor"), {
            mode: "application/json",
            lineNumbers: false,
            extraKeys: {
                "Ctrl-Space": "autocomplete"
            },
            hintOptions: {
                hint: this.getHtmlEslintHints.bind(this)
            }
        });
        this.configEditor.on('inputRead', (cm, change)=>{
            if (change.text[0].match(/[\w$.]/)) this.configEditor.showHint({
                completeSingle: false
            });
        });
        this.$languageTabs = document.getElementById("language-tabs");
        this.$errors = document.getElementById("errors");
    }
    /**
   * Custom hint function for HTML ESLint rules
   * @param {CodeMirror.Editor} cm
   * @returns {Object|null}
   */ getHtmlEslintHints(cm) {
        const cur = cm.getCursor();
        const token = cm.getTokenAt(cur);
        const start = token.start;
        const end = cur.ch;
        const line = cm.getLine(cur.line);
        // Get the text before cursor
        const textBefore = line.substring(0, cur.ch);
        // Check if we're in a context where rule names should be suggested
        const ruleNameContext = $7ab8b90118534b5f$var$HTML_REG.test(textBefore) || $7ab8b90118534b5f$var$RULES_REG.test(cm.getValue().substring(0, cm.indexFromPos(cur)));
        const ruleValueContext = $7ab8b90118534b5f$var$RULES_VALUE_REG.test(textBefore);
        if (!ruleNameContext && !ruleValueContext) return null;
        let suggestions = [];
        const word = token.string.replace(/^["']|["']$/g, '');
        if (ruleValueContext) // Provide ESLint severity suggestions
        suggestions = $7ab8b90118534b5f$var$ESLINT_SEVERITIES.filter((severity)=>{
            const severityStr = severity.toString();
            return severityStr.toLowerCase().includes(word.toLowerCase());
        }).map((severity)=>({
                text: typeof severity === 'string' ? `"${severity}"` : severity.toString(),
                displayText: severity.toString()
            }));
        else if (ruleNameContext) // Provide rule name suggestions
        suggestions = $7ab8b90118534b5f$var$HTML_ESLINT_RULES.filter((rule)=>rule.includes(word.toLowerCase())).map((rule)=>({
                text: `"${rule}"`,
                displayText: rule
            }));
        if (suggestions.length === 0) return null;
        return {
            list: suggestions,
            from: (0, (/*@__PURE__*/$parcel$interopDefault($irZNt))).Pos(cur.line, start),
            to: (0, (/*@__PURE__*/$parcel$interopDefault($irZNt))).Pos(cur.line, end)
        };
    }
    /**
   * @param {string} content
   */ renderFixed(content) {
        const $fixed = document.getElementById("fixed");
        $fixed.textContent = content;
    }
    /**
   * @param {string} language
   */ renderLanguageTabs(language) {
        const $tabs = document.querySelectorAll("[data-language]");
        [
            ...$tabs
        ].forEach(($tab)=>{
            if ($tab.dataset.language === language) $tab.classList.add("bg-gray-300");
            else $tab.classList.remove("bg-gray-300");
        });
    }
    /**
   *
   * @param {LintMessage[]} messages
   */ renderErrors(messages) {
        const children = messages.map((message)=>this.lintMessageHTML(message));
        this.$errors.innerHTML = (0, $f8ccc60522e42651$exports.html)`<ul class="text-sm flex flex-col gap-2">
        ${children}
      </ul>`;
        if (messages.some((message)=>message.fatal)) return;
        this.codeEditor.getAllMarks().forEach((mark)=>mark.clear());
        messages.forEach((message)=>{
            const [start, end] = (0, $499b2cfdbbc46160$export$1f9098f74da61591)(message);
            this.codeEditor.markText(start, end, {
                className: "editor_error"
            });
        });
    }
    /**
   * @private
   * @param {LintMessage} message
   */ lintMessageHTML({ line: line, column: column, message: message, ruleId: ruleId, fatal: fatal, fix: fix, suggestions: suggestions }) {
        if (fatal) {
            console.error(message);
            return (0, $f8ccc60522e42651$exports.html)`<li class="bg-red-100 text-red-800 px-2 py-1 my-1 rounded">
          ${line}:${column} - ${message}
        </li>`;
        }
        const rule = ruleId.replace("@html-eslint/", "");
        return (0, $f8ccc60522e42651$exports.html)`<li class="bg-red-100 text-red-800 px-2 rounded flex items-center">
        <span class="my-4">
          <span>${line}:${column} - ${(0, $499b2cfdbbc46160$export$5dd27816c66fb702)(message)}</span>
          <a class="ml-1 hover:underline" href="/docs/rules/${rule}">(${rule})</a>
        </span>
        <div class="ml-auto mr-0 my-2">
          ${fix ? (0, $f8ccc60522e42651$exports.html)`<button type="submit" class="bg-accent text-white px-4 py-1 rounded hover:opacity-80 w-max">apply fix</button>` : ""}
          ${suggestions && suggestions.length > 0 ? (0, $f8ccc60522e42651$exports.html)`
            <button type="submit" class="bg-accent text-white px-4 py-1 rounded hover:opacity-80 w-max">apply suggestion</button>
          ` : ""}
        </div>
      </li>`;
    }
}


class $06a1f2b93736225b$var$App {
    constructor(){
        this.view = new (0, $7ab8b90118534b5f$export$27a5bd065ad55220)();
        this.model = new (0, $0e4e4b9d2ca77023$export$a1edc412be3e1841)();
        this.model.on("lint", ()=>this.handleLint());
        this.model.on("changeLanguage", ()=>this.handleLanguageChange());
        this.model.on("autofixed", ()=>this.view.codeEditor.setValue(this.model.getCode()));
        this.view.codeEditor.on("change", (editor)=>this.handleCodeChange(editor));
        this.view.configEditor.on("change", (editor)=>{
            this.handleConfigChange(editor);
        });
        this.view.$languageTabs.addEventListener("click", (event)=>{
            const $tab = event.target.closest("[data-language]");
            this.model.setLanguage($tab.dataset.language);
        });
        this.view.$errors.addEventListener('click', (event)=>{
            const $button = event.target.closest("button");
            if ($button) {
                const $li = $button.closest("li");
                const index = Array.from($li.parentNode.children).indexOf($li);
                const message = this.model.messages[index];
                if ($button.textContent.includes("fix")) this.model.applyFix(message);
                else if ($button.textContent.includes("suggestion")) this.model.applySuggestion(message);
            }
        });
    }
    start() {
        const decoded = decodeURIComponent(escape(window.atob(window.location.hash.substring(1))));
        this.model.load(decoded);
        this.view.codeEditor.setValue(this.model.getCode());
        this.view.configEditor.setValue(JSON.stringify({
            parserOptions: this.model.parserOptions || undefined,
            rules: this.model.rules
        }, null, 2));
        this.handleCodeChange(this.view.codeEditor);
        this.handleConfigChange(this.view.configEditor);
        this.handleLanguageChange();
    }
    /**
   * @param {Editor} editor
   */ handleConfigChange(editor) {
        try {
            const parsed = JSON.parse(editor.getValue());
            const rules = parsed.rules;
            const parserOptions = parsed.parserOptions;
            this.model.setRules(rules);
            this.model.setParserOptions(parserOptions);
            this.model.lint();
        } catch (e) {
            this.view.renderErrors([
                {
                    line: 0,
                    column: 0,
                    message: e.message,
                    fatal: true
                }
            ]);
        }
    }
    /**
   * @param {Editor} editor
   */ handleCodeChange(editor) {
        this.model.setCode(editor.getValue());
        this.model.lint();
    }
    handleLint() {
        this.view.renderErrors(this.model.messages);
        this.view.renderFixed(this.model.fixed);
        const hash = this.model.toHash();
        window.location.hash = hash;
    }
    handleLanguageChange() {
        this.view.renderLanguageTabs(this.model.language.key);
        this.view.codeEditor.setOption("mode", this.model.language.mime);
        this.view.codeEditor.setValue(this.model.getCode());
        this.view.configEditor.setValue(JSON.stringify({
            rules: this.model.rules
        }, null, 2));
        this.model.lint();
    }
}
const $06a1f2b93736225b$var$app = new $06a1f2b93736225b$var$App();
$06a1f2b93736225b$var$app.start();


//# sourceMappingURL=playground.2ddb43dc.js.map
